/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(545);
	__webpack_require__(428);
	module.exports = __webpack_require__(238);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(488);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(13);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function warning(condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(29);
	var ReactDOMComponentFlags = __webpack_require__(206);
	
	var invariant = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a native or
	 * native text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedNativeOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_nativeNode` on the rendered native/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var nativeInst = getRenderedNativeOrTextFromComponent(inst);
	  nativeInst._nativeNode = node;
	  node[internalInstanceKey] = nativeInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._nativeNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._nativeNode = null;
	  }
	}
	
	/**
	 * Populate `_nativeNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedNativeOrTextFromComponent(childInst)._domID;
	    if (childID == null) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : invariant(false) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._nativeNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._nativeNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : invariant(false) : void 0;
	
	  if (inst._nativeNode) {
	    return inst._nativeNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._nativeNode) {
	    parents.push(inst);
	    !inst._nativeParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : invariant(false) : void 0;
	    inst = inst._nativeParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._nativeNode);
	  }
	
	  return inst._nativeNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(546);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 8 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var checkGlobal = __webpack_require__(329);
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var ReactDebugTool = __webpack_require__(208);
	
	module.exports = { debugTool: ReactDebugTool };

/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(24);
	
	var warning = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(118);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.createElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	      ref = !config.hasOwnProperty('ref') || Object.getOwnPropertyDescriptor(config, 'ref').get ? null : config.ref;
	      key = !config.hasOwnProperty('key') || Object.getOwnPropertyDescriptor(config, 'key').get ? null : '' + config.key;
	    } else {
	      ref = config.ref === undefined ? null : config.ref;
	      key = config.key === undefined ? null : '' + config.key;
	    }
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    // Create dummy `key` and `ref` property to `props` to warn users
	    // against its use
	    if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	      if (!props.hasOwnProperty('key')) {
	        Object.defineProperty(props, 'key', {
	          get: function () {
	            if (!specialPropKeyWarningShown) {
	              specialPropKeyWarningShown = true;
	              process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', typeof type === 'function' && 'displayName' in type ? type.displayName : 'Element') : void 0;
	            }
	            return undefined;
	          },
	          configurable: true
	        });
	      }
	      if (!props.hasOwnProperty('ref')) {
	        Object.defineProperty(props, 'ref', {
	          get: function () {
	            if (!specialPropRefWarningShown) {
	              specialPropRefWarningShown = true;
	              process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', typeof type === 'function' && 'displayName' in type ? type.displayName : 'Element') : void 0;
	            }
	            return undefined;
	          },
	          configurable: true
	        });
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.cloneElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(47);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(200);
	var PooledClass = __webpack_require__(23);
	var ReactFeatureFlags = __webpack_require__(211);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactReconciler = __webpack_require__(38);
	var Transaction = __webpack_require__(78);
	
	var invariant = __webpack_require__(2);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 18 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(23);
	
	var emptyFunction = __webpack_require__(13);
	var warning = __webpack_require__(3);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      var noop = require('fbjs/lib/emptyFunction');
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', noop));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', noop));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(159),
	    baseKeys = __webpack_require__(161),
	    indexKeys = __webpack_require__(359),
	    isArrayLike = __webpack_require__(42),
	    isIndex = __webpack_require__(59),
	    isPrototype = __webpack_require__(176);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MDLComponent = __webpack_require__(447);
	
	var _MDLComponent2 = _interopRequireDefault(_MDLComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (Component) {
	    var render = Component.prototype.render;
	
	    Component.prototype.render = function rendr() {
	        // eslint-disable-line no-param-reassign
	        var renderBound = render.bind(this);
	        return _react2.default.createElement(
	            _MDLComponent2.default,
	            null,
	            renderBound()
	        );
	    };
	
	    return Component;
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_SIDE_EFFECTS: 0x2,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : void 0;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\uB7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(317),
	    getValue = __webpack_require__(352);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var baseConvert = __webpack_require__(395),
	    util = __webpack_require__(397);
	
	/**
	 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
	 * version with conversion `options` applied. If `name` is an object its methods
	 * will be converted.
	 *
	 * @param {string} name The name of the function to wrap.
	 * @param {Function} [func] The function to wrap.
	 * @param {Object} [options] The options object. See `baseConvert` for more details.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function convert(name, func, options) {
	  return baseConvert(util, name, func, options);
	}
	
	module.exports = convert;


/***/ },
/* 33 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(201);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(119);
	var setTextContent = __webpack_require__(227);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    node.innerHTML = tree.html;
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    tree.node.innerHTML = html;
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(72);
	var EventPluginUtils = __webpack_require__(73);
	var ReactErrorUtils = __webpack_require__(115);
	
	var accumulateInto = __webpack_require__(221);
	var forEachAccumulated = __webpack_require__(222);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : void 0;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[inst._rootNodeID] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[inst._rootNodeID];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][inst._rootNodeID]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPluginHub = __webpack_require__(36);
	var EventPluginUtils = __webpack_require__(73);
	
	var accumulateInto = __webpack_require__(221);
	var forEachAccumulated = __webpack_require__(222);
	var warning = __webpack_require__(3);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(518);
	var ReactInstrumentation = __webpack_require__(12);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing native component instance
	   * @param {?object} info about the native container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, nativeParent, nativeContainerInfo, context) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'mountComponent');
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, nativeParent, nativeContainerInfo, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'mountComponent');
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getNativeNode: function (internalInstance) {
	    return internalInstance.getNativeNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	      !(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1) ?  false ? invariant(false, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : invariant(false) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	var getEventTarget = __webpack_require__(122);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentLanguage = currentLanguage;
	exports.t = t;
	exports.switchLanguage = switchLanguage;
	
	var _ro = __webpack_require__(295);
	
	var _ro2 = _interopRequireDefault(_ro);
	
	var _en = __webpack_require__(294);
	
	var _en2 = _interopRequireDefault(_en);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = _ro2.default;
	
	if (typeof window !== 'undefined' && typeof window.Storage !== 'undefined') {
	  language = localStorage.getItem('language') === 'en' ? _en2.default : _ro2.default;
	}
	
	function currentLanguage() {
	  return language === _ro2.default ? 'ro' : 'en';
	}
	
	function t(string) {
	  if (string in language) {
	    return language[string];
	  }
	
	  return 'Missing translation: ' + string;
	}
	
	function switchLanguage() {
	  if (language === _en2.default) {
	    localStorage.setItem('language', 'ro');
	  } else {
	    localStorage.setItem('language', 'en');
	  }
	  window.location.reload();
	}

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(43);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(350),
	    isFunction = __webpack_require__(62),
	    isLength = __webpack_require__(63);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(33);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTimeBeforeNow = exports.cleanStationNameForInfofer = exports.moneyFormat = exports.normalizeMulti = exports.normalize = exports.zpad = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.timeToSeconds = timeToSeconds;
	exports.secondsToTime = secondsToTime;
	exports.timeDiff = timeDiff;
	exports.secondsToDuration = secondsToDuration;
	exports.timeSubtractSeconds = timeSubtractSeconds;
	exports.dateStringToFriendly = dateStringToFriendly;
	exports.dateStringToDay = dateStringToDay;
	
	var _trans = __webpack_require__(40);
	
	var zpad = exports.zpad = function zpad(num) {
	  return ('00' + num).slice(-2);
	};
	
	function timeToSeconds(time) {
	  var _time$split = time.split(/:/);
	
	  var _time$split2 = _slicedToArray(_time$split, 2);
	
	  var hours = _time$split2[0];
	  var minutes = _time$split2[1];
	
	  return parseInt(hours) * 3600 + parseInt(minutes) * 60;
	}
	
	function secondsToTime(seconds) {
	  if (seconds < 0) {
	    seconds += 86400;
	  }
	  var num = parseInt(seconds);
	  var hours = zpad(Math.floor(num / 3600));
	  var minutes = zpad(Math.floor(Math.floor(num % 3600) / 60), 2);
	  return hours + ':' + minutes;
	}
	
	function timeDiff(from, to) {
	  var seconds = timeToSeconds(to) - timeToSeconds(from);
	  return seconds < 0 ? seconds + 86400 : seconds;
	}
	
	function secondsToDuration(seconds) {
	  var minutes = Math.floor(seconds / 60);
	  if (seconds < 3600) {
	    return minutes + ' min';
	  } else {
	    return Math.floor(minutes / 60) + ' h ' + minutes % 60 + ' min';
	  }
	}
	
	function timeSubtractSeconds(time, seconds) {
	  return secondsToTime(timeToSeconds(time) - seconds);
	}
	
	function dateStringToFriendly(dateString) {
	  var day = dateString.slice(6).replace(/^0/, '');
	  var month = dateString.slice(4, 6).replace(/^0/, '');
	
	  var months = {
	    '1': 'january',
	    '2': 'february',
	    '3': 'march',
	    '4': 'april',
	    '5': 'may',
	    '6': 'june',
	    '7': 'july',
	    '8': 'august',
	    '9': 'september',
	    '10': 'october',
	    '11': 'november',
	    '12': 'december'
	  };
	
	  if ((0, _trans.t)('DATE_BEFORE_MONTH')) {
	    return day + ' ' + (0, _trans.t)(months[month]);
	  } else {
	    return (0, _trans.t)(months[month]) + ' ' + day;
	  }
	}
	
	function dateStringToDay(dateString) {
	  var day = parseInt(dateString.slice(6).replace(/^0/, ''), 10);
	  var month = parseInt(dateString.slice(4, 6).replace(/^0/, ''), 10);
	
	  return month * 31 + day;
	}
	
	var normalize = exports.normalize = function normalize(str) {
	  return str.toLowerCase().replace(/â/g, 'a').replace(/ş/g, 's').replace(/ă/g, 'a').replace(/ţ/g, 't').replace(/î/g, 'i').replace(/\s+/g, '');
	};
	
	var normalizeMulti = exports.normalizeMulti = function normalizeMulti(str) {
	  var preNormalized = str.toLowerCase().replace(/ş/g, 's').replace(/ă/g, 'a').replace(/ţ/g, 't').replace(/\s+/g, '');
	  return [preNormalized.replace(/â/g, 'a').replace(/î/g, 'a'), preNormalized.replace(/â/g, 'i').replace(/î/g, 'i')];
	};
	
	var moneyFormat = exports.moneyFormat = function moneyFormat(amount) {
	  var fraction = (Math.round((amount - Math.floor(amount)) * 10) + '').slice(0, 1).replace(/0+$/, '');
	  return '' + Math.floor(amount) + (fraction ? '.' + fraction : '');
	};
	
	var cleanStationNameForInfofer = exports.cleanStationNameForInfofer = function cleanStationNameForInfofer(name) {
	  return (name + '').replace(/â/g, 'a').replace(/ş/g, 's').replace(/ă/g, 'a').replace(/ţ/g, 't').replace(/\./g, '').replace(/î/g, 'i');
	};
	
	var isTimeBeforeNow = exports.isTimeBeforeNow = function isTimeBeforeNow(time) {
	  var timeInSeconds = timeToSeconds(time);
	  var now = new Date();
	  var nowInSeconds = now.getHours() * 3600 + now.getMinutes() * 60;
	  return timeInSeconds < nowInSeconds;
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(293);
	
	var _runTransitionHook = __webpack_require__(86);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(25);
	
	var _deprecate = __webpack_require__(85);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(369),
	    listCacheDelete = __webpack_require__(370),
	    listCacheGet = __webpack_require__(371),
	    listCacheHas = __webpack_require__(372),
	    listCacheSet = __webpack_require__(373);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 51 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 52 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(98);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	module.exports = baseCreate;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(318),
	    baseMatchesProperty = __webpack_require__(319),
	    identity = __webpack_require__(100),
	    isArray = __webpack_require__(10),
	    property = __webpack_require__(412);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(54),
	    isObject = __webpack_require__(18);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtorWrapper(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtorWrapper;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(366);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 59 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(10),
	    isSymbol = __webpack_require__(43);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(31);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 63 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(51),
	    toInteger = __webpack_require__(65);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as
	 * an array.
	 *
	 * **Note:** This method is based on the
	 * [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, array);
	      case 1: return func.call(this, args[0], array);
	      case 2: return func.call(this, args[0], args[1], array);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = rest;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(419);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(491);


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardMedia = exports.CardActions = exports.CardTitle = exports.CardMenu = exports.CardText = exports.Card = undefined;
	
	var _Card = __webpack_require__(429);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	var _CardTitle = __webpack_require__(431);
	
	Object.defineProperty(exports, 'CardTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardTitle).default;
	  }
	});
	
	var _CardActions = __webpack_require__(430);
	
	Object.defineProperty(exports, 'CardActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardActions).default;
	  }
	});
	
	var _basicClassCreator = __webpack_require__(106);
	
	var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardText = exports.CardText = (0, _basicClassCreator2.default)('CardText', 'mdl-card__supporting-text');
	var CardMenu = exports.CardMenu = (0, _basicClassCreator2.default)('CardMenu', 'mdl-card__menu');
	var CardMedia = exports.CardMedia = (0, _basicClassCreator2.default)('CardMedia', 'mdl-card__media');

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    name: _react.PropTypes.string.isRequired
	};
	
	var Icon = function Icon(props) {
	    var className = props.className;
	    var name = props.name;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'name']);
	
	    var classes = (0, _classnames2.default)('material-icons', className);
	
	    return _react2.default.createElement(
	        'i',
	        _extends({ className: classes }, otherProps),
	        name
	    );
	};
	
	Icon.propTypes = propTypes;
	
	exports.default = Icon;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(70);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(464);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(22);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 71 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getNativeProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var ReactErrorUtils = __webpack_require__(115);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventConstants = __webpack_require__(16);
	var EventPluginRegistry = __webpack_require__(72);
	var ReactEventEmitterMixin = __webpack_require__(510);
	var ViewportMetrics = __webpack_require__(117);
	
	var getVendorPrefixedEventName = __webpack_require__(539);
	var isEventSupported = __webpack_require__(124);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = document.createEvent && 'pageX' in document.createEvent('MouseEvent');
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(47);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(39);
	var ViewportMetrics = __webpack_require__(117);
	
	var getEventModifierState = __webpack_require__(121);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 80 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(82)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 84 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(54),
	    baseLodash = __webpack_require__(92);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(374),
	    mapCacheDelete = __webpack_require__(375),
	    mapCacheGet = __webpack_require__(376),
	    mapCacheHas = __webpack_require__(377),
	    mapCacheSet = __webpack_require__(378);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(50),
	    stackClear = __webpack_require__(384),
	    stackDelete = __webpack_require__(385),
	    stackGet = __webpack_require__(386),
	    stackHas = __webpack_require__(387),
	    stackSet = __webpack_require__(388);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 91 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 92 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 93 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(150);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(162),
	    createBaseWrapper = __webpack_require__(342),
	    createCurryWrapper = __webpack_require__(343),
	    createHybridWrapper = __webpack_require__(168),
	    createPartialWrapper = __webpack_require__(345),
	    getData = __webpack_require__(171),
	    mergeData = __webpack_require__(379),
	    setData = __webpack_require__(181),
	    toInteger = __webpack_require__(65);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBaseWrapper(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurryWrapper(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartialWrapper(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybridWrapper.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setter(result, newData);
	}
	
	module.exports = createWrapper;


/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 97 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(32),
	    func = convert('sum', __webpack_require__(418), __webpack_require__(185));
	
	func.placeholder = __webpack_require__(26);
	module.exports = func;


/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument given to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(102);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(42),
	    isObjectLike = __webpack_require__(33);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(27);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    accent: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    colored: _react.PropTypes.bool,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func]),
	    href: _react.PropTypes.string,
	    primary: _react.PropTypes.bool,
	    raised: _react.PropTypes.bool,
	    ripple: _react.PropTypes.bool
	};
	
	// eslint-disable-next-line react/prefer-stateless-function
	
	var Button = function (_React$Component) {
	    _inherits(Button, _React$Component);
	
	    function Button() {
	        _classCallCheck(this, Button);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Button).apply(this, arguments));
	    }
	
	    _createClass(Button, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var accent = _props.accent;
	            var className = _props.className;
	            var colored = _props.colored;
	            var primary = _props.primary;
	            var raised = _props.raised;
	            var ripple = _props.ripple;
	            var component = _props.component;
	            var href = _props.href;
	            var children = _props.children;
	
	            var otherProps = _objectWithoutProperties(_props, ['accent', 'className', 'colored', 'primary', 'raised', 'ripple', 'component', 'href', 'children']);
	
	            var buttonClasses = (0, _classnames2.default)('mdl-button mdl-js-button', {
	                'mdl-js-ripple-effect': ripple,
	                'mdl-button--raised': raised,
	                'mdl-button--colored': colored,
	                'mdl-button--primary': primary,
	                'mdl-button--accent': accent
	            }, className);
	
	            return _react2.default.createElement(component || (href ? 'a' : 'button'), _extends({
	                className: buttonClasses,
	                href: href
	            }, otherProps), children);
	        }
	    }]);
	
	    return Button;
	}(_react2.default.Component);
	
	Button.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Button);

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _basicClassCreator = __webpack_require__(106);
	
	var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _basicClassCreator2.default)('Spacer', 'mdl-layout-spacer');

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    activeTab: _react.PropTypes.number,
	    className: _react.PropTypes.string,
	    cssPrefix: _react.PropTypes.string.isRequired,
	    onChange: _react.PropTypes.func
	};
	
	var defaultProps = {
	    activeTab: 0
	};
	
	var TabBar = function (_React$Component) {
	    _inherits(TabBar, _React$Component);
	
	    function TabBar(props) {
	        _classCallCheck(this, TabBar);
	
	        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TabBar).call(this, props));
	
	        _this.handleClickTab = _this.handleClickTab.bind(_this);
	        return _this;
	    }
	
	    _createClass(TabBar, [{
	        key: 'handleClickTab',
	        value: function handleClickTab(tabId) {
	            if (this.props.onChange) {
	                this.props.onChange(tabId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var activeTab = _props.activeTab;
	            var className = _props.className;
	            var cssPrefix = _props.cssPrefix;
	            var children = _props.children;
	
	            var otherProps = _objectWithoutProperties(_props, ['activeTab', 'className', 'cssPrefix', 'children']);
	
	            var classes = (0, _classnames2.default)(_defineProperty({}, cssPrefix + '__tab-bar', true), className);
	
	            return _react2.default.createElement(
	                'div',
	                _extends({ className: classes }, otherProps),
	                _react2.default.Children.map(children, function (child, tabId) {
	                    return _react2.default.cloneElement(child, {
	                        cssPrefix: cssPrefix,
	                        tabId: tabId,
	                        active: tabId === activeTab,
	                        onTabClick: _this2.handleClickTab
	                    });
	                })
	            );
	        }
	    }]);
	
	    return TabBar;
	}(_react2.default.Component);
	
	TabBar.propTypes = propTypes;
	TabBar.defaultProps = defaultProps;
	
	exports.default = TabBar;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (displayName, defaultClassName) {
	    var element = arguments.length <= 2 || arguments[2] === undefined ? 'div' : arguments[2];
	
	    var fn = function fn(props) {
	        var className = props.className;
	        var children = props.children;
	
	        var otherProps = _objectWithoutProperties(props, ['className', 'children']);
	
	        return _react2.default.createElement(element, _extends({
	            className: (0, _classnames2.default)(defaultClassName, className)
	        }, otherProps), children);
	    };
	
	    fn.displayName = displayName;
	    fn.propTypes = {
	        className: _react.PropTypes.string
	    };
	
	    return fn;
	};

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(70);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(28);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _Actions = __webpack_require__(30);
	
	var _computeChangedRoutes2 = __webpack_require__(462);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(459);
	
	var _isActive2 = __webpack_require__(467);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(463);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(469);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  function createLocationFromRedirectInfo(location) {
	    return history.createLocation(location, _Actions.REPLACE);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, createLocationFromRedirectInfo(redirectInfo));
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.transitionTo(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(35);
	var Danger = __webpack_require__(483);
	var ReactMultiChildUpdateTypes = __webpack_require__(214);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(12);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(119);
	var setInnerHTML = __webpack_require__(125);
	var setTextContent = __webpack_require__(227);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getNativeNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onNativeOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onNativeOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onNativeOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onNativeOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onNativeOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onNativeOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onNativeOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onNativeOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMInstrumentation = __webpack_require__(501);
	var ReactInstrumentation = __webpack_require__(12);
	
	var quoteAttributeValueForBrowser = __webpack_require__(541);
	var warning = __webpack_require__(3);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onCreateMarkupForProperty(name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onSetValueForProperty(node, name, value);
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onNativeOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onNativeOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          // No HAS_SIDE_EFFECTS logic here, only `value` has it and is string.
	          node[propName] = false;
	        } else {
	          if (!propertyInfo.hasSideEffects || '' + node[propName] !== '') {
	            node[propName] = '';
	          }
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onNativeOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 112 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {*} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(218);
	var ReactPropTypeLocations = __webpack_require__(76);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : void 0;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(119);
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  node.innerHTML = html;
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 126 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactElement = __webpack_require__(14);
	
	var getIteratorFn = __webpack_require__(123);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(112);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyFunction = __webpack_require__(13);
	var warning = __webpack_require__(3);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      if (childTag !== '#text') {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>. ' + 'See %s.%s', tagDisplayName, ancestorTag, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 129 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 130 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(253)
	  , createDesc = __webpack_require__(258);
	module.exports = __webpack_require__(81) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(246);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 133 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(132)
	  , defined = __webpack_require__(129);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 135 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 136 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(13);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 141 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(48);
	
	var _DOMUtils = __webpack_require__(84);
	
	var _createHistory = __webpack_require__(145);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(30);
	
	var _PathUtils = __webpack_require__(25);
	
	var _ExecutionEnvironment = __webpack_require__(48);
	
	var _DOMUtils = __webpack_require__(84);
	
	var _DOMStateStorage = __webpack_require__(142);
	
	var _createDOMHistory = __webpack_require__(143);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(269);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(25);
	
	var _AsyncUtils = __webpack_require__(289);
	
	var _Actions = __webpack_require__(30);
	
	var _createLocation2 = __webpack_require__(291);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(86);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(85);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(48);
	
	var _PathUtils = __webpack_require__(25);
	
	var _runTransitionHook = __webpack_require__(86);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(85);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(54),
	    baseLodash = __webpack_require__(92);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(31),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(88),
	    setCacheAdd = __webpack_require__(382),
	    setCacheHas = __webpack_require__(383);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(31),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(98);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(167),
	    keys = __webpack_require__(21);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(89),
	    arrayEach = __webpack_require__(152),
	    assignValue = __webpack_require__(155),
	    baseAssign = __webpack_require__(156),
	    cloneBuffer = __webpack_require__(330),
	    copyArray = __webpack_require__(56),
	    copySymbols = __webpack_require__(337),
	    getAllKeys = __webpack_require__(348),
	    getTag = __webpack_require__(175),
	    initCloneArray = __webpack_require__(361),
	    initCloneByTag = __webpack_require__(362),
	    initCloneObject = __webpack_require__(363),
	    isArray = __webpack_require__(10),
	    isBuffer = __webpack_require__(405),
	    isHostObject = __webpack_require__(96),
	    isObject = __webpack_require__(18),
	    keys = __webpack_require__(21);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  // Recursively populate clone (susceptible to call stack limits).
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(164),
	    isKey = __webpack_require__(60),
	    toKey = __webpack_require__(41);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(173);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return object != null &&
	    (hasOwnProperty.call(object, key) ||
	      (typeof object == 'object' && key in object && getPrototype(object) === null));
	}
	
	module.exports = baseHas;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(315),
	    isObject = __webpack_require__(18),
	    isObjectLike = __webpack_require__(33);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 161 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = Object.keys;
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	module.exports = baseKeys;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(100),
	    metaMap = __webpack_require__(180);
	
	/**
	 * The base implementation of `setData` without support for hot loop detection.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(10),
	    stringToPath = __webpack_require__(183);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = castPath;


/***/ },
/* 165 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 166 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(155);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];
	
	    assignValue(object, key, newValue);
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(165),
	    composeArgsRight = __webpack_require__(166),
	    countHolders = __webpack_require__(339),
	    createCtorWrapper = __webpack_require__(57),
	    createRecurryWrapper = __webpack_require__(169),
	    getHolder = __webpack_require__(172),
	    reorder = __webpack_require__(381),
	    replaceHolders = __webpack_require__(97),
	    root = __webpack_require__(11);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    ARY_FLAG = 128,
	    FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurryWrapper(
	        func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtorWrapper(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybridWrapper;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(367),
	    setData = __webpack_require__(181);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return result;
	}
	
	module.exports = createRecurryWrapper;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(149),
	    arraySome = __webpack_require__(154);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(180),
	    noop = __webpack_require__(410);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 173 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	module.exports = getPrototype;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var stubArray = __webpack_require__(416);
	
	/** Built-in value references. */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	function getSymbols(object) {
	  // Coerce `object` to an object to avoid non-object errors in V8.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	  return getOwnPropertySymbols(Object(object));
	}
	
	// Fallback for IE < 11.
	if (!getOwnPropertySymbols) {
	  getSymbols = stubArray;
	}
	
	module.exports = getSymbols;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(297),
	    Map = __webpack_require__(148),
	    Promise = __webpack_require__(299),
	    Set = __webpack_require__(300),
	    WeakMap = __webpack_require__(151),
	    toSource = __webpack_require__(184);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 176 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 178 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 179 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(151);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(162),
	    now = __webpack_require__(411);
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 150,
	    HOT_SPAN = 16;
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = (function() {
	  var count = 0,
	      lastCalled = 0;
	
	  return function(key, value) {
	    var stamp = now(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return key;
	      }
	    } else {
	      count = 0;
	    }
	    return baseSetData(key, value);
	  };
	}());
	
	module.exports = setData;


/***/ },
/* 182 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(409),
	    toString = __webpack_require__(422);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(\.|\[\])(?:\4|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  var result = [];
	  toString(string).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 184 */
/***/ function(module, exports) {

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 185 */
/***/ function(module, exports) {

	module.exports = {
	  'cap': false,
	  'curry': false,
	  'fixed': false,
	  'immutable': false,
	  'rearg': false
	};


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(32),
	    func = convert('keys', __webpack_require__(21), __webpack_require__(185));
	
	func.placeholder = __webpack_require__(26);
	module.exports = func;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(10),
	    isObjectLike = __webpack_require__(33);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Spacer = __webpack_require__(104);
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HeaderRow = function HeaderRow(props) {
	    var className = props.className;
	    var title = props.title;
	    var children = props.children;
	    var hideSpacer = props.hideSpacer;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'title', 'children', 'hideSpacer']);
	
	    var classes = (0, _classnames2.default)('mdl-layout__header-row', className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        title && _react2.default.createElement(
	            'span',
	            { className: 'mdl-layout-title' },
	            title
	        ),
	        title && !hideSpacer && _react2.default.createElement(_Spacer2.default, null),
	        children
	    );
	};
	HeaderRow.propTypes = {
	    className: _react.PropTypes.string,
	    title: _react.PropTypes.node,
	    hideSpacer: _react.PropTypes.bool
	};
	
	exports.default = HeaderRow;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TabBar = __webpack_require__(105);
	
	var _TabBar2 = _interopRequireDefault(_TabBar);
	
	var _mdlUpgrade = __webpack_require__(27);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HeaderTabs = function HeaderTabs(props) {
	    var className = props.className;
	    var ripple = props.ripple;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'ripple', 'children']);
	
	    var classes = (0, _classnames2.default)({
	        'mdl-js-ripple-effect': ripple
	    }, className);
	
	    return _react2.default.createElement(
	        _TabBar2.default,
	        _extends({ cssPrefix: 'mdl-layout', className: classes }, otherProps),
	        children
	    );
	};
	HeaderTabs.propTypes = {
	    activeTab: _react.PropTypes.number,
	    className: _react.PropTypes.string,
	    onChange: _react.PropTypes.func,
	    ripple: _react.PropTypes.bool
	};
	
	exports.default = (0, _mdlUpgrade2.default)(HeaderTabs);

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(68);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    avatar: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	    children: _react.PropTypes.node,
	    className: _react.PropTypes.string,
	    icon: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	    subtitle: _react.PropTypes.node,
	    useBodyClass: _react.PropTypes.bool
	};
	
	function createIcon(type, icon) {
	    if (typeof icon === 'string') {
	        return _react2.default.createElement(_Icon2.default, { className: 'mdl-list__item-' + type, name: icon });
	    }
	    return _react2.default.cloneElement(icon, { className: 'mdl-list__item-' + type });
	}
	
	var ListItemContent = function ListItemContent(props) {
	    var avatar = props.avatar;
	    var children = props.children;
	    var className = props.className;
	    var icon = props.icon;
	    var subtitle = props.subtitle;
	    var useBodyClass = props.useBodyClass;
	
	    var otherProps = _objectWithoutProperties(props, ['avatar', 'children', 'className', 'icon', 'subtitle', 'useBodyClass']);
	
	    var classes = (0, _classnames2.default)('mdl-list__item-primary-content', className);
	    var subtitleClassName = useBodyClass ? 'mdl-list__item-text-body' : 'mdl-list__item-sub-title';
	
	    var iconElement = null;
	    if (icon) {
	        iconElement = createIcon('icon', icon);
	    } else if (avatar) {
	        iconElement = createIcon('avatar', avatar);
	    }
	
	    return _react2.default.createElement(
	        'span',
	        _extends({ className: classes }, otherProps),
	        iconElement,
	        _react2.default.createElement(
	            'span',
	            null,
	            children
	        ),
	        subtitle && _react2.default.createElement(
	            'span',
	            { className: subtitleClassName },
	            subtitle
	        )
	    );
	};
	
	ListItemContent.propTypes = propTypes;
	
	exports.default = ListItemContent;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    active: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func]),
	    cssPrefix: _react.PropTypes.string,
	    onTabClick: _react.PropTypes.func,
	    style: _react.PropTypes.object,
	    tabId: _react.PropTypes.number
	};
	
	var defaultProps = {
	    style: {}
	};
	
	var Tab = function Tab(props) {
	    var _classNames;
	
	    var active = props.active;
	    var className = props.className;
	    var component = props.component;
	    var children = props.children;
	    var cssPrefix = props.cssPrefix;
	    var onTabClick = props.onTabClick;
	    var style = props.style;
	    var tabId = props.tabId;
	
	    var otherProps = _objectWithoutProperties(props, ['active', 'className', 'component', 'children', 'cssPrefix', 'onTabClick', 'style', 'tabId']);
	
	    var classes = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, cssPrefix + '__tab', true), _defineProperty(_classNames, 'is-active', active), _classNames), className);
	
	    style.cursor = 'pointer';
	
	    return _react2.default.createElement(component || 'a', _extends({
	        className: classes,
	        onClick: function onClick() {
	            return onTabClick(tabId);
	        },
	        style: style
	    }, otherProps), children);
	};
	
	Tab.propTypes = propTypes;
	Tab.defaultProps = defaultProps;
	
	exports.default = Tab;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]).isRequired,
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(22);
	
	var _PatternUtils = __webpack_require__(34);
	
	var _InternalPropTypes = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(70);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(49);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(146);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(292);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(198);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(70);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(49);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(146);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(23);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 201 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(23);
	var ReactElement = __webpack_require__(14);
	
	var emptyFunction = __webpack_require__(13);
	var traverseAllChildren = __webpack_require__(127);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactComponent = __webpack_require__(204);
	var ReactElement = __webpack_require__(14);
	var ReactPropTypeLocations = __webpack_require__(76);
	var ReactPropTypeLocationNames = __webpack_require__(75);
	var ReactNoopUpdateQueue = __webpack_require__(217);
	
	var emptyObject = __webpack_require__(46);
	var invariant = __webpack_require__(2);
	var keyMirror = __webpack_require__(47);
	var keyOf = __webpack_require__(20);
	var warning = __webpack_require__(3);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.') : invariant(false) : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(217);
	var ReactInstrumentation = __webpack_require__(12);
	
	var canDefineProperty = __webpack_require__(118);
	var emptyObject = __webpack_require__(46);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : void 0;
	  if (false) {
	    ReactInstrumentation.debugTool.onSetState();
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(110);
	var ReactDOMIDOperations = __webpack_require__(499);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {}
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 206 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DisabledInputUtils = __webpack_require__(71);
	var LinkedValueUtils = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(17);
	
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValueNull = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function warnIfValueIsNull(props) {
	  if (props != null && props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `select` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.') : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getNativeProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getNativeProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	      warnIfValueIsNull(props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    if (false) {
	      warnIfValueIsNull(props);
	    }
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDebugTool
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var performanceNow = __webpack_require__(285);
	var warning = __webpack_require__(3);
	
	var eventHandlers = [];
	var handlerDoesThrowForEvent = {};
	
	function emitEvent(handlerFunctionName, arg1, arg2, arg3, arg4, arg5) {
	  if (false) {
	    eventHandlers.forEach(function (handler) {
	      try {
	        if (handler[handlerFunctionName]) {
	          handler[handlerFunctionName](arg1, arg2, arg3, arg4, arg5);
	        }
	      } catch (e) {
	        process.env.NODE_ENV !== 'production' ? warning(!handlerDoesThrowForEvent[handlerFunctionName], 'exception thrown by devtool while handling %s: %s', handlerFunctionName, e.message) : void 0;
	        handlerDoesThrowForEvent[handlerFunctionName] = true;
	      }
	    });
	  }
	}
	
	var isProfiling = false;
	var flushHistory = [];
	var currentFlushNesting = 0;
	var currentFlushMeasurements = null;
	var currentFlushStartTime = null;
	var currentTimerDebugID = null;
	var currentTimerStartTime = null;
	var currentTimerType = null;
	
	function clearHistory() {
	  ReactComponentTreeDevtool.purgeUnmountedComponents();
	  ReactNativeOperationHistoryDevtool.clearHistory();
	}
	
	function getTreeSnapshot(registeredIDs) {
	  return registeredIDs.reduce(function (tree, id) {
	    var ownerID = ReactComponentTreeDevtool.getOwnerID(id);
	    var parentID = ReactComponentTreeDevtool.getParentID(id);
	    tree[id] = {
	      displayName: ReactComponentTreeDevtool.getDisplayName(id),
	      text: ReactComponentTreeDevtool.getText(id),
	      updateCount: ReactComponentTreeDevtool.getUpdateCount(id),
	      childIDs: ReactComponentTreeDevtool.getChildIDs(id),
	      // Text nodes don't have owners but this is close enough.
	      ownerID: ownerID || ReactComponentTreeDevtool.getOwnerID(parentID),
	      parentID: parentID
	    };
	    return tree;
	  }, {});
	}
	
	function resetMeasurements() {
	  if (false) {
	    var previousStartTime = currentFlushStartTime;
	    var previousMeasurements = currentFlushMeasurements || [];
	    var previousOperations = ReactNativeOperationHistoryDevtool.getHistory();
	
	    if (!isProfiling || currentFlushNesting === 0) {
	      currentFlushStartTime = null;
	      currentFlushMeasurements = null;
	      clearHistory();
	      return;
	    }
	
	    if (previousMeasurements.length || previousOperations.length) {
	      var registeredIDs = ReactComponentTreeDevtool.getRegisteredIDs();
	      flushHistory.push({
	        duration: performanceNow() - previousStartTime,
	        measurements: previousMeasurements || [],
	        operations: previousOperations || [],
	        treeSnapshot: getTreeSnapshot(registeredIDs)
	      });
	    }
	
	    clearHistory();
	    currentFlushStartTime = performanceNow();
	    currentFlushMeasurements = [];
	  }
	}
	
	function checkDebugID(debugID) {
	   false ? warning(debugID, 'ReactDebugTool: debugID may not be empty.') : void 0;
	}
	
	var ReactDebugTool = {
	  addDevtool: function (devtool) {
	    eventHandlers.push(devtool);
	  },
	  removeDevtool: function (devtool) {
	    for (var i = 0; i < eventHandlers.length; i++) {
	      if (eventHandlers[i] === devtool) {
	        eventHandlers.splice(i, 1);
	        i--;
	      }
	    }
	  },
	  beginProfiling: function () {
	    if (false) {
	      if (isProfiling) {
	        return;
	      }
	
	      isProfiling = true;
	      flushHistory.length = 0;
	      resetMeasurements();
	    }
	  },
	  endProfiling: function () {
	    if (false) {
	      if (!isProfiling) {
	        return;
	      }
	
	      isProfiling = false;
	      resetMeasurements();
	    }
	  },
	  getFlushHistory: function () {
	    if (false) {
	      return flushHistory;
	    }
	  },
	  onBeginFlush: function () {
	    if (false) {
	      currentFlushNesting++;
	      resetMeasurements();
	    }
	    emitEvent('onBeginFlush');
	  },
	  onEndFlush: function () {
	    if (false) {
	      resetMeasurements();
	      currentFlushNesting--;
	    }
	    emitEvent('onEndFlush');
	  },
	  onBeginLifeCycleTimer: function (debugID, timerType) {
	    checkDebugID(debugID);
	    emitEvent('onBeginLifeCycleTimer', debugID, timerType);
	    if (false) {
	      if (isProfiling && currentFlushNesting > 0) {
	        process.env.NODE_ENV !== 'production' ? warning(!currentTimerType, 'There is an internal error in the React performance measurement code. ' + 'Did not expect %s timer to start while %s timer is still in ' + 'progress for %s instance.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
	        currentTimerStartTime = performanceNow();
	        currentTimerDebugID = debugID;
	        currentTimerType = timerType;
	      }
	    }
	  },
	  onEndLifeCycleTimer: function (debugID, timerType) {
	    checkDebugID(debugID);
	    if (false) {
	      if (isProfiling && currentFlushNesting > 0) {
	        process.env.NODE_ENV !== 'production' ? warning(currentTimerType === timerType, 'There is an internal error in the React performance measurement code. ' + 'We did not expect %s timer to stop while %s timer is still in ' + 'progress for %s instance. Please report this as a bug in React.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
	        currentFlushMeasurements.push({
	          timerType: timerType,
	          instanceID: debugID,
	          duration: performanceNow() - currentTimerStartTime
	        });
	        currentTimerStartTime = null;
	        currentTimerDebugID = null;
	        currentTimerType = null;
	      }
	    }
	    emitEvent('onEndLifeCycleTimer', debugID, timerType);
	  },
	  onBeginReconcilerTimer: function (debugID, timerType) {
	    checkDebugID(debugID);
	    emitEvent('onBeginReconcilerTimer', debugID, timerType);
	  },
	  onEndReconcilerTimer: function (debugID, timerType) {
	    checkDebugID(debugID);
	    emitEvent('onEndReconcilerTimer', debugID, timerType);
	  },
	  onBeginProcessingChildContext: function () {
	    emitEvent('onBeginProcessingChildContext');
	  },
	  onEndProcessingChildContext: function () {
	    emitEvent('onEndProcessingChildContext');
	  },
	  onNativeOperation: function (debugID, type, payload) {
	    checkDebugID(debugID);
	    emitEvent('onNativeOperation', debugID, type, payload);
	  },
	  onSetState: function () {
	    emitEvent('onSetState');
	  },
	  onSetDisplayName: function (debugID, displayName) {
	    checkDebugID(debugID);
	    emitEvent('onSetDisplayName', debugID, displayName);
	  },
	  onSetChildren: function (debugID, childDebugIDs) {
	    checkDebugID(debugID);
	    emitEvent('onSetChildren', debugID, childDebugIDs);
	  },
	  onSetOwner: function (debugID, ownerDebugID) {
	    checkDebugID(debugID);
	    emitEvent('onSetOwner', debugID, ownerDebugID);
	  },
	  onSetText: function (debugID, text) {
	    checkDebugID(debugID);
	    emitEvent('onSetText', debugID, text);
	  },
	  onMountRootComponent: function (debugID) {
	    checkDebugID(debugID);
	    emitEvent('onMountRootComponent', debugID);
	  },
	  onMountComponent: function (debugID) {
	    checkDebugID(debugID);
	    emitEvent('onMountComponent', debugID);
	  },
	  onUpdateComponent: function (debugID) {
	    checkDebugID(debugID);
	    emitEvent('onUpdateComponent', debugID);
	  },
	  onUnmountComponent: function (debugID) {
	    checkDebugID(debugID);
	    emitEvent('onUnmountComponent', debugID);
	  }
	};
	
	if (false) {
	  var ReactInvalidSetStateWarningDevTool = require('./ReactInvalidSetStateWarningDevTool');
	  var ReactNativeOperationHistoryDevtool = require('./ReactNativeOperationHistoryDevtool');
	  var ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	  ReactDebugTool.addDevtool(ReactInvalidSetStateWarningDevTool);
	  ReactDebugTool.addDevtool(ReactComponentTreeDevtool);
	  ReactDebugTool.addDevtool(ReactNativeOperationHistoryDevtool);
	  var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	  if (/[?&]react_perf\b/.test(url)) {
	    ReactDebugTool.beginProfiling();
	  }
	}
	
	module.exports = ReactDebugTool;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	var ReactPropTypeLocations = __webpack_require__(76);
	var ReactPropTypeLocationNames = __webpack_require__(75);
	var ReactCurrentOwner = __webpack_require__(24);
	
	var canDefineProperty = __webpack_require__(118);
	var getIteratorFn = __webpack_require__(123);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : void 0;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : void 0;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : void 0;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : void 0;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ },
/* 210 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 211 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(503);
	
	var containsNode = __webpack_require__(274);
	var focusNode = __webpack_require__(138);
	var getActiveElement = __webpack_require__(139);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(35);
	var DOMProperty = __webpack_require__(29);
	var ReactBrowserEventEmitter = __webpack_require__(74);
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMContainerInfo = __webpack_require__(494);
	var ReactDOMFeatureFlags = __webpack_require__(498);
	var ReactElement = __webpack_require__(14);
	var ReactFeatureFlags = __webpack_require__(211);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactMarkupChecksum = __webpack_require__(513);
	var ReactReconciler = __webpack_require__(38);
	var ReactUpdateQueue = __webpack_require__(219);
	var ReactUpdates = __webpack_require__(17);
	
	var emptyObject = __webpack_require__(46);
	var instantiateReactComponent = __webpack_require__(225);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(125);
	var shouldUpdateReactComponent = __webpack_require__(126);
	var warning = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context);
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  ReactReconciler.unmountComponent(instance, safely);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._nativeParent);
	  }
	}
	
	function getNativeRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevNativeInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevNativeInstance && !prevNativeInstance._nativeParent ? prevNativeInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getNativeRootInstanceInContainer(container);
	  return root ? root._nativeContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by devtools!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginFlush();
	    }
	
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement);
	
	    if (false) {
	      // Mute future events from the top level wrapper.
	      // It is an implementation detail that devtools should not know about.
	      componentInstance._debugID = 0;
	    }
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    if (false) {
	      // The instance here is TopLevelWrapper so we report mount for its child.
	      ReactInstrumentation.debugTool.onMountRootComponent(componentInstance._renderedComponent._debugID);
	      ReactInstrumentation.debugTool.onEndFlush();
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : void 0;
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var nativeNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (nativeNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onNativeOperation(nativeNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(47);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var invariant = __webpack_require__(2);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	
	var ReactNodeTypes = {
	  NATIVE: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.NATIVE;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : invariant(false) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(3);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	var ReactPropTypeLocationNames = __webpack_require__(75);
	
	var emptyFunction = __webpack_require__(13);
	var getIteratorFn = __webpack_require__(123);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactInstanceMap = __webpack_require__(116);
	var ReactUpdates = __webpack_require__(17);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : invariant(false) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 220 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.1.0';

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : void 0;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 222 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNativeComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(216);
	
	function getNativeComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.NATIVE) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getNativeComponentFromComposite;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCompositeComponent = __webpack_require__(490);
	var ReactEmptyComponent = __webpack_require__(210);
	var ReactNativeComponent = __webpack_require__(215);
	var ReactInstrumentation = __webpack_require__(12);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getDisplayName(instance) {
	  var element = instance._currentElement;
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else if (instance.getName) {
	    return instance.getName() || 'Unknown';
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  var isEmpty = node === null || node === false;
	  if (isEmpty) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getNativeNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  if (false) {
	    var debugID = isEmpty ? 0 : nextDebugID++;
	    instance._debugID = debugID;
	
	    if (debugID !== 0) {
	      var displayName = getDisplayName(instance);
	      ReactInstrumentation.debugTool.onSetDisplayName(debugID, displayName);
	      var owner = node && node._owner;
	      if (owner) {
	        ReactInstrumentation.debugTool.onSetOwner(debugID, owner._debugID);
	      }
	    }
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 226 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	var escapeTextContentForBrowser = __webpack_require__(79);
	var setInnerHTML = __webpack_require__(125);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 229 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Textfield = __webpack_require__(446);
	
	var _Textfield2 = _interopRequireDefault(_Textfield);
	
	var _List = __webpack_require__(441);
	
	var _Card = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoComplete = function (_React$Component) {
	  _inherits(AutoComplete, _React$Component);
	
	  function AutoComplete(props) {
	    _classCallCheck(this, AutoComplete);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AutoComplete).call(this, props));
	
	    _this.state = { value: '' };
	    return _this;
	  }
	
	  _createClass(AutoComplete, [{
	    key: 'onSelect',
	    value: function onSelect(match) {
	      this.setState({
	        focused: false,
	        value: match
	      });
	      this.props.onNewRequest(match);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState({
	        value: e.target.value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var filter = _props.filter;
	      var dataSource = _props.dataSource;
	      var hintText = _props.hintText;
	      var maxSearchResults = _props.maxSearchResults;
	      var id = _props.id;
	      var fullWidth = _props.fullWidth;
	
	      var currentValue = this.state.focused ? this.state.value : this.props.searchText || '';
	      var matches = dataSource.filter(function (value) {
	        return currentValue && currentValue.length > 0 && filter(currentValue, value);
	      }).slice(0, maxSearchResults);
	
	      return _jsx('div', {
	        className: fullWidth ? 'AutoComplete-full-width' : '',
	        id: id + '-container'
	      }, void 0, _jsx(_Textfield2.default, {
	        onChange: this.onChange.bind(this),
	        onFocus: function onFocus() {
	          _this2.setState({ focused: true, value: '' });
	          if (screen.width < 740) {
	            document.getElementById(id + '-container').scrollIntoView();
	          }
	        },
	        onBlur: function onBlur() {
	          return _this2.setState({ focused: false });
	        },
	        label: hintText,
	        floatingLabel: true,
	        value: currentValue,
	        id: id
	      }), !this.state.focused || !matches.length ? null : _jsx(_Card.Card, {
	        shadow: 0
	      }, void 0, _jsx(_List.List, {}, void 0, matches.map(function (match) {
	        return _jsx(_List.ListItem, {
	          onMouseDown: function onMouseDown() {
	            return _this2.onSelect(match);
	          },
	          style: { cursor: 'pointer' }
	        }, void 0, match);
	      }))));
	    }
	  }]);
	
	  return AutoComplete;
	}(_react2.default.Component);
	
	exports.default = AutoComplete;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Page = __webpack_require__(233);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _reactRouter = __webpack_require__(466);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(544);
	
	var _ref = _jsx(_reactRouter.Router, {
	  history: _reactRouter.browserHistory
	}, void 0, _jsx(_reactRouter.Route, {
	  path: '/',
	  component: _Page2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/train/',
	  component: _Page2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/train/:trainNumber/',
	  component: _Page2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/route/',
	  component: _Page2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/route/:routeFrom/',
	  component: _Page2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/route//:routeTo/',
	  component: _Page2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/route/:routeFrom/:routeTo/',
	  component: _Page2.default
	}));
	
	function AppComponent(props) {
	  return _ref;
	}
	
	AppComponent.defaultProps = {};
	
	exports.default = AppComponent;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(67);
	
	var _trans = __webpack_require__(40);
	
	var _Icon = __webpack_require__(68);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('br', {});
	
	exports.default = function () {
	  return _jsx(_Card.Card, {
	    shadow: 0,
	    style: { minHeight: 0, width: '100%' }
	  }, void 0, _jsx('div', {
	    style: { textAlign: 'center', fontSize: '1.3em', padding: '18px' }
	  }, void 0, _jsx(_Icon2.default, {
	    name: 'train',
	    style: { fontSize: '40px' }
	  }), _ref, (0, _trans.t)('no trains')));
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Train = __webpack_require__(234);
	
	var _Train2 = _interopRequireDefault(_Train);
	
	var _NoTrainResults = __webpack_require__(232);
	
	var _NoTrainResults2 = _interopRequireDefault(_NoTrainResults);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _finder = __webpack_require__(237);
	
	var _utils = __webpack_require__(44);
	
	var _trans = __webpack_require__(40);
	
	var _Layout = __webpack_require__(438);
	
	var _Button = __webpack_require__(103);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Tabs = __webpack_require__(445);
	
	var _Card = __webpack_require__(67);
	
	var _AutoComplete = __webpack_require__(230);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	var _Icon = __webpack_require__(68);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Switch = __webpack_require__(443);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	var _FABButton = __webpack_require__(432);
	
	var _FABButton2 = _interopRequireDefault(_FABButton);
	
	var _Spinner = __webpack_require__(442);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _firebase = __webpack_require__(286);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var firebaseConfig = {
	  apiKey: 'AIzaSyD3nyYOe5GEaEkrobRx5zO9Wugl3auC9MA',
	  authDomain: 'intarzieriacceleratul.firebaseapp.com',
	  databaseURL: 'https://intarzieriacceleratul.firebaseio.com',
	  storageBucket: 'intarzieriacceleratul.appspot.com'
	};
	
	var firebaseApp = void 0;
	if (!_firebase2.default.apps.length) {
	  firebaseApp = _firebase2.default.initializeApp(firebaseConfig).database();
	} else {
	  firebaseApp = _firebase2.default.apps[0].database();
	}
	
	var _ref = _jsx(_Layout.Header, {
	  title: _jsx('img', {
	    src: '/images/header-logo.png',
	    height: '64',
	    width: '195'
	  })
	}, void 0, _jsx(_Layout.Navigation, {}, void 0, _jsx('a', {
	  href: 'mailto:gabi@purcaru.com'
	}, void 0, 'BETA')));
	
	var _ref2 = _jsx(_Icon2.default, {
	  name: 'search'
	});
	
	var _ref3 = _jsx(_Icon2.default, {
	  name: 'compare_arrows'
	});
	
	var _ref4 = _jsx(_Icon2.default, {
	  name: 'train'
	});
	
	var _ref5 = _jsx(_Icon2.default, {
	  name: 'search'
	});
	
	var _ref6 = _jsx(_Spinner2.default, {});
	
	var _ref7 = _jsx('hr', {});
	
	var _ref8 = _jsx(_NoTrainResults2.default, {});
	
	var _ref9 = _jsx('a', {
	  href: 'mailto:gabi+acceleratul@purcaru.com'
	}, void 0, 'gabi@purcaru.com');
	
	var _ref10 = _jsx('p', {}, void 0, '©2016 ', _jsx('a', {
	  href: 'http://gabi.purcaru.com'
	}, void 0, 'Gabi Purcaru'));
	
	var _ref11 = _jsx('p', {}, void 0, _jsx('a', {
	  href: 'https://www.facebook.com/acceleratul'
	}, void 0, _jsx('img', {
	  src: '/images/fb-logo-small.png',
	  width: '29',
	  height: '29'
	})));
	
	var _ref12 = _jsx(_Icon2.default, {
	  name: 'call'
	});
	
	var Page = function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Page).call(this, props));
	
	    var stations = (0, _finder.getStations)();
	    var trains = (0, _finder.getTrains)();
	    _this.state = {
	      stations: stations,
	      trains: trains,
	      directOnly: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'selectedTab',
	    value: function selectedTab() {
	      return this.props.location.pathname.indexOf('train') !== -1 ? 'train' : 'route';
	    }
	  }, {
	    key: 'selectedTabId',
	    value: function selectedTabId() {
	      return ['route', 'train'].indexOf(this.selectedTab());
	    }
	  }, {
	    key: 'fakeSearch',
	    value: function fakeSearch() {
	      var _this2 = this;
	
	      this.setState({ loading: true });
	      setTimeout(function () {
	        _this2.setState({ loading: false });
	      }, 200);
	    }
	  }, {
	    key: 'updateFrom',
	    value: function updateFrom(station) {
	      var _this3 = this;
	
	      this.setState({ loading: true });
	
	      setTimeout(function () {
	        _this3.setState({ loading: false });
	        if (!_this3.props.params.routeTo) {
	          _this3.context.router.replace('/route/' + station + '/');
	        } else {
	          _this3.context.router.replace('/route/' + station + '/' + _this3.props.params.routeTo + '/');
	        }
	      }, 200);
	    }
	  }, {
	    key: 'updateTo',
	    value: function updateTo(station) {
	      var _this4 = this;
	
	      this.setState({ loading: true });
	
	      setTimeout(function () {
	        _this4.setState({ loading: false });
	        _this4.context.router.replace('/route/' + (_this4.props.params.routeFrom || '') + '/' + station + '/');
	      }, 200);
	    }
	  }, {
	    key: 'updateTrain',
	    value: function updateTrain(train) {
	      var _this5 = this;
	
	      this.setState({ loading: true });
	
	      setTimeout(function () {
	        _this5.setState({ loading: false });
	        _this5.context.router.replace('/train/' + train + '/');
	      });
	    }
	  }, {
	    key: 'autoCompleteFilter',
	    value: function autoCompleteFilter(searchText, key) {
	      return (0, _utils.normalizeMulti)(key).filter(function (option) {
	        return option.indexOf((0, _utils.normalize)(searchText)) !== -1;
	      }).length > 0;
	    }
	  }, {
	    key: 'reverseStations',
	    value: function reverseStations() {
	      var _this6 = this;
	
	      this.setState({ loading: true });
	
	      setTimeout(function () {
	        _this6.setState({ loading: false });
	        _this6.context.router.replace('/route/' + _this6.props.params.routeTo + '/' + _this6.props.params.routeFrom + '/');
	      }, 200);
	    }
	  }, {
	    key: 'changeTab',
	    value: function changeTab(selectedTabId) {
	      this.context.router.replace(selectedTabId === 0 ? '/route/' : '/train/');
	    }
	  }, {
	    key: 'setDirectOnly',
	    value: function setDirectOnly() {
	      this.setState({ directOnly: !this.state.directOnly });
	    }
	  }, {
	    key: 'searchOnInfofer',
	    value: function searchOnInfofer() {
	      var date = new Date();
	      var today = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
	
	      var leavesFrom = (0, _utils.cleanStationNameForInfofer)(this.props.params.routeFrom);
	      var arrivesAt = (0, _utils.cleanStationNameForInfofer)(this.props.params.routeTo);
	      var lang = 'en';
	      window.location = 'https://bilete.cfrcalatori.ro/vanzare/rute_.aspx?keyimt=dtm%3d' + today + '&p=' + leavesFrom + '&d=' + arrivesAt + '&ora=CURENTA&cautavans=0&lng=' + lang;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var trains = void 0;
	      var fastestTrain = void 0;
	      if (this.selectedTab() === 'route') {
	        if (this.props.params.routeFrom === this.props.params.routeTo) {
	          trains = [];
	        } else if (this.props.params.routeFrom && !this.props.params.routeTo) {
	          trains = (0, _finder.findRouteFrom)(this.props.params.routeFrom);
	        } else if (!this.props.params.routeFrom && this.props.params.routeTo) {
	          trains = (0, _finder.findRouteTo)(this.props.params.routeTo);
	        } else {
	          trains = (0, _finder.findRoute)(this.props.params.routeFrom, this.props.params.routeTo);
	          if (trains.length > 1) {
	            fastestTrain = trains[0];
	            trains.slice(1).map(function (train) {
	              if ((0, _utils.timeDiff)(train.leavesAt, train.arrivesAt) < (0, _utils.timeDiff)(fastestTrain.leavesAt, fastestTrain.arrivesAt)) {
	                fastestTrain = train;
	              }
	            });
	          }
	        }
	        if (this.state.directOnly) {
	          trains = trains.filter(function (train) {
	            return train.legs.length === 1;
	          });
	        }
	      } else {
	        trains = (0, _finder.findTrain)(this.props.params.trainNumber);
	      }
	
	      var otherLanguage = (0, _trans.currentLanguage)() === 'ro' ? 'EN' : 'RO';
	
	      var renderTrain = function renderTrain(train, idx) {
	        var firstTrain = train.legs[0].train;
	        var fullTrainNumber = firstTrain.type + ' ' + firstTrain.number;
	        return _jsx(_Train2.default, {
	          firebase: firebaseApp,
	          train: train,
	          forceOpen: _this7.selectedTab() === 'train' && fullTrainNumber === _this7.props.params.trainNumber,
	          isFastest: train === fastestTrain,
	          showStations: _this7.selectedTab() === 'train' || !_this7.props.params.routeFrom || !_this7.props.params.routeTo
	        }, idx + ' ' + train.legs.map(function (leg) {
	          return leg.train.number;
	        }).join(' '));
	      };
	
	      var trainsBefore = trains.filter(function (train) {
	        return (0, _utils.isTimeBeforeNow)(train.leavesAt);
	      });
	      var trainsAfter = trains.filter(function (train) {
	        return !(0, _utils.isTimeBeforeNow)(train.leavesAt);
	      });
	
	      return _jsx('div', {}, void 0, _jsx(_Layout.Layout, {
	        fixedHeader: true
	      }, void 0, _ref, _jsx(_Layout.Content, {
	        className: 'Page-content'
	      }, void 0, _jsx(_Card.Card, {
	        shadow: 0,
	        style: { width: '100%', marginBottom: '10px', padding: '10px' }
	      }, void 0, _jsx(_Tabs.Tabs, {
	        ripple: true,
	        activeTab: this.selectedTabId(),
	        onChange: this.changeTab.bind(this),
	        style: { marginBottom: '10px' },
	        className: 'Tabs-full-width is-upgraded'
	      }, void 0, _jsx(_Tabs.Tab, {}, void 0, (0, _trans.t)('search route')), _jsx(_Tabs.Tab, {}, void 0, (0, _trans.t)('search train'))), this.selectedTab() !== 'route' ? null : _jsx('div', {}, void 0, _jsx('div', {
	        style: { position: 'relative' }
	      }, void 0, _jsx(_AutoComplete2.default, {
	        hintText: (0, _trans.t)('from'),
	        fullWidth: true,
	        maxSearchResults: 6,
	        searchText: this.props.params.routeFrom,
	        onNewRequest: this.updateFrom.bind(this),
	        filter: this.autoCompleteFilter,
	        dataSource: this.state.stations,
	        id: 'routeFrom'
	      })), _jsx('div', {
	        style: { position: 'relative' }
	      }, void 0, _jsx(_AutoComplete2.default, {
	        hintText: (0, _trans.t)('to'),
	        fullWidth: true,
	        maxSearchResults: 6,
	        searchText: this.props.params.routeTo,
	        onNewRequest: this.updateTo.bind(this),
	        filter: this.autoCompleteFilter,
	        dataSource: this.state.stations,
	        id: 'routeTo'
	      })), _jsx('div', {}, void 0, _jsx(_Button2.default, {
	        raised: true,
	        colored: true,
	        style: { marginRight: '10px' },
	        onClick: this.fakeSearch.bind(this)
	      }, void 0, _ref2, (0, _trans.t)('search')), _jsx(_Button2.default, {
	        raised: true,
	        onClick: this.reverseStations.bind(this)
	      }, void 0, _ref3, (0, _trans.t)('reverse')), this.props.params.routeFrom && this.props.params.routeTo ? _jsx('div', {
	        style: { marginTop: '10px' }
	      }, void 0, _jsx(_Button2.default, {
	        accent: true,
	        raised: true,
	        onClick: this.searchOnInfofer.bind(this)
	      }, void 0, _ref4, (0, _trans.t)('search on infofer'))) : null, _jsx('div', {
	        style: { marginTop: '10px' }
	      }), _jsx(_Switch2.default, {
	        checked: this.state.directOnly,
	        onChange: this.setDirectOnly.bind(this),
	        ripple: true
	      }, void 0, (0, _trans.t)('only direct routes')))), this.selectedTab() !== 'train' ? null : _jsx('div', {}, void 0, _jsx(_AutoComplete2.default, {
	        hintText: (0, _trans.t)('train number'),
	        fullWidth: true,
	        maxSearchResults: 10,
	        searchText: this.props.params.trainNumber,
	        onNewRequest: this.updateTrain.bind(this),
	        filter: this.autoCompleteFilter,
	        dataSource: this.state.trains
	      }), _jsx(_Button2.default, {
	        raised: true,
	        colored: true,
	        onClick: this.fakeSearch.bind(this)
	      }, void 0, _ref5, (0, _trans.t)('search')))), this.state.loading ? _jsx('div', {
	        style: { width: '100%', display: 'flex', justifyContent: 'center' }
	      }, void 0, _ref6) : _jsx('div', {}, void 0, trainsBefore.map(renderTrain), trainsBefore.length && trainsAfter.length ? _ref7 : null, trainsAfter.map(renderTrain)), trains.length === 0 ? _ref8 : '', _jsx(_Card.Card, {
	        className: 'footer'
	      }, void 0, _jsx('p', {
	        dangerouslySetInnerHTML: { __html: (0, _trans.t)('footer disclaimer') }
	      }, void 0), _jsx('p', {}, void 0, (0, _trans.t)('footer contact'), ' ', _ref9, '.'), _ref10, _ref11))), _jsx(_FABButton2.default, {
	        style: { position: 'fixed', bottom: '20px', right: '20px', zIndex: '10' },
	        raised: true,
	        primary: true,
	        mini: true,
	        href: 'tel:+40219521'
	      }, void 0, _ref12), _jsx(_FABButton2.default, {
	        style: { position: 'fixed', bottom: '65px', right: '20px', zIndex: '10' },
	        primary: true,
	        raised: true,
	        mini: true,
	        onMouseUp: _trans.switchLanguage
	      }, void 0, _jsx('strong', {
	        style: { color: 'white' }
	      }, void 0, _jsx('small', {}, void 0, otherLanguage))));
	    }
	  }]);
	
	  return Page;
	}(_react2.default.Component);
	
	exports.default = Page;
	
	
	Page.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(68);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(44);
	
	var _TrainRestrictions = __webpack_require__(235);
	
	var _TrainRestrictions2 = _interopRequireDefault(_TrainRestrictions);
	
	var _trans = __webpack_require__(40);
	
	var _sum = __webpack_require__(99);
	
	var _sum2 = _interopRequireDefault(_sum);
	
	var _price = __webpack_require__(239);
	
	var _Button = __webpack_require__(103);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Card = __webpack_require__(67);
	
	var _reactHighcharts = __webpack_require__(427);
	
	var _reactHighcharts2 = _interopRequireDefault(_reactHighcharts);
	
	var _lodash = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var halfPadding = { paddingLeft: '12px', paddingRight: '12px' };
	
	var _ref = _jsx('br', {});
	
	var renderLeg = function renderLeg(leg) {
	  var distance = (0, _sum2.default)(leg.segments.map(function (s) {
	    return s.distance;
	  }));
	  var price = (0, _price.legPrice)(leg);
	  var rows = [_jsx('tr', {}, void 0, _jsx('td', {
	    colSpan: 2,
	    style: { textAlign: 'center' }
	  }, void 0, _jsx('h4', {
	    style: { whiteSpace: 'pre-wrap' }
	  }, void 0, _jsx('strong', {}, void 0, leg.train.type, ' ', leg.train.number), ' ', _jsx(_TrainRestrictions2.default, {
	    train: leg.train
	  }), leg.train.operator !== 'CFR' ? _jsx('span', {}, void 0, _ref, { 'RGT': 'RegioTrans', 'TFC': 'TransFeroviar', 'SFT': 'Softrans' }[leg.train.operator]) : ''))), price ? _jsx('tr', {}, void 0, _jsx('td', {
	    colSpan: '2',
	    style: { textAlign: 'center' }
	  }, void 0, distance / 1000, ' km — ', (0, _utils.moneyFormat)(price), ' lei')) : ''];
	
	  return rows.concat(leg.segments.map(function (segment, idx) {
	    return _jsx('tr', {}, idx + ' ' + leg.train.number, _jsx('td', {
	      colSpan: 2,
	      style: halfPadding,
	      className: 'mdl-data-table__cell--non-numeric'
	    }, void 0, _jsx('div', {
	      style: { float: 'left' }
	    }, void 0, _jsx('strong', {}, void 0, segment.leavesAt), ' ', segment.from), _jsx('div', {
	      style: { float: 'right' }
	    }, void 0, segment.to, ' ', _jsx('strong', {}, void 0, segment.arrivesAt))));
	  }));
	};
	
	var renderLegs = function renderLegs(legs) {
	  return [].concat.apply([], legs.map(function (leg, idx) {
	    var legRows = renderLeg(leg);
	    if (idx < legs.length - 1) {
	      legRows.push(_jsx('tr', {}, 'waitTime ' + leg.train.number, _jsx('th', {
	        colSpan: 2,
	        className: 'mdl-data-table__cell--non-numeric',
	        style: { textAlign: 'center' }
	      }, void 0, (0, _trans.t)('wait for'), _jsx('strong', {}, void 0, ' ', _jsx(_Icon2.default, {
	        name: 'access_time',
	        style: { fontSize: '12px' }
	      }), ' ', (0, _utils.secondsToDuration)((0, _utils.timeDiff)(leg.arrivesAt, legs[idx + 1].leavesAt))), ',', ' ', (0, _trans.t)('and then'), ':')));
	    }
	
	    return legRows;
	  }));
	};
	
	var _ref4 = _jsx('br', {});
	
	var _ref5 = _jsx('br', {});
	
	var _ref6 = _jsx(_Icon2.default, {
	  name: 'error_outline'
	});
	
	var Train = function (_React$Component) {
	  _inherits(Train, _React$Component);
	
	  function Train(props) {
	    _classCallCheck(this, Train);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Train).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Train, [{
	    key: 'expand',
	    value: function expand(fetchOnly) {
	      var _this2 = this;
	
	      if (fetchOnly !== true) {
	        this.setState({ expanded: !this.state.expanded });
	      }
	
	      if (!this.state.delayDetails && this.props.firebase) {
	        this.props.firebase.ref('/delayDetails/' + this.props.train.legs[0].train.number).once('value', function (node) {
	          _this2.setState({
	            delayDetails: node.val() || undefined
	          });
	        });
	      }
	    }
	  }, {
	    key: 'renderDelays',
	    value: function renderDelays() {
	      if (!this.state.delayDetails || this.props.train.legs.length > 1) {
	        return null;
	      }
	      var runs = this.state.delayDetails.runs;
	      var stations = [];
	      (0, _lodash.map)(this.state.delayDetails.runs, function (run) {
	        if (run.length > stations.length) {
	          stations = run.map(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 1);
	
	            var k = _ref3[0];
	            return k;
	          });
	        }
	      });
	
	      var series = [];
	      var run = void 0;
	
	      var idx = 0;
	
	      for (var date in runs) {
	        run = runs[date];
	        series.push({
	          type: 'line',
	          name: date,
	          marker: {
	            enabled: false
	          },
	          data: run,
	          color: '#444',
	          lineWidth: 1
	        });
	
	        idx++;
	      }
	
	      var config = {
	        title: { text: (0, _trans.t)('Delays last month') },
	        series: series,
	        xAxis: {
	          categories: stations
	        },
	        yAxis: {
	          labels: {
	            format: '{value} min'
	          },
	          title: {
	            text: (0, _trans.t)('delay')
	          }
	        },
	        legend: {
	          enabled: false
	        }
	      };
	      return _jsx(_reactHighcharts2.default, {
	        config: config
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var train = _props.train;
	      var showStations = _props.showStations;
	      var isFastest = _props.isFastest;
	      var forceOpen = _props.forceOpen;
	
	      if (forceOpen) {
	        setTimeout(function () {
	          _this3.expand(true); // force fetching from firebase
	        }, 50);
	      }
	      var duration = void 0;
	
	      if (typeof train.legs !== 'undefined') {
	        duration = (0, _utils.secondsToDuration)((0, _utils.timeDiff)(train.legs[0].leavesAt, train.legs[train.legs.length - 1].arrivesAt));
	      } else {
	        duration = (0, _utils.secondsToDuration)((0, _utils.timeDiff)(train.leavesAt, train.arrivesAt));
	      }
	      var price = (0, _price.routePrice)(train);
	      var dom = _jsx(_Card.Card, {
	        style: { marginTop: '1px', width: '100%' },
	        shadow: 0,
	        className: 'Train ' + (forceOpen ? '' : 'expandable')
	      }, void 0, _jsx(_Card.CardTitle, {
	        style: { backgroundColor: isFastest ? '#eee' : 'white' },
	        onClick: this.expand.bind(this)
	      }, void 0, _jsx('span', {}, void 0, _jsx('strong', {}, void 0, _jsx(_Icon2.default, {
	        name: train.legs[0].train.type === 'R' ? 'train' : 'flash_on',
	        style: { fontSize: '13px' }
	      }), train.legs.map(function (leg) {
	        return leg.train.type + ' ' + leg.train.number;
	      }).join(' + ')), ' ', (0, _trans.t)('time from'), _jsx('strong', {}, void 0, ' ', train.leavesAt), ' ', (0, _trans.t)('time to'), _jsx('strong', {}, void 0, ' ', train.arrivesAt), price ? _jsx('span', {}, void 0, ', ', (0, _trans.t)('costs'), ' ', (0, _utils.moneyFormat)(price), ' ', (0, _trans.t)('lei')) : '', _ref4, isFastest ? _jsx(_Icon2.default, {
	        name: 'stars',
	        style: { fontSize: '12px' }
	      }) : '', showStations ? _jsx('span', {}, void 0, (0, _trans.t)('time from'), ' ', train.from, ' ', (0, _trans.t)('time to'), ' ', train.to, _ref5) : '', _jsx('small', {}, void 0, _jsx('strong', {}, void 0, duration), train.legs.length > 1 ? _jsx('span', {}, void 0, ' via ', train.legs.slice(0, -1).map(function (leg) {
	        return leg.to;
	      }).join(', ')) : '', isFastest ? _jsx('span', {}, void 0, ' — ', (0, _trans.t)('fastest'), '!') : '')), forceOpen ? null : _jsx('div', {
	        style: { position: 'absolute', right: '20px' }
	      }, void 0, _jsx(_Icon2.default, {
	        name: this.state.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
	      }))), !this.state.expanded && !forceOpen ? null : _jsx(_Card.CardText, {
	        style: { width: 'auto' }
	      }, void 0, _jsx('table', {
	        style: { width: '100%' },
	        className: 'mdl-data-table mdl-js-data-table'
	      }, void 0, _jsx('tbody', {}, void 0, renderLegs(train.legs))), this.renderDelays()), !this.state.expanded && !forceOpen ? null : _jsx(_Card.CardActions, {}, void 0, _jsx('a', {
	        href: 'mailto:gabi@purcaru.com?subject=Acceleratul - Eroare tren ' + train.legs.map(function (leg) {
	          return leg.train.type + leg.train.number;
	        }).join(', ')
	      }, void 0, _jsx(_Button2.default, {
	        raised: true,
	        accent: true
	      }, void 0, _ref6, (0, _trans.t)('report error')))));
	
	      return dom;
	    }
	  }]);
	
	  return Train;
	}(_react2.default.Component);
	
	exports.default = Train;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(236);
	
	var _utils = __webpack_require__(44);
	
	var _trans = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var showRestriction = function showRestriction(restriction) {
	  // TODO: handle holidays
	
	  var weekdaysMap = 62;
	  var weekendsMap = 65;
	  var dailyMap = 127;
	  var daysMap = restriction.daysOfWeek & dailyMap;
	
	  var weekdays = daysMap === weekdaysMap;
	  var weekends = daysMap === weekendsMap;
	  var daily = daysMap === dailyMap;
	
	  var weeklySchedule = void 0;
	
	  if (daily) {
	    weeklySchedule = null;
	  } else if (weekdays) {
	    weeklySchedule = _jsx('span', {}, void 0, (0, _trans.t)('weekdays'));
	  } else if (weekends) {
	    weeklySchedule = _jsx('span', {}, void 0, (0, _trans.t)('weekends'));
	  } else {
	    var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
	    weeklySchedule = _jsx('span', {}, void 0, days.filter(function (day, idx) {
	      return 1 << idx & restriction.daysOfWeek;
	    }).map(_trans.t).join(', '));
	  }
	
	  var yearlySchedule = void 0;
	  if (restriction.from === _config.startDate && restriction.to === _config.endDate) {
	    yearlySchedule = null;
	  } else {
	    yearlySchedule = _jsx('span', {}, void 0, (0, _trans.t)('just from'), ' ', (0, _utils.dateStringToFriendly)(restriction.from), ' ', (0, _trans.t)('just to'), ' ', (0, _utils.dateStringToFriendly)(restriction.to));
	  }
	
	  if (!weeklySchedule && !yearlySchedule) {
	    return null;
	  }
	
	  return _jsx('span', {}, void 0, weeklySchedule, ' ', yearlySchedule);
	};
	
	exports.default = function (_ref) {
	  var train = _ref.train;
	
	  if (train.restrictions.length === 0) {
	    return null;
	  }
	
	  var restrictionsDom = train.restrictions.map(showRestriction).filter(function (r) {
	    return !!r;
	  });
	
	  if (restrictionsDom.length === 0) {
	    return null;
	  }
	
	  return _jsx('span', {}, void 0, '—', ' ', restrictionsDom.map(function (restrictionDom, idx, allRestrictions) {
	    return _jsx('span', {}, idx, restrictionDom, idx !== allRestrictions.length - 1 ? ' / ' : null);
	  }), ' ', (0, _trans.t)('only'));
	};

/***/ },
/* 236 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var startDate = exports.startDate = '20151213';
	var endDate = exports.endDate = '20161210';

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.findTrain = findTrain;
	exports.findRoute = findRoute;
	exports.findRouteFrom = findRouteFrom;
	exports.findRouteTo = findRouteTo;
	exports.getStations = getStations;
	exports.getTrains = getTrains;
	
	var _trains = __webpack_require__(296);
	
	var _trains2 = _interopRequireDefault(_trains);
	
	var _utils = __webpack_require__(44);
	
	var _intersection = __webpack_require__(399);
	
	var _intersection2 = _interopRequireDefault(_intersection);
	
	var _zip = __webpack_require__(401);
	
	var _zip2 = _interopRequireDefault(_zip);
	
	var _sum = __webpack_require__(99);
	
	var _sum2 = _interopRequireDefault(_sum);
	
	var _keys = __webpack_require__(186);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routeCache = {};
	var trainCache = {};
	
	var restrictionsCompatible = function restrictionsCompatible(route) {
	  if (route.legs.length !== 2) {
	    return true;
	  }
	  if (route.legs[0].train.restrictions.length === 1 && route.legs[1].train.restrictions.length === 1) {
	    var left = route.legs[0].train.restrictions[0];
	    var right = route.legs[1].train.restrictions[0];
	
	    if (left.from === right.from && left.to === right.to) {
	      var leftWeekbits = left.daysOfWeek & 127;
	      var rightWeekbits = right.daysOfWeek & 127;
	      return leftWeekbits & rightWeekbits !== 0;
	    } else {
	      // TODO: make it more robust
	      return true;
	    }
	  }
	
	  // TODO: make it more robust
	  return true;
	};
	
	function findTrain(train) {
	  if (typeof trainCache[train] !== 'undefined') {
	    return trainCache[train];
	  }
	
	  return _trains2.default.filter(function (currentTrain) {
	    return currentTrain.type + ' ' + currentTrain.number === train;
	  }).map(function (currentTrain) {
	    return {
	      from: currentTrain.segments[0].from,
	      to: currentTrain.segments[currentTrain.segments.length - 1].to,
	      leavesAt: currentTrain.segments[0].leavesAt,
	      arrivesAt: currentTrain.segments[currentTrain.segments.length - 1].arrivesAt,
	      legs: [{
	        train: currentTrain,
	        from: currentTrain.segments[0].from,
	        to: currentTrain.segments[currentTrain.segments.length - 1].to,
	        leavesAt: currentTrain.segments[0].leavesAt,
	        arrivesAt: currentTrain.segments[currentTrain.segments.length - 1].arrivesAt,
	        segments: currentTrain.segments
	      }]
	    };
	  });
	}
	
	function findRoute(from, to) {
	  if (typeof routeCache[from] !== 'undefined' && typeof routeCache[from][to] !== 'undefined') {
	    return routeCache[from][to];
	  }
	
	  var routes = [];
	  var intermediaryStationsFrom = {};
	  var intermediaryStationsTo = {};
	
	  _trains2.default.map(function (train) {
	    var hasSourceAt = -1;
	    var hasDestinationAt = -1;
	    train.segments.map(function (segment, idx) {
	      if (segment.from === from) {
	        hasSourceAt = idx;
	      } else if (segment.to === to) {
	        hasDestinationAt = idx;
	      }
	    });
	
	    if (hasSourceAt !== -1 && hasDestinationAt === -1) {
	      train.segments.slice(hasSourceAt).map(function (segment, idx) {
	        if (typeof intermediaryStationsFrom[segment.to] === 'undefined') {
	          intermediaryStationsFrom[segment.to] = [];
	        }
	        intermediaryStationsFrom[segment.to].push({
	          train: train,
	          from: from,
	          to: segment.to,
	          leavesAt: train.segments[hasSourceAt].leavesAt,
	          arrivesAt: train.segments[hasSourceAt + idx].arrivesAt,
	          segments: train.segments.slice(hasSourceAt, hasSourceAt + 1 + idx)
	        });
	      });
	    } else if (hasDestinationAt !== -1 && hasSourceAt === -1) {
	      train.segments.slice(0, hasDestinationAt).map(function (segment, idx) {
	        if (typeof intermediaryStationsTo[segment.from] === 'undefined') {
	          intermediaryStationsTo[segment.from] = [];
	        }
	        intermediaryStationsTo[segment.from].push({
	          train: train,
	          from: segment.from,
	          to: to,
	          leavesAt: train.segments[idx].leavesAt,
	          arrivesAt: train.segments[hasDestinationAt].arrivesAt,
	          segments: train.segments.slice(idx, hasDestinationAt + 1)
	        });
	      });
	    }
	
	    if (hasSourceAt !== -1 && hasDestinationAt !== -1 && hasSourceAt < hasDestinationAt) {
	      routes.push({
	        from: from,
	        to: to,
	        leavesAt: train.segments[hasSourceAt].leavesAt,
	        arrivesAt: train.segments[hasDestinationAt].arrivesAt,
	        legs: [{
	          train: train,
	          from: from,
	          to: to,
	          leavesAt: train.segments[hasSourceAt].leavesAt,
	          arrivesAt: train.segments[hasDestinationAt].arrivesAt,
	          segments: train.segments.slice(hasSourceAt, hasDestinationAt + 1)
	        }]
	      });
	    }
	  });
	
	  var last = function last(arr) {
	    return arr[arr.length - 1];
	  };
	  (0, _intersection2.default)((0, _keys2.default)(intermediaryStationsFrom), (0, _keys2.default)(intermediaryStationsTo)).map(function (intermediaryStation) {
	    intermediaryStationsFrom[intermediaryStation].map(function (firstLeg) {
	      intermediaryStationsTo[intermediaryStation].map(function (secondLeg) {
	        var timeWaiting = (0, _utils.timeDiff)(last(firstLeg.segments).arrivesAt, secondLeg.segments[0].leavesAt);
	        if (timeWaiting > 5 * 3600) {
	          // don't wait for more than 5h
	          return;
	        }
	
	        routes.push({
	          from: from,
	          to: to,
	          leavesAt: firstLeg.leavesAt,
	          arrivesAt: secondLeg.arrivesAt,
	          legs: [firstLeg, secondLeg]
	        });
	      });
	    });
	  });
	
	  // remove routes that are significantly slower than the fastest
	  var fastestTime = Infinity;
	  var routeTime = function routeTime(route) {
	    var actualTime = (0, _sum2.default)(route.legs.map(function (leg) {
	      return (0, _utils.timeDiff)(leg.leavesAt, leg.arrivesAt);
	    }));
	    var waitingTime = (0, _sum2.default)((0, _zip2.default)(route.legs.slice(0, -1), route.legs.slice(1)).map(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var leg = _ref2[0];
	      var nextLeg = _ref2[1];
	      return (0, _utils.timeDiff)(leg.arrivesAt, nextLeg.leavesAt);
	    }));
	    return actualTime + waitingTime;
	  };
	  routes.map(function (route) {
	    fastestTime = Math.min(fastestTime, routeTime(route));
	  });
	
	  routes = routes.filter(function (route) {
	    return routeTime(route) < fastestTime * 1.5;
	  });
	  routes = routes.filter(restrictionsCompatible);
	
	  routes.sort(function (left, right) {
	    var leaveDiff = (0, _utils.timeToSeconds)(left.leavesAt) - (0, _utils.timeToSeconds)(right.leavesAt);
	    if (!leaveDiff) {
	      return (0, _utils.timeToSeconds)(left.arrivesAt) - (0, _utils.timeToSeconds)(right.arrivesAt);
	    }
	    return leaveDiff;
	  });
	
	  if (typeof routeCache[from] === 'undefined') {
	    routeCache[from] = {};
	  }
	
	  routeCache[from][to] = routes;
	  return routes;
	}
	
	function findRouteFrom(source) {
	  var routes = [];
	  _trains2.default.map(function (train) {
	    train.segments.map(function (segment, idx) {
	      if (segment.from === source) {
	        routes.push({
	          from: source,
	          to: train.segments[train.segments.length - 1].to,
	          leavesAt: segment.leavesAt,
	          arrivesAt: train.segments[train.segments.length - 1].arrivesAt,
	          legs: [{
	            from: source,
	            to: train.segments[train.segments.length - 1].to,
	            leavesAt: segment.leavesAt,
	            arrivesAt: train.segments[train.segments.length - 1].arrivesAt,
	            train: train,
	            segments: train.segments.slice(idx)
	          }]
	        });
	      }
	    });
	  });
	
	  return routes;
	}
	
	function findRouteTo(destination) {
	  var routes = [];
	  _trains2.default.map(function (train) {
	    train.segments.map(function (segment, idx) {
	      if (segment.to === destination) {
	        routes.push({
	          from: train.segments[0].from,
	          to: destination,
	          leavesAt: train.segments[0].leavesAt,
	          arrivesAt: segment.arrivesAt,
	          legs: [{
	            from: train.segments[0].from,
	            to: destination,
	            leavesAt: train.segments[0].leavesAt,
	            arrivesAt: segment.arrivesAt,
	            train: train,
	            segments: train.segments.slice(0, idx + 1)
	          }]
	        });
	      }
	    });
	  });
	
	  return routes;
	}
	
	function getStations() {
	  var stations = {};
	  _trains2.default.map(function (train) {
	    return train.segments.map(function (segment) {
	      stations[segment.from] = (stations[segment.from] || 0) + 1;
	      stations[segment.to] = (stations[segment.to] || 0) + 1;
	    });
	  });
	
	  var stationNames = Object.keys(stations);
	  stationNames.sort(function (a, b) {
	    return stations[b] - stations[a];
	  });
	
	  return stationNames;
	}
	
	function getTrains() {
	  return _trains2.default.map(function (train) {
	    return train.type + ' ' + train.number;
	  });
	}

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	__webpack_require__(242);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(66);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Main = __webpack_require__(231);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _reactTapEventPlugin = __webpack_require__(478);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _swRegister = __webpack_require__(240);
	
	var _swRegister2 = _interopRequireDefault(_swRegister);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Needed for onTouchTap
	// http://stackoverflow.com/a/34015469/988941
	(0, _reactTapEventPlugin2.default)();
	
	// ServiceWorker
	(0, _swRegister2.default)();
	
	// Render the main component into the dom
	_reactDom2.default.render(_jsx(_Main2.default, {}), document.getElementById('app'));
	
	window.Perf = __webpack_require__(426);

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.legPrice = legPrice;
	exports.routePrice = routePrice;
	
	var _keys = __webpack_require__(186);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _find = __webpack_require__(398);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _sum = __webpack_require__(99);
	
	var _sum2 = _interopRequireDefault(_sum);
	
	var _some = __webpack_require__(400);
	
	var _some2 = _interopRequireDefault(_some);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceTableRegio = {
	  10: 3.6,
	  20: 4.1,
	  30: 4.6,
	  40: 5.5,
	  50: 7,
	  60: 7.5,
	  70: 9.4,
	  80: 10.8,
	  90: 12.3,
	  100: 13.3,
	  120: 15.7,
	  140: 18.6,
	  160: 21,
	  180: 24.4,
	  200: 25.8,
	  250: 29.7,
	  300: 35,
	  350: 40.8,
	  400: 46.2,
	  500: 55.8,
	  600: 67.4,
	  700: 79,
	  800: 90.6,
	  900: 102.2,
	  1000: 113.8
	};
	
	var priceTableInterRegio = {
	  10: 11.6,
	  20: 12.1,
	  30: 13.1,
	  40: 14.5,
	  50: 17,
	  60: 18.5,
	  70: 22.3,
	  80: 24.7,
	  90: 28.5,
	  100: 30,
	  120: 34.9,
	  140: 41,
	  160: 46,
	  180: 50.5,
	  200: 54.5,
	  250: 62,
	  300: 69,
	  350: 75.5,
	  400: 82.5,
	  500: 94.5,
	  600: 105,
	  700: 115.5,
	  800: 125,
	  900: 134,
	  1000: 138.4
	};
	
	var seatPriceRegio = 4;
	
	var multipleLegsFeeReduction = 0.095; // 9.5%
	
	var priceBuckets = (0, _keys2.default)(priceTableRegio).map(function (kms) {
	  return parseInt(kms, 10);
	});
	priceBuckets.sort(function (left, right) {
	  return left - right;
	});
	
	function legPrice(leg) {
	  if (leg.train.operator !== 'CFR') {
	    // TODO: add support for other operators
	    return null;
	  }
	  var distance = (0, _sum2.default)(leg.segments.map(function (s) {
	    return s.distance;
	  })) / 1000;
	  var priceBucket = (0, _find2.default)(function (kms) {
	    return kms > distance;
	  }, priceBuckets);
	
	  if (leg.train.type === 'R') {
	    return seatPriceRegio + priceTableRegio[priceBucket];
	  } else if (leg.train.type === 'IR') {
	    return priceTableInterRegio[priceBucket];
	  }
	  return null;
	}
	
	function routePrice(route) {
	  if ((0, _some2.default)(function (leg) {
	    return leg.train.operator !== 'CFR';
	  }, route.legs)) {
	    return null;
	  }
	  var cost = (0, _sum2.default)(route.legs.map(legPrice));
	  if (route.legs.length > 1) {
	    cost -= multipleLegsFeeReduction * (cost - (0, _sum2.default)(route.legs.map(function (leg) {
	      return leg.train.type === 'R' ? seatPriceRegio : 0;
	    })));
	  }
	  return cost;
	}

/***/ },
/* 240 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015 Google Inc. All rights reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable no-console */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = register;
	function register() {
	  if ('serviceWorker' in navigator && (
	  // See http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
	  window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname.indexOf('127.') === 0)) {
	    // Your service-worker.js *must* be located at the top-level directory relative to your site.
	    // It won't be able to control pages unless it's located at the same level or higher than them.
	    // *Don't* register service worker file in, e.g., a scripts/ sub-directory!
	    // See https://github.com/slightlyoff/ServiceWorker/issues/468
	    navigator.serviceWorker.register('/sw.js').then(function (registration) {
	      // Check to see if there's an updated version of service-worker.js with new files to cache:
	      // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-registration-update-method
	      if (typeof registration.update == 'function') {
	        registration.update();
	      }
	
	      // updatefound is fired if service-worker.js changes.
	      registration.onupdatefound = function () {
	        // The updatefound event implies that registration.installing is set; see
	        // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
	        var installingWorker = registration.installing;
	
	        installingWorker.onstatechange = function () {
	          switch (installingWorker.state) {
	            case 'installed':
	              if (navigator.serviceWorker.controller) {
	                // At this point, the old content will have been purged and the fresh content will
	                // have been added to the cache.
	                // It's the perfect time to display a "New content is available; please refresh."
	                // message in the page's interface.
	                console.log('New or updated content is available.');
	              } else {
	                // At this point, everything has been precached, but the service worker is not
	                // controlling the page. The service worker will not take control until the next
	                // reload or navigation to a page under the registered scope.
	                // It's the perfect time to display a "Content is cached for offline use." message.
	                console.log('Content is cached, and will be available for offline use the ' + 'next time the page is loaded.');
	              }
	              break;
	
	            case 'redundant':
	              console.error('The installing service worker became redundant.');
	              break;
	          }
	        };
	      };
	    }).catch(function (e) {
	      console.error('Error during service worker registration:', e);
	    });
	  }
	}
	/* eslint-enable no-console */

/***/ },
/* 241 */
/***/ function(module, exports) {

	module.exports = clamp
	
	function clamp(value, min, max) {
	  return min < max
	    ? (value < min ? min : value > max ? max : value)
	    : (value < max ? max : value > min ? min : value)
	}


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(266);
	module.exports = __webpack_require__(80).Object.assign;

/***/ },
/* 243 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(134)
	  , toLength  = __webpack_require__(263)
	  , toIndex   = __webpack_require__(262);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 246 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(243);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83)
	  , document = __webpack_require__(45).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 249 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(45)
	  , core      = __webpack_require__(80)
	  , hide      = __webpack_require__(131)
	  , redefine  = __webpack_require__(259)
	  , ctx       = __webpack_require__(247)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(81) && !__webpack_require__(82)(function(){
	  return Object.defineProperty(__webpack_require__(248)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(256)
	  , gOPS     = __webpack_require__(254)
	  , pIE      = __webpack_require__(257)
	  , toObject = __webpack_require__(264)
	  , IObject  = __webpack_require__(132)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(82)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(244)
	  , IE8_DOM_DEFINE = __webpack_require__(251)
	  , toPrimitive    = __webpack_require__(265)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(81) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 254 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(130)
	  , toIObject    = __webpack_require__(134)
	  , arrayIndexOf = __webpack_require__(245)(false)
	  , IE_PROTO     = __webpack_require__(260)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(255)
	  , enumBugKeys = __webpack_require__(249);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 257 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(45)
	  , hide      = __webpack_require__(131)
	  , has       = __webpack_require__(130)
	  , SRC       = __webpack_require__(135)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(80).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(261)('keys')
	  , uid    = __webpack_require__(135);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(45)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(133)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(133)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(129);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(83);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(250);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(252)});

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(136)();
	// imports
	
	
	// module
	exports.push([module.id, "body{margin:0;background-image:url(/images/tile.png)}.main-container{max-width:740px;display:block;margin:0 auto}@-webkit-keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.fade-enter.fade-enter-active{-webkit-animation-name:slideInLeft;animation-name:slideInLeft;animation-duration:.5s}.footer{margin-top:70px;margin-left:auto;margin-right:auto;text-align:center;font-size:.8em;background:none!important;padding-left:10px;padding-right:10px}.footer:before{content:\"\\274B\"}.AutoComplete-full-width,.AutoComplete-full-width .mdl-textfield{width:100%}.AutoComplete-full-width .mdl-list{margin:0;padding:0}.AutoComplete-full-width .mdl-list__item:hover{background:#ccc;cursor:pointer}.AutoComplete-full-width .mdl-card{width:100%;margin-top:-20px;margin-bottom:10px;min-height:0}.Tabs-full-width .mdl-tabs__tab{width:100%}.Train.mdl-card{min-height:0}.Train.expandable .mdl-card__title{cursor:pointer}.Train .mdl-card__supporting-text,.Train .mdl-card__title,.Train .mdl-data-table th{color:rgba(0,0,0,.87)}@media (min-width:740px){.Page-content{width:740px}}@media (max-width:740px){.Page-content{width:100%}.mdl-layout__header-row{padding:0 16px 0 10px}}.Page-content{margin-left:auto;margin-right:auto;overflow:visible}", ""]);
	
	// exports


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(136)();
	// imports
	
	
	// module
	exports.push([module.id, "html{color:rgba(0,0,0,.87)}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}.hidden{display:none!important}.visuallyhidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.visuallyhidden.focusable:active,.visuallyhidden.focusable:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}.invisible{visibility:hidden}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}@media print{*,:after,:before,:first-letter{background:transparent!important;color:#000!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href)\")\"}abbr[title]:after{content:\" (\" attr(title)\")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}.mdl-accordion,.mdl-button,.mdl-card,.mdl-checkbox,.mdl-dropdown-menu,.mdl-icon-toggle,.mdl-item,.mdl-radio,.mdl-slider,.mdl-switch,.mdl-tabs__tab,a{-webkit-tap-highlight-color:transparent;-webkit-tap-highlight-color:rgba(255,255,255,0)}html{height:100%;-ms-touch-action:manipulation;touch-action:manipulation}body,html{width:100%}body{min-height:100%;margin:0}main{display:block}[hidden]{display:none!important}body,html{font-family:Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;line-height:20px}h1,h2,h3,h4,h5,h6,p{padding:0}h1 small,h2 small,h3 small,h4 small,h5 small,h6 small{font-family:Roboto,Helvetica,Arial,sans-serif;font-weight:400;line-height:1.35;letter-spacing:-.02em;opacity:.54;font-size:.6em}h1{font-size:56px;line-height:1.35;letter-spacing:-.02em;margin:24px 0}h1,h2{font-family:Roboto,Helvetica,Arial,sans-serif;font-weight:400}h2{font-size:45px;line-height:48px}h2,h3{margin:24px 0}h3{font-size:34px;line-height:40px}h3,h4{font-family:Roboto,Helvetica,Arial,sans-serif;font-weight:400}h4{font-size:24px;line-height:32px;-moz-osx-font-smoothing:grayscale;margin:24px 0 16px}h5{font-size:20px;font-weight:500;line-height:1;letter-spacing:.02em}h5,h6{font-family:Roboto,Helvetica,Arial,sans-serif;margin:24px 0 16px}h6{font-size:16px;letter-spacing:.04em}h6,p{font-weight:400;line-height:24px}p{font-size:14px;letter-spacing:0;margin:0 0 16px}a{color:#ff4081;font-weight:500}blockquote{font-family:Roboto,Helvetica,Arial,sans-serif;position:relative;font-size:24px;font-weight:300;font-style:italic;line-height:1.35;letter-spacing:.08em}blockquote:before{position:absolute;left:-.5em;content:'\\201C'}blockquote:after{content:'\\201D';margin-left:-.05em}mark{background-color:#f4ff81}dt{font-weight:700}address{font-size:12px;line-height:1;font-style:normal}address,ol,ul{font-weight:400;letter-spacing:0}ol,ul{font-size:14px;line-height:24px}.mdl-typography--display-4,.mdl-typography--display-4-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:112px;font-weight:300;line-height:1;letter-spacing:-.04em}.mdl-typography--display-4-color-contrast{opacity:.54}.mdl-typography--display-3,.mdl-typography--display-3-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:56px;font-weight:400;line-height:1.35;letter-spacing:-.02em}.mdl-typography--display-3-color-contrast{opacity:.54}.mdl-typography--display-2,.mdl-typography--display-2-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:45px;font-weight:400;line-height:48px}.mdl-typography--display-2-color-contrast{opacity:.54}.mdl-typography--display-1,.mdl-typography--display-1-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:34px;font-weight:400;line-height:40px}.mdl-typography--display-1-color-contrast{opacity:.54}.mdl-typography--headline,.mdl-typography--headline-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:24px;font-weight:400;line-height:32px;-moz-osx-font-smoothing:grayscale}.mdl-typography--headline-color-contrast{opacity:.87}.mdl-typography--title,.mdl-typography--title-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:20px;font-weight:500;line-height:1;letter-spacing:.02em}.mdl-typography--title-color-contrast{opacity:.87}.mdl-typography--subhead,.mdl-typography--subhead-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px;letter-spacing:.04em}.mdl-typography--subhead-color-contrast{opacity:.87}.mdl-typography--body-2,.mdl-typography--body-2-color-contrast{font-size:14px;font-weight:700;line-height:24px;letter-spacing:0}.mdl-typography--body-2-color-contrast{opacity:.87}.mdl-typography--body-1,.mdl-typography--body-1-color-contrast{font-size:14px;font-weight:400;line-height:24px;letter-spacing:0}.mdl-typography--body-1-color-contrast{opacity:.87}.mdl-typography--body-2-force-preferred-font,.mdl-typography--body-2-force-preferred-font-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;line-height:24px;letter-spacing:0}.mdl-typography--body-2-force-preferred-font-color-contrast{opacity:.87}.mdl-typography--body-1-force-preferred-font,.mdl-typography--body-1-force-preferred-font-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;line-height:24px;letter-spacing:0}.mdl-typography--body-1-force-preferred-font-color-contrast{opacity:.87}.mdl-typography--caption,.mdl-typography--caption-force-preferred-font{font-size:12px;font-weight:400;line-height:1;letter-spacing:0}.mdl-typography--caption-force-preferred-font{font-family:Roboto,Helvetica,Arial,sans-serif}.mdl-typography--caption-color-contrast,.mdl-typography--caption-force-preferred-font-color-contrast{font-size:12px;font-weight:400;line-height:1;letter-spacing:0;opacity:.54}.mdl-typography--caption-force-preferred-font-color-contrast,.mdl-typography--menu{font-family:Roboto,Helvetica,Arial,sans-serif}.mdl-typography--menu{font-size:14px;font-weight:500;line-height:1;letter-spacing:0}.mdl-typography--menu-color-contrast{opacity:.87}.mdl-typography--button,.mdl-typography--button-color-contrast,.mdl-typography--menu-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;line-height:1;letter-spacing:0}.mdl-typography--button,.mdl-typography--button-color-contrast{text-transform:uppercase}.mdl-typography--button-color-contrast{opacity:.87}.mdl-typography--text-left{text-align:left}.mdl-typography--text-right{text-align:right}.mdl-typography--text-center{text-align:center}.mdl-typography--text-justify{text-align:justify}.mdl-typography--text-nowrap{white-space:nowrap}.mdl-typography--text-lowercase{text-transform:lowercase}.mdl-typography--text-uppercase{text-transform:uppercase}.mdl-typography--text-capitalize{text-transform:capitalize}.mdl-typography--font-thin{font-weight:200!important}.mdl-typography--font-light{font-weight:300!important}.mdl-typography--font-regular{font-weight:400!important}.mdl-typography--font-medium{font-weight:500!important}.mdl-typography--font-bold{font-weight:700!important}.mdl-typography--font-black{font-weight:900!important}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;word-wrap:normal;font-feature-settings:'liga';-webkit-font-feature-settings:'liga';-webkit-font-smoothing:antialiased}.mdl-color-text--red{color:#f44336!important}.mdl-color--red{background-color:#f44336!important}.mdl-color-text--red-50{color:#ffebee!important}.mdl-color--red-50{background-color:#ffebee!important}.mdl-color-text--red-100{color:#ffcdd2!important}.mdl-color--red-100{background-color:#ffcdd2!important}.mdl-color-text--red-200{color:#ef9a9a!important}.mdl-color--red-200{background-color:#ef9a9a!important}.mdl-color-text--red-300{color:#e57373!important}.mdl-color--red-300{background-color:#e57373!important}.mdl-color-text--red-400{color:#ef5350!important}.mdl-color--red-400{background-color:#ef5350!important}.mdl-color-text--red-500{color:#f44336!important}.mdl-color--red-500{background-color:#f44336!important}.mdl-color-text--red-600{color:#e53935!important}.mdl-color--red-600{background-color:#e53935!important}.mdl-color-text--red-700{color:#d32f2f!important}.mdl-color--red-700{background-color:#d32f2f!important}.mdl-color-text--red-800{color:#c62828!important}.mdl-color--red-800{background-color:#c62828!important}.mdl-color-text--red-900{color:#b71c1c!important}.mdl-color--red-900{background-color:#b71c1c!important}.mdl-color-text--red-A100{color:#ff8a80!important}.mdl-color--red-A100{background-color:#ff8a80!important}.mdl-color-text--red-A200{color:#ff5252!important}.mdl-color--red-A200{background-color:#ff5252!important}.mdl-color-text--red-A400{color:#ff1744!important}.mdl-color--red-A400{background-color:#ff1744!important}.mdl-color-text--red-A700{color:#d50000!important}.mdl-color--red-A700{background-color:#d50000!important}.mdl-color-text--pink{color:#e91e63!important}.mdl-color--pink{background-color:#e91e63!important}.mdl-color-text--pink-50{color:#fce4ec!important}.mdl-color--pink-50{background-color:#fce4ec!important}.mdl-color-text--pink-100{color:#f8bbd0!important}.mdl-color--pink-100{background-color:#f8bbd0!important}.mdl-color-text--pink-200{color:#f48fb1!important}.mdl-color--pink-200{background-color:#f48fb1!important}.mdl-color-text--pink-300{color:#f06292!important}.mdl-color--pink-300{background-color:#f06292!important}.mdl-color-text--pink-400{color:#ec407a!important}.mdl-color--pink-400{background-color:#ec407a!important}.mdl-color-text--pink-500{color:#e91e63!important}.mdl-color--pink-500{background-color:#e91e63!important}.mdl-color-text--pink-600{color:#d81b60!important}.mdl-color--pink-600{background-color:#d81b60!important}.mdl-color-text--pink-700{color:#c2185b!important}.mdl-color--pink-700{background-color:#c2185b!important}.mdl-color-text--pink-800{color:#ad1457!important}.mdl-color--pink-800{background-color:#ad1457!important}.mdl-color-text--pink-900{color:#880e4f!important}.mdl-color--pink-900{background-color:#880e4f!important}.mdl-color-text--pink-A100{color:#ff80ab!important}.mdl-color--pink-A100{background-color:#ff80ab!important}.mdl-color-text--pink-A200{color:#ff4081!important}.mdl-color--pink-A200{background-color:#ff4081!important}.mdl-color-text--pink-A400{color:#f50057!important}.mdl-color--pink-A400{background-color:#f50057!important}.mdl-color-text--pink-A700{color:#c51162!important}.mdl-color--pink-A700{background-color:#c51162!important}.mdl-color-text--purple{color:#9c27b0!important}.mdl-color--purple{background-color:#9c27b0!important}.mdl-color-text--purple-50{color:#f3e5f5!important}.mdl-color--purple-50{background-color:#f3e5f5!important}.mdl-color-text--purple-100{color:#e1bee7!important}.mdl-color--purple-100{background-color:#e1bee7!important}.mdl-color-text--purple-200{color:#ce93d8!important}.mdl-color--purple-200{background-color:#ce93d8!important}.mdl-color-text--purple-300{color:#ba68c8!important}.mdl-color--purple-300{background-color:#ba68c8!important}.mdl-color-text--purple-400{color:#ab47bc!important}.mdl-color--purple-400{background-color:#ab47bc!important}.mdl-color-text--purple-500{color:#9c27b0!important}.mdl-color--purple-500{background-color:#9c27b0!important}.mdl-color-text--purple-600{color:#8e24aa!important}.mdl-color--purple-600{background-color:#8e24aa!important}.mdl-color-text--purple-700{color:#7b1fa2!important}.mdl-color--purple-700{background-color:#7b1fa2!important}.mdl-color-text--purple-800{color:#6a1b9a!important}.mdl-color--purple-800{background-color:#6a1b9a!important}.mdl-color-text--purple-900{color:#4a148c!important}.mdl-color--purple-900{background-color:#4a148c!important}.mdl-color-text--purple-A100{color:#ea80fc!important}.mdl-color--purple-A100{background-color:#ea80fc!important}.mdl-color-text--purple-A200{color:#e040fb!important}.mdl-color--purple-A200{background-color:#e040fb!important}.mdl-color-text--purple-A400{color:#d500f9!important}.mdl-color--purple-A400{background-color:#d500f9!important}.mdl-color-text--purple-A700{color:#a0f!important}.mdl-color--purple-A700{background-color:#a0f!important}.mdl-color-text--deep-purple{color:#673ab7!important}.mdl-color--deep-purple{background-color:#673ab7!important}.mdl-color-text--deep-purple-50{color:#ede7f6!important}.mdl-color--deep-purple-50{background-color:#ede7f6!important}.mdl-color-text--deep-purple-100{color:#d1c4e9!important}.mdl-color--deep-purple-100{background-color:#d1c4e9!important}.mdl-color-text--deep-purple-200{color:#b39ddb!important}.mdl-color--deep-purple-200{background-color:#b39ddb!important}.mdl-color-text--deep-purple-300{color:#9575cd!important}.mdl-color--deep-purple-300{background-color:#9575cd!important}.mdl-color-text--deep-purple-400{color:#7e57c2!important}.mdl-color--deep-purple-400{background-color:#7e57c2!important}.mdl-color-text--deep-purple-500{color:#673ab7!important}.mdl-color--deep-purple-500{background-color:#673ab7!important}.mdl-color-text--deep-purple-600{color:#5e35b1!important}.mdl-color--deep-purple-600{background-color:#5e35b1!important}.mdl-color-text--deep-purple-700{color:#512da8!important}.mdl-color--deep-purple-700{background-color:#512da8!important}.mdl-color-text--deep-purple-800{color:#4527a0!important}.mdl-color--deep-purple-800{background-color:#4527a0!important}.mdl-color-text--deep-purple-900{color:#311b92!important}.mdl-color--deep-purple-900{background-color:#311b92!important}.mdl-color-text--deep-purple-A100{color:#b388ff!important}.mdl-color--deep-purple-A100{background-color:#b388ff!important}.mdl-color-text--deep-purple-A200{color:#7c4dff!important}.mdl-color--deep-purple-A200{background-color:#7c4dff!important}.mdl-color-text--deep-purple-A400{color:#651fff!important}.mdl-color--deep-purple-A400{background-color:#651fff!important}.mdl-color-text--deep-purple-A700{color:#6200ea!important}.mdl-color--deep-purple-A700{background-color:#6200ea!important}.mdl-color-text--indigo{color:#3f51b5!important}.mdl-color--indigo{background-color:#3f51b5!important}.mdl-color-text--indigo-50{color:#e8eaf6!important}.mdl-color--indigo-50{background-color:#e8eaf6!important}.mdl-color-text--indigo-100{color:#c5cae9!important}.mdl-color--indigo-100{background-color:#c5cae9!important}.mdl-color-text--indigo-200{color:#9fa8da!important}.mdl-color--indigo-200{background-color:#9fa8da!important}.mdl-color-text--indigo-300{color:#7986cb!important}.mdl-color--indigo-300{background-color:#7986cb!important}.mdl-color-text--indigo-400{color:#5c6bc0!important}.mdl-color--indigo-400{background-color:#5c6bc0!important}.mdl-color-text--indigo-500{color:#3f51b5!important}.mdl-color--indigo-500{background-color:#3f51b5!important}.mdl-color-text--indigo-600{color:#3949ab!important}.mdl-color--indigo-600{background-color:#3949ab!important}.mdl-color-text--indigo-700{color:#303f9f!important}.mdl-color--indigo-700{background-color:#303f9f!important}.mdl-color-text--indigo-800{color:#283593!important}.mdl-color--indigo-800{background-color:#283593!important}.mdl-color-text--indigo-900{color:#1a237e!important}.mdl-color--indigo-900{background-color:#1a237e!important}.mdl-color-text--indigo-A100{color:#8c9eff!important}.mdl-color--indigo-A100{background-color:#8c9eff!important}.mdl-color-text--indigo-A200{color:#536dfe!important}.mdl-color--indigo-A200{background-color:#536dfe!important}.mdl-color-text--indigo-A400{color:#3d5afe!important}.mdl-color--indigo-A400{background-color:#3d5afe!important}.mdl-color-text--indigo-A700{color:#304ffe!important}.mdl-color--indigo-A700{background-color:#304ffe!important}.mdl-color-text--blue{color:#2196f3!important}.mdl-color--blue{background-color:#2196f3!important}.mdl-color-text--blue-50{color:#e3f2fd!important}.mdl-color--blue-50{background-color:#e3f2fd!important}.mdl-color-text--blue-100{color:#bbdefb!important}.mdl-color--blue-100{background-color:#bbdefb!important}.mdl-color-text--blue-200{color:#90caf9!important}.mdl-color--blue-200{background-color:#90caf9!important}.mdl-color-text--blue-300{color:#64b5f6!important}.mdl-color--blue-300{background-color:#64b5f6!important}.mdl-color-text--blue-400{color:#42a5f5!important}.mdl-color--blue-400{background-color:#42a5f5!important}.mdl-color-text--blue-500{color:#2196f3!important}.mdl-color--blue-500{background-color:#2196f3!important}.mdl-color-text--blue-600{color:#1e88e5!important}.mdl-color--blue-600{background-color:#1e88e5!important}.mdl-color-text--blue-700{color:#1976d2!important}.mdl-color--blue-700{background-color:#1976d2!important}.mdl-color-text--blue-800{color:#1565c0!important}.mdl-color--blue-800{background-color:#1565c0!important}.mdl-color-text--blue-900{color:#0d47a1!important}.mdl-color--blue-900{background-color:#0d47a1!important}.mdl-color-text--blue-A100{color:#82b1ff!important}.mdl-color--blue-A100{background-color:#82b1ff!important}.mdl-color-text--blue-A200{color:#448aff!important}.mdl-color--blue-A200{background-color:#448aff!important}.mdl-color-text--blue-A400{color:#2979ff!important}.mdl-color--blue-A400{background-color:#2979ff!important}.mdl-color-text--blue-A700{color:#2962ff!important}.mdl-color--blue-A700{background-color:#2962ff!important}.mdl-color-text--light-blue{color:#03a9f4!important}.mdl-color--light-blue{background-color:#03a9f4!important}.mdl-color-text--light-blue-50{color:#e1f5fe!important}.mdl-color--light-blue-50{background-color:#e1f5fe!important}.mdl-color-text--light-blue-100{color:#b3e5fc!important}.mdl-color--light-blue-100{background-color:#b3e5fc!important}.mdl-color-text--light-blue-200{color:#81d4fa!important}.mdl-color--light-blue-200{background-color:#81d4fa!important}.mdl-color-text--light-blue-300{color:#4fc3f7!important}.mdl-color--light-blue-300{background-color:#4fc3f7!important}.mdl-color-text--light-blue-400{color:#29b6f6!important}.mdl-color--light-blue-400{background-color:#29b6f6!important}.mdl-color-text--light-blue-500{color:#03a9f4!important}.mdl-color--light-blue-500{background-color:#03a9f4!important}.mdl-color-text--light-blue-600{color:#039be5!important}.mdl-color--light-blue-600{background-color:#039be5!important}.mdl-color-text--light-blue-700{color:#0288d1!important}.mdl-color--light-blue-700{background-color:#0288d1!important}.mdl-color-text--light-blue-800{color:#0277bd!important}.mdl-color--light-blue-800{background-color:#0277bd!important}.mdl-color-text--light-blue-900{color:#01579b!important}.mdl-color--light-blue-900{background-color:#01579b!important}.mdl-color-text--light-blue-A100{color:#80d8ff!important}.mdl-color--light-blue-A100{background-color:#80d8ff!important}.mdl-color-text--light-blue-A200{color:#40c4ff!important}.mdl-color--light-blue-A200{background-color:#40c4ff!important}.mdl-color-text--light-blue-A400{color:#00b0ff!important}.mdl-color--light-blue-A400{background-color:#00b0ff!important}.mdl-color-text--light-blue-A700{color:#0091ea!important}.mdl-color--light-blue-A700{background-color:#0091ea!important}.mdl-color-text--cyan{color:#00bcd4!important}.mdl-color--cyan{background-color:#00bcd4!important}.mdl-color-text--cyan-50{color:#e0f7fa!important}.mdl-color--cyan-50{background-color:#e0f7fa!important}.mdl-color-text--cyan-100{color:#b2ebf2!important}.mdl-color--cyan-100{background-color:#b2ebf2!important}.mdl-color-text--cyan-200{color:#80deea!important}.mdl-color--cyan-200{background-color:#80deea!important}.mdl-color-text--cyan-300{color:#4dd0e1!important}.mdl-color--cyan-300{background-color:#4dd0e1!important}.mdl-color-text--cyan-400{color:#26c6da!important}.mdl-color--cyan-400{background-color:#26c6da!important}.mdl-color-text--cyan-500{color:#00bcd4!important}.mdl-color--cyan-500{background-color:#00bcd4!important}.mdl-color-text--cyan-600{color:#00acc1!important}.mdl-color--cyan-600{background-color:#00acc1!important}.mdl-color-text--cyan-700{color:#0097a7!important}.mdl-color--cyan-700{background-color:#0097a7!important}.mdl-color-text--cyan-800{color:#00838f!important}.mdl-color--cyan-800{background-color:#00838f!important}.mdl-color-text--cyan-900{color:#006064!important}.mdl-color--cyan-900{background-color:#006064!important}.mdl-color-text--cyan-A100{color:#84ffff!important}.mdl-color--cyan-A100{background-color:#84ffff!important}.mdl-color-text--cyan-A200{color:#18ffff!important}.mdl-color--cyan-A200{background-color:#18ffff!important}.mdl-color-text--cyan-A400{color:#00e5ff!important}.mdl-color--cyan-A400{background-color:#00e5ff!important}.mdl-color-text--cyan-A700{color:#00b8d4!important}.mdl-color--cyan-A700{background-color:#00b8d4!important}.mdl-color-text--teal{color:#009688!important}.mdl-color--teal{background-color:#009688!important}.mdl-color-text--teal-50{color:#e0f2f1!important}.mdl-color--teal-50{background-color:#e0f2f1!important}.mdl-color-text--teal-100{color:#b2dfdb!important}.mdl-color--teal-100{background-color:#b2dfdb!important}.mdl-color-text--teal-200{color:#80cbc4!important}.mdl-color--teal-200{background-color:#80cbc4!important}.mdl-color-text--teal-300{color:#4db6ac!important}.mdl-color--teal-300{background-color:#4db6ac!important}.mdl-color-text--teal-400{color:#26a69a!important}.mdl-color--teal-400{background-color:#26a69a!important}.mdl-color-text--teal-500{color:#009688!important}.mdl-color--teal-500{background-color:#009688!important}.mdl-color-text--teal-600{color:#00897b!important}.mdl-color--teal-600{background-color:#00897b!important}.mdl-color-text--teal-700{color:#00796b!important}.mdl-color--teal-700{background-color:#00796b!important}.mdl-color-text--teal-800{color:#00695c!important}.mdl-color--teal-800{background-color:#00695c!important}.mdl-color-text--teal-900{color:#004d40!important}.mdl-color--teal-900{background-color:#004d40!important}.mdl-color-text--teal-A100{color:#a7ffeb!important}.mdl-color--teal-A100{background-color:#a7ffeb!important}.mdl-color-text--teal-A200{color:#64ffda!important}.mdl-color--teal-A200{background-color:#64ffda!important}.mdl-color-text--teal-A400{color:#1de9b6!important}.mdl-color--teal-A400{background-color:#1de9b6!important}.mdl-color-text--teal-A700{color:#00bfa5!important}.mdl-color--teal-A700{background-color:#00bfa5!important}.mdl-color-text--green{color:#4caf50!important}.mdl-color--green{background-color:#4caf50!important}.mdl-color-text--green-50{color:#e8f5e9!important}.mdl-color--green-50{background-color:#e8f5e9!important}.mdl-color-text--green-100{color:#c8e6c9!important}.mdl-color--green-100{background-color:#c8e6c9!important}.mdl-color-text--green-200{color:#a5d6a7!important}.mdl-color--green-200{background-color:#a5d6a7!important}.mdl-color-text--green-300{color:#81c784!important}.mdl-color--green-300{background-color:#81c784!important}.mdl-color-text--green-400{color:#66bb6a!important}.mdl-color--green-400{background-color:#66bb6a!important}.mdl-color-text--green-500{color:#4caf50!important}.mdl-color--green-500{background-color:#4caf50!important}.mdl-color-text--green-600{color:#43a047!important}.mdl-color--green-600{background-color:#43a047!important}.mdl-color-text--green-700{color:#388e3c!important}.mdl-color--green-700{background-color:#388e3c!important}.mdl-color-text--green-800{color:#2e7d32!important}.mdl-color--green-800{background-color:#2e7d32!important}.mdl-color-text--green-900{color:#1b5e20!important}.mdl-color--green-900{background-color:#1b5e20!important}.mdl-color-text--green-A100{color:#b9f6ca!important}.mdl-color--green-A100{background-color:#b9f6ca!important}.mdl-color-text--green-A200{color:#69f0ae!important}.mdl-color--green-A200{background-color:#69f0ae!important}.mdl-color-text--green-A400{color:#00e676!important}.mdl-color--green-A400{background-color:#00e676!important}.mdl-color-text--green-A700{color:#00c853!important}.mdl-color--green-A700{background-color:#00c853!important}.mdl-color-text--light-green{color:#8bc34a!important}.mdl-color--light-green{background-color:#8bc34a!important}.mdl-color-text--light-green-50{color:#f1f8e9!important}.mdl-color--light-green-50{background-color:#f1f8e9!important}.mdl-color-text--light-green-100{color:#dcedc8!important}.mdl-color--light-green-100{background-color:#dcedc8!important}.mdl-color-text--light-green-200{color:#c5e1a5!important}.mdl-color--light-green-200{background-color:#c5e1a5!important}.mdl-color-text--light-green-300{color:#aed581!important}.mdl-color--light-green-300{background-color:#aed581!important}.mdl-color-text--light-green-400{color:#9ccc65!important}.mdl-color--light-green-400{background-color:#9ccc65!important}.mdl-color-text--light-green-500{color:#8bc34a!important}.mdl-color--light-green-500{background-color:#8bc34a!important}.mdl-color-text--light-green-600{color:#7cb342!important}.mdl-color--light-green-600{background-color:#7cb342!important}.mdl-color-text--light-green-700{color:#689f38!important}.mdl-color--light-green-700{background-color:#689f38!important}.mdl-color-text--light-green-800{color:#558b2f!important}.mdl-color--light-green-800{background-color:#558b2f!important}.mdl-color-text--light-green-900{color:#33691e!important}.mdl-color--light-green-900{background-color:#33691e!important}.mdl-color-text--light-green-A100{color:#ccff90!important}.mdl-color--light-green-A100{background-color:#ccff90!important}.mdl-color-text--light-green-A200{color:#b2ff59!important}.mdl-color--light-green-A200{background-color:#b2ff59!important}.mdl-color-text--light-green-A400{color:#76ff03!important}.mdl-color--light-green-A400{background-color:#76ff03!important}.mdl-color-text--light-green-A700{color:#64dd17!important}.mdl-color--light-green-A700{background-color:#64dd17!important}.mdl-color-text--lime{color:#cddc39!important}.mdl-color--lime{background-color:#cddc39!important}.mdl-color-text--lime-50{color:#f9fbe7!important}.mdl-color--lime-50{background-color:#f9fbe7!important}.mdl-color-text--lime-100{color:#f0f4c3!important}.mdl-color--lime-100{background-color:#f0f4c3!important}.mdl-color-text--lime-200{color:#e6ee9c!important}.mdl-color--lime-200{background-color:#e6ee9c!important}.mdl-color-text--lime-300{color:#dce775!important}.mdl-color--lime-300{background-color:#dce775!important}.mdl-color-text--lime-400{color:#d4e157!important}.mdl-color--lime-400{background-color:#d4e157!important}.mdl-color-text--lime-500{color:#cddc39!important}.mdl-color--lime-500{background-color:#cddc39!important}.mdl-color-text--lime-600{color:#c0ca33!important}.mdl-color--lime-600{background-color:#c0ca33!important}.mdl-color-text--lime-700{color:#afb42b!important}.mdl-color--lime-700{background-color:#afb42b!important}.mdl-color-text--lime-800{color:#9e9d24!important}.mdl-color--lime-800{background-color:#9e9d24!important}.mdl-color-text--lime-900{color:#827717!important}.mdl-color--lime-900{background-color:#827717!important}.mdl-color-text--lime-A100{color:#f4ff81!important}.mdl-color--lime-A100{background-color:#f4ff81!important}.mdl-color-text--lime-A200{color:#eeff41!important}.mdl-color--lime-A200{background-color:#eeff41!important}.mdl-color-text--lime-A400{color:#c6ff00!important}.mdl-color--lime-A400{background-color:#c6ff00!important}.mdl-color-text--lime-A700{color:#aeea00!important}.mdl-color--lime-A700{background-color:#aeea00!important}.mdl-color-text--yellow{color:#ffeb3b!important}.mdl-color--yellow{background-color:#ffeb3b!important}.mdl-color-text--yellow-50{color:#fffde7!important}.mdl-color--yellow-50{background-color:#fffde7!important}.mdl-color-text--yellow-100{color:#fff9c4!important}.mdl-color--yellow-100{background-color:#fff9c4!important}.mdl-color-text--yellow-200{color:#fff59d!important}.mdl-color--yellow-200{background-color:#fff59d!important}.mdl-color-text--yellow-300{color:#fff176!important}.mdl-color--yellow-300{background-color:#fff176!important}.mdl-color-text--yellow-400{color:#ffee58!important}.mdl-color--yellow-400{background-color:#ffee58!important}.mdl-color-text--yellow-500{color:#ffeb3b!important}.mdl-color--yellow-500{background-color:#ffeb3b!important}.mdl-color-text--yellow-600{color:#fdd835!important}.mdl-color--yellow-600{background-color:#fdd835!important}.mdl-color-text--yellow-700{color:#fbc02d!important}.mdl-color--yellow-700{background-color:#fbc02d!important}.mdl-color-text--yellow-800{color:#f9a825!important}.mdl-color--yellow-800{background-color:#f9a825!important}.mdl-color-text--yellow-900{color:#f57f17!important}.mdl-color--yellow-900{background-color:#f57f17!important}.mdl-color-text--yellow-A100{color:#ffff8d!important}.mdl-color--yellow-A100{background-color:#ffff8d!important}.mdl-color-text--yellow-A200{color:#ff0!important}.mdl-color--yellow-A200{background-color:#ff0!important}.mdl-color-text--yellow-A400{color:#ffea00!important}.mdl-color--yellow-A400{background-color:#ffea00!important}.mdl-color-text--yellow-A700{color:#ffd600!important}.mdl-color--yellow-A700{background-color:#ffd600!important}.mdl-color-text--amber{color:#ffc107!important}.mdl-color--amber{background-color:#ffc107!important}.mdl-color-text--amber-50{color:#fff8e1!important}.mdl-color--amber-50{background-color:#fff8e1!important}.mdl-color-text--amber-100{color:#ffecb3!important}.mdl-color--amber-100{background-color:#ffecb3!important}.mdl-color-text--amber-200{color:#ffe082!important}.mdl-color--amber-200{background-color:#ffe082!important}.mdl-color-text--amber-300{color:#ffd54f!important}.mdl-color--amber-300{background-color:#ffd54f!important}.mdl-color-text--amber-400{color:#ffca28!important}.mdl-color--amber-400{background-color:#ffca28!important}.mdl-color-text--amber-500{color:#ffc107!important}.mdl-color--amber-500{background-color:#ffc107!important}.mdl-color-text--amber-600{color:#ffb300!important}.mdl-color--amber-600{background-color:#ffb300!important}.mdl-color-text--amber-700{color:#ffa000!important}.mdl-color--amber-700{background-color:#ffa000!important}.mdl-color-text--amber-800{color:#ff8f00!important}.mdl-color--amber-800{background-color:#ff8f00!important}.mdl-color-text--amber-900{color:#ff6f00!important}.mdl-color--amber-900{background-color:#ff6f00!important}.mdl-color-text--amber-A100{color:#ffe57f!important}.mdl-color--amber-A100{background-color:#ffe57f!important}.mdl-color-text--amber-A200{color:#ffd740!important}.mdl-color--amber-A200{background-color:#ffd740!important}.mdl-color-text--amber-A400{color:#ffc400!important}.mdl-color--amber-A400{background-color:#ffc400!important}.mdl-color-text--amber-A700{color:#ffab00!important}.mdl-color--amber-A700{background-color:#ffab00!important}.mdl-color-text--orange{color:#ff9800!important}.mdl-color--orange{background-color:#ff9800!important}.mdl-color-text--orange-50{color:#fff3e0!important}.mdl-color--orange-50{background-color:#fff3e0!important}.mdl-color-text--orange-100{color:#ffe0b2!important}.mdl-color--orange-100{background-color:#ffe0b2!important}.mdl-color-text--orange-200{color:#ffcc80!important}.mdl-color--orange-200{background-color:#ffcc80!important}.mdl-color-text--orange-300{color:#ffb74d!important}.mdl-color--orange-300{background-color:#ffb74d!important}.mdl-color-text--orange-400{color:#ffa726!important}.mdl-color--orange-400{background-color:#ffa726!important}.mdl-color-text--orange-500{color:#ff9800!important}.mdl-color--orange-500{background-color:#ff9800!important}.mdl-color-text--orange-600{color:#fb8c00!important}.mdl-color--orange-600{background-color:#fb8c00!important}.mdl-color-text--orange-700{color:#f57c00!important}.mdl-color--orange-700{background-color:#f57c00!important}.mdl-color-text--orange-800{color:#ef6c00!important}.mdl-color--orange-800{background-color:#ef6c00!important}.mdl-color-text--orange-900{color:#e65100!important}.mdl-color--orange-900{background-color:#e65100!important}.mdl-color-text--orange-A100{color:#ffd180!important}.mdl-color--orange-A100{background-color:#ffd180!important}.mdl-color-text--orange-A200{color:#ffab40!important}.mdl-color--orange-A200{background-color:#ffab40!important}.mdl-color-text--orange-A400{color:#ff9100!important}.mdl-color--orange-A400{background-color:#ff9100!important}.mdl-color-text--orange-A700{color:#ff6d00!important}.mdl-color--orange-A700{background-color:#ff6d00!important}.mdl-color-text--deep-orange{color:#ff5722!important}.mdl-color--deep-orange{background-color:#ff5722!important}.mdl-color-text--deep-orange-50{color:#fbe9e7!important}.mdl-color--deep-orange-50{background-color:#fbe9e7!important}.mdl-color-text--deep-orange-100{color:#ffccbc!important}.mdl-color--deep-orange-100{background-color:#ffccbc!important}.mdl-color-text--deep-orange-200{color:#ffab91!important}.mdl-color--deep-orange-200{background-color:#ffab91!important}.mdl-color-text--deep-orange-300{color:#ff8a65!important}.mdl-color--deep-orange-300{background-color:#ff8a65!important}.mdl-color-text--deep-orange-400{color:#ff7043!important}.mdl-color--deep-orange-400{background-color:#ff7043!important}.mdl-color-text--deep-orange-500{color:#ff5722!important}.mdl-color--deep-orange-500{background-color:#ff5722!important}.mdl-color-text--deep-orange-600{color:#f4511e!important}.mdl-color--deep-orange-600{background-color:#f4511e!important}.mdl-color-text--deep-orange-700{color:#e64a19!important}.mdl-color--deep-orange-700{background-color:#e64a19!important}.mdl-color-text--deep-orange-800{color:#d84315!important}.mdl-color--deep-orange-800{background-color:#d84315!important}.mdl-color-text--deep-orange-900{color:#bf360c!important}.mdl-color--deep-orange-900{background-color:#bf360c!important}.mdl-color-text--deep-orange-A100{color:#ff9e80!important}.mdl-color--deep-orange-A100{background-color:#ff9e80!important}.mdl-color-text--deep-orange-A200{color:#ff6e40!important}.mdl-color--deep-orange-A200{background-color:#ff6e40!important}.mdl-color-text--deep-orange-A400{color:#ff3d00!important}.mdl-color--deep-orange-A400{background-color:#ff3d00!important}.mdl-color-text--deep-orange-A700{color:#dd2c00!important}.mdl-color--deep-orange-A700{background-color:#dd2c00!important}.mdl-color-text--brown{color:#795548!important}.mdl-color--brown{background-color:#795548!important}.mdl-color-text--brown-50{color:#efebe9!important}.mdl-color--brown-50{background-color:#efebe9!important}.mdl-color-text--brown-100{color:#d7ccc8!important}.mdl-color--brown-100{background-color:#d7ccc8!important}.mdl-color-text--brown-200{color:#bcaaa4!important}.mdl-color--brown-200{background-color:#bcaaa4!important}.mdl-color-text--brown-300{color:#a1887f!important}.mdl-color--brown-300{background-color:#a1887f!important}.mdl-color-text--brown-400{color:#8d6e63!important}.mdl-color--brown-400{background-color:#8d6e63!important}.mdl-color-text--brown-500{color:#795548!important}.mdl-color--brown-500{background-color:#795548!important}.mdl-color-text--brown-600{color:#6d4c41!important}.mdl-color--brown-600{background-color:#6d4c41!important}.mdl-color-text--brown-700{color:#5d4037!important}.mdl-color--brown-700{background-color:#5d4037!important}.mdl-color-text--brown-800{color:#4e342e!important}.mdl-color--brown-800{background-color:#4e342e!important}.mdl-color-text--brown-900{color:#3e2723!important}.mdl-color--brown-900{background-color:#3e2723!important}.mdl-color-text--grey{color:#9e9e9e!important}.mdl-color--grey{background-color:#9e9e9e!important}.mdl-color-text--grey-50{color:#fafafa!important}.mdl-color--grey-50{background-color:#fafafa!important}.mdl-color-text--grey-100{color:#f5f5f5!important}.mdl-color--grey-100{background-color:#f5f5f5!important}.mdl-color-text--grey-200{color:#eee!important}.mdl-color--grey-200{background-color:#eee!important}.mdl-color-text--grey-300{color:#e0e0e0!important}.mdl-color--grey-300{background-color:#e0e0e0!important}.mdl-color-text--grey-400{color:#bdbdbd!important}.mdl-color--grey-400{background-color:#bdbdbd!important}.mdl-color-text--grey-500{color:#9e9e9e!important}.mdl-color--grey-500{background-color:#9e9e9e!important}.mdl-color-text--grey-600{color:#757575!important}.mdl-color--grey-600{background-color:#757575!important}.mdl-color-text--grey-700{color:#616161!important}.mdl-color--grey-700{background-color:#616161!important}.mdl-color-text--grey-800{color:#424242!important}.mdl-color--grey-800{background-color:#424242!important}.mdl-color-text--grey-900{color:#212121!important}.mdl-color--grey-900{background-color:#212121!important}.mdl-color-text--blue-grey{color:#607d8b!important}.mdl-color--blue-grey{background-color:#607d8b!important}.mdl-color-text--blue-grey-50{color:#eceff1!important}.mdl-color--blue-grey-50{background-color:#eceff1!important}.mdl-color-text--blue-grey-100{color:#cfd8dc!important}.mdl-color--blue-grey-100{background-color:#cfd8dc!important}.mdl-color-text--blue-grey-200{color:#b0bec5!important}.mdl-color--blue-grey-200{background-color:#b0bec5!important}.mdl-color-text--blue-grey-300{color:#90a4ae!important}.mdl-color--blue-grey-300{background-color:#90a4ae!important}.mdl-color-text--blue-grey-400{color:#78909c!important}.mdl-color--blue-grey-400{background-color:#78909c!important}.mdl-color-text--blue-grey-500{color:#607d8b!important}.mdl-color--blue-grey-500{background-color:#607d8b!important}.mdl-color-text--blue-grey-600{color:#546e7a!important}.mdl-color--blue-grey-600{background-color:#546e7a!important}.mdl-color-text--blue-grey-700{color:#455a64!important}.mdl-color--blue-grey-700{background-color:#455a64!important}.mdl-color-text--blue-grey-800{color:#37474f!important}.mdl-color--blue-grey-800{background-color:#37474f!important}.mdl-color-text--blue-grey-900{color:#263238!important}.mdl-color--blue-grey-900{background-color:#263238!important}.mdl-color--black{background-color:#000!important}.mdl-color-text--black{color:#000!important}.mdl-color--white{background-color:#fff!important}.mdl-color-text--white{color:#fff!important}.mdl-color--primary{background-color:#3f51b5!important}.mdl-color--primary-contrast{background-color:#fff!important}.mdl-color--primary-dark{background-color:#303f9f!important}.mdl-color--accent{background-color:#ff4081!important}.mdl-color--accent-contrast{background-color:#fff!important}.mdl-color-text--primary{color:#3f51b5!important}.mdl-color-text--primary-contrast{color:#fff!important}.mdl-color-text--primary-dark{color:#303f9f!important}.mdl-color-text--accent{color:#ff4081!important}.mdl-color-text--accent-contrast{color:#fff!important}.mdl-ripple{background:#000;border-radius:50%;height:50px;left:0;opacity:0;pointer-events:none;position:absolute;top:0;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:50px;overflow:hidden}.mdl-ripple.is-animating{transition:transform .3s cubic-bezier(0,0,.2,1),width .3s cubic-bezier(0,0,.2,1),height .3s cubic-bezier(0,0,.2,1),opacity .6s cubic-bezier(0,0,.2,1);transition:transform .3s cubic-bezier(0,0,.2,1),width .3s cubic-bezier(0,0,.2,1),height .3s cubic-bezier(0,0,.2,1),opacity .6s cubic-bezier(0,0,.2,1),-webkit-transform .3s cubic-bezier(0,0,.2,1)}.mdl-ripple.is-visible{opacity:.3}.mdl-animation--default,.mdl-animation--fast-out-slow-in{transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-animation--linear-out-slow-in{transition-timing-function:cubic-bezier(0,0,.2,1)}.mdl-animation--fast-out-linear-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.mdl-badge{position:relative;white-space:nowrap;margin-right:24px}.mdl-badge:not([data-badge]){margin-right:auto}.mdl-badge[data-badge]:after{content:attr(data-badge);display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;position:absolute;top:-11px;right:-24px;font-family:Roboto,Helvetica,Arial,sans-serif;font-weight:600;font-size:12px;width:22px;height:22px;border-radius:50%;background:#ff4081;color:#fff}.mdl-button .mdl-badge[data-badge]:after{top:-10px;right:-5px}.mdl-badge.mdl-badge--no-background[data-badge]:after{color:#ff4081;background:hsla(0,0%,100%,.2);box-shadow:0 0 1px gray}.mdl-badge.mdl-badge--overlap{margin-right:10px}.mdl-badge.mdl-badge--overlap:after{right:-10px}.mdl-button{background:0 0;border:none;border-radius:2px;color:#000;position:relative;height:36px;margin:0;min-width:64px;padding:0 16px;display:inline-block;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase;letter-spacing:0;overflow:hidden;will-change:box-shadow;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1);outline:none;cursor:pointer;text-decoration:none;text-align:center;line-height:36px;vertical-align:middle}.mdl-button::-moz-focus-inner{border:0}.mdl-button:hover{background-color:hsla(0,0%,62%,.2)}.mdl-button:focus:not(:active){background-color:rgba(0,0,0,.12)}.mdl-button:active{background-color:hsla(0,0%,62%,.4)}.mdl-button.mdl-button--colored{color:#3f51b5}.mdl-button.mdl-button--colored:focus:not(:active){background-color:rgba(0,0,0,.12)}input.mdl-button[type=submit]{-webkit-appearance:none}.mdl-button--raised{background:hsla(0,0%,62%,.2);box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-button--raised:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised.mdl-button--colored{background:#3f51b5;color:#fff}.mdl-button--raised.mdl-button--colored:active,.mdl-button--raised.mdl-button--colored:focus:not(:active),.mdl-button--raised.mdl-button--colored:hover{background-color:#3f51b5}.mdl-button--raised.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--fab{border-radius:50%;font-size:24px;height:56px;margin:auto;min-width:56px;width:56px;padding:0;overflow:hidden;background:hsla(0,0%,62%,.2);box-shadow:0 1px 1.5px 0 rgba(0,0,0,.12),0 1px 1px 0 rgba(0,0,0,.24);position:relative;line-height:normal}.mdl-button--fab .material-icons{position:absolute;top:50%;left:50%;-webkit-transform:translate(-12px,-12px);transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--fab.mdl-button--mini-fab{height:40px;min-width:40px;width:40px}.mdl-button--fab .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button--fab:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab.mdl-button--colored{background:#ff4081;color:#fff}.mdl-button--fab.mdl-button--colored:active,.mdl-button--fab.mdl-button--colored:focus:not(:active),.mdl-button--fab.mdl-button--colored:hover{background-color:#ff4081}.mdl-button--fab.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--icon{border-radius:50%;font-size:24px;height:32px;margin-left:0;margin-right:0;min-width:32px;width:32px;padding:0;overflow:hidden;color:inherit;line-height:normal}.mdl-button--icon .material-icons{position:absolute;top:50%;left:50%;-webkit-transform:translate(-12px,-12px);transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon{height:24px;min-width:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon .material-icons{top:0;left:0}.mdl-button--icon .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button__ripple-container{display:block;height:100%;left:0;position:absolute;top:0;width:100%;z-index:0;overflow:hidden}.mdl-button.mdl-button--disabled .mdl-button__ripple-container .mdl-ripple,.mdl-button[disabled] .mdl-button__ripple-container .mdl-ripple{background-color:transparent}.mdl-button--primary.mdl-button--primary{color:#3f51b5}.mdl-button--primary.mdl-button--primary .mdl-ripple{background:#fff}.mdl-button--primary.mdl-button--primary.mdl-button--fab,.mdl-button--primary.mdl-button--primary.mdl-button--raised{color:#fff;background-color:#3f51b5}.mdl-button--accent.mdl-button--accent{color:#ff4081}.mdl-button--accent.mdl-button--accent .mdl-ripple{background:#fff}.mdl-button--accent.mdl-button--accent.mdl-button--fab,.mdl-button--accent.mdl-button--accent.mdl-button--raised{color:#fff;background-color:#ff4081}.mdl-button.mdl-button--disabled.mdl-button--disabled,.mdl-button[disabled][disabled]{color:rgba(0,0,0,.26);cursor:default;background-color:transparent}.mdl-button--fab.mdl-button--disabled.mdl-button--disabled,.mdl-button--fab[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-button--raised.mdl-button--disabled.mdl-button--disabled,.mdl-button--raised[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26);box-shadow:none}.mdl-button--colored.mdl-button--disabled.mdl-button--disabled,.mdl-button--colored[disabled][disabled]{color:rgba(0,0,0,.26)}.mdl-button .material-icons{vertical-align:middle}.mdl-card{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;font-size:16px;font-weight:400;min-height:200px;overflow:hidden;width:330px;z-index:1;position:relative;background:#fff;border-radius:2px;box-sizing:border-box}.mdl-card__media{background-color:#ff4081;background-repeat:repeat;background-position:50% 50%;background-size:cover;background-origin:padding-box;background-attachment:scroll;box-sizing:border-box}.mdl-card__title{-ms-flex-align:center;align-items:center;color:#000;display:block;display:-ms-flexbox;display:flex;-ms-flex-pack:stretch;justify-content:stretch;line-height:normal;padding:16px;-webkit-perspective-origin:165px 56px;perspective-origin:165px 56px;-webkit-transform-origin:165px 56px;transform-origin:165px 56px;box-sizing:border-box}.mdl-card__title.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__title-text{-ms-flex-item-align:end;align-self:flex-end;color:inherit;display:block;display:-ms-flexbox;display:flex;font-size:24px;font-weight:300;line-height:normal;overflow:hidden;-webkit-transform-origin:149px 48px;transform-origin:149px 48px;margin:0}.mdl-card__subtitle-text{font-size:14px;color:rgba(0,0,0,.54);margin:0}.mdl-card__supporting-text{color:rgba(0,0,0,.54);font-size:1rem;line-height:18px;overflow:hidden;padding:16px;width:90%}.mdl-card__actions{font-size:16px;line-height:normal;width:100%;background-color:transparent;padding:8px;box-sizing:border-box}.mdl-card__actions.mdl-card--border{border-top:1px solid rgba(0,0,0,.1)}.mdl-card--expand{-ms-flex-positive:1;flex-grow:1}.mdl-card__menu{position:absolute;right:16px;top:16px}.mdl-checkbox{position:relative;z-index:1;vertical-align:middle;display:inline-block;box-sizing:border-box;width:100%;height:24px;margin:0;padding:0}.mdl-checkbox.is-upgraded{padding-left:24px}.mdl-checkbox__input{line-height:24px}.mdl-checkbox.is-upgraded .mdl-checkbox__input{position:absolute;width:0;height:0;margin:0;padding:0;opacity:0;-ms-appearance:none;-moz-appearance:none;-webkit-appearance:none;appearance:none;border:none}.mdl-checkbox__box-outline{position:absolute;top:3px;left:0;display:inline-block;box-sizing:border-box;width:16px;height:16px;margin:0;cursor:pointer;overflow:hidden;border:2px solid rgba(0,0,0,.54);border-radius:2px;z-index:2}.mdl-checkbox.is-checked .mdl-checkbox__box-outline{border:2px solid #3f51b5}.mdl-checkbox.is-disabled .mdl-checkbox__box-outline,fieldset[disabled] .mdl-checkbox .mdl-checkbox__box-outline{border:2px solid rgba(0,0,0,.26);cursor:auto}.mdl-checkbox__focus-helper{position:absolute;top:3px;left:0;display:inline-block;box-sizing:border-box;width:16px;height:16px;border-radius:50%;background-color:transparent}.mdl-checkbox.is-focused .mdl-checkbox__focus-helper{box-shadow:0 0 0 8px rgba(0,0,0,.1);background-color:rgba(0,0,0,.1)}.mdl-checkbox.is-focused.is-checked .mdl-checkbox__focus-helper{box-shadow:0 0 0 8px rgba(63,81,181,.26);background-color:rgba(63,81,181,.26)}.mdl-checkbox__tick-outline{position:absolute;top:0;left:0;height:100%;width:100%;-webkit-mask:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcCI+CiAgICAgIDxwYXRoCiAgICAgICAgIGQ9Ik0gMCwwIDAsMSAxLDEgMSwwIDAsMCB6IE0gMC44NTM0Mzc1LDAuMTY3MTg3NSAwLjk1OTY4NzUsMC4yNzMxMjUgMC40MjkzNzUsMC44MDM0Mzc1IDAuMzIzMTI1LDAuOTA5Njg3NSAwLjIxNzE4NzUsMC44MDM0Mzc1IDAuMDQwMzEyNSwwLjYyNjg3NSAwLjE0NjU2MjUsMC41MjA2MjUgMC4zMjMxMjUsMC42OTc1IDAuODUzNDM3NSwwLjE2NzE4NzUgeiIKICAgICAgICAgc3R5bGU9ImZpbGw6I2ZmZmZmZjtmaWxsLW9wYWNpdHk6MTtzdHJva2U6bm9uZSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgICA8bWFzayBpZD0ibWFzayIgbWFza1VuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgbWFza0NvbnRlbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgICA8cGF0aAogICAgICAgICBkPSJNIDAsMCAwLDEgMSwxIDEsMCAwLDAgeiBNIDAuODUzNDM3NSwwLjE2NzE4NzUgMC45NTk2ODc1LDAuMjczMTI1IDAuNDI5Mzc1LDAuODAzNDM3NSAwLjMyMzEyNSwwLjkwOTY4NzUgMC4yMTcxODc1LDAuODAzNDM3NSAwLjA0MDMxMjUsMC42MjY4NzUgMC4xNDY1NjI1LDAuNTIwNjI1IDAuMzIzMTI1LDAuNjk3NSAwLjg1MzQzNzUsMC4xNjcxODc1IHoiCiAgICAgICAgIHN0eWxlPSJmaWxsOiNmZmZmZmY7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOm5vbmUiIC8+CiAgICA8L21hc2s+CiAgPC9kZWZzPgogIDxyZWN0CiAgICAgd2lkdGg9IjEiCiAgICAgaGVpZ2h0PSIxIgogICAgIHg9IjAiCiAgICAgeT0iMCIKICAgICBjbGlwLXBhdGg9InVybCgjY2xpcCkiCiAgICAgc3R5bGU9ImZpbGw6IzAwMDAwMDtmaWxsLW9wYWNpdHk6MTtzdHJva2U6bm9uZSIgLz4KPC9zdmc+Cg==\");mask:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcCI+CiAgICAgIDxwYXRoCiAgICAgICAgIGQ9Ik0gMCwwIDAsMSAxLDEgMSwwIDAsMCB6IE0gMC44NTM0Mzc1LDAuMTY3MTg3NSAwLjk1OTY4NzUsMC4yNzMxMjUgMC40MjkzNzUsMC44MDM0Mzc1IDAuMzIzMTI1LDAuOTA5Njg3NSAwLjIxNzE4NzUsMC44MDM0Mzc1IDAuMDQwMzEyNSwwLjYyNjg3NSAwLjE0NjU2MjUsMC41MjA2MjUgMC4zMjMxMjUsMC42OTc1IDAuODUzNDM3NSwwLjE2NzE4NzUgeiIKICAgICAgICAgc3R5bGU9ImZpbGw6I2ZmZmZmZjtmaWxsLW9wYWNpdHk6MTtzdHJva2U6bm9uZSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgICA8bWFzayBpZD0ibWFzayIgbWFza1VuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgbWFza0NvbnRlbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgICA8cGF0aAogICAgICAgICBkPSJNIDAsMCAwLDEgMSwxIDEsMCAwLDAgeiBNIDAuODUzNDM3NSwwLjE2NzE4NzUgMC45NTk2ODc1LDAuMjczMTI1IDAuNDI5Mzc1LDAuODAzNDM3NSAwLjMyMzEyNSwwLjkwOTY4NzUgMC4yMTcxODc1LDAuODAzNDM3NSAwLjA0MDMxMjUsMC42MjY4NzUgMC4xNDY1NjI1LDAuNTIwNjI1IDAuMzIzMTI1LDAuNjk3NSAwLjg1MzQzNzUsMC4xNjcxODc1IHoiCiAgICAgICAgIHN0eWxlPSJmaWxsOiNmZmZmZmY7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOm5vbmUiIC8+CiAgICA8L21hc2s+CiAgPC9kZWZzPgogIDxyZWN0CiAgICAgd2lkdGg9IjEiCiAgICAgaGVpZ2h0PSIxIgogICAgIHg9IjAiCiAgICAgeT0iMCIKICAgICBjbGlwLXBhdGg9InVybCgjY2xpcCkiCiAgICAgc3R5bGU9ImZpbGw6IzAwMDAwMDtmaWxsLW9wYWNpdHk6MTtzdHJva2U6bm9uZSIgLz4KPC9zdmc+Cg==\");background:0 0;transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:background}.mdl-checkbox.is-checked .mdl-checkbox__tick-outline{background:#3f51b5 url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aAogICAgIGQ9Ik0gMC4wNDAzODA1OSwwLjYyNjc3NjcgMC4xNDY0NDY2MSwwLjUyMDcxMDY4IDAuNDI5Mjg5MzIsMC44MDM1NTMzOSAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IE0gMC4yMTcxNTcyOSwwLjgwMzU1MzM5IDAuODUzNTUzMzksMC4xNjcxNTcyOSAwLjk1OTYxOTQxLDAuMjczMjIzMyAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IgogICAgIGlkPSJyZWN0Mzc4MCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lIiAvPgo8L3N2Zz4K\")}.mdl-checkbox.is-checked.is-disabled .mdl-checkbox__tick-outline,fieldset[disabled] .mdl-checkbox.is-checked .mdl-checkbox__tick-outline{background:rgba(0,0,0,.26)url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aAogICAgIGQ9Ik0gMC4wNDAzODA1OSwwLjYyNjc3NjcgMC4xNDY0NDY2MSwwLjUyMDcxMDY4IDAuNDI5Mjg5MzIsMC44MDM1NTMzOSAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IE0gMC4yMTcxNTcyOSwwLjgwMzU1MzM5IDAuODUzNTUzMzksMC4xNjcxNTcyOSAwLjk1OTYxOTQxLDAuMjczMjIzMyAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IgogICAgIGlkPSJyZWN0Mzc4MCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lIiAvPgo8L3N2Zz4K\")}.mdl-checkbox__label{position:relative;cursor:pointer;font-size:16px;line-height:24px;margin:0}.mdl-checkbox.is-disabled .mdl-checkbox__label,fieldset[disabled] .mdl-checkbox .mdl-checkbox__label{color:rgba(0,0,0,.26);cursor:auto}.mdl-checkbox__ripple-container{position:absolute;z-index:2;top:-6px;left:-10px;box-sizing:border-box;width:36px;height:36px;border-radius:50%;cursor:pointer;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-checkbox__ripple-container .mdl-ripple{background:#3f51b5}.mdl-checkbox.is-disabled .mdl-checkbox__ripple-container,fieldset[disabled] .mdl-checkbox .mdl-checkbox__ripple-container{cursor:auto}.mdl-checkbox.is-disabled .mdl-checkbox__ripple-container .mdl-ripple,fieldset[disabled] .mdl-checkbox .mdl-checkbox__ripple-container .mdl-ripple{background:0 0}.mdl-chip{height:32px;font-family:Roboto,Helvetica,Arial,sans-serif;line-height:32px;padding:0 12px;border:0;border-radius:16px;background-color:#dedede;display:inline-block;color:rgba(0,0,0,.87);margin:2px 0;font-size:0;white-space:nowrap}.mdl-chip__text{font-size:13px;vertical-align:middle;display:inline-block}.mdl-chip__action{height:24px;width:24px;background:0 0;opacity:.54;cursor:pointer;padding:0;margin:0 0 0 4px;font-size:13px;text-decoration:none;color:rgba(0,0,0,.87);border:none;outline:none}.mdl-chip__action,.mdl-chip__contact{display:inline-block;vertical-align:middle;overflow:hidden;text-align:center}.mdl-chip__contact{height:32px;width:32px;border-radius:16px;margin-right:8px;font-size:18px;line-height:32px}.mdl-chip:focus{outline:0;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-chip:active{background-color:#d6d6d6}.mdl-chip--deletable{padding-right:4px}.mdl-chip--contact{padding-left:0}.mdl-data-table{position:relative;border:1px solid rgba(0,0,0,.12);border-collapse:collapse;white-space:nowrap;font-size:13px;background-color:#fff}.mdl-data-table thead{padding-bottom:3px}.mdl-data-table thead .mdl-data-table__select{margin-top:0}.mdl-data-table tbody tr{position:relative;height:48px;transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:background-color}.mdl-data-table tbody tr.is-selected{background-color:#e0e0e0}.mdl-data-table tbody tr:hover{background-color:#eee}.mdl-data-table td{text-align:right}.mdl-data-table th{padding:0 18px 12px;text-align:right}.mdl-data-table td:first-of-type,.mdl-data-table th:first-of-type{padding-left:24px}.mdl-data-table td:last-of-type,.mdl-data-table th:last-of-type{padding-right:24px}.mdl-data-table td{position:relative;height:48px;border-top:1px solid rgba(0,0,0,.12);border-bottom:1px solid rgba(0,0,0,.12);padding:12px 18px;box-sizing:border-box}.mdl-data-table td,.mdl-data-table td .mdl-data-table__select{vertical-align:middle}.mdl-data-table th{position:relative;vertical-align:bottom;text-overflow:ellipsis;font-weight:700;line-height:24px;letter-spacing:0;height:48px;font-size:12px;color:rgba(0,0,0,.54);padding-bottom:8px;box-sizing:border-box}.mdl-data-table th.mdl-data-table__header--sorted-ascending,.mdl-data-table th.mdl-data-table__header--sorted-descending{color:rgba(0,0,0,.87)}.mdl-data-table th.mdl-data-table__header--sorted-ascending:before,.mdl-data-table th.mdl-data-table__header--sorted-descending:before{font-family:Material Icons;font-weight:400;font-style:normal;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;word-wrap:normal;font-feature-settings:'liga';-webkit-font-feature-settings:'liga';-webkit-font-smoothing:antialiased;font-size:16px;content:\"\\E5D8\";margin-right:5px;vertical-align:sub}.mdl-data-table th.mdl-data-table__header--sorted-ascending:hover,.mdl-data-table th.mdl-data-table__header--sorted-descending:hover{cursor:pointer}.mdl-data-table th.mdl-data-table__header--sorted-ascending:hover:before,.mdl-data-table th.mdl-data-table__header--sorted-descending:hover:before{color:rgba(0,0,0,.26)}.mdl-data-table th.mdl-data-table__header--sorted-descending:before{content:\"\\E5DB\"}.mdl-data-table__select{width:16px}.mdl-data-table__cell--non-numeric.mdl-data-table__cell--non-numeric{text-align:left}.mdl-dialog{border:none;box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2);width:280px}.mdl-dialog__title{padding:24px 24px 0;margin:0;font-size:2.5rem}.mdl-dialog__actions{padding:8px 8px 8px 24px;display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse;-ms-flex-wrap:wrap;flex-wrap:wrap}.mdl-dialog__actions>*{margin-right:8px;height:36px}.mdl-dialog__actions>:first-child{margin-right:0}.mdl-dialog__actions--full-width{padding:0 0 8px}.mdl-dialog__actions--full-width>*{height:48px;-ms-flex:0 0 100%;flex:0 0 100%;padding-right:16px;margin-right:0;text-align:right}.mdl-dialog__content{padding:20px 24px 24px;color:rgba(0,0,0,.54)}.mdl-mega-footer{padding:16px 40px;color:#9e9e9e;background-color:#424242}.mdl-mega-footer--bottom-section:after,.mdl-mega-footer--middle-section:after,.mdl-mega-footer--top-section:after,.mdl-mega-footer__bottom-section:after,.mdl-mega-footer__middle-section:after,.mdl-mega-footer__top-section:after{content:'';display:block;clear:both}.mdl-mega-footer--left-section,.mdl-mega-footer--right-section,.mdl-mega-footer__left-section,.mdl-mega-footer__right-section{margin-bottom:16px}.mdl-mega-footer--right-section a,.mdl-mega-footer__right-section a{display:block;margin-bottom:16px;color:inherit;text-decoration:none}@media screen and (min-width:760px){.mdl-mega-footer--left-section,.mdl-mega-footer__left-section{float:left}.mdl-mega-footer--right-section,.mdl-mega-footer__right-section{float:right}.mdl-mega-footer--right-section a,.mdl-mega-footer__right-section a{display:inline-block;margin-left:16px;line-height:36px;vertical-align:middle}}.mdl-mega-footer--social-btn,.mdl-mega-footer__social-btn{width:36px;height:36px;padding:0;margin:0;background-color:#9e9e9e;border:none}.mdl-mega-footer--drop-down-section,.mdl-mega-footer__drop-down-section{display:block;position:relative}@media screen and (min-width:760px){.mdl-mega-footer--drop-down-section,.mdl-mega-footer__drop-down-section{width:33%}.mdl-mega-footer--drop-down-section:nth-child(1),.mdl-mega-footer--drop-down-section:nth-child(2),.mdl-mega-footer__drop-down-section:nth-child(1),.mdl-mega-footer__drop-down-section:nth-child(2){float:left}.mdl-mega-footer--drop-down-section:nth-child(3),.mdl-mega-footer__drop-down-section:nth-child(3){float:right}.mdl-mega-footer--drop-down-section:nth-child(3):after,.mdl-mega-footer__drop-down-section:nth-child(3):after{clear:right}.mdl-mega-footer--drop-down-section:nth-child(4),.mdl-mega-footer__drop-down-section:nth-child(4){clear:right;float:right}.mdl-mega-footer--middle-section:after,.mdl-mega-footer__middle-section:after{content:'';display:block;clear:both}.mdl-mega-footer--bottom-section,.mdl-mega-footer__bottom-section{padding-top:0}}@media screen and (min-width:1024px){.mdl-mega-footer--drop-down-section,.mdl-mega-footer--drop-down-section:nth-child(3),.mdl-mega-footer--drop-down-section:nth-child(4),.mdl-mega-footer__drop-down-section,.mdl-mega-footer__drop-down-section:nth-child(3),.mdl-mega-footer__drop-down-section:nth-child(4){width:24%;float:left}}.mdl-mega-footer--heading-checkbox,.mdl-mega-footer__heading-checkbox{position:absolute;width:100%;height:55.8px;padding:32px;margin:-16px 0 0;cursor:pointer;z-index:1;opacity:0}.mdl-mega-footer--heading-checkbox+.mdl-mega-footer--heading:after,.mdl-mega-footer--heading-checkbox+.mdl-mega-footer__heading:after,.mdl-mega-footer__heading-checkbox+.mdl-mega-footer--heading:after,.mdl-mega-footer__heading-checkbox+.mdl-mega-footer__heading:after{font-family:Material Icons;content:'\\E5CE'}.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer--heading+.mdl-mega-footer--link-list,.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer__heading+.mdl-mega-footer__link-list,.mdl-mega-footer--heading-checkbox:checked~.mdl-mega-footer--link-list,.mdl-mega-footer--heading-checkbox:checked~.mdl-mega-footer__link-list,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer--heading+.mdl-mega-footer--link-list,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer__heading+.mdl-mega-footer__link-list,.mdl-mega-footer__heading-checkbox:checked~.mdl-mega-footer--link-list,.mdl-mega-footer__heading-checkbox:checked~.mdl-mega-footer__link-list{display:none}.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer--heading:after,.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer__heading:after,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer--heading:after,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer__heading:after{font-family:Material Icons;content:'\\E5CF'}.mdl-mega-footer--heading,.mdl-mega-footer__heading{position:relative;width:100%;padding-right:39.8px;margin-bottom:16px;box-sizing:border-box;font-size:14px;line-height:23.8px;font-weight:500;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:#e0e0e0}.mdl-mega-footer--heading:after,.mdl-mega-footer__heading:after{content:'';position:absolute;top:0;right:0;display:block;width:23.8px;height:23.8px;background-size:cover}.mdl-mega-footer--link-list,.mdl-mega-footer__link-list{list-style:none;padding:0;margin:0 0 32px}.mdl-mega-footer--link-list:after,.mdl-mega-footer__link-list:after{clear:both;display:block;content:''}.mdl-mega-footer--link-list li,.mdl-mega-footer__link-list li{font-size:14px;font-weight:400;letter-spacing:0;line-height:20px}.mdl-mega-footer--link-list a,.mdl-mega-footer__link-list a{color:inherit;text-decoration:none;white-space:nowrap}@media screen and (min-width:760px){.mdl-mega-footer--heading-checkbox,.mdl-mega-footer__heading-checkbox{display:none}.mdl-mega-footer--heading-checkbox+.mdl-mega-footer--heading:after,.mdl-mega-footer--heading-checkbox+.mdl-mega-footer__heading:after,.mdl-mega-footer__heading-checkbox+.mdl-mega-footer--heading:after,.mdl-mega-footer__heading-checkbox+.mdl-mega-footer__heading:after{content:''}.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer--heading+.mdl-mega-footer--link-list,.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer__heading+.mdl-mega-footer__link-list,.mdl-mega-footer--heading-checkbox:checked~.mdl-mega-footer--link-list,.mdl-mega-footer--heading-checkbox:checked~.mdl-mega-footer__link-list,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer--heading+.mdl-mega-footer--link-list,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer__heading+.mdl-mega-footer__link-list,.mdl-mega-footer__heading-checkbox:checked~.mdl-mega-footer--link-list,.mdl-mega-footer__heading-checkbox:checked~.mdl-mega-footer__link-list{display:block}.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer--heading:after,.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer__heading:after,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer--heading:after,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer__heading:after{content:''}}.mdl-mega-footer--bottom-section,.mdl-mega-footer__bottom-section{padding-top:16px;margin-bottom:16px}.mdl-logo{margin-bottom:16px;color:#fff}.mdl-mega-footer--bottom-section .mdl-mega-footer--link-list li,.mdl-mega-footer__bottom-section .mdl-mega-footer__link-list li{float:left;margin-bottom:0;margin-right:16px}@media screen and (min-width:760px){.mdl-logo{float:left;margin-bottom:0;margin-right:16px}}.mdl-mini-footer{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-pack:justify;justify-content:space-between;padding:32px 16px;color:#9e9e9e;background-color:#424242}.mdl-mini-footer:after{content:'';display:block}.mdl-mini-footer .mdl-logo{line-height:36px}.mdl-mini-footer--link-list,.mdl-mini-footer__link-list{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row;list-style:none;margin:0;padding:0}.mdl-mini-footer--link-list li,.mdl-mini-footer__link-list li{margin-bottom:0;margin-right:16px}@media screen and (min-width:760px){.mdl-mini-footer--link-list li,.mdl-mini-footer__link-list li{line-height:36px}}.mdl-mini-footer--link-list a,.mdl-mini-footer__link-list a{color:inherit;text-decoration:none;white-space:nowrap}.mdl-mini-footer--left-section,.mdl-mini-footer__left-section{display:inline-block;-ms-flex-order:0;order:0}.mdl-mini-footer--right-section,.mdl-mini-footer__right-section{display:inline-block;-ms-flex-order:1;order:1}.mdl-mini-footer--social-btn,.mdl-mini-footer__social-btn{width:36px;height:36px;padding:0;margin:0;background-color:#9e9e9e;border:none}.mdl-icon-toggle{position:relative;z-index:1;vertical-align:middle;display:inline-block;height:32px;margin:0;padding:0}.mdl-icon-toggle__input{line-height:32px}.mdl-icon-toggle.is-upgraded .mdl-icon-toggle__input{position:absolute;width:0;height:0;margin:0;padding:0;opacity:0;-ms-appearance:none;-moz-appearance:none;-webkit-appearance:none;appearance:none;border:none}.mdl-icon-toggle__label{display:inline-block;position:relative;cursor:pointer;height:32px;width:32px;min-width:32px;color:#616161;border-radius:50%;padding:0;margin-left:0;margin-right:0;text-align:center;background-color:transparent;will-change:background-color;transition:background-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1)}.mdl-icon-toggle__label.material-icons{line-height:32px;font-size:24px}.mdl-icon-toggle.is-checked .mdl-icon-toggle__label{color:#3f51b5}.mdl-icon-toggle.is-disabled .mdl-icon-toggle__label{color:rgba(0,0,0,.26);cursor:auto;transition:none}.mdl-icon-toggle.is-focused .mdl-icon-toggle__label{background-color:rgba(0,0,0,.12)}.mdl-icon-toggle.is-focused.is-checked .mdl-icon-toggle__label{background-color:rgba(63,81,181,.26)}.mdl-icon-toggle__ripple-container{position:absolute;z-index:2;top:-2px;left:-2px;box-sizing:border-box;width:36px;height:36px;border-radius:50%;cursor:pointer;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-icon-toggle__ripple-container .mdl-ripple{background:#616161}.mdl-icon-toggle.is-disabled .mdl-icon-toggle__ripple-container{cursor:auto}.mdl-icon-toggle.is-disabled .mdl-icon-toggle__ripple-container .mdl-ripple{background:0 0}.mdl-list{display:block;padding:8px 0;list-style:none}.mdl-list__item{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;letter-spacing:.04em;line-height:1;min-height:48px;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding:16px;cursor:default;color:rgba(0,0,0,.87);overflow:hidden}.mdl-list__item,.mdl-list__item .mdl-list__item-primary-content{box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.mdl-list__item .mdl-list__item-primary-content{-ms-flex-order:0;order:0;-ms-flex-positive:2;flex-grow:2;text-decoration:none}.mdl-list__item .mdl-list__item-primary-content .mdl-list__item-icon{margin-right:32px}.mdl-list__item .mdl-list__item-primary-content .mdl-list__item-avatar{margin-right:16px}.mdl-list__item .mdl-list__item-secondary-content{display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-align:end;align-items:flex-end;margin-left:16px}.mdl-list__item .mdl-list__item-secondary-content .mdl-list__item-secondary-action label{display:inline}.mdl-list__item .mdl-list__item-secondary-content .mdl-list__item-secondary-info{font-size:12px;font-weight:400;line-height:1;letter-spacing:0;color:rgba(0,0,0,.54)}.mdl-list__item .mdl-list__item-secondary-content .mdl-list__item-sub-header{padding:0 0 0 16px}.mdl-list__item-icon,.mdl-list__item-icon.material-icons{height:24px;width:24px;font-size:24px;box-sizing:border-box;color:#757575}.mdl-list__item-avatar,.mdl-list__item-avatar.material-icons{height:40px;width:40px;box-sizing:border-box;border-radius:50%;background-color:#757575;font-size:40px;color:#fff}.mdl-list__item--two-line{height:72px}.mdl-list__item--two-line .mdl-list__item-primary-content{height:36px;line-height:20px;display:block}.mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-avatar{float:left}.mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-icon{float:left;margin-top:6px}.mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-secondary-content{height:36px}.mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-sub-title{font-size:14px;font-weight:400;letter-spacing:0;line-height:18px;color:rgba(0,0,0,.54);display:block;padding:0}.mdl-list__item--three-line{height:88px}.mdl-list__item--three-line .mdl-list__item-primary-content{height:52px;line-height:20px;display:block}.mdl-list__item--three-line .mdl-list__item-primary-content .mdl-list__item-avatar,.mdl-list__item--three-line .mdl-list__item-primary-content .mdl-list__item-icon{float:left}.mdl-list__item--three-line .mdl-list__item-secondary-content{height:52px}.mdl-list__item--three-line .mdl-list__item-text-body{font-size:14px;font-weight:400;letter-spacing:0;line-height:18px;height:52px;color:rgba(0,0,0,.54);display:block;padding:0}.mdl-menu__container{display:block;margin:0;padding:0;border:none;position:absolute;overflow:visible;height:0;width:0;visibility:hidden;z-index:-1}.mdl-menu__container.is-animating,.mdl-menu__container.is-visible{z-index:999;visibility:visible}.mdl-menu__outline{display:block;background:#fff;margin:0;padding:0;border:none;border-radius:2px;position:absolute;top:0;left:0;overflow:hidden;opacity:0;-webkit-transform:scale(0);transform:scale(0);-webkit-transform-origin:0 0;transform-origin:0 0;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);will-change:transform;transition:transform .3s cubic-bezier(.4,0,.2,1),opacity .2s cubic-bezier(.4,0,.2,1);transition:transform .3s cubic-bezier(.4,0,.2,1),opacity .2s cubic-bezier(.4,0,.2,1),-webkit-transform .3s cubic-bezier(.4,0,.2,1);z-index:-1}.mdl-menu__container.is-visible .mdl-menu__outline{opacity:1;-webkit-transform:scale(1);transform:scale(1);z-index:999}.mdl-menu__outline.mdl-menu--bottom-right{-webkit-transform-origin:100% 0;transform-origin:100% 0}.mdl-menu__outline.mdl-menu--top-left{-webkit-transform-origin:0 100%;transform-origin:0 100%}.mdl-menu__outline.mdl-menu--top-right{-webkit-transform-origin:100% 100%;transform-origin:100% 100%}.mdl-menu{position:absolute;list-style:none;top:0;left:0;height:auto;width:auto;min-width:124px;padding:8px 0;margin:0;opacity:0;clip:rect(0 0 0 0);z-index:-1}.mdl-menu__container.is-visible .mdl-menu{opacity:1;z-index:999}.mdl-menu.is-animating{transition:opacity .2s cubic-bezier(.4,0,.2,1),clip .3s cubic-bezier(.4,0,.2,1)}.mdl-menu.mdl-menu--bottom-right{left:auto;right:0}.mdl-menu.mdl-menu--top-left{top:auto;bottom:0}.mdl-menu.mdl-menu--top-right{top:auto;left:auto;bottom:0;right:0}.mdl-menu.mdl-menu--unaligned{top:auto;left:auto}.mdl-menu__item{display:block;border:none;color:rgba(0,0,0,.87);background-color:transparent;text-align:left;margin:0;padding:0 16px;outline-color:#bdbdbd;position:relative;overflow:hidden;font-size:14px;font-weight:400;letter-spacing:0;text-decoration:none;cursor:pointer;height:48px;line-height:48px;white-space:nowrap;opacity:0;transition:opacity .2s cubic-bezier(.4,0,.2,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mdl-menu__container.is-visible .mdl-menu__item{opacity:1}.mdl-menu__item::-moz-focus-inner{border:0}.mdl-menu__item--full-bleed-divider{border-bottom:1px solid rgba(0,0,0,.12)}.mdl-menu__item[data-mdl-disabled],.mdl-menu__item[disabled]{color:#bdbdbd;background-color:transparent;cursor:auto}.mdl-menu__item[data-mdl-disabled]:focus,.mdl-menu__item[data-mdl-disabled]:hover,.mdl-menu__item[disabled]:focus,.mdl-menu__item[disabled]:hover{background-color:transparent}.mdl-menu__item[data-mdl-disabled] .mdl-ripple,.mdl-menu__item[disabled] .mdl-ripple{background:0 0}.mdl-menu__item:hover{background-color:#eee}.mdl-menu__item:focus{outline:none;background-color:#eee}.mdl-menu__item:active{background-color:#e0e0e0}.mdl-menu__item--ripple-container{display:block;height:100%;left:0;position:absolute;top:0;width:100%;z-index:0;overflow:hidden}.mdl-progress{display:block;position:relative;height:4px;width:500px;max-width:100%}.mdl-progress>.bar{display:block;position:absolute;top:0;bottom:0;width:0;transition:width .2s cubic-bezier(.4,0,.2,1)}.mdl-progress>.progressbar{background-color:#3f51b5;z-index:1;left:0}.mdl-progress>.bufferbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);z-index:0;left:0}.mdl-progress>.auxbar{right:0}@supports (-webkit-appearance:none){.mdl-progress:not(.mdl-progress--indeterminate):not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate):not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);-webkit-mask:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=\");mask:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=\")}}.mdl-progress:not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.9),hsla(0,0%,100%,.9)),linear-gradient(90deg,#3f51b5,#3f51b5)}.mdl-progress.mdl-progress--indeterminate>.bar1,.mdl-progress.mdl-progress__indeterminate>.bar1{-webkit-animation-name:indeterminate1;animation-name:indeterminate1}.mdl-progress.mdl-progress--indeterminate>.bar1,.mdl-progress.mdl-progress--indeterminate>.bar3,.mdl-progress.mdl-progress__indeterminate>.bar1,.mdl-progress.mdl-progress__indeterminate>.bar3{background-color:#3f51b5;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear}.mdl-progress.mdl-progress--indeterminate>.bar3,.mdl-progress.mdl-progress__indeterminate>.bar3{background-image:none;-webkit-animation-name:indeterminate2;animation-name:indeterminate2}@-webkit-keyframes indeterminate1{0%{left:0;width:0}50%{left:25%;width:75%}75%{left:100%;width:0}}@keyframes indeterminate1{0%{left:0;width:0}50%{left:25%;width:75%}75%{left:100%;width:0}}@-webkit-keyframes indeterminate2{0%,50%{left:0;width:0}75%{left:0;width:25%}to{left:100%;width:0}}@keyframes indeterminate2{0%,50%{left:0;width:0}75%{left:0;width:25%}to{left:100%;width:0}}.mdl-navigation{display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;box-sizing:border-box}.mdl-navigation__link{color:#424242;text-decoration:none;margin:0;font-size:14px;font-weight:400;line-height:24px;letter-spacing:0;opacity:.87}.mdl-navigation__link .material-icons{vertical-align:middle}.mdl-layout{position:absolute;width:100%;height:100%}.mdl-layout.is-small-screen .mdl-layout--large-screen-only,.mdl-layout:not(.is-small-screen) .mdl-layout--small-screen-only{display:none}.mdl-layout__inner-container{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;overflow-y:auto;overflow-x:hidden;position:relative;-webkit-overflow-scrolling:touch}.mdl-layout-title,.mdl-layout__title{display:block;position:relative;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:20px;line-height:1;letter-spacing:.02em;font-weight:400;box-sizing:border-box}.mdl-layout-spacer{-ms-flex-positive:1;flex-grow:1}.mdl-layout__drawer{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:240px;height:100%;max-height:100%;position:absolute;top:0;left:0;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);box-sizing:border-box;border-right:1px solid #e0e0e0;background:#fafafa;-webkit-transform:translateX(-250px);transform:translateX(-250px);-webkit-transform-style:preserve-3d;transform-style:preserve-3d;will-change:transform;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:transform;transition-property:transform,-webkit-transform;color:#424242;overflow:visible;overflow-y:auto;z-index:5}.mdl-layout__drawer.is-visible{-webkit-transform:translateX(0);transform:translateX(0)}.mdl-layout__drawer.is-visible~.mdl-layout__content.mdl-layout__content{overflow:hidden}.mdl-layout__drawer>*{-ms-flex-negative:0;flex-shrink:0}.mdl-layout__drawer>.mdl-layout-title,.mdl-layout__drawer>.mdl-layout__title{line-height:64px;padding-left:40px}@media screen and (max-width:1024px){.mdl-layout__drawer>.mdl-layout-title,.mdl-layout__drawer>.mdl-layout__title{line-height:56px;padding-left:16px}}.mdl-layout__drawer .mdl-navigation{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;-ms-grid-row-align:stretch;align-items:stretch;padding-top:16px}.mdl-layout__drawer .mdl-navigation .mdl-navigation__link{display:block;-ms-flex-negative:0;flex-shrink:0;padding:16px 40px;margin:0;color:#757575}@media screen and (max-width:1024px){.mdl-layout__drawer .mdl-navigation .mdl-navigation__link{padding:16px}}.mdl-layout__drawer .mdl-navigation .mdl-navigation__link:hover{background-color:#e0e0e0}.mdl-layout__drawer .mdl-navigation .mdl-navigation__link--current{background-color:#e0e0e0;color:#000}@media screen and (min-width:1025px){.mdl-layout--fixed-drawer>.mdl-layout__inner-container>.mdl-layout__drawer{-webkit-transform:translateX(0);transform:translateX(0)}}.mdl-layout__drawer-button{display:block;position:absolute;height:48px;width:48px;border:0;-ms-flex-negative:0;flex-shrink:0;overflow:hidden;text-align:center;cursor:pointer;font-size:26px;line-height:56px;font-family:Helvetica,Arial,sans-serif;margin:10px 12px;top:0;left:0;color:#fff;z-index:4}.mdl-layout__header .mdl-layout__drawer-button{position:absolute;color:#fff;background-color:inherit}@media screen and (max-width:1024px){.mdl-layout__header .mdl-layout__drawer-button{margin:4px}}@media screen and (max-width:1024px){.mdl-layout__drawer-button{margin:4px;color:rgba(0,0,0,.5)}}@media screen and (min-width:1025px){.mdl-layout__drawer-button{line-height:64px}.mdl-layout--fixed-drawer>.mdl-layout__inner-container>.mdl-layout__drawer-button,.mdl-layout--no-desktop-drawer-button .mdl-layout__drawer-button,.mdl-layout--no-drawer-button .mdl-layout__drawer-button{display:none}}.mdl-layout__header{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-pack:start;justify-content:flex-start;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;width:100%;margin:0;padding:0;border:none;min-height:64px;max-height:1000px;z-index:3;background-color:#3f51b5;color:#fff;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:max-height,box-shadow}@media screen and (max-width:1024px){.mdl-layout__header{min-height:56px}}.mdl-layout--fixed-drawer.is-upgraded:not(.is-small-screen)>.mdl-layout__inner-container>.mdl-layout__header{margin-left:240px;width:calc(100% - 240px)}@media screen and (min-width:1025px){.mdl-layout--fixed-drawer>.mdl-layout__inner-container>.mdl-layout__header .mdl-layout__header-row{padding-left:40px}}.mdl-layout__header>.mdl-layout-icon{position:absolute;left:40px;top:16px;height:32px;width:32px;overflow:hidden;z-index:3;display:block}@media screen and (max-width:1024px){.mdl-layout__header>.mdl-layout-icon{left:16px;top:12px}}.mdl-layout.has-drawer .mdl-layout__header>.mdl-layout-icon{display:none}.mdl-layout__header.is-compact{max-height:64px}@media screen and (max-width:1024px){.mdl-layout__header.is-compact{max-height:56px}}.mdl-layout__header.is-compact.has-tabs{height:112px}@media screen and (max-width:1024px){.mdl-layout__header.is-compact.has-tabs{min-height:104px}}@media screen and (max-width:1024px){.mdl-layout__header{display:none}.mdl-layout--fixed-header>.mdl-layout__inner-container>.mdl-layout__header{display:-ms-flexbox;display:flex}}.mdl-layout__header--transparent.mdl-layout__header--transparent{background-color:transparent;box-shadow:none}.mdl-layout__header--scroll,.mdl-layout__header--seamed{box-shadow:none}.mdl-layout__header--waterfall{box-shadow:none;overflow:hidden}.mdl-layout__header--waterfall.is-casting-shadow{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-layout__header--waterfall.mdl-layout__header--waterfall-hide-top{-ms-flex-pack:end;justify-content:flex-end}.mdl-layout__header-row{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-negative:0;flex-shrink:0;box-sizing:border-box;-ms-flex-item-align:stretch;align-self:stretch;-ms-flex-align:center;align-items:center;height:64px;margin:0;padding:0 40px 0 80px}.mdl-layout--no-drawer-button .mdl-layout__header-row{padding-left:40px}@media screen and (min-width:1025px){.mdl-layout--no-desktop-drawer-button .mdl-layout__header-row{padding-left:40px}}@media screen and (max-width:1024px){.mdl-layout__header-row{height:56px;padding:0 16px 0 72px}.mdl-layout--no-drawer-button .mdl-layout__header-row{padding-left:16px}}.mdl-layout__header-row>*{-ms-flex-negative:0;flex-shrink:0}.mdl-layout__header--scroll .mdl-layout__header-row{width:100%}.mdl-layout__header-row .mdl-navigation{margin:0;padding:0;height:64px;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}@media screen and (max-width:1024px){.mdl-layout__header-row .mdl-navigation{height:56px}}.mdl-layout__header-row .mdl-navigation__link{display:block;color:#fff;line-height:64px;padding:0 24px}@media screen and (max-width:1024px){.mdl-layout__header-row .mdl-navigation__link{line-height:56px;padding:0 16px}}.mdl-layout__obfuscator{background-color:transparent;position:absolute;top:0;left:0;height:100%;width:100%;z-index:4;visibility:hidden;transition-property:background-color;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-layout__obfuscator.is-visible{background-color:rgba(0,0,0,.5);visibility:visible}@supports (pointer-events:auto){.mdl-layout__obfuscator{background-color:rgba(0,0,0,.5);opacity:0;transition-property:opacity;visibility:visible;pointer-events:none}.mdl-layout__obfuscator.is-visible{pointer-events:auto;opacity:1}}.mdl-layout__content{-ms-flex:0 1 auto;position:relative;display:inline-block;overflow-y:auto;overflow-x:hidden;-ms-flex-positive:1;flex-grow:1;z-index:1;-webkit-overflow-scrolling:touch}.mdl-layout--fixed-drawer>.mdl-layout__inner-container>.mdl-layout__content{margin-left:240px}.mdl-layout.has-scrolling-header .mdl-layout__content{overflow:visible}@media screen and (max-width:1024px){.mdl-layout--fixed-drawer>.mdl-layout__inner-container>.mdl-layout__content{margin-left:0}.mdl-layout.has-scrolling-header .mdl-layout__content{overflow-y:auto;overflow-x:hidden}}.mdl-layout__tab-bar{height:96px;margin:0;width:calc(100% - 112px);padding:0 0 0 56px;display:-ms-flexbox;display:flex;background-color:#3f51b5;overflow-y:hidden;overflow-x:scroll}.mdl-layout__tab-bar::-webkit-scrollbar{display:none}.mdl-layout--no-drawer-button .mdl-layout__tab-bar{padding-left:16px;width:calc(100% - 32px)}@media screen and (min-width:1025px){.mdl-layout--no-desktop-drawer-button .mdl-layout__tab-bar{padding-left:16px;width:calc(100% - 32px)}}@media screen and (max-width:1024px){.mdl-layout__tab-bar{width:calc(100% - 60px);padding:0 0 0 60px}.mdl-layout--no-drawer-button .mdl-layout__tab-bar{width:calc(100% - 8px);padding-left:4px}}.mdl-layout--fixed-tabs .mdl-layout__tab-bar{padding:0;overflow:hidden;width:100%}.mdl-layout__tab-bar-container{position:relative;height:48px;width:100%;border:none;margin:0;z-index:2;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;overflow:hidden}.mdl-layout__container>.mdl-layout__tab-bar-container{position:absolute;top:0;left:0}.mdl-layout__tab-bar-button{display:inline-block;position:absolute;top:0;height:48px;width:56px;z-index:4;text-align:center;background-color:#3f51b5;color:transparent;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mdl-layout--no-desktop-drawer-button .mdl-layout__tab-bar-button,.mdl-layout--no-drawer-button .mdl-layout__tab-bar-button{width:16px}.mdl-layout--no-desktop-drawer-button .mdl-layout__tab-bar-button .material-icons,.mdl-layout--no-drawer-button .mdl-layout__tab-bar-button .material-icons{position:relative;left:-4px}@media screen and (max-width:1024px){.mdl-layout__tab-bar-button{width:60px}}.mdl-layout--fixed-tabs .mdl-layout__tab-bar-button{display:none}.mdl-layout__tab-bar-button .material-icons{line-height:48px}.mdl-layout__tab-bar-button.is-active{color:#fff}.mdl-layout__tab-bar-left-button{left:0}.mdl-layout__tab-bar-right-button{right:0}.mdl-layout__tab{margin:0;border:none;padding:0 24px;float:left;position:relative;display:block;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;text-decoration:none;height:48px;line-height:48px;text-align:center;font-weight:500;font-size:14px;text-transform:uppercase;color:hsla(0,0%,100%,.6);overflow:hidden}@media screen and (max-width:1024px){.mdl-layout__tab{padding:0 12px}}.mdl-layout--fixed-tabs .mdl-layout__tab{float:none;-ms-flex-positive:1;flex-grow:1;padding:0}.mdl-layout.is-upgraded .mdl-layout__tab.is-active{color:#fff}.mdl-layout.is-upgraded .mdl-layout__tab.is-active:after{height:2px;width:100%;display:block;content:\" \";bottom:0;left:0;position:absolute;background:#ff4081;-webkit-animation:border-expand .2s cubic-bezier(.4,0,.4,1).01s alternate forwards;animation:border-expand .2s cubic-bezier(.4,0,.4,1).01s alternate forwards;transition:all 1s cubic-bezier(.4,0,1,1)}.mdl-layout__tab .mdl-layout__tab-ripple-container{display:block;position:absolute;height:100%;width:100%;left:0;top:0;z-index:1;overflow:hidden}.mdl-layout__tab .mdl-layout__tab-ripple-container .mdl-ripple{background-color:#fff}.mdl-layout__tab-panel{display:block}.mdl-layout.is-upgraded .mdl-layout__tab-panel{display:none}.mdl-layout.is-upgraded .mdl-layout__tab-panel.is-active{display:block}.mdl-radio{position:relative;font-size:16px;line-height:24px;display:inline-block;box-sizing:border-box;margin:0;padding-left:0}.mdl-radio.is-upgraded{padding-left:24px}.mdl-radio__button{line-height:24px}.mdl-radio.is-upgraded .mdl-radio__button{position:absolute;width:0;height:0;margin:0;padding:0;opacity:0;-ms-appearance:none;-moz-appearance:none;-webkit-appearance:none;appearance:none;border:none}.mdl-radio__outer-circle{position:absolute;top:4px;left:0;display:inline-block;box-sizing:border-box;width:16px;height:16px;margin:0;cursor:pointer;border:2px solid rgba(0,0,0,.54);border-radius:50%;z-index:2}.mdl-radio.is-checked .mdl-radio__outer-circle{border:2px solid #3f51b5}.mdl-radio.is-disabled .mdl-radio__outer-circle,.mdl-radio__outer-circle fieldset[disabled] .mdl-radio{border:2px solid rgba(0,0,0,.26);cursor:auto}.mdl-radio__inner-circle{position:absolute;z-index:1;margin:0;top:8px;left:4px;box-sizing:border-box;width:8px;height:8px;cursor:pointer;transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:transform;transition-property:transform,-webkit-transform;-webkit-transform:scale3d(0,0,0);transform:scale3d(0,0,0);border-radius:50%;background:#3f51b5}.mdl-radio.is-checked .mdl-radio__inner-circle{-webkit-transform:scaleX(1);transform:scaleX(1)}.mdl-radio.is-disabled .mdl-radio__inner-circle,fieldset[disabled] .mdl-radio .mdl-radio__inner-circle{background:rgba(0,0,0,.26);cursor:auto}.mdl-radio.is-focused .mdl-radio__inner-circle{box-shadow:0 0 0 10px rgba(0,0,0,.1)}.mdl-radio__label{cursor:pointer}.mdl-radio.is-disabled .mdl-radio__label,fieldset[disabled] .mdl-radio .mdl-radio__label{color:rgba(0,0,0,.26);cursor:auto}.mdl-radio__ripple-container{position:absolute;z-index:2;top:-9px;left:-13px;box-sizing:border-box;width:42px;height:42px;border-radius:50%;cursor:pointer;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-radio__ripple-container .mdl-ripple{background:#3f51b5}.mdl-radio.is-disabled .mdl-radio__ripple-container,fieldset[disabled] .mdl-radio .mdl-radio__ripple-container{cursor:auto}.mdl-radio.is-disabled .mdl-radio__ripple-container .mdl-ripple,fieldset[disabled] .mdl-radio .mdl-radio__ripple-container .mdl-ripple{background:0 0}:root .mdl-slider.mdl-slider.is-upgraded,_:-ms-input-placeholder{-ms-appearance:none;height:32px;margin:0}.mdl-slider{width:calc(100% - 40px);margin:0 20px}.mdl-slider.is-upgraded{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:2px;background:0 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0;padding:0;color:#3f51b5;-ms-flex-item-align:center;align-self:center;z-index:1;cursor:pointer}.mdl-slider.is-upgraded::-moz-focus-outer{border:0}.mdl-slider.is-upgraded::-ms-tooltip{display:none}.mdl-slider.is-upgraded::-webkit-slider-runnable-track{background:0 0}.mdl-slider.is-upgraded::-moz-range-track{background:0 0;border:none}.mdl-slider.is-upgraded::-ms-track{background:0 0;color:transparent;height:2px;width:100%;border:none}.mdl-slider.is-upgraded::-ms-fill-lower{padding:0;background:linear-gradient(90deg,transparent,transparent 16px,#3f51b5 0,#3f51b5 0)}.mdl-slider.is-upgraded::-ms-fill-upper{padding:0;background:linear-gradient(270deg,transparent,transparent 16px,rgba(0,0,0,.26)16px,rgba(0,0,0,.26)0)}.mdl-slider.is-upgraded::-webkit-slider-thumb{-webkit-appearance:none;width:12px;height:12px;box-sizing:border-box;border-radius:50%;background:#3f51b5;border:none;transition:transform .18s cubic-bezier(.4,0,.2,1),border .18s cubic-bezier(.4,0,.2,1),box-shadow .18s cubic-bezier(.4,0,.2,1),background .28s cubic-bezier(.4,0,.2,1);transition:transform .18s cubic-bezier(.4,0,.2,1),border .18s cubic-bezier(.4,0,.2,1),box-shadow .18s cubic-bezier(.4,0,.2,1),background .28s cubic-bezier(.4,0,.2,1),-webkit-transform .18s cubic-bezier(.4,0,.2,1)}.mdl-slider.is-upgraded::-moz-range-thumb{-moz-appearance:none;width:12px;height:12px;box-sizing:border-box;border-radius:50%;background-image:none;background:#3f51b5;border:none}.mdl-slider.is-upgraded:focus:not(:active)::-webkit-slider-thumb{box-shadow:0 0 0 10px rgba(63,81,181,.26)}.mdl-slider.is-upgraded:focus:not(:active)::-moz-range-thumb{box-shadow:0 0 0 10px rgba(63,81,181,.26)}.mdl-slider.is-upgraded:active::-webkit-slider-thumb{background-image:none;background:#3f51b5;-webkit-transform:scale(1.5);transform:scale(1.5)}.mdl-slider.is-upgraded:active::-moz-range-thumb{background-image:none;background:#3f51b5;transform:scale(1.5)}.mdl-slider.is-upgraded::-ms-thumb{width:32px;height:32px;border:none;border-radius:50%;background:#3f51b5;transform:scale(.375);transition:transform .18s cubic-bezier(.4,0,.2,1),background .28s cubic-bezier(.4,0,.2,1);transition:transform .18s cubic-bezier(.4,0,.2,1),background .28s cubic-bezier(.4,0,.2,1),-webkit-transform .18s cubic-bezier(.4,0,.2,1)}.mdl-slider.is-upgraded:focus:not(:active)::-ms-thumb{background:radial-gradient(circle closest-side,#3f51b5 0,#3f51b5 37.5%,rgba(63,81,181,.26)37.5%,rgba(63,81,181,.26)100%);transform:scale(1)}.mdl-slider.is-upgraded:active::-ms-thumb{background:#3f51b5;transform:scale(.5625)}.mdl-slider.is-upgraded.is-lowest-value::-webkit-slider-thumb{border:2px solid rgba(0,0,0,.26);background:0 0}.mdl-slider.is-upgraded.is-lowest-value::-moz-range-thumb{border:2px solid rgba(0,0,0,.26);background:0 0}.mdl-slider.is-upgraded.is-lowest-value+.mdl-slider__background-flex>.mdl-slider__background-upper{left:6px}.mdl-slider.is-upgraded.is-lowest-value:focus:not(:active)::-webkit-slider-thumb{box-shadow:0 0 0 10px rgba(0,0,0,.12);background:rgba(0,0,0,.12)}.mdl-slider.is-upgraded.is-lowest-value:focus:not(:active)::-moz-range-thumb{box-shadow:0 0 0 10px rgba(0,0,0,.12);background:rgba(0,0,0,.12)}.mdl-slider.is-upgraded.is-lowest-value:active::-webkit-slider-thumb{border:1.6px solid rgba(0,0,0,.26);-webkit-transform:scale(1.5);transform:scale(1.5)}.mdl-slider.is-upgraded.is-lowest-value:active+.mdl-slider__background-flex>.mdl-slider__background-upper{left:9px}.mdl-slider.is-upgraded.is-lowest-value:active::-moz-range-thumb{border:1.5px solid rgba(0,0,0,.26);transform:scale(1.5)}.mdl-slider.is-upgraded.is-lowest-value::-ms-thumb{background:radial-gradient(circle closest-side,transparent 0,transparent 66.67%,rgba(0,0,0,.26)66.67%,rgba(0,0,0,.26)100%)}.mdl-slider.is-upgraded.is-lowest-value:focus:not(:active)::-ms-thumb{background:radial-gradient(circle closest-side,rgba(0,0,0,.12)0,rgba(0,0,0,.12)25%,rgba(0,0,0,.26)25%,rgba(0,0,0,.26)37.5%,rgba(0,0,0,.12)37.5%,rgba(0,0,0,.12)100%);transform:scale(1)}.mdl-slider.is-upgraded.is-lowest-value:active::-ms-thumb{transform:scale(.5625);background:radial-gradient(circle closest-side,transparent 0,transparent 77.78%,rgba(0,0,0,.26)77.78%,rgba(0,0,0,.26)100%)}.mdl-slider.is-upgraded.is-lowest-value::-ms-fill-lower{background:0 0}.mdl-slider.is-upgraded.is-lowest-value::-ms-fill-upper{margin-left:6px}.mdl-slider.is-upgraded.is-lowest-value:active::-ms-fill-upper{margin-left:9px}.mdl-slider.is-upgraded:disabled::-webkit-slider-thumb,.mdl-slider.is-upgraded:disabled:active::-webkit-slider-thumb,.mdl-slider.is-upgraded:disabled:focus::-webkit-slider-thumb{-webkit-transform:scale(.667);transform:scale(.667);background:rgba(0,0,0,.26)}.mdl-slider.is-upgraded:disabled::-moz-range-thumb,.mdl-slider.is-upgraded:disabled:active::-moz-range-thumb,.mdl-slider.is-upgraded:disabled:focus::-moz-range-thumb{transform:scale(.667);background:rgba(0,0,0,.26)}.mdl-slider.is-upgraded:disabled+.mdl-slider__background-flex>.mdl-slider__background-lower{background-color:rgba(0,0,0,.26);left:-6px}.mdl-slider.is-upgraded:disabled+.mdl-slider__background-flex>.mdl-slider__background-upper{left:6px}.mdl-slider.is-upgraded.is-lowest-value:disabled::-webkit-slider-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:active::-webkit-slider-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:focus::-webkit-slider-thumb{border:3px solid rgba(0,0,0,.26);background:0 0;-webkit-transform:scale(.667);transform:scale(.667)}.mdl-slider.is-upgraded.is-lowest-value:disabled::-moz-range-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:active::-moz-range-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:focus::-moz-range-thumb{border:3px solid rgba(0,0,0,.26);background:0 0;transform:scale(.667)}.mdl-slider.is-upgraded.is-lowest-value:disabled:active+.mdl-slider__background-flex>.mdl-slider__background-upper{left:6px}.mdl-slider.is-upgraded:disabled::-ms-thumb,.mdl-slider.is-upgraded:disabled:active::-ms-thumb,.mdl-slider.is-upgraded:disabled:focus::-ms-thumb{transform:scale(.25);background:rgba(0,0,0,.26)}.mdl-slider.is-upgraded.is-lowest-value:disabled::-ms-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:active::-ms-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:focus::-ms-thumb{transform:scale(.25);background:radial-gradient(circle closest-side,transparent 0,transparent 50%,rgba(0,0,0,.26)50%,rgba(0,0,0,.26)100%)}.mdl-slider.is-upgraded:disabled::-ms-fill-lower{margin-right:6px;background:linear-gradient(90deg,transparent,transparent 25px,rgba(0,0,0,.26)25px,rgba(0,0,0,.26)0)}.mdl-slider.is-upgraded.is-lowest-value:disabled:active::-ms-fill-upper,.mdl-slider.is-upgraded:disabled::-ms-fill-upper{margin-left:6px}.mdl-slider__ie-container{height:18px;overflow:visible;border:none;margin:none;padding:none}.mdl-slider__container{height:18px;position:relative;-ms-flex-direction:row;flex-direction:row}.mdl-slider__background-flex,.mdl-slider__container{background:0 0;display:-ms-flexbox;display:flex}.mdl-slider__background-flex{position:absolute;height:2px;width:calc(100% - 52px);top:50%;left:0;margin:0 26px;overflow:hidden;border:0;padding:0;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.mdl-slider__background-lower{background:#3f51b5}.mdl-slider__background-lower,.mdl-slider__background-upper{-ms-flex:0;flex:0;position:relative;border:0;padding:0}.mdl-slider__background-upper{background:rgba(0,0,0,.26);transition:left .18s cubic-bezier(.4,0,.2,1)}.mdl-snackbar{position:fixed;bottom:0;left:50%;cursor:default;background-color:#323232;z-index:3;display:block;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;font-family:Roboto,Helvetica,Arial,sans-serif;will-change:transform;-webkit-transform:translateY(80px);transform:translateY(80px);transition:transform .25s cubic-bezier(.4,0,1,1);transition:transform .25s cubic-bezier(.4,0,1,1),-webkit-transform .25s cubic-bezier(.4,0,1,1);pointer-events:none}@media (max-width:479px){.mdl-snackbar{width:100%;left:0;min-height:48px;max-height:80px}}@media (min-width:480px){.mdl-snackbar{min-width:288px;max-width:568px;border-radius:2px;-webkit-transform:translate(-50%,80px);transform:translate(-50%,80px)}}.mdl-snackbar--active{-webkit-transform:translate(0);transform:translate(0);pointer-events:auto;transition:transform .25s cubic-bezier(0,0,.2,1);transition:transform .25s cubic-bezier(0,0,.2,1),-webkit-transform .25s cubic-bezier(0,0,.2,1)}@media (min-width:480px){.mdl-snackbar--active{-webkit-transform:translate(-50%);transform:translate(-50%)}}.mdl-snackbar__text{padding:14px 12px 14px 24px;vertical-align:middle;color:#fff;float:left}.mdl-snackbar__action{background:0 0;border:none;color:#ff4081;float:right;padding:14px 24px 14px 12px;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase;line-height:1;letter-spacing:0;overflow:hidden;outline:none;opacity:0;pointer-events:none;cursor:pointer;text-decoration:none;text-align:center;-ms-flex-item-align:center;align-self:center}.mdl-snackbar__action::-moz-focus-inner{border:0}.mdl-snackbar__action:not([aria-hidden]){opacity:1;pointer-events:auto}.mdl-spinner{display:inline-block;position:relative;width:28px;height:28px}.mdl-spinner:not(.is-upgraded).is-active:after{content:\"Loading...\"}.mdl-spinner.is-upgraded.is-active{-webkit-animation:mdl-spinner__container-rotate 1.56823529412s linear infinite;animation:mdl-spinner__container-rotate 1.56823529412s linear infinite}@-webkit-keyframes mdl-spinner__container-rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes mdl-spinner__container-rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.mdl-spinner__layer{position:absolute;width:100%;height:100%;opacity:0}.mdl-spinner__layer-1{border-color:#42a5f5}.mdl-spinner--single-color .mdl-spinner__layer-1{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-1{-webkit-animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both;animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both}.mdl-spinner__layer-2{border-color:#f44336}.mdl-spinner--single-color .mdl-spinner__layer-2{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-2{-webkit-animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both;animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both}.mdl-spinner__layer-3{border-color:#fdd835}.mdl-spinner--single-color .mdl-spinner__layer-3{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-3{-webkit-animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both;animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both}.mdl-spinner__layer-4{border-color:#4caf50}.mdl-spinner--single-color .mdl-spinner__layer-4{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-4{-webkit-animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both;animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both}@-webkit-keyframes mdl-spinner__fill-unfill-rotate{12.5%{-webkit-transform:rotate(135deg);transform:rotate(135deg)}25%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}37.5%{-webkit-transform:rotate(405deg);transform:rotate(405deg)}50%{-webkit-transform:rotate(540deg);transform:rotate(540deg)}62.5%{-webkit-transform:rotate(675deg);transform:rotate(675deg)}75%{-webkit-transform:rotate(810deg);transform:rotate(810deg)}87.5%{-webkit-transform:rotate(945deg);transform:rotate(945deg)}to{-webkit-transform:rotate(3turn);transform:rotate(3turn)}}@keyframes mdl-spinner__fill-unfill-rotate{12.5%{-webkit-transform:rotate(135deg);transform:rotate(135deg)}25%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}37.5%{-webkit-transform:rotate(405deg);transform:rotate(405deg)}50%{-webkit-transform:rotate(540deg);transform:rotate(540deg)}62.5%{-webkit-transform:rotate(675deg);transform:rotate(675deg)}75%{-webkit-transform:rotate(810deg);transform:rotate(810deg)}87.5%{-webkit-transform:rotate(945deg);transform:rotate(945deg)}to{-webkit-transform:rotate(3turn);transform:rotate(3turn)}}@-webkit-keyframes mdl-spinner__layer-1-fade-in-out{0%,25%{opacity:.99}26%,89%{opacity:0}90%,to{opacity:.99}}@keyframes mdl-spinner__layer-1-fade-in-out{0%,25%{opacity:.99}26%,89%{opacity:0}90%,to{opacity:.99}}@-webkit-keyframes mdl-spinner__layer-2-fade-in-out{0%,15%{opacity:0}25%,50%{opacity:.99}51%{opacity:0}}@keyframes mdl-spinner__layer-2-fade-in-out{0%,15%{opacity:0}25%,50%{opacity:.99}51%{opacity:0}}@-webkit-keyframes mdl-spinner__layer-3-fade-in-out{0%,40%{opacity:0}50%,75%{opacity:.99}76%{opacity:0}}@keyframes mdl-spinner__layer-3-fade-in-out{0%,40%{opacity:0}50%,75%{opacity:.99}76%{opacity:0}}@-webkit-keyframes mdl-spinner__layer-4-fade-in-out{0%,65%{opacity:0}75%,90%{opacity:.99}to{opacity:0}}@keyframes mdl-spinner__layer-4-fade-in-out{0%,65%{opacity:0}75%,90%{opacity:.99}to{opacity:0}}.mdl-spinner__gap-patch{position:absolute;box-sizing:border-box;top:0;left:45%;width:10%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__gap-patch .mdl-spinner__circle{width:1000%;left:-450%}.mdl-spinner__circle-clipper{display:inline-block;position:relative;width:50%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__circle-clipper .mdl-spinner__circle{width:200%}.mdl-spinner__circle{box-sizing:border-box;height:100%;border-width:3px;border-style:solid;border-color:inherit;border-bottom-color:transparent!important;border-radius:50%;-webkit-animation:none;animation:none;position:absolute;top:0;right:0;bottom:0;left:0}.mdl-spinner__left .mdl-spinner__circle{border-right-color:transparent!important;-webkit-transform:rotate(129deg);transform:rotate(129deg)}.mdl-spinner.is-active .mdl-spinner__left .mdl-spinner__circle{-webkit-animation:mdl-spinner__left-spin 1333ms cubic-bezier(.4,0,.2,1)infinite both;animation:mdl-spinner__left-spin 1333ms cubic-bezier(.4,0,.2,1)infinite both}.mdl-spinner__right .mdl-spinner__circle{left:-100%;border-left-color:transparent!important;-webkit-transform:rotate(-129deg);transform:rotate(-129deg)}.mdl-spinner.is-active .mdl-spinner__right .mdl-spinner__circle{-webkit-animation:mdl-spinner__right-spin 1333ms cubic-bezier(.4,0,.2,1)infinite both;animation:mdl-spinner__right-spin 1333ms cubic-bezier(.4,0,.2,1)infinite both}@-webkit-keyframes mdl-spinner__left-spin{0%{-webkit-transform:rotate(130deg);transform:rotate(130deg)}50%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(130deg);transform:rotate(130deg)}}@keyframes mdl-spinner__left-spin{0%{-webkit-transform:rotate(130deg);transform:rotate(130deg)}50%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(130deg);transform:rotate(130deg)}}@-webkit-keyframes mdl-spinner__right-spin{0%{-webkit-transform:rotate(-130deg);transform:rotate(-130deg)}50%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}to{-webkit-transform:rotate(-130deg);transform:rotate(-130deg)}}@keyframes mdl-spinner__right-spin{0%{-webkit-transform:rotate(-130deg);transform:rotate(-130deg)}50%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}to{-webkit-transform:rotate(-130deg);transform:rotate(-130deg)}}.mdl-switch{position:relative;z-index:1;vertical-align:middle;display:inline-block;box-sizing:border-box;width:100%;height:24px;margin:0;padding:0;overflow:visible;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mdl-switch.is-upgraded{padding-left:28px}.mdl-switch__input{line-height:24px}.mdl-switch.is-upgraded .mdl-switch__input{position:absolute;width:0;height:0;margin:0;padding:0;opacity:0;-ms-appearance:none;-moz-appearance:none;-webkit-appearance:none;appearance:none;border:none}.mdl-switch__track{background:rgba(0,0,0,.26);position:absolute;left:0;top:5px;height:14px;width:36px;border-radius:14px;cursor:pointer}.mdl-switch.is-checked .mdl-switch__track{background:rgba(63,81,181,.5)}.mdl-switch.is-disabled .mdl-switch__track,.mdl-switch__track fieldset[disabled] .mdl-switch{background:rgba(0,0,0,.12);cursor:auto}.mdl-switch__thumb{background:#fafafa;position:absolute;left:0;top:2px;height:20px;width:20px;border-radius:50%;cursor:pointer;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:left}.mdl-switch.is-checked .mdl-switch__thumb{background:#3f51b5;left:16px;box-shadow:0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.2),0 1px 8px 0 rgba(0,0,0,.12)}.mdl-switch.is-disabled .mdl-switch__thumb,.mdl-switch__thumb fieldset[disabled] .mdl-switch{background:#bdbdbd;cursor:auto}.mdl-switch__focus-helper{position:absolute;top:50%;left:50%;-webkit-transform:translate(-4px,-4px);transform:translate(-4px,-4px);display:inline-block;box-sizing:border-box;width:8px;height:8px;border-radius:50%;background-color:transparent}.mdl-switch.is-focused .mdl-switch__focus-helper{box-shadow:0 0 0 20px rgba(0,0,0,.1);background-color:rgba(0,0,0,.1)}.mdl-switch.is-focused.is-checked .mdl-switch__focus-helper{box-shadow:0 0 0 20px rgba(63,81,181,.26);background-color:rgba(63,81,181,.26)}.mdl-switch__label{position:relative;cursor:pointer;font-size:16px;line-height:24px;margin:0;left:24px}.mdl-switch.is-disabled .mdl-switch__label,.mdl-switch__label fieldset[disabled] .mdl-switch{color:#bdbdbd;cursor:auto}.mdl-switch__ripple-container{position:absolute;z-index:2;top:-12px;left:-14px;box-sizing:border-box;width:48px;height:48px;border-radius:50%;cursor:pointer;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000);transition-duration:.4s;transition-timing-function:step-end;transition-property:left}.mdl-switch__ripple-container .mdl-ripple{background:#3f51b5}.mdl-switch.is-disabled .mdl-switch__ripple-container,.mdl-switch__ripple-container fieldset[disabled] .mdl-switch{cursor:auto}.mdl-switch.is-disabled .mdl-switch__ripple-container .mdl-ripple,fieldset[disabled] .mdl-switch .mdl-switch__ripple-container .mdl-ripple{background:0 0}.mdl-switch.is-checked .mdl-switch__ripple-container{left:2px}.mdl-tabs{display:block;width:100%}.mdl-tabs__tab-bar{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-ms-flex-align:start;align-items:flex-start;height:48px;padding:0;margin:0;border-bottom:1px solid #e0e0e0}.mdl-tabs__tab{margin:0;border:none;padding:0 24px;float:left;position:relative;display:block;text-decoration:none;height:48px;line-height:48px;text-align:center;font-weight:500;font-size:14px;text-transform:uppercase;color:rgba(0,0,0,.54);overflow:hidden}.mdl-tabs.is-upgraded .mdl-tabs__tab.is-active{color:rgba(0,0,0,.87)}.mdl-tabs.is-upgraded .mdl-tabs__tab.is-active:after{height:2px;width:100%;display:block;content:\" \";bottom:0;left:0;position:absolute;background:#3f51b5;-webkit-animation:border-expand .2s cubic-bezier(.4,0,.4,1).01s alternate forwards;animation:border-expand .2s cubic-bezier(.4,0,.4,1).01s alternate forwards;transition:all 1s cubic-bezier(.4,0,1,1)}.mdl-tabs__tab .mdl-tabs__ripple-container{display:block;position:absolute;height:100%;width:100%;left:0;top:0;z-index:1;overflow:hidden}.mdl-tabs__tab .mdl-tabs__ripple-container .mdl-ripple{background:#3f51b5}.mdl-tabs__panel{display:block}.mdl-tabs.is-upgraded .mdl-tabs__panel{display:none}.mdl-tabs.is-upgraded .mdl-tabs__panel.is-active{display:block}@-webkit-keyframes border-expand{0%{opacity:0;width:0}to{opacity:1;width:100%}}@keyframes border-expand{0%{opacity:0;width:0}to{opacity:1;width:100%}}.mdl-textfield{position:relative;font-size:16px;display:inline-block;box-sizing:border-box;width:300px;max-width:100%;margin:0;padding:20px 0}.mdl-textfield .mdl-button{position:absolute;bottom:20px}.mdl-textfield--align-right{text-align:right}.mdl-textfield--full-width{width:100%}.mdl-textfield--expandable{min-width:32px;width:auto;min-height:32px}.mdl-textfield--expandable .mdl-button--icon{top:16px}.mdl-textfield__input{border:none;border-bottom:1px solid rgba(0,0,0,.12);display:block;font-size:16px;font-family:Helvetica,Arial,sans-serif;margin:0;padding:4px 0;width:100%;background:0 0;text-align:left;color:inherit}.mdl-textfield__input[type=number]{-moz-appearance:textfield}.mdl-textfield__input[type=number]::-webkit-inner-spin-button,.mdl-textfield__input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.mdl-textfield.is-focused .mdl-textfield__input{outline:none}.mdl-textfield.is-invalid .mdl-textfield__input{border-color:#d50000;box-shadow:none}.mdl-textfield.is-disabled .mdl-textfield__input,fieldset[disabled] .mdl-textfield .mdl-textfield__input{background-color:transparent;border-bottom:1px dotted rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-textfield textarea.mdl-textfield__input{display:block}.mdl-textfield__label{bottom:0;color:rgba(0,0,0,.26);font-size:16px;left:0;right:0;pointer-events:none;position:absolute;display:block;top:24px;width:100%;overflow:hidden;white-space:nowrap;text-align:left}.mdl-textfield.has-placeholder .mdl-textfield__label,.mdl-textfield.is-dirty .mdl-textfield__label{visibility:hidden}.mdl-textfield--floating-label .mdl-textfield__label{transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label{transition:none}.mdl-textfield.is-disabled.is-disabled .mdl-textfield__label,fieldset[disabled] .mdl-textfield .mdl-textfield__label{color:rgba(0,0,0,.26)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#3f51b5;font-size:12px;top:4px;visibility:visible}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__expandable-holder .mdl-textfield__label{top:-16px}.mdl-textfield--floating-label.is-invalid .mdl-textfield__label{color:#d50000;font-size:12px}.mdl-textfield__label:after{background-color:#3f51b5;bottom:20px;content:'';height:2px;left:45%;position:absolute;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);visibility:hidden;width:10px}.mdl-textfield.is-focused .mdl-textfield__label:after{left:0;visibility:visible;width:100%}.mdl-textfield.is-invalid .mdl-textfield__label:after{background-color:#d50000}.mdl-textfield__error{color:#d50000;position:absolute;font-size:12px;margin-top:3px;visibility:hidden;display:block}.mdl-textfield.is-invalid .mdl-textfield__error{visibility:visible}.mdl-textfield__expandable-holder{position:relative;margin-left:32px;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);display:inline-block;max-width:.1px}.mdl-textfield.is-dirty .mdl-textfield__expandable-holder,.mdl-textfield.is-focused .mdl-textfield__expandable-holder{max-width:600px}.mdl-textfield__expandable-holder .mdl-textfield__label:after{bottom:0}.mdl-tooltip{-webkit-transform:scale(0);transform:scale(0);-webkit-transform-origin:top center;transform-origin:top center;z-index:999;background:rgba(97,97,97,.9);border-radius:2px;color:#fff;display:inline-block;font-size:10px;font-weight:500;line-height:14px;max-width:170px;position:fixed;top:-500px;left:-500px;padding:8px;text-align:center}.mdl-tooltip.is-active{-webkit-animation:pulse .2s cubic-bezier(0,0,.2,1)forwards;animation:pulse .2s cubic-bezier(0,0,.2,1)forwards}.mdl-tooltip--large{line-height:14px;font-size:14px;padding:16px}@-webkit-keyframes pulse{0%{-webkit-transform:scale(0);transform:scale(0);opacity:0}50%{-webkit-transform:scale(.99);transform:scale(.99)}to{-webkit-transform:scale(1);transform:scale(1);opacity:1;visibility:visible}}@keyframes pulse{0%{-webkit-transform:scale(0);transform:scale(0);opacity:0}50%{-webkit-transform:scale(.99);transform:scale(.99)}to{-webkit-transform:scale(1);transform:scale(1);opacity:1;visibility:visible}}.mdl-shadow--2dp{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-shadow--3dp{box-shadow:0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.2),0 1px 8px 0 rgba(0,0,0,.12)}.mdl-shadow--4dp{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2)}.mdl-shadow--6dp{box-shadow:0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12),0 3px 5px -1px rgba(0,0,0,.2)}.mdl-shadow--8dp{box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2)}.mdl-shadow--16dp{box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.mdl-shadow--24dp{box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2)}.mdl-grid{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;margin:0 auto;-ms-flex-align:stretch;align-items:stretch}.mdl-grid.mdl-grid--no-spacing{padding:0}.mdl-cell{box-sizing:border-box}.mdl-cell--top{-ms-flex-item-align:start;align-self:flex-start}.mdl-cell--middle{-ms-flex-item-align:center;align-self:center}.mdl-cell--bottom{-ms-flex-item-align:end;align-self:flex-end}.mdl-cell--stretch{-ms-flex-item-align:stretch;align-self:stretch}.mdl-grid.mdl-grid--no-spacing>.mdl-cell{margin:0}.mdl-cell--order-1{-ms-flex-order:1;order:1}.mdl-cell--order-2{-ms-flex-order:2;order:2}.mdl-cell--order-3{-ms-flex-order:3;order:3}.mdl-cell--order-4{-ms-flex-order:4;order:4}.mdl-cell--order-5{-ms-flex-order:5;order:5}.mdl-cell--order-6{-ms-flex-order:6;order:6}.mdl-cell--order-7{-ms-flex-order:7;order:7}.mdl-cell--order-8{-ms-flex-order:8;order:8}.mdl-cell--order-9{-ms-flex-order:9;order:9}.mdl-cell--order-10{-ms-flex-order:10;order:10}.mdl-cell--order-11{-ms-flex-order:11;order:11}.mdl-cell--order-12{-ms-flex-order:12;order:12}@media (max-width:479px){.mdl-grid{padding:8px}.mdl-cell{margin:8px;width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell{width:100%}.mdl-cell--hide-phone{display:none!important}.mdl-cell--order-1-phone.mdl-cell--order-1-phone{-ms-flex-order:1;order:1}.mdl-cell--order-2-phone.mdl-cell--order-2-phone{-ms-flex-order:2;order:2}.mdl-cell--order-3-phone.mdl-cell--order-3-phone{-ms-flex-order:3;order:3}.mdl-cell--order-4-phone.mdl-cell--order-4-phone{-ms-flex-order:4;order:4}.mdl-cell--order-5-phone.mdl-cell--order-5-phone{-ms-flex-order:5;order:5}.mdl-cell--order-6-phone.mdl-cell--order-6-phone{-ms-flex-order:6;order:6}.mdl-cell--order-7-phone.mdl-cell--order-7-phone{-ms-flex-order:7;order:7}.mdl-cell--order-8-phone.mdl-cell--order-8-phone{-ms-flex-order:8;order:8}.mdl-cell--order-9-phone.mdl-cell--order-9-phone{-ms-flex-order:9;order:9}.mdl-cell--order-10-phone.mdl-cell--order-10-phone{-ms-flex-order:10;order:10}.mdl-cell--order-11-phone.mdl-cell--order-11-phone{-ms-flex-order:11;order:11}.mdl-cell--order-12-phone.mdl-cell--order-12-phone{-ms-flex-order:12;order:12}.mdl-cell--1-col,.mdl-cell--1-col-phone.mdl-cell--1-col-phone{width:calc(25% - 16px)}.mdl-grid--no-spacing>.mdl-cell--1-col,.mdl-grid--no-spacing>.mdl-cell--1-col-phone.mdl-cell--1-col-phone{width:25%}.mdl-cell--2-col,.mdl-cell--2-col-phone.mdl-cell--2-col-phone{width:calc(50% - 16px)}.mdl-grid--no-spacing>.mdl-cell--2-col,.mdl-grid--no-spacing>.mdl-cell--2-col-phone.mdl-cell--2-col-phone{width:50%}.mdl-cell--3-col,.mdl-cell--3-col-phone.mdl-cell--3-col-phone{width:calc(75% - 16px)}.mdl-grid--no-spacing>.mdl-cell--3-col,.mdl-grid--no-spacing>.mdl-cell--3-col-phone.mdl-cell--3-col-phone{width:75%}.mdl-cell--4-col,.mdl-cell--4-col-phone.mdl-cell--4-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--4-col,.mdl-grid--no-spacing>.mdl-cell--4-col-phone.mdl-cell--4-col-phone{width:100%}.mdl-cell--5-col,.mdl-cell--5-col-phone.mdl-cell--5-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--5-col,.mdl-grid--no-spacing>.mdl-cell--5-col-phone.mdl-cell--5-col-phone{width:100%}.mdl-cell--6-col,.mdl-cell--6-col-phone.mdl-cell--6-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--6-col,.mdl-grid--no-spacing>.mdl-cell--6-col-phone.mdl-cell--6-col-phone{width:100%}.mdl-cell--7-col,.mdl-cell--7-col-phone.mdl-cell--7-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--7-col,.mdl-grid--no-spacing>.mdl-cell--7-col-phone.mdl-cell--7-col-phone{width:100%}.mdl-cell--8-col,.mdl-cell--8-col-phone.mdl-cell--8-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--8-col,.mdl-grid--no-spacing>.mdl-cell--8-col-phone.mdl-cell--8-col-phone{width:100%}.mdl-cell--9-col,.mdl-cell--9-col-phone.mdl-cell--9-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--9-col,.mdl-grid--no-spacing>.mdl-cell--9-col-phone.mdl-cell--9-col-phone{width:100%}.mdl-cell--10-col,.mdl-cell--10-col-phone.mdl-cell--10-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--10-col,.mdl-grid--no-spacing>.mdl-cell--10-col-phone.mdl-cell--10-col-phone{width:100%}.mdl-cell--11-col,.mdl-cell--11-col-phone.mdl-cell--11-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--11-col,.mdl-grid--no-spacing>.mdl-cell--11-col-phone.mdl-cell--11-col-phone{width:100%}.mdl-cell--12-col,.mdl-cell--12-col-phone.mdl-cell--12-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--12-col,.mdl-grid--no-spacing>.mdl-cell--12-col-phone.mdl-cell--12-col-phone{width:100%}.mdl-cell--1-offset,.mdl-cell--1-offset-phone.mdl-cell--1-offset-phone{margin-left:calc(25% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset-phone.mdl-cell--1-offset-phone{margin-left:25%}.mdl-cell--2-offset,.mdl-cell--2-offset-phone.mdl-cell--2-offset-phone{margin-left:calc(50% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset-phone.mdl-cell--2-offset-phone{margin-left:50%}.mdl-cell--3-offset,.mdl-cell--3-offset-phone.mdl-cell--3-offset-phone{margin-left:calc(75% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset-phone.mdl-cell--3-offset-phone{margin-left:75%}}@media (min-width:480px) and (max-width:839px){.mdl-grid{padding:8px}.mdl-cell{margin:8px;width:calc(50% - 16px)}.mdl-grid--no-spacing>.mdl-cell{width:50%}.mdl-cell--hide-tablet{display:none!important}.mdl-cell--order-1-tablet.mdl-cell--order-1-tablet{-ms-flex-order:1;order:1}.mdl-cell--order-2-tablet.mdl-cell--order-2-tablet{-ms-flex-order:2;order:2}.mdl-cell--order-3-tablet.mdl-cell--order-3-tablet{-ms-flex-order:3;order:3}.mdl-cell--order-4-tablet.mdl-cell--order-4-tablet{-ms-flex-order:4;order:4}.mdl-cell--order-5-tablet.mdl-cell--order-5-tablet{-ms-flex-order:5;order:5}.mdl-cell--order-6-tablet.mdl-cell--order-6-tablet{-ms-flex-order:6;order:6}.mdl-cell--order-7-tablet.mdl-cell--order-7-tablet{-ms-flex-order:7;order:7}.mdl-cell--order-8-tablet.mdl-cell--order-8-tablet{-ms-flex-order:8;order:8}.mdl-cell--order-9-tablet.mdl-cell--order-9-tablet{-ms-flex-order:9;order:9}.mdl-cell--order-10-tablet.mdl-cell--order-10-tablet{-ms-flex-order:10;order:10}.mdl-cell--order-11-tablet.mdl-cell--order-11-tablet{-ms-flex-order:11;order:11}.mdl-cell--order-12-tablet.mdl-cell--order-12-tablet{-ms-flex-order:12;order:12}.mdl-cell--1-col,.mdl-cell--1-col-tablet.mdl-cell--1-col-tablet{width:calc(12.5% - 16px)}.mdl-grid--no-spacing>.mdl-cell--1-col,.mdl-grid--no-spacing>.mdl-cell--1-col-tablet.mdl-cell--1-col-tablet{width:12.5%}.mdl-cell--2-col,.mdl-cell--2-col-tablet.mdl-cell--2-col-tablet{width:calc(25% - 16px)}.mdl-grid--no-spacing>.mdl-cell--2-col,.mdl-grid--no-spacing>.mdl-cell--2-col-tablet.mdl-cell--2-col-tablet{width:25%}.mdl-cell--3-col,.mdl-cell--3-col-tablet.mdl-cell--3-col-tablet{width:calc(37.5% - 16px)}.mdl-grid--no-spacing>.mdl-cell--3-col,.mdl-grid--no-spacing>.mdl-cell--3-col-tablet.mdl-cell--3-col-tablet{width:37.5%}.mdl-cell--4-col,.mdl-cell--4-col-tablet.mdl-cell--4-col-tablet{width:calc(50% - 16px)}.mdl-grid--no-spacing>.mdl-cell--4-col,.mdl-grid--no-spacing>.mdl-cell--4-col-tablet.mdl-cell--4-col-tablet{width:50%}.mdl-cell--5-col,.mdl-cell--5-col-tablet.mdl-cell--5-col-tablet{width:calc(62.5% - 16px)}.mdl-grid--no-spacing>.mdl-cell--5-col,.mdl-grid--no-spacing>.mdl-cell--5-col-tablet.mdl-cell--5-col-tablet{width:62.5%}.mdl-cell--6-col,.mdl-cell--6-col-tablet.mdl-cell--6-col-tablet{width:calc(75% - 16px)}.mdl-grid--no-spacing>.mdl-cell--6-col,.mdl-grid--no-spacing>.mdl-cell--6-col-tablet.mdl-cell--6-col-tablet{width:75%}.mdl-cell--7-col,.mdl-cell--7-col-tablet.mdl-cell--7-col-tablet{width:calc(87.5% - 16px)}.mdl-grid--no-spacing>.mdl-cell--7-col,.mdl-grid--no-spacing>.mdl-cell--7-col-tablet.mdl-cell--7-col-tablet{width:87.5%}.mdl-cell--8-col,.mdl-cell--8-col-tablet.mdl-cell--8-col-tablet{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--8-col,.mdl-grid--no-spacing>.mdl-cell--8-col-tablet.mdl-cell--8-col-tablet{width:100%}.mdl-cell--9-col,.mdl-cell--9-col-tablet.mdl-cell--9-col-tablet{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--9-col,.mdl-grid--no-spacing>.mdl-cell--9-col-tablet.mdl-cell--9-col-tablet{width:100%}.mdl-cell--10-col,.mdl-cell--10-col-tablet.mdl-cell--10-col-tablet{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--10-col,.mdl-grid--no-spacing>.mdl-cell--10-col-tablet.mdl-cell--10-col-tablet{width:100%}.mdl-cell--11-col,.mdl-cell--11-col-tablet.mdl-cell--11-col-tablet{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--11-col,.mdl-grid--no-spacing>.mdl-cell--11-col-tablet.mdl-cell--11-col-tablet{width:100%}.mdl-cell--12-col,.mdl-cell--12-col-tablet.mdl-cell--12-col-tablet{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--12-col,.mdl-grid--no-spacing>.mdl-cell--12-col-tablet.mdl-cell--12-col-tablet{width:100%}.mdl-cell--1-offset,.mdl-cell--1-offset-tablet.mdl-cell--1-offset-tablet{margin-left:calc(12.5% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset-tablet.mdl-cell--1-offset-tablet{margin-left:12.5%}.mdl-cell--2-offset,.mdl-cell--2-offset-tablet.mdl-cell--2-offset-tablet{margin-left:calc(25% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset-tablet.mdl-cell--2-offset-tablet{margin-left:25%}.mdl-cell--3-offset,.mdl-cell--3-offset-tablet.mdl-cell--3-offset-tablet{margin-left:calc(37.5% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset-tablet.mdl-cell--3-offset-tablet{margin-left:37.5%}.mdl-cell--4-offset,.mdl-cell--4-offset-tablet.mdl-cell--4-offset-tablet{margin-left:calc(50% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--4-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--4-offset-tablet.mdl-cell--4-offset-tablet{margin-left:50%}.mdl-cell--5-offset,.mdl-cell--5-offset-tablet.mdl-cell--5-offset-tablet{margin-left:calc(62.5% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--5-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--5-offset-tablet.mdl-cell--5-offset-tablet{margin-left:62.5%}.mdl-cell--6-offset,.mdl-cell--6-offset-tablet.mdl-cell--6-offset-tablet{margin-left:calc(75% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--6-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--6-offset-tablet.mdl-cell--6-offset-tablet{margin-left:75%}.mdl-cell--7-offset,.mdl-cell--7-offset-tablet.mdl-cell--7-offset-tablet{margin-left:calc(87.5% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--7-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--7-offset-tablet.mdl-cell--7-offset-tablet{margin-left:87.5%}}@media (min-width:840px){.mdl-grid{padding:8px}.mdl-cell{margin:8px;width:calc(33.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell{width:33.3333333333%}.mdl-cell--hide-desktop{display:none!important}.mdl-cell--order-1-desktop.mdl-cell--order-1-desktop{-ms-flex-order:1;order:1}.mdl-cell--order-2-desktop.mdl-cell--order-2-desktop{-ms-flex-order:2;order:2}.mdl-cell--order-3-desktop.mdl-cell--order-3-desktop{-ms-flex-order:3;order:3}.mdl-cell--order-4-desktop.mdl-cell--order-4-desktop{-ms-flex-order:4;order:4}.mdl-cell--order-5-desktop.mdl-cell--order-5-desktop{-ms-flex-order:5;order:5}.mdl-cell--order-6-desktop.mdl-cell--order-6-desktop{-ms-flex-order:6;order:6}.mdl-cell--order-7-desktop.mdl-cell--order-7-desktop{-ms-flex-order:7;order:7}.mdl-cell--order-8-desktop.mdl-cell--order-8-desktop{-ms-flex-order:8;order:8}.mdl-cell--order-9-desktop.mdl-cell--order-9-desktop{-ms-flex-order:9;order:9}.mdl-cell--order-10-desktop.mdl-cell--order-10-desktop{-ms-flex-order:10;order:10}.mdl-cell--order-11-desktop.mdl-cell--order-11-desktop{-ms-flex-order:11;order:11}.mdl-cell--order-12-desktop.mdl-cell--order-12-desktop{-ms-flex-order:12;order:12}.mdl-cell--1-col,.mdl-cell--1-col-desktop.mdl-cell--1-col-desktop{width:calc(8.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell--1-col,.mdl-grid--no-spacing>.mdl-cell--1-col-desktop.mdl-cell--1-col-desktop{width:8.3333333333%}.mdl-cell--2-col,.mdl-cell--2-col-desktop.mdl-cell--2-col-desktop{width:calc(16.6666666667% - 16px)}.mdl-grid--no-spacing>.mdl-cell--2-col,.mdl-grid--no-spacing>.mdl-cell--2-col-desktop.mdl-cell--2-col-desktop{width:16.6666666667%}.mdl-cell--3-col,.mdl-cell--3-col-desktop.mdl-cell--3-col-desktop{width:calc(25% - 16px)}.mdl-grid--no-spacing>.mdl-cell--3-col,.mdl-grid--no-spacing>.mdl-cell--3-col-desktop.mdl-cell--3-col-desktop{width:25%}.mdl-cell--4-col,.mdl-cell--4-col-desktop.mdl-cell--4-col-desktop{width:calc(33.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell--4-col,.mdl-grid--no-spacing>.mdl-cell--4-col-desktop.mdl-cell--4-col-desktop{width:33.3333333333%}.mdl-cell--5-col,.mdl-cell--5-col-desktop.mdl-cell--5-col-desktop{width:calc(41.6666666667% - 16px)}.mdl-grid--no-spacing>.mdl-cell--5-col,.mdl-grid--no-spacing>.mdl-cell--5-col-desktop.mdl-cell--5-col-desktop{width:41.6666666667%}.mdl-cell--6-col,.mdl-cell--6-col-desktop.mdl-cell--6-col-desktop{width:calc(50% - 16px)}.mdl-grid--no-spacing>.mdl-cell--6-col,.mdl-grid--no-spacing>.mdl-cell--6-col-desktop.mdl-cell--6-col-desktop{width:50%}.mdl-cell--7-col,.mdl-cell--7-col-desktop.mdl-cell--7-col-desktop{width:calc(58.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell--7-col,.mdl-grid--no-spacing>.mdl-cell--7-col-desktop.mdl-cell--7-col-desktop{width:58.3333333333%}.mdl-cell--8-col,.mdl-cell--8-col-desktop.mdl-cell--8-col-desktop{width:calc(66.6666666667% - 16px)}.mdl-grid--no-spacing>.mdl-cell--8-col,.mdl-grid--no-spacing>.mdl-cell--8-col-desktop.mdl-cell--8-col-desktop{width:66.6666666667%}.mdl-cell--9-col,.mdl-cell--9-col-desktop.mdl-cell--9-col-desktop{width:calc(75% - 16px)}.mdl-grid--no-spacing>.mdl-cell--9-col,.mdl-grid--no-spacing>.mdl-cell--9-col-desktop.mdl-cell--9-col-desktop{width:75%}.mdl-cell--10-col,.mdl-cell--10-col-desktop.mdl-cell--10-col-desktop{width:calc(83.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell--10-col,.mdl-grid--no-spacing>.mdl-cell--10-col-desktop.mdl-cell--10-col-desktop{width:83.3333333333%}.mdl-cell--11-col,.mdl-cell--11-col-desktop.mdl-cell--11-col-desktop{width:calc(91.6666666667% - 16px)}.mdl-grid--no-spacing>.mdl-cell--11-col,.mdl-grid--no-spacing>.mdl-cell--11-col-desktop.mdl-cell--11-col-desktop{width:91.6666666667%}.mdl-cell--12-col,.mdl-cell--12-col-desktop.mdl-cell--12-col-desktop{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--12-col,.mdl-grid--no-spacing>.mdl-cell--12-col-desktop.mdl-cell--12-col-desktop{width:100%}.mdl-cell--1-offset,.mdl-cell--1-offset-desktop.mdl-cell--1-offset-desktop{margin-left:calc(8.3333333333% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset-desktop.mdl-cell--1-offset-desktop{margin-left:8.3333333333%}.mdl-cell--2-offset,.mdl-cell--2-offset-desktop.mdl-cell--2-offset-desktop{margin-left:calc(16.6666666667% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset-desktop.mdl-cell--2-offset-desktop{margin-left:16.6666666667%}.mdl-cell--3-offset,.mdl-cell--3-offset-desktop.mdl-cell--3-offset-desktop{margin-left:calc(25% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset-desktop.mdl-cell--3-offset-desktop{margin-left:25%}.mdl-cell--4-offset,.mdl-cell--4-offset-desktop.mdl-cell--4-offset-desktop{margin-left:calc(33.3333333333% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--4-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--4-offset-desktop.mdl-cell--4-offset-desktop{margin-left:33.3333333333%}.mdl-cell--5-offset,.mdl-cell--5-offset-desktop.mdl-cell--5-offset-desktop{margin-left:calc(41.6666666667% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--5-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--5-offset-desktop.mdl-cell--5-offset-desktop{margin-left:41.6666666667%}.mdl-cell--6-offset,.mdl-cell--6-offset-desktop.mdl-cell--6-offset-desktop{margin-left:calc(50% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--6-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--6-offset-desktop.mdl-cell--6-offset-desktop{margin-left:50%}.mdl-cell--7-offset,.mdl-cell--7-offset-desktop.mdl-cell--7-offset-desktop{margin-left:calc(58.3333333333% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--7-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--7-offset-desktop.mdl-cell--7-offset-desktop{margin-left:58.3333333333%}.mdl-cell--8-offset,.mdl-cell--8-offset-desktop.mdl-cell--8-offset-desktop{margin-left:calc(66.6666666667% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--8-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--8-offset-desktop.mdl-cell--8-offset-desktop{margin-left:66.6666666667%}.mdl-cell--9-offset,.mdl-cell--9-offset-desktop.mdl-cell--9-offset-desktop{margin-left:calc(75% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--9-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--9-offset-desktop.mdl-cell--9-offset-desktop{margin-left:75%}.mdl-cell--10-offset,.mdl-cell--10-offset-desktop.mdl-cell--10-offset-desktop{margin-left:calc(83.3333333333% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--10-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--10-offset-desktop.mdl-cell--10-offset-desktop{margin-left:83.3333333333%}.mdl-cell--11-offset,.mdl-cell--11-offset-desktop.mdl-cell--11-offset-desktop{margin-left:calc(91.6666666667% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--11-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--11-offset-desktop.mdl-cell--11-offset-desktop{margin-left:91.6666666667%}}", ""]);
	
	// exports


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(271);
	var isArguments = __webpack_require__(270);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 270 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 271 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 272 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(272);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(281);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var createArrayFromMixed = __webpack_require__(275);
	var getMarkupWrap = __webpack_require__(140);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 277 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 278 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(278);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(280);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 282 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 283 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var performance;
	
	if (ExecutionEnvironment.canUseDOM) {
	  performance = window.performance || window.msPerformance || window.webkitPerformance;
	}
	
	module.exports = performance || {};

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var performance = __webpack_require__(284);
	
	var performanceNow;
	
	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (performance.now) {
	  performanceNow = function performanceNow() {
	    return performance.now();
	  };
	} else {
	  performanceNow = function performanceNow() {
	    return Date.now();
	  };
	}
	
	module.exports = performanceNow;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Firebase libraries for browser - npm package.
	 *
	 * Usage:
	 *
	 *   firebase = require('firebase');
	 */
	__webpack_require__(287);
	module.exports = firebase;


/***/ },
/* 287 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.3.0
	    Build: 3.3.0-rc.7
	    Terms: https://developers.google.com/terms */
	(function() { var aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(c.get||c.set)throw new TypeError("ES3 does not support getters and setters.");a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},h="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global?global:this,l=function(){l=function(){};h.Symbol||(h.Symbol=ba)},ca=0,ba=function(a){return"jscomp_symbol_"+(a||"")+ca++},p=function(){l();var a=h.Symbol.iterator;a||(a=h.Symbol.iterator=h.Symbol("iterator"));
	"function"!=typeof Array.prototype[a]&&aa(Array.prototype,a,{configurable:!0,writable:!0,value:function(){return m(this)}});p=function(){}},m=function(a){var b=0;return da(function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}})},da=function(a){p();a={next:a};a[h.Symbol.iterator]=function(){return this};return a},q=this,r=function(){},t=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);
	if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},u=function(a){return"function"==t(a)},ea=function(a,
	b,c){return a.call.apply(a.bind,arguments)},fa=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}},v=function(a,b,c){v=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ea:fa;return v.apply(null,arguments)},w=function(a,b){var c=Array.prototype.slice.call(arguments,
	1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}},x=function(a,b){function c(){}c.prototype=b.prototype;a.ga=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.fa=function(a,c,g){for(var f=Array(arguments.length-2),k=2;k<arguments.length;k++)f[k-2]=arguments[k];return b.prototype[c].apply(a,f)}};var y="undefined"!==typeof window?window:global;function __extends(a,b){function c(){this.constructor=a}for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d]);a.prototype=null===b?Object.create(b):(c.prototype=b.prototype,new c)}
	function __decorate(a,b,c,d){var e=arguments.length,g=3>e?b:null===d?d=Object.getOwnPropertyDescriptor(b,c):d,f;f=y.Reflect;if("object"===typeof f&&"function"===typeof f.decorate)g=f.decorate(a,b,c,d);else for(var k=a.length-1;0<=k;k--)if(f=a[k])g=(3>e?f(g):3<e?f(b,c,g):f(b,c))||g;return 3<e&&g&&Object.defineProperty(b,c,g),g}function __metadata(a,b){var c=y.Reflect;if("object"===typeof c&&"function"===typeof c.metadata)return c.metadata(a,b)}
	var __param=function(a,b){return function(c,d){b(c,d,a)}},__awaiter=function(a,b,c,d){return new (c||(c=Promise))(function(e,g){function f(a){try{n(d.next(a))}catch(b){g(b)}}function k(a){try{n(d.throw(a))}catch(b){g(b)}}function n(a){a.done?e(a.value):(new c(function(b){b(a.value)})).then(f,k)}n((d=d.apply(a,b)).next())})};"undefined"!==typeof y.L&&y.L||"undefined"===typeof global||(global.ca=__extends,global.ba=__decorate,global.da=__metadata,global.ea=__param,global.aa=__awaiter);var z=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,z);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};x(z,Error);z.prototype.name="CustomError";var ga=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")};var A=function(a,b){b.unshift(a);z.call(this,ga.apply(null,b));b.shift()};x(A,z);A.prototype.name="AssertionError";var ha=function(a,b,c,d){var e="Assertion failed";if(c)var e=e+(": "+c),g=d;else a&&(e+=": "+a,g=b);throw new A(""+e,g||[]);},B=function(a,b,c){a||ha("",null,b,Array.prototype.slice.call(arguments,2))},C=function(a,b,c){u(a)||ha("Expected function but got %s: %s.",[t(a),a],b,Array.prototype.slice.call(arguments,2))};var D=function(a,b,c){this.S=c;this.M=a;this.U=b;this.s=0;this.o=null};D.prototype.get=function(){var a;0<this.s?(this.s--,a=this.o,this.o=a.next,a.next=null):a=this.M();return a};D.prototype.put=function(a){this.U(a);this.s<this.S&&(this.s++,a.next=this.o,this.o=a)};var E;a:{var ia=q.navigator;if(ia){var ja=ia.userAgent;if(ja){E=ja;break a}}E=""};var ka=function(a){q.setTimeout(function(){throw a;},0)},F,la=function(){var a=q.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&-1==E.indexOf("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+
	"//"+b.location.host,a=v(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&-1==E.indexOf("Trident")&&-1==E.indexOf("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.F;c.F=null;a()}};return function(a){d.next={F:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in
	document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){q.setTimeout(a,0)}};var G=function(){this.v=this.f=null},ma=new D(function(){return new H},function(a){a.reset()},100);G.prototype.add=function(a,b){var c=ma.get();c.set(a,b);this.v?this.v.next=c:(B(!this.f),this.f=c);this.v=c};G.prototype.remove=function(){var a=null;this.f&&(a=this.f,this.f=this.f.next,this.f||(this.v=null),a.next=null);return a};var H=function(){this.next=this.scope=this.B=null};H.prototype.set=function(a,b){this.B=a;this.scope=b;this.next=null};
	H.prototype.reset=function(){this.next=this.scope=this.B=null};var L=function(a,b){I||na();K||(I(),K=!0);oa.add(a,b)},I,na=function(){if(q.Promise&&q.Promise.resolve){var a=q.Promise.resolve(void 0);I=function(){a.then(pa)}}else I=function(){var a=pa;!u(q.setImmediate)||q.Window&&q.Window.prototype&&-1==E.indexOf("Edge")&&q.Window.prototype.setImmediate==q.setImmediate?(F||(F=la()),F(a)):q.setImmediate(a)}},K=!1,oa=new G,pa=function(){for(var a;a=oa.remove();){try{a.B.call(a.scope)}catch(b){ka(b)}ma.put(a)}K=!1};var N=function(a,b){this.b=0;this.K=void 0;this.j=this.g=this.u=null;this.m=this.A=!1;if(a!=r)try{var c=this;a.call(b,function(a){M(c,2,a)},function(a){try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(b){}M(c,3,a)})}catch(d){M(this,3,d)}},qa=function(){this.next=this.context=this.h=this.c=this.child=null;this.w=!1};qa.prototype.reset=function(){this.context=this.h=this.c=this.child=null;this.w=!1};
	var ra=new D(function(){return new qa},function(a){a.reset()},100),sa=function(a,b,c){var d=ra.get();d.c=a;d.h=b;d.context=c;return d},ua=function(a,b,c){ta(a,b,c,null)||L(w(b,a))};N.prototype.then=function(a,b,c){null!=a&&C(a,"opt_onFulfilled should be a function.");null!=b&&C(b,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return va(this,u(a)?a:null,u(b)?b:null,c)};N.prototype.then=N.prototype.then;N.prototype.$goog_Thenable=!0;
	N.prototype.X=function(a,b){return va(this,null,a,b)};var xa=function(a,b){a.g||2!=a.b&&3!=a.b||wa(a);B(null!=b.c);a.j?a.j.next=b:a.g=b;a.j=b},va=function(a,b,c,d){var e=sa(null,null,null);e.child=new N(function(a,f){e.c=b?function(c){try{var e=b.call(d,c);a(e)}catch(J){f(J)}}:a;e.h=c?function(b){try{var e=c.call(d,b);a(e)}catch(J){f(J)}}:f});e.child.u=a;xa(a,e);return e.child};N.prototype.Y=function(a){B(1==this.b);this.b=0;M(this,2,a)};N.prototype.Z=function(a){B(1==this.b);this.b=0;M(this,3,a)};
	var M=function(a,b,c){0==a.b&&(a===c&&(b=3,c=new TypeError("Promise cannot resolve to itself")),a.b=1,ta(c,a.Y,a.Z,a)||(a.K=c,a.b=b,a.u=null,wa(a),3!=b||ya(a,c)))},ta=function(a,b,c,d){if(a instanceof N)return null!=b&&C(b,"opt_onFulfilled should be a function."),null!=c&&C(c,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"),xa(a,sa(b||r,c||null,d)),!0;var e;if(a)try{e=!!a.$goog_Thenable}catch(f){e=!1}else e=!1;if(e)return a.then(b,c,d),
	!0;e=typeof a;if("object"==e&&null!=a||"function"==e)try{var g=a.then;if(u(g))return za(a,g,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1},za=function(a,b,c,d,e){var g=!1,f=function(a){g||(g=!0,c.call(e,a))},k=function(a){g||(g=!0,d.call(e,a))};try{b.call(a,f,k)}catch(n){k(n)}},wa=function(a){a.A||(a.A=!0,L(a.O,a))},Aa=function(a){var b=null;a.g&&(b=a.g,a.g=b.next,b.next=null);a.g||(a.j=null);null!=b&&B(null!=b.c);return b};
	N.prototype.O=function(){for(var a;a=Aa(this);){var b=this.b,c=this.K;if(3==b&&a.h&&!a.w){var d;for(d=this;d&&d.m;d=d.u)d.m=!1}if(a.child)a.child.u=null,Ba(a,b,c);else try{a.w?a.c.call(a.context):Ba(a,b,c)}catch(e){Ca.call(null,e)}ra.put(a)}this.A=!1};var Ba=function(a,b,c){2==b?a.c.call(a.context,c):a.h&&a.h.call(a.context,c)},ya=function(a,b){a.m=!0;L(function(){a.m&&Ca.call(null,b)})},Ca=ka;function O(a,b){if(!(b instanceof Object))return b;switch(b.constructor){case Date:return new Date(b.getTime());case Object:void 0===a&&(a={});break;case Array:a=[];break;default:return b}for(var c in b)b.hasOwnProperty(c)&&(a[c]=O(a[c],b[c]));return a};var Da=Error.captureStackTrace,Q=function(a,b){this.code=a;this.message=b;if(Da)Da(this,P.prototype.create);else{var c=Error.apply(this,arguments);this.name="FirebaseError";Object.defineProperty(this,"stack",{get:function(){return c.stack}})}};Q.prototype=Object.create(Error.prototype);Q.prototype.constructor=Q;Q.prototype.name="FirebaseError";var P=function(a,b,c){this.V=a;this.W=b;this.N=c;this.pattern=/\{\$([^}]+)}/g};
	P.prototype.create=function(a,b){void 0===b&&(b={});var c=this.N[a];a=this.V+"/"+a;var c=void 0===c?"Error":c.replace(this.pattern,function(a,c){a=b[c];return void 0!==a?a.toString():"<"+c+"?>"}),c=this.W+": "+c+" ("+a+").",c=new Q(a,c),d;for(d in b)b.hasOwnProperty(d)&&"_"!==d.slice(-1)&&(c[d]=b[d]);return c};N.all=function(a){return new N(function(b,c){var d=a.length,e=[];if(d)for(var g=function(a,c){d--;e[a]=c;0==d&&b(e)},f=function(a){c(a)},k=0,n;k<a.length;k++)n=a[k],ua(n,w(g,k),f);else b(e)})};N.resolve=function(a){if(a instanceof N)return a;var b=new N(r);M(b,2,a);return b};N.reject=function(a){return new N(function(b,c){c(a)})};N.prototype["catch"]=N.prototype.X;var R=N;"undefined"!==typeof Promise&&(R=Promise);var Ea=R;function Fa(a,b){a=new S(a,b);return a.subscribe.bind(a)}var S=function(a,b){var c=this;this.a=[];this.J=0;this.task=Ea.resolve();this.l=!1;this.D=b;this.task.then(function(){a(c)}).catch(function(a){c.error(a)})};S.prototype.next=function(a){T(this,function(b){b.next(a)})};S.prototype.error=function(a){T(this,function(b){b.error(a)});this.close(a)};S.prototype.complete=function(){T(this,function(a){a.complete()});this.close()};
	S.prototype.subscribe=function(a,b,c){var d=this,e;if(void 0===a&&void 0===b&&void 0===c)throw Error("Missing Observer.");e=Ga(a)?a:{next:a,error:b,complete:c};void 0===e.next&&(e.next=U);void 0===e.error&&(e.error=U);void 0===e.complete&&(e.complete=U);a=this.$.bind(this,this.a.length);this.l&&this.task.then(function(){try{d.G?e.error(d.G):e.complete()}catch(a){}});this.a.push(e);return a};
	S.prototype.$=function(a){void 0!==this.a&&void 0!==this.a[a]&&(delete this.a[a],--this.J,0===this.J&&void 0!==this.D&&this.D(this))};var T=function(a,b){if(!a.l)for(var c=0;c<a.a.length;c++)Ha(a,c,b)},Ha=function(a,b,c){a.task.then(function(){if(void 0!==a.a&&void 0!==a.a[b])try{c(a.a[b])}catch(d){}})};S.prototype.close=function(a){var b=this;this.l||(this.l=!0,void 0!==a&&(this.G=a),this.task.then(function(){b.a=void 0;b.D=void 0}))};
	function Ga(a){if("object"!==typeof a||null===a)return!1;var b;b=["next","error","complete"];p();var c=b[Symbol.iterator];b=c?c.call(b):m(b);for(c=b.next();!c.done;c=b.next())if(c=c.value,c in a&&"function"===typeof a[c])return!0;return!1}function U(){};var V=R,W=function(a,b,c){var d=this;this.H=c;this.I=!1;this.i={};this.C=b;this.T=O(void 0,a);Object.keys(c.INTERNAL.factories).forEach(function(a){var b=c.INTERNAL.useAsService(d,a);null!==b&&(d[a]=d.R.bind(d,b))})};W.prototype.delete=function(){var a=this;return(new V(function(b){X(a);b()})).then(function(){a.H.INTERNAL.removeApp(a.C);return V.all(Object.keys(a.i).map(function(b){return a.i[b].INTERNAL.delete()}))}).then(function(){a.I=!0;a.i={}})};
	W.prototype.R=function(a){X(this);void 0===this.i[a]&&(this.i[a]=this.H.INTERNAL.factories[a](this,this.P.bind(this)));return this.i[a]};W.prototype.P=function(a){O(this,a)};var X=function(a){a.I&&Y(Ia("deleted",{name:a.C}))};h.Object.defineProperties(W.prototype,{name:{configurable:!0,enumerable:!0,get:function(){X(this);return this.C}},options:{configurable:!0,enumerable:!0,get:function(){X(this);return this.T}}});W.prototype.name&&W.prototype.options||W.prototype.delete||console.log("dc");
	function Ja(){function a(a){a=a||"[DEFAULT]";var b=d[a];void 0===b&&Y("noApp",{name:a});return b}function b(a,b){Object.keys(e).forEach(function(d){d=c(a,d);if(null!==d&&g[d])g[d](b,a)})}function c(a,b){if("serverAuth"===b)return null;var c=b;a=a.options;"auth"===b&&(a.serviceAccount||a.credential)&&(c="serverAuth");return c}var d={},e={},g={},f={__esModule:!0,initializeApp:function(a,c){void 0===c?c="[DEFAULT]":"string"===typeof c&&""!==c||Y("bad-app-name",{name:c+""});void 0!==d[c]&&Y("dupApp",
	{name:c});a=new W(a,c,f);d[c]=a;b(a,"create");void 0!=a.INTERNAL&&void 0!=a.INTERNAL.getToken||O(a,{INTERNAL:{getToken:function(){return V.resolve(null)},addAuthTokenListener:function(){},removeAuthTokenListener:function(){}}});return a},app:a,apps:null,Promise:V,SDK_VERSION:"0.0.0",INTERNAL:{registerService:function(b,c,d,Z){e[b]&&Y("dupService",{name:b});e[b]=c;Z&&(g[b]=Z);c=function(c){void 0===c&&(c=a());return c[b]()};void 0!==d&&O(c,d);return f[b]=c},createFirebaseNamespace:Ja,extendNamespace:function(a){O(f,
	a)},createSubscribe:Fa,ErrorFactory:P,removeApp:function(a){b(d[a],"delete");delete d[a]},factories:e,useAsService:c,Promise:N,deepExtend:O}};f["default"]=f;Object.defineProperty(f,"apps",{get:function(){return Object.keys(d).map(function(a){return d[a]})}});a.App=W;return f}function Y(a,b){throw Error(Ia(a,b));}
	function Ia(a,b){b=b||{};b={noApp:"No Firebase App '"+b.name+"' has been created - call Firebase App.initializeApp().","bad-app-name":"Illegal App name: '"+b.name+"'.",dupApp:"Firebase App named '"+b.name+"' already exists.",deleted:"Firebase App named '"+b.name+"' already deleted.",dupService:"Firebase Service named '"+b.name+"' already registered."}[a];return void 0===b?"Application Error: ("+a+")":b};"undefined"!==typeof window&&(window.firebase=Ja()); })();
	firebase.SDK_VERSION = "3.3.0";
	(function(){var h,aa=aa||{},l=this,ba=function(){},m=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&
	!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},ca=function(a){return null===a},da=function(a){return"array"==m(a)},ea=function(a){var b=m(a);return"array"==b||"object"==b&&"number"==typeof a.length},n=function(a){return"string"==typeof a},fa=function(a){return"number"==typeof a},p=function(a){return"function"==m(a)},ga=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b},ha=function(a,b,
	c){return a.call.apply(a.bind,arguments)},ia=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}},r=function(a,b,c){r=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ha:ia;return r.apply(null,arguments)},ja=function(a,b){var c=Array.prototype.slice.call(arguments,
	1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}},ka=Date.now||function(){return+new Date},t=function(a,b){function c(){}c.prototype=b.prototype;a.Pc=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Ne=function(a,c,f){for(var g=Array(arguments.length-2),k=2;k<arguments.length;k++)g[k-2]=arguments[k];return b.prototype[c].apply(a,g)}};var u=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};t(u,Error);u.prototype.name="CustomError";var la=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")},ma=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},na=/&/g,oa=/</g,pa=/>/g,qa=/"/g,sa=/'/g,ta=/\x00/g,ua=/[\x00&<>"']/,v=function(a,b){return-1!=a.indexOf(b)},va=function(a,b){return a<b?-1:a>b?1:0};var wa=function(a,b){b.unshift(a);u.call(this,la.apply(null,b));b.shift()};t(wa,u);wa.prototype.name="AssertionError";
	var xa=function(a,b,c,d){var e="Assertion failed";if(c)var e=e+(": "+c),f=d;else a&&(e+=": "+a,f=b);throw new wa(""+e,f||[]);},w=function(a,b,c){a||xa("",null,b,Array.prototype.slice.call(arguments,2))},ya=function(a,b){throw new wa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));},za=function(a,b,c){fa(a)||xa("Expected number but got %s: %s.",[m(a),a],b,Array.prototype.slice.call(arguments,2));return a},Aa=function(a,b,c){n(a)||xa("Expected string but got %s: %s.",[m(a),a],b,Array.prototype.slice.call(arguments,
	2))},Ba=function(a,b,c){p(a)||xa("Expected function but got %s: %s.",[m(a),a],b,Array.prototype.slice.call(arguments,2))};var Ca=Array.prototype.indexOf?function(a,b,c){w(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(n(a))return n(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},x=Array.prototype.forEach?function(a,b,c){w(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=n(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},Da=function(a,b){for(var c=n(a)?
	a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)},Ea=Array.prototype.map?function(a,b,c){w(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=n(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Fa=Array.prototype.some?function(a,b,c){w(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=n(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1},
	Ha=function(a){var b;a:{b=Ga;for(var c=a.length,d=n(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:n(a)?a.charAt(b):a[b]},Ia=function(a,b){return 0<=Ca(a,b)},Ka=function(a,b){b=Ca(a,b);var c;(c=0<=b)&&Ja(a,b);return c},Ja=function(a,b){w(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length},La=function(a,b){var c=0;Da(a,function(d,e){b.call(void 0,d,e,a)&&Ja(a,e)&&c++})},Ma=function(a){return Array.prototype.concat.apply(Array.prototype,
	arguments)},Na=function(a){return Array.prototype.concat.apply(Array.prototype,arguments)},Oa=function(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]},Pa=function(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c];if(ea(d)){var e=a.length||0,f=d.length||0;a.length=e+f;for(var g=0;g<f;g++)a[e+g]=d[g]}else a.push(d)}};var Qa=function(a,b){for(var c in a)b.call(void 0,a[c],c,a)},Ra=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b},Sa=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b},Ta=function(a){for(var b in a)return!1;return!0},Ua=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0},Va=function(a){var b={},c;for(c in a)b[c]=a[c];return b},Wa="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
	Xa=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Wa.length;f++)c=Wa[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};var Ya;a:{var Za=l.navigator;if(Za){var $a=Za.userAgent;if($a){Ya=$a;break a}}Ya=""}var y=function(a){return v(Ya,a)};var ab=function(a){ab[" "](a);return a};ab[" "]=ba;var cb=function(a,b){var c=bb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var db=y("Opera"),z=y("Trident")||y("MSIE"),eb=y("Edge"),fb=eb||z,gb=y("Gecko")&&!(v(Ya.toLowerCase(),"webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),hb=v(Ya.toLowerCase(),"webkit")&&!y("Edge"),ib=function(){var a=l.document;return a?a.documentMode:void 0},jb;
	a:{var kb="",lb=function(){var a=Ya;if(gb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(eb)return/Edge\/([\d\.]+)/.exec(a);if(z)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(hb)return/WebKit\/(\S+)/.exec(a);if(db)return/(?:Version)[ \/]?(\S+)/.exec(a)}();lb&&(kb=lb?lb[1]:"");if(z){var mb=ib();if(null!=mb&&mb>parseFloat(kb)){jb=String(mb);break a}}jb=kb}
	var nb=jb,bb={},A=function(a){return cb(a,function(){for(var b=0,c=ma(String(nb)).split("."),d=ma(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",k=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==g[0].length&&0==k[0].length)break;b=va(0==g[1].length?0:parseInt(g[1],10),0==k[1].length?0:parseInt(k[1],10))||va(0==g[2].length,0==k[2].length)||va(g[2],k[2]);g=g[3];k=k[3]}while(0==b)}return 0<=b})},ob=l.document,
	pb=ob&&z?ib()||("CSS1Compat"==ob.compatMode?parseInt(nb,10):5):void 0;var qb=null,rb=null,tb=function(a){var b="";sb(a,function(a){b+=String.fromCharCode(a)});return b},sb=function(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=rb[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}ub();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),k=c(64);if(64===k&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=k&&b(g<<6&192|k))}},ub=function(){if(!qb){qb={};rb={};for(var a=0;65>a;a++)qb[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),
	rb[qb[a]]=a,62<=a&&(rb["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};var wb=function(){this.ec="";this.Md=vb};wb.prototype.Nb=!0;wb.prototype.Ib=function(){return this.ec};wb.prototype.toString=function(){return"Const{"+this.ec+"}"};var xb=function(a){if(a instanceof wb&&a.constructor===wb&&a.Md===vb)return a.ec;ya("expected object of type Const, got '"+a+"'");return"type_error:Const"},vb={};var B=function(){this.ja="";this.Ld=yb};B.prototype.Nb=!0;B.prototype.Ib=function(){return this.ja};B.prototype.toString=function(){return"SafeUrl{"+this.ja+"}"};
	var zb=function(a){if(a instanceof B&&a.constructor===B&&a.Ld===yb)return a.ja;ya("expected object of type SafeUrl, got '"+a+"' of type "+m(a));return"type_error:SafeUrl"},Ab=/^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i,Cb=function(a){if(a instanceof B)return a;a=a.Nb?a.Ib():String(a);Ab.test(a)||(a="about:invalid#zClosurez");return Bb(a)},yb={},Bb=function(a){var b=new B;b.ja=a;return b};Bb("about:blank");var Eb=function(){this.Vb="";this.Nd=Db};Eb.prototype.Nb=!0;Eb.prototype.Ib=function(){return this.Vb};Eb.prototype.toString=function(){return"TrustedResourceUrl{"+this.Vb+"}"};var Db={};var Gb=function(){this.ja="";this.Kd=Fb};Gb.prototype.Nb=!0;Gb.prototype.Ib=function(){return this.ja};Gb.prototype.toString=function(){return"SafeHtml{"+this.ja+"}"};var Hb=function(a){if(a instanceof Gb&&a.constructor===Gb&&a.Kd===Fb)return a.ja;ya("expected object of type SafeHtml, got '"+a+"' of type "+m(a));return"type_error:SafeHtml"},Fb={};Gb.prototype.ne=function(a){this.ja=a;return this};var Ib=function(a,b){b=b instanceof B?b:Cb(b);a.href=zb(b)};var Jb=!z||9<=Number(pb),Kb=z&&!A("9");!hb||A("528");gb&&A("1.9b")||z&&A("8")||db&&A("9.5")||hb&&A("528");gb&&!A("8")||z&&A("9");var Lb=function(){this.ya=this.ya;this.Sb=this.Sb};Lb.prototype.ya=!1;Lb.prototype.isDisposed=function(){return this.ya};Lb.prototype.Oa=function(){if(this.Sb)for(;this.Sb.length;)this.Sb.shift()()};var Mb=function(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.Va=!1;this.ud=!0};Mb.prototype.preventDefault=function(){this.defaultPrevented=!0;this.ud=!1};var Nb=function(a,b){Mb.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.charCode=this.keyCode=this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.kb=this.state=null;a&&this.init(a,b)};t(Nb,Mb);
	Nb.prototype.init=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;if(b=a.relatedTarget){if(gb){var e;a:{try{ab(b.nodeName);e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.offsetX=hb||void 0!==a.offsetX?a.offsetX:a.layerX,this.offsetY=hb||void 0!==a.offsetY?a.offsetY:a.layerY,this.clientX=void 0!==a.clientX?a.clientX:
	a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.state=a.state;this.kb=a;a.defaultPrevented&&
	this.preventDefault()};Nb.prototype.preventDefault=function(){Nb.Pc.preventDefault.call(this);var a=this.kb;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Kb)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Nb.prototype.ce=function(){return this.kb};var Ob="closure_listenable_"+(1E6*Math.random()|0),Pb=0;var Qb=function(a,b,c,d,e){this.listener=a;this.Wb=null;this.src=b;this.type=c;this.Bb=!!d;this.Kb=e;this.key=++Pb;this.$a=this.Ab=!1},Rb=function(a){a.$a=!0;a.listener=null;a.Wb=null;a.src=null;a.Kb=null};var Sb=function(a){this.src=a;this.w={};this.xb=0};Sb.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.w[f];a||(a=this.w[f]=[],this.xb++);var g=Tb(a,b,d,e);-1<g?(b=a[g],c||(b.Ab=!1)):(b=new Qb(b,this.src,f,!!d,e),b.Ab=c,a.push(b));return b};Sb.prototype.remove=function(a,b,c,d){a=a.toString();if(!(a in this.w))return!1;var e=this.w[a];b=Tb(e,b,c,d);return-1<b?(Rb(e[b]),Ja(e,b),0==e.length&&(delete this.w[a],this.xb--),!0):!1};
	var Ub=function(a,b){var c=b.type;c in a.w&&Ka(a.w[c],b)&&(Rb(b),0==a.w[c].length&&(delete a.w[c],a.xb--))};Sb.prototype.tc=function(a,b,c,d){a=this.w[a.toString()];var e=-1;a&&(e=Tb(a,b,c,d));return-1<e?a[e]:null};var Tb=function(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.$a&&f.listener==b&&f.Bb==!!c&&f.Kb==d)return e}return-1};var Vb="closure_lm_"+(1E6*Math.random()|0),Wb={},Xb=0,Yb=function(a,b,c,d,e){if(da(b))for(var f=0;f<b.length;f++)Yb(a,b[f],c,d,e);else c=Zb(c),a&&a[Ob]?a.listen(b,c,d,e):$b(a,b,c,!1,d,e)},$b=function(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=!!e,k=ac(a);k||(a[Vb]=k=new Sb(a));c=k.add(b,c,d,e,f);if(c.Wb)return;d=bc();c.Wb=d;d.src=a;d.listener=c;if(a.addEventListener)a.addEventListener(b.toString(),d,g);else if(a.attachEvent)a.attachEvent(cc(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");
	Xb++},bc=function(){var a=dc,b=Jb?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b},ec=function(a,b,c,d,e){if(da(b))for(var f=0;f<b.length;f++)ec(a,b[f],c,d,e);else c=Zb(c),a&&a[Ob]?fc(a,b,c,d,e):$b(a,b,c,!0,d,e)},gc=function(a,b,c,d,e){if(da(b))for(var f=0;f<b.length;f++)gc(a,b[f],c,d,e);else c=Zb(c),a&&a[Ob]?a.Y.remove(String(b),c,d,e):a&&(a=ac(a))&&(b=a.tc(b,c,!!d,e))&&hc(b)},hc=function(a){if(!fa(a)&&a&&!a.$a){var b=a.src;if(b&&b[Ob])Ub(b.Y,
	a);else{var c=a.type,d=a.Wb;b.removeEventListener?b.removeEventListener(c,d,a.Bb):b.detachEvent&&b.detachEvent(cc(c),d);Xb--;(c=ac(b))?(Ub(c,a),0==c.xb&&(c.src=null,b[Vb]=null)):Rb(a)}}},cc=function(a){return a in Wb?Wb[a]:Wb[a]="on"+a},jc=function(a,b,c,d){var e=!0;if(a=ac(a))if(b=a.w[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.Bb==c&&!f.$a&&(f=ic(f,d),e=e&&!1!==f)}return e},ic=function(a,b){var c=a.listener,d=a.Kb||a.src;a.Ab&&hc(a);return c.call(d,b)},dc=function(a,b){if(a.$a)return!0;
	if(!Jb){if(!b)a:{b=["window","event"];for(var c=l,d;d=b.shift();)if(null!=c[d])c=c[d];else{b=null;break a}b=c}d=b;b=new Nb(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.currentTarget;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;!b.Va&&0<=e;e--){b.currentTarget=d[e];var f=jc(d[e],a,!0,b),c=c&&f}for(e=0;!b.Va&&e<d.length;e++)b.currentTarget=d[e],f=jc(d[e],a,!1,
	b),c=c&&f}return c}return ic(a,new Nb(b,this))},ac=function(a){a=a[Vb];return a instanceof Sb?a:null},kc="__closure_events_fn_"+(1E9*Math.random()>>>0),Zb=function(a){w(a,"Listener can not be null.");if(p(a))return a;w(a.handleEvent,"An object listener must have handleEvent method.");a[kc]||(a[kc]=function(b){return a.handleEvent(b)});return a[kc]};var lc=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;var mc=function(a){a=String(a);if(/^\s*$/.test(a)?0:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,"")))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);},pc=function(a){var b=[];nc(new oc,a,b);return b.join("")},oc=function(){this.$b=void 0},nc=function(a,b,c){if(null==
	b)c.push("null");else{if("object"==typeof b){if(da(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),e=d[f],nc(a,a.$b?a.$b.call(d,String(f),e):e,c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");f="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(e=b[d],"function"!=typeof e&&(c.push(f),qc(d,c),c.push(":"),nc(a,a.$b?a.$b.call(b,d,e):e,c),f=","));c.push("}");return}}switch(typeof b){case "string":qc(b,
	c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}},rc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},sc=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g,qc=function(a,b){b.push('"',a.replace(sc,function(a){var b=rc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),
	rc[a]=b);return b}),'"')};var tc=function(){};tc.prototype.Tc=null;var uc=function(a){return a.Tc||(a.Tc=a.xc())};var vc,wc=function(){};t(wc,tc);wc.prototype.Cb=function(){var a=xc(this);return a?new ActiveXObject(a):new XMLHttpRequest};wc.prototype.xc=function(){var a={};xc(this)&&(a[0]=!0,a[1]=!0);return a};
	var xc=function(a){if(!a.gd&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.gd=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.gd};vc=new wc;var yc=function(){};t(yc,tc);yc.prototype.Cb=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new zc;throw Error("Unsupported browser");};yc.prototype.xc=function(){return{}};
	var zc=function(){this.na=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.na.onload=r(this.ee,this);this.na.onerror=r(this.ed,this);this.na.onprogress=r(this.fe,this);this.na.ontimeout=r(this.ge,this)};h=zc.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.na.open(a,b)};
	h.send=function(a){if(a)if("string"==typeof a)this.na.send(a);else throw Error("Only string data is supported");else this.na.send()};h.abort=function(){this.na.abort()};h.setRequestHeader=function(){};h.ee=function(){this.status=200;this.responseText=this.na.responseText;Ac(this,4)};h.ed=function(){this.status=500;this.responseText="";Ac(this,4)};h.ge=function(){this.ed()};h.fe=function(){this.status=200;Ac(this,1)};var Ac=function(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()};var C=function(a,b){this.h=[];this.g=b;for(var c=!0,d=a.length-1;0<=d;d--){var e=a[d]|0;c&&e==b||(this.h[d]=e,c=!1)}},Bc={},Cc=function(a){if(-128<=a&&128>a){var b=Bc[a];if(b)return b}b=new C([a|0],0>a?-1:0);-128<=a&&128>a&&(Bc[a]=b);return b},F=function(a){if(isNaN(a)||!isFinite(a))return D;if(0>a)return E(F(-a));for(var b=[],c=1,d=0;a>=c;d++)b[d]=a/c|0,c*=4294967296;return new C(b,0)},Dc=function(a,b){if(0==a.length)throw Error("number format error: empty string");b=b||10;if(2>b||36<b)throw Error("radix out of range: "+
	b);if("-"==a.charAt(0))return E(Dc(a.substring(1),b));if(0<=a.indexOf("-"))throw Error('number format error: interior "-" character');for(var c=F(Math.pow(b,8)),d=D,e=0;e<a.length;e+=8){var f=Math.min(8,a.length-e),g=parseInt(a.substring(e,e+f),b);8>f?(f=F(Math.pow(b,f)),d=d.multiply(f).add(F(g))):(d=d.multiply(c),d=d.add(F(g)))}return d},D=Cc(0),Ec=Cc(1),Fc=Cc(16777216),Gc=function(a){if(-1==a.g)return-Gc(E(a));for(var b=0,c=1,d=0;d<a.h.length;d++)b+=Hc(a,d)*c,c*=4294967296;return b};
	C.prototype.toString=function(a){a=a||10;if(2>a||36<a)throw Error("radix out of range: "+a);if(G(this))return"0";if(-1==this.g)return"-"+E(this).toString(a);for(var b=F(Math.pow(a,6)),c=this,d="";;){var e=Ic(c,b),c=Jc(c,e.multiply(b)),f=((0<c.h.length?c.h[0]:c.g)>>>0).toString(a),c=e;if(G(c))return f+d;for(;6>f.length;)f="0"+f;d=""+f+d}};
	var H=function(a,b){return 0>b?0:b<a.h.length?a.h[b]:a.g},Hc=function(a,b){a=H(a,b);return 0<=a?a:4294967296+a},G=function(a){if(0!=a.g)return!1;for(var b=0;b<a.h.length;b++)if(0!=a.h[b])return!1;return!0};C.prototype.Eb=function(a){if(this.g!=a.g)return!1;for(var b=Math.max(this.h.length,a.h.length),c=0;c<b;c++)if(H(this,c)!=H(a,c))return!1;return!0};C.prototype.compare=function(a){a=Jc(this,a);return-1==a.g?-1:G(a)?0:1};
	var E=function(a){for(var b=a.h.length,c=[],d=0;d<b;d++)c[d]=~a.h[d];return(new C(c,~a.g)).add(Ec)};C.prototype.add=function(a){for(var b=Math.max(this.h.length,a.h.length),c=[],d=0,e=0;e<=b;e++){var f=d+(H(this,e)&65535)+(H(a,e)&65535),g=(f>>>16)+(H(this,e)>>>16)+(H(a,e)>>>16),d=g>>>16,f=f&65535,g=g&65535;c[e]=g<<16|f}return new C(c,c[c.length-1]&-2147483648?-1:0)};var Jc=function(a,b){return a.add(E(b))};
	C.prototype.multiply=function(a){if(G(this)||G(a))return D;if(-1==this.g)return-1==a.g?E(this).multiply(E(a)):E(E(this).multiply(a));if(-1==a.g)return E(this.multiply(E(a)));if(0>this.compare(Fc)&&0>a.compare(Fc))return F(Gc(this)*Gc(a));for(var b=this.h.length+a.h.length,c=[],d=0;d<2*b;d++)c[d]=0;for(d=0;d<this.h.length;d++)for(var e=0;e<a.h.length;e++){var f=H(this,d)>>>16,g=H(this,d)&65535,k=H(a,e)>>>16,q=H(a,e)&65535;c[2*d+2*e]+=g*q;Kc(c,2*d+2*e);c[2*d+2*e+1]+=f*q;Kc(c,2*d+2*e+1);c[2*d+2*e+1]+=
	g*k;Kc(c,2*d+2*e+1);c[2*d+2*e+2]+=f*k;Kc(c,2*d+2*e+2)}for(d=0;d<b;d++)c[d]=c[2*d+1]<<16|c[2*d];for(d=b;d<2*b;d++)c[d]=0;return new C(c,0)};
	var Kc=function(a,b){for(;(a[b]&65535)!=a[b];)a[b+1]+=a[b]>>>16,a[b]&=65535},Ic=function(a,b){if(G(b))throw Error("division by zero");if(G(a))return D;if(-1==a.g)return-1==b.g?Ic(E(a),E(b)):E(Ic(E(a),b));if(-1==b.g)return E(Ic(a,E(b)));if(30<a.h.length){if(-1==a.g||-1==b.g)throw Error("slowDivide_ only works with positive integers.");for(var c=Ec;0>=b.compare(a);)c=c.shiftLeft(1),b=b.shiftLeft(1);var d=Lc(c,1),e=Lc(b,1),f;b=Lc(b,2);for(c=Lc(c,2);!G(b);)f=e.add(b),0>=f.compare(a)&&(d=d.add(c),e=f),
	b=Lc(b,1),c=Lc(c,1);return d}for(c=D;0<=a.compare(b);){d=Math.max(1,Math.floor(Gc(a)/Gc(b)));e=Math.ceil(Math.log(d)/Math.LN2);e=48>=e?1:Math.pow(2,e-48);f=F(d);for(var g=f.multiply(b);-1==g.g||0<g.compare(a);)d-=e,f=F(d),g=f.multiply(b);G(f)&&(f=Ec);c=c.add(f);a=Jc(a,g)}return c},Mc=function(a,b){for(var c=Math.max(a.h.length,b.h.length),d=[],e=0;e<c;e++)d[e]=H(a,e)|H(b,e);return new C(d,a.g|b.g)};
	C.prototype.shiftLeft=function(a){var b=a>>5;a%=32;for(var c=this.h.length+b+(0<a?1:0),d=[],e=0;e<c;e++)d[e]=0<a?H(this,e-b)<<a|H(this,e-b-1)>>>32-a:H(this,e-b);return new C(d,this.g)};var Lc=function(a,b){var c=b>>5;b%=32;for(var d=a.h.length-c,e=[],f=0;f<d;f++)e[f]=0<b?H(a,f+c)>>>b|H(a,f+c+1)<<32-b:H(a,f+c);return new C(e,a.g)};var Nc=function(a,b){this.ob=a;this.ma=b};Nc.prototype.Eb=function(a){return this.ma==a.ma&&this.ob.Eb(Va(a.ob))};
	var Qc=function(a){try{var b;if(b=0==a.lastIndexOf("[",0)){var c=a.length-1;b=0<=c&&a.indexOf("]",c)==c}return b?new Oc(a.substring(1,a.length-1)):new Pc(a)}catch(d){return null}},Pc=function(a){var b=D;if(a instanceof C){if(0!=a.g||0>a.compare(D)||0<a.compare(Rc))throw Error("The address does not look like an IPv4.");b=Va(a)}else{if(!Sc.test(a))throw Error(a+" does not look like an IPv4 address.");var c=a.split(".");if(4!=c.length)throw Error(a+" does not look like an IPv4 address.");for(var d=0;d<
	c.length;d++){var e;e=c[d];var f=Number(e);e=0==f&&/^[\s\xa0]*$/.test(e)?NaN:f;if(isNaN(e)||0>e||255<e||1!=c[d].length&&0==c[d].lastIndexOf("0",0))throw Error("In "+a+", octet "+d+" is not valid");e=F(e);b=Mc(b.shiftLeft(8),e)}}Nc.call(this,b,4)};t(Pc,Nc);var Sc=/^[0-9.]*$/,Rc=Jc(Ec.shiftLeft(32),Ec);Pc.prototype.toString=function(){if(this.Ca)return this.Ca;for(var a=Hc(this.ob,0),b=[],c=3;0<=c;c--)b[c]=String(a&255),a>>>=8;return this.Ca=b.join(".")};
	var Oc=function(a){var b=D;if(a instanceof C){if(0!=a.g||0>a.compare(D)||0<a.compare(Tc))throw Error("The address does not look like a valid IPv6.");b=Va(a)}else{if(!Uc.test(a))throw Error(a+" is not a valid IPv6 address.");var c=a.split(":");if(-1!=c[c.length-1].indexOf(".")){a=Hc(Va((new Pc(c[c.length-1])).ob),0);var d=[];d.push((a>>>16&65535).toString(16));d.push((a&65535).toString(16));Ja(c,c.length-1);Pa(c,d);a=c.join(":")}d=a.split("::");if(2<d.length||1==d.length&&8!=c.length)throw Error(a+
	" is not a valid IPv6 address.");if(1<d.length){c=d[0].split(":");d=d[1].split(":");1==c.length&&""==c[0]&&(c=[]);1==d.length&&""==d[0]&&(d=[]);var e=8-(c.length+d.length);if(1>e)c=[];else{for(var f=[],g=0;g<e;g++)f[g]="0";c=Na(c,f,d)}}if(8!=c.length)throw Error(a+" is not a valid IPv6 address");for(d=0;d<c.length;d++){e=Dc(c[d],16);if(0>e.compare(D)||0<e.compare(Vc))throw Error(c[d]+" in "+a+" is not a valid hextet.");b=Mc(b.shiftLeft(16),e)}}Nc.call(this,b,6)};t(Oc,Nc);
	var Uc=/^([a-fA-F0-9]*:){2}[a-fA-F0-9:.]*$/,Vc=Cc(65535),Tc=Jc(Ec.shiftLeft(128),Ec);Oc.prototype.toString=function(){if(this.Ca)return this.Ca;for(var a=[],b=3;0<=b;b--){var c=Hc(this.ob,b),d=c&65535;a.push((c>>>16).toString(16));a.push(d.toString(16))}for(var c=b=-1,e=d=0,f=0;f<a.length;f++)"0"==a[f]?(e++,-1==c&&(c=f),e>d&&(d=e,b=c)):(c=-1,e=0);0<d&&(b+d==a.length&&a.push(""),a.splice(b,d,""),0==b&&(a=[""].concat(a)));return this.Ca=a.join(":")};!gb&&!z||z&&9<=Number(pb)||gb&&A("1.9.1");z&&A("9");var Xc=function(a,b){Qa(b,function(b,d){"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Wc.hasOwnProperty(d)?a.setAttribute(Wc[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})},Wc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};var Yc=function(a,b,c){this.pe=c;this.Td=a;this.ye=b;this.Rb=0;this.Lb=null};Yc.prototype.get=function(){var a;0<this.Rb?(this.Rb--,a=this.Lb,this.Lb=a.next,a.next=null):a=this.Td();return a};Yc.prototype.put=function(a){this.ye(a);this.Rb<this.pe&&(this.Rb++,a.next=this.Lb,this.Lb=a)};var Zc=function(a){l.setTimeout(function(){throw a;},0)},$c,ad=function(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host,
	a=r(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.Xc;c.Xc=null;a()}};return function(a){d.next={Xc:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?
	function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){l.setTimeout(a,0)}};var bd=function(){this.jc=this.Ja=null},dd=new Yc(function(){return new cd},function(a){a.reset()},100);bd.prototype.add=function(a,b){var c=dd.get();c.set(a,b);this.jc?this.jc.next=c:(w(!this.Ja),this.Ja=c);this.jc=c};bd.prototype.remove=function(){var a=null;this.Ja&&(a=this.Ja,this.Ja=this.Ja.next,this.Ja||(this.jc=null),a.next=null);return a};var cd=function(){this.next=this.scope=this.sc=null};cd.prototype.set=function(a,b){this.sc=a;this.scope=b;this.next=null};
	cd.prototype.reset=function(){this.next=this.scope=this.sc=null};var id=function(a,b){ed||fd();gd||(ed(),gd=!0);hd.add(a,b)},ed,fd=function(){if(l.Promise&&l.Promise.resolve){var a=l.Promise.resolve(void 0);ed=function(){a.then(jd)}}else ed=function(){var a=jd;!p(l.setImmediate)||l.Window&&l.Window.prototype&&!y("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?($c||($c=ad()),$c(a)):l.setImmediate(a)}},gd=!1,hd=new bd,jd=function(){for(var a;a=hd.remove();){try{a.sc.call(a.scope)}catch(b){Zc(b)}dd.put(a)}gd=!1};var kd=function(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0},ld=function(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};var I=function(a,b){this.F=0;this.ka=void 0;this.Ma=this.fa=this.o=null;this.Jb=this.rc=!1;if(a!=ba)try{var c=this;a.call(b,function(a){md(c,2,a)},function(a){if(!(a instanceof nd))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(b){}md(c,3,a)})}catch(d){md(this,3,d)}},od=function(){this.next=this.context=this.Sa=this.Ea=this.child=null;this.ib=!1};od.prototype.reset=function(){this.context=this.Sa=this.Ea=this.child=null;this.ib=!1};
	var pd=new Yc(function(){return new od},function(a){a.reset()},100),qd=function(a,b,c){var d=pd.get();d.Ea=a;d.Sa=b;d.context=c;return d},J=function(a){if(a instanceof I)return a;var b=new I(ba);md(b,2,a);return b},K=function(a){return new I(function(b,c){c(a)})},sd=function(a,b,c){rd(a,b,c,null)||id(ja(b,a))},td=function(a){return new I(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{be:!0,value:f}:{be:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],sd(g,ja(e,f,!0),
	ja(e,f,!1));else b(d)})};I.prototype.then=function(a,b,c){null!=a&&Ba(a,"opt_onFulfilled should be a function.");null!=b&&Ba(b,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return ud(this,p(a)?a:null,p(b)?b:null,c)};kd(I);var wd=function(a,b){b=qd(b,b,void 0);b.ib=!0;vd(a,b);return a};I.prototype.l=function(a,b){return ud(this,null,a,b)};I.prototype.cancel=function(a){0==this.F&&id(function(){var b=new nd(a);xd(this,b)},this)};
	var xd=function(a,b){if(0==a.F)if(a.o){var c=a.o;if(c.fa){for(var d=0,e=null,f=null,g=c.fa;g&&(g.ib||(d++,g.child==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(0==c.F&&1==d?xd(c,b):(f?(d=f,w(c.fa),w(null!=d),d.next==c.Ma&&(c.Ma=d),d.next=d.next.next):yd(c),zd(c,e,3,b)))}a.o=null}else md(a,3,b)},vd=function(a,b){a.fa||2!=a.F&&3!=a.F||Ad(a);w(null!=b.Ea);a.Ma?a.Ma.next=b:a.fa=b;a.Ma=b},ud=function(a,b,c,d){var e=qd(null,null,null);e.child=new I(function(a,g){e.Ea=b?function(c){try{var e=b.call(d,c);a(e)}catch(ra){g(ra)}}:
	a;e.Sa=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof nd?g(b):a(e)}catch(ra){g(ra)}}:g});e.child.o=a;vd(a,e);return e.child};I.prototype.He=function(a){w(1==this.F);this.F=0;md(this,2,a)};I.prototype.Ie=function(a){w(1==this.F);this.F=0;md(this,3,a)};
	var md=function(a,b,c){0==a.F&&(a===c&&(b=3,c=new TypeError("Promise cannot resolve to itself")),a.F=1,rd(c,a.He,a.Ie,a)||(a.ka=c,a.F=b,a.o=null,Ad(a),3!=b||c instanceof nd||Bd(a,c)))},rd=function(a,b,c,d){if(a instanceof I)return null!=b&&Ba(b,"opt_onFulfilled should be a function."),null!=c&&Ba(c,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"),vd(a,qd(b||ba,c||null,d)),!0;if(ld(a))return a.then(b,c,d),!0;if(ga(a))try{var e=a.then;if(p(e))return Cd(a,
	e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1},Cd=function(a,b,c,d,e){var f=!1,g=function(a){f||(f=!0,c.call(e,a))},k=function(a){f||(f=!0,d.call(e,a))};try{b.call(a,g,k)}catch(q){k(q)}},Ad=function(a){a.rc||(a.rc=!0,id(a.Xd,a))},yd=function(a){var b=null;a.fa&&(b=a.fa,a.fa=b.next,b.next=null);a.fa||(a.Ma=null);null!=b&&w(null!=b.Ea);return b};I.prototype.Xd=function(){for(var a;a=yd(this);)zd(this,a,this.F,this.ka);this.rc=!1};
	var zd=function(a,b,c,d){if(3==c&&b.Sa&&!b.ib)for(;a&&a.Jb;a=a.o)a.Jb=!1;if(b.child)b.child.o=null,Dd(b,c,d);else try{b.ib?b.Ea.call(b.context):Dd(b,c,d)}catch(e){Ed.call(null,e)}pd.put(b)},Dd=function(a,b,c){2==b?a.Ea.call(a.context,c):a.Sa&&a.Sa.call(a.context,c)},Bd=function(a,b){a.Jb=!0;id(function(){a.Jb&&Ed.call(null,b)})},Ed=Zc,nd=function(a){u.call(this,a)};t(nd,u);nd.prototype.name="cancel";/*
	 Portions of this code are from MochiKit, received by
	 The Closure Authors under the MIT license. All other code is Copyright
	 2005-2009 The Closure Authors. All Rights Reserved.
	*/
	var Fd=function(a,b){this.ac=[];this.nd=a;this.Zc=b||null;this.mb=this.Qa=!1;this.ka=void 0;this.Nc=this.Sc=this.mc=!1;this.hc=0;this.o=null;this.nc=0};Fd.prototype.cancel=function(a){if(this.Qa)this.ka instanceof Fd&&this.ka.cancel();else{if(this.o){var b=this.o;delete this.o;a?b.cancel(a):(b.nc--,0>=b.nc&&b.cancel())}this.nd?this.nd.call(this.Zc,this):this.Nc=!0;this.Qa||Gd(this,new Hd)}};Fd.prototype.Yc=function(a,b){this.mc=!1;Id(this,a,b)};
	var Id=function(a,b,c){a.Qa=!0;a.ka=c;a.mb=!b;Jd(a)},Ld=function(a){if(a.Qa){if(!a.Nc)throw new Kd;a.Nc=!1}};Fd.prototype.callback=function(a){Ld(this);Md(a);Id(this,!0,a)};
	var Gd=function(a,b){Ld(a);Md(b);Id(a,!1,b)},Md=function(a){w(!(a instanceof Fd),"An execution sequence may not be initiated with a blocking Deferred.")},Qd=function(a){var b=Nd("https://apis.google.com/js/client.js?onload="+Od);Pd(b,null,a,void 0)},Pd=function(a,b,c,d){w(!a.Sc,"Blocking Deferreds can not be re-used");a.ac.push([b,c,d]);a.Qa&&Jd(a)};Fd.prototype.then=function(a,b,c){var d,e,f=new I(function(a,b){d=a;e=b});Pd(this,d,function(a){a instanceof Hd?f.cancel():e(a)});return f.then(a,b,c)};
	kd(Fd);
	var Rd=function(a){return Fa(a.ac,function(a){return p(a[1])})},Jd=function(a){if(a.hc&&a.Qa&&Rd(a)){var b=a.hc,c=Sd[b];c&&(l.clearTimeout(c.nb),delete Sd[b]);a.hc=0}a.o&&(a.o.nc--,delete a.o);for(var b=a.ka,d=c=!1;a.ac.length&&!a.mc;){var e=a.ac.shift(),f=e[0],g=e[1],e=e[2];if(f=a.mb?g:f)try{var k=f.call(e||a.Zc,b);void 0!==k&&(a.mb=a.mb&&(k==b||k instanceof Error),a.ka=b=k);if(ld(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.mc=!0}catch(q){b=q,a.mb=!0,Rd(a)||(c=!0)}}a.ka=b;d&&
	(k=r(a.Yc,a,!0),d=r(a.Yc,a,!1),b instanceof Fd?(Pd(b,k,d),b.Sc=!0):b.then(k,d));c&&(b=new Td(b),Sd[b.nb]=b,a.hc=b.nb)},Kd=function(){u.call(this)};t(Kd,u);Kd.prototype.message="Deferred has already fired";Kd.prototype.name="AlreadyCalledError";var Hd=function(){u.call(this)};t(Hd,u);Hd.prototype.message="Deferred was canceled";Hd.prototype.name="CanceledError";var Td=function(a){this.nb=l.setTimeout(r(this.Ge,this),0);this.J=a};
	Td.prototype.Ge=function(){w(Sd[this.nb],"Cannot throw an error that is not scheduled.");delete Sd[this.nb];throw this.J;};var Sd={};var Nd=function(a){var b=new Eb;b.Vb=a;return Ud(b)},Ud=function(a){var b={},c=b.document||document,d;a instanceof Eb&&a.constructor===Eb&&a.Nd===Db?d=a.Vb:(ya("expected object of type TrustedResourceUrl, got '"+a+"' of type "+m(a)),d="type_error:TrustedResourceUrl");var e=document.createElement("SCRIPT");a={vd:e,wb:void 0};var f=new Fd(Vd,a),g=null,k=null!=b.timeout?b.timeout:5E3;0<k&&(g=window.setTimeout(function(){Wd(e,!0);Gd(f,new Xd(1,"Timeout reached for loading script "+d))},k),a.wb=g);e.onload=
	e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Wd(e,b.Oe||!1,g),f.callback(null))};e.onerror=function(){Wd(e,!0,g);Gd(f,new Xd(0,"Error while loading script "+d))};a=b.attributes||{};Xa(a,{type:"text/javascript",charset:"UTF-8",src:d});Xc(e,a);Yd(c).appendChild(e);return f},Yd=function(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement},Vd=function(){if(this&&this.vd){var a=this.vd;a&&"SCRIPT"==a.tagName&&
	Wd(a,!0,this.wb)}},Wd=function(a,b,c){null!=c&&l.clearTimeout(c);a.onload=ba;a.onerror=ba;a.onreadystatechange=ba;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)},Xd=function(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a};t(Xd,u);var Zd=function(){Lb.call(this);this.Y=new Sb(this);this.Qd=this;this.Cc=null};t(Zd,Lb);Zd.prototype[Ob]=!0;h=Zd.prototype;h.addEventListener=function(a,b,c,d){Yb(this,a,b,c,d)};h.removeEventListener=function(a,b,c,d){gc(this,a,b,c,d)};
	h.dispatchEvent=function(a){$d(this);var b,c=this.Cc;if(c){b=[];for(var d=1;c;c=c.Cc)b.push(c),w(1E3>++d,"infinite loop")}c=this.Qd;d=a.type||a;if(n(a))a=new Mb(a,c);else if(a instanceof Mb)a.target=a.target||c;else{var e=a;a=new Mb(d,c);Xa(a,e)}var e=!0,f;if(b)for(var g=b.length-1;!a.Va&&0<=g;g--)f=a.currentTarget=b[g],e=ae(f,d,!0,a)&&e;a.Va||(f=a.currentTarget=c,e=ae(f,d,!0,a)&&e,a.Va||(e=ae(f,d,!1,a)&&e));if(b)for(g=0;!a.Va&&g<b.length;g++)f=a.currentTarget=b[g],e=ae(f,d,!1,a)&&e;return e};
	h.Oa=function(){Zd.Pc.Oa.call(this);if(this.Y){var a=this.Y,b=0,c;for(c in a.w){for(var d=a.w[c],e=0;e<d.length;e++)++b,Rb(d[e]);delete a.w[c];a.xb--}}this.Cc=null};h.listen=function(a,b,c,d){$d(this);return this.Y.add(String(a),b,!1,c,d)};
	var fc=function(a,b,c,d,e){a.Y.add(String(b),c,!0,d,e)},ae=function(a,b,c,d){b=a.Y.w[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.$a&&g.Bb==c){var k=g.listener,q=g.Kb||g.src;g.Ab&&Ub(a.Y,g);e=!1!==k.call(q,d)&&e}}return e&&0!=d.ud};Zd.prototype.tc=function(a,b,c,d){return this.Y.tc(String(a),b,c,d)};var $d=function(a){w(a.Y,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?")};var be="StopIteration"in l?l.StopIteration:{message:"StopIteration",stack:""},ce=function(){};ce.prototype.next=function(){throw be;};ce.prototype.Pd=function(){return this};var de=function(a,b){this.Z={};this.s=[];this.ma=this.i=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.addAll(a)};h=de.prototype;h.dd=function(){return this.i};h.T=function(){ee(this);for(var a=[],b=0;b<this.s.length;b++)a.push(this.Z[this.s[b]]);return a};h.ha=function(){ee(this);return this.s.concat()};h.jb=function(a){return fe(this.Z,a)};
	h.Eb=function(a,b){if(this===a)return!0;if(this.i!=a.dd())return!1;b=b||ge;ee(this);for(var c,d=0;c=this.s[d];d++)if(!b(this.get(c),a.get(c)))return!1;return!0};var ge=function(a,b){return a===b};de.prototype.remove=function(a){return fe(this.Z,a)?(delete this.Z[a],this.i--,this.ma++,this.s.length>2*this.i&&ee(this),!0):!1};
	var ee=function(a){if(a.i!=a.s.length){for(var b=0,c=0;b<a.s.length;){var d=a.s[b];fe(a.Z,d)&&(a.s[c++]=d);b++}a.s.length=c}if(a.i!=a.s.length){for(var e={},c=b=0;b<a.s.length;)d=a.s[b],fe(e,d)||(a.s[c++]=d,e[d]=1),b++;a.s.length=c}};h=de.prototype;h.get=function(a,b){return fe(this.Z,a)?this.Z[a]:b};h.set=function(a,b){fe(this.Z,a)||(this.i++,this.s.push(a),this.ma++);this.Z[a]=b};
	h.addAll=function(a){var b;a instanceof de?(b=a.ha(),a=a.T()):(b=Sa(a),a=Ra(a));for(var c=0;c<b.length;c++)this.set(b[c],a[c])};h.forEach=function(a,b){for(var c=this.ha(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};h.clone=function(){return new de(this)};h.Pd=function(a){ee(this);var b=0,c=this.ma,d=this,e=new ce;e.next=function(){if(c!=d.ma)throw Error("The map has changed since the iterator was created");if(b>=d.s.length)throw be;var e=d.s[b++];return a?e:d.Z[e]};return e};
	var fe=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var he=function(a){if(a.T&&"function"==typeof a.T)return a.T();if(n(a))return a.split("");if(ea(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ra(a)},ie=function(a){if(a.ha&&"function"==typeof a.ha)return a.ha();if(!a.T||"function"!=typeof a.T){if(ea(a)||n(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return Sa(a)}},je=function(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ea(a)||n(a))x(a,b,void 0);else for(var c=ie(a),d=he(a),e=
	d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};var ke=function(a,b,c,d,e){this.reset(a,b,c,d,e)};ke.prototype.ad=null;var le=0;ke.prototype.reset=function(a,b,c,d,e){"number"==typeof e||le++;d||ka();this.qb=a;this.re=b;delete this.ad};ke.prototype.yd=function(a){this.qb=a};var me=function(a){this.se=a;this.fd=this.oc=this.qb=this.o=null},ne=function(a,b){this.name=a;this.value=b};ne.prototype.toString=function(){return this.name};var oe=new ne("SEVERE",1E3),pe=new ne("CONFIG",700),qe=new ne("FINE",500);me.prototype.getParent=function(){return this.o};me.prototype.yd=function(a){this.qb=a};var re=function(a){if(a.qb)return a.qb;if(a.o)return re(a.o);ya("Root logger has no level set.");return null};
	me.prototype.log=function(a,b,c){if(a.value>=re(this).value)for(p(b)&&(b=b()),a=new ke(a,String(b),this.se),c&&(a.ad=c),c="log:"+a.re,l.console&&(l.console.timeStamp?l.console.timeStamp(c):l.console.markTimeline&&l.console.markTimeline(c)),l.msWriteProfilerMark&&l.msWriteProfilerMark(c),c=this;c;){b=c;var d=a;if(b.fd)for(var e=0,f;f=b.fd[e];e++)f(d);c=c.getParent()}};
	var se={},te=null,ue=function(a){te||(te=new me(""),se[""]=te,te.yd(pe));var b;if(!(b=se[a])){b=new me(a);var c=a.lastIndexOf("."),d=a.substr(c+1),c=ue(a.substr(0,c));c.oc||(c.oc={});c.oc[d]=b;b.o=c;se[a]=b}return b};var L=function(a,b){a&&a.log(qe,b,void 0)};var ve=function(a,b,c){if(p(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)},we=function(a){var b=null;return(new I(function(c,d){b=ve(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).l(function(a){l.clearTimeout(b);throw a;})};var xe=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/,ye=function(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e,f=null;0<=d?(e=a[c].substring(0,d),f=a[c].substring(d+1)):e=a[c];b(e,f?decodeURIComponent(f.replace(/\+/g," ")):"")}}};var M=function(a){Zd.call(this);this.headers=new de;this.lc=a||null;this.oa=!1;this.kc=this.a=null;this.pb=this.ld=this.Qb="";this.Ba=this.wc=this.Ob=this.qc=!1;this.fb=0;this.gc=null;this.td="";this.ic=this.xe=this.Gd=!1};t(M,Zd);var ze=M.prototype,Ae=ue("goog.net.XhrIo");ze.P=Ae;var Be=/^https?$/i,Ce=["POST","PUT"];
	M.prototype.send=function(a,b,c,d){if(this.a)throw Error("[goog.net.XhrIo] Object is active with another request="+this.Qb+"; newUri="+a);b=b?b.toUpperCase():"GET";this.Qb=a;this.pb="";this.ld=b;this.qc=!1;this.oa=!0;this.a=this.lc?this.lc.Cb():vc.Cb();this.kc=this.lc?uc(this.lc):uc(vc);this.a.onreadystatechange=r(this.qd,this);this.xe&&"onprogress"in this.a&&(this.a.onprogress=r(function(a){this.pd(a,!0)},this),this.a.upload&&(this.a.upload.onprogress=r(this.pd,this)));try{L(this.P,De(this,"Opening Xhr")),
	this.wc=!0,this.a.open(b,String(a),!0),this.wc=!1}catch(f){L(this.P,De(this,"Error opening Xhr: "+f.message));this.J(5,f);return}a=c||"";var e=this.headers.clone();d&&je(d,function(a,b){e.set(b,a)});d=Ha(e.ha());c=l.FormData&&a instanceof l.FormData;!Ia(Ce,b)||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.a.setRequestHeader(b,a)},this);this.td&&(this.a.responseType=this.td);"withCredentials"in this.a&&this.a.withCredentials!==this.Gd&&(this.a.withCredentials=
	this.Gd);try{Ee(this),0<this.fb&&(this.ic=Fe(this.a),L(this.P,De(this,"Will abort after "+this.fb+"ms if incomplete, xhr2 "+this.ic)),this.ic?(this.a.timeout=this.fb,this.a.ontimeout=r(this.wb,this)):this.gc=ve(this.wb,this.fb,this)),L(this.P,De(this,"Sending request")),this.Ob=!0,this.a.send(a),this.Ob=!1}catch(f){L(this.P,De(this,"Send error: "+f.message)),this.J(5,f)}};var Fe=function(a){return z&&A(9)&&fa(a.timeout)&&void 0!==a.ontimeout},Ga=function(a){return"content-type"==a.toLowerCase()};
	M.prototype.wb=function(){"undefined"!=typeof aa&&this.a&&(this.pb="Timed out after "+this.fb+"ms, aborting",L(this.P,De(this,this.pb)),this.dispatchEvent("timeout"),this.abort(8))};M.prototype.J=function(a,b){this.oa=!1;this.a&&(this.Ba=!0,this.a.abort(),this.Ba=!1);this.pb=b;Ge(this);He(this)};var Ge=function(a){a.qc||(a.qc=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))};
	M.prototype.abort=function(){this.a&&this.oa&&(L(this.P,De(this,"Aborting")),this.oa=!1,this.Ba=!0,this.a.abort(),this.Ba=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),He(this))};M.prototype.Oa=function(){this.a&&(this.oa&&(this.oa=!1,this.Ba=!0,this.a.abort(),this.Ba=!1),He(this,!0));M.Pc.Oa.call(this)};M.prototype.qd=function(){this.isDisposed()||(this.wc||this.Ob||this.Ba?Ie(this):this.ve())};M.prototype.ve=function(){Ie(this)};
	var Ie=function(a){if(a.oa&&"undefined"!=typeof aa)if(a.kc[1]&&4==Je(a)&&2==Ke(a))L(a.P,De(a,"Local request error detected and ignored"));else if(a.Ob&&4==Je(a))ve(a.qd,0,a);else if(a.dispatchEvent("readystatechange"),4==Je(a)){L(a.P,De(a,"Request complete"));a.oa=!1;try{var b=Ke(a),c;a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.Qb).match(xe)[1]||null;if(!f&&l.self&&l.self.location)var g=l.self.location.protocol,
	f=g.substr(0,g.length-1);e=!Be.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{var k;try{k=2<Je(a)?a.a.statusText:""}catch(q){L(a.P,"Can not get status: "+q.message),k=""}a.pb=k+" ["+Ke(a)+"]";Ge(a)}}finally{He(a)}}};M.prototype.pd=function(a,b){w("progress"===a.type,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(Le(a,"progress"));this.dispatchEvent(Le(a,b?"downloadprogress":"uploadprogress"))};
	var Le=function(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}},He=function(a,b){if(a.a){Ee(a);var c=a.a,d=a.kc[0]?ba:null;a.a=null;a.kc=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.P)&&a.log(oe,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}},Ee=function(a){a.a&&a.ic&&(a.a.ontimeout=null);fa(a.gc)&&(l.clearTimeout(a.gc),a.gc=null)},Je=function(a){return a.a?a.a.readyState:0},Ke=function(a){try{return 2<Je(a)?
	a.a.status:-1}catch(b){return-1}},Me=function(a){try{return a.a?a.a.responseText:""}catch(b){return L(a.P,"Can not get responseText: "+b.message),""}},De=function(a,b){return b+" ["+a.ld+" "+a.Qb+" "+Ke(a)+"]"};var Ne=function(a,b){this.ga=this.Ia=this.la="";this.Ua=null;this.Aa=this.qa="";this.M=this.oe=!1;var c;a instanceof Ne?(this.M=void 0!==b?b:a.M,Oe(this,a.la),c=a.Ia,N(this),this.Ia=c,Pe(this,a.ga),Qe(this,a.Ua),Re(this,a.qa),Se(this,a.aa.clone()),a=a.Aa,N(this),this.Aa=a):a&&(c=String(a).match(xe))?(this.M=!!b,Oe(this,c[1]||"",!0),a=c[2]||"",N(this),this.Ia=Te(a),Pe(this,c[3]||"",!0),Qe(this,c[4]),Re(this,c[5]||"",!0),Se(this,c[6]||"",!0),a=c[7]||"",N(this),this.Aa=Te(a)):(this.M=!!b,this.aa=new O(null,
	0,this.M))};Ne.prototype.toString=function(){var a=[],b=this.la;b&&a.push(Ue(b,Ve,!0),":");var c=this.ga;if(c||"file"==b)a.push("//"),(b=this.Ia)&&a.push(Ue(b,Ve,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.Ua,null!=c&&a.push(":",String(c));if(c=this.qa)this.ga&&"/"!=c.charAt(0)&&a.push("/"),a.push(Ue(c,"/"==c.charAt(0)?We:Xe,!0));(c=this.aa.toString())&&a.push("?",c);(c=this.Aa)&&a.push("#",Ue(c,Ye));return a.join("")};
	Ne.prototype.resolve=function(a){var b=this.clone(),c=!!a.la;c?Oe(b,a.la):c=!!a.Ia;if(c){var d=a.Ia;N(b);b.Ia=d}else c=!!a.ga;c?Pe(b,a.ga):c=null!=a.Ua;d=a.qa;if(c)Qe(b,a.Ua);else if(c=!!a.qa){if("/"!=d.charAt(0))if(this.ga&&!this.qa)d="/"+d;else{var e=b.qa.lastIndexOf("/");-1!=e&&(d=b.qa.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(v(e,"./")||v(e,"/.")){for(var d=0==e.lastIndexOf("/",0),e=e.split("/"),f=[],g=0;g<e.length;){var k=e[g++];"."==k?d&&g==e.length&&f.push(""):".."==k?((1<f.length||
	1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(k),d=!0)}d=f.join("/")}else d=e}c?Re(b,d):c=""!==a.aa.toString();c?Se(b,Te(a.aa.toString())):c=!!a.Aa;c&&(a=a.Aa,N(b),b.Aa=a);return b};Ne.prototype.clone=function(){return new Ne(this)};
	var Oe=function(a,b,c){N(a);a.la=c?Te(b,!0):b;a.la&&(a.la=a.la.replace(/:$/,""))},Pe=function(a,b,c){N(a);a.ga=c?Te(b,!0):b},Qe=function(a,b){N(a);if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.Ua=b}else a.Ua=null},Re=function(a,b,c){N(a);a.qa=c?Te(b,!0):b},Se=function(a,b,c){N(a);b instanceof O?(a.aa=b,a.aa.Mc(a.M)):(c||(b=Ue(b,Ze)),a.aa=new O(b,0,a.M))},P=function(a,b,c){N(a);a.aa.set(b,c)},N=function(a){if(a.oe)throw Error("Tried to modify a read-only Uri");};
	Ne.prototype.Mc=function(a){this.M=a;this.aa&&this.aa.Mc(a);return this};
	var $e=function(a){return a instanceof Ne?a.clone():new Ne(a,void 0)},af=function(a,b){var c=new Ne(null,void 0);Oe(c,"https");a&&Pe(c,a);b&&Re(c,b);return c},Te=function(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""},Ue=function(a,b,c){return n(a)?(a=encodeURI(a).replace(b,bf),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null},bf=function(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)},Ve=/[#\/\?@]/g,Xe=/[\#\?:]/g,We=/[\#\?]/g,Ze=/[\#\?@]/g,
	Ye=/#/g,O=function(a,b,c){this.i=this.j=null;this.I=a||null;this.M=!!c},cf=function(a){a.j||(a.j=new de,a.i=0,a.I&&ye(a.I,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))},ef=function(a){var b=ie(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new O(null,0,void 0);a=he(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];da(f)?df(c,e,f):c.add(e,f)}return c};h=O.prototype;h.dd=function(){cf(this);return this.i};
	h.add=function(a,b){cf(this);this.I=null;a=this.K(a);var c=this.j.get(a);c||this.j.set(a,c=[]);c.push(b);this.i=za(this.i)+1;return this};h.remove=function(a){cf(this);a=this.K(a);return this.j.jb(a)?(this.I=null,this.i=za(this.i)-this.j.get(a).length,this.j.remove(a)):!1};h.jb=function(a){cf(this);a=this.K(a);return this.j.jb(a)};h.ha=function(){cf(this);for(var a=this.j.T(),b=this.j.ha(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
	h.T=function(a){cf(this);var b=[];if(n(a))this.jb(a)&&(b=Ma(b,this.j.get(this.K(a))));else{a=this.j.T();for(var c=0;c<a.length;c++)b=Ma(b,a[c])}return b};h.set=function(a,b){cf(this);this.I=null;a=this.K(a);this.jb(a)&&(this.i=za(this.i)-this.j.get(a).length);this.j.set(a,[b]);this.i=za(this.i)+1;return this};h.get=function(a,b){a=a?this.T(a):[];return 0<a.length?String(a[0]):b};var df=function(a,b,c){a.remove(b);0<c.length&&(a.I=null,a.j.set(a.K(b),Oa(c)),a.i=za(a.i)+c.length)};
	O.prototype.toString=function(){if(this.I)return this.I;if(!this.j)return"";for(var a=[],b=this.j.ha(),c=0;c<b.length;c++)for(var d=b[c],e=encodeURIComponent(String(d)),d=this.T(d),f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}return this.I=a.join("&")};O.prototype.clone=function(){var a=new O;a.I=this.I;this.j&&(a.j=this.j.clone(),a.i=this.i);return a};O.prototype.K=function(a){a=String(a);this.M&&(a=a.toLowerCase());return a};
	O.prototype.Mc=function(a){a&&!this.M&&(cf(this),this.I=null,this.j.forEach(function(a,c){var d=c.toLowerCase();c!=d&&(this.remove(c),df(this,d,a))},this));this.M=a};var gf=function(){var a=ff();return z&&!!pb&&11==pb||/Edge\/\d+/.test(a)},hf=function(){return l.window&&l.window.location.href||""},jf=function(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):da(a[d])?Ua(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<jf(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c},lf=function(){var a;a=ff();a="Chrome"!=kf(a)?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],
	10):null;return a&&30>a?!1:!z||!pb||9<pb},mf=function(a){(a||l.window).close()},nf=function(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};d&&(b.target=d);"Firefox"==kf(ff())&&(a=a||"http://localhost",b.scrollbars=!0);var g;c=a||"about:blank";(d=b)||(d={});a=window;b=c instanceof B?c:Cb("undefined"!=typeof c.href?
	c.href:String(c));c=d.target||c.target;e=[];for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;default:e.push(g+"="+(d[g]?1:0))}g=e.join(",");(y("iPhone")&&!y("iPod")&&!y("iPad")||y("iPad")||y("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),b=b instanceof B?b:Cb(b),g.href=zb(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel","noreferrer"),d=document.createEvent("MouseEvent"),
	d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),d=zb(b),g&&(fb&&v(d,";")&&(d="'"+d.replace(/'/g,"%27")+"'"),g.opener=null,a=new wb,a.ec="b/12014412, meta tag with sanitized URL",ua.test(d)&&(-1!=d.indexOf("&")&&(d=d.replace(na,"&amp;")),-1!=d.indexOf("<")&&(d=d.replace(oa,"&lt;")),-1!=d.indexOf(">")&&(d=d.replace(pa,"&gt;")),-1!=d.indexOf('"')&&(d=d.replace(qa,"&quot;")),-1!=d.indexOf("'")&&(d=d.replace(sa,"&#39;")),-1!=d.indexOf("\x00")&&(d=d.replace(ta,
	"&#0;"))),d='<META HTTP-EQUIV="refresh" content="0; url='+d+'">',Aa(xb(a),"must provide justification"),w(!/^[\s\xa0]*$/.test(xb(a)),"must provide non-empty justification"),g.document.write(Hb((new Gb).ne(d))),g.document.close())):g=a.open(zb(b),c,g);if(g)try{g.focus()}catch(k){}return g},of=function(a){return new I(function(b){var c=function(){we(2E3).then(function(){if(!a||a.closed)b();else return c()})};return c()})},pf=function(){var a=null;return(new I(function(b){"complete"==l.document.readyState?
	b():(a=function(){b()},ec(window,"load",a))})).l(function(b){gc(window,"load",a);throw b;})},qf=function(a){switch(a||l.navigator&&l.navigator.product||""){case "ReactNative":return"ReactNative";default:return"undefined"!==typeof l.process?"Node":"Browser"}},rf=function(){var a=qf();return"ReactNative"===a||"Node"===a},kf=function(a){var b=a.toLowerCase();if(v(b,"opera/")||v(b,"opr/")||v(b,"opios/"))return"Opera";if(v(b,"iemobile"))return"IEMobile";if(v(b,"msie")||v(b,"trident/"))return"IE";if(v(b,
	"edge/"))return"Edge";if(v(b,"firefox/"))return"Firefox";if(v(b,"silk/"))return"Silk";if(v(b,"blackberry"))return"Blackberry";if(v(b,"webos"))return"Webos";if(!v(b,"safari/")||v(b,"chrome/")||v(b,"crios/")||v(b,"android"))if(!v(b,"chrome/")&&!v(b,"crios/")||v(b,"edge/")){if(v(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&2==a.length)return a[1]}else return"Chrome";else return"Safari";return"Other"},sf=function(a){var b=qf(void 0);return("Browser"===b?kf(ff()):b)+
	"/JsCore/"+a},ff=function(){return l.navigator&&l.navigator.userAgent||""},tf=function(a){a=a.split(".");for(var b=l,c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b},vf=function(){var a;if(!(a=!l.location||!l.location.protocol||"http:"!=l.location.protocol&&"https:"!=l.location.protocol||rf())){var b;a:{try{var c=l.localStorage,d=uf();if(c){c.setItem(d,"1");c.removeItem(d);b=gf()?!!l.indexedDB:!0;break a}}catch(e){}b=!1}a=!b}return!a},wf=function(a){a=a||
	ff();var b=(a||ff()).toLowerCase();return b.match(/android/)||b.match(/webos/)||b.match(/iphone|ipad|ipod/)||b.match(/blackberry/)||b.match(/windows phone/)||b.match(/iemobile/)||"Firefox"==kf(a)?!1:!0},xf=function(a){return"undefined"===typeof a?null:pc(a)},yf=function(a){if(null!==a){var b;try{b=mc(a)}catch(c){try{b=JSON.parse(a)}catch(d){throw c;}}return b}},uf=function(a){return a?a:""+Math.floor(1E9*Math.random()).toString()},zf=function(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=
	a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null};var Af;try{var Bf={};Object.defineProperty(Bf,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Bf,"abcd",{configurable:!0,enumerable:!0,value:2});Af=2==Bf.abcd}catch(a){Af=!1}
	var Q=function(a,b,c){Af?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c},Cf=function(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&Q(a,c,b[c])},Df=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b},Ef=function(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0};var Ff={Hd:{tb:985,sb:735,providerId:"facebook.com"},Id:{tb:500,sb:620,providerId:"github.com"},Jd:{tb:515,sb:680,providerId:"google.com"},Od:{tb:485,sb:705,providerId:"twitter.com"}},Gf=function(a){for(var b in Ff)if(Ff[b].providerId==a)return Ff[b];return null};var R=function(a,b){this.code="auth/"+a;this.message=b||Hf[a]||""};t(R,Error);R.prototype.G=function(){return{name:this.code,code:this.code,message:this.message}};
	var Hf={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
	"email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.","invalid-auth-event":"An internal error has occurred.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.",
	"invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
	"invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","missing-iframe-start":"An internal error has occurred.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
	"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http or https and web storage must be enabled.',
	"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.",
	"user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported."};var If=function(a,b,c,d,e){this.ua=a;this.za=b||null;this.hb=c||null;this.bc=d||null;this.J=e||null;if(this.hb||this.J){if(this.hb&&this.J)throw new R("invalid-auth-event");if(this.hb&&!this.bc)throw new R("invalid-auth-event");}else throw new R("invalid-auth-event");};If.prototype.getError=function(){return this.J};If.prototype.G=function(){return{type:this.ua,eventId:this.za,urlResponse:this.hb,sessionId:this.bc,error:this.J&&this.J.G()}};var Jf=function(a){var b="unauthorized-domain",c=void 0,d=$e(a);a=d.ga;d=d.la;"http"!=d&&"https"!=d?b="operation-not-supported-in-this-environment":c=la("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a);R.call(this,b,c)};t(Jf,R);var Kf=function(a){this.qe=a.sub;ka();this.Db=a.email||null};var Lf=function(a,b,c,d){var e={};ga(c)?e=c:b&&n(c)&&n(d)?e={oauthToken:c,oauthTokenSecret:d}:!b&&n(c)&&(e={accessToken:c});if(b||!e.idToken&&!e.accessToken)if(b&&e.oauthToken&&e.oauthTokenSecret)Q(this,"accessToken",e.oauthToken),Q(this,"secret",e.oauthTokenSecret);else{if(b)throw new R("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");throw new R("argument-error","credential failed: expected 1 argument (the OAuth access token).");}else e.idToken&&Q(this,
	"idToken",e.idToken),e.accessToken&&Q(this,"accessToken",e.accessToken);Q(this,"provider",a)};Lf.prototype.Gb=function(a){var b=Mf(this);return S(a,Nf,b)};Lf.prototype.md=function(a,b){var c=Mf(this);c.idToken=b;return S(a,Of,c)};var Mf=function(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.provider;return{postBody:ef(b).toString(),requestUri:vf()?hf():"http://localhost"}};
	Lf.prototype.G=function(){var a={provider:this.provider};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};
	var Pf=function(a,b){var c=!!b;b=function(){Cf(this,{providerId:a,isOAuthProvider:!0});this.Lc=[];"google.com"==a&&this.addScope("profile")};c||(b.prototype.addScope=function(a){Ia(this.Lc,a)||this.Lc.push(a)});b.prototype.Hb=function(){return Oa(this.Lc)};b.credential=function(b,e){return new Lf(a,c,b,e)};Cf(b,{PROVIDER_ID:a});return b},Qf=Pf("facebook.com");Qf.prototype.addScope=Qf.prototype.addScope||void 0;var Rf=Pf("github.com");Rf.prototype.addScope=Rf.prototype.addScope||void 0;var Sf=Pf("google.com");
	Sf.prototype.addScope=Sf.prototype.addScope||void 0;Sf.credential=function(a,b){if(!a&&!b)throw new R("argument-error","credential failed: must provide the ID token and/or the access token.");return new Lf("google.com",!1,ga(a)?a:{idToken:a||null,accessToken:b||null})};var Tf=Pf("twitter.com",!0),Uf=function(a,b){this.Db=a;this.Dc=b;Q(this,"provider","password")};Uf.prototype.Gb=function(a){return S(a,Vf,{email:this.Db,password:this.Dc})};
	Uf.prototype.md=function(a,b){return S(a,Wf,{idToken:b,email:this.Db,password:this.Dc})};Uf.prototype.G=function(){return{email:this.Db,password:this.Dc}};var Xf=function(){Cf(this,{providerId:"password",isOAuthProvider:!1})};Cf(Xf,{PROVIDER_ID:"password"});
	var Yf={Me:Xf,Hd:Qf,Jd:Sf,Id:Rf,Od:Tf},Zf=function(a){var b=a&&a.providerId;if(!b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;for(var e in Yf)if(Yf[e].PROVIDER_ID==b)try{return Yf[e].credential({accessToken:c,idToken:a,oauthToken:c,oauthTokenSecret:d})}catch(f){break}return null};var $f=function(a,b,c){R.call(this,"account-exists-with-different-credential",c);Q(this,"email",a);Q(this,"credential",b)};t($f,R);$f.prototype.G=function(){var a={code:this.code,message:this.message,email:this.email},b=this.credential&&this.credential.G();b&&(Xa(a,b),a.providerId=b.provider,delete a.provider);return a};var ag=function(a){this.Le=a};t(ag,tc);ag.prototype.Cb=function(){return new this.Le};ag.prototype.xc=function(){return{}};
	var T=function(a,b,c){var d;d="Node"==qf();d=l.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new R("internal-error","The XMLHttpRequest compatibility library was not found.");this.v=a;a=b||{};this.Ae=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.Be=a.secureTokenTimeout||1E4;this.wd=Va(a.secureTokenHeaders||bg);this.$d=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.ae=a.firebaseTimeout||
	1E4;this.cd=Va(a.firebaseHeaders||cg);c&&(this.cd["X-Client-Version"]=c,this.wd["X-Client-Version"]=c);this.Sd=new yc;this.Ke=new ag(d)},dg,bg={"Content-Type":"application/x-www-form-urlencoded"},cg={"Content-Type":"application/json"},fg=function(a,b,c,d,e,f,g){lf()?a=r(a.De,a):(dg||(dg=new I(function(a,b){eg(a,b)})),a=r(a.Ce,a));a(b,c,d,e,f,g)};
	T.prototype.De=function(a,b,c,d,e,f){var g="Node"==qf(),k=rf()?g?new M(this.Ke):new M:new M(this.Sd),q;f&&(k.fb=Math.max(0,f),q=setTimeout(function(){k.dispatchEvent("timeout")},f));k.listen("complete",function(){q&&clearTimeout(q);var a=null;try{var c;c=this.a?mc(this.a.responseText):void 0;a=c||null}catch(d){try{a=JSON.parse(Me(this))||null}catch(e){a=null}}b&&b(a)});fc(k,"ready",function(){q&&clearTimeout(q);this.ya||(this.ya=!0,this.Oa())});fc(k,"timeout",function(){q&&clearTimeout(q);this.ya||
	(this.ya=!0,this.Oa());b&&b(null)});k.send(a,c,d,e)};var Od="__fcb"+Math.floor(1E6*Math.random()).toString(),eg=function(a,b){((window.gapi||{}).client||{}).request?a():(l[Od]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))},Qd(function(){b(Error("CORS_UNSUPPORTED"))}))};
	T.prototype.Ce=function(a,b,c,d,e){var f=this;dg.then(function(){window.gapi.client.setApiKey(f.v);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).l(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
	var hg=function(a,b){return new I(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?fg(a,a.Ae+"?key="+encodeURIComponent(a.v),function(a){a?a.error?d(gg(a)):a.access_token&&a.refresh_token?c(a):d(new R("internal-error")):d(new R("network-request-failed"))},"POST",ef(b).toString(),a.wd,a.Be):d(new R("internal-error"))})},ig=function(a){var b={},c;for(c in a)null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return pc(b)},jg=function(a,b,c,d,e){var f=a.$d+
	b+"?key="+encodeURIComponent(a.v);e&&(f+="&cb="+ka().toString());return new I(function(b,e){fg(a,f,function(a){a?a.error?e(gg(a)):b(a):e(new R("network-request-failed"))},c,ig(d),a.cd,a.ae)})},kg=function(a){if(!lc.test(a.email))throw new R("invalid-email");},lg=function(a){"email"in a&&kg(a)},ng=function(a,b){var c=vf()?hf():"http://localhost";return S(a,mg,{identifier:b,continueUri:c}).then(function(a){return a.allProviders||[]})},pg=function(a){return S(a,og,{}).then(function(a){return a.authorizedDomains||
	[]})},qg=function(a){if(!a.idToken)throw new R("internal-error");};T.prototype.signInAnonymously=function(){return S(this,rg,{})};T.prototype.updateEmail=function(a,b){return S(this,sg,{idToken:a,email:b})};T.prototype.updatePassword=function(a,b){return S(this,Wf,{idToken:a,password:b})};var tg={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};
	T.prototype.updateProfile=function(a,b){var c={idToken:a},d=[];Qa(tg,function(a,f){var g=b[f];null===g?d.push(a):f in b&&(c[f]=g)});d.length&&(c.deleteAttribute=d);return S(this,sg,c)};T.prototype.sendPasswordResetEmail=function(a){return S(this,ug,{requestType:"PASSWORD_RESET",email:a})};T.prototype.sendEmailVerification=function(a){return S(this,vg,{requestType:"VERIFY_EMAIL",idToken:a})};
	var xg=function(a,b,c){return S(a,wg,{idToken:b,deleteProvider:c})},yg=function(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new R("internal-error");},zg=function(a){if(a.needConfirmation)throw(a&&a.email?new $f(a.email,Zf(a),a.message):null)||new R("account-exists-with-different-credential");if(!a.idToken)throw new R("internal-error");},Ag=function(a){if(!a.oobCode)throw new R("invalid-action-code");};T.prototype.confirmPasswordReset=function(a,b){return S(this,Bg,{oobCode:a,newPassword:b})};
	T.prototype.checkActionCode=function(a){return S(this,Cg,{oobCode:a})};T.prototype.applyActionCode=function(a){return S(this,Dg,{oobCode:a})};
	var Dg={endpoint:"setAccountInfo",D:Ag,cb:"email"},Cg={endpoint:"resetPassword",D:Ag,sa:function(a){if(!lc.test(a.email))throw new R("internal-error");}},Eg={endpoint:"signupNewUser",D:function(a){kg(a);if(!a.password)throw new R("weak-password");},sa:qg,ta:!0},mg={endpoint:"createAuthUri"},Fg={endpoint:"deleteAccount",ab:["idToken"]},wg={endpoint:"setAccountInfo",ab:["idToken","deleteProvider"],D:function(a){if(!da(a.deleteProvider))throw new R("internal-error");}},Gg={endpoint:"getAccountInfo"},
	vg={endpoint:"getOobConfirmationCode",ab:["idToken","requestType"],D:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new R("internal-error");},cb:"email"},ug={endpoint:"getOobConfirmationCode",ab:["requestType"],D:function(a){if("PASSWORD_RESET"!=a.requestType)throw new R("internal-error");kg(a)},cb:"email"},og={Rd:!0,endpoint:"getProjectConfig",je:"GET"},Bg={endpoint:"resetPassword",D:Ag,cb:"email"},sg={endpoint:"setAccountInfo",ab:["idToken"],D:lg,ta:!0},Wf={endpoint:"setAccountInfo",ab:["idToken"],
	D:function(a){lg(a);if(!a.password)throw new R("weak-password");},sa:qg,ta:!0},rg={endpoint:"signupNewUser",sa:qg,ta:!0},Nf={endpoint:"verifyAssertion",D:yg,sa:zg,ta:!0},Of={endpoint:"verifyAssertion",D:function(a){yg(a);if(!a.idToken)throw new R("internal-error");},sa:zg,ta:!0},Hg={endpoint:"verifyCustomToken",D:function(a){if(!a.token)throw new R("invalid-custom-token");},sa:qg,ta:!0},Vf={endpoint:"verifyPassword",D:function(a){kg(a);if(!a.password)throw new R("wrong-password");},sa:qg,ta:!0},S=
	function(a,b,c){if(!Ef(c,b.ab))return K(new R("internal-error"));var d=b.je||"POST",e;return J(c).then(b.D).then(function(){b.ta&&(c.returnSecureToken=!0);return jg(a,b.endpoint,d,c,b.Rd||!1)}).then(function(a){return e=a}).then(b.sa).then(function(){if(!b.cb)return e;if(!(b.cb in e))throw new R("internal-error");return e[b.cb]})},gg=function(a){var b,c;c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?
	new R(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",
	FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed"};
	b=(b=c.match(/:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new R(d[e],b);!b&&a&&(b=xf(a));return new R("internal-error",b)};var Ig=function(a){this.R=a};Ig.prototype.value=function(){return this.R};Ig.prototype.zd=function(a){this.R.style=a;return this};var Jg=function(a){this.R=a||{}};Jg.prototype.value=function(){return this.R};Jg.prototype.zd=function(a){this.R.style=a;return this};var Lg=function(a){this.Je=a;this.vc=null;this.od=Kg(this)};Lg.prototype.Bc=function(){return this.od};
	var Mg=function(a){var b=new Jg;b.R.where=document.body;b.R.url=a.Je;b.R.messageHandlersFilter=tf("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER");b.R.attributes=b.R.attributes||{};(new Ig(b.R.attributes)).zd({position:"absolute",top:"-100px",width:"1px",height:"1px"});b.R.dontclear=!0;return b},Kg=function(a){return Ng().then(function(){return new I(function(b,c){tf("gapi.iframes.getContext")().open(Mg(a).value(),function(d){a.vc=d;a.vc.restyle({setHideOnLeave:!1});var e=setTimeout(function(){c(Error("Network Error"))},
	5E3),f=function(){clearTimeout(e);b()};d.ping(f).then(f,function(){c(Error("Network Error"))})})})})},Og=function(a,b){a.od.then(function(){a.vc.register("authEvent",b,tf("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})},Pg="__iframefcb"+Math.floor(1E6*Math.random()).toString(),Ng=function(){return new I(function(a,b){var c=function(){zf();tf("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){zf();b(Error("Network Error"))},timeout:3E3})};tf("gapi.iframes.Iframe")?a():tf("gapi.load")?c():
	(l[Pg]=function(){tf("gapi.load")?c():b(Error("Network Error"))},J(Nd("https://apis.google.com/js/api.js?onload="+Pg)).l(function(){b(Error("Network Error"))}))})};var Rg=function(a,b,c,d){this.X=a;this.v=b;this.ea=c;d=this.xa=d||null;a=af(a,"/__/auth/iframe");P(a,"apiKey",b);P(a,"appName",c);d&&P(a,"v",d);this.ke=a.toString();this.hd=new Lg(this.ke);this.yb=[];Qg(this)};Rg.prototype.Bc=function(){return this.hd.Bc()};
	var Sg=function(a,b,c,d,e,f,g,k,q){a=af(a,"/__/auth/handler");P(a,"apiKey",b);P(a,"appName",c);P(a,"authType",d);P(a,"providerId",e);f&&f.length&&P(a,"scopes",f.join(","));g&&P(a,"redirectUrl",g);k&&P(a,"eventId",k);q&&P(a,"v",q);return a.toString()},Qg=function(a){Og(a.hd,function(b){var c={};if(b&&b.authEvent){var d=!1;b=b.authEvent||{};if(b.type){if(c=b.error)var e=(c=b.error)&&(c.name||c.code),c=e?new R(e.substring(5),c.message):null;b=new If(b.type,b.eventId,b.urlResponse,b.sessionId,c)}else b=
	null;for(c=0;c<a.yb.length;c++)d=a.yb[c](b)||d;c={};c.status=d?"ACK":"ERROR";return J(c)}c.status="ERROR";return J(c)})},Tg=function(a,b){La(a.yb,function(a){return a==b})};var Ug=function(a){this.u=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.u)throw new R("internal-error","The React Native compatibility library was not found.");};h=Ug.prototype;h.get=function(a){return J(this.u.getItem(a)).then(function(a){return a&&yf(a)})};h.set=function(a,b){return J(this.u.setItem(a,xf(b)))};h.remove=function(a){return J(this.u.removeItem(a))};h.Ka=function(){};h.Za=function(){};var Vg=function(){this.u={}};h=Vg.prototype;h.get=function(a){return J(this.u[a])};h.set=function(a,b){this.u[a]=b;return J()};h.remove=function(a){delete this.u[a];return J()};h.Ka=function(){};h.Za=function(){};var Xg=function(){if(!Wg()){if("Node"==qf())throw new R("internal-error","The LocalStorage compatibility library was not found.");throw new R("web-storage-unsupported");}this.u=l.localStorage||firebase.INTERNAL.node.localStorage},Wg=function(){var a="Node"==qf(),a=l.localStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=Xg.prototype;
	h.get=function(a){var b=this;return J().then(function(){var c=b.u.getItem(a);return yf(c)})};h.set=function(a,b){var c=this;return J().then(function(){var d=xf(b);null===d?c.remove(a):c.u.setItem(a,d)})};h.remove=function(a){var b=this;return J().then(function(){b.u.removeItem(a)})};h.Ka=function(a){l.window&&Yb(l.window,"storage",a)};h.Za=function(a){l.window&&gc(l.window,"storage",a)};var Yg=function(){this.u={}};h=Yg.prototype;h.get=function(){return J(null)};h.set=function(){return J()};h.remove=function(){return J()};h.Ka=function(){};h.Za=function(){};var $g=function(){if(!Zg()){if("Node"==qf())throw new R("internal-error","The SessionStorage compatibility library was not found.");throw new R("web-storage-unsupported");}this.u=l.sessionStorage||firebase.INTERNAL.node.sessionStorage},Zg=function(){var a="Node"==qf(),a=l.sessionStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=$g.prototype;
	h.get=function(a){var b=this;return J().then(function(){var c=b.u.getItem(a);return yf(c)})};h.set=function(a,b){var c=this;return J().then(function(){var d=xf(b);null===d?c.remove(a):c.u.setItem(a,d)})};h.remove=function(a){var b=this;return J().then(function(){b.u.removeItem(a)})};h.Ka=function(){};h.Za=function(){};var ah=function(a,b,c,d,e,f){if(!window.indexedDB)throw new R("web-storage-unsupported");this.Ud=a;this.Ac=b;this.pc=c;this.Fd=d;this.ma=e;this.O={};this.ub=[];this.rb=0;this.le=f||l.indexedDB},bh,ch=function(a){return new I(function(b,c){var d=a.le.open(a.Ud,a.ma);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.Ac,{keyPath:a.pc})}catch(d){c(d)}};d.onsuccess=function(a){b(a.target.result)}})},dh=function(a){a.jd||(a.jd=
	ch(a));return a.jd},eh=function(a,b){return b.objectStore(a.Ac)},fh=function(a,b,c){return b.transaction([a.Ac],c?"readwrite":"readonly")},gh=function(a){return new I(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})};h=ah.prototype;
	h.set=function(a,b){var c=!1,d,e=this;return wd(dh(this).then(function(b){d=b;b=eh(e,fh(e,d,!0));return gh(b.get(a))}).then(function(f){var g=eh(e,fh(e,d,!0));if(f)return f.value=b,gh(g.put(f));e.rb++;c=!0;f={};f[e.pc]=a;f[e.Fd]=b;return gh(g.add(f))}).then(function(){e.O[a]=b}),function(){c&&e.rb--})};h.get=function(a){var b=this;return dh(this).then(function(c){return gh(eh(b,fh(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
	h.remove=function(a){var b=!1,c=this;return wd(dh(this).then(function(d){b=!0;c.rb++;return gh(eh(c,fh(c,d,!0))["delete"](a))}).then(function(){delete c.O[a]}),function(){b&&c.rb--})};
	h.Fe=function(){var a=this;return dh(this).then(function(b){var c=eh(a,fh(a,b,!1));return c.getAll?gh(c.getAll()):new I(function(a,b){var f=[],g=c.openCursor();g.onsuccess=function(b){(b=b.target.result)?(f.push(b.value),b["continue"]()):a(f)};g.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.rb){for(d=0;d<b.length;d++)c[b[d][a.pc]]=b[d][a.Fd];d=jf(a.O,c);a.O=c}return d})};h.Ka=function(a){0==this.ub.length&&this.Oc();this.ub.push(a)};
	h.Za=function(a){La(this.ub,function(b){return b==a});0==this.ub.length&&this.dc()};h.Oc=function(){var a=this;this.dc();var b=function(){a.Fc=we(800).then(r(a.Fe,a)).then(function(b){0<b.length&&x(a.ub,function(a){a(b)})}).then(b).l(function(a){"STOP_EVENT"!=a.message&&b()});return a.Fc};b()};h.dc=function(){this.Fc&&this.Fc.cancel("STOP_EVENT")};var kh=function(){this.$c={Browser:hh,Node:ih,ReactNative:jh}[qf()]},lh,hh={V:Xg,Qc:$g},ih={V:Xg,Qc:$g},jh={V:Ug,Qc:Yg};var mh="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" "),U=function(a,b){return{name:a||"",ca:"a valid string",optional:!!b,da:n}},nh=function(a){return{name:a||"",ca:"a valid object",optional:!1,da:ga}},oh=function(a,b){return{name:a||"",ca:"a function",optional:!!b,da:p}},ph=function(){return{name:"",ca:"null",optional:!1,da:ca}},qh=function(){return{name:"credential",ca:"a valid credential",optional:!1,da:function(a){return!(!a||!a.Gb)}}},rh=function(){return{name:"authProvider",
	ca:"a valid Auth provider",optional:!1,da:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}},sh=function(a,b,c,d){return{name:c||"",ca:a.ca+" or "+b.ca,optional:!!d,da:function(c){return a.da(c)||b.da(c)}}};var uh=function(a,b){for(var c in b){var d=b[c].name;a[d]=th(d,a[c],b[c].b)}},V=function(a,b,c,d){a[b]=th(b,c,d)},th=function(a,b,c){if(!c)return b;var d=vh(a);a=function(){var a=Array.prototype.slice.call(arguments),e;a:{e=Array.prototype.slice.call(a);var k;k=0;for(var q=!1,ra=0;ra<c.length;ra++)if(c[ra].optional)q=!0;else{if(q)throw new R("internal-error","Argument validator encountered a required argument after an optional argument.");k++}q=c.length;if(e.length<k||q<e.length)e="Expected "+(k==
	q?1==k?"1 argument":k+" arguments":k+"-"+q+" arguments")+" but got "+e.length+".";else{for(k=0;k<e.length;k++)if(q=c[k].optional&&void 0===e[k],!c[k].da(e[k])&&!q){e=c[k];if(0>k||k>=mh.length)throw new R("internal-error","Argument validator received an unsupported number of arguments.");e=mh[k]+" argument "+(e.name?'"'+e.name+'" ':"")+"must be "+e.ca+".";break a}e=null}}if(e)throw new R("argument-error",d+" failed: "+e);return b.apply(this,a)};for(var e in b)a[e]=b[e];for(e in b.prototype)a.prototype[e]=
	b.prototype[e];return a},vh=function(a){a=a.split(".");return a[a.length-1]};var wh=function(a,b,c,d){this.te=a;this.xd=b;this.ze=c;this.eb=d;this.N={};lh||(lh=new kh);a=lh;try{var e;gf()?(bh||(bh=new ah("firebaseLocalStorageDb","firebaseLocalStorage","fbase_key","value",1)),e=bh):e=new a.$c.V;this.Ta=e}catch(f){this.Ta=new Vg,this.eb=!0}try{this.fc=new a.$c.Qc}catch(f){this.fc=new Vg}this.Ad=r(this.Bd,this);this.O={}},xh,yh=function(){xh||(xh=new wh("firebase",":","Safari"==kf(ff())&&l.window&&l.window!=l.window.top?!0:!1,wf()));return xh};h=wh.prototype;
	h.K=function(a,b){return this.te+this.xd+a.name+(b?this.xd+b:"")};h.get=function(a,b){return(a.V?this.Ta:this.fc).get(this.K(a,b))};h.remove=function(a,b){b=this.K(a,b);a.V&&!this.eb&&(this.O[b]=null);return(a.V?this.Ta:this.fc).remove(b)};h.set=function(a,b,c){var d=this.K(a,c),e=this,f=a.V?this.Ta:this.fc;return f.set(d,b).then(function(){return f.get(d)}).then(function(b){a.V&&!this.eb&&(e.O[d]=b)})};
	h.addListener=function(a,b,c){a=this.K(a,b);this.eb||(this.O[a]=l.localStorage.getItem(a));Ta(this.N)&&this.Oc();this.N[a]||(this.N[a]=[]);this.N[a].push(c)};h.removeListener=function(a,b,c){a=this.K(a,b);this.N[a]&&(La(this.N[a],function(a){return a==c}),0==this.N[a].length&&delete this.N[a]);Ta(this.N)&&this.dc()};h.Oc=function(){this.Ta.Ka(this.Ad);this.eb||zh(this)};
	var zh=function(a){Ah(a);a.zc=setInterval(function(){for(var b in a.N){var c=l.localStorage.getItem(b);c!=a.O[b]&&(a.O[b]=c,c=new Nb({type:"storage",key:b,target:window,oldValue:a.O[b],newValue:c}),a.Bd(c))}},1E3)},Ah=function(a){a.zc&&(clearInterval(a.zc),a.zc=null)};wh.prototype.dc=function(){this.Ta.Za(this.Ad);this.eb||Ah(this)};
	wh.prototype.Bd=function(a){if(a&&a.ce){var b=a.kb.key;if(this.ze){var c=l.localStorage.getItem(b);a=a.kb.newValue;a!=c&&(a?l.localStorage.setItem(b,a):a||l.localStorage.removeItem(b))}this.O[b]=l.localStorage.getItem(b);this.Vc(b)}else x(a,r(this.Vc,this))};wh.prototype.Vc=function(a){this.N[a]&&x(this.N[a],function(a){a()})};var Bh=function(a){this.B=a;this.A=yh()},Ch={name:"pendingRedirect",V:!1},Dh=function(a){return a.A.set(Ch,"pending",a.B)},Eh=function(a){return a.A.remove(Ch,a.B)},Fh=function(a){return a.A.get(Ch,a.B).then(function(a){return"pending"==a})};var Ih=function(a,b,c){var d=this,e=(this.xa=firebase.SDK_VERSION||null)?sf(this.xa):null;this.f=new T(b,null,e);this.pa=null;this.X=a;this.v=b;this.ea=c;this.vb=[];this.Pb=!1;this.Rc=r(this.de,this);this.Wa=new Gh(this);this.rd=new Hh(this);this.Ec=new Bh(this.v+":"+this.ea);this.gb={};this.gb.unknown=this.Wa;this.gb.signInViaRedirect=this.Wa;this.gb.linkViaRedirect=this.Wa;this.gb.signInViaPopup=this.rd;this.gb.linkViaPopup=this.rd;this.Zb=this.bb=null;this.Tb=new I(function(a,b){d.bb=a;d.Zb=b})};
	Ih.prototype.reset=function(){var a=this;this.pa=null;this.Tb.cancel();this.Pb=!1;this.Zb=this.bb=null;this.Mb&&Tg(this.Mb,this.Rc);this.Tb=new I(function(b,c){a.bb=b;a.Zb=c})};
	var Jh=function(a){var b=hf();return pg(a).then(function(a){a:{for(var d=$e(b).ga,e=0;e<a.length;e++){var f;var g=a[e];f=d;var k=Qc(g);k?f=(f=Qc(f))?k.Eb(f):!1:(k=g.split(".").join("\\."),f=(new RegExp("^(.+\\."+k+"|"+k+")$","i")).test(f));if(f){a=!0;break a}}a=!1}if(!a)throw new Jf(hf());})},Kh=function(a){a.Pb||(a.Pb=!0,pf().then(function(){a.Mb=new Rg(a.X,a.v,a.ea,a.xa);a.Mb.Bc().l(function(){a.Zb(new R("network-request-failed"));a.reset()});a.Mb.yb.push(a.Rc)}));return a.Tb};
	Ih.prototype.subscribe=function(a){Ia(this.vb,a)||this.vb.push(a);if(!this.Pb){var b=this,c=function(){var a=ff(),c;(c=wf(a))||(a=a||ff(),c="Safari"==kf(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0);c?Lh(b.Wa):Kh(b)};Fh(this.Ec).then(function(a){a?Eh(b.Ec).then(function(){Kh(b)}):c()}).l(function(){c()})}};Ih.prototype.unsubscribe=function(a){La(this.vb,function(b){return b==a})};
	Ih.prototype.de=function(a){if(!a)throw new R("invalid-auth-event");this.bb&&(this.bb(),this.bb=null);for(var b=!1,c=0;c<this.vb.length;c++){var d=this.vb[c];if(d.Wc(a.ua,a.za)){(b=this.gb[a.ua])&&b.sd(a,d);b=!0;break}}Lh(this.Wa);return b};Ih.prototype.getRedirectResult=function(){return this.Wa.getRedirectResult()};
	var Nh=function(a,b,c,d,e,f){if(!b)return K(new R("popup-blocked"));if(f)return Kh(a),J();a.pa||(a.pa=Jh(a.f));return a.pa.then(function(){return Kh(a)}).then(function(){Mh(d);var f=Sg(a.X,a.v,a.ea,c,d.providerId,d.Hb(),null,e,a.xa);Ib((b||l.window).location,f)}).l(function(b){"auth/network-request-failed"==b.code&&(a.pa=null);throw b;})},Oh=function(a,b,c,d){a.pa||(a.pa=Jh(a.f));return a.pa.then(function(){Mh(c);var e=Sg(a.X,a.v,a.ea,b,c.providerId,c.Hb(),hf(),d,a.xa);Dh(a.Ec).then(function(){Ib(l.window.location,
	e)})})},Ph=function(a,b,c,d,e){var f=new R("popup-closed-by-user");return a.Tb.l(function(){}).then(function(){return of(d)}).then(function(){return we(2E3).then(function(){b.Ha(c,null,f,e)})})},Mh=function(a){if(!a.isOAuthProvider)throw new R("invalid-oauth-provider");},Qh={},Rh=function(a,b,c){var d=b+":"+c;Qh[d]||(Qh[d]=new Ih(a,b,c));return Qh[d]},Gh=function(a){this.A=a;this.Jc=this.Yb=this.Xa=this.W=null;this.Ic=!1};
	Gh.prototype.sd=function(a,b){if(!a)return K(new R("invalid-auth-event"));this.Ic=!0;var c=a.ua,d=a.za;"unknown"==c?(this.W||Sh(this,!1,null,null),a=J()):a=a.J?this.Gc(a,b):b.lb(c,d)?this.Hc(a,b):K(new R("invalid-auth-event"));return a};var Lh=function(a){a.Ic||(a.Ic=!0,Sh(a,!1,null,null))};Gh.prototype.Gc=function(a){this.W||Sh(this,!0,null,a.getError());return J()};
	Gh.prototype.Hc=function(a,b){var c=this,d=a.ua;b=b.lb(d,a.za);var e=a.hb;a=a.bc;var f="signInViaRedirect"==d||"linkViaRedirect"==d;return this.W?J():b(e,a).then(function(a){c.W||Sh(c,f,a,null)}).l(function(a){c.W||Sh(c,f,null,a)})};var Sh=function(a,b,c,d){b?d?(a.W=function(){return K(d)},a.Yb&&a.Yb(d)):(a.W=function(){return J(c)},a.Xa&&a.Xa(c)):(a.W=function(){return J({user:null})},a.Xa&&a.Xa({user:null}));a.Xa=null;a.Yb=null};
	Gh.prototype.getRedirectResult=function(){var a=this;this.Uc||(this.Uc=new I(function(b,c){a.W?a.W().then(b,c):(a.Xa=b,a.Yb=c,Th(a))}));return this.Uc};var Th=function(a){var b=new R("timeout");a.Jc&&a.Jc.cancel();a.Jc=we(1E4).then(function(){a.W||Sh(a,!0,null,b)})},Hh=function(a){this.A=a};Hh.prototype.sd=function(a,b){if(!a)return K(new R("invalid-auth-event"));var c=a.ua,d=a.za;return a.J?this.Gc(a,b):b.lb(c,d)?this.Hc(a,b):K(new R("invalid-auth-event"))};
	Hh.prototype.Gc=function(a,b){b.Ha(a.ua,null,a.getError(),a.za);return J()};Hh.prototype.Hc=function(a,b){var c=a.za,d=a.ua;return b.lb(d,c)(a.hb,a.bc).then(function(a){b.Ha(d,a,null,c)}).l(function(a){b.Ha(d,null,a,c)})};var Uh=function(a){this.f=a;this.wa=this.S=null;this.Pa=0};Uh.prototype.G=function(){return{apiKey:this.f.v,refreshToken:this.S,accessToken:this.wa,expirationTime:this.Pa}};
	var Wh=function(a,b){var c=b.idToken,d=b.refreshToken;b=Vh(b.expiresIn);a.wa=c;a.Pa=b;a.S=d},Vh=function(a){return ka()+1E3*parseInt(a,10)},Xh=function(a,b){return hg(a.f,b).then(function(b){a.wa=b.access_token;a.Pa=Vh(b.expires_in);a.S=b.refresh_token;return{accessToken:a.wa,expirationTime:a.Pa,refreshToken:a.S}}).l(function(b){"auth/user-token-expired"==b.code&&(a.S=null);throw b;})},Yh=function(a){return!(!a.wa||a.S)};
	Uh.prototype.getToken=function(a){a=!!a;return Yh(this)?K(new R("user-token-expired")):a||!this.wa||ka()>this.Pa-3E4?this.S?Xh(this,{grant_type:"refresh_token",refresh_token:this.S}):J(null):J({accessToken:this.wa,expirationTime:this.Pa,refreshToken:this.S})};var Zh=function(a,b,c,d,e){Cf(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,providerId:b})},$h=function(a,b){Mb.call(this,a);for(var c in b)this[c]=b[c]};t($h,Mb);
	var W=function(a,b,c){this.U=[];this.v=a.apiKey;this.ea=a.appName;this.X=a.authDomain||null;a=firebase.SDK_VERSION?sf(firebase.SDK_VERSION):null;this.f=new T(this.v,null,a);this.ba=new Uh(this.f);ai(this,b.idToken);Wh(this.ba,b);Q(this,"refreshToken",this.ba.S);bi(this,c||{});Zd.call(this);this.Ub=!1;this.X&&vf()&&(this.m=Rh(this.X,this.v,this.ea));this.cc=[]};t(W,Zd);
	var ai=function(a,b){a.kd=b;Q(a,"_lat",b)},ci=function(a,b){La(a.cc,function(a){return a==b})},di=function(a){for(var b=[],c=0;c<a.cc.length;c++)b.push(a.cc[c](a));return td(b).then(function(){return a})},ei=function(a){a.m&&!a.Ub&&(a.Ub=!0,a.m.subscribe(a))},bi=function(a,b){Cf(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,isAnonymous:b.isAnonymous||!1,providerData:[]})};Q(W.prototype,"providerId","firebase");
	var fi=function(){},gi=function(a){return J().then(function(){if(a.Vd)throw new R("app-deleted");})},hi=function(a){return Ea(a.providerData,function(a){return a.providerId})},ji=function(a,b){b&&(ii(a,b.providerId),a.providerData.push(b))},ii=function(a,b){La(a.providerData,function(a){return a.providerId==b})},ki=function(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&Q(a,b,c)};
	W.prototype.copy=function(a){var b=this;b!=a&&(Cf(this,{uid:a.uid,displayName:a.displayName,photoURL:a.photoURL,email:a.email,emailVerified:a.emailVerified,isAnonymous:a.isAnonymous,providerData:[]}),x(a.providerData,function(a){ji(b,a)}),this.ba=a.ba,Q(this,"refreshToken",this.ba.S))};W.prototype.reload=function(){var a=this;return gi(this).then(function(){return li(a).then(function(){return di(a)}).then(fi)})};
	var li=function(a){return a.getToken().then(function(b){var c=a.isAnonymous;return mi(a,b).then(function(){c||ki(a,"isAnonymous",!1);return b}).l(function(b){"auth/user-token-expired"==b.code&&(a.dispatchEvent(new $h("userDeleted")),ni(a));throw b;})})};
	W.prototype.getToken=function(a){var b=this,c=Yh(this.ba);return gi(this).then(function(){return b.ba.getToken(a)}).then(function(a){if(!a)throw new R("internal-error");a.accessToken!=b.kd&&(ai(b,a.accessToken),b.Da());ki(b,"refreshToken",a.refreshToken);return a.accessToken}).l(function(a){if("auth/user-token-expired"==a.code&&!c)return di(b).then(function(){ki(b,"refreshToken",null);throw a;});throw a;})};
	var oi=function(a,b){b.idToken&&a.kd!=b.idToken&&(Wh(a.ba,b),a.Da(),ai(a,b.idToken),ki(a,"refreshToken",a.ba.S))};W.prototype.Da=function(){this.dispatchEvent(new $h("tokenChanged"))};var mi=function(a,b){return S(a.f,Gg,{idToken:b}).then(r(a.we,a))};
	W.prototype.we=function(a){a=a.users;if(!a||!a.length)throw new R("internal-error");a=a[0];bi(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified});for(var b=pi(a),c=0;c<b.length;c++)ji(this,b[c]);ki(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
	var pi=function(a){return(a=a.providerUserInfo)&&a.length?Ea(a,function(a){return new Zh(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl)}):[]};W.prototype.reauthenticate=function(a){var b=this;return this.c(a.Gb(this.f).then(function(a){var d;a:{var e=a.idToken.split(".");if(3==e.length){for(var e=e[1],f=(4-e.length%4)%4,g=0;g<f;g++)e+=".";try{var k=mc(tb(e));if(k.sub&&k.iss&&k.aud&&k.exp){d=new Kf(k);break a}}catch(q){}}d=null}if(!d||b.uid!=d.qe)throw new R("user-mismatch");oi(b,a);return b.reload()}))};
	var qi=function(a,b){return li(a).then(function(){if(Ia(hi(a),b))return di(a).then(function(){throw new R("provider-already-linked");})})};h=W.prototype;h.link=function(a){var b=this;return this.c(qi(this,a.provider).then(function(){return b.getToken()}).then(function(c){return a.md(b.f,c)}).then(r(this.bd,this)))};h.bd=function(a){oi(this,a);var b=this;return this.reload().then(function(){return b})};
	h.updateEmail=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.f.updateEmail(c,a)}).then(function(a){oi(b,a);return b.reload()}))};h.updatePassword=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.f.updatePassword(c,a)}).then(function(a){oi(b,a);return b.reload()}))};
	h.updateProfile=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return gi(this);var b=this;return this.c(this.getToken().then(function(c){return b.f.updateProfile(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){oi(b,a);ki(b,"displayName",a.displayName||null);ki(b,"photoURL",a.photoUrl||null);return di(b)}).then(fi))};
	h.unlink=function(a){var b=this;return this.c(li(this).then(function(c){return Ia(hi(b),a)?xg(b.f,c,[a]).then(function(a){var c={};x(a.providerUserInfo||[],function(a){c[a.providerId]=!0});x(hi(b),function(a){c[a]||ii(b,a)});return di(b)}):di(b).then(function(){throw new R("no-such-provider");})}))};h.delete=function(){var a=this;return this.c(this.getToken().then(function(b){return S(a.f,Fg,{idToken:b})}).then(function(){a.dispatchEvent(new $h("userDeleted"))})).then(function(){ni(a)})};
	h.Wc=function(a,b){return"linkViaPopup"==a&&(this.ia||null)==b&&this.$||"linkViaRedirect"==a&&(this.Xb||null)==b?!0:!1};h.Ha=function(a,b,c,d){"linkViaPopup"==a&&d==(this.ia||null)&&(c&&this.Fa?this.Fa(c):b&&!c&&this.$&&this.$(b),this.C&&(this.C.cancel(),this.C=null),delete this.$,delete this.Fa)};h.lb=function(a,b){return"linkViaPopup"==a&&b==(this.ia||null)||"linkViaRedirect"==a&&(this.Xb||null)==b?r(this.Yd,this):null};h.Fb=function(){return uf(this.uid+":::")};
	h.linkWithPopup=function(a){if(!vf())return K(new R("operation-not-supported-in-this-environment"));var b=this,c=Gf(a.providerId),d=this.Fb(),e=null;!wf()&&this.X&&a.isOAuthProvider&&(e=Sg(this.X,this.v,this.ea,"linkViaPopup",a.providerId,a.Hb(),null,d,firebase.SDK_VERSION||null));var f=nf(e,c&&c.tb,c&&c.sb),c=qi(this,a.providerId).then(function(){return di(b)}).then(function(){ri(b);return b.getToken()}).then(function(){return Nh(b.m,f,"linkViaPopup",a,d,!!e)}).then(function(){return new I(function(a,
	c){b.Ha("linkViaPopup",null,new R("cancelled-popup-request"),b.ia||null);b.$=a;b.Fa=c;b.ia=d;b.C=Ph(b.m,b,"linkViaPopup",f,d)})}).then(function(a){f&&mf(f);return a}).l(function(a){f&&mf(f);throw a;});return this.c(c)};
	h.linkWithRedirect=function(a){if(!vf())return K(new R("operation-not-supported-in-this-environment"));var b=this,c=null,d=this.Fb(),e=qi(this,a.providerId).then(function(){ri(b);return b.getToken()}).then(function(){b.Xb=d;return di(b)}).then(function(a){b.Ga&&(a=b.Ga,a=a.A.set(si,b.G(),a.B));return a}).then(function(){return Oh(b.m,"linkViaRedirect",a,d)}).l(function(a){c=a;if(b.Ga)return ti(b.Ga);throw c;}).then(function(){if(c)throw c;});return this.c(e)};
	var ri=function(a){if(a.m&&a.Ub)return;if(a.m&&!a.Ub)throw new R("internal-error");throw new R("auth-domain-config-required");};W.prototype.Yd=function(a,b){var c=this;this.C&&(this.C.cancel(),this.C=null);var d=null,e=this.getToken().then(function(d){return S(c.f,Of,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=Zf(a);return c.bd(a)}).then(function(a){return{user:a,credential:d}});return this.c(e)};
	W.prototype.sendEmailVerification=function(){var a=this;return this.c(this.getToken().then(function(b){return a.f.sendEmailVerification(b)}).then(function(b){if(a.email!=b)return a.reload()}).then(function(){}))};var ni=function(a){for(var b=0;b<a.U.length;b++)a.U[b].cancel("app-deleted");a.U=[];a.Vd=!0;Q(a,"refreshToken",null);a.m&&a.m.unsubscribe(a)};W.prototype.c=function(a){var b=this;this.U.push(a);wd(a,function(){Ka(b.U,a)});return a};W.prototype.toJSON=function(){return this.G()};
	W.prototype.G=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.v,appName:this.ea,authDomain:this.X,stsTokenManager:this.ba.G(),redirectEventId:this.Xb||null};x(this.providerData,function(b){a.providerData.push(Df(b))});return a};
	var ui=function(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c.idToken=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-ka())/1E3;else return null;var d=new W(b,c,a);a.providerData&&x(a.providerData,function(a){if(a){var b={};Cf(b,a);ji(d,b)}});a.redirectEventId&&(d.Xb=a.redirectEventId);
	return d},vi=function(a,b,c){var d=new W(a,b);c&&(d.Ga=c);return d.reload().then(function(){return d})};var wi=function(a){this.B=a;this.A=yh()},si={name:"redirectUser",V:!1},ti=function(a){return a.A.remove(si,a.B)},xi=function(a,b){return a.A.get(si,a.B).then(function(a){a&&b&&(a.authDomain=b);return ui(a||{})})};var yi=function(a){this.B=a;this.A=yh()},zi={name:"authUser",V:!0},Ai=function(a){return a.A.remove(zi,a.B)},Bi=function(a,b){return a.A.get(zi,a.B).then(function(a){a&&b&&(a.authDomain=b);return ui(a||{})})};var Y=function(a){this.Na=!1;Q(this,"app",a);if(X(this).options&&X(this).options.apiKey)a=firebase.SDK_VERSION?sf(firebase.SDK_VERSION):null,this.f=new T(X(this).options&&X(this).options.apiKey,null,a);else throw new R("invalid-api-key");this.U=[];this.La=[];this.ue=firebase.INTERNAL.createSubscribe(r(this.me,this));Ci(this,null);this.va=new yi(X(this).options.apiKey+":"+X(this).name);this.Ya=new wi(X(this).options.apiKey+":"+X(this).name);this.zb=this.c(Di(this));this.ra=this.c(Ei(this));this.yc=
	!1;this.uc=r(this.Ee,this);this.Dd=r(this.Ra,this);this.Ed=r(this.ie,this);this.Cd=r(this.he,this);Fi(this);this.INTERNAL={};this.INTERNAL.delete=r(this.delete,this)};Y.prototype.toJSON=function(){return{apiKey:X(this).options.apiKey,authDomain:X(this).options.authDomain,appName:X(this).name,currentUser:Z(this)&&Z(this).G()}};
	var Gi=function(a){return a.Wd||K(new R("auth-domain-config-required"))},Fi=function(a){var b=X(a).options.authDomain,c=X(a).options.apiKey;b&&vf()&&(a.Wd=a.zb.then(function(){if(!a.Na)return a.m=Rh(b,c,X(a).name),a.m.subscribe(a),Z(a)&&ei(Z(a)),a.Kc&&(ei(a.Kc),a.Kc=null),a.m}))};h=Y.prototype;h.Wc=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.ia==b&&!!this.$;default:return!1}};
	h.Ha=function(a,b,c,d){"signInViaPopup"==a&&this.ia==d&&(c&&this.Fa?this.Fa(c):b&&!c&&this.$&&this.$(b),this.C&&(this.C.cancel(),this.C=null),delete this.$,delete this.Fa)};h.lb=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.ia==b&&this.$?r(this.Zd,this):null};
	h.Zd=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.C&&(this.C.cancel(),this.C=null);var d=null,e=S(c.f,Nf,a).then(function(a){d=Zf(a);return a});a=c.zb.then(function(){return e}).then(function(a){return Hi(c,a)}).then(function(){return{user:Z(c),credential:d}});return this.c(a)};h.Fb=function(){return uf()};
	h.signInWithPopup=function(a){if(!vf())return K(new R("operation-not-supported-in-this-environment"));var b=this,c=Gf(a.providerId),d=this.Fb(),e=null;!wf()&&X(this).options.authDomain&&a.isOAuthProvider&&(e=Sg(X(this).options.authDomain,X(this).options.apiKey,X(this).name,"signInViaPopup",a.providerId,a.Hb(),null,d,firebase.SDK_VERSION||null));var f=nf(e,c&&c.tb,c&&c.sb),c=Gi(this).then(function(b){return Nh(b,f,"signInViaPopup",a,d,!!e)}).then(function(){return new I(function(a,c){b.Ha("signInViaPopup",
	null,new R("cancelled-popup-request"),b.ia);b.$=a;b.Fa=c;b.ia=d;b.C=Ph(b.m,b,"signInViaPopup",f,d)})}).then(function(a){f&&mf(f);return a}).l(function(a){f&&mf(f);throw a;});return this.c(c)};h.signInWithRedirect=function(a){if(!vf())return K(new R("operation-not-supported-in-this-environment"));var b=this,c=Gi(this).then(function(){return Oh(b.m,"signInViaRedirect",a)});return this.c(c)};
	h.getRedirectResult=function(){if(!vf())return K(new R("operation-not-supported-in-this-environment"));var a=this,b=Gi(this).then(function(){return a.m.getRedirectResult()});return this.c(b)};
	var Hi=function(a,b){var c={};c.apiKey=X(a).options.apiKey;c.authDomain=X(a).options.authDomain;c.appName=X(a).name;return a.zb.then(function(){return vi(c,b,a.Ya)}).then(function(b){if(Z(a)&&b.uid==Z(a).uid)return Z(a).copy(b),a.Ra(b);Ci(a,b);ei(b);return a.Ra(b)}).then(function(){a.Da()})},Ci=function(a,b){Z(a)&&(ci(Z(a),a.Dd),gc(Z(a),"tokenChanged",a.Ed),gc(Z(a),"userDeleted",a.Cd));b&&(b.cc.push(a.Dd),Yb(b,"tokenChanged",a.Ed),Yb(b,"userDeleted",a.Cd));Q(a,"currentUser",b)};
	Y.prototype.signOut=function(){var a=this,b=this.ra.then(function(){if(!Z(a))return J();Ci(a,null);return Ai(a.va).then(function(){a.Da()})});return this.c(b)};
	var Ii=function(a){var b=xi(a.Ya,X(a).options.authDomain).then(function(b){if(a.Kc=b)b.Ga=a.Ya;return ti(a.Ya)});return a.c(b)},Di=function(a){var b=X(a).options.authDomain,c=Ii(a).then(function(){return Bi(a.va,b)}).then(function(b){return b?(b.Ga=a.Ya,b.reload().then(function(){return b}).l(function(c){return"auth/network-request-failed"==c.code?b:Ai(a.va)})):null}).then(function(b){Ci(a,b||null)});return a.c(c)},Ei=function(a){return a.zb.then(function(){return a.getRedirectResult()}).l(function(){}).then(function(){if(!a.Na)return a.uc()}).l(function(){}).then(function(){if(!a.Na){a.yc=
	!0;var b=a.va;b.A.addListener(zi,b.B,a.uc)}})};Y.prototype.Ee=function(){var a=this;return Bi(this.va,X(this).options.authDomain).then(function(b){if(!a.Na){var c;if(c=Z(a)&&b){c=Z(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return Z(a).copy(b),Z(a).getToken();if(Z(a)||b)Ci(a,b),b&&(ei(b),b.Ga=a.Ya),a.m&&a.m.subscribe(a),a.Da()}})};Y.prototype.Ra=function(a){var b=this.va;return b.A.set(zi,a.G(),b.B)};Y.prototype.ie=function(){this.Da();this.Ra(Z(this))};
	Y.prototype.he=function(){this.signOut()};var Ji=function(a,b){return a.c(b.then(function(b){return Hi(a,b)}).then(function(){return Z(a)}))};h=Y.prototype;h.me=function(a){var b=this;this.addAuthTokenListener(function(){a.next(Z(b))})};h.onAuthStateChanged=function(a,b,c){var d=this;this.yc&&firebase.Promise.resolve().then(function(){p(a)?a(Z(d)):p(a.next)&&a.next(Z(d))});return this.ue(a,b,c)};
	h.getToken=function(a){var b=this,c=this.ra.then(function(){return Z(b)?Z(b).getToken(a).then(function(a){return{accessToken:a}}):null});return this.c(c)};h.signInWithCustomToken=function(a){var b=this;return this.ra.then(function(){return Ji(b,S(b.f,Hg,{token:a}))}).then(function(a){ki(a,"isAnonymous",!1);return b.Ra(a)}).then(function(){return Z(b)})};h.signInWithEmailAndPassword=function(a,b){var c=this;return this.ra.then(function(){return Ji(c,S(c.f,Vf,{email:a,password:b}))})};
	h.createUserWithEmailAndPassword=function(a,b){var c=this;return this.ra.then(function(){return Ji(c,S(c.f,Eg,{email:a,password:b}))})};h.signInWithCredential=function(a){var b=this;return this.ra.then(function(){return Ji(b,a.Gb(b.f))})};h.signInAnonymously=function(){var a=Z(this),b=this;return a&&a.isAnonymous?J(a):this.ra.then(function(){return Ji(b,b.f.signInAnonymously())}).then(function(a){ki(a,"isAnonymous",!0);return b.Ra(a)}).then(function(){return Z(b)})};
	var X=function(a){return a.app},Z=function(a){return a.currentUser};h=Y.prototype;h.Da=function(){if(this.yc)for(var a=0;a<this.La.length;a++)if(this.La[a])this.La[a](Z(this)&&Z(this)._lat||null)};h.addAuthTokenListener=function(a){var b=this;this.La.push(a);this.c(this.ra.then(function(){b.Na||Ia(b.La,a)&&a(Z(b)&&Z(b)._lat||null)}))};h.removeAuthTokenListener=function(a){La(this.La,function(b){return b==a})};
	h.delete=function(){this.Na=!0;for(var a=0;a<this.U.length;a++)this.U[a].cancel("app-deleted");this.U=[];this.va&&(a=this.va,a.A.removeListener(zi,a.B,this.uc));this.m&&this.m.unsubscribe(this);return firebase.Promise.resolve()};h.c=function(a){var b=this;this.U.push(a);wd(a,function(){Ka(b.U,a)});return a};h.fetchProvidersForEmail=function(a){return this.c(ng(this.f,a))};h.verifyPasswordResetCode=function(a){return this.checkActionCode(a).then(function(a){return a.data.email})};
	h.confirmPasswordReset=function(a,b){return this.c(this.f.confirmPasswordReset(a,b).then(function(){}))};h.checkActionCode=function(a){return this.c(this.f.checkActionCode(a).then(function(a){return{data:{email:a.email}}}))};h.applyActionCode=function(a){return this.c(this.f.applyActionCode(a).then(function(){}))};h.sendPasswordResetEmail=function(a){return this.c(this.f.sendPasswordResetEmail(a).then(function(){}))};uh(Y.prototype,{applyActionCode:{name:"applyActionCode",b:[U("code")]},checkActionCode:{name:"checkActionCode",b:[U("code")]},confirmPasswordReset:{name:"confirmPasswordReset",b:[U("code"),U("newPassword")]},createUserWithEmailAndPassword:{name:"createUserWithEmailAndPassword",b:[U("email"),U("password")]},fetchProvidersForEmail:{name:"fetchProvidersForEmail",b:[U("email")]},getRedirectResult:{name:"getRedirectResult",b:[]},onAuthStateChanged:{name:"onAuthStateChanged",b:[sh(nh(),oh(),"nextOrObserver"),
	oh("opt_error",!0),oh("opt_completed",!0)]},sendPasswordResetEmail:{name:"sendPasswordResetEmail",b:[U("email")]},signInAnonymously:{name:"signInAnonymously",b:[]},signInWithCredential:{name:"signInWithCredential",b:[qh()]},signInWithCustomToken:{name:"signInWithCustomToken",b:[U("token")]},signInWithEmailAndPassword:{name:"signInWithEmailAndPassword",b:[U("email"),U("password")]},signInWithPopup:{name:"signInWithPopup",b:[rh()]},signInWithRedirect:{name:"signInWithRedirect",b:[rh()]},signOut:{name:"signOut",
	b:[]},toJSON:{name:"toJSON",b:[U(null,!0)]},verifyPasswordResetCode:{name:"verifyPasswordResetCode",b:[U("code")]}});
	uh(W.prototype,{"delete":{name:"delete",b:[]},getToken:{name:"getToken",b:[{name:"opt_forceRefresh",ca:"a boolean",optional:!0,da:function(a){return"boolean"==typeof a}}]},link:{name:"link",b:[qh()]},linkWithPopup:{name:"linkWithPopup",b:[rh()]},linkWithRedirect:{name:"linkWithRedirect",b:[rh()]},reauthenticate:{name:"reauthenticate",b:[qh()]},reload:{name:"reload",b:[]},sendEmailVerification:{name:"sendEmailVerification",b:[]},toJSON:{name:"toJSON",b:[U(null,!0)]},unlink:{name:"unlink",b:[U("provider")]},
	updateEmail:{name:"updateEmail",b:[U("email")]},updatePassword:{name:"updatePassword",b:[U("password")]},updateProfile:{name:"updateProfile",b:[nh("profile")]}});uh(I.prototype,{l:{name:"catch"},then:{name:"then"}});V(Xf,"credential",function(a,b){return new Uf(a,b)},[U("email"),U("password")]);uh(Qf.prototype,{addScope:{name:"addScope",b:[U("scope")]}});V(Qf,"credential",Qf.credential,[sh(U(),nh(),"token")]);uh(Rf.prototype,{addScope:{name:"addScope",b:[U("scope")]}});
	V(Rf,"credential",Rf.credential,[sh(U(),nh(),"token")]);uh(Sf.prototype,{addScope:{name:"addScope",b:[U("scope")]}});V(Sf,"credential",Sf.credential,[sh(U(),sh(nh(),ph()),"idToken"),sh(U(),ph(),"accessToken",!0)]);V(Tf,"credential",Tf.credential,[sh(U(),nh(),"token"),U("secret",!0)]);
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:Y,Error:R};V(a,"EmailAuthProvider",Xf,[]);V(a,"FacebookAuthProvider",Qf,[]);V(a,"GithubAuthProvider",Rf,[]);V(a,"GoogleAuthProvider",Sf,[]);V(a,"TwitterAuthProvider",Tf,[]);firebase.INTERNAL.registerService("auth",function(a,c){a=new Y(a);c({INTERNAL:{getToken:r(a.getToken,a),addAuthTokenListener:r(a.addAuthTokenListener,a),removeAuthTokenListener:r(a.removeAuthTokenListener,a)}});return a},
	a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:W})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();})();
	(function() {var h,n=this;function p(a){return void 0!==a}function aa(){}function ba(a){a.Wb=function(){return a.bf?a.bf:a.bf=new a}}
	function ca(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function da(a){return"array"==ca(a)}function ea(a){var b=ca(a);return"array"==b||"object"==b&&"number"==typeof a.length}function q(a){return"string"==typeof a}function fa(a){return"number"==typeof a}function ga(a){return"function"==ca(a)}function ha(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}function ia(a,b,c){return a.call.apply(a.bind,arguments)}
	function ja(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){r=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ia:ja;return r.apply(null,arguments)}
	function ka(a,b){function c(){}c.prototype=b.prototype;a.Ig=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Eg=function(a,c,f){for(var g=Array(arguments.length-2),k=2;k<arguments.length;k++)g[k-2]=arguments[k];return b.prototype[c].apply(a,g)}};function la(){this.Ya=-1};function ma(){this.Ya=-1;this.Ya=64;this.N=[];this.Wd=[];this.Jf=[];this.zd=[];this.zd[0]=128;for(var a=1;a<this.Ya;++a)this.zd[a]=0;this.Pd=this.ac=0;this.reset()}ka(ma,la);ma.prototype.reset=function(){this.N[0]=1732584193;this.N[1]=4023233417;this.N[2]=2562383102;this.N[3]=271733878;this.N[4]=3285377520;this.Pd=this.ac=0};
	function na(a,b,c){c||(c=0);var d=a.Jf;if(q(b))for(var e=0;16>e;e++)d[e]=b.charCodeAt(c)<<24|b.charCodeAt(c+1)<<16|b.charCodeAt(c+2)<<8|b.charCodeAt(c+3),c+=4;else for(e=0;16>e;e++)d[e]=b[c]<<24|b[c+1]<<16|b[c+2]<<8|b[c+3],c+=4;for(e=16;80>e;e++){var f=d[e-3]^d[e-8]^d[e-14]^d[e-16];d[e]=(f<<1|f>>>31)&4294967295}b=a.N[0];c=a.N[1];for(var g=a.N[2],k=a.N[3],m=a.N[4],l,e=0;80>e;e++)40>e?20>e?(f=k^c&(g^k),l=1518500249):(f=c^g^k,l=1859775393):60>e?(f=c&g|k&(c|g),l=2400959708):(f=c^g^k,l=3395469782),f=(b<<
	5|b>>>27)+f+m+l+d[e]&4294967295,m=k,k=g,g=(c<<30|c>>>2)&4294967295,c=b,b=f;a.N[0]=a.N[0]+b&4294967295;a.N[1]=a.N[1]+c&4294967295;a.N[2]=a.N[2]+g&4294967295;a.N[3]=a.N[3]+k&4294967295;a.N[4]=a.N[4]+m&4294967295}
	ma.prototype.update=function(a,b){if(null!=a){p(b)||(b=a.length);for(var c=b-this.Ya,d=0,e=this.Wd,f=this.ac;d<b;){if(0==f)for(;d<=c;)na(this,a,d),d+=this.Ya;if(q(a))for(;d<b;){if(e[f]=a.charCodeAt(d),++f,++d,f==this.Ya){na(this,e);f=0;break}}else for(;d<b;)if(e[f]=a[d],++f,++d,f==this.Ya){na(this,e);f=0;break}}this.ac=f;this.Pd+=b}};function t(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function oa(a,b){var c={},d;for(d in a)c[d]=b.call(void 0,a[d],d,a);return c}function pa(a,b){for(var c in a)if(!b.call(void 0,a[c],c,a))return!1;return!0}function qa(a){var b=0,c;for(c in a)b++;return b}function ra(a){for(var b in a)return b}function sa(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function ta(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function ua(a,b){for(var c in a)if(a[c]==b)return!0;return!1}
	function va(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d}function wa(a,b){var c=va(a,b,void 0);return c&&a[c]}function xa(a){for(var b in a)return!1;return!0}function ya(a){var b={},c;for(c in a)b[c]=a[c];return b};function za(a){a=String(a);if(/^\s*$/.test(a)?0:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,"")))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function Aa(){this.Fd=void 0}
	function Ba(a,b,c){switch(typeof b){case "string":Ca(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?b:"null");break;case "boolean":c.push(b);break;case "undefined":c.push("null");break;case "object":if(null==b){c.push("null");break}if(da(b)){var d=b.length;c.push("[");for(var e="",f=0;f<d;f++)c.push(e),e=b[f],Ba(a,a.Fd?a.Fd.call(b,String(f),e):e,c),e=",";c.push("]");break}c.push("{");d="";for(f in b)Object.prototype.hasOwnProperty.call(b,f)&&(e=b[f],"function"!=typeof e&&(c.push(d),Ca(f,c),
	c.push(":"),Ba(a,a.Fd?a.Fd.call(b,f,e):e,c),d=","));c.push("}");break;case "function":break;default:throw Error("Unknown type: "+typeof b);}}var Da={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ea=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
	function Ca(a,b){b.push('"',a.replace(Ea,function(a){if(a in Da)return Da[a];var b=a.charCodeAt(0),e="\\u";16>b?e+="000":256>b?e+="00":4096>b&&(e+="0");return Da[a]=e+b.toString(16)}),'"')};var v;a:{var Fa=n.navigator;if(Fa){var Ga=Fa.userAgent;if(Ga){v=Ga;break a}}v=""};function Ha(a){if(Error.captureStackTrace)Error.captureStackTrace(this,Ha);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}ka(Ha,Error);Ha.prototype.name="CustomError";var w=Array.prototype,Ia=w.indexOf?function(a,b,c){return w.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(q(a))return q(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},Ja=w.forEach?function(a,b,c){w.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=q(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},Ka=w.filter?function(a,b,c){return w.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,g=q(a)?
	a.split(""):a,k=0;k<d;k++)if(k in g){var m=g[k];b.call(c,m,k,a)&&(e[f++]=m)}return e},La=w.map?function(a,b,c){return w.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=q(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Ma=w.reduce?function(a,b,c,d){for(var e=[],f=1,g=arguments.length;f<g;f++)e.push(arguments[f]);d&&(e[0]=r(b,d));return w.reduce.apply(a,e)}:function(a,b,c,d){var e=c;Ja(a,function(c,g){e=b.call(d,e,c,g,a)});return e},Na=w.every?function(a,b,
	c){return w.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=q(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};function Oa(a,b){var c=Pa(a,b,void 0);return 0>c?null:q(a)?a.charAt(c):a[c]}function Pa(a,b,c){for(var d=a.length,e=q(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}function Qa(a,b){var c=Ia(a,b);0<=c&&w.splice.call(a,c,1)}function Ra(a,b,c){return 2>=arguments.length?w.slice.call(a,b):w.slice.call(a,b,c)}
	function Sa(a,b){a.sort(b||Ta)}function Ta(a,b){return a>b?1:a<b?-1:0};var Ua=-1!=v.indexOf("Opera")||-1!=v.indexOf("OPR"),Va=-1!=v.indexOf("Trident")||-1!=v.indexOf("MSIE"),Wa=-1!=v.indexOf("Gecko")&&-1==v.toLowerCase().indexOf("webkit")&&!(-1!=v.indexOf("Trident")||-1!=v.indexOf("MSIE")),Xa=-1!=v.toLowerCase().indexOf("webkit");
	(function(){var a="",b;if(Ua&&n.opera)return a=n.opera.version,ga(a)?a():a;Wa?b=/rv\:([^\);]+)(\)|;)/:Va?b=/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/:Xa&&(b=/WebKit\/(\S+)/);b&&(a=(a=b.exec(v))?a[1]:"");return Va&&(b=(b=n.document)?b.documentMode:void 0,b>parseFloat(a))?String(b):a})();var Ya=null,Za=null,$a=null;function ab(a,b){if(!ea(a))throw Error("encodeByteArray takes an array as a parameter");bb();for(var c=b?Za:Ya,d=[],e=0;e<a.length;e+=3){var f=a[e],g=e+1<a.length,k=g?a[e+1]:0,m=e+2<a.length,l=m?a[e+2]:0,u=f>>2,f=(f&3)<<4|k>>4,k=(k&15)<<2|l>>6,l=l&63;m||(l=64,g||(k=64));d.push(c[u],c[f],c[k],c[l])}return d.join("")}
	function bb(){if(!Ya){Ya={};Za={};$a={};for(var a=0;65>a;a++)Ya[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Za[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a),$a[Za[a]]=a,62<=a&&($a["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a)]=a)}};function cb(a){n.setTimeout(function(){throw a;},0)}var db;
	function eb(){var a=n.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&-1==v.indexOf("Presto")&&(a=function(){var a=document.createElement("iframe");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host,a=r(function(a){if(("*"==d||a.origin==
	d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&-1==v.indexOf("Trident")&&-1==v.indexOf("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(p(c.next)){c=c.next;var a=c.Le;c.Le=null;a()}};return function(a){d.next={Le:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("script")?function(a){var b=
	document.createElement("script");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){n.setTimeout(a,0)}};function fb(a,b){gb||hb();ib||(gb(),ib=!0);jb.push(new kb(a,b))}var gb;function hb(){if(n.Promise&&n.Promise.resolve){var a=n.Promise.resolve();gb=function(){a.then(lb)}}else gb=function(){var a=lb;!ga(n.setImmediate)||n.Window&&n.Window.prototype&&n.Window.prototype.setImmediate==n.setImmediate?(db||(db=eb()),db(a)):n.setImmediate(a)}}var ib=!1,jb=[];[].push(function(){ib=!1;jb=[]});
	function lb(){for(;jb.length;){var a=jb;jb=[];for(var b=0;b<a.length;b++){var c=a[b];try{c.Wf.call(c.scope)}catch(d){cb(d)}}}ib=!1}function kb(a,b){this.Wf=a;this.scope=b};function mb(a,b){this.L=nb;this.uf=void 0;this.Ca=this.Ha=null;this.jd=this.be=!1;if(a==ob)pb(this,qb,b);else try{var c=this;a.call(b,function(a){pb(c,qb,a)},function(a){if(!(a instanceof rb))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(b){}pb(c,sb,a)})}catch(d){pb(this,sb,d)}}var nb=0,qb=2,sb=3;function ob(){}mb.prototype.then=function(a,b,c){return tb(this,ga(a)?a:null,ga(b)?b:null,c)};mb.prototype.then=mb.prototype.then;mb.prototype.$goog_Thenable=!0;h=mb.prototype;
	h.Ag=function(a,b){return tb(this,null,a,b)};h.cancel=function(a){this.L==nb&&fb(function(){var b=new rb(a);ub(this,b)},this)};function ub(a,b){if(a.L==nb)if(a.Ha){var c=a.Ha;if(c.Ca){for(var d=0,e=-1,f=0,g;g=c.Ca[f];f++)if(g=g.m)if(d++,g==a&&(e=f),0<=e&&1<d)break;0<=e&&(c.L==nb&&1==d?ub(c,b):(d=c.Ca.splice(e,1)[0],vb(c,d,sb,b)))}a.Ha=null}else pb(a,sb,b)}function wb(a,b){a.Ca&&a.Ca.length||a.L!=qb&&a.L!=sb||xb(a);a.Ca||(a.Ca=[]);a.Ca.push(b)}
	function tb(a,b,c,d){var e={m:null,hf:null,kf:null};e.m=new mb(function(a,g){e.hf=b?function(c){try{var e=b.call(d,c);a(e)}catch(l){g(l)}}:a;e.kf=c?function(b){try{var e=c.call(d,b);!p(e)&&b instanceof rb?g(b):a(e)}catch(l){g(l)}}:g});e.m.Ha=a;wb(a,e);return e.m}h.Cf=function(a){this.L=nb;pb(this,qb,a)};h.Df=function(a){this.L=nb;pb(this,sb,a)};
	function pb(a,b,c){if(a.L==nb){if(a==c)b=sb,c=new TypeError("Promise cannot resolve to itself");else{var d;if(c)try{d=!!c.$goog_Thenable}catch(e){d=!1}else d=!1;if(d){a.L=1;c.then(a.Cf,a.Df,a);return}if(ha(c))try{var f=c.then;if(ga(f)){yb(a,c,f);return}}catch(g){b=sb,c=g}}a.uf=c;a.L=b;a.Ha=null;xb(a);b!=sb||c instanceof rb||zb(a,c)}}function yb(a,b,c){function d(b){f||(f=!0,a.Df(b))}function e(b){f||(f=!0,a.Cf(b))}a.L=1;var f=!1;try{c.call(b,e,d)}catch(g){d(g)}}
	function xb(a){a.be||(a.be=!0,fb(a.Uf,a))}h.Uf=function(){for(;this.Ca&&this.Ca.length;){var a=this.Ca;this.Ca=null;for(var b=0;b<a.length;b++)vb(this,a[b],this.L,this.uf)}this.be=!1};function vb(a,b,c,d){if(c==qb)b.hf(d);else{if(b.m)for(;a&&a.jd;a=a.Ha)a.jd=!1;b.kf(d)}}function zb(a,b){a.jd=!0;fb(function(){a.jd&&Ab.call(null,b)})}var Ab=cb;function rb(a){Ha.call(this,a)}ka(rb,Ha);rb.prototype.name="cancel";function Bb(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function x(a,b){if(Object.prototype.hasOwnProperty.call(a,b))return a[b]}function Cb(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])};function y(a,b,c,d){var e;d<b?e="at least "+b:d>c&&(e=0===c?"none":"no more than "+c);if(e)throw Error(a+" failed: Was called with "+d+(1===d?" argument.":" arguments.")+" Expects "+e+".");}function Db(a,b,c){var d="";switch(b){case 1:d=c?"first":"First";break;case 2:d=c?"second":"Second";break;case 3:d=c?"third":"Third";break;case 4:d=c?"fourth":"Fourth";break;default:throw Error("errorPrefix called with argumentNumber > 4.  Need to update it?");}return a=a+" failed: "+(d+" argument ")}
	function A(a,b,c,d){if((!d||p(c))&&!ga(c))throw Error(Db(a,b,d)+"must be a valid function.");}function Eb(a,b,c){if(p(c)&&(!ha(c)||null===c))throw Error(Db(a,b,!0)+"must be a valid context object.");};function Fb(a){var b=[];Cb(a,function(a,d){da(d)?Ja(d,function(d){b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))}):b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))});return b.length?"&"+b.join("&"):""};var Gb=n.Promise||mb;mb.prototype["catch"]=mb.prototype.Ag;function Hb(){var a=this;this.reject=this.resolve=null;this.ra=new Gb(function(b,c){a.resolve=b;a.reject=c})}function Ib(a,b){return function(c,d){c?a.reject(c):a.resolve(d);ga(b)&&(Jb(a.ra),1===b.length?b(c):b(c,d))}}function Jb(a){a.then(void 0,aa)};function Kb(a,b){if(!a)throw Lb(b);}function Lb(a){return Error("Firebase Database ("+firebase.SDK_VERSION+") INTERNAL ASSERT FAILED: "+a)};function Mb(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);55296<=e&&56319>=e&&(e-=55296,d++,Kb(d<a.length,"Surrogate pair missing trail surrogate."),e=65536+(e<<10)+(a.charCodeAt(d)-56320));128>e?b[c++]=e:(2048>e?b[c++]=e>>6|192:(65536>e?b[c++]=e>>12|224:(b[c++]=e>>18|240,b[c++]=e>>12&63|128),b[c++]=e>>6&63|128),b[c++]=e&63|128)}return b}function Nb(a){for(var b=0,c=0;c<a.length;c++){var d=a.charCodeAt(c);128>d?b++:2048>d?b+=2:55296<=d&&56319>=d?(b+=4,c++):b+=3}return b};function Ob(a){return"undefined"!==typeof JSON&&p(JSON.parse)?JSON.parse(a):za(a)}function B(a){if("undefined"!==typeof JSON&&p(JSON.stringify))a=JSON.stringify(a);else{var b=[];Ba(new Aa,a,b);a=b.join("")}return a};function Pb(a,b){this.committed=a;this.snapshot=b};function Qb(){return"undefined"!==typeof window&&!!(window.cordova||window.phonegap||window.PhoneGap)&&/ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test("undefined"!==typeof navigator&&"string"===typeof navigator.userAgent?navigator.userAgent:"")};function Rb(a){this.te=a;this.Bd=[];this.Rb=0;this.Yd=-1;this.Gb=null}function Sb(a,b,c){a.Yd=b;a.Gb=c;a.Yd<a.Rb&&(a.Gb(),a.Gb=null)}function Tb(a,b,c){for(a.Bd[b]=c;a.Bd[a.Rb];){var d=a.Bd[a.Rb];delete a.Bd[a.Rb];for(var e=0;e<d.length;++e)if(d[e]){var f=a;Ub(function(){f.te(d[e])})}if(a.Rb===a.Yd){a.Gb&&(clearTimeout(a.Gb),a.Gb(),a.Gb=null);break}a.Rb++}};function Vb(){this.qc={}}Vb.prototype.set=function(a,b){null==b?delete this.qc[a]:this.qc[a]=b};Vb.prototype.get=function(a){return Bb(this.qc,a)?this.qc[a]:null};Vb.prototype.remove=function(a){delete this.qc[a]};Vb.prototype.cf=!0;function Wb(a){this.vc=a;this.Cd="firebase:"}h=Wb.prototype;h.set=function(a,b){null==b?this.vc.removeItem(this.Cd+a):this.vc.setItem(this.Cd+a,B(b))};h.get=function(a){a=this.vc.getItem(this.Cd+a);return null==a?null:Ob(a)};h.remove=function(a){this.vc.removeItem(this.Cd+a)};h.cf=!1;h.toString=function(){return this.vc.toString()};function Xb(a){try{if("undefined"!==typeof window&&"undefined"!==typeof window[a]){var b=window[a];b.setItem("firebase:sentinel","cache");b.removeItem("firebase:sentinel");return new Wb(b)}}catch(c){}return new Vb}var Yb=Xb("localStorage"),Zb=Xb("sessionStorage");function $b(a,b,c){this.type=ac;this.source=a;this.path=b;this.Ja=c}$b.prototype.Nc=function(a){return this.path.e()?new $b(this.source,C,this.Ja.R(a)):new $b(this.source,D(this.path),this.Ja)};$b.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" overwrite: "+this.Ja.toString()+")"};function bc(a,b){this.type=cc;this.source=a;this.path=b}bc.prototype.Nc=function(){return this.path.e()?new bc(this.source,C):new bc(this.source,D(this.path))};bc.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" listen_complete)"};function dc(a){this.He=a}dc.prototype.getToken=function(a){return this.He.INTERNAL.getToken(a).then(null,function(a){return a&&"auth/token-not-initialized"===a.code?(E("Got auth/token-not-initialized error.  Treating as null token."),null):Promise.reject(a)})};function ec(a,b){a.He.INTERNAL.addAuthTokenListener(b)};function fc(){this.Jd=F}fc.prototype.j=function(a){return this.Jd.Q(a)};fc.prototype.toString=function(){return this.Jd.toString()};function gc(a,b,c,d,e){this.host=a.toLowerCase();this.domain=this.host.substr(this.host.indexOf(".")+1);this.Sc=b;this.pe=c;this.Cg=d;this.nf=e||"";this.bb=Yb.get("host:"+a)||this.host}function hc(a,b){b!==a.bb&&(a.bb=b,"s-"===a.bb.substr(0,2)&&Yb.set("host:"+a.host,a.bb))}
	function ic(a,b,c){H("string"===typeof b,"typeof type must == string");H("object"===typeof c,"typeof params must == object");if("websocket"===b)b=(a.Sc?"wss://":"ws://")+a.bb+"/.ws?";else if("long_polling"===b)b=(a.Sc?"https://":"http://")+a.bb+"/.lp?";else throw Error("Unknown connection type: "+b);a.host!==a.bb&&(c.ns=a.pe);var d=[];t(c,function(a,b){d.push(b+"="+a)});return b+d.join("&")}
	gc.prototype.toString=function(){var a=(this.Sc?"https://":"http://")+this.host;this.nf&&(a+="<"+this.nf+">");return a};function jc(a,b){this.zf={};this.Vc=new kc(a);this.va=b;var c=1E4+2E4*Math.random();setTimeout(r(this.rf,this),Math.floor(c))}jc.prototype.rf=function(){var a=this.Vc.get(),b={},c=!1,d;for(d in a)0<a[d]&&Bb(this.zf,d)&&(b[d]=a[d],c=!0);c&&this.va.ye(b);setTimeout(r(this.rf,this),Math.floor(6E5*Math.random()))};function lc(){this.uc={}}function mc(a,b,c){p(c)||(c=1);Bb(a.uc,b)||(a.uc[b]=0);a.uc[b]+=c}lc.prototype.get=function(){return ya(this.uc)};function kc(a){this.Nf=a;this.rd=null}kc.prototype.get=function(){var a=this.Nf.get(),b=ya(a);if(this.rd)for(var c in this.rd)b[c]-=this.rd[c];this.rd=a;return b};var nc={},oc={};function pc(a){a=a.toString();nc[a]||(nc[a]=new lc);return nc[a]}function qc(a,b){var c=a.toString();oc[c]||(oc[c]=b());return oc[c]};function rc(){this.wb=[]}function sc(a,b){for(var c=null,d=0;d<b.length;d++){var e=b[d],f=e.Zb();null===c||f.ca(c.Zb())||(a.wb.push(c),c=null);null===c&&(c=new tc(f));c.add(e)}c&&a.wb.push(c)}function uc(a,b,c){sc(a,c);vc(a,function(a){return a.ca(b)})}function wc(a,b,c){sc(a,c);vc(a,function(a){return a.contains(b)||b.contains(a)})}
	function vc(a,b){for(var c=!0,d=0;d<a.wb.length;d++){var e=a.wb[d];if(e)if(e=e.Zb(),b(e)){for(var e=a.wb[d],f=0;f<e.hd.length;f++){var g=e.hd[f];if(null!==g){e.hd[f]=null;var k=g.Ub();xc&&E("event: "+g.toString());Ub(k)}}a.wb[d]=null}else c=!1}c&&(a.wb=[])}function tc(a){this.qa=a;this.hd=[]}tc.prototype.add=function(a){this.hd.push(a)};tc.prototype.Zb=function(){return this.qa};function yc(a,b,c,d){this.ae=b;this.Md=c;this.Dd=d;this.gd=a}yc.prototype.Zb=function(){var a=this.Md.xb();return"value"===this.gd?a.path:a.getParent().path};yc.prototype.ge=function(){return this.gd};yc.prototype.Ub=function(){return this.ae.Ub(this)};yc.prototype.toString=function(){return this.Zb().toString()+":"+this.gd+":"+B(this.Md.Ue())};function zc(a,b,c){this.ae=a;this.error=b;this.path=c}zc.prototype.Zb=function(){return this.path};zc.prototype.ge=function(){return"cancel"};
	zc.prototype.Ub=function(){return this.ae.Ub(this)};zc.prototype.toString=function(){return this.path.toString()+":cancel"};function Ac(){}Ac.prototype.Xe=function(){return null};Ac.prototype.fe=function(){return null};var Bc=new Ac;function Cc(a,b,c){this.Gf=a;this.Na=b;this.yd=c}Cc.prototype.Xe=function(a){var b=this.Na.O;if(Dc(b,a))return b.j().R(a);b=null!=this.yd?new Ec(this.yd,!0,!1):this.Na.u();return this.Gf.rc(a,b)};Cc.prototype.fe=function(a,b,c){var d=null!=this.yd?this.yd:Fc(this.Na);a=this.Gf.Xd(d,b,1,c,a);return 0===a.length?null:a[0]};function I(a,b,c,d){this.type=a;this.Ma=b;this.Za=c;this.qe=d;this.Dd=void 0}function Gc(a){return new I(Hc,a)}var Hc="value";function Ec(a,b,c){this.A=a;this.ea=b;this.Tb=c}function Ic(a){return a.ea}function Jc(a){return a.Tb}function Kc(a,b){return b.e()?a.ea&&!a.Tb:Dc(a,J(b))}function Dc(a,b){return a.ea&&!a.Tb||a.A.Fa(b)}Ec.prototype.j=function(){return this.A};function Lc(a,b){return Mc(a.name,b.name)}function Nc(a,b){return Mc(a,b)};function K(a,b){this.name=a;this.S=b}function Oc(a,b){return new K(a,b)};function Pc(a,b){return a&&"object"===typeof a?(H(".sv"in a,"Unexpected leaf node or priority contents"),b[a[".sv"]]):a}function Qc(a,b){var c=new Rc;Sc(a,new L(""),function(a,e){Tc(c,a,Uc(e,b))});return c}function Uc(a,b){var c=a.C().H(),c=Pc(c,b),d;if(a.J()){var e=Pc(a.Ea(),b);return e!==a.Ea()||c!==a.C().H()?new Vc(e,M(c)):a}d=a;c!==a.C().H()&&(d=d.ga(new Vc(c)));a.P(N,function(a,c){var e=Uc(c,b);e!==c&&(d=d.U(a,e))});return d};var Wc=function(){var a=1;return function(){return a++}}(),H=Kb,Xc=Lb;
	function Yc(a){try{var b;bb();for(var c=$a,d=[],e=0;e<a.length;){var f=c[a.charAt(e++)],g=e<a.length?c[a.charAt(e)]:0;++e;var k=e<a.length?c[a.charAt(e)]:64;++e;var m=e<a.length?c[a.charAt(e)]:64;++e;if(null==f||null==g||null==k||null==m)throw Error();d.push(f<<2|g>>4);64!=k&&(d.push(g<<4&240|k>>2),64!=m&&d.push(k<<6&192|m))}if(8192>d.length)b=String.fromCharCode.apply(null,d);else{a="";for(c=0;c<d.length;c+=8192)a+=String.fromCharCode.apply(null,Ra(d,c,c+8192));b=a}return b}catch(l){E("base64Decode failed: ",
	l)}return null}function Zc(a){var b=Mb(a);a=new ma;a.update(b);var b=[],c=8*a.Pd;56>a.ac?a.update(a.zd,56-a.ac):a.update(a.zd,a.Ya-(a.ac-56));for(var d=a.Ya-1;56<=d;d--)a.Wd[d]=c&255,c/=256;na(a,a.Wd);for(d=c=0;5>d;d++)for(var e=24;0<=e;e-=8)b[c]=a.N[d]>>e&255,++c;return ab(b)}function $c(a){for(var b="",c=0;c<arguments.length;c++)b=ea(arguments[c])?b+$c.apply(null,arguments[c]):"object"===typeof arguments[c]?b+B(arguments[c]):b+arguments[c],b+=" ";return b}var xc=null,ad=!0;
	function bd(a,b){Kb(!b||!0===a||!1===a,"Can't turn on custom loggers persistently.");!0===a?("undefined"!==typeof console&&("function"===typeof console.log?xc=r(console.log,console):"object"===typeof console.log&&(xc=function(a){console.log(a)})),b&&Zb.set("logging_enabled",!0)):ga(a)?xc=a:(xc=null,Zb.remove("logging_enabled"))}function E(a){!0===ad&&(ad=!1,null===xc&&!0===Zb.get("logging_enabled")&&bd(!0));if(xc){var b=$c.apply(null,arguments);xc(b)}}
	function cd(a){return function(){E(a,arguments)}}function dd(a){if("undefined"!==typeof console){var b="FIREBASE INTERNAL ERROR: "+$c.apply(null,arguments);"undefined"!==typeof console.error?console.error(b):console.log(b)}}function ed(a){var b=$c.apply(null,arguments);throw Error("FIREBASE FATAL ERROR: "+b);}function O(a){if("undefined"!==typeof console){var b="FIREBASE WARNING: "+$c.apply(null,arguments);"undefined"!==typeof console.warn?console.warn(b):console.log(b)}}
	function fd(a){var b,c,d,e,f,g=a;f=c=a=b="";d=!0;e="https";if(q(g)){var k=g.indexOf("//");0<=k&&(e=g.substring(0,k-1),g=g.substring(k+2));k=g.indexOf("/");-1===k&&(k=g.length);b=g.substring(0,k);f="";g=g.substring(k).split("/");for(k=0;k<g.length;k++)if(0<g[k].length){var m=g[k];try{m=decodeURIComponent(m.replace(/\+/g," "))}catch(l){}f+="/"+m}g=b.split(".");3===g.length?(a=g[1],c=g[0].toLowerCase()):2===g.length&&(a=g[0]);k=b.indexOf(":");0<=k&&(d="https"===e||"wss"===e)}"firebase"===a&&ed(b+" is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead");
	c&&"undefined"!=c||ed("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");d||"undefined"!==typeof window&&window.location&&window.location.protocol&&-1!==window.location.protocol.indexOf("https:")&&O("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");return{kc:new gc(b,d,c,"ws"===e||"wss"===e),path:new L(f)}}function gd(a){return fa(a)&&(a!=a||a==Number.POSITIVE_INFINITY||a==Number.NEGATIVE_INFINITY)}
	function hd(a){if("complete"===document.readyState)a();else{var b=!1,c=function(){document.body?b||(b=!0,a()):setTimeout(c,Math.floor(10))};document.addEventListener?(document.addEventListener("DOMContentLoaded",c,!1),window.addEventListener("load",c,!1)):document.attachEvent&&(document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&c()}),window.attachEvent("onload",c))}}
	function Mc(a,b){if(a===b)return 0;if("[MIN_NAME]"===a||"[MAX_NAME]"===b)return-1;if("[MIN_NAME]"===b||"[MAX_NAME]"===a)return 1;var c=id(a),d=id(b);return null!==c?null!==d?0==c-d?a.length-b.length:c-d:-1:null!==d?1:a<b?-1:1}function jd(a,b){if(b&&a in b)return b[a];throw Error("Missing required key ("+a+") in object: "+B(b));}
	function kd(a){if("object"!==typeof a||null===a)return B(a);var b=[],c;for(c in a)b.push(c);b.sort();c="{";for(var d=0;d<b.length;d++)0!==d&&(c+=","),c+=B(b[d]),c+=":",c+=kd(a[b[d]]);return c+"}"}function ld(a,b){if(a.length<=b)return[a];for(var c=[],d=0;d<a.length;d+=b)d+b>a?c.push(a.substring(d,a.length)):c.push(a.substring(d,d+b));return c}function md(a,b){if(da(a))for(var c=0;c<a.length;++c)b(c,a[c]);else t(a,b)}
	function nd(a){H(!gd(a),"Invalid JSON number");var b,c,d,e;0===a?(d=c=0,b=-Infinity===1/a?1:0):(b=0>a,a=Math.abs(a),a>=Math.pow(2,-1022)?(d=Math.min(Math.floor(Math.log(a)/Math.LN2),1023),c=d+1023,d=Math.round(a*Math.pow(2,52-d)-Math.pow(2,52))):(c=0,d=Math.round(a/Math.pow(2,-1074))));e=[];for(a=52;a;--a)e.push(d%2?1:0),d=Math.floor(d/2);for(a=11;a;--a)e.push(c%2?1:0),c=Math.floor(c/2);e.push(b?1:0);e.reverse();b=e.join("");c="";for(a=0;64>a;a+=8)d=parseInt(b.substr(a,8),2).toString(16),1===d.length&&
	(d="0"+d),c+=d;return c.toLowerCase()}var od=/^-?\d{1,10}$/;function id(a){return od.test(a)&&(a=Number(a),-2147483648<=a&&2147483647>=a)?a:null}function Ub(a){try{a()}catch(b){setTimeout(function(){O("Exception was thrown by user callback.",b.stack||"");throw b;},Math.floor(0))}}function pd(a,b,c){Object.defineProperty(a,b,{get:c})};function qd(a){var b={},c={},d={},e="";try{var f=a.split("."),b=Ob(Yc(f[0])||""),c=Ob(Yc(f[1])||""),e=f[2],d=c.d||{};delete c.d}catch(g){}return{Fg:b,Me:c,data:d,xg:e}}function rd(a){a=qd(a);var b=a.Me;return!!a.xg&&!!b&&"object"===typeof b&&b.hasOwnProperty("iat")}function sd(a){a=qd(a).Me;return"object"===typeof a&&!0===x(a,"admin")};var ud=null;"undefined"!==typeof MozWebSocket?ud=MozWebSocket:"undefined"!==typeof WebSocket&&(ud=WebSocket);function vd(a,b,c,d){this.Zd=a;this.f=cd(this.Zd);this.frames=this.Ac=null;this.qb=this.rb=this.Fe=0;this.Xa=pc(b);a={v:"5"};"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");c&&(a.s=c);d&&(a.ls=d);this.Ne=ic(b,"websocket",a)}var wd;
	vd.prototype.open=function(a,b){this.kb=b;this.hg=a;this.f("Websocket connecting to "+this.Ne);this.xc=!1;Yb.set("previous_websocket_failure",!0);try{this.La=new ud(this.Ne)}catch(c){this.f("Error instantiating WebSocket.");var d=c.message||c.data;d&&this.f(d);this.fb();return}var e=this;this.La.onopen=function(){e.f("Websocket connected.");e.xc=!0};this.La.onclose=function(){e.f("Websocket connection was disconnected.");e.La=null;e.fb()};this.La.onmessage=function(a){if(null!==e.La)if(a=a.data,e.qb+=
	a.length,mc(e.Xa,"bytes_received",a.length),xd(e),null!==e.frames)yd(e,a);else{a:{H(null===e.frames,"We already have a frame buffer");if(6>=a.length){var b=Number(a);if(!isNaN(b)){e.Fe=b;e.frames=[];a=null;break a}}e.Fe=1;e.frames=[]}null!==a&&yd(e,a)}};this.La.onerror=function(a){e.f("WebSocket error.  Closing connection.");(a=a.message||a.data)&&e.f(a);e.fb()}};vd.prototype.start=function(){};
	vd.isAvailable=function(){var a=!1;if("undefined"!==typeof navigator&&navigator.userAgent){var b=navigator.userAgent.match(/Android ([0-9]{0,}\.[0-9]{0,})/);b&&1<b.length&&4.4>parseFloat(b[1])&&(a=!0)}return!a&&null!==ud&&!wd};vd.responsesRequiredToBeHealthy=2;vd.healthyTimeout=3E4;h=vd.prototype;h.sd=function(){Yb.remove("previous_websocket_failure")};function yd(a,b){a.frames.push(b);if(a.frames.length==a.Fe){var c=a.frames.join("");a.frames=null;c=Ob(c);a.hg(c)}}
	h.send=function(a){xd(this);a=B(a);this.rb+=a.length;mc(this.Xa,"bytes_sent",a.length);a=ld(a,16384);1<a.length&&zd(this,String(a.length));for(var b=0;b<a.length;b++)zd(this,a[b])};h.Tc=function(){this.Bb=!0;this.Ac&&(clearInterval(this.Ac),this.Ac=null);this.La&&(this.La.close(),this.La=null)};h.fb=function(){this.Bb||(this.f("WebSocket is closing itself"),this.Tc(),this.kb&&(this.kb(this.xc),this.kb=null))};h.close=function(){this.Bb||(this.f("WebSocket is being closed"),this.Tc())};
	function xd(a){clearInterval(a.Ac);a.Ac=setInterval(function(){a.La&&zd(a,"0");xd(a)},Math.floor(45E3))}function zd(a,b){try{a.La.send(b)}catch(c){a.f("Exception thrown from WebSocket.send():",c.message||c.data,"Closing connection."),setTimeout(r(a.fb,a),0)}};function Ad(a,b,c){this.f=cd("p:rest:");this.M=a;this.Hb=b;this.Vd=c;this.$={}}function Bd(a,b){if(p(b))return"tag$"+b;H(Cd(a.n),"should have a tag if it's not a default query.");return a.path.toString()}h=Ad.prototype;
	h.df=function(a,b,c,d){var e=a.path.toString();this.f("Listen called for "+e+" "+a.ya());var f=Bd(a,c),g={};this.$[f]=g;a=Dd(a.n);var k=this;Ed(this,e+".json",a,function(a,b){var u=b;404===a&&(a=u=null);null===a&&k.Hb(e,u,!1,c);x(k.$,f)===g&&d(a?401==a?"permission_denied":"rest_error:"+a:"ok",null)})};h.Ef=function(a,b){var c=Bd(a,b);delete this.$[c]};h.qf=function(){};h.re=function(){};h.gf=function(){};h.xd=function(){};h.put=function(){};h.ef=function(){};h.ye=function(){};
	function Ed(a,b,c,d){c=c||{};c.format="export";a.Vd.getToken(!1).then(function(e){(e=e&&e.accessToken)&&(c.auth=e);var f=(a.M.Sc?"https://":"http://")+a.M.host+b+"?"+Fb(c);a.f("Sending REST request for "+f);var g=new XMLHttpRequest;g.onreadystatechange=function(){if(d&&4===g.readyState){a.f("REST Response for "+f+" received. status:",g.status,"response:",g.responseText);var b=null;if(200<=g.status&&300>g.status){try{b=Ob(g.responseText)}catch(c){O("Failed to parse JSON response for "+f+": "+g.responseText)}d(null,
	b)}else 401!==g.status&&404!==g.status&&O("Got unsuccessful REST response for "+f+" Status: "+g.status),d(g.status);d=null}};g.open("GET",f,!0);g.send()})};function Fd(a,b,c){this.type=Gd;this.source=a;this.path=b;this.children=c}Fd.prototype.Nc=function(a){if(this.path.e())return a=this.children.subtree(new L(a)),a.e()?null:a.value?new $b(this.source,C,a.value):new Fd(this.source,C,a);H(J(this.path)===a,"Can't get a merge for a child not on the path of the operation");return new Fd(this.source,D(this.path),this.children)};Fd.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" merge: "+this.children.toString()+")"};function Hd(){this.hb={}}
	function Id(a,b){var c=b.type,d=b.Za;H("child_added"==c||"child_changed"==c||"child_removed"==c,"Only child changes supported for tracking");H(".priority"!==d,"Only non-priority child changes can be tracked.");var e=x(a.hb,d);if(e){var f=e.type;if("child_added"==c&&"child_removed"==f)a.hb[d]=new I("child_changed",b.Ma,d,e.Ma);else if("child_removed"==c&&"child_added"==f)delete a.hb[d];else if("child_removed"==c&&"child_changed"==f)a.hb[d]=new I("child_removed",e.qe,d);else if("child_changed"==c&&
	"child_added"==f)a.hb[d]=new I("child_added",b.Ma,d);else if("child_changed"==c&&"child_changed"==f)a.hb[d]=new I("child_changed",b.Ma,d,e.qe);else throw Xc("Illegal combination of changes: "+b+" occurred after "+e);}else a.hb[d]=b};function Jd(a){this.W=a;this.g=a.n.g}function Kd(a,b,c,d){var e=[],f=[];Ja(b,function(b){"child_changed"===b.type&&a.g.nd(b.qe,b.Ma)&&f.push(new I("child_moved",b.Ma,b.Za))});Ld(a,e,"child_removed",b,d,c);Ld(a,e,"child_added",b,d,c);Ld(a,e,"child_moved",f,d,c);Ld(a,e,"child_changed",b,d,c);Ld(a,e,Hc,b,d,c);return e}function Ld(a,b,c,d,e,f){d=Ka(d,function(a){return a.type===c});Sa(d,r(a.Of,a));Ja(d,function(c){var d=Md(a,c,f);Ja(e,function(e){e.tf(c.type)&&b.push(e.createEvent(d,a.W))})})}
	function Md(a,b,c){"value"!==b.type&&"child_removed"!==b.type&&(b.Dd=c.Ze(b.Za,b.Ma,a.g));return b}Jd.prototype.Of=function(a,b){if(null==a.Za||null==b.Za)throw Xc("Should only compare child_ events.");return this.g.compare(new K(a.Za,a.Ma),new K(b.Za,b.Ma))};function Nd(a,b){this.Sd=a;this.Mf=b}function Od(a){this.V=a}
	Od.prototype.gb=function(a,b,c,d){var e=new Hd,f;if(b.type===ac)b.source.ee?c=Pd(this,a,b.path,b.Ja,c,d,e):(H(b.source.We,"Unknown source."),f=b.source.Ee||Jc(a.u())&&!b.path.e(),c=Qd(this,a,b.path,b.Ja,c,d,f,e));else if(b.type===Gd)b.source.ee?c=Rd(this,a,b.path,b.children,c,d,e):(H(b.source.We,"Unknown source."),f=b.source.Ee||Jc(a.u()),c=Sd(this,a,b.path,b.children,c,d,f,e));else if(b.type===Td)if(b.Id)if(b=b.path,null!=c.mc(b))c=a;else{f=new Cc(c,a,d);d=a.O.j();if(b.e()||".priority"===J(b))Ic(a.u())?
	b=c.Ba(Fc(a)):(b=a.u().j(),H(b instanceof P,"serverChildren would be complete if leaf node"),b=c.sc(b)),b=this.V.za(d,b,e);else{var g=J(b),k=c.rc(g,a.u());null==k&&Dc(a.u(),g)&&(k=d.R(g));b=null!=k?this.V.F(d,g,k,D(b),f,e):a.O.j().Fa(g)?this.V.F(d,g,F,D(b),f,e):d;b.e()&&Ic(a.u())&&(d=c.Ba(Fc(a)),d.J()&&(b=this.V.za(b,d,e)))}d=Ic(a.u())||null!=c.mc(C);c=Ud(a,b,d,this.V.Qa())}else c=Vd(this,a,b.path,b.Pb,c,d,e);else if(b.type===cc)d=b.path,b=a.u(),f=b.j(),g=b.ea||d.e(),c=Wd(this,new Xd(a.O,new Ec(f,
	g,b.Tb)),d,c,Bc,e);else throw Xc("Unknown operation type: "+b.type);e=sa(e.hb);d=c;b=d.O;b.ea&&(f=b.j().J()||b.j().e(),g=Yd(a),(0<e.length||!a.O.ea||f&&!b.j().ca(g)||!b.j().C().ca(g.C()))&&e.push(Gc(Yd(d))));return new Nd(c,e)};
	function Wd(a,b,c,d,e,f){var g=b.O;if(null!=d.mc(c))return b;var k;if(c.e())H(Ic(b.u()),"If change path is empty, we must have complete server data"),Jc(b.u())?(e=Fc(b),d=d.sc(e instanceof P?e:F)):d=d.Ba(Fc(b)),f=a.V.za(b.O.j(),d,f);else{var m=J(c);if(".priority"==m)H(1==Zd(c),"Can't have a priority with additional path components"),f=g.j(),k=b.u().j(),d=d.$c(c,f,k),f=null!=d?a.V.ga(f,d):g.j();else{var l=D(c);Dc(g,m)?(k=b.u().j(),d=d.$c(c,g.j(),k),d=null!=d?g.j().R(m).F(l,d):g.j().R(m)):d=d.rc(m,
	b.u());f=null!=d?a.V.F(g.j(),m,d,l,e,f):g.j()}}return Ud(b,f,g.ea||c.e(),a.V.Qa())}function Qd(a,b,c,d,e,f,g,k){var m=b.u();g=g?a.V:a.V.Vb();if(c.e())d=g.za(m.j(),d,null);else if(g.Qa()&&!m.Tb)d=m.j().F(c,d),d=g.za(m.j(),d,null);else{var l=J(c);if(!Kc(m,c)&&1<Zd(c))return b;var u=D(c);d=m.j().R(l).F(u,d);d=".priority"==l?g.ga(m.j(),d):g.F(m.j(),l,d,u,Bc,null)}m=m.ea||c.e();b=new Xd(b.O,new Ec(d,m,g.Qa()));return Wd(a,b,c,e,new Cc(e,b,f),k)}
	function Pd(a,b,c,d,e,f,g){var k=b.O;e=new Cc(e,b,f);if(c.e())g=a.V.za(b.O.j(),d,g),a=Ud(b,g,!0,a.V.Qa());else if(f=J(c),".priority"===f)g=a.V.ga(b.O.j(),d),a=Ud(b,g,k.ea,k.Tb);else{c=D(c);var m=k.j().R(f);if(!c.e()){var l=e.Xe(f);d=null!=l?".priority"===$d(c)&&l.Q(c.parent()).e()?l:l.F(c,d):F}m.ca(d)?a=b:(g=a.V.F(k.j(),f,d,c,e,g),a=Ud(b,g,k.ea,a.V.Qa()))}return a}
	function Rd(a,b,c,d,e,f,g){var k=b;ae(d,function(d,l){var u=c.m(d);Dc(b.O,J(u))&&(k=Pd(a,k,u,l,e,f,g))});ae(d,function(d,l){var u=c.m(d);Dc(b.O,J(u))||(k=Pd(a,k,u,l,e,f,g))});return k}function be(a,b){ae(b,function(b,d){a=a.F(b,d)});return a}
	function Sd(a,b,c,d,e,f,g,k){if(b.u().j().e()&&!Ic(b.u()))return b;var m=b;c=c.e()?d:ce(Q,c,d);var l=b.u().j();c.children.ia(function(c,d){if(l.Fa(c)){var G=b.u().j().R(c),G=be(G,d);m=Qd(a,m,new L(c),G,e,f,g,k)}});c.children.ia(function(c,d){var G=!Dc(b.u(),c)&&null==d.value;l.Fa(c)||G||(G=b.u().j().R(c),G=be(G,d),m=Qd(a,m,new L(c),G,e,f,g,k))});return m}
	function Vd(a,b,c,d,e,f,g){if(null!=e.mc(c))return b;var k=Jc(b.u()),m=b.u();if(null!=d.value){if(c.e()&&m.ea||Kc(m,c))return Qd(a,b,c,m.j().Q(c),e,f,k,g);if(c.e()){var l=Q;m.j().P(de,function(a,b){l=l.set(new L(a),b)});return Sd(a,b,c,l,e,f,k,g)}return b}l=Q;ae(d,function(a){var b=c.m(a);Kc(m,b)&&(l=l.set(a,m.j().Q(b)))});return Sd(a,b,c,l,e,f,k,g)};function ee(a){this.g=a}h=ee.prototype;h.F=function(a,b,c,d,e,f){H(a.zc(this.g),"A node must be indexed if only a child is updated");e=a.R(b);if(e.Q(d).ca(c.Q(d))&&e.e()==c.e())return a;null!=f&&(c.e()?a.Fa(b)?Id(f,new I("child_removed",e,b)):H(a.J(),"A child remove without an old child only makes sense on a leaf node"):e.e()?Id(f,new I("child_added",c,b)):Id(f,new I("child_changed",c,b,e)));return a.J()&&c.e()?a:a.U(b,c).ob(this.g)};
	h.za=function(a,b,c){null!=c&&(a.J()||a.P(N,function(a,e){b.Fa(a)||Id(c,new I("child_removed",e,a))}),b.J()||b.P(N,function(b,e){if(a.Fa(b)){var f=a.R(b);f.ca(e)||Id(c,new I("child_changed",e,b,f))}else Id(c,new I("child_added",e,b))}));return b.ob(this.g)};h.ga=function(a,b){return a.e()?F:a.ga(b)};h.Qa=function(){return!1};h.Vb=function(){return this};function fe(a){this.he=new ee(a.g);this.g=a.g;var b;a.ka?(b=ge(a),b=a.g.Fc(he(a),b)):b=a.g.Ic();this.Uc=b;a.na?(b=ie(a),a=a.g.Fc(je(a),b)):a=a.g.Gc();this.wc=a}h=fe.prototype;h.matches=function(a){return 0>=this.g.compare(this.Uc,a)&&0>=this.g.compare(a,this.wc)};h.F=function(a,b,c,d,e,f){this.matches(new K(b,c))||(c=F);return this.he.F(a,b,c,d,e,f)};
	h.za=function(a,b,c){b.J()&&(b=F);var d=b.ob(this.g),d=d.ga(F),e=this;b.P(N,function(a,b){e.matches(new K(a,b))||(d=d.U(a,F))});return this.he.za(a,d,c)};h.ga=function(a){return a};h.Qa=function(){return!0};h.Vb=function(){return this.he};function ke(a){this.sa=new fe(a);this.g=a.g;H(a.xa,"Only valid if limit has been set");this.oa=a.oa;this.Jb=!le(a)}h=ke.prototype;h.F=function(a,b,c,d,e,f){this.sa.matches(new K(b,c))||(c=F);return a.R(b).ca(c)?a:a.Fb()<this.oa?this.sa.Vb().F(a,b,c,d,e,f):me(this,a,b,c,e,f)};
	h.za=function(a,b,c){var d;if(b.J()||b.e())d=F.ob(this.g);else if(2*this.oa<b.Fb()&&b.zc(this.g)){d=F.ob(this.g);b=this.Jb?b.$b(this.sa.wc,this.g):b.Yb(this.sa.Uc,this.g);for(var e=0;0<b.Sa.length&&e<this.oa;){var f=R(b),g;if(g=this.Jb?0>=this.g.compare(this.sa.Uc,f):0>=this.g.compare(f,this.sa.wc))d=d.U(f.name,f.S),e++;else break}}else{d=b.ob(this.g);d=d.ga(F);var k,m,l;if(this.Jb){b=d.$e(this.g);k=this.sa.wc;m=this.sa.Uc;var u=ne(this.g);l=function(a,b){return u(b,a)}}else b=d.Xb(this.g),k=this.sa.Uc,
	m=this.sa.wc,l=ne(this.g);for(var e=0,z=!1;0<b.Sa.length;)f=R(b),!z&&0>=l(k,f)&&(z=!0),(g=z&&e<this.oa&&0>=l(f,m))?e++:d=d.U(f.name,F)}return this.sa.Vb().za(a,d,c)};h.ga=function(a){return a};h.Qa=function(){return!0};h.Vb=function(){return this.sa.Vb()};
	function me(a,b,c,d,e,f){var g;if(a.Jb){var k=ne(a.g);g=function(a,b){return k(b,a)}}else g=ne(a.g);H(b.Fb()==a.oa,"");var m=new K(c,d),l=a.Jb?oe(b,a.g):pe(b,a.g),u=a.sa.matches(m);if(b.Fa(c)){for(var z=b.R(c),l=e.fe(a.g,l,a.Jb);null!=l&&(l.name==c||b.Fa(l.name));)l=e.fe(a.g,l,a.Jb);e=null==l?1:g(l,m);if(u&&!d.e()&&0<=e)return null!=f&&Id(f,new I("child_changed",d,c,z)),b.U(c,d);null!=f&&Id(f,new I("child_removed",z,c));b=b.U(c,F);return null!=l&&a.sa.matches(l)?(null!=f&&Id(f,new I("child_added",
	l.S,l.name)),b.U(l.name,l.S)):b}return d.e()?b:u&&0<=g(l,m)?(null!=f&&(Id(f,new I("child_removed",l.S,l.name)),Id(f,new I("child_added",d,c))),b.U(c,d).U(l.name,F)):b};function Vc(a,b){this.B=a;H(p(this.B)&&null!==this.B,"LeafNode shouldn't be created with null/undefined value.");this.aa=b||F;qe(this.aa);this.Eb=null}var re=["object","boolean","number","string"];h=Vc.prototype;h.J=function(){return!0};h.C=function(){return this.aa};h.ga=function(a){return new Vc(this.B,a)};h.R=function(a){return".priority"===a?this.aa:F};h.Q=function(a){return a.e()?this:".priority"===J(a)?this.aa:F};h.Fa=function(){return!1};h.Ze=function(){return null};
	h.U=function(a,b){return".priority"===a?this.ga(b):b.e()&&".priority"!==a?this:F.U(a,b).ga(this.aa)};h.F=function(a,b){var c=J(a);if(null===c)return b;if(b.e()&&".priority"!==c)return this;H(".priority"!==c||1===Zd(a),".priority must be the last token in a path");return this.U(c,F.F(D(a),b))};h.e=function(){return!1};h.Fb=function(){return 0};h.P=function(){return!1};h.H=function(a){return a&&!this.C().e()?{".value":this.Ea(),".priority":this.C().H()}:this.Ea()};
	h.hash=function(){if(null===this.Eb){var a="";this.aa.e()||(a+="priority:"+se(this.aa.H())+":");var b=typeof this.B,a=a+(b+":"),a="number"===b?a+nd(this.B):a+this.B;this.Eb=Zc(a)}return this.Eb};h.Ea=function(){return this.B};h.tc=function(a){if(a===F)return 1;if(a instanceof P)return-1;H(a.J(),"Unknown node type");var b=typeof a.B,c=typeof this.B,d=Ia(re,b),e=Ia(re,c);H(0<=d,"Unknown leaf type: "+b);H(0<=e,"Unknown leaf type: "+c);return d===e?"object"===c?0:this.B<a.B?-1:this.B===a.B?0:1:e-d};
	h.ob=function(){return this};h.zc=function(){return!0};h.ca=function(a){return a===this?!0:a.J()?this.B===a.B&&this.aa.ca(a.aa):!1};h.toString=function(){return B(this.H(!0))};function te(){}var ue={};function ne(a){return r(a.compare,a)}te.prototype.nd=function(a,b){return 0!==this.compare(new K("[MIN_NAME]",a),new K("[MIN_NAME]",b))};te.prototype.Ic=function(){return ve};function we(a){H(!a.e()&&".priority"!==J(a),"Can't create PathIndex with empty path or .priority key");this.cc=a}ka(we,te);h=we.prototype;h.yc=function(a){return!a.Q(this.cc).e()};h.compare=function(a,b){var c=a.S.Q(this.cc),d=b.S.Q(this.cc),c=c.tc(d);return 0===c?Mc(a.name,b.name):c};
	h.Fc=function(a,b){var c=M(a),c=F.F(this.cc,c);return new K(b,c)};h.Gc=function(){var a=F.F(this.cc,xe);return new K("[MAX_NAME]",a)};h.toString=function(){return this.cc.slice().join("/")};function ye(){}ka(ye,te);h=ye.prototype;h.compare=function(a,b){var c=a.S.C(),d=b.S.C(),c=c.tc(d);return 0===c?Mc(a.name,b.name):c};h.yc=function(a){return!a.C().e()};h.nd=function(a,b){return!a.C().ca(b.C())};h.Ic=function(){return ve};h.Gc=function(){return new K("[MAX_NAME]",new Vc("[PRIORITY-POST]",xe))};
	h.Fc=function(a,b){var c=M(a);return new K(b,new Vc("[PRIORITY-POST]",c))};h.toString=function(){return".priority"};var N=new ye;function ze(){}ka(ze,te);h=ze.prototype;h.compare=function(a,b){return Mc(a.name,b.name)};h.yc=function(){throw Xc("KeyIndex.isDefinedOn not expected to be called.");};h.nd=function(){return!1};h.Ic=function(){return ve};h.Gc=function(){return new K("[MAX_NAME]",F)};h.Fc=function(a){H(q(a),"KeyIndex indexValue must always be a string.");return new K(a,F)};h.toString=function(){return".key"};
	var de=new ze;function Ae(){}ka(Ae,te);h=Ae.prototype;h.compare=function(a,b){var c=a.S.tc(b.S);return 0===c?Mc(a.name,b.name):c};h.yc=function(){return!0};h.nd=function(a,b){return!a.ca(b)};h.Ic=function(){return ve};h.Gc=function(){return Be};h.Fc=function(a,b){var c=M(a);return new K(b,c)};h.toString=function(){return".value"};var Ce=new Ae;function De(){this.Sb=this.na=this.Lb=this.ka=this.xa=!1;this.oa=0;this.oc="";this.ec=null;this.Ab="";this.bc=null;this.yb="";this.g=N}var Ee=new De;function le(a){return""===a.oc?a.ka:"l"===a.oc}function he(a){H(a.ka,"Only valid if start has been set");return a.ec}function ge(a){H(a.ka,"Only valid if start has been set");return a.Lb?a.Ab:"[MIN_NAME]"}function je(a){H(a.na,"Only valid if end has been set");return a.bc}
	function ie(a){H(a.na,"Only valid if end has been set");return a.Sb?a.yb:"[MAX_NAME]"}function Fe(a){var b=new De;b.xa=a.xa;b.oa=a.oa;b.ka=a.ka;b.ec=a.ec;b.Lb=a.Lb;b.Ab=a.Ab;b.na=a.na;b.bc=a.bc;b.Sb=a.Sb;b.yb=a.yb;b.g=a.g;return b}h=De.prototype;h.ne=function(a){var b=Fe(this);b.xa=!0;b.oa=a;b.oc="l";return b};h.oe=function(a){var b=Fe(this);b.xa=!0;b.oa=a;b.oc="r";return b};h.Nd=function(a,b){var c=Fe(this);c.ka=!0;p(a)||(a=null);c.ec=a;null!=b?(c.Lb=!0,c.Ab=b):(c.Lb=!1,c.Ab="");return c};
	h.fd=function(a,b){var c=Fe(this);c.na=!0;p(a)||(a=null);c.bc=a;p(b)?(c.Sb=!0,c.yb=b):(c.Hg=!1,c.yb="");return c};function Ge(a,b){var c=Fe(a);c.g=b;return c}function He(a){var b={};a.ka&&(b.sp=a.ec,a.Lb&&(b.sn=a.Ab));a.na&&(b.ep=a.bc,a.Sb&&(b.en=a.yb));if(a.xa){b.l=a.oa;var c=a.oc;""===c&&(c=le(a)?"l":"r");b.vf=c}a.g!==N&&(b.i=a.g.toString());return b}function S(a){return!(a.ka||a.na||a.xa)}function Cd(a){return S(a)&&a.g==N}
	function Dd(a){var b={};if(Cd(a))return b;var c;a.g===N?c="$priority":a.g===Ce?c="$value":a.g===de?c="$key":(H(a.g instanceof we,"Unrecognized index type!"),c=a.g.toString());b.orderBy=B(c);a.ka&&(b.startAt=B(a.ec),a.Lb&&(b.startAt+=","+B(a.Ab)));a.na&&(b.endAt=B(a.bc),a.Sb&&(b.endAt+=","+B(a.yb)));a.xa&&(le(a)?b.limitToFirst=a.oa:b.limitToLast=a.oa);return b}h.toString=function(){return B(He(this))};function Ie(a,b){this.od=a;this.dc=b}Ie.prototype.get=function(a){var b=x(this.od,a);if(!b)throw Error("No index defined for "+a);return b===ue?null:b};function Je(a,b,c){var d=oa(a.od,function(d,f){var g=x(a.dc,f);H(g,"Missing index implementation for "+f);if(d===ue){if(g.yc(b.S)){for(var k=[],m=c.Xb(Oc),l=R(m);l;)l.name!=b.name&&k.push(l),l=R(m);k.push(b);return Ke(k,ne(g))}return ue}g=c.get(b.name);k=d;g&&(k=k.remove(new K(b.name,g)));return k.Ra(b,b.S)});return new Ie(d,a.dc)}
	function Le(a,b,c){var d=oa(a.od,function(a){if(a===ue)return a;var d=c.get(b.name);return d?a.remove(new K(b.name,d)):a});return new Ie(d,a.dc)}var Me=new Ie({".priority":ue},{".priority":N});function Ne(){this.set={}}h=Ne.prototype;h.add=function(a,b){this.set[a]=null!==b?b:!0};h.contains=function(a){return Bb(this.set,a)};h.get=function(a){return this.contains(a)?this.set[a]:void 0};h.remove=function(a){delete this.set[a]};h.clear=function(){this.set={}};h.e=function(){return xa(this.set)};h.count=function(){return qa(this.set)};function Oe(a,b){t(a.set,function(a,d){b(d,a)})}h.keys=function(){var a=[];t(this.set,function(b,c){a.push(c)});return a};function Pe(a,b,c,d){this.Zd=a;this.f=cd(a);this.kc=b;this.qb=this.rb=0;this.Xa=pc(b);this.Bf=c;this.xc=!1;this.Db=d;this.Yc=function(a){return ic(b,"long_polling",a)}}var Qe,Re;
	Pe.prototype.open=function(a,b){this.Qe=0;this.ja=b;this.ff=new Rb(a);this.Bb=!1;var c=this;this.tb=setTimeout(function(){c.f("Timed out trying to connect.");c.fb();c.tb=null},Math.floor(3E4));hd(function(){if(!c.Bb){c.Wa=new Se(function(a,b,d,k,m){Te(c,arguments);if(c.Wa)if(c.tb&&(clearTimeout(c.tb),c.tb=null),c.xc=!0,"start"==a)c.id=b,c.mf=d;else if("close"===a)b?(c.Wa.Kd=!1,Sb(c.ff,b,function(){c.fb()})):c.fb();else throw Error("Unrecognized command received: "+a);},function(a,b){Te(c,arguments);
	Tb(c.ff,a,b)},function(){c.fb()},c.Yc);var a={start:"t"};a.ser=Math.floor(1E8*Math.random());c.Wa.Qd&&(a.cb=c.Wa.Qd);a.v="5";c.Bf&&(a.s=c.Bf);c.Db&&(a.ls=c.Db);"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");a=c.Yc(a);c.f("Connecting via long-poll to "+a);Ue(c.Wa,a,function(){})}})};
	Pe.prototype.start=function(){var a=this.Wa,b=this.mf;a.fg=this.id;a.gg=b;for(a.Ud=!0;Ve(a););a=this.id;b=this.mf;this.gc=document.createElement("iframe");var c={dframe:"t"};c.id=a;c.pw=b;this.gc.src=this.Yc(c);this.gc.style.display="none";document.body.appendChild(this.gc)};
	Pe.isAvailable=function(){return Qe||!Re&&"undefined"!==typeof document&&null!=document.createElement&&!("object"===typeof window&&window.chrome&&window.chrome.extension&&!/^chrome/.test(window.location.href))&&!("object"===typeof Windows&&"object"===typeof Windows.Dg)&&!0};h=Pe.prototype;h.sd=function(){};h.Tc=function(){this.Bb=!0;this.Wa&&(this.Wa.close(),this.Wa=null);this.gc&&(document.body.removeChild(this.gc),this.gc=null);this.tb&&(clearTimeout(this.tb),this.tb=null)};
	h.fb=function(){this.Bb||(this.f("Longpoll is closing itself"),this.Tc(),this.ja&&(this.ja(this.xc),this.ja=null))};h.close=function(){this.Bb||(this.f("Longpoll is being closed."),this.Tc())};h.send=function(a){a=B(a);this.rb+=a.length;mc(this.Xa,"bytes_sent",a.length);a=Mb(a);a=ab(a,!0);a=ld(a,1840);for(var b=0;b<a.length;b++){var c=this.Wa;c.Qc.push({ug:this.Qe,Bg:a.length,Se:a[b]});c.Ud&&Ve(c);this.Qe++}};function Te(a,b){var c=B(b).length;a.qb+=c;mc(a.Xa,"bytes_received",c)}
	function Se(a,b,c,d){this.Yc=d;this.kb=c;this.ve=new Ne;this.Qc=[];this.$d=Math.floor(1E8*Math.random());this.Kd=!0;this.Qd=Wc();window["pLPCommand"+this.Qd]=a;window["pRTLPCB"+this.Qd]=b;a=document.createElement("iframe");a.style.display="none";if(document.body){document.body.appendChild(a);try{a.contentWindow.document||E("No IE domain setting required")}catch(e){a.src="javascript:void((function(){document.open();document.domain='"+document.domain+"';document.close();})())"}}else throw"Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
	a.contentDocument?a.ib=a.contentDocument:a.contentWindow?a.ib=a.contentWindow.document:a.document&&(a.ib=a.document);this.Ga=a;a="";this.Ga.src&&"javascript:"===this.Ga.src.substr(0,11)&&(a='<script>document.domain="'+document.domain+'";\x3c/script>');a="<html><body>"+a+"</body></html>";try{this.Ga.ib.open(),this.Ga.ib.write(a),this.Ga.ib.close()}catch(f){E("frame writing exception"),f.stack&&E(f.stack),E(f)}}
	Se.prototype.close=function(){this.Ud=!1;if(this.Ga){this.Ga.ib.body.innerHTML="";var a=this;setTimeout(function(){null!==a.Ga&&(document.body.removeChild(a.Ga),a.Ga=null)},Math.floor(0))}var b=this.kb;b&&(this.kb=null,b())};
	function Ve(a){if(a.Ud&&a.Kd&&a.ve.count()<(0<a.Qc.length?2:1)){a.$d++;var b={};b.id=a.fg;b.pw=a.gg;b.ser=a.$d;for(var b=a.Yc(b),c="",d=0;0<a.Qc.length;)if(1870>=a.Qc[0].Se.length+30+c.length){var e=a.Qc.shift(),c=c+"&seg"+d+"="+e.ug+"&ts"+d+"="+e.Bg+"&d"+d+"="+e.Se;d++}else break;We(a,b+c,a.$d);return!0}return!1}function We(a,b,c){function d(){a.ve.remove(c);Ve(a)}a.ve.add(c,1);var e=setTimeout(d,Math.floor(25E3));Ue(a,b,function(){clearTimeout(e);d()})}
	function Ue(a,b,c){setTimeout(function(){try{if(a.Kd){var d=a.Ga.ib.createElement("script");d.type="text/javascript";d.async=!0;d.src=b;d.onload=d.onreadystatechange=function(){var a=d.readyState;a&&"loaded"!==a&&"complete"!==a||(d.onload=d.onreadystatechange=null,d.parentNode&&d.parentNode.removeChild(d),c())};d.onerror=function(){E("Long-poll script failed to load: "+b);a.Kd=!1;a.close()};a.Ga.ib.body.appendChild(d)}}catch(e){}},Math.floor(1))};function Xe(a){Ye(this,a)}var Ze=[Pe,vd];function Ye(a,b){var c=vd&&vd.isAvailable(),d=c&&!(Yb.cf||!0===Yb.get("previous_websocket_failure"));b.Cg&&(c||O("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."),d=!0);if(d)a.Wc=[vd];else{var e=a.Wc=[];md(Ze,function(a,b){b&&b.isAvailable()&&e.push(b)})}}function $e(a){if(0<a.Wc.length)return a.Wc[0];throw Error("No transports available");};function af(a,b,c,d,e,f,g){this.id=a;this.f=cd("c:"+this.id+":");this.te=c;this.Mc=d;this.ja=e;this.se=f;this.M=b;this.Ad=[];this.Oe=0;this.Af=new Xe(b);this.L=0;this.Db=g;this.f("Connection created");bf(this)}
	function bf(a){var b=$e(a.Af);a.I=new b("c:"+a.id+":"+a.Oe++,a.M,void 0,a.Db);a.xe=b.responsesRequiredToBeHealthy||0;var c=cf(a,a.I),d=df(a,a.I);a.Xc=a.I;a.Rc=a.I;a.D=null;a.Cb=!1;setTimeout(function(){a.I&&a.I.open(c,d)},Math.floor(0));b=b.healthyTimeout||0;0<b&&(a.md=setTimeout(function(){a.md=null;a.Cb||(a.I&&102400<a.I.qb?(a.f("Connection exceeded healthy timeout but has received "+a.I.qb+" bytes.  Marking connection healthy."),a.Cb=!0,a.I.sd()):a.I&&10240<a.I.rb?a.f("Connection exceeded healthy timeout but has sent "+
	a.I.rb+" bytes.  Leaving connection alive."):(a.f("Closing unhealthy connection after timeout."),a.close()))},Math.floor(b)))}function df(a,b){return function(c){b===a.I?(a.I=null,c||0!==a.L?1===a.L&&a.f("Realtime connection lost."):(a.f("Realtime connection failed."),"s-"===a.M.bb.substr(0,2)&&(Yb.remove("host:"+a.M.host),a.M.bb=a.M.host)),a.close()):b===a.D?(a.f("Secondary connection lost."),c=a.D,a.D=null,a.Xc!==c&&a.Rc!==c||a.close()):a.f("closing an old connection")}}
	function cf(a,b){return function(c){if(2!=a.L)if(b===a.Rc){var d=jd("t",c);c=jd("d",c);if("c"==d){if(d=jd("t",c),"d"in c)if(c=c.d,"h"===d){var d=c.ts,e=c.v,f=c.h;a.yf=c.s;hc(a.M,f);0==a.L&&(a.I.start(),ef(a,a.I,d),"5"!==e&&O("Protocol version mismatch detected"),c=a.Af,(c=1<c.Wc.length?c.Wc[1]:null)&&ff(a,c))}else if("n"===d){a.f("recvd end transmission on primary");a.Rc=a.D;for(c=0;c<a.Ad.length;++c)a.wd(a.Ad[c]);a.Ad=[];gf(a)}else"s"===d?(a.f("Connection shutdown command received. Shutting down..."),
	a.se&&(a.se(c),a.se=null),a.ja=null,a.close()):"r"===d?(a.f("Reset packet received.  New host: "+c),hc(a.M,c),1===a.L?a.close():(hf(a),bf(a))):"e"===d?dd("Server Error: "+c):"o"===d?(a.f("got pong on primary."),jf(a),kf(a)):dd("Unknown control packet command: "+d)}else"d"==d&&a.wd(c)}else if(b===a.D)if(d=jd("t",c),c=jd("d",c),"c"==d)"t"in c&&(c=c.t,"a"===c?lf(a):"r"===c?(a.f("Got a reset on secondary, closing it"),a.D.close(),a.Xc!==a.D&&a.Rc!==a.D||a.close()):"o"===c&&(a.f("got pong on secondary."),
	a.xf--,lf(a)));else if("d"==d)a.Ad.push(c);else throw Error("Unknown protocol layer: "+d);else a.f("message on old connection")}}af.prototype.ua=function(a){mf(this,{t:"d",d:a})};function gf(a){a.Xc===a.D&&a.Rc===a.D&&(a.f("cleaning up and promoting a connection: "+a.D.Zd),a.I=a.D,a.D=null)}
	function lf(a){0>=a.xf?(a.f("Secondary connection is healthy."),a.Cb=!0,a.D.sd(),a.D.start(),a.f("sending client ack on secondary"),a.D.send({t:"c",d:{t:"a",d:{}}}),a.f("Ending transmission on primary"),a.I.send({t:"c",d:{t:"n",d:{}}}),a.Xc=a.D,gf(a)):(a.f("sending ping on secondary."),a.D.send({t:"c",d:{t:"p",d:{}}}))}af.prototype.wd=function(a){jf(this);this.te(a)};function jf(a){a.Cb||(a.xe--,0>=a.xe&&(a.f("Primary connection is healthy."),a.Cb=!0,a.I.sd()))}
	function ff(a,b){a.D=new b("c:"+a.id+":"+a.Oe++,a.M,a.yf);a.xf=b.responsesRequiredToBeHealthy||0;a.D.open(cf(a,a.D),df(a,a.D));setTimeout(function(){a.D&&(a.f("Timed out trying to upgrade."),a.D.close())},Math.floor(6E4))}function ef(a,b,c){a.f("Realtime connection established.");a.I=b;a.L=1;a.Mc&&(a.Mc(c,a.yf),a.Mc=null);0===a.xe?(a.f("Primary connection is healthy."),a.Cb=!0):setTimeout(function(){kf(a)},Math.floor(5E3))}
	function kf(a){a.Cb||1!==a.L||(a.f("sending ping on primary."),mf(a,{t:"c",d:{t:"p",d:{}}}))}function mf(a,b){if(1!==a.L)throw"Connection is not connected";a.Xc.send(b)}af.prototype.close=function(){2!==this.L&&(this.f("Closing realtime connection."),this.L=2,hf(this),this.ja&&(this.ja(),this.ja=null))};function hf(a){a.f("Shutting down all connections");a.I&&(a.I.close(),a.I=null);a.D&&(a.D.close(),a.D=null);a.md&&(clearTimeout(a.md),a.md=null)};function L(a,b){if(1==arguments.length){this.o=a.split("/");for(var c=0,d=0;d<this.o.length;d++)0<this.o[d].length&&(this.o[c]=this.o[d],c++);this.o.length=c;this.Z=0}else this.o=a,this.Z=b}function T(a,b){var c=J(a);if(null===c)return b;if(c===J(b))return T(D(a),D(b));throw Error("INTERNAL ERROR: innerPath ("+b+") is not within outerPath ("+a+")");}
	function nf(a,b){for(var c=a.slice(),d=b.slice(),e=0;e<c.length&&e<d.length;e++){var f=Mc(c[e],d[e]);if(0!==f)return f}return c.length===d.length?0:c.length<d.length?-1:1}function J(a){return a.Z>=a.o.length?null:a.o[a.Z]}function Zd(a){return a.o.length-a.Z}function D(a){var b=a.Z;b<a.o.length&&b++;return new L(a.o,b)}function $d(a){return a.Z<a.o.length?a.o[a.o.length-1]:null}h=L.prototype;
	h.toString=function(){for(var a="",b=this.Z;b<this.o.length;b++)""!==this.o[b]&&(a+="/"+this.o[b]);return a||"/"};h.slice=function(a){return this.o.slice(this.Z+(a||0))};h.parent=function(){if(this.Z>=this.o.length)return null;for(var a=[],b=this.Z;b<this.o.length-1;b++)a.push(this.o[b]);return new L(a,0)};
	h.m=function(a){for(var b=[],c=this.Z;c<this.o.length;c++)b.push(this.o[c]);if(a instanceof L)for(c=a.Z;c<a.o.length;c++)b.push(a.o[c]);else for(a=a.split("/"),c=0;c<a.length;c++)0<a[c].length&&b.push(a[c]);return new L(b,0)};h.e=function(){return this.Z>=this.o.length};h.ca=function(a){if(Zd(this)!==Zd(a))return!1;for(var b=this.Z,c=a.Z;b<=this.o.length;b++,c++)if(this.o[b]!==a.o[c])return!1;return!0};
	h.contains=function(a){var b=this.Z,c=a.Z;if(Zd(this)>Zd(a))return!1;for(;b<this.o.length;){if(this.o[b]!==a.o[c])return!1;++b;++c}return!0};var C=new L("");function of(a,b){this.Ta=a.slice();this.Ka=Math.max(1,this.Ta.length);this.Te=b;for(var c=0;c<this.Ta.length;c++)this.Ka+=Nb(this.Ta[c]);pf(this)}of.prototype.push=function(a){0<this.Ta.length&&(this.Ka+=1);this.Ta.push(a);this.Ka+=Nb(a);pf(this)};of.prototype.pop=function(){var a=this.Ta.pop();this.Ka-=Nb(a);0<this.Ta.length&&--this.Ka};
	function pf(a){if(768<a.Ka)throw Error(a.Te+"has a key path longer than 768 bytes ("+a.Ka+").");if(32<a.Ta.length)throw Error(a.Te+"path specified exceeds the maximum depth that can be written (32) or object contains a cycle "+qf(a));}function qf(a){return 0==a.Ta.length?"":"in property '"+a.Ta.join(".")+"'"};function rf(a){a instanceof sf||ed("Don't call new Database() directly - please use firebase.database().");this.ta=a;this.ba=new U(a,C);this.INTERNAL=new tf(this)}var uf={TIMESTAMP:{".sv":"timestamp"}};h=rf.prototype;h.app=null;h.pf=function(a){vf(this,"ref");y("database.ref",0,1,arguments.length);return p(a)?this.ba.m(a):this.ba};
	h.rg=function(a){vf(this,"database.refFromURL");y("database.refFromURL",1,1,arguments.length);var b=fd(a);wf("database.refFromURL",b);var c=b.kc;c.host!==this.ta.M.host&&ed("database.refFromURL: Host name does not match the current database: (found "+c.host+" but expected "+this.ta.M.host+")");return this.pf(b.path.toString())};function vf(a,b){null===a.ta&&ed("Cannot call "+b+" on a deleted database.")}h.$f=function(){y("database.goOffline",0,0,arguments.length);vf(this,"goOffline");this.ta.eb()};
	h.ag=function(){y("database.goOnline",0,0,arguments.length);vf(this,"goOnline");this.ta.lc()};Object.defineProperty(rf.prototype,"app",{get:function(){return this.ta.app}});function tf(a){this.$a=a}tf.prototype.delete=function(){vf(this.$a,"delete");var a=xf.Wb(),b=this.$a.ta;x(a.nb,b.app.name)!==b&&ed("Database "+b.app.name+" has already been deleted.");b.eb();delete a.nb[b.app.name];this.$a.ta=null;this.$a.ba=null;this.$a=this.$a.INTERNAL=null;return firebase.Promise.resolve()};
	rf.prototype.ref=rf.prototype.pf;rf.prototype.refFromURL=rf.prototype.rg;rf.prototype.goOnline=rf.prototype.ag;rf.prototype.goOffline=rf.prototype.$f;tf.prototype["delete"]=tf.prototype.delete;function Rc(){this.k=this.B=null}Rc.prototype.find=function(a){if(null!=this.B)return this.B.Q(a);if(a.e()||null==this.k)return null;var b=J(a);a=D(a);return this.k.contains(b)?this.k.get(b).find(a):null};function Tc(a,b,c){if(b.e())a.B=c,a.k=null;else if(null!==a.B)a.B=a.B.F(b,c);else{null==a.k&&(a.k=new Ne);var d=J(b);a.k.contains(d)||a.k.add(d,new Rc);a=a.k.get(d);b=D(b);Tc(a,b,c)}}
	function yf(a,b){if(b.e())return a.B=null,a.k=null,!0;if(null!==a.B){if(a.B.J())return!1;var c=a.B;a.B=null;c.P(N,function(b,c){Tc(a,new L(b),c)});return yf(a,b)}return null!==a.k?(c=J(b),b=D(b),a.k.contains(c)&&yf(a.k.get(c),b)&&a.k.remove(c),a.k.e()?(a.k=null,!0):!1):!0}function Sc(a,b,c){null!==a.B?c(b,a.B):a.P(function(a,e){var f=new L(b.toString()+"/"+a);Sc(e,f,c)})}Rc.prototype.P=function(a){null!==this.k&&Oe(this.k,function(b,c){a(b,c)})};var zf=/[\[\].#$\/\u0000-\u001F\u007F]/,Af=/[\[\].#$\u0000-\u001F\u007F]/;function Bf(a){return q(a)&&0!==a.length&&!zf.test(a)}function Cf(a){return null===a||q(a)||fa(a)&&!gd(a)||ha(a)&&Bb(a,".sv")}function Df(a,b,c,d){d&&!p(b)||Ef(Db(a,1,d),b,c)}
	function Ef(a,b,c){c instanceof L&&(c=new of(c,a));if(!p(b))throw Error(a+"contains undefined "+qf(c));if(ga(b))throw Error(a+"contains a function "+qf(c)+" with contents: "+b.toString());if(gd(b))throw Error(a+"contains "+b.toString()+" "+qf(c));if(q(b)&&b.length>10485760/3&&10485760<Nb(b))throw Error(a+"contains a string greater than 10485760 utf8 bytes "+qf(c)+" ('"+b.substring(0,50)+"...')");if(ha(b)){var d=!1,e=!1;Cb(b,function(b,g){if(".value"===b)d=!0;else if(".priority"!==b&&".sv"!==b&&(e=
	!0,!Bf(b)))throw Error(a+" contains an invalid key ("+b+") "+qf(c)+'.  Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');c.push(b);Ef(a,g,c);c.pop()});if(d&&e)throw Error(a+' contains ".value" child '+qf(c)+" in addition to actual children.");}}
	function Ff(a,b){var c,d;for(c=0;c<b.length;c++){d=b[c];for(var e=d.slice(),f=0;f<e.length;f++)if((".priority"!==e[f]||f!==e.length-1)&&!Bf(e[f]))throw Error(a+"contains an invalid key ("+e[f]+") in path "+d.toString()+'. Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');}b.sort(nf);e=null;for(c=0;c<b.length;c++){d=b[c];if(null!==e&&e.contains(d))throw Error(a+"contains a path "+e.toString()+" that is ancestor of another path "+d.toString());e=d}}
	function Gf(a,b,c){var d=Db(a,1,!1);if(!ha(b)||da(b))throw Error(d+" must be an object containing the children to replace.");var e=[];Cb(b,function(a,b){var k=new L(a);Ef(d,b,c.m(k));if(".priority"===$d(k)&&!Cf(b))throw Error(d+"contains an invalid value for '"+k.toString()+"', which must be a valid Firebase priority (a string, finite number, server value, or null).");e.push(k)});Ff(d,e)}
	function Hf(a,b,c){if(gd(c))throw Error(Db(a,b,!1)+"is "+c.toString()+", but must be a valid Firebase priority (a string, finite number, server value, or null).");if(!Cf(c))throw Error(Db(a,b,!1)+"must be a valid Firebase priority (a string, finite number, server value, or null).");}
	function If(a,b,c){if(!c||p(b))switch(b){case "value":case "child_added":case "child_removed":case "child_changed":case "child_moved":break;default:throw Error(Db(a,1,c)+'must be a valid event type: "value", "child_added", "child_removed", "child_changed", or "child_moved".');}}function Jf(a,b){if(p(b)&&!Bf(b))throw Error(Db(a,2,!0)+'was an invalid key: "'+b+'".  Firebase keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]").');}
	function Kf(a,b){if(!q(b)||0===b.length||Af.test(b))throw Error(Db(a,1,!1)+'was an invalid path: "'+b+'". Paths must be non-empty strings and can\'t contain ".", "#", "$", "[", or "]"');}function Lf(a,b){if(".info"===J(b))throw Error(a+" failed: Can't modify data under /.info/");}
	function wf(a,b){var c=b.path.toString(),d;!(d=!q(b.kc.host)||0===b.kc.host.length||!Bf(b.kc.pe))&&(d=0!==c.length)&&(c&&(c=c.replace(/^\/*\.info(\/|$)/,"/")),d=!(q(c)&&0!==c.length&&!Af.test(c)));if(d)throw Error(Db(a,1,!1)+'must be a valid firebase URL and the path can\'t contain ".", "#", "$", "[", or "]".');};function V(a,b){this.ta=a;this.qa=b}V.prototype.cancel=function(a){y("Firebase.onDisconnect().cancel",0,1,arguments.length);A("Firebase.onDisconnect().cancel",1,a,!0);var b=new Hb;this.ta.xd(this.qa,Ib(b,a));return b.ra};V.prototype.cancel=V.prototype.cancel;V.prototype.remove=function(a){y("Firebase.onDisconnect().remove",0,1,arguments.length);Lf("Firebase.onDisconnect().remove",this.qa);A("Firebase.onDisconnect().remove",1,a,!0);var b=new Hb;Mf(this.ta,this.qa,null,Ib(b,a));return b.ra};
	V.prototype.remove=V.prototype.remove;V.prototype.set=function(a,b){y("Firebase.onDisconnect().set",1,2,arguments.length);Lf("Firebase.onDisconnect().set",this.qa);Df("Firebase.onDisconnect().set",a,this.qa,!1);A("Firebase.onDisconnect().set",2,b,!0);var c=new Hb;Mf(this.ta,this.qa,a,Ib(c,b));return c.ra};V.prototype.set=V.prototype.set;
	V.prototype.Kb=function(a,b,c){y("Firebase.onDisconnect().setWithPriority",2,3,arguments.length);Lf("Firebase.onDisconnect().setWithPriority",this.qa);Df("Firebase.onDisconnect().setWithPriority",a,this.qa,!1);Hf("Firebase.onDisconnect().setWithPriority",2,b);A("Firebase.onDisconnect().setWithPriority",3,c,!0);var d=new Hb;Nf(this.ta,this.qa,a,b,Ib(d,c));return d.ra};V.prototype.setWithPriority=V.prototype.Kb;
	V.prototype.update=function(a,b){y("Firebase.onDisconnect().update",1,2,arguments.length);Lf("Firebase.onDisconnect().update",this.qa);if(da(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;O("Passing an Array to Firebase.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Gf("Firebase.onDisconnect().update",a,this.qa);A("Firebase.onDisconnect().update",2,b,!0);
	c=new Hb;Of(this.ta,this.qa,a,Ib(c,b));return c.ra};V.prototype.update=V.prototype.update;function Pf(a){H(da(a)&&0<a.length,"Requires a non-empty array");this.Kf=a;this.Ec={}}Pf.prototype.Ge=function(a,b){var c;c=this.Ec[a]||[];var d=c.length;if(0<d){for(var e=Array(d),f=0;f<d;f++)e[f]=c[f];c=e}else c=[];for(d=0;d<c.length;d++)c[d].Ke.apply(c[d].Pa,Array.prototype.slice.call(arguments,1))};Pf.prototype.hc=function(a,b,c){Qf(this,a);this.Ec[a]=this.Ec[a]||[];this.Ec[a].push({Ke:b,Pa:c});(a=this.Ye(a))&&b.apply(c,a)};
	Pf.prototype.Jc=function(a,b,c){Qf(this,a);a=this.Ec[a]||[];for(var d=0;d<a.length;d++)if(a[d].Ke===b&&(!c||c===a[d].Pa)){a.splice(d,1);break}};function Qf(a,b){H(Oa(a.Kf,function(a){return a===b}),"Unknown event: "+b)};function Rf(){Pf.call(this,["online"]);this.ic=!0;if("undefined"!==typeof window&&"undefined"!==typeof window.addEventListener&&!Qb()){var a=this;window.addEventListener("online",function(){a.ic||(a.ic=!0,a.Ge("online",!0))},!1);window.addEventListener("offline",function(){a.ic&&(a.ic=!1,a.Ge("online",!1))},!1)}}ka(Rf,Pf);Rf.prototype.Ye=function(a){H("online"===a,"Unknown event type: "+a);return[this.ic]};ba(Rf);function Sf(){Pf.call(this,["visible"]);var a,b;"undefined"!==typeof document&&"undefined"!==typeof document.addEventListener&&("undefined"!==typeof document.hidden?(b="visibilitychange",a="hidden"):"undefined"!==typeof document.mozHidden?(b="mozvisibilitychange",a="mozHidden"):"undefined"!==typeof document.msHidden?(b="msvisibilitychange",a="msHidden"):"undefined"!==typeof document.webkitHidden&&(b="webkitvisibilitychange",a="webkitHidden"));this.Nb=!0;if(b){var c=this;document.addEventListener(b,
	function(){var b=!document[a];b!==c.Nb&&(c.Nb=b,c.Ge("visible",b))},!1)}}ka(Sf,Pf);Sf.prototype.Ye=function(a){H("visible"===a,"Unknown event type: "+a);return[this.Nb]};ba(Sf);var Tf=function(){var a=0,b=[];return function(c){var d=c===a;a=c;for(var e=Array(8),f=7;0<=f;f--)e[f]="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(c%64),c=Math.floor(c/64);H(0===c,"Cannot push at time == 0");c=e.join("");if(d){for(f=11;0<=f&&63===b[f];f--)b[f]=0;b[f]++}else for(f=0;12>f;f++)b[f]=Math.floor(64*Math.random());for(f=0;12>f;f++)c+="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(b[f]);H(20===c.length,"nextPushId: Length should be 20.");
	return c}}();function Uf(a,b){this.Oa=a;this.ba=b?b:Vf}h=Uf.prototype;h.Ra=function(a,b){return new Uf(this.Oa,this.ba.Ra(a,b,this.Oa).Y(null,null,!1,null,null))};h.remove=function(a){return new Uf(this.Oa,this.ba.remove(a,this.Oa).Y(null,null,!1,null,null))};h.get=function(a){for(var b,c=this.ba;!c.e();){b=this.Oa(a,c.key);if(0===b)return c.value;0>b?c=c.left:0<b&&(c=c.right)}return null};
	function Wf(a,b){for(var c,d=a.ba,e=null;!d.e();){c=a.Oa(b,d.key);if(0===c){if(d.left.e())return e?e.key:null;for(d=d.left;!d.right.e();)d=d.right;return d.key}0>c?d=d.left:0<c&&(e=d,d=d.right)}throw Error("Attempted to find predecessor key for a nonexistent key.  What gives?");}h.e=function(){return this.ba.e()};h.count=function(){return this.ba.count()};h.Hc=function(){return this.ba.Hc()};h.fc=function(){return this.ba.fc()};h.ia=function(a){return this.ba.ia(a)};
	h.Xb=function(a){return new Xf(this.ba,null,this.Oa,!1,a)};h.Yb=function(a,b){return new Xf(this.ba,a,this.Oa,!1,b)};h.$b=function(a,b){return new Xf(this.ba,a,this.Oa,!0,b)};h.$e=function(a){return new Xf(this.ba,null,this.Oa,!0,a)};function Xf(a,b,c,d,e){this.Hd=e||null;this.le=d;this.Sa=[];for(e=1;!a.e();)if(e=b?c(a.key,b):1,d&&(e*=-1),0>e)a=this.le?a.left:a.right;else if(0===e){this.Sa.push(a);break}else this.Sa.push(a),a=this.le?a.right:a.left}
	function R(a){if(0===a.Sa.length)return null;var b=a.Sa.pop(),c;c=a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value};if(a.le)for(b=b.left;!b.e();)a.Sa.push(b),b=b.right;else for(b=b.right;!b.e();)a.Sa.push(b),b=b.left;return c}function Yf(a){if(0===a.Sa.length)return null;var b;b=a.Sa;b=b[b.length-1];return a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value}}function Zf(a,b,c,d,e){this.key=a;this.value=b;this.color=null!=c?c:!0;this.left=null!=d?d:Vf;this.right=null!=e?e:Vf}h=Zf.prototype;
	h.Y=function(a,b,c,d,e){return new Zf(null!=a?a:this.key,null!=b?b:this.value,null!=c?c:this.color,null!=d?d:this.left,null!=e?e:this.right)};h.count=function(){return this.left.count()+1+this.right.count()};h.e=function(){return!1};h.ia=function(a){return this.left.ia(a)||a(this.key,this.value)||this.right.ia(a)};function $f(a){return a.left.e()?a:$f(a.left)}h.Hc=function(){return $f(this).key};h.fc=function(){return this.right.e()?this.key:this.right.fc()};
	h.Ra=function(a,b,c){var d,e;e=this;d=c(a,e.key);e=0>d?e.Y(null,null,null,e.left.Ra(a,b,c),null):0===d?e.Y(null,b,null,null,null):e.Y(null,null,null,null,e.right.Ra(a,b,c));return ag(e)};function bg(a){if(a.left.e())return Vf;a.left.fa()||a.left.left.fa()||(a=cg(a));a=a.Y(null,null,null,bg(a.left),null);return ag(a)}
	h.remove=function(a,b){var c,d;c=this;if(0>b(a,c.key))c.left.e()||c.left.fa()||c.left.left.fa()||(c=cg(c)),c=c.Y(null,null,null,c.left.remove(a,b),null);else{c.left.fa()&&(c=dg(c));c.right.e()||c.right.fa()||c.right.left.fa()||(c=eg(c),c.left.left.fa()&&(c=dg(c),c=eg(c)));if(0===b(a,c.key)){if(c.right.e())return Vf;d=$f(c.right);c=c.Y(d.key,d.value,null,null,bg(c.right))}c=c.Y(null,null,null,null,c.right.remove(a,b))}return ag(c)};h.fa=function(){return this.color};
	function ag(a){a.right.fa()&&!a.left.fa()&&(a=fg(a));a.left.fa()&&a.left.left.fa()&&(a=dg(a));a.left.fa()&&a.right.fa()&&(a=eg(a));return a}function cg(a){a=eg(a);a.right.left.fa()&&(a=a.Y(null,null,null,null,dg(a.right)),a=fg(a),a=eg(a));return a}function fg(a){return a.right.Y(null,null,a.color,a.Y(null,null,!0,null,a.right.left),null)}function dg(a){return a.left.Y(null,null,a.color,null,a.Y(null,null,!0,a.left.right,null))}
	function eg(a){return a.Y(null,null,!a.color,a.left.Y(null,null,!a.left.color,null,null),a.right.Y(null,null,!a.right.color,null,null))}function gg(){}h=gg.prototype;h.Y=function(){return this};h.Ra=function(a,b){return new Zf(a,b,null)};h.remove=function(){return this};h.count=function(){return 0};h.e=function(){return!0};h.ia=function(){return!1};h.Hc=function(){return null};h.fc=function(){return null};h.fa=function(){return!1};var Vf=new gg;function P(a,b,c){this.k=a;(this.aa=b)&&qe(this.aa);a.e()&&H(!this.aa||this.aa.e(),"An empty node cannot have a priority");this.zb=c;this.Eb=null}h=P.prototype;h.J=function(){return!1};h.C=function(){return this.aa||F};h.ga=function(a){return this.k.e()?this:new P(this.k,a,this.zb)};h.R=function(a){if(".priority"===a)return this.C();a=this.k.get(a);return null===a?F:a};h.Q=function(a){var b=J(a);return null===b?this:this.R(b).Q(D(a))};h.Fa=function(a){return null!==this.k.get(a)};
	h.U=function(a,b){H(b,"We should always be passing snapshot nodes");if(".priority"===a)return this.ga(b);var c=new K(a,b),d,e;b.e()?(d=this.k.remove(a),c=Le(this.zb,c,this.k)):(d=this.k.Ra(a,b),c=Je(this.zb,c,this.k));e=d.e()?F:this.aa;return new P(d,e,c)};h.F=function(a,b){var c=J(a);if(null===c)return b;H(".priority"!==J(a)||1===Zd(a),".priority must be the last token in a path");var d=this.R(c).F(D(a),b);return this.U(c,d)};h.e=function(){return this.k.e()};h.Fb=function(){return this.k.count()};
	var hg=/^(0|[1-9]\d*)$/;h=P.prototype;h.H=function(a){if(this.e())return null;var b={},c=0,d=0,e=!0;this.P(N,function(f,g){b[f]=g.H(a);c++;e&&hg.test(f)?d=Math.max(d,Number(f)):e=!1});if(!a&&e&&d<2*c){var f=[],g;for(g in b)f[g]=b[g];return f}a&&!this.C().e()&&(b[".priority"]=this.C().H());return b};h.hash=function(){if(null===this.Eb){var a="";this.C().e()||(a+="priority:"+se(this.C().H())+":");this.P(N,function(b,c){var d=c.hash();""!==d&&(a+=":"+b+":"+d)});this.Eb=""===a?"":Zc(a)}return this.Eb};
	h.Ze=function(a,b,c){return(c=ig(this,c))?(a=Wf(c,new K(a,b)))?a.name:null:Wf(this.k,a)};function oe(a,b){var c;c=(c=ig(a,b))?(c=c.Hc())&&c.name:a.k.Hc();return c?new K(c,a.k.get(c)):null}function pe(a,b){var c;c=(c=ig(a,b))?(c=c.fc())&&c.name:a.k.fc();return c?new K(c,a.k.get(c)):null}h.P=function(a,b){var c=ig(this,a);return c?c.ia(function(a){return b(a.name,a.S)}):this.k.ia(b)};h.Xb=function(a){return this.Yb(a.Ic(),a)};
	h.Yb=function(a,b){var c=ig(this,b);if(c)return c.Yb(a,function(a){return a});for(var c=this.k.Yb(a.name,Oc),d=Yf(c);null!=d&&0>b.compare(d,a);)R(c),d=Yf(c);return c};h.$e=function(a){return this.$b(a.Gc(),a)};h.$b=function(a,b){var c=ig(this,b);if(c)return c.$b(a,function(a){return a});for(var c=this.k.$b(a.name,Oc),d=Yf(c);null!=d&&0<b.compare(d,a);)R(c),d=Yf(c);return c};h.tc=function(a){return this.e()?a.e()?0:-1:a.J()||a.e()?1:a===xe?-1:0};
	h.ob=function(a){if(a===de||ua(this.zb.dc,a.toString()))return this;var b=this.zb,c=this.k;H(a!==de,"KeyIndex always exists and isn't meant to be added to the IndexMap.");for(var d=[],e=!1,c=c.Xb(Oc),f=R(c);f;)e=e||a.yc(f.S),d.push(f),f=R(c);d=e?Ke(d,ne(a)):ue;e=a.toString();c=ya(b.dc);c[e]=a;a=ya(b.od);a[e]=d;return new P(this.k,this.aa,new Ie(a,c))};h.zc=function(a){return a===de||ua(this.zb.dc,a.toString())};
	h.ca=function(a){if(a===this)return!0;if(a.J())return!1;if(this.C().ca(a.C())&&this.k.count()===a.k.count()){var b=this.Xb(N);a=a.Xb(N);for(var c=R(b),d=R(a);c&&d;){if(c.name!==d.name||!c.S.ca(d.S))return!1;c=R(b);d=R(a)}return null===c&&null===d}return!1};function ig(a,b){return b===de?null:a.zb.get(b.toString())}h.toString=function(){return B(this.H(!0))};function M(a,b){if(null===a)return F;var c=null;"object"===typeof a&&".priority"in a?c=a[".priority"]:"undefined"!==typeof b&&(c=b);H(null===c||"string"===typeof c||"number"===typeof c||"object"===typeof c&&".sv"in c,"Invalid priority type found: "+typeof c);"object"===typeof a&&".value"in a&&null!==a[".value"]&&(a=a[".value"]);if("object"!==typeof a||".sv"in a)return new Vc(a,M(c));if(a instanceof Array){var d=F,e=a;t(e,function(a,b){if(Bb(e,b)&&"."!==b.substring(0,1)){var c=M(a);if(c.J()||!c.e())d=
	d.U(b,c)}});return d.ga(M(c))}var f=[],g=!1,k=a;Cb(k,function(a){if("string"!==typeof a||"."!==a.substring(0,1)){var b=M(k[a]);b.e()||(g=g||!b.C().e(),f.push(new K(a,b)))}});if(0==f.length)return F;var m=Ke(f,Lc,function(a){return a.name},Nc);if(g){var l=Ke(f,ne(N));return new P(m,M(c),new Ie({".priority":l},{".priority":N}))}return new P(m,M(c),Me)}var jg=Math.log(2);
	function kg(a){this.count=parseInt(Math.log(a+1)/jg,10);this.Re=this.count-1;this.Lf=a+1&parseInt(Array(this.count+1).join("1"),2)}function lg(a){var b=!(a.Lf&1<<a.Re);a.Re--;return b}
	function Ke(a,b,c,d){function e(b,d){var f=d-b;if(0==f)return null;if(1==f){var l=a[b],u=c?c(l):l;return new Zf(u,l.S,!1,null,null)}var l=parseInt(f/2,10)+b,f=e(b,l),z=e(l+1,d),l=a[l],u=c?c(l):l;return new Zf(u,l.S,!1,f,z)}a.sort(b);var f=function(b){function d(b,g){var k=u-b,z=u;u-=b;var z=e(k+1,z),k=a[k],G=c?c(k):k,z=new Zf(G,k.S,g,null,z);f?f.left=z:l=z;f=z}for(var f=null,l=null,u=a.length,z=0;z<b.count;++z){var G=lg(b),td=Math.pow(2,b.count-(z+1));G?d(td,!1):(d(td,!1),d(td,!0))}return l}(new kg(a.length));
	return null!==f?new Uf(d||b,f):new Uf(d||b)}function se(a){return"number"===typeof a?"number:"+nd(a):"string:"+a}function qe(a){if(a.J()){var b=a.H();H("string"===typeof b||"number"===typeof b||"object"===typeof b&&Bb(b,".sv"),"Priority must be a string or number.")}else H(a===xe||a.e(),"priority of unexpected type.");H(a===xe||a.C().e(),"Priority nodes can't have a priority of their own.")}var F=new P(new Uf(Nc),null,Me);function mg(){P.call(this,new Uf(Nc),F,Me)}ka(mg,P);h=mg.prototype;
	h.tc=function(a){return a===this?0:1};h.ca=function(a){return a===this};h.C=function(){return this};h.R=function(){return F};h.e=function(){return!1};var xe=new mg,ve=new K("[MIN_NAME]",F),Be=new K("[MAX_NAME]",xe);function W(a,b,c){this.A=a;this.W=b;this.g=c}W.prototype.H=function(){y("Firebase.DataSnapshot.val",0,0,arguments.length);return this.A.H()};W.prototype.val=W.prototype.H;W.prototype.Ue=function(){y("Firebase.DataSnapshot.exportVal",0,0,arguments.length);return this.A.H(!0)};W.prototype.exportVal=W.prototype.Ue;W.prototype.Vf=function(){y("Firebase.DataSnapshot.exists",0,0,arguments.length);return!this.A.e()};W.prototype.exists=W.prototype.Vf;
	W.prototype.m=function(a){y("Firebase.DataSnapshot.child",0,1,arguments.length);fa(a)&&(a=String(a));Kf("Firebase.DataSnapshot.child",a);var b=new L(a),c=this.W.m(b);return new W(this.A.Q(b),c,N)};W.prototype.child=W.prototype.m;W.prototype.Fa=function(a){y("Firebase.DataSnapshot.hasChild",1,1,arguments.length);Kf("Firebase.DataSnapshot.hasChild",a);var b=new L(a);return!this.A.Q(b).e()};W.prototype.hasChild=W.prototype.Fa;
	W.prototype.C=function(){y("Firebase.DataSnapshot.getPriority",0,0,arguments.length);return this.A.C().H()};W.prototype.getPriority=W.prototype.C;W.prototype.forEach=function(a){y("Firebase.DataSnapshot.forEach",1,1,arguments.length);A("Firebase.DataSnapshot.forEach",1,a,!1);if(this.A.J())return!1;var b=this;return!!this.A.P(this.g,function(c,d){return a(new W(d,b.W.m(c),N))})};W.prototype.forEach=W.prototype.forEach;
	W.prototype.kd=function(){y("Firebase.DataSnapshot.hasChildren",0,0,arguments.length);return this.A.J()?!1:!this.A.e()};W.prototype.hasChildren=W.prototype.kd;W.prototype.getKey=function(){y("Firebase.DataSnapshot.key",0,0,arguments.length);return this.W.getKey()};pd(W.prototype,"key",W.prototype.getKey);W.prototype.Fb=function(){y("Firebase.DataSnapshot.numChildren",0,0,arguments.length);return this.A.Fb()};W.prototype.numChildren=W.prototype.Fb;
	W.prototype.xb=function(){y("Firebase.DataSnapshot.ref",0,0,arguments.length);return this.W};pd(W.prototype,"ref",W.prototype.xb);function Xd(a,b){this.O=a;this.Ld=b}function Ud(a,b,c,d){return new Xd(new Ec(b,c,d),a.Ld)}function Yd(a){return a.O.ea?a.O.j():null}Xd.prototype.u=function(){return this.Ld};function Fc(a){return a.Ld.ea?a.Ld.j():null};function ng(a,b){this.W=a;var c=a.n,d=new ee(c.g),c=S(c)?new ee(c.g):c.xa?new ke(c):new fe(c);this.of=new Od(c);var e=b.u(),f=b.O,g=d.za(F,e.j(),null),k=c.za(F,f.j(),null);this.Na=new Xd(new Ec(k,f.ea,c.Qa()),new Ec(g,e.ea,d.Qa()));this.ab=[];this.Sf=new Jd(a)}function og(a){return a.W}h=ng.prototype;h.u=function(){return this.Na.u().j()};h.jb=function(a){var b=Fc(this.Na);return b&&(S(this.W.n)||!a.e()&&!b.R(J(a)).e())?b.Q(a):null};h.e=function(){return 0===this.ab.length};h.Ob=function(a){this.ab.push(a)};
	h.mb=function(a,b){var c=[];if(b){H(null==a,"A cancel should cancel all event registrations.");var d=this.W.path;Ja(this.ab,function(a){(a=a.Pe(b,d))&&c.push(a)})}if(a){for(var e=[],f=0;f<this.ab.length;++f){var g=this.ab[f];if(!g.matches(a))e.push(g);else if(a.af()){e=e.concat(this.ab.slice(f+1));break}}this.ab=e}else this.ab=[];return c};
	h.gb=function(a,b,c){a.type===Gd&&null!==a.source.Ib&&(H(Fc(this.Na),"We should always have a full cache before handling merges"),H(Yd(this.Na),"Missing event cache, even though we have a server cache"));var d=this.Na;a=this.of.gb(d,a,b,c);b=this.of;c=a.Sd;H(c.O.j().zc(b.V.g),"Event snap not indexed");H(c.u().j().zc(b.V.g),"Server snap not indexed");H(Ic(a.Sd.u())||!Ic(d.u()),"Once a server snap is complete, it should never go back");this.Na=a.Sd;return pg(this,a.Mf,a.Sd.O.j(),null)};
	function qg(a,b){var c=a.Na.O,d=[];c.j().J()||c.j().P(N,function(a,b){d.push(new I("child_added",b,a))});c.ea&&d.push(Gc(c.j()));return pg(a,d,c.j(),b)}function pg(a,b,c,d){return Kd(a.Sf,b,c,d?[d]:a.ab)};function rg(a,b,c){this.Qb=a;this.sb=b;this.ub=c||null}h=rg.prototype;h.tf=function(a){return"value"===a};h.createEvent=function(a,b){var c=b.n.g;return new yc("value",this,new W(a.Ma,b.xb(),c))};h.Ub=function(a){var b=this.ub;if("cancel"===a.ge()){H(this.sb,"Raising a cancel event on a listener with no cancel callback");var c=this.sb;return function(){c.call(b,a.error)}}var d=this.Qb;return function(){d.call(b,a.Md)}};h.Pe=function(a,b){return this.sb?new zc(this,a,b):null};
	h.matches=function(a){return a instanceof rg?a.Qb&&this.Qb?a.Qb===this.Qb&&a.ub===this.ub:!0:!1};h.af=function(){return null!==this.Qb};function sg(a,b,c){this.ha=a;this.sb=b;this.ub=c}h=sg.prototype;h.tf=function(a){a="children_added"===a?"child_added":a;return("children_removed"===a?"child_removed":a)in this.ha};h.Pe=function(a,b){return this.sb?new zc(this,a,b):null};
	h.createEvent=function(a,b){H(null!=a.Za,"Child events should have a childName.");var c=b.xb().m(a.Za);return new yc(a.type,this,new W(a.Ma,c,b.n.g),a.Dd)};h.Ub=function(a){var b=this.ub;if("cancel"===a.ge()){H(this.sb,"Raising a cancel event on a listener with no cancel callback");var c=this.sb;return function(){c.call(b,a.error)}}var d=this.ha[a.gd];return function(){d.call(b,a.Md,a.Dd)}};
	h.matches=function(a){if(a instanceof sg){if(!this.ha||!a.ha)return!0;if(this.ub===a.ub){var b=qa(a.ha);if(b===qa(this.ha)){if(1===b){var b=ra(a.ha),c=ra(this.ha);return c===b&&(!a.ha[b]||!this.ha[c]||a.ha[b]===this.ha[c])}return pa(this.ha,function(b,c){return a.ha[c]===b})}}}return!1};h.af=function(){return null!==this.ha};function X(a,b,c,d){this.w=a;this.path=b;this.n=c;this.Oc=d}
	function tg(a){var b=null,c=null;a.ka&&(b=he(a));a.na&&(c=je(a));if(a.g===de){if(a.ka){if("[MIN_NAME]"!=ge(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==typeof b)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}if(a.na){if("[MAX_NAME]"!=ie(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==
	typeof c)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}}else if(a.g===N){if(null!=b&&!Cf(b)||null!=c&&!Cf(c))throw Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");}else if(H(a.g instanceof we||a.g===Ce,"unknown index type."),null!=b&&"object"===typeof b||null!=c&&"object"===typeof c)throw Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
	}function ug(a){if(a.ka&&a.na&&a.xa&&(!a.xa||""===a.oc))throw Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");}function vg(a,b){if(!0===a.Oc)throw Error(b+": You can't combine multiple orderBy calls.");}h=X.prototype;h.xb=function(){y("Query.ref",0,0,arguments.length);return new U(this.w,this.path)};
	h.hc=function(a,b,c,d){y("Query.on",2,4,arguments.length);If("Query.on",a,!1);A("Query.on",2,b,!1);var e=wg("Query.on",c,d);if("value"===a)xg(this.w,this,new rg(b,e.cancel||null,e.Pa||null));else{var f={};f[a]=b;xg(this.w,this,new sg(f,e.cancel,e.Pa))}return b};
	h.Jc=function(a,b,c){y("Query.off",0,3,arguments.length);If("Query.off",a,!0);A("Query.off",2,b,!0);Eb("Query.off",3,c);var d=null,e=null;"value"===a?d=new rg(b||null,null,c||null):a&&(b&&(e={},e[a]=b),d=new sg(e,null,c||null));e=this.w;d=".info"===J(this.path)?e.pd.mb(this,d):e.K.mb(this,d);uc(e.da,this.path,d)};
	h.kg=function(a,b){function c(k){f&&(f=!1,e.Jc(a,c),b&&b.call(d.Pa,k),g.resolve(k))}y("Query.once",1,4,arguments.length);If("Query.once",a,!1);A("Query.once",2,b,!0);var d=wg("Query.once",arguments[2],arguments[3]),e=this,f=!0,g=new Hb;Jb(g.ra);this.hc(a,c,function(b){e.Jc(a,c);d.cancel&&d.cancel.call(d.Pa,b);g.reject(b)});return g.ra};
	h.ne=function(a){y("Query.limitToFirst",1,1,arguments.length);if(!fa(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToFirst: First argument must be a positive integer.");if(this.n.xa)throw Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.w,this.path,this.n.ne(a),this.Oc)};
	h.oe=function(a){y("Query.limitToLast",1,1,arguments.length);if(!fa(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToLast: First argument must be a positive integer.");if(this.n.xa)throw Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.w,this.path,this.n.oe(a),this.Oc)};
	h.lg=function(a){y("Query.orderByChild",1,1,arguments.length);if("$key"===a)throw Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');if("$priority"===a)throw Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');if("$value"===a)throw Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');Kf("Query.orderByChild",a);vg(this,"Query.orderByChild");var b=new L(a);if(b.e())throw Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
	b=new we(b);b=Ge(this.n,b);tg(b);return new X(this.w,this.path,b,!0)};h.mg=function(){y("Query.orderByKey",0,0,arguments.length);vg(this,"Query.orderByKey");var a=Ge(this.n,de);tg(a);return new X(this.w,this.path,a,!0)};h.ng=function(){y("Query.orderByPriority",0,0,arguments.length);vg(this,"Query.orderByPriority");var a=Ge(this.n,N);tg(a);return new X(this.w,this.path,a,!0)};
	h.og=function(){y("Query.orderByValue",0,0,arguments.length);vg(this,"Query.orderByValue");var a=Ge(this.n,Ce);tg(a);return new X(this.w,this.path,a,!0)};h.Nd=function(a,b){y("Query.startAt",0,2,arguments.length);Df("Query.startAt",a,this.path,!0);Jf("Query.startAt",b);var c=this.n.Nd(a,b);ug(c);tg(c);if(this.n.ka)throw Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");p(a)||(b=a=null);return new X(this.w,this.path,c,this.Oc)};
	h.fd=function(a,b){y("Query.endAt",0,2,arguments.length);Df("Query.endAt",a,this.path,!0);Jf("Query.endAt",b);var c=this.n.fd(a,b);ug(c);tg(c);if(this.n.na)throw Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");return new X(this.w,this.path,c,this.Oc)};
	h.Rf=function(a,b){y("Query.equalTo",1,2,arguments.length);Df("Query.equalTo",a,this.path,!1);Jf("Query.equalTo",b);if(this.n.ka)throw Error("Query.equalTo: Starting point was already set (by another call to endAt or equalTo).");if(this.n.na)throw Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");return this.Nd(a,b).fd(a,b)};
	h.toString=function(){y("Query.toString",0,0,arguments.length);for(var a=this.path,b="",c=a.Z;c<a.o.length;c++)""!==a.o[c]&&(b+="/"+encodeURIComponent(String(a.o[c])));return this.w.toString()+(b||"/")};h.ya=function(){var a=kd(He(this.n));return"{}"===a?"default":a};
	function wg(a,b,c){var d={cancel:null,Pa:null};if(b&&c)d.cancel=b,A(a,3,d.cancel,!0),d.Pa=c,Eb(a,4,d.Pa);else if(b)if("object"===typeof b&&null!==b)d.Pa=b;else if("function"===typeof b)d.cancel=b;else throw Error(Db(a,3,!0)+" must either be a cancel callback or a context object.");return d}X.prototype.on=X.prototype.hc;X.prototype.off=X.prototype.Jc;X.prototype.once=X.prototype.kg;X.prototype.limitToFirst=X.prototype.ne;X.prototype.limitToLast=X.prototype.oe;X.prototype.orderByChild=X.prototype.lg;
	X.prototype.orderByKey=X.prototype.mg;X.prototype.orderByPriority=X.prototype.ng;X.prototype.orderByValue=X.prototype.og;X.prototype.startAt=X.prototype.Nd;X.prototype.endAt=X.prototype.fd;X.prototype.equalTo=X.prototype.Rf;X.prototype.toString=X.prototype.toString;pd(X.prototype,"ref",X.prototype.xb);function yg(a,b){this.value=a;this.children=b||zg}var zg=new Uf(function(a,b){return a===b?0:a<b?-1:1});function Ag(a){var b=Q;t(a,function(a,d){b=b.set(new L(d),a)});return b}h=yg.prototype;h.e=function(){return null===this.value&&this.children.e()};function Bg(a,b,c){if(null!=a.value&&c(a.value))return{path:C,value:a.value};if(b.e())return null;var d=J(b);a=a.children.get(d);return null!==a?(b=Bg(a,D(b),c),null!=b?{path:(new L(d)).m(b.path),value:b.value}:null):null}
	function Cg(a,b){return Bg(a,b,function(){return!0})}h.subtree=function(a){if(a.e())return this;var b=this.children.get(J(a));return null!==b?b.subtree(D(a)):Q};h.set=function(a,b){if(a.e())return new yg(b,this.children);var c=J(a),d=(this.children.get(c)||Q).set(D(a),b),c=this.children.Ra(c,d);return new yg(this.value,c)};
	h.remove=function(a){if(a.e())return this.children.e()?Q:new yg(null,this.children);var b=J(a),c=this.children.get(b);return c?(a=c.remove(D(a)),b=a.e()?this.children.remove(b):this.children.Ra(b,a),null===this.value&&b.e()?Q:new yg(this.value,b)):this};h.get=function(a){if(a.e())return this.value;var b=this.children.get(J(a));return b?b.get(D(a)):null};
	function ce(a,b,c){if(b.e())return c;var d=J(b);b=ce(a.children.get(d)||Q,D(b),c);d=b.e()?a.children.remove(d):a.children.Ra(d,b);return new yg(a.value,d)}function Dg(a,b){return Eg(a,C,b)}function Eg(a,b,c){var d={};a.children.ia(function(a,f){d[a]=Eg(f,b.m(a),c)});return c(b,a.value,d)}function Fg(a,b,c){return Gg(a,b,C,c)}function Gg(a,b,c,d){var e=a.value?d(c,a.value):!1;if(e)return e;if(b.e())return null;e=J(b);return(a=a.children.get(e))?Gg(a,D(b),c.m(e),d):null}
	function Hg(a,b,c){Ig(a,b,C,c)}function Ig(a,b,c,d){if(b.e())return a;a.value&&d(c,a.value);var e=J(b);return(a=a.children.get(e))?Ig(a,D(b),c.m(e),d):Q}function ae(a,b){Jg(a,C,b)}function Jg(a,b,c){a.children.ia(function(a,e){Jg(e,b.m(a),c)});a.value&&c(b,a.value)}function Kg(a,b){a.children.ia(function(a,d){d.value&&b(a,d.value)})}var Q=new yg(null);yg.prototype.toString=function(){var a={};ae(this,function(b,c){a[b.toString()]=c.toString()});return B(a)};function Lg(a,b,c){this.type=Td;this.source=Mg;this.path=a;this.Pb=b;this.Id=c}Lg.prototype.Nc=function(a){if(this.path.e()){if(null!=this.Pb.value)return H(this.Pb.children.e(),"affectedTree should not have overlapping affected paths."),this;a=this.Pb.subtree(new L(a));return new Lg(C,a,this.Id)}H(J(this.path)===a,"operationForChild called for unrelated child.");return new Lg(D(this.path),this.Pb,this.Id)};
	Lg.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" ack write revert="+this.Id+" affectedTree="+this.Pb+")"};var ac=0,Gd=1,Td=2,cc=3;function Ng(a,b,c,d){this.ee=a;this.We=b;this.Ib=c;this.Ee=d;H(!d||b,"Tagged queries must be from server.")}var Mg=new Ng(!0,!1,null,!1),Og=new Ng(!1,!0,null,!1);Ng.prototype.toString=function(){return this.ee?"user":this.Ee?"server(queryID="+this.Ib+")":"server"};function Pg(a){this.X=a}var Qg=new Pg(new yg(null));function Rg(a,b,c){if(b.e())return new Pg(new yg(c));var d=Cg(a.X,b);if(null!=d){var e=d.path,d=d.value;b=T(e,b);d=d.F(b,c);return new Pg(a.X.set(e,d))}a=ce(a.X,b,new yg(c));return new Pg(a)}function Sg(a,b,c){var d=a;Cb(c,function(a,c){d=Rg(d,b.m(a),c)});return d}Pg.prototype.Ed=function(a){if(a.e())return Qg;a=ce(this.X,a,Q);return new Pg(a)};function Tg(a,b){var c=Cg(a.X,b);return null!=c?a.X.get(c.path).Q(T(c.path,b)):null}
	function Ug(a){var b=[],c=a.X.value;null!=c?c.J()||c.P(N,function(a,c){b.push(new K(a,c))}):a.X.children.ia(function(a,c){null!=c.value&&b.push(new K(a,c.value))});return b}function Vg(a,b){if(b.e())return a;var c=Tg(a,b);return null!=c?new Pg(new yg(c)):new Pg(a.X.subtree(b))}Pg.prototype.e=function(){return this.X.e()};Pg.prototype.apply=function(a){return Wg(C,this.X,a)};
	function Wg(a,b,c){if(null!=b.value)return c.F(a,b.value);var d=null;b.children.ia(function(b,f){".priority"===b?(H(null!==f.value,"Priority writes must always be leaf nodes"),d=f.value):c=Wg(a.m(b),f,c)});c.Q(a).e()||null===d||(c=c.F(a.m(".priority"),d));return c};function Xg(){this.Aa={}}h=Xg.prototype;h.e=function(){return xa(this.Aa)};h.gb=function(a,b,c){var d=a.source.Ib;if(null!==d)return d=x(this.Aa,d),H(null!=d,"SyncTree gave us an op for an invalid query."),d.gb(a,b,c);var e=[];t(this.Aa,function(d){e=e.concat(d.gb(a,b,c))});return e};h.Ob=function(a,b,c,d,e){var f=a.ya(),g=x(this.Aa,f);if(!g){var g=c.Ba(e?d:null),k=!1;g?k=!0:(g=d instanceof P?c.sc(d):F,k=!1);g=new ng(a,new Xd(new Ec(g,k,!1),new Ec(d,e,!1)));this.Aa[f]=g}g.Ob(b);return qg(g,b)};
	h.mb=function(a,b,c){var d=a.ya(),e=[],f=[],g=null!=Yg(this);if("default"===d){var k=this;t(this.Aa,function(a,d){f=f.concat(a.mb(b,c));a.e()&&(delete k.Aa[d],S(a.W.n)||e.push(a.W))})}else{var m=x(this.Aa,d);m&&(f=f.concat(m.mb(b,c)),m.e()&&(delete this.Aa[d],S(m.W.n)||e.push(m.W)))}g&&null==Yg(this)&&e.push(new U(a.w,a.path));return{sg:e,Tf:f}};function Zg(a){return Ka(sa(a.Aa),function(a){return!S(a.W.n)})}h.jb=function(a){var b=null;t(this.Aa,function(c){b=b||c.jb(a)});return b};
	function $g(a,b){if(S(b.n))return Yg(a);var c=b.ya();return x(a.Aa,c)}function Yg(a){return wa(a.Aa,function(a){return S(a.W.n)})||null};function ah(){this.T=Qg;this.la=[];this.Cc=-1}function bh(a,b){for(var c=0;c<a.la.length;c++){var d=a.la[c];if(d.Zc===b)return d}return null}h=ah.prototype;
	h.Ed=function(a){var b=Pa(this.la,function(b){return b.Zc===a});H(0<=b,"removeWrite called with nonexistent writeId.");var c=this.la[b];this.la.splice(b,1);for(var d=c.visible,e=!1,f=this.la.length-1;d&&0<=f;){var g=this.la[f];g.visible&&(f>=b&&ch(g,c.path)?d=!1:c.path.contains(g.path)&&(e=!0));f--}if(d){if(e)this.T=dh(this.la,eh,C),this.Cc=0<this.la.length?this.la[this.la.length-1].Zc:-1;else if(c.Ja)this.T=this.T.Ed(c.path);else{var k=this;t(c.children,function(a,b){k.T=k.T.Ed(c.path.m(b))})}return!0}return!1};
	h.Ba=function(a,b,c,d){if(c||d){var e=Vg(this.T,a);return!d&&e.e()?b:d||null!=b||null!=Tg(e,C)?(e=dh(this.la,function(b){return(b.visible||d)&&(!c||!(0<=Ia(c,b.Zc)))&&(b.path.contains(a)||a.contains(b.path))},a),b=b||F,e.apply(b)):null}e=Tg(this.T,a);if(null!=e)return e;e=Vg(this.T,a);return e.e()?b:null!=b||null!=Tg(e,C)?(b=b||F,e.apply(b)):null};
	h.sc=function(a,b){var c=F,d=Tg(this.T,a);if(d)d.J()||d.P(N,function(a,b){c=c.U(a,b)});else if(b){var e=Vg(this.T,a);b.P(N,function(a,b){var d=Vg(e,new L(a)).apply(b);c=c.U(a,d)});Ja(Ug(e),function(a){c=c.U(a.name,a.S)})}else e=Vg(this.T,a),Ja(Ug(e),function(a){c=c.U(a.name,a.S)});return c};h.$c=function(a,b,c,d){H(c||d,"Either existingEventSnap or existingServerSnap must exist");a=a.m(b);if(null!=Tg(this.T,a))return null;a=Vg(this.T,a);return a.e()?d.Q(b):a.apply(d.Q(b))};
	h.rc=function(a,b,c){a=a.m(b);var d=Tg(this.T,a);return null!=d?d:Dc(c,b)?Vg(this.T,a).apply(c.j().R(b)):null};h.mc=function(a){return Tg(this.T,a)};h.Xd=function(a,b,c,d,e,f){var g;a=Vg(this.T,a);g=Tg(a,C);if(null==g)if(null!=b)g=a.apply(b);else return[];g=g.ob(f);if(g.e()||g.J())return[];b=[];a=ne(f);e=e?g.$b(c,f):g.Yb(c,f);for(f=R(e);f&&b.length<d;)0!==a(f,c)&&b.push(f),f=R(e);return b};
	function ch(a,b){return a.Ja?a.path.contains(b):!!va(a.children,function(c,d){return a.path.m(d).contains(b)})}function eh(a){return a.visible}
	function dh(a,b,c){for(var d=Qg,e=0;e<a.length;++e){var f=a[e];if(b(f)){var g=f.path;if(f.Ja)c.contains(g)?(g=T(c,g),d=Rg(d,g,f.Ja)):g.contains(c)&&(g=T(g,c),d=Rg(d,C,f.Ja.Q(g)));else if(f.children)if(c.contains(g))g=T(c,g),d=Sg(d,g,f.children);else{if(g.contains(c))if(g=T(g,c),g.e())d=Sg(d,C,f.children);else if(f=x(f.children,J(g)))f=f.Q(D(g)),d=Rg(d,C,f)}else throw Xc("WriteRecord should have .snap or .children");}}return d}function fh(a,b){this.Mb=a;this.X=b}h=fh.prototype;
	h.Ba=function(a,b,c){return this.X.Ba(this.Mb,a,b,c)};h.sc=function(a){return this.X.sc(this.Mb,a)};h.$c=function(a,b,c){return this.X.$c(this.Mb,a,b,c)};h.mc=function(a){return this.X.mc(this.Mb.m(a))};h.Xd=function(a,b,c,d,e){return this.X.Xd(this.Mb,a,b,c,d,e)};h.rc=function(a,b){return this.X.rc(this.Mb,a,b)};h.m=function(a){return new fh(this.Mb.m(a),this.X)};function gh(){this.children={};this.ad=0;this.value=null}function hh(a,b,c){this.ud=a?a:"";this.Ha=b?b:null;this.A=c?c:new gh}function ih(a,b){for(var c=b instanceof L?b:new L(b),d=a,e;null!==(e=J(c));)d=new hh(e,d,x(d.A.children,e)||new gh),c=D(c);return d}h=hh.prototype;h.Ea=function(){return this.A.value};function jh(a,b){H("undefined"!==typeof b,"Cannot set value to undefined");a.A.value=b;kh(a)}h.clear=function(){this.A.value=null;this.A.children={};this.A.ad=0;kh(this)};
	h.kd=function(){return 0<this.A.ad};h.e=function(){return null===this.Ea()&&!this.kd()};h.P=function(a){var b=this;t(this.A.children,function(c,d){a(new hh(d,b,c))})};function lh(a,b,c,d){c&&!d&&b(a);a.P(function(a){lh(a,b,!0,d)});c&&d&&b(a)}function mh(a,b){for(var c=a.parent();null!==c&&!b(c);)c=c.parent()}h.path=function(){return new L(null===this.Ha?this.ud:this.Ha.path()+"/"+this.ud)};h.name=function(){return this.ud};h.parent=function(){return this.Ha};
	function kh(a){if(null!==a.Ha){var b=a.Ha,c=a.ud,d=a.e(),e=Bb(b.A.children,c);d&&e?(delete b.A.children[c],b.A.ad--,kh(b)):d||e||(b.A.children[c]=a.A,b.A.ad++,kh(b))}};function nh(a,b,c,d,e,f){this.id=oh++;this.f=cd("p:"+this.id+":");this.qd={};this.$={};this.pa=[];this.Pc=0;this.Lc=[];this.ma=!1;this.Va=1E3;this.td=3E5;this.Hb=b;this.Kc=c;this.ue=d;this.M=a;this.pb=this.Ia=this.Db=this.ze=null;this.Vd=e;this.de=!1;this.ke=0;if(f)throw Error("Auth override specified in options, but not supported on non Node.js platforms");this.Je=f||null;this.vb=null;this.Nb=!1;this.Gd={};this.tg=0;this.Ve=!0;this.Bc=this.me=null;ph(this,0);Sf.Wb().hc("visible",this.jg,this);-1===
	a.host.indexOf("fblocal")&&Rf.Wb().hc("online",this.ig,this)}var oh=0,qh=0;h=nh.prototype;h.ua=function(a,b,c){var d=++this.tg;a={r:d,a:a,b:b};this.f(B(a));H(this.ma,"sendRequest call when we're not connected not allowed.");this.Ia.ua(a);c&&(this.Gd[d]=c)};
	h.df=function(a,b,c,d){var e=a.ya(),f=a.path.toString();this.f("Listen called for "+f+" "+e);this.$[f]=this.$[f]||{};H(Cd(a.n)||!S(a.n),"listen() called for non-default but complete query");H(!this.$[f][e],"listen() called twice for same path/queryId.");a={G:d,ld:b,pg:a,tag:c};this.$[f][e]=a;this.ma&&rh(this,a)};
	function rh(a,b){var c=b.pg,d=c.path.toString(),e=c.ya();a.f("Listen on "+d+" for "+e);var f={p:d};b.tag&&(f.q=He(c.n),f.t=b.tag);f.h=b.ld();a.ua("q",f,function(f){var k=f.d,m=f.s;if(k&&"object"===typeof k&&Bb(k,"w")){var l=x(k,"w");da(l)&&0<=Ia(l,"no_index")&&O("Using an unspecified index. Consider adding "+('".indexOn": "'+c.n.g.toString()+'"')+" at "+c.path.toString()+" to your security rules for better performance")}(a.$[d]&&a.$[d][e])===b&&(a.f("listen response",f),"ok"!==m&&sh(a,d,e),b.G&&b.G(m,
	k))})}h.qf=function(a){this.pb=a;this.f("Auth token refreshed");this.pb?th(this):this.ma&&this.ua("unauth",{},function(){});if(a&&40===a.length||sd(a))this.f("Admin auth credential detected.  Reducing max reconnect time."),this.td=3E4};function th(a){if(a.ma&&a.pb){var b=a.pb,c=rd(b)?"auth":"gauth",d={cred:b};a.Je&&(d.authvar=a.Je);a.ua(c,d,function(c){var d=c.s;c=c.d||"error";a.pb===b&&("ok"===d?this.ke=0:uh(a,d,c))})}}
	h.Ef=function(a,b){var c=a.path.toString(),d=a.ya();this.f("Unlisten called for "+c+" "+d);H(Cd(a.n)||!S(a.n),"unlisten() called for non-default but complete query");if(sh(this,c,d)&&this.ma){var e=He(a.n);this.f("Unlisten on "+c+" for "+d);c={p:c};b&&(c.q=e,c.t=b);this.ua("n",c)}};h.re=function(a,b,c){this.ma?vh(this,"o",a,b,c):this.Lc.push({we:a,action:"o",data:b,G:c})};h.gf=function(a,b,c){this.ma?vh(this,"om",a,b,c):this.Lc.push({we:a,action:"om",data:b,G:c})};
	h.xd=function(a,b){this.ma?vh(this,"oc",a,null,b):this.Lc.push({we:a,action:"oc",data:null,G:b})};function vh(a,b,c,d,e){c={p:c,d:d};a.f("onDisconnect "+b,c);a.ua(b,c,function(a){e&&setTimeout(function(){e(a.s,a.d)},Math.floor(0))})}h.put=function(a,b,c,d){wh(this,"p",a,b,c,d)};h.ef=function(a,b,c,d){wh(this,"m",a,b,c,d)};function wh(a,b,c,d,e,f){d={p:c,d:d};p(f)&&(d.h=f);a.pa.push({action:b,sf:d,G:e});a.Pc++;b=a.pa.length-1;a.ma?xh(a,b):a.f("Buffering put: "+c)}
	function xh(a,b){var c=a.pa[b].action,d=a.pa[b].sf,e=a.pa[b].G;a.pa[b].qg=a.ma;a.ua(c,d,function(d){a.f(c+" response",d);delete a.pa[b];a.Pc--;0===a.Pc&&(a.pa=[]);e&&e(d.s,d.d)})}h.ye=function(a){this.ma&&(a={c:a},this.f("reportStats",a),this.ua("s",a,function(a){"ok"!==a.s&&this.f("reportStats","Error sending stats: "+a.d)}))};
	h.wd=function(a){if("r"in a){this.f("from server: "+B(a));var b=a.r,c=this.Gd[b];c&&(delete this.Gd[b],c(a.b))}else{if("error"in a)throw"A server-side error has occurred: "+a.error;"a"in a&&(b=a.a,a=a.b,this.f("handleServerMessage",b,a),"d"===b?this.Hb(a.p,a.d,!1,a.t):"m"===b?this.Hb(a.p,a.d,!0,a.t):"c"===b?yh(this,a.p,a.q):"ac"===b?uh(this,a.s,a.d):"sd"===b?this.ze?this.ze(a):"msg"in a&&"undefined"!==typeof console&&console.log("FIREBASE: "+a.msg.replace("\n","\nFIREBASE: ")):dd("Unrecognized action received from server: "+
	B(b)+"\nAre you using the latest client?"))}};h.Mc=function(a,b){this.f("connection ready");this.ma=!0;this.Bc=(new Date).getTime();this.ue({serverTimeOffset:a-(new Date).getTime()});this.Db=b;if(this.Ve){var c={};c["sdk.js."+firebase.SDK_VERSION.replace(/\./g,"-")]=1;Qb()?c["framework.cordova"]=1:"object"===typeof navigator&&"ReactNative"===navigator.product&&(c["framework.reactnative"]=1);this.ye(c)}zh(this);this.Ve=!1;this.Kc(!0)};
	function ph(a,b){H(!a.Ia,"Scheduling a connect when we're already connected/ing?");a.vb&&clearTimeout(a.vb);a.vb=setTimeout(function(){a.vb=null;Ah(a)},Math.floor(b))}h.jg=function(a){a&&!this.Nb&&this.Va===this.td&&(this.f("Window became visible.  Reducing delay."),this.Va=1E3,this.Ia||ph(this,0));this.Nb=a};h.ig=function(a){a?(this.f("Browser went online."),this.Va=1E3,this.Ia||ph(this,0)):(this.f("Browser went offline.  Killing connection."),this.Ia&&this.Ia.close())};
	h.jf=function(){this.f("data client disconnected");this.ma=!1;this.Ia=null;for(var a=0;a<this.pa.length;a++){var b=this.pa[a];b&&"h"in b.sf&&b.qg&&(b.G&&b.G("disconnect"),delete this.pa[a],this.Pc--)}0===this.Pc&&(this.pa=[]);this.Gd={};Bh(this)&&(this.Nb?this.Bc&&(3E4<(new Date).getTime()-this.Bc&&(this.Va=1E3),this.Bc=null):(this.f("Window isn't visible.  Delaying reconnect."),this.Va=this.td,this.me=(new Date).getTime()),a=Math.max(0,this.Va-((new Date).getTime()-this.me)),a*=Math.random(),this.f("Trying to reconnect in "+
	a+"ms"),ph(this,a),this.Va=Math.min(this.td,1.3*this.Va));this.Kc(!1)};
	function Ah(a){if(Bh(a)){a.f("Making a connection attempt");a.me=(new Date).getTime();a.Bc=null;var b=r(a.wd,a),c=r(a.Mc,a),d=r(a.jf,a),e=a.id+":"+qh++,f=a.Db,g=!1,k=null,m=function(){k?k.close():(g=!0,d())};a.Ia={close:m,ua:function(a){H(k,"sendRequest call when we're not connected not allowed.");k.ua(a)}};var l=a.de;a.de=!1;a.Vd.getToken(l).then(function(l){g?E("getToken() completed but was canceled"):(E("getToken() completed. Creating connection."),a.pb=l&&l.accessToken,k=new af(e,a.M,b,c,d,function(b){O(b+
	" ("+a.M.toString()+")");a.eb("server_kill")},f))}).then(null,function(b){a.f("Failed to get token: "+b);g||m()})}}h.eb=function(a){E("Interrupting connection for reason: "+a);this.qd[a]=!0;this.Ia?this.Ia.close():(this.vb&&(clearTimeout(this.vb),this.vb=null),this.ma&&this.jf())};h.lc=function(a){E("Resuming connection for reason: "+a);delete this.qd[a];xa(this.qd)&&(this.Va=1E3,this.Ia||ph(this,0))};
	function yh(a,b,c){c=c?La(c,function(a){return kd(a)}).join("$"):"default";(a=sh(a,b,c))&&a.G&&a.G("permission_denied")}function sh(a,b,c){b=(new L(b)).toString();var d;p(a.$[b])?(d=a.$[b][c],delete a.$[b][c],0===qa(a.$[b])&&delete a.$[b]):d=void 0;return d}
	function uh(a,b,c){E("Auth token revoked: "+b+"/"+c);a.pb=null;a.de=!0;a.Ia.close();"invalid_token"===b&&(a.ke++,3<=a.ke&&(a.Va=3E4,O("Provided authentication credentials are invalid. This usually indicates your FirebaseApp instance was not initialized correctly. Make sure your apiKey and databaseURL match the values provided for your app at https://console.firebase.google.com/, or if you're using a service account, make sure it's authorized to access the specified databaseURL and is from the correct project.")))}
	function zh(a){th(a);t(a.$,function(b){t(b,function(b){rh(a,b)})});for(var b=0;b<a.pa.length;b++)a.pa[b]&&xh(a,b);for(;a.Lc.length;)b=a.Lc.shift(),vh(a,b.action,b.we,b.data,b.G)}function Bh(a){var b;b=Rf.Wb().ic;return xa(a.qd)&&b};var Y={Xf:function(){Qe=wd=!0}};Y.forceLongPolling=Y.Xf;Y.Yf=function(){Re=!0};Y.forceWebSockets=Y.Yf;Y.dg=function(){return vd.isAvailable()};Y.isWebSocketsAvailable=Y.dg;Y.wg=function(a,b){a.w.Ua.ze=b};Y.setSecurityDebugCallback=Y.wg;Y.Be=function(a,b){a.w.Be(b)};Y.stats=Y.Be;Y.Ce=function(a,b){a.w.Ce(b)};Y.statsIncrementCounter=Y.Ce;Y.ed=function(a){return a.w.ed};Y.dataUpdateCount=Y.ed;Y.cg=function(a,b){a.w.je=b};Y.interceptServerData=Y.cg;function Ch(a){this.wa=Q;this.lb=new ah;this.De={};this.jc={};this.Dc=a}function Dh(a,b,c,d,e){var f=a.lb,g=e;H(d>f.Cc,"Stacking an older write on top of newer ones");p(g)||(g=!0);f.la.push({path:b,Ja:c,Zc:d,visible:g});g&&(f.T=Rg(f.T,b,c));f.Cc=d;return e?Eh(a,new $b(Mg,b,c)):[]}function Fh(a,b,c,d){var e=a.lb;H(d>e.Cc,"Stacking an older merge on top of newer ones");e.la.push({path:b,children:c,Zc:d,visible:!0});e.T=Sg(e.T,b,c);e.Cc=d;c=Ag(c);return Eh(a,new Fd(Mg,b,c))}
	function Gh(a,b,c){c=c||!1;var d=bh(a.lb,b);if(a.lb.Ed(b)){var e=Q;null!=d.Ja?e=e.set(C,!0):Cb(d.children,function(a,b){e=e.set(new L(a),b)});return Eh(a,new Lg(d.path,e,c))}return[]}function Hh(a,b,c){c=Ag(c);return Eh(a,new Fd(Og,b,c))}function Ih(a,b,c,d){d=Jh(a,d);if(null!=d){var e=Kh(d);d=e.path;e=e.Ib;b=T(d,b);c=new $b(new Ng(!1,!0,e,!0),b,c);return Lh(a,d,c)}return[]}
	function Mh(a,b,c,d){if(d=Jh(a,d)){var e=Kh(d);d=e.path;e=e.Ib;b=T(d,b);c=Ag(c);c=new Fd(new Ng(!1,!0,e,!0),b,c);return Lh(a,d,c)}return[]}
	Ch.prototype.Ob=function(a,b){var c=a.path,d=null,e=!1;Hg(this.wa,c,function(a,b){var f=T(a,c);d=d||b.jb(f);e=e||null!=Yg(b)});var f=this.wa.get(c);f?(e=e||null!=Yg(f),d=d||f.jb(C)):(f=new Xg,this.wa=this.wa.set(c,f));var g;null!=d?g=!0:(g=!1,d=F,Kg(this.wa.subtree(c),function(a,b){var c=b.jb(C);c&&(d=d.U(a,c))}));var k=null!=$g(f,a);if(!k&&!S(a.n)){var m=Nh(a);H(!(m in this.jc),"View does not exist, but we have a tag");var l=Oh++;this.jc[m]=l;this.De["_"+l]=m}g=f.Ob(a,b,new fh(c,this.lb),d,g);k||
	e||(f=$g(f,a),g=g.concat(Ph(this,a,f)));return g};
	Ch.prototype.mb=function(a,b,c){var d=a.path,e=this.wa.get(d),f=[];if(e&&("default"===a.ya()||null!=$g(e,a))){f=e.mb(a,b,c);e.e()&&(this.wa=this.wa.remove(d));e=f.sg;f=f.Tf;b=-1!==Pa(e,function(a){return S(a.n)});var g=Fg(this.wa,d,function(a,b){return null!=Yg(b)});if(b&&!g&&(d=this.wa.subtree(d),!d.e()))for(var d=Qh(d),k=0;k<d.length;++k){var m=d[k],l=m.W,m=Rh(this,m);this.Dc.Ae(Sh(l),Th(this,l),m.ld,m.G)}if(!g&&0<e.length&&!c)if(b)this.Dc.Od(Sh(a),null);else{var u=this;Ja(e,function(a){a.ya();
	var b=u.jc[Nh(a)];u.Dc.Od(Sh(a),b)})}Uh(this,e)}return f};Ch.prototype.Ba=function(a,b){var c=this.lb,d=Fg(this.wa,a,function(b,c){var d=T(b,a);if(d=c.jb(d))return d});return c.Ba(a,d,b,!0)};function Qh(a){return Dg(a,function(a,c,d){if(c&&null!=Yg(c))return[Yg(c)];var e=[];c&&(e=Zg(c));t(d,function(a){e=e.concat(a)});return e})}function Uh(a,b){for(var c=0;c<b.length;++c){var d=b[c];if(!S(d.n)){var d=Nh(d),e=a.jc[d];delete a.jc[d];delete a.De["_"+e]}}}
	function Sh(a){return S(a.n)&&!Cd(a.n)?a.xb():a}function Ph(a,b,c){var d=b.path,e=Th(a,b);c=Rh(a,c);b=a.Dc.Ae(Sh(b),e,c.ld,c.G);d=a.wa.subtree(d);if(e)H(null==Yg(d.value),"If we're adding a query, it shouldn't be shadowed");else for(e=Dg(d,function(a,b,c){if(!a.e()&&b&&null!=Yg(b))return[og(Yg(b))];var d=[];b&&(d=d.concat(La(Zg(b),function(a){return a.W})));t(c,function(a){d=d.concat(a)});return d}),d=0;d<e.length;++d)c=e[d],a.Dc.Od(Sh(c),Th(a,c));return b}
	function Rh(a,b){var c=b.W,d=Th(a,c);return{ld:function(){return(b.u()||F).hash()},G:function(b){if("ok"===b){if(d){var f=c.path;if(b=Jh(a,d)){var g=Kh(b);b=g.path;g=g.Ib;f=T(b,f);f=new bc(new Ng(!1,!0,g,!0),f);b=Lh(a,b,f)}else b=[]}else b=Eh(a,new bc(Og,c.path));return b}f="Unknown Error";"too_big"===b?f="The data requested exceeds the maximum size that can be accessed with a single request.":"permission_denied"==b?f="Client doesn't have permission to access the desired data.":"unavailable"==b&&
	(f="The service is unavailable");f=Error(b+" at "+c.path.toString()+": "+f);f.code=b.toUpperCase();return a.mb(c,null,f)}}}function Nh(a){return a.path.toString()+"$"+a.ya()}function Kh(a){var b=a.indexOf("$");H(-1!==b&&b<a.length-1,"Bad queryKey.");return{Ib:a.substr(b+1),path:new L(a.substr(0,b))}}function Jh(a,b){var c=a.De,d="_"+b;return d in c?c[d]:void 0}function Th(a,b){var c=Nh(b);return x(a.jc,c)}var Oh=1;
	function Lh(a,b,c){var d=a.wa.get(b);H(d,"Missing sync point for query tag that we're tracking");return d.gb(c,new fh(b,a.lb),null)}function Eh(a,b){return Vh(a,b,a.wa,null,new fh(C,a.lb))}function Vh(a,b,c,d,e){if(b.path.e())return Wh(a,b,c,d,e);var f=c.get(C);null==d&&null!=f&&(d=f.jb(C));var g=[],k=J(b.path),m=b.Nc(k);if((c=c.children.get(k))&&m)var l=d?d.R(k):null,k=e.m(k),g=g.concat(Vh(a,m,c,l,k));f&&(g=g.concat(f.gb(b,e,d)));return g}
	function Wh(a,b,c,d,e){var f=c.get(C);null==d&&null!=f&&(d=f.jb(C));var g=[];c.children.ia(function(c,f){var l=d?d.R(c):null,u=e.m(c),z=b.Nc(c);z&&(g=g.concat(Wh(a,z,f,l,u)))});f&&(g=g.concat(f.gb(b,e,d)));return g};function sf(a,b,c){this.app=c;var d=new dc(c);this.M=a;this.Xa=pc(a);this.Vc=null;this.da=new rc;this.vd=1;this.Ua=null;if(b||0<=("object"===typeof window&&window.navigator&&window.navigator.userAgent||"").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i))this.va=new Ad(this.M,r(this.Hb,this),d),setTimeout(r(this.Kc,this,!0),0);else{b=c.options.databaseAuthVariableOverride||null;if(null!==b){if("object"!==ca(b))throw Error("Only objects are supported for option databaseAuthVariableOverride");
	try{B(b)}catch(e){throw Error("Invalid authOverride provided: "+e);}}this.va=this.Ua=new nh(this.M,r(this.Hb,this),r(this.Kc,this),r(this.ue,this),d,b)}var f=this;ec(d,function(a){f.va.qf(a)});this.zg=qc(a,r(function(){return new jc(this.Xa,this.va)},this));this.nc=new hh;this.ie=new fc;this.pd=new Ch({Ae:function(a,b,c,d){b=[];c=f.ie.j(a.path);c.e()||(b=Eh(f.pd,new $b(Og,a.path,c)),setTimeout(function(){d("ok")},0));return b},Od:aa});Xh(this,"connected",!1);this.ja=new Rc;this.$a=new rf(this);this.ed=
	0;this.je=null;this.K=new Ch({Ae:function(a,b,c,d){f.va.df(a,c,b,function(b,c){var e=d(b,c);wc(f.da,a.path,e)});return[]},Od:function(a,b){f.va.Ef(a,b)}})}h=sf.prototype;h.toString=function(){return(this.M.Sc?"https://":"http://")+this.M.host};h.name=function(){return this.M.pe};function Yh(a){a=a.ie.j(new L(".info/serverTimeOffset")).H()||0;return(new Date).getTime()+a}function Zh(a){a=a={timestamp:Yh(a)};a.timestamp=a.timestamp||(new Date).getTime();return a}
	h.Hb=function(a,b,c,d){this.ed++;var e=new L(a);b=this.je?this.je(a,b):b;a=[];d?c?(b=oa(b,function(a){return M(a)}),a=Mh(this.K,e,b,d)):(b=M(b),a=Ih(this.K,e,b,d)):c?(d=oa(b,function(a){return M(a)}),a=Hh(this.K,e,d)):(d=M(b),a=Eh(this.K,new $b(Og,e,d)));d=e;0<a.length&&(d=$h(this,e));wc(this.da,d,a)};h.Kc=function(a){Xh(this,"connected",a);!1===a&&ai(this)};h.ue=function(a){var b=this;md(a,function(a,d){Xh(b,d,a)})};
	function Xh(a,b,c){b=new L("/.info/"+b);c=M(c);var d=a.ie;d.Jd=d.Jd.F(b,c);c=Eh(a.pd,new $b(Og,b,c));wc(a.da,b,c)}h.Kb=function(a,b,c,d){this.f("set",{path:a.toString(),value:b,Gg:c});var e=Zh(this);b=M(b,c);var e=Uc(b,e),f=this.vd++,e=Dh(this.K,a,e,f,!0);sc(this.da,e);var g=this;this.va.put(a.toString(),b.H(!0),function(b,c){var e="ok"===b;e||O("set at "+a+" failed: "+b);e=Gh(g.K,f,!e);wc(g.da,a,e);bi(d,b,c)});e=ci(this,a);$h(this,e);wc(this.da,e,[])};
	h.update=function(a,b,c){this.f("update",{path:a.toString(),value:b});var d=!0,e=Zh(this),f={};t(b,function(a,b){d=!1;var c=M(a);f[b]=Uc(c,e)});if(d)E("update() called with empty data.  Don't do anything."),bi(c,"ok");else{var g=this.vd++,k=Fh(this.K,a,f,g);sc(this.da,k);var m=this;this.va.ef(a.toString(),b,function(b,d){var e="ok"===b;e||O("update at "+a+" failed: "+b);var e=Gh(m.K,g,!e),f=a;0<e.length&&(f=$h(m,a));wc(m.da,f,e);bi(c,b,d)});b=ci(this,a);$h(this,b);wc(this.da,a,[])}};
	function ai(a){a.f("onDisconnectEvents");var b=Zh(a),c=[];Sc(Qc(a.ja,b),C,function(b,e){c=c.concat(Eh(a.K,new $b(Og,b,e)));var f=ci(a,b);$h(a,f)});a.ja=new Rc;wc(a.da,C,c)}h.xd=function(a,b){var c=this;this.va.xd(a.toString(),function(d,e){"ok"===d&&yf(c.ja,a);bi(b,d,e)})};function Mf(a,b,c,d){var e=M(c);a.va.re(b.toString(),e.H(!0),function(c,g){"ok"===c&&Tc(a.ja,b,e);bi(d,c,g)})}function Nf(a,b,c,d,e){var f=M(c,d);a.va.re(b.toString(),f.H(!0),function(c,d){"ok"===c&&Tc(a.ja,b,f);bi(e,c,d)})}
	function Of(a,b,c,d){var e=!0,f;for(f in c)e=!1;e?(E("onDisconnect().update() called with empty data.  Don't do anything."),bi(d,"ok")):a.va.gf(b.toString(),c,function(e,f){if("ok"===e)for(var m in c){var l=M(c[m]);Tc(a.ja,b.m(m),l)}bi(d,e,f)})}function xg(a,b,c){c=".info"===J(b.path)?a.pd.Ob(b,c):a.K.Ob(b,c);uc(a.da,b.path,c)}h.eb=function(){this.Ua&&this.Ua.eb("repo_interrupt")};h.lc=function(){this.Ua&&this.Ua.lc("repo_interrupt")};
	h.Be=function(a){if("undefined"!==typeof console){a?(this.Vc||(this.Vc=new kc(this.Xa)),a=this.Vc.get()):a=this.Xa.get();var b=Ma(ta(a),function(a,b){return Math.max(b.length,a)},0),c;for(c in a){for(var d=a[c],e=c.length;e<b+2;e++)c+=" ";console.log(c+d)}}};h.Ce=function(a){mc(this.Xa,a);this.zg.zf[a]=!0};h.f=function(a){var b="";this.Ua&&(b=this.Ua.id+":");E(b,arguments)};
	function bi(a,b,c){a&&Ub(function(){if("ok"==b)a(null);else{var d=(b||"error").toUpperCase(),e=d;c&&(e+=": "+c);e=Error(e);e.code=d;a(e)}})};function di(a,b,c,d,e){function f(){}a.f("transaction on "+b);var g=new U(a,b);g.hc("value",f);c={path:b,update:c,G:d,status:null,lf:Wc(),Ie:e,wf:0,Rd:function(){g.Jc("value",f)},Td:null,Da:null,bd:null,cd:null,dd:null};d=a.K.Ba(b,void 0)||F;c.bd=d;d=c.update(d.H());if(p(d)){Ef("transaction failed: Data returned ",d,c.path);c.status=1;e=ih(a.nc,b);var k=e.Ea()||[];k.push(c);jh(e,k);"object"===typeof d&&null!==d&&Bb(d,".priority")?(k=x(d,".priority"),H(Cf(k),"Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.")):
	k=(a.K.Ba(b)||F).C().H();e=Zh(a);d=M(d,k);e=Uc(d,e);c.cd=d;c.dd=e;c.Da=a.vd++;c=Dh(a.K,b,e,c.Da,c.Ie);wc(a.da,b,c);ei(a)}else c.Rd(),c.cd=null,c.dd=null,c.G&&(a=new W(c.bd,new U(a,c.path),N),c.G(null,!1,a))}function ei(a,b){var c=b||a.nc;b||fi(a,c);if(null!==c.Ea()){var d=gi(a,c);H(0<d.length,"Sending zero length transaction queue");Na(d,function(a){return 1===a.status})&&hi(a,c.path(),d)}else c.kd()&&c.P(function(b){ei(a,b)})}
	function hi(a,b,c){for(var d=La(c,function(a){return a.Da}),e=a.K.Ba(b,d)||F,d=e,e=e.hash(),f=0;f<c.length;f++){var g=c[f];H(1===g.status,"tryToSendTransactionQueue_: items in queue should all be run.");g.status=2;g.wf++;var k=T(b,g.path),d=d.F(k,g.cd)}d=d.H(!0);a.va.put(b.toString(),d,function(d){a.f("transaction put response",{path:b.toString(),status:d});var e=[];if("ok"===d){d=[];for(f=0;f<c.length;f++){c[f].status=3;e=e.concat(Gh(a.K,c[f].Da));if(c[f].G){var g=c[f].dd,k=new U(a,c[f].path);d.push(r(c[f].G,
	null,null,!0,new W(g,k,N)))}c[f].Rd()}fi(a,ih(a.nc,b));ei(a);wc(a.da,b,e);for(f=0;f<d.length;f++)Ub(d[f])}else{if("datastale"===d)for(f=0;f<c.length;f++)c[f].status=4===c[f].status?5:1;else for(O("transaction at "+b.toString()+" failed: "+d),f=0;f<c.length;f++)c[f].status=5,c[f].Td=d;$h(a,b)}},e)}function $h(a,b){var c=ii(a,b),d=c.path(),c=gi(a,c);ji(a,c,d);return d}
	function ji(a,b,c){if(0!==b.length){for(var d=[],e=[],f=Ka(b,function(a){return 1===a.status}),f=La(f,function(a){return a.Da}),g=0;g<b.length;g++){var k=b[g],m=T(c,k.path),l=!1,u;H(null!==m,"rerunTransactionsUnderNode_: relativePath should not be null.");if(5===k.status)l=!0,u=k.Td,e=e.concat(Gh(a.K,k.Da,!0));else if(1===k.status)if(25<=k.wf)l=!0,u="maxretry",e=e.concat(Gh(a.K,k.Da,!0));else{var z=a.K.Ba(k.path,f)||F;k.bd=z;var G=b[g].update(z.H());p(G)?(Ef("transaction failed: Data returned ",G,
	k.path),m=M(G),"object"===typeof G&&null!=G&&Bb(G,".priority")||(m=m.ga(z.C())),z=k.Da,G=Zh(a),G=Uc(m,G),k.cd=m,k.dd=G,k.Da=a.vd++,Qa(f,z),e=e.concat(Dh(a.K,k.path,G,k.Da,k.Ie)),e=e.concat(Gh(a.K,z,!0))):(l=!0,u="nodata",e=e.concat(Gh(a.K,k.Da,!0)))}wc(a.da,c,e);e=[];l&&(b[g].status=3,setTimeout(b[g].Rd,Math.floor(0)),b[g].G&&("nodata"===u?(k=new U(a,b[g].path),d.push(r(b[g].G,null,null,!1,new W(b[g].bd,k,N)))):d.push(r(b[g].G,null,Error(u),!1,null))))}fi(a,a.nc);for(g=0;g<d.length;g++)Ub(d[g]);ei(a)}}
	function ii(a,b){for(var c,d=a.nc;null!==(c=J(b))&&null===d.Ea();)d=ih(d,c),b=D(b);return d}function gi(a,b){var c=[];ki(a,b,c);c.sort(function(a,b){return a.lf-b.lf});return c}function ki(a,b,c){var d=b.Ea();if(null!==d)for(var e=0;e<d.length;e++)c.push(d[e]);b.P(function(b){ki(a,b,c)})}function fi(a,b){var c=b.Ea();if(c){for(var d=0,e=0;e<c.length;e++)3!==c[e].status&&(c[d]=c[e],d++);c.length=d;jh(b,0<c.length?c:null)}b.P(function(b){fi(a,b)})}
	function ci(a,b){var c=ii(a,b).path(),d=ih(a.nc,b);mh(d,function(b){li(a,b)});li(a,d);lh(d,function(b){li(a,b)});return c}
	function li(a,b){var c=b.Ea();if(null!==c){for(var d=[],e=[],f=-1,g=0;g<c.length;g++)4!==c[g].status&&(2===c[g].status?(H(f===g-1,"All SENT items should be at beginning of queue."),f=g,c[g].status=4,c[g].Td="set"):(H(1===c[g].status,"Unexpected transaction status in abort"),c[g].Rd(),e=e.concat(Gh(a.K,c[g].Da,!0)),c[g].G&&d.push(r(c[g].G,null,Error("set"),!1,null))));-1===f?jh(b,null):c.length=f+1;wc(a.da,b.path(),e);for(g=0;g<d.length;g++)Ub(d[g])}};function xf(){this.nb={};this.Ff=!1}xf.prototype.eb=function(){for(var a in this.nb)this.nb[a].eb()};xf.prototype.lc=function(){for(var a in this.nb)this.nb[a].lc()};xf.prototype.ce=function(a){this.Ff=a};ba(xf);xf.prototype.interrupt=xf.prototype.eb;xf.prototype.resume=xf.prototype.lc;var Z={};Z.pc=nh;Z.DataConnection=Z.pc;nh.prototype.yg=function(a,b){this.ua("q",{p:a},b)};Z.pc.prototype.simpleListen=Z.pc.prototype.yg;nh.prototype.Qf=function(a,b){this.ua("echo",{d:a},b)};Z.pc.prototype.echo=Z.pc.prototype.Qf;nh.prototype.interrupt=nh.prototype.eb;Z.If=af;Z.RealTimeConnection=Z.If;af.prototype.sendRequest=af.prototype.ua;af.prototype.close=af.prototype.close;
	Z.bg=function(a){var b=nh.prototype.put;nh.prototype.put=function(c,d,e,f){p(f)&&(f=a());b.call(this,c,d,e,f)};return function(){nh.prototype.put=b}};Z.hijackHash=Z.bg;Z.Hf=gc;Z.ConnectionTarget=Z.Hf;Z.ya=function(a){return a.ya()};Z.queryIdentifier=Z.ya;Z.eg=function(a){return a.w.Ua.$};Z.listens=Z.eg;Z.ce=function(a){xf.Wb().ce(a)};Z.forceRestClient=Z.ce;Z.Context=xf;function U(a,b){if(!(a instanceof sf))throw Error("new Firebase() no longer supported - use app.database().");X.call(this,a,b,Ee,!1);this.then=void 0;this["catch"]=void 0}ka(U,X);h=U.prototype;h.getKey=function(){y("Firebase.key",0,0,arguments.length);return this.path.e()?null:$d(this.path)};
	h.m=function(a){y("Firebase.child",1,1,arguments.length);if(fa(a))a=String(a);else if(!(a instanceof L))if(null===J(this.path)){var b=a;b&&(b=b.replace(/^\/*\.info(\/|$)/,"/"));Kf("Firebase.child",b)}else Kf("Firebase.child",a);return new U(this.w,this.path.m(a))};h.getParent=function(){y("Firebase.parent",0,0,arguments.length);var a=this.path.parent();return null===a?null:new U(this.w,a)};
	h.Zf=function(){y("Firebase.ref",0,0,arguments.length);for(var a=this;null!==a.getParent();)a=a.getParent();return a};h.Pf=function(){return this.w.$a};h.set=function(a,b){y("Firebase.set",1,2,arguments.length);Lf("Firebase.set",this.path);Df("Firebase.set",a,this.path,!1);A("Firebase.set",2,b,!0);var c=new Hb;this.w.Kb(this.path,a,null,Ib(c,b));return c.ra};
	h.update=function(a,b){y("Firebase.update",1,2,arguments.length);Lf("Firebase.update",this.path);if(da(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;O("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Gf("Firebase.update",a,this.path);A("Firebase.update",2,b,!0);c=new Hb;this.w.update(this.path,a,Ib(c,b));return c.ra};
	h.Kb=function(a,b,c){y("Firebase.setWithPriority",2,3,arguments.length);Lf("Firebase.setWithPriority",this.path);Df("Firebase.setWithPriority",a,this.path,!1);Hf("Firebase.setWithPriority",2,b);A("Firebase.setWithPriority",3,c,!0);if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.setWithPriority failed: "+this.getKey()+" is a read-only object.";var d=new Hb;this.w.Kb(this.path,a,b,Ib(d,c));return d.ra};
	h.remove=function(a){y("Firebase.remove",0,1,arguments.length);Lf("Firebase.remove",this.path);A("Firebase.remove",1,a,!0);return this.set(null,a)};
	h.transaction=function(a,b,c){y("Firebase.transaction",1,3,arguments.length);Lf("Firebase.transaction",this.path);A("Firebase.transaction",1,a,!1);A("Firebase.transaction",2,b,!0);if(p(c)&&"boolean"!=typeof c)throw Error(Db("Firebase.transaction",3,!0)+"must be a boolean.");if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.transaction failed: "+this.getKey()+" is a read-only object.";"undefined"===typeof c&&(c=!0);var d=new Hb;ga(b)&&Jb(d.ra);di(this.w,this.path,a,function(a,c,
	g){a?d.reject(a):d.resolve(new Pb(c,g));ga(b)&&b(a,c,g)},c);return d.ra};h.vg=function(a,b){y("Firebase.setPriority",1,2,arguments.length);Lf("Firebase.setPriority",this.path);Hf("Firebase.setPriority",1,a);A("Firebase.setPriority",2,b,!0);var c=new Hb;this.w.Kb(this.path.m(".priority"),a,null,Ib(c,b));return c.ra};
	h.push=function(a,b){y("Firebase.push",0,2,arguments.length);Lf("Firebase.push",this.path);Df("Firebase.push",a,this.path,!0);A("Firebase.push",2,b,!0);var c=Yh(this.w),d=Tf(c),c=this.m(d);if(null!=a){var e=this,f=c.set(a,b).then(function(){return e.m(d)});c.then=r(f.then,f);c["catch"]=r(f.then,f,void 0);ga(b)&&Jb(f)}return c};h.kb=function(){Lf("Firebase.onDisconnect",this.path);return new V(this.w,this.path)};U.prototype.child=U.prototype.m;U.prototype.set=U.prototype.set;U.prototype.update=U.prototype.update;
	U.prototype.setWithPriority=U.prototype.Kb;U.prototype.remove=U.prototype.remove;U.prototype.transaction=U.prototype.transaction;U.prototype.setPriority=U.prototype.vg;U.prototype.push=U.prototype.push;U.prototype.onDisconnect=U.prototype.kb;pd(U.prototype,"database",U.prototype.Pf);pd(U.prototype,"key",U.prototype.getKey);pd(U.prototype,"parent",U.prototype.getParent);pd(U.prototype,"root",U.prototype.Zf);if("undefined"===typeof firebase)throw Error("Cannot install Firebase Database - be sure to load firebase-app.js first.");
	try{firebase.INTERNAL.registerService("database",function(a){var b=xf.Wb(),c=a.options.databaseURL;p(c)||ed("Can't determine Firebase Database URL.  Be sure to include databaseURL option when calling firebase.intializeApp().");var d=fd(c),c=d.kc;wf("Invalid Firebase Database URL",d);d.path.e()||ed("Database URL must point to the root of a Firebase Database (not including a child path).");(d=x(b.nb,a.name))&&ed("FIREBASE INTERNAL ERROR: Database initialized multiple times.");d=new sf(c,b.Ff,a);b.nb[a.name]=
	d;return d.$a},{Reference:U,Query:X,Database:rf,enableLogging:bd,INTERNAL:Y,TEST_ACCESS:Z,ServerValue:uf})}catch(mi){ed("Failed to register the Firebase Database Service ("+mi+")")};})();
	
	(function() {var k,aa=aa||{},m=this,n=function(a){return void 0!==a},ba=function(){},p=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=
	typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},ca=function(a){var b=p(a);return"array"==b||"object"==b&&"number"==typeof a.length},q=function(a){return"string"==typeof a},r=function(a){return"function"==p(a)},da=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b},ea="closure_uid_"+(1E9*Math.random()>>>0),fa=0,ga=function(a,b,c){return a.call.apply(a.bind,
	arguments)},ha=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}},t=function(a,b,c){t=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ga:ha;return t.apply(null,arguments)},ia=Date.now||function(){return+new Date},u=function(a,b){function c(){}
	c.prototype=b.prototype;a.I=b.prototype;a.prototype=new c;a.La=function(a,c,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[c].apply(a,g)}};var ja=function(a,b,c){function d(){ya||(ya=!0,b.apply(null,arguments))}function e(b){l=setTimeout(function(){l=null;a(f,2===N)},b)}function f(a,b){if(!ya)if(a)d.apply(null,arguments);else if(2===N||F)d.apply(null,arguments);else{64>h&&(h*=2);var c;1===N?(N=2,c=0):c=1E3*(h+Math.random());e(c)}}function g(a){cc||(cc=!0,ya||(null!==l?(a||(N=2),clearTimeout(l),e(0)):a||(N=1)))}var h=1,l=null,F=!1,N=0,ya=!1,cc=!1;e(0);setTimeout(function(){F=!0;g(!0)},c);return g};var ka="https://firebasestorage.googleapis.com";var v=function(a,b){this.code="storage/"+a;this.message="Firebase Storage: "+b;this.serverResponse=null;this.name="FirebaseError"};u(v,Error);
	var la=function(){return new v("unknown","An unknown error occurred, please check the error payload for server response.")},ma=function(){return new v("canceled","User canceled the upload/download.")},na=function(){return new v("cannot-slice-blob","Cannot slice blob for upload. Please retry the upload.")},oa=function(a,b,c){return new v("invalid-argument","Invalid argument in `"+b+"` at index "+a+": "+c)},pa=function(){return new v("app-deleted","The Firebase app was deleted.")},qa=function(a,b){return new v("invalid-format",
	"String does not match format '"+a+"': "+b)};var ra=function(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])},sa=function(a){var b={};ra(a,function(a,d){b[a]=d});return b};var w=function(a,b,c,d){this.l=a;this.f={};this.i=b;this.b={};this.c="";this.M=c;this.g=this.a=null;this.h=[200];this.j=d};var ta={STATE_CHANGED:"state_changed"},ua={RUNNING:"running",PAUSED:"paused",SUCCESS:"success",CANCELED:"canceled",ERROR:"error"},va=function(a){switch(a){case "running":case "pausing":case "canceling":return"running";case "paused":return"paused";case "success":return"success";case "canceled":return"canceled";case "error":return"error";default:return"error"}};var x=function(a){return n(a)&&null!==a},wa=function(a){return"string"===typeof a||a instanceof String},xa=function(){return"undefined"!==typeof Blob};var za=function(a,b,c){this.f=c;this.c=a;this.g=b;this.b=0;this.a=null};za.prototype.get=function(){var a;0<this.b?(this.b--,a=this.a,this.a=a.next,a.next=null):a=this.c();return a};var Aa=function(a,b){a.g(b);a.b<a.f&&(a.b++,b.next=a.a,a.a=b)};var Ba=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,Ba);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};u(Ba,Error);Ba.prototype.name="CustomError";var Ca=function(a,b,c,d,e){this.reset(a,b,c,d,e)};Ca.prototype.a=null;var Da=0;Ca.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Da++;d||ia();this.b=b;delete this.a};var Ea=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b},Fa=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b},Ga="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),Ha=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Ga.length;f++)c=Ga[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};var Ia=function(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0},Ja=function(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};var Ka=function(a){Ka[" "](a);return a};Ka[" "]=ba;var Ma=function(a,b){var c=La;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Na=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")},Oa=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},Pa=function(a,b){return a<b?-1:a>b?1:0};var Qa=function(a,b){this.a=a;this.b=b};var y=function(a,b){this.bucket=a;this.path=b},Ra=function(a){var b=encodeURIComponent;return"/b/"+b(a.bucket)+"/o/"+b(a.path)},Sa=function(a){for(var b=null,c=[{ia:/^gs:\/\/([A-Za-z0-9.\-]+)(\/(.*))?$/i,ba:{bucket:1,path:3},ha:function(a){"/"===a.path.charAt(a.path.length-1)&&(a.path=a.path.slice(0,-1))}},{ia:/^https?:\/\/firebasestorage\.googleapis\.com\/v[A-Za-z0-9_]+\/b\/([A-Za-z0-9.\-]+)\/o(\/([^?#]*).*)?$/i,ba:{bucket:1,path:3},ha:function(a){a.path=decodeURIComponent(a.path)}}],d=0;d<c.length;d++){var e=
	c[d],f=e.ia.exec(a);if(f){b=f[e.ba.bucket];(f=f[e.ba.path])||(f="");b=new y(b,f);e.ha(b);break}}if(null==b)throw new v("invalid-url","Invalid URL '"+a+"'.");return b};var Ta=function(a,b,c){r(a)||x(b)||x(c)?(this.next=a,this.a=b||null,this.b=c||null):(this.next=a.next||null,this.a=a.error||null,this.b=a.complete||null)};var Ua={RAW:"raw",BASE64:"base64",BASE64URL:"base64url",DATA_URL:"data_url"},Va=function(a){switch(a){case "raw":case "base64":case "base64url":case "data_url":break;default:throw"Expected one of the event types: [raw, base64, base64url, data_url].";}},Wa=function(a,b){this.data=a;this.a=b||null},$a=function(a,b){switch(a){case "raw":return new Wa(Xa(b));case "base64":case "base64url":return new Wa(Ya(a,b));case "data_url":return a=new Za(b),a=a.a?Ya("base64",a.c):Xa(a.c),new Wa(a,(new Za(b)).b)}throw la();
	},Xa=function(a){for(var b=[],c=0;c<a.length;c++){var d=a.charCodeAt(c);if(127>=d)b.push(d);else if(2047>=d)b.push(192|d>>6,128|d&63);else if(55296==(d&64512))if(c<a.length-1&&56320==(a.charCodeAt(c+1)&64512)){var e=a.charCodeAt(++c),d=65536|(d&1023)<<10|e&1023;b.push(240|d>>18,128|d>>12&63,128|d>>6&63,128|d&63)}else b.push(239,191,189);else 56320==(d&64512)?b.push(239,191,189):b.push(224|d>>12,128|d>>6&63,128|d&63)}return new Uint8Array(b)},Ya=function(a,b){switch(a){case "base64":var c=-1!==b.indexOf("-"),
	d=-1!==b.indexOf("_");if(c||d)throw qa(a,"Invalid character '"+(c?"-":"_")+"' found: is it base64url encoded?");break;case "base64url":c=-1!==b.indexOf("+");d=-1!==b.indexOf("/");if(c||d)throw qa(a,"Invalid character '"+(c?"+":"/")+"' found: is it base64 encoded?");b=b.replace(/-/g,"+").replace(/_/g,"/")}var e;try{e=atob(b)}catch(f){throw qa(a,"Invalid character found");}a=new Uint8Array(e.length);for(b=0;b<e.length;b++)a[b]=e.charCodeAt(b);return a},Za=function(a){var b=a.match(/^data:([^,]+)?,/);
	if(null===b)throw qa("data_url","Must be formatted 'data:[<mediatype>][;base64],<data>");b=b[1]||null;this.a=!1;this.b=null;if(null!=b){var c=b.length-7;this.b=(this.a=0<=c&&b.indexOf(";base64",c)==c)?b.substring(0,b.length-7):b}this.c=a.substring(a.indexOf(",")+1)};var bb=function(a){var b=encodeURIComponent,c="?";ra(a,function(a,e){a=b(a)+"="+b(e);c=c+a+"&"});return c=c.slice(0,-1)};var z=function(a,b,c,d,e,f){this.b=a;this.h=b;this.f=c;this.a=d;this.g=e;this.c=f};k=z.prototype;k.oa=function(){return this.b};k.Ka=function(){return this.h};k.Ha=function(){return this.f};k.Ca=function(){return this.a};k.qa=function(){if(x(this.a)){var a=this.a.downloadURLs;return x(a)&&x(a[0])?a[0]:null}return null};k.Ja=function(){return this.g};k.Fa=function(){return this.c};var cb=function(a,b){b.unshift(a);Ba.call(this,Na.apply(null,b));b.shift()};u(cb,Ba);cb.prototype.name="AssertionError";
	var db=function(a,b,c,d){var e="Assertion failed";if(c)var e=e+(": "+c),f=d;else a&&(e+=": "+a,f=b);throw new cb(""+e,f||[]);},A=function(a,b,c){a||db("",null,b,Array.prototype.slice.call(arguments,2))},eb=function(a,b){throw new cb("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));},fb=function(a,b,c){r(a)||db("Expected function but got %s: %s.",[p(a),a],b,Array.prototype.slice.call(arguments,2))};var B=function(){this.g=this.g;this.o=this.o};B.prototype.g=!1;B.prototype.ea=function(){this.g||(this.g=!0,this.C())};B.prototype.C=function(){if(this.o)for(;this.o.length;)this.o.shift()()};var gb="closure_listenable_"+(1E6*Math.random()|0),hb=0;var ib;a:{var jb=m.navigator;if(jb){var kb=jb.userAgent;if(kb){ib=kb;break a}}ib=""}var C=function(a){return-1!=ib.indexOf(a)};var lb=function(){};lb.prototype.a=null;var nb=function(a){var b;(b=a.a)||(b={},mb(a)&&(b[0]=!0,b[1]=!0),b=a.a=b);return b};var ob=Array.prototype.indexOf?function(a,b,c){A(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(q(a))return q(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},pb=Array.prototype.forEach?function(a,b,c){A(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=q(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},qb=Array.prototype.filter?function(a,
	b,c){A(null!=a.length);return Array.prototype.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,g=q(a)?a.split(""):a,h=0;h<d;h++)if(h in g){var l=g[h];b.call(c,l,h,a)&&(e[f++]=l)}return e},rb=Array.prototype.map?function(a,b,c){A(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=q(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},sb=Array.prototype.some?function(a,b,c){A(null!=a.length);return Array.prototype.some.call(a,
	b,c)}:function(a,b,c){for(var d=a.length,e=q(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1},ub=function(a){var b;a:{b=tb;for(var c=a.length,d=q(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:q(a)?a.charAt(b):a[b]},vb=function(a){if("array"!=p(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0},wb=function(a,b){b=ob(a,b);var c;if(c=0<=b)A(null!=a.length),Array.prototype.splice.call(a,b,1);return c},xb=function(a){var b=
	a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var zb=new za(function(){return new yb},function(a){a.reset()},100),Bb=function(){var a=Ab,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b},yb=function(){this.next=this.b=this.a=null};yb.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};yb.prototype.reset=function(){this.next=this.b=this.a=null};var Cb=function(a,b){this.type=a;this.a=this.target=b;this.ja=!0};Cb.prototype.b=function(){this.ja=!1};var Db=function(a,b,c,d,e){this.listener=a;this.a=null;this.src=b;this.type=c;this.V=!!d;this.M=e;++hb;this.N=this.U=!1},Eb=function(a){a.N=!0;a.listener=null;a.a=null;a.src=null;a.M=null};var Fb=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;var Gb=function(a,b){b=qb(b.split("/"),function(a){return 0<a.length}).join("/");return 0===a.length?b:a+"/"+b},Hb=function(a){var b=a.lastIndexOf("/",a.length-2);return-1===b?a:a.slice(b+1)};var Ib=function(a){this.src=a;this.a={};this.b=0},Kb=function(a,b,c,d,e,f){var g=b.toString();b=a.a[g];b||(b=a.a[g]=[],a.b++);var h=Jb(b,c,e,f);-1<h?(a=b[h],d||(a.U=!1)):(a=new Db(c,a.src,g,!!e,f),a.U=d,b.push(a));return a},Lb=function(a,b){var c=b.type;c in a.a&&wb(a.a[c],b)&&(Eb(b),0==a.a[c].length&&(delete a.a[c],a.b--))},Jb=function(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.N&&f.listener==b&&f.V==!!c&&f.M==d)return e}return-1};var Mb,Nb=function(){};u(Nb,lb);var Ob=function(a){return(a=mb(a))?new ActiveXObject(a):new XMLHttpRequest},mb=function(a){if(!a.b&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.b=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.b};Mb=new Nb;var Pb=function(a){this.a=[];if(a)a:{var b;if(a instanceof Pb){if(b=a.H(),a=a.A(),0>=this.b()){for(var c=this.a,d=0;d<b.length;d++)c.push(new Qa(b[d],a[d]));break a}}else b=Fa(a),a=Ea(a);for(d=0;d<b.length;d++)Qb(this,b[d],a[d])}},Qb=function(a,b,c){var d=a.a;d.push(new Qa(b,c));b=d.length-1;a=a.a;for(c=a[b];0<b;)if(d=b-1>>1,a[d].a>c.a)a[b]=a[d],b=d;else break;a[b]=c};Pb.prototype.A=function(){for(var a=this.a,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].b);return b};
	Pb.prototype.H=function(){for(var a=this.a,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].a);return b};Pb.prototype.b=function(){return this.a.length};var Rb=function(){this.c=[];this.a=[]},Sb=function(a){0==a.c.length&&(a.c=a.a,a.c.reverse(),a.a=[]);return a.c.pop()};Rb.prototype.b=function(){return this.c.length+this.a.length};Rb.prototype.A=function(){for(var a=[],b=this.c.length-1;0<=b;--b)a.push(this.c[b]);for(var c=this.a.length,b=0;b<c;++b)a.push(this.a[b]);return a};var Tb=function(a){if(a.A&&"function"==typeof a.A)return a.A();if(q(a))return a.split("");if(ca(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ea(a)},Ub=function(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ca(a)||q(a))pb(a,b,void 0);else{var c;if(a.H&&"function"==typeof a.H)c=a.H();else if(a.A&&"function"==typeof a.A)c=void 0;else if(ca(a)||q(a)){c=[];for(var d=a.length,e=0;e<d;e++)c.push(e)}else c=Fa(a);for(var d=Tb(a),e=d.length,f=0;f<e;f++)b.call(void 0,
	d[f],c&&c[f],a)}};var Vb=function(a){m.setTimeout(function(){throw a;},0)},Wb,Xb=function(){var a=m.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!C("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host,
	a=t(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!C("Trident")&&!C("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(n(c.next)){c=c.next;var a=c.da;c.da=null;a()}};return function(a){d.next={da:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?
	function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){m.setTimeout(a,0)}};var Yb="StopIteration"in m?m.StopIteration:{message:"StopIteration",stack:""},Zb=function(){};Zb.prototype.next=function(){throw Yb;};Zb.prototype.h=function(){return this};var $b=function(){Pb.call(this)};u($b,Pb);var ac=C("Opera"),D=C("Trident")||C("MSIE"),bc=C("Edge"),dc=C("Gecko")&&!(-1!=ib.toLowerCase().indexOf("webkit")&&!C("Edge"))&&!(C("Trident")||C("MSIE"))&&!C("Edge"),ec=-1!=ib.toLowerCase().indexOf("webkit")&&!C("Edge"),fc=function(){var a=m.document;return a?a.documentMode:void 0},gc;
	a:{var hc="",ic=function(){var a=ib;if(dc)return/rv\:([^\);]+)(\)|;)/.exec(a);if(bc)return/Edge\/([\d\.]+)/.exec(a);if(D)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(ec)return/WebKit\/(\S+)/.exec(a);if(ac)return/(?:Version)[ \/]?(\S+)/.exec(a)}();ic&&(hc=ic?ic[1]:"");if(D){var jc=fc();if(null!=jc&&jc>parseFloat(hc)){gc=String(jc);break a}}gc=hc}
	var kc=gc,La={},E=function(a){return Ma(a,function(){for(var b=0,c=Oa(String(kc)).split("."),d=Oa(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",h=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;b=Pa(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||Pa(0==g[2].length,0==h[2].length)||Pa(g[2],h[2]);g=g[3];h=h[3]}while(0==b)}return 0<=b})},lc=m.document,
	mc=lc&&D?fc()||("CSS1Compat"==lc.compatMode?parseInt(kc,10):5):void 0;var qc=function(a,b){nc||oc();pc||(nc(),pc=!0);var c=Ab,d=zb.get();d.set(a,b);c.b?c.b.next=d:(A(!c.a),c.a=d);c.b=d},nc,oc=function(){if(m.Promise&&m.Promise.resolve){var a=m.Promise.resolve(void 0);nc=function(){a.then(rc)}}else nc=function(){var a=rc;!r(m.setImmediate)||m.Window&&m.Window.prototype&&!C("Edge")&&m.Window.prototype.setImmediate==m.setImmediate?(Wb||(Wb=Xb()),Wb(a)):m.setImmediate(a)}},pc=!1,Ab=new function(){this.b=this.a=null},rc=function(){for(var a;a=Bb();){try{a.a.call(a.b)}catch(b){Vb(b)}Aa(zb,
	a)}pc=!1};var sc;(sc=!D)||(sc=9<=Number(mc));var tc=sc,uc=D&&!E("9");!ec||E("528");dc&&E("1.9b")||D&&E("8")||ac&&E("9.5")||ec&&E("528");dc&&!E("8")||D&&E("9");var G=function(a,b){this.c={};this.a=[];this.g=this.f=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a){a instanceof G?(c=a.H(),d=a.A()):(c=Fa(a),d=Ea(a));for(var e=0;e<c.length;e++)this.set(c[e],d[e])}};G.prototype.b=function(){return this.f};G.prototype.A=function(){vc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.c[this.a[b]]);return a};G.prototype.H=function(){vc(this);return this.a.concat()};
	var wc=function(a,b){return Object.prototype.hasOwnProperty.call(a.c,b)?(delete a.c[b],a.f--,a.g++,a.a.length>2*a.f&&vc(a),!0):!1},vc=function(a){if(a.f!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Object.prototype.hasOwnProperty.call(a.c,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.f!=a.a.length){for(var e={},c=b=0;b<a.a.length;)d=a.a[b],Object.prototype.hasOwnProperty.call(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}};
	G.prototype.get=function(a,b){return Object.prototype.hasOwnProperty.call(this.c,a)?this.c[a]:b};G.prototype.set=function(a,b){Object.prototype.hasOwnProperty.call(this.c,a)||(this.f++,this.a.push(a),this.g++);this.c[a]=b};G.prototype.forEach=function(a,b){for(var c=this.H(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};
	G.prototype.h=function(a){vc(this);var b=0,c=this.g,d=this,e=new Zb;e.next=function(){if(c!=d.g)throw Error("The map has changed since the iterator was created");if(b>=d.a.length)throw Yb;var e=d.a[b++];return a?e:d.c[e]};return e};var xc=function(a,b){Cb.call(this,a?a.type:"");this.c=this.a=this.target=null;if(a){this.type=a.type;this.target=a.target||a.srcElement;this.a=b;if((b=a.relatedTarget)&&dc)try{Ka(b.nodeName)}catch(c){}this.c=a;a.defaultPrevented&&this.b()}};u(xc,Cb);xc.prototype.b=function(){xc.I.b.call(this);var a=this.c;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,uc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};var H=function(a,b){this.a=0;this.i=void 0;this.c=this.b=this.f=null;this.g=this.h=!1;if(a!=ba)try{var c=this;a.call(b,function(a){yc(c,2,a)},function(a){try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(b){}yc(c,3,a)})}catch(d){yc(this,3,d)}},zc=function(){this.next=this.f=this.c=this.a=this.b=null;this.g=!1};zc.prototype.reset=function(){this.f=this.c=this.a=this.b=null;this.g=!1};
	var Ac=new za(function(){return new zc},function(a){a.reset()},100),Bc=function(a,b,c){var d=Ac.get();d.a=a;d.c=b;d.f=c;return d},Cc=function(a){if(a instanceof H)return a;var b=new H(ba);yc(b,2,a);return b},Dc=function(a){return new H(function(b,c){c(a)})};
	H.prototype.then=function(a,b,c){null!=a&&fb(a,"opt_onFulfilled should be a function.");null!=b&&fb(b,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return Ec(this,r(a)?a:null,r(b)?b:null,c)};Ia(H);H.prototype.l=function(a,b){return Ec(this,null,a,b)};
	var Gc=function(a,b){a.b||2!=a.a&&3!=a.a||Fc(a);A(null!=b.a);a.c?a.c.next=b:a.b=b;a.c=b},Ec=function(a,b,c,d){var e=Bc(null,null,null);e.b=new H(function(a,g){e.a=b?function(c){try{var e=b.call(d,c);a(e)}catch(F){g(F)}}:a;e.c=c?function(b){try{var e=c.call(d,b);a(e)}catch(F){g(F)}}:g});e.b.f=a;Gc(a,e);return e.b};H.prototype.o=function(a){A(1==this.a);this.a=0;yc(this,2,a)};H.prototype.m=function(a){A(1==this.a);this.a=0;yc(this,3,a)};
	var yc=function(a,b,c){if(0==a.a){a===c&&(b=3,c=new TypeError("Promise cannot resolve to itself"));a.a=1;var d;a:{var e=c,f=a.o,g=a.m;if(e instanceof H)null!=f&&fb(f,"opt_onFulfilled should be a function."),null!=g&&fb(g,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"),Gc(e,Bc(f||ba,g||null,a)),d=!0;else if(Ja(e))e.then(f,g,a),d=!0;else{if(da(e))try{var h=e.then;if(r(h)){Hc(e,h,f,g,a);d=!0;break a}}catch(l){g.call(a,l);d=!0;break a}d=!1}}d||
	(a.i=c,a.a=b,a.f=null,Fc(a),3!=b||Ic(a,c))}},Hc=function(a,b,c,d,e){var f=!1,g=function(a){f||(f=!0,c.call(e,a))},h=function(a){f||(f=!0,d.call(e,a))};try{b.call(a,g,h)}catch(l){h(l)}},Fc=function(a){a.h||(a.h=!0,qc(a.j,a))},Jc=function(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.c=null);null!=b&&A(null!=b.a);return b};
	H.prototype.j=function(){for(var a;a=Jc(this);){var b=this.a,c=this.i;if(3==b&&a.c&&!a.g){var d;for(d=this;d&&d.g;d=d.f)d.g=!1}if(a.b)a.b.f=null,Kc(a,b,c);else try{a.g?a.a.call(a.f):Kc(a,b,c)}catch(e){Lc.call(null,e)}Aa(Ac,a)}this.h=!1};var Kc=function(a,b,c){2==b?a.a.call(a.f,c):a.c&&a.c.call(a.f,c)},Ic=function(a,b){a.g=!0;qc(function(){a.g&&Lc.call(null,b)})},Lc=Vb;var Nc=function(a){this.a=new G;if(a){a=Tb(a);for(var b=a.length,c=0;c<b;c++){var d=a[c];this.a.set(Mc(d),d)}}},Mc=function(a){var b=typeof a;return"object"==b&&a||"function"==b?"o"+(a[ea]||(a[ea]=++fa)):b.substr(0,1)+a};Nc.prototype.b=function(){return this.a.b()};Nc.prototype.A=function(){return this.a.A()};Nc.prototype.h=function(){return this.a.h(!1)};var Oc=function(a){return function(){var b=[];Array.prototype.push.apply(b,arguments);Cc(!0).then(function(){a.apply(null,b)})}};var Pc="closure_lm_"+(1E6*Math.random()|0),Qc={},Rc=0,Sc=function(a,b,c,d,e){if("array"==p(b)){for(var f=0;f<b.length;f++)Sc(a,b[f],c,d,e);return null}c=Tc(c);a&&a[gb]?(Uc(a),a=Kb(a.b,String(b),c,!1,d,e)):a=Vc(a,b,c,!1,d,e);return a},Vc=function(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=!!e,h=Wc(a);h||(a[Pc]=h=new Ib(a));c=Kb(h,b,c,d,e,f);if(c.a)return c;d=Xc();c.a=d;d.src=a;d.listener=c;if(a.addEventListener)a.addEventListener(b.toString(),d,g);else if(a.attachEvent)a.attachEvent(Yc(b.toString()),
	d);else throw Error("addEventListener and attachEvent are unavailable.");Rc++;return c},Xc=function(){var a=Zc,b=tc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b},$c=function(a,b,c,d,e){if("array"==p(b))for(var f=0;f<b.length;f++)$c(a,b[f],c,d,e);else c=Tc(c),a&&a[gb]?Kb(a.b,String(b),c,!0,d,e):Vc(a,b,c,!0,d,e)},ad=function(a,b,c,d,e){if("array"==p(b))for(var f=0;f<b.length;f++)ad(a,b[f],c,d,e);else(c=Tc(c),a&&a[gb])?(a=a.b,b=String(b).toString(),
	b in a.a&&(f=a.a[b],c=Jb(f,c,d,e),-1<c&&(Eb(f[c]),A(null!=f.length),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=Wc(a))&&(b=a.a[b.toString()],a=-1,b&&(a=Jb(b,c,!!d,e)),(c=-1<a?b[a]:null)&&bd(c))},bd=function(a){if("number"!=typeof a&&a&&!a.N){var b=a.src;if(b&&b[gb])Lb(b.b,a);else{var c=a.type,d=a.a;b.removeEventListener?b.removeEventListener(c,d,a.V):b.detachEvent&&b.detachEvent(Yc(c),d);Rc--;(c=Wc(b))?(Lb(c,a),0==c.b&&(c.src=null,b[Pc]=null)):Eb(a)}}},Yc=function(a){return a in
	Qc?Qc[a]:Qc[a]="on"+a},dd=function(a,b,c,d){var e=!0;if(a=Wc(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.V==c&&!f.N&&(f=cd(f,d),e=e&&!1!==f)}return e},cd=function(a,b){var c=a.listener,d=a.M||a.src;a.U&&bd(a);return c.call(d,b)},Zc=function(a,b){if(a.N)return!0;if(!tc){if(!b)a:{b=["window","event"];for(var c=m,d;d=b.shift();)if(null!=c[d])c=c[d];else{b=null;break a}b=c}d=b;b=new xc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=
	-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.a;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.a=d[e];var f=dd(d[e],a,!0,b),c=c&&f}for(e=0;e<d.length;e++)b.a=d[e],f=dd(d[e],a,!1,b),c=c&&f}return c}return cd(a,new xc(b,this))},Wc=function(a){a=a[Pc];return a instanceof Ib?a:null},ed="__closure_events_fn_"+(1E9*Math.random()>>>0),Tc=function(a){A(a,"Listener can not be null.");if(r(a))return a;A(a.handleEvent,"An object listener must have handleEvent method.");
	a[ed]||(a[ed]=function(b){return a.handleEvent(b)});return a[ed]};var I=function(a,b){B.call(this);this.m=a||0;this.f=b||10;if(this.m>this.f)throw Error("[goog.structs.Pool] Min can not be greater than max");this.a=new Rb;this.c=new Nc;this.j=null;this.T()};u(I,B);I.prototype.X=function(){var a=ia();if(!(null!=this.j&&0>a-this.j)){for(var b;0<this.a.b()&&(b=Sb(this.a),!this.l(b));)this.T();!b&&this.b()<this.f&&(b=this.i());b&&(this.j=a,this.c.a.set(Mc(b),b));return b}};var gd=function(a){var b=fd;wc(b.c.a,Mc(a))&&b.$(a)};
	I.prototype.$=function(a){wc(this.c.a,Mc(a));this.l(a)&&this.b()<this.f?this.a.a.push(a):hd(a)};I.prototype.T=function(){for(var a=this.a;this.b()<this.m;){var b=this.i();a.a.push(b)}for(;this.b()>this.f&&0<this.a.b();)hd(Sb(a))};I.prototype.i=function(){return{}};var hd=function(a){if("function"==typeof a.ea)a.ea();else for(var b in a)a[b]=null};I.prototype.l=function(a){return"function"==typeof a.pa?a.pa():!0};I.prototype.b=function(){return this.a.b()+this.c.b()};
	I.prototype.C=function(){I.I.C.call(this);if(0<this.c.b())throw Error("[goog.structs.Pool] Objects not released");delete this.c;for(var a=this.a;0!=a.c.length||0!=a.a.length;)hd(Sb(a));delete this.a};/*
	 Portions of this code are from MochiKit, received by
	 The Closure Authors under the MIT license. All other code is Copyright
	 2005-2009 The Closure Authors. All Rights Reserved.
	*/
	var id=function(a,b){this.c=[];this.m=b||null;this.a=this.h=!1;this.b=void 0;this.j=this.g=!1;this.f=0;this.i=null;this.o=0};id.prototype.l=function(a,b){this.g=!1;this.h=!0;this.b=b;this.a=!a;jd(this)};var kd=function(a,b,c){A(!a.j,"Blocking Deferreds can not be re-used");a.c.push([b,c,void 0]);a.h&&jd(a)};id.prototype.then=function(a,b,c){var d,e,f=new H(function(a,b){d=a;e=b});kd(this,d,function(a){e(a)});return f.then(a,b,c)};Ia(id);
	var ld=function(a){return sb(a.c,function(a){return r(a[1])})},jd=function(a){if(a.f&&a.h&&ld(a)){var b=a.f,c=md[b];c&&(m.clearTimeout(c.a),delete md[b]);a.f=0}a.i&&(a.i.o--,delete a.i);for(var b=a.b,d=c=!1;a.c.length&&!a.g;){var e=a.c.shift(),f=e[0],g=e[1],e=e[2];if(f=a.a?g:f)try{var h=f.call(e||a.m,b);n(h)&&(a.a=a.a&&(h==b||h instanceof Error),a.b=b=h);if(Ja(b)||"function"===typeof m.Promise&&b instanceof m.Promise)d=!0,a.g=!0}catch(l){b=l,a.a=!0,ld(a)||(c=!0)}}a.b=b;d&&(h=t(a.l,a,!0),d=t(a.l,a,
	!1),b instanceof id?(kd(b,h,d),b.j=!0):b.then(h,d));c&&(b=new nd(b),md[b.a]=b,a.f=b.a)},nd=function(a){this.a=m.setTimeout(t(this.c,this),0);this.b=a};nd.prototype.c=function(){A(md[this.a],"Cannot throw an error that is not scheduled.");delete md[this.a];throw this.b;};var md={};var od=function(a){this.f=a;this.b=this.c=this.a=null},pd=function(a,b){this.name=a;this.value=b};pd.prototype.toString=function(){return this.name};var qd=new pd("SEVERE",1E3),rd=new pd("CONFIG",700),sd=new pd("FINE",500),td=function(a){if(a.c)return a.c;if(a.a)return td(a.a);eb("Root logger has no level set.");return null};
	od.prototype.log=function(a,b,c){if(a.value>=td(this).value)for(r(b)&&(b=b()),a=new Ca(a,String(b),this.f),c&&(a.a=c),c="log:"+a.b,m.console&&(m.console.timeStamp?m.console.timeStamp(c):m.console.markTimeline&&m.console.markTimeline(c)),m.msWriteProfilerMark&&m.msWriteProfilerMark(c),c=this;c;)c=c.a};
	var ud={},vd=null,wd=function(a){vd||(vd=new od(""),ud[""]=vd,vd.c=rd);var b;if(!(b=ud[a])){b=new od(a);var c=a.lastIndexOf("."),d=a.substr(c+1),c=wd(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;ud[a]=b}return b};var xd=function(){B.call(this);this.b=new Ib(this);this.Z=this;this.G=null};u(xd,B);xd.prototype[gb]=!0;xd.prototype.removeEventListener=function(a,b,c,d){ad(this,a,b,c,d)};
	var J=function(a,b){Uc(a);var c,d=a.G;if(d){c=[];for(var e=1;d;d=d.G)c.push(d),A(1E3>++e,"infinite loop")}a=a.Z;d=b.type||b;q(b)?b=new Cb(b,a):b instanceof Cb?b.target=b.target||a:(e=b,b=new Cb(d,a),Ha(b,e));var e=!0,f;if(c)for(var g=c.length-1;0<=g;g--)f=b.a=c[g],e=yd(f,d,!0,b)&&e;f=b.a=a;e=yd(f,d,!0,b)&&e;e=yd(f,d,!1,b)&&e;if(c)for(g=0;g<c.length;g++)f=b.a=c[g],e=yd(f,d,!1,b)&&e};
	xd.prototype.C=function(){xd.I.C.call(this);if(this.b){var a=this.b,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,Eb(d[e]);delete a.a[c];a.b--}}this.G=null};var yd=function(a,b,c,d){b=a.b.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.N&&g.V==c){var h=g.listener,l=g.M||g.src;g.U&&Lb(a.b,g);e=!1!==h.call(l,d)&&e}}return e&&0!=d.ja},Uc=function(a){A(a.b,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?")};var K=function(a,b){this.h=new $b;I.call(this,a,b)};u(K,I);k=K.prototype;k.X=function(a,b){if(!a)return K.I.X.call(this);Qb(this.h,n(b)?b:100,a);this.aa()};k.aa=function(){for(var a=this.h;0<a.b();){var b=this.X();if(b){var c;var d=a,e=d.a,f=e.length;c=e[0];if(0>=f)c=void 0;else{if(1==f)vb(e);else{e[0]=e.pop();for(var e=0,d=d.a,f=d.length,g=d[e];e<f>>1;){var h=2*e+1,l=2*e+2,h=l<f&&d[l].a<d[h].a?l:h;if(d[h].a>g.a)break;d[e]=d[h];e=h}d[e]=g}c=c.b}c.apply(this,[b])}else break}};
	k.$=function(a){K.I.$.call(this,a);this.aa()};k.T=function(){K.I.T.call(this);this.aa()};k.C=function(){K.I.C.call(this);m.clearTimeout(void 0);vb(this.h.a);this.h=null};var L=function(a,b){a&&a.log(sd,b,void 0)};var zd=function(a,b,c){if(r(a))c&&(a=t(a,c));else if(a&&"function"==typeof a.handleEvent)a=t(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:m.setTimeout(a,b||0)};var M=function(a){xd.call(this);this.K=new G;this.B=a||null;this.c=!1;this.w=this.a=null;this.O=this.l="";this.J=0;this.h="";this.f=this.F=this.j=this.D=!1;this.i=0;this.m=null;this.S="";this.u=this.ca=this.Y=!1};u(M,xd);var Ad=M.prototype,Bd=wd("goog.net.XhrIo");Ad.v=Bd;var Cd=/^https?$/i,Dd=["POST","PUT"];
	M.prototype.send=function(a,b,c,d){if(this.a)throw Error("[goog.net.XhrIo] Object is active with another request="+this.l+"; newUri="+a);b=b?b.toUpperCase():"GET";this.l=a;this.h="";this.J=0;this.O=b;this.D=!1;this.c=!0;this.a=this.B?Ob(this.B):Ob(Mb);this.w=this.B?nb(this.B):nb(Mb);this.a.onreadystatechange=t(this.R,this);this.ca&&"onprogress"in this.a&&(this.a.onprogress=t(function(a){this.P(a,!0)},this),this.a.upload&&(this.a.upload.onprogress=t(this.P,this)));try{L(this.v,O(this,"Opening Xhr")),
	this.F=!0,this.a.open(b,String(a),!0),this.F=!1}catch(f){L(this.v,O(this,"Error opening Xhr: "+f.message));Ed(this,f);return}a=c||"";var e=new G(this.K);d&&Ub(d,function(a,b){e.set(b,a)});d=ub(e.H());c=m.FormData&&a instanceof m.FormData;!(0<=ob(Dd,b))||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.a.setRequestHeader(b,a)},this);this.S&&(this.a.responseType=this.S);"withCredentials"in this.a&&this.a.withCredentials!==this.Y&&(this.a.withCredentials=
	this.Y);try{Fd(this),0<this.i&&(this.u=Gd(this.a),L(this.v,O(this,"Will abort after "+this.i+"ms if incomplete, xhr2 "+this.u)),this.u?(this.a.timeout=this.i,this.a.ontimeout=t(this.L,this)):this.m=zd(this.L,this.i,this)),L(this.v,O(this,"Sending request")),this.j=!0,this.a.send(a),this.j=!1}catch(f){L(this.v,O(this,"Send error: "+f.message)),Ed(this,f)}};var Gd=function(a){return D&&E(9)&&"number"==typeof a.timeout&&n(a.ontimeout)},tb=function(a){return"content-type"==a.toLowerCase()};
	M.prototype.L=function(){"undefined"!=typeof aa&&this.a&&(this.h="Timed out after "+this.i+"ms, aborting",this.J=8,L(this.v,O(this,this.h)),J(this,"timeout"),Hd(this,8))};var Ed=function(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;a.J=5;Id(a);Kd(a)},Id=function(a){a.D||(a.D=!0,J(a,"complete"),J(a,"error"))},Hd=function(a,b){a.a&&a.c&&(L(a.v,O(a,"Aborting")),a.c=!1,a.f=!0,a.a.abort(),a.f=!1,a.J=b||7,J(a,"complete"),J(a,"abort"),Kd(a))};
	M.prototype.C=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),Kd(this,!0));M.I.C.call(this)};M.prototype.R=function(){this.g||(this.F||this.j||this.f?Ld(this):this.la())};M.prototype.la=function(){Ld(this)};
	var Ld=function(a){if(a.c&&"undefined"!=typeof aa)if(a.w[1]&&4==Md(a)&&2==P(a))L(a.v,O(a,"Local request error detected and ignored"));else if(a.j&&4==Md(a))zd(a.R,0,a);else if(J(a,"readystatechange"),4==Md(a)){L(a.v,O(a,"Request complete"));a.c=!1;try{if(Nd(a))J(a,"complete"),J(a,"success");else{a.J=6;var b;try{b=2<Md(a)?a.a.statusText:""}catch(c){L(a.v,"Can not get status: "+c.message),b=""}a.h=b+" ["+P(a)+"]";Id(a)}}finally{Kd(a)}}};
	M.prototype.P=function(a,b){A("progress"===a.type,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");J(this,Od(a,"progress"));J(this,Od(a,b?"downloadprogress":"uploadprogress"))};
	var Od=function(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}},Kd=function(a,b){if(a.a){Fd(a);var c=a.a,d=a.w[0]?ba:null;a.a=null;a.w=null;b||J(a,"ready");try{c.onreadystatechange=d}catch(e){(a=a.v)&&a.log(qd,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}},Fd=function(a){a.a&&a.u&&(a.a.ontimeout=null);"number"==typeof a.m&&(m.clearTimeout(a.m),a.m=null)},Nd=function(a){var b=P(a),c;a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:c=
	!0;break a;default:c=!1}if(!c){if(b=0===b)a=String(a.l).match(Fb)[1]||null,!a&&m.self&&m.self.location&&(a=m.self.location.protocol,a=a.substr(0,a.length-1)),b=!Cd.test(a?a.toLowerCase():"");c=b}return c},Md=function(a){return a.a?a.a.readyState:0},P=function(a){try{return 2<Md(a)?a.a.status:-1}catch(b){return-1}},Pd=function(a){try{return a.a?a.a.responseText:""}catch(b){return L(a.v,"Can not get responseText: "+b.message),""}},Qd=function(a,b){return a.a&&4==Md(a)?a.a.getResponseHeader(b):void 0},
	O=function(a,b){return b+" ["+a.O+" "+a.l+" "+P(a)+"]"};var Rd=function(a,b,c,d){this.u=a;this.w=!!d;K.call(this,b,c)};u(Rd,K);Rd.prototype.i=function(){var a=new M,b=this.u;b&&b.forEach(function(b,d){a.K.set(d,b)});this.w&&(a.Y=!0);return a};Rd.prototype.l=function(a){return!a.g&&!a.a};var fd=new Rd;var Td=function(a,b,c,d,e,f,g,h,l,F){this.K=a;this.F=b;this.w=c;this.m=d;this.G=e.slice();this.l=this.o=this.f=this.c=null;this.h=this.i=!1;this.u=f;this.j=g;this.g=l;this.L=F;this.D=h;var N=this;this.B=new H(function(a,b){N.o=a;N.l=b;Sd(N)})},Ud=function(a,b,c){this.b=a;this.c=b;this.a=!!c},Sd=function(a){function b(a,b){b?a(!1,new Ud(!1,null,!0)):fd.X(function(b){b.Y=d.L;d.c=b;var c=null;null!==d.g&&(b.ca=!0,c=Sc(b,"uploadprogress",function(a){d.g(a.loaded,a.lengthComputable?a.total:-1)}),b.ca=
	null!==d.g);b.send(d.K,d.F,d.m,d.w);$c(b,"complete",function(b){null!==c&&bd(c);d.c=null;b=b.target;var f=6===b.J&&100<=P(b),f=Nd(b)||f,g=P(b);!f||500<=g&&600>g||429===g?(f=7===b.J,gd(b),a(!1,new Ud(!1,null,f))):(f=0<=ob(d.G,g),a(!0,new Ud(f,b)))})})}function c(a,b){var c=d.o;a=d.l;var h=b.c;if(b.b)try{var l=d.u(h,Pd(h));n(l)?c(l):c()}catch(F){a(F)}else null!==h?(b=la(),l=Pd(h),b.serverResponse=l,d.j?a(d.j(h,b)):a(b)):(b=b.a?d.h?pa():ma():new v("retry-limit-exceeded","Max retry time for operation exceeded, please try again."),
	a(b));gd(h)}var d=a;a.i?c(0,new Ud(!1,null,!0)):a.f=ja(b,c,a.D)};Td.prototype.a=function(){return this.B};Td.prototype.b=function(a){this.i=!0;this.h=a||!1;null!==this.f&&(0,this.f)(!1);null!==this.c&&Hd(this.c)};var Vd=function(a,b,c){var d=bb(a.f),d=a.l+d,e=a.b?sa(a.b):{};null!==b&&0<b.length&&(e.Authorization="Firebase "+b);e["X-Firebase-Storage-Version"]="webjs/"+("undefined"!==typeof firebase?firebase.SDK_VERSION:"AppManager");return new Td(d,a.i,e,a.c,a.h,a.M,a.a,a.j,a.g,c)};var Wd=function(a){var b=m.BlobBuilder||m.WebKitBlobBuilder;if(n(b)){for(var b=new b,c=0;c<arguments.length;c++)b.append(arguments[c]);return b.getBlob()}b=xb(arguments);c=m.BlobBuilder||m.WebKitBlobBuilder;if(n(c)){for(var c=new c,d=0;d<b.length;d++)c.append(b[d],void 0);b=c.getBlob(void 0)}else if(n(m.Blob))b=new Blob(b,{});else throw Error("This browser doesn't seem to support creating Blobs");return b},Xd=function(a,b,c){n(c)||(c=a.size);return a.webkitSlice?a.webkitSlice(b,c):a.mozSlice?a.mozSlice(b,
	c):a.slice?dc&&!E("13.0")||ec&&!E("537.1")?(0>b&&(b+=a.size),0>b&&(b=0),0>c&&(c+=a.size),c<b&&(c=b),a.slice(b,c-b)):a.slice(b,c):null};var Q=function(a,b){xa()&&a instanceof Blob?(this.s=a,b=a.size,a=a.type):(a instanceof ArrayBuffer?(b?this.s=new Uint8Array(a):(this.s=new Uint8Array(a.byteLength),this.s.set(new Uint8Array(a))),b=this.s.length):(b?this.s=a:(this.s=new Uint8Array(a.length),this.s.set(a)),b=a.length),a="");this.a=b;this.b=a};Q.prototype.type=function(){return this.b};
	Q.prototype.slice=function(a,b){if(xa()&&this.s instanceof Blob)return a=Xd(this.s,a,b),null===a?null:new Q(a);a=new Uint8Array(this.s.buffer,a,b-a);return new Q(a,!0)};
	var Yd=function(a){var b=[];Array.prototype.push.apply(b,arguments);if(xa())return b=rb(b,function(a){return a instanceof Q?a.s:a}),new Q(Wd.apply(null,b));var b=rb(b,function(a){return wa(a)?$a("raw",a).data.buffer:a.s.buffer}),c=0;pb(b,function(a){c+=a.byteLength});var d=new Uint8Array(c),e=0;pb(b,function(a){a=new Uint8Array(a);for(var b=0;b<a.length;b++)d[e++]=a[b]});return new Q(d,!0)};var Zd=function(a){this.c=Dc(a)};Zd.prototype.a=function(){return this.c};Zd.prototype.b=function(){};var $d=function(){this.a={};this.b=Number.MIN_SAFE_INTEGER},ae=function(a,b){function c(){delete e.a[d]}var d=a.b;a.b++;a.a[d]=b;var e=a;b.a().then(c,c)},be=function(a){ra(a.a,function(a,c){c&&c.b(!0)});a.a={}};var ce=function(a,b,c,d){this.a=a;this.g=null;if(null!==this.a&&(a=this.a.options,x(a))){a=a.storageBucket||null;if(null==a)a=null;else{var e=null;try{e=Sa(a)}catch(f){}if(null!==e){if(""!==e.path)throw new v("invalid-default-bucket","Invalid default bucket '"+a+"'.");a=e.bucket}}this.g=a}this.l=b;this.j=c;this.i=d;this.c=12E4;this.b=6E4;this.h=new $d;this.f=!1},de=function(a){return null!==a.a&&x(a.a.INTERNAL)&&x(a.a.INTERNAL.getToken)?a.a.INTERNAL.getToken().then(function(a){return x(a)?a.accessToken:
	null},function(){return null}):Cc(null)};ce.prototype.bucket=function(){if(this.f)throw pa();return this.g};var R=function(a,b,c){if(a.f)return new Zd(pa());b=a.j(b,c,null===a.a);ae(a.h,b);return b};var ee=function(a,b){return b},S=function(a,b,c,d){this.c=a;this.b=b||a;this.f=!!c;this.a=d||ee},fe=null,ge=function(){if(fe)return fe;var a=[];a.push(new S("bucket"));a.push(new S("generation"));a.push(new S("metageneration"));a.push(new S("name","fullPath",!0));var b=new S("name");b.a=function(a,b){return!wa(b)||2>b.length?b:Hb(b)};a.push(b);b=new S("size");b.a=function(a,b){return x(b)?+b:b};a.push(b);a.push(new S("timeCreated"));a.push(new S("updated"));a.push(new S("md5Hash",null,!0));a.push(new S("cacheControl",
	null,!0));a.push(new S("contentDisposition",null,!0));a.push(new S("contentEncoding",null,!0));a.push(new S("contentLanguage",null,!0));a.push(new S("contentType",null,!0));a.push(new S("metadata","customMetadata",!0));a.push(new S("downloadTokens","downloadURLs",!1,function(a,b){if(!(wa(b)&&0<b.length))return[];var e=encodeURIComponent;return rb(b.split(","),function(b){var d=a.fullPath,d="https://firebasestorage.googleapis.com/v0"+("/b/"+e(a.bucket)+"/o/"+e(d));b=bb({alt:"media",token:b});return d+
	b})}));return fe=a},he=function(a,b){Object.defineProperty(a,"ref",{get:function(){return b.l(b,new y(a.bucket,a.fullPath))}})},ie=function(a,b){for(var c={},d=b.length,e=0;e<d;e++){var f=b[e];f.f&&(c[f.c]=a[f.b])}return JSON.stringify(c)},je=function(a){if(!a||"object"!==typeof a)throw"Expected Metadata object.";for(var b in a){var c=a[b];if("customMetadata"===b&&"object"!==typeof c)throw"Expected object for 'customMetadata' mapping.";}};var T=function(a,b,c){for(var d=b.length,e=b.length,f=0;f<b.length;f++)if(b[f].b){d=f;break}if(!(d<=c.length&&c.length<=e))throw d===e?(b=d,d=1===d?"argument":"arguments"):(b="between "+d+" and "+e,d="arguments"),new v("invalid-argument-count","Invalid argument count in `"+a+"`: Expected "+b+" "+d+", received "+c.length+".");for(f=0;f<c.length;f++)try{b[f].a(c[f])}catch(g){if(g instanceof Error)throw oa(f,a,g.message);throw oa(f,a,g);}},U=function(a,b){var c=this;this.a=function(b){c.b&&!n(b)||a(b)};
	this.b=!!b},ke=function(a,b){return function(c){a(c);b(c)}},le=function(a,b){function c(a){if(!("string"===typeof a||a instanceof String))throw"Expected string.";}var d;a?d=ke(c,a):d=c;return new U(d,b)},me=function(){return new U(function(a){if(!(a instanceof Uint8Array||a instanceof ArrayBuffer||xa()&&a instanceof Blob))throw"Expected Blob or File.";})},ne=function(){return new U(function(a){if(!(("number"===typeof a||a instanceof Number)&&0<=a))throw"Expected a number 0 or greater.";})},oe=function(a,
	b){return new U(function(b){if(!(null===b||x(b)&&b instanceof Object))throw"Expected an Object.";x(a)&&a(b)},b)},pe=function(){return new U(function(a){if(null!==a&&!r(a))throw"Expected a Function.";},!0)};var qe=function(a){if(!a)throw la();},re=function(a,b){return function(c,d){a:{var e;try{e=JSON.parse(d)}catch(h){c=null;break a}c=da(e)?e:null}if(null===c)c=null;else{d={type:"file"};e=b.length;for(var f=0;f<e;f++){var g=b[f];d[g.b]=g.a(d,c[g.c])}he(d,a);c=d}qe(null!==c);return c}},se=function(a){return function(b,c){b=401===P(b)?new v("unauthenticated","User is not authenticated, please authenticate using Firebase Authentication and try again."):402===P(b)?new v("quota-exceeded","Quota for bucket '"+
	a.bucket+"' exceeded, please view quota on https://firebase.google.com/pricing/."):403===P(b)?new v("unauthorized","User does not have permission to access '"+a.path+"'."):c;b.serverResponse=c.serverResponse;return b}},te=function(a){var b=se(a);return function(c,d){var e=b(c,d);404===P(c)&&(e=new v("object-not-found","Object '"+a.path+"' does not exist."));e.serverResponse=d.serverResponse;return e}},ue=function(a,b,c){var d=Ra(b);a=new w(ka+"/v0"+d,"GET",re(a,c),a.c);a.a=te(b);return a},ve=function(a,
	b){var c=Ra(b);a=new w(ka+"/v0"+c,"DELETE",function(){},a.c);a.h=[200,204];a.a=te(b);return a},we=function(a,b,c){c=c?sa(c):{};c.fullPath=a.path;c.size=b.a;c.contentType||(a=b&&b.type()||"application/octet-stream",c.contentType=a);return c},xe=function(a,b,c,d,e){var f="/b/"+encodeURIComponent(b.bucket)+"/o",g={"X-Goog-Upload-Protocol":"multipart"},h;h="";for(var l=0;2>l;l++)h+=Math.random().toString().slice(2);g["Content-Type"]="multipart/related; boundary="+h;e=we(b,d,e);l=ie(e,c);d=Yd("--"+h+"\r\nContent-Type: application/json; charset=utf-8\r\n\r\n"+
	l+"\r\n--"+h+"\r\nContent-Type: "+e.contentType+"\r\n\r\n",d,"\r\n--"+h+"--");if(null===d)throw na();a=new w(ka+"/v0"+f,"POST",re(a,c),a.b);a.f={name:e.fullPath};a.b=g;a.c=d.s;a.a=se(b);return a},ye=function(a,b,c,d){this.a=a;this.total=b;this.b=!!c;this.c=d||null},ze=function(a,b){var c;try{c=Qd(a,"X-Goog-Upload-Status")}catch(d){qe(!1)}a=0<=ob(b||["active"],c);qe(a);return c},Ae=function(a,b,c,d,e){var f="/b/"+encodeURIComponent(b.bucket)+"/o",g=we(b,d,e);e={name:g.fullPath};f=ka+"/v0"+f;d={"X-Goog-Upload-Protocol":"resumable",
	"X-Goog-Upload-Command":"start","X-Goog-Upload-Header-Content-Length":d.a,"X-Goog-Upload-Header-Content-Type":g.contentType,"Content-Type":"application/json; charset=utf-8"};c=ie(g,c);a=new w(f,"POST",function(a){ze(a);var b;try{b=Qd(a,"X-Goog-Upload-URL")}catch(c){qe(!1)}qe(wa(b));return b},a.b);a.f=e;a.b=d;a.c=c;a.a=se(b);return a},Be=function(a,b,c,d){a=new w(c,"POST",function(a){var b=ze(a,["active","final"]),c;try{c=Qd(a,"X-Goog-Upload-Size-Received")}catch(h){qe(!1)}a=c;isFinite(a)&&(a=String(a));
	a=q(a)?/^\s*-?0x/i.test(a)?parseInt(a,16):parseInt(a,10):NaN;qe(!isNaN(a));return new ye(a,d.a,"final"===b)},a.b);a.b={"X-Goog-Upload-Command":"query"};a.a=se(b);return a},Ce=function(a,b,c,d,e,f){var g=new ye(0,0);f?(g.a=f.a,g.total=f.total):(g.a=0,g.total=d.a);if(d.a!==g.total)throw new v("server-file-wrong-size","Server recorded incorrect upload file size, please retry the upload.");var h=f=g.total-g.a,h=Math.min(h,262144),l=g.a;f={"X-Goog-Upload-Command":h===f?"upload, finalize":"upload","X-Goog-Upload-Offset":g.a};
	l=d.slice(l,l+h);if(null===l)throw na();c=new w(c,"POST",function(a,c){var f=ze(a,["active","final"]),l=g.a+h,Jd=d.a,ab;"final"===f?ab=re(b,e)(a,c):ab=null;return new ye(l,Jd,"final"===f,ab)},b.b);c.b=f;c.c=l.s;c.g=null;c.a=se(a);return c};var W=function(a,b,c,d,e,f){this.K=a;this.c=b;this.i=c;this.f=e;this.h=f||null;this.o=d;this.j=0;this.G=this.m=!1;this.B=[];this.Z=262144<this.f.a;this.b="running";this.a=this.u=this.g=null;var g=this;this.W=function(a){g.a=null;"storage/canceled"===a.code?(g.m=!0,De(g)):(g.g=a,V(g,"error"))};this.S=function(a){g.a=null;"storage/canceled"===a.code?De(g):(g.g=a,V(g,"error"))};this.w=this.l=null;this.F=new H(function(a,b){g.l=a;g.w=b;Ee(g)});this.F.then(null,function(){})},Ee=function(a){"running"===
	a.b&&null===a.a&&(a.Z?null===a.u?Fe(a):a.m?Ge(a):a.G?He(a):Ie(a):Je(a))},Ke=function(a,b){de(a.c).then(function(c){switch(a.b){case "running":b(c);break;case "canceling":V(a,"canceled");break;case "pausing":V(a,"paused")}})},Fe=function(a){Ke(a,function(b){var c=Ae(a.c,a.i,a.o,a.f,a.h);a.a=R(a.c,c,b);a.a.a().then(function(b){a.a=null;a.u=b;a.m=!1;De(a)},this.W)})},Ge=function(a){var b=a.u;Ke(a,function(c){var d=Be(a.c,a.i,b,a.f);a.a=R(a.c,d,c);a.a.a().then(function(b){a.a=null;Le(a,b.a);a.m=!1;b.b&&
	(a.G=!0);De(a)},a.W)})},Ie=function(a){var b=new ye(a.j,a.f.a),c=a.u;Ke(a,function(d){var e;try{e=Ce(a.i,a.c,c,a.f,a.o,b)}catch(f){a.g=f;V(a,"error");return}a.a=R(a.c,e,d);a.a.a().then(function(b){a.a=null;Le(a,b.a);b.b?(a.h=b.c,V(a,"success")):De(a)},a.W)})},He=function(a){Ke(a,function(b){var c=ue(a.c,a.i,a.o);a.a=R(a.c,c,b);a.a.a().then(function(b){a.a=null;a.h=b;V(a,"success")},a.S)})},Je=function(a){Ke(a,function(b){var c=xe(a.c,a.i,a.o,a.f,a.h);a.a=R(a.c,c,b);a.a.a().then(function(b){a.a=null;
	a.h=b;Le(a,a.f.a);V(a,"success")},a.W)})},Le=function(a,b){var c=a.j;a.j=b;a.j>c&&Me(a)},V=function(a,b){if(a.b!==b)switch(b){case "canceling":a.b=b;null!==a.a&&a.a.b();break;case "pausing":a.b=b;null!==a.a&&a.a.b();break;case "running":var c="paused"===a.b;a.b=b;c&&(Me(a),Ee(a));break;case "paused":a.b=b;Me(a);break;case "canceled":a.g=ma();a.b=b;Me(a);break;case "error":a.b=b;Me(a);break;case "success":a.b=b,Me(a)}},De=function(a){switch(a.b){case "pausing":V(a,"paused");break;case "canceling":V(a,
	"canceled");break;case "running":Ee(a)}};W.prototype.D=function(){return new z(this.j,this.f.a,va(this.b),this.h,this,this.K)};
	W.prototype.O=function(a,b,c,d){function e(a){try{g(a);return}catch(b){}try{if(h(a),!(n(a.next)||n(a.error)||n(a.complete)))throw"";}catch(b){throw"Expected a function or an Object with one of `next`, `error`, `complete` properties.";}}function f(a){return function(b,c,d){null!==a&&T("on",a,arguments);var e=new Ta(b,c,d);Ne(l,e);return function(){wb(l.B,e)}}}var g=pe().a,h=oe(null,!0).a;T("on",[le(function(){if("state_changed"!==a)throw"Expected one of the event types: [state_changed].";}),oe(e,!0),
	pe(),pe()],arguments);var l=this,F=[oe(function(a){if(null===a)throw"Expected a function or an Object with one of `next`, `error`, `complete` properties.";e(a)}),pe(),pe()];return n(b)||n(c)||n(d)?f(null)(b,c,d):f(F)};W.prototype.then=function(a,b){return this.F.then(a,b)};
	var Ne=function(a,b){a.B.push(b);Oe(a,b)},Me=function(a){Pe(a);var b=xb(a.B);pb(b,function(b){Oe(a,b)})},Pe=function(a){if(null!==a.l){var b=!0;switch(va(a.b)){case "success":Oc(a.l.bind(null,a.D()))();break;case "canceled":case "error":Oc(a.w.bind(null,a.g))();break;default:b=!1}b&&(a.l=null,a.w=null)}},Oe=function(a,b){switch(va(a.b)){case "running":case "paused":null!==b.next&&Oc(b.next.bind(b,a.D()))();break;case "success":null!==b.b&&Oc(b.b.bind(b))();break;case "canceled":case "error":null!==
	b.a&&Oc(b.a.bind(b,a.g))();break;default:null!==b.a&&Oc(b.a.bind(b,a.g))()}};W.prototype.R=function(){T("resume",[],arguments);var a="paused"===this.b||"pausing"===this.b;a&&V(this,"running");return a};W.prototype.P=function(){T("pause",[],arguments);var a="running"===this.b;a&&V(this,"pausing");return a};W.prototype.L=function(){T("cancel",[],arguments);var a="running"===this.b||"pausing"===this.b;a&&V(this,"canceling");return a};var X=function(a,b){this.b=a;if(b)this.a=b instanceof y?b:Sa(b);else if(a=a.bucket(),null!==a)this.a=new y(a,"");else throw new v("no-default-bucket","No default bucket found. Did you set the 'storageBucket' property when initializing the app?");};X.prototype.toString=function(){T("toString",[],arguments);return"gs://"+this.a.bucket+"/"+this.a.path};var Qe=function(a,b){return new X(a,b)};k=X.prototype;
	k.fa=function(a){T("child",[le()],arguments);var b=Gb(this.a.path,a);return Qe(this.b,new y(this.a.bucket,b))};k.Ea=function(){var a;a=this.a.path;if(0==a.length)a=null;else{var b=a.lastIndexOf("/");a=-1===b?"":a.slice(0,b)}return null===a?null:Qe(this.b,new y(this.a.bucket,a))};k.Ga=function(){return Qe(this.b,new y(this.a.bucket,""))};k.na=function(){return this.a.bucket};k.za=function(){return this.a.path};k.Da=function(){return Hb(this.a.path)};k.Ia=function(){return this.b.i};
	k.sa=function(a,b){T("put",[me(),new U(je,!0)],arguments);Re(this,"put");return new W(this,this.b,this.a,ge(),new Q(a),b)};k.ta=function(a,b,c){T("putString",[le(),le(Va,!0),new U(je,!0)],arguments);Re(this,"putString");var d=$a(x(b)?b:"raw",a),e=c?sa(c):{};e.contentType=d.a;return new W(this,this.b,this.a,ge(),new Q(d.data,!0),e)};k.delete=function(){T("delete",[],arguments);Re(this,"delete");var a=this;return de(this.b).then(function(b){var c=ve(a.b,a.a);return R(a.b,c,b).a()})};
	k.ga=function(){T("getMetadata",[],arguments);Re(this,"getMetadata");var a=this;return de(this.b).then(function(b){var c=ue(a.b,a.a,ge());return R(a.b,c,b).a()})};k.ua=function(a){T("updateMetadata",[new U(je,void 0)],arguments);Re(this,"updateMetadata");var b=this;return de(this.b).then(function(c){var d=b.b,e=b.a,f=a,g=ge(),h=Ra(e),h=ka+"/v0"+h,f=ie(f,g),d=new w(h,"PATCH",re(d,g),d.c);d.b={"Content-Type":"application/json; charset=utf-8"};d.c=f;d.a=te(e);return R(b.b,d,c).a()})};
	k.ra=function(){T("getDownloadURL",[],arguments);Re(this,"getDownloadURL");return this.ga().then(function(a){a=a.downloadURLs[0];if(x(a))return a;throw new v("no-download-url","The given file does not have any download URLs.");})};var Re=function(a,b){if(""===a.a.path)throw new v("invalid-root-operation","The operation '"+b+"' cannot be performed on a root reference, create a non-root reference using child, such as .child('file.png').");};var Y=function(a){this.a=new ce(a,function(a,c){return new X(a,c)},Vd,this);this.b=a;this.c=new Se(this)};k=Y.prototype;k.va=function(a){T("ref",[le(function(a){if(/^[A-Za-z]+:\/\//.test(a))throw"Expected child path but got a URL, use refFromURL instead.";},!0)],arguments);var b=new X(this.a);return n(a)?b.fa(a):b};
	k.wa=function(a){T("refFromURL",[le(function(a){if(!/^[A-Za-z]+:\/\//.test(a))throw"Expected full URL but got a child path, use ref instead.";try{Sa(a)}catch(c){throw"Expected valid full URL but got an invalid one.";}},!1)],arguments);return new X(this.a,a)};k.Ba=function(){return this.a.b};k.ya=function(a){T("setMaxUploadRetryTime",[ne()],arguments);this.a.b=a};k.Aa=function(){return this.a.c};k.xa=function(a){T("setMaxOperationRetryTime",[ne()],arguments);this.a.c=a};k.ma=function(){return this.b};
	k.ka=function(){return this.c};var Se=function(a){this.a=a};Se.prototype.delete=function(){var a=this.a.a;a.f=!0;a.a=null;be(a.h)};var Z=function(a,b,c){Object.defineProperty(a,b,{get:c})};X.prototype.toString=X.prototype.toString;X.prototype.child=X.prototype.fa;X.prototype.put=X.prototype.sa;X.prototype.putString=X.prototype.ta;X.prototype["delete"]=X.prototype.delete;X.prototype.getMetadata=X.prototype.ga;X.prototype.updateMetadata=X.prototype.ua;X.prototype.getDownloadURL=X.prototype.ra;Z(X.prototype,"parent",X.prototype.Ea);Z(X.prototype,"root",X.prototype.Ga);Z(X.prototype,"bucket",X.prototype.na);
	Z(X.prototype,"fullPath",X.prototype.za);Z(X.prototype,"name",X.prototype.Da);Z(X.prototype,"storage",X.prototype.Ia);Y.prototype.ref=Y.prototype.va;Y.prototype.refFromURL=Y.prototype.wa;Z(Y.prototype,"maxOperationRetryTime",Y.prototype.Aa);Y.prototype.setMaxOperationRetryTime=Y.prototype.xa;Z(Y.prototype,"maxUploadRetryTime",Y.prototype.Ba);Y.prototype.setMaxUploadRetryTime=Y.prototype.ya;Z(Y.prototype,"app",Y.prototype.ma);Z(Y.prototype,"INTERNAL",Y.prototype.ka);Se.prototype["delete"]=Se.prototype.delete;
	Y.prototype.capi_=function(a){ka=a};W.prototype.on=W.prototype.O;W.prototype.resume=W.prototype.R;W.prototype.pause=W.prototype.P;W.prototype.cancel=W.prototype.L;Z(W.prototype,"snapshot",W.prototype.D);Z(z.prototype,"bytesTransferred",z.prototype.oa);Z(z.prototype,"totalBytes",z.prototype.Ka);Z(z.prototype,"state",z.prototype.Ha);Z(z.prototype,"metadata",z.prototype.Ca);Z(z.prototype,"downloadURL",z.prototype.qa);Z(z.prototype,"task",z.prototype.Ja);Z(z.prototype,"ref",z.prototype.Fa);
	ta.STATE_CHANGED="state_changed";ua.RUNNING="running";ua.PAUSED="paused";ua.SUCCESS="success";ua.CANCELED="canceled";ua.ERROR="error";Ua.RAW="raw";Ua.BASE64="base64";Ua.BASE64URL="base64url";Ua.DATA_URL="data_url";H.prototype["catch"]=H.prototype.l;H.prototype.then=H.prototype.then;
	(function(){function a(a){return new Y(a)}var b={TaskState:ua,TaskEvent:ta,StringFormat:Ua,Storage:Y,Reference:X};if(window.firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService)firebase.INTERNAL.registerService("storage",a,b);else throw Error("Cannot install Firebase Storage - be sure to load firebase-app.js first.");})();})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 288 */
/***/ function(module, exports) {

	/*
	 Highcharts JS v4.2.6 (2016-08-02)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(D,ca){typeof module==="object"&&module.exports?module.exports=D.document?ca(D):ca:D.Highcharts=ca(D)})(typeof window!=="undefined"?window:this,function(D){function ca(a,b){var c="Highcharts error #"+a+": www.highcharts.com/errors/"+a;if(b)throw Error(c);D.console&&console.log(c)}function sb(a,b,c){this.options=b;this.elem=a;this.prop=c}function E(){var a,b=arguments,c,d={},e=function(a,b){var c,d;typeof a!=="object"&&(a={});for(d in b)b.hasOwnProperty(d)&&(c=b[d],a[d]=c&&typeof c==="object"&&
	Object.prototype.toString.call(c)!=="[object Array]"&&d!=="renderTo"&&typeof c.nodeType!=="number"?e(a[d]||{},c):b[d]);return a};b[0]===!0&&(d=b[1],b=Array.prototype.slice.call(b,2));c=b.length;for(a=0;a<c;a++)d=e(d,b[a]);return d}function B(a,b){return parseInt(a,b||10)}function ya(a){return typeof a==="string"}function Fa(a){return Object.prototype.toString.call(a)==="[object Array]"}function ra(a,b){for(var c=a.length;c--;)if(a[c]===b){a.splice(c,1);break}}function s(a){return a!==A&&a!==null}
	function P(a,b,c){var d,e;if(ya(b))s(c)?a.setAttribute(b,c):a&&a.getAttribute&&(e=a.getAttribute(b));else if(s(b)&&$(b))for(d in b)a.setAttribute(d,b[d]);return e}function ua(a){return Fa(a)?a:[a]}function Ra(a,b,c){if(b)return setTimeout(a,b,c);a.call(0,c)}function M(a,b){if(za&&!ga&&b&&b.opacity!==A)b.filter="alpha(opacity="+b.opacity*100+")";x(a.style,b)}function da(a,b,c,d,e){a=y.createElement(a);b&&x(a,b);e&&M(a,{padding:0,border:"none",margin:0});c&&M(a,c);d&&d.appendChild(a);return a}function sa(a,
	b){var c=function(){};c.prototype=new a;x(c.prototype,b);return c}function Ga(a,b,c){return Array((b||2)+1-String(a).length).join(c||0)+a}function $a(a){return(ab&&ab(a)||tb||0)*6E4}function Na(a,b){for(var c="{",d=!1,e,f,g,h,i,j=[];(c=a.indexOf(c))!==-1;){e=a.slice(0,c);if(d){f=e.split(":");g=f.shift().split(".");i=g.length;e=b;for(h=0;h<i;h++)e=e[g[h]];if(f.length)f=f.join(":"),g=/\.([0-9])/,h=U.lang,i=void 0,/f$/.test(f)?(i=(i=f.match(g))?i[1]:-1,e!==null&&(e=u.numberFormat(e,i,h.decimalPoint,
	f.indexOf(",")>-1?h.thousandsSep:""))):e=Sa(f,e)}j.push(e);a=a.slice(c+1);c=(d=!d)?"}":"{"}j.push(a);return j.join("")}function ub(a){return Z.pow(10,V(Z.log(a)/Z.LN10))}function vb(a,b,c,d,e){var f,g=a,c=p(c,1);f=a/c;b||(b=[1,2,2.5,5,10],d===!1&&(c===1?b=[1,2,5,10]:c<=0.1&&(b=[1/c])));for(d=0;d<b.length;d++)if(g=b[d],e&&g*c>=a||!e&&f<=(b[d]+(b[d+1]||b[d]))/2)break;g*=c;return g}function jb(a,b){var c=a.length,d,e;for(e=0;e<c;e++)a[e].safeI=e;a.sort(function(a,c){d=b(a,c);return d===0?a.safeI-c.safeI:
	d});for(e=0;e<c;e++)delete a[e].safeI}function Oa(a){for(var b=a.length,c=a[0];b--;)a[b]<c&&(c=a[b]);return c}function Ha(a){for(var b=a.length,c=a[0];b--;)a[b]>c&&(c=a[b]);return c}function Ta(a,b){for(var c in a)a[c]&&a[c]!==b&&a[c].destroy&&a[c].destroy(),delete a[c]}function Ua(a){kb||(kb=da(Pa));a&&kb.appendChild(a);kb.innerHTML=""}function aa(a,b){return parseFloat(a.toPrecision(b||14))}function Va(a,b){b.renderer.globalAnimation=p(a,b.animation)}function bb(a){return $(a)?E(a):{duration:a?
	500:0}}function Gb(){var a=U.global,b=a.useUTC,c=b?"getUTC":"get",d=b?"setUTC":"set";ma=a.Date||D.Date;tb=b&&a.timezoneOffset;ab=b&&a.getTimezoneOffset;lb=function(a,c,d,h,i,j){var k;b?(k=ma.UTC.apply(0,arguments),k+=$a(k)):k=(new ma(a,c,p(d,1),p(h,0),p(i,0),p(j,0))).getTime();return k};wb=c+"Minutes";xb=c+"Hours";yb=c+"Day";Wa=c+"Date";cb=c+"Month";db=c+"FullYear";Hb=d+"Milliseconds";Ib=d+"Seconds";Jb=d+"Minutes";Kb=d+"Hours";mb=d+"Date";zb=d+"Month";Ab=d+"FullYear"}function na(a){if(!(this instanceof
	na))return new na(a);this.init(a)}function O(){}function Xa(a,b,c,d){this.axis=a;this.pos=b;this.type=c||"";this.isNew=!0;!c&&!d&&this.addLabel()}function Lb(a,b,c,d,e){var f=a.chart.inverted;this.axis=a;this.isNegative=c;this.options=b;this.x=d;this.total=null;this.points={};this.stack=e;this.rightCliff=this.leftCliff=0;this.alignOptions={align:b.align||(f?c?"left":"right":"center"),verticalAlign:b.verticalAlign||(f?"middle":c?"bottom":"top"),y:p(b.y,f?4:c?14:-6),x:p(b.x,f?c?-6:6:0)};this.textAlign=
	b.textAlign||(f?c?"right":"left":"center")}var A,y=D.document,Z=Math,C=Z.round,V=Z.floor,va=Z.ceil,t=Z.max,F=Z.min,Q=Z.abs,W=Z.cos,ea=Z.sin,ta=Z.PI,ka=ta*2/360,Aa=D.navigator&&D.navigator.userAgent||"",Mb=D.opera,za=/(msie|trident|edge)/i.test(Aa)&&!Mb,nb=y&&y.documentMode===8,ob=!za&&/AppleWebKit/.test(Aa),Qa=/Firefox/.test(Aa),Nb=/(Mobile|Android|Windows Phone)/.test(Aa),Ia="http://www.w3.org/2000/svg",ga=y&&y.createElementNS&&!!y.createElementNS(Ia,"svg").createSVGRect,Rb=Qa&&parseInt(Aa.split("Firefox/")[1],
	10)<4,la=y&&!ga&&!za&&!!y.createElement("canvas").getContext,eb,fb,Ob={},Bb=0,kb,U,Sa,H,Ba=function(){},T=[],gb=0,Pa="div",X="M",S="L",Sb=/^[0-9]+$/,pb=["plotTop","marginRight","marginBottom","plotLeft"],ma,lb,tb,ab,wb,xb,yb,Wa,cb,db,Hb,Ib,Jb,Kb,mb,zb,Ab,L={},u;u=D.Highcharts?ca(16,!0):{win:D};u.seriesTypes=L;var Ja=[],oa,pa,q,Ca,Cb,Da,N,Y,I,Ya,Ka;sb.prototype={dSetter:function(){var a=this.paths[0],b=this.paths[1],c=[],d=this.now,e=a.length,f;if(d===1)c=this.toD;else if(e===b.length&&d<1)for(;e--;)f=
	parseFloat(a[e]),c[e]=isNaN(f)?a[e]:d*parseFloat(b[e]-f)+f;else c=b;this.elem.attr("d",c)},update:function(){var a=this.elem,b=this.prop,c=this.now,d=this.options.step;if(this[b+"Setter"])this[b+"Setter"]();else a.attr?a.element&&a.attr(b,c):a.style[b]=c+this.unit;d&&d.call(a,c,this)},run:function(a,b,c){var d=this,e=function(a){return e.stopped?!1:d.step(a)},f;this.startTime=+new ma;this.start=a;this.end=b;this.unit=c;this.now=this.start;this.pos=0;e.elem=this.elem;if(e()&&Ja.push(e)===1)e.timerId=
	setInterval(function(){for(f=0;f<Ja.length;f++)Ja[f]()||Ja.splice(f--,1);Ja.length||clearInterval(e.timerId)},13)},step:function(a){var b=+new ma,c,d=this.options;c=this.elem;var e=d.complete,f=d.duration,g=d.curAnim,h;if(c.attr&&!c.element)c=!1;else if(a||b>=f+this.startTime){this.now=this.end;this.pos=1;this.update();a=g[this.prop]=!0;for(h in g)g[h]!==!0&&(a=!1);a&&e&&e.call(c);c=!1}else this.pos=d.easing((b-this.startTime)/f),this.now=this.start+(this.end-this.start)*this.pos,this.update(),c=
	!0;return c},initPath:function(a,b,c){function d(a){for(n=a.length;n--;)(a[n]===X||a[n]===S)&&a.splice(n+1,0,a[n+1],a[n+2],a[n+1],a[n+2])}function e(a,b){for(;a.length<l;){a[0]=b[l-a.length];var c=a.slice(0,k);[].splice.apply(a,[0,0].concat(c));o&&(c=a.slice(a.length-k),[].splice.apply(a,[a.length,0].concat(c)),n--)}a[0]="M"}function f(a,b){for(var c=(l-a.length)/k;c>0&&c--;)m=a.slice().splice(a.length/z-k,k*z),m[0]=b[l-k-c*k],j&&(m[k-6]=m[k-2],m[k-5]=m[k-1]),[].splice.apply(a,[a.length/z,0].concat(m)),
	o&&c--}var b=b||"",g,h=a.startX,i=a.endX,j=b.indexOf("C")>-1,k=j?7:3,l,m,n,b=b.split(" "),c=c.slice(),o=a.isArea,z=o?2:1,r;j&&(d(b),d(c));if(h&&i){for(n=0;n<h.length;n++)if(h[n]===i[0]){g=n;break}else if(h[0]===i[i.length-h.length+n]){g=n;r=!0;break}g===void 0&&(b=[])}b.length&&u.isNumber(g)&&(l=c.length+g*z*k,r?(e(b,c),f(c,b)):(e(c,b),f(b,c)));return[b,c]}};var x=u.extend=function(a,b){var c;a||(a={});for(c in b)a[c]=b[c];return a},$=u.isObject=function(a,b){return a&&typeof a==="object"&&(!b||!Fa(a))},
	J=u.isNumber=function(a){return typeof a==="number"&&!isNaN(a)},p=u.pick=function(){var a=arguments,b,c,d=a.length;for(b=0;b<d;b++)if(c=a[b],c!==A&&c!==null)return c},hb=u.wrap=function(a,b,c){var d=a[b];a[b]=function(){var a=Array.prototype.slice.call(arguments);a.unshift(d);return c.apply(this,a)}};Sa=function(a,b,c){if(!s(b)||isNaN(b))return U.lang.invalidDate||"";var a=p(a,"%Y-%m-%d %H:%M:%S"),d=new ma(b-$a(b)),e,f=d[xb](),g=d[yb](),h=d[Wa](),i=d[cb](),j=d[db](),k=U.lang,l=k.weekdays,m=k.shortWeekdays,
	d=x({a:m?m[g]:l[g].substr(0,3),A:l[g],d:Ga(h),e:Ga(h,2," "),w:g,b:k.shortMonths[i],B:k.months[i],m:Ga(i+1),y:j.toString().substr(2,2),Y:j,H:Ga(f),k:f,I:Ga(f%12||12),l:f%12||12,M:Ga(d[wb]()),p:f<12?"AM":"PM",P:f<12?"am":"pm",S:Ga(d.getSeconds()),L:Ga(C(b%1E3),3)},u.dateFormats);for(e in d)for(;a.indexOf("%"+e)!==-1;)a=a.replace("%"+e,typeof d[e]==="function"?d[e](b):d[e]);return c?a.substr(0,1).toUpperCase()+a.substr(1):a};H={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,
	year:314496E5};u.numberFormat=function(a,b,c,d){var a=+a||0,b=+b,e=U.lang,f=(a.toString().split(".")[1]||"").length,g,h,i=Math.abs(a);b===-1?b=Math.min(f,20):J(b)||(b=2);g=String(B(i.toFixed(b)));h=g.length>3?g.length%3:0;c=p(c,e.decimalPoint);d=p(d,e.thousandsSep);a=a<0?"-":"";a+=h?g.substr(0,h)+d:"";a+=g.substr(h).replace(/(\d{3})(?=\d)/g,"$1"+d);b&&(d=Math.abs(i-g+Math.pow(10,-Math.max(b,f)-1)),a+=c+d.toFixed(b).slice(2));return a};Math.easeInOutSine=function(a){return-0.5*(Math.cos(Math.PI*a)-
	1)};oa=function(a,b){var c;if(b==="width")return Math.min(a.offsetWidth,a.scrollWidth)-oa(a,"padding-left")-oa(a,"padding-right");else if(b==="height")return Math.min(a.offsetHeight,a.scrollHeight)-oa(a,"padding-top")-oa(a,"padding-bottom");return(c=D.getComputedStyle(a,void 0))&&B(c.getPropertyValue(b))};pa=function(a,b){return b.indexOf?b.indexOf(a):[].indexOf.call(b,a)};Ca=function(a,b){return[].filter.call(a,b)};Da=function(a,b){for(var c=[],d=0,e=a.length;d<e;d++)c[d]=b.call(a[d],a[d],d,a);return c};
	Cb=function(a){var b=y.documentElement,a=a.getBoundingClientRect();return{top:a.top+(D.pageYOffset||b.scrollTop)-(b.clientTop||0),left:a.left+(D.pageXOffset||b.scrollLeft)-(b.clientLeft||0)}};Ka=function(a){for(var b=Ja.length;b--;)if(Ja[b].elem===a)Ja[b].stopped=!0};q=function(a,b){return Array.prototype.forEach.call(a,b)};N=function(a,b,c){function d(b){b.target=b.srcElement||D;c.call(a,b)}var e=a.hcEvents=a.hcEvents||{};if(a.addEventListener)a.addEventListener(b,c,!1);else if(a.attachEvent){if(!a.hcEventsIE)a.hcEventsIE=
	{};a.hcEventsIE[c.toString()]=d;a.attachEvent("on"+b,d)}e[b]||(e[b]=[]);e[b].push(c)};Y=function(a,b,c){function d(b,c){a.removeEventListener?a.removeEventListener(b,c,!1):a.attachEvent&&(c=a.hcEventsIE[c.toString()],a.detachEvent("on"+b,c))}function e(){var c,e,f;if(a.nodeName)for(f in b?(c={},c[b]=!0):c=g,c)if(g[f])for(e=g[f].length;e--;)d(f,g[f][e])}var f,g=a.hcEvents,h;if(g)b?(f=g[b]||[],c?(h=pa(c,f),h>-1&&(f.splice(h,1),g[b]=f),d(b,c)):(e(),g[b]=[])):(e(),a.hcEvents={})};I=function(a,b,c,d){var e;
	e=a.hcEvents;var f,g,c=c||{};if(y.createEvent&&(a.dispatchEvent||a.fireEvent))e=y.createEvent("Events"),e.initEvent(b,!0,!0),e.target=a,x(e,c),a.dispatchEvent?a.dispatchEvent(e):a.fireEvent(b,e);else if(e){e=e[b]||[];f=e.length;if(!c.preventDefault)c.preventDefault=function(){c.defaultPrevented=!0};c.target=a;if(!c.type)c.type=b;for(b=0;b<f;b++)(g=e[b])&&g.call(a,c)===!1&&c.preventDefault()}d&&!c.defaultPrevented&&d(c)};Ya=function(a,b,c){var d,e="",f,g,h;$(c)||(d=arguments,c={duration:d[2],easing:d[3],
	complete:d[4]});if(!J(c.duration))c.duration=400;c.easing=typeof c.easing==="function"?c.easing:Math[c.easing]||Math.easeInOutSine;c.curAnim=E(b);for(h in b)g=new sb(a,c,h),f=null,h==="d"?(g.paths=g.initPath(a,a.d,b.d),g.toD=b.d,d=0,f=1):a.attr?d=a.attr(h):(d=parseFloat(oa(a,h))||0,h!=="opacity"&&(e="px")),f||(f=b[h]),f.match&&f.match("px")&&(f=f.replace(/px/g,"")),g.run(d,f,e)};if(D.jQuery)D.jQuery.fn.highcharts=function(){var a=[].slice.call(arguments);if(this[0])return a[0]?(new (u[ya(a[0])?a.shift():
	"Chart"])(this[0],a[0],a[1]),this):T[P(this[0],"data-highcharts-chart")]};y&&!y.defaultView&&(oa=function(a,b){var c;c={width:"clientWidth",height:"clientHeight"}[b];if(a.style[b])return B(a.style[b]);b==="opacity"&&(b="filter");if(c)return a.style.zoom=1,Math.max(a[c]-2*oa(a,"padding"),0);c=a.currentStyle[b.replace(/\-(\w)/g,function(a,b){return b.toUpperCase()})];b==="filter"&&(c=c.replace(/alpha\(opacity=([0-9]+)\)/,function(a,b){return b/100}));return c===""?1:B(c)});Array.prototype.forEach||
	(q=function(a,b){for(var c=0,d=a.length;c<d;c++)if(b.call(a[c],a[c],c,a)===!1)return c});Array.prototype.indexOf||(pa=function(a,b){var c,d=0;if(b)for(c=b.length;d<c;d++)if(b[d]===a)return d;return-1});Array.prototype.filter||(Ca=function(a,b){for(var c=[],d=0,e=a.length;d<e;d++)b(a[d],d)&&c.push(a[d]);return c});u.Fx=sb;u.inArray=pa;u.each=q;u.grep=Ca;u.offset=Cb;u.map=Da;u.addEvent=N;u.removeEvent=Y;u.fireEvent=I;u.animate=Ya;u.animObject=bb;u.stop=Ka;U={colors:"#7cb5ec,#434348,#90ed7d,#f7a35c,#8085e9,#f15c80,#e4d354,#2b908f,#f45b5b,#91e8e1".split(","),
	symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January,February,March,April,May,June,July,August,September,October,November,December".split(","),shortMonths:"Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec".split(","),weekdays:"Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday".split(","),decimalPoint:".",numericSymbols:"k,M,G,T,P,E".split(","),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0,
	canvasToolsURL:"http://code.highcharts.com/modules/canvas-tools.js",VMLRadialGradientURL:"http://code.highcharts.com/4.2.6/gfx/vml-radial-gradient.png"},chart:{borderColor:"#4572A7",borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],backgroundColor:"#FFFFFF",plotBorderColor:"#C0C0C0",resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}},width:null,height:null},title:{text:"Chart title",align:"center",margin:15,style:{color:"#333333",fontSize:"18px"},
	widthAdjust:-44},subtitle:{text:"",align:"center",style:{color:"#555555"},widthAdjust:-44},plotOptions:{line:{allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},lineWidth:2,marker:{lineWidth:0,radius:4,lineColor:"#FFFFFF",states:{hover:{enabled:!0,lineWidthPlus:1,radiusPlus:2},select:{fillColor:"#FFFFFF",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return this.y===null?"":u.numberFormat(this.y,-1)},style:{color:"contrast",
	fontSize:"11px",fontWeight:"bold",textShadow:"0 0 6px contrast, 0 0 3px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{lineWidthPlus:1,marker:{},halo:{size:10,opacity:0.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3}},labels:{style:{position:"absolute",color:"#3E576F"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#909090",borderRadius:0,navigation:{activeColor:"#274b6d",
	inactiveColor:"#CCC"},shadow:!1,itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold"},itemHoverStyle:{color:"#000"},itemHiddenStyle:{color:"#CCC"},itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"white",opacity:0.5,textAlign:"center"}},tooltip:{enabled:!0,animation:ga,backgroundColor:"rgba(249, 249, 249, .85)",
	borderWidth:1,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',shadow:!0,snap:Nb?25:10,style:{color:"#333333",cursor:"default",fontSize:"12px",
	padding:"8px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,text:"Highcharts.com",href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#909090",fontSize:"9px"}}};var fa=U.plotOptions,ha=fa.line;Gb();na.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[B(a[1]),B(a[2]),B(a[3]),parseFloat(a[4],10)]}},{regex:/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
	parse:function(a){return[B(a[1],16),B(a[2],16),B(a[3],16),1]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[B(a[1]),B(a[2]),B(a[3]),1]}}],init:function(a){var b,c,d,e;if((this.input=a)&&a.stops)this.stops=Da(a.stops,function(a){return new na(a[1])});else for(d=this.parsers.length;d--&&!c;)e=this.parsers[d],(b=e.regex.exec(a))&&(c=e.parse(b));this.rgba=c||[]},get:function(a){var b=this.input,c=this.rgba,d;this.stops?(d=E(b),d.stops=[].concat(d.stops),
	q(this.stops,function(b,c){d.stops[c]=[d.stops[c][0],b.get(a)]})):d=c&&J(c[0])?a==="rgb"||!a&&c[3]===1?"rgb("+c[0]+","+c[1]+","+c[2]+")":a==="a"?c[3]:"rgba("+c.join(",")+")":b;return d},brighten:function(a){var b,c=this.rgba;if(this.stops)q(this.stops,function(b){b.brighten(a)});else if(J(a)&&a!==0)for(b=0;b<3;b++)c[b]+=B(a*255),c[b]<0&&(c[b]=0),c[b]>255&&(c[b]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this}};O.prototype={opacity:1,textProps:"direction,fontSize,fontWeight,fontFamily,fontStyle,color,lineHeight,width,textDecoration,textOverflow,textShadow".split(","),
	init:function(a,b){this.element=b==="span"?da(b):y.createElementNS(Ia,b);this.renderer=a},animate:function(a,b,c){b=p(b,this.renderer.globalAnimation,!0);Ka(this);if(b){if(c)b.complete=c;Ya(this,a,b)}else this.attr(a,null,c);return this},colorGradient:function(a,b,c){var d=this.renderer,e,f,g,h,i,j,k,l,m,n,o,z=[],r;a.linearGradient?f="linearGradient":a.radialGradient&&(f="radialGradient");if(f){g=a[f];i=d.gradients;k=a.stops;n=c.radialReference;Fa(g)&&(a[f]=g={x1:g[0],y1:g[1],x2:g[2],y2:g[3],gradientUnits:"userSpaceOnUse"});
	f==="radialGradient"&&n&&!s(g.gradientUnits)&&(h=g,g=E(g,d.getRadialAttr(n,h),{gradientUnits:"userSpaceOnUse"}));for(o in g)o!=="id"&&z.push(o,g[o]);for(o in k)z.push(k[o]);z=z.join(",");i[z]?n=i[z].attr("id"):(g.id=n="highcharts-"+Bb++,i[z]=j=d.createElement(f).attr(g).add(d.defs),j.radAttr=h,j.stops=[],q(k,function(a){a[1].indexOf("rgba")===0?(e=na(a[1]),l=e.get("rgb"),m=e.get("a")):(l=a[1],m=1);a=d.createElement("stop").attr({offset:a[0],"stop-color":l,"stop-opacity":m}).add(j);j.stops.push(a)}));
	r="url("+d.url+"#"+n+")";c.setAttribute(b,r);c.gradient=z;a.toString=function(){return r}}},applyTextShadow:function(a){var b=this.element,c,d=a.indexOf("contrast")!==-1,e={},f=this.renderer.forExport,g=f||b.style.textShadow!==A&&!za;if(d)e.textShadow=a=a.replace(/contrast/g,this.renderer.getContrast(b.style.fill));if(ob||f)e.textRendering="geometricPrecision";g?this.css(e):(this.fakeTS=!0,this.ySetter=this.xSetter,c=[].slice.call(b.getElementsByTagName("tspan")),q(a.split(/\s?,\s?/g),function(a){var d=
	b.firstChild,e,f,a=a.split(" ");e=a[a.length-1];(f=a[a.length-2])&&q(c,function(a,c){var g;c===0&&(a.setAttribute("x",b.getAttribute("x")),c=b.getAttribute("y"),a.setAttribute("y",c||0),c===null&&b.setAttribute("y",0));g=a.cloneNode(1);P(g,{"class":"highcharts-text-shadow",fill:e,stroke:e,"stroke-opacity":1/t(B(f),3),"stroke-width":f,"stroke-linejoin":"round"});b.insertBefore(g,d)})}))},attr:function(a,b,c){var d,e=this.element,f,g=this,h;typeof a==="string"&&b!==A&&(d=a,a={},a[d]=b);if(typeof a===
	"string")g=(this[a+"Getter"]||this._defaultGetter).call(this,a,e);else{for(d in a){b=a[d];h=!1;this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)/.test(d)&&(f||(this.symbolAttr(a),f=!0),h=!0);if(this.rotation&&(d==="x"||d==="y"))this.doTransform=!0;h||(h=this[d+"Setter"]||this._defaultSetter,h.call(this,b,d,e),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(d)&&this.updateShadows(d,b,h))}if(this.doTransform)this.updateTransform(),this.doTransform=!1}c&&
	c();return g},updateShadows:function(a,b,c){for(var d=this.shadows,e=d.length;e--;)c.call(d[e],a==="height"?Math.max(b-(d[e].cutHeight||0),0):a==="d"?this.d:b,a,d[e])},addClass:function(a){var b=this.element,c=P(b,"class")||"";c.indexOf(a)===-1&&P(b,"class",c+" "+a);return this},symbolAttr:function(a){var b=this;q("x,y,r,start,end,width,height,innerR,anchorX,anchorY".split(","),function(c){b[c]=p(a[c],b[c])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})},clip:function(a){return this.attr("clip-path",
	a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a){var b,c={},d,e=this.strokeWidth||0;d=C(e)%2/2;a.x=V(a.x||this.x||0)+d;a.y=V(a.y||this.y||0)+d;a.width=V((a.width||this.width||0)-2*d);a.height=V((a.height||this.height||0)-2*d);a.strokeWidth=e;for(b in a)this[b]!==a[b]&&(this[b]=c[b]=a[b]);return c},css:function(a){var b=this.styles,c={},d=this.element,e,f,g="";e=!b;if(a&&a.color)a.fill=a.color;if(b)for(f in a)a[f]!==b[f]&&(c[f]=a[f],e=!0);if(e){e=this.textWidth=a&&a.width&&d.nodeName.toLowerCase()===
	"text"&&B(a.width)||this.textWidth;b&&(a=x(b,c));this.styles=a;e&&(la||!ga&&this.renderer.forExport)&&delete a.width;if(za&&!ga)M(this.element,a);else{b=function(a,b){return"-"+b.toLowerCase()};for(f in a)g+=f.replace(/([A-Z])/g,b)+":"+a[f]+";";P(d,"style",g)}e&&this.added&&this.renderer.buildText(this)}return this},on:function(a,b){var c=this,d=c.element;fb&&a==="click"?(d.ontouchstart=function(a){c.touchEventFired=ma.now();a.preventDefault();b.call(d,a)},d.onclick=function(a){(Aa.indexOf("Android")===
	-1||ma.now()-(c.touchEventFired||0)>1100)&&b.call(d,a)}):d["on"+a]=b;return this},setRadialReference:function(a){var b=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;b&&b.radAttr&&b.animate(this.renderer.getRadialAttr(a,b.radAttr));return this},translate:function(a,b){return this.attr({translateX:a,translateY:b})},invert:function(){this.inverted=!0;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,b=this.translateY||0,c=this.scaleX,
	d=this.scaleY,e=this.inverted,f=this.rotation,g=this.element;e&&(a+=this.attr("width"),b+=this.attr("height"));a=["translate("+a+","+b+")"];e?a.push("rotate(90) scale(-1,1)"):f&&a.push("rotate("+f+" "+(g.getAttribute("x")||0)+" "+(g.getAttribute("y")||0)+")");(s(c)||s(d))&&a.push("scale("+p(c,1)+" "+p(d,1)+")");a.length&&g.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,b,c){var d,e,f,g,h={};e=this.renderer;f=e.alignedObjects;
	if(a){if(this.alignOptions=a,this.alignByTranslate=b,!c||ya(c))this.alignTo=d=c||"renderer",ra(f,this),f.push(this),c=null}else a=this.alignOptions,b=this.alignByTranslate,d=this.alignTo;c=p(c,e[d],e);d=a.align;e=a.verticalAlign;f=(c.x||0)+(a.x||0);g=(c.y||0)+(a.y||0);if(d==="right"||d==="center")f+=(c.width-(a.width||0))/{right:1,center:2}[d];h[b?"translateX":"x"]=C(f);if(e==="bottom"||e==="middle")g+=(c.height-(a.height||0))/({bottom:1,middle:2}[e]||1);h[b?"translateY":"y"]=C(g);this[this.placed?
	"animate":"attr"](h);this.placed=!0;this.alignAttr=h;return this},getBBox:function(a,b){var c,d=this.renderer,e,f,g,h=this.element,i=this.styles;e=this.textStr;var j,k=h.style,l,m=d.cache,n=d.cacheKeys,o;f=p(b,this.rotation);g=f*ka;e!==A&&(o=["",f||0,i&&i.fontSize,h.style.width].join(","),o=e===""||Sb.test(e)?"num:"+e.toString().length+o:e+o);o&&!a&&(c=m[o]);if(!c){if(h.namespaceURI===Ia||d.forExport){try{l=this.fakeTS&&function(a){q(h.querySelectorAll(".highcharts-text-shadow"),function(b){b.style.display=
	a})},Qa&&k.textShadow?(j=k.textShadow,k.textShadow=""):l&&l("none"),c=h.getBBox?x({},h.getBBox()):{width:h.offsetWidth,height:h.offsetHeight},j?k.textShadow=j:l&&l("")}catch(z){}if(!c||c.width<0)c={width:0,height:0}}else c=this.htmlGetBBox();if(d.isSVG){d=c.width;e=c.height;if(za&&i&&i.fontSize==="11px"&&e.toPrecision(3)==="16.9")c.height=e=14;if(f)c.width=Q(e*ea(g))+Q(d*W(g)),c.height=Q(e*W(g))+Q(d*ea(g))}if(o){for(;n.length>250;)delete m[n.shift()];m[o]||n.push(o);m[o]=c}}return c},show:function(a){return this.attr({visibility:a?
	"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var b=this;b.animate({opacity:0},{duration:a||150,complete:function(){b.attr({y:-9999})}})},add:function(a){var b=this.renderer,c=this.element,d;if(a)this.parentGroup=a;this.parentInverted=a&&a.inverted;this.textStr!==void 0&&b.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)d=this.zIndexSetter();d||(a?a.element:b.box).appendChild(c);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var b=
	a.parentNode;b&&b.removeChild(a)},destroy:function(){var a=this,b=a.element||{},c=a.shadows,d=a.renderer.isSVG&&b.nodeName==="SPAN"&&a.parentGroup,e,f;b.onclick=b.onmouseout=b.onmouseover=b.onmousemove=b.point=null;Ka(a);if(a.clipPath)a.clipPath=a.clipPath.destroy();if(a.stops){for(f=0;f<a.stops.length;f++)a.stops[f]=a.stops[f].destroy();a.stops=null}a.safeRemoveChild(b);for(c&&q(c,function(b){a.safeRemoveChild(b)});d&&d.div&&d.div.childNodes.length===0;)b=d.parentGroup,a.safeRemoveChild(d.div),delete d.div,
	d=b;a.alignTo&&ra(a.renderer.alignedObjects,a);for(e in a)delete a[e];return null},shadow:function(a,b,c){var d=[],e,f,g=this.element,h,i,j,k;if(a){i=p(a.width,3);j=(a.opacity||0.15)/i;k=this.parentInverted?"(-1,-1)":"("+p(a.offsetX,1)+", "+p(a.offsetY,1)+")";for(e=1;e<=i;e++){f=g.cloneNode(0);h=i*2+1-2*e;P(f,{isShadow:"true",stroke:a.color||"black","stroke-opacity":j*e,"stroke-width":h,transform:"translate"+k,fill:"none"});if(c)P(f,"height",t(P(f,"height")-h,0)),f.cutHeight=h;b?b.element.appendChild(f):
	g.parentNode.insertBefore(f,g);d.push(f)}this.shadows=d}return this},xGetter:function(a){this.element.nodeName==="circle"&&(a={x:"cx",y:"cy"}[a]||a);return this._defaultGetter(a)},_defaultGetter:function(a){a=p(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,b,c){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");c.setAttribute(b,a);this[b]=a},dashstyleSetter:function(a){var b,c=this["stroke-width"];c===
	"inherit"&&(c=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=B(a[b])*c;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},
	opacitySetter:function(a,b,c){this[b]=a;c.setAttribute(b,a)},titleSetter:function(a){var b=this.element.getElementsByTagName("title")[0];b||(b=y.createElementNS(Ia,"title"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);b.appendChild(y.createTextNode(String(p(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){if(a!==this.textStr)delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this)},fillSetter:function(a,b,c){typeof a==="string"?c.setAttribute(b,a):
	a&&this.colorGradient(a,b,c)},visibilitySetter:function(a,b,c){a==="inherit"?c.removeAttribute(b):c.setAttribute(b,a)},zIndexSetter:function(a,b){var c=this.renderer,d=this.parentGroup,c=(d||c).element||c.box,e,f,g=this.element,h;e=this.added;var i;if(s(a))g.zIndex=a,a=+a,this[b]===a&&(e=!1),this[b]=a;if(e){if((a=this.zIndex)&&d)d.handleZ=!0;d=c.childNodes;for(i=0;i<d.length&&!h;i++)if(e=d[i],f=e.zIndex,e!==g&&(B(f)>a||!s(a)&&s(f)))c.insertBefore(g,e),h=!0;h||c.appendChild(g)}return h},_defaultSetter:function(a,
	b,c){c.setAttribute(b,a)}};O.prototype.yGetter=O.prototype.xGetter;O.prototype.translateXSetter=O.prototype.translateYSetter=O.prototype.rotationSetter=O.prototype.verticalAlignSetter=O.prototype.scaleXSetter=O.prototype.scaleYSetter=function(a,b){this[b]=a;this.doTransform=!0};O.prototype["stroke-widthSetter"]=O.prototype.strokeSetter=function(a,b,c){this[b]=a;if(this.stroke&&this["stroke-width"])this.strokeWidth=this["stroke-width"],O.prototype.fillSetter.call(this,this.stroke,"stroke",c),c.setAttribute("stroke-width",
	this["stroke-width"]),this.hasStroke=!0;else if(b==="stroke-width"&&a===0&&this.hasStroke)c.removeAttribute("stroke"),this.hasStroke=!1};var Ea=function(){this.init.apply(this,arguments)};Ea.prototype={Element:O,init:function(a,b,c,d,e,f){var g,d=this.createElement("svg").attr({version:"1.1"}).css(this.getStyle(d));g=d.element;a.appendChild(g);a.innerHTML.indexOf("xmlns")===-1&&P(g,"xmlns",Ia);this.isSVG=!0;this.box=g;this.boxWrapper=d;this.alignedObjects=[];this.url=(Qa||ob)&&y.getElementsByTagName("base").length?
	D.location.href.replace(/#.*?$/,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(y.createTextNode("Created with Highcharts 4.2.6"));this.defs=this.createElement("defs").add();this.allowHTML=f;this.forExport=e;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,c,!1);var h;if(Qa&&a.getBoundingClientRect)this.subPixelFix=b=function(){M(a,{left:0,top:0});h=a.getBoundingClientRect();M(a,{left:va(h.left)-h.left+"px",
	top:va(h.top)-h.top+"px"})},b(),N(D,"resize",b)},getStyle:function(a){return this.style=x({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();Ta(this.gradients||{});this.gradients=null;if(a)this.defs=a.destroy();this.subPixelFix&&Y(D,"resize",this.subPixelFix);return this.alignedObjects=null},createElement:function(a){var b=
	new this.Element;b.init(this,a);return b},draw:function(){},getRadialAttr:function(a,b){return{cx:a[0]-a[2]/2+b.cx*a[2],cy:a[1]-a[2]/2+b.cy*a[2],r:b.r*a[2]}},buildText:function(a){for(var b=a.element,c=this,d=c.forExport,e=p(a.textStr,"").toString(),f=e.indexOf("<")!==-1,g=b.childNodes,h,i,j,k=P(b,"x"),l=a.styles,m=a.textWidth,n=l&&l.lineHeight,o=l&&l.textShadow,z=l&&l.textOverflow==="ellipsis",r=g.length,G=m&&!a.added&&this.box,w=function(a){return n?B(n):c.fontMetrics(/(px|em)$/.test(a&&a.style.fontSize)?
	a.style.fontSize:l&&l.fontSize||c.style.fontSize||12,a).h},v=function(a){return a.replace(/&lt;/g,"<").replace(/&gt;/g,">")};r--;)b.removeChild(g[r]);!f&&!o&&!z&&!m&&e.indexOf(" ")===-1?b.appendChild(y.createTextNode(v(e))):(h=/<.*style="([^"]+)".*>/,i=/<.*href="(http[^"]+)".*>/,G&&G.appendChild(b),e=f?e.replace(/<(b|strong)>/g,'<span style="font-weight:bold">').replace(/<(i|em)>/g,'<span style="font-style:italic">').replace(/<a/g,"<span").replace(/<\/(b|strong|i|em|a)>/g,"</span>").split(/<br.*?>/g):
	[e],e=Ca(e,function(a){return a!==""}),q(e,function(e,f){var g,n=0,e=e.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||<span").replace(/<\/span>/g,"</span>|||");g=e.split("|||");q(g,function(e){if(e!==""||g.length===1){var o={},r=y.createElementNS(Ia,"tspan"),p;h.test(e)&&(p=e.match(h)[1].replace(/(;| |^)color([ :])/,"$1fill$2"),P(r,"style",p));i.test(e)&&!d&&(P(r,"onclick",'location.href="'+e.match(i)[1]+'"'),M(r,{cursor:"pointer"}));e=v(e.replace(/<(.|\n)*?>/g,"")||" ");if(e!==" "){r.appendChild(y.createTextNode(e));
	if(n)o.dx=0;else if(f&&k!==null)o.x=k;P(r,o);b.appendChild(r);!n&&f&&(!ga&&d&&M(r,{display:"block"}),P(r,"dy",w(r)));if(m){for(var o=e.replace(/([^\^])-/g,"$1- ").split(" "),q=g.length>1||f||o.length>1&&l.whiteSpace!=="nowrap",G,s,La=[],t=w(r),x=1,C=a.rotation,A=e,u=A.length;(q||z)&&(o.length||La.length);)a.rotation=0,G=a.getBBox(!0),s=G.width,!ga&&c.forExport&&(s=c.measureSpanWidth(r.firstChild.data,a.styles)),G=s>m,j===void 0&&(j=G),z&&j?(u/=2,A===""||!G&&u<0.5?o=[]:(A=e.substring(0,A.length+(G?
	-1:1)*va(u)),o=[A+(m>3?"\u2026":"")],r.removeChild(r.firstChild))):!G||o.length===1?(o=La,La=[],o.length&&(x++,r=y.createElementNS(Ia,"tspan"),P(r,{dy:t,x:k}),p&&P(r,"style",p),b.appendChild(r)),s>m&&(m=s)):(r.removeChild(r.firstChild),La.unshift(o.pop())),o.length&&r.appendChild(y.createTextNode(o.join(" ").replace(/- /g,"-")));a.rotation=C}n++}}})}),j&&a.attr("title",a.textStr),G&&G.removeChild(b),o&&a.applyTextShadow&&a.applyTextShadow(o))},getContrast:function(a){a=na(a).rgba;return a[0]+a[1]+
	a[2]>384?"#000000":"#FFFFFF"},button:function(a,b,c,d,e,f,g,h,i){var j=this.label(a,b,c,i,null,null,null,null,"button"),k=0,l,m,n,o,z,r,a={x1:0,y1:0,x2:0,y2:1},e=E({"stroke-width":1,stroke:"#CCCCCC",fill:{linearGradient:a,stops:[[0,"#FEFEFE"],[1,"#F6F6F6"]]},r:2,padding:5,style:{color:"black"}},e);n=e.style;delete e.style;f=E(e,{stroke:"#68A",fill:{linearGradient:a,stops:[[0,"#FFF"],[1,"#ACF"]]}},f);o=f.style;delete f.style;g=E(e,{stroke:"#68A",fill:{linearGradient:a,stops:[[0,"#9BD"],[1,"#CDF"]]}},
	g);z=g.style;delete g.style;h=E(e,{style:{color:"#CCC"}},h);r=h.style;delete h.style;N(j.element,za?"mouseover":"mouseenter",function(){k!==3&&j.attr(f).css(o)});N(j.element,za?"mouseout":"mouseleave",function(){k!==3&&(l=[e,f,g][k],m=[n,o,z][k],j.attr(l).css(m))});j.setState=function(a){(j.state=k=a)?a===2?j.attr(g).css(z):a===3&&j.attr(h).css(r):j.attr(e).css(n)};return j.on("click",function(a){k!==3&&d.call(j,a)}).attr(e).css(x({cursor:"default"},n))},crispLine:function(a,b){a[1]===a[4]&&(a[1]=
	a[4]=C(a[1])-b%2/2);a[2]===a[5]&&(a[2]=a[5]=C(a[2])+b%2/2);return a},path:function(a){var b={fill:"none"};Fa(a)?b.d=a:$(a)&&x(b,a);return this.createElement("path").attr(b)},circle:function(a,b,c){a=$(a)?a:{x:a,y:b,r:c};b=this.createElement("circle");b.xSetter=b.ySetter=function(a,b,c){c.setAttribute("c"+b,a)};return b.attr(a)},arc:function(a,b,c,d,e,f){if($(a))b=a.y,c=a.r,d=a.innerR,e=a.start,f=a.end,a=a.x;a=this.symbol("arc",a||0,b||0,c||0,c||0,{innerR:d||0,start:e||0,end:f||0});a.r=c;return a},
	rect:function(a,b,c,d,e,f){var e=$(a)?a.r:e,g=this.createElement("rect"),a=$(a)?a:a===A?{}:{x:a,y:b,width:t(c,0),height:t(d,0)};if(f!==A)g.strokeWidth=f,a=g.crisp(a);if(e)a.r=e;g.rSetter=function(a,b,c){P(c,{rx:a,ry:a})};return g.attr(a)},setSize:function(a,b,c){var d=this.alignedObjects,e=d.length;this.width=a;this.height=b;for(this.boxWrapper[p(c,!0)?"animate":"attr"]({width:a,height:b});e--;)d[e].align()},g:function(a){var b=this.createElement("g");return s(a)?b.attr({"class":"highcharts-"+a}):
	b},image:function(a,b,c,d,e){var f={preserveAspectRatio:"none"};arguments.length>1&&x(f,{x:b,y:c,width:d,height:e});f=this.createElement("image").attr(f);f.element.setAttributeNS?f.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):f.element.setAttribute("hc-svg-href",a);return f},symbol:function(a,b,c,d,e,f){var g=this,h,i=this.symbols[a],i=i&&i(C(b),C(c),d,e,f),j=/^url\((.*?)\)$/,k,l;if(i)h=this.path(i),x(h,{symbolName:a,x:b,y:c,width:d,height:e}),f&&x(h,f);else if(j.test(a))l=function(a,
	b){a.element&&(a.attr({width:b[0],height:b[1]}),a.alignByTranslate||a.translate(C((d-b[0])/2),C((e-b[1])/2)))},k=a.match(j)[1],a=Ob[k]||f&&f.width&&f.height&&[f.width,f.height],h=this.image(k).attr({x:b,y:c}),h.isImg=!0,a?l(h,a):(h.attr({width:0,height:0}),da("img",{onload:function(){this.width===0&&(M(this,{position:"absolute",top:"-999em"}),y.body.appendChild(this));l(h,Ob[k]=[this.width,this.height]);this.parentNode&&this.parentNode.removeChild(this);g.imgCount--;if(!g.imgCount&&T[g.chartIndex].onload)T[g.chartIndex].onload()},
	src:k}),this.imgCount++);return h},symbols:{circle:function(a,b,c,d){var e=0.166*c;return[X,a+c/2,b,"C",a+c+e,b,a+c+e,b+d,a+c/2,b+d,"C",a-e,b+d,a-e,b,a+c/2,b,"Z"]},square:function(a,b,c,d){return[X,a,b,S,a+c,b,a+c,b+d,a,b+d,"Z"]},triangle:function(a,b,c,d){return[X,a+c/2,b,S,a+c,b+d,a,b+d,"Z"]},"triangle-down":function(a,b,c,d){return[X,a,b,S,a+c,b,a+c/2,b+d,"Z"]},diamond:function(a,b,c,d){return[X,a+c/2,b,S,a+c,b+d/2,a+c/2,b+d,a,b+d/2,"Z"]},arc:function(a,b,c,d,e){var f=e.start,c=e.r||c||d,g=e.end-
	0.001,d=e.innerR,h=e.open,i=W(f),j=ea(f),k=W(g),g=ea(g),e=e.end-f<ta?0:1;return[X,a+c*i,b+c*j,"A",c,c,0,e,1,a+c*k,b+c*g,h?X:S,a+d*k,b+d*g,"A",d,d,0,e,0,a+d*i,b+d*j,h?"":"Z"]},callout:function(a,b,c,d,e){var f=F(e&&e.r||0,c,d),g=f+6,h=e&&e.anchorX,e=e&&e.anchorY,i;i=["M",a+f,b,"L",a+c-f,b,"C",a+c,b,a+c,b,a+c,b+f,"L",a+c,b+d-f,"C",a+c,b+d,a+c,b+d,a+c-f,b+d,"L",a+f,b+d,"C",a,b+d,a,b+d,a,b+d-f,"L",a,b+f,"C",a,b,a,b,a+f,b];h&&h>c&&e>b+g&&e<b+d-g?i.splice(13,3,"L",a+c,e-6,a+c+6,e,a+c,e+6,a+c,b+d-f):h&&
	h<0&&e>b+g&&e<b+d-g?i.splice(33,3,"L",a,e+6,a-6,e,a,e-6,a,b+f):e&&e>d&&h>a+g&&h<a+c-g?i.splice(23,3,"L",h+6,b+d,h,b+d+6,h-6,b+d,a+f,b+d):e&&e<0&&h>a+g&&h<a+c-g&&i.splice(3,3,"L",h-6,b,h,b-6,h+6,b,c-f,b);return i}},clipRect:function(a,b,c,d){var e="highcharts-"+Bb++,f=this.createElement("clipPath").attr({id:e}).add(this.defs),a=this.rect(a,b,c,d,0).add(f);a.id=e;a.clipPath=f;a.count=0;return a},text:function(a,b,c,d){var e=la||!ga&&this.forExport,f={};if(d&&(this.allowHTML||!this.forExport))return this.html(a,
	b,c);f.x=Math.round(b||0);if(c)f.y=Math.round(c);if(a||a===0)f.text=a;a=this.createElement("text").attr(f);e&&a.css({position:"absolute"});if(!d)a.xSetter=function(a,b,c){var d=c.getElementsByTagName("tspan"),e,f=c.getAttribute(b),m;for(m=0;m<d.length;m++)e=d[m],e.getAttribute(b)===f&&e.setAttribute(b,a);c.setAttribute(b,a)};return a},fontMetrics:function(a,b){var c,d,a=a||this.style.fontSize;!a&&b&&D.getComputedStyle&&(b=b.element||b,a=(c=D.getComputedStyle(b,""))&&c.fontSize);a=/px/.test(a)?B(a):
	/em/.test(a)?parseFloat(a)*12:12;c=a<24?a+3:C(a*1.2);d=C(c*0.8);return{h:c,b:d,f:a}},rotCorr:function(a,b,c){var d=a;b&&c&&(d=t(d*W(b*ka),4));return{x:-a/3*ea(b*ka),y:d}},label:function(a,b,c,d,e,f,g,h,i){var j=this,k=j.g(i),l=j.text("",0,0,g).attr({zIndex:1}),m,n,o=0,z=3,r=0,p,w,v,La,qb=0,ba={},t,u,y,F,D;y=function(){var a,b;a=l.element.style;n=(p===void 0||w===void 0||k.styles.textAlign)&&s(l.textStr)&&l.getBBox();k.width=(p||n.width||0)+2*z+r;k.height=(w||n.height||0)+2*z;t=z+j.fontMetrics(a&&
	a.fontSize,l).b;if(u){if(!m)a=qb,b=(h?-t:0)+qb,k.box=m=j.symbols[d]?j.symbol(d,a,b,k.width,k.height,ba):j.rect(a,b,k.width,k.height,0,ba["stroke-width"]),m.isImg||m.attr("fill","none"),m.add(k);m.isImg||m.attr(x({width:C(k.width),height:C(k.height)},ba));ba=null}};F=function(){var a=k.styles,a=a&&a.textAlign,b=r+z,c;c=h?0:t;if(s(p)&&n&&(a==="center"||a==="right"))b+={center:0.5,right:1}[a]*(p-n.width);if(b!==l.x||c!==l.y)l.attr("x",b),c!==A&&l.attr("y",c);l.x=b;l.y=c};D=function(a,b){m?m.attr(a,b):
	ba[a]=b};k.onAdd=function(){l.add(k);k.attr({text:a||a===0?a:"",x:b,y:c});m&&s(e)&&k.attr({anchorX:e,anchorY:f})};k.widthSetter=function(a){p=a};k.heightSetter=function(a){w=a};k.paddingSetter=function(a){if(s(a)&&a!==z)z=k.padding=a,F()};k.paddingLeftSetter=function(a){s(a)&&a!==r&&(r=a,F())};k.alignSetter=function(a){a={left:0,center:0.5,right:1}[a];a!==o&&(o=a,n&&k.attr({x:v}))};k.textSetter=function(a){a!==A&&l.textSetter(a);y();F()};k["stroke-widthSetter"]=function(a,b){a&&(u=!0);qb=a%2/2;D(b,
	a)};k.strokeSetter=k.fillSetter=k.rSetter=function(a,b){b==="fill"&&a&&(u=!0);D(b,a)};k.anchorXSetter=function(a,b){e=a;D(b,C(a)-qb-v)};k.anchorYSetter=function(a,b){f=a;D(b,a-La)};k.xSetter=function(a){k.x=a;o&&(a-=o*((p||n.width)+2*z));v=C(a);k.attr("translateX",v)};k.ySetter=function(a){La=k.y=C(a);k.attr("translateY",La)};var B=k.css;return x(k,{css:function(a){if(a){var b={},a=E(a);q(k.textProps,function(c){a[c]!==A&&(b[c]=a[c],delete a[c])});l.css(b)}return B.call(k,a)},getBBox:function(){return{width:n.width+
	2*z,height:n.height+2*z,x:n.x-z,y:n.y-z}},shadow:function(a){m&&m.shadow(a);return k},destroy:function(){Y(k.element,"mouseenter");Y(k.element,"mouseleave");l&&(l=l.destroy());m&&(m=m.destroy());O.prototype.destroy.call(k);k=j=y=F=D=null}})}};eb=Ea;x(O.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&b.tagName==="SPAN"&&a.width)delete a.width,this.textWidth=b,this.updateTransform();if(a&&a.textOverflow==="ellipsis")a.whiteSpace="nowrap",a.overflow="hidden";this.styles=x(this.styles,a);M(this.element,
	a);return this},htmlGetBBox:function(){var a=this.element;if(a.nodeName==="text")a.style.position="absolute";return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,c=this.translateX||0,d=this.translateY||0,e=this.x||0,f=this.y||0,g=this.textAlign||"left",h={left:0,center:0.5,right:1}[g],i=this.shadows,j=this.styles;M(b,{marginLeft:c,marginTop:d});i&&q(i,function(a){M(a,{marginLeft:c+1,marginTop:d+
	1})});this.inverted&&q(b.childNodes,function(c){a.invertChild(c,b)});if(b.tagName==="SPAN"){var i=this.rotation,k=B(this.textWidth),l=j&&j.whiteSpace,m=[i,g,b.innerHTML,this.textWidth,this.textAlign].join(",");if(m!==this.cTT){j=a.fontMetrics(b.style.fontSize).b;s(i)&&this.setSpanRotation(i,h,j);M(b,{width:"",whiteSpace:l||"nowrap"});if(b.offsetWidth>k&&/[ \-]/.test(b.textContent||b.innerText))M(b,{width:k+"px",display:"block",whiteSpace:l||"normal"});this.getSpanCorrection(b.offsetWidth,j,h,i,g)}M(b,
	{left:e+(this.xCorr||0)+"px",top:f+(this.yCorr||0)+"px"});if(ob)j=b.offsetHeight;this.cTT=m}}else this.alignOnAdd=!0},setSpanRotation:function(a,b,c){var d={},e=za?"-ms-transform":ob?"-webkit-transform":Qa?"MozTransform":Mb?"-o-transform":"";d[e]=d.transform="rotate("+a+"deg)";d[e+(Qa?"Origin":"-origin")]=d.transformOrigin=b*100+"% "+c+"px";M(this.element,d)},getSpanCorrection:function(a,b,c){this.xCorr=-a*c;this.yCorr=-b}});x(Ea.prototype,{html:function(a,b,c){var d=this.createElement("span"),e=
	d.element,f=d.renderer,g=f.isSVG,h=function(a,b){q(["opacity","visibility"],function(c){hb(a,c+"Setter",function(a,c,d,e){a.call(this,c,d,e);b[d]=c})})};d.textSetter=function(a){a!==e.innerHTML&&delete this.bBox;e.innerHTML=this.textStr=a;d.htmlUpdateTransform()};g&&h(d,d.element.style);d.xSetter=d.ySetter=d.alignSetter=d.rotationSetter=function(a,b){b==="align"&&(b="textAlign");d[b]=a;d.htmlUpdateTransform()};d.attr({text:a,x:C(b),y:C(c)}).css({position:"absolute",fontFamily:this.style.fontFamily,
	fontSize:this.style.fontSize});e.style.whiteSpace="nowrap";d.css=d.htmlCss;if(g)d.add=function(a){var b,c=f.box.parentNode,g=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)g.push(a),a=a.parentGroup;q(g.reverse(),function(a){var d,e=P(a.element,"class");e&&(e={className:e});b=a.div=a.div||da(Pa,e,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",opacity:a.opacity},b||c);d=b.style;x(a,{translateXSetter:function(b,c){d.left=b+"px";a[c]=b;a.doTransform=!0},translateYSetter:function(b,
	c){d.top=b+"px";a[c]=b;a.doTransform=!0}});h(a,d)})}}else b=c;b.appendChild(e);d.added=!0;d.alignOnAdd&&d.htmlUpdateTransform();return d};return d}});var K;if(!ga&&!la){K={init:function(a,b){var c=["<",b,' filled="f" stroked="f"'],d=["position: ","absolute",";"],e=b===Pa;(b==="shape"||e)&&d.push("left:0;top:0;width:1px;height:1px;");d.push("visibility: ",e?"hidden":"visible");c.push(' style="',d.join(""),'"/>');if(b)c=e||b==="span"||b==="img"?c.join(""):a.prepVML(c),this.element=da(c);this.renderer=
	a},add:function(a){var b=this.renderer,c=this.element,d=b.box,e=a&&a.inverted,d=a?a.element||a:d;if(a)this.parentGroup=a;e&&b.invertChild(c,d);d.appendChild(c);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();return this},updateTransform:O.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,b=W(a*ka),c=ea(a*ka);M(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11=",b,", M12=",-c,", M21=",c,", M22=",
	b,", sizingMethod='auto expand')"].join(""):"none"})},getSpanCorrection:function(a,b,c,d,e){var f=d?W(d*ka):1,g=d?ea(d*ka):0,h=p(this.elemHeight,this.element.offsetHeight),i;this.xCorr=f<0&&-a;this.yCorr=g<0&&-h;i=f*g<0;this.xCorr+=g*b*(i?1-c:c);this.yCorr-=f*b*(d?i?c:1-c:1);e&&e!=="left"&&(this.xCorr-=a*c*(f<0?-1:1),d&&(this.yCorr-=h*c*(g<0?-1:1)),M(this.element,{textAlign:e}))},pathToVML:function(a){for(var b=a.length,c=[];b--;)if(J(a[b]))c[b]=C(a[b]*10)-5;else if(a[b]==="Z")c[b]="x";else if(c[b]=
	a[b],a.isArc&&(a[b]==="wa"||a[b]==="at"))c[b+5]===c[b+7]&&(c[b+7]+=a[b+7]>a[b+5]?1:-1),c[b+6]===c[b+8]&&(c[b+8]+=a[b+8]>a[b+6]?1:-1);return c.join(" ")||"x"},clip:function(a){var b=this,c;a?(c=a.members,ra(c,b),c.push(b),b.destroyClip=function(){ra(c,b)},a=a.getCSS(b)):(b.destroyClip&&b.destroyClip(),a={clip:nb?"inherit":"rect(auto)"});return b.css(a)},css:O.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&Ua(a)},destroy:function(){this.destroyClip&&this.destroyClip();return O.prototype.destroy.apply(this)},
	on:function(a,b){this.element["on"+a]=function(){var a=D.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,b){var c,a=a.split(/[ ,]/);c=a.length;if(c===9||c===11)a[c-4]=a[c-2]=B(a[c-2])-10*b;return a.join(" ")},shadow:function(a,b,c){var d=[],e,f=this.element,g=this.renderer,h,i=f.style,j,k=f.path,l,m,n,o;k&&typeof k.value!=="string"&&(k="x");m=k;if(a){n=p(a.width,3);o=(a.opacity||0.15)/n;for(e=1;e<=3;e++){l=n*2+1-2*e;c&&(m=this.cutOffPath(k.value,l+0.5));j=['<shape isShadow="true" strokeweight="',
	l,'" filled="false" path="',m,'" coordsize="10 10" style="',f.style.cssText,'" />'];h=da(g.prepVML(j),null,{left:B(i.left)+p(a.offsetX,1),top:B(i.top)+p(a.offsetY,1)});if(c)h.cutOff=l+1;j=['<stroke color="',a.color||"black",'" opacity="',o*e,'"/>'];da(g.prepVML(j),null,null,h);b?b.element.appendChild(h):f.parentNode.insertBefore(h,f);d.push(h)}this.shadows=d}return this},updateShadows:Ba,setAttr:function(a,b){nb?this.element[a]=b:this.element.setAttribute(a,b)},classSetter:function(a){this.element.className=
	a},dashstyleSetter:function(a,b,c){(c.getElementsByTagName("stroke")[0]||da(this.renderer.prepVML(["<stroke/>"]),null,null,c))[b]=a||"solid";this[b]=a},dSetter:function(a,b,c){var d=this.shadows,a=a||[];this.d=a.join&&a.join(" ");c.path=a=this.pathToVML(a);if(d)for(c=d.length;c--;)d[c].path=d[c].cutOff?this.cutOffPath(a,d[c].cutOff):a;this.setAttr(b,a)},fillSetter:function(a,b,c){var d=c.nodeName;if(d==="SPAN")c.style.color=a;else if(d!=="IMG")c.filled=a!=="none",this.setAttr("fillcolor",this.renderer.color(a,
	c,b,this))},"fill-opacitySetter":function(a,b,c){da(this.renderer.prepVML(["<",b.split("-")[0],' opacity="',a,'"/>']),null,null,c)},opacitySetter:Ba,rotationSetter:function(a,b,c){c=c.style;this[b]=c[b]=a;c.left=-C(ea(a*ka)+1)+"px";c.top=C(W(a*ka))+"px"},strokeSetter:function(a,b,c){this.setAttr("strokecolor",this.renderer.color(a,c,b,this))},"stroke-widthSetter":function(a,b,c){c.stroked=!!a;this[b]=a;J(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,
	b,c){a==="inherit"&&(a="visible");this.shadows&&q(this.shadows,function(c){c.style[b]=a});c.nodeName==="DIV"&&(a=a==="hidden"?"-999em":0,nb||(c.style[b]=a?"visible":"hidden"),b="top");c.style[b]=a},xSetter:function(a,b,c){this[b]=a;b==="x"?b="left":b==="y"&&(b="top");this.updateClipping?(this[b]=a,this.updateClipping()):c.style[b]=a},zIndexSetter:function(a,b,c){c.style[b]=a}};K["stroke-opacitySetter"]=K["fill-opacitySetter"];u.VMLElement=K=sa(O,K);K.prototype.ySetter=K.prototype.widthSetter=K.prototype.heightSetter=
	K.prototype.xSetter;var Db={Element:K,isIE8:Aa.indexOf("MSIE 8.0")>-1,init:function(a,b,c,d){var e;this.alignedObjects=[];d=this.createElement(Pa).css(x(this.getStyle(d),{position:"relative"}));e=d.element;a.appendChild(d.element);this.isVML=!0;this.box=e;this.boxWrapper=d;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,c,!1);if(!y.namespaces.hcv){y.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{y.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(f){y.styleSheets[0].cssText+=
	"hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},isHidden:function(){return!this.box.offsetWidth},clipRect:function(a,b,c,d){var e=this.createElement(),f=$(a);return x(e,{members:[],count:0,left:(f?a.x:a)+1,top:(f?a.y:b)+1,width:(f?a.width:c)-1,height:(f?a.height:d)-1,getCSS:function(a){var b=a.element,c=b.nodeName,a=a.inverted,d=this.top-(c==="shape"?b.offsetTop:0),e=this.left,b=e+this.width,f=d+this.height,d={clip:"rect("+C(a?e:d)+"px,"+
	C(a?f:b)+"px,"+C(a?b:f)+"px,"+C(a?d:e)+"px)"};!a&&nb&&c==="DIV"&&x(d,{width:b+"px",height:f+"px"});return d},updateClipping:function(){q(e.members,function(a){a.element&&a.css(e.getCSS(a))})}})},color:function(a,b,c,d){var e=this,f,g=/^rgba/,h,i,j="none";a&&a.linearGradient?i="gradient":a&&a.radialGradient&&(i="pattern");if(i){var k,l,m=a.linearGradient||a.radialGradient,n,o,z,r,p,w="",a=a.stops,v,s=[],t=function(){h=['<fill colors="'+s.join(",")+'" opacity="',z,'" o:opacity2="',o,'" type="',i,'" ',
	w,'focus="100%" method="any" />'];da(e.prepVML(h),null,null,b)};n=a[0];v=a[a.length-1];n[0]>0&&a.unshift([0,n[1]]);v[0]<1&&a.push([1,v[1]]);q(a,function(a,b){g.test(a[1])?(f=na(a[1]),k=f.get("rgb"),l=f.get("a")):(k=a[1],l=1);s.push(a[0]*100+"% "+k);b?(z=l,r=k):(o=l,p=k)});if(c==="fill")if(i==="gradient")c=m.x1||m[0]||0,a=m.y1||m[1]||0,n=m.x2||m[2]||0,m=m.y2||m[3]||0,w='angle="'+(90-Z.atan((m-a)/(n-c))*180/ta)+'"',t();else{var j=m.r,ba=j*2,x=j*2,u=m.cx,A=m.cy,C=b.radialReference,y,j=function(){C&&
	(y=d.getBBox(),u+=(C[0]-y.x)/y.width-0.5,A+=(C[1]-y.y)/y.height-0.5,ba*=C[2]/y.width,x*=C[2]/y.height);w='src="'+U.global.VMLRadialGradientURL+'" size="'+ba+","+x+'" origin="0.5,0.5" position="'+u+","+A+'" color2="'+p+'" ';t()};d.added?j():d.onAdd=j;j=r}else j=k}else if(g.test(a)&&b.tagName!=="IMG")f=na(a),d[c+"-opacitySetter"](f.get("a"),c,b),j=f.get("rgb");else{j=b.getElementsByTagName(c);if(j.length)j[0].opacity=1,j[0].type="solid";j=a}return j},prepVML:function(a){var b=this.isIE8,a=a.join("");
	b?(a=a.replace("/>",' xmlns="urn:schemas-microsoft-com:vml" />'),a=a.indexOf('style="')===-1?a.replace("/>",' style="display:inline-block;behavior:url(#default#VML);" />'):a.replace('style="','style="display:inline-block;behavior:url(#default#VML);')):a=a.replace("<","<hcv:");return a},text:Ea.prototype.html,path:function(a){var b={coordsize:"10 10"};Fa(a)?b.d=a:$(a)&&x(b,a);return this.createElement("shape").attr(b)},circle:function(a,b,c){var d=this.symbol("circle");if($(a))c=a.r,b=a.y,a=a.x;d.isCircle=
	!0;d.r=c;return d.attr({x:a,y:b})},g:function(a){var b;a&&(b={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement(Pa).attr(b)},image:function(a,b,c,d,e){var f=this.createElement("img").attr({src:a});arguments.length>1&&f.attr({x:b,y:c,width:d,height:e});return f},createElement:function(a){return a==="rect"?this.symbol(a):Ea.prototype.createElement.call(this,a)},invertChild:function(a,b){var c=this,d=b.style,e=a.tagName==="IMG"&&a.style;M(a,{flip:"x",left:B(d.width)-(e?B(e.top):
	1),top:B(d.height)-(e?B(e.left):1),rotation:-90});q(a.childNodes,function(b){c.invertChild(b,a)})},symbols:{arc:function(a,b,c,d,e){var f=e.start,g=e.end,h=e.r||c||d,c=e.innerR,d=W(f),i=ea(f),j=W(g),k=ea(g);if(g-f===0)return["x"];f=["wa",a-h,b-h,a+h,b+h,a+h*d,b+h*i,a+h*j,b+h*k];e.open&&!c&&f.push("e",X,a,b);f.push("at",a-c,b-c,a+c,b+c,a+c*j,b+c*k,a+c*d,b+c*i,"x","e");f.isArc=!0;return f},circle:function(a,b,c,d,e){e&&(c=d=2*e.r);e&&e.isCircle&&(a-=c/2,b-=d/2);return["wa",a,b,a+c,b+d,a+c,b+d/2,a+c,
	b+d/2,"e"]},rect:function(a,b,c,d,e){return Ea.prototype.symbols[!s(e)||!e.r?"square":"callout"].call(0,a,b,c,d,e)}}};u.VMLRenderer=K=function(){this.init.apply(this,arguments)};K.prototype=E(Ea.prototype,Db);eb=K}Ea.prototype.measureSpanWidth=function(a,b){var c=y.createElement("span"),d;d=y.createTextNode(a);c.appendChild(d);M(c,b);this.box.appendChild(c);d=c.offsetWidth;Ua(c);return d};var Pb;if(la)u.CanVGRenderer=K=function(){Ia="http://www.w3.org/1999/xhtml"},K.prototype.symbols={},Pb=function(){function a(){var a=
	b.length,d;for(d=0;d<a;d++)b[d]();b=[]}var b=[];return{push:function(c,d){if(b.length===0){var e=y.getElementsByTagName("head")[0],f=y.createElement("script");f.type="text/javascript";f.src=d;f.onload=a;e.appendChild(f)}b.push(c)}}}(),eb=K;Xa.prototype={addLabel:function(){var a=this.axis,b=a.options,c=a.chart,d=a.categories,e=a.names,f=this.pos,g=b.labels,h=a.tickPositions,i=f===h[0],j=f===h[h.length-1],e=d?p(d[f],e[f],f):f,d=this.label,h=h.info,k;a.isDatetimeAxis&&h&&(k=b.dateTimeLabelFormats[h.higherRanks[f]||
	h.unitName]);this.isFirst=i;this.isLast=j;b=a.labelFormatter.call({axis:a,chart:c,isFirst:i,isLast:j,dateTimeLabelFormat:k,value:a.isLog?aa(a.lin2log(e)):e});s(d)?d&&d.attr({text:b}):(this.labelLength=(this.label=d=s(b)&&g.enabled?c.renderer.text(b,0,0,g.useHTML).css(E(g.style)).add(a.labelGroup):null)&&d.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var b=this.axis,c=a.x,d=b.chart.chartWidth,
	e=b.chart.spacing,f=p(b.labelLeft,F(b.pos,e[3])),e=p(b.labelRight,t(b.pos+b.len,d-e[1])),g=this.label,h=this.rotation,i={left:0,center:0.5,right:1}[b.labelAlign],j=g.getBBox().width,k=b.getSlotWidth(),l=k,m=1,n,o={};if(h)h<0&&c-i*j<f?n=C(c/W(h*ka)-f):h>0&&c+i*j>e&&(n=C((d-c)/W(h*ka)));else if(d=c+(1-i)*j,c-i*j<f?l=a.x+l*(1-i)-f:d>e&&(l=e-a.x+l*i,m=-1),l=F(k,l),l<k&&b.labelAlign==="center"&&(a.x+=m*(k-l-i*(k-F(j,l)))),j>l||b.autoRotation&&g.styles.width)n=l;if(n){o.width=n;if(!b.options.labels.style.textOverflow)o.textOverflow=
	"ellipsis";g.css(o)}},getPosition:function(a,b,c,d){var e=this.axis,f=e.chart,g=d&&f.oldChartHeight||f.chartHeight;return{x:a?e.translate(b+c,null,null,d)+e.transB:e.left+e.offset+(e.opposite?(d&&f.oldChartWidth||f.chartWidth)-e.right-e.left:0),y:a?g-e.bottom+e.offset-(e.opposite?e.height:0):g-e.translate(b+c,null,null,d)-e.transB}},getLabelPosition:function(a,b,c,d,e,f,g,h){var i=this.axis,j=i.transA,k=i.reversed,l=i.staggerLines,m=i.tickRotCorr||{x:0,y:0},n=e.y;s(n)||(n=i.side===0?c.rotation?-8:
	-c.getBBox().height:i.side===2?m.y+8:W(c.rotation*ka)*(m.y-c.getBBox(!1,0).height/2));a=a+e.x+m.x-(f&&d?f*j*(k?-1:1):0);b=b+n-(f&&!d?f*j*(k?1:-1):0);l&&(c=g/(h||1)%l,i.opposite&&(c=l-c-1),b+=c*(i.labelOffset/l));return{x:a,y:C(b)}},getMarkPath:function(a,b,c,d,e,f){return f.crispLine([X,a,b,S,a+(e?0:-c),b+(e?c:0)],d)},render:function(a,b,c){var d=this.axis,e=d.options,f=d.chart.renderer,g=d.horiz,h=this.type,i=this.label,j=this.pos,k=e.labels,l=this.gridLine,m=h?h+"Grid":"grid",n=h?h+"Tick":"tick",
	o=e[m+"LineWidth"],z=e[m+"LineColor"],r=e[m+"LineDashStyle"],m=d.tickSize(n),n=e[n+"Color"],q=this.mark,w=k.step,v=!0,s=d.tickmarkOffset,t=this.getPosition(g,j,s,b),ba=t.x,t=t.y,x=g&&ba===d.pos+d.len||!g&&t===d.pos?-1:1,c=p(c,1);this.isActive=!0;if(o){j=d.getPlotLinePath(j+s,o*x,b,!0);if(l===A){l={stroke:z,"stroke-width":o};if(r)l.dashstyle=r;if(!h)l.zIndex=1;if(b)l.opacity=0;this.gridLine=l=o?f.path(j).attr(l).add(d.gridGroup):null}if(!b&&l&&j)l[this.isNew?"attr":"animate"]({d:j,opacity:c})}if(m)d.opposite&&
	(m[0]=-m[0]),h=this.getMarkPath(ba,t,m[0],m[1]*x,g,f),q?q.animate({d:h,opacity:c}):this.mark=f.path(h).attr({stroke:n,"stroke-width":m[1],opacity:c}).add(d.axisGroup);if(i&&J(ba))i.xy=t=this.getLabelPosition(ba,t,i,g,k,s,a,w),this.isFirst&&!this.isLast&&!p(e.showFirstLabel,1)||this.isLast&&!this.isFirst&&!p(e.showLastLabel,1)?v=!1:g&&!d.isRadial&&!k.step&&!k.rotation&&!b&&c!==0&&this.handleOverflow(t),w&&a%w&&(v=!1),v&&J(t.y)?(t.opacity=c,i[this.isNew?"attr":"animate"](t)):(Ka(i),i.attr("y",-9999)),
	this.isNew=!1},destroy:function(){Ta(this,this.axis)}};u.PlotLineOrBand=function(a,b){this.axis=a;if(b)this.options=b,this.id=b.id};u.PlotLineOrBand.prototype={render:function(){var a=this,b=a.axis,c=b.horiz,d=a.options,e=d.label,f=a.label,g=d.width,h=d.to,i=d.from,j=s(i)&&s(h),k=d.value,l=d.dashStyle,m=a.svgElem,n=[],o,z=d.color,r=p(d.zIndex,0),q=d.events,w={},v=b.chart.renderer,n=b.log2lin;b.isLog&&(i=n(i),h=n(h),k=n(k));if(g){if(n=b.getPlotLinePath(k,g),w={stroke:z,"stroke-width":g},l)w.dashstyle=
	l}else if(j){n=b.getPlotBandPath(i,h,d);if(z)w.fill=z;if(d.borderWidth)w.stroke=d.borderColor,w["stroke-width"]=d.borderWidth}else return;w.zIndex=r;if(m)if(n)m.show(),m.animate({d:n});else{if(m.hide(),f)a.label=f=f.destroy()}else if(n&&n.length&&(a.svgElem=m=v.path(n).attr(w).add(),q))for(o in d=function(b){m.on(b,function(c){q[b].apply(a,[c])})},q)d(o);e&&s(e.text)&&n&&n.length&&b.width>0&&b.height>0&&!n.flat?(e=E({align:c&&j&&"center",x:c?!j&&4:10,verticalAlign:!c&&j&&"middle",y:c?j?16:10:j?6:
	-4,rotation:c&&!j&&90},e),this.renderLabel(e,n,j,r)):f&&f.hide();return a},renderLabel:function(a,b,c,d){var e=this.label,f=this.axis.chart.renderer;if(!e)e={align:a.textAlign||a.align,rotation:a.rotation},e.zIndex=d,this.label=e=f.text(a.text,0,0,a.useHTML).attr(e).css(a.style).add();d=[b[1],b[4],c?b[6]:b[1]];b=[b[2],b[5],c?b[7]:b[2]];c=Oa(d);f=Oa(b);e.align(a,!1,{x:c,y:f,width:Ha(d)-c,height:Ha(b)-f});e.show()},destroy:function(){ra(this.axis.plotLinesAndBands,this);delete this.axis;Ta(this)}};
	var ia=u.Axis=function(){this.init.apply(this,arguments)};ia.prototype={defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,gridLineColor:"#D8D8D8",labels:{enabled:!0,style:{color:"#606060",cursor:"default",fontSize:"11px"},x:0},lineColor:"#C0D0E0",lineWidth:1,minPadding:0.01,maxPadding:0.01,minorGridLineColor:"#E0E0E0",minorGridLineWidth:1,minorTickColor:"#A0A0A0",minorTickLength:2,
	minorTickPosition:"outside",startOfWeek:1,startOnTick:!1,tickColor:"#C0D0E0",tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",title:{align:"middle",style:{color:"#707070"}},type:"linear"},defaultYAxisOptions:{endOnTick:!0,gridLineWidth:1,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},lineWidth:0,maxPadding:0.05,minPadding:0.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{enabled:!1,formatter:function(){return u.numberFormat(this.total,-1)},
	style:E(fa.line.dataLabels.style,{color:"#000000"})}},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,b){var c=b.isX;this.chart=a;this.horiz=a.inverted?!c:c;this.coll=(this.isXAxis=c)?"xAxis":"yAxis";this.opposite=b.opposite;this.side=b.side||(this.horiz?this.opposite?
	0:2:this.opposite?1:3);this.setOptions(b);var d=this.options,e=d.type;this.labelFormatter=d.labels.formatter||this.defaultLabelFormatter;this.userOptions=b;this.minPixelPadding=0;this.reversed=d.reversed;this.visible=d.visible!==!1;this.zoomEnabled=d.zoomEnabled!==!1;this.categories=d.categories||e==="category";this.names=this.names||[];this.isLog=e==="logarithmic";this.isDatetimeAxis=e==="datetime";this.isLinked=s(d.linkedTo);this.ticks={};this.labelEdge=[];this.minorTicks={};this.plotLinesAndBands=
	[];this.alternateBands={};this.len=0;this.minRange=this.userMinRange=d.minRange||d.maxZoom;this.range=d.range;this.offset=d.offset||0;this.stacks={};this.oldStacks={};this.stacksTouched=0;this.min=this.max=null;this.crosshair=p(d.crosshair,ua(a.options.tooltip.crosshairs)[c?0:1],!1);var f,d=this.options.events;pa(this,a.axes)===-1&&(c&&!this.isColorAxis?a.axes.splice(a.xAxis.length,0,this):a.axes.push(this),a[this.coll].push(this));this.series=this.series||[];if(a.inverted&&c&&this.reversed===A)this.reversed=
	!0;this.removePlotLine=this.removePlotBand=this.removePlotBandOrLine;for(f in d)N(this,f,d[f]);if(this.isLog)this.val2lin=this.log2lin,this.lin2val=this.lin2log},setOptions:function(a){this.options=E(this.defaultOptions,this.isXAxis?{}:this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],E(U[this.coll],a))},defaultLabelFormatter:function(){var a=this.axis,b=this.value,c=a.categories,d=this.dateTimeLabelFormat,
	e=U.lang.numericSymbols,f=e&&e.length,g,h=a.options.labels.format,a=a.isLog?b:a.tickInterval;if(h)g=Na(h,this);else if(c)g=b;else if(d)g=Sa(d,b);else if(f&&a>=1E3)for(;f--&&g===A;)c=Math.pow(1E3,f+1),a>=c&&b*10%c===0&&e[f]!==null&&b!==0&&(g=u.numberFormat(b/c,-1)+e[f]);g===A&&(g=Q(b)>=1E4?u.numberFormat(b,-1):u.numberFormat(b,-1,A,""));return g},getSeriesExtremes:function(){var a=this,b=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();
	q(a.series,function(c){if(c.visible||!b.options.chart.ignoreHiddenSeries){var d=c.options,e=d.threshold,f;a.hasVisibleSeries=!0;a.isLog&&e<=0&&(e=null);if(a.isXAxis){if(d=c.xData,d.length)c=Oa(d),!J(c)&&!(c instanceof ma)&&(d=Ca(d,function(a){return J(a)}),c=Oa(d)),a.dataMin=F(p(a.dataMin,d[0]),c),a.dataMax=t(p(a.dataMax,d[0]),Ha(d))}else{c.getExtremes();f=c.dataMax;c=c.dataMin;if(s(c)&&s(f))a.dataMin=F(p(a.dataMin,c),c),a.dataMax=t(p(a.dataMax,f),f);if(s(e))a.threshold=e;if(!d.softThreshold||a.isLog)a.softThreshold=
	!1}}})},translate:function(a,b,c,d,e,f){var g=this.linkedParent||this,h=1,i=0,j=d?g.oldTransA:g.transA,d=d?g.oldMin:g.min,k=g.minPixelPadding,e=(g.isOrdinal||g.isBroken||g.isLog&&e)&&g.lin2val;if(!j)j=g.transA;if(c)h*=-1,i=g.len;g.reversed&&(h*=-1,i-=h*(g.sector||g.len));b?(a=a*h+i,a-=k,a=a/j+d,e&&(a=g.lin2val(a))):(e&&(a=g.val2lin(a)),f==="between"&&(f=0.5),a=h*(a-d)*j+i+h*k+(J(f)?j*f*g.pointRange:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},
	toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,d,e){var f=this.chart,g=this.left,h=this.top,i,j,k=c&&f.oldChartHeight||f.chartHeight,l=c&&f.oldChartWidth||f.chartWidth,m;i=this.transB;var n=function(a,b,c){if(a<b||a>c)d?a=F(t(b,a),c):m=!0;return a},e=p(e,this.translate(a,null,null,c)),a=c=C(e+i);i=j=C(k-e-i);J(e)?this.horiz?(i=h,j=k-this.bottom,a=c=n(a,g,g+this.width)):(a=g,c=l-this.right,i=j=n(i,h,h+this.height)):m=!0;return m&&
	!d?null:f.renderer.crispLine([X,a,i,S,c,j],b||1)},getLinearTickPositions:function(a,b,c){var d,e=aa(V(b/a)*a),f=aa(va(c/a)*a),g=[];if(b===c&&J(b))return[b];for(b=e;b<=f;){g.push(b);b=aa(b+a);if(b===d)break;d=b}return g},getMinorTickPositions:function(){var a=this.options,b=this.tickPositions,c=this.minorTickInterval,d=[],e,f=this.pointRangePadding||0;e=this.min-f;var f=this.max+f,g=f-e;if(g&&g/c<this.len/3)if(this.isLog){f=b.length;for(e=1;e<f;e++)d=d.concat(this.getLogTickPositions(c,b[e-1],b[e],
	!0))}else if(this.isDatetimeAxis&&a.minorTickInterval==="auto")d=d.concat(this.getTimeTicks(this.normalizeTimeTickInterval(c),e,f,a.startOfWeek));else for(b=e+(b[0]-e)%c;b<=f;b+=c)d.push(b);d.length!==0&&this.trimTicks(d,a.startOnTick,a.endOnTick);return d},adjustForMinRange:function(){var a=this.options,b=this.min,c=this.max,d,e=this.dataMax-this.dataMin>=this.minRange,f,g,h,i,j,k;if(this.isXAxis&&this.minRange===A&&!this.isLog)s(a.min)||s(a.max)?this.minRange=null:(q(this.series,function(a){i=a.xData;
	for(g=j=a.xIncrement?1:i.length-1;g>0;g--)if(h=i[g]-i[g-1],f===A||h<f)f=h}),this.minRange=F(f*5,this.dataMax-this.dataMin));if(c-b<this.minRange){k=this.minRange;d=(k-c+b)/2;d=[b-d,p(a.min,b-d)];if(e)d[2]=this.dataMin;b=Ha(d);c=[b+k,p(a.max,b+k)];if(e)c[2]=this.dataMax;c=Oa(c);c-b<k&&(d[0]=c-k,d[1]=p(a.min,c-k),b=Ha(d))}this.min=b;this.max=c},getClosest:function(){var a;this.categories?a=1:q(this.series,function(b){var c=b.closestPointRange;!b.noSharedTooltip&&s(c)&&(a=s(a)?F(a,c):c)});return a},
	setAxisTranslation:function(a){var b=this,c=b.max-b.min,d=b.axisPointRange||0,e,f=0,g=0,h=b.linkedParent,i=!!b.categories,j=b.transA,k=b.isXAxis;if(k||i||d)if(h?(f=h.minPointOffset,g=h.pointRangePadding):(e=b.getClosest(),q(b.series,function(a){var c=i?1:k?p(a.options.pointRange,e,0):b.axisPointRange||0,a=a.options.pointPlacement;d=t(d,c);b.single||(f=t(f,ya(a)?0:c/2),g=t(g,a==="on"?0:c))})),h=b.ordinalSlope&&e?b.ordinalSlope/e:1,b.minPointOffset=f*=h,b.pointRangePadding=g*=h,b.pointRange=F(d,c),
	k)b.closestPointRange=e;if(a)b.oldTransA=j;b.translationSlope=b.transA=j=b.len/(c+g||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=j*f},minFromRange:function(){return this.max-this.range},setTickInterval:function(a){var b=this,c=b.chart,d=b.options,e=b.isLog,f=b.log2lin,g=b.isDatetimeAxis,h=b.isXAxis,i=b.isLinked,j=d.maxPadding,k=d.minPadding,l=d.tickInterval,m=d.tickPixelInterval,n=b.categories,o=b.threshold,z=b.softThreshold,r,G,w,v;!g&&!n&&!i&&this.getTickAmount();w=p(b.userMin,d.min);
	v=p(b.userMax,d.max);i?(b.linkedParent=c[b.coll][d.linkedTo],c=b.linkedParent.getExtremes(),b.min=p(c.min,c.dataMin),b.max=p(c.max,c.dataMax),d.type!==b.linkedParent.options.type&&ca(11,1)):(!z&&s(o)&&(b.dataMin>=o?(r=o,k=0):b.dataMax<=o&&(G=o,j=0)),b.min=p(w,r,b.dataMin),b.max=p(v,G,b.dataMax));if(e)!a&&F(b.min,p(b.dataMin,b.min))<=0&&ca(10,1),b.min=aa(f(b.min),15),b.max=aa(f(b.max),15);if(b.range&&s(b.max))b.userMin=b.min=w=t(b.min,b.minFromRange()),b.userMax=v=b.max,b.range=null;I(b,"foundExtremes");
	b.beforePadding&&b.beforePadding();b.adjustForMinRange();if(!n&&!b.axisPointRange&&!b.usePercentage&&!i&&s(b.min)&&s(b.max)&&(f=b.max-b.min))!s(w)&&k&&(b.min-=f*k),!s(v)&&j&&(b.max+=f*j);if(J(d.floor))b.min=t(b.min,d.floor);if(J(d.ceiling))b.max=F(b.max,d.ceiling);if(z&&s(b.dataMin))if(o=o||0,!s(w)&&b.min<o&&b.dataMin>=o)b.min=o;else if(!s(v)&&b.max>o&&b.dataMax<=o)b.max=o;b.tickInterval=b.min===b.max||b.min===void 0||b.max===void 0?1:i&&!l&&m===b.linkedParent.options.tickPixelInterval?l=b.linkedParent.tickInterval:
	p(l,this.tickAmount?(b.max-b.min)/t(this.tickAmount-1,1):void 0,n?1:(b.max-b.min)*m/t(b.len,m));h&&!a&&q(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();if(b.postProcessTickInterval)b.tickInterval=b.postProcessTickInterval(b.tickInterval);if(b.pointRange&&!l)b.tickInterval=t(b.pointRange,b.tickInterval);a=p(d.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);if(!l&&b.tickInterval<a)b.tickInterval=
	a;if(!g&&!e&&!l)b.tickInterval=vb(b.tickInterval,null,ub(b.tickInterval),p(d.allowDecimals,!(b.tickInterval>0.5&&b.tickInterval<5&&b.max>1E3&&b.max<9999)),!!this.tickAmount);if(!this.tickAmount&&this.len)b.tickInterval=b.unsquish();this.setTickPositions()},setTickPositions:function(){var a=this.options,b,c=a.tickPositions,d=a.tickPositioner,e=a.startOnTick,f=a.endOnTick,g;this.tickmarkOffset=this.categories&&a.tickmarkPlacement==="between"&&this.tickInterval===1?0.5:0;this.minorTickInterval=a.minorTickInterval===
	"auto"&&this.tickInterval?this.tickInterval/5:a.minorTickInterval;this.tickPositions=b=c&&c.slice();if(!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()]),this.tickPositions=b,d&&(d=d.apply(this,
	[this.min,this.max]))))this.tickPositions=b=d;if(!this.isLinked)this.trimTicks(b,e,f),this.min===this.max&&s(this.min)&&!this.tickAmount&&(g=!0,this.min-=0.5,this.max+=0.5),this.single=g,!c&&!d&&this.adjustTickAmount()},trimTicks:function(a,b,c){var d=a[0],e=a[a.length-1],f=this.minPointOffset||0;if(b)this.min=d;else for(;this.min-f>a[0];)a.shift();if(c)this.max=e;else for(;this.max+f<a[a.length-1];)a.pop();a.length===0&&s(d)&&a.push((e+d)/2)},alignToOthers:function(){var a={},b,c=this.options;this.chart.options.chart.alignTicks!==
	!1&&c.alignTicks!==!1&&q(this.chart[this.coll],function(c){var e=c.options,e=[c.horiz?e.left:e.top,e.width,e.height,e.pane].join(",");c.series.length&&(a[e]?b=!0:a[e]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,c=a.tickPixelInterval;!s(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=va(this.len/c)+1);if(b<4)this.finalTickAmt=b,b=5;this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,
	b=this.tickPositions,c=this.tickAmount,d=this.finalTickAmt,e=b&&b.length;if(e<c){for(;b.length<c;)b.push(aa(b[b.length-1]+a));this.transA*=(e-1)/(c-1);this.max=b[b.length-1]}else e>c&&(this.tickInterval*=2,this.setTickPositions());if(s(d)){for(a=c=b.length;a--;)(d===3&&a%2===1||d<=2&&a>0&&a<c-1)&&b.splice(a,1);this.finalTickAmt=A}},setScale:function(){var a,b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;q(this.series,function(b){if(b.isDirtyData||
	b.isDirty||b.xAxis.isDirty)a=!0});if(b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()){if(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,!this.isDirty)this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax}else this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,b,c,d,e){var f=this,g=f.chart,
	c=p(c,!0);q(f.series,function(a){delete a.kdTree});e=x(e,{min:a,max:b});I(f,"setExtremes",e,function(){f.userMin=a;f.userMax=b;f.eventArgs=e;c&&g.redraw(d)})},zoom:function(a,b){var c=this.dataMin,d=this.dataMax,e=this.options,f=F(c,p(e.min,c)),e=t(d,p(e.max,d));this.allowZoomOutside||(s(c)&&a<=f&&(a=f),s(d)&&b>=e&&(b=e));this.displayBtn=a!==A||b!==A;this.setExtremes(a,b,!1,A,{trigger:"zoom"});return!0},setAxisSize:function(){var a=this.chart,b=this.options,c=b.offsetLeft||0,d=this.horiz,e=p(b.width,
	a.plotWidth-c+(b.offsetRight||0)),f=p(b.height,a.plotHeight),g=p(b.top,a.plotTop),b=p(b.left,a.plotLeft+c),c=/%$/;c.test(f)&&(f=Math.round(parseFloat(f)/100*a.plotHeight));c.test(g)&&(g=Math.round(parseFloat(g)/100*a.plotHeight+a.plotTop));this.left=b;this.top=g;this.width=e;this.height=f;this.bottom=a.chartHeight-f-g;this.right=a.chartWidth-e-b;this.len=t(d?e:f,0);this.pos=d?b:g},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?aa(b(this.min)):this.min,max:a?aa(b(this.max)):this.max,
	dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,c=this.lin2log,d=b?c(this.min):this.min,b=b?c(this.max):this.max;a===null?a=d:d>a?a=d:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(p(a,0)-this.side*90+720)%360;return a>15&&a<165?"right":a>195&&a<345?"left":"center"},tickSize:function(a){var b=this.options,c=b[a+"Length"],d=p(b[a+"Width"],a==="tick"&&this.isXAxis?1:0);if(d&&c)return b[a+"Position"]===
	"inside"&&(c=-c),[c,d]},labelMetrics:function(){return this.chart.renderer.fontMetrics(this.options.labels.style.fontSize,this.ticks[0]&&this.ticks[0].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,c=this.tickInterval,d=c,e=this.len/(((this.categories?1:0)+this.max-this.min)/c),f,g=a.rotation,h=this.labelMetrics(),i,j=Number.MAX_VALUE,k,l=function(a){a/=e||1;a=a>1?va(a):1;return a*c};b?(k=!a.staggerLines&&!a.step&&(s(g)?[g]:e<p(a.autoRotationLimit,80)&&a.autoRotation))&&q(k,function(a){var b;
	if(a===g||a&&a>=-90&&a<=90)i=l(Q(h.h/ea(ka*a))),b=i+Q(a/360),b<j&&(j=b,f=a,d=i)}):a.step||(d=l(h.h));this.autoRotation=k;this.labelRotation=p(f,g);return d},getSlotWidth:function(){var a=this.chart,b=this.horiz,c=this.options.labels,d=Math.max(this.tickPositions.length-(this.categories?0:1),1),e=a.margin[3];return b&&(c.step||0)<2&&!c.rotation&&(this.staggerLines||1)*a.plotWidth/d||!b&&(e&&e-a.spacing[3]||a.chartWidth*0.33)},renderUnsquish:function(){var a=this.chart,b=a.renderer,c=this.tickPositions,
	d=this.ticks,e=this.options.labels,f=this.horiz,g=this.getSlotWidth(),h=t(1,C(g-2*(e.padding||5))),i={},j=this.labelMetrics(),k=e.style.textOverflow,l,m=0,n,o;if(!ya(e.rotation))i.rotation=e.rotation||0;if(this.autoRotation)q(c,function(a){if((a=d[a])&&a.labelLength>m)m=a.labelLength}),m>h&&m>j.h?i.rotation=this.labelRotation:this.labelRotation=0;else if(g&&(l={width:h+"px"},!k)){l.textOverflow="clip";for(n=c.length;!f&&n--;)if(o=c[n],h=d[o].label)if(h.styles.textOverflow==="ellipsis"?h.css({textOverflow:"clip"}):
	d[o].labelLength>g&&h.css({width:g+"px"}),h.getBBox().height>this.len/c.length-(j.h-j.f))h.specCss={textOverflow:"ellipsis"}}if(i.rotation&&(l={width:(m>a.chartHeight*0.5?a.chartHeight*0.33:a.chartHeight)+"px"},!k))l.textOverflow="ellipsis";if(this.labelAlign=e.align||this.autoLabelAlign(this.labelRotation))i.align=this.labelAlign;q(c,function(a){var b=(a=d[a])&&a.label;if(b)b.attr(i),l&&b.css(E(l,b.specCss)),delete b.specCss,a.rotation=i.rotation});this.tickRotCorr=b.rotCorr(j.b,this.labelRotation||
	0,this.side!==0)},hasData:function(){return this.hasVisibleSeries||s(this.min)&&s(this.max)&&!!this.tickPositions},getOffset:function(){var a=this,b=a.chart,c=b.renderer,d=a.options,e=a.tickPositions,f=a.ticks,g=a.horiz,h=a.side,i=b.inverted?[1,0,3,2][h]:h,j,k,l=0,m,n=0,o=d.title,z=d.labels,r=0,G=a.opposite,w=b.axisOffset,b=b.clipOffset,v=[-1,1,1,-1][h],x,u=a.axisParent,ba=this.tickSize("tick");j=a.hasData();a.showAxis=k=j||p(d.showEmpty,!0);a.staggerLines=a.horiz&&z.staggerLines;if(!a.axisGroup)a.gridGroup=
	c.g("grid").attr({zIndex:d.gridZIndex||1}).add(u),a.axisGroup=c.g("axis").attr({zIndex:d.zIndex||2}).add(u),a.labelGroup=c.g("axis-labels").attr({zIndex:z.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels").add(u);if(j||a.isLinked){if(q(e,function(b){f[b]?f[b].addLabel():f[b]=new Xa(a,b)}),a.renderUnsquish(),z.reserveSpace!==!1&&(h===0||h===2||{1:"left",3:"right"}[h]===a.labelAlign||a.labelAlign==="center")&&q(e,function(a){r=t(f[a].getLabelSize(),r)}),a.staggerLines)r*=a.staggerLines,
	a.labelOffset=r*(a.opposite?-1:1)}else for(x in f)f[x].destroy(),delete f[x];if(o&&o.text&&o.enabled!==!1){if(!a.axisTitle)(x=o.textAlign)||(x=(g?{low:"left",middle:"center",high:"right"}:{low:G?"right":"left",middle:"center",high:G?"left":"right"})[o.align]),a.axisTitle=c.text(o.text,0,0,o.useHTML).attr({zIndex:7,rotation:o.rotation||0,align:x}).addClass("highcharts-"+this.coll.toLowerCase()+"-title").css(o.style).add(a.axisGroup),a.axisTitle.isNew=!0;if(k)l=a.axisTitle.getBBox()[g?"height":"width"],
	m=o.offset,n=s(m)?0:p(o.margin,g?5:10);a.axisTitle[k?"show":"hide"](!0)}a.offset=v*p(d.offset,w[h]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};c=h===0?-a.labelMetrics().h:h===2?a.tickRotCorr.y:0;n=Math.abs(r)+n;r&&(n-=c,n+=v*(g?p(z.y,a.tickRotCorr.y+v*8):z.x));a.axisTitleMargin=p(m,n);w[h]=t(w[h],a.axisTitleMargin+l+v*a.offset,n,j&&e.length&&ba?ba[0]:0);d=d.offset?0:V(d.lineWidth/2)*2;b[i]=t(b[i],d)},getLinePath:function(a){var b=this.chart,c=this.opposite,d=this.offset,e=this.horiz,f=this.left+(c?this.width:
	0)+d,d=b.chartHeight-this.bottom-(c?this.height:0)+d;c&&(a*=-1);return b.renderer.crispLine([X,e?this.left:f,e?d:this.top,S,e?b.chartWidth-this.right:f,e?d:b.chartHeight-this.bottom],a)},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,d=this.len,e=this.options.title,f=a?b:c,g=this.opposite,h=this.offset,i=e.x||0,j=e.y||0,k=this.chart.renderer.fontMetrics(e.style.fontSize).f,d={low:f+(a?0:d),middle:f+d/2,high:f+(a?d:0)}[e.align],b=(a?c+this.height:b)+(a?1:-1)*(g?-1:1)*this.axisTitleMargin+
	(this.side===2?k:0);return{x:a?d+i:b+(g?this.width:0)+h+i,y:a?b+j-(g?this.height:0)+h:d+j}},render:function(){var a=this,b=a.chart,c=b.renderer,d=a.options,e=a.isLog,f=a.lin2log,g=a.isLinked,h=a.tickPositions,i=a.axisTitle,j=a.ticks,k=a.minorTicks,l=a.alternateBands,m=d.stackLabels,n=d.alternateGridColor,o=a.tickmarkOffset,z=d.lineWidth,r,p=b.hasRendered&&J(a.oldMin),w=a.showAxis,v=bb(c.globalAnimation),t,s;a.labelEdge.length=0;a.overlap=!1;q([j,k,l],function(a){for(var b in a)a[b].isActive=!1});
	if(a.hasData()||g){a.minorTickInterval&&!a.categories&&q(a.getMinorTickPositions(),function(b){k[b]||(k[b]=new Xa(a,b,"minor"));p&&k[b].isNew&&k[b].render(null,!0);k[b].render(null,!1,1)});if(h.length&&(q(h,function(b,c){if(!g||b>=a.min&&b<=a.max)j[b]||(j[b]=new Xa(a,b)),p&&j[b].isNew&&j[b].render(c,!0,0.1),j[b].render(c)}),o&&(a.min===0||a.single)))j[-1]||(j[-1]=new Xa(a,-1,null,!0)),j[-1].render(-1);n&&q(h,function(c,d){s=h[d+1]!==A?h[d+1]+o:a.max-o;if(d%2===0&&c<a.max&&s<=a.max+(b.polar?-o:o))l[c]||
	(l[c]=new u.PlotLineOrBand(a)),t=c+o,l[c].options={from:e?f(t):t,to:e?f(s):s,color:n},l[c].render(),l[c].isActive=!0});if(!a._addedPlotLB)q((d.plotLines||[]).concat(d.plotBands||[]),function(b){a.addPlotBandOrLine(b)}),a._addedPlotLB=!0}q([j,k,l],function(a){var c,d,e=[],f=v.duration;for(c in a)if(!a[c].isActive)a[c].render(c,!1,0),a[c].isActive=!1,e.push(c);Ra(function(){for(d=e.length;d--;)a[e[d]]&&!a[e[d]].isActive&&(a[e[d]].destroy(),delete a[e[d]])},a===l||!b.hasRendered||!f?0:f)});if(z)r=a.getLinePath(z),
	a.axisLine?a.axisLine.animate({d:r}):a.axisLine=c.path(r).attr({stroke:d.lineColor,"stroke-width":z,zIndex:7}).add(a.axisGroup),a.axisLine[w?"show":"hide"](!0);if(i&&w)i[i.isNew?"attr":"animate"](a.getTitlePosition()),i.isNew=!1;m&&m.enabled&&a.renderStackTotals();a.isDirty=!1},redraw:function(){this.visible&&(this.render(),q(this.plotLinesAndBands,function(a){a.render()}));q(this.series,function(a){a.isDirty=!0})},destroy:function(a){var b=this,c=b.stacks,d,e=b.plotLinesAndBands;a||Y(b);for(d in c)Ta(c[d]),
	c[d]=null;q([b.ticks,b.minorTicks,b.alternateBands],function(a){Ta(a)});for(a=e.length;a--;)e[a].destroy();q("stackTotalGroup,axisLine,axisTitle,axisGroup,gridGroup,labelGroup,cross".split(","),function(a){b[a]&&(b[a]=b[a].destroy())});this._addedPlotLB=this.chart._labelPanes=this.ordinalSlope=void 0},drawCrosshair:function(a,b){var c,d=this.crosshair,e,f;a||(a=this.cross&&this.cross.e);if(!this.crosshair||(s(b)||!p(d.snap,!0))===!1)this.hideCrosshair();else if(p(d.snap,!0)?s(b)&&(c=this.isXAxis?
	b.plotX:this.len-b.plotY):c=this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos,c=this.isRadial?this.getPlotLinePath(this.isXAxis?b.x:p(b.stackY,b.y))||null:this.getPlotLinePath(null,null,null,null,c)||null,c===null)this.hideCrosshair();else{e=this.categories&&!this.isRadial;f=p(d.width,e?this.transA:1);if(this.cross)this.cross.attr({d:c,visibility:"visible","stroke-width":f});else{e={"pointer-events":"none","stroke-width":f,stroke:d.color||(e?"rgba(155,200,255,0.2)":"#C0C0C0"),zIndex:p(d.zIndex,
	2)};if(d.dashStyle)e.dashstyle=d.dashStyle;this.cross=this.chart.renderer.path(c).attr(e).add()}this.cross.e=a}},hideCrosshair:function(){this.cross&&this.cross.hide()}};x(ia.prototype,{getPlotBandPath:function(a,b){var c=this.getPlotLinePath(b,null,null,!0),d=this.getPlotLinePath(a,null,null,!0);d&&c?(d.flat=d.toString()===c.toString(),d.push(c[4],c[5],c[1],c[2])):d=null;return d},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,
	"plotLines")},addPlotBandOrLine:function(a,b){var c=(new u.PlotLineOrBand(this,a)).render(),d=this.userOptions;c&&(b&&(d[b]=d[b]||[],d[b].push(a)),this.plotLinesAndBands.push(c));return c},removePlotBandOrLine:function(a){for(var b=this.plotLinesAndBands,c=this.options,d=this.userOptions,e=b.length;e--;)b[e].id===a&&b[e].destroy();q([c.plotLines||[],d.plotLines||[],c.plotBands||[],d.plotBands||[]],function(b){for(e=b.length;e--;)b[e].id===a&&ra(b,b[e])})}});ia.prototype.getTimeTicks=function(a,b,
	c,d){var e=[],f={},g=U.global.useUTC,h,i=new ma(b-$a(b)),j=a.unitRange,k=a.count;if(s(b)){i[Hb](j>=H.second?0:k*V(i.getMilliseconds()/k));if(j>=H.second)i[Ib](j>=H.minute?0:k*V(i.getSeconds()/k));if(j>=H.minute)i[Jb](j>=H.hour?0:k*V(i[wb]()/k));if(j>=H.hour)i[Kb](j>=H.day?0:k*V(i[xb]()/k));if(j>=H.day)i[mb](j>=H.month?1:k*V(i[Wa]()/k));j>=H.month&&(i[zb](j>=H.year?0:k*V(i[cb]()/k)),h=i[db]());j>=H.year&&(h-=h%k,i[Ab](h));if(j===H.week)i[mb](i[Wa]()-i[yb]()+p(d,1));b=1;if(tb||ab)i=i.getTime(),i=new ma(i+
	$a(i));h=i[db]();for(var d=i.getTime(),l=i[cb](),m=i[Wa](),n=!g||!!ab,o=(H.day+(g?$a(i):i.getTimezoneOffset()*6E4))%H.day;d<c;)e.push(d),j===H.year?d=lb(h+b*k,0):j===H.month?d=lb(h,l+b*k):n&&(j===H.day||j===H.week)?d=lb(h,l,m+b*k*(j===H.day?1:7)):d+=j*k,b++;e.push(d);q(Ca(e,function(a){return j<=H.hour&&a%H.day===o}),function(a){f[a]="day"})}e.info=x(a,{higherRanks:f,totalRange:j*k});return e};ia.prototype.normalizeTimeTickInterval=function(a,b){var c=b||[["millisecond",[1,2,5,10,20,25,50,100,200,
	500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]],d=c[c.length-1],e=H[d[0]],f=d[1],g;for(g=0;g<c.length;g++)if(d=c[g],e=H[d[0]],f=d[1],c[g+1]&&a<=(e*f[f.length-1]+H[c[g+1][0]])/2)break;e===H.year&&a<5*e&&(f=[1,2,5]);c=vb(a/e,f,d[0]==="year"?t(ub(a/e),1):1);return{unitRange:e,count:c,unitName:d[0]}};ia.prototype.getLogTickPositions=function(a,b,c,d){var e=this.options,f=this.len,g=this.lin2log,h=
	this.log2lin,i=[];if(!d)this._minorAutoInterval=null;if(a>=0.5)a=C(a),i=this.getLinearTickPositions(a,b,c);else if(a>=0.08)for(var f=V(b),j,k,l,m,n,e=a>0.3?[1,2,4]:a>0.15?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];f<c+1&&!n;f++){k=e.length;for(j=0;j<k&&!n;j++)l=h(g(f)*e[j]),l>b&&(!d||m<=c)&&m!==A&&i.push(m),m>c&&(n=!0),m=l}else if(b=g(b),c=g(c),a=e[d?"minorTickInterval":"tickInterval"],a=p(a==="auto"?null:a,this._minorAutoInterval,(c-b)*(e.tickPixelInterval/(d?5:1))/((d?f/this.tickPositions.length:f)||1)),a=
	vb(a,null,ub(a)),i=Da(this.getLinearTickPositions(a,b,c),h),!d)this._minorAutoInterval=a/5;if(!d)this.tickInterval=a;return i};ia.prototype.log2lin=function(a){return Z.log(a)/Z.LN10};ia.prototype.lin2log=function(a){return Z.pow(10,a)};var Qb=u.Tooltip=function(){this.init.apply(this,arguments)};Qb.prototype={init:function(a,b){var c=b.borderWidth,d=b.style,e=B(d.padding);this.chart=a;this.options=b;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.label=a.renderer.label("",0,0,b.shape||
	"callout",null,null,b.useHTML,null,"tooltip").attr({padding:e,fill:b.backgroundColor,"stroke-width":c,r:b.borderRadius,zIndex:8}).css(d).css({padding:0}).add().attr({y:-9E9});la||this.label.shadow(b.shadow);this.shared=b.shared},destroy:function(){if(this.label)this.label=this.label.destroy();clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},move:function(a,b,c,d){var e=this,f=e.now,g=e.options.animation!==!1&&!e.isHidden&&(Q(a-f.x)>1||Q(b-f.y)>1),h=e.followPointer||e.len>1;x(f,{x:g?
	(2*f.x+a)/3:a,y:g?(f.y+b)/2:b,anchorX:h?A:g?(2*f.anchorX+c)/3:c,anchorY:h?A:g?(f.anchorY+d)/2:d});e.label.attr(f);if(g)clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){e&&e.move(a,b,c,d)},32)},hide:function(a){var b=this;clearTimeout(this.hideTimer);a=p(a,this.options.hideDelay,500);if(!this.isHidden)this.hideTimer=Ra(function(){b.label[a?"fadeOut":"hide"]();b.isHidden=!0},a)},getAnchor:function(a,b){var c,d=this.chart,e=d.inverted,f=d.plotTop,g=d.plotLeft,h=0,i=0,j,k,a=
	ua(a);c=a[0].tooltipPos;this.followPointer&&b&&(b.chartX===A&&(b=d.pointer.normalize(b)),c=[b.chartX-d.plotLeft,b.chartY-f]);c||(q(a,function(a){j=a.series.yAxis;k=a.series.xAxis;h+=a.plotX+(!e&&k?k.left-g:0);i+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!e&&j?j.top-f:0)}),h/=a.length,i/=a.length,c=[e?d.plotWidth-i:h,this.shared&&!e&&a.length>1&&b?b.chartY-f:e?d.plotHeight-h:i]);return Da(c,C)},getPosition:function(a,b,c){var d=this.chart,e=this.distance,f={},g=c.h||0,h,i=["y",d.chartHeight,b,
	c.plotY+d.plotTop,d.plotTop,d.plotTop+d.plotHeight],j=["x",d.chartWidth,a,c.plotX+d.plotLeft,d.plotLeft,d.plotLeft+d.plotWidth],k=!this.followPointer&&p(c.ttBelow,!d.inverted===!!c.negative),l=function(a,b,c,d,h,i){var j=c<d-e,m=d+e+c<b,l=d-e-c;d+=e;if(k&&m)f[a]=d;else if(!k&&j)f[a]=l;else if(j)f[a]=F(i-c,l-g<0?l:l-g);else if(m)f[a]=t(h,d+g+c>b?d:d+g);else return!1},m=function(a,b,c,d){var g;d<e||d>b-e?g=!1:f[a]=d<c/2?1:d>b-c/2?b-c-2:d-c/2;return g},n=function(a){var b=i;i=j;j=b;h=a},o=function(){l.apply(0,
	i)!==!1?m.apply(0,j)===!1&&!h&&(n(!0),o()):h?f.x=f.y=0:(n(!0),o())};(d.inverted||this.len>1)&&n();o();return f},defaultFormatter:function(a){var b=this.points||ua(this),c;c=[a.tooltipFooterHeaderFormatter(b[0])];c=c.concat(a.bodyFormatter(b));c.push(a.tooltipFooterHeaderFormatter(b[0],!0));return c.join("")},refresh:function(a,b){var c=this.chart,d=this.label,e=this.options,f,g,h,i={},j,k=[];j=e.formatter||this.defaultFormatter;var i=c.hoverPoints,l,m=this.shared;clearTimeout(this.hideTimer);this.followPointer=
	ua(a)[0].series.tooltipOptions.followPointer;h=this.getAnchor(a,b);f=h[0];g=h[1];m&&(!a.series||!a.series.noSharedTooltip)?(c.hoverPoints=a,i&&q(i,function(a){a.setState()}),q(a,function(a){a.setState("hover");k.push(a.getLabelConfig())}),i={x:a[0].category,y:a[0].y},i.points=k,this.len=k.length,a=a[0]):i=a.getLabelConfig();j=j.call(i,this);i=a.series;this.distance=p(i.tooltipOptions.distance,16);j===!1?this.hide():(this.isHidden&&(Ka(d),d.attr("opacity",1).show()),d.attr({text:j}),l=e.borderColor||
	a.color||i.color||"#606060",d.attr({stroke:l}),this.updatePosition({plotX:f,plotY:g,negative:a.negative,ttBelow:a.ttBelow,h:h[2]||0}),this.isHidden=!1);I(c,"tooltipRefresh",{text:j,x:f+c.plotLeft,y:g+c.plotTop,borderColor:l})},updatePosition:function(a){var b=this.chart,c=this.label,c=(this.options.positioner||this.getPosition).call(this,c.width,c.height,a);this.move(C(c.x),C(c.y||0),a.plotX+b.plotLeft,a.plotY+b.plotTop)},getXDateFormat:function(a,b,c){var d,b=b.dateTimeLabelFormats,e=c&&c.closestPointRange,
	f,g={millisecond:15,second:12,minute:9,hour:6,day:3},h,i="millisecond";if(e){h=Sa("%m-%d %H:%M:%S.%L",a.x);for(f in H){if(e===H.week&&+Sa("%w",a.x)===c.options.startOfWeek&&h.substr(6)==="00:00:00.000"){f="week";break}if(H[f]>e){f=i;break}if(g[f]&&h.substr(g[f])!=="01-01 00:00:00.000".substr(g[f]))break;f!=="week"&&(i=f)}f&&(d=b[f])}else d=b.day;return d||b.year},tooltipFooterHeaderFormatter:function(a,b){var c=b?"footer":"header",d=a.series,e=d.tooltipOptions,f=e.xDateFormat,g=d.xAxis,h=g&&g.options.type===
	"datetime"&&J(a.key),c=e[c+"Format"];h&&!f&&(f=this.getXDateFormat(a,e,g));h&&f&&(c=c.replace("{point.key}","{point.key:"+f+"}"));return Na(c,{point:a,series:d})},bodyFormatter:function(a){return Da(a,function(a){var c=a.series.tooltipOptions;return(c.pointFormatter||a.point.tooltipFormatter).call(a.point,c.pointFormat)})}};var ja;fb=y&&y.documentElement.ontouchstart!==A;var Za=u.Pointer=function(a,b){this.init(a,b)};Za.prototype={init:function(a,b){var c=b.chart,d=c.events,e=la?"":c.zoomType,c=a.inverted,
	f;this.options=b;this.chart=a;this.zoomX=f=/x/.test(e);this.zoomY=e=/y/.test(e);this.zoomHor=f&&!c||e&&c;this.zoomVert=e&&!c||f&&c;this.hasZoom=f||e;this.runChartClick=d&&!!d.click;this.pinchDown=[];this.lastValidTouch={};if(u.Tooltip&&b.tooltip.enabled)a.tooltip=new Qb(a,b.tooltip),this.followTouchMove=p(b.tooltip.followTouchMove,!0);this.setDOMEvents()},normalize:function(a,b){var c,d,a=a||D.event;if(!a.target)a.target=a.srcElement;d=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:
	a;if(!b)this.chartPosition=b=Cb(this.chart.container);d.pageX===A?(c=t(a.x,a.clientX-b.left),d=a.y):(c=d.pageX-b.left,d=d.pageY-b.top);return x(a,{chartX:C(c),chartY:C(d)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};q(this.chart.axes,function(c){b[c.isXAxis?"xAxis":"yAxis"].push({axis:c,value:c.toValue(a[c.horiz?"chartX":"chartY"])})});return b},runPointActions:function(a){var b=this.chart,c=b.series,d=b.tooltip,e=d?d.shared:!1,f=b.hoverPoint,g=b.hoverSeries,h,i=[Number.MAX_VALUE,Number.MAX_VALUE],
	j,k,l=[],m=[],n;if(!e&&!g)for(h=0;h<c.length;h++)if(c[h].directTouch||!c[h].options.stickyTracking)c=[];g&&(e?g.noSharedTooltip:g.directTouch)&&f?m=[f]:(q(c,function(b){j=b.noSharedTooltip&&e;k=!e&&b.directTouch;b.visible&&!j&&!k&&p(b.options.enableMouseTracking,!0)&&(n=b.searchPoint(a,!j&&b.kdDimensions===1))&&n.series&&l.push(n)}),q(l,function(a){a&&q(["dist","distX"],function(b,c){if(J(a[b])){var d=a[b]===i[c]&&a.series.group.zIndex>=m[c].series.group.zIndex;if(a[b]<i[c]||d)i[c]=a[b],m[c]=a}})}));
	if(e)for(h=l.length;h--;)(l[h].clientX!==m[1].clientX||l[h].series.noSharedTooltip)&&l.splice(h,1);if(m[0]&&(m[0]!==this.prevKDPoint||d&&d.isHidden))if(e&&!m[0].series.noSharedTooltip)l.length&&d&&d.refresh(l,a),q(l,function(b){b.onMouseOver(a,b!==(g&&g.directTouch&&f||m[0]))}),this.prevKDPoint=m[1];else{d&&d.refresh(m[0],a);if(!g||!g.directTouch)m[0].onMouseOver(a);this.prevKDPoint=m[0]}else c=g&&g.tooltipOptions.followPointer,d&&c&&!d.isHidden&&(c=d.getAnchor([{}],a),d.updatePosition({plotX:c[0],
	plotY:c[1]}));if(!this._onDocumentMouseMove)this._onDocumentMouseMove=function(a){if(T[ja])T[ja].pointer.onDocumentMouseMove(a)},N(y,"mousemove",this._onDocumentMouseMove);q(e?l:[p(f,m[1])],function(c){q(b.axes,function(b){(!c||c.series[b.coll]===b)&&b.drawCrosshair(a,c)})})},reset:function(a,b){var c=this.chart,d=c.hoverSeries,e=c.hoverPoint,f=c.hoverPoints,g=c.tooltip,h=g&&g.shared?f:e;a&&h&&q(ua(h),function(b){b.series.isCartesian&&b.plotX===void 0&&(a=!1)});if(a)g&&h&&(g.refresh(h),e&&(e.setState(e.state,
	!0),q(c.axes,function(a){a.crosshair&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();f&&q(f,function(a){a.setState()});if(d)d.onMouseOut();g&&g.hide(b);if(this._onDocumentMouseMove)Y(y,"mousemove",this._onDocumentMouseMove),this._onDocumentMouseMove=null;q(c.axes,function(a){a.hideCrosshair()});this.hoverX=this.prevKDPoint=c.hoverPoints=c.hoverPoint=null}},scaleGroups:function(a,b){var c=this.chart,d;q(c.series,function(e){d=a||e.getPlotBox();e.xAxis&&e.xAxis.zoomEnabled&&(e.group.attr(d),e.markerGroup&&
	(e.markerGroup.attr(d),e.markerGroup.clip(b?c.clipRect:null)),e.dataLabelsGroup&&e.dataLabelsGroup.attr(d))});c.clipRect.attr(b||c.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,c=b.options.chart,d=a.chartX,e=a.chartY,f=this.zoomHor,g=this.zoomVert,h=b.plotLeft,i=b.plotTop,j=b.plotWidth,k=b.plotHeight,l,m=this.selectionMarker,n=this.mouseDownX,o=this.mouseDownY,
	p=c.panKey&&a[c.panKey+"Key"];if(!m||!m.touch)if(d<h?d=h:d>h+j&&(d=h+j),e<i?e=i:e>i+k&&(e=i+k),this.hasDragged=Math.sqrt(Math.pow(n-d,2)+Math.pow(o-e,2)),this.hasDragged>10){l=b.isInsidePlot(n-h,o-i);if(b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&l&&!p&&!m)this.selectionMarker=m=b.renderer.rect(h,i,f?1:j,g?1:k,0).attr({fill:c.selectionMarkerFill||"rgba(69,114,167,0.25)",zIndex:7}).add();m&&f&&(d-=n,m.attr({width:Q(d),x:(d>0?0:d)+n}));m&&g&&(d=e-o,m.attr({height:Q(d),y:(d>0?0:d)+o}));l&&!m&&c.panning&&
	b.pan(a,c.panning)}},drop:function(a){var b=this,c=this.chart,d=this.hasPinched;if(this.selectionMarker){var e={originalEvent:a,xAxis:[],yAxis:[]},f=this.selectionMarker,g=f.attr?f.attr("x"):f.x,h=f.attr?f.attr("y"):f.y,i=f.attr?f.attr("width"):f.width,j=f.attr?f.attr("height"):f.height,k;if(this.hasDragged||d)q(c.axes,function(c){if(c.zoomEnabled&&s(c.min)&&(d||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var f=c.horiz,n=a.type==="touchend"?c.minPixelPadding:0,o=c.toValue((f?g:h)+n),f=c.toValue((f?
	g+i:h+j)-n);e[c.coll].push({axis:c,min:F(o,f),max:t(o,f)});k=!0}}),k&&I(c,"selection",e,function(a){c.zoom(x(a,d?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();d&&this.scaleGroups()}if(c)M(c.container,{cursor:c._cursor}),c.cancelClick=this.hasDragged>10,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[]},onContainerMouseDown:function(a){a=this.normalize(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(a){T[ja]&&T[ja].pointer.drop(a)},
	onDocumentMouseMove:function(a){var b=this.chart,c=this.chartPosition,a=this.normalize(a,c);c&&!this.inClass(a.target,"highcharts-tracker")&&!b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)&&this.reset()},onContainerMouseLeave:function(a){var b=T[ja];if(b&&(a.relatedTarget||a.toElement))b.pointer.reset(),b.pointer.chartPosition=null},onContainerMouseMove:function(a){var b=this.chart;if(!s(ja)||!T[ja]||!T[ja].mouseIsDown)ja=b.index;a=this.normalize(a);a.returnValue=!1;b.mouseIsDown==="mousedown"&&
	this.drag(a);(this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop))&&!b.openMenu&&this.runPointActions(a)},inClass:function(a,b){for(var c;a;){if(c=P(a,"class")){if(c.indexOf(b)!==-1)return!0;if(c.indexOf("highcharts-container")!==-1)return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries,a=a.relatedTarget||a.toElement;if(b&&a&&!b.options.stickyTracking&&!this.inClass(a,"highcharts-tooltip")&&!this.inClass(a,"highcharts-series-"+
	b.index))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,d=b.plotLeft,e=b.plotTop,a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(I(c.series,"click",x(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(x(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-d,a.chartY-e)&&I(b,"click",a)))},setDOMEvents:function(){var a=this,b=a.chart.container;b.onmousedown=function(b){a.onContainerMouseDown(b)};b.onmousemove=function(b){a.onContainerMouseMove(b)};
	b.onclick=function(b){a.onContainerClick(b)};N(b,"mouseleave",a.onContainerMouseLeave);gb===1&&N(y,"mouseup",a.onDocumentMouseUp);if(fb)b.ontouchstart=function(b){a.onContainerTouchStart(b)},b.ontouchmove=function(b){a.onContainerTouchMove(b)},gb===1&&N(y,"touchend",a.onDocumentTouchEnd)},destroy:function(){var a;Y(this.chart.container,"mouseleave",this.onContainerMouseLeave);gb||(Y(y,"mouseup",this.onDocumentMouseUp),Y(y,"touchend",this.onDocumentTouchEnd));clearInterval(this.tooltipTimeout);for(a in this)this[a]=
	null}};x(u.Pointer.prototype,{pinchTranslate:function(a,b,c,d,e,f){(this.zoomHor||this.pinchHor)&&this.pinchTranslateDirection(!0,a,b,c,d,e,f);(this.zoomVert||this.pinchVert)&&this.pinchTranslateDirection(!1,a,b,c,d,e,f)},pinchTranslateDirection:function(a,b,c,d,e,f,g,h){var i=this.chart,j=a?"x":"y",k=a?"X":"Y",l="chart"+k,m=a?"width":"height",n=i["plot"+(a?"Left":"Top")],o,p,r=h||1,q=i.inverted,w=i.bounds[a?"h":"v"],v=b.length===1,s=b[0][l],t=c[0][l],x=!v&&b[1][l],u=!v&&c[1][l],C,c=function(){!v&&
	Q(s-x)>20&&(r=h||Q(t-u)/Q(s-x));p=(n-t)/r+s;o=i["plot"+(a?"Width":"Height")]/r};c();b=p;b<w.min?(b=w.min,C=!0):b+o>w.max&&(b=w.max-o,C=!0);C?(t-=0.8*(t-g[j][0]),v||(u-=0.8*(u-g[j][1])),c()):g[j]=[t,u];q||(f[j]=p-n,f[m]=o);f=q?1/r:r;e[m]=o;e[j]=b;d[q?a?"scaleY":"scaleX":"scale"+k]=r;d["translate"+k]=f*n+(t-f*s)},pinch:function(a){var b=this,c=b.chart,d=b.pinchDown,e=a.touches,f=e.length,g=b.lastValidTouch,h=b.hasZoom,i=b.selectionMarker,j={},k=f===1&&(b.inClass(a.target,"highcharts-tracker")&&c.runTrackerClick||
	b.runChartClick),l={};if(f>1)b.initiated=!0;h&&b.initiated&&!k&&a.preventDefault();Da(e,function(a){return b.normalize(a)});if(a.type==="touchstart")q(e,function(a,b){d[b]={chartX:a.chartX,chartY:a.chartY}}),g.x=[d[0].chartX,d[1]&&d[1].chartX],g.y=[d[0].chartY,d[1]&&d[1].chartY],q(c.axes,function(a){if(a.zoomEnabled){var b=c.bounds[a.horiz?"h":"v"],d=a.minPixelPadding,e=a.toPixels(p(a.options.min,a.dataMin)),f=a.toPixels(p(a.options.max,a.dataMax)),g=F(e,f),e=t(e,f);b.min=F(a.pos,g-d);b.max=t(a.pos+
	a.len,e+d)}}),b.res=!0;else if(d.length){if(!i)b.selectionMarker=i=x({destroy:Ba,touch:!0},c.plotBox);b.pinchTranslate(d,e,j,i,l,g);b.hasPinched=h;b.scaleGroups(j,l);if(!h&&b.followTouchMove&&f===1)this.runPointActions(b.normalize(a));else if(b.res)b.res=!1,this.reset(!1,0)}},touch:function(a,b){var c=this.chart,d;ja=c.index;if(a.touches.length===1)if(a=this.normalize(a),c.isInsidePlot(a.chartX-c.plotLeft,a.chartY-c.plotTop)&&!c.openMenu){b&&this.runPointActions(a);if(a.type==="touchmove")c=this.pinchDown,
	d=c[0]?Math.sqrt(Math.pow(c[0].chartX-a.chartX,2)+Math.pow(c[0].chartY-a.chartY,2))>=4:!1;p(d,!0)&&this.pinch(a)}else b&&this.reset();else a.touches.length===2&&this.pinch(a)},onContainerTouchStart:function(a){this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(a){T[ja]&&T[ja].pointer.drop(a)}});if(D.PointerEvent||D.MSPointerEvent){var wa={},Eb=!!D.PointerEvent,Tb=function(){var a,b=[];b.item=function(a){return this[a]};for(a in wa)wa.hasOwnProperty(a)&&b.push({pageX:wa[a].pageX,
	pageY:wa[a].pageY,target:wa[a].target});return b},Fb=function(a,b,c,d){if((a.pointerType==="touch"||a.pointerType===a.MSPOINTER_TYPE_TOUCH)&&T[ja])d(a),d=T[ja].pointer,d[b]({type:c,target:a.currentTarget,preventDefault:Ba,touches:Tb()})};x(Za.prototype,{onContainerPointerDown:function(a){Fb(a,"onContainerTouchStart","touchstart",function(a){wa[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){Fb(a,"onContainerTouchMove","touchmove",function(a){wa[a.pointerId]=
	{pageX:a.pageX,pageY:a.pageY};if(!wa[a.pointerId].target)wa[a.pointerId].target=a.currentTarget})},onDocumentPointerUp:function(a){Fb(a,"onDocumentTouchEnd","touchend",function(a){delete wa[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,Eb?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,Eb?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(y,Eb?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});hb(Za.prototype,"init",function(a,b,c){a.call(this,
	b,c);this.hasZoom&&M(b.container,{"-ms-touch-action":"none","touch-action":"none"})});hb(Za.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(N)});hb(Za.prototype,"destroy",function(a){this.batchMSEvents(Y);a.call(this)})}var rb=u.Legend=function(a,b){this.init(a,b)};rb.prototype={init:function(a,b){var c=this,d=b.itemStyle,e=b.itemMarginTop||0;this.options=b;if(b.enabled)c.itemStyle=d,c.itemHiddenStyle=E(d,b.itemHiddenStyle),c.itemMarginTop=
	e,c.padding=d=p(b.padding,8),c.initialItemX=d,c.initialItemY=d-5,c.maxItemWidth=0,c.chart=a,c.itemHeight=0,c.symbolWidth=p(b.symbolWidth,16),c.pages=[],c.render(),N(c.chart,"endResize",function(){c.positionCheckboxes()})},colorizeItem:function(a,b){var c=this.options,d=a.legendItem,e=a.legendLine,f=a.legendSymbol,g=this.itemHiddenStyle.color,c=b?c.itemStyle.color:g,h=b?a.legendColor||a.color||"#CCC":g,g=a.options&&a.options.marker,i={fill:h},j;d&&d.css({fill:c,color:c});e&&e.attr({stroke:h});if(f){if(g&&
	f.isMarker)for(j in i.stroke=h,g=a.convertAttribs(g),g)d=g[j],d!==A&&(i[j]=d);f.attr(i)}},positionItem:function(a){var b=this.options,c=b.symbolPadding,b=!b.rtl,d=a._legendItemPos,e=d[0],d=d[1],f=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(b?e:this.legendWidth-e-2*c-4,d);if(f)f.x=e,f.y=d},destroyItem:function(a){var b=a.checkbox;q(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&Ua(a.checkbox)},destroy:function(){var a=this.group,b=this.box;
	if(b)this.box=b.destroy();if(a)this.group=a.destroy()},positionCheckboxes:function(a){var b=this.group.alignAttr,c,d=this.clipHeight||this.legendHeight,e=this.titleHeight;if(b)c=b.translateY,q(this.allItems,function(f){var g=f.checkbox,h;g&&(h=c+e+g.y+(a||0)+3,M(g,{left:b.translateX+f.checkboxOffset+g.x-20+"px",top:h+"px",display:h>c-6&&h<c+d-6?"":"none"}))})},renderTitle:function(){var a=this.padding,b=this.options.title,c=0;if(b.text){if(!this.title)this.title=this.chart.renderer.label(b.text,a-
	3,a-4,null,null,null,null,null,"legend-title").attr({zIndex:1}).css(b.style).add(this.group);a=this.title.getBBox();c=a.height;this.offsetWidth=a.width;this.contentGroup.attr({translateY:c})}this.titleHeight=c},setText:function(a){var b=this.options;a.legendItem.attr({text:b.labelFormat?Na(b.labelFormat,a):b.labelFormatter.call(a)})},renderItem:function(a){var b=this.chart,c=b.renderer,d=this.options,e=d.layout==="horizontal",f=this.symbolWidth,g=d.symbolPadding,h=this.itemStyle,i=this.itemHiddenStyle,
	j=this.padding,k=e?p(d.itemDistance,20):0,l=!d.rtl,m=d.width,n=d.itemMarginBottom||0,o=this.itemMarginTop,z=this.initialItemX,r=a.legendItem,q=a.series&&a.series.drawLegendSymbol?a.series:a,w=q.options,w=this.createCheckboxForItem&&w&&w.showCheckbox,v=d.useHTML;if(!r){a.legendGroup=c.g("legend-item").attr({zIndex:1}).add(this.scrollGroup);a.legendItem=r=c.text("",l?f+g:-g,this.baseline||0,v).css(E(a.visible?h:i)).attr({align:l?"left":"right",zIndex:2}).add(a.legendGroup);if(!this.baseline)this.fontMetrics=
	c.fontMetrics(h.fontSize,r),this.baseline=this.fontMetrics.f+3+o,r.attr("y",this.baseline);q.drawLegendSymbol(this,a);this.setItemEvents&&this.setItemEvents(a,r,v,h,i);w&&this.createCheckboxForItem(a)}this.colorizeItem(a,a.visible);this.setText(a);c=r.getBBox();f=a.checkboxOffset=d.itemWidth||a.legendItemWidth||f+g+c.width+k+(w?20:0);this.itemHeight=g=C(a.legendItemHeight||c.height);if(e&&this.itemX-z+f>(m||b.chartWidth-2*j-z-d.x))this.itemX=z,this.itemY+=o+this.lastLineHeight+n,this.lastLineHeight=
	0;this.maxItemWidth=t(this.maxItemWidth,f);this.lastItemY=o+this.itemY+n;this.lastLineHeight=t(g,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=f:(this.itemY+=o+g+n,this.lastLineHeight=g);this.offsetWidth=m||t((e?this.itemX-z-k:f)+j,this.offsetWidth)},getAllItems:function(){var a=[];q(this.chart.series,function(b){var c=b.options;if(p(c.showInLegend,!s(c.linkedTo)?A:!1,!0))a=a.concat(b.legendItems||(c.legendType==="point"?b.data:b))});return a},adjustMargins:function(a,
	b){var c=this.chart,d=this.options,e=d.align.charAt(0)+d.verticalAlign.charAt(0)+d.layout.charAt(0);d.floating||q([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(f,g){f.test(e)&&!s(a[g])&&(c[pb[g]]=t(c[pb[g]],c.legend[(g+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][g]*d[g%2?"x":"y"]+p(d.margin,12)+b[g]))})},render:function(){var a=this,b=a.chart,c=b.renderer,d=a.group,e,f,g,h,i=a.box,j=a.options,k=a.padding,l=j.borderWidth,m=j.backgroundColor;a.itemX=a.initialItemX;a.itemY=
	a.initialItemY;a.offsetWidth=0;a.lastItemY=0;if(!d)a.group=d=c.g("legend").attr({zIndex:7}).add(),a.contentGroup=c.g().attr({zIndex:1}).add(d),a.scrollGroup=c.g().add(a.contentGroup);a.renderTitle();e=a.getAllItems();jb(e,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});j.reversed&&e.reverse();a.allItems=e;a.display=f=!!e.length;a.lastLineHeight=0;q(e,function(b){a.renderItem(b)});g=(j.width||a.offsetWidth)+k;h=a.lastItemY+a.lastLineHeight+a.titleHeight;
	h=a.handleOverflow(h);h+=k;if(l||m){if(i){if(g>0&&h>0)i[i.isNew?"attr":"animate"](i.crisp({width:g,height:h})),i.isNew=!1}else a.box=i=c.rect(0,0,g,h,j.borderRadius,l||0).attr({stroke:j.borderColor,"stroke-width":l||0,fill:m||"none"}).add(d).shadow(j.shadow),i.isNew=!0;i[f?"show":"hide"]()}a.legendWidth=g;a.legendHeight=h;q(e,function(b){a.positionItem(b)});f&&d.align(x({width:g,height:h},j),!0,"spacingBox");b.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var b=this,c=this.chart,
	d=c.renderer,e=this.options,f=e.y,f=c.spacingBox.height+(e.verticalAlign==="top"?-f:f)-this.padding,g=e.maxHeight,h,i=this.clipRect,j=e.navigation,k=p(j.animation,!0),l=j.arrowSize||12,m=this.nav,n=this.pages,o=this.padding,z,r=this.allItems,s=function(a){i.attr({height:a});if(b.contentGroup.div)b.contentGroup.div.style.clip="rect("+o+"px,9999px,"+(o+a)+"px,0)"};e.layout==="horizontal"&&(f/=2);g&&(f=F(f,g));n.length=0;if(a>f&&j.enabled!==!1){this.clipHeight=h=t(f-20-this.titleHeight-o,0);this.currentPage=
	p(this.currentPage,1);this.fullHeight=a;q(r,function(a,b){var c=a._legendItemPos[1],d=C(a.legendItem.getBBox().height),e=n.length;if(!e||c-n[e-1]>h&&(z||c)!==n[e-1])n.push(z||c),e++;b===r.length-1&&c+d-n[e-1]>h&&n.push(c);c!==z&&(z=c)});if(!i)i=b.clipRect=d.clipRect(0,o,9999,0),b.contentGroup.clip(i);s(h);if(!m)this.nav=m=d.g().attr({zIndex:1}).add(this.group),this.up=d.symbol("triangle",0,0,l,l).on("click",function(){b.scroll(-1,k)}).add(m),this.pager=d.text("",15,10).css(j.style).add(m),this.down=
	d.symbol("triangle-down",0,0,l,l).on("click",function(){b.scroll(1,k)}).add(m);b.scroll(0);a=f}else if(m)s(c.chartHeight),m.hide(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0;return a},scroll:function(a,b){var c=this.pages,d=c.length,e=this.currentPage+a,f=this.clipHeight,g=this.options.navigation,h=g.activeColor,g=g.inactiveColor,i=this.pager,j=this.padding;e>d&&(e=d);if(e>0)b!==A&&Va(b,this.chart),this.nav.attr({translateX:j,translateY:f+this.padding+7+this.titleHeight,visibility:"visible"}),
	this.up.attr({fill:e===1?g:h}).css({cursor:e===1?"default":"pointer"}),i.attr({text:e+"/"+d}),this.down.attr({x:18+this.pager.getBBox().width,fill:e===d?g:h}).css({cursor:e===d?"default":"pointer"}),c=-c[e-1]+this.initialItemY,this.scrollGroup.animate({translateY:c}),this.currentPage=e,this.positionCheckboxes(c)}};K=u.LegendSymbolMixin={drawRectangle:function(a,b){var c=a.options.symbolHeight||a.fontMetrics.f;b.legendSymbol=this.chart.renderer.rect(0,a.baseline-c+1,a.symbolWidth,c,a.options.symbolRadius||
	0).attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,c=b.marker,d=a.symbolWidth,e=this.chart.renderer,f=this.legendGroup,a=a.baseline-C(a.fontMetrics.b*0.3),g;if(b.lineWidth){g={"stroke-width":b.lineWidth};if(b.dashStyle)g.dashstyle=b.dashStyle;this.legendLine=e.path([X,0,a,S,d,a]).attr(g).add(f)}if(c&&c.enabled!==!1)b=c.radius,this.legendSymbol=c=e.symbol(this.symbol,d/2-b,a-b,2*b,2*b,c).add(f),c.isMarker=!0}};(/Trident\/7\.0/.test(Aa)||Qa)&&hb(rb.prototype,"positionItem",
	function(a,b){var c=this,d=function(){b._legendItemPos&&a.call(c,b)};d();setTimeout(d)});var ib=u.Chart=function(){this.getArgs.apply(this,arguments)};u.chart=function(a,b,c){return new ib(a,b,c)};ib.prototype={callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(ya(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(a,b){var c,d=a.series;a.series=null;c=E(U,a);c.series=a.series=d;this.userOptions=a;d=c.chart;this.margin=this.splashArray("margin",d);this.spacing=
	this.splashArray("spacing",d);var e=d.events;this.bounds={h:{},v:{}};this.callback=b;this.isResizing=0;this.options=c;this.axes=[];this.series=[];this.hasCartesianSeries=d.showAxes;var f=this,g;f.index=T.length;T.push(f);gb++;d.reflow!==!1&&N(f,"load",function(){f.initReflow()});if(e)for(g in e)N(f,g,e[g]);f.xAxis=[];f.yAxis=[];f.animation=la?!1:p(d.animation,!0);f.pointCount=f.colorCounter=f.symbolCounter=0;f.firstRender()},initSeries:function(a){var b=this.options.chart;(b=L[a.type||b.type||b.defaultSeriesType])||
	ca(17,!0);b=new b;b.init(this,a);return b},isInsidePlot:function(a,b,c){var d=c?b:a,a=c?a:b;return d>=0&&d<=this.plotWidth&&a>=0&&a<=this.plotHeight},redraw:function(a){var b=this.axes,c=this.series,d=this.pointer,e=this.legend,f=this.isDirtyLegend,g,h,i=this.hasCartesianSeries,j=this.isDirtyBox,k=c.length,l=k,m=this.renderer,n=m.isHidden(),o=[];Va(a,this);n&&this.cloneRenderTo();for(this.layOutTitles();l--;)if(a=c[l],a.options.stacking&&(g=!0,a.isDirty)){h=!0;break}if(h)for(l=k;l--;)if(a=c[l],a.options.stacking)a.isDirty=
	!0;q(c,function(a){a.isDirty&&a.options.legendType==="point"&&(a.updateTotals&&a.updateTotals(),f=!0);a.isDirtyData&&I(a,"updatedData")});if(f&&e.options.enabled)e.render(),this.isDirtyLegend=!1;g&&this.getStacks();if(i&&!this.isResizing)this.maxTicks=null,q(b,function(a){a.setScale()});this.getMargins();i&&(q(b,function(a){a.isDirty&&(j=!0)}),q(b,function(a){var b=a.min+","+a.max;if(a.extKey!==b)a.extKey=b,o.push(function(){I(a,"afterSetExtremes",x(a.eventArgs,a.getExtremes()));delete a.eventArgs});
	(j||g)&&a.redraw()}));j&&this.drawChartBox();q(c,function(a){a.isDirty&&a.visible&&(!a.isCartesian||a.xAxis)&&a.redraw()});d&&d.reset(!0);m.draw();I(this,"redraw");n&&this.cloneRenderTo(!0);q(o,function(a){a.call()})},get:function(a){var b=this.axes,c=this.series,d,e;for(d=0;d<b.length;d++)if(b[d].options.id===a)return b[d];for(d=0;d<c.length;d++)if(c[d].options.id===a)return c[d];for(d=0;d<c.length;d++){e=c[d].points||[];for(b=0;b<e.length;b++)if(e[b].id===a)return e[b]}return null},getAxes:function(){var a=
	this,b=this.options,c=b.xAxis=ua(b.xAxis||{}),b=b.yAxis=ua(b.yAxis||{});q(c,function(a,b){a.index=b;a.isX=!0});q(b,function(a,b){a.index=b});c=c.concat(b);q(c,function(b){new ia(a,b)})},getSelectedPoints:function(){var a=[];q(this.series,function(b){a=a.concat(Ca(b.points||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return Ca(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var g;var d=this,e=d.options,f;f=e.title=E(e.title,a);g=e.subtitle=E(e.subtitle,
	b),e=g;q([["title",a,f],["subtitle",b,e]],function(a){var b=a[0],c=d[b],e=a[1],a=a[2];c&&e&&(d[b]=c=c.destroy());a&&a.text&&!c&&(d[b]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+b,zIndex:a.zIndex||4}).css(a.style).add())});d.layOutTitles(c)},layOutTitles:function(a){var b=0,c=this.title,d=this.subtitle,e=this.options,f=e.title,e=e.subtitle,g=this.renderer,h=this.spacingBox;if(c&&(c.css({width:(f.width||h.width+f.widthAdjust)+"px"}).align(x({y:g.fontMetrics(f.style.fontSize,
	c).b-3},f),!1,h),!f.floating&&!f.verticalAlign))b=c.getBBox().height;d&&(d.css({width:(e.width||h.width+e.widthAdjust)+"px"}).align(x({y:b+(f.margin-13)+g.fontMetrics(e.style.fontSize,c).b},e),!1,h),!e.floating&&!e.verticalAlign&&(b=va(b+d.getBBox().height)));c=this.titleOffset!==b;this.titleOffset=b;if(!this.isDirtyBox&&c)this.isDirtyBox=c,this.hasRendered&&p(a,!0)&&this.isDirtyBox&&this.redraw()},getChartSize:function(){var a=this.options.chart,b=a.width,a=a.height,c=this.renderToClone||this.renderTo;
	if(!s(b))this.containerWidth=oa(c,"width");if(!s(a))this.containerHeight=oa(c,"height");this.chartWidth=t(0,b||this.containerWidth||600);this.chartHeight=t(0,p(a,this.containerHeight>19?this.containerHeight:400))},cloneRenderTo:function(a){var b=this.renderToClone,c=this.container;a?b&&(this.renderTo.appendChild(c),Ua(b),delete this.renderToClone):(c&&c.parentNode===this.renderTo&&this.renderTo.removeChild(c),this.renderToClone=b=this.renderTo.cloneNode(0),M(b,{position:"absolute",top:"-9999px",display:"block"}),
	b.style.setProperty&&b.style.setProperty("display","block","important"),y.body.appendChild(b),c&&b.appendChild(c))},getContainer:function(){var a,b=this.options,c=b.chart,d,e;a=this.renderTo;var f="highcharts-"+Bb++;if(!a)this.renderTo=a=c.renderTo;if(ya(a))this.renderTo=a=y.getElementById(a);a||ca(13,!0);d=B(P(a,"data-highcharts-chart"));J(d)&&T[d]&&T[d].hasRendered&&T[d].destroy();P(a,"data-highcharts-chart",this.index);a.innerHTML="";!c.skipClone&&!a.offsetWidth&&this.cloneRenderTo();this.getChartSize();
	d=this.chartWidth;e=this.chartHeight;this.container=a=da(Pa,{className:"highcharts-container"+(c.className?" "+c.className:""),id:f},x({position:"relative",overflow:"hidden",width:d+"px",height:e+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},c.style),this.renderToClone||a);this._cursor=a.style.cursor;this.renderer=new (u[c.renderer]||eb)(a,d,e,c.style,c.forExport,b.exporting&&b.exporting.allowHTML);la&&this.renderer.create(this,a,d,e);this.renderer.chartIndex=
	this.index},getMargins:function(a){var b=this.spacing,c=this.margin,d=this.titleOffset;this.resetMargins();if(d&&!s(c[0]))this.plotTop=t(this.plotTop,d+this.options.title.margin+b[0]);this.legend.display&&this.legend.adjustMargins(c,b);this.extraBottomMargin&&(this.marginBottom+=this.extraBottomMargin);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],c=a.margin;a.hasCartesianSeries&&q(a.axes,function(a){a.visible&&
	a.getOffset()});q(pb,function(d,e){s(c[e])||(a[d]+=b[e])});a.setChartSize()},reflow:function(a){var b=this,c=b.options.chart,d=b.renderTo,e=s(c.width),f=c.width||oa(d,"width"),c=c.height||oa(d,"height"),d=a?a.target:D;if(!e&&!b.isPrinting&&f&&c&&(d===D||d===y)){if(f!==b.containerWidth||c!==b.containerHeight)clearTimeout(b.reflowTimeout),b.reflowTimeout=Ra(function(){b.container&&b.setSize(void 0,void 0,!1)},a?100:0);b.containerWidth=f;b.containerHeight=c}},initReflow:function(){var a=this,b=function(b){a.reflow(b)};
	N(D,"resize",b);N(a,"destroy",function(){Y(D,"resize",b)})},setSize:function(a,b,c){var d=this,e=d.renderer;d.isResizing+=1;Va(c,d);d.oldChartHeight=d.chartHeight;d.oldChartWidth=d.chartWidth;if(a!==void 0)d.options.chart.width=a;if(b!==void 0)d.options.chart.height=b;d.getChartSize();a=e.globalAnimation;(a?Ya:M)(d.container,{width:d.chartWidth+"px",height:d.chartHeight+"px"},a);d.setChartSize(!0);e.setSize(d.chartWidth,d.chartHeight,c);d.maxTicks=null;q(d.axes,function(a){a.isDirty=!0;a.setScale()});
	q(d.series,function(a){a.isDirty=!0});d.isDirtyLegend=!0;d.isDirtyBox=!0;d.layOutTitles();d.getMargins();d.redraw(c);d.oldChartHeight=null;I(d,"resize");Ra(function(){d&&I(d,"endResize",null,function(){d.isResizing-=1})},bb(a).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,d=this.chartWidth,e=this.chartHeight,f=this.options.chart,g=this.spacing,h=this.clipOffset,i,j,k,l;this.plotLeft=i=C(this.plotLeft);this.plotTop=j=C(this.plotTop);this.plotWidth=k=t(0,C(d-i-this.marginRight));
	this.plotHeight=l=t(0,C(e-j-this.marginBottom));this.plotSizeX=b?l:k;this.plotSizeY=b?k:l;this.plotBorderWidth=f.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:g[3],y:g[0],width:d-g[3]-g[1],height:e-g[0]-g[2]};this.plotBox=c.plotBox={x:i,y:j,width:k,height:l};d=2*V(this.plotBorderWidth/2);b=va(t(d,h[3])/2);c=va(t(d,h[0])/2);this.clipBox={x:b,y:c,width:V(this.plotSizeX-t(d,h[1])/2-b),height:t(0,V(this.plotSizeY-t(d,h[2])/2-c))};a||q(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},
	resetMargins:function(){var a=this;q(pb,function(b,c){a[b]=p(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,d=this.chartHeight,e=this.chartBackground,f=this.plotBackground,g=this.plotBorder,h=this.plotBGImage,i=a.borderWidth||0,j=a.backgroundColor,k=a.plotBackgroundColor,l=a.plotBackgroundImage,m=a.plotBorderWidth||0,n,o=this.plotLeft,p=this.plotTop,r=this.plotWidth,q=this.plotHeight,w=this.plotBox,
	v=this.clipRect,s=this.clipBox;n=i+(a.shadow?8:0);if(i||j)if(e)e.animate(e.crisp({width:c-n,height:d-n}));else{e={fill:j||"none"};if(i)e.stroke=a.borderColor,e["stroke-width"]=i;this.chartBackground=b.rect(n/2,n/2,c-n,d-n,a.borderRadius,i).attr(e).addClass("highcharts-background").add().shadow(a.shadow)}if(k)f?f.animate(w):this.plotBackground=b.rect(o,p,r,q,0).attr({fill:k}).add().shadow(a.plotShadow);if(l)h?h.animate(w):this.plotBGImage=b.image(l,o,p,r,q).add();v?v.animate({width:s.width,height:s.height}):
	this.clipRect=b.clipRect(s);if(m)g?(g.strokeWidth=-m,g.animate(g.crisp({x:o,y:p,width:r,height:q}))):this.plotBorder=b.rect(o,p,r,q,0,-m).attr({stroke:a.plotBorderColor,"stroke-width":m,fill:"none",zIndex:1}).add();this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,e,f;q(["inverted","angular","polar"],function(g){c=L[b.type||b.defaultSeriesType];f=a[g]||b[g]||c&&c.prototype[g];for(e=d&&d.length;!f&&e--;)(c=L[d[e].type])&&c.prototype[g]&&(f=!0);a[g]=f})},
	linkSeries:function(){var a=this,b=a.series;q(b,function(a){a.linkedSeries.length=0});q(b,function(b){var d=b.options.linkedTo;if(ya(d)&&(d=d===":previous"?a.series[b.index-1]:a.get(d)))d.linkedSeries.push(b),b.linkedParent=d,b.visible=p(b.options.visible,d.options.visible,b.visible)})},renderSeries:function(){q(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&q(b.items,function(c){var d=x(b.style,c.style),e=B(d.left)+a.plotLeft,f=
	B(d.top)+a.plotTop+12;delete d.left;delete d.top;a.renderer.text(c.html,e,f).attr({zIndex:2}).css(d).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,d,e,f,g;this.setTitle();this.legend=new rb(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();d=this.plotWidth;e=this.plotHeight-=21;q(a,function(a){a.setScale()});this.getAxisMargins();f=d/this.plotWidth>1.1;g=e/this.plotHeight>1.05;if(f||g)this.maxTicks=null,q(a,function(a){(a.horiz&&f||
	!a.horiz&&g)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&q(a,function(a){a.visible&&a.render()});if(!this.seriesGroup)this.seriesGroup=b.g("series-group").attr({zIndex:3}).add();this.renderSeries();this.renderLabels();this.showCredits(c.credits);this.hasRendered=!0},showCredits:function(a){if(a.enabled&&!this.credits)this.credits=this.renderer.text(a.text,0,0).on("click",function(){if(a.href)D.location.href=a.href}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position)},
	destroy:function(){var a=this,b=a.axes,c=a.series,d=a.container,e,f=d&&d.parentNode;I(a,"destroy");T[a.index]=A;gb--;a.renderTo.removeAttribute("data-highcharts-chart");Y(a);for(e=b.length;e--;)b[e]=b[e].destroy();for(e=c.length;e--;)c[e]=c[e].destroy();q("title,subtitle,chartBackground,plotBackground,plotBGImage,plotBorder,seriesGroup,clipRect,credits,pointer,scroller,rangeSelector,legend,resetZoomButton,tooltip,renderer".split(","),function(b){var c=a[b];c&&c.destroy&&(a[b]=c.destroy())});if(d)d.innerHTML=
	"",Y(d),f&&Ua(d);for(e in a)delete a[e]},isReadyToRender:function(){var a=this;return!ga&&D==D.top&&y.readyState!=="complete"||la&&!D.canvg?(la?Pb.push(function(){a.firstRender()},a.options.global.canvasToolsURL):y.attachEvent("onreadystatechange",function(){y.detachEvent("onreadystatechange",a.firstRender);y.readyState==="complete"&&a.firstRender()}),!1):!0},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();I(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();
	a.getAxes();q(b.series||[],function(b){a.initSeries(b)});a.linkSeries();I(a,"beforeRender");if(u.Pointer)a.pointer=new Za(a,b);a.render();a.renderer.draw();if(!a.renderer.imgCount&&a.onload)a.onload();a.cloneRenderTo(!0)}},onload:function(){var a=this;q([this.callback].concat(this.callbacks),function(b){b&&a.index!==void 0&&b.apply(a,[a])});I(a,"load");this.onload=null},splashArray:function(a,b){var c=b[a],c=$(c)?c:[c,c,c,c];return[p(b[a+"Top"],c[0]),p(b[a+"Right"],c[1]),p(b[a+"Bottom"],c[2]),p(b[a+
	"Left"],c[3])]}};var Db=u.CenteredSeriesMixin={getCenter:function(){var a=this.options,b=this.chart,c=2*(a.slicedOffset||0),d=b.plotWidth-2*c,b=b.plotHeight-2*c,e=a.center,e=[p(e[0],"50%"),p(e[1],"50%"),a.size||"100%",a.innerSize||0],f=F(d,b),g,h;for(g=0;g<4;++g)h=e[g],a=g<2||g===2&&/%$/.test(h),e[g]=(/%$/.test(h)?[d,b,f,e[2]][g]*parseFloat(h)/100:parseFloat(h))+(a?c:0);e[3]>e[2]&&(e[3]=e[2]);return e}},Ma=function(){};Ma.prototype={init:function(a,b,c){this.series=a;this.color=a.color;this.applyOptions(b,
	c);this.pointAttr={};if(a.options.colorByPoint&&(b=a.options.colors||a.chart.options.colors,this.color=this.color||b[a.colorCounter++],a.colorCounter===b.length))a.colorCounter=0;a.chart.pointCount++;return this},applyOptions:function(a,b){var c=this.series,d=c.options.pointValKey||c.pointValKey,a=Ma.prototype.optionsToObject.call(this,a);x(this,a);this.options=this.options?x(this.options,a):a;if(d)this.y=this[d];this.isNull=this.x===null||!J(this.y,!0);if(this.x===void 0&&c)this.x=b===void 0?c.autoIncrement(this):
	b;if(c.xAxis&&c.xAxis.names)c.xAxis.names[this.x]=this.name;return this},optionsToObject:function(a){var b={},c=this.series,d=c.options.keys,e=d||c.pointArrayMap||["y"],f=e.length,g=0,h=0;if(J(a)||a===null)b[e[0]]=a;else if(Fa(a)){if(!d&&a.length>f){c=typeof a[0];if(c==="string")b.name=a[0];else if(c==="number")b.x=a[0];g++}for(;h<f;){if(!d||a[g]!==void 0)b[e[h]]=a[g];g++;h++}}else if(typeof a==="object"){b=a;if(a.dataLabels)c._hasPointLabels=!0;if(a.marker)c._hasPointMarkers=!0}return b},destroy:function(){var a=
	this.series.chart,b=a.hoverPoints,c;a.pointCount--;if(b&&(this.setState(),ra(b,this),!b.length))a.hoverPoints=null;if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)Y(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(c in this)this[c]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],b,c=6;c--;)b=a[c],this[b]&&(this[b]=this[b].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,
	color:this.color,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var b=this.series,c=b.tooltipOptions,d=p(c.valueDecimals,""),e=c.valuePrefix||"",f=c.valueSuffix||"";q(b.pointArrayMap||["y"],function(b){b="{point."+b;if(e||f)a=a.replace(b+"}",e+b+"}"+f);a=a.replace(b+"}",b+":,."+d+"f}")});return Na(a,{point:this,series:this.series})},firePointEvent:function(a,b,c){var d=this,e=this.series.options;
	(e.point.events[a]||d.options&&d.options.events&&d.options.events[a])&&this.importEvents();a==="click"&&e.allowPointSelect&&(c=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});I(this,a,b,c)},visible:!0};var R=u.Series=function(){};R.prototype={isCartesian:!0,type:"line",pointClass:Ma,sorted:!0,requireSorting:!0,pointAttrToOptions:{stroke:"lineColor","stroke-width":"lineWidth",fill:"fillColor",r:"radius"},directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x",
	"y"],init:function(a,b){var c=this,d,e,f=a.series,g=function(a,b){return p(a.options.index,a._i)-p(b.options.index,b._i)};c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();x(c,{name:b.name,state:"",pointAttr:{},visible:b.visible!==!1,selected:b.selected===!0});if(la)b.animation=!1;e=b.events;for(d in e)N(c,d,e[d]);if(e&&e.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();q(c.parallelArrays,function(a){c[a+"Data"]=
	[]});c.setData(b.data,!1);if(c.isCartesian)a.hasCartesianSeries=!0;f.push(c);c._i=f.length-1;jb(f,g);this.yAxis&&jb(this.yAxis.series,g);q(f,function(a,b){a.index=b;a.name=a.name||"Series "+(b+1)})},bindAxes:function(){var a=this,b=a.options,c=a.chart,d;q(a.axisTypes||[],function(e){q(c[e],function(c){d=c.options;if(b[e]===d.index||b[e]!==A&&b[e]===d.id||b[e]===A&&d.index===0)c.series.push(a),a[e]=c,c.isDirty=!0});!a[e]&&a.optionalAxis!==e&&ca(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,
	d=arguments,e=J(b)?function(d){var e=d==="y"&&c.toYData?c.toYData(a):a[d];c[d+"Data"][b]=e}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,2))};q(c.parallelArrays,e)},autoIncrement:function(a){var g;var b=this.options,c=this.xIncrement,d=b.pointIntervalUnit,e=this.xAxis,f,c=p(c,b.pointStart,0);this.pointInterval=b=p(this.pointInterval,b.pointInterval,1);if(e&&e.categories&&a.name)if(this.requireSorting=!1,g=(f=Fa(e.categories))?e.categories:e.names,e=g,a=pa(a.name,e),
	a===-1){if(!f)c=e.length}else c=a;d&&(a=new ma(c),d==="day"?a=+a[mb](a[Wa]()+b):d==="month"?a=+a[zb](a[cb]()+b):d==="year"&&(a=+a[Ab](a[db]()+b)),b=a-c);this.xIncrement=c+b;return c},setOptions:function(a){var b=this.chart,c=b.options.plotOptions,b=b.userOptions||{},d=b.plotOptions||{},e=c[this.type];this.userOptions=a;c=E(e,c.series,a);this.tooltipOptions=E(U.tooltip,U.plotOptions[this.type].tooltip,b.tooltip,d.series&&d.series.tooltip,d[this.type]&&d[this.type].tooltip,a.tooltip);e.marker===null&&
	delete c.marker;this.zoneAxis=c.zoneAxis;a=this.zones=(c.zones||[]).slice();if((c.negativeColor||c.negativeFillColor)&&!c.zones)a.push({value:c[this.zoneAxis+"Threshold"]||c.threshold||0,color:c.negativeColor,fillColor:c.negativeFillColor});a.length&&s(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return c},getCyclic:function(a,b,c){var d=this.userOptions,e="_"+a+"Index",f=a+"Counter";b||(s(d[e])?b=d[e]:(d[e]=b=this.chart[f]%c.length,this.chart[f]+=1),b=c[b]);this[a]=b},
	getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||fa[this.type].color,this.chart.options.colors)},getSymbol:function(){var a=this.options.marker;this.getCyclic("symbol",a.symbol,this.chart.options.symbols);if(/^url/.test(this.symbol))a.radius=0},drawLegendSymbol:K.drawLineMarker,setData:function(a,b,c,d){var e=this,f=e.points,g=f&&f.length||0,h,i=e.options,j=e.chart,k=null,l=e.xAxis,m=i.turboThreshold,n=this.xData,o=this.yData,z=(h=e.pointArrayMap)&&
	h.length,a=a||[];h=a.length;b=p(b,!0);if(d!==!1&&h&&g===h&&!e.cropped&&!e.hasGroupedData&&e.visible)q(a,function(a,b){f[b].update&&a!==i.data[b]&&f[b].update(a,!1,null,!1)});else{e.xIncrement=null;e.colorCounter=0;q(this.parallelArrays,function(a){e[a+"Data"].length=0});if(m&&h>m){for(c=0;k===null&&c<h;)k=a[c],c++;if(J(k)){k=p(i.pointStart,0);z=p(i.pointInterval,1);for(c=0;c<h;c++)n[c]=k,o[c]=a[c],k+=z;e.xIncrement=k}else if(Fa(k))if(z)for(c=0;c<h;c++)k=a[c],n[c]=k[0],o[c]=k.slice(1,z+1);else for(c=
	0;c<h;c++)k=a[c],n[c]=k[0],o[c]=k[1];else ca(12)}else for(c=0;c<h;c++)a[c]!==A&&(k={series:e},e.pointClass.prototype.applyOptions.apply(k,[a[c]]),e.updateParallelArrays(k,c));ya(o[0])&&ca(14,!0);e.data=[];e.options.data=e.userOptions.data=a;for(c=g;c--;)f[c]&&f[c].destroy&&f[c].destroy();if(l)l.minRange=l.userMinRange;e.isDirty=e.isDirtyData=j.isDirtyBox=!0;c=!1}i.legendType==="point"&&(this.processData(),this.generatePoints());b&&j.redraw(c)},processData:function(a){var b=this.xData,c=this.yData,
	d=b.length,e;e=0;var f,g,h=this.xAxis,i,j=this.options;i=j.cropThreshold;var k=this.getExtremesFromAll||j.getExtremesFromAll,l=this.isCartesian,j=h&&h.val2lin,m=h&&h.isLog,n,o;if(l&&!this.isDirty&&!h.isDirty&&!this.yAxis.isDirty&&!a)return!1;if(h)a=h.getExtremes(),n=a.min,o=a.max;if(l&&this.sorted&&!k&&(!i||d>i||this.forceCrop))if(b[d-1]<n||b[0]>o)b=[],c=[];else if(b[0]<n||b[d-1]>o)e=this.cropData(this.xData,this.yData,n,o),b=e.xData,c=e.yData,e=e.start,f=!0;for(i=b.length||1;--i;)d=m?j(b[i])-j(b[i-
	1]):b[i]-b[i-1],d>0&&(g===A||d<g)?g=d:d<0&&this.requireSorting&&ca(15);this.cropped=f;this.cropStart=e;this.processedXData=b;this.processedYData=c;this.closestPointRange=g},cropData:function(a,b,c,d){var e=a.length,f=0,g=e,h=p(this.cropShoulder,1),i;for(i=0;i<e;i++)if(a[i]>=c){f=t(0,i-h);break}for(c=i;c<e;c++)if(a[c]>d){g=c+h;break}return{xData:a.slice(f,g),yData:b.slice(f,g),start:f,end:g}},generatePoints:function(){var a=this.options.data,b=this.data,c,d=this.processedXData,e=this.processedYData,
	f=this.pointClass,g=d.length,h=this.cropStart||0,i,j=this.hasGroupedData,k,l=[],m;if(!b&&!j)b=[],b.length=a.length,b=this.data=b;for(m=0;m<g;m++)i=h+m,j?(l[m]=(new f).init(this,[d[m]].concat(ua(e[m]))),l[m].dataGroup=this.groupMap[m]):(b[i]?k=b[i]:a[i]!==A&&(b[i]=k=(new f).init(this,a[i],d[m])),l[m]=k),l[m].index=i;if(b&&(g!==(c=b.length)||j))for(m=0;m<c;m++)if(m===h&&!j&&(m+=g),b[m])b[m].destroyElements(),b[m].plotX=A;this.data=b;this.points=l},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,
	d,e=[],f=0;d=this.xAxis.getExtremes();var g=d.min,h=d.max,i,j,k,l,a=a||this.stackedYData||this.processedYData||[];d=a.length;for(l=0;l<d;l++)if(j=c[l],k=a[l],i=k!==null&&k!==A&&(!b.isLog||k.length||k>0),j=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[l+1]||j)>=g&&(c[l-1]||j)<=h,i&&j)if(i=k.length)for(;i--;)k[i]!==null&&(e[f++]=k[i]);else e[f++]=k;this.dataMin=Oa(e);this.dataMax=Ha(e)},translate:function(){this.processedXData||this.processData();this.generatePoints();for(var a=
	this.options,b=a.stacking,c=this.xAxis,d=c.categories,e=this.yAxis,f=this.points,g=f.length,h=!!this.modifyValue,i=a.pointPlacement,j=i==="between"||J(i),k=a.threshold,l=a.startFromThreshold?k:0,m,n,o,q,r=Number.MAX_VALUE,a=0;a<g;a++){var G=f[a],w=G.x,v=G.y;n=G.low;var x=b&&e.stacks[(this.negStacks&&v<(l?0:k)?"-":"")+this.stackKey],u;if(e.isLog&&v!==null&&v<=0)G.y=v=null,ca(10);G.plotX=m=aa(F(t(-1E5,c.translate(w,0,0,0,1,i,this.type==="flags")),1E5));if(b&&this.visible&&!G.isNull&&x&&x[w])q=this.getStackIndicator(q,
	w,this.index),u=x[w],v=u.points[q.key],n=v[0],v=v[1],n===l&&q.key===x[w].base&&(n=p(k,e.min)),e.isLog&&n<=0&&(n=null),G.total=G.stackTotal=u.total,G.percentage=u.total&&G.y/u.total*100,G.stackY=v,u.setOffset(this.pointXOffset||0,this.barW||0);G.yBottom=s(n)?e.translate(n,0,1,0,1):null;h&&(v=this.modifyValue(v,G));G.plotY=n=typeof v==="number"&&v!==Infinity?F(t(-1E5,e.translate(v,0,1,0,1)),1E5):A;G.isInside=n!==A&&n>=0&&n<=e.len&&m>=0&&m<=c.len;G.clientX=j?aa(c.translate(w,0,0,0,1)):m;G.negative=G.y<
	(k||0);G.category=d&&d[G.x]!==A?d[G.x]:G.x;G.isNull||(o!==void 0&&(r=F(r,Q(m-o))),o=m)}this.closestPointRangePx=r},getValidPoints:function(a,b){var c=this.chart;return Ca(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,e=b.inverted,f=this.clipBox,g=f||b.clipBox,h=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,g.height,c.xAxis,c.yAxis].join(","),i=b[h],j=b[h+"m"];if(!i){if(a)g.width=
	0,b[h+"m"]=j=d.clipRect(-99,e?-b.plotLeft:-b.plotTop,99,e?b.chartWidth:b.chartHeight);b[h]=i=d.clipRect(g);i.count={length:0}}a&&!i.count[this.index]&&(i.count[this.index]=!0,i.count.length+=1);if(c.clip!==!1)this.group.clip(a||f?i:b.clipRect),this.markerGroup.clip(j),this.sharedClipKey=h;a||(i.count[this.index]&&(delete i.count[this.index],i.count.length-=1),i.count.length===0&&h&&b[h]&&(f||(b[h]=b[h].destroy()),b[h+"m"]&&(b[h+"m"]=b[h+"m"].destroy())))},animate:function(a){var b=this.chart,c=this.options.animation,
	d;if(c&&!$(c))c=fa[this.type].animation;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();I(this,"afterAnimate")},drawPoints:function(){var a,b=this.points,c=this.chart,d,e,f,g,h,i,j,k,l=this.options.marker,m=this.pointAttr[""],n,o,q,r=this.markerGroup,s=p(l.enabled,this.xAxis.isRadial,this.closestPointRangePx>2*l.radius);if(l.enabled!==!1||this._hasPointMarkers)for(f=
	b.length;f--;)if(g=b[f],d=V(g.plotX),e=g.plotY,k=g.graphic,n=g.marker||{},o=!!g.marker,a=s&&n.enabled===A||n.enabled,q=g.isInside,a&&J(e)&&g.y!==null)if(a=g.pointAttr[g.selected?"select":""]||m,h=a.r,i=p(n.symbol,this.symbol),j=i.indexOf("url")===0,k)k[q?"show":"hide"](!0).attr(a).animate(x({x:d-h,y:e-h},k.symbolName?{width:2*h,height:2*h}:{}));else{if(q&&(h>0||j))g.graphic=c.renderer.symbol(i,d-h,e-h,2*h,2*h,o?n:l).attr(a).add(r)}else if(k)g.graphic=k.destroy()},convertAttribs:function(a,b,c,d){var e=
	this.pointAttrToOptions,f,g,h={},a=a||{},b=b||{},c=c||{},d=d||{};for(f in e)g=e[f],h[f]=p(a[g],b[f],c[f],d[f]);return h},getAttribs:function(){var a=this,b=a.options,c=fa[a.type].marker?b.marker:b,d=c.states,e=d.hover,f,g=a.color,h=a.options.negativeColor,i={stroke:g,fill:g},j=a.points||[],k,l=[],m,n=a.pointAttrToOptions;f=a.hasPointSpecificOptions;var o=c.lineColor,z=c.fillColor;k=b.turboThreshold;var r=a.zones,t=a.zoneAxis||"y",w,v;b.marker?(e.radius=+e.radius||+c.radius+ +e.radiusPlus,e.lineWidth=
	e.lineWidth||c.lineWidth+e.lineWidthPlus):(e.color=e.color||na(e.color||g).brighten(e.brightness).get(),e.negativeColor=e.negativeColor||na(e.negativeColor||h).brighten(e.brightness).get());l[""]=a.convertAttribs(c,i);q(["hover","select"],function(b){l[b]=a.convertAttribs(d[b],l[""])});a.pointAttr=l;g=j.length;if(!k||g<k||f)for(;g--;){k=j[g];if((c=k.options&&k.options.marker||k.options)&&c.enabled===!1)c.radius=0;i=null;if(r.length){f=0;for(i=r[f];k[t]>=i.value;)i=r[++f];k.color=k.fillColor=i=p(i.color,
	a.color)}f=b.colorByPoint||k.color;if(k.options)for(v in n)s(c[n[v]])&&(f=!0);if(f){c=c||{};m=[];d=c.states||{};f=d.hover=d.hover||{};if(!b.marker||k.negative&&!f.fillColor&&!e.fillColor)f[a.pointAttrToOptions.fill]=f.color||!k.options.color&&e[k.negative&&h?"negativeColor":"color"]||na(k.color).brighten(f.brightness||e.brightness).get();w={color:k.color};if(!z)w.fillColor=k.color;if(!o)w.lineColor=k.color;c.hasOwnProperty("color")&&!c.color&&delete c.color;if(i&&!e.fillColor)f.fillColor=i;m[""]=
	a.convertAttribs(x(w,c),l[""]);m.hover=a.convertAttribs(d.hover,l.hover,m[""]);m.select=a.convertAttribs(d.select,l.select,m[""])}else m=l;k.pointAttr=m}},destroy:function(){var a=this,b=a.chart,c=/AppleWebKit\/533/.test(Aa),d,e=a.data||[],f,g,h;I(a,"destroy");Y(a);q(a.axisTypes||[],function(b){if(h=a[b])ra(h.series,a),h.isDirty=h.forceRedraw=!0});a.legendItem&&a.chart.legend.destroyItem(a);for(d=e.length;d--;)(f=e[d])&&f.destroy&&f.destroy();a.points=null;clearTimeout(a.animationTimeout);for(g in a)a[g]instanceof
	O&&!a[g].survive&&(d=c&&g==="group"?"hide":"destroy",a[g][d]());if(b.hoverSeries===a)b.hoverSeries=null;ra(b.series,a);for(g in a)delete a[g]},getGraphPath:function(a,b,c){var d=this,e=d.options,f=e.step,g,h=[],i=[],j,a=a||d.points;(g=a.reversed)&&a.reverse();(f={right:1,center:2}[f]||f&&3)&&g&&(f=4-f);e.connectNulls&&!b&&!c&&(a=this.getValidPoints(a));q(a,function(g,l){var m=g.plotX,n=g.plotY,o=a[l-1];if((g.leftCliff||o&&o.rightCliff)&&!c)j=!0;g.isNull&&!s(b)&&l>0?j=!e.connectNulls:g.isNull&&!b?
	j=!0:(l===0||j?o=[X,g.plotX,g.plotY]:d.getPointSpline?o=d.getPointSpline(a,g,l):f?(o=f===1?[S,o.plotX,n]:f===2?[S,(o.plotX+m)/2,o.plotY,S,(o.plotX+m)/2,n]:[S,m,o.plotY],o.push(S,m,n)):o=[S,m,n],i.push(g.x),f&&i.push(g.x),h.push.apply(h,o),j=!1)});h.xMap=i;return d.graphPath=h},drawGraph:function(){var a=this,b=this.options,c=[["graph",b.lineColor||this.color,b.dashStyle]],d=b.lineWidth,e=b.linecap!=="square",f=(this.gappedPath||this.getGraphPath).call(this);q(this.zones,function(d,e){c.push(["zoneGraph"+
	e,d.color||a.color,d.dashStyle||b.dashStyle])});q(c,function(c,h){var i=c[0],j=a[i];if(j)j.endX=f.xMap,j.animate({d:f});else if(d&&f.length)j={stroke:c[1],"stroke-width":d,fill:"none",zIndex:1},c[2]?j.dashstyle=c[2]:e&&(j["stroke-linecap"]=j["stroke-linejoin"]="round"),j=a[i]=a.chart.renderer.path(f).attr(j).add(a.group).shadow(h<2&&b.shadow);if(j)j.startX=f.xMap,j.isArea=f.isArea})},applyZones:function(){var a=this,b=this.chart,c=b.renderer,d=this.zones,e,f,g=this.clips||[],h,i=this.graph,j=this.area,
	k=t(b.chartWidth,b.chartHeight),l=this[(this.zoneAxis||"y")+"Axis"],m,n=l.reversed,o=b.inverted,z=l.horiz,r,s,w,v=!1;if(d.length&&(i||j)&&l.min!==A)i&&i.hide(),j&&j.hide(),m=l.getExtremes(),q(d,function(d,q){e=n?z?b.plotWidth:0:z?0:l.toPixels(m.min);e=F(t(p(f,e),0),k);f=F(t(C(l.toPixels(p(d.value,m.max),!0)),0),k);v&&(e=f=l.toPixels(m.max));r=Math.abs(e-f);s=F(e,f);w=t(e,f);if(l.isXAxis){if(h={x:o?w:s,y:0,width:r,height:k},!z)h.x=b.plotHeight-h.x}else if(h={x:0,y:o?w:s,width:k,height:r},z)h.y=b.plotWidth-
	h.y;b.inverted&&c.isVML&&(h=l.isXAxis?{x:0,y:n?s:w,height:h.width,width:b.chartWidth}:{x:h.y-b.plotLeft-b.spacingBox.x,y:0,width:h.height,height:b.chartHeight});g[q]?g[q].animate(h):(g[q]=c.clipRect(h),i&&a["zoneGraph"+q].clip(g[q]),j&&a["zoneArea"+q].clip(g[q]));v=d.value>m.max}),this.clips=g},invertGroups:function(){function a(){var a={width:b.yAxis.len,height:b.xAxis.len};q(["group","markerGroup"],function(c){b[c]&&b[c].attr(a).invert()})}var b=this,c=b.chart;if(b.xAxis)N(c,"resize",a),N(b,"destroy",
	function(){Y(c,"resize",a)}),a(),b.invertGroups=a},plotGroup:function(a,b,c,d,e){var f=this[a],g=!f;g&&(this[a]=f=this.chart.renderer.g(b).attr({zIndex:d||0.1}).add(e),f.addClass("highcharts-series-"+this.index));f.attr({visibility:c})[g?"attr":"animate"](this.getPlotBox());return f},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;if(a.inverted)b=c,c=this.xAxis;return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,
	c,d=a.options,e=!!a.animate&&b.renderer.isSVG&&bb(d.animation).duration,f=a.visible?"inherit":"hidden",g=d.zIndex,h=a.hasRendered,i=b.seriesGroup;c=a.plotGroup("group","series",f,g,i);a.markerGroup=a.plotGroup("markerGroup","markers",f,g,i);e&&a.animate(!0);a.getAttribs();c.inverted=a.isCartesian?b.inverted:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());q(a.points,function(a){a.redraw&&a.redraw()});a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&a.options.enableMouseTracking!==
	!1&&a.drawTracker();b.inverted&&a.invertGroups();d.clip!==!1&&!a.sharedClipKey&&!h&&c.clip(b.clipRect);e&&a.animate();if(!h)a.animationTimeout=Ra(function(){a.afterAnimate()},e);a.isDirty=a.isDirtyData=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,d=this.xAxis,e=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:p(d&&d.left,a.plotLeft),translateY:p(e&&e.top,a.plotTop)}));this.translate();this.render();
	b&&delete this.kdTree},kdDimensions:1,kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,e=this.chart.inverted;return this.searchKDTree({clientX:e?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:e?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,e,f){var g,h;if(h=c&&c.length)return g=b.kdAxisArray[e%f],c.sort(function(a,b){return a[g]-b[g]}),h=Math.floor(h/2),{point:c[h],left:a(c.slice(0,h),e+1,f),right:a(c.slice(h+1),e+1,f)}}var b=this,c=
	b.kdDimensions;delete b.kdTree;Ra(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c)},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,j,k){var l=b.point,m=d.kdAxisArray[j%k],n,o,p=l;o=s(a[e])&&s(l[e])?Math.pow(a[e]-l[e],2):null;n=s(a[f])&&s(l[f])?Math.pow(a[f]-l[f],2):null;n=(o||0)+(n||0);l.dist=s(n)?Math.sqrt(n):Number.MAX_VALUE;l.distX=s(o)?Math.sqrt(o):Number.MAX_VALUE;m=a[m]-l[m];n=m<0?"left":"right";o=m<0?"right":"left";b[n]&&(n=c(a,b[n],j+1,k),p=n[g]<p[g]?n:l);
	b[o]&&Math.sqrt(m*m)<p[g]&&(a=c(a,b[o],j+1,k),p=a[g]<p[g]?a:p);return p}var d=this,e=this.kdAxisArray[0],f=this.kdAxisArray[1],g=b?"distX":"dist";this.kdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,this.kdDimensions,this.kdDimensions)}};Lb.prototype={destroy:function(){Ta(this,this.axis)},render:function(a){var b=this.options,c=b.format,c=c?Na(c,this):b.formatter.call(this);this.label?this.label.attr({text:c,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(c,null,null,
	b.useHTML).css(b.style).attr({align:this.textAlign,rotation:b.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,b){var c=this.axis,d=c.chart,e=d.inverted,f=c.reversed,f=this.isNegative&&!f||!this.isNegative&&f,g=c.translate(c.usePercentage?100:this.total,0,0,0,1),c=c.translate(0),c=Q(g-c),h=d.xAxis[0].translate(this.x)+a,i=d.plotHeight,f={x:e?f?g:g-c:h,y:e?i-h-b:f?i-g-c:i-g,width:e?c:b,height:e?b:c};if(e=this.label)e.align(this.alignOptions,null,f),f=e.alignAttr,e[this.options.crop===!1||
	d.isInsidePlot(f.x,f.y)?"show":"hide"](!0)}};ib.prototype.getStacks=function(){var a=this;q(a.yAxis,function(a){if(a.stacks&&a.hasVisibleSeries)a.oldStacks=a.stacks});q(a.series,function(b){if(b.options.stacking&&(b.visible===!0||a.options.chart.ignoreHiddenSeries===!1))b.stackKey=b.type+p(b.options.stack,"")})};ia.prototype.buildStacks=function(){var a=this.series,b,c=p(this.options.reversedStacks,!0),d=a.length,e;if(!this.isXAxis){this.usePercentage=!1;for(e=d;e--;)a[c?e:d-e-1].setStackedPoints();
	for(e=d;e--;)b=a[c?e:d-e-1],b.setStackCliffs&&b.setStackCliffs();if(this.usePercentage)for(e=0;e<d;e++)a[e].setPercentStacks()}};ia.prototype.renderStackTotals=function(){var a=this.chart,b=a.renderer,c=this.stacks,d,e,f=this.stackTotalGroup;if(!f)this.stackTotalGroup=f=b.g("stack-labels").attr({visibility:"visible",zIndex:6}).add();f.translate(a.plotLeft,a.plotTop);for(d in c)for(e in a=c[d],a)a[e].render(f)};ia.prototype.resetStacks=function(){var a=this.stacks,b,c;if(!this.isXAxis)for(b in a)for(c in a[b])a[b][c].touched<
	this.stacksTouched?(a[b][c].destroy(),delete a[b][c]):(a[b][c].total=null,a[b][c].cum=0)};ia.prototype.cleanStacks=function(){var a,b,c;if(!this.isXAxis){if(this.oldStacks)a=this.stacks=this.oldStacks;for(b in a)for(c in a[b])a[b][c].cum=a[b][c].total}};R.prototype.setStackedPoints=function(){if(this.options.stacking&&!(this.visible!==!0&&this.chart.options.chart.ignoreHiddenSeries!==!1)){var a=this.processedXData,b=this.processedYData,c=[],d=b.length,e=this.options,f=e.threshold,g=e.startFromThreshold?
	f:0,h=e.stack,e=e.stacking,i=this.stackKey,j="-"+i,k=this.negStacks,l=this.yAxis,m=l.stacks,n=l.oldStacks,o,q,r,x,w,v,u;l.stacksTouched+=1;for(w=0;w<d;w++){v=a[w];u=b[w];o=this.getStackIndicator(o,v,this.index);x=o.key;r=(q=k&&u<(g?0:f))?j:i;m[r]||(m[r]={});if(!m[r][v])n[r]&&n[r][v]?(m[r][v]=n[r][v],m[r][v].total=null):m[r][v]=new Lb(l,l.options.stackLabels,q,v,h);r=m[r][v];if(u!==null){r.points[x]=r.points[this.index]=[p(r.cum,g)];if(!s(r.cum))r.base=x;r.touched=l.stacksTouched;o.index>0&&this.singleStacks===
	!1&&(r.points[x][0]=r.points[this.index+","+v+",0"][0])}e==="percent"?(q=q?i:j,k&&m[q]&&m[q][v]?(q=m[q][v],r.total=q.total=t(q.total,r.total)+Q(u)||0):r.total=aa(r.total+(Q(u)||0))):r.total=aa(r.total+(u||0));r.cum=p(r.cum,g)+(u||0);if(u!==null)r.points[x].push(r.cum),c[w]=r.cum}if(e==="percent")l.usePercentage=!0;this.stackedYData=c;l.oldStacks={}}};R.prototype.setPercentStacks=function(){var a=this,b=a.stackKey,c=a.yAxis.stacks,d=a.processedXData,e;q([b,"-"+b],function(b){var f;for(var g=d.length,
	h,i;g--;)if(h=d[g],e=a.getStackIndicator(e,h,a.index),f=(i=c[b]&&c[b][h])&&i.points[e.key],h=f)i=i.total?100/i.total:0,h[0]=aa(h[0]*i),h[1]=aa(h[1]*i),a.stackedYData[g]=h[1]})};R.prototype.getStackIndicator=function(a,b,c){!s(a)||a.x!==b?a={x:b,index:0}:a.index++;a.key=[c,b,a.index].join(",");return a};x(ib.prototype,{addSeries:function(a,b,c){var d,e=this;a&&(b=p(b,!0),I(e,"addSeries",{options:a},function(){d=e.initSeries(a);e.isDirtyLegend=!0;e.linkSeries();b&&e.redraw(c)}));return d},addAxis:function(a,
	b,c,d){var e=b?"xAxis":"yAxis",f=this.options,a=E(a,{index:this[e].length,isX:b});new ia(this,a);f[e]=ua(f[e]||{});f[e].push(a);p(c,!0)&&this.redraw(d)},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,e=c.loading,f=function(){d&&M(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};if(!d)b.loadingDiv=d=da(Pa,{className:"highcharts-loading"},x(e.style,{zIndex:10,display:"none"}),b.container),b.loadingSpan=da("span",null,e.labelStyle,d),N(b,"redraw",
	f);b.loadingSpan.innerHTML=a||c.lang.loading;if(!b.loadingShown)M(d,{opacity:0,display:""}),Ya(d,{opacity:e.style.opacity},{duration:e.showDuration||0}),b.loadingShown=!0;f()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&Ya(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){M(b,{display:"none"})}});this.loadingShown=!1}});x(Ma.prototype,{update:function(a,b,c,d){function e(){f.applyOptions(a);if(f.y===null&&h)f.graphic=h.destroy();if($(a,!0))f.redraw=function(){if(h&&
	h.element&&a&&a.marker&&a.marker.symbol)f.graphic=h.destroy();if(a&&a.dataLabels&&f.dataLabel)f.dataLabel=f.dataLabel.destroy();f.redraw=null};i=f.index;g.updateParallelArrays(f,i);if(l&&f.name)l[f.x]=f.name;k.data[i]=$(k.data[i],!0)?f.options:a;g.isDirty=g.isDirtyData=!0;if(!g.fixedBox&&g.hasCartesianSeries)j.isDirtyBox=!0;if(k.legendType==="point")j.isDirtyLegend=!0;b&&j.redraw(c)}var f=this,g=f.series,h=f.graphic,i,j=g.chart,k=g.options,l=g.xAxis&&g.xAxis.names,b=p(b,!0);d===!1?e():f.firePointEvent("update",
	{options:a},e)},remove:function(a,b){this.series.removePoint(pa(this,this.series.data),a,b)}});x(R.prototype,{addPoint:function(a,b,c,d){var e=this.options,f=this.data,g=this.chart,h=this.xAxis&&this.xAxis.names,i=e.data,j,k=this.xData,l,m;Va(d,g);b=p(b,!0);d={series:this};this.pointClass.prototype.applyOptions.apply(d,[a]);m=d.x;l=k.length;if(this.requireSorting&&m<k[l-1])for(j=!0;l&&k[l-1]>m;)l--;this.updateParallelArrays(d,"splice",l,0,0);this.updateParallelArrays(d,l);if(h&&d.name)h[m]=d.name;
	i.splice(l,0,a);j&&(this.data.splice(l,0,null),this.processData());e.legendType==="point"&&this.generatePoints();c&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(d,"shift"),i.shift()));this.isDirtyData=this.isDirty=!0;b&&(this.getAttribs(),g.redraw())},removePoint:function(a,b,c){var d=this,e=d.data,f=e[a],g=d.points,h=d.chart,i=function(){g&&g.length===e.length&&g.splice(a,1);e.splice(a,1);d.options.data.splice(a,1);d.updateParallelArrays(f||{series:d},"splice",a,1);f&&
	f.destroy();d.isDirty=!0;d.isDirtyData=!0;b&&h.redraw()};Va(c,h);b=p(b,!0);f?f.firePointEvent("remove",null,i):i()},remove:function(a,b){var c=this,d=c.chart;I(c,"remove",null,function(){c.destroy();d.isDirtyLegend=d.isDirtyBox=!0;d.linkSeries();p(a,!0)&&d.redraw(b)})},update:function(a,b){var c=this,d=this.chart,e=this.userOptions,f=this.type,g=L[f].prototype,h=["group","markerGroup","dataLabelsGroup"],i;if(a.type&&a.type!==f||a.zIndex!==void 0)h.length=0;q(h,function(a){h[a]=c[a];delete c[a]});
	a=E(e,{animation:!1,index:this.index,pointStart:this.xData[0]},{data:this.options.data},a);this.remove(!1);for(i in g)this[i]=A;x(this,L[a.type||f].prototype);q(h,function(a){c[a]=h[a]});this.init(d,a);d.linkSeries();p(b,!0)&&d.redraw(!1)}});x(ia.prototype,{update:function(a,b){var c=this.chart,a=c.options[this.coll][this.options.index]=E(this.userOptions,a);this.destroy(!0);this.init(c,x(a,{events:A}));c.isDirtyBox=!0;p(b,!0)&&c.redraw()},remove:function(a){for(var b=this.chart,c=this.coll,d=this.series,
	e=d.length;e--;)d[e]&&d[e].remove(!1);ra(b.axes,this);ra(b[c],this);b.options[c].splice(this.options.index,1);q(b[c],function(a,b){a.options.index=b});this.destroy();b.isDirtyBox=!0;p(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}});var xa=sa(R);L.line=xa;fa.area=E(ha,{softThreshold:!1,threshold:0});var qa=sa(R,{type:"area",singleStacks:!1,getStackPoints:function(){var a=[],b=[],c=this.xAxis,d=this.yAxis,e=d.stacks[this.stackKey],
	f={},g=this.points,h=this.index,i=d.series,j=i.length,k,l=p(d.options.reversedStacks,!0)?1:-1,m,n;if(this.options.stacking){for(m=0;m<g.length;m++)f[g[m].x]=g[m];for(n in e)e[n].total!==null&&b.push(n);b.sort(function(a,b){return a-b});k=Da(i,function(){return this.visible});q(b,function(g,i){var n=0,p,s;if(f[g]&&!f[g].isNull)a.push(f[g]),q([-1,1],function(a){var c=a===1?"rightNull":"leftNull",d=0,n=e[b[i+a]];if(n)for(m=h;m>=0&&m<j;)p=n.points[m],p||(m===h?f[g][c]=!0:k[m]&&(s=e[g].points[m])&&(d-=
	s[1]-s[0])),m+=l;f[g][a===1?"rightCliff":"leftCliff"]=d});else{for(m=h;m>=0&&m<j;){if(p=e[g].points[m]){n=p[1];break}m+=l}n=d.toPixels(n,!0);a.push({isNull:!0,plotX:c.toPixels(g,!0),plotY:n,yBottom:n})}})}return a},getGraphPath:function(a){var b=R.prototype.getGraphPath,c=this.options,d=c.stacking,e=this.yAxis,f,g,h=[],i=[],j=this.index,k,l=e.stacks[this.stackKey],m=c.threshold,n=e.getThreshold(c.threshold),o,c=c.connectNulls||d==="percent",q=function(b,c,f){var g=a[b],b=d&&l[g.x].points[j],o=g[f+
	"Null"]||0,f=g[f+"Cliff"]||0,p,q,g=!0;f||o?(p=(o?b[0]:b[1])+f,q=b[0]+f,g=!!o):!d&&a[c]&&a[c].isNull&&(p=q=m);p!==void 0&&(i.push({plotX:k,plotY:p===null?n:e.getThreshold(p),isNull:g}),h.push({plotX:k,plotY:q===null?n:e.getThreshold(q)}))},a=a||this.points;d&&(a=this.getStackPoints());for(f=0;f<a.length;f++)if(g=a[f].isNull,k=p(a[f].rectPlotX,a[f].plotX),o=p(a[f].yBottom,n),!g||c){c||q(f,f-1,"left");if(!g||d||!c)i.push(a[f]),h.push({x:f,plotX:k,plotY:o});c||q(f,f+1,"right")}f=b.call(this,i,!0,!0);
	h.reversed=!0;g=b.call(this,h,!0,!0);g.length&&(g[0]=S);g=f.concat(g);b=b.call(this,i,!1,c);g.xMap=f.xMap;this.areaPath=g;return b},drawGraph:function(){this.areaPath=[];R.prototype.drawGraph.apply(this);var a=this,b=this.areaPath,c=this.options,d=[["area",this.color,c.fillColor]];q(this.zones,function(b,f){d.push(["zoneArea"+f,b.color||a.color,b.fillColor||c.fillColor])});q(d,function(d){var f=d[0],g=a[f];g?(g.endX=b.xMap,g.animate({d:b})):(g={fill:d[2]||d[1],zIndex:0},d[2]||(g["fill-opacity"]=p(c.fillOpacity,
	0.75)),g=a[f]=a.chart.renderer.path(b).attr(g).add(a.group),g.isArea=!0);g.startX=b.xMap;g.shiftUnit=c.step?2:1})},drawLegendSymbol:K.drawRectangle});L.area=qa;fa.spline=E(ha);xa=sa(R,{type:"spline",getPointSpline:function(a,b,c){var d=b.plotX,e=b.plotY,f=a[c-1],c=a[c+1],g,h,i,j;if(f&&!f.isNull&&c&&!c.isNull){a=f.plotY;i=c.plotX;var c=c.plotY,k=0;g=(1.5*d+f.plotX)/2.5;h=(1.5*e+a)/2.5;i=(1.5*d+i)/2.5;j=(1.5*e+c)/2.5;i!==g&&(k=(j-h)*(i-d)/(i-g)+e-j);h+=k;j+=k;h>a&&h>e?(h=t(a,e),j=2*e-h):h<a&&h<e&&(h=
	F(a,e),j=2*e-h);j>c&&j>e?(j=t(c,e),h=2*e-j):j<c&&j<e&&(j=F(c,e),h=2*e-j);b.rightContX=i;b.rightContY=j}b=["C",p(f.rightContX,f.plotX),p(f.rightContY,f.plotY),p(g,d),p(h,e),d,e];f.rightContX=f.rightContY=null;return b}});L.spline=xa;fa.areaspline=E(fa.area);qa=qa.prototype;xa=sa(xa,{type:"areaspline",getStackPoints:qa.getStackPoints,getGraphPath:qa.getGraphPath,setStackCliffs:qa.setStackCliffs,drawGraph:qa.drawGraph,drawLegendSymbol:K.drawRectangle});L.areaspline=xa;fa.column=E(ha,{borderColor:"#FFFFFF",
	borderRadius:0,groupPadding:0.2,marker:null,pointPadding:0.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{brightness:0.1,shadow:!1,halo:!1},select:{color:"#C0C0C0",borderColor:"#000000",shadow:!1}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0});xa=sa(R,{type:"column",pointAttrToOptions:{stroke:"borderColor",fill:"color",r:"borderRadius"},cropShoulder:0,directTouch:!0,trackerGroups:["group",
	"dataLabelsGroup"],negStacks:!0,init:function(){R.prototype.init.apply(this,arguments);var a=this,b=a.chart;b.hasRendered&&q(b.series,function(b){if(b.type===a.type)b.isDirty=!0})},getColumnMetrics:function(){var a=this,b=a.options,c=a.xAxis,d=a.yAxis,e=c.reversed,f,g={},h=0;b.grouping===!1?h=1:q(a.chart.series,function(b){var c=b.options,e=b.yAxis,i;if(b.type===a.type&&b.visible&&d.len===e.len&&d.pos===e.pos)c.stacking?(f=b.stackKey,g[f]===A&&(g[f]=h++),i=g[f]):c.grouping!==!1&&(i=h++),b.columnIndex=
	i});var i=F(Q(c.transA)*(c.ordinalSlope||b.pointRange||c.closestPointRange||c.tickInterval||1),c.len),j=i*b.groupPadding,k=(i-2*j)/h,b=F(b.maxPointWidth||c.len,p(b.pointWidth,k*(1-2*b.pointPadding)));a.columnMetrics={width:b,offset:(k-b)/2+(j+((a.columnIndex||0)+(e?1:0))*k-i/2)*(e?-1:1)};return a.columnMetrics},crispCol:function(a,b,c,d){var e=this.chart,f=this.borderWidth,g=-(f%2?0.5:0),f=f%2?0.5:1;e.inverted&&e.renderer.isVML&&(f+=1);c=Math.round(a+c)+g;a=Math.round(a)+g;c-=a;d=Math.round(b+d)+
	f;g=Q(b)<=0.5&&d>0.5;b=Math.round(b)+f;d-=b;g&&d&&(b-=1,d+=1);return{x:a,y:b,width:c,height:d}},translate:function(){var a=this,b=a.chart,c=a.options,d=a.borderWidth=p(c.borderWidth,a.closestPointRange*a.xAxis.transA<2?0:1),e=a.yAxis,f=a.translatedThreshold=e.getThreshold(c.threshold),g=p(c.minPointLength,5),h=a.getColumnMetrics(),i=h.width,j=a.barW=t(i,1+2*d),k=a.pointXOffset=h.offset;b.inverted&&(f-=0.5);c.pointPadding&&(j=va(j));R.prototype.translate.apply(a);q(a.points,function(c){var d=F(p(c.yBottom,
	f),9E4),h=999+Q(d),h=F(t(-h,c.plotY),e.len+h),o=c.plotX+k,q=j,r=F(h,d),s,w=t(h,d)-r;Q(w)<g&&g&&(w=g,s=!e.reversed&&!c.negative||e.reversed&&c.negative,r=Q(r-f)>g?d-g:f-(s?g:0));c.barX=o;c.pointWidth=i;c.tooltipPos=b.inverted?[e.len+e.pos-b.plotLeft-h,a.xAxis.len-o-q/2,w]:[o+q/2,h+e.pos-b.plotTop,w];c.shapeType="rect";c.shapeArgs=a.crispCol(o,r,q,w)})},getSymbol:Ba,drawLegendSymbol:K.drawRectangle,drawGraph:Ba,drawPoints:function(){var a=this,b=this.chart,c=a.options,d=b.renderer,e=c.animationLimit||
	250,f,g;q(a.points,function(h){var i=h.graphic,j;if(J(h.plotY)&&h.y!==null)f=h.shapeArgs,j=s(a.borderWidth)?{"stroke-width":a.borderWidth}:{},g=h.pointAttr[h.selected?"select":""]||a.pointAttr[""],i?(Ka(i),i.attr(j).attr(g)[b.pointCount<e?"animate":"attr"](E(f))):h.graphic=d[h.shapeType](f).attr(j).attr(g).add(h.group||a.group).shadow(c.shadow,null,c.stacking&&!c.borderRadius);else if(i)h.graphic=i.destroy()})},animate:function(a){var b=this,c=this.yAxis,d=b.options,e=this.chart.inverted,f={};if(ga)a?
	(f.scaleY=0.001,a=F(c.pos+c.len,t(c.pos,c.toPixels(d.threshold))),e?f.translateX=a-c.len:f.translateY=a,b.group.attr(f)):(f[e?"translateX":"translateY"]=c.pos,b.group.animate(f,x(bb(b.options.animation),{step:function(a,c){b.group.attr({scaleY:t(0.001,c.pos)})}})),b.animate=null)},remove:function(){var a=this,b=a.chart;b.hasRendered&&q(b.series,function(b){if(b.type===a.type)b.isDirty=!0});R.prototype.remove.apply(a,arguments)}});L.column=xa;fa.bar=E(fa.column);qa=sa(xa,{type:"bar",inverted:!0});
	L.bar=qa;fa.scatter=E(ha,{lineWidth:0,marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px;"> {series.name}</span><br/>',pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}});qa=sa(R,{type:"scatter",sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,kdDimensions:2,drawGraph:function(){this.options.lineWidth&&R.prototype.drawGraph.call(this)}});L.scatter=
	qa;fa.pie=E(ha,{borderColor:"#FFFFFF",borderWidth:1,center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return this.y===null?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,states:{hover:{brightness:0.1,shadow:!1}},stickyTracking:!1,tooltip:{followPointer:!0}});ha={type:"pie",isCartesian:!1,pointClass:sa(Ma,{init:function(){Ma.prototype.init.apply(this,arguments);var a=this,b;
	a.name=p(a.name,"Slice");b=function(b){a.slice(b.type==="select")};N(a,"select",b);N(a,"unselect",b);return a},setVisible:function(a,b){var c=this,d=c.series,e=d.chart,f=d.options.ignoreHiddenPoint,b=p(b,f);if(a!==c.visible){c.visible=c.options.visible=a=a===A?!c.visible:a;d.options.data[pa(c,d.data)]=c.options;q(["graphic","dataLabel","connector","shadowGroup"],function(b){if(c[b])c[b][a?"show":"hide"](!0)});c.legendItem&&e.legend.colorizeItem(c,a);!a&&c.state==="hover"&&c.setState("");if(f)d.isDirty=
	!0;b&&e.redraw()}},slice:function(a,b,c){var d=this.series;Va(c,d.chart);p(b,!0);this.sliced=this.options.sliced=a=s(a)?a:!this.sliced;d.options.data[pa(this,d.data)]=this.options;a=a?this.slicedTranslation:{translateX:0,translateY:0};this.graphic.animate(a);this.shadowGroup&&this.shadowGroup.animate(a)},haloPath:function(a){var b=this.shapeArgs,c=this.series.chart;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.plotLeft+b.x,c.plotTop+b.y,b.r+a,b.r+a,{innerR:this.shapeArgs.r,
	start:b.start,end:b.end})}}),requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttrToOptions:{stroke:"borderColor","stroke-width":"borderWidth",fill:"color"},animate:function(a){var b=this,c=b.points,d=b.startAngleRad;if(!a)q(c,function(a){var c=a.graphic,g=a.shapeArgs;c&&(c.attr({r:a.startR||b.center[3]/2,start:d,end:d}),c.animate({r:g.r,start:g.start,end:g.end},b.options.animation))}),b.animate=null},updateTotals:function(){var a,b=0,
	c=this.points,d=c.length,e,f=this.options.ignoreHiddenPoint;for(a=0;a<d;a++){e=c[a];if(e.y<0)e.y=null;b+=f&&!e.visible?0:e.y}this.total=b;for(a=0;a<d;a++)e=c[a],e.percentage=b>0&&(e.visible||!f)?e.y/b*100:0,e.total=b},generatePoints:function(){R.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();var b=0,c=this.options,d=c.slicedOffset,e=d+c.borderWidth,f,g,h,i=c.startAngle||0,j=this.startAngleRad=ta/180*(i-90),i=(this.endAngleRad=ta/180*(p(c.endAngle,
	i+360)-90))-j,k=this.points,l=c.dataLabels.distance,c=c.ignoreHiddenPoint,m,n=k.length,o;if(!a)this.center=a=this.getCenter();this.getX=function(b,c){h=Z.asin(F((b-a[1])/(a[2]/2+l),1));return a[0]+(c?-1:1)*W(h)*(a[2]/2+l)};for(m=0;m<n;m++){o=k[m];f=j+b*i;if(!c||o.visible)b+=o.percentage/100;g=j+b*i;o.shapeType="arc";o.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:C(f*1E3)/1E3,end:C(g*1E3)/1E3};h=(g+f)/2;h>1.5*ta?h-=2*ta:h<-ta/2&&(h+=2*ta);o.slicedTranslation={translateX:C(W(h)*d),translateY:C(ea(h)*
	d)};f=W(h)*a[2]/2;g=ea(h)*a[2]/2;o.tooltipPos=[a[0]+f*0.7,a[1]+g*0.7];o.half=h<-ta/2||h>ta/2?1:0;o.angle=h;e=F(e,l/2);o.labelPos=[a[0]+f+W(h)*l,a[1]+g+ea(h)*l,a[0]+f+W(h)*e,a[1]+g+ea(h)*e,a[0]+f,a[1]+g,l<0?"center":o.half?"right":"left",h]}},drawGraph:null,drawPoints:function(){var a=this,b=a.chart.renderer,c,d,e=a.options.shadow,f,g,h,i;if(e&&!a.shadowGroup)a.shadowGroup=b.g("shadow").add(a.group);q(a.points,function(j){if(j.y!==null){d=j.graphic;h=j.shapeArgs;f=j.shadowGroup;g=j.pointAttr[j.selected?
	"select":""];if(!g.stroke)g.stroke=g.fill;if(e&&!f)f=j.shadowGroup=b.g("shadow").add(a.shadowGroup);c=j.sliced?j.slicedTranslation:{translateX:0,translateY:0};f&&f.attr(c);if(d)d.setRadialReference(a.center).attr(g).animate(x(h,c));else{i={"stroke-linejoin":"round"};if(!j.visible)i.visibility="hidden";j.graphic=d=b[j.shapeType](h).setRadialReference(a.center).attr(g).attr(i).attr(c).add(a.group).shadow(e,f)}}})},searchPoint:Ba,sortByAngle:function(a,b){a.sort(function(a,d){return a.angle!==void 0&&
	(d.angle-a.angle)*b})},drawLegendSymbol:K.drawRectangle,getCenter:Db.getCenter,getSymbol:Ba};ha=sa(R,ha);L.pie=ha;R.prototype.drawDataLabels=function(){var a=this,b=a.options,c=b.cursor,d=b.dataLabels,e=a.points,f,g,h=a.hasRendered||0,i,j,k=p(d.defer,!0),l=a.chart.renderer;if(d.enabled||a._hasPointLabels)a.dlProcessOptions&&a.dlProcessOptions(d),j=a.plotGroup("dataLabelsGroup","data-labels",k&&!h?"hidden":"visible",d.zIndex||6),k&&(j.attr({opacity:+h}),h||N(a,"afterAnimate",function(){a.visible&&
	j.show(!0);j[b.animation?"animate":"attr"]({opacity:1},{duration:200})})),g=d,q(e,function(e){var h,k=e.dataLabel,q,r,t=e.connector,w=!0,v,u={};f=e.dlOptions||e.options&&e.options.dataLabels;h=p(f&&f.enabled,g.enabled)&&e.y!==null;if(k&&!h)e.dataLabel=k.destroy();else if(h){d=E(g,f);v=d.style;h=d.rotation;q=e.getLabelConfig();i=d.format?Na(d.format,q):d.formatter.call(q,d);v.color=p(d.color,v.color,a.color,"black");if(k)if(s(i))k.attr({text:i}),w=!1;else{if(e.dataLabel=k=k.destroy(),t)e.connector=
	t.destroy()}else if(s(i)){k={fill:d.backgroundColor,stroke:d.borderColor,"stroke-width":d.borderWidth,r:d.borderRadius||0,rotation:h,padding:d.padding,zIndex:1};if(v.color==="contrast")u.color=d.inside||d.distance<0||b.stacking?l.getContrast(e.color||a.color):"#000000";if(c)u.cursor=c;for(r in k)k[r]===A&&delete k[r];k=e.dataLabel=l[h?"text":"label"](i,0,-9999,d.shape,null,null,d.useHTML).attr(k).css(x(v,u)).add(j).shadow(d.shadow)}k&&a.alignDataLabel(e,k,d,null,w)}})};R.prototype.alignDataLabel=
	function(a,b,c,d,e){var f=this.chart,g=f.inverted,h=p(a.plotX,-9999),i=p(a.plotY,-9999),j=b.getBBox(),k=f.renderer.fontMetrics(c.style.fontSize).b,l=c.rotation,m=c.align,n=this.visible&&(a.series.forceDL||f.isInsidePlot(h,C(i),g)||d&&f.isInsidePlot(h,g?d.x+1:d.y+d.height-1,g)),o=p(c.overflow,"justify")==="justify";if(n)d=x({x:g?f.plotWidth-i:h,y:C(g?f.plotHeight-h:i),width:0,height:0},d),x(c,{width:j.width,height:j.height}),l?(o=!1,g=f.renderer.rotCorr(k,l),g={x:d.x+c.x+d.width/2+g.x,y:d.y+c.y+{top:0,
	middle:0.5,bottom:1}[c.verticalAlign]*d.height},b[e?"attr":"animate"](g).attr({align:m}),h=(l+720)%360,h=h>180&&h<360,m==="left"?g.y-=h?j.height:0:m==="center"?(g.x-=j.width/2,g.y-=j.height/2):m==="right"&&(g.x-=j.width,g.y-=h?0:j.height)):(b.align(c,null,d),g=b.alignAttr),o?this.justifyDataLabel(b,c,g,j,d,e):p(c.crop,!0)&&(n=f.isInsidePlot(g.x,g.y)&&f.isInsidePlot(g.x+j.width,g.y+j.height)),c.shape&&!l&&b.attr({anchorX:a.plotX,anchorY:a.plotY});if(!n)Ka(b),b.attr({y:-9999}),b.placed=!1};R.prototype.justifyDataLabel=
	function(a,b,c,d,e,f){var g=this.chart,h=b.align,i=b.verticalAlign,j,k,l=a.box?0:a.padding||0;j=c.x+l;if(j<0)h==="right"?b.align="left":b.x=-j,k=!0;j=c.x+d.width-l;if(j>g.plotWidth)h==="left"?b.align="right":b.x=g.plotWidth-j,k=!0;j=c.y+l;if(j<0)i==="bottom"?b.verticalAlign="top":b.y=-j,k=!0;j=c.y+d.height-l;if(j>g.plotHeight)i==="top"?b.verticalAlign="bottom":b.y=g.plotHeight-j,k=!0;if(k)a.placed=!f,a.align(b,null,e)};if(L.pie)L.pie.prototype.drawDataLabels=function(){var a=this,b=a.data,c,d=a.chart,
	e=a.options.dataLabels,f=p(e.connectorPadding,10),g=p(e.connectorWidth,1),h=d.plotWidth,i=d.plotHeight,j,k,l=p(e.softConnector,!0),m=e.distance,n=a.center,o=n[2]/2,s=n[1],r=m>0,u,w,v,x=[[],[]],A,y,D,E,B,H=[0,0,0,0],M=function(a,b){return b.y-a.y};if(a.visible&&(e.enabled||a._hasPointLabels)){R.prototype.drawDataLabels.apply(a);q(b,function(a){if(a.dataLabel&&a.visible)x[a.half].push(a),a.dataLabel._pos=null});for(E=2;E--;){var I=[],N=[],J=x[E],L=J.length,K;if(L){a.sortByAngle(J,E-0.5);for(B=b=0;!b&&
	J[B];)b=J[B]&&J[B].dataLabel&&(J[B].dataLabel.getBBox().height||21),B++;if(m>0){w=F(s+o+m,d.plotHeight);for(B=t(0,s-o-m);B<=w;B+=b)I.push(B);w=I.length;if(L>w){c=[].concat(J);c.sort(M);for(B=L;B--;)c[B].rank=B;for(B=L;B--;)J[B].rank>=w&&J.splice(B,1);L=J.length}for(B=0;B<L;B++){c=J[B];v=c.labelPos;c=9999;var P,O;for(O=0;O<w;O++)P=Q(I[O]-v[1]),P<c&&(c=P,K=O);if(K<B&&I[B]!==null)K=B;else for(w<L-B+K&&I[B]!==null&&(K=w-L+B);I[K]===null;)K++;N.push({i:K,y:I[K]});I[K]=null}N.sort(M)}for(B=0;B<L;B++){c=
	J[B];v=c.labelPos;u=c.dataLabel;D=c.visible===!1?"hidden":"inherit";c=v[1];if(m>0){if(w=N.pop(),K=w.i,y=w.y,c>y&&I[K+1]!==null||c<y&&I[K-1]!==null)y=F(t(0,c),d.plotHeight)}else y=c;A=e.justify?n[0]+(E?-1:1)*(o+m):a.getX(y===s-o-m||y===s+o+m?c:y,E);u._attr={visibility:D,align:v[6]};u._pos={x:A+e.x+({left:f,right:-f}[v[6]]||0),y:y+e.y-10};u.connX=A;u.connY=y;if(this.options.size===null)w=u.width,A-w<f?H[3]=t(C(w-A+f),H[3]):A+w>h-f&&(H[1]=t(C(A+w-h+f),H[1])),y-b/2<0?H[0]=t(C(-y+b/2),H[0]):y+b/2>i&&(H[2]=
	t(C(y+b/2-i),H[2]))}}}if(Ha(H)===0||this.verifyDataLabelOverflow(H))this.placeDataLabels(),r&&g&&q(this.points,function(b){j=b.connector;v=b.labelPos;if((u=b.dataLabel)&&u._pos&&b.visible)D=u._attr.visibility,A=u.connX,y=u.connY,k=l?[X,A+(v[6]==="left"?5:-5),y,"C",A,y,2*v[2]-v[4],2*v[3]-v[5],v[2],v[3],S,v[4],v[5]]:[X,A+(v[6]==="left"?5:-5),y,S,v[2],v[3],S,v[4],v[5]],j?(j.animate({d:k}),j.attr("visibility",D)):b.connector=j=a.chart.renderer.path(k).attr({"stroke-width":g,stroke:e.connectorColor||b.color||
	"#606060",visibility:D}).add(a.dataLabelsGroup);else if(j)b.connector=j.destroy()})}},L.pie.prototype.placeDataLabels=function(){q(this.points,function(a){var b=a.dataLabel;if(b&&a.visible)(a=b._pos)?(b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999})})},L.pie.prototype.alignDataLabel=Ba,L.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,d=c.center,e=c.minSize||80,f=e,g;d[0]!==null?f=t(b[2]-t(a[1],a[3]),e):(f=t(b[2]-a[1]-a[3],e),b[0]+=
	(a[3]-a[1])/2);d[1]!==null?f=t(F(f,b[2]-t(a[0],a[2])),e):(f=t(F(f,b[2]-a[0]-a[2]),e),b[1]+=(a[0]-a[2])/2);f<b[2]?(b[2]=f,b[3]=Math.min(/%$/.test(c.innerSize||0)?f*parseFloat(c.innerSize||0)/100:parseFloat(c.innerSize||0),f),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):g=!0;return g};if(L.column)L.column.prototype.alignDataLabel=function(a,b,c,d,e){var f=this.chart.inverted,g=a.series,h=a.dlBox||a.shapeArgs,i=p(a.below,a.plotY>p(this.translatedThreshold,g.yAxis.len)),j=p(c.inside,
	!!this.options.stacking);if(h){d=E(h);if(d.y<0)d.height+=d.y,d.y=0;h=d.y+d.height-g.yAxis.len;h>0&&(d.height-=h);f&&(d={x:g.yAxis.len-d.y-d.height,y:g.xAxis.len-d.x-d.width,width:d.height,height:d.width});if(!j)f?(d.x+=i?0:d.width,d.width=0):(d.y+=i?d.height:0,d.height=0)}c.align=p(c.align,!f||j?"center":i?"right":"left");c.verticalAlign=p(c.verticalAlign,f||j?"middle":i?"top":"bottom");R.prototype.alignDataLabel.call(this,a,b,c,d,e)};(function(a){var b=a.Chart,c=a.each,d=a.pick,e=a.addEvent;b.prototype.callbacks.push(function(a){function b(){var e=
	[];c(a.series,function(a){var b=a.options.dataLabels,f=a.dataLabelCollections||["dataLabel"];(b.enabled||a._hasPointLabels)&&!b.allowOverlap&&a.visible&&c(f,function(b){c(a.points,function(a){if(a[b])a[b].labelrank=d(a.labelrank,a.shapeArgs&&a.shapeArgs.height),e.push(a[b])})})});a.hideOverlappingLabels(e)}b();e(a,"redraw",b)});b.prototype.hideOverlappingLabels=function(a){var b=a.length,d,e,j,k,l,m,n,o,p;for(e=0;e<b;e++)if(d=a[e])d.oldOpacity=d.opacity,d.newOpacity=1;a.sort(function(a,b){return(b.labelrank||
	0)-(a.labelrank||0)});for(e=0;e<b;e++){j=a[e];for(d=e+1;d<b;++d)if(k=a[d],j&&k&&j.placed&&k.placed&&j.newOpacity!==0&&k.newOpacity!==0&&(l=j.alignAttr,m=k.alignAttr,n=j.parentGroup,o=k.parentGroup,p=2*(j.box?0:j.padding),l=!(m.x+o.translateX>l.x+n.translateX+(j.width-p)||m.x+o.translateX+(k.width-p)<l.x+n.translateX||m.y+o.translateY>l.y+n.translateY+(j.height-p)||m.y+o.translateY+(k.height-p)<l.y+n.translateY)))(j.labelrank<k.labelrank?j:k).newOpacity=0}c(a,function(a){var b,c;if(a){c=a.newOpacity;
	if(a.oldOpacity!==c&&a.placed)c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b);a.isOld=!0}})}})(u);ha=u.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart,c=b.pointer,d=a.options.cursor,e=d&&{cursor:d},f=function(a){for(var c=a.target,d;c&&!d;)d=c.point,c=c.parentNode;if(d!==A&&d!==b.hoverPoint)d.onMouseOver(a)};q(a.points,function(a){if(a.graphic)a.graphic.element.point=a;if(a.dataLabel)a.dataLabel.element.point=a});if(!a._hasTracking)q(a.trackerGroups,
	function(b){if(a[b]&&(a[b].addClass("highcharts-tracker").on("mouseover",f).on("mouseout",function(a){c.onTrackerMouseOut(a)}).css(e),fb))a[b].on("touchstart",f)}),a._hasTracking=!0},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),e=d.length,f=a.chart,g=f.pointer,h=f.renderer,i=f.options.tooltip.snap,j=a.tracker,k=b.cursor,l=k&&{cursor:k},m=function(){if(f.hoverSeries!==a)a.onMouseOver()},n="rgba(192,192,192,"+(ga?1.0E-4:0.002)+")";if(e&&!c)for(k=
	e+1;k--;)d[k]===X&&d.splice(k+1,0,d[k+1]-i,d[k+2],S),(k&&d[k]===X||k===e)&&d.splice(k,0,S,d[k-2]+i,d[k-1]);j?j.attr({d:d}):(a.tracker=h.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:n,fill:c?n:"none","stroke-width":b.lineWidth+(c?0:2*i),zIndex:2}).add(a.group),q([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",m).on("mouseout",function(a){g.onTrackerMouseOut(a)}).css(l);if(fb)a.on("touchstart",m)}))}};if(L.column)xa.prototype.drawTracker=
	ha.drawTrackerPoint;if(L.pie)L.pie.prototype.drawTracker=ha.drawTrackerPoint;if(L.scatter)qa.prototype.drawTracker=ha.drawTrackerPoint;x(rb.prototype,{setItemEvents:function(a,b,c,d,e){var f=this;(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");b.css(f.options.itemHoverStyle)}).on("mouseout",function(){b.css(a.visible?d:e);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()},b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):
	I(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=da("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);N(a.checkbox,"click",function(b){I(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});U.legend.itemStyle.cursor="pointer";x(ib.prototype,{showResetZoom:function(){var a=this,b=U.lang,c=a.options.chart.resetZoomButton,d=c.theme,e=d.states,f=c.relativeTo==="chart"?
	null:"plotBox";this.resetZoomButton=a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},d,e&&e.hover).attr({align:c.position.align,title:b.resetZoomTitle}).add().align(c.position,!1,f)},zoomOut:function(){var a=this;I(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var b,c=this.pointer,d=!1,e;!a||a.resetSelection?q(this.axes,function(a){b=a.zoom()}):q(a.xAxis.concat(a.yAxis),function(a){var e=a.axis,h=e.isXAxis;if(c[h?"zoomX":"zoomY"]||c[h?"pinchX":"pinchY"])b=
	e.zoom(a.min,a.max),e.displayBtn&&(d=!0)});e=this.resetZoomButton;if(d&&!e)this.showResetZoom();else if(!d&&$(e))this.resetZoomButton=e.destroy();b&&this.redraw(p(this.options.chart.animation,a&&a.animation,this.pointCount<100))},pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&q(d,function(a){a.setState()});q(b==="xy"?[1,0]:[1],function(b){var b=c[b?"xAxis":"yAxis"][0],d=b.horiz,h=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",i=c[d],j=(b.pointRange||0)/2,k=b.getExtremes(),l=b.toValue(i-h,
	!0)+j,j=b.toValue(i+b.len-h,!0)-j,i=i>h;if(b.series.length&&(i||l>F(k.dataMin,k.min))&&(!i||j<t(k.dataMax,k.max)))b.setExtremes(l,j,!1,!1,{trigger:"pan"}),e=!0;c[d]=h});e&&c.redraw(!1);M(c.container,{cursor:"move"})}});x(Ma.prototype,{select:function(a,b){var c=this,d=c.series,e=d.chart,a=p(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[pa(c,d.data)]=c.options;c.setState(a&&"select");b||q(e.getSelectedPoints(),function(a){if(a.selected&&
	a!==c)a.selected=a.options.selected=!1,d.options.data[pa(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect")})})},onMouseOver:function(a,b){var c=this.series,d=c.chart,e=d.tooltip,f=d.hoverPoint;if(d.hoverSeries!==c)c.onMouseOver();if(f&&f!==this)f.onMouseOut();if(this.series&&(this.firePointEvent("mouseOver"),e&&(!e.shared||c.noSharedTooltip)&&e.refresh(this,a),this.setState("hover"),!b))d.hoverPoint=this},onMouseOut:function(){var a=this.series.chart,b=a.hoverPoints;this.firePointEvent("mouseOut");
	if(!b||pa(this,b)===-1)this.setState(),a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var a=E(this.series.options.point,this.options).events,b;this.events=a;for(b in a)N(this,b,a[b]);this.hasImportedEvents=!0}},setState:function(a,b){var c=V(this.plotX),d=this.plotY,e=this.series,f=e.options.states,g=fa[e.type].marker&&e.options.marker,h=g&&!g.enabled,i=g&&g.states[a],j=i&&i.enabled===!1,k=e.stateMarkerGraphic,l=this.marker||{},m=e.chart,n=e.halo,o,a=a||"";o=this.pointAttr[a]||
	e.pointAttr[a];if(!(a===this.state&&!b||this.selected&&a!=="select"||f[a]&&f[a].enabled===!1||a&&(j||h&&i.enabled===!1)||a&&l.states&&l.states[a]&&l.states[a].enabled===!1)){if(this.graphic)g=g&&this.graphic.symbolName&&o.r,this.graphic.attr(E(o,g?{x:c-g,y:d-g,width:2*g,height:2*g}:{})),k&&k.hide();else{if(a&&i)if(g=i.radius,l=l.symbol||e.symbol,k&&k.currentSymbol!==l&&(k=k.destroy()),k)k[b?"animate":"attr"]({x:c-g,y:d-g});else if(l)e.stateMarkerGraphic=k=m.renderer.symbol(l,c-g,d-g,2*g,2*g).attr(o).add(e.markerGroup),
	k.currentSymbol=l;if(k)k[a&&m.isInsidePlot(c,d,m.inverted)?"show":"hide"](),k.element.point=this}if((c=f[a]&&f[a].halo)&&c.size){if(!n)e.halo=n=m.renderer.path().add(m.seriesGroup);n.attr(x({fill:this.color||e.color,"fill-opacity":c.opacity,zIndex:-1},c.attributes))[b?"animate":"attr"]({d:this.haloPath(c.size)})}else n&&n.attr({d:[]});this.state=a}},haloPath:function(a){var b=this.series,c=b.chart,d=b.getPlotBox(),e=c.inverted,f=Math.floor(this.plotX);return c.renderer.symbols.circle(d.translateX+
	(e?b.yAxis.len-this.plotY:f)-a,d.translateY+(e?b.xAxis.len-f:this.plotY)-a,a*2,a*2)}});x(R.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&I(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&I(this,"mouseOut");c&&!a.stickyTracking&&(!c.shared||this.noSharedTooltip)&&
	c.hide();this.setState()},setState:function(a){var b=this.options,c=this.graph,d=b.states,e=b.lineWidth,b=0,a=a||"";if(this.state!==a&&(this.state=a,!(d[a]&&d[a].enabled===!1)&&(a&&(e=d[a].lineWidth||e+(d[a].lineWidthPlus||0)),c&&!c.dashstyle))){a={"stroke-width":e};for(c.attr(a);this["zoneGraph"+b];)this["zoneGraph"+b].attr(a),b+=1}},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,g=d.options.chart.ignoreHiddenSeries,h=c.visible;f=(c.visible=a=c.userOptions.visible=a===A?!h:a)?"show":
	"hide";q(["group","dataLabelsGroup","markerGroup","tracker"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&q(d.series,function(a){if(a.options.stacking&&a.visible)a.isDirty=!0});q(c.linkedSeries,function(b){b.setVisible(a,!1)});if(g)d.isDirtyBox=!0;b!==!1&&d.redraw();I(c,f)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=
	a=a===A?!this.selected:a;if(this.checkbox)this.checkbox.checked=a;I(this,a?"select":"unselect")},drawTracker:ha.drawTrackerGraph});x(u,{Color:na,Point:Ma,Tick:Xa,Renderer:eb,SVGElement:O,SVGRenderer:Ea,arrayMin:Oa,arrayMax:Ha,charts:T,correctFloat:aa,dateFormat:Sa,error:ca,format:Na,pathAnim:void 0,getOptions:function(){return U},hasBidiBug:Rb,isTouchDevice:Nb,setOptions:function(a){U=E(!0,U,a);Gb();return U},addEvent:N,removeEvent:Y,createElement:da,discardElement:Ua,css:M,each:q,map:Da,merge:E,
	splat:ua,stableSort:jb,extendClass:sa,pInt:B,svg:ga,canvas:la,vml:!ga&&!la,product:"Highcharts",version:"4.2.6"});return u});


/***/ },
/* 289 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(30);
	
	var _PathUtils = __webpack_require__(25);
	
	var _ExecutionEnvironment = __webpack_require__(48);
	
	var _DOMUtils = __webpack_require__(84);
	
	var _DOMStateStorage = __webpack_require__(142);
	
	var _createDOMHistory = __webpack_require__(143);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(30);
	
	var _PathUtils = __webpack_require__(25);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(25);
	
	var _Actions = __webpack_require__(30);
	
	var _createHistory = __webpack_require__(145);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(543);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 294 */
/***/ function(module, exports) {

	module.exports = {
		"search route": "Search route",
		"search train": "Search train",
		"train number": "Train number",
		"report error": "Report error",
		"fastest": "fastest",
		"search": "Search",
		"search on infofer": "Search/buy on the CFR website",
		"reverse": "Reverse",
		"from": "From",
		"to": "To",
		"only direct routes": "Show only direct routes",
		"no trains": "Search for a route by selecting departure and arrival stations, or by selecting a train number.",
		"footer disclaimer": "Acceleratul is in <strong>beta</strong> and it cannot be held responsible for any problems due to incomplete or incorrect data. Prices are for IInd class trains, with assigned seats, and are approximations. For exact amounts, call CFR by using the call button on the lower right.",
		"footer contact": "If you missed the train because of this website, complain here:",
		"Delays last month": "Delays last month",
		"delay": "delay",
		"time from": "from",
		"time to": "to",
		"wait for": "Wait for",
		"and then": "and then",
		"just from": "from",
		"just to": "to",
		"only": "only",
		"weekdays": "weekdays",
		"weekends": "weekends",
		"monday": "Monday",
		"tuesday": "Tuesday",
		"wednesday": "Wednesday",
		"thursday": "Thursday",
		"friday": "Friday",
		"saturday": "Saturday",
		"sunday": "Sunday",
		"january": "January",
		"february": "February",
		"march": "March",
		"april": "April",
		"may": "May",
		"june": "June",
		"july": "July",
		"august": "August",
		"september": "September",
		"october": "October",
		"november": "November",
		"december": "December",
		"costs": "costs",
		"lei": "lei",
		"DATE_BEFORE_MONTH": false
	};

/***/ },
/* 295 */
/***/ function(module, exports) {

	module.exports = {
		"search route": "Caută rută",
		"search train": "Caută tren",
		"train number": "Număr tren",
		"report error": "Raportează o eroare",
		"fastest": "cel mai rapid",
		"search": "Caută",
		"search on infofer": "Caută/cumpără pe site-ul CFR",
		"reverse": "Întoarcere",
		"from": "De la",
		"to": "Până La",
		"only direct routes": "Arată doar rutele directe",
		"no trains": "Caută o rută selectând staţiile de plecare şi destinaţie, sau selectând un număr de tren",
		"footer disclaimer": "Acceleratul este în <strong>beta</strong> şi nu îşi asumă nicio responsabilitate pentru eventualele probleme apărute din cauza unor date posibil incomplete sau incorecte. Preturile se refera la tariful intreg la clasa a II-a, cu loc, si sunt aproximari. Pentru preturi exacte, sunati la informatii folosind butonul din dreapta jos.",
		"footer contact": "Dacă ai pierdut trenul din cauza acestui site, înjură-mă aici:",
		"Delays last month": "Întârzieri în ultima lună",
		"delay": "întârziere",
		"time from": "de la",
		"time to": "până la",
		"wait for": "Aşteaptă",
		"and then": "şi după aceea",
		"just from": "doar din",
		"just to": "până în",
		"only": "",
		"weekdays": "în zile lucrătoare",
		"weekends": "în sfârşituri de saptamână",
		"monday": "luni",
		"tuesday": "marţi",
		"wednesday": "miercuri",
		"thursday": "joi",
		"friday": "vineri",
		"saturday": "sâmbătă",
		"sunday": "duminică",
		"january": "ianuarie",
		"february": "februarie",
		"march": "martie",
		"april": "aprilie",
		"may": "mai",
		"june": "iunie",
		"july": "iulie",
		"august": "august",
		"september": "septembrie",
		"october": "octombrie",
		"november": "noiembrie",
		"december": "decembrie",
		"costs": "costă",
		"lei": "lei",
		"DATE_BEFORE_MONTH": true
	};

/***/ },
/* 296 */
/***/ function(module, exports) {

	module.exports = [
		{
			"type": "R",
			"operator": "CFR",
			"number": "2872",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Amaradia",
					"leavesAt": "12:35",
					"arrivesAt": "12:44",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Amaradia",
					"to": "Drăguţeşti h.",
					"leavesAt": "12:45",
					"arrivesAt": "12:50",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "12:51",
					"arrivesAt": "12:55",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Vârţ h.",
					"leavesAt": "12:56",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Vârţ h.",
					"to": "Rogojelu",
					"leavesAt": "13:01",
					"arrivesAt": "13:05",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Rogojelu",
					"to": "Km. 49+800 h.",
					"leavesAt": "13:06",
					"arrivesAt": "13:09",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rovinari Hm.",
					"leavesAt": "13:10",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Rovinari Hm.",
					"to": "Rovinari Sud h.",
					"leavesAt": "13:15",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Roşia Jiu h.",
					"leavesAt": "13:18",
					"arrivesAt": "13:20",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Roşia Jiu h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "13:21",
					"arrivesAt": "13:26",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Bâlteni h.",
					"leavesAt": "13:27",
					"arrivesAt": "13:31",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bâlteni h.",
					"to": "Peşteana Jiu h.",
					"leavesAt": "13:32",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Plopşoru",
					"leavesAt": "13:36",
					"arrivesAt": "13:44",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Plopşoru",
					"to": "Sărdăneşti h.",
					"leavesAt": "13:45",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Gârbovu h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Gârbovu h.",
					"to": "Turceni",
					"leavesAt": "13:57",
					"arrivesAt": "14:04",
					"waitsAtSource": 60,
					"distance": 6600
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20180526",
					"daysOfWeek": 383
				},
				{
					"from": "20180528",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9473",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Bradu de Sus",
					"leavesAt": "13:34",
					"arrivesAt": "13:39",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bradu de Sus",
					"to": "Pârvu Hm.",
					"leavesAt": "13:40",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Pârvu Hm.",
					"to": "Pârvu h.",
					"leavesAt": "13:46",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Pârvu h.",
					"to": "Suseni h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:55",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Suseni h.",
					"to": "Costeşti",
					"leavesAt": "13:56",
					"arrivesAt": "14:06",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Costeşti",
					"to": "Fâlfani Hm.",
					"leavesAt": "14:07",
					"arrivesAt": "14:15",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "14:19",
					"arrivesAt": "14:27",
					"waitsAtSource": 240,
					"distance": 8000
				},
				{
					"from": "Stolnici Hm.",
					"to": "Hârseşti Hm.",
					"leavesAt": "14:28",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Corbu",
					"leavesAt": "14:34",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Corbu",
					"to": "Sineşti Hm.",
					"leavesAt": "14:45",
					"arrivesAt": "14:52",
					"waitsAtSource": 300,
					"distance": 6000
				},
				{
					"from": "Sineşti Hm.",
					"to": "Potcoava",
					"leavesAt": "14:53",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Potcoava",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "15:01",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Recea Hm.",
					"leavesAt": "15:09",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Recea Hm.",
					"to": "Slatina",
					"leavesAt": "15:18",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Slatina",
					"to": "Milcov Hm.",
					"leavesAt": "15:27",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Milcov Hm.",
					"to": "Slătioara Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:45",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "15:46",
					"arrivesAt": "15:52",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 895
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 895
				},
				{
					"from": "20180526",
					"to": "20180603",
					"daysOfWeek": 895
				},
				{
					"from": "20180609",
					"to": "20180610",
					"daysOfWeek": 895
				},
				{
					"from": "20180616",
					"to": "20180617",
					"daysOfWeek": 895
				},
				{
					"from": "20180623",
					"to": "20180624",
					"daysOfWeek": 895
				},
				{
					"from": "20180630",
					"to": "20180701",
					"daysOfWeek": 895
				},
				{
					"from": "20180707",
					"to": "20180708",
					"daysOfWeek": 895
				},
				{
					"from": "20180714",
					"to": "20180715",
					"daysOfWeek": 895
				},
				{
					"from": "20180721",
					"to": "20180722",
					"daysOfWeek": 895
				},
				{
					"from": "20180728",
					"to": "20180729",
					"daysOfWeek": 895
				},
				{
					"from": "20180804",
					"to": "20180805",
					"daysOfWeek": 895
				},
				{
					"from": "20180811",
					"to": "20180819",
					"daysOfWeek": 895
				},
				{
					"from": "20180825",
					"to": "20180826",
					"daysOfWeek": 895
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 895
				},
				{
					"from": "20180908",
					"to": "20180909",
					"daysOfWeek": 895
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 895
				},
				{
					"from": "20180922",
					"to": "20181208",
					"daysOfWeek": 895
				},
				{
					"from": "20171210",
					"to": "20180506",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9008",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(900)",
					"leavesAt": "13:05",
					"arrivesAt": "13:08",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "13:09",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "13:15",
					"arrivesAt": "13:18",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "13:19",
					"arrivesAt": "13:25",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Leu Hm.",
					"leavesAt": "13:26",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Leu Hm.",
					"to": "Ţărţăl h.",
					"leavesAt": "13:36",
					"arrivesAt": "13:40",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ţărţăl h.",
					"to": "Jianca",
					"leavesAt": "13:41",
					"arrivesAt": "13:45",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Jianca",
					"to": "Radomiru hc.",
					"leavesAt": "13:46",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Radomiru hc.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "13:50",
					"arrivesAt": "13:55",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Cezieni h.",
					"leavesAt": "13:56",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Cezieni h.",
					"to": "Caracal",
					"leavesAt": "14:02",
					"arrivesAt": "14:08",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Caracal",
					"to": "Fărcaşele Hm.",
					"leavesAt": "14:10",
					"arrivesAt": "14:16",
					"waitsAtSource": 120,
					"distance": 7800
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Stoeneşti h.",
					"leavesAt": "14:17",
					"arrivesAt": "14:20",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Stoeneşti h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "14:21",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Dăneasa h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Dăneasa h.",
					"to": "Radomireşti Hm.",
					"leavesAt": "14:34",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "14:43",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Măldăeni Hm.",
					"leavesAt": "14:53",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Măldăeni Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "15:04",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Roşiori Nord",
					"to": "Atârnaţi Hm.",
					"leavesAt": "15:15",
					"arrivesAt": "15:22",
					"waitsAtSource": 180,
					"distance": 7200
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "15:23",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Vârtoapele hc.",
					"leavesAt": "15:32",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Olteni",
					"leavesAt": "15:38",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "15:49",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Ciolpani Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Videle",
					"leavesAt": "16:08",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Videle",
					"to": "Zăvestreni Hm.",
					"leavesAt": "16:28",
					"arrivesAt": "16:33",
					"waitsAtSource": 600,
					"distance": 4800
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "16:39",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Zorile h.",
					"leavesAt": "16:47",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zorile h.",
					"to": "Grădinari",
					"leavesAt": "16:52",
					"arrivesAt": "17:01",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Grădinari",
					"to": "Domneştii de Sus h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Chiajna",
					"leavesAt": "17:09",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Chiajna",
					"to": "Bucureştii Noi",
					"leavesAt": "17:26",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Carpaţi h.(900)",
					"leavesAt": "17:30",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:36",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "17:37",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9403",
			"segments": [
				{
					"from": "Caracal",
					"to": "Romula Hm.",
					"leavesAt": "07:12",
					"arrivesAt": "07:25",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Romula Hm.",
					"to": "Fălcoiu h.",
					"leavesAt": "07:26",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Fălcoiu h.",
					"to": "Vlăduleni",
					"leavesAt": "07:36",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vlăduleni",
					"to": "Şopârliţa hc.",
					"leavesAt": "07:45",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Piatra Olt",
					"leavesAt": "07:50",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:22",
					"waitsAtSource": 660,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "08:23",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "08:39",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5052",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "04:24",
					"arrivesAt": "04:32",
					"waitsAtSource": 0,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "04:33",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Focşani",
					"to": "Coteşti Hm.",
					"leavesAt": "04:47",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Coteşti Hm.",
					"to": "Gugeşti",
					"leavesAt": "04:55",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Gugeşti",
					"to": "Sihlea Hm.",
					"leavesAt": "05:03",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sihlea Hm.",
					"to": "Voetin h.",
					"leavesAt": "05:12",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Voetin h.",
					"to": "Râmnicu Sărat",
					"leavesAt": "05:20",
					"arrivesAt": "05:30",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Zoita Hm.",
					"leavesAt": "05:31",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Zoita Hm.",
					"to": "Boboc Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Boboc Hm.",
					"to": "Buzău",
					"leavesAt": "05:52",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Buzău",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "06:06",
					"arrivesAt": "06:15",
					"waitsAtSource": 120,
					"distance": 10500
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Ulmeni",
					"leavesAt": "06:16",
					"arrivesAt": "06:21",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "06:22",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:36",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "06:37",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "06:45",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "06:53",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "06:58",
					"arrivesAt": "07:03",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "07:04",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "07:07",
					"arrivesAt": "07:14",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "07:15",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "07:23",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ploieşti Sud",
					"to": "Crivina",
					"leavesAt": "07:32",
					"arrivesAt": "07:53",
					"waitsAtSource": 120,
					"distance": 20500
				},
				{
					"from": "Crivina",
					"to": "Buftea",
					"leavesAt": "07:54",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 22800
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "08:10",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4205",
			"segments": [
				{
					"from": "Vatra Dornei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "04:28",
					"arrivesAt": "04:31",
					"waitsAtSource": 0,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Roşu Hm.",
					"leavesAt": "04:32",
					"arrivesAt": "04:39",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Roşu Hm.",
					"to": "Dorna Candrenilor h.",
					"leavesAt": "04:40",
					"arrivesAt": "04:45",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dorna Candrenilor h.",
					"to": "Floreni",
					"leavesAt": "04:46",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Floreni",
					"to": "Coşna Hm.",
					"leavesAt": "04:53",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Coşna Hm.",
					"to": "Grădiniţa",
					"leavesAt": "05:03",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Grădiniţa",
					"to": "Larion Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:26",
					"waitsAtSource": 240,
					"distance": 5300
				},
				{
					"from": "Larion Hm.",
					"to": "Silhoasa Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Silhoasa Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "05:39",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Lunca Ilvei",
					"to": "Ilva Mare Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Ilva Mare Hm.",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "05:59",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Poiana Ilvei",
					"leavesAt": "06:10",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Poiana Ilvei",
					"to": "Leşu Ilvei Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Leşu Ilvei Hm.",
					"to": "Strâmba h.",
					"leavesAt": "06:29",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Strâmba h.",
					"to": "Ilva Mică",
					"leavesAt": "06:34",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ilva Mică",
					"to": "Podereia Feldrului h.",
					"leavesAt": "06:44",
					"arrivesAt": "06:48",
					"waitsAtSource": 240,
					"distance": 2900
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Feldru Hm.",
					"leavesAt": "06:49",
					"arrivesAt": "06:53",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Feldru Hm.",
					"to": "Nepos h.",
					"leavesAt": "06:55",
					"arrivesAt": "07:01",
					"waitsAtSource": 120,
					"distance": 4700
				},
				{
					"from": "Nepos h.",
					"to": "Rebrişoara Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Năsăud",
					"leavesAt": "07:09",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Năsăud",
					"to": "Năsăud h.",
					"leavesAt": "07:19",
					"arrivesAt": "07:21",
					"waitsAtSource": 240,
					"distance": 2200
				},
				{
					"from": "Năsăud h.",
					"to": "Salva",
					"leavesAt": "07:22",
					"arrivesAt": "07:27",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Salva",
					"to": "Mititei h.",
					"leavesAt": "07:28",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Mititei h.",
					"to": "Nimigea Hm.",
					"leavesAt": "07:31",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Nimigea Hm.",
					"to": "Nimigea h.",
					"leavesAt": "07:38",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Nimigea h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "07:42",
					"arrivesAt": "07:46",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Cociu h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cociu h.",
					"to": "Beclean pe Someş",
					"leavesAt": "07:50",
					"arrivesAt": "07:58",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Beclean pe Someş",
					"to": "Şintereag Hm.",
					"leavesAt": "08:17",
					"arrivesAt": "08:25",
					"waitsAtSource": 1140,
					"distance": 7400
				},
				{
					"from": "Şintereag Hm.",
					"to": "Caila hc.",
					"leavesAt": "08:26",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Caila hc.",
					"to": "Sfântu h.",
					"leavesAt": "08:31",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sfântu h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:41",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "08:42",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Sărata h.",
					"leavesAt": "08:53",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Viişoara h.",
					"leavesAt": "08:59",
					"arrivesAt": "09:02",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Viişoara h.",
					"to": "Bistriţa Nord",
					"leavesAt": "09:03",
					"arrivesAt": "09:09",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4206",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Viişoara h.",
					"leavesAt": "12:20",
					"arrivesAt": "12:26",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Viişoara h.",
					"to": "Sărata h.",
					"leavesAt": "12:27",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "12:31",
					"arrivesAt": "12:36",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "12:37",
					"arrivesAt": "12:41",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "12:42",
					"arrivesAt": "12:47",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Sfântu h.",
					"leavesAt": "12:48",
					"arrivesAt": "12:53",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Sfântu h.",
					"to": "Caila hc.",
					"leavesAt": "12:54",
					"arrivesAt": "12:57",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Caila hc.",
					"to": "Şintereag Hm.",
					"leavesAt": "12:58",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Şintereag Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "13:03",
					"arrivesAt": "13:12",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Beclean pe Someş",
					"to": "Cociu h.",
					"leavesAt": "13:40",
					"arrivesAt": "13:48",
					"waitsAtSource": 1680,
					"distance": 6700
				},
				{
					"from": "Cociu h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "13:49",
					"arrivesAt": "13:52",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Nimigea h.",
					"leavesAt": "13:53",
					"arrivesAt": "13:57",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Nimigea h.",
					"to": "Nimigea Hm.",
					"leavesAt": "13:58",
					"arrivesAt": "14:01",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Nimigea Hm.",
					"to": "Mititei h.",
					"leavesAt": "14:02",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mititei h.",
					"to": "Salva",
					"leavesAt": "14:09",
					"arrivesAt": "14:12",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Salva",
					"to": "Năsăud h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Năsăud h.",
					"to": "Năsăud",
					"leavesAt": "14:18",
					"arrivesAt": "14:21",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Năsăud",
					"to": "Rebrişoara Hm.",
					"leavesAt": "14:26",
					"arrivesAt": "14:31",
					"waitsAtSource": 300,
					"distance": 4800
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Nepos h.",
					"leavesAt": "14:32",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Nepos h.",
					"to": "Feldru Hm.",
					"leavesAt": "14:39",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Feldru Hm.",
					"to": "Podereia Feldrului h.",
					"leavesAt": "14:46",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Ilva Mică",
					"leavesAt": "14:50",
					"arrivesAt": "14:55",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Ilva Mică",
					"to": "Strâmba h.",
					"leavesAt": "14:56",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Strâmba h.",
					"to": "Leşu Ilvei Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:07",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Leşu Ilvei Hm.",
					"to": "Poiana Ilvei",
					"leavesAt": "15:08",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Poiana Ilvei",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "15:17",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Ilva Mare Hm.",
					"leavesAt": "15:25",
					"arrivesAt": "15:34",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ilva Mare Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "15:35",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Lunca Ilvei",
					"to": "Silhoasa Hm.",
					"leavesAt": "15:45",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Silhoasa Hm.",
					"to": "Larion Hm.",
					"leavesAt": "15:54",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Larion Hm.",
					"to": "Grădiniţa",
					"leavesAt": "16:05",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Grădiniţa",
					"to": "Coşna Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:31",
					"waitsAtSource": 360,
					"distance": 8000
				},
				{
					"from": "Coşna Hm.",
					"to": "Floreni",
					"leavesAt": "16:32",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Floreni",
					"to": "Dorna Candrenilor h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:54",
					"waitsAtSource": 540,
					"distance": 3500
				},
				{
					"from": "Dorna Candrenilor h.",
					"to": "Roşu Hm.",
					"leavesAt": "16:55",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Roşu Hm.",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "17:02",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Vatra Dornei",
					"leavesAt": "17:10",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4335",
			"segments": [
				{
					"from": "Valea lui Mihai",
					"to": "Curtuiuşeni h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:59",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Resighea h.",
					"leavesAt": "13:00",
					"arrivesAt": "13:07",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Resighea h.",
					"to": "Sanislău Hm.",
					"leavesAt": "13:08",
					"arrivesAt": "13:13",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Sanislău Hm.",
					"to": "Marna h.",
					"leavesAt": "13:14",
					"arrivesAt": "13:19",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Marna h.",
					"to": "Carei",
					"leavesAt": "13:20",
					"arrivesAt": "13:28",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Carei",
					"to": "Domăneşti h.",
					"leavesAt": "13:29",
					"arrivesAt": "13:38",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Domăneşti h.",
					"to": "Moftin h.",
					"leavesAt": "13:39",
					"arrivesAt": "13:43",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Moftin h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "13:44",
					"arrivesAt": "13:48",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Sătmărel h.",
					"leavesAt": "13:49",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Sătmărel h.",
					"to": "Satu Mare Sud",
					"leavesAt": "13:59",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Satu Mare Sud",
					"to": "Satu Mare",
					"leavesAt": "14:07",
					"arrivesAt": "14:14",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4331",
			"segments": [
				{
					"from": "Oradea",
					"to": "Diosig Hm.",
					"leavesAt": "02:53",
					"arrivesAt": "03:25",
					"waitsAtSource": 0,
					"distance": 33700
				},
				{
					"from": "Diosig Hm.",
					"to": "Săcuieni Bihor",
					"leavesAt": "03:34",
					"arrivesAt": "03:45",
					"waitsAtSource": 540,
					"distance": 10500
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Şilindru Hm.",
					"leavesAt": "03:46",
					"arrivesAt": "03:54",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Şilindru Hm.",
					"to": "Simion h.",
					"leavesAt": "03:55",
					"arrivesAt": "04:02",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Simion h.",
					"to": "Valea lui Mihai",
					"leavesAt": "04:03",
					"arrivesAt": "04:10",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Valea lui Mihai",
					"to": "Curtuiuşeni h.",
					"leavesAt": "04:35",
					"arrivesAt": "04:42",
					"waitsAtSource": 1500,
					"distance": 6300
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Resighea h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:50",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Resighea h.",
					"to": "Sanislău Hm.",
					"leavesAt": "04:51",
					"arrivesAt": "04:56",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Sanislău Hm.",
					"to": "Marna h.",
					"leavesAt": "04:57",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Marna h.",
					"to": "Carei",
					"leavesAt": "05:03",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Carei",
					"to": "Domăneşti h.",
					"leavesAt": "05:11",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Domăneşti h.",
					"to": "Moftin h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Moftin h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "05:26",
					"arrivesAt": "05:30",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Sătmărel h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Sătmărel h.",
					"to": "Satu Mare Sud",
					"leavesAt": "05:41",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Satu Mare Sud",
					"to": "Satu Mare",
					"leavesAt": "05:49",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Satu Mare",
					"to": "Ram. Botiz h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:18",
					"waitsAtSource": 960,
					"distance": 5000
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Micula Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Micula Hm.",
					"to": "Porumbeşti Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Halmeu",
					"leavesAt": "06:34",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4074",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:58",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "13:59",
					"arrivesAt": "14:03",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "14:04",
					"arrivesAt": "14:10",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "14:11",
					"arrivesAt": "14:27",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Zalău Nord",
					"to": "Guruslău h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:38",
					"waitsAtSource": 120,
					"distance": 6700
				},
				{
					"from": "Guruslău h.",
					"to": "Borla Hm.",
					"leavesAt": "14:39",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Borla Hm.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:54",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Sărmăşag",
					"leavesAt": "14:55",
					"arrivesAt": "15:02",
					"waitsAtSource": 30,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180212",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180616",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180901",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171223",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4361",
			"segments": [
				{
					"from": "Sărmăşag",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "06:58",
					"arrivesAt": "07:05",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "07:06",
					"arrivesAt": "07:10",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Borla Hm.",
					"leavesAt": "07:11",
					"arrivesAt": "07:15",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Borla Hm.",
					"to": "Guruslău h.",
					"leavesAt": "07:16",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Guruslău h.",
					"to": "Zalău Nord",
					"leavesAt": "07:22",
					"arrivesAt": "07:30",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "07:32",
					"arrivesAt": "07:49",
					"waitsAtSource": 120,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "08:02",
					"arrivesAt": "08:09",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180616",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180901",
					"daysOfWeek": 799
				},
				{
					"from": "20180909",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4308",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "17:35",
					"arrivesAt": "17:45",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "17:46",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "17:51",
					"arrivesAt": "17:57",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Apahida h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Apahida h.",
					"to": "Jucu Hm.",
					"leavesAt": "18:03",
					"arrivesAt": "18:08",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Jucu Hm.",
					"to": "Jucu de Jos hc.",
					"leavesAt": "18:09",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 1820
				},
				{
					"from": "Jucu de Jos hc.",
					"to": "Răscruci h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 2680
				},
				{
					"from": "Răscruci h.",
					"to": "Bonţida Hm.",
					"leavesAt": "18:18",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Bonţida Hm.",
					"to": "Fundătura h.",
					"leavesAt": "18:23",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Fundătura h.",
					"to": "Iclod Hm.",
					"leavesAt": "18:30",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Iclod Hm.",
					"to": "Livada Someş h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:41",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Livada Someş h.",
					"to": "Gherla",
					"leavesAt": "18:42",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Gherla",
					"to": "Nima h.",
					"leavesAt": "18:52",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Nima h.",
					"to": "Dej Călători",
					"leavesAt": "19:04",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5101",
			"segments": [
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "04:55",
					"arrivesAt": "05:06",
					"waitsAtSource": 0,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "05:07",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "05:18",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "05:40",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "05:48",
					"arrivesAt": "05:55",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "05:56",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "06:05",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:32",
					"waitsAtSource": 240,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "06:33",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "06:51",
					"arrivesAt": "06:58",
					"waitsAtSource": 480,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "07:16",
					"arrivesAt": "07:28",
					"waitsAtSource": 30,
					"distance": 8400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5110",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "16:00",
					"arrivesAt": "16:08",
					"waitsAtSource": 0,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "16:09",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Focşani",
					"to": "Coteşti Hm.",
					"leavesAt": "16:25",
					"arrivesAt": "16:33",
					"waitsAtSource": 120,
					"distance": 7900
				},
				{
					"from": "Coteşti Hm.",
					"to": "Gugeşti",
					"leavesAt": "16:34",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Gugeşti",
					"to": "Sihlea Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sihlea Hm.",
					"to": "Voetin h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Voetin h.",
					"to": "Râmnicu Sărat",
					"leavesAt": "17:00",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Zoita Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Zoita Hm.",
					"to": "Boboc Hm.",
					"leavesAt": "17:22",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Boboc Hm.",
					"to": "Buzău",
					"leavesAt": "17:33",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 11500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7569",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "07:00",
					"arrivesAt": "07:07",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Cosmeşti Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "Tecuci",
					"leavesAt": "07:14",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Tecuci",
					"to": "Malul Alb h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:33",
					"waitsAtSource": 120,
					"distance": 5600
				},
				{
					"from": "Malul Alb h.",
					"to": "Barcea",
					"leavesAt": "07:34",
					"arrivesAt": "07:39",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Barcea",
					"to": "Umbrăreşti h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "07:47",
					"arrivesAt": "07:53",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Iveşti Hm.",
					"to": "Buceşti h.",
					"leavesAt": "07:54",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Buceşti h.",
					"to": "Lieşti",
					"leavesAt": "07:59",
					"arrivesAt": "08:03",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lieşti",
					"to": "Şerbăneşti h.",
					"leavesAt": "08:04",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "08:09",
					"arrivesAt": "08:15",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "08:16",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Vameş h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Vameş h.",
					"to": "Piscu h.",
					"leavesAt": "08:29",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Piscu h.",
					"to": "Independenţa Hm.",
					"leavesAt": "08:34",
					"arrivesAt": "08:41",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Independenţa Hm.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Braniştea h.",
					"leavesAt": "08:48",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Braniştea h.",
					"to": "Şendreni Hm.",
					"leavesAt": "08:53",
					"arrivesAt": "09:02",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Şendreni Hm.",
					"to": "Barboşi",
					"leavesAt": "09:03",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "09:15",
					"arrivesAt": "09:21",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "09:22",
					"arrivesAt": "09:33",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1590",
			"segments": [
				{
					"from": "Drobeta Tr. Severin",
					"to": "Balota",
					"leavesAt": "14:25",
					"arrivesAt": "14:58",
					"waitsAtSource": 0,
					"distance": 19000
				},
				{
					"from": "Balota",
					"to": "Strehaia hc.",
					"leavesAt": "14:59",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Strehaia hc.",
					"to": "Filiaşi",
					"leavesAt": "15:30",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "15:55",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "16:28",
					"arrivesAt": "17:08",
					"waitsAtSource": 480,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Roşiori Nord",
					"leavesAt": "17:10",
					"arrivesAt": "17:53",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "17:55",
					"arrivesAt": "18:40",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Grădinari",
					"leavesAt": "18:42",
					"arrivesAt": "19:08",
					"waitsAtSource": 120,
					"distance": 25400
				},
				{
					"from": "Grădinari",
					"to": "Bucureşti Nord",
					"leavesAt": "19:13",
					"arrivesAt": "19:42",
					"waitsAtSource": 300,
					"distance": 25500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9477",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Bradu de Sus",
					"leavesAt": "19:50",
					"arrivesAt": "19:57",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bradu de Sus",
					"to": "Pârvu Hm.",
					"leavesAt": "19:58",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Pârvu Hm.",
					"to": "Pârvu h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Pârvu h.",
					"to": "Costeşti",
					"leavesAt": "20:11",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Costeşti",
					"to": "Fâlfani Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:33",
					"waitsAtSource": 120,
					"distance": 7900
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "20:34",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Stolnici Hm.",
					"to": "Hârseşti Hm.",
					"leavesAt": "20:47",
					"arrivesAt": "20:53",
					"waitsAtSource": 300,
					"distance": 4700
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Corbu",
					"leavesAt": "20:54",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Corbu",
					"to": "Sineşti Hm.",
					"leavesAt": "21:01",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Sineşti Hm.",
					"to": "Potcoava",
					"leavesAt": "21:09",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Potcoava",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "21:18",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Recea Hm.",
					"leavesAt": "21:27",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Recea Hm.",
					"to": "Slatina",
					"leavesAt": "21:39",
					"arrivesAt": "21:47",
					"waitsAtSource": 300,
					"distance": 7800
				},
				{
					"from": "Slatina",
					"to": "Criva h.",
					"leavesAt": "21:48",
					"arrivesAt": "22:01",
					"waitsAtSource": 60,
					"distance": 13000
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "22:02",
					"arrivesAt": "22:09",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9476",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:19",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "16:20",
					"arrivesAt": "16:25",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "16:26",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "16:35",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "16:51",
					"waitsAtSource": 120,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "16:55",
					"arrivesAt": "17:04",
					"waitsAtSource": 240,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "17:05",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Potcoava",
					"to": "Sineşti Hm.",
					"leavesAt": "17:14",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sineşti Hm.",
					"to": "Corbu",
					"leavesAt": "17:22",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Corbu",
					"to": "Hârseşti Hm.",
					"leavesAt": "17:30",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stolnici Hm.",
					"to": "Fâlfani Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Costeşti",
					"leavesAt": "17:54",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Costeşti",
					"to": "Pârvu h.",
					"leavesAt": "18:08",
					"arrivesAt": "18:15",
					"waitsAtSource": 360,
					"distance": 7600
				},
				{
					"from": "Pârvu h.",
					"to": "Pârvu Hm.",
					"leavesAt": "18:16",
					"arrivesAt": "18:24",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Pârvu Hm.",
					"to": "Bradu de Sus",
					"leavesAt": "18:25",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bradu de Sus",
					"to": "Km. 109+000 h.",
					"leavesAt": "18:34",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Km. 109+000 h.",
					"to": "Piteşti",
					"leavesAt": "18:40",
					"arrivesAt": "18:42",
					"waitsAtSource": 30,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "36313",
			"segments": [
				{
					"from": "Tiborszallas",
					"to": "Carei",
					"leavesAt": "15:55",
					"arrivesAt": "16:21",
					"waitsAtSource": 0,
					"distance": 16100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "36329",
			"segments": [
				{
					"from": "Tiborszallas",
					"to": "Carei",
					"leavesAt": "07:20",
					"arrivesAt": "07:46",
					"waitsAtSource": 0,
					"distance": 16100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4084",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Satu Mare Sud",
					"leavesAt": "14:35",
					"arrivesAt": "14:40",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Satu Mare Sud",
					"to": "Sătmărel h.",
					"leavesAt": "14:41",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Sătmărel h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "14:48",
					"arrivesAt": "14:57",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Moftin h.",
					"leavesAt": "14:58",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Moftin h.",
					"to": "Domăneşti h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:06",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Domăneşti h.",
					"to": "Carei",
					"leavesAt": "15:07",
					"arrivesAt": "15:19",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Carei",
					"to": "Tiream h.",
					"leavesAt": "15:29",
					"arrivesAt": "15:39",
					"waitsAtSource": 600,
					"distance": 11700
				},
				{
					"from": "Tiream h.",
					"to": "Hotoan h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Hotoan h.",
					"to": "Santău h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Santău h.",
					"to": "Tăşnad",
					"leavesAt": "15:51",
					"arrivesAt": "15:56",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tăşnad",
					"to": "Săcăşeni h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Săcăşeni h.",
					"to": "Acâş Hm.",
					"leavesAt": "16:03",
					"arrivesAt": "16:12",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Acâş Hm.",
					"to": "Supur Haltă hc.",
					"leavesAt": "16:13",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Supur Haltă hc.",
					"to": "Supur h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Supur h.",
					"to": "Giorocuţa h.",
					"leavesAt": "16:25",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Giorocuţa h.",
					"to": "Derşida h.",
					"leavesAt": "16:29",
					"arrivesAt": "16:34",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Derşida h.",
					"to": "Sărmăşag h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:38",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Sărmăşag h.",
					"to": "Sărmăşag",
					"leavesAt": "16:39",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Sărmăşag",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "16:47",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "16:55",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Borla Hm.",
					"leavesAt": "17:00",
					"arrivesAt": "17:04",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Borla Hm.",
					"to": "Guruslău h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Guruslău h.",
					"to": "Zalău Nord",
					"leavesAt": "17:11",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "17:19",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:54",
					"waitsAtSource": 660,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "17:55",
					"arrivesAt": "18:00",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "18:01",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4321",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Botiz Hm.",
					"leavesAt": "14:45",
					"arrivesAt": "14:51",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Botiz Hm.",
					"to": "Odoreu h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Odoreu h.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "14:59",
					"arrivesAt": "15:10",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Apa Hm.",
					"leavesAt": "15:11",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20180114",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180901",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				},
				{
					"from": "20171231",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4322",
			"segments": [
				{
					"from": "Apa Hm.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "15:36",
					"arrivesAt": "15:45",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Odoreu h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Odoreu h.",
					"to": "Botiz Hm.",
					"leavesAt": "15:56",
					"arrivesAt": "16:02",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Botiz Hm.",
					"to": "Satu Mare",
					"leavesAt": "16:03",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20180114",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180901",
					"daysOfWeek": 799
				},
				{
					"from": "20180909",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				},
				{
					"from": "20171231",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4452",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "21:42",
					"arrivesAt": "21:50",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:56",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "21:57",
					"arrivesAt": "22:04",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "22:05",
					"arrivesAt": "22:22",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "36326",
			"segments": [
				{
					"from": "Carei",
					"to": "Tiborszallas",
					"leavesAt": "17:38",
					"arrivesAt": "18:04",
					"waitsAtSource": 0,
					"distance": 16100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4340",
			"segments": [
				{
					"from": "Valea lui Mihai",
					"to": "Simion h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:55",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Simion h.",
					"to": "Şilindru Hm.",
					"leavesAt": "05:56",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Şilindru Hm.",
					"to": "Săcuieni Bihor",
					"leavesAt": "06:04",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Cadia h.",
					"leavesAt": "06:13",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cadia h.",
					"to": "Diosig Hm.",
					"leavesAt": "06:21",
					"arrivesAt": "06:27",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Diosig Hm.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Tămăşeu h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:41",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tămăşeu h.",
					"to": "Biharia Hm.",
					"leavesAt": "06:42",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Biharia Hm.",
					"to": "Episcopia Bihor",
					"leavesAt": "06:50",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "07:01",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171223",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2611",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:04",
					"waitsAtSource": 0,
					"distance": 4400
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:07",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "20:08",
					"arrivesAt": "20:11",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:23",
					"waitsAtSource": 360,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Băile Călacea",
					"leavesAt": "20:24",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Călacea",
					"to": "Orţişoara",
					"leavesAt": "20:31",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Orţişoara",
					"to": "Vinga Hm.",
					"leavesAt": "20:37",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Valea Viilor Hm.",
					"leavesAt": "20:50",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Aradu Nou",
					"leavesAt": "21:00",
					"arrivesAt": "21:10",
					"waitsAtSource": 300,
					"distance": 5500
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "21:11",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5311",
			"segments": [
				{
					"from": "Adjud",
					"to": "Urecheşti Hm.",
					"leavesAt": "19:45",
					"arrivesAt": "19:54",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "19:55",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Bâlca hc.",
					"leavesAt": "20:00",
					"arrivesAt": "20:05",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Bâlca hc.",
					"to": "Căiuţi Hm.",
					"leavesAt": "20:06",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Borzeşti Bacău",
					"leavesAt": "20:13",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Oneşti",
					"leavesAt": "20:30",
					"arrivesAt": "20:37",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Oneşti",
					"to": "Viişoara h",
					"leavesAt": "20:38",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Viişoara h",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "20:51",
					"arrivesAt": "20:58",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Saline hc.",
					"leavesAt": "20:59",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Saline hc.",
					"to": "Cireşoaia h.",
					"leavesAt": "21:03",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cireşoaia h.",
					"to": "Dofteana Bacău",
					"leavesAt": "21:09",
					"arrivesAt": "21:14",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dofteana Bacău",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "21:21",
					"arrivesAt": "21:26",
					"waitsAtSource": 420,
					"distance": 5100
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Valea Uzului Hm.",
					"leavesAt": "21:27",
					"arrivesAt": "21:32",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Comăneşti",
					"leavesAt": "21:33",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5213",
			"segments": [
				{
					"from": "Comăneşti",
					"to": "Asău Hm.",
					"leavesAt": "04:15",
					"arrivesAt": "04:20",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Asău Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "04:21",
					"arrivesAt": "04:26",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Caraliţa h.",
					"to": "Goioasa Hm.",
					"leavesAt": "04:27",
					"arrivesAt": "04:33",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Goioasa Hm.",
					"to": "Simbrea Hm.",
					"leavesAt": "04:34",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Simbrea Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "04:43",
					"arrivesAt": "04:48",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Palanca Hm.",
					"leavesAt": "04:49",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Palanca Hm.",
					"to": "Ghimeş",
					"leavesAt": "04:55",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Ghimeş",
					"to": "Bolovăniş h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "05:11",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Tarcău h.",
					"leavesAt": "05:18",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "05:23",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Utuşoiu h.",
					"leavesAt": "05:29",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Utuşoiu h.",
					"to": "Livezi Ciuc",
					"leavesAt": "05:35",
					"arrivesAt": "05:41",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Caracău h.",
					"leavesAt": "05:44",
					"arrivesAt": "05:48",
					"waitsAtSource": 180,
					"distance": 2100
				},
				{
					"from": "Caracău h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "05:57",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Mihăileni Hm.",
					"leavesAt": "06:02",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Siculeni",
					"leavesAt": "06:07",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "06:14",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4083",
			"segments": [
				{
					"from": "Carei",
					"to": "Tiream h.",
					"leavesAt": "03:51",
					"arrivesAt": "04:02",
					"waitsAtSource": 0,
					"distance": 11700
				},
				{
					"from": "Tiream h.",
					"to": "Hotoan h.",
					"leavesAt": "04:03",
					"arrivesAt": "04:09",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Hotoan h.",
					"to": "Santău h.",
					"leavesAt": "04:10",
					"arrivesAt": "04:15",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Santău h.",
					"to": "Tăşnad",
					"leavesAt": "04:16",
					"arrivesAt": "04:21",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tăşnad",
					"to": "Săcăşeni h.",
					"leavesAt": "04:22",
					"arrivesAt": "04:27",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Săcăşeni h.",
					"to": "Acâş Hm.",
					"leavesAt": "04:28",
					"arrivesAt": "04:37",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Acâş Hm.",
					"to": "Supur Haltă hc.",
					"leavesAt": "04:42",
					"arrivesAt": "04:49",
					"waitsAtSource": 300,
					"distance": 7500
				},
				{
					"from": "Supur Haltă hc.",
					"to": "Supur h.",
					"leavesAt": "04:50",
					"arrivesAt": "04:52",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Supur h.",
					"to": "Giorocuţa h.",
					"leavesAt": "04:53",
					"arrivesAt": "04:56",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Giorocuţa h.",
					"to": "Derşida h.",
					"leavesAt": "04:57",
					"arrivesAt": "05:02",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Derşida h.",
					"to": "Sărmăşag h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:05",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Sărmăşag h.",
					"to": "Sărmăşag",
					"leavesAt": "05:06",
					"arrivesAt": "05:12",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Sărmăşag",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:24",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Borla Hm.",
					"leavesAt": "05:25",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Borla Hm.",
					"to": "Guruslău h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Guruslău h.",
					"to": "Zalău Nord",
					"leavesAt": "05:36",
					"arrivesAt": "05:43",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "05:44",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:12",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "06:13",
					"arrivesAt": "06:20",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3620",
			"segments": [
				{
					"from": "Huedin",
					"to": "Jebuc h.",
					"leavesAt": "04:00",
					"arrivesAt": "04:06",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Jebuc h.",
					"to": "Stana Hm.",
					"leavesAt": "04:07",
					"arrivesAt": "04:14",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Stana Hm.",
					"to": "Gălăşeni h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Gălăşeni h.",
					"to": "Aghireş h.",
					"leavesAt": "04:19",
					"arrivesAt": "04:26",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "04:27",
					"arrivesAt": "04:31",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Dorolţu h.",
					"leavesAt": "04:32",
					"arrivesAt": "04:34",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Dorolţu h.",
					"to": "Macău h.",
					"leavesAt": "04:35",
					"arrivesAt": "04:37",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Macău h.",
					"to": "Gârbău Hm.",
					"leavesAt": "04:38",
					"arrivesAt": "04:43",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Gârbău Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "04:44",
					"arrivesAt": "04:50",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Nădăşel h.",
					"to": "Mera Hm.",
					"leavesAt": "04:51",
					"arrivesAt": "04:54",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mera Hm.",
					"to": "Rădaia h.",
					"leavesAt": "04:55",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rădaia h.",
					"to": "Suceag h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:00",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Suceag h.",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "05:01",
					"arrivesAt": "05:06",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "05:07",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180106",
					"daysOfWeek": 383
				},
				{
					"from": "20180108",
					"to": "20180113",
					"daysOfWeek": 383
				},
				{
					"from": "20180115",
					"to": "20180120",
					"daysOfWeek": 383
				},
				{
					"from": "20180122",
					"to": "20180127",
					"daysOfWeek": 383
				},
				{
					"from": "20180129",
					"to": "20180203",
					"daysOfWeek": 383
				},
				{
					"from": "20180205",
					"to": "20180210",
					"daysOfWeek": 383
				},
				{
					"from": "20180212",
					"to": "20180217",
					"daysOfWeek": 383
				},
				{
					"from": "20180219",
					"to": "20180224",
					"daysOfWeek": 383
				},
				{
					"from": "20180226",
					"to": "20180303",
					"daysOfWeek": 383
				},
				{
					"from": "20180305",
					"to": "20180310",
					"daysOfWeek": 383
				},
				{
					"from": "20180312",
					"to": "20180317",
					"daysOfWeek": 383
				},
				{
					"from": "20180319",
					"to": "20180324",
					"daysOfWeek": 383
				},
				{
					"from": "20180326",
					"to": "20180331",
					"daysOfWeek": 383
				},
				{
					"from": "20180402",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180410",
					"to": "20180414",
					"daysOfWeek": 383
				},
				{
					"from": "20180416",
					"to": "20180421",
					"daysOfWeek": 383
				},
				{
					"from": "20180423",
					"to": "20180428",
					"daysOfWeek": 383
				},
				{
					"from": "20180430",
					"to": "20180505",
					"daysOfWeek": 383
				},
				{
					"from": "20180507",
					"to": "20180512",
					"daysOfWeek": 383
				},
				{
					"from": "20180514",
					"to": "20180519",
					"daysOfWeek": 383
				},
				{
					"from": "20180521",
					"to": "20180526",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20180602",
					"daysOfWeek": 383
				},
				{
					"from": "20180604",
					"to": "20180609",
					"daysOfWeek": 383
				},
				{
					"from": "20180611",
					"to": "20180616",
					"daysOfWeek": 383
				},
				{
					"from": "20180618",
					"to": "20180623",
					"daysOfWeek": 383
				},
				{
					"from": "20180625",
					"to": "20180630",
					"daysOfWeek": 383
				},
				{
					"from": "20180702",
					"to": "20180707",
					"daysOfWeek": 383
				},
				{
					"from": "20180709",
					"to": "20180714",
					"daysOfWeek": 383
				},
				{
					"from": "20180716",
					"to": "20180721",
					"daysOfWeek": 383
				},
				{
					"from": "20180723",
					"to": "20180728",
					"daysOfWeek": 383
				},
				{
					"from": "20180730",
					"to": "20180804",
					"daysOfWeek": 383
				},
				{
					"from": "20180806",
					"to": "20180811",
					"daysOfWeek": 383
				},
				{
					"from": "20180813",
					"to": "20180818",
					"daysOfWeek": 383
				},
				{
					"from": "20180820",
					"to": "20180825",
					"daysOfWeek": 383
				},
				{
					"from": "20180827",
					"to": "20180901",
					"daysOfWeek": 383
				},
				{
					"from": "20180903",
					"to": "20180908",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20180915",
					"daysOfWeek": 383
				},
				{
					"from": "20180917",
					"to": "20180922",
					"daysOfWeek": 383
				},
				{
					"from": "20180924",
					"to": "20180929",
					"daysOfWeek": 383
				},
				{
					"from": "20181001",
					"to": "20181006",
					"daysOfWeek": 383
				},
				{
					"from": "20181008",
					"to": "20181013",
					"daysOfWeek": 383
				},
				{
					"from": "20181015",
					"to": "20181020",
					"daysOfWeek": 383
				},
				{
					"from": "20181022",
					"to": "20181027",
					"daysOfWeek": 383
				},
				{
					"from": "20181029",
					"to": "20181103",
					"daysOfWeek": 383
				},
				{
					"from": "20181105",
					"to": "20181110",
					"daysOfWeek": 383
				},
				{
					"from": "20181112",
					"to": "20181117",
					"daysOfWeek": 383
				},
				{
					"from": "20181119",
					"to": "20181124",
					"daysOfWeek": 383
				},
				{
					"from": "20181126",
					"to": "20181129",
					"daysOfWeek": 383
				},
				{
					"from": "20181203",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171211",
					"to": "20171216",
					"daysOfWeek": 383
				},
				{
					"from": "20171218",
					"to": "20171223",
					"daysOfWeek": 383
				},
				{
					"from": "20171227",
					"to": "20171230",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3628",
			"segments": [
				{
					"from": "Huedin",
					"to": "Jebuc h.",
					"leavesAt": "14:25",
					"arrivesAt": "14:32",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Jebuc h.",
					"to": "Stana Hm.",
					"leavesAt": "14:33",
					"arrivesAt": "14:41",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Stana Hm.",
					"to": "Gălăşeni h.",
					"leavesAt": "14:42",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Gălăşeni h.",
					"to": "Aghireş h.",
					"leavesAt": "14:46",
					"arrivesAt": "14:53",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "14:54",
					"arrivesAt": "14:58",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Dorolţu h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Dorolţu h.",
					"to": "Macău h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Macău h.",
					"to": "Gârbău Hm.",
					"leavesAt": "15:05",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Gârbău Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Nădăşel h.",
					"to": "Mera Hm.",
					"leavesAt": "15:16",
					"arrivesAt": "15:19",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mera Hm.",
					"to": "Rădaia h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rădaia h.",
					"to": "Suceag h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Suceag h.",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "15:26",
					"arrivesAt": "15:31",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "15:32",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3629",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "14:55",
					"arrivesAt": "15:02",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Suceag h.",
					"leavesAt": "15:03",
					"arrivesAt": "15:07",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Suceag h.",
					"to": "Rădaia h.",
					"leavesAt": "15:08",
					"arrivesAt": "15:10",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Rădaia h.",
					"to": "Mera Hm.",
					"leavesAt": "15:11",
					"arrivesAt": "15:13",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Mera Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "15:14",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Nădăşel h.",
					"to": "Gârbău Hm.",
					"leavesAt": "15:18",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gârbău Hm.",
					"to": "Macău h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Macău h.",
					"to": "Dorolţu h.",
					"leavesAt": "15:32",
					"arrivesAt": "15:34",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Dorolţu h.",
					"to": "Aghireş",
					"leavesAt": "15:35",
					"arrivesAt": "15:38",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:42",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Gălăşeni h.",
					"leavesAt": "15:43",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Gălăşeni h.",
					"to": "Stana Hm.",
					"leavesAt": "15:51",
					"arrivesAt": "15:55",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Stana Hm.",
					"to": "Jebuc h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Jebuc h.",
					"to": "Huedin",
					"leavesAt": "16:04",
					"arrivesAt": "16:11",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Huedin",
					"to": "Brăişoru Hm.",
					"leavesAt": "16:12",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Bologa h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bologa h.",
					"to": "Poieni",
					"leavesAt": "16:27",
					"arrivesAt": "16:31",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3627",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "12:40",
					"arrivesAt": "12:47",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Suceag h.",
					"leavesAt": "12:48",
					"arrivesAt": "12:52",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Suceag h.",
					"to": "Rădaia h.",
					"leavesAt": "12:53",
					"arrivesAt": "12:55",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Rădaia h.",
					"to": "Mera Hm.",
					"leavesAt": "12:56",
					"arrivesAt": "12:59",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Mera Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "13:00",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Nădăşel h.",
					"to": "Gârbău Hm.",
					"leavesAt": "13:04",
					"arrivesAt": "13:11",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gârbău Hm.",
					"to": "Macău h.",
					"leavesAt": "13:12",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Macău h.",
					"to": "Dorolţu h.",
					"leavesAt": "13:18",
					"arrivesAt": "13:20",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Dorolţu h.",
					"to": "Aghireş",
					"leavesAt": "13:21",
					"arrivesAt": "13:24",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "13:25",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Gălăşeni h.",
					"leavesAt": "13:29",
					"arrivesAt": "13:36",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Gălăşeni h.",
					"to": "Stana Hm.",
					"leavesAt": "13:37",
					"arrivesAt": "13:41",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Stana Hm.",
					"to": "Jebuc h.",
					"leavesAt": "13:42",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Jebuc h.",
					"to": "Huedin",
					"leavesAt": "13:50",
					"arrivesAt": "13:57",
					"waitsAtSource": 30,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3637",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "22:45",
					"arrivesAt": "22:51",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Suceag h.",
					"leavesAt": "22:52",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Suceag h.",
					"to": "Rădaia h.",
					"leavesAt": "22:57",
					"arrivesAt": "22:59",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Rădaia h.",
					"to": "Mera Hm.",
					"leavesAt": "23:00",
					"arrivesAt": "23:03",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Mera Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "23:04",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Nădăşel h.",
					"to": "Gârbău Hm.",
					"leavesAt": "23:08",
					"arrivesAt": "23:14",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gârbău Hm.",
					"to": "Macău h.",
					"leavesAt": "23:15",
					"arrivesAt": "23:20",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Macău h.",
					"to": "Dorolţu h.",
					"leavesAt": "23:21",
					"arrivesAt": "23:23",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Dorolţu h.",
					"to": "Aghireş",
					"leavesAt": "23:24",
					"arrivesAt": "23:27",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "23:28",
					"arrivesAt": "23:31",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Gălăşeni h.",
					"leavesAt": "23:32",
					"arrivesAt": "23:38",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Gălăşeni h.",
					"to": "Stana Hm.",
					"leavesAt": "23:39",
					"arrivesAt": "23:43",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Stana Hm.",
					"to": "Jebuc h.",
					"leavesAt": "23:44",
					"arrivesAt": "23:51",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Jebuc h.",
					"to": "Huedin",
					"leavesAt": "23:52",
					"arrivesAt": "23:59",
					"waitsAtSource": 30,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180105",
					"daysOfWeek": 351
				},
				{
					"from": "20180107",
					"to": "20180112",
					"daysOfWeek": 351
				},
				{
					"from": "20180114",
					"to": "20180119",
					"daysOfWeek": 351
				},
				{
					"from": "20180121",
					"to": "20180126",
					"daysOfWeek": 351
				},
				{
					"from": "20180128",
					"to": "20180202",
					"daysOfWeek": 351
				},
				{
					"from": "20180204",
					"to": "20180209",
					"daysOfWeek": 351
				},
				{
					"from": "20180211",
					"to": "20180216",
					"daysOfWeek": 351
				},
				{
					"from": "20180218",
					"to": "20180223",
					"daysOfWeek": 351
				},
				{
					"from": "20180225",
					"to": "20180302",
					"daysOfWeek": 351
				},
				{
					"from": "20180304",
					"to": "20180309",
					"daysOfWeek": 351
				},
				{
					"from": "20180311",
					"to": "20180316",
					"daysOfWeek": 351
				},
				{
					"from": "20180318",
					"to": "20180323",
					"daysOfWeek": 351
				},
				{
					"from": "20180325",
					"to": "20180330",
					"daysOfWeek": 351
				},
				{
					"from": "20180401",
					"to": "20180406",
					"daysOfWeek": 351
				},
				{
					"from": "20180409",
					"to": "20180413",
					"daysOfWeek": 351
				},
				{
					"from": "20180415",
					"to": "20180420",
					"daysOfWeek": 351
				},
				{
					"from": "20180422",
					"to": "20180427",
					"daysOfWeek": 351
				},
				{
					"from": "20180429",
					"to": "20180504",
					"daysOfWeek": 351
				},
				{
					"from": "20180506",
					"to": "20180511",
					"daysOfWeek": 351
				},
				{
					"from": "20180513",
					"to": "20180518",
					"daysOfWeek": 351
				},
				{
					"from": "20180520",
					"to": "20180525",
					"daysOfWeek": 351
				},
				{
					"from": "20180528",
					"to": "20180601",
					"daysOfWeek": 351
				},
				{
					"from": "20180603",
					"to": "20180608",
					"daysOfWeek": 351
				},
				{
					"from": "20180610",
					"to": "20180615",
					"daysOfWeek": 351
				},
				{
					"from": "20180617",
					"to": "20180622",
					"daysOfWeek": 351
				},
				{
					"from": "20180624",
					"to": "20180629",
					"daysOfWeek": 351
				},
				{
					"from": "20180701",
					"to": "20180706",
					"daysOfWeek": 351
				},
				{
					"from": "20180708",
					"to": "20180713",
					"daysOfWeek": 351
				},
				{
					"from": "20180715",
					"to": "20180720",
					"daysOfWeek": 351
				},
				{
					"from": "20180722",
					"to": "20180727",
					"daysOfWeek": 351
				},
				{
					"from": "20180729",
					"to": "20180803",
					"daysOfWeek": 351
				},
				{
					"from": "20180805",
					"to": "20180810",
					"daysOfWeek": 351
				},
				{
					"from": "20180812",
					"to": "20180817",
					"daysOfWeek": 351
				},
				{
					"from": "20180819",
					"to": "20180824",
					"daysOfWeek": 351
				},
				{
					"from": "20180826",
					"to": "20180831",
					"daysOfWeek": 351
				},
				{
					"from": "20180902",
					"to": "20180907",
					"daysOfWeek": 351
				},
				{
					"from": "20180909",
					"to": "20180914",
					"daysOfWeek": 351
				},
				{
					"from": "20180916",
					"to": "20180921",
					"daysOfWeek": 351
				},
				{
					"from": "20180923",
					"to": "20180928",
					"daysOfWeek": 351
				},
				{
					"from": "20180930",
					"to": "20181005",
					"daysOfWeek": 351
				},
				{
					"from": "20181007",
					"to": "20181012",
					"daysOfWeek": 351
				},
				{
					"from": "20181014",
					"to": "20181019",
					"daysOfWeek": 351
				},
				{
					"from": "20181021",
					"to": "20181026",
					"daysOfWeek": 351
				},
				{
					"from": "20181028",
					"to": "20181102",
					"daysOfWeek": 351
				},
				{
					"from": "20181104",
					"to": "20181109",
					"daysOfWeek": 351
				},
				{
					"from": "20181111",
					"to": "20181116",
					"daysOfWeek": 351
				},
				{
					"from": "20181118",
					"to": "20181123",
					"daysOfWeek": 351
				},
				{
					"from": "20181125",
					"to": "20181129",
					"daysOfWeek": 351
				},
				{
					"from": "20181202",
					"to": "20181207",
					"daysOfWeek": 351
				},
				{
					"from": "20171210",
					"to": "20171215",
					"daysOfWeek": 351
				},
				{
					"from": "20171217",
					"to": "20171222",
					"daysOfWeek": 351
				},
				{
					"from": "20171226",
					"to": "20171229",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3635",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "19:58",
					"arrivesAt": "20:05",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Suceag h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Suceag h.",
					"to": "Rădaia h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:13",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Rădaia h.",
					"to": "Mera Hm.",
					"leavesAt": "20:14",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Mera Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "20:17",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Nădăşel h.",
					"to": "Gârbău Hm.",
					"leavesAt": "20:20",
					"arrivesAt": "20:26",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gârbău Hm.",
					"to": "Macău h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Macău h.",
					"to": "Dorolţu h.",
					"leavesAt": "20:32",
					"arrivesAt": "20:34",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Dorolţu h.",
					"to": "Aghireş",
					"leavesAt": "20:35",
					"arrivesAt": "20:38",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "20:39",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Gălăşeni h.",
					"leavesAt": "20:43",
					"arrivesAt": "20:49",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Gălăşeni h.",
					"to": "Stana Hm.",
					"leavesAt": "20:50",
					"arrivesAt": "20:54",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Stana Hm.",
					"to": "Jebuc h.",
					"leavesAt": "20:55",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Jebuc h.",
					"to": "Huedin",
					"leavesAt": "21:03",
					"arrivesAt": "21:10",
					"waitsAtSource": 30,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3622",
			"segments": [
				{
					"from": "Huedin",
					"to": "Jebuc h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:59",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Jebuc h.",
					"to": "Stana Hm.",
					"leavesAt": "06:00",
					"arrivesAt": "06:08",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Stana Hm.",
					"to": "Gălăşeni h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Gălăşeni h.",
					"to": "Aghireş h.",
					"leavesAt": "06:13",
					"arrivesAt": "06:20",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "06:21",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Dorolţu h.",
					"leavesAt": "06:26",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Dorolţu h.",
					"to": "Macău h.",
					"leavesAt": "06:29",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Macău h.",
					"to": "Gârbău Hm.",
					"leavesAt": "06:32",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Gârbău Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Nădăşel h.",
					"to": "Mera Hm.",
					"leavesAt": "06:46",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mera Hm.",
					"to": "Rădaia h.",
					"leavesAt": "06:50",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rădaia h.",
					"to": "Suceag h.",
					"leavesAt": "06:53",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Suceag h.",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "06:56",
					"arrivesAt": "07:00",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "07:01",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3640",
			"segments": [
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "04:02",
					"arrivesAt": "04:37",
					"waitsAtSource": 0,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "04:38",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "04:59",
					"arrivesAt": "05:08",
					"waitsAtSource": 300,
					"distance": 6800
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "05:09",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3641",
			"segments": [
				{
					"from": "Bratca",
					"to": "Bălnaca h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:52",
					"waitsAtSource": 0,
					"distance": 2300
				},
				{
					"from": "Bălnaca h.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "05:53",
					"arrivesAt": "05:58",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Vadu Crişului h.",
					"leavesAt": "05:59",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vadu Crişului h.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "06:05",
					"arrivesAt": "06:08",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Butan h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Butan h.",
					"to": "Aleşd h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:19",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Aleşd h.",
					"to": "Aleşd",
					"leavesAt": "06:20",
					"arrivesAt": "06:26",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aleşd",
					"to": "Ţeţchea hc.",
					"leavesAt": "06:27",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Ţeţchea hc.",
					"to": "Telechiu Hm.",
					"leavesAt": "06:31",
					"arrivesAt": "06:36",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Telechiu Hm.",
					"to": "Tileagd",
					"leavesAt": "06:37",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Tileagd",
					"to": "Săbolciu h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Săbolciu h.",
					"to": "Săcădat h.",
					"leavesAt": "06:49",
					"arrivesAt": "06:52",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săcădat h.",
					"to": "Oşorhei Hm.",
					"leavesAt": "06:53",
					"arrivesAt": "06:59",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Oradea Est Triaj h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Oradea Est Triaj h.",
					"to": "Oradea Est",
					"leavesAt": "07:06",
					"arrivesAt": "07:08",
					"waitsAtSource": 30,
					"distance": 700
				},
				{
					"from": "Oradea Est",
					"to": "Oradea",
					"leavesAt": "07:09",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2344",
			"segments": [
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:41",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "06:42",
					"arrivesAt": "06:48",
					"waitsAtSource": 30,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2047",
			"segments": [
				{
					"from": "Simeria",
					"to": "Săuleşti h.",
					"leavesAt": "19:28",
					"arrivesAt": "19:32",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Săuleşti h.",
					"to": "Deva",
					"leavesAt": "19:33",
					"arrivesAt": "19:41",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "19:43",
					"arrivesAt": "19:53",
					"waitsAtSource": 120,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Mintia h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Veţel h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Veţel h.",
					"to": "Brănişca Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Ilia",
					"leavesAt": "20:17",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ilia",
					"to": "Gurasada Hm.",
					"leavesAt": "20:26",
					"arrivesAt": "20:33",
					"waitsAtSource": 120,
					"distance": 5800
				},
				{
					"from": "Gurasada Hm.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "20:34",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Burjuc h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Burjuc h.",
					"to": "Zam",
					"leavesAt": "20:49",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Zam",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "21:02",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Ilteu",
					"leavesAt": "21:07",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ilteu",
					"to": "Toc h.",
					"leavesAt": "21:15",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Toc h.",
					"to": "Săvârşin",
					"leavesAt": "21:19",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 7400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9576",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "16:27",
					"arrivesAt": "16:33",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Remetea Mare",
					"leavesAt": "16:34",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Remetea Mare",
					"to": "Izvin h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Izvin h.",
					"to": "Recaş",
					"leavesAt": "16:57",
					"arrivesAt": "17:00",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Recaş",
					"to": "Şuştra h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Şuştra h.",
					"to": "Topolovăţ",
					"leavesAt": "17:07",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Topolovăţ",
					"to": "Chizătău Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Chizătău Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "17:18",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Belinţ Hm.",
					"to": "Jabăr Hm.",
					"leavesAt": "17:23",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Lugoj",
					"leavesAt": "17:29",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Lugoj",
					"to": "Tapia Hm.",
					"leavesAt": "17:36",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Tapia Hm.",
					"to": "Găvojdia",
					"leavesAt": "17:43",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Găvojdia",
					"to": "Jena Hm.",
					"leavesAt": "17:48",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Jena Hm.",
					"to": "Sacu h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sacu h.",
					"to": "Căvăran",
					"leavesAt": "18:02",
					"arrivesAt": "18:05",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Căvăran",
					"to": "Zăgujeni Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Tibiscu h.",
					"leavesAt": "18:17",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tibiscu h.",
					"to": "Caransebeş",
					"leavesAt": "18:21",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9552",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Caransebeş haltă h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:03",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Caransebeş haltă h.",
					"to": "Balta Sărată",
					"leavesAt": "07:04",
					"arrivesAt": "07:08",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Balta Sărată",
					"to": "Valea Timişului Hm.",
					"leavesAt": "07:09",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Valea Timişului Hm.",
					"to": "Petroşniţa h.",
					"leavesAt": "07:14",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Petroşniţa h.",
					"to": "Vălişoara Hm.",
					"leavesAt": "07:18",
					"arrivesAt": "07:25",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălişoara Hm.",
					"to": "Slatina Timiş",
					"leavesAt": "07:26",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Slatina Timiş",
					"to": "Armeniş",
					"leavesAt": "07:33",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Armeniş",
					"to": "Teregova Hm.",
					"leavesAt": "07:44",
					"arrivesAt": "07:51",
					"waitsAtSource": 240,
					"distance": 5100
				},
				{
					"from": "Teregova Hm.",
					"to": "Poarta Hm.",
					"leavesAt": "07:52",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Poarta Hm.",
					"to": "Luncaviţa h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Luncaviţa h.",
					"to": "Domaşnea Cornea Hm.",
					"leavesAt": "08:08",
					"arrivesAt": "08:13",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Domaşnea Cornea Hm.",
					"to": "Cornea h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cornea h.",
					"to": "Cruşovăţ",
					"leavesAt": "08:19",
					"arrivesAt": "08:25",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Cruşovăţ",
					"to": "Iablaniţa",
					"leavesAt": "08:26",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Iablaniţa",
					"to": "Mehadia Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Mehadia Hm.",
					"to": "Mehadia Nouă Hm.",
					"leavesAt": "08:46",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Mehadia Nouă Hm.",
					"to": "Băile Herculane",
					"leavesAt": "08:50",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Băile Herculane",
					"to": "Topleţ Hm.",
					"leavesAt": "08:54",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Topleţ Hm.",
					"to": "Valea Cernei Hm.",
					"leavesAt": "09:04",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Valea Cernei Hm.",
					"to": "Orşova",
					"leavesAt": "09:10",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2436",
			"segments": [
				{
					"from": "Călimăneşti",
					"to": "Dăeşti Hm.",
					"leavesAt": "13:35",
					"arrivesAt": "13:42",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "13:43",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "13:53",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "13:59",
					"arrivesAt": "14:02",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4044",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "14:43",
					"arrivesAt": "14:59",
					"waitsAtSource": 0,
					"distance": 14600
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Fersig h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Fersig h.",
					"to": "Mireşu Mare PM.",
					"leavesAt": "15:06",
					"arrivesAt": "15:12",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "15:13",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Ţicău h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ţicău h.",
					"to": "Benesat Hm.",
					"leavesAt": "15:23",
					"arrivesAt": "15:30",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Benesat Hm.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "15:31",
					"arrivesAt": "15:34",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Inău h.",
					"leavesAt": "15:35",
					"arrivesAt": "15:38",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Inău h.",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:43",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Jibou",
					"leavesAt": "15:44",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 9300
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4375",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Viişoara h.",
					"leavesAt": "14:32",
					"arrivesAt": "14:39",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Viişoara h.",
					"to": "Sărata h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "14:44",
					"arrivesAt": "14:49",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "14:50",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "14:55",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Sfântu h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Sfântu h.",
					"to": "Caila hc.",
					"leavesAt": "15:07",
					"arrivesAt": "15:10",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Caila hc.",
					"to": "Şintereag Hm.",
					"leavesAt": "15:11",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Şintereag Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "15:16",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Beclean pe Someş",
					"to": "Coldău Hm.",
					"leavesAt": "15:48",
					"arrivesAt": "15:58",
					"waitsAtSource": 1380,
					"distance": 5100
				},
				{
					"from": "Coldău Hm.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "16:06",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Ciceu Mihăeşti h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ciceu Mihăeşti h.",
					"to": "Dej Triaj",
					"leavesAt": "16:17",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "16:23",
					"arrivesAt": "16:30",
					"waitsAtSource": 60,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4376",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "05:28",
					"arrivesAt": "05:35",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Ciceu Mihăeşti h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ciceu Mihăeşti h.",
					"to": "Reteag Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Reteag Hm.",
					"to": "Reteag h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag h.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "05:53",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "05:57",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "06:02",
					"arrivesAt": "06:11",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Beclean pe Someş",
					"to": "Şintereag Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:34",
					"waitsAtSource": 840,
					"distance": 7400
				},
				{
					"from": "Şintereag Hm.",
					"to": "Caila hc.",
					"leavesAt": "06:35",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Caila hc.",
					"to": "Sfântu h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sfântu h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "06:44",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "06:52",
					"arrivesAt": "06:55",
					"waitsAtSource": 120,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel Hm.",
					"leavesAt": "06:56",
					"arrivesAt": "07:03",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Sărata h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:10",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Viişoara h.",
					"leavesAt": "07:11",
					"arrivesAt": "07:14",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Viişoara h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:19",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "07:20",
					"arrivesAt": "07:23",
					"waitsAtSource": 30,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4046",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "16:36",
					"arrivesAt": "16:52",
					"waitsAtSource": 0,
					"distance": 14600
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Fersig h.",
					"leavesAt": "16:53",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Fersig h.",
					"to": "Mireşu Mare PM.",
					"leavesAt": "16:59",
					"arrivesAt": "17:05",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "17:06",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Ţicău h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:16",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Ţicău h.",
					"to": "Benesat Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Benesat Hm.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:38",
					"waitsAtSource": 600,
					"distance": 2700
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Inău h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Inău h.",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:47",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Jibou",
					"leavesAt": "17:48",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 9300
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4532",
			"segments": [
				{
					"from": "Războieni",
					"to": "Lunca Mureşului h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:09",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Gura Arieşului h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:20",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Cheţani h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Cheţani h.",
					"to": "Luduş",
					"leavesAt": "05:26",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Luduş",
					"to": "Bogata Mureş h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Cuci h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cuci h.",
					"to": "Iernut",
					"leavesAt": "05:45",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Iernut",
					"to": "Cipău h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Cipău h.",
					"to": "Ogra h.",
					"leavesAt": "05:57",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ogra h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "06:01",
					"arrivesAt": "06:05",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Chirileu h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chirileu h.",
					"to": "Vidrasău h.",
					"leavesAt": "06:11",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vidrasău h.",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "06:16",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "06:22",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "Azomureş h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş",
					"leavesAt": "06:31",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "06:41",
					"arrivesAt": "06:49",
					"waitsAtSource": 300,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2423",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(210)",
					"leavesAt": "14:33",
					"arrivesAt": "14:36",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Turnişor Hm.",
					"leavesAt": "14:37",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Cristian Sibiu h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Orlat",
					"leavesAt": "14:56",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Orlat",
					"to": "Sibiel h.",
					"leavesAt": "15:05",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Sibiel h.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:13",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sălişte Hm.",
					"leavesAt": "15:14",
					"arrivesAt": "15:20",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sălişte Hm.",
					"to": "Aciliu h.",
					"leavesAt": "15:21",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Aciliu h.",
					"to": "Tilişca h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:29",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Tilişca h.",
					"to": "Apoldu de Sus Hm.",
					"leavesAt": "15:30",
					"arrivesAt": "15:41",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Apoldu de Sus Hm.",
					"to": "Apoldu de Jos h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Apoldu de Jos h.",
					"to": "Miercurea Sibiu Hm.",
					"leavesAt": "15:50",
					"arrivesAt": "15:56",
					"waitsAtSource": 30,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180115",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180212",
					"to": "20180323",
					"daysOfWeek": 799
				},
				{
					"from": "20180326",
					"to": "20180330",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4584",
			"segments": [
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "14:44",
					"arrivesAt": "14:51",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:02",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "15:03",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "15:07",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:26",
					"waitsAtSource": 240,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "15:27",
					"arrivesAt": "15:33",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180616",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180901",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171231",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4135",
			"segments": [
				{
					"from": "Beclean pe Someş",
					"to": "Cociu h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:38",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Cociu h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "07:39",
					"arrivesAt": "07:42",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Nimigea h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:52",
					"waitsAtSource": 360,
					"distance": 3600
				},
				{
					"from": "Nimigea h.",
					"to": "Nimigea Hm.",
					"leavesAt": "07:53",
					"arrivesAt": "07:57",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Nimigea Hm.",
					"to": "Mititei h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mititei h.",
					"to": "Salva",
					"leavesAt": "08:05",
					"arrivesAt": "08:09",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Salva",
					"to": "Coşbuc Hm.",
					"leavesAt": "08:11",
					"arrivesAt": "08:24",
					"waitsAtSource": 120,
					"distance": 9500
				},
				{
					"from": "Coşbuc Hm.",
					"to": "Telciu Hm.",
					"leavesAt": "08:25",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Telciu Hm.",
					"to": "Fiad Hm.",
					"leavesAt": "08:34",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Fiad Hm.",
					"to": "Romuli h.",
					"leavesAt": "08:49",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Romuli h.",
					"to": "Dealu Ştefăniţei",
					"leavesAt": "08:59",
					"arrivesAt": "09:08",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Dealu Ştefăniţei",
					"to": "Săcel Hm.",
					"leavesAt": "09:09",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Săcel Hm.",
					"to": "Iza P.M.",
					"leavesAt": "09:21",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Iza P.M.",
					"to": "Vişeu de Jos",
					"leavesAt": "09:32",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Vişeu de Jos",
					"to": "Leordina",
					"leavesAt": "10:00",
					"arrivesAt": "10:17",
					"waitsAtSource": 960,
					"distance": 12400
				},
				{
					"from": "Leordina",
					"to": "Petrova hc.",
					"leavesAt": "10:18",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Petrova hc.",
					"to": "Vişeu Bistra h.",
					"leavesAt": "10:29",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Valea Vişeului",
					"leavesAt": "10:38",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Valea Vişeului",
					"to": "Lunca la Tisa h.",
					"leavesAt": "11:12",
					"arrivesAt": "11:28",
					"waitsAtSource": 1200,
					"distance": 10700
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "11:29",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Crăciuneşti h.",
					"leavesAt": "11:36",
					"arrivesAt": "11:42",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Tisa h.",
					"leavesAt": "11:43",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Tisa h.",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "11:47",
					"arrivesAt": "11:54",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Sighetu Marmaţiei",
					"leavesAt": "11:55",
					"arrivesAt": "12:00",
					"waitsAtSource": 60,
					"distance": 1900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5601",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "04:35",
					"arrivesAt": "04:49",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "04:50",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "04:58",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "05:13",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "05:23",
					"arrivesAt": "05:29",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "05:30",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "05:35",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "05:45",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:22",
					"waitsAtSource": 1080,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "06:23",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "06:34",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "06:40",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "06:59",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "07:06",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "07:13",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "07:20",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "07:28",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3633",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "18:28",
					"arrivesAt": "18:35",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Suceag h.",
					"leavesAt": "18:36",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Suceag h.",
					"to": "Rădaia h.",
					"leavesAt": "18:41",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Rădaia h.",
					"to": "Mera Hm.",
					"leavesAt": "18:44",
					"arrivesAt": "18:47",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Mera Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "18:48",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Nădăşel h.",
					"to": "Gârbău Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "18:59",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gârbău Hm.",
					"to": "Macău h.",
					"leavesAt": "19:00",
					"arrivesAt": "19:05",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Macău h.",
					"to": "Dorolţu h.",
					"leavesAt": "19:06",
					"arrivesAt": "19:08",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Dorolţu h.",
					"to": "Aghireş",
					"leavesAt": "19:09",
					"arrivesAt": "19:12",
					"waitsAtSource": 30,
					"distance": 1900
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9368",
			"segments": [
				{
					"from": "Zimnicea",
					"to": "Ulmuleţ h.",
					"leavesAt": "16:38",
					"arrivesAt": "16:49",
					"waitsAtSource": 0,
					"distance": 9800
				},
				{
					"from": "Ulmuleţ h.",
					"to": "Şoimu h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Şoimu h.",
					"to": "Păuleasa h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:05",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Păuleasa h.",
					"to": "Smârdioasa h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Smârdioasa h.",
					"to": "Brânceni h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Brânceni h.",
					"to": "Ţigăneşti h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:21",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Ţigăneşti h.",
					"to": "Alexandria",
					"leavesAt": "17:22",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 9500
				},
				{
					"from": "Alexandria",
					"to": "Alexandria Nord h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Buzescu h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:49",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Buzescu h.",
					"to": "Plosca Hm.",
					"leavesAt": "17:50",
					"arrivesAt": "18:01",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Plosca Hm.",
					"to": "Peret hc.",
					"leavesAt": "18:02",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Peret hc.",
					"to": "Roşiori Hm.",
					"leavesAt": "18:09",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "18:23",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5007",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "17:12",
					"arrivesAt": "17:21",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "17:22",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "17:29",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "17:33",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "17:41",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "17:46",
					"arrivesAt": "17:50",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "17:51",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "17:56",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "18:06",
					"arrivesAt": "18:21",
					"waitsAtSource": 240,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "18:23",
					"arrivesAt": "18:29",
					"waitsAtSource": 120,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "18:30",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Muru hc.",
					"leavesAt": "18:40",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "18:45",
					"arrivesAt": "18:48",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "18:49",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "18:54",
					"arrivesAt": "18:59",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "19:00",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "19:08",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "19:19",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "19:27",
					"arrivesAt": "19:32",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "19:33",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "19:39",
					"arrivesAt": "19:51",
					"waitsAtSource": 30,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9343",
			"segments": [
				{
					"from": "Videle",
					"to": "Răduleşti Hm.",
					"leavesAt": "09:57",
					"arrivesAt": "10:07",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "10:08",
					"arrivesAt": "10:16",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Târnavele Hm.",
					"to": "Vlaşca Hm.",
					"leavesAt": "10:17",
					"arrivesAt": "10:25",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Răsuceni h.",
					"leavesAt": "10:26",
					"arrivesAt": "10:32",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Răsuceni h.",
					"to": "Toporu",
					"leavesAt": "10:33",
					"arrivesAt": "10:37",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Toporu",
					"to": "Chiriacu Hm.",
					"leavesAt": "10:38",
					"arrivesAt": "10:49",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Stăneşti Hm.",
					"leavesAt": "10:50",
					"arrivesAt": "10:57",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Onceşti h.",
					"leavesAt": "10:58",
					"arrivesAt": "11:02",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Onceşti h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "11:03",
					"arrivesAt": "11:09",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Cetatea h.",
					"leavesAt": "11:10",
					"arrivesAt": "11:12",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cetatea h.",
					"to": "Giurgiu Nord",
					"leavesAt": "11:13",
					"arrivesAt": "11:19",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Giurgiu Nord",
					"to": "Giurgiu",
					"leavesAt": "11:20",
					"arrivesAt": "11:25",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7375",
			"segments": [
				{
					"from": "Făurei",
					"to": "Găiseanca h.",
					"leavesAt": "12:30",
					"arrivesAt": "12:34",
					"waitsAtSource": 0,
					"distance": 3900
				},
				{
					"from": "Găiseanca h.",
					"to": "Deduleşti Hm.",
					"leavesAt": "12:35",
					"arrivesAt": "12:42",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Ianca hc.",
					"leavesAt": "12:43",
					"arrivesAt": "12:49",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ianca hc.",
					"to": "Plopu",
					"leavesAt": "12:50",
					"arrivesAt": "12:54",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Plopu",
					"to": "Urleasca Hm.",
					"leavesAt": "12:55",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Urleasca Hm.",
					"to": "Traian Sat Hm.",
					"leavesAt": "13:03",
					"arrivesAt": "13:11",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Lacu Sărat",
					"leavesAt": "13:12",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Lacu Sărat",
					"to": "Brăila",
					"leavesAt": "13:23",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "13:35",
					"arrivesAt": "13:42",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "13:43",
					"arrivesAt": "13:48",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Zagna Vădeni h.",
					"leavesAt": "13:49",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Barboşi",
					"leavesAt": "13:54",
					"arrivesAt": "14:01",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "14:02",
					"arrivesAt": "14:09",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "14:10",
					"arrivesAt": "14:22",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2569",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(203)",
					"leavesAt": "19:36",
					"arrivesAt": "19:40",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "19:41",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "19:53",
					"arrivesAt": "19:57",
					"waitsAtSource": 120,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Mândra h.",
					"leavesAt": "19:59",
					"arrivesAt": "20:06",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Mândra h.",
					"to": "Loamneş Hm.",
					"leavesAt": "20:07",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Loamneş Hm.",
					"to": "Hăşag h.",
					"leavesAt": "20:20",
					"arrivesAt": "20:26",
					"waitsAtSource": 360,
					"distance": 4100
				},
				{
					"from": "Hăşag h.",
					"to": "Veşeud h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:32",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Veşeud h.",
					"to": "Şeica Mare h.",
					"leavesAt": "20:33",
					"arrivesAt": "20:38",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Şeica Mare h.",
					"to": "Şeica Mare",
					"leavesAt": "20:39",
					"arrivesAt": "20:42",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Şeica Mare",
					"to": "Agârbiciu h.",
					"leavesAt": "20:43",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Agârbiciu h.",
					"to": "Axente Sever h.",
					"leavesAt": "20:50",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Axente Sever h.",
					"to": "Copşa Mică",
					"leavesAt": "20:56",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "21:02",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "21:10",
					"arrivesAt": "21:17",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8371",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "06:15",
					"arrivesAt": "06:26",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "06:35",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "06:46",
					"arrivesAt": "06:53",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "06:55",
					"arrivesAt": "07:04",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "07:05",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "07:21",
					"arrivesAt": "07:25",
					"waitsAtSource": 480,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Pescăruş h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:33",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Pescăruş h.",
					"to": "Neptun hc.",
					"leavesAt": "07:34",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "07:43",
					"arrivesAt": "07:48",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "07:49",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180502",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4362",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "06:49",
					"arrivesAt": "06:56",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "06:57",
					"arrivesAt": "07:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:08",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "07:09",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Zalău Nord",
					"to": "Guruslău h.",
					"leavesAt": "07:31",
					"arrivesAt": "07:40",
					"waitsAtSource": 360,
					"distance": 6700
				},
				{
					"from": "Guruslău h.",
					"to": "Borla Hm.",
					"leavesAt": "07:41",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Borla Hm.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:52",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "07:53",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Sărmăşag",
					"leavesAt": "07:59",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sărmăşag",
					"to": "Sărmăşag h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sărmăşag h.",
					"to": "Derşida h.",
					"leavesAt": "08:13",
					"arrivesAt": "08:15",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Derşida h.",
					"to": "Giorocuţa h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Giorocuţa h.",
					"to": "Supur h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:25",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Supur h.",
					"to": "Supur Haltă hc.",
					"leavesAt": "08:26",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Supur Haltă hc.",
					"to": "Acâş Hm.",
					"leavesAt": "08:29",
					"arrivesAt": "08:36",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Acâş Hm.",
					"to": "Săcăşeni h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:08",
					"waitsAtSource": 1260,
					"distance": 10000
				},
				{
					"from": "Săcăşeni h.",
					"to": "Tăşnad",
					"leavesAt": "09:09",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Tăşnad",
					"to": "Santău h.",
					"leavesAt": "09:18",
					"arrivesAt": "09:24",
					"waitsAtSource": 120,
					"distance": 5500
				},
				{
					"from": "Santău h.",
					"to": "Hotoan h.",
					"leavesAt": "09:25",
					"arrivesAt": "09:30",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Hotoan h.",
					"to": "Tiream h.",
					"leavesAt": "09:31",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Tiream h.",
					"to": "Carei",
					"leavesAt": "09:38",
					"arrivesAt": "09:53",
					"waitsAtSource": 30,
					"distance": 11700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9578",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "19:39",
					"arrivesAt": "19:45",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Remetea Mare",
					"leavesAt": "19:46",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Remetea Mare",
					"to": "Izvin h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:13",
					"waitsAtSource": 300,
					"distance": 7700
				},
				{
					"from": "Izvin h.",
					"to": "Recaş",
					"leavesAt": "20:14",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Recaş",
					"to": "Şuştra h.",
					"leavesAt": "20:18",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Şuştra h.",
					"to": "Topolovăţ",
					"leavesAt": "20:25",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Topolovăţ",
					"to": "Chizătău Hm.",
					"leavesAt": "20:29",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Chizătău Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "20:36",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Belinţ Hm.",
					"to": "Jabăr Hm.",
					"leavesAt": "20:41",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Lugoj",
					"leavesAt": "20:47",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Lugoj",
					"to": "Găvojdia",
					"leavesAt": "20:54",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Găvojdia",
					"to": "Jena Hm.",
					"leavesAt": "21:11",
					"arrivesAt": "21:21",
					"waitsAtSource": 420,
					"distance": 5800
				},
				{
					"from": "Jena Hm.",
					"to": "Sacu h.",
					"leavesAt": "21:22",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sacu h.",
					"to": "Căvăran",
					"leavesAt": "21:25",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Căvăran",
					"to": "Zăgujeni Hm.",
					"leavesAt": "21:36",
					"arrivesAt": "21:47",
					"waitsAtSource": 480,
					"distance": 7900
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Tibiscu h.",
					"leavesAt": "21:48",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tibiscu h.",
					"to": "Caransebeş",
					"leavesAt": "21:52",
					"arrivesAt": "21:56",
					"waitsAtSource": 30,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8121",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Carpaţi h.(700)",
					"leavesAt": "10:05",
					"arrivesAt": "10:11",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Pajura Hm. (700)",
					"leavesAt": "10:12",
					"arrivesAt": "10:16",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Chitila",
					"leavesAt": "10:17",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chitila",
					"to": "Mogoşoaia",
					"leavesAt": "10:24",
					"arrivesAt": "10:41",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Mogoşoaia",
					"to": "P.O. Aeroport h.",
					"leavesAt": "10:42",
					"arrivesAt": "10:49",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Baloteşti Hm.",
					"leavesAt": "10:50",
					"arrivesAt": "10:53",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Baloteşti Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "10:54",
					"arrivesAt": "11:00",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "11:01",
					"arrivesAt": "11:07",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Greci h.",
					"leavesAt": "11:08",
					"arrivesAt": "11:14",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Greci h.",
					"to": "Fierbinţi",
					"leavesAt": "11:15",
					"arrivesAt": "11:22",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Fierbinţi",
					"to": "Dridu Hm.",
					"leavesAt": "11:29",
					"arrivesAt": "11:36",
					"waitsAtSource": 420,
					"distance": 6600
				},
				{
					"from": "Dridu Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "11:37",
					"arrivesAt": "11:42",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moldoveni h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "11:43",
					"arrivesAt": "11:48",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "11:49",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "11:53",
					"arrivesAt": "12:00",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Urziceni",
					"to": "Alexeni h.",
					"leavesAt": "12:02",
					"arrivesAt": "12:08",
					"waitsAtSource": 120,
					"distance": 5800
				},
				{
					"from": "Alexeni h.",
					"to": "Broşteni Hm.",
					"leavesAt": "12:09",
					"arrivesAt": "12:15",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Broşteni Hm.",
					"to": "Malu h.",
					"leavesAt": "12:16",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Malu h.",
					"to": "Km. 74+600 h.",
					"leavesAt": "12:22",
					"arrivesAt": "12:26",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Km. 74+600 h.",
					"to": "Sărăţuica Hm.",
					"leavesAt": "12:27",
					"arrivesAt": "12:31",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Sărăţuica Hm.",
					"to": "Sărăţeni Ialomiţa h.",
					"leavesAt": "12:32",
					"arrivesAt": "12:35",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sărăţeni Ialomiţa h.",
					"to": "Munteni Buzău h.",
					"leavesAt": "12:36",
					"arrivesAt": "12:40",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Munteni Buzău h.",
					"to": "Căzăneşti",
					"leavesAt": "12:41",
					"arrivesAt": "12:47",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Căzăneşti",
					"to": "Ciochina hc.",
					"leavesAt": "12:48",
					"arrivesAt": "12:53",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ciochina hc.",
					"to": "Andrăşeşti Hm.",
					"leavesAt": "12:54",
					"arrivesAt": "13:03",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Andrăşeşti Hm.",
					"to": "Fundata h.",
					"leavesAt": "13:04",
					"arrivesAt": "13:08",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Fundata h.",
					"to": "Perieţi h.",
					"leavesAt": "13:09",
					"arrivesAt": "13:14",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Perieţi h.",
					"to": "Slobozia Veche",
					"leavesAt": "13:15",
					"arrivesAt": "13:27",
					"waitsAtSource": 30,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6503",
			"segments": [
				{
					"from": "Ungheni Prut Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "07:05",
					"arrivesAt": "07:13",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Holboca Hm.",
					"leavesAt": "07:14",
					"arrivesAt": "07:20",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Holboca Hm.",
					"to": "Remiza T Socola h.",
					"leavesAt": "07:21",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Remiza T Socola h.",
					"to": "Socola",
					"leavesAt": "07:28",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Socola",
					"to": "Nicolina",
					"leavesAt": "07:35",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "07:42",
					"arrivesAt": "07:49",
					"waitsAtSource": 120,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4544",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "10:55",
					"arrivesAt": "11:03",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "11:04",
					"arrivesAt": "11:16",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "11:17",
					"arrivesAt": "11:21",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Periş Mureş h.",
					"leavesAt": "11:22",
					"arrivesAt": "11:27",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Periş Mureş h.",
					"to": "Petelea h.",
					"leavesAt": "11:28",
					"arrivesAt": "11:33",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Petelea h.",
					"to": "Reghin",
					"leavesAt": "11:34",
					"arrivesAt": "11:44",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Reghin",
					"to": "Ideciu de Jos h.",
					"leavesAt": "11:46",
					"arrivesAt": "11:52",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "11:53",
					"arrivesAt": "11:58",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Halta Aluniş h.",
					"leavesAt": "11:59",
					"arrivesAt": "12:03",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "12:04",
					"arrivesAt": "12:10",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Ruşii Munţi h.",
					"leavesAt": "12:16",
					"arrivesAt": "12:20",
					"waitsAtSource": 360,
					"distance": 1400
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Deda",
					"leavesAt": "12:21",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2142",
			"segments": [
				{
					"from": "Hunedoara",
					"to": "Pestişu Mare h.",
					"leavesAt": "05:43",
					"arrivesAt": "05:53",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pestişu Mare h.",
					"to": "Bârcea Mică",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bârcea Mică",
					"to": "Bârcea Mare h.",
					"leavesAt": "05:59",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bârcea Mare h.",
					"to": "Simeria",
					"leavesAt": "06:02",
					"arrivesAt": "06:10",
					"waitsAtSource": 30,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1593",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "17:25",
					"arrivesAt": "18:15",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "18:16",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "19:03",
					"arrivesAt": "19:34",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "19:35",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "19:54",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 53600
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9448",
			"segments": [
				{
					"from": "Pietroşiţa Hm.",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "17:54",
					"arrivesAt": "18:00",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Fieni",
					"leavesAt": "18:01",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Moţăieni h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Moţăieni h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:16",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Trainica h.",
					"leavesAt": "18:17",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Trainica h.",
					"to": "Scârlenţa h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:23",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Scârlenţa h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "18:24",
					"arrivesAt": "18:27",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Doiceşti h.",
					"leavesAt": "18:28",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Doiceşti h.",
					"to": "Doiceşti",
					"leavesAt": "18:31",
					"arrivesAt": "18:33",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Doiceşti",
					"to": "Săteni h.",
					"leavesAt": "18:34",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Săteni h.",
					"to": "Aninoasa Hm.",
					"leavesAt": "18:38",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Aninoasa Hm.",
					"to": "TEIŞ Hm.",
					"leavesAt": "18:41",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "18:45",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "18:48",
					"arrivesAt": "18:52",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1942",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "17:52",
					"arrivesAt": "18:09",
					"waitsAtSource": 0,
					"distance": 14600
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Mireşu Mare PM.",
					"leavesAt": "18:10",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "18:21",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Benesat Hm.",
					"leavesAt": "18:29",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Benesat Hm.",
					"to": "Jibou",
					"leavesAt": "18:39",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Jibou",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "19:09",
					"arrivesAt": "19:17",
					"waitsAtSource": 720,
					"distance": 6800
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Letca Hm.",
					"leavesAt": "19:23",
					"arrivesAt": "19:46",
					"waitsAtSource": 360,
					"distance": 16300
				},
				{
					"from": "Letca Hm.",
					"to": "Ileanda",
					"leavesAt": "19:47",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 13600
				},
				{
					"from": "Ileanda",
					"to": "Gâlgău",
					"leavesAt": "20:05",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Gâlgău",
					"to": "Câţcău h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Câţcău h.",
					"to": "Dej Călători",
					"leavesAt": "20:34",
					"arrivesAt": "20:48",
					"waitsAtSource": 30,
					"distance": 12700
				},
				{
					"from": "Dej Călători",
					"to": "Beclean pe Someş",
					"leavesAt": "21:02",
					"arrivesAt": "21:35",
					"waitsAtSource": 840,
					"distance": 24600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Sărăţel Hm.",
					"leavesAt": "21:37",
					"arrivesAt": "22:03",
					"waitsAtSource": 120,
					"distance": 24900
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Deda",
					"leavesAt": "22:04",
					"arrivesAt": "22:58",
					"waitsAtSource": 60,
					"distance": 46800
				},
				{
					"from": "Deda",
					"to": "Topliţa",
					"leavesAt": "23:02",
					"arrivesAt": "23:59",
					"waitsAtSource": 240,
					"distance": 43900
				},
				{
					"from": "Topliţa",
					"to": "Gheorgheni",
					"leavesAt": "00:06",
					"arrivesAt": "00:39",
					"waitsAtSource": 420,
					"distance": 34000
				},
				{
					"from": "Gheorgheni",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "00:41",
					"arrivesAt": "00:57",
					"waitsAtSource": 120,
					"distance": 19100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Izvoru Oltului",
					"leavesAt": "00:58",
					"arrivesAt": "01:10",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Izvoru Oltului",
					"to": "Siculeni",
					"leavesAt": "01:12",
					"arrivesAt": "01:32",
					"waitsAtSource": 120,
					"distance": 17100
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "01:37",
					"arrivesAt": "01:46",
					"waitsAtSource": 300,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "01:48",
					"arrivesAt": "02:11",
					"waitsAtSource": 120,
					"distance": 28500
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "02:13",
					"arrivesAt": "02:45",
					"waitsAtSource": 120,
					"distance": 34400
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Braşov",
					"leavesAt": "02:47",
					"arrivesAt": "03:17",
					"waitsAtSource": 120,
					"distance": 32100
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "03:32",
					"arrivesAt": "04:09",
					"waitsAtSource": 900,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Sinaia",
					"leavesAt": "04:11",
					"arrivesAt": "04:32",
					"waitsAtSource": 120,
					"distance": 19000
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "04:34",
					"arrivesAt": "04:58",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "05:00",
					"arrivesAt": "05:11",
					"waitsAtSource": 120,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Ploieşti Vest",
					"leavesAt": "05:12",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 18600
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "05:29",
					"arrivesAt": "06:14",
					"waitsAtSource": 120,
					"distance": 58900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ciulniţa",
					"leavesAt": "06:40",
					"arrivesAt": "07:47",
					"waitsAtSource": 1560,
					"distance": 108900
				},
				{
					"from": "Ciulniţa",
					"to": "Perişoru Hm.",
					"leavesAt": "07:48",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Feteşti",
					"leavesAt": "08:02",
					"arrivesAt": "08:19",
					"waitsAtSource": 360,
					"distance": 25200
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "08:20",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "08:39",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "08:57",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 36000
				},
				{
					"from": "Constanţa",
					"to": "Eforie Nord",
					"leavesAt": "10:05",
					"arrivesAt": "10:28",
					"waitsAtSource": 2040,
					"distance": 14000
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "10:30",
					"arrivesAt": "10:37",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Costineşti",
					"leavesAt": "10:39",
					"arrivesAt": "10:55",
					"waitsAtSource": 120,
					"distance": 8600
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "10:57",
					"arrivesAt": "11:01",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "11:03",
					"arrivesAt": "11:16",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "11:18",
					"arrivesAt": "11:28",
					"waitsAtSource": 120,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180426",
					"to": "20180430",
					"daysOfWeek": 383
				},
				{
					"from": "20180524",
					"to": "20180528",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1588",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Bucureşti Nord",
					"leavesAt": "19:00",
					"arrivesAt": "21:02",
					"waitsAtSource": 0,
					"distance": 225000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8151",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Alexeni h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:11",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Alexeni h.",
					"to": "Broşteni Hm.",
					"leavesAt": "06:12",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Broşteni Hm.",
					"to": "Malu h.",
					"leavesAt": "06:19",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Malu h.",
					"to": "Km. 74+600 h.",
					"leavesAt": "06:25",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Km. 74+600 h.",
					"to": "Sărăţuica Hm.",
					"leavesAt": "06:29",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Sărăţuica Hm.",
					"to": "Sărăţeni Ialomiţa h.",
					"leavesAt": "06:34",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sărăţeni Ialomiţa h.",
					"to": "Munteni Buzău h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:41",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Munteni Buzău h.",
					"to": "Căzăneşti",
					"leavesAt": "06:42",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Căzăneşti",
					"to": "Ciochina hc.",
					"leavesAt": "06:48",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ciochina hc.",
					"to": "Andrăşeşti Hm.",
					"leavesAt": "06:55",
					"arrivesAt": "07:04",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Andrăşeşti Hm.",
					"to": "Fundata h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Fundata h.",
					"to": "Perieţi h.",
					"leavesAt": "07:09",
					"arrivesAt": "07:13",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Perieţi h.",
					"to": "Slobozia Veche",
					"leavesAt": "07:14",
					"arrivesAt": "07:24",
					"waitsAtSource": 30,
					"distance": 8600
				},
				{
					"from": "Slobozia Veche",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:48",
					"waitsAtSource": 840,
					"distance": 4200
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Brâncoveni h.",
					"leavesAt": "07:49",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Brâncoveni h.",
					"to": "Ciulniţa",
					"leavesAt": "07:59",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9345",
			"segments": [
				{
					"from": "Videle",
					"to": "Răduleşti Hm.",
					"leavesAt": "13:50",
					"arrivesAt": "14:00",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "14:01",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Târnavele Hm.",
					"to": "Vlaşca Hm.",
					"leavesAt": "14:11",
					"arrivesAt": "14:19",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Răsuceni h.",
					"leavesAt": "14:20",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Răsuceni h.",
					"to": "Toporu",
					"leavesAt": "14:27",
					"arrivesAt": "14:31",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Toporu",
					"to": "Chiriacu Hm.",
					"leavesAt": "14:32",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Stăneşti Hm.",
					"leavesAt": "14:44",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Onceşti h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Onceşti h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:03",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Cetatea h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cetatea h.",
					"to": "Giurgiu Nord",
					"leavesAt": "15:07",
					"arrivesAt": "15:13",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Giurgiu Nord",
					"to": "Giurgiu",
					"leavesAt": "15:14",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8804",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "08:50",
					"arrivesAt": "08:57",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "09:05",
					"arrivesAt": "09:10",
					"waitsAtSource": 480,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "09:11",
					"arrivesAt": "09:24",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "09:25",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "09:30",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "09:39",
					"arrivesAt": "09:48",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "09:49",
					"arrivesAt": "09:57",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "09:58",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "10:08",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3074",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Est",
					"leavesAt": "07:30",
					"arrivesAt": "07:36",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Oradea Est",
					"to": "Oradea Est Triaj h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 700
				},
				{
					"from": "Oradea Est Triaj h.",
					"to": "Oşorhei Hm.",
					"leavesAt": "07:39",
					"arrivesAt": "07:45",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Săcădat h.",
					"leavesAt": "07:49",
					"arrivesAt": "07:55",
					"waitsAtSource": 240,
					"distance": 6000
				},
				{
					"from": "Săcădat h.",
					"to": "Săbolciu h.",
					"leavesAt": "07:56",
					"arrivesAt": "07:58",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săbolciu h.",
					"to": "Tileagd",
					"leavesAt": "07:59",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tileagd",
					"to": "Telechiu Hm.",
					"leavesAt": "08:09",
					"arrivesAt": "08:14",
					"waitsAtSource": 240,
					"distance": 4400
				},
				{
					"from": "Telechiu Hm.",
					"to": "Ţeţchea hc.",
					"leavesAt": "08:15",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ţeţchea hc.",
					"to": "Aleşd",
					"leavesAt": "08:19",
					"arrivesAt": "08:22",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Aleşd",
					"to": "Aleşd h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aleşd h.",
					"to": "Butan h.",
					"leavesAt": "08:27",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Butan h.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "08:32",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Vadu Crişului h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:45",
					"waitsAtSource": 240,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului h.",
					"to": "Peştera h.",
					"leavesAt": "08:46",
					"arrivesAt": "08:49",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Peştera h.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "08:50",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bălnaca h.",
					"leavesAt": "08:55",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bălnaca h.",
					"to": "Bratca",
					"leavesAt": "09:00",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Bratca",
					"to": "Stâna de Vale h.",
					"leavesAt": "09:08",
					"arrivesAt": "09:14",
					"waitsAtSource": 300,
					"distance": 4100
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bulz Hm.",
					"leavesAt": "09:15",
					"arrivesAt": "09:18",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bulz Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "09:19",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Lacu Crişului h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Negreni h.",
					"leavesAt": "09:31",
					"arrivesAt": "09:35",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Ciucea Hm.",
					"leavesAt": "09:36",
					"arrivesAt": "09:41",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ciucea Hm.",
					"to": "Valea Drăganului h.",
					"leavesAt": "09:42",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Valea Drăganului h.",
					"to": "Poieni",
					"leavesAt": "09:48",
					"arrivesAt": "09:52",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Poieni",
					"to": "Bologa h.",
					"leavesAt": "09:53",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Bologa h.",
					"to": "Brăişoru Hm.",
					"leavesAt": "09:57",
					"arrivesAt": "10:01",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Huedin",
					"leavesAt": "10:02",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Huedin",
					"to": "Jebuc h.",
					"leavesAt": "10:11",
					"arrivesAt": "10:17",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Jebuc h.",
					"to": "Stana Hm.",
					"leavesAt": "10:18",
					"arrivesAt": "10:25",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Stana Hm.",
					"to": "Gălăşeni h.",
					"leavesAt": "10:26",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Gălăşeni h.",
					"to": "Aghireş h.",
					"leavesAt": "10:30",
					"arrivesAt": "10:37",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "10:38",
					"arrivesAt": "10:42",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Dorolţu h.",
					"leavesAt": "10:43",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Dorolţu h.",
					"to": "Macău h.",
					"leavesAt": "10:46",
					"arrivesAt": "10:48",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Macău h.",
					"to": "Gârbău Hm.",
					"leavesAt": "10:49",
					"arrivesAt": "10:54",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Gârbău Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "10:55",
					"arrivesAt": "11:01",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Nădăşel h.",
					"to": "Mera Hm.",
					"leavesAt": "11:02",
					"arrivesAt": "11:05",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mera Hm.",
					"to": "Rădaia h.",
					"leavesAt": "11:06",
					"arrivesAt": "11:08",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rădaia h.",
					"to": "Suceag h.",
					"leavesAt": "11:09",
					"arrivesAt": "11:11",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Suceag h.",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "11:12",
					"arrivesAt": "11:17",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "11:18",
					"arrivesAt": "11:25",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2083",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "05:40",
					"arrivesAt": "05:43",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "05:44",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "05:48",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "05:52",
					"arrivesAt": "05:55",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "05:56",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "06:00",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "06:09",
					"arrivesAt": "06:14",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "06:18",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:32",
					"waitsAtSource": 120,
					"distance": 5700
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "06:33",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Floreşti hc.",
					"to": "Gilort Hm.",
					"leavesAt": "06:37",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Gilort Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "06:44",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turburea Hm.",
					"to": "Bibeşti Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "07:02",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Musculeşti",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Jupâneşti Hm.",
					"leavesAt": "07:15",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "07:22",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cărbuneşti",
					"to": "Pojogeni Hm.",
					"leavesAt": "07:31",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "07:39",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Budieni h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Budieni h.",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "07:51",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "07:56",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Târgu Jiu",
					"to": "Ramificaţia C.A.M. h.",
					"leavesAt": "08:15",
					"arrivesAt": "08:17",
					"waitsAtSource": 600,
					"distance": 800
				},
				{
					"from": "Ramificaţia C.A.M. h.",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "08:18",
					"arrivesAt": "08:22",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Ezureni h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ezureni h.",
					"to": "Parângu Hm.",
					"leavesAt": "08:28",
					"arrivesAt": "08:32",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Parângu Hm.",
					"to": "Bumbeşti Hm.",
					"leavesAt": "08:33",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bumbeşti Hm.",
					"to": "Valea Sadului Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Meri",
					"leavesAt": "08:46",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Meri",
					"to": "Lainici Hm.",
					"leavesAt": "08:54",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Lainici Hm.",
					"to": "Km. 105+600 h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Km. 105+600 h.",
					"to": "Pietrele Albe Hm.",
					"leavesAt": "09:11",
					"arrivesAt": "09:15",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pietrele Albe Hm.",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "09:16",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Livezeni",
					"leavesAt": "09:27",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Lunca Jiului hc.",
					"leavesAt": "09:38",
					"arrivesAt": "09:41",
					"waitsAtSource": 240,
					"distance": 3000
				},
				{
					"from": "Lunca Jiului hc.",
					"to": "Petroşani",
					"leavesAt": "09:42",
					"arrivesAt": "09:48",
					"waitsAtSource": 30,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 863
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7364",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "15:30",
					"arrivesAt": "15:44",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "15:45",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Zagna Vădeni h.",
					"leavesAt": "15:53",
					"arrivesAt": "15:56",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Vădeni Hm.",
					"leavesAt": "15:57",
					"arrivesAt": "16:00",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vădeni Hm.",
					"to": "Baldovineşti Hm.",
					"leavesAt": "16:01",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Brăila",
					"leavesAt": "16:06",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Brăila",
					"to": "Lacu Sărat",
					"leavesAt": "16:15",
					"arrivesAt": "16:22",
					"waitsAtSource": 120,
					"distance": 9700
				},
				{
					"from": "Lacu Sărat",
					"to": "Traian Sat Hm.",
					"leavesAt": "16:23",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Urleasca Hm.",
					"leavesAt": "16:33",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Urleasca Hm.",
					"to": "Plopu",
					"leavesAt": "16:41",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Plopu",
					"to": "Ianca hc.",
					"leavesAt": "16:50",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ianca hc.",
					"to": "Deduleşti Hm.",
					"leavesAt": "16:54",
					"arrivesAt": "17:02",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Găiseanca h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Găiseanca h.",
					"to": "Făurei",
					"leavesAt": "17:09",
					"arrivesAt": "17:14",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Făurei",
					"to": "CTF Făurei h.",
					"leavesAt": "17:28",
					"arrivesAt": "17:33",
					"waitsAtSource": 840,
					"distance": 4100
				},
				{
					"from": "CTF Făurei h.",
					"to": "Vizireni h.",
					"leavesAt": "17:34",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vizireni h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "17:39",
					"arrivesAt": "17:44",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "17:54",
					"arrivesAt": "18:02",
					"waitsAtSource": 600,
					"distance": 6400
				},
				{
					"from": "Movila Oii h.",
					"to": "Cilibia Hm.",
					"leavesAt": "18:03",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Cilibia Hm.",
					"to": "Bentu h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:18",
					"waitsAtSource": 240,
					"distance": 4000
				},
				{
					"from": "Bentu h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Tăbărăşti h.",
					"leavesAt": "18:24",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Buzău Sud",
					"leavesAt": "18:27",
					"arrivesAt": "18:32",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Buzău Sud",
					"to": "Buzău",
					"leavesAt": "18:33",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "37656",
			"segments": [
				{
					"from": "Kotegyan",
					"to": "Salonta",
					"leavesAt": "17:45",
					"arrivesAt": "18:05",
					"waitsAtSource": 0,
					"distance": 13200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7575",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "18:40",
					"arrivesAt": "18:47",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Cosmeşti Hm.",
					"leavesAt": "18:48",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "Tecuci",
					"leavesAt": "18:54",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Tecuci",
					"to": "Malul Alb h.",
					"leavesAt": "19:17",
					"arrivesAt": "19:22",
					"waitsAtSource": 660,
					"distance": 5600
				},
				{
					"from": "Malul Alb h.",
					"to": "Barcea",
					"leavesAt": "19:23",
					"arrivesAt": "19:27",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Barcea",
					"to": "Umbrăreşti h.",
					"leavesAt": "19:28",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "19:34",
					"arrivesAt": "19:39",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Iveşti Hm.",
					"to": "Buceşti h.",
					"leavesAt": "19:40",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Buceşti h.",
					"to": "Lieşti",
					"leavesAt": "19:44",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lieşti",
					"to": "Şerbăneşti h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "19:53",
					"arrivesAt": "19:58",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "19:59",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Vameş h.",
					"leavesAt": "20:04",
					"arrivesAt": "20:10",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Vameş h.",
					"to": "Piscu h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:15",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Piscu h.",
					"to": "Independenţa Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Independenţa Hm.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Braniştea h.",
					"leavesAt": "20:28",
					"arrivesAt": "20:31",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Braniştea h.",
					"to": "Şendreni Hm.",
					"leavesAt": "20:32",
					"arrivesAt": "20:41",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Şendreni Hm.",
					"to": "Barboşi",
					"leavesAt": "20:42",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "20:53",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "21:01",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5434",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "10:29",
					"arrivesAt": "10:36",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "10:37",
					"arrivesAt": "10:42",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "10:43",
					"arrivesAt": "10:47",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "10:48",
					"arrivesAt": "10:53",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "10:54",
					"arrivesAt": "10:58",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "10:59",
					"arrivesAt": "11:05",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "11:06",
					"arrivesAt": "11:15",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "11:17",
					"arrivesAt": "11:24",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "11:25",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "11:30",
					"arrivesAt": "11:38",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "11:39",
					"arrivesAt": "11:44",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "11:45",
					"arrivesAt": "11:50",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "11:51",
					"arrivesAt": "12:03",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5022",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Brazi",
					"leavesAt": "04:40",
					"arrivesAt": "04:55",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "04:56",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "05:02",
					"arrivesAt": "05:07",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "05:13",
					"arrivesAt": "05:18",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "05:19",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "05:28",
					"arrivesAt": "05:32",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "05:33",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "05:43",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "05:46",
					"arrivesAt": "05:49",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "05:50",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "05:54",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "05:57",
					"arrivesAt": "06:02",
					"waitsAtSource": 30,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5740",
			"segments": [
				{
					"from": "Cacica Hm.",
					"to": "Pârteşti h.",
					"leavesAt": "14:00",
					"arrivesAt": "14:07",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Pârteşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "14:08",
					"arrivesAt": "14:14",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Soloneţ h.",
					"to": "Todireşti h.",
					"leavesAt": "14:15",
					"arrivesAt": "14:22",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Todireşti h.",
					"to": "Părhăuţi h.",
					"leavesAt": "14:23",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Părhăuţi h.",
					"to": "Dărmăneşti",
					"leavesAt": "14:32",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "14:41",
					"arrivesAt": "14:48",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "14:49",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4104",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "17:08",
					"arrivesAt": "17:15",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Reteag Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Reteag Hm.",
					"to": "Reteag h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag h.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "17:32",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "17:36",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "17:41",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Beclean pe Someş",
					"to": "Şintereag Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şintereag Hm.",
					"to": "Caila hc.",
					"leavesAt": "18:00",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Caila hc.",
					"to": "Sfântu h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sfântu h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "18:09",
					"arrivesAt": "18:15",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "18:16",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Sărata h.",
					"leavesAt": "18:27",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Viişoara h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:36",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Viişoara h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "18:37",
					"arrivesAt": "18:41",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "18:42",
					"arrivesAt": "18:45",
					"waitsAtSource": 30,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180107",
					"daysOfWeek": 511
				},
				{
					"from": "20180113",
					"to": "20180114",
					"daysOfWeek": 511
				},
				{
					"from": "20180120",
					"to": "20180121",
					"daysOfWeek": 511
				},
				{
					"from": "20180124",
					"to": "20180124",
					"daysOfWeek": 511
				},
				{
					"from": "20180127",
					"to": "20180128",
					"daysOfWeek": 511
				},
				{
					"from": "20180203",
					"to": "20180204",
					"daysOfWeek": 511
				},
				{
					"from": "20180210",
					"to": "20180211",
					"daysOfWeek": 511
				},
				{
					"from": "20180217",
					"to": "20180218",
					"daysOfWeek": 511
				},
				{
					"from": "20180224",
					"to": "20180225",
					"daysOfWeek": 511
				},
				{
					"from": "20180303",
					"to": "20180304",
					"daysOfWeek": 511
				},
				{
					"from": "20180310",
					"to": "20180311",
					"daysOfWeek": 511
				},
				{
					"from": "20180317",
					"to": "20180318",
					"daysOfWeek": 511
				},
				{
					"from": "20180324",
					"to": "20180325",
					"daysOfWeek": 511
				},
				{
					"from": "20180331",
					"to": "20180401",
					"daysOfWeek": 511
				},
				{
					"from": "20180407",
					"to": "20180409",
					"daysOfWeek": 511
				},
				{
					"from": "20180414",
					"to": "20180415",
					"daysOfWeek": 511
				},
				{
					"from": "20180421",
					"to": "20180422",
					"daysOfWeek": 511
				},
				{
					"from": "20180428",
					"to": "20180429",
					"daysOfWeek": 511
				},
				{
					"from": "20180501",
					"to": "20180501",
					"daysOfWeek": 511
				},
				{
					"from": "20180505",
					"to": "20180506",
					"daysOfWeek": 511
				},
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 511
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 511
				},
				{
					"from": "20180526",
					"to": "20180528",
					"daysOfWeek": 511
				},
				{
					"from": "20180601",
					"to": "20180603",
					"daysOfWeek": 511
				},
				{
					"from": "20180909",
					"to": "20180909",
					"daysOfWeek": 511
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 511
				},
				{
					"from": "20180922",
					"to": "20180923",
					"daysOfWeek": 511
				},
				{
					"from": "20180929",
					"to": "20180930",
					"daysOfWeek": 511
				},
				{
					"from": "20181006",
					"to": "20181007",
					"daysOfWeek": 511
				},
				{
					"from": "20181013",
					"to": "20181014",
					"daysOfWeek": 511
				},
				{
					"from": "20181020",
					"to": "20181021",
					"daysOfWeek": 511
				},
				{
					"from": "20181027",
					"to": "20181028",
					"daysOfWeek": 511
				},
				{
					"from": "20181103",
					"to": "20181104",
					"daysOfWeek": 511
				},
				{
					"from": "20181110",
					"to": "20181111",
					"daysOfWeek": 511
				},
				{
					"from": "20181117",
					"to": "20181118",
					"daysOfWeek": 511
				},
				{
					"from": "20181124",
					"to": "20181125",
					"daysOfWeek": 511
				},
				{
					"from": "20181130",
					"to": "20181202",
					"daysOfWeek": 511
				},
				{
					"from": "20181208",
					"to": "20181208",
					"daysOfWeek": 511
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 511
				},
				{
					"from": "20171216",
					"to": "20171217",
					"daysOfWeek": 511
				},
				{
					"from": "20171223",
					"to": "20171226",
					"daysOfWeek": 511
				},
				{
					"from": "20171230",
					"to": "20180102",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5449",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "13:29",
					"arrivesAt": "13:40",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "13:41",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "13:46",
					"arrivesAt": "13:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "13:52",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "14:02",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "14:07",
					"arrivesAt": "14:14",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "14:16",
					"arrivesAt": "14:23",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "14:24",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "14:31",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "14:36",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "14:42",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "14:47",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani Triaj",
					"leavesAt": "14:52",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Paşcani Triaj",
					"to": "Paşcani",
					"leavesAt": "14:58",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:15",
					"waitsAtSource": 300,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "15:16",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "15:33",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "15:46",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "15:53",
					"arrivesAt": "15:59",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "16:00",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "16:07",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "16:14",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "16:23",
					"arrivesAt": "16:29",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4454",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:17",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "09:18",
					"arrivesAt": "09:22",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "09:23",
					"arrivesAt": "09:29",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "09:30",
					"arrivesAt": "09:46",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "346",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "14:00",
					"arrivesAt": "14:36",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Sinaia",
					"leavesAt": "14:38",
					"arrivesAt": "15:22",
					"waitsAtSource": 120,
					"distance": 62100
				},
				{
					"from": "Sinaia",
					"to": "Predeal",
					"leavesAt": "15:24",
					"arrivesAt": "15:43",
					"waitsAtSource": 120,
					"distance": 19000
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "15:45",
					"arrivesAt": "16:23",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Făgăraş",
					"leavesAt": "16:35",
					"arrivesAt": "17:46",
					"waitsAtSource": 720,
					"distance": 65000
				},
				{
					"from": "Făgăraş",
					"to": "Sibiu",
					"leavesAt": "17:47",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 83900
				},
				{
					"from": "Sibiu",
					"to": "Sălişte Hm.",
					"leavesAt": "19:13",
					"arrivesAt": "19:52",
					"waitsAtSource": 300,
					"distance": 29700
				},
				{
					"from": "Sălişte Hm.",
					"to": "Vinţu de Jos",
					"leavesAt": "19:56",
					"arrivesAt": "21:02",
					"waitsAtSource": 240,
					"distance": 53100
				},
				{
					"from": "Vinţu de Jos",
					"to": "Şibot",
					"leavesAt": "21:03",
					"arrivesAt": "21:25",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Şibot",
					"to": "Simeria",
					"leavesAt": "21:26",
					"arrivesAt": "22:02",
					"waitsAtSource": 60,
					"distance": 28800
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "22:14",
					"arrivesAt": "22:24",
					"waitsAtSource": 720,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Arad",
					"leavesAt": "22:26",
					"arrivesAt": "01:14",
					"waitsAtSource": 120,
					"distance": 148200
				},
				{
					"from": "Arad",
					"to": "Curtici",
					"leavesAt": "01:22",
					"arrivesAt": "01:35",
					"waitsAtSource": 480,
					"distance": 17000
				},
				{
					"from": "Curtici",
					"to": "Lokoshaza",
					"leavesAt": "02:10",
					"arrivesAt": "02:20",
					"waitsAtSource": 2100,
					"distance": 11200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2031",
			"segments": [
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "06:18",
					"arrivesAt": "06:31",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "06:32",
					"arrivesAt": "06:41",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Mintia h.",
					"leavesAt": "06:42",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Veţel h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Veţel h.",
					"to": "Brănişca Hm.",
					"leavesAt": "06:48",
					"arrivesAt": "06:52",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "06:53",
					"arrivesAt": "06:59",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Ilia",
					"leavesAt": "07:00",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ilia",
					"to": "Gurasada Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Gurasada Hm.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "07:16",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Burjuc h.",
					"leavesAt": "07:24",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Burjuc h.",
					"to": "Zam",
					"leavesAt": "07:30",
					"arrivesAt": "07:42",
					"waitsAtSource": 30,
					"distance": 8500
				},
				{
					"from": "Zam",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Ilteu",
					"leavesAt": "07:48",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ilteu",
					"to": "Toc h.",
					"leavesAt": "07:56",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Toc h.",
					"to": "Săvârşin",
					"leavesAt": "08:00",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Săvârşin",
					"to": "Vărădia h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:19",
					"waitsAtSource": 300,
					"distance": 6000
				},
				{
					"from": "Vărădia h.",
					"to": "Vărădia Hm.",
					"leavesAt": "08:20",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vărădia Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "08:26",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "08:31",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Căpruţa h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Căpruţa h.",
					"to": "Bârzava",
					"leavesAt": "08:45",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bârzava",
					"to": "Nadăş h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Nadăş h.",
					"to": "Conop Hm.",
					"leavesAt": "08:58",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Conop Hm.",
					"to": "Corfeni h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Corfeni h.",
					"to": "Milova",
					"leavesAt": "09:11",
					"arrivesAt": "09:17",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Milova",
					"to": "Radna",
					"leavesAt": "09:18",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Radna",
					"to": "Păuliş Hm.",
					"leavesAt": "09:31",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Păuliş Hm.",
					"to": "Păuliş h.",
					"leavesAt": "09:41",
					"arrivesAt": "09:45",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş h.",
					"to": "Ghioroc",
					"leavesAt": "09:46",
					"arrivesAt": "09:53",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ghioroc",
					"to": "Glogovăţ",
					"leavesAt": "09:54",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Glogovăţ",
					"to": "Arad",
					"leavesAt": "10:07",
					"arrivesAt": "10:15",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1819",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Iernut",
					"leavesAt": "16:07",
					"arrivesAt": "16:34",
					"waitsAtSource": 0,
					"distance": 28600
				},
				{
					"from": "Iernut",
					"to": "Luduş",
					"leavesAt": "16:35",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Luduş",
					"to": "Războieni",
					"leavesAt": "16:50",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 19200
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "17:09",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Aiud Hm.",
					"leavesAt": "17:15",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "17:31",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Coşlariu",
					"leavesAt": "17:49",
					"arrivesAt": "17:57",
					"waitsAtSource": 240,
					"distance": 3500
				},
				{
					"from": "Coşlariu",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "17:58",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "18:23",
					"arrivesAt": "18:31",
					"waitsAtSource": 240,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "18:33",
					"arrivesAt": "18:44",
					"waitsAtSource": 120,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Blandiana Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "19:00",
					"waitsAtSource": 480,
					"distance": 5200
				},
				{
					"from": "Blandiana Hm.",
					"to": "Şibot",
					"leavesAt": "19:08",
					"arrivesAt": "19:23",
					"waitsAtSource": 480,
					"distance": 9800
				},
				{
					"from": "Şibot",
					"to": "Aurel Vlaicu",
					"leavesAt": "19:25",
					"arrivesAt": "19:34",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Orăştie",
					"leavesAt": "19:35",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Orăştie",
					"to": "Simeria",
					"leavesAt": "19:50",
					"arrivesAt": "20:12",
					"waitsAtSource": 360,
					"distance": 16500
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "20:14",
					"arrivesAt": "20:24",
					"waitsAtSource": 120,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Ilia",
					"leavesAt": "20:26",
					"arrivesAt": "20:53",
					"waitsAtSource": 120,
					"distance": 23600
				},
				{
					"from": "Ilia",
					"to": "Margina",
					"leavesAt": "20:54",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 35500
				},
				{
					"from": "Margina",
					"to": "Făget",
					"leavesAt": "21:43",
					"arrivesAt": "21:51",
					"waitsAtSource": 660,
					"distance": 7600
				},
				{
					"from": "Făget",
					"to": "Lugoj",
					"leavesAt": "21:53",
					"arrivesAt": "22:35",
					"waitsAtSource": 120,
					"distance": 39700
				},
				{
					"from": "Lugoj",
					"to": "Buziaş",
					"leavesAt": "22:40",
					"arrivesAt": "23:09",
					"waitsAtSource": 300,
					"distance": 27500
				},
				{
					"from": "Buziaş",
					"to": "Timişoara Nord",
					"leavesAt": "23:10",
					"arrivesAt": "23:47",
					"waitsAtSource": 60,
					"distance": 36400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6502",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "04:15",
					"arrivesAt": "04:22",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Socola",
					"leavesAt": "04:23",
					"arrivesAt": "04:28",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Socola",
					"to": "Holboca Hm.",
					"leavesAt": "04:29",
					"arrivesAt": "04:37",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Holboca Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "04:38",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "04:47",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9553",
			"segments": [
				{
					"from": "Orşova",
					"to": "Valea Cernei Hm.",
					"leavesAt": "13:32",
					"arrivesAt": "13:38",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Valea Cernei Hm.",
					"to": "Topleţ Hm.",
					"leavesAt": "13:39",
					"arrivesAt": "13:44",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Topleţ Hm.",
					"to": "Băile Herculane",
					"leavesAt": "13:45",
					"arrivesAt": "13:54",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Herculane",
					"to": "Mehadia Nouă Hm.",
					"leavesAt": "13:55",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Mehadia Nouă Hm.",
					"to": "Mehadia Hm.",
					"leavesAt": "13:59",
					"arrivesAt": "14:02",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Mehadia Hm.",
					"to": "Iablaniţa",
					"leavesAt": "14:03",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Iablaniţa",
					"to": "Cruşovăţ",
					"leavesAt": "14:14",
					"arrivesAt": "14:22",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Cruşovăţ",
					"to": "Cornea h.",
					"leavesAt": "14:23",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Cornea h.",
					"to": "Domaşnea Cornea Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Domaşnea Cornea Hm.",
					"to": "Luncaviţa h.",
					"leavesAt": "14:39",
					"arrivesAt": "14:44",
					"waitsAtSource": 300,
					"distance": 3000
				},
				{
					"from": "Luncaviţa h.",
					"to": "Poarta Hm.",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Poarta Hm.",
					"to": "Teregova Hm.",
					"leavesAt": "14:51",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Teregova Hm.",
					"to": "Armeniş",
					"leavesAt": "15:01",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Armeniş",
					"to": "Slatina Timiş",
					"leavesAt": "15:09",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Slatina Timiş",
					"to": "Vălişoara Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:26",
					"waitsAtSource": 240,
					"distance": 6400
				},
				{
					"from": "Vălişoara Hm.",
					"to": "Petroşniţa h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Petroşniţa h.",
					"to": "Valea Timişului Hm.",
					"leavesAt": "15:32",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Valea Timişului Hm.",
					"to": "Balta Sărată",
					"leavesAt": "15:39",
					"arrivesAt": "15:43",
					"waitsAtSource": 240,
					"distance": 3500
				},
				{
					"from": "Balta Sărată",
					"to": "Caransebeş haltă h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Caransebeş haltă h.",
					"to": "Caransebeş",
					"leavesAt": "15:49",
					"arrivesAt": "15:55",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Caransebeş",
					"to": "Tibiscu h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:01",
					"waitsAtSource": 180,
					"distance": 4100
				},
				{
					"from": "Tibiscu h.",
					"to": "Zăgujeni Hm.",
					"leavesAt": "16:02",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Căvăran",
					"leavesAt": "16:06",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Căvăran",
					"to": "Sacu h.",
					"leavesAt": "16:17",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Sacu h.",
					"to": "Jena Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Jena Hm.",
					"to": "Găvojdia",
					"leavesAt": "16:25",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Găvojdia",
					"to": "Tapia Hm.",
					"leavesAt": "16:36",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tapia Hm.",
					"to": "Lugoj",
					"leavesAt": "16:41",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lugoj",
					"to": "Jabăr Hm.",
					"leavesAt": "16:52",
					"arrivesAt": "16:58",
					"waitsAtSource": 300,
					"distance": 7600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "16:59",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Belinţ Hm.",
					"to": "Chizătău Hm.",
					"leavesAt": "17:09",
					"arrivesAt": "17:13",
					"waitsAtSource": 300,
					"distance": 4100
				},
				{
					"from": "Chizătău Hm.",
					"to": "Topolovăţ",
					"leavesAt": "17:19",
					"arrivesAt": "17:25",
					"waitsAtSource": 360,
					"distance": 7200
				},
				{
					"from": "Topolovăţ",
					"to": "Şuştra h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Şuştra h.",
					"to": "Recaş",
					"leavesAt": "17:30",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Recaş",
					"to": "Izvin h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Izvin h.",
					"to": "Remetea Mare",
					"leavesAt": "17:41",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Remetea Mare",
					"to": "Timişoara Est",
					"leavesAt": "17:50",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "18:05",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 375
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9666",
			"segments": [
				{
					"from": "Stamora Moraviţa",
					"to": "Denta h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:56",
					"waitsAtSource": 0,
					"distance": 8400
				},
				{
					"from": "Denta h.",
					"to": "Deta Hm.",
					"leavesAt": "16:57",
					"arrivesAt": "17:04",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Deta Hm.",
					"to": "Voiteni",
					"leavesAt": "17:05",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "17:24",
					"arrivesAt": "17:34",
					"waitsAtSource": 540,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "17:35",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara C.E.T.",
					"leavesAt": "17:51",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişoara Sud",
					"leavesAt": "17:58",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "18:02",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "363",
			"segments": [
				{
					"from": "Biharkeresztes",
					"to": "Episcopia Bihor",
					"leavesAt": "18:57",
					"arrivesAt": "19:12",
					"waitsAtSource": 0,
					"distance": 12500
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "19:36",
					"arrivesAt": "19:44",
					"waitsAtSource": 1440,
					"distance": 5700
				},
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "19:48",
					"arrivesAt": "20:20",
					"waitsAtSource": 240,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "20:21",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "20:42",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bratca",
					"to": "Ciucea Hm.",
					"leavesAt": "20:51",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Ciucea Hm.",
					"to": "Huedin",
					"leavesAt": "21:13",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Huedin",
					"to": "Aghireş",
					"leavesAt": "21:34",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Aghireş",
					"to": "Cluj Napoca",
					"leavesAt": "21:59",
					"arrivesAt": "22:25",
					"waitsAtSource": 60,
					"distance": 27900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2421",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(210)",
					"leavesAt": "12:15",
					"arrivesAt": "12:18",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Turnişor Hm.",
					"leavesAt": "12:19",
					"arrivesAt": "12:24",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Cristian Sibiu h.",
					"leavesAt": "12:25",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Orlat",
					"leavesAt": "12:38",
					"arrivesAt": "12:46",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Orlat",
					"to": "Sibiel h.",
					"leavesAt": "12:47",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Sibiel h.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:55",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sălişte Hm.",
					"leavesAt": "12:56",
					"arrivesAt": "13:03",
					"waitsAtSource": 30,
					"distance": 4300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7365",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Sud",
					"leavesAt": "19:29",
					"arrivesAt": "19:34",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Buzău Sud",
					"to": "Tăbărăşti h.",
					"leavesAt": "19:39",
					"arrivesAt": "19:44",
					"waitsAtSource": 300,
					"distance": 5100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "19:45",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Bentu h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:54",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bentu h.",
					"to": "Cilibia Hm.",
					"leavesAt": "19:55",
					"arrivesAt": "20:00",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cilibia Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:09",
					"waitsAtSource": 300,
					"distance": 4100
				},
				{
					"from": "Movila Oii h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "20:10",
					"arrivesAt": "20:17",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Vizireni h.",
					"leavesAt": "20:18",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vizireni h.",
					"to": "CTF Făurei h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:26",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "CTF Făurei h.",
					"to": "Făurei",
					"leavesAt": "20:27",
					"arrivesAt": "20:34",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Făurei",
					"to": "Găiseanca h.",
					"leavesAt": "20:39",
					"arrivesAt": "20:42",
					"waitsAtSource": 300,
					"distance": 3900
				},
				{
					"from": "Găiseanca h.",
					"to": "Deduleşti Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:49",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Ianca hc.",
					"leavesAt": "20:50",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ianca hc.",
					"to": "Plopu",
					"leavesAt": "20:56",
					"arrivesAt": "20:59",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Plopu",
					"to": "Urleasca Hm.",
					"leavesAt": "21:00",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Urleasca Hm.",
					"to": "Traian Sat Hm.",
					"leavesAt": "21:07",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Lacu Sărat",
					"leavesAt": "21:14",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Lacu Sărat",
					"to": "Brăila",
					"leavesAt": "21:23",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "21:33",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "21:39",
					"arrivesAt": "21:44",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Zagna Vădeni h.",
					"leavesAt": "21:45",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Barboşi",
					"leavesAt": "21:50",
					"arrivesAt": "21:57",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "21:58",
					"arrivesAt": "22:05",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "22:06",
					"arrivesAt": "22:18",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8580",
			"segments": [
				{
					"from": "Ciulniţa",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "04:40",
					"arrivesAt": "04:59",
					"waitsAtSource": 0,
					"distance": 12600
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Slobozia Veche",
					"leavesAt": "05:00",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 4200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5426",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "18:40",
					"arrivesAt": "18:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "18:55",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "19:03",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "19:10",
					"arrivesAt": "19:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "19:18",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "19:28",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "19:35",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "19:40",
					"arrivesAt": "19:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "19:50",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:36",
					"waitsAtSource": 1500,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "20:37",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "20:48",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "20:54",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "20:59",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "21:06",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "21:17",
					"arrivesAt": "21:24",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "21:25",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "21:30",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "21:39",
					"arrivesAt": "21:44",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "21:45",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "21:51",
					"arrivesAt": "22:03",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4546",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:38",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "14:39",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Periş Mureş h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:02",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Periş Mureş h.",
					"to": "Petelea h.",
					"leavesAt": "15:03",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Petelea h.",
					"to": "Reghin",
					"leavesAt": "15:09",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Reghin",
					"to": "Ideciu de Jos h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:32",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Halta Aluniş h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "15:38",
					"arrivesAt": "15:43",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Ruşii Munţi h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Deda",
					"leavesAt": "15:48",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2203",
			"segments": [
				{
					"from": "Arad",
					"to": "Şofronea",
					"leavesAt": "07:52",
					"arrivesAt": "08:02",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Şofronea",
					"to": "Curtici",
					"leavesAt": "08:03",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4525",
			"segments": [
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "00:43",
					"arrivesAt": "01:10",
					"waitsAtSource": 0,
					"distance": 28500
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 382
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 382
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3010",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "16:25",
					"arrivesAt": "16:34",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Timişu de Jos h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Predeal",
					"leavesAt": "16:52",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "17:10",
					"arrivesAt": "17:19",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "17:20",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "17:27",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "17:31",
					"arrivesAt": "17:36",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:41",
					"waitsAtSource": 120,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Posada h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Posada h.",
					"to": "Comarnic",
					"leavesAt": "17:54",
					"arrivesAt": "17:59",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "18:10",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "18:15",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Bobolia h.",
					"leavesAt": "18:22",
					"arrivesAt": "18:28",
					"waitsAtSource": 120,
					"distance": 5500
				},
				{
					"from": "Bobolia h.",
					"to": "Floreşti Prahova",
					"leavesAt": "18:29",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "18:44",
					"arrivesAt": "18:54",
					"waitsAtSource": 420,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "18:55",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "19:17",
					"arrivesAt": "19:20",
					"waitsAtSource": 840,
					"distance": 2900
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Brazi",
					"leavesAt": "19:21",
					"arrivesAt": "19:26",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:32",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "19:33",
					"arrivesAt": "19:37",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "19:38",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "19:43",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "19:57",
					"arrivesAt": "20:01",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "20:02",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "20:11",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "20:16",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4108",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Apahida",
					"leavesAt": "15:30",
					"arrivesAt": "15:47",
					"waitsAtSource": 0,
					"distance": 12300
				},
				{
					"from": "Apahida",
					"to": "Jucu Hm.",
					"leavesAt": "15:48",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Jucu Hm.",
					"to": "Răscruci h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Răscruci h.",
					"to": "Bonţida Hm.",
					"leavesAt": "16:05",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bonţida Hm.",
					"to": "Iclod Hm.",
					"leavesAt": "16:11",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Iclod Hm.",
					"to": "Livada Someş h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Livada Someş h.",
					"to": "Gherla",
					"leavesAt": "16:28",
					"arrivesAt": "16:37",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "16:39",
					"arrivesAt": "16:58",
					"waitsAtSource": 120,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "17:08",
					"arrivesAt": "17:15",
					"waitsAtSource": 600,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Reteag Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Reteag Hm.",
					"to": "Reteag h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag h.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "17:32",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "17:36",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "17:41",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Beclean pe Someş",
					"to": "Şintereag Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şintereag Hm.",
					"to": "Caila hc.",
					"leavesAt": "18:00",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Caila hc.",
					"to": "Sfântu h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sfântu h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "18:09",
					"arrivesAt": "18:15",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "18:16",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Sărata h.",
					"leavesAt": "18:27",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Viişoara h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:36",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Viişoara h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "18:37",
					"arrivesAt": "18:41",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "18:42",
					"arrivesAt": "18:45",
					"waitsAtSource": 30,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180105",
					"daysOfWeek": 895
				},
				{
					"from": "20180108",
					"to": "20180112",
					"daysOfWeek": 895
				},
				{
					"from": "20180115",
					"to": "20180119",
					"daysOfWeek": 895
				},
				{
					"from": "20180122",
					"to": "20180123",
					"daysOfWeek": 895
				},
				{
					"from": "20180125",
					"to": "20180126",
					"daysOfWeek": 895
				},
				{
					"from": "20180129",
					"to": "20180202",
					"daysOfWeek": 895
				},
				{
					"from": "20180205",
					"to": "20180209",
					"daysOfWeek": 895
				},
				{
					"from": "20180212",
					"to": "20180216",
					"daysOfWeek": 895
				},
				{
					"from": "20180219",
					"to": "20180223",
					"daysOfWeek": 895
				},
				{
					"from": "20180226",
					"to": "20180302",
					"daysOfWeek": 895
				},
				{
					"from": "20180305",
					"to": "20180309",
					"daysOfWeek": 895
				},
				{
					"from": "20180312",
					"to": "20180316",
					"daysOfWeek": 895
				},
				{
					"from": "20180319",
					"to": "20180323",
					"daysOfWeek": 895
				},
				{
					"from": "20180326",
					"to": "20180330",
					"daysOfWeek": 895
				},
				{
					"from": "20180402",
					"to": "20180406",
					"daysOfWeek": 895
				},
				{
					"from": "20180410",
					"to": "20180413",
					"daysOfWeek": 895
				},
				{
					"from": "20180416",
					"to": "20180420",
					"daysOfWeek": 895
				},
				{
					"from": "20180423",
					"to": "20180427",
					"daysOfWeek": 895
				},
				{
					"from": "20180430",
					"to": "20180430",
					"daysOfWeek": 895
				},
				{
					"from": "20180502",
					"to": "20180504",
					"daysOfWeek": 895
				},
				{
					"from": "20180507",
					"to": "20180511",
					"daysOfWeek": 895
				},
				{
					"from": "20180514",
					"to": "20180518",
					"daysOfWeek": 895
				},
				{
					"from": "20180521",
					"to": "20180525",
					"daysOfWeek": 895
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 895
				},
				{
					"from": "20180604",
					"to": "20180908",
					"daysOfWeek": 895
				},
				{
					"from": "20180910",
					"to": "20180914",
					"daysOfWeek": 895
				},
				{
					"from": "20180917",
					"to": "20180921",
					"daysOfWeek": 895
				},
				{
					"from": "20180924",
					"to": "20180928",
					"daysOfWeek": 895
				},
				{
					"from": "20181001",
					"to": "20181005",
					"daysOfWeek": 895
				},
				{
					"from": "20181008",
					"to": "20181012",
					"daysOfWeek": 895
				},
				{
					"from": "20181015",
					"to": "20181019",
					"daysOfWeek": 895
				},
				{
					"from": "20181022",
					"to": "20181026",
					"daysOfWeek": 895
				},
				{
					"from": "20181029",
					"to": "20181102",
					"daysOfWeek": 895
				},
				{
					"from": "20181105",
					"to": "20181109",
					"daysOfWeek": 895
				},
				{
					"from": "20181112",
					"to": "20181116",
					"daysOfWeek": 895
				},
				{
					"from": "20181119",
					"to": "20181123",
					"daysOfWeek": 895
				},
				{
					"from": "20181126",
					"to": "20181129",
					"daysOfWeek": 895
				},
				{
					"from": "20181203",
					"to": "20181207",
					"daysOfWeek": 895
				},
				{
					"from": "20171211",
					"to": "20171215",
					"daysOfWeek": 895
				},
				{
					"from": "20171218",
					"to": "20171222",
					"daysOfWeek": 895
				},
				{
					"from": "20171227",
					"to": "20171229",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5566",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "18:17",
					"arrivesAt": "18:22",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "18:24",
					"arrivesAt": "18:33",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "18:34",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Bursuceni h.",
					"leavesAt": "18:57",
					"arrivesAt": "19:07",
					"waitsAtSource": 900,
					"distance": 8100
				},
				{
					"from": "Bursuceni h.",
					"to": "Bucecea Hm",
					"leavesAt": "19:08",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Bucecea Hm",
					"to": "Leorda Hm.",
					"leavesAt": "19:26",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Leorda Hm.",
					"to": "Botoşani",
					"leavesAt": "19:58",
					"arrivesAt": "20:22",
					"waitsAtSource": 780,
					"distance": 15500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4653",
			"segments": [
				{
					"from": "Valea Vişeului",
					"to": "Lunca la Tisa h.",
					"leavesAt": "13:12",
					"arrivesAt": "13:28",
					"waitsAtSource": 0,
					"distance": 10700
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "13:29",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Crăciuneşti h.",
					"leavesAt": "13:36",
					"arrivesAt": "13:42",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Tisa h.",
					"leavesAt": "13:43",
					"arrivesAt": "13:46",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Tisa h.",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "13:47",
					"arrivesAt": "13:54",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Sighetu Marmaţiei",
					"leavesAt": "13:55",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 1900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4334",
			"segments": [
				{
					"from": "Halmeu",
					"to": "Porumbeşti Hm.",
					"leavesAt": "07:01",
					"arrivesAt": "07:07",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Micula Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Micula Hm.",
					"to": "Ram. Botiz h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Satu Mare",
					"leavesAt": "07:23",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Satu Mare",
					"to": "Satu Mare Sud",
					"leavesAt": "07:40",
					"arrivesAt": "07:45",
					"waitsAtSource": 720,
					"distance": 3100
				},
				{
					"from": "Satu Mare Sud",
					"to": "Sătmărel h.",
					"leavesAt": "07:53",
					"arrivesAt": "07:59",
					"waitsAtSource": 480,
					"distance": 6600
				},
				{
					"from": "Sătmărel h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "08:00",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Moftin h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Moftin h.",
					"to": "Domăneşti h.",
					"leavesAt": "08:13",
					"arrivesAt": "08:17",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Domăneşti h.",
					"to": "Carei",
					"leavesAt": "08:18",
					"arrivesAt": "08:30",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Carei",
					"to": "Marna h.",
					"leavesAt": "08:31",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Marna h.",
					"to": "Sanislău Hm.",
					"leavesAt": "08:38",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Sanislău Hm.",
					"to": "Resighea h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Resighea h.",
					"to": "Curtuiuşeni h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:58",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Valea lui Mihai",
					"leavesAt": "08:59",
					"arrivesAt": "09:05",
					"waitsAtSource": 30,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7373",
			"segments": [
				{
					"from": "Făurei",
					"to": "Găiseanca h.",
					"leavesAt": "07:20",
					"arrivesAt": "07:24",
					"waitsAtSource": 0,
					"distance": 3900
				},
				{
					"from": "Găiseanca h.",
					"to": "Deduleşti Hm.",
					"leavesAt": "07:25",
					"arrivesAt": "07:32",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Ianca hc.",
					"leavesAt": "07:33",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ianca hc.",
					"to": "Plopu",
					"leavesAt": "07:40",
					"arrivesAt": "07:44",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Plopu",
					"to": "Urleasca Hm.",
					"leavesAt": "07:45",
					"arrivesAt": "07:52",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Urleasca Hm.",
					"to": "Traian Sat Hm.",
					"leavesAt": "07:53",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Lacu Sărat",
					"leavesAt": "08:02",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Lacu Sărat",
					"to": "Brăila",
					"leavesAt": "08:13",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "08:25",
					"arrivesAt": "08:32",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "08:33",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Zagna Vădeni h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Barboşi",
					"leavesAt": "08:44",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "08:52",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "09:00",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3623",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "06:20",
					"arrivesAt": "06:26",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Suceag h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Suceag h.",
					"to": "Rădaia h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:34",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Rădaia h.",
					"to": "Mera Hm.",
					"leavesAt": "06:35",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Mera Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Nădăşel h.",
					"to": "Gârbău Hm.",
					"leavesAt": "06:41",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gârbău Hm.",
					"to": "Macău h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Macău h.",
					"to": "Dorolţu h.",
					"leavesAt": "06:53",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Dorolţu h.",
					"to": "Aghireş",
					"leavesAt": "06:56",
					"arrivesAt": "06:59",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Stana Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:15",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Stana Hm.",
					"to": "Jebuc h.",
					"leavesAt": "07:16",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Jebuc h.",
					"to": "Huedin",
					"leavesAt": "07:24",
					"arrivesAt": "07:31",
					"waitsAtSource": 30,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5462",
			"segments": [
				{
					"from": "Piatra Neamţ",
					"to": "Dumbrava h.",
					"leavesAt": "14:20",
					"arrivesAt": "14:27",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Săvineşti h.",
					"leavesAt": "14:28",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Săvineşti h.",
					"to": "Roznov",
					"leavesAt": "14:35",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Roznov",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "14:42",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Podoleni Hm.",
					"leavesAt": "14:47",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Podoleni Hm.",
					"to": "Costişa h.",
					"leavesAt": "14:55",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Costişa h.",
					"to": "Buhuşi",
					"leavesAt": "15:03",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhuşi",
					"to": "Racova h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:24",
					"waitsAtSource": 480,
					"distance": 3800
				},
				{
					"from": "Racova h.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Gârleni Hm.",
					"leavesAt": "15:31",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gârleni Hm.",
					"to": "Hămeiuş P.M.",
					"leavesAt": "15:36",
					"arrivesAt": "15:42",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Bacău",
					"leavesAt": "15:43",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 7900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "79",
			"segments": [
				{
					"from": "Lokoshaza",
					"to": "Curtici",
					"leavesAt": "19:53",
					"arrivesAt": "20:03",
					"waitsAtSource": 0,
					"distance": 11200
				},
				{
					"from": "Curtici",
					"to": "Arad",
					"leavesAt": "20:28",
					"arrivesAt": "20:42",
					"waitsAtSource": 1500,
					"distance": 17000
				},
				{
					"from": "Arad",
					"to": "Timişoara Nord",
					"leavesAt": "20:44",
					"arrivesAt": "21:33",
					"waitsAtSource": 120,
					"distance": 57200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2085",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "14:25",
					"arrivesAt": "14:29",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "14:30",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "14:34",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "14:39",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "14:47",
					"arrivesAt": "14:50",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "14:51",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "14:56",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "15:05",
					"arrivesAt": "15:10",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Bungeţel h.",
					"leavesAt": "15:36",
					"arrivesAt": "15:39",
					"waitsAtSource": 1560,
					"distance": 2300
				},
				{
					"from": "Bungeţel h.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "15:40",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "15:46",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Floreşti hc.",
					"to": "Gilort Hm.",
					"leavesAt": "15:50",
					"arrivesAt": "15:56",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Gilort Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "15:57",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turburea Hm.",
					"to": "Bibeşti Hm.",
					"leavesAt": "16:08",
					"arrivesAt": "16:17",
					"waitsAtSource": 300,
					"distance": 7300
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "16:18",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Musculeşti",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:30",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Jupâneşti Hm.",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "16:37",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cărbuneşti",
					"to": "Pojogeni Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Scoarţa h.",
					"leavesAt": "16:53",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Scoarţa h.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "16:57",
					"arrivesAt": "17:00",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Budieni h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Budieni h.",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "17:06",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "17:11",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Târgu Jiu",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "17:21",
					"arrivesAt": "17:25",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Ezureni h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ezureni h.",
					"to": "Parângu Hm.",
					"leavesAt": "17:31",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Parângu Hm.",
					"to": "Bumbeşti Hm.",
					"leavesAt": "17:36",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bumbeşti Hm.",
					"to": "Valea Sadului Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Meri",
					"leavesAt": "17:49",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Meri",
					"to": "Lainici Hm.",
					"leavesAt": "17:57",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Lainici Hm.",
					"to": "Km. 105+600 h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Km. 105+600 h.",
					"to": "Pietrele Albe Hm.",
					"leavesAt": "18:13",
					"arrivesAt": "18:18",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pietrele Albe Hm.",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Livezeni",
					"leavesAt": "18:29",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Lunca Jiului hc.",
					"leavesAt": "18:35",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Lunca Jiului hc.",
					"to": "Petroşani",
					"leavesAt": "18:39",
					"arrivesAt": "18:45",
					"waitsAtSource": 30,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 351
				},
				{
					"from": "20180409",
					"to": "20180526",
					"daysOfWeek": 351
				},
				{
					"from": "20180528",
					"to": "20181208",
					"daysOfWeek": 351
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 351
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1832",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Gherla",
					"leavesAt": "09:14",
					"arrivesAt": "10:11",
					"waitsAtSource": 0,
					"distance": 44900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "10:12",
					"arrivesAt": "10:31",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Beclean pe Someş",
					"leavesAt": "10:34",
					"arrivesAt": "11:07",
					"waitsAtSource": 180,
					"distance": 24600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Salva",
					"leavesAt": "11:08",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Salva",
					"to": "Năsăud",
					"leavesAt": "11:31",
					"arrivesAt": "11:38",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Năsăud",
					"to": "Ilva Mică",
					"leavesAt": "11:40",
					"arrivesAt": "12:02",
					"waitsAtSource": 120,
					"distance": 19800
				},
				{
					"from": "Ilva Mică",
					"to": "Poiana Ilvei",
					"leavesAt": "12:05",
					"arrivesAt": "12:20",
					"waitsAtSource": 180,
					"distance": 12800
				},
				{
					"from": "Poiana Ilvei",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "12:25",
					"arrivesAt": "12:33",
					"waitsAtSource": 300,
					"distance": 4500
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "12:34",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 14300
				},
				{
					"from": "Lunca Ilvei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "12:52",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 42800
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Vatra Dornei",
					"leavesAt": "13:46",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei",
					"to": "Iacobeni",
					"leavesAt": "13:50",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Iacobeni",
					"to": "Mestecăniş",
					"leavesAt": "14:06",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Pojorâta Hm.",
					"leavesAt": "14:18",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "14:40",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "14:50",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Vama",
					"leavesAt": "14:57",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Vama",
					"to": "Frasin",
					"leavesAt": "15:12",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "15:24",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Suceava",
					"leavesAt": "15:33",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 46800
				},
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "16:26",
					"arrivesAt": "16:39",
					"waitsAtSource": 600,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "16:40",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "16:59",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Târgu Frumos",
					"leavesAt": "17:17",
					"arrivesAt": "17:44",
					"waitsAtSource": 120,
					"distance": 30800
				},
				{
					"from": "Târgu Frumos",
					"to": "Iaşi",
					"leavesAt": "17:45",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 44900
				},
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "18:32",
					"arrivesAt": "18:38",
					"waitsAtSource": 720,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Bârnova Hm.",
					"leavesAt": "18:39",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Buhăieşti",
					"leavesAt": "19:01",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Buhăieşti",
					"to": "Vaslui",
					"leavesAt": "19:24",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Vaslui",
					"to": "Crasna",
					"leavesAt": "19:43",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Crasna",
					"to": "Bârlad",
					"leavesAt": "19:58",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Bârlad",
					"to": "Tutova",
					"leavesAt": "20:34",
					"arrivesAt": "20:47",
					"waitsAtSource": 180,
					"distance": 15000
				},
				{
					"from": "Tutova",
					"to": "Tecuci",
					"leavesAt": "20:51",
					"arrivesAt": "21:27",
					"waitsAtSource": 240,
					"distance": 35300
				},
				{
					"from": "Tecuci",
					"to": "Lieşti",
					"leavesAt": "21:29",
					"arrivesAt": "21:55",
					"waitsAtSource": 120,
					"distance": 24400
				},
				{
					"from": "Lieşti",
					"to": "Barboşi",
					"leavesAt": "21:56",
					"arrivesAt": "22:47",
					"waitsAtSource": 60,
					"distance": 48300
				},
				{
					"from": "Barboşi",
					"to": "Galaţi",
					"leavesAt": "22:48",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9346",
			"segments": [
				{
					"from": "Giurgiu",
					"to": "Giurgiu Nord",
					"leavesAt": "15:35",
					"arrivesAt": "15:40",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Giurgiu Nord",
					"to": "Cetatea h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cetatea h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "15:44",
					"arrivesAt": "15:47",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Onceşti h.",
					"leavesAt": "15:48",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Onceşti h.",
					"to": "Stăneşti Hm.",
					"leavesAt": "15:52",
					"arrivesAt": "15:57",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Chiriacu Hm.",
					"leavesAt": "15:58",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Toporu",
					"leavesAt": "16:06",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Toporu",
					"to": "Răsuceni h.",
					"leavesAt": "16:17",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Răsuceni h.",
					"to": "Vlaşca Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Târnavele Hm.",
					"to": "Răduleşti Hm.",
					"leavesAt": "16:38",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Videle",
					"leavesAt": "16:57",
					"arrivesAt": "17:07",
					"waitsAtSource": 480,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1643",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "18:00",
					"arrivesAt": "18:42",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "18:44",
					"arrivesAt": "19:08",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "19:09",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Comarnic",
					"leavesAt": "19:15",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Comarnic",
					"to": "Sinaia",
					"leavesAt": "19:24",
					"arrivesAt": "19:37",
					"waitsAtSource": 60,
					"distance": 15100
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "19:39",
					"arrivesAt": "19:47",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "19:48",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "19:54",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "20:05",
					"arrivesAt": "20:42",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Sfântu Gheorghe",
					"leavesAt": "20:54",
					"arrivesAt": "21:23",
					"waitsAtSource": 720,
					"distance": 32100
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "21:24",
					"arrivesAt": "21:56",
					"waitsAtSource": 60,
					"distance": 34400
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "21:57",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "22:22",
					"arrivesAt": "22:30",
					"waitsAtSource": 360,
					"distance": 7800
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "22:31",
					"arrivesAt": "22:39",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Izvoru Oltului",
					"leavesAt": "22:43",
					"arrivesAt": "23:00",
					"waitsAtSource": 240,
					"distance": 17100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "23:01",
					"arrivesAt": "23:12",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Gheorgheni",
					"leavesAt": "23:13",
					"arrivesAt": "23:30",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Gheorgheni",
					"to": "Topliţa",
					"leavesAt": "23:31",
					"arrivesAt": "00:03",
					"waitsAtSource": 60,
					"distance": 34000
				},
				{
					"from": "Topliţa",
					"to": "Deda",
					"leavesAt": "00:05",
					"arrivesAt": "01:04",
					"waitsAtSource": 120,
					"distance": 43900
				},
				{
					"from": "Deda",
					"to": "Sărăţel Hm.",
					"leavesAt": "01:09",
					"arrivesAt": "02:07",
					"waitsAtSource": 300,
					"distance": 46800
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "02:09",
					"arrivesAt": "02:36",
					"waitsAtSource": 120,
					"distance": 24900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9358",
			"segments": [
				{
					"from": "Alexandria",
					"to": "Alexandria Nord h.",
					"leavesAt": "02:32",
					"arrivesAt": "02:35",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Buzescu h.",
					"leavesAt": "02:36",
					"arrivesAt": "02:45",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Buzescu h.",
					"to": "Plosca Hm.",
					"leavesAt": "02:46",
					"arrivesAt": "02:57",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Plosca Hm.",
					"to": "Peret hc.",
					"leavesAt": "02:58",
					"arrivesAt": "03:03",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Peret hc.",
					"to": "Roşiori Hm.",
					"leavesAt": "03:04",
					"arrivesAt": "03:17",
					"waitsAtSource": 30,
					"distance": 10400
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "03:18",
					"arrivesAt": "03:25",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8807",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "20:05",
					"arrivesAt": "20:17",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "20:25",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "20:34",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "20:50",
					"arrivesAt": "20:58",
					"waitsAtSource": 540,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "20:59",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "21:15",
					"arrivesAt": "21:18",
					"waitsAtSource": 480,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "21:19",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "21:32",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "21:45",
					"arrivesAt": "21:53",
					"waitsAtSource": 540,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2724",
			"segments": [
				{
					"from": "Simeria",
					"to": "Simeria Triaj",
					"leavesAt": "14:45",
					"arrivesAt": "14:52",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Simeria Triaj",
					"to": "Băcia h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Băcia h.",
					"to": "Băcia Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Băcia Hm.",
					"to": "Batiz h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Batiz h.",
					"to": "Călan Băi",
					"leavesAt": "15:03",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Călan Băi",
					"to": "Călan Hm.",
					"leavesAt": "15:06",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Hm.",
					"to": "Ruşi h.",
					"leavesAt": "15:11",
					"arrivesAt": "15:14",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ruşi h.",
					"to": "Măceu h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Măceu h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "15:19",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Plopi h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Plopi h.",
					"to": "Covragiu h.",
					"leavesAt": "15:29",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Covragiu h.",
					"to": "Subcetate",
					"leavesAt": "15:33",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20180115",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180701",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20180921",
					"daysOfWeek": 799
				},
				{
					"from": "20180924",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1095",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "12:45",
					"arrivesAt": "13:38",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Giurgiu Nord",
					"leavesAt": "13:39",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 63000
				},
				{
					"from": "Giurgiu Nord",
					"to": "Ruse",
					"leavesAt": "15:10",
					"arrivesAt": "15:35",
					"waitsAtSource": 1380,
					"distance": 16000
				}
			],
			"restrictions": [
				{
					"from": "20181002",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180531",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4311",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Botiz Hm.",
					"leavesAt": "04:52",
					"arrivesAt": "04:58",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Botiz Hm.",
					"to": "Odoreu h.",
					"leavesAt": "04:59",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Odoreu h.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:16",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Apa Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Apa Hm.",
					"to": "Seini",
					"leavesAt": "05:36",
					"arrivesAt": "05:50",
					"waitsAtSource": 600,
					"distance": 8500
				},
				{
					"from": "Seini",
					"to": "Săbişa h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Săbişa h.",
					"to": "Ilba h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ilba h.",
					"to": "Cicârlău h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cicârlău h.",
					"to": "Buşag Hm.",
					"leavesAt": "06:13",
					"arrivesAt": "06:19",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Buşag Hm.",
					"to": "Baia Mare",
					"leavesAt": "06:20",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9443",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "07:35",
					"arrivesAt": "07:37",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:40",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Aninoasa Hm.",
					"leavesAt": "07:41",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Aninoasa Hm.",
					"to": "Săteni h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Săteni h.",
					"to": "Doiceşti",
					"leavesAt": "07:48",
					"arrivesAt": "07:51",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Doiceşti",
					"to": "Doiceşti h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Doiceşti h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "07:55",
					"arrivesAt": "07:58",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Scârlenţa h.",
					"leavesAt": "07:59",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Scârlenţa h.",
					"to": "Trainica h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Trainica h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "08:06",
					"arrivesAt": "08:10",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Moţăieni h.",
					"leavesAt": "08:11",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Moţăieni h.",
					"to": "Fieni",
					"leavesAt": "08:15",
					"arrivesAt": "08:20",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "08:21",
					"arrivesAt": "08:24",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Pietroşiţa Hm.",
					"leavesAt": "08:25",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9301",
			"segments": [
				{
					"from": "Videle",
					"to": "Ciolpani Hm.",
					"leavesAt": "05:45",
					"arrivesAt": "05:52",
					"waitsAtSource": 0,
					"distance": 7700
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Gălăteni Hm.",
					"leavesAt": "05:53",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Olteni",
					"leavesAt": "06:03",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Olteni",
					"to": "Vârtoapele hc.",
					"leavesAt": "06:10",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "06:18",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Atârnaţi Hm.",
					"leavesAt": "06:24",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "06:36",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5523",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Topile h.",
					"leavesAt": "06:52",
					"arrivesAt": "06:57",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Topile h.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "06:58",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Timişeşti Hm.",
					"leavesAt": "07:07",
					"arrivesAt": "07:14",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Plăieşu h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:20",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Plăieşu h.",
					"to": "Sfântu Mina h.",
					"leavesAt": "07:21",
					"arrivesAt": "07:24",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Târgu Neamţ",
					"leavesAt": "07:25",
					"arrivesAt": "07:36",
					"waitsAtSource": 30,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2604",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "13:36",
					"arrivesAt": "13:43",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Valea Viilor Hm.",
					"leavesAt": "13:44",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Şag Hm.",
					"leavesAt": "13:58",
					"arrivesAt": "14:03",
					"waitsAtSource": 300,
					"distance": 5500
				},
				{
					"from": "Şag Hm.",
					"to": "Vinga Hm.",
					"leavesAt": "14:08",
					"arrivesAt": "14:14",
					"waitsAtSource": 300,
					"distance": 7400
				},
				{
					"from": "Vinga Hm.",
					"to": "Orţişoara",
					"leavesAt": "14:15",
					"arrivesAt": "14:20",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Orţişoara",
					"to": "Băile Călacea",
					"leavesAt": "14:26",
					"arrivesAt": "14:32",
					"waitsAtSource": 360,
					"distance": 5900
				},
				{
					"from": "Băile Călacea",
					"to": "Sânandrei Hm.",
					"leavesAt": "14:33",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:57",
					"waitsAtSource": 660,
					"distance": 7400
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "14:58",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "15:02",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3116",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Vest Hm.",
					"leavesAt": "16:03",
					"arrivesAt": "16:10",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "16:11",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Cefa Hm.",
					"leavesAt": "16:23",
					"arrivesAt": "16:33",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Cefa Hm.",
					"to": "Mădăraş Bihor h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:47",
					"waitsAtSource": 180,
					"distance": 9300
				},
				{
					"from": "Mădăraş Bihor h.",
					"to": "Salonta",
					"leavesAt": "16:48",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Salonta",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "16:54",
					"arrivesAt": "17:05",
					"waitsAtSource": 120,
					"distance": 10200
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Boiu Bihor h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:11",
					"waitsAtSource": 120,
					"distance": 3800
				},
				{
					"from": "Boiu Bihor h.",
					"to": "Tămaşda h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tămaşda h.",
					"to": "Zerind Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:29",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Zerind Hm.",
					"to": "Chişineu Criş",
					"leavesAt": "17:30",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Chişineu Criş",
					"to": "Nădab",
					"leavesAt": "17:54",
					"arrivesAt": "18:01",
					"waitsAtSource": 1020,
					"distance": 4900
				},
				{
					"from": "Nădab",
					"to": "Şimand Hm.",
					"leavesAt": "18:02",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şimand Hm.",
					"to": "Comlăuş h.",
					"leavesAt": "18:12",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Comlăuş h.",
					"to": "Sântana",
					"leavesAt": "18:20",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "18:31",
					"arrivesAt": "18:41",
					"waitsAtSource": 300,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utviniş h.",
					"leavesAt": "18:42",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Utviniş h.",
					"to": "Utvinişu Nou",
					"leavesAt": "18:47",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Utvinişu Nou",
					"to": "Arad",
					"leavesAt": "18:52",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "19:23",
					"arrivesAt": "19:30",
					"waitsAtSource": 1140,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Şag Hm.",
					"leavesAt": "19:31",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Şag Hm.",
					"to": "Vinga Hm.",
					"leavesAt": "19:45",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vinga Hm.",
					"to": "Orţişoara",
					"leavesAt": "19:52",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Orţişoara",
					"to": "Băile Călacea",
					"leavesAt": "19:58",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Băile Călacea",
					"to": "Sânandrei Hm.",
					"leavesAt": "20:04",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj h",
					"leavesAt": "20:11",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Ronaţ Triaj Cab 1 h",
					"leavesAt": "20:18",
					"arrivesAt": "20:20",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab 1 h",
					"to": "Timişoara Nord",
					"leavesAt": "20:21",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9167",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Valea Păltinişului h.",
					"leavesAt": "13:33",
					"arrivesAt": "13:38",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "13:39",
					"arrivesAt": "13:46",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Brebu",
					"leavesAt": "13:47",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Brebu",
					"to": "Ezeriş h.",
					"leavesAt": "14:00",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ezeriş h.",
					"to": "Bănila Câlnic h.",
					"leavesAt": "14:09",
					"arrivesAt": "14:15",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "14:16",
					"arrivesAt": "14:27",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Reşiţa Nord",
					"to": "Reşiţa Sud Hm.",
					"leavesAt": "14:28",
					"arrivesAt": "14:37",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4511",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "15:38",
					"arrivesAt": "15:46",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Racu h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Racu h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "15:51",
					"arrivesAt": "15:59",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Dăneşti h.",
					"leavesAt": "16:06",
					"arrivesAt": "16:11",
					"waitsAtSource": 420,
					"distance": 3000
				},
				{
					"from": "Dăneşti h.",
					"to": "Cârţani h.",
					"leavesAt": "16:12",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cârţani h.",
					"to": "Tomeşti h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:19",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Izvoru Oltului",
					"leavesAt": "16:20",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Izvoru Oltului",
					"to": "Sândominic h.",
					"leavesAt": "16:25",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "16:30",
					"arrivesAt": "16:39",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Şugău h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şugău h.",
					"to": "Valea Strâmbă h.",
					"leavesAt": "16:56",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Gheorgheni",
					"leavesAt": "17:00",
					"arrivesAt": "17:04",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Gheorgheni",
					"to": "Lăzarea Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Lăzarea Hm.",
					"to": "Ditrău",
					"leavesAt": "17:11",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ditrău",
					"to": "Subcetate Mureş Hm.",
					"leavesAt": "17:18",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Subcetate Mureş Hm.",
					"to": "Sărmaş Runc h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărmaş Runc h.",
					"to": "Gălăuţaş Hm.",
					"leavesAt": "17:34",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Gălăuţaş Hm.",
					"to": "Topliţa",
					"leavesAt": "17:42",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Topliţa",
					"to": "Ciobotani h.",
					"leavesAt": "17:50",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ciobotani h.",
					"to": "Stânceni Hm.",
					"leavesAt": "18:00",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Stânceni Hm.",
					"to": "Stânceni h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Stânceni h.",
					"to": "Stânceni Neagra h.",
					"leavesAt": "18:15",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Stânceni Neagra h.",
					"to": "Lunca Bradului Hm.",
					"leavesAt": "18:21",
					"arrivesAt": "18:29",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Lunca Bradului Hm.",
					"to": "Andreneasa h.",
					"leavesAt": "18:30",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Andreneasa h.",
					"to": "Răstoliţa Hm.",
					"leavesAt": "18:41",
					"arrivesAt": "18:50",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Răstoliţa Hm.",
					"to": "Borzia h.",
					"leavesAt": "18:51",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Borzia h.",
					"to": "Deda Bistra Hm.",
					"leavesAt": "18:56",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Deda Bistra Hm.",
					"to": "Deda",
					"leavesAt": "19:01",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Deda",
					"to": "Ruşii Munţi h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:25",
					"waitsAtSource": 4200,
					"distance": 4500
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "20:26",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Halta Aluniş h.",
					"leavesAt": "20:36",
					"arrivesAt": "20:41",
					"waitsAtSource": 360,
					"distance": 3800
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Ideciu de Jos h.",
					"leavesAt": "20:46",
					"arrivesAt": "20:51",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Reghin",
					"leavesAt": "20:52",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Reghin",
					"to": "Petelea h.",
					"leavesAt": "21:02",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Petelea h.",
					"to": "Periş Mureş h.",
					"leavesAt": "21:10",
					"arrivesAt": "21:15",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Periş Mureş h.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "21:16",
					"arrivesAt": "21:21",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "21:22",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "21:28",
					"arrivesAt": "21:40",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Târgu Mureş",
					"leavesAt": "21:41",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5723",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Vest",
					"leavesAt": "19:26",
					"arrivesAt": "19:34",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Suceava Vest",
					"to": "Stroieşti",
					"leavesAt": "19:35",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Stroieşti",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "19:49",
					"arrivesAt": "19:56",
					"waitsAtSource": 240,
					"distance": 7000
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "20:05",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Gura Humorului Hm.",
					"leavesAt": "20:13",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Gura Humorului Oraş",
					"leavesAt": "20:24",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "20:31",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Molid Hm.",
					"leavesAt": "20:41",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Molid Hm.",
					"to": "Vama",
					"leavesAt": "20:49",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vama",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "20:55",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "21:03",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "21:14",
					"arrivesAt": "21:21",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4705",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "11:47",
					"arrivesAt": "11:55",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Gherla",
					"leavesAt": "11:56",
					"arrivesAt": "12:07",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "12:08",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "12:15",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:24",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "12:25",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "12:31",
					"arrivesAt": "12:34",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "12:35",
					"arrivesAt": "12:40",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:47",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Apahida h.",
					"to": "Apahida",
					"leavesAt": "12:48",
					"arrivesAt": "12:53",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "12:54",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "12:58",
					"arrivesAt": "13:06",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "13:07",
					"arrivesAt": "13:12",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "13:13",
					"arrivesAt": "13:18",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180105",
					"daysOfWeek": 383
				},
				{
					"from": "20180108",
					"to": "20180112",
					"daysOfWeek": 383
				},
				{
					"from": "20180205",
					"to": "20180209",
					"daysOfWeek": 383
				},
				{
					"from": "20180402",
					"to": "20180406",
					"daysOfWeek": 383
				},
				{
					"from": "20180410",
					"to": "20180410",
					"daysOfWeek": 383
				},
				{
					"from": "20180618",
					"to": "20180622",
					"daysOfWeek": 383
				},
				{
					"from": "20180625",
					"to": "20180629",
					"daysOfWeek": 383
				},
				{
					"from": "20180702",
					"to": "20180706",
					"daysOfWeek": 383
				},
				{
					"from": "20180709",
					"to": "20180713",
					"daysOfWeek": 383
				},
				{
					"from": "20180716",
					"to": "20180720",
					"daysOfWeek": 383
				},
				{
					"from": "20180723",
					"to": "20180727",
					"daysOfWeek": 383
				},
				{
					"from": "20180730",
					"to": "20180803",
					"daysOfWeek": 383
				},
				{
					"from": "20180806",
					"to": "20180810",
					"daysOfWeek": 383
				},
				{
					"from": "20180813",
					"to": "20180814",
					"daysOfWeek": 383
				},
				{
					"from": "20180816",
					"to": "20180817",
					"daysOfWeek": 383
				},
				{
					"from": "20180820",
					"to": "20180824",
					"daysOfWeek": 383
				},
				{
					"from": "20180827",
					"to": "20180831",
					"daysOfWeek": 383
				},
				{
					"from": "20180903",
					"to": "20180907",
					"daysOfWeek": 383
				},
				{
					"from": "20171227",
					"to": "20171229",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9168",
			"segments": [
				{
					"from": "Reşiţa Sud Hm.",
					"to": "Reşiţa Nord",
					"leavesAt": "17:58",
					"arrivesAt": "18:07",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Reşiţa Nord",
					"to": "Bănila Câlnic h.",
					"leavesAt": "18:08",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Ezeriş h.",
					"leavesAt": "18:17",
					"arrivesAt": "18:24",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Ezeriş h.",
					"to": "Brebu",
					"leavesAt": "18:25",
					"arrivesAt": "18:37",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Brebu",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "18:47",
					"arrivesAt": "18:59",
					"waitsAtSource": 600,
					"distance": 10500
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Valea Păltinişului h.",
					"leavesAt": "19:00",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Caransebeş",
					"leavesAt": "19:08",
					"arrivesAt": "19:14",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2235",
			"segments": [
				{
					"from": "Radna",
					"to": "Neudorf h.",
					"leavesAt": "14:15",
					"arrivesAt": "14:22",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Neudorf h.",
					"to": "Zăbrani Hm.",
					"leavesAt": "14:23",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zăbrani Hm.",
					"to": "Aliuş hcv.",
					"leavesAt": "14:30",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Aliuş hcv.",
					"to": "Gomila h.",
					"leavesAt": "14:42",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Gomila h.",
					"to": "Şarlota h.",
					"leavesAt": "14:51",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Şarlota h.",
					"to": "Remetea Mică",
					"leavesAt": "14:57",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180525",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				},
				{
					"from": "20181228",
					"to": "20181229",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1818",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Buziaş",
					"leavesAt": "06:27",
					"arrivesAt": "07:04",
					"waitsAtSource": 0,
					"distance": 36400
				},
				{
					"from": "Buziaş",
					"to": "Lugoj",
					"leavesAt": "07:06",
					"arrivesAt": "07:37",
					"waitsAtSource": 120,
					"distance": 27500
				},
				{
					"from": "Lugoj",
					"to": "Făget",
					"leavesAt": "07:39",
					"arrivesAt": "08:20",
					"waitsAtSource": 120,
					"distance": 39700
				},
				{
					"from": "Făget",
					"to": "Margina",
					"leavesAt": "08:33",
					"arrivesAt": "08:46",
					"waitsAtSource": 780,
					"distance": 7600
				},
				{
					"from": "Margina",
					"to": "Ilia",
					"leavesAt": "08:48",
					"arrivesAt": "09:28",
					"waitsAtSource": 120,
					"distance": 35500
				},
				{
					"from": "Ilia",
					"to": "Deva",
					"leavesAt": "09:29",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 23600
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "09:58",
					"arrivesAt": "10:09",
					"waitsAtSource": 120,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Orăştie",
					"leavesAt": "10:12",
					"arrivesAt": "10:33",
					"waitsAtSource": 180,
					"distance": 16500
				},
				{
					"from": "Orăştie",
					"to": "Şibot",
					"leavesAt": "10:45",
					"arrivesAt": "11:00",
					"waitsAtSource": 720,
					"distance": 12300
				},
				{
					"from": "Şibot",
					"to": "Vinţu de Jos",
					"leavesAt": "11:01",
					"arrivesAt": "11:23",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "11:24",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Teiuş",
					"leavesAt": "11:36",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "12:15",
					"arrivesAt": "12:27",
					"waitsAtSource": 240,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Unirea hc.",
					"leavesAt": "12:28",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "12:44",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Luduş",
					"leavesAt": "12:52",
					"arrivesAt": "13:10",
					"waitsAtSource": 60,
					"distance": 19200
				},
				{
					"from": "Luduş",
					"to": "Iernut",
					"leavesAt": "13:11",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Iernut",
					"to": "Târgu Mureş",
					"leavesAt": "13:26",
					"arrivesAt": "13:55",
					"waitsAtSource": 60,
					"distance": 28600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1667",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "22:55",
					"arrivesAt": "23:44",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "23:46",
					"arrivesAt": "00:20",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "00:21",
					"arrivesAt": "00:58",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "01:00",
					"arrivesAt": "01:31",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "01:33",
					"arrivesAt": "02:11",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Tecuci",
					"leavesAt": "02:13",
					"arrivesAt": "02:56",
					"waitsAtSource": 120,
					"distance": 36500
				},
				{
					"from": "Tecuci",
					"to": "Bârlad",
					"leavesAt": "03:08",
					"arrivesAt": "03:51",
					"waitsAtSource": 720,
					"distance": 50300
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "03:52",
					"arrivesAt": "04:21",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "04:22",
					"arrivesAt": "04:36",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "04:38",
					"arrivesAt": "04:56",
					"waitsAtSource": 120,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "04:57",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "05:24",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "05:40",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1695",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "21:20",
					"arrivesAt": "22:13",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "22:14",
					"arrivesAt": "22:59",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Caracal",
					"leavesAt": "23:01",
					"arrivesAt": "23:49",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "23:50",
					"arrivesAt": "00:30",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "00:40",
					"arrivesAt": "01:06",
					"waitsAtSource": 600,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Strehaia hc.",
					"leavesAt": "01:07",
					"arrivesAt": "01:31",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Strehaia hc.",
					"to": "Balota",
					"leavesAt": "01:32",
					"arrivesAt": "02:10",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Balota",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "02:11",
					"arrivesAt": "02:44",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Orşova",
					"leavesAt": "02:48",
					"arrivesAt": "03:19",
					"waitsAtSource": 240,
					"distance": 24000
				},
				{
					"from": "Orşova",
					"to": "Băile Herculane",
					"leavesAt": "03:20",
					"arrivesAt": "03:40",
					"waitsAtSource": 60,
					"distance": 17500
				},
				{
					"from": "Băile Herculane",
					"to": "Caransebeş",
					"leavesAt": "03:42",
					"arrivesAt": "05:05",
					"waitsAtSource": 120,
					"distance": 70800
				},
				{
					"from": "Caransebeş",
					"to": "Lugoj",
					"leavesAt": "05:16",
					"arrivesAt": "05:50",
					"waitsAtSource": 660,
					"distance": 39400
				},
				{
					"from": "Lugoj",
					"to": "Belinţ Hm.",
					"leavesAt": "05:52",
					"arrivesAt": "06:02",
					"waitsAtSource": 120,
					"distance": 13200
				},
				{
					"from": "Belinţ Hm.",
					"to": "Timişoara Nord",
					"leavesAt": "06:06",
					"arrivesAt": "06:52",
					"waitsAtSource": 240,
					"distance": 45700
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180427",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1781",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "07:30",
					"arrivesAt": "08:30",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "08:36",
					"arrivesAt": "08:55",
					"waitsAtSource": 360,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "08:56",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "09:19",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1831",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Barboşi",
					"leavesAt": "05:56",
					"arrivesAt": "06:21",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Barboşi",
					"to": "Lieşti",
					"leavesAt": "06:24",
					"arrivesAt": "07:11",
					"waitsAtSource": 180,
					"distance": 48300
				},
				{
					"from": "Lieşti",
					"to": "Tecuci",
					"leavesAt": "07:12",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 24400
				},
				{
					"from": "Tecuci",
					"to": "Bârlad",
					"leavesAt": "07:44",
					"arrivesAt": "08:27",
					"waitsAtSource": 120,
					"distance": 50300
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "08:28",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "08:58",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "09:14",
					"arrivesAt": "09:32",
					"waitsAtSource": 120,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "09:33",
					"arrivesAt": "09:59",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "10:00",
					"arrivesAt": "10:15",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "10:17",
					"arrivesAt": "10:24",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Iaşi",
					"to": "Târgu Frumos",
					"leavesAt": "10:49",
					"arrivesAt": "11:25",
					"waitsAtSource": 1500,
					"distance": 44900
				},
				{
					"from": "Târgu Frumos",
					"to": "Paşcani",
					"leavesAt": "11:26",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 30800
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "11:55",
					"arrivesAt": "12:15",
					"waitsAtSource": 120,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "12:16",
					"arrivesAt": "12:32",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "12:34",
					"arrivesAt": "12:46",
					"waitsAtSource": 120,
					"distance": 14800
				},
				{
					"from": "Suceava",
					"to": "Gura Humorului Oraş",
					"leavesAt": "13:03",
					"arrivesAt": "13:49",
					"waitsAtSource": 1020,
					"distance": 46800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "13:50",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Vama",
					"leavesAt": "13:59",
					"arrivesAt": "14:09",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vama",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "14:10",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "14:27",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Sadova Hm.",
					"leavesAt": "14:35",
					"arrivesAt": "14:41",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Sadova Hm.",
					"to": "Pojorâta Hm.",
					"leavesAt": "14:46",
					"arrivesAt": "14:52",
					"waitsAtSource": 300,
					"distance": 3000
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Mestecăniş",
					"leavesAt": "14:53",
					"arrivesAt": "15:14",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Mestecăniş",
					"to": "Vatra Dornei",
					"leavesAt": "15:15",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Vatra Dornei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "15:41",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Floreni",
					"leavesAt": "15:45",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Floreni",
					"to": "Lunca Ilvei",
					"leavesAt": "16:01",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 31900
				},
				{
					"from": "Lunca Ilvei",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 14300
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Ilva Mică",
					"leavesAt": "17:02",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 17300
				},
				{
					"from": "Ilva Mică",
					"to": "Năsăud",
					"leavesAt": "17:28",
					"arrivesAt": "17:49",
					"waitsAtSource": 300,
					"distance": 19800
				},
				{
					"from": "Năsăud",
					"to": "Salva",
					"leavesAt": "17:52",
					"arrivesAt": "17:59",
					"waitsAtSource": 180,
					"distance": 6300
				},
				{
					"from": "Salva",
					"to": "Beclean pe Someş",
					"leavesAt": "18:01",
					"arrivesAt": "18:23",
					"waitsAtSource": 120,
					"distance": 21600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Dej Triaj",
					"leavesAt": "18:25",
					"arrivesAt": "18:53",
					"waitsAtSource": 120,
					"distance": 21900
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "18:54",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "19:06",
					"arrivesAt": "19:25",
					"waitsAtSource": 300,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Cluj Napoca",
					"leavesAt": "19:27",
					"arrivesAt": "20:19",
					"waitsAtSource": 120,
					"distance": 44900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2873",
			"segments": [
				{
					"from": "Turceni",
					"to": "Gârbovu h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:37",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Gârbovu h.",
					"to": "Sărdăneşti h.",
					"leavesAt": "14:38",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Plopşoru",
					"leavesAt": "14:44",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Plopşoru",
					"to": "Peşteana Jiu h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Bâlteni h.",
					"leavesAt": "14:58",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Bâlteni h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Roşia Jiu h.",
					"leavesAt": "15:07",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Roşia Jiu h.",
					"to": "Rovinari Sud h.",
					"leavesAt": "15:12",
					"arrivesAt": "15:14",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Rovinari Hm.",
					"leavesAt": "15:15",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rovinari Hm.",
					"to": "Km. 49+800 h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:29",
					"waitsAtSource": 480,
					"distance": 1000
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rogojelu",
					"leavesAt": "15:30",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Rogojelu",
					"to": "Vârţ h.",
					"leavesAt": "15:34",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Vârţ h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "15:38",
					"arrivesAt": "15:44",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Drăguţeşti h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Amaradia",
					"leavesAt": "15:50",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Amaradia",
					"to": "Târgu Jiu",
					"leavesAt": "15:55",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20180526",
					"daysOfWeek": 383
				},
				{
					"from": "20180528",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1582",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Bucureşti Nord",
					"leavesAt": "13:00",
					"arrivesAt": "15:02",
					"waitsAtSource": 0,
					"distance": 225000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9005",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:07",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureştii Noi",
					"leavesAt": "17:08",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Bucureştii Noi",
					"to": "Chiajna",
					"leavesAt": "17:16",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiajna",
					"to": "Domneştii de Sus h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:36",
					"waitsAtSource": 360,
					"distance": 10500
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Grădinari",
					"leavesAt": "17:37",
					"arrivesAt": "17:47",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Grădinari",
					"to": "Vadu Lat Hm.",
					"leavesAt": "17:55",
					"arrivesAt": "18:08",
					"waitsAtSource": 480,
					"distance": 10800
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "18:09",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Zăvestreni Hm.",
					"leavesAt": "18:15",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Videle",
					"leavesAt": "18:21",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Videle",
					"to": "Ciolpani Hm.",
					"leavesAt": "18:39",
					"arrivesAt": "18:46",
					"waitsAtSource": 600,
					"distance": 7700
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Gălăteni Hm.",
					"leavesAt": "18:47",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Olteni",
					"leavesAt": "18:56",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Olteni",
					"to": "Vârtoapele hc.",
					"leavesAt": "19:03",
					"arrivesAt": "19:10",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "19:11",
					"arrivesAt": "19:16",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Atârnaţi Hm.",
					"leavesAt": "19:17",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "19:28",
					"arrivesAt": "19:40",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Roşiori Nord",
					"to": "Mihăeşti Hm.",
					"leavesAt": "19:42",
					"arrivesAt": "19:56",
					"waitsAtSource": 120,
					"distance": 17300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Radomireşti Hm.",
					"leavesAt": "19:57",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Dăneasa h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Dăneasa h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "20:14",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Stoeneşti h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Stoeneşti h.",
					"to": "Fărcaşele Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Caracal",
					"leavesAt": "20:31",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Caracal",
					"to": "Cezieni h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Cezieni h.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "20:48",
					"arrivesAt": "20:54",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Radomiru hc.",
					"leavesAt": "20:55",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Radomiru hc.",
					"to": "Jianca",
					"leavesAt": "21:01",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Jianca",
					"to": "Ţărţăl h.",
					"leavesAt": "21:05",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţărţăl h.",
					"to": "Leu Hm.",
					"leavesAt": "21:09",
					"arrivesAt": "21:14",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Leu Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "21:15",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "21:24",
					"arrivesAt": "21:29",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "21:30",
					"arrivesAt": "21:34",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Bordei hc.(900)",
					"leavesAt": "21:35",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Craiova",
					"leavesAt": "21:39",
					"arrivesAt": "21:44",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4580",
			"segments": [
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "05:02",
					"arrivesAt": "05:09",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:20",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:24",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "05:25",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "05:41",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8806",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "11:10",
					"arrivesAt": "11:18",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "11:26",
					"arrivesAt": "11:30",
					"waitsAtSource": 480,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "11:31",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "11:42",
					"arrivesAt": "11:45",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "11:46",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "11:54",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "12:03",
					"arrivesAt": "12:09",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "12:10",
					"arrivesAt": "12:35",
					"waitsAtSource": 60,
					"distance": 14000
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1798",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Remetea Mare",
					"leavesAt": "13:52",
					"arrivesAt": "14:11",
					"waitsAtSource": 0,
					"distance": 13300
				},
				{
					"from": "Remetea Mare",
					"to": "Lugoj",
					"leavesAt": "14:15",
					"arrivesAt": "14:50",
					"waitsAtSource": 240,
					"distance": 45600
				},
				{
					"from": "Lugoj",
					"to": "Caransebeş",
					"leavesAt": "14:52",
					"arrivesAt": "15:26",
					"waitsAtSource": 120,
					"distance": 39400
				},
				{
					"from": "Caransebeş",
					"to": "Băile Herculane",
					"leavesAt": "15:28",
					"arrivesAt": "16:51",
					"waitsAtSource": 120,
					"distance": 70800
				},
				{
					"from": "Băile Herculane",
					"to": "Valea Cernei Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "17:08",
					"waitsAtSource": 120,
					"distance": 11800
				},
				{
					"from": "Valea Cernei Hm.",
					"to": "Orşova",
					"leavesAt": "17:12",
					"arrivesAt": "17:19",
					"waitsAtSource": 240,
					"distance": 5700
				},
				{
					"from": "Orşova",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "17:20",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Balota",
					"leavesAt": "17:54",
					"arrivesAt": "18:27",
					"waitsAtSource": 120,
					"distance": 19000
				},
				{
					"from": "Balota",
					"to": "Strehaia hc.",
					"leavesAt": "18:28",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Strehaia hc.",
					"to": "Filiaşi",
					"leavesAt": "19:00",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "19:28",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "20:00",
					"arrivesAt": "20:39",
					"waitsAtSource": 480,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Roşiori Nord",
					"leavesAt": "20:40",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 55300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "21:26",
					"arrivesAt": "22:10",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "22:11",
					"arrivesAt": "23:02",
					"waitsAtSource": 60,
					"distance": 50900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9135",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(913)",
					"leavesAt": "14:18",
					"arrivesAt": "14:21",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(913)",
					"to": "Jiu Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:27",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Jiu Hm.",
					"to": "Podari",
					"leavesAt": "14:28",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Podari",
					"to": "Sălcuţa Hm.",
					"leavesAt": "14:39",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Sălcuţa Hm.",
					"to": "Dealul Robului h.",
					"leavesAt": "14:55",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dealul Robului h.",
					"to": "Segarcea Nord hc.",
					"leavesAt": "15:01",
					"arrivesAt": "15:08",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Segarcea Nord hc.",
					"to": "Segarcea",
					"leavesAt": "15:09",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Segarcea",
					"to": "Cerăt h.",
					"leavesAt": "15:21",
					"arrivesAt": "15:27",
					"waitsAtSource": 540,
					"distance": 3200
				},
				{
					"from": "Cerăt h.",
					"to": "Portăreşti Hm.",
					"leavesAt": "15:28",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Portăreşti Hm.",
					"to": "Urzica Mare h.",
					"leavesAt": "15:38",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Urzica Mare h.",
					"to": "Afumaţi h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:56",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Afumaţi h.",
					"to": "Siliştea Crucii h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Siliştea Crucii h.",
					"to": "Boureni P.M.",
					"leavesAt": "16:06",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Boureni P.M.",
					"to": "Băileşti",
					"leavesAt": "16:11",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1968",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Iaşi",
					"leavesAt": "03:45",
					"arrivesAt": "04:52",
					"waitsAtSource": 0,
					"distance": 75700
				}
			],
			"restrictions": [
				{
					"from": "20181012",
					"to": "20181015",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9485",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Brăneţ h.",
					"leavesAt": "13:45",
					"arrivesAt": "13:53",
					"waitsAtSource": 0,
					"distance": 7700
				},
				{
					"from": "Brăneţ h.",
					"to": "Balş",
					"leavesAt": "13:54",
					"arrivesAt": "14:00",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Balş",
					"to": "Spineni h.",
					"leavesAt": "14:01",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Spineni h.",
					"to": "Robăneşti Hm.",
					"leavesAt": "14:06",
					"arrivesAt": "14:14",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Robăneşti Hm.",
					"to": "Toporaş h.",
					"leavesAt": "14:15",
					"arrivesAt": "14:20",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Toporaş h.",
					"to": "Pieleşti Hm.",
					"leavesAt": "14:21",
					"arrivesAt": "14:24",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Pieleşti Hm.",
					"to": "Cârcea h.",
					"leavesAt": "14:25",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Cârcea h.",
					"to": "Plaiu Vulcăneşti Hm.",
					"leavesAt": "14:33",
					"arrivesAt": "14:39",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Plaiu Vulcăneşti Hm.",
					"to": "Bordei hc.(901)",
					"leavesAt": "14:40",
					"arrivesAt": "14:44",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Craiova",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6412",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "15:47",
					"arrivesAt": "15:54",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Ciurea Hm.",
					"leavesAt": "15:56",
					"arrivesAt": "16:03",
					"waitsAtSource": 120,
					"distance": 6400
				},
				{
					"from": "Ciurea Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Bârnova Hm.",
					"leavesAt": "16:14",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Grajduri",
					"leavesAt": "16:24",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Grajduri",
					"to": "Scânteia Hm.",
					"leavesAt": "16:32",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Scânteia Hm.",
					"to": "Rebricea Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Rebricea Hm.",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "16:47",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Buhăieşti",
					"leavesAt": "16:53",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Buhăieşti",
					"to": "Bârzeşti h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bârzeşti h.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bălteni Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bălteni Hm.",
					"to": "Vaslui",
					"leavesAt": "17:17",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 9800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9613",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Boldur h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:54",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Boldur h.",
					"to": "Sinia Hm.",
					"leavesAt": "07:55",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sinia Hm.",
					"to": "Căpăt h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Căpăt h.",
					"to": "Buziaş",
					"leavesAt": "08:07",
					"arrivesAt": "08:18",
					"waitsAtSource": 30,
					"distance": 7300
				},
				{
					"from": "Buziaş",
					"to": "Bacova h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Bacova h.",
					"to": "Chevereş h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:26",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Chevereş h.",
					"to": "Sacoşu Mic",
					"leavesAt": "08:27",
					"arrivesAt": "08:32",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Sacoşu Mic",
					"to": "Uliuc h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Uliuc h.",
					"to": "Urseni h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Urseni h.",
					"to": "Semenic Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Semenic Hm.",
					"to": "Giroc h.",
					"leavesAt": "08:50",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Giroc h.",
					"to": "Timişoara Sud",
					"leavesAt": "08:54",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "09:01",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9351",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "04:25",
					"arrivesAt": "05:16",
					"waitsAtSource": 0,
					"distance": 50900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5631",
			"segments": [
				{
					"from": "Dărmăneşti",
					"to": "Milişăuţi Hm.",
					"leavesAt": "05:58",
					"arrivesAt": "06:09",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Ţibeni h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ţibeni h.",
					"to": "Dorneşti",
					"leavesAt": "06:19",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1995",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "16:05",
					"arrivesAt": "16:12",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "16:13",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "16:21",
					"arrivesAt": "16:34",
					"waitsAtSource": 180,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 180,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "16:44",
					"arrivesAt": "16:59",
					"waitsAtSource": 180,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "17:07",
					"arrivesAt": "17:14",
					"waitsAtSource": 480,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "17:15",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 14000
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "18:05",
					"arrivesAt": "18:32",
					"waitsAtSource": 1560,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "18:33",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "18:54",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "19:16",
					"arrivesAt": "19:42",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "19:43",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 108900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "21:20",
					"arrivesAt": "22:13",
					"waitsAtSource": 1680,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "22:14",
					"arrivesAt": "22:59",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Caracal",
					"leavesAt": "23:01",
					"arrivesAt": "23:49",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "23:50",
					"arrivesAt": "00:30",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "00:40",
					"arrivesAt": "01:06",
					"waitsAtSource": 600,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Strehaia hc.",
					"leavesAt": "01:07",
					"arrivesAt": "01:31",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Strehaia hc.",
					"to": "Balota",
					"leavesAt": "01:32",
					"arrivesAt": "02:10",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Balota",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "02:11",
					"arrivesAt": "02:44",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Orşova",
					"leavesAt": "02:48",
					"arrivesAt": "03:19",
					"waitsAtSource": 240,
					"distance": 24000
				},
				{
					"from": "Orşova",
					"to": "Băile Herculane",
					"leavesAt": "03:20",
					"arrivesAt": "03:40",
					"waitsAtSource": 60,
					"distance": 17500
				},
				{
					"from": "Băile Herculane",
					"to": "Caransebeş",
					"leavesAt": "03:42",
					"arrivesAt": "05:05",
					"waitsAtSource": 120,
					"distance": 70800
				},
				{
					"from": "Caransebeş",
					"to": "Lugoj",
					"leavesAt": "05:16",
					"arrivesAt": "05:50",
					"waitsAtSource": 660,
					"distance": 39400
				},
				{
					"from": "Lugoj",
					"to": "Belinţ Hm.",
					"leavesAt": "05:52",
					"arrivesAt": "06:02",
					"waitsAtSource": 120,
					"distance": 13200
				},
				{
					"from": "Belinţ Hm.",
					"to": "Timişoara Nord",
					"leavesAt": "06:06",
					"arrivesAt": "06:52",
					"waitsAtSource": 240,
					"distance": 45700
				}
			],
			"restrictions": [
				{
					"from": "20180428",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180528",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8375",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "18:39",
					"arrivesAt": "18:51",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "18:59",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "19:15",
					"arrivesAt": "19:21",
					"waitsAtSource": 480,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "19:22",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "19:30",
					"arrivesAt": "19:38",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "19:39",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "19:44",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "19:55",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "20:00",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180529",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1749",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Iernut",
					"leavesAt": "11:46",
					"arrivesAt": "12:12",
					"waitsAtSource": 0,
					"distance": 28600
				},
				{
					"from": "Iernut",
					"to": "Luduş",
					"leavesAt": "12:13",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Luduş",
					"to": "Războieni",
					"leavesAt": "12:28",
					"arrivesAt": "12:46",
					"waitsAtSource": 60,
					"distance": 19200
				},
				{
					"from": "Războieni",
					"to": "Câmpia Turzii",
					"leavesAt": "12:56",
					"arrivesAt": "13:11",
					"waitsAtSource": 600,
					"distance": 17100
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cluj Napoca",
					"leavesAt": "13:13",
					"arrivesAt": "14:18",
					"waitsAtSource": 120,
					"distance": 51500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5207",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "14:28",
					"arrivesAt": "14:34",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "14:35",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "14:39",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:48",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "14:49",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Urecheşti Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:12",
					"waitsAtSource": 120,
					"distance": 9700
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "15:13",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Bâlca hc.",
					"leavesAt": "15:17",
					"arrivesAt": "15:21",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Bâlca hc.",
					"to": "Căiuţi Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:27",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Borzeşti Bacău",
					"leavesAt": "15:28",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:42",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Oneşti",
					"leavesAt": "15:43",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Oneşti",
					"to": "Viişoara h",
					"leavesAt": "15:51",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Viişoara h",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "16:03",
					"arrivesAt": "16:08",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Saline hc.",
					"leavesAt": "16:09",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Saline hc.",
					"to": "Cireşoaia h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cireşoaia h.",
					"to": "Dofteana Bacău",
					"leavesAt": "16:19",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dofteana Bacău",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "16:25",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Valea Uzului Hm.",
					"leavesAt": "16:30",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Comăneşti",
					"leavesAt": "16:36",
					"arrivesAt": "16:44",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Comăneşti",
					"to": "Asău Hm.",
					"leavesAt": "16:45",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Asău Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Caraliţa h.",
					"to": "Goioasa Hm.",
					"leavesAt": "16:57",
					"arrivesAt": "17:02",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Goioasa Hm.",
					"to": "Simbrea Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Simbrea Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "17:16",
					"arrivesAt": "17:22",
					"waitsAtSource": 360,
					"distance": 4300
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Palanca Hm.",
					"leavesAt": "17:23",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Palanca Hm.",
					"to": "Ghimeş",
					"leavesAt": "17:29",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Ghimeş",
					"to": "Bolovăniş h.",
					"leavesAt": "17:40",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "17:52",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Tarcău h.",
					"leavesAt": "17:53",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "17:58",
					"arrivesAt": "18:03",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Utuşoiu h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Utuşoiu h.",
					"to": "Livezi Ciuc",
					"leavesAt": "18:10",
					"arrivesAt": "18:16",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Caracău h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:22",
					"waitsAtSource": 180,
					"distance": 2100
				},
				{
					"from": "Caracău h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "18:23",
					"arrivesAt": "18:30",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "18:31",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Mihăileni Hm.",
					"leavesAt": "18:36",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Siculeni",
					"leavesAt": "18:41",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "18:48",
					"arrivesAt": "18:56",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4342",
			"segments": [
				{
					"from": "Valea lui Mihai",
					"to": "Simion h.",
					"leavesAt": "13:20",
					"arrivesAt": "13:26",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Simion h.",
					"to": "Şilindru Hm.",
					"leavesAt": "13:27",
					"arrivesAt": "13:33",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Şilindru Hm.",
					"to": "Săcuieni Bihor",
					"leavesAt": "13:34",
					"arrivesAt": "13:43",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Cadia h.",
					"leavesAt": "13:44",
					"arrivesAt": "13:51",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cadia h.",
					"to": "Diosig Hm.",
					"leavesAt": "13:52",
					"arrivesAt": "13:58",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Diosig Hm.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "13:59",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Tămăşeu h.",
					"leavesAt": "14:06",
					"arrivesAt": "14:13",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tămăşeu h.",
					"to": "Biharia Hm.",
					"leavesAt": "14:14",
					"arrivesAt": "14:22",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Biharia Hm.",
					"to": "Episcopia Bihor",
					"leavesAt": "14:23",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "14:34",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9588",
			"segments": [
				{
					"from": "Jimbolia",
					"to": "Clarii Vii h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:21",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Clarii Vii h.",
					"to": "Cărpiniş",
					"leavesAt": "09:22",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Cărpiniş",
					"to": "Beregsău hcv.",
					"leavesAt": "09:31",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Beregsău hcv.",
					"to": "Săcălaz h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:46",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Săcălaz h.",
					"to": "Timişoara Nord",
					"leavesAt": "09:47",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1723",
			"segments": [
				{
					"from": "Caracal",
					"to": "Romula Hm.",
					"leavesAt": "18:16",
					"arrivesAt": "18:27",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Romula Hm.",
					"to": "Fălcoiu h.",
					"leavesAt": "18:28",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Fălcoiu h.",
					"to": "Vlăduleni",
					"leavesAt": "18:35",
					"arrivesAt": "18:42",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Vlăduleni",
					"to": "Şopârliţa hc.",
					"leavesAt": "18:43",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Piatra Olt",
					"leavesAt": "18:47",
					"arrivesAt": "18:59",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Piatra Olt",
					"to": "Drăgăşani",
					"leavesAt": "19:00",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 33800
				},
				{
					"from": "Drăgăşani",
					"to": "Băbeni",
					"leavesAt": "19:28",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 33200
				},
				{
					"from": "Băbeni",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "20:02",
					"arrivesAt": "20:23",
					"waitsAtSource": 480,
					"distance": 19600
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Călimăneşti",
					"leavesAt": "20:35",
					"arrivesAt": "20:52",
					"waitsAtSource": 720,
					"distance": 16200
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Lotru",
					"leavesAt": "20:59",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Lotru",
					"to": "Câineni",
					"leavesAt": "21:26",
					"arrivesAt": "21:49",
					"waitsAtSource": 540,
					"distance": 21100
				},
				{
					"from": "Câineni",
					"to": "Turnu Roşu hc.",
					"leavesAt": "21:50",
					"arrivesAt": "22:19",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "22:20",
					"arrivesAt": "22:30",
					"waitsAtSource": 30,
					"distance": 7300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Sibiu",
					"leavesAt": "22:31",
					"arrivesAt": "22:50",
					"waitsAtSource": 60,
					"distance": 17800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9383",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Măldăeni Hm.",
					"leavesAt": "05:40",
					"arrivesAt": "05:47",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Măldăeni Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Radomireşti Hm.",
					"leavesAt": "05:57",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Dăneasa h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Dăneasa h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "06:15",
					"arrivesAt": "06:19",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Stoeneşti h.",
					"leavesAt": "06:20",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Stoeneşti h.",
					"to": "Fărcaşele Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Caracal",
					"leavesAt": "06:33",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Caracal",
					"to": "Cezieni h.",
					"leavesAt": "06:44",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Cezieni h.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "06:50",
					"arrivesAt": "06:56",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Radomiru hc.",
					"leavesAt": "06:57",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Radomiru hc.",
					"to": "Jianca",
					"leavesAt": "07:03",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jianca",
					"to": "Ţărţăl h.",
					"leavesAt": "07:07",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţărţăl h.",
					"to": "Leu Hm.",
					"leavesAt": "07:11",
					"arrivesAt": "07:16",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Leu Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "07:17",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Malu Mare Hm.",
					"leavesAt": "07:26",
					"arrivesAt": "07:29",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Malu Mare Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "07:33",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Bordei hc.(900)",
					"leavesAt": "07:38",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Craiova",
					"leavesAt": "07:42",
					"arrivesAt": "07:47",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5609",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "16:40",
					"arrivesAt": "16:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "16:55",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "17:03",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "17:10",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "17:18",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "17:28",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "17:35",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "17:50",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:15",
					"waitsAtSource": 360,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "18:16",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "18:27",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "18:33",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "18:46",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "18:53",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "19:00",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "19:07",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "19:14",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "19:23",
					"arrivesAt": "19:29",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9610",
			"segments": [
				{
					"from": "Buziaş",
					"to": "Căpăt h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:25",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Căpăt h.",
					"to": "Sinia Hm.",
					"leavesAt": "05:26",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Sinia Hm.",
					"to": "Boldur h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Boldur h.",
					"to": "Lugoj",
					"leavesAt": "05:40",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9109",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Depoul Buc.Triaj h.(300)",
					"leavesAt": "14:07",
					"arrivesAt": "14:15",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Depoul Buc.Triaj h.(300)",
					"to": "Chitila",
					"leavesAt": "14:16",
					"arrivesAt": "14:19",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "14:20",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "14:54",
					"arrivesAt": "15:03",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "15:13",
					"arrivesAt": "15:17",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "15:18",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "15:36",
					"arrivesAt": "15:40",
					"waitsAtSource": 660,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Podu Rizii h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Podu Rizii h.",
					"to": "Băneşti h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "15:55",
					"arrivesAt": "15:59",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "16:00",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "16:10",
					"arrivesAt": "16:18",
					"waitsAtSource": 30,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8691",
			"segments": [
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:25",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "05:26",
					"arrivesAt": "05:30",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "05:46",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "05:52",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "05:58",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180106",
					"daysOfWeek": 383
				},
				{
					"from": "20180108",
					"to": "20180113",
					"daysOfWeek": 383
				},
				{
					"from": "20180115",
					"to": "20180120",
					"daysOfWeek": 383
				},
				{
					"from": "20180122",
					"to": "20180123",
					"daysOfWeek": 383
				},
				{
					"from": "20180125",
					"to": "20180127",
					"daysOfWeek": 383
				},
				{
					"from": "20180129",
					"to": "20180203",
					"daysOfWeek": 383
				},
				{
					"from": "20180205",
					"to": "20180210",
					"daysOfWeek": 383
				},
				{
					"from": "20180212",
					"to": "20180217",
					"daysOfWeek": 383
				},
				{
					"from": "20180219",
					"to": "20180224",
					"daysOfWeek": 383
				},
				{
					"from": "20180226",
					"to": "20180303",
					"daysOfWeek": 383
				},
				{
					"from": "20180305",
					"to": "20180310",
					"daysOfWeek": 383
				},
				{
					"from": "20180312",
					"to": "20180317",
					"daysOfWeek": 383
				},
				{
					"from": "20180319",
					"to": "20180324",
					"daysOfWeek": 383
				},
				{
					"from": "20180326",
					"to": "20180331",
					"daysOfWeek": 383
				},
				{
					"from": "20180402",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180410",
					"to": "20180414",
					"daysOfWeek": 383
				},
				{
					"from": "20180416",
					"to": "20180421",
					"daysOfWeek": 383
				},
				{
					"from": "20180423",
					"to": "20180426",
					"daysOfWeek": 383
				},
				{
					"from": "20180502",
					"to": "20180505",
					"daysOfWeek": 383
				},
				{
					"from": "20180507",
					"to": "20180512",
					"daysOfWeek": 383
				},
				{
					"from": "20180514",
					"to": "20180519",
					"daysOfWeek": 383
				},
				{
					"from": "20180521",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180531",
					"daysOfWeek": 383
				},
				{
					"from": "20180602",
					"to": "20180602",
					"daysOfWeek": 383
				},
				{
					"from": "20180604",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20180915",
					"daysOfWeek": 383
				},
				{
					"from": "20180917",
					"to": "20180922",
					"daysOfWeek": 383
				},
				{
					"from": "20180924",
					"to": "20180929",
					"daysOfWeek": 383
				},
				{
					"from": "20181001",
					"to": "20181006",
					"daysOfWeek": 383
				},
				{
					"from": "20181008",
					"to": "20181013",
					"daysOfWeek": 383
				},
				{
					"from": "20181015",
					"to": "20181020",
					"daysOfWeek": 383
				},
				{
					"from": "20181022",
					"to": "20181027",
					"daysOfWeek": 383
				},
				{
					"from": "20181029",
					"to": "20181103",
					"daysOfWeek": 383
				},
				{
					"from": "20181105",
					"to": "20181110",
					"daysOfWeek": 383
				},
				{
					"from": "20181112",
					"to": "20181117",
					"daysOfWeek": 383
				},
				{
					"from": "20181119",
					"to": "20181124",
					"daysOfWeek": 383
				},
				{
					"from": "20181126",
					"to": "20181129",
					"daysOfWeek": 383
				},
				{
					"from": "20181203",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171211",
					"to": "20171216",
					"daysOfWeek": 383
				},
				{
					"from": "20171218",
					"to": "20171223",
					"daysOfWeek": 383
				},
				{
					"from": "20171227",
					"to": "20171230",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4545",
			"segments": [
				{
					"from": "Topliţa",
					"to": "Ciobotani h.",
					"leavesAt": "10:30",
					"arrivesAt": "10:39",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Ciobotani h.",
					"to": "Stânceni Hm.",
					"leavesAt": "10:40",
					"arrivesAt": "10:46",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Stânceni Hm.",
					"to": "Stânceni h.",
					"leavesAt": "10:47",
					"arrivesAt": "10:54",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Stânceni h.",
					"to": "Stânceni Neagra h.",
					"leavesAt": "10:55",
					"arrivesAt": "11:00",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Stânceni Neagra h.",
					"to": "Lunca Bradului Hm.",
					"leavesAt": "11:01",
					"arrivesAt": "11:09",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Lunca Bradului Hm.",
					"to": "Andreneasa h.",
					"leavesAt": "11:10",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Andreneasa h.",
					"to": "Răstoliţa Hm.",
					"leavesAt": "11:21",
					"arrivesAt": "11:30",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Răstoliţa Hm.",
					"to": "Borzia h.",
					"leavesAt": "11:31",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Borzia h.",
					"to": "Deda Bistra Hm.",
					"leavesAt": "11:36",
					"arrivesAt": "11:40",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Deda Bistra Hm.",
					"to": "Deda",
					"leavesAt": "11:41",
					"arrivesAt": "11:50",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Deda",
					"to": "Ruşii Munţi h.",
					"leavesAt": "12:04",
					"arrivesAt": "12:10",
					"waitsAtSource": 840,
					"distance": 4500
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "12:11",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Halta Aluniş h.",
					"leavesAt": "12:15",
					"arrivesAt": "12:19",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "12:20",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Ideciu de Jos h.",
					"leavesAt": "12:24",
					"arrivesAt": "12:29",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Reghin",
					"leavesAt": "12:30",
					"arrivesAt": "12:39",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Reghin",
					"to": "Petelea h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:48",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Petelea h.",
					"to": "Periş Mureş h.",
					"leavesAt": "12:49",
					"arrivesAt": "12:54",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Periş Mureş h.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "12:55",
					"arrivesAt": "13:00",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "13:01",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "13:07",
					"arrivesAt": "13:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Târgu Mureş",
					"leavesAt": "13:20",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4042",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "07:20",
					"arrivesAt": "07:36",
					"waitsAtSource": 0,
					"distance": 14600
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Fersig h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Fersig h.",
					"to": "Mireşu Mare PM.",
					"leavesAt": "07:43",
					"arrivesAt": "07:49",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Ţicău h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:00",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ţicău h.",
					"to": "Benesat Hm.",
					"leavesAt": "08:01",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Benesat Hm.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "08:10",
					"arrivesAt": "08:14",
					"waitsAtSource": 120,
					"distance": 2700
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Inău h.",
					"leavesAt": "08:15",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Inău h.",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "08:20",
					"arrivesAt": "08:25",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Jibou",
					"leavesAt": "08:36",
					"arrivesAt": "08:46",
					"waitsAtSource": 660,
					"distance": 9300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1004",
			"segments": [
				{
					"from": "Ruse",
					"to": "Giurgiu Nord",
					"leavesAt": "00:20",
					"arrivesAt": "00:45",
					"waitsAtSource": 0,
					"distance": 16000
				},
				{
					"from": "Giurgiu Nord",
					"to": "Videle",
					"leavesAt": "01:15",
					"arrivesAt": "02:24",
					"waitsAtSource": 1800,
					"distance": 63000
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "02:25",
					"arrivesAt": "03:19",
					"waitsAtSource": 60,
					"distance": 50900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "03:37",
					"arrivesAt": "04:30",
					"waitsAtSource": 1080,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Buzău",
					"leavesAt": "04:33",
					"arrivesAt": "05:43",
					"waitsAtSource": 180,
					"distance": 68600
				},
				{
					"from": "Buzău",
					"to": "Focşani",
					"leavesAt": "05:46",
					"arrivesAt": "06:56",
					"waitsAtSource": 180,
					"distance": 70800
				},
				{
					"from": "Focşani",
					"to": "Adjud",
					"leavesAt": "06:58",
					"arrivesAt": "07:46",
					"waitsAtSource": 120,
					"distance": 45400
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "07:48",
					"arrivesAt": "08:32",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Paşcani",
					"leavesAt": "08:34",
					"arrivesAt": "09:38",
					"waitsAtSource": 120,
					"distance": 84000
				},
				{
					"from": "Paşcani",
					"to": "Suceava",
					"leavesAt": "09:41",
					"arrivesAt": "10:31",
					"waitsAtSource": 180,
					"distance": 60600
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "10:50",
					"arrivesAt": "10:55",
					"waitsAtSource": 1140,
					"distance": 2500
				},
				{
					"from": "Suceava Nord",
					"to": "Dărmăneşti",
					"leavesAt": "10:56",
					"arrivesAt": "11:06",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dărmăneşti",
					"to": "Milişăuţi Hm.",
					"leavesAt": "11:07",
					"arrivesAt": "11:17",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Dorneşti",
					"leavesAt": "11:18",
					"arrivesAt": "11:32",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Dorneşti",
					"to": "Vicşani",
					"leavesAt": "11:33",
					"arrivesAt": "11:47",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Vicşani",
					"to": "Vadu Siretului",
					"leavesAt": "12:43",
					"arrivesAt": "13:05",
					"waitsAtSource": 3360,
					"distance": 10600
				}
			],
			"restrictions": [
				{
					"from": "20180613",
					"to": "20180613",
					"daysOfWeek": 383
				},
				{
					"from": "20180618",
					"to": "20180618",
					"daysOfWeek": 383
				},
				{
					"from": "20180625",
					"to": "20180625",
					"daysOfWeek": 383
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 383
				},
				{
					"from": "20180707",
					"to": "20180707",
					"daysOfWeek": 383
				},
				{
					"from": "20180712",
					"to": "20180712",
					"daysOfWeek": 383
				},
				{
					"from": "20180719",
					"to": "20180719",
					"daysOfWeek": 383
				},
				{
					"from": "20180724",
					"to": "20180724",
					"daysOfWeek": 383
				},
				{
					"from": "20180731",
					"to": "20180731",
					"daysOfWeek": 383
				},
				{
					"from": "20180805",
					"to": "20180805",
					"daysOfWeek": 383
				},
				{
					"from": "20180812",
					"to": "20180812",
					"daysOfWeek": 383
				},
				{
					"from": "20180817",
					"to": "20180817",
					"daysOfWeek": 383
				},
				{
					"from": "20180824",
					"to": "20180824",
					"daysOfWeek": 383
				},
				{
					"from": "20180829",
					"to": "20180829",
					"daysOfWeek": 383
				},
				{
					"from": "20180905",
					"to": "20180905",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20180910",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9580",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "22:58",
					"arrivesAt": "23:04",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Remetea Mare",
					"leavesAt": "23:05",
					"arrivesAt": "23:19",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Remetea Mare",
					"to": "Izvin h.",
					"leavesAt": "23:20",
					"arrivesAt": "23:27",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Izvin h.",
					"to": "Recaş",
					"leavesAt": "23:28",
					"arrivesAt": "23:31",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Recaş",
					"to": "Şuştra h.",
					"leavesAt": "23:32",
					"arrivesAt": "23:38",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Şuştra h.",
					"to": "Topolovăţ",
					"leavesAt": "23:39",
					"arrivesAt": "23:42",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Topolovăţ",
					"to": "Chizătău Hm.",
					"leavesAt": "23:43",
					"arrivesAt": "23:49",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Chizătău Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "23:50",
					"arrivesAt": "23:54",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Belinţ Hm.",
					"to": "Jabăr Hm.",
					"leavesAt": "23:55",
					"arrivesAt": "00:00",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Lugoj",
					"leavesAt": "00:04",
					"arrivesAt": "00:10",
					"waitsAtSource": 240,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7034",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "12:26",
					"arrivesAt": "12:29",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "12:30",
					"arrivesAt": "12:35",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "12:36",
					"arrivesAt": "12:41",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Moldoveni h.",
					"to": "Dridu Hm.",
					"leavesAt": "12:42",
					"arrivesAt": "12:48",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Dridu Hm.",
					"to": "Fierbinţi",
					"leavesAt": "12:49",
					"arrivesAt": "12:55",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Fierbinţi",
					"to": "Greci h.",
					"leavesAt": "12:56",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Greci h.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "13:02",
					"arrivesAt": "13:08",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "13:09",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Baloteşti Hm.",
					"leavesAt": "13:15",
					"arrivesAt": "13:20",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Baloteşti Hm.",
					"to": "P.O. Aeroport h.",
					"leavesAt": "13:25",
					"arrivesAt": "13:28",
					"waitsAtSource": 300,
					"distance": 2100
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Odăile h.",
					"leavesAt": "13:29",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Odăile h.",
					"to": "Mogoşoaia",
					"leavesAt": "13:33",
					"arrivesAt": "13:41",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Mogoşoaia",
					"to": "Chitila",
					"leavesAt": "13:42",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Chitila",
					"to": "Pajura Hm. (700)",
					"leavesAt": "13:59",
					"arrivesAt": "14:04",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Carpaţi h.(700)",
					"leavesAt": "14:05",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Bucureşti Nord",
					"leavesAt": "14:09",
					"arrivesAt": "14:16",
					"waitsAtSource": 30,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4310",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "22:42",
					"arrivesAt": "22:52",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "22:53",
					"arrivesAt": "22:57",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "22:58",
					"arrivesAt": "23:04",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Apahida h.",
					"leavesAt": "23:05",
					"arrivesAt": "23:09",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Apahida h.",
					"to": "Jucu Hm.",
					"leavesAt": "23:10",
					"arrivesAt": "23:15",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Jucu Hm.",
					"to": "Răscruci h.",
					"leavesAt": "23:16",
					"arrivesAt": "23:22",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Răscruci h.",
					"to": "Bonţida Hm.",
					"leavesAt": "23:23",
					"arrivesAt": "23:28",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bonţida Hm.",
					"to": "Fundătura h.",
					"leavesAt": "23:29",
					"arrivesAt": "23:35",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Fundătura h.",
					"to": "Iclod Hm.",
					"leavesAt": "23:36",
					"arrivesAt": "23:40",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Iclod Hm.",
					"to": "Livada Someş h.",
					"leavesAt": "23:41",
					"arrivesAt": "23:47",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Livada Someş h.",
					"to": "Gherla",
					"leavesAt": "23:48",
					"arrivesAt": "23:57",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Gherla",
					"to": "Nima h.",
					"leavesAt": "23:58",
					"arrivesAt": "00:09",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Nima h.",
					"to": "Dej Călători",
					"leavesAt": "00:10",
					"arrivesAt": "00:19",
					"waitsAtSource": 30,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 831
				},
				{
					"from": "20180125",
					"to": "20180407",
					"daysOfWeek": 831
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 831
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 831
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 831
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 831
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 831
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 831
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 831
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9555",
			"segments": [
				{
					"from": "Orşova",
					"to": "Valea Cernei Hm.",
					"leavesAt": "13:32",
					"arrivesAt": "13:38",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Valea Cernei Hm.",
					"to": "Topleţ Hm.",
					"leavesAt": "13:39",
					"arrivesAt": "13:44",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Topleţ Hm.",
					"to": "Băile Herculane",
					"leavesAt": "13:45",
					"arrivesAt": "13:54",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Herculane",
					"to": "Mehadia Nouă Hm.",
					"leavesAt": "13:55",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Mehadia Nouă Hm.",
					"to": "Mehadia Hm.",
					"leavesAt": "13:59",
					"arrivesAt": "14:02",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Mehadia Hm.",
					"to": "Iablaniţa",
					"leavesAt": "14:03",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Iablaniţa",
					"to": "Cruşovăţ",
					"leavesAt": "14:14",
					"arrivesAt": "14:22",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Cruşovăţ",
					"to": "Cornea h.",
					"leavesAt": "14:23",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Cornea h.",
					"to": "Domaşnea Cornea Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Domaşnea Cornea Hm.",
					"to": "Luncaviţa h.",
					"leavesAt": "14:39",
					"arrivesAt": "14:44",
					"waitsAtSource": 300,
					"distance": 3000
				},
				{
					"from": "Luncaviţa h.",
					"to": "Poarta Hm.",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Poarta Hm.",
					"to": "Teregova Hm.",
					"leavesAt": "14:51",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Teregova Hm.",
					"to": "Armeniş",
					"leavesAt": "15:01",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Armeniş",
					"to": "Slatina Timiş",
					"leavesAt": "15:09",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Slatina Timiş",
					"to": "Vălişoara Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:26",
					"waitsAtSource": 240,
					"distance": 6400
				},
				{
					"from": "Vălişoara Hm.",
					"to": "Petroşniţa h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Petroşniţa h.",
					"to": "Valea Timişului Hm.",
					"leavesAt": "15:32",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Valea Timişului Hm.",
					"to": "Balta Sărată",
					"leavesAt": "15:39",
					"arrivesAt": "15:43",
					"waitsAtSource": 240,
					"distance": 3500
				},
				{
					"from": "Balta Sărată",
					"to": "Caransebeş haltă h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Caransebeş haltă h.",
					"to": "Caransebeş",
					"leavesAt": "15:49",
					"arrivesAt": "15:55",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Caransebeş",
					"to": "Tibiscu h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:25",
					"waitsAtSource": 1560,
					"distance": 4100
				},
				{
					"from": "Tibiscu h.",
					"to": "Zăgujeni Hm.",
					"leavesAt": "16:26",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Căvăran",
					"leavesAt": "16:31",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Căvăran",
					"to": "Sacu h.",
					"leavesAt": "16:44",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Sacu h.",
					"to": "Jena Hm.",
					"leavesAt": "16:50",
					"arrivesAt": "16:54",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Jena Hm.",
					"to": "Găvojdia",
					"leavesAt": "16:55",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Găvojdia",
					"to": "Tapia Hm.",
					"leavesAt": "17:08",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tapia Hm.",
					"to": "Lugoj",
					"leavesAt": "17:25",
					"arrivesAt": "17:32",
					"waitsAtSource": 660,
					"distance": 6500
				},
				{
					"from": "Lugoj",
					"to": "Jabăr Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:45",
					"waitsAtSource": 300,
					"distance": 7600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Belinţ Hm.",
					"to": "Chizătău Hm.",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Chizătău Hm.",
					"to": "Topolovăţ",
					"leavesAt": "17:59",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Topolovăţ",
					"to": "Şuştra h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Şuştra h.",
					"to": "Recaş",
					"leavesAt": "18:12",
					"arrivesAt": "18:20",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Recaş",
					"to": "Izvin h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Izvin h.",
					"to": "Remetea Mare",
					"leavesAt": "18:25",
					"arrivesAt": "18:33",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Remetea Mare",
					"to": "Timişoara Est",
					"leavesAt": "18:34",
					"arrivesAt": "18:48",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "18:49",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 264
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5522",
			"segments": [
				{
					"from": "Târgu Neamţ",
					"to": "Sfântu Mina h.",
					"leavesAt": "07:56",
					"arrivesAt": "08:00",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Plăieşu h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plăieşu h.",
					"to": "Timişeşti Hm.",
					"leavesAt": "08:05",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "08:12",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Topile h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:25",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Topile h.",
					"to": "Paşcani",
					"leavesAt": "08:26",
					"arrivesAt": "08:36",
					"waitsAtSource": 30,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4082",
			"segments": [
				{
					"from": "Sărmăşag",
					"to": "Sărmăşag h.",
					"leavesAt": "03:55",
					"arrivesAt": "03:58",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Sărmăşag h.",
					"to": "Derşida h.",
					"leavesAt": "03:59",
					"arrivesAt": "04:02",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Derşida h.",
					"to": "Giorocuţa h.",
					"leavesAt": "04:03",
					"arrivesAt": "04:09",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Giorocuţa h.",
					"to": "Supur h.",
					"leavesAt": "04:10",
					"arrivesAt": "04:13",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Supur h.",
					"to": "Supur Haltă hc.",
					"leavesAt": "04:14",
					"arrivesAt": "04:16",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Supur Haltă hc.",
					"to": "Acâş Hm.",
					"leavesAt": "04:17",
					"arrivesAt": "04:25",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Acâş Hm.",
					"to": "Săcăşeni h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:09",
					"waitsAtSource": 1980,
					"distance": 10000
				},
				{
					"from": "Săcăşeni h.",
					"to": "Tăşnad",
					"leavesAt": "05:10",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Tăşnad",
					"to": "Santău h.",
					"leavesAt": "05:19",
					"arrivesAt": "05:26",
					"waitsAtSource": 120,
					"distance": 5500
				},
				{
					"from": "Santău h.",
					"to": "Hotoan h.",
					"leavesAt": "05:27",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Hotoan h.",
					"to": "Tiream h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tiream h.",
					"to": "Carei",
					"leavesAt": "05:43",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Carei",
					"to": "Domăneşti h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:24",
					"waitsAtSource": 840,
					"distance": 9900
				},
				{
					"from": "Domăneşti h.",
					"to": "Moftin h.",
					"leavesAt": "06:25",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Moftin h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "06:32",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Sătmărel h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:58",
					"waitsAtSource": 600,
					"distance": 9900
				},
				{
					"from": "Sătmărel h.",
					"to": "Satu Mare Sud",
					"leavesAt": "06:59",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Satu Mare Sud",
					"to": "Satu Mare",
					"leavesAt": "07:15",
					"arrivesAt": "07:22",
					"waitsAtSource": 540,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2311",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Coşlariu",
					"leavesAt": "11:53",
					"arrivesAt": "12:01",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Coşlariu",
					"to": "Sântimbru h.",
					"leavesAt": "12:05",
					"arrivesAt": "12:16",
					"waitsAtSource": 240,
					"distance": 4400
				},
				{
					"from": "Sântimbru h.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "12:17",
					"arrivesAt": "12:21",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "12:22",
					"arrivesAt": "12:29",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "12:30",
					"arrivesAt": "12:39",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "12:50",
					"arrivesAt": "13:02",
					"waitsAtSource": 660,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Blandiana Hm.",
					"leavesAt": "13:08",
					"arrivesAt": "13:16",
					"waitsAtSource": 360,
					"distance": 5200
				},
				{
					"from": "Blandiana Hm.",
					"to": "Tărtăria h.",
					"leavesAt": "13:17",
					"arrivesAt": "13:23",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tărtăria h.",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "13:24",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Şibot",
					"leavesAt": "13:31",
					"arrivesAt": "13:37",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şibot",
					"to": "Geoagiu h.",
					"leavesAt": "13:38",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Geoagiu h.",
					"to": "Orăştie",
					"leavesAt": "13:50",
					"arrivesAt": "13:57",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Orăştie",
					"to": "Pricaz h.",
					"leavesAt": "13:58",
					"arrivesAt": "14:02",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pricaz h.",
					"to": "Turdaş Hm.",
					"leavesAt": "14:03",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Turdaş Hm.",
					"to": "Simeria Veche h.",
					"leavesAt": "14:12",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Simeria Veche h.",
					"to": "Simeria",
					"leavesAt": "14:18",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5720",
			"segments": [
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "04:41",
					"arrivesAt": "04:47",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Vama",
					"leavesAt": "04:58",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Vama",
					"to": "Molid Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Molid Hm.",
					"to": "Frasin",
					"leavesAt": "05:11",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "05:19",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Gura Humorului Hm.",
					"leavesAt": "05:33",
					"arrivesAt": "05:41",
					"waitsAtSource": 300,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "05:54",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "06:02",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Stroieşti",
					"leavesAt": "06:11",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Stroieşti",
					"to": "Suceava Vest",
					"leavesAt": "06:19",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Suceava Vest",
					"to": "Suceava",
					"leavesAt": "06:29",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1794",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "17:00",
					"arrivesAt": "17:11",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "17:21",
					"arrivesAt": "17:44",
					"waitsAtSource": 600,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "17:45",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "18:12",
					"arrivesAt": "18:52",
					"waitsAtSource": 480,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9573",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Tibiscu h.",
					"leavesAt": "07:35",
					"arrivesAt": "07:39",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Tibiscu h.",
					"to": "Zăgujeni Hm.",
					"leavesAt": "07:40",
					"arrivesAt": "07:43",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Căvăran",
					"leavesAt": "07:44",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Căvăran",
					"to": "Sacu h.",
					"leavesAt": "07:56",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Sacu h.",
					"to": "Jena Hm.",
					"leavesAt": "08:00",
					"arrivesAt": "08:03",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Jena Hm.",
					"to": "Găvojdia",
					"leavesAt": "08:04",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Găvojdia",
					"to": "Tapia Hm.",
					"leavesAt": "08:15",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tapia Hm.",
					"to": "Lugoj",
					"leavesAt": "08:20",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lugoj",
					"to": "Jabăr Hm.",
					"leavesAt": "08:27",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "08:34",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Belinţ Hm.",
					"to": "Chizătău Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Chizătău Hm.",
					"to": "Topolovăţ",
					"leavesAt": "08:45",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Topolovăţ",
					"to": "Şuştra h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Şuştra h.",
					"to": "Recaş",
					"leavesAt": "08:56",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Recaş",
					"to": "Izvin h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:13",
					"waitsAtSource": 480,
					"distance": 2200
				},
				{
					"from": "Izvin h.",
					"to": "Remetea Mare",
					"leavesAt": "09:14",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Remetea Mare",
					"to": "Timişoara Est",
					"leavesAt": "09:23",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "09:38",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5492",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "20:40",
					"arrivesAt": "20:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "20:55",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "21:03",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "21:10",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "21:18",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "21:28",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "21:35",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "21:40",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "21:50",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "22:38",
					"arrivesAt": "22:45",
					"waitsAtSource": 2040,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "22:46",
					"arrivesAt": "22:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "22:52",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "22:57",
					"arrivesAt": "23:02",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "23:03",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "23:08",
					"arrivesAt": "23:14",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "23:15",
					"arrivesAt": "23:24",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "23:26",
					"arrivesAt": "23:33",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "23:34",
					"arrivesAt": "23:38",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "23:39",
					"arrivesAt": "23:47",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "23:48",
					"arrivesAt": "23:53",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "23:54",
					"arrivesAt": "23:59",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "00:00",
					"arrivesAt": "00:12",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20180531",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6812",
			"segments": [
				{
					"from": "Nyirabrany",
					"to": "Valea lui Mihai",
					"leavesAt": "09:06",
					"arrivesAt": "09:21",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Valea lui Mihai",
					"to": "Simion h.",
					"leavesAt": "09:41",
					"arrivesAt": "09:47",
					"waitsAtSource": 1200,
					"distance": 5900
				},
				{
					"from": "Simion h.",
					"to": "Şilindru Hm.",
					"leavesAt": "09:48",
					"arrivesAt": "09:54",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Şilindru Hm.",
					"to": "Săcuieni Bihor",
					"leavesAt": "09:55",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Cadia h.",
					"leavesAt": "10:05",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cadia h.",
					"to": "Diosig Hm.",
					"leavesAt": "10:14",
					"arrivesAt": "10:20",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Diosig Hm.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "10:21",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Tămăşeu h.",
					"leavesAt": "10:28",
					"arrivesAt": "10:35",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tămăşeu h.",
					"to": "Biharia Hm.",
					"leavesAt": "10:36",
					"arrivesAt": "10:44",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Biharia Hm.",
					"to": "Episcopia Bihor",
					"leavesAt": "10:45",
					"arrivesAt": "10:55",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "10:56",
					"arrivesAt": "11:05",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1861",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "22:20",
					"arrivesAt": "22:45",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "22:46",
					"arrivesAt": "23:04",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "23:05",
					"arrivesAt": "23:24",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Movila Hm.",
					"leavesAt": "23:26",
					"arrivesAt": "23:43",
					"waitsAtSource": 120,
					"distance": 16700
				},
				{
					"from": "Movila Hm.",
					"to": "Ţăndărei",
					"leavesAt": "23:44",
					"arrivesAt": "23:56",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Ţăndărei",
					"to": "Spicu",
					"leavesAt": "23:57",
					"arrivesAt": "00:17",
					"waitsAtSource": 60,
					"distance": 21700
				},
				{
					"from": "Spicu",
					"to": "Făurei",
					"leavesAt": "00:18",
					"arrivesAt": "00:55",
					"waitsAtSource": 60,
					"distance": 36400
				},
				{
					"from": "Făurei",
					"to": "Buzău",
					"leavesAt": "00:57",
					"arrivesAt": "01:36",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "01:56",
					"arrivesAt": "02:27",
					"waitsAtSource": 1200,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "02:29",
					"arrivesAt": "03:07",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "03:09",
					"arrivesAt": "03:31",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Tecuci Nord hc.(605)",
					"leavesAt": "03:46",
					"arrivesAt": "04:10",
					"waitsAtSource": 900,
					"distance": 17800
				},
				{
					"from": "Tecuci Nord hc.(605)",
					"to": "Bârlad",
					"leavesAt": "04:11",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 48600
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "04:55",
					"arrivesAt": "05:24",
					"waitsAtSource": 120,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "05:25",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "05:41",
					"arrivesAt": "05:59",
					"waitsAtSource": 120,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "06:00",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "06:27",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "06:44",
					"arrivesAt": "06:51",
					"waitsAtSource": 120,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9440",
			"segments": [
				{
					"from": "Pietroşiţa Hm.",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:16",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Fieni",
					"leavesAt": "05:17",
					"arrivesAt": "05:22",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Moţăieni h.",
					"leavesAt": "05:23",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Moţăieni h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "05:28",
					"arrivesAt": "05:32",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Trainica h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Trainica h.",
					"to": "Scârlenţa h.",
					"leavesAt": "05:37",
					"arrivesAt": "05:39",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Scârlenţa h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "05:40",
					"arrivesAt": "05:43",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Doiceşti h.",
					"leavesAt": "05:44",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Doiceşti h.",
					"to": "Doiceşti",
					"leavesAt": "05:47",
					"arrivesAt": "05:49",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Doiceşti",
					"to": "Săteni h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Săteni h.",
					"to": "Aninoasa Hm.",
					"leavesAt": "05:54",
					"arrivesAt": "05:56",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Aninoasa Hm.",
					"to": "TEIŞ Hm.",
					"leavesAt": "05:57",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "06:04",
					"arrivesAt": "06:08",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1691",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "11:05",
					"arrivesAt": "11:56",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "11:57",
					"arrivesAt": "12:42",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "12:44",
					"arrivesAt": "13:14",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "13:15",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "13:33",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "14:20",
					"arrivesAt": "14:46",
					"waitsAtSource": 420,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Strehaia hc.",
					"leavesAt": "14:47",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Strehaia hc.",
					"to": "Ciochiuţa Hm.",
					"leavesAt": "15:11",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Ciochiuţa Hm.",
					"to": "Balota",
					"leavesAt": "15:26",
					"arrivesAt": "15:55",
					"waitsAtSource": 300,
					"distance": 26900
				},
				{
					"from": "Balota",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "15:56",
					"arrivesAt": "16:30",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Orşova",
					"leavesAt": "16:32",
					"arrivesAt": "17:04",
					"waitsAtSource": 120,
					"distance": 24000
				},
				{
					"from": "Orşova",
					"to": "Băile Herculane",
					"leavesAt": "17:05",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 17500
				},
				{
					"from": "Băile Herculane",
					"to": "Caransebeş",
					"leavesAt": "17:26",
					"arrivesAt": "18:49",
					"waitsAtSource": 120,
					"distance": 70800
				},
				{
					"from": "Caransebeş",
					"to": "Lugoj",
					"leavesAt": "18:53",
					"arrivesAt": "19:27",
					"waitsAtSource": 240,
					"distance": 39400
				},
				{
					"from": "Lugoj",
					"to": "Timişoara Nord",
					"leavesAt": "19:28",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5711",
			"segments": [
				{
					"from": "Câmpulung Mold.",
					"to": "Sadova Hm.",
					"leavesAt": "15:18",
					"arrivesAt": "15:23",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Sadova Hm.",
					"to": "Pojorâta Hm.",
					"leavesAt": "15:24",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Valea Putnei P.M.",
					"leavesAt": "15:31",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Valea Putnei P.M.",
					"to": "Mestecăniş",
					"leavesAt": "15:44",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Iacobeni",
					"leavesAt": "15:55",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Iacobeni",
					"to": "Argestru Hm.",
					"leavesAt": "16:05",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Argestru Hm.",
					"to": "Vatra Dornei",
					"leavesAt": "16:14",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Vatra Dornei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "16:22",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Roşu Hm.",
					"leavesAt": "16:26",
					"arrivesAt": "16:33",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Roşu Hm.",
					"to": "Dorna Candrenilor h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dorna Candrenilor h.",
					"to": "Floreni",
					"leavesAt": "16:40",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Floreni",
					"to": "Coşna Hm.",
					"leavesAt": "16:48",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Coşna Hm.",
					"to": "Grădiniţa",
					"leavesAt": "17:02",
					"arrivesAt": "17:12",
					"waitsAtSource": 300,
					"distance": 8000
				},
				{
					"from": "Grădiniţa",
					"to": "Larion Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Larion Hm.",
					"to": "Silhoasa Hm.",
					"leavesAt": "17:23",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Silhoasa Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "17:35",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Lunca Ilvei",
					"to": "Ilva Mare Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Ilva Mare Hm.",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "17:55",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Poiana Ilvei",
					"leavesAt": "18:06",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Poiana Ilvei",
					"to": "Leşu Ilvei Hm.",
					"leavesAt": "18:15",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Leşu Ilvei Hm.",
					"to": "Strâmba h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Strâmba h.",
					"to": "Ilva Mică",
					"leavesAt": "18:30",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3005",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "14:20",
					"arrivesAt": "14:29",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "14:30",
					"arrivesAt": "14:36",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "14:37",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "14:42",
					"arrivesAt": "14:50",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "14:51",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "14:57",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "15:07",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "15:16",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Ploieşti Vest",
					"leavesAt": "15:21",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "15:29",
					"arrivesAt": "15:36",
					"waitsAtSource": 240,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "15:37",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Bobolia h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Bobolia h.",
					"to": "Câmpina",
					"leavesAt": "15:56",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "16:14",
					"arrivesAt": "16:19",
					"waitsAtSource": 600,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "16:28",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Posada h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Posada h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Sinaia Sud h.",
					"leavesAt": "16:47",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "16:52",
					"arrivesAt": "16:55",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "16:57",
					"arrivesAt": "17:02",
					"waitsAtSource": 120,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "17:03",
					"arrivesAt": "17:07",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "17:08",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "17:14",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "17:26",
					"arrivesAt": "17:41",
					"waitsAtSource": 120,
					"distance": 9900
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Timişu de Jos h.",
					"leavesAt": "17:42",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Dârste",
					"leavesAt": "17:51",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "18:00",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9022",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Ram. Goleşti",
					"leavesAt": "03:50",
					"arrivesAt": "03:56",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Ram. Goleşti",
					"to": "Goleşti",
					"leavesAt": "03:57",
					"arrivesAt": "04:04",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Goleşti",
					"to": "Călineşti Hm.",
					"leavesAt": "04:05",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Călineşti Hm.",
					"to": "Leordeni Argeş",
					"leavesAt": "04:15",
					"arrivesAt": "04:21",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Leordeni Argeş",
					"to": "Pătroaia Hm.",
					"leavesAt": "04:22",
					"arrivesAt": "04:29",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pătroaia Hm.",
					"to": "Găeşti",
					"leavesAt": "04:30",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Găeşti",
					"to": "Găeşti Sud h.",
					"leavesAt": "04:39",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Găeşti Sud h.",
					"to": "Cojocaru h.",
					"leavesAt": "04:44",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Cojocaru h.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Fusea Hm.",
					"leavesAt": "04:54",
					"arrivesAt": "04:59",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Fusea Hm.",
					"to": "Titu",
					"leavesAt": "05:00",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:15",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "05:16",
					"arrivesAt": "05:19",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "05:20",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "05:27",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "05:33",
					"arrivesAt": "05:40",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "05:41",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "05:50",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "05:58",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "06:02",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "06:07",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "06:11",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "06:15",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1988",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun hc.",
					"leavesAt": "18:10",
					"arrivesAt": "18:20",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "18:23",
					"arrivesAt": "18:36",
					"waitsAtSource": 180,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "18:39",
					"arrivesAt": "18:43",
					"waitsAtSource": 180,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "18:46",
					"arrivesAt": "19:01",
					"waitsAtSource": 180,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "19:04",
					"arrivesAt": "19:11",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "19:13",
					"arrivesAt": "19:22",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Agigea Nord",
					"leavesAt": "19:23",
					"arrivesAt": "19:30",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Nord",
					"to": "Constanţa",
					"leavesAt": "19:31",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "20:00",
					"arrivesAt": "20:26",
					"waitsAtSource": 1080,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "20:27",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "20:47",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "21:10",
					"arrivesAt": "21:36",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "21:37",
					"arrivesAt": "22:45",
					"waitsAtSource": 60,
					"distance": 108900
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180524",
					"to": "20180528",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2492",
			"segments": [
				{
					"from": "Cugir  Hm.",
					"to": "Cugir hc.",
					"leavesAt": "06:17",
					"arrivesAt": "06:20",
					"waitsAtSource": 0,
					"distance": 600
				},
				{
					"from": "Cugir hc.",
					"to": "Vinerea h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Vinerea h.",
					"to": "Şibot",
					"leavesAt": "06:34",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Şibot",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "06:53",
					"arrivesAt": "06:59",
					"waitsAtSource": 360,
					"distance": 3000
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Tărtăria h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Tărtăria h.",
					"to": "Blandiana Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Blandiana Hm.",
					"to": "Vinţu de Jos",
					"leavesAt": "07:14",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "07:23",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "08:17",
					"arrivesAt": "08:26",
					"waitsAtSource": 2520,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "08:31",
					"arrivesAt": "08:38",
					"waitsAtSource": 300,
					"distance": 4800
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Sântimbru h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Sântimbru h.",
					"to": "Coşlariu",
					"leavesAt": "08:43",
					"arrivesAt": "08:55",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "08:56",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5201",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "03:50",
					"arrivesAt": "03:57",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "03:58",
					"arrivesAt": "04:01",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "04:02",
					"arrivesAt": "04:08",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "04:09",
					"arrivesAt": "04:12",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "04:13",
					"arrivesAt": "04:25",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Urecheşti Hm.",
					"leavesAt": "04:38",
					"arrivesAt": "04:48",
					"waitsAtSource": 780,
					"distance": 9700
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "04:49",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Bâlca hc.",
					"leavesAt": "04:54",
					"arrivesAt": "04:59",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Bâlca hc.",
					"to": "Căiuţi Hm.",
					"leavesAt": "05:00",
					"arrivesAt": "05:05",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Borzeşti Bacău",
					"leavesAt": "05:06",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Oneşti",
					"leavesAt": "05:22",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Oneşti",
					"to": "Trotuş h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:37",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Trotuş h.",
					"to": "Viişoara h",
					"leavesAt": "05:38",
					"arrivesAt": "05:41",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Viişoara h",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Saline hc.",
					"leavesAt": "05:49",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Saline hc.",
					"to": "Cireşoaia h.",
					"leavesAt": "05:53",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cireşoaia h.",
					"to": "Dofteana Bacău",
					"leavesAt": "05:58",
					"arrivesAt": "06:02",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dofteana Bacău",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Valea Uzului Hm.",
					"leavesAt": "06:09",
					"arrivesAt": "06:14",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Comăneşti",
					"leavesAt": "06:15",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Comăneşti",
					"to": "Asău Hm.",
					"leavesAt": "06:33",
					"arrivesAt": "06:39",
					"waitsAtSource": 600,
					"distance": 5100
				},
				{
					"from": "Asău Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Caraliţa h.",
					"to": "Goioasa Hm.",
					"leavesAt": "06:45",
					"arrivesAt": "06:52",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Goioasa Hm.",
					"to": "Simbrea Hm.",
					"leavesAt": "06:53",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Simbrea Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "07:01",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Palanca Hm.",
					"leavesAt": "07:06",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Palanca Hm.",
					"to": "Ghimeş",
					"leavesAt": "07:12",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Ghimeş",
					"to": "Bolovăniş h.",
					"leavesAt": "07:22",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "07:28",
					"arrivesAt": "07:34",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Tarcău h.",
					"leavesAt": "07:35",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "07:40",
					"arrivesAt": "07:45",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Utuşoiu h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Utuşoiu h.",
					"to": "Livezi Ciuc",
					"leavesAt": "07:52",
					"arrivesAt": "07:58",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Caracău h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:06",
					"waitsAtSource": 240,
					"distance": 2100
				},
				{
					"from": "Caracău h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "08:07",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "08:15",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Mihăileni Hm.",
					"leavesAt": "08:20",
					"arrivesAt": "08:24",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Siculeni",
					"leavesAt": "08:25",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "08:46",
					"arrivesAt": "08:54",
					"waitsAtSource": 900,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5528",
			"segments": [
				{
					"from": "Târgu Neamţ",
					"to": "Sfântu Mina h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Plăieşu h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plăieşu h.",
					"to": "Timişeşti Hm.",
					"leavesAt": "17:53",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "18:00",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Topile h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Topile h.",
					"to": "Paşcani",
					"leavesAt": "18:15",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1521",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "09:24",
					"arrivesAt": "10:17",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "10:18",
					"arrivesAt": "11:03",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "11:05",
					"arrivesAt": "11:36",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "11:37",
					"arrivesAt": "11:54",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Piatra Olt",
					"leavesAt": "11:55",
					"arrivesAt": "12:30",
					"waitsAtSource": 60,
					"distance": 32400
				},
				{
					"from": "Piatra Olt",
					"to": "Drăgăşani",
					"leavesAt": "12:31",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 33800
				},
				{
					"from": "Drăgăşani",
					"to": "Băbeni",
					"leavesAt": "12:58",
					"arrivesAt": "13:23",
					"waitsAtSource": 60,
					"distance": 33200
				},
				{
					"from": "Băbeni",
					"to": "Govora",
					"leavesAt": "13:24",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Govora",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "13:33",
					"arrivesAt": "13:44",
					"waitsAtSource": 60,
					"distance": 11400
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Călimăneşti",
					"leavesAt": "13:46",
					"arrivesAt": "14:03",
					"waitsAtSource": 120,
					"distance": 16200
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "14:05",
					"arrivesAt": "14:10",
					"waitsAtSource": 120,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7584",
			"segments": [
				{
					"from": "Tecuci",
					"to": "Cosmeşti Hm.",
					"leavesAt": "05:10",
					"arrivesAt": "05:18",
					"waitsAtSource": 0,
					"distance": 7400
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "05:19",
					"arrivesAt": "05:24",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "05:25",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2039",
			"segments": [
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "14:25",
					"arrivesAt": "14:31",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "14:32",
					"arrivesAt": "14:39",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Simeria",
					"to": "Turdaş Hm.",
					"leavesAt": "14:40",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Turdaş Hm.",
					"to": "Pricaz h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Pricaz h.",
					"to": "Orăştie",
					"leavesAt": "14:59",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Orăştie",
					"to": "Geoagiu h.",
					"leavesAt": "15:05",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Geoagiu h.",
					"to": "Aurel Vlaicu",
					"leavesAt": "15:10",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Şibot",
					"leavesAt": "15:16",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Şibot",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Tărtăria h.",
					"leavesAt": "15:31",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Tărtăria h.",
					"to": "Blandiana Hm.",
					"leavesAt": "15:38",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Blandiana Hm.",
					"to": "Vinţu de Jos",
					"leavesAt": "15:45",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "15:54",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "16:08",
					"arrivesAt": "16:17",
					"waitsAtSource": 120,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "16:18",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Sântimbru h.",
					"leavesAt": "16:26",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Sântimbru h.",
					"to": "Coşlariu",
					"leavesAt": "16:30",
					"arrivesAt": "16:42",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "16:43",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "16:55",
					"arrivesAt": "17:07",
					"waitsAtSource": 240,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Mirăslău h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Mirăslău h.",
					"to": "Decea h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Decea h.",
					"to": "Unirea Hm.",
					"leavesAt": "17:18",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Unirea Hm.",
					"to": "Unirea hc.",
					"leavesAt": "17:24",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "17:28",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Grindeni h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Grindeni h.",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:46",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Câmpia Turzii",
					"leavesAt": "17:47",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cânepişti h.",
					"leavesAt": "17:55",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Cânepişti h.",
					"to": "Ploscoş h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:10",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ploscoş h.",
					"to": "Valea Florilor Hm.",
					"leavesAt": "18:11",
					"arrivesAt": "18:17",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Boju",
					"leavesAt": "18:18",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Boju",
					"to": "Tunel Hm.",
					"leavesAt": "18:31",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Tunel Hm.",
					"to": "Cojocna Hm.",
					"leavesAt": "18:39",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cojocna Hm.",
					"to": "Apahida",
					"leavesAt": "18:47",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "18:54",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "18:58",
					"arrivesAt": "19:05",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "19:06",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "19:12",
					"arrivesAt": "19:17",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5303",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "21:25",
					"arrivesAt": "21:32",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "21:33",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "21:38",
					"arrivesAt": "21:46",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "21:47",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "21:52",
					"arrivesAt": "22:05",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Urecheşti Hm.",
					"leavesAt": "22:09",
					"arrivesAt": "22:19",
					"waitsAtSource": 240,
					"distance": 9700
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "22:20",
					"arrivesAt": "22:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Bâlca hc.",
					"leavesAt": "22:25",
					"arrivesAt": "22:30",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Bâlca hc.",
					"to": "Căiuţi Hm.",
					"leavesAt": "22:31",
					"arrivesAt": "22:37",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Borzeşti Bacău",
					"leavesAt": "22:38",
					"arrivesAt": "22:49",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "22:50",
					"arrivesAt": "22:54",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Oneşti",
					"leavesAt": "22:55",
					"arrivesAt": "23:02",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Oneşti",
					"to": "Viişoara h",
					"leavesAt": "23:30",
					"arrivesAt": "23:41",
					"waitsAtSource": 1680,
					"distance": 9100
				},
				{
					"from": "Viişoara h",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "23:42",
					"arrivesAt": "23:49",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Saline hc.",
					"leavesAt": "23:50",
					"arrivesAt": "23:53",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Saline hc.",
					"to": "Cireşoaia h.",
					"leavesAt": "23:54",
					"arrivesAt": "23:58",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cireşoaia h.",
					"to": "Dofteana Bacău",
					"leavesAt": "23:59",
					"arrivesAt": "00:03",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dofteana Bacău",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "00:04",
					"arrivesAt": "00:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Comăneşti",
					"leavesAt": "00:10",
					"arrivesAt": "00:22",
					"waitsAtSource": 30,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3007",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Depoul Buc.Triaj h.(300)",
					"leavesAt": "16:36",
					"arrivesAt": "16:43",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Depoul Buc.Triaj h.(300)",
					"to": "Chitila",
					"leavesAt": "16:44",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "16:47",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "16:59",
					"arrivesAt": "17:06",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:16",
					"waitsAtSource": 360,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "17:17",
					"arrivesAt": "17:21",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "17:27",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "17:35",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Ploieşti Vest",
					"leavesAt": "17:40",
					"arrivesAt": "17:44",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "17:46",
					"arrivesAt": "17:52",
					"waitsAtSource": 120,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "17:53",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "18:02",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "18:14",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "18:20",
					"arrivesAt": "18:23",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "18:24",
					"arrivesAt": "18:27",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "18:28",
					"arrivesAt": "18:32",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Posada h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Posada h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "18:39",
					"arrivesAt": "18:44",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Sinaia Sud h.",
					"leavesAt": "18:45",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "18:50",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "18:54",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "19:00",
					"arrivesAt": "19:04",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "19:05",
					"arrivesAt": "19:10",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "19:11",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "19:21",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Timişu de Jos h.",
					"leavesAt": "19:37",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Dârste",
					"leavesAt": "19:45",
					"arrivesAt": "19:53",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "19:54",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9444",
			"segments": [
				{
					"from": "Pietroşiţa Hm.",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:21",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Fieni",
					"leavesAt": "09:22",
					"arrivesAt": "09:27",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Moţăieni h.",
					"leavesAt": "09:28",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Moţăieni h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "09:33",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Trainica h.",
					"leavesAt": "09:38",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Trainica h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "09:42",
					"arrivesAt": "09:47",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Doiceşti",
					"leavesAt": "09:48",
					"arrivesAt": "09:52",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Doiceşti",
					"to": "Săteni h.",
					"leavesAt": "09:53",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Săteni h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "09:57",
					"arrivesAt": "10:01",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "10:02",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "10:05",
					"arrivesAt": "10:09",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1953",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun hc.",
					"leavesAt": "21:35",
					"arrivesAt": "21:45",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "21:48",
					"arrivesAt": "22:01",
					"waitsAtSource": 180,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "22:04",
					"arrivesAt": "22:08",
					"waitsAtSource": 180,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "22:11",
					"arrivesAt": "22:26",
					"waitsAtSource": 180,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "22:29",
					"arrivesAt": "22:36",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "22:38",
					"arrivesAt": "23:01",
					"waitsAtSource": 120,
					"distance": 14000
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "23:20",
					"arrivesAt": "23:45",
					"waitsAtSource": 1140,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "23:46",
					"arrivesAt": "00:05",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "00:06",
					"arrivesAt": "00:27",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ţăndărei",
					"leavesAt": "00:29",
					"arrivesAt": "00:56",
					"waitsAtSource": 120,
					"distance": 30600
				},
				{
					"from": "Ţăndărei",
					"to": "Făurei",
					"leavesAt": "00:57",
					"arrivesAt": "01:53",
					"waitsAtSource": 60,
					"distance": 58100
				},
				{
					"from": "Făurei",
					"to": "Buzău",
					"leavesAt": "01:54",
					"arrivesAt": "02:33",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "02:53",
					"arrivesAt": "03:25",
					"waitsAtSource": 1200,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "03:27",
					"arrivesAt": "04:05",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "04:07",
					"arrivesAt": "04:29",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "04:31",
					"arrivesAt": "04:58",
					"waitsAtSource": 120,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "05:00",
					"arrivesAt": "05:38",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "05:41",
					"arrivesAt": "06:10",
					"waitsAtSource": 180,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Paşcani",
					"leavesAt": "06:12",
					"arrivesAt": "06:41",
					"waitsAtSource": 120,
					"distance": 40200
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "06:44",
					"arrivesAt": "07:04",
					"waitsAtSource": 180,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "07:05",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "07:23",
					"arrivesAt": "07:33",
					"waitsAtSource": 120,
					"distance": 14800
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "07:36",
					"arrivesAt": "07:42",
					"waitsAtSource": 180,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8586",
			"segments": [
				{
					"from": "Ciulniţa",
					"to": "Brâncoveni h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:46",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Brâncoveni h.",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "15:47",
					"arrivesAt": "15:56",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Slobozia Veche",
					"leavesAt": "15:57",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 4200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4701",
			"segments": [
				{
					"from": "Ilva Mică",
					"to": "Podereia Feldrului h.",
					"leavesAt": "03:52",
					"arrivesAt": "03:56",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Feldru Hm.",
					"leavesAt": "03:57",
					"arrivesAt": "04:02",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Feldru Hm.",
					"to": "Nepos h.",
					"leavesAt": "04:09",
					"arrivesAt": "04:16",
					"waitsAtSource": 420,
					"distance": 4700
				},
				{
					"from": "Nepos h.",
					"to": "Rebrişoara Hm.",
					"leavesAt": "04:17",
					"arrivesAt": "04:23",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Năsăud",
					"leavesAt": "04:24",
					"arrivesAt": "04:29",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Năsăud",
					"to": "Năsăud h.",
					"leavesAt": "04:31",
					"arrivesAt": "04:34",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Năsăud h.",
					"to": "Salva",
					"leavesAt": "04:35",
					"arrivesAt": "04:40",
					"waitsAtSource": 30,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2502",
			"segments": [
				{
					"from": "Făgăraş",
					"to": "Mândra Oltului h.",
					"leavesAt": "04:22",
					"arrivesAt": "04:28",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Şercaia h.",
					"leavesAt": "04:29",
					"arrivesAt": "04:36",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Şercaia h.",
					"to": "Şercaia Hm.",
					"leavesAt": "04:37",
					"arrivesAt": "04:39",
					"waitsAtSource": 30,
					"distance": 1200
				},
				{
					"from": "Şercaia Hm.",
					"to": "Perşani h.",
					"leavesAt": "04:40",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Brădet Hm.",
					"leavesAt": "04:47",
					"arrivesAt": "04:56",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Brădet Hm.",
					"to": "Valea Homorod h.",
					"leavesAt": "04:57",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Homorod h.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "05:06",
					"arrivesAt": "05:15",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "05:16",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "05:22",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Codlea Hm.",
					"to": "Ghimbav Hm.",
					"leavesAt": "05:32",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Bartolomeu",
					"leavesAt": "05:43",
					"arrivesAt": "05:50",
					"waitsAtSource": 240,
					"distance": 5400
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "05:51",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8444",
			"segments": [
				{
					"from": "Călăraşi Sud",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "19:50",
					"arrivesAt": "19:57",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Ştefan Vodă h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Ciulniţa",
					"leavesAt": "20:06",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 12600
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "20:41",
					"arrivesAt": "20:49",
					"waitsAtSource": 1140,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "20:50",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "20:55",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "20:59",
					"arrivesAt": "21:04",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "21:05",
					"arrivesAt": "21:10",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "21:11",
					"arrivesAt": "21:16",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "21:17",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1638",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Gherla",
					"leavesAt": "19:05",
					"arrivesAt": "20:02",
					"waitsAtSource": 0,
					"distance": 44900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "20:04",
					"arrivesAt": "20:23",
					"waitsAtSource": 120,
					"distance": 13900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9436",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "19:40",
					"arrivesAt": "19:47",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "19:54",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "19:59",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Podu Rizii h.",
					"leavesAt": "20:08",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Podu Rizii h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "20:13",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "20:18",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4520",
			"segments": [
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "14:39",
					"arrivesAt": "14:48",
					"waitsAtSource": 0,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9611",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Boldur h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:25",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Boldur h.",
					"to": "Sinia Hm.",
					"leavesAt": "04:26",
					"arrivesAt": "04:33",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sinia Hm.",
					"to": "Căpăt h.",
					"leavesAt": "04:34",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Căpăt h.",
					"to": "Buziaş",
					"leavesAt": "04:41",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9437",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Depoul Buc.Triaj h.(300)",
					"leavesAt": "12:30",
					"arrivesAt": "12:38",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Depoul Buc.Triaj h.(300)",
					"to": "Chitila",
					"leavesAt": "12:39",
					"arrivesAt": "12:42",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "12:43",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "12:52",
					"arrivesAt": "13:04",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "13:05",
					"arrivesAt": "13:15",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "13:16",
					"arrivesAt": "13:25",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "13:26",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "13:35",
					"arrivesAt": "13:38",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "13:39",
					"arrivesAt": "13:46",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "13:48",
					"arrivesAt": "13:51",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Podu Rizii h.",
					"leavesAt": "13:52",
					"arrivesAt": "13:56",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Podu Rizii h.",
					"to": "Băneşti h.",
					"leavesAt": "13:57",
					"arrivesAt": "14:00",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "14:01",
					"arrivesAt": "14:05",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "14:06",
					"arrivesAt": "14:09",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "14:10",
					"arrivesAt": "14:14",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "14:15",
					"arrivesAt": "14:20",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "14:21",
					"arrivesAt": "14:28",
					"waitsAtSource": 60,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1543",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Ulmeni Sălaj",
					"leavesAt": "17:07",
					"arrivesAt": "17:37",
					"waitsAtSource": 0,
					"distance": 31000
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Benesat Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "17:55",
					"waitsAtSource": 540,
					"distance": 8800
				},
				{
					"from": "Benesat Hm.",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "17:56",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Jibou",
					"leavesAt": "18:06",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Jibou",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "18:24",
					"arrivesAt": "18:33",
					"waitsAtSource": 540,
					"distance": 6800
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Cuciulat Hm.",
					"leavesAt": "18:40",
					"arrivesAt": "18:58",
					"waitsAtSource": 420,
					"distance": 11700
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Ileanda",
					"leavesAt": "19:07",
					"arrivesAt": "19:31",
					"waitsAtSource": 540,
					"distance": 18200
				},
				{
					"from": "Ileanda",
					"to": "Dej Călători",
					"leavesAt": "19:32",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 39500
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "20:11",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Cluj Napoca",
					"leavesAt": "20:31",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 44900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8036",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "19:38",
					"arrivesAt": "19:45",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "19:46",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "20:00",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "20:10",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:25",
					"waitsAtSource": 480,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "20:26",
					"arrivesAt": "20:33",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "20:34",
					"arrivesAt": "20:44",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "20:45",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "20:54",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Ramificaţia Borcea",
					"leavesAt": "21:05",
					"arrivesAt": "21:20",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "21:21",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180529",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3072",
			"segments": [
				{
					"from": "Oradea",
					"to": "Tileagd",
					"leavesAt": "02:50",
					"arrivesAt": "03:13",
					"waitsAtSource": 0,
					"distance": 23100
				},
				{
					"from": "Tileagd",
					"to": "Aleşd",
					"leavesAt": "03:14",
					"arrivesAt": "03:26",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Aleşd",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "03:27",
					"arrivesAt": "03:47",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "03:48",
					"arrivesAt": "03:56",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bratca",
					"to": "Stâna de Vale h.",
					"leavesAt": "04:00",
					"arrivesAt": "04:05",
					"waitsAtSource": 240,
					"distance": 4100
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bulz Hm.",
					"leavesAt": "04:06",
					"arrivesAt": "04:10",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bulz Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "04:11",
					"arrivesAt": "04:16",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Lacu Crişului h.",
					"leavesAt": "04:17",
					"arrivesAt": "04:22",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Negreni h.",
					"leavesAt": "04:23",
					"arrivesAt": "04:27",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Ciucea Hm.",
					"leavesAt": "04:28",
					"arrivesAt": "04:32",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ciucea Hm.",
					"to": "Valea Drăganului h.",
					"leavesAt": "04:33",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Valea Drăganului h.",
					"to": "Poieni",
					"leavesAt": "04:39",
					"arrivesAt": "04:43",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Poieni",
					"to": "Bologa h.",
					"leavesAt": "04:44",
					"arrivesAt": "04:48",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Bologa h.",
					"to": "Brăişoru Hm.",
					"leavesAt": "04:49",
					"arrivesAt": "04:54",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Huedin",
					"leavesAt": "04:55",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Huedin",
					"to": "Jebuc h.",
					"leavesAt": "05:04",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Jebuc h.",
					"to": "Stana Hm.",
					"leavesAt": "05:11",
					"arrivesAt": "05:18",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Stana Hm.",
					"to": "Gălăşeni h.",
					"leavesAt": "05:19",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Gălăşeni h.",
					"to": "Aghireş h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "05:32",
					"arrivesAt": "05:36",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Dorolţu h.",
					"leavesAt": "05:37",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Dorolţu h.",
					"to": "Macău h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:44",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Macău h.",
					"to": "Gârbău Hm.",
					"leavesAt": "05:45",
					"arrivesAt": "05:50",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Gârbău Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Nădăşel h.",
					"to": "Mera Hm.",
					"leavesAt": "05:58",
					"arrivesAt": "06:02",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mera Hm.",
					"to": "Rădaia h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rădaia h.",
					"to": "Suceag h.",
					"leavesAt": "06:07",
					"arrivesAt": "06:10",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Suceag h.",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:17",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "06:18",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4045",
			"segments": [
				{
					"from": "Jibou",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "06:01",
					"waitsAtSource": 0,
					"distance": 9300
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Inău h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:14",
					"waitsAtSource": 540,
					"distance": 3400
				},
				{
					"from": "Inău h.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:18",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Benesat Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:22",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Benesat Hm.",
					"to": "Ţicău h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ţicău h.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "06:30",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "06:34",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Fersig h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Fersig h.",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "06:48",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Baia Mare",
					"leavesAt": "06:54",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5521",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "02:40",
					"arrivesAt": "02:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "02:55",
					"arrivesAt": "03:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "03:03",
					"arrivesAt": "03:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "03:10",
					"arrivesAt": "03:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "03:18",
					"arrivesAt": "03:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "03:28",
					"arrivesAt": "03:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "03:35",
					"arrivesAt": "03:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "03:40",
					"arrivesAt": "03:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "03:50",
					"arrivesAt": "04:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Topile h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:20",
					"waitsAtSource": 660,
					"distance": 5200
				},
				{
					"from": "Topile h.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "04:21",
					"arrivesAt": "04:29",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Timişeşti Hm.",
					"leavesAt": "04:30",
					"arrivesAt": "04:37",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Plăieşu h.",
					"leavesAt": "04:38",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Plăieşu h.",
					"to": "Târgu Neamţ",
					"leavesAt": "04:44",
					"arrivesAt": "04:58",
					"waitsAtSource": 30,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3535",
			"segments": [
				{
					"from": "Braşov",
					"to": "Stupini Hm.",
					"leavesAt": "20:09",
					"arrivesAt": "20:18",
					"waitsAtSource": 0,
					"distance": 5400
				},
				{
					"from": "Stupini Hm.",
					"to": "Bod Hm.",
					"leavesAt": "20:19",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Bod Hm.",
					"to": "Feldioara Hm.",
					"leavesAt": "20:28",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Rotbav h.",
					"leavesAt": "20:39",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Rotbav h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Măieruş h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:51",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Măieruş h.",
					"to": "Apaţa",
					"leavesAt": "20:52",
					"arrivesAt": "21:04",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Apaţa",
					"to": "Ormeniş h.",
					"leavesAt": "21:05",
					"arrivesAt": "21:11",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ormeniş h.",
					"to": "Augustin Hm.",
					"leavesAt": "21:12",
					"arrivesAt": "21:25",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Augustin Hm.",
					"to": "Racoş Hm.",
					"leavesAt": "21:26",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Racoş Hm.",
					"to": "Mateiaş h.",
					"leavesAt": "21:43",
					"arrivesAt": "21:47",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mateiaş h.",
					"to": "Rupea",
					"leavesAt": "21:48",
					"arrivesAt": "22:02",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Rupea",
					"to": "Caţa Hm.",
					"leavesAt": "22:03",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Caţa Hm.",
					"to": "Paloş Ardeal h.",
					"leavesAt": "22:13",
					"arrivesAt": "22:17",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Paloş Ardeal h.",
					"to": "Beia Hm.",
					"leavesAt": "22:18",
					"arrivesAt": "22:29",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Beia Hm.",
					"to": "Archita h",
					"leavesAt": "22:30",
					"arrivesAt": "22:41",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Archita h",
					"to": "Mureni Hm.",
					"leavesAt": "22:42",
					"arrivesAt": "22:56",
					"waitsAtSource": 30,
					"distance": 9600
				},
				{
					"from": "Mureni Hm.",
					"to": "Saschiz h.",
					"leavesAt": "22:57",
					"arrivesAt": "23:01",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Saschiz h.",
					"to": "Vânători",
					"leavesAt": "23:02",
					"arrivesAt": "23:06",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vânători",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "23:07",
					"arrivesAt": "23:14",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Sighişoara",
					"leavesAt": "23:15",
					"arrivesAt": "23:24",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2602",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "04:42",
					"arrivesAt": "04:49",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Şag Hm.",
					"leavesAt": "04:50",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Şag Hm.",
					"to": "Vinga Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vinga Hm.",
					"to": "Orţişoara",
					"leavesAt": "05:13",
					"arrivesAt": "05:19",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Orţişoara",
					"to": "Băile Călacea",
					"leavesAt": "05:20",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Băile Călacea",
					"to": "Sânandrei Hm.",
					"leavesAt": "05:32",
					"arrivesAt": "05:38",
					"waitsAtSource": 360,
					"distance": 7200
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Cab 1 h",
					"leavesAt": "05:39",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Ronaţ Triaj Cab 1 h",
					"to": "Timişoara Nord",
					"leavesAt": "05:48",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9122",
			"segments": [
				{
					"from": "Parcul Kreţulescu h.",
					"to": "Câmpulung",
					"leavesAt": "15:30",
					"arrivesAt": "15:33",
					"waitsAtSource": 0,
					"distance": 1900
				},
				{
					"from": "Câmpulung",
					"to": "Schitu Goleşti",
					"leavesAt": "15:35",
					"arrivesAt": "15:46",
					"waitsAtSource": 120,
					"distance": 6700
				},
				{
					"from": "Schitu Goleşti",
					"to": "Lăzăreşti Hm.",
					"leavesAt": "15:47",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lăzăreşti Hm.",
					"to": "Drăghici h.",
					"leavesAt": "15:55",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Drăghici h.",
					"to": "Stâlpeni Hm.",
					"leavesAt": "16:02",
					"arrivesAt": "16:13",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Stâlpeni Hm.",
					"to": "Clucereasa h.",
					"leavesAt": "16:14",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Clucereasa h.",
					"to": "Ciumeşti",
					"leavesAt": "16:23",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Ciumeşti",
					"to": "Gropeni h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Gropeni h.",
					"to": "Ştefăneşti Argeş Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Ştefăneşti Argeş Hm.",
					"to": "Goleşti",
					"leavesAt": "16:49",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2700",
			"segments": [
				{
					"from": "Simeria",
					"to": "Simeria Triaj",
					"leavesAt": "04:03",
					"arrivesAt": "04:10",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Simeria Triaj",
					"to": "Băcia h.",
					"leavesAt": "04:11",
					"arrivesAt": "04:13",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Băcia h.",
					"to": "Băcia Hm.",
					"leavesAt": "04:14",
					"arrivesAt": "04:16",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Băcia Hm.",
					"to": "Batiz h.",
					"leavesAt": "04:17",
					"arrivesAt": "04:19",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Batiz h.",
					"to": "Călan Băi",
					"leavesAt": "04:20",
					"arrivesAt": "04:22",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Călan Băi",
					"to": "Călan Hm.",
					"leavesAt": "04:23",
					"arrivesAt": "04:27",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Hm.",
					"to": "Ruşi h.",
					"leavesAt": "04:28",
					"arrivesAt": "04:32",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ruşi h.",
					"to": "Măceu h.",
					"leavesAt": "04:33",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Măceu h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "04:36",
					"arrivesAt": "04:41",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Plopi h.",
					"leavesAt": "04:42",
					"arrivesAt": "04:44",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Plopi h.",
					"to": "Covragiu h.",
					"leavesAt": "04:45",
					"arrivesAt": "04:47",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Covragiu h.",
					"to": "Subcetate",
					"leavesAt": "04:48",
					"arrivesAt": "04:52",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Subcetate",
					"to": "Ciopea h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:12",
					"waitsAtSource": 900,
					"distance": 3800
				},
				{
					"from": "Ciopea h.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Băeşti Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ruşor h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:24",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ruşor h.",
					"to": "Pui",
					"leavesAt": "05:25",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Pui",
					"to": "Ponor h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ponor h.",
					"to": "Livadia h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Livadia h.",
					"to": "Baru Mare",
					"leavesAt": "05:39",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Baru Mare",
					"to": "Baru Mare h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Baru Mare h.",
					"to": "Crivadia Hm.",
					"leavesAt": "05:53",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Crivadia Hm.",
					"to": "Merişor Hm.",
					"leavesAt": "06:01",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Merişor Hm.",
					"to": "Băniţa",
					"leavesAt": "06:11",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băniţa",
					"to": "Peştera Bolii h.",
					"leavesAt": "06:24",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Petroşani Triaj h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Petroşani Triaj h.",
					"to": "Dep Petroşani h.",
					"leavesAt": "06:36",
					"arrivesAt": "06:38",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Petroşani",
					"leavesAt": "06:39",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180107",
					"daysOfWeek": 287
				},
				{
					"from": "20180113",
					"to": "20180204",
					"daysOfWeek": 287
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 287
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 287
				},
				{
					"from": "20180411",
					"to": "20180617",
					"daysOfWeek": 287
				},
				{
					"from": "20180901",
					"to": "20180901",
					"daysOfWeek": 287
				},
				{
					"from": "20180909",
					"to": "20181208",
					"daysOfWeek": 287
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 287
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8656",
			"segments": [
				{
					"from": "Tulcea Oraş",
					"to": "Tulcea Mărfuri",
					"leavesAt": "16:12",
					"arrivesAt": "16:21",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Tulcea Mărfuri",
					"to": "Cataloi Hm.",
					"leavesAt": "16:22",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Cataloi Hm.",
					"to": "Mihail Kogălniceanu h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mihail Kogălniceanu h.",
					"to": "Zebil h.",
					"leavesAt": "16:54",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Zebil h.",
					"to": "Babadag",
					"leavesAt": "17:09",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Babadag",
					"to": "Ceamurlia de Jos h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Ceamurlia de Jos h.",
					"to": "Baia Dobrogea",
					"leavesAt": "17:43",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baia Dobrogea",
					"to": "Mihai Viteazu Hm.",
					"leavesAt": "17:50",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Mihai Viteazu Hm.",
					"to": "Cogealac",
					"leavesAt": "18:09",
					"arrivesAt": "18:28",
					"waitsAtSource": 480,
					"distance": 17400
				},
				{
					"from": "Cogealac",
					"to": "Târguşor Dobrogea Hm.",
					"leavesAt": "18:29",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Târguşor Dobrogea Hm.",
					"to": "Ram. M.K.P. Aj. M.",
					"leavesAt": "18:50",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Ram. M.K.P. Aj. M.",
					"to": "Nicolae Bălcescu",
					"leavesAt": "19:01",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Nicolae Bălcescu",
					"to": "Medgidia",
					"leavesAt": "19:08",
					"arrivesAt": "19:28",
					"waitsAtSource": 60,
					"distance": 19100
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1996",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Lugoj",
					"leavesAt": "22:40",
					"arrivesAt": "23:34",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Lugoj",
					"to": "Găvojdia",
					"leavesAt": "23:36",
					"arrivesAt": "23:45",
					"waitsAtSource": 120,
					"distance": 11900
				},
				{
					"from": "Găvojdia",
					"to": "Caransebeş",
					"leavesAt": "23:49",
					"arrivesAt": "00:16",
					"waitsAtSource": 240,
					"distance": 27500
				},
				{
					"from": "Caransebeş",
					"to": "Băile Herculane",
					"leavesAt": "00:30",
					"arrivesAt": "01:53",
					"waitsAtSource": 840,
					"distance": 70800
				},
				{
					"from": "Băile Herculane",
					"to": "Orşova",
					"leavesAt": "01:55",
					"arrivesAt": "02:15",
					"waitsAtSource": 120,
					"distance": 17500
				},
				{
					"from": "Orşova",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "02:16",
					"arrivesAt": "02:47",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Balota",
					"leavesAt": "02:53",
					"arrivesAt": "03:27",
					"waitsAtSource": 360,
					"distance": 19000
				},
				{
					"from": "Balota",
					"to": "Strehaia hc.",
					"leavesAt": "03:28",
					"arrivesAt": "04:02",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Strehaia hc.",
					"to": "Filiaşi",
					"leavesAt": "04:04",
					"arrivesAt": "04:33",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "04:35",
					"arrivesAt": "05:00",
					"waitsAtSource": 120,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "05:10",
					"arrivesAt": "05:51",
					"waitsAtSource": 600,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "05:52",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Roşiori Nord",
					"leavesAt": "06:08",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "06:40",
					"arrivesAt": "07:24",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Grădinari",
					"leavesAt": "07:26",
					"arrivesAt": "07:51",
					"waitsAtSource": 120,
					"distance": 25400
				},
				{
					"from": "Grădinari",
					"to": "Bucureşti Nord",
					"leavesAt": "07:56",
					"arrivesAt": "08:26",
					"waitsAtSource": 300,
					"distance": 25500
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ciulniţa",
					"leavesAt": "08:50",
					"arrivesAt": "09:58",
					"waitsAtSource": 1440,
					"distance": 108900
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "09:59",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "10:25",
					"arrivesAt": "10:44",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "10:45",
					"arrivesAt": "11:03",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "11:04",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 34600
				},
				{
					"from": "Constanţa",
					"to": "Eforie Nord",
					"leavesAt": "11:55",
					"arrivesAt": "12:18",
					"waitsAtSource": 1560,
					"distance": 14000
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "12:20",
					"arrivesAt": "12:27",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Costineşti",
					"leavesAt": "12:29",
					"arrivesAt": "12:45",
					"waitsAtSource": 120,
					"distance": 8600
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "12:47",
					"arrivesAt": "12:51",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "12:53",
					"arrivesAt": "13:06",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "13:08",
					"arrivesAt": "13:18",
					"waitsAtSource": 120,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180430",
					"daysOfWeek": 383
				},
				{
					"from": "20180524",
					"to": "20180527",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4043",
			"segments": [
				{
					"from": "Jibou",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "05:09",
					"arrivesAt": "05:19",
					"waitsAtSource": 0,
					"distance": 9300
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Inău h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Inău h.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:27",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Benesat Hm.",
					"leavesAt": "05:28",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Benesat Hm.",
					"to": "Ţicău h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ţicău h.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "05:39",
					"arrivesAt": "05:42",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "05:51",
					"arrivesAt": "05:57",
					"waitsAtSource": 540,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Fersig h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Fersig h.",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "06:05",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Baia Mare",
					"leavesAt": "06:11",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9159",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "03:28",
					"arrivesAt": "03:40",
					"waitsAtSource": 0,
					"distance": 10400
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Brebu",
					"leavesAt": "03:41",
					"arrivesAt": "03:53",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Brebu",
					"to": "Ezeriş h.",
					"leavesAt": "03:54",
					"arrivesAt": "04:02",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ezeriş h.",
					"to": "Bănila Câlnic h.",
					"leavesAt": "04:03",
					"arrivesAt": "04:09",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "04:10",
					"arrivesAt": "04:20",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Reşiţa Nord",
					"to": "Reşiţa Sud Hm.",
					"leavesAt": "04:21",
					"arrivesAt": "04:30",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4314",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Buşag Hm.",
					"leavesAt": "12:29",
					"arrivesAt": "12:46",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Buşag Hm.",
					"to": "Cicârlău h.",
					"leavesAt": "12:47",
					"arrivesAt": "12:53",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cicârlău h.",
					"to": "Ilba h.",
					"leavesAt": "12:54",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ilba h.",
					"to": "Săbişa h.",
					"leavesAt": "13:04",
					"arrivesAt": "13:09",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Săbişa h.",
					"to": "Seini",
					"leavesAt": "13:10",
					"arrivesAt": "13:16",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Seini",
					"to": "Apa Hm.",
					"leavesAt": "13:17",
					"arrivesAt": "13:31",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Apa Hm.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "13:41",
					"arrivesAt": "13:52",
					"waitsAtSource": 600,
					"distance": 5100
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Odoreu h.",
					"leavesAt": "13:53",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Odoreu h.",
					"to": "Botiz Hm.",
					"leavesAt": "14:02",
					"arrivesAt": "14:08",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Botiz Hm.",
					"to": "Satu Mare",
					"leavesAt": "14:09",
					"arrivesAt": "14:16",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 831
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 831
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 831
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 831
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 831
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 831
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 831
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 831
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 831
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1821",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "20:50",
					"arrivesAt": "21:14",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "21:15",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "21:33",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "21:55",
					"arrivesAt": "22:18",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Lehliu",
					"leavesAt": "22:19",
					"arrivesAt": "22:40",
					"waitsAtSource": 60,
					"distance": 39300
				},
				{
					"from": "Lehliu",
					"to": "Bucureşti Nord",
					"leavesAt": "22:41",
					"arrivesAt": "23:21",
					"waitsAtSource": 60,
					"distance": 69600
				},
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "23:45",
					"arrivesAt": "00:37",
					"waitsAtSource": 1440,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "00:38",
					"arrivesAt": "01:23",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "01:25",
					"arrivesAt": "01:56",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "01:57",
					"arrivesAt": "02:14",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "02:15",
					"arrivesAt": "02:55",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "03:05",
					"arrivesAt": "03:32",
					"waitsAtSource": 600,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Cărbuneşti",
					"leavesAt": "03:33",
					"arrivesAt": "04:19",
					"waitsAtSource": 60,
					"distance": 46500
				},
				{
					"from": "Cărbuneşti",
					"to": "Târgu Jiu",
					"leavesAt": "04:20",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 23800
				},
				{
					"from": "Târgu Jiu",
					"to": "Valea Sadului Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "05:09",
					"waitsAtSource": 120,
					"distance": 19600
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Petroşani",
					"leavesAt": "05:10",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 31700
				},
				{
					"from": "Petroşani",
					"to": "Băniţa",
					"leavesAt": "06:02",
					"arrivesAt": "06:17",
					"waitsAtSource": 300,
					"distance": 11300
				},
				{
					"from": "Băniţa",
					"to": "Subcetate",
					"leavesAt": "06:18",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 38500
				},
				{
					"from": "Subcetate",
					"to": "Călan Hm.",
					"leavesAt": "07:15",
					"arrivesAt": "07:34",
					"waitsAtSource": 120,
					"distance": 15600
				},
				{
					"from": "Călan Hm.",
					"to": "Simeria",
					"leavesAt": "07:36",
					"arrivesAt": "07:51",
					"waitsAtSource": 120,
					"distance": 14600
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "07:57",
					"arrivesAt": "08:08",
					"waitsAtSource": 360,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Ilia",
					"leavesAt": "08:10",
					"arrivesAt": "08:38",
					"waitsAtSource": 120,
					"distance": 23600
				},
				{
					"from": "Ilia",
					"to": "Săvârşin",
					"leavesAt": "08:39",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Săvârşin",
					"to": "Radna",
					"leavesAt": "09:28",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 49700
				},
				{
					"from": "Radna",
					"to": "Arad",
					"leavesAt": "10:28",
					"arrivesAt": "11:05",
					"waitsAtSource": 60,
					"distance": 34500
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1992",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Topolovăţ",
					"leavesAt": "19:09",
					"arrivesAt": "19:44",
					"waitsAtSource": 0,
					"distance": 34400
				},
				{
					"from": "Topolovăţ",
					"to": "Lugoj",
					"leavesAt": "19:48",
					"arrivesAt": "20:06",
					"waitsAtSource": 240,
					"distance": 24500
				},
				{
					"from": "Lugoj",
					"to": "Caransebeş",
					"leavesAt": "20:10",
					"arrivesAt": "20:43",
					"waitsAtSource": 240,
					"distance": 39400
				},
				{
					"from": "Caransebeş",
					"to": "Iablaniţa",
					"leavesAt": "21:00",
					"arrivesAt": "22:10",
					"waitsAtSource": 1020,
					"distance": 59800
				},
				{
					"from": "Iablaniţa",
					"to": "Băile Herculane",
					"leavesAt": "22:14",
					"arrivesAt": "22:30",
					"waitsAtSource": 240,
					"distance": 11000
				},
				{
					"from": "Băile Herculane",
					"to": "Orşova",
					"leavesAt": "22:32",
					"arrivesAt": "22:52",
					"waitsAtSource": 120,
					"distance": 17500
				},
				{
					"from": "Orşova",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "22:54",
					"arrivesAt": "23:25",
					"waitsAtSource": 120,
					"distance": 24000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Balota",
					"leavesAt": "23:35",
					"arrivesAt": "00:07",
					"waitsAtSource": 600,
					"distance": 19000
				},
				{
					"from": "Balota",
					"to": "Strehaia hc.",
					"leavesAt": "00:17",
					"arrivesAt": "00:50",
					"waitsAtSource": 600,
					"distance": 32600
				},
				{
					"from": "Strehaia hc.",
					"to": "Craiova",
					"leavesAt": "00:52",
					"arrivesAt": "01:42",
					"waitsAtSource": 120,
					"distance": 62100
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "01:55",
					"arrivesAt": "02:36",
					"waitsAtSource": 780,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Roşiori Nord",
					"leavesAt": "02:38",
					"arrivesAt": "03:23",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "03:25",
					"arrivesAt": "04:11",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Băneasa",
					"leavesAt": "04:13",
					"arrivesAt": "05:13",
					"waitsAtSource": 120,
					"distance": 51000
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Ciulniţa",
					"leavesAt": "05:23",
					"arrivesAt": "06:20",
					"waitsAtSource": 600,
					"distance": 102300
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "06:22",
					"arrivesAt": "06:45",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Medgidia",
					"leavesAt": "06:47",
					"arrivesAt": "07:23",
					"waitsAtSource": 120,
					"distance": 44000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "07:25",
					"arrivesAt": "07:57",
					"waitsAtSource": 120,
					"distance": 36000
				},
				{
					"from": "Constanţa",
					"to": "Eforie Nord",
					"leavesAt": "08:28",
					"arrivesAt": "08:55",
					"waitsAtSource": 1860,
					"distance": 14000
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "08:58",
					"arrivesAt": "09:05",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Costineşti",
					"leavesAt": "09:08",
					"arrivesAt": "09:24",
					"waitsAtSource": 180,
					"distance": 8600
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "09:33",
					"arrivesAt": "09:37",
					"waitsAtSource": 540,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "09:40",
					"arrivesAt": "09:53",
					"waitsAtSource": 180,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "09:56",
					"arrivesAt": "10:06",
					"waitsAtSource": 180,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4411",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Ram. Botiz h.",
					"leavesAt": "19:55",
					"arrivesAt": "20:01",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Micula Hm.",
					"leavesAt": "20:02",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Micula Hm.",
					"to": "Porumbeşti Hm.",
					"leavesAt": "20:12",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Halmeu",
					"leavesAt": "20:20",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2182",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Balinţ h.",
					"leavesAt": "03:58",
					"arrivesAt": "04:12",
					"waitsAtSource": 0,
					"distance": 14400
				},
				{
					"from": "Balinţ h.",
					"to": "Cliciova",
					"leavesAt": "04:13",
					"arrivesAt": "04:20",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Cliciova",
					"to": "Susani Bega h.",
					"leavesAt": "04:21",
					"arrivesAt": "04:24",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Susani Bega h.",
					"to": "Traian Vuia h.",
					"leavesAt": "04:25",
					"arrivesAt": "04:27",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Traian Vuia h.",
					"to": "Mănăştur Hm.",
					"leavesAt": "04:28",
					"arrivesAt": "04:32",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Mănăştur Hm.",
					"to": "Răchita h.",
					"leavesAt": "04:33",
					"arrivesAt": "04:36",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Răchita h.",
					"to": "Făget",
					"leavesAt": "04:37",
					"arrivesAt": "04:42",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Făget",
					"to": "Margina",
					"leavesAt": "04:43",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Margina",
					"to": "Nemeşeşti h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:12",
					"waitsAtSource": 720,
					"distance": 5400
				},
				{
					"from": "Nemeşeşti h.",
					"to": "Coşteiu h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:19",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Coşteiu h.",
					"to": "Holdea Hm.",
					"leavesAt": "05:20",
					"arrivesAt": "05:23",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Holdea Hm.",
					"to": "Ohaba hc.",
					"leavesAt": "05:24",
					"arrivesAt": "05:29",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ohaba hc.",
					"to": "Lăpugiu h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Lăpugiu h.",
					"to": "Dobra Hm.",
					"leavesAt": "05:37",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Dobra Hm.",
					"to": "Ilia",
					"leavesAt": "05:44",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "05:57",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "06:04",
					"arrivesAt": "06:11",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Mintia",
					"leavesAt": "06:22",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "06:27",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:47",
					"waitsAtSource": 180,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "06:48",
					"arrivesAt": "06:54",
					"waitsAtSource": 30,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2044",
			"segments": [
				{
					"from": "Arad",
					"to": "Glogovăţ",
					"leavesAt": "06:12",
					"arrivesAt": "06:19",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Glogovăţ",
					"to": "Ghioroc",
					"leavesAt": "06:20",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Ghioroc",
					"to": "Păuliş h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Păuliş h.",
					"to": "Păuliş Hm.",
					"leavesAt": "06:41",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş Hm.",
					"to": "Radna",
					"leavesAt": "06:47",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Radna",
					"to": "Milova",
					"leavesAt": "06:59",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Milova",
					"to": "Corfeni h.",
					"leavesAt": "07:10",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Corfeni h.",
					"to": "Conop Hm.",
					"leavesAt": "07:14",
					"arrivesAt": "07:20",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Conop Hm.",
					"to": "Nadăş h.",
					"leavesAt": "07:21",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Nadăş h.",
					"to": "Bârzava",
					"leavesAt": "07:27",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârzava",
					"to": "Căpruţa h.",
					"leavesAt": "07:35",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Căpruţa h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "07:39",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Vărădia Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vărădia Hm.",
					"to": "Vărădia h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vărădia h.",
					"to": "Săvârşin",
					"leavesAt": "08:02",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Săvârşin",
					"to": "Toc h.",
					"leavesAt": "08:11",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Toc h.",
					"to": "Ilteu",
					"leavesAt": "08:19",
					"arrivesAt": "08:24",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ilteu",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "08:25",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Zam",
					"leavesAt": "08:30",
					"arrivesAt": "08:36",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Zam",
					"to": "Burjuc h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Burjuc h.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "08:47",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Gurasada Hm.",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Gurasada Hm.",
					"to": "Ilia",
					"leavesAt": "09:03",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "09:16",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "09:23",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia",
					"leavesAt": "09:28",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "09:35",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "09:45",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "09:52",
					"arrivesAt": "09:58",
					"waitsAtSource": 30,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2608",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "16:34",
					"arrivesAt": "16:41",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Şag Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Şag Hm.",
					"to": "Vinga Hm.",
					"leavesAt": "16:57",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vinga Hm.",
					"to": "Orţişoara",
					"leavesAt": "17:04",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Orţişoara",
					"to": "Băile Călacea",
					"leavesAt": "17:10",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Băile Călacea",
					"to": "Sânandrei Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj h",
					"leavesAt": "17:27",
					"arrivesAt": "17:34",
					"waitsAtSource": 300,
					"distance": 7400
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Ronaţ Triaj Cab 1 h",
					"leavesAt": "17:35",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab 1 h",
					"to": "Timişoara Nord",
					"leavesAt": "17:38",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5520",
			"segments": [
				{
					"from": "Târgu Neamţ",
					"to": "Sfântu Mina h.",
					"leavesAt": "05:18",
					"arrivesAt": "05:22",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Plăieşu h.",
					"leavesAt": "05:23",
					"arrivesAt": "05:26",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plăieşu h.",
					"to": "Timişeşti Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "05:34",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Topile h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Topile h.",
					"to": "Paşcani",
					"leavesAt": "05:48",
					"arrivesAt": "05:58",
					"waitsAtSource": 30,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9530",
			"segments": [
				{
					"from": "Curtea de Argeş",
					"to": "Băiculeşti h.",
					"leavesAt": "06:50",
					"arrivesAt": "07:00",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Băiculeşti h.",
					"to": "Merişani h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Merişani h.",
					"to": "Bascov Hm.",
					"leavesAt": "07:14",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Bascov Hm.",
					"to": "C.I.L. h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "C.I.L. h.",
					"to": "Piteşti Nord",
					"leavesAt": "07:30",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Piteşti Nord",
					"to": "Piteşti",
					"leavesAt": "07:35",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2567",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(203)",
					"leavesAt": "17:30",
					"arrivesAt": "17:34",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "17:35",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "17:50",
					"arrivesAt": "17:54",
					"waitsAtSource": 300,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Mândra h.",
					"leavesAt": "17:55",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mândra h.",
					"to": "Loamneş Hm.",
					"leavesAt": "18:03",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Loamneş Hm.",
					"to": "Hăşag h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Hăşag h.",
					"to": "Şeica Mare h.",
					"leavesAt": "18:16",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Şeica Mare h.",
					"to": "Şeica Mare",
					"leavesAt": "18:27",
					"arrivesAt": "18:30",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Şeica Mare",
					"to": "Agârbiciu h.",
					"leavesAt": "18:31",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Agârbiciu h.",
					"to": "Axente Sever h.",
					"leavesAt": "18:38",
					"arrivesAt": "18:43",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Axente Sever h.",
					"to": "Copşa Mică",
					"leavesAt": "18:44",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "18:56",
					"arrivesAt": "19:03",
					"waitsAtSource": 420,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "19:04",
					"arrivesAt": "19:11",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Bratei h.",
					"leavesAt": "19:25",
					"arrivesAt": "19:33",
					"waitsAtSource": 840,
					"distance": 5100
				},
				{
					"from": "Bratei h.",
					"to": "Aţel Hm.",
					"leavesAt": "19:34",
					"arrivesAt": "19:42",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Aţel Hm.",
					"to": "Dumbrăveni",
					"leavesAt": "19:43",
					"arrivesAt": "19:53",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Dumbrăveni",
					"to": "Luna h.",
					"leavesAt": "19:54",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Luna h.",
					"to": "Daneş Hm.",
					"leavesAt": "20:02",
					"arrivesAt": "20:09",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Daneş Hm.",
					"to": "Sighişoara",
					"leavesAt": "20:10",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1538",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Câmpia Turzii",
					"leavesAt": "13:30",
					"arrivesAt": "14:38",
					"waitsAtSource": 0,
					"distance": 51500
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "14:39",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "14:56",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Aiud Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "15:18",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Blaj",
					"leavesAt": "15:36",
					"arrivesAt": "16:04",
					"waitsAtSource": 240,
					"distance": 21300
				},
				{
					"from": "Blaj",
					"to": "Valea Lungă Hm.",
					"leavesAt": "16:05",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Copşa Mică",
					"leavesAt": "16:17",
					"arrivesAt": "16:43",
					"waitsAtSource": 30,
					"distance": 17900
				},
				{
					"from": "Copşa Mică",
					"to": "Mediaş",
					"leavesAt": "16:44",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Mediaş",
					"to": "Sighişoara",
					"leavesAt": "16:58",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 38400
				},
				{
					"from": "Sighişoara",
					"to": "Braşov",
					"leavesAt": "17:51",
					"arrivesAt": "20:26",
					"waitsAtSource": 180,
					"distance": 127400
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "20:34",
					"arrivesAt": "21:09",
					"waitsAtSource": 480,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "21:11",
					"arrivesAt": "21:20",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "21:21",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "21:28",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "21:37",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "22:01",
					"arrivesAt": "22:23",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "22:24",
					"arrivesAt": "23:04",
					"waitsAtSource": 60,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3076",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Est",
					"leavesAt": "15:30",
					"arrivesAt": "15:36",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Oradea Est",
					"to": "Oşorhei Hm.",
					"leavesAt": "15:37",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Săcădat h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Săcădat h.",
					"to": "Săbolciu h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săbolciu h.",
					"to": "Tileagd",
					"leavesAt": "15:55",
					"arrivesAt": "16:02",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tileagd",
					"to": "Telechiu Hm.",
					"leavesAt": "16:03",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Telechiu Hm.",
					"to": "Ţeţchea hc.",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ţeţchea hc.",
					"to": "Aleşd",
					"leavesAt": "16:16",
					"arrivesAt": "16:20",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Aleşd",
					"to": "Aleşd h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aleşd h.",
					"to": "Butan h.",
					"leavesAt": "16:27",
					"arrivesAt": "16:32",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Butan h.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "16:33",
					"arrivesAt": "16:41",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Vadu Crişului h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:49",
					"waitsAtSource": 240,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului h.",
					"to": "Peştera h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:54",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Peştera h.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "16:55",
					"arrivesAt": "17:00",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bălnaca h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:09",
					"waitsAtSource": 300,
					"distance": 4000
				},
				{
					"from": "Bălnaca h.",
					"to": "Bratca",
					"leavesAt": "17:10",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Bratca",
					"to": "Stâna de Vale h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bulz Hm.",
					"leavesAt": "17:19",
					"arrivesAt": "17:22",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bulz Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "17:26",
					"arrivesAt": "17:31",
					"waitsAtSource": 240,
					"distance": 4000
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Lacu Crişului h.",
					"leavesAt": "17:32",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Negreni h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:41",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Ciucea Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:46",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ciucea Hm.",
					"to": "Valea Drăganului h.",
					"leavesAt": "17:53",
					"arrivesAt": "17:57",
					"waitsAtSource": 420,
					"distance": 4100
				},
				{
					"from": "Valea Drăganului h.",
					"to": "Poieni",
					"leavesAt": "17:58",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Poieni",
					"to": "Bologa h.",
					"leavesAt": "18:03",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Bologa h.",
					"to": "Brăişoru Hm.",
					"leavesAt": "18:07",
					"arrivesAt": "18:11",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Huedin",
					"leavesAt": "18:12",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Huedin",
					"to": "Jebuc h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Jebuc h.",
					"to": "Stana Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:34",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Stana Hm.",
					"to": "Gălăşeni h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Gălăşeni h.",
					"to": "Aghireş h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:46",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "18:47",
					"arrivesAt": "18:51",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Dorolţu h.",
					"leavesAt": "18:52",
					"arrivesAt": "18:54",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Dorolţu h.",
					"to": "Macău h.",
					"leavesAt": "18:55",
					"arrivesAt": "18:57",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Macău h.",
					"to": "Gârbău Hm.",
					"leavesAt": "18:58",
					"arrivesAt": "19:02",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Gârbău Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "19:03",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Nădăşel h.",
					"to": "Mera Hm.",
					"leavesAt": "19:09",
					"arrivesAt": "19:12",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mera Hm.",
					"to": "Rădaia h.",
					"leavesAt": "19:13",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rădaia h.",
					"to": "Suceag h.",
					"leavesAt": "19:16",
					"arrivesAt": "19:18",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Suceag h.",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "19:19",
					"arrivesAt": "19:23",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "19:24",
					"arrivesAt": "19:30",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9063",
			"segments": [
				{
					"from": "Caracal",
					"to": "Canton 239+700 h.",
					"leavesAt": "14:20",
					"arrivesAt": "14:22",
					"waitsAtSource": 0,
					"distance": 1400
				},
				{
					"from": "Canton 239+700 h.",
					"to": "Deveselu h.",
					"leavesAt": "14:23",
					"arrivesAt": "14:32",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Deveselu h.",
					"to": "Frăsinet hc.",
					"leavesAt": "14:33",
					"arrivesAt": "14:41",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Frăsinet hc.",
					"to": "Studiniţa h.",
					"leavesAt": "14:42",
					"arrivesAt": "14:46",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Studiniţa h.",
					"to": "Studina hc.",
					"leavesAt": "14:47",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Studina hc.",
					"to": "Vişina h.",
					"leavesAt": "14:53",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Vişina h.",
					"to": "Vişina Veche hc.",
					"leavesAt": "15:01",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vişina Veche hc.",
					"to": "Corabia",
					"leavesAt": "15:05",
					"arrivesAt": "15:20",
					"waitsAtSource": 30,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4085",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "19:35",
					"arrivesAt": "19:42",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "19:49",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "19:57",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Zalău Nord",
					"to": "Guruslău h.",
					"leavesAt": "20:16",
					"arrivesAt": "20:23",
					"waitsAtSource": 120,
					"distance": 6700
				},
				{
					"from": "Guruslău h.",
					"to": "Borla Hm.",
					"leavesAt": "20:24",
					"arrivesAt": "20:29",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Borla Hm.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "20:30",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:38",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Sărmăşag",
					"leavesAt": "20:39",
					"arrivesAt": "20:46",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Sărmăşag",
					"to": "Sărmăşag h.",
					"leavesAt": "20:47",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sărmăşag h.",
					"to": "Derşida h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:55",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Derşida h.",
					"to": "Giorocuţa h.",
					"leavesAt": "20:56",
					"arrivesAt": "21:01",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Giorocuţa h.",
					"to": "Supur h.",
					"leavesAt": "21:02",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Supur h.",
					"to": "Supur Haltă hc.",
					"leavesAt": "21:06",
					"arrivesAt": "21:08",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Supur Haltă hc.",
					"to": "Acâş Hm.",
					"leavesAt": "21:09",
					"arrivesAt": "21:16",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Acâş Hm.",
					"to": "Săcăşeni h.",
					"leavesAt": "21:37",
					"arrivesAt": "21:48",
					"waitsAtSource": 1260,
					"distance": 10000
				},
				{
					"from": "Săcăşeni h.",
					"to": "Tăşnad",
					"leavesAt": "21:49",
					"arrivesAt": "21:56",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Tăşnad",
					"to": "Santău h.",
					"leavesAt": "21:57",
					"arrivesAt": "22:03",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Santău h.",
					"to": "Hotoan h.",
					"leavesAt": "22:04",
					"arrivesAt": "22:10",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Hotoan h.",
					"to": "Tiream h.",
					"leavesAt": "22:11",
					"arrivesAt": "22:17",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tiream h.",
					"to": "Carei",
					"leavesAt": "22:18",
					"arrivesAt": "22:32",
					"waitsAtSource": 30,
					"distance": 11700
				},
				{
					"from": "Carei",
					"to": "Domăneşti h.",
					"leavesAt": "22:42",
					"arrivesAt": "22:49",
					"waitsAtSource": 600,
					"distance": 9900
				},
				{
					"from": "Domăneşti h.",
					"to": "Moftin h.",
					"leavesAt": "22:50",
					"arrivesAt": "22:53",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Moftin h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "22:54",
					"arrivesAt": "22:57",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Sătmărel h.",
					"leavesAt": "22:58",
					"arrivesAt": "23:06",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Sătmărel h.",
					"to": "Satu Mare Sud",
					"leavesAt": "23:07",
					"arrivesAt": "23:14",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Satu Mare Sud",
					"to": "Satu Mare",
					"leavesAt": "23:15",
					"arrivesAt": "23:22",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4543",
			"segments": [
				{
					"from": "Deda",
					"to": "Ruşii Munţi h.",
					"leavesAt": "05:04",
					"arrivesAt": "05:10",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "05:11",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Halta Aluniş h.",
					"leavesAt": "05:15",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Ideciu de Jos h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Reghin",
					"leavesAt": "05:30",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Reghin",
					"to": "Petelea h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:48",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Petelea h.",
					"to": "Periş Mureş h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:54",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Periş Mureş h.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "06:01",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Târgu Mureş",
					"leavesAt": "06:31",
					"arrivesAt": "06:39",
					"waitsAtSource": 720,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9480",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:45",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "05:46",
					"arrivesAt": "05:52",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Slatina",
					"leavesAt": "05:53",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "06:08",
					"arrivesAt": "06:17",
					"waitsAtSource": 120,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "06:18",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "06:28",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9024",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "03:50",
					"arrivesAt": "03:54",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "03:55",
					"arrivesAt": "04:00",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "04:01",
					"arrivesAt": "04:09",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "04:10",
					"arrivesAt": "04:16",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "04:17",
					"arrivesAt": "04:25",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "04:26",
					"arrivesAt": "04:34",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "04:35",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Potcoava",
					"to": "Sineşti Hm.",
					"leavesAt": "04:44",
					"arrivesAt": "04:50",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sineşti Hm.",
					"to": "Corbu",
					"leavesAt": "04:51",
					"arrivesAt": "04:58",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Corbu",
					"to": "Hârseşti Hm.",
					"leavesAt": "05:03",
					"arrivesAt": "05:10",
					"waitsAtSource": 300,
					"distance": 5100
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "05:11",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stolnici Hm.",
					"to": "Fâlfani Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Costeşti",
					"leavesAt": "05:29",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Costeşti",
					"to": "Pârvu h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Pârvu h.",
					"to": "Pârvu Hm.",
					"leavesAt": "05:47",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Pârvu Hm.",
					"to": "Bradu de Sus",
					"leavesAt": "05:57",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bradu de Sus",
					"to": "Km. 109+000 h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:11",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Km. 109+000 h.",
					"to": "Piteşti",
					"leavesAt": "06:12",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Piteşti",
					"to": "Km. 107+000 h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:43",
					"waitsAtSource": 1500,
					"distance": 1000
				},
				{
					"from": "Km. 107+000 h.",
					"to": "Ram. Goleşti",
					"leavesAt": "06:44",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Ram. Goleşti",
					"to": "Goleşti",
					"leavesAt": "06:50",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Goleşti",
					"to": "Canton 97+770 h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:03",
					"waitsAtSource": 120,
					"distance": 2600
				},
				{
					"from": "Canton 97+770 h.",
					"to": "Călineşti Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:10",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Călineşti Hm.",
					"to": "Leordeni Argeş",
					"leavesAt": "07:11",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Leordeni Argeş",
					"to": "Pătroaia Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pătroaia Hm.",
					"to": "Găeşti",
					"leavesAt": "07:28",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Găeşti",
					"to": "Găeşti Sud h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:51",
					"waitsAtSource": 600,
					"distance": 4000
				},
				{
					"from": "Găeşti Sud h.",
					"to": "Cojocaru h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:56",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Cojocaru h.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "07:57",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Fusea Hm.",
					"leavesAt": "08:03",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Fusea Hm.",
					"to": "Titu",
					"leavesAt": "08:09",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "08:20",
					"arrivesAt": "08:25",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "08:26",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "08:36",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "08:43",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "08:51",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "09:00",
					"arrivesAt": "09:06",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "09:07",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "09:12",
					"arrivesAt": "09:20",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7401",
			"segments": [
				{
					"from": "Buzău",
					"to": "Tăbărăşti h.",
					"leavesAt": "05:11",
					"arrivesAt": "05:20",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:23",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Bentu h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bentu h.",
					"to": "Cilibia Hm.",
					"leavesAt": "05:29",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cilibia Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Movila Oii h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "05:39",
					"arrivesAt": "05:45",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Vizireni h.",
					"leavesAt": "05:46",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vizireni h.",
					"to": "Făurei",
					"leavesAt": "05:50",
					"arrivesAt": "05:59",
					"waitsAtSource": 30,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2088",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Lunca Jiului hc.",
					"leavesAt": "19:10",
					"arrivesAt": "19:13",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Lunca Jiului hc.",
					"to": "Livezeni",
					"leavesAt": "19:14",
					"arrivesAt": "19:19",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "19:20",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Pietrele Albe Hm.",
					"leavesAt": "19:27",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Pietrele Albe Hm.",
					"to": "Km. 105+600 h.",
					"leavesAt": "19:37",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Km. 105+600 h.",
					"to": "Lainici Hm.",
					"leavesAt": "19:42",
					"arrivesAt": "19:49",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Lainici Hm.",
					"to": "Meri",
					"leavesAt": "19:50",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Meri",
					"to": "Valea Sadului Hm.",
					"leavesAt": "20:00",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Bumbeşti Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bumbeşti Hm.",
					"to": "Parângu Hm.",
					"leavesAt": "20:13",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Parângu Hm.",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "20:21",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Ramificaţia C.A.M. h.",
					"leavesAt": "20:28",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ramificaţia C.A.M. h.",
					"to": "Târgu Jiu",
					"leavesAt": "20:32",
					"arrivesAt": "20:36",
					"waitsAtSource": 30,
					"distance": 800
				},
				{
					"from": "Târgu Jiu",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "20:44",
					"arrivesAt": "20:51",
					"waitsAtSource": 480,
					"distance": 6800
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Budieni h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Budieni h.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "20:57",
					"arrivesAt": "21:02",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Scoarţa h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:10",
					"waitsAtSource": 300,
					"distance": 2800
				},
				{
					"from": "Scoarţa h.",
					"to": "Pojogeni Hm.",
					"leavesAt": "21:11",
					"arrivesAt": "21:14",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "21:15",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cărbuneşti",
					"to": "Jupâneşti Hm.",
					"leavesAt": "21:23",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "21:29",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "21:36",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Musculeşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "21:47",
					"arrivesAt": "21:52",
					"waitsAtSource": 300,
					"distance": 4600
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "21:53",
					"arrivesAt": "22:01",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Gilort Hm.",
					"leavesAt": "22:02",
					"arrivesAt": "22:08",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gilort Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "22:09",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Floreşti hc.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "22:13",
					"arrivesAt": "22:18",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Filiaşi",
					"leavesAt": "22:19",
					"arrivesAt": "22:25",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "22:26",
					"arrivesAt": "22:29",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "22:30",
					"arrivesAt": "22:34",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "22:35",
					"arrivesAt": "22:39",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "22:40",
					"arrivesAt": "22:45",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "22:46",
					"arrivesAt": "22:49",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "22:50",
					"arrivesAt": "22:55",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "22:56",
					"arrivesAt": "22:58",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Craiova Triaj hc.",
					"leavesAt": "22:59",
					"arrivesAt": "23:05",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "23:06",
					"arrivesAt": "23:10",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 351
				},
				{
					"from": "20180409",
					"to": "20180526",
					"daysOfWeek": 351
				},
				{
					"from": "20180528",
					"to": "20181208",
					"daysOfWeek": 351
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 351
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3514",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Coşlariu Gr. P. Mureş",
					"leavesAt": "14:12",
					"arrivesAt": "14:19",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Coşlariu Gr. P. Mureş",
					"to": "Mihalţ h.",
					"leavesAt": "14:20",
					"arrivesAt": "14:23",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Mihalţ h.",
					"to": "Cistei h.",
					"leavesAt": "14:24",
					"arrivesAt": "14:29",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Cistei h.",
					"to": "Crăciunel Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:40",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Crăciunel Hm.",
					"to": "Blaj",
					"leavesAt": "14:41",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Blaj",
					"to": "Câmpu Libertăţii  h.",
					"leavesAt": "14:51",
					"arrivesAt": "14:55",
					"waitsAtSource": 120,
					"distance": 3500
				},
				{
					"from": "Câmpu Libertăţii  h.",
					"to": "Mănărade h.",
					"leavesAt": "14:56",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Mănărade h.",
					"to": "Glogoveţ h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Glogoveţ h.",
					"to": "Valea Lungă Hm.",
					"leavesAt": "15:05",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Lunca h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Lunca h.",
					"to": "Micăsasa h.",
					"leavesAt": "15:14",
					"arrivesAt": "15:23",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Micăsasa h.",
					"to": "Copşa Mică",
					"leavesAt": "15:24",
					"arrivesAt": "15:41",
					"waitsAtSource": 30,
					"distance": 10200
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "15:50",
					"arrivesAt": "15:57",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2233",
			"segments": [
				{
					"from": "Remetea Mică",
					"to": "Fibiş h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:26",
					"waitsAtSource": 0,
					"distance": 4300
				},
				{
					"from": "Fibiş h.",
					"to": "Bencei h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bencei h.",
					"to": "Pişchia h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pişchia h.",
					"to": "Cerneteaz h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Cerneteaz h.",
					"to": "Giarmata Hm.",
					"leavesAt": "06:51",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Giarmata Hm.",
					"to": "Viile Giarmata h.",
					"leavesAt": "06:55",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Viile Giarmata h.",
					"to": "Timişoara Est",
					"leavesAt": "07:01",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "07:12",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5502",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "08:00",
					"arrivesAt": "08:05",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "08:07",
					"arrivesAt": "08:14",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "08:15",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "08:23",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "08:43",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "08:53",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "08:59",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "09:05",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "09:11",
					"arrivesAt": "09:17",
					"waitsAtSource": 60,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1744",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Seini",
					"leavesAt": "00:45",
					"arrivesAt": "01:21",
					"waitsAtSource": 0,
					"distance": 24600
				},
				{
					"from": "Seini",
					"to": "Satu Mare",
					"leavesAt": "01:22",
					"arrivesAt": "02:01",
					"waitsAtSource": 60,
					"distance": 34800
				},
				{
					"from": "Satu Mare",
					"to": "Carei",
					"leavesAt": "02:06",
					"arrivesAt": "02:36",
					"waitsAtSource": 300,
					"distance": 36000
				},
				{
					"from": "Carei",
					"to": "Valea lui Mihai",
					"leavesAt": "02:37",
					"arrivesAt": "03:00",
					"waitsAtSource": 60,
					"distance": 31200
				},
				{
					"from": "Valea lui Mihai",
					"to": "Săcuieni Bihor",
					"leavesAt": "03:01",
					"arrivesAt": "03:18",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Oradea",
					"leavesAt": "03:19",
					"arrivesAt": "04:05",
					"waitsAtSource": 60,
					"distance": 44200
				},
				{
					"from": "Oradea",
					"to": "Salonta",
					"leavesAt": "04:16",
					"arrivesAt": "04:57",
					"waitsAtSource": 660,
					"distance": 39200
				},
				{
					"from": "Salonta",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "04:59",
					"arrivesAt": "05:12",
					"waitsAtSource": 120,
					"distance": 10200
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Chişineu Criş",
					"leavesAt": "05:19",
					"arrivesAt": "05:42",
					"waitsAtSource": 420,
					"distance": 23700
				},
				{
					"from": "Chişineu Criş",
					"to": "Sântana",
					"leavesAt": "05:43",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Sântana",
					"to": "Arad",
					"leavesAt": "06:02",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "06:31",
					"arrivesAt": "06:38",
					"waitsAtSource": 240,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Vinga Hm.",
					"leavesAt": "06:39",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 18400
				},
				{
					"from": "Vinga Hm.",
					"to": "Timişoara Nord",
					"leavesAt": "07:03",
					"arrivesAt": "07:28",
					"waitsAtSource": 300,
					"distance": 32600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9575",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Tibiscu h.",
					"leavesAt": "13:06",
					"arrivesAt": "13:09",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Tibiscu h.",
					"to": "Zăgujeni Hm.",
					"leavesAt": "13:10",
					"arrivesAt": "13:13",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Căvăran",
					"leavesAt": "13:14",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Căvăran",
					"to": "Sacu h.",
					"leavesAt": "13:26",
					"arrivesAt": "13:29",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Sacu h.",
					"to": "Jena Hm.",
					"leavesAt": "13:30",
					"arrivesAt": "13:34",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Jena Hm.",
					"to": "Găvojdia",
					"leavesAt": "13:35",
					"arrivesAt": "13:46",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Găvojdia",
					"to": "Tapia Hm.",
					"leavesAt": "13:47",
					"arrivesAt": "13:51",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tapia Hm.",
					"to": "Lugoj",
					"leavesAt": "13:52",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lugoj",
					"to": "Jabăr Hm.",
					"leavesAt": "13:59",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "14:13",
					"arrivesAt": "14:18",
					"waitsAtSource": 480,
					"distance": 5600
				},
				{
					"from": "Belinţ Hm.",
					"to": "Chizătău Hm.",
					"leavesAt": "14:19",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Chizătău Hm.",
					"to": "Topolovăţ",
					"leavesAt": "14:24",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Topolovăţ",
					"to": "Şuştra h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:37",
					"waitsAtSource": 240,
					"distance": 3700
				},
				{
					"from": "Şuştra h.",
					"to": "Recaş",
					"leavesAt": "14:38",
					"arrivesAt": "14:44",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Recaş",
					"to": "Izvin h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:00",
					"waitsAtSource": 780,
					"distance": 2200
				},
				{
					"from": "Izvin h.",
					"to": "Remetea Mare",
					"leavesAt": "15:01",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Remetea Mare",
					"to": "Timişoara Est",
					"leavesAt": "15:10",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "15:25",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9347",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "15:24",
					"arrivesAt": "15:27",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureştii Noi",
					"leavesAt": "15:28",
					"arrivesAt": "15:35",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Bucureştii Noi",
					"to": "Chiajna",
					"leavesAt": "15:36",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiajna",
					"to": "Domneştii de Sus h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Grădinari",
					"leavesAt": "15:53",
					"arrivesAt": "16:03",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Grădinari",
					"to": "Zorile h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:08",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Zorile h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "16:09",
					"arrivesAt": "16:18",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "16:27",
					"arrivesAt": "16:31",
					"waitsAtSource": 540,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Zăvestreni Hm.",
					"leavesAt": "16:32",
					"arrivesAt": "16:37",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Videle",
					"leavesAt": "16:38",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Videle",
					"to": "Răduleşti Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:55",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "16:56",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Târnavele Hm.",
					"to": "Vlaşca Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Răsuceni h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Răsuceni h.",
					"to": "Toporu",
					"leavesAt": "17:21",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Toporu",
					"to": "Chiriacu Hm.",
					"leavesAt": "17:34",
					"arrivesAt": "17:45",
					"waitsAtSource": 540,
					"distance": 10600
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Stăneşti Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Onceşti h.",
					"leavesAt": "17:54",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Onceşti h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "18:00",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Cetatea h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cetatea h.",
					"to": "Giurgiu Nord",
					"leavesAt": "18:11",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Giurgiu Nord",
					"to": "Giurgiu",
					"leavesAt": "18:18",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "1384",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "10:50",
					"arrivesAt": "10:55",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava Nord",
					"to": "Dărmăneşti",
					"leavesAt": "10:56",
					"arrivesAt": "11:06",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dărmăneşti",
					"to": "Milişăuţi Hm.",
					"leavesAt": "11:07",
					"arrivesAt": "11:17",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Dorneşti",
					"leavesAt": "11:18",
					"arrivesAt": "11:32",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Dorneşti",
					"to": "Vicşani",
					"leavesAt": "11:33",
					"arrivesAt": "11:47",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Vicşani",
					"to": "Vadu Siretului",
					"leavesAt": "12:43",
					"arrivesAt": "13:05",
					"waitsAtSource": 3360,
					"distance": 10600
				}
			],
			"restrictions": [
				{
					"from": "20180614",
					"to": "20180617",
					"daysOfWeek": 383
				},
				{
					"from": "20180619",
					"to": "20180624",
					"daysOfWeek": 383
				},
				{
					"from": "20180626",
					"to": "20180629",
					"daysOfWeek": 383
				},
				{
					"from": "20180701",
					"to": "20180706",
					"daysOfWeek": 383
				},
				{
					"from": "20180708",
					"to": "20180711",
					"daysOfWeek": 383
				},
				{
					"from": "20180713",
					"to": "20180718",
					"daysOfWeek": 383
				},
				{
					"from": "20180720",
					"to": "20180723",
					"daysOfWeek": 383
				},
				{
					"from": "20180725",
					"to": "20180730",
					"daysOfWeek": 383
				},
				{
					"from": "20180801",
					"to": "20180804",
					"daysOfWeek": 383
				},
				{
					"from": "20180806",
					"to": "20180811",
					"daysOfWeek": 383
				},
				{
					"from": "20180813",
					"to": "20180816",
					"daysOfWeek": 383
				},
				{
					"from": "20180818",
					"to": "20180823",
					"daysOfWeek": 383
				},
				{
					"from": "20180825",
					"to": "20180828",
					"daysOfWeek": 383
				},
				{
					"from": "20180830",
					"to": "20180904",
					"daysOfWeek": 383
				},
				{
					"from": "20180906",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180911",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180612",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4501",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "03:58",
					"arrivesAt": "04:02",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "04:03",
					"arrivesAt": "04:08",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Prejmer Hm.",
					"leavesAt": "04:09",
					"arrivesAt": "04:17",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ozun Hm.",
					"leavesAt": "04:18",
					"arrivesAt": "04:26",
					"waitsAtSource": 30,
					"distance": 8600
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "04:27",
					"arrivesAt": "04:36",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Arcuş h.",
					"leavesAt": "05:12",
					"arrivesAt": "05:17",
					"waitsAtSource": 2160,
					"distance": 5000
				},
				{
					"from": "Arcuş h.",
					"to": "Bodoc Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:23",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Bodoc Hm.",
					"to": "Malnaş h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Malnaş h.",
					"to": "Malnaş Băi",
					"leavesAt": "05:32",
					"arrivesAt": "05:38",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Malnaş Băi",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "05:39",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Tuşnad Sat",
					"leavesAt": "05:58",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tuşnad Sat",
					"to": "Vrabia h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Vrabia h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:16",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "06:21",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "06:26",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "07:28",
					"arrivesAt": "07:37",
					"waitsAtSource": 3240,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Racu h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:45",
					"waitsAtSource": 300,
					"distance": 2200
				},
				{
					"from": "Racu h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "07:46",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Dăneşti h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:06",
					"waitsAtSource": 420,
					"distance": 3000
				},
				{
					"from": "Dăneşti h.",
					"to": "Cârţani h.",
					"leavesAt": "08:07",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cârţani h.",
					"to": "Tomeşti h.",
					"leavesAt": "08:11",
					"arrivesAt": "08:14",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Izvoru Oltului",
					"leavesAt": "08:15",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Izvoru Oltului",
					"to": "Sândominic h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:26",
					"waitsAtSource": 180,
					"distance": 3100
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "08:27",
					"arrivesAt": "08:36",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "08:37",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Şugău h.",
					"leavesAt": "08:49",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şugău h.",
					"to": "Valea Strâmbă h.",
					"leavesAt": "08:53",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Gheorgheni",
					"leavesAt": "08:57",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5209",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "17:14",
					"arrivesAt": "17:20",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "17:25",
					"arrivesAt": "17:30",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "17:35",
					"arrivesAt": "17:46",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Urecheşti Hm.",
					"leavesAt": "17:56",
					"arrivesAt": "18:05",
					"waitsAtSource": 600,
					"distance": 9700
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Bâlca hc.",
					"leavesAt": "18:10",
					"arrivesAt": "18:14",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Bâlca hc.",
					"to": "Căiuţi Hm.",
					"leavesAt": "18:15",
					"arrivesAt": "18:19",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Borzeşti Bacău",
					"leavesAt": "18:20",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "18:30",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Oneşti",
					"leavesAt": "18:34",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Oneşti",
					"to": "Trotuş h.",
					"leavesAt": "18:42",
					"arrivesAt": "18:49",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Trotuş h.",
					"to": "Viişoara h",
					"leavesAt": "18:50",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Viişoara h",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "18:54",
					"arrivesAt": "18:59",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Saline hc.",
					"leavesAt": "19:06",
					"arrivesAt": "19:08",
					"waitsAtSource": 420,
					"distance": 1500
				},
				{
					"from": "Saline hc.",
					"to": "Cireşoaia h.",
					"leavesAt": "19:09",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cireşoaia h.",
					"to": "Dofteana Bacău",
					"leavesAt": "19:16",
					"arrivesAt": "19:22",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dofteana Bacău",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "19:23",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Valea Uzului Hm.",
					"leavesAt": "19:30",
					"arrivesAt": "19:35",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Comăneşti",
					"leavesAt": "19:36",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Comăneşti",
					"to": "Asău Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:08",
					"waitsAtSource": 1140,
					"distance": 5100
				},
				{
					"from": "Asău Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Caraliţa h.",
					"to": "Goioasa Hm.",
					"leavesAt": "20:15",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Goioasa Hm.",
					"to": "Simbrea Hm.",
					"leavesAt": "20:21",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Simbrea Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "20:30",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Palanca Hm.",
					"leavesAt": "20:36",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Palanca Hm.",
					"to": "Ghimeş",
					"leavesAt": "20:42",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Ghimeş",
					"to": "Bolovăniş h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "20:58",
					"arrivesAt": "21:04",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Tarcău h.",
					"leavesAt": "21:05",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "21:10",
					"arrivesAt": "21:15",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Utuşoiu h.",
					"leavesAt": "21:16",
					"arrivesAt": "21:21",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Utuşoiu h.",
					"to": "Livezi Ciuc",
					"leavesAt": "21:22",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Caracău h.",
					"leavesAt": "21:31",
					"arrivesAt": "21:34",
					"waitsAtSource": 180,
					"distance": 2100
				},
				{
					"from": "Caracău h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "21:35",
					"arrivesAt": "21:42",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "21:43",
					"arrivesAt": "21:47",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Mihăileni Hm.",
					"leavesAt": "21:48",
					"arrivesAt": "21:52",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Siculeni",
					"leavesAt": "21:53",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1756",
			"segments": [
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "22:16",
					"arrivesAt": "22:29",
					"waitsAtSource": 0,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "22:44",
					"arrivesAt": "23:03",
					"waitsAtSource": 900,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "23:04",
					"arrivesAt": "23:20",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Roman",
					"leavesAt": "23:23",
					"arrivesAt": "23:50",
					"waitsAtSource": 180,
					"distance": 40200
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "23:51",
					"arrivesAt": "00:20",
					"waitsAtSource": 60,
					"distance": 43800
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "00:35",
					"arrivesAt": "01:15",
					"waitsAtSource": 900,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "01:16",
					"arrivesAt": "01:43",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "01:45",
					"arrivesAt": "02:06",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "02:08",
					"arrivesAt": "02:45",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "02:47",
					"arrivesAt": "03:18",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "03:20",
					"arrivesAt": "03:52",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "03:53",
					"arrivesAt": "04:28",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "04:31",
					"arrivesAt": "05:23",
					"waitsAtSource": 180,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9475",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Bradu de Sus",
					"leavesAt": "16:25",
					"arrivesAt": "16:30",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bradu de Sus",
					"to": "Pârvu Hm.",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Pârvu Hm.",
					"to": "Pârvu h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Pârvu h.",
					"to": "Suseni h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:45",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Suseni h.",
					"to": "Costeşti",
					"leavesAt": "16:46",
					"arrivesAt": "16:55",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Costeşti",
					"to": "Fâlfani Hm.",
					"leavesAt": "16:56",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Stolnici Hm.",
					"to": "Hârseşti Hm.",
					"leavesAt": "17:14",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Corbu",
					"leavesAt": "17:20",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Corbu",
					"to": "Sineşti Hm.",
					"leavesAt": "17:31",
					"arrivesAt": "17:37",
					"waitsAtSource": 300,
					"distance": 6000
				},
				{
					"from": "Sineşti Hm.",
					"to": "Potcoava",
					"leavesAt": "17:38",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Potcoava",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "17:59",
					"waitsAtSource": 300,
					"distance": 7600
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Recea Hm.",
					"leavesAt": "18:00",
					"arrivesAt": "18:07",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Recea Hm.",
					"to": "Slatina",
					"leavesAt": "18:08",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Slatina",
					"to": "Milcov Hm.",
					"leavesAt": "18:17",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Milcov Hm.",
					"to": "Slătioara Hm.",
					"leavesAt": "18:24",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "18:31",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "18:35",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9344",
			"segments": [
				{
					"from": "Giurgiu",
					"to": "Giurgiu Nord",
					"leavesAt": "11:40",
					"arrivesAt": "11:45",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Giurgiu Nord",
					"to": "Cetatea h.",
					"leavesAt": "11:46",
					"arrivesAt": "11:49",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cetatea h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "11:50",
					"arrivesAt": "11:53",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Onceşti h.",
					"leavesAt": "11:54",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Onceşti h.",
					"to": "Stăneşti Hm.",
					"leavesAt": "11:58",
					"arrivesAt": "12:03",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Chiriacu Hm.",
					"leavesAt": "12:04",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Toporu",
					"leavesAt": "12:12",
					"arrivesAt": "12:22",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Toporu",
					"to": "Răsuceni h.",
					"leavesAt": "12:23",
					"arrivesAt": "12:25",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Răsuceni h.",
					"to": "Vlaşca Hm.",
					"leavesAt": "12:26",
					"arrivesAt": "12:33",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "12:34",
					"arrivesAt": "12:42",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Târnavele Hm.",
					"to": "Răduleşti Hm.",
					"leavesAt": "12:43",
					"arrivesAt": "12:54",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Videle",
					"leavesAt": "12:55",
					"arrivesAt": "13:05",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5026",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Brazi",
					"leavesAt": "14:40",
					"arrivesAt": "14:54",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "14:55",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "15:02",
					"arrivesAt": "15:07",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:19",
					"waitsAtSource": 480,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "15:20",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "15:34",
					"arrivesAt": "15:38",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "15:39",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "15:49",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "15:53",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "16:02",
					"arrivesAt": "16:04",
					"waitsAtSource": 300,
					"distance": 1900
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Bucureşti Nord",
					"leavesAt": "16:05",
					"arrivesAt": "16:11",
					"waitsAtSource": 30,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9696",
			"segments": [
				{
					"from": "Anina",
					"to": "Gârlişte Hm.",
					"leavesAt": "14:40",
					"arrivesAt": "15:09",
					"waitsAtSource": 0,
					"distance": 8100
				},
				{
					"from": "Gârlişte Hm.",
					"to": "Ciudanoviţa Pam.",
					"leavesAt": "15:10",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Ciudanoviţa Pam.",
					"to": "Lişava Hm.",
					"leavesAt": "15:36",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 1200
				},
				{
					"from": "Lişava Hm.",
					"to": "Dobrei hcv.",
					"leavesAt": "15:42",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dobrei hcv.",
					"to": "Brădişoru de Jos h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Brădişoru de Jos h.",
					"to": "Oraviţa",
					"leavesAt": "16:19",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20180401",
					"to": "20180930",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2713",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Dep Petroşani h.",
					"leavesAt": "18:50",
					"arrivesAt": "18:53",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Peştera Bolii h.",
					"leavesAt": "18:54",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Băniţa",
					"leavesAt": "19:00",
					"arrivesAt": "19:07",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Băniţa",
					"to": "Merişor Hm.",
					"leavesAt": "19:08",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Merişor Hm.",
					"to": "Crivadia Hm.",
					"leavesAt": "19:20",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Crivadia Hm.",
					"to": "Baru Mare h.",
					"leavesAt": "19:30",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Baru Mare h.",
					"to": "Baru Mare",
					"leavesAt": "19:37",
					"arrivesAt": "19:43",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Baru Mare",
					"to": "Livadia h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Livadia h.",
					"to": "Ponor h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:50",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ponor h.",
					"to": "Pui",
					"leavesAt": "19:51",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Pui",
					"to": "Ruşor h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Ruşor h.",
					"to": "Băeşti Hm.",
					"leavesAt": "20:02",
					"arrivesAt": "20:05",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Ciopea h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:11",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ciopea h.",
					"to": "Subcetate",
					"leavesAt": "20:12",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Subcetate",
					"to": "Covragiu h.",
					"leavesAt": "20:17",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Covragiu h.",
					"to": "Plopi h.",
					"leavesAt": "20:20",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Plopi h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "20:23",
					"arrivesAt": "20:25",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Măceu h.",
					"leavesAt": "20:26",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măceu h.",
					"to": "Ruşi h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:31",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ruşi h.",
					"to": "Călan Hm.",
					"leavesAt": "20:32",
					"arrivesAt": "20:42",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Călan Hm.",
					"to": "Călan Băi",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Băi",
					"to": "Batiz h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Batiz h.",
					"to": "Băcia Hm.",
					"leavesAt": "20:51",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Băcia Hm.",
					"to": "Băcia h.",
					"leavesAt": "20:54",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Băcia h.",
					"to": "Simeria Triaj",
					"leavesAt": "20:57",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Simeria Triaj",
					"to": "Simeria",
					"leavesAt": "21:01",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "21:09",
					"arrivesAt": "21:20",
					"waitsAtSource": 60,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8025",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "13:20",
					"arrivesAt": "13:29",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "13:30",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Pasărea",
					"leavesAt": "13:36",
					"arrivesAt": "13:41",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pasărea",
					"to": "Brăneşti Sat h.",
					"leavesAt": "13:42",
					"arrivesAt": "13:46",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "13:47",
					"arrivesAt": "13:50",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Islaz h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Islaz h.",
					"to": "Fundulea Hm.",
					"leavesAt": "13:54",
					"arrivesAt": "14:01",
					"waitsAtSource": 30,
					"distance": 9800
				},
				{
					"from": "Fundulea Hm.",
					"to": "Mostiştea h.",
					"leavesAt": "14:02",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Mostiştea h.",
					"to": "Săruleşti",
					"leavesAt": "14:07",
					"arrivesAt": "14:12",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Săruleşti",
					"to": "Preasna h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:18",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Preasna h.",
					"to": "Lehliu",
					"leavesAt": "14:19",
					"arrivesAt": "14:27",
					"waitsAtSource": 30,
					"distance": 8800
				},
				{
					"from": "Lehliu",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:33",
					"waitsAtSource": 120,
					"distance": 5000
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "14:34",
					"arrivesAt": "14:37",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dâlga h.",
					"leavesAt": "14:44",
					"arrivesAt": "14:49",
					"waitsAtSource": 420,
					"distance": 7100
				},
				{
					"from": "Dâlga h.",
					"to": "Bogdana h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Bogdana h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "14:56",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Ivăneşti h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ivăneşti h.",
					"to": "Ciulniţa",
					"leavesAt": "15:07",
					"arrivesAt": "15:13",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:21",
					"waitsAtSource": 120,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "15:26",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "15:30",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "15:34",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "15:44",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "16:12",
					"arrivesAt": "16:18",
					"waitsAtSource": 1140,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Cernavodă Pod",
					"leavesAt": "16:19",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "16:37",
					"arrivesAt": "16:45",
					"waitsAtSource": 180,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "16:53",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:08",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "17:09",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:27",
					"waitsAtSource": 540,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "17:28",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "17:34",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "17:39",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 600,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "17:59",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6313",
			"segments": [
				{
					"from": "Tecuci",
					"to": "Tecuci Nord hc.(600)",
					"leavesAt": "13:38",
					"arrivesAt": "13:41",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Tecuci Nord hc.(600)",
					"to": "Frunzeasca Hm.",
					"leavesAt": "13:42",
					"arrivesAt": "13:47",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Frunzeasca Hm.",
					"to": "Rateş Munteni h.",
					"leavesAt": "13:48",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Rateş Munteni h.",
					"to": "Berheci Hm.",
					"leavesAt": "13:54",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Berheci Hm.",
					"to": "Nichişeni",
					"leavesAt": "14:01",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Nichişeni",
					"to": "Ghidigeni Hm.",
					"leavesAt": "14:12",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ghidigeni Hm.",
					"to": "Tutova",
					"leavesAt": "14:18",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Tutova",
					"to": "Dragalina h.",
					"leavesAt": "14:31",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Dragalina h.",
					"to": "Bârlad",
					"leavesAt": "14:39",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Bârlad",
					"to": "Zorleni",
					"leavesAt": "14:52",
					"arrivesAt": "15:00",
					"waitsAtSource": 180,
					"distance": 7300
				},
				{
					"from": "Zorleni",
					"to": "Banca Hm.",
					"leavesAt": "15:01",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Banca Hm.",
					"to": "Dodeşti hc.",
					"leavesAt": "15:10",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dodeşti hc.",
					"to": "Roşieşti hc.",
					"leavesAt": "15:16",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Roşieşti hc.",
					"to": "Crasna",
					"leavesAt": "15:23",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Crasna",
					"to": "Bulboaca h.",
					"leavesAt": "15:32",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Bulboaca h.",
					"to": "Munteni Hm.",
					"leavesAt": "15:41",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Munteni Hm.",
					"to": "Vaslui",
					"leavesAt": "15:48",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vaslui",
					"to": "Bălteni Hm.",
					"leavesAt": "15:57",
					"arrivesAt": "16:07",
					"waitsAtSource": 180,
					"distance": 9800
				},
				{
					"from": "Bălteni Hm.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bârzeşti h.",
					"leavesAt": "16:14",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bârzeşti h.",
					"to": "Buhăieşti",
					"leavesAt": "16:19",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhăieşti",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 300,
					"distance": 3900
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Rebricea Hm.",
					"leavesAt": "16:37",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebricea Hm.",
					"to": "Scânteia Hm.",
					"leavesAt": "16:48",
					"arrivesAt": "16:54",
					"waitsAtSource": 300,
					"distance": 5500
				},
				{
					"from": "Scânteia Hm.",
					"to": "Grajduri",
					"leavesAt": "16:55",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Grajduri",
					"to": "Bârnova Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Ciurea Hm.",
					"leavesAt": "17:21",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ciurea Hm.",
					"to": "Nicolina",
					"leavesAt": "17:28",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "17:35",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9003",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "12:05",
					"arrivesAt": "12:08",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h.(900)",
					"leavesAt": "12:09",
					"arrivesAt": "12:12",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureştii Noi",
					"leavesAt": "12:13",
					"arrivesAt": "12:17",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Chiajna",
					"leavesAt": "12:18",
					"arrivesAt": "12:22",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiajna",
					"to": "Domneştii de Sus h.",
					"leavesAt": "12:23",
					"arrivesAt": "12:34",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Grădinari",
					"leavesAt": "12:35",
					"arrivesAt": "12:45",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Grădinari",
					"to": "Vadu Lat Hm.",
					"leavesAt": "12:46",
					"arrivesAt": "12:59",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Videle",
					"leavesAt": "13:00",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 14600
				},
				{
					"from": "Videle",
					"to": "Ciolpani Hm.",
					"leavesAt": "13:15",
					"arrivesAt": "13:21",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Gălăteni Hm.",
					"leavesAt": "13:22",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Olteni",
					"leavesAt": "13:31",
					"arrivesAt": "13:36",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Olteni",
					"to": "Vârtoapele hc.",
					"leavesAt": "13:37",
					"arrivesAt": "13:44",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "13:45",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Atârnaţi Hm.",
					"leavesAt": "13:51",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "14:02",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Roşiori Nord",
					"to": "Mihăeşti Hm.",
					"leavesAt": "14:15",
					"arrivesAt": "14:28",
					"waitsAtSource": 120,
					"distance": 17300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Radomireşti Hm.",
					"leavesAt": "14:29",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "14:41",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Stoeneşti h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Stoeneşti h.",
					"to": "Caracal",
					"leavesAt": "14:58",
					"arrivesAt": "15:10",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Caracal",
					"to": "Radomiru hc.",
					"leavesAt": "15:11",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 18800
				},
				{
					"from": "Radomiru hc.",
					"to": "Jianca",
					"leavesAt": "15:26",
					"arrivesAt": "15:30",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jianca",
					"to": "Leu Hm.",
					"leavesAt": "15:31",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Leu Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "15:40",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "15:50",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Bordei hc.(900)",
					"leavesAt": "15:55",
					"arrivesAt": "16:04",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Craiova",
					"leavesAt": "16:05",
					"arrivesAt": "16:12",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3023",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "04:36",
					"arrivesAt": "04:41",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "04:42",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "04:48",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "04:58",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "05:11",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:24",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "05:25",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Posada h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Posada h.",
					"to": "Sinaia Sud h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:44",
					"waitsAtSource": 30,
					"distance": 8900
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "05:45",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "05:49",
					"arrivesAt": "05:53",
					"waitsAtSource": 120,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "05:59",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "06:05",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "06:17",
					"arrivesAt": "06:32",
					"waitsAtSource": 120,
					"distance": 9900
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Timişu de Jos h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Dârste",
					"leavesAt": "06:41",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "06:50",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5737",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "15:40",
					"arrivesAt": "15:45",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava Nord",
					"to": "Dărmăneşti",
					"leavesAt": "15:46",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dărmăneşti",
					"to": "Părhăuţi h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:08",
					"waitsAtSource": 360,
					"distance": 4400
				},
				{
					"from": "Părhăuţi h.",
					"to": "Todireşti h.",
					"leavesAt": "16:09",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Todireşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "16:18",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Soloneţ h.",
					"to": "Pârteşti h.",
					"leavesAt": "16:26",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Pârteşti h.",
					"to": "Cacica Hm.",
					"leavesAt": "16:33",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3533",
			"segments": [
				{
					"from": "Braşov",
					"to": "Stupini Hm.",
					"leavesAt": "16:10",
					"arrivesAt": "16:19",
					"waitsAtSource": 0,
					"distance": 5400
				},
				{
					"from": "Stupini Hm.",
					"to": "Bod Hm.",
					"leavesAt": "16:20",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Bod Hm.",
					"to": "Feldioara Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Rotbav h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Rotbav h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "16:44",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Măieruş h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Măieruş h.",
					"to": "Apaţa",
					"leavesAt": "16:53",
					"arrivesAt": "17:05",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Apaţa",
					"to": "Ormeniş h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ormeniş h.",
					"to": "Augustin Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:26",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Augustin Hm.",
					"to": "Racoş Hm.",
					"leavesAt": "17:27",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Racoş Hm.",
					"to": "Mateiaş h.",
					"leavesAt": "17:44",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mateiaş h.",
					"to": "Rupea",
					"leavesAt": "17:49",
					"arrivesAt": "18:03",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Rupea",
					"to": "Caţa Hm.",
					"leavesAt": "18:04",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Caţa Hm.",
					"to": "Paloş Ardeal h.",
					"leavesAt": "18:14",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Paloş Ardeal h.",
					"to": "Beia Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:30",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Beia Hm.",
					"to": "Archita h",
					"leavesAt": "18:31",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Archita h",
					"to": "Mureni Hm.",
					"leavesAt": "18:43",
					"arrivesAt": "18:57",
					"waitsAtSource": 30,
					"distance": 9600
				},
				{
					"from": "Mureni Hm.",
					"to": "Saschiz h.",
					"leavesAt": "18:58",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Saschiz h.",
					"to": "Vânători",
					"leavesAt": "19:03",
					"arrivesAt": "19:07",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vânători",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "19:08",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Sighişoara",
					"leavesAt": "19:16",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1944",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "13:28",
					"arrivesAt": "13:46",
					"waitsAtSource": 0,
					"distance": 21200
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Seini",
					"leavesAt": "13:56",
					"arrivesAt": "14:15",
					"waitsAtSource": 600,
					"distance": 13600
				},
				{
					"from": "Seini",
					"to": "Baia Mare",
					"leavesAt": "14:16",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Baia Mare",
					"to": "Ulmeni Sălaj",
					"leavesAt": "15:06",
					"arrivesAt": "15:36",
					"waitsAtSource": 840,
					"distance": 31000
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Benesat Hm.",
					"leavesAt": "15:37",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Benesat Hm.",
					"to": "Jibou",
					"leavesAt": "15:47",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Jibou",
					"to": "Cuciulat Hm.",
					"leavesAt": "16:06",
					"arrivesAt": "16:30",
					"waitsAtSource": 120,
					"distance": 18500
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Ileanda",
					"leavesAt": "16:36",
					"arrivesAt": "17:01",
					"waitsAtSource": 360,
					"distance": 18200
				},
				{
					"from": "Ileanda",
					"to": "Gâlgău",
					"leavesAt": "17:03",
					"arrivesAt": "17:20",
					"waitsAtSource": 120,
					"distance": 16100
				},
				{
					"from": "Gâlgău",
					"to": "Dej Călători",
					"leavesAt": "17:22",
					"arrivesAt": "17:46",
					"waitsAtSource": 120,
					"distance": 23400
				},
				{
					"from": "Dej Călători",
					"to": "Beclean pe Someş",
					"leavesAt": "18:02",
					"arrivesAt": "18:35",
					"waitsAtSource": 960,
					"distance": 24600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Sărăţel Hm.",
					"leavesAt": "18:51",
					"arrivesAt": "19:17",
					"waitsAtSource": 960,
					"distance": 24900
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Deda",
					"leavesAt": "19:20",
					"arrivesAt": "20:16",
					"waitsAtSource": 180,
					"distance": 46800
				},
				{
					"from": "Deda",
					"to": "Topliţa",
					"leavesAt": "20:38",
					"arrivesAt": "21:35",
					"waitsAtSource": 1320,
					"distance": 43900
				},
				{
					"from": "Topliţa",
					"to": "Gălăuţaş Hm.",
					"leavesAt": "21:36",
					"arrivesAt": "21:44",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Gălăuţaş Hm.",
					"to": "Gheorgheni",
					"leavesAt": "21:51",
					"arrivesAt": "22:19",
					"waitsAtSource": 420,
					"distance": 28000
				},
				{
					"from": "Gheorgheni",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "22:22",
					"arrivesAt": "22:38",
					"waitsAtSource": 180,
					"distance": 19100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Izvoru Oltului",
					"leavesAt": "22:41",
					"arrivesAt": "22:54",
					"waitsAtSource": 180,
					"distance": 10900
				},
				{
					"from": "Izvoru Oltului",
					"to": "Siculeni",
					"leavesAt": "23:02",
					"arrivesAt": "23:22",
					"waitsAtSource": 480,
					"distance": 17100
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "23:26",
					"arrivesAt": "23:34",
					"waitsAtSource": 240,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "23:36",
					"arrivesAt": "23:59",
					"waitsAtSource": 120,
					"distance": 28500
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Bodoc Hm.",
					"leavesAt": "00:01",
					"arrivesAt": "00:28",
					"waitsAtSource": 120,
					"distance": 24900
				},
				{
					"from": "Bodoc Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "00:38",
					"arrivesAt": "00:47",
					"waitsAtSource": 600,
					"distance": 9500
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Braşov",
					"leavesAt": "00:50",
					"arrivesAt": "01:20",
					"waitsAtSource": 180,
					"distance": 32100
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "01:40",
					"arrivesAt": "02:15",
					"waitsAtSource": 1200,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "02:25",
					"arrivesAt": "02:34",
					"waitsAtSource": 600,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "02:36",
					"arrivesAt": "02:42",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "02:44",
					"arrivesAt": "02:53",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "02:55",
					"arrivesAt": "03:19",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "03:21",
					"arrivesAt": "03:46",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Băneasa",
					"leavesAt": "03:49",
					"arrivesAt": "04:38",
					"waitsAtSource": 180,
					"distance": 58100
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Feteşti",
					"leavesAt": "04:48",
					"arrivesAt": "06:04",
					"waitsAtSource": 600,
					"distance": 139800
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "06:07",
					"arrivesAt": "06:27",
					"waitsAtSource": 180,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "06:28",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "06:46",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 36000
				},
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:55",
					"waitsAtSource": 1200,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "07:56",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "08:07",
					"arrivesAt": "08:14",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:25",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "08:26",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "08:35",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "08:41",
					"arrivesAt": "08:54",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "08:56",
					"arrivesAt": "09:01",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "09:02",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2071",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Găneasa h.",
					"leavesAt": "03:45",
					"arrivesAt": "03:49",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Găneasa h.",
					"to": "Găneasa Olt h.",
					"leavesAt": "03:50",
					"arrivesAt": "03:53",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Găneasa Olt h.",
					"to": "Arceşti Hm.",
					"leavesAt": "03:54",
					"arrivesAt": "03:59",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Arceşti Hm.",
					"to": "Colibaşi h.",
					"leavesAt": "04:00",
					"arrivesAt": "04:07",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Colibaşi h.",
					"to": "Strejeşti",
					"leavesAt": "04:08",
					"arrivesAt": "04:15",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Strejeşti",
					"to": "Zlătărei Hm.",
					"leavesAt": "04:16",
					"arrivesAt": "04:22",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Drăgăşani",
					"leavesAt": "04:23",
					"arrivesAt": "04:31",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Drăgăşani",
					"to": "Călina h.",
					"leavesAt": "04:32",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Călina h.",
					"to": "Zăvideni Hm.",
					"leavesAt": "04:39",
					"arrivesAt": "04:44",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "04:45",
					"arrivesAt": "04:50",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Orleşti hc.",
					"to": "Fişcălia Hm.",
					"leavesAt": "04:51",
					"arrivesAt": "04:54",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "04:55",
					"arrivesAt": "04:58",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Ioneşti Hm.",
					"leavesAt": "04:59",
					"arrivesAt": "05:03",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Slăviteşti hc.",
					"leavesAt": "05:04",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Băbeni",
					"leavesAt": "05:11",
					"arrivesAt": "05:20",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Băbeni",
					"to": "Tătărani h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:45",
					"waitsAtSource": 1320,
					"distance": 2700
				},
				{
					"from": "Tătărani h.",
					"to": "Govora",
					"leavesAt": "05:46",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Govora",
					"to": "Râureni hc.",
					"leavesAt": "05:54",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Râureni hc.",
					"to": "Râureni",
					"leavesAt": "05:59",
					"arrivesAt": "06:08",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Râureni",
					"to": "Răstoaca h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:20",
					"waitsAtSource": 600,
					"distance": 1400
				},
				{
					"from": "Răstoaca h.",
					"to": "Ostroveni h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ostroveni h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "06:25",
					"arrivesAt": "06:27",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:32",
					"waitsAtSource": 180,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "06:33",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Dăeşti Hm.",
					"leavesAt": "06:38",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Călimăneşti",
					"leavesAt": "06:45",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "06:53",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Cozia Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Cozia Hm.",
					"to": "Lotru",
					"leavesAt": "07:12",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lotru",
					"to": "Beţel h.",
					"leavesAt": "07:22",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Beţel h.",
					"to": "Cornet Hm.",
					"leavesAt": "07:29",
					"arrivesAt": "07:35",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Cornet Hm.",
					"to": "Balota h.",
					"leavesAt": "07:36",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Balota h.",
					"to": "Robeşti h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:45",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Robeşti h.",
					"to": "Câineni",
					"leavesAt": "07:46",
					"arrivesAt": "07:53",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Râu Vadului h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:10",
					"waitsAtSource": 540,
					"distance": 5400
				},
				{
					"from": "Râu Vadului h.",
					"to": "Valea Fratelui h.",
					"leavesAt": "08:11",
					"arrivesAt": "08:15",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Valea Fratelui h.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "08:16",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Turnu Roşu hc.",
					"leavesAt": "08:39",
					"arrivesAt": "08:49",
					"waitsAtSource": 660,
					"distance": 6400
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Podu Olt",
					"leavesAt": "08:50",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1736",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Câmpia Turzii",
					"leavesAt": "16:30",
					"arrivesAt": "17:36",
					"waitsAtSource": 0,
					"distance": 51500
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "17:37",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "17:58",
					"arrivesAt": "18:03",
					"waitsAtSource": 300,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Aiud Hm.",
					"leavesAt": "18:04",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "18:20",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Blaj",
					"leavesAt": "18:38",
					"arrivesAt": "19:05",
					"waitsAtSource": 240,
					"distance": 21300
				},
				{
					"from": "Blaj",
					"to": "Valea Lungă Hm.",
					"leavesAt": "19:06",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Copşa Mică",
					"leavesAt": "19:22",
					"arrivesAt": "19:48",
					"waitsAtSource": 240,
					"distance": 17900
				},
				{
					"from": "Copşa Mică",
					"to": "Şeica Mare",
					"leavesAt": "19:53",
					"arrivesAt": "20:04",
					"waitsAtSource": 300,
					"distance": 11100
				},
				{
					"from": "Şeica Mare",
					"to": "Loamneş Hm.",
					"leavesAt": "20:05",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 13100
				},
				{
					"from": "Loamneş Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:28",
					"waitsAtSource": 30,
					"distance": 8200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Sibiu",
					"leavesAt": "20:29",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 12500
				},
				{
					"from": "Sibiu",
					"to": "Tălmaciu Hm.",
					"leavesAt": "20:44",
					"arrivesAt": "21:03",
					"waitsAtSource": 120,
					"distance": 17800
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Turnu Roşu hc.",
					"leavesAt": "21:04",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Câineni",
					"leavesAt": "21:14",
					"arrivesAt": "21:44",
					"waitsAtSource": 30,
					"distance": 21600
				},
				{
					"from": "Câineni",
					"to": "Călimăneşti",
					"leavesAt": "21:53",
					"arrivesAt": "22:36",
					"waitsAtSource": 540,
					"distance": 36700
				},
				{
					"from": "Călimăneşti",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "22:37",
					"arrivesAt": "22:55",
					"waitsAtSource": 60,
					"distance": 16200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8204",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "16:42",
					"arrivesAt": "16:48",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "16:49",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "17:02",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:19",
					"waitsAtSource": 480,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "17:20",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "17:29",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "17:41",
					"arrivesAt": "17:50",
					"waitsAtSource": 300,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "17:51",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "17:57",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Ramificaţia Borcea",
					"leavesAt": "18:08",
					"arrivesAt": "18:28",
					"waitsAtSource": 120,
					"distance": 16000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "18:29",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Feteşti",
					"to": "Movila Hm.",
					"leavesAt": "18:46",
					"arrivesAt": "19:04",
					"waitsAtSource": 600,
					"distance": 16700
				},
				{
					"from": "Movila Hm.",
					"to": "Platoneşti h.",
					"leavesAt": "19:05",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Platoneşti h.",
					"to": "Ţăndărei",
					"leavesAt": "19:14",
					"arrivesAt": "19:22",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ţăndărei",
					"to": "Murgeanca Hm.",
					"leavesAt": "19:25",
					"arrivesAt": "19:37",
					"waitsAtSource": 180,
					"distance": 12200
				},
				{
					"from": "Murgeanca Hm.",
					"to": "Spicu",
					"leavesAt": "19:38",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spicu",
					"to": "Dudeşti Hm.",
					"leavesAt": "19:48",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Dudeşti Hm.",
					"to": "Scărlăteşti hc.",
					"leavesAt": "19:59",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Scărlăteşti hc.",
					"to": "Cireşu Hm.",
					"leavesAt": "20:07",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cireşu Hm.",
					"to": "Făurei",
					"leavesAt": "20:15",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 15700
				},
				{
					"from": "Făurei",
					"to": "Vizireni h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:42",
					"waitsAtSource": 120,
					"distance": 6700
				},
				{
					"from": "Vizireni h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "20:55",
					"arrivesAt": "21:00",
					"waitsAtSource": 480,
					"distance": 6400
				},
				{
					"from": "Movila Oii h.",
					"to": "Cilibia Hm.",
					"leavesAt": "21:01",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cilibia Hm.",
					"to": "Bentu h.",
					"leavesAt": "21:10",
					"arrivesAt": "21:14",
					"waitsAtSource": 300,
					"distance": 4000
				},
				{
					"from": "Bentu h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "21:15",
					"arrivesAt": "21:19",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Tăbărăşti h.",
					"leavesAt": "21:20",
					"arrivesAt": "21:23",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Buzău Sud",
					"leavesAt": "21:24",
					"arrivesAt": "21:30",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Buzău Sud",
					"to": "Buzău",
					"leavesAt": "21:31",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8034",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "19:38",
					"arrivesAt": "19:45",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "19:46",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "20:00",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "20:10",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "20:19",
					"arrivesAt": "20:25",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "20:26",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "20:37",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "20:46",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Ramificaţia Borcea",
					"leavesAt": "20:57",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "21:13",
					"arrivesAt": "21:21",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8654",
			"segments": [
				{
					"from": "Tulcea Oraş",
					"to": "Tulcea Mărfuri",
					"leavesAt": "16:12",
					"arrivesAt": "16:21",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Tulcea Mărfuri",
					"to": "Cataloi Hm.",
					"leavesAt": "16:22",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Cataloi Hm.",
					"to": "Mihail Kogălniceanu h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mihail Kogălniceanu h.",
					"to": "Zebil h.",
					"leavesAt": "16:54",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Zebil h.",
					"to": "Babadag",
					"leavesAt": "17:09",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Babadag",
					"to": "Ceamurlia de Jos h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Ceamurlia de Jos h.",
					"to": "Baia Dobrogea",
					"leavesAt": "17:43",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baia Dobrogea",
					"to": "Mihai Viteazu Hm.",
					"leavesAt": "17:50",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Mihai Viteazu Hm.",
					"to": "Cogealac",
					"leavesAt": "18:09",
					"arrivesAt": "18:28",
					"waitsAtSource": 480,
					"distance": 17400
				},
				{
					"from": "Cogealac",
					"to": "Târguşor Dobrogea Hm.",
					"leavesAt": "18:29",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Târguşor Dobrogea Hm.",
					"to": "Ram. M.K.P. Aj. M.",
					"leavesAt": "18:50",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Ram. M.K.P. Aj. M.",
					"to": "Nicolae Bălcescu",
					"leavesAt": "19:01",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Nicolae Bălcescu",
					"to": "Medgidia",
					"leavesAt": "19:08",
					"arrivesAt": "19:28",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Medgidia",
					"to": "Poarta Albă h.",
					"leavesAt": "19:30",
					"arrivesAt": "19:39",
					"waitsAtSource": 120,
					"distance": 12300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "19:40",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Constanţa",
					"leavesAt": "19:45",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 17400
				}
			],
			"restrictions": [
				{
					"from": "20180101",
					"to": "20180104",
					"daysOfWeek": 383
				},
				{
					"from": "20180108",
					"to": "20180111",
					"daysOfWeek": 383
				},
				{
					"from": "20180115",
					"to": "20180118",
					"daysOfWeek": 383
				},
				{
					"from": "20180122",
					"to": "20180125",
					"daysOfWeek": 383
				},
				{
					"from": "20180129",
					"to": "20180201",
					"daysOfWeek": 383
				},
				{
					"from": "20180205",
					"to": "20180208",
					"daysOfWeek": 383
				},
				{
					"from": "20180212",
					"to": "20180215",
					"daysOfWeek": 383
				},
				{
					"from": "20180219",
					"to": "20180222",
					"daysOfWeek": 383
				},
				{
					"from": "20180226",
					"to": "20180301",
					"daysOfWeek": 383
				},
				{
					"from": "20180305",
					"to": "20180308",
					"daysOfWeek": 383
				},
				{
					"from": "20180312",
					"to": "20180315",
					"daysOfWeek": 383
				},
				{
					"from": "20180319",
					"to": "20180322",
					"daysOfWeek": 383
				},
				{
					"from": "20180326",
					"to": "20180329",
					"daysOfWeek": 383
				},
				{
					"from": "20180402",
					"to": "20180405",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20180412",
					"daysOfWeek": 383
				},
				{
					"from": "20180416",
					"to": "20180419",
					"daysOfWeek": 383
				},
				{
					"from": "20180423",
					"to": "20180426",
					"daysOfWeek": 383
				},
				{
					"from": "20180430",
					"to": "20180503",
					"daysOfWeek": 383
				},
				{
					"from": "20180507",
					"to": "20180510",
					"daysOfWeek": 383
				},
				{
					"from": "20180514",
					"to": "20180517",
					"daysOfWeek": 383
				},
				{
					"from": "20180521",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180528",
					"to": "20180531",
					"daysOfWeek": 383
				},
				{
					"from": "20180604",
					"to": "20180607",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20180913",
					"daysOfWeek": 383
				},
				{
					"from": "20180917",
					"to": "20180920",
					"daysOfWeek": 383
				},
				{
					"from": "20180924",
					"to": "20180927",
					"daysOfWeek": 383
				},
				{
					"from": "20181001",
					"to": "20181004",
					"daysOfWeek": 383
				},
				{
					"from": "20181008",
					"to": "20181011",
					"daysOfWeek": 383
				},
				{
					"from": "20181015",
					"to": "20181018",
					"daysOfWeek": 383
				},
				{
					"from": "20181022",
					"to": "20181025",
					"daysOfWeek": 383
				},
				{
					"from": "20181029",
					"to": "20181101",
					"daysOfWeek": 383
				},
				{
					"from": "20181105",
					"to": "20181108",
					"daysOfWeek": 383
				},
				{
					"from": "20181112",
					"to": "20181115",
					"daysOfWeek": 383
				},
				{
					"from": "20181119",
					"to": "20181122",
					"daysOfWeek": 383
				},
				{
					"from": "20181126",
					"to": "20181129",
					"daysOfWeek": 383
				},
				{
					"from": "20181203",
					"to": "20181206",
					"daysOfWeek": 383
				},
				{
					"from": "20171211",
					"to": "20171214",
					"daysOfWeek": 383
				},
				{
					"from": "20171218",
					"to": "20171221",
					"daysOfWeek": 383
				},
				{
					"from": "20171225",
					"to": "20171228",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5002",
			"segments": [
				{
					"from": "Buzău",
					"to": "Ulmeni",
					"leavesAt": "03:50",
					"arrivesAt": "04:04",
					"waitsAtSource": 0,
					"distance": 15400
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "04:05",
					"arrivesAt": "04:09",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "04:10",
					"arrivesAt": "04:19",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "04:20",
					"arrivesAt": "04:28",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "04:29",
					"arrivesAt": "04:37",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "04:44",
					"arrivesAt": "04:49",
					"waitsAtSource": 420,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Muru hc.",
					"leavesAt": "04:50",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "04:58",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "05:06",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "05:14",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ploieşti Sud",
					"to": "Brazi",
					"leavesAt": "05:24",
					"arrivesAt": "05:39",
					"waitsAtSource": 120,
					"distance": 8800
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "05:47",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:02",
					"waitsAtSource": 360,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "06:03",
					"arrivesAt": "06:08",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "06:19",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "06:25",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "06:36",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "06:40",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "06:44",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "06:51",
					"arrivesAt": "06:55",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4531",
			"segments": [
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Târgu Mureş",
					"leavesAt": "07:04",
					"arrivesAt": "07:12",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Târgu Mureş",
					"to": "Azomureş h.",
					"leavesAt": "07:14",
					"arrivesAt": "07:18",
					"waitsAtSource": 120,
					"distance": 3700
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "07:19",
					"arrivesAt": "07:22",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "07:23",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Vidrasău h.",
					"leavesAt": "07:28",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vidrasău h.",
					"to": "Chirileu h.",
					"leavesAt": "07:33",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Chirileu h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Ogra h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Ogra h.",
					"to": "Cipău h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:51",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cipău h.",
					"to": "Iernut",
					"leavesAt": "07:52",
					"arrivesAt": "07:57",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iernut",
					"to": "Cuci h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cuci h.",
					"to": "Bogata Mureş h.",
					"leavesAt": "08:04",
					"arrivesAt": "08:10",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Luduş",
					"leavesAt": "08:11",
					"arrivesAt": "08:15",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Luduş",
					"to": "Cheţani h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Cheţani h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "08:23",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Gura Arieşului h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Lunca Mureşului h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:37",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Războieni",
					"leavesAt": "08:38",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4301",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "03:50",
					"arrivesAt": "03:58",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Buneşti h.",
					"leavesAt": "03:59",
					"arrivesAt": "04:02",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Buneşti h.",
					"to": "Gherla",
					"leavesAt": "04:03",
					"arrivesAt": "04:11",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "04:12",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "04:19",
					"arrivesAt": "04:24",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "04:25",
					"arrivesAt": "04:28",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "04:29",
					"arrivesAt": "04:34",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "04:35",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "04:39",
					"arrivesAt": "04:44",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida h.",
					"leavesAt": "04:45",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Apahida h.",
					"to": "Apahida",
					"leavesAt": "04:52",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "05:02",
					"arrivesAt": "05:09",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "05:16",
					"arrivesAt": "05:21",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9388",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(900)",
					"leavesAt": "20:05",
					"arrivesAt": "20:08",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "20:09",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "20:16",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "20:20",
					"arrivesAt": "20:26",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Leu Hm.",
					"leavesAt": "20:27",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Leu Hm.",
					"to": "Ţărţăl h.",
					"leavesAt": "20:37",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ţărţăl h.",
					"to": "Jianca",
					"leavesAt": "20:42",
					"arrivesAt": "20:46",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Jianca",
					"to": "Radomiru hc.",
					"leavesAt": "20:47",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Radomiru hc.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "20:51",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Cezieni h.",
					"leavesAt": "20:57",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Cezieni h.",
					"to": "Caracal",
					"leavesAt": "21:03",
					"arrivesAt": "21:09",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Caracal",
					"to": "Fărcaşele Hm.",
					"leavesAt": "21:10",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Stoeneşti h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:21",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Stoeneşti h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "21:22",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Dăneasa h.",
					"leavesAt": "21:30",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Dăneasa h.",
					"to": "Radomireşti Hm.",
					"leavesAt": "21:34",
					"arrivesAt": "21:41",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "21:42",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "21:52",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 17300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2312",
			"segments": [
				{
					"from": "Simeria",
					"to": "Simeria Veche h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:20",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Simeria Veche h.",
					"to": "Turdaş Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Turdaş Hm.",
					"to": "Pricaz h.",
					"leavesAt": "16:27",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Pricaz h.",
					"to": "Orăştie",
					"leavesAt": "16:35",
					"arrivesAt": "16:41",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Orăştie",
					"to": "Geoagiu h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 300,
					"distance": 4000
				},
				{
					"from": "Geoagiu h.",
					"to": "Aurel Vlaicu",
					"leavesAt": "16:51",
					"arrivesAt": "16:56",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Şibot",
					"leavesAt": "16:57",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Şibot",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Tărtăria h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Tărtăria h.",
					"to": "Blandiana Hm.",
					"leavesAt": "17:22",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Blandiana Hm.",
					"to": "Vinţu de Jos",
					"leavesAt": "17:28",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "17:37",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "18:00",
					"waitsAtSource": 120,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "18:01",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Sântimbru h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:16",
					"waitsAtSource": 300,
					"distance": 1900
				},
				{
					"from": "Sântimbru h.",
					"to": "Coşlariu",
					"leavesAt": "18:17",
					"arrivesAt": "18:28",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "18:29",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9446",
			"segments": [
				{
					"from": "Pietroşiţa Hm.",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "13:50",
					"arrivesAt": "13:55",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Fieni",
					"leavesAt": "13:56",
					"arrivesAt": "14:01",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Moţăieni h.",
					"leavesAt": "14:02",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Moţăieni h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "14:07",
					"arrivesAt": "14:11",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Trainica h.",
					"leavesAt": "14:12",
					"arrivesAt": "14:15",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Trainica h.",
					"to": "Scârlenţa h.",
					"leavesAt": "14:16",
					"arrivesAt": "14:18",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Scârlenţa h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "14:19",
					"arrivesAt": "14:22",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Doiceşti h.",
					"leavesAt": "14:23",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Doiceşti h.",
					"to": "Doiceşti",
					"leavesAt": "14:26",
					"arrivesAt": "14:28",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Doiceşti",
					"to": "Săteni h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Săteni h.",
					"to": "Aninoasa Hm.",
					"leavesAt": "14:33",
					"arrivesAt": "14:35",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Aninoasa Hm.",
					"to": "TEIŞ Hm.",
					"leavesAt": "14:36",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "14:43",
					"arrivesAt": "14:47",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1594",
			"segments": [
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "04:28",
					"arrivesAt": "05:07",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "05:08",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Radomireşti Hm.",
					"leavesAt": "05:24",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "05:36",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 25600
				},
				{
					"from": "Roşiori Nord",
					"to": "Olteni",
					"leavesAt": "06:00",
					"arrivesAt": "06:26",
					"waitsAtSource": 120,
					"distance": 26800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Videle",
					"leavesAt": "06:36",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 15800
				},
				{
					"from": "Videle",
					"to": "Grădinari",
					"leavesAt": "06:50",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 25400
				},
				{
					"from": "Grădinari",
					"to": "Bucureşti Nord",
					"leavesAt": "07:16",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 25500
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2493",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Coşlariu",
					"leavesAt": "12:55",
					"arrivesAt": "13:03",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Coşlariu",
					"to": "Sântimbru h.",
					"leavesAt": "13:04",
					"arrivesAt": "13:15",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sântimbru h.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "13:16",
					"arrivesAt": "13:20",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "13:21",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "13:33",
					"arrivesAt": "13:42",
					"waitsAtSource": 300,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "13:44",
					"arrivesAt": "13:56",
					"waitsAtSource": 120,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Blandiana Hm.",
					"leavesAt": "13:57",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Blandiana Hm.",
					"to": "Tărtăria h.",
					"leavesAt": "14:06",
					"arrivesAt": "14:12",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tărtăria h.",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:19",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Şibot",
					"leavesAt": "14:20",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şibot",
					"to": "Vinerea h.",
					"leavesAt": "14:27",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Vinerea h.",
					"to": "Cugir hc.",
					"leavesAt": "14:41",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Cugir hc.",
					"to": "Cugir  Hm.",
					"leavesAt": "14:54",
					"arrivesAt": "14:56",
					"waitsAtSource": 30,
					"distance": 600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5530",
			"segments": [
				{
					"from": "Târgu Neamţ",
					"to": "Plăieşu h.",
					"leavesAt": "21:35",
					"arrivesAt": "21:42",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Plăieşu h.",
					"to": "Timişeşti Hm.",
					"leavesAt": "21:43",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "21:50",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Topile h.",
					"leavesAt": "21:56",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Topile h.",
					"to": "Paşcani",
					"leavesAt": "22:05",
					"arrivesAt": "22:15",
					"waitsAtSource": 60,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9615",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Boldur h.",
					"leavesAt": "12:17",
					"arrivesAt": "12:26",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Boldur h.",
					"to": "Sinia Hm.",
					"leavesAt": "12:27",
					"arrivesAt": "12:34",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Sinia Hm.",
					"to": "Căpăt h.",
					"leavesAt": "12:35",
					"arrivesAt": "12:40",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Căpăt h.",
					"to": "Buziaş",
					"leavesAt": "12:41",
					"arrivesAt": "12:53",
					"waitsAtSource": 30,
					"distance": 7300
				},
				{
					"from": "Buziaş",
					"to": "Bacova h.",
					"leavesAt": "12:55",
					"arrivesAt": "12:58",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Bacova h.",
					"to": "Chevereş h.",
					"leavesAt": "12:59",
					"arrivesAt": "13:04",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Chevereş h.",
					"to": "Sacoşu Mic",
					"leavesAt": "13:05",
					"arrivesAt": "13:11",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Sacoşu Mic",
					"to": "Uliuc h.",
					"leavesAt": "13:12",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Uliuc h.",
					"to": "Urseni h.",
					"leavesAt": "13:18",
					"arrivesAt": "13:23",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Urseni h.",
					"to": "Semenic Hm.",
					"leavesAt": "13:24",
					"arrivesAt": "13:28",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Semenic Hm.",
					"to": "Giroc h.",
					"leavesAt": "13:29",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Giroc h.",
					"to": "Timişoara Sud",
					"leavesAt": "13:33",
					"arrivesAt": "13:39",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "13:40",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7038",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "16:30",
					"arrivesAt": "16:33",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "16:34",
					"arrivesAt": "16:39",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Moldoveni h.",
					"to": "Dridu Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Dridu Hm.",
					"to": "Fierbinţi",
					"leavesAt": "16:53",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Fierbinţi",
					"to": "Greci h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Greci h.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "17:07",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "17:14",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Baloteşti Hm.",
					"leavesAt": "17:20",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Baloteşti Hm.",
					"to": "P.O. Aeroport h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:36",
					"waitsAtSource": 420,
					"distance": 2100
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Mogoşoaia",
					"leavesAt": "17:37",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Mogoşoaia",
					"to": "Pajura Hm. (700)",
					"leavesAt": "17:55",
					"arrivesAt": "18:18",
					"waitsAtSource": 420,
					"distance": 15000
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Carpaţi h.(700)",
					"leavesAt": "18:19",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Bucureşti Nord",
					"leavesAt": "18:23",
					"arrivesAt": "18:31",
					"waitsAtSource": 30,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5561",
			"segments": [
				{
					"from": "Botoşani",
					"to": "Leorda Hm.",
					"leavesAt": "04:54",
					"arrivesAt": "05:18",
					"waitsAtSource": 0,
					"distance": 15500
				},
				{
					"from": "Leorda Hm.",
					"to": "Bucecea Hm",
					"leavesAt": "05:19",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bucecea Hm",
					"to": "Bursuceni h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Bursuceni h.",
					"to": "Vereşti",
					"leavesAt": "05:55",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "06:08",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "06:16",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "06:28",
					"arrivesAt": "06:34",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6510",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "18:45",
					"arrivesAt": "18:52",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Socola",
					"leavesAt": "18:53",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Socola",
					"to": "Remiza T Socola h.",
					"leavesAt": "18:59",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Remiza T Socola h.",
					"to": "Holboca Hm.",
					"leavesAt": "19:04",
					"arrivesAt": "19:10",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Holboca Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "19:11",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "19:20",
					"arrivesAt": "19:28",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2704",
			"segments": [
				{
					"from": "Simeria",
					"to": "Simeria Triaj",
					"leavesAt": "10:35",
					"arrivesAt": "10:42",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Simeria Triaj",
					"to": "Băcia h.",
					"leavesAt": "10:43",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Băcia h.",
					"to": "Băcia Hm.",
					"leavesAt": "10:46",
					"arrivesAt": "10:48",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Băcia Hm.",
					"to": "Batiz h.",
					"leavesAt": "10:49",
					"arrivesAt": "10:51",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Batiz h.",
					"to": "Călan Băi",
					"leavesAt": "10:52",
					"arrivesAt": "10:54",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Călan Băi",
					"to": "Călan Hm.",
					"leavesAt": "10:55",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Hm.",
					"to": "Ruşi h.",
					"leavesAt": "11:00",
					"arrivesAt": "11:04",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ruşi h.",
					"to": "Măceu h.",
					"leavesAt": "11:05",
					"arrivesAt": "11:08",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Măceu h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "11:09",
					"arrivesAt": "11:14",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Plopi h.",
					"leavesAt": "11:15",
					"arrivesAt": "11:18",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Plopi h.",
					"to": "Covragiu h.",
					"leavesAt": "11:19",
					"arrivesAt": "11:22",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Covragiu h.",
					"to": "Subcetate",
					"leavesAt": "11:23",
					"arrivesAt": "11:27",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Subcetate",
					"to": "Ciopea h.",
					"leavesAt": "11:28",
					"arrivesAt": "11:32",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ciopea h.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "11:33",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Băeşti Hm.",
					"leavesAt": "11:36",
					"arrivesAt": "11:39",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ruşor h.",
					"leavesAt": "11:40",
					"arrivesAt": "11:42",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ruşor h.",
					"to": "Pui",
					"leavesAt": "11:43",
					"arrivesAt": "11:48",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Pui",
					"to": "Ponor h.",
					"leavesAt": "11:49",
					"arrivesAt": "11:54",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ponor h.",
					"to": "Livadia h.",
					"leavesAt": "11:55",
					"arrivesAt": "11:58",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Livadia h.",
					"to": "Baru Mare",
					"leavesAt": "11:59",
					"arrivesAt": "12:07",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Baru Mare",
					"to": "Baru Mare h.",
					"leavesAt": "12:08",
					"arrivesAt": "12:12",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Baru Mare h.",
					"to": "Crivadia Hm.",
					"leavesAt": "12:13",
					"arrivesAt": "12:20",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Crivadia Hm.",
					"to": "Merişor Hm.",
					"leavesAt": "12:21",
					"arrivesAt": "12:30",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Merişor Hm.",
					"to": "Băniţa",
					"leavesAt": "12:31",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băniţa",
					"to": "Peştera Bolii h.",
					"leavesAt": "12:44",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Petroşani Triaj h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:56",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Petroşani Triaj h.",
					"to": "Dep Petroşani h.",
					"leavesAt": "12:57",
					"arrivesAt": "12:59",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Petroşani",
					"leavesAt": "13:00",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8014",
			"segments": [
				{
					"from": "Feteşti",
					"to": "Bărăganu Hm.",
					"leavesAt": "05:20",
					"arrivesAt": "05:31",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Jegălia",
					"leavesAt": "05:36",
					"arrivesAt": "05:40",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Jegălia",
					"to": "Recolta hc.",
					"leavesAt": "05:41",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Recolta hc.",
					"to": "Perişoru Hm.",
					"leavesAt": "05:45",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Perişoru Hm.",
					"to": "Ogoarele h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ogoarele h.",
					"to": "Ciulniţa",
					"leavesAt": "05:53",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ciulniţa",
					"to": "Ivăneşti h.",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 1320,
					"distance": 6700
				},
				{
					"from": "Ivăneşti h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "06:30",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Bogdana h.",
					"leavesAt": "06:36",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Bogdana h.",
					"to": "Dâlga h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:46",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Dâlga h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "06:47",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "06:54",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Lehliu",
					"leavesAt": "06:58",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lehliu",
					"to": "Preasna h.",
					"leavesAt": "07:04",
					"arrivesAt": "07:09",
					"waitsAtSource": 120,
					"distance": 8800
				},
				{
					"from": "Preasna h.",
					"to": "Săruleşti",
					"leavesAt": "07:10",
					"arrivesAt": "07:16",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Săruleşti",
					"to": "Mostiştea h.",
					"leavesAt": "07:25",
					"arrivesAt": "07:29",
					"waitsAtSource": 540,
					"distance": 5900
				},
				{
					"from": "Mostiştea h.",
					"to": "Fundulea Hm.",
					"leavesAt": "07:30",
					"arrivesAt": "07:35",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Fundulea Hm.",
					"to": "Islaz h.",
					"leavesAt": "07:36",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Islaz h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "07:43",
					"arrivesAt": "07:46",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Brăneşti Sat h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Pasărea",
					"leavesAt": "07:51",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Pasărea",
					"to": "Pantelimon",
					"leavesAt": "07:58",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pantelimon",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "08:05",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Bucureşti Obor",
					"leavesAt": "08:08",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9061",
			"segments": [
				{
					"from": "Caracal",
					"to": "Deveselu h.",
					"leavesAt": "04:50",
					"arrivesAt": "04:59",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Deveselu h.",
					"to": "Frăsinet hc.",
					"leavesAt": "05:00",
					"arrivesAt": "05:08",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Frăsinet hc.",
					"to": "Studiniţa h.",
					"leavesAt": "05:09",
					"arrivesAt": "05:13",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Studiniţa h.",
					"to": "Studina hc.",
					"leavesAt": "05:14",
					"arrivesAt": "05:19",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Studina hc.",
					"to": "Vişina h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:27",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Vişina h.",
					"to": "Vişina Veche hc.",
					"leavesAt": "05:28",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vişina Veche hc.",
					"to": "Corabia",
					"leavesAt": "05:32",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20180527",
					"daysOfWeek": 319
				},
				{
					"from": "20180529",
					"to": "20181130",
					"daysOfWeek": 319
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7361",
			"segments": [
				{
					"from": "Buzău",
					"to": "Tăbărăşti h.",
					"leavesAt": "03:52",
					"arrivesAt": "04:00",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "04:01",
					"arrivesAt": "04:03",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Bentu h.",
					"leavesAt": "04:04",
					"arrivesAt": "04:08",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bentu h.",
					"to": "Cilibia Hm.",
					"leavesAt": "04:09",
					"arrivesAt": "04:13",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cilibia Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "04:14",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Movila Oii h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "04:19",
					"arrivesAt": "04:25",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Vizireni h.",
					"leavesAt": "04:26",
					"arrivesAt": "04:29",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vizireni h.",
					"to": "Făurei",
					"leavesAt": "04:30",
					"arrivesAt": "04:39",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Făurei",
					"to": "Găiseanca h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:28",
					"waitsAtSource": 2700,
					"distance": 3900
				},
				{
					"from": "Găiseanca h.",
					"to": "Deduleşti Hm.",
					"leavesAt": "05:29",
					"arrivesAt": "05:35",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Ianca hc.",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ianca hc.",
					"to": "Plopu",
					"leavesAt": "05:42",
					"arrivesAt": "05:45",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Plopu",
					"to": "Urleasca Hm.",
					"leavesAt": "05:46",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Urleasca Hm.",
					"to": "Traian Sat Hm.",
					"leavesAt": "05:53",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Lacu Sărat",
					"leavesAt": "06:00",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Lacu Sărat",
					"to": "Brăila",
					"leavesAt": "06:10",
					"arrivesAt": "06:19",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "06:30",
					"arrivesAt": "06:35",
					"waitsAtSource": 660,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "06:36",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Zagna Vădeni h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Barboşi",
					"leavesAt": "06:45",
					"arrivesAt": "06:51",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "07:01",
					"arrivesAt": "07:13",
					"waitsAtSource": 180,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6445",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "21:40",
					"arrivesAt": "21:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "21:55",
					"arrivesAt": "22:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "22:03",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "22:10",
					"arrivesAt": "22:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "22:18",
					"arrivesAt": "22:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "22:28",
					"arrivesAt": "22:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "22:35",
					"arrivesAt": "22:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "22:40",
					"arrivesAt": "22:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "22:50",
					"arrivesAt": "23:04",
					"waitsAtSource": 60,
					"distance": 14700
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1579",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "18:22",
					"arrivesAt": "19:11",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "19:13",
					"arrivesAt": "19:46",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "19:47",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Făurei",
					"leavesAt": "20:24",
					"arrivesAt": "21:02",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Făurei",
					"to": "Ianca hc.",
					"leavesAt": "21:03",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Ianca hc.",
					"to": "Brăila",
					"leavesAt": "21:18",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 42400
				},
				{
					"from": "Brăila",
					"to": "Barboşi",
					"leavesAt": "21:52",
					"arrivesAt": "22:10",
					"waitsAtSource": 120,
					"distance": 19500
				},
				{
					"from": "Barboşi",
					"to": "Galaţi",
					"leavesAt": "22:11",
					"arrivesAt": "22:30",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9694",
			"segments": [
				{
					"from": "Anina",
					"to": "Gârlişte Hm.",
					"leavesAt": "13:30",
					"arrivesAt": "13:59",
					"waitsAtSource": 0,
					"distance": 8100
				},
				{
					"from": "Gârlişte Hm.",
					"to": "Ciudanoviţa Pam.",
					"leavesAt": "14:00",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Ciudanoviţa Pam.",
					"to": "Lişava Hm.",
					"leavesAt": "14:26",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 1200
				},
				{
					"from": "Lişava Hm.",
					"to": "Dobrei hcv.",
					"leavesAt": "14:32",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dobrei hcv.",
					"to": "Brădişoru de Jos h.",
					"leavesAt": "14:46",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Brădişoru de Jos h.",
					"to": "Oraviţa",
					"leavesAt": "15:09",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20181001",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180331",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4146",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Sărăţel Hm.",
					"leavesAt": "19:38",
					"arrivesAt": "19:51",
					"waitsAtSource": 0,
					"distance": 10700
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Domneşti pe Şieu h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:11",
					"waitsAtSource": 720,
					"distance": 6600
				},
				{
					"from": "Domneşti pe Şieu h.",
					"to": "Mărişelu Hm.",
					"leavesAt": "20:12",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Mărişelu Hm.",
					"to": "Bârla pe Şieu h.",
					"leavesAt": "20:17",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bârla pe Şieu h.",
					"to": "Şieu Hm.",
					"leavesAt": "20:22",
					"arrivesAt": "20:28",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Şieu Hm.",
					"to": "Şieuţ h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Şieuţ h.",
					"to": "Monor Gledin",
					"leavesAt": "20:35",
					"arrivesAt": "20:43",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Monor Gledin",
					"to": "Râpa de Jos Hm.",
					"leavesAt": "20:44",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Râpa de Jos Hm.",
					"to": "Morăreni h.",
					"leavesAt": "20:56",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Morăreni h.",
					"to": "Deda",
					"leavesAt": "21:01",
					"arrivesAt": "21:09",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Deda",
					"to": "Ruşii Munţi h.",
					"leavesAt": "21:24",
					"arrivesAt": "21:30",
					"waitsAtSource": 900,
					"distance": 4500
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "21:31",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Halta Aluniş h.",
					"leavesAt": "21:35",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Ideciu de Jos h.",
					"leavesAt": "21:40",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Reghin",
					"leavesAt": "21:47",
					"arrivesAt": "21:56",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Reghin",
					"to": "Petelea h.",
					"leavesAt": "21:57",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Petelea h.",
					"to": "Periş Mureş h.",
					"leavesAt": "22:05",
					"arrivesAt": "22:10",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Periş Mureş h.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "22:11",
					"arrivesAt": "22:20",
					"waitsAtSource": 30,
					"distance": 7300
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "22:21",
					"arrivesAt": "22:33",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Târgu Mureş",
					"leavesAt": "22:34",
					"arrivesAt": "22:42",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4094",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "05:30",
					"arrivesAt": "05:40",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "05:46",
					"arrivesAt": "05:52",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Apahida h.",
					"leavesAt": "05:53",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Apahida h.",
					"to": "Jucu Hm.",
					"leavesAt": "05:58",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Jucu Hm.",
					"to": "Jucu de Jos hc.",
					"leavesAt": "06:04",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 1820
				},
				{
					"from": "Jucu de Jos hc.",
					"to": "Răscruci h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 2680
				},
				{
					"from": "Răscruci h.",
					"to": "Bonţida Hm.",
					"leavesAt": "06:13",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Bonţida Hm.",
					"to": "Fundătura h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Fundătura h.",
					"to": "Iclod Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Iclod Hm.",
					"to": "Livada Someş h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Livada Someş h.",
					"to": "Gherla",
					"leavesAt": "06:37",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Gherla",
					"to": "Nima h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Nima h.",
					"to": "Dej Călători",
					"leavesAt": "06:58",
					"arrivesAt": "07:07",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Dej Călători",
					"to": "Căşeiu Hm.",
					"leavesAt": "07:09",
					"arrivesAt": "07:18",
					"waitsAtSource": 120,
					"distance": 6300
				},
				{
					"from": "Căşeiu Hm.",
					"to": "Coplean h.",
					"leavesAt": "07:19",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coplean h.",
					"to": "Câţcău h.",
					"leavesAt": "07:23",
					"arrivesAt": "07:27",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Câţcău h.",
					"to": "Căpâlna pe Someş h.",
					"leavesAt": "07:28",
					"arrivesAt": "07:33",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Căpâlna pe Someş h.",
					"to": "Gâlgău",
					"leavesAt": "07:34",
					"arrivesAt": "07:40",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Gâlgău",
					"to": "Gâlgău h.",
					"leavesAt": "07:41",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Gâlgău h.",
					"to": "Glodu Someşului h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:50",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Glodu Someşului h.",
					"to": "Rus h.",
					"leavesAt": "07:51",
					"arrivesAt": "07:56",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Rus h.",
					"to": "Ileanda",
					"leavesAt": "07:57",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Ileanda",
					"to": "Bizuşa h.",
					"leavesAt": "08:05",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Bizuşa h.",
					"to": "Răstoci Hm.",
					"leavesAt": "08:08",
					"arrivesAt": "08:14",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Răstoci Hm.",
					"to": "Letca Hm.",
					"leavesAt": "08:15",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Letca Hm.",
					"to": "Cuciulat Hm.",
					"leavesAt": "08:26",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Băbuţeni Hm.",
					"leavesAt": "08:34",
					"arrivesAt": "08:40",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Băbuţeni Hm.",
					"to": "Ciocmani h.",
					"leavesAt": "08:41",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ciocmani h.",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "08:47",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Var h.",
					"leavesAt": "08:55",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Var h.",
					"to": "Jibou",
					"leavesAt": "09:01",
					"arrivesAt": "09:05",
					"waitsAtSource": 30,
					"distance": 2800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3084",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "15:20",
					"arrivesAt": "15:30",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "15:31",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "15:36",
					"arrivesAt": "15:42",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Cojocna Hm.",
					"leavesAt": "15:43",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cojocna Hm.",
					"to": "Tunel Hm.",
					"leavesAt": "15:49",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tunel Hm.",
					"to": "Boju",
					"leavesAt": "15:58",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Boju",
					"to": "Valea Florilor Hm.",
					"leavesAt": "16:07",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Ploscoş h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ploscoş h.",
					"to": "Cânepişti h.",
					"leavesAt": "16:25",
					"arrivesAt": "16:31",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cânepişti h.",
					"to": "Câmpia Turzii",
					"leavesAt": "16:32",
					"arrivesAt": "16:40",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Câmpia Turzii",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "16:41",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Grindeni h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Grindeni h.",
					"to": "Războieni",
					"leavesAt": "16:57",
					"arrivesAt": "17:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "17:15",
					"arrivesAt": "17:19",
					"waitsAtSource": 840,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Unirea Hm.",
					"leavesAt": "17:20",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea Hm.",
					"to": "Decea h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Decea h.",
					"to": "Mirăslău h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Mirăslău h.",
					"to": "Aiud Hm.",
					"leavesAt": "17:36",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "17:44",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 13100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1662",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "14:02",
					"arrivesAt": "14:08",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Bârnova Hm.",
					"leavesAt": "14:09",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Buhăieşti",
					"leavesAt": "14:32",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Buhăieşti",
					"to": "Vaslui",
					"leavesAt": "14:55",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Vaslui",
					"to": "Crasna",
					"leavesAt": "15:15",
					"arrivesAt": "15:29",
					"waitsAtSource": 120,
					"distance": 15500
				},
				{
					"from": "Crasna",
					"to": "Bârlad",
					"leavesAt": "15:30",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Bârlad",
					"to": "Tecuci Nord hc.(605)",
					"leavesAt": "16:04",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 48600
				},
				{
					"from": "Tecuci Nord hc.(605)",
					"to": "Mărăşeşti",
					"leavesAt": "16:48",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 17800
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "17:27",
					"arrivesAt": "17:48",
					"waitsAtSource": 900,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "17:49",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "18:27",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "19:00",
					"arrivesAt": "19:32",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "19:33",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "20:11",
					"arrivesAt": "21:02",
					"waitsAtSource": 120,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2491",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Sântimbru h.",
					"leavesAt": "04:12",
					"arrivesAt": "04:29",
					"waitsAtSource": 0,
					"distance": 7900
				},
				{
					"from": "Sântimbru h.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "04:30",
					"arrivesAt": "04:41",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "04:42",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "04:55",
					"arrivesAt": "05:07",
					"waitsAtSource": 240,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Blandiana Hm.",
					"leavesAt": "05:08",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Blandiana Hm.",
					"to": "Tărtăria h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tărtăria h.",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Şibot",
					"leavesAt": "05:31",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şibot",
					"to": "Vinerea h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Vinerea h.",
					"to": "Cugir hc.",
					"leavesAt": "05:52",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Cugir hc.",
					"to": "Cugir  Hm.",
					"leavesAt": "06:05",
					"arrivesAt": "06:07",
					"waitsAtSource": 30,
					"distance": 600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1811",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Miercurea Sibiu Hm.",
					"leavesAt": "03:38",
					"arrivesAt": "04:43",
					"waitsAtSource": 0,
					"distance": 52800
				},
				{
					"from": "Miercurea Sibiu Hm.",
					"to": "Sebeş Alba",
					"leavesAt": "04:49",
					"arrivesAt": "05:18",
					"waitsAtSource": 360,
					"distance": 20900
				},
				{
					"from": "Sebeş Alba",
					"to": "Vinţu de Jos",
					"leavesAt": "05:19",
					"arrivesAt": "05:29",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vinţu de Jos",
					"to": "Şibot",
					"leavesAt": "05:30",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Şibot",
					"to": "Aurel Vlaicu",
					"leavesAt": "05:53",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Orăştie",
					"leavesAt": "06:02",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Orăştie",
					"to": "Pricaz h.",
					"leavesAt": "06:11",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pricaz h.",
					"to": "Turdaş Hm.",
					"leavesAt": "06:16",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Turdaş Hm.",
					"to": "Simeria",
					"leavesAt": "06:25",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "06:39",
					"arrivesAt": "06:49",
					"waitsAtSource": 120,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Mintia h.",
					"leavesAt": "06:51",
					"arrivesAt": "07:02",
					"waitsAtSource": 120,
					"distance": 8500
				},
				{
					"from": "Mintia h.",
					"to": "Ilia",
					"leavesAt": "07:03",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 15100
				},
				{
					"from": "Ilia",
					"to": "Dobra Hm.",
					"leavesAt": "07:25",
					"arrivesAt": "07:36",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Dobra Hm.",
					"to": "Holdea Hm.",
					"leavesAt": "07:37",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Holdea Hm.",
					"to": "Margina",
					"leavesAt": "07:56",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Margina",
					"to": "Făget",
					"leavesAt": "08:16",
					"arrivesAt": "08:25",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Făget",
					"to": "Lugoj",
					"leavesAt": "08:27",
					"arrivesAt": "09:11",
					"waitsAtSource": 120,
					"distance": 39700
				},
				{
					"from": "Lugoj",
					"to": "Buziaş",
					"leavesAt": "09:15",
					"arrivesAt": "09:45",
					"waitsAtSource": 240,
					"distance": 27500
				},
				{
					"from": "Buziaş",
					"to": "Timişoara Nord",
					"leavesAt": "09:46",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 36400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6447",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "19:30",
					"arrivesAt": "19:44",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "19:45",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "19:53",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "20:00",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "20:08",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "20:18",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "20:25",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "20:30",
					"arrivesAt": "20:39",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "20:40",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 14700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20180531",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1665",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "16:05",
					"arrivesAt": "16:54",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "16:57",
					"arrivesAt": "17:30",
					"waitsAtSource": 180,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "17:32",
					"arrivesAt": "18:09",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "18:11",
					"arrivesAt": "18:42",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "18:43",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Tecuci",
					"leavesAt": "19:22",
					"arrivesAt": "20:05",
					"waitsAtSource": 120,
					"distance": 36500
				},
				{
					"from": "Tecuci",
					"to": "Bârlad",
					"leavesAt": "20:17",
					"arrivesAt": "21:00",
					"waitsAtSource": 720,
					"distance": 50300
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "21:02",
					"arrivesAt": "21:31",
					"waitsAtSource": 120,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "21:32",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "21:47",
					"arrivesAt": "22:05",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "22:06",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "22:33",
					"arrivesAt": "22:48",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "22:49",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5461",
			"segments": [
				{
					"from": "Bacău",
					"to": "Hămeiuş P.M.",
					"leavesAt": "05:11",
					"arrivesAt": "05:20",
					"waitsAtSource": 0,
					"distance": 7900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Gârleni Hm.",
					"leavesAt": "05:21",
					"arrivesAt": "05:29",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Gârleni Hm.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Racova h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Racova h.",
					"to": "Buhuşi",
					"leavesAt": "05:42",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Buhuşi",
					"to": "Costişa h.",
					"leavesAt": "05:59",
					"arrivesAt": "06:06",
					"waitsAtSource": 600,
					"distance": 6300
				},
				{
					"from": "Costişa h.",
					"to": "Podoleni Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Podoleni Hm.",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "06:16",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Roznov",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Roznov",
					"to": "Săvineşti h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Săvineşti h.",
					"to": "Dumbrava h.",
					"leavesAt": "06:36",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Piatra Neamţ",
					"leavesAt": "06:45",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1789",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "16:30",
					"arrivesAt": "17:30",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "17:35",
					"arrivesAt": "17:54",
					"waitsAtSource": 300,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "17:55",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "18:23",
					"arrivesAt": "18:34",
					"waitsAtSource": 300,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4365",
			"segments": [
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "07:32",
					"arrivesAt": "07:49",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "08:02",
					"arrivesAt": "08:09",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180114",
					"daysOfWeek": 383
				},
				{
					"from": "20180120",
					"to": "20180121",
					"daysOfWeek": 383
				},
				{
					"from": "20180124",
					"to": "20180124",
					"daysOfWeek": 383
				},
				{
					"from": "20180127",
					"to": "20180128",
					"daysOfWeek": 383
				},
				{
					"from": "20180203",
					"to": "20180211",
					"daysOfWeek": 383
				},
				{
					"from": "20180217",
					"to": "20180218",
					"daysOfWeek": 383
				},
				{
					"from": "20180224",
					"to": "20180225",
					"daysOfWeek": 383
				},
				{
					"from": "20180303",
					"to": "20180304",
					"daysOfWeek": 383
				},
				{
					"from": "20180310",
					"to": "20180311",
					"daysOfWeek": 383
				},
				{
					"from": "20180317",
					"to": "20180318",
					"daysOfWeek": 383
				},
				{
					"from": "20180324",
					"to": "20180325",
					"daysOfWeek": 383
				},
				{
					"from": "20180331",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180410",
					"to": "20180410",
					"daysOfWeek": 383
				},
				{
					"from": "20180414",
					"to": "20180415",
					"daysOfWeek": 383
				},
				{
					"from": "20180421",
					"to": "20180422",
					"daysOfWeek": 383
				},
				{
					"from": "20180428",
					"to": "20180429",
					"daysOfWeek": 383
				},
				{
					"from": "20180505",
					"to": "20180506",
					"daysOfWeek": 383
				},
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180526",
					"to": "20180526",
					"daysOfWeek": 383
				},
				{
					"from": "20180601",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180610",
					"daysOfWeek": 383
				},
				{
					"from": "20180616",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180922",
					"to": "20180923",
					"daysOfWeek": 383
				},
				{
					"from": "20180929",
					"to": "20180930",
					"daysOfWeek": 383
				},
				{
					"from": "20181006",
					"to": "20181007",
					"daysOfWeek": 383
				},
				{
					"from": "20181013",
					"to": "20181014",
					"daysOfWeek": 383
				},
				{
					"from": "20181020",
					"to": "20181021",
					"daysOfWeek": 383
				},
				{
					"from": "20181027",
					"to": "20181028",
					"daysOfWeek": 383
				},
				{
					"from": "20181103",
					"to": "20181104",
					"daysOfWeek": 383
				},
				{
					"from": "20181110",
					"to": "20181111",
					"daysOfWeek": 383
				},
				{
					"from": "20181117",
					"to": "20181118",
					"daysOfWeek": 383
				},
				{
					"from": "20181124",
					"to": "20181125",
					"daysOfWeek": 383
				},
				{
					"from": "20181202",
					"to": "20181202",
					"daysOfWeek": 383
				},
				{
					"from": "20181208",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 383
				},
				{
					"from": "20171216",
					"to": "20171217",
					"daysOfWeek": 383
				},
				{
					"from": "20171223",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171227",
					"to": "20171230",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9504",
			"segments": [
				{
					"from": "Orşova",
					"to": "Şantier Naval h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:17",
					"waitsAtSource": 0,
					"distance": 1300
				},
				{
					"from": "Şantier Naval h.",
					"to": "Iloviţa h.",
					"leavesAt": "07:18",
					"arrivesAt": "07:23",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iloviţa h.",
					"to": "Vârciorova Hm.",
					"leavesAt": "07:24",
					"arrivesAt": "07:31",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Vârciorova Hm.",
					"to": "Jidoştiţa h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Jidoştiţa h.",
					"to": "Gura Văii Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:42",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Gura Văii Hm.",
					"to": "Dinamica h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dinamica h.",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "07:50",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Drobeta Tr.Sev Est Hm.",
					"leavesAt": "07:56",
					"arrivesAt": "08:00",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Drobeta Tr.Sev Est Hm.",
					"to": "Drobeta Tr. Severin Mf.",
					"leavesAt": "08:01",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Drobeta Tr. Severin Mf.",
					"to": "Ergheviţa h.",
					"leavesAt": "08:08",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ergheviţa h.",
					"to": "Valea Albă Hm.",
					"leavesAt": "08:14",
					"arrivesAt": "08:24",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Albă Hm.",
					"to": "Balota",
					"leavesAt": "08:25",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Balota",
					"to": "Gârniţa Hm.",
					"leavesAt": "08:38",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Gârniţa Hm.",
					"to": "Prunişor Hm.",
					"leavesAt": "08:43",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Prunişor Hm.",
					"to": "Igiroasa Hm.",
					"leavesAt": "08:50",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Igiroasa Hm.",
					"to": "Tâmna",
					"leavesAt": "08:57",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Tâmna",
					"to": "Ciochiuţa Hm.",
					"leavesAt": "09:05",
					"arrivesAt": "09:13",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciochiuţa Hm.",
					"to": "Strehaia hc.",
					"leavesAt": "09:14",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Strehaia hc.",
					"to": "Strehaia",
					"leavesAt": "09:20",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Strehaia",
					"to": "Lunca Banului h.",
					"leavesAt": "09:28",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Lunca Banului h.",
					"to": "Butoieşti Hm.",
					"leavesAt": "09:33",
					"arrivesAt": "09:40",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Gura Motrului Hm.",
					"leavesAt": "09:41",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Filiaşi",
					"leavesAt": "09:48",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4517",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "12:09",
					"arrivesAt": "12:14",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "12:15",
					"arrivesAt": "12:21",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "12:22",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "12:29",
					"arrivesAt": "12:32",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "12:33",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "12:38",
					"arrivesAt": "12:44",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "12:51",
					"arrivesAt": "13:00",
					"waitsAtSource": 420,
					"distance": 7600
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Arcuş h.",
					"leavesAt": "13:04",
					"arrivesAt": "13:08",
					"waitsAtSource": 240,
					"distance": 5000
				},
				{
					"from": "Arcuş h.",
					"to": "Bodoc Hm.",
					"leavesAt": "13:09",
					"arrivesAt": "13:14",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Bodoc Hm.",
					"to": "Malnaş h.",
					"leavesAt": "13:15",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Malnaş h.",
					"to": "Malnaş Băi",
					"leavesAt": "13:23",
					"arrivesAt": "13:29",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Malnaş Băi",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "13:30",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "13:40",
					"arrivesAt": "13:48",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Tuşnad Sat",
					"leavesAt": "13:49",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tuşnad Sat",
					"to": "Vrabia h.",
					"leavesAt": "13:57",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Vrabia h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "14:01",
					"arrivesAt": "14:07",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "14:08",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "14:12",
					"arrivesAt": "14:16",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "14:17",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "14:28",
					"arrivesAt": "14:36",
					"waitsAtSource": 180,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1836",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Apahida",
					"leavesAt": "07:00",
					"arrivesAt": "07:17",
					"waitsAtSource": 0,
					"distance": 12300
				},
				{
					"from": "Apahida",
					"to": "Câmpia Turzii",
					"leavesAt": "07:18",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 39200
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "08:11",
					"arrivesAt": "08:27",
					"waitsAtSource": 120,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "08:29",
					"arrivesAt": "08:34",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Aiud Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "08:52",
					"arrivesAt": "09:06",
					"waitsAtSource": 120,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Alba Iulia",
					"leavesAt": "09:12",
					"arrivesAt": "09:47",
					"waitsAtSource": 360,
					"distance": 19100
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "09:51",
					"arrivesAt": "10:03",
					"waitsAtSource": 240,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Şibot",
					"leavesAt": "10:05",
					"arrivesAt": "10:27",
					"waitsAtSource": 120,
					"distance": 15000
				},
				{
					"from": "Şibot",
					"to": "Orăştie",
					"leavesAt": "10:28",
					"arrivesAt": "10:43",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Orăştie",
					"to": "Simeria",
					"leavesAt": "10:44",
					"arrivesAt": "11:07",
					"waitsAtSource": 60,
					"distance": 16500
				},
				{
					"from": "Simeria",
					"to": "Simeria Triaj",
					"leavesAt": "11:28",
					"arrivesAt": "11:34",
					"waitsAtSource": 1260,
					"distance": 3200
				},
				{
					"from": "Simeria Triaj",
					"to": "Călan Băi",
					"leavesAt": "11:35",
					"arrivesAt": "11:44",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Călan Băi",
					"to": "Călan Hm.",
					"leavesAt": "11:45",
					"arrivesAt": "11:49",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Hm.",
					"to": "Subcetate",
					"leavesAt": "11:50",
					"arrivesAt": "12:05",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Subcetate",
					"to": "Pui",
					"leavesAt": "12:07",
					"arrivesAt": "12:23",
					"waitsAtSource": 120,
					"distance": 14300
				},
				{
					"from": "Pui",
					"to": "Băniţa",
					"leavesAt": "12:24",
					"arrivesAt": "13:08",
					"waitsAtSource": 60,
					"distance": 24200
				},
				{
					"from": "Băniţa",
					"to": "Petroşani",
					"leavesAt": "13:09",
					"arrivesAt": "13:24",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Petroşani",
					"to": "Livezeni",
					"leavesAt": "13:30",
					"arrivesAt": "13:38",
					"waitsAtSource": 360,
					"distance": 5200
				},
				{
					"from": "Livezeni",
					"to": "Valea Sadului Hm.",
					"leavesAt": "13:39",
					"arrivesAt": "14:19",
					"waitsAtSource": 60,
					"distance": 26500
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "14:20",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 19600
				},
				{
					"from": "Târgu Jiu",
					"to": "Cărbuneşti",
					"leavesAt": "15:05",
					"arrivesAt": "15:33",
					"waitsAtSource": 1380,
					"distance": 23800
				},
				{
					"from": "Cărbuneşti",
					"to": "Musculeşti",
					"leavesAt": "15:34",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Musculeşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "15:51",
					"arrivesAt": "15:56",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "15:57",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Filiaşi",
					"leavesAt": "16:07",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "16:26",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Bordei hc.(900)",
					"leavesAt": "17:10",
					"arrivesAt": "17:13",
					"waitsAtSource": 900,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "17:14",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Radomiru hc.",
					"leavesAt": "17:27",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 21300
				},
				{
					"from": "Radomiru hc.",
					"to": "Caracal",
					"leavesAt": "17:44",
					"arrivesAt": "18:00",
					"waitsAtSource": 30,
					"distance": 18800
				},
				{
					"from": "Caracal",
					"to": "Stoeneşti h.",
					"leavesAt": "18:02",
					"arrivesAt": "18:10",
					"waitsAtSource": 120,
					"distance": 11100
				},
				{
					"from": "Stoeneşti h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "18:11",
					"arrivesAt": "18:18",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Radomireşti Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "18:30",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 25600
				},
				{
					"from": "Roşiori Nord",
					"to": "Vârtoapele hc.",
					"leavesAt": "18:55",
					"arrivesAt": "19:14",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Olteni",
					"leavesAt": "19:15",
					"arrivesAt": "19:24",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "19:25",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Videle",
					"leavesAt": "19:35",
					"arrivesAt": "19:49",
					"waitsAtSource": 60,
					"distance": 15800
				},
				{
					"from": "Videle",
					"to": "Grădinari",
					"leavesAt": "19:50",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 25400
				},
				{
					"from": "Grădinari",
					"to": "Bucureşti Nord",
					"leavesAt": "20:17",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 25500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5564",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "12:54",
					"arrivesAt": "12:59",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "13:00",
					"arrivesAt": "13:09",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "13:10",
					"arrivesAt": "13:18",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Bursuceni h.",
					"leavesAt": "13:20",
					"arrivesAt": "13:30",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Bursuceni h.",
					"to": "Bucecea Hm",
					"leavesAt": "13:31",
					"arrivesAt": "13:48",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Bucecea Hm",
					"to": "Leorda Hm.",
					"leavesAt": "13:49",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Leorda Hm.",
					"to": "Botoşani",
					"leavesAt": "14:09",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 15500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4048",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "19:25",
					"arrivesAt": "19:41",
					"waitsAtSource": 0,
					"distance": 14600
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Fersig h.",
					"leavesAt": "19:42",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Fersig h.",
					"to": "Mireşu Mare PM.",
					"leavesAt": "19:48",
					"arrivesAt": "19:54",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "19:55",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Ţicău h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:13",
					"waitsAtSource": 600,
					"distance": 2200
				},
				{
					"from": "Ţicău h.",
					"to": "Benesat Hm.",
					"leavesAt": "20:14",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Benesat Hm.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Inău h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Inău h.",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "20:31",
					"arrivesAt": "20:35",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Jibou",
					"leavesAt": "20:36",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 9300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9163",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Valea Păltinişului h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:20",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "07:21",
					"arrivesAt": "07:28",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Valeadeni h.",
					"leavesAt": "07:29",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valeadeni h.",
					"to": "Brebu",
					"leavesAt": "07:36",
					"arrivesAt": "07:42",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Brebu",
					"to": "Ezeriş h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ezeriş h.",
					"to": "Bănila Câlnic h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:58",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "07:59",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Reşiţa Nord",
					"to": "Reşiţa Sud Hm.",
					"leavesAt": "08:11",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4106",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "19:35",
					"arrivesAt": "19:45",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "19:51",
					"arrivesAt": "19:57",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Apahida h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Apahida h.",
					"to": "Jucu Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:08",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Jucu Hm.",
					"to": "Răscruci h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Răscruci h.",
					"to": "Bonţida Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:21",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bonţida Hm.",
					"to": "Fundătura h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Fundătura h.",
					"to": "Iclod Hm.",
					"leavesAt": "20:29",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Iclod Hm.",
					"to": "Livada Someş h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Livada Someş h.",
					"to": "Gherla",
					"leavesAt": "20:41",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Gherla",
					"to": "Buneşti h.",
					"leavesAt": "20:51",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Buneşti h.",
					"to": "Nima h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:04",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Nima h.",
					"to": "Dej Călători",
					"leavesAt": "21:05",
					"arrivesAt": "21:14",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "21:26",
					"arrivesAt": "21:33",
					"waitsAtSource": 720,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Ciceu Mihăeşti h.",
					"leavesAt": "21:34",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ciceu Mihăeşti h.",
					"to": "Reteag Hm.",
					"leavesAt": "21:40",
					"arrivesAt": "21:45",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Reteag Hm.",
					"to": "Reteag h.",
					"leavesAt": "21:46",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag h.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:54",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "21:55",
					"arrivesAt": "21:59",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "22:00",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Beclean pe Someş",
					"to": "Şintereag Hm.",
					"leavesAt": "22:19",
					"arrivesAt": "22:27",
					"waitsAtSource": 600,
					"distance": 7400
				},
				{
					"from": "Şintereag Hm.",
					"to": "Caila hc.",
					"leavesAt": "22:28",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Caila hc.",
					"to": "Sfântu h.",
					"leavesAt": "22:33",
					"arrivesAt": "22:36",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sfântu h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "22:37",
					"arrivesAt": "22:43",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "22:44",
					"arrivesAt": "22:46",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel Hm.",
					"leavesAt": "22:47",
					"arrivesAt": "22:54",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Sărata h.",
					"leavesAt": "22:55",
					"arrivesAt": "23:00",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Viişoara h.",
					"leavesAt": "23:01",
					"arrivesAt": "23:04",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Viişoara h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "23:05",
					"arrivesAt": "23:09",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "23:10",
					"arrivesAt": "23:13",
					"waitsAtSource": 30,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9572",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "08:34",
					"arrivesAt": "08:40",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Ghiroda h.",
					"leavesAt": "08:41",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Ghiroda h.",
					"to": "Remetea Mare",
					"leavesAt": "08:47",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Remetea Mare",
					"to": "Izvin h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Izvin h.",
					"to": "Recaş",
					"leavesAt": "09:05",
					"arrivesAt": "09:08",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Recaş",
					"to": "Şuştra h.",
					"leavesAt": "09:09",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Şuştra h.",
					"to": "Topolovăţ",
					"leavesAt": "09:15",
					"arrivesAt": "09:18",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Topolovăţ",
					"to": "Chizătău Hm.",
					"leavesAt": "09:26",
					"arrivesAt": "09:32",
					"waitsAtSource": 480,
					"distance": 7200
				},
				{
					"from": "Chizătău Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "09:33",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Belinţ Hm.",
					"to": "Jabăr Hm.",
					"leavesAt": "09:38",
					"arrivesAt": "09:43",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Lugoj",
					"leavesAt": "09:44",
					"arrivesAt": "09:50",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Lugoj",
					"to": "Tapia Hm.",
					"leavesAt": "09:51",
					"arrivesAt": "09:57",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Tapia Hm.",
					"to": "Găvojdia",
					"leavesAt": "09:58",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Găvojdia",
					"to": "Jena Hm.",
					"leavesAt": "10:03",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Jena Hm.",
					"to": "Sacu h.",
					"leavesAt": "10:14",
					"arrivesAt": "10:17",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sacu h.",
					"to": "Căvăran",
					"leavesAt": "10:18",
					"arrivesAt": "10:21",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Căvăran",
					"to": "Zăgujeni Hm.",
					"leavesAt": "10:22",
					"arrivesAt": "10:32",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Tibiscu h.",
					"leavesAt": "10:33",
					"arrivesAt": "10:36",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tibiscu h.",
					"to": "Caransebeş",
					"leavesAt": "10:37",
					"arrivesAt": "10:41",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 375
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1688",
			"segments": [
				{
					"from": "Tulcea Oraş",
					"to": "Tulcea Mărfuri",
					"leavesAt": "13:10",
					"arrivesAt": "13:19",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Tulcea Mărfuri",
					"to": "Cataloi Hm.",
					"leavesAt": "13:20",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Cataloi Hm.",
					"to": "Mihail Kogălniceanu h.",
					"leavesAt": "13:36",
					"arrivesAt": "13:48",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mihail Kogălniceanu h.",
					"to": "Zebil h.",
					"leavesAt": "13:49",
					"arrivesAt": "14:02",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Zebil h.",
					"to": "Babadag",
					"leavesAt": "14:03",
					"arrivesAt": "14:18",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Babadag",
					"to": "Ceamurlia de Jos h.",
					"leavesAt": "14:19",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Ceamurlia de Jos h.",
					"to": "Baia Dobrogea",
					"leavesAt": "14:36",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baia Dobrogea",
					"to": "Mihai Viteazu Hm.",
					"leavesAt": "14:43",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Mihai Viteazu Hm.",
					"to": "Cogealac",
					"leavesAt": "14:56",
					"arrivesAt": "15:14",
					"waitsAtSource": 60,
					"distance": 17400
				},
				{
					"from": "Cogealac",
					"to": "Târguşor Dobrogea Hm.",
					"leavesAt": "15:15",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Târguşor Dobrogea Hm.",
					"to": "Ram. M.K.P. Aj. M.",
					"leavesAt": "15:36",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Ram. M.K.P. Aj. M.",
					"to": "Nicolae Bălcescu",
					"leavesAt": "15:47",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Nicolae Bălcescu",
					"to": "Medgidia",
					"leavesAt": "15:54",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "16:33",
					"arrivesAt": "16:52",
					"waitsAtSource": 1260,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "16:53",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "17:15",
					"arrivesAt": "17:42",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Lehliu",
					"leavesAt": "17:43",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 39300
				},
				{
					"from": "Lehliu",
					"to": "Bucureşti Nord",
					"leavesAt": "18:07",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 69600
				}
			],
			"restrictions": [
				{
					"from": "20180105",
					"to": "20180107",
					"daysOfWeek": 383
				},
				{
					"from": "20180112",
					"to": "20180114",
					"daysOfWeek": 383
				},
				{
					"from": "20180119",
					"to": "20180121",
					"daysOfWeek": 383
				},
				{
					"from": "20180126",
					"to": "20180128",
					"daysOfWeek": 383
				},
				{
					"from": "20180202",
					"to": "20180204",
					"daysOfWeek": 383
				},
				{
					"from": "20180209",
					"to": "20180211",
					"daysOfWeek": 383
				},
				{
					"from": "20180216",
					"to": "20180218",
					"daysOfWeek": 383
				},
				{
					"from": "20180223",
					"to": "20180225",
					"daysOfWeek": 383
				},
				{
					"from": "20180302",
					"to": "20180304",
					"daysOfWeek": 383
				},
				{
					"from": "20180309",
					"to": "20180311",
					"daysOfWeek": 383
				},
				{
					"from": "20180316",
					"to": "20180318",
					"daysOfWeek": 383
				},
				{
					"from": "20180323",
					"to": "20180325",
					"daysOfWeek": 383
				},
				{
					"from": "20180330",
					"to": "20180401",
					"daysOfWeek": 383
				},
				{
					"from": "20180406",
					"to": "20180408",
					"daysOfWeek": 383
				},
				{
					"from": "20180413",
					"to": "20180415",
					"daysOfWeek": 383
				},
				{
					"from": "20180420",
					"to": "20180422",
					"daysOfWeek": 383
				},
				{
					"from": "20180427",
					"to": "20180429",
					"daysOfWeek": 383
				},
				{
					"from": "20180504",
					"to": "20180506",
					"daysOfWeek": 383
				},
				{
					"from": "20180511",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180518",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180527",
					"daysOfWeek": 383
				},
				{
					"from": "20180601",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180608",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180914",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180921",
					"to": "20180923",
					"daysOfWeek": 383
				},
				{
					"from": "20180928",
					"to": "20180930",
					"daysOfWeek": 383
				},
				{
					"from": "20181005",
					"to": "20181007",
					"daysOfWeek": 383
				},
				{
					"from": "20181012",
					"to": "20181014",
					"daysOfWeek": 383
				},
				{
					"from": "20181019",
					"to": "20181021",
					"daysOfWeek": 383
				},
				{
					"from": "20181026",
					"to": "20181028",
					"daysOfWeek": 383
				},
				{
					"from": "20181102",
					"to": "20181104",
					"daysOfWeek": 383
				},
				{
					"from": "20181109",
					"to": "20181111",
					"daysOfWeek": 383
				},
				{
					"from": "20181116",
					"to": "20181118",
					"daysOfWeek": 383
				},
				{
					"from": "20181123",
					"to": "20181125",
					"daysOfWeek": 383
				},
				{
					"from": "20181130",
					"to": "20181202",
					"daysOfWeek": 383
				},
				{
					"from": "20181207",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 383
				},
				{
					"from": "20171215",
					"to": "20171217",
					"daysOfWeek": 383
				},
				{
					"from": "20171222",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171229",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1984",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun hc.",
					"leavesAt": "17:41",
					"arrivesAt": "17:51",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "17:54",
					"arrivesAt": "18:07",
					"waitsAtSource": 180,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "18:10",
					"arrivesAt": "18:14",
					"waitsAtSource": 180,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "18:16",
					"arrivesAt": "18:31",
					"waitsAtSource": 120,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "18:34",
					"arrivesAt": "18:41",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "18:44",
					"arrivesAt": "19:07",
					"waitsAtSource": 180,
					"distance": 14000
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "19:30",
					"arrivesAt": "19:54",
					"waitsAtSource": 1380,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Feteşti",
					"leavesAt": "19:55",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 44000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "20:31",
					"arrivesAt": "20:54",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "20:55",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 108900
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2068",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Atelier Zona h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:45",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "07:49",
					"arrivesAt": "07:52",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Mohu h.",
					"leavesAt": "07:53",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Mohu h.",
					"to": "Veştem h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:01",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Veştem h.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "08:02",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "08:12",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "08:20",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "08:26",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Valea Fratelui h.",
					"leavesAt": "08:36",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Valea Fratelui h.",
					"to": "Râu Vadului h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Râu Vadului h.",
					"to": "Câineni",
					"leavesAt": "08:52",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Robeşti h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Robeşti h.",
					"to": "Balota h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:13",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Balota h.",
					"to": "Cornet Hm.",
					"leavesAt": "09:14",
					"arrivesAt": "09:19",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cornet Hm.",
					"to": "Beţel h.",
					"leavesAt": "09:20",
					"arrivesAt": "09:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Beţel h.",
					"to": "Lotru",
					"leavesAt": "09:25",
					"arrivesAt": "09:34",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Lotru",
					"to": "Cozia Hm.",
					"leavesAt": "09:35",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cozia Hm.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "09:45",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Păuşa h.",
					"leavesAt": "09:52",
					"arrivesAt": "09:57",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "09:59",
					"arrivesAt": "10:04",
					"waitsAtSource": 120,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Dăeşti Hm.",
					"leavesAt": "10:06",
					"arrivesAt": "10:13",
					"waitsAtSource": 120,
					"distance": 6100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "10:14",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "10:24",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "10:30",
					"arrivesAt": "10:32",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4537",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Azomureş h.",
					"leavesAt": "19:16",
					"arrivesAt": "19:21",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "19:22",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "19:26",
					"arrivesAt": "19:30",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Vidrasău h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vidrasău h.",
					"to": "Chirileu h.",
					"leavesAt": "19:37",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Chirileu h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "19:42",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Ogra h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Ogra h.",
					"to": "Cipău h.",
					"leavesAt": "19:52",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cipău h.",
					"to": "Iernut",
					"leavesAt": "19:57",
					"arrivesAt": "20:02",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iernut",
					"to": "Cuci h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cuci h.",
					"to": "Bogata Mureş h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:15",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Luduş",
					"leavesAt": "20:16",
					"arrivesAt": "20:20",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Luduş",
					"to": "Cheţani h.",
					"leavesAt": "20:21",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Cheţani h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "20:29",
					"arrivesAt": "20:33",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Gura Arieşului h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Lunca Mureşului h.",
					"leavesAt": "20:39",
					"arrivesAt": "20:43",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Războieni",
					"leavesAt": "20:44",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8389",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "16:34",
					"arrivesAt": "16:47",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "16:48",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "16:57",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "17:10",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "17:18",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "17:22",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "17:31",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "17:36",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "1061",
			"segments": [
				{
					"from": "Ungheni",
					"to": "Ungheni Prut Fr.",
					"leavesAt": "07:06",
					"arrivesAt": "07:10",
					"waitsAtSource": 0,
					"distance": 800
				},
				{
					"from": "Ungheni Prut Fr.",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "07:13",
					"arrivesAt": "07:15",
					"waitsAtSource": 180,
					"distance": 600
				},
				{
					"from": "Ungheni Prut Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "08:04",
					"arrivesAt": "08:12",
					"waitsAtSource": 2940,
					"distance": 5800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Holboca Hm.",
					"leavesAt": "08:13",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Holboca Hm.",
					"to": "Socola",
					"leavesAt": "08:20",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Socola",
					"to": "Nicolina",
					"leavesAt": "08:32",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "08:38",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "362",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Aghireş",
					"leavesAt": "06:44",
					"arrivesAt": "07:12",
					"waitsAtSource": 0,
					"distance": 27900
				},
				{
					"from": "Aghireş",
					"to": "Huedin",
					"leavesAt": "07:13",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Huedin",
					"to": "Ciucea Hm.",
					"leavesAt": "07:40",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Ciucea Hm.",
					"to": "Bratca",
					"leavesAt": "08:02",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Bratca",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "08:24",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Aleşd",
					"leavesAt": "08:33",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Aleşd",
					"to": "Oradea",
					"leavesAt": "08:53",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 34300
				},
				{
					"from": "Oradea",
					"to": "Episcopia Bihor",
					"leavesAt": "09:26",
					"arrivesAt": "09:34",
					"waitsAtSource": 180,
					"distance": 5700
				},
				{
					"from": "Episcopia Bihor",
					"to": "Biharkeresztes",
					"leavesAt": "09:49",
					"arrivesAt": "10:04",
					"waitsAtSource": 900,
					"distance": 12500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1584",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "14:00",
					"arrivesAt": "14:24",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "14:25",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "14:43",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "15:04",
					"arrivesAt": "15:27",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "15:28",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 108900
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2307",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Coşlariu",
					"leavesAt": "19:54",
					"arrivesAt": "20:02",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Coşlariu",
					"to": "Sântimbru h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sântimbru h.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "20:15",
					"arrivesAt": "20:19",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "20:20",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "20:28",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "20:45",
					"arrivesAt": "20:57",
					"waitsAtSource": 480,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Blandiana Hm.",
					"leavesAt": "21:10",
					"arrivesAt": "21:18",
					"waitsAtSource": 780,
					"distance": 5200
				},
				{
					"from": "Blandiana Hm.",
					"to": "Tărtăria h.",
					"leavesAt": "21:19",
					"arrivesAt": "21:25",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tărtăria h.",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "21:26",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Şibot",
					"leavesAt": "21:33",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şibot",
					"to": "Aurel Vlaicu",
					"leavesAt": "21:40",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Geoagiu h.",
					"leavesAt": "21:53",
					"arrivesAt": "21:56",
					"waitsAtSource": 300,
					"distance": 2400
				},
				{
					"from": "Geoagiu h.",
					"to": "Orăştie",
					"leavesAt": "21:57",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Orăştie",
					"to": "Pricaz h.",
					"leavesAt": "22:05",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pricaz h.",
					"to": "Turdaş Hm.",
					"leavesAt": "22:10",
					"arrivesAt": "22:18",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Turdaş Hm.",
					"to": "Simeria Veche h.",
					"leavesAt": "22:19",
					"arrivesAt": "22:24",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Simeria Veche h.",
					"to": "Simeria",
					"leavesAt": "22:25",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5442",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "05:00",
					"arrivesAt": "05:05",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "05:06",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "05:16",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 660,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "05:55",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "06:16",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "06:21",
					"arrivesAt": "06:27",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Paşcani Triaj",
					"leavesAt": "06:28",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Paşcani Triaj",
					"to": "Stolniceni h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "06:39",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "06:45",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "06:50",
					"arrivesAt": "06:55",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "06:56",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "07:01",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "07:08",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "07:18",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "07:26",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "07:31",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "07:46",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "07:52",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2183",
			"segments": [
				{
					"from": "Margina",
					"to": "Făget",
					"leavesAt": "12:08",
					"arrivesAt": "12:16",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Făget",
					"to": "Răchita h.",
					"leavesAt": "12:17",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Răchita h.",
					"to": "Mănăştur Hm.",
					"leavesAt": "12:24",
					"arrivesAt": "12:29",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Mănăştur Hm.",
					"to": "Traian Vuia h.",
					"leavesAt": "12:30",
					"arrivesAt": "12:35",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Traian Vuia h.",
					"to": "Susani Bega h.",
					"leavesAt": "12:36",
					"arrivesAt": "12:40",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Susani Bega h.",
					"to": "Cliciova",
					"leavesAt": "12:41",
					"arrivesAt": "12:47",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cliciova",
					"to": "Nevrincea h.",
					"leavesAt": "12:48",
					"arrivesAt": "12:54",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Nevrincea h.",
					"to": "Balinţ h.",
					"leavesAt": "12:55",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Balinţ h.",
					"to": "Păru h.",
					"leavesAt": "13:01",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Păru h.",
					"to": "Coşteiu Mare Hm.",
					"leavesAt": "13:07",
					"arrivesAt": "13:11",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Coşteiu Mare Hm.",
					"to": "Lugoj Nord h.",
					"leavesAt": "13:12",
					"arrivesAt": "13:19",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Lugoj Nord h.",
					"to": "Lugoj",
					"leavesAt": "13:20",
					"arrivesAt": "13:30",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4092",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "15:25",
					"arrivesAt": "15:41",
					"waitsAtSource": 0,
					"distance": 14600
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Fersig h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Fersig h.",
					"to": "Mireşu Mare PM.",
					"leavesAt": "15:48",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "15:55",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Ţicău h.",
					"leavesAt": "16:02",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ţicău h.",
					"to": "Benesat Hm.",
					"leavesAt": "16:05",
					"arrivesAt": "16:12",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Benesat Hm.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Inău h.",
					"leavesAt": "16:17",
					"arrivesAt": "16:20",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Inău h.",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:25",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Jibou",
					"leavesAt": "16:26",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 9300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1630",
			"segments": [
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "04:55",
					"arrivesAt": "05:30",
					"waitsAtSource": 0,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "05:31",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "05:40",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "05:46",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Comarnic",
					"leavesAt": "05:56",
					"arrivesAt": "06:10",
					"waitsAtSource": 120,
					"distance": 15100
				},
				{
					"from": "Comarnic",
					"to": "Breaza hc.",
					"leavesAt": "06:11",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "06:19",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "06:25",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Ploieşti Vest",
					"leavesAt": "06:36",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 18600
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "06:53",
					"arrivesAt": "07:36",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2063",
			"segments": [
				{
					"from": "Băbeni",
					"to": "Tătărani h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:28",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Tătărani h.",
					"to": "Govora",
					"leavesAt": "15:29",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Govora",
					"to": "Râureni hc.",
					"leavesAt": "15:44",
					"arrivesAt": "15:47",
					"waitsAtSource": 420,
					"distance": 2200
				},
				{
					"from": "Râureni hc.",
					"to": "Râureni",
					"leavesAt": "15:49",
					"arrivesAt": "15:56",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Râureni",
					"to": "Răstoaca h.",
					"leavesAt": "15:57",
					"arrivesAt": "15:59",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Răstoaca h.",
					"to": "Ostroveni h.",
					"leavesAt": "16:00",
					"arrivesAt": "16:03",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ostroveni h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "16:04",
					"arrivesAt": "16:06",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:10",
					"waitsAtSource": 120,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "16:11",
					"arrivesAt": "16:16",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Dăeşti Hm.",
					"leavesAt": "16:17",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Călimăneşti",
					"leavesAt": "16:23",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "16:30",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Cozia Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:47",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Cozia Hm.",
					"to": "Lotru",
					"leavesAt": "16:48",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lotru",
					"to": "Beţel h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Beţel h.",
					"to": "Cornet Hm.",
					"leavesAt": "17:04",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Cornet Hm.",
					"to": "Balota h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Balota h.",
					"to": "Robeşti h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Robeşti h.",
					"to": "Câineni",
					"leavesAt": "17:21",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Râu Vadului h.",
					"leavesAt": "17:29",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Râu Vadului h.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "17:38",
					"arrivesAt": "17:55",
					"waitsAtSource": 30,
					"distance": 9800
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Turnu Roşu hc.",
					"leavesAt": "17:56",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Podu Olt",
					"leavesAt": "18:07",
					"arrivesAt": "18:11",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "18:20",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "18:30",
					"arrivesAt": "18:33",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "18:34",
					"arrivesAt": "18:38",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:43",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Atelier Zona h.",
					"leavesAt": "18:44",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu",
					"leavesAt": "18:48",
					"arrivesAt": "18:52",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2215",
			"segments": [
				{
					"from": "Arad",
					"to": "Şofronea",
					"leavesAt": "23:50",
					"arrivesAt": "00:00",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Şofronea",
					"to": "Curtici",
					"leavesAt": "00:01",
					"arrivesAt": "00:10",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1986",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "06:45",
					"arrivesAt": "06:52",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "06:53",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "06:59",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "07:13",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "07:18",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "07:34",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "07:41",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Agigea Nord",
					"leavesAt": "07:50",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Nord",
					"to": "Constanţa",
					"leavesAt": "07:58",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "08:30",
					"arrivesAt": "08:54",
					"waitsAtSource": 1260,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "08:55",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "09:13",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "09:34",
					"arrivesAt": "09:57",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "09:58",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 108900
				}
			],
			"restrictions": [
				{
					"from": "20180428",
					"to": "20180502",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180529",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1555",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "19:22",
					"arrivesAt": "19:32",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "19:33",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Crivina",
					"leavesAt": "19:40",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 22800
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "19:55",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Ploieşti Triaj",
					"leavesAt": "20:00",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 12100
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Ploieşti Sud",
					"leavesAt": "20:18",
					"arrivesAt": "20:25",
					"waitsAtSource": 240,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4302",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "07:35",
					"arrivesAt": "07:45",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "07:51",
					"arrivesAt": "07:57",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Apahida h.",
					"leavesAt": "07:59",
					"arrivesAt": "08:03",
					"waitsAtSource": 120,
					"distance": 2900
				},
				{
					"from": "Apahida h.",
					"to": "Jucu Hm.",
					"leavesAt": "08:04",
					"arrivesAt": "08:09",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Jucu Hm.",
					"to": "Răscruci h.",
					"leavesAt": "08:10",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Răscruci h.",
					"to": "Bonţida Hm.",
					"leavesAt": "08:17",
					"arrivesAt": "08:22",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bonţida Hm.",
					"to": "Fundătura h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Fundătura h.",
					"to": "Iclod Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Iclod Hm.",
					"to": "Livada Someş h.",
					"leavesAt": "08:35",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Livada Someş h.",
					"to": "Gherla",
					"leavesAt": "08:42",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Gherla",
					"to": "Buneşti h.",
					"leavesAt": "08:53",
					"arrivesAt": "09:01",
					"waitsAtSource": 120,
					"distance": 5800
				},
				{
					"from": "Buneşti h.",
					"to": "Nima h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:05",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Nima h.",
					"to": "Dej Călători",
					"leavesAt": "09:06",
					"arrivesAt": "09:15",
					"waitsAtSource": 30,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9307",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:18",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h.(900)",
					"leavesAt": "20:19",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureştii Noi",
					"leavesAt": "20:23",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Chiajna",
					"leavesAt": "20:28",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiajna",
					"to": "Domneştii de Sus h.",
					"leavesAt": "20:37",
					"arrivesAt": "20:47",
					"waitsAtSource": 300,
					"distance": 10500
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Grădinari",
					"leavesAt": "20:48",
					"arrivesAt": "20:58",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Grădinari",
					"to": "Zorile h.",
					"leavesAt": "20:59",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Zorile h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "21:04",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "21:13",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Zăvestreni Hm.",
					"leavesAt": "21:18",
					"arrivesAt": "21:23",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Videle",
					"leavesAt": "21:24",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Videle",
					"to": "Ciolpani Hm.",
					"leavesAt": "21:32",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Gălăteni Hm.",
					"leavesAt": "21:40",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Olteni",
					"leavesAt": "21:50",
					"arrivesAt": "21:56",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Olteni",
					"to": "Vârtoapele hc.",
					"leavesAt": "21:57",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "22:05",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Atârnaţi Hm.",
					"leavesAt": "22:11",
					"arrivesAt": "22:21",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "22:22",
					"arrivesAt": "22:33",
					"waitsAtSource": 60,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8653",
			"segments": [
				{
					"from": "Medgidia",
					"to": "Nicolae Bălcescu",
					"leavesAt": "09:05",
					"arrivesAt": "09:23",
					"waitsAtSource": 0,
					"distance": 19100
				},
				{
					"from": "Nicolae Bălcescu",
					"to": "Ram. M.K.P. Aj. M.",
					"leavesAt": "09:24",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ram. M.K.P. Aj. M.",
					"to": "Târguşor Dobrogea Hm.",
					"leavesAt": "09:31",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Târguşor Dobrogea Hm.",
					"to": "Cogealac",
					"leavesAt": "09:41",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Cogealac",
					"to": "Mihai Viteazu Hm.",
					"leavesAt": "10:02",
					"arrivesAt": "10:20",
					"waitsAtSource": 60,
					"distance": 17400
				},
				{
					"from": "Mihai Viteazu Hm.",
					"to": "Baia Dobrogea",
					"leavesAt": "10:21",
					"arrivesAt": "10:32",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Baia Dobrogea",
					"to": "Ceamurlia de Jos h.",
					"leavesAt": "10:33",
					"arrivesAt": "10:39",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ceamurlia de Jos h.",
					"to": "Babadag",
					"leavesAt": "10:40",
					"arrivesAt": "10:57",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Babadag",
					"to": "Zebil h.",
					"leavesAt": "10:58",
					"arrivesAt": "11:14",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Zebil h.",
					"to": "Mihail Kogălniceanu h.",
					"leavesAt": "11:15",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Mihail Kogălniceanu h.",
					"to": "Cataloi Hm.",
					"leavesAt": "11:30",
					"arrivesAt": "11:44",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Cataloi Hm.",
					"to": "Tulcea Mărfuri",
					"leavesAt": "11:45",
					"arrivesAt": "12:00",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Tulcea Mărfuri",
					"to": "Tulcea Oraş",
					"leavesAt": "12:01",
					"arrivesAt": "12:10",
					"waitsAtSource": 60,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20180101",
					"to": "20180104",
					"daysOfWeek": 383
				},
				{
					"from": "20180108",
					"to": "20180111",
					"daysOfWeek": 383
				},
				{
					"from": "20180115",
					"to": "20180118",
					"daysOfWeek": 383
				},
				{
					"from": "20180122",
					"to": "20180125",
					"daysOfWeek": 383
				},
				{
					"from": "20180129",
					"to": "20180201",
					"daysOfWeek": 383
				},
				{
					"from": "20180205",
					"to": "20180208",
					"daysOfWeek": 383
				},
				{
					"from": "20180212",
					"to": "20180215",
					"daysOfWeek": 383
				},
				{
					"from": "20180219",
					"to": "20180222",
					"daysOfWeek": 383
				},
				{
					"from": "20180226",
					"to": "20180301",
					"daysOfWeek": 383
				},
				{
					"from": "20180305",
					"to": "20180308",
					"daysOfWeek": 383
				},
				{
					"from": "20180312",
					"to": "20180315",
					"daysOfWeek": 383
				},
				{
					"from": "20180319",
					"to": "20180322",
					"daysOfWeek": 383
				},
				{
					"from": "20180326",
					"to": "20180329",
					"daysOfWeek": 383
				},
				{
					"from": "20180402",
					"to": "20180405",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20180412",
					"daysOfWeek": 383
				},
				{
					"from": "20180416",
					"to": "20180419",
					"daysOfWeek": 383
				},
				{
					"from": "20180423",
					"to": "20180426",
					"daysOfWeek": 383
				},
				{
					"from": "20180430",
					"to": "20180503",
					"daysOfWeek": 383
				},
				{
					"from": "20180507",
					"to": "20180510",
					"daysOfWeek": 383
				},
				{
					"from": "20180514",
					"to": "20180517",
					"daysOfWeek": 383
				},
				{
					"from": "20180521",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180528",
					"to": "20180531",
					"daysOfWeek": 383
				},
				{
					"from": "20180604",
					"to": "20180607",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20180913",
					"daysOfWeek": 383
				},
				{
					"from": "20180917",
					"to": "20180920",
					"daysOfWeek": 383
				},
				{
					"from": "20180924",
					"to": "20180927",
					"daysOfWeek": 383
				},
				{
					"from": "20181001",
					"to": "20181004",
					"daysOfWeek": 383
				},
				{
					"from": "20181008",
					"to": "20181011",
					"daysOfWeek": 383
				},
				{
					"from": "20181015",
					"to": "20181018",
					"daysOfWeek": 383
				},
				{
					"from": "20181022",
					"to": "20181025",
					"daysOfWeek": 383
				},
				{
					"from": "20181029",
					"to": "20181101",
					"daysOfWeek": 383
				},
				{
					"from": "20181105",
					"to": "20181108",
					"daysOfWeek": 383
				},
				{
					"from": "20181112",
					"to": "20181115",
					"daysOfWeek": 383
				},
				{
					"from": "20181119",
					"to": "20181122",
					"daysOfWeek": 383
				},
				{
					"from": "20181126",
					"to": "20181129",
					"daysOfWeek": 383
				},
				{
					"from": "20181203",
					"to": "20181206",
					"daysOfWeek": 383
				},
				{
					"from": "20171211",
					"to": "20171214",
					"daysOfWeek": 383
				},
				{
					"from": "20171218",
					"to": "20171221",
					"daysOfWeek": 383
				},
				{
					"from": "20171225",
					"to": "20171228",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9026",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Km. 107+000 h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:43",
					"waitsAtSource": 0,
					"distance": 1000
				},
				{
					"from": "Km. 107+000 h.",
					"to": "Ram. Goleşti",
					"leavesAt": "06:44",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Ram. Goleşti",
					"to": "Goleşti",
					"leavesAt": "06:50",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Goleşti",
					"to": "Canton 97+770 h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:03",
					"waitsAtSource": 120,
					"distance": 2600
				},
				{
					"from": "Canton 97+770 h.",
					"to": "Călineşti Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:10",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Călineşti Hm.",
					"to": "Leordeni Argeş",
					"leavesAt": "07:11",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Leordeni Argeş",
					"to": "Pătroaia Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pătroaia Hm.",
					"to": "Găeşti",
					"leavesAt": "07:28",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Găeşti",
					"to": "Găeşti Sud h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:51",
					"waitsAtSource": 600,
					"distance": 4000
				},
				{
					"from": "Găeşti Sud h.",
					"to": "Cojocaru h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:56",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Cojocaru h.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "07:57",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Fusea Hm.",
					"leavesAt": "08:03",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Fusea Hm.",
					"to": "Titu",
					"leavesAt": "08:09",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "08:20",
					"arrivesAt": "08:25",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "08:26",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "08:36",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "08:43",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "08:51",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "09:00",
					"arrivesAt": "09:06",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "09:07",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "09:12",
					"arrivesAt": "09:20",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 384
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5208",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "16:10",
					"arrivesAt": "16:18",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Mihăileni Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:30",
					"waitsAtSource": 360,
					"distance": 6200
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "16:36",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Caracău h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Caracău h.",
					"to": "Livezi Ciuc",
					"leavesAt": "16:48",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Utuşoiu h.",
					"leavesAt": "16:55",
					"arrivesAt": "17:01",
					"waitsAtSource": 180,
					"distance": 4100
				},
				{
					"from": "Utuşoiu h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "17:02",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Tarcău h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Bolovăniş h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Ghimeş",
					"leavesAt": "17:25",
					"arrivesAt": "17:30",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Ghimeş",
					"to": "Palanca Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:49",
					"waitsAtSource": 840,
					"distance": 5200
				},
				{
					"from": "Palanca Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "17:50",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Simbrea Hm.",
					"leavesAt": "17:55",
					"arrivesAt": "17:59",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Simbrea Hm.",
					"to": "Goioasa Hm.",
					"leavesAt": "18:00",
					"arrivesAt": "18:07",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Goioasa Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "18:08",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Caraliţa h.",
					"to": "Asău Hm.",
					"leavesAt": "18:13",
					"arrivesAt": "18:18",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Asău Hm.",
					"to": "Comăneşti",
					"leavesAt": "18:19",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Comăneşti",
					"to": "Valea Uzului Hm.",
					"leavesAt": "18:29",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "18:38",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Dofteana Bacău",
					"leavesAt": "18:41",
					"arrivesAt": "18:46",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Dofteana Bacău",
					"to": "Cireşoaia h.",
					"leavesAt": "18:47",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cireşoaia h.",
					"to": "Saline hc.",
					"leavesAt": "18:53",
					"arrivesAt": "18:58",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Saline hc.",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "18:59",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Viişoara h",
					"leavesAt": "19:03",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Viişoara h",
					"to": "Oneşti",
					"leavesAt": "19:07",
					"arrivesAt": "19:19",
					"waitsAtSource": 30,
					"distance": 9100
				},
				{
					"from": "Oneşti",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "19:30",
					"arrivesAt": "19:35",
					"waitsAtSource": 660,
					"distance": 3400
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Borzeşti Bacău",
					"leavesAt": "19:36",
					"arrivesAt": "19:45",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Căiuţi Hm.",
					"leavesAt": "19:46",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Bâlca hc.",
					"leavesAt": "19:55",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Bâlca hc.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:07",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Urecheşti Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:11",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Adjud",
					"leavesAt": "20:12",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "20:24",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "20:32",
					"arrivesAt": "20:36",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "20:37",
					"arrivesAt": "20:43",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "20:44",
					"arrivesAt": "20:48",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "20:49",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Mărăşeşti",
					"to": "Tecuci",
					"leavesAt": "21:01",
					"arrivesAt": "21:22",
					"waitsAtSource": 120,
					"distance": 19000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2141",
			"segments": [
				{
					"from": "Simeria",
					"to": "Bârcea Mare h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:42",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Bârcea Mare h.",
					"to": "Bârcea Mică",
					"leavesAt": "04:43",
					"arrivesAt": "04:46",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Bârcea Mică",
					"to": "Pestişu Mare h.",
					"leavesAt": "04:47",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Pestişu Mare h.",
					"to": "Hunedoara",
					"leavesAt": "04:52",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9557",
			"segments": [
				{
					"from": "Orşova",
					"to": "Valea Cernei Hm.",
					"leavesAt": "16:11",
					"arrivesAt": "16:17",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Valea Cernei Hm.",
					"to": "Topleţ Hm.",
					"leavesAt": "16:18",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Topleţ Hm.",
					"to": "Băile Herculane",
					"leavesAt": "16:24",
					"arrivesAt": "16:33",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Herculane",
					"to": "Mehadia Nouă Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:43",
					"waitsAtSource": 420,
					"distance": 1900
				},
				{
					"from": "Mehadia Nouă Hm.",
					"to": "Mehadia Hm.",
					"leavesAt": "16:49",
					"arrivesAt": "16:52",
					"waitsAtSource": 360,
					"distance": 2400
				},
				{
					"from": "Mehadia Hm.",
					"to": "Iablaniţa",
					"leavesAt": "16:53",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Iablaniţa",
					"to": "Cruşovăţ",
					"leavesAt": "17:04",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Cruşovăţ",
					"to": "Cornea h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Cornea h.",
					"to": "Domaşnea Cornea Hm.",
					"leavesAt": "17:20",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Domaşnea Cornea Hm.",
					"to": "Luncaviţa h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:05",
					"waitsAtSource": 2160,
					"distance": 3000
				},
				{
					"from": "Luncaviţa h.",
					"to": "Poarta Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Poarta Hm.",
					"to": "Teregova Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Teregova Hm.",
					"to": "Armeniş",
					"leavesAt": "18:22",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Armeniş",
					"to": "Slatina Timiş",
					"leavesAt": "18:30",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Slatina Timiş",
					"to": "Vălişoara Hm.",
					"leavesAt": "18:38",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Vălişoara Hm.",
					"to": "Petroşniţa h.",
					"leavesAt": "18:45",
					"arrivesAt": "18:48",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Petroşniţa h.",
					"to": "Valea Timişului Hm.",
					"leavesAt": "18:49",
					"arrivesAt": "18:52",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Valea Timişului Hm.",
					"to": "Balta Sărată",
					"leavesAt": "18:53",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Balta Sărată",
					"to": "Caransebeş haltă h.",
					"leavesAt": "18:58",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Caransebeş haltă h.",
					"to": "Caransebeş",
					"leavesAt": "19:03",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1748",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Câmpia Turzii",
					"leavesAt": "16:02",
					"arrivesAt": "17:10",
					"waitsAtSource": 0,
					"distance": 51500
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "17:12",
					"arrivesAt": "17:29",
					"waitsAtSource": 120,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Luduş",
					"leavesAt": "17:47",
					"arrivesAt": "18:05",
					"waitsAtSource": 1080,
					"distance": 19200
				},
				{
					"from": "Luduş",
					"to": "Iernut",
					"leavesAt": "18:06",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Iernut",
					"to": "Târgu Mureş",
					"leavesAt": "18:21",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 28600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4586",
			"segments": [
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "18:59",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "19:00",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "19:05",
					"arrivesAt": "19:11",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "19:17",
					"arrivesAt": "19:21",
					"waitsAtSource": 360,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "19:22",
					"arrivesAt": "19:30",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "19:37",
					"arrivesAt": "19:43",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1632",
			"segments": [
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "08:40",
					"arrivesAt": "09:15",
					"waitsAtSource": 0,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Buşteni",
					"leavesAt": "09:17",
					"arrivesAt": "09:29",
					"waitsAtSource": 120,
					"distance": 11400
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "09:30",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "09:40",
					"arrivesAt": "10:03",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "10:04",
					"arrivesAt": "10:25",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "10:26",
					"arrivesAt": "11:05",
					"waitsAtSource": 60,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5738",
			"segments": [
				{
					"from": "Cacica Hm.",
					"to": "Pârteşti h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:59",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Pârteşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Soloneţ h.",
					"to": "Todireşti h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Todireşti h.",
					"to": "Părhăuţi h.",
					"leavesAt": "21:15",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Părhăuţi h.",
					"to": "Dărmăneşti",
					"leavesAt": "21:24",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "21:33",
					"arrivesAt": "21:40",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "21:41",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9372",
			"segments": [
				{
					"from": "Zimnicea",
					"to": "Ulmuleţ h.",
					"leavesAt": "06:55",
					"arrivesAt": "07:07",
					"waitsAtSource": 0,
					"distance": 9800
				},
				{
					"from": "Ulmuleţ h.",
					"to": "Şoimu h.",
					"leavesAt": "07:08",
					"arrivesAt": "07:18",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Şoimu h.",
					"to": "Păuleasa h.",
					"leavesAt": "07:19",
					"arrivesAt": "07:24",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Păuleasa h.",
					"to": "Smârdioasa h.",
					"leavesAt": "07:25",
					"arrivesAt": "07:30",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Smârdioasa h.",
					"to": "Brânceni h.",
					"leavesAt": "07:31",
					"arrivesAt": "07:36",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Brânceni h.",
					"to": "Ţigăneşti h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:40",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Ţigăneşti h.",
					"to": "Alexandria",
					"leavesAt": "07:41",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 9500
				},
				{
					"from": "Alexandria",
					"to": "Alexandria Nord h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:17",
					"waitsAtSource": 1200,
					"distance": 1600
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Buzescu h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Buzescu h.",
					"to": "Plosca Hm.",
					"leavesAt": "08:29",
					"arrivesAt": "08:41",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Plosca Hm.",
					"to": "Peret hc.",
					"leavesAt": "08:50",
					"arrivesAt": "08:56",
					"waitsAtSource": 540,
					"distance": 4200
				},
				{
					"from": "Peret hc.",
					"to": "Roşiori Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "09:12",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4507",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "12:00",
					"arrivesAt": "12:08",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Racu h.",
					"leavesAt": "12:09",
					"arrivesAt": "12:12",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Racu h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "12:13",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Dăneşti h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:25",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dăneşti h.",
					"to": "Cârţani h.",
					"leavesAt": "12:26",
					"arrivesAt": "12:29",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cârţani h.",
					"to": "Tomeşti h.",
					"leavesAt": "12:30",
					"arrivesAt": "12:33",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Izvoru Oltului",
					"leavesAt": "12:34",
					"arrivesAt": "12:38",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Izvoru Oltului",
					"to": "Sândominic h.",
					"leavesAt": "12:39",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "12:44",
					"arrivesAt": "12:53",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "12:54",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Şugău h.",
					"leavesAt": "13:13",
					"arrivesAt": "13:17",
					"waitsAtSource": 420,
					"distance": 3000
				},
				{
					"from": "Şugău h.",
					"to": "Valea Strâmbă h.",
					"leavesAt": "13:18",
					"arrivesAt": "13:21",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Gheorgheni",
					"leavesAt": "13:22",
					"arrivesAt": "13:26",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Gheorgheni",
					"to": "Lăzarea Hm.",
					"leavesAt": "13:31",
					"arrivesAt": "13:36",
					"waitsAtSource": 300,
					"distance": 4400
				},
				{
					"from": "Lăzarea Hm.",
					"to": "Ditrău",
					"leavesAt": "13:37",
					"arrivesAt": "13:43",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ditrău",
					"to": "Subcetate Mureş Hm.",
					"leavesAt": "13:44",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Subcetate Mureş Hm.",
					"to": "Sărmaş Runc h.",
					"leavesAt": "13:53",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărmaş Runc h.",
					"to": "Gălăuţaş Hm.",
					"leavesAt": "14:00",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Gălăuţaş Hm.",
					"to": "Topliţa",
					"leavesAt": "14:08",
					"arrivesAt": "14:16",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Topliţa",
					"to": "Ciobotani h.",
					"leavesAt": "14:27",
					"arrivesAt": "14:37",
					"waitsAtSource": 660,
					"distance": 6600
				},
				{
					"from": "Ciobotani h.",
					"to": "Stânceni Hm.",
					"leavesAt": "14:38",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Stânceni Hm.",
					"to": "Stânceni h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Stânceni h.",
					"to": "Stânceni Neagra h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Stânceni Neagra h.",
					"to": "Lunca Bradului Hm.",
					"leavesAt": "14:59",
					"arrivesAt": "15:08",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Lunca Bradului Hm.",
					"to": "Andreneasa h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:26",
					"waitsAtSource": 420,
					"distance": 7000
				},
				{
					"from": "Andreneasa h.",
					"to": "Răstoliţa Hm.",
					"leavesAt": "15:27",
					"arrivesAt": "15:36",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Răstoliţa Hm.",
					"to": "Borzia h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Borzia h.",
					"to": "Deda Bistra Hm.",
					"leavesAt": "15:42",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Deda Bistra Hm.",
					"to": "Deda",
					"leavesAt": "15:47",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Deda",
					"to": "Ruşii Munţi h.",
					"leavesAt": "16:38",
					"arrivesAt": "16:44",
					"waitsAtSource": 2460,
					"distance": 4500
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "16:45",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Halta Aluniş h.",
					"leavesAt": "16:55",
					"arrivesAt": "17:01",
					"waitsAtSource": 360,
					"distance": 3800
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Ideciu de Jos h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Reghin",
					"leavesAt": "17:14",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Reghin",
					"to": "Petelea h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Petelea h.",
					"to": "Periş Mureş h.",
					"leavesAt": "17:34",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Periş Mureş h.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "17:41",
					"arrivesAt": "17:47",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "17:48",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "17:55",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Târgu Mureş",
					"leavesAt": "18:09",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2038",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "05:23",
					"arrivesAt": "05:32",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "05:38",
					"arrivesAt": "05:44",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Cojocna Hm.",
					"leavesAt": "05:45",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cojocna Hm.",
					"to": "Tunel Hm.",
					"leavesAt": "05:51",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tunel Hm.",
					"to": "Boju",
					"leavesAt": "06:00",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Boju",
					"to": "Valea Florilor Hm.",
					"leavesAt": "06:09",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Ploscoş h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ploscoş h.",
					"to": "Cânepişti h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cânepişti h.",
					"to": "Câmpia Turzii",
					"leavesAt": "06:34",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Câmpia Turzii",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "06:43",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Grindeni h.",
					"leavesAt": "06:52",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Grindeni h.",
					"to": "Războieni",
					"leavesAt": "06:59",
					"arrivesAt": "07:02",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "07:03",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Unirea Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea Hm.",
					"to": "Decea h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Decea h.",
					"to": "Mirăslău h.",
					"leavesAt": "07:19",
					"arrivesAt": "07:23",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Mirăslău h.",
					"to": "Aiud Hm.",
					"leavesAt": "07:24",
					"arrivesAt": "07:31",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "07:32",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Coşlariu",
					"leavesAt": "07:57",
					"arrivesAt": "08:05",
					"waitsAtSource": 660,
					"distance": 3500
				},
				{
					"from": "Coşlariu",
					"to": "Sântimbru h.",
					"leavesAt": "08:06",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sântimbru h.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "08:17",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "08:22",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "08:30",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "08:40",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Blandiana Hm.",
					"leavesAt": "08:58",
					"arrivesAt": "09:06",
					"waitsAtSource": 360,
					"distance": 5200
				},
				{
					"from": "Blandiana Hm.",
					"to": "Tărtăria h.",
					"leavesAt": "09:07",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tărtăria h.",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "09:13",
					"arrivesAt": "09:19",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Şibot",
					"leavesAt": "09:20",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şibot",
					"to": "Aurel Vlaicu",
					"leavesAt": "09:27",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Geoagiu h.",
					"leavesAt": "09:35",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Geoagiu h.",
					"to": "Orăştie",
					"leavesAt": "09:38",
					"arrivesAt": "09:44",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Orăştie",
					"to": "Pricaz h.",
					"leavesAt": "09:45",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pricaz h.",
					"to": "Turdaş Hm.",
					"leavesAt": "09:50",
					"arrivesAt": "09:58",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Turdaş Hm.",
					"to": "Simeria",
					"leavesAt": "09:59",
					"arrivesAt": "10:11",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Simeria",
					"to": "Săuleşti h.",
					"leavesAt": "10:14",
					"arrivesAt": "10:18",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Săuleşti h.",
					"to": "Deva",
					"leavesAt": "10:19",
					"arrivesAt": "10:27",
					"waitsAtSource": 30,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5736",
			"segments": [
				{
					"from": "Cacica Hm.",
					"to": "Pârteşti h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:08",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Pârteşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Soloneţ h.",
					"to": "Todireşti h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Todireşti h.",
					"to": "Părhăuţi h.",
					"leavesAt": "17:24",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Părhăuţi h.",
					"to": "Dărmăneşti",
					"leavesAt": "17:33",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "17:42",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "17:50",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5072",
			"segments": [
				{
					"from": "Buzău",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "04:30",
					"arrivesAt": "04:40",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Ulmeni",
					"leavesAt": "04:41",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "04:47",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "04:52",
					"arrivesAt": "05:01",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "05:02",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "05:10",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "05:18",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "05:23",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "05:29",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "05:32",
					"arrivesAt": "05:38",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "05:44",
					"arrivesAt": "05:51",
					"waitsAtSource": 360,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "05:52",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Triaj",
					"leavesAt": "06:18",
					"arrivesAt": "06:24",
					"waitsAtSource": 1200,
					"distance": 3600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Brazi",
					"leavesAt": "06:28",
					"arrivesAt": "06:36",
					"waitsAtSource": 240,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9486",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(901)",
					"leavesAt": "16:50",
					"arrivesAt": "16:53",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Plaiu Vulcăneşti Hm.",
					"leavesAt": "16:54",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plaiu Vulcăneşti Hm.",
					"to": "Cârcea h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cârcea h.",
					"to": "Pieleşti Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Pieleşti Hm.",
					"to": "Toporaş h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Toporaş h.",
					"to": "Robăneşti Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Robăneşti Hm.",
					"to": "Spineni h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Spineni h.",
					"to": "Balş",
					"leavesAt": "17:33",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Balş",
					"to": "Canton 217 h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:53",
					"waitsAtSource": 540,
					"distance": 1800
				},
				{
					"from": "Canton 217 h.",
					"to": "Brăneţ h.",
					"leavesAt": "17:54",
					"arrivesAt": "17:59",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Brăneţ h.",
					"to": "Piatra Olt",
					"leavesAt": "18:00",
					"arrivesAt": "18:10",
					"waitsAtSource": 30,
					"distance": 7700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2703",
			"segments": [
				{
					"from": "Subcetate",
					"to": "Covragiu h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:10",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Covragiu h.",
					"to": "Plopi h.",
					"leavesAt": "06:11",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Plopi h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "06:15",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Măceu h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măceu h.",
					"to": "Ruşi h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ruşi h.",
					"to": "Călan Hm.",
					"leavesAt": "06:26",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Călan Hm.",
					"to": "Călan Băi",
					"leavesAt": "06:37",
					"arrivesAt": "06:41",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Băi",
					"to": "Batiz h.",
					"leavesAt": "06:42",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Batiz h.",
					"to": "Băcia Hm.",
					"leavesAt": "06:45",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Băcia Hm.",
					"to": "Băcia h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Băcia h.",
					"to": "Simeria Triaj",
					"leavesAt": "06:51",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Simeria Triaj",
					"to": "Simeria",
					"leavesAt": "06:55",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180107",
					"daysOfWeek": 287
				},
				{
					"from": "20180113",
					"to": "20180204",
					"daysOfWeek": 287
				},
				{
					"from": "20180210",
					"to": "20180331",
					"daysOfWeek": 287
				},
				{
					"from": "20180411",
					"to": "20180601",
					"daysOfWeek": 287
				},
				{
					"from": "20180604",
					"to": "20180608",
					"daysOfWeek": 287
				},
				{
					"from": "20180611",
					"to": "20180615",
					"daysOfWeek": 287
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 287
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 287
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5636",
			"segments": [
				{
					"from": "Dorneşti",
					"to": "Ţibeni h.",
					"leavesAt": "21:15",
					"arrivesAt": "21:24",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Ţibeni h.",
					"to": "Milişăuţi Hm.",
					"leavesAt": "21:25",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Dărmăneşti",
					"leavesAt": "21:34",
					"arrivesAt": "21:45",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "21:46",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "21:58",
					"arrivesAt": "22:03",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3532",
			"segments": [
				{
					"from": "Rupea",
					"to": "Mateiaş h.",
					"leavesAt": "04:59",
					"arrivesAt": "05:13",
					"waitsAtSource": 0,
					"distance": 10700
				},
				{
					"from": "Mateiaş h.",
					"to": "Racoş Hm.",
					"leavesAt": "05:14",
					"arrivesAt": "05:20",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Racoş Hm.",
					"to": "Augustin Hm.",
					"leavesAt": "05:21",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Augustin Hm.",
					"to": "Ormeniş h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ormeniş h.",
					"to": "Apaţa",
					"leavesAt": "05:47",
					"arrivesAt": "05:57",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Apaţa",
					"to": "Măieruş h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Măieruş h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Rotbav h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Rotbav h.",
					"to": "Feldioara Hm.",
					"leavesAt": "06:16",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Bod Hm.",
					"leavesAt": "06:24",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Bod Hm.",
					"to": "Stupini Hm.",
					"leavesAt": "06:40",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Stupini Hm.",
					"to": "Braşov",
					"leavesAt": "06:50",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1720",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Tălmaciu Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "07:12",
					"waitsAtSource": 0,
					"distance": 17800
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "07:13",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "07:20",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Lotru",
					"leavesAt": "07:27",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 42700
				},
				{
					"from": "Lotru",
					"to": "Păuşa h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "08:40",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "08:46",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 16200
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Băbeni",
					"leavesAt": "09:05",
					"arrivesAt": "09:24",
					"waitsAtSource": 120,
					"distance": 19600
				},
				{
					"from": "Băbeni",
					"to": "Fişcălia Hm.",
					"leavesAt": "09:25",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Drăgăşani",
					"leavesAt": "09:45",
					"arrivesAt": "09:57",
					"waitsAtSource": 480,
					"distance": 17200
				},
				{
					"from": "Drăgăşani",
					"to": "Piatra Olt",
					"leavesAt": "09:58",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 33800
				},
				{
					"from": "Piatra Olt",
					"to": "Brăneţ h.",
					"leavesAt": "10:28",
					"arrivesAt": "10:34",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Brăneţ h.",
					"to": "Balş",
					"leavesAt": "10:35",
					"arrivesAt": "10:40",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Balş",
					"to": "Toporaş h.",
					"leavesAt": "10:41",
					"arrivesAt": "10:55",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Toporaş h.",
					"to": "Bordei hc.(901)",
					"leavesAt": "10:56",
					"arrivesAt": "11:11",
					"waitsAtSource": 30,
					"distance": 15700
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Craiova",
					"leavesAt": "11:12",
					"arrivesAt": "11:18",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9616",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "14:21",
					"arrivesAt": "14:30",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Giroc h.",
					"leavesAt": "14:31",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Giroc h.",
					"to": "Urseni h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:40",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Urseni h.",
					"to": "Uliuc h.",
					"leavesAt": "14:41",
					"arrivesAt": "14:46",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Uliuc h.",
					"to": "Sacoşu Mic",
					"leavesAt": "14:47",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Sacoşu Mic",
					"to": "Chevereş h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Chevereş h.",
					"to": "Bacova h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bacova h.",
					"to": "Buziaş",
					"leavesAt": "15:04",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Buziaş",
					"to": "Căpăt h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Căpăt h.",
					"to": "Sinia Hm.",
					"leavesAt": "15:17",
					"arrivesAt": "15:22",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Sinia Hm.",
					"to": "Boldur h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Boldur h.",
					"to": "Lugoj",
					"leavesAt": "15:29",
					"arrivesAt": "15:43",
					"waitsAtSource": 30,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4101",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Viişoara h.",
					"leavesAt": "03:20",
					"arrivesAt": "03:26",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Viişoara h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "03:27",
					"arrivesAt": "03:34",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "03:35",
					"arrivesAt": "03:39",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "03:40",
					"arrivesAt": "03:45",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Sfântu h.",
					"leavesAt": "03:46",
					"arrivesAt": "03:51",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Sfântu h.",
					"to": "Caila hc.",
					"leavesAt": "03:52",
					"arrivesAt": "03:55",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Caila hc.",
					"to": "Şintereag Hm.",
					"leavesAt": "03:56",
					"arrivesAt": "04:00",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Şintereag Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "04:01",
					"arrivesAt": "04:10",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Beclean pe Someş",
					"to": "Coldău Hm.",
					"leavesAt": "04:12",
					"arrivesAt": "04:22",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Coldău Hm.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "04:23",
					"arrivesAt": "04:26",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "04:27",
					"arrivesAt": "04:30",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "04:31",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Dej Triaj",
					"leavesAt": "04:36",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "04:47",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "05:14",
					"arrivesAt": "05:22",
					"waitsAtSource": 1200,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Buneşti h.",
					"leavesAt": "05:23",
					"arrivesAt": "05:27",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Buneşti h.",
					"to": "Gherla",
					"leavesAt": "05:28",
					"arrivesAt": "05:36",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:44",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "05:45",
					"arrivesAt": "05:50",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "06:05",
					"arrivesAt": "06:11",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Apahida h.",
					"to": "Apahida",
					"leavesAt": "06:19",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "06:25",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "06:30",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "06:44",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3120",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Vest Hm.",
					"leavesAt": "07:15",
					"arrivesAt": "07:22",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "07:23",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Cefa Hm.",
					"leavesAt": "07:35",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Cefa Hm.",
					"to": "Mădăraş Bihor h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Mădăraş Bihor h.",
					"to": "Salonta",
					"leavesAt": "07:56",
					"arrivesAt": "08:00",
					"waitsAtSource": 30,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2043",
			"segments": [
				{
					"from": "Simeria",
					"to": "Săuleşti h.",
					"leavesAt": "12:20",
					"arrivesAt": "12:25",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Săuleşti h.",
					"to": "Deva",
					"leavesAt": "12:26",
					"arrivesAt": "12:34",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "12:36",
					"arrivesAt": "12:45",
					"waitsAtSource": 120,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Veţel h.",
					"leavesAt": "12:46",
					"arrivesAt": "12:50",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Veţel h.",
					"to": "Brănişca Hm.",
					"leavesAt": "12:51",
					"arrivesAt": "12:55",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "12:56",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Ilia",
					"leavesAt": "13:02",
					"arrivesAt": "13:09",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Ilia",
					"to": "Gurasada Hm.",
					"leavesAt": "13:10",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Gurasada Hm.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "13:18",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Burjuc h.",
					"leavesAt": "13:26",
					"arrivesAt": "13:31",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Burjuc h.",
					"to": "Zam",
					"leavesAt": "13:32",
					"arrivesAt": "13:44",
					"waitsAtSource": 30,
					"distance": 8500
				},
				{
					"from": "Zam",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "13:45",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Ilteu",
					"leavesAt": "13:50",
					"arrivesAt": "13:57",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ilteu",
					"to": "Toc h.",
					"leavesAt": "13:58",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Toc h.",
					"to": "Săvârşin",
					"leavesAt": "14:02",
					"arrivesAt": "14:09",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Săvârşin",
					"to": "Vărădia h.",
					"leavesAt": "14:10",
					"arrivesAt": "14:16",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vărădia h.",
					"to": "Vărădia Hm.",
					"leavesAt": "14:17",
					"arrivesAt": "14:22",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărădia Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "14:23",
					"arrivesAt": "14:27",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "14:28",
					"arrivesAt": "14:35",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Căpruţa h.",
					"leavesAt": "14:36",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Căpruţa h.",
					"to": "Bârzava",
					"leavesAt": "14:42",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bârzava",
					"to": "Conop Hm.",
					"leavesAt": "14:48",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Conop Hm.",
					"to": "Corfeni h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Corfeni h.",
					"to": "Milova",
					"leavesAt": "15:06",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Milova",
					"to": "Radna",
					"leavesAt": "15:13",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Radna",
					"to": "Păuliş Hm.",
					"leavesAt": "15:29",
					"arrivesAt": "15:38",
					"waitsAtSource": 240,
					"distance": 6900
				},
				{
					"from": "Păuliş Hm.",
					"to": "Păuliş h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş h.",
					"to": "Ghioroc",
					"leavesAt": "15:44",
					"arrivesAt": "15:51",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ghioroc",
					"to": "Glogovăţ",
					"leavesAt": "15:52",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Glogovăţ",
					"to": "Arad",
					"leavesAt": "16:04",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2603",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Cab 1 h",
					"leavesAt": "08:21",
					"arrivesAt": "08:25",
					"waitsAtSource": 0,
					"distance": 4400
				},
				{
					"from": "Ronaţ Triaj Cab 1 h",
					"to": "Ronaţ Triaj h",
					"leavesAt": "08:26",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "08:29",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "08:32",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Băile Călacea",
					"leavesAt": "08:43",
					"arrivesAt": "08:49",
					"waitsAtSource": 300,
					"distance": 7200
				},
				{
					"from": "Băile Călacea",
					"to": "Orţişoara",
					"leavesAt": "08:50",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Orţişoara",
					"to": "Vinga Hm.",
					"leavesAt": "08:56",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "09:05",
					"arrivesAt": "09:11",
					"waitsAtSource": 240,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Valea Viilor Hm.",
					"leavesAt": "09:15",
					"arrivesAt": "09:20",
					"waitsAtSource": 240,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Aradu Nou",
					"leavesAt": "09:21",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "09:31",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2101",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "06:06",
					"arrivesAt": "06:12",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Ghimbav Hm.",
					"leavesAt": "06:13",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "06:21",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Codlea Hm.",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "06:28",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "06:38",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Valea Homorod h.",
					"leavesAt": "06:44",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Valea Homorod h.",
					"to": "Brădet Hm.",
					"leavesAt": "06:51",
					"arrivesAt": "07:00",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Brădet Hm.",
					"to": "Perşani h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Şercaia Hm.",
					"leavesAt": "07:10",
					"arrivesAt": "07:19",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Şercaia Hm.",
					"to": "Şercaia h.",
					"leavesAt": "07:20",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 1200
				},
				{
					"from": "Şercaia h.",
					"to": "Mândra Oltului h.",
					"leavesAt": "07:23",
					"arrivesAt": "07:30",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Făgăraş",
					"leavesAt": "07:31",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Făgăraş",
					"to": "Beclean pe Olt h.",
					"leavesAt": "07:39",
					"arrivesAt": "07:44",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Beclean pe Olt h.",
					"to": "Dridif h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:49",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Dridif h.",
					"to": "Voila Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Voila Hm.",
					"to": "Olteţ h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:07",
					"waitsAtSource": 300,
					"distance": 6100
				},
				{
					"from": "Olteţ h.",
					"to": "Viştea h.",
					"leavesAt": "08:08",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Viştea h.",
					"to": "Ucea",
					"leavesAt": "08:13",
					"arrivesAt": "08:17",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ucea",
					"to": "Arpaş Hm.",
					"leavesAt": "08:18",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Arpaş Hm.",
					"to": "Cârţa h.",
					"leavesAt": "08:27",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cârţa h.",
					"to": "Scoreiu h.",
					"leavesAt": "08:31",
					"arrivesAt": "08:35",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Scoreiu h.",
					"to": "Sărata Colun h.",
					"leavesAt": "08:36",
					"arrivesAt": "08:39",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Sărata Colun h.",
					"to": "Porumbacu Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:45",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "08:46",
					"arrivesAt": "08:54",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Avrig Hm.",
					"to": "Mârşa h.",
					"leavesAt": "08:55",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Mârşa h.",
					"to": "Racoviţa h.",
					"leavesAt": "09:00",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Racoviţa h.",
					"to": "Sebeş Olt h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:07",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Podu Olt",
					"leavesAt": "09:08",
					"arrivesAt": "09:13",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "09:14",
					"arrivesAt": "09:21",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "09:22",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "09:32",
					"arrivesAt": "09:35",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "09:36",
					"arrivesAt": "09:43",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Atelier Zona h.",
					"leavesAt": "09:44",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu",
					"leavesAt": "09:48",
					"arrivesAt": "09:52",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2852",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Amaradia",
					"leavesAt": "08:10",
					"arrivesAt": "08:17",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Amaradia",
					"to": "Drăguţeşti h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "08:23",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Vârţ h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:38",
					"waitsAtSource": 420,
					"distance": 4100
				},
				{
					"from": "Vârţ h.",
					"to": "Rogojelu",
					"leavesAt": "08:39",
					"arrivesAt": "08:43",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Rogojelu",
					"to": "Km. 49+800 h.",
					"leavesAt": "08:44",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rovinari Hm.",
					"leavesAt": "08:47",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Rovinari Hm.",
					"to": "Rovinari Sud h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Roşia Jiu h.",
					"leavesAt": "08:54",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Roşia Jiu h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Bâlteni h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:05",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Bâlteni h.",
					"to": "Peşteana Jiu h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:09",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Plopşoru",
					"leavesAt": "09:10",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Plopşoru",
					"to": "Sărdăneşti h.",
					"leavesAt": "09:19",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Gârbovu h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:28",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Gârbovu h.",
					"to": "Turceni",
					"leavesAt": "09:29",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Turceni",
					"to": "Termo Turceni h.",
					"leavesAt": "09:38",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 900
				},
				{
					"from": "Termo Turceni h.",
					"to": "Km. 9+820 h.",
					"leavesAt": "09:41",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Km. 9+820 h.",
					"to": "Ioneşti Gorj h.",
					"leavesAt": "09:45",
					"arrivesAt": "09:48",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Ioneşti Gorj h.",
					"to": "Filiaşi",
					"leavesAt": "09:49",
					"arrivesAt": "10:04",
					"waitsAtSource": 30,
					"distance": 12400
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "10:06",
					"arrivesAt": "10:09",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "10:10",
					"arrivesAt": "10:14",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "10:15",
					"arrivesAt": "10:19",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "10:20",
					"arrivesAt": "10:25",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "10:26",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "10:30",
					"arrivesAt": "10:35",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "10:36",
					"arrivesAt": "10:38",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "10:39",
					"arrivesAt": "10:43",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "10:44",
					"arrivesAt": "10:47",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "10:48",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180107",
					"to": "20180107",
					"daysOfWeek": 319
				},
				{
					"from": "20180115",
					"to": "20180202",
					"daysOfWeek": 319
				},
				{
					"from": "20180212",
					"to": "20180330",
					"daysOfWeek": 319
				},
				{
					"from": "20180411",
					"to": "20180615",
					"daysOfWeek": 319
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9164",
			"segments": [
				{
					"from": "Reşiţa Sud Hm.",
					"to": "Reşiţa Nord",
					"leavesAt": "13:17",
					"arrivesAt": "13:26",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Reşiţa Nord",
					"to": "Bănila Câlnic h.",
					"leavesAt": "13:27",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Ezeriş h.",
					"leavesAt": "13:35",
					"arrivesAt": "13:41",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Ezeriş h.",
					"to": "Brebu",
					"leavesAt": "13:42",
					"arrivesAt": "13:54",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Brebu",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "14:04",
					"arrivesAt": "14:15",
					"waitsAtSource": 600,
					"distance": 10500
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Valea Păltinişului h.",
					"leavesAt": "14:16",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Caransebeş",
					"leavesAt": "14:24",
					"arrivesAt": "14:29",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8011",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "07:30",
					"arrivesAt": "07:39",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "07:40",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Pasărea",
					"leavesAt": "07:46",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pasărea",
					"to": "Brăneşti Sat h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "07:57",
					"arrivesAt": "08:00",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Islaz h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Islaz h.",
					"to": "Fundulea Hm.",
					"leavesAt": "08:04",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 9800
				},
				{
					"from": "Fundulea Hm.",
					"to": "Mostiştea h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Mostiştea h.",
					"to": "Săruleşti",
					"leavesAt": "08:17",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Săruleşti",
					"to": "Preasna h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Preasna h.",
					"to": "Lehliu",
					"leavesAt": "08:28",
					"arrivesAt": "08:36",
					"waitsAtSource": 30,
					"distance": 8800
				},
				{
					"from": "Lehliu",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "08:42",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dâlga h.",
					"leavesAt": "08:46",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dâlga h.",
					"to": "Bogdana h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Bogdana h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "08:58",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Ivăneşti h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:06",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ivăneşti h.",
					"to": "Ciulniţa",
					"leavesAt": "09:07",
					"arrivesAt": "09:12",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "09:13",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "09:20",
					"arrivesAt": "09:23",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "09:24",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "09:27",
					"arrivesAt": "09:31",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "09:32",
					"arrivesAt": "09:36",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "09:37",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "09:42",
					"arrivesAt": "09:52",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1639",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "06:31",
					"arrivesAt": "06:50",
					"waitsAtSource": 0,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Cluj Napoca",
					"leavesAt": "06:51",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 44900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1863",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "07:59",
					"arrivesAt": "08:05",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Bârnova Hm.",
					"leavesAt": "08:06",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Buhăieşti",
					"leavesAt": "08:28",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Buhăieşti",
					"to": "Vaslui",
					"leavesAt": "08:51",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Vaslui",
					"to": "Crasna",
					"leavesAt": "09:13",
					"arrivesAt": "09:27",
					"waitsAtSource": 240,
					"distance": 15500
				},
				{
					"from": "Crasna",
					"to": "Bârlad",
					"leavesAt": "09:28",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Bârlad",
					"to": "Tutova",
					"leavesAt": "10:02",
					"arrivesAt": "10:15",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Tutova",
					"to": "Tecuci",
					"leavesAt": "10:20",
					"arrivesAt": "10:54",
					"waitsAtSource": 300,
					"distance": 35300
				},
				{
					"from": "Tecuci",
					"to": "Lieşti",
					"leavesAt": "10:55",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 24400
				},
				{
					"from": "Lieşti",
					"to": "Barboşi",
					"leavesAt": "11:21",
					"arrivesAt": "12:12",
					"waitsAtSource": 60,
					"distance": 48300
				},
				{
					"from": "Barboşi",
					"to": "Galaţi",
					"leavesAt": "12:13",
					"arrivesAt": "12:32",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2416",
			"segments": [
				{
					"from": "Vinţu de Jos",
					"to": "Sebeş Glod h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:05",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Sebeş Glod h.",
					"to": "Sebeş Alba",
					"leavesAt": "16:06",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sebeş Alba",
					"to": "Rahău h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Rahău h.",
					"to": "Cut h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cut h.",
					"to": "Cunţa Hm.",
					"leavesAt": "16:25",
					"arrivesAt": "16:32",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Cunţa Hm.",
					"to": "Băile Miercurea h.",
					"leavesAt": "16:33",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Băile Miercurea h.",
					"to": "Miercurea Sibiu Hm.",
					"leavesAt": "16:37",
					"arrivesAt": "16:45",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Miercurea Sibiu Hm.",
					"to": "Apoldu de Jos h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:04",
					"waitsAtSource": 900,
					"distance": 3700
				},
				{
					"from": "Apoldu de Jos h.",
					"to": "Apoldu de Sus Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:14",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Apoldu de Sus Hm.",
					"to": "Tilişca h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Tilişca h.",
					"to": "Aciliu h.",
					"leavesAt": "17:28",
					"arrivesAt": "17:33",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Aciliu h.",
					"to": "Sălişte Hm.",
					"leavesAt": "17:34",
					"arrivesAt": "17:38",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Sălişte Hm.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sibiel h.",
					"leavesAt": "17:45",
					"arrivesAt": "17:48",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sibiel h.",
					"to": "Orlat",
					"leavesAt": "17:49",
					"arrivesAt": "17:55",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Orlat",
					"to": "Cristian Sibiu h.",
					"leavesAt": "17:56",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Turnişor Hm.",
					"leavesAt": "18:02",
					"arrivesAt": "18:16",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Sibiu h.(210)",
					"leavesAt": "18:17",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Sibiu",
					"leavesAt": "18:21",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8033",
			"segments": [
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "04:53",
					"arrivesAt": "05:00",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Cernavodă Pod",
					"leavesAt": "05:01",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "05:21",
					"arrivesAt": "05:29",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "05:30",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "05:39",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:56",
					"waitsAtSource": 180,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "05:57",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:14",
					"waitsAtSource": 540,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "06:15",
					"arrivesAt": "06:21",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "06:28",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "06:33",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "06:39",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9381",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Mihăeşti Hm.",
					"leavesAt": "04:12",
					"arrivesAt": "04:30",
					"waitsAtSource": 0,
					"distance": 17300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Radomireşti Hm.",
					"leavesAt": "04:31",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "04:43",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Stoeneşti h.",
					"leavesAt": "04:57",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Stoeneşti h.",
					"to": "Fărcaşele Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Caracal",
					"leavesAt": "05:11",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Caracal",
					"to": "Cezieni h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:35",
					"waitsAtSource": 480,
					"distance": 6100
				},
				{
					"from": "Cezieni h.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "05:36",
					"arrivesAt": "05:42",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Radomiru hc.",
					"leavesAt": "05:43",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Radomiru hc.",
					"to": "Jianca",
					"leavesAt": "05:48",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jianca",
					"to": "Ţărţăl h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:55",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţărţăl h.",
					"to": "Leu Hm.",
					"leavesAt": "05:56",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Leu Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "06:02",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Malu Mare Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Malu Mare Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "06:18",
					"arrivesAt": "06:22",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Bordei hc.(900)",
					"leavesAt": "06:23",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Craiova",
					"leavesAt": "06:28",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9432",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "07:03",
					"arrivesAt": "07:09",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "07:10",
					"arrivesAt": "07:15",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "07:16",
					"arrivesAt": "07:20",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "07:21",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "07:24",
					"arrivesAt": "07:27",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Podu Rizii h.",
					"leavesAt": "07:28",
					"arrivesAt": "07:32",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Podu Rizii h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "07:33",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "07:38",
					"arrivesAt": "07:43",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:49",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:52",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "07:53",
					"arrivesAt": "07:59",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "08:05",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "08:12",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "08:20",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "08:27",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "08:31",
					"arrivesAt": "08:34",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "08:35",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:41",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "08:42",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5474",
			"segments": [
				{
					"from": "Bicaz",
					"to": "Tarcău Neamţ Hm.",
					"leavesAt": "19:19",
					"arrivesAt": "19:26",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Tarcău Neamţ Hm.",
					"to": "Stejaru h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stejaru h.",
					"to": "Pângăraţi Hm.",
					"leavesAt": "19:34",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Pângăraţi Hm.",
					"to": "Vaduri h.",
					"leavesAt": "19:39",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Vaduri h.",
					"to": "Piatra Neamţ",
					"leavesAt": "19:45",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Piatra Neamţ",
					"to": "Dumbrava h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:05",
					"waitsAtSource": 120,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Săvineşti h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Săvineşti h.",
					"to": "Roznov",
					"leavesAt": "20:13",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Roznov",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "20:20",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Podoleni Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Podoleni Hm.",
					"to": "Costişa h.",
					"leavesAt": "20:33",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Costişa h.",
					"to": "Buhuşi",
					"leavesAt": "20:41",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhuşi",
					"to": "Racova h.",
					"leavesAt": "20:51",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Racova h.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "20:56",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Gârleni Hm.",
					"leavesAt": "21:02",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gârleni Hm.",
					"to": "Hămeiuş P.M.",
					"leavesAt": "21:07",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Bacău",
					"leavesAt": "21:14",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 7900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9139",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(913)",
					"leavesAt": "19:40",
					"arrivesAt": "19:43",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(913)",
					"to": "Jiu Hm.",
					"leavesAt": "19:44",
					"arrivesAt": "19:49",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Jiu Hm.",
					"to": "Podari",
					"leavesAt": "19:50",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Podari",
					"to": "Sălcuţa Hm.",
					"leavesAt": "20:01",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Sălcuţa Hm.",
					"to": "Dealul Robului h.",
					"leavesAt": "20:16",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dealul Robului h.",
					"to": "Segarcea Nord hc.",
					"leavesAt": "20:22",
					"arrivesAt": "20:29",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Segarcea Nord hc.",
					"to": "Segarcea",
					"leavesAt": "20:30",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Segarcea",
					"to": "Cerăt h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cerăt h.",
					"to": "Portăreşti Hm.",
					"leavesAt": "20:41",
					"arrivesAt": "20:49",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Portăreşti Hm.",
					"to": "Urzica Mare h.",
					"leavesAt": "20:50",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Urzica Mare h.",
					"to": "Afumaţi h.",
					"leavesAt": "20:56",
					"arrivesAt": "21:08",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Afumaţi h.",
					"to": "Siliştea Crucii h.",
					"leavesAt": "21:09",
					"arrivesAt": "21:17",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Siliştea Crucii h.",
					"to": "Boureni P.M.",
					"leavesAt": "21:18",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Boureni P.M.",
					"to": "Băileşti",
					"leavesAt": "21:23",
					"arrivesAt": "21:36",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Băileşti",
					"to": "Moţăţei Hm.",
					"leavesAt": "21:37",
					"arrivesAt": "21:59",
					"waitsAtSource": 60,
					"distance": 12800
				},
				{
					"from": "Moţăţei Hm.",
					"to": "Maglavit h.",
					"leavesAt": "22:00",
					"arrivesAt": "22:14",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Maglavit h.",
					"to": "Golenţi Hm.",
					"leavesAt": "22:15",
					"arrivesAt": "22:30",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Golenţi Hm.",
					"to": "Calafat",
					"leavesAt": "22:31",
					"arrivesAt": "22:49",
					"waitsAtSource": 60,
					"distance": 11800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1921",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "19:00",
					"arrivesAt": "19:07",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "19:08",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "19:15",
					"arrivesAt": "19:28",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "19:30",
					"arrivesAt": "19:34",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "19:42",
					"arrivesAt": "19:50",
					"waitsAtSource": 480,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "19:51",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "20:02",
					"arrivesAt": "20:09",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "20:11",
					"arrivesAt": "20:34",
					"waitsAtSource": 120,
					"distance": 14000
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "20:50",
					"arrivesAt": "21:14",
					"waitsAtSource": 960,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "21:15",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "21:33",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "21:55",
					"arrivesAt": "22:18",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Lehliu",
					"leavesAt": "22:19",
					"arrivesAt": "22:40",
					"waitsAtSource": 60,
					"distance": 39300
				},
				{
					"from": "Lehliu",
					"to": "Bucureşti Nord",
					"leavesAt": "22:41",
					"arrivesAt": "23:21",
					"waitsAtSource": 60,
					"distance": 69600
				},
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "23:45",
					"arrivesAt": "00:37",
					"waitsAtSource": 1440,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "00:38",
					"arrivesAt": "01:23",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "01:25",
					"arrivesAt": "01:56",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "01:57",
					"arrivesAt": "02:14",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "02:15",
					"arrivesAt": "02:55",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "03:05",
					"arrivesAt": "03:32",
					"waitsAtSource": 600,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Cărbuneşti",
					"leavesAt": "03:33",
					"arrivesAt": "04:19",
					"waitsAtSource": 60,
					"distance": 46500
				},
				{
					"from": "Cărbuneşti",
					"to": "Târgu Jiu",
					"leavesAt": "04:20",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 23800
				},
				{
					"from": "Târgu Jiu",
					"to": "Valea Sadului Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "05:09",
					"waitsAtSource": 120,
					"distance": 19600
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Petroşani",
					"leavesAt": "05:10",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 31700
				},
				{
					"from": "Petroşani",
					"to": "Băniţa",
					"leavesAt": "06:02",
					"arrivesAt": "06:17",
					"waitsAtSource": 300,
					"distance": 11300
				},
				{
					"from": "Băniţa",
					"to": "Subcetate",
					"leavesAt": "06:18",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 38500
				},
				{
					"from": "Subcetate",
					"to": "Călan Hm.",
					"leavesAt": "07:15",
					"arrivesAt": "07:34",
					"waitsAtSource": 120,
					"distance": 15600
				},
				{
					"from": "Călan Hm.",
					"to": "Simeria",
					"leavesAt": "07:36",
					"arrivesAt": "07:51",
					"waitsAtSource": 120,
					"distance": 14600
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "07:57",
					"arrivesAt": "08:08",
					"waitsAtSource": 360,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Ilia",
					"leavesAt": "08:10",
					"arrivesAt": "08:38",
					"waitsAtSource": 120,
					"distance": 23600
				},
				{
					"from": "Ilia",
					"to": "Săvârşin",
					"leavesAt": "08:39",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Săvârşin",
					"to": "Radna",
					"leavesAt": "09:28",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 49700
				},
				{
					"from": "Radna",
					"to": "Arad",
					"leavesAt": "10:28",
					"arrivesAt": "11:05",
					"waitsAtSource": 60,
					"distance": 34500
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180529",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1790",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "14:00",
					"arrivesAt": "14:11",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "14:12",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "14:36",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "14:56",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2437",
			"segments": [
				{
					"from": "Râmnicu Vâlcea",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "14:20",
					"arrivesAt": "14:22",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "14:23",
					"arrivesAt": "14:28",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Dăeşti Hm.",
					"leavesAt": "14:29",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Călimăneşti",
					"leavesAt": "14:36",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "14:44",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Cozia Hm.",
					"leavesAt": "14:55",
					"arrivesAt": "15:02",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Cozia Hm.",
					"to": "Lotru",
					"leavesAt": "15:03",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3612",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "11:45",
					"arrivesAt": "11:55",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "11:56",
					"arrivesAt": "12:00",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "12:01",
					"arrivesAt": "12:06",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Cojocna Hm.",
					"leavesAt": "12:07",
					"arrivesAt": "12:12",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cojocna Hm.",
					"to": "Tunel Hm.",
					"leavesAt": "12:13",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tunel Hm.",
					"to": "Boju",
					"leavesAt": "12:22",
					"arrivesAt": "12:30",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Boju",
					"to": "Valea Florilor Hm.",
					"leavesAt": "12:31",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Ploscoş h.",
					"leavesAt": "12:44",
					"arrivesAt": "12:48",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ploscoş h.",
					"to": "Cânepişti h.",
					"leavesAt": "12:49",
					"arrivesAt": "12:55",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cânepişti h.",
					"to": "Câmpia Turzii",
					"leavesAt": "12:56",
					"arrivesAt": "13:04",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Câmpia Turzii",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "13:05",
					"arrivesAt": "13:13",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Grindeni h.",
					"leavesAt": "13:14",
					"arrivesAt": "13:20",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Grindeni h.",
					"to": "Războieni",
					"leavesAt": "13:21",
					"arrivesAt": "13:25",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "13:26",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Unirea Hm.",
					"leavesAt": "13:31",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea Hm.",
					"to": "Decea h.",
					"leavesAt": "13:36",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Decea h.",
					"to": "Mirăslău h.",
					"leavesAt": "13:40",
					"arrivesAt": "13:44",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Mirăslău h.",
					"to": "Aiud Hm.",
					"leavesAt": "13:45",
					"arrivesAt": "13:52",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "13:53",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 13100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5432",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "04:45",
					"arrivesAt": "04:52",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "04:53",
					"arrivesAt": "04:58",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "04:59",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "05:04",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "05:10",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "05:22",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "05:33",
					"arrivesAt": "05:40",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "05:41",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "05:46",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "06:01",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "06:07",
					"arrivesAt": "06:19",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2095",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "20:15",
					"arrivesAt": "20:19",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "20:20",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "20:24",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "20:29",
					"arrivesAt": "20:32",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "20:33",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "20:37",
					"arrivesAt": "20:41",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "20:47",
					"arrivesAt": "20:52",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "20:57",
					"arrivesAt": "21:02",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "21:04",
					"arrivesAt": "21:11",
					"waitsAtSource": 120,
					"distance": 5700
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "21:12",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Floreşti hc.",
					"to": "Gilort Hm.",
					"leavesAt": "21:16",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Gilort Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "21:23",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turburea Hm.",
					"to": "Bibeşti Hm.",
					"leavesAt": "21:30",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "21:40",
					"arrivesAt": "21:45",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Musculeşti",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "21:46",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Jupâneşti Hm.",
					"leavesAt": "21:52",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "21:58",
					"arrivesAt": "22:06",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cărbuneşti",
					"to": "Pojogeni Hm.",
					"leavesAt": "22:07",
					"arrivesAt": "22:14",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "22:15",
					"arrivesAt": "22:21",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Budieni h.",
					"leavesAt": "22:22",
					"arrivesAt": "22:26",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Budieni h.",
					"to": "Târgu Jiu",
					"leavesAt": "22:27",
					"arrivesAt": "22:39",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5005",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "13:17",
					"arrivesAt": "13:26",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "13:27",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "13:34",
					"arrivesAt": "13:38",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "13:39",
					"arrivesAt": "13:46",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "13:47",
					"arrivesAt": "13:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "13:52",
					"arrivesAt": "13:56",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "13:57",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "14:02",
					"arrivesAt": "14:10",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "14:11",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "14:27",
					"arrivesAt": "14:33",
					"waitsAtSource": 120,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "14:34",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Muru hc.",
					"leavesAt": "14:44",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "14:48",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "15:00",
					"arrivesAt": "15:05",
					"waitsAtSource": 480,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "15:06",
					"arrivesAt": "15:11",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "15:12",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "15:21",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "15:32",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "15:40",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "15:46",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "15:52",
					"arrivesAt": "16:04",
					"waitsAtSource": 30,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5712",
			"segments": [
				{
					"from": "Ilva Mică",
					"to": "Strâmba h.",
					"leavesAt": "18:55",
					"arrivesAt": "19:00",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Strâmba h.",
					"to": "Leşu Ilvei Hm.",
					"leavesAt": "19:01",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Leşu Ilvei Hm.",
					"to": "Poiana Ilvei",
					"leavesAt": "19:07",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Poiana Ilvei",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "19:16",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Ilva Mare Hm.",
					"leavesAt": "19:24",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ilva Mare Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "19:34",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Lunca Ilvei",
					"to": "Silhoasa Hm.",
					"leavesAt": "19:44",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Silhoasa Hm.",
					"to": "Larion Hm.",
					"leavesAt": "19:53",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Larion Hm.",
					"to": "Grădiniţa",
					"leavesAt": "20:04",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Grădiniţa",
					"to": "Coşna Hm.",
					"leavesAt": "20:14",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Coşna Hm.",
					"to": "Floreni",
					"leavesAt": "20:29",
					"arrivesAt": "20:37",
					"waitsAtSource": 360,
					"distance": 5700
				},
				{
					"from": "Floreni",
					"to": "Dorna Candrenilor h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:43",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dorna Candrenilor h.",
					"to": "Roşu Hm.",
					"leavesAt": "20:44",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Roşu Hm.",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "20:51",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Vatra Dornei",
					"leavesAt": "20:59",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1924",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun hc.",
					"leavesAt": "18:10",
					"arrivesAt": "18:20",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "18:23",
					"arrivesAt": "18:36",
					"waitsAtSource": 180,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "18:39",
					"arrivesAt": "18:43",
					"waitsAtSource": 180,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "18:46",
					"arrivesAt": "19:01",
					"waitsAtSource": 180,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "19:04",
					"arrivesAt": "19:11",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "19:13",
					"arrivesAt": "19:22",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Agigea Nord",
					"leavesAt": "19:23",
					"arrivesAt": "19:30",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Nord",
					"to": "Constanţa",
					"leavesAt": "19:31",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "20:00",
					"arrivesAt": "20:26",
					"waitsAtSource": 1080,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "20:27",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "20:47",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "21:10",
					"arrivesAt": "21:36",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "21:37",
					"arrivesAt": "22:45",
					"waitsAtSource": 60,
					"distance": 108900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "23:04",
					"arrivesAt": "00:02",
					"waitsAtSource": 1140,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "00:03",
					"arrivesAt": "00:23",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "00:24",
					"arrivesAt": "00:48",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "00:49",
					"arrivesAt": "01:00",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Piteşti",
					"to": "Costeşti",
					"leavesAt": "01:25",
					"arrivesAt": "01:48",
					"waitsAtSource": 1500,
					"distance": 21800
				},
				{
					"from": "Costeşti",
					"to": "Stolnici Hm.",
					"leavesAt": "01:50",
					"arrivesAt": "02:05",
					"waitsAtSource": 120,
					"distance": 15900
				},
				{
					"from": "Stolnici Hm.",
					"to": "Slatina",
					"leavesAt": "02:07",
					"arrivesAt": "02:48",
					"waitsAtSource": 120,
					"distance": 43300
				},
				{
					"from": "Slatina",
					"to": "Piatra Olt",
					"leavesAt": "02:50",
					"arrivesAt": "03:08",
					"waitsAtSource": 120,
					"distance": 17000
				},
				{
					"from": "Piatra Olt",
					"to": "Drăgăşani",
					"leavesAt": "03:30",
					"arrivesAt": "03:58",
					"waitsAtSource": 1320,
					"distance": 33800
				},
				{
					"from": "Drăgăşani",
					"to": "Băbeni",
					"leavesAt": "04:00",
					"arrivesAt": "04:26",
					"waitsAtSource": 120,
					"distance": 33200
				},
				{
					"from": "Băbeni",
					"to": "Govora",
					"leavesAt": "04:27",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Govora",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "04:36",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 11400
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Călimăneşti",
					"leavesAt": "04:50",
					"arrivesAt": "05:08",
					"waitsAtSource": 180,
					"distance": 16200
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:15",
					"waitsAtSource": 120,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Lotru",
					"leavesAt": "05:17",
					"arrivesAt": "05:36",
					"waitsAtSource": 120,
					"distance": 11500
				},
				{
					"from": "Lotru",
					"to": "Câineni",
					"leavesAt": "05:37",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 21100
				},
				{
					"from": "Câineni",
					"to": "Turnu Roşu hc.",
					"leavesAt": "06:03",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Podu Olt",
					"leavesAt": "06:36",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "06:43",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Sibiu",
					"leavesAt": "06:51",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 17800
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4103",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Viişoara h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:43",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Viişoara h.",
					"to": "Sărata h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:47",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "07:48",
					"arrivesAt": "07:53",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "07:54",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "07:59",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Sfântu h.",
					"leavesAt": "08:05",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Sfântu h.",
					"to": "Caila hc.",
					"leavesAt": "08:11",
					"arrivesAt": "08:14",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Caila hc.",
					"to": "Şintereag Hm.",
					"leavesAt": "08:15",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Şintereag Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "08:27",
					"arrivesAt": "08:36",
					"waitsAtSource": 420,
					"distance": 7400
				},
				{
					"from": "Beclean pe Someş",
					"to": "Coldău Hm.",
					"leavesAt": "08:37",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Coldău Hm.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "08:48",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "08:56",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Dej Triaj",
					"leavesAt": "09:01",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "09:12",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "09:29",
					"arrivesAt": "09:37",
					"waitsAtSource": 600,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Gherla",
					"leavesAt": "09:38",
					"arrivesAt": "09:49",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "09:51",
					"arrivesAt": "09:57",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "09:58",
					"arrivesAt": "10:03",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "10:04",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "10:08",
					"arrivesAt": "10:13",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "10:14",
					"arrivesAt": "10:17",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "10:18",
					"arrivesAt": "10:23",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida h.",
					"leavesAt": "10:24",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Apahida h.",
					"to": "Apahida",
					"leavesAt": "10:31",
					"arrivesAt": "10:36",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "10:37",
					"arrivesAt": "10:40",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "10:41",
					"arrivesAt": "10:48",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "10:49",
					"arrivesAt": "10:54",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "10:55",
					"arrivesAt": "11:00",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5464",
			"segments": [
				{
					"from": "Piatra Neamţ",
					"to": "Dumbrava h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:31",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Săvineşti h.",
					"leavesAt": "16:32",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Săvineşti h.",
					"to": "Roznov",
					"leavesAt": "16:39",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Roznov",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Podoleni Hm.",
					"leavesAt": "16:51",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Podoleni Hm.",
					"to": "Costişa h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Costişa h.",
					"to": "Buhuşi",
					"leavesAt": "17:07",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhuşi",
					"to": "Racova h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Racova h.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Gârleni Hm.",
					"leavesAt": "17:28",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gârleni Hm.",
					"to": "Hămeiuş P.M.",
					"leavesAt": "17:33",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Bacău",
					"leavesAt": "17:40",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 7900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7040",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Armăşeşti Hm.",
					"leavesAt": "21:24",
					"arrivesAt": "21:32",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "21:33",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Moldoveni h.",
					"to": "Dridu Hm.",
					"leavesAt": "21:39",
					"arrivesAt": "21:45",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Dridu Hm.",
					"to": "Fierbinţi",
					"leavesAt": "21:46",
					"arrivesAt": "21:52",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Fierbinţi",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "21:53",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 12500
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "22:05",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Baloteşti Hm.",
					"leavesAt": "22:11",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Baloteşti Hm.",
					"to": "P.O. Aeroport h.",
					"leavesAt": "22:17",
					"arrivesAt": "22:20",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Mogoşoaia",
					"leavesAt": "22:21",
					"arrivesAt": "22:31",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Mogoşoaia",
					"to": "Pajura Hm. (700)",
					"leavesAt": "22:32",
					"arrivesAt": "22:53",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Carpaţi h.(700)",
					"leavesAt": "22:54",
					"arrivesAt": "22:57",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Bucureşti Nord",
					"leavesAt": "22:58",
					"arrivesAt": "23:06",
					"waitsAtSource": 30,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8212",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "03:30",
					"arrivesAt": "03:36",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Murfatlar h.",
					"leavesAt": "03:37",
					"arrivesAt": "03:45",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "03:46",
					"arrivesAt": "03:50",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "03:51",
					"arrivesAt": "03:56",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Castelu h.",
					"leavesAt": "03:57",
					"arrivesAt": "04:03",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "04:04",
					"arrivesAt": "04:12",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "04:27",
					"arrivesAt": "04:46",
					"waitsAtSource": 900,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "04:47",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Movila Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:33",
					"waitsAtSource": 480,
					"distance": 16700
				},
				{
					"from": "Movila Hm.",
					"to": "Platoneşti h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Platoneşti h.",
					"to": "Ţăndărei",
					"leavesAt": "05:42",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ţăndărei",
					"to": "Murgeanca Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Murgeanca Hm.",
					"to": "Spicu",
					"leavesAt": "06:02",
					"arrivesAt": "06:11",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spicu",
					"to": "Dudeşti Hm.",
					"leavesAt": "06:12",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Dudeşti Hm.",
					"to": "Scărlăteşti hc.",
					"leavesAt": "06:23",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Scărlăteşti hc.",
					"to": "Cireşu Hm.",
					"leavesAt": "06:30",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Cireşu Hm.",
					"to": "Făurei",
					"leavesAt": "06:38",
					"arrivesAt": "06:55",
					"waitsAtSource": 60,
					"distance": 15700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7585",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Cosmeşti Hm.",
					"leavesAt": "09:03",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "Tecuci",
					"leavesAt": "09:09",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 7400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2046",
			"segments": [
				{
					"from": "Arad",
					"to": "Glogovăţ",
					"leavesAt": "16:20",
					"arrivesAt": "16:28",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Glogovăţ",
					"to": "Ghioroc",
					"leavesAt": "16:29",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Ghioroc",
					"to": "Păuliş h.",
					"leavesAt": "16:44",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Păuliş h.",
					"to": "Păuliş Hm.",
					"leavesAt": "16:50",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş Hm.",
					"to": "Radna",
					"leavesAt": "16:56",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Radna",
					"to": "Milova",
					"leavesAt": "17:09",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Milova",
					"to": "Corfeni h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Corfeni h.",
					"to": "Conop Hm.",
					"leavesAt": "17:26",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Conop Hm.",
					"to": "Nadăş h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Nadăş h.",
					"to": "Bârzava",
					"leavesAt": "17:39",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârzava",
					"to": "Căpruţa h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Căpruţa h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "17:52",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:03",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Vărădia Hm.",
					"leavesAt": "18:04",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vărădia Hm.",
					"to": "Vărădia h.",
					"leavesAt": "18:12",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vărădia h.",
					"to": "Săvârşin",
					"leavesAt": "18:16",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Săvârşin",
					"to": "Toc h.",
					"leavesAt": "18:26",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Toc h.",
					"to": "Ilteu",
					"leavesAt": "18:34",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ilteu",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "18:40",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Zam",
					"leavesAt": "18:46",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zam",
					"to": "Burjuc h.",
					"leavesAt": "18:53",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Burjuc h.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "19:05",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Gurasada Hm.",
					"leavesAt": "19:14",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Gurasada Hm.",
					"to": "Ilia",
					"leavesAt": "19:22",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:36",
					"waitsAtSource": 120,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "19:37",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:48",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Mintia",
					"leavesAt": "19:53",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "19:58",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:16",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "20:17",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1591",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "06:32",
					"arrivesAt": "07:24",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "07:25",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Caracal",
					"leavesAt": "08:10",
					"arrivesAt": "08:57",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "08:58",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "09:45",
					"arrivesAt": "10:12",
					"waitsAtSource": 300,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Strehaia hc.",
					"leavesAt": "10:13",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Strehaia hc.",
					"to": "Balota",
					"leavesAt": "10:38",
					"arrivesAt": "11:13",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Balota",
					"to": "Ergheviţa h.",
					"leavesAt": "11:14",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Ergheviţa h.",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "11:30",
					"arrivesAt": "11:49",
					"waitsAtSource": 30,
					"distance": 11600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2441",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Sud",
					"leavesAt": "03:14",
					"arrivesAt": "03:20",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "03:21",
					"arrivesAt": "03:25",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Sânpaul Hm.",
					"leavesAt": "03:26",
					"arrivesAt": "03:39",
					"waitsAtSource": 30,
					"distance": 11200
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Iernut",
					"leavesAt": "03:40",
					"arrivesAt": "03:49",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Iernut",
					"to": "Cuci h.",
					"leavesAt": "03:50",
					"arrivesAt": "03:55",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cuci h.",
					"to": "Bogata Mureş h.",
					"leavesAt": "03:56",
					"arrivesAt": "04:02",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Luduş",
					"leavesAt": "04:03",
					"arrivesAt": "04:07",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Luduş",
					"to": "Cheţani h.",
					"leavesAt": "04:08",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Cheţani h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "04:15",
					"arrivesAt": "04:19",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Gura Arieşului h.",
					"leavesAt": "04:20",
					"arrivesAt": "04:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Lunca Mureşului h.",
					"leavesAt": "04:25",
					"arrivesAt": "04:29",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Războieni",
					"leavesAt": "04:30",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "04:36",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Unirea Hm.",
					"leavesAt": "04:41",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea Hm.",
					"to": "Decea h.",
					"leavesAt": "04:48",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Decea h.",
					"to": "Mirăslău h.",
					"leavesAt": "04:52",
					"arrivesAt": "04:56",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Mirăslău h.",
					"to": "Aiud Hm.",
					"leavesAt": "04:57",
					"arrivesAt": "05:04",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "05:05",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Coşlariu",
					"leavesAt": "05:23",
					"arrivesAt": "05:31",
					"waitsAtSource": 240,
					"distance": 3500
				},
				{
					"from": "Coşlariu",
					"to": "Sântimbru h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sântimbru h.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "05:44",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "05:57",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "06:40",
					"arrivesAt": "06:52",
					"waitsAtSource": 2040,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Sebeş Glod h.",
					"leavesAt": "07:14",
					"arrivesAt": "07:21",
					"waitsAtSource": 1320,
					"distance": 6500
				},
				{
					"from": "Sebeş Glod h.",
					"to": "Sebeş Alba",
					"leavesAt": "07:22",
					"arrivesAt": "07:26",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sebeş Alba",
					"to": "Rahău h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Rahău h.",
					"to": "Cut h.",
					"leavesAt": "07:36",
					"arrivesAt": "07:40",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cut h.",
					"to": "Cunţa Hm.",
					"leavesAt": "07:41",
					"arrivesAt": "07:48",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Cunţa Hm.",
					"to": "Băile Miercurea h.",
					"leavesAt": "07:49",
					"arrivesAt": "07:52",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Băile Miercurea h.",
					"to": "Miercurea Sibiu Hm.",
					"leavesAt": "07:53",
					"arrivesAt": "08:01",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Miercurea Sibiu Hm.",
					"to": "Apoldu de Jos h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Apoldu de Jos h.",
					"to": "Apoldu de Sus Hm.",
					"leavesAt": "08:07",
					"arrivesAt": "08:16",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Apoldu de Sus Hm.",
					"to": "Tilişca h.",
					"leavesAt": "08:21",
					"arrivesAt": "08:33",
					"waitsAtSource": 300,
					"distance": 7800
				},
				{
					"from": "Tilişca h.",
					"to": "Aciliu h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:39",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Aciliu h.",
					"to": "Sălişte Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Sălişte Hm.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sibiel h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sibiel h.",
					"to": "Orlat",
					"leavesAt": "08:55",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Orlat",
					"to": "Cristian Sibiu h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Turnişor Hm.",
					"leavesAt": "09:08",
					"arrivesAt": "09:22",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Sibiu h.(210)",
					"leavesAt": "09:23",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Sibiu",
					"leavesAt": "09:27",
					"arrivesAt": "09:32",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4050",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "22:46",
					"arrivesAt": "23:03",
					"waitsAtSource": 0,
					"distance": 14600
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Fersig h.",
					"leavesAt": "23:04",
					"arrivesAt": "23:09",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Fersig h.",
					"to": "Mireşu Mare PM.",
					"leavesAt": "23:10",
					"arrivesAt": "23:16",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "23:17",
					"arrivesAt": "23:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Ţicău h.",
					"leavesAt": "23:24",
					"arrivesAt": "23:26",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ţicău h.",
					"to": "Benesat Hm.",
					"leavesAt": "23:27",
					"arrivesAt": "23:35",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Benesat Hm.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "23:36",
					"arrivesAt": "23:39",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Inău h.",
					"leavesAt": "23:40",
					"arrivesAt": "23:43",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Inău h.",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "23:44",
					"arrivesAt": "23:48",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Jibou",
					"leavesAt": "23:49",
					"arrivesAt": "23:59",
					"waitsAtSource": 60,
					"distance": 9300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7381",
			"segments": [
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "05:45",
					"arrivesAt": "05:50",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "05:51",
					"arrivesAt": "05:55",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Zagna Vădeni h.",
					"leavesAt": "05:56",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Barboşi",
					"leavesAt": "06:00",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "06:14",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7572",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "15:40",
					"arrivesAt": "15:54",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "15:55",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Barboşi Triaj h.",
					"leavesAt": "16:02",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Barboşi Triaj h.",
					"to": "Şendreni Hm.",
					"leavesAt": "16:08",
					"arrivesAt": "16:12",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Şendreni Hm.",
					"to": "Şerbeştii Vechi h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Şerbeştii Vechi h.",
					"to": "Braniştea h.",
					"leavesAt": "16:18",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Braniştea h.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "16:23",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Independenţa Hm.",
					"leavesAt": "16:27",
					"arrivesAt": "16:32",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Independenţa Hm.",
					"to": "Piscu h.",
					"leavesAt": "16:33",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Piscu h.",
					"to": "Vameş h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:44",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Vameş h.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "16:45",
					"arrivesAt": "16:51",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "16:52",
					"arrivesAt": "16:57",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Şerbăneşti h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Lieşti",
					"leavesAt": "17:04",
					"arrivesAt": "17:07",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lieşti",
					"to": "Buceşti h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Buceşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Iveşti Hm.",
					"to": "Umbrăreşti h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Barcea",
					"leavesAt": "17:24",
					"arrivesAt": "17:30",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Barcea",
					"to": "Malul Alb h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Malul Alb h.",
					"to": "Tecuci",
					"leavesAt": "17:35",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Tecuci",
					"to": "Cosmeşti Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "17:54",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "18:00",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1724",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(901)",
					"leavesAt": "08:00",
					"arrivesAt": "08:03",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Cârcea h.",
					"leavesAt": "08:04",
					"arrivesAt": "08:11",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Cârcea h.",
					"to": "Pieleşti Hm.",
					"leavesAt": "08:12",
					"arrivesAt": "08:18",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Pieleşti Hm.",
					"to": "Toporaş h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Toporaş h.",
					"to": "Robăneşti Hm.",
					"leavesAt": "08:23",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Robăneşti Hm.",
					"to": "Spineni h.",
					"leavesAt": "08:30",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Spineni h.",
					"to": "Balş",
					"leavesAt": "08:36",
					"arrivesAt": "08:42",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Balş",
					"to": "Brăneţ h.",
					"leavesAt": "08:43",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Brăneţ h.",
					"to": "Piatra Olt",
					"leavesAt": "08:49",
					"arrivesAt": "08:59",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Piatra Olt",
					"to": "Drăgăşani",
					"leavesAt": "09:04",
					"arrivesAt": "09:30",
					"waitsAtSource": 300,
					"distance": 33800
				},
				{
					"from": "Drăgăşani",
					"to": "Băbeni",
					"leavesAt": "09:31",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 33200
				},
				{
					"from": "Băbeni",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "09:56",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 19600
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Călimăneşti",
					"leavesAt": "10:15",
					"arrivesAt": "10:30",
					"waitsAtSource": 120,
					"distance": 16200
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "10:31",
					"arrivesAt": "10:36",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Câineni",
					"leavesAt": "10:37",
					"arrivesAt": "11:18",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Câineni",
					"to": "Turnu Roşu hc.",
					"leavesAt": "11:19",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Podu Olt",
					"leavesAt": "11:53",
					"arrivesAt": "11:58",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "11:59",
					"arrivesAt": "12:06",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Sibiu",
					"leavesAt": "12:08",
					"arrivesAt": "12:27",
					"waitsAtSource": 120,
					"distance": 17800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6314",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "12:50",
					"arrivesAt": "12:57",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Ciurea Hm.",
					"leavesAt": "12:58",
					"arrivesAt": "13:05",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ciurea Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "13:06",
					"arrivesAt": "13:15",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Bârnova Hm.",
					"leavesAt": "13:16",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Grajduri",
					"leavesAt": "13:26",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Grajduri",
					"to": "Scânteia Hm.",
					"leavesAt": "13:34",
					"arrivesAt": "13:41",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Scânteia Hm.",
					"to": "Rebricea Hm.",
					"leavesAt": "13:42",
					"arrivesAt": "13:48",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Rebricea Hm.",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "13:49",
					"arrivesAt": "13:54",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Buhăieşti",
					"leavesAt": "13:55",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Buhăieşti",
					"to": "Bârzeşti h.",
					"leavesAt": "14:01",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bârzeşti h.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "14:08",
					"arrivesAt": "14:12",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bălteni Hm.",
					"leavesAt": "14:13",
					"arrivesAt": "14:18",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bălteni Hm.",
					"to": "Vaslui",
					"leavesAt": "14:24",
					"arrivesAt": "14:32",
					"waitsAtSource": 360,
					"distance": 9800
				},
				{
					"from": "Vaslui",
					"to": "Munteni Hm.",
					"leavesAt": "14:34",
					"arrivesAt": "14:39",
					"waitsAtSource": 120,
					"distance": 4600
				},
				{
					"from": "Munteni Hm.",
					"to": "Bulboaca h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bulboaca h.",
					"to": "Crasna",
					"leavesAt": "14:46",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Crasna",
					"to": "Roşieşti hc.",
					"leavesAt": "14:54",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Roşieşti hc.",
					"to": "Dodeşti hc.",
					"leavesAt": "15:03",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Dodeşti hc.",
					"to": "Banca Hm.",
					"leavesAt": "15:10",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Banca Hm.",
					"to": "Zorleni",
					"leavesAt": "15:17",
					"arrivesAt": "15:27",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Zorleni",
					"to": "Bârlad",
					"leavesAt": "15:28",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bârlad",
					"to": "Dragalina h.",
					"leavesAt": "15:48",
					"arrivesAt": "15:56",
					"waitsAtSource": 660,
					"distance": 8200
				},
				{
					"from": "Dragalina h.",
					"to": "Tutova",
					"leavesAt": "15:57",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Tutova",
					"to": "Ghidigeni Hm.",
					"leavesAt": "16:05",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ghidigeni Hm.",
					"to": "Nichişeni",
					"leavesAt": "16:17",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nichişeni",
					"to": "Berheci Hm.",
					"leavesAt": "16:33",
					"arrivesAt": "16:42",
					"waitsAtSource": 660,
					"distance": 8400
				},
				{
					"from": "Berheci Hm.",
					"to": "Rateş Munteni h.",
					"leavesAt": "16:43",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Rateş Munteni h.",
					"to": "Frunzeasca Hm.",
					"leavesAt": "16:50",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Frunzeasca Hm.",
					"to": "Tecuci Nord hc.(600)",
					"leavesAt": "16:56",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tecuci Nord hc.(600)",
					"to": "Tecuci",
					"leavesAt": "17:05",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8809",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "21:15",
					"arrivesAt": "21:29",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "21:30",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "21:45",
					"arrivesAt": "21:50",
					"waitsAtSource": 480,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "21:58",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "22:13",
					"arrivesAt": "22:16",
					"waitsAtSource": 540,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "22:17",
					"arrivesAt": "22:26",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "22:27",
					"arrivesAt": "22:36",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180909",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5463",
			"segments": [
				{
					"from": "Bacău",
					"to": "Hămeiuş P.M.",
					"leavesAt": "07:18",
					"arrivesAt": "07:27",
					"waitsAtSource": 0,
					"distance": 7900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Gârleni Hm.",
					"leavesAt": "07:28",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Gârleni Hm.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Racova h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Racova h.",
					"to": "Buhuşi",
					"leavesAt": "07:49",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Buhuşi",
					"to": "Costişa h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Costişa h.",
					"to": "Podoleni Hm.",
					"leavesAt": "08:05",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Podoleni Hm.",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "08:25",
					"arrivesAt": "08:32",
					"waitsAtSource": 720,
					"distance": 5800
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Roznov",
					"leavesAt": "08:33",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Roznov",
					"to": "Săvineşti h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Săvineşti h.",
					"to": "Dumbrava h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Piatra Neamţ",
					"leavesAt": "08:54",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1833",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Târgu Frumos",
					"leavesAt": "06:10",
					"arrivesAt": "06:46",
					"waitsAtSource": 0,
					"distance": 44900
				},
				{
					"from": "Târgu Frumos",
					"to": "Paşcani",
					"leavesAt": "06:47",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 30800
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "07:16",
					"arrivesAt": "07:36",
					"waitsAtSource": 120,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "07:37",
					"arrivesAt": "07:53",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "07:54",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 14800
				},
				{
					"from": "Suceava",
					"to": "Gura Humorului Oraş",
					"leavesAt": "08:23",
					"arrivesAt": "09:09",
					"waitsAtSource": 1020,
					"distance": 46800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "09:10",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Vama",
					"leavesAt": "09:19",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vama",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "09:30",
					"arrivesAt": "09:46",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "09:49",
					"arrivesAt": "09:55",
					"waitsAtSource": 180,
					"distance": 3800
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Pojorâta Hm.",
					"leavesAt": "09:56",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Mestecăniş",
					"leavesAt": "10:07",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Mestecăniş",
					"to": "Iacobeni",
					"leavesAt": "10:29",
					"arrivesAt": "10:38",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Iacobeni",
					"to": "Vatra Dornei",
					"leavesAt": "10:39",
					"arrivesAt": "10:55",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Vatra Dornei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "10:56",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Lunca Ilvei",
					"leavesAt": "11:00",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 42800
				},
				{
					"from": "Lunca Ilvei",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "11:56",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 14300
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Ilva Mică",
					"leavesAt": "12:15",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 17300
				},
				{
					"from": "Ilva Mică",
					"to": "Năsăud",
					"leavesAt": "12:38",
					"arrivesAt": "12:59",
					"waitsAtSource": 60,
					"distance": 19800
				},
				{
					"from": "Năsăud",
					"to": "Salva",
					"leavesAt": "13:01",
					"arrivesAt": "13:08",
					"waitsAtSource": 120,
					"distance": 6300
				},
				{
					"from": "Salva",
					"to": "Beclean pe Someş",
					"leavesAt": "13:09",
					"arrivesAt": "13:31",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Dej Călători",
					"leavesAt": "13:33",
					"arrivesAt": "14:08",
					"waitsAtSource": 120,
					"distance": 24600
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "14:13",
					"arrivesAt": "14:32",
					"waitsAtSource": 300,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Cluj Napoca",
					"leavesAt": "14:34",
					"arrivesAt": "15:26",
					"waitsAtSource": 120,
					"distance": 44900
				},
				{
					"from": "Cluj Napoca",
					"to": "Aghireş",
					"leavesAt": "15:48",
					"arrivesAt": "16:18",
					"waitsAtSource": 1320,
					"distance": 27900
				},
				{
					"from": "Aghireş",
					"to": "Huedin",
					"leavesAt": "16:19",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Huedin",
					"to": "Ciucea Hm.",
					"leavesAt": "16:48",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Ciucea Hm.",
					"to": "Bratca",
					"leavesAt": "17:11",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Bratca",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "17:33",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Aleşd",
					"leavesAt": "17:54",
					"arrivesAt": "18:07",
					"waitsAtSource": 240,
					"distance": 12200
				},
				{
					"from": "Aleşd",
					"to": "Oradea",
					"leavesAt": "18:08",
					"arrivesAt": "18:41",
					"waitsAtSource": 60,
					"distance": 34300
				},
				{
					"from": "Oradea",
					"to": "Salonta",
					"leavesAt": "18:50",
					"arrivesAt": "19:33",
					"waitsAtSource": 540,
					"distance": 39200
				},
				{
					"from": "Salonta",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "19:34",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Chişineu Criş",
					"leavesAt": "19:48",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 23700
				},
				{
					"from": "Chişineu Criş",
					"to": "Sântana",
					"leavesAt": "20:16",
					"arrivesAt": "20:36",
					"waitsAtSource": 120,
					"distance": 24000
				},
				{
					"from": "Sântana",
					"to": "Arad",
					"leavesAt": "20:38",
					"arrivesAt": "21:04",
					"waitsAtSource": 120,
					"distance": 23500
				},
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "21:22",
					"arrivesAt": "21:30",
					"waitsAtSource": 1080,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Timişoara Nord",
					"leavesAt": "21:31",
					"arrivesAt": "22:14",
					"waitsAtSource": 60,
					"distance": 51000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1693",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "15:45",
					"arrivesAt": "16:36",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "16:37",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Caracal",
					"leavesAt": "17:24",
					"arrivesAt": "18:11",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "18:12",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "19:00",
					"arrivesAt": "19:26",
					"waitsAtSource": 480,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Strehaia hc.",
					"leavesAt": "19:27",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Strehaia hc.",
					"to": "Balota",
					"leavesAt": "19:52",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Balota",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "20:29",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Orşova",
					"leavesAt": "21:04",
					"arrivesAt": "21:35",
					"waitsAtSource": 120,
					"distance": 24000
				},
				{
					"from": "Orşova",
					"to": "Băile Herculane",
					"leavesAt": "21:36",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 17500
				},
				{
					"from": "Băile Herculane",
					"to": "Caransebeş",
					"leavesAt": "21:57",
					"arrivesAt": "23:20",
					"waitsAtSource": 120,
					"distance": 70800
				},
				{
					"from": "Caransebeş",
					"to": "Lugoj",
					"leavesAt": "23:22",
					"arrivesAt": "23:56",
					"waitsAtSource": 120,
					"distance": 39400
				},
				{
					"from": "Lugoj",
					"to": "Timişoara Nord",
					"leavesAt": "23:57",
					"arrivesAt": "00:50",
					"waitsAtSource": 60,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4506",
			"segments": [
				{
					"from": "Deda",
					"to": "Deda Bistra Hm.",
					"leavesAt": "06:02",
					"arrivesAt": "06:08",
					"waitsAtSource": 0,
					"distance": 3900
				},
				{
					"from": "Deda Bistra Hm.",
					"to": "Borzia h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Borzia h.",
					"to": "Răstoliţa Hm.",
					"leavesAt": "06:14",
					"arrivesAt": "06:18",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Răstoliţa Hm.",
					"to": "Lunca Bradului Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 12700
				},
				{
					"from": "Lunca Bradului Hm.",
					"to": "Stânceni Neagra h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Stânceni Neagra h.",
					"to": "Stânceni h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:52",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Stânceni h.",
					"to": "Stânceni Hm.",
					"leavesAt": "06:53",
					"arrivesAt": "07:00",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Stânceni Hm.",
					"to": "Ciobotani h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ciobotani h.",
					"to": "Topliţa",
					"leavesAt": "07:07",
					"arrivesAt": "07:17",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Topliţa",
					"to": "Gălăuţaş Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:26",
					"waitsAtSource": 120,
					"distance": 6000
				},
				{
					"from": "Gălăuţaş Hm.",
					"to": "Sărmaş Runc h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Sărmaş Runc h.",
					"to": "Subcetate Mureş Hm.",
					"leavesAt": "07:34",
					"arrivesAt": "07:40",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Subcetate Mureş Hm.",
					"to": "Ditrău",
					"leavesAt": "07:41",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ditrău",
					"to": "Lăzarea Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Lăzarea Hm.",
					"to": "Gheorgheni",
					"leavesAt": "07:57",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Gheorgheni",
					"to": "Valea Strâmbă h.",
					"leavesAt": "08:05",
					"arrivesAt": "08:08",
					"waitsAtSource": 180,
					"distance": 3400
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Şugău h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Şugău h.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "08:13",
					"arrivesAt": "08:17",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "08:18",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Sândominic h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:47",
					"waitsAtSource": 540,
					"distance": 7800
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Oltului",
					"leavesAt": "08:48",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Tomeşti h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:10",
					"waitsAtSource": 720,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Cârţani h.",
					"leavesAt": "09:11",
					"arrivesAt": "09:14",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Cârţani h.",
					"to": "Dăneşti h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:18",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Dăneşti h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "09:19",
					"arrivesAt": "09:25",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Racu h.",
					"leavesAt": "09:26",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Racu h.",
					"to": "Siculeni",
					"leavesAt": "09:32",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "09:38",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1595",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "13:45",
					"arrivesAt": "14:37",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "14:38",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "15:25",
					"arrivesAt": "15:56",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "15:57",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "16:16",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 53600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2076",
			"segments": [
				{
					"from": "Râmnicu Vâlcea",
					"to": "Ostroveni h.",
					"leavesAt": "13:06",
					"arrivesAt": "13:08",
					"waitsAtSource": 0,
					"distance": 1000
				},
				{
					"from": "Ostroveni h.",
					"to": "Răstoaca h.",
					"leavesAt": "13:09",
					"arrivesAt": "13:12",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Răstoaca h.",
					"to": "Râureni",
					"leavesAt": "13:13",
					"arrivesAt": "13:16",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Râureni",
					"to": "Râureni hc.",
					"leavesAt": "13:17",
					"arrivesAt": "13:21",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni hc.",
					"to": "Govora",
					"leavesAt": "13:22",
					"arrivesAt": "13:27",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Govora",
					"to": "Tătărani h.",
					"leavesAt": "13:35",
					"arrivesAt": "13:40",
					"waitsAtSource": 480,
					"distance": 5500
				},
				{
					"from": "Tătărani h.",
					"to": "Băbeni",
					"leavesAt": "13:41",
					"arrivesAt": "13:48",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Băbeni",
					"to": "Slăviteşti hc.",
					"leavesAt": "13:49",
					"arrivesAt": "13:54",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Ioneşti Hm.",
					"leavesAt": "13:55",
					"arrivesAt": "14:02",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "14:03",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Fişcălia Hm.",
					"leavesAt": "14:08",
					"arrivesAt": "14:12",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "14:13",
					"arrivesAt": "14:16",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Orleşti hc.",
					"to": "Zăvideni Hm.",
					"leavesAt": "14:17",
					"arrivesAt": "14:22",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Călina h.",
					"leavesAt": "14:23",
					"arrivesAt": "14:27",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Călina h.",
					"to": "Drăgăşani",
					"leavesAt": "14:28",
					"arrivesAt": "14:36",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Drăgăşani",
					"to": "Zlătărei Hm.",
					"leavesAt": "14:38",
					"arrivesAt": "14:45",
					"waitsAtSource": 120,
					"distance": 6600
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Strejeşti",
					"leavesAt": "14:46",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Strejeşti",
					"to": "Colibaşi h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Colibaşi h.",
					"to": "Arceşti Hm.",
					"leavesAt": "15:00",
					"arrivesAt": "15:07",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Arceşti Hm.",
					"to": "Găneasa Olt h.",
					"leavesAt": "15:08",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Găneasa Olt h.",
					"to": "Găneasa h.",
					"leavesAt": "15:14",
					"arrivesAt": "15:16",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Găneasa h.",
					"to": "Piatra Olt",
					"leavesAt": "15:17",
					"arrivesAt": "15:24",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5571",
			"segments": [
				{
					"from": "Botoşani",
					"to": "Leorda Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:21",
					"waitsAtSource": 0,
					"distance": 15500
				},
				{
					"from": "Leorda Hm.",
					"to": "Bucecea Hm",
					"leavesAt": "15:22",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bucecea Hm",
					"to": "Bursuceni h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Bursuceni h.",
					"to": "Vereşti",
					"leavesAt": "15:58",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "16:12",
					"arrivesAt": "16:18",
					"waitsAtSource": 120,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "16:19",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9002",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(900)",
					"leavesAt": "04:45",
					"arrivesAt": "04:47",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "04:53",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "04:54",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Malu Mare Hm.",
					"leavesAt": "04:58",
					"arrivesAt": "05:01",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Malu Mare Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "05:02",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Leu Hm.",
					"leavesAt": "05:06",
					"arrivesAt": "05:13",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Leu Hm.",
					"to": "Ţărţăl h.",
					"leavesAt": "05:14",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ţărţăl h.",
					"to": "Jianca",
					"leavesAt": "05:19",
					"arrivesAt": "05:23",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Jianca",
					"to": "Radomiru hc.",
					"leavesAt": "05:24",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Radomiru hc.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "05:28",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Cezieni h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Cezieni h.",
					"to": "Caracal",
					"leavesAt": "05:40",
					"arrivesAt": "05:46",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Caracal",
					"to": "Fărcaşele Hm.",
					"leavesAt": "05:56",
					"arrivesAt": "06:02",
					"waitsAtSource": 600,
					"distance": 7800
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Stoeneşti h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Stoeneşti h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "06:07",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Dăneasa h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Dăneasa h.",
					"to": "Radomireşti Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:27",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "06:28",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Măldăeni Hm.",
					"leavesAt": "06:38",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Măldăeni Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "06:48",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Roşiori Nord",
					"to": "Atârnaţi Hm.",
					"leavesAt": "07:00",
					"arrivesAt": "07:08",
					"waitsAtSource": 180,
					"distance": 7200
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "07:09",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Vârtoapele hc.",
					"leavesAt": "07:17",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Olteni",
					"leavesAt": "07:23",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "07:33",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Ciolpani Hm.",
					"leavesAt": "07:42",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Videle",
					"leavesAt": "07:49",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Videle",
					"to": "Zăvestreni Hm.",
					"leavesAt": "08:00",
					"arrivesAt": "08:05",
					"waitsAtSource": 120,
					"distance": 4800
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "08:06",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "08:11",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Grădinari",
					"leavesAt": "08:20",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Grădinari",
					"to": "Domneştii de Sus h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:43",
					"waitsAtSource": 300,
					"distance": 6000
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Chiajna",
					"leavesAt": "08:44",
					"arrivesAt": "09:00",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Chiajna",
					"to": "Bucureştii Noi",
					"leavesAt": "09:09",
					"arrivesAt": "09:12",
					"waitsAtSource": 540,
					"distance": 3200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Bucureşti Basarab",
					"leavesAt": "09:13",
					"arrivesAt": "09:21",
					"waitsAtSource": 60,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2209",
			"segments": [
				{
					"from": "Arad",
					"to": "Şofronea",
					"leavesAt": "16:32",
					"arrivesAt": "16:42",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Şofronea",
					"to": "Curtici",
					"leavesAt": "16:43",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4305",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "14:25",
					"arrivesAt": "14:33",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Gherla",
					"leavesAt": "14:34",
					"arrivesAt": "14:45",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "14:47",
					"arrivesAt": "14:53",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "14:54",
					"arrivesAt": "14:59",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "15:04",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "15:14",
					"arrivesAt": "15:20",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida h.",
					"leavesAt": "15:21",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Apahida h.",
					"to": "Apahida",
					"leavesAt": "15:29",
					"arrivesAt": "15:34",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "15:35",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "15:39",
					"arrivesAt": "15:46",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "15:53",
					"arrivesAt": "15:58",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180701",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180910",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4486",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "19:50",
					"arrivesAt": "19:57",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Ciceu Mihăeşti h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ciceu Mihăeşti h.",
					"to": "Reteag Hm.",
					"leavesAt": "20:04",
					"arrivesAt": "20:09",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Reteag Hm.",
					"to": "Reteag h.",
					"leavesAt": "20:10",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag h.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "20:19",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "20:23",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Beclean pe Someş",
					"to": "Cociu h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:43",
					"waitsAtSource": 180,
					"distance": 6700
				},
				{
					"from": "Cociu h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "20:44",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Nimigea h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Nimigea h.",
					"to": "Nimigea Hm.",
					"leavesAt": "20:53",
					"arrivesAt": "20:56",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Nimigea Hm.",
					"to": "Mititei h.",
					"leavesAt": "20:57",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mititei h.",
					"to": "Salva",
					"leavesAt": "21:04",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Salva",
					"to": "Năsăud h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:22",
					"waitsAtSource": 600,
					"distance": 4100
				},
				{
					"from": "Năsăud h.",
					"to": "Năsăud",
					"leavesAt": "21:23",
					"arrivesAt": "21:26",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Năsăud",
					"to": "Rebrişoara Hm.",
					"leavesAt": "21:27",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Nepos h.",
					"leavesAt": "21:33",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Nepos h.",
					"to": "Feldru Hm.",
					"leavesAt": "21:40",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Feldru Hm.",
					"to": "Podereia Feldrului h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:54",
					"waitsAtSource": 300,
					"distance": 2200
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Ilva Mică",
					"leavesAt": "21:55",
					"arrivesAt": "22:00",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "1064",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "18:09",
					"arrivesAt": "18:16",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Socola",
					"leavesAt": "18:17",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Socola",
					"to": "Holboca Hm.",
					"leavesAt": "18:23",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Holboca Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "18:33",
					"arrivesAt": "18:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "18:42",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ungheni Prut Hm.",
					"to": "Ungheni Prut Fr.",
					"leavesAt": "19:32",
					"arrivesAt": "19:34",
					"waitsAtSource": 2520,
					"distance": 600
				},
				{
					"from": "Ungheni Prut Fr.",
					"to": "Ungheni",
					"leavesAt": "19:54",
					"arrivesAt": "19:58",
					"waitsAtSource": 1200,
					"distance": 800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1925",
			"segments": [
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "03:42",
					"arrivesAt": "04:08",
					"waitsAtSource": 0,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Turceni",
					"leavesAt": "04:09",
					"arrivesAt": "04:30",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Turceni",
					"to": "Rovinari Hm.",
					"leavesAt": "04:31",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 35300
				},
				{
					"from": "Rovinari Hm.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "05:04",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "05:23",
					"arrivesAt": "05:40",
					"waitsAtSource": 360,
					"distance": 12500
				},
				{
					"from": "Târgu Jiu",
					"to": "Parângu Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:54",
					"waitsAtSource": 120,
					"distance": 10200
				},
				{
					"from": "Parângu Hm.",
					"to": "Valea Sadului Hm.",
					"leavesAt": "05:59",
					"arrivesAt": "06:10",
					"waitsAtSource": 300,
					"distance": 9400
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Petroşani",
					"leavesAt": "06:11",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 31700
				},
				{
					"from": "Petroşani",
					"to": "Băeşti Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "08:09",
					"waitsAtSource": 600,
					"distance": 42100
				},
				{
					"from": "Băeşti Hm.",
					"to": "Subcetate",
					"leavesAt": "08:16",
					"arrivesAt": "08:25",
					"waitsAtSource": 420,
					"distance": 7700
				},
				{
					"from": "Subcetate",
					"to": "Călan Hm.",
					"leavesAt": "08:26",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Călan Hm.",
					"to": "Simeria",
					"leavesAt": "08:46",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 14600
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "09:03",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20180610",
					"to": "20180910",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5054",
			"segments": [
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:17",
					"waitsAtSource": 0,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:22",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "05:23",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "05:29",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "05:34",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "05:46",
					"arrivesAt": "05:54",
					"waitsAtSource": 120,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "05:55",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Focşani",
					"to": "Coteşti Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:18",
					"waitsAtSource": 120,
					"distance": 7900
				},
				{
					"from": "Coteşti Hm.",
					"to": "Gugeşti",
					"leavesAt": "06:19",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Gugeşti",
					"to": "Sihlea Hm.",
					"leavesAt": "06:37",
					"arrivesAt": "06:45",
					"waitsAtSource": 600,
					"distance": 7200
				},
				{
					"from": "Sihlea Hm.",
					"to": "Voetin h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Voetin h.",
					"to": "Râmnicu Sărat",
					"leavesAt": "06:54",
					"arrivesAt": "07:04",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Zoita Hm.",
					"leavesAt": "07:05",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Zoita Hm.",
					"to": "Boboc Hm.",
					"leavesAt": "07:17",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Boboc Hm.",
					"to": "Buzău",
					"leavesAt": "07:28",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Buzău",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "07:43",
					"arrivesAt": "07:52",
					"waitsAtSource": 120,
					"distance": 10500
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Ulmeni",
					"leavesAt": "07:53",
					"arrivesAt": "07:58",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "07:59",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "08:04",
					"arrivesAt": "08:13",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "08:14",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "08:22",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "08:30",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:40",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "08:41",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "08:45",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "08:53",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "09:01",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 4300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9377",
			"segments": [
				{
					"from": "Alexandria",
					"to": "Ţigăneşti h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:57",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Ţigăneşti h.",
					"to": "Brânceni h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Brânceni h.",
					"to": "Smârdioasa h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:07",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Smârdioasa h.",
					"to": "Păuleasa h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:13",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Păuleasa h.",
					"to": "Şoimu h.",
					"leavesAt": "06:14",
					"arrivesAt": "06:19",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Şoimu h.",
					"to": "Ulmuleţ h.",
					"leavesAt": "06:20",
					"arrivesAt": "06:30",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Ulmuleţ h.",
					"to": "Zimnicea",
					"leavesAt": "06:31",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 9800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5304",
			"segments": [
				{
					"from": "Comăneşti",
					"to": "Valea Uzului Hm.",
					"leavesAt": "10:00",
					"arrivesAt": "10:09",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "10:10",
					"arrivesAt": "10:12",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Dofteana Bacău",
					"leavesAt": "10:13",
					"arrivesAt": "10:19",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Dofteana Bacău",
					"to": "Cireşoaia h.",
					"leavesAt": "10:20",
					"arrivesAt": "10:25",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cireşoaia h.",
					"to": "Saline hc.",
					"leavesAt": "10:26",
					"arrivesAt": "10:32",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Saline hc.",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "10:33",
					"arrivesAt": "10:36",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Viişoara h",
					"leavesAt": "10:44",
					"arrivesAt": "10:49",
					"waitsAtSource": 480,
					"distance": 3400
				},
				{
					"from": "Viişoara h",
					"to": "Oneşti",
					"leavesAt": "10:50",
					"arrivesAt": "11:03",
					"waitsAtSource": 30,
					"distance": 9100
				},
				{
					"from": "Oneşti",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "11:05",
					"arrivesAt": "11:10",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Borzeşti Bacău",
					"leavesAt": "11:11",
					"arrivesAt": "11:20",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Căiuţi Hm.",
					"leavesAt": "11:21",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Bâlca hc.",
					"leavesAt": "11:31",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Bâlca hc.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "11:36",
					"arrivesAt": "11:40",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Urecheşti Hm.",
					"leavesAt": "11:41",
					"arrivesAt": "11:44",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Adjud",
					"leavesAt": "11:45",
					"arrivesAt": "11:56",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "11:58",
					"arrivesAt": "12:06",
					"waitsAtSource": 120,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "12:07",
					"arrivesAt": "12:10",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "12:11",
					"arrivesAt": "12:18",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "12:19",
					"arrivesAt": "12:23",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "12:24",
					"arrivesAt": "12:34",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9375",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "21:30",
					"arrivesAt": "21:35",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Peret hc.",
					"leavesAt": "21:36",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Peret hc.",
					"to": "Plosca Hm.",
					"leavesAt": "21:49",
					"arrivesAt": "21:57",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Plosca Hm.",
					"to": "Buzescu h.",
					"leavesAt": "21:58",
					"arrivesAt": "22:06",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzescu h.",
					"to": "Alexandria Nord h.",
					"leavesAt": "22:07",
					"arrivesAt": "22:16",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Alexandria",
					"leavesAt": "22:17",
					"arrivesAt": "22:22",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 351
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 351
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 351
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4316",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Buşag Hm.",
					"leavesAt": "15:40",
					"arrivesAt": "15:57",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Buşag Hm.",
					"to": "Cicârlău h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cicârlău h.",
					"to": "Ilba h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:12",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Ilba h.",
					"to": "Săbişa h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:17",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săbişa h.",
					"to": "Seini",
					"leavesAt": "16:18",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Seini",
					"to": "Apa Hm.",
					"leavesAt": "16:25",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Apa Hm.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:58",
					"waitsAtSource": 600,
					"distance": 5100
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Odoreu h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Odoreu h.",
					"to": "Botiz Hm.",
					"leavesAt": "17:10",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Botiz Hm.",
					"to": "Satu Mare",
					"leavesAt": "17:18",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1624",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Tălmaciu Hm.",
					"leavesAt": "15:11",
					"arrivesAt": "15:30",
					"waitsAtSource": 0,
					"distance": 17800
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "15:31",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Avrig Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Avrig Hm.",
					"to": "Ucea",
					"leavesAt": "15:53",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 26100
				},
				{
					"from": "Ucea",
					"to": "Făgăraş",
					"leavesAt": "16:20",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Făgăraş",
					"to": "Brădet Hm.",
					"leavesAt": "16:45",
					"arrivesAt": "17:12",
					"waitsAtSource": 120,
					"distance": 26100
				},
				{
					"from": "Brădet Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:47",
					"waitsAtSource": 300,
					"distance": 25100
				},
				{
					"from": "Codlea Hm.",
					"to": "Braşov",
					"leavesAt": "17:48",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "18:20",
					"arrivesAt": "18:56",
					"waitsAtSource": 900,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "18:58",
					"arrivesAt": "19:07",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "19:08",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "19:16",
					"arrivesAt": "19:25",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Comarnic",
					"leavesAt": "19:27",
					"arrivesAt": "19:41",
					"waitsAtSource": 120,
					"distance": 15100
				},
				{
					"from": "Comarnic",
					"to": "Câmpina",
					"leavesAt": "19:42",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "19:55",
					"arrivesAt": "20:20",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buftea",
					"leavesAt": "20:22",
					"arrivesAt": "20:51",
					"waitsAtSource": 120,
					"distance": 42000
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "20:52",
					"arrivesAt": "21:10",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9133",
			"segments": [
				{
					"from": "Golenţi Hm.",
					"to": "Calafat",
					"leavesAt": "11:18",
					"arrivesAt": "11:33",
					"waitsAtSource": 0,
					"distance": 11800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2708",
			"segments": [
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "15:18",
					"arrivesAt": "15:22",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "15:23",
					"arrivesAt": "15:29",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia h.",
					"leavesAt": "15:34",
					"arrivesAt": "15:36",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Mintia",
					"leavesAt": "15:37",
					"arrivesAt": "15:41",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "15:42",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "15:52",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "15:59",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Simeria",
					"to": "Simeria Triaj",
					"leavesAt": "16:08",
					"arrivesAt": "16:14",
					"waitsAtSource": 180,
					"distance": 3200
				},
				{
					"from": "Simeria Triaj",
					"to": "Băcia h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Băcia h.",
					"to": "Băcia Hm.",
					"leavesAt": "16:18",
					"arrivesAt": "16:20",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Băcia Hm.",
					"to": "Batiz h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Batiz h.",
					"to": "Călan Băi",
					"leavesAt": "16:24",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Călan Băi",
					"to": "Călan Hm.",
					"leavesAt": "16:27",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Hm.",
					"to": "Ruşi h.",
					"leavesAt": "16:32",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ruşi h.",
					"to": "Măceu h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:38",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Măceu h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "16:39",
					"arrivesAt": "16:44",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Plopi h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Plopi h.",
					"to": "Covragiu h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Covragiu h.",
					"to": "Subcetate",
					"leavesAt": "16:52",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Subcetate",
					"to": "Ciopea h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ciopea h.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Băeşti Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:08",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ruşor h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:11",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ruşor h.",
					"to": "Pui",
					"leavesAt": "17:12",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Pui",
					"to": "Ponor h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ponor h.",
					"to": "Livadia h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Livadia h.",
					"to": "Baru Mare",
					"leavesAt": "17:26",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Baru Mare",
					"to": "Baru Mare h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Baru Mare h.",
					"to": "Crivadia Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Crivadia Hm.",
					"to": "Merişor Hm.",
					"leavesAt": "17:48",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Merişor Hm.",
					"to": "Băniţa",
					"leavesAt": "17:57",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băniţa",
					"to": "Peştera Bolii h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Petroşani Triaj h.",
					"leavesAt": "18:17",
					"arrivesAt": "18:21",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Petroşani Triaj h.",
					"to": "Dep Petroşani h.",
					"leavesAt": "18:22",
					"arrivesAt": "18:24",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Petroşani",
					"leavesAt": "18:25",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9386",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(900)",
					"leavesAt": "16:38",
					"arrivesAt": "16:41",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Malu Mare Hm.",
					"leavesAt": "16:52",
					"arrivesAt": "16:55",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Malu Mare Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "16:56",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Leu Hm.",
					"leavesAt": "17:01",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Leu Hm.",
					"to": "Ţărţăl h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ţărţăl h.",
					"to": "Jianca",
					"leavesAt": "17:16",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Jianca",
					"to": "Radomiru hc.",
					"leavesAt": "17:21",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Radomiru hc.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "17:25",
					"arrivesAt": "17:30",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Cezieni h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Cezieni h.",
					"to": "Caracal",
					"leavesAt": "17:37",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Caracal",
					"to": "Fărcaşele Hm.",
					"leavesAt": "17:45",
					"arrivesAt": "17:51",
					"waitsAtSource": 120,
					"distance": 7800
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Stoeneşti h.",
					"leavesAt": "17:52",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Stoeneşti h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "17:56",
					"arrivesAt": "18:03",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Dăneasa h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:07",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Dăneasa h.",
					"to": "Radomireşti Hm.",
					"leavesAt": "18:08",
					"arrivesAt": "18:15",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "18:16",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Măldăeni Hm.",
					"leavesAt": "18:26",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Măldăeni Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "18:37",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4136",
			"segments": [
				{
					"from": "Sighetu Marmaţiei",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "17:30",
					"arrivesAt": "17:35",
					"waitsAtSource": 0,
					"distance": 1900
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Tisa h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tisa h.",
					"to": "Crăciuneşti h.",
					"leavesAt": "17:45",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "17:49",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Lunca la Tisa h.",
					"leavesAt": "17:56",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Valea Vişeului",
					"leavesAt": "18:02",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Valea Vişeului",
					"to": "Vişeu Bistra h.",
					"leavesAt": "18:36",
					"arrivesAt": "18:50",
					"waitsAtSource": 960,
					"distance": 8500
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Petrova hc.",
					"leavesAt": "18:51",
					"arrivesAt": "19:00",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Petrova hc.",
					"to": "Leordina",
					"leavesAt": "19:01",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Leordina",
					"to": "Leordina h.",
					"leavesAt": "19:13",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Leordina h.",
					"to": "Bocicoel h.",
					"leavesAt": "19:19",
					"arrivesAt": "19:27",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Bocicoel h.",
					"to": "Vişeu de Jos",
					"leavesAt": "19:28",
					"arrivesAt": "19:33",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Vişeu de Jos",
					"to": "Iza P.M.",
					"leavesAt": "19:41",
					"arrivesAt": "19:53",
					"waitsAtSource": 480,
					"distance": 8600
				},
				{
					"from": "Iza P.M.",
					"to": "Săcel Hm.",
					"leavesAt": "19:54",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săcel Hm.",
					"to": "Dealu Ştefăniţei",
					"leavesAt": "20:05",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dealu Ştefăniţei",
					"to": "Romuli h.",
					"leavesAt": "20:17",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Romuli h.",
					"to": "Fiad Hm.",
					"leavesAt": "20:27",
					"arrivesAt": "20:36",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Fiad Hm.",
					"to": "Telciu Hm.",
					"leavesAt": "20:37",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Telciu Hm.",
					"to": "Coşbuc Hm.",
					"leavesAt": "20:51",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Coşbuc Hm.",
					"to": "Salva",
					"leavesAt": "21:00",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Salva",
					"to": "Mititei h.",
					"leavesAt": "21:14",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Mititei h.",
					"to": "Nimigea Hm.",
					"leavesAt": "21:18",
					"arrivesAt": "21:24",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Nimigea Hm.",
					"to": "Nimigea h.",
					"leavesAt": "21:25",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Nimigea h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "21:29",
					"arrivesAt": "21:34",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Cociu h.",
					"leavesAt": "21:35",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cociu h.",
					"to": "Beclean pe Someş",
					"leavesAt": "21:39",
					"arrivesAt": "21:48",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Beclean pe Someş",
					"to": "Ciceu Cristur h.",
					"leavesAt": "21:59",
					"arrivesAt": "22:12",
					"waitsAtSource": 660,
					"distance": 7600
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "22:13",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "22:17",
					"arrivesAt": "22:21",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Dej Triaj",
					"leavesAt": "22:22",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "22:33",
					"arrivesAt": "22:40",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "22:52",
					"arrivesAt": "23:11",
					"waitsAtSource": 720,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Iclod Hm.",
					"leavesAt": "23:12",
					"arrivesAt": "23:24",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Iclod Hm.",
					"to": "Bonţida Hm.",
					"leavesAt": "23:25",
					"arrivesAt": "23:33",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Bonţida Hm.",
					"to": "Jucu Hm.",
					"leavesAt": "23:34",
					"arrivesAt": "23:42",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida",
					"leavesAt": "23:43",
					"arrivesAt": "23:53",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Apahida",
					"to": "Cluj Napoca Est",
					"leavesAt": "23:54",
					"arrivesAt": "00:03",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "00:04",
					"arrivesAt": "00:09",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "00:10",
					"arrivesAt": "00:15",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1689",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Lehliu",
					"leavesAt": "06:10",
					"arrivesAt": "06:56",
					"waitsAtSource": 0,
					"distance": 69600
				},
				{
					"from": "Lehliu",
					"to": "Ciulniţa",
					"leavesAt": "07:05",
					"arrivesAt": "07:29",
					"waitsAtSource": 540,
					"distance": 39300
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "07:31",
					"arrivesAt": "07:54",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "07:56",
					"arrivesAt": "08:15",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "08:16",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Nicolae Bălcescu",
					"leavesAt": "09:05",
					"arrivesAt": "09:23",
					"waitsAtSource": 1800,
					"distance": 19100
				},
				{
					"from": "Nicolae Bălcescu",
					"to": "Ram. M.K.P. Aj. M.",
					"leavesAt": "09:24",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ram. M.K.P. Aj. M.",
					"to": "Târguşor Dobrogea Hm.",
					"leavesAt": "09:31",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Târguşor Dobrogea Hm.",
					"to": "Cogealac",
					"leavesAt": "09:41",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Cogealac",
					"to": "Mihai Viteazu Hm.",
					"leavesAt": "10:02",
					"arrivesAt": "10:20",
					"waitsAtSource": 60,
					"distance": 17400
				},
				{
					"from": "Mihai Viteazu Hm.",
					"to": "Baia Dobrogea",
					"leavesAt": "10:21",
					"arrivesAt": "10:32",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Baia Dobrogea",
					"to": "Ceamurlia de Jos h.",
					"leavesAt": "10:33",
					"arrivesAt": "10:39",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ceamurlia de Jos h.",
					"to": "Babadag",
					"leavesAt": "10:40",
					"arrivesAt": "10:57",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Babadag",
					"to": "Zebil h.",
					"leavesAt": "10:58",
					"arrivesAt": "11:14",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Zebil h.",
					"to": "Mihail Kogălniceanu h.",
					"leavesAt": "11:15",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Mihail Kogălniceanu h.",
					"to": "Cataloi Hm.",
					"leavesAt": "11:30",
					"arrivesAt": "11:44",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Cataloi Hm.",
					"to": "Tulcea Mărfuri",
					"leavesAt": "11:45",
					"arrivesAt": "12:00",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Tulcea Mărfuri",
					"to": "Tulcea Oraş",
					"leavesAt": "12:01",
					"arrivesAt": "12:10",
					"waitsAtSource": 60,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20180105",
					"to": "20180107",
					"daysOfWeek": 383
				},
				{
					"from": "20180112",
					"to": "20180114",
					"daysOfWeek": 383
				},
				{
					"from": "20180119",
					"to": "20180121",
					"daysOfWeek": 383
				},
				{
					"from": "20180126",
					"to": "20180128",
					"daysOfWeek": 383
				},
				{
					"from": "20180202",
					"to": "20180204",
					"daysOfWeek": 383
				},
				{
					"from": "20180209",
					"to": "20180211",
					"daysOfWeek": 383
				},
				{
					"from": "20180216",
					"to": "20180218",
					"daysOfWeek": 383
				},
				{
					"from": "20180223",
					"to": "20180225",
					"daysOfWeek": 383
				},
				{
					"from": "20180302",
					"to": "20180304",
					"daysOfWeek": 383
				},
				{
					"from": "20180309",
					"to": "20180311",
					"daysOfWeek": 383
				},
				{
					"from": "20180316",
					"to": "20180318",
					"daysOfWeek": 383
				},
				{
					"from": "20180323",
					"to": "20180325",
					"daysOfWeek": 383
				},
				{
					"from": "20180330",
					"to": "20180401",
					"daysOfWeek": 383
				},
				{
					"from": "20180406",
					"to": "20180408",
					"daysOfWeek": 383
				},
				{
					"from": "20180413",
					"to": "20180415",
					"daysOfWeek": 383
				},
				{
					"from": "20180420",
					"to": "20180422",
					"daysOfWeek": 383
				},
				{
					"from": "20180427",
					"to": "20180429",
					"daysOfWeek": 383
				},
				{
					"from": "20180504",
					"to": "20180506",
					"daysOfWeek": 383
				},
				{
					"from": "20180511",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180518",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180527",
					"daysOfWeek": 383
				},
				{
					"from": "20180601",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180608",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180914",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180921",
					"to": "20180923",
					"daysOfWeek": 383
				},
				{
					"from": "20180928",
					"to": "20180930",
					"daysOfWeek": 383
				},
				{
					"from": "20181005",
					"to": "20181007",
					"daysOfWeek": 383
				},
				{
					"from": "20181012",
					"to": "20181014",
					"daysOfWeek": 383
				},
				{
					"from": "20181019",
					"to": "20181021",
					"daysOfWeek": 383
				},
				{
					"from": "20181026",
					"to": "20181028",
					"daysOfWeek": 383
				},
				{
					"from": "20181102",
					"to": "20181104",
					"daysOfWeek": 383
				},
				{
					"from": "20181109",
					"to": "20181111",
					"daysOfWeek": 383
				},
				{
					"from": "20181116",
					"to": "20181118",
					"daysOfWeek": 383
				},
				{
					"from": "20181123",
					"to": "20181125",
					"daysOfWeek": 383
				},
				{
					"from": "20181130",
					"to": "20181202",
					"daysOfWeek": 383
				},
				{
					"from": "20181207",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 383
				},
				{
					"from": "20171215",
					"to": "20171217",
					"daysOfWeek": 383
				},
				{
					"from": "20171223",
					"to": "20171225",
					"daysOfWeek": 383
				},
				{
					"from": "20171229",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4070",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:10",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "05:11",
					"arrivesAt": "05:15",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "05:16",
					"arrivesAt": "05:22",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "05:23",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180114",
					"daysOfWeek": 383
				},
				{
					"from": "20180120",
					"to": "20180121",
					"daysOfWeek": 383
				},
				{
					"from": "20180124",
					"to": "20180124",
					"daysOfWeek": 383
				},
				{
					"from": "20180127",
					"to": "20180128",
					"daysOfWeek": 383
				},
				{
					"from": "20180203",
					"to": "20180211",
					"daysOfWeek": 383
				},
				{
					"from": "20180217",
					"to": "20180218",
					"daysOfWeek": 383
				},
				{
					"from": "20180224",
					"to": "20180225",
					"daysOfWeek": 383
				},
				{
					"from": "20180303",
					"to": "20180304",
					"daysOfWeek": 383
				},
				{
					"from": "20180310",
					"to": "20180311",
					"daysOfWeek": 383
				},
				{
					"from": "20180317",
					"to": "20180318",
					"daysOfWeek": 383
				},
				{
					"from": "20180324",
					"to": "20180325",
					"daysOfWeek": 383
				},
				{
					"from": "20180331",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180410",
					"to": "20180410",
					"daysOfWeek": 383
				},
				{
					"from": "20180414",
					"to": "20180415",
					"daysOfWeek": 383
				},
				{
					"from": "20180421",
					"to": "20180422",
					"daysOfWeek": 383
				},
				{
					"from": "20180428",
					"to": "20180429",
					"daysOfWeek": 383
				},
				{
					"from": "20180505",
					"to": "20180506",
					"daysOfWeek": 383
				},
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180526",
					"to": "20180526",
					"daysOfWeek": 383
				},
				{
					"from": "20180601",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180610",
					"daysOfWeek": 383
				},
				{
					"from": "20180616",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180922",
					"to": "20180923",
					"daysOfWeek": 383
				},
				{
					"from": "20180929",
					"to": "20180930",
					"daysOfWeek": 383
				},
				{
					"from": "20181006",
					"to": "20181007",
					"daysOfWeek": 383
				},
				{
					"from": "20181013",
					"to": "20181014",
					"daysOfWeek": 383
				},
				{
					"from": "20181020",
					"to": "20181021",
					"daysOfWeek": 383
				},
				{
					"from": "20181027",
					"to": "20181028",
					"daysOfWeek": 383
				},
				{
					"from": "20181103",
					"to": "20181104",
					"daysOfWeek": 383
				},
				{
					"from": "20181110",
					"to": "20181111",
					"daysOfWeek": 383
				},
				{
					"from": "20181117",
					"to": "20181118",
					"daysOfWeek": 383
				},
				{
					"from": "20181124",
					"to": "20181125",
					"daysOfWeek": 383
				},
				{
					"from": "20181202",
					"to": "20181202",
					"daysOfWeek": 383
				},
				{
					"from": "20181208",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 383
				},
				{
					"from": "20171216",
					"to": "20171217",
					"daysOfWeek": 383
				},
				{
					"from": "20171223",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171227",
					"to": "20171230",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9472",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "10:50",
					"arrivesAt": "10:55",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "10:56",
					"arrivesAt": "11:01",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "11:02",
					"arrivesAt": "11:10",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "11:11",
					"arrivesAt": "11:18",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "11:20",
					"arrivesAt": "11:29",
					"waitsAtSource": 120,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "11:30",
					"arrivesAt": "11:37",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "11:38",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Potcoava",
					"to": "Sineşti Hm.",
					"leavesAt": "11:47",
					"arrivesAt": "11:54",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sineşti Hm.",
					"to": "Corbu",
					"leavesAt": "11:55",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Corbu",
					"to": "Hârseşti Hm.",
					"leavesAt": "12:07",
					"arrivesAt": "12:13",
					"waitsAtSource": 300,
					"distance": 5100
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "12:14",
					"arrivesAt": "12:20",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stolnici Hm.",
					"to": "Fâlfani Hm.",
					"leavesAt": "12:21",
					"arrivesAt": "12:30",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Costeşti",
					"leavesAt": "12:31",
					"arrivesAt": "12:40",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Costeşti",
					"to": "Pârvu h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:49",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Pârvu h.",
					"to": "Bradu de Sus",
					"leavesAt": "12:50",
					"arrivesAt": "13:06",
					"waitsAtSource": 30,
					"distance": 9700
				},
				{
					"from": "Bradu de Sus",
					"to": "Km. 109+000 h.",
					"leavesAt": "13:07",
					"arrivesAt": "13:12",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Km. 109+000 h.",
					"to": "Piteşti",
					"leavesAt": "13:13",
					"arrivesAt": "13:15",
					"waitsAtSource": 30,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180526",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180610",
					"daysOfWeek": 383
				},
				{
					"from": "20180616",
					"to": "20180617",
					"daysOfWeek": 383
				},
				{
					"from": "20180623",
					"to": "20180624",
					"daysOfWeek": 383
				},
				{
					"from": "20180630",
					"to": "20180701",
					"daysOfWeek": 383
				},
				{
					"from": "20180707",
					"to": "20180708",
					"daysOfWeek": 383
				},
				{
					"from": "20180714",
					"to": "20180715",
					"daysOfWeek": 383
				},
				{
					"from": "20180721",
					"to": "20180722",
					"daysOfWeek": 383
				},
				{
					"from": "20180728",
					"to": "20180729",
					"daysOfWeek": 383
				},
				{
					"from": "20180804",
					"to": "20180805",
					"daysOfWeek": 383
				},
				{
					"from": "20180811",
					"to": "20180819",
					"daysOfWeek": 383
				},
				{
					"from": "20180825",
					"to": "20180826",
					"daysOfWeek": 383
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 383
				},
				{
					"from": "20180908",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180922",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180506",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9608",
			"segments": [
				{
					"from": "Buziaş",
					"to": "Bacova h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:11",
					"waitsAtSource": 0,
					"distance": 2300
				},
				{
					"from": "Bacova h.",
					"to": "Chevereş h.",
					"leavesAt": "05:12",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Chevereş h.",
					"to": "Sacoşu Mic",
					"leavesAt": "05:18",
					"arrivesAt": "05:24",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Sacoşu Mic",
					"to": "Uliuc h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Uliuc h.",
					"to": "Urseni h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Urseni h.",
					"to": "Semenic Hm.",
					"leavesAt": "05:37",
					"arrivesAt": "05:41",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Semenic Hm.",
					"to": "Giroc h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Giroc h.",
					"to": "Timişoara Sud",
					"leavesAt": "05:45",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "05:52",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3012",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "18:30",
					"arrivesAt": "18:40",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Timişu de Jos h.",
					"leavesAt": "18:41",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "18:48",
					"arrivesAt": "18:57",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Predeal",
					"leavesAt": "18:58",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "19:17",
					"arrivesAt": "19:26",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "19:27",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "19:34",
					"arrivesAt": "19:37",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "19:38",
					"arrivesAt": "19:44",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:49",
					"waitsAtSource": 120,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "19:50",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Posada h.",
					"leavesAt": "19:56",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Posada h.",
					"to": "Comarnic",
					"leavesAt": "20:02",
					"arrivesAt": "20:07",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "20:08",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "20:13",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "20:17",
					"arrivesAt": "20:20",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "20:21",
					"arrivesAt": "20:27",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Bobolia h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:34",
					"waitsAtSource": 120,
					"distance": 5500
				},
				{
					"from": "Bobolia h.",
					"to": "Floreşti Prahova",
					"leavesAt": "20:35",
					"arrivesAt": "20:43",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "20:49",
					"arrivesAt": "20:59",
					"waitsAtSource": 360,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "21:00",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Brazi",
					"leavesAt": "21:13",
					"arrivesAt": "21:20",
					"waitsAtSource": 240,
					"distance": 7500
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "21:21",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "21:27",
					"arrivesAt": "21:32",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Periş",
					"leavesAt": "21:33",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Periş",
					"to": "Buftea",
					"leavesAt": "21:42",
					"arrivesAt": "21:52",
					"waitsAtSource": 60,
					"distance": 13300
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "21:53",
					"arrivesAt": "22:01",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Nord",
					"leavesAt": "22:02",
					"arrivesAt": "22:14",
					"waitsAtSource": 60,
					"distance": 9400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1834",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Vinga Hm.",
					"leavesAt": "06:33",
					"arrivesAt": "07:01",
					"waitsAtSource": 0,
					"distance": 32600
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Aradu Nou",
					"leavesAt": "07:09",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "07:25",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Arad",
					"to": "Sântana",
					"leavesAt": "07:47",
					"arrivesAt": "08:13",
					"waitsAtSource": 900,
					"distance": 23500
				},
				{
					"from": "Sântana",
					"to": "Chişineu Criş",
					"leavesAt": "08:14",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Chişineu Criş",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 23700
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Salonta",
					"leavesAt": "09:00",
					"arrivesAt": "09:13",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Salonta",
					"to": "Oradea",
					"leavesAt": "09:14",
					"arrivesAt": "09:53",
					"waitsAtSource": 60,
					"distance": 39200
				},
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "09:57",
					"arrivesAt": "10:28",
					"waitsAtSource": 240,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "10:29",
					"arrivesAt": "10:49",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "10:50",
					"arrivesAt": "10:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bratca",
					"to": "Ciucea Hm.",
					"leavesAt": "10:59",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Ciucea Hm.",
					"to": "Huedin",
					"leavesAt": "11:21",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Huedin",
					"to": "Aghireş",
					"leavesAt": "11:42",
					"arrivesAt": "12:06",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Aghireş",
					"to": "Cluj Napoca",
					"leavesAt": "12:07",
					"arrivesAt": "12:33",
					"waitsAtSource": 60,
					"distance": 27900
				},
				{
					"from": "Cluj Napoca",
					"to": "Gherla",
					"leavesAt": "12:47",
					"arrivesAt": "13:45",
					"waitsAtSource": 840,
					"distance": 44900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "13:46",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Beclean pe Someş",
					"leavesAt": "14:10",
					"arrivesAt": "14:43",
					"waitsAtSource": 300,
					"distance": 24600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Salva",
					"leavesAt": "14:45",
					"arrivesAt": "15:07",
					"waitsAtSource": 120,
					"distance": 21600
				},
				{
					"from": "Salva",
					"to": "Năsăud",
					"leavesAt": "15:09",
					"arrivesAt": "15:16",
					"waitsAtSource": 120,
					"distance": 6300
				},
				{
					"from": "Năsăud",
					"to": "Ilva Mică",
					"leavesAt": "15:18",
					"arrivesAt": "15:40",
					"waitsAtSource": 120,
					"distance": 19800
				},
				{
					"from": "Ilva Mică",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "15:42",
					"arrivesAt": "16:03",
					"waitsAtSource": 120,
					"distance": 17300
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "16:04",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 14300
				},
				{
					"from": "Lunca Ilvei",
					"to": "Silhoasa Hm.",
					"leavesAt": "16:22",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Silhoasa Hm.",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "16:36",
					"arrivesAt": "17:25",
					"waitsAtSource": 300,
					"distance": 37000
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Vatra Dornei",
					"leavesAt": "17:27",
					"arrivesAt": "17:30",
					"waitsAtSource": 120,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei",
					"to": "Iacobeni",
					"leavesAt": "17:33",
					"arrivesAt": "17:48",
					"waitsAtSource": 180,
					"distance": 10200
				},
				{
					"from": "Iacobeni",
					"to": "Mestecăniş",
					"leavesAt": "17:49",
					"arrivesAt": "18:00",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Pojorâta Hm.",
					"leavesAt": "18:01",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "18:23",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "18:33",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Vama",
					"leavesAt": "18:40",
					"arrivesAt": "18:54",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Vama",
					"to": "Frasin",
					"leavesAt": "18:55",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "19:07",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Suceava",
					"leavesAt": "19:18",
					"arrivesAt": "20:01",
					"waitsAtSource": 180,
					"distance": 46800
				},
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "20:15",
					"arrivesAt": "20:28",
					"waitsAtSource": 840,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "20:29",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "20:48",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Târgu Frumos",
					"leavesAt": "21:06",
					"arrivesAt": "21:33",
					"waitsAtSource": 120,
					"distance": 30800
				},
				{
					"from": "Târgu Frumos",
					"to": "Iaşi",
					"leavesAt": "21:34",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 44900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5401",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "04:40",
					"arrivesAt": "04:46",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "04:47",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "04:52",
					"arrivesAt": "04:58",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "04:59",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "05:03",
					"arrivesAt": "05:15",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Adjudu Vechi h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:21",
					"waitsAtSource": 120,
					"distance": 4100
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Şişcani h.",
					"leavesAt": "05:22",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Şişcani h.",
					"to": "Sascut Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:33",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sascut Hm.",
					"to": "Orbeni Hm.",
					"leavesAt": "05:34",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Orbeni Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Răcăciuni h.",
					"to": "Faraoani Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Faraoani Hm.",
					"to": "Siretu Bacău h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Valea Seacă",
					"leavesAt": "06:04",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Valea Seacă",
					"to": "Letea h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Letea h.",
					"to": "Bacău",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "37630",
			"segments": [
				{
					"from": "Kotegyan",
					"to": "Salonta",
					"leavesAt": "08:40",
					"arrivesAt": "09:00",
					"waitsAtSource": 0,
					"distance": 13200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5471",
			"segments": [
				{
					"from": "Bacău",
					"to": "Hămeiuş P.M.",
					"leavesAt": "04:09",
					"arrivesAt": "04:18",
					"waitsAtSource": 0,
					"distance": 7900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Gârleni Hm.",
					"leavesAt": "04:19",
					"arrivesAt": "04:27",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Gârleni Hm.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "04:28",
					"arrivesAt": "04:33",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Racova h.",
					"leavesAt": "04:34",
					"arrivesAt": "04:39",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Racova h.",
					"to": "Buhuşi",
					"leavesAt": "04:40",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Buhuşi",
					"to": "Costişa h.",
					"leavesAt": "04:48",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Costişa h.",
					"to": "Podoleni Hm.",
					"leavesAt": "04:56",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Podoleni Hm.",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Roznov",
					"leavesAt": "05:13",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Roznov",
					"to": "Săvineşti h.",
					"leavesAt": "05:28",
					"arrivesAt": "05:33",
					"waitsAtSource": 600,
					"distance": 4200
				},
				{
					"from": "Săvineşti h.",
					"to": "Dumbrava h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Piatra Neamţ",
					"leavesAt": "05:43",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Piatra Neamţ",
					"to": "Vaduri h.",
					"leavesAt": "05:51",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Vaduri h.",
					"to": "Pângăraţi Hm.",
					"leavesAt": "06:04",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Pângăraţi Hm.",
					"to": "Stejaru h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Stejaru h.",
					"to": "Tarcău Neamţ Hm.",
					"leavesAt": "06:15",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tarcău Neamţ Hm.",
					"to": "Bicaz",
					"leavesAt": "06:23",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9352",
			"segments": [
				{
					"from": "Giurgiu",
					"to": "Giurgiu Nord",
					"leavesAt": "19:00",
					"arrivesAt": "19:05",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Giurgiu Nord",
					"to": "Cetatea h.",
					"leavesAt": "19:06",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cetatea h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "19:10",
					"arrivesAt": "19:13",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Onceşti h.",
					"leavesAt": "19:14",
					"arrivesAt": "19:17",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Onceşti h.",
					"to": "Stăneşti Hm.",
					"leavesAt": "19:18",
					"arrivesAt": "19:23",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Chiriacu Hm.",
					"leavesAt": "19:24",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Toporu",
					"leavesAt": "19:32",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Toporu",
					"to": "Răsuceni h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Răsuceni h.",
					"to": "Vlaşca Hm.",
					"leavesAt": "19:46",
					"arrivesAt": "19:53",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "19:54",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Târnavele Hm.",
					"to": "Răduleşti Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Videle",
					"leavesAt": "20:15",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7587",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "13:02",
					"arrivesAt": "13:09",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Cosmeşti Hm.",
					"leavesAt": "13:10",
					"arrivesAt": "13:15",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "Tecuci",
					"leavesAt": "13:16",
					"arrivesAt": "13:27",
					"waitsAtSource": 60,
					"distance": 7400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8002",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "05:52",
					"arrivesAt": "05:58",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "05:59",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "06:07",
					"arrivesAt": "06:11",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "06:12",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "06:23",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "06:32",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "06:40",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "06:50",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "06:57",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Dunărea Hm.",
					"leavesAt": "07:07",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Dunărea Hm.",
					"to": "Ovidiu",
					"leavesAt": "07:22",
					"arrivesAt": "07:28",
					"waitsAtSource": 360,
					"distance": 7600
				},
				{
					"from": "Ovidiu",
					"to": "Ramificaţia Borcea",
					"leavesAt": "07:29",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "07:34",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Feteşti",
					"to": "Bărăganu Hm.",
					"leavesAt": "07:41",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "07:51",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Jegălia",
					"leavesAt": "07:56",
					"arrivesAt": "08:00",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Jegălia",
					"to": "Recolta hc.",
					"leavesAt": "08:01",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Recolta hc.",
					"to": "Perişoru Hm.",
					"leavesAt": "08:05",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Perişoru Hm.",
					"to": "Ogoarele h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ogoarele h.",
					"to": "Ciulniţa",
					"leavesAt": "08:13",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 9000
				},
				{
					"from": "Ciulniţa",
					"to": "Ivăneşti h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ivăneşti h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "08:28",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Bogdana h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Bogdana h.",
					"to": "Dâlga h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Dâlga h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:54",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Lehliu",
					"leavesAt": "08:55",
					"arrivesAt": "08:59",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Lehliu",
					"to": "Preasna h.",
					"leavesAt": "09:00",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Preasna h.",
					"to": "Săruleşti",
					"leavesAt": "09:08",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Săruleşti",
					"to": "Mostiştea h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mostiştea h.",
					"to": "Fundulea Hm.",
					"leavesAt": "09:21",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Fundulea Hm.",
					"to": "Islaz h.",
					"leavesAt": "09:27",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Islaz h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "09:35",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Brăneşti Sat h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Pasărea",
					"leavesAt": "09:42",
					"arrivesAt": "09:48",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Pasărea",
					"to": "Pantelimon",
					"leavesAt": "09:49",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pantelimon",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "09:56",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Bucureşti Obor",
					"leavesAt": "09:59",
					"arrivesAt": "10:11",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4528",
			"segments": [
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "01:21",
					"arrivesAt": "01:42",
					"waitsAtSource": 0,
					"distance": 20900
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Siculeni",
					"leavesAt": "01:49",
					"arrivesAt": "01:59",
					"waitsAtSource": 420,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 382
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3642",
			"segments": [
				{
					"from": "Bratca",
					"to": "Stâna de Vale h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:33",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bulz Hm.",
					"leavesAt": "06:34",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bulz Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "06:38",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Lacu Crişului h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:53",
					"waitsAtSource": 240,
					"distance": 4400
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Negreni h.",
					"leavesAt": "06:54",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Ciucea Hm.",
					"leavesAt": "06:59",
					"arrivesAt": "07:03",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ciucea Hm.",
					"to": "Valea Drăganului h.",
					"leavesAt": "07:04",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Valea Drăganului h.",
					"to": "Poieni",
					"leavesAt": "07:09",
					"arrivesAt": "07:13",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Poieni",
					"to": "Bologa h.",
					"leavesAt": "07:14",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Bologa h.",
					"to": "Brăişoru Hm.",
					"leavesAt": "07:18",
					"arrivesAt": "07:22",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Huedin",
					"leavesAt": "07:23",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180107",
					"daysOfWeek": 799
				},
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180901",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4441",
			"segments": [
				{
					"from": "Carei",
					"to": "Tiream h.",
					"leavesAt": "20:47",
					"arrivesAt": "20:57",
					"waitsAtSource": 0,
					"distance": 11700
				},
				{
					"from": "Tiream h.",
					"to": "Hotoan h.",
					"leavesAt": "20:58",
					"arrivesAt": "21:03",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Hotoan h.",
					"to": "Santău h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:09",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Santău h.",
					"to": "Tăşnad",
					"leavesAt": "21:10",
					"arrivesAt": "21:15",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tăşnad",
					"to": "Acâş Hm.",
					"leavesAt": "21:16",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Acâş Hm.",
					"to": "Supur h.",
					"leavesAt": "21:31",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Supur h.",
					"to": "Giorocuţa h.",
					"leavesAt": "21:40",
					"arrivesAt": "21:43",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Giorocuţa h.",
					"to": "Derşida h.",
					"leavesAt": "21:44",
					"arrivesAt": "21:49",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Derşida h.",
					"to": "Sărmăşag",
					"leavesAt": "21:50",
					"arrivesAt": "21:58",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Sărmăşag",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "21:59",
					"arrivesAt": "22:05",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "22:06",
					"arrivesAt": "22:09",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Borla Hm.",
					"leavesAt": "22:10",
					"arrivesAt": "22:14",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Borla Hm.",
					"to": "Guruslău h.",
					"leavesAt": "22:15",
					"arrivesAt": "22:19",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Guruslău h.",
					"to": "Zalău Nord",
					"leavesAt": "22:20",
					"arrivesAt": "22:27",
					"waitsAtSource": 30,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3543",
			"segments": [
				{
					"from": "Odorhei",
					"to": "Odorhei Sud hc.",
					"leavesAt": "08:00",
					"arrivesAt": "08:04",
					"waitsAtSource": 0,
					"distance": 1200
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Feliceni h.",
					"leavesAt": "08:06",
					"arrivesAt": "08:13",
					"waitsAtSource": 120,
					"distance": 5300
				},
				{
					"from": "Feliceni h.",
					"to": "Dobeni h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Lutiţa h.",
					"leavesAt": "08:20",
					"arrivesAt": "08:24",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Lutiţa h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "08:25",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Beteşti h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Beteşti h.",
					"to": "Cristur Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:48",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Cristur Hm.",
					"to": "Sântămaria h.",
					"leavesAt": "08:55",
					"arrivesAt": "08:59",
					"waitsAtSource": 420,
					"distance": 3000
				},
				{
					"from": "Sântămaria h.",
					"to": "Săcuienii Noi h.",
					"leavesAt": "09:00",
					"arrivesAt": "09:05",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Săcuienii Noi h.",
					"to": "Vânători",
					"leavesAt": "09:06",
					"arrivesAt": "09:13",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Vânători",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "09:14",
					"arrivesAt": "09:21",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Sighişoara",
					"leavesAt": "09:22",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9506",
			"segments": [
				{
					"from": "Orşova",
					"to": "Şantier Naval h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:17",
					"waitsAtSource": 0,
					"distance": 1300
				},
				{
					"from": "Şantier Naval h.",
					"to": "Iloviţa h.",
					"leavesAt": "07:18",
					"arrivesAt": "07:23",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iloviţa h.",
					"to": "Vârciorova Hm.",
					"leavesAt": "07:24",
					"arrivesAt": "07:31",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Vârciorova Hm.",
					"to": "Jidoştiţa h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Jidoştiţa h.",
					"to": "Gura Văii Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:42",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Gura Văii Hm.",
					"to": "Dinamica h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dinamica h.",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "07:50",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 288
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9006",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(900)",
					"leavesAt": "08:05",
					"arrivesAt": "08:08",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "08:09",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "08:15",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Malu Mare Hm.",
					"leavesAt": "08:20",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Malu Mare Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "08:24",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Leu Hm.",
					"leavesAt": "08:28",
					"arrivesAt": "08:35",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Leu Hm.",
					"to": "Ţărţăl h.",
					"leavesAt": "08:36",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ţărţăl h.",
					"to": "Jianca",
					"leavesAt": "08:42",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Jianca",
					"to": "Radomiru hc.",
					"leavesAt": "08:47",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Radomiru hc.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "08:51",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Cezieni h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Cezieni h.",
					"to": "Caracal",
					"leavesAt": "09:03",
					"arrivesAt": "09:09",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Caracal",
					"to": "Fărcaşele Hm.",
					"leavesAt": "09:10",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Stoeneşti h.",
					"leavesAt": "09:17",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Stoeneşti h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "09:21",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Dăneasa h.",
					"leavesAt": "09:28",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Dăneasa h.",
					"to": "Radomireşti Hm.",
					"leavesAt": "09:32",
					"arrivesAt": "09:39",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "09:40",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Măldăeni Hm.",
					"leavesAt": "09:50",
					"arrivesAt": "09:59",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Măldăeni Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "10:00",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Roşiori Nord",
					"to": "Atârnaţi Hm.",
					"leavesAt": "10:18",
					"arrivesAt": "10:25",
					"waitsAtSource": 660,
					"distance": 7200
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "10:26",
					"arrivesAt": "10:34",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Vârtoapele hc.",
					"leavesAt": "10:35",
					"arrivesAt": "10:40",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Olteni",
					"leavesAt": "10:41",
					"arrivesAt": "10:50",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "10:51",
					"arrivesAt": "11:00",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Ciolpani Hm.",
					"leavesAt": "11:01",
					"arrivesAt": "11:09",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Videle",
					"leavesAt": "11:10",
					"arrivesAt": "11:19",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Videle",
					"to": "Zăvestreni Hm.",
					"leavesAt": "11:21",
					"arrivesAt": "11:26",
					"waitsAtSource": 120,
					"distance": 4800
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "11:27",
					"arrivesAt": "11:31",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "11:32",
					"arrivesAt": "11:40",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Grădinari",
					"leavesAt": "11:41",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Grădinari",
					"to": "Domneştii de Sus h.",
					"leavesAt": "11:54",
					"arrivesAt": "12:00",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Chiajna",
					"leavesAt": "12:01",
					"arrivesAt": "12:17",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Chiajna",
					"to": "Bucureştii Noi",
					"leavesAt": "12:18",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "12:22",
					"arrivesAt": "12:26",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "12:27",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9593",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Săcălaz h.",
					"leavesAt": "19:36",
					"arrivesAt": "19:46",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Săcălaz h.",
					"to": "Beregsău hcv.",
					"leavesAt": "19:47",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Beregsău hcv.",
					"to": "Cărpiniş",
					"leavesAt": "19:55",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Cărpiniş",
					"to": "Clarii Vii h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Clarii Vii h.",
					"to": "Jimbolia",
					"leavesAt": "20:11",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7588",
			"segments": [
				{
					"from": "Tecuci",
					"to": "Cosmeşti Hm.",
					"leavesAt": "15:10",
					"arrivesAt": "15:18",
					"waitsAtSource": 0,
					"distance": 7400
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "15:19",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "15:25",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4330",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Satu Mare Sud",
					"leavesAt": "23:31",
					"arrivesAt": "23:36",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Satu Mare Sud",
					"to": "Sătmărel h.",
					"leavesAt": "23:37",
					"arrivesAt": "23:43",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Sătmărel h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "23:44",
					"arrivesAt": "23:52",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Moftin h.",
					"leavesAt": "23:53",
					"arrivesAt": "23:56",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Moftin h.",
					"to": "Domăneşti h.",
					"leavesAt": "23:57",
					"arrivesAt": "00:01",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Domăneşti h.",
					"to": "Carei",
					"leavesAt": "00:02",
					"arrivesAt": "00:14",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1783",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "09:30",
					"arrivesAt": "10:31",
					"waitsAtSource": 0,
					"distance": 48100
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "10:36",
					"arrivesAt": "10:55",
					"waitsAtSource": 300,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "10:56",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "11:26",
					"arrivesAt": "11:37",
					"waitsAtSource": 360,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6504",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "06:17",
					"arrivesAt": "06:24",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Socola",
					"leavesAt": "06:25",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Socola",
					"to": "Remiza T Socola h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Remiza T Socola h.",
					"to": "Holboca Hm.",
					"leavesAt": "06:36",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Holboca Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "06:43",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8201",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Sud",
					"leavesAt": "07:50",
					"arrivesAt": "07:55",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Buzău Sud",
					"to": "Tăbărăşti h.",
					"leavesAt": "07:56",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Bentu h.",
					"leavesAt": "08:06",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bentu h.",
					"to": "Cilibia Hm.",
					"leavesAt": "08:12",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Cilibia Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Movila Oii h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "08:23",
					"arrivesAt": "08:30",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Vizireni h.",
					"leavesAt": "08:31",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vizireni h.",
					"to": "CTF Făurei h.",
					"leavesAt": "08:36",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "CTF Făurei h.",
					"to": "Făurei",
					"leavesAt": "08:40",
					"arrivesAt": "08:47",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Făurei",
					"to": "Cireşu Hm.",
					"leavesAt": "08:49",
					"arrivesAt": "09:02",
					"waitsAtSource": 120,
					"distance": 15700
				},
				{
					"from": "Cireşu Hm.",
					"to": "Scărlăteşti hc.",
					"leavesAt": "09:03",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Scărlăteşti hc.",
					"to": "Dudeşti Hm.",
					"leavesAt": "09:08",
					"arrivesAt": "09:13",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Dudeşti Hm.",
					"to": "Spicu",
					"leavesAt": "09:14",
					"arrivesAt": "09:21",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Spicu",
					"to": "Murgeanca Hm.",
					"leavesAt": "09:22",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Murgeanca Hm.",
					"to": "Ţăndărei",
					"leavesAt": "09:30",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Ţăndărei",
					"to": "Platoneşti h.",
					"leavesAt": "09:43",
					"arrivesAt": "09:51",
					"waitsAtSource": 120,
					"distance": 6000
				},
				{
					"from": "Platoneşti h.",
					"to": "Movila Hm.",
					"leavesAt": "09:52",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Movila Hm.",
					"to": "Feteşti",
					"leavesAt": "10:05",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 16700
				},
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "10:25",
					"arrivesAt": "10:32",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Cernavodă Pod",
					"leavesAt": "10:33",
					"arrivesAt": "10:48",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "10:49",
					"arrivesAt": "10:56",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "10:57",
					"arrivesAt": "11:02",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "11:03",
					"arrivesAt": "11:10",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "11:12",
					"arrivesAt": "11:17",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "11:18",
					"arrivesAt": "11:21",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "11:22",
					"arrivesAt": "11:26",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "11:27",
					"arrivesAt": "11:31",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "11:41",
					"arrivesAt": "11:44",
					"waitsAtSource": 600,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "11:45",
					"arrivesAt": "11:49",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "11:50",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "11:56",
					"arrivesAt": "12:04",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1552",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Triaj",
					"leavesAt": "06:50",
					"arrivesAt": "06:57",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Crivina",
					"leavesAt": "07:01",
					"arrivesAt": "07:17",
					"waitsAtSource": 240,
					"distance": 16900
				},
				{
					"from": "Crivina",
					"to": "Buftea",
					"leavesAt": "07:18",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 22800
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "07:35",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5460",
			"segments": [
				{
					"from": "Piatra Neamţ",
					"to": "Dumbrava h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:09",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Săvineşti h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Săvineşti h.",
					"to": "Roznov",
					"leavesAt": "05:17",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Roznov",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Podoleni Hm.",
					"leavesAt": "05:29",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Podoleni Hm.",
					"to": "Costişa h.",
					"leavesAt": "05:37",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Costişa h.",
					"to": "Buhuşi",
					"leavesAt": "05:45",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhuşi",
					"to": "Racova h.",
					"leavesAt": "05:55",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Racova h.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Gârleni Hm.",
					"leavesAt": "06:06",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gârleni Hm.",
					"to": "Hămeiuş P.M.",
					"leavesAt": "06:11",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Bacău",
					"leavesAt": "06:18",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 7900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7033",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Carpaţi h.(700)",
					"leavesAt": "07:10",
					"arrivesAt": "07:16",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Pajura Hm. (700)",
					"leavesAt": "07:17",
					"arrivesAt": "07:20",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Chitila",
					"leavesAt": "07:21",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chitila",
					"to": "Mogoşoaia",
					"leavesAt": "07:27",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Mogoşoaia",
					"to": "P.O. Aeroport h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Baloteşti Hm.",
					"leavesAt": "07:51",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Baloteşti Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "07:55",
					"arrivesAt": "08:00",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "08:01",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Greci h.",
					"leavesAt": "08:07",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Greci h.",
					"to": "Fierbinţi",
					"leavesAt": "08:13",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Fierbinţi",
					"to": "Dridu Hm.",
					"leavesAt": "08:20",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Dridu Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "08:27",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moldoveni h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "08:33",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "08:44",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3011",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Depoul Buc.Triaj h.(300)",
					"leavesAt": "20:16",
					"arrivesAt": "20:24",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Depoul Buc.Triaj h.(300)",
					"to": "Chitila",
					"leavesAt": "20:25",
					"arrivesAt": "20:28",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "20:29",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Periş",
					"leavesAt": "20:36",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 13300
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "20:47",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "20:53",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "20:58",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "21:03",
					"arrivesAt": "21:11",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Vest",
					"leavesAt": "21:12",
					"arrivesAt": "21:19",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Ploieşti Vest",
					"to": "Floreşti Prahova",
					"leavesAt": "21:21",
					"arrivesAt": "21:35",
					"waitsAtSource": 120,
					"distance": 18600
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "21:36",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "21:49",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Comarnic",
					"leavesAt": "21:55",
					"arrivesAt": "22:03",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Comarnic",
					"to": "Sinaia",
					"leavesAt": "22:12",
					"arrivesAt": "22:27",
					"waitsAtSource": 540,
					"distance": 15100
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "22:29",
					"arrivesAt": "22:34",
					"waitsAtSource": 120,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "22:35",
					"arrivesAt": "22:39",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "22:40",
					"arrivesAt": "22:45",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "22:46",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "22:58",
					"arrivesAt": "23:13",
					"waitsAtSource": 120,
					"distance": 9900
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Dârste",
					"leavesAt": "23:14",
					"arrivesAt": "23:29",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "23:30",
					"arrivesAt": "23:40",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9369",
			"segments": [
				{
					"from": "Alexandria",
					"to": "Ţigăneşti h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:32",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Ţigăneşti h.",
					"to": "Brânceni h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:36",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Brânceni h.",
					"to": "Smârdioasa h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:42",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Smârdioasa h.",
					"to": "Păuleasa h.",
					"leavesAt": "15:43",
					"arrivesAt": "15:48",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Păuleasa h.",
					"to": "Şoimu h.",
					"leavesAt": "15:49",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Şoimu h.",
					"to": "Ulmuleţ h.",
					"leavesAt": "15:55",
					"arrivesAt": "16:04",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Ulmuleţ h.",
					"to": "Zimnicea",
					"leavesAt": "16:05",
					"arrivesAt": "16:20",
					"waitsAtSource": 30,
					"distance": 9800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "472",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "17:45",
					"arrivesAt": "18:23",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Sinaia",
					"leavesAt": "18:25",
					"arrivesAt": "19:09",
					"waitsAtSource": 120,
					"distance": 62100
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "19:10",
					"arrivesAt": "19:17",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Predeal",
					"leavesAt": "19:18",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 11400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "19:33",
					"arrivesAt": "20:11",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Codlea Hm.",
					"leavesAt": "20:23",
					"arrivesAt": "20:39",
					"waitsAtSource": 720,
					"distance": 13800
				},
				{
					"from": "Codlea Hm.",
					"to": "Făgăraş",
					"leavesAt": "20:40",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 51200
				},
				{
					"from": "Făgăraş",
					"to": "Sibiu",
					"leavesAt": "21:39",
					"arrivesAt": "22:57",
					"waitsAtSource": 240,
					"distance": 83900
				},
				{
					"from": "Sibiu",
					"to": "Sebeş Alba",
					"leavesAt": "23:02",
					"arrivesAt": "00:36",
					"waitsAtSource": 300,
					"distance": 73700
				},
				{
					"from": "Sebeş Alba",
					"to": "Vinţu de Jos",
					"leavesAt": "00:37",
					"arrivesAt": "00:47",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vinţu de Jos",
					"to": "Orăştie",
					"leavesAt": "00:48",
					"arrivesAt": "01:26",
					"waitsAtSource": 60,
					"distance": 27300
				},
				{
					"from": "Orăştie",
					"to": "Simeria",
					"leavesAt": "01:30",
					"arrivesAt": "01:53",
					"waitsAtSource": 240,
					"distance": 16500
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "02:05",
					"arrivesAt": "02:16",
					"waitsAtSource": 720,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Arad",
					"leavesAt": "02:18",
					"arrivesAt": "05:06",
					"waitsAtSource": 120,
					"distance": 148200
				},
				{
					"from": "Arad",
					"to": "Curtici",
					"leavesAt": "05:11",
					"arrivesAt": "05:24",
					"waitsAtSource": 300,
					"distance": 17000
				},
				{
					"from": "Curtici",
					"to": "Lokoshaza",
					"leavesAt": "05:59",
					"arrivesAt": "06:09",
					"waitsAtSource": 2100,
					"distance": 11200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9412",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:36",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "06:37",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "06:44",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "06:53",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:10",
					"waitsAtSource": 120,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "07:11",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "07:20",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Potcoava",
					"to": "Sineşti Hm.",
					"leavesAt": "07:29",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sineşti Hm.",
					"to": "Corbu",
					"leavesAt": "07:37",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Corbu",
					"to": "Hârseşti Hm.",
					"leavesAt": "07:45",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "07:52",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stolnici Hm.",
					"to": "Fâlfani Hm.",
					"leavesAt": "07:58",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Costeşti",
					"leavesAt": "08:14",
					"arrivesAt": "08:25",
					"waitsAtSource": 360,
					"distance": 7900
				},
				{
					"from": "Costeşti",
					"to": "Suseni h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:39",
					"waitsAtSource": 540,
					"distance": 4400
				},
				{
					"from": "Suseni h.",
					"to": "Pârvu h.",
					"leavesAt": "08:40",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Pârvu h.",
					"to": "Pârvu Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:53",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Pârvu Hm.",
					"to": "Bradu de Sus",
					"leavesAt": "08:54",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bradu de Sus",
					"to": "Km. 109+000 h.",
					"leavesAt": "09:03",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Km. 109+000 h.",
					"to": "Piteşti",
					"leavesAt": "09:08",
					"arrivesAt": "09:10",
					"waitsAtSource": 30,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				},
				{
					"from": "18991230",
					"to": "20171225",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2853",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "06:05",
					"arrivesAt": "06:09",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "06:10",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "06:14",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "06:19",
					"arrivesAt": "06:22",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "06:37",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "06:47",
					"arrivesAt": "06:52",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Ioneşti Gorj h.",
					"leavesAt": "06:54",
					"arrivesAt": "07:07",
					"waitsAtSource": 120,
					"distance": 11500
				},
				{
					"from": "Ioneşti Gorj h.",
					"to": "Km. 9+820 h.",
					"leavesAt": "07:08",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Km. 9+820 h.",
					"to": "Termo Turceni h.",
					"leavesAt": "07:13",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Termo Turceni h.",
					"to": "Turceni",
					"leavesAt": "07:19",
					"arrivesAt": "07:22",
					"waitsAtSource": 120,
					"distance": 900
				},
				{
					"from": "Turceni",
					"to": "Gârbovu h.",
					"leavesAt": "07:24",
					"arrivesAt": "07:29",
					"waitsAtSource": 120,
					"distance": 6600
				},
				{
					"from": "Gârbovu h.",
					"to": "Sărdăneşti h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:35",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Plopşoru",
					"leavesAt": "07:36",
					"arrivesAt": "07:41",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Plopşoru",
					"to": "Peşteana Jiu h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Bâlteni h.",
					"leavesAt": "07:49",
					"arrivesAt": "07:52",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bâlteni h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "07:53",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Rovinari Sud h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Rovinari Hm.",
					"leavesAt": "08:05",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rovinari Hm.",
					"to": "Km. 49+800 h.",
					"leavesAt": "08:11",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rogojelu",
					"leavesAt": "08:14",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Rogojelu",
					"to": "Vârţ h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Vârţ h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "08:22",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Drăguţeşti h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Amaradia",
					"leavesAt": "08:37",
					"arrivesAt": "08:41",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Amaradia",
					"to": "Târgu Jiu",
					"leavesAt": "08:42",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2075",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Găneasa h.",
					"leavesAt": "12:42",
					"arrivesAt": "12:46",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Găneasa h.",
					"to": "Găneasa Olt h.",
					"leavesAt": "12:47",
					"arrivesAt": "12:50",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Găneasa Olt h.",
					"to": "Arceşti Hm.",
					"leavesAt": "12:51",
					"arrivesAt": "12:56",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Arceşti Hm.",
					"to": "Colibaşi h.",
					"leavesAt": "12:57",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Colibaşi h.",
					"to": "Strejeşti",
					"leavesAt": "13:04",
					"arrivesAt": "13:10",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Strejeşti",
					"to": "Zlătărei Hm.",
					"leavesAt": "13:11",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Drăgăşani",
					"leavesAt": "13:18",
					"arrivesAt": "13:26",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Drăgăşani",
					"to": "Călina h.",
					"leavesAt": "13:27",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Călina h.",
					"to": "Zăvideni Hm.",
					"leavesAt": "13:34",
					"arrivesAt": "13:39",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "13:40",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Orleşti hc.",
					"to": "Fişcălia Hm.",
					"leavesAt": "13:46",
					"arrivesAt": "13:49",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "13:50",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Ioneşti Hm.",
					"leavesAt": "13:54",
					"arrivesAt": "13:58",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Slăviteşti hc.",
					"leavesAt": "14:05",
					"arrivesAt": "14:11",
					"waitsAtSource": 420,
					"distance": 6400
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Băbeni",
					"leavesAt": "14:12",
					"arrivesAt": "14:20",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Băbeni",
					"to": "Tătărani h.",
					"leavesAt": "14:21",
					"arrivesAt": "14:24",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Tătărani h.",
					"to": "Govora",
					"leavesAt": "14:25",
					"arrivesAt": "14:33",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Govora",
					"to": "Râureni hc.",
					"leavesAt": "14:34",
					"arrivesAt": "14:37",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Râureni hc.",
					"to": "Râureni",
					"leavesAt": "14:38",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni",
					"to": "Răstoaca h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:54",
					"waitsAtSource": 420,
					"distance": 1400
				},
				{
					"from": "Răstoaca h.",
					"to": "Ostroveni h.",
					"leavesAt": "14:55",
					"arrivesAt": "14:59",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ostroveni h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "15:00",
					"arrivesAt": "15:02",
					"waitsAtSource": 30,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4503",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "05:00",
					"arrivesAt": "05:08",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Racu h.",
					"leavesAt": "05:12",
					"arrivesAt": "05:15",
					"waitsAtSource": 240,
					"distance": 2200
				},
				{
					"from": "Racu h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "05:16",
					"arrivesAt": "05:23",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Dăneşti h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dăneşti h.",
					"to": "Cârţani h.",
					"leavesAt": "05:29",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cârţani h.",
					"to": "Tomeşti h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:36",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Izvoru Oltului",
					"leavesAt": "05:37",
					"arrivesAt": "05:42",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Izvoru Oltului",
					"to": "Sândominic h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:54",
					"waitsAtSource": 420,
					"distance": 3100
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "05:55",
					"arrivesAt": "06:04",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "06:06",
					"arrivesAt": "06:17",
					"waitsAtSource": 120,
					"distance": 10100
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Şugău h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şugău h.",
					"to": "Valea Strâmbă h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Gheorgheni",
					"leavesAt": "06:26",
					"arrivesAt": "06:30",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Gheorgheni",
					"to": "Lăzarea Hm.",
					"leavesAt": "06:35",
					"arrivesAt": "06:40",
					"waitsAtSource": 300,
					"distance": 4400
				},
				{
					"from": "Lăzarea Hm.",
					"to": "Ditrău",
					"leavesAt": "06:41",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ditrău",
					"to": "Subcetate Mureş Hm.",
					"leavesAt": "06:48",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Subcetate Mureş Hm.",
					"to": "Sărmaş Runc h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:12",
					"waitsAtSource": 480,
					"distance": 3400
				},
				{
					"from": "Sărmaş Runc h.",
					"to": "Gălăuţaş Hm.",
					"leavesAt": "07:13",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Gălăuţaş Hm.",
					"to": "Topliţa",
					"leavesAt": "07:28",
					"arrivesAt": "07:36",
					"waitsAtSource": 420,
					"distance": 6000
				},
				{
					"from": "Topliţa",
					"to": "Ciobotani h.",
					"leavesAt": "07:38",
					"arrivesAt": "07:47",
					"waitsAtSource": 120,
					"distance": 6600
				},
				{
					"from": "Ciobotani h.",
					"to": "Stânceni Hm.",
					"leavesAt": "07:48",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Stânceni Hm.",
					"to": "Stânceni h.",
					"leavesAt": "07:55",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Stânceni h.",
					"to": "Stânceni Neagra h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Stânceni Neagra h.",
					"to": "Lunca Bradului Hm.",
					"leavesAt": "08:09",
					"arrivesAt": "08:17",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Lunca Bradului Hm.",
					"to": "Andreneasa h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Andreneasa h.",
					"to": "Răstoliţa Hm.",
					"leavesAt": "08:29",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Răstoliţa Hm.",
					"to": "Borzia h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Borzia h.",
					"to": "Deda Bistra Hm.",
					"leavesAt": "08:44",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Deda Bistra Hm.",
					"to": "Deda",
					"leavesAt": "08:56",
					"arrivesAt": "09:06",
					"waitsAtSource": 420,
					"distance": 3900
				},
				{
					"from": "Deda",
					"to": "Ruşii Munţi h.",
					"leavesAt": "09:21",
					"arrivesAt": "09:26",
					"waitsAtSource": 900,
					"distance": 4500
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "09:27",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Halta Aluniş h.",
					"leavesAt": "09:30",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "09:35",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Ideciu de Jos h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:44",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Reghin",
					"leavesAt": "09:45",
					"arrivesAt": "09:54",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Reghin",
					"to": "Petelea h.",
					"leavesAt": "09:55",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Petelea h.",
					"to": "Periş Mureş h.",
					"leavesAt": "10:03",
					"arrivesAt": "10:08",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Periş Mureş h.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "10:09",
					"arrivesAt": "10:14",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "10:15",
					"arrivesAt": "10:20",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "10:21",
					"arrivesAt": "10:33",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Târgu Mureş",
					"leavesAt": "10:34",
					"arrivesAt": "10:42",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7586",
			"segments": [
				{
					"from": "Tecuci",
					"to": "Cosmeşti Hm.",
					"leavesAt": "13:54",
					"arrivesAt": "14:01",
					"waitsAtSource": 0,
					"distance": 7400
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "14:02",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "14:09",
					"arrivesAt": "14:20",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9373",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "19:45",
					"arrivesAt": "19:50",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Peret hc.",
					"leavesAt": "19:59",
					"arrivesAt": "20:13",
					"waitsAtSource": 540,
					"distance": 10400
				},
				{
					"from": "Peret hc.",
					"to": "Plosca Hm.",
					"leavesAt": "20:14",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Plosca Hm.",
					"to": "Buzescu h.",
					"leavesAt": "20:24",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzescu h.",
					"to": "Alexandria Nord h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:45",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Alexandria",
					"leavesAt": "20:46",
					"arrivesAt": "20:52",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9589",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Săcălaz h.",
					"leavesAt": "13:40",
					"arrivesAt": "13:50",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Săcălaz h.",
					"to": "Beregsău hcv.",
					"leavesAt": "13:51",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Beregsău hcv.",
					"to": "Cărpiniş",
					"leavesAt": "13:59",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Cărpiniş",
					"to": "Clarii Vii h.",
					"leavesAt": "14:07",
					"arrivesAt": "14:14",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Clarii Vii h.",
					"to": "Jimbolia",
					"leavesAt": "14:15",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4654",
			"segments": [
				{
					"from": "Sighetu Marmaţiei",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "23:40",
					"arrivesAt": "23:45",
					"waitsAtSource": 0,
					"distance": 1900
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Tisa h.",
					"leavesAt": "23:46",
					"arrivesAt": "23:53",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tisa h.",
					"to": "Crăciuneşti h.",
					"leavesAt": "23:54",
					"arrivesAt": "23:57",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "23:58",
					"arrivesAt": "00:04",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Lunca la Tisa h.",
					"leavesAt": "00:05",
					"arrivesAt": "00:09",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Valea Vişeului",
					"leavesAt": "00:10",
					"arrivesAt": "00:28",
					"waitsAtSource": 30,
					"distance": 10700
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 863
				},
				{
					"from": "20180125",
					"to": "20180407",
					"daysOfWeek": 863
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 863
				},
				{
					"from": "20180502",
					"to": "20180526",
					"daysOfWeek": 863
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 863
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 863
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 863
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 863
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 863
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 863
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9137",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(913)",
					"leavesAt": "17:00",
					"arrivesAt": "17:03",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(913)",
					"to": "Jiu Hm.",
					"leavesAt": "17:04",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Jiu Hm.",
					"to": "R. 1 Jiu",
					"leavesAt": "17:10",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "R. 1 Jiu",
					"to": "Podari",
					"leavesAt": "17:14",
					"arrivesAt": "17:21",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Podari",
					"to": "Sălcuţa Hm.",
					"leavesAt": "17:22",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Sălcuţa Hm.",
					"to": "Dealul Robului h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dealul Robului h.",
					"to": "Segarcea Nord hc.",
					"leavesAt": "17:43",
					"arrivesAt": "17:50",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Segarcea Nord hc.",
					"to": "Segarcea",
					"leavesAt": "17:51",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Segarcea",
					"to": "Cerăt h.",
					"leavesAt": "17:55",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cerăt h.",
					"to": "Portăreşti Hm.",
					"leavesAt": "18:02",
					"arrivesAt": "18:10",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Portăreşti Hm.",
					"to": "Urzica Mare h.",
					"leavesAt": "18:11",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Urzica Mare h.",
					"to": "Afumaţi h.",
					"leavesAt": "18:17",
					"arrivesAt": "18:29",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Afumaţi h.",
					"to": "Siliştea Crucii h.",
					"leavesAt": "18:30",
					"arrivesAt": "18:38",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Siliştea Crucii h.",
					"to": "Boureni P.M.",
					"leavesAt": "18:39",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Boureni P.M.",
					"to": "Băileşti",
					"leavesAt": "18:44",
					"arrivesAt": "18:57",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Băileşti",
					"to": "Moţăţei Hm.",
					"leavesAt": "18:58",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 12800
				},
				{
					"from": "Moţăţei Hm.",
					"to": "Maglavit h.",
					"leavesAt": "19:21",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Maglavit h.",
					"to": "Golenţi Hm.",
					"leavesAt": "19:36",
					"arrivesAt": "19:51",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Golenţi Hm.",
					"to": "Calafat",
					"leavesAt": "19:52",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 11800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1654",
			"segments": [
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Vatra Dornei",
					"leavesAt": "21:48",
					"arrivesAt": "21:51",
					"waitsAtSource": 0,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei",
					"to": "Iacobeni",
					"leavesAt": "21:54",
					"arrivesAt": "22:09",
					"waitsAtSource": 180,
					"distance": 10200
				},
				{
					"from": "Iacobeni",
					"to": "Mestecăniş",
					"leavesAt": "22:10",
					"arrivesAt": "22:21",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Pojorâta Hm.",
					"leavesAt": "22:22",
					"arrivesAt": "22:43",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "22:44",
					"arrivesAt": "22:53",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "22:54",
					"arrivesAt": "23:01",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Vama",
					"leavesAt": "23:02",
					"arrivesAt": "23:16",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Vama",
					"to": "Frasin",
					"leavesAt": "23:17",
					"arrivesAt": "23:28",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "23:29",
					"arrivesAt": "23:37",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Suceava",
					"leavesAt": "23:38",
					"arrivesAt": "00:22",
					"waitsAtSource": 60,
					"distance": 46800
				},
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "00:36",
					"arrivesAt": "00:49",
					"waitsAtSource": 840,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "00:50",
					"arrivesAt": "01:08",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "01:09",
					"arrivesAt": "01:25",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Roman",
					"leavesAt": "01:27",
					"arrivesAt": "01:54",
					"waitsAtSource": 120,
					"distance": 40200
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "01:56",
					"arrivesAt": "02:25",
					"waitsAtSource": 120,
					"distance": 43800
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "02:37",
					"arrivesAt": "03:16",
					"waitsAtSource": 720,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "03:17",
					"arrivesAt": "03:44",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "03:48",
					"arrivesAt": "04:09",
					"waitsAtSource": 240,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "04:10",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "04:48",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "05:21",
					"arrivesAt": "05:54",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "05:56",
					"arrivesAt": "06:32",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "06:35",
					"arrivesAt": "07:28",
					"waitsAtSource": 180,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8657",
			"segments": [
				{
					"from": "Medgidia",
					"to": "Nicolae Bălcescu",
					"leavesAt": "16:45",
					"arrivesAt": "17:06",
					"waitsAtSource": 0,
					"distance": 19100
				},
				{
					"from": "Nicolae Bălcescu",
					"to": "Ram. M.K.P. Aj. M.",
					"leavesAt": "17:07",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ram. M.K.P. Aj. M.",
					"to": "Târguşor Dobrogea Hm.",
					"leavesAt": "17:14",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Târguşor Dobrogea Hm.",
					"to": "Cogealac",
					"leavesAt": "17:25",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Cogealac",
					"to": "Mihai Viteazu Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 17400
				},
				{
					"from": "Mihai Viteazu Hm.",
					"to": "Baia Dobrogea",
					"leavesAt": "18:06",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Baia Dobrogea",
					"to": "Ceamurlia de Jos h.",
					"leavesAt": "18:18",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ceamurlia de Jos h.",
					"to": "Babadag",
					"leavesAt": "18:25",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Babadag",
					"to": "Zebil h.",
					"leavesAt": "18:43",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Zebil h.",
					"to": "Mihail Kogălniceanu h.",
					"leavesAt": "19:00",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Mihail Kogălniceanu h.",
					"to": "Cataloi Hm.",
					"leavesAt": "19:15",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Cataloi Hm.",
					"to": "Tulcea Mărfuri",
					"leavesAt": "19:30",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Tulcea Mărfuri",
					"to": "Tulcea Oraş",
					"leavesAt": "19:44",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20180610",
					"to": "20180910",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1699",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Recaş",
					"leavesAt": "16:23",
					"arrivesAt": "16:51",
					"waitsAtSource": 0,
					"distance": 23200
				},
				{
					"from": "Recaş",
					"to": "Lugoj",
					"leavesAt": "16:52",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 35700
				},
				{
					"from": "Lugoj",
					"to": "Caransebeş",
					"leavesAt": "17:19",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 39400
				},
				{
					"from": "Caransebeş",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "18:18",
					"arrivesAt": "18:31",
					"waitsAtSource": 1380,
					"distance": 10400
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Reşiţa Nord",
					"leavesAt": "18:32",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 29000
				},
				{
					"from": "Reşiţa Nord",
					"to": "Reşiţa Sud Hm.",
					"leavesAt": "19:10",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9445",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "12:15",
					"arrivesAt": "12:17",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "12:18",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Aninoasa Hm.",
					"leavesAt": "12:21",
					"arrivesAt": "12:24",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Aninoasa Hm.",
					"to": "Săteni h.",
					"leavesAt": "12:25",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Săteni h.",
					"to": "Doiceşti",
					"leavesAt": "12:28",
					"arrivesAt": "12:31",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Doiceşti",
					"to": "Doiceşti h.",
					"leavesAt": "12:32",
					"arrivesAt": "12:33",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Doiceşti h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "12:34",
					"arrivesAt": "12:37",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Scârlenţa h.",
					"leavesAt": "12:38",
					"arrivesAt": "12:40",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Scârlenţa h.",
					"to": "Trainica h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:43",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Trainica h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "12:44",
					"arrivesAt": "12:48",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Moţăieni h.",
					"leavesAt": "12:49",
					"arrivesAt": "12:52",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Moţăieni h.",
					"to": "Fieni",
					"leavesAt": "12:53",
					"arrivesAt": "12:58",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "12:59",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Pietroşiţa Hm.",
					"leavesAt": "13:03",
					"arrivesAt": "13:10",
					"waitsAtSource": 30,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9669",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "19:01",
					"arrivesAt": "19:11",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara C.E.T.",
					"leavesAt": "19:12",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişeni Hm.",
					"leavesAt": "19:16",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişeni Hm.",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "19:24",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Jebel",
					"leavesAt": "19:32",
					"arrivesAt": "19:38",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Jebel",
					"to": "Voiteni",
					"leavesAt": "19:39",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Voiteni",
					"to": "Deta Hm.",
					"leavesAt": "19:52",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Deta Hm.",
					"to": "Denta h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Denta h.",
					"to": "Stamora Moraviţa",
					"leavesAt": "20:08",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 8400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1535",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Aghireş",
					"leavesAt": "20:30",
					"arrivesAt": "20:56",
					"waitsAtSource": 0,
					"distance": 27900
				},
				{
					"from": "Aghireş",
					"to": "Huedin",
					"leavesAt": "20:57",
					"arrivesAt": "21:21",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Huedin",
					"to": "Ciucea Hm.",
					"leavesAt": "21:22",
					"arrivesAt": "21:43",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Ciucea Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "21:50",
					"arrivesAt": "22:00",
					"waitsAtSource": 420,
					"distance": 10800
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bratca",
					"leavesAt": "22:01",
					"arrivesAt": "22:11",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bratca",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "22:23",
					"arrivesAt": "22:30",
					"waitsAtSource": 720,
					"distance": 6300
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Aleşd",
					"leavesAt": "22:31",
					"arrivesAt": "22:50",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Aleşd",
					"to": "Tileagd",
					"leavesAt": "22:51",
					"arrivesAt": "23:02",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Tileagd",
					"to": "Oradea",
					"leavesAt": "23:03",
					"arrivesAt": "23:24",
					"waitsAtSource": 60,
					"distance": 23100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4134",
			"segments": [
				{
					"from": "Sighetu Marmaţiei",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "15:40",
					"arrivesAt": "15:45",
					"waitsAtSource": 0,
					"distance": 1900
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Tisa h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tisa h.",
					"to": "Crăciuneşti h.",
					"leavesAt": "15:55",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Lunca la Tisa h.",
					"leavesAt": "16:06",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Valea Vişeului",
					"leavesAt": "16:12",
					"arrivesAt": "16:30",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Valea Vişeului",
					"to": "Vişeu Bistra h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:59",
					"waitsAtSource": 900,
					"distance": 8500
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Petrova hc.",
					"leavesAt": "17:00",
					"arrivesAt": "17:09",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Petrova hc.",
					"to": "Leordina",
					"leavesAt": "17:10",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Leordina",
					"to": "Leordina h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Leordina h.",
					"to": "Bocicoel h.",
					"leavesAt": "17:28",
					"arrivesAt": "17:36",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Bocicoel h.",
					"to": "Vişeu de Jos",
					"leavesAt": "17:37",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Vişeu de Jos",
					"to": "Iza P.M.",
					"leavesAt": "17:44",
					"arrivesAt": "17:56",
					"waitsAtSource": 120,
					"distance": 8600
				},
				{
					"from": "Iza P.M.",
					"to": "Săcel Hm.",
					"leavesAt": "17:57",
					"arrivesAt": "18:07",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săcel Hm.",
					"to": "Dealu Ştefăniţei",
					"leavesAt": "18:08",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dealu Ştefăniţei",
					"to": "Romuli h.",
					"leavesAt": "18:20",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Romuli h.",
					"to": "Fiad Hm.",
					"leavesAt": "18:30",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Fiad Hm.",
					"to": "Telciu Hm.",
					"leavesAt": "18:41",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Telciu Hm.",
					"to": "Coşbuc Hm.",
					"leavesAt": "18:56",
					"arrivesAt": "19:05",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Coşbuc Hm.",
					"to": "Salva",
					"leavesAt": "19:06",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Salva",
					"to": "Nimigea Hm.",
					"leavesAt": "19:23",
					"arrivesAt": "19:32",
					"waitsAtSource": 180,
					"distance": 7300
				},
				{
					"from": "Nimigea Hm.",
					"to": "Nimigea h.",
					"leavesAt": "19:33",
					"arrivesAt": "19:37",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Nimigea h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "19:38",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Cociu h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:48",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cociu h.",
					"to": "Beclean pe Someş",
					"leavesAt": "19:49",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Beclean pe Someş",
					"to": "Ciceu Cristur h.",
					"leavesAt": "20:00",
					"arrivesAt": "20:13",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "20:14",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Dej Triaj",
					"leavesAt": "20:23",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "20:34",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "20:43",
					"arrivesAt": "21:02",
					"waitsAtSource": 120,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Iclod Hm.",
					"leavesAt": "21:03",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Iclod Hm.",
					"to": "Bonţida Hm.",
					"leavesAt": "21:16",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Bonţida Hm.",
					"to": "Apahida",
					"leavesAt": "21:25",
					"arrivesAt": "21:43",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Apahida",
					"to": "Cluj Napoca Est",
					"leavesAt": "21:44",
					"arrivesAt": "21:52",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "21:53",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "21:59",
					"arrivesAt": "22:03",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1597",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "19:45",
					"arrivesAt": "20:36",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Gălăteni Hm.",
					"leavesAt": "20:37",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 15800
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "20:52",
					"arrivesAt": "21:25",
					"waitsAtSource": 60,
					"distance": 33400
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "21:27",
					"arrivesAt": "21:58",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "21:59",
					"arrivesAt": "22:17",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "22:18",
					"arrivesAt": "22:58",
					"waitsAtSource": 60,
					"distance": 53600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4704",
			"segments": [
				{
					"from": "Salva",
					"to": "Năsăud h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:09",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Năsăud h.",
					"to": "Năsăud",
					"leavesAt": "18:10",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Năsăud",
					"to": "Rebrişoara Hm.",
					"leavesAt": "18:14",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Nepos h.",
					"leavesAt": "18:20",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Nepos h.",
					"to": "Feldru Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Feldru Hm.",
					"to": "Podereia Feldrului h.",
					"leavesAt": "18:34",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Ilva Mică",
					"leavesAt": "18:38",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5053",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "13:46",
					"arrivesAt": "13:52",
					"waitsAtSource": 0,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "13:53",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Muru hc.",
					"leavesAt": "14:02",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "14:06",
					"arrivesAt": "14:09",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "14:10",
					"arrivesAt": "14:15",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "14:16",
					"arrivesAt": "14:21",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "14:22",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "14:50",
					"arrivesAt": "14:57",
					"waitsAtSource": 540,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "14:58",
					"arrivesAt": "15:03",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "15:04",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "15:09",
					"arrivesAt": "15:21",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "15:23",
					"arrivesAt": "15:33",
					"waitsAtSource": 120,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "15:45",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "16:07",
					"arrivesAt": "16:14",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "16:15",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "16:23",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "16:32",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "16:44",
					"arrivesAt": "16:57",
					"waitsAtSource": 120,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "16:58",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 8000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2594",
			"segments": [
				{
					"from": "Copşa Mică",
					"to": "Axente Sever h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:01",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Axente Sever h.",
					"to": "Agârbiciu h.",
					"leavesAt": "16:02",
					"arrivesAt": "16:08",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Agârbiciu h.",
					"to": "Şeica Mare",
					"leavesAt": "16:09",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şeica Mare",
					"to": "Şeica Mare h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Şeica Mare h.",
					"to": "Hăşag h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:29",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Hăşag h.",
					"to": "Loamneş Hm.",
					"leavesAt": "16:30",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Loamneş Hm.",
					"to": "Mândra h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mândra h.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "16:50",
					"arrivesAt": "16:57",
					"waitsAtSource": 120,
					"distance": 2100
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Sibiu h.(203)",
					"leavesAt": "16:58",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Sibiu",
					"leavesAt": "17:08",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180107",
					"daysOfWeek": 799
				},
				{
					"from": "20180114",
					"to": "20180203",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180616",
					"daysOfWeek": 799
				},
				{
					"from": "20180618",
					"to": "20180624",
					"daysOfWeek": 799
				},
				{
					"from": "20180806",
					"to": "20180806",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180909",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				},
				{
					"from": "18991230",
					"to": "20180617",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1668",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "23:08",
					"arrivesAt": "23:14",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Bârnova Hm.",
					"leavesAt": "23:16",
					"arrivesAt": "23:38",
					"waitsAtSource": 120,
					"distance": 16300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Buhăieşti",
					"leavesAt": "23:39",
					"arrivesAt": "00:01",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Buhăieşti",
					"to": "Vaslui",
					"leavesAt": "00:02",
					"arrivesAt": "00:20",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Vaslui",
					"to": "Crasna",
					"leavesAt": "00:30",
					"arrivesAt": "00:44",
					"waitsAtSource": 600,
					"distance": 15500
				},
				{
					"from": "Crasna",
					"to": "Bârlad",
					"leavesAt": "00:45",
					"arrivesAt": "01:18",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Bârlad",
					"to": "Tecuci",
					"leavesAt": "01:22",
					"arrivesAt": "02:07",
					"waitsAtSource": 240,
					"distance": 50300
				},
				{
					"from": "Tecuci",
					"to": "Focşani",
					"leavesAt": "02:20",
					"arrivesAt": "03:07",
					"waitsAtSource": 780,
					"distance": 36500
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "03:09",
					"arrivesAt": "03:46",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "03:47",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "04:20",
					"arrivesAt": "04:53",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "04:55",
					"arrivesAt": "05:31",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "05:34",
					"arrivesAt": "06:28",
					"waitsAtSource": 180,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9609",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Buziaş",
					"leavesAt": "04:16",
					"arrivesAt": "04:56",
					"waitsAtSource": 0,
					"distance": 36400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2045",
			"segments": [
				{
					"from": "Simeria",
					"to": "Săuleşti h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:46",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Săuleşti h.",
					"to": "Deva",
					"leavesAt": "15:47",
					"arrivesAt": "15:53",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "15:54",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Mintia h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Veţel h.",
					"leavesAt": "16:07",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Veţel h.",
					"to": "Brănişca Hm.",
					"leavesAt": "16:10",
					"arrivesAt": "16:14",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Ilia",
					"leavesAt": "16:21",
					"arrivesAt": "16:28",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Ilia",
					"to": "Gurasada Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Gurasada Hm.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "16:37",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Burjuc h.",
					"leavesAt": "16:44",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Burjuc h.",
					"to": "Zam",
					"leavesAt": "16:49",
					"arrivesAt": "17:00",
					"waitsAtSource": 30,
					"distance": 8500
				},
				{
					"from": "Zam",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Ilteu",
					"leavesAt": "17:06",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ilteu",
					"to": "Toc h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Toc h.",
					"to": "Săvârşin",
					"leavesAt": "17:17",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Săvârşin",
					"to": "Vărădia h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vărădia h.",
					"to": "Vărădia Hm.",
					"leavesAt": "17:32",
					"arrivesAt": "17:37",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărădia Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:50",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Căpruţa h.",
					"leavesAt": "17:51",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Căpruţa h.",
					"to": "Bârzava",
					"leavesAt": "17:55",
					"arrivesAt": "18:00",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Bârzava",
					"to": "Nadăş h.",
					"leavesAt": "18:01",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Nadăş h.",
					"to": "Conop Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Conop Hm.",
					"to": "Corfeni h.",
					"leavesAt": "18:14",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Corfeni h.",
					"to": "Milova",
					"leavesAt": "18:18",
					"arrivesAt": "18:23",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Milova",
					"to": "Radna",
					"leavesAt": "18:24",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Radna",
					"to": "Păuliş Hm.",
					"leavesAt": "18:35",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Păuliş Hm.",
					"to": "Păuliş h.",
					"leavesAt": "18:45",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş h.",
					"to": "Ghioroc",
					"leavesAt": "18:50",
					"arrivesAt": "18:57",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ghioroc",
					"to": "Glogovăţ",
					"leavesAt": "19:01",
					"arrivesAt": "19:13",
					"waitsAtSource": 240,
					"distance": 14200
				},
				{
					"from": "Glogovăţ",
					"to": "Arad",
					"leavesAt": "19:14",
					"arrivesAt": "19:22",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5563",
			"segments": [
				{
					"from": "Botoşani",
					"to": "Leorda Hm.",
					"leavesAt": "08:43",
					"arrivesAt": "09:07",
					"waitsAtSource": 0,
					"distance": 15500
				},
				{
					"from": "Leorda Hm.",
					"to": "Bucecea Hm",
					"leavesAt": "09:08",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bucecea Hm",
					"to": "Bursuceni h.",
					"leavesAt": "09:28",
					"arrivesAt": "09:43",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Bursuceni h.",
					"to": "Vereşti",
					"leavesAt": "09:44",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "09:57",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "10:05",
					"arrivesAt": "10:15",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "10:16",
					"arrivesAt": "10:22",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5406",
			"segments": [
				{
					"from": "Bacău",
					"to": "Letea h.",
					"leavesAt": "20:57",
					"arrivesAt": "21:03",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Letea h.",
					"to": "Valea Seacă",
					"leavesAt": "21:04",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Seacă",
					"to": "Siretu Bacău h.",
					"leavesAt": "21:10",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Faraoani Hm.",
					"leavesAt": "21:15",
					"arrivesAt": "21:20",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Faraoani Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "21:21",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Răcăciuni h.",
					"to": "Orbeni Hm.",
					"leavesAt": "21:28",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Orbeni Hm.",
					"to": "Sascut Hm.",
					"leavesAt": "21:40",
					"arrivesAt": "21:47",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Sascut Hm.",
					"to": "Şişcani h.",
					"leavesAt": "21:48",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Şişcani h.",
					"to": "Adjudu Vechi h.",
					"leavesAt": "21:55",
					"arrivesAt": "21:59",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Adjud",
					"leavesAt": "22:00",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "22:06",
					"arrivesAt": "22:14",
					"waitsAtSource": 120,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "22:15",
					"arrivesAt": "22:19",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "22:20",
					"arrivesAt": "22:25",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "22:26",
					"arrivesAt": "22:30",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "22:31",
					"arrivesAt": "22:41",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5112",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:49",
					"waitsAtSource": 0,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "16:50",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Focşani",
					"to": "Coteşti Hm.",
					"leavesAt": "17:09",
					"arrivesAt": "17:18",
					"waitsAtSource": 120,
					"distance": 7900
				},
				{
					"from": "Coteşti Hm.",
					"to": "Gugeşti",
					"leavesAt": "17:19",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Gugeşti",
					"to": "Sihlea Hm.",
					"leavesAt": "17:29",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sihlea Hm.",
					"to": "Voetin h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Voetin h.",
					"to": "Râmnicu Sărat",
					"leavesAt": "17:46",
					"arrivesAt": "17:56",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Zoita Hm.",
					"leavesAt": "17:57",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Zoita Hm.",
					"to": "Boboc Hm.",
					"leavesAt": "18:09",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Boboc Hm.",
					"to": "Buzău",
					"leavesAt": "18:20",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 11500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9389",
			"segments": [
				{
					"from": "Caracal",
					"to": "Cezieni h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:45",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Cezieni h.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Radomiru hc.",
					"leavesAt": "16:53",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Radomiru hc.",
					"to": "Jianca",
					"leavesAt": "16:59",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Jianca",
					"to": "Ţărţăl h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţărţăl h.",
					"to": "Leu Hm.",
					"leavesAt": "17:07",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Leu Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "17:13",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Malu Mare Hm.",
					"leavesAt": "17:23",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Malu Mare Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "17:30",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Bordei hc.(900)",
					"leavesAt": "17:35",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Craiova",
					"leavesAt": "17:40",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5570",
			"segments": [
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "06:23",
					"arrivesAt": "06:32",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "06:33",
					"arrivesAt": "06:41",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Bursuceni h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:53",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Bursuceni h.",
					"to": "Bucecea Hm",
					"leavesAt": "06:54",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Bucecea Hm",
					"to": "Leorda Hm.",
					"leavesAt": "07:12",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Leorda Hm.",
					"to": "Botoşani",
					"leavesAt": "07:32",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 15500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9501",
			"segments": [
				{
					"from": "Filiaşi",
					"to": "Gura Motrului Hm.",
					"leavesAt": "04:22",
					"arrivesAt": "04:30",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Butoieşti Hm.",
					"leavesAt": "04:31",
					"arrivesAt": "04:37",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Lunca Banului h.",
					"leavesAt": "04:38",
					"arrivesAt": "04:44",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lunca Banului h.",
					"to": "Strehaia",
					"leavesAt": "04:45",
					"arrivesAt": "04:50",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Strehaia",
					"to": "Strehaia hc.",
					"leavesAt": "04:51",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Strehaia hc.",
					"to": "Ciochiuţa Hm.",
					"leavesAt": "04:55",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Ciochiuţa Hm.",
					"to": "Tâmna",
					"leavesAt": "05:04",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Tâmna",
					"to": "Igiroasa Hm.",
					"leavesAt": "05:13",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Igiroasa Hm.",
					"to": "Prunişor Hm.",
					"leavesAt": "05:19",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prunişor Hm.",
					"to": "Gârniţa Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:33",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Gârniţa Hm.",
					"to": "Balota",
					"leavesAt": "05:34",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Balota",
					"to": "Valea Albă Hm.",
					"leavesAt": "05:39",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Valea Albă Hm.",
					"to": "Ergheviţa h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ergheviţa h.",
					"to": "Drobeta Tr. Severin Mf.",
					"leavesAt": "05:57",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Drobeta Tr. Severin Mf.",
					"to": "Drobeta Tr.Sev Est Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Drobeta Tr.Sev Est Hm.",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "06:14",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Dinamica h.",
					"leavesAt": "06:20",
					"arrivesAt": "06:22",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Dinamica h.",
					"to": "Gura Văii Hm.",
					"leavesAt": "06:23",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Gura Văii Hm.",
					"to": "Jidoştiţa h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Jidoştiţa h.",
					"to": "Vârciorova Hm.",
					"leavesAt": "06:34",
					"arrivesAt": "06:40",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Vârciorova Hm.",
					"to": "Iloviţa h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Iloviţa h.",
					"to": "Şantier Naval h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Şantier Naval h.",
					"to": "Orşova",
					"leavesAt": "06:51",
					"arrivesAt": "06:57",
					"waitsAtSource": 30,
					"distance": 1300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1589",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ciulniţa",
					"leavesAt": "17:00",
					"arrivesAt": "17:55",
					"waitsAtSource": 0,
					"distance": 108900
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "17:56",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "18:20",
					"arrivesAt": "18:38",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "18:39",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "18:56",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 34600
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180523",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5001",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Depoul Buc.Triaj h.(300)",
					"leavesAt": "04:50",
					"arrivesAt": "04:58",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Depoul Buc.Triaj h.(300)",
					"to": "Chitila",
					"leavesAt": "04:59",
					"arrivesAt": "05:02",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "05:03",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "05:14",
					"arrivesAt": "05:21",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "05:22",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "05:27",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "05:37",
					"arrivesAt": "05:45",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "05:49",
					"arrivesAt": "06:02",
					"waitsAtSource": 240,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "06:05",
					"arrivesAt": "06:10",
					"waitsAtSource": 180,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "06:11",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Muru hc.",
					"leavesAt": "06:21",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:28",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "06:29",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "06:34",
					"arrivesAt": "06:39",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "06:40",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "06:48",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "07:07",
					"arrivesAt": "07:14",
					"waitsAtSource": 540,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "07:15",
					"arrivesAt": "07:20",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "07:21",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "07:26",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8592",
			"segments": [
				{
					"from": "Călăraşi Sud",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "07:36",
					"arrivesAt": "07:43",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Ştefan Vodă h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Ciulniţa",
					"leavesAt": "07:52",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 12600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5412",
			"segments": [
				{
					"from": "Bacău",
					"to": "Letea h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:46",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Letea h.",
					"to": "Valea Seacă",
					"leavesAt": "06:47",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Seacă",
					"to": "Siretu Bacău h.",
					"leavesAt": "06:53",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Faraoani Hm.",
					"leavesAt": "06:58",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Faraoani Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "07:04",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Răcăciuni h.",
					"to": "Orbeni Hm.",
					"leavesAt": "07:11",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Orbeni Hm.",
					"to": "Sascut Hm.",
					"leavesAt": "07:32",
					"arrivesAt": "07:39",
					"waitsAtSource": 600,
					"distance": 9200
				},
				{
					"from": "Sascut Hm.",
					"to": "Şişcani h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Şişcani h.",
					"to": "Adjudu Vechi h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Adjud",
					"leavesAt": "07:52",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1931",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "16:05",
					"arrivesAt": "16:12",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "16:13",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "16:21",
					"arrivesAt": "16:34",
					"waitsAtSource": 180,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 180,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "16:44",
					"arrivesAt": "16:59",
					"waitsAtSource": 180,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "17:07",
					"arrivesAt": "17:14",
					"waitsAtSource": 480,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "17:15",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 14000
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "18:05",
					"arrivesAt": "18:32",
					"waitsAtSource": 1560,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "18:33",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "18:53",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "19:16",
					"arrivesAt": "19:41",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Băneasa",
					"leavesAt": "19:42",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 102300
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Ploieşti Vest",
					"leavesAt": "20:39",
					"arrivesAt": "21:27",
					"waitsAtSource": 180,
					"distance": 58100
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "21:29",
					"arrivesAt": "21:54",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Comarnic",
					"leavesAt": "21:55",
					"arrivesAt": "22:07",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Comarnic",
					"to": "Sinaia",
					"leavesAt": "22:08",
					"arrivesAt": "22:21",
					"waitsAtSource": 60,
					"distance": 15100
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "22:23",
					"arrivesAt": "22:31",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "22:32",
					"arrivesAt": "22:37",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "22:38",
					"arrivesAt": "22:48",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "22:50",
					"arrivesAt": "23:30",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Rupea",
					"leavesAt": "23:50",
					"arrivesAt": "01:26",
					"waitsAtSource": 1200,
					"distance": 73800
				},
				{
					"from": "Rupea",
					"to": "Sighişoara",
					"leavesAt": "01:28",
					"arrivesAt": "02:37",
					"waitsAtSource": 120,
					"distance": 53600
				},
				{
					"from": "Sighişoara",
					"to": "Mediaş",
					"leavesAt": "02:44",
					"arrivesAt": "03:38",
					"waitsAtSource": 420,
					"distance": 38400
				},
				{
					"from": "Mediaş",
					"to": "Copşa Mică",
					"leavesAt": "03:40",
					"arrivesAt": "03:54",
					"waitsAtSource": 120,
					"distance": 10400
				},
				{
					"from": "Copşa Mică",
					"to": "Blaj",
					"leavesAt": "03:55",
					"arrivesAt": "04:34",
					"waitsAtSource": 60,
					"distance": 30000
				},
				{
					"from": "Blaj",
					"to": "Teiuş",
					"leavesAt": "04:35",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 21300
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "05:09",
					"arrivesAt": "05:24",
					"waitsAtSource": 240,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Războieni",
					"leavesAt": "05:25",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 20400
				},
				{
					"from": "Războieni",
					"to": "Câmpia Turzii",
					"leavesAt": "05:48",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cluj Napoca",
					"leavesAt": "06:05",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 51500
				},
				{
					"from": "Cluj Napoca",
					"to": "Aghireş",
					"leavesAt": "07:28",
					"arrivesAt": "07:58",
					"waitsAtSource": 1020,
					"distance": 27900
				},
				{
					"from": "Aghireş",
					"to": "Huedin",
					"leavesAt": "07:59",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Huedin",
					"to": "Ciucea Hm.",
					"leavesAt": "08:32",
					"arrivesAt": "08:56",
					"waitsAtSource": 120,
					"distance": 22400
				},
				{
					"from": "Ciucea Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bulz Hm.",
					"leavesAt": "09:09",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bulz Hm.",
					"to": "Bratca",
					"leavesAt": "09:20",
					"arrivesAt": "09:28",
					"waitsAtSource": 300,
					"distance": 5900
				},
				{
					"from": "Bratca",
					"to": "Aleşd",
					"leavesAt": "09:29",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 25300
				},
				{
					"from": "Aleşd",
					"to": "Tileagd",
					"leavesAt": "09:59",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Tileagd",
					"to": "Oradea",
					"leavesAt": "10:19",
					"arrivesAt": "10:40",
					"waitsAtSource": 360,
					"distance": 23100
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4533",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Azomureş h.",
					"leavesAt": "14:37",
					"arrivesAt": "14:42",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "14:43",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "14:47",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Vidrasău h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vidrasău h.",
					"to": "Chirileu h.",
					"leavesAt": "14:58",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Chirileu h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "15:03",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Ogra h.",
					"leavesAt": "15:09",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Ogra h.",
					"to": "Cipău h.",
					"leavesAt": "15:13",
					"arrivesAt": "15:17",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cipău h.",
					"to": "Iernut",
					"leavesAt": "15:18",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Iernut",
					"to": "Cuci h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:30",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Cuci h.",
					"to": "Bogata Mureş h.",
					"leavesAt": "15:31",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Luduş",
					"leavesAt": "15:38",
					"arrivesAt": "15:42",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Luduş",
					"to": "Cheţani h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:50",
					"waitsAtSource": 120,
					"distance": 6300
				},
				{
					"from": "Cheţani h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "15:51",
					"arrivesAt": "15:55",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Gura Arieşului h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Lunca Mureşului h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Războieni",
					"leavesAt": "16:06",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5429",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:54",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "20:55",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "21:00",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "21:06",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "21:16",
					"arrivesAt": "21:20",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "21:21",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "21:30",
					"arrivesAt": "21:37",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "21:38",
					"arrivesAt": "21:44",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "21:45",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "21:50",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "21:56",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "22:01",
					"arrivesAt": "22:05",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani",
					"leavesAt": "22:06",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "22:41",
					"arrivesAt": "22:55",
					"waitsAtSource": 1500,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "22:56",
					"arrivesAt": "23:03",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "23:04",
					"arrivesAt": "23:09",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "23:10",
					"arrivesAt": "23:18",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "23:19",
					"arrivesAt": "23:29",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "23:30",
					"arrivesAt": "23:36",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "23:37",
					"arrivesAt": "23:43",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "23:44",
					"arrivesAt": "23:51",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "23:52",
					"arrivesAt": "00:07",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9512",
			"segments": [
				{
					"from": "Drobeta Tr. Severin",
					"to": "Drobeta Tr.Sev Est Hm.",
					"leavesAt": "07:56",
					"arrivesAt": "08:00",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Drobeta Tr.Sev Est Hm.",
					"to": "Drobeta Tr. Severin Mf.",
					"leavesAt": "08:01",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Drobeta Tr. Severin Mf.",
					"to": "Ergheviţa h.",
					"leavesAt": "08:08",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ergheviţa h.",
					"to": "Valea Albă Hm.",
					"leavesAt": "08:14",
					"arrivesAt": "08:24",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Albă Hm.",
					"to": "Balota",
					"leavesAt": "08:25",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Balota",
					"to": "Gârniţa Hm.",
					"leavesAt": "08:38",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Gârniţa Hm.",
					"to": "Prunişor Hm.",
					"leavesAt": "08:43",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Prunişor Hm.",
					"to": "Igiroasa Hm.",
					"leavesAt": "08:50",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Igiroasa Hm.",
					"to": "Tâmna",
					"leavesAt": "08:57",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Tâmna",
					"to": "Ciochiuţa Hm.",
					"leavesAt": "09:05",
					"arrivesAt": "09:13",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciochiuţa Hm.",
					"to": "Strehaia hc.",
					"leavesAt": "09:14",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Strehaia hc.",
					"to": "Strehaia",
					"leavesAt": "09:20",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Strehaia",
					"to": "Lunca Banului h.",
					"leavesAt": "09:28",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Lunca Banului h.",
					"to": "Butoieşti Hm.",
					"leavesAt": "09:33",
					"arrivesAt": "09:40",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Gura Motrului Hm.",
					"leavesAt": "09:41",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Filiaşi",
					"leavesAt": "09:48",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 448
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9064",
			"segments": [
				{
					"from": "Corabia",
					"to": "Vişina Veche hc.",
					"leavesAt": "15:30",
					"arrivesAt": "15:44",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Vişina Veche hc.",
					"to": "Vişina h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:48",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vişina h.",
					"to": "Studina hc.",
					"leavesAt": "15:49",
					"arrivesAt": "15:56",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Studina hc.",
					"to": "Studiniţa h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:02",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Studiniţa h.",
					"to": "Frăsinet hc.",
					"leavesAt": "16:03",
					"arrivesAt": "16:07",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Frăsinet hc.",
					"to": "Deveselu h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:16",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Deveselu h.",
					"to": "Grupa Tehnică Caracal Hm.",
					"leavesAt": "16:17",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Grupa Tehnică Caracal Hm.",
					"to": "Canton 239+700 h.",
					"leavesAt": "16:23",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Canton 239+700 h.",
					"to": "Caracal",
					"leavesAt": "16:27",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 1400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8224",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "16:42",
					"arrivesAt": "16:48",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "16:49",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "17:02",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:19",
					"waitsAtSource": 480,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "17:20",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "17:29",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "17:46",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "18:00",
					"arrivesAt": "18:09",
					"waitsAtSource": 540,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Dunărea Hm.",
					"leavesAt": "18:10",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Dunărea Hm.",
					"to": "Ramificaţia Borcea",
					"leavesAt": "18:20",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "18:33",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Feteşti",
					"to": "Movila Hm.",
					"leavesAt": "18:46",
					"arrivesAt": "19:04",
					"waitsAtSource": 420,
					"distance": 16700
				},
				{
					"from": "Movila Hm.",
					"to": "Platoneşti h.",
					"leavesAt": "19:05",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Platoneşti h.",
					"to": "Ţăndărei",
					"leavesAt": "19:14",
					"arrivesAt": "19:22",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ţăndărei",
					"to": "Murgeanca Hm.",
					"leavesAt": "19:25",
					"arrivesAt": "19:37",
					"waitsAtSource": 180,
					"distance": 12200
				},
				{
					"from": "Murgeanca Hm.",
					"to": "Spicu",
					"leavesAt": "19:38",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spicu",
					"to": "Dudeşti Hm.",
					"leavesAt": "19:48",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Dudeşti Hm.",
					"to": "Scărlăteşti hc.",
					"leavesAt": "19:59",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Scărlăteşti hc.",
					"to": "Cireşu Hm.",
					"leavesAt": "20:07",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cireşu Hm.",
					"to": "Făurei",
					"leavesAt": "20:15",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 15700
				},
				{
					"from": "Făurei",
					"to": "Vizireni h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:42",
					"waitsAtSource": 120,
					"distance": 6700
				},
				{
					"from": "Vizireni h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "20:55",
					"arrivesAt": "21:00",
					"waitsAtSource": 480,
					"distance": 6400
				},
				{
					"from": "Movila Oii h.",
					"to": "Cilibia Hm.",
					"leavesAt": "21:01",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cilibia Hm.",
					"to": "Bentu h.",
					"leavesAt": "21:10",
					"arrivesAt": "21:14",
					"waitsAtSource": 300,
					"distance": 4000
				},
				{
					"from": "Bentu h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "21:15",
					"arrivesAt": "21:19",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Tăbărăşti h.",
					"leavesAt": "21:20",
					"arrivesAt": "21:23",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Buzău Sud",
					"leavesAt": "21:24",
					"arrivesAt": "21:30",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Buzău Sud",
					"to": "Buzău",
					"leavesAt": "21:31",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2211",
			"segments": [
				{
					"from": "Arad",
					"to": "Şofronea",
					"leavesAt": "18:25",
					"arrivesAt": "18:35",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Şofronea",
					"to": "Curtici",
					"leavesAt": "18:36",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6509",
			"segments": [
				{
					"from": "Ungheni Prut Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "19:42",
					"arrivesAt": "19:50",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Holboca Hm.",
					"leavesAt": "19:51",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Holboca Hm.",
					"to": "Socola",
					"leavesAt": "19:58",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Socola",
					"to": "Nicolina",
					"leavesAt": "20:09",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "20:15",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1891",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "05:55",
					"arrivesAt": "06:54",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "06:55",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "07:15",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "07:39",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Piteşti",
					"to": "Costeşti",
					"leavesAt": "08:08",
					"arrivesAt": "08:31",
					"waitsAtSource": 1080,
					"distance": 21800
				},
				{
					"from": "Costeşti",
					"to": "Stolnici Hm.",
					"leavesAt": "08:32",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 15900
				},
				{
					"from": "Stolnici Hm.",
					"to": "Corbu",
					"leavesAt": "08:47",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Corbu",
					"to": "Slatina",
					"leavesAt": "09:03",
					"arrivesAt": "09:34",
					"waitsAtSource": 240,
					"distance": 33500
				},
				{
					"from": "Slatina",
					"to": "Piatra Olt",
					"leavesAt": "09:36",
					"arrivesAt": "09:54",
					"waitsAtSource": 120,
					"distance": 17000
				},
				{
					"from": "Piatra Olt",
					"to": "Balş",
					"leavesAt": "09:55",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 12900
				},
				{
					"from": "Balş",
					"to": "Craiova",
					"leavesAt": "10:07",
					"arrivesAt": "10:39",
					"waitsAtSource": 60,
					"distance": 31200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9401",
			"segments": [
				{
					"from": "Caracal",
					"to": "Romula Hm.",
					"leavesAt": "05:34",
					"arrivesAt": "05:46",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Romula Hm.",
					"to": "Fălcoiu h.",
					"leavesAt": "05:47",
					"arrivesAt": "05:55",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Fălcoiu h.",
					"to": "Vlăduleni",
					"leavesAt": "05:56",
					"arrivesAt": "06:04",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Vlăduleni",
					"to": "Şopârliţa hc.",
					"leavesAt": "06:05",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Piatra Olt",
					"leavesAt": "06:10",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:36",
					"waitsAtSource": 420,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "06:37",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "06:44",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "06:53",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:10",
					"waitsAtSource": 120,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "07:11",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "07:20",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Potcoava",
					"to": "Sineşti Hm.",
					"leavesAt": "07:29",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sineşti Hm.",
					"to": "Corbu",
					"leavesAt": "07:37",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Corbu",
					"to": "Hârseşti Hm.",
					"leavesAt": "07:45",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "07:52",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stolnici Hm.",
					"to": "Fâlfani Hm.",
					"leavesAt": "07:58",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Costeşti",
					"leavesAt": "08:14",
					"arrivesAt": "08:25",
					"waitsAtSource": 360,
					"distance": 7900
				},
				{
					"from": "Costeşti",
					"to": "Suseni h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:39",
					"waitsAtSource": 540,
					"distance": 4400
				},
				{
					"from": "Suseni h.",
					"to": "Pârvu h.",
					"leavesAt": "08:40",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Pârvu h.",
					"to": "Pârvu Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:53",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Pârvu Hm.",
					"to": "Bradu de Sus",
					"leavesAt": "08:54",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bradu de Sus",
					"to": "Km. 109+000 h.",
					"leavesAt": "09:03",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Km. 109+000 h.",
					"to": "Piteşti",
					"leavesAt": "09:08",
					"arrivesAt": "09:10",
					"waitsAtSource": 30,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20180527",
					"daysOfWeek": 319
				},
				{
					"from": "20180529",
					"to": "20181130",
					"daysOfWeek": 319
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "37647",
			"segments": [
				{
					"from": "Salonta",
					"to": "Kotegyan",
					"leavesAt": "09:40",
					"arrivesAt": "10:00",
					"waitsAtSource": 0,
					"distance": 13200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8031",
			"segments": [
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "04:53",
					"arrivesAt": "05:00",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Cernavodă Pod",
					"leavesAt": "05:01",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "05:22",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "05:32",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "05:41",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "05:57",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "06:07",
					"arrivesAt": "06:12",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "06:13",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "06:18",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "06:23",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "06:29",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181209",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5204",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "12:07",
					"arrivesAt": "12:15",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Mihăileni Hm.",
					"leavesAt": "12:16",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "12:24",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "12:29",
					"arrivesAt": "12:34",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Caracău h.",
					"leavesAt": "12:35",
					"arrivesAt": "12:40",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Caracău h.",
					"to": "Livezi Ciuc",
					"leavesAt": "12:41",
					"arrivesAt": "12:45",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Utuşoiu h.",
					"leavesAt": "12:48",
					"arrivesAt": "12:54",
					"waitsAtSource": 180,
					"distance": 4100
				},
				{
					"from": "Utuşoiu h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "12:55",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Tarcău h.",
					"leavesAt": "13:02",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "13:07",
					"arrivesAt": "13:12",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Bolovăniş h.",
					"leavesAt": "13:13",
					"arrivesAt": "13:19",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Ghimeş",
					"leavesAt": "13:20",
					"arrivesAt": "13:26",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Ghimeş",
					"to": "Palanca Hm.",
					"leavesAt": "13:31",
					"arrivesAt": "13:38",
					"waitsAtSource": 300,
					"distance": 5200
				},
				{
					"from": "Palanca Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "13:39",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Simbrea Hm.",
					"leavesAt": "13:46",
					"arrivesAt": "13:52",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Simbrea Hm.",
					"to": "Goioasa Hm.",
					"leavesAt": "13:53",
					"arrivesAt": "14:02",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Goioasa Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "14:03",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Caraliţa h.",
					"to": "Asău Hm.",
					"leavesAt": "14:09",
					"arrivesAt": "14:15",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Asău Hm.",
					"to": "Comăneşti",
					"leavesAt": "14:16",
					"arrivesAt": "14:27",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Comăneşti",
					"to": "Valea Uzului Hm.",
					"leavesAt": "14:32",
					"arrivesAt": "14:42",
					"waitsAtSource": 300,
					"distance": 6200
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:52",
					"waitsAtSource": 480,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Dofteana Bacău",
					"leavesAt": "14:53",
					"arrivesAt": "14:59",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Dofteana Bacău",
					"to": "Cireşoaia h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cireşoaia h.",
					"to": "Saline hc.",
					"leavesAt": "15:07",
					"arrivesAt": "15:13",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Saline hc.",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "15:14",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Viişoara h",
					"leavesAt": "15:18",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Viişoara h",
					"to": "Oneşti",
					"leavesAt": "15:23",
					"arrivesAt": "15:35",
					"waitsAtSource": 30,
					"distance": 9100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5739",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "19:31",
					"arrivesAt": "19:36",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava Nord",
					"to": "Dărmăneşti",
					"leavesAt": "19:37",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dărmăneşti",
					"to": "Părhăuţi h.",
					"leavesAt": "19:52",
					"arrivesAt": "19:59",
					"waitsAtSource": 360,
					"distance": 4400
				},
				{
					"from": "Părhăuţi h.",
					"to": "Todireşti h.",
					"leavesAt": "20:00",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Todireşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Soloneţ h.",
					"to": "Pârteşti h.",
					"leavesAt": "20:17",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Pârteşti h.",
					"to": "Cacica Hm.",
					"leavesAt": "20:24",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3003",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:47",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "07:48",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "07:51",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "07:55",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Chitila",
					"leavesAt": "07:58",
					"arrivesAt": "08:01",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "08:02",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "08:14",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "08:27",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:41",
					"waitsAtSource": 360,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "08:42",
					"arrivesAt": "08:49",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "08:53",
					"arrivesAt": "08:57",
					"waitsAtSource": 240,
					"distance": 4600
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Ploieşti Vest",
					"leavesAt": "08:58",
					"arrivesAt": "09:02",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "09:04",
					"arrivesAt": "09:10",
					"waitsAtSource": 120,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "09:11",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Bobolia h.",
					"leavesAt": "09:21",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Bobolia h.",
					"to": "Câmpina",
					"leavesAt": "09:29",
					"arrivesAt": "09:36",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "09:37",
					"arrivesAt": "09:42",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "09:43",
					"arrivesAt": "09:46",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "09:47",
					"arrivesAt": "09:50",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "09:51",
					"arrivesAt": "09:55",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Posada h.",
					"leavesAt": "09:56",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Posada h.",
					"to": "Sinaia Sud h.",
					"leavesAt": "10:02",
					"arrivesAt": "10:11",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "10:12",
					"arrivesAt": "10:15",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "10:17",
					"arrivesAt": "10:22",
					"waitsAtSource": 120,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "10:23",
					"arrivesAt": "10:27",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "10:28",
					"arrivesAt": "10:33",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "10:34",
					"arrivesAt": "10:44",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "10:46",
					"arrivesAt": "11:01",
					"waitsAtSource": 120,
					"distance": 9900
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Timişu de Jos h.",
					"leavesAt": "11:02",
					"arrivesAt": "11:10",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Dârste",
					"leavesAt": "11:11",
					"arrivesAt": "11:19",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "11:20",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2513",
			"segments": [
				{
					"from": "Făgăraş",
					"to": "Dridif h.",
					"leavesAt": "03:33",
					"arrivesAt": "03:43",
					"waitsAtSource": 0,
					"distance": 8500
				},
				{
					"from": "Dridif h.",
					"to": "Voila Hm.",
					"leavesAt": "03:44",
					"arrivesAt": "03:48",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Voila Hm.",
					"to": "Olteţ h.",
					"leavesAt": "03:49",
					"arrivesAt": "03:55",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Olteţ h.",
					"to": "Viştea h.",
					"leavesAt": "03:56",
					"arrivesAt": "04:00",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Viştea h.",
					"to": "Ucea",
					"leavesAt": "04:01",
					"arrivesAt": "04:05",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ucea",
					"to": "Arpaş Hm.",
					"leavesAt": "04:06",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Arpaş Hm.",
					"to": "Cârţa h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cârţa h.",
					"to": "Scoreiu h.",
					"leavesAt": "04:19",
					"arrivesAt": "04:23",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Scoreiu h.",
					"to": "Sărata Colun h.",
					"leavesAt": "04:24",
					"arrivesAt": "04:27",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Sărata Colun h.",
					"to": "Porumbacu Hm.",
					"leavesAt": "04:28",
					"arrivesAt": "04:33",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "04:34",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Avrig Hm.",
					"to": "Mârşa h.",
					"leavesAt": "04:48",
					"arrivesAt": "04:53",
					"waitsAtSource": 300,
					"distance": 3700
				},
				{
					"from": "Mârşa h.",
					"to": "Racoviţa h.",
					"leavesAt": "04:54",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Racoviţa h.",
					"to": "Sebeş Olt h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Podu Olt",
					"leavesAt": "05:02",
					"arrivesAt": "05:07",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "05:08",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "05:16",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "05:26",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "05:30",
					"arrivesAt": "05:34",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Atelier Zona h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu",
					"leavesAt": "05:44",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1655",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Triaj",
					"leavesAt": "07:10",
					"arrivesAt": "07:55",
					"waitsAtSource": 0,
					"distance": 56600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Ploieşti Sud",
					"leavesAt": "07:59",
					"arrivesAt": "08:06",
					"waitsAtSource": 240,
					"distance": 3600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Cricov Hm.",
					"leavesAt": "08:08",
					"arrivesAt": "08:26",
					"waitsAtSource": 120,
					"distance": 16700
				},
				{
					"from": "Cricov Hm.",
					"to": "Mizil",
					"leavesAt": "08:27",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 16900
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "08:43",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "09:20",
					"arrivesAt": "09:51",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "09:52",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "10:32",
					"arrivesAt": "10:54",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "10:56",
					"arrivesAt": "11:22",
					"waitsAtSource": 120,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "11:24",
					"arrivesAt": "12:01",
					"waitsAtSource": 120,
					"distance": 58200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9105",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:43",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "16:44",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "16:50",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Chitila",
					"leavesAt": "16:55",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "16:59",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "17:08",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "17:32",
					"arrivesAt": "17:41",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "17:42",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "17:51",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "17:56",
					"arrivesAt": "18:03",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "18:08",
					"arrivesAt": "18:12",
					"waitsAtSource": 300,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Podu Rizii h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Podu Rizii h.",
					"to": "Băneşti h.",
					"leavesAt": "18:17",
					"arrivesAt": "18:21",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "18:22",
					"arrivesAt": "18:25",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "18:26",
					"arrivesAt": "18:30",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "18:31",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "18:36",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "18:41",
					"arrivesAt": "18:49",
					"waitsAtSource": 30,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3115",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "13:06",
					"arrivesAt": "13:14",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "13:15",
					"arrivesAt": "13:21",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Băile Călacea",
					"leavesAt": "13:25",
					"arrivesAt": "13:31",
					"waitsAtSource": 240,
					"distance": 7200
				},
				{
					"from": "Băile Călacea",
					"to": "Orţişoara",
					"leavesAt": "13:32",
					"arrivesAt": "13:37",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Orţişoara",
					"to": "Vinga Hm.",
					"leavesAt": "13:38",
					"arrivesAt": "13:43",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "13:44",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Valea Viilor Hm.",
					"leavesAt": "13:51",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Aradu Nou",
					"leavesAt": "13:57",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "14:07",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Arad",
					"to": "Utviniş h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:43",
					"waitsAtSource": 1020,
					"distance": 9600
				},
				{
					"from": "Utviniş h.",
					"to": "Zimandu Nou h.",
					"leavesAt": "14:44",
					"arrivesAt": "14:48",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "14:49",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Comlăuş h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Comlăuş h.",
					"to": "Şimand Hm.",
					"leavesAt": "15:05",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şimand Hm.",
					"to": "Nădab",
					"leavesAt": "15:13",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Nădab",
					"to": "Chişineu Criş",
					"leavesAt": "15:21",
					"arrivesAt": "15:27",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Chişineu Criş",
					"to": "Zerind Hm.",
					"leavesAt": "15:28",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Zerind Hm.",
					"to": "Tămaşda h.",
					"leavesAt": "15:36",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Tămaşda h.",
					"to": "Boiu Bihor h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Boiu Bihor h.",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "15:49",
					"arrivesAt": "15:59",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Salonta",
					"leavesAt": "16:00",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Salonta",
					"to": "Mădăraş Bihor h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Mădăraş Bihor h.",
					"to": "Cefa Hm.",
					"leavesAt": "16:16",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 9300
				},
				{
					"from": "Cefa Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "16:34",
					"arrivesAt": "16:45",
					"waitsAtSource": 480,
					"distance": 10400
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Oradea Vest Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Oradea",
					"leavesAt": "16:58",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3004",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "06:04",
					"arrivesAt": "06:12",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Timişu de Jos h.",
					"leavesAt": "06:13",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:27",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Predeal",
					"leavesAt": "06:28",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "06:45",
					"arrivesAt": "06:54",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "06:55",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "07:02",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "07:06",
					"arrivesAt": "07:12",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "07:13",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Posada h.",
					"leavesAt": "07:16",
					"arrivesAt": "07:25",
					"waitsAtSource": 30,
					"distance": 8900
				},
				{
					"from": "Posada h.",
					"to": "Comarnic",
					"leavesAt": "07:26",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:40",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "07:41",
					"arrivesAt": "07:44",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "07:45",
					"arrivesAt": "07:50",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Bobolia h.",
					"leavesAt": "07:51",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Bobolia h.",
					"to": "Floreşti Prahova",
					"leavesAt": "07:57",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "08:05",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "08:15",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "08:35",
					"arrivesAt": "08:38",
					"waitsAtSource": 720,
					"distance": 2900
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Brazi",
					"leavesAt": "08:39",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "08:51",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:06",
					"waitsAtSource": 360,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "09:07",
					"arrivesAt": "09:12",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "09:13",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "09:20",
					"arrivesAt": "09:24",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "09:29",
					"arrivesAt": "09:36",
					"waitsAtSource": 300,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "09:37",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "09:42",
					"arrivesAt": "09:51",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1752",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "08:44",
					"arrivesAt": "08:49",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "08:52",
					"arrivesAt": "09:04",
					"waitsAtSource": 180,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "09:05",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "09:24",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Roman",
					"leavesAt": "09:42",
					"arrivesAt": "10:09",
					"waitsAtSource": 120,
					"distance": 40200
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "10:10",
					"arrivesAt": "10:39",
					"waitsAtSource": 60,
					"distance": 43800
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "10:53",
					"arrivesAt": "11:33",
					"waitsAtSource": 840,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "11:35",
					"arrivesAt": "12:02",
					"waitsAtSource": 120,
					"distance": 25700
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "12:04",
					"arrivesAt": "12:25",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "12:27",
					"arrivesAt": "13:04",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "13:06",
					"arrivesAt": "13:37",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "13:39",
					"arrivesAt": "14:10",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "14:12",
					"arrivesAt": "14:48",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "14:51",
					"arrivesAt": "15:44",
					"waitsAtSource": 180,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2501",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "07:05",
					"arrivesAt": "07:11",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Ghimbav Hm.",
					"leavesAt": "07:15",
					"arrivesAt": "07:23",
					"waitsAtSource": 240,
					"distance": 5400
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "07:24",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Codlea Hm.",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "07:31",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "07:41",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Valea Homorod h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:53",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Valea Homorod h.",
					"to": "Brădet Hm.",
					"leavesAt": "07:54",
					"arrivesAt": "08:03",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Brădet Hm.",
					"to": "Perşani h.",
					"leavesAt": "08:04",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Şercaia Hm.",
					"leavesAt": "08:13",
					"arrivesAt": "08:23",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Şercaia Hm.",
					"to": "Şercaia h.",
					"leavesAt": "08:27",
					"arrivesAt": "08:30",
					"waitsAtSource": 240,
					"distance": 1200
				},
				{
					"from": "Şercaia h.",
					"to": "Mândra Oltului h.",
					"leavesAt": "08:31",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Făgăraş",
					"leavesAt": "08:39",
					"arrivesAt": "08:45",
					"waitsAtSource": 30,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1743",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Aradu Nou",
					"leavesAt": "15:55",
					"arrivesAt": "16:38",
					"waitsAtSource": 0,
					"distance": 51000
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "16:43",
					"arrivesAt": "16:50",
					"waitsAtSource": 300,
					"distance": 6200
				},
				{
					"from": "Arad",
					"to": "Sântana",
					"leavesAt": "17:00",
					"arrivesAt": "17:24",
					"waitsAtSource": 600,
					"distance": 23500
				},
				{
					"from": "Sântana",
					"to": "Chişineu Criş",
					"leavesAt": "17:26",
					"arrivesAt": "17:44",
					"waitsAtSource": 120,
					"distance": 24000
				},
				{
					"from": "Chişineu Criş",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "18:09",
					"waitsAtSource": 120,
					"distance": 23700
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Salonta",
					"leavesAt": "18:10",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Salonta",
					"to": "Oradea Vest Hm.",
					"leavesAt": "18:22",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 33700
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Oradea",
					"leavesAt": "19:00",
					"arrivesAt": "19:08",
					"waitsAtSource": 300,
					"distance": 5500
				},
				{
					"from": "Oradea",
					"to": "Săcuieni Bihor",
					"leavesAt": "19:14",
					"arrivesAt": "19:58",
					"waitsAtSource": 360,
					"distance": 44200
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Valea lui Mihai",
					"leavesAt": "19:59",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Valea lui Mihai",
					"to": "Carei",
					"leavesAt": "20:18",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 31200
				},
				{
					"from": "Carei",
					"to": "Satu Mare",
					"leavesAt": "20:43",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 36000
				},
				{
					"from": "Satu Mare",
					"to": "Seini",
					"leavesAt": "21:19",
					"arrivesAt": "21:55",
					"waitsAtSource": 420,
					"distance": 34800
				},
				{
					"from": "Seini",
					"to": "Baia Mare",
					"leavesAt": "21:56",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 24600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9123",
			"segments": [
				{
					"from": "Goleşti",
					"to": "Ştefăneşti Argeş Hm.",
					"leavesAt": "18:30",
					"arrivesAt": "18:40",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Ştefăneşti Argeş Hm.",
					"to": "Gropeni h.",
					"leavesAt": "18:41",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gropeni h.",
					"to": "Ciumeşti",
					"leavesAt": "18:46",
					"arrivesAt": "18:52",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Ciumeşti",
					"to": "Clucereasa h.",
					"leavesAt": "18:53",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Clucereasa h.",
					"to": "Stâlpeni Hm.",
					"leavesAt": "19:05",
					"arrivesAt": "19:15",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Stâlpeni Hm.",
					"to": "Drăghici h.",
					"leavesAt": "19:16",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Drăghici h.",
					"to": "Lăzăreşti Hm.",
					"leavesAt": "19:27",
					"arrivesAt": "19:34",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Lăzăreşti Hm.",
					"to": "Schitu Goleşti",
					"leavesAt": "19:35",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Schitu Goleşti",
					"to": "Câmpulung",
					"leavesAt": "19:44",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Câmpulung",
					"to": "Parcul Kreţulescu h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 1900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4097",
			"segments": [
				{
					"from": "Jibou",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "17:10",
					"arrivesAt": "17:19",
					"waitsAtSource": 0,
					"distance": 9300
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Inău h.",
					"leavesAt": "17:20",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Inău h.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "17:24",
					"arrivesAt": "17:27",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Benesat Hm.",
					"leavesAt": "17:28",
					"arrivesAt": "17:31",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Benesat Hm.",
					"to": "Ţicău h.",
					"leavesAt": "17:32",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ţicău h.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "17:39",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "17:43",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Fersig h.",
					"leavesAt": "17:50",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Fersig h.",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "17:57",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Baia Mare",
					"leavesAt": "18:13",
					"arrivesAt": "18:29",
					"waitsAtSource": 660,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6506",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "14:23",
					"arrivesAt": "14:30",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Socola",
					"leavesAt": "14:31",
					"arrivesAt": "14:36",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Socola",
					"to": "Holboca Hm.",
					"leavesAt": "14:37",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Holboca Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "14:46",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "14:55",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20170107",
					"to": "20170205",
					"daysOfWeek": 799
				},
				{
					"from": "20170211",
					"to": "20170418",
					"daysOfWeek": 799
				},
				{
					"from": "20170422",
					"to": "20170423",
					"daysOfWeek": 799
				},
				{
					"from": "20170429",
					"to": "20170618",
					"daysOfWeek": 799
				},
				{
					"from": "20170624",
					"to": "20170625",
					"daysOfWeek": 799
				},
				{
					"from": "20170701",
					"to": "20170702",
					"daysOfWeek": 799
				},
				{
					"from": "20170708",
					"to": "20170709",
					"daysOfWeek": 799
				},
				{
					"from": "20170715",
					"to": "20170716",
					"daysOfWeek": 799
				},
				{
					"from": "20170722",
					"to": "20170723",
					"daysOfWeek": 799
				},
				{
					"from": "20170729",
					"to": "20170730",
					"daysOfWeek": 799
				},
				{
					"from": "20170805",
					"to": "20170806",
					"daysOfWeek": 799
				},
				{
					"from": "20170812",
					"to": "20170813",
					"daysOfWeek": 799
				},
				{
					"from": "20170819",
					"to": "20170820",
					"daysOfWeek": 799
				},
				{
					"from": "20170826",
					"to": "20170827",
					"daysOfWeek": 799
				},
				{
					"from": "20170902",
					"to": "20170903",
					"daysOfWeek": 799
				},
				{
					"from": "20170909",
					"to": "20171209",
					"daysOfWeek": 799
				},
				{
					"from": "20161211",
					"to": "20161225",
					"daysOfWeek": 799
				},
				{
					"from": "20161231",
					"to": "20170101",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9051",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "05:00",
					"arrivesAt": "05:05",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Km. 200+400 P.aj.m",
					"leavesAt": "05:06",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Km. 200+400 P.aj.m",
					"to": "Troian h.",
					"leavesAt": "05:14",
					"arrivesAt": "05:23",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Troian h.",
					"to": "Salcia Teleorman Hm.",
					"leavesAt": "05:24",
					"arrivesAt": "05:38",
					"waitsAtSource": 30,
					"distance": 9700
				},
				{
					"from": "Salcia Teleorman Hm.",
					"to": "Km. 231+600 h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:55",
					"waitsAtSource": 60,
					"distance": 14500
				},
				{
					"from": "Km. 231+600 h.",
					"to": "Turnu Măgurele",
					"leavesAt": "05:56",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2857",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "17:25",
					"arrivesAt": "17:29",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "17:30",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "17:34",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "17:39",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "17:47",
					"arrivesAt": "17:51",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "17:52",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "17:57",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "18:03",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "18:07",
					"arrivesAt": "18:13",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Ioneşti Gorj h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:50",
					"waitsAtSource": 1320,
					"distance": 11500
				},
				{
					"from": "Ioneşti Gorj h.",
					"to": "Km. 9+820 h.",
					"leavesAt": "18:51",
					"arrivesAt": "18:55",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Km. 9+820 h.",
					"to": "Termo Turceni h.",
					"leavesAt": "18:56",
					"arrivesAt": "19:00",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Termo Turceni h.",
					"to": "Turceni",
					"leavesAt": "19:01",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 900
				},
				{
					"from": "Turceni",
					"to": "Gârbovu h.",
					"leavesAt": "19:06",
					"arrivesAt": "19:12",
					"waitsAtSource": 180,
					"distance": 6600
				},
				{
					"from": "Gârbovu h.",
					"to": "Sărdăneşti h.",
					"leavesAt": "19:13",
					"arrivesAt": "19:19",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Plopşoru",
					"leavesAt": "19:20",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Plopşoru",
					"to": "Peşteana Jiu h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Bâlteni h.",
					"leavesAt": "19:35",
					"arrivesAt": "19:38",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bâlteni h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "19:39",
					"arrivesAt": "19:43",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Rovinari Sud h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Rovinari Hm.",
					"leavesAt": "19:52",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rovinari Hm.",
					"to": "Km. 49+800 h.",
					"leavesAt": "19:57",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rogojelu",
					"leavesAt": "20:00",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Rogojelu",
					"to": "Vârţ h.",
					"leavesAt": "20:04",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Vârţ h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Drăguţeşti h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Amaradia",
					"leavesAt": "20:20",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Amaradia",
					"to": "Târgu Jiu",
					"leavesAt": "20:25",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4423",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Căşeiu Hm.",
					"leavesAt": "16:35",
					"arrivesAt": "16:44",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Căşeiu Hm.",
					"to": "Coplean h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coplean h.",
					"to": "Câţcău h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:54",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Câţcău h.",
					"to": "Căpâlna pe Someş h.",
					"leavesAt": "16:55",
					"arrivesAt": "17:01",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Căpâlna pe Someş h.",
					"to": "Gâlgău",
					"leavesAt": "17:02",
					"arrivesAt": "17:09",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Gâlgău",
					"to": "Gâlgău h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:15",
					"waitsAtSource": 120,
					"distance": 3100
				},
				{
					"from": "Gâlgău h.",
					"to": "Glodu Someşului h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Glodu Someşului h.",
					"to": "Rus h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Rus h.",
					"to": "Ileanda",
					"leavesAt": "17:29",
					"arrivesAt": "17:38",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Ileanda",
					"to": "Bizuşa h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:51",
					"waitsAtSource": 600,
					"distance": 1800
				},
				{
					"from": "Bizuşa h.",
					"to": "Răstoci Hm.",
					"leavesAt": "17:52",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Răstoci Hm.",
					"to": "Letca Hm.",
					"leavesAt": "18:00",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Letca Hm.",
					"to": "Cuciulat Hm.",
					"leavesAt": "18:11",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Băbuţeni Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Băbuţeni Hm.",
					"to": "Ciocmani h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ciocmani h.",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "18:31",
					"arrivesAt": "18:38",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Var h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Var h.",
					"to": "Jibou",
					"leavesAt": "18:45",
					"arrivesAt": "18:50",
					"waitsAtSource": 30,
					"distance": 2800
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 351
				},
				{
					"from": "20180409",
					"to": "20180429",
					"daysOfWeek": 351
				},
				{
					"from": "20180501",
					"to": "20180526",
					"daysOfWeek": 351
				},
				{
					"from": "20180528",
					"to": "20180530",
					"daysOfWeek": 351
				},
				{
					"from": "20180601",
					"to": "20181128",
					"daysOfWeek": 351
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 351
				},
				{
					"from": "20171210",
					"to": "20171223",
					"daysOfWeek": 351
				},
				{
					"from": "20171226",
					"to": "20171230",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5447",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "12:29",
					"arrivesAt": "12:40",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "12:46",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "12:52",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "13:02",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "13:07",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "13:16",
					"arrivesAt": "13:23",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "13:24",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "13:31",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "13:36",
					"arrivesAt": "13:41",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "13:42",
					"arrivesAt": "13:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "13:47",
					"arrivesAt": "13:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani",
					"leavesAt": "13:52",
					"arrivesAt": "14:02",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "14:10",
					"arrivesAt": "14:15",
					"waitsAtSource": 480,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "14:16",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "14:27",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "14:33",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "14:39",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "14:46",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "14:53",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "15:00",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "15:07",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "15:14",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "15:23",
					"arrivesAt": "15:29",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8374",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "11:35",
					"arrivesAt": "11:43",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "11:44",
					"arrivesAt": "11:48",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Pescăruş h.",
					"leavesAt": "11:49",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pescăruş h.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "11:56",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "12:03",
					"arrivesAt": "12:06",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "12:07",
					"arrivesAt": "12:15",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "12:16",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "12:30",
					"arrivesAt": "12:36",
					"waitsAtSource": 420,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "12:37",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 14000
				}
			],
			"restrictions": [
				{
					"from": "20180428",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180528",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6443",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "11:40",
					"arrivesAt": "11:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "11:55",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "12:03",
					"arrivesAt": "12:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "12:10",
					"arrivesAt": "12:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "12:18",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "12:28",
					"arrivesAt": "12:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "12:35",
					"arrivesAt": "12:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "12:40",
					"arrivesAt": "12:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "12:50",
					"arrivesAt": "13:04",
					"waitsAtSource": 60,
					"distance": 14700
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "1063",
			"segments": [
				{
					"from": "Ungheni",
					"to": "Ungheni Prut Fr.",
					"leavesAt": "16:14",
					"arrivesAt": "16:18",
					"waitsAtSource": 0,
					"distance": 800
				},
				{
					"from": "Ungheni Prut Fr.",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:23",
					"waitsAtSource": 180,
					"distance": 600
				},
				{
					"from": "Ungheni Prut Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "17:06",
					"arrivesAt": "17:14",
					"waitsAtSource": 2580,
					"distance": 5800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Holboca Hm.",
					"leavesAt": "17:15",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Holboca Hm.",
					"to": "Socola",
					"leavesAt": "17:22",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Socola",
					"to": "Nicolina",
					"leavesAt": "17:34",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "17:43",
					"arrivesAt": "17:50",
					"waitsAtSource": 240,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1574",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Barboşi",
					"leavesAt": "08:20",
					"arrivesAt": "08:39",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Barboşi",
					"to": "Brăila",
					"leavesAt": "08:40",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 19500
				},
				{
					"from": "Brăila",
					"to": "Ianca hc.",
					"leavesAt": "08:59",
					"arrivesAt": "09:29",
					"waitsAtSource": 120,
					"distance": 42400
				},
				{
					"from": "Ianca hc.",
					"to": "Făurei",
					"leavesAt": "09:30",
					"arrivesAt": "09:46",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Făurei",
					"to": "Buzău",
					"leavesAt": "09:48",
					"arrivesAt": "10:27",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "10:29",
					"arrivesAt": "11:01",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "11:02",
					"arrivesAt": "11:38",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "11:40",
					"arrivesAt": "12:30",
					"waitsAtSource": 120,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2481",
			"segments": [
				{
					"from": "Câineni",
					"to": "Râu Vadului h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:53",
					"waitsAtSource": 0,
					"distance": 5400
				},
				{
					"from": "Râu Vadului h.",
					"to": "Valea Fratelui h.",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Valea Fratelui h.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "05:59",
					"arrivesAt": "06:11",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Turnu Roşu hc.",
					"leavesAt": "06:12",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Podu Olt",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "06:30",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:51",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:02",
					"waitsAtSource": 240,
					"distance": 1600
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Atelier Zona h.",
					"leavesAt": "07:03",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu",
					"leavesAt": "07:07",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3122",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Vest Hm.",
					"leavesAt": "19:55",
					"arrivesAt": "20:04",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "20:11",
					"arrivesAt": "20:24",
					"waitsAtSource": 420,
					"distance": 10800
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Cefa Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Cefa Hm.",
					"to": "Mădăraş Bihor h.",
					"leavesAt": "20:39",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Mădăraş Bihor h.",
					"to": "Salonta",
					"leavesAt": "20:52",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Salonta",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "21:06",
					"arrivesAt": "21:17",
					"waitsAtSource": 480,
					"distance": 10200
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Boiu Bihor h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Boiu Bihor h.",
					"to": "Tămaşda h.",
					"leavesAt": "21:23",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tămaşda h.",
					"to": "Zerind Hm.",
					"leavesAt": "21:29",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Zerind Hm.",
					"to": "Chişineu Criş",
					"leavesAt": "21:43",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Chişineu Criş",
					"to": "Nădab",
					"leavesAt": "22:02",
					"arrivesAt": "22:08",
					"waitsAtSource": 720,
					"distance": 4900
				},
				{
					"from": "Nădab",
					"to": "Şimand Hm.",
					"leavesAt": "22:09",
					"arrivesAt": "22:17",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şimand Hm.",
					"to": "Comlăuş h.",
					"leavesAt": "22:18",
					"arrivesAt": "22:26",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Comlăuş h.",
					"to": "Sântana",
					"leavesAt": "22:27",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "22:33",
					"arrivesAt": "22:44",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utviniş h.",
					"leavesAt": "22:45",
					"arrivesAt": "22:50",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Utviniş h.",
					"to": "Arad",
					"leavesAt": "22:51",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 9600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 288
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4143",
			"segments": [
				{
					"from": "Deda",
					"to": "Morăreni h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:10",
					"waitsAtSource": 0,
					"distance": 4200
				},
				{
					"from": "Morăreni h.",
					"to": "Râpa de Jos Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:17",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Râpa de Jos Hm.",
					"to": "Monor Gledin",
					"leavesAt": "06:18",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Monor Gledin",
					"to": "Şieuţ h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Şieuţ h.",
					"to": "Şieu Hm.",
					"leavesAt": "06:38",
					"arrivesAt": "06:44",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Şieu Hm.",
					"to": "Bârla pe Şieu h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Bârla pe Şieu h.",
					"to": "Mărişelu Hm.",
					"leavesAt": "06:51",
					"arrivesAt": "06:56",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Mărişelu Hm.",
					"to": "Domneşti pe Şieu h.",
					"leavesAt": "06:57",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Domneşti pe Şieu h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "07:01",
					"arrivesAt": "07:09",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "07:21",
					"arrivesAt": "07:31",
					"waitsAtSource": 720,
					"distance": 9800
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "07:32",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7566",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "04:24",
					"arrivesAt": "04:37",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "04:38",
					"arrivesAt": "04:44",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Independenţa Hm.",
					"leavesAt": "04:45",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 20900
				},
				{
					"from": "Independenţa Hm.",
					"to": "Piscu h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Piscu h.",
					"to": "Vameş h.",
					"leavesAt": "05:14",
					"arrivesAt": "05:18",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Vameş h.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "05:19",
					"arrivesAt": "05:25",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "05:26",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Şerbăneşti h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Lieşti",
					"leavesAt": "05:38",
					"arrivesAt": "05:41",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lieşti",
					"to": "Buceşti h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Buceşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "05:46",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Iveşti Hm.",
					"to": "Umbrăreşti h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Barcea",
					"leavesAt": "05:57",
					"arrivesAt": "06:02",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Barcea",
					"to": "Malul Alb h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Malul Alb h.",
					"to": "Tecuci",
					"leavesAt": "06:07",
					"arrivesAt": "06:17",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Tecuci",
					"to": "Cosmeşti Hm.",
					"leavesAt": "06:18",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "06:26",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "06:32",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1887",
			"segments": [
				{
					"from": "Titu",
					"to": "Nucet",
					"leavesAt": "17:40",
					"arrivesAt": "17:51",
					"waitsAtSource": 0,
					"distance": 15400
				},
				{
					"from": "Nucet",
					"to": "Târgovişte",
					"leavesAt": "17:52",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 16300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8443",
			"segments": [
				{
					"from": "Ciulniţa",
					"to": "Ştefan Vodă h.",
					"leavesAt": "06:39",
					"arrivesAt": "06:53",
					"waitsAtSource": 0,
					"distance": 12600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "06:54",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Km. 25+700 h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Km. 25+700 h.",
					"to": "Călăraşi Sud",
					"leavesAt": "07:08",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 1300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2027",
			"segments": [
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "01:45",
					"arrivesAt": "01:57",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "01:58",
					"arrivesAt": "02:08",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Brănişca Hm.",
					"leavesAt": "02:09",
					"arrivesAt": "02:17",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Ilia",
					"leavesAt": "02:18",
					"arrivesAt": "02:31",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Ilia",
					"to": "Gurasada Hm.",
					"leavesAt": "02:32",
					"arrivesAt": "02:39",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Gurasada Hm.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "02:40",
					"arrivesAt": "02:47",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Zam",
					"leavesAt": "02:48",
					"arrivesAt": "03:04",
					"waitsAtSource": 60,
					"distance": 12600
				},
				{
					"from": "Zam",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "03:16",
					"arrivesAt": "03:20",
					"waitsAtSource": 720,
					"distance": 3900
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Ilteu",
					"leavesAt": "03:21",
					"arrivesAt": "03:28",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Ilteu",
					"to": "Toc h.",
					"leavesAt": "03:29",
					"arrivesAt": "03:32",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Toc h.",
					"to": "Săvârşin",
					"leavesAt": "03:33",
					"arrivesAt": "03:42",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Săvârşin",
					"to": "Vărădia h.",
					"leavesAt": "03:43",
					"arrivesAt": "03:50",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vărădia h.",
					"to": "Vărădia Hm.",
					"leavesAt": "03:51",
					"arrivesAt": "03:56",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vărădia Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "03:57",
					"arrivesAt": "04:02",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "04:03",
					"arrivesAt": "04:10",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Căpruţa h.",
					"leavesAt": "04:11",
					"arrivesAt": "04:16",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Căpruţa h.",
					"to": "Bârzava",
					"leavesAt": "04:17",
					"arrivesAt": "04:22",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bârzava",
					"to": "Conop Hm.",
					"leavesAt": "04:23",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Conop Hm.",
					"to": "Corfeni h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Corfeni h.",
					"to": "Milova",
					"leavesAt": "04:41",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Milova",
					"to": "Radna",
					"leavesAt": "04:48",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Radna",
					"to": "Păuliş Hm.",
					"leavesAt": "05:01",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Păuliş Hm.",
					"to": "Păuliş h.",
					"leavesAt": "05:14",
					"arrivesAt": "05:19",
					"waitsAtSource": 300,
					"distance": 3000
				},
				{
					"from": "Păuliş h.",
					"to": "Ghioroc",
					"leavesAt": "05:20",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Ghioroc",
					"to": "Glogovăţ",
					"leavesAt": "05:28",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Glogovăţ",
					"to": "Arad",
					"leavesAt": "05:41",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "06:07",
					"arrivesAt": "06:13",
					"waitsAtSource": 1080,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Valea Viilor Hm.",
					"leavesAt": "06:14",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Şag Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Şag Hm.",
					"to": "Vinga Hm.",
					"leavesAt": "06:31",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vinga Hm.",
					"to": "Orţişoara",
					"leavesAt": "06:38",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Orţişoara",
					"to": "Băile Călacea",
					"leavesAt": "06:44",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Băile Călacea",
					"to": "Sânandrei Hm.",
					"leavesAt": "06:53",
					"arrivesAt": "06:59",
					"waitsAtSource": 240,
					"distance": 7200
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "07:00",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h",
					"leavesAt": "07:07",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Ronaţ Triaj Cab 1 h",
					"leavesAt": "07:10",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab 1 h",
					"to": "Timişoara Nord",
					"leavesAt": "07:13",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3547",
			"segments": [
				{
					"from": "Odorhei",
					"to": "Odorhei Sud hc.",
					"leavesAt": "16:45",
					"arrivesAt": "16:49",
					"waitsAtSource": 0,
					"distance": 1200
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Feliceni h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Feliceni h.",
					"to": "Dobeni h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Lutiţa h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Lutiţa h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Beteşti h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Beteşti h.",
					"to": "Cristur Hm.",
					"leavesAt": "17:29",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Cristur Hm.",
					"to": "Sântămaria h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:43",
					"waitsAtSource": 420,
					"distance": 3000
				},
				{
					"from": "Sântămaria h.",
					"to": "Săcuienii Noi h.",
					"leavesAt": "17:44",
					"arrivesAt": "17:49",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Săcuienii Noi h.",
					"to": "Vânători",
					"leavesAt": "17:50",
					"arrivesAt": "17:57",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Vânători",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "17:58",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Sighişoara",
					"leavesAt": "18:06",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6415",
			"segments": [
				{
					"from": "Vaslui",
					"to": "Bălteni Hm.",
					"leavesAt": "18:29",
					"arrivesAt": "18:39",
					"waitsAtSource": 0,
					"distance": 9800
				},
				{
					"from": "Bălteni Hm.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "18:46",
					"arrivesAt": "18:51",
					"waitsAtSource": 420,
					"distance": 4200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bârzeşti h.",
					"leavesAt": "18:52",
					"arrivesAt": "18:56",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bârzeşti h.",
					"to": "Buhăieşti",
					"leavesAt": "18:57",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhăieşti",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "19:06",
					"arrivesAt": "19:11",
					"waitsAtSource": 120,
					"distance": 3900
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Rebricea Hm.",
					"leavesAt": "19:12",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebricea Hm.",
					"to": "Scânteia Hm.",
					"leavesAt": "19:19",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Scânteia Hm.",
					"to": "Grajduri",
					"leavesAt": "19:26",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Grajduri",
					"to": "Bârnova Hm.",
					"leavesAt": "19:36",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "19:45",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Ciurea Hm.",
					"leavesAt": "19:52",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ciurea Hm.",
					"to": "Nicolina",
					"leavesAt": "19:59",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "20:06",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2709",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Dep Petroşani h.",
					"leavesAt": "15:18",
					"arrivesAt": "15:21",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Petroşani Triaj h.",
					"leavesAt": "15:22",
					"arrivesAt": "15:24",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Petroşani Triaj h.",
					"to": "Peştera Bolii h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Băniţa",
					"leavesAt": "15:30",
					"arrivesAt": "15:38",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Băniţa",
					"to": "Merişor Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Merişor Hm.",
					"to": "Crivadia Hm.",
					"leavesAt": "15:51",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Crivadia Hm.",
					"to": "Baru Mare h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Baru Mare h.",
					"to": "Baru Mare",
					"leavesAt": "16:08",
					"arrivesAt": "16:14",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Baru Mare",
					"to": "Livadia h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Livadia h.",
					"to": "Ponor h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ponor h.",
					"to": "Pui",
					"leavesAt": "16:22",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Pui",
					"to": "Ruşor h.",
					"leavesAt": "16:28",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Ruşor h.",
					"to": "Băeşti Hm.",
					"leavesAt": "16:33",
					"arrivesAt": "16:36",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Ciopea h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:42",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ciopea h.",
					"to": "Subcetate",
					"leavesAt": "16:43",
					"arrivesAt": "16:47",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Subcetate",
					"to": "Covragiu h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:11",
					"waitsAtSource": 1260,
					"distance": 2600
				},
				{
					"from": "Covragiu h.",
					"to": "Plopi h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Plopi h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "17:15",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Măceu h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măceu h.",
					"to": "Ruşi h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ruşi h.",
					"to": "Călan Hm.",
					"leavesAt": "17:25",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Călan Hm.",
					"to": "Călan Băi",
					"leavesAt": "17:36",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Băi",
					"to": "Batiz h.",
					"leavesAt": "17:41",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Batiz h.",
					"to": "Băcia Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Băcia Hm.",
					"to": "Băcia h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Băcia h.",
					"to": "Simeria Triaj",
					"leavesAt": "17:50",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Simeria Triaj",
					"to": "Simeria",
					"leavesAt": "17:54",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20180114",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180203",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180616",
					"daysOfWeek": 799
				},
				{
					"from": "20180701",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180909",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9021",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Depoul Buc.Triaj h.(300)",
					"leavesAt": "06:30",
					"arrivesAt": "06:40",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Depoul Buc.Triaj h.(300)",
					"to": "Chitila",
					"leavesAt": "06:41",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "06:45",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "06:54",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "07:08",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "07:20",
					"arrivesAt": "07:29",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "07:39",
					"arrivesAt": "07:42",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "07:43",
					"arrivesAt": "07:50",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Fusea Hm.",
					"leavesAt": "07:52",
					"arrivesAt": "08:00",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Fusea Hm.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "08:01",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Cojocaru h.",
					"leavesAt": "08:08",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Cojocaru h.",
					"to": "Găeşti Sud h.",
					"leavesAt": "08:15",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Găeşti Sud h.",
					"to": "Găeşti",
					"leavesAt": "08:20",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Găeşti",
					"to": "Pătroaia Hm.",
					"leavesAt": "08:28",
					"arrivesAt": "08:36",
					"waitsAtSource": 120,
					"distance": 8300
				},
				{
					"from": "Pătroaia Hm.",
					"to": "Leordeni Argeş",
					"leavesAt": "08:37",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Leordeni Argeş",
					"to": "Călineşti Hm.",
					"leavesAt": "08:46",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Călineşti Hm.",
					"to": "Goleşti",
					"leavesAt": "08:54",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Goleşti",
					"to": "Ram. Goleşti",
					"leavesAt": "09:05",
					"arrivesAt": "09:09",
					"waitsAtSource": 120,
					"distance": 3200
				},
				{
					"from": "Ram. Goleşti",
					"to": "Piteşti",
					"leavesAt": "09:10",
					"arrivesAt": "09:20",
					"waitsAtSource": 30,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5584",
			"segments": [
				{
					"from": "Botoşani",
					"to": "Leorda Hm.",
					"leavesAt": "21:04",
					"arrivesAt": "21:28",
					"waitsAtSource": 0,
					"distance": 15500
				},
				{
					"from": "Leorda Hm.",
					"to": "Bucecea Hm",
					"leavesAt": "21:40",
					"arrivesAt": "21:59",
					"waitsAtSource": 720,
					"distance": 9900
				},
				{
					"from": "Bucecea Hm",
					"to": "Vereşti",
					"leavesAt": "22:00",
					"arrivesAt": "22:24",
					"waitsAtSource": 60,
					"distance": 19100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8024",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "14:50",
					"arrivesAt": "14:56",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "14:57",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "15:05",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "15:11",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "15:16",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "15:21",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "15:29",
					"arrivesAt": "15:36",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "15:37",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "15:55",
					"arrivesAt": "16:02",
					"waitsAtSource": 540,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "16:03",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Ramificaţia Borcea",
					"leavesAt": "16:13",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "16:32",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Feteşti",
					"to": "Bărăganu Hm.",
					"leavesAt": "16:39",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Jegălia",
					"leavesAt": "16:55",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Jegălia",
					"to": "Recolta hc.",
					"leavesAt": "17:00",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Recolta hc.",
					"to": "Perişoru Hm.",
					"leavesAt": "17:04",
					"arrivesAt": "17:07",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Perişoru Hm.",
					"to": "Ogoarele h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:19",
					"waitsAtSource": 540,
					"distance": 3300
				},
				{
					"from": "Ogoarele h.",
					"to": "Ciulniţa",
					"leavesAt": "17:20",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 9000
				},
				{
					"from": "Ciulniţa",
					"to": "Ivăneşti h.",
					"leavesAt": "17:29",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ivăneşti h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "17:35",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Bogdana h.",
					"leavesAt": "17:41",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Bogdana h.",
					"to": "Dâlga h.",
					"leavesAt": "17:45",
					"arrivesAt": "17:51",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Dâlga h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "17:52",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:07",
					"waitsAtSource": 420,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Lehliu",
					"leavesAt": "18:08",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lehliu",
					"to": "Preasna h.",
					"leavesAt": "18:14",
					"arrivesAt": "18:19",
					"waitsAtSource": 120,
					"distance": 8800
				},
				{
					"from": "Preasna h.",
					"to": "Săruleşti",
					"leavesAt": "18:20",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Săruleşti",
					"to": "Mostiştea h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:37",
					"waitsAtSource": 420,
					"distance": 5900
				},
				{
					"from": "Mostiştea h.",
					"to": "Fundulea Hm.",
					"leavesAt": "18:38",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Fundulea Hm.",
					"to": "Islaz h.",
					"leavesAt": "18:44",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Islaz h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "18:51",
					"arrivesAt": "18:54",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Brăneşti Sat h.",
					"leavesAt": "18:55",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Pasărea",
					"leavesAt": "18:58",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Pasărea",
					"to": "Pantelimon",
					"leavesAt": "19:11",
					"arrivesAt": "19:17",
					"waitsAtSource": 420,
					"distance": 6000
				},
				{
					"from": "Pantelimon",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "19:18",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Bucureşti Obor",
					"leavesAt": "19:21",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20180420",
					"to": "20180915",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2103",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "14:35",
					"arrivesAt": "14:41",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Ghimbav Hm.",
					"leavesAt": "14:42",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "14:50",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Codlea Hm.",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "15:07",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Valea Homorod h.",
					"leavesAt": "15:13",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Valea Homorod h.",
					"to": "Brădet Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:29",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Brădet Hm.",
					"to": "Perşani h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Şercaia Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:48",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Şercaia Hm.",
					"to": "Şercaia h.",
					"leavesAt": "15:49",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 1200
				},
				{
					"from": "Şercaia h.",
					"to": "Mândra Oltului h.",
					"leavesAt": "15:52",
					"arrivesAt": "15:59",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Făgăraş",
					"leavesAt": "16:00",
					"arrivesAt": "16:06",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Făgăraş",
					"to": "Beclean pe Olt h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 240,
					"distance": 5200
				},
				{
					"from": "Beclean pe Olt h.",
					"to": "Dridif h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:20",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Dridif h.",
					"to": "Voila Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Voila Hm.",
					"to": "Olteţ h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:52",
					"waitsAtSource": 1140,
					"distance": 6100
				},
				{
					"from": "Olteţ h.",
					"to": "Viştea h.",
					"leavesAt": "16:53",
					"arrivesAt": "16:57",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Viştea h.",
					"to": "Ucea",
					"leavesAt": "16:58",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ucea",
					"to": "Arpaş Hm.",
					"leavesAt": "17:08",
					"arrivesAt": "17:17",
					"waitsAtSource": 300,
					"distance": 5100
				},
				{
					"from": "Arpaş Hm.",
					"to": "Cârţa h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cârţa h.",
					"to": "Scoreiu h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:26",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Scoreiu h.",
					"to": "Sărata Colun h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:30",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Sărata Colun h.",
					"to": "Porumbacu Hm.",
					"leavesAt": "17:31",
					"arrivesAt": "17:36",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Avrig Hm.",
					"to": "Mârşa h.",
					"leavesAt": "17:46",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Mârşa h.",
					"to": "Racoviţa h.",
					"leavesAt": "17:51",
					"arrivesAt": "17:54",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Racoviţa h.",
					"to": "Sebeş Olt h.",
					"leavesAt": "17:55",
					"arrivesAt": "17:58",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Podu Olt",
					"leavesAt": "17:59",
					"arrivesAt": "18:04",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "18:05",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "18:23",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:31",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "18:32",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Atelier Zona h.",
					"leavesAt": "18:37",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu",
					"leavesAt": "18:41",
					"arrivesAt": "18:45",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5423",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "04:29",
					"arrivesAt": "04:40",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "04:41",
					"arrivesAt": "04:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "04:46",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "04:52",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "05:11",
					"arrivesAt": "05:15",
					"waitsAtSource": 600,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "05:16",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "05:24",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "05:32",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "05:39",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "05:43",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani Triaj",
					"leavesAt": "05:59",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Paşcani Triaj",
					"to": "Paşcani",
					"leavesAt": "06:05",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "06:31",
					"arrivesAt": "06:45",
					"waitsAtSource": 1140,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "06:46",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "07:03",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Podu Iloaiei",
					"leavesAt": "07:14",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "07:25",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "07:33",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1786",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "11:00",
					"arrivesAt": "11:11",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "11:12",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "11:36",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "11:57",
					"arrivesAt": "12:37",
					"waitsAtSource": 120,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3086",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "16:42",
					"arrivesAt": "16:52",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "16:53",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "16:58",
					"arrivesAt": "17:04",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Cojocna Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cojocna Hm.",
					"to": "Tunel Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tunel Hm.",
					"to": "Boju",
					"leavesAt": "17:20",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Boju",
					"to": "Valea Florilor Hm.",
					"leavesAt": "17:29",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Ploscoş h.",
					"leavesAt": "17:42",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ploscoş h.",
					"to": "Cânepişti h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:53",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cânepişti h.",
					"to": "Câmpia Turzii",
					"leavesAt": "17:54",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Câmpia Turzii",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "18:03",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Grindeni h.",
					"leavesAt": "18:11",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Grindeni h.",
					"to": "Războieni",
					"leavesAt": "18:18",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "18:23",
					"arrivesAt": "18:27",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Unirea Hm.",
					"leavesAt": "18:28",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea Hm.",
					"to": "Decea h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Decea h.",
					"to": "Mirăslău h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Mirăslău h.",
					"to": "Aiud Hm.",
					"leavesAt": "18:44",
					"arrivesAt": "18:51",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "18:52",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Coşlariu Gr. P. Mureş",
					"leavesAt": "19:11",
					"arrivesAt": "19:18",
					"waitsAtSource": 300,
					"distance": 3400
				},
				{
					"from": "Coşlariu Gr. P. Mureş",
					"to": "Mihalţ h.",
					"leavesAt": "19:19",
					"arrivesAt": "19:21",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Mihalţ h.",
					"to": "Cistei h.",
					"leavesAt": "19:22",
					"arrivesAt": "19:27",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Cistei h.",
					"to": "Crăciunel Hm.",
					"leavesAt": "19:28",
					"arrivesAt": "19:38",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Crăciunel Hm.",
					"to": "Blaj",
					"leavesAt": "19:42",
					"arrivesAt": "19:50",
					"waitsAtSource": 240,
					"distance": 5300
				},
				{
					"from": "Blaj",
					"to": "Câmpu Libertăţii  h.",
					"leavesAt": "20:00",
					"arrivesAt": "20:04",
					"waitsAtSource": 600,
					"distance": 3500
				},
				{
					"from": "Câmpu Libertăţii  h.",
					"to": "Mănărade h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:09",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Mănărade h.",
					"to": "Glogoveţ h.",
					"leavesAt": "20:10",
					"arrivesAt": "20:13",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Glogoveţ h.",
					"to": "Valea Lungă Hm.",
					"leavesAt": "20:14",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Lunca h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:26",
					"waitsAtSource": 300,
					"distance": 2100
				},
				{
					"from": "Lunca h.",
					"to": "Micăsasa h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:36",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Micăsasa h.",
					"to": "Copşa Mică",
					"leavesAt": "20:37",
					"arrivesAt": "20:54",
					"waitsAtSource": 30,
					"distance": 10200
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "20:55",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "21:03",
					"arrivesAt": "21:10",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Bratei h.",
					"leavesAt": "21:22",
					"arrivesAt": "21:30",
					"waitsAtSource": 720,
					"distance": 5100
				},
				{
					"from": "Bratei h.",
					"to": "Aţel Hm.",
					"leavesAt": "21:31",
					"arrivesAt": "21:39",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Aţel Hm.",
					"to": "Dumbrăveni",
					"leavesAt": "21:40",
					"arrivesAt": "21:50",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Dumbrăveni",
					"to": "Luna h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Luna h.",
					"to": "Daneş Hm.",
					"leavesAt": "21:59",
					"arrivesAt": "22:06",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Daneş Hm.",
					"to": "Sighişoara",
					"leavesAt": "22:07",
					"arrivesAt": "22:23",
					"waitsAtSource": 60,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2564",
			"segments": [
				{
					"from": "Beia Hm.",
					"to": "Archita h",
					"leavesAt": "05:30",
					"arrivesAt": "05:41",
					"waitsAtSource": 0,
					"distance": 8700
				},
				{
					"from": "Archita h",
					"to": "Mureni Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:56",
					"waitsAtSource": 30,
					"distance": 9600
				},
				{
					"from": "Mureni Hm.",
					"to": "Saschiz h.",
					"leavesAt": "05:57",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Saschiz h.",
					"to": "Vânători",
					"leavesAt": "06:02",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vânători",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Sighişoara",
					"leavesAt": "06:15",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Sighişoara",
					"to": "Daneş Hm.",
					"leavesAt": "06:29",
					"arrivesAt": "06:45",
					"waitsAtSource": 300,
					"distance": 9500
				},
				{
					"from": "Daneş Hm.",
					"to": "Luna h.",
					"leavesAt": "06:50",
					"arrivesAt": "06:57",
					"waitsAtSource": 300,
					"distance": 4900
				},
				{
					"from": "Luna h.",
					"to": "Dumbrăveni",
					"leavesAt": "06:58",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Dumbrăveni",
					"to": "Aţel Hm.",
					"leavesAt": "07:06",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Aţel Hm.",
					"to": "Bratei h.",
					"leavesAt": "07:16",
					"arrivesAt": "07:25",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Bratei h.",
					"to": "Mediaş",
					"leavesAt": "07:26",
					"arrivesAt": "07:35",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:45",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "07:46",
					"arrivesAt": "07:53",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Axente Sever h.",
					"leavesAt": "07:55",
					"arrivesAt": "08:00",
					"waitsAtSource": 120,
					"distance": 2700
				},
				{
					"from": "Axente Sever h.",
					"to": "Agârbiciu h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Agârbiciu h.",
					"to": "Şeica Mare",
					"leavesAt": "08:08",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şeica Mare",
					"to": "Şeica Mare h.",
					"leavesAt": "08:20",
					"arrivesAt": "08:22",
					"waitsAtSource": 360,
					"distance": 1400
				},
				{
					"from": "Şeica Mare h.",
					"to": "Veşeud h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Veşeud h.",
					"to": "Hăşag h.",
					"leavesAt": "08:29",
					"arrivesAt": "08:34",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Hăşag h.",
					"to": "Loamneş Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:40",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Loamneş Hm.",
					"to": "Mândra h.",
					"leavesAt": "08:41",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mândra h.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:53",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 120,
					"distance": 2100
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Sibiu h.(203)",
					"leavesAt": "09:03",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Sibiu",
					"leavesAt": "09:13",
					"arrivesAt": "09:17",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5076",
			"segments": [
				{
					"from": "Buzău",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "19:34",
					"arrivesAt": "19:44",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Ulmeni",
					"leavesAt": "19:45",
					"arrivesAt": "19:50",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "19:51",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "19:56",
					"arrivesAt": "20:06",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "20:07",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:33",
					"waitsAtSource": 600,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "20:34",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "20:39",
					"arrivesAt": "20:44",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "20:45",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "20:48",
					"arrivesAt": "20:55",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "20:56",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "21:04",
					"arrivesAt": "21:11",
					"waitsAtSource": 60,
					"distance": 4300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8370",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "06:45",
					"arrivesAt": "06:52",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "06:53",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "06:59",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "07:13",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "07:18",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "07:30",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "07:37",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "07:50",
					"arrivesAt": "08:05",
					"waitsAtSource": 300,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180427",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5706",
			"segments": [
				{
					"from": "Vatra Dornei",
					"to": "Argestru Hm.",
					"leavesAt": "14:55",
					"arrivesAt": "15:01",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Argestru Hm.",
					"to": "Iacobeni",
					"leavesAt": "15:02",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Iacobeni",
					"to": "Mestecăniş",
					"leavesAt": "15:13",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Valea Putnei P.M.",
					"leavesAt": "15:24",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Valea Putnei P.M.",
					"to": "Pojorâta Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Sadova Hm.",
					"leavesAt": "15:47",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sadova Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "15:53",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "16:06",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Vama",
					"leavesAt": "16:16",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Vama",
					"to": "Molid Hm.",
					"leavesAt": "16:23",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Molid Hm.",
					"to": "Frasin",
					"leavesAt": "16:29",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "16:37",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Gura Humorului Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:14",
					"waitsAtSource": 480,
					"distance": 7900
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "17:23",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Stroieşti",
					"leavesAt": "17:32",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Stroieşti",
					"to": "Suceava Vest",
					"leavesAt": "17:45",
					"arrivesAt": "17:54",
					"waitsAtSource": 300,
					"distance": 9400
				},
				{
					"from": "Suceava Vest",
					"to": "Suceava",
					"leavesAt": "17:55",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9160",
			"segments": [
				{
					"from": "Reşiţa Sud Hm.",
					"to": "Reşiţa Nord",
					"leavesAt": "05:45",
					"arrivesAt": "05:54",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Reşiţa Nord",
					"to": "Bănila Câlnic h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Ezeriş h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:10",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Ezeriş h.",
					"to": "Brebu",
					"leavesAt": "06:11",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Brebu",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "06:24",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Valea Păltinişului h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Caransebeş",
					"leavesAt": "06:45",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5404",
			"segments": [
				{
					"from": "Bacău",
					"to": "Letea h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:51",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Letea h.",
					"to": "Valea Seacă",
					"leavesAt": "16:52",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Seacă",
					"to": "Siretu Bacău h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Faraoani Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Faraoani Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Răcăciuni h.",
					"to": "Orbeni Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Orbeni Hm.",
					"to": "Sascut Hm.",
					"leavesAt": "17:28",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Sascut Hm.",
					"to": "Şişcani h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Şişcani h.",
					"to": "Adjudu Vechi h.",
					"leavesAt": "17:42",
					"arrivesAt": "17:46",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Adjud",
					"leavesAt": "17:47",
					"arrivesAt": "17:51",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "17:52",
					"arrivesAt": "18:00",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "18:01",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:16",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "18:17",
					"arrivesAt": "18:27",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4412",
			"segments": [
				{
					"from": "Halmeu",
					"to": "Porumbeşti Hm.",
					"leavesAt": "21:40",
					"arrivesAt": "21:46",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Micula Hm.",
					"leavesAt": "21:47",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Micula Hm.",
					"to": "Ram. Botiz h.",
					"leavesAt": "21:55",
					"arrivesAt": "22:03",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Satu Mare",
					"leavesAt": "22:04",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "380",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "06:15",
					"arrivesAt": "07:06",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "07:08",
					"arrivesAt": "07:41",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "07:43",
					"arrivesAt": "08:19",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "08:22",
					"arrivesAt": "08:53",
					"waitsAtSource": 180,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "08:55",
					"arrivesAt": "09:33",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "09:36",
					"arrivesAt": "09:58",
					"waitsAtSource": 180,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "10:00",
					"arrivesAt": "10:26",
					"waitsAtSource": 120,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "10:29",
					"arrivesAt": "11:07",
					"waitsAtSource": 180,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "11:22",
					"arrivesAt": "11:51",
					"waitsAtSource": 900,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Paşcani",
					"leavesAt": "11:52",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 40200
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "12:23",
					"arrivesAt": "12:43",
					"waitsAtSource": 120,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "12:44",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "13:02",
					"arrivesAt": "13:14",
					"waitsAtSource": 120,
					"distance": 14800
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "13:17",
					"arrivesAt": "13:22",
					"waitsAtSource": 180,
					"distance": 2500
				},
				{
					"from": "Suceava Nord",
					"to": "Dorneşti",
					"leavesAt": "13:40",
					"arrivesAt": "14:10",
					"waitsAtSource": 1080,
					"distance": 30000
				},
				{
					"from": "Dorneşti",
					"to": "Vicşani",
					"leavesAt": "14:11",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Vicşani",
					"to": "Vadu Siretului",
					"leavesAt": "15:19",
					"arrivesAt": "15:41",
					"waitsAtSource": 3240,
					"distance": 10600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9190",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "14:18",
					"arrivesAt": "14:24",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Remetea Mare",
					"leavesAt": "14:28",
					"arrivesAt": "14:42",
					"waitsAtSource": 240,
					"distance": 9600
				},
				{
					"from": "Remetea Mare",
					"to": "Izvin h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Izvin h.",
					"to": "Recaş",
					"leavesAt": "14:52",
					"arrivesAt": "14:55",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Recaş",
					"to": "Şuştra h.",
					"leavesAt": "14:56",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Şuştra h.",
					"to": "Topolovăţ",
					"leavesAt": "15:03",
					"arrivesAt": "15:06",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Topolovăţ",
					"to": "Chizătău Hm.",
					"leavesAt": "15:07",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Chizătău Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "15:14",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Belinţ Hm.",
					"to": "Lugoj",
					"leavesAt": "15:19",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 13200
				},
				{
					"from": "Lugoj",
					"to": "Găvojdia",
					"leavesAt": "15:31",
					"arrivesAt": "15:40",
					"waitsAtSource": 120,
					"distance": 11900
				},
				{
					"from": "Găvojdia",
					"to": "Jena Hm.",
					"leavesAt": "15:41",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Jena Hm.",
					"to": "Sacu h.",
					"leavesAt": "15:52",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sacu h.",
					"to": "Căvăran",
					"leavesAt": "15:56",
					"arrivesAt": "15:59",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Căvăran",
					"to": "Zăgujeni Hm.",
					"leavesAt": "16:00",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Tibiscu h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tibiscu h.",
					"to": "Caransebeş",
					"leavesAt": "16:15",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2184",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Lugoj Nord h.",
					"leavesAt": "08:04",
					"arrivesAt": "08:08",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Lugoj Nord h.",
					"to": "Coşteiu Mare Hm.",
					"leavesAt": "08:09",
					"arrivesAt": "08:16",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Coşteiu Mare Hm.",
					"to": "Păru h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Păru h.",
					"to": "Balinţ h.",
					"leavesAt": "08:21",
					"arrivesAt": "08:26",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Balinţ h.",
					"to": "Nevrincea h.",
					"leavesAt": "08:27",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Nevrincea h.",
					"to": "Cliciova",
					"leavesAt": "08:33",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Cliciova",
					"to": "Susani Bega h.",
					"leavesAt": "08:54",
					"arrivesAt": "09:00",
					"waitsAtSource": 900,
					"distance": 3500
				},
				{
					"from": "Susani Bega h.",
					"to": "Traian Vuia h.",
					"leavesAt": "09:01",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Traian Vuia h.",
					"to": "Mănăştur Hm.",
					"leavesAt": "09:06",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Mănăştur Hm.",
					"to": "Răchita h.",
					"leavesAt": "09:13",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Răchita h.",
					"to": "Făget",
					"leavesAt": "09:19",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Făget",
					"to": "Margina",
					"leavesAt": "09:38",
					"arrivesAt": "09:51",
					"waitsAtSource": 720,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1642",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "17:52",
					"arrivesAt": "18:09",
					"waitsAtSource": 0,
					"distance": 14600
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Mireşu Mare PM.",
					"leavesAt": "18:10",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "18:21",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Benesat Hm.",
					"leavesAt": "18:29",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Benesat Hm.",
					"to": "Jibou",
					"leavesAt": "18:39",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Jibou",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "19:09",
					"arrivesAt": "19:17",
					"waitsAtSource": 720,
					"distance": 6800
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Letca Hm.",
					"leavesAt": "19:23",
					"arrivesAt": "19:46",
					"waitsAtSource": 360,
					"distance": 16300
				},
				{
					"from": "Letca Hm.",
					"to": "Ileanda",
					"leavesAt": "19:47",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 13600
				},
				{
					"from": "Ileanda",
					"to": "Gâlgău",
					"leavesAt": "20:05",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Gâlgău",
					"to": "Câţcău h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Câţcău h.",
					"to": "Dej Călători",
					"leavesAt": "20:34",
					"arrivesAt": "20:48",
					"waitsAtSource": 30,
					"distance": 12700
				},
				{
					"from": "Dej Călători",
					"to": "Beclean pe Someş",
					"leavesAt": "21:02",
					"arrivesAt": "21:35",
					"waitsAtSource": 840,
					"distance": 24600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Sărăţel Hm.",
					"leavesAt": "21:37",
					"arrivesAt": "22:03",
					"waitsAtSource": 120,
					"distance": 24900
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Deda",
					"leavesAt": "22:04",
					"arrivesAt": "22:58",
					"waitsAtSource": 60,
					"distance": 46800
				},
				{
					"from": "Deda",
					"to": "Topliţa",
					"leavesAt": "23:02",
					"arrivesAt": "23:59",
					"waitsAtSource": 240,
					"distance": 43900
				},
				{
					"from": "Topliţa",
					"to": "Gheorgheni",
					"leavesAt": "00:06",
					"arrivesAt": "00:39",
					"waitsAtSource": 420,
					"distance": 34000
				},
				{
					"from": "Gheorgheni",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "00:41",
					"arrivesAt": "00:57",
					"waitsAtSource": 120,
					"distance": 19100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Izvoru Oltului",
					"leavesAt": "00:58",
					"arrivesAt": "01:10",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Izvoru Oltului",
					"to": "Siculeni",
					"leavesAt": "01:12",
					"arrivesAt": "01:32",
					"waitsAtSource": 120,
					"distance": 17100
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "01:37",
					"arrivesAt": "01:46",
					"waitsAtSource": 300,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "01:48",
					"arrivesAt": "02:11",
					"waitsAtSource": 120,
					"distance": 28500
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "02:13",
					"arrivesAt": "02:45",
					"waitsAtSource": 120,
					"distance": 34400
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Braşov",
					"leavesAt": "02:47",
					"arrivesAt": "03:17",
					"waitsAtSource": 120,
					"distance": 32100
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "03:32",
					"arrivesAt": "04:09",
					"waitsAtSource": 900,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Sinaia",
					"leavesAt": "04:11",
					"arrivesAt": "04:32",
					"waitsAtSource": 120,
					"distance": 19000
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "04:34",
					"arrivesAt": "04:58",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "05:00",
					"arrivesAt": "05:11",
					"waitsAtSource": 120,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Ploieşti Vest",
					"leavesAt": "05:12",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 18600
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "05:29",
					"arrivesAt": "06:14",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20180501",
					"to": "20180523",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180425",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6827",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Buşag Hm.",
					"leavesAt": "04:33",
					"arrivesAt": "04:50",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Buşag Hm.",
					"to": "Cicârlău h.",
					"leavesAt": "04:51",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cicârlău h.",
					"to": "Ilba h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:07",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Ilba h.",
					"to": "Săbişa h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:12",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săbişa h.",
					"to": "Seini",
					"leavesAt": "05:13",
					"arrivesAt": "05:19",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Seini",
					"to": "Apa Hm.",
					"leavesAt": "05:20",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Apa Hm.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "05:33",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Odoreu h.",
					"leavesAt": "05:44",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Odoreu h.",
					"to": "Botiz Hm.",
					"leavesAt": "05:54",
					"arrivesAt": "05:59",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Botiz Hm.",
					"to": "Satu Mare",
					"leavesAt": "06:00",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Satu Mare",
					"to": "Satu Mare Sud",
					"leavesAt": "06:21",
					"arrivesAt": "06:26",
					"waitsAtSource": 900,
					"distance": 3100
				},
				{
					"from": "Satu Mare Sud",
					"to": "Sătmărel h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Sătmărel h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "06:34",
					"arrivesAt": "06:44",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Moftin h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Moftin h.",
					"to": "Domăneşti h.",
					"leavesAt": "06:50",
					"arrivesAt": "06:55",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Domăneşti h.",
					"to": "Carei",
					"leavesAt": "06:56",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Carei",
					"to": "Marna h.",
					"leavesAt": "07:10",
					"arrivesAt": "07:18",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Marna h.",
					"to": "Sanislău Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Sanislău Hm.",
					"to": "Resighea h.",
					"leavesAt": "07:25",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Resighea h.",
					"to": "Curtuiuşeni h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Valea lui Mihai",
					"leavesAt": "07:41",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Valea lui Mihai",
					"to": "Nyirabrany",
					"leavesAt": "08:15",
					"arrivesAt": "08:30",
					"waitsAtSource": 1560,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4548",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "19:18",
					"arrivesAt": "19:26",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "19:27",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "19:40",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Periş Mureş h.",
					"leavesAt": "19:45",
					"arrivesAt": "19:50",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Periş Mureş h.",
					"to": "Petelea h.",
					"leavesAt": "19:51",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Petelea h.",
					"to": "Reghin",
					"leavesAt": "19:57",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Reghin",
					"to": "Ideciu de Jos h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:16",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "20:17",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Halta Aluniş h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "20:29",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Ruşii Munţi h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Deda",
					"leavesAt": "20:39",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1890",
			"segments": [
				{
					"from": "Craiova",
					"to": "Balş",
					"leavesAt": "04:25",
					"arrivesAt": "04:55",
					"waitsAtSource": 0,
					"distance": 31200
				},
				{
					"from": "Balş",
					"to": "Piatra Olt",
					"leavesAt": "04:56",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 12900
				},
				{
					"from": "Piatra Olt",
					"to": "Slatina",
					"leavesAt": "05:09",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Slatina",
					"to": "Stolnici Hm.",
					"leavesAt": "05:30",
					"arrivesAt": "06:10",
					"waitsAtSource": 120,
					"distance": 43300
				},
				{
					"from": "Stolnici Hm.",
					"to": "Costeşti",
					"leavesAt": "06:11",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 15900
				},
				{
					"from": "Costeşti",
					"to": "Piteşti",
					"leavesAt": "06:26",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "07:00",
					"arrivesAt": "07:11",
					"waitsAtSource": 600,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "07:19",
					"arrivesAt": "07:42",
					"waitsAtSource": 480,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "07:43",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "08:03",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5021",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "12:22",
					"arrivesAt": "12:31",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "12:32",
					"arrivesAt": "12:38",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "12:39",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "12:44",
					"arrivesAt": "12:51",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "12:58",
					"arrivesAt": "13:02",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "13:03",
					"arrivesAt": "13:07",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "13:08",
					"arrivesAt": "13:16",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "13:17",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8385",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "12:20",
					"arrivesAt": "12:33",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "12:39",
					"arrivesAt": "12:46",
					"waitsAtSource": 360,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "12:47",
					"arrivesAt": "12:52",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "12:53",
					"arrivesAt": "12:59",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "13:00",
					"arrivesAt": "13:07",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "13:08",
					"arrivesAt": "13:11",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "13:12",
					"arrivesAt": "13:20",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "13:21",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "13:26",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180427",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1859",
			"segments": [
				{
					"from": "Bacău",
					"to": "Hămeiuş P.M.",
					"leavesAt": "21:50",
					"arrivesAt": "21:59",
					"waitsAtSource": 0,
					"distance": 7900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Gârleni Hm.",
					"leavesAt": "22:00",
					"arrivesAt": "22:06",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Gârleni Hm.",
					"to": "Buhuşi",
					"leavesAt": "22:07",
					"arrivesAt": "22:20",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Buhuşi",
					"to": "Podoleni Hm.",
					"leavesAt": "22:21",
					"arrivesAt": "22:34",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Podoleni Hm.",
					"to": "Roznov",
					"leavesAt": "22:35",
					"arrivesAt": "22:45",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Roznov",
					"to": "Piatra Neamţ",
					"leavesAt": "22:53",
					"arrivesAt": "23:09",
					"waitsAtSource": 480,
					"distance": 15200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9531",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Piteşti Nord",
					"leavesAt": "13:40",
					"arrivesAt": "13:48",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Piteşti Nord",
					"to": "C.I.L. h.",
					"leavesAt": "13:49",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "C.I.L. h.",
					"to": "Bascov Hm.",
					"leavesAt": "13:53",
					"arrivesAt": "13:55",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Bascov Hm.",
					"to": "Merişani h.",
					"leavesAt": "13:56",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Merişani h.",
					"to": "Băiculeşti h.",
					"leavesAt": "14:06",
					"arrivesAt": "14:17",
					"waitsAtSource": 30,
					"distance": 11300
				},
				{
					"from": "Băiculeşti h.",
					"to": "Curtea de Argeş",
					"leavesAt": "14:18",
					"arrivesAt": "14:29",
					"waitsAtSource": 30,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2070",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Atelier Zona h.",
					"leavesAt": "16:07",
					"arrivesAt": "16:10",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "16:14",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Mohu h.",
					"leavesAt": "16:18",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Mohu h.",
					"to": "Veştem h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:25",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Veştem h.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "16:26",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "16:36",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "16:44",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "16:50",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Râu Vadului h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Râu Vadului h.",
					"to": "Câineni",
					"leavesAt": "17:14",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Robeşti h.",
					"leavesAt": "17:32",
					"arrivesAt": "17:38",
					"waitsAtSource": 540,
					"distance": 5400
				},
				{
					"from": "Robeşti h.",
					"to": "Balota h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Balota h.",
					"to": "Cornet Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cornet Hm.",
					"to": "Beţel h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Beţel h.",
					"to": "Lotru",
					"leavesAt": "17:54",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Lotru",
					"to": "Cozia Hm.",
					"leavesAt": "18:03",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cozia Hm.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "18:12",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Păuşa h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:23",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "18:24",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Dăeşti Hm.",
					"leavesAt": "18:30",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "18:38",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "18:47",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "18:53",
					"arrivesAt": "18:56",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Ostroveni h.",
					"leavesAt": "19:10",
					"arrivesAt": "19:12",
					"waitsAtSource": 840,
					"distance": 1000
				},
				{
					"from": "Ostroveni h.",
					"to": "Răstoaca h.",
					"leavesAt": "19:13",
					"arrivesAt": "19:16",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Răstoaca h.",
					"to": "Râureni",
					"leavesAt": "19:17",
					"arrivesAt": "19:20",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Râureni",
					"to": "Râureni hc.",
					"leavesAt": "19:21",
					"arrivesAt": "19:24",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni hc.",
					"to": "Govora",
					"leavesAt": "19:25",
					"arrivesAt": "19:30",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Govora",
					"to": "Tătărani h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Tătărani h.",
					"to": "Băbeni",
					"leavesAt": "19:37",
					"arrivesAt": "19:44",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Băbeni",
					"to": "Slăviteşti hc.",
					"leavesAt": "20:10",
					"arrivesAt": "20:15",
					"waitsAtSource": 1560,
					"distance": 3200
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Ioneşti Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Fişcălia Hm.",
					"leavesAt": "20:28",
					"arrivesAt": "20:32",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "20:33",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Orleşti hc.",
					"to": "Zăvideni Hm.",
					"leavesAt": "20:37",
					"arrivesAt": "20:43",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Călina h.",
					"leavesAt": "20:44",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Călina h.",
					"to": "Drăgăşani",
					"leavesAt": "20:49",
					"arrivesAt": "20:58",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Drăgăşani",
					"to": "Zlătărei Hm.",
					"leavesAt": "21:00",
					"arrivesAt": "21:07",
					"waitsAtSource": 120,
					"distance": 6600
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Strejeşti",
					"leavesAt": "21:08",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Strejeşti",
					"to": "Colibaşi h.",
					"leavesAt": "21:25",
					"arrivesAt": "21:32",
					"waitsAtSource": 660,
					"distance": 5800
				},
				{
					"from": "Colibaşi h.",
					"to": "Arceşti Hm.",
					"leavesAt": "21:33",
					"arrivesAt": "21:40",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Arceşti Hm.",
					"to": "Găneasa Olt h.",
					"leavesAt": "21:41",
					"arrivesAt": "21:47",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Găneasa Olt h.",
					"to": "Găneasa h.",
					"leavesAt": "21:48",
					"arrivesAt": "21:51",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Găneasa h.",
					"to": "Piatra Olt",
					"leavesAt": "21:52",
					"arrivesAt": "22:00",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Piatra Olt",
					"to": "Brăneţ h.",
					"leavesAt": "22:14",
					"arrivesAt": "22:21",
					"waitsAtSource": 840,
					"distance": 7700
				},
				{
					"from": "Brăneţ h.",
					"to": "Canton 217 h.",
					"leavesAt": "22:22",
					"arrivesAt": "22:26",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Canton 217 h.",
					"to": "Balş",
					"leavesAt": "22:27",
					"arrivesAt": "22:30",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Balş",
					"to": "Spineni h.",
					"leavesAt": "22:31",
					"arrivesAt": "22:35",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Spineni h.",
					"to": "Robăneşti Hm.",
					"leavesAt": "22:36",
					"arrivesAt": "22:44",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Robăneşti Hm.",
					"to": "Toporaş h.",
					"leavesAt": "22:45",
					"arrivesAt": "22:50",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Toporaş h.",
					"to": "Cârcea h.",
					"leavesAt": "22:51",
					"arrivesAt": "23:01",
					"waitsAtSource": 30,
					"distance": 9100
				},
				{
					"from": "Cârcea h.",
					"to": "Bordei hc.(901)",
					"leavesAt": "23:02",
					"arrivesAt": "23:09",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Craiova",
					"leavesAt": "23:10",
					"arrivesAt": "23:15",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9192",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "14:18",
					"arrivesAt": "14:24",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Remetea Mare",
					"leavesAt": "14:28",
					"arrivesAt": "14:42",
					"waitsAtSource": 240,
					"distance": 9600
				},
				{
					"from": "Remetea Mare",
					"to": "Izvin h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Izvin h.",
					"to": "Recaş",
					"leavesAt": "14:52",
					"arrivesAt": "14:55",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Recaş",
					"to": "Şuştra h.",
					"leavesAt": "14:56",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Şuştra h.",
					"to": "Topolovăţ",
					"leavesAt": "15:03",
					"arrivesAt": "15:06",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Topolovăţ",
					"to": "Chizătău Hm.",
					"leavesAt": "15:07",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Chizătău Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "15:14",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Belinţ Hm.",
					"to": "Lugoj",
					"leavesAt": "15:19",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 13200
				},
				{
					"from": "Lugoj",
					"to": "Găvojdia",
					"leavesAt": "15:31",
					"arrivesAt": "15:40",
					"waitsAtSource": 120,
					"distance": 11900
				},
				{
					"from": "Găvojdia",
					"to": "Jena Hm.",
					"leavesAt": "15:41",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Jena Hm.",
					"to": "Sacu h.",
					"leavesAt": "15:52",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sacu h.",
					"to": "Căvăran",
					"leavesAt": "15:56",
					"arrivesAt": "15:59",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Căvăran",
					"to": "Zăgujeni Hm.",
					"leavesAt": "16:00",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Tibiscu h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tibiscu h.",
					"to": "Caransebeş",
					"leavesAt": "16:15",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Caransebeş",
					"to": "Caransebeş haltă h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:25",
					"waitsAtSource": 120,
					"distance": 1600
				},
				{
					"from": "Caransebeş haltă h.",
					"to": "Balta Sărată",
					"leavesAt": "16:26",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Balta Sărată",
					"to": "Valea Timişului Hm.",
					"leavesAt": "16:31",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Valea Timişului Hm.",
					"to": "Petroşniţa h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Petroşniţa h.",
					"to": "Vălişoara Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Vălişoara Hm.",
					"to": "Slatina Timiş",
					"leavesAt": "16:48",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Slatina Timiş",
					"to": "Armeniş",
					"leavesAt": "16:55",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Armeniş",
					"to": "Teregova Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Teregova Hm.",
					"to": "Poarta Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Poarta Hm.",
					"to": "Luncaviţa h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Luncaviţa h.",
					"to": "Domaşnea Cornea Hm.",
					"leavesAt": "17:27",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2086",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "16:10",
					"arrivesAt": "16:17",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Budieni h.",
					"leavesAt": "16:18",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Budieni h.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "16:23",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Pojogeni Hm.",
					"leavesAt": "16:28",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "16:35",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cărbuneşti",
					"to": "Jupâneşti Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:52",
					"waitsAtSource": 300,
					"distance": 5400
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "17:01",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Musculeşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "17:09",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "17:15",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Gilort Hm.",
					"leavesAt": "17:25",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gilort Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "17:38",
					"arrivesAt": "17:41",
					"waitsAtSource": 360,
					"distance": 3700
				},
				{
					"from": "Floreşti hc.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:48",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Bungeţel h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bungeţel h.",
					"to": "Filiaşi",
					"leavesAt": "17:53",
					"arrivesAt": "17:57",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "18:02",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:18",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "18:23",
					"arrivesAt": "18:28",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "18:29",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "18:32",
					"arrivesAt": "18:36",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "18:37",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "18:41",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 416
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5024",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Brazi",
					"leavesAt": "06:03",
					"arrivesAt": "06:16",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "06:35",
					"arrivesAt": "06:40",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:54",
					"waitsAtSource": 360,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "06:55",
					"arrivesAt": "06:59",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "07:00",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Basarab",
					"leavesAt": "07:10",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 8700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "402",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "19:15",
					"arrivesAt": "20:10",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Buzău",
					"leavesAt": "20:13",
					"arrivesAt": "21:21",
					"waitsAtSource": 180,
					"distance": 68600
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "21:29",
					"arrivesAt": "22:02",
					"waitsAtSource": 480,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "22:03",
					"arrivesAt": "22:43",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "22:45",
					"arrivesAt": "23:12",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "23:13",
					"arrivesAt": "23:41",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "23:43",
					"arrivesAt": "00:28",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "00:36",
					"arrivesAt": "01:10",
					"waitsAtSource": 480,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Paşcani Triaj",
					"leavesAt": "01:11",
					"arrivesAt": "01:43",
					"waitsAtSource": 60,
					"distance": 37900
				},
				{
					"from": "Paşcani Triaj",
					"to": "Iaşi",
					"leavesAt": "01:46",
					"arrivesAt": "02:50",
					"waitsAtSource": 180,
					"distance": 76200
				},
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "03:10",
					"arrivesAt": "03:17",
					"waitsAtSource": 1200,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "03:19",
					"arrivesAt": "03:47",
					"waitsAtSource": 120,
					"distance": 19000
				},
				{
					"from": "Ungheni Prut Hm.",
					"to": "Ungheni Prut Fr.",
					"leavesAt": "04:37",
					"arrivesAt": "04:39",
					"waitsAtSource": 3000,
					"distance": 600
				},
				{
					"from": "Ungheni Prut Fr.",
					"to": "Ungheni",
					"leavesAt": "04:59",
					"arrivesAt": "05:02",
					"waitsAtSource": 1200,
					"distance": 800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5210",
			"segments": [
				{
					"from": "Ghimeş",
					"to": "Palanca Hm.",
					"leavesAt": "16:10",
					"arrivesAt": "16:16",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Palanca Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "16:17",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Simbrea Hm.",
					"leavesAt": "16:23",
					"arrivesAt": "16:28",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Simbrea Hm.",
					"to": "Goioasa Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Goioasa Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "16:38",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Caraliţa h.",
					"to": "Asău Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Asău Hm.",
					"to": "Comăneşti",
					"leavesAt": "16:54",
					"arrivesAt": "17:03",
					"waitsAtSource": 360,
					"distance": 5100
				},
				{
					"from": "Comăneşti",
					"to": "Valea Uzului Hm.",
					"leavesAt": "17:04",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Dofteana Bacău",
					"leavesAt": "17:18",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Dofteana Bacău",
					"to": "Cireşoaia h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cireşoaia h.",
					"to": "Saline hc.",
					"leavesAt": "17:31",
					"arrivesAt": "17:37",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Saline hc.",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "17:38",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Viişoara h",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Viişoara h",
					"to": "Trotuş h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:53",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Trotuş h.",
					"to": "Oneşti",
					"leavesAt": "17:54",
					"arrivesAt": "18:04",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Oneşti",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Borzeşti Bacău",
					"leavesAt": "18:10",
					"arrivesAt": "18:17",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Căiuţi Hm.",
					"leavesAt": "18:18",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Bâlca hc.",
					"leavesAt": "18:26",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Bâlca hc.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:38",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Urecheşti Hm.",
					"leavesAt": "18:39",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Adjud",
					"leavesAt": "18:44",
					"arrivesAt": "18:56",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "19:17",
					"arrivesAt": "19:24",
					"waitsAtSource": 1260,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "19:25",
					"arrivesAt": "19:28",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "19:29",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "19:37",
					"arrivesAt": "19:41",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "19:42",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "20:09",
					"arrivesAt": "20:18",
					"waitsAtSource": 1020,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "20:19",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Focşani",
					"to": "Coteşti Hm.",
					"leavesAt": "20:35",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Coteşti Hm.",
					"to": "Gugeşti",
					"leavesAt": "20:43",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Gugeşti",
					"to": "Sihlea Hm.",
					"leavesAt": "20:52",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sihlea Hm.",
					"to": "Voetin h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Voetin h.",
					"to": "Râmnicu Sărat",
					"leavesAt": "21:07",
					"arrivesAt": "21:16",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Zoita Hm.",
					"leavesAt": "21:17",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Zoita Hm.",
					"to": "Boboc Hm.",
					"leavesAt": "21:28",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Boboc Hm.",
					"to": "Buzău",
					"leavesAt": "21:38",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 11500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1782",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "06:00",
					"arrivesAt": "06:11",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "06:12",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "06:37",
					"arrivesAt": "06:56",
					"waitsAtSource": 120,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "07:04",
					"arrivesAt": "07:43",
					"waitsAtSource": 480,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4076",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:58",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "13:59",
					"arrivesAt": "14:03",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "14:04",
					"arrivesAt": "14:10",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "14:11",
					"arrivesAt": "14:27",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180120",
					"to": "20180121",
					"daysOfWeek": 383
				},
				{
					"from": "20180124",
					"to": "20180124",
					"daysOfWeek": 383
				},
				{
					"from": "20180127",
					"to": "20180128",
					"daysOfWeek": 383
				},
				{
					"from": "20180203",
					"to": "20180211",
					"daysOfWeek": 383
				},
				{
					"from": "20180217",
					"to": "20180218",
					"daysOfWeek": 383
				},
				{
					"from": "20180224",
					"to": "20180225",
					"daysOfWeek": 383
				},
				{
					"from": "20180303",
					"to": "20180304",
					"daysOfWeek": 383
				},
				{
					"from": "20180310",
					"to": "20180311",
					"daysOfWeek": 383
				},
				{
					"from": "20180317",
					"to": "20180318",
					"daysOfWeek": 383
				},
				{
					"from": "20180324",
					"to": "20180325",
					"daysOfWeek": 383
				},
				{
					"from": "20180331",
					"to": "20180410",
					"daysOfWeek": 383
				},
				{
					"from": "20180414",
					"to": "20180415",
					"daysOfWeek": 383
				},
				{
					"from": "20180421",
					"to": "20180422",
					"daysOfWeek": 383
				},
				{
					"from": "20180428",
					"to": "20180429",
					"daysOfWeek": 383
				},
				{
					"from": "20180501",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180505",
					"to": "20180506",
					"daysOfWeek": 383
				},
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180526",
					"to": "20180528",
					"daysOfWeek": 383
				},
				{
					"from": "20180601",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180610",
					"daysOfWeek": 383
				},
				{
					"from": "20180616",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180922",
					"to": "20180923",
					"daysOfWeek": 383
				},
				{
					"from": "20180929",
					"to": "20180930",
					"daysOfWeek": 383
				},
				{
					"from": "20181006",
					"to": "20181007",
					"daysOfWeek": 383
				},
				{
					"from": "20181013",
					"to": "20181014",
					"daysOfWeek": 383
				},
				{
					"from": "20181020",
					"to": "20181021",
					"daysOfWeek": 383
				},
				{
					"from": "20181027",
					"to": "20181028",
					"daysOfWeek": 383
				},
				{
					"from": "20181103",
					"to": "20181104",
					"daysOfWeek": 383
				},
				{
					"from": "20181110",
					"to": "20181111",
					"daysOfWeek": 383
				},
				{
					"from": "20181117",
					"to": "20181118",
					"daysOfWeek": 383
				},
				{
					"from": "20181124",
					"to": "20181125",
					"daysOfWeek": 383
				},
				{
					"from": "20181130",
					"to": "20181202",
					"daysOfWeek": 383
				},
				{
					"from": "20181208",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 383
				},
				{
					"from": "20171216",
					"to": "20171217",
					"daysOfWeek": 383
				},
				{
					"from": "20171223",
					"to": "20180114",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5611",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "05:04",
					"arrivesAt": "05:18",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "05:19",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "05:27",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "05:33",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "05:41",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "05:58",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "06:03",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "06:13",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:33",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "06:34",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "06:51",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "06:57",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "07:11",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "07:18",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "07:25",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "07:32",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "07:41",
					"arrivesAt": "07:47",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20180531",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9056",
			"segments": [
				{
					"from": "Turnu Măgurele",
					"to": "Km. 231+600 h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:52",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Km. 231+600 h.",
					"to": "Salcia Teleorman Hm.",
					"leavesAt": "14:53",
					"arrivesAt": "15:17",
					"waitsAtSource": 30,
					"distance": 14500
				},
				{
					"from": "Salcia Teleorman Hm.",
					"to": "Roşiori Hm.",
					"leavesAt": "15:18",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 22700
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "15:47",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 320
				},
				{
					"from": "20171210",
					"to": "20180407",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9618",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "16:27",
					"arrivesAt": "16:36",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Giroc h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Giroc h.",
					"to": "Semenic Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Semenic Hm.",
					"to": "Urseni h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Urseni h.",
					"to": "Uliuc h.",
					"leavesAt": "16:51",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Uliuc h.",
					"to": "Sacoşu Mic",
					"leavesAt": "16:59",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Sacoşu Mic",
					"to": "Chevereş h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Chevereş h.",
					"to": "Bacova h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bacova h.",
					"to": "Buziaş",
					"leavesAt": "17:17",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Buziaş",
					"to": "Căpăt h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Căpăt h.",
					"to": "Sinia Hm.",
					"leavesAt": "17:30",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Sinia Hm.",
					"to": "Boldur h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Boldur h.",
					"to": "Lugoj",
					"leavesAt": "17:42",
					"arrivesAt": "17:56",
					"waitsAtSource": 30,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2707",
			"segments": [
				{
					"from": "Simeria",
					"to": "Săuleşti h.",
					"leavesAt": "14:10",
					"arrivesAt": "14:15",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Săuleşti h.",
					"to": "Deva",
					"leavesAt": "14:16",
					"arrivesAt": "14:23",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "14:24",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Mintia h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:36",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Veţel h.",
					"leavesAt": "14:37",
					"arrivesAt": "14:39",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Veţel h.",
					"to": "Brănişca Hm.",
					"leavesAt": "14:40",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Ilia",
					"leavesAt": "14:51",
					"arrivesAt": "14:58",
					"waitsAtSource": 30,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4403",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Ram. Botiz h.",
					"leavesAt": "07:41",
					"arrivesAt": "07:47",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Micula Hm.",
					"leavesAt": "07:48",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Micula Hm.",
					"to": "Porumbeşti Hm.",
					"leavesAt": "07:58",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Halmeu",
					"leavesAt": "08:06",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5465",
			"segments": [
				{
					"from": "Bacău",
					"to": "Hămeiuş P.M.",
					"leavesAt": "14:38",
					"arrivesAt": "14:47",
					"waitsAtSource": 0,
					"distance": 7900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Gârleni Hm.",
					"leavesAt": "14:48",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Gârleni Hm.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Racova h.",
					"leavesAt": "15:03",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Racova h.",
					"to": "Buhuşi",
					"leavesAt": "15:09",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Buhuşi",
					"to": "Costişa h.",
					"leavesAt": "15:17",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Costişa h.",
					"to": "Podoleni Hm.",
					"leavesAt": "15:25",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Podoleni Hm.",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "15:34",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Roznov",
					"leavesAt": "15:42",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Roznov",
					"to": "Săvineşti h.",
					"leavesAt": "15:48",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Săvineşti h.",
					"to": "Dumbrava h.",
					"leavesAt": "15:54",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Piatra Neamţ",
					"leavesAt": "16:03",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1982",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "11:30",
					"arrivesAt": "11:54",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Feteşti",
					"leavesAt": "11:55",
					"arrivesAt": "12:29",
					"waitsAtSource": 60,
					"distance": 44000
				},
				{
					"from": "Feteşti",
					"to": "Bucureşti Nord",
					"leavesAt": "12:31",
					"arrivesAt": "13:50",
					"waitsAtSource": 120,
					"distance": 146400
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9134",
			"segments": [
				{
					"from": "Calafat",
					"to": "Golenţi Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:26",
					"waitsAtSource": 0,
					"distance": 11800
				},
				{
					"from": "Golenţi Hm.",
					"to": "Maglavit h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Maglavit h.",
					"to": "Moţăţei Hm.",
					"leavesAt": "06:43",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Moţăţei Hm.",
					"to": "Băileşti",
					"leavesAt": "06:59",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 12800
				},
				{
					"from": "Băileşti",
					"to": "Boureni P.M.",
					"leavesAt": "07:22",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Boureni P.M.",
					"to": "Siliştea Crucii h.",
					"leavesAt": "07:35",
					"arrivesAt": "07:39",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Siliştea Crucii h.",
					"to": "Afumaţi h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:48",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Afumaţi h.",
					"to": "Urzica Mare h.",
					"leavesAt": "07:49",
					"arrivesAt": "08:01",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Urzica Mare h.",
					"to": "Portăreşti Hm.",
					"leavesAt": "08:02",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Portăreşti Hm.",
					"to": "Cerăt h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cerăt h.",
					"to": "Segarcea",
					"leavesAt": "08:18",
					"arrivesAt": "08:24",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Segarcea",
					"to": "Segarcea Nord hc.",
					"leavesAt": "08:25",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Segarcea Nord hc.",
					"to": "Sălcuţa Hm.",
					"leavesAt": "08:28",
					"arrivesAt": "08:40",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Sălcuţa Hm.",
					"to": "Podari",
					"leavesAt": "08:49",
					"arrivesAt": "09:03",
					"waitsAtSource": 540,
					"distance": 13800
				},
				{
					"from": "Podari",
					"to": "R. 1 Jiu",
					"leavesAt": "09:04",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "R. 1 Jiu",
					"to": "Jiu Hm.",
					"leavesAt": "09:12",
					"arrivesAt": "09:15",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Jiu Hm.",
					"to": "Bordei hc.(913)",
					"leavesAt": "09:16",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Bordei hc.(913)",
					"to": "Craiova",
					"leavesAt": "09:20",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5583",
			"segments": [
				{
					"from": "Vereşti",
					"to": "Bucecea Hm",
					"leavesAt": "18:03",
					"arrivesAt": "18:27",
					"waitsAtSource": 0,
					"distance": 19100
				},
				{
					"from": "Bucecea Hm",
					"to": "Leorda Hm.",
					"leavesAt": "18:28",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Leorda Hm.",
					"to": "Botoşani",
					"leavesAt": "18:46",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 15500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1862",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "22:29",
					"arrivesAt": "22:35",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Bârnova Hm.",
					"leavesAt": "22:37",
					"arrivesAt": "22:59",
					"waitsAtSource": 120,
					"distance": 16300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Buhăieşti",
					"leavesAt": "23:00",
					"arrivesAt": "23:22",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Buhăieşti",
					"to": "Vaslui",
					"leavesAt": "23:23",
					"arrivesAt": "23:41",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Vaslui",
					"to": "Crasna",
					"leavesAt": "23:46",
					"arrivesAt": "00:00",
					"waitsAtSource": 300,
					"distance": 15500
				},
				{
					"from": "Crasna",
					"to": "Bârlad",
					"leavesAt": "00:01",
					"arrivesAt": "00:34",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Bârlad",
					"to": "Tecuci Nord hc.(605)",
					"leavesAt": "00:39",
					"arrivesAt": "01:24",
					"waitsAtSource": 300,
					"distance": 48600
				},
				{
					"from": "Tecuci Nord hc.(605)",
					"to": "Mărăşeşti",
					"leavesAt": "01:26",
					"arrivesAt": "01:52",
					"waitsAtSource": 120,
					"distance": 17800
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "02:10",
					"arrivesAt": "02:34",
					"waitsAtSource": 1080,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "02:36",
					"arrivesAt": "03:13",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "03:15",
					"arrivesAt": "03:47",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Făurei",
					"leavesAt": "04:07",
					"arrivesAt": "04:45",
					"waitsAtSource": 1200,
					"distance": 40400
				},
				{
					"from": "Făurei",
					"to": "Spicu",
					"leavesAt": "04:47",
					"arrivesAt": "05:12",
					"waitsAtSource": 120,
					"distance": 36400
				},
				{
					"from": "Spicu",
					"to": "Ţăndărei",
					"leavesAt": "05:13",
					"arrivesAt": "05:29",
					"waitsAtSource": 60,
					"distance": 21700
				},
				{
					"from": "Ţăndărei",
					"to": "Platoneşti h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:37",
					"waitsAtSource": 120,
					"distance": 6000
				},
				{
					"from": "Platoneşti h.",
					"to": "Movila Hm.",
					"leavesAt": "05:38",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Movila Hm.",
					"to": "Feteşti",
					"leavesAt": "05:48",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 16700
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "06:07",
					"arrivesAt": "06:27",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "06:28",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Palas",
					"leavesAt": "06:46",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 30600
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "07:04",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180501",
					"to": "20180523",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20180607",
					"daysOfWeek": 383
				},
				{
					"from": "20180909",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180425",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6505",
			"segments": [
				{
					"from": "Ungheni Prut Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "15:11",
					"arrivesAt": "15:19",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Holboca Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Holboca Hm.",
					"to": "Remiza T Socola h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Remiza T Socola h.",
					"to": "Socola",
					"leavesAt": "15:34",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Socola",
					"to": "Nicolina",
					"leavesAt": "15:41",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "15:47",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20170107",
					"to": "20170205",
					"daysOfWeek": 799
				},
				{
					"from": "20170211",
					"to": "20170418",
					"daysOfWeek": 799
				},
				{
					"from": "20170422",
					"to": "20170423",
					"daysOfWeek": 799
				},
				{
					"from": "20170429",
					"to": "20170618",
					"daysOfWeek": 799
				},
				{
					"from": "20170624",
					"to": "20170625",
					"daysOfWeek": 799
				},
				{
					"from": "20170701",
					"to": "20170702",
					"daysOfWeek": 799
				},
				{
					"from": "20170709",
					"to": "20170709",
					"daysOfWeek": 799
				},
				{
					"from": "20170715",
					"to": "20170716",
					"daysOfWeek": 799
				},
				{
					"from": "20170722",
					"to": "20170723",
					"daysOfWeek": 799
				},
				{
					"from": "20170729",
					"to": "20170730",
					"daysOfWeek": 799
				},
				{
					"from": "20170805",
					"to": "20170806",
					"daysOfWeek": 799
				},
				{
					"from": "20170812",
					"to": "20170813",
					"daysOfWeek": 799
				},
				{
					"from": "20170819",
					"to": "20170820",
					"daysOfWeek": 799
				},
				{
					"from": "20170826",
					"to": "20170827",
					"daysOfWeek": 799
				},
				{
					"from": "20170902",
					"to": "20170903",
					"daysOfWeek": 799
				},
				{
					"from": "20170909",
					"to": "20171209",
					"daysOfWeek": 799
				},
				{
					"from": "20161211",
					"to": "20161223",
					"daysOfWeek": 799
				},
				{
					"from": "20161225",
					"to": "20161225",
					"daysOfWeek": 799
				},
				{
					"from": "20161231",
					"to": "20170101",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3085",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Daneş Hm.",
					"leavesAt": "04:54",
					"arrivesAt": "05:10",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Daneş Hm.",
					"to": "Luna h.",
					"leavesAt": "05:11",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Luna h.",
					"to": "Dumbrăveni",
					"leavesAt": "05:19",
					"arrivesAt": "05:26",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Dumbrăveni",
					"to": "Aţel Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Aţel Hm.",
					"to": "Bratei h.",
					"leavesAt": "05:37",
					"arrivesAt": "05:46",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Bratei h.",
					"to": "Mediaş",
					"leavesAt": "05:47",
					"arrivesAt": "05:56",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:08",
					"waitsAtSource": 240,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "06:09",
					"arrivesAt": "06:16",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Micăsasa h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Micăsasa h.",
					"to": "Lunca h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:44",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lunca h.",
					"to": "Valea Lungă Hm.",
					"leavesAt": "06:45",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Glogoveţ h.",
					"leavesAt": "06:51",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Glogoveţ h.",
					"to": "Mănărade h.",
					"leavesAt": "06:57",
					"arrivesAt": "07:00",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Mănărade h.",
					"to": "Câmpu Libertăţii  h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Câmpu Libertăţii  h.",
					"to": "Blaj",
					"leavesAt": "07:06",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Blaj",
					"to": "Crăciunel Hm.",
					"leavesAt": "07:15",
					"arrivesAt": "07:23",
					"waitsAtSource": 240,
					"distance": 5300
				},
				{
					"from": "Crăciunel Hm.",
					"to": "Cistei h.",
					"leavesAt": "07:24",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Cistei h.",
					"to": "Mihalţ h.",
					"leavesAt": "07:34",
					"arrivesAt": "07:39",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Mihalţ h.",
					"to": "Coşlariu Gr. P. Mureş",
					"leavesAt": "07:40",
					"arrivesAt": "07:44",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Coşlariu Gr. P. Mureş",
					"to": "Teiuş",
					"leavesAt": "07:45",
					"arrivesAt": "07:52",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "08:00",
					"arrivesAt": "08:12",
					"waitsAtSource": 480,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Mirăslău h.",
					"leavesAt": "08:13",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Mirăslău h.",
					"to": "Decea h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:22",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Decea h.",
					"to": "Unirea Hm.",
					"leavesAt": "08:23",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Unirea Hm.",
					"to": "Unirea hc.",
					"leavesAt": "08:29",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "08:33",
					"arrivesAt": "08:40",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Grindeni h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:18",
					"waitsAtSource": 2100,
					"distance": 2800
				},
				{
					"from": "Grindeni h.",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "09:19",
					"arrivesAt": "09:25",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Câmpia Turzii",
					"leavesAt": "09:26",
					"arrivesAt": "09:33",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cânepişti h.",
					"leavesAt": "09:34",
					"arrivesAt": "09:42",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Cânepişti h.",
					"to": "Ploscoş h.",
					"leavesAt": "09:43",
					"arrivesAt": "09:48",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ploscoş h.",
					"to": "Valea Florilor Hm.",
					"leavesAt": "09:49",
					"arrivesAt": "09:55",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Boju",
					"leavesAt": "09:56",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Boju",
					"to": "Tunel Hm.",
					"leavesAt": "10:08",
					"arrivesAt": "10:15",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Tunel Hm.",
					"to": "Cojocna Hm.",
					"leavesAt": "10:16",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cojocna Hm.",
					"to": "Apahida",
					"leavesAt": "10:24",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "10:31",
					"arrivesAt": "10:34",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "10:35",
					"arrivesAt": "10:42",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "10:43",
					"arrivesAt": "10:48",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "10:49",
					"arrivesAt": "10:54",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9052",
			"segments": [
				{
					"from": "Turnu Măgurele",
					"to": "Km. 231+600 h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:51",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Km. 231+600 h.",
					"to": "Salcia Teleorman Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "07:16",
					"waitsAtSource": 30,
					"distance": 14500
				},
				{
					"from": "Salcia Teleorman Hm.",
					"to": "Troian h.",
					"leavesAt": "07:17",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Troian h.",
					"to": "Km. 200+400 P.aj.m",
					"leavesAt": "07:29",
					"arrivesAt": "07:38",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Km. 200+400 P.aj.m",
					"to": "Roşiori Hm.",
					"leavesAt": "07:39",
					"arrivesAt": "07:47",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "07:48",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1941",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "15:20",
					"arrivesAt": "15:27",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "15:35",
					"arrivesAt": "15:40",
					"waitsAtSource": 480,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "15:42",
					"arrivesAt": "15:54",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "15:56",
					"arrivesAt": "16:00",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "16:10",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "16:20",
					"arrivesAt": "16:27",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:38",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "16:39",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "17:45",
					"arrivesAt": "18:12",
					"waitsAtSource": 2760,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "18:13",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "18:32",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "18:53",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Băneasa",
					"leavesAt": "19:20",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 102300
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Bucureşti Nord",
					"leavesAt": "20:24",
					"arrivesAt": "20:34",
					"waitsAtSource": 300,
					"distance": 6600
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "21:10",
					"arrivesAt": "21:50",
					"waitsAtSource": 2160,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Floreşti Prahova",
					"leavesAt": "21:52",
					"arrivesAt": "22:05",
					"waitsAtSource": 120,
					"distance": 18600
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "22:06",
					"arrivesAt": "22:18",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "22:19",
					"arrivesAt": "22:42",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "22:43",
					"arrivesAt": "22:51",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "22:52",
					"arrivesAt": "22:57",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "22:58",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "23:09",
					"arrivesAt": "23:46",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Sfântu Gheorghe",
					"leavesAt": "23:58",
					"arrivesAt": "00:27",
					"waitsAtSource": 720,
					"distance": 32100
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "00:29",
					"arrivesAt": "01:01",
					"waitsAtSource": 120,
					"distance": 34400
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "01:03",
					"arrivesAt": "01:26",
					"waitsAtSource": 120,
					"distance": 28500
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "01:28",
					"arrivesAt": "01:36",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Izvoru Oltului",
					"leavesAt": "01:40",
					"arrivesAt": "01:56",
					"waitsAtSource": 240,
					"distance": 17100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "01:57",
					"arrivesAt": "02:08",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Gheorgheni",
					"leavesAt": "02:09",
					"arrivesAt": "02:26",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Gheorgheni",
					"to": "Topliţa",
					"leavesAt": "02:27",
					"arrivesAt": "02:59",
					"waitsAtSource": 60,
					"distance": 34000
				},
				{
					"from": "Topliţa",
					"to": "Deda",
					"leavesAt": "03:00",
					"arrivesAt": "03:58",
					"waitsAtSource": 60,
					"distance": 43900
				},
				{
					"from": "Deda",
					"to": "Sărăţel Hm.",
					"leavesAt": "03:59",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 46800
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "05:08",
					"arrivesAt": "05:37",
					"waitsAtSource": 900,
					"distance": 24900
				},
				{
					"from": "Beclean pe Someş",
					"to": "Dej Călători",
					"leavesAt": "05:40",
					"arrivesAt": "06:15",
					"waitsAtSource": 180,
					"distance": 24600
				},
				{
					"from": "Dej Călători",
					"to": "Câţcău h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:56",
					"waitsAtSource": 1560,
					"distance": 12700
				},
				{
					"from": "Câţcău h.",
					"to": "Gâlgău",
					"leavesAt": "06:57",
					"arrivesAt": "07:08",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Gâlgău",
					"to": "Ileanda",
					"leavesAt": "07:09",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Ileanda",
					"to": "Răstoci Hm.",
					"leavesAt": "07:29",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Răstoci Hm.",
					"to": "Letca Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Letca Hm.",
					"to": "Jibou",
					"leavesAt": "07:49",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 23100
				},
				{
					"from": "Jibou",
					"to": "Benesat Hm.",
					"leavesAt": "08:22",
					"arrivesAt": "08:40",
					"waitsAtSource": 120,
					"distance": 18000
				},
				{
					"from": "Benesat Hm.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "08:41",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "08:51",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "08:59",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Baia Mare",
					"leavesAt": "09:11",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180529",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8801",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "14:15",
					"arrivesAt": "14:32",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "14:33",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "14:42",
					"arrivesAt": "14:48",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "14:49",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "14:58",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "15:07",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Pescăruş h.",
					"leavesAt": "15:12",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Pescăruş h.",
					"to": "Neptun hc.",
					"leavesAt": "15:19",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "15:27",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "15:40",
					"arrivesAt": "15:48",
					"waitsAtSource": 540,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8380",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "05:23",
					"arrivesAt": "05:30",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "05:31",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "05:35",
					"arrivesAt": "05:46",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "05:47",
					"arrivesAt": "05:50",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "05:58",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "06:07",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "06:14",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Agigea Nord",
					"leavesAt": "06:23",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Nord",
					"to": "Constanţa",
					"leavesAt": "06:30",
					"arrivesAt": "06:41",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4338",
			"segments": [
				{
					"from": "Halmeu",
					"to": "Porumbeşti Hm.",
					"leavesAt": "19:20",
					"arrivesAt": "19:26",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Micula Hm.",
					"leavesAt": "19:27",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Micula Hm.",
					"to": "Ram. Botiz h.",
					"leavesAt": "19:34",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Satu Mare",
					"leavesAt": "19:42",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Satu Mare",
					"to": "Satu Mare Sud",
					"leavesAt": "19:59",
					"arrivesAt": "20:04",
					"waitsAtSource": 780,
					"distance": 3100
				},
				{
					"from": "Satu Mare Sud",
					"to": "Sătmărel h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Sătmărel h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "20:12",
					"arrivesAt": "20:20",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Moftin h.",
					"leavesAt": "20:21",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Moftin h.",
					"to": "Domăneşti h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:28",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Domăneşti h.",
					"to": "Carei",
					"leavesAt": "20:29",
					"arrivesAt": "20:39",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Carei",
					"to": "Marna h.",
					"leavesAt": "20:46",
					"arrivesAt": "20:53",
					"waitsAtSource": 420,
					"distance": 6800
				},
				{
					"from": "Marna h.",
					"to": "Sanislău Hm.",
					"leavesAt": "20:54",
					"arrivesAt": "21:00",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Sanislău Hm.",
					"to": "Resighea h.",
					"leavesAt": "21:01",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Resighea h.",
					"to": "Curtuiuşeni h.",
					"leavesAt": "21:08",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Valea lui Mihai",
					"leavesAt": "21:16",
					"arrivesAt": "21:23",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Valea lui Mihai",
					"to": "Simion h.",
					"leavesAt": "21:24",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Simion h.",
					"to": "Şilindru Hm.",
					"leavesAt": "21:31",
					"arrivesAt": "21:37",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Şilindru Hm.",
					"to": "Săcuieni Bihor",
					"leavesAt": "21:38",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Cadia h.",
					"leavesAt": "21:47",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cadia h.",
					"to": "Diosig Hm.",
					"leavesAt": "21:55",
					"arrivesAt": "22:01",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Diosig Hm.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "22:02",
					"arrivesAt": "22:08",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Tămăşeu h.",
					"leavesAt": "22:09",
					"arrivesAt": "22:16",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tămăşeu h.",
					"to": "Biharia Hm.",
					"leavesAt": "22:17",
					"arrivesAt": "22:25",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Biharia Hm.",
					"to": "Episcopia Bihor",
					"leavesAt": "22:26",
					"arrivesAt": "22:36",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "22:37",
					"arrivesAt": "22:46",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5608",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "14:06",
					"arrivesAt": "14:11",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "14:13",
					"arrivesAt": "14:20",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "14:21",
					"arrivesAt": "14:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "14:29",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "14:36",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:48",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "14:49",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "15:05",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "15:11",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "15:17",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "15:31",
					"arrivesAt": "15:45",
					"waitsAtSource": 480,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "15:46",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "15:54",
					"arrivesAt": "15:59",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "16:00",
					"arrivesAt": "16:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "16:09",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "16:20",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "16:27",
					"arrivesAt": "16:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "16:34",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "16:42",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8588",
			"segments": [
				{
					"from": "Ciulniţa",
					"to": "Brâncoveni h.",
					"leavesAt": "18:51",
					"arrivesAt": "19:00",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Brâncoveni h.",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "19:01",
					"arrivesAt": "19:10",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Slobozia Veche",
					"leavesAt": "19:11",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 4200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2871",
			"segments": [
				{
					"from": "Rovinari Hm.",
					"to": "Km. 49+800 h.",
					"leavesAt": "07:20",
					"arrivesAt": "07:22",
					"waitsAtSource": 0,
					"distance": 1000
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rogojelu",
					"leavesAt": "07:24",
					"arrivesAt": "07:27",
					"waitsAtSource": 120,
					"distance": 1800
				},
				{
					"from": "Rogojelu",
					"to": "Vârţ h.",
					"leavesAt": "07:28",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Vârţ h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "07:33",
					"arrivesAt": "07:39",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Drăguţeşti h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Amaradia",
					"leavesAt": "07:44",
					"arrivesAt": "07:48",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Amaradia",
					"to": "Târgu Jiu",
					"leavesAt": "07:49",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20180526",
					"daysOfWeek": 383
				},
				{
					"from": "20180528",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9302",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Atârnaţi Hm.",
					"leavesAt": "03:30",
					"arrivesAt": "03:37",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "03:38",
					"arrivesAt": "03:46",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Vârtoapele hc.",
					"leavesAt": "03:47",
					"arrivesAt": "03:52",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Olteni",
					"leavesAt": "03:53",
					"arrivesAt": "04:02",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "04:03",
					"arrivesAt": "04:11",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Ciolpani Hm.",
					"leavesAt": "04:12",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Videle",
					"leavesAt": "04:19",
					"arrivesAt": "04:27",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Videle",
					"to": "Zăvestreni Hm.",
					"leavesAt": "04:28",
					"arrivesAt": "04:33",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "04:34",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "04:39",
					"arrivesAt": "04:46",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Zorile h.",
					"leavesAt": "04:54",
					"arrivesAt": "04:58",
					"waitsAtSource": 480,
					"distance": 5100
				},
				{
					"from": "Zorile h.",
					"to": "Grădinari",
					"leavesAt": "04:59",
					"arrivesAt": "05:08",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Grădinari",
					"to": "Domneştii de Sus h.",
					"leavesAt": "05:09",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Chiajna",
					"leavesAt": "05:15",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Chiajna",
					"to": "Bucureştii Noi",
					"leavesAt": "05:29",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Carpaţi h.(900)",
					"leavesAt": "05:33",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "05:37",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "05:41",
					"arrivesAt": "05:45",
					"waitsAtSource": 30,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8001",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "06:30",
					"arrivesAt": "06:39",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "06:40",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Pasărea",
					"leavesAt": "06:46",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pasărea",
					"to": "Brăneşti Sat h.",
					"leavesAt": "06:52",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "06:57",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Islaz h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Islaz h.",
					"to": "Fundulea Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 9800
				},
				{
					"from": "Fundulea Hm.",
					"to": "Mostiştea h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Mostiştea h.",
					"to": "Săruleşti",
					"leavesAt": "07:17",
					"arrivesAt": "07:22",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Săruleşti",
					"to": "Preasna h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:35",
					"waitsAtSource": 480,
					"distance": 7500
				},
				{
					"from": "Preasna h.",
					"to": "Lehliu",
					"leavesAt": "07:36",
					"arrivesAt": "07:44",
					"waitsAtSource": 30,
					"distance": 8800
				},
				{
					"from": "Lehliu",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "07:51",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dâlga h.",
					"leavesAt": "07:55",
					"arrivesAt": "08:00",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dâlga h.",
					"to": "Bogdana h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Bogdana h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "08:08",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Ciulniţa",
					"leavesAt": "08:22",
					"arrivesAt": "08:31",
					"waitsAtSource": 600,
					"distance": 13100
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "08:39",
					"arrivesAt": "08:42",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "08:43",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "08:47",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "09:02",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "09:12",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Ovidiu",
					"leavesAt": "09:19",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ovidiu",
					"to": "Dunărea Hm.",
					"leavesAt": "09:24",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Dunărea Hm.",
					"to": "Cernavodă Pod",
					"leavesAt": "09:31",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "09:41",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "09:50",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "09:56",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "10:05",
					"arrivesAt": "10:09",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "10:10",
					"arrivesAt": "10:13",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "10:14",
					"arrivesAt": "10:18",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "10:19",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "10:25",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "10:29",
					"arrivesAt": "10:33",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "10:34",
					"arrivesAt": "10:39",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "10:40",
					"arrivesAt": "10:49",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8383",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "07:34",
					"arrivesAt": "07:47",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "07:48",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "07:56",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "08:09",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "08:17",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Pescăruş h.",
					"leavesAt": "08:21",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Pescăruş h.",
					"to": "Neptun hc.",
					"leavesAt": "08:26",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "08:32",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "08:37",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180503",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9193",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Tibiscu h.",
					"leavesAt": "04:53",
					"arrivesAt": "04:57",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Tibiscu h.",
					"to": "Zăgujeni Hm.",
					"leavesAt": "04:58",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Căvăran",
					"leavesAt": "05:02",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Căvăran",
					"to": "Sacu h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Sacu h.",
					"to": "Jena Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Jena Hm.",
					"to": "Găvojdia",
					"leavesAt": "05:21",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Găvojdia",
					"to": "Tapia Hm.",
					"leavesAt": "05:32",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tapia Hm.",
					"to": "Lugoj",
					"leavesAt": "05:37",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lugoj",
					"to": "Belinţ Hm.",
					"leavesAt": "05:44",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 13200
				},
				{
					"from": "Belinţ Hm.",
					"to": "Chizătău Hm.",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Chizătău Hm.",
					"to": "Topolovăţ",
					"leavesAt": "06:02",
					"arrivesAt": "06:08",
					"waitsAtSource": 240,
					"distance": 7200
				},
				{
					"from": "Topolovăţ",
					"to": "Şuştra h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Şuştra h.",
					"to": "Recaş",
					"leavesAt": "06:13",
					"arrivesAt": "06:19",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Recaş",
					"to": "Izvin h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:31",
					"waitsAtSource": 540,
					"distance": 2200
				},
				{
					"from": "Izvin h.",
					"to": "Remetea Mare",
					"leavesAt": "06:32",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Remetea Mare",
					"to": "Timişoara Est",
					"leavesAt": "06:41",
					"arrivesAt": "06:55",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "06:56",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7036",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:57",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "14:58",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Moldoveni h.",
					"to": "Dridu Hm.",
					"leavesAt": "15:10",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Dridu Hm.",
					"to": "Fierbinţi",
					"leavesAt": "15:17",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Fierbinţi",
					"to": "Greci h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:38",
					"waitsAtSource": 540,
					"distance": 6100
				},
				{
					"from": "Greci h.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "15:46",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Baloteşti Hm.",
					"leavesAt": "15:52",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Baloteşti Hm.",
					"to": "P.O. Aeroport h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Mogoşoaia",
					"leavesAt": "16:02",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Mogoşoaia",
					"to": "Pajura Hm. (700)",
					"leavesAt": "16:12",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Carpaţi h.(700)",
					"leavesAt": "16:33",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Bucureşti Nord",
					"leavesAt": "16:37",
					"arrivesAt": "16:44",
					"waitsAtSource": 30,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2372",
			"segments": [
				{
					"from": "Arad",
					"to": "Glogovăţ",
					"leavesAt": "07:59",
					"arrivesAt": "08:06",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Glogovăţ",
					"to": "Ghioroc",
					"leavesAt": "08:07",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Ghioroc",
					"to": "Păuliş h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Păuliş h.",
					"to": "Păuliş Hm.",
					"leavesAt": "08:28",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Păuliş Hm.",
					"to": "Radna",
					"leavesAt": "08:34",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Radna",
					"to": "Milova",
					"leavesAt": "08:47",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Milova",
					"to": "Corfeni h.",
					"leavesAt": "08:59",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Corfeni h.",
					"to": "Conop Hm.",
					"leavesAt": "09:04",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Conop Hm.",
					"to": "Nadăş h.",
					"leavesAt": "09:11",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Nadăş h.",
					"to": "Bârzava",
					"leavesAt": "09:17",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârzava",
					"to": "Căpruţa h.",
					"leavesAt": "09:26",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Căpruţa h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "09:30",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "09:35",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Vărădia Hm.",
					"leavesAt": "09:41",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vărădia Hm.",
					"to": "Vărădia h.",
					"leavesAt": "09:48",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vărădia h.",
					"to": "Săvârşin",
					"leavesAt": "09:52",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Săvârşin",
					"to": "Toc h.",
					"leavesAt": "10:02",
					"arrivesAt": "10:09",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Toc h.",
					"to": "Ilteu",
					"leavesAt": "10:10",
					"arrivesAt": "10:15",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ilteu",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "10:16",
					"arrivesAt": "10:20",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Zam",
					"leavesAt": "10:21",
					"arrivesAt": "10:27",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Zam",
					"to": "Burjuc h.",
					"leavesAt": "10:28",
					"arrivesAt": "10:36",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Burjuc h.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "10:37",
					"arrivesAt": "10:44",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Gurasada Hm.",
					"leavesAt": "10:45",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Gurasada Hm.",
					"to": "Ilia",
					"leavesAt": "10:53",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "11:00",
					"arrivesAt": "11:04",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "11:05",
					"arrivesAt": "11:11",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "11:12",
					"arrivesAt": "11:15",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia",
					"leavesAt": "11:16",
					"arrivesAt": "11:22",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "11:23",
					"arrivesAt": "11:32",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "11:33",
					"arrivesAt": "11:39",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "11:40",
					"arrivesAt": "11:46",
					"waitsAtSource": 30,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2442",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "06:20",
					"arrivesAt": "06:33",
					"waitsAtSource": 0,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Mirăslău h.",
					"leavesAt": "06:34",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Mirăslău h.",
					"to": "Decea h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:45",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Decea h.",
					"to": "Unirea Hm.",
					"leavesAt": "06:46",
					"arrivesAt": "06:52",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Unirea Hm.",
					"to": "Unirea hc.",
					"leavesAt": "06:53",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "06:58",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Lunca Mureşului h.",
					"leavesAt": "07:07",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Gura Arieşului h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:16",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "07:17",
					"arrivesAt": "07:21",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Cheţani h.",
					"leavesAt": "07:22",
					"arrivesAt": "07:26",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Cheţani h.",
					"to": "Luduş",
					"leavesAt": "07:27",
					"arrivesAt": "07:34",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Luduş",
					"to": "Bogata Mureş h.",
					"leavesAt": "07:35",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Cuci h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cuci h.",
					"to": "Iernut",
					"leavesAt": "07:47",
					"arrivesAt": "07:53",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Iernut",
					"to": "Cipău h.",
					"leavesAt": "07:59",
					"arrivesAt": "08:04",
					"waitsAtSource": 360,
					"distance": 4100
				},
				{
					"from": "Cipău h.",
					"to": "Ogra h.",
					"leavesAt": "08:05",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ogra h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "08:09",
					"arrivesAt": "08:13",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Chirileu h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chirileu h.",
					"to": "Vidrasău h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:23",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vidrasău h.",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "08:24",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "08:30",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "Azomureş h.",
					"leavesAt": "08:35",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş",
					"leavesAt": "08:39",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2146",
			"segments": [
				{
					"from": "Hunedoara",
					"to": "Pestişu Mare h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:15",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pestişu Mare h.",
					"to": "Bârcea Mică",
					"leavesAt": "18:16",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bârcea Mică",
					"to": "Bârcea Mare h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bârcea Mare h.",
					"to": "Simeria",
					"leavesAt": "18:24",
					"arrivesAt": "18:32",
					"waitsAtSource": 30,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2851",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "04:30",
					"arrivesAt": "04:34",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "04:35",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "04:39",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "04:44",
					"arrivesAt": "04:47",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "04:48",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "04:53",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "05:03",
					"arrivesAt": "05:08",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Filiaşi",
					"leavesAt": "05:09",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Filiaşi",
					"to": "Ioneşti Gorj h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:29",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Ioneşti Gorj h.",
					"to": "Km. 9+820 h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Km. 9+820 h.",
					"to": "Termo Turceni h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Termo Turceni h.",
					"to": "Turceni",
					"leavesAt": "05:39",
					"arrivesAt": "05:41",
					"waitsAtSource": 30,
					"distance": 900
				},
				{
					"from": "Turceni",
					"to": "Gârbovu h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gârbovu h.",
					"to": "Sărdăneşti h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Plopşoru",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Plopşoru",
					"to": "Peşteana Jiu h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Bâlteni h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:11",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Bâlteni h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Roşia Jiu h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Roşia Jiu h.",
					"to": "Rovinari Sud h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Rovinari Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:31",
					"waitsAtSource": 120,
					"distance": 1400
				},
				{
					"from": "Rovinari Hm.",
					"to": "Km. 49+800 h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rogojelu",
					"leavesAt": "06:36",
					"arrivesAt": "06:39",
					"waitsAtSource": 120,
					"distance": 1800
				},
				{
					"from": "Rogojelu",
					"to": "Vârţ h.",
					"leavesAt": "06:44",
					"arrivesAt": "06:47",
					"waitsAtSource": 300,
					"distance": 2400
				},
				{
					"from": "Vârţ h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "06:48",
					"arrivesAt": "06:54",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Drăguţeşti h.",
					"leavesAt": "06:55",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Amaradia",
					"leavesAt": "06:59",
					"arrivesAt": "07:03",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Amaradia",
					"to": "Târgu Jiu",
					"leavesAt": "07:04",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9303",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:18",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureştii Noi",
					"leavesAt": "07:19",
					"arrivesAt": "07:24",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Bucureştii Noi",
					"to": "Chiajna",
					"leavesAt": "07:25",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiajna",
					"to": "Domneştii de Sus h.",
					"leavesAt": "07:34",
					"arrivesAt": "07:43",
					"waitsAtSource": 300,
					"distance": 10500
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Grădinari",
					"leavesAt": "07:44",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Grădinari",
					"to": "Vadu Lat Hm.",
					"leavesAt": "07:55",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Zăvestreni Hm.",
					"leavesAt": "08:14",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Videle",
					"leavesAt": "08:20",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Videle",
					"to": "Ciolpani Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:37",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Gălăteni Hm.",
					"leavesAt": "08:38",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Olteni",
					"leavesAt": "08:48",
					"arrivesAt": "08:54",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Olteni",
					"to": "Vârtoapele hc.",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "09:03",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Atârnaţi Hm.",
					"leavesAt": "09:09",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "09:20",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5206",
			"segments": [
				{
					"from": "Oneşti",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:49",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Borzeşti Bacău",
					"leavesAt": "15:50",
					"arrivesAt": "15:58",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Căiuţi Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Bâlca hc.",
					"leavesAt": "16:08",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Bâlca hc.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:21",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Urecheşti Hm.",
					"leavesAt": "16:22",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Adjud",
					"leavesAt": "16:27",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:07",
					"waitsAtSource": 1260,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "17:08",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "17:20",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "17:25",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2302",
			"segments": [
				{
					"from": "Simeria",
					"to": "Simeria Veche h.",
					"leavesAt": "05:00",
					"arrivesAt": "05:04",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Simeria Veche h.",
					"to": "Turdaş Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Turdaş Hm.",
					"to": "Pricaz h.",
					"leavesAt": "05:11",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Pricaz h.",
					"to": "Orăştie",
					"leavesAt": "05:19",
					"arrivesAt": "05:25",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Orăştie",
					"to": "Geoagiu h.",
					"leavesAt": "05:26",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Geoagiu h.",
					"to": "Aurel Vlaicu",
					"leavesAt": "05:31",
					"arrivesAt": "05:36",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Şibot",
					"leavesAt": "05:37",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Şibot",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "05:54",
					"arrivesAt": "06:00",
					"waitsAtSource": 420,
					"distance": 3000
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Tărtăria h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Tărtăria h.",
					"to": "Blandiana Hm.",
					"leavesAt": "06:09",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Blandiana Hm.",
					"to": "Vinţu de Jos",
					"leavesAt": "06:15",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "06:27",
					"arrivesAt": "06:39",
					"waitsAtSource": 240,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "06:41",
					"arrivesAt": "06:50",
					"waitsAtSource": 120,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "06:51",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Sântimbru h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Sântimbru h.",
					"to": "Coşlariu",
					"leavesAt": "07:03",
					"arrivesAt": "07:15",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "07:16",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3536",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "15:30",
					"arrivesAt": "15:38",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Vânători",
					"leavesAt": "15:39",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Vânători",
					"to": "Saschiz h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Saschiz h.",
					"to": "Mureni Hm.",
					"leavesAt": "15:52",
					"arrivesAt": "15:58",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mureni Hm.",
					"to": "Archita h",
					"leavesAt": "15:59",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Archita h",
					"to": "Beia Hm.",
					"leavesAt": "16:13",
					"arrivesAt": "16:28",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Beia Hm.",
					"to": "Paloş Ardeal h.",
					"leavesAt": "16:29",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paloş Ardeal h.",
					"to": "Caţa Hm.",
					"leavesAt": "16:37",
					"arrivesAt": "16:43",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Caţa Hm.",
					"to": "Rupea",
					"leavesAt": "16:44",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Rupea",
					"to": "Mateiaş h.",
					"leavesAt": "16:54",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Mateiaş h.",
					"to": "Racoş Hm.",
					"leavesAt": "17:09",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Racoş Hm.",
					"to": "Augustin Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Augustin Hm.",
					"to": "Ormeniş h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ormeniş h.",
					"to": "Apaţa",
					"leavesAt": "17:42",
					"arrivesAt": "17:52",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Apaţa",
					"to": "Măieruş h.",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Măieruş h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:04",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Rotbav h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:10",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Rotbav h.",
					"to": "Feldioara Hm.",
					"leavesAt": "18:11",
					"arrivesAt": "18:18",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Bod Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Bod Hm.",
					"to": "Stupini Hm.",
					"leavesAt": "18:35",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Stupini Hm.",
					"to": "Braşov",
					"leavesAt": "18:45",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9619",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Boldur h.",
					"leavesAt": "19:40",
					"arrivesAt": "19:50",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Boldur h.",
					"to": "Sinia Hm.",
					"leavesAt": "19:51",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sinia Hm.",
					"to": "Căpăt h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Căpăt h.",
					"to": "Buziaş",
					"leavesAt": "20:03",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 7300
				},
				{
					"from": "Buziaş",
					"to": "Bacova h.",
					"leavesAt": "20:24",
					"arrivesAt": "20:26",
					"waitsAtSource": 600,
					"distance": 2300
				},
				{
					"from": "Bacova h.",
					"to": "Chevereş h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:31",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Chevereş h.",
					"to": "Sacoşu Mic",
					"leavesAt": "20:32",
					"arrivesAt": "20:37",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Sacoşu Mic",
					"to": "Uliuc h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Uliuc h.",
					"to": "Urseni h.",
					"leavesAt": "20:43",
					"arrivesAt": "20:48",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Urseni h.",
					"to": "Giroc h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:54",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Giroc h.",
					"to": "Timişoara Sud",
					"leavesAt": "20:55",
					"arrivesAt": "21:01",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "21:02",
					"arrivesAt": "21:11",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2506",
			"segments": [
				{
					"from": "Făgăraş",
					"to": "Mândra Oltului h.",
					"leavesAt": "11:56",
					"arrivesAt": "12:02",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Şercaia h.",
					"leavesAt": "12:03",
					"arrivesAt": "12:10",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Şercaia h.",
					"to": "Şercaia Hm.",
					"leavesAt": "12:11",
					"arrivesAt": "12:13",
					"waitsAtSource": 30,
					"distance": 1200
				},
				{
					"from": "Şercaia Hm.",
					"to": "Perşani h.",
					"leavesAt": "12:14",
					"arrivesAt": "12:20",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Brădet Hm.",
					"leavesAt": "12:21",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Brădet Hm.",
					"to": "Valea Homorod h.",
					"leavesAt": "12:31",
					"arrivesAt": "12:39",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Homorod h.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "12:40",
					"arrivesAt": "12:49",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "12:50",
					"arrivesAt": "12:55",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "12:56",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Codlea Hm.",
					"to": "Ghimbav Hm.",
					"leavesAt": "13:18",
					"arrivesAt": "13:24",
					"waitsAtSource": 720,
					"distance": 5300
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Bartolomeu",
					"leavesAt": "13:25",
					"arrivesAt": "13:31",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "13:32",
					"arrivesAt": "13:38",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1823",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Grădinari",
					"leavesAt": "08:55",
					"arrivesAt": "09:27",
					"waitsAtSource": 0,
					"distance": 25500
				},
				{
					"from": "Grădinari",
					"to": "Videle",
					"leavesAt": "09:28",
					"arrivesAt": "09:52",
					"waitsAtSource": 60,
					"distance": 25400
				},
				{
					"from": "Videle",
					"to": "Gălăteni Hm.",
					"leavesAt": "09:53",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 15800
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Olteni",
					"leavesAt": "10:07",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Olteni",
					"to": "Vârtoapele hc.",
					"leavesAt": "10:14",
					"arrivesAt": "10:20",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Roşiori Nord",
					"leavesAt": "10:21",
					"arrivesAt": "10:45",
					"waitsAtSource": 30,
					"distance": 20000
				},
				{
					"from": "Roşiori Nord",
					"to": "Radomireşti Hm.",
					"leavesAt": "10:47",
					"arrivesAt": "11:10",
					"waitsAtSource": 120,
					"distance": 25600
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "11:11",
					"arrivesAt": "11:21",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Stoeneşti h.",
					"leavesAt": "11:22",
					"arrivesAt": "11:27",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Stoeneşti h.",
					"to": "Caracal",
					"leavesAt": "11:28",
					"arrivesAt": "11:41",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Caracal",
					"to": "Bordei hc.(900)",
					"leavesAt": "11:42",
					"arrivesAt": "12:20",
					"waitsAtSource": 60,
					"distance": 51900
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Craiova",
					"leavesAt": "12:21",
					"arrivesAt": "12:26",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "12:30",
					"arrivesAt": "12:33",
					"waitsAtSource": 240,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Filiaşi",
					"leavesAt": "12:34",
					"arrivesAt": "12:57",
					"waitsAtSource": 30,
					"distance": 32100
				},
				{
					"from": "Filiaşi",
					"to": "Turceni",
					"leavesAt": "12:58",
					"arrivesAt": "13:18",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Turceni",
					"to": "Rovinari Hm.",
					"leavesAt": "13:19",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 35300
				},
				{
					"from": "Rovinari Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "13:57",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 21800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4524",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "23:30",
					"arrivesAt": "23:38",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "23:39",
					"arrivesAt": "23:42",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "23:43",
					"arrivesAt": "23:47",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Vrabia h.",
					"leavesAt": "23:48",
					"arrivesAt": "23:53",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Vrabia h.",
					"to": "Tuşnad Sat",
					"leavesAt": "23:54",
					"arrivesAt": "23:58",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Tuşnad Sat",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "23:59",
					"arrivesAt": "00:07",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20180909",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20180607",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8594",
			"segments": [
				{
					"from": "Călăraşi Sud",
					"to": "Km. 25+700 h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:16",
					"waitsAtSource": 0,
					"distance": 1300
				},
				{
					"from": "Km. 25+700 h.",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "14:17",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Ştefan Vodă h.",
					"leavesAt": "14:24",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Ciulniţa",
					"leavesAt": "14:32",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 12600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9171",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Valea Păltinişului h.",
					"leavesAt": "19:35",
					"arrivesAt": "19:40",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "19:41",
					"arrivesAt": "19:48",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Brebu",
					"leavesAt": "19:58",
					"arrivesAt": "20:10",
					"waitsAtSource": 600,
					"distance": 10500
				},
				{
					"from": "Brebu",
					"to": "Ezeriş h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ezeriş h.",
					"to": "Bănila Câlnic h.",
					"leavesAt": "20:20",
					"arrivesAt": "20:26",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "20:27",
					"arrivesAt": "20:38",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Reşiţa Nord",
					"to": "Reşiţa Sud Hm.",
					"leavesAt": "20:39",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1894",
			"segments": [
				{
					"from": "Craiova",
					"to": "Balş",
					"leavesAt": "12:25",
					"arrivesAt": "12:55",
					"waitsAtSource": 0,
					"distance": 31200
				},
				{
					"from": "Balş",
					"to": "Piatra Olt",
					"leavesAt": "12:56",
					"arrivesAt": "13:08",
					"waitsAtSource": 60,
					"distance": 12900
				},
				{
					"from": "Piatra Olt",
					"to": "Slatina",
					"leavesAt": "13:12",
					"arrivesAt": "13:31",
					"waitsAtSource": 240,
					"distance": 17000
				},
				{
					"from": "Slatina",
					"to": "Costeşti",
					"leavesAt": "13:32",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 59200
				},
				{
					"from": "Costeşti",
					"to": "Piteşti",
					"leavesAt": "14:26",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "15:00",
					"arrivesAt": "15:10",
					"waitsAtSource": 600,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "15:11",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "15:36",
					"arrivesAt": "15:56",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "15:57",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9132",
			"segments": [
				{
					"from": "Calafat",
					"to": "Golenţi Hm.",
					"leavesAt": "03:25",
					"arrivesAt": "03:40",
					"waitsAtSource": 0,
					"distance": 11800
				},
				{
					"from": "Golenţi Hm.",
					"to": "Maglavit h.",
					"leavesAt": "03:41",
					"arrivesAt": "03:56",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Maglavit h.",
					"to": "Moţăţei Hm.",
					"leavesAt": "03:57",
					"arrivesAt": "04:11",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Moţăţei Hm.",
					"to": "Băileşti",
					"leavesAt": "04:12",
					"arrivesAt": "04:34",
					"waitsAtSource": 60,
					"distance": 12800
				},
				{
					"from": "Băileşti",
					"to": "Boureni P.M.",
					"leavesAt": "04:35",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Boureni P.M.",
					"to": "Siliştea Crucii h.",
					"leavesAt": "04:48",
					"arrivesAt": "04:52",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Siliştea Crucii h.",
					"to": "Afumaţi h.",
					"leavesAt": "04:53",
					"arrivesAt": "05:01",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Afumaţi h.",
					"to": "Urzica Mare h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Urzica Mare h.",
					"to": "Portăreşti Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:21",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Portăreşti Hm.",
					"to": "Cerăt h.",
					"leavesAt": "05:22",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cerăt h.",
					"to": "Segarcea",
					"leavesAt": "05:31",
					"arrivesAt": "05:37",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Segarcea",
					"to": "Segarcea Nord hc.",
					"leavesAt": "05:38",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Segarcea Nord hc.",
					"to": "Dealul Robului h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dealul Robului h.",
					"to": "Sălcuţa Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:54",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Sălcuţa Hm.",
					"to": "Podari",
					"leavesAt": "05:55",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Podari",
					"to": "Jiu Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Jiu Hm.",
					"to": "Bordei hc.(913)",
					"leavesAt": "06:21",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Bordei hc.(913)",
					"to": "Craiova",
					"leavesAt": "06:25",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2231",
			"segments": [
				{
					"from": "Remetea Mică",
					"to": "Fibiş h.",
					"leavesAt": "04:57",
					"arrivesAt": "05:02",
					"waitsAtSource": 0,
					"distance": 4300
				},
				{
					"from": "Fibiş h.",
					"to": "Bencei h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bencei h.",
					"to": "Pişchia h.",
					"leavesAt": "05:09",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pişchia h.",
					"to": "Cerneteaz h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Cerneteaz h.",
					"to": "Giarmata Hm.",
					"leavesAt": "05:26",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Giarmata Hm.",
					"to": "Viile Giarmata h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Viile Giarmata h.",
					"to": "Timişoara Est",
					"leavesAt": "05:36",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "05:47",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1822",
			"segments": [
				{
					"from": "Arad",
					"to": "Radna",
					"leavesAt": "18:40",
					"arrivesAt": "19:20",
					"waitsAtSource": 0,
					"distance": 34500
				},
				{
					"from": "Radna",
					"to": "Săvârşin",
					"leavesAt": "19:21",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 49700
				},
				{
					"from": "Săvârşin",
					"to": "Ilia",
					"leavesAt": "20:19",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Ilia",
					"to": "Deva",
					"leavesAt": "21:08",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 23600
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "21:36",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Călan Hm.",
					"leavesAt": "21:50",
					"arrivesAt": "22:06",
					"waitsAtSource": 120,
					"distance": 14600
				},
				{
					"from": "Călan Hm.",
					"to": "Subcetate",
					"leavesAt": "22:07",
					"arrivesAt": "22:22",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Subcetate",
					"to": "Petroşani",
					"leavesAt": "22:23",
					"arrivesAt": "23:32",
					"waitsAtSource": 60,
					"distance": 49800
				},
				{
					"from": "Petroşani",
					"to": "Valea Sadului Hm.",
					"leavesAt": "23:37",
					"arrivesAt": "00:22",
					"waitsAtSource": 300,
					"distance": 31700
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "00:23",
					"arrivesAt": "00:44",
					"waitsAtSource": 60,
					"distance": 19600
				},
				{
					"from": "Târgu Jiu",
					"to": "Cărbuneşti",
					"leavesAt": "00:46",
					"arrivesAt": "01:14",
					"waitsAtSource": 120,
					"distance": 23800
				},
				{
					"from": "Cărbuneşti",
					"to": "Filiaşi",
					"leavesAt": "01:15",
					"arrivesAt": "01:59",
					"waitsAtSource": 60,
					"distance": 46500
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "02:00",
					"arrivesAt": "02:25",
					"waitsAtSource": 60,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "02:35",
					"arrivesAt": "03:14",
					"waitsAtSource": 600,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "03:16",
					"arrivesAt": "03:31",
					"waitsAtSource": 120,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Roşiori Nord",
					"leavesAt": "03:32",
					"arrivesAt": "04:03",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "04:05",
					"arrivesAt": "04:54",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Chiajna",
					"leavesAt": "04:56",
					"arrivesAt": "05:38",
					"waitsAtSource": 120,
					"distance": 41900
				},
				{
					"from": "Chiajna",
					"to": "Bucureşti Nord",
					"leavesAt": "05:42",
					"arrivesAt": "05:55",
					"waitsAtSource": 240,
					"distance": 9000
				},
				{
					"from": "Bucureşti Nord",
					"to": "Lehliu",
					"leavesAt": "06:20",
					"arrivesAt": "07:01",
					"waitsAtSource": 1500,
					"distance": 69600
				},
				{
					"from": "Lehliu",
					"to": "Ciulniţa",
					"leavesAt": "07:02",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 39300
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "07:23",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "07:47",
					"arrivesAt": "08:07",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "08:08",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "08:26",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 34600
				}
			],
			"restrictions": [
				{
					"from": "20180501",
					"to": "20180523",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20180607",
					"daysOfWeek": 383
				},
				{
					"from": "20180909",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180425",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8582",
			"segments": [
				{
					"from": "Ciulniţa",
					"to": "Brâncoveni h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:09",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Brâncoveni h.",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "07:10",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Slobozia Veche",
					"leavesAt": "07:20",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 4200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2438",
			"segments": [
				{
					"from": "Lotru",
					"to": "Cozia Hm.",
					"leavesAt": "15:32",
					"arrivesAt": "15:41",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Cozia Hm.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Păuşa h.",
					"leavesAt": "15:49",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "15:56",
					"arrivesAt": "16:01",
					"waitsAtSource": 120,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Dăeşti Hm.",
					"leavesAt": "16:03",
					"arrivesAt": "16:11",
					"waitsAtSource": 120,
					"distance": 6100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "16:12",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "16:27",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5413",
			"segments": [
				{
					"from": "Adjud",
					"to": "Adjudu Vechi h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:14",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Şişcani h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Şişcani h.",
					"to": "Sascut Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sascut Hm.",
					"to": "Orbeni Hm.",
					"leavesAt": "15:36",
					"arrivesAt": "15:43",
					"waitsAtSource": 600,
					"distance": 9200
				},
				{
					"from": "Orbeni Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Răcăciuni h.",
					"to": "Faraoani Hm.",
					"leavesAt": "15:51",
					"arrivesAt": "15:59",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Faraoani Hm.",
					"to": "Siretu Bacău h.",
					"leavesAt": "16:00",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Valea Seacă",
					"leavesAt": "16:06",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Valea Seacă",
					"to": "Letea h.",
					"leavesAt": "16:12",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Letea h.",
					"to": "Bacău",
					"leavesAt": "16:18",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9104",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:47",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "05:59",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Podu Rizii h.",
					"leavesAt": "06:07",
					"arrivesAt": "06:11",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Podu Rizii h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:16",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "06:25",
					"arrivesAt": "06:30",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "06:35",
					"arrivesAt": "06:41",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "06:42",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "06:48",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "06:56",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "07:05",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "07:12",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "07:16",
					"arrivesAt": "07:19",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "07:20",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "07:23",
					"arrivesAt": "07:26",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "07:27",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4485",
			"segments": [
				{
					"from": "Ilva Mică",
					"to": "Podereia Feldrului h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:39",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Feldru Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:44",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Feldru Hm.",
					"to": "Nepos h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Nepos h.",
					"to": "Rebrişoara Hm.",
					"leavesAt": "16:51",
					"arrivesAt": "16:57",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Năsăud",
					"leavesAt": "16:58",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Năsăud",
					"to": "Năsăud h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Năsăud h.",
					"to": "Salva",
					"leavesAt": "17:08",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Salva",
					"to": "Mititei h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Mititei h.",
					"to": "Nimigea Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:22",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Nimigea Hm.",
					"to": "Nimigea h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Nimigea h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "17:27",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Cociu h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cociu h.",
					"to": "Beclean pe Someş",
					"leavesAt": "17:36",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Beclean pe Someş",
					"to": "Coldău Hm.",
					"leavesAt": "17:47",
					"arrivesAt": "17:57",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Coldău Hm.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "18:02",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "18:05",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Ciceu Mihăeşti h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ciceu Mihăeşti h.",
					"to": "Dej Triaj",
					"leavesAt": "18:16",
					"arrivesAt": "18:21",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "18:22",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4523",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "23:37",
					"arrivesAt": "23:45",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Racu h.",
					"leavesAt": "23:46",
					"arrivesAt": "23:49",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Racu h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "23:50",
					"arrivesAt": "23:57",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Dăneşti h.",
					"leavesAt": "23:58",
					"arrivesAt": "00:02",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dăneşti h.",
					"to": "Cârţani h.",
					"leavesAt": "00:03",
					"arrivesAt": "00:06",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cârţani h.",
					"to": "Tomeşti h.",
					"leavesAt": "00:07",
					"arrivesAt": "00:10",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Izvoru Oltului",
					"leavesAt": "00:11",
					"arrivesAt": "00:15",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Izvoru Oltului",
					"to": "Sândominic h.",
					"leavesAt": "00:16",
					"arrivesAt": "00:20",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "00:21",
					"arrivesAt": "00:31",
					"waitsAtSource": 30,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1728",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Lainici Hm.",
					"leavesAt": "12:42",
					"arrivesAt": "13:12",
					"waitsAtSource": 0,
					"distance": 20400
				},
				{
					"from": "Lainici Hm.",
					"to": "Valea Sadului Hm.",
					"leavesAt": "13:13",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "13:31",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 19600
				},
				{
					"from": "Târgu Jiu",
					"to": "Cărbuneşti",
					"leavesAt": "13:55",
					"arrivesAt": "14:21",
					"waitsAtSource": 120,
					"distance": 23800
				},
				{
					"from": "Cărbuneşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "14:42",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Gilort Hm.",
					"leavesAt": "14:52",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gilort Hm.",
					"to": "Filiaşi",
					"leavesAt": "15:00",
					"arrivesAt": "15:14",
					"waitsAtSource": 60,
					"distance": 12400
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "15:15",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "15:45",
					"arrivesAt": "16:24",
					"waitsAtSource": 300,
					"distance": 53600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 496
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9664",
			"segments": [
				{
					"from": "Stamora Moraviţa",
					"to": "Denta h.",
					"leavesAt": "12:29",
					"arrivesAt": "12:37",
					"waitsAtSource": 0,
					"distance": 8400
				},
				{
					"from": "Denta h.",
					"to": "Deta Hm.",
					"leavesAt": "12:38",
					"arrivesAt": "12:45",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Deta Hm.",
					"to": "Voiteni",
					"leavesAt": "12:46",
					"arrivesAt": "12:56",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "12:57",
					"arrivesAt": "13:07",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "13:08",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "13:15",
					"arrivesAt": "13:23",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara Sud",
					"leavesAt": "13:24",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "13:33",
					"arrivesAt": "13:44",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2855",
			"segments": [
				{
					"from": "Filiaşi",
					"to": "Ioneşti Gorj h.",
					"leavesAt": "15:22",
					"arrivesAt": "15:34",
					"waitsAtSource": 0,
					"distance": 11500
				},
				{
					"from": "Ioneşti Gorj h.",
					"to": "Km. 9+820 h.",
					"leavesAt": "15:35",
					"arrivesAt": "15:38",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Km. 9+820 h.",
					"to": "Termo Turceni h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:43",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Termo Turceni h.",
					"to": "Turceni",
					"leavesAt": "15:44",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 900
				},
				{
					"from": "Turceni",
					"to": "Gârbovu h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:28",
					"waitsAtSource": 2100,
					"distance": 6600
				},
				{
					"from": "Gârbovu h.",
					"to": "Sărdăneşti h.",
					"leavesAt": "16:29",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Plopşoru",
					"leavesAt": "16:35",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Plopşoru",
					"to": "Peşteana Jiu h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Bâlteni h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Bâlteni h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Roşia Jiu h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Roşia Jiu h.",
					"to": "Rovinari Sud h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:06",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Rovinari Hm.",
					"leavesAt": "17:08",
					"arrivesAt": "17:12",
					"waitsAtSource": 120,
					"distance": 1400
				},
				{
					"from": "Rovinari Hm.",
					"to": "Km. 49+800 h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rogojelu",
					"leavesAt": "17:16",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Rogojelu",
					"to": "Vârţ h.",
					"leavesAt": "17:20",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Vârţ h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "17:24",
					"arrivesAt": "17:31",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Drăguţeşti h.",
					"leavesAt": "17:32",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Amaradia",
					"leavesAt": "17:38",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Amaradia",
					"to": "Târgu Jiu",
					"leavesAt": "17:44",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8345",
			"segments": [
				{
					"from": "Călăraşi Sud",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "05:30",
					"arrivesAt": "05:38",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Ştefan Vodă h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Ciulniţa",
					"leavesAt": "05:47",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 12600
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:12",
					"waitsAtSource": 120,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "06:13",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "06:18",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "06:24",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:38",
					"waitsAtSource": 420,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "06:39",
					"arrivesAt": "06:44",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "06:51",
					"arrivesAt": "07:01",
					"waitsAtSource": 420,
					"distance": 9900
				},
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "07:02",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Ovidiu",
					"leavesAt": "07:09",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ovidiu",
					"to": "Dunărea Hm.",
					"leavesAt": "07:14",
					"arrivesAt": "07:20",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Dunărea Hm.",
					"to": "Cernavodă Pod",
					"leavesAt": "07:21",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "07:30",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "07:40",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "07:47",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "08:02",
					"arrivesAt": "08:06",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "08:13",
					"arrivesAt": "08:16",
					"waitsAtSource": 420,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "08:17",
					"arrivesAt": "08:22",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "08:27",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "08:32",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "08:38",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180916",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5422",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "12:40",
					"arrivesAt": "12:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "12:55",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "13:03",
					"arrivesAt": "13:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "13:10",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "13:18",
					"arrivesAt": "13:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "13:28",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "13:35",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "13:40",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "13:50",
					"arrivesAt": "14:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Paşcani Triaj",
					"leavesAt": "14:24",
					"arrivesAt": "14:28",
					"waitsAtSource": 1200,
					"distance": 2300
				},
				{
					"from": "Paşcani Triaj",
					"to": "Stolniceni h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "14:35",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "14:41",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "14:46",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "14:52",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "15:04",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "15:15",
					"arrivesAt": "15:22",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "15:23",
					"arrivesAt": "15:27",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "15:28",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:42",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "15:43",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "15:49",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9107",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "19:20",
					"arrivesAt": "19:24",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "19:25",
					"arrivesAt": "19:28",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "19:29",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "19:34",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Chitila",
					"leavesAt": "19:39",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "19:44",
					"arrivesAt": "19:52",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "19:53",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:27",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "20:28",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "20:36",
					"arrivesAt": "20:40",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "20:41",
					"arrivesAt": "20:48",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Podu Rizii h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:57",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Podu Rizii h.",
					"to": "Băneşti h.",
					"leavesAt": "20:58",
					"arrivesAt": "21:02",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "21:03",
					"arrivesAt": "21:06",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "21:07",
					"arrivesAt": "21:11",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "21:12",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "21:16",
					"arrivesAt": "21:21",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "21:22",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2701",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Dep Petroşani h.",
					"leavesAt": "03:35",
					"arrivesAt": "03:38",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Peştera Bolii h.",
					"leavesAt": "03:39",
					"arrivesAt": "03:44",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Băniţa",
					"leavesAt": "03:45",
					"arrivesAt": "03:53",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Băniţa",
					"to": "Merişor Hm.",
					"leavesAt": "03:54",
					"arrivesAt": "04:05",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Merişor Hm.",
					"to": "Crivadia Hm.",
					"leavesAt": "04:06",
					"arrivesAt": "04:15",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Crivadia Hm.",
					"to": "Baru Mare h.",
					"leavesAt": "04:16",
					"arrivesAt": "04:22",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Baru Mare h.",
					"to": "Baru Mare",
					"leavesAt": "04:23",
					"arrivesAt": "04:29",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Baru Mare",
					"to": "Livadia h.",
					"leavesAt": "04:30",
					"arrivesAt": "04:33",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Livadia h.",
					"to": "Ponor h.",
					"leavesAt": "04:34",
					"arrivesAt": "04:36",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ponor h.",
					"to": "Pui",
					"leavesAt": "04:37",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Pui",
					"to": "Ruşor h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Ruşor h.",
					"to": "Băeşti Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "04:51",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "04:52",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Ciopea h.",
					"leavesAt": "04:55",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ciopea h.",
					"to": "Subcetate",
					"leavesAt": "04:58",
					"arrivesAt": "05:02",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Subcetate",
					"to": "Covragiu h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Covragiu h.",
					"to": "Plopi h.",
					"leavesAt": "05:06",
					"arrivesAt": "05:08",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Plopi h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "05:09",
					"arrivesAt": "05:11",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Măceu h.",
					"leavesAt": "05:12",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măceu h.",
					"to": "Ruşi h.",
					"leavesAt": "05:16",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ruşi h.",
					"to": "Călan Hm.",
					"leavesAt": "05:19",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Călan Hm.",
					"to": "Călan Băi",
					"leavesAt": "05:30",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Băi",
					"to": "Batiz h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Batiz h.",
					"to": "Băcia Hm.",
					"leavesAt": "05:38",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Băcia Hm.",
					"to": "Băcia h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Băcia h.",
					"to": "Simeria Triaj",
					"leavesAt": "05:44",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Simeria Triaj",
					"to": "Simeria",
					"leavesAt": "05:48",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Simeria",
					"to": "Săuleşti h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Săuleşti h.",
					"to": "Deva",
					"leavesAt": "06:01",
					"arrivesAt": "06:08",
					"waitsAtSource": 30,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1696",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Lugoj",
					"leavesAt": "22:40",
					"arrivesAt": "23:34",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Lugoj",
					"to": "Găvojdia",
					"leavesAt": "23:36",
					"arrivesAt": "23:45",
					"waitsAtSource": 120,
					"distance": 11900
				},
				{
					"from": "Găvojdia",
					"to": "Caransebeş",
					"leavesAt": "23:49",
					"arrivesAt": "00:16",
					"waitsAtSource": 240,
					"distance": 27500
				},
				{
					"from": "Caransebeş",
					"to": "Băile Herculane",
					"leavesAt": "00:30",
					"arrivesAt": "01:53",
					"waitsAtSource": 840,
					"distance": 70800
				},
				{
					"from": "Băile Herculane",
					"to": "Orşova",
					"leavesAt": "01:55",
					"arrivesAt": "02:15",
					"waitsAtSource": 120,
					"distance": 17500
				},
				{
					"from": "Orşova",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "02:16",
					"arrivesAt": "02:47",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Balota",
					"leavesAt": "02:53",
					"arrivesAt": "03:27",
					"waitsAtSource": 360,
					"distance": 19000
				},
				{
					"from": "Balota",
					"to": "Strehaia hc.",
					"leavesAt": "03:28",
					"arrivesAt": "04:02",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Strehaia hc.",
					"to": "Filiaşi",
					"leavesAt": "04:04",
					"arrivesAt": "04:33",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "04:35",
					"arrivesAt": "05:00",
					"waitsAtSource": 120,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "05:10",
					"arrivesAt": "05:51",
					"waitsAtSource": 600,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "05:52",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Roşiori Nord",
					"leavesAt": "06:08",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "06:40",
					"arrivesAt": "07:24",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Grădinari",
					"leavesAt": "07:26",
					"arrivesAt": "07:51",
					"waitsAtSource": 120,
					"distance": 25400
				},
				{
					"from": "Grădinari",
					"to": "Bucureşti Nord",
					"leavesAt": "07:56",
					"arrivesAt": "08:26",
					"waitsAtSource": 300,
					"distance": 25500
				}
			],
			"restrictions": [
				{
					"from": "20180501",
					"to": "20180523",
					"daysOfWeek": 383
				},
				{
					"from": "20180528",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3544",
			"segments": [
				{
					"from": "Cristur Hm.",
					"to": "Beteşti h.",
					"leavesAt": "06:42",
					"arrivesAt": "06:45",
					"waitsAtSource": 0,
					"distance": 1300
				},
				{
					"from": "Beteşti h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "06:54",
					"arrivesAt": "06:59",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Lutiţa h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Lutiţa h.",
					"to": "Dobeni h.",
					"leavesAt": "07:06",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Feliceni h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Feliceni h.",
					"to": "Odorhei Sud hc.",
					"leavesAt": "07:17",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Odorhei",
					"leavesAt": "07:27",
					"arrivesAt": "07:31",
					"waitsAtSource": 120,
					"distance": 1200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4142",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:43",
					"waitsAtSource": 0,
					"distance": 900
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "14:44",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Domneşti pe Şieu h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:09",
					"waitsAtSource": 360,
					"distance": 6600
				},
				{
					"from": "Domneşti pe Şieu h.",
					"to": "Mărişelu Hm.",
					"leavesAt": "15:10",
					"arrivesAt": "15:14",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Mărişelu Hm.",
					"to": "Bârla pe Şieu h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bârla pe Şieu h.",
					"to": "Şieu Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:26",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Şieu Hm.",
					"to": "Şieuţ h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Şieuţ h.",
					"to": "Monor Gledin",
					"leavesAt": "15:33",
					"arrivesAt": "15:41",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Monor Gledin",
					"to": "Râpa de Jos Hm.",
					"leavesAt": "15:42",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Râpa de Jos Hm.",
					"to": "Morăreni h.",
					"leavesAt": "15:54",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Morăreni h.",
					"to": "Deda",
					"leavesAt": "15:59",
					"arrivesAt": "16:07",
					"waitsAtSource": 30,
					"distance": 4200
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3078",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "14:37",
					"arrivesAt": "14:47",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "14:53",
					"arrivesAt": "14:59",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Cojocna Hm.",
					"leavesAt": "15:00",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cojocna Hm.",
					"to": "Tunel Hm.",
					"leavesAt": "15:06",
					"arrivesAt": "15:14",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tunel Hm.",
					"to": "Boju",
					"leavesAt": "15:15",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Boju",
					"to": "Valea Florilor Hm.",
					"leavesAt": "15:24",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Ploscoş h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ploscoş h.",
					"to": "Cânepişti h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:48",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cânepişti h.",
					"to": "Câmpia Turzii",
					"leavesAt": "15:49",
					"arrivesAt": "15:57",
					"waitsAtSource": 30,
					"distance": 7700
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180203",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8003",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "13:20",
					"arrivesAt": "13:29",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "13:30",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Pasărea",
					"leavesAt": "13:36",
					"arrivesAt": "13:41",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pasărea",
					"to": "Brăneşti Sat h.",
					"leavesAt": "13:42",
					"arrivesAt": "13:46",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "13:47",
					"arrivesAt": "13:50",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Islaz h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Islaz h.",
					"to": "Fundulea Hm.",
					"leavesAt": "13:54",
					"arrivesAt": "14:01",
					"waitsAtSource": 30,
					"distance": 9800
				},
				{
					"from": "Fundulea Hm.",
					"to": "Mostiştea h.",
					"leavesAt": "14:02",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Mostiştea h.",
					"to": "Săruleşti",
					"leavesAt": "14:07",
					"arrivesAt": "14:12",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Săruleşti",
					"to": "Preasna h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:18",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Preasna h.",
					"to": "Lehliu",
					"leavesAt": "14:19",
					"arrivesAt": "14:27",
					"waitsAtSource": 30,
					"distance": 8800
				},
				{
					"from": "Lehliu",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:33",
					"waitsAtSource": 120,
					"distance": 5000
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "14:34",
					"arrivesAt": "14:37",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dâlga h.",
					"leavesAt": "14:44",
					"arrivesAt": "14:49",
					"waitsAtSource": 420,
					"distance": 7100
				},
				{
					"from": "Dâlga h.",
					"to": "Bogdana h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Bogdana h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "14:56",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Ivăneşti h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ivăneşti h.",
					"to": "Ciulniţa",
					"leavesAt": "15:07",
					"arrivesAt": "15:13",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:21",
					"waitsAtSource": 120,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "15:26",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "15:30",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "15:34",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "15:44",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "16:12",
					"arrivesAt": "16:18",
					"waitsAtSource": 1140,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Cernavodă Pod",
					"leavesAt": "16:19",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "16:37",
					"arrivesAt": "16:45",
					"waitsAtSource": 180,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "16:53",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:09",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "17:10",
					"arrivesAt": "17:14",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "17:20",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "17:30",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "17:35",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "17:41",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2091",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "05:40",
					"arrivesAt": "05:43",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "05:44",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "05:48",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "05:52",
					"arrivesAt": "05:55",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "05:56",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "06:00",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "06:09",
					"arrivesAt": "06:14",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "06:18",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:32",
					"waitsAtSource": 120,
					"distance": 5700
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "06:33",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Floreşti hc.",
					"to": "Gilort Hm.",
					"leavesAt": "06:37",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Gilort Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "06:44",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turburea Hm.",
					"to": "Bibeşti Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "07:02",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Musculeşti",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Jupâneşti Hm.",
					"leavesAt": "07:15",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "07:22",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cărbuneşti",
					"to": "Pojogeni Hm.",
					"leavesAt": "07:31",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "07:39",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Budieni h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Budieni h.",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "07:51",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "07:56",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 416
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4091",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Botiz Hm.",
					"leavesAt": "16:12",
					"arrivesAt": "16:18",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Botiz Hm.",
					"to": "Odoreu h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Odoreu h.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "16:25",
					"arrivesAt": "16:34",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Apa Hm.",
					"leavesAt": "16:35",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Apa Hm.",
					"to": "Seini",
					"leavesAt": "16:44",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Seini",
					"to": "Săbişa h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Săbişa h.",
					"to": "Ilba h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:07",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ilba h.",
					"to": "Cicârlău h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Cicârlău h.",
					"to": "Buşag Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Buşag Hm.",
					"to": "Baia Mare",
					"leavesAt": "17:24",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8392",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "18:34",
					"arrivesAt": "18:40",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "18:41",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "18:46",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "18:56",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "19:07",
					"arrivesAt": "19:13",
					"waitsAtSource": 480,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "19:14",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "19:21",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "19:27",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Agigea Nord",
					"leavesAt": "19:36",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Nord",
					"to": "Constanţa",
					"leavesAt": "19:42",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9406",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Şopârliţa hc.",
					"leavesAt": "13:15",
					"arrivesAt": "13:26",
					"waitsAtSource": 0,
					"distance": 11100
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Vlăduleni",
					"leavesAt": "13:27",
					"arrivesAt": "13:33",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vlăduleni",
					"to": "Fălcoiu h.",
					"leavesAt": "13:34",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Fălcoiu h.",
					"to": "Romula Hm.",
					"leavesAt": "13:40",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Romula Hm.",
					"to": "Caracal",
					"leavesAt": "13:53",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Caracal",
					"to": "Fărcaşele Hm.",
					"leavesAt": "14:25",
					"arrivesAt": "14:34",
					"waitsAtSource": 1200,
					"distance": 7800
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Stoeneşti h.",
					"leavesAt": "14:35",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Stoeneşti h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "14:40",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Dăneasa h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Dăneasa h.",
					"to": "Radomireşti Hm.",
					"leavesAt": "14:55",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "15:05",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "15:27",
					"arrivesAt": "15:48",
					"waitsAtSource": 660,
					"distance": 17300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2306",
			"segments": [
				{
					"from": "Simeria",
					"to": "Simeria Veche h.",
					"leavesAt": "11:51",
					"arrivesAt": "11:56",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Simeria Veche h.",
					"to": "Turdaş Hm.",
					"leavesAt": "11:57",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Turdaş Hm.",
					"to": "Pricaz h.",
					"leavesAt": "12:03",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Pricaz h.",
					"to": "Orăştie",
					"leavesAt": "12:12",
					"arrivesAt": "12:18",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Orăştie",
					"to": "Geoagiu h.",
					"leavesAt": "12:19",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Geoagiu h.",
					"to": "Şibot",
					"leavesAt": "12:24",
					"arrivesAt": "12:36",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Şibot",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "12:37",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Tărtăria h.",
					"leavesAt": "12:44",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Tărtăria h.",
					"to": "Blandiana Hm.",
					"leavesAt": "12:52",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Blandiana Hm.",
					"to": "Vinţu de Jos",
					"leavesAt": "12:58",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "13:07",
					"arrivesAt": "13:19",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "13:22",
					"arrivesAt": "13:31",
					"waitsAtSource": 180,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "13:32",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Sântimbru h.",
					"leavesAt": "13:40",
					"arrivesAt": "13:43",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Sântimbru h.",
					"to": "Coşlariu",
					"leavesAt": "13:44",
					"arrivesAt": "13:56",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "13:57",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3545",
			"segments": [
				{
					"from": "Odorhei",
					"to": "Odorhei Sud hc.",
					"leavesAt": "14:30",
					"arrivesAt": "14:34",
					"waitsAtSource": 0,
					"distance": 1200
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Feliceni h.",
					"leavesAt": "14:36",
					"arrivesAt": "14:44",
					"waitsAtSource": 120,
					"distance": 5300
				},
				{
					"from": "Feliceni h.",
					"to": "Dobeni h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Lutiţa h.",
					"leavesAt": "14:51",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Lutiţa h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Beteşti Est h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:14",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Beteşti Est h.",
					"to": "Beteşti h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:18",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beteşti h.",
					"to": "Cristur Hm.",
					"leavesAt": "15:19",
					"arrivesAt": "15:22",
					"waitsAtSource": 30,
					"distance": 1300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5056",
			"segments": [
				{
					"from": "Buzău",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "13:10",
					"arrivesAt": "13:19",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Ulmeni",
					"leavesAt": "13:20",
					"arrivesAt": "13:25",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "13:26",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "13:31",
					"arrivesAt": "13:40",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "13:41",
					"arrivesAt": "13:48",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "13:49",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "13:57",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "14:02",
					"arrivesAt": "14:07",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "14:08",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "14:12",
					"arrivesAt": "14:19",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "14:20",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "14:27",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 4300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5453",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "18:29",
					"arrivesAt": "18:40",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "18:41",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "18:46",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "19:02",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "19:07",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "19:27",
					"arrivesAt": "19:34",
					"waitsAtSource": 780,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "19:35",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "19:42",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "19:47",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "19:53",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani",
					"leavesAt": "20:03",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "20:20",
					"arrivesAt": "20:25",
					"waitsAtSource": 420,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "20:26",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "20:37",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "20:43",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "20:56",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "21:03",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "21:10",
					"arrivesAt": "21:16",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "21:17",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "21:24",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "21:33",
					"arrivesAt": "21:39",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1753",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "13:45",
					"arrivesAt": "14:36",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "14:38",
					"arrivesAt": "15:11",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "15:12",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "15:50",
					"arrivesAt": "16:21",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "16:22",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "17:02",
					"arrivesAt": "17:24",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "17:25",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "17:54",
					"arrivesAt": "18:34",
					"waitsAtSource": 180,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "18:51",
					"arrivesAt": "19:21",
					"waitsAtSource": 1020,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Paşcani",
					"leavesAt": "19:23",
					"arrivesAt": "19:52",
					"waitsAtSource": 120,
					"distance": 40200
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "19:54",
					"arrivesAt": "20:14",
					"waitsAtSource": 120,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "20:15",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "20:32",
					"arrivesAt": "20:43",
					"waitsAtSource": 60,
					"distance": 14800
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "20:45",
					"arrivesAt": "20:51",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1529",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "16:43",
					"arrivesAt": "16:58",
					"waitsAtSource": 0,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Crivina",
					"leavesAt": "16:59",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 22800
				},
				{
					"from": "Crivina",
					"to": "Ploieşti Vest",
					"leavesAt": "17:16",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 19200
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "17:33",
					"arrivesAt": "17:56",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "17:57",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Comarnic",
					"leavesAt": "18:02",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 9000
				},
				{
					"from": "Comarnic",
					"to": "Sinaia",
					"leavesAt": "18:10",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 15100
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "18:24",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "18:32",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "18:38",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "18:48",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "19:37",
					"arrivesAt": "19:43",
					"waitsAtSource": 720,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Ghimbav Hm.",
					"leavesAt": "19:44",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "19:52",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Codlea Hm.",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "19:59",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "20:09",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Valea Homorod h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Valea Homorod h.",
					"to": "Brădet Hm.",
					"leavesAt": "20:22",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Brădet Hm.",
					"to": "Perşani h.",
					"leavesAt": "20:31",
					"arrivesAt": "20:39",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Şercaia Hm.",
					"leavesAt": "20:40",
					"arrivesAt": "20:49",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Şercaia Hm.",
					"to": "Şercaia h.",
					"leavesAt": "20:50",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 1200
				},
				{
					"from": "Şercaia h.",
					"to": "Mândra Oltului h.",
					"leavesAt": "20:53",
					"arrivesAt": "21:00",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Făgăraş",
					"leavesAt": "21:01",
					"arrivesAt": "21:07",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Făgăraş",
					"to": "Ucea",
					"leavesAt": "21:08",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Ucea",
					"to": "Porumbacu Hm.",
					"leavesAt": "21:35",
					"arrivesAt": "21:55",
					"waitsAtSource": 300,
					"distance": 18700
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "21:56",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Avrig Hm.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "22:05",
					"arrivesAt": "22:22",
					"waitsAtSource": 60,
					"distance": 15400
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Sibiu",
					"leavesAt": "22:23",
					"arrivesAt": "22:42",
					"waitsAtSource": 60,
					"distance": 17800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2474",
			"segments": [
				{
					"from": "Râmnicu Vâlcea",
					"to": "Ostroveni h.",
					"leavesAt": "23:20",
					"arrivesAt": "23:22",
					"waitsAtSource": 0,
					"distance": 1000
				},
				{
					"from": "Ostroveni h.",
					"to": "Răstoaca h.",
					"leavesAt": "23:23",
					"arrivesAt": "23:27",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Răstoaca h.",
					"to": "Râureni",
					"leavesAt": "23:28",
					"arrivesAt": "23:30",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Râureni",
					"to": "Râureni hc.",
					"leavesAt": "23:39",
					"arrivesAt": "23:43",
					"waitsAtSource": 540,
					"distance": 3400
				},
				{
					"from": "Râureni hc.",
					"to": "Govora",
					"leavesAt": "23:44",
					"arrivesAt": "23:49",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Govora",
					"to": "Tătărani h.",
					"leavesAt": "23:50",
					"arrivesAt": "23:56",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Tătărani h.",
					"to": "Băbeni",
					"leavesAt": "23:57",
					"arrivesAt": "00:04",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Băbeni",
					"to": "Slăviteşti hc.",
					"leavesAt": "00:05",
					"arrivesAt": "00:10",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Ioneşti Hm.",
					"leavesAt": "00:11",
					"arrivesAt": "00:18",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "00:19",
					"arrivesAt": "00:23",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Fişcălia Hm.",
					"leavesAt": "00:24",
					"arrivesAt": "00:28",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "00:29",
					"arrivesAt": "00:32",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Orleşti hc.",
					"to": "Zăvideni Hm.",
					"leavesAt": "00:33",
					"arrivesAt": "00:39",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Călina h.",
					"leavesAt": "00:40",
					"arrivesAt": "00:44",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Călina h.",
					"to": "Drăgăşani",
					"leavesAt": "00:45",
					"arrivesAt": "00:53",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Drăgăşani",
					"to": "Zlătărei Hm.",
					"leavesAt": "00:54",
					"arrivesAt": "01:01",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Strejeşti",
					"leavesAt": "01:02",
					"arrivesAt": "01:08",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Strejeşti",
					"to": "Piatra Olt",
					"leavesAt": "01:09",
					"arrivesAt": "01:35",
					"waitsAtSource": 60,
					"distance": 21900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1889",
			"segments": [
				{
					"from": "Titu",
					"to": "Nucet",
					"leavesAt": "18:41",
					"arrivesAt": "18:52",
					"waitsAtSource": 0,
					"distance": 15400
				},
				{
					"from": "Nucet",
					"to": "Târgovişte",
					"leavesAt": "18:53",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 16300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4651",
			"segments": [
				{
					"from": "Vişeu de Jos",
					"to": "Bocicoel h.",
					"leavesAt": "04:30",
					"arrivesAt": "04:34",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Bocicoel h.",
					"to": "Leordina h.",
					"leavesAt": "04:35",
					"arrivesAt": "04:43",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Leordina h.",
					"to": "Leordina",
					"leavesAt": "04:44",
					"arrivesAt": "04:50",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Leordina",
					"to": "Petrova hc.",
					"leavesAt": "04:51",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Petrova hc.",
					"to": "Vişeu Bistra h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Valea Vişeului",
					"leavesAt": "05:11",
					"arrivesAt": "05:25",
					"waitsAtSource": 30,
					"distance": 8500
				},
				{
					"from": "Valea Vişeului",
					"to": "Lunca la Tisa h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:56",
					"waitsAtSource": 900,
					"distance": 10700
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "05:57",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Crăciuneşti h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Tisa h.",
					"leavesAt": "06:11",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Tisa h.",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "06:15",
					"arrivesAt": "06:22",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Sighetu Marmaţiei",
					"leavesAt": "06:23",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 1900
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 831
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 831
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 831
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 831
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 831
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 831
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 831
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 831
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 831
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2069",
			"segments": [
				{
					"from": "Râmnicu Vâlcea",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "02:45",
					"arrivesAt": "02:48",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "02:49",
					"arrivesAt": "02:54",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Dăeşti Hm.",
					"leavesAt": "02:55",
					"arrivesAt": "03:01",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Călimăneşti",
					"leavesAt": "03:02",
					"arrivesAt": "03:09",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "03:10",
					"arrivesAt": "03:15",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "03:16",
					"arrivesAt": "03:20",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Lotru",
					"leavesAt": "03:21",
					"arrivesAt": "03:36",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Lotru",
					"to": "Beţel h.",
					"leavesAt": "03:46",
					"arrivesAt": "03:53",
					"waitsAtSource": 600,
					"distance": 5700
				},
				{
					"from": "Beţel h.",
					"to": "Cornet Hm.",
					"leavesAt": "03:54",
					"arrivesAt": "04:01",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Cornet Hm.",
					"to": "Balota h.",
					"leavesAt": "04:11",
					"arrivesAt": "04:17",
					"waitsAtSource": 600,
					"distance": 4000
				},
				{
					"from": "Balota h.",
					"to": "Robeşti h.",
					"leavesAt": "04:18",
					"arrivesAt": "04:21",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Robeşti h.",
					"to": "Câineni",
					"leavesAt": "04:22",
					"arrivesAt": "04:29",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Râu Vadului h.",
					"leavesAt": "04:30",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Râu Vadului h.",
					"to": "Valea Fratelui h.",
					"leavesAt": "04:39",
					"arrivesAt": "04:43",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Valea Fratelui h.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "04:44",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Turnu Roşu hc.",
					"leavesAt": "04:58",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Podu Olt",
					"leavesAt": "05:09",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "05:23",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:36",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "05:37",
					"arrivesAt": "05:41",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Atelier Zona h.",
					"leavesAt": "05:47",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu",
					"leavesAt": "05:52",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2496",
			"segments": [
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "23:50",
					"arrivesAt": "23:59",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "00:00",
					"arrivesAt": "00:07",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Sântimbru h.",
					"leavesAt": "00:08",
					"arrivesAt": "00:11",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Sântimbru h.",
					"to": "Coşlariu",
					"leavesAt": "00:12",
					"arrivesAt": "00:24",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "00:25",
					"arrivesAt": "00:33",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4405",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Ram. Botiz h.",
					"leavesAt": "12:40",
					"arrivesAt": "12:46",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Micula Hm.",
					"leavesAt": "12:47",
					"arrivesAt": "12:56",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Micula Hm.",
					"to": "Porumbeşti Hm.",
					"leavesAt": "12:57",
					"arrivesAt": "13:04",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Halmeu",
					"leavesAt": "13:05",
					"arrivesAt": "13:11",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9620",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "19:22",
					"arrivesAt": "19:32",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Giroc h.",
					"leavesAt": "19:33",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Giroc h.",
					"to": "Semenic Hm.",
					"leavesAt": "19:37",
					"arrivesAt": "19:40",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Semenic Hm.",
					"to": "Urseni h.",
					"leavesAt": "19:41",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Urseni h.",
					"to": "Uliuc h.",
					"leavesAt": "19:47",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Uliuc h.",
					"to": "Sacoşu Mic",
					"leavesAt": "19:55",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Sacoşu Mic",
					"to": "Chevereş h.",
					"leavesAt": "20:01",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Chevereş h.",
					"to": "Bacova h.",
					"leavesAt": "20:08",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bacova h.",
					"to": "Buziaş",
					"leavesAt": "20:14",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Buziaş",
					"to": "Căpăt h.",
					"leavesAt": "20:21",
					"arrivesAt": "20:29",
					"waitsAtSource": 120,
					"distance": 7300
				},
				{
					"from": "Căpăt h.",
					"to": "Sinia Hm.",
					"leavesAt": "20:30",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Sinia Hm.",
					"to": "Boldur h.",
					"leavesAt": "20:36",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Boldur h.",
					"to": "Lugoj",
					"leavesAt": "20:43",
					"arrivesAt": "20:57",
					"waitsAtSource": 30,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3114",
			"segments": [
				{
					"from": "Salonta",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:56",
					"waitsAtSource": 0,
					"distance": 10200
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Boiu Bihor h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:05",
					"waitsAtSource": 360,
					"distance": 3800
				},
				{
					"from": "Boiu Bihor h.",
					"to": "Tămaşda h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:10",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Tămaşda h.",
					"to": "Zerind Hm.",
					"leavesAt": "09:11",
					"arrivesAt": "09:23",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Zerind Hm.",
					"to": "Chişineu Criş",
					"leavesAt": "09:24",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Chişineu Criş",
					"to": "Nădab",
					"leavesAt": "09:32",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Nădab",
					"to": "Şimand Hm.",
					"leavesAt": "09:39",
					"arrivesAt": "09:46",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şimand Hm.",
					"to": "Comlăuş h.",
					"leavesAt": "09:47",
					"arrivesAt": "09:54",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Comlăuş h.",
					"to": "Sântana",
					"leavesAt": "09:55",
					"arrivesAt": "09:59",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "10:00",
					"arrivesAt": "10:09",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utviniş h.",
					"leavesAt": "10:10",
					"arrivesAt": "10:14",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Utviniş h.",
					"to": "Arad",
					"leavesAt": "10:15",
					"arrivesAt": "10:31",
					"waitsAtSource": 60,
					"distance": 9600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9362",
			"segments": [
				{
					"from": "Alexandria",
					"to": "Alexandria Nord h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:38",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Buzescu h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:49",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Buzescu h.",
					"to": "Plosca Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Plosca Hm.",
					"to": "Peret hc.",
					"leavesAt": "06:02",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Peret hc.",
					"to": "Roşiori Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "06:24",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5212",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "19:51",
					"arrivesAt": "19:59",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Mihăileni Hm.",
					"leavesAt": "20:05",
					"arrivesAt": "20:11",
					"waitsAtSource": 360,
					"distance": 6200
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Caracău h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Caracău h.",
					"to": "Livezi Ciuc",
					"leavesAt": "20:29",
					"arrivesAt": "20:33",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Utuşoiu h.",
					"leavesAt": "20:36",
					"arrivesAt": "20:42",
					"waitsAtSource": 180,
					"distance": 4100
				},
				{
					"from": "Utuşoiu h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Tarcău h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "20:54",
					"arrivesAt": "20:59",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Bolovăniş h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:13",
					"waitsAtSource": 480,
					"distance": 4900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Ghimeş",
					"leavesAt": "21:14",
					"arrivesAt": "21:19",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ghimeş",
					"to": "Palanca Hm.",
					"leavesAt": "21:20",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Palanca Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "21:27",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Simbrea Hm.",
					"leavesAt": "21:33",
					"arrivesAt": "21:39",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Simbrea Hm.",
					"to": "Goioasa Hm.",
					"leavesAt": "21:40",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Goioasa Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "21:49",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Caraliţa h.",
					"to": "Asău Hm.",
					"leavesAt": "21:54",
					"arrivesAt": "21:59",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Asău Hm.",
					"to": "Comăneşti",
					"leavesAt": "22:00",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Comăneşti",
					"to": "Valea Uzului Hm.",
					"leavesAt": "22:16",
					"arrivesAt": "22:26",
					"waitsAtSource": 360,
					"distance": 6200
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "22:27",
					"arrivesAt": "22:29",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Dofteana Bacău",
					"leavesAt": "22:30",
					"arrivesAt": "22:36",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Dofteana Bacău",
					"to": "Cireşoaia h.",
					"leavesAt": "22:37",
					"arrivesAt": "22:44",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cireşoaia h.",
					"to": "Saline hc.",
					"leavesAt": "22:45",
					"arrivesAt": "22:52",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Saline hc.",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "22:53",
					"arrivesAt": "22:57",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Viişoara h",
					"leavesAt": "22:58",
					"arrivesAt": "23:04",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Viişoara h",
					"to": "Oneşti",
					"leavesAt": "23:05",
					"arrivesAt": "23:19",
					"waitsAtSource": 30,
					"distance": 9100
				},
				{
					"from": "Oneşti",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "23:25",
					"arrivesAt": "23:30",
					"waitsAtSource": 360,
					"distance": 3400
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Borzeşti Bacău",
					"leavesAt": "23:31",
					"arrivesAt": "23:39",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Căiuţi Hm.",
					"leavesAt": "23:40",
					"arrivesAt": "23:47",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Bâlca hc.",
					"leavesAt": "23:48",
					"arrivesAt": "23:53",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Bâlca hc.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "23:54",
					"arrivesAt": "00:00",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Urecheşti Hm.",
					"leavesAt": "00:01",
					"arrivesAt": "00:06",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Adjud",
					"leavesAt": "00:07",
					"arrivesAt": "00:18",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "00:20",
					"arrivesAt": "00:28",
					"waitsAtSource": 120,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "00:29",
					"arrivesAt": "00:32",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "00:33",
					"arrivesAt": "00:40",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "00:41",
					"arrivesAt": "00:45",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "00:46",
					"arrivesAt": "00:56",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5427",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:40",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "16:41",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "16:46",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "16:52",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "17:02",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "17:07",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:23",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "17:24",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "17:31",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "17:36",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani Triaj",
					"leavesAt": "17:52",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Paşcani Triaj",
					"to": "Paşcani",
					"leavesAt": "17:58",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "18:31",
					"arrivesAt": "18:45",
					"waitsAtSource": 1560,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "18:46",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "18:54",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "19:00",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "19:09",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "19:20",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "19:27",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "19:34",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "19:42",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5532",
			"segments": [
				{
					"from": "Târgu Neamţ",
					"to": "Plăieşu h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:45",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Plăieşu h.",
					"to": "Timişeşti Hm.",
					"leavesAt": "20:46",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "20:53",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Topile h.",
					"leavesAt": "20:59",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Topile h.",
					"to": "Paşcani",
					"leavesAt": "21:08",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6414",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "19:28",
					"arrivesAt": "19:35",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Ciurea Hm.",
					"leavesAt": "19:36",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ciurea Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Bârnova Hm.",
					"leavesAt": "19:54",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Grajduri",
					"leavesAt": "20:04",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Grajduri",
					"to": "Scânteia Hm.",
					"leavesAt": "20:12",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Scânteia Hm.",
					"to": "Rebricea Hm.",
					"leavesAt": "20:20",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Rebricea Hm.",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Buhăieşti",
					"leavesAt": "20:33",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Buhăieşti",
					"to": "Bârzeşti h.",
					"leavesAt": "20:39",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bârzeşti h.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "20:46",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bălteni Hm.",
					"leavesAt": "20:51",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bălteni Hm.",
					"to": "Vaslui",
					"leavesAt": "20:57",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 9800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5701",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Vest",
					"leavesAt": "05:28",
					"arrivesAt": "05:36",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Suceava Vest",
					"to": "Stroieşti",
					"leavesAt": "05:40",
					"arrivesAt": "05:49",
					"waitsAtSource": 240,
					"distance": 9400
				},
				{
					"from": "Stroieşti",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:19",
					"waitsAtSource": 900,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "06:20",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Gura Humorului Hm.",
					"leavesAt": "06:28",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Gura Humorului Oraş",
					"leavesAt": "06:39",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "06:47",
					"arrivesAt": "06:56",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Molid Hm.",
					"leavesAt": "06:57",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Molid Hm.",
					"to": "Vama",
					"leavesAt": "07:05",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vama",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "07:18",
					"arrivesAt": "07:25",
					"waitsAtSource": 480,
					"distance": 4300
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "07:26",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "07:38",
					"arrivesAt": "07:45",
					"waitsAtSource": 120,
					"distance": 3800
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Sadova Hm.",
					"leavesAt": "07:47",
					"arrivesAt": "07:52",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Sadova Hm.",
					"to": "Pojorâta Hm.",
					"leavesAt": "07:53",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Valea Putnei P.M.",
					"leavesAt": "08:00",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Valea Putnei P.M.",
					"to": "Mestecăniş",
					"leavesAt": "08:13",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Iacobeni",
					"leavesAt": "08:25",
					"arrivesAt": "08:34",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Iacobeni",
					"to": "Argestru Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Argestru Hm.",
					"to": "Vatra Dornei",
					"leavesAt": "08:44",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Vatra Dornei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "08:53",
					"arrivesAt": "08:56",
					"waitsAtSource": 120,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Roşu Hm.",
					"leavesAt": "08:58",
					"arrivesAt": "09:05",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Roşu Hm.",
					"to": "Dorna Candrenilor h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dorna Candrenilor h.",
					"to": "Floreni",
					"leavesAt": "09:12",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Floreni",
					"to": "Coşna Hm.",
					"leavesAt": "09:19",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Coşna Hm.",
					"to": "Grădiniţa",
					"leavesAt": "09:29",
					"arrivesAt": "09:39",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Grădiniţa",
					"to": "Larion Hm.",
					"leavesAt": "09:40",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Larion Hm.",
					"to": "Silhoasa Hm.",
					"leavesAt": "09:50",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Silhoasa Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "10:02",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Lunca Ilvei",
					"to": "Ilva Mare Hm.",
					"leavesAt": "10:11",
					"arrivesAt": "10:21",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Ilva Mare Hm.",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "10:22",
					"arrivesAt": "10:32",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Poiana Ilvei",
					"leavesAt": "10:33",
					"arrivesAt": "10:41",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Poiana Ilvei",
					"to": "Leşu Ilvei Hm.",
					"leavesAt": "10:42",
					"arrivesAt": "10:51",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Leşu Ilvei Hm.",
					"to": "Strâmba h.",
					"leavesAt": "10:52",
					"arrivesAt": "10:56",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Strâmba h.",
					"to": "Ilva Mică",
					"leavesAt": "10:57",
					"arrivesAt": "11:03",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "473",
			"segments": [
				{
					"from": "Lokoshaza",
					"to": "Curtici",
					"leavesAt": "23:51",
					"arrivesAt": "00:01",
					"waitsAtSource": 0,
					"distance": 11200
				},
				{
					"from": "Curtici",
					"to": "Arad",
					"leavesAt": "00:31",
					"arrivesAt": "00:45",
					"waitsAtSource": 1800,
					"distance": 17000
				},
				{
					"from": "Arad",
					"to": "Deva",
					"leavesAt": "00:47",
					"arrivesAt": "03:30",
					"waitsAtSource": 120,
					"distance": 148200
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "03:32",
					"arrivesAt": "03:44",
					"waitsAtSource": 120,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Vinţu de Jos",
					"leavesAt": "03:56",
					"arrivesAt": "04:53",
					"waitsAtSource": 720,
					"distance": 43800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Sebeş Alba",
					"leavesAt": "04:54",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Sebeş Alba",
					"to": "Sibiu",
					"leavesAt": "05:05",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 73700
				},
				{
					"from": "Sibiu",
					"to": "Porumbacu Hm.",
					"leavesAt": "06:43",
					"arrivesAt": "07:27",
					"waitsAtSource": 480,
					"distance": 40600
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Făgăraş",
					"leavesAt": "07:31",
					"arrivesAt": "08:11",
					"waitsAtSource": 240,
					"distance": 43300
				},
				{
					"from": "Făgăraş",
					"to": "Codlea Hm.",
					"leavesAt": "08:13",
					"arrivesAt": "09:08",
					"waitsAtSource": 120,
					"distance": 51200
				},
				{
					"from": "Codlea Hm.",
					"to": "Braşov",
					"leavesAt": "09:09",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "09:38",
					"arrivesAt": "10:13",
					"waitsAtSource": 720,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Buşteni",
					"leavesAt": "10:15",
					"arrivesAt": "10:27",
					"waitsAtSource": 120,
					"distance": 11400
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "10:28",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Ploieşti Vest",
					"leavesAt": "10:39",
					"arrivesAt": "11:22",
					"waitsAtSource": 120,
					"distance": 62100
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "11:24",
					"arrivesAt": "12:05",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3001",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Depoul Buc.Triaj h.(300)",
					"leavesAt": "06:22",
					"arrivesAt": "06:30",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Depoul Buc.Triaj h.(300)",
					"to": "Chitila",
					"leavesAt": "06:31",
					"arrivesAt": "06:34",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "06:35",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "06:47",
					"arrivesAt": "06:54",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "06:55",
					"arrivesAt": "06:59",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "07:00",
					"arrivesAt": "07:04",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "07:10",
					"arrivesAt": "07:14",
					"waitsAtSource": 360,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "07:15",
					"arrivesAt": "07:23",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "07:24",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Ploieşti Vest",
					"leavesAt": "07:30",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "07:46",
					"arrivesAt": "07:53",
					"waitsAtSource": 720,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "07:54",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Bobolia h.",
					"leavesAt": "08:04",
					"arrivesAt": "08:11",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Bobolia h.",
					"to": "Câmpina",
					"leavesAt": "08:12",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "08:20",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "08:26",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "08:30",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "08:34",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Posada h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Posada h.",
					"to": "Sinaia Sud h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 8900
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "08:55",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "09:00",
					"arrivesAt": "09:05",
					"waitsAtSource": 120,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "09:06",
					"arrivesAt": "09:10",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "09:11",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "09:17",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "09:29",
					"arrivesAt": "09:44",
					"waitsAtSource": 120,
					"distance": 9900
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Timişu de Jos h.",
					"leavesAt": "09:45",
					"arrivesAt": "09:53",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Dârste",
					"leavesAt": "09:54",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "10:03",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1948",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "18:42",
					"arrivesAt": "18:49",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Reghin",
					"leavesAt": "18:55",
					"arrivesAt": "19:26",
					"waitsAtSource": 360,
					"distance": 28200
				},
				{
					"from": "Reghin",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "19:28",
					"arrivesAt": "19:43",
					"waitsAtSource": 120,
					"distance": 16100
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Deda",
					"leavesAt": "19:48",
					"arrivesAt": "19:54",
					"waitsAtSource": 300,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2213",
			"segments": [
				{
					"from": "Arad",
					"to": "Şofronea",
					"leavesAt": "19:45",
					"arrivesAt": "19:55",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Şofronea",
					"to": "Curtici",
					"leavesAt": "19:56",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3112",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Vest Hm.",
					"leavesAt": "05:02",
					"arrivesAt": "05:09",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "05:10",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Cefa Hm.",
					"leavesAt": "05:22",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Cefa Hm.",
					"to": "Mădăraş Bihor h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Mădăraş Bihor h.",
					"to": "Salonta",
					"leavesAt": "05:43",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Salonta",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Boiu Bihor h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Boiu Bihor h.",
					"to": "Tămaşda h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tămaşda h.",
					"to": "Zerind Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:22",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Zerind Hm.",
					"to": "Chişineu Criş",
					"leavesAt": "06:23",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Chişineu Criş",
					"to": "Nădab",
					"leavesAt": "06:31",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Nădab",
					"to": "Şimand Hm.",
					"leavesAt": "06:37",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şimand Hm.",
					"to": "Comlăuş h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Comlăuş h.",
					"to": "Sântana",
					"leavesAt": "06:53",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "06:58",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utviniş h.",
					"leavesAt": "07:08",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Utviniş h.",
					"to": "Utvinişu Nou",
					"leavesAt": "07:12",
					"arrivesAt": "07:16",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Utvinişu Nou",
					"to": "Arad",
					"leavesAt": "07:17",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "07:42",
					"arrivesAt": "07:49",
					"waitsAtSource": 900,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Valea Viilor Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "08:00",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Şag Hm.",
					"leavesAt": "08:10",
					"arrivesAt": "08:15",
					"waitsAtSource": 600,
					"distance": 5500
				},
				{
					"from": "Şag Hm.",
					"to": "Vinga Hm.",
					"leavesAt": "08:16",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vinga Hm.",
					"to": "Orţişoara",
					"leavesAt": "08:23",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Orţişoara",
					"to": "Băile Călacea",
					"leavesAt": "08:29",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Băile Călacea",
					"to": "Sânandrei Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "08:50",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "08:53",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1934",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Carei",
					"leavesAt": "17:55",
					"arrivesAt": "18:28",
					"waitsAtSource": 0,
					"distance": 36000
				},
				{
					"from": "Carei",
					"to": "Valea lui Mihai",
					"leavesAt": "18:40",
					"arrivesAt": "19:08",
					"waitsAtSource": 720,
					"distance": 31200
				},
				{
					"from": "Valea lui Mihai",
					"to": "Săcuieni Bihor",
					"leavesAt": "19:09",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Diosig Hm.",
					"leavesAt": "19:27",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Diosig Hm.",
					"to": "Oradea",
					"leavesAt": "19:49",
					"arrivesAt": "20:24",
					"waitsAtSource": 600,
					"distance": 33700
				},
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "20:38",
					"arrivesAt": "21:12",
					"waitsAtSource": 840,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Bratca",
					"leavesAt": "21:13",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 25300
				},
				{
					"from": "Bratca",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "21:43",
					"arrivesAt": "21:56",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Ciucea Hm.",
					"leavesAt": "22:02",
					"arrivesAt": "22:13",
					"waitsAtSource": 360,
					"distance": 10800
				},
				{
					"from": "Ciucea Hm.",
					"to": "Huedin",
					"leavesAt": "22:14",
					"arrivesAt": "22:35",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Huedin",
					"to": "Aghireş",
					"leavesAt": "22:37",
					"arrivesAt": "23:01",
					"waitsAtSource": 120,
					"distance": 21500
				},
				{
					"from": "Aghireş",
					"to": "Cluj Napoca",
					"leavesAt": "23:02",
					"arrivesAt": "23:30",
					"waitsAtSource": 60,
					"distance": 27900
				},
				{
					"from": "Cluj Napoca",
					"to": "Câmpia Turzii",
					"leavesAt": "23:49",
					"arrivesAt": "00:56",
					"waitsAtSource": 1140,
					"distance": 51500
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "00:57",
					"arrivesAt": "01:13",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Aiud Hm.",
					"leavesAt": "01:14",
					"arrivesAt": "01:32",
					"waitsAtSource": 60,
					"distance": 20400
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "01:33",
					"arrivesAt": "01:47",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Crăciunel Hm.",
					"leavesAt": "01:53",
					"arrivesAt": "02:16",
					"waitsAtSource": 360,
					"distance": 16000
				},
				{
					"from": "Crăciunel Hm.",
					"to": "Blaj",
					"leavesAt": "02:21",
					"arrivesAt": "02:29",
					"waitsAtSource": 300,
					"distance": 5300
				},
				{
					"from": "Blaj",
					"to": "Copşa Mică",
					"leavesAt": "02:31",
					"arrivesAt": "03:09",
					"waitsAtSource": 120,
					"distance": 30000
				},
				{
					"from": "Copşa Mică",
					"to": "Mediaş",
					"leavesAt": "03:14",
					"arrivesAt": "03:27",
					"waitsAtSource": 300,
					"distance": 10400
				},
				{
					"from": "Mediaş",
					"to": "Dumbrăveni",
					"leavesAt": "03:39",
					"arrivesAt": "04:05",
					"waitsAtSource": 720,
					"distance": 18000
				},
				{
					"from": "Dumbrăveni",
					"to": "Sighişoara",
					"leavesAt": "04:07",
					"arrivesAt": "04:34",
					"waitsAtSource": 120,
					"distance": 20400
				},
				{
					"from": "Sighişoara",
					"to": "Rupea",
					"leavesAt": "04:38",
					"arrivesAt": "05:39",
					"waitsAtSource": 240,
					"distance": 53600
				},
				{
					"from": "Rupea",
					"to": "Braşov",
					"leavesAt": "05:41",
					"arrivesAt": "07:16",
					"waitsAtSource": 120,
					"distance": 73800
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "07:25",
					"arrivesAt": "08:00",
					"waitsAtSource": 540,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "08:02",
					"arrivesAt": "08:11",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "08:12",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "08:19",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "08:30",
					"arrivesAt": "08:54",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "08:55",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "09:21",
					"arrivesAt": "10:06",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1788",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "13:00",
					"arrivesAt": "13:11",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "13:16",
					"arrivesAt": "13:39",
					"waitsAtSource": 300,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "13:40",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "14:07",
					"arrivesAt": "14:47",
					"waitsAtSource": 480,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1726",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Cărbuneşti",
					"leavesAt": "13:55",
					"arrivesAt": "14:21",
					"waitsAtSource": 0,
					"distance": 23800
				},
				{
					"from": "Cărbuneşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "14:42",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Gilort Hm.",
					"leavesAt": "14:52",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gilort Hm.",
					"to": "Filiaşi",
					"leavesAt": "15:00",
					"arrivesAt": "15:14",
					"waitsAtSource": 60,
					"distance": 12400
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "15:15",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "15:45",
					"arrivesAt": "16:24",
					"waitsAtSource": 300,
					"distance": 53600
				}
			],
			"restrictions": [
				{
					"from": "20180807",
					"to": "20181208",
					"daysOfWeek": 783
				},
				{
					"from": "20171210",
					"to": "20180802",
					"daysOfWeek": 783
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5450",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "19:50",
					"arrivesAt": "19:55",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "19:57",
					"arrivesAt": "20:04",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "20:05",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "20:13",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "20:20",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "20:33",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:57",
					"waitsAtSource": 600,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "20:58",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "21:10",
					"arrivesAt": "21:16",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "21:33",
					"arrivesAt": "21:40",
					"waitsAtSource": 1020,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "21:41",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "21:47",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "21:52",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "21:58",
					"arrivesAt": "22:02",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "22:03",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "22:10",
					"arrivesAt": "22:19",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "22:21",
					"arrivesAt": "22:28",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "22:29",
					"arrivesAt": "22:33",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "22:34",
					"arrivesAt": "22:42",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "22:43",
					"arrivesAt": "22:48",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "22:49",
					"arrivesAt": "22:54",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "22:55",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9028",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "13:40",
					"arrivesAt": "13:45",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slatina",
					"leavesAt": "13:46",
					"arrivesAt": "14:03",
					"waitsAtSource": 30,
					"distance": 13000
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "14:05",
					"arrivesAt": "14:13",
					"waitsAtSource": 120,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "14:14",
					"arrivesAt": "14:21",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "14:22",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Potcoava",
					"to": "Sineşti Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:36",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sineşti Hm.",
					"to": "Corbu",
					"leavesAt": "14:37",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Corbu",
					"to": "Hârseşti Hm.",
					"leavesAt": "14:44",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "14:51",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stolnici Hm.",
					"to": "Fâlfani Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Costeşti",
					"leavesAt": "15:07",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Costeşti",
					"to": "Suseni h.",
					"leavesAt": "15:18",
					"arrivesAt": "15:22",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Suseni h.",
					"to": "Pârvu h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:26",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Pârvu h.",
					"to": "Bradu de Sus",
					"leavesAt": "15:27",
					"arrivesAt": "15:42",
					"waitsAtSource": 30,
					"distance": 9700
				},
				{
					"from": "Bradu de Sus",
					"to": "Km. 109+000 h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:49",
					"waitsAtSource": 240,
					"distance": 3500
				},
				{
					"from": "Km. 109+000 h.",
					"to": "Piteşti",
					"leavesAt": "15:50",
					"arrivesAt": "15:52",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Piteşti",
					"to": "Ram. Goleşti",
					"leavesAt": "16:10",
					"arrivesAt": "16:16",
					"waitsAtSource": 1080,
					"distance": 4600
				},
				{
					"from": "Ram. Goleşti",
					"to": "Goleşti",
					"leavesAt": "16:17",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Goleşti",
					"to": "Călineşti Hm.",
					"leavesAt": "16:25",
					"arrivesAt": "16:33",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Călineşti Hm.",
					"to": "Leordeni Argeş",
					"leavesAt": "16:34",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Leordeni Argeş",
					"to": "Pătroaia Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pătroaia Hm.",
					"to": "Găeşti",
					"leavesAt": "16:47",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Găeşti",
					"to": "Găeşti Sud h.",
					"leavesAt": "16:55",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Găeşti Sud h.",
					"to": "Cojocaru h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Cojocaru h.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:08",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Fusea Hm.",
					"leavesAt": "17:09",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Fusea Hm.",
					"to": "Titu",
					"leavesAt": "17:14",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:28",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "17:29",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "17:33",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "17:45",
					"arrivesAt": "17:51",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "17:52",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "18:00",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "18:07",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "18:10",
					"arrivesAt": "18:14",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "18:19",
					"arrivesAt": "18:21",
					"waitsAtSource": 300,
					"distance": 1900
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "18:22",
					"arrivesAt": "18:25",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "18:26",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180526",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180610",
					"daysOfWeek": 383
				},
				{
					"from": "20180616",
					"to": "20180617",
					"daysOfWeek": 383
				},
				{
					"from": "20180623",
					"to": "20180624",
					"daysOfWeek": 383
				},
				{
					"from": "20180630",
					"to": "20180701",
					"daysOfWeek": 383
				},
				{
					"from": "20180707",
					"to": "20180708",
					"daysOfWeek": 383
				},
				{
					"from": "20180714",
					"to": "20180715",
					"daysOfWeek": 383
				},
				{
					"from": "20180721",
					"to": "20180722",
					"daysOfWeek": 383
				},
				{
					"from": "20180728",
					"to": "20180729",
					"daysOfWeek": 383
				},
				{
					"from": "20180804",
					"to": "20180805",
					"daysOfWeek": 383
				},
				{
					"from": "20180811",
					"to": "20180819",
					"daysOfWeek": 383
				},
				{
					"from": "20180825",
					"to": "20180826",
					"daysOfWeek": 383
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 383
				},
				{
					"from": "20180908",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180922",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180506",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2511",
			"segments": [
				{
					"from": "Ucea",
					"to": "Arpaş Hm.",
					"leavesAt": "04:06",
					"arrivesAt": "04:14",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Arpaş Hm.",
					"to": "Cârţa h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cârţa h.",
					"to": "Scoreiu h.",
					"leavesAt": "04:19",
					"arrivesAt": "04:23",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Scoreiu h.",
					"to": "Sărata Colun h.",
					"leavesAt": "04:24",
					"arrivesAt": "04:27",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Sărata Colun h.",
					"to": "Porumbacu Hm.",
					"leavesAt": "04:28",
					"arrivesAt": "04:33",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "04:34",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Avrig Hm.",
					"to": "Mârşa h.",
					"leavesAt": "04:48",
					"arrivesAt": "04:53",
					"waitsAtSource": 300,
					"distance": 3700
				},
				{
					"from": "Mârşa h.",
					"to": "Racoviţa h.",
					"leavesAt": "04:54",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Racoviţa h.",
					"to": "Sebeş Olt h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Podu Olt",
					"leavesAt": "05:02",
					"arrivesAt": "05:07",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "05:08",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "05:16",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "05:26",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "05:30",
					"arrivesAt": "05:34",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Atelier Zona h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu",
					"leavesAt": "05:44",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9586",
			"segments": [
				{
					"from": "Jimbolia",
					"to": "Clarii Vii h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:14",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Clarii Vii h.",
					"to": "Cărpiniş",
					"leavesAt": "06:15",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Cărpiniş",
					"to": "Beregsău hcv.",
					"leavesAt": "06:24",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Beregsău hcv.",
					"to": "Săcălaz h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Săcălaz h.",
					"to": "Timişoara Nord",
					"leavesAt": "06:40",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1926",
			"segments": [
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "20:02",
					"arrivesAt": "20:15",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Călan Hm.",
					"leavesAt": "20:24",
					"arrivesAt": "20:40",
					"waitsAtSource": 540,
					"distance": 14600
				},
				{
					"from": "Călan Hm.",
					"to": "Subcetate",
					"leavesAt": "20:41",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Subcetate",
					"to": "Petroşani",
					"leavesAt": "20:57",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 49800
				},
				{
					"from": "Petroşani",
					"to": "Livezeni",
					"leavesAt": "22:08",
					"arrivesAt": "22:15",
					"waitsAtSource": 240,
					"distance": 5200
				},
				{
					"from": "Livezeni",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "22:16",
					"arrivesAt": "22:22",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Valea Sadului Hm.",
					"leavesAt": "22:26",
					"arrivesAt": "23:02",
					"waitsAtSource": 240,
					"distance": 23500
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "23:04",
					"arrivesAt": "23:27",
					"waitsAtSource": 120,
					"distance": 19600
				},
				{
					"from": "Târgu Jiu",
					"to": "Rovinari Hm.",
					"leavesAt": "23:30",
					"arrivesAt": "23:59",
					"waitsAtSource": 180,
					"distance": 21800
				},
				{
					"from": "Rovinari Hm.",
					"to": "Turceni",
					"leavesAt": "00:00",
					"arrivesAt": "00:35",
					"waitsAtSource": 60,
					"distance": 35300
				},
				{
					"from": "Turceni",
					"to": "Filiaşi",
					"leavesAt": "00:36",
					"arrivesAt": "01:02",
					"waitsAtSource": 60,
					"distance": 19900
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "01:04",
					"arrivesAt": "01:30",
					"waitsAtSource": 120,
					"distance": 35800
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "347",
			"segments": [
				{
					"from": "Lokoshaza",
					"to": "Curtici",
					"leavesAt": "03:39",
					"arrivesAt": "03:49",
					"waitsAtSource": 0,
					"distance": 11200
				},
				{
					"from": "Curtici",
					"to": "Arad",
					"leavesAt": "04:19",
					"arrivesAt": "04:33",
					"waitsAtSource": 1800,
					"distance": 17000
				},
				{
					"from": "Arad",
					"to": "Deva",
					"leavesAt": "04:47",
					"arrivesAt": "07:28",
					"waitsAtSource": 840,
					"distance": 148200
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "07:30",
					"arrivesAt": "07:42",
					"waitsAtSource": 120,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Şibot",
					"leavesAt": "07:54",
					"arrivesAt": "08:33",
					"waitsAtSource": 720,
					"distance": 28800
				},
				{
					"from": "Şibot",
					"to": "Vinţu de Jos",
					"leavesAt": "08:34",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Vinţu de Jos",
					"to": "Cunţa Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 22100
				},
				{
					"from": "Cunţa Hm.",
					"to": "Sibiu",
					"leavesAt": "09:30",
					"arrivesAt": "10:44",
					"waitsAtSource": 240,
					"distance": 60700
				},
				{
					"from": "Sibiu",
					"to": "Făgăraş",
					"leavesAt": "10:54",
					"arrivesAt": "12:18",
					"waitsAtSource": 600,
					"distance": 83900
				},
				{
					"from": "Făgăraş",
					"to": "Braşov",
					"leavesAt": "12:20",
					"arrivesAt": "13:30",
					"waitsAtSource": 120,
					"distance": 65000
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "13:42",
					"arrivesAt": "14:17",
					"waitsAtSource": 720,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Sinaia",
					"leavesAt": "14:19",
					"arrivesAt": "14:38",
					"waitsAtSource": 120,
					"distance": 19000
				},
				{
					"from": "Sinaia",
					"to": "Ploieşti Vest",
					"leavesAt": "14:39",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 62100
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "15:24",
					"arrivesAt": "16:05",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9359",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "04:16",
					"arrivesAt": "04:21",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Peret hc.",
					"leavesAt": "04:22",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Peret hc.",
					"to": "Plosca Hm.",
					"leavesAt": "04:36",
					"arrivesAt": "04:44",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Plosca Hm.",
					"to": "Buzescu h.",
					"leavesAt": "04:45",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzescu h.",
					"to": "Alexandria Nord h.",
					"leavesAt": "04:55",
					"arrivesAt": "05:05",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Alexandria",
					"leavesAt": "05:06",
					"arrivesAt": "05:12",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4515",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:54",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "19:55",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "20:01",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:11",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "20:23",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Arcuş h.",
					"leavesAt": "20:36",
					"arrivesAt": "20:40",
					"waitsAtSource": 300,
					"distance": 5000
				},
				{
					"from": "Arcuş h.",
					"to": "Bodoc Hm.",
					"leavesAt": "20:41",
					"arrivesAt": "20:46",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Bodoc Hm.",
					"to": "Malnaş h.",
					"leavesAt": "20:47",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Malnaş h.",
					"to": "Malnaş Băi",
					"leavesAt": "20:55",
					"arrivesAt": "21:02",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Malnaş Băi",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "21:10",
					"arrivesAt": "21:20",
					"waitsAtSource": 480,
					"distance": 7800
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "21:21",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Tuşnad Sat",
					"leavesAt": "21:31",
					"arrivesAt": "21:38",
					"waitsAtSource": 120,
					"distance": 5700
				},
				{
					"from": "Tuşnad Sat",
					"to": "Vrabia h.",
					"leavesAt": "21:39",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Vrabia h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "21:43",
					"arrivesAt": "21:49",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "21:50",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "21:54",
					"arrivesAt": "21:58",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "21:59",
					"arrivesAt": "22:07",
					"waitsAtSource": 60,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8015",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "20:00",
					"arrivesAt": "20:09",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "20:10",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Pasărea",
					"leavesAt": "20:16",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pasărea",
					"to": "Brăneşti Sat h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "20:28",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Islaz h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:41",
					"waitsAtSource": 480,
					"distance": 2400
				},
				{
					"from": "Islaz h.",
					"to": "Fundulea Hm.",
					"leavesAt": "20:42",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Fundulea Hm.",
					"to": "Mostiştea h.",
					"leavesAt": "20:50",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Mostiştea h.",
					"to": "Săruleşti",
					"leavesAt": "20:55",
					"arrivesAt": "21:00",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Săruleşti",
					"to": "Preasna h.",
					"leavesAt": "21:01",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Preasna h.",
					"to": "Lehliu",
					"leavesAt": "21:07",
					"arrivesAt": "21:15",
					"waitsAtSource": 30,
					"distance": 8800
				},
				{
					"from": "Lehliu",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "21:16",
					"arrivesAt": "21:20",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "21:21",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dâlga h.",
					"leavesAt": "21:25",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dâlga h.",
					"to": "Bogdana h.",
					"leavesAt": "21:31",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Bogdana h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "21:38",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Ivăneşti h.",
					"leavesAt": "21:42",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ivăneşti h.",
					"to": "Ciulniţa",
					"leavesAt": "21:47",
					"arrivesAt": "21:53",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "21:54",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "22:01",
					"arrivesAt": "22:04",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "22:05",
					"arrivesAt": "22:08",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "22:09",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "22:13",
					"arrivesAt": "22:17",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "22:18",
					"arrivesAt": "22:22",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "22:23",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8393",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "19:39",
					"arrivesAt": "19:50",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "19:51",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "19:58",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "20:07",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "20:14",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "20:21",
					"arrivesAt": "20:29",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "20:37",
					"arrivesAt": "20:39",
					"waitsAtSource": 480,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "20:40",
					"arrivesAt": "20:50",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "20:51",
					"arrivesAt": "20:55",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "20:56",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180523",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9306",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Atârnaţi Hm.",
					"leavesAt": "16:32",
					"arrivesAt": "16:39",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Vârtoapele hc.",
					"leavesAt": "16:49",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Olteni",
					"leavesAt": "16:55",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Ciolpani Hm.",
					"leavesAt": "17:15",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Videle",
					"leavesAt": "17:22",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Videle",
					"to": "Zăvestreni Hm.",
					"leavesAt": "17:33",
					"arrivesAt": "17:38",
					"waitsAtSource": 120,
					"distance": 4800
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:51",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Zorile h.",
					"leavesAt": "17:52",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zorile h.",
					"to": "Grădinari",
					"leavesAt": "17:57",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Grădinari",
					"to": "Domneştii de Sus h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:15",
					"waitsAtSource": 240,
					"distance": 6000
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Chiajna",
					"leavesAt": "18:16",
					"arrivesAt": "18:32",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Chiajna",
					"to": "Bucureştii Noi",
					"leavesAt": "18:33",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Carpaţi h.(900)",
					"leavesAt": "18:37",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "18:40",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "18:44",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9400",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Şopârliţa hc.",
					"leavesAt": "03:40",
					"arrivesAt": "03:51",
					"waitsAtSource": 0,
					"distance": 11100
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Vlăduleni",
					"leavesAt": "03:52",
					"arrivesAt": "03:58",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vlăduleni",
					"to": "Fălcoiu h.",
					"leavesAt": "03:59",
					"arrivesAt": "04:03",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Fălcoiu h.",
					"to": "Romula Hm.",
					"leavesAt": "04:04",
					"arrivesAt": "04:16",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Romula Hm.",
					"to": "Caracal",
					"leavesAt": "04:17",
					"arrivesAt": "04:30",
					"waitsAtSource": 60,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20180527",
					"daysOfWeek": 319
				},
				{
					"from": "20180529",
					"to": "20181130",
					"daysOfWeek": 319
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1784",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "08:00",
					"arrivesAt": "08:11",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "08:12",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "08:36",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "08:56",
					"arrivesAt": "09:36",
					"waitsAtSource": 60,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1949",
			"segments": [
				{
					"from": "Deda",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "03:25",
					"arrivesAt": "03:32",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Reghin",
					"leavesAt": "03:39",
					"arrivesAt": "03:56",
					"waitsAtSource": 420,
					"distance": 16100
				},
				{
					"from": "Reghin",
					"to": "Târgu Mureş",
					"leavesAt": "03:58",
					"arrivesAt": "04:32",
					"waitsAtSource": 120,
					"distance": 32300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1994",
			"segments": [
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "04:28",
					"arrivesAt": "05:07",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "05:08",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Radomireşti Hm.",
					"leavesAt": "05:24",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "05:36",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 25600
				},
				{
					"from": "Roşiori Nord",
					"to": "Olteni",
					"leavesAt": "06:00",
					"arrivesAt": "06:26",
					"waitsAtSource": 120,
					"distance": 26800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Videle",
					"leavesAt": "06:36",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 15800
				},
				{
					"from": "Videle",
					"to": "Grădinari",
					"leavesAt": "06:50",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 25400
				},
				{
					"from": "Grădinari",
					"to": "Bucureşti Nord",
					"leavesAt": "07:16",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 25500
				},
				{
					"from": "Bucureşti Nord",
					"to": "Feteşti",
					"leavesAt": "08:05",
					"arrivesAt": "09:20",
					"waitsAtSource": 1260,
					"distance": 146400
				},
				{
					"from": "Feteşti",
					"to": "Constanţa",
					"leavesAt": "09:21",
					"arrivesAt": "10:18",
					"waitsAtSource": 60,
					"distance": 78600
				},
				{
					"from": "Constanţa",
					"to": "Eforie Nord",
					"leavesAt": "10:45",
					"arrivesAt": "11:11",
					"waitsAtSource": 1620,
					"distance": 14000
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "11:14",
					"arrivesAt": "11:22",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Costineşti",
					"leavesAt": "11:25",
					"arrivesAt": "11:41",
					"waitsAtSource": 180,
					"distance": 8600
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "11:49",
					"arrivesAt": "11:53",
					"waitsAtSource": 480,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "11:56",
					"arrivesAt": "12:09",
					"waitsAtSource": 180,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "12:12",
					"arrivesAt": "12:22",
					"waitsAtSource": 180,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8203",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Sud",
					"leavesAt": "16:20",
					"arrivesAt": "16:26",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Buzău Sud",
					"to": "Tăbărăşti h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 300,
					"distance": 5100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:40",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Bentu h.",
					"leavesAt": "16:41",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bentu h.",
					"to": "Cilibia Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Cilibia Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "16:53",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Movila Oii h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "16:58",
					"arrivesAt": "17:05",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Făurei",
					"leavesAt": "17:06",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Făurei",
					"to": "Cireşu Hm.",
					"leavesAt": "17:19",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 15700
				},
				{
					"from": "Cireşu Hm.",
					"to": "Scărlăteşti hc.",
					"leavesAt": "17:33",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Scărlăteşti hc.",
					"to": "Dudeşti Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Dudeşti Hm.",
					"to": "Spicu",
					"leavesAt": "17:43",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Spicu",
					"to": "Murgeanca Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Murgeanca Hm.",
					"to": "Ţăndărei",
					"leavesAt": "17:59",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Ţăndărei",
					"to": "Platoneşti h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Platoneşti h.",
					"to": "Movila Hm.",
					"leavesAt": "18:17",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Movila Hm.",
					"to": "Feteşti",
					"leavesAt": "18:26",
					"arrivesAt": "18:43",
					"waitsAtSource": 60,
					"distance": 16700
				},
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "18:47",
					"arrivesAt": "18:54",
					"waitsAtSource": 240,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Ovidiu",
					"leavesAt": "18:55",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ovidiu",
					"to": "Dunărea Hm.",
					"leavesAt": "19:00",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Dunărea Hm.",
					"to": "Cernavodă Pod",
					"leavesAt": "19:07",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "19:18",
					"arrivesAt": "19:26",
					"waitsAtSource": 180,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "19:27",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "19:34",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "19:45",
					"arrivesAt": "19:49",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "19:50",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "19:55",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "20:00",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:09",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "20:10",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "20:15",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "20:21",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3511",
			"segments": [
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "13:25",
					"arrivesAt": "13:33",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "13:34",
					"arrivesAt": "13:41",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Şeica Mică h.",
					"leavesAt": "13:46",
					"arrivesAt": "13:51",
					"waitsAtSource": 300,
					"distance": 5500
				},
				{
					"from": "Şeica Mică h.",
					"to": "Micăsasa h.",
					"leavesAt": "13:52",
					"arrivesAt": "14:04",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Micăsasa h.",
					"to": "Lunca h.",
					"leavesAt": "14:05",
					"arrivesAt": "14:14",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lunca h.",
					"to": "Valea Lungă Hm.",
					"leavesAt": "14:15",
					"arrivesAt": "14:20",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Glogoveţ h.",
					"leavesAt": "14:21",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Glogoveţ h.",
					"to": "Mănărade h.",
					"leavesAt": "14:27",
					"arrivesAt": "14:30",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Mănărade h.",
					"to": "Câmpu Libertăţii  h.",
					"leavesAt": "14:31",
					"arrivesAt": "14:35",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Câmpu Libertăţii  h.",
					"to": "Blaj",
					"leavesAt": "14:36",
					"arrivesAt": "14:41",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Blaj",
					"to": "Crăciunel Hm.",
					"leavesAt": "14:50",
					"arrivesAt": "14:58",
					"waitsAtSource": 540,
					"distance": 5300
				},
				{
					"from": "Crăciunel Hm.",
					"to": "Cistei h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Cistei h.",
					"to": "Mihalţ h.",
					"leavesAt": "15:09",
					"arrivesAt": "15:14",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Mihalţ h.",
					"to": "Coşlariu Gr. P. Mureş",
					"leavesAt": "15:15",
					"arrivesAt": "15:19",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Coşlariu Gr. P. Mureş",
					"to": "Teiuş",
					"leavesAt": "15:20",
					"arrivesAt": "15:27",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9341",
			"segments": [
				{
					"from": "Videle",
					"to": "Răduleşti Hm.",
					"leavesAt": "05:52",
					"arrivesAt": "06:02",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "06:03",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Târnavele Hm.",
					"to": "Vlaşca Hm.",
					"leavesAt": "06:13",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Răsuceni h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Răsuceni h.",
					"to": "Toporu",
					"leavesAt": "06:29",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Toporu",
					"to": "Chiriacu Hm.",
					"leavesAt": "06:34",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Stăneşti Hm.",
					"leavesAt": "06:46",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Onceşti h.",
					"leavesAt": "06:54",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Onceşti h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "06:59",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Cetatea h.",
					"leavesAt": "07:06",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cetatea h.",
					"to": "Giurgiu Nord",
					"leavesAt": "07:09",
					"arrivesAt": "07:15",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Giurgiu Nord",
					"to": "Giurgiu",
					"leavesAt": "07:16",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3083",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "04:17",
					"arrivesAt": "04:29",
					"waitsAtSource": 0,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Mirăslău h.",
					"leavesAt": "04:30",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Mirăslău h.",
					"to": "Decea h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:39",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Decea h.",
					"to": "Unirea Hm.",
					"leavesAt": "04:40",
					"arrivesAt": "04:45",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Unirea Hm.",
					"to": "Unirea hc.",
					"leavesAt": "04:46",
					"arrivesAt": "04:49",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "04:50",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Grindeni h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Grindeni h.",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "05:04",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Câmpia Turzii",
					"leavesAt": "05:11",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cânepişti h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:30",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Cânepişti h.",
					"to": "Ploscoş h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Ploscoş h.",
					"to": "Valea Florilor Hm.",
					"leavesAt": "05:38",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Boju",
					"leavesAt": "05:44",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Boju",
					"to": "Tunel Hm.",
					"leavesAt": "05:57",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Tunel Hm.",
					"to": "Cojocna Hm.",
					"leavesAt": "06:05",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cojocna Hm.",
					"to": "Apahida",
					"leavesAt": "06:13",
					"arrivesAt": "06:19",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "06:20",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "06:24",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "06:38",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1971",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "18:40",
					"arrivesAt": "19:04",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "19:05",
					"arrivesAt": "19:22",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "19:23",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Movila Hm.",
					"leavesAt": "19:44",
					"arrivesAt": "20:01",
					"waitsAtSource": 120,
					"distance": 16700
				},
				{
					"from": "Movila Hm.",
					"to": "Platoneşti h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Platoneşti h.",
					"to": "Ţăndărei",
					"leavesAt": "20:09",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ţăndărei",
					"to": "Ianca hc.",
					"leavesAt": "20:18",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 72100
				},
				{
					"from": "Ianca hc.",
					"to": "Brăila",
					"leavesAt": "21:28",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 42400
				},
				{
					"from": "Brăila",
					"to": "Barboşi",
					"leavesAt": "22:02",
					"arrivesAt": "22:20",
					"waitsAtSource": 120,
					"distance": 19500
				},
				{
					"from": "Barboşi",
					"to": "Galaţi",
					"leavesAt": "22:21",
					"arrivesAt": "22:40",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3538",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "18:25",
					"arrivesAt": "18:33",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Vânători",
					"leavesAt": "18:34",
					"arrivesAt": "18:41",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Vânători",
					"to": "Saschiz h.",
					"leavesAt": "18:42",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Saschiz h.",
					"to": "Mureni Hm.",
					"leavesAt": "18:47",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mureni Hm.",
					"to": "Archita h",
					"leavesAt": "18:54",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Archita h",
					"to": "Beia Hm.",
					"leavesAt": "19:08",
					"arrivesAt": "19:23",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Beia Hm.",
					"to": "Paloş Ardeal h.",
					"leavesAt": "19:24",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paloş Ardeal h.",
					"to": "Caţa Hm.",
					"leavesAt": "19:32",
					"arrivesAt": "19:38",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Caţa Hm.",
					"to": "Rupea",
					"leavesAt": "19:39",
					"arrivesAt": "19:48",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Rupea",
					"to": "Mateiaş h.",
					"leavesAt": "19:49",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Mateiaş h.",
					"to": "Racoş Hm.",
					"leavesAt": "20:04",
					"arrivesAt": "20:10",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Racoş Hm.",
					"to": "Augustin Hm.",
					"leavesAt": "20:11",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Augustin Hm.",
					"to": "Ormeniş h.",
					"leavesAt": "20:28",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ormeniş h.",
					"to": "Apaţa",
					"leavesAt": "20:37",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Apaţa",
					"to": "Măieruş h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Măieruş h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "20:54",
					"arrivesAt": "20:59",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Rotbav h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Rotbav h.",
					"to": "Feldioara Hm.",
					"leavesAt": "21:06",
					"arrivesAt": "21:13",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Bod Hm.",
					"leavesAt": "21:14",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Bod Hm.",
					"to": "Stupini Hm.",
					"leavesAt": "21:30",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Stupini Hm.",
					"to": "Braşov",
					"leavesAt": "21:40",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2205",
			"segments": [
				{
					"from": "Arad",
					"to": "Şofronea",
					"leavesAt": "12:50",
					"arrivesAt": "13:00",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Şofronea",
					"to": "Curtici",
					"leavesAt": "13:01",
					"arrivesAt": "13:10",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9120",
			"segments": [
				{
					"from": "Parcul Kreţulescu h.",
					"to": "Câmpulung",
					"leavesAt": "05:35",
					"arrivesAt": "05:38",
					"waitsAtSource": 0,
					"distance": 1900
				},
				{
					"from": "Câmpulung",
					"to": "Schitu Goleşti",
					"leavesAt": "05:40",
					"arrivesAt": "05:51",
					"waitsAtSource": 120,
					"distance": 6700
				},
				{
					"from": "Schitu Goleşti",
					"to": "Lăzăreşti Hm.",
					"leavesAt": "05:52",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lăzăreşti Hm.",
					"to": "Drăghici h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Drăghici h.",
					"to": "Stâlpeni Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:18",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Stâlpeni Hm.",
					"to": "Clucereasa h.",
					"leavesAt": "06:19",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Clucereasa h.",
					"to": "Ciumeşti",
					"leavesAt": "06:28",
					"arrivesAt": "06:40",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Ciumeşti",
					"to": "Gropeni h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Gropeni h.",
					"to": "Ştefăneşti Argeş Hm.",
					"leavesAt": "06:47",
					"arrivesAt": "06:53",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Ştefăneşti Argeş Hm.",
					"to": "Goleşti",
					"leavesAt": "06:54",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4456",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:33",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "17:34",
					"arrivesAt": "17:39",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:46",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "17:47",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5414",
			"segments": [
				{
					"from": "Bacău",
					"to": "Letea h.",
					"leavesAt": "13:35",
					"arrivesAt": "13:41",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Letea h.",
					"to": "Valea Seacă",
					"leavesAt": "13:42",
					"arrivesAt": "13:47",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Seacă",
					"to": "Siretu Bacău h.",
					"leavesAt": "13:48",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Faraoani Hm.",
					"leavesAt": "13:53",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Faraoani Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "13:59",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Răcăciuni h.",
					"to": "Orbeni Hm.",
					"leavesAt": "14:06",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Orbeni Hm.",
					"to": "Sascut Hm.",
					"leavesAt": "14:18",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Sascut Hm.",
					"to": "Şişcani h.",
					"leavesAt": "14:26",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Şişcani h.",
					"to": "Adjudu Vechi h.",
					"leavesAt": "14:33",
					"arrivesAt": "14:37",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Adjud",
					"leavesAt": "14:38",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5634",
			"segments": [
				{
					"from": "Dorneşti",
					"to": "Ţibeni h.",
					"leavesAt": "17:28",
					"arrivesAt": "17:37",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Ţibeni h.",
					"to": "Milişăuţi Hm.",
					"leavesAt": "17:38",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Dărmăneşti",
					"leavesAt": "17:47",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "17:59",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "18:11",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "367",
			"segments": [
				{
					"from": "Biharkeresztes",
					"to": "Episcopia Bihor",
					"leavesAt": "12:28",
					"arrivesAt": "12:43",
					"waitsAtSource": 0,
					"distance": 12500
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "12:58",
					"arrivesAt": "13:06",
					"waitsAtSource": 900,
					"distance": 5700
				},
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "13:13",
					"arrivesAt": "13:44",
					"waitsAtSource": 420,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Bratca",
					"leavesAt": "13:45",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 25300
				},
				{
					"from": "Bratca",
					"to": "Ciucea Hm.",
					"leavesAt": "14:12",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Ciucea Hm.",
					"to": "Huedin",
					"leavesAt": "14:34",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Huedin",
					"to": "Aghireş",
					"leavesAt": "14:55",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Aghireş",
					"to": "Cluj Napoca",
					"leavesAt": "15:20",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 27900
				},
				{
					"from": "Cluj Napoca",
					"to": "Gherla",
					"leavesAt": "16:08",
					"arrivesAt": "17:06",
					"waitsAtSource": 1260,
					"distance": 44900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "17:08",
					"arrivesAt": "17:27",
					"waitsAtSource": 120,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Beclean pe Someş",
					"leavesAt": "17:31",
					"arrivesAt": "18:04",
					"waitsAtSource": 240,
					"distance": 24600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Sărăţel Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:32",
					"waitsAtSource": 120,
					"distance": 24900
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Deda",
					"leavesAt": "18:33",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 46800
				},
				{
					"from": "Deda",
					"to": "Topliţa",
					"leavesAt": "19:29",
					"arrivesAt": "20:26",
					"waitsAtSource": 120,
					"distance": 43900
				},
				{
					"from": "Topliţa",
					"to": "Gheorgheni",
					"leavesAt": "20:28",
					"arrivesAt": "21:00",
					"waitsAtSource": 120,
					"distance": 34000
				},
				{
					"from": "Gheorgheni",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "21:02",
					"arrivesAt": "21:11",
					"waitsAtSource": 120,
					"distance": 9000
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Izvoru Oltului",
					"leavesAt": "21:17",
					"arrivesAt": "21:41",
					"waitsAtSource": 360,
					"distance": 21000
				},
				{
					"from": "Izvoru Oltului",
					"to": "Siculeni",
					"leavesAt": "21:43",
					"arrivesAt": "22:02",
					"waitsAtSource": 120,
					"distance": 17100
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "22:04",
					"arrivesAt": "22:12",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "22:14",
					"arrivesAt": "22:37",
					"waitsAtSource": 120,
					"distance": 28500
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Bodoc Hm.",
					"leavesAt": "22:39",
					"arrivesAt": "23:06",
					"waitsAtSource": 120,
					"distance": 24900
				},
				{
					"from": "Bodoc Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "23:13",
					"arrivesAt": "23:22",
					"waitsAtSource": 420,
					"distance": 9500
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Braşov",
					"leavesAt": "23:24",
					"arrivesAt": "23:54",
					"waitsAtSource": 120,
					"distance": 32100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9367",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "14:20",
					"arrivesAt": "14:25",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Peret hc.",
					"leavesAt": "14:26",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Peret hc.",
					"to": "Plosca Hm.",
					"leavesAt": "14:41",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Plosca Hm.",
					"to": "Buzescu h.",
					"leavesAt": "14:51",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzescu h.",
					"to": "Alexandria Nord h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:12",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Alexandria",
					"leavesAt": "15:13",
					"arrivesAt": "15:18",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Alexandria",
					"to": "Ţigăneşti h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:32",
					"waitsAtSource": 120,
					"distance": 9500
				},
				{
					"from": "Ţigăneşti h.",
					"to": "Brânceni h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:36",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Brânceni h.",
					"to": "Smârdioasa h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:42",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Smârdioasa h.",
					"to": "Păuleasa h.",
					"leavesAt": "15:43",
					"arrivesAt": "15:48",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Păuleasa h.",
					"to": "Şoimu h.",
					"leavesAt": "15:49",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Şoimu h.",
					"to": "Ulmuleţ h.",
					"leavesAt": "15:55",
					"arrivesAt": "16:04",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Ulmuleţ h.",
					"to": "Zimnicea",
					"leavesAt": "16:05",
					"arrivesAt": "16:20",
					"waitsAtSource": 30,
					"distance": 9800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8595",
			"segments": [
				{
					"from": "Ciulniţa",
					"to": "Ştefan Vodă h.",
					"leavesAt": "18:52",
					"arrivesAt": "19:05",
					"waitsAtSource": 0,
					"distance": 12600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "19:06",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Km. 25+700 h.",
					"leavesAt": "19:13",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Km. 25+700 h.",
					"to": "Călăraşi Sud",
					"leavesAt": "19:20",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 1300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5443",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "09:29",
					"arrivesAt": "09:40",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "09:41",
					"arrivesAt": "09:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "09:46",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "09:52",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "10:02",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "10:07",
					"arrivesAt": "10:14",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "10:16",
					"arrivesAt": "10:23",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "10:24",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "10:31",
					"arrivesAt": "10:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "10:36",
					"arrivesAt": "10:41",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "10:42",
					"arrivesAt": "10:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "10:47",
					"arrivesAt": "10:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani",
					"leavesAt": "10:52",
					"arrivesAt": "11:02",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "11:10",
					"arrivesAt": "11:15",
					"waitsAtSource": 480,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "11:16",
					"arrivesAt": "11:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "11:27",
					"arrivesAt": "11:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "11:33",
					"arrivesAt": "11:38",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "11:39",
					"arrivesAt": "11:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "11:46",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "11:53",
					"arrivesAt": "11:59",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "12:00",
					"arrivesAt": "12:06",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "12:07",
					"arrivesAt": "12:13",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "12:14",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "12:23",
					"arrivesAt": "12:29",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8032",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "11:55",
					"arrivesAt": "12:01",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "12:02",
					"arrivesAt": "12:09",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "12:10",
					"arrivesAt": "12:15",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "12:16",
					"arrivesAt": "12:20",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:25",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "12:26",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "12:31",
					"arrivesAt": "12:34",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "12:35",
					"arrivesAt": "12:41",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "12:42",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "12:52",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "12:58",
					"arrivesAt": "13:07",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Dunărea Hm.",
					"leavesAt": "13:08",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Dunărea Hm.",
					"to": "Ovidiu",
					"leavesAt": "13:18",
					"arrivesAt": "13:24",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ovidiu",
					"to": "Ramificaţia Borcea",
					"leavesAt": "13:25",
					"arrivesAt": "13:29",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "13:30",
					"arrivesAt": "13:37",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1866",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Barboşi",
					"leavesAt": "16:40",
					"arrivesAt": "16:59",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Barboşi",
					"to": "Lieşti",
					"leavesAt": "17:04",
					"arrivesAt": "17:50",
					"waitsAtSource": 300,
					"distance": 48300
				},
				{
					"from": "Lieşti",
					"to": "Tecuci",
					"leavesAt": "17:51",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 24400
				},
				{
					"from": "Tecuci",
					"to": "Nichişeni",
					"leavesAt": "18:24",
					"arrivesAt": "18:47",
					"waitsAtSource": 180,
					"distance": 24400
				},
				{
					"from": "Nichişeni",
					"to": "Bârlad",
					"leavesAt": "18:52",
					"arrivesAt": "19:15",
					"waitsAtSource": 300,
					"distance": 25900
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "19:17",
					"arrivesAt": "19:46",
					"waitsAtSource": 120,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "19:47",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "20:03",
					"arrivesAt": "20:21",
					"waitsAtSource": 120,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "20:22",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "20:49",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "21:05",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8016",
			"segments": [
				{
					"from": "Feteşti",
					"to": "Bărăganu Hm.",
					"leavesAt": "14:20",
					"arrivesAt": "14:30",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "14:31",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Jegălia",
					"leavesAt": "14:36",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Jegălia",
					"to": "Recolta hc.",
					"leavesAt": "14:41",
					"arrivesAt": "14:44",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Recolta hc.",
					"to": "Perişoru Hm.",
					"leavesAt": "14:45",
					"arrivesAt": "14:48",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Perişoru Hm.",
					"to": "Ogoarele h.",
					"leavesAt": "14:49",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ogoarele h.",
					"to": "Ciulniţa",
					"leavesAt": "14:53",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 9000
				},
				{
					"from": "Ciulniţa",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Bogdana h.",
					"leavesAt": "15:12",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Bogdana h.",
					"to": "Dâlga h.",
					"leavesAt": "15:16",
					"arrivesAt": "15:22",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Dâlga h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "15:23",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "15:29",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Lehliu",
					"leavesAt": "15:33",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Lehliu",
					"to": "Preasna h.",
					"leavesAt": "15:38",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Preasna h.",
					"to": "Săruleşti",
					"leavesAt": "15:44",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Săruleşti",
					"to": "Mostiştea h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:01",
					"waitsAtSource": 420,
					"distance": 5900
				},
				{
					"from": "Mostiştea h.",
					"to": "Fundulea Hm.",
					"leavesAt": "16:02",
					"arrivesAt": "16:07",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Fundulea Hm.",
					"to": "Islaz h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Islaz h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "16:15",
					"arrivesAt": "16:18",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Brăneşti Sat h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Pasărea",
					"leavesAt": "16:22",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Pasărea",
					"to": "Pantelimon",
					"leavesAt": "16:29",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pantelimon",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "16:36",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Bucureşti Obor",
					"leavesAt": "16:39",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4504",
			"segments": [
				{
					"from": "Topliţa",
					"to": "Gălăuţaş Hm.",
					"leavesAt": "04:23",
					"arrivesAt": "04:31",
					"waitsAtSource": 0,
					"distance": 6000
				},
				{
					"from": "Gălăuţaş Hm.",
					"to": "Sărmaş Runc h.",
					"leavesAt": "04:32",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Sărmaş Runc h.",
					"to": "Subcetate Mureş Hm.",
					"leavesAt": "04:39",
					"arrivesAt": "04:45",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Subcetate Mureş Hm.",
					"to": "Ditrău",
					"leavesAt": "04:46",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ditrău",
					"to": "Lăzarea Hm.",
					"leavesAt": "04:55",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Lăzarea Hm.",
					"to": "Gheorgheni",
					"leavesAt": "05:02",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Gheorgheni",
					"to": "Valea Strâmbă h.",
					"leavesAt": "05:09",
					"arrivesAt": "05:12",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Şugău h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:16",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Şugău h.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:21",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "05:22",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Sândominic h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Oltului",
					"leavesAt": "05:42",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Tomeşti h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Cârţani h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:55",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Cârţani h.",
					"to": "Dăneşti h.",
					"leavesAt": "05:56",
					"arrivesAt": "05:59",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Dăneşti h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "06:00",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Racu h.",
					"leavesAt": "06:07",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Racu h.",
					"to": "Siculeni",
					"leavesAt": "06:13",
					"arrivesAt": "06:18",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "06:22",
					"arrivesAt": "06:30",
					"waitsAtSource": 240,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "07:36",
					"arrivesAt": "07:44",
					"waitsAtSource": 3960,
					"distance": 7800
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "07:51",
					"arrivesAt": "07:55",
					"waitsAtSource": 420,
					"distance": 3400
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "07:56",
					"arrivesAt": "08:00",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Vrabia h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Vrabia h.",
					"to": "Tuşnad Sat",
					"leavesAt": "08:07",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Tuşnad Sat",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "08:20",
					"arrivesAt": "08:27",
					"waitsAtSource": 480,
					"distance": 5700
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "08:28",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Malnaş Băi",
					"leavesAt": "08:36",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Malnaş Băi",
					"to": "Malnaş h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Malnaş h.",
					"to": "Bodoc Hm.",
					"leavesAt": "08:51",
					"arrivesAt": "08:58",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Bodoc Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "08:59",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "09:08",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "09:20",
					"arrivesAt": "09:25",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "09:26",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "09:30",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "09:45",
					"arrivesAt": "09:51",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1838",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Buziaş",
					"leavesAt": "17:36",
					"arrivesAt": "18:13",
					"waitsAtSource": 0,
					"distance": 36400
				},
				{
					"from": "Buziaş",
					"to": "Lugoj",
					"leavesAt": "18:14",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 27500
				},
				{
					"from": "Lugoj",
					"to": "Mănăştur Hm.",
					"leavesAt": "18:45",
					"arrivesAt": "19:16",
					"waitsAtSource": 60,
					"distance": 31200
				},
				{
					"from": "Mănăştur Hm.",
					"to": "Făget",
					"leavesAt": "19:17",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Făget",
					"to": "Margina",
					"leavesAt": "19:27",
					"arrivesAt": "19:40",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Margina",
					"to": "Ilia",
					"leavesAt": "19:41",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 35500
				},
				{
					"from": "Ilia",
					"to": "Deva",
					"leavesAt": "20:22",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 23600
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "20:51",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Orăştie",
					"leavesAt": "21:15",
					"arrivesAt": "21:37",
					"waitsAtSource": 720,
					"distance": 16500
				},
				{
					"from": "Orăştie",
					"to": "Şibot",
					"leavesAt": "21:42",
					"arrivesAt": "22:00",
					"waitsAtSource": 300,
					"distance": 12300
				},
				{
					"from": "Şibot",
					"to": "Vinţu de Jos",
					"leavesAt": "22:01",
					"arrivesAt": "22:23",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "22:24",
					"arrivesAt": "22:36",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Teiuş",
					"leavesAt": "22:38",
					"arrivesAt": "23:13",
					"waitsAtSource": 120,
					"distance": 19100
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "23:14",
					"arrivesAt": "23:26",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Unirea hc.",
					"leavesAt": "23:27",
					"arrivesAt": "23:41",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "23:42",
					"arrivesAt": "23:49",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Câmpia Turzii",
					"leavesAt": "23:50",
					"arrivesAt": "00:06",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cluj Napoca",
					"leavesAt": "00:07",
					"arrivesAt": "01:13",
					"waitsAtSource": 60,
					"distance": 51500
				},
				{
					"from": "Cluj Napoca",
					"to": "Gherla",
					"leavesAt": "01:26",
					"arrivesAt": "02:24",
					"waitsAtSource": 780,
					"distance": 44900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "02:25",
					"arrivesAt": "02:44",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Beclean pe Someş",
					"leavesAt": "02:46",
					"arrivesAt": "03:19",
					"waitsAtSource": 120,
					"distance": 24600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Salva",
					"leavesAt": "03:21",
					"arrivesAt": "03:43",
					"waitsAtSource": 120,
					"distance": 21600
				},
				{
					"from": "Salva",
					"to": "Năsăud",
					"leavesAt": "03:44",
					"arrivesAt": "03:51",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Năsăud",
					"to": "Ilva Mică",
					"leavesAt": "03:52",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 19800
				},
				{
					"from": "Ilva Mică",
					"to": "Lunca Ilvei",
					"leavesAt": "04:15",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 31600
				},
				{
					"from": "Lunca Ilvei",
					"to": "Floreni",
					"leavesAt": "04:52",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 31900
				},
				{
					"from": "Floreni",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "05:33",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Vatra Dornei",
					"leavesAt": "05:50",
					"arrivesAt": "05:53",
					"waitsAtSource": 120,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei",
					"to": "Iacobeni",
					"leavesAt": "05:54",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Iacobeni",
					"to": "Mestecăniş",
					"leavesAt": "06:10",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Pojorâta Hm.",
					"leavesAt": "06:22",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "06:44",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "06:54",
					"arrivesAt": "06:59",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Vama",
					"leavesAt": "07:02",
					"arrivesAt": "07:16",
					"waitsAtSource": 180,
					"distance": 11800
				},
				{
					"from": "Vama",
					"to": "Frasin",
					"leavesAt": "07:17",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "07:29",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Suceava",
					"leavesAt": "07:38",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 46800
				},
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "08:33",
					"arrivesAt": "08:46",
					"waitsAtSource": 720,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "08:47",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "09:06",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Târgu Frumos",
					"leavesAt": "09:24",
					"arrivesAt": "09:51",
					"waitsAtSource": 120,
					"distance": 30800
				},
				{
					"from": "Târgu Frumos",
					"to": "Iaşi",
					"leavesAt": "09:52",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 44900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "1385",
			"segments": [
				{
					"from": "Vadu Siretului",
					"to": "Vicşani",
					"leavesAt": "16:25",
					"arrivesAt": "16:51",
					"waitsAtSource": 0,
					"distance": 10600
				},
				{
					"from": "Vicşani",
					"to": "Dorneşti",
					"leavesAt": "17:35",
					"arrivesAt": "17:49",
					"waitsAtSource": 2640,
					"distance": 8300
				},
				{
					"from": "Dorneşti",
					"to": "Milişăuţi Hm.",
					"leavesAt": "17:50",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Dărmăneşti",
					"leavesAt": "18:03",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "18:13",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "18:23",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20180612",
					"to": "20180615",
					"daysOfWeek": 383
				},
				{
					"from": "20180617",
					"to": "20180622",
					"daysOfWeek": 383
				},
				{
					"from": "20180624",
					"to": "20180627",
					"daysOfWeek": 383
				},
				{
					"from": "20180629",
					"to": "20180704",
					"daysOfWeek": 383
				},
				{
					"from": "20180706",
					"to": "20180709",
					"daysOfWeek": 383
				},
				{
					"from": "20180711",
					"to": "20180716",
					"daysOfWeek": 383
				},
				{
					"from": "20180718",
					"to": "20180721",
					"daysOfWeek": 383
				},
				{
					"from": "20180723",
					"to": "20180728",
					"daysOfWeek": 383
				},
				{
					"from": "20180730",
					"to": "20180802",
					"daysOfWeek": 383
				},
				{
					"from": "20180804",
					"to": "20180809",
					"daysOfWeek": 383
				},
				{
					"from": "20180811",
					"to": "20180814",
					"daysOfWeek": 383
				},
				{
					"from": "20180816",
					"to": "20180821",
					"daysOfWeek": 383
				},
				{
					"from": "20180823",
					"to": "20180826",
					"daysOfWeek": 383
				},
				{
					"from": "20180828",
					"to": "20180904",
					"daysOfWeek": 383
				},
				{
					"from": "20180906",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180911",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180610",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3082",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "07:52",
					"arrivesAt": "08:02",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "08:08",
					"arrivesAt": "08:14",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Cojocna Hm.",
					"leavesAt": "08:15",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cojocna Hm.",
					"to": "Tunel Hm.",
					"leavesAt": "08:21",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tunel Hm.",
					"to": "Boju",
					"leavesAt": "08:30",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Boju",
					"to": "Valea Florilor Hm.",
					"leavesAt": "08:39",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Ploscoş h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ploscoş h.",
					"to": "Cânepişti h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cânepişti h.",
					"to": "Câmpia Turzii",
					"leavesAt": "09:04",
					"arrivesAt": "09:12",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Câmpia Turzii",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "09:13",
					"arrivesAt": "09:21",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Grindeni h.",
					"leavesAt": "09:22",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Grindeni h.",
					"to": "Războieni",
					"leavesAt": "09:29",
					"arrivesAt": "09:33",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "09:34",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Unirea Hm.",
					"leavesAt": "09:39",
					"arrivesAt": "09:45",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea Hm.",
					"to": "Decea h.",
					"leavesAt": "09:46",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Decea h.",
					"to": "Mirăslău h.",
					"leavesAt": "09:50",
					"arrivesAt": "09:54",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Mirăslău h.",
					"to": "Aiud Hm.",
					"leavesAt": "09:55",
					"arrivesAt": "10:02",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "10:03",
					"arrivesAt": "10:17",
					"waitsAtSource": 60,
					"distance": 13100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2079",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Găneasa h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:57",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Găneasa h.",
					"to": "Arceşti Hm.",
					"leavesAt": "20:58",
					"arrivesAt": "21:06",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Arceşti Hm.",
					"to": "Strejeşti",
					"leavesAt": "21:07",
					"arrivesAt": "21:21",
					"waitsAtSource": 60,
					"distance": 11600
				},
				{
					"from": "Strejeşti",
					"to": "Zlătărei Hm.",
					"leavesAt": "21:22",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Drăgăşani",
					"leavesAt": "21:29",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Drăgăşani",
					"to": "Călina h.",
					"leavesAt": "21:39",
					"arrivesAt": "21:46",
					"waitsAtSource": 120,
					"distance": 6400
				},
				{
					"from": "Călina h.",
					"to": "Zăvideni Hm.",
					"leavesAt": "21:47",
					"arrivesAt": "21:52",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "21:53",
					"arrivesAt": "21:59",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Orleşti hc.",
					"to": "Fişcălia Hm.",
					"leavesAt": "22:00",
					"arrivesAt": "22:03",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "22:04",
					"arrivesAt": "22:07",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Ioneşti Hm.",
					"leavesAt": "22:08",
					"arrivesAt": "22:12",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Slăviteşti hc.",
					"leavesAt": "22:13",
					"arrivesAt": "22:19",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Băbeni",
					"leavesAt": "22:20",
					"arrivesAt": "22:29",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Băbeni",
					"to": "Tătărani h.",
					"leavesAt": "22:30",
					"arrivesAt": "22:33",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Tătărani h.",
					"to": "Govora",
					"leavesAt": "22:34",
					"arrivesAt": "22:43",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Govora",
					"to": "Râureni hc.",
					"leavesAt": "22:44",
					"arrivesAt": "22:47",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Râureni hc.",
					"to": "Râureni",
					"leavesAt": "22:48",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni",
					"to": "Răstoaca h.",
					"leavesAt": "22:57",
					"arrivesAt": "22:59",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Răstoaca h.",
					"to": "Ostroveni h.",
					"leavesAt": "23:00",
					"arrivesAt": "23:04",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ostroveni h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "23:05",
					"arrivesAt": "23:07",
					"waitsAtSource": 30,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9551",
			"segments": [
				{
					"from": "Orşova",
					"to": "Topleţ Hm.",
					"leavesAt": "04:00",
					"arrivesAt": "04:10",
					"waitsAtSource": 0,
					"distance": 10300
				},
				{
					"from": "Topleţ Hm.",
					"to": "Băile Herculane",
					"leavesAt": "04:11",
					"arrivesAt": "04:20",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Herculane",
					"to": "Mehadia Nouă Hm.",
					"leavesAt": "04:21",
					"arrivesAt": "04:24",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Mehadia Nouă Hm.",
					"to": "Mehadia Hm.",
					"leavesAt": "04:25",
					"arrivesAt": "04:28",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Mehadia Hm.",
					"to": "Iablaniţa",
					"leavesAt": "04:29",
					"arrivesAt": "04:39",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Iablaniţa",
					"to": "Cruşovăţ",
					"leavesAt": "04:40",
					"arrivesAt": "04:48",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Cruşovăţ",
					"to": "Cornea h.",
					"leavesAt": "04:49",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Cornea h.",
					"to": "Domaşnea Cornea Hm.",
					"leavesAt": "04:56",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Domaşnea Cornea Hm.",
					"to": "Luncaviţa h.",
					"leavesAt": "05:01",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Luncaviţa h.",
					"to": "Poarta Hm.",
					"leavesAt": "05:06",
					"arrivesAt": "05:11",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Poarta Hm.",
					"to": "Teregova Hm.",
					"leavesAt": "05:12",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Teregova Hm.",
					"to": "Armeniş",
					"leavesAt": "05:22",
					"arrivesAt": "05:29",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Armeniş",
					"to": "Slatina Timiş",
					"leavesAt": "05:30",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Slatina Timiş",
					"to": "Vălişoara Hm.",
					"leavesAt": "05:38",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Vălişoara Hm.",
					"to": "Petroşniţa h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Petroşniţa h.",
					"to": "Valea Timişului Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:52",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Valea Timişului Hm.",
					"to": "Balta Sărată",
					"leavesAt": "05:53",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Balta Sărată",
					"to": "Caransebeş haltă h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Caransebeş haltă h.",
					"to": "Caransebeş",
					"leavesAt": "06:03",
					"arrivesAt": "06:10",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4319",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Botiz Hm.",
					"leavesAt": "23:27",
					"arrivesAt": "23:33",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Botiz Hm.",
					"to": "Odoreu h.",
					"leavesAt": "23:34",
					"arrivesAt": "23:39",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Odoreu h.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "23:40",
					"arrivesAt": "23:51",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Apa Hm.",
					"leavesAt": "23:52",
					"arrivesAt": "23:59",
					"waitsAtSource": 60,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20180527",
					"daysOfWeek": 319
				},
				{
					"from": "20180529",
					"to": "20181129",
					"daysOfWeek": 319
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2239",
			"segments": [
				{
					"from": "Remetea Mică",
					"to": "Fibiş h.",
					"leavesAt": "18:01",
					"arrivesAt": "18:06",
					"waitsAtSource": 0,
					"distance": 4300
				},
				{
					"from": "Fibiş h.",
					"to": "Bencei h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bencei h.",
					"to": "Pişchia h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pişchia h.",
					"to": "Cerneteaz h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Cerneteaz h.",
					"to": "Giarmata Hm.",
					"leavesAt": "18:31",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Giarmata Hm.",
					"to": "Viile Giarmata h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Viile Giarmata h.",
					"to": "Timişoara Est",
					"leavesAt": "18:41",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "18:54",
					"arrivesAt": "19:00",
					"waitsAtSource": 180,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4306",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "16:35",
					"arrivesAt": "16:45",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "16:51",
					"arrivesAt": "16:57",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Apahida h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:03",
					"waitsAtSource": 120,
					"distance": 2900
				},
				{
					"from": "Apahida h.",
					"to": "Jucu Hm.",
					"leavesAt": "17:04",
					"arrivesAt": "17:09",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Jucu Hm.",
					"to": "Răscruci h.",
					"leavesAt": "17:10",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Răscruci h.",
					"to": "Bonţida Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:22",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bonţida Hm.",
					"to": "Fundătura h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Fundătura h.",
					"to": "Iclod Hm.",
					"leavesAt": "17:30",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Iclod Hm.",
					"to": "Livada Someş h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:42",
					"waitsAtSource": 120,
					"distance": 4100
				},
				{
					"from": "Livada Someş h.",
					"to": "Gherla",
					"leavesAt": "17:43",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Gherla",
					"to": "Nima h.",
					"leavesAt": "17:53",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Nima h.",
					"to": "Dej Călători",
					"leavesAt": "18:05",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6811",
			"segments": [
				{
					"from": "Oradea",
					"to": "Episcopia Bihor",
					"leavesAt": "16:39",
					"arrivesAt": "16:46",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Episcopia Bihor",
					"to": "Biharia Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Biharia Hm.",
					"to": "Tămăşeu h.",
					"leavesAt": "16:56",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Tămăşeu h.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Diosig Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Diosig Hm.",
					"to": "Cadia h.",
					"leavesAt": "17:19",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cadia h.",
					"to": "Săcuieni Bihor",
					"leavesAt": "17:25",
					"arrivesAt": "17:31",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Şilindru Hm.",
					"leavesAt": "17:38",
					"arrivesAt": "17:47",
					"waitsAtSource": 420,
					"distance": 9400
				},
				{
					"from": "Şilindru Hm.",
					"to": "Simion h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:12",
					"waitsAtSource": 1140,
					"distance": 6300
				},
				{
					"from": "Simion h.",
					"to": "Valea lui Mihai",
					"leavesAt": "18:13",
					"arrivesAt": "18:19",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Valea lui Mihai",
					"to": "Nyirabrany",
					"leavesAt": "18:39",
					"arrivesAt": "18:54",
					"waitsAtSource": 1200,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1985",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Constanţa",
					"leavesAt": "09:00",
					"arrivesAt": "11:00",
					"waitsAtSource": 0,
					"distance": 225000
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1653",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Brazi",
					"leavesAt": "21:30",
					"arrivesAt": "22:08",
					"waitsAtSource": 0,
					"distance": 51400
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "22:12",
					"arrivesAt": "22:26",
					"waitsAtSource": 240,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "22:28",
					"arrivesAt": "23:01",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "23:02",
					"arrivesAt": "23:37",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "23:39",
					"arrivesAt": "00:11",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "00:12",
					"arrivesAt": "00:50",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "00:52",
					"arrivesAt": "01:16",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "01:17",
					"arrivesAt": "01:43",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "01:45",
					"arrivesAt": "02:22",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "02:34",
					"arrivesAt": "03:03",
					"waitsAtSource": 720,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Paşcani",
					"leavesAt": "03:05",
					"arrivesAt": "03:34",
					"waitsAtSource": 120,
					"distance": 40200
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "03:36",
					"arrivesAt": "03:56",
					"waitsAtSource": 120,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "03:57",
					"arrivesAt": "04:13",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "04:14",
					"arrivesAt": "04:26",
					"waitsAtSource": 60,
					"distance": 14800
				},
				{
					"from": "Suceava",
					"to": "Berchişeşti Hm.",
					"leavesAt": "04:38",
					"arrivesAt": "05:12",
					"waitsAtSource": 720,
					"distance": 34400
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Gura Humorului Oraş",
					"leavesAt": "05:16",
					"arrivesAt": "05:31",
					"waitsAtSource": 240,
					"distance": 12400
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "05:32",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Vama",
					"leavesAt": "05:41",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vama",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "05:52",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "06:08",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Pojorâta Hm.",
					"leavesAt": "06:15",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Mestecăniş",
					"leavesAt": "06:26",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Mestecăniş",
					"to": "Iacobeni",
					"leavesAt": "06:48",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Iacobeni",
					"to": "Vatra Dornei",
					"leavesAt": "06:58",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Vatra Dornei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "07:16",
					"arrivesAt": "07:19",
					"waitsAtSource": 120,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2343",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Coşlariu",
					"leavesAt": "14:51",
					"arrivesAt": "14:59",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Coşlariu",
					"to": "Sântimbru h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sântimbru h.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "15:12",
					"arrivesAt": "15:16",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "15:17",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "15:25",
					"arrivesAt": "15:34",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "15:36",
					"arrivesAt": "15:48",
					"waitsAtSource": 120,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Blandiana Hm.",
					"leavesAt": "15:56",
					"arrivesAt": "16:04",
					"waitsAtSource": 480,
					"distance": 5200
				},
				{
					"from": "Blandiana Hm.",
					"to": "Tărtăria h.",
					"leavesAt": "16:05",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tărtăria h.",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "16:12",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Şibot",
					"leavesAt": "16:19",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şibot",
					"to": "Geoagiu h.",
					"leavesAt": "16:26",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Geoagiu h.",
					"to": "Orăştie",
					"leavesAt": "16:37",
					"arrivesAt": "16:44",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Orăştie",
					"to": "Pricaz h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pricaz h.",
					"to": "Turdaş Hm.",
					"leavesAt": "16:50",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Turdaş Hm.",
					"to": "Simeria Veche h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Simeria Veche h.",
					"to": "Simeria",
					"leavesAt": "17:05",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Simeria",
					"to": "Săuleşti h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:22",
					"waitsAtSource": 300,
					"distance": 3300
				},
				{
					"from": "Săuleşti h.",
					"to": "Deva",
					"leavesAt": "17:23",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "17:33",
					"arrivesAt": "17:42",
					"waitsAtSource": 120,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Mintia h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Veţel h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Veţel h.",
					"to": "Brănişca Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "17:56",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Ilia",
					"leavesAt": "18:03",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ilia",
					"to": "Gurasada Hm.",
					"leavesAt": "18:11",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Gurasada Hm.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Burjuc h.",
					"leavesAt": "18:27",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Burjuc h.",
					"to": "Zam",
					"leavesAt": "18:34",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Zam",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "18:47",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Ilteu",
					"leavesAt": "18:52",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ilteu",
					"to": "Toc h.",
					"leavesAt": "19:00",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Toc h.",
					"to": "Săvârşin",
					"leavesAt": "19:04",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 7400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9025",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "15:52",
					"arrivesAt": "15:54",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "15:55",
					"arrivesAt": "15:57",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "15:58",
					"arrivesAt": "16:01",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "16:03",
					"arrivesAt": "16:06",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Chitila",
					"leavesAt": "16:07",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "16:11",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "16:20",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "16:33",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "16:44",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "16:53",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:05",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "17:06",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Fusea Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Fusea Hm.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "17:19",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Cojocaru h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Cojocaru h.",
					"to": "Găeşti Sud h.",
					"leavesAt": "17:30",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Găeşti Sud h.",
					"to": "Găeşti",
					"leavesAt": "17:33",
					"arrivesAt": "17:39",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Găeşti",
					"to": "Pătroaia Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Pătroaia Hm.",
					"to": "Leordeni Argeş",
					"leavesAt": "17:48",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Leordeni Argeş",
					"to": "Călineşti Hm.",
					"leavesAt": "17:55",
					"arrivesAt": "18:00",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Călineşti Hm.",
					"to": "Canton 97+770 h.",
					"leavesAt": "18:01",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Canton 97+770 h.",
					"to": "Goleşti",
					"leavesAt": "18:06",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Goleşti",
					"to": "Ram. Goleşti",
					"leavesAt": "18:10",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ram. Goleşti",
					"to": "Piteşti",
					"leavesAt": "18:15",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9595",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Săcălaz h.",
					"leavesAt": "23:12",
					"arrivesAt": "23:22",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Săcălaz h.",
					"to": "Beregsău hcv.",
					"leavesAt": "23:23",
					"arrivesAt": "23:30",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Beregsău hcv.",
					"to": "Cărpiniş",
					"leavesAt": "23:31",
					"arrivesAt": "23:38",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Cărpiniş",
					"to": "Clarii Vii h.",
					"leavesAt": "23:39",
					"arrivesAt": "23:46",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Clarii Vii h.",
					"to": "Jimbolia",
					"leavesAt": "23:47",
					"arrivesAt": "23:55",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2593",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(203)",
					"leavesAt": "10:10",
					"arrivesAt": "10:14",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "10:15",
					"arrivesAt": "10:25",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "10:26",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Mândra h.",
					"leavesAt": "10:32",
					"arrivesAt": "10:39",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Mândra h.",
					"to": "Loamneş Hm.",
					"leavesAt": "10:40",
					"arrivesAt": "10:46",
					"waitsAtSource": 30,
					"distance": 2000
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1856",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "22:48",
					"arrivesAt": "22:53",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "22:55",
					"arrivesAt": "23:07",
					"waitsAtSource": 120,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "23:08",
					"arrivesAt": "23:26",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "23:27",
					"arrivesAt": "23:43",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Roman",
					"leavesAt": "23:44",
					"arrivesAt": "00:12",
					"waitsAtSource": 60,
					"distance": 40200
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "00:14",
					"arrivesAt": "00:43",
					"waitsAtSource": 120,
					"distance": 43800
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "00:45",
					"arrivesAt": "01:25",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "01:27",
					"arrivesAt": "01:54",
					"waitsAtSource": 120,
					"distance": 25700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9614",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "07:17",
					"arrivesAt": "07:27",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Giroc h.",
					"leavesAt": "07:28",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Giroc h.",
					"to": "Semenic Hm.",
					"leavesAt": "07:32",
					"arrivesAt": "07:35",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Semenic Hm.",
					"to": "Urseni h.",
					"leavesAt": "07:36",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Urseni h.",
					"to": "Uliuc h.",
					"leavesAt": "07:41",
					"arrivesAt": "07:47",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Uliuc h.",
					"to": "Sacoşu Mic",
					"leavesAt": "07:48",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Sacoşu Mic",
					"to": "Chevereş h.",
					"leavesAt": "07:56",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Chevereş h.",
					"to": "Bacova h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:07",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bacova h.",
					"to": "Buziaş",
					"leavesAt": "08:08",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Buziaş",
					"to": "Căpăt h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:30",
					"waitsAtSource": 600,
					"distance": 7300
				},
				{
					"from": "Căpăt h.",
					"to": "Sinia Hm.",
					"leavesAt": "08:31",
					"arrivesAt": "08:36",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Sinia Hm.",
					"to": "Boldur h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Boldur h.",
					"to": "Lugoj",
					"leavesAt": "08:45",
					"arrivesAt": "08:59",
					"waitsAtSource": 30,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1983",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ciulniţa",
					"leavesAt": "07:30",
					"arrivesAt": "08:25",
					"waitsAtSource": 0,
					"distance": 108900
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "08:26",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Medgidia",
					"leavesAt": "08:49",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 44000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "09:21",
					"arrivesAt": "09:45",
					"waitsAtSource": 60,
					"distance": 34600
				},
				{
					"from": "Constanţa",
					"to": "Eforie Nord",
					"leavesAt": "10:05",
					"arrivesAt": "10:28",
					"waitsAtSource": 1200,
					"distance": 14000
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "10:30",
					"arrivesAt": "10:37",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Costineşti",
					"leavesAt": "10:39",
					"arrivesAt": "10:55",
					"waitsAtSource": 120,
					"distance": 8600
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "10:57",
					"arrivesAt": "11:01",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "11:03",
					"arrivesAt": "11:16",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "11:18",
					"arrivesAt": "11:28",
					"waitsAtSource": 120,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5710",
			"segments": [
				{
					"from": "Vatra Dornei",
					"to": "Argestru Hm.",
					"leavesAt": "06:05",
					"arrivesAt": "06:11",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Argestru Hm.",
					"to": "Iacobeni",
					"leavesAt": "06:12",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Iacobeni",
					"to": "Mestecăniş",
					"leavesAt": "06:23",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Valea Putnei P.M.",
					"leavesAt": "06:34",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Valea Putnei P.M.",
					"to": "Pojorâta Hm.",
					"leavesAt": "06:44",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Sadova Hm.",
					"leavesAt": "06:57",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sadova Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "07:03",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2850",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Amaradia",
					"leavesAt": "05:55",
					"arrivesAt": "06:02",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Amaradia",
					"to": "Drăguţeşti h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:11",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Vârţ h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Vârţ h.",
					"to": "Rogojelu",
					"leavesAt": "06:17",
					"arrivesAt": "06:21",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Rogojelu",
					"to": "Km. 49+800 h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rovinari Hm.",
					"leavesAt": "06:26",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Rovinari Hm.",
					"to": "Rovinari Sud h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Bâlteni h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bâlteni h.",
					"to": "Peşteana Jiu h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Plopşoru",
					"leavesAt": "06:49",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Plopşoru",
					"to": "Sărdăneşti h.",
					"leavesAt": "06:58",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Gârbovu h.",
					"leavesAt": "07:04",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Gârbovu h.",
					"to": "Turceni",
					"leavesAt": "07:10",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turceni",
					"to": "Termo Turceni h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:47",
					"waitsAtSource": 1620,
					"distance": 900
				},
				{
					"from": "Termo Turceni h.",
					"to": "Km. 9+820 h.",
					"leavesAt": "07:49",
					"arrivesAt": "07:53",
					"waitsAtSource": 120,
					"distance": 3000
				},
				{
					"from": "Km. 9+820 h.",
					"to": "Ioneşti Gorj h.",
					"leavesAt": "07:54",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ioneşti Gorj h.",
					"to": "Filiaşi",
					"leavesAt": "07:58",
					"arrivesAt": "08:13",
					"waitsAtSource": 30,
					"distance": 12400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4527",
			"segments": [
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "01:15",
					"arrivesAt": "01:42",
					"waitsAtSource": 0,
					"distance": 28500
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 382
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5109",
			"segments": [
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "11:05",
					"arrivesAt": "11:16",
					"waitsAtSource": 0,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "11:17",
					"arrivesAt": "11:27",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "11:28",
					"arrivesAt": "11:42",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "11:43",
					"arrivesAt": "11:51",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "11:52",
					"arrivesAt": "11:59",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "12:00",
					"arrivesAt": "12:08",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "12:09",
					"arrivesAt": "12:17",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "12:18",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "12:30",
					"arrivesAt": "12:45",
					"waitsAtSource": 120,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "12:46",
					"arrivesAt": "12:56",
					"waitsAtSource": 60,
					"distance": 8000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9370",
			"segments": [
				{
					"from": "Alexandria",
					"to": "Alexandria Nord h.",
					"leavesAt": "19:10",
					"arrivesAt": "19:12",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Buzescu h.",
					"leavesAt": "19:13",
					"arrivesAt": "19:22",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Buzescu h.",
					"to": "Plosca Hm.",
					"leavesAt": "19:23",
					"arrivesAt": "19:34",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Plosca Hm.",
					"to": "Peret hc.",
					"leavesAt": "19:35",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Peret hc.",
					"to": "Roşiori Hm.",
					"leavesAt": "19:42",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "19:56",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1895",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "15:30",
					"arrivesAt": "16:30",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "16:32",
					"arrivesAt": "16:51",
					"waitsAtSource": 120,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "16:52",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "17:16",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Piteşti",
					"to": "Costeşti",
					"leavesAt": "17:40",
					"arrivesAt": "18:05",
					"waitsAtSource": 720,
					"distance": 21800
				},
				{
					"from": "Costeşti",
					"to": "Fâlfani Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Slatina",
					"leavesAt": "18:19",
					"arrivesAt": "19:06",
					"waitsAtSource": 240,
					"distance": 51300
				},
				{
					"from": "Slatina",
					"to": "Piatra Olt",
					"leavesAt": "19:08",
					"arrivesAt": "19:26",
					"waitsAtSource": 120,
					"distance": 17000
				},
				{
					"from": "Piatra Olt",
					"to": "Brăneţ h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:32",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Brăneţ h.",
					"to": "Balş",
					"leavesAt": "19:33",
					"arrivesAt": "19:38",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Balş",
					"to": "Craiova",
					"leavesAt": "19:39",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 31200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9055",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "13:05",
					"arrivesAt": "13:10",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Troian h.",
					"leavesAt": "13:22",
					"arrivesAt": "13:38",
					"waitsAtSource": 720,
					"distance": 13000
				},
				{
					"from": "Troian h.",
					"to": "Salcia Teleorman Hm.",
					"leavesAt": "13:39",
					"arrivesAt": "13:52",
					"waitsAtSource": 30,
					"distance": 9700
				},
				{
					"from": "Salcia Teleorman Hm.",
					"to": "Km. 231+600 h.",
					"leavesAt": "13:53",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 14500
				},
				{
					"from": "Km. 231+600 h.",
					"to": "Turnu Măgurele",
					"leavesAt": "14:11",
					"arrivesAt": "14:30",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 320
				},
				{
					"from": "20171210",
					"to": "20180407",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9592",
			"segments": [
				{
					"from": "Jimbolia",
					"to": "Clarii Vii h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:46",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Clarii Vii h.",
					"to": "Cărpiniş",
					"leavesAt": "14:47",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Cărpiniş",
					"to": "Beregsău hcv.",
					"leavesAt": "14:56",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Beregsău hcv.",
					"to": "Săcălaz h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Săcălaz h.",
					"to": "Timişoara Nord",
					"leavesAt": "15:12",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2562",
			"segments": [
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:32",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "05:33",
					"arrivesAt": "05:40",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Axente Sever h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 900,
					"distance": 2700
				},
				{
					"from": "Axente Sever h.",
					"to": "Agârbiciu h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Agârbiciu h.",
					"to": "Şeica Mare",
					"leavesAt": "06:08",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şeica Mare",
					"to": "Şeica Mare h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Şeica Mare h.",
					"to": "Hăşag h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:28",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Hăşag h.",
					"to": "Loamneş Hm.",
					"leavesAt": "06:29",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Loamneş Hm.",
					"to": "Mândra h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:46",
					"waitsAtSource": 480,
					"distance": 2000
				},
				{
					"from": "Mândra h.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "06:56",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Sibiu h.(203)",
					"leavesAt": "07:04",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Sibiu",
					"leavesAt": "07:14",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5003",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "09:20",
					"arrivesAt": "09:30",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "09:31",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Periş",
					"leavesAt": "09:43",
					"arrivesAt": "09:54",
					"waitsAtSource": 360,
					"distance": 13300
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "09:55",
					"arrivesAt": "09:59",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "10:00",
					"arrivesAt": "10:04",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "10:05",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "10:11",
					"arrivesAt": "10:19",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "10:20",
					"arrivesAt": "10:35",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "10:38",
					"arrivesAt": "10:44",
					"waitsAtSource": 180,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "10:45",
					"arrivesAt": "10:54",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Muru hc.",
					"leavesAt": "10:55",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "11:00",
					"arrivesAt": "11:04",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "11:05",
					"arrivesAt": "11:10",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "11:11",
					"arrivesAt": "11:16",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "11:17",
					"arrivesAt": "11:25",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "11:26",
					"arrivesAt": "11:36",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "11:37",
					"arrivesAt": "11:45",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "11:46",
					"arrivesAt": "11:51",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "11:52",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "11:58",
					"arrivesAt": "12:10",
					"waitsAtSource": 30,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4072",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:10",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "05:11",
					"arrivesAt": "05:15",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "05:16",
					"arrivesAt": "05:22",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "05:23",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Zalău Nord",
					"to": "Guruslău h.",
					"leavesAt": "05:46",
					"arrivesAt": "05:55",
					"waitsAtSource": 360,
					"distance": 6700
				},
				{
					"from": "Guruslău h.",
					"to": "Borla Hm.",
					"leavesAt": "05:56",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Borla Hm.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "06:07",
					"arrivesAt": "06:11",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Sărmăşag",
					"leavesAt": "06:12",
					"arrivesAt": "06:20",
					"waitsAtSource": 30,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180107",
					"daysOfWeek": 799
				},
				{
					"from": "20180113",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2568",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Daneş Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:38",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Daneş Hm.",
					"to": "Luna h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Luna h.",
					"to": "Dumbrăveni",
					"leavesAt": "15:47",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Dumbrăveni",
					"to": "Aţel Hm.",
					"leavesAt": "15:55",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Aţel Hm.",
					"to": "Bratei h.",
					"leavesAt": "16:05",
					"arrivesAt": "16:14",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Bratei h.",
					"to": "Mediaş",
					"leavesAt": "16:15",
					"arrivesAt": "16:23",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "16:25",
					"arrivesAt": "16:32",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "16:33",
					"arrivesAt": "16:40",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Axente Sever h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:53",
					"waitsAtSource": 480,
					"distance": 2700
				},
				{
					"from": "Axente Sever h.",
					"to": "Agârbiciu h.",
					"leavesAt": "16:54",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Agârbiciu h.",
					"to": "Şeica Mare",
					"leavesAt": "17:01",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şeica Mare",
					"to": "Şeica Mare h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Şeica Mare h.",
					"to": "Hăşag h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:21",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Hăşag h.",
					"to": "Loamneş Hm.",
					"leavesAt": "17:22",
					"arrivesAt": "17:27",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Loamneş Hm.",
					"to": "Mândra h.",
					"leavesAt": "17:28",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mândra h.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "17:32",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:49",
					"waitsAtSource": 120,
					"distance": 2100
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Sibiu h.(203)",
					"leavesAt": "17:51",
					"arrivesAt": "18:00",
					"waitsAtSource": 120,
					"distance": 8800
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Sibiu",
					"leavesAt": "18:01",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5524",
			"segments": [
				{
					"from": "Târgu Neamţ",
					"to": "Sfântu Mina h.",
					"leavesAt": "10:41",
					"arrivesAt": "10:46",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Plăieşu h.",
					"leavesAt": "10:47",
					"arrivesAt": "10:50",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plăieşu h.",
					"to": "Timişeşti Hm.",
					"leavesAt": "10:51",
					"arrivesAt": "10:57",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "10:58",
					"arrivesAt": "11:03",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Topile h.",
					"leavesAt": "11:04",
					"arrivesAt": "11:12",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Topile h.",
					"to": "Paşcani",
					"leavesAt": "11:13",
					"arrivesAt": "11:23",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "11:31",
					"arrivesAt": "11:45",
					"waitsAtSource": 480,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "11:46",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "11:54",
					"arrivesAt": "11:59",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "12:00",
					"arrivesAt": "12:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "12:09",
					"arrivesAt": "12:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "12:20",
					"arrivesAt": "12:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "12:27",
					"arrivesAt": "12:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "12:34",
					"arrivesAt": "12:41",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "12:42",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5632",
			"segments": [
				{
					"from": "Dorneşti",
					"to": "Ţibeni h.",
					"leavesAt": "10:05",
					"arrivesAt": "10:15",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Ţibeni h.",
					"to": "Milişăuţi Hm.",
					"leavesAt": "10:16",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Dărmăneşti",
					"leavesAt": "10:25",
					"arrivesAt": "10:36",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "10:37",
					"arrivesAt": "10:48",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "10:49",
					"arrivesAt": "10:54",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1663",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Brazi",
					"leavesAt": "11:50",
					"arrivesAt": "12:25",
					"waitsAtSource": 0,
					"distance": 51400
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "12:29",
					"arrivesAt": "12:43",
					"waitsAtSource": 240,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "12:45",
					"arrivesAt": "13:18",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "13:19",
					"arrivesAt": "13:54",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "13:56",
					"arrivesAt": "14:27",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "14:28",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Tecuci",
					"leavesAt": "15:08",
					"arrivesAt": "15:51",
					"waitsAtSource": 120,
					"distance": 36500
				},
				{
					"from": "Tecuci",
					"to": "Nichişeni",
					"leavesAt": "16:02",
					"arrivesAt": "16:25",
					"waitsAtSource": 660,
					"distance": 24400
				},
				{
					"from": "Nichişeni",
					"to": "Bârlad",
					"leavesAt": "16:29",
					"arrivesAt": "16:51",
					"waitsAtSource": 240,
					"distance": 25900
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "16:53",
					"arrivesAt": "17:22",
					"waitsAtSource": 120,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "17:23",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "17:44",
					"arrivesAt": "18:02",
					"waitsAtSource": 420,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "18:03",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "18:30",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "18:47",
					"arrivesAt": "18:54",
					"waitsAtSource": 120,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2201",
			"segments": [
				{
					"from": "Arad",
					"to": "Şofronea",
					"leavesAt": "06:21",
					"arrivesAt": "06:31",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Şofronea",
					"to": "Curtici",
					"leavesAt": "06:32",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9695",
			"segments": [
				{
					"from": "Oraviţa",
					"to": "Brădişoru de Jos h.",
					"leavesAt": "11:15",
					"arrivesAt": "11:28",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Brădişoru de Jos h.",
					"to": "Dobrei hcv.",
					"leavesAt": "11:29",
					"arrivesAt": "11:52",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Dobrei hcv.",
					"to": "Lişava Hm.",
					"leavesAt": "11:53",
					"arrivesAt": "12:06",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Lişava Hm.",
					"to": "Ciudanoviţa Pam.",
					"leavesAt": "12:07",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 1200
				},
				{
					"from": "Ciudanoviţa Pam.",
					"to": "Gârlişte Hm.",
					"leavesAt": "12:12",
					"arrivesAt": "12:37",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Gârlişte Hm.",
					"to": "Anina",
					"leavesAt": "12:38",
					"arrivesAt": "13:09",
					"waitsAtSource": 60,
					"distance": 8100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3091",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "19:30",
					"arrivesAt": "19:42",
					"waitsAtSource": 0,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Mirăslău h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:48",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Mirăslău h.",
					"to": "Decea h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:52",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Decea h.",
					"to": "Unirea Hm.",
					"leavesAt": "19:53",
					"arrivesAt": "19:58",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Unirea Hm.",
					"to": "Unirea hc.",
					"leavesAt": "19:59",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "20:03",
					"arrivesAt": "20:10",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Grindeni h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Grindeni h.",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "20:15",
					"arrivesAt": "20:21",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Câmpia Turzii",
					"leavesAt": "20:22",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cânepişti h.",
					"leavesAt": "20:30",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Cânepişti h.",
					"to": "Ploscoş h.",
					"leavesAt": "20:39",
					"arrivesAt": "20:44",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ploscoş h.",
					"to": "Valea Florilor Hm.",
					"leavesAt": "20:45",
					"arrivesAt": "20:51",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Boju",
					"leavesAt": "20:52",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Boju",
					"to": "Tunel Hm.",
					"leavesAt": "21:05",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Tunel Hm.",
					"to": "Cojocna Hm.",
					"leavesAt": "21:13",
					"arrivesAt": "21:20",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cojocna Hm.",
					"to": "Apahida",
					"leavesAt": "21:21",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Apahida",
					"to": "Cluj Napoca Est",
					"leavesAt": "21:27",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "21:36",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "21:42",
					"arrivesAt": "21:47",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1725",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Tălmaciu Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:24",
					"waitsAtSource": 0,
					"distance": 17800
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "17:25",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "17:32",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "17:38",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Câineni",
					"leavesAt": "17:59",
					"arrivesAt": "18:23",
					"waitsAtSource": 540,
					"distance": 15200
				},
				{
					"from": "Câineni",
					"to": "Păuşa h.",
					"leavesAt": "18:33",
					"arrivesAt": "19:14",
					"waitsAtSource": 600,
					"distance": 32600
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "19:15",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "19:20",
					"arrivesAt": "19:37",
					"waitsAtSource": 60,
					"distance": 16200
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Băbeni",
					"leavesAt": "19:40",
					"arrivesAt": "19:59",
					"waitsAtSource": 180,
					"distance": 19600
				},
				{
					"from": "Băbeni",
					"to": "Drăgăşani",
					"leavesAt": "20:00",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 33200
				},
				{
					"from": "Drăgăşani",
					"to": "Piatra Olt",
					"leavesAt": "20:23",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 33800
				},
				{
					"from": "Piatra Olt",
					"to": "Balş",
					"leavesAt": "20:50",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 12900
				},
				{
					"from": "Balş",
					"to": "Craiova",
					"leavesAt": "21:02",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 31200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3728",
			"segments": [
				{
					"from": "Nădab",
					"to": "Şimand Hm.",
					"leavesAt": "04:28",
					"arrivesAt": "04:36",
					"waitsAtSource": 0,
					"distance": 7400
				},
				{
					"from": "Şimand Hm.",
					"to": "Comlăuş h.",
					"leavesAt": "04:37",
					"arrivesAt": "04:45",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Comlăuş h.",
					"to": "Sântana",
					"leavesAt": "04:46",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "04:53",
					"arrivesAt": "05:04",
					"waitsAtSource": 120,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utviniş h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Utviniş h.",
					"to": "Arad",
					"leavesAt": "05:10",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 9600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6311",
			"segments": [
				{
					"from": "Tecuci",
					"to": "Tecuci Nord hc.(600)",
					"leavesAt": "04:52",
					"arrivesAt": "04:55",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Tecuci Nord hc.(600)",
					"to": "Frunzeasca Hm.",
					"leavesAt": "04:56",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Frunzeasca Hm.",
					"to": "Rateş Munteni h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Rateş Munteni h.",
					"to": "Berheci Hm.",
					"leavesAt": "05:08",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Berheci Hm.",
					"to": "Nichişeni",
					"leavesAt": "05:15",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Nichişeni",
					"to": "Ghidigeni Hm.",
					"leavesAt": "05:26",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ghidigeni Hm.",
					"to": "Tutova",
					"leavesAt": "05:32",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Tutova",
					"to": "Dragalina h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Dragalina h.",
					"to": "Bârlad",
					"leavesAt": "05:53",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Bârlad",
					"to": "Zorleni",
					"leavesAt": "06:06",
					"arrivesAt": "06:14",
					"waitsAtSource": 180,
					"distance": 7300
				},
				{
					"from": "Zorleni",
					"to": "Banca Hm.",
					"leavesAt": "06:15",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Banca Hm.",
					"to": "Dodeşti hc.",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dodeşti hc.",
					"to": "Roşieşti hc.",
					"leavesAt": "06:30",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Roşieşti hc.",
					"to": "Crasna",
					"leavesAt": "06:37",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Crasna",
					"to": "Bulboaca h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Bulboaca h.",
					"to": "Munteni Hm.",
					"leavesAt": "06:55",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Munteni Hm.",
					"to": "Vaslui",
					"leavesAt": "07:02",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vaslui",
					"to": "Bălteni Hm.",
					"leavesAt": "07:14",
					"arrivesAt": "07:24",
					"waitsAtSource": 360,
					"distance": 9800
				},
				{
					"from": "Bălteni Hm.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "07:25",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bârzeşti h.",
					"leavesAt": "07:31",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bârzeşti h.",
					"to": "Buhăieşti",
					"leavesAt": "07:36",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhăieşti",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Rebricea Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebricea Hm.",
					"to": "Scânteia Hm.",
					"leavesAt": "07:57",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Scânteia Hm.",
					"to": "Grajduri",
					"leavesAt": "08:04",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Grajduri",
					"to": "Bârnova Hm.",
					"leavesAt": "08:14",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Ciurea Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ciurea Hm.",
					"to": "Nicolina",
					"leavesAt": "08:37",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "08:44",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5630",
			"segments": [
				{
					"from": "Dorneşti",
					"to": "Ţibeni h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:55",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Ţibeni h.",
					"to": "Milişăuţi Hm.",
					"leavesAt": "06:56",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Dărmăneşti",
					"leavesAt": "07:05",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "07:17",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "07:29",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1793",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "19:30",
					"arrivesAt": "20:30",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "20:32",
					"arrivesAt": "20:51",
					"waitsAtSource": 120,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "20:52",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "21:16",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6315",
			"segments": [
				{
					"from": "Tecuci",
					"to": "Tecuci Nord hc.(600)",
					"leavesAt": "18:53",
					"arrivesAt": "18:56",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Tecuci Nord hc.(600)",
					"to": "Frunzeasca Hm.",
					"leavesAt": "18:57",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Frunzeasca Hm.",
					"to": "Rateş Munteni h.",
					"leavesAt": "19:06",
					"arrivesAt": "19:11",
					"waitsAtSource": 240,
					"distance": 3200
				},
				{
					"from": "Rateş Munteni h.",
					"to": "Berheci Hm.",
					"leavesAt": "19:12",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Berheci Hm.",
					"to": "Nichişeni",
					"leavesAt": "19:19",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Nichişeni",
					"to": "Ghidigeni Hm.",
					"leavesAt": "19:30",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ghidigeni Hm.",
					"to": "Tutova",
					"leavesAt": "19:36",
					"arrivesAt": "19:48",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Tutova",
					"to": "Dragalina h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Dragalina h.",
					"to": "Bârlad",
					"leavesAt": "19:57",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Bârlad",
					"to": "Zorleni",
					"leavesAt": "20:08",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Zorleni",
					"to": "Banca Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:25",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Banca Hm.",
					"to": "Dodeşti hc.",
					"leavesAt": "20:26",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dodeşti hc.",
					"to": "Roşieşti hc.",
					"leavesAt": "20:32",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Roşieşti hc.",
					"to": "Crasna",
					"leavesAt": "20:39",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Crasna",
					"to": "Bulboaca h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Bulboaca h.",
					"to": "Munteni Hm.",
					"leavesAt": "20:57",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Munteni Hm.",
					"to": "Vaslui",
					"leavesAt": "21:04",
					"arrivesAt": "21:10",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vaslui",
					"to": "Bălteni Hm.",
					"leavesAt": "21:11",
					"arrivesAt": "21:21",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Bălteni Hm.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "21:22",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bârzeşti h.",
					"leavesAt": "21:28",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bârzeşti h.",
					"to": "Buhăieşti",
					"leavesAt": "21:33",
					"arrivesAt": "21:40",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhăieşti",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "21:41",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Rebricea Hm.",
					"leavesAt": "21:47",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebricea Hm.",
					"to": "Scânteia Hm.",
					"leavesAt": "21:54",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Scânteia Hm.",
					"to": "Grajduri",
					"leavesAt": "22:01",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Grajduri",
					"to": "Bârnova Hm.",
					"leavesAt": "22:11",
					"arrivesAt": "22:19",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "22:20",
					"arrivesAt": "22:26",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Ciurea Hm.",
					"leavesAt": "22:27",
					"arrivesAt": "22:33",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ciurea Hm.",
					"to": "Nicolina",
					"leavesAt": "22:34",
					"arrivesAt": "22:40",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "22:41",
					"arrivesAt": "22:48",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9577",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Tibiscu h.",
					"leavesAt": "19:20",
					"arrivesAt": "19:23",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Tibiscu h.",
					"to": "Zăgujeni Hm.",
					"leavesAt": "19:24",
					"arrivesAt": "19:27",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Căvăran",
					"leavesAt": "19:28",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Căvăran",
					"to": "Sacu h.",
					"leavesAt": "19:39",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Sacu h.",
					"to": "Jena Hm.",
					"leavesAt": "19:43",
					"arrivesAt": "19:46",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Jena Hm.",
					"to": "Găvojdia",
					"leavesAt": "19:47",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Găvojdia",
					"to": "Tapia Hm.",
					"leavesAt": "19:58",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tapia Hm.",
					"to": "Lugoj",
					"leavesAt": "20:03",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lugoj",
					"to": "Jabăr Hm.",
					"leavesAt": "20:15",
					"arrivesAt": "20:21",
					"waitsAtSource": 360,
					"distance": 7600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "20:22",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Belinţ Hm.",
					"to": "Chizătău Hm.",
					"leavesAt": "20:28",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Chizătău Hm.",
					"to": "Topolovăţ",
					"leavesAt": "20:37",
					"arrivesAt": "20:43",
					"waitsAtSource": 300,
					"distance": 7200
				},
				{
					"from": "Topolovăţ",
					"to": "Şuştra h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:52",
					"waitsAtSource": 360,
					"distance": 3700
				},
				{
					"from": "Şuştra h.",
					"to": "Recaş",
					"leavesAt": "20:53",
					"arrivesAt": "20:59",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Recaş",
					"to": "Izvin h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Izvin h.",
					"to": "Remetea Mare",
					"leavesAt": "21:04",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Remetea Mare",
					"to": "Timişoara Est",
					"leavesAt": "21:13",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "21:28",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "401",
			"segments": [
				{
					"from": "Ungheni",
					"to": "Ungheni Prut Fr.",
					"leavesAt": "20:45",
					"arrivesAt": "20:47",
					"waitsAtSource": 0,
					"distance": 800
				},
				{
					"from": "Ungheni Prut Fr.",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "20:48",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Ungheni Prut Hm.",
					"to": "Nicolina",
					"leavesAt": "21:44",
					"arrivesAt": "22:12",
					"waitsAtSource": 3240,
					"distance": 19000
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "22:14",
					"arrivesAt": "22:21",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Iaşi",
					"to": "Paşcani Triaj",
					"leavesAt": "22:43",
					"arrivesAt": "23:51",
					"waitsAtSource": 1320,
					"distance": 76200
				},
				{
					"from": "Paşcani Triaj",
					"to": "Roman",
					"leavesAt": "23:53",
					"arrivesAt": "00:24",
					"waitsAtSource": 120,
					"distance": 37900
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "00:25",
					"arrivesAt": "01:02",
					"waitsAtSource": 60,
					"distance": 43800
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "01:04",
					"arrivesAt": "01:50",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "01:51",
					"arrivesAt": "02:18",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "02:19",
					"arrivesAt": "02:44",
					"waitsAtSource": 60,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "02:46",
					"arrivesAt": "03:23",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "03:24",
					"arrivesAt": "03:55",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Ploieşti Sud",
					"leavesAt": "04:03",
					"arrivesAt": "05:09",
					"waitsAtSource": 480,
					"distance": 68600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "05:11",
					"arrivesAt": "06:07",
					"waitsAtSource": 120,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8154",
			"segments": [
				{
					"from": "Slobozia Veche",
					"to": "Perieţi h.",
					"leavesAt": "19:10",
					"arrivesAt": "19:18",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Perieţi h.",
					"to": "Fundata h.",
					"leavesAt": "19:19",
					"arrivesAt": "19:24",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Fundata h.",
					"to": "Andrăşeşti Hm.",
					"leavesAt": "19:25",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrăşeşti Hm.",
					"to": "Ciochina hc.",
					"leavesAt": "19:32",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciochina hc.",
					"to": "Căzăneşti",
					"leavesAt": "19:40",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Căzăneşti",
					"to": "Munteni Buzău h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Munteni Buzău h.",
					"to": "Sărăţeni Ialomiţa h.",
					"leavesAt": "19:55",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Sărăţeni Ialomiţa h.",
					"to": "Sărăţuica Hm.",
					"leavesAt": "20:01",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sărăţuica Hm.",
					"to": "Km. 74+600 h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Km. 74+600 h.",
					"to": "Malu h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Malu h.",
					"to": "Broşteni Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Broşteni Hm.",
					"to": "Alexeni h.",
					"leavesAt": "20:24",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Alexeni h.",
					"to": "Urziceni",
					"leavesAt": "20:30",
					"arrivesAt": "20:39",
					"waitsAtSource": 30,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9410",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Şopârliţa hc.",
					"leavesAt": "17:45",
					"arrivesAt": "17:56",
					"waitsAtSource": 0,
					"distance": 11100
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Vlăduleni",
					"leavesAt": "17:57",
					"arrivesAt": "18:03",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vlăduleni",
					"to": "Fălcoiu h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Fălcoiu h.",
					"to": "Romula Hm.",
					"leavesAt": "18:09",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Romula Hm.",
					"to": "Caracal",
					"leavesAt": "18:31",
					"arrivesAt": "18:43",
					"waitsAtSource": 540,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 351
				},
				{
					"from": "20180409",
					"to": "20180526",
					"daysOfWeek": 351
				},
				{
					"from": "20180528",
					"to": "20181208",
					"daysOfWeek": 351
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 351
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9066",
			"segments": [
				{
					"from": "Corabia",
					"to": "Vişina Veche hc.",
					"leavesAt": "19:30",
					"arrivesAt": "19:44",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Vişina Veche hc.",
					"to": "Vişina h.",
					"leavesAt": "19:45",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vişina h.",
					"to": "Studina hc.",
					"leavesAt": "19:49",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Studina hc.",
					"to": "Studiniţa h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:02",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Studiniţa h.",
					"to": "Frăsinet hc.",
					"leavesAt": "20:03",
					"arrivesAt": "20:07",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Frăsinet hc.",
					"to": "Deveselu h.",
					"leavesAt": "20:08",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Deveselu h.",
					"to": "Grupa Tehnică Caracal Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Grupa Tehnică Caracal Hm.",
					"to": "Canton 239+700 h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Canton 239+700 h.",
					"to": "Caracal",
					"leavesAt": "20:27",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 1400
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3546",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "12:00",
					"arrivesAt": "12:07",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Vânători",
					"leavesAt": "12:08",
					"arrivesAt": "12:15",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Vânători",
					"to": "Săcuienii Noi h.",
					"leavesAt": "12:16",
					"arrivesAt": "12:22",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Săcuienii Noi h.",
					"to": "Sântămaria h.",
					"leavesAt": "12:23",
					"arrivesAt": "12:28",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Sântămaria h.",
					"to": "Cristur Hm.",
					"leavesAt": "12:29",
					"arrivesAt": "12:33",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Cristur Hm.",
					"to": "Beteşti h.",
					"leavesAt": "12:40",
					"arrivesAt": "12:43",
					"waitsAtSource": 420,
					"distance": 1300
				},
				{
					"from": "Beteşti h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "12:44",
					"arrivesAt": "12:52",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "12:53",
					"arrivesAt": "12:58",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Lutiţa h.",
					"leavesAt": "12:59",
					"arrivesAt": "13:04",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Lutiţa h.",
					"to": "Dobeni h.",
					"leavesAt": "13:05",
					"arrivesAt": "13:10",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Feliceni h.",
					"leavesAt": "13:11",
					"arrivesAt": "13:15",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Feliceni h.",
					"to": "Odorhei Sud hc.",
					"leavesAt": "13:16",
					"arrivesAt": "13:24",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Odorhei",
					"leavesAt": "13:26",
					"arrivesAt": "13:30",
					"waitsAtSource": 120,
					"distance": 1200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8651",
			"segments": [
				{
					"from": "Medgidia",
					"to": "Nicolae Bălcescu",
					"leavesAt": "05:56",
					"arrivesAt": "06:14",
					"waitsAtSource": 0,
					"distance": 19100
				},
				{
					"from": "Nicolae Bălcescu",
					"to": "Ram. M.K.P. Aj. M.",
					"leavesAt": "06:15",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ram. M.K.P. Aj. M.",
					"to": "Târguşor Dobrogea Hm.",
					"leavesAt": "06:22",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Târguşor Dobrogea Hm.",
					"to": "Cogealac",
					"leavesAt": "06:32",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Cogealac",
					"to": "Mihai Viteazu Hm.",
					"leavesAt": "06:53",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 17400
				},
				{
					"from": "Mihai Viteazu Hm.",
					"to": "Baia Dobrogea",
					"leavesAt": "07:12",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Baia Dobrogea",
					"to": "Ceamurlia de Jos h.",
					"leavesAt": "07:24",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ceamurlia de Jos h.",
					"to": "Babadag",
					"leavesAt": "07:31",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Babadag",
					"to": "Zebil h.",
					"leavesAt": "07:49",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Zebil h.",
					"to": "Mihail Kogălniceanu h.",
					"leavesAt": "08:06",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Mihail Kogălniceanu h.",
					"to": "Cataloi Hm.",
					"leavesAt": "08:21",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Cataloi Hm.",
					"to": "Tulcea Mărfuri",
					"leavesAt": "08:36",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Tulcea Mărfuri",
					"to": "Tulcea Oraş",
					"leavesAt": "08:50",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2048",
			"segments": [
				{
					"from": "Arad",
					"to": "Glogovăţ",
					"leavesAt": "18:45",
					"arrivesAt": "18:53",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Glogovăţ",
					"to": "Ghioroc",
					"leavesAt": "18:54",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Ghioroc",
					"to": "Păuliş h.",
					"leavesAt": "19:09",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Păuliş h.",
					"to": "Păuliş Hm.",
					"leavesAt": "19:15",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş Hm.",
					"to": "Radna",
					"leavesAt": "19:21",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Radna",
					"to": "Milova",
					"leavesAt": "19:34",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Milova",
					"to": "Corfeni h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Corfeni h.",
					"to": "Conop Hm.",
					"leavesAt": "19:51",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Conop Hm.",
					"to": "Bârzava",
					"leavesAt": "19:58",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bârzava",
					"to": "Căpruţa h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Căpruţa h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "20:15",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "20:21",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Vărădia Hm.",
					"leavesAt": "20:27",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vărădia Hm.",
					"to": "Vărădia h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vărădia h.",
					"to": "Săvârşin",
					"leavesAt": "20:39",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Săvârşin",
					"to": "Toc h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:25",
					"waitsAtSource": 1800,
					"distance": 7400
				},
				{
					"from": "Toc h.",
					"to": "Ilteu",
					"leavesAt": "21:26",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ilteu",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "21:32",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Zam",
					"leavesAt": "21:38",
					"arrivesAt": "21:44",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zam",
					"to": "Burjuc h.",
					"leavesAt": "21:45",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Burjuc h.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "21:56",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Gurasada Hm.",
					"leavesAt": "22:05",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Gurasada Hm.",
					"to": "Ilia",
					"leavesAt": "22:13",
					"arrivesAt": "22:19",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "22:20",
					"arrivesAt": "22:25",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "22:26",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "22:33",
					"arrivesAt": "22:37",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia h.",
					"leavesAt": "22:38",
					"arrivesAt": "22:41",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Mintia",
					"leavesAt": "22:42",
					"arrivesAt": "22:46",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "22:47",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "22:58",
					"arrivesAt": "23:05",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "23:06",
					"arrivesAt": "23:12",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9102",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "03:47",
					"arrivesAt": "03:54",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "03:55",
					"arrivesAt": "04:00",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "04:01",
					"arrivesAt": "04:05",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "04:06",
					"arrivesAt": "04:09",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "04:10",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Podu Rizii h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:19",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Podu Rizii h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "04:20",
					"arrivesAt": "04:24",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "04:25",
					"arrivesAt": "04:31",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "04:33",
					"arrivesAt": "04:38",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "04:39",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "04:43",
					"arrivesAt": "04:49",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "04:50",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "04:57",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "05:05",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "05:13",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "05:21",
					"arrivesAt": "05:26",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "05:27",
					"arrivesAt": "05:37",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8800",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "05:00",
					"arrivesAt": "05:07",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "05:08",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "05:14",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "05:28",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:48",
					"waitsAtSource": 480,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "05:49",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "05:59",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Agigea Nord",
					"leavesAt": "06:17",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Nord",
					"to": "Constanţa",
					"leavesAt": "06:25",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4105",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Viişoara h.",
					"leavesAt": "15:31",
					"arrivesAt": "15:37",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Viişoara h.",
					"to": "Sărata h.",
					"leavesAt": "15:38",
					"arrivesAt": "15:41",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "15:42",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "15:48",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "15:53",
					"arrivesAt": "15:58",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Sfântu h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Sfântu h.",
					"to": "Caila hc.",
					"leavesAt": "16:05",
					"arrivesAt": "16:08",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Caila hc.",
					"to": "Şintereag Hm.",
					"leavesAt": "16:09",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Şintereag Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "16:14",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Beclean pe Someş",
					"to": "Coldău Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Coldău Hm.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "16:39",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Dej Triaj",
					"leavesAt": "16:48",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "16:59",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Buneşti h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:19",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Buneşti h.",
					"to": "Gherla",
					"leavesAt": "17:20",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "17:29",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "17:36",
					"arrivesAt": "17:41",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "17:42",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "17:51",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "17:52",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "17:56",
					"arrivesAt": "18:01",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida h.",
					"leavesAt": "18:02",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Apahida h.",
					"to": "Apahida",
					"leavesAt": "18:09",
					"arrivesAt": "18:14",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "18:15",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "18:19",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "18:27",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "18:33",
					"arrivesAt": "18:38",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4110",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "14:30",
					"arrivesAt": "14:40",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "14:41",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "14:46",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Apahida h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Apahida h.",
					"to": "Jucu Hm.",
					"leavesAt": "14:58",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Jucu Hm.",
					"to": "Răscruci h.",
					"leavesAt": "15:05",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Răscruci h.",
					"to": "Bonţida Hm.",
					"leavesAt": "15:12",
					"arrivesAt": "15:17",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bonţida Hm.",
					"to": "Fundătura h.",
					"leavesAt": "15:18",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Fundătura h.",
					"to": "Iclod Hm.",
					"leavesAt": "15:25",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Iclod Hm.",
					"to": "Livada Someş h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Livada Someş h.",
					"to": "Gherla",
					"leavesAt": "15:37",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Gherla",
					"to": "Buneşti h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Buneşti h.",
					"to": "Nima h.",
					"leavesAt": "15:56",
					"arrivesAt": "15:59",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Nima h.",
					"to": "Dej Călători",
					"leavesAt": "16:00",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "16:12",
					"arrivesAt": "16:19",
					"waitsAtSource": 180,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Reteag Hm.",
					"leavesAt": "16:20",
					"arrivesAt": "16:30",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Reteag Hm.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "16:38",
					"arrivesAt": "16:42",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "16:43",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Beclean pe Someş",
					"to": "Cociu h.",
					"leavesAt": "16:56",
					"arrivesAt": "17:04",
					"waitsAtSource": 180,
					"distance": 6700
				},
				{
					"from": "Cociu h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:08",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Nimigea h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Nimigea h.",
					"to": "Nimigea Hm.",
					"leavesAt": "17:14",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Nimigea Hm.",
					"to": "Mititei h.",
					"leavesAt": "17:24",
					"arrivesAt": "17:30",
					"waitsAtSource": 360,
					"distance": 5100
				},
				{
					"from": "Mititei h.",
					"to": "Salva",
					"leavesAt": "17:31",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Salva",
					"to": "Coşbuc Hm.",
					"leavesAt": "17:49",
					"arrivesAt": "18:03",
					"waitsAtSource": 840,
					"distance": 9500
				},
				{
					"from": "Coşbuc Hm.",
					"to": "Bichigiu h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Bichigiu h.",
					"to": "Telciu Hm.",
					"leavesAt": "18:09",
					"arrivesAt": "18:14",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Telciu Hm.",
					"to": "Fiezel h.",
					"leavesAt": "18:15",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fiezel h.",
					"to": "Fiad Hm.",
					"leavesAt": "18:23",
					"arrivesAt": "18:32",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Fiad Hm.",
					"to": "Romuli h.",
					"leavesAt": "18:44",
					"arrivesAt": "18:53",
					"waitsAtSource": 720,
					"distance": 6700
				},
				{
					"from": "Romuli h.",
					"to": "Dealu Ştefăniţei",
					"leavesAt": "18:54",
					"arrivesAt": "19:03",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Dealu Ştefăniţei",
					"to": "Săcel Hm.",
					"leavesAt": "19:04",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Săcel Hm.",
					"to": "Iza P.M.",
					"leavesAt": "19:16",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Iza P.M.",
					"to": "Vişeu de Jos",
					"leavesAt": "19:27",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Vişeu de Jos",
					"to": "Bocicoel h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:47",
					"waitsAtSource": 240,
					"distance": 2700
				},
				{
					"from": "Bocicoel h.",
					"to": "Leordina h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Leordina h.",
					"to": "Leordina",
					"leavesAt": "19:57",
					"arrivesAt": "20:03",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Leordina",
					"to": "Petrova hc.",
					"leavesAt": "20:04",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Petrova hc.",
					"to": "Vişeu Bistra h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Valea Vişeului",
					"leavesAt": "20:24",
					"arrivesAt": "20:38",
					"waitsAtSource": 30,
					"distance": 8500
				},
				{
					"from": "Valea Vişeului",
					"to": "Lunca la Tisa h.",
					"leavesAt": "20:53",
					"arrivesAt": "21:09",
					"waitsAtSource": 900,
					"distance": 10700
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "21:10",
					"arrivesAt": "21:16",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Crăciuneşti h.",
					"leavesAt": "21:17",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Tisa h.",
					"leavesAt": "21:24",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Tisa h.",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "21:28",
					"arrivesAt": "21:35",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Sighetu Marmaţiei",
					"leavesAt": "21:36",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 1900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1729",
			"segments": [
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "07:15",
					"arrivesAt": "07:55",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "08:00",
					"arrivesAt": "08:25",
					"waitsAtSource": 300,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Gilort Hm.",
					"leavesAt": "08:26",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 12400
				},
				{
					"from": "Gilort Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "08:42",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turburea Hm.",
					"to": "Bibeşti Hm.",
					"leavesAt": "08:50",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "09:00",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Cărbuneşti",
					"to": "Târgu Jiu",
					"leavesAt": "09:21",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 23800
				},
				{
					"from": "Târgu Jiu",
					"to": "Valea Sadului Hm.",
					"leavesAt": "09:52",
					"arrivesAt": "10:12",
					"waitsAtSource": 180,
					"distance": 19600
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Lainici Hm.",
					"leavesAt": "10:17",
					"arrivesAt": "10:34",
					"waitsAtSource": 300,
					"distance": 11300
				},
				{
					"from": "Lainici Hm.",
					"to": "Petroşani",
					"leavesAt": "10:35",
					"arrivesAt": "11:07",
					"waitsAtSource": 60,
					"distance": 20400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 496
				},
				{
					"from": "18991230",
					"to": "20180806",
					"daysOfWeek": 496
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4332",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Carei",
					"leavesAt": "03:30",
					"arrivesAt": "03:59",
					"waitsAtSource": 0,
					"distance": 36000
				},
				{
					"from": "Carei",
					"to": "Sanislău Hm.",
					"leavesAt": "04:00",
					"arrivesAt": "04:10",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Sanislău Hm.",
					"to": "Resighea h.",
					"leavesAt": "04:11",
					"arrivesAt": "04:16",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Resighea h.",
					"to": "Curtuiuşeni h.",
					"leavesAt": "04:17",
					"arrivesAt": "04:23",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Valea lui Mihai",
					"leavesAt": "04:24",
					"arrivesAt": "04:31",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Valea lui Mihai",
					"to": "Simion h.",
					"leavesAt": "04:32",
					"arrivesAt": "04:39",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Simion h.",
					"to": "Şilindru Hm.",
					"leavesAt": "04:40",
					"arrivesAt": "04:46",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Şilindru Hm.",
					"to": "Săcuieni Bihor",
					"leavesAt": "04:47",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Cadia h.",
					"leavesAt": "04:57",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cadia h.",
					"to": "Diosig Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:11",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Diosig Hm.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "05:12",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Tămăşeu h.",
					"leavesAt": "05:19",
					"arrivesAt": "05:26",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tămăşeu h.",
					"to": "Biharia Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:34",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Biharia Hm.",
					"to": "Episcopia Bihor",
					"leavesAt": "05:35",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "05:46",
					"arrivesAt": "05:55",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9342",
			"segments": [
				{
					"from": "Giurgiu",
					"to": "Giurgiu Nord",
					"leavesAt": "07:31",
					"arrivesAt": "07:36",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Giurgiu Nord",
					"to": "Cetatea h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cetatea h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "07:41",
					"arrivesAt": "07:44",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Onceşti h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Onceşti h.",
					"to": "Stăneşti Hm.",
					"leavesAt": "07:49",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Chiriacu Hm.",
					"leavesAt": "07:55",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Toporu",
					"leavesAt": "08:03",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Toporu",
					"to": "Răsuceni h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Răsuceni h.",
					"to": "Vlaşca Hm.",
					"leavesAt": "08:17",
					"arrivesAt": "08:24",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "08:25",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Târnavele Hm.",
					"to": "Răduleşti Hm.",
					"leavesAt": "08:34",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Videle",
					"leavesAt": "08:46",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9062",
			"segments": [
				{
					"from": "Corabia",
					"to": "Vişina Veche hc.",
					"leavesAt": "05:55",
					"arrivesAt": "06:10",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Vişina Veche hc.",
					"to": "Vişina h.",
					"leavesAt": "06:11",
					"arrivesAt": "06:14",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vişina h.",
					"to": "Studina hc.",
					"leavesAt": "06:15",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Studina hc.",
					"to": "Studiniţa h.",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Studiniţa h.",
					"to": "Frăsinet hc.",
					"leavesAt": "06:30",
					"arrivesAt": "06:34",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Frăsinet hc.",
					"to": "Deveselu h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Deveselu h.",
					"to": "Grupa Tehnică Caracal Hm.",
					"leavesAt": "06:44",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Grupa Tehnică Caracal Hm.",
					"to": "Canton 239+700 h.",
					"leavesAt": "06:50",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Canton 239+700 h.",
					"to": "Caracal",
					"leavesAt": "06:54",
					"arrivesAt": "06:57",
					"waitsAtSource": 30,
					"distance": 1400
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20180527",
					"daysOfWeek": 319
				},
				{
					"from": "20180529",
					"to": "20181130",
					"daysOfWeek": 319
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9481",
			"segments": [
				{
					"from": "Slatina",
					"to": "Slătioara Hm.",
					"leavesAt": "13:04",
					"arrivesAt": "13:17",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "13:21",
					"arrivesAt": "13:25",
					"waitsAtSource": 240,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "13:26",
					"arrivesAt": "13:33",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4041",
			"segments": [
				{
					"from": "Jibou",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "03:55",
					"arrivesAt": "04:05",
					"waitsAtSource": 0,
					"distance": 9300
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Inău h.",
					"leavesAt": "04:06",
					"arrivesAt": "04:09",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Inău h.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "04:10",
					"arrivesAt": "04:13",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Benesat Hm.",
					"leavesAt": "04:14",
					"arrivesAt": "04:17",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Benesat Hm.",
					"to": "Ţicău h.",
					"leavesAt": "04:18",
					"arrivesAt": "04:24",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ţicău h.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "04:25",
					"arrivesAt": "04:28",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "04:29",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Fersig h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Fersig h.",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "04:43",
					"arrivesAt": "04:48",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Baia Mare",
					"leavesAt": "04:49",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1922",
			"segments": [
				{
					"from": "Arad",
					"to": "Radna",
					"leavesAt": "18:40",
					"arrivesAt": "19:20",
					"waitsAtSource": 0,
					"distance": 34500
				},
				{
					"from": "Radna",
					"to": "Săvârşin",
					"leavesAt": "19:21",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 49700
				},
				{
					"from": "Săvârşin",
					"to": "Ilia",
					"leavesAt": "20:19",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Ilia",
					"to": "Deva",
					"leavesAt": "21:08",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 23600
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "21:36",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Călan Hm.",
					"leavesAt": "21:50",
					"arrivesAt": "22:06",
					"waitsAtSource": 120,
					"distance": 14600
				},
				{
					"from": "Călan Hm.",
					"to": "Subcetate",
					"leavesAt": "22:07",
					"arrivesAt": "22:22",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Subcetate",
					"to": "Petroşani",
					"leavesAt": "22:23",
					"arrivesAt": "23:32",
					"waitsAtSource": 60,
					"distance": 49800
				},
				{
					"from": "Petroşani",
					"to": "Valea Sadului Hm.",
					"leavesAt": "23:37",
					"arrivesAt": "00:22",
					"waitsAtSource": 300,
					"distance": 31700
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "00:23",
					"arrivesAt": "00:44",
					"waitsAtSource": 60,
					"distance": 19600
				},
				{
					"from": "Târgu Jiu",
					"to": "Cărbuneşti",
					"leavesAt": "00:46",
					"arrivesAt": "01:14",
					"waitsAtSource": 120,
					"distance": 23800
				},
				{
					"from": "Cărbuneşti",
					"to": "Filiaşi",
					"leavesAt": "01:15",
					"arrivesAt": "01:59",
					"waitsAtSource": 60,
					"distance": 46500
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "02:00",
					"arrivesAt": "02:25",
					"waitsAtSource": 60,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "02:35",
					"arrivesAt": "03:14",
					"waitsAtSource": 600,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "03:16",
					"arrivesAt": "03:31",
					"waitsAtSource": 120,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Roşiori Nord",
					"leavesAt": "03:32",
					"arrivesAt": "04:03",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "04:05",
					"arrivesAt": "04:54",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Chiajna",
					"leavesAt": "04:56",
					"arrivesAt": "05:38",
					"waitsAtSource": 120,
					"distance": 41900
				},
				{
					"from": "Chiajna",
					"to": "Bucureşti Nord",
					"leavesAt": "05:42",
					"arrivesAt": "05:55",
					"waitsAtSource": 240,
					"distance": 9000
				},
				{
					"from": "Bucureşti Nord",
					"to": "Lehliu",
					"leavesAt": "06:20",
					"arrivesAt": "07:01",
					"waitsAtSource": 1500,
					"distance": 69600
				},
				{
					"from": "Lehliu",
					"to": "Ciulniţa",
					"leavesAt": "07:02",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 39300
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "07:23",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "07:47",
					"arrivesAt": "08:07",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "08:08",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "08:26",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 36000
				},
				{
					"from": "Constanţa",
					"to": "Eforie Nord",
					"leavesAt": "09:30",
					"arrivesAt": "09:53",
					"waitsAtSource": 1800,
					"distance": 14000
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "10:01",
					"arrivesAt": "10:08",
					"waitsAtSource": 480,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Costineşti",
					"leavesAt": "10:10",
					"arrivesAt": "10:26",
					"waitsAtSource": 120,
					"distance": 8600
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "10:28",
					"arrivesAt": "10:32",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "10:34",
					"arrivesAt": "10:47",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "10:49",
					"arrivesAt": "10:59",
					"waitsAtSource": 120,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180426",
					"to": "20180430",
					"daysOfWeek": 383
				},
				{
					"from": "20180524",
					"to": "20180528",
					"daysOfWeek": 383
				},
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4333",
			"segments": [
				{
					"from": "Oradea",
					"to": "Episcopia Bihor",
					"leavesAt": "07:31",
					"arrivesAt": "07:39",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Episcopia Bihor",
					"to": "Biharia Hm.",
					"leavesAt": "07:40",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Biharia Hm.",
					"to": "Tămăşeu h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Tămăşeu h.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Diosig Hm.",
					"leavesAt": "08:05",
					"arrivesAt": "08:13",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Diosig Hm.",
					"to": "Cadia h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cadia h.",
					"to": "Săcuieni Bihor",
					"leavesAt": "08:21",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Şilindru Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Şilindru Hm.",
					"to": "Simion h.",
					"leavesAt": "08:40",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Simion h.",
					"to": "Valea lui Mihai",
					"leavesAt": "08:47",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8376",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "20:08",
					"arrivesAt": "20:14",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "20:15",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "20:20",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "20:30",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:54",
					"waitsAtSource": 900,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "20:55",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "21:02",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "21:15",
					"arrivesAt": "21:23",
					"waitsAtSource": 480,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "21:24",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20180524",
					"to": "20180524",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4312",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Buşag Hm.",
					"leavesAt": "07:45",
					"arrivesAt": "08:03",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Buşag Hm.",
					"to": "Cicârlău h.",
					"leavesAt": "08:04",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cicârlău h.",
					"to": "Ilba h.",
					"leavesAt": "08:10",
					"arrivesAt": "08:18",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Ilba h.",
					"to": "Săbişa h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:23",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săbişa h.",
					"to": "Seini",
					"leavesAt": "08:24",
					"arrivesAt": "08:30",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Seini",
					"to": "Apa Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:53",
					"waitsAtSource": 600,
					"distance": 8500
				},
				{
					"from": "Apa Hm.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "08:54",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Odoreu h.",
					"leavesAt": "09:05",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Odoreu h.",
					"to": "Botiz Hm.",
					"leavesAt": "09:15",
					"arrivesAt": "09:21",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Botiz Hm.",
					"to": "Satu Mare",
					"leavesAt": "09:22",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2711",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Dep Petroşani h.",
					"leavesAt": "15:18",
					"arrivesAt": "15:21",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Petroşani Triaj h.",
					"leavesAt": "15:22",
					"arrivesAt": "15:24",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Petroşani Triaj h.",
					"to": "Peştera Bolii h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Băniţa",
					"leavesAt": "15:30",
					"arrivesAt": "15:38",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Băniţa",
					"to": "Merişor Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Merişor Hm.",
					"to": "Crivadia Hm.",
					"leavesAt": "15:51",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Crivadia Hm.",
					"to": "Baru Mare h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Baru Mare h.",
					"to": "Baru Mare",
					"leavesAt": "16:08",
					"arrivesAt": "16:14",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Baru Mare",
					"to": "Livadia h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Livadia h.",
					"to": "Ponor h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ponor h.",
					"to": "Pui",
					"leavesAt": "16:22",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Pui",
					"to": "Ruşor h.",
					"leavesAt": "16:28",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Ruşor h.",
					"to": "Băeşti Hm.",
					"leavesAt": "16:33",
					"arrivesAt": "16:36",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Ciopea h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:42",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ciopea h.",
					"to": "Subcetate",
					"leavesAt": "16:43",
					"arrivesAt": "16:47",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Subcetate",
					"to": "Covragiu h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Covragiu h.",
					"to": "Plopi h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Plopi h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "16:55",
					"arrivesAt": "16:57",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Măceu h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măceu h.",
					"to": "Ruşi h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ruşi h.",
					"to": "Călan Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Călan Hm.",
					"to": "Călan Băi",
					"leavesAt": "17:16",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Băi",
					"to": "Batiz h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Batiz h.",
					"to": "Băcia Hm.",
					"leavesAt": "17:24",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Băcia Hm.",
					"to": "Băcia h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Băcia h.",
					"to": "Simeria Triaj",
					"leavesAt": "17:30",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Simeria Triaj",
					"to": "Simeria",
					"leavesAt": "17:34",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20180120",
					"to": "20180121",
					"daysOfWeek": 383
				},
				{
					"from": "20180124",
					"to": "20180124",
					"daysOfWeek": 383
				},
				{
					"from": "20180127",
					"to": "20180128",
					"daysOfWeek": 383
				},
				{
					"from": "20180203",
					"to": "20180211",
					"daysOfWeek": 383
				},
				{
					"from": "20180217",
					"to": "20180218",
					"daysOfWeek": 383
				},
				{
					"from": "20180224",
					"to": "20180225",
					"daysOfWeek": 383
				},
				{
					"from": "20180303",
					"to": "20180304",
					"daysOfWeek": 383
				},
				{
					"from": "20180310",
					"to": "20180311",
					"daysOfWeek": 383
				},
				{
					"from": "20180317",
					"to": "20180318",
					"daysOfWeek": 383
				},
				{
					"from": "20180324",
					"to": "20180325",
					"daysOfWeek": 383
				},
				{
					"from": "20180331",
					"to": "20180410",
					"daysOfWeek": 383
				},
				{
					"from": "20180414",
					"to": "20180415",
					"daysOfWeek": 383
				},
				{
					"from": "20180421",
					"to": "20180422",
					"daysOfWeek": 383
				},
				{
					"from": "20180428",
					"to": "20180429",
					"daysOfWeek": 383
				},
				{
					"from": "20180501",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180505",
					"to": "20180506",
					"daysOfWeek": 383
				},
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180526",
					"to": "20180528",
					"daysOfWeek": 383
				},
				{
					"from": "20180601",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180610",
					"daysOfWeek": 383
				},
				{
					"from": "20180616",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180922",
					"to": "20180923",
					"daysOfWeek": 383
				},
				{
					"from": "20180929",
					"to": "20180930",
					"daysOfWeek": 383
				},
				{
					"from": "20181006",
					"to": "20181007",
					"daysOfWeek": 383
				},
				{
					"from": "20181013",
					"to": "20181014",
					"daysOfWeek": 383
				},
				{
					"from": "20181020",
					"to": "20181021",
					"daysOfWeek": 383
				},
				{
					"from": "20181027",
					"to": "20181028",
					"daysOfWeek": 383
				},
				{
					"from": "20181103",
					"to": "20181104",
					"daysOfWeek": 383
				},
				{
					"from": "20181110",
					"to": "20181111",
					"daysOfWeek": 383
				},
				{
					"from": "20181117",
					"to": "20181118",
					"daysOfWeek": 383
				},
				{
					"from": "20181124",
					"to": "20181125",
					"daysOfWeek": 383
				},
				{
					"from": "20181130",
					"to": "20181202",
					"daysOfWeek": 383
				},
				{
					"from": "20181208",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 383
				},
				{
					"from": "20171216",
					"to": "20171217",
					"daysOfWeek": 383
				},
				{
					"from": "20171223",
					"to": "20180114",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1937",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "10:15",
					"arrivesAt": "10:39",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "10:40",
					"arrivesAt": "10:57",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "10:58",
					"arrivesAt": "11:17",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "11:19",
					"arrivesAt": "11:42",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "11:43",
					"arrivesAt": "12:39",
					"waitsAtSource": 60,
					"distance": 108900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "13:00",
					"arrivesAt": "13:38",
					"waitsAtSource": 1260,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Sinaia",
					"leavesAt": "13:40",
					"arrivesAt": "14:23",
					"waitsAtSource": 120,
					"distance": 62100
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "14:25",
					"arrivesAt": "14:33",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Predeal",
					"leavesAt": "14:34",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 11400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "14:49",
					"arrivesAt": "15:27",
					"waitsAtSource": 120,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2202",
			"segments": [
				{
					"from": "Curtici",
					"to": "Şofronea",
					"leavesAt": "05:42",
					"arrivesAt": "05:50",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Şofronea",
					"to": "Arad",
					"leavesAt": "05:51",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "74",
			"segments": [
				{
					"from": "Braşov",
					"to": "Codlea Hm.",
					"leavesAt": "05:32",
					"arrivesAt": "05:48",
					"waitsAtSource": 0,
					"distance": 13800
				},
				{
					"from": "Codlea Hm.",
					"to": "Brădet Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 25100
				},
				{
					"from": "Brădet Hm.",
					"to": "Făgăraş",
					"leavesAt": "06:22",
					"arrivesAt": "06:50",
					"waitsAtSource": 300,
					"distance": 26100
				},
				{
					"from": "Făgăraş",
					"to": "Sibiu",
					"leavesAt": "06:52",
					"arrivesAt": "08:10",
					"waitsAtSource": 120,
					"distance": 83900
				},
				{
					"from": "Sibiu",
					"to": "Sebeş Alba",
					"leavesAt": "08:15",
					"arrivesAt": "09:47",
					"waitsAtSource": 300,
					"distance": 73700
				},
				{
					"from": "Sebeş Alba",
					"to": "Vinţu de Jos",
					"leavesAt": "09:48",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vinţu de Jos",
					"to": "Simeria",
					"leavesAt": "09:59",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 43800
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "11:12",
					"arrivesAt": "11:22",
					"waitsAtSource": 780,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Ilia",
					"leavesAt": "11:23",
					"arrivesAt": "11:50",
					"waitsAtSource": 60,
					"distance": 23600
				},
				{
					"from": "Ilia",
					"to": "Săvârşin",
					"leavesAt": "11:51",
					"arrivesAt": "12:38",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Săvârşin",
					"to": "Radna",
					"leavesAt": "12:39",
					"arrivesAt": "13:40",
					"waitsAtSource": 60,
					"distance": 49700
				},
				{
					"from": "Radna",
					"to": "Arad",
					"leavesAt": "13:41",
					"arrivesAt": "14:18",
					"waitsAtSource": 60,
					"distance": 34500
				},
				{
					"from": "Arad",
					"to": "Curtici",
					"leavesAt": "14:20",
					"arrivesAt": "14:33",
					"waitsAtSource": 120,
					"distance": 17000
				},
				{
					"from": "Curtici",
					"to": "Lokoshaza",
					"leavesAt": "14:58",
					"arrivesAt": "15:08",
					"waitsAtSource": 1500,
					"distance": 11200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9112",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "12:00",
					"arrivesAt": "12:06",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "12:07",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "12:12",
					"arrivesAt": "12:16",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "12:17",
					"arrivesAt": "12:19",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "12:20",
					"arrivesAt": "12:23",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Podu Rizii h.",
					"leavesAt": "12:24",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Podu Rizii h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "12:28",
					"arrivesAt": "12:32",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "12:33",
					"arrivesAt": "12:38",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "12:40",
					"arrivesAt": "12:44",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "12:45",
					"arrivesAt": "12:48",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "12:49",
					"arrivesAt": "12:54",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "12:55",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "13:01",
					"arrivesAt": "13:07",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "13:08",
					"arrivesAt": "13:15",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "13:16",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "13:23",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "13:29",
					"arrivesAt": "13:38",
					"waitsAtSource": 60,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4324",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Buşag Hm.",
					"leavesAt": "20:20",
					"arrivesAt": "20:37",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Buşag Hm.",
					"to": "Cicârlău h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:43",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cicârlău h.",
					"to": "Ilba h.",
					"leavesAt": "20:44",
					"arrivesAt": "20:52",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Ilba h.",
					"to": "Săbişa h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:57",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săbişa h.",
					"to": "Seini",
					"leavesAt": "20:58",
					"arrivesAt": "21:04",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Seini",
					"to": "Apa Hm.",
					"leavesAt": "21:05",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Apa Hm.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "21:19",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Odoreu h.",
					"leavesAt": "21:40",
					"arrivesAt": "21:47",
					"waitsAtSource": 600,
					"distance": 10000
				},
				{
					"from": "Odoreu h.",
					"to": "Botiz Hm.",
					"leavesAt": "21:48",
					"arrivesAt": "21:53",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Botiz Hm.",
					"to": "Satu Mare",
					"leavesAt": "21:54",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "406",
			"segments": [
				{
					"from": "Braşov",
					"to": "Sfântu Gheorghe",
					"leavesAt": "19:00",
					"arrivesAt": "19:29",
					"waitsAtSource": 0,
					"distance": 32100
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "19:30",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 34400
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "20:03",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 28500
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "20:28",
					"arrivesAt": "20:36",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Izvoru Oltului",
					"leavesAt": "20:37",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Gheorgheni",
					"leavesAt": "20:54",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 30000
				},
				{
					"from": "Gheorgheni",
					"to": "Topliţa",
					"leavesAt": "21:23",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 34000
				},
				{
					"from": "Topliţa",
					"to": "Deda",
					"leavesAt": "21:56",
					"arrivesAt": "22:55",
					"waitsAtSource": 60,
					"distance": 43900
				},
				{
					"from": "Deda",
					"to": "Sărăţel Hm.",
					"leavesAt": "22:59",
					"arrivesAt": "23:53",
					"waitsAtSource": 240,
					"distance": 46800
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "23:55",
					"arrivesAt": "00:21",
					"waitsAtSource": 120,
					"distance": 24900
				},
				{
					"from": "Beclean pe Someş",
					"to": "Dej Călători",
					"leavesAt": "00:23",
					"arrivesAt": "00:58",
					"waitsAtSource": 120,
					"distance": 24600
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "01:02",
					"arrivesAt": "01:21",
					"waitsAtSource": 240,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Cluj Napoca",
					"leavesAt": "01:22",
					"arrivesAt": "02:14",
					"waitsAtSource": 60,
					"distance": 44900
				},
				{
					"from": "Cluj Napoca",
					"to": "Huedin",
					"leavesAt": "02:26",
					"arrivesAt": "03:19",
					"waitsAtSource": 720,
					"distance": 49400
				},
				{
					"from": "Huedin",
					"to": "Aleşd",
					"leavesAt": "03:20",
					"arrivesAt": "04:26",
					"waitsAtSource": 60,
					"distance": 68400
				},
				{
					"from": "Aleşd",
					"to": "Oradea",
					"leavesAt": "04:27",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 34300
				},
				{
					"from": "Oradea",
					"to": "Episcopia Bihor",
					"leavesAt": "05:03",
					"arrivesAt": "05:11",
					"waitsAtSource": 360,
					"distance": 5700
				},
				{
					"from": "Episcopia Bihor",
					"to": "Biharkeresztes",
					"leavesAt": "05:33",
					"arrivesAt": "05:48",
					"waitsAtSource": 1320,
					"distance": 12500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8346",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "17:42",
					"arrivesAt": "17:49",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "17:50",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:03",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "18:04",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "18:09",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "18:15",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "18:28",
					"arrivesAt": "18:31",
					"waitsAtSource": 480,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "18:32",
					"arrivesAt": "18:39",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "18:40",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "18:50",
					"arrivesAt": "18:56",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "18:57",
					"arrivesAt": "19:05",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Dunărea Hm.",
					"leavesAt": "19:06",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Dunărea Hm.",
					"to": "Ovidiu",
					"leavesAt": "19:15",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ovidiu",
					"to": "Ramificaţia Borcea",
					"leavesAt": "19:22",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "19:27",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Feteşti",
					"to": "Bărăganu Hm.",
					"leavesAt": "19:34",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:49",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Jegălia",
					"leavesAt": "19:50",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Jegălia",
					"to": "Recolta hc.",
					"leavesAt": "20:04",
					"arrivesAt": "20:07",
					"waitsAtSource": 480,
					"distance": 3800
				},
				{
					"from": "Recolta hc.",
					"to": "Perişoru Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Perişoru Hm.",
					"to": "Ogoarele h.",
					"leavesAt": "20:13",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ogoarele h.",
					"to": "Ciulniţa",
					"leavesAt": "20:18",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ciulniţa",
					"to": "Ştefan Vodă h.",
					"leavesAt": "20:30",
					"arrivesAt": "20:43",
					"waitsAtSource": 120,
					"distance": 12600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "20:44",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Km. 25+700 h.",
					"leavesAt": "20:51",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Km. 25+700 h.",
					"to": "Călăraşi Sud",
					"leavesAt": "20:58",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 1300
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180916",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9471",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Bradu de Sus",
					"leavesAt": "07:30",
					"arrivesAt": "07:35",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bradu de Sus",
					"to": "Pârvu Hm.",
					"leavesAt": "07:36",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Pârvu Hm.",
					"to": "Pârvu h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Pârvu h.",
					"to": "Costeşti",
					"leavesAt": "07:49",
					"arrivesAt": "08:02",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Costeşti",
					"to": "Fâlfani Hm.",
					"leavesAt": "08:03",
					"arrivesAt": "08:11",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "08:12",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Stolnici Hm.",
					"to": "Hârseşti Hm.",
					"leavesAt": "08:21",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Corbu",
					"leavesAt": "08:27",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Corbu",
					"to": "Sineşti Hm.",
					"leavesAt": "08:34",
					"arrivesAt": "08:40",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Sineşti Hm.",
					"to": "Potcoava",
					"leavesAt": "08:41",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Potcoava",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "08:52",
					"arrivesAt": "09:00",
					"waitsAtSource": 240,
					"distance": 7600
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Recea Hm.",
					"leavesAt": "09:01",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Recea Hm.",
					"to": "Slatina",
					"leavesAt": "09:10",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Slatina",
					"to": "Milcov Hm.",
					"leavesAt": "09:20",
					"arrivesAt": "09:26",
					"waitsAtSource": 120,
					"distance": 5300
				},
				{
					"from": "Milcov Hm.",
					"to": "Slătioara Hm.",
					"leavesAt": "09:27",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "09:35",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "09:39",
					"arrivesAt": "09:45",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5055",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "17:20",
					"arrivesAt": "17:26",
					"waitsAtSource": 0,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "17:27",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Muru hc.",
					"leavesAt": "17:37",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:46",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "17:47",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "17:59",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "18:07",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "18:18",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "18:26",
					"arrivesAt": "18:31",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "18:32",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "18:38",
					"arrivesAt": "18:50",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "19:05",
					"arrivesAt": "19:16",
					"waitsAtSource": 900,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "19:17",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "19:28",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "19:42",
					"arrivesAt": "19:50",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "19:51",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "20:00",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "20:17",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "20:28",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "20:42",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 8000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2214",
			"segments": [
				{
					"from": "Curtici",
					"to": "Şofronea",
					"leavesAt": "19:04",
					"arrivesAt": "19:12",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Şofronea",
					"to": "Arad",
					"leavesAt": "19:13",
					"arrivesAt": "19:24",
					"waitsAtSource": 60,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8124",
			"segments": [
				{
					"from": "Slobozia Veche",
					"to": "Perieţi h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:59",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Perieţi h.",
					"to": "Fundata h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Fundata h.",
					"to": "Andrăşeşti Hm.",
					"leavesAt": "17:06",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Andrăşeşti Hm.",
					"to": "Ciochina hc.",
					"leavesAt": "17:14",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciochina hc.",
					"to": "Căzăneşti",
					"leavesAt": "17:24",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Căzăneşti",
					"to": "Munteni Buzău h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Munteni Buzău h.",
					"to": "Sărăţeni Ialomiţa h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Sărăţeni Ialomiţa h.",
					"to": "Sărăţuica Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:49",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Sărăţuica Hm.",
					"to": "Km. 74+600 h.",
					"leavesAt": "17:50",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Km. 74+600 h.",
					"to": "Malu h.",
					"leavesAt": "17:55",
					"arrivesAt": "17:59",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Malu h.",
					"to": "Broşteni Hm.",
					"leavesAt": "18:00",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Broşteni Hm.",
					"to": "Alexeni h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Alexeni h.",
					"to": "Urziceni",
					"leavesAt": "18:15",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "18:28",
					"arrivesAt": "18:32",
					"waitsAtSource": 240,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "18:33",
					"arrivesAt": "18:37",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "18:38",
					"arrivesAt": "18:43",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Moldoveni h.",
					"to": "Dridu Hm.",
					"leavesAt": "18:44",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Dridu Hm.",
					"to": "Fierbinţi",
					"leavesAt": "18:51",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Fierbinţi",
					"to": "Greci h.",
					"leavesAt": "18:58",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Greci h.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "19:05",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "19:12",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Baloteşti Hm.",
					"leavesAt": "19:19",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Baloteşti Hm.",
					"to": "P.O. Aeroport h.",
					"leavesAt": "19:26",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Odăile h.",
					"leavesAt": "19:30",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Odăile h.",
					"to": "Mogoşoaia",
					"leavesAt": "19:35",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Mogoşoaia",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "19:43",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "20:05",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4650",
			"segments": [
				{
					"from": "Sighetu Marmaţiei",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "07:20",
					"arrivesAt": "07:25",
					"waitsAtSource": 0,
					"distance": 1900
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Tisa h.",
					"leavesAt": "07:26",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tisa h.",
					"to": "Crăciuneşti h.",
					"leavesAt": "07:34",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:44",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Lunca la Tisa h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Valea Vişeului",
					"leavesAt": "07:51",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Valea Vişeului",
					"to": "Vişeu Bistra h.",
					"leavesAt": "08:26",
					"arrivesAt": "08:40",
					"waitsAtSource": 1020,
					"distance": 8500
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Petrova hc.",
					"leavesAt": "08:41",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Petrova hc.",
					"to": "Leordina",
					"leavesAt": "08:51",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Leordina",
					"to": "Leordina h.",
					"leavesAt": "09:03",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Leordina h.",
					"to": "Bocicoel h.",
					"leavesAt": "09:09",
					"arrivesAt": "09:17",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Bocicoel h.",
					"to": "Vişeu de Jos",
					"leavesAt": "09:18",
					"arrivesAt": "09:23",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9622",
			"segments": [
				{
					"from": "Buziaş",
					"to": "Căpăt h.",
					"leavesAt": "06:20",
					"arrivesAt": "06:27",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Căpăt h.",
					"to": "Sinia Hm.",
					"leavesAt": "06:28",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Sinia Hm.",
					"to": "Boldur h.",
					"leavesAt": "06:34",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Boldur h.",
					"to": "Lugoj",
					"leavesAt": "06:41",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7567",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "03:51",
					"arrivesAt": "03:59",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Cosmeşti Hm.",
					"leavesAt": "04:00",
					"arrivesAt": "04:05",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "Tecuci",
					"leavesAt": "04:06",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Tecuci",
					"to": "Malul Alb h.",
					"leavesAt": "04:28",
					"arrivesAt": "04:34",
					"waitsAtSource": 600,
					"distance": 5600
				},
				{
					"from": "Malul Alb h.",
					"to": "Barcea",
					"leavesAt": "04:35",
					"arrivesAt": "04:39",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Barcea",
					"to": "Umbrăreşti h.",
					"leavesAt": "04:40",
					"arrivesAt": "04:45",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "04:46",
					"arrivesAt": "04:51",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Iveşti Hm.",
					"to": "Buceşti h.",
					"leavesAt": "04:52",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Buceşti h.",
					"to": "Lieşti",
					"leavesAt": "04:57",
					"arrivesAt": "05:01",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lieşti",
					"to": "Şerbăneşti h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "05:06",
					"arrivesAt": "05:11",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "05:12",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Vameş h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:23",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Vameş h.",
					"to": "Piscu h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Piscu h.",
					"to": "Independenţa Hm.",
					"leavesAt": "05:29",
					"arrivesAt": "05:36",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Independenţa Hm.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "05:37",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Braniştea h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:46",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Braniştea h.",
					"to": "Şerbeştii Vechi h.",
					"leavesAt": "05:47",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şerbeştii Vechi h.",
					"to": "Şendreni Hm.",
					"leavesAt": "05:52",
					"arrivesAt": "05:57",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şendreni Hm.",
					"to": "Barboşi Triaj h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Barboşi Triaj h.",
					"to": "Barboşi",
					"leavesAt": "06:02",
					"arrivesAt": "06:10",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "06:18",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4505",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:14",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "06:15",
					"arrivesAt": "06:20",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "06:34",
					"arrivesAt": "06:38",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "06:39",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Bodoc Hm.",
					"leavesAt": "06:49",
					"arrivesAt": "06:56",
					"waitsAtSource": 120,
					"distance": 9500
				},
				{
					"from": "Bodoc Hm.",
					"to": "Malnaş h.",
					"leavesAt": "06:57",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Malnaş h.",
					"to": "Malnaş Băi",
					"leavesAt": "07:04",
					"arrivesAt": "07:09",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Malnaş Băi",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "07:10",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Tuşnad Sat",
					"leavesAt": "07:27",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tuşnad Sat",
					"to": "Vrabia h.",
					"leavesAt": "07:34",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Vrabia h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "07:37",
					"arrivesAt": "07:42",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "07:46",
					"arrivesAt": "07:49",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "07:57",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1644",
			"segments": [
				{
					"from": "Beclean pe Someş",
					"to": "Sărăţel Hm.",
					"leavesAt": "22:40",
					"arrivesAt": "23:06",
					"waitsAtSource": 0,
					"distance": 24900
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Mărişelu Hm.",
					"leavesAt": "23:24",
					"arrivesAt": "23:37",
					"waitsAtSource": 1080,
					"distance": 9300
				},
				{
					"from": "Mărişelu Hm.",
					"to": "Deda",
					"leavesAt": "23:42",
					"arrivesAt": "00:29",
					"waitsAtSource": 300,
					"distance": 37500
				},
				{
					"from": "Deda",
					"to": "Răstoliţa Hm.",
					"leavesAt": "00:33",
					"arrivesAt": "00:46",
					"waitsAtSource": 240,
					"distance": 9200
				},
				{
					"from": "Răstoliţa Hm.",
					"to": "Topliţa",
					"leavesAt": "00:54",
					"arrivesAt": "01:45",
					"waitsAtSource": 480,
					"distance": 34700
				},
				{
					"from": "Topliţa",
					"to": "Lăzarea Hm.",
					"leavesAt": "01:53",
					"arrivesAt": "02:24",
					"waitsAtSource": 480,
					"distance": 29600
				},
				{
					"from": "Lăzarea Hm.",
					"to": "Gheorgheni",
					"leavesAt": "02:32",
					"arrivesAt": "02:38",
					"waitsAtSource": 480,
					"distance": 4400
				},
				{
					"from": "Gheorgheni",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "02:40",
					"arrivesAt": "02:56",
					"waitsAtSource": 120,
					"distance": 19100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Izvoru Oltului",
					"leavesAt": "02:57",
					"arrivesAt": "03:09",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Izvoru Oltului",
					"to": "Siculeni",
					"leavesAt": "03:10",
					"arrivesAt": "03:29",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "03:33",
					"arrivesAt": "03:41",
					"waitsAtSource": 240,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "03:43",
					"arrivesAt": "04:06",
					"waitsAtSource": 120,
					"distance": 28500
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "04:08",
					"arrivesAt": "04:40",
					"waitsAtSource": 120,
					"distance": 34400
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Braşov",
					"leavesAt": "04:42",
					"arrivesAt": "05:12",
					"waitsAtSource": 120,
					"distance": 32100
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "05:27",
					"arrivesAt": "06:05",
					"waitsAtSource": 900,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "06:07",
					"arrivesAt": "06:16",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "06:25",
					"arrivesAt": "06:34",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Comarnic",
					"leavesAt": "06:36",
					"arrivesAt": "06:50",
					"waitsAtSource": 120,
					"distance": 15100
				},
				{
					"from": "Comarnic",
					"to": "Breaza hc.",
					"leavesAt": "06:51",
					"arrivesAt": "06:59",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "07:00",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "07:06",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Ploieşti Vest",
					"leavesAt": "07:17",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 18600
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "07:34",
					"arrivesAt": "08:19",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2050",
			"segments": [
				{
					"from": "Arad",
					"to": "Glogovăţ",
					"leavesAt": "18:45",
					"arrivesAt": "18:53",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Glogovăţ",
					"to": "Ghioroc",
					"leavesAt": "18:54",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Ghioroc",
					"to": "Păuliş h.",
					"leavesAt": "19:09",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Păuliş h.",
					"to": "Păuliş Hm.",
					"leavesAt": "19:15",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş Hm.",
					"to": "Radna",
					"leavesAt": "19:21",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Radna",
					"to": "Milova",
					"leavesAt": "19:34",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Milova",
					"to": "Corfeni h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Corfeni h.",
					"to": "Conop Hm.",
					"leavesAt": "19:51",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Conop Hm.",
					"to": "Bârzava",
					"leavesAt": "19:58",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bârzava",
					"to": "Căpruţa h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Căpruţa h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "20:15",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "20:21",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Vărădia Hm.",
					"leavesAt": "20:27",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vărădia Hm.",
					"to": "Vărădia h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vărădia h.",
					"to": "Săvârşin",
					"leavesAt": "20:39",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Săvârşin",
					"to": "Toc h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Toc h.",
					"to": "Ilteu",
					"leavesAt": "20:57",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ilteu",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "21:03",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Zam",
					"leavesAt": "21:09",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zam",
					"to": "Burjuc h.",
					"leavesAt": "21:16",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Burjuc h.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "21:27",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Gurasada Hm.",
					"leavesAt": "21:36",
					"arrivesAt": "21:43",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Gurasada Hm.",
					"to": "Ilia",
					"leavesAt": "21:44",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "21:52",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "21:58",
					"arrivesAt": "22:05",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "22:06",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia h.",
					"leavesAt": "22:11",
					"arrivesAt": "22:14",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Mintia",
					"leavesAt": "22:15",
					"arrivesAt": "22:19",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "22:20",
					"arrivesAt": "22:29",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "22:31",
					"arrivesAt": "22:38",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "22:39",
					"arrivesAt": "22:45",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 352
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1963",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun hc.",
					"leavesAt": "20:15",
					"arrivesAt": "20:25",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "20:27",
					"arrivesAt": "20:40",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "20:42",
					"arrivesAt": "20:46",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:57",
					"waitsAtSource": 180,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "20:58",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "21:10",
					"arrivesAt": "21:17",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "21:20",
					"arrivesAt": "21:43",
					"waitsAtSource": 180,
					"distance": 14000
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "22:20",
					"arrivesAt": "22:45",
					"waitsAtSource": 2220,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "22:46",
					"arrivesAt": "23:04",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "23:05",
					"arrivesAt": "23:24",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Movila Hm.",
					"leavesAt": "23:26",
					"arrivesAt": "23:43",
					"waitsAtSource": 120,
					"distance": 16700
				},
				{
					"from": "Movila Hm.",
					"to": "Ţăndărei",
					"leavesAt": "23:44",
					"arrivesAt": "23:56",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Ţăndărei",
					"to": "Spicu",
					"leavesAt": "23:57",
					"arrivesAt": "00:17",
					"waitsAtSource": 60,
					"distance": 21700
				},
				{
					"from": "Spicu",
					"to": "Făurei",
					"leavesAt": "00:18",
					"arrivesAt": "00:55",
					"waitsAtSource": 60,
					"distance": 36400
				},
				{
					"from": "Făurei",
					"to": "Buzău",
					"leavesAt": "00:57",
					"arrivesAt": "01:36",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "01:56",
					"arrivesAt": "02:27",
					"waitsAtSource": 1200,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "02:29",
					"arrivesAt": "03:07",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "03:09",
					"arrivesAt": "03:31",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Tecuci Nord hc.(605)",
					"leavesAt": "03:46",
					"arrivesAt": "04:10",
					"waitsAtSource": 900,
					"distance": 17800
				},
				{
					"from": "Tecuci Nord hc.(605)",
					"to": "Bârlad",
					"leavesAt": "04:11",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 48600
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "04:55",
					"arrivesAt": "05:24",
					"waitsAtSource": 120,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "05:25",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "05:41",
					"arrivesAt": "05:59",
					"waitsAtSource": 120,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "06:00",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "06:27",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "06:44",
					"arrivesAt": "06:51",
					"waitsAtSource": 120,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180529",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6316",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Dragalina h.",
					"leavesAt": "21:01",
					"arrivesAt": "21:09",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Dragalina h.",
					"to": "Tutova",
					"leavesAt": "21:10",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Tutova",
					"to": "Ghidigeni Hm.",
					"leavesAt": "21:18",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ghidigeni Hm.",
					"to": "Nichişeni",
					"leavesAt": "21:30",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nichişeni",
					"to": "Berheci Hm.",
					"leavesAt": "21:36",
					"arrivesAt": "21:45",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Berheci Hm.",
					"to": "Rateş Munteni h.",
					"leavesAt": "21:46",
					"arrivesAt": "21:52",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Rateş Munteni h.",
					"to": "Frunzeasca Hm.",
					"leavesAt": "21:53",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Frunzeasca Hm.",
					"to": "Tecuci Nord hc.(600)",
					"leavesAt": "21:59",
					"arrivesAt": "22:07",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tecuci Nord hc.(600)",
					"to": "Tecuci",
					"leavesAt": "22:08",
					"arrivesAt": "22:11",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9418",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Şopârliţa hc.",
					"leavesAt": "13:15",
					"arrivesAt": "13:26",
					"waitsAtSource": 0,
					"distance": 11100
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Vlăduleni",
					"leavesAt": "13:27",
					"arrivesAt": "13:33",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vlăduleni",
					"to": "Fălcoiu h.",
					"leavesAt": "13:34",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Fălcoiu h.",
					"to": "Romula Hm.",
					"leavesAt": "13:40",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Romula Hm.",
					"to": "Caracal",
					"leavesAt": "13:53",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 480
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5481",
			"segments": [
				{
					"from": "Bacău",
					"to": "Hămeiuş P.M.",
					"leavesAt": "19:07",
					"arrivesAt": "19:16",
					"waitsAtSource": 0,
					"distance": 7900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Gârleni Hm.",
					"leavesAt": "19:17",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Gârleni Hm.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "19:26",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Racova h.",
					"leavesAt": "19:32",
					"arrivesAt": "19:37",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Racova h.",
					"to": "Buhuşi",
					"leavesAt": "19:38",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Buhuşi",
					"to": "Costişa h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Costişa h.",
					"to": "Podoleni Hm.",
					"leavesAt": "19:54",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Podoleni Hm.",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Roznov",
					"leavesAt": "20:11",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Roznov",
					"to": "Săvineşti h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:28",
					"waitsAtSource": 420,
					"distance": 4200
				},
				{
					"from": "Săvineşti h.",
					"to": "Dumbrava h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Piatra Neamţ",
					"leavesAt": "20:38",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Piatra Neamţ",
					"to": "Vaduri h.",
					"leavesAt": "20:47",
					"arrivesAt": "20:59",
					"waitsAtSource": 120,
					"distance": 9600
				},
				{
					"from": "Vaduri h.",
					"to": "Pângăraţi Hm.",
					"leavesAt": "21:00",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Pângăraţi Hm.",
					"to": "Stejaru h.",
					"leavesAt": "21:06",
					"arrivesAt": "21:10",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Stejaru h.",
					"to": "Tarcău Neamţ Hm.",
					"leavesAt": "21:11",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tarcău Neamţ Hm.",
					"to": "Bicaz",
					"leavesAt": "21:19",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6442",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "04:21",
					"arrivesAt": "04:35",
					"waitsAtSource": 0,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "04:36",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "04:44",
					"arrivesAt": "04:49",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "04:50",
					"arrivesAt": "04:58",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "04:59",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "05:10",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "05:17",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "05:24",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "05:32",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4372",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "05:05",
					"arrivesAt": "05:12",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Reteag Hm.",
					"leavesAt": "05:13",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Reteag Hm.",
					"to": "Reteag h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag h.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "05:29",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "05:33",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "05:38",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Beclean pe Someş",
					"to": "Şintereag Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:57",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Şintereag Hm.",
					"to": "Caila hc.",
					"leavesAt": "05:58",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Caila hc.",
					"to": "Sfântu h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sfântu h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "06:14",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel Hm.",
					"leavesAt": "06:17",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Sărata h.",
					"leavesAt": "06:25",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Viişoara h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Viişoara h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "06:34",
					"arrivesAt": "06:38",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "06:39",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3088",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "19:43",
					"arrivesAt": "19:53",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "19:59",
					"arrivesAt": "20:05",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Cojocna Hm.",
					"leavesAt": "20:06",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cojocna Hm.",
					"to": "Tunel Hm.",
					"leavesAt": "20:12",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tunel Hm.",
					"to": "Boju",
					"leavesAt": "20:21",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Boju",
					"to": "Valea Florilor Hm.",
					"leavesAt": "20:30",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Ploscoş h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ploscoş h.",
					"to": "Cânepişti h.",
					"leavesAt": "20:47",
					"arrivesAt": "20:53",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cânepişti h.",
					"to": "Câmpia Turzii",
					"leavesAt": "20:54",
					"arrivesAt": "21:02",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Câmpia Turzii",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "21:03",
					"arrivesAt": "21:10",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Grindeni h.",
					"leavesAt": "21:11",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Grindeni h.",
					"to": "Războieni",
					"leavesAt": "21:18",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "21:23",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Unirea Hm.",
					"leavesAt": "21:28",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea Hm.",
					"to": "Decea h.",
					"leavesAt": "21:35",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Decea h.",
					"to": "Mirăslău h.",
					"leavesAt": "21:39",
					"arrivesAt": "21:43",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Mirăslău h.",
					"to": "Aiud Hm.",
					"leavesAt": "21:44",
					"arrivesAt": "21:51",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "21:52",
					"arrivesAt": "22:06",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Coşlariu",
					"leavesAt": "22:07",
					"arrivesAt": "22:15",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Coşlariu",
					"to": "Sântimbru h.",
					"leavesAt": "22:16",
					"arrivesAt": "22:27",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sântimbru h.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "22:28",
					"arrivesAt": "22:32",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "22:36",
					"arrivesAt": "22:43",
					"waitsAtSource": 240,
					"distance": 4800
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "22:47",
					"arrivesAt": "22:56",
					"waitsAtSource": 240,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8584",
			"segments": [
				{
					"from": "Ciulniţa",
					"to": "Brâncoveni h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:47",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Brâncoveni h.",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "08:48",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Slobozia Veche",
					"leavesAt": "08:58",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 4200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5431",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "21:39",
					"arrivesAt": "21:50",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "21:56",
					"arrivesAt": "22:01",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "22:02",
					"arrivesAt": "22:11",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "22:12",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "22:17",
					"arrivesAt": "22:24",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "22:26",
					"arrivesAt": "22:33",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "22:34",
					"arrivesAt": "22:40",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "22:41",
					"arrivesAt": "22:45",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "22:46",
					"arrivesAt": "22:51",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "22:52",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "22:57",
					"arrivesAt": "23:01",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani Triaj",
					"leavesAt": "23:02",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Paşcani Triaj",
					"to": "Paşcani",
					"leavesAt": "23:08",
					"arrivesAt": "23:15",
					"waitsAtSource": 60,
					"distance": 2300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7571",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "11:10",
					"arrivesAt": "11:17",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Cosmeşti Hm.",
					"leavesAt": "11:18",
					"arrivesAt": "11:23",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "Tecuci",
					"leavesAt": "11:24",
					"arrivesAt": "11:36",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Tecuci",
					"to": "Malul Alb h.",
					"leavesAt": "11:37",
					"arrivesAt": "11:42",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Malul Alb h.",
					"to": "Barcea",
					"leavesAt": "11:43",
					"arrivesAt": "11:47",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Barcea",
					"to": "Umbrăreşti h.",
					"leavesAt": "11:48",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "11:54",
					"arrivesAt": "11:59",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Iveşti Hm.",
					"to": "Buceşti h.",
					"leavesAt": "12:00",
					"arrivesAt": "12:03",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Buceşti h.",
					"to": "Lieşti",
					"leavesAt": "12:04",
					"arrivesAt": "12:08",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lieşti",
					"to": "Şerbăneşti h.",
					"leavesAt": "12:09",
					"arrivesAt": "12:12",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "12:13",
					"arrivesAt": "12:18",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "12:19",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Vameş h.",
					"leavesAt": "12:24",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Vameş h.",
					"to": "Piscu h.",
					"leavesAt": "12:31",
					"arrivesAt": "12:35",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Piscu h.",
					"to": "Independenţa Hm.",
					"leavesAt": "12:36",
					"arrivesAt": "12:43",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Independenţa Hm.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "12:44",
					"arrivesAt": "12:49",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Braniştea h.",
					"leavesAt": "12:50",
					"arrivesAt": "12:54",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Braniştea h.",
					"to": "Şendreni Hm.",
					"leavesAt": "12:55",
					"arrivesAt": "13:04",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Şendreni Hm.",
					"to": "Barboşi",
					"leavesAt": "13:05",
					"arrivesAt": "13:16",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "13:17",
					"arrivesAt": "13:23",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "13:24",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1826",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Rovinari Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:35",
					"waitsAtSource": 0,
					"distance": 21800
				},
				{
					"from": "Rovinari Hm.",
					"to": "Turceni",
					"leavesAt": "05:36",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 35300
				},
				{
					"from": "Turceni",
					"to": "Filiaşi",
					"leavesAt": "06:13",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 19900
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "06:39",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "07:13",
					"arrivesAt": "07:53",
					"waitsAtSource": 480,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "07:55",
					"arrivesAt": "08:10",
					"waitsAtSource": 120,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Radomireşti Hm.",
					"leavesAt": "08:11",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "08:23",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 25600
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "08:48",
					"arrivesAt": "09:33",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "09:35",
					"arrivesAt": "10:27",
					"waitsAtSource": 120,
					"distance": 50900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4109",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Sărăţel Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:53",
					"waitsAtSource": 0,
					"distance": 10700
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "18:01",
					"arrivesAt": "18:05",
					"waitsAtSource": 480,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:11",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Sfântu h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:30",
					"waitsAtSource": 840,
					"distance": 5300
				},
				{
					"from": "Sfântu h.",
					"to": "Caila hc.",
					"leavesAt": "18:31",
					"arrivesAt": "18:34",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Caila hc.",
					"to": "Şintereag Hm.",
					"leavesAt": "18:35",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Şintereag Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "18:40",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Beclean pe Someş",
					"to": "Ciceu Cristur h.",
					"leavesAt": "18:50",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "19:03",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "19:07",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Dej Călători",
					"leavesAt": "19:12",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "19:31",
					"arrivesAt": "19:50",
					"waitsAtSource": 120,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "19:51",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "19:58",
					"arrivesAt": "20:03",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "20:04",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:13",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "20:14",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:23",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida",
					"leavesAt": "20:24",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "20:39",
					"arrivesAt": "20:46",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "20:47",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "20:53",
					"arrivesAt": "20:58",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180114",
					"to": "20180114",
					"daysOfWeek": 895
				},
				{
					"from": "20180121",
					"to": "20180121",
					"daysOfWeek": 895
				},
				{
					"from": "20180128",
					"to": "20180128",
					"daysOfWeek": 895
				},
				{
					"from": "20180211",
					"to": "20180211",
					"daysOfWeek": 895
				},
				{
					"from": "20180218",
					"to": "20180218",
					"daysOfWeek": 895
				},
				{
					"from": "20180225",
					"to": "20180225",
					"daysOfWeek": 895
				},
				{
					"from": "20180304",
					"to": "20180304",
					"daysOfWeek": 895
				},
				{
					"from": "20180311",
					"to": "20180311",
					"daysOfWeek": 895
				},
				{
					"from": "20180318",
					"to": "20180318",
					"daysOfWeek": 895
				},
				{
					"from": "20180325",
					"to": "20180325",
					"daysOfWeek": 895
				},
				{
					"from": "20180410",
					"to": "20180410",
					"daysOfWeek": 895
				},
				{
					"from": "20180415",
					"to": "20180415",
					"daysOfWeek": 895
				},
				{
					"from": "20180422",
					"to": "20180422",
					"daysOfWeek": 895
				},
				{
					"from": "20180429",
					"to": "20180429",
					"daysOfWeek": 895
				},
				{
					"from": "20180506",
					"to": "20180506",
					"daysOfWeek": 895
				},
				{
					"from": "20180513",
					"to": "20180513",
					"daysOfWeek": 895
				},
				{
					"from": "20180520",
					"to": "20180520",
					"daysOfWeek": 895
				},
				{
					"from": "20180527",
					"to": "20180527",
					"daysOfWeek": 895
				},
				{
					"from": "20180603",
					"to": "20180603",
					"daysOfWeek": 895
				},
				{
					"from": "20180610",
					"to": "20180610",
					"daysOfWeek": 895
				},
				{
					"from": "20180909",
					"to": "20180909",
					"daysOfWeek": 895
				},
				{
					"from": "20180916",
					"to": "20180916",
					"daysOfWeek": 895
				},
				{
					"from": "20180923",
					"to": "20180923",
					"daysOfWeek": 895
				},
				{
					"from": "20180930",
					"to": "20180930",
					"daysOfWeek": 895
				},
				{
					"from": "20181007",
					"to": "20181007",
					"daysOfWeek": 895
				},
				{
					"from": "20181014",
					"to": "20181014",
					"daysOfWeek": 895
				},
				{
					"from": "20181021",
					"to": "20181021",
					"daysOfWeek": 895
				},
				{
					"from": "20181028",
					"to": "20181028",
					"daysOfWeek": 895
				},
				{
					"from": "20181104",
					"to": "20181104",
					"daysOfWeek": 895
				},
				{
					"from": "20181111",
					"to": "20181111",
					"daysOfWeek": 895
				},
				{
					"from": "20181118",
					"to": "20181118",
					"daysOfWeek": 895
				},
				{
					"from": "20181125",
					"to": "20181125",
					"daysOfWeek": 895
				},
				{
					"from": "20181202",
					"to": "20181202",
					"daysOfWeek": 895
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 895
				},
				{
					"from": "20171217",
					"to": "20171217",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1656",
			"segments": [
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "16:06",
					"arrivesAt": "16:46",
					"waitsAtSource": 0,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "16:47",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 25700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6822",
			"segments": [
				{
					"from": "Nyirabrany",
					"to": "Valea lui Mihai",
					"leavesAt": "11:06",
					"arrivesAt": "11:21",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Valea lui Mihai",
					"to": "Curtuiuşeni h.",
					"leavesAt": "11:41",
					"arrivesAt": "11:48",
					"waitsAtSource": 1200,
					"distance": 6300
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Resighea h.",
					"leavesAt": "11:49",
					"arrivesAt": "11:56",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Resighea h.",
					"to": "Sanislău Hm.",
					"leavesAt": "11:57",
					"arrivesAt": "12:02",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Sanislău Hm.",
					"to": "Marna h.",
					"leavesAt": "12:03",
					"arrivesAt": "12:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Marna h.",
					"to": "Carei",
					"leavesAt": "12:09",
					"arrivesAt": "12:16",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Carei",
					"to": "Domăneşti h.",
					"leavesAt": "12:17",
					"arrivesAt": "12:25",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Domăneşti h.",
					"to": "Moftin h.",
					"leavesAt": "12:26",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Moftin h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "12:31",
					"arrivesAt": "12:35",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Sătmărel h.",
					"leavesAt": "12:36",
					"arrivesAt": "12:44",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Sătmărel h.",
					"to": "Satu Mare Sud",
					"leavesAt": "12:45",
					"arrivesAt": "12:52",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Satu Mare Sud",
					"to": "Satu Mare",
					"leavesAt": "12:53",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6823",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Satu Mare Sud",
					"leavesAt": "15:00",
					"arrivesAt": "15:05",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Satu Mare Sud",
					"to": "Sătmărel h.",
					"leavesAt": "15:06",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Sătmărel h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "15:13",
					"arrivesAt": "15:23",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Moftin h.",
					"leavesAt": "15:24",
					"arrivesAt": "15:27",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Moftin h.",
					"to": "Domăneşti h.",
					"leavesAt": "15:28",
					"arrivesAt": "15:32",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Domăneşti h.",
					"to": "Carei",
					"leavesAt": "15:33",
					"arrivesAt": "15:43",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Carei",
					"to": "Marna h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Marna h.",
					"to": "Sanislău Hm.",
					"leavesAt": "15:51",
					"arrivesAt": "15:56",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Sanislău Hm.",
					"to": "Resighea h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Resighea h.",
					"to": "Curtuiuşeni h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Valea lui Mihai",
					"leavesAt": "16:10",
					"arrivesAt": "16:17",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Valea lui Mihai",
					"to": "Nyirabrany",
					"leavesAt": "16:39",
					"arrivesAt": "16:54",
					"waitsAtSource": 1320,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1631",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "07:00",
					"arrivesAt": "07:40",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "07:42",
					"arrivesAt": "08:06",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "08:07",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "08:32",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "08:40",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "08:46",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "08:57",
					"arrivesAt": "09:35",
					"waitsAtSource": 120,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8202",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "07:57",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "08:05",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "08:11",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "08:21",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "08:26",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "08:30",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "08:37",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "08:46",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "08:52",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Ramificaţia Borcea",
					"leavesAt": "09:02",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "09:20",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Feteşti",
					"to": "Movila Hm.",
					"leavesAt": "09:27",
					"arrivesAt": "09:46",
					"waitsAtSource": 60,
					"distance": 16700
				},
				{
					"from": "Movila Hm.",
					"to": "Platoneşti h.",
					"leavesAt": "09:47",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Platoneşti h.",
					"to": "Ţăndărei",
					"leavesAt": "09:57",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ţăndărei",
					"to": "Murgeanca Hm.",
					"leavesAt": "10:07",
					"arrivesAt": "10:19",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Murgeanca Hm.",
					"to": "Spicu",
					"leavesAt": "10:20",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spicu",
					"to": "Dudeşti Hm.",
					"leavesAt": "10:30",
					"arrivesAt": "10:40",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Dudeşti Hm.",
					"to": "Scărlăteşti hc.",
					"leavesAt": "10:41",
					"arrivesAt": "10:48",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Scărlăteşti hc.",
					"to": "Cireşu Hm.",
					"leavesAt": "10:49",
					"arrivesAt": "10:56",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cireşu Hm.",
					"to": "Făurei",
					"leavesAt": "10:57",
					"arrivesAt": "11:15",
					"waitsAtSource": 60,
					"distance": 15700
				},
				{
					"from": "Făurei",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "11:17",
					"arrivesAt": "11:28",
					"waitsAtSource": 120,
					"distance": 10000
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "11:29",
					"arrivesAt": "11:36",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Movila Oii h.",
					"to": "Cilibia Hm.",
					"leavesAt": "11:37",
					"arrivesAt": "11:42",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Cilibia Hm.",
					"to": "Bentu h.",
					"leavesAt": "11:43",
					"arrivesAt": "11:48",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bentu h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "11:49",
					"arrivesAt": "11:54",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Tăbărăşti h.",
					"leavesAt": "11:55",
					"arrivesAt": "11:58",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Buzău",
					"leavesAt": "11:59",
					"arrivesAt": "12:11",
					"waitsAtSource": 30,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8153",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Alexeni h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:46",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Alexeni h.",
					"to": "Broşteni Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:53",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Broşteni Hm.",
					"to": "Malu h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Malu h.",
					"to": "Km. 74+600 h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Km. 74+600 h.",
					"to": "Sărăţuica Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Sărăţuica Hm.",
					"to": "Sărăţeni Ialomiţa h.",
					"leavesAt": "17:10",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sărăţeni Ialomiţa h.",
					"to": "Munteni Buzău h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Munteni Buzău h.",
					"to": "Căzăneşti",
					"leavesAt": "17:19",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Căzăneşti",
					"to": "Ciochina hc.",
					"leavesAt": "17:26",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ciochina hc.",
					"to": "Andrăşeşti Hm.",
					"leavesAt": "17:33",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Andrăşeşti Hm.",
					"to": "Fundata h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Fundata h.",
					"to": "Perieţi h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:53",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Perieţi h.",
					"to": "Slobozia Veche",
					"leavesAt": "17:54",
					"arrivesAt": "18:05",
					"waitsAtSource": 30,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5114",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:48",
					"waitsAtSource": 0,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "17:49",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Focşani",
					"to": "Coteşti Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Coteşti Hm.",
					"to": "Gugeşti",
					"leavesAt": "18:15",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Gugeşti",
					"to": "Sihlea Hm.",
					"leavesAt": "18:24",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sihlea Hm.",
					"to": "Voetin h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Voetin h.",
					"to": "Râmnicu Sărat",
					"leavesAt": "18:40",
					"arrivesAt": "18:49",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Zoita Hm.",
					"leavesAt": "18:50",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Zoita Hm.",
					"to": "Boboc Hm.",
					"leavesAt": "19:01",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Boboc Hm.",
					"to": "Buzău",
					"leavesAt": "19:12",
					"arrivesAt": "19:24",
					"waitsAtSource": 60,
					"distance": 11500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1727",
			"segments": [
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "07:15",
					"arrivesAt": "07:55",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "08:00",
					"arrivesAt": "08:25",
					"waitsAtSource": 300,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Gilort Hm.",
					"leavesAt": "08:26",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 12400
				},
				{
					"from": "Gilort Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "08:42",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turburea Hm.",
					"to": "Bibeşti Hm.",
					"leavesAt": "08:50",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "09:00",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Cărbuneşti",
					"to": "Târgu Jiu",
					"leavesAt": "09:21",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 23800
				}
			],
			"restrictions": [
				{
					"from": "20180807",
					"to": "20181208",
					"daysOfWeek": 783
				},
				{
					"from": "20171210",
					"to": "20180805",
					"daysOfWeek": 783
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1835",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "16:25",
					"arrivesAt": "17:16",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "17:17",
					"arrivesAt": "18:03",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "18:05",
					"arrivesAt": "18:35",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "18:36",
					"arrivesAt": "18:54",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "18:55",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "19:42",
					"arrivesAt": "20:08",
					"waitsAtSource": 480,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Cărbuneşti",
					"leavesAt": "20:09",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 46500
				},
				{
					"from": "Cărbuneşti",
					"to": "Târgu Jiu",
					"leavesAt": "20:55",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 23800
				},
				{
					"from": "Târgu Jiu",
					"to": "Valea Sadului Hm.",
					"leavesAt": "21:30",
					"arrivesAt": "21:50",
					"waitsAtSource": 480,
					"distance": 19600
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Petroşani",
					"leavesAt": "21:51",
					"arrivesAt": "22:37",
					"waitsAtSource": 60,
					"distance": 31700
				},
				{
					"from": "Petroşani",
					"to": "Subcetate",
					"leavesAt": "22:41",
					"arrivesAt": "23:47",
					"waitsAtSource": 240,
					"distance": 49800
				},
				{
					"from": "Subcetate",
					"to": "Călan Hm.",
					"leavesAt": "23:48",
					"arrivesAt": "00:07",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Călan Hm.",
					"to": "Simeria",
					"leavesAt": "00:08",
					"arrivesAt": "00:23",
					"waitsAtSource": 60,
					"distance": 14600
				},
				{
					"from": "Simeria",
					"to": "Orăştie",
					"leavesAt": "00:43",
					"arrivesAt": "01:05",
					"waitsAtSource": 1200,
					"distance": 16500
				},
				{
					"from": "Orăştie",
					"to": "Aurel Vlaicu",
					"leavesAt": "01:06",
					"arrivesAt": "01:15",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Şibot",
					"leavesAt": "01:20",
					"arrivesAt": "01:28",
					"waitsAtSource": 300,
					"distance": 5900
				},
				{
					"from": "Şibot",
					"to": "Vinţu de Jos",
					"leavesAt": "01:29",
					"arrivesAt": "01:51",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "01:52",
					"arrivesAt": "02:04",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Teiuş",
					"leavesAt": "02:05",
					"arrivesAt": "02:40",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "02:44",
					"arrivesAt": "02:56",
					"waitsAtSource": 240,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Războieni",
					"leavesAt": "02:57",
					"arrivesAt": "03:18",
					"waitsAtSource": 60,
					"distance": 20400
				},
				{
					"from": "Războieni",
					"to": "Câmpia Turzii",
					"leavesAt": "03:20",
					"arrivesAt": "03:36",
					"waitsAtSource": 120,
					"distance": 17100
				},
				{
					"from": "Câmpia Turzii",
					"to": "Apahida",
					"leavesAt": "03:37",
					"arrivesAt": "04:27",
					"waitsAtSource": 60,
					"distance": 39200
				},
				{
					"from": "Apahida",
					"to": "Cluj Napoca",
					"leavesAt": "04:28",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 12300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1657",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "15:00",
					"arrivesAt": "15:51",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "15:53",
					"arrivesAt": "16:26",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "16:27",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "17:05",
					"arrivesAt": "17:36",
					"waitsAtSource": 180,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "17:37",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "18:17",
					"arrivesAt": "18:39",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "18:41",
					"arrivesAt": "19:07",
					"waitsAtSource": 120,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "19:08",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 58200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9405",
			"segments": [
				{
					"from": "Caracal",
					"to": "Romula Hm.",
					"leavesAt": "14:18",
					"arrivesAt": "14:31",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Romula Hm.",
					"to": "Fălcoiu h.",
					"leavesAt": "14:32",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Fălcoiu h.",
					"to": "Vlăduleni",
					"leavesAt": "14:42",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vlăduleni",
					"to": "Şopârliţa hc.",
					"leavesAt": "14:52",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Pârşcoveni hc.",
					"leavesAt": "14:57",
					"arrivesAt": "15:03",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Pârşcoveni hc.",
					"to": "Piatra Olt",
					"leavesAt": "15:04",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20180115",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180212",
					"to": "20180330",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4484",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "14:20",
					"arrivesAt": "14:27",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Ciceu Mihăeşti h.",
					"leavesAt": "14:28",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ciceu Mihăeşti h.",
					"to": "Reteag Hm.",
					"leavesAt": "14:34",
					"arrivesAt": "14:39",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Reteag Hm.",
					"to": "Reteag h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:44",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag h.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:48",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "14:49",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "14:53",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Beclean pe Someş",
					"to": "Cociu h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:12",
					"waitsAtSource": 120,
					"distance": 6700
				},
				{
					"from": "Cociu h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "15:13",
					"arrivesAt": "15:16",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Nimigea h.",
					"leavesAt": "15:17",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Nimigea h.",
					"to": "Nimigea Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Nimigea Hm.",
					"to": "Mititei h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mititei h.",
					"to": "Salva",
					"leavesAt": "15:33",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Salva",
					"to": "Năsăud h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Năsăud h.",
					"to": "Năsăud",
					"leavesAt": "15:42",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Năsăud",
					"to": "Rebrişoara Hm.",
					"leavesAt": "15:46",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Nepos h.",
					"leavesAt": "15:52",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Nepos h.",
					"to": "Feldru Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Feldru Hm.",
					"to": "Podereia Feldrului h.",
					"leavesAt": "16:06",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Ilva Mică",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180701",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3747",
			"segments": [
				{
					"from": "Arad",
					"to": "Utviniş h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:16",
					"waitsAtSource": 0,
					"distance": 9600
				},
				{
					"from": "Utviniş h.",
					"to": "Zimandu Nou h.",
					"leavesAt": "16:17",
					"arrivesAt": "16:21",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "16:22",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Comlăuş h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Comlăuş h.",
					"to": "Şimand Hm.",
					"leavesAt": "16:39",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Şimand Hm.",
					"to": "Nădab",
					"leavesAt": "16:49",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Nădab",
					"to": "Chişineu Criş",
					"leavesAt": "16:58",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9587",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Săcălaz h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:22",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Săcălaz h.",
					"to": "Beregsău hcv.",
					"leavesAt": "08:23",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Beregsău hcv.",
					"to": "Cărpiniş",
					"leavesAt": "08:31",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Cărpiniş",
					"to": "Clarii Vii h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Clarii Vii h.",
					"to": "Jimbolia",
					"leavesAt": "08:47",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5436",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "11:28",
					"arrivesAt": "11:35",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "11:36",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "11:42",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "11:47",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "11:53",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "11:58",
					"arrivesAt": "12:04",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "12:05",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "12:16",
					"arrivesAt": "12:23",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "12:24",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "12:29",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "12:38",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "12:44",
					"arrivesAt": "12:49",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "12:50",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9402",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Şopârliţa hc.",
					"leavesAt": "05:42",
					"arrivesAt": "05:53",
					"waitsAtSource": 0,
					"distance": 11100
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Vlăduleni",
					"leavesAt": "05:54",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vlăduleni",
					"to": "Fălcoiu h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:13",
					"waitsAtSource": 540,
					"distance": 3800
				},
				{
					"from": "Fălcoiu h.",
					"to": "Romula Hm.",
					"leavesAt": "06:14",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Romula Hm.",
					"to": "Caracal",
					"leavesAt": "06:26",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1648",
			"segments": [
				{
					"from": "Sărăţel Hm.",
					"to": "Bistriţa Nord",
					"leavesAt": "05:12",
					"arrivesAt": "05:26",
					"waitsAtSource": 0,
					"distance": 10700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1928",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Tălmaciu Hm.",
					"leavesAt": "04:08",
					"arrivesAt": "04:27",
					"waitsAtSource": 0,
					"distance": 17800
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "04:28",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 15400
				},
				{
					"from": "Avrig Hm.",
					"to": "Porumbacu Hm.",
					"leavesAt": "04:47",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Cârţa h.",
					"leavesAt": "04:57",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Cârţa h.",
					"to": "Ucea",
					"leavesAt": "05:09",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Ucea",
					"to": "Făgăraş",
					"leavesAt": "05:21",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Făgăraş",
					"to": "Mândra Oltului h.",
					"leavesAt": "05:46",
					"arrivesAt": "05:52",
					"waitsAtSource": 120,
					"distance": 6100
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Şercaia h.",
					"leavesAt": "05:53",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Şercaia h.",
					"to": "Şercaia Hm.",
					"leavesAt": "06:01",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 1200
				},
				{
					"from": "Şercaia Hm.",
					"to": "Perşani h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Brădet Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:20",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Brădet Hm.",
					"to": "Valea Homorod h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Homorod h.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "06:30",
					"arrivesAt": "06:40",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "06:45",
					"arrivesAt": "06:50",
					"waitsAtSource": 300,
					"distance": 4600
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "06:51",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Codlea Hm.",
					"to": "Ghimbav Hm.",
					"leavesAt": "07:01",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Bartolomeu",
					"leavesAt": "07:08",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "07:16",
					"arrivesAt": "07:22",
					"waitsAtSource": 120,
					"distance": 3100
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "07:40",
					"arrivesAt": "08:18",
					"waitsAtSource": 1080,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "08:20",
					"arrivesAt": "08:29",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "08:31",
					"arrivesAt": "08:37",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "08:38",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Valea Largă Hm.",
					"leavesAt": "08:49",
					"arrivesAt": "08:55",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Comarnic",
					"leavesAt": "08:56",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Comarnic",
					"to": "Câmpina",
					"leavesAt": "09:06",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "09:20",
					"arrivesAt": "09:44",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "09:46",
					"arrivesAt": "10:32",
					"waitsAtSource": 120,
					"distance": 58900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Feteşti",
					"leavesAt": "11:00",
					"arrivesAt": "12:16",
					"waitsAtSource": 1680,
					"distance": 146400
				},
				{
					"from": "Feteşti",
					"to": "Constanţa",
					"leavesAt": "12:18",
					"arrivesAt": "13:14",
					"waitsAtSource": 120,
					"distance": 78600
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5466",
			"segments": [
				{
					"from": "Piatra Neamţ",
					"to": "Dumbrava h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:32",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Săvineşti h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Săvineşti h.",
					"to": "Roznov",
					"leavesAt": "17:40",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Roznov",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "17:53",
					"arrivesAt": "17:57",
					"waitsAtSource": 420,
					"distance": 3600
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Podoleni Hm.",
					"leavesAt": "17:58",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Podoleni Hm.",
					"to": "Costişa h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Costişa h.",
					"to": "Buhuşi",
					"leavesAt": "18:14",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhuşi",
					"to": "Racova h.",
					"leavesAt": "18:24",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Racova h.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "18:29",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Gârleni Hm.",
					"leavesAt": "18:35",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gârleni Hm.",
					"to": "Hămeiuş P.M.",
					"leavesAt": "18:40",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Bacău",
					"leavesAt": "18:47",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 7900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4483",
			"segments": [
				{
					"from": "Ilva Mică",
					"to": "Podereia Feldrului h.",
					"leavesAt": "13:56",
					"arrivesAt": "14:00",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Feldru Hm.",
					"leavesAt": "14:01",
					"arrivesAt": "14:05",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Feldru Hm.",
					"to": "Nepos h.",
					"leavesAt": "14:06",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Nepos h.",
					"to": "Rebrişoara Hm.",
					"leavesAt": "14:12",
					"arrivesAt": "14:18",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Năsăud",
					"leavesAt": "14:19",
					"arrivesAt": "14:24",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Năsăud",
					"to": "Năsăud h.",
					"leavesAt": "14:32",
					"arrivesAt": "14:35",
					"waitsAtSource": 480,
					"distance": 2200
				},
				{
					"from": "Năsăud h.",
					"to": "Salva",
					"leavesAt": "14:36",
					"arrivesAt": "14:41",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Salva",
					"to": "Mititei h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:46",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Mititei h.",
					"to": "Nimigea Hm.",
					"leavesAt": "14:47",
					"arrivesAt": "14:54",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Nimigea Hm.",
					"to": "Nimigea h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:04",
					"waitsAtSource": 420,
					"distance": 2200
				},
				{
					"from": "Nimigea h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "15:05",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Cociu h.",
					"leavesAt": "15:18",
					"arrivesAt": "15:20",
					"waitsAtSource": 420,
					"distance": 1800
				},
				{
					"from": "Cociu h.",
					"to": "Beclean pe Someş",
					"leavesAt": "15:21",
					"arrivesAt": "15:29",
					"waitsAtSource": 30,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180909",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4510",
			"segments": [
				{
					"from": "Deda",
					"to": "Deda Bistra Hm.",
					"leavesAt": "13:06",
					"arrivesAt": "13:12",
					"waitsAtSource": 0,
					"distance": 3900
				},
				{
					"from": "Deda Bistra Hm.",
					"to": "Borzia h.",
					"leavesAt": "13:13",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Borzia h.",
					"to": "Răstoliţa Hm.",
					"leavesAt": "13:18",
					"arrivesAt": "13:22",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Răstoliţa Hm.",
					"to": "Lunca Bradului Hm.",
					"leavesAt": "13:23",
					"arrivesAt": "13:41",
					"waitsAtSource": 60,
					"distance": 12700
				},
				{
					"from": "Lunca Bradului Hm.",
					"to": "Stânceni Neagra h.",
					"leavesAt": "13:42",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Stânceni Neagra h.",
					"to": "Stânceni h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:56",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Stânceni h.",
					"to": "Stânceni Hm.",
					"leavesAt": "13:57",
					"arrivesAt": "14:04",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Stânceni Hm.",
					"to": "Ciobotani h.",
					"leavesAt": "14:05",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ciobotani h.",
					"to": "Topliţa",
					"leavesAt": "14:11",
					"arrivesAt": "14:21",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Topliţa",
					"to": "Gălăuţaş Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Gălăuţaş Hm.",
					"to": "Sărmaş Runc h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:36",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Sărmaş Runc h.",
					"to": "Subcetate Mureş Hm.",
					"leavesAt": "14:37",
					"arrivesAt": "14:43",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Subcetate Mureş Hm.",
					"to": "Ditrău",
					"leavesAt": "14:44",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ditrău",
					"to": "Lăzarea Hm.",
					"leavesAt": "14:53",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Lăzarea Hm.",
					"to": "Gheorgheni",
					"leavesAt": "15:00",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Gheorgheni",
					"to": "Valea Strâmbă h.",
					"leavesAt": "15:07",
					"arrivesAt": "15:10",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Şugău h.",
					"leavesAt": "15:11",
					"arrivesAt": "15:14",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Şugău h.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "15:15",
					"arrivesAt": "15:19",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Sândominic h.",
					"leavesAt": "15:31",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Oltului",
					"leavesAt": "15:40",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Tomeşti h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Cârţani h.",
					"leavesAt": "15:50",
					"arrivesAt": "15:53",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Cârţani h.",
					"to": "Dăneşti h.",
					"leavesAt": "15:54",
					"arrivesAt": "15:57",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Dăneşti h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "15:58",
					"arrivesAt": "16:04",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Racu h.",
					"leavesAt": "16:05",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Racu h.",
					"to": "Siculeni",
					"leavesAt": "16:11",
					"arrivesAt": "16:16",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "16:20",
					"arrivesAt": "16:29",
					"waitsAtSource": 240,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:50",
					"waitsAtSource": 780,
					"distance": 7800
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "16:51",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "16:55",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Vrabia h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Vrabia h.",
					"to": "Tuşnad Sat",
					"leavesAt": "17:06",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Tuşnad Sat",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "17:19",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Malnaş Băi",
					"leavesAt": "17:27",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Malnaş Băi",
					"to": "Malnaş h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Malnaş h.",
					"to": "Bodoc Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:50",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Bodoc Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "17:51",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "18:00",
					"arrivesAt": "18:07",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "18:14",
					"arrivesAt": "18:19",
					"waitsAtSource": 420,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "18:20",
					"arrivesAt": "18:25",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "18:26",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "18:30",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "18:45",
					"arrivesAt": "18:51",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9108",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:47",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "16:53",
					"arrivesAt": "16:57",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Podu Rizii h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:07",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Podu Rizii h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "17:13",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "17:32",
					"arrivesAt": "17:36",
					"waitsAtSource": 840,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "17:41",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "17:53",
					"arrivesAt": "18:00",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "18:01",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "18:09",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "18:15",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "18:21",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2374",
			"segments": [
				{
					"from": "Arad",
					"to": "Glogovăţ",
					"leavesAt": "19:48",
					"arrivesAt": "19:56",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Glogovăţ",
					"to": "Ghioroc",
					"leavesAt": "19:57",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Ghioroc",
					"to": "Păuliş h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Păuliş h.",
					"to": "Păuliş Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş Hm.",
					"to": "Radna",
					"leavesAt": "20:24",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Radna",
					"to": "Milova",
					"leavesAt": "20:36",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Milova",
					"to": "Corfeni h.",
					"leavesAt": "20:47",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Corfeni h.",
					"to": "Conop Hm.",
					"leavesAt": "20:52",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Conop Hm.",
					"to": "Nadăş h.",
					"leavesAt": "20:59",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Nadăş h.",
					"to": "Bârzava",
					"leavesAt": "21:05",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârzava",
					"to": "Căpruţa h.",
					"leavesAt": "21:13",
					"arrivesAt": "21:16",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Căpruţa h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "21:17",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "21:23",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Vărădia Hm.",
					"leavesAt": "21:29",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vărădia Hm.",
					"to": "Vărădia h.",
					"leavesAt": "21:37",
					"arrivesAt": "21:40",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vărădia h.",
					"to": "Săvârşin",
					"leavesAt": "21:41",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 6000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4131",
			"segments": [
				{
					"from": "Vişeu de Jos",
					"to": "Bocicoel h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Bocicoel h.",
					"to": "Leordina h.",
					"leavesAt": "16:51",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Leordina h.",
					"to": "Leordina",
					"leavesAt": "17:00",
					"arrivesAt": "17:06",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Leordina",
					"to": "Petrova hc.",
					"leavesAt": "17:26",
					"arrivesAt": "17:36",
					"waitsAtSource": 1200,
					"distance": 6400
				},
				{
					"from": "Petrova hc.",
					"to": "Vişeu Bistra h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Valea Vişeului",
					"leavesAt": "17:47",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Valea Vişeului",
					"to": "Lunca la Tisa h.",
					"leavesAt": "18:24",
					"arrivesAt": "18:40",
					"waitsAtSource": 1380,
					"distance": 10700
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "18:41",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Crăciuneşti h.",
					"leavesAt": "18:48",
					"arrivesAt": "18:54",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Tisa h.",
					"leavesAt": "18:55",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Tisa h.",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "18:59",
					"arrivesAt": "19:06",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Sighetu Marmaţiei",
					"leavesAt": "19:07",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 1900
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1825",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "14:45",
					"arrivesAt": "15:36",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "15:37",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "16:24",
					"arrivesAt": "16:55",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "16:56",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "17:15",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "18:00",
					"arrivesAt": "18:26",
					"waitsAtSource": 300,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Turceni",
					"leavesAt": "18:28",
					"arrivesAt": "18:49",
					"waitsAtSource": 120,
					"distance": 19000
				},
				{
					"from": "Turceni",
					"to": "Rovinari Hm.",
					"leavesAt": "18:50",
					"arrivesAt": "19:24",
					"waitsAtSource": 60,
					"distance": 35300
				},
				{
					"from": "Rovinari Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "19:25",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 21800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1575",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "13:10",
					"arrivesAt": "14:00",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "14:02",
					"arrivesAt": "14:35",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "14:36",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Făurei",
					"leavesAt": "15:13",
					"arrivesAt": "15:50",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Făurei",
					"to": "Ianca hc.",
					"leavesAt": "15:51",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Ianca hc.",
					"to": "Brăila",
					"leavesAt": "16:06",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 42400
				},
				{
					"from": "Brăila",
					"to": "Barboşi",
					"leavesAt": "16:40",
					"arrivesAt": "16:58",
					"waitsAtSource": 120,
					"distance": 19500
				},
				{
					"from": "Barboşi",
					"to": "Galaţi",
					"leavesAt": "16:59",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4413",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Ram. Botiz h.",
					"leavesAt": "23:29",
					"arrivesAt": "23:35",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Micula Hm.",
					"leavesAt": "23:36",
					"arrivesAt": "23:44",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Micula Hm.",
					"to": "Porumbeşti Hm.",
					"leavesAt": "23:45",
					"arrivesAt": "23:52",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Halmeu",
					"leavesAt": "23:53",
					"arrivesAt": "23:59",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20180101",
					"to": "20180407",
					"daysOfWeek": 351
				},
				{
					"from": "20180409",
					"to": "20180429",
					"daysOfWeek": 351
				},
				{
					"from": "20180501",
					"to": "20180526",
					"daysOfWeek": 351
				},
				{
					"from": "20180528",
					"to": "20180530",
					"daysOfWeek": 351
				},
				{
					"from": "20180601",
					"to": "20181128",
					"daysOfWeek": 351
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 351
				},
				{
					"from": "20171210",
					"to": "20171223",
					"daysOfWeek": 351
				},
				{
					"from": "20171226",
					"to": "20171230",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5454",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "05:00",
					"arrivesAt": "05:05",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "05:06",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "05:16",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 660,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "05:55",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "06:16",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "06:21",
					"arrivesAt": "06:27",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Paşcani Triaj",
					"leavesAt": "07:25",
					"arrivesAt": "07:29",
					"waitsAtSource": 3480,
					"distance": 2300
				},
				{
					"from": "Paşcani Triaj",
					"to": "Stolniceni h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "07:36",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "07:42",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "07:47",
					"arrivesAt": "07:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "07:53",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "07:58",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "08:05",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "08:16",
					"arrivesAt": "08:23",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "08:24",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "08:29",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "08:44",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "08:50",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20180531",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2212",
			"segments": [
				{
					"from": "Curtici",
					"to": "Şofronea",
					"leavesAt": "17:18",
					"arrivesAt": "17:26",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Şofronea",
					"to": "Arad",
					"leavesAt": "17:27",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2571",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(203)",
					"leavesAt": "23:17",
					"arrivesAt": "23:21",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "23:22",
					"arrivesAt": "23:32",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "23:33",
					"arrivesAt": "23:37",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Mândra h.",
					"leavesAt": "23:38",
					"arrivesAt": "23:45",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mândra h.",
					"to": "Loamneş Hm.",
					"leavesAt": "23:46",
					"arrivesAt": "23:52",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Loamneş Hm.",
					"to": "Hăşag h.",
					"leavesAt": "23:53",
					"arrivesAt": "23:58",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Hăşag h.",
					"to": "Şeica Mare h.",
					"leavesAt": "23:59",
					"arrivesAt": "00:09",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Şeica Mare h.",
					"to": "Şeica Mare",
					"leavesAt": "00:10",
					"arrivesAt": "00:13",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Şeica Mare",
					"to": "Agârbiciu h.",
					"leavesAt": "00:14",
					"arrivesAt": "00:20",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Agârbiciu h.",
					"to": "Axente Sever h.",
					"leavesAt": "00:21",
					"arrivesAt": "00:26",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Axente Sever h.",
					"to": "Copşa Mică",
					"leavesAt": "00:27",
					"arrivesAt": "00:32",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "00:33",
					"arrivesAt": "00:40",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "00:41",
					"arrivesAt": "00:48",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5430",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "02:28",
					"arrivesAt": "02:35",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "02:36",
					"arrivesAt": "02:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "02:42",
					"arrivesAt": "02:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "02:47",
					"arrivesAt": "02:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "02:53",
					"arrivesAt": "02:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "02:58",
					"arrivesAt": "03:04",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "03:05",
					"arrivesAt": "03:14",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "03:16",
					"arrivesAt": "03:23",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "03:24",
					"arrivesAt": "03:28",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "03:29",
					"arrivesAt": "03:37",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "03:38",
					"arrivesAt": "03:43",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "03:44",
					"arrivesAt": "03:49",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "03:50",
					"arrivesAt": "04:02",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3090",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "22:35",
					"arrivesAt": "22:45",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "22:46",
					"arrivesAt": "22:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "22:51",
					"arrivesAt": "22:57",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Cojocna Hm.",
					"leavesAt": "22:58",
					"arrivesAt": "23:03",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cojocna Hm.",
					"to": "Tunel Hm.",
					"leavesAt": "23:04",
					"arrivesAt": "23:12",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tunel Hm.",
					"to": "Boju",
					"leavesAt": "23:13",
					"arrivesAt": "23:21",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Boju",
					"to": "Valea Florilor Hm.",
					"leavesAt": "23:22",
					"arrivesAt": "23:34",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Ploscoş h.",
					"leavesAt": "23:35",
					"arrivesAt": "23:39",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ploscoş h.",
					"to": "Cânepişti h.",
					"leavesAt": "23:40",
					"arrivesAt": "23:46",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cânepişti h.",
					"to": "Câmpia Turzii",
					"leavesAt": "23:47",
					"arrivesAt": "23:55",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Câmpia Turzii",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "23:56",
					"arrivesAt": "00:04",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Grindeni h.",
					"leavesAt": "00:05",
					"arrivesAt": "00:11",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Grindeni h.",
					"to": "Războieni",
					"leavesAt": "00:12",
					"arrivesAt": "00:16",
					"waitsAtSource": 30,
					"distance": 2800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8387",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:35",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "14:36",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "14:51",
					"arrivesAt": "14:56",
					"waitsAtSource": 480,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "15:04",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "15:12",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Pescăruş h.",
					"leavesAt": "15:16",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Pescăruş h.",
					"to": "Neptun hc.",
					"leavesAt": "15:21",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "15:27",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "15:32",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2081",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "03:10",
					"arrivesAt": "03:13",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "03:14",
					"arrivesAt": "03:17",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "03:18",
					"arrivesAt": "03:21",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "03:22",
					"arrivesAt": "03:25",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "03:26",
					"arrivesAt": "03:29",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "03:30",
					"arrivesAt": "03:33",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "03:34",
					"arrivesAt": "03:38",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "03:39",
					"arrivesAt": "03:44",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "03:45",
					"arrivesAt": "03:47",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "03:48",
					"arrivesAt": "03:54",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Bungeţel h.",
					"leavesAt": "04:10",
					"arrivesAt": "04:13",
					"waitsAtSource": 960,
					"distance": 2300
				},
				{
					"from": "Bungeţel h.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "04:14",
					"arrivesAt": "04:19",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "04:20",
					"arrivesAt": "04:23",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Floreşti hc.",
					"to": "Gilort Hm.",
					"leavesAt": "04:24",
					"arrivesAt": "04:30",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Gilort Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "04:31",
					"arrivesAt": "04:37",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turburea Hm.",
					"to": "Bibeşti Hm.",
					"leavesAt": "04:38",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "04:47",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Musculeşti",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "04:57",
					"arrivesAt": "05:02",
					"waitsAtSource": 300,
					"distance": 5900
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Jupâneşti Hm.",
					"leavesAt": "05:03",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "05:09",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cărbuneşti",
					"to": "Pojogeni Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:24",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Scoarţa h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Scoarţa h.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "05:29",
					"arrivesAt": "05:32",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Budieni h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Budieni h.",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "05:38",
					"arrivesAt": "05:42",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "05:43",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Târgu Jiu",
					"to": "Ramificaţia C.A.M. h.",
					"leavesAt": "05:56",
					"arrivesAt": "05:58",
					"waitsAtSource": 360,
					"distance": 800
				},
				{
					"from": "Ramificaţia C.A.M. h.",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "05:59",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Ezureni h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:12",
					"waitsAtSource": 300,
					"distance": 3800
				},
				{
					"from": "Ezureni h.",
					"to": "Parângu Hm.",
					"leavesAt": "06:13",
					"arrivesAt": "06:17",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Parângu Hm.",
					"to": "Bumbeşti Hm.",
					"leavesAt": "06:18",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bumbeşti Hm.",
					"to": "Valea Sadului Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Meri",
					"leavesAt": "06:31",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Meri",
					"to": "Lainici Hm.",
					"leavesAt": "06:39",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Lainici Hm.",
					"to": "Km. 105+600 h.",
					"leavesAt": "06:49",
					"arrivesAt": "06:55",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Km. 105+600 h.",
					"to": "Pietrele Albe Hm.",
					"leavesAt": "06:56",
					"arrivesAt": "07:01",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pietrele Albe Hm.",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Livezeni",
					"leavesAt": "07:12",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Lunca Jiului hc.",
					"leavesAt": "07:20",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Lunca Jiului hc.",
					"to": "Petroşani",
					"leavesAt": "07:24",
					"arrivesAt": "07:30",
					"waitsAtSource": 30,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9404",
			"segments": [
				{
					"from": "Potcoava",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "06:50",
					"arrivesAt": "06:58",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Recea Hm.",
					"leavesAt": "06:59",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Recea Hm.",
					"to": "Slatina",
					"leavesAt": "07:12",
					"arrivesAt": "07:20",
					"waitsAtSource": 300,
					"distance": 7800
				},
				{
					"from": "Slatina",
					"to": "Milcov Hm.",
					"leavesAt": "07:22",
					"arrivesAt": "07:28",
					"waitsAtSource": 120,
					"distance": 5300
				},
				{
					"from": "Milcov Hm.",
					"to": "Slătioara Hm.",
					"leavesAt": "07:29",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "07:42",
					"arrivesAt": "07:48",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Piatra Olt",
					"to": "Şopârliţa hc.",
					"leavesAt": "08:15",
					"arrivesAt": "08:26",
					"waitsAtSource": 1620,
					"distance": 11100
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Vlăduleni",
					"leavesAt": "08:27",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vlăduleni",
					"to": "Fălcoiu h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Fălcoiu h.",
					"to": "Romula Hm.",
					"leavesAt": "08:39",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Romula Hm.",
					"to": "Caracal",
					"leavesAt": "08:52",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5582",
			"segments": [
				{
					"from": "Botoşani",
					"to": "Leorda Hm.",
					"leavesAt": "11:19",
					"arrivesAt": "11:43",
					"waitsAtSource": 0,
					"distance": 15500
				},
				{
					"from": "Leorda Hm.",
					"to": "Bucecea Hm",
					"leavesAt": "11:44",
					"arrivesAt": "12:03",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bucecea Hm",
					"to": "Vereşti",
					"leavesAt": "12:04",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 19100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2601",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "04:32",
					"arrivesAt": "04:38",
					"waitsAtSource": 0,
					"distance": 4400
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Sânandrei Hm.",
					"leavesAt": "04:39",
					"arrivesAt": "04:49",
					"waitsAtSource": 30,
					"distance": 8900
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Băile Călacea",
					"leavesAt": "04:50",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Călacea",
					"to": "Orţişoara",
					"leavesAt": "04:57",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Orţişoara",
					"to": "Vinga Hm.",
					"leavesAt": "05:03",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "05:12",
					"arrivesAt": "05:18",
					"waitsAtSource": 240,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Aradu Nou",
					"leavesAt": "05:19",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "05:35",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7037",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Carpaţi h.(700)",
					"leavesAt": "19:00",
					"arrivesAt": "19:06",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Pajura Hm. (700)",
					"leavesAt": "19:07",
					"arrivesAt": "19:11",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Chitila",
					"leavesAt": "19:12",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chitila",
					"to": "Mogoşoaia",
					"leavesAt": "19:19",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Mogoşoaia",
					"to": "Odăile h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:48",
					"waitsAtSource": 360,
					"distance": 3900
				},
				{
					"from": "Odăile h.",
					"to": "P.O. Aeroport h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:52",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Baloteşti Hm.",
					"leavesAt": "19:53",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Baloteşti Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "19:57",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Greci h.",
					"leavesAt": "20:10",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Greci h.",
					"to": "Fierbinţi",
					"leavesAt": "20:16",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Fierbinţi",
					"to": "Dridu Hm.",
					"leavesAt": "20:23",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Dridu Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "20:30",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moldoveni h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "20:36",
					"arrivesAt": "20:41",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "20:47",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9533",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Piteşti Nord",
					"leavesAt": "20:40",
					"arrivesAt": "20:48",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Piteşti Nord",
					"to": "C.I.L. h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "C.I.L. h.",
					"to": "Bascov Hm.",
					"leavesAt": "20:53",
					"arrivesAt": "20:55",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Bascov Hm.",
					"to": "Merişani h.",
					"leavesAt": "20:56",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Merişani h.",
					"to": "Băiculeşti h.",
					"leavesAt": "21:06",
					"arrivesAt": "21:17",
					"waitsAtSource": 30,
					"distance": 11300
				},
				{
					"from": "Băiculeşti h.",
					"to": "Curtea de Argeş",
					"leavesAt": "21:18",
					"arrivesAt": "21:29",
					"waitsAtSource": 30,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1812",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Buziaş",
					"leavesAt": "16:00",
					"arrivesAt": "16:37",
					"waitsAtSource": 0,
					"distance": 36400
				},
				{
					"from": "Buziaş",
					"to": "Lugoj",
					"leavesAt": "16:38",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 27500
				},
				{
					"from": "Lugoj",
					"to": "Făget",
					"leavesAt": "17:10",
					"arrivesAt": "17:49",
					"waitsAtSource": 120,
					"distance": 39700
				},
				{
					"from": "Făget",
					"to": "Margina",
					"leavesAt": "17:50",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Margina",
					"to": "Ilia",
					"leavesAt": "18:03",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 35500
				},
				{
					"from": "Ilia",
					"to": "Deva",
					"leavesAt": "18:43",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 23600
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "19:10",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Turdaş Hm.",
					"leavesAt": "19:24",
					"arrivesAt": "19:34",
					"waitsAtSource": 180,
					"distance": 7400
				},
				{
					"from": "Turdaş Hm.",
					"to": "Pricaz h.",
					"leavesAt": "19:35",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Pricaz h.",
					"to": "Orăştie",
					"leavesAt": "19:43",
					"arrivesAt": "19:49",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Orăştie",
					"to": "Aurel Vlaicu",
					"leavesAt": "19:51",
					"arrivesAt": "20:00",
					"waitsAtSource": 120,
					"distance": 6400
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Şibot",
					"leavesAt": "20:01",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Şibot",
					"to": "Blandiana Hm.",
					"leavesAt": "20:10",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Blandiana Hm.",
					"to": "Vinţu de Jos",
					"leavesAt": "20:27",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vinţu de Jos",
					"to": "Sebeş Alba",
					"leavesAt": "20:36",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Sebeş Alba",
					"to": "Cunţa Hm.",
					"leavesAt": "20:48",
					"arrivesAt": "21:07",
					"waitsAtSource": 120,
					"distance": 13000
				},
				{
					"from": "Cunţa Hm.",
					"to": "Miercurea Sibiu Hm.",
					"leavesAt": "21:12",
					"arrivesAt": "21:23",
					"waitsAtSource": 300,
					"distance": 7900
				},
				{
					"from": "Miercurea Sibiu Hm.",
					"to": "Apoldu de Sus Hm.",
					"leavesAt": "21:24",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Apoldu de Sus Hm.",
					"to": "Sălişte Hm.",
					"leavesAt": "21:37",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 13000
				},
				{
					"from": "Sălişte Hm.",
					"to": "Orlat",
					"leavesAt": "21:58",
					"arrivesAt": "22:11",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Orlat",
					"to": "Sibiu",
					"leavesAt": "22:12",
					"arrivesAt": "22:37",
					"waitsAtSource": 60,
					"distance": 19300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1528",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Tălmaciu Hm.",
					"leavesAt": "04:08",
					"arrivesAt": "04:27",
					"waitsAtSource": 0,
					"distance": 17800
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "04:28",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 15400
				},
				{
					"from": "Avrig Hm.",
					"to": "Porumbacu Hm.",
					"leavesAt": "04:47",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Cârţa h.",
					"leavesAt": "04:57",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Cârţa h.",
					"to": "Ucea",
					"leavesAt": "05:09",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Ucea",
					"to": "Făgăraş",
					"leavesAt": "05:21",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Făgăraş",
					"to": "Mândra Oltului h.",
					"leavesAt": "05:46",
					"arrivesAt": "05:52",
					"waitsAtSource": 120,
					"distance": 6100
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Şercaia h.",
					"leavesAt": "05:53",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Şercaia h.",
					"to": "Şercaia Hm.",
					"leavesAt": "06:01",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 1200
				},
				{
					"from": "Şercaia Hm.",
					"to": "Perşani h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Brădet Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:20",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Brădet Hm.",
					"to": "Valea Homorod h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Homorod h.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "06:30",
					"arrivesAt": "06:40",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "06:45",
					"arrivesAt": "06:50",
					"waitsAtSource": 300,
					"distance": 4600
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "06:51",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Codlea Hm.",
					"to": "Ghimbav Hm.",
					"leavesAt": "07:01",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Bartolomeu",
					"leavesAt": "07:08",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "07:16",
					"arrivesAt": "07:22",
					"waitsAtSource": 120,
					"distance": 3100
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "07:40",
					"arrivesAt": "08:18",
					"waitsAtSource": 1080,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "08:20",
					"arrivesAt": "08:29",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "08:31",
					"arrivesAt": "08:37",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "08:38",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Valea Largă Hm.",
					"leavesAt": "08:49",
					"arrivesAt": "08:55",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Comarnic",
					"leavesAt": "08:56",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Comarnic",
					"to": "Câmpina",
					"leavesAt": "09:06",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "09:20",
					"arrivesAt": "09:44",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "09:46",
					"arrivesAt": "10:32",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9011",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Km. 109+000 h.",
					"leavesAt": "04:00",
					"arrivesAt": "04:02",
					"waitsAtSource": 0,
					"distance": 1000
				},
				{
					"from": "Km. 109+000 h.",
					"to": "Bradu de Sus",
					"leavesAt": "04:03",
					"arrivesAt": "04:07",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Bradu de Sus",
					"to": "Pârvu h.",
					"leavesAt": "04:08",
					"arrivesAt": "04:17",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Pârvu h.",
					"to": "Costeşti",
					"leavesAt": "04:18",
					"arrivesAt": "04:30",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Costeşti",
					"to": "Fâlfani Hm.",
					"leavesAt": "04:31",
					"arrivesAt": "04:39",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "04:40",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Stolnici Hm.",
					"to": "Hârseşti Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Corbu",
					"leavesAt": "04:55",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Corbu",
					"to": "Sineşti Hm.",
					"leavesAt": "05:02",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Sineşti Hm.",
					"to": "Potcoava",
					"leavesAt": "05:10",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Potcoava",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Recea Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Recea Hm.",
					"to": "Slatina",
					"leavesAt": "05:38",
					"arrivesAt": "05:48",
					"waitsAtSource": 240,
					"distance": 7800
				},
				{
					"from": "Slatina",
					"to": "Milcov Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "05:57",
					"waitsAtSource": 120,
					"distance": 5300
				},
				{
					"from": "Milcov Hm.",
					"to": "Slătioara Hm.",
					"leavesAt": "06:01",
					"arrivesAt": "06:07",
					"waitsAtSource": 240,
					"distance": 4600
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "06:13",
					"arrivesAt": "06:20",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Piatra Olt",
					"to": "Brăneţ h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:37",
					"waitsAtSource": 600,
					"distance": 7700
				},
				{
					"from": "Brăneţ h.",
					"to": "Canton 217 h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Canton 217 h.",
					"to": "Balş",
					"leavesAt": "06:43",
					"arrivesAt": "06:46",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Balş",
					"to": "Spineni h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Spineni h.",
					"to": "Robăneşti Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "07:00",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Robăneşti Hm.",
					"to": "Toporaş h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Toporaş h.",
					"to": "Pieleşti Hm.",
					"leavesAt": "07:07",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Pieleşti Hm.",
					"to": "Cârcea h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Cârcea h.",
					"to": "Plaiu Vulcăneşti Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:24",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Plaiu Vulcăneşti Hm.",
					"to": "Bordei hc.(901)",
					"leavesAt": "07:31",
					"arrivesAt": "07:34",
					"waitsAtSource": 420,
					"distance": 1900
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Craiova",
					"leavesAt": "07:35",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171225",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20180101",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4307",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:45",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Gherla",
					"leavesAt": "16:46",
					"arrivesAt": "16:57",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "17:15",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "17:25",
					"arrivesAt": "17:30",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Apahida h.",
					"to": "Apahida",
					"leavesAt": "17:38",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "17:44",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "17:48",
					"arrivesAt": "17:55",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "17:56",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "18:02",
					"arrivesAt": "18:07",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7371",
			"segments": [
				{
					"from": "Făurei",
					"to": "Găiseanca h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:22",
					"waitsAtSource": 0,
					"distance": 3900
				},
				{
					"from": "Găiseanca h.",
					"to": "Deduleşti Hm.",
					"leavesAt": "06:23",
					"arrivesAt": "06:30",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Ianca hc.",
					"leavesAt": "06:31",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ianca hc.",
					"to": "Plopu",
					"leavesAt": "06:37",
					"arrivesAt": "06:41",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Plopu",
					"to": "Urleasca Hm.",
					"leavesAt": "06:42",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Urleasca Hm.",
					"to": "Traian Sat Hm.",
					"leavesAt": "06:49",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Lacu Sărat",
					"leavesAt": "06:57",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Lacu Sărat",
					"to": "Brăila",
					"leavesAt": "07:07",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:25",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "07:26",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Zagna Vădeni h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Barboşi",
					"leavesAt": "07:37",
					"arrivesAt": "07:44",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "07:46",
					"arrivesAt": "07:52",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "07:53",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5010",
			"segments": [
				{
					"from": "Buzău",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "15:05",
					"arrivesAt": "15:15",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Ulmeni",
					"leavesAt": "15:16",
					"arrivesAt": "15:22",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "15:23",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "15:29",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "15:40",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "15:49",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "15:58",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "16:04",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "16:10",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "16:14",
					"arrivesAt": "16:21",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "16:22",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "16:30",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Triaj",
					"leavesAt": "16:39",
					"arrivesAt": "16:45",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Brazi",
					"leavesAt": "16:49",
					"arrivesAt": "16:57",
					"waitsAtSource": 240,
					"distance": 5200
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:04",
					"waitsAtSource": 120,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "17:05",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "17:15",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:33",
					"waitsAtSource": 360,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "17:34",
					"arrivesAt": "17:38",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "17:39",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "17:48",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "17:51",
					"arrivesAt": "17:54",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "17:55",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:00",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "18:01",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4336",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Satu Mare Sud",
					"leavesAt": "15:45",
					"arrivesAt": "15:50",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Satu Mare Sud",
					"to": "Sătmărel h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Sătmărel h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Moftin h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Moftin h.",
					"to": "Domăneşti h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:19",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Domăneşti h.",
					"to": "Carei",
					"leavesAt": "16:20",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 9900
				},
				{
					"from": "Carei",
					"to": "Marna h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Marna h.",
					"to": "Sanislău Hm.",
					"leavesAt": "16:38",
					"arrivesAt": "16:43",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Sanislău Hm.",
					"to": "Resighea h.",
					"leavesAt": "16:44",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Resighea h.",
					"to": "Curtuiuşeni h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:56",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Valea lui Mihai",
					"leavesAt": "16:57",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Valea lui Mihai",
					"to": "Simion h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:19",
					"waitsAtSource": 600,
					"distance": 5900
				},
				{
					"from": "Simion h.",
					"to": "Şilindru Hm.",
					"leavesAt": "17:20",
					"arrivesAt": "17:26",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Şilindru Hm.",
					"to": "Săcuieni Bihor",
					"leavesAt": "17:27",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Cadia h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cadia h.",
					"to": "Diosig Hm.",
					"leavesAt": "17:45",
					"arrivesAt": "17:51",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Diosig Hm.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "17:52",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Tămăşeu h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:05",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tămăşeu h.",
					"to": "Biharia Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:14",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Biharia Hm.",
					"to": "Episcopia Bihor",
					"leavesAt": "18:15",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "18:26",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5051",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "04:45",
					"arrivesAt": "04:51",
					"waitsAtSource": 0,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "04:52",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Cricov Hm.",
					"leavesAt": "05:02",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "05:11",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:22",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "05:23",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "05:31",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "05:42",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "05:50",
					"arrivesAt": "05:55",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "05:56",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "06:02",
					"arrivesAt": "06:14",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "06:28",
					"arrivesAt": "06:39",
					"waitsAtSource": 840,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "06:40",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "06:51",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "07:13",
					"arrivesAt": "07:21",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "07:22",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "07:30",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "07:39",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "07:51",
					"arrivesAt": "08:04",
					"waitsAtSource": 120,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "08:05",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 8000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6403",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Zorleni",
					"leavesAt": "13:49",
					"arrivesAt": "13:57",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Zorleni",
					"to": "Banca Hm.",
					"leavesAt": "13:58",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Banca Hm.",
					"to": "Dodeşti hc.",
					"leavesAt": "14:07",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dodeşti hc.",
					"to": "Roşieşti hc.",
					"leavesAt": "14:12",
					"arrivesAt": "14:18",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Roşieşti hc.",
					"to": "Crasna",
					"leavesAt": "14:19",
					"arrivesAt": "14:27",
					"waitsAtSource": 30,
					"distance": 8900
				},
				{
					"from": "Crasna",
					"to": "Bulboaca h.",
					"leavesAt": "14:28",
					"arrivesAt": "14:36",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Bulboaca h.",
					"to": "Munteni Hm.",
					"leavesAt": "14:37",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Munteni Hm.",
					"to": "Vaslui",
					"leavesAt": "14:44",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vaslui",
					"to": "Bălteni Hm.",
					"leavesAt": "14:51",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Bălteni Hm.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "15:08",
					"arrivesAt": "15:12",
					"waitsAtSource": 420,
					"distance": 4200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bârzeşti h.",
					"leavesAt": "15:13",
					"arrivesAt": "15:17",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bârzeşti h.",
					"to": "Buhăieşti",
					"leavesAt": "15:18",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Buhăieşti",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Rebricea Hm.",
					"leavesAt": "15:31",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Rebricea Hm.",
					"to": "Scânteia Hm.",
					"leavesAt": "15:38",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Scânteia Hm.",
					"to": "Grajduri",
					"leavesAt": "15:45",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Grajduri",
					"to": "Bârnova Hm.",
					"leavesAt": "15:55",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Ciurea Hm.",
					"leavesAt": "16:11",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ciurea Hm.",
					"to": "Nicolina",
					"leavesAt": "16:18",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "16:25",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7568",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "07:36",
					"arrivesAt": "07:50",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "07:51",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Barboşi Triaj h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Barboşi Triaj h.",
					"to": "Şendreni Hm.",
					"leavesAt": "08:03",
					"arrivesAt": "08:07",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Şendreni Hm.",
					"to": "Şerbeştii Vechi h.",
					"leavesAt": "08:08",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Şerbeştii Vechi h.",
					"to": "Braniştea h.",
					"leavesAt": "08:13",
					"arrivesAt": "08:17",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Braniştea h.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Independenţa Hm.",
					"leavesAt": "08:22",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Independenţa Hm.",
					"to": "Piscu h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Piscu h.",
					"to": "Vameş h.",
					"leavesAt": "08:35",
					"arrivesAt": "08:39",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Vameş h.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "08:40",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "08:47",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Şerbăneşti h.",
					"leavesAt": "08:53",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Lieşti",
					"leavesAt": "08:59",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lieşti",
					"to": "Buceşti h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Buceşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "09:09",
					"arrivesAt": "09:13",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Iveşti Hm.",
					"to": "Umbrăreşti h.",
					"leavesAt": "09:14",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Barcea",
					"leavesAt": "09:20",
					"arrivesAt": "09:26",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Barcea",
					"to": "Malul Alb h.",
					"leavesAt": "09:27",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Malul Alb h.",
					"to": "Tecuci",
					"leavesAt": "09:31",
					"arrivesAt": "09:41",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Tecuci",
					"to": "Cosmeşti Hm.",
					"leavesAt": "09:44",
					"arrivesAt": "09:51",
					"waitsAtSource": 180,
					"distance": 7400
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "09:52",
					"arrivesAt": "09:57",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "09:58",
					"arrivesAt": "10:09",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2074",
			"segments": [
				{
					"from": "Lotru",
					"to": "Cozia Hm.",
					"leavesAt": "05:55",
					"arrivesAt": "06:04",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Cozia Hm.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Păuşa h.",
					"leavesAt": "06:11",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "06:16",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Dăeşti Hm.",
					"leavesAt": "06:22",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "06:30",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "06:39",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "06:45",
					"arrivesAt": "06:48",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Ostroveni h.",
					"leavesAt": "06:55",
					"arrivesAt": "06:57",
					"waitsAtSource": 420,
					"distance": 1000
				},
				{
					"from": "Ostroveni h.",
					"to": "Răstoaca h.",
					"leavesAt": "06:58",
					"arrivesAt": "07:02",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Răstoaca h.",
					"to": "Râureni",
					"leavesAt": "07:03",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Râureni",
					"to": "Râureni hc.",
					"leavesAt": "07:06",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni hc.",
					"to": "Govora",
					"leavesAt": "07:11",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Govora",
					"to": "Tătărani h.",
					"leavesAt": "07:17",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Tătărani h.",
					"to": "Băbeni",
					"leavesAt": "07:23",
					"arrivesAt": "07:30",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Băbeni",
					"to": "Slăviteşti hc.",
					"leavesAt": "07:31",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Ioneşti Hm.",
					"leavesAt": "07:37",
					"arrivesAt": "07:44",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Fişcălia Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "07:55",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Orleşti hc.",
					"to": "Zăvideni Hm.",
					"leavesAt": "07:59",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Călina h.",
					"leavesAt": "08:05",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Călina h.",
					"to": "Drăgăşani",
					"leavesAt": "08:10",
					"arrivesAt": "08:18",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Drăgăşani",
					"to": "Zlătărei Hm.",
					"leavesAt": "08:19",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Strejeşti",
					"leavesAt": "08:27",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Strejeşti",
					"to": "Arceşti Hm.",
					"leavesAt": "08:34",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 11600
				},
				{
					"from": "Arceşti Hm.",
					"to": "Găneasa h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:54",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Găneasa h.",
					"to": "Piatra Olt",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5306",
			"segments": [
				{
					"from": "Comăneşti",
					"to": "Valea Uzului Hm.",
					"leavesAt": "12:52",
					"arrivesAt": "13:00",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "13:01",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Dofteana Bacău",
					"leavesAt": "13:04",
					"arrivesAt": "13:09",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Dofteana Bacău",
					"to": "Cireşoaia h.",
					"leavesAt": "13:10",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cireşoaia h.",
					"to": "Saline hc.",
					"leavesAt": "13:15",
					"arrivesAt": "13:20",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Saline hc.",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "13:21",
					"arrivesAt": "13:23",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Viişoara h",
					"leavesAt": "13:24",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Viişoara h",
					"to": "Trotuş h.",
					"leavesAt": "13:29",
					"arrivesAt": "13:32",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Trotuş h.",
					"to": "Oneşti",
					"leavesAt": "13:33",
					"arrivesAt": "13:42",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Oneşti",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "14:10",
					"arrivesAt": "14:13",
					"waitsAtSource": 1680,
					"distance": 3400
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Borzeşti Bacău",
					"leavesAt": "14:14",
					"arrivesAt": "14:21",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Căiuţi Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:28",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Bâlca hc.",
					"leavesAt": "14:29",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Bâlca hc.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:38",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Urecheşti Hm.",
					"leavesAt": "14:39",
					"arrivesAt": "14:43",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Adjud",
					"leavesAt": "14:44",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "15:03",
					"arrivesAt": "15:10",
					"waitsAtSource": 420,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "15:11",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "15:16",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:26",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "15:27",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1633",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "15:10",
					"arrivesAt": "15:47",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "15:48",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "16:11",
					"arrivesAt": "16:33",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "16:34",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Predeal",
					"leavesAt": "16:42",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 11400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "16:57",
					"arrivesAt": "17:35",
					"waitsAtSource": 120,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9507",
			"segments": [
				{
					"from": "Filiaşi",
					"to": "Gura Motrului Hm.",
					"leavesAt": "17:32",
					"arrivesAt": "17:40",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Butoieşti Hm.",
					"leavesAt": "17:41",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Lunca Banului h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lunca Banului h.",
					"to": "Strehaia",
					"leavesAt": "17:56",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Strehaia",
					"to": "Strehaia hc.",
					"leavesAt": "18:03",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Strehaia hc.",
					"to": "Ciochiuţa Hm.",
					"leavesAt": "18:08",
					"arrivesAt": "18:16",
					"waitsAtSource": 120,
					"distance": 5700
				},
				{
					"from": "Ciochiuţa Hm.",
					"to": "Tâmna",
					"leavesAt": "18:20",
					"arrivesAt": "18:29",
					"waitsAtSource": 240,
					"distance": 7000
				},
				{
					"from": "Tâmna",
					"to": "Igiroasa Hm.",
					"leavesAt": "18:30",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Igiroasa Hm.",
					"to": "Prunişor Hm.",
					"leavesAt": "18:43",
					"arrivesAt": "18:50",
					"waitsAtSource": 360,
					"distance": 4800
				},
				{
					"from": "Prunişor Hm.",
					"to": "Gârniţa Hm.",
					"leavesAt": "18:51",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Gârniţa Hm.",
					"to": "Balota",
					"leavesAt": "18:59",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Balota",
					"to": "Valea Albă Hm.",
					"leavesAt": "19:04",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Valea Albă Hm.",
					"to": "Ergheviţa h.",
					"leavesAt": "19:16",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ergheviţa h.",
					"to": "Drobeta Tr. Severin Mf.",
					"leavesAt": "19:22",
					"arrivesAt": "19:32",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Drobeta Tr. Severin Mf.",
					"to": "Drobeta Tr.Sev Est Hm.",
					"leavesAt": "19:33",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Drobeta Tr.Sev Est Hm.",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "19:40",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5424",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "14:40",
					"arrivesAt": "14:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "14:55",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "15:03",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "15:10",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "15:18",
					"arrivesAt": "15:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "15:28",
					"arrivesAt": "15:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "15:35",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "15:40",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "15:50",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "16:28",
					"arrivesAt": "16:35",
					"waitsAtSource": 1440,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "16:36",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "16:42",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "16:47",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "16:53",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "16:58",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "17:05",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "17:26",
					"arrivesAt": "17:33",
					"waitsAtSource": 720,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "17:34",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "17:39",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "17:54",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "18:00",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2516",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Atelier Zona h.",
					"leavesAt": "23:35",
					"arrivesAt": "23:38",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "23:39",
					"arrivesAt": "23:41",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Mohu h.",
					"leavesAt": "23:42",
					"arrivesAt": "23:48",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mohu h.",
					"to": "Veştem h.",
					"leavesAt": "23:49",
					"arrivesAt": "23:52",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Veştem h.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "23:53",
					"arrivesAt": "00:02",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "00:03",
					"arrivesAt": "00:10",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Sebeş Olt h.",
					"leavesAt": "00:11",
					"arrivesAt": "00:14",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Racoviţa h.",
					"leavesAt": "00:15",
					"arrivesAt": "00:18",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Racoviţa h.",
					"to": "Mârşa h.",
					"leavesAt": "00:19",
					"arrivesAt": "00:22",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Mârşa h.",
					"to": "Avrig Hm.",
					"leavesAt": "00:23",
					"arrivesAt": "00:28",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Avrig Hm.",
					"to": "Porumbacu Hm.",
					"leavesAt": "00:29",
					"arrivesAt": "00:38",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Sărata Colun h.",
					"leavesAt": "00:39",
					"arrivesAt": "00:43",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sărata Colun h.",
					"to": "Scoreiu h.",
					"leavesAt": "00:44",
					"arrivesAt": "00:47",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Scoreiu h.",
					"to": "Cârţa h.",
					"leavesAt": "00:48",
					"arrivesAt": "00:53",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârţa h.",
					"to": "Arpaş Hm.",
					"leavesAt": "00:54",
					"arrivesAt": "00:58",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Arpaş Hm.",
					"to": "Ucea",
					"leavesAt": "00:59",
					"arrivesAt": "01:06",
					"waitsAtSource": 60,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9004",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Atârnaţi Hm.",
					"leavesAt": "07:00",
					"arrivesAt": "07:08",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "07:09",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Vârtoapele hc.",
					"leavesAt": "07:17",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Olteni",
					"leavesAt": "07:23",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "07:33",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Ciolpani Hm.",
					"leavesAt": "07:42",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Videle",
					"leavesAt": "07:49",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Videle",
					"to": "Zăvestreni Hm.",
					"leavesAt": "08:00",
					"arrivesAt": "08:05",
					"waitsAtSource": 120,
					"distance": 4800
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "08:06",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "08:11",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Grădinari",
					"leavesAt": "08:20",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Grădinari",
					"to": "Domneştii de Sus h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:43",
					"waitsAtSource": 300,
					"distance": 6000
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Chiajna",
					"leavesAt": "08:44",
					"arrivesAt": "09:00",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Chiajna",
					"to": "Bucureştii Noi",
					"leavesAt": "09:09",
					"arrivesAt": "09:12",
					"waitsAtSource": 540,
					"distance": 3200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Bucureşti Basarab",
					"leavesAt": "09:13",
					"arrivesAt": "09:21",
					"waitsAtSource": 60,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 448
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5735",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "08:28",
					"arrivesAt": "08:33",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava Nord",
					"to": "Dărmăneşti",
					"leavesAt": "08:34",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dărmăneşti",
					"to": "Părhăuţi h.",
					"leavesAt": "08:49",
					"arrivesAt": "08:56",
					"waitsAtSource": 360,
					"distance": 4400
				},
				{
					"from": "Părhăuţi h.",
					"to": "Todireşti h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Todireşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:13",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Soloneţ h.",
					"to": "Pârteşti h.",
					"leavesAt": "09:14",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Pârteşti h.",
					"to": "Cacica Hm.",
					"leavesAt": "09:21",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1932",
			"segments": [
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "19:12",
					"arrivesAt": "19:46",
					"waitsAtSource": 0,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Bratca",
					"leavesAt": "19:47",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 25300
				},
				{
					"from": "Bratca",
					"to": "Ciucea Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Ciucea Hm.",
					"to": "Huedin",
					"leavesAt": "20:38",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Huedin",
					"to": "Aghireş",
					"leavesAt": "21:00",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Aghireş",
					"to": "Cluj Napoca",
					"leavesAt": "21:25",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 27900
				},
				{
					"from": "Cluj Napoca",
					"to": "Câmpia Turzii",
					"leavesAt": "22:09",
					"arrivesAt": "23:16",
					"waitsAtSource": 960,
					"distance": 51500
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "23:17",
					"arrivesAt": "23:33",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Aiud Hm.",
					"leavesAt": "23:34",
					"arrivesAt": "23:56",
					"waitsAtSource": 60,
					"distance": 20400
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "23:57",
					"arrivesAt": "00:11",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Blaj",
					"leavesAt": "00:15",
					"arrivesAt": "00:46",
					"waitsAtSource": 240,
					"distance": 21300
				},
				{
					"from": "Blaj",
					"to": "Copşa Mică",
					"leavesAt": "00:48",
					"arrivesAt": "01:27",
					"waitsAtSource": 120,
					"distance": 30000
				},
				{
					"from": "Copşa Mică",
					"to": "Mediaş",
					"leavesAt": "01:33",
					"arrivesAt": "01:47",
					"waitsAtSource": 360,
					"distance": 10400
				},
				{
					"from": "Mediaş",
					"to": "Dumbrăveni",
					"leavesAt": "01:48",
					"arrivesAt": "02:14",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Dumbrăveni",
					"to": "Sighişoara",
					"leavesAt": "02:15",
					"arrivesAt": "02:42",
					"waitsAtSource": 60,
					"distance": 20400
				},
				{
					"from": "Sighişoara",
					"to": "Rupea",
					"leavesAt": "02:46",
					"arrivesAt": "03:49",
					"waitsAtSource": 240,
					"distance": 53600
				},
				{
					"from": "Rupea",
					"to": "Braşov",
					"leavesAt": "03:50",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 73800
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "05:45",
					"arrivesAt": "06:23",
					"waitsAtSource": 840,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "06:31",
					"arrivesAt": "06:40",
					"waitsAtSource": 480,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "06:41",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "06:48",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Comarnic",
					"leavesAt": "06:59",
					"arrivesAt": "07:13",
					"waitsAtSource": 120,
					"distance": 15100
				},
				{
					"from": "Comarnic",
					"to": "Câmpina",
					"leavesAt": "07:14",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "07:26",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Băneasa",
					"leavesAt": "07:52",
					"arrivesAt": "08:38",
					"waitsAtSource": 120,
					"distance": 58100
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Feteşti",
					"leavesAt": "08:41",
					"arrivesAt": "09:53",
					"waitsAtSource": 180,
					"distance": 139800
				},
				{
					"from": "Feteşti",
					"to": "Medgidia",
					"leavesAt": "09:54",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 44000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "10:29",
					"arrivesAt": "11:01",
					"waitsAtSource": 60,
					"distance": 36000
				},
				{
					"from": "Constanţa",
					"to": "Eforie Nord",
					"leavesAt": "11:25",
					"arrivesAt": "11:48",
					"waitsAtSource": 1440,
					"distance": 14000
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "11:50",
					"arrivesAt": "11:57",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "12:07",
					"arrivesAt": "12:16",
					"waitsAtSource": 600,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "12:17",
					"arrivesAt": "12:25",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "12:27",
					"arrivesAt": "12:31",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "12:33",
					"arrivesAt": "12:46",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "12:48",
					"arrivesAt": "12:53",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "13:01",
					"arrivesAt": "13:08",
					"waitsAtSource": 480,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8021",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "06:30",
					"arrivesAt": "06:39",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "06:40",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Pasărea",
					"leavesAt": "06:46",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pasărea",
					"to": "Brăneşti Sat h.",
					"leavesAt": "06:52",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "06:57",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Islaz h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Islaz h.",
					"to": "Fundulea Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 9800
				},
				{
					"from": "Fundulea Hm.",
					"to": "Mostiştea h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Mostiştea h.",
					"to": "Săruleşti",
					"leavesAt": "07:17",
					"arrivesAt": "07:22",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Săruleşti",
					"to": "Preasna h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:35",
					"waitsAtSource": 480,
					"distance": 7500
				},
				{
					"from": "Preasna h.",
					"to": "Lehliu",
					"leavesAt": "07:36",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Lehliu",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "07:51",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dâlga h.",
					"leavesAt": "07:55",
					"arrivesAt": "08:00",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dâlga h.",
					"to": "Bogdana h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Bogdana h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "08:08",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Ciulniţa",
					"leavesAt": "08:22",
					"arrivesAt": "08:31",
					"waitsAtSource": 600,
					"distance": 13100
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "08:39",
					"arrivesAt": "08:42",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "08:43",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "08:47",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "09:02",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "09:12",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Ovidiu",
					"leavesAt": "09:19",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ovidiu",
					"to": "Dunărea Hm.",
					"leavesAt": "09:24",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Dunărea Hm.",
					"to": "Cernavodă Pod",
					"leavesAt": "09:37",
					"arrivesAt": "09:46",
					"waitsAtSource": 420,
					"distance": 4800
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "09:47",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "09:56",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "10:02",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "10:11",
					"arrivesAt": "10:15",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "10:16",
					"arrivesAt": "10:19",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "10:20",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "10:25",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "10:30",
					"arrivesAt": "10:33",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "10:34",
					"arrivesAt": "10:38",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "10:53",
					"arrivesAt": "10:58",
					"waitsAtSource": 900,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "10:59",
					"arrivesAt": "11:08",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4521",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "10:36",
					"arrivesAt": "10:45",
					"waitsAtSource": 0,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1635",
			"segments": [
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "17:15",
					"arrivesAt": "17:50",
					"waitsAtSource": 0,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "17:52",
					"arrivesAt": "18:01",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "18:02",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "18:09",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "18:20",
					"arrivesAt": "18:44",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "18:45",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "19:11",
					"arrivesAt": "19:53",
					"waitsAtSource": 120,
					"distance": 58900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Lehliu",
					"leavesAt": "20:15",
					"arrivesAt": "20:54",
					"waitsAtSource": 1320,
					"distance": 69600
				},
				{
					"from": "Lehliu",
					"to": "Ciulniţa",
					"leavesAt": "20:55",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 39300
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "21:14",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "21:38",
					"arrivesAt": "21:56",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "21:57",
					"arrivesAt": "22:13",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "22:14",
					"arrivesAt": "22:37",
					"waitsAtSource": 60,
					"distance": 34600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1858",
			"segments": [
				{
					"from": "Piatra Neamţ",
					"to": "Roznov",
					"leavesAt": "09:10",
					"arrivesAt": "09:26",
					"waitsAtSource": 0,
					"distance": 15200
				},
				{
					"from": "Roznov",
					"to": "Podoleni Hm.",
					"leavesAt": "09:27",
					"arrivesAt": "09:39",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Podoleni Hm.",
					"to": "Buhuşi",
					"leavesAt": "09:40",
					"arrivesAt": "09:54",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Buhuşi",
					"to": "Bacău",
					"leavesAt": "09:55",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 23600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3550",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "19:49",
					"arrivesAt": "19:56",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Vânători",
					"leavesAt": "19:57",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Vânători",
					"to": "Săcuienii Noi h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Săcuienii Noi h.",
					"to": "Sântămaria h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:17",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Sântămaria h.",
					"to": "Cristur Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Cristur Hm.",
					"to": "Beteşti h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:32",
					"waitsAtSource": 420,
					"distance": 1300
				},
				{
					"from": "Beteşti h.",
					"to": "Beteşti Est h.",
					"leavesAt": "20:33",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Beteşti Est h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "20:37",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "20:43",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Lutiţa h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Lutiţa h.",
					"to": "Dobeni h.",
					"leavesAt": "20:55",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Feliceni h.",
					"leavesAt": "21:01",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Feliceni h.",
					"to": "Odorhei Sud hc.",
					"leavesAt": "21:06",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Odorhei",
					"leavesAt": "21:16",
					"arrivesAt": "21:20",
					"waitsAtSource": 120,
					"distance": 1200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2860",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Amaradia",
					"leavesAt": "08:10",
					"arrivesAt": "08:17",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Amaradia",
					"to": "Drăguţeşti h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "08:23",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Vârţ h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:38",
					"waitsAtSource": 420,
					"distance": 4100
				},
				{
					"from": "Vârţ h.",
					"to": "Rogojelu",
					"leavesAt": "08:39",
					"arrivesAt": "08:43",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Rogojelu",
					"to": "Km. 49+800 h.",
					"leavesAt": "08:44",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rovinari Hm.",
					"leavesAt": "08:47",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Rovinari Hm.",
					"to": "Rovinari Sud h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Roşia Jiu h.",
					"leavesAt": "08:54",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Roşia Jiu h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Bâlteni h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:05",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Bâlteni h.",
					"to": "Peşteana Jiu h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:09",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Plopşoru",
					"leavesAt": "09:10",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Plopşoru",
					"to": "Sărdăneşti h.",
					"leavesAt": "09:19",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Gârbovu h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:28",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Gârbovu h.",
					"to": "Turceni",
					"leavesAt": "09:29",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Turceni",
					"to": "Termo Turceni h.",
					"leavesAt": "09:38",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 900
				},
				{
					"from": "Termo Turceni h.",
					"to": "Km. 9+820 h.",
					"leavesAt": "09:41",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Km. 9+820 h.",
					"to": "Ioneşti Gorj h.",
					"leavesAt": "09:45",
					"arrivesAt": "09:48",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Ioneşti Gorj h.",
					"to": "Filiaşi",
					"leavesAt": "09:49",
					"arrivesAt": "10:04",
					"waitsAtSource": 30,
					"distance": 12400
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "10:22",
					"arrivesAt": "10:25",
					"waitsAtSource": 1080,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "10:26",
					"arrivesAt": "10:30",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "10:31",
					"arrivesAt": "10:35",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "10:36",
					"arrivesAt": "10:41",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "10:42",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "10:46",
					"arrivesAt": "10:51",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "10:52",
					"arrivesAt": "10:54",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "10:55",
					"arrivesAt": "10:59",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "11:00",
					"arrivesAt": "11:03",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "11:04",
					"arrivesAt": "11:08",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180203",
					"to": "20180211",
					"daysOfWeek": 319
				},
				{
					"from": "20180331",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180616",
					"to": "20180909",
					"daysOfWeek": 319
				},
				{
					"from": "20171223",
					"to": "20171223",
					"daysOfWeek": 319
				},
				{
					"from": "20171225",
					"to": "20180114",
					"daysOfWeek": 319
				},
				{
					"from": "18991230",
					"to": "20180618",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3501",
			"segments": [
				{
					"from": "Braşov",
					"to": "Stupini Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:19",
					"waitsAtSource": 0,
					"distance": 5400
				},
				{
					"from": "Stupini Hm.",
					"to": "Bod Hm.",
					"leavesAt": "06:20",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Bod Hm.",
					"to": "Feldioara Hm.",
					"leavesAt": "06:29",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Rotbav h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Rotbav h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "06:44",
					"arrivesAt": "06:48",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Măieruş h.",
					"leavesAt": "06:49",
					"arrivesAt": "06:52",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Măieruş h.",
					"to": "Apaţa",
					"leavesAt": "06:53",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Apaţa",
					"to": "Ormeniş h.",
					"leavesAt": "07:06",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ormeniş h.",
					"to": "Augustin Hm.",
					"leavesAt": "07:13",
					"arrivesAt": "07:26",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Augustin Hm.",
					"to": "Racoş Hm.",
					"leavesAt": "07:27",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Racoş Hm.",
					"to": "Mateiaş h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mateiaş h.",
					"to": "Rupea",
					"leavesAt": "07:49",
					"arrivesAt": "08:03",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Rupea",
					"to": "Caţa Hm.",
					"leavesAt": "08:04",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Caţa Hm.",
					"to": "Paloş Ardeal h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Paloş Ardeal h.",
					"to": "Beia Hm.",
					"leavesAt": "08:19",
					"arrivesAt": "08:30",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Beia Hm.",
					"to": "Archita h",
					"leavesAt": "08:31",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Archita h",
					"to": "Mureni Hm.",
					"leavesAt": "08:43",
					"arrivesAt": "08:57",
					"waitsAtSource": 30,
					"distance": 9600
				},
				{
					"from": "Mureni Hm.",
					"to": "Saschiz h.",
					"leavesAt": "08:58",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Saschiz h.",
					"to": "Vânători",
					"leavesAt": "09:03",
					"arrivesAt": "09:07",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vânători",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "09:08",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Sighişoara",
					"leavesAt": "09:16",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Sighişoara",
					"to": "Daneş Hm.",
					"leavesAt": "09:36",
					"arrivesAt": "09:52",
					"waitsAtSource": 660,
					"distance": 9500
				},
				{
					"from": "Daneş Hm.",
					"to": "Luna h.",
					"leavesAt": "09:53",
					"arrivesAt": "10:00",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Luna h.",
					"to": "Dumbrăveni",
					"leavesAt": "10:01",
					"arrivesAt": "10:08",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Dumbrăveni",
					"to": "Aţel Hm.",
					"leavesAt": "10:09",
					"arrivesAt": "10:18",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Aţel Hm.",
					"to": "Bratei h.",
					"leavesAt": "10:19",
					"arrivesAt": "10:28",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Bratei h.",
					"to": "Mediaş",
					"leavesAt": "10:29",
					"arrivesAt": "10:38",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4583",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "13:44",
					"arrivesAt": "13:48",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "13:49",
					"arrivesAt": "13:54",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "13:55",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "14:01",
					"arrivesAt": "14:03",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "14:04",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "14:09",
					"arrivesAt": "14:13",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "14:14",
					"arrivesAt": "14:21",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180212",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180608",
					"daysOfWeek": 799
				},
				{
					"from": "20180611",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180701",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180811",
					"to": "20180811",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1970",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Barboşi",
					"leavesAt": "05:30",
					"arrivesAt": "05:49",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Barboşi",
					"to": "Brăila",
					"leavesAt": "05:50",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 19500
				},
				{
					"from": "Brăila",
					"to": "Ianca hc.",
					"leavesAt": "06:10",
					"arrivesAt": "06:40",
					"waitsAtSource": 180,
					"distance": 42400
				},
				{
					"from": "Ianca hc.",
					"to": "Ţăndărei",
					"leavesAt": "06:41",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 72100
				},
				{
					"from": "Ţăndărei",
					"to": "Movila Hm.",
					"leavesAt": "07:35",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Movila Hm.",
					"to": "Feteşti",
					"leavesAt": "07:49",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 16700
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "08:20",
					"arrivesAt": "08:38",
					"waitsAtSource": 840,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "08:39",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "08:57",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 34600
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3530",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "04:20",
					"arrivesAt": "04:27",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Vânători",
					"leavesAt": "04:28",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Vânători",
					"to": "Saschiz h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Saschiz h.",
					"to": "Mureni Hm.",
					"leavesAt": "04:41",
					"arrivesAt": "04:46",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mureni Hm.",
					"to": "Archita h",
					"leavesAt": "04:47",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Archita h",
					"to": "Beia Hm.",
					"leavesAt": "05:01",
					"arrivesAt": "05:16",
					"waitsAtSource": 30,
					"distance": 8700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2412",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Coşlariu",
					"leavesAt": "01:52",
					"arrivesAt": "02:00",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Coşlariu",
					"to": "Sântimbru h.",
					"leavesAt": "02:01",
					"arrivesAt": "02:11",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sântimbru h.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "02:12",
					"arrivesAt": "02:16",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "02:20",
					"arrivesAt": "02:27",
					"waitsAtSource": 240,
					"distance": 4800
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "02:33",
					"arrivesAt": "02:42",
					"waitsAtSource": 360,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "02:45",
					"arrivesAt": "02:57",
					"waitsAtSource": 180,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Sebeş Glod h.",
					"leavesAt": "03:25",
					"arrivesAt": "03:32",
					"waitsAtSource": 1680,
					"distance": 6500
				},
				{
					"from": "Sebeş Glod h.",
					"to": "Sebeş Alba",
					"leavesAt": "03:33",
					"arrivesAt": "03:37",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sebeş Alba",
					"to": "Rahău h.",
					"leavesAt": "03:38",
					"arrivesAt": "03:46",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Rahău h.",
					"to": "Cut h.",
					"leavesAt": "03:47",
					"arrivesAt": "03:51",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cut h.",
					"to": "Cunţa Hm.",
					"leavesAt": "03:52",
					"arrivesAt": "03:59",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Cunţa Hm.",
					"to": "Băile Miercurea h.",
					"leavesAt": "04:00",
					"arrivesAt": "04:03",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Băile Miercurea h.",
					"to": "Miercurea Sibiu Hm.",
					"leavesAt": "04:04",
					"arrivesAt": "04:13",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Miercurea Sibiu Hm.",
					"to": "Apoldu de Jos h.",
					"leavesAt": "04:14",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Apoldu de Jos h.",
					"to": "Apoldu de Sus Hm.",
					"leavesAt": "04:19",
					"arrivesAt": "04:28",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Apoldu de Sus Hm.",
					"to": "Tilişca h.",
					"leavesAt": "04:33",
					"arrivesAt": "04:45",
					"waitsAtSource": 300,
					"distance": 7800
				},
				{
					"from": "Tilişca h.",
					"to": "Aciliu h.",
					"leavesAt": "04:46",
					"arrivesAt": "04:51",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Aciliu h.",
					"to": "Sălişte Hm.",
					"leavesAt": "04:52",
					"arrivesAt": "04:56",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Sălişte Hm.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "04:57",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sibiel h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:06",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sibiel h.",
					"to": "Orlat",
					"leavesAt": "05:07",
					"arrivesAt": "05:13",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Orlat",
					"to": "Cristian Sibiu h.",
					"leavesAt": "05:14",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Turnişor Hm.",
					"leavesAt": "05:20",
					"arrivesAt": "05:34",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Sibiu h.(210)",
					"leavesAt": "05:35",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Sibiu",
					"leavesAt": "05:39",
					"arrivesAt": "05:44",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9121",
			"segments": [
				{
					"from": "Goleşti",
					"to": "Ştefăneşti Argeş Hm.",
					"leavesAt": "11:35",
					"arrivesAt": "11:45",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Ştefăneşti Argeş Hm.",
					"to": "Gropeni h.",
					"leavesAt": "11:46",
					"arrivesAt": "11:50",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gropeni h.",
					"to": "Ciumeşti",
					"leavesAt": "11:51",
					"arrivesAt": "11:57",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Ciumeşti",
					"to": "Clucereasa h.",
					"leavesAt": "11:58",
					"arrivesAt": "12:09",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Clucereasa h.",
					"to": "Stâlpeni Hm.",
					"leavesAt": "12:10",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Stâlpeni Hm.",
					"to": "Drăghici h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:31",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Drăghici h.",
					"to": "Lăzăreşti Hm.",
					"leavesAt": "12:32",
					"arrivesAt": "12:39",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Lăzăreşti Hm.",
					"to": "Schitu Goleşti",
					"leavesAt": "12:40",
					"arrivesAt": "12:48",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Schitu Goleşti",
					"to": "Câmpulung",
					"leavesAt": "12:49",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Câmpulung",
					"to": "Parcul Kreţulescu h.",
					"leavesAt": "13:02",
					"arrivesAt": "13:05",
					"waitsAtSource": 60,
					"distance": 1900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2595",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(203)",
					"leavesAt": "14:21",
					"arrivesAt": "14:25",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "14:26",
					"arrivesAt": "14:36",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "14:37",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Mândra h.",
					"leavesAt": "14:42",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mândra h.",
					"to": "Loamneş Hm.",
					"leavesAt": "14:50",
					"arrivesAt": "14:56",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Loamneş Hm.",
					"to": "Hăşag h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Hăşag h.",
					"to": "Veşeud h.",
					"leavesAt": "15:03",
					"arrivesAt": "15:08",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Veşeud h.",
					"to": "Şeica Mare h.",
					"leavesAt": "15:09",
					"arrivesAt": "15:14",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Şeica Mare h.",
					"to": "Şeica Mare",
					"leavesAt": "15:15",
					"arrivesAt": "15:18",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Şeica Mare",
					"to": "Agârbiciu h.",
					"leavesAt": "15:19",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Agârbiciu h.",
					"to": "Axente Sever h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Axente Sever h.",
					"to": "Copşa Mică",
					"leavesAt": "15:32",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180203",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "18991230",
					"to": "20180717",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3542",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "03:52",
					"arrivesAt": "03:59",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Vânători",
					"leavesAt": "04:00",
					"arrivesAt": "04:07",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Vânători",
					"to": "Săcuienii Noi h.",
					"leavesAt": "04:08",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Săcuienii Noi h.",
					"to": "Sântămaria h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:20",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Sântămaria h.",
					"to": "Cristur Hm.",
					"leavesAt": "04:21",
					"arrivesAt": "04:25",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Cristur Hm.",
					"to": "Beteşti h.",
					"leavesAt": "04:32",
					"arrivesAt": "04:35",
					"waitsAtSource": 420,
					"distance": 1300
				},
				{
					"from": "Beteşti h.",
					"to": "Beteşti Est h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:39",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Beteşti Est h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "04:40",
					"arrivesAt": "04:45",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "04:46",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Lutiţa h.",
					"leavesAt": "04:52",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Lutiţa h.",
					"to": "Dobeni h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Feliceni h.",
					"leavesAt": "05:04",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Feliceni h.",
					"to": "Odorhei Sud hc.",
					"leavesAt": "05:09",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Odorhei",
					"leavesAt": "05:19",
					"arrivesAt": "05:23",
					"waitsAtSource": 120,
					"distance": 1200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1929",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "14:00",
					"arrivesAt": "14:24",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "14:25",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "14:43",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "15:04",
					"arrivesAt": "15:27",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "15:28",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 108900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "16:43",
					"arrivesAt": "16:58",
					"waitsAtSource": 1140,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Crivina",
					"leavesAt": "16:59",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 22800
				},
				{
					"from": "Crivina",
					"to": "Ploieşti Vest",
					"leavesAt": "17:16",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 19200
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "17:33",
					"arrivesAt": "17:56",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "17:57",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Comarnic",
					"leavesAt": "18:02",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 9000
				},
				{
					"from": "Comarnic",
					"to": "Sinaia",
					"leavesAt": "18:10",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 15100
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "18:24",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "18:32",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "18:38",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "18:48",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "19:37",
					"arrivesAt": "19:43",
					"waitsAtSource": 720,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Ghimbav Hm.",
					"leavesAt": "19:44",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "19:52",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Codlea Hm.",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "19:59",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "20:09",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Valea Homorod h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Valea Homorod h.",
					"to": "Brădet Hm.",
					"leavesAt": "20:22",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Brădet Hm.",
					"to": "Perşani h.",
					"leavesAt": "20:31",
					"arrivesAt": "20:39",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Şercaia Hm.",
					"leavesAt": "20:40",
					"arrivesAt": "20:49",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Şercaia Hm.",
					"to": "Şercaia h.",
					"leavesAt": "20:50",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 1200
				},
				{
					"from": "Şercaia h.",
					"to": "Mândra Oltului h.",
					"leavesAt": "20:53",
					"arrivesAt": "21:00",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Făgăraş",
					"leavesAt": "21:01",
					"arrivesAt": "21:07",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Făgăraş",
					"to": "Ucea",
					"leavesAt": "21:08",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Ucea",
					"to": "Porumbacu Hm.",
					"leavesAt": "21:35",
					"arrivesAt": "21:55",
					"waitsAtSource": 300,
					"distance": 18700
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "21:56",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Avrig Hm.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "22:05",
					"arrivesAt": "22:22",
					"waitsAtSource": 60,
					"distance": 15400
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Sibiu",
					"leavesAt": "22:23",
					"arrivesAt": "22:42",
					"waitsAtSource": 60,
					"distance": 17800
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5411",
			"segments": [
				{
					"from": "Adjud",
					"to": "Adjudu Vechi h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:21",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Şişcani h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Şişcani h.",
					"to": "Sascut Hm.",
					"leavesAt": "08:27",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sascut Hm.",
					"to": "Orbeni Hm.",
					"leavesAt": "08:34",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Orbeni Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Răcăciuni h.",
					"to": "Faraoani Hm.",
					"leavesAt": "08:49",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Faraoani Hm.",
					"to": "Siretu Bacău h.",
					"leavesAt": "08:58",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Valea Seacă",
					"leavesAt": "09:04",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Valea Seacă",
					"to": "Letea h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Letea h.",
					"to": "Bacău",
					"leavesAt": "09:17",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2188",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Lugoj Nord h.",
					"leavesAt": "19:50",
					"arrivesAt": "19:54",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Lugoj Nord h.",
					"to": "Coşteiu Mare Hm.",
					"leavesAt": "19:55",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Coşteiu Mare Hm.",
					"to": "Păru h.",
					"leavesAt": "20:01",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Păru h.",
					"to": "Balinţ h.",
					"leavesAt": "20:04",
					"arrivesAt": "20:08",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Balinţ h.",
					"to": "Nevrincea h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Nevrincea h.",
					"to": "Cliciova",
					"leavesAt": "20:13",
					"arrivesAt": "20:17",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Cliciova",
					"to": "Susani Bega h.",
					"leavesAt": "20:18",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Susani Bega h.",
					"to": "Traian Vuia h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Traian Vuia h.",
					"to": "Mănăştur Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:29",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Mănăştur Hm.",
					"to": "Răchita h.",
					"leavesAt": "20:30",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Răchita h.",
					"to": "Făget",
					"leavesAt": "20:35",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Făget",
					"to": "Margina",
					"leavesAt": "20:41",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4415",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Ram. Botiz h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:18",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Micula Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Micula Hm.",
					"to": "Porumbeşti Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Halmeu",
					"leavesAt": "06:34",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1586",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "17:00",
					"arrivesAt": "17:24",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "17:25",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "17:43",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "18:04",
					"arrivesAt": "18:27",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "18:28",
					"arrivesAt": "19:24",
					"waitsAtSource": 60,
					"distance": 108900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9138",
			"segments": [
				{
					"from": "Băileşti",
					"to": "Boureni P.M.",
					"leavesAt": "16:45",
					"arrivesAt": "16:57",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Boureni P.M.",
					"to": "Siliştea Crucii h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:02",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Siliştea Crucii h.",
					"to": "Afumaţi h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Afumaţi h.",
					"to": "Urzica Mare h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Urzica Mare h.",
					"to": "Portăreşti Hm.",
					"leavesAt": "17:26",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Portăreşti Hm.",
					"to": "Cerăt h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cerăt h.",
					"to": "Segarcea",
					"leavesAt": "17:42",
					"arrivesAt": "17:48",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Segarcea",
					"to": "Segarcea Nord hc.",
					"leavesAt": "17:57",
					"arrivesAt": "17:59",
					"waitsAtSource": 540,
					"distance": 1100
				},
				{
					"from": "Segarcea Nord hc.",
					"to": "Dealul Robului h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dealul Robului h.",
					"to": "Sălcuţa Hm.",
					"leavesAt": "18:07",
					"arrivesAt": "18:13",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Sălcuţa Hm.",
					"to": "Podari",
					"leavesAt": "18:14",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Podari",
					"to": "R. 1 Jiu",
					"leavesAt": "18:30",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "R. 1 Jiu",
					"to": "Jiu Hm.",
					"leavesAt": "18:38",
					"arrivesAt": "18:41",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Jiu Hm.",
					"to": "Bordei hc.(913)",
					"leavesAt": "18:42",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Bordei hc.(913)",
					"to": "Craiova",
					"leavesAt": "18:46",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9617",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Boldur h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:06",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Boldur h.",
					"to": "Sinia Hm.",
					"leavesAt": "16:07",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sinia Hm.",
					"to": "Căpăt h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Căpăt h.",
					"to": "Buziaş",
					"leavesAt": "16:21",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 7300
				},
				{
					"from": "Buziaş",
					"to": "Bacova h.",
					"leavesAt": "16:43",
					"arrivesAt": "16:46",
					"waitsAtSource": 600,
					"distance": 2300
				},
				{
					"from": "Bacova h.",
					"to": "Chevereş h.",
					"leavesAt": "16:47",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Chevereş h.",
					"to": "Sacoşu Mic",
					"leavesAt": "16:53",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Sacoşu Mic",
					"to": "Uliuc h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:17",
					"waitsAtSource": 720,
					"distance": 5000
				},
				{
					"from": "Uliuc h.",
					"to": "Urseni h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Urseni h.",
					"to": "Semenic Hm.",
					"leavesAt": "17:25",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Semenic Hm.",
					"to": "Giroc h.",
					"leavesAt": "17:30",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Giroc h.",
					"to": "Timişoara Sud",
					"leavesAt": "17:34",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "17:45",
					"arrivesAt": "17:54",
					"waitsAtSource": 300,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1880",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Nucet",
					"leavesAt": "05:22",
					"arrivesAt": "05:34",
					"waitsAtSource": 0,
					"distance": 16300
				},
				{
					"from": "Nucet",
					"to": "Titu",
					"leavesAt": "05:35",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 15400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1852",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Târgu Frumos",
					"leavesAt": "19:10",
					"arrivesAt": "19:46",
					"waitsAtSource": 0,
					"distance": 44900
				},
				{
					"from": "Târgu Frumos",
					"to": "Roman",
					"leavesAt": "19:47",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 69200
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "20:42",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 43800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9450",
			"segments": [
				{
					"from": "Pietroşiţa Hm.",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:06",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Fieni",
					"leavesAt": "21:07",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Moţăieni h.",
					"leavesAt": "21:13",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Moţăieni h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "21:18",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Trainica h.",
					"leavesAt": "21:23",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Trainica h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "21:27",
					"arrivesAt": "21:32",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Doiceşti",
					"leavesAt": "21:33",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Doiceşti",
					"to": "Săteni h.",
					"leavesAt": "21:38",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Săteni h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "21:42",
					"arrivesAt": "21:46",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "21:47",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "21:50",
					"arrivesAt": "21:54",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9585",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Săcălaz h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:15",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Săcălaz h.",
					"to": "Beregsău hcv.",
					"leavesAt": "07:16",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Beregsău hcv.",
					"to": "Cărpiniş",
					"leavesAt": "07:24",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Cărpiniş",
					"to": "Clarii Vii h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Clarii Vii h.",
					"to": "Jimbolia",
					"leavesAt": "07:40",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5533",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Topile h.",
					"leavesAt": "19:34",
					"arrivesAt": "19:39",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Topile h.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "19:40",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Timişeşti Hm.",
					"leavesAt": "19:49",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Plăieşu h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Plăieşu h.",
					"to": "Sfântu Mina h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:06",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Târgu Neamţ",
					"leavesAt": "20:07",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3503",
			"segments": [
				{
					"from": "Braşov",
					"to": "Stupini Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:39",
					"waitsAtSource": 0,
					"distance": 5400
				},
				{
					"from": "Stupini Hm.",
					"to": "Bod Hm.",
					"leavesAt": "14:40",
					"arrivesAt": "14:48",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Bod Hm.",
					"to": "Feldioara Hm.",
					"leavesAt": "14:49",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Rotbav h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Rotbav h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:08",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Măieruş h.",
					"leavesAt": "15:09",
					"arrivesAt": "15:12",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Măieruş h.",
					"to": "Apaţa",
					"leavesAt": "15:13",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Apaţa",
					"to": "Ormeniş h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ormeniş h.",
					"to": "Augustin Hm.",
					"leavesAt": "15:33",
					"arrivesAt": "15:46",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Augustin Hm.",
					"to": "Racoş Hm.",
					"leavesAt": "15:47",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Racoş Hm.",
					"to": "Mateiaş h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:08",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mateiaş h.",
					"to": "Rupea",
					"leavesAt": "16:09",
					"arrivesAt": "16:23",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Rupea",
					"to": "Caţa Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:33",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Caţa Hm.",
					"to": "Paloş Ardeal h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Paloş Ardeal h.",
					"to": "Beia Hm.",
					"leavesAt": "16:39",
					"arrivesAt": "16:50",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Beia Hm.",
					"to": "Archita h",
					"leavesAt": "16:51",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Archita h",
					"to": "Mureni Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 9600
				},
				{
					"from": "Mureni Hm.",
					"to": "Saschiz h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:36",
					"waitsAtSource": 780,
					"distance": 3400
				},
				{
					"from": "Saschiz h.",
					"to": "Vânători",
					"leavesAt": "17:37",
					"arrivesAt": "17:41",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vânători",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Sighişoara",
					"leavesAt": "17:50",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Sighişoara",
					"to": "Daneş Hm.",
					"leavesAt": "18:22",
					"arrivesAt": "18:38",
					"waitsAtSource": 1380,
					"distance": 9500
				},
				{
					"from": "Daneş Hm.",
					"to": "Luna h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Luna h.",
					"to": "Dumbrăveni",
					"leavesAt": "18:47",
					"arrivesAt": "18:54",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Dumbrăveni",
					"to": "Aţel Hm.",
					"leavesAt": "18:55",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Aţel Hm.",
					"to": "Bratei h.",
					"leavesAt": "19:05",
					"arrivesAt": "19:14",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Bratei h.",
					"to": "Mediaş",
					"leavesAt": "19:15",
					"arrivesAt": "19:24",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "19:29",
					"arrivesAt": "19:37",
					"waitsAtSource": 300,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "19:38",
					"arrivesAt": "19:45",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Micăsasa h.",
					"leavesAt": "19:49",
					"arrivesAt": "20:06",
					"waitsAtSource": 240,
					"distance": 10200
				},
				{
					"from": "Micăsasa h.",
					"to": "Lunca h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lunca h.",
					"to": "Valea Lungă Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:21",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Glogoveţ h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Glogoveţ h.",
					"to": "Mănărade h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Mănărade h.",
					"to": "Câmpu Libertăţii  h.",
					"leavesAt": "20:31",
					"arrivesAt": "20:35",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Câmpu Libertăţii  h.",
					"to": "Blaj",
					"leavesAt": "20:36",
					"arrivesAt": "20:41",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Blaj",
					"to": "Crăciunel Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:51",
					"waitsAtSource": 120,
					"distance": 5300
				},
				{
					"from": "Crăciunel Hm.",
					"to": "Cistei h.",
					"leavesAt": "20:52",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Cistei h.",
					"to": "Mihalţ h.",
					"leavesAt": "21:02",
					"arrivesAt": "21:07",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Mihalţ h.",
					"to": "Coşlariu Gr. P. Mureş",
					"leavesAt": "21:08",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Coşlariu Gr. P. Mureş",
					"to": "Teiuş",
					"leavesAt": "21:13",
					"arrivesAt": "21:20",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5527",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Topile h.",
					"leavesAt": "14:25",
					"arrivesAt": "14:30",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Topile h.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "14:31",
					"arrivesAt": "14:39",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Timişeşti Hm.",
					"leavesAt": "14:40",
					"arrivesAt": "14:47",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Plăieşu h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Plăieşu h.",
					"to": "Sfântu Mina h.",
					"leavesAt": "14:54",
					"arrivesAt": "14:57",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Târgu Neamţ",
					"leavesAt": "14:58",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 863
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4073",
			"segments": [
				{
					"from": "Sărmăşag",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "15:21",
					"arrivesAt": "15:28",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "15:29",
					"arrivesAt": "15:33",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Borla Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:39",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Borla Hm.",
					"to": "Guruslău h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:45",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Guruslău h.",
					"to": "Zalău Nord",
					"leavesAt": "15:46",
					"arrivesAt": "15:55",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "15:56",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "16:25",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20180114",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180901",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5445",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "10:29",
					"arrivesAt": "10:40",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "10:41",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "10:46",
					"arrivesAt": "10:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "10:52",
					"arrivesAt": "11:01",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "11:02",
					"arrivesAt": "11:06",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "11:07",
					"arrivesAt": "11:14",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "11:16",
					"arrivesAt": "11:23",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "11:24",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "11:31",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "11:36",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "11:42",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "11:47",
					"arrivesAt": "11:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani",
					"leavesAt": "11:52",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "12:07",
					"arrivesAt": "12:12",
					"waitsAtSource": 300,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "12:13",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "12:24",
					"arrivesAt": "12:29",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "12:30",
					"arrivesAt": "12:35",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "12:48",
					"arrivesAt": "12:54",
					"waitsAtSource": 780,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "12:55",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "13:02",
					"arrivesAt": "13:08",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "13:09",
					"arrivesAt": "13:15",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "13:21",
					"arrivesAt": "13:29",
					"waitsAtSource": 360,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "13:30",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "13:41",
					"arrivesAt": "13:47",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1961",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "20:35",
					"arrivesAt": "20:42",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "20:43",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "20:51",
					"arrivesAt": "21:04",
					"waitsAtSource": 180,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "21:07",
					"arrivesAt": "21:11",
					"waitsAtSource": 180,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "21:13",
					"arrivesAt": "21:21",
					"waitsAtSource": 120,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "21:22",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "21:34",
					"arrivesAt": "21:41",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "21:43",
					"arrivesAt": "22:06",
					"waitsAtSource": 120,
					"distance": 14000
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "22:40",
					"arrivesAt": "23:05",
					"waitsAtSource": 2040,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "23:06",
					"arrivesAt": "23:24",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "23:25",
					"arrivesAt": "23:44",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Movila Hm.",
					"leavesAt": "23:54",
					"arrivesAt": "00:10",
					"waitsAtSource": 600,
					"distance": 16700
				},
				{
					"from": "Movila Hm.",
					"to": "Ţăndărei",
					"leavesAt": "00:11",
					"arrivesAt": "00:25",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Ţăndărei",
					"to": "Ianca hc.",
					"leavesAt": "00:26",
					"arrivesAt": "01:36",
					"waitsAtSource": 60,
					"distance": 72100
				},
				{
					"from": "Ianca hc.",
					"to": "Brăila",
					"leavesAt": "01:37",
					"arrivesAt": "02:09",
					"waitsAtSource": 60,
					"distance": 42400
				},
				{
					"from": "Brăila",
					"to": "Barboşi",
					"leavesAt": "02:10",
					"arrivesAt": "02:29",
					"waitsAtSource": 60,
					"distance": 19500
				},
				{
					"from": "Barboşi",
					"to": "Lieşti",
					"leavesAt": "02:49",
					"arrivesAt": "03:38",
					"waitsAtSource": 1200,
					"distance": 48300
				},
				{
					"from": "Lieşti",
					"to": "Tecuci",
					"leavesAt": "03:39",
					"arrivesAt": "04:09",
					"waitsAtSource": 60,
					"distance": 24400
				},
				{
					"from": "Tecuci",
					"to": "Bârlad",
					"leavesAt": "04:10",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 50300
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "04:55",
					"arrivesAt": "05:24",
					"waitsAtSource": 120,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "05:25",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "05:41",
					"arrivesAt": "05:59",
					"waitsAtSource": 120,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "06:00",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "06:27",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "06:44",
					"arrivesAt": "06:51",
					"waitsAtSource": 120,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9030",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Ram. Goleşti",
					"leavesAt": "20:00",
					"arrivesAt": "20:04",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Ram. Goleşti",
					"to": "Goleşti",
					"leavesAt": "20:05",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Goleşti",
					"to": "Canton 97+770 h.",
					"leavesAt": "20:17",
					"arrivesAt": "20:21",
					"waitsAtSource": 300,
					"distance": 2600
				},
				{
					"from": "Canton 97+770 h.",
					"to": "Călineşti Hm.",
					"leavesAt": "20:22",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Călineşti Hm.",
					"to": "Leordeni Argeş",
					"leavesAt": "20:29",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Leordeni Argeş",
					"to": "Pătroaia Hm.",
					"leavesAt": "20:36",
					"arrivesAt": "20:43",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pătroaia Hm.",
					"to": "Găeşti",
					"leavesAt": "20:44",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Găeşti",
					"to": "Cojocaru h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Cojocaru h.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "21:00",
					"arrivesAt": "21:06",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Fusea Hm.",
					"leavesAt": "21:07",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Fusea Hm.",
					"to": "Titu",
					"leavesAt": "21:14",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "21:25",
					"arrivesAt": "21:30",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "21:31",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "21:35",
					"arrivesAt": "21:40",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "21:41",
					"arrivesAt": "21:47",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "21:48",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "21:56",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "22:05",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "22:13",
					"arrivesAt": "22:18",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Basarab",
					"leavesAt": "22:19",
					"arrivesAt": "22:27",
					"waitsAtSource": 30,
					"distance": 4700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9574",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "08:34",
					"arrivesAt": "08:40",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Ghiroda h.",
					"leavesAt": "08:41",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Ghiroda h.",
					"to": "Remetea Mare",
					"leavesAt": "08:47",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Remetea Mare",
					"to": "Izvin h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Izvin h.",
					"to": "Recaş",
					"leavesAt": "09:05",
					"arrivesAt": "09:08",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Recaş",
					"to": "Şuştra h.",
					"leavesAt": "09:09",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Şuştra h.",
					"to": "Topolovăţ",
					"leavesAt": "09:17",
					"arrivesAt": "09:21",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Topolovăţ",
					"to": "Chizătău Hm.",
					"leavesAt": "09:26",
					"arrivesAt": "09:34",
					"waitsAtSource": 300,
					"distance": 7200
				},
				{
					"from": "Chizătău Hm.",
					"to": "Belinţ Hm.",
					"leavesAt": "09:35",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Belinţ Hm.",
					"to": "Jabăr Hm.",
					"leavesAt": "09:41",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Jabăr Hm.",
					"to": "Lugoj",
					"leavesAt": "09:48",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Lugoj",
					"to": "Tapia Hm.",
					"leavesAt": "09:57",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Tapia Hm.",
					"to": "Găvojdia",
					"leavesAt": "10:05",
					"arrivesAt": "10:11",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Găvojdia",
					"to": "Jena Hm.",
					"leavesAt": "10:12",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Jena Hm.",
					"to": "Sacu h.",
					"leavesAt": "10:25",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sacu h.",
					"to": "Căvăran",
					"leavesAt": "10:30",
					"arrivesAt": "10:34",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Căvăran",
					"to": "Zăgujeni Hm.",
					"leavesAt": "10:35",
					"arrivesAt": "10:47",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Zăgujeni Hm.",
					"to": "Tibiscu h.",
					"leavesAt": "10:48",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Tibiscu h.",
					"to": "Caransebeş",
					"leavesAt": "10:53",
					"arrivesAt": "10:58",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 264
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2592",
			"segments": [
				{
					"from": "Loamneş Hm.",
					"to": "Mândra h.",
					"leavesAt": "11:05",
					"arrivesAt": "11:08",
					"waitsAtSource": 0,
					"distance": 2000
				},
				{
					"from": "Mândra h.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "11:09",
					"arrivesAt": "11:17",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "11:18",
					"arrivesAt": "11:25",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Sibiu h.(203)",
					"leavesAt": "11:26",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Sibiu",
					"leavesAt": "11:36",
					"arrivesAt": "11:40",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3746",
			"segments": [
				{
					"from": "Chişineu Criş",
					"to": "Nădab",
					"leavesAt": "14:17",
					"arrivesAt": "14:23",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Nădab",
					"to": "Şimand Hm.",
					"leavesAt": "14:24",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şimand Hm.",
					"to": "Comlăuş h.",
					"leavesAt": "14:33",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Comlăuş h.",
					"to": "Sântana",
					"leavesAt": "14:42",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utviniş h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Utviniş h.",
					"to": "Utvinişu Nou",
					"leavesAt": "15:03",
					"arrivesAt": "15:07",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Utvinişu Nou",
					"to": "Arad",
					"leavesAt": "15:08",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "1062",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "13:10",
					"arrivesAt": "13:17",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Socola",
					"leavesAt": "13:18",
					"arrivesAt": "13:23",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Socola",
					"to": "Holboca Hm.",
					"leavesAt": "13:24",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Holboca Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "13:34",
					"arrivesAt": "13:42",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "13:43",
					"arrivesAt": "13:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ungheni Prut Hm.",
					"to": "Ungheni Prut Fr.",
					"leavesAt": "14:39",
					"arrivesAt": "14:41",
					"waitsAtSource": 2880,
					"distance": 600
				},
				{
					"from": "Ungheni Prut Fr.",
					"to": "Ungheni",
					"leavesAt": "15:01",
					"arrivesAt": "15:05",
					"waitsAtSource": 1200,
					"distance": 800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5428",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "20:40",
					"arrivesAt": "20:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "20:55",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "21:03",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "21:10",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "21:18",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "21:28",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "21:35",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "21:40",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "21:50",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "22:28",
					"arrivesAt": "22:35",
					"waitsAtSource": 1440,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "22:36",
					"arrivesAt": "22:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "22:42",
					"arrivesAt": "22:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "22:47",
					"arrivesAt": "22:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "22:53",
					"arrivesAt": "22:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "22:58",
					"arrivesAt": "23:04",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "23:05",
					"arrivesAt": "23:14",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "23:16",
					"arrivesAt": "23:23",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "23:24",
					"arrivesAt": "23:28",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "23:29",
					"arrivesAt": "23:37",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "23:38",
					"arrivesAt": "23:43",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "23:44",
					"arrivesAt": "23:49",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "23:50",
					"arrivesAt": "00:02",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4406",
			"segments": [
				{
					"from": "Halmeu",
					"to": "Porumbeşti Hm.",
					"leavesAt": "13:40",
					"arrivesAt": "13:46",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Micula Hm.",
					"leavesAt": "13:47",
					"arrivesAt": "13:54",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Micula Hm.",
					"to": "Ram. Botiz h.",
					"leavesAt": "13:55",
					"arrivesAt": "14:03",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Satu Mare",
					"leavesAt": "14:04",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4585",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "17:40",
					"arrivesAt": "17:44",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "17:45",
					"arrivesAt": "17:50",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "17:51",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "17:58",
					"arrivesAt": "18:01",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "18:02",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "18:07",
					"arrivesAt": "18:12",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "18:13",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1592",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(900)",
					"leavesAt": "03:00",
					"arrivesAt": "03:03",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "03:04",
					"arrivesAt": "03:19",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Caracal",
					"leavesAt": "03:20",
					"arrivesAt": "03:49",
					"waitsAtSource": 60,
					"distance": 40100
				},
				{
					"from": "Caracal",
					"to": "Stoeneşti h.",
					"leavesAt": "03:50",
					"arrivesAt": "04:00",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Stoeneşti h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "04:01",
					"arrivesAt": "04:11",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Radomireşti Hm.",
					"leavesAt": "04:12",
					"arrivesAt": "04:23",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "04:24",
					"arrivesAt": "04:32",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "04:33",
					"arrivesAt": "04:49",
					"waitsAtSource": 60,
					"distance": 17300
				},
				{
					"from": "Roşiori Nord",
					"to": "Vârtoapele hc.",
					"leavesAt": "04:50",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Olteni",
					"leavesAt": "05:10",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "05:24",
					"arrivesAt": "05:33",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Videle",
					"leavesAt": "05:34",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 15800
				},
				{
					"from": "Videle",
					"to": "Grădinari",
					"leavesAt": "05:48",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 25400
				},
				{
					"from": "Grădinari",
					"to": "Bucureştii Noi",
					"leavesAt": "06:14",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 19700
				},
				{
					"from": "Bucureştii Noi",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:43",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Nord",
					"leavesAt": "06:44",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3081",
			"segments": [
				{
					"from": "Războieni",
					"to": "Grindeni h.",
					"leavesAt": "03:50",
					"arrivesAt": "03:54",
					"waitsAtSource": 0,
					"distance": 2800
				},
				{
					"from": "Grindeni h.",
					"to": "Călăraşi Turda Hm.",
					"leavesAt": "03:55",
					"arrivesAt": "04:01",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Călăraşi Turda Hm.",
					"to": "Câmpia Turzii",
					"leavesAt": "04:02",
					"arrivesAt": "04:09",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cânepişti h.",
					"leavesAt": "04:10",
					"arrivesAt": "04:19",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Cânepişti h.",
					"to": "Ploscoş h.",
					"leavesAt": "04:20",
					"arrivesAt": "04:25",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ploscoş h.",
					"to": "Valea Florilor Hm.",
					"leavesAt": "04:26",
					"arrivesAt": "04:31",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Boju",
					"leavesAt": "04:32",
					"arrivesAt": "04:44",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Boju",
					"to": "Tunel Hm.",
					"leavesAt": "04:45",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Tunel Hm.",
					"to": "Cojocna Hm.",
					"leavesAt": "04:53",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cojocna Hm.",
					"to": "Apahida",
					"leavesAt": "05:01",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "05:12",
					"arrivesAt": "05:19",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "05:26",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3646",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Est",
					"leavesAt": "19:30",
					"arrivesAt": "19:35",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Oradea Est",
					"to": "Oradea Est Triaj h.",
					"leavesAt": "19:36",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 700
				},
				{
					"from": "Oradea Est Triaj h.",
					"to": "Oşorhei Hm.",
					"leavesAt": "19:39",
					"arrivesAt": "19:45",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Săcădat h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Săcădat h.",
					"to": "Săbolciu h.",
					"leavesAt": "19:52",
					"arrivesAt": "19:54",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săbolciu h.",
					"to": "Tileagd",
					"leavesAt": "19:55",
					"arrivesAt": "20:02",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tileagd",
					"to": "Telechiu Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Telechiu Hm.",
					"to": "Ţeţchea hc.",
					"leavesAt": "20:08",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ţeţchea hc.",
					"to": "Aleşd",
					"leavesAt": "20:12",
					"arrivesAt": "20:15",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Aleşd",
					"to": "Aleşd h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:33",
					"waitsAtSource": 840,
					"distance": 2600
				},
				{
					"from": "Aleşd h.",
					"to": "Butan h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:39",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Butan h.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "20:40",
					"arrivesAt": "20:48",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Vadu Crişului h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului h.",
					"to": "Peştera h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:56",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Peştera h.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "20:57",
					"arrivesAt": "21:01",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bălnaca h.",
					"leavesAt": "21:02",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bălnaca h.",
					"to": "Bratca",
					"leavesAt": "21:07",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 2300
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 831
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 831
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 831
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 831
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 831
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 831
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 831
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 831
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 831
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1576",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Barboşi",
					"leavesAt": "14:30",
					"arrivesAt": "14:49",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Barboşi",
					"to": "Brăila",
					"leavesAt": "14:50",
					"arrivesAt": "15:07",
					"waitsAtSource": 60,
					"distance": 19500
				},
				{
					"from": "Brăila",
					"to": "Ianca hc.",
					"leavesAt": "15:09",
					"arrivesAt": "15:39",
					"waitsAtSource": 120,
					"distance": 42400
				},
				{
					"from": "Ianca hc.",
					"to": "Făurei",
					"leavesAt": "15:40",
					"arrivesAt": "15:56",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Făurei",
					"to": "Buzău",
					"leavesAt": "15:58",
					"arrivesAt": "16:37",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "16:39",
					"arrivesAt": "17:11",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "17:12",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "17:51",
					"arrivesAt": "18:43",
					"waitsAtSource": 180,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4313",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Botiz Hm.",
					"leavesAt": "07:45",
					"arrivesAt": "07:52",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Botiz Hm.",
					"to": "Odoreu h.",
					"leavesAt": "07:53",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Odoreu h.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "08:00",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Apa Hm.",
					"leavesAt": "08:12",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Apa Hm.",
					"to": "Seini",
					"leavesAt": "08:21",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Seini",
					"to": "Săbişa h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Săbişa h.",
					"to": "Ilba h.",
					"leavesAt": "08:43",
					"arrivesAt": "08:47",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ilba h.",
					"to": "Cicârlău h.",
					"leavesAt": "08:48",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Cicârlău h.",
					"to": "Buşag Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Buşag Hm.",
					"to": "Baia Mare",
					"leavesAt": "09:04",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20180911",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180609",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1780",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "05:00",
					"arrivesAt": "05:11",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "05:12",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "05:36",
					"arrivesAt": "05:55",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "06:03",
					"arrivesAt": "06:43",
					"waitsAtSource": 480,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9365",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "10:50",
					"arrivesAt": "10:55",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Peret hc.",
					"leavesAt": "10:56",
					"arrivesAt": "11:09",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Peret hc.",
					"to": "Plosca Hm.",
					"leavesAt": "11:10",
					"arrivesAt": "11:18",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Plosca Hm.",
					"to": "Buzescu h.",
					"leavesAt": "11:19",
					"arrivesAt": "11:27",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzescu h.",
					"to": "Alexandria Nord h.",
					"leavesAt": "11:28",
					"arrivesAt": "11:39",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Alexandria",
					"leavesAt": "11:40",
					"arrivesAt": "11:46",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180526",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180506",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9584",
			"segments": [
				{
					"from": "Jimbolia",
					"to": "Clarii Vii h.",
					"leavesAt": "05:15",
					"arrivesAt": "05:21",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Clarii Vii h.",
					"to": "Cărpiniş",
					"leavesAt": "05:22",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Cărpiniş",
					"to": "Beregsău hcv.",
					"leavesAt": "05:31",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Beregsău hcv.",
					"to": "Săcălaz h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Săcălaz h.",
					"to": "Timişoara Nord",
					"leavesAt": "05:47",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3117",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj h",
					"leavesAt": "17:50",
					"arrivesAt": "17:56",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "17:57",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "18:00",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Băile Călacea",
					"leavesAt": "18:06",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Călacea",
					"to": "Orţişoara",
					"leavesAt": "18:13",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Orţişoara",
					"to": "Vinga Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "18:25",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Valea Viilor Hm.",
					"leavesAt": "18:32",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Aradu Nou",
					"leavesAt": "18:38",
					"arrivesAt": "18:48",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "18:49",
					"arrivesAt": "18:56",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Arad",
					"to": "Utvinişu Nou",
					"leavesAt": "19:11",
					"arrivesAt": "19:21",
					"waitsAtSource": 900,
					"distance": 6500
				},
				{
					"from": "Utvinişu Nou",
					"to": "Utviniş h.",
					"leavesAt": "19:22",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Utviniş h.",
					"to": "Zimandu Nou h.",
					"leavesAt": "19:26",
					"arrivesAt": "19:30",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "19:31",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Comlăuş h.",
					"leavesAt": "19:42",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Comlăuş h.",
					"to": "Şimand Hm.",
					"leavesAt": "19:47",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şimand Hm.",
					"to": "Nădab",
					"leavesAt": "19:55",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Nădab",
					"to": "Chişineu Criş",
					"leavesAt": "20:03",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Chişineu Criş",
					"to": "Zerind Hm.",
					"leavesAt": "20:22",
					"arrivesAt": "20:29",
					"waitsAtSource": 780,
					"distance": 8000
				},
				{
					"from": "Zerind Hm.",
					"to": "Tămaşda h.",
					"leavesAt": "20:30",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Tămaşda h.",
					"to": "Boiu Bihor h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Boiu Bihor h.",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:53",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Salonta",
					"leavesAt": "20:54",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Salonta",
					"to": "Mădăraş Bihor h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:12",
					"waitsAtSource": 120,
					"distance": 3200
				},
				{
					"from": "Mădăraş Bihor h.",
					"to": "Cefa Hm.",
					"leavesAt": "21:13",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Cefa Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "21:24",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Oradea Vest Hm.",
					"leavesAt": "21:35",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Oradea",
					"leavesAt": "21:47",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5565",
			"segments": [
				{
					"from": "Botoşani",
					"to": "Leorda Hm.",
					"leavesAt": "19:29",
					"arrivesAt": "19:53",
					"waitsAtSource": 0,
					"distance": 15500
				},
				{
					"from": "Leorda Hm.",
					"to": "Bucecea Hm",
					"leavesAt": "19:54",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bucecea Hm",
					"to": "Bursuceni h.",
					"leavesAt": "20:14",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Bursuceni h.",
					"to": "Vereşti",
					"leavesAt": "20:30",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "20:43",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "20:51",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "21:02",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5107",
			"segments": [
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "08:04",
					"arrivesAt": "08:16",
					"waitsAtSource": 0,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "08:17",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "08:28",
					"arrivesAt": "08:40",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "08:41",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "08:51",
					"arrivesAt": "08:59",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "09:00",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "09:21",
					"arrivesAt": "09:29",
					"waitsAtSource": 720,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "09:30",
					"arrivesAt": "09:42",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "10:04",
					"arrivesAt": "10:16",
					"waitsAtSource": 1320,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "10:17",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 8000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8343",
			"segments": [
				{
					"from": "Călăraşi Sud",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "05:40",
					"arrivesAt": "05:48",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Ştefan Vodă h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Ciulniţa",
					"leavesAt": "05:57",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 12600
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "06:22",
					"arrivesAt": "06:26",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "06:27",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "06:31",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "06:36",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "06:41",
					"arrivesAt": "06:46",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "06:47",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Feteşti",
					"to": "Ramificaţia Borcea",
					"leavesAt": "06:58",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Ovidiu",
					"leavesAt": "07:05",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ovidiu",
					"to": "Dunărea Hm.",
					"leavesAt": "07:10",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Dunărea Hm.",
					"to": "Cernavodă Pod",
					"leavesAt": "07:17",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Cernavodă Pod",
					"to": "Saligny",
					"leavesAt": "07:26",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Saligny",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "07:35",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Medgidia",
					"leavesAt": "07:42",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "07:57",
					"arrivesAt": "08:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "08:06",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "08:16",
					"arrivesAt": "08:20",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "08:21",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "08:27",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180917",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9054",
			"segments": [
				{
					"from": "Turnu Măgurele",
					"to": "Km. 231+600 h.",
					"leavesAt": "17:30",
					"arrivesAt": "17:41",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Km. 231+600 h.",
					"to": "Salcia Teleorman Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "18:05",
					"waitsAtSource": 30,
					"distance": 14500
				},
				{
					"from": "Salcia Teleorman Hm.",
					"to": "Troian h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Troian h.",
					"to": "Km. 200+400 P.aj.m",
					"leavesAt": "18:18",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Km. 200+400 P.aj.m",
					"to": "Roşiori Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:35",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "18:36",
					"arrivesAt": "18:43",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2443",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(210)",
					"leavesAt": "15:48",
					"arrivesAt": "15:51",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Turnişor Hm.",
					"leavesAt": "15:52",
					"arrivesAt": "15:57",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Cristian Sibiu h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Orlat",
					"leavesAt": "16:11",
					"arrivesAt": "16:19",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Orlat",
					"to": "Sibiel h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Sibiel h.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "16:25",
					"arrivesAt": "16:28",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sălişte Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sălişte Hm.",
					"to": "Apoldu de Sus Hm.",
					"leavesAt": "16:36",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 13000
				},
				{
					"from": "Apoldu de Sus Hm.",
					"to": "Apoldu de Jos h.",
					"leavesAt": "16:55",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Apoldu de Jos h.",
					"to": "Miercurea Sibiu Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:08",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Miercurea Sibiu Hm.",
					"to": "Băile Miercurea h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Băile Miercurea h.",
					"to": "Cunţa Hm.",
					"leavesAt": "17:15",
					"arrivesAt": "17:21",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cunţa Hm.",
					"to": "Rahău h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Rahău h.",
					"to": "Sebeş Alba",
					"leavesAt": "17:33",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Sebeş Alba",
					"to": "Vinţu de Jos",
					"leavesAt": "17:43",
					"arrivesAt": "17:54",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "18:00",
					"arrivesAt": "18:12",
					"waitsAtSource": 360,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "18:13",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "18:24",
					"arrivesAt": "18:31",
					"waitsAtSource": 120,
					"distance": 4800
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Sântimbru h.",
					"leavesAt": "18:32",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Sântimbru h.",
					"to": "Coşlariu",
					"leavesAt": "18:36",
					"arrivesAt": "18:48",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "18:49",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "19:01",
					"arrivesAt": "19:13",
					"waitsAtSource": 240,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Mirăslău h.",
					"leavesAt": "19:14",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Mirăslău h.",
					"to": "Decea h.",
					"leavesAt": "19:20",
					"arrivesAt": "19:23",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Decea h.",
					"to": "Unirea Hm.",
					"leavesAt": "19:24",
					"arrivesAt": "19:29",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Unirea Hm.",
					"to": "Unirea hc.",
					"leavesAt": "19:30",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "19:34",
					"arrivesAt": "19:41",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Lunca Mureşului h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:53",
					"waitsAtSource": 480,
					"distance": 3000
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Gura Arieşului h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "19:59",
					"arrivesAt": "20:03",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Cheţani h.",
					"leavesAt": "20:04",
					"arrivesAt": "20:08",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Cheţani h.",
					"to": "Luduş",
					"leavesAt": "20:09",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Luduş",
					"to": "Bogata Mureş h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:26",
					"waitsAtSource": 360,
					"distance": 2700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Cuci h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cuci h.",
					"to": "Iernut",
					"leavesAt": "20:34",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Iernut",
					"to": "Cipău h.",
					"leavesAt": "20:41",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Cipău h.",
					"to": "Ogra h.",
					"leavesAt": "20:46",
					"arrivesAt": "20:49",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ogra h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "20:50",
					"arrivesAt": "20:54",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Chirileu h.",
					"leavesAt": "20:55",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chirileu h.",
					"to": "Vidrasău h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:04",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vidrasău h.",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "21:05",
					"arrivesAt": "21:10",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "21:11",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "Azomureş h.",
					"leavesAt": "21:16",
					"arrivesAt": "21:19",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş",
					"leavesAt": "21:20",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8589",
			"segments": [
				{
					"from": "Slobozia Veche",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "05:30",
					"arrivesAt": "05:40",
					"waitsAtSource": 0,
					"distance": 4200
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Brâncoveni h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Brâncoveni h.",
					"to": "Ciulniţa",
					"leavesAt": "05:50",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9449",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "19:16",
					"arrivesAt": "19:18",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "19:19",
					"arrivesAt": "19:21",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Aninoasa Hm.",
					"leavesAt": "19:22",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Aninoasa Hm.",
					"to": "Săteni h.",
					"leavesAt": "19:26",
					"arrivesAt": "19:28",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Săteni h.",
					"to": "Doiceşti",
					"leavesAt": "19:29",
					"arrivesAt": "19:32",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Doiceşti",
					"to": "Doiceşti h.",
					"leavesAt": "19:33",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Doiceşti h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "19:36",
					"arrivesAt": "19:39",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Scârlenţa h.",
					"leavesAt": "19:40",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Scârlenţa h.",
					"to": "Trainica h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:46",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Trainica h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "19:47",
					"arrivesAt": "19:51",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Moţăieni h.",
					"leavesAt": "19:52",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Moţăieni h.",
					"to": "Fieni",
					"leavesAt": "19:56",
					"arrivesAt": "20:01",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Pietroşiţa Hm.",
					"leavesAt": "20:06",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1587",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Constanţa",
					"leavesAt": "16:00",
					"arrivesAt": "18:00",
					"waitsAtSource": 0,
					"distance": 225000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2230",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "03:45",
					"arrivesAt": "03:51",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Viile Giarmata h.",
					"leavesAt": "03:52",
					"arrivesAt": "03:58",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Viile Giarmata h.",
					"to": "Giarmata Hm.",
					"leavesAt": "03:59",
					"arrivesAt": "04:04",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Giarmata Hm.",
					"to": "Cerneteaz h.",
					"leavesAt": "04:05",
					"arrivesAt": "04:07",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Cerneteaz h.",
					"to": "Pişchia h.",
					"leavesAt": "04:08",
					"arrivesAt": "04:16",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Pişchia h.",
					"to": "Bencei h.",
					"leavesAt": "04:17",
					"arrivesAt": "04:23",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Bencei h.",
					"to": "Fibiş h.",
					"leavesAt": "04:24",
					"arrivesAt": "04:28",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Fibiş h.",
					"to": "Remetea Mică",
					"leavesAt": "04:29",
					"arrivesAt": "04:37",
					"waitsAtSource": 30,
					"distance": 4300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5529",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Topile h.",
					"leavesAt": "16:39",
					"arrivesAt": "16:44",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Topile h.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "16:45",
					"arrivesAt": "16:53",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Timişeşti Hm.",
					"leavesAt": "16:54",
					"arrivesAt": "17:01",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Plăieşu h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Plăieşu h.",
					"to": "Sfântu Mina h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Târgu Neamţ",
					"leavesAt": "17:12",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8122",
			"segments": [
				{
					"from": "Slobozia Veche",
					"to": "Perieţi h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:13",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Perieţi h.",
					"to": "Fundata h.",
					"leavesAt": "06:14",
					"arrivesAt": "06:19",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Fundata h.",
					"to": "Andrăşeşti Hm.",
					"leavesAt": "06:20",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrăşeşti Hm.",
					"to": "Ciochina hc.",
					"leavesAt": "06:27",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciochina hc.",
					"to": "Căzăneşti",
					"leavesAt": "06:36",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Căzăneşti",
					"to": "Munteni Buzău h.",
					"leavesAt": "06:52",
					"arrivesAt": "06:56",
					"waitsAtSource": 480,
					"distance": 3000
				},
				{
					"from": "Munteni Buzău h.",
					"to": "Sărăţeni Ialomiţa h.",
					"leavesAt": "06:57",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Sărăţeni Ialomiţa h.",
					"to": "Sărăţuica Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sărăţuica Hm.",
					"to": "Km. 74+600 h.",
					"leavesAt": "07:07",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Km. 74+600 h.",
					"to": "Malu h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Malu h.",
					"to": "Broşteni Hm.",
					"leavesAt": "07:17",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Broşteni Hm.",
					"to": "Alexeni h.",
					"leavesAt": "07:23",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Alexeni h.",
					"to": "Urziceni",
					"leavesAt": "07:30",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:48",
					"waitsAtSource": 300,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "07:49",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "07:55",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Moldoveni h.",
					"to": "Dridu Hm.",
					"leavesAt": "08:02",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Dridu Hm.",
					"to": "Fierbinţi",
					"leavesAt": "08:09",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Fierbinţi",
					"to": "Greci h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:29",
					"waitsAtSource": 420,
					"distance": 6100
				},
				{
					"from": "Greci h.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "08:37",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Baloteşti Hm.",
					"leavesAt": "08:44",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Baloteşti Hm.",
					"to": "P.O. Aeroport h.",
					"leavesAt": "08:50",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Odăile h.",
					"leavesAt": "08:54",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Odăile h.",
					"to": "Mogoşoaia",
					"leavesAt": "08:58",
					"arrivesAt": "09:06",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Mogoşoaia",
					"to": "Chitila",
					"leavesAt": "09:07",
					"arrivesAt": "09:24",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Chitila",
					"to": "Pajura Hm. (700)",
					"leavesAt": "09:25",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Bucureşti Nord",
					"leavesAt": "09:32",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8381",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "06:15",
					"arrivesAt": "06:24",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "06:31",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "06:39",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "06:52",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "06:59",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "07:03",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "07:12",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "07:17",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4102",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Cluj Napoca Est",
					"leavesAt": "11:10",
					"arrivesAt": "11:20",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Dezmir h.",
					"leavesAt": "11:21",
					"arrivesAt": "11:25",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dezmir h.",
					"to": "Apahida",
					"leavesAt": "11:26",
					"arrivesAt": "11:32",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Apahida",
					"to": "Apahida h.",
					"leavesAt": "11:33",
					"arrivesAt": "11:37",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Apahida h.",
					"to": "Jucu Hm.",
					"leavesAt": "11:38",
					"arrivesAt": "11:44",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Jucu Hm.",
					"to": "Răscruci h.",
					"leavesAt": "11:45",
					"arrivesAt": "11:51",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Răscruci h.",
					"to": "Bonţida Hm.",
					"leavesAt": "11:52",
					"arrivesAt": "11:57",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bonţida Hm.",
					"to": "Fundătura h.",
					"leavesAt": "11:58",
					"arrivesAt": "12:04",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Fundătura h.",
					"to": "Iclod Hm.",
					"leavesAt": "12:05",
					"arrivesAt": "12:09",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Iclod Hm.",
					"to": "Livada Someş h.",
					"leavesAt": "12:10",
					"arrivesAt": "12:16",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Livada Someş h.",
					"to": "Gherla",
					"leavesAt": "12:17",
					"arrivesAt": "12:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Gherla",
					"to": "Nima h.",
					"leavesAt": "12:28",
					"arrivesAt": "12:39",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Nima h.",
					"to": "Dej Călători",
					"leavesAt": "12:40",
					"arrivesAt": "12:49",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "12:51",
					"arrivesAt": "12:58",
					"waitsAtSource": 120,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Reteag Hm.",
					"leavesAt": "12:59",
					"arrivesAt": "13:09",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Reteag Hm.",
					"to": "Reteag h.",
					"leavesAt": "13:10",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag h.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "13:15",
					"arrivesAt": "13:18",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "13:19",
					"arrivesAt": "13:23",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "13:24",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Beclean pe Someş",
					"to": "Şintereag Hm.",
					"leavesAt": "13:36",
					"arrivesAt": "13:44",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Şintereag Hm.",
					"to": "Caila hc.",
					"leavesAt": "13:45",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Caila hc.",
					"to": "Sfântu h.",
					"leavesAt": "13:50",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sfântu h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "13:54",
					"arrivesAt": "14:00",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "14:01",
					"arrivesAt": "14:03",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel Hm.",
					"leavesAt": "14:04",
					"arrivesAt": "14:11",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Sărata h.",
					"leavesAt": "14:12",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Viişoara h.",
					"leavesAt": "14:18",
					"arrivesAt": "14:21",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Viişoara h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "14:22",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "14:27",
					"arrivesAt": "14:30",
					"waitsAtSource": 30,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5301",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:51",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "08:56",
					"arrivesAt": "09:04",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "09:05",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "09:09",
					"arrivesAt": "09:21",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Urecheşti Hm.",
					"leavesAt": "09:22",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "09:33",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Bâlca hc.",
					"leavesAt": "09:38",
					"arrivesAt": "09:43",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Bâlca hc.",
					"to": "Căiuţi Hm.",
					"leavesAt": "09:44",
					"arrivesAt": "09:50",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Borzeşti Bacău",
					"leavesAt": "09:51",
					"arrivesAt": "10:03",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "10:04",
					"arrivesAt": "10:08",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Oneşti",
					"leavesAt": "10:09",
					"arrivesAt": "10:16",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Oneşti",
					"to": "Viişoara h",
					"leavesAt": "10:19",
					"arrivesAt": "10:31",
					"waitsAtSource": 180,
					"distance": 9100
				},
				{
					"from": "Viişoara h",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "10:32",
					"arrivesAt": "10:40",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Saline hc.",
					"leavesAt": "10:41",
					"arrivesAt": "10:44",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Saline hc.",
					"to": "Cireşoaia h.",
					"leavesAt": "10:45",
					"arrivesAt": "10:50",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cireşoaia h.",
					"to": "Dofteana Bacău",
					"leavesAt": "10:51",
					"arrivesAt": "10:56",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dofteana Bacău",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "10:57",
					"arrivesAt": "11:02",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Valea Uzului Hm.",
					"leavesAt": "11:03",
					"arrivesAt": "11:08",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Comăneşti",
					"leavesAt": "11:09",
					"arrivesAt": "11:17",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2561",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(203)",
					"leavesAt": "07:20",
					"arrivesAt": "07:24",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "07:25",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "07:36",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Mândra h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:49",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Mândra h.",
					"to": "Loamneş Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Loamneş Hm.",
					"to": "Hăşag h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Hăşag h.",
					"to": "Veşeud h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Veşeud h.",
					"to": "Şeica Mare h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:14",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Şeica Mare h.",
					"to": "Şeica Mare",
					"leavesAt": "08:15",
					"arrivesAt": "08:18",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Şeica Mare",
					"to": "Agârbiciu h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Agârbiciu h.",
					"to": "Axente Sever h.",
					"leavesAt": "08:26",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Axente Sever h.",
					"to": "Copşa Mică",
					"leavesAt": "08:32",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "08:46",
					"arrivesAt": "08:53",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1580",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "08:30",
					"arrivesAt": "08:54",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "08:55",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "09:13",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "09:34",
					"arrivesAt": "09:57",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "09:58",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 108900
				}
			],
			"restrictions": [
				{
					"from": "20180503",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180427",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8012",
			"segments": [
				{
					"from": "Feteşti",
					"to": "Bărăganu Hm.",
					"leavesAt": "03:35",
					"arrivesAt": "03:46",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "03:47",
					"arrivesAt": "03:51",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Jegălia",
					"leavesAt": "03:52",
					"arrivesAt": "03:56",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Jegălia",
					"to": "Recolta hc.",
					"leavesAt": "03:57",
					"arrivesAt": "04:00",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Recolta hc.",
					"to": "Perişoru Hm.",
					"leavesAt": "04:01",
					"arrivesAt": "04:04",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Perişoru Hm.",
					"to": "Ogoarele h.",
					"leavesAt": "04:05",
					"arrivesAt": "04:08",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ogoarele h.",
					"to": "Ciulniţa",
					"leavesAt": "04:09",
					"arrivesAt": "04:19",
					"waitsAtSource": 30,
					"distance": 9000
				},
				{
					"from": "Ciulniţa",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "04:34",
					"arrivesAt": "04:42",
					"waitsAtSource": 900,
					"distance": 13100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Bogdana h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Bogdana h.",
					"to": "Dâlga h.",
					"leavesAt": "04:47",
					"arrivesAt": "04:53",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Dâlga h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "04:54",
					"arrivesAt": "04:59",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "05:00",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Lehliu",
					"leavesAt": "05:04",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lehliu",
					"to": "Preasna h.",
					"leavesAt": "05:09",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Preasna h.",
					"to": "Săruleşti",
					"leavesAt": "05:15",
					"arrivesAt": "05:21",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Săruleşti",
					"to": "Mostiştea h.",
					"leavesAt": "05:22",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mostiştea h.",
					"to": "Fundulea Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:32",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Fundulea Hm.",
					"to": "Islaz h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Islaz h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "05:41",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Brăneşti Sat h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Pasărea",
					"leavesAt": "05:48",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Pasărea",
					"to": "Pantelimon",
					"leavesAt": "05:54",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pantelimon",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "06:01",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Bucureşti Obor",
					"leavesAt": "06:04",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2464",
			"segments": [
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "20:10",
					"arrivesAt": "20:15",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:25",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Râu Vadului h.",
					"leavesAt": "20:26",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Râu Vadului h.",
					"to": "Câineni",
					"leavesAt": "20:41",
					"arrivesAt": "20:50",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Robeşti h.",
					"leavesAt": "20:51",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Robeşti h.",
					"to": "Balota h.",
					"leavesAt": "20:59",
					"arrivesAt": "21:02",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Balota h.",
					"to": "Cornet Hm.",
					"leavesAt": "21:03",
					"arrivesAt": "21:09",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cornet Hm.",
					"to": "Beţel h.",
					"leavesAt": "21:10",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Beţel h.",
					"to": "Lotru",
					"leavesAt": "21:15",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Lotru",
					"to": "Cozia Hm.",
					"leavesAt": "21:23",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cozia Hm.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "21:32",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Păuşa h.",
					"leavesAt": "21:38",
					"arrivesAt": "21:43",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "21:44",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Dăeşti Hm.",
					"leavesAt": "21:50",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "21:58",
					"arrivesAt": "22:06",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "22:07",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "22:13",
					"arrivesAt": "22:16",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Ostroveni h.",
					"leavesAt": "22:18",
					"arrivesAt": "22:20",
					"waitsAtSource": 120,
					"distance": 1000
				},
				{
					"from": "Ostroveni h.",
					"to": "Răstoaca h.",
					"leavesAt": "22:21",
					"arrivesAt": "22:24",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Răstoaca h.",
					"to": "Râureni",
					"leavesAt": "22:25",
					"arrivesAt": "22:28",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Râureni",
					"to": "Râureni hc.",
					"leavesAt": "22:29",
					"arrivesAt": "22:33",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni hc.",
					"to": "Govora",
					"leavesAt": "22:34",
					"arrivesAt": "22:39",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Govora",
					"to": "Tătărani h.",
					"leavesAt": "22:47",
					"arrivesAt": "22:52",
					"waitsAtSource": 480,
					"distance": 5500
				},
				{
					"from": "Tătărani h.",
					"to": "Băbeni",
					"leavesAt": "22:53",
					"arrivesAt": "23:00",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1641",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "21:10",
					"arrivesAt": "21:50",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Floreşti Prahova",
					"leavesAt": "21:52",
					"arrivesAt": "22:05",
					"waitsAtSource": 120,
					"distance": 18600
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "22:06",
					"arrivesAt": "22:18",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "22:19",
					"arrivesAt": "22:42",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "22:43",
					"arrivesAt": "22:51",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "22:52",
					"arrivesAt": "22:57",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "22:58",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "23:09",
					"arrivesAt": "23:46",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Sfântu Gheorghe",
					"leavesAt": "23:58",
					"arrivesAt": "00:27",
					"waitsAtSource": 720,
					"distance": 32100
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "00:29",
					"arrivesAt": "01:01",
					"waitsAtSource": 120,
					"distance": 34400
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "01:03",
					"arrivesAt": "01:26",
					"waitsAtSource": 120,
					"distance": 28500
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "01:28",
					"arrivesAt": "01:36",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Izvoru Oltului",
					"leavesAt": "01:40",
					"arrivesAt": "01:56",
					"waitsAtSource": 240,
					"distance": 17100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "01:57",
					"arrivesAt": "02:08",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Gheorgheni",
					"leavesAt": "02:09",
					"arrivesAt": "02:26",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Gheorgheni",
					"to": "Topliţa",
					"leavesAt": "02:27",
					"arrivesAt": "02:59",
					"waitsAtSource": 60,
					"distance": 34000
				},
				{
					"from": "Topliţa",
					"to": "Deda",
					"leavesAt": "03:00",
					"arrivesAt": "03:58",
					"waitsAtSource": 60,
					"distance": 43900
				},
				{
					"from": "Deda",
					"to": "Sărăţel Hm.",
					"leavesAt": "03:59",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 46800
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "05:08",
					"arrivesAt": "05:37",
					"waitsAtSource": 900,
					"distance": 24900
				},
				{
					"from": "Beclean pe Someş",
					"to": "Dej Călători",
					"leavesAt": "05:40",
					"arrivesAt": "06:15",
					"waitsAtSource": 180,
					"distance": 24600
				},
				{
					"from": "Dej Călători",
					"to": "Câţcău h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:56",
					"waitsAtSource": 1560,
					"distance": 12700
				},
				{
					"from": "Câţcău h.",
					"to": "Gâlgău",
					"leavesAt": "06:57",
					"arrivesAt": "07:08",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Gâlgău",
					"to": "Ileanda",
					"leavesAt": "07:09",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Ileanda",
					"to": "Răstoci Hm.",
					"leavesAt": "07:29",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Răstoci Hm.",
					"to": "Letca Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Letca Hm.",
					"to": "Jibou",
					"leavesAt": "07:49",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 23100
				},
				{
					"from": "Jibou",
					"to": "Benesat Hm.",
					"leavesAt": "08:22",
					"arrivesAt": "08:40",
					"waitsAtSource": 120,
					"distance": 18000
				},
				{
					"from": "Benesat Hm.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "08:41",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "08:51",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "08:59",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Baia Mare",
					"leavesAt": "09:11",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5202",
			"segments": [
				{
					"from": "Siculeni",
					"to": "Mihăileni Hm.",
					"leavesAt": "04:18",
					"arrivesAt": "04:25",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "04:26",
					"arrivesAt": "04:30",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "04:31",
					"arrivesAt": "04:36",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Caracău h.",
					"leavesAt": "04:37",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Caracău h.",
					"to": "Livezi Ciuc",
					"leavesAt": "04:43",
					"arrivesAt": "04:47",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Utuşoiu h.",
					"leavesAt": "04:50",
					"arrivesAt": "04:56",
					"waitsAtSource": 180,
					"distance": 4100
				},
				{
					"from": "Utuşoiu h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "04:57",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Tarcău h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "05:08",
					"arrivesAt": "05:13",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Bolovăniş h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:28",
					"waitsAtSource": 480,
					"distance": 4900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Ghimeş",
					"leavesAt": "05:29",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ghimeş",
					"to": "Palanca Hm.",
					"leavesAt": "05:36",
					"arrivesAt": "05:43",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Palanca Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "05:44",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Simbrea Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "05:55",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Simbrea Hm.",
					"to": "Goioasa Hm.",
					"leavesAt": "05:56",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Goioasa Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Caraliţa h.",
					"to": "Asău Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:16",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Asău Hm.",
					"to": "Comăneşti",
					"leavesAt": "06:17",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Comăneşti",
					"to": "Valea Uzului Hm.",
					"leavesAt": "06:28",
					"arrivesAt": "06:37",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Dofteana Bacău",
					"leavesAt": "06:41",
					"arrivesAt": "06:46",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Dofteana Bacău",
					"to": "Cireşoaia h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cireşoaia h.",
					"to": "Saline hc.",
					"leavesAt": "06:53",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Saline hc.",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "06:59",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Viişoara h",
					"leavesAt": "07:02",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Viişoara h",
					"to": "Oneşti",
					"leavesAt": "07:07",
					"arrivesAt": "07:19",
					"waitsAtSource": 30,
					"distance": 9100
				},
				{
					"from": "Oneşti",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "07:21",
					"arrivesAt": "07:26",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Borzeşti Bacău",
					"leavesAt": "07:27",
					"arrivesAt": "07:36",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Căiuţi Hm.",
					"leavesAt": "07:37",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Bâlca hc.",
					"leavesAt": "07:45",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Bâlca hc.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Urecheşti Hm.",
					"leavesAt": "07:56",
					"arrivesAt": "08:00",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Adjud",
					"leavesAt": "08:01",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "08:15",
					"arrivesAt": "08:23",
					"waitsAtSource": 180,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "08:24",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "08:34",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "08:39",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "08:51",
					"arrivesAt": "08:59",
					"waitsAtSource": 120,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "09:00",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 11700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4702",
			"segments": [
				{
					"from": "Beclean pe Someş",
					"to": "Cociu h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:45",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Cociu h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "06:46",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Nimigea h.",
					"leavesAt": "06:50",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Nimigea h.",
					"to": "Nimigea Hm.",
					"leavesAt": "06:55",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Nimigea Hm.",
					"to": "Mititei h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mititei h.",
					"to": "Salva",
					"leavesAt": "07:05",
					"arrivesAt": "07:08",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Salva",
					"to": "Năsăud h.",
					"leavesAt": "07:09",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Năsăud h.",
					"to": "Năsăud",
					"leavesAt": "07:14",
					"arrivesAt": "07:17",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Năsăud",
					"to": "Rebrişoara Hm.",
					"leavesAt": "07:20",
					"arrivesAt": "07:25",
					"waitsAtSource": 180,
					"distance": 4800
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Nepos h.",
					"leavesAt": "07:26",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Nepos h.",
					"to": "Feldru Hm.",
					"leavesAt": "07:33",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Feldru Hm.",
					"to": "Podereia Feldrului h.",
					"leavesAt": "07:41",
					"arrivesAt": "07:44",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Ilva Mică",
					"leavesAt": "07:45",
					"arrivesAt": "07:50",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "460",
			"segments": [
				{
					"from": "Ruse",
					"to": "Giurgiu Nord",
					"leavesAt": "16:10",
					"arrivesAt": "16:35",
					"waitsAtSource": 0,
					"distance": 16000
				},
				{
					"from": "Giurgiu Nord",
					"to": "Videle",
					"leavesAt": "16:58",
					"arrivesAt": "18:07",
					"waitsAtSource": 1380,
					"distance": 63000
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "18:08",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 50900
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181001",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6404",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "10:42",
					"arrivesAt": "10:49",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Ciurea Hm.",
					"leavesAt": "10:50",
					"arrivesAt": "10:57",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ciurea Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "10:58",
					"arrivesAt": "11:07",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Bârnova Hm.",
					"leavesAt": "11:08",
					"arrivesAt": "11:17",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Grajduri",
					"leavesAt": "11:18",
					"arrivesAt": "11:25",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Grajduri",
					"to": "Scânteia Hm.",
					"leavesAt": "11:26",
					"arrivesAt": "11:33",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Scânteia Hm.",
					"to": "Rebricea Hm.",
					"leavesAt": "11:38",
					"arrivesAt": "11:44",
					"waitsAtSource": 300,
					"distance": 5500
				},
				{
					"from": "Rebricea Hm.",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "11:45",
					"arrivesAt": "11:50",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Buhăieşti",
					"leavesAt": "11:51",
					"arrivesAt": "11:56",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Buhăieşti",
					"to": "Bârzeşti h.",
					"leavesAt": "11:57",
					"arrivesAt": "12:03",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bârzeşti h.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "12:04",
					"arrivesAt": "12:08",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bălteni Hm.",
					"leavesAt": "12:09",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bălteni Hm.",
					"to": "Vaslui",
					"leavesAt": "12:15",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Vaslui",
					"to": "Munteni Hm.",
					"leavesAt": "12:24",
					"arrivesAt": "12:29",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Munteni Hm.",
					"to": "Bulboaca h.",
					"leavesAt": "12:30",
					"arrivesAt": "12:35",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bulboaca h.",
					"to": "Crasna",
					"leavesAt": "12:36",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Crasna",
					"to": "Roşieşti hc.",
					"leavesAt": "12:44",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Roşieşti hc.",
					"to": "Dodeşti hc.",
					"leavesAt": "12:52",
					"arrivesAt": "12:58",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Dodeşti hc.",
					"to": "Banca Hm.",
					"leavesAt": "12:59",
					"arrivesAt": "13:05",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Banca Hm.",
					"to": "Zorleni",
					"leavesAt": "13:06",
					"arrivesAt": "13:16",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Zorleni",
					"to": "Bârlad",
					"leavesAt": "13:17",
					"arrivesAt": "13:26",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1551",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "17:37",
					"arrivesAt": "17:51",
					"waitsAtSource": 0,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Periş",
					"leavesAt": "17:52",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 13300
				},
				{
					"from": "Periş",
					"to": "Crivina",
					"leavesAt": "18:07",
					"arrivesAt": "18:14",
					"waitsAtSource": 360,
					"distance": 9500
				},
				{
					"from": "Crivina",
					"to": "Ploieşti Sud",
					"leavesAt": "18:15",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 20500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1585",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ciulniţa",
					"leavesAt": "14:00",
					"arrivesAt": "14:55",
					"waitsAtSource": 0,
					"distance": 108900
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "14:56",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "15:20",
					"arrivesAt": "15:38",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "15:39",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "15:56",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 34600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "381",
			"segments": [
				{
					"from": "Vadu Siretului",
					"to": "Vicşani",
					"leavesAt": "13:40",
					"arrivesAt": "14:02",
					"waitsAtSource": 0,
					"distance": 10600
				},
				{
					"from": "Vicşani",
					"to": "Dorneşti",
					"leavesAt": "14:52",
					"arrivesAt": "15:06",
					"waitsAtSource": 3000,
					"distance": 8300
				},
				{
					"from": "Dorneşti",
					"to": "Suceava Nord",
					"leavesAt": "15:07",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 30000
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "15:53",
					"arrivesAt": "15:58",
					"waitsAtSource": 1020,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "16:01",
					"arrivesAt": "16:14",
					"waitsAtSource": 180,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "16:15",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "16:35",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Roman",
					"leavesAt": "16:52",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 40200
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "17:22",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 43800
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "17:59",
					"arrivesAt": "18:40",
					"waitsAtSource": 420,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "18:41",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "19:09",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "19:36",
					"arrivesAt": "20:13",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "20:14",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "20:47",
					"arrivesAt": "21:19",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "21:20",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "21:57",
					"arrivesAt": "22:47",
					"waitsAtSource": 120,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5302",
			"segments": [
				{
					"from": "Comăneşti",
					"to": "Valea Uzului Hm.",
					"leavesAt": "04:25",
					"arrivesAt": "04:35",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Dofteana Bacău",
					"leavesAt": "04:39",
					"arrivesAt": "04:44",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Dofteana Bacău",
					"to": "Cireşoaia h.",
					"leavesAt": "04:45",
					"arrivesAt": "04:50",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cireşoaia h.",
					"to": "Saline hc.",
					"leavesAt": "04:51",
					"arrivesAt": "04:56",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Saline hc.",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "04:57",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Viişoara h",
					"leavesAt": "05:01",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Viişoara h",
					"to": "Trotuş h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Trotuş h.",
					"to": "Oneşti",
					"leavesAt": "05:15",
					"arrivesAt": "05:24",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Oneşti",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Borzeşti Bacău",
					"leavesAt": "05:29",
					"arrivesAt": "05:35",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Căiuţi Hm.",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Bâlca hc.",
					"leavesAt": "05:42",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Bâlca hc.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Urecheşti Hm.",
					"leavesAt": "05:54",
					"arrivesAt": "05:57",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Adjud",
					"leavesAt": "05:58",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "06:11",
					"arrivesAt": "06:18",
					"waitsAtSource": 120,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:22",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "06:30",
					"arrivesAt": "06:34",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "06:35",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "06:50",
					"arrivesAt": "06:58",
					"waitsAtSource": 300,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "06:59",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Focşani",
					"to": "Coteşti Hm.",
					"leavesAt": "07:23",
					"arrivesAt": "07:30",
					"waitsAtSource": 480,
					"distance": 7900
				},
				{
					"from": "Coteşti Hm.",
					"to": "Gugeşti",
					"leavesAt": "07:31",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Gugeşti",
					"to": "Sihlea Hm.",
					"leavesAt": "07:40",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sihlea Hm.",
					"to": "Voetin h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Voetin h.",
					"to": "Râmnicu Sărat",
					"leavesAt": "07:56",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Zoita Hm.",
					"leavesAt": "08:07",
					"arrivesAt": "08:17",
					"waitsAtSource": 120,
					"distance": 11300
				},
				{
					"from": "Zoita Hm.",
					"to": "Boboc Hm.",
					"leavesAt": "08:18",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Boboc Hm.",
					"to": "Buzău",
					"leavesAt": "08:28",
					"arrivesAt": "08:40",
					"waitsAtSource": 60,
					"distance": 11500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2042",
			"segments": [
				{
					"from": "Săvârşin",
					"to": "Toc h.",
					"leavesAt": "04:42",
					"arrivesAt": "04:49",
					"waitsAtSource": 0,
					"distance": 7400
				},
				{
					"from": "Toc h.",
					"to": "Ilteu",
					"leavesAt": "04:50",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ilteu",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "04:56",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Zam",
					"leavesAt": "05:01",
					"arrivesAt": "05:07",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Zam",
					"to": "Burjuc h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Burjuc h.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:26",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Gurasada Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Gurasada Hm.",
					"to": "Ilia",
					"leavesAt": "05:35",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "05:47",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia h.",
					"leavesAt": "05:59",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Mintia",
					"leavesAt": "06:02",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "06:07",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "06:24",
					"arrivesAt": "06:30",
					"waitsAtSource": 30,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1546",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Gherla",
					"leavesAt": "14:00",
					"arrivesAt": "14:58",
					"waitsAtSource": 0,
					"distance": 44900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "14:59",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Câţcău h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:36",
					"waitsAtSource": 120,
					"distance": 12700
				},
				{
					"from": "Câţcău h.",
					"to": "Gâlgău",
					"leavesAt": "15:37",
					"arrivesAt": "15:48",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Gâlgău",
					"to": "Ileanda",
					"leavesAt": "15:49",
					"arrivesAt": "16:08",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Ileanda",
					"to": "Letca Hm.",
					"leavesAt": "16:09",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 13600
				},
				{
					"from": "Letca Hm.",
					"to": "Cuciulat Hm.",
					"leavesAt": "16:27",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Băbuţeni Hm.",
					"leavesAt": "16:35",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Băbuţeni Hm.",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Jibou",
					"leavesAt": "16:55",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Jibou",
					"to": "Mirşid Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:33",
					"waitsAtSource": 780,
					"distance": 11700
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "17:38",
					"arrivesAt": "17:55",
					"waitsAtSource": 300,
					"distance": 12000
				},
				{
					"from": "Zalău Nord",
					"to": "Sărmăşag",
					"leavesAt": "17:57",
					"arrivesAt": "18:16",
					"waitsAtSource": 120,
					"distance": 22300
				},
				{
					"from": "Sărmăşag",
					"to": "Acâş Hm.",
					"leavesAt": "18:17",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 22500
				},
				{
					"from": "Acâş Hm.",
					"to": "Tăşnad",
					"leavesAt": "18:37",
					"arrivesAt": "18:48",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Tăşnad",
					"to": "Carei",
					"leavesAt": "18:49",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 27800
				},
				{
					"from": "Carei",
					"to": "Satu Mare",
					"leavesAt": "19:21",
					"arrivesAt": "19:49",
					"waitsAtSource": 600,
					"distance": 36000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "364",
			"segments": [
				{
					"from": "Oradea",
					"to": "Episcopia Bihor",
					"leavesAt": "11:30",
					"arrivesAt": "11:38",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Episcopia Bihor",
					"to": "Biharkeresztes",
					"leavesAt": "11:53",
					"arrivesAt": "12:08",
					"waitsAtSource": 900,
					"distance": 12500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3534",
			"segments": [
				{
					"from": "Rupea",
					"to": "Mateiaş h.",
					"leavesAt": "11:49",
					"arrivesAt": "12:03",
					"waitsAtSource": 0,
					"distance": 10700
				},
				{
					"from": "Mateiaş h.",
					"to": "Racoş Hm.",
					"leavesAt": "12:04",
					"arrivesAt": "12:10",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Racoş Hm.",
					"to": "Augustin Hm.",
					"leavesAt": "12:11",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Augustin Hm.",
					"to": "Ormeniş h.",
					"leavesAt": "12:28",
					"arrivesAt": "12:36",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ormeniş h.",
					"to": "Apaţa",
					"leavesAt": "12:37",
					"arrivesAt": "12:47",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Apaţa",
					"to": "Măieruş h.",
					"leavesAt": "12:48",
					"arrivesAt": "12:53",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Măieruş h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "12:54",
					"arrivesAt": "12:59",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Rotbav h.",
					"leavesAt": "13:00",
					"arrivesAt": "13:05",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Rotbav h.",
					"to": "Feldioara Hm.",
					"leavesAt": "13:06",
					"arrivesAt": "13:13",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Bod Hm.",
					"leavesAt": "13:14",
					"arrivesAt": "13:29",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Bod Hm.",
					"to": "Stupini Hm.",
					"leavesAt": "13:30",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Stupini Hm.",
					"to": "Braşov",
					"leavesAt": "13:40",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2444",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Azomureş h.",
					"leavesAt": "22:15",
					"arrivesAt": "22:20",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "22:21",
					"arrivesAt": "22:24",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "22:25",
					"arrivesAt": "22:29",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Vidrasău h.",
					"leavesAt": "22:30",
					"arrivesAt": "22:35",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vidrasău h.",
					"to": "Chirileu h.",
					"leavesAt": "22:36",
					"arrivesAt": "22:40",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Chirileu h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "22:41",
					"arrivesAt": "22:46",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Ogra h.",
					"leavesAt": "22:47",
					"arrivesAt": "22:50",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Ogra h.",
					"to": "Cipău h.",
					"leavesAt": "22:51",
					"arrivesAt": "22:55",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cipău h.",
					"to": "Iernut",
					"leavesAt": "22:56",
					"arrivesAt": "23:01",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iernut",
					"to": "Cuci h.",
					"leavesAt": "23:02",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cuci h.",
					"to": "Bogata Mureş h.",
					"leavesAt": "23:08",
					"arrivesAt": "23:14",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Luduş",
					"leavesAt": "23:15",
					"arrivesAt": "23:19",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Luduş",
					"to": "Cheţani h.",
					"leavesAt": "23:20",
					"arrivesAt": "23:26",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Cheţani h.",
					"to": "Gura Arieşului h.",
					"leavesAt": "23:27",
					"arrivesAt": "23:33",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Lunca Mureşului h.",
					"leavesAt": "23:34",
					"arrivesAt": "23:38",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Războieni",
					"leavesAt": "23:39",
					"arrivesAt": "23:44",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "23:45",
					"arrivesAt": "23:49",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Unirea Hm.",
					"leavesAt": "23:50",
					"arrivesAt": "23:56",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Unirea Hm.",
					"to": "Decea h.",
					"leavesAt": "23:57",
					"arrivesAt": "00:00",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Decea h.",
					"to": "Mirăslău h.",
					"leavesAt": "00:01",
					"arrivesAt": "00:05",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Mirăslău h.",
					"to": "Aiud Hm.",
					"leavesAt": "00:06",
					"arrivesAt": "00:13",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "00:14",
					"arrivesAt": "00:28",
					"waitsAtSource": 60,
					"distance": 13100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7372",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "17:00",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "17:01",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Zagna Vădeni h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Vădeni Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vădeni Hm.",
					"to": "Baldovineşti Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Brăila",
					"leavesAt": "17:23",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Brăila",
					"to": "Lacu Sărat",
					"leavesAt": "17:32",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Lacu Sărat",
					"to": "Traian Sat Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Urleasca Hm.",
					"leavesAt": "17:50",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Urleasca Hm.",
					"to": "Plopu",
					"leavesAt": "17:58",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Plopu",
					"to": "Ianca hc.",
					"leavesAt": "18:06",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ianca hc.",
					"to": "Deduleşti Hm.",
					"leavesAt": "18:10",
					"arrivesAt": "18:18",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Găiseanca h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Găiseanca h.",
					"to": "Făurei",
					"leavesAt": "18:24",
					"arrivesAt": "18:29",
					"waitsAtSource": 30,
					"distance": 3900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3516",
			"segments": [
				{
					"from": "Mediaş",
					"to": "Bratei h.",
					"leavesAt": "16:26",
					"arrivesAt": "16:34",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Bratei h.",
					"to": "Aţel Hm.",
					"leavesAt": "16:35",
					"arrivesAt": "16:43",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Aţel Hm.",
					"to": "Dumbrăveni",
					"leavesAt": "16:44",
					"arrivesAt": "16:54",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Dumbrăveni",
					"to": "Luna h.",
					"leavesAt": "16:55",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Luna h.",
					"to": "Daneş Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Daneş Hm.",
					"to": "Sighişoara",
					"leavesAt": "17:11",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1522",
			"segments": [
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "14:16",
					"arrivesAt": "14:21",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "14:22",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 16200
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Govora",
					"leavesAt": "14:45",
					"arrivesAt": "14:55",
					"waitsAtSource": 300,
					"distance": 11400
				},
				{
					"from": "Govora",
					"to": "Băbeni",
					"leavesAt": "14:56",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Băbeni",
					"to": "Drăgăşani",
					"leavesAt": "15:06",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 33200
				},
				{
					"from": "Drăgăşani",
					"to": "Piatra Olt",
					"leavesAt": "15:30",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 33800
				},
				{
					"from": "Piatra Olt",
					"to": "Caracal",
					"leavesAt": "15:58",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 32400
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "16:33",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Roşiori Nord",
					"leavesAt": "16:49",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "17:23",
					"arrivesAt": "18:06",
					"waitsAtSource": 240,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "18:14",
					"arrivesAt": "19:06",
					"waitsAtSource": 480,
					"distance": 50900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3118",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Vest Hm.",
					"leavesAt": "19:55",
					"arrivesAt": "20:04",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "20:11",
					"arrivesAt": "20:24",
					"waitsAtSource": 420,
					"distance": 10800
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Cefa Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Cefa Hm.",
					"to": "Mădăraş Bihor h.",
					"leavesAt": "20:39",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Mădăraş Bihor h.",
					"to": "Salonta",
					"leavesAt": "20:52",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Salonta",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "21:06",
					"arrivesAt": "21:17",
					"waitsAtSource": 480,
					"distance": 10200
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Boiu Bihor h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Boiu Bihor h.",
					"to": "Tămaşda h.",
					"leavesAt": "21:23",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tămaşda h.",
					"to": "Zerind Hm.",
					"leavesAt": "21:29",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Zerind Hm.",
					"to": "Chişineu Criş",
					"leavesAt": "21:43",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Chişineu Criş",
					"to": "Nădab",
					"leavesAt": "22:02",
					"arrivesAt": "22:08",
					"waitsAtSource": 720,
					"distance": 4900
				},
				{
					"from": "Nădab",
					"to": "Şimand Hm.",
					"leavesAt": "22:09",
					"arrivesAt": "22:17",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şimand Hm.",
					"to": "Comlăuş h.",
					"leavesAt": "22:18",
					"arrivesAt": "22:26",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Comlăuş h.",
					"to": "Sântana",
					"leavesAt": "22:27",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "22:33",
					"arrivesAt": "22:44",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utviniş h.",
					"leavesAt": "22:45",
					"arrivesAt": "22:50",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Utviniş h.",
					"to": "Arad",
					"leavesAt": "22:51",
					"arrivesAt": "23:07",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "23:34",
					"arrivesAt": "23:41",
					"waitsAtSource": 1620,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Şag Hm.",
					"leavesAt": "23:43",
					"arrivesAt": "23:57",
					"waitsAtSource": 120,
					"distance": 11000
				},
				{
					"from": "Şag Hm.",
					"to": "Vinga Hm.",
					"leavesAt": "23:58",
					"arrivesAt": "00:05",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vinga Hm.",
					"to": "Orţişoara",
					"leavesAt": "00:06",
					"arrivesAt": "00:11",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Orţişoara",
					"to": "Băile Călacea",
					"leavesAt": "00:12",
					"arrivesAt": "00:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Băile Călacea",
					"to": "Sânandrei Hm.",
					"leavesAt": "00:18",
					"arrivesAt": "00:24",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "00:25",
					"arrivesAt": "00:31",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h",
					"leavesAt": "00:32",
					"arrivesAt": "00:34",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Ronaţ Triaj Cab 1 h",
					"leavesAt": "00:35",
					"arrivesAt": "00:37",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab 1 h",
					"to": "Timişoara Nord",
					"leavesAt": "00:38",
					"arrivesAt": "00:43",
					"waitsAtSource": 60,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9414",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:22",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "08:23",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "08:39",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9349",
			"segments": [
				{
					"from": "Videle",
					"to": "Răduleşti Hm.",
					"leavesAt": "21:36",
					"arrivesAt": "21:46",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "21:47",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Târnavele Hm.",
					"to": "Vlaşca Hm.",
					"leavesAt": "21:56",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Răsuceni h.",
					"leavesAt": "22:05",
					"arrivesAt": "22:11",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Răsuceni h.",
					"to": "Toporu",
					"leavesAt": "22:12",
					"arrivesAt": "22:16",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Toporu",
					"to": "Chiriacu Hm.",
					"leavesAt": "22:17",
					"arrivesAt": "22:28",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Stăneşti Hm.",
					"leavesAt": "22:29",
					"arrivesAt": "22:36",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Onceşti h.",
					"leavesAt": "22:37",
					"arrivesAt": "22:41",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Onceşti h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "22:42",
					"arrivesAt": "22:48",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Cetatea h.",
					"leavesAt": "22:49",
					"arrivesAt": "22:51",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cetatea h.",
					"to": "Giurgiu Nord",
					"leavesAt": "22:52",
					"arrivesAt": "22:58",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Giurgiu Nord",
					"to": "Giurgiu",
					"leavesAt": "22:59",
					"arrivesAt": "23:04",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2208",
			"segments": [
				{
					"from": "Curtici",
					"to": "Şofronea",
					"leavesAt": "13:45",
					"arrivesAt": "13:53",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Şofronea",
					"to": "Arad",
					"leavesAt": "13:54",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "368",
			"segments": [
				{
					"from": "Salonta",
					"to": "Cefa Hm.",
					"leavesAt": "13:42",
					"arrivesAt": "13:54",
					"waitsAtSource": 0,
					"distance": 12500
				},
				{
					"from": "Cefa Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "13:55",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Oradea Vest Hm.",
					"leavesAt": "14:06",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Oradea",
					"leavesAt": "14:18",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Oradea",
					"to": "Episcopia Bihor",
					"leavesAt": "14:41",
					"arrivesAt": "14:49",
					"waitsAtSource": 960,
					"distance": 5700
				},
				{
					"from": "Episcopia Bihor",
					"to": "Biharkeresztes",
					"leavesAt": "15:04",
					"arrivesAt": "15:19",
					"waitsAtSource": 900,
					"distance": 12500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1843",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Gherla",
					"leavesAt": "05:18",
					"arrivesAt": "06:15",
					"waitsAtSource": 0,
					"distance": 44900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "06:16",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "06:37",
					"arrivesAt": "06:44",
					"waitsAtSource": 120,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Beclean pe Someş",
					"leavesAt": "06:45",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 21900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4535",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Azomureş h.",
					"leavesAt": "16:14",
					"arrivesAt": "16:19",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "16:20",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Vidrasău h.",
					"leavesAt": "16:29",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vidrasău h.",
					"to": "Chirileu h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Chirileu h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Ogra h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Ogra h.",
					"to": "Cipău h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:54",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cipău h.",
					"to": "Iernut",
					"leavesAt": "16:55",
					"arrivesAt": "17:00",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iernut",
					"to": "Cuci h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Cuci h.",
					"to": "Bogata Mureş h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Luduş",
					"leavesAt": "17:14",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Luduş",
					"to": "Cheţani h.",
					"leavesAt": "17:19",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Cheţani h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "17:26",
					"arrivesAt": "17:30",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Gura Arieşului h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Lunca Mureşului h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Războieni",
					"leavesAt": "17:41",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5506",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "23:06",
					"arrivesAt": "23:11",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "23:13",
					"arrivesAt": "23:20",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "23:21",
					"arrivesAt": "23:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "23:29",
					"arrivesAt": "23:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "23:36",
					"arrivesAt": "23:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "23:43",
					"arrivesAt": "23:48",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "23:49",
					"arrivesAt": "23:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "23:59",
					"arrivesAt": "00:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "00:05",
					"arrivesAt": "00:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "00:11",
					"arrivesAt": "00:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "00:17",
					"arrivesAt": "00:23",
					"waitsAtSource": 60,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4455",
			"segments": [
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "18:22",
					"arrivesAt": "18:39",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "18:40",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "18:47",
					"arrivesAt": "18:52",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "18:53",
					"arrivesAt": "19:01",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5525",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Topile h.",
					"leavesAt": "09:28",
					"arrivesAt": "09:33",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Topile h.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "09:34",
					"arrivesAt": "09:42",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Timişeşti Hm.",
					"leavesAt": "09:43",
					"arrivesAt": "09:50",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Plăieşu h.",
					"leavesAt": "09:51",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Plăieşu h.",
					"to": "Sfântu Mina h.",
					"leavesAt": "09:57",
					"arrivesAt": "10:00",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Târgu Neamţ",
					"leavesAt": "10:01",
					"arrivesAt": "10:12",
					"waitsAtSource": 30,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5732",
			"segments": [
				{
					"from": "Cacica Hm.",
					"to": "Pârteşti h.",
					"leavesAt": "06:52",
					"arrivesAt": "06:59",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Pârteşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Soloneţ h.",
					"to": "Todireşti h.",
					"leavesAt": "07:07",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Todireşti h.",
					"to": "Părhăuţi h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Părhăuţi h.",
					"to": "Dărmăneşti",
					"leavesAt": "07:24",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "07:33",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "07:41",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7360",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "04:31",
					"arrivesAt": "04:43",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "04:44",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Zagna Vădeni h.",
					"leavesAt": "04:52",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Vădeni Hm.",
					"leavesAt": "04:56",
					"arrivesAt": "05:00",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vădeni Hm.",
					"to": "Baldovineşti Hm.",
					"leavesAt": "05:01",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Brăila",
					"leavesAt": "05:08",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Brăila",
					"to": "Lacu Sărat",
					"leavesAt": "05:44",
					"arrivesAt": "05:52",
					"waitsAtSource": 1620,
					"distance": 9700
				},
				{
					"from": "Lacu Sărat",
					"to": "Traian Sat Hm.",
					"leavesAt": "05:53",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Urleasca Hm.",
					"leavesAt": "06:03",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Urleasca Hm.",
					"to": "Plopu",
					"leavesAt": "06:11",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Plopu",
					"to": "Ianca hc.",
					"leavesAt": "06:19",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ianca hc.",
					"to": "Deduleşti Hm.",
					"leavesAt": "06:23",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Găiseanca h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Găiseanca h.",
					"to": "Făurei",
					"leavesAt": "06:37",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Făurei",
					"to": "CTF Făurei h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "CTF Făurei h.",
					"to": "Vizireni h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:51",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vizireni h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "06:56",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "06:57",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Movila Oii h.",
					"to": "Cilibia Hm.",
					"leavesAt": "07:03",
					"arrivesAt": "07:07",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cilibia Hm.",
					"to": "Bentu h.",
					"leavesAt": "07:08",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bentu h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "07:13",
					"arrivesAt": "07:17",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Tăbărăşti h.",
					"leavesAt": "07:18",
					"arrivesAt": "07:20",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Buzău Sud",
					"leavesAt": "07:21",
					"arrivesAt": "07:26",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Buzău Sud",
					"to": "Buzău",
					"leavesAt": "07:27",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3006",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "13:10",
					"arrivesAt": "13:17",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Timişu de Jos h.",
					"leavesAt": "13:18",
					"arrivesAt": "13:24",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "13:25",
					"arrivesAt": "13:32",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Predeal",
					"leavesAt": "13:33",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "13:52",
					"arrivesAt": "14:01",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "14:02",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "14:08",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "14:12",
					"arrivesAt": "14:16",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "14:17",
					"arrivesAt": "14:19",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "14:20",
					"arrivesAt": "14:24",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Comarnic",
					"leavesAt": "14:25",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Comarnic",
					"to": "Breaza hc.",
					"leavesAt": "14:34",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "14:42",
					"arrivesAt": "14:47",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "14:48",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "14:59",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "15:09",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "15:28",
					"arrivesAt": "15:31",
					"waitsAtSource": 660,
					"distance": 2900
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Brazi",
					"leavesAt": "15:32",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "15:38",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "15:44",
					"arrivesAt": "15:48",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "15:49",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "15:54",
					"arrivesAt": "15:59",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Buftea",
					"leavesAt": "16:00",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 13300
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "16:10",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "16:19",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "16:24",
					"arrivesAt": "16:32",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5203",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:17",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "06:23",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "06:36",
					"arrivesAt": "06:48",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Urecheşti Hm.",
					"leavesAt": "06:50",
					"arrivesAt": "07:00",
					"waitsAtSource": 120,
					"distance": 9700
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Bâlca hc.",
					"leavesAt": "07:06",
					"arrivesAt": "07:10",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Bâlca hc.",
					"to": "Căiuţi Hm.",
					"leavesAt": "07:11",
					"arrivesAt": "07:16",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Borzeşti Bacău",
					"leavesAt": "07:17",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "07:28",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Oneşti",
					"leavesAt": "07:34",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Oneşti",
					"to": "Viişoara h",
					"leavesAt": "07:46",
					"arrivesAt": "07:56",
					"waitsAtSource": 300,
					"distance": 9100
				},
				{
					"from": "Viişoara h",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "07:57",
					"arrivesAt": "08:03",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Saline hc.",
					"leavesAt": "08:04",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Saline hc.",
					"to": "Cireşoaia h.",
					"leavesAt": "08:08",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cireşoaia h.",
					"to": "Dofteana Bacău",
					"leavesAt": "08:13",
					"arrivesAt": "08:18",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dofteana Bacău",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:24",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Valea Uzului Hm.",
					"leavesAt": "08:25",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Comăneşti",
					"leavesAt": "08:31",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Comăneşti",
					"to": "Asău Hm.",
					"leavesAt": "08:41",
					"arrivesAt": "08:47",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Asău Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "08:48",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Caraliţa h.",
					"to": "Goioasa Hm.",
					"leavesAt": "08:53",
					"arrivesAt": "08:58",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Goioasa Hm.",
					"to": "Simbrea Hm.",
					"leavesAt": "08:59",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Simbrea Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "09:08",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Palanca Hm.",
					"leavesAt": "09:13",
					"arrivesAt": "09:18",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Palanca Hm.",
					"to": "Ghimeş",
					"leavesAt": "09:19",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Ghimeş",
					"to": "Bolovăniş h.",
					"leavesAt": "09:31",
					"arrivesAt": "09:36",
					"waitsAtSource": 120,
					"distance": 3900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "09:37",
					"arrivesAt": "09:43",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Tarcău h.",
					"leavesAt": "09:44",
					"arrivesAt": "09:48",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "09:49",
					"arrivesAt": "09:54",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Utuşoiu h.",
					"leavesAt": "09:55",
					"arrivesAt": "10:00",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Utuşoiu h.",
					"to": "Livezi Ciuc",
					"leavesAt": "10:01",
					"arrivesAt": "10:07",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Caracău h.",
					"leavesAt": "10:10",
					"arrivesAt": "10:14",
					"waitsAtSource": 180,
					"distance": 2100
				},
				{
					"from": "Caracău h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "10:15",
					"arrivesAt": "10:22",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "10:23",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Mihăileni Hm.",
					"leavesAt": "10:28",
					"arrivesAt": "10:32",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Siculeni",
					"leavesAt": "10:33",
					"arrivesAt": "10:39",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "10:46",
					"arrivesAt": "10:54",
					"waitsAtSource": 420,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2082",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Lunca Jiului hc.",
					"leavesAt": "08:00",
					"arrivesAt": "08:03",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Lunca Jiului hc.",
					"to": "Livezeni",
					"leavesAt": "08:04",
					"arrivesAt": "08:09",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "08:10",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Pietrele Albe Hm.",
					"leavesAt": "08:18",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Pietrele Albe Hm.",
					"to": "Km. 105+600 h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Km. 105+600 h.",
					"to": "Lainici Hm.",
					"leavesAt": "08:33",
					"arrivesAt": "08:40",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Lainici Hm.",
					"to": "Meri",
					"leavesAt": "08:41",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Meri",
					"to": "Valea Sadului Hm.",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 300,
					"distance": 4900
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Bumbeşti Hm.",
					"leavesAt": "09:03",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bumbeşti Hm.",
					"to": "Parângu Hm.",
					"leavesAt": "09:09",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Parângu Hm.",
					"to": "Ezureni h.",
					"leavesAt": "09:17",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Ezureni h.",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "09:21",
					"arrivesAt": "09:25",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Ramificaţia C.A.M. h.",
					"leavesAt": "09:26",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ramificaţia C.A.M. h.",
					"to": "Târgu Jiu",
					"leavesAt": "09:30",
					"arrivesAt": "09:34",
					"waitsAtSource": 30,
					"distance": 800
				},
				{
					"from": "Târgu Jiu",
					"to": "Budieni h.",
					"leavesAt": "09:50",
					"arrivesAt": "10:02",
					"waitsAtSource": 960,
					"distance": 9900
				},
				{
					"from": "Budieni h.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "10:03",
					"arrivesAt": "10:09",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Scoarţa h.",
					"leavesAt": "10:10",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Scoarţa h.",
					"to": "Pojogeni Hm.",
					"leavesAt": "10:14",
					"arrivesAt": "10:17",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "10:18",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cărbuneşti",
					"to": "Jupâneşti Hm.",
					"leavesAt": "10:25",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "10:31",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "10:38",
					"arrivesAt": "10:44",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Musculeşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "10:45",
					"arrivesAt": "10:50",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "10:51",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Gilort Hm.",
					"leavesAt": "11:00",
					"arrivesAt": "11:06",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gilort Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "11:07",
					"arrivesAt": "11:10",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Floreşti hc.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "11:11",
					"arrivesAt": "11:16",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Bungeţel h.",
					"leavesAt": "11:17",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bungeţel h.",
					"to": "Filiaşi",
					"leavesAt": "11:21",
					"arrivesAt": "11:25",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "11:26",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "11:30",
					"arrivesAt": "11:34",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "11:35",
					"arrivesAt": "11:38",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "11:39",
					"arrivesAt": "11:44",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "11:45",
					"arrivesAt": "11:48",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "11:49",
					"arrivesAt": "11:54",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "11:55",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "11:58",
					"arrivesAt": "12:02",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "12:03",
					"arrivesAt": "12:05",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "12:06",
					"arrivesAt": "12:10",
					"waitsAtSource": 30,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1596",
			"segments": [
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "14:10",
					"arrivesAt": "14:49",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "14:50",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Roşiori Nord",
					"leavesAt": "15:05",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "15:38",
					"arrivesAt": "16:23",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Grădinari",
					"leavesAt": "16:24",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 25400
				},
				{
					"from": "Grădinari",
					"to": "Bucureşti Nord",
					"leavesAt": "16:53",
					"arrivesAt": "17:21",
					"waitsAtSource": 240,
					"distance": 25500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5581",
			"segments": [
				{
					"from": "Vereşti",
					"to": "Bucecea Hm",
					"leavesAt": "06:14",
					"arrivesAt": "06:38",
					"waitsAtSource": 0,
					"distance": 19100
				},
				{
					"from": "Bucecea Hm",
					"to": "Leorda Hm.",
					"leavesAt": "06:39",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Leorda Hm.",
					"to": "Botoşani",
					"leavesAt": "06:57",
					"arrivesAt": "07:20",
					"waitsAtSource": 60,
					"distance": 15500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8082",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "08:50",
					"arrivesAt": "09:01",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "09:03",
					"arrivesAt": "09:10",
					"waitsAtSource": 120,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Bucureşti Băneasa",
					"leavesAt": "09:28",
					"arrivesAt": "09:37",
					"waitsAtSource": 1080,
					"distance": 9500
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Bucureşti Nord",
					"leavesAt": "09:39",
					"arrivesAt": "09:52",
					"waitsAtSource": 120,
					"distance": 6600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4518",
			"segments": [
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "11:00",
					"arrivesAt": "11:09",
					"waitsAtSource": 0,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1791",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "18:30",
					"arrivesAt": "19:30",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "19:32",
					"arrivesAt": "19:51",
					"waitsAtSource": 120,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "19:52",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "20:16",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5441",
			"segments": [
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "02:39",
					"arrivesAt": "03:12",
					"waitsAtSource": 0,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "03:15",
					"arrivesAt": "03:22",
					"waitsAtSource": 180,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "03:23",
					"arrivesAt": "03:29",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "03:30",
					"arrivesAt": "03:34",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "03:35",
					"arrivesAt": "03:40",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "03:41",
					"arrivesAt": "03:45",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "03:46",
					"arrivesAt": "03:50",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani",
					"leavesAt": "03:51",
					"arrivesAt": "04:01",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "04:09",
					"arrivesAt": "04:14",
					"waitsAtSource": 480,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "04:15",
					"arrivesAt": "04:25",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "04:26",
					"arrivesAt": "04:31",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "04:32",
					"arrivesAt": "04:37",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "04:38",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "04:44",
					"arrivesAt": "04:50",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "04:51",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "04:58",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "05:05",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "05:12",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "05:21",
					"arrivesAt": "05:27",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2181",
			"segments": [
				{
					"from": "Margina",
					"to": "Făget",
					"leavesAt": "05:01",
					"arrivesAt": "05:08",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Făget",
					"to": "Răchita h.",
					"leavesAt": "05:09",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Răchita h.",
					"to": "Mănăştur Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mănăştur Hm.",
					"to": "Traian Vuia h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:24",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Traian Vuia h.",
					"to": "Susani Bega h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Susani Bega h.",
					"to": "Cliciova",
					"leavesAt": "05:29",
					"arrivesAt": "05:33",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Cliciova",
					"to": "Nevrincea h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Nevrincea h.",
					"to": "Balinţ h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Balinţ h.",
					"to": "Păru h.",
					"leavesAt": "05:43",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Păru h.",
					"to": "Coşteiu Mare Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Coşteiu Mare Hm.",
					"to": "Lugoj Nord h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Lugoj Nord h.",
					"to": "Lugoj",
					"leavesAt": "05:58",
					"arrivesAt": "06:07",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5635",
			"segments": [
				{
					"from": "Dărmăneşti",
					"to": "Milişăuţi Hm.",
					"leavesAt": "16:07",
					"arrivesAt": "16:18",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Ţibeni h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ţibeni h.",
					"to": "Dorneşti",
					"leavesAt": "16:28",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5420",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "10:54",
					"arrivesAt": "11:08",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "11:09",
					"arrivesAt": "11:16",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "11:17",
					"arrivesAt": "11:23",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "11:24",
					"arrivesAt": "11:31",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "11:32",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "11:42",
					"arrivesAt": "11:48",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "11:49",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "11:54",
					"arrivesAt": "12:03",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "12:04",
					"arrivesAt": "12:18",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "12:38",
					"arrivesAt": "12:45",
					"waitsAtSource": 1200,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "12:46",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "12:52",
					"arrivesAt": "12:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "12:57",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "13:03",
					"arrivesAt": "13:07",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "13:08",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "13:15",
					"arrivesAt": "13:24",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "13:26",
					"arrivesAt": "13:33",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "13:34",
					"arrivesAt": "13:38",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "13:39",
					"arrivesAt": "13:47",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "13:48",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "13:54",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "14:00",
					"arrivesAt": "14:12",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1837",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Târgu Frumos",
					"leavesAt": "18:10",
					"arrivesAt": "18:46",
					"waitsAtSource": 0,
					"distance": 44900
				},
				{
					"from": "Târgu Frumos",
					"to": "Paşcani",
					"leavesAt": "18:47",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 30800
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "19:16",
					"arrivesAt": "19:36",
					"waitsAtSource": 120,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "19:37",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "19:54",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 14800
				},
				{
					"from": "Suceava",
					"to": "Gura Humorului Oraş",
					"leavesAt": "20:21",
					"arrivesAt": "21:07",
					"waitsAtSource": 900,
					"distance": 46800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "21:08",
					"arrivesAt": "21:16",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Vama",
					"leavesAt": "21:17",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vama",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "21:28",
					"arrivesAt": "21:44",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "21:45",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Pojorâta Hm.",
					"leavesAt": "21:53",
					"arrivesAt": "22:03",
					"waitsAtSource": 120,
					"distance": 6300
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Mestecăniş",
					"leavesAt": "22:04",
					"arrivesAt": "22:25",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Mestecăniş",
					"to": "Iacobeni",
					"leavesAt": "22:26",
					"arrivesAt": "22:35",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Iacobeni",
					"to": "Vatra Dornei",
					"leavesAt": "22:36",
					"arrivesAt": "22:52",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Vatra Dornei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "22:54",
					"arrivesAt": "22:57",
					"waitsAtSource": 120,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Lunca Ilvei",
					"leavesAt": "22:58",
					"arrivesAt": "23:50",
					"waitsAtSource": 60,
					"distance": 42800
				},
				{
					"from": "Lunca Ilvei",
					"to": "Ilva Mică",
					"leavesAt": "23:51",
					"arrivesAt": "00:28",
					"waitsAtSource": 60,
					"distance": 31600
				},
				{
					"from": "Ilva Mică",
					"to": "Năsăud",
					"leavesAt": "00:30",
					"arrivesAt": "00:51",
					"waitsAtSource": 120,
					"distance": 19800
				},
				{
					"from": "Năsăud",
					"to": "Salva",
					"leavesAt": "00:52",
					"arrivesAt": "00:59",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Salva",
					"to": "Beclean pe Someş",
					"leavesAt": "01:00",
					"arrivesAt": "01:22",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Dej Călători",
					"leavesAt": "01:24",
					"arrivesAt": "01:59",
					"waitsAtSource": 120,
					"distance": 24600
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "02:03",
					"arrivesAt": "02:22",
					"waitsAtSource": 240,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Cluj Napoca",
					"leavesAt": "02:23",
					"arrivesAt": "03:15",
					"waitsAtSource": 60,
					"distance": 44900
				},
				{
					"from": "Cluj Napoca",
					"to": "Câmpia Turzii",
					"leavesAt": "03:28",
					"arrivesAt": "04:35",
					"waitsAtSource": 780,
					"distance": 51500
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "04:36",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "04:54",
					"arrivesAt": "04:59",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Aiud Hm.",
					"leavesAt": "05:01",
					"arrivesAt": "05:16",
					"waitsAtSource": 120,
					"distance": 16800
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "05:18",
					"arrivesAt": "05:32",
					"waitsAtSource": 120,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Alba Iulia",
					"leavesAt": "05:37",
					"arrivesAt": "06:12",
					"waitsAtSource": 300,
					"distance": 19100
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "06:14",
					"arrivesAt": "06:26",
					"waitsAtSource": 120,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Şibot",
					"leavesAt": "06:28",
					"arrivesAt": "06:50",
					"waitsAtSource": 120,
					"distance": 15000
				},
				{
					"from": "Şibot",
					"to": "Aurel Vlaicu",
					"leavesAt": "06:52",
					"arrivesAt": "07:00",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Aurel Vlaicu",
					"to": "Orăştie",
					"leavesAt": "07:01",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Orăştie",
					"to": "Simeria",
					"leavesAt": "07:10",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 16500
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "07:46",
					"arrivesAt": "07:58",
					"waitsAtSource": 720,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Ilia",
					"leavesAt": "08:00",
					"arrivesAt": "08:30",
					"waitsAtSource": 120,
					"distance": 23600
				},
				{
					"from": "Ilia",
					"to": "Holdea Hm.",
					"leavesAt": "08:31",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 23800
				},
				{
					"from": "Holdea Hm.",
					"to": "Margina",
					"leavesAt": "09:06",
					"arrivesAt": "09:24",
					"waitsAtSource": 600,
					"distance": 11700
				},
				{
					"from": "Margina",
					"to": "Făget",
					"leavesAt": "09:25",
					"arrivesAt": "09:33",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Făget",
					"to": "Mănăştur Hm.",
					"leavesAt": "09:34",
					"arrivesAt": "09:43",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Mănăştur Hm.",
					"to": "Lugoj",
					"leavesAt": "09:44",
					"arrivesAt": "10:20",
					"waitsAtSource": 60,
					"distance": 31200
				},
				{
					"from": "Lugoj",
					"to": "Buziaş",
					"leavesAt": "10:27",
					"arrivesAt": "10:57",
					"waitsAtSource": 420,
					"distance": 27500
				},
				{
					"from": "Buziaş",
					"to": "Timişoara Nord",
					"leavesAt": "10:58",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 36400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1731",
			"segments": [
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "17:38",
					"arrivesAt": "18:14",
					"waitsAtSource": 0,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "18:16",
					"arrivesAt": "18:25",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "18:26",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "18:33",
					"arrivesAt": "18:41",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "18:43",
					"arrivesAt": "19:07",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "19:08",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "19:33",
					"arrivesAt": "19:38",
					"waitsAtSource": 120,
					"distance": 3000
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "19:40",
					"arrivesAt": "20:13",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "20:14",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Făurei",
					"leavesAt": "20:51",
					"arrivesAt": "21:28",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Făurei",
					"to": "Ianca hc.",
					"leavesAt": "21:29",
					"arrivesAt": "21:43",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Ianca hc.",
					"to": "Brăila",
					"leavesAt": "21:44",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 42400
				},
				{
					"from": "Brăila",
					"to": "Barboşi",
					"leavesAt": "22:18",
					"arrivesAt": "22:36",
					"waitsAtSource": 120,
					"distance": 19500
				},
				{
					"from": "Barboşi",
					"to": "Galaţi",
					"leavesAt": "22:37",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3002",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "04:14",
					"arrivesAt": "04:22",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "04:23",
					"arrivesAt": "04:36",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Predeal",
					"leavesAt": "04:37",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "04:53",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "05:02",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "05:08",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "05:13",
					"arrivesAt": "05:19",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:23",
					"waitsAtSource": 120,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Posada h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 8900
				},
				{
					"from": "Posada h.",
					"to": "Comarnic",
					"leavesAt": "05:34",
					"arrivesAt": "05:39",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "05:44",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "05:49",
					"arrivesAt": "05:52",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "05:53",
					"arrivesAt": "05:58",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Bobolia h.",
					"leavesAt": "05:59",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Bobolia h.",
					"to": "Floreşti Prahova",
					"leavesAt": "06:05",
					"arrivesAt": "06:12",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "06:13",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "06:23",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "06:34",
					"arrivesAt": "06:37",
					"waitsAtSource": 180,
					"distance": 2900
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Brazi",
					"leavesAt": "06:38",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "06:49",
					"arrivesAt": "06:53",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:03",
					"waitsAtSource": 360,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "07:04",
					"arrivesAt": "07:09",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:21",
					"waitsAtSource": 360,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "07:22",
					"arrivesAt": "07:26",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "07:27",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "07:36",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "07:41",
					"arrivesAt": "07:49",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9161",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "05:45",
					"arrivesAt": "05:56",
					"waitsAtSource": 0,
					"distance": 10400
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Brebu",
					"leavesAt": "06:06",
					"arrivesAt": "06:18",
					"waitsAtSource": 600,
					"distance": 10500
				},
				{
					"from": "Brebu",
					"to": "Ezeriş h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:36",
					"waitsAtSource": 600,
					"distance": 7700
				},
				{
					"from": "Ezeriş h.",
					"to": "Bănila Câlnic h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "06:44",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Reşiţa Nord",
					"to": "Reşiţa Sud Hm.",
					"leavesAt": "06:56",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8023",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "07:30",
					"arrivesAt": "07:39",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "07:40",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Pasărea",
					"leavesAt": "07:46",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pasărea",
					"to": "Brăneşti Sat h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "07:57",
					"arrivesAt": "08:00",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Islaz h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Islaz h.",
					"to": "Fundulea Hm.",
					"leavesAt": "08:04",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 9800
				},
				{
					"from": "Fundulea Hm.",
					"to": "Mostiştea h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Mostiştea h.",
					"to": "Săruleşti",
					"leavesAt": "08:17",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Săruleşti",
					"to": "Preasna h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Preasna h.",
					"to": "Lehliu",
					"leavesAt": "08:28",
					"arrivesAt": "08:36",
					"waitsAtSource": 30,
					"distance": 8800
				},
				{
					"from": "Lehliu",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "08:46",
					"arrivesAt": "08:51",
					"waitsAtSource": 600,
					"distance": 5000
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "08:52",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dâlga h.",
					"leavesAt": "08:56",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dâlga h.",
					"to": "Bogdana h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Bogdana h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "09:08",
					"arrivesAt": "09:11",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Ivăneşti h.",
					"leavesAt": "09:12",
					"arrivesAt": "09:17",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ivăneşti h.",
					"to": "Ciulniţa",
					"leavesAt": "09:18",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "09:31",
					"arrivesAt": "09:34",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "09:42",
					"arrivesAt": "09:44",
					"waitsAtSource": 480,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "09:45",
					"arrivesAt": "09:50",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "09:51",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "09:56",
					"arrivesAt": "10:00",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "10:07",
					"arrivesAt": "10:17",
					"waitsAtSource": 420,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4542",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:27",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "07:28",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "07:41",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Periş Mureş h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:51",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Periş Mureş h.",
					"to": "Petelea h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Petelea h.",
					"to": "Reghin",
					"leavesAt": "07:58",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Reghin",
					"to": "Ideciu de Jos h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Halta Aluniş h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "08:27",
					"arrivesAt": "08:32",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Ruşii Munţi h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Deda",
					"leavesAt": "08:37",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Deda",
					"to": "Deda Bistra Hm.",
					"leavesAt": "08:47",
					"arrivesAt": "08:54",
					"waitsAtSource": 180,
					"distance": 3900
				},
				{
					"from": "Deda Bistra Hm.",
					"to": "Borzia h.",
					"leavesAt": "08:55",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Borzia h.",
					"to": "Răstoliţa Hm.",
					"leavesAt": "09:00",
					"arrivesAt": "09:04",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Răstoliţa Hm.",
					"to": "Lunca Bradului Hm.",
					"leavesAt": "09:05",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 12700
				},
				{
					"from": "Lunca Bradului Hm.",
					"to": "Stânceni Neagra h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Stânceni Neagra h.",
					"to": "Stânceni h.",
					"leavesAt": "09:33",
					"arrivesAt": "09:38",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Stânceni h.",
					"to": "Stânceni Hm.",
					"leavesAt": "09:39",
					"arrivesAt": "09:46",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Stânceni Hm.",
					"to": "Ciobotani h.",
					"leavesAt": "09:47",
					"arrivesAt": "09:52",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ciobotani h.",
					"to": "Topliţa",
					"leavesAt": "09:53",
					"arrivesAt": "10:03",
					"waitsAtSource": 30,
					"distance": 6600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9166",
			"segments": [
				{
					"from": "Reşiţa Sud Hm.",
					"to": "Reşiţa Nord",
					"leavesAt": "15:10",
					"arrivesAt": "15:19",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Reşiţa Nord",
					"to": "Bănila Câlnic h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Ezeriş h.",
					"leavesAt": "15:29",
					"arrivesAt": "15:36",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Ezeriş h.",
					"to": "Brebu",
					"leavesAt": "15:37",
					"arrivesAt": "15:49",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Brebu",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "15:50",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Valea Păltinişului h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Caransebeş",
					"leavesAt": "16:11",
					"arrivesAt": "16:17",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2102",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Atelier Zona h.",
					"leavesAt": "11:55",
					"arrivesAt": "11:58",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "11:59",
					"arrivesAt": "12:01",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Mohu h.",
					"leavesAt": "12:02",
					"arrivesAt": "12:07",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mohu h.",
					"to": "Veştem h.",
					"leavesAt": "12:08",
					"arrivesAt": "12:11",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Veştem h.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "12:12",
					"arrivesAt": "12:21",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "12:22",
					"arrivesAt": "12:29",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Sebeş Olt h.",
					"leavesAt": "12:30",
					"arrivesAt": "12:34",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Racoviţa h.",
					"leavesAt": "12:35",
					"arrivesAt": "12:38",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Racoviţa h.",
					"to": "Mârşa h.",
					"leavesAt": "12:39",
					"arrivesAt": "12:42",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Mârşa h.",
					"to": "Avrig Hm.",
					"leavesAt": "12:43",
					"arrivesAt": "12:47",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Avrig Hm.",
					"to": "Porumbacu Hm.",
					"leavesAt": "12:48",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Sărata Colun h.",
					"leavesAt": "12:58",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sărata Colun h.",
					"to": "Scoreiu h.",
					"leavesAt": "13:03",
					"arrivesAt": "13:06",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Scoreiu h.",
					"to": "Cârţa h.",
					"leavesAt": "13:07",
					"arrivesAt": "13:11",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârţa h.",
					"to": "Arpaş Hm.",
					"leavesAt": "13:12",
					"arrivesAt": "13:16",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Arpaş Hm.",
					"to": "Ucea",
					"leavesAt": "13:17",
					"arrivesAt": "13:23",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ucea",
					"to": "Viştea h.",
					"leavesAt": "13:24",
					"arrivesAt": "13:27",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Viştea h.",
					"to": "Olteţ h.",
					"leavesAt": "13:28",
					"arrivesAt": "13:32",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Olteţ h.",
					"to": "Voila Hm.",
					"leavesAt": "13:33",
					"arrivesAt": "13:40",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Voila Hm.",
					"to": "Dridif h.",
					"leavesAt": "13:41",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dridif h.",
					"to": "Făgăraş",
					"leavesAt": "13:46",
					"arrivesAt": "13:59",
					"waitsAtSource": 30,
					"distance": 8500
				},
				{
					"from": "Făgăraş",
					"to": "Mândra Oltului h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:20",
					"waitsAtSource": 840,
					"distance": 6100
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Şercaia h.",
					"leavesAt": "14:21",
					"arrivesAt": "14:28",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Şercaia h.",
					"to": "Şercaia Hm.",
					"leavesAt": "14:29",
					"arrivesAt": "14:31",
					"waitsAtSource": 30,
					"distance": 1200
				},
				{
					"from": "Şercaia Hm.",
					"to": "Perşani h.",
					"leavesAt": "14:32",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Brădet Hm.",
					"leavesAt": "14:39",
					"arrivesAt": "14:48",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Brădet Hm.",
					"to": "Valea Homorod h.",
					"leavesAt": "14:49",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Homorod h.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "14:58",
					"arrivesAt": "15:08",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "15:14",
					"arrivesAt": "15:20",
					"waitsAtSource": 360,
					"distance": 4600
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "15:21",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Codlea Hm.",
					"to": "Ghimbav Hm.",
					"leavesAt": "15:31",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Bartolomeu",
					"leavesAt": "15:38",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "15:46",
					"arrivesAt": "15:52",
					"waitsAtSource": 120,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3541",
			"segments": [
				{
					"from": "Odorhei",
					"to": "Odorhei Sud hc.",
					"leavesAt": "05:40",
					"arrivesAt": "05:43",
					"waitsAtSource": 0,
					"distance": 1200
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Feliceni h.",
					"leavesAt": "05:44",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Feliceni h.",
					"to": "Dobeni h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:57",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Lutiţa h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Lutiţa h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Beteşti h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Beteşti h.",
					"to": "Cristur Hm.",
					"leavesAt": "06:24",
					"arrivesAt": "06:28",
					"waitsAtSource": 30,
					"distance": 1300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2236",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "16:32",
					"arrivesAt": "16:38",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Viile Giarmata h.",
					"leavesAt": "16:39",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Viile Giarmata h.",
					"to": "Giarmata Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Giarmata Hm.",
					"to": "Cerneteaz h.",
					"leavesAt": "16:53",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Cerneteaz h.",
					"to": "Pişchia h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Pişchia h.",
					"to": "Bencei h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Bencei h.",
					"to": "Fibiş h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Fibiş h.",
					"to": "Remetea Mică",
					"leavesAt": "17:21",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 4300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4366",
			"segments": [
				{
					"from": "Jibou",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:22",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Poptelec h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:28",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poptelec h.",
					"to": "Mirşid Hm.",
					"leavesAt": "15:29",
					"arrivesAt": "15:35",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Mirşid Hm.",
					"to": "Zalău Nord",
					"leavesAt": "15:36",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Zalău Nord",
					"to": "Guruslău h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:07",
					"waitsAtSource": 300,
					"distance": 6700
				},
				{
					"from": "Guruslău h.",
					"to": "Borla Hm.",
					"leavesAt": "16:08",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Borla Hm.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "16:14",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Sărmăşag",
					"leavesAt": "16:26",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sărmăşag",
					"to": "Sărmăşag h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:54",
					"waitsAtSource": 840,
					"distance": 3100
				},
				{
					"from": "Sărmăşag h.",
					"to": "Derşida h.",
					"leavesAt": "16:55",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Derşida h.",
					"to": "Giorocuţa h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:04",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Giorocuţa h.",
					"to": "Supur h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:08",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Supur h.",
					"to": "Supur Haltă hc.",
					"leavesAt": "17:09",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Supur Haltă hc.",
					"to": "Acâş Hm.",
					"leavesAt": "17:12",
					"arrivesAt": "17:19",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Acâş Hm.",
					"to": "Săcăşeni h.",
					"leavesAt": "17:20",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Săcăşeni h.",
					"to": "Tăşnad",
					"leavesAt": "17:31",
					"arrivesAt": "17:37",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tăşnad",
					"to": "Santău h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Santău h.",
					"to": "Hotoan h.",
					"leavesAt": "17:45",
					"arrivesAt": "17:50",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Hotoan h.",
					"to": "Tiream h.",
					"leavesAt": "17:51",
					"arrivesAt": "17:57",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Tiream h.",
					"to": "Carei",
					"leavesAt": "17:58",
					"arrivesAt": "18:13",
					"waitsAtSource": 30,
					"distance": 11700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5008",
			"segments": [
				{
					"from": "Buzău",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "14:00",
					"arrivesAt": "14:10",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Ulmeni",
					"leavesAt": "14:11",
					"arrivesAt": "14:16",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "14:17",
					"arrivesAt": "14:21",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:32",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "14:33",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "14:42",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "14:50",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "14:56",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "15:02",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "15:06",
					"arrivesAt": "15:13",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "15:14",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "15:22",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Triaj",
					"leavesAt": "15:35",
					"arrivesAt": "15:42",
					"waitsAtSource": 360,
					"distance": 3600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Brazi",
					"leavesAt": "15:46",
					"arrivesAt": "15:54",
					"waitsAtSource": 240,
					"distance": 5200
				},
				{
					"from": "Brazi",
					"to": "Crivina",
					"leavesAt": "15:55",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "16:05",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Buftea",
					"leavesAt": "16:16",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 13300
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "16:27",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "16:36",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "16:41",
					"arrivesAt": "16:50",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2411",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(210)",
					"leavesAt": "07:15",
					"arrivesAt": "07:18",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Turnişor Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:24",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Cristian Sibiu h.",
					"leavesAt": "07:25",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Orlat",
					"leavesAt": "07:38",
					"arrivesAt": "07:46",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Orlat",
					"to": "Sibiel h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Sibiel h.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sălişte Hm.",
					"leavesAt": "07:56",
					"arrivesAt": "08:02",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sălişte Hm.",
					"to": "Apoldu de Sus Hm.",
					"leavesAt": "08:03",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 13000
				},
				{
					"from": "Apoldu de Sus Hm.",
					"to": "Apoldu de Jos h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:31",
					"waitsAtSource": 180,
					"distance": 6400
				},
				{
					"from": "Apoldu de Jos h.",
					"to": "Miercurea Sibiu Hm.",
					"leavesAt": "08:32",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Miercurea Sibiu Hm.",
					"to": "Băile Miercurea h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:44",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Băile Miercurea h.",
					"to": "Cunţa Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cunţa Hm.",
					"to": "Cut h.",
					"leavesAt": "08:53",
					"arrivesAt": "08:59",
					"waitsAtSource": 120,
					"distance": 4500
				},
				{
					"from": "Cut h.",
					"to": "Rahău h.",
					"leavesAt": "09:00",
					"arrivesAt": "09:04",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Rahău h.",
					"to": "Sebeş Alba",
					"leavesAt": "09:05",
					"arrivesAt": "09:14",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Sebeş Alba",
					"to": "Sebeş Glod h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sebeş Glod h.",
					"to": "Vinţu de Jos",
					"leavesAt": "09:19",
					"arrivesAt": "09:28",
					"waitsAtSource": 30,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2064",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu Triaj h.",
					"leavesAt": "03:13",
					"arrivesAt": "03:18",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "03:19",
					"arrivesAt": "03:22",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "03:23",
					"arrivesAt": "03:37",
					"waitsAtSource": 60,
					"distance": 13200
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "03:38",
					"arrivesAt": "03:45",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "03:46",
					"arrivesAt": "03:50",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "03:51",
					"arrivesAt": "04:00",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Râu Vadului h.",
					"leavesAt": "04:01",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Râu Vadului h.",
					"to": "Câineni",
					"leavesAt": "04:15",
					"arrivesAt": "04:24",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Robeşti h.",
					"leavesAt": "04:33",
					"arrivesAt": "04:40",
					"waitsAtSource": 540,
					"distance": 5400
				},
				{
					"from": "Robeşti h.",
					"to": "Balota h.",
					"leavesAt": "04:41",
					"arrivesAt": "04:44",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Balota h.",
					"to": "Cornet Hm.",
					"leavesAt": "04:45",
					"arrivesAt": "04:51",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cornet Hm.",
					"to": "Beţel h.",
					"leavesAt": "05:00",
					"arrivesAt": "05:05",
					"waitsAtSource": 540,
					"distance": 3600
				},
				{
					"from": "Beţel h.",
					"to": "Lotru",
					"leavesAt": "05:06",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Lotru",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "05:15",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Păuşa h.",
					"leavesAt": "05:29",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "05:34",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Dăeşti Hm.",
					"leavesAt": "05:40",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "05:47",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "06:01",
					"arrivesAt": "06:04",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Ostroveni h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ostroveni h.",
					"to": "Răstoaca h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:11",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Răstoaca h.",
					"to": "Râureni",
					"leavesAt": "06:12",
					"arrivesAt": "06:14",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Râureni",
					"to": "Râureni hc.",
					"leavesAt": "06:15",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni hc.",
					"to": "Govora",
					"leavesAt": "06:19",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Govora",
					"to": "Tătărani h.",
					"leavesAt": "06:25",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Tătărani h.",
					"to": "Băbeni",
					"leavesAt": "06:30",
					"arrivesAt": "06:36",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Băbeni",
					"to": "Slăviteşti hc.",
					"leavesAt": "06:37",
					"arrivesAt": "06:41",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Ioneşti Hm.",
					"leavesAt": "06:42",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Fişcălia Hm.",
					"leavesAt": "06:53",
					"arrivesAt": "06:57",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "06:58",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Orleşti hc.",
					"to": "Zăvideni Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Călina h.",
					"leavesAt": "07:07",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Călina h.",
					"to": "Drăgăşani",
					"leavesAt": "07:12",
					"arrivesAt": "07:19",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Drăgăşani",
					"to": "Zlătărei Hm.",
					"leavesAt": "07:20",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Strejeşti",
					"leavesAt": "07:27",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Strejeşti",
					"to": "Colibaşi h.",
					"leavesAt": "07:33",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Colibaşi h.",
					"to": "Arceşti Hm.",
					"leavesAt": "07:39",
					"arrivesAt": "07:45",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Arceşti Hm.",
					"to": "Găneasa Olt h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Găneasa Olt h.",
					"to": "Găneasa h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Găneasa h.",
					"to": "Piatra Olt",
					"leavesAt": "07:56",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2570",
			"segments": [
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:10",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "20:11",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Axente Sever h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Axente Sever h.",
					"to": "Agârbiciu h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Agârbiciu h.",
					"to": "Şeica Mare",
					"leavesAt": "20:32",
					"arrivesAt": "20:39",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şeica Mare",
					"to": "Şeica Mare h.",
					"leavesAt": "20:44",
					"arrivesAt": "20:47",
					"waitsAtSource": 300,
					"distance": 1400
				},
				{
					"from": "Şeica Mare h.",
					"to": "Veşeud h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:53",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Veşeud h.",
					"to": "Hăşag h.",
					"leavesAt": "20:54",
					"arrivesAt": "20:59",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Hăşag h.",
					"to": "Loamneş Hm.",
					"leavesAt": "21:00",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Loamneş Hm.",
					"to": "Mândra h.",
					"leavesAt": "21:06",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mândra h.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "21:10",
					"arrivesAt": "21:18",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "21:20",
					"arrivesAt": "21:27",
					"waitsAtSource": 120,
					"distance": 2100
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Sibiu h.(203)",
					"leavesAt": "21:28",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Sibiu",
					"leavesAt": "21:38",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5108",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "13:05",
					"arrivesAt": "13:14",
					"waitsAtSource": 0,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "13:15",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Focşani",
					"to": "Coteşti Hm.",
					"leavesAt": "13:33",
					"arrivesAt": "13:41",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Coteşti Hm.",
					"to": "Gugeşti",
					"leavesAt": "13:42",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Gugeşti",
					"to": "Sihlea Hm.",
					"leavesAt": "13:51",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sihlea Hm.",
					"to": "Voetin h.",
					"leavesAt": "14:00",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Voetin h.",
					"to": "Râmnicu Sărat",
					"leavesAt": "14:08",
					"arrivesAt": "14:18",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Zoita Hm.",
					"leavesAt": "14:21",
					"arrivesAt": "14:32",
					"waitsAtSource": 180,
					"distance": 11300
				},
				{
					"from": "Zoita Hm.",
					"to": "Boboc Hm.",
					"leavesAt": "14:33",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Boboc Hm.",
					"to": "Buzău",
					"leavesAt": "14:44",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 11500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1962",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "22:21",
					"arrivesAt": "22:27",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Bârnova Hm.",
					"leavesAt": "22:29",
					"arrivesAt": "22:51",
					"waitsAtSource": 120,
					"distance": 16300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Buhăieşti",
					"leavesAt": "22:52",
					"arrivesAt": "23:14",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Buhăieşti",
					"to": "Vaslui",
					"leavesAt": "23:15",
					"arrivesAt": "23:33",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Vaslui",
					"to": "Crasna",
					"leavesAt": "23:37",
					"arrivesAt": "23:51",
					"waitsAtSource": 240,
					"distance": 15500
				},
				{
					"from": "Crasna",
					"to": "Bârlad",
					"leavesAt": "23:52",
					"arrivesAt": "00:25",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Bârlad",
					"to": "Tecuci",
					"leavesAt": "00:29",
					"arrivesAt": "01:15",
					"waitsAtSource": 240,
					"distance": 50300
				},
				{
					"from": "Tecuci",
					"to": "Lieşti",
					"leavesAt": "01:16",
					"arrivesAt": "01:41",
					"waitsAtSource": 60,
					"distance": 24400
				},
				{
					"from": "Lieşti",
					"to": "Barboşi",
					"leavesAt": "01:42",
					"arrivesAt": "02:33",
					"waitsAtSource": 60,
					"distance": 48300
				},
				{
					"from": "Barboşi",
					"to": "Brăila",
					"leavesAt": "02:53",
					"arrivesAt": "03:12",
					"waitsAtSource": 1200,
					"distance": 19500
				},
				{
					"from": "Brăila",
					"to": "Ianca hc.",
					"leavesAt": "03:13",
					"arrivesAt": "03:44",
					"waitsAtSource": 60,
					"distance": 42400
				},
				{
					"from": "Ianca hc.",
					"to": "Ţăndărei",
					"leavesAt": "03:45",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 72100
				},
				{
					"from": "Ţăndărei",
					"to": "Platoneşti h.",
					"leavesAt": "04:41",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Platoneşti h.",
					"to": "Movila Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Movila Hm.",
					"to": "Feteşti",
					"leavesAt": "04:57",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 16700
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "05:24",
					"arrivesAt": "05:43",
					"waitsAtSource": 600,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "05:44",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Palas",
					"leavesAt": "06:02",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 30600
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "06:21",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Constanţa",
					"to": "Eforie Nord",
					"leavesAt": "06:55",
					"arrivesAt": "07:18",
					"waitsAtSource": 1560,
					"distance": 14000
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "07:21",
					"arrivesAt": "07:28",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Costineşti",
					"leavesAt": "07:35",
					"arrivesAt": "07:51",
					"waitsAtSource": 420,
					"distance": 8600
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "07:53",
					"arrivesAt": "07:57",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "07:59",
					"arrivesAt": "08:12",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "08:14",
					"arrivesAt": "08:24",
					"waitsAtSource": 120,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8695",
			"segments": [
				{
					"from": "Medgidia",
					"to": "Dorobanţu",
					"leavesAt": "16:28",
					"arrivesAt": "16:36",
					"waitsAtSource": 0,
					"distance": 8000
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "16:42",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "16:47",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Palas",
					"leavesAt": "16:51",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "17:00",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180105",
					"to": "20180107",
					"daysOfWeek": 383
				},
				{
					"from": "20180112",
					"to": "20180114",
					"daysOfWeek": 383
				},
				{
					"from": "20180119",
					"to": "20180121",
					"daysOfWeek": 383
				},
				{
					"from": "20180126",
					"to": "20180128",
					"daysOfWeek": 383
				},
				{
					"from": "20180202",
					"to": "20180204",
					"daysOfWeek": 383
				},
				{
					"from": "20180209",
					"to": "20180211",
					"daysOfWeek": 383
				},
				{
					"from": "20180216",
					"to": "20180218",
					"daysOfWeek": 383
				},
				{
					"from": "20180223",
					"to": "20180225",
					"daysOfWeek": 383
				},
				{
					"from": "20180302",
					"to": "20180304",
					"daysOfWeek": 383
				},
				{
					"from": "20180309",
					"to": "20180311",
					"daysOfWeek": 383
				},
				{
					"from": "20180316",
					"to": "20180318",
					"daysOfWeek": 383
				},
				{
					"from": "20180323",
					"to": "20180325",
					"daysOfWeek": 383
				},
				{
					"from": "20180330",
					"to": "20180401",
					"daysOfWeek": 383
				},
				{
					"from": "20180406",
					"to": "20180408",
					"daysOfWeek": 383
				},
				{
					"from": "20180413",
					"to": "20180415",
					"daysOfWeek": 383
				},
				{
					"from": "20180420",
					"to": "20180422",
					"daysOfWeek": 383
				},
				{
					"from": "20180427",
					"to": "20180429",
					"daysOfWeek": 383
				},
				{
					"from": "20180504",
					"to": "20180506",
					"daysOfWeek": 383
				},
				{
					"from": "20180511",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180518",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180527",
					"daysOfWeek": 383
				},
				{
					"from": "20180601",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180909",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180914",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180921",
					"to": "20180923",
					"daysOfWeek": 383
				},
				{
					"from": "20180928",
					"to": "20180930",
					"daysOfWeek": 383
				},
				{
					"from": "20181005",
					"to": "20181007",
					"daysOfWeek": 383
				},
				{
					"from": "20181012",
					"to": "20181014",
					"daysOfWeek": 383
				},
				{
					"from": "20181019",
					"to": "20181021",
					"daysOfWeek": 383
				},
				{
					"from": "20181026",
					"to": "20181028",
					"daysOfWeek": 383
				},
				{
					"from": "20181102",
					"to": "20181104",
					"daysOfWeek": 383
				},
				{
					"from": "20181109",
					"to": "20181111",
					"daysOfWeek": 383
				},
				{
					"from": "20181116",
					"to": "20181118",
					"daysOfWeek": 383
				},
				{
					"from": "20181123",
					"to": "20181125",
					"daysOfWeek": 383
				},
				{
					"from": "20181130",
					"to": "20181202",
					"daysOfWeek": 383
				},
				{
					"from": "20181207",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 383
				},
				{
					"from": "20171215",
					"to": "20171217",
					"daysOfWeek": 383
				},
				{
					"from": "20171222",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171229",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1745",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "06:05",
					"arrivesAt": "06:47",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "06:49",
					"arrivesAt": "07:13",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "07:14",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Comarnic",
					"leavesAt": "07:20",
					"arrivesAt": "07:28",
					"waitsAtSource": 30,
					"distance": 9000
				},
				{
					"from": "Comarnic",
					"to": "Valea Largă Hm.",
					"leavesAt": "07:29",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Sinaia",
					"leavesAt": "07:39",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "07:46",
					"arrivesAt": "07:53",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "07:54",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "08:00",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "08:11",
					"arrivesAt": "08:49",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Augustin Hm.",
					"leavesAt": "08:58",
					"arrivesAt": "10:01",
					"waitsAtSource": 540,
					"distance": 49100
				},
				{
					"from": "Augustin Hm.",
					"to": "Racoş Hm.",
					"leavesAt": "10:02",
					"arrivesAt": "10:18",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Racoş Hm.",
					"to": "Rupea",
					"leavesAt": "10:19",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 14000
				},
				{
					"from": "Rupea",
					"to": "Sighişoara",
					"leavesAt": "10:38",
					"arrivesAt": "11:40",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Sighişoara",
					"to": "Dumbrăveni",
					"leavesAt": "11:43",
					"arrivesAt": "12:10",
					"waitsAtSource": 180,
					"distance": 20400
				},
				{
					"from": "Dumbrăveni",
					"to": "Mediaş",
					"leavesAt": "12:11",
					"arrivesAt": "12:36",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Mediaş",
					"to": "Copşa Mică",
					"leavesAt": "12:38",
					"arrivesAt": "12:51",
					"waitsAtSource": 120,
					"distance": 10400
				},
				{
					"from": "Copşa Mică",
					"to": "Blaj",
					"leavesAt": "12:52",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 30000
				},
				{
					"from": "Blaj",
					"to": "Teiuş",
					"leavesAt": "13:31",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 21300
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "14:03",
					"arrivesAt": "14:16",
					"waitsAtSource": 240,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Unirea hc.",
					"leavesAt": "14:17",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "14:33",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Câmpia Turzii",
					"leavesAt": "14:41",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cluj Napoca",
					"leavesAt": "14:57",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 51500
				},
				{
					"from": "Cluj Napoca",
					"to": "Gherla",
					"leavesAt": "16:18",
					"arrivesAt": "17:16",
					"waitsAtSource": 900,
					"distance": 44900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "17:18",
					"arrivesAt": "17:37",
					"waitsAtSource": 120,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Câţcău h.",
					"leavesAt": "17:51",
					"arrivesAt": "18:07",
					"waitsAtSource": 840,
					"distance": 12700
				},
				{
					"from": "Câţcău h.",
					"to": "Gâlgău",
					"leavesAt": "18:08",
					"arrivesAt": "18:19",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Gâlgău",
					"to": "Ileanda",
					"leavesAt": "18:20",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Ileanda",
					"to": "Letca Hm.",
					"leavesAt": "18:40",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 13600
				},
				{
					"from": "Letca Hm.",
					"to": "Jibou",
					"leavesAt": "18:59",
					"arrivesAt": "19:30",
					"waitsAtSource": 60,
					"distance": 23100
				},
				{
					"from": "Jibou",
					"to": "Benesat Hm.",
					"leavesAt": "19:38",
					"arrivesAt": "19:56",
					"waitsAtSource": 480,
					"distance": 18000
				},
				{
					"from": "Benesat Hm.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "19:57",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "20:07",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Baia Mare",
					"leavesAt": "20:15",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 25100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8004",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "14:50",
					"arrivesAt": "14:56",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "14:57",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "15:05",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "15:11",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "15:16",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "15:21",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "15:29",
					"arrivesAt": "15:36",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "15:37",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "15:55",
					"arrivesAt": "16:02",
					"waitsAtSource": 540,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "16:03",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Ramificaţia Borcea",
					"leavesAt": "16:13",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 16000
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "16:32",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Feteşti",
					"to": "Bărăganu Hm.",
					"leavesAt": "16:39",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Jegălia",
					"leavesAt": "16:55",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Jegălia",
					"to": "Recolta hc.",
					"leavesAt": "17:00",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Recolta hc.",
					"to": "Perişoru Hm.",
					"leavesAt": "17:04",
					"arrivesAt": "17:07",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Perişoru Hm.",
					"to": "Ogoarele h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:11",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ogoarele h.",
					"to": "Ciulniţa",
					"leavesAt": "17:12",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 9000
				},
				{
					"from": "Ciulniţa",
					"to": "Ivăneşti h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ivăneşti h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "17:27",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Bogdana h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Bogdana h.",
					"to": "Dâlga h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Dâlga h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "17:50",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Lehliu",
					"leavesAt": "17:54",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lehliu",
					"to": "Preasna h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Preasna h.",
					"to": "Săruleşti",
					"leavesAt": "18:06",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Săruleşti",
					"to": "Mostiştea h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:23",
					"waitsAtSource": 420,
					"distance": 5900
				},
				{
					"from": "Mostiştea h.",
					"to": "Fundulea Hm.",
					"leavesAt": "18:24",
					"arrivesAt": "18:29",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Fundulea Hm.",
					"to": "Islaz h.",
					"leavesAt": "18:30",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Islaz h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "18:37",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Brăneşti Sat h.",
					"leavesAt": "18:41",
					"arrivesAt": "18:43",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Pasărea",
					"leavesAt": "18:44",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Pasărea",
					"to": "Pantelimon",
					"leavesAt": "18:51",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pantelimon",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "18:58",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Bucureşti Obor",
					"leavesAt": "19:01",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20180916",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180419",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9484",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "22:15",
					"arrivesAt": "22:21",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "22:22",
					"arrivesAt": "22:28",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Slatina",
					"leavesAt": "22:29",
					"arrivesAt": "22:42",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5602",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "09:06",
					"arrivesAt": "09:11",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "09:13",
					"arrivesAt": "09:20",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "09:21",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "09:29",
					"arrivesAt": "09:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "09:36",
					"arrivesAt": "09:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "09:43",
					"arrivesAt": "09:48",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "09:49",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "09:59",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "10:05",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "10:11",
					"arrivesAt": "10:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "10:17",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "10:31",
					"arrivesAt": "10:45",
					"waitsAtSource": 480,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "10:46",
					"arrivesAt": "10:53",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "10:54",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "11:00",
					"arrivesAt": "11:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "11:09",
					"arrivesAt": "11:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "11:20",
					"arrivesAt": "11:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "11:27",
					"arrivesAt": "11:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "11:34",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "11:42",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1578",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Barboşi",
					"leavesAt": "17:35",
					"arrivesAt": "17:54",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Barboşi",
					"to": "Brăila",
					"leavesAt": "17:55",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 19500
				},
				{
					"from": "Brăila",
					"to": "Ianca hc.",
					"leavesAt": "18:14",
					"arrivesAt": "18:44",
					"waitsAtSource": 120,
					"distance": 42400
				},
				{
					"from": "Ianca hc.",
					"to": "Făurei",
					"leavesAt": "18:45",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Făurei",
					"to": "Buzău",
					"leavesAt": "19:05",
					"arrivesAt": "19:44",
					"waitsAtSource": 180,
					"distance": 40400
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "19:47",
					"arrivesAt": "20:19",
					"waitsAtSource": 180,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "20:20",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Triaj",
					"leavesAt": "20:58",
					"arrivesAt": "21:04",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Bucureşti Nord",
					"leavesAt": "21:08",
					"arrivesAt": "21:53",
					"waitsAtSource": 240,
					"distance": 56600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9502",
			"segments": [
				{
					"from": "Drobeta Tr. Severin",
					"to": "Drobeta Tr. Severin Mf.",
					"leavesAt": "04:12",
					"arrivesAt": "04:22",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Drobeta Tr. Severin Mf.",
					"to": "Ergheviţa h.",
					"leavesAt": "04:23",
					"arrivesAt": "04:28",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ergheviţa h.",
					"to": "Valea Albă Hm.",
					"leavesAt": "04:29",
					"arrivesAt": "04:38",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Albă Hm.",
					"to": "Balota",
					"leavesAt": "04:39",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Balota",
					"to": "Gârniţa Hm.",
					"leavesAt": "04:52",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Gârniţa Hm.",
					"to": "Prunişor Hm.",
					"leavesAt": "05:01",
					"arrivesAt": "05:08",
					"waitsAtSource": 240,
					"distance": 6100
				},
				{
					"from": "Prunişor Hm.",
					"to": "Igiroasa Hm.",
					"leavesAt": "05:09",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Igiroasa Hm.",
					"to": "Tâmna",
					"leavesAt": "05:20",
					"arrivesAt": "05:26",
					"waitsAtSource": 300,
					"distance": 5100
				},
				{
					"from": "Tâmna",
					"to": "Ciochiuţa Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciochiuţa Hm.",
					"to": "Strehaia hc.",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Strehaia hc.",
					"to": "Strehaia",
					"leavesAt": "05:42",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Strehaia",
					"to": "Lunca Banului h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Lunca Banului h.",
					"to": "Butoieşti Hm.",
					"leavesAt": "05:55",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Gura Motrului Hm.",
					"leavesAt": "06:02",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Filiaşi",
					"leavesAt": "06:09",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "06:21",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "06:26",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "06:31",
					"arrivesAt": "06:36",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "06:41",
					"arrivesAt": "06:46",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "06:47",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "06:50",
					"arrivesAt": "06:54",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "06:55",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "06:58",
					"arrivesAt": "07:02",
					"waitsAtSource": 30,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2061",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(901)",
					"leavesAt": "05:05",
					"arrivesAt": "05:08",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Cârcea h.",
					"leavesAt": "05:09",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Cârcea h.",
					"to": "Toporaş h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:25",
					"waitsAtSource": 30,
					"distance": 9100
				},
				{
					"from": "Toporaş h.",
					"to": "Robăneşti Hm.",
					"leavesAt": "05:26",
					"arrivesAt": "05:34",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Robăneşti Hm.",
					"to": "Spineni h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Spineni h.",
					"to": "Balş",
					"leavesAt": "05:42",
					"arrivesAt": "05:49",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Balş",
					"to": "Canton 217 h.",
					"leavesAt": "05:57",
					"arrivesAt": "06:00",
					"waitsAtSource": 480,
					"distance": 1800
				},
				{
					"from": "Canton 217 h.",
					"to": "Brăneţ h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:05",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Brăneţ h.",
					"to": "Piatra Olt",
					"leavesAt": "06:06",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Piatra Olt",
					"to": "Găneasa h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:37",
					"waitsAtSource": 1080,
					"distance": 3500
				},
				{
					"from": "Găneasa h.",
					"to": "Găneasa Olt h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:41",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Găneasa Olt h.",
					"to": "Arceşti Hm.",
					"leavesAt": "06:42",
					"arrivesAt": "06:46",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Arceşti Hm.",
					"to": "Colibaşi h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Colibaşi h.",
					"to": "Strejeşti",
					"leavesAt": "06:54",
					"arrivesAt": "07:00",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Strejeşti",
					"to": "Zlătărei Hm.",
					"leavesAt": "07:01",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Drăgăşani",
					"leavesAt": "07:07",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Drăgăşani",
					"to": "Călina h.",
					"leavesAt": "07:23",
					"arrivesAt": "07:30",
					"waitsAtSource": 480,
					"distance": 6400
				},
				{
					"from": "Călina h.",
					"to": "Zăvideni Hm.",
					"leavesAt": "07:31",
					"arrivesAt": "07:36",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "07:37",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Orleşti hc.",
					"to": "Fişcălia Hm.",
					"leavesAt": "07:43",
					"arrivesAt": "07:47",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:00",
					"waitsAtSource": 600,
					"distance": 3000
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Ioneşti Hm.",
					"leavesAt": "08:01",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Slăviteşti hc.",
					"leavesAt": "08:06",
					"arrivesAt": "08:11",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Băbeni",
					"leavesAt": "08:12",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Băbeni",
					"to": "Tătărani h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Tătărani h.",
					"to": "Govora",
					"leavesAt": "08:26",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Govora",
					"to": "Râureni hc.",
					"leavesAt": "08:34",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Râureni hc.",
					"to": "Râureni",
					"leavesAt": "08:38",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni",
					"to": "Răstoaca h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Răstoaca h.",
					"to": "Ostroveni h.",
					"leavesAt": "08:50",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ostroveni h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "08:55",
					"arrivesAt": "08:57",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:12",
					"waitsAtSource": 780,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "09:13",
					"arrivesAt": "09:18",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Dăeşti Hm.",
					"leavesAt": "09:19",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Călimăneşti",
					"leavesAt": "09:26",
					"arrivesAt": "09:33",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "09:34",
					"arrivesAt": "09:39",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "09:40",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Cozia Hm.",
					"leavesAt": "09:45",
					"arrivesAt": "09:52",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Cozia Hm.",
					"to": "Lotru",
					"leavesAt": "09:53",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lotru",
					"to": "Beţel h.",
					"leavesAt": "10:03",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Beţel h.",
					"to": "Cornet Hm.",
					"leavesAt": "10:11",
					"arrivesAt": "10:17",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Cornet Hm.",
					"to": "Balota h.",
					"leavesAt": "10:18",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Balota h.",
					"to": "Robeşti h.",
					"leavesAt": "10:24",
					"arrivesAt": "10:27",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Robeşti h.",
					"to": "Câineni",
					"leavesAt": "10:28",
					"arrivesAt": "10:34",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Râu Vadului h.",
					"leavesAt": "10:35",
					"arrivesAt": "10:43",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Râu Vadului h.",
					"to": "Valea Fratelui h.",
					"leavesAt": "10:44",
					"arrivesAt": "10:48",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Valea Fratelui h.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "10:49",
					"arrivesAt": "11:01",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Turnu Roşu hc.",
					"leavesAt": "11:02",
					"arrivesAt": "11:12",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Podu Olt",
					"leavesAt": "11:13",
					"arrivesAt": "11:18",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "11:21",
					"arrivesAt": "11:28",
					"waitsAtSource": 180,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "11:29",
					"arrivesAt": "11:38",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "11:39",
					"arrivesAt": "11:42",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "11:43",
					"arrivesAt": "11:47",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Sibiu Triaj",
					"leavesAt": "11:48",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Triaj",
					"to": "Atelier Zona h",
					"leavesAt": "11:53",
					"arrivesAt": "11:56",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h",
					"to": "Sibiu",
					"leavesAt": "11:57",
					"arrivesAt": "12:01",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9483",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Brăneţ h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:44",
					"waitsAtSource": 0,
					"distance": 7700
				},
				{
					"from": "Brăneţ h.",
					"to": "Canton 217 h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:49",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Canton 217 h.",
					"to": "Balş",
					"leavesAt": "05:50",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Balş",
					"to": "Spineni h.",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Spineni h.",
					"to": "Robăneşti Hm.",
					"leavesAt": "05:59",
					"arrivesAt": "06:08",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Robăneşti Hm.",
					"to": "Toporaş h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Toporaş h.",
					"to": "Pieleşti Hm.",
					"leavesAt": "06:15",
					"arrivesAt": "06:18",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Pieleşti Hm.",
					"to": "Cârcea h.",
					"leavesAt": "06:19",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Cârcea h.",
					"to": "Plaiu Vulcăneşti Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Plaiu Vulcăneşti Hm.",
					"to": "Bordei hc.(901)",
					"leavesAt": "06:34",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Craiova",
					"leavesAt": "06:38",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 863
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2854",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Amaradia",
					"leavesAt": "14:28",
					"arrivesAt": "14:36",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Amaradia",
					"to": "Drăguţeşti h.",
					"leavesAt": "14:37",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "14:42",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Vârţ h.",
					"leavesAt": "14:47",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Vârţ h.",
					"to": "Rogojelu",
					"leavesAt": "14:52",
					"arrivesAt": "14:57",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Rogojelu",
					"to": "Km. 49+800 h.",
					"leavesAt": "14:58",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rovinari Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Rovinari Hm.",
					"to": "Rovinari Sud h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:32",
					"waitsAtSource": 1500,
					"distance": 1400
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Bâlteni h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bâlteni h.",
					"to": "Peşteana Jiu h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Plopşoru",
					"leavesAt": "15:49",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Plopşoru",
					"to": "Sărdăneşti h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Gârbovu h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:08",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Gârbovu h.",
					"to": "Turceni",
					"leavesAt": "16:09",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turceni",
					"to": "Termo Turceni h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:22",
					"waitsAtSource": 120,
					"distance": 900
				},
				{
					"from": "Termo Turceni h.",
					"to": "Km. 9+820 h.",
					"leavesAt": "16:23",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Km. 9+820 h.",
					"to": "Ioneşti Gorj h.",
					"leavesAt": "16:27",
					"arrivesAt": "16:31",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Ioneşti Gorj h.",
					"to": "Filiaşi",
					"leavesAt": "16:32",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 12400
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:53",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "16:54",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "17:04",
					"arrivesAt": "17:09",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "17:10",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "17:14",
					"arrivesAt": "17:19",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "17:20",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "17:23",
					"arrivesAt": "17:27",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "17:28",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "17:32",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8585",
			"segments": [
				{
					"from": "Slobozia Veche",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "16:45",
					"arrivesAt": "16:55",
					"waitsAtSource": 0,
					"distance": 4200
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Brâncoveni h.",
					"leavesAt": "16:56",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Brâncoveni h.",
					"to": "Ciulniţa",
					"leavesAt": "17:05",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "72",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Arad",
					"leavesAt": "14:38",
					"arrivesAt": "15:24",
					"waitsAtSource": 0,
					"distance": 57200
				},
				{
					"from": "Arad",
					"to": "Curtici",
					"leavesAt": "15:26",
					"arrivesAt": "15:39",
					"waitsAtSource": 120,
					"distance": 17000
				},
				{
					"from": "Curtici",
					"to": "Lokoshaza",
					"leavesAt": "16:09",
					"arrivesAt": "16:19",
					"waitsAtSource": 1800,
					"distance": 11200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3548",
			"segments": [
				{
					"from": "Cristur Hm.",
					"to": "Beteşti h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:43",
					"waitsAtSource": 0,
					"distance": 1300
				},
				{
					"from": "Beteşti h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "15:52",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Lutiţa h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Lutiţa h.",
					"to": "Dobeni h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Feliceni h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Feliceni h.",
					"to": "Odorhei Sud hc.",
					"leavesAt": "16:15",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Odorhei",
					"leavesAt": "16:24",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 1200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7366",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "19:50",
					"arrivesAt": "20:03",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "20:05",
					"arrivesAt": "20:12",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Zagna Vădeni h.",
					"leavesAt": "20:13",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Vădeni Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:21",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vădeni Hm.",
					"to": "Baldovineşti Hm.",
					"leavesAt": "20:22",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Brăila",
					"leavesAt": "20:28",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Brăila",
					"to": "Lacu Sărat",
					"leavesAt": "20:38",
					"arrivesAt": "20:46",
					"waitsAtSource": 120,
					"distance": 9700
				},
				{
					"from": "Lacu Sărat",
					"to": "Traian Sat Hm.",
					"leavesAt": "20:47",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Urleasca Hm.",
					"leavesAt": "20:57",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Urleasca Hm.",
					"to": "Plopu",
					"leavesAt": "21:05",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Plopu",
					"to": "Ianca hc.",
					"leavesAt": "21:13",
					"arrivesAt": "21:16",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ianca hc.",
					"to": "Deduleşti Hm.",
					"leavesAt": "21:17",
					"arrivesAt": "21:25",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Găiseanca h.",
					"leavesAt": "21:26",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Găiseanca h.",
					"to": "Făurei",
					"leavesAt": "21:32",
					"arrivesAt": "21:37",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Făurei",
					"to": "Vizireni h.",
					"leavesAt": "21:38",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vizireni h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "21:47",
					"arrivesAt": "21:52",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "21:53",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Movila Oii h.",
					"to": "Cilibia Hm.",
					"leavesAt": "22:01",
					"arrivesAt": "22:06",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cilibia Hm.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "22:07",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Buzău",
					"leavesAt": "22:17",
					"arrivesAt": "22:31",
					"waitsAtSource": 60,
					"distance": 11800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2092",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Copăcioasa Hm.",
					"leavesAt": "04:00",
					"arrivesAt": "04:16",
					"waitsAtSource": 0,
					"distance": 13500
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Pojogeni Hm.",
					"leavesAt": "04:17",
					"arrivesAt": "04:23",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "04:27",
					"arrivesAt": "04:34",
					"waitsAtSource": 240,
					"distance": 4700
				},
				{
					"from": "Cărbuneşti",
					"to": "Jupâneşti Hm.",
					"leavesAt": "04:35",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "04:41",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "04:48",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Musculeşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "04:56",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "05:02",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Gilort Hm.",
					"leavesAt": "05:11",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gilort Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "05:18",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Floreşti hc.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "05:22",
					"arrivesAt": "05:27",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Filiaşi",
					"leavesAt": "05:28",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:39",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "05:40",
					"arrivesAt": "05:44",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "05:56",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "05:57",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "06:01",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "06:07",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "06:10",
					"arrivesAt": "06:14",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "06:15",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "06:19",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2104",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Atelier Zona h.",
					"leavesAt": "14:35",
					"arrivesAt": "14:38",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "14:39",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Mohu h.",
					"leavesAt": "14:42",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mohu h.",
					"to": "Veştem h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:51",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Veştem h.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "14:52",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "15:02",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Sebeş Olt h.",
					"leavesAt": "15:19",
					"arrivesAt": "15:23",
					"waitsAtSource": 600,
					"distance": 2300
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Racoviţa h.",
					"leavesAt": "15:24",
					"arrivesAt": "15:27",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Racoviţa h.",
					"to": "Mârşa h.",
					"leavesAt": "15:28",
					"arrivesAt": "15:31",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Mârşa h.",
					"to": "Avrig Hm.",
					"leavesAt": "15:32",
					"arrivesAt": "15:36",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Avrig Hm.",
					"to": "Porumbacu Hm.",
					"leavesAt": "15:37",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Sărata Colun h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sărata Colun h.",
					"to": "Scoreiu h.",
					"leavesAt": "15:52",
					"arrivesAt": "15:55",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Scoreiu h.",
					"to": "Cârţa h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:00",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârţa h.",
					"to": "Arpaş Hm.",
					"leavesAt": "16:01",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Arpaş Hm.",
					"to": "Ucea",
					"leavesAt": "16:06",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ucea",
					"to": "Viştea h.",
					"leavesAt": "16:26",
					"arrivesAt": "16:30",
					"waitsAtSource": 780,
					"distance": 3000
				},
				{
					"from": "Viştea h.",
					"to": "Olteţ h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Olteţ h.",
					"to": "Voila Hm.",
					"leavesAt": "16:36",
					"arrivesAt": "16:43",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Voila Hm.",
					"to": "Dridif h.",
					"leavesAt": "16:44",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dridif h.",
					"to": "Beclean pe Olt h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:53",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Beclean pe Olt h.",
					"to": "Făgăraş",
					"leavesAt": "16:54",
					"arrivesAt": "17:02",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Făgăraş",
					"to": "Mândra Oltului h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:16",
					"waitsAtSource": 420,
					"distance": 6100
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Şercaia h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Şercaia h.",
					"to": "Şercaia Hm.",
					"leavesAt": "17:25",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 1200
				},
				{
					"from": "Şercaia Hm.",
					"to": "Perşani h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:50",
					"waitsAtSource": 900,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Brădet Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "18:01",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Brădet Hm.",
					"to": "Valea Homorod h.",
					"leavesAt": "18:24",
					"arrivesAt": "18:34",
					"waitsAtSource": 1380,
					"distance": 5500
				},
				{
					"from": "Valea Homorod h.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "18:35",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "18:45",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "19:01",
					"waitsAtSource": 120,
					"distance": 8400
				},
				{
					"from": "Codlea Hm.",
					"to": "Ghimbav Hm.",
					"leavesAt": "19:02",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Bartolomeu",
					"leavesAt": "19:09",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "19:16",
					"arrivesAt": "19:22",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6402",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "06:53",
					"arrivesAt": "07:00",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Ciurea Hm.",
					"leavesAt": "07:01",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ciurea Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "07:09",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Bârnova Hm.",
					"leavesAt": "07:19",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Grajduri",
					"leavesAt": "07:29",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Grajduri",
					"to": "Scânteia Hm.",
					"leavesAt": "07:37",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Scânteia Hm.",
					"to": "Rebricea Hm.",
					"leavesAt": "07:45",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Rebricea Hm.",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Buhăieşti",
					"leavesAt": "07:58",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Buhăieşti",
					"to": "Bârzeşti h.",
					"leavesAt": "08:04",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bârzeşti h.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "08:11",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bălteni Hm.",
					"leavesAt": "08:16",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bălteni Hm.",
					"to": "Vaslui",
					"leavesAt": "08:22",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Vaslui",
					"to": "Munteni Hm.",
					"leavesAt": "08:31",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Munteni Hm.",
					"to": "Bulboaca h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bulboaca h.",
					"to": "Crasna",
					"leavesAt": "08:43",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Crasna",
					"to": "Roşieşti hc.",
					"leavesAt": "08:51",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Roşieşti hc.",
					"to": "Dodeşti hc.",
					"leavesAt": "09:00",
					"arrivesAt": "09:06",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Dodeşti hc.",
					"to": "Banca Hm.",
					"leavesAt": "09:07",
					"arrivesAt": "09:13",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Banca Hm.",
					"to": "Zorleni",
					"leavesAt": "09:14",
					"arrivesAt": "09:24",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Zorleni",
					"to": "Bârlad",
					"leavesAt": "09:25",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1557",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "20:46",
					"arrivesAt": "21:01",
					"waitsAtSource": 0,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Crivina",
					"leavesAt": "21:02",
					"arrivesAt": "21:16",
					"waitsAtSource": 60,
					"distance": 22800
				},
				{
					"from": "Crivina",
					"to": "Ploieşti Sud",
					"leavesAt": "21:17",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 20500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5531",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Topile h.",
					"leavesAt": "20:28",
					"arrivesAt": "20:33",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Topile h.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "20:34",
					"arrivesAt": "20:42",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Timişeşti Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:50",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Plăieşu h.",
					"leavesAt": "20:51",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Plăieşu h.",
					"to": "Sfântu Mina h.",
					"leavesAt": "20:57",
					"arrivesAt": "21:00",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Târgu Neamţ",
					"leavesAt": "21:01",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2207",
			"segments": [
				{
					"from": "Arad",
					"to": "Şofronea",
					"leavesAt": "14:48",
					"arrivesAt": "14:58",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Şofronea",
					"to": "Curtici",
					"leavesAt": "14:59",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180107",
					"daysOfWeek": 799
				},
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180609",
					"daysOfWeek": 799
				},
				{
					"from": "20180611",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180623",
					"to": "20180624",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20180928",
					"daysOfWeek": 799
				},
				{
					"from": "20181001",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3500",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Cistei h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:29",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Cistei h.",
					"to": "Crăciunel Hm.",
					"leavesAt": "04:30",
					"arrivesAt": "04:40",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Crăciunel Hm.",
					"to": "Blaj",
					"leavesAt": "04:44",
					"arrivesAt": "04:52",
					"waitsAtSource": 240,
					"distance": 5300
				},
				{
					"from": "Blaj",
					"to": "Câmpu Libertăţii  h.",
					"leavesAt": "04:53",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Câmpu Libertăţii  h.",
					"to": "Mănărade h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:02",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Mănărade h.",
					"to": "Glogoveţ h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:06",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Glogoveţ h.",
					"to": "Valea Lungă Hm.",
					"leavesAt": "05:07",
					"arrivesAt": "05:11",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Lunca h.",
					"leavesAt": "05:12",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Lunca h.",
					"to": "Micăsasa h.",
					"leavesAt": "05:16",
					"arrivesAt": "05:25",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Micăsasa h.",
					"to": "Copşa Mică",
					"leavesAt": "05:26",
					"arrivesAt": "05:43",
					"waitsAtSource": 30,
					"distance": 10200
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "05:44",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "05:52",
					"arrivesAt": "05:59",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Bratei h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:12",
					"waitsAtSource": 300,
					"distance": 5100
				},
				{
					"from": "Bratei h.",
					"to": "Aţel Hm.",
					"leavesAt": "06:13",
					"arrivesAt": "06:21",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Aţel Hm.",
					"to": "Dumbrăveni",
					"leavesAt": "06:22",
					"arrivesAt": "06:32",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Dumbrăveni",
					"to": "Luna h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Luna h.",
					"to": "Daneş Hm.",
					"leavesAt": "06:41",
					"arrivesAt": "06:48",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Daneş Hm.",
					"to": "Sighişoara",
					"leavesAt": "06:49",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Sighişoara",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "07:15",
					"arrivesAt": "07:23",
					"waitsAtSource": 600,
					"distance": 4800
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Vânători",
					"leavesAt": "07:24",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Vânători",
					"to": "Saschiz h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Saschiz h.",
					"to": "Mureni Hm.",
					"leavesAt": "07:37",
					"arrivesAt": "07:43",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mureni Hm.",
					"to": "Archita h",
					"leavesAt": "07:44",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Archita h",
					"to": "Beia Hm.",
					"leavesAt": "07:58",
					"arrivesAt": "08:13",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Beia Hm.",
					"to": "Paloş Ardeal h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paloş Ardeal h.",
					"to": "Caţa Hm.",
					"leavesAt": "08:22",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Caţa Hm.",
					"to": "Rupea",
					"leavesAt": "08:29",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Rupea",
					"to": "Mateiaş h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Mateiaş h.",
					"to": "Racoş Hm.",
					"leavesAt": "08:54",
					"arrivesAt": "09:00",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Racoş Hm.",
					"to": "Augustin Hm.",
					"leavesAt": "09:01",
					"arrivesAt": "09:17",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Augustin Hm.",
					"to": "Ormeniş h.",
					"leavesAt": "09:18",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ormeniş h.",
					"to": "Apaţa",
					"leavesAt": "09:27",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Apaţa",
					"to": "Măieruş h.",
					"leavesAt": "09:38",
					"arrivesAt": "09:43",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Măieruş h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "09:44",
					"arrivesAt": "09:49",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Rotbav h.",
					"leavesAt": "09:50",
					"arrivesAt": "09:55",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Rotbav h.",
					"to": "Feldioara Hm.",
					"leavesAt": "09:56",
					"arrivesAt": "10:03",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Bod Hm.",
					"leavesAt": "10:04",
					"arrivesAt": "10:19",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Bod Hm.",
					"to": "Stupini Hm.",
					"leavesAt": "10:20",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Stupini Hm.",
					"to": "Braşov",
					"leavesAt": "10:30",
					"arrivesAt": "10:40",
					"waitsAtSource": 60,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5501",
			"segments": [
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "03:10",
					"arrivesAt": "03:15",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "03:16",
					"arrivesAt": "03:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "03:27",
					"arrivesAt": "03:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "03:33",
					"arrivesAt": "03:38",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "03:39",
					"arrivesAt": "03:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "03:46",
					"arrivesAt": "03:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "03:53",
					"arrivesAt": "03:59",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "04:00",
					"arrivesAt": "04:06",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "04:07",
					"arrivesAt": "04:13",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "04:14",
					"arrivesAt": "04:21",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "04:23",
					"arrivesAt": "04:29",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9439",
			"segments": [
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "21:40",
					"arrivesAt": "21:45",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Podu Rizii h.",
					"leavesAt": "21:46",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Podu Rizii h.",
					"to": "Băneşti h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "21:56",
					"arrivesAt": "22:00",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "22:01",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "22:05",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "22:10",
					"arrivesAt": "22:15",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "22:16",
					"arrivesAt": "22:24",
					"waitsAtSource": 60,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9409",
			"segments": [
				{
					"from": "Caracal",
					"to": "Romula Hm.",
					"leavesAt": "20:46",
					"arrivesAt": "20:59",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Romula Hm.",
					"to": "Fălcoiu h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Fălcoiu h.",
					"to": "Vlăduleni",
					"leavesAt": "21:09",
					"arrivesAt": "21:17",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Vlăduleni",
					"to": "Şopârliţa hc.",
					"leavesAt": "21:18",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Piatra Olt",
					"leavesAt": "21:23",
					"arrivesAt": "21:37",
					"waitsAtSource": 30,
					"distance": 11100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3073",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "07:40",
					"arrivesAt": "07:46",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Suceag h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Suceag h.",
					"to": "Rădaia h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Rădaia h.",
					"to": "Mera Hm.",
					"leavesAt": "07:56",
					"arrivesAt": "07:59",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Mera Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Nădăşel h.",
					"to": "Gârbău Hm.",
					"leavesAt": "08:04",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gârbău Hm.",
					"to": "Macău h.",
					"leavesAt": "08:13",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Macău h.",
					"to": "Dorolţu h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:22",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Dorolţu h.",
					"to": "Aghireş",
					"leavesAt": "08:23",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Gălăşeni h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:41",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Gălăşeni h.",
					"to": "Stana Hm.",
					"leavesAt": "08:42",
					"arrivesAt": "08:47",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Stana Hm.",
					"to": "Jebuc h.",
					"leavesAt": "08:48",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Jebuc h.",
					"to": "Huedin",
					"leavesAt": "08:57",
					"arrivesAt": "09:04",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Huedin",
					"to": "Brăişoru Hm.",
					"leavesAt": "09:05",
					"arrivesAt": "09:13",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Bologa h.",
					"leavesAt": "09:14",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bologa h.",
					"to": "Poieni",
					"leavesAt": "09:20",
					"arrivesAt": "09:25",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Poieni",
					"to": "Valea Drăganului h.",
					"leavesAt": "09:26",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Drăganului h.",
					"to": "Ciucea Hm.",
					"leavesAt": "09:31",
					"arrivesAt": "09:36",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Ciucea Hm.",
					"to": "Negreni h.",
					"leavesAt": "09:43",
					"arrivesAt": "09:47",
					"waitsAtSource": 420,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Lacu Crişului h.",
					"leavesAt": "09:48",
					"arrivesAt": "09:52",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "09:53",
					"arrivesAt": "09:58",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bulz Hm.",
					"leavesAt": "09:59",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bulz Hm.",
					"to": "Stâna de Vale h.",
					"leavesAt": "10:05",
					"arrivesAt": "10:08",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bratca",
					"leavesAt": "10:09",
					"arrivesAt": "10:14",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bratca",
					"to": "Bălnaca h.",
					"leavesAt": "10:15",
					"arrivesAt": "10:18",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Bălnaca h.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "10:19",
					"arrivesAt": "10:25",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Peştera h.",
					"leavesAt": "10:26",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Peştera h.",
					"to": "Vadu Crişului h.",
					"leavesAt": "10:30",
					"arrivesAt": "10:33",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului h.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "10:34",
					"arrivesAt": "10:38",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Butan h.",
					"leavesAt": "10:42",
					"arrivesAt": "10:48",
					"waitsAtSource": 240,
					"distance": 5000
				},
				{
					"from": "Butan h.",
					"to": "Aleşd h.",
					"leavesAt": "10:49",
					"arrivesAt": "10:55",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Aleşd h.",
					"to": "Aleşd",
					"leavesAt": "10:56",
					"arrivesAt": "11:02",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aleşd",
					"to": "Ţeţchea hc.",
					"leavesAt": "11:03",
					"arrivesAt": "11:07",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Ţeţchea hc.",
					"to": "Telechiu Hm.",
					"leavesAt": "11:08",
					"arrivesAt": "11:13",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Telechiu Hm.",
					"to": "Tileagd",
					"leavesAt": "11:14",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Tileagd",
					"to": "Săbolciu h.",
					"leavesAt": "11:21",
					"arrivesAt": "11:27",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Săbolciu h.",
					"to": "Săcădat h.",
					"leavesAt": "11:28",
					"arrivesAt": "11:31",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săcădat h.",
					"to": "Oşorhei Hm.",
					"leavesAt": "11:32",
					"arrivesAt": "11:39",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Oradea Est",
					"leavesAt": "11:40",
					"arrivesAt": "11:48",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Oradea Est",
					"to": "Oradea",
					"leavesAt": "11:49",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7363",
			"segments": [
				{
					"from": "Buzău",
					"to": "Tăbărăşti h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:39",
					"waitsAtSource": 0,
					"distance": 9700
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:42",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Bentu h.",
					"leavesAt": "15:43",
					"arrivesAt": "15:47",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bentu h.",
					"to": "Cilibia Hm.",
					"leavesAt": "15:48",
					"arrivesAt": "15:52",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cilibia Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "15:53",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Movila Oii h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Vizireni h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:13",
					"waitsAtSource": 300,
					"distance": 3300
				},
				{
					"from": "Vizireni h.",
					"to": "Făurei",
					"leavesAt": "16:14",
					"arrivesAt": "16:23",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Făurei",
					"to": "Găiseanca h.",
					"leavesAt": "16:25",
					"arrivesAt": "16:28",
					"waitsAtSource": 120,
					"distance": 3900
				},
				{
					"from": "Găiseanca h.",
					"to": "Deduleşti Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Ianca hc.",
					"leavesAt": "16:36",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ianca hc.",
					"to": "Plopu",
					"leavesAt": "16:42",
					"arrivesAt": "16:45",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Plopu",
					"to": "Urleasca Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Urleasca Hm.",
					"to": "Traian Sat Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Lacu Sărat",
					"leavesAt": "17:00",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Lacu Sărat",
					"to": "Brăila",
					"leavesAt": "17:09",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "17:20",
					"arrivesAt": "17:25",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "17:26",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Zagna Vădeni h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Barboşi",
					"leavesAt": "17:35",
					"arrivesAt": "17:41",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:49",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "17:55",
					"arrivesAt": "18:06",
					"waitsAtSource": 360,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1964",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "22:29",
					"arrivesAt": "22:35",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Bârnova Hm.",
					"leavesAt": "22:37",
					"arrivesAt": "22:59",
					"waitsAtSource": 120,
					"distance": 16300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Buhăieşti",
					"leavesAt": "23:00",
					"arrivesAt": "23:22",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Buhăieşti",
					"to": "Vaslui",
					"leavesAt": "23:23",
					"arrivesAt": "23:41",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Vaslui",
					"to": "Crasna",
					"leavesAt": "23:46",
					"arrivesAt": "00:00",
					"waitsAtSource": 300,
					"distance": 15500
				},
				{
					"from": "Crasna",
					"to": "Bârlad",
					"leavesAt": "00:01",
					"arrivesAt": "00:34",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Bârlad",
					"to": "Tecuci Nord hc.(605)",
					"leavesAt": "00:39",
					"arrivesAt": "01:24",
					"waitsAtSource": 300,
					"distance": 48600
				},
				{
					"from": "Tecuci Nord hc.(605)",
					"to": "Mărăşeşti",
					"leavesAt": "01:26",
					"arrivesAt": "01:52",
					"waitsAtSource": 120,
					"distance": 17800
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "02:10",
					"arrivesAt": "02:34",
					"waitsAtSource": 1080,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "02:36",
					"arrivesAt": "03:13",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "03:15",
					"arrivesAt": "03:47",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Făurei",
					"leavesAt": "04:07",
					"arrivesAt": "04:45",
					"waitsAtSource": 1200,
					"distance": 40400
				},
				{
					"from": "Făurei",
					"to": "Spicu",
					"leavesAt": "04:47",
					"arrivesAt": "05:12",
					"waitsAtSource": 120,
					"distance": 36400
				},
				{
					"from": "Spicu",
					"to": "Ţăndărei",
					"leavesAt": "05:13",
					"arrivesAt": "05:29",
					"waitsAtSource": 60,
					"distance": 21700
				},
				{
					"from": "Ţăndărei",
					"to": "Platoneşti h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:37",
					"waitsAtSource": 120,
					"distance": 6000
				},
				{
					"from": "Platoneşti h.",
					"to": "Movila Hm.",
					"leavesAt": "05:38",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Movila Hm.",
					"to": "Feteşti",
					"leavesAt": "05:48",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 16700
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "06:07",
					"arrivesAt": "06:27",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "06:28",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Palas",
					"leavesAt": "06:46",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 30600
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "07:04",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:55",
					"waitsAtSource": 1200,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "07:56",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "08:07",
					"arrivesAt": "08:14",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:25",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "08:26",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "08:35",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "08:41",
					"arrivesAt": "08:54",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "08:56",
					"arrivesAt": "09:01",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "09:02",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180426",
					"to": "20180430",
					"daysOfWeek": 383
				},
				{
					"from": "20180524",
					"to": "20180528",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4133",
			"segments": [
				{
					"from": "Beclean pe Someş",
					"to": "Cociu h.",
					"leavesAt": "02:52",
					"arrivesAt": "03:00",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Cociu h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "03:01",
					"arrivesAt": "03:04",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Nimigea h.",
					"leavesAt": "03:05",
					"arrivesAt": "03:09",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Nimigea h.",
					"to": "Nimigea Hm.",
					"leavesAt": "03:10",
					"arrivesAt": "03:14",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Nimigea Hm.",
					"to": "Mititei h.",
					"leavesAt": "03:15",
					"arrivesAt": "03:21",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mititei h.",
					"to": "Salva",
					"leavesAt": "03:22",
					"arrivesAt": "03:26",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Salva",
					"to": "Coşbuc Hm.",
					"leavesAt": "03:28",
					"arrivesAt": "03:41",
					"waitsAtSource": 120,
					"distance": 9500
				},
				{
					"from": "Coşbuc Hm.",
					"to": "Telciu Hm.",
					"leavesAt": "03:42",
					"arrivesAt": "03:50",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Telciu Hm.",
					"to": "Fiad Hm.",
					"leavesAt": "03:51",
					"arrivesAt": "04:05",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Fiad Hm.",
					"to": "Romuli h.",
					"leavesAt": "04:16",
					"arrivesAt": "04:25",
					"waitsAtSource": 660,
					"distance": 6700
				},
				{
					"from": "Romuli h.",
					"to": "Dealu Ştefăniţei",
					"leavesAt": "04:26",
					"arrivesAt": "04:35",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Dealu Ştefăniţei",
					"to": "Săcel Hm.",
					"leavesAt": "04:36",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Săcel Hm.",
					"to": "Iza P.M.",
					"leavesAt": "04:48",
					"arrivesAt": "04:58",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Iza P.M.",
					"to": "Vişeu de Jos",
					"leavesAt": "04:59",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Vişeu de Jos",
					"to": "Bocicoel h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:17",
					"waitsAtSource": 120,
					"distance": 2700
				},
				{
					"from": "Bocicoel h.",
					"to": "Leordina h.",
					"leavesAt": "05:18",
					"arrivesAt": "05:26",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Leordina h.",
					"to": "Leordina",
					"leavesAt": "05:27",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Leordina",
					"to": "Petrova hc.",
					"leavesAt": "05:34",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Petrova hc.",
					"to": "Vişeu Bistra h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Valea Vişeului",
					"leavesAt": "05:54",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Valea Vişeului",
					"to": "Lunca la Tisa h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:39",
					"waitsAtSource": 900,
					"distance": 10700
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "06:40",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Crăciuneşti h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Tisa h.",
					"leavesAt": "06:54",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Tisa h.",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "06:58",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Sighetu Marmaţiei",
					"leavesAt": "07:06",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 1900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "75",
			"segments": [
				{
					"from": "Lokoshaza",
					"to": "Curtici",
					"leavesAt": "13:40",
					"arrivesAt": "13:50",
					"waitsAtSource": 0,
					"distance": 11200
				},
				{
					"from": "Curtici",
					"to": "Arad",
					"leavesAt": "14:20",
					"arrivesAt": "14:34",
					"waitsAtSource": 1800,
					"distance": 17000
				},
				{
					"from": "Arad",
					"to": "Radna",
					"leavesAt": "14:36",
					"arrivesAt": "15:13",
					"waitsAtSource": 120,
					"distance": 34500
				},
				{
					"from": "Radna",
					"to": "Săvârşin",
					"leavesAt": "15:14",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 49700
				},
				{
					"from": "Săvârşin",
					"to": "Ilia",
					"leavesAt": "16:10",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Ilia",
					"to": "Deva",
					"leavesAt": "16:58",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 23600
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "17:27",
					"arrivesAt": "17:39",
					"waitsAtSource": 120,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Vinţu de Jos",
					"leavesAt": "17:51",
					"arrivesAt": "18:48",
					"waitsAtSource": 720,
					"distance": 43800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Sebeş Alba",
					"leavesAt": "18:49",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Sebeş Alba",
					"to": "Sibiu",
					"leavesAt": "19:00",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 73700
				},
				{
					"from": "Sibiu",
					"to": "Voila Hm.",
					"leavesAt": "20:35",
					"arrivesAt": "21:47",
					"waitsAtSource": 300,
					"distance": 71900
				},
				{
					"from": "Voila Hm.",
					"to": "Făgăraş",
					"leavesAt": "21:51",
					"arrivesAt": "22:04",
					"waitsAtSource": 240,
					"distance": 12000
				},
				{
					"from": "Făgăraş",
					"to": "Codlea Hm.",
					"leavesAt": "22:05",
					"arrivesAt": "22:59",
					"waitsAtSource": 60,
					"distance": 51200
				},
				{
					"from": "Codlea Hm.",
					"to": "Braşov",
					"leavesAt": "23:00",
					"arrivesAt": "23:17",
					"waitsAtSource": 60,
					"distance": 13800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8587",
			"segments": [
				{
					"from": "Slobozia Veche",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "19:47",
					"arrivesAt": "19:57",
					"waitsAtSource": 0,
					"distance": 4200
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Brâncoveni h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Brâncoveni h.",
					"to": "Ciulniţa",
					"leavesAt": "20:07",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9065",
			"segments": [
				{
					"from": "Caracal",
					"to": "Canton 239+700 h.",
					"leavesAt": "18:20",
					"arrivesAt": "18:22",
					"waitsAtSource": 0,
					"distance": 1400
				},
				{
					"from": "Canton 239+700 h.",
					"to": "Grupa Tehnică Caracal Hm.",
					"leavesAt": "18:23",
					"arrivesAt": "18:27",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Grupa Tehnică Caracal Hm.",
					"to": "Deveselu h.",
					"leavesAt": "18:28",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Deveselu h.",
					"to": "Frăsinet hc.",
					"leavesAt": "18:34",
					"arrivesAt": "18:42",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Frăsinet hc.",
					"to": "Studiniţa h.",
					"leavesAt": "18:43",
					"arrivesAt": "18:47",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Studiniţa h.",
					"to": "Studina hc.",
					"leavesAt": "18:48",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Studina hc.",
					"to": "Vişina h.",
					"leavesAt": "18:54",
					"arrivesAt": "19:01",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Vişina h.",
					"to": "Vişina Veche hc.",
					"leavesAt": "19:02",
					"arrivesAt": "19:05",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vişina Veche hc.",
					"to": "Corabia",
					"leavesAt": "19:06",
					"arrivesAt": "19:20",
					"waitsAtSource": 30,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9668",
			"segments": [
				{
					"from": "Stamora Moraviţa",
					"to": "Denta h.",
					"leavesAt": "20:45",
					"arrivesAt": "20:53",
					"waitsAtSource": 0,
					"distance": 8400
				},
				{
					"from": "Denta h.",
					"to": "Deta Hm.",
					"leavesAt": "20:54",
					"arrivesAt": "21:01",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Deta Hm.",
					"to": "Voiteni",
					"leavesAt": "21:02",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "21:13",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "21:24",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "21:31",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara Sud",
					"leavesAt": "21:40",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "21:49",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9532",
			"segments": [
				{
					"from": "Curtea de Argeş",
					"to": "Băiculeşti h.",
					"leavesAt": "16:00",
					"arrivesAt": "16:10",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Băiculeşti h.",
					"to": "Merişani h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Merişani h.",
					"to": "Bascov Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Bascov Hm.",
					"to": "C.I.L. h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "C.I.L. h.",
					"to": "Piteşti Nord",
					"leavesAt": "16:39",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Piteşti Nord",
					"to": "Piteşti",
					"leavesAt": "16:44",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4409",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Ram. Botiz h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:21",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Micula Hm.",
					"leavesAt": "16:22",
					"arrivesAt": "16:30",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Micula Hm.",
					"to": "Porumbeşti Hm.",
					"leavesAt": "16:31",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Halmeu",
					"leavesAt": "16:38",
					"arrivesAt": "16:44",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2710",
			"segments": [
				{
					"from": "Simeria",
					"to": "Simeria Triaj",
					"leavesAt": "16:08",
					"arrivesAt": "16:14",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Simeria Triaj",
					"to": "Băcia h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Băcia h.",
					"to": "Băcia Hm.",
					"leavesAt": "16:18",
					"arrivesAt": "16:20",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Băcia Hm.",
					"to": "Batiz h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Batiz h.",
					"to": "Călan Băi",
					"leavesAt": "16:24",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Călan Băi",
					"to": "Călan Hm.",
					"leavesAt": "16:27",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Hm.",
					"to": "Ruşi h.",
					"leavesAt": "16:32",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ruşi h.",
					"to": "Măceu h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:38",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Măceu h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "16:39",
					"arrivesAt": "16:44",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Plopi h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Plopi h.",
					"to": "Covragiu h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Covragiu h.",
					"to": "Subcetate",
					"leavesAt": "16:52",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Subcetate",
					"to": "Ciopea h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ciopea h.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Băeşti Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:08",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ruşor h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:11",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ruşor h.",
					"to": "Pui",
					"leavesAt": "17:12",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Pui",
					"to": "Ponor h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ponor h.",
					"to": "Livadia h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Livadia h.",
					"to": "Baru Mare",
					"leavesAt": "17:26",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Baru Mare",
					"to": "Baru Mare h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Baru Mare h.",
					"to": "Crivadia Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Crivadia Hm.",
					"to": "Merişor Hm.",
					"leavesAt": "17:48",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Merişor Hm.",
					"to": "Băniţa",
					"leavesAt": "17:57",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băniţa",
					"to": "Peştera Bolii h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Petroşani Triaj h.",
					"leavesAt": "18:17",
					"arrivesAt": "18:21",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Petroşani Triaj h.",
					"to": "Dep Petroşani h.",
					"leavesAt": "18:22",
					"arrivesAt": "18:24",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Petroşani",
					"leavesAt": "18:25",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 288
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1969",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Paşcani",
					"leavesAt": "12:16",
					"arrivesAt": "13:19",
					"waitsAtSource": 0,
					"distance": 75700
				}
			],
			"restrictions": [
				{
					"from": "20181012",
					"to": "20181015",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5105",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Putna Seacă Hm.",
					"leavesAt": "11:15",
					"arrivesAt": "11:24",
					"waitsAtSource": 0,
					"distance": 8000
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Focşani",
					"leavesAt": "11:25",
					"arrivesAt": "11:39",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Focşani",
					"to": "Coteşti Hm.",
					"leavesAt": "11:41",
					"arrivesAt": "11:49",
					"waitsAtSource": 120,
					"distance": 7900
				},
				{
					"from": "Coteşti Hm.",
					"to": "Gugeşti",
					"leavesAt": "11:50",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Gugeşti",
					"to": "Sihlea Hm.",
					"leavesAt": "11:58",
					"arrivesAt": "12:05",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sihlea Hm.",
					"to": "Voetin h.",
					"leavesAt": "12:06",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Voetin h.",
					"to": "Râmnicu Sărat",
					"leavesAt": "12:15",
					"arrivesAt": "12:25",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Zoita Hm.",
					"leavesAt": "12:26",
					"arrivesAt": "12:36",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Zoita Hm.",
					"to": "Boboc Hm.",
					"leavesAt": "12:37",
					"arrivesAt": "12:47",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Boboc Hm.",
					"to": "Buzău",
					"leavesAt": "12:48",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Buzău",
					"to": "Buzău Sud",
					"leavesAt": "13:25",
					"arrivesAt": "13:31",
					"waitsAtSource": 1500,
					"distance": 4600
				},
				{
					"from": "Buzău Sud",
					"to": "Tăbărăşti h.",
					"leavesAt": "13:32",
					"arrivesAt": "13:38",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "13:39",
					"arrivesAt": "13:42",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Bentu h.",
					"leavesAt": "13:43",
					"arrivesAt": "13:48",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bentu h.",
					"to": "Cilibia Hm.",
					"leavesAt": "13:49",
					"arrivesAt": "13:54",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cilibia Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "13:55",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Movila Oii h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "14:01",
					"arrivesAt": "14:08",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Vizireni h.",
					"leavesAt": "14:09",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vizireni h.",
					"to": "CTF Făurei h.",
					"leavesAt": "14:14",
					"arrivesAt": "14:18",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "CTF Făurei h.",
					"to": "Făurei",
					"leavesAt": "14:19",
					"arrivesAt": "14:26",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Făurei",
					"to": "Găiseanca h.",
					"leavesAt": "14:27",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Găiseanca h.",
					"to": "Deduleşti Hm.",
					"leavesAt": "14:32",
					"arrivesAt": "14:39",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Ianca hc.",
					"leavesAt": "14:40",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ianca hc.",
					"to": "Plopu",
					"leavesAt": "14:47",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Plopu",
					"to": "Urleasca Hm.",
					"leavesAt": "14:51",
					"arrivesAt": "14:58",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Urleasca Hm.",
					"to": "Traian Sat Hm.",
					"leavesAt": "14:59",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Lacu Sărat",
					"leavesAt": "15:07",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Lacu Sărat",
					"to": "Brăila",
					"leavesAt": "15:17",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "15:27",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Zagna Vădeni h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Barboşi",
					"leavesAt": "15:45",
					"arrivesAt": "15:52",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "15:54",
					"arrivesAt": "16:01",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "16:02",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4508",
			"segments": [
				{
					"from": "Gheorgheni",
					"to": "Valea Strâmbă h.",
					"leavesAt": "12:58",
					"arrivesAt": "13:02",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Şugău h.",
					"leavesAt": "13:03",
					"arrivesAt": "13:06",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Şugău h.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "13:07",
					"arrivesAt": "13:11",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "13:12",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Sândominic h.",
					"leavesAt": "13:23",
					"arrivesAt": "13:31",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Oltului",
					"leavesAt": "13:32",
					"arrivesAt": "13:37",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Tomeşti h.",
					"leavesAt": "13:38",
					"arrivesAt": "13:41",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Cârţani h.",
					"leavesAt": "13:42",
					"arrivesAt": "13:45",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Cârţani h.",
					"to": "Dăneşti h.",
					"leavesAt": "13:46",
					"arrivesAt": "13:49",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Dăneşti h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "13:50",
					"arrivesAt": "13:56",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Racu h.",
					"leavesAt": "13:57",
					"arrivesAt": "14:02",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Racu h.",
					"to": "Siculeni",
					"leavesAt": "14:03",
					"arrivesAt": "14:08",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "14:12",
					"arrivesAt": "14:21",
					"waitsAtSource": 240,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "14:27",
					"arrivesAt": "14:35",
					"waitsAtSource": 360,
					"distance": 7800
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "14:36",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "14:40",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Vrabia h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Vrabia h.",
					"to": "Tuşnad Sat",
					"leavesAt": "14:51",
					"arrivesAt": "14:55",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Tuşnad Sat",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "14:56",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "15:04",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Malnaş Băi",
					"leavesAt": "15:17",
					"arrivesAt": "15:27",
					"waitsAtSource": 300,
					"distance": 7800
				},
				{
					"from": "Malnaş Băi",
					"to": "Malnaş h.",
					"leavesAt": "15:28",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Malnaş h.",
					"to": "Bodoc Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:42",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Bodoc Hm.",
					"to": "Arcuş h.",
					"leavesAt": "15:50",
					"arrivesAt": "15:55",
					"waitsAtSource": 480,
					"distance": 4500
				},
				{
					"from": "Arcuş h.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "15:56",
					"arrivesAt": "16:01",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "16:03",
					"arrivesAt": "16:09",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "16:15",
					"arrivesAt": "16:20",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "16:25",
					"arrivesAt": "16:33",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "16:40",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2094",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "14:00",
					"arrivesAt": "14:08",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Budieni h.",
					"leavesAt": "14:09",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Budieni h.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "14:14",
					"arrivesAt": "14:19",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Scoarţa h.",
					"leavesAt": "14:20",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Scoarţa h.",
					"to": "Pojogeni Hm.",
					"leavesAt": "14:24",
					"arrivesAt": "14:27",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "14:28",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cărbuneşti",
					"to": "Jupâneşti Hm.",
					"leavesAt": "14:36",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "14:42",
					"arrivesAt": "14:48",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "14:49",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Musculeşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "14:56",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "15:01",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Gilort Hm.",
					"leavesAt": "15:10",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gilort Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "15:17",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Floreşti hc.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "15:21",
					"arrivesAt": "15:26",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Bungeţel h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bungeţel h.",
					"to": "Filiaşi",
					"leavesAt": "15:31",
					"arrivesAt": "15:35",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "15:38",
					"arrivesAt": "15:41",
					"waitsAtSource": 180,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "15:42",
					"arrivesAt": "15:46",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:51",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "15:52",
					"arrivesAt": "15:58",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "16:03",
					"arrivesAt": "16:08",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "16:18",
					"arrivesAt": "16:20",
					"waitsAtSource": 600,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "16:21",
					"arrivesAt": "16:25",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "16:26",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "16:29",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2494",
			"segments": [
				{
					"from": "Cugir  Hm.",
					"to": "Cugir hc.",
					"leavesAt": "15:10",
					"arrivesAt": "15:13",
					"waitsAtSource": 0,
					"distance": 600
				},
				{
					"from": "Cugir hc.",
					"to": "Vinerea h.",
					"leavesAt": "15:14",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Vinerea h.",
					"to": "Şibot",
					"leavesAt": "15:27",
					"arrivesAt": "15:40",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Şibot",
					"to": "Balomiru de Câmp h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Balomiru de Câmp h.",
					"to": "Tărtăria h.",
					"leavesAt": "15:48",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Tărtăria h.",
					"to": "Blandiana Hm.",
					"leavesAt": "15:56",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Blandiana Hm.",
					"to": "Vinţu de Jos",
					"leavesAt": "16:06",
					"arrivesAt": "16:14",
					"waitsAtSource": 300,
					"distance": 5200
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "16:15",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:38",
					"waitsAtSource": 120,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Sântimbru  Hm.",
					"leavesAt": "16:39",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Sântimbru  Hm.",
					"to": "Sântimbru h.",
					"leavesAt": "16:47",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Sântimbru h.",
					"to": "Coşlariu",
					"leavesAt": "16:51",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "17:04",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2210",
			"segments": [
				{
					"from": "Curtici",
					"to": "Şofronea",
					"leavesAt": "15:40",
					"arrivesAt": "15:48",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Şofronea",
					"to": "Arad",
					"leavesAt": "15:49",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180107",
					"daysOfWeek": 799
				},
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180623",
					"to": "20180624",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2232",
			"segments": [
				{
					"from": "Remetea Mică",
					"to": "Şarlota h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:36",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Şarlota h.",
					"to": "Gomila h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Gomila h.",
					"to": "Aliuş hcv.",
					"leavesAt": "06:46",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Aliuş hcv.",
					"to": "Zăbrani Hm.",
					"leavesAt": "06:55",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Zăbrani Hm.",
					"to": "Neudorf h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Neudorf h.",
					"to": "Radna",
					"leavesAt": "07:12",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5205",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "12:40",
					"arrivesAt": "12:46",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "12:47",
					"arrivesAt": "12:50",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "12:51",
					"arrivesAt": "12:56",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "12:57",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "13:01",
					"arrivesAt": "13:12",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Urecheşti Hm.",
					"leavesAt": "13:14",
					"arrivesAt": "13:24",
					"waitsAtSource": 120,
					"distance": 9700
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "13:25",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Bâlca hc.",
					"leavesAt": "13:29",
					"arrivesAt": "13:33",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Bâlca hc.",
					"to": "Căiuţi Hm.",
					"leavesAt": "13:34",
					"arrivesAt": "13:39",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Borzeşti Bacău",
					"leavesAt": "13:40",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "13:50",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Oneşti",
					"leavesAt": "13:54",
					"arrivesAt": "14:00",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Oneşti",
					"to": "Trotuş h.",
					"leavesAt": "14:02",
					"arrivesAt": "14:09",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Trotuş h.",
					"to": "Viişoara h",
					"leavesAt": "14:10",
					"arrivesAt": "14:14",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Viişoara h",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "14:15",
					"arrivesAt": "14:20",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Saline hc.",
					"leavesAt": "14:21",
					"arrivesAt": "14:24",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Saline hc.",
					"to": "Cireşoaia h.",
					"leavesAt": "14:25",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cireşoaia h.",
					"to": "Dofteana Bacău",
					"leavesAt": "14:31",
					"arrivesAt": "14:35",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dofteana Bacău",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "14:36",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Valea Uzului Hm.",
					"leavesAt": "14:42",
					"arrivesAt": "14:47",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Comăneşti",
					"leavesAt": "14:48",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Comăneşti",
					"to": "Asău Hm.",
					"leavesAt": "15:00",
					"arrivesAt": "15:07",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Asău Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "15:08",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Caraliţa h.",
					"to": "Goioasa Hm.",
					"leavesAt": "15:13",
					"arrivesAt": "15:18",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Goioasa Hm.",
					"to": "Simbrea Hm.",
					"leavesAt": "15:19",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Simbrea Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "15:27",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Palanca Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:39",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Palanca Hm.",
					"to": "Ghimeş",
					"leavesAt": "15:40",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8344",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Palas",
					"leavesAt": "18:02",
					"arrivesAt": "18:09",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Palas",
					"to": "Valul lui Traian",
					"leavesAt": "18:10",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Valul lui Traian",
					"to": "Murfatlar h.",
					"leavesAt": "18:18",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Murfatlar h.",
					"to": "Basarabi",
					"leavesAt": "18:24",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "18:29",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Dorobanţu",
					"leavesAt": "18:34",
					"arrivesAt": "18:38",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Dorobanţu",
					"to": "Castelu h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Castelu h.",
					"to": "Medgidia",
					"leavesAt": "18:43",
					"arrivesAt": "18:49",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Medgidia",
					"to": "Mircea Vodă Hm.",
					"leavesAt": "18:50",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Mircea Vodă Hm.",
					"to": "Saligny",
					"leavesAt": "19:00",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Saligny",
					"to": "Cernavodă Pod",
					"leavesAt": "19:07",
					"arrivesAt": "19:16",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Cernavodă Pod",
					"to": "Dunărea Hm.",
					"leavesAt": "19:17",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Dunărea Hm.",
					"to": "Ovidiu",
					"leavesAt": "19:27",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ovidiu",
					"to": "Ramificaţia Borcea",
					"leavesAt": "19:34",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ramificaţia Borcea",
					"to": "Feteşti",
					"leavesAt": "19:39",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Feteşti",
					"to": "Bărăganu Hm.",
					"leavesAt": "19:54",
					"arrivesAt": "20:05",
					"waitsAtSource": 540,
					"distance": 9900
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Jegălia",
					"leavesAt": "20:11",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Jegălia",
					"to": "Recolta hc.",
					"leavesAt": "20:17",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Recolta hc.",
					"to": "Perişoru Hm.",
					"leavesAt": "20:21",
					"arrivesAt": "20:25",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Perişoru Hm.",
					"to": "Ogoarele h.",
					"leavesAt": "20:26",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ogoarele h.",
					"to": "Ciulniţa",
					"leavesAt": "20:31",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ciulniţa",
					"to": "Ştefan Vodă h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:55",
					"waitsAtSource": 120,
					"distance": 12600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "20:56",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Km. 25+700 h.",
					"leavesAt": "21:03",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Km. 25+700 h.",
					"to": "Călăraşi Sud",
					"leavesAt": "21:10",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 1300
				}
			],
			"restrictions": [
				{
					"from": "20180917",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1746",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Mireşu Mare PM.",
					"leavesAt": "05:12",
					"arrivesAt": "05:39",
					"waitsAtSource": 0,
					"distance": 25100
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "05:40",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Benesat Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Benesat Hm.",
					"to": "Jibou",
					"leavesAt": "05:58",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Jibou",
					"to": "Letca Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:55",
					"waitsAtSource": 600,
					"distance": 23100
				},
				{
					"from": "Letca Hm.",
					"to": "Ileanda",
					"leavesAt": "06:56",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 13600
				},
				{
					"from": "Ileanda",
					"to": "Gâlgău",
					"leavesAt": "07:14",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Gâlgău",
					"to": "Câţcău h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Câţcău h.",
					"to": "Dej Călători",
					"leavesAt": "07:43",
					"arrivesAt": "07:57",
					"waitsAtSource": 30,
					"distance": 12700
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "08:12",
					"arrivesAt": "08:31",
					"waitsAtSource": 900,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Apahida",
					"leavesAt": "08:32",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 57200
				},
				{
					"from": "Apahida",
					"to": "Cluj Napoca",
					"leavesAt": "09:08",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": -12300
				},
				{
					"from": "Cluj Napoca",
					"to": "Câmpia Turzii",
					"leavesAt": "09:37",
					"arrivesAt": "10:43",
					"waitsAtSource": 720,
					"distance": 51500
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "10:44",
					"arrivesAt": "11:00",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "11:01",
					"arrivesAt": "11:06",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Aiud Hm.",
					"leavesAt": "11:07",
					"arrivesAt": "11:22",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "11:23",
					"arrivesAt": "11:37",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Blaj",
					"leavesAt": "11:41",
					"arrivesAt": "12:09",
					"waitsAtSource": 240,
					"distance": 21300
				},
				{
					"from": "Blaj",
					"to": "Copşa Mică",
					"leavesAt": "12:10",
					"arrivesAt": "12:48",
					"waitsAtSource": 60,
					"distance": 30000
				},
				{
					"from": "Copşa Mică",
					"to": "Mediaş",
					"leavesAt": "12:53",
					"arrivesAt": "13:06",
					"waitsAtSource": 300,
					"distance": 10400
				},
				{
					"from": "Mediaş",
					"to": "Dumbrăveni",
					"leavesAt": "13:08",
					"arrivesAt": "13:33",
					"waitsAtSource": 120,
					"distance": 18000
				},
				{
					"from": "Dumbrăveni",
					"to": "Sighişoara",
					"leavesAt": "13:34",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 20400
				},
				{
					"from": "Sighişoara",
					"to": "Rupea",
					"leavesAt": "14:04",
					"arrivesAt": "15:05",
					"waitsAtSource": 180,
					"distance": 53600
				},
				{
					"from": "Rupea",
					"to": "Racoş Hm.",
					"leavesAt": "15:06",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 14000
				},
				{
					"from": "Racoş Hm.",
					"to": "Augustin Hm.",
					"leavesAt": "15:25",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Augustin Hm.",
					"to": "Braşov",
					"leavesAt": "15:42",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 49100
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "16:57",
					"arrivesAt": "17:33",
					"waitsAtSource": 720,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "17:35",
					"arrivesAt": "17:43",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "17:44",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "17:51",
					"arrivesAt": "18:00",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Comarnic",
					"leavesAt": "18:02",
					"arrivesAt": "18:16",
					"waitsAtSource": 120,
					"distance": 15100
				},
				{
					"from": "Comarnic",
					"to": "Câmpina",
					"leavesAt": "18:17",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "18:30",
					"arrivesAt": "18:54",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "18:56",
					"arrivesAt": "19:40",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6413",
			"segments": [
				{
					"from": "Vaslui",
					"to": "Bălteni Hm.",
					"leavesAt": "04:49",
					"arrivesAt": "04:59",
					"waitsAtSource": 0,
					"distance": 9800
				},
				{
					"from": "Bălteni Hm.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "05:00",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bârzeşti h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:09",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bârzeşti h.",
					"to": "Buhăieşti",
					"leavesAt": "05:10",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Buhăieşti",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "05:18",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Rebricea Hm.",
					"leavesAt": "05:24",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebricea Hm.",
					"to": "Scânteia Hm.",
					"leavesAt": "05:31",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Scânteia Hm.",
					"to": "Grajduri",
					"leavesAt": "05:38",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Grajduri",
					"to": "Bârnova Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:57",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Ciurea Hm.",
					"leavesAt": "06:05",
					"arrivesAt": "06:11",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ciurea Hm.",
					"to": "Nicolina",
					"leavesAt": "06:12",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "06:20",
					"arrivesAt": "06:27",
					"waitsAtSource": 120,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2515",
			"segments": [
				{
					"from": "Făgăraş",
					"to": "Dridif h.",
					"leavesAt": "04:44",
					"arrivesAt": "04:54",
					"waitsAtSource": 0,
					"distance": 8500
				},
				{
					"from": "Dridif h.",
					"to": "Voila Hm.",
					"leavesAt": "04:55",
					"arrivesAt": "04:59",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Voila Hm.",
					"to": "Olteţ h.",
					"leavesAt": "05:00",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Olteţ h.",
					"to": "Viştea h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:11",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Viştea h.",
					"to": "Ucea",
					"leavesAt": "05:12",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ucea",
					"to": "Arpaş Hm.",
					"leavesAt": "05:26",
					"arrivesAt": "05:35",
					"waitsAtSource": 540,
					"distance": 5100
				},
				{
					"from": "Arpaş Hm.",
					"to": "Cârţa h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cârţa h.",
					"to": "Scoreiu h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:44",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Scoreiu h.",
					"to": "Sărata Colun h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Sărata Colun h.",
					"to": "Porumbacu Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:54",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "05:55",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Avrig Hm.",
					"to": "Mârşa h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:09",
					"waitsAtSource": 120,
					"distance": 3700
				},
				{
					"from": "Mârşa h.",
					"to": "Racoviţa h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:13",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Racoviţa h.",
					"to": "Sebeş Olt h.",
					"leavesAt": "06:14",
					"arrivesAt": "06:17",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Podu Olt",
					"leavesAt": "06:18",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "06:24",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:41",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "06:42",
					"arrivesAt": "06:45",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Triaj",
					"leavesAt": "06:46",
					"arrivesAt": "06:53",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sibiu Triaj",
					"to": "Atelier Zona h",
					"leavesAt": "06:54",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h",
					"to": "Sibiu",
					"leavesAt": "06:59",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1897",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "17:30",
					"arrivesAt": "18:30",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "18:35",
					"arrivesAt": "18:54",
					"waitsAtSource": 300,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "18:55",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "19:19",
					"arrivesAt": "19:30",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Piteşti",
					"to": "Costeşti",
					"leavesAt": "19:40",
					"arrivesAt": "20:04",
					"waitsAtSource": 600,
					"distance": 21800
				},
				{
					"from": "Costeşti",
					"to": "Stolnici Hm.",
					"leavesAt": "20:05",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 15900
				},
				{
					"from": "Stolnici Hm.",
					"to": "Slatina",
					"leavesAt": "20:20",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 43300
				},
				{
					"from": "Slatina",
					"to": "Piatra Olt",
					"leavesAt": "21:00",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Piatra Olt",
					"to": "Balş",
					"leavesAt": "21:19",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 12900
				},
				{
					"from": "Balş",
					"to": "Craiova",
					"leavesAt": "21:31",
					"arrivesAt": "22:03",
					"waitsAtSource": 60,
					"distance": 31200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5730",
			"segments": [
				{
					"from": "Cacica Hm.",
					"to": "Pârteşti h.",
					"leavesAt": "04:03",
					"arrivesAt": "04:10",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Pârteşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "04:11",
					"arrivesAt": "04:17",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Soloneţ h.",
					"to": "Todireşti h.",
					"leavesAt": "04:18",
					"arrivesAt": "04:25",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Todireşti h.",
					"to": "Părhăuţi h.",
					"leavesAt": "04:26",
					"arrivesAt": "04:34",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Părhăuţi h.",
					"to": "Dărmăneşti",
					"leavesAt": "04:35",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "04:44",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "04:52",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2237",
			"segments": [
				{
					"from": "Remetea Mică",
					"to": "Fibiş h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:30",
					"waitsAtSource": 0,
					"distance": 4300
				},
				{
					"from": "Fibiş h.",
					"to": "Bencei h.",
					"leavesAt": "15:31",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bencei h.",
					"to": "Pişchia h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pişchia h.",
					"to": "Cerneteaz h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Cerneteaz h.",
					"to": "Giarmata Hm.",
					"leavesAt": "15:55",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Giarmata Hm.",
					"to": "Viile Giarmata h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Viile Giarmata h.",
					"to": "Timişoara Est",
					"leavesAt": "16:05",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "16:16",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180630",
					"to": "20180630",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9505",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "12:35",
					"arrivesAt": "12:38",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Işalniţa hc.",
					"leavesAt": "12:39",
					"arrivesAt": "12:44",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "12:45",
					"arrivesAt": "12:48",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "12:49",
					"arrivesAt": "12:52",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "12:53",
					"arrivesAt": "12:57",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "12:58",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "13:03",
					"arrivesAt": "13:08",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "13:09",
					"arrivesAt": "13:12",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "13:13",
					"arrivesAt": "13:18",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Gura Motrului Hm.",
					"leavesAt": "13:19",
					"arrivesAt": "13:27",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Butoieşti Hm.",
					"leavesAt": "13:28",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Lunca Banului h.",
					"leavesAt": "13:35",
					"arrivesAt": "13:40",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lunca Banului h.",
					"to": "Strehaia",
					"leavesAt": "13:41",
					"arrivesAt": "13:45",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Strehaia",
					"to": "Strehaia hc.",
					"leavesAt": "13:46",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Strehaia hc.",
					"to": "Ciochiuţa Hm.",
					"leavesAt": "13:50",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Ciochiuţa Hm.",
					"to": "Tâmna",
					"leavesAt": "13:59",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Tâmna",
					"to": "Igiroasa Hm.",
					"leavesAt": "14:08",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Igiroasa Hm.",
					"to": "Prunişor Hm.",
					"leavesAt": "14:14",
					"arrivesAt": "14:21",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prunişor Hm.",
					"to": "Gârniţa Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:28",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Gârniţa Hm.",
					"to": "Balota",
					"leavesAt": "14:29",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Balota",
					"to": "Valea Albă Hm.",
					"leavesAt": "14:34",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Valea Albă Hm.",
					"to": "Ergheviţa h.",
					"leavesAt": "14:49",
					"arrivesAt": "14:55",
					"waitsAtSource": 240,
					"distance": 3300
				},
				{
					"from": "Ergheviţa h.",
					"to": "Drobeta Tr. Severin Mf.",
					"leavesAt": "14:56",
					"arrivesAt": "15:06",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Drobeta Tr. Severin Mf.",
					"to": "Drobeta Tr.Sev Est Hm.",
					"leavesAt": "15:07",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Drobeta Tr.Sev Est Hm.",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "15:14",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Gura Văii Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:28",
					"waitsAtSource": 120,
					"distance": 8500
				},
				{
					"from": "Gura Văii Hm.",
					"to": "Vârciorova Hm.",
					"leavesAt": "15:29",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Vârciorova Hm.",
					"to": "Orşova",
					"leavesAt": "15:41",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 7700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8655",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Basarabi",
					"leavesAt": "15:43",
					"arrivesAt": "15:58",
					"waitsAtSource": 0,
					"distance": 17400
				},
				{
					"from": "Basarabi",
					"to": "Poarta Albă h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Poarta Albă h.",
					"to": "Medgidia",
					"leavesAt": "16:04",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Medgidia",
					"to": "Nicolae Bălcescu",
					"leavesAt": "16:45",
					"arrivesAt": "17:06",
					"waitsAtSource": 1680,
					"distance": 19100
				},
				{
					"from": "Nicolae Bălcescu",
					"to": "Ram. M.K.P. Aj. M.",
					"leavesAt": "17:07",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ram. M.K.P. Aj. M.",
					"to": "Târguşor Dobrogea Hm.",
					"leavesAt": "17:14",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Târguşor Dobrogea Hm.",
					"to": "Cogealac",
					"leavesAt": "17:25",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Cogealac",
					"to": "Mihai Viteazu Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 17400
				},
				{
					"from": "Mihai Viteazu Hm.",
					"to": "Baia Dobrogea",
					"leavesAt": "18:06",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Baia Dobrogea",
					"to": "Ceamurlia de Jos h.",
					"leavesAt": "18:18",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ceamurlia de Jos h.",
					"to": "Babadag",
					"leavesAt": "18:25",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Babadag",
					"to": "Zebil h.",
					"leavesAt": "18:43",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Zebil h.",
					"to": "Mihail Kogălniceanu h.",
					"leavesAt": "19:00",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Mihail Kogălniceanu h.",
					"to": "Cataloi Hm.",
					"leavesAt": "19:15",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Cataloi Hm.",
					"to": "Tulcea Mărfuri",
					"leavesAt": "19:30",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Tulcea Mărfuri",
					"to": "Tulcea Oraş",
					"leavesAt": "19:44",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20180911",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180609",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6411",
			"segments": [
				{
					"from": "Vaslui",
					"to": "Bălteni Hm.",
					"leavesAt": "03:56",
					"arrivesAt": "04:06",
					"waitsAtSource": 0,
					"distance": 9800
				},
				{
					"from": "Bălteni Hm.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "04:07",
					"arrivesAt": "04:12",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bârzeşti h.",
					"leavesAt": "04:13",
					"arrivesAt": "04:17",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bârzeşti h.",
					"to": "Buhăieşti",
					"leavesAt": "04:18",
					"arrivesAt": "04:25",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhăieşti",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "04:26",
					"arrivesAt": "04:31",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Rebricea Hm.",
					"leavesAt": "04:32",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebricea Hm.",
					"to": "Scânteia Hm.",
					"leavesAt": "04:39",
					"arrivesAt": "04:45",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Scânteia Hm.",
					"to": "Grajduri",
					"leavesAt": "04:46",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Grajduri",
					"to": "Bârnova Hm.",
					"leavesAt": "04:56",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Ciurea Hm.",
					"leavesAt": "05:12",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ciurea Hm.",
					"to": "Nicolina",
					"leavesAt": "05:19",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "05:26",
					"arrivesAt": "05:33",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "407",
			"segments": [
				{
					"from": "Biharkeresztes",
					"to": "Episcopia Bihor",
					"leavesAt": "22:53",
					"arrivesAt": "23:08",
					"waitsAtSource": 0,
					"distance": 12500
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "23:23",
					"arrivesAt": "23:31",
					"waitsAtSource": 900,
					"distance": 5700
				},
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "23:35",
					"arrivesAt": "00:08",
					"waitsAtSource": 240,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Huedin",
					"leavesAt": "00:09",
					"arrivesAt": "01:16",
					"waitsAtSource": 60,
					"distance": 68400
				},
				{
					"from": "Huedin",
					"to": "Cluj Napoca",
					"leavesAt": "01:17",
					"arrivesAt": "02:08",
					"waitsAtSource": 60,
					"distance": 49400
				},
				{
					"from": "Cluj Napoca",
					"to": "Gherla",
					"leavesAt": "02:20",
					"arrivesAt": "03:18",
					"waitsAtSource": 720,
					"distance": 44900
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "03:20",
					"arrivesAt": "03:39",
					"waitsAtSource": 120,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Beclean pe Someş",
					"leavesAt": "03:44",
					"arrivesAt": "04:17",
					"waitsAtSource": 300,
					"distance": 24600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Sărăţel Hm.",
					"leavesAt": "04:19",
					"arrivesAt": "04:46",
					"waitsAtSource": 120,
					"distance": 24900
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Deda",
					"leavesAt": "04:54",
					"arrivesAt": "05:48",
					"waitsAtSource": 480,
					"distance": 46800
				},
				{
					"from": "Deda",
					"to": "Topliţa",
					"leavesAt": "05:49",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 43900
				},
				{
					"from": "Topliţa",
					"to": "Gheorgheni",
					"leavesAt": "06:47",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 34000
				},
				{
					"from": "Gheorgheni",
					"to": "Izvoru Oltului",
					"leavesAt": "07:20",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 30000
				},
				{
					"from": "Izvoru Oltului",
					"to": "Siculeni",
					"leavesAt": "07:49",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "08:08",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "08:17",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "08:31",
					"arrivesAt": "08:50",
					"waitsAtSource": 360,
					"distance": 20700
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "08:52",
					"arrivesAt": "09:24",
					"waitsAtSource": 120,
					"distance": 34400
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Braşov",
					"leavesAt": "09:27",
					"arrivesAt": "09:57",
					"waitsAtSource": 180,
					"distance": 32100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7039",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Carpaţi h.(700)",
					"leavesAt": "19:55",
					"arrivesAt": "20:01",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Pajura Hm. (700)",
					"leavesAt": "20:02",
					"arrivesAt": "20:06",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Mogoşoaia",
					"leavesAt": "20:07",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Mogoşoaia",
					"to": "P.O. Aeroport h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Baloteşti Hm.",
					"leavesAt": "20:37",
					"arrivesAt": "20:40",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Baloteşti Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "20:41",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "20:47",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Greci h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Greci h.",
					"to": "Fierbinţi",
					"leavesAt": "20:59",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Fierbinţi",
					"to": "Dridu Hm.",
					"leavesAt": "21:06",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Dridu Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "21:13",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moldoveni h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "21:19",
					"arrivesAt": "21:25",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "21:26",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "21:31",
					"arrivesAt": "21:38",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9510",
			"segments": [
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "13:20",
					"arrivesAt": "13:23",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "13:24",
					"arrivesAt": "13:28",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "13:29",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "13:34",
					"arrivesAt": "13:39",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "13:40",
					"arrivesAt": "13:43",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "13:44",
					"arrivesAt": "13:49",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "13:50",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "13:53",
					"arrivesAt": "13:57",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "13:58",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "14:01",
					"arrivesAt": "14:05",
					"waitsAtSource": 30,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180115",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180212",
					"to": "20180330",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2080",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Lunca Jiului hc.",
					"leavesAt": "04:45",
					"arrivesAt": "04:48",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Lunca Jiului hc.",
					"to": "Livezeni",
					"leavesAt": "04:49",
					"arrivesAt": "04:54",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "04:55",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Pietrele Albe Hm.",
					"leavesAt": "05:03",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Pietrele Albe Hm.",
					"to": "Lainici Hm.",
					"leavesAt": "05:13",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lainici Hm.",
					"to": "Meri",
					"leavesAt": "05:28",
					"arrivesAt": "05:37",
					"waitsAtSource": 300,
					"distance": 6400
				},
				{
					"from": "Meri",
					"to": "Valea Sadului Hm.",
					"leavesAt": "05:38",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Parângu Hm.",
					"leavesAt": "05:46",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Parângu Hm.",
					"to": "Ezureni h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Ezureni h.",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "06:02",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Ramificaţia C.A.M. h.",
					"leavesAt": "06:07",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ramificaţia C.A.M. h.",
					"to": "Târgu Jiu",
					"leavesAt": "06:11",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 800
				},
				{
					"from": "Târgu Jiu",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "06:24",
					"arrivesAt": "06:31",
					"waitsAtSource": 540,
					"distance": 6800
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Budieni h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Budieni h.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "06:37",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Scoarţa h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Scoarţa h.",
					"to": "Pojogeni Hm.",
					"leavesAt": "06:47",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "06:51",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cărbuneşti",
					"to": "Jupâneşti Hm.",
					"leavesAt": "06:59",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "07:05",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "07:16",
					"arrivesAt": "07:23",
					"waitsAtSource": 300,
					"distance": 5900
				},
				{
					"from": "Musculeşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "07:24",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "07:30",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Gilort Hm.",
					"leavesAt": "07:39",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gilort Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "07:46",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Floreşti hc.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Bungeţel h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:00",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bungeţel h.",
					"to": "Filiaşi",
					"leavesAt": "08:01",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "08:35",
					"arrivesAt": "08:38",
					"waitsAtSource": 1800,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "08:39",
					"arrivesAt": "08:43",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "08:44",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "08:49",
					"arrivesAt": "08:55",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "08:56",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "09:00",
					"arrivesAt": "09:05",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Cernele",
					"leavesAt": "09:06",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "09:12",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "09:16",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4371",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Sărata h.",
					"leavesAt": "19:22",
					"arrivesAt": "19:30",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "19:31",
					"arrivesAt": "19:36",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "19:37",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "19:42",
					"arrivesAt": "19:47",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Sfântu h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Sfântu h.",
					"to": "Caila hc.",
					"leavesAt": "19:54",
					"arrivesAt": "19:57",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Caila hc.",
					"to": "Şintereag Hm.",
					"leavesAt": "19:58",
					"arrivesAt": "20:02",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Şintereag Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "20:03",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Beclean pe Someş",
					"to": "Coldău Hm.",
					"leavesAt": "20:14",
					"arrivesAt": "20:24",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Coldău Hm.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:31",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "20:32",
					"arrivesAt": "20:36",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Dej Triaj",
					"leavesAt": "20:37",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "20:49",
					"arrivesAt": "20:56",
					"waitsAtSource": 120,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2610",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "18:04",
					"arrivesAt": "18:11",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Valea Viilor Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Şag Hm.",
					"leavesAt": "18:23",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Şag Hm.",
					"to": "Vinga Hm.",
					"leavesAt": "18:33",
					"arrivesAt": "18:40",
					"waitsAtSource": 300,
					"distance": 7400
				},
				{
					"from": "Vinga Hm.",
					"to": "Orţişoara",
					"leavesAt": "18:41",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Orţişoara",
					"to": "Băile Călacea",
					"leavesAt": "18:48",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Băile Călacea",
					"to": "Sânandrei Hm.",
					"leavesAt": "18:54",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "19:02",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h",
					"leavesAt": "19:09",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Ronaţ Triaj Cab 1 h",
					"leavesAt": "19:12",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab 1 h",
					"to": "Timişoara Nord",
					"leavesAt": "19:15",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9101",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "05:33",
					"arrivesAt": "05:43",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "05:44",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "05:53",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "06:17",
					"arrivesAt": "06:26",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "06:34",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "06:38",
					"arrivesAt": "06:44",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Podu Rizii h.",
					"leavesAt": "06:50",
					"arrivesAt": "06:53",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Podu Rizii h.",
					"to": "Băneşti h.",
					"leavesAt": "06:54",
					"arrivesAt": "06:57",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "06:58",
					"arrivesAt": "07:00",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "07:01",
					"arrivesAt": "07:04",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "07:09",
					"arrivesAt": "07:12",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "07:13",
					"arrivesAt": "07:21",
					"waitsAtSource": 30,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8152",
			"segments": [
				{
					"from": "Slobozia Veche",
					"to": "Perieţi h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:39",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Perieţi h.",
					"to": "Fundata h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Fundata h.",
					"to": "Andrăşeşti Hm.",
					"leavesAt": "14:46",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrăşeşti Hm.",
					"to": "Ciochina hc.",
					"leavesAt": "14:53",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciochina hc.",
					"to": "Căzăneşti",
					"leavesAt": "15:03",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Căzăneşti",
					"to": "Munteni Buzău h.",
					"leavesAt": "15:12",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Munteni Buzău h.",
					"to": "Sărăţeni Ialomiţa h.",
					"leavesAt": "15:16",
					"arrivesAt": "15:19",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Sărăţeni Ialomiţa h.",
					"to": "Sărăţuica Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:24",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Sărăţuica Hm.",
					"to": "Km. 74+600 h.",
					"leavesAt": "15:25",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Km. 74+600 h.",
					"to": "Malu h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Malu h.",
					"to": "Broşteni Hm.",
					"leavesAt": "15:36",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Broşteni Hm.",
					"to": "Alexeni h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Alexeni h.",
					"to": "Urziceni",
					"leavesAt": "15:49",
					"arrivesAt": "15:57",
					"waitsAtSource": 30,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5633",
			"segments": [
				{
					"from": "Dărmăneşti",
					"to": "Milişăuţi Hm.",
					"leavesAt": "08:55",
					"arrivesAt": "09:06",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Ţibeni h.",
					"leavesAt": "09:07",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ţibeni h.",
					"to": "Dorneşti",
					"leavesAt": "09:16",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9556",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Caransebeş haltă h.",
					"leavesAt": "19:52",
					"arrivesAt": "19:55",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Caransebeş haltă h.",
					"to": "Balta Sărată",
					"leavesAt": "19:56",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Balta Sărată",
					"to": "Valea Timişului Hm.",
					"leavesAt": "20:02",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Valea Timişului Hm.",
					"to": "Petroşniţa h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Petroşniţa h.",
					"to": "Vălişoara Hm.",
					"leavesAt": "20:11",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălişoara Hm.",
					"to": "Slatina Timiş",
					"leavesAt": "20:23",
					"arrivesAt": "20:29",
					"waitsAtSource": 300,
					"distance": 6400
				},
				{
					"from": "Slatina Timiş",
					"to": "Armeniş",
					"leavesAt": "20:30",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Armeniş",
					"to": "Teregova Hm.",
					"leavesAt": "20:38",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Teregova Hm.",
					"to": "Poarta Hm.",
					"leavesAt": "20:46",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Poarta Hm.",
					"to": "Luncaviţa h.",
					"leavesAt": "20:56",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Luncaviţa h.",
					"to": "Domaşnea Cornea Hm.",
					"leavesAt": "21:02",
					"arrivesAt": "21:07",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Domaşnea Cornea Hm.",
					"to": "Cornea h.",
					"leavesAt": "21:08",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cornea h.",
					"to": "Cruşovăţ",
					"leavesAt": "21:13",
					"arrivesAt": "21:19",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Cruşovăţ",
					"to": "Iablaniţa",
					"leavesAt": "21:20",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Iablaniţa",
					"to": "Mehadia Hm.",
					"leavesAt": "21:29",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Mehadia Hm.",
					"to": "Mehadia Nouă Hm.",
					"leavesAt": "21:40",
					"arrivesAt": "21:43",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Mehadia Nouă Hm.",
					"to": "Băile Herculane",
					"leavesAt": "21:44",
					"arrivesAt": "21:47",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Băile Herculane",
					"to": "Topleţ Hm.",
					"leavesAt": "21:58",
					"arrivesAt": "22:07",
					"waitsAtSource": 660,
					"distance": 7200
				},
				{
					"from": "Topleţ Hm.",
					"to": "Orşova",
					"leavesAt": "22:08",
					"arrivesAt": "22:18",
					"waitsAtSource": 60,
					"distance": 10300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2457",
			"segments": [
				{
					"from": "Băbeni",
					"to": "Tătărani h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:03",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Tătărani h.",
					"to": "Govora",
					"leavesAt": "07:04",
					"arrivesAt": "07:12",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Govora",
					"to": "Râureni hc.",
					"leavesAt": "07:20",
					"arrivesAt": "07:23",
					"waitsAtSource": 480,
					"distance": 2200
				},
				{
					"from": "Râureni hc.",
					"to": "Râureni",
					"leavesAt": "07:24",
					"arrivesAt": "07:32",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni",
					"to": "Răstoaca h.",
					"leavesAt": "07:33",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Răstoaca h.",
					"to": "Ostroveni h.",
					"leavesAt": "07:36",
					"arrivesAt": "07:40",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ostroveni h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "07:41",
					"arrivesAt": "07:43",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:50",
					"waitsAtSource": 300,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "07:51",
					"arrivesAt": "07:56",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Dăeşti Hm.",
					"leavesAt": "07:57",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Călimăneşti",
					"leavesAt": "08:04",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5403",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "11:35",
					"arrivesAt": "11:42",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "11:43",
					"arrivesAt": "11:47",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "11:48",
					"arrivesAt": "11:54",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "11:55",
					"arrivesAt": "11:58",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "11:59",
					"arrivesAt": "12:11",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Adjudu Vechi h.",
					"leavesAt": "12:12",
					"arrivesAt": "12:16",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Şişcani h.",
					"leavesAt": "12:17",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Şişcani h.",
					"to": "Sascut Hm.",
					"leavesAt": "12:22",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sascut Hm.",
					"to": "Orbeni Hm.",
					"leavesAt": "12:29",
					"arrivesAt": "12:36",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Orbeni Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "12:37",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Răcăciuni h.",
					"to": "Faraoani Hm.",
					"leavesAt": "12:44",
					"arrivesAt": "12:52",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Faraoani Hm.",
					"to": "Siretu Bacău h.",
					"leavesAt": "12:53",
					"arrivesAt": "12:58",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Valea Seacă",
					"leavesAt": "12:59",
					"arrivesAt": "13:04",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Valea Seacă",
					"to": "Letea h.",
					"leavesAt": "13:05",
					"arrivesAt": "13:11",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Letea h.",
					"to": "Bacău",
					"leavesAt": "13:12",
					"arrivesAt": "13:18",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2234",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Est",
					"leavesAt": "14:13",
					"arrivesAt": "14:19",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Timişoara Est",
					"to": "Viile Giarmata h.",
					"leavesAt": "14:20",
					"arrivesAt": "14:27",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Viile Giarmata h.",
					"to": "Giarmata Hm.",
					"leavesAt": "14:28",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Giarmata Hm.",
					"to": "Cerneteaz h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:37",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Cerneteaz h.",
					"to": "Pişchia h.",
					"leavesAt": "14:38",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Pişchia h.",
					"to": "Bencei h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Bencei h.",
					"to": "Fibiş h.",
					"leavesAt": "14:56",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Fibiş h.",
					"to": "Remetea Mică",
					"leavesAt": "15:02",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 4300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4703",
			"segments": [
				{
					"from": "Ilva Mică",
					"to": "Podereia Feldrului h.",
					"leavesAt": "09:30",
					"arrivesAt": "09:34",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Feldru Hm.",
					"leavesAt": "09:35",
					"arrivesAt": "09:40",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Feldru Hm.",
					"to": "Nepos h.",
					"leavesAt": "09:47",
					"arrivesAt": "09:52",
					"waitsAtSource": 420,
					"distance": 4700
				},
				{
					"from": "Nepos h.",
					"to": "Rebrişoara Hm.",
					"leavesAt": "09:53",
					"arrivesAt": "09:59",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Năsăud",
					"leavesAt": "10:00",
					"arrivesAt": "10:05",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Năsăud",
					"to": "Năsăud h.",
					"leavesAt": "10:07",
					"arrivesAt": "10:10",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Năsăud h.",
					"to": "Salva",
					"leavesAt": "10:11",
					"arrivesAt": "10:16",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Salva",
					"to": "Mititei h.",
					"leavesAt": "10:18",
					"arrivesAt": "10:21",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Mititei h.",
					"to": "Nimigea Hm.",
					"leavesAt": "10:22",
					"arrivesAt": "10:28",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Nimigea Hm.",
					"to": "Nimigea h.",
					"leavesAt": "10:29",
					"arrivesAt": "10:32",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Nimigea h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "10:33",
					"arrivesAt": "10:37",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Cociu h.",
					"leavesAt": "10:38",
					"arrivesAt": "10:40",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cociu h.",
					"to": "Beclean pe Someş",
					"leavesAt": "10:41",
					"arrivesAt": "10:50",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Beclean pe Someş",
					"to": "Coldău Hm.",
					"leavesAt": "10:52",
					"arrivesAt": "11:02",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Coldău Hm.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "11:03",
					"arrivesAt": "11:06",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "11:07",
					"arrivesAt": "11:09",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "11:10",
					"arrivesAt": "11:14",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Dej Triaj",
					"leavesAt": "11:15",
					"arrivesAt": "11:25",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "11:26",
					"arrivesAt": "11:33",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "11:47",
					"arrivesAt": "11:55",
					"waitsAtSource": 840,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Gherla",
					"leavesAt": "11:56",
					"arrivesAt": "12:07",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "12:08",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "12:15",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:24",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "12:25",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "12:31",
					"arrivesAt": "12:34",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "12:35",
					"arrivesAt": "12:40",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:47",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Apahida h.",
					"to": "Apahida",
					"leavesAt": "12:48",
					"arrivesAt": "12:53",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "12:54",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "12:58",
					"arrivesAt": "13:06",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "13:07",
					"arrivesAt": "13:12",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "13:13",
					"arrivesAt": "13:18",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180701",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171231",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3745",
			"segments": [
				{
					"from": "Arad",
					"to": "Utvinişu Nou",
					"leavesAt": "13:00",
					"arrivesAt": "13:10",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Utvinişu Nou",
					"to": "Utviniş h.",
					"leavesAt": "13:15",
					"arrivesAt": "13:19",
					"waitsAtSource": 300,
					"distance": 3100
				},
				{
					"from": "Utviniş h.",
					"to": "Zimandu Nou h.",
					"leavesAt": "13:20",
					"arrivesAt": "13:24",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "13:25",
					"arrivesAt": "13:37",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Comlăuş h.",
					"leavesAt": "13:38",
					"arrivesAt": "13:42",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Comlăuş h.",
					"to": "Şimand Hm.",
					"leavesAt": "13:43",
					"arrivesAt": "13:51",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Şimand Hm.",
					"to": "Nădab",
					"leavesAt": "13:52",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Nădab",
					"to": "Chişineu Criş",
					"leavesAt": "14:01",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 4900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5472",
			"segments": [
				{
					"from": "Bicaz",
					"to": "Tarcău Neamţ Hm.",
					"leavesAt": "07:06",
					"arrivesAt": "07:13",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Tarcău Neamţ Hm.",
					"to": "Stejaru h.",
					"leavesAt": "07:14",
					"arrivesAt": "07:20",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stejaru h.",
					"to": "Pângăraţi Hm.",
					"leavesAt": "07:21",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Pângăraţi Hm.",
					"to": "Vaduri h.",
					"leavesAt": "07:26",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Vaduri h.",
					"to": "Piatra Neamţ",
					"leavesAt": "07:32",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Piatra Neamţ",
					"to": "Dumbrava h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Săvineşti h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Săvineşti h.",
					"to": "Roznov",
					"leavesAt": "07:59",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Roznov",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "08:06",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Podoleni Hm.",
					"leavesAt": "08:11",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Podoleni Hm.",
					"to": "Costişa h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Costişa h.",
					"to": "Buhuşi",
					"leavesAt": "08:27",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhuşi",
					"to": "Racova h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Racova h.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Gârleni Hm.",
					"leavesAt": "08:48",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Gârleni Hm.",
					"to": "Hămeiuş P.M.",
					"leavesAt": "08:53",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Bacău",
					"leavesAt": "09:00",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 7900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8391",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "18:19",
					"arrivesAt": "18:28",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "18:29",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "18:35",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "18:43",
					"arrivesAt": "18:48",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "18:49",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "18:56",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "19:04",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "19:08",
					"arrivesAt": "19:16",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "19:17",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "19:22",
					"arrivesAt": "19:28",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4315",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Botiz Hm.",
					"leavesAt": "11:24",
					"arrivesAt": "11:30",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Botiz Hm.",
					"to": "Odoreu h.",
					"leavesAt": "11:31",
					"arrivesAt": "11:36",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Odoreu h.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "11:37",
					"arrivesAt": "11:47",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Apa Hm.",
					"leavesAt": "11:48",
					"arrivesAt": "11:56",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Apa Hm.",
					"to": "Seini",
					"leavesAt": "11:57",
					"arrivesAt": "12:09",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Seini",
					"to": "Săbişa h.",
					"leavesAt": "12:10",
					"arrivesAt": "12:15",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Săbişa h.",
					"to": "Ilba h.",
					"leavesAt": "12:16",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ilba h.",
					"to": "Cicârlău h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Cicârlău h.",
					"to": "Buşag Hm.",
					"leavesAt": "12:31",
					"arrivesAt": "12:39",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Buşag Hm.",
					"to": "Baia Mare",
					"leavesAt": "12:50",
					"arrivesAt": "13:10",
					"waitsAtSource": 660,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 831
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 831
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 831
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 831
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 831
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 831
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 831
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 831
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 831
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3630",
			"segments": [
				{
					"from": "Poieni",
					"to": "Bologa h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:52",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Bologa h.",
					"to": "Brăişoru Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "16:57",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Huedin",
					"leavesAt": "16:58",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Huedin",
					"to": "Jebuc h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Jebuc h.",
					"to": "Stana Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Stana Hm.",
					"to": "Aghireş h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "17:30",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Dorolţu h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Dorolţu h.",
					"to": "Macău h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Macău h.",
					"to": "Gârbău Hm.",
					"leavesAt": "17:41",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Gârbău Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "17:46",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Nădăşel h.",
					"to": "Mera Hm.",
					"leavesAt": "17:53",
					"arrivesAt": "17:56",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mera Hm.",
					"to": "Rădaia h.",
					"leavesAt": "17:57",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rădaia h.",
					"to": "Suceag h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Suceag h.",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "18:03",
					"arrivesAt": "18:07",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "18:08",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9340",
			"segments": [
				{
					"from": "Giurgiu",
					"to": "Giurgiu Nord",
					"leavesAt": "04:00",
					"arrivesAt": "04:05",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Giurgiu Nord",
					"to": "Cetatea h.",
					"leavesAt": "04:06",
					"arrivesAt": "04:09",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cetatea h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "04:10",
					"arrivesAt": "04:13",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Onceşti h.",
					"leavesAt": "04:14",
					"arrivesAt": "04:17",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Onceşti h.",
					"to": "Stăneşti Hm.",
					"leavesAt": "04:18",
					"arrivesAt": "04:23",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Chiriacu Hm.",
					"leavesAt": "04:24",
					"arrivesAt": "04:31",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Toporu",
					"leavesAt": "04:32",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Toporu",
					"to": "Răsuceni h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:45",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Răsuceni h.",
					"to": "Vlaşca Hm.",
					"leavesAt": "04:46",
					"arrivesAt": "04:53",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "04:54",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Târnavele Hm.",
					"to": "Răduleşti Hm.",
					"leavesAt": "05:03",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Videle",
					"leavesAt": "05:15",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Videle",
					"to": "Zăvestreni Hm.",
					"leavesAt": "05:35",
					"arrivesAt": "05:40",
					"waitsAtSource": 540,
					"distance": 4800
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "05:46",
					"arrivesAt": "05:54",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Zorile h.",
					"leavesAt": "05:55",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zorile h.",
					"to": "Grădinari",
					"leavesAt": "06:00",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Grădinari",
					"to": "Domneştii de Sus h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:24",
					"waitsAtSource": 540,
					"distance": 6000
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Chiajna",
					"leavesAt": "06:25",
					"arrivesAt": "06:40",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Chiajna",
					"to": "Bucureştii Noi",
					"leavesAt": "06:44",
					"arrivesAt": "06:48",
					"waitsAtSource": 240,
					"distance": 3200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Carpaţi h.(900)",
					"leavesAt": "06:49",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "06:54",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Nord",
					"leavesAt": "06:58",
					"arrivesAt": "07:02",
					"waitsAtSource": 30,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8581",
			"segments": [
				{
					"from": "Slobozia Veche",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "05:40",
					"arrivesAt": "05:50",
					"waitsAtSource": 0,
					"distance": 4200
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Brâncoveni h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Brâncoveni h.",
					"to": "Ciulniţa",
					"leavesAt": "06:00",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1559",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "20:09",
					"arrivesAt": "20:57",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "21:00",
					"arrivesAt": "21:33",
					"waitsAtSource": 180,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "21:34",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 35000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1757",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "23:20",
					"arrivesAt": "00:08",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "00:11",
					"arrivesAt": "00:44",
					"waitsAtSource": 180,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "00:46",
					"arrivesAt": "01:21",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "01:23",
					"arrivesAt": "01:54",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "01:56",
					"arrivesAt": "02:34",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "02:36",
					"arrivesAt": "02:58",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "03:00",
					"arrivesAt": "03:26",
					"waitsAtSource": 120,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "03:28",
					"arrivesAt": "04:05",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "04:14",
					"arrivesAt": "04:43",
					"waitsAtSource": 540,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Paşcani",
					"leavesAt": "04:44",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 40200
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "05:15",
					"arrivesAt": "05:35",
					"waitsAtSource": 120,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "05:36",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "06:02",
					"arrivesAt": "06:14",
					"waitsAtSource": 600,
					"distance": 14800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9360",
			"segments": [
				{
					"from": "Alexandria",
					"to": "Alexandria Nord h.",
					"leavesAt": "03:00",
					"arrivesAt": "03:03",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Buzescu h.",
					"leavesAt": "03:04",
					"arrivesAt": "03:15",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Buzescu h.",
					"to": "Plosca Hm.",
					"leavesAt": "03:16",
					"arrivesAt": "03:28",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Plosca Hm.",
					"to": "Peret hc.",
					"leavesAt": "03:29",
					"arrivesAt": "03:36",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Peret hc.",
					"to": "Roşiori Hm.",
					"leavesAt": "03:37",
					"arrivesAt": "03:51",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "03:52",
					"arrivesAt": "03:59",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171225",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20180101",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1636",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "05:25",
					"arrivesAt": "05:49",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "05:50",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "06:08",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "06:29",
					"arrivesAt": "06:52",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Lehliu",
					"leavesAt": "06:53",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 39300
				},
				{
					"from": "Lehliu",
					"to": "Bucureşti Nord",
					"leavesAt": "07:13",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 69600
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "08:10",
					"arrivesAt": "08:48",
					"waitsAtSource": 1140,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "08:50",
					"arrivesAt": "09:13",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "09:14",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "09:39",
					"arrivesAt": "09:47",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "09:48",
					"arrivesAt": "09:53",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "09:54",
					"arrivesAt": "10:03",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "10:05",
					"arrivesAt": "10:43",
					"waitsAtSource": 120,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1737",
			"segments": [
				{
					"from": "Râmnicu Vâlcea",
					"to": "Călimăneşti",
					"leavesAt": "04:10",
					"arrivesAt": "04:25",
					"waitsAtSource": 0,
					"distance": 16200
				},
				{
					"from": "Călimăneşti",
					"to": "Turnu Roşu hc.",
					"leavesAt": "04:26",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 58300
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "05:41",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Sibiu",
					"leavesAt": "05:53",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 17800
				},
				{
					"from": "Sibiu",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "06:17",
					"arrivesAt": "06:28",
					"waitsAtSource": 300,
					"distance": 10400
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "06:29",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Loamneş Hm.",
					"leavesAt": "06:33",
					"arrivesAt": "06:41",
					"waitsAtSource": 30,
					"distance": 8200
				},
				{
					"from": "Loamneş Hm.",
					"to": "Şeica Mare",
					"leavesAt": "06:42",
					"arrivesAt": "06:55",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Şeica Mare",
					"to": "Copşa Mică",
					"leavesAt": "06:56",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Copşa Mică",
					"to": "Blaj",
					"leavesAt": "07:15",
					"arrivesAt": "07:52",
					"waitsAtSource": 360,
					"distance": 30000
				},
				{
					"from": "Blaj",
					"to": "Teiuş",
					"leavesAt": "07:54",
					"arrivesAt": "08:22",
					"waitsAtSource": 120,
					"distance": 21300
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "08:26",
					"arrivesAt": "08:38",
					"waitsAtSource": 240,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Unirea hc.",
					"leavesAt": "08:39",
					"arrivesAt": "08:54",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Câmpia Turzii",
					"leavesAt": "09:08",
					"arrivesAt": "09:23",
					"waitsAtSource": 360,
					"distance": 17100
				},
				{
					"from": "Câmpia Turzii",
					"to": "Apahida",
					"leavesAt": "09:24",
					"arrivesAt": "10:12",
					"waitsAtSource": 60,
					"distance": 39200
				},
				{
					"from": "Apahida",
					"to": "Cluj Napoca",
					"leavesAt": "10:13",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 12300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8211",
			"segments": [
				{
					"from": "Făurei",
					"to": "Cireşu Hm.",
					"leavesAt": "18:55",
					"arrivesAt": "19:08",
					"waitsAtSource": 0,
					"distance": 15700
				},
				{
					"from": "Cireşu Hm.",
					"to": "Scărlăteşti hc.",
					"leavesAt": "19:09",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Scărlăteşti hc.",
					"to": "Dudeşti Hm.",
					"leavesAt": "19:14",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Dudeşti Hm.",
					"to": "Spicu",
					"leavesAt": "19:20",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Spicu",
					"to": "Murgeanca Hm.",
					"leavesAt": "19:28",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Murgeanca Hm.",
					"to": "Ţăndărei",
					"leavesAt": "19:36",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Ţăndărei",
					"to": "Platoneşti h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:54",
					"waitsAtSource": 120,
					"distance": 6000
				},
				{
					"from": "Platoneşti h.",
					"to": "Movila Hm.",
					"leavesAt": "19:55",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Movila Hm.",
					"to": "Feteşti",
					"leavesAt": "20:05",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 16700
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "20:25",
					"arrivesAt": "20:45",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "20:46",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Basarabi",
					"leavesAt": "21:05",
					"arrivesAt": "21:17",
					"waitsAtSource": 120,
					"distance": 17200
				},
				{
					"from": "Basarabi",
					"to": "Constanţa",
					"leavesAt": "21:18",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 17400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5113",
			"segments": [
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:54",
					"waitsAtSource": 0,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "17:55",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "18:06",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "18:30",
					"arrivesAt": "18:37",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "18:38",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "18:47",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "18:56",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "19:08",
					"arrivesAt": "19:22",
					"waitsAtSource": 120,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "19:23",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 8000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1721",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(901)",
					"leavesAt": "14:55",
					"arrivesAt": "14:57",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Cârcea h.",
					"leavesAt": "14:58",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Cârcea h.",
					"to": "Toporaş h.",
					"leavesAt": "15:06",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 9100
				},
				{
					"from": "Toporaş h.",
					"to": "Spineni h.",
					"leavesAt": "15:16",
					"arrivesAt": "15:27",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Spineni h.",
					"to": "Balş",
					"leavesAt": "15:28",
					"arrivesAt": "15:34",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Balş",
					"to": "Canton 217 h.",
					"leavesAt": "15:35",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Canton 217 h.",
					"to": "Brăneţ h.",
					"leavesAt": "15:38",
					"arrivesAt": "15:42",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Brăneţ h.",
					"to": "Piatra Olt",
					"leavesAt": "15:43",
					"arrivesAt": "15:52",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Piatra Olt",
					"to": "Drăgăşani",
					"leavesAt": "16:00",
					"arrivesAt": "16:26",
					"waitsAtSource": 480,
					"distance": 33800
				},
				{
					"from": "Drăgăşani",
					"to": "Băbeni",
					"leavesAt": "16:27",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 33200
				},
				{
					"from": "Băbeni",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "16:53",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 19600
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Călimăneşti",
					"leavesAt": "17:14",
					"arrivesAt": "17:29",
					"waitsAtSource": 120,
					"distance": 16200
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "17:30",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Lotru",
					"leavesAt": "17:35",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Lotru",
					"to": "Turnu Roşu hc.",
					"leavesAt": "18:05",
					"arrivesAt": "18:57",
					"waitsAtSource": 780,
					"distance": 42700
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "18:58",
					"arrivesAt": "19:07",
					"waitsAtSource": 30,
					"distance": 7300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Sibiu",
					"leavesAt": "19:08",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 17800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9487",
			"segments": [
				{
					"from": "Slatina",
					"to": "Milcov Hm.",
					"leavesAt": "20:00",
					"arrivesAt": "20:06",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Milcov Hm.",
					"to": "Slătioara Hm.",
					"leavesAt": "20:07",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "20:20",
					"arrivesAt": "20:26",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7032",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "04:18",
					"arrivesAt": "04:22",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "04:23",
					"arrivesAt": "04:28",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "04:29",
					"arrivesAt": "04:34",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Moldoveni h.",
					"to": "Dridu Hm.",
					"leavesAt": "04:35",
					"arrivesAt": "04:41",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Dridu Hm.",
					"to": "Fierbinţi",
					"leavesAt": "04:42",
					"arrivesAt": "04:49",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Fierbinţi",
					"to": "Greci h.",
					"leavesAt": "04:50",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Greci h.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "04:57",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "05:04",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Baloteşti Hm.",
					"leavesAt": "05:10",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Baloteşti Hm.",
					"to": "P.O. Aeroport h.",
					"leavesAt": "05:16",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Mogoşoaia",
					"leavesAt": "05:20",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Mogoşoaia",
					"to": "Chitila",
					"leavesAt": "05:32",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Chitila",
					"to": "Pajura Hm. (700)",
					"leavesAt": "05:50",
					"arrivesAt": "05:56",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Carpaţi h.(700)",
					"leavesAt": "05:57",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Bucureşti Nord",
					"leavesAt": "06:01",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2386",
			"segments": [
				{
					"from": "Săvârşin",
					"to": "Toc h.",
					"leavesAt": "12:09",
					"arrivesAt": "12:16",
					"waitsAtSource": 0,
					"distance": 7400
				},
				{
					"from": "Toc h.",
					"to": "Ilteu",
					"leavesAt": "12:17",
					"arrivesAt": "12:22",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ilteu",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "12:23",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Zam",
					"leavesAt": "12:28",
					"arrivesAt": "12:34",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Zam",
					"to": "Burjuc h.",
					"leavesAt": "12:35",
					"arrivesAt": "12:44",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Burjuc h.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "12:45",
					"arrivesAt": "12:52",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Gurasada Hm.",
					"leavesAt": "12:53",
					"arrivesAt": "12:59",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Gurasada Hm.",
					"to": "Ilia",
					"leavesAt": "13:00",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "13:07",
					"arrivesAt": "13:11",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "13:12",
					"arrivesAt": "13:18",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "13:19",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia h.",
					"leavesAt": "13:23",
					"arrivesAt": "13:25",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Mintia",
					"leavesAt": "13:26",
					"arrivesAt": "13:30",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "13:31",
					"arrivesAt": "13:40",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "13:41",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2216",
			"segments": [
				{
					"from": "Curtici",
					"to": "Şofronea",
					"leavesAt": "21:30",
					"arrivesAt": "21:38",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Şofronea",
					"to": "Arad",
					"leavesAt": "21:39",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5721",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Vest",
					"leavesAt": "08:36",
					"arrivesAt": "08:44",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Suceava Vest",
					"to": "Stroieşti",
					"leavesAt": "08:45",
					"arrivesAt": "08:54",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Stroieşti",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "09:03",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "09:11",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Gura Humorului Hm.",
					"leavesAt": "09:19",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Gura Humorului Oraş",
					"leavesAt": "09:30",
					"arrivesAt": "09:36",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "09:38",
					"arrivesAt": "09:47",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Molid Hm.",
					"leavesAt": "09:48",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Molid Hm.",
					"to": "Vama",
					"leavesAt": "09:56",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vama",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "10:02",
					"arrivesAt": "10:09",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "10:10",
					"arrivesAt": "10:20",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "10:21",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1885",
			"segments": [
				{
					"from": "Titu",
					"to": "Nucet",
					"leavesAt": "14:40",
					"arrivesAt": "14:51",
					"waitsAtSource": 0,
					"distance": 15400
				},
				{
					"from": "Nucet",
					"to": "Târgovişte",
					"leavesAt": "14:52",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 16300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9441",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "03:55",
					"arrivesAt": "03:57",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "03:58",
					"arrivesAt": "04:00",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Săteni h.",
					"leavesAt": "04:01",
					"arrivesAt": "04:05",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Săteni h.",
					"to": "Doiceşti",
					"leavesAt": "04:06",
					"arrivesAt": "04:09",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Doiceşti",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "04:10",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Trainica h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:20",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Trainica h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "04:21",
					"arrivesAt": "04:25",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Moţăieni h.",
					"leavesAt": "04:26",
					"arrivesAt": "04:29",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Moţăieni h.",
					"to": "Fieni",
					"leavesAt": "04:30",
					"arrivesAt": "04:35",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:39",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Pietroşiţa Hm.",
					"leavesAt": "04:40",
					"arrivesAt": "04:48",
					"waitsAtSource": 30,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5562",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "07:47",
					"arrivesAt": "07:52",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "07:53",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "08:03",
					"arrivesAt": "08:11",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Bursuceni h.",
					"leavesAt": "08:13",
					"arrivesAt": "08:23",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Bursuceni h.",
					"to": "Bucecea Hm",
					"leavesAt": "08:24",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Bucecea Hm",
					"to": "Leorda Hm.",
					"leavesAt": "08:42",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Leorda Hm.",
					"to": "Botoşani",
					"leavesAt": "09:13",
					"arrivesAt": "09:37",
					"waitsAtSource": 720,
					"distance": 15500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3645",
			"segments": [
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bulz Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:44",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Bulz Hm.",
					"to": "Stâna de Vale h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bratca",
					"leavesAt": "16:48",
					"arrivesAt": "16:53",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bratca",
					"to": "Bălnaca h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Bălnaca h.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "16:58",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Peştera h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Peştera h.",
					"to": "Vadu Crişului h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului h.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "17:12",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Butan h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Butan h.",
					"to": "Aleşd h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:27",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Aleşd h.",
					"to": "Aleşd",
					"leavesAt": "17:28",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aleşd",
					"to": "Ţeţchea hc.",
					"leavesAt": "17:35",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Ţeţchea hc.",
					"to": "Telechiu Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:44",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Telechiu Hm.",
					"to": "Tileagd",
					"leavesAt": "17:45",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Tileagd",
					"to": "Săbolciu h.",
					"leavesAt": "17:54",
					"arrivesAt": "17:59",
					"waitsAtSource": 240,
					"distance": 5400
				},
				{
					"from": "Săbolciu h.",
					"to": "Săcădat h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:03",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săcădat h.",
					"to": "Oşorhei Hm.",
					"leavesAt": "18:04",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Oradea Est",
					"leavesAt": "18:10",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Oradea Est",
					"to": "Oradea",
					"leavesAt": "18:18",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 831
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 831
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 831
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 831
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 831
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 831
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 831
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 831
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 831
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1824",
			"segments": [
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "07:10",
					"arrivesAt": "07:24",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Simeria Triaj",
					"leavesAt": "07:28",
					"arrivesAt": "07:34",
					"waitsAtSource": 240,
					"distance": 3200
				},
				{
					"from": "Simeria Triaj",
					"to": "Călan Băi",
					"leavesAt": "07:35",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Călan Băi",
					"to": "Călan Hm.",
					"leavesAt": "07:45",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Hm.",
					"to": "Subcetate",
					"leavesAt": "07:51",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Subcetate",
					"to": "Pui",
					"leavesAt": "08:07",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 14300
				},
				{
					"from": "Pui",
					"to": "Crivadia Hm.",
					"leavesAt": "08:24",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 13400
				},
				{
					"from": "Crivadia Hm.",
					"to": "Băniţa",
					"leavesAt": "08:47",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Băniţa",
					"to": "Petroşani",
					"leavesAt": "09:10",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Petroşani",
					"to": "Valea Sadului Hm.",
					"leavesAt": "09:30",
					"arrivesAt": "10:15",
					"waitsAtSource": 300,
					"distance": 31700
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "10:16",
					"arrivesAt": "10:38",
					"waitsAtSource": 60,
					"distance": 19600
				},
				{
					"from": "Târgu Jiu",
					"to": "Cărbuneşti",
					"leavesAt": "10:40",
					"arrivesAt": "11:08",
					"waitsAtSource": 120,
					"distance": 23800
				},
				{
					"from": "Cărbuneşti",
					"to": "Filiaşi",
					"leavesAt": "11:09",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 46500
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "11:55",
					"arrivesAt": "12:20",
					"waitsAtSource": 120,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "12:30",
					"arrivesAt": "13:10",
					"waitsAtSource": 600,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "13:12",
					"arrivesAt": "13:27",
					"waitsAtSource": 120,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Roşiori Nord",
					"leavesAt": "13:28",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "14:02",
					"arrivesAt": "14:48",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "14:50",
					"arrivesAt": "15:43",
					"waitsAtSource": 120,
					"distance": 50900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2204",
			"segments": [
				{
					"from": "Curtici",
					"to": "Şofronea",
					"leavesAt": "06:50",
					"arrivesAt": "06:57",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Şofronea",
					"to": "Arad",
					"leavesAt": "06:58",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5104",
			"segments": [
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:57",
					"waitsAtSource": 0,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "07:58",
					"arrivesAt": "08:02",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "08:10",
					"arrivesAt": "08:14",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "08:15",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5444",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "06:06",
					"arrivesAt": "06:11",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "06:13",
					"arrivesAt": "06:20",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "06:21",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "06:29",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "06:36",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "06:49",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "07:05",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "07:11",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "07:17",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Paşcani Triaj",
					"leavesAt": "07:25",
					"arrivesAt": "07:29",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Paşcani Triaj",
					"to": "Stolniceni h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "07:36",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "07:42",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "07:47",
					"arrivesAt": "07:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "07:53",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "07:58",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "08:05",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "08:16",
					"arrivesAt": "08:23",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "08:24",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "08:29",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "08:44",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "08:50",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1664",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Bârnova Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "17:02",
					"waitsAtSource": 0,
					"distance": 18500
				},
				{
					"from": "Bârnova Hm.",
					"to": "Vaslui",
					"leavesAt": "17:03",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Vaslui",
					"to": "Bârlad",
					"leavesAt": "17:43",
					"arrivesAt": "18:27",
					"waitsAtSource": 60,
					"distance": 52100
				},
				{
					"from": "Bârlad",
					"to": "Tecuci",
					"leavesAt": "18:28",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 50300
				},
				{
					"from": "Tecuci",
					"to": "Focşani",
					"leavesAt": "19:24",
					"arrivesAt": "20:06",
					"waitsAtSource": 720,
					"distance": 36500
				},
				{
					"from": "Focşani",
					"to": "Buzău",
					"leavesAt": "20:07",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 70800
				},
				{
					"from": "Buzău",
					"to": "Ploieşti Sud",
					"leavesAt": "21:16",
					"arrivesAt": "22:25",
					"waitsAtSource": 120,
					"distance": 68600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "22:27",
					"arrivesAt": "23:15",
					"waitsAtSource": 120,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3549",
			"segments": [
				{
					"from": "Odorhei",
					"to": "Odorhei Sud hc.",
					"leavesAt": "22:20",
					"arrivesAt": "22:24",
					"waitsAtSource": 0,
					"distance": 1200
				},
				{
					"from": "Odorhei Sud hc.",
					"to": "Feliceni h.",
					"leavesAt": "22:25",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Feliceni h.",
					"to": "Dobeni h.",
					"leavesAt": "22:33",
					"arrivesAt": "22:38",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Dobeni h.",
					"to": "Lutiţa h.",
					"leavesAt": "22:39",
					"arrivesAt": "22:43",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Lutiţa h.",
					"to": "Porumbenii Mari h.",
					"leavesAt": "22:44",
					"arrivesAt": "22:50",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Porumbenii Mari h.",
					"to": "Porumbenii Mici h.",
					"leavesAt": "22:51",
					"arrivesAt": "22:55",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Porumbenii Mici h.",
					"to": "Beteşti Est h.",
					"leavesAt": "22:56",
					"arrivesAt": "23:01",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Beteşti Est h.",
					"to": "Beteşti h.",
					"leavesAt": "23:02",
					"arrivesAt": "23:05",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Beteşti h.",
					"to": "Cristur Hm.",
					"leavesAt": "23:06",
					"arrivesAt": "23:09",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Cristur Hm.",
					"to": "Sântămaria h.",
					"leavesAt": "23:16",
					"arrivesAt": "23:20",
					"waitsAtSource": 420,
					"distance": 3000
				},
				{
					"from": "Sântămaria h.",
					"to": "Săcuienii Noi h.",
					"leavesAt": "23:21",
					"arrivesAt": "23:26",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Săcuienii Noi h.",
					"to": "Vânători",
					"leavesAt": "23:27",
					"arrivesAt": "23:34",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Vânători",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "23:35",
					"arrivesAt": "23:42",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Sighişoara",
					"leavesAt": "23:43",
					"arrivesAt": "23:52",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9387",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Măldăeni Hm.",
					"leavesAt": "16:35",
					"arrivesAt": "16:42",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Măldăeni Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Radomireşti Hm.",
					"leavesAt": "16:52",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Dăneasa h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Dăneasa h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "17:10",
					"arrivesAt": "17:14",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Stoeneşti h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Stoeneşti h.",
					"to": "Fărcaşele Hm.",
					"leavesAt": "17:22",
					"arrivesAt": "17:27",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Caracal",
					"leavesAt": "17:28",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Caracal",
					"to": "Cezieni h.",
					"leavesAt": "17:40",
					"arrivesAt": "17:45",
					"waitsAtSource": 120,
					"distance": 6100
				},
				{
					"from": "Cezieni h.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "17:52",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Radomiru hc.",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Radomiru hc.",
					"to": "Jianca",
					"leavesAt": "17:59",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jianca",
					"to": "Ţărţăl h.",
					"leavesAt": "18:03",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţărţăl h.",
					"to": "Leu Hm.",
					"leavesAt": "18:07",
					"arrivesAt": "18:12",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Leu Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "18:13",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Malu Mare Hm.",
					"leavesAt": "18:22",
					"arrivesAt": "18:25",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Malu Mare Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "18:26",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "18:29",
					"arrivesAt": "18:33",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Bordei hc.(900)",
					"leavesAt": "18:34",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Craiova",
					"leavesAt": "18:39",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9435",
			"segments": [
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "11:00",
					"arrivesAt": "11:03",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Podu Rizii h.",
					"leavesAt": "11:04",
					"arrivesAt": "11:07",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Podu Rizii h.",
					"to": "Băneşti h.",
					"leavesAt": "11:08",
					"arrivesAt": "11:12",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "11:13",
					"arrivesAt": "11:16",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "11:17",
					"arrivesAt": "11:20",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "11:21",
					"arrivesAt": "11:24",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "11:25",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "11:30",
					"arrivesAt": "11:37",
					"waitsAtSource": 60,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2560",
			"segments": [
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "04:21",
					"arrivesAt": "04:28",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "04:29",
					"arrivesAt": "04:36",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Axente Sever h.",
					"leavesAt": "04:37",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Axente Sever h.",
					"to": "Agârbiciu h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:49",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Agârbiciu h.",
					"to": "Şeica Mare",
					"leavesAt": "04:50",
					"arrivesAt": "04:56",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şeica Mare",
					"to": "Şeica Mare h.",
					"leavesAt": "04:57",
					"arrivesAt": "04:59",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Şeica Mare h.",
					"to": "Hăşag h.",
					"leavesAt": "05:00",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Hăşag h.",
					"to": "Loamneş Hm.",
					"leavesAt": "05:11",
					"arrivesAt": "05:16",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Loamneş Hm.",
					"to": "Mândra h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mândra h.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "05:30",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Sibiu h.(203)",
					"leavesAt": "05:38",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Sibiu",
					"leavesAt": "05:48",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9385",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Măldăeni Hm.",
					"leavesAt": "07:20",
					"arrivesAt": "07:27",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Măldăeni Hm.",
					"to": "Mihăeşti Hm.",
					"leavesAt": "07:28",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Radomireşti Hm.",
					"leavesAt": "07:37",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Dăneasa h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Dăneasa h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "07:55",
					"arrivesAt": "07:59",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Stoeneşti h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Stoeneşti h.",
					"to": "Fărcaşele Hm.",
					"leavesAt": "08:07",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Caracal",
					"leavesAt": "08:13",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Caracal",
					"to": "Cezieni h.",
					"leavesAt": "08:25",
					"arrivesAt": "08:30",
					"waitsAtSource": 120,
					"distance": 6100
				},
				{
					"from": "Cezieni h.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "08:31",
					"arrivesAt": "08:37",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Radomiru hc.",
					"leavesAt": "08:38",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Radomiru hc.",
					"to": "Jianca",
					"leavesAt": "08:45",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Jianca",
					"to": "Ţărţăl h.",
					"leavesAt": "08:49",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţărţăl h.",
					"to": "Leu Hm.",
					"leavesAt": "08:53",
					"arrivesAt": "08:58",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Leu Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "08:59",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "09:08",
					"arrivesAt": "09:12",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "09:13",
					"arrivesAt": "09:17",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Bordei hc.(900)",
					"leavesAt": "09:18",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Craiova",
					"leavesAt": "09:23",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2105",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "17:22",
					"arrivesAt": "17:28",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Ghimbav Hm.",
					"leavesAt": "17:29",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Codlea Hm.",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "17:49",
					"arrivesAt": "17:59",
					"waitsAtSource": 300,
					"distance": 8400
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "18:00",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Valea Homorod h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Valea Homorod h.",
					"to": "Brădet Hm.",
					"leavesAt": "18:13",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Brădet Hm.",
					"to": "Perşani h.",
					"leavesAt": "18:23",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Şercaia Hm.",
					"leavesAt": "18:32",
					"arrivesAt": "18:41",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Şercaia Hm.",
					"to": "Şercaia h.",
					"leavesAt": "18:42",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 1200
				},
				{
					"from": "Şercaia h.",
					"to": "Mândra Oltului h.",
					"leavesAt": "18:45",
					"arrivesAt": "18:52",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Făgăraş",
					"leavesAt": "18:53",
					"arrivesAt": "18:59",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Făgăraş",
					"to": "Beclean pe Olt h.",
					"leavesAt": "19:08",
					"arrivesAt": "19:13",
					"waitsAtSource": 540,
					"distance": 5200
				},
				{
					"from": "Beclean pe Olt h.",
					"to": "Dridif h.",
					"leavesAt": "19:14",
					"arrivesAt": "19:18",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Dridif h.",
					"to": "Voila Hm.",
					"leavesAt": "19:19",
					"arrivesAt": "19:23",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Voila Hm.",
					"to": "Olteţ h.",
					"leavesAt": "19:24",
					"arrivesAt": "19:30",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Olteţ h.",
					"to": "Viştea h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:35",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Viştea h.",
					"to": "Ucea",
					"leavesAt": "19:36",
					"arrivesAt": "19:40",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ucea",
					"to": "Arpaş Hm.",
					"leavesAt": "19:41",
					"arrivesAt": "19:49",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Arpaş Hm.",
					"to": "Cârţa h.",
					"leavesAt": "19:50",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cârţa h.",
					"to": "Scoreiu h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:58",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Scoreiu h.",
					"to": "Sărata Colun h.",
					"leavesAt": "19:59",
					"arrivesAt": "20:02",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Sărata Colun h.",
					"to": "Porumbacu Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:08",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "20:09",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Avrig Hm.",
					"to": "Mârşa h.",
					"leavesAt": "20:24",
					"arrivesAt": "20:29",
					"waitsAtSource": 360,
					"distance": 3700
				},
				{
					"from": "Mârşa h.",
					"to": "Racoviţa h.",
					"leavesAt": "20:30",
					"arrivesAt": "20:33",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Racoviţa h.",
					"to": "Sebeş Olt h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:37",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Podu Olt",
					"leavesAt": "20:38",
					"arrivesAt": "20:43",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "20:44",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "20:52",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "21:02",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "21:06",
					"arrivesAt": "21:10",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "21:11",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Atelier Zona h.",
					"leavesAt": "21:16",
					"arrivesAt": "21:19",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu",
					"leavesAt": "21:20",
					"arrivesAt": "21:24",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9416",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Şopârliţa hc.",
					"leavesAt": "08:15",
					"arrivesAt": "08:26",
					"waitsAtSource": 0,
					"distance": 11100
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Vlăduleni",
					"leavesAt": "08:27",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vlăduleni",
					"to": "Fălcoiu h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Fălcoiu h.",
					"to": "Romula Hm.",
					"leavesAt": "08:39",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Romula Hm.",
					"to": "Caracal",
					"leavesAt": "08:52",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 448
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8386",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "11:43",
					"arrivesAt": "11:49",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "11:50",
					"arrivesAt": "11:54",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "11:55",
					"arrivesAt": "12:04",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "12:05",
					"arrivesAt": "12:08",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "12:09",
					"arrivesAt": "12:15",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "12:16",
					"arrivesAt": "12:22",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "12:23",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "12:29",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "12:38",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180427",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4144",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Sărăţel Hm.",
					"leavesAt": "15:42",
					"arrivesAt": "15:56",
					"waitsAtSource": 0,
					"distance": 10700
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Domneşti pe Şieu h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:16",
					"waitsAtSource": 720,
					"distance": 6600
				},
				{
					"from": "Domneşti pe Şieu h.",
					"to": "Mărişelu Hm.",
					"leavesAt": "16:17",
					"arrivesAt": "16:21",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Mărişelu Hm.",
					"to": "Bârla pe Şieu h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bârla pe Şieu h.",
					"to": "Şieu Hm.",
					"leavesAt": "16:27",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Şieu Hm.",
					"to": "Şieuţ h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Şieuţ h.",
					"to": "Monor Gledin",
					"leavesAt": "16:40",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Monor Gledin",
					"to": "Râpa de Jos Hm.",
					"leavesAt": "16:49",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Râpa de Jos Hm.",
					"to": "Morăreni h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Morăreni h.",
					"to": "Deda",
					"leavesAt": "17:06",
					"arrivesAt": "17:14",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Deda",
					"to": "Ruşii Munţi h.",
					"leavesAt": "17:29",
					"arrivesAt": "17:35",
					"waitsAtSource": 900,
					"distance": 4500
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "17:36",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Halta Aluniş h.",
					"leavesAt": "17:40",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "17:46",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Ideciu de Jos h.",
					"leavesAt": "17:51",
					"arrivesAt": "17:57",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Reghin",
					"leavesAt": "17:58",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Reghin",
					"to": "Petelea h.",
					"leavesAt": "18:09",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Petelea h.",
					"to": "Periş Mureş h.",
					"leavesAt": "18:18",
					"arrivesAt": "18:24",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Periş Mureş h.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:31",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "18:32",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "18:39",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Târgu Mureş",
					"leavesAt": "18:53",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4047",
			"segments": [
				{
					"from": "Jibou",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "11:55",
					"arrivesAt": "12:05",
					"waitsAtSource": 0,
					"distance": 9300
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Inău h.",
					"leavesAt": "12:06",
					"arrivesAt": "12:09",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Inău h.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "12:10",
					"arrivesAt": "12:13",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Benesat Hm.",
					"leavesAt": "12:14",
					"arrivesAt": "12:17",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Benesat Hm.",
					"to": "Ţicău h.",
					"leavesAt": "12:18",
					"arrivesAt": "12:24",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ţicău h.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "12:25",
					"arrivesAt": "12:28",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "12:29",
					"arrivesAt": "12:35",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Fersig h.",
					"leavesAt": "12:36",
					"arrivesAt": "12:42",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Fersig h.",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "12:43",
					"arrivesAt": "12:48",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Baia Mare",
					"leavesAt": "12:49",
					"arrivesAt": "13:05",
					"waitsAtSource": 60,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4538",
			"segments": [
				{
					"from": "Războieni",
					"to": "Lunca Mureşului h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:41",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Gura Arieşului h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:53",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Cheţani h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:04",
					"waitsAtSource": 420,
					"distance": 3100
				},
				{
					"from": "Cheţani h.",
					"to": "Luduş",
					"leavesAt": "17:05",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Luduş",
					"to": "Bogata Mureş h.",
					"leavesAt": "17:20",
					"arrivesAt": "17:25",
					"waitsAtSource": 420,
					"distance": 2700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Cuci h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cuci h.",
					"to": "Iernut",
					"leavesAt": "17:33",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Iernut",
					"to": "Cipău h.",
					"leavesAt": "17:40",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Cipău h.",
					"to": "Ogra h.",
					"leavesAt": "17:45",
					"arrivesAt": "17:48",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ogra h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "17:49",
					"arrivesAt": "17:53",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Chirileu h.",
					"leavesAt": "17:54",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chirileu h.",
					"to": "Vidrasău h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:03",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vidrasău h.",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "18:04",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "18:10",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "Azomureş h.",
					"leavesAt": "18:15",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş",
					"leavesAt": "18:19",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8394",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "20:08",
					"arrivesAt": "20:14",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "20:15",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "20:20",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "20:30",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "20:41",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "20:48",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "20:54",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "21:03",
					"arrivesAt": "21:16",
					"waitsAtSource": 60,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180523",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1646",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Reghin",
					"leavesAt": "13:36",
					"arrivesAt": "14:13",
					"waitsAtSource": 0,
					"distance": 32300
				},
				{
					"from": "Reghin",
					"to": "Deda",
					"leavesAt": "14:14",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 22000
				},
				{
					"from": "Deda",
					"to": "Topliţa",
					"leavesAt": "14:46",
					"arrivesAt": "15:44",
					"waitsAtSource": 720,
					"distance": 43900
				},
				{
					"from": "Topliţa",
					"to": "Gheorgheni",
					"leavesAt": "15:45",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 34000
				},
				{
					"from": "Gheorgheni",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "16:18",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Izvoru Oltului",
					"leavesAt": "16:41",
					"arrivesAt": "16:53",
					"waitsAtSource": 420,
					"distance": 10900
				},
				{
					"from": "Izvoru Oltului",
					"to": "Siculeni",
					"leavesAt": "16:54",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "17:17",
					"arrivesAt": "17:25",
					"waitsAtSource": 240,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "17:27",
					"arrivesAt": "17:50",
					"waitsAtSource": 120,
					"distance": 28500
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "17:59",
					"arrivesAt": "18:25",
					"waitsAtSource": 30,
					"distance": 28300
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Braşov",
					"leavesAt": "18:27",
					"arrivesAt": "18:57",
					"waitsAtSource": 120,
					"distance": 32100
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "19:09",
					"arrivesAt": "19:44",
					"waitsAtSource": 720,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "19:46",
					"arrivesAt": "19:55",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "19:56",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "20:02",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "20:12",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "20:37",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "21:00",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1773",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "P.O. Aeroport h.",
					"leavesAt": "12:50",
					"arrivesAt": "13:21",
					"waitsAtSource": 0,
					"distance": 27400
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Urziceni",
					"leavesAt": "13:22",
					"arrivesAt": "14:05",
					"waitsAtSource": 30,
					"distance": 50500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1772",
			"segments": [
				{
					"from": "Urziceni",
					"to": "P.O. Aeroport h.",
					"leavesAt": "08:35",
					"arrivesAt": "09:18",
					"waitsAtSource": 0,
					"distance": 50500
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Mogoşoaia",
					"leavesAt": "09:19",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Mogoşoaia",
					"to": "Bucureşti Nord",
					"leavesAt": "09:31",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 20400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8596",
			"segments": [
				{
					"from": "Călăraşi Sud",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "16:45",
					"arrivesAt": "16:52",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Ştefan Vodă h.",
					"leavesAt": "16:53",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Ciulniţa",
					"leavesAt": "17:01",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 12600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5402",
			"segments": [
				{
					"from": "Bacău",
					"to": "Letea h.",
					"leavesAt": "09:19",
					"arrivesAt": "09:25",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Letea h.",
					"to": "Valea Seacă",
					"leavesAt": "09:26",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Valea Seacă",
					"to": "Siretu Bacău h.",
					"leavesAt": "09:32",
					"arrivesAt": "09:36",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Faraoani Hm.",
					"leavesAt": "09:37",
					"arrivesAt": "09:42",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Faraoani Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "09:43",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Răcăciuni h.",
					"to": "Orbeni Hm.",
					"leavesAt": "09:50",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Orbeni Hm.",
					"to": "Sascut Hm.",
					"leavesAt": "10:02",
					"arrivesAt": "10:09",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Sascut Hm.",
					"to": "Şişcani h.",
					"leavesAt": "10:10",
					"arrivesAt": "10:16",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Şişcani h.",
					"to": "Adjudu Vechi h.",
					"leavesAt": "10:17",
					"arrivesAt": "10:21",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Adjud",
					"leavesAt": "10:22",
					"arrivesAt": "10:26",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "10:28",
					"arrivesAt": "10:37",
					"waitsAtSource": 120,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "10:38",
					"arrivesAt": "10:42",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "10:43",
					"arrivesAt": "10:48",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "10:49",
					"arrivesAt": "10:53",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "10:54",
					"arrivesAt": "11:04",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3024",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "19:51",
					"arrivesAt": "20:00",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Timişu de Jos h.",
					"leavesAt": "20:01",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Predeal",
					"leavesAt": "20:17",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "20:35",
					"arrivesAt": "20:44",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "20:45",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "20:52",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "20:56",
					"arrivesAt": "21:02",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:06",
					"waitsAtSource": 120,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Posada h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:16",
					"waitsAtSource": 30,
					"distance": 8900
				},
				{
					"from": "Posada h.",
					"to": "Comarnic",
					"leavesAt": "21:17",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "21:23",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "21:28",
					"arrivesAt": "21:31",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "21:32",
					"arrivesAt": "21:35",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "21:36",
					"arrivesAt": "21:41",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "21:42",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "21:54",
					"arrivesAt": "22:03",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "22:04",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "22:14",
					"arrivesAt": "22:19",
					"waitsAtSource": 120,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9170",
			"segments": [
				{
					"from": "Reşiţa Sud Hm.",
					"to": "Reşiţa Nord",
					"leavesAt": "18:57",
					"arrivesAt": "19:06",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Reşiţa Nord",
					"to": "Bănila Câlnic h.",
					"leavesAt": "19:11",
					"arrivesAt": "19:19",
					"waitsAtSource": 300,
					"distance": 5300
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Ezeriş h.",
					"leavesAt": "19:20",
					"arrivesAt": "19:27",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Ezeriş h.",
					"to": "Brebu",
					"leavesAt": "19:28",
					"arrivesAt": "19:40",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Brebu",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "19:41",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Valea Păltinişului h.",
					"leavesAt": "19:54",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Caransebeş",
					"leavesAt": "20:02",
					"arrivesAt": "20:08",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5448",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "17:00",
					"arrivesAt": "17:05",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "17:07",
					"arrivesAt": "17:16",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "17:17",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "17:32",
					"arrivesAt": "17:38",
					"waitsAtSource": 360,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "17:39",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "17:46",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "17:52",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "18:02",
					"arrivesAt": "18:07",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "18:08",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "18:14",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "18:20",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Paşcani Triaj",
					"leavesAt": "18:30",
					"arrivesAt": "18:34",
					"waitsAtSource": 240,
					"distance": 2300
				},
				{
					"from": "Paşcani Triaj",
					"to": "Stolniceni h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "18:41",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "18:47",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "18:52",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "18:58",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "19:03",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "19:10",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "19:21",
					"arrivesAt": "19:28",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "19:29",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "19:34",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:48",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "19:49",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "19:55",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8803",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:48",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "16:49",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "16:58",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "17:14",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "17:23",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "17:27",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "17:39",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "17:51",
					"arrivesAt": "17:59",
					"waitsAtSource": 480,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2422",
			"segments": [
				{
					"from": "Sălişte Hm.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "13:20",
					"arrivesAt": "13:25",
					"waitsAtSource": 0,
					"distance": 4300
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sibiel h.",
					"leavesAt": "13:26",
					"arrivesAt": "13:29",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sibiel h.",
					"to": "Orlat",
					"leavesAt": "13:30",
					"arrivesAt": "13:36",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Orlat",
					"to": "Cristian Sibiu h.",
					"leavesAt": "13:37",
					"arrivesAt": "13:42",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Turnişor Hm.",
					"leavesAt": "13:43",
					"arrivesAt": "13:57",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Sibiu h.(210)",
					"leavesAt": "13:58",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Sibiu",
					"leavesAt": "14:02",
					"arrivesAt": "14:07",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1692",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Lugoj",
					"leavesAt": "05:22",
					"arrivesAt": "06:15",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Lugoj",
					"to": "Caransebeş",
					"leavesAt": "06:19",
					"arrivesAt": "06:54",
					"waitsAtSource": 240,
					"distance": 39400
				},
				{
					"from": "Caransebeş",
					"to": "Băile Herculane",
					"leavesAt": "06:57",
					"arrivesAt": "08:20",
					"waitsAtSource": 180,
					"distance": 70800
				},
				{
					"from": "Băile Herculane",
					"to": "Orşova",
					"leavesAt": "08:22",
					"arrivesAt": "08:42",
					"waitsAtSource": 120,
					"distance": 17500
				},
				{
					"from": "Orşova",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "08:43",
					"arrivesAt": "09:13",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Balota",
					"leavesAt": "09:15",
					"arrivesAt": "09:47",
					"waitsAtSource": 120,
					"distance": 19000
				},
				{
					"from": "Balota",
					"to": "Prunişor Hm.",
					"leavesAt": "09:48",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Prunişor Hm.",
					"to": "Strehaia hc.",
					"leavesAt": "10:02",
					"arrivesAt": "10:24",
					"waitsAtSource": 240,
					"distance": 22600
				},
				{
					"from": "Strehaia hc.",
					"to": "Filiaşi",
					"leavesAt": "10:25",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Filiaşi",
					"to": "Craiova",
					"leavesAt": "10:54",
					"arrivesAt": "11:22",
					"waitsAtSource": 120,
					"distance": 35800
				},
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "11:30",
					"arrivesAt": "12:09",
					"waitsAtSource": 480,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Drăgăneşti Olt",
					"leavesAt": "12:11",
					"arrivesAt": "12:26",
					"waitsAtSource": 120,
					"distance": 18000
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Roşiori Nord",
					"leavesAt": "12:27",
					"arrivesAt": "12:58",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "13:00",
					"arrivesAt": "13:44",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Grădinari",
					"leavesAt": "13:45",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 25400
				},
				{
					"from": "Grădinari",
					"to": "Bucureşti Nord",
					"leavesAt": "14:14",
					"arrivesAt": "14:42",
					"waitsAtSource": 240,
					"distance": 25500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "1090",
			"segments": [
				{
					"from": "Vidin Patnicheska",
					"to": "Golenţi Hm.",
					"leavesAt": "12:35",
					"arrivesAt": "12:53",
					"waitsAtSource": 0,
					"distance": 23200
				},
				{
					"from": "Golenţi Hm.",
					"to": "Maglavit h.",
					"leavesAt": "13:22",
					"arrivesAt": "13:37",
					"waitsAtSource": 1740,
					"distance": 6600
				},
				{
					"from": "Maglavit h.",
					"to": "Moţăţei Hm.",
					"leavesAt": "13:38",
					"arrivesAt": "13:52",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Moţăţei Hm.",
					"to": "Băileşti",
					"leavesAt": "13:53",
					"arrivesAt": "14:15",
					"waitsAtSource": 60,
					"distance": 12800
				},
				{
					"from": "Băileşti",
					"to": "Siliştea Crucii h.",
					"leavesAt": "14:16",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Siliştea Crucii h.",
					"to": "Afumaţi h.",
					"leavesAt": "14:33",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Afumaţi h.",
					"to": "Portăreşti Hm.",
					"leavesAt": "14:43",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Portăreşti Hm.",
					"to": "Cerăt h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cerăt h.",
					"to": "Segarcea",
					"leavesAt": "15:11",
					"arrivesAt": "15:17",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Segarcea",
					"to": "Segarcea Nord hc.",
					"leavesAt": "15:18",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Segarcea Nord hc.",
					"to": "Dealul Robului h.",
					"leavesAt": "15:21",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dealul Robului h.",
					"to": "Sălcuţa Hm.",
					"leavesAt": "15:27",
					"arrivesAt": "15:32",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Sălcuţa Hm.",
					"to": "Podari",
					"leavesAt": "15:33",
					"arrivesAt": "15:45",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Podari",
					"to": "Jiu Hm.",
					"leavesAt": "15:46",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Jiu Hm.",
					"to": "Bordei hc.(913)",
					"leavesAt": "15:56",
					"arrivesAt": "15:59",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Bordei hc.(913)",
					"to": "Craiova",
					"leavesAt": "16:00",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9665",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "14:48",
					"arrivesAt": "14:58",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara C.E.T.",
					"leavesAt": "14:59",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişeni Hm.",
					"leavesAt": "15:03",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişeni Hm.",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "15:10",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Jebel",
					"leavesAt": "15:18",
					"arrivesAt": "15:24",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Jebel",
					"to": "Voiteni",
					"leavesAt": "15:25",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Voiteni",
					"to": "Deta Hm.",
					"leavesAt": "15:38",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Deta Hm.",
					"to": "Denta h.",
					"leavesAt": "15:48",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Denta h.",
					"to": "Stamora Moraviţa",
					"leavesAt": "15:54",
					"arrivesAt": "16:03",
					"waitsAtSource": 30,
					"distance": 8400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1722",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Tălmaciu Hm.",
					"leavesAt": "02:41",
					"arrivesAt": "03:02",
					"waitsAtSource": 0,
					"distance": 17800
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Turnu Roşu hc.",
					"leavesAt": "03:03",
					"arrivesAt": "03:14",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Câineni",
					"leavesAt": "03:15",
					"arrivesAt": "03:47",
					"waitsAtSource": 30,
					"distance": 21600
				},
				{
					"from": "Câineni",
					"to": "Lotru",
					"leavesAt": "03:55",
					"arrivesAt": "04:19",
					"waitsAtSource": 480,
					"distance": 21100
				},
				{
					"from": "Lotru",
					"to": "Păuşa h.",
					"leavesAt": "04:20",
					"arrivesAt": "04:37",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "04:38",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "04:44",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 16200
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Băbeni",
					"leavesAt": "05:10",
					"arrivesAt": "05:28",
					"waitsAtSource": 420,
					"distance": 19600
				},
				{
					"from": "Băbeni",
					"to": "Drăgăşani",
					"leavesAt": "05:29",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 33200
				},
				{
					"from": "Drăgăşani",
					"to": "Piatra Olt",
					"leavesAt": "05:54",
					"arrivesAt": "06:25",
					"waitsAtSource": 120,
					"distance": 33800
				},
				{
					"from": "Piatra Olt",
					"to": "Caracal",
					"leavesAt": "06:27",
					"arrivesAt": "07:05",
					"waitsAtSource": 120,
					"distance": 32400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9103",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "15:05",
					"arrivesAt": "15:16",
					"waitsAtSource": 0,
					"distance": 7700
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Chitila",
					"leavesAt": "15:17",
					"arrivesAt": "15:20",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "15:21",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "15:31",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "15:56",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "16:06",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "16:19",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:40",
					"waitsAtSource": 540,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Podu Rizii h.",
					"leavesAt": "16:41",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Podu Rizii h.",
					"to": "Băneşti h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "16:51",
					"arrivesAt": "16:55",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "16:56",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "17:10",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2482",
			"segments": [
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "15:25",
					"arrivesAt": "15:30",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "15:31",
					"arrivesAt": "15:40",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Valea Fratelui h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Valea Fratelui h.",
					"to": "Râu Vadului h.",
					"leavesAt": "15:53",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Râu Vadului h.",
					"to": "Câineni",
					"leavesAt": "15:58",
					"arrivesAt": "16:07",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Robeşti h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Robeşti h.",
					"to": "Cornet Hm.",
					"leavesAt": "16:16",
					"arrivesAt": "16:23",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Cornet Hm.",
					"to": "Lotru",
					"leavesAt": "16:24",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 9300
				}
			],
			"restrictions": [
				{
					"from": "20180115",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180212",
					"to": "20180330",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180413",
					"daysOfWeek": 799
				},
				{
					"from": "20180416",
					"to": "20180420",
					"daysOfWeek": 799
				},
				{
					"from": "20180423",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5006",
			"segments": [
				{
					"from": "Buzău",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "09:55",
					"arrivesAt": "10:05",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Ulmeni",
					"leavesAt": "10:06",
					"arrivesAt": "10:11",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "10:12",
					"arrivesAt": "10:16",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "10:17",
					"arrivesAt": "10:27",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "10:28",
					"arrivesAt": "10:36",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "10:37",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "10:46",
					"arrivesAt": "10:51",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "10:52",
					"arrivesAt": "10:58",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "10:59",
					"arrivesAt": "11:02",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "11:03",
					"arrivesAt": "11:10",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "11:11",
					"arrivesAt": "11:18",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "11:19",
					"arrivesAt": "11:26",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ploieşti Sud",
					"to": "Brazi",
					"leavesAt": "11:28",
					"arrivesAt": "11:43",
					"waitsAtSource": 120,
					"distance": 8800
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "11:44",
					"arrivesAt": "11:51",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "11:52",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "12:04",
					"arrivesAt": "12:09",
					"waitsAtSource": 420,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "12:10",
					"arrivesAt": "12:15",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "12:16",
					"arrivesAt": "12:24",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "12:25",
					"arrivesAt": "12:30",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "12:31",
					"arrivesAt": "12:40",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "12:41",
					"arrivesAt": "12:46",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Basarab",
					"leavesAt": "12:47",
					"arrivesAt": "12:56",
					"waitsAtSource": 60,
					"distance": 4700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2093",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "08:05",
					"arrivesAt": "08:08",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "08:09",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "08:13",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "08:18",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "08:26",
					"arrivesAt": "08:30",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "08:31",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "08:36",
					"arrivesAt": "08:41",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "08:46",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "08:52",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "08:59",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Floreşti hc.",
					"to": "Gilort Hm.",
					"leavesAt": "09:03",
					"arrivesAt": "09:09",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Gilort Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "09:10",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turburea Hm.",
					"to": "Bibeşti Hm.",
					"leavesAt": "09:17",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "09:26",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Musculeşti",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "09:31",
					"arrivesAt": "09:36",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Jupâneşti Hm.",
					"leavesAt": "09:37",
					"arrivesAt": "09:42",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "09:43",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cărbuneşti",
					"to": "Pojogeni Hm.",
					"leavesAt": "09:52",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Scoarţa h.",
					"leavesAt": "09:59",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Scoarţa h.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "10:03",
					"arrivesAt": "10:07",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Budieni h.",
					"leavesAt": "10:12",
					"arrivesAt": "10:16",
					"waitsAtSource": 300,
					"distance": 3600
				},
				{
					"from": "Budieni h.",
					"to": "Târgu Jiu",
					"leavesAt": "10:17",
					"arrivesAt": "10:29",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1795",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "20:30",
					"arrivesAt": "21:30",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "21:32",
					"arrivesAt": "21:51",
					"waitsAtSource": 120,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "21:52",
					"arrivesAt": "22:15",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "22:16",
					"arrivesAt": "22:27",
					"waitsAtSource": 60,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1544",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Apahida",
					"leavesAt": "18:20",
					"arrivesAt": "18:37",
					"waitsAtSource": 0,
					"distance": 12300
				},
				{
					"from": "Apahida",
					"to": "Bonţida Hm.",
					"leavesAt": "18:38",
					"arrivesAt": "18:56",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Bonţida Hm.",
					"to": "Iclod Hm.",
					"leavesAt": "18:57",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Iclod Hm.",
					"to": "Gherla",
					"leavesAt": "19:07",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "19:22",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Căşeiu Hm.",
					"leavesAt": "19:43",
					"arrivesAt": "19:51",
					"waitsAtSource": 120,
					"distance": 6300
				},
				{
					"from": "Căşeiu Hm.",
					"to": "Câţcău h.",
					"leavesAt": "19:52",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Câţcău h.",
					"to": "Gâlgău",
					"leavesAt": "20:00",
					"arrivesAt": "20:11",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Gâlgău",
					"to": "Ileanda",
					"leavesAt": "20:12",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Ileanda",
					"to": "Răstoci Hm.",
					"leavesAt": "20:33",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Răstoci Hm.",
					"to": "Letca Hm.",
					"leavesAt": "20:42",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Letca Hm.",
					"to": "Cuciulat Hm.",
					"leavesAt": "20:53",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Băbuţeni Hm.",
					"leavesAt": "21:01",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Băbuţeni Hm.",
					"to": "Ciocmani h.",
					"leavesAt": "21:08",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ciocmani h.",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "21:15",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Jibou",
					"leavesAt": "21:23",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Jibou",
					"to": "Benesat Hm.",
					"leavesAt": "21:33",
					"arrivesAt": "21:50",
					"waitsAtSource": 120,
					"distance": 18000
				},
				{
					"from": "Benesat Hm.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "21:51",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "22:01",
					"arrivesAt": "22:08",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "22:09",
					"arrivesAt": "22:20",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Baia Mare",
					"leavesAt": "22:21",
					"arrivesAt": "22:37",
					"waitsAtSource": 60,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2517",
			"segments": [
				{
					"from": "Făgăraş",
					"to": "Dridif h.",
					"leavesAt": "11:46",
					"arrivesAt": "11:56",
					"waitsAtSource": 0,
					"distance": 8500
				},
				{
					"from": "Dridif h.",
					"to": "Voila Hm.",
					"leavesAt": "11:57",
					"arrivesAt": "12:02",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Voila Hm.",
					"to": "Olteţ h.",
					"leavesAt": "12:07",
					"arrivesAt": "12:14",
					"waitsAtSource": 300,
					"distance": 6100
				},
				{
					"from": "Olteţ h.",
					"to": "Viştea h.",
					"leavesAt": "12:15",
					"arrivesAt": "12:19",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Viştea h.",
					"to": "Ucea",
					"leavesAt": "12:20",
					"arrivesAt": "12:24",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ucea",
					"to": "Arpaş Hm.",
					"leavesAt": "12:25",
					"arrivesAt": "12:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Arpaş Hm.",
					"to": "Cârţa h.",
					"leavesAt": "12:34",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cârţa h.",
					"to": "Scoreiu h.",
					"leavesAt": "12:38",
					"arrivesAt": "12:42",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Scoreiu h.",
					"to": "Sărata Colun h.",
					"leavesAt": "12:43",
					"arrivesAt": "12:46",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Sărata Colun h.",
					"to": "Porumbacu Hm.",
					"leavesAt": "12:47",
					"arrivesAt": "12:53",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Avrig Hm.",
					"leavesAt": "12:59",
					"arrivesAt": "13:08",
					"waitsAtSource": 360,
					"distance": 7400
				},
				{
					"from": "Avrig Hm.",
					"to": "Mârşa h.",
					"leavesAt": "13:09",
					"arrivesAt": "13:13",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Mârşa h.",
					"to": "Racoviţa h.",
					"leavesAt": "13:14",
					"arrivesAt": "13:17",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Racoviţa h.",
					"to": "Sebeş Olt h.",
					"leavesAt": "13:18",
					"arrivesAt": "13:21",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Podu Olt",
					"leavesAt": "13:22",
					"arrivesAt": "13:27",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "13:28",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Veştem h.",
					"leavesAt": "13:36",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Veştem h.",
					"to": "Mohu h.",
					"leavesAt": "13:46",
					"arrivesAt": "13:49",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mohu h.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "13:50",
					"arrivesAt": "13:57",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Atelier Zona h.",
					"leavesAt": "13:58",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu",
					"leavesAt": "14:02",
					"arrivesAt": "14:06",
					"waitsAtSource": 30,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1658",
			"segments": [
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "04:47",
					"arrivesAt": "05:26",
					"waitsAtSource": 0,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "05:27",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "05:55",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "06:18",
					"arrivesAt": "06:55",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "06:56",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "07:29",
					"arrivesAt": "08:01",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "08:02",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "08:39",
					"arrivesAt": "09:28",
					"waitsAtSource": 120,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9172",
			"segments": [
				{
					"from": "Reşiţa Sud Hm.",
					"to": "Reşiţa Nord",
					"leavesAt": "22:05",
					"arrivesAt": "22:14",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Reşiţa Nord",
					"to": "Bănila Câlnic h.",
					"leavesAt": "22:15",
					"arrivesAt": "22:23",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Ezeriş h.",
					"leavesAt": "22:24",
					"arrivesAt": "22:31",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Ezeriş h.",
					"to": "Brebu",
					"leavesAt": "22:32",
					"arrivesAt": "22:43",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Brebu",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "22:44",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Caransebeş",
					"leavesAt": "22:57",
					"arrivesAt": "23:10",
					"waitsAtSource": 60,
					"distance": 10400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2563",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(203)",
					"leavesAt": "12:22",
					"arrivesAt": "12:26",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "12:27",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "12:38",
					"arrivesAt": "12:42",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Mândra h.",
					"leavesAt": "12:44",
					"arrivesAt": "12:51",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Mândra h.",
					"to": "Loamneş Hm.",
					"leavesAt": "12:52",
					"arrivesAt": "12:58",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Loamneş Hm.",
					"to": "Hăşag h.",
					"leavesAt": "12:59",
					"arrivesAt": "13:04",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Hăşag h.",
					"to": "Şeica Mare h.",
					"leavesAt": "13:05",
					"arrivesAt": "13:15",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Şeica Mare h.",
					"to": "Şeica Mare",
					"leavesAt": "13:16",
					"arrivesAt": "13:19",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Şeica Mare",
					"to": "Agârbiciu h.",
					"leavesAt": "13:20",
					"arrivesAt": "13:26",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Agârbiciu h.",
					"to": "Axente Sever h.",
					"leavesAt": "13:27",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Axente Sever h.",
					"to": "Copşa Mică",
					"leavesAt": "13:33",
					"arrivesAt": "13:38",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "13:42",
					"arrivesAt": "13:49",
					"waitsAtSource": 240,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "13:50",
					"arrivesAt": "13:57",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Bratei h.",
					"leavesAt": "13:58",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bratei h.",
					"to": "Aţel Hm.",
					"leavesAt": "14:07",
					"arrivesAt": "14:15",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Aţel Hm.",
					"to": "Dumbrăveni",
					"leavesAt": "14:16",
					"arrivesAt": "14:26",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Dumbrăveni",
					"to": "Luna h.",
					"leavesAt": "14:27",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Luna h.",
					"to": "Daneş Hm.",
					"leavesAt": "14:35",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Daneş Hm.",
					"to": "Sighişoara",
					"leavesAt": "14:43",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7035",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Carpaţi h.(700)",
					"leavesAt": "14:18",
					"arrivesAt": "14:24",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Pajura Hm. (700)",
					"leavesAt": "14:25",
					"arrivesAt": "14:28",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Chitila",
					"leavesAt": "14:29",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chitila",
					"to": "Mogoşoaia",
					"leavesAt": "14:35",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Mogoşoaia",
					"to": "P.O. Aeroport h.",
					"leavesAt": "14:53",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Baloteşti Hm.",
					"leavesAt": "15:01",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Baloteşti Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "15:05",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "15:11",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Greci h.",
					"leavesAt": "15:17",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Greci h.",
					"to": "Fierbinţi",
					"leavesAt": "15:24",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Fierbinţi",
					"to": "Dridu Hm.",
					"leavesAt": "15:31",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Dridu Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "15:38",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moldoveni h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "15:44",
					"arrivesAt": "15:49",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "15:50",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "15:55",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5526",
			"segments": [
				{
					"from": "Târgu Neamţ",
					"to": "Sfântu Mina h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:38",
					"waitsAtSource": 0,
					"distance": 4600
				},
				{
					"from": "Sfântu Mina h.",
					"to": "Plăieşu h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:42",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plăieşu h.",
					"to": "Timişeşti Hm.",
					"leavesAt": "15:43",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Timişeşti Hm.",
					"to": "Cristeşti Paşcani hc.",
					"leavesAt": "15:50",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cristeşti Paşcani hc.",
					"to": "Topile h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Topile h.",
					"to": "Paşcani",
					"leavesAt": "16:05",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 863
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2461",
			"segments": [
				{
					"from": "Râmnicu Vâlcea",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:37",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "17:38",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Dăeşti Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Călimăneşti",
					"leavesAt": "17:51",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Călimăneşti",
					"to": "Păuşa h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Păuşa h.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Cozia Hm.",
					"leavesAt": "18:10",
					"arrivesAt": "18:18",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Cozia Hm.",
					"to": "Lotru",
					"leavesAt": "18:19",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lotru",
					"to": "Beţel h.",
					"leavesAt": "18:29",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Beţel h.",
					"to": "Cornet Hm.",
					"leavesAt": "18:37",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Cornet Hm.",
					"to": "Balota h.",
					"leavesAt": "18:51",
					"arrivesAt": "18:55",
					"waitsAtSource": 480,
					"distance": 4000
				},
				{
					"from": "Balota h.",
					"to": "Robeşti h.",
					"leavesAt": "18:56",
					"arrivesAt": "18:59",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Robeşti h.",
					"to": "Câineni",
					"leavesAt": "19:00",
					"arrivesAt": "19:06",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Râu Vadului h.",
					"leavesAt": "19:07",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Râu Vadului h.",
					"to": "Valea Fratelui h.",
					"leavesAt": "19:15",
					"arrivesAt": "19:19",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Valea Fratelui h.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "19:20",
					"arrivesAt": "19:33",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Turnu Roşu hc.",
					"leavesAt": "19:34",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Podu Olt",
					"leavesAt": "19:45",
					"arrivesAt": "19:50",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9366",
			"segments": [
				{
					"from": "Alexandria",
					"to": "Alexandria Nord h.",
					"leavesAt": "14:15",
					"arrivesAt": "14:18",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Buzescu h.",
					"leavesAt": "14:19",
					"arrivesAt": "14:30",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Buzescu h.",
					"to": "Plosca Hm.",
					"leavesAt": "14:31",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Plosca Hm.",
					"to": "Peret hc.",
					"leavesAt": "14:54",
					"arrivesAt": "15:02",
					"waitsAtSource": 600,
					"distance": 4200
				},
				{
					"from": "Peret hc.",
					"to": "Roşiori Hm.",
					"leavesAt": "15:03",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "15:20",
					"arrivesAt": "15:27",
					"waitsAtSource": 120,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2144",
			"segments": [
				{
					"from": "Hunedoara",
					"to": "Pestişu Mare h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:20",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pestişu Mare h.",
					"to": "Bârcea Mică",
					"leavesAt": "15:21",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bârcea Mică",
					"to": "Bârcea Mare h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bârcea Mare h.",
					"to": "Simeria",
					"leavesAt": "15:29",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2348",
			"segments": [
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "22:38",
					"arrivesAt": "22:45",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "22:46",
					"arrivesAt": "22:52",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1533",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Aghireş",
					"leavesAt": "13:35",
					"arrivesAt": "14:01",
					"waitsAtSource": 0,
					"distance": 27900
				},
				{
					"from": "Aghireş",
					"to": "Huedin",
					"leavesAt": "14:02",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Huedin",
					"to": "Ciucea Hm.",
					"leavesAt": "14:32",
					"arrivesAt": "14:54",
					"waitsAtSource": 360,
					"distance": 22400
				},
				{
					"from": "Ciucea Hm.",
					"to": "Bratca",
					"leavesAt": "14:55",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Bratca",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "15:17",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Aleşd",
					"leavesAt": "15:26",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Aleşd",
					"to": "Tileagd",
					"leavesAt": "15:48",
					"arrivesAt": "15:59",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Tileagd",
					"to": "Oradea",
					"leavesAt": "16:04",
					"arrivesAt": "16:25",
					"waitsAtSource": 300,
					"distance": 23100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9407",
			"segments": [
				{
					"from": "Caracal",
					"to": "Romula Hm.",
					"leavesAt": "16:35",
					"arrivesAt": "16:48",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Romula Hm.",
					"to": "Fălcoiu h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:07",
					"waitsAtSource": 600,
					"distance": 7000
				},
				{
					"from": "Fălcoiu h.",
					"to": "Vlăduleni",
					"leavesAt": "17:08",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vlăduleni",
					"to": "Şopârliţa hc.",
					"leavesAt": "17:17",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Pârşcoveni hc.",
					"leavesAt": "17:22",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Pârşcoveni hc.",
					"to": "Piatra Olt",
					"leavesAt": "17:29",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9027",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "20:00",
					"arrivesAt": "20:04",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "20:05",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "20:09",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "20:14",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Chitila",
					"leavesAt": "20:19",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "20:23",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "20:31",
					"arrivesAt": "20:43",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "20:44",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "20:55",
					"arrivesAt": "21:04",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "21:05",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "21:13",
					"arrivesAt": "21:16",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "21:17",
					"arrivesAt": "21:24",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Fusea Hm.",
					"leavesAt": "21:36",
					"arrivesAt": "21:44",
					"waitsAtSource": 720,
					"distance": 5400
				},
				{
					"from": "Fusea Hm.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "21:45",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Cojocaru h.",
					"leavesAt": "21:52",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Cojocaru h.",
					"to": "Găeşti Sud h.",
					"leavesAt": "21:59",
					"arrivesAt": "22:02",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Găeşti Sud h.",
					"to": "Găeşti",
					"leavesAt": "22:03",
					"arrivesAt": "22:10",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Găeşti",
					"to": "Pătroaia Hm.",
					"leavesAt": "22:11",
					"arrivesAt": "22:19",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Pătroaia Hm.",
					"to": "Leordeni Argeş",
					"leavesAt": "22:20",
					"arrivesAt": "22:27",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Leordeni Argeş",
					"to": "Călineşti Hm.",
					"leavesAt": "22:28",
					"arrivesAt": "22:34",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Călineşti Hm.",
					"to": "Goleşti",
					"leavesAt": "22:35",
					"arrivesAt": "22:45",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Goleşti",
					"to": "Ram. Goleşti",
					"leavesAt": "22:46",
					"arrivesAt": "22:53",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ram. Goleşti",
					"to": "Piteşti",
					"leavesAt": "22:54",
					"arrivesAt": "23:05",
					"waitsAtSource": 30,
					"distance": 4600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8013",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "17:00",
					"arrivesAt": "17:09",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "17:10",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Pasărea",
					"leavesAt": "17:16",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Pasărea",
					"to": "Brăneşti Sat h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Brăneşti Sat h.",
					"to": "Brăneşti Hm.",
					"leavesAt": "17:28",
					"arrivesAt": "17:30",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Brăneşti Hm.",
					"to": "Islaz h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Islaz h.",
					"to": "Fundulea Hm.",
					"leavesAt": "17:35",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Fundulea Hm.",
					"to": "Mostiştea h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Mostiştea h.",
					"to": "Săruleşti",
					"leavesAt": "17:48",
					"arrivesAt": "17:53",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Săruleşti",
					"to": "Preasna h.",
					"leavesAt": "17:54",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Preasna h.",
					"to": "Lehliu",
					"leavesAt": "18:00",
					"arrivesAt": "18:08",
					"waitsAtSource": 30,
					"distance": 8800
				},
				{
					"from": "Lehliu",
					"to": "Dor Mărunt Sat h.",
					"leavesAt": "18:09",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dor Mărunt Sat h.",
					"to": "Dor Mărunt Hm.",
					"leavesAt": "18:14",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Dor Mărunt Hm.",
					"to": "Dâlga h.",
					"leavesAt": "18:18",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Dâlga h.",
					"to": "Bogdana h.",
					"leavesAt": "18:24",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Bogdana h.",
					"to": "Dragoş Vodă Hm.",
					"leavesAt": "18:31",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Dragoş Vodă Hm.",
					"to": "Ciulniţa",
					"leavesAt": "18:35",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Ciulniţa",
					"to": "Ogoarele h.",
					"leavesAt": "18:46",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Ogoarele h.",
					"to": "Perişoru Hm.",
					"leavesAt": "18:53",
					"arrivesAt": "18:56",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Perişoru Hm.",
					"to": "Recolta hc.",
					"leavesAt": "18:57",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Recolta hc.",
					"to": "Jegălia",
					"leavesAt": "19:01",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Jegălia",
					"to": "Ştefan cel Mare h.",
					"leavesAt": "19:05",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ştefan cel Mare h.",
					"to": "Bărăganu Hm.",
					"leavesAt": "19:10",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bărăganu Hm.",
					"to": "Feteşti",
					"leavesAt": "19:15",
					"arrivesAt": "19:24",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2415",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(210)",
					"leavesAt": "19:32",
					"arrivesAt": "19:35",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Turnişor Hm.",
					"leavesAt": "19:36",
					"arrivesAt": "19:41",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Cristian Sibiu h.",
					"leavesAt": "19:42",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Orlat",
					"leavesAt": "19:55",
					"arrivesAt": "20:03",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Orlat",
					"to": "Sibiel h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:11",
					"waitsAtSource": 240,
					"distance": 3200
				},
				{
					"from": "Sibiel h.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:15",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sălişte Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sălişte Hm.",
					"to": "Aciliu h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Aciliu h.",
					"to": "Tilişca h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:31",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Tilişca h.",
					"to": "Apoldu de Sus Hm.",
					"leavesAt": "20:32",
					"arrivesAt": "20:43",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Apoldu de Sus Hm.",
					"to": "Apoldu de Jos h.",
					"leavesAt": "20:44",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Apoldu de Jos h.",
					"to": "Miercurea Sibiu Hm.",
					"leavesAt": "20:52",
					"arrivesAt": "20:57",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Miercurea Sibiu Hm.",
					"to": "Băile Miercurea h.",
					"leavesAt": "20:58",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Băile Miercurea h.",
					"to": "Cunţa Hm.",
					"leavesAt": "21:04",
					"arrivesAt": "21:10",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Cunţa Hm.",
					"to": "Sebeş Alba",
					"leavesAt": "21:11",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 13000
				},
				{
					"from": "Sebeş Alba",
					"to": "Vinţu de Jos",
					"leavesAt": "21:31",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "22:02",
					"arrivesAt": "22:14",
					"waitsAtSource": 1200,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "22:15",
					"arrivesAt": "22:24",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Sântimbru h.",
					"leavesAt": "22:28",
					"arrivesAt": "22:37",
					"waitsAtSource": 240,
					"distance": 6700
				},
				{
					"from": "Sântimbru h.",
					"to": "Coşlariu",
					"leavesAt": "22:38",
					"arrivesAt": "22:50",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "22:51",
					"arrivesAt": "22:59",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "366",
			"segments": [
				{
					"from": "Braşov",
					"to": "Sfântu Gheorghe",
					"leavesAt": "07:07",
					"arrivesAt": "07:36",
					"waitsAtSource": 0,
					"distance": 32100
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "08:10",
					"waitsAtSource": 120,
					"distance": 34400
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "08:12",
					"arrivesAt": "08:35",
					"waitsAtSource": 120,
					"distance": 28500
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "08:37",
					"arrivesAt": "08:45",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Izvoru Oltului",
					"leavesAt": "08:47",
					"arrivesAt": "09:03",
					"waitsAtSource": 120,
					"distance": 17100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Gheorgheni",
					"leavesAt": "09:05",
					"arrivesAt": "09:33",
					"waitsAtSource": 120,
					"distance": 30000
				},
				{
					"from": "Gheorgheni",
					"to": "Topliţa",
					"leavesAt": "09:35",
					"arrivesAt": "10:07",
					"waitsAtSource": 120,
					"distance": 34000
				},
				{
					"from": "Topliţa",
					"to": "Deda",
					"leavesAt": "10:09",
					"arrivesAt": "11:08",
					"waitsAtSource": 120,
					"distance": 43900
				},
				{
					"from": "Deda",
					"to": "Sărăţel Hm.",
					"leavesAt": "11:11",
					"arrivesAt": "12:05",
					"waitsAtSource": 180,
					"distance": 46800
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "12:06",
					"arrivesAt": "12:32",
					"waitsAtSource": 60,
					"distance": 24900
				},
				{
					"from": "Beclean pe Someş",
					"to": "Dej Călători",
					"leavesAt": "12:34",
					"arrivesAt": "13:09",
					"waitsAtSource": 120,
					"distance": 24600
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "13:13",
					"arrivesAt": "13:32",
					"waitsAtSource": 240,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Cluj Napoca",
					"leavesAt": "13:33",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 44900
				},
				{
					"from": "Cluj Napoca",
					"to": "Aghireş",
					"leavesAt": "14:45",
					"arrivesAt": "15:14",
					"waitsAtSource": 1200,
					"distance": 27900
				},
				{
					"from": "Aghireş",
					"to": "Huedin",
					"leavesAt": "15:15",
					"arrivesAt": "15:42",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Huedin",
					"to": "Ciucea Hm.",
					"leavesAt": "15:43",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Ciucea Hm.",
					"to": "Bratca",
					"leavesAt": "16:05",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Bratca",
					"to": "Aleşd",
					"leavesAt": "16:28",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 25300
				},
				{
					"from": "Aleşd",
					"to": "Oradea",
					"leavesAt": "16:57",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 34300
				},
				{
					"from": "Oradea",
					"to": "Episcopia Bihor",
					"leavesAt": "17:31",
					"arrivesAt": "17:39",
					"waitsAtSource": 180,
					"distance": 5700
				},
				{
					"from": "Episcopia Bihor",
					"to": "Biharkeresztes",
					"leavesAt": "17:59",
					"arrivesAt": "18:14",
					"waitsAtSource": 1200,
					"distance": 12500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2023",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "22:15",
					"arrivesAt": "22:20",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Bumbeşti Hm.",
					"leavesAt": "22:21",
					"arrivesAt": "22:34",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Bumbeşti Hm.",
					"to": "Valea Sadului Hm.",
					"leavesAt": "22:35",
					"arrivesAt": "22:41",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Meri",
					"leavesAt": "22:42",
					"arrivesAt": "22:50",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Meri",
					"to": "Pietrele Albe Hm.",
					"leavesAt": "22:55",
					"arrivesAt": "23:15",
					"waitsAtSource": 300,
					"distance": 12900
				},
				{
					"from": "Pietrele Albe Hm.",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "23:16",
					"arrivesAt": "23:27",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Livezeni",
					"leavesAt": "23:28",
					"arrivesAt": "23:34",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Petroşani",
					"leavesAt": "23:35",
					"arrivesAt": "23:43",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Petroşani",
					"to": "Băniţa",
					"leavesAt": "23:47",
					"arrivesAt": "00:01",
					"waitsAtSource": 240,
					"distance": 11300
				},
				{
					"from": "Băniţa",
					"to": "Baru Mare h.",
					"leavesAt": "00:02",
					"arrivesAt": "00:25",
					"waitsAtSource": 60,
					"distance": 14400
				},
				{
					"from": "Baru Mare h.",
					"to": "Pui",
					"leavesAt": "00:26",
					"arrivesAt": "00:40",
					"waitsAtSource": 30,
					"distance": 9800
				},
				{
					"from": "Pui",
					"to": "Ruşor h.",
					"leavesAt": "00:41",
					"arrivesAt": "00:45",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Ruşor h.",
					"to": "Subcetate",
					"leavesAt": "00:46",
					"arrivesAt": "00:55",
					"waitsAtSource": 30,
					"distance": 9500
				},
				{
					"from": "Subcetate",
					"to": "Călan Hm.",
					"leavesAt": "00:56",
					"arrivesAt": "01:15",
					"waitsAtSource": 60,
					"distance": 15600
				},
				{
					"from": "Călan Hm.",
					"to": "Simeria",
					"leavesAt": "01:16",
					"arrivesAt": "01:30",
					"waitsAtSource": 60,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3009",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:10",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "18:11",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "18:14",
					"arrivesAt": "18:17",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "18:18",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Chitila",
					"leavesAt": "18:22",
					"arrivesAt": "18:25",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "18:26",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "18:40",
					"arrivesAt": "18:44",
					"waitsAtSource": 420,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "18:45",
					"arrivesAt": "18:52",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "18:53",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "18:58",
					"arrivesAt": "19:02",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "19:03",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "19:08",
					"arrivesAt": "19:17",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "19:23",
					"arrivesAt": "19:27",
					"waitsAtSource": 360,
					"distance": 4600
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Ploieşti Vest",
					"leavesAt": "19:28",
					"arrivesAt": "19:32",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "19:34",
					"arrivesAt": "19:40",
					"waitsAtSource": 120,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "19:41",
					"arrivesAt": "19:50",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Bobolia h.",
					"leavesAt": "19:51",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Bobolia h.",
					"to": "Câmpina",
					"leavesAt": "19:58",
					"arrivesAt": "20:05",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "20:06",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "20:16",
					"arrivesAt": "20:19",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "20:20",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Posada h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Posada h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "20:31",
					"arrivesAt": "20:36",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Sinaia Sud h.",
					"leavesAt": "20:37",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "20:42",
					"arrivesAt": "20:44",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "20:46",
					"arrivesAt": "20:50",
					"waitsAtSource": 120,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "20:51",
					"arrivesAt": "20:55",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "20:56",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "21:02",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "21:14",
					"arrivesAt": "21:29",
					"waitsAtSource": 120,
					"distance": 9900
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Timişu de Jos h.",
					"leavesAt": "21:30",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Dârste",
					"leavesAt": "21:38",
					"arrivesAt": "21:46",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "21:47",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9408",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Şopârliţa hc.",
					"leavesAt": "16:16",
					"arrivesAt": "16:28",
					"waitsAtSource": 0,
					"distance": 11100
				},
				{
					"from": "Şopârliţa hc.",
					"to": "Vlăduleni",
					"leavesAt": "16:29",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vlăduleni",
					"to": "Fălcoiu h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Fălcoiu h.",
					"to": "Romula Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Romula Hm.",
					"to": "Caracal",
					"leavesAt": "16:55",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1936",
			"segments": [
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "12:30",
					"arrivesAt": "13:05",
					"waitsAtSource": 0,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Sinaia",
					"leavesAt": "13:07",
					"arrivesAt": "13:26",
					"waitsAtSource": 120,
					"distance": 19000
				},
				{
					"from": "Sinaia",
					"to": "Ploieşti Vest",
					"leavesAt": "13:28",
					"arrivesAt": "14:12",
					"waitsAtSource": 120,
					"distance": 62100
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "14:14",
					"arrivesAt": "14:54",
					"waitsAtSource": 120,
					"distance": 58900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ciulniţa",
					"leavesAt": "15:15",
					"arrivesAt": "16:11",
					"waitsAtSource": 1260,
					"distance": 108900
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "16:12",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "16:36",
					"arrivesAt": "16:56",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "16:57",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "17:14",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 34600
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2434",
			"segments": [
				{
					"from": "Râmnicu Vâlcea",
					"to": "Ostroveni h.",
					"leavesAt": "14:10",
					"arrivesAt": "14:12",
					"waitsAtSource": 0,
					"distance": 1000
				},
				{
					"from": "Ostroveni h.",
					"to": "Răstoaca h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:16",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Răstoaca h.",
					"to": "Râureni",
					"leavesAt": "14:17",
					"arrivesAt": "14:19",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Râureni",
					"to": "Râureni hc.",
					"leavesAt": "14:20",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni hc.",
					"to": "Govora",
					"leavesAt": "14:24",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Govora",
					"to": "Tătărani h.",
					"leavesAt": "14:36",
					"arrivesAt": "14:41",
					"waitsAtSource": 420,
					"distance": 5500
				},
				{
					"from": "Tătărani h.",
					"to": "Băbeni",
					"leavesAt": "14:42",
					"arrivesAt": "14:50",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6508",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "16:19",
					"arrivesAt": "16:26",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Socola",
					"leavesAt": "16:27",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Socola",
					"to": "Remiza T Socola h.",
					"leavesAt": "16:33",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Remiza T Socola h.",
					"to": "Holboca Hm.",
					"leavesAt": "16:37",
					"arrivesAt": "16:43",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Holboca Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "16:44",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Ungheni Prut Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9503",
			"segments": [
				{
					"from": "Filiaşi",
					"to": "Gura Motrului Hm.",
					"leavesAt": "04:22",
					"arrivesAt": "04:30",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Butoieşti Hm.",
					"leavesAt": "04:31",
					"arrivesAt": "04:37",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Lunca Banului h.",
					"leavesAt": "04:38",
					"arrivesAt": "04:44",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lunca Banului h.",
					"to": "Strehaia",
					"leavesAt": "04:45",
					"arrivesAt": "04:50",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Strehaia",
					"to": "Strehaia hc.",
					"leavesAt": "04:51",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Strehaia hc.",
					"to": "Ciochiuţa Hm.",
					"leavesAt": "04:55",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Ciochiuţa Hm.",
					"to": "Tâmna",
					"leavesAt": "05:04",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Tâmna",
					"to": "Igiroasa Hm.",
					"leavesAt": "05:13",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Igiroasa Hm.",
					"to": "Prunişor Hm.",
					"leavesAt": "05:19",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prunişor Hm.",
					"to": "Gârniţa Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:33",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Gârniţa Hm.",
					"to": "Balota",
					"leavesAt": "05:34",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Balota",
					"to": "Valea Albă Hm.",
					"leavesAt": "05:39",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Valea Albă Hm.",
					"to": "Ergheviţa h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ergheviţa h.",
					"to": "Drobeta Tr. Severin Mf.",
					"leavesAt": "05:57",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Drobeta Tr. Severin Mf.",
					"to": "Drobeta Tr.Sev Est Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Drobeta Tr.Sev Est Hm.",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "06:14",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 448
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2028",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Cab 1 h",
					"leavesAt": "13:54",
					"arrivesAt": "13:58",
					"waitsAtSource": 0,
					"distance": 4400
				},
				{
					"from": "Ronaţ Triaj Cab 1 h",
					"to": "Ronaţ Triaj h",
					"leavesAt": "13:59",
					"arrivesAt": "14:02",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Sânandrei Hm.",
					"leavesAt": "14:03",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Băile Călacea",
					"leavesAt": "14:11",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Călacea",
					"to": "Orţişoara",
					"leavesAt": "14:19",
					"arrivesAt": "14:24",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Orţişoara",
					"to": "Vinga Hm.",
					"leavesAt": "14:25",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "14:32",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Aradu Nou",
					"leavesAt": "14:40",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "14:56",
					"arrivesAt": "15:03",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Arad",
					"to": "Glogovăţ",
					"leavesAt": "15:25",
					"arrivesAt": "15:33",
					"waitsAtSource": 1320,
					"distance": 6900
				},
				{
					"from": "Glogovăţ",
					"to": "Ghioroc",
					"leavesAt": "15:34",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Ghioroc",
					"to": "Păuliş h.",
					"leavesAt": "15:53",
					"arrivesAt": "15:58",
					"waitsAtSource": 300,
					"distance": 3500
				},
				{
					"from": "Păuliş h.",
					"to": "Păuliş Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş Hm.",
					"to": "Radna",
					"leavesAt": "16:05",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Radna",
					"to": "Milova",
					"leavesAt": "16:18",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Milova",
					"to": "Corfeni h.",
					"leavesAt": "16:30",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Corfeni h.",
					"to": "Conop Hm.",
					"leavesAt": "16:35",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Conop Hm.",
					"to": "Nadăş h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Nadăş h.",
					"to": "Bârzava",
					"leavesAt": "16:48",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârzava",
					"to": "Căpruţa h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Căpruţa h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "17:01",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:11",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Vărădia Hm.",
					"leavesAt": "17:12",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vărădia Hm.",
					"to": "Vărădia h.",
					"leavesAt": "17:20",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Vărădia h.",
					"to": "Săvârşin",
					"leavesAt": "17:24",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Săvârşin",
					"to": "Toc h.",
					"leavesAt": "17:34",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Toc h.",
					"to": "Ilteu",
					"leavesAt": "17:42",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ilteu",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Zam",
					"leavesAt": "17:53",
					"arrivesAt": "17:59",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Zam",
					"to": "Burjuc h.",
					"leavesAt": "18:11",
					"arrivesAt": "18:22",
					"waitsAtSource": 720,
					"distance": 8500
				},
				{
					"from": "Burjuc h.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "18:23",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Gurasada Hm.",
					"leavesAt": "18:32",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Gurasada Hm.",
					"to": "Ilia",
					"leavesAt": "18:40",
					"arrivesAt": "18:47",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ilia",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "18:48",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Brănişca Hm.",
					"leavesAt": "18:54",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Veţel h.",
					"leavesAt": "19:02",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Veţel h.",
					"to": "Mintia h.",
					"leavesAt": "19:07",
					"arrivesAt": "19:10",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Mintia",
					"leavesAt": "19:11",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia",
					"to": "Deva",
					"leavesAt": "19:16",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Deva",
					"to": "Săuleşti h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Săuleşti h.",
					"to": "Simeria",
					"leavesAt": "19:34",
					"arrivesAt": "19:40",
					"waitsAtSource": 30,
					"distance": 3300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9001",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "07:55",
					"arrivesAt": "07:58",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h.(900)",
					"leavesAt": "07:59",
					"arrivesAt": "08:02",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureştii Noi",
					"leavesAt": "08:03",
					"arrivesAt": "08:06",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Chiajna",
					"leavesAt": "08:07",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiajna",
					"to": "Domneştii de Sus h.",
					"leavesAt": "08:15",
					"arrivesAt": "08:24",
					"waitsAtSource": 300,
					"distance": 10500
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Grădinari",
					"leavesAt": "08:25",
					"arrivesAt": "08:35",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Grădinari",
					"to": "Zorile h.",
					"leavesAt": "08:36",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Zorile h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "08:42",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Zăvestreni Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:02",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Videle",
					"leavesAt": "09:03",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Videle",
					"to": "Ciolpani Hm.",
					"leavesAt": "09:13",
					"arrivesAt": "09:19",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Gălăteni Hm.",
					"leavesAt": "09:20",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Olteni",
					"leavesAt": "09:28",
					"arrivesAt": "09:33",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Olteni",
					"to": "Vârtoapele hc.",
					"leavesAt": "09:34",
					"arrivesAt": "09:42",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "09:43",
					"arrivesAt": "09:48",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Atârnaţi Hm.",
					"leavesAt": "09:49",
					"arrivesAt": "09:59",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "10:00",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Roşiori Nord",
					"to": "Mihăeşti Hm.",
					"leavesAt": "10:12",
					"arrivesAt": "10:26",
					"waitsAtSource": 120,
					"distance": 17300
				},
				{
					"from": "Mihăeşti Hm.",
					"to": "Radomireşti Hm.",
					"leavesAt": "10:27",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Radomireşti Hm.",
					"to": "Dăneasa h.",
					"leavesAt": "10:38",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Dăneasa h.",
					"to": "Drăgăneşti Olt",
					"leavesAt": "10:46",
					"arrivesAt": "10:50",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Stoeneşti h.",
					"leavesAt": "10:51",
					"arrivesAt": "10:57",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Stoeneşti h.",
					"to": "Fărcaşele Hm.",
					"leavesAt": "10:58",
					"arrivesAt": "11:03",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Fărcaşele Hm.",
					"to": "Caracal",
					"leavesAt": "11:04",
					"arrivesAt": "11:14",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Caracal",
					"to": "Cezieni h.",
					"leavesAt": "11:15",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Cezieni h.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "11:21",
					"arrivesAt": "11:27",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Radomiru hc.",
					"leavesAt": "11:28",
					"arrivesAt": "11:33",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Radomiru hc.",
					"to": "Jianca",
					"leavesAt": "11:34",
					"arrivesAt": "11:37",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Jianca",
					"to": "Ţărţăl h.",
					"leavesAt": "11:38",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţărţăl h.",
					"to": "Leu Hm.",
					"leavesAt": "11:42",
					"arrivesAt": "11:47",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Leu Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "11:48",
					"arrivesAt": "11:56",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Malu Mare Hm.",
					"leavesAt": "11:57",
					"arrivesAt": "12:00",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Malu Mare Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "12:01",
					"arrivesAt": "12:03",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "12:04",
					"arrivesAt": "12:08",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Bordei hc.(900)",
					"leavesAt": "12:09",
					"arrivesAt": "12:13",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Craiova",
					"leavesAt": "12:14",
					"arrivesAt": "12:19",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9053",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "16:00",
					"arrivesAt": "16:05",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Km. 200+400 P.aj.m",
					"leavesAt": "16:06",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Km. 200+400 P.aj.m",
					"to": "Troian h.",
					"leavesAt": "16:14",
					"arrivesAt": "16:23",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Troian h.",
					"to": "Salcia Teleorman Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:37",
					"waitsAtSource": 30,
					"distance": 9700
				},
				{
					"from": "Salcia Teleorman Hm.",
					"to": "Km. 231+600 h.",
					"leavesAt": "16:38",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 14500
				},
				{
					"from": "Km. 231+600 h.",
					"to": "Turnu Măgurele",
					"leavesAt": "16:55",
					"arrivesAt": "17:14",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2084",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Lunca Jiului hc.",
					"leavesAt": "14:20",
					"arrivesAt": "14:23",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Lunca Jiului hc.",
					"to": "Livezeni",
					"leavesAt": "14:24",
					"arrivesAt": "14:29",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:37",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Pietrele Albe Hm.",
					"leavesAt": "14:38",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Pietrele Albe Hm.",
					"to": "Km. 105+600 h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Km. 105+600 h.",
					"to": "Lainici Hm.",
					"leavesAt": "14:53",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Lainici Hm.",
					"to": "Meri",
					"leavesAt": "15:01",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Meri",
					"to": "Valea Sadului Hm.",
					"leavesAt": "15:12",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Bumbeşti Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bumbeşti Hm.",
					"to": "Parângu Hm.",
					"leavesAt": "15:25",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Parângu Hm.",
					"to": "Ezureni h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Ezureni h.",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "15:37",
					"arrivesAt": "15:41",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Ramificaţia C.A.M. h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ramificaţia C.A.M. h.",
					"to": "Târgu Jiu",
					"leavesAt": "15:46",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 800
				},
				{
					"from": "Târgu Jiu",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "16:10",
					"arrivesAt": "16:17",
					"waitsAtSource": 1200,
					"distance": 6800
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Budieni h.",
					"leavesAt": "16:18",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Budieni h.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "16:23",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Pojogeni Hm.",
					"leavesAt": "16:28",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "16:35",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cărbuneşti",
					"to": "Jupâneşti Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:52",
					"waitsAtSource": 300,
					"distance": 5400
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "17:01",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Musculeşti",
					"to": "Bibeşti Hm.",
					"leavesAt": "17:09",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "17:15",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Turburea Hm.",
					"to": "Gilort Hm.",
					"leavesAt": "17:25",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gilort Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "17:38",
					"arrivesAt": "17:41",
					"waitsAtSource": 360,
					"distance": 3700
				},
				{
					"from": "Floreşti hc.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:48",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Bungeţel h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bungeţel h.",
					"to": "Filiaşi",
					"leavesAt": "17:53",
					"arrivesAt": "17:57",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "18:02",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:18",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "18:23",
					"arrivesAt": "18:28",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "18:29",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "18:32",
					"arrivesAt": "18:36",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "18:37",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "18:41",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 863
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4513",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "16:18",
					"arrivesAt": "16:22",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "16:23",
					"arrivesAt": "16:29",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:42",
					"waitsAtSource": 360,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "16:47",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "16:52",
					"arrivesAt": "16:57",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "16:58",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Bodoc Hm.",
					"leavesAt": "17:07",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Bodoc Hm.",
					"to": "Malnaş h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Malnaş h.",
					"to": "Malnaş Băi",
					"leavesAt": "17:24",
					"arrivesAt": "17:31",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Malnaş Băi",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "17:38",
					"arrivesAt": "17:48",
					"waitsAtSource": 420,
					"distance": 7800
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "18:00",
					"arrivesAt": "18:09",
					"waitsAtSource": 720,
					"distance": 6100
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Tuşnad Sat",
					"leavesAt": "18:10",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tuşnad Sat",
					"to": "Vrabia h.",
					"leavesAt": "18:18",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Vrabia h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "18:22",
					"arrivesAt": "18:28",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "18:29",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "18:33",
					"arrivesAt": "18:37",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "18:38",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "18:57",
					"arrivesAt": "19:05",
					"waitsAtSource": 660,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Racu h.",
					"leavesAt": "19:09",
					"arrivesAt": "19:12",
					"waitsAtSource": 240,
					"distance": 2200
				},
				{
					"from": "Racu h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "19:13",
					"arrivesAt": "19:21",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Dăneşti h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:32",
					"waitsAtSource": 360,
					"distance": 3000
				},
				{
					"from": "Dăneşti h.",
					"to": "Cârţani h.",
					"leavesAt": "19:33",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cârţani h.",
					"to": "Tomeşti h.",
					"leavesAt": "19:37",
					"arrivesAt": "19:40",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Izvoru Oltului",
					"leavesAt": "19:41",
					"arrivesAt": "19:45",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Izvoru Oltului",
					"to": "Sândominic h.",
					"leavesAt": "19:47",
					"arrivesAt": "19:51",
					"waitsAtSource": 120,
					"distance": 3100
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "19:52",
					"arrivesAt": "20:01",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:14",
					"waitsAtSource": 120,
					"distance": 10100
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Şugău h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şugău h.",
					"to": "Valea Strâmbă h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Gheorgheni",
					"leavesAt": "20:23",
					"arrivesAt": "20:27",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Gheorgheni",
					"to": "Lăzarea Hm.",
					"leavesAt": "20:32",
					"arrivesAt": "20:37",
					"waitsAtSource": 300,
					"distance": 4400
				},
				{
					"from": "Lăzarea Hm.",
					"to": "Ditrău",
					"leavesAt": "20:38",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Ditrău",
					"to": "Subcetate Mureş Hm.",
					"leavesAt": "20:53",
					"arrivesAt": "21:02",
					"waitsAtSource": 480,
					"distance": 8500
				},
				{
					"from": "Subcetate Mureş Hm.",
					"to": "Sărmaş Runc h.",
					"leavesAt": "21:03",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărmaş Runc h.",
					"to": "Gălăuţaş Hm.",
					"leavesAt": "21:10",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Gălăuţaş Hm.",
					"to": "Topliţa",
					"leavesAt": "21:18",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 6000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3512",
			"segments": [
				{
					"from": "Teiuş",
					"to": "Coşlariu Gr. P. Mureş",
					"leavesAt": "06:37",
					"arrivesAt": "06:44",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Coşlariu Gr. P. Mureş",
					"to": "Mihalţ h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:48",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Mihalţ h.",
					"to": "Cistei h.",
					"leavesAt": "06:49",
					"arrivesAt": "06:54",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Cistei h.",
					"to": "Crăciunel Hm.",
					"leavesAt": "06:55",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Crăciunel Hm.",
					"to": "Blaj",
					"leavesAt": "07:06",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Blaj",
					"to": "Câmpu Libertăţii  h.",
					"leavesAt": "07:19",
					"arrivesAt": "07:23",
					"waitsAtSource": 300,
					"distance": 3500
				},
				{
					"from": "Câmpu Libertăţii  h.",
					"to": "Mănărade h.",
					"leavesAt": "07:24",
					"arrivesAt": "07:28",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Mănărade h.",
					"to": "Glogoveţ h.",
					"leavesAt": "07:29",
					"arrivesAt": "07:32",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Glogoveţ h.",
					"to": "Valea Lungă Hm.",
					"leavesAt": "07:33",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Lunca h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:46",
					"waitsAtSource": 360,
					"distance": 2100
				},
				{
					"from": "Lunca h.",
					"to": "Micăsasa h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:56",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Micăsasa h.",
					"to": "Şeica Mică h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Şeica Mică h.",
					"to": "Copşa Mică",
					"leavesAt": "08:06",
					"arrivesAt": "08:15",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "08:24",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Bratei h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:41",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Bratei h.",
					"to": "Aţel Hm.",
					"leavesAt": "08:42",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Aţel Hm.",
					"to": "Dumbrăveni",
					"leavesAt": "08:51",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Dumbrăveni",
					"to": "Luna h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Luna h.",
					"to": "Daneş Hm.",
					"leavesAt": "09:10",
					"arrivesAt": "09:17",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Daneş Hm.",
					"to": "Sighişoara",
					"leavesAt": "09:18",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4318",
			"segments": [
				{
					"from": "Apa Hm.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "06:41",
					"arrivesAt": "06:51",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Odoreu h.",
					"leavesAt": "06:52",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Odoreu h.",
					"to": "Botiz Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Botiz Hm.",
					"to": "Satu Mare",
					"leavesAt": "07:11",
					"arrivesAt": "07:18",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20180114",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1539",
			"segments": [
				{
					"from": "Braşov",
					"to": "Sighişoara",
					"leavesAt": "15:08",
					"arrivesAt": "17:44",
					"waitsAtSource": 0,
					"distance": 127400
				},
				{
					"from": "Sighişoara",
					"to": "Mediaş",
					"leavesAt": "17:49",
					"arrivesAt": "18:39",
					"waitsAtSource": 300,
					"distance": 38400
				},
				{
					"from": "Mediaş",
					"to": "Copşa Mică",
					"leavesAt": "18:41",
					"arrivesAt": "18:54",
					"waitsAtSource": 120,
					"distance": 10400
				},
				{
					"from": "Copşa Mică",
					"to": "Blaj",
					"leavesAt": "18:55",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 30000
				},
				{
					"from": "Blaj",
					"to": "Teiuş",
					"leavesAt": "19:34",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 21300
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "20:06",
					"arrivesAt": "20:19",
					"waitsAtSource": 240,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Unirea hc.",
					"leavesAt": "20:20",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "20:36",
					"arrivesAt": "20:43",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Câmpia Turzii",
					"leavesAt": "20:44",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cluj Napoca",
					"leavesAt": "21:01",
					"arrivesAt": "22:08",
					"waitsAtSource": 60,
					"distance": 51500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1945",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun hc.",
					"leavesAt": "15:30",
					"arrivesAt": "15:40",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "15:42",
					"arrivesAt": "15:54",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "15:56",
					"arrivesAt": "16:00",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "16:10",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "16:20",
					"arrivesAt": "16:27",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:38",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "16:39",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "17:20",
					"arrivesAt": "17:46",
					"waitsAtSource": 1260,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "17:47",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "18:05",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Bucureşti Băneasa",
					"leavesAt": "18:27",
					"arrivesAt": "19:41",
					"waitsAtSource": 120,
					"distance": 139800
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Ploieşti Vest",
					"leavesAt": "19:43",
					"arrivesAt": "20:24",
					"waitsAtSource": 120,
					"distance": 58100
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "20:27",
					"arrivesAt": "20:50",
					"waitsAtSource": 180,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "20:52",
					"arrivesAt": "21:15",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "21:17",
					"arrivesAt": "21:25",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Predeal",
					"leavesAt": "21:27",
					"arrivesAt": "21:40",
					"waitsAtSource": 120,
					"distance": 11400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "21:43",
					"arrivesAt": "22:21",
					"waitsAtSource": 180,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Sfântu Gheorghe",
					"leavesAt": "22:33",
					"arrivesAt": "23:02",
					"waitsAtSource": 720,
					"distance": 32100
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "23:04",
					"arrivesAt": "23:36",
					"waitsAtSource": 120,
					"distance": 34400
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Tuşnad Sat",
					"leavesAt": "23:38",
					"arrivesAt": "23:47",
					"waitsAtSource": 120,
					"distance": 5700
				},
				{
					"from": "Tuşnad Sat",
					"to": "Miercurea Ciuc",
					"leavesAt": "23:54",
					"arrivesAt": "00:11",
					"waitsAtSource": 420,
					"distance": 22800
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "00:12",
					"arrivesAt": "00:20",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Izvoru Oltului",
					"leavesAt": "00:24",
					"arrivesAt": "00:40",
					"waitsAtSource": 240,
					"distance": 17100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "00:41",
					"arrivesAt": "00:53",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Gheorgheni",
					"leavesAt": "00:59",
					"arrivesAt": "01:17",
					"waitsAtSource": 360,
					"distance": 19100
				},
				{
					"from": "Gheorgheni",
					"to": "Topliţa",
					"leavesAt": "01:18",
					"arrivesAt": "01:51",
					"waitsAtSource": 60,
					"distance": 34000
				},
				{
					"from": "Topliţa",
					"to": "Deda",
					"leavesAt": "01:55",
					"arrivesAt": "02:56",
					"waitsAtSource": 240,
					"distance": 43900
				},
				{
					"from": "Deda",
					"to": "Sărăţel Hm.",
					"leavesAt": "03:10",
					"arrivesAt": "04:04",
					"waitsAtSource": 840,
					"distance": 46800
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Şintereag Hm.",
					"leavesAt": "04:06",
					"arrivesAt": "04:24",
					"waitsAtSource": 120,
					"distance": 17500
				},
				{
					"from": "Şintereag Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "04:28",
					"arrivesAt": "04:37",
					"waitsAtSource": 240,
					"distance": 7400
				},
				{
					"from": "Beclean pe Someş",
					"to": "Dej Călători",
					"leavesAt": "04:49",
					"arrivesAt": "05:23",
					"waitsAtSource": 720,
					"distance": 24600
				},
				{
					"from": "Dej Călători",
					"to": "Gâlgău",
					"leavesAt": "05:35",
					"arrivesAt": "05:59",
					"waitsAtSource": 720,
					"distance": 23400
				},
				{
					"from": "Gâlgău",
					"to": "Ileanda",
					"leavesAt": "06:00",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Ileanda",
					"to": "Letca Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 13600
				},
				{
					"from": "Letca Hm.",
					"to": "Cuciulat Hm.",
					"leavesAt": "06:37",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Jibou",
					"leavesAt": "06:49",
					"arrivesAt": "07:14",
					"waitsAtSource": 240,
					"distance": 18500
				},
				{
					"from": "Jibou",
					"to": "Benesat Hm.",
					"leavesAt": "07:23",
					"arrivesAt": "07:41",
					"waitsAtSource": 540,
					"distance": 18000
				},
				{
					"from": "Benesat Hm.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "07:42",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Baia Mare",
					"leavesAt": "08:01",
					"arrivesAt": "08:33",
					"waitsAtSource": 600,
					"distance": 31000
				},
				{
					"from": "Baia Mare",
					"to": "Seini",
					"leavesAt": "08:51",
					"arrivesAt": "09:27",
					"waitsAtSource": 1080,
					"distance": 24600
				},
				{
					"from": "Seini",
					"to": "Satu Mare",
					"leavesAt": "09:28",
					"arrivesAt": "10:05",
					"waitsAtSource": 60,
					"distance": 34800
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1839",
			"segments": [
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "00:40",
					"arrivesAt": "00:52",
					"waitsAtSource": 0,
					"distance": 9200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5504",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "21:06",
					"arrivesAt": "21:11",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "21:13",
					"arrivesAt": "21:20",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "21:21",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "21:29",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "21:36",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "21:43",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "21:49",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "21:59",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "22:05",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "22:11",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "22:17",
					"arrivesAt": "22:23",
					"waitsAtSource": 60,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2041",
			"segments": [
				{
					"from": "Săvârşin",
					"to": "Vărădia h.",
					"leavesAt": "04:40",
					"arrivesAt": "04:46",
					"waitsAtSource": 0,
					"distance": 6000
				},
				{
					"from": "Vărădia h.",
					"to": "Vărădia Hm.",
					"leavesAt": "04:47",
					"arrivesAt": "04:52",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărădia Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "04:53",
					"arrivesAt": "04:58",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "04:59",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Căpruţa h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Căpruţa h.",
					"to": "Bârzava",
					"leavesAt": "05:12",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Bârzava",
					"to": "Nadăş h.",
					"leavesAt": "05:18",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Nadăş h.",
					"to": "Conop Hm.",
					"leavesAt": "05:24",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Conop Hm.",
					"to": "Corfeni h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Corfeni h.",
					"to": "Milova",
					"leavesAt": "05:37",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Milova",
					"to": "Radna",
					"leavesAt": "05:44",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Radna",
					"to": "Păuliş Hm.",
					"leavesAt": "05:57",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Păuliş Hm.",
					"to": "Păuliş h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş h.",
					"to": "Ghioroc",
					"leavesAt": "06:11",
					"arrivesAt": "06:18",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ghioroc",
					"to": "Glogovăţ",
					"leavesAt": "06:19",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Glogovăţ",
					"to": "Arad",
					"leavesAt": "06:32",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "36322",
			"segments": [
				{
					"from": "Carei",
					"to": "Tiborszallas",
					"leavesAt": "09:27",
					"arrivesAt": "09:53",
					"waitsAtSource": 0,
					"distance": 16100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5473",
			"segments": [
				{
					"from": "Bacău",
					"to": "Hămeiuş P.M.",
					"leavesAt": "16:34",
					"arrivesAt": "16:43",
					"waitsAtSource": 0,
					"distance": 7900
				},
				{
					"from": "Hămeiuş P.M.",
					"to": "Gârleni Hm.",
					"leavesAt": "16:44",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Gârleni Hm.",
					"to": "Lespezi Bacău h.",
					"leavesAt": "16:53",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Lespezi Bacău h.",
					"to": "Racova h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Racova h.",
					"to": "Buhuşi",
					"leavesAt": "17:05",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Buhuşi",
					"to": "Costişa h.",
					"leavesAt": "17:19",
					"arrivesAt": "17:26",
					"waitsAtSource": 420,
					"distance": 6300
				},
				{
					"from": "Costişa h.",
					"to": "Podoleni Hm.",
					"leavesAt": "17:27",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Podoleni Hm.",
					"to": "Zăneşti Neamţ h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Zăneşti Neamţ h.",
					"to": "Roznov",
					"leavesAt": "17:44",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Roznov",
					"to": "Săvineşti h.",
					"leavesAt": "17:50",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Săvineşti h.",
					"to": "Dumbrava h.",
					"leavesAt": "17:56",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumbrava h.",
					"to": "Piatra Neamţ",
					"leavesAt": "18:05",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Piatra Neamţ",
					"to": "Vaduri h.",
					"leavesAt": "18:14",
					"arrivesAt": "18:26",
					"waitsAtSource": 120,
					"distance": 9600
				},
				{
					"from": "Vaduri h.",
					"to": "Pângăraţi Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Pângăraţi Hm.",
					"to": "Stejaru h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Stejaru h.",
					"to": "Tarcău Neamţ Hm.",
					"leavesAt": "18:38",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tarcău Neamţ Hm.",
					"to": "Bicaz",
					"leavesAt": "18:46",
					"arrivesAt": "18:54",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5604",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "11:06",
					"arrivesAt": "11:11",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "11:13",
					"arrivesAt": "11:20",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "11:21",
					"arrivesAt": "11:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "11:29",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "11:36",
					"arrivesAt": "11:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "11:43",
					"arrivesAt": "11:48",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "11:49",
					"arrivesAt": "11:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "11:59",
					"arrivesAt": "12:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "12:05",
					"arrivesAt": "12:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "12:11",
					"arrivesAt": "12:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "12:17",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "12:31",
					"arrivesAt": "12:45",
					"waitsAtSource": 480,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "12:46",
					"arrivesAt": "12:53",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "12:54",
					"arrivesAt": "12:59",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "13:00",
					"arrivesAt": "13:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "13:09",
					"arrivesAt": "13:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "13:20",
					"arrivesAt": "13:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "13:27",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "13:34",
					"arrivesAt": "13:41",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "13:42",
					"arrivesAt": "13:57",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "37651",
			"segments": [
				{
					"from": "Salonta",
					"to": "Kotegyan",
					"leavesAt": "18:30",
					"arrivesAt": "18:50",
					"waitsAtSource": 0,
					"distance": 13200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4422",
			"segments": [
				{
					"from": "Jibou",
					"to": "Var h.",
					"leavesAt": "03:50",
					"arrivesAt": "03:54",
					"waitsAtSource": 0,
					"distance": 2800
				},
				{
					"from": "Var h.",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "03:55",
					"arrivesAt": "04:00",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Ciocmani h.",
					"leavesAt": "04:01",
					"arrivesAt": "04:07",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ciocmani h.",
					"to": "Băbuţeni Hm.",
					"leavesAt": "04:08",
					"arrivesAt": "04:14",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Băbuţeni Hm.",
					"to": "Cuciulat Hm.",
					"leavesAt": "04:15",
					"arrivesAt": "04:21",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Letca Hm.",
					"leavesAt": "04:22",
					"arrivesAt": "04:29",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Letca Hm.",
					"to": "Răstoci Hm.",
					"leavesAt": "04:30",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Răstoci Hm.",
					"to": "Bizuşa h.",
					"leavesAt": "04:41",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bizuşa h.",
					"to": "Ileanda",
					"leavesAt": "04:48",
					"arrivesAt": "04:52",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Ileanda",
					"to": "Rus h.",
					"leavesAt": "04:54",
					"arrivesAt": "05:00",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Rus h.",
					"to": "Glodu Someşului h.",
					"leavesAt": "05:01",
					"arrivesAt": "05:07",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Glodu Someşului h.",
					"to": "Gâlgău h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Gâlgău h.",
					"to": "Gâlgău",
					"leavesAt": "05:13",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Gâlgău",
					"to": "Căpâlna pe Someş h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:28",
					"waitsAtSource": 120,
					"distance": 5700
				},
				{
					"from": "Căpâlna pe Someş h.",
					"to": "Câţcău h.",
					"leavesAt": "05:29",
					"arrivesAt": "05:35",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Câţcău h.",
					"to": "Coplean h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Coplean h.",
					"to": "Căşeiu Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:46",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Căşeiu Hm.",
					"to": "C. C. H. Dej h.",
					"leavesAt": "05:47",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "C. C. H. Dej h.",
					"to": "Dej Călători",
					"leavesAt": "05:53",
					"arrivesAt": "05:57",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180430",
					"daysOfWeek": 319
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 319
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 319
				},
				{
					"from": "20180602",
					"to": "20181129",
					"daysOfWeek": 319
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1981",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Feteşti",
					"leavesAt": "05:40",
					"arrivesAt": "06:57",
					"waitsAtSource": 0,
					"distance": 146400
				},
				{
					"from": "Feteşti",
					"to": "Medgidia",
					"leavesAt": "06:59",
					"arrivesAt": "07:33",
					"waitsAtSource": 120,
					"distance": 44000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "07:34",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 34600
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4337",
			"segments": [
				{
					"from": "Oradea",
					"to": "Episcopia Bihor",
					"leavesAt": "15:36",
					"arrivesAt": "15:44",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Episcopia Bihor",
					"to": "Biharia Hm.",
					"leavesAt": "15:45",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Biharia Hm.",
					"to": "Tămăşeu h.",
					"leavesAt": "15:55",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Tămăşeu h.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "16:02",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Diosig Hm.",
					"leavesAt": "16:10",
					"arrivesAt": "16:18",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Diosig Hm.",
					"to": "Cadia h.",
					"leavesAt": "16:27",
					"arrivesAt": "16:34",
					"waitsAtSource": 540,
					"distance": 5400
				},
				{
					"from": "Cadia h.",
					"to": "Săcuieni Bihor",
					"leavesAt": "16:35",
					"arrivesAt": "16:43",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Şilindru Hm.",
					"leavesAt": "16:44",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Şilindru Hm.",
					"to": "Simion h.",
					"leavesAt": "16:55",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Simion h.",
					"to": "Valea lui Mihai",
					"leavesAt": "17:02",
					"arrivesAt": "17:09",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Valea lui Mihai",
					"to": "Curtuiuşeni h.",
					"leavesAt": "17:10",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Resighea h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Resighea h.",
					"to": "Sanislău Hm.",
					"leavesAt": "17:24",
					"arrivesAt": "17:29",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Sanislău Hm.",
					"to": "Marna h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:44",
					"waitsAtSource": 600,
					"distance": 5100
				},
				{
					"from": "Marna h.",
					"to": "Carei",
					"leavesAt": "17:45",
					"arrivesAt": "17:53",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Carei",
					"to": "Domăneşti h.",
					"leavesAt": "17:54",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Domăneşti h.",
					"to": "Moftin h.",
					"leavesAt": "18:03",
					"arrivesAt": "18:07",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Moftin h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "18:08",
					"arrivesAt": "18:12",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Sătmărel h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Sătmărel h.",
					"to": "Satu Mare Sud",
					"leavesAt": "18:22",
					"arrivesAt": "18:28",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Satu Mare Sud",
					"to": "Satu Mare",
					"leavesAt": "18:29",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Satu Mare",
					"to": "Ram. Botiz h.",
					"leavesAt": "18:38",
					"arrivesAt": "18:44",
					"waitsAtSource": 120,
					"distance": 5000
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Micula Hm.",
					"leavesAt": "18:45",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Micula Hm.",
					"to": "Porumbeşti Hm.",
					"leavesAt": "18:53",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Halmeu",
					"leavesAt": "19:00",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20180909",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180607",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4482",
			"segments": [
				{
					"from": "Dej Călători",
					"to": "Dej Triaj",
					"leavesAt": "07:13",
					"arrivesAt": "07:20",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Dej Triaj",
					"to": "Reteag Hm.",
					"leavesAt": "07:21",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Reteag Hm.",
					"to": "Reteag h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag h.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:40",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Coldău Hm.",
					"leavesAt": "07:41",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Coldău Hm.",
					"to": "Beclean pe Someş",
					"leavesAt": "07:45",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5446",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "07:06",
					"arrivesAt": "07:11",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "07:13",
					"arrivesAt": "07:20",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "07:21",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "07:29",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "07:36",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "07:49",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "07:59",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "08:05",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "08:11",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "08:17",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Stolniceni h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:35",
					"waitsAtSource": 300,
					"distance": 7100
				},
				{
					"from": "Stolniceni h.",
					"to": "Muncel Hm.",
					"leavesAt": "08:36",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Muncel Hm.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "08:42",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Hălăuceşti hc.",
					"leavesAt": "08:47",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mirceşti",
					"leavesAt": "08:53",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mirceşti",
					"to": "Săbăoani Hm.",
					"leavesAt": "08:58",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Roman",
					"leavesAt": "09:05",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Roman",
					"to": "Ram. Trifeşti",
					"leavesAt": "09:16",
					"arrivesAt": "09:23",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "09:24",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Galbeni",
					"leavesAt": "09:29",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Galbeni",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "09:38",
					"arrivesAt": "09:43",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Iteşti Hm.",
					"leavesAt": "09:44",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Iteşti Hm.",
					"to": "Bacău",
					"leavesAt": "09:50",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1532",
			"segments": [
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "06:00",
					"arrivesAt": "06:30",
					"waitsAtSource": 0,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "06:31",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "06:52",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bratca",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:12",
					"waitsAtSource": 120,
					"distance": 9900
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Ciucea Hm.",
					"leavesAt": "07:16",
					"arrivesAt": "07:26",
					"waitsAtSource": 240,
					"distance": 10800
				},
				{
					"from": "Ciucea Hm.",
					"to": "Huedin",
					"leavesAt": "07:27",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Huedin",
					"to": "Aghireş",
					"leavesAt": "07:55",
					"arrivesAt": "08:18",
					"waitsAtSource": 480,
					"distance": 21500
				},
				{
					"from": "Aghireş",
					"to": "Cluj Napoca",
					"leavesAt": "08:19",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 27900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5405",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "18:45",
					"arrivesAt": "18:52",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "18:53",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "18:58",
					"arrivesAt": "19:04",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "19:05",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "19:09",
					"arrivesAt": "19:21",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Adjud",
					"to": "Adjudu Vechi h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:35",
					"waitsAtSource": 600,
					"distance": 4100
				},
				{
					"from": "Adjudu Vechi h.",
					"to": "Şişcani h.",
					"leavesAt": "19:36",
					"arrivesAt": "19:40",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Şişcani h.",
					"to": "Sascut Hm.",
					"leavesAt": "19:41",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sascut Hm.",
					"to": "Orbeni Hm.",
					"leavesAt": "19:48",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Orbeni Hm.",
					"to": "Răcăciuni h.",
					"leavesAt": "19:56",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Răcăciuni h.",
					"to": "Faraoani Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Faraoani Hm.",
					"to": "Siretu Bacău h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Siretu Bacău h.",
					"to": "Valea Seacă",
					"leavesAt": "20:18",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Valea Seacă",
					"to": "Letea h.",
					"leavesAt": "20:24",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Letea h.",
					"to": "Bacău",
					"leavesAt": "20:31",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9136",
			"segments": [
				{
					"from": "Calafat",
					"to": "Golenţi Hm.",
					"leavesAt": "12:55",
					"arrivesAt": "13:10",
					"waitsAtSource": 0,
					"distance": 11800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1645",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "12:15",
					"arrivesAt": "12:57",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "12:59",
					"arrivesAt": "13:22",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "13:23",
					"arrivesAt": "13:47",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "13:49",
					"arrivesAt": "13:58",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "13:59",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "14:06",
					"arrivesAt": "14:15",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "14:17",
					"arrivesAt": "14:32",
					"waitsAtSource": 120,
					"distance": 9900
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Braşov",
					"leavesAt": "14:33",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 16400
				},
				{
					"from": "Braşov",
					"to": "Sfântu Gheorghe",
					"leavesAt": "15:10",
					"arrivesAt": "15:39",
					"waitsAtSource": 720,
					"distance": 32100
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "15:41",
					"arrivesAt": "16:13",
					"waitsAtSource": 120,
					"distance": 34400
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "16:14",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 28500
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "16:39",
					"arrivesAt": "16:47",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "16:51",
					"arrivesAt": "17:01",
					"waitsAtSource": 240,
					"distance": 7100
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Izvoru Oltului",
					"leavesAt": "17:07",
					"arrivesAt": "17:17",
					"waitsAtSource": 360,
					"distance": 10000
				},
				{
					"from": "Izvoru Oltului",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "17:18",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 10900
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Gheorgheni",
					"leavesAt": "17:30",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Gheorgheni",
					"to": "Topliţa",
					"leavesAt": "17:49",
					"arrivesAt": "18:21",
					"waitsAtSource": 120,
					"distance": 34000
				},
				{
					"from": "Topliţa",
					"to": "Deda",
					"leavesAt": "18:23",
					"arrivesAt": "19:22",
					"waitsAtSource": 120,
					"distance": 43900
				},
				{
					"from": "Deda",
					"to": "Reghin",
					"leavesAt": "19:41",
					"arrivesAt": "20:03",
					"waitsAtSource": 1140,
					"distance": 22000
				},
				{
					"from": "Reghin",
					"to": "Târgu Mureş",
					"leavesAt": "20:10",
					"arrivesAt": "20:45",
					"waitsAtSource": 420,
					"distance": 32300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6312",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "05:01",
					"arrivesAt": "05:08",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Ciurea Hm.",
					"leavesAt": "05:09",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ciurea Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Bârnova Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Grajduri",
					"leavesAt": "05:37",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Grajduri",
					"to": "Scânteia Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:55",
					"waitsAtSource": 240,
					"distance": 6300
				},
				{
					"from": "Scânteia Hm.",
					"to": "Rebricea Hm.",
					"leavesAt": "05:56",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Rebricea Hm.",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Buhăieşti",
					"leavesAt": "06:09",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Buhăieşti",
					"to": "Bârzeşti h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bârzeşti h.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bălteni Hm.",
					"leavesAt": "06:26",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Bălteni Hm.",
					"to": "Vaslui",
					"leavesAt": "06:32",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Vaslui",
					"to": "Munteni Hm.",
					"leavesAt": "06:41",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Munteni Hm.",
					"to": "Bulboaca h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bulboaca h.",
					"to": "Crasna",
					"leavesAt": "06:53",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Crasna",
					"to": "Roşieşti hc.",
					"leavesAt": "07:01",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Roşieşti hc.",
					"to": "Dodeşti hc.",
					"leavesAt": "07:10",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Dodeşti hc.",
					"to": "Banca Hm.",
					"leavesAt": "07:17",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Banca Hm.",
					"to": "Zorleni",
					"leavesAt": "07:24",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Zorleni",
					"to": "Bârlad",
					"leavesAt": "07:35",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bârlad",
					"to": "Dragalina h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:58",
					"waitsAtSource": 360,
					"distance": 8200
				},
				{
					"from": "Dragalina h.",
					"to": "Tutova",
					"leavesAt": "07:59",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Tutova",
					"to": "Ghidigeni Hm.",
					"leavesAt": "08:22",
					"arrivesAt": "08:33",
					"waitsAtSource": 900,
					"distance": 7100
				},
				{
					"from": "Ghidigeni Hm.",
					"to": "Nichişeni",
					"leavesAt": "08:34",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nichişeni",
					"to": "Berheci Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Berheci Hm.",
					"to": "Rateş Munteni h.",
					"leavesAt": "08:50",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Rateş Munteni h.",
					"to": "Frunzeasca Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Frunzeasca Hm.",
					"to": "Tecuci Nord hc.(600)",
					"leavesAt": "09:03",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tecuci Nord hc.(600)",
					"to": "Tecuci",
					"leavesAt": "09:12",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4550",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "22:47",
					"arrivesAt": "22:55",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "22:56",
					"arrivesAt": "23:08",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "23:09",
					"arrivesAt": "23:13",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Periş Mureş h.",
					"leavesAt": "23:14",
					"arrivesAt": "23:19",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Periş Mureş h.",
					"to": "Petelea h.",
					"leavesAt": "23:20",
					"arrivesAt": "23:25",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Petelea h.",
					"to": "Reghin",
					"leavesAt": "23:26",
					"arrivesAt": "23:36",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Reghin",
					"to": "Ideciu de Jos h.",
					"leavesAt": "23:37",
					"arrivesAt": "23:43",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "23:44",
					"arrivesAt": "23:49",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Halta Aluniş h.",
					"leavesAt": "23:50",
					"arrivesAt": "23:54",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "23:55",
					"arrivesAt": "00:00",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Ruşii Munţi h.",
					"leavesAt": "00:01",
					"arrivesAt": "00:04",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Deda",
					"leavesAt": "00:05",
					"arrivesAt": "00:11",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1787",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "14:30",
					"arrivesAt": "15:32",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "15:35",
					"arrivesAt": "15:54",
					"waitsAtSource": 180,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "15:55",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "16:26",
					"arrivesAt": "16:37",
					"waitsAtSource": 420,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7574",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:53",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "17:54",
					"arrivesAt": "18:00",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Şendreni Hm.",
					"leavesAt": "18:01",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Şendreni Hm.",
					"to": "Braniştea h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Braniştea h.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Independenţa Hm.",
					"leavesAt": "18:23",
					"arrivesAt": "18:28",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Independenţa Hm.",
					"to": "Piscu h.",
					"leavesAt": "18:29",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Piscu h.",
					"to": "Vameş h.",
					"leavesAt": "18:36",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Vameş h.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "18:41",
					"arrivesAt": "18:47",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "18:48",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Şerbăneşti h.",
					"leavesAt": "18:54",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Lieşti",
					"leavesAt": "19:00",
					"arrivesAt": "19:03",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lieşti",
					"to": "Buceşti h.",
					"leavesAt": "19:04",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Buceşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "19:08",
					"arrivesAt": "19:12",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Iveşti Hm.",
					"to": "Umbrăreşti h.",
					"leavesAt": "19:13",
					"arrivesAt": "19:17",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Barcea",
					"leavesAt": "19:18",
					"arrivesAt": "19:23",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Barcea",
					"to": "Malul Alb h.",
					"leavesAt": "19:24",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Malul Alb h.",
					"to": "Tecuci",
					"leavesAt": "19:28",
					"arrivesAt": "19:38",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Tecuci",
					"to": "Cosmeşti Hm.",
					"leavesAt": "19:39",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "19:48",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "19:54",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9478",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "19:04",
					"arrivesAt": "19:09",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "19:10",
					"arrivesAt": "19:15",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "19:19",
					"arrivesAt": "19:26",
					"waitsAtSource": 240,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "19:27",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "19:42",
					"arrivesAt": "19:51",
					"waitsAtSource": 540,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "19:52",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "20:01",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Potcoava",
					"to": "Sineşti Hm.",
					"leavesAt": "20:11",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sineşti Hm.",
					"to": "Corbu",
					"leavesAt": "20:19",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Corbu",
					"to": "Hârseşti Hm.",
					"leavesAt": "20:31",
					"arrivesAt": "20:38",
					"waitsAtSource": 240,
					"distance": 5100
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "20:39",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stolnici Hm.",
					"to": "Fâlfani Hm.",
					"leavesAt": "20:46",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Costeşti",
					"leavesAt": "20:56",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Costeşti",
					"to": "Pârvu h.",
					"leavesAt": "21:06",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Pârvu h.",
					"to": "Bradu de Sus",
					"leavesAt": "21:15",
					"arrivesAt": "21:31",
					"waitsAtSource": 30,
					"distance": 9700
				},
				{
					"from": "Bradu de Sus",
					"to": "Km. 109+000 h.",
					"leavesAt": "21:32",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Km. 109+000 h.",
					"to": "Piteşti",
					"leavesAt": "21:37",
					"arrivesAt": "21:39",
					"waitsAtSource": 30,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2089",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "16:20",
					"arrivesAt": "16:23",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "16:24",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "16:28",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "16:33",
					"arrivesAt": "16:36",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "16:41",
					"arrivesAt": "16:45",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "16:51",
					"arrivesAt": "16:56",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "17:01",
					"arrivesAt": "17:06",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Bungeţel h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:20",
					"waitsAtSource": 720,
					"distance": 2300
				},
				{
					"from": "Bungeţel h.",
					"to": "Ţânţăreni Hm.",
					"leavesAt": "17:21",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ţânţăreni Hm.",
					"to": "Floreşti hc.",
					"leavesAt": "17:26",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Floreşti hc.",
					"to": "Gilort Hm.",
					"leavesAt": "17:30",
					"arrivesAt": "17:36",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Gilort Hm.",
					"to": "Turburea Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turburea Hm.",
					"to": "Bibeşti Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Bibeşti Hm.",
					"to": "Musculeşti",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Musculeşti",
					"to": "Bărbăteşti Hm.",
					"leavesAt": "17:59",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Bărbăteşti Hm.",
					"to": "Jupâneşti Hm.",
					"leavesAt": "18:05",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Jupâneşti Hm.",
					"to": "Cărbuneşti",
					"leavesAt": "18:11",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cărbuneşti",
					"to": "Pojogeni Hm.",
					"leavesAt": "18:20",
					"arrivesAt": "18:27",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pojogeni Hm.",
					"to": "Copăcioasa Hm.",
					"leavesAt": "18:28",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Copăcioasa Hm.",
					"to": "Budieni h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Budieni h.",
					"to": "Lunca Budieni Hm.",
					"leavesAt": "18:40",
					"arrivesAt": "18:44",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Lunca Budieni Hm.",
					"to": "Târgu Jiu",
					"leavesAt": "18:45",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Târgu Jiu",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "18:58",
					"arrivesAt": "19:03",
					"waitsAtSource": 300,
					"distance": 4000
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Parângu Hm.",
					"leavesAt": "19:04",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Parângu Hm.",
					"to": "Bumbeşti Hm.",
					"leavesAt": "19:13",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Bumbeşti Hm.",
					"to": "Valea Sadului Hm.",
					"leavesAt": "19:20",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Meri",
					"leavesAt": "19:27",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Meri",
					"to": "Lainici Hm.",
					"leavesAt": "19:36",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Lainici Hm.",
					"to": "Km. 105+600 h.",
					"leavesAt": "19:51",
					"arrivesAt": "19:57",
					"waitsAtSource": 300,
					"distance": 3800
				},
				{
					"from": "Km. 105+600 h.",
					"to": "Pietrele Albe Hm.",
					"leavesAt": "19:58",
					"arrivesAt": "20:03",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pietrele Albe Hm.",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "20:04",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Livezeni",
					"leavesAt": "20:15",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Lunca Jiului hc.",
					"leavesAt": "20:22",
					"arrivesAt": "20:25",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Lunca Jiului hc.",
					"to": "Petroşani",
					"leavesAt": "20:26",
					"arrivesAt": "20:32",
					"waitsAtSource": 30,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2503",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "16:14",
					"arrivesAt": "16:20",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Ghimbav Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ghimbav Hm.",
					"to": "Codlea Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Codlea Hm.",
					"to": "Dumbrăviţa Bârsei Hm.",
					"leavesAt": "16:36",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Dumbrăviţa Bârsei Hm.",
					"to": "Vlădeni Ardeal",
					"leavesAt": "16:46",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vlădeni Ardeal",
					"to": "Valea Homorod h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Valea Homorod h.",
					"to": "Brădet Hm.",
					"leavesAt": "16:59",
					"arrivesAt": "17:09",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Brădet Hm.",
					"to": "Perşani h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:31",
					"waitsAtSource": 780,
					"distance": 5700
				},
				{
					"from": "Perşani h.",
					"to": "Şercaia Hm.",
					"leavesAt": "17:32",
					"arrivesAt": "17:41",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Şercaia Hm.",
					"to": "Şercaia h.",
					"leavesAt": "17:42",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 1200
				},
				{
					"from": "Şercaia h.",
					"to": "Mândra Oltului h.",
					"leavesAt": "17:45",
					"arrivesAt": "17:52",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Mândra Oltului h.",
					"to": "Făgăraş",
					"leavesAt": "17:53",
					"arrivesAt": "17:59",
					"waitsAtSource": 30,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3643",
			"segments": [
				{
					"from": "Huedin",
					"to": "Brăişoru Hm.",
					"leavesAt": "14:41",
					"arrivesAt": "14:49",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Bologa h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bologa h.",
					"to": "Poieni",
					"leavesAt": "14:54",
					"arrivesAt": "14:57",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Poieni",
					"to": "Valea Drăganului h.",
					"leavesAt": "14:58",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Drăganului h.",
					"to": "Ciucea Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:07",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Ciucea Hm.",
					"to": "Negreni h.",
					"leavesAt": "15:08",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Lacu Crişului h.",
					"leavesAt": "15:12",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "15:16",
					"arrivesAt": "15:20",
					"waitsAtSource": 30,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180203",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180604",
					"to": "20180608",
					"daysOfWeek": 799
				},
				{
					"from": "20180611",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180804",
					"to": "20180805",
					"daysOfWeek": 799
				},
				{
					"from": "20180818",
					"to": "20180818",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180901",
					"daysOfWeek": 799
				},
				{
					"from": "20180909",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2856",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Amaradia",
					"leavesAt": "19:00",
					"arrivesAt": "19:06",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Amaradia",
					"to": "Drăguţeşti h.",
					"leavesAt": "19:07",
					"arrivesAt": "19:10",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Drăguţeşti h.",
					"to": "Cârbeşti Hm.",
					"leavesAt": "19:11",
					"arrivesAt": "19:15",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Vârţ h.",
					"leavesAt": "19:16",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Vârţ h.",
					"to": "Rogojelu",
					"leavesAt": "19:21",
					"arrivesAt": "19:25",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Rogojelu",
					"to": "Km. 49+800 h.",
					"leavesAt": "19:26",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rovinari Hm.",
					"leavesAt": "19:30",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Rovinari Hm.",
					"to": "Rovinari Sud h.",
					"leavesAt": "19:34",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rovinari Sud h.",
					"to": "Roşia Jiu h.",
					"leavesAt": "19:37",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Roşia Jiu h.",
					"to": "Vlăduleni Gorj h.",
					"leavesAt": "19:40",
					"arrivesAt": "19:44",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Vlăduleni Gorj h.",
					"to": "Bâlteni h.",
					"leavesAt": "19:45",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Bâlteni h.",
					"to": "Peşteana Jiu h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:52",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Peşteana Jiu h.",
					"to": "Plopşoru",
					"leavesAt": "19:53",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Plopşoru",
					"to": "Sărdăneşti h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Sărdăneşti h.",
					"to": "Gârbovu h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:11",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Gârbovu h.",
					"to": "Turceni",
					"leavesAt": "20:12",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Turceni",
					"to": "Termo Turceni h.",
					"leavesAt": "20:21",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 900
				},
				{
					"from": "Termo Turceni h.",
					"to": "Km. 9+820 h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:26",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Km. 9+820 h.",
					"to": "Ioneşti Gorj h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ioneşti Gorj h.",
					"to": "Filiaşi",
					"leavesAt": "20:32",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 12400
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "20:50",
					"arrivesAt": "20:54",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "20:55",
					"arrivesAt": "20:59",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "21:05",
					"arrivesAt": "21:11",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "21:12",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "21:16",
					"arrivesAt": "21:21",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "21:22",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "21:25",
					"arrivesAt": "21:29",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "21:30",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "21:34",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8384",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "07:45",
					"arrivesAt": "07:51",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "07:52",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Pescăruş h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pescăruş h.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "08:03",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "08:08",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "08:20",
					"arrivesAt": "08:26",
					"waitsAtSource": 480,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "08:27",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "08:34",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "08:49",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20180503",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4442",
			"segments": [
				{
					"from": "Zalău Nord",
					"to": "Guruslău h.",
					"leavesAt": "23:29",
					"arrivesAt": "23:35",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Guruslău h.",
					"to": "Borla Hm.",
					"leavesAt": "23:36",
					"arrivesAt": "23:41",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Borla Hm.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "23:42",
					"arrivesAt": "23:46",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "23:47",
					"arrivesAt": "23:51",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Sărmăşag",
					"leavesAt": "23:52",
					"arrivesAt": "23:59",
					"waitsAtSource": 30,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5482",
			"segments": [
				{
					"from": "Bicaz",
					"to": "Tarcău Neamţ Hm.",
					"leavesAt": "21:57",
					"arrivesAt": "22:04",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Tarcău Neamţ Hm.",
					"to": "Pângăraţi Hm.",
					"leavesAt": "22:05",
					"arrivesAt": "22:15",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Pângăraţi Hm.",
					"to": "Piatra Neamţ",
					"leavesAt": "22:16",
					"arrivesAt": "22:31",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Piatra Neamţ",
					"to": "Roznov",
					"leavesAt": "22:33",
					"arrivesAt": "22:49",
					"waitsAtSource": 120,
					"distance": 15200
				},
				{
					"from": "Roznov",
					"to": "Podoleni Hm.",
					"leavesAt": "22:50",
					"arrivesAt": "23:01",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Podoleni Hm.",
					"to": "Buhuşi",
					"leavesAt": "23:02",
					"arrivesAt": "23:16",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Buhuşi",
					"to": "Gârleni Hm.",
					"leavesAt": "23:17",
					"arrivesAt": "23:29",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Gârleni Hm.",
					"to": "Bacău",
					"leavesAt": "23:30",
					"arrivesAt": "23:48",
					"waitsAtSource": 60,
					"distance": 12800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5734",
			"segments": [
				{
					"from": "Cacica Hm.",
					"to": "Pârteşti h.",
					"leavesAt": "09:50",
					"arrivesAt": "09:57",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Pârteşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "09:58",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Soloneţ h.",
					"to": "Todireşti h.",
					"leavesAt": "10:05",
					"arrivesAt": "10:12",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Todireşti h.",
					"to": "Părhăuţi h.",
					"leavesAt": "10:13",
					"arrivesAt": "10:21",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Părhăuţi h.",
					"to": "Dărmăneşti",
					"leavesAt": "10:22",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "10:31",
					"arrivesAt": "10:38",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "10:39",
					"arrivesAt": "10:44",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1741",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "18:45",
					"arrivesAt": "19:26",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "19:28",
					"arrivesAt": "19:52",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "19:53",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "20:18",
					"arrivesAt": "20:26",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "20:27",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "20:34",
					"arrivesAt": "20:44",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "20:46",
					"arrivesAt": "21:24",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Rupea",
					"leavesAt": "21:32",
					"arrivesAt": "23:07",
					"waitsAtSource": 480,
					"distance": 73800
				},
				{
					"from": "Rupea",
					"to": "Sighişoara",
					"leavesAt": "23:08",
					"arrivesAt": "00:17",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Sighişoara",
					"to": "Dumbrăveni",
					"leavesAt": "00:21",
					"arrivesAt": "00:48",
					"waitsAtSource": 240,
					"distance": 20400
				},
				{
					"from": "Dumbrăveni",
					"to": "Mediaş",
					"leavesAt": "00:49",
					"arrivesAt": "01:15",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Mediaş",
					"to": "Copşa Mică",
					"leavesAt": "01:17",
					"arrivesAt": "01:31",
					"waitsAtSource": 120,
					"distance": 10400
				},
				{
					"from": "Copşa Mică",
					"to": "Blaj",
					"leavesAt": "01:32",
					"arrivesAt": "02:11",
					"waitsAtSource": 60,
					"distance": 30000
				},
				{
					"from": "Blaj",
					"to": "Teiuş",
					"leavesAt": "02:12",
					"arrivesAt": "02:42",
					"waitsAtSource": 60,
					"distance": 21300
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "02:49",
					"arrivesAt": "03:04",
					"waitsAtSource": 420,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Războieni",
					"leavesAt": "03:06",
					"arrivesAt": "03:29",
					"waitsAtSource": 120,
					"distance": 20400
				},
				{
					"from": "Războieni",
					"to": "Câmpia Turzii",
					"leavesAt": "03:31",
					"arrivesAt": "03:47",
					"waitsAtSource": 120,
					"distance": 17100
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cluj Napoca",
					"leavesAt": "03:48",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 51500
				},
				{
					"from": "Cluj Napoca",
					"to": "Aghireş",
					"leavesAt": "05:11",
					"arrivesAt": "05:41",
					"waitsAtSource": 1020,
					"distance": 27900
				},
				{
					"from": "Aghireş",
					"to": "Huedin",
					"leavesAt": "05:42",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Huedin",
					"to": "Ciucea Hm.",
					"leavesAt": "06:13",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Ciucea Hm.",
					"to": "Bratca",
					"leavesAt": "06:36",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Bratca",
					"to": "Aleşd",
					"leavesAt": "07:01",
					"arrivesAt": "07:27",
					"waitsAtSource": 240,
					"distance": 25300
				},
				{
					"from": "Aleşd",
					"to": "Oradea",
					"leavesAt": "07:28",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 34300
				},
				{
					"from": "Oradea",
					"to": "Săcuieni Bihor",
					"leavesAt": "08:11",
					"arrivesAt": "08:54",
					"waitsAtSource": 720,
					"distance": 44200
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Valea lui Mihai",
					"leavesAt": "08:55",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Valea lui Mihai",
					"to": "Carei",
					"leavesAt": "09:15",
					"arrivesAt": "09:39",
					"waitsAtSource": 60,
					"distance": 31200
				},
				{
					"from": "Carei",
					"to": "Satu Mare",
					"leavesAt": "09:40",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 36000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2072",
			"segments": [
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "13:05",
					"arrivesAt": "13:10",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "13:11",
					"arrivesAt": "13:21",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Valea Fratelui h.",
					"leavesAt": "13:22",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Valea Fratelui h.",
					"to": "Râu Vadului h.",
					"leavesAt": "13:33",
					"arrivesAt": "13:37",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Râu Vadului h.",
					"to": "Câineni",
					"leavesAt": "13:38",
					"arrivesAt": "13:48",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Robeşti h.",
					"leavesAt": "13:49",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Robeşti h.",
					"to": "Balota h.",
					"leavesAt": "13:57",
					"arrivesAt": "14:00",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Balota h.",
					"to": "Cornet Hm.",
					"leavesAt": "14:01",
					"arrivesAt": "14:06",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cornet Hm.",
					"to": "Beţel h.",
					"leavesAt": "14:07",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Beţel h.",
					"to": "Lotru",
					"leavesAt": "14:12",
					"arrivesAt": "14:21",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Lotru",
					"to": "Cozia Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cozia Hm.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "14:32",
					"arrivesAt": "14:37",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Păuşa h.",
					"leavesAt": "14:38",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "14:43",
					"arrivesAt": "14:48",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Dăeşti Hm.",
					"leavesAt": "14:49",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "15:06",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "15:12",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Ostroveni h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:22",
					"waitsAtSource": 300,
					"distance": 1000
				},
				{
					"from": "Ostroveni h.",
					"to": "Răstoaca h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:26",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Răstoaca h.",
					"to": "Râureni",
					"leavesAt": "15:27",
					"arrivesAt": "15:29",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Râureni",
					"to": "Râureni hc.",
					"leavesAt": "15:30",
					"arrivesAt": "15:34",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni hc.",
					"to": "Govora",
					"leavesAt": "15:36",
					"arrivesAt": "15:41",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Govora",
					"to": "Tătărani h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Tătărani h.",
					"to": "Băbeni",
					"leavesAt": "15:48",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Băbeni",
					"to": "Slăviteşti hc.",
					"leavesAt": "15:55",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Slăviteşti hc.",
					"to": "Ioneşti Hm.",
					"leavesAt": "16:01",
					"arrivesAt": "16:07",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Ioneşti Hm.",
					"to": "Bucşani Vâlcea h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bucşani Vâlcea h.",
					"to": "Fişcălia Hm.",
					"leavesAt": "16:13",
					"arrivesAt": "16:17",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Fişcălia Hm.",
					"to": "Orleşti hc.",
					"leavesAt": "16:18",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Orleşti hc.",
					"to": "Zăvideni Hm.",
					"leavesAt": "16:22",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Călina h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:40",
					"waitsAtSource": 540,
					"distance": 3800
				},
				{
					"from": "Călina h.",
					"to": "Drăgăşani",
					"leavesAt": "16:41",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Drăgăşani",
					"to": "Zlătărei Hm.",
					"leavesAt": "16:50",
					"arrivesAt": "16:57",
					"waitsAtSource": 120,
					"distance": 6600
				},
				{
					"from": "Zlătărei Hm.",
					"to": "Strejeşti",
					"leavesAt": "16:58",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Strejeşti",
					"to": "Colibaşi h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Colibaşi h.",
					"to": "Arceşti Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Arceşti Hm.",
					"to": "Găneasa Olt h.",
					"leavesAt": "17:19",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Găneasa Olt h.",
					"to": "Găneasa h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:27",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Găneasa h.",
					"to": "Piatra Olt",
					"leavesAt": "17:28",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9162",
			"segments": [
				{
					"from": "Reşiţa Sud Hm.",
					"to": "Reşiţa Nord",
					"leavesAt": "08:45",
					"arrivesAt": "08:54",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Reşiţa Nord",
					"to": "Bănila Câlnic h.",
					"leavesAt": "08:55",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Ezeriş h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:11",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Ezeriş h.",
					"to": "Brebu",
					"leavesAt": "09:12",
					"arrivesAt": "09:24",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Brebu",
					"to": "Valeadeni h.",
					"leavesAt": "09:25",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Valeadeni h.",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "09:31",
					"arrivesAt": "09:38",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Caransebeş",
					"leavesAt": "09:39",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 10400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2087",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "14:25",
					"arrivesAt": "14:29",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "14:30",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "14:34",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "14:39",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "14:47",
					"arrivesAt": "14:50",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "14:51",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "14:56",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "15:05",
					"arrivesAt": "15:10",
					"waitsAtSource": 30,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 288
				},
				{
					"from": "18991230",
					"to": "20180101",
					"daysOfWeek": 288
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4320",
			"segments": [
				{
					"from": "Apa Hm.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "00:35",
					"arrivesAt": "00:44",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Odoreu h.",
					"leavesAt": "00:45",
					"arrivesAt": "00:55",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Odoreu h.",
					"to": "Botiz Hm.",
					"leavesAt": "00:56",
					"arrivesAt": "01:02",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Botiz Hm.",
					"to": "Satu Mare",
					"leavesAt": "01:03",
					"arrivesAt": "01:10",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20180104",
					"to": "20180409",
					"daysOfWeek": 382
				},
				{
					"from": "20180411",
					"to": "20180528",
					"daysOfWeek": 382
				},
				{
					"from": "20180530",
					"to": "20181130",
					"daysOfWeek": 382
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 382
				},
				{
					"from": "20171210",
					"to": "20171225",
					"daysOfWeek": 382
				},
				{
					"from": "20171228",
					"to": "20180101",
					"daysOfWeek": 382
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8583",
			"segments": [
				{
					"from": "Slobozia Veche",
					"to": "Slobozia Sud Hm.",
					"leavesAt": "14:13",
					"arrivesAt": "14:23",
					"waitsAtSource": 0,
					"distance": 4200
				},
				{
					"from": "Slobozia Sud Hm.",
					"to": "Brâncoveni h.",
					"leavesAt": "14:24",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Brâncoveni h.",
					"to": "Ciulniţa",
					"leavesAt": "14:33",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2591",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(203)",
					"leavesAt": "08:42",
					"arrivesAt": "08:46",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "08:47",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "09:03",
					"arrivesAt": "09:08",
					"waitsAtSource": 300,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Mândra h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:17",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Mândra h.",
					"to": "Loamneş Hm.",
					"leavesAt": "09:18",
					"arrivesAt": "09:24",
					"waitsAtSource": 30,
					"distance": 2000
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9361",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "06:52",
					"arrivesAt": "06:57",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Peret hc.",
					"leavesAt": "06:58",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Peret hc.",
					"to": "Plosca Hm.",
					"leavesAt": "07:12",
					"arrivesAt": "07:21",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Plosca Hm.",
					"to": "Buzescu h.",
					"leavesAt": "07:22",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzescu h.",
					"to": "Alexandria Nord h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:43",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Alexandria",
					"leavesAt": "07:44",
					"arrivesAt": "07:50",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4145",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "15:40",
					"arrivesAt": "15:48",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "15:49",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "16:02",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Periş Mureş h.",
					"leavesAt": "16:07",
					"arrivesAt": "16:12",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Periş Mureş h.",
					"to": "Petelea h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Petelea h.",
					"to": "Reghin",
					"leavesAt": "16:19",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Reghin",
					"to": "Ideciu de Jos h.",
					"leavesAt": "16:30",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:42",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Halta Aluniş h.",
					"leavesAt": "16:43",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "16:48",
					"arrivesAt": "16:53",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Ruşii Munţi h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Deda",
					"leavesAt": "16:58",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Deda",
					"to": "Morăreni h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:22",
					"waitsAtSource": 720,
					"distance": 4200
				},
				{
					"from": "Morăreni h.",
					"to": "Râpa de Jos Hm.",
					"leavesAt": "17:23",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râpa de Jos Hm.",
					"to": "Monor Gledin",
					"leavesAt": "17:30",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Monor Gledin",
					"to": "Şieuţ h.",
					"leavesAt": "17:42",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Şieuţ h.",
					"to": "Şieu Hm.",
					"leavesAt": "17:50",
					"arrivesAt": "17:56",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Şieu Hm.",
					"to": "Bârla pe Şieu h.",
					"leavesAt": "17:57",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Bârla pe Şieu h.",
					"to": "Mărişelu Hm.",
					"leavesAt": "18:03",
					"arrivesAt": "18:07",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Mărişelu Hm.",
					"to": "Domneşti pe Şieu h.",
					"leavesAt": "18:08",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Domneşti pe Şieu h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:20",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "18:40",
					"arrivesAt": "18:50",
					"waitsAtSource": 1200,
					"distance": 9800
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "18:51",
					"arrivesAt": "18:54",
					"waitsAtSource": 30,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5637",
			"segments": [
				{
					"from": "Dărmăneşti",
					"to": "Milişăuţi Hm.",
					"leavesAt": "19:57",
					"arrivesAt": "20:08",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Ţibeni h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ţibeni h.",
					"to": "Dorneşti",
					"leavesAt": "20:18",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5568",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "20:14",
					"arrivesAt": "20:19",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "20:20",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "20:30",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Bursuceni h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:57",
					"waitsAtSource": 600,
					"distance": 8100
				},
				{
					"from": "Bursuceni h.",
					"to": "Bucecea Hm",
					"leavesAt": "20:58",
					"arrivesAt": "21:15",
					"waitsAtSource": 30,
					"distance": 11000
				},
				{
					"from": "Bucecea Hm",
					"to": "Leorda Hm.",
					"leavesAt": "21:16",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Leorda Hm.",
					"to": "Botoşani",
					"leavesAt": "21:36",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 15500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2381",
			"segments": [
				{
					"from": "Simeria",
					"to": "Săuleşti h.",
					"leavesAt": "07:17",
					"arrivesAt": "07:22",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Săuleşti h.",
					"to": "Deva",
					"leavesAt": "07:23",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "07:33",
					"arrivesAt": "07:42",
					"waitsAtSource": 120,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Mintia h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Veţel h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Veţel h.",
					"to": "Brănişca Hm.",
					"leavesAt": "07:51",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "07:56",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Ilia",
					"leavesAt": "08:03",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ilia",
					"to": "Gurasada Hm.",
					"leavesAt": "08:12",
					"arrivesAt": "08:19",
					"waitsAtSource": 120,
					"distance": 5800
				},
				{
					"from": "Gurasada Hm.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "08:20",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Burjuc h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Burjuc h.",
					"to": "Zam",
					"leavesAt": "08:35",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Zam",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "08:48",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Ilteu",
					"leavesAt": "08:53",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ilteu",
					"to": "Toc h.",
					"leavesAt": "09:01",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Toc h.",
					"to": "Săvârşin",
					"leavesAt": "09:05",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 7400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1660",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "06:00",
					"arrivesAt": "06:06",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Bârnova Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Buhăieşti",
					"leavesAt": "06:30",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Buhăieşti",
					"to": "Vaslui",
					"leavesAt": "06:53",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Vaslui",
					"to": "Crasna",
					"leavesAt": "07:12",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Crasna",
					"to": "Bârlad",
					"leavesAt": "07:27",
					"arrivesAt": "08:00",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Bârlad",
					"to": "Tutova",
					"leavesAt": "08:01",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Tutova",
					"to": "Tecuci",
					"leavesAt": "08:18",
					"arrivesAt": "08:52",
					"waitsAtSource": 240,
					"distance": 35300
				},
				{
					"from": "Tecuci",
					"to": "Focşani",
					"leavesAt": "09:07",
					"arrivesAt": "09:50",
					"waitsAtSource": 900,
					"distance": 36500
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "09:52",
					"arrivesAt": "10:29",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "10:31",
					"arrivesAt": "11:02",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "11:04",
					"arrivesAt": "11:36",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "11:37",
					"arrivesAt": "12:12",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "12:14",
					"arrivesAt": "13:07",
					"waitsAtSource": 120,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8084",
			"segments": [
				{
					"from": "Bucureşti Obor",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "20:22",
					"arrivesAt": "20:33",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Pantelimon",
					"leavesAt": "20:34",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 600
				},
				{
					"from": "Pantelimon",
					"to": "Bucureşti Băneasa",
					"leavesAt": "20:56",
					"arrivesAt": "21:06",
					"waitsAtSource": 900,
					"distance": 9500
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Bucureşti Nord",
					"leavesAt": "21:07",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 6600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1765",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Târgu Frumos",
					"leavesAt": "15:20",
					"arrivesAt": "15:55",
					"waitsAtSource": 0,
					"distance": 44900
				},
				{
					"from": "Târgu Frumos",
					"to": "Paşcani",
					"leavesAt": "15:56",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 30800
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "16:24",
					"arrivesAt": "16:44",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "16:45",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "17:02",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 14800
				},
				{
					"from": "Suceava",
					"to": "Gura Humorului Oraş",
					"leavesAt": "17:29",
					"arrivesAt": "18:15",
					"waitsAtSource": 900,
					"distance": 46800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "18:18",
					"arrivesAt": "18:26",
					"waitsAtSource": 180,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Vama",
					"leavesAt": "18:27",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Vama",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "18:38",
					"arrivesAt": "18:54",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "18:55",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Pojorâta Hm.",
					"leavesAt": "19:02",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Mestecăniş",
					"leavesAt": "19:13",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Mestecăniş",
					"to": "Iacobeni",
					"leavesAt": "19:35",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Iacobeni",
					"to": "Vatra Dornei",
					"leavesAt": "19:45",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Vatra Dornei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "20:03",
					"arrivesAt": "20:06",
					"waitsAtSource": 120,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Lunca Ilvei",
					"leavesAt": "20:08",
					"arrivesAt": "20:59",
					"waitsAtSource": 120,
					"distance": 42800
				},
				{
					"from": "Lunca Ilvei",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "21:00",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 14300
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Ilva Mică",
					"leavesAt": "21:18",
					"arrivesAt": "21:40",
					"waitsAtSource": 60,
					"distance": 17300
				},
				{
					"from": "Ilva Mică",
					"to": "Năsăud",
					"leavesAt": "21:43",
					"arrivesAt": "22:04",
					"waitsAtSource": 180,
					"distance": 19800
				},
				{
					"from": "Năsăud",
					"to": "Salva",
					"leavesAt": "22:05",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Salva",
					"to": "Beclean pe Someş",
					"leavesAt": "22:13",
					"arrivesAt": "22:35",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Dej Călători",
					"leavesAt": "22:37",
					"arrivesAt": "23:12",
					"waitsAtSource": 120,
					"distance": 24600
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "23:14",
					"arrivesAt": "23:33",
					"waitsAtSource": 120,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Cluj Napoca",
					"leavesAt": "23:35",
					"arrivesAt": "00:27",
					"waitsAtSource": 120,
					"distance": 44900
				},
				{
					"from": "Cluj Napoca",
					"to": "Câmpia Turzii",
					"leavesAt": "00:44",
					"arrivesAt": "01:51",
					"waitsAtSource": 1020,
					"distance": 51500
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "01:52",
					"arrivesAt": "02:07",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Unirea hc.",
					"leavesAt": "02:08",
					"arrivesAt": "02:12",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Unirea hc.",
					"to": "Aiud Hm.",
					"leavesAt": "02:13",
					"arrivesAt": "02:28",
					"waitsAtSource": 30,
					"distance": 16800
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "02:29",
					"arrivesAt": "02:43",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Alba Iulia",
					"leavesAt": "02:47",
					"arrivesAt": "03:22",
					"waitsAtSource": 240,
					"distance": 19100
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "03:23",
					"arrivesAt": "03:35",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Şibot",
					"leavesAt": "03:36",
					"arrivesAt": "03:58",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Şibot",
					"to": "Orăştie",
					"leavesAt": "03:59",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Orăştie",
					"to": "Simeria",
					"leavesAt": "04:19",
					"arrivesAt": "04:43",
					"waitsAtSource": 300,
					"distance": 16500
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "04:51",
					"arrivesAt": "05:02",
					"waitsAtSource": 480,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Ilia",
					"leavesAt": "05:05",
					"arrivesAt": "05:34",
					"waitsAtSource": 180,
					"distance": 23600
				},
				{
					"from": "Ilia",
					"to": "Săvârşin",
					"leavesAt": "05:37",
					"arrivesAt": "06:24",
					"waitsAtSource": 180,
					"distance": 40400
				},
				{
					"from": "Săvârşin",
					"to": "Radna",
					"leavesAt": "06:26",
					"arrivesAt": "07:27",
					"waitsAtSource": 120,
					"distance": 49700
				},
				{
					"from": "Radna",
					"to": "Arad",
					"leavesAt": "07:29",
					"arrivesAt": "08:12",
					"waitsAtSource": 120,
					"distance": 34500
				},
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "08:32",
					"arrivesAt": "08:40",
					"waitsAtSource": 1200,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Timişoara Nord",
					"leavesAt": "08:45",
					"arrivesAt": "09:29",
					"waitsAtSource": 300,
					"distance": 51000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5610",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "15:06",
					"arrivesAt": "15:11",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "15:13",
					"arrivesAt": "15:20",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "15:21",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "15:29",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "15:36",
					"arrivesAt": "15:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "15:43",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "15:49",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "16:05",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "16:17",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "16:31",
					"arrivesAt": "16:45",
					"waitsAtSource": 480,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "16:46",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "17:00",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "17:09",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "17:20",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "17:27",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "17:34",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "17:42",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1661",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "05:48",
					"arrivesAt": "06:33",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Buzău",
					"leavesAt": "06:34",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 68600
				},
				{
					"from": "Buzău",
					"to": "Focşani",
					"leavesAt": "07:44",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 70800
				},
				{
					"from": "Focşani",
					"to": "Tecuci",
					"leavesAt": "08:52",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 36500
				},
				{
					"from": "Tecuci",
					"to": "Bârlad",
					"leavesAt": "09:46",
					"arrivesAt": "10:29",
					"waitsAtSource": 720,
					"distance": 50300
				},
				{
					"from": "Bârlad",
					"to": "Vaslui",
					"leavesAt": "10:30",
					"arrivesAt": "11:08",
					"waitsAtSource": 60,
					"distance": 52100
				},
				{
					"from": "Vaslui",
					"to": "Bârnova Hm.",
					"leavesAt": "11:09",
					"arrivesAt": "11:50",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Iaşi",
					"leavesAt": "11:51",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 18500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1892",
			"segments": [
				{
					"from": "Craiova",
					"to": "Balş",
					"leavesAt": "07:25",
					"arrivesAt": "07:55",
					"waitsAtSource": 0,
					"distance": 31200
				},
				{
					"from": "Balş",
					"to": "Piatra Olt",
					"leavesAt": "07:56",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 12900
				},
				{
					"from": "Piatra Olt",
					"to": "Slatina",
					"leavesAt": "08:09",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Slatina",
					"to": "Stolnici Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "09:12",
					"waitsAtSource": 120,
					"distance": 43300
				},
				{
					"from": "Stolnici Hm.",
					"to": "Costeşti",
					"leavesAt": "09:13",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 15900
				},
				{
					"from": "Costeşti",
					"to": "Piteşti",
					"leavesAt": "09:28",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "10:00",
					"arrivesAt": "10:11",
					"waitsAtSource": 540,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "10:12",
					"arrivesAt": "10:35",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "10:36",
					"arrivesAt": "10:55",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "11:03",
					"arrivesAt": "11:42",
					"waitsAtSource": 480,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5703",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Vest",
					"leavesAt": "16:00",
					"arrivesAt": "16:08",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Suceava Vest",
					"to": "Stroieşti",
					"leavesAt": "16:12",
					"arrivesAt": "16:21",
					"waitsAtSource": 240,
					"distance": 9400
				},
				{
					"from": "Stroieşti",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "16:22",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:41",
					"waitsAtSource": 300,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Gura Humorului Hm.",
					"leavesAt": "16:50",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Gura Humorului Oraş",
					"leavesAt": "17:02",
					"arrivesAt": "17:08",
					"waitsAtSource": 120,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "17:10",
					"arrivesAt": "17:19",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Molid Hm.",
					"leavesAt": "17:21",
					"arrivesAt": "17:28",
					"waitsAtSource": 120,
					"distance": 5800
				},
				{
					"from": "Molid Hm.",
					"to": "Vama",
					"leavesAt": "17:29",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vama",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "17:35",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "17:55",
					"arrivesAt": "18:02",
					"waitsAtSource": 120,
					"distance": 3800
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Sadova Hm.",
					"leavesAt": "18:04",
					"arrivesAt": "18:09",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Sadova Hm.",
					"to": "Pojorâta Hm.",
					"leavesAt": "18:10",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Valea Putnei P.M.",
					"leavesAt": "18:17",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Valea Putnei P.M.",
					"to": "Mestecăniş",
					"leavesAt": "18:30",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Iacobeni",
					"leavesAt": "18:41",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Iacobeni",
					"to": "Argestru Hm.",
					"leavesAt": "18:51",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Argestru Hm.",
					"to": "Vatra Dornei",
					"leavesAt": "19:00",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Vatra Dornei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "19:17",
					"arrivesAt": "19:20",
					"waitsAtSource": 600,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Roşu Hm.",
					"leavesAt": "19:23",
					"arrivesAt": "19:30",
					"waitsAtSource": 180,
					"distance": 4400
				},
				{
					"from": "Roşu Hm.",
					"to": "Dorna Candrenilor h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dorna Candrenilor h.",
					"to": "Floreni",
					"leavesAt": "19:37",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Floreni",
					"to": "Coşna Hm.",
					"leavesAt": "19:45",
					"arrivesAt": "19:54",
					"waitsAtSource": 120,
					"distance": 5700
				},
				{
					"from": "Coşna Hm.",
					"to": "Grădiniţa",
					"leavesAt": "19:55",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Grădiniţa",
					"to": "Larion Hm.",
					"leavesAt": "20:15",
					"arrivesAt": "20:24",
					"waitsAtSource": 540,
					"distance": 5300
				},
				{
					"from": "Larion Hm.",
					"to": "Silhoasa Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Silhoasa Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "20:37",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Lunca Ilvei",
					"to": "Ilva Mare Hm.",
					"leavesAt": "20:46",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Ilva Mare Hm.",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "20:56",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Poiana Ilvei",
					"leavesAt": "21:06",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Poiana Ilvei",
					"to": "Leşu Ilvei Hm.",
					"leavesAt": "21:14",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Leşu Ilvei Hm.",
					"to": "Strâmba h.",
					"leavesAt": "21:23",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Strâmba h.",
					"to": "Ilva Mică",
					"leavesAt": "21:28",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1766",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Aradu Nou",
					"leavesAt": "13:35",
					"arrivesAt": "14:21",
					"waitsAtSource": 0,
					"distance": 51000
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "14:25",
					"arrivesAt": "14:32",
					"waitsAtSource": 240,
					"distance": 6200
				},
				{
					"from": "Arad",
					"to": "Radna",
					"leavesAt": "14:50",
					"arrivesAt": "15:28",
					"waitsAtSource": 1080,
					"distance": 34500
				},
				{
					"from": "Radna",
					"to": "Săvârşin",
					"leavesAt": "15:30",
					"arrivesAt": "16:26",
					"waitsAtSource": 120,
					"distance": 49700
				},
				{
					"from": "Săvârşin",
					"to": "Ilia",
					"leavesAt": "16:27",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Ilia",
					"to": "Deva",
					"leavesAt": "17:15",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 23600
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "17:44",
					"arrivesAt": "17:56",
					"waitsAtSource": 120,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Orăştie",
					"leavesAt": "18:11",
					"arrivesAt": "18:33",
					"waitsAtSource": 900,
					"distance": 16500
				},
				{
					"from": "Orăştie",
					"to": "Şibot",
					"leavesAt": "18:34",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Şibot",
					"to": "Vinţu de Jos",
					"leavesAt": "18:51",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "19:15",
					"arrivesAt": "19:27",
					"waitsAtSource": 120,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Coşlariu",
					"leavesAt": "19:30",
					"arrivesAt": "19:58",
					"waitsAtSource": 180,
					"distance": 15600
				},
				{
					"from": "Coşlariu",
					"to": "Teiuş",
					"leavesAt": "20:04",
					"arrivesAt": "20:12",
					"waitsAtSource": 360,
					"distance": 3500
				},
				{
					"from": "Teiuş",
					"to": "Aiud Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:28",
					"waitsAtSource": 240,
					"distance": 13100
				},
				{
					"from": "Aiud Hm.",
					"to": "Unirea hc.",
					"leavesAt": "20:29",
					"arrivesAt": "20:44",
					"waitsAtSource": 60,
					"distance": 16800
				},
				{
					"from": "Unirea hc.",
					"to": "Războieni",
					"leavesAt": "20:45",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Războieni",
					"to": "Câmpia Turzii",
					"leavesAt": "20:54",
					"arrivesAt": "21:10",
					"waitsAtSource": 120,
					"distance": 17100
				},
				{
					"from": "Câmpia Turzii",
					"to": "Cluj Napoca",
					"leavesAt": "21:11",
					"arrivesAt": "22:17",
					"waitsAtSource": 60,
					"distance": 51500
				},
				{
					"from": "Cluj Napoca",
					"to": "Apahida",
					"leavesAt": "22:30",
					"arrivesAt": "22:47",
					"waitsAtSource": 780,
					"distance": 12300
				},
				{
					"from": "Apahida",
					"to": "Gherla",
					"leavesAt": "22:48",
					"arrivesAt": "23:30",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Gherla",
					"to": "Dej Călători",
					"leavesAt": "23:32",
					"arrivesAt": "23:51",
					"waitsAtSource": 120,
					"distance": 13900
				},
				{
					"from": "Dej Călători",
					"to": "Beclean pe Someş",
					"leavesAt": "23:56",
					"arrivesAt": "00:30",
					"waitsAtSource": 300,
					"distance": 24600
				},
				{
					"from": "Beclean pe Someş",
					"to": "Salva",
					"leavesAt": "00:32",
					"arrivesAt": "00:54",
					"waitsAtSource": 120,
					"distance": 21600
				},
				{
					"from": "Salva",
					"to": "Năsăud",
					"leavesAt": "01:01",
					"arrivesAt": "01:10",
					"waitsAtSource": 420,
					"distance": 6300
				},
				{
					"from": "Năsăud",
					"to": "Ilva Mică",
					"leavesAt": "01:12",
					"arrivesAt": "01:34",
					"waitsAtSource": 120,
					"distance": 19800
				},
				{
					"from": "Ilva Mică",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "01:36",
					"arrivesAt": "01:58",
					"waitsAtSource": 120,
					"distance": 17300
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "01:59",
					"arrivesAt": "02:17",
					"waitsAtSource": 60,
					"distance": 14300
				},
				{
					"from": "Lunca Ilvei",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "02:18",
					"arrivesAt": "03:12",
					"waitsAtSource": 60,
					"distance": 42800
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Vatra Dornei",
					"leavesAt": "03:13",
					"arrivesAt": "03:16",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei",
					"to": "Iacobeni",
					"leavesAt": "03:17",
					"arrivesAt": "03:32",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Iacobeni",
					"to": "Mestecăniş",
					"leavesAt": "03:33",
					"arrivesAt": "03:44",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Pojorâta Hm.",
					"leavesAt": "03:45",
					"arrivesAt": "04:06",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "04:07",
					"arrivesAt": "04:16",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "04:17",
					"arrivesAt": "04:24",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Vama",
					"leavesAt": "04:25",
					"arrivesAt": "04:39",
					"waitsAtSource": 60,
					"distance": 11800
				},
				{
					"from": "Vama",
					"to": "Frasin",
					"leavesAt": "04:40",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 9100
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "04:52",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Suceava",
					"leavesAt": "05:01",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 46800
				},
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "05:58",
					"arrivesAt": "06:11",
					"waitsAtSource": 780,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "06:12",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "06:31",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Târgu Frumos",
					"leavesAt": "06:50",
					"arrivesAt": "07:17",
					"waitsAtSource": 180,
					"distance": 30800
				},
				{
					"from": "Târgu Frumos",
					"to": "Iaşi",
					"leavesAt": "07:19",
					"arrivesAt": "07:54",
					"waitsAtSource": 120,
					"distance": 44900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9447",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:42",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "16:45",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Săteni h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Săteni h.",
					"to": "Doiceşti",
					"leavesAt": "16:51",
					"arrivesAt": "16:54",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Doiceşti",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "16:56",
					"arrivesAt": "17:00",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Trainica h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Trainica h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "17:07",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Moţăieni h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Moţăieni h.",
					"to": "Fieni",
					"leavesAt": "17:16",
					"arrivesAt": "17:21",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Pietroşiţa Hm.",
					"leavesAt": "17:26",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9663",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "07:49",
					"arrivesAt": "07:59",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişeni Hm.",
					"leavesAt": "08:00",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Timişeni Hm.",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "08:09",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Jebel",
					"leavesAt": "08:17",
					"arrivesAt": "08:23",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Jebel",
					"to": "Voiteni",
					"leavesAt": "08:24",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Voiteni",
					"to": "Deta Hm.",
					"leavesAt": "08:37",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Deta Hm.",
					"to": "Denta h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Denta h.",
					"to": "Stamora Moraviţa",
					"leavesAt": "08:53",
					"arrivesAt": "09:02",
					"waitsAtSource": 30,
					"distance": 8400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5103",
			"segments": [
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "05:35",
					"arrivesAt": "05:45",
					"waitsAtSource": 0,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "05:46",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "05:58",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:29",
					"waitsAtSource": 600,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "06:30",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "06:38",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "06:47",
					"arrivesAt": "06:55",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "06:56",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "07:21",
					"waitsAtSource": 120,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "07:22",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 8000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4453",
			"segments": [
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "23:35",
					"arrivesAt": "23:52",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "23:53",
					"arrivesAt": "00:00",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "00:01",
					"arrivesAt": "00:06",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "00:07",
					"arrivesAt": "00:15",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2702",
			"segments": [
				{
					"from": "Simeria",
					"to": "Simeria Triaj",
					"leavesAt": "04:10",
					"arrivesAt": "04:17",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Simeria Triaj",
					"to": "Băcia h.",
					"leavesAt": "04:18",
					"arrivesAt": "04:20",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Băcia h.",
					"to": "Băcia Hm.",
					"leavesAt": "04:21",
					"arrivesAt": "04:23",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Băcia Hm.",
					"to": "Batiz h.",
					"leavesAt": "04:24",
					"arrivesAt": "04:26",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Batiz h.",
					"to": "Călan Băi",
					"leavesAt": "04:27",
					"arrivesAt": "04:29",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Călan Băi",
					"to": "Călan Hm.",
					"leavesAt": "04:30",
					"arrivesAt": "04:34",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Hm.",
					"to": "Ruşi h.",
					"leavesAt": "04:35",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ruşi h.",
					"to": "Măceu h.",
					"leavesAt": "04:39",
					"arrivesAt": "04:41",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Măceu h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "04:42",
					"arrivesAt": "04:47",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Plopi h.",
					"leavesAt": "04:48",
					"arrivesAt": "04:50",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Plopi h.",
					"to": "Covragiu h.",
					"leavesAt": "04:51",
					"arrivesAt": "04:53",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Covragiu h.",
					"to": "Subcetate",
					"leavesAt": "04:54",
					"arrivesAt": "04:58",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Subcetate",
					"to": "Ciopea h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:12",
					"waitsAtSource": 540,
					"distance": 3800
				},
				{
					"from": "Ciopea h.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Băeşti Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ruşor h.",
					"leavesAt": "05:21",
					"arrivesAt": "05:24",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ruşor h.",
					"to": "Pui",
					"leavesAt": "05:25",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Pui",
					"to": "Ponor h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Ponor h.",
					"to": "Livadia h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Livadia h.",
					"to": "Baru Mare",
					"leavesAt": "05:39",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Baru Mare",
					"to": "Baru Mare h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Baru Mare h.",
					"to": "Crivadia Hm.",
					"leavesAt": "05:53",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Crivadia Hm.",
					"to": "Merişor Hm.",
					"leavesAt": "06:01",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Merişor Hm.",
					"to": "Băniţa",
					"leavesAt": "06:11",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băniţa",
					"to": "Peştera Bolii h.",
					"leavesAt": "06:24",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Petroşani Triaj h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Petroşani Triaj h.",
					"to": "Dep Petroşani h.",
					"leavesAt": "06:36",
					"arrivesAt": "06:38",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Petroşani",
					"leavesAt": "06:39",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20180120",
					"to": "20180121",
					"daysOfWeek": 383
				},
				{
					"from": "20180127",
					"to": "20180128",
					"daysOfWeek": 383
				},
				{
					"from": "20180203",
					"to": "20180211",
					"daysOfWeek": 383
				},
				{
					"from": "20180217",
					"to": "20180218",
					"daysOfWeek": 383
				},
				{
					"from": "20180224",
					"to": "20180225",
					"daysOfWeek": 383
				},
				{
					"from": "20180303",
					"to": "20180304",
					"daysOfWeek": 383
				},
				{
					"from": "20180310",
					"to": "20180311",
					"daysOfWeek": 383
				},
				{
					"from": "20180317",
					"to": "20180318",
					"daysOfWeek": 383
				},
				{
					"from": "20180324",
					"to": "20180325",
					"daysOfWeek": 383
				},
				{
					"from": "20180331",
					"to": "20180410",
					"daysOfWeek": 383
				},
				{
					"from": "20180414",
					"to": "20180415",
					"daysOfWeek": 383
				},
				{
					"from": "20180421",
					"to": "20180422",
					"daysOfWeek": 383
				},
				{
					"from": "20180428",
					"to": "20180429",
					"daysOfWeek": 383
				},
				{
					"from": "20180505",
					"to": "20180506",
					"daysOfWeek": 383
				},
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180526",
					"to": "20180527",
					"daysOfWeek": 383
				},
				{
					"from": "20180602",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180610",
					"daysOfWeek": 383
				},
				{
					"from": "20180616",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180922",
					"to": "20180923",
					"daysOfWeek": 383
				},
				{
					"from": "20180929",
					"to": "20180930",
					"daysOfWeek": 383
				},
				{
					"from": "20181006",
					"to": "20181007",
					"daysOfWeek": 383
				},
				{
					"from": "20181013",
					"to": "20181014",
					"daysOfWeek": 383
				},
				{
					"from": "20181020",
					"to": "20181021",
					"daysOfWeek": 383
				},
				{
					"from": "20181027",
					"to": "20181028",
					"daysOfWeek": 383
				},
				{
					"from": "20181103",
					"to": "20181104",
					"daysOfWeek": 383
				},
				{
					"from": "20181110",
					"to": "20181111",
					"daysOfWeek": 383
				},
				{
					"from": "20181117",
					"to": "20181118",
					"daysOfWeek": 383
				},
				{
					"from": "20181124",
					"to": "20181125",
					"daysOfWeek": 383
				},
				{
					"from": "20181201",
					"to": "20181202",
					"daysOfWeek": 383
				},
				{
					"from": "20181208",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 383
				},
				{
					"from": "20171216",
					"to": "20171217",
					"daysOfWeek": 383
				},
				{
					"from": "20171223",
					"to": "20180114",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9384",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(900)",
					"leavesAt": "14:30",
					"arrivesAt": "14:33",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(900)",
					"to": "Banu Mărăcine Hm.",
					"leavesAt": "14:34",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Banu Mărăcine Hm.",
					"to": "Viaductu Cârcea h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Viaductu Cârcea h.",
					"to": "Malu Mare Hm.",
					"leavesAt": "14:44",
					"arrivesAt": "14:48",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Malu Mare Hm.",
					"to": "Pasaju Coşoveni hc.",
					"leavesAt": "14:49",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Pasaju Coşoveni hc.",
					"to": "Leu Hm.",
					"leavesAt": "14:54",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Leu Hm.",
					"to": "Ţărţăl h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ţărţăl h.",
					"to": "Jianca",
					"leavesAt": "15:09",
					"arrivesAt": "15:13",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Jianca",
					"to": "Radomiru hc.",
					"leavesAt": "15:14",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Radomiru hc.",
					"to": "Grozăveşti Hm.",
					"leavesAt": "15:18",
					"arrivesAt": "15:23",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Grozăveşti Hm.",
					"to": "Cezieni h.",
					"leavesAt": "15:24",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Cezieni h.",
					"to": "Caracal",
					"leavesAt": "15:31",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1751",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Brazi",
					"leavesAt": "11:15",
					"arrivesAt": "11:51",
					"waitsAtSource": 0,
					"distance": 51400
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "11:55",
					"arrivesAt": "12:09",
					"waitsAtSource": 240,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "12:11",
					"arrivesAt": "12:44",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "12:45",
					"arrivesAt": "13:20",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "13:22",
					"arrivesAt": "13:53",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "13:54",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "14:34",
					"arrivesAt": "14:56",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "14:57",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "15:25",
					"arrivesAt": "16:02",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "16:11",
					"arrivesAt": "16:40",
					"waitsAtSource": 540,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Paşcani",
					"leavesAt": "16:41",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 40200
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "17:12",
					"arrivesAt": "17:32",
					"waitsAtSource": 120,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "17:33",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "17:58",
					"arrivesAt": "18:10",
					"waitsAtSource": 540,
					"distance": 14800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9363",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "08:15",
					"arrivesAt": "08:20",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Peret hc.",
					"leavesAt": "08:22",
					"arrivesAt": "08:36",
					"waitsAtSource": 120,
					"distance": 10400
				},
				{
					"from": "Peret hc.",
					"to": "Plosca Hm.",
					"leavesAt": "08:37",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Plosca Hm.",
					"to": "Buzescu h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzescu h.",
					"to": "Alexandria Nord h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:08",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Alexandria",
					"leavesAt": "09:09",
					"arrivesAt": "09:15",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1732",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Barboşi",
					"leavesAt": "06:45",
					"arrivesAt": "07:04",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Barboşi",
					"to": "Brăila",
					"leavesAt": "07:05",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 19500
				},
				{
					"from": "Brăila",
					"to": "Ianca hc.",
					"leavesAt": "07:24",
					"arrivesAt": "07:54",
					"waitsAtSource": 120,
					"distance": 42400
				},
				{
					"from": "Ianca hc.",
					"to": "Făurei",
					"leavesAt": "07:55",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Făurei",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "08:15",
					"arrivesAt": "08:27",
					"waitsAtSource": 180,
					"distance": 10000
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Buzău",
					"leavesAt": "08:31",
					"arrivesAt": "09:01",
					"waitsAtSource": 240,
					"distance": 30400
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "09:04",
					"arrivesAt": "09:36",
					"waitsAtSource": 180,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "09:38",
					"arrivesAt": "10:14",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "10:17",
					"arrivesAt": "10:22",
					"waitsAtSource": 180,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "10:24",
					"arrivesAt": "10:49",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "10:51",
					"arrivesAt": "11:15",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "11:17",
					"arrivesAt": "11:24",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "11:25",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "11:31",
					"arrivesAt": "11:40",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "11:42",
					"arrivesAt": "12:20",
					"waitsAtSource": 120,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1531",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Huedin",
					"leavesAt": "05:45",
					"arrivesAt": "06:35",
					"waitsAtSource": 0,
					"distance": 49400
				},
				{
					"from": "Huedin",
					"to": "Ciucea Hm.",
					"leavesAt": "06:36",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Ciucea Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "07:05",
					"arrivesAt": "07:15",
					"waitsAtSource": 420,
					"distance": 10800
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bratca",
					"leavesAt": "07:17",
					"arrivesAt": "07:28",
					"waitsAtSource": 120,
					"distance": 9900
				},
				{
					"from": "Bratca",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "07:29",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Aleşd",
					"leavesAt": "07:38",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Aleşd",
					"to": "Oradea",
					"leavesAt": "07:58",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 34300
				},
				{
					"from": "Oradea",
					"to": "Salonta",
					"leavesAt": "08:30",
					"arrivesAt": "09:10",
					"waitsAtSource": 120,
					"distance": 39200
				},
				{
					"from": "Salonta",
					"to": "Chişineu Criş",
					"leavesAt": "09:16",
					"arrivesAt": "09:54",
					"waitsAtSource": 360,
					"distance": 33900
				},
				{
					"from": "Chişineu Criş",
					"to": "Nădab",
					"leavesAt": "09:56",
					"arrivesAt": "10:02",
					"waitsAtSource": 120,
					"distance": 4900
				},
				{
					"from": "Nădab",
					"to": "Sântana",
					"leavesAt": "10:03",
					"arrivesAt": "10:20",
					"waitsAtSource": 60,
					"distance": 19100
				},
				{
					"from": "Sântana",
					"to": "Arad",
					"leavesAt": "10:22",
					"arrivesAt": "10:47",
					"waitsAtSource": 120,
					"distance": 23500
				},
				{
					"from": "Arad",
					"to": "Timişoara Nord",
					"leavesAt": "10:50",
					"arrivesAt": "11:38",
					"waitsAtSource": 180,
					"distance": 57200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1923",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Tălmaciu Hm.",
					"leavesAt": "18:35",
					"arrivesAt": "19:00",
					"waitsAtSource": 0,
					"distance": 17800
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "19:02",
					"arrivesAt": "19:09",
					"waitsAtSource": 120,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "19:10",
					"arrivesAt": "19:16",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "19:18",
					"arrivesAt": "19:28",
					"waitsAtSource": 120,
					"distance": 6400
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Câineni",
					"leavesAt": "19:37",
					"arrivesAt": "20:00",
					"waitsAtSource": 540,
					"distance": 15200
				},
				{
					"from": "Câineni",
					"to": "Lotru",
					"leavesAt": "20:01",
					"arrivesAt": "20:25",
					"waitsAtSource": 60,
					"distance": 21100
				},
				{
					"from": "Lotru",
					"to": "Păuşa h.",
					"leavesAt": "20:26",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 11500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "20:42",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "20:48",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 16200
				},
				{
					"from": "Râmnicu Vâlcea",
					"to": "Govora",
					"leavesAt": "21:10",
					"arrivesAt": "21:20",
					"waitsAtSource": 240,
					"distance": 11400
				},
				{
					"from": "Govora",
					"to": "Băbeni",
					"leavesAt": "21:21",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Băbeni",
					"to": "Zăvideni Hm.",
					"leavesAt": "21:31",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 23000
				},
				{
					"from": "Zăvideni Hm.",
					"to": "Drăgăşani",
					"leavesAt": "21:56",
					"arrivesAt": "22:04",
					"waitsAtSource": 480,
					"distance": 10200
				},
				{
					"from": "Drăgăşani",
					"to": "Piatra Olt",
					"leavesAt": "22:06",
					"arrivesAt": "22:35",
					"waitsAtSource": 120,
					"distance": 33800
				},
				{
					"from": "Piatra Olt",
					"to": "Slatina",
					"leavesAt": "22:55",
					"arrivesAt": "23:14",
					"waitsAtSource": 1200,
					"distance": 17000
				},
				{
					"from": "Slatina",
					"to": "Stolnici Hm.",
					"leavesAt": "23:17",
					"arrivesAt": "23:57",
					"waitsAtSource": 180,
					"distance": 43300
				},
				{
					"from": "Stolnici Hm.",
					"to": "Costeşti",
					"leavesAt": "23:58",
					"arrivesAt": "00:13",
					"waitsAtSource": 60,
					"distance": 15900
				},
				{
					"from": "Costeşti",
					"to": "Piteşti",
					"leavesAt": "00:19",
					"arrivesAt": "00:45",
					"waitsAtSource": 360,
					"distance": 21800
				},
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "01:10",
					"arrivesAt": "01:21",
					"waitsAtSource": 1500,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "01:22",
					"arrivesAt": "01:43",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "01:45",
					"arrivesAt": "02:04",
					"waitsAtSource": 120,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "02:06",
					"arrivesAt": "02:46",
					"waitsAtSource": 120,
					"distance": 48000
				},
				{
					"from": "Bucureşti Nord",
					"to": "Feteşti",
					"leavesAt": "03:15",
					"arrivesAt": "04:46",
					"waitsAtSource": 1740,
					"distance": 146400
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "04:47",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "05:08",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "05:26",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 36000
				},
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "06:15",
					"arrivesAt": "06:26",
					"waitsAtSource": 960,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "06:35",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "06:46",
					"arrivesAt": "06:53",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "06:55",
					"arrivesAt": "07:04",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "07:05",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "07:21",
					"arrivesAt": "07:25",
					"waitsAtSource": 480,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Pescăruş h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:33",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Pescăruş h.",
					"to": "Neptun hc.",
					"leavesAt": "07:34",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "07:43",
					"arrivesAt": "07:48",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "07:49",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1581",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Constanţa",
					"leavesAt": "07:30",
					"arrivesAt": "09:30",
					"waitsAtSource": 0,
					"distance": 225000
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1888",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Nucet",
					"leavesAt": "17:32",
					"arrivesAt": "17:44",
					"waitsAtSource": 0,
					"distance": 16300
				},
				{
					"from": "Nucet",
					"to": "Titu",
					"leavesAt": "17:45",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 15400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9612",
			"segments": [
				{
					"from": "Buziaş",
					"to": "Bacova h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:03",
					"waitsAtSource": 0,
					"distance": 2300
				},
				{
					"from": "Bacova h.",
					"to": "Chevereş h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Chevereş h.",
					"to": "Sacoşu Mic",
					"leavesAt": "06:10",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Sacoşu Mic",
					"to": "Uliuc h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Uliuc h.",
					"to": "Urseni h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:28",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Urseni h.",
					"to": "Semenic Hm.",
					"leavesAt": "06:29",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Semenic Hm.",
					"to": "Giroc h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:46",
					"waitsAtSource": 600,
					"distance": 2100
				},
				{
					"from": "Giroc h.",
					"to": "Timişoara Sud",
					"leavesAt": "06:47",
					"arrivesAt": "06:53",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "06:54",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180107",
					"daysOfWeek": 799
				},
				{
					"from": "20180113",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180407",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2185",
			"segments": [
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "14:59",
					"arrivesAt": "15:12",
					"waitsAtSource": 0,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "15:13",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Mintia h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:25",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mintia h.",
					"to": "Veţel h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:28",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Veţel h.",
					"to": "Brănişca Hm.",
					"leavesAt": "15:29",
					"arrivesAt": "15:33",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "15:34",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Ilia",
					"leavesAt": "15:41",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ilia",
					"to": "Dobra Hm.",
					"leavesAt": "15:49",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dobra Hm.",
					"to": "Lăpugiu h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Lăpugiu h.",
					"to": "Ohaba hc.",
					"leavesAt": "16:05",
					"arrivesAt": "16:11",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Ohaba hc.",
					"to": "Holdea Hm.",
					"leavesAt": "16:12",
					"arrivesAt": "16:17",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Holdea Hm.",
					"to": "Coşteiu h.",
					"leavesAt": "16:18",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Coşteiu h.",
					"to": "Nemeşeşti h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Nemeşeşti h.",
					"to": "Margina",
					"leavesAt": "16:28",
					"arrivesAt": "16:38",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Margina",
					"to": "Făget",
					"leavesAt": "16:55",
					"arrivesAt": "17:02",
					"waitsAtSource": 1020,
					"distance": 7600
				},
				{
					"from": "Făget",
					"to": "Răchita h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Răchita h.",
					"to": "Mănăştur Hm.",
					"leavesAt": "17:08",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Mănăştur Hm.",
					"to": "Traian Vuia h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Traian Vuia h.",
					"to": "Susani Bega h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:19",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Susani Bega h.",
					"to": "Cliciova",
					"leavesAt": "17:20",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Cliciova",
					"to": "Nevrincea h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:42",
					"waitsAtSource": 840,
					"distance": 4400
				},
				{
					"from": "Nevrincea h.",
					"to": "Balinţ h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Balinţ h.",
					"to": "Păru h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Păru h.",
					"to": "Coşteiu Mare Hm.",
					"leavesAt": "17:52",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Coşteiu Mare Hm.",
					"to": "Lugoj Nord h.",
					"leavesAt": "17:56",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Lugoj Nord h.",
					"to": "Lugoj",
					"leavesAt": "18:02",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "461",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "12:45",
					"arrivesAt": "13:38",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Giurgiu Nord",
					"leavesAt": "13:39",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 63000
				},
				{
					"from": "Giurgiu Nord",
					"to": "Ruse",
					"leavesAt": "15:10",
					"arrivesAt": "15:35",
					"waitsAtSource": 1380,
					"distance": 16000
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181001",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3624",
			"segments": [
				{
					"from": "Huedin",
					"to": "Jebuc h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:08",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Jebuc h.",
					"to": "Stana Hm.",
					"leavesAt": "08:09",
					"arrivesAt": "08:17",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Stana Hm.",
					"to": "Gălăşeni h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Gălăşeni h.",
					"to": "Aghireş h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "08:30",
					"arrivesAt": "08:34",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Dorolţu h.",
					"leavesAt": "08:35",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Dorolţu h.",
					"to": "Macău h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:40",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Macău h.",
					"to": "Gârbău Hm.",
					"leavesAt": "08:41",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Gârbău Hm.",
					"to": "Nădăşel h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Nădăşel h.",
					"to": "Mera Hm.",
					"leavesAt": "08:54",
					"arrivesAt": "08:57",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mera Hm.",
					"to": "Rădaia h.",
					"leavesAt": "08:58",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Rădaia h.",
					"to": "Suceag h.",
					"leavesAt": "09:01",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Suceag h.",
					"to": "Baciu Triaj Hm.",
					"leavesAt": "09:04",
					"arrivesAt": "09:09",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Baciu Triaj Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "09:10",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 799
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2705",
			"segments": [
				{
					"from": "Petroşani",
					"to": "Dep Petroşani h.",
					"leavesAt": "07:35",
					"arrivesAt": "07:38",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Petroşani Triaj h.",
					"leavesAt": "07:39",
					"arrivesAt": "07:41",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Petroşani Triaj h.",
					"to": "Peştera Bolii h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Băniţa",
					"leavesAt": "07:47",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Băniţa",
					"to": "Merişor Hm.",
					"leavesAt": "07:56",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Merişor Hm.",
					"to": "Crivadia Hm.",
					"leavesAt": "08:08",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Crivadia Hm.",
					"to": "Baru Mare h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Baru Mare h.",
					"to": "Baru Mare",
					"leavesAt": "08:25",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Baru Mare",
					"to": "Livadia h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Livadia h.",
					"to": "Ponor h.",
					"leavesAt": "08:36",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ponor h.",
					"to": "Pui",
					"leavesAt": "08:39",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Pui",
					"to": "Ruşor h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:56",
					"waitsAtSource": 480,
					"distance": 4800
				},
				{
					"from": "Ruşor h.",
					"to": "Băeşti Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:00",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ohaba de sub Piatră h.",
					"leavesAt": "09:01",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ohaba de sub Piatră h.",
					"to": "Ciopea h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:07",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ciopea h.",
					"to": "Subcetate",
					"leavesAt": "09:08",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Subcetate",
					"to": "Covragiu h.",
					"leavesAt": "09:13",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Covragiu h.",
					"to": "Plopi h.",
					"leavesAt": "09:17",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Plopi h.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "09:20",
					"arrivesAt": "09:22",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Măceu h.",
					"leavesAt": "09:23",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măceu h.",
					"to": "Ruşi h.",
					"leavesAt": "09:27",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ruşi h.",
					"to": "Călan Hm.",
					"leavesAt": "09:30",
					"arrivesAt": "09:40",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Călan Hm.",
					"to": "Călan Băi",
					"leavesAt": "09:41",
					"arrivesAt": "09:45",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Băi",
					"to": "Batiz h.",
					"leavesAt": "09:46",
					"arrivesAt": "09:48",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Batiz h.",
					"to": "Băcia Hm.",
					"leavesAt": "09:49",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Băcia Hm.",
					"to": "Băcia h.",
					"leavesAt": "09:52",
					"arrivesAt": "09:54",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Băcia h.",
					"to": "Simeria Triaj",
					"leavesAt": "09:55",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Simeria Triaj",
					"to": "Simeria",
					"leavesAt": "09:59",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Simeria",
					"to": "Săuleşti h.",
					"leavesAt": "10:20",
					"arrivesAt": "10:24",
					"waitsAtSource": 840,
					"distance": 3300
				},
				{
					"from": "Săuleşti h.",
					"to": "Deva",
					"leavesAt": "10:25",
					"arrivesAt": "10:32",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Deva",
					"to": "Mintia",
					"leavesAt": "10:33",
					"arrivesAt": "10:42",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Mintia",
					"to": "Veţel h.",
					"leavesAt": "10:43",
					"arrivesAt": "10:47",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Veţel h.",
					"to": "Brănişca Hm.",
					"leavesAt": "10:48",
					"arrivesAt": "10:52",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Brănişca Hm.",
					"to": "Bretea Mureşeană h.",
					"leavesAt": "10:53",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bretea Mureşeană h.",
					"to": "Ilia",
					"leavesAt": "11:00",
					"arrivesAt": "11:07",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ilia",
					"to": "Gurasada Hm.",
					"leavesAt": "11:08",
					"arrivesAt": "11:15",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Gurasada Hm.",
					"to": "Câmpuri Surduc Hm.",
					"leavesAt": "11:16",
					"arrivesAt": "11:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Câmpuri Surduc Hm.",
					"to": "Burjuc h.",
					"leavesAt": "11:24",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Burjuc h.",
					"to": "Zam",
					"leavesAt": "11:30",
					"arrivesAt": "11:42",
					"waitsAtSource": 30,
					"distance": 8500
				},
				{
					"from": "Zam",
					"to": "Petriş pe Mureş h.",
					"leavesAt": "11:43",
					"arrivesAt": "11:47",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Petriş pe Mureş h.",
					"to": "Ilteu",
					"leavesAt": "11:48",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ilteu",
					"to": "Toc h.",
					"leavesAt": "11:56",
					"arrivesAt": "11:59",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Toc h.",
					"to": "Săvârşin",
					"leavesAt": "12:00",
					"arrivesAt": "12:07",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Săvârşin",
					"to": "Vărădia h.",
					"leavesAt": "12:08",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vărădia h.",
					"to": "Vărădia Hm.",
					"leavesAt": "12:15",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărădia Hm.",
					"to": "Valea Mureşului h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:25",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Valea Mureşului h.",
					"to": "Bătuţa Hm.",
					"leavesAt": "12:26",
					"arrivesAt": "12:33",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Bătuţa Hm.",
					"to": "Căpruţa h.",
					"leavesAt": "12:34",
					"arrivesAt": "12:38",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Căpruţa h.",
					"to": "Bârzava",
					"leavesAt": "12:39",
					"arrivesAt": "12:44",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Bârzava",
					"to": "Conop Hm.",
					"leavesAt": "12:45",
					"arrivesAt": "12:56",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Conop Hm.",
					"to": "Corfeni h.",
					"leavesAt": "12:57",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Corfeni h.",
					"to": "Milova",
					"leavesAt": "13:02",
					"arrivesAt": "13:08",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Milova",
					"to": "Radna",
					"leavesAt": "13:09",
					"arrivesAt": "13:20",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Radna",
					"to": "Păuliş Hm.",
					"leavesAt": "13:21",
					"arrivesAt": "13:29",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Păuliş Hm.",
					"to": "Păuliş h.",
					"leavesAt": "13:30",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Păuliş h.",
					"to": "Ghioroc",
					"leavesAt": "13:35",
					"arrivesAt": "13:42",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ghioroc",
					"to": "Glogovăţ",
					"leavesAt": "13:43",
					"arrivesAt": "13:54",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Glogovăţ",
					"to": "Arad",
					"leavesAt": "13:55",
					"arrivesAt": "14:03",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1797",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "05:30",
					"arrivesAt": "06:21",
					"waitsAtSource": 0,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "06:22",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Caracal",
					"leavesAt": "07:10",
					"arrivesAt": "07:57",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "07:58",
					"arrivesAt": "08:38",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Filiaşi",
					"leavesAt": "08:45",
					"arrivesAt": "09:11",
					"waitsAtSource": 420,
					"distance": 35800
				},
				{
					"from": "Filiaşi",
					"to": "Strehaia hc.",
					"leavesAt": "09:12",
					"arrivesAt": "09:35",
					"waitsAtSource": 60,
					"distance": 26300
				},
				{
					"from": "Strehaia hc.",
					"to": "Balota",
					"leavesAt": "09:36",
					"arrivesAt": "10:11",
					"waitsAtSource": 60,
					"distance": 32600
				},
				{
					"from": "Balota",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "10:12",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Orşova",
					"leavesAt": "10:47",
					"arrivesAt": "11:18",
					"waitsAtSource": 120,
					"distance": 24000
				},
				{
					"from": "Orşova",
					"to": "Băile Herculane",
					"leavesAt": "11:19",
					"arrivesAt": "11:38",
					"waitsAtSource": 60,
					"distance": 17500
				},
				{
					"from": "Băile Herculane",
					"to": "Caransebeş",
					"leavesAt": "11:40",
					"arrivesAt": "13:02",
					"waitsAtSource": 120,
					"distance": 70800
				},
				{
					"from": "Caransebeş",
					"to": "Lugoj",
					"leavesAt": "13:03",
					"arrivesAt": "13:36",
					"waitsAtSource": 60,
					"distance": 39400
				},
				{
					"from": "Lugoj",
					"to": "Timişoara Nord",
					"leavesAt": "13:37",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1634",
			"segments": [
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "14:15",
					"arrivesAt": "14:50",
					"waitsAtSource": 0,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "14:52",
					"arrivesAt": "15:01",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "15:02",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "15:09",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Comarnic",
					"leavesAt": "15:19",
					"arrivesAt": "15:33",
					"waitsAtSource": 120,
					"distance": 15100
				},
				{
					"from": "Comarnic",
					"to": "Breaza hc.",
					"leavesAt": "15:34",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "15:42",
					"arrivesAt": "15:47",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "15:48",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Ploieşti Vest",
					"leavesAt": "15:59",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 18600
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buftea",
					"leavesAt": "16:16",
					"arrivesAt": "16:44",
					"waitsAtSource": 180,
					"distance": 42000
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "16:45",
					"arrivesAt": "17:03",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9434",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "09:40",
					"arrivesAt": "09:47",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "09:48",
					"arrivesAt": "09:53",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "09:54",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "09:59",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "10:03",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Podu Rizii h.",
					"leavesAt": "10:08",
					"arrivesAt": "10:12",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Podu Rizii h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "10:13",
					"arrivesAt": "10:17",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "10:18",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4541",
			"segments": [
				{
					"from": "Deda",
					"to": "Ruşii Munţi h.",
					"leavesAt": "04:17",
					"arrivesAt": "04:23",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "04:24",
					"arrivesAt": "04:27",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Halta Aluniş h.",
					"leavesAt": "04:28",
					"arrivesAt": "04:32",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "04:33",
					"arrivesAt": "04:36",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Ideciu de Jos h.",
					"leavesAt": "04:37",
					"arrivesAt": "04:42",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Reghin",
					"leavesAt": "04:43",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Reghin",
					"to": "Petelea h.",
					"leavesAt": "04:54",
					"arrivesAt": "05:01",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Petelea h.",
					"to": "Periş Mureş h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:07",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Periş Mureş h.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:13",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "05:14",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "05:20",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Târgu Mureş",
					"leavesAt": "05:33",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4071",
			"segments": [
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "15:56",
					"arrivesAt": "16:12",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:24",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "16:25",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20180120",
					"to": "20180121",
					"daysOfWeek": 383
				},
				{
					"from": "20180124",
					"to": "20180124",
					"daysOfWeek": 383
				},
				{
					"from": "20180127",
					"to": "20180128",
					"daysOfWeek": 383
				},
				{
					"from": "20180203",
					"to": "20180211",
					"daysOfWeek": 383
				},
				{
					"from": "20180217",
					"to": "20180218",
					"daysOfWeek": 383
				},
				{
					"from": "20180224",
					"to": "20180225",
					"daysOfWeek": 383
				},
				{
					"from": "20180303",
					"to": "20180304",
					"daysOfWeek": 383
				},
				{
					"from": "20180310",
					"to": "20180311",
					"daysOfWeek": 383
				},
				{
					"from": "20180317",
					"to": "20180318",
					"daysOfWeek": 383
				},
				{
					"from": "20180324",
					"to": "20180325",
					"daysOfWeek": 383
				},
				{
					"from": "20180331",
					"to": "20180410",
					"daysOfWeek": 383
				},
				{
					"from": "20180414",
					"to": "20180415",
					"daysOfWeek": 383
				},
				{
					"from": "20180421",
					"to": "20180422",
					"daysOfWeek": 383
				},
				{
					"from": "20180428",
					"to": "20180429",
					"daysOfWeek": 383
				},
				{
					"from": "20180501",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180505",
					"to": "20180506",
					"daysOfWeek": 383
				},
				{
					"from": "20180512",
					"to": "20180513",
					"daysOfWeek": 383
				},
				{
					"from": "20180519",
					"to": "20180520",
					"daysOfWeek": 383
				},
				{
					"from": "20180526",
					"to": "20180528",
					"daysOfWeek": 383
				},
				{
					"from": "20180601",
					"to": "20180603",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180610",
					"daysOfWeek": 383
				},
				{
					"from": "20180616",
					"to": "20180909",
					"daysOfWeek": 383
				},
				{
					"from": "20180915",
					"to": "20180916",
					"daysOfWeek": 383
				},
				{
					"from": "20180922",
					"to": "20180923",
					"daysOfWeek": 383
				},
				{
					"from": "20180929",
					"to": "20180930",
					"daysOfWeek": 383
				},
				{
					"from": "20181006",
					"to": "20181007",
					"daysOfWeek": 383
				},
				{
					"from": "20181013",
					"to": "20181014",
					"daysOfWeek": 383
				},
				{
					"from": "20181020",
					"to": "20181021",
					"daysOfWeek": 383
				},
				{
					"from": "20181027",
					"to": "20181028",
					"daysOfWeek": 383
				},
				{
					"from": "20181103",
					"to": "20181104",
					"daysOfWeek": 383
				},
				{
					"from": "20181110",
					"to": "20181111",
					"daysOfWeek": 383
				},
				{
					"from": "20181117",
					"to": "20181118",
					"daysOfWeek": 383
				},
				{
					"from": "20181124",
					"to": "20181125",
					"daysOfWeek": 383
				},
				{
					"from": "20181130",
					"to": "20181202",
					"daysOfWeek": 383
				},
				{
					"from": "20181208",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171210",
					"daysOfWeek": 383
				},
				{
					"from": "20171216",
					"to": "20171217",
					"daysOfWeek": 383
				},
				{
					"from": "20171223",
					"to": "20180114",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2613",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Sânandrei Hm.",
					"leavesAt": "23:26",
					"arrivesAt": "23:42",
					"waitsAtSource": 0,
					"distance": 13300
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Băile Călacea",
					"leavesAt": "23:43",
					"arrivesAt": "23:49",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Călacea",
					"to": "Orţişoara",
					"leavesAt": "23:50",
					"arrivesAt": "23:55",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Orţişoara",
					"to": "Vinga Hm.",
					"leavesAt": "23:56",
					"arrivesAt": "00:01",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "00:07",
					"arrivesAt": "00:13",
					"waitsAtSource": 360,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Aradu Nou",
					"leavesAt": "00:14",
					"arrivesAt": "00:28",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "00:29",
					"arrivesAt": "00:36",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8377",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "19:36",
					"arrivesAt": "19:47",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "19:48",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "19:56",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "20:14",
					"arrivesAt": "20:21",
					"waitsAtSource": 540,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:32",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "20:33",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "20:51",
					"arrivesAt": "20:55",
					"waitsAtSource": 600,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "20:57",
					"arrivesAt": "21:10",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "21:12",
					"arrivesAt": "21:22",
					"waitsAtSource": 120,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180529",
					"to": "20180529",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5057",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "16:00",
					"arrivesAt": "16:05",
					"waitsAtSource": 0,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "16:06",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Muru hc.",
					"leavesAt": "16:16",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:25",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "16:26",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "16:32",
					"arrivesAt": "16:37",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "16:38",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "17:05",
					"arrivesAt": "17:12",
					"waitsAtSource": 540,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "17:13",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "17:19",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "17:25",
					"arrivesAt": "17:37",
					"waitsAtSource": 30,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1583",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ciulniţa",
					"leavesAt": "09:30",
					"arrivesAt": "10:25",
					"waitsAtSource": 0,
					"distance": 108900
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "10:26",
					"arrivesAt": "10:48",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "10:50",
					"arrivesAt": "11:10",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "11:11",
					"arrivesAt": "11:27",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "11:28",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 34600
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180608",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9433",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Depoul Buc.Triaj h.(300)",
					"leavesAt": "04:20",
					"arrivesAt": "04:28",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Depoul Buc.Triaj h.(300)",
					"to": "Chitila",
					"leavesAt": "04:29",
					"arrivesAt": "04:32",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "04:33",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "04:43",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "04:56",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "05:07",
					"arrivesAt": "05:16",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:24",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "05:30",
					"arrivesAt": "05:37",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "05:39",
					"arrivesAt": "05:43",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Podu Rizii h.",
					"leavesAt": "05:44",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Podu Rizii h.",
					"to": "Băneşti h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "05:59",
					"arrivesAt": "06:02",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:07",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "06:14",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5071",
			"segments": [
				{
					"from": "Brazi",
					"to": "Ploieşti Triaj",
					"leavesAt": "07:28",
					"arrivesAt": "07:35",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Ploieşti Sud",
					"leavesAt": "07:39",
					"arrivesAt": "07:46",
					"waitsAtSource": 240,
					"distance": 3600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "07:56",
					"arrivesAt": "08:02",
					"waitsAtSource": 600,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "08:03",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Muru hc.",
					"leavesAt": "08:13",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "08:18",
					"arrivesAt": "08:22",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "08:30",
					"arrivesAt": "08:35",
					"waitsAtSource": 480,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "08:36",
					"arrivesAt": "08:42",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "08:43",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "08:52",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "09:04",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "09:12",
					"arrivesAt": "09:17",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "09:18",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "09:24",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9482",
			"segments": [
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "13:50",
					"arrivesAt": "13:56",
					"waitsAtSource": 0,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "13:57",
					"arrivesAt": "14:03",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "14:04",
					"arrivesAt": "14:12",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "14:13",
					"arrivesAt": "14:20",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "14:22",
					"arrivesAt": "14:32",
					"waitsAtSource": 120,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "14:33",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "14:43",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 256
				},
				{
					"from": "18991230",
					"to": "20180803",
					"daysOfWeek": 256
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4141",
			"segments": [
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "02:24",
					"arrivesAt": "02:32",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Târgu Mureş Nord Hm.",
					"to": "Dumbrăvioara Hm.",
					"leavesAt": "02:33",
					"arrivesAt": "02:45",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Dumbrăvioara Hm.",
					"to": "Gorneşti Mureş h.",
					"leavesAt": "02:46",
					"arrivesAt": "02:50",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gorneşti Mureş h.",
					"to": "Periş Mureş h.",
					"leavesAt": "02:51",
					"arrivesAt": "02:56",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Periş Mureş h.",
					"to": "Petelea h.",
					"leavesAt": "02:57",
					"arrivesAt": "03:02",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Petelea h.",
					"to": "Reghin",
					"leavesAt": "03:03",
					"arrivesAt": "03:13",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Reghin",
					"to": "Ideciu de Jos h.",
					"leavesAt": "03:14",
					"arrivesAt": "03:20",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ideciu de Jos h.",
					"to": "Brâncoveneşti h.",
					"leavesAt": "03:21",
					"arrivesAt": "03:26",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Brâncoveneşti h.",
					"to": "Halta Aluniş h.",
					"leavesAt": "03:27",
					"arrivesAt": "03:31",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Halta Aluniş h.",
					"to": "Aluniş Mureş Hm.",
					"leavesAt": "03:32",
					"arrivesAt": "03:37",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Aluniş Mureş Hm.",
					"to": "Ruşii Munţi h.",
					"leavesAt": "03:38",
					"arrivesAt": "03:41",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ruşii Munţi h.",
					"to": "Deda",
					"leavesAt": "03:42",
					"arrivesAt": "03:48",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Deda",
					"to": "Morăreni h.",
					"leavesAt": "04:27",
					"arrivesAt": "04:34",
					"waitsAtSource": 2340,
					"distance": 4200
				},
				{
					"from": "Morăreni h.",
					"to": "Râpa de Jos Hm.",
					"leavesAt": "04:35",
					"arrivesAt": "04:41",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râpa de Jos Hm.",
					"to": "Monor Gledin",
					"leavesAt": "04:42",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Monor Gledin",
					"to": "Şieuţ h.",
					"leavesAt": "04:54",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Şieuţ h.",
					"to": "Şieu Hm.",
					"leavesAt": "05:03",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Şieu Hm.",
					"to": "Bârla pe Şieu h.",
					"leavesAt": "05:16",
					"arrivesAt": "05:23",
					"waitsAtSource": 360,
					"distance": 5000
				},
				{
					"from": "Bârla pe Şieu h.",
					"to": "Mărişelu Hm.",
					"leavesAt": "05:24",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Mărişelu Hm.",
					"to": "Domneşti pe Şieu h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Domneşti pe Şieu h.",
					"to": "Sărăţel Hm.",
					"leavesAt": "05:35",
					"arrivesAt": "05:44",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Sărăţel Hm.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:13",
					"waitsAtSource": 1080,
					"distance": 9800
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "06:14",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4317",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Botiz Hm.",
					"leavesAt": "05:12",
					"arrivesAt": "05:19",
					"waitsAtSource": 0,
					"distance": 5500
				},
				{
					"from": "Botiz Hm.",
					"to": "Odoreu h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Odoreu h.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:38",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Apa Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:56",
					"waitsAtSource": 600,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1884",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Nucet",
					"leavesAt": "10:22",
					"arrivesAt": "10:34",
					"waitsAtSource": 0,
					"distance": 16300
				},
				{
					"from": "Nucet",
					"to": "Titu",
					"leavesAt": "10:35",
					"arrivesAt": "10:48",
					"waitsAtSource": 60,
					"distance": 15400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1989",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ciulniţa",
					"leavesAt": "17:00",
					"arrivesAt": "17:55",
					"waitsAtSource": 0,
					"distance": 108900
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "17:56",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "18:20",
					"arrivesAt": "18:38",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "18:39",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "18:56",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 34600
				},
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "19:39",
					"arrivesAt": "19:55",
					"waitsAtSource": 1140,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "19:56",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "20:14",
					"arrivesAt": "20:21",
					"waitsAtSource": 540,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:32",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "20:33",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "20:51",
					"arrivesAt": "20:55",
					"waitsAtSource": 600,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "20:57",
					"arrivesAt": "21:10",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "21:12",
					"arrivesAt": "21:22",
					"waitsAtSource": 120,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180524",
					"to": "20180528",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5073",
			"segments": [
				{
					"from": "Brazi",
					"to": "Ploieşti Triaj",
					"leavesAt": "19:47",
					"arrivesAt": "19:55",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Ploieşti Sud",
					"leavesAt": "19:56",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "20:17",
					"arrivesAt": "20:23",
					"waitsAtSource": 840,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "20:24",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Muru hc.",
					"leavesAt": "20:34",
					"arrivesAt": "20:38",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "20:39",
					"arrivesAt": "20:42",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "20:43",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Inoteşti Hm.",
					"leavesAt": "20:49",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Mizil",
					"leavesAt": "20:55",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "21:03",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Clondiru hc.",
					"leavesAt": "21:14",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Clondiru hc.",
					"to": "Ulmeni",
					"leavesAt": "21:23",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Ulmeni",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "21:29",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Buzău",
					"leavesAt": "21:35",
					"arrivesAt": "21:47",
					"waitsAtSource": 30,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9304",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Atârnaţi Hm.",
					"leavesAt": "04:10",
					"arrivesAt": "04:17",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "04:18",
					"arrivesAt": "04:26",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Vârtoapele hc.",
					"leavesAt": "04:27",
					"arrivesAt": "04:32",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Olteni",
					"leavesAt": "04:33",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Olteni",
					"to": "Gălăteni Hm.",
					"leavesAt": "04:43",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Ciolpani Hm.",
					"leavesAt": "04:53",
					"arrivesAt": "04:59",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Videle",
					"leavesAt": "05:00",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Videle",
					"to": "Zăvestreni Hm.",
					"leavesAt": "05:21",
					"arrivesAt": "05:26",
					"waitsAtSource": 780,
					"distance": 4800
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "05:27",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "05:32",
					"arrivesAt": "05:39",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Zorile h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zorile h.",
					"to": "Grădinari",
					"leavesAt": "05:45",
					"arrivesAt": "05:54",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Grădinari",
					"to": "Domneştii de Sus h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:02",
					"waitsAtSource": 240,
					"distance": 6000
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Chiajna",
					"leavesAt": "06:03",
					"arrivesAt": "06:16",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Chiajna",
					"to": "Bucureştii Noi",
					"leavesAt": "06:17",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Carpaţi h.(900)",
					"leavesAt": "06:21",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "06:24",
					"arrivesAt": "06:27",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "06:28",
					"arrivesAt": "06:32",
					"waitsAtSource": 30,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9165",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Valea Păltinişului h.",
					"leavesAt": "08:53",
					"arrivesAt": "08:58",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "08:59",
					"arrivesAt": "09:06",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Brebu",
					"leavesAt": "09:07",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Brebu",
					"to": "Ezeriş h.",
					"leavesAt": "09:30",
					"arrivesAt": "09:38",
					"waitsAtSource": 600,
					"distance": 7700
				},
				{
					"from": "Ezeriş h.",
					"to": "Bănila Câlnic h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:45",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "09:46",
					"arrivesAt": "09:57",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Reşiţa Nord",
					"to": "Reşiţa Sud Hm.",
					"leavesAt": "09:58",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20180610",
					"to": "20180910",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5106",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "10:15",
					"arrivesAt": "10:28",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "10:29",
					"arrivesAt": "10:36",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Zagna Vădeni h.",
					"leavesAt": "10:37",
					"arrivesAt": "10:41",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Vădeni Hm.",
					"leavesAt": "10:42",
					"arrivesAt": "10:46",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vădeni Hm.",
					"to": "Baldovineşti Hm.",
					"leavesAt": "10:47",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Brăila",
					"leavesAt": "10:53",
					"arrivesAt": "11:01",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Brăila",
					"to": "Lacu Sărat",
					"leavesAt": "11:02",
					"arrivesAt": "11:10",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Lacu Sărat",
					"to": "Traian Sat Hm.",
					"leavesAt": "11:11",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Urleasca Hm.",
					"leavesAt": "11:21",
					"arrivesAt": "11:28",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Urleasca Hm.",
					"to": "Plopu",
					"leavesAt": "11:29",
					"arrivesAt": "11:36",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Plopu",
					"to": "Ianca hc.",
					"leavesAt": "11:37",
					"arrivesAt": "11:40",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ianca hc.",
					"to": "Deduleşti Hm.",
					"leavesAt": "11:41",
					"arrivesAt": "11:49",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Găiseanca h.",
					"leavesAt": "11:50",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Găiseanca h.",
					"to": "Făurei",
					"leavesAt": "11:56",
					"arrivesAt": "12:01",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Făurei",
					"to": "CTF Făurei h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:26",
					"waitsAtSource": 1200,
					"distance": 4100
				},
				{
					"from": "CTF Făurei h.",
					"to": "Vizireni h.",
					"leavesAt": "12:27",
					"arrivesAt": "12:31",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vizireni h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "12:32",
					"arrivesAt": "12:37",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "12:38",
					"arrivesAt": "12:45",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Movila Oii h.",
					"to": "Cilibia Hm.",
					"leavesAt": "12:46",
					"arrivesAt": "12:51",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cilibia Hm.",
					"to": "Bentu h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:56",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bentu h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "12:57",
					"arrivesAt": "13:01",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Tăbărăşti h.",
					"leavesAt": "13:02",
					"arrivesAt": "13:04",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Buzău Sud",
					"leavesAt": "13:05",
					"arrivesAt": "13:11",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Buzău Sud",
					"to": "Buzău",
					"leavesAt": "13:12",
					"arrivesAt": "13:20",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "13:40",
					"arrivesAt": "13:52",
					"waitsAtSource": 1200,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "13:53",
					"arrivesAt": "14:04",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "14:05",
					"arrivesAt": "14:20",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:42",
					"waitsAtSource": 840,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "14:43",
					"arrivesAt": "14:51",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "14:52",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "15:01",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "15:10",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:37",
					"waitsAtSource": 120,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "15:38",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Mărăşeşti",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "15:49",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "16:03",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Domneşti Târg h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Adjud",
					"leavesAt": "16:14",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 8400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1881",
			"segments": [
				{
					"from": "Titu",
					"to": "Nucet",
					"leavesAt": "08:40",
					"arrivesAt": "08:51",
					"waitsAtSource": 0,
					"distance": 15400
				},
				{
					"from": "Nucet",
					"to": "Târgovişte",
					"leavesAt": "08:52",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 16300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5705",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Vest",
					"leavesAt": "05:28",
					"arrivesAt": "05:36",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Suceava Vest",
					"to": "Stroieşti",
					"leavesAt": "05:40",
					"arrivesAt": "05:49",
					"waitsAtSource": 240,
					"distance": 9400
				},
				{
					"from": "Stroieşti",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:19",
					"waitsAtSource": 900,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "06:20",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Gura Humorului Hm.",
					"leavesAt": "06:28",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Gura Humorului Oraş",
					"leavesAt": "06:39",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Frasin",
					"leavesAt": "06:47",
					"arrivesAt": "06:56",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Frasin",
					"to": "Molid Hm.",
					"leavesAt": "06:57",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Molid Hm.",
					"to": "Vama",
					"leavesAt": "07:05",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Vama",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "07:18",
					"arrivesAt": "07:25",
					"waitsAtSource": 480,
					"distance": 4300
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "07:26",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "07:38",
					"arrivesAt": "07:45",
					"waitsAtSource": 120,
					"distance": 3800
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Sadova Hm.",
					"leavesAt": "07:47",
					"arrivesAt": "07:52",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Sadova Hm.",
					"to": "Pojorâta Hm.",
					"leavesAt": "07:53",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Valea Putnei P.M.",
					"leavesAt": "08:00",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Valea Putnei P.M.",
					"to": "Mestecăniş",
					"leavesAt": "08:13",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Iacobeni",
					"leavesAt": "08:25",
					"arrivesAt": "08:34",
					"waitsAtSource": 120,
					"distance": 5900
				},
				{
					"from": "Iacobeni",
					"to": "Argestru Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Argestru Hm.",
					"to": "Vatra Dornei",
					"leavesAt": "08:44",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9508",
			"segments": [
				{
					"from": "Orşova",
					"to": "Şantier Naval h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:12",
					"waitsAtSource": 0,
					"distance": 1300
				},
				{
					"from": "Şantier Naval h.",
					"to": "Vârciorova Hm.",
					"leavesAt": "16:13",
					"arrivesAt": "16:25",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Vârciorova Hm.",
					"to": "Jidoştiţa h.",
					"leavesAt": "16:26",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Jidoştiţa h.",
					"to": "Gura Văii Hm.",
					"leavesAt": "16:33",
					"arrivesAt": "16:38",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Gura Văii Hm.",
					"to": "Dinamica h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:47",
					"waitsAtSource": 240,
					"distance": 6300
				},
				{
					"from": "Dinamica h.",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "16:48",
					"arrivesAt": "16:53",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Drobeta Tr.Sev Est Hm.",
					"leavesAt": "16:55",
					"arrivesAt": "16:59",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Drobeta Tr.Sev Est Hm.",
					"to": "Drobeta Tr. Severin Mf.",
					"leavesAt": "17:00",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Drobeta Tr. Severin Mf.",
					"to": "Ergheviţa h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ergheviţa h.",
					"to": "Valea Albă Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Albă Hm.",
					"to": "Balota",
					"leavesAt": "17:24",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Balota",
					"to": "Gârniţa Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Gârniţa Hm.",
					"to": "Prunişor Hm.",
					"leavesAt": "17:42",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Prunişor Hm.",
					"to": "Igiroasa Hm.",
					"leavesAt": "17:50",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Igiroasa Hm.",
					"to": "Tâmna",
					"leavesAt": "17:57",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Tâmna",
					"to": "Ciochiuţa Hm.",
					"leavesAt": "18:05",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Ciochiuţa Hm.",
					"to": "Strehaia hc.",
					"leavesAt": "18:17",
					"arrivesAt": "18:22",
					"waitsAtSource": 240,
					"distance": 5700
				},
				{
					"from": "Strehaia hc.",
					"to": "Strehaia",
					"leavesAt": "18:23",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Strehaia",
					"to": "Lunca Banului h.",
					"leavesAt": "18:31",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Lunca Banului h.",
					"to": "Butoieşti Hm.",
					"leavesAt": "18:36",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Gura Motrului Hm.",
					"leavesAt": "18:44",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Filiaşi",
					"leavesAt": "18:51",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "19:00",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "19:04",
					"arrivesAt": "19:08",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "19:09",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "19:14",
					"arrivesAt": "19:19",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "19:20",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "19:24",
					"arrivesAt": "19:29",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "19:30",
					"arrivesAt": "19:32",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "19:33",
					"arrivesAt": "19:37",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "19:38",
					"arrivesAt": "19:40",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "19:41",
					"arrivesAt": "19:45",
					"waitsAtSource": 30,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2605",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj h",
					"leavesAt": "16:23",
					"arrivesAt": "16:28",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "16:29",
					"arrivesAt": "16:31",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "16:32",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Băile Călacea",
					"leavesAt": "16:39",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Călacea",
					"to": "Orţişoara",
					"leavesAt": "16:47",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Orţişoara",
					"to": "Vinga Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:11",
					"waitsAtSource": 360,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Aradu Nou",
					"leavesAt": "17:12",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "17:27",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3113",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "05:08",
					"arrivesAt": "05:16",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Băile Călacea",
					"leavesAt": "05:24",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Băile Călacea",
					"to": "Orţişoara",
					"leavesAt": "05:31",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Orţişoara",
					"to": "Vinga Hm.",
					"leavesAt": "05:37",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Vinga Hm.",
					"to": "Şag Hm.",
					"leavesAt": "05:43",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Şag Hm.",
					"to": "Valea Viilor Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "05:55",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Aradu Nou",
					"leavesAt": "05:56",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "06:18",
					"arrivesAt": "06:25",
					"waitsAtSource": 720,
					"distance": 6200
				},
				{
					"from": "Arad",
					"to": "Utvinişu Nou",
					"leavesAt": "06:43",
					"arrivesAt": "06:54",
					"waitsAtSource": 1080,
					"distance": 6500
				},
				{
					"from": "Utvinişu Nou",
					"to": "Utviniş h.",
					"leavesAt": "06:55",
					"arrivesAt": "06:59",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Utviniş h.",
					"to": "Zimandu Nou h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "07:05",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Comlăuş h.",
					"leavesAt": "07:17",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Comlăuş h.",
					"to": "Şimand Hm.",
					"leavesAt": "07:22",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şimand Hm.",
					"to": "Nădab",
					"leavesAt": "07:30",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Nădab",
					"to": "Chişineu Criş",
					"leavesAt": "07:38",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Chişineu Criş",
					"to": "Zerind Hm.",
					"leavesAt": "07:45",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Zerind Hm.",
					"to": "Tămaşda h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Tămaşda h.",
					"to": "Boiu Bihor h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Boiu Bihor h.",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "08:06",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Salonta",
					"leavesAt": "08:17",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Salonta",
					"to": "Mădăraş Bihor h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:38",
					"waitsAtSource": 120,
					"distance": 3200
				},
				{
					"from": "Mădăraş Bihor h.",
					"to": "Cefa Hm.",
					"leavesAt": "08:39",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Cefa Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "08:59",
					"arrivesAt": "09:09",
					"waitsAtSource": 480,
					"distance": 10400
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Oradea Vest Hm.",
					"leavesAt": "09:10",
					"arrivesAt": "09:21",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Oradea",
					"leavesAt": "09:22",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5214",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "07:15",
					"arrivesAt": "07:23",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Mihăileni Hm.",
					"leavesAt": "07:24",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mihăileni Hm.",
					"to": "Nădejdea Sat h.",
					"leavesAt": "07:31",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Nădejdea Sat h.",
					"to": "Nădejdea Hm.",
					"leavesAt": "07:36",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Nădejdea Hm.",
					"to": "Caracău h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Caracău h.",
					"to": "Livezi Ciuc",
					"leavesAt": "07:48",
					"arrivesAt": "07:53",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Livezi Ciuc",
					"to": "Utuşoiu h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:10",
					"waitsAtSource": 600,
					"distance": 4100
				},
				{
					"from": "Utuşoiu h.",
					"to": "Lunca de Sus Hm.",
					"leavesAt": "08:11",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Lunca de Sus Hm.",
					"to": "Tarcău h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Tarcău h.",
					"to": "Lunca de Mijloc Hm.",
					"leavesAt": "08:22",
					"arrivesAt": "08:26",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Lunca de Mijloc Hm.",
					"to": "Bolovăniş h.",
					"leavesAt": "08:27",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Bolovăniş h.",
					"to": "Ghimeş",
					"leavesAt": "08:34",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ghimeş",
					"to": "Palanca Hm.",
					"leavesAt": "08:42",
					"arrivesAt": "08:49",
					"waitsAtSource": 180,
					"distance": 5200
				},
				{
					"from": "Palanca Hm.",
					"to": "Brusturoasa hc.",
					"leavesAt": "08:50",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brusturoasa hc.",
					"to": "Simbrea Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Simbrea Hm.",
					"to": "Goioasa Hm.",
					"leavesAt": "09:10",
					"arrivesAt": "09:18",
					"waitsAtSource": 540,
					"distance": 7600
				},
				{
					"from": "Goioasa Hm.",
					"to": "Caraliţa h.",
					"leavesAt": "09:19",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Caraliţa h.",
					"to": "Asău Hm.",
					"leavesAt": "09:26",
					"arrivesAt": "09:30",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Asău Hm.",
					"to": "Comăneşti",
					"leavesAt": "09:31",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2459",
			"segments": [
				{
					"from": "Băbeni",
					"to": "Tătărani h.",
					"leavesAt": "23:10",
					"arrivesAt": "23:13",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Tătărani h.",
					"to": "Govora",
					"leavesAt": "23:14",
					"arrivesAt": "23:22",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Govora",
					"to": "Râureni hc.",
					"leavesAt": "23:23",
					"arrivesAt": "23:26",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Râureni hc.",
					"to": "Râureni",
					"leavesAt": "23:27",
					"arrivesAt": "23:35",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râureni",
					"to": "Răstoaca h.",
					"leavesAt": "23:36",
					"arrivesAt": "23:38",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Răstoaca h.",
					"to": "Ostroveni h.",
					"leavesAt": "23:39",
					"arrivesAt": "23:43",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ostroveni h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "23:44",
					"arrivesAt": "23:46",
					"waitsAtSource": 30,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2512",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Atelier Zona h.",
					"leavesAt": "07:35",
					"arrivesAt": "07:39",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "07:43",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Mohu h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Mohu h.",
					"to": "Veştem h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:53",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Veştem h.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "07:54",
					"arrivesAt": "08:03",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "08:04",
					"arrivesAt": "08:11",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Sebeş Olt h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Racoviţa h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:20",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Racoviţa h.",
					"to": "Mârşa h.",
					"leavesAt": "08:21",
					"arrivesAt": "08:24",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Mârşa h.",
					"to": "Avrig Hm.",
					"leavesAt": "08:25",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Avrig Hm.",
					"to": "Porumbacu Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:40",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Sărata Colun h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:52",
					"waitsAtSource": 420,
					"distance": 3800
				},
				{
					"from": "Sărata Colun h.",
					"to": "Scoreiu h.",
					"leavesAt": "08:53",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Scoreiu h.",
					"to": "Cârţa h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârţa h.",
					"to": "Arpaş Hm.",
					"leavesAt": "09:02",
					"arrivesAt": "09:06",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Arpaş Hm.",
					"to": "Ucea",
					"leavesAt": "09:07",
					"arrivesAt": "09:13",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ucea",
					"to": "Viştea h.",
					"leavesAt": "09:14",
					"arrivesAt": "09:17",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Viştea h.",
					"to": "Olteţ h.",
					"leavesAt": "09:18",
					"arrivesAt": "09:22",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Olteţ h.",
					"to": "Voila Hm.",
					"leavesAt": "09:23",
					"arrivesAt": "09:30",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Voila Hm.",
					"to": "Dridif h.",
					"leavesAt": "09:31",
					"arrivesAt": "09:35",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dridif h.",
					"to": "Beclean pe Olt h.",
					"leavesAt": "09:36",
					"arrivesAt": "09:40",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Beclean pe Olt h.",
					"to": "Făgăraş",
					"leavesAt": "09:41",
					"arrivesAt": "09:49",
					"waitsAtSource": 30,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3644",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Est",
					"leavesAt": "14:30",
					"arrivesAt": "14:35",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Oradea Est",
					"to": "Oradea Est Triaj h.",
					"leavesAt": "14:36",
					"arrivesAt": "14:37",
					"waitsAtSource": 60,
					"distance": 700
				},
				{
					"from": "Oradea Est Triaj h.",
					"to": "Oşorhei Hm.",
					"leavesAt": "14:38",
					"arrivesAt": "14:43",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Săcădat h.",
					"leavesAt": "14:44",
					"arrivesAt": "14:49",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Săcădat h.",
					"to": "Săbolciu h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săbolciu h.",
					"to": "Tileagd",
					"leavesAt": "14:53",
					"arrivesAt": "14:58",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tileagd",
					"to": "Telechiu Hm.",
					"leavesAt": "14:59",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Telechiu Hm.",
					"to": "Ţeţchea hc.",
					"leavesAt": "15:05",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ţeţchea hc.",
					"to": "Aleşd",
					"leavesAt": "15:10",
					"arrivesAt": "15:14",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Aleşd",
					"to": "Aleşd h.",
					"leavesAt": "15:15",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aleşd h.",
					"to": "Butan h.",
					"leavesAt": "15:19",
					"arrivesAt": "15:23",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Butan h.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "15:24",
					"arrivesAt": "15:32",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Vadu Crişului h.",
					"leavesAt": "15:36",
					"arrivesAt": "15:40",
					"waitsAtSource": 240,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului h.",
					"to": "Peştera h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Peştera h.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "15:46",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bălnaca h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:00",
					"waitsAtSource": 360,
					"distance": 4000
				},
				{
					"from": "Bălnaca h.",
					"to": "Bratca",
					"leavesAt": "16:01",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Bratca",
					"to": "Stâna de Vale h.",
					"leavesAt": "16:06",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bulz Hm.",
					"leavesAt": "16:11",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bulz Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "16:20",
					"arrivesAt": "16:25",
					"waitsAtSource": 300,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180123",
					"daysOfWeek": 831
				},
				{
					"from": "20180125",
					"to": "20180408",
					"daysOfWeek": 831
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 831
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 831
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 831
				},
				{
					"from": "20180602",
					"to": "20180814",
					"daysOfWeek": 831
				},
				{
					"from": "20180816",
					"to": "20181129",
					"daysOfWeek": 831
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 831
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 831
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6507",
			"segments": [
				{
					"from": "Ungheni Prut Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "17:25",
					"arrivesAt": "17:33",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Holboca Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:46",
					"waitsAtSource": 420,
					"distance": 3800
				},
				{
					"from": "Holboca Hm.",
					"to": "Remiza T Socola h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Remiza T Socola h.",
					"to": "Socola",
					"leavesAt": "17:54",
					"arrivesAt": "18:00",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Socola",
					"to": "Nicolina",
					"leavesAt": "18:01",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "18:08",
					"arrivesAt": "18:15",
					"waitsAtSource": 120,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5023",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "15:50",
					"arrivesAt": "16:00",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "16:01",
					"arrivesAt": "16:08",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "16:09",
					"arrivesAt": "16:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "16:14",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "16:28",
					"arrivesAt": "16:32",
					"waitsAtSource": 360,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "16:33",
					"arrivesAt": "16:38",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "16:39",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "16:44",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "16:58",
					"arrivesAt": "17:14",
					"waitsAtSource": 360,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6441",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "09:40",
					"arrivesAt": "09:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "09:55",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "10:03",
					"arrivesAt": "10:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "10:10",
					"arrivesAt": "10:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "10:18",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "10:28",
					"arrivesAt": "10:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "10:35",
					"arrivesAt": "10:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "10:40",
					"arrivesAt": "10:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "10:50",
					"arrivesAt": "11:04",
					"waitsAtSource": 60,
					"distance": 14700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1571",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Triaj",
					"leavesAt": "05:25",
					"arrivesAt": "06:06",
					"waitsAtSource": 0,
					"distance": 56600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Ploieşti Sud",
					"leavesAt": "06:10",
					"arrivesAt": "06:17",
					"waitsAtSource": 240,
					"distance": 3600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "06:19",
					"arrivesAt": "06:52",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "06:53",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Făurei",
					"leavesAt": "07:36",
					"arrivesAt": "08:13",
					"waitsAtSource": 480,
					"distance": 40400
				},
				{
					"from": "Făurei",
					"to": "Ianca hc.",
					"leavesAt": "08:16",
					"arrivesAt": "08:30",
					"waitsAtSource": 180,
					"distance": 17200
				},
				{
					"from": "Ianca hc.",
					"to": "Brăila",
					"leavesAt": "08:31",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 42400
				},
				{
					"from": "Brăila",
					"to": "Barboşi",
					"leavesAt": "09:05",
					"arrivesAt": "09:23",
					"waitsAtSource": 120,
					"distance": 19500
				},
				{
					"from": "Barboşi",
					"to": "Galaţi",
					"leavesAt": "09:24",
					"arrivesAt": "09:43",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1577",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Carpaţi h.(700)",
					"leavesAt": "15:30",
					"arrivesAt": "15:36",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Chitila",
					"leavesAt": "15:37",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "15:46",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Periş",
					"leavesAt": "15:53",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 13300
				},
				{
					"from": "Periş",
					"to": "Crivina",
					"leavesAt": "16:03",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "16:11",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "16:23",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "16:40",
					"arrivesAt": "16:45",
					"waitsAtSource": 180,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "16:46",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Mizil",
					"leavesAt": "16:55",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 22500
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "17:16",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Cilibia Hm.",
					"leavesAt": "17:52",
					"arrivesAt": "18:12",
					"waitsAtSource": 180,
					"distance": 19900
				},
				{
					"from": "Cilibia Hm.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "18:14",
					"arrivesAt": "18:25",
					"waitsAtSource": 120,
					"distance": 10500
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Făurei",
					"leavesAt": "18:26",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Făurei",
					"to": "Găiseanca h.",
					"leavesAt": "18:40",
					"arrivesAt": "18:43",
					"waitsAtSource": 120,
					"distance": 3900
				},
				{
					"from": "Găiseanca h.",
					"to": "Deduleşti Hm.",
					"leavesAt": "18:44",
					"arrivesAt": "18:50",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Ianca hc.",
					"leavesAt": "18:51",
					"arrivesAt": "18:56",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ianca hc.",
					"to": "Plopu",
					"leavesAt": "18:57",
					"arrivesAt": "19:00",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Plopu",
					"to": "Urleasca Hm.",
					"leavesAt": "19:01",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Urleasca Hm.",
					"to": "Traian Sat Hm.",
					"leavesAt": "19:08",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Lacu Sărat",
					"leavesAt": "19:15",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Lacu Sărat",
					"to": "Brăila",
					"leavesAt": "19:24",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "19:35",
					"arrivesAt": "19:40",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "19:41",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Zagna Vădeni h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:49",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Barboşi",
					"leavesAt": "19:50",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "19:57",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "20:04",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "73",
			"segments": [
				{
					"from": "Lokoshaza",
					"to": "Curtici",
					"leavesAt": "11:50",
					"arrivesAt": "12:00",
					"waitsAtSource": 0,
					"distance": 11200
				},
				{
					"from": "Curtici",
					"to": "Arad",
					"leavesAt": "12:30",
					"arrivesAt": "12:44",
					"waitsAtSource": 1800,
					"distance": 17000
				},
				{
					"from": "Arad",
					"to": "Timişoara Nord",
					"leavesAt": "12:47",
					"arrivesAt": "13:34",
					"waitsAtSource": 180,
					"distance": 57200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1623",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "10:00",
					"arrivesAt": "10:14",
					"waitsAtSource": 0,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Ploieşti Vest",
					"leavesAt": "10:15",
					"arrivesAt": "10:44",
					"waitsAtSource": 60,
					"distance": 42000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "10:46",
					"arrivesAt": "11:10",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Comarnic",
					"leavesAt": "11:11",
					"arrivesAt": "11:22",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Comarnic",
					"to": "Sinaia",
					"leavesAt": "11:23",
					"arrivesAt": "11:36",
					"waitsAtSource": 60,
					"distance": 15100
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "11:38",
					"arrivesAt": "11:45",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "11:46",
					"arrivesAt": "11:51",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "11:52",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "12:04",
					"arrivesAt": "12:42",
					"waitsAtSource": 120,
					"distance": 26300
				},
				{
					"from": "Braşov",
					"to": "Codlea Hm.",
					"leavesAt": "12:54",
					"arrivesAt": "13:10",
					"waitsAtSource": 720,
					"distance": 13800
				},
				{
					"from": "Codlea Hm.",
					"to": "Făgăraş",
					"leavesAt": "13:14",
					"arrivesAt": "14:10",
					"waitsAtSource": 240,
					"distance": 51200
				},
				{
					"from": "Făgăraş",
					"to": "Ucea",
					"leavesAt": "14:12",
					"arrivesAt": "14:34",
					"waitsAtSource": 120,
					"distance": 24600
				},
				{
					"from": "Ucea",
					"to": "Avrig Hm.",
					"leavesAt": "14:35",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 26100
				},
				{
					"from": "Avrig Hm.",
					"to": "Podu Olt",
					"leavesAt": "15:01",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Podu Olt",
					"to": "Tălmaciu Hm.",
					"leavesAt": "15:14",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Sibiu",
					"leavesAt": "15:22",
					"arrivesAt": "15:42",
					"waitsAtSource": 60,
					"distance": 17800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1742",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Carei",
					"leavesAt": "16:50",
					"arrivesAt": "17:24",
					"waitsAtSource": 0,
					"distance": 36000
				},
				{
					"from": "Carei",
					"to": "Valea lui Mihai",
					"leavesAt": "17:25",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 31200
				},
				{
					"from": "Valea lui Mihai",
					"to": "Săcuieni Bihor",
					"leavesAt": "17:52",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 21600
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Oradea",
					"leavesAt": "18:11",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 44200
				},
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "19:12",
					"arrivesAt": "19:46",
					"waitsAtSource": 720,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Bratca",
					"leavesAt": "19:47",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 25300
				},
				{
					"from": "Bratca",
					"to": "Ciucea Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 20700
				},
				{
					"from": "Ciucea Hm.",
					"to": "Huedin",
					"leavesAt": "20:38",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Huedin",
					"to": "Aghireş",
					"leavesAt": "21:00",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 21500
				},
				{
					"from": "Aghireş",
					"to": "Cluj Napoca",
					"leavesAt": "21:25",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 27900
				},
				{
					"from": "Cluj Napoca",
					"to": "Câmpia Turzii",
					"leavesAt": "22:09",
					"arrivesAt": "23:16",
					"waitsAtSource": 960,
					"distance": 51500
				},
				{
					"from": "Câmpia Turzii",
					"to": "Războieni",
					"leavesAt": "23:17",
					"arrivesAt": "23:33",
					"waitsAtSource": 60,
					"distance": 17100
				},
				{
					"from": "Războieni",
					"to": "Aiud Hm.",
					"leavesAt": "23:34",
					"arrivesAt": "23:56",
					"waitsAtSource": 60,
					"distance": 20400
				},
				{
					"from": "Aiud Hm.",
					"to": "Teiuş",
					"leavesAt": "23:57",
					"arrivesAt": "00:11",
					"waitsAtSource": 60,
					"distance": 13100
				},
				{
					"from": "Teiuş",
					"to": "Blaj",
					"leavesAt": "00:15",
					"arrivesAt": "00:46",
					"waitsAtSource": 240,
					"distance": 21300
				},
				{
					"from": "Blaj",
					"to": "Copşa Mică",
					"leavesAt": "00:48",
					"arrivesAt": "01:27",
					"waitsAtSource": 120,
					"distance": 30000
				},
				{
					"from": "Copşa Mică",
					"to": "Mediaş",
					"leavesAt": "01:33",
					"arrivesAt": "01:47",
					"waitsAtSource": 360,
					"distance": 10400
				},
				{
					"from": "Mediaş",
					"to": "Dumbrăveni",
					"leavesAt": "01:48",
					"arrivesAt": "02:14",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Dumbrăveni",
					"to": "Sighişoara",
					"leavesAt": "02:15",
					"arrivesAt": "02:42",
					"waitsAtSource": 60,
					"distance": 20400
				},
				{
					"from": "Sighişoara",
					"to": "Rupea",
					"leavesAt": "02:46",
					"arrivesAt": "03:49",
					"waitsAtSource": 240,
					"distance": 53600
				},
				{
					"from": "Rupea",
					"to": "Braşov",
					"leavesAt": "03:50",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 73800
				},
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "05:45",
					"arrivesAt": "06:23",
					"waitsAtSource": 840,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "06:31",
					"arrivesAt": "06:40",
					"waitsAtSource": 480,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "06:41",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "06:48",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Comarnic",
					"leavesAt": "06:59",
					"arrivesAt": "07:13",
					"waitsAtSource": 120,
					"distance": 15100
				},
				{
					"from": "Comarnic",
					"to": "Câmpina",
					"leavesAt": "07:14",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "07:26",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "07:52",
					"arrivesAt": "08:35",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20180909",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180607",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4522",
			"segments": [
				{
					"from": "Gheorgheni",
					"to": "Valea Strâmbă h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:39",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Şugău h.",
					"leavesAt": "20:40",
					"arrivesAt": "20:43",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Şugău h.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "20:44",
					"arrivesAt": "20:48",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "20:49",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Sândominic h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:15",
					"waitsAtSource": 420,
					"distance": 7800
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Oltului",
					"leavesAt": "21:16",
					"arrivesAt": "21:21",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Tomeşti h.",
					"leavesAt": "21:22",
					"arrivesAt": "21:25",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Cârţani h.",
					"leavesAt": "21:26",
					"arrivesAt": "21:29",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Cârţani h.",
					"to": "Dăneşti h.",
					"leavesAt": "21:30",
					"arrivesAt": "21:33",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Dăneşti h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "21:34",
					"arrivesAt": "21:40",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Racu h.",
					"leavesAt": "21:41",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Racu h.",
					"to": "Siculeni",
					"leavesAt": "21:47",
					"arrivesAt": "21:52",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "22:10",
					"arrivesAt": "22:19",
					"waitsAtSource": 1080,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1545",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Carei",
					"leavesAt": "07:33",
					"arrivesAt": "08:03",
					"waitsAtSource": 0,
					"distance": 36000
				},
				{
					"from": "Carei",
					"to": "Tăşnad",
					"leavesAt": "08:13",
					"arrivesAt": "08:35",
					"waitsAtSource": 600,
					"distance": 27800
				},
				{
					"from": "Tăşnad",
					"to": "Acâş Hm.",
					"leavesAt": "08:37",
					"arrivesAt": "08:50",
					"waitsAtSource": 120,
					"distance": 15500
				},
				{
					"from": "Acâş Hm.",
					"to": "Sărmăşag",
					"leavesAt": "08:51",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 22500
				},
				{
					"from": "Sărmăşag",
					"to": "Zalău Nord",
					"leavesAt": "09:16",
					"arrivesAt": "09:38",
					"waitsAtSource": 120,
					"distance": 22300
				},
				{
					"from": "Zalău Nord",
					"to": "Jibou",
					"leavesAt": "09:47",
					"arrivesAt": "10:19",
					"waitsAtSource": 540,
					"distance": 23700
				},
				{
					"from": "Jibou",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "10:28",
					"arrivesAt": "10:36",
					"waitsAtSource": 540,
					"distance": 6800
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Băbuţeni Hm.",
					"leavesAt": "10:37",
					"arrivesAt": "10:49",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Băbuţeni Hm.",
					"to": "Cuciulat Hm.",
					"leavesAt": "10:50",
					"arrivesAt": "10:55",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Letca Hm.",
					"leavesAt": "10:56",
					"arrivesAt": "11:03",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Letca Hm.",
					"to": "Răstoci Hm.",
					"leavesAt": "11:04",
					"arrivesAt": "11:14",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Răstoci Hm.",
					"to": "Ileanda",
					"leavesAt": "11:15",
					"arrivesAt": "11:23",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ileanda",
					"to": "Gâlgău",
					"leavesAt": "11:24",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 16100
				},
				{
					"from": "Gâlgău",
					"to": "Câţcău h.",
					"leavesAt": "11:42",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Câţcău h.",
					"to": "Căşeiu Hm.",
					"leavesAt": "11:53",
					"arrivesAt": "12:00",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Căşeiu Hm.",
					"to": "Dej Călători",
					"leavesAt": "12:01",
					"arrivesAt": "12:10",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dej Călători",
					"to": "Gherla",
					"leavesAt": "12:13",
					"arrivesAt": "12:32",
					"waitsAtSource": 180,
					"distance": 13900
				},
				{
					"from": "Gherla",
					"to": "Cluj Napoca",
					"leavesAt": "12:33",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 44900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9169",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Valea Păltinişului h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Valea Păltinişului h.",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "16:37",
					"arrivesAt": "16:44",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Brebu",
					"leavesAt": "16:45",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Brebu",
					"to": "Ezeriş h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ezeriş h.",
					"to": "Bănila Câlnic h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bănila Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "17:14",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Reşiţa Nord",
					"to": "Reşiţa Sud Hm.",
					"leavesAt": "17:26",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7573",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "16:02",
					"arrivesAt": "16:09",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Cosmeşti Hm.",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "Tecuci",
					"leavesAt": "16:16",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Tecuci",
					"to": "Malul Alb h.",
					"leavesAt": "16:28",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Malul Alb h.",
					"to": "Barcea",
					"leavesAt": "16:35",
					"arrivesAt": "16:39",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Barcea",
					"to": "Umbrăreşti h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:51",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Iveşti Hm.",
					"to": "Buceşti h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Buceşti h.",
					"to": "Lieşti",
					"leavesAt": "16:57",
					"arrivesAt": "17:01",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lieşti",
					"to": "Şerbăneşti h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "17:06",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "17:12",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Vameş h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Vameş h.",
					"to": "Piscu h.",
					"leavesAt": "17:24",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Piscu h.",
					"to": "Independenţa Hm.",
					"leavesAt": "17:29",
					"arrivesAt": "17:36",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Independenţa Hm.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Braniştea h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:47",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Braniştea h.",
					"to": "Şerbeştii Vechi h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:52",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şerbeştii Vechi h.",
					"to": "Şendreni Hm.",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şendreni Hm.",
					"to": "Barboşi Triaj h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Barboşi Triaj h.",
					"to": "Barboşi",
					"leavesAt": "18:03",
					"arrivesAt": "18:11",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "18:19",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9348",
			"segments": [
				{
					"from": "Giurgiu",
					"to": "Giurgiu Nord",
					"leavesAt": "19:00",
					"arrivesAt": "19:05",
					"waitsAtSource": 0,
					"distance": 3300
				},
				{
					"from": "Giurgiu Nord",
					"to": "Cetatea h.",
					"leavesAt": "19:06",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cetatea h.",
					"to": "Bălănoaia Hm.",
					"leavesAt": "19:10",
					"arrivesAt": "19:13",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bălănoaia Hm.",
					"to": "Onceşti h.",
					"leavesAt": "19:14",
					"arrivesAt": "19:17",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Onceşti h.",
					"to": "Stăneşti Hm.",
					"leavesAt": "19:18",
					"arrivesAt": "19:23",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Stăneşti Hm.",
					"to": "Chiriacu Hm.",
					"leavesAt": "19:24",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Chiriacu Hm.",
					"to": "Toporu",
					"leavesAt": "19:32",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Toporu",
					"to": "Răsuceni h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Răsuceni h.",
					"to": "Vlaşca Hm.",
					"leavesAt": "19:46",
					"arrivesAt": "19:53",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Vlaşca Hm.",
					"to": "Târnavele Hm.",
					"leavesAt": "19:54",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Târnavele Hm.",
					"to": "Răduleşti Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Răduleşti Hm.",
					"to": "Videle",
					"leavesAt": "20:15",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Videle",
					"to": "Vadu Lat Hm.",
					"leavesAt": "20:27",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 14600
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Grădinari",
					"leavesAt": "20:42",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Grădinari",
					"to": "Domneştii de Sus h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:07",
					"waitsAtSource": 300,
					"distance": 6000
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Chiajna",
					"leavesAt": "21:08",
					"arrivesAt": "21:25",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Chiajna",
					"to": "Bucureştii Noi",
					"leavesAt": "21:26",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Carpaţi h.(900)",
					"leavesAt": "21:31",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "21:36",
					"arrivesAt": "21:40",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Nord",
					"leavesAt": "21:41",
					"arrivesAt": "21:45",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 480
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5722",
			"segments": [
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "15:07",
					"arrivesAt": "15:13",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "15:14",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Vama",
					"leavesAt": "15:24",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Vama",
					"to": "Molid Hm.",
					"leavesAt": "15:31",
					"arrivesAt": "15:36",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Molid Hm.",
					"to": "Frasin",
					"leavesAt": "15:37",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "15:45",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Gura Humorului Hm.",
					"leavesAt": "15:55",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "16:04",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Stroieşti",
					"leavesAt": "16:33",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Stroieşti",
					"to": "Suceava Vest",
					"leavesAt": "16:41",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Suceava Vest",
					"to": "Suceava",
					"leavesAt": "16:51",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4512",
			"segments": [
				{
					"from": "Deda",
					"to": "Deda Bistra Hm.",
					"leavesAt": "16:12",
					"arrivesAt": "16:18",
					"waitsAtSource": 0,
					"distance": 3900
				},
				{
					"from": "Deda Bistra Hm.",
					"to": "Borzia h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Borzia h.",
					"to": "Răstoliţa Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:28",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Răstoliţa Hm.",
					"to": "Andreneasa h.",
					"leavesAt": "16:29",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Andreneasa h.",
					"to": "Lunca Bradului Hm.",
					"leavesAt": "16:38",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Lunca Bradului Hm.",
					"to": "Stânceni Neagra h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Stânceni Neagra h.",
					"to": "Stânceni h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Stânceni h.",
					"to": "Stânceni Hm.",
					"leavesAt": "17:04",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Stânceni Hm.",
					"to": "Ciobotani h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Ciobotani h.",
					"to": "Topliţa",
					"leavesAt": "17:18",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Topliţa",
					"to": "Gălăuţaş Hm.",
					"leavesAt": "17:29",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Gălăuţaş Hm.",
					"to": "Sărmaş Runc h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:50",
					"waitsAtSource": 360,
					"distance": 4100
				},
				{
					"from": "Sărmaş Runc h.",
					"to": "Subcetate Mureş Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "17:58",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Subcetate Mureş Hm.",
					"to": "Ditrău",
					"leavesAt": "18:06",
					"arrivesAt": "18:14",
					"waitsAtSource": 480,
					"distance": 8500
				},
				{
					"from": "Ditrău",
					"to": "Lăzarea Hm.",
					"leavesAt": "18:15",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Lăzarea Hm.",
					"to": "Gheorgheni",
					"leavesAt": "18:22",
					"arrivesAt": "18:27",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Gheorgheni",
					"to": "Valea Strâmbă h.",
					"leavesAt": "18:28",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Şugău h.",
					"leavesAt": "18:32",
					"arrivesAt": "18:35",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Şugău h.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "18:36",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "18:41",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Sândominic h.",
					"leavesAt": "18:52",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Oltului",
					"leavesAt": "19:01",
					"arrivesAt": "19:06",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Izvoru Oltului",
					"to": "Tomeşti h.",
					"leavesAt": "19:07",
					"arrivesAt": "19:10",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Cârţani h.",
					"leavesAt": "19:11",
					"arrivesAt": "19:14",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Cârţani h.",
					"to": "Dăneşti h.",
					"leavesAt": "19:15",
					"arrivesAt": "19:18",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Dăneşti h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "19:19",
					"arrivesAt": "19:25",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Racu h.",
					"leavesAt": "19:26",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Racu h.",
					"to": "Siculeni",
					"leavesAt": "19:32",
					"arrivesAt": "19:37",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "19:41",
					"arrivesAt": "19:49",
					"waitsAtSource": 240,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:15",
					"waitsAtSource": 1140,
					"distance": 7800
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:26",
					"waitsAtSource": 420,
					"distance": 3400
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "20:27",
					"arrivesAt": "20:31",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Vrabia h.",
					"leavesAt": "20:32",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Vrabia h.",
					"to": "Tuşnad Sat",
					"leavesAt": "20:38",
					"arrivesAt": "20:42",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Tuşnad Sat",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "20:51",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Malnaş Băi",
					"leavesAt": "20:59",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Malnaş Băi",
					"to": "Malnaş h.",
					"leavesAt": "21:09",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Malnaş h.",
					"to": "Bodoc Hm.",
					"leavesAt": "21:15",
					"arrivesAt": "21:23",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Bodoc Hm.",
					"to": "Arcuş h.",
					"leavesAt": "21:33",
					"arrivesAt": "21:38",
					"waitsAtSource": 600,
					"distance": 4500
				},
				{
					"from": "Arcuş h.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "21:39",
					"arrivesAt": "21:44",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "21:46",
					"arrivesAt": "21:52",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "21:53",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "21:58",
					"arrivesAt": "22:03",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "22:04",
					"arrivesAt": "22:07",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "22:08",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "22:17",
					"arrivesAt": "22:22",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "22:23",
					"arrivesAt": "22:29",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1003",
			"segments": [
				{
					"from": "Vadu Siretului",
					"to": "Vicşani",
					"leavesAt": "16:25",
					"arrivesAt": "16:51",
					"waitsAtSource": 0,
					"distance": 10600
				},
				{
					"from": "Vicşani",
					"to": "Dorneşti",
					"leavesAt": "17:35",
					"arrivesAt": "17:49",
					"waitsAtSource": 2640,
					"distance": 8300
				},
				{
					"from": "Dorneşti",
					"to": "Milişăuţi Hm.",
					"leavesAt": "17:50",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Milişăuţi Hm.",
					"to": "Dărmăneşti",
					"leavesAt": "18:03",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Dărmăneşti",
					"to": "Suceava Nord",
					"leavesAt": "18:13",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "18:23",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Paşcani",
					"leavesAt": "18:40",
					"arrivesAt": "19:28",
					"waitsAtSource": 720,
					"distance": 60600
				},
				{
					"from": "Paşcani",
					"to": "Bacău",
					"leavesAt": "19:29",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 84000
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "20:33",
					"arrivesAt": "21:19",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Focşani",
					"leavesAt": "21:20",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 45400
				},
				{
					"from": "Focşani",
					"to": "Buzău",
					"leavesAt": "22:12",
					"arrivesAt": "23:18",
					"waitsAtSource": 120,
					"distance": 70800
				},
				{
					"from": "Buzău",
					"to": "Ploieşti Sud",
					"leavesAt": "23:20",
					"arrivesAt": "00:25",
					"waitsAtSource": 120,
					"distance": 68600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "00:27",
					"arrivesAt": "01:22",
					"waitsAtSource": 120,
					"distance": 60200
				},
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "01:40",
					"arrivesAt": "02:33",
					"waitsAtSource": 1080,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Giurgiu Nord",
					"leavesAt": "02:34",
					"arrivesAt": "03:48",
					"waitsAtSource": 60,
					"distance": 63000
				},
				{
					"from": "Giurgiu Nord",
					"to": "Ruse",
					"leavesAt": "04:25",
					"arrivesAt": "04:50",
					"waitsAtSource": 2220,
					"distance": 16000
				}
			],
			"restrictions": [
				{
					"from": "20180611",
					"to": "20180611",
					"daysOfWeek": 383
				},
				{
					"from": "20180616",
					"to": "20180616",
					"daysOfWeek": 383
				},
				{
					"from": "20180623",
					"to": "20180623",
					"daysOfWeek": 383
				},
				{
					"from": "20180628",
					"to": "20180628",
					"daysOfWeek": 383
				},
				{
					"from": "20180705",
					"to": "20180705",
					"daysOfWeek": 383
				},
				{
					"from": "20180710",
					"to": "20180710",
					"daysOfWeek": 383
				},
				{
					"from": "20180717",
					"to": "20180717",
					"daysOfWeek": 383
				},
				{
					"from": "20180722",
					"to": "20180722",
					"daysOfWeek": 383
				},
				{
					"from": "20180729",
					"to": "20180729",
					"daysOfWeek": 383
				},
				{
					"from": "20180803",
					"to": "20180803",
					"daysOfWeek": 383
				},
				{
					"from": "20180810",
					"to": "20180810",
					"daysOfWeek": 383
				},
				{
					"from": "20180815",
					"to": "20180815",
					"daysOfWeek": 383
				},
				{
					"from": "20180822",
					"to": "20180822",
					"daysOfWeek": 383
				},
				{
					"from": "20180827",
					"to": "20180827",
					"daysOfWeek": 383
				},
				{
					"from": "20180903",
					"to": "20180903",
					"daysOfWeek": 383
				},
				{
					"from": "20180908",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4581",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:50",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "07:51",
					"arrivesAt": "07:57",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "08:05",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "08:14",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "08:20",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1755",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "17:05",
					"arrivesAt": "17:50",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Buzău",
					"leavesAt": "17:52",
					"arrivesAt": "18:58",
					"waitsAtSource": 120,
					"distance": 68600
				},
				{
					"from": "Buzău",
					"to": "Focşani",
					"leavesAt": "18:59",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 70800
				},
				{
					"from": "Focşani",
					"to": "Adjud",
					"leavesAt": "20:05",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 45400
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "20:50",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "21:35",
					"arrivesAt": "22:04",
					"waitsAtSource": 420,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Paşcani",
					"leavesAt": "22:05",
					"arrivesAt": "22:34",
					"waitsAtSource": 60,
					"distance": 40200
				},
				{
					"from": "Paşcani",
					"to": "Suceava",
					"leavesAt": "22:35",
					"arrivesAt": "23:20",
					"waitsAtSource": 60,
					"distance": 60600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9590",
			"segments": [
				{
					"from": "Jimbolia",
					"to": "Clarii Vii h.",
					"leavesAt": "12:50",
					"arrivesAt": "12:56",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Clarii Vii h.",
					"to": "Cărpiniş",
					"leavesAt": "12:57",
					"arrivesAt": "13:05",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Cărpiniş",
					"to": "Beregsău hcv.",
					"leavesAt": "13:06",
					"arrivesAt": "13:13",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Beregsău hcv.",
					"to": "Săcălaz h.",
					"leavesAt": "13:14",
					"arrivesAt": "13:21",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Săcălaz h.",
					"to": "Timişoara Nord",
					"leavesAt": "13:22",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5421",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "03:29",
					"arrivesAt": "03:40",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "03:41",
					"arrivesAt": "03:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "03:46",
					"arrivesAt": "03:51",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "03:52",
					"arrivesAt": "04:01",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "04:02",
					"arrivesAt": "04:06",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "04:07",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "04:16",
					"arrivesAt": "04:23",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "04:24",
					"arrivesAt": "04:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "04:31",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "04:36",
					"arrivesAt": "04:41",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "04:42",
					"arrivesAt": "04:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "04:47",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani",
					"leavesAt": "04:52",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "05:22",
					"arrivesAt": "05:36",
					"waitsAtSource": 1200,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "05:37",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "05:51",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "06:00",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "06:11",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "06:18",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "06:25",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "06:33",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5605",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "07:40",
					"arrivesAt": "07:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "07:55",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "08:03",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "08:10",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "08:18",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "08:35",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "08:50",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:15",
					"waitsAtSource": 360,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "09:16",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "09:27",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "09:33",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "09:46",
					"arrivesAt": "09:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "09:53",
					"arrivesAt": "09:59",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "10:00",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "10:07",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "10:14",
					"arrivesAt": "10:21",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "10:23",
					"arrivesAt": "10:29",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8591",
			"segments": [
				{
					"from": "Ciulniţa",
					"to": "Ştefan Vodă h.",
					"leavesAt": "08:40",
					"arrivesAt": "08:53",
					"waitsAtSource": 0,
					"distance": 12600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "08:54",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Km. 25+700 h.",
					"leavesAt": "09:01",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Km. 25+700 h.",
					"to": "Călăraşi Sud",
					"leavesAt": "09:08",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 1300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7565",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Tecuci",
					"leavesAt": "03:05",
					"arrivesAt": "03:29",
					"waitsAtSource": 0,
					"distance": 19000
				},
				{
					"from": "Tecuci",
					"to": "Barcea",
					"leavesAt": "03:30",
					"arrivesAt": "03:39",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Barcea",
					"to": "Umbrăreşti h.",
					"leavesAt": "03:40",
					"arrivesAt": "03:45",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "03:46",
					"arrivesAt": "03:51",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Iveşti Hm.",
					"to": "Buceşti h.",
					"leavesAt": "03:52",
					"arrivesAt": "03:56",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Buceşti h.",
					"to": "Lieşti",
					"leavesAt": "03:57",
					"arrivesAt": "04:01",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Lieşti",
					"to": "Şerbăneşti h.",
					"leavesAt": "04:02",
					"arrivesAt": "04:05",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "04:06",
					"arrivesAt": "04:11",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "04:12",
					"arrivesAt": "04:16",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Vameş h.",
					"leavesAt": "04:17",
					"arrivesAt": "04:23",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Vameş h.",
					"to": "Piscu h.",
					"leavesAt": "04:24",
					"arrivesAt": "04:28",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Piscu h.",
					"to": "Independenţa Hm.",
					"leavesAt": "04:29",
					"arrivesAt": "04:35",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Independenţa Hm.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Braniştea h.",
					"leavesAt": "04:41",
					"arrivesAt": "04:44",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Braniştea h.",
					"to": "Şendreni Hm.",
					"leavesAt": "04:45",
					"arrivesAt": "04:53",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Şendreni Hm.",
					"to": "Barboşi",
					"leavesAt": "04:54",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Barboşi",
					"to": "Fileşti Hm.",
					"leavesAt": "05:06",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Fileşti Hm.",
					"to": "Galaţi",
					"leavesAt": "05:14",
					"arrivesAt": "05:27",
					"waitsAtSource": 120,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8083",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Bucureşti Băneasa",
					"leavesAt": "14:40",
					"arrivesAt": "14:48",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Pantelimon",
					"leavesAt": "14:49",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Pantelimon",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "15:20",
					"arrivesAt": "15:24",
					"waitsAtSource": 1200,
					"distance": 600
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Bucureşti Obor",
					"leavesAt": "15:25",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8802",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "06:45",
					"arrivesAt": "06:52",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "06:53",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "06:59",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "07:13",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "07:18",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "07:34",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "07:41",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Agigea Nord",
					"leavesAt": "07:50",
					"arrivesAt": "07:57",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Nord",
					"to": "Constanţa",
					"leavesAt": "07:58",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9364",
			"segments": [
				{
					"from": "Alexandria",
					"to": "Alexandria Nord h.",
					"leavesAt": "12:25",
					"arrivesAt": "12:28",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Buzescu h.",
					"leavesAt": "12:29",
					"arrivesAt": "12:41",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Buzescu h.",
					"to": "Plosca Hm.",
					"leavesAt": "12:42",
					"arrivesAt": "12:54",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Plosca Hm.",
					"to": "Peret hc.",
					"leavesAt": "12:55",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Peret hc.",
					"to": "Roşiori Hm.",
					"leavesAt": "13:03",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Roşiori Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "13:18",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1556",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Triaj",
					"leavesAt": "19:28",
					"arrivesAt": "19:35",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Crivina",
					"leavesAt": "19:39",
					"arrivesAt": "19:55",
					"waitsAtSource": 240,
					"distance": 16900
				},
				{
					"from": "Crivina",
					"to": "Buftea",
					"leavesAt": "19:56",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 22800
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "20:12",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1573",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Sud",
					"leavesAt": "08:25",
					"arrivesAt": "09:17",
					"waitsAtSource": 0,
					"distance": 60200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "09:19",
					"arrivesAt": "09:52",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "09:53",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Făurei",
					"leavesAt": "10:30",
					"arrivesAt": "11:07",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Făurei",
					"to": "Ianca hc.",
					"leavesAt": "11:09",
					"arrivesAt": "11:23",
					"waitsAtSource": 120,
					"distance": 17200
				},
				{
					"from": "Ianca hc.",
					"to": "Brăila",
					"leavesAt": "11:24",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 42400
				},
				{
					"from": "Brăila",
					"to": "Barboşi",
					"leavesAt": "11:59",
					"arrivesAt": "12:18",
					"waitsAtSource": 120,
					"distance": 19500
				},
				{
					"from": "Barboşi",
					"to": "Galaţi",
					"leavesAt": "12:19",
					"arrivesAt": "12:38",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8652",
			"segments": [
				{
					"from": "Tulcea Oraş",
					"to": "Tulcea Mărfuri",
					"leavesAt": "05:17",
					"arrivesAt": "05:26",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Tulcea Mărfuri",
					"to": "Cataloi Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Cataloi Hm.",
					"to": "Mihail Kogălniceanu h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mihail Kogălniceanu h.",
					"to": "Zebil h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Zebil h.",
					"to": "Babadag",
					"leavesAt": "06:13",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Babadag",
					"to": "Ceamurlia de Jos h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Ceamurlia de Jos h.",
					"to": "Baia Dobrogea",
					"leavesAt": "06:48",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baia Dobrogea",
					"to": "Mihai Viteazu Hm.",
					"leavesAt": "06:55",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 10300
				},
				{
					"from": "Mihai Viteazu Hm.",
					"to": "Cogealac",
					"leavesAt": "07:15",
					"arrivesAt": "07:33",
					"waitsAtSource": 480,
					"distance": 17400
				},
				{
					"from": "Cogealac",
					"to": "Târguşor Dobrogea Hm.",
					"leavesAt": "07:34",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 20200
				},
				{
					"from": "Târguşor Dobrogea Hm.",
					"to": "Ram. M.K.P. Aj. M.",
					"leavesAt": "07:55",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Ram. M.K.P. Aj. M.",
					"to": "Nicolae Bălcescu",
					"leavesAt": "08:06",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Nicolae Bălcescu",
					"to": "Medgidia",
					"leavesAt": "08:13",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 19100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3008",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "14:25",
					"arrivesAt": "14:34",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Timişu de Jos h.",
					"leavesAt": "14:35",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Timişu de Jos h.",
					"to": "Timişu de Sus Hm.",
					"leavesAt": "14:43",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Timişu de Sus Hm.",
					"to": "Predeal",
					"leavesAt": "14:53",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "15:11",
					"arrivesAt": "15:20",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "15:21",
					"arrivesAt": "15:27",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "15:28",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "15:32",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:41",
					"waitsAtSource": 120,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Posada h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 8900
				},
				{
					"from": "Posada h.",
					"to": "Comarnic",
					"leavesAt": "15:51",
					"arrivesAt": "15:56",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "16:02",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "16:06",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "16:10",
					"arrivesAt": "16:16",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Bobolia h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:28",
					"waitsAtSource": 480,
					"distance": 5500
				},
				{
					"from": "Bobolia h.",
					"to": "Floreşti Prahova",
					"leavesAt": "16:29",
					"arrivesAt": "16:36",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "16:37",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "16:47",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "P. M. Ram. Ploieşti Tj.",
					"leavesAt": "16:57",
					"arrivesAt": "17:00",
					"waitsAtSource": 120,
					"distance": 2900
				},
				{
					"from": "P. M. Ram. Ploieşti Tj.",
					"to": "Brazi",
					"leavesAt": "17:01",
					"arrivesAt": "17:06",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Brazi",
					"to": "Prahova h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:19",
					"waitsAtSource": 480,
					"distance": 6900
				},
				{
					"from": "Prahova h.",
					"to": "Crivina",
					"leavesAt": "17:20",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "17:30",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "17:44",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Chitila",
					"leavesAt": "17:49",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Triaj hc.",
					"leavesAt": "17:58",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bucureşti Triaj hc.",
					"to": "Bucureşti Nord",
					"leavesAt": "18:03",
					"arrivesAt": "18:12",
					"waitsAtSource": 30,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3528",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Albeşti Târnava Hm.",
					"leavesAt": "02:18",
					"arrivesAt": "02:25",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Albeşti Târnava Hm.",
					"to": "Vânători",
					"leavesAt": "02:26",
					"arrivesAt": "02:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Vânători",
					"to": "Archita h",
					"leavesAt": "02:34",
					"arrivesAt": "02:55",
					"waitsAtSource": 60,
					"distance": 16400
				},
				{
					"from": "Archita h",
					"to": "Beia Hm.",
					"leavesAt": "02:56",
					"arrivesAt": "03:11",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Beia Hm.",
					"to": "Paloş Ardeal h.",
					"leavesAt": "03:12",
					"arrivesAt": "03:19",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paloş Ardeal h.",
					"to": "Caţa Hm.",
					"leavesAt": "03:20",
					"arrivesAt": "03:26",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Caţa Hm.",
					"to": "Rupea",
					"leavesAt": "03:27",
					"arrivesAt": "03:36",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Rupea",
					"to": "Mateiaş h.",
					"leavesAt": "03:56",
					"arrivesAt": "04:10",
					"waitsAtSource": 1200,
					"distance": 10700
				},
				{
					"from": "Mateiaş h.",
					"to": "Racoş Hm.",
					"leavesAt": "04:11",
					"arrivesAt": "04:17",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Racoş Hm.",
					"to": "Augustin Hm.",
					"leavesAt": "04:18",
					"arrivesAt": "04:34",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Augustin Hm.",
					"to": "Ormeniş h.",
					"leavesAt": "04:35",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ormeniş h.",
					"to": "Apaţa",
					"leavesAt": "04:44",
					"arrivesAt": "04:54",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Apaţa",
					"to": "Măieruş h.",
					"leavesAt": "04:55",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Măieruş h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "05:01",
					"arrivesAt": "05:06",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Rotbav h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:12",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Rotbav h.",
					"to": "Feldioara Hm.",
					"leavesAt": "05:13",
					"arrivesAt": "05:20",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Bod Hm.",
					"leavesAt": "05:21",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Bod Hm.",
					"to": "Stupini Hm.",
					"leavesAt": "05:37",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Stupini Hm.",
					"to": "Braşov",
					"leavesAt": "05:47",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4408",
			"segments": [
				{
					"from": "Halmeu",
					"to": "Porumbeşti Hm.",
					"leavesAt": "15:30",
					"arrivesAt": "15:36",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Micula Hm.",
					"leavesAt": "15:37",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Micula Hm.",
					"to": "Ram. Botiz h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Satu Mare",
					"leavesAt": "15:54",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180408",
					"to": "20180408",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180909",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				},
				{
					"from": "20171231",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2565",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Sibiu h.(203)",
					"leavesAt": "15:55",
					"arrivesAt": "15:59",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "16:00",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Mândra h.",
					"leavesAt": "16:17",
					"arrivesAt": "16:24",
					"waitsAtSource": 120,
					"distance": 6200
				},
				{
					"from": "Mândra h.",
					"to": "Loamneş Hm.",
					"leavesAt": "16:25",
					"arrivesAt": "16:32",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Loamneş Hm.",
					"to": "Hăşag h.",
					"leavesAt": "16:38",
					"arrivesAt": "16:44",
					"waitsAtSource": 360,
					"distance": 4100
				},
				{
					"from": "Hăşag h.",
					"to": "Şeica Mare h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:55",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Şeica Mare h.",
					"to": "Şeica Mare",
					"leavesAt": "16:56",
					"arrivesAt": "17:00",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Şeica Mare",
					"to": "Agârbiciu h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:16",
					"waitsAtSource": 540,
					"distance": 4500
				},
				{
					"from": "Agârbiciu h.",
					"to": "Axente Sever h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Axente Sever h.",
					"to": "Copşa Mică",
					"leavesAt": "17:23",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Copşa Mică",
					"to": "Târnava h.",
					"leavesAt": "17:29",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Târnava h.",
					"to": "Mediaş",
					"leavesAt": "17:37",
					"arrivesAt": "17:44",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5312",
			"segments": [
				{
					"from": "Comăneşti",
					"to": "Valea Uzului Hm.",
					"leavesAt": "21:00",
					"arrivesAt": "21:08",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Valea Uzului Hm.",
					"to": "Valea Uzului Haltă h.",
					"leavesAt": "21:09",
					"arrivesAt": "21:11",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Valea Uzului Haltă h.",
					"to": "Dofteana Bacău",
					"leavesAt": "21:12",
					"arrivesAt": "21:17",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Dofteana Bacău",
					"to": "Cireşoaia h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cireşoaia h.",
					"to": "Saline hc.",
					"leavesAt": "21:23",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Saline hc.",
					"to": "Târgu Ocna Hm.",
					"leavesAt": "21:29",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Târgu Ocna Hm.",
					"to": "Viişoara h",
					"leavesAt": "21:33",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Viişoara h",
					"to": "Oneşti",
					"leavesAt": "21:38",
					"arrivesAt": "21:49",
					"waitsAtSource": 30,
					"distance": 9100
				},
				{
					"from": "Oneşti",
					"to": "Borzeşti Bacău h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:54",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Borzeşti Bacău h.",
					"to": "Borzeşti Bacău",
					"leavesAt": "21:55",
					"arrivesAt": "22:01",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Borzeşti Bacău",
					"to": "Căiuţi Hm.",
					"leavesAt": "22:02",
					"arrivesAt": "22:08",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Căiuţi Hm.",
					"to": "Bâlca hc.",
					"leavesAt": "22:09",
					"arrivesAt": "22:14",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Bâlca hc.",
					"to": "Cornăţel Moldova h.",
					"leavesAt": "22:15",
					"arrivesAt": "22:19",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Cornăţel Moldova h.",
					"to": "Urecheşti Hm.",
					"leavesAt": "22:20",
					"arrivesAt": "22:23",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Urecheşti Hm.",
					"to": "Adjud",
					"leavesAt": "22:24",
					"arrivesAt": "22:35",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Adjud",
					"to": "Domneşti Târg h.",
					"leavesAt": "22:37",
					"arrivesAt": "22:44",
					"waitsAtSource": 120,
					"distance": 8400
				},
				{
					"from": "Domneşti Târg h.",
					"to": "Pufeşti Hm.",
					"leavesAt": "22:45",
					"arrivesAt": "22:48",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Pufeşti Hm.",
					"to": "Călimăneşti Vrancea h.",
					"leavesAt": "22:49",
					"arrivesAt": "22:56",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Călimăneşti Vrancea h.",
					"to": "Pădureni Putna Hm.",
					"leavesAt": "22:57",
					"arrivesAt": "23:01",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Pădureni Putna Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "23:02",
					"arrivesAt": "23:12",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4339",
			"segments": [
				{
					"from": "Oradea",
					"to": "Episcopia Bihor",
					"leavesAt": "19:37",
					"arrivesAt": "19:46",
					"waitsAtSource": 0,
					"distance": 5700
				},
				{
					"from": "Episcopia Bihor",
					"to": "Biharia Hm.",
					"leavesAt": "19:47",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Biharia Hm.",
					"to": "Tămăşeu h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Tămăşeu h.",
					"to": "Roşiori Bihor h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Roşiori Bihor h.",
					"to": "Diosig Hm.",
					"leavesAt": "20:15",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Diosig Hm.",
					"to": "Cadia h.",
					"leavesAt": "20:23",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Cadia h.",
					"to": "Săcuieni Bihor",
					"leavesAt": "20:30",
					"arrivesAt": "20:39",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Săcuieni Bihor",
					"to": "Şilindru Hm.",
					"leavesAt": "20:40",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Şilindru Hm.",
					"to": "Simion h.",
					"leavesAt": "20:51",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Simion h.",
					"to": "Valea lui Mihai",
					"leavesAt": "20:58",
					"arrivesAt": "21:06",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Valea lui Mihai",
					"to": "Curtuiuşeni h.",
					"leavesAt": "21:26",
					"arrivesAt": "21:31",
					"waitsAtSource": 1200,
					"distance": 6300
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Resighea h.",
					"leavesAt": "21:32",
					"arrivesAt": "21:38",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Resighea h.",
					"to": "Sanislău Hm.",
					"leavesAt": "21:39",
					"arrivesAt": "21:44",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Sanislău Hm.",
					"to": "Marna h.",
					"leavesAt": "21:45",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Marna h.",
					"to": "Carei",
					"leavesAt": "21:50",
					"arrivesAt": "21:56",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Carei",
					"to": "Domăneşti h.",
					"leavesAt": "21:57",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Domăneşti h.",
					"to": "Moftin h.",
					"leavesAt": "22:05",
					"arrivesAt": "22:09",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Moftin h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "22:10",
					"arrivesAt": "22:14",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Sătmărel h.",
					"leavesAt": "22:15",
					"arrivesAt": "22:23",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Sătmărel h.",
					"to": "Satu Mare Sud",
					"leavesAt": "22:24",
					"arrivesAt": "22:30",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Satu Mare Sud",
					"to": "Satu Mare",
					"leavesAt": "22:31",
					"arrivesAt": "22:38",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20180909",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180607",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1893",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "13:30",
					"arrivesAt": "14:30",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "14:36",
					"arrivesAt": "14:55",
					"waitsAtSource": 360,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "14:56",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "15:19",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Piteşti",
					"to": "Costeşti",
					"leavesAt": "15:40",
					"arrivesAt": "16:05",
					"waitsAtSource": 600,
					"distance": 21800
				},
				{
					"from": "Costeşti",
					"to": "Stolnici Hm.",
					"leavesAt": "16:06",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 15900
				},
				{
					"from": "Stolnici Hm.",
					"to": "Slatina",
					"leavesAt": "16:22",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 43300
				},
				{
					"from": "Slatina",
					"to": "Slătioara Hm.",
					"leavesAt": "17:02",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Slătioara Hm.",
					"to": "Piatra Olt",
					"leavesAt": "17:18",
					"arrivesAt": "17:28",
					"waitsAtSource": 240,
					"distance": 7100
				},
				{
					"from": "Piatra Olt",
					"to": "Brăneţ h.",
					"leavesAt": "17:30",
					"arrivesAt": "17:38",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Brăneţ h.",
					"to": "Balş",
					"leavesAt": "17:39",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Balş",
					"to": "Robăneşti Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Robăneşti Hm.",
					"to": "Toporaş h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Toporaş h.",
					"to": "Pieleşti Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:10",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Pieleşti Hm.",
					"to": "Cârcea h.",
					"leavesAt": "18:11",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Cârcea h.",
					"to": "Bordei hc.(901)",
					"leavesAt": "18:19",
					"arrivesAt": "18:27",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Craiova",
					"leavesAt": "18:28",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 1700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5704",
			"segments": [
				{
					"from": "Ilva Mică",
					"to": "Strâmba h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:57",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Strâmba h.",
					"to": "Leşu Ilvei Hm.",
					"leavesAt": "12:58",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Leşu Ilvei Hm.",
					"to": "Poiana Ilvei",
					"leavesAt": "13:04",
					"arrivesAt": "13:12",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Poiana Ilvei",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "13:13",
					"arrivesAt": "13:20",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Ilva Mare Hm.",
					"leavesAt": "13:21",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ilva Mare Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "13:31",
					"arrivesAt": "13:40",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Lunca Ilvei",
					"to": "Silhoasa Hm.",
					"leavesAt": "13:41",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Silhoasa Hm.",
					"to": "Larion Hm.",
					"leavesAt": "13:50",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Larion Hm.",
					"to": "Grădiniţa",
					"leavesAt": "14:01",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Grădiniţa",
					"to": "Coşna Hm.",
					"leavesAt": "14:11",
					"arrivesAt": "14:20",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Coşna Hm.",
					"to": "Floreni",
					"leavesAt": "14:21",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Floreni",
					"to": "Dorna Candrenilor h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dorna Candrenilor h.",
					"to": "Roşu Hm.",
					"leavesAt": "14:36",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Roşu Hm.",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "14:43",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Vatra Dornei",
					"leavesAt": "14:51",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei",
					"to": "Argestru Hm.",
					"leavesAt": "14:55",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Argestru Hm.",
					"to": "Iacobeni",
					"leavesAt": "15:02",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Iacobeni",
					"to": "Mestecăniş",
					"leavesAt": "15:13",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Valea Putnei P.M.",
					"leavesAt": "15:24",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Valea Putnei P.M.",
					"to": "Pojorâta Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Sadova Hm.",
					"leavesAt": "15:47",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sadova Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "15:53",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "16:06",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Vama",
					"leavesAt": "16:16",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Vama",
					"to": "Molid Hm.",
					"leavesAt": "16:23",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Molid Hm.",
					"to": "Frasin",
					"leavesAt": "16:29",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "16:37",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Gura Humorului Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:14",
					"waitsAtSource": 480,
					"distance": 7900
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "17:23",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Stroieşti",
					"leavesAt": "17:32",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Stroieşti",
					"to": "Suceava Vest",
					"leavesAt": "17:45",
					"arrivesAt": "17:54",
					"waitsAtSource": 300,
					"distance": 9400
				},
				{
					"from": "Suceava Vest",
					"to": "Suceava",
					"leavesAt": "17:55",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2106",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Atelier Zona h",
					"leavesAt": "15:34",
					"arrivesAt": "15:38",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Atelier Zona h",
					"to": "Sibiu Triaj",
					"leavesAt": "15:39",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Sibiu Triaj",
					"to": "Mohu h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Mohu h.",
					"to": "Veştem h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Veştem h.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "15:55",
					"arrivesAt": "16:04",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "16:05",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Sebeş Olt h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Racoviţa h.",
					"leavesAt": "16:18",
					"arrivesAt": "16:21",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Racoviţa h.",
					"to": "Mârşa h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:25",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Mârşa h.",
					"to": "Avrig Hm.",
					"leavesAt": "16:26",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Avrig Hm.",
					"to": "Porumbacu Hm.",
					"leavesAt": "16:31",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Sărata Colun h.",
					"leavesAt": "16:41",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sărata Colun h.",
					"to": "Scoreiu h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:49",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Scoreiu h.",
					"to": "Cârţa h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:54",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârţa h.",
					"to": "Arpaş Hm.",
					"leavesAt": "16:55",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Arpaş Hm.",
					"to": "Ucea",
					"leavesAt": "17:00",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ucea",
					"to": "Viştea h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Viştea h.",
					"to": "Olteţ h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Olteţ h.",
					"to": "Voila Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Voila Hm.",
					"to": "Dridif h.",
					"leavesAt": "17:24",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dridif h.",
					"to": "Făgăraş",
					"leavesAt": "17:29",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 8500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5612",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "19:06",
					"arrivesAt": "19:11",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "19:13",
					"arrivesAt": "19:20",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "19:21",
					"arrivesAt": "19:28",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "19:29",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "19:36",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:48",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "19:49",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "19:59",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "20:05",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "20:17",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "20:31",
					"arrivesAt": "20:45",
					"waitsAtSource": 480,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "20:46",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "20:54",
					"arrivesAt": "20:59",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "21:00",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "21:09",
					"arrivesAt": "21:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "21:20",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "21:27",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "21:34",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "21:42",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4502",
			"segments": [
				{
					"from": "Siculeni",
					"to": "Miercurea Ciuc",
					"leavesAt": "04:38",
					"arrivesAt": "04:46",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Tuşnad Sat",
					"leavesAt": "04:48",
					"arrivesAt": "05:06",
					"waitsAtSource": 120,
					"distance": 22800
				},
				{
					"from": "Tuşnad Sat",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "05:07",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Malnaş Băi",
					"leavesAt": "05:23",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Malnaş Băi",
					"to": "Malnaş h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:45",
					"waitsAtSource": 480,
					"distance": 4200
				},
				{
					"from": "Malnaş h.",
					"to": "Bodoc Hm.",
					"leavesAt": "05:46",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Bodoc Hm.",
					"to": "Arcuş h.",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Arcuş h.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "05:59",
					"arrivesAt": "06:04",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "06:06",
					"arrivesAt": "06:12",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "06:13",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "06:18",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:35",
					"waitsAtSource": 420,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "06:36",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "06:53",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7402",
			"segments": [
				{
					"from": "Făurei",
					"to": "Vizireni h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:09",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Vizireni h.",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "05:10",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Movila Oii h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:25",
					"waitsAtSource": 180,
					"distance": 6400
				},
				{
					"from": "Movila Oii h.",
					"to": "Cilibia Hm.",
					"leavesAt": "05:26",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cilibia Hm.",
					"to": "Bentu h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:40",
					"waitsAtSource": 300,
					"distance": 4000
				},
				{
					"from": "Bentu h.",
					"to": "Tăbărăşti Sud h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:45",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Tăbărăşti Sud h.",
					"to": "Tăbărăşti h.",
					"leavesAt": "05:46",
					"arrivesAt": "05:48",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Tăbărăşti h.",
					"to": "Buzău",
					"leavesAt": "05:49",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9371",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Roşiori Hm.",
					"leavesAt": "16:28",
					"arrivesAt": "16:33",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Roşiori Hm.",
					"to": "Peret hc.",
					"leavesAt": "16:34",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Peret hc.",
					"to": "Plosca Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:55",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Plosca Hm.",
					"to": "Buzescu h.",
					"leavesAt": "16:56",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzescu h.",
					"to": "Alexandria Nord h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Alexandria Nord h.",
					"to": "Alexandria",
					"leavesAt": "17:16",
					"arrivesAt": "17:21",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2145",
			"segments": [
				{
					"from": "Simeria",
					"to": "Bârcea Mare h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:41",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Bârcea Mare h.",
					"to": "Bârcea Mică",
					"leavesAt": "16:42",
					"arrivesAt": "16:45",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Bârcea Mică",
					"to": "Pestişu Mare h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Pestişu Mare h.",
					"to": "Hunedoara",
					"leavesAt": "16:51",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6501",
			"segments": [
				{
					"from": "Ungheni Prut Hm.",
					"to": "Cristeşti Jijia",
					"leavesAt": "05:00",
					"arrivesAt": "05:08",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Cristeşti Jijia",
					"to": "Holboca Hm.",
					"leavesAt": "05:09",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Holboca Hm.",
					"to": "Socola",
					"leavesAt": "05:16",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Socola",
					"to": "Nicolina",
					"leavesAt": "05:27",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "05:33",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4410",
			"segments": [
				{
					"from": "Halmeu",
					"to": "Porumbeşti Hm.",
					"leavesAt": "17:20",
					"arrivesAt": "17:26",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Micula Hm.",
					"leavesAt": "17:27",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Micula Hm.",
					"to": "Ram. Botiz h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Satu Mare",
					"leavesAt": "17:44",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4526",
			"segments": [
				{
					"from": "Miercurea Ciuc",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "23:52",
					"arrivesAt": "00:00",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "00:07",
					"arrivesAt": "00:11",
					"waitsAtSource": 420,
					"distance": 3400
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "00:12",
					"arrivesAt": "00:16",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Vrabia h.",
					"leavesAt": "00:17",
					"arrivesAt": "00:22",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Vrabia h.",
					"to": "Tuşnad Sat",
					"leavesAt": "00:23",
					"arrivesAt": "00:27",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Tuşnad Sat",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "00:28",
					"arrivesAt": "00:36",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20180325",
					"to": "20180325",
					"daysOfWeek": 319
				},
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5074",
			"segments": [
				{
					"from": "Buzău",
					"to": "Băile Sarata Monteoru hcv.",
					"leavesAt": "16:55",
					"arrivesAt": "17:04",
					"waitsAtSource": 0,
					"distance": 10500
				},
				{
					"from": "Băile Sarata Monteoru hcv.",
					"to": "Ulmeni",
					"leavesAt": "17:05",
					"arrivesAt": "17:10",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Ulmeni",
					"to": "Clondiru hc.",
					"leavesAt": "17:11",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Clondiru hc.",
					"to": "Săhăteni Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:26",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "17:27",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Inoteşti Hm.",
					"leavesAt": "17:35",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Inoteşti Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "17:49",
					"arrivesAt": "17:54",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "17:55",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Valea Calugareasca Hm",
					"leavesAt": "17:59",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Valea Calugareasca Hm",
					"to": "Ploieşti Est",
					"leavesAt": "18:07",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "18:15",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Triaj",
					"leavesAt": "18:24",
					"arrivesAt": "18:30",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Brazi",
					"leavesAt": "18:34",
					"arrivesAt": "18:42",
					"waitsAtSource": 240,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5607",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "15:40",
					"arrivesAt": "15:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "15:55",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "16:03",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "16:10",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "16:18",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "16:28",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "16:35",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "16:50",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "17:20",
					"arrivesAt": "17:25",
					"waitsAtSource": 960,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "17:26",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "17:56",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "18:03",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "18:10",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "18:17",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "18:24",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "18:33",
					"arrivesAt": "18:39",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20180601",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5111",
			"segments": [
				{
					"from": "Buzău",
					"to": "Boboc Hm.",
					"leavesAt": "16:18",
					"arrivesAt": "16:29",
					"waitsAtSource": 0,
					"distance": 11500
				},
				{
					"from": "Boboc Hm.",
					"to": "Zoita Hm.",
					"leavesAt": "16:30",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Zoita Hm.",
					"to": "Râmnicu Sărat",
					"leavesAt": "16:41",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 11300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Voetin h.",
					"leavesAt": "16:56",
					"arrivesAt": "17:04",
					"waitsAtSource": 120,
					"distance": 7900
				},
				{
					"from": "Voetin h.",
					"to": "Sihlea Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Sihlea Hm.",
					"to": "Gugeşti",
					"leavesAt": "17:14",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gugeşti",
					"to": "Coteşti Hm.",
					"leavesAt": "17:22",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Coteşti Hm.",
					"to": "Focşani",
					"leavesAt": "17:31",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Focşani",
					"to": "Putna Seacă Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:56",
					"waitsAtSource": 120,
					"distance": 11700
				},
				{
					"from": "Putna Seacă Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "17:57",
					"arrivesAt": "18:07",
					"waitsAtSource": 60,
					"distance": 8000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7362",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "06:07",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "06:08",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Zagna Vădeni h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:22",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Zagna Vădeni h.",
					"to": "Vădeni Hm.",
					"leavesAt": "06:23",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Vădeni Hm.",
					"to": "Baldovineşti Hm.",
					"leavesAt": "06:28",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Brăila",
					"leavesAt": "06:34",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Brăila",
					"to": "Lacu Sărat",
					"leavesAt": "06:44",
					"arrivesAt": "06:52",
					"waitsAtSource": 120,
					"distance": 9700
				},
				{
					"from": "Lacu Sărat",
					"to": "Traian Sat Hm.",
					"leavesAt": "06:53",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Traian Sat Hm.",
					"to": "Urleasca Hm.",
					"leavesAt": "07:03",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Urleasca Hm.",
					"to": "Plopu",
					"leavesAt": "07:11",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Plopu",
					"to": "Ianca hc.",
					"leavesAt": "07:20",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Ianca hc.",
					"to": "Deduleşti Hm.",
					"leavesAt": "07:25",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Deduleşti Hm.",
					"to": "Găiseanca h.",
					"leavesAt": "07:35",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Găiseanca h.",
					"to": "Făurei",
					"leavesAt": "07:42",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Făurei",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "07:49",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Cilibia Hm.",
					"leavesAt": "08:04",
					"arrivesAt": "08:14",
					"waitsAtSource": 300,
					"distance": 10500
				},
				{
					"from": "Cilibia Hm.",
					"to": "Buzău",
					"leavesAt": "08:19",
					"arrivesAt": "08:42",
					"waitsAtSource": 300,
					"distance": 19900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9489",
			"segments": [
				{
					"from": "Slatina",
					"to": "Slătioara Hm.",
					"leavesAt": "23:30",
					"arrivesAt": "23:42",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "23:43",
					"arrivesAt": "23:46",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "23:47",
					"arrivesAt": "23:53",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6401",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Zorleni",
					"leavesAt": "11:18",
					"arrivesAt": "11:26",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Zorleni",
					"to": "Banca Hm.",
					"leavesAt": "11:27",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Banca Hm.",
					"to": "Dodeşti hc.",
					"leavesAt": "11:36",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Dodeşti hc.",
					"to": "Roşieşti hc.",
					"leavesAt": "11:42",
					"arrivesAt": "11:48",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Roşieşti hc.",
					"to": "Crasna",
					"leavesAt": "11:49",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Crasna",
					"to": "Bulboaca h.",
					"leavesAt": "11:58",
					"arrivesAt": "12:06",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Bulboaca h.",
					"to": "Munteni Hm.",
					"leavesAt": "12:07",
					"arrivesAt": "12:13",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Munteni Hm.",
					"to": "Vaslui",
					"leavesAt": "12:14",
					"arrivesAt": "12:20",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vaslui",
					"to": "Bălteni Hm.",
					"leavesAt": "12:26",
					"arrivesAt": "12:36",
					"waitsAtSource": 360,
					"distance": 9800
				},
				{
					"from": "Bălteni Hm.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "12:37",
					"arrivesAt": "12:42",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bârzeşti h.",
					"leavesAt": "12:43",
					"arrivesAt": "12:47",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bârzeşti h.",
					"to": "Buhăieşti",
					"leavesAt": "12:48",
					"arrivesAt": "12:55",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Buhăieşti",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "12:56",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Rebricea Hm.",
					"leavesAt": "13:02",
					"arrivesAt": "13:08",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebricea Hm.",
					"to": "Scânteia Hm.",
					"leavesAt": "13:09",
					"arrivesAt": "13:15",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Scânteia Hm.",
					"to": "Grajduri",
					"leavesAt": "13:16",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Grajduri",
					"to": "Bârnova Hm.",
					"leavesAt": "13:26",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "13:35",
					"arrivesAt": "13:41",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Ciurea Hm.",
					"leavesAt": "13:42",
					"arrivesAt": "13:48",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ciurea Hm.",
					"to": "Nicolina",
					"leavesAt": "13:49",
					"arrivesAt": "13:55",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "13:56",
					"arrivesAt": "14:03",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8805",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "18:39",
					"arrivesAt": "18:51",
					"waitsAtSource": 0,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "18:59",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "19:15",
					"arrivesAt": "19:22",
					"waitsAtSource": 480,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Costineşti",
					"leavesAt": "19:23",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "19:39",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "19:44",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "19:55",
					"arrivesAt": "19:59",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "20:00",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9662",
			"segments": [
				{
					"from": "Stamora Moraviţa",
					"to": "Denta h.",
					"leavesAt": "05:27",
					"arrivesAt": "05:35",
					"waitsAtSource": 0,
					"distance": 8400
				},
				{
					"from": "Denta h.",
					"to": "Deta Hm.",
					"leavesAt": "05:36",
					"arrivesAt": "05:43",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Deta Hm.",
					"to": "Voiteni",
					"leavesAt": "05:44",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "05:55",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "06:06",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "06:13",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara C.E.T.",
					"leavesAt": "06:22",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişoara Sud",
					"leavesAt": "06:29",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "06:36",
					"arrivesAt": "06:47",
					"waitsAtSource": 240,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2420",
			"segments": [
				{
					"from": "Miercurea Sibiu Hm.",
					"to": "Apoldu de Jos h.",
					"leavesAt": "05:47",
					"arrivesAt": "05:51",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Apoldu de Jos h.",
					"to": "Apoldu de Sus Hm.",
					"leavesAt": "05:52",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Apoldu de Sus Hm.",
					"to": "Tilişca h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Tilişca h.",
					"to": "Aciliu h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:20",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Aciliu h.",
					"to": "Sălişte Hm.",
					"leavesAt": "06:21",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Sălişte Hm.",
					"to": "Săcelu Sibiului h.",
					"leavesAt": "06:26",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Săcelu Sibiului h.",
					"to": "Sibiel h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sibiel h.",
					"to": "Orlat",
					"leavesAt": "06:36",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Orlat",
					"to": "Cristian Sibiu h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Cristian Sibiu h.",
					"to": "Turnişor Hm.",
					"leavesAt": "06:49",
					"arrivesAt": "07:03",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Turnişor Hm.",
					"to": "Sibiu h.(210)",
					"leavesAt": "07:05",
					"arrivesAt": "07:08",
					"waitsAtSource": 120,
					"distance": 2100
				},
				{
					"from": "Sibiu h.(210)",
					"to": "Sibiu",
					"leavesAt": "07:09",
					"arrivesAt": "07:14",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20180114",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180701",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180714",
					"to": "20180714",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180909",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7031",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Carpaţi h.(700)",
					"leavesAt": "05:32",
					"arrivesAt": "05:38",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Pajura Hm. (700)",
					"leavesAt": "05:39",
					"arrivesAt": "05:42",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Chitila",
					"leavesAt": "05:43",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chitila",
					"to": "Mogoşoaia",
					"leavesAt": "05:51",
					"arrivesAt": "06:07",
					"waitsAtSource": 120,
					"distance": 11000
				},
				{
					"from": "Mogoşoaia",
					"to": "Odăile h.",
					"leavesAt": "06:08",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Odăile h.",
					"to": "P.O. Aeroport h.",
					"leavesAt": "06:13",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Baloteşti Hm.",
					"leavesAt": "06:16",
					"arrivesAt": "06:19",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Baloteşti Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "06:20",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "06:26",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Greci h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Greci h.",
					"to": "Fierbinţi",
					"leavesAt": "06:39",
					"arrivesAt": "06:45",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Fierbinţi",
					"to": "Dridu Hm.",
					"leavesAt": "06:46",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Dridu Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "06:53",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moldoveni h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "06:59",
					"arrivesAt": "07:04",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "07:09",
					"arrivesAt": "07:16",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1952",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "20:25",
					"arrivesAt": "20:30",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "20:35",
					"arrivesAt": "20:47",
					"waitsAtSource": 300,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "20:49",
					"arrivesAt": "21:07",
					"waitsAtSource": 120,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "21:09",
					"arrivesAt": "21:25",
					"waitsAtSource": 120,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Roman",
					"leavesAt": "21:28",
					"arrivesAt": "21:55",
					"waitsAtSource": 180,
					"distance": 40200
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "21:57",
					"arrivesAt": "22:26",
					"waitsAtSource": 120,
					"distance": 43800
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "22:28",
					"arrivesAt": "23:07",
					"waitsAtSource": 120,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "23:09",
					"arrivesAt": "23:36",
					"waitsAtSource": 120,
					"distance": 25700
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "23:38",
					"arrivesAt": "23:59",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "00:01",
					"arrivesAt": "00:38",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "00:39",
					"arrivesAt": "01:10",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "C.A.Rosetti Hm.",
					"leavesAt": "01:30",
					"arrivesAt": "01:59",
					"waitsAtSource": 1200,
					"distance": 30400
				},
				{
					"from": "C.A.Rosetti Hm.",
					"to": "Făurei",
					"leavesAt": "02:04",
					"arrivesAt": "02:16",
					"waitsAtSource": 300,
					"distance": 10000
				},
				{
					"from": "Făurei",
					"to": "Ţăndărei",
					"leavesAt": "02:17",
					"arrivesAt": "02:56",
					"waitsAtSource": 60,
					"distance": 58100
				},
				{
					"from": "Ţăndărei",
					"to": "Feteşti",
					"leavesAt": "02:57",
					"arrivesAt": "03:27",
					"waitsAtSource": 60,
					"distance": 30600
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "03:28",
					"arrivesAt": "03:48",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "03:49",
					"arrivesAt": "04:06",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "04:07",
					"arrivesAt": "04:31",
					"waitsAtSource": 60,
					"distance": 34600
				},
				{
					"from": "Constanţa",
					"to": "Eforie Nord",
					"leavesAt": "04:46",
					"arrivesAt": "05:09",
					"waitsAtSource": 900,
					"distance": 14000
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "05:11",
					"arrivesAt": "05:18",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Costineşti",
					"leavesAt": "05:20",
					"arrivesAt": "05:36",
					"waitsAtSource": 120,
					"distance": 8600
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "05:38",
					"arrivesAt": "05:42",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "05:44",
					"arrivesAt": "05:57",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "05:59",
					"arrivesAt": "06:09",
					"waitsAtSource": 120,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180608",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8372",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "08:01",
					"arrivesAt": "08:09",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "08:10",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Pescăruş h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:20",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Pescăruş h.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "08:21",
					"arrivesAt": "08:26",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "08:27",
					"arrivesAt": "08:30",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:44",
					"waitsAtSource": 480,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "08:45",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "08:52",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "08:59",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 14000
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180502",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180529",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1754",
			"segments": [
				{
					"from": "Suceava",
					"to": "Vereşti",
					"leavesAt": "12:30",
					"arrivesAt": "12:43",
					"waitsAtSource": 0,
					"distance": 14800
				},
				{
					"from": "Vereşti",
					"to": "Dolhasca",
					"leavesAt": "12:58",
					"arrivesAt": "13:17",
					"waitsAtSource": 900,
					"distance": 24600
				},
				{
					"from": "Dolhasca",
					"to": "Paşcani",
					"leavesAt": "13:18",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 21200
				},
				{
					"from": "Paşcani",
					"to": "Roman",
					"leavesAt": "13:36",
					"arrivesAt": "14:03",
					"waitsAtSource": 120,
					"distance": 40200
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "14:04",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 43800
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "14:42",
					"arrivesAt": "15:21",
					"waitsAtSource": 540,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Mărăşeşti",
					"leavesAt": "15:22",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "15:50",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "16:13",
					"arrivesAt": "16:50",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "16:51",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "17:25",
					"arrivesAt": "17:58",
					"waitsAtSource": 180,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "18:00",
					"arrivesAt": "18:36",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "18:40",
					"arrivesAt": "19:31",
					"waitsAtSource": 240,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "1091",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(913)",
					"leavesAt": "08:10",
					"arrivesAt": "08:13",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(913)",
					"to": "Jiu Hm.",
					"leavesAt": "08:14",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Jiu Hm.",
					"to": "Podari",
					"leavesAt": "08:20",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Podari",
					"to": "Sălcuţa Hm.",
					"leavesAt": "08:31",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 13800
				},
				{
					"from": "Sălcuţa Hm.",
					"to": "Dealul Robului h.",
					"leavesAt": "08:46",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dealul Robului h.",
					"to": "Segarcea Nord hc.",
					"leavesAt": "08:52",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Segarcea Nord hc.",
					"to": "Segarcea",
					"leavesAt": "09:00",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Segarcea",
					"to": "Cerăt h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cerăt h.",
					"to": "Portăreşti Hm.",
					"leavesAt": "09:11",
					"arrivesAt": "09:20",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Portăreşti Hm.",
					"to": "Afumaţi h.",
					"leavesAt": "09:21",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Afumaţi h.",
					"to": "Siliştea Crucii h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:47",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Siliştea Crucii h.",
					"to": "Băileşti",
					"leavesAt": "09:48",
					"arrivesAt": "10:05",
					"waitsAtSource": 30,
					"distance": 9500
				},
				{
					"from": "Băileşti",
					"to": "Moţăţei Hm.",
					"leavesAt": "10:06",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 12800
				},
				{
					"from": "Moţăţei Hm.",
					"to": "Maglavit h.",
					"leavesAt": "10:29",
					"arrivesAt": "10:43",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Maglavit h.",
					"to": "Golenţi Hm.",
					"leavesAt": "10:44",
					"arrivesAt": "10:59",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Golenţi Hm.",
					"to": "Vidin Patnicheska",
					"leavesAt": "11:07",
					"arrivesAt": "11:25",
					"waitsAtSource": 480,
					"distance": 23200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8373",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "07:38",
					"arrivesAt": "07:55",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "07:56",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "08:07",
					"arrivesAt": "08:14",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:25",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "08:26",
					"arrivesAt": "08:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "08:35",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "08:41",
					"arrivesAt": "08:54",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "08:56",
					"arrivesAt": "09:01",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "09:02",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180502",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1896",
			"segments": [
				{
					"from": "Craiova",
					"to": "Balş",
					"leavesAt": "16:25",
					"arrivesAt": "16:55",
					"waitsAtSource": 0,
					"distance": 31200
				},
				{
					"from": "Balş",
					"to": "Piatra Olt",
					"leavesAt": "16:56",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 12900
				},
				{
					"from": "Piatra Olt",
					"to": "Slatina",
					"leavesAt": "17:09",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 17000
				},
				{
					"from": "Slatina",
					"to": "Stolnici Hm.",
					"leavesAt": "17:30",
					"arrivesAt": "18:10",
					"waitsAtSource": 120,
					"distance": 43300
				},
				{
					"from": "Stolnici Hm.",
					"to": "Costeşti",
					"leavesAt": "18:11",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 15900
				},
				{
					"from": "Costeşti",
					"to": "Piteşti",
					"leavesAt": "18:26",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "19:00",
					"arrivesAt": "19:11",
					"waitsAtSource": 600,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "19:12",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Titu",
					"leavesAt": "19:36",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "19:57",
					"arrivesAt": "20:37",
					"waitsAtSource": 120,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1882",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Nucet",
					"leavesAt": "06:27",
					"arrivesAt": "06:39",
					"waitsAtSource": 0,
					"distance": 16300
				},
				{
					"from": "Nucet",
					"to": "Titu",
					"leavesAt": "06:40",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 15400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8693",
			"segments": [
				{
					"from": "Medgidia",
					"to": "Castelu h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:36",
					"waitsAtSource": 0,
					"distance": 5200
				},
				{
					"from": "Castelu h.",
					"to": "Dorobanţu",
					"leavesAt": "05:37",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Dorobanţu",
					"to": "Poarta Albă h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Poarta Albă h.",
					"to": "Basarabi",
					"leavesAt": "05:47",
					"arrivesAt": "05:52",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Basarabi",
					"to": "Murfatlar h.",
					"leavesAt": "05:53",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Murfatlar h.",
					"to": "Valul lui Traian",
					"leavesAt": "05:57",
					"arrivesAt": "06:02",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Valul lui Traian",
					"to": "Palas",
					"leavesAt": "06:03",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Palas",
					"to": "Constanţa",
					"leavesAt": "06:09",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180428",
					"daysOfWeek": 383
				},
				{
					"from": "20180430",
					"to": "20180430",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180526",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20180529",
					"daysOfWeek": 383
				},
				{
					"from": "20180609",
					"to": "20180609",
					"daysOfWeek": 383
				},
				{
					"from": "20180611",
					"to": "20180616",
					"daysOfWeek": 383
				},
				{
					"from": "20180618",
					"to": "20180623",
					"daysOfWeek": 383
				},
				{
					"from": "20180625",
					"to": "20180630",
					"daysOfWeek": 383
				},
				{
					"from": "20180702",
					"to": "20180707",
					"daysOfWeek": 383
				},
				{
					"from": "20180709",
					"to": "20180714",
					"daysOfWeek": 383
				},
				{
					"from": "20180716",
					"to": "20180721",
					"daysOfWeek": 383
				},
				{
					"from": "20180723",
					"to": "20180728",
					"daysOfWeek": 383
				},
				{
					"from": "20180730",
					"to": "20180804",
					"daysOfWeek": 383
				},
				{
					"from": "20180806",
					"to": "20180811",
					"daysOfWeek": 383
				},
				{
					"from": "20180813",
					"to": "20180814",
					"daysOfWeek": 383
				},
				{
					"from": "20180816",
					"to": "20180818",
					"daysOfWeek": 383
				},
				{
					"from": "20180820",
					"to": "20180825",
					"daysOfWeek": 383
				},
				{
					"from": "20180827",
					"to": "20180901",
					"daysOfWeek": 383
				},
				{
					"from": "20180903",
					"to": "20180908",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4490",
			"segments": [
				{
					"from": "Beclean pe Someş",
					"to": "Cociu h.",
					"leavesAt": "08:43",
					"arrivesAt": "08:51",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Cociu h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "08:52",
					"arrivesAt": "08:55",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Nimigea h.",
					"leavesAt": "08:56",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Nimigea h.",
					"to": "Nimigea Hm.",
					"leavesAt": "09:01",
					"arrivesAt": "09:04",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Nimigea Hm.",
					"to": "Mititei h.",
					"leavesAt": "09:05",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mititei h.",
					"to": "Salva",
					"leavesAt": "09:12",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Salva",
					"to": "Năsăud h.",
					"leavesAt": "09:16",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Năsăud h.",
					"to": "Năsăud",
					"leavesAt": "09:21",
					"arrivesAt": "09:24",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Năsăud",
					"to": "Rebrişoara Hm.",
					"leavesAt": "09:26",
					"arrivesAt": "09:31",
					"waitsAtSource": 120,
					"distance": 4800
				},
				{
					"from": "Rebrişoara Hm.",
					"to": "Nepos h.",
					"leavesAt": "09:32",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Nepos h.",
					"to": "Feldru Hm.",
					"leavesAt": "09:39",
					"arrivesAt": "09:45",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Feldru Hm.",
					"to": "Podereia Feldrului h.",
					"leavesAt": "09:46",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Podereia Feldrului h.",
					"to": "Ilva Mică",
					"leavesAt": "09:50",
					"arrivesAt": "09:55",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3071",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Huedin",
					"leavesAt": "02:16",
					"arrivesAt": "03:07",
					"waitsAtSource": 0,
					"distance": 49400
				},
				{
					"from": "Huedin",
					"to": "Poieni",
					"leavesAt": "03:31",
					"arrivesAt": "03:46",
					"waitsAtSource": 1440,
					"distance": 15300
				},
				{
					"from": "Poieni",
					"to": "Valea Drăganului h.",
					"leavesAt": "03:47",
					"arrivesAt": "03:51",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Drăganului h.",
					"to": "Ciucea Hm.",
					"leavesAt": "03:52",
					"arrivesAt": "03:57",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Ciucea Hm.",
					"to": "Negreni h.",
					"leavesAt": "03:58",
					"arrivesAt": "04:02",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Lacu Crişului h.",
					"leavesAt": "04:03",
					"arrivesAt": "04:07",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "04:08",
					"arrivesAt": "04:13",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bulz Hm.",
					"leavesAt": "04:18",
					"arrivesAt": "04:23",
					"waitsAtSource": 300,
					"distance": 4000
				},
				{
					"from": "Bulz Hm.",
					"to": "Stâna de Vale h.",
					"leavesAt": "04:24",
					"arrivesAt": "04:27",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bratca",
					"leavesAt": "04:28",
					"arrivesAt": "04:34",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bratca",
					"to": "Bălnaca h.",
					"leavesAt": "04:35",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Bălnaca h.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "04:39",
					"arrivesAt": "04:45",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Vadu Crişului h.",
					"leavesAt": "04:46",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Vadu Crişului h.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "04:53",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Butan h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:03",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Butan h.",
					"to": "Aleşd h.",
					"leavesAt": "05:04",
					"arrivesAt": "05:08",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Aleşd h.",
					"to": "Aleşd",
					"leavesAt": "05:09",
					"arrivesAt": "05:15",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aleşd",
					"to": "Ţeţchea hc.",
					"leavesAt": "05:16",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Ţeţchea hc.",
					"to": "Telechiu Hm.",
					"leavesAt": "05:22",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Telechiu Hm.",
					"to": "Tileagd",
					"leavesAt": "05:29",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Tileagd",
					"to": "Săbolciu h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Săbolciu h.",
					"to": "Săcădat h.",
					"leavesAt": "05:47",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Săcădat h.",
					"to": "Oşorhei Hm.",
					"leavesAt": "05:52",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Oradea Est Triaj h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Oradea Est Triaj h.",
					"to": "Oradea Est",
					"leavesAt": "06:09",
					"arrivesAt": "06:11",
					"waitsAtSource": 30,
					"distance": 700
				},
				{
					"from": "Oradea Est",
					"to": "Oradea",
					"leavesAt": "06:12",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3513",
			"segments": [
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "16:17",
					"arrivesAt": "16:25",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "16:26",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Micăsasa h.",
					"leavesAt": "16:45",
					"arrivesAt": "17:02",
					"waitsAtSource": 720,
					"distance": 10200
				},
				{
					"from": "Micăsasa h.",
					"to": "Lunca h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lunca h.",
					"to": "Valea Lungă Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Valea Lungă Hm.",
					"to": "Glogoveţ h.",
					"leavesAt": "17:19",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Glogoveţ h.",
					"to": "Mănărade h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:28",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Mănărade h.",
					"to": "Câmpu Libertăţii  h.",
					"leavesAt": "17:29",
					"arrivesAt": "17:33",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Câmpu Libertăţii  h.",
					"to": "Blaj",
					"leavesAt": "17:34",
					"arrivesAt": "17:39",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Blaj",
					"to": "Crăciunel Hm.",
					"leavesAt": "17:41",
					"arrivesAt": "17:49",
					"waitsAtSource": 120,
					"distance": 5300
				},
				{
					"from": "Crăciunel Hm.",
					"to": "Cistei h.",
					"leavesAt": "17:50",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Cistei h.",
					"to": "Coşlariu Gr. P. Mureş",
					"leavesAt": "18:00",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Coşlariu Gr. P. Mureş",
					"to": "Teiuş",
					"leavesAt": "18:10",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4451",
			"segments": [
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "10:00",
					"arrivesAt": "10:16",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "10:17",
					"arrivesAt": "10:23",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "10:24",
					"arrivesAt": "10:28",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "10:29",
					"arrivesAt": "10:36",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3079",
			"segments": [
				{
					"from": "Câmpia Turzii",
					"to": "Cânepişti h.",
					"leavesAt": "16:27",
					"arrivesAt": "16:36",
					"waitsAtSource": 0,
					"distance": 7700
				},
				{
					"from": "Cânepişti h.",
					"to": "Ploscoş h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:42",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Ploscoş h.",
					"to": "Valea Florilor Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "16:49",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Valea Florilor Hm.",
					"to": "Boju",
					"leavesAt": "16:50",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Boju",
					"to": "Tunel Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Tunel Hm.",
					"to": "Cojocna Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cojocna Hm.",
					"to": "Apahida",
					"leavesAt": "17:19",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "17:30",
					"arrivesAt": "17:37",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "17:44",
					"arrivesAt": "17:49",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180106",
					"to": "20180106",
					"daysOfWeek": 799
				},
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180203",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180604",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1536",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Arad",
					"leavesAt": "17:15",
					"arrivesAt": "18:03",
					"waitsAtSource": 0,
					"distance": 57200
				},
				{
					"from": "Arad",
					"to": "Sântana",
					"leavesAt": "18:08",
					"arrivesAt": "18:32",
					"waitsAtSource": 300,
					"distance": 23500
				},
				{
					"from": "Sântana",
					"to": "Chişineu Criş",
					"leavesAt": "18:33",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Chişineu Criş",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "18:53",
					"arrivesAt": "19:16",
					"waitsAtSource": 120,
					"distance": 23700
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Salonta",
					"leavesAt": "19:17",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 10200
				},
				{
					"from": "Salonta",
					"to": "Oradea",
					"leavesAt": "19:36",
					"arrivesAt": "20:15",
					"waitsAtSource": 420,
					"distance": 39200
				},
				{
					"from": "Oradea",
					"to": "Aleşd",
					"leavesAt": "20:24",
					"arrivesAt": "20:57",
					"waitsAtSource": 540,
					"distance": 34300
				},
				{
					"from": "Aleşd",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "20:58",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 19000
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "21:19",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bratca",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "21:28",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Ciucea Hm.",
					"leavesAt": "21:39",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Ciucea Hm.",
					"to": "Huedin",
					"leavesAt": "21:49",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 22400
				},
				{
					"from": "Huedin",
					"to": "Cluj Napoca",
					"leavesAt": "22:19",
					"arrivesAt": "23:09",
					"waitsAtSource": 600,
					"distance": 49400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5702",
			"segments": [
				{
					"from": "Ilva Mică",
					"to": "Strâmba h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:43",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Strâmba h.",
					"to": "Leşu Ilvei Hm.",
					"leavesAt": "05:44",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Leşu Ilvei Hm.",
					"to": "Poiana Ilvei",
					"leavesAt": "05:50",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Poiana Ilvei",
					"to": "Măgura Ilvei Hm.",
					"leavesAt": "05:59",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Măgura Ilvei Hm.",
					"to": "Ilva Mare Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:21",
					"waitsAtSource": 300,
					"distance": 7100
				},
				{
					"from": "Ilva Mare Hm.",
					"to": "Lunca Ilvei",
					"leavesAt": "06:22",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Lunca Ilvei",
					"to": "Silhoasa Hm.",
					"leavesAt": "06:33",
					"arrivesAt": "06:41",
					"waitsAtSource": 120,
					"distance": 5800
				},
				{
					"from": "Silhoasa Hm.",
					"to": "Larion Hm.",
					"leavesAt": "06:42",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Larion Hm.",
					"to": "Grădiniţa",
					"leavesAt": "06:53",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Grădiniţa",
					"to": "Coşna Hm.",
					"leavesAt": "07:03",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Coşna Hm.",
					"to": "Floreni",
					"leavesAt": "07:13",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Floreni",
					"to": "Dorna Candrenilor h.",
					"leavesAt": "07:22",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Dorna Candrenilor h.",
					"to": "Roşu Hm.",
					"leavesAt": "07:28",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Roşu Hm.",
					"to": "Vatra Dornei Băi hc.",
					"leavesAt": "07:35",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Vatra Dornei Băi hc.",
					"to": "Vatra Dornei",
					"leavesAt": "07:44",
					"arrivesAt": "07:47",
					"waitsAtSource": 120,
					"distance": 1000
				},
				{
					"from": "Vatra Dornei",
					"to": "Argestru Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "07:56",
					"waitsAtSource": 180,
					"distance": 4500
				},
				{
					"from": "Argestru Hm.",
					"to": "Iacobeni",
					"leavesAt": "07:57",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Iacobeni",
					"to": "Mestecăniş",
					"leavesAt": "08:08",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mestecăniş",
					"to": "Valea Putnei P.M.",
					"leavesAt": "08:19",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Valea Putnei P.M.",
					"to": "Pojorâta Hm.",
					"leavesAt": "08:29",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Pojorâta Hm.",
					"to": "Sadova Hm.",
					"leavesAt": "08:42",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Sadova Hm.",
					"to": "Câmpulung Mold.",
					"leavesAt": "08:48",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Câmpulung Mold.",
					"to": "Câmpulung Est Hm.",
					"leavesAt": "08:56",
					"arrivesAt": "09:02",
					"waitsAtSource": 180,
					"distance": 3800
				},
				{
					"from": "Câmpulung Est Hm.",
					"to": "Prisaca Dornei Hm.",
					"leavesAt": "09:05",
					"arrivesAt": "09:14",
					"waitsAtSource": 180,
					"distance": 7500
				},
				{
					"from": "Prisaca Dornei Hm.",
					"to": "Vama",
					"leavesAt": "09:16",
					"arrivesAt": "09:22",
					"waitsAtSource": 120,
					"distance": 4300
				},
				{
					"from": "Vama",
					"to": "Molid Hm.",
					"leavesAt": "09:31",
					"arrivesAt": "09:36",
					"waitsAtSource": 540,
					"distance": 3300
				},
				{
					"from": "Molid Hm.",
					"to": "Frasin",
					"leavesAt": "09:37",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Frasin",
					"to": "Gura Humorului Oraş",
					"leavesAt": "09:49",
					"arrivesAt": "09:58",
					"waitsAtSource": 300,
					"distance": 6800
				},
				{
					"from": "Gura Humorului Oraş",
					"to": "Gura Humorului Hm.",
					"leavesAt": "09:59",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Gura Humorului Hm.",
					"to": "Berchişeşti Hm.",
					"leavesAt": "10:08",
					"arrivesAt": "10:19",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Berchişeşti Hm.",
					"to": "Lucăceşti h.",
					"leavesAt": "10:20",
					"arrivesAt": "10:26",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lucăceşti h.",
					"to": "Ciprian Porumbescu Hm.",
					"leavesAt": "10:27",
					"arrivesAt": "10:35",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Ciprian Porumbescu Hm.",
					"to": "Stroieşti",
					"leavesAt": "10:36",
					"arrivesAt": "10:43",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Stroieşti",
					"to": "Suceava Vest",
					"leavesAt": "10:44",
					"arrivesAt": "10:53",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Suceava Vest",
					"to": "Suceava",
					"leavesAt": "10:54",
					"arrivesAt": "11:01",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8379",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "20:49",
					"arrivesAt": "21:03",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "21:04",
					"arrivesAt": "21:11",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "21:22",
					"arrivesAt": "21:27",
					"waitsAtSource": 660,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "21:28",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "21:35",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "21:43",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "21:47",
					"arrivesAt": "21:56",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "21:57",
					"arrivesAt": "22:06",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180525",
					"to": "20180529",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2206",
			"segments": [
				{
					"from": "Curtici",
					"to": "Şofronea",
					"leavesAt": "08:40",
					"arrivesAt": "08:48",
					"waitsAtSource": 0,
					"distance": 7300
				},
				{
					"from": "Şofronea",
					"to": "Arad",
					"leavesAt": "08:49",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 9700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9305",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:14",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h.(900)",
					"leavesAt": "16:15",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Carpaţi h.(900)",
					"to": "Bucureştii Noi",
					"leavesAt": "16:19",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Bucureştii Noi",
					"to": "Chiajna",
					"leavesAt": "16:23",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiajna",
					"to": "Domneştii de Sus h.",
					"leavesAt": "16:27",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Domneştii de Sus h.",
					"to": "Grădinari",
					"leavesAt": "16:37",
					"arrivesAt": "16:47",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Grădinari",
					"to": "Zorile h.",
					"leavesAt": "16:56",
					"arrivesAt": "17:01",
					"waitsAtSource": 540,
					"distance": 5700
				},
				{
					"from": "Zorile h.",
					"to": "Vadu Lat Hm.",
					"leavesAt": "17:02",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Vadu Lat Hm.",
					"to": "Angheleşti h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Angheleşti h.",
					"to": "Zăvestreni Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:21",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Zăvestreni Hm.",
					"to": "Videle",
					"leavesAt": "17:22",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Videle",
					"to": "Ciolpani Hm.",
					"leavesAt": "17:32",
					"arrivesAt": "17:39",
					"waitsAtSource": 120,
					"distance": 7700
				},
				{
					"from": "Ciolpani Hm.",
					"to": "Gălăteni Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Gălăteni Hm.",
					"to": "Olteni",
					"leavesAt": "17:50",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Olteni",
					"to": "Vârtoapele hc.",
					"leavesAt": "17:57",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vârtoapele hc.",
					"to": "Rădoieşti Hm.",
					"leavesAt": "18:05",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Rădoieşti Hm.",
					"to": "Atârnaţi Hm.",
					"leavesAt": "18:12",
					"arrivesAt": "18:22",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Atârnaţi Hm.",
					"to": "Roşiori Nord",
					"leavesAt": "18:23",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1886",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Nucet",
					"leavesAt": "13:30",
					"arrivesAt": "13:42",
					"waitsAtSource": 0,
					"distance": 16300
				},
				{
					"from": "Nucet",
					"to": "Titu",
					"leavesAt": "13:43",
					"arrivesAt": "13:55",
					"waitsAtSource": 60,
					"distance": 15400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1883",
			"segments": [
				{
					"from": "Titu",
					"to": "Nucet",
					"leavesAt": "10:40",
					"arrivesAt": "10:51",
					"waitsAtSource": 0,
					"distance": 15400
				},
				{
					"from": "Nucet",
					"to": "Târgovişte",
					"leavesAt": "10:52",
					"arrivesAt": "11:05",
					"waitsAtSource": 60,
					"distance": 16300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4652",
			"segments": [
				{
					"from": "Sighetu Marmaţiei",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "14:32",
					"arrivesAt": "14:37",
					"waitsAtSource": 0,
					"distance": 1900
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Tisa h.",
					"leavesAt": "14:38",
					"arrivesAt": "14:45",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tisa h.",
					"to": "Crăciuneşti h.",
					"leavesAt": "14:46",
					"arrivesAt": "14:49",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "14:50",
					"arrivesAt": "14:56",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Lunca la Tisa h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Valea Vişeului",
					"leavesAt": "15:03",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Valea Vişeului",
					"to": "Vişeu Bistra h.",
					"leavesAt": "15:36",
					"arrivesAt": "15:50",
					"waitsAtSource": 900,
					"distance": 8500
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Petrova hc.",
					"leavesAt": "15:51",
					"arrivesAt": "16:00",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Petrova hc.",
					"to": "Leordina",
					"leavesAt": "16:01",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Leordina",
					"to": "Leordina h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Leordina h.",
					"to": "Bocicoel h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Bocicoel h.",
					"to": "Vişeu de Jos",
					"leavesAt": "16:28",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180204",
					"daysOfWeek": 799
				},
				{
					"from": "20180210",
					"to": "20180302",
					"daysOfWeek": 799
				},
				{
					"from": "20180305",
					"to": "20180401",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180617",
					"daysOfWeek": 799
				},
				{
					"from": "20180701",
					"to": "20180701",
					"daysOfWeek": 799
				},
				{
					"from": "20180901",
					"to": "20180902",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9591",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Săcălaz h.",
					"leavesAt": "16:25",
					"arrivesAt": "16:35",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Săcălaz h.",
					"to": "Beregsău hcv.",
					"leavesAt": "16:36",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Beregsău hcv.",
					"to": "Cărpiniş",
					"leavesAt": "16:44",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Cărpiniş",
					"to": "Clarii Vii h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Clarii Vii h.",
					"to": "Jimbolia",
					"leavesAt": "17:00",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 6300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2572",
			"segments": [
				{
					"from": "Sighişoara",
					"to": "Daneş Hm.",
					"leavesAt": "06:29",
					"arrivesAt": "06:45",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Daneş Hm.",
					"to": "Luna h.",
					"leavesAt": "06:50",
					"arrivesAt": "06:57",
					"waitsAtSource": 300,
					"distance": 4900
				},
				{
					"from": "Luna h.",
					"to": "Dumbrăveni",
					"leavesAt": "06:58",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Dumbrăveni",
					"to": "Aţel Hm.",
					"leavesAt": "07:06",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Aţel Hm.",
					"to": "Bratei h.",
					"leavesAt": "07:16",
					"arrivesAt": "07:25",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Bratei h.",
					"to": "Mediaş",
					"leavesAt": "07:26",
					"arrivesAt": "07:35",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:45",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "07:46",
					"arrivesAt": "07:53",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Axente Sever h.",
					"leavesAt": "07:55",
					"arrivesAt": "08:00",
					"waitsAtSource": 120,
					"distance": 2700
				},
				{
					"from": "Axente Sever h.",
					"to": "Agârbiciu h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Agârbiciu h.",
					"to": "Şeica Mare",
					"leavesAt": "08:08",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şeica Mare",
					"to": "Şeica Mare h.",
					"leavesAt": "08:20",
					"arrivesAt": "08:22",
					"waitsAtSource": 360,
					"distance": 1400
				},
				{
					"from": "Şeica Mare h.",
					"to": "Veşeud h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Veşeud h.",
					"to": "Hăşag h.",
					"leavesAt": "08:29",
					"arrivesAt": "08:34",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Hăşag h.",
					"to": "Loamneş Hm.",
					"leavesAt": "08:35",
					"arrivesAt": "08:40",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Loamneş Hm.",
					"to": "Mândra h.",
					"leavesAt": "08:41",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mândra h.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:53",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 120,
					"distance": 2100
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Sibiu h.(203)",
					"leavesAt": "09:03",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Sibiu",
					"leavesAt": "09:13",
					"arrivesAt": "09:17",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8382",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "06:29",
					"arrivesAt": "06:35",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "06:36",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "06:41",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "06:51",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "07:02",
					"arrivesAt": "07:08",
					"waitsAtSource": 480,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "07:09",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "07:16",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "07:22",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Agigea Nord",
					"leavesAt": "07:30",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Nord",
					"to": "Constanţa",
					"leavesAt": "07:36",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 5300
				}
			],
			"restrictions": [
				{
					"from": "20180103",
					"to": "20180106",
					"daysOfWeek": 383
				},
				{
					"from": "20180108",
					"to": "20180113",
					"daysOfWeek": 383
				},
				{
					"from": "20180115",
					"to": "20180120",
					"daysOfWeek": 383
				},
				{
					"from": "20180122",
					"to": "20180127",
					"daysOfWeek": 383
				},
				{
					"from": "20180129",
					"to": "20180203",
					"daysOfWeek": 383
				},
				{
					"from": "20180205",
					"to": "20180210",
					"daysOfWeek": 383
				},
				{
					"from": "20180212",
					"to": "20180217",
					"daysOfWeek": 383
				},
				{
					"from": "20180219",
					"to": "20180224",
					"daysOfWeek": 383
				},
				{
					"from": "20180226",
					"to": "20180303",
					"daysOfWeek": 383
				},
				{
					"from": "20180305",
					"to": "20180310",
					"daysOfWeek": 383
				},
				{
					"from": "20180312",
					"to": "20180317",
					"daysOfWeek": 383
				},
				{
					"from": "20180319",
					"to": "20180324",
					"daysOfWeek": 383
				},
				{
					"from": "20180326",
					"to": "20180331",
					"daysOfWeek": 383
				},
				{
					"from": "20180402",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180410",
					"to": "20180414",
					"daysOfWeek": 383
				},
				{
					"from": "20180416",
					"to": "20180421",
					"daysOfWeek": 383
				},
				{
					"from": "20180423",
					"to": "20180426",
					"daysOfWeek": 383
				},
				{
					"from": "20180503",
					"to": "20180505",
					"daysOfWeek": 383
				},
				{
					"from": "20180507",
					"to": "20180512",
					"daysOfWeek": 383
				},
				{
					"from": "20180514",
					"to": "20180519",
					"daysOfWeek": 383
				},
				{
					"from": "20180521",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180602",
					"daysOfWeek": 383
				},
				{
					"from": "20180604",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20180915",
					"daysOfWeek": 383
				},
				{
					"from": "20180917",
					"to": "20180922",
					"daysOfWeek": 383
				},
				{
					"from": "20180924",
					"to": "20180929",
					"daysOfWeek": 383
				},
				{
					"from": "20181001",
					"to": "20181006",
					"daysOfWeek": 383
				},
				{
					"from": "20181008",
					"to": "20181013",
					"daysOfWeek": 383
				},
				{
					"from": "20181015",
					"to": "20181020",
					"daysOfWeek": 383
				},
				{
					"from": "20181022",
					"to": "20181027",
					"daysOfWeek": 383
				},
				{
					"from": "20181029",
					"to": "20181103",
					"daysOfWeek": 383
				},
				{
					"from": "20181105",
					"to": "20181110",
					"daysOfWeek": 383
				},
				{
					"from": "20181112",
					"to": "20181117",
					"daysOfWeek": 383
				},
				{
					"from": "20181119",
					"to": "20181124",
					"daysOfWeek": 383
				},
				{
					"from": "20181126",
					"to": "20181201",
					"daysOfWeek": 383
				},
				{
					"from": "20181203",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171211",
					"to": "20171216",
					"daysOfWeek": 383
				},
				{
					"from": "20171218",
					"to": "20171223",
					"daysOfWeek": 383
				},
				{
					"from": "20171227",
					"to": "20171230",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1094",
			"segments": [
				{
					"from": "Ruse",
					"to": "Giurgiu Nord",
					"leavesAt": "16:10",
					"arrivesAt": "16:35",
					"waitsAtSource": 0,
					"distance": 16000
				},
				{
					"from": "Giurgiu Nord",
					"to": "Videle",
					"leavesAt": "16:58",
					"arrivesAt": "18:07",
					"waitsAtSource": 1380,
					"distance": 63000
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "18:08",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 50900
				}
			],
			"restrictions": [
				{
					"from": "20181002",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180531",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9571",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Belinţ Hm.",
					"leavesAt": "04:51",
					"arrivesAt": "05:01",
					"waitsAtSource": 0,
					"distance": 13200
				},
				{
					"from": "Belinţ Hm.",
					"to": "Chizătău Hm.",
					"leavesAt": "05:02",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Chizătău Hm.",
					"to": "Topolovăţ",
					"leavesAt": "05:07",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Topolovăţ",
					"to": "Şuştra h.",
					"leavesAt": "05:14",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Şuştra h.",
					"to": "Recaş",
					"leavesAt": "05:18",
					"arrivesAt": "05:24",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Recaş",
					"to": "Izvin h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Izvin h.",
					"to": "Remetea Mare",
					"leavesAt": "05:29",
					"arrivesAt": "05:37",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Remetea Mare",
					"to": "Timişoara Est",
					"leavesAt": "05:41",
					"arrivesAt": "05:55",
					"waitsAtSource": 240,
					"distance": 9600
				},
				{
					"from": "Timişoara Est",
					"to": "Timişoara Nord",
					"leavesAt": "05:56",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2514",
			"segments": [
				{
					"from": "Sibiu",
					"to": "Atelier Zona h.",
					"leavesAt": "19:28",
					"arrivesAt": "19:31",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Atelier Zona h.",
					"to": "Sibiu Triaj h.",
					"leavesAt": "19:32",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Sibiu Triaj h.",
					"to": "Sibiu Gr.Şelimbăr Hm.",
					"leavesAt": "19:35",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sibiu Gr.Şelimbăr Hm.",
					"to": "Mohu h.",
					"leavesAt": "19:39",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Mohu h.",
					"to": "Veştem h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:46",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Veştem h.",
					"to": "Tălmaciu Hm.",
					"leavesAt": "19:47",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 7500
				},
				{
					"from": "Tălmaciu Hm.",
					"to": "Podu Olt",
					"leavesAt": "19:57",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Podu Olt",
					"to": "Sebeş Olt h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Sebeş Olt h.",
					"to": "Racoviţa h.",
					"leavesAt": "20:10",
					"arrivesAt": "20:13",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Racoviţa h.",
					"to": "Mârşa h.",
					"leavesAt": "20:14",
					"arrivesAt": "20:17",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Mârşa h.",
					"to": "Avrig Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Avrig Hm.",
					"to": "Porumbacu Hm.",
					"leavesAt": "20:23",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Porumbacu Hm.",
					"to": "Sărata Colun h.",
					"leavesAt": "20:33",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sărata Colun h.",
					"to": "Scoreiu h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:41",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Scoreiu h.",
					"to": "Cârţa h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:46",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Cârţa h.",
					"to": "Arpaş Hm.",
					"leavesAt": "20:47",
					"arrivesAt": "20:51",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Arpaş Hm.",
					"to": "Ucea",
					"leavesAt": "20:52",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Ucea",
					"to": "Viştea h.",
					"leavesAt": "20:59",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Viştea h.",
					"to": "Olteţ h.",
					"leavesAt": "21:03",
					"arrivesAt": "21:07",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Olteţ h.",
					"to": "Voila Hm.",
					"leavesAt": "21:08",
					"arrivesAt": "21:15",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Voila Hm.",
					"to": "Dridif h.",
					"leavesAt": "21:20",
					"arrivesAt": "21:24",
					"waitsAtSource": 300,
					"distance": 3500
				},
				{
					"from": "Dridif h.",
					"to": "Beclean pe Olt h.",
					"leavesAt": "21:25",
					"arrivesAt": "21:29",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Beclean pe Olt h.",
					"to": "Făgăraş",
					"leavesAt": "21:30",
					"arrivesAt": "21:38",
					"waitsAtSource": 30,
					"distance": 5200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2606",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "14:44",
					"arrivesAt": "14:51",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Valea Viilor Hm.",
					"leavesAt": "14:55",
					"arrivesAt": "15:05",
					"waitsAtSource": 240,
					"distance": 5500
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Şag Hm.",
					"leavesAt": "15:15",
					"arrivesAt": "15:20",
					"waitsAtSource": 600,
					"distance": 5500
				},
				{
					"from": "Şag Hm.",
					"to": "Vinga Hm.",
					"leavesAt": "15:21",
					"arrivesAt": "15:27",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vinga Hm.",
					"to": "Orţişoara",
					"leavesAt": "15:28",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Orţişoara",
					"to": "Băile Călacea",
					"leavesAt": "15:34",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Băile Călacea",
					"to": "Sânandrei Hm.",
					"leavesAt": "15:40",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "15:55",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "15:58",
					"arrivesAt": "16:06",
					"waitsAtSource": 30,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2143",
			"segments": [
				{
					"from": "Simeria",
					"to": "Bârcea Mare h.",
					"leavesAt": "14:03",
					"arrivesAt": "14:09",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Bârcea Mare h.",
					"to": "Bârcea Mică",
					"leavesAt": "14:10",
					"arrivesAt": "14:13",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Bârcea Mică",
					"to": "Pestişu Mare h.",
					"leavesAt": "14:14",
					"arrivesAt": "14:18",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Pestişu Mare h.",
					"to": "Hunedoara",
					"leavesAt": "14:19",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5603",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "06:40",
					"arrivesAt": "06:54",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "06:55",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Budăi hc.",
					"leavesAt": "07:03",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Budăi hc.",
					"to": "Sârca Hm.",
					"leavesAt": "07:10",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Sârca Hm.",
					"to": "Târgu Frumos",
					"leavesAt": "07:18",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Târgu Frumos",
					"to": "Pietrişu h.",
					"leavesAt": "07:28",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pietrişu h.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "07:35",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Ruginoasa Hm.",
					"leavesAt": "07:40",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Paşcani",
					"leavesAt": "07:50",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 14700
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "08:20",
					"arrivesAt": "08:25",
					"waitsAtSource": 960,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "08:26",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "08:43",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "08:49",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "08:56",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "09:03",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "09:10",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "09:17",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "09:24",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "09:33",
					"arrivesAt": "09:39",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1649",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Sărăţel Hm.",
					"leavesAt": "22:35",
					"arrivesAt": "22:47",
					"waitsAtSource": 0,
					"distance": 10700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5027",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "22:15",
					"arrivesAt": "22:25",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "22:26",
					"arrivesAt": "22:32",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "22:33",
					"arrivesAt": "22:37",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "22:38",
					"arrivesAt": "22:46",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "22:47",
					"arrivesAt": "22:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "22:52",
					"arrivesAt": "22:57",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "22:58",
					"arrivesAt": "23:02",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "23:03",
					"arrivesAt": "23:11",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "23:12",
					"arrivesAt": "23:28",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8081",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Bucureşti Băneasa",
					"leavesAt": "04:47",
					"arrivesAt": "04:55",
					"waitsAtSource": 0,
					"distance": 6600
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Pantelimon",
					"leavesAt": "04:56",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Pantelimon",
					"to": "Pantelimon Sud hc.",
					"leavesAt": "05:24",
					"arrivesAt": "05:28",
					"waitsAtSource": 1020,
					"distance": 600
				},
				{
					"from": "Pantelimon Sud hc.",
					"to": "Bucureşti Obor",
					"leavesAt": "05:29",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4095",
			"segments": [
				{
					"from": "Jibou",
					"to": "Var h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:44",
					"waitsAtSource": 0,
					"distance": 2800
				},
				{
					"from": "Var h.",
					"to": "Surduc Sălaj Hm.",
					"leavesAt": "16:45",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Surduc Sălaj Hm.",
					"to": "Ciocmani h.",
					"leavesAt": "16:56",
					"arrivesAt": "17:02",
					"waitsAtSource": 360,
					"distance": 4400
				},
				{
					"from": "Ciocmani h.",
					"to": "Băbuţeni Hm.",
					"leavesAt": "17:03",
					"arrivesAt": "17:09",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Băbuţeni Hm.",
					"to": "Cuciulat Hm.",
					"leavesAt": "17:10",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Cuciulat Hm.",
					"to": "Letca Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Letca Hm.",
					"to": "Răstoci Hm.",
					"leavesAt": "17:24",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Răstoci Hm.",
					"to": "Bizuşa h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bizuşa h.",
					"to": "Ileanda",
					"leavesAt": "17:41",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Ileanda",
					"to": "Rus h.",
					"leavesAt": "17:46",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Rus h.",
					"to": "Glodu Someşului h.",
					"leavesAt": "17:52",
					"arrivesAt": "17:57",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Glodu Someşului h.",
					"to": "Gâlgău h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Gâlgău h.",
					"to": "Gâlgău",
					"leavesAt": "18:03",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Gâlgău",
					"to": "Căpâlna pe Someş h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Căpâlna pe Someş h.",
					"to": "Câţcău h.",
					"leavesAt": "18:17",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Câţcău h.",
					"to": "Coplean h.",
					"leavesAt": "18:23",
					"arrivesAt": "18:27",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Coplean h.",
					"to": "Căşeiu Hm.",
					"leavesAt": "18:28",
					"arrivesAt": "18:31",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Căşeiu Hm.",
					"to": "C. C. H. Dej h.",
					"leavesAt": "18:32",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "C. C. H. Dej h.",
					"to": "Dej Călători",
					"leavesAt": "18:38",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "18:44",
					"arrivesAt": "18:52",
					"waitsAtSource": 120,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Gherla",
					"leavesAt": "18:53",
					"arrivesAt": "19:04",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "19:05",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "19:12",
					"arrivesAt": "19:17",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "19:18",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "19:22",
					"arrivesAt": "19:27",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "19:28",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "19:32",
					"arrivesAt": "19:37",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida h.",
					"leavesAt": "19:38",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Apahida h.",
					"to": "Apahida",
					"leavesAt": "19:45",
					"arrivesAt": "19:50",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Apahida",
					"to": "Dezmir h.",
					"leavesAt": "19:51",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Dezmir h.",
					"to": "Cluj Napoca Est",
					"leavesAt": "19:55",
					"arrivesAt": "20:02",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "20:09",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8593",
			"segments": [
				{
					"from": "Ciulniţa",
					"to": "Ştefan Vodă h.",
					"leavesAt": "15:35",
					"arrivesAt": "15:48",
					"waitsAtSource": 0,
					"distance": 12600
				},
				{
					"from": "Ştefan Vodă h.",
					"to": "Călăraşi Nord Hm.",
					"leavesAt": "15:49",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Călăraşi Nord Hm.",
					"to": "Km. 25+700 h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Km. 25+700 h.",
					"to": "Călăraşi Sud",
					"leavesAt": "16:03",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 1300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4407",
			"segments": [
				{
					"from": "Satu Mare",
					"to": "Ram. Botiz h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:46",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Micula Hm.",
					"leavesAt": "14:47",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Micula Hm.",
					"to": "Porumbeşti Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Halmeu",
					"leavesAt": "15:05",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20180113",
					"to": "20180123",
					"daysOfWeek": 799
				},
				{
					"from": "20180125",
					"to": "20180202",
					"daysOfWeek": 799
				},
				{
					"from": "20180211",
					"to": "20180331",
					"daysOfWeek": 799
				},
				{
					"from": "20180411",
					"to": "20180430",
					"daysOfWeek": 799
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 799
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 799
				},
				{
					"from": "20180602",
					"to": "20180615",
					"daysOfWeek": 799
				},
				{
					"from": "20180908",
					"to": "20181129",
					"daysOfWeek": 799
				},
				{
					"from": "20181201",
					"to": "20181208",
					"daysOfWeek": 799
				},
				{
					"from": "20171210",
					"to": "20171222",
					"daysOfWeek": 799
				},
				{
					"from": "20171230",
					"to": "20171231",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1785",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Titu",
					"leavesAt": "11:30",
					"arrivesAt": "12:30",
					"waitsAtSource": 0,
					"distance": 48000
				},
				{
					"from": "Titu",
					"to": "Găeşti",
					"leavesAt": "12:31",
					"arrivesAt": "12:50",
					"waitsAtSource": 60,
					"distance": 21800
				},
				{
					"from": "Găeşti",
					"to": "Goleşti",
					"leavesAt": "12:51",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Goleşti",
					"to": "Piteşti",
					"leavesAt": "13:15",
					"arrivesAt": "13:26",
					"waitsAtSource": 60,
					"distance": 7800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1550",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "06:06",
					"arrivesAt": "06:11",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crivina",
					"leavesAt": "06:20",
					"arrivesAt": "06:35",
					"waitsAtSource": 540,
					"distance": 19200
				},
				{
					"from": "Crivina",
					"to": "Buftea",
					"leavesAt": "06:36",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 22800
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "06:53",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "369",
			"segments": [
				{
					"from": "Biharkeresztes",
					"to": "Episcopia Bihor",
					"leavesAt": "09:02",
					"arrivesAt": "09:17",
					"waitsAtSource": 0,
					"distance": 12500
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "09:35",
					"arrivesAt": "09:43",
					"waitsAtSource": 1080,
					"distance": 5700
				},
				{
					"from": "Oradea",
					"to": "Leş Bihor Hm.",
					"leavesAt": "09:56",
					"arrivesAt": "10:13",
					"waitsAtSource": 780,
					"distance": 16300
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Cefa Hm.",
					"leavesAt": "10:14",
					"arrivesAt": "10:25",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Cefa Hm.",
					"to": "Salonta",
					"leavesAt": "10:26",
					"arrivesAt": "10:38",
					"waitsAtSource": 60,
					"distance": 12500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9023",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:05",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "08:06",
					"arrivesAt": "08:09",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "08:10",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "08:14",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Chitila",
					"leavesAt": "08:18",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Sabareni",
					"leavesAt": "08:22",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Sabareni",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "08:31",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Bâldana h.",
					"leavesAt": "08:44",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Bâldana h.",
					"to": "Ghergani Hm.",
					"leavesAt": "08:56",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Ghergani Hm.",
					"to": "Conţeşti h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Conţeşti h.",
					"to": "Boteni h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:20",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boteni h.",
					"to": "Titu",
					"leavesAt": "09:21",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Titu",
					"to": "Fusea Hm.",
					"leavesAt": "09:30",
					"arrivesAt": "09:36",
					"waitsAtSource": 120,
					"distance": 5400
				},
				{
					"from": "Fusea Hm.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "09:37",
					"arrivesAt": "09:43",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Cojocaru h.",
					"leavesAt": "09:44",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Cojocaru h.",
					"to": "Găeşti Sud h.",
					"leavesAt": "09:50",
					"arrivesAt": "09:53",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Găeşti Sud h.",
					"to": "Găeşti",
					"leavesAt": "09:54",
					"arrivesAt": "10:00",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Găeşti",
					"to": "Pătroaia Hm.",
					"leavesAt": "10:01",
					"arrivesAt": "10:09",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Pătroaia Hm.",
					"to": "Leordeni Argeş",
					"leavesAt": "10:10",
					"arrivesAt": "10:17",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Leordeni Argeş",
					"to": "Călineşti Hm.",
					"leavesAt": "10:18",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Călineşti Hm.",
					"to": "Goleşti",
					"leavesAt": "10:25",
					"arrivesAt": "10:33",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Goleşti",
					"to": "Ram. Goleşti",
					"leavesAt": "10:34",
					"arrivesAt": "10:39",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ram. Goleşti",
					"to": "Piteşti",
					"leavesAt": "10:40",
					"arrivesAt": "10:50",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Piteşti",
					"to": "Bradu de Sus",
					"leavesAt": "11:10",
					"arrivesAt": "11:15",
					"waitsAtSource": 1200,
					"distance": 4500
				},
				{
					"from": "Bradu de Sus",
					"to": "Pârvu h.",
					"leavesAt": "11:16",
					"arrivesAt": "11:25",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Pârvu h.",
					"to": "Costeşti",
					"leavesAt": "11:26",
					"arrivesAt": "11:38",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Costeşti",
					"to": "Stolnici Hm.",
					"leavesAt": "11:39",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 15900
				},
				{
					"from": "Stolnici Hm.",
					"to": "Hârseşti Hm.",
					"leavesAt": "11:54",
					"arrivesAt": "11:59",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Corbu",
					"leavesAt": "12:00",
					"arrivesAt": "12:05",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Corbu",
					"to": "Sineşti Hm.",
					"leavesAt": "12:06",
					"arrivesAt": "12:12",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Sineşti Hm.",
					"to": "Potcoava",
					"leavesAt": "12:13",
					"arrivesAt": "12:19",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Potcoava",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "12:20",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Recea Hm.",
					"leavesAt": "12:28",
					"arrivesAt": "12:35",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Recea Hm.",
					"to": "Slatina",
					"leavesAt": "12:36",
					"arrivesAt": "12:44",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Slatina",
					"to": "Criva h.",
					"leavesAt": "12:45",
					"arrivesAt": "12:58",
					"waitsAtSource": 60,
					"distance": 13000
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "12:59",
					"arrivesAt": "13:05",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8388",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "14:00",
					"arrivesAt": "14:06",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "14:07",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Pescăruş h.",
					"leavesAt": "14:12",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pescăruş h.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "14:18",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "14:24",
					"arrivesAt": "14:27",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "14:28",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "14:35",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "14:42",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "14:48",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "14:57",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180529",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180427",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5733",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "05:31",
					"arrivesAt": "05:36",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava Nord",
					"to": "Dărmăneşti",
					"leavesAt": "05:37",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dărmăneşti",
					"to": "Părhăuţi h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:59",
					"waitsAtSource": 360,
					"distance": 4400
				},
				{
					"from": "Părhăuţi h.",
					"to": "Todireşti h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Todireşti h.",
					"to": "Soloneţ h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Soloneţ h.",
					"to": "Pârteşti h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Pârteşti h.",
					"to": "Cacica Hm.",
					"leavesAt": "06:24",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1698",
			"segments": [
				{
					"from": "Reşiţa Sud Hm.",
					"to": "Reşiţa Nord",
					"leavesAt": "05:17",
					"arrivesAt": "05:26",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Reşiţa Nord",
					"to": "Cornuţel Banat Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 29000
				},
				{
					"from": "Cornuţel Banat Hm.",
					"to": "Caransebeş",
					"leavesAt": "06:01",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Caransebeş",
					"to": "Lugoj",
					"leavesAt": "06:39",
					"arrivesAt": "07:12",
					"waitsAtSource": 1560,
					"distance": 39400
				},
				{
					"from": "Lugoj",
					"to": "Recaş",
					"leavesAt": "07:13",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 35700
				},
				{
					"from": "Recaş",
					"to": "Timişoara Nord",
					"leavesAt": "07:39",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 23200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9411",
			"segments": [
				{
					"from": "Potcoava",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "06:50",
					"arrivesAt": "06:58",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Recea Hm.",
					"leavesAt": "06:59",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Recea Hm.",
					"to": "Slatina",
					"leavesAt": "07:12",
					"arrivesAt": "07:20",
					"waitsAtSource": 300,
					"distance": 7800
				},
				{
					"from": "Slatina",
					"to": "Milcov Hm.",
					"leavesAt": "07:22",
					"arrivesAt": "07:28",
					"waitsAtSource": 120,
					"distance": 5300
				},
				{
					"from": "Milcov Hm.",
					"to": "Slătioara Hm.",
					"leavesAt": "07:29",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "07:42",
					"arrivesAt": "07:48",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 288
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1558",
			"segments": [
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "06:40",
					"arrivesAt": "07:13",
					"waitsAtSource": 0,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "07:14",
					"arrivesAt": "07:49",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Buftea",
					"leavesAt": "07:51",
					"arrivesAt": "08:28",
					"waitsAtSource": 120,
					"distance": 43300
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "08:29",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4582",
			"segments": [
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "11:05",
					"arrivesAt": "11:12",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "11:13",
					"arrivesAt": "11:17",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "11:18",
					"arrivesAt": "11:23",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "11:24",
					"arrivesAt": "11:27",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "11:28",
					"arrivesAt": "11:36",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "11:37",
					"arrivesAt": "11:42",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "11:43",
					"arrivesAt": "11:49",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 831
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2566",
			"segments": [
				{
					"from": "Mediaş",
					"to": "Târnava h.",
					"leavesAt": "12:25",
					"arrivesAt": "12:33",
					"waitsAtSource": 0,
					"distance": 5100
				},
				{
					"from": "Târnava h.",
					"to": "Copşa Mică",
					"leavesAt": "12:34",
					"arrivesAt": "12:41",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Copşa Mică",
					"to": "Axente Sever h.",
					"leavesAt": "12:57",
					"arrivesAt": "13:02",
					"waitsAtSource": 960,
					"distance": 2700
				},
				{
					"from": "Axente Sever h.",
					"to": "Agârbiciu h.",
					"leavesAt": "13:03",
					"arrivesAt": "13:09",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Agârbiciu h.",
					"to": "Şeica Mare",
					"leavesAt": "13:10",
					"arrivesAt": "13:16",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şeica Mare",
					"to": "Şeica Mare h.",
					"leavesAt": "13:21",
					"arrivesAt": "13:23",
					"waitsAtSource": 300,
					"distance": 1400
				},
				{
					"from": "Şeica Mare h.",
					"to": "Veşeud h.",
					"leavesAt": "13:24",
					"arrivesAt": "13:29",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Veşeud h.",
					"to": "Hăşag h.",
					"leavesAt": "13:30",
					"arrivesAt": "13:35",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Hăşag h.",
					"to": "Loamneş Hm.",
					"leavesAt": "13:36",
					"arrivesAt": "13:41",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Loamneş Hm.",
					"to": "Mândra h.",
					"leavesAt": "13:42",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Mândra h.",
					"to": "Băile Ocna Sibiului h.",
					"leavesAt": "13:46",
					"arrivesAt": "13:54",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Băile Ocna Sibiului h.",
					"to": "Ocna Sibiului Hm.",
					"leavesAt": "13:56",
					"arrivesAt": "14:03",
					"waitsAtSource": 120,
					"distance": 2100
				},
				{
					"from": "Ocna Sibiului Hm.",
					"to": "Sibiu h.(203)",
					"leavesAt": "14:04",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Sibiu h.(203)",
					"to": "Sibiu",
					"leavesAt": "14:14",
					"arrivesAt": "14:18",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8123",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Carpaţi h.(700)",
					"leavesAt": "16:45",
					"arrivesAt": "16:51",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Carpaţi h.(700)",
					"to": "Pajura Hm. (700)",
					"leavesAt": "16:52",
					"arrivesAt": "16:55",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (700)",
					"to": "Mogoşoaia",
					"leavesAt": "16:56",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Mogoşoaia",
					"to": "P.O. Aeroport h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "P.O. Aeroport h.",
					"to": "Baloteşti Hm.",
					"leavesAt": "17:27",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Baloteşti Hm.",
					"to": "Căciulaţi Hm.",
					"leavesAt": "17:31",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Căciulaţi Hm.",
					"to": "Moara Vlasiei Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Moara Vlasiei Hm.",
					"to": "Greci h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Greci h.",
					"to": "Fierbinţi",
					"leavesAt": "17:49",
					"arrivesAt": "17:55",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Fierbinţi",
					"to": "Dridu Hm.",
					"leavesAt": "17:56",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Dridu Hm.",
					"to": "Moldoveni h.",
					"leavesAt": "18:03",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Moldoveni h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "18:09",
					"arrivesAt": "18:14",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "18:15",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "18:20",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Urziceni",
					"to": "Alexeni h.",
					"leavesAt": "18:37",
					"arrivesAt": "18:43",
					"waitsAtSource": 660,
					"distance": 5800
				},
				{
					"from": "Alexeni h.",
					"to": "Broşteni Hm.",
					"leavesAt": "18:44",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Broşteni Hm.",
					"to": "Malu h.",
					"leavesAt": "18:52",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Malu h.",
					"to": "Km. 74+600 h.",
					"leavesAt": "18:58",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Km. 74+600 h.",
					"to": "Sărăţuica Hm.",
					"leavesAt": "19:03",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Sărăţuica Hm.",
					"to": "Sărăţeni Ialomiţa h.",
					"leavesAt": "19:08",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sărăţeni Ialomiţa h.",
					"to": "Munteni Buzău h.",
					"leavesAt": "19:13",
					"arrivesAt": "19:17",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Munteni Buzău h.",
					"to": "Căzăneşti",
					"leavesAt": "19:18",
					"arrivesAt": "19:24",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Căzăneşti",
					"to": "Ciochina hc.",
					"leavesAt": "19:25",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ciochina hc.",
					"to": "Andrăşeşti Hm.",
					"leavesAt": "19:32",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Andrăşeşti Hm.",
					"to": "Fundata h.",
					"leavesAt": "19:42",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Fundata h.",
					"to": "Perieţi h.",
					"leavesAt": "19:47",
					"arrivesAt": "19:52",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Perieţi h.",
					"to": "Slobozia Veche",
					"leavesAt": "19:53",
					"arrivesAt": "20:04",
					"waitsAtSource": 30,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1553",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "18:52",
					"arrivesAt": "19:06",
					"waitsAtSource": 0,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Crivina",
					"leavesAt": "19:07",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 22800
				},
				{
					"from": "Crivina",
					"to": "Ploieşti Sud",
					"leavesAt": "19:22",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 20500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7570",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "14:35",
					"arrivesAt": "14:49",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "14:50",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Şendreni Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Şendreni Hm.",
					"to": "Şerbeştii Vechi h.",
					"leavesAt": "15:06",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Şerbeştii Vechi h.",
					"to": "Braniştea h.",
					"leavesAt": "15:11",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Braniştea h.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "15:16",
					"arrivesAt": "15:19",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Independenţa Hm.",
					"leavesAt": "15:20",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Independenţa Hm.",
					"to": "Piscu h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Piscu h.",
					"to": "Vameş h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Vameş h.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "15:38",
					"arrivesAt": "15:44",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "15:45",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Şerbăneşti h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:56",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Lieşti",
					"leavesAt": "15:57",
					"arrivesAt": "16:00",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lieşti",
					"to": "Buceşti h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:04",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Buceşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "16:05",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Iveşti Hm.",
					"to": "Umbrăreşti h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Barcea",
					"leavesAt": "16:16",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Barcea",
					"to": "Malul Alb h.",
					"leavesAt": "16:23",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Malul Alb h.",
					"to": "Tecuci",
					"leavesAt": "16:27",
					"arrivesAt": "16:37",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Tecuci",
					"to": "Cosmeşti Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:47",
					"waitsAtSource": 180,
					"distance": 7400
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "16:48",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "16:54",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1792",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Goleşti",
					"leavesAt": "16:00",
					"arrivesAt": "16:11",
					"waitsAtSource": 0,
					"distance": 7800
				},
				{
					"from": "Goleşti",
					"to": "Găeşti",
					"leavesAt": "16:12",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 30400
				},
				{
					"from": "Găeşti",
					"to": "Cojocaru h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Cojocaru h.",
					"to": "Mătăsaru Hm.",
					"leavesAt": "16:42",
					"arrivesAt": "16:47",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Mătăsaru Hm.",
					"to": "Fusea Hm.",
					"leavesAt": "16:48",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Fusea Hm.",
					"to": "Titu",
					"leavesAt": "16:54",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Titu",
					"to": "Bucureşti Nord",
					"leavesAt": "17:03",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 48000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1993",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "12:50",
					"arrivesAt": "12:57",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "12:58",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "13:05",
					"arrivesAt": "13:18",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "13:20",
					"arrivesAt": "13:24",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "13:26",
					"arrivesAt": "13:34",
					"waitsAtSource": 120,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "13:35",
					"arrivesAt": "13:44",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "13:47",
					"arrivesAt": "13:54",
					"waitsAtSource": 180,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "13:57",
					"arrivesAt": "14:21",
					"waitsAtSource": 180,
					"distance": 14000
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "14:40",
					"arrivesAt": "15:04",
					"waitsAtSource": 1140,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Feteşti",
					"leavesAt": "15:05",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 44000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "15:36",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "15:59",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 108900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "17:25",
					"arrivesAt": "18:15",
					"waitsAtSource": 1860,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "18:16",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Drăgăneşti Olt",
					"leavesAt": "19:03",
					"arrivesAt": "19:34",
					"waitsAtSource": 120,
					"distance": 37300
				},
				{
					"from": "Drăgăneşti Olt",
					"to": "Caracal",
					"leavesAt": "19:35",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "19:54",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 53600
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2186",
			"segments": [
				{
					"from": "Lugoj",
					"to": "Lugoj Nord h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:54",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Lugoj Nord h.",
					"to": "Coşteiu Mare Hm.",
					"leavesAt": "15:55",
					"arrivesAt": "16:00",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Coşteiu Mare Hm.",
					"to": "Păru h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Păru h.",
					"to": "Balinţ h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:07",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Balinţ h.",
					"to": "Nevrincea h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Nevrincea h.",
					"to": "Cliciova",
					"leavesAt": "16:11",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Cliciova",
					"to": "Susani Bega h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Susani Bega h.",
					"to": "Traian Vuia h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Traian Vuia h.",
					"to": "Mănăştur Hm.",
					"leavesAt": "16:23",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Mănăştur Hm.",
					"to": "Răchita h.",
					"leavesAt": "16:28",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Răchita h.",
					"to": "Făget",
					"leavesAt": "16:32",
					"arrivesAt": "16:37",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Făget",
					"to": "Margina",
					"leavesAt": "16:38",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6826",
			"segments": [
				{
					"from": "Nyirabrany",
					"to": "Valea lui Mihai",
					"leavesAt": "17:31",
					"arrivesAt": "17:46",
					"waitsAtSource": 0,
					"distance": 8800
				},
				{
					"from": "Valea lui Mihai",
					"to": "Curtuiuşeni h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:11",
					"waitsAtSource": 1140,
					"distance": 6300
				},
				{
					"from": "Curtuiuşeni h.",
					"to": "Resighea h.",
					"leavesAt": "18:12",
					"arrivesAt": "18:18",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Resighea h.",
					"to": "Sanislău Hm.",
					"leavesAt": "18:19",
					"arrivesAt": "18:24",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Sanislău Hm.",
					"to": "Marna h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Marna h.",
					"to": "Carei",
					"leavesAt": "18:31",
					"arrivesAt": "18:38",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Carei",
					"to": "Domăneşti h.",
					"leavesAt": "18:43",
					"arrivesAt": "18:52",
					"waitsAtSource": 300,
					"distance": 9900
				},
				{
					"from": "Domăneşti h.",
					"to": "Moftin h.",
					"leavesAt": "18:53",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Moftin h.",
					"to": "Gen. Gh. Avramescu Hm.",
					"leavesAt": "18:59",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Gen. Gh. Avramescu Hm.",
					"to": "Sătmărel h.",
					"leavesAt": "19:04",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 9900
				},
				{
					"from": "Sătmărel h.",
					"to": "Satu Mare Sud",
					"leavesAt": "19:14",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Satu Mare Sud",
					"to": "Satu Mare",
					"leavesAt": "19:22",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Satu Mare",
					"to": "Botiz Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:10",
					"waitsAtSource": 2040,
					"distance": 5500
				},
				{
					"from": "Botiz Hm.",
					"to": "Odoreu h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Odoreu h.",
					"to": "Medieşu Aurit Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Medieşu Aurit Hm.",
					"to": "Apa Hm.",
					"leavesAt": "20:31",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Apa Hm.",
					"to": "Seini",
					"leavesAt": "20:41",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Seini",
					"to": "Săbişa h.",
					"leavesAt": "21:08",
					"arrivesAt": "21:14",
					"waitsAtSource": 660,
					"distance": 3300
				},
				{
					"from": "Săbişa h.",
					"to": "Ilba h.",
					"leavesAt": "21:15",
					"arrivesAt": "21:19",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ilba h.",
					"to": "Cicârlău h.",
					"leavesAt": "21:20",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Cicârlău h.",
					"to": "Buşag Hm.",
					"leavesAt": "21:29",
					"arrivesAt": "21:35",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Buşag Hm.",
					"to": "Baia Mare",
					"leavesAt": "21:36",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 10500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1987",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Feteşti",
					"leavesAt": "03:15",
					"arrivesAt": "04:46",
					"waitsAtSource": 0,
					"distance": 146400
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "04:47",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "05:08",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "05:26",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 36000
				},
				{
					"from": "Constanţa",
					"to": "Agigea Nord",
					"leavesAt": "06:15",
					"arrivesAt": "06:26",
					"waitsAtSource": 960,
					"distance": 5300
				},
				{
					"from": "Agigea Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "06:35",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "06:46",
					"arrivesAt": "06:53",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "06:55",
					"arrivesAt": "07:04",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "07:05",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "07:21",
					"arrivesAt": "07:25",
					"waitsAtSource": 480,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Pescăruş h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:33",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Pescăruş h.",
					"to": "Neptun hc.",
					"leavesAt": "07:34",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Neptun hc.",
					"to": "Neptun",
					"leavesAt": "07:43",
					"arrivesAt": "07:48",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Neptun",
					"to": "Mangalia",
					"leavesAt": "07:49",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20180427",
					"to": "20180501",
					"daysOfWeek": 383
				},
				{
					"from": "20180524",
					"to": "20180528",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "365",
			"segments": [
				{
					"from": "Biharkeresztes",
					"to": "Episcopia Bihor",
					"leavesAt": "15:37",
					"arrivesAt": "15:52",
					"waitsAtSource": 0,
					"distance": 12500
				},
				{
					"from": "Episcopia Bihor",
					"to": "Oradea",
					"leavesAt": "16:07",
					"arrivesAt": "16:15",
					"waitsAtSource": 900,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4509",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "12:09",
					"arrivesAt": "12:14",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "12:15",
					"arrivesAt": "12:21",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "12:22",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "12:29",
					"arrivesAt": "12:32",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "12:33",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "12:38",
					"arrivesAt": "12:44",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "12:51",
					"arrivesAt": "13:00",
					"waitsAtSource": 420,
					"distance": 7600
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Arcuş h.",
					"leavesAt": "13:04",
					"arrivesAt": "13:08",
					"waitsAtSource": 240,
					"distance": 5000
				},
				{
					"from": "Arcuş h.",
					"to": "Bodoc Hm.",
					"leavesAt": "13:09",
					"arrivesAt": "13:14",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Bodoc Hm.",
					"to": "Malnaş h.",
					"leavesAt": "13:15",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Malnaş h.",
					"to": "Malnaş Băi",
					"leavesAt": "13:23",
					"arrivesAt": "13:29",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Malnaş Băi",
					"to": "Bicsadu Oltului Hm.",
					"leavesAt": "13:30",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Bicsadu Oltului Hm.",
					"to": "Băile Tuşnad Hm.",
					"leavesAt": "13:40",
					"arrivesAt": "13:48",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băile Tuşnad Hm.",
					"to": "Tuşnad Sat",
					"leavesAt": "13:49",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Tuşnad Sat",
					"to": "Vrabia h.",
					"leavesAt": "13:57",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Vrabia h.",
					"to": "Sânsimion Hm.",
					"leavesAt": "14:01",
					"arrivesAt": "14:07",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Sânsimion Hm.",
					"to": "Sântimbru Ciuc h.",
					"leavesAt": "14:08",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sântimbru Ciuc h.",
					"to": "Sâncrăieni Hm.",
					"leavesAt": "14:12",
					"arrivesAt": "14:16",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sâncrăieni Hm.",
					"to": "Miercurea Ciuc",
					"leavesAt": "14:17",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Miercurea Ciuc",
					"to": "Siculeni",
					"leavesAt": "14:28",
					"arrivesAt": "14:36",
					"waitsAtSource": 180,
					"distance": 8200
				},
				{
					"from": "Siculeni",
					"to": "Racu h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:43",
					"waitsAtSource": 240,
					"distance": 2200
				},
				{
					"from": "Racu h.",
					"to": "Mădăraş Ciuc Hm.",
					"leavesAt": "14:44",
					"arrivesAt": "14:51",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Mădăraş Ciuc Hm.",
					"to": "Dăneşti h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Dăneşti h.",
					"to": "Cârţani h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Cârţani h.",
					"to": "Tomeşti h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Tomeşti h.",
					"to": "Izvoru Oltului",
					"leavesAt": "15:05",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Izvoru Oltului",
					"to": "Sândominic h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:14",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sândominic h.",
					"to": "Izvoru Mureşului Hm.",
					"leavesAt": "15:15",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 7800
				},
				{
					"from": "Izvoru Mureşului Hm.",
					"to": "Voşlăbeni Hm.",
					"leavesAt": "15:32",
					"arrivesAt": "15:44",
					"waitsAtSource": 420,
					"distance": 10100
				},
				{
					"from": "Voşlăbeni Hm.",
					"to": "Şugău h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Şugău h.",
					"to": "Valea Strâmbă h.",
					"leavesAt": "15:49",
					"arrivesAt": "15:52",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Valea Strâmbă h.",
					"to": "Gheorgheni",
					"leavesAt": "15:53",
					"arrivesAt": "15:58",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4530",
			"segments": [
				{
					"from": "Războieni",
					"to": "Lunca Mureşului h.",
					"leavesAt": "03:35",
					"arrivesAt": "03:40",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Gura Arieşului h.",
					"leavesAt": "03:41",
					"arrivesAt": "03:45",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Cheţani h.",
					"leavesAt": "03:46",
					"arrivesAt": "03:53",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cheţani h.",
					"to": "Luduş",
					"leavesAt": "03:54",
					"arrivesAt": "04:02",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Luduş",
					"to": "Bogata Mureş h.",
					"leavesAt": "04:09",
					"arrivesAt": "04:14",
					"waitsAtSource": 420,
					"distance": 2700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Cuci h.",
					"leavesAt": "04:15",
					"arrivesAt": "04:21",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cuci h.",
					"to": "Iernut",
					"leavesAt": "04:22",
					"arrivesAt": "04:28",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Iernut",
					"to": "Cipău h.",
					"leavesAt": "04:30",
					"arrivesAt": "04:34",
					"waitsAtSource": 120,
					"distance": 4100
				},
				{
					"from": "Cipău h.",
					"to": "Ogra h.",
					"leavesAt": "04:35",
					"arrivesAt": "04:38",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ogra h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "04:39",
					"arrivesAt": "04:43",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Chirileu h.",
					"leavesAt": "04:44",
					"arrivesAt": "04:48",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chirileu h.",
					"to": "Vidrasău h.",
					"leavesAt": "04:49",
					"arrivesAt": "04:53",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vidrasău h.",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "04:54",
					"arrivesAt": "04:59",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "05:00",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "Azomureş h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş",
					"leavesAt": "05:09",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Târgu Mureş",
					"to": "Târgu Mureş Nord Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:26",
					"waitsAtSource": 240,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5425",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "06:39",
					"arrivesAt": "06:50",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "06:51",
					"arrivesAt": "06:55",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "06:56",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "07:02",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "07:12",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "07:17",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "07:26",
					"arrivesAt": "07:33",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "07:34",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "07:41",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "07:46",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "07:52",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani Triaj",
					"leavesAt": "08:02",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Paşcani Triaj",
					"to": "Paşcani",
					"leavesAt": "08:08",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "08:41",
					"arrivesAt": "08:55",
					"waitsAtSource": 1560,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "08:56",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "09:10",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "09:19",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "09:30",
					"arrivesAt": "09:36",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "09:37",
					"arrivesAt": "09:43",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "09:44",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "09:52",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2466",
			"segments": [
				{
					"from": "Podu Olt",
					"to": "Turnu Roşu hc.",
					"leavesAt": "20:10",
					"arrivesAt": "20:15",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Turnu Roşu hc.",
					"to": "Valea Mărului Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:25",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Valea Mărului Hm.",
					"to": "Râu Vadului h.",
					"leavesAt": "20:26",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Râu Vadului h.",
					"to": "Câineni",
					"leavesAt": "20:41",
					"arrivesAt": "20:50",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Câineni",
					"to": "Robeşti h.",
					"leavesAt": "20:51",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Robeşti h.",
					"to": "Balota h.",
					"leavesAt": "20:59",
					"arrivesAt": "21:02",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Balota h.",
					"to": "Cornet Hm.",
					"leavesAt": "21:03",
					"arrivesAt": "21:09",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Cornet Hm.",
					"to": "Beţel h.",
					"leavesAt": "21:10",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Beţel h.",
					"to": "Lotru",
					"leavesAt": "21:15",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Lotru",
					"to": "Cozia Hm.",
					"leavesAt": "21:23",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cozia Hm.",
					"to": "Mânăstirea Turnu h.",
					"leavesAt": "21:32",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mânăstirea Turnu h.",
					"to": "Păuşa h.",
					"leavesAt": "21:38",
					"arrivesAt": "21:43",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Păuşa h.",
					"to": "Călimăneşti",
					"leavesAt": "21:44",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Călimăneşti",
					"to": "Dăeşti Hm.",
					"leavesAt": "21:50",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Dăeşti Hm.",
					"to": "Bujoreni Vâlcea Hm.",
					"leavesAt": "21:58",
					"arrivesAt": "22:06",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Bujoreni Vâlcea Hm.",
					"to": "Râmnicu Vâlcea Nord h.",
					"leavesAt": "22:07",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râmnicu Vâlcea Nord h.",
					"to": "Râmnicu Vâlcea",
					"leavesAt": "22:13",
					"arrivesAt": "22:16",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 480
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9106",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:07",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "15:08",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "15:14",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "15:19",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:27",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Podu Rizii h.",
					"leavesAt": "15:28",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Podu Rizii h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "15:38",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Titu",
					"to": "Boteni h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:49",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Boteni h.",
					"to": "Conţeşti h.",
					"leavesAt": "15:50",
					"arrivesAt": "15:53",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Conţeşti h.",
					"to": "Ghergani Hm.",
					"leavesAt": "15:54",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Bâldana h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 600,
					"distance": 5800
				},
				{
					"from": "Bâldana h.",
					"to": "Ciocăneşti Hm.",
					"leavesAt": "16:16",
					"arrivesAt": "16:23",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Ciocăneşti Hm.",
					"to": "Sabareni",
					"leavesAt": "16:24",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 8500
				},
				{
					"from": "Sabareni",
					"to": "Chitila",
					"leavesAt": "16:33",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Chitila",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "16:41",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "16:44",
					"arrivesAt": "16:47",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "16:51",
					"arrivesAt": "16:53",
					"waitsAtSource": 240,
					"distance": 1900
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:56",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Bucureşti Basarab",
					"leavesAt": "16:57",
					"arrivesAt": "17:02",
					"waitsAtSource": 30,
					"distance": 1500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1857",
			"segments": [
				{
					"from": "Mărăşeşti",
					"to": "Adjud",
					"leavesAt": "03:40",
					"arrivesAt": "04:06",
					"waitsAtSource": 0,
					"distance": 25700
				},
				{
					"from": "Adjud",
					"to": "Bacău",
					"leavesAt": "04:07",
					"arrivesAt": "04:44",
					"waitsAtSource": 60,
					"distance": 58200
				},
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "04:46",
					"arrivesAt": "05:15",
					"waitsAtSource": 120,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Paşcani",
					"leavesAt": "05:17",
					"arrivesAt": "05:46",
					"waitsAtSource": 120,
					"distance": 40200
				},
				{
					"from": "Paşcani",
					"to": "Dolhasca",
					"leavesAt": "05:49",
					"arrivesAt": "06:09",
					"waitsAtSource": 180,
					"distance": 21200
				},
				{
					"from": "Dolhasca",
					"to": "Vereşti",
					"leavesAt": "06:10",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 24600
				},
				{
					"from": "Vereşti",
					"to": "Suceava",
					"leavesAt": "06:27",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 14800
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "06:40",
					"arrivesAt": "06:46",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4363",
			"segments": [
				{
					"from": "Carei",
					"to": "Tiream h.",
					"leavesAt": "12:24",
					"arrivesAt": "12:35",
					"waitsAtSource": 0,
					"distance": 11700
				},
				{
					"from": "Tiream h.",
					"to": "Hotoan h.",
					"leavesAt": "12:36",
					"arrivesAt": "12:42",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Hotoan h.",
					"to": "Santău h.",
					"leavesAt": "12:43",
					"arrivesAt": "12:48",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Santău h.",
					"to": "Tăşnad",
					"leavesAt": "12:49",
					"arrivesAt": "12:55",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tăşnad",
					"to": "Săcăşeni h.",
					"leavesAt": "12:56",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Săcăşeni h.",
					"to": "Acâş Hm.",
					"leavesAt": "13:03",
					"arrivesAt": "13:13",
					"waitsAtSource": 30,
					"distance": 10000
				},
				{
					"from": "Acâş Hm.",
					"to": "Supur Haltă hc.",
					"leavesAt": "13:14",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Supur Haltă hc.",
					"to": "Supur h.",
					"leavesAt": "13:23",
					"arrivesAt": "13:25",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Supur h.",
					"to": "Giorocuţa h.",
					"leavesAt": "13:26",
					"arrivesAt": "13:29",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Giorocuţa h.",
					"to": "Derşida h.",
					"leavesAt": "13:30",
					"arrivesAt": "13:36",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Derşida h.",
					"to": "Sărmăşag h.",
					"leavesAt": "13:37",
					"arrivesAt": "13:40",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Sărmăşag h.",
					"to": "Sărmăşag",
					"leavesAt": "13:41",
					"arrivesAt": "13:47",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Sărmăşag",
					"to": "Câmpia Sălaj h.",
					"leavesAt": "13:48",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Câmpia Sălaj h.",
					"to": "Bocşa Sălaj h.",
					"leavesAt": "13:57",
					"arrivesAt": "14:01",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bocşa Sălaj h.",
					"to": "Borla Hm.",
					"leavesAt": "14:02",
					"arrivesAt": "14:07",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Borla Hm.",
					"to": "Guruslău h.",
					"leavesAt": "14:08",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Guruslău h.",
					"to": "Zalău Nord",
					"leavesAt": "14:14",
					"arrivesAt": "14:23",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Zalău Nord",
					"to": "Mirşid Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:47",
					"waitsAtSource": 420,
					"distance": 12000
				},
				{
					"from": "Mirşid Hm.",
					"to": "Poptelec h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:54",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Poptelec h.",
					"to": "Cuceu Sălaj h.",
					"leavesAt": "14:55",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Cuceu Sălaj h.",
					"to": "Jibou",
					"leavesAt": "15:01",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 5100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "6406",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "17:10",
					"arrivesAt": "17:17",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Ciurea Hm.",
					"leavesAt": "17:18",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ciurea Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Bârnova Hm.",
					"leavesAt": "17:36",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Grajduri",
					"leavesAt": "17:46",
					"arrivesAt": "17:53",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Grajduri",
					"to": "Scânteia Hm.",
					"leavesAt": "17:54",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Scânteia Hm.",
					"to": "Rebricea Hm.",
					"leavesAt": "18:02",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Rebricea Hm.",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:18",
					"waitsAtSource": 300,
					"distance": 4800
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Buhăieşti",
					"leavesAt": "18:19",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Buhăieşti",
					"to": "Bârzeşti h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bârzeşti h.",
					"to": "Brăhăşoaia h.",
					"leavesAt": "18:32",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Brăhăşoaia h.",
					"to": "Bălteni Hm.",
					"leavesAt": "18:37",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bălteni Hm.",
					"to": "Vaslui",
					"leavesAt": "18:43",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Vaslui",
					"to": "Munteni Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Munteni Hm.",
					"to": "Bulboaca h.",
					"leavesAt": "18:58",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bulboaca h.",
					"to": "Crasna",
					"leavesAt": "19:04",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Crasna",
					"to": "Roşieşti hc.",
					"leavesAt": "19:12",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Roşieşti hc.",
					"to": "Dodeşti hc.",
					"leavesAt": "19:21",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Dodeşti hc.",
					"to": "Banca Hm.",
					"leavesAt": "19:28",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Banca Hm.",
					"to": "Zorleni",
					"leavesAt": "19:35",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Zorleni",
					"to": "Bârlad",
					"leavesAt": "19:46",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 7300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5025",
			"segments": [
				{
					"from": "Bucureşti Basarab",
					"to": "Bucureşti Basarab h.",
					"leavesAt": "19:51",
					"arrivesAt": "19:54",
					"waitsAtSource": 0,
					"distance": 1500
				},
				{
					"from": "Bucureşti Basarab h.",
					"to": "Carpaţi h. (IIIK)",
					"leavesAt": "19:55",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Carpaţi h. (IIIK)",
					"to": "Pajura Hm. (IIIK)",
					"leavesAt": "19:57",
					"arrivesAt": "20:00",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Pajura Hm. (IIIK)",
					"to": "Depoul Buc.Triaj h. (IIIK)",
					"leavesAt": "20:01",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Depoul Buc.Triaj h. (IIIK)",
					"to": "Chitila",
					"leavesAt": "20:04",
					"arrivesAt": "20:07",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Chitila",
					"to": "Buftea",
					"leavesAt": "20:08",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "20:20",
					"arrivesAt": "20:27",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "20:33",
					"arrivesAt": "20:38",
					"waitsAtSource": 360,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "20:39",
					"arrivesAt": "20:43",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Prahova h.",
					"leavesAt": "20:44",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Prahova h.",
					"to": "Brazi",
					"leavesAt": "20:49",
					"arrivesAt": "20:57",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "20:58",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4534",
			"segments": [
				{
					"from": "Războieni",
					"to": "Lunca Mureşului h.",
					"leavesAt": "11:52",
					"arrivesAt": "11:57",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Lunca Mureşului h.",
					"to": "Gura Arieşului h.",
					"leavesAt": "11:58",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Gura Arieşului h.",
					"to": "Gligoreşti Hm.",
					"leavesAt": "12:03",
					"arrivesAt": "12:08",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Gligoreşti Hm.",
					"to": "Cheţani h.",
					"leavesAt": "12:09",
					"arrivesAt": "12:13",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Cheţani h.",
					"to": "Luduş",
					"leavesAt": "12:14",
					"arrivesAt": "12:22",
					"waitsAtSource": 30,
					"distance": 6300
				},
				{
					"from": "Luduş",
					"to": "Bogata Mureş h.",
					"leavesAt": "12:29",
					"arrivesAt": "12:33",
					"waitsAtSource": 420,
					"distance": 2700
				},
				{
					"from": "Bogata Mureş h.",
					"to": "Cuci h.",
					"leavesAt": "12:34",
					"arrivesAt": "12:39",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cuci h.",
					"to": "Iernut",
					"leavesAt": "12:40",
					"arrivesAt": "12:46",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Iernut",
					"to": "Cipău h.",
					"leavesAt": "12:47",
					"arrivesAt": "12:51",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Cipău h.",
					"to": "Ogra h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:55",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ogra h.",
					"to": "Sânpaul Hm.",
					"leavesAt": "12:56",
					"arrivesAt": "13:00",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Sânpaul Hm.",
					"to": "Chirileu h.",
					"leavesAt": "13:01",
					"arrivesAt": "13:05",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Chirileu h.",
					"to": "Vidrasău h.",
					"leavesAt": "13:06",
					"arrivesAt": "13:10",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Vidrasău h.",
					"to": "G-ral N. Dăscălescu Hm.",
					"leavesAt": "13:11",
					"arrivesAt": "13:16",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "G-ral N. Dăscălescu Hm.",
					"to": "Târgu Mureş Sud",
					"leavesAt": "13:17",
					"arrivesAt": "13:21",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Târgu Mureş Sud",
					"to": "Azomureş h.",
					"leavesAt": "13:22",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Azomureş h.",
					"to": "Târgu Mureş",
					"leavesAt": "13:26",
					"arrivesAt": "13:31",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4111",
			"segments": [
				{
					"from": "Sighetu Marmaţiei",
					"to": "Cămara Sighet Hm.",
					"leavesAt": "01:00",
					"arrivesAt": "01:05",
					"waitsAtSource": 0,
					"distance": 1900
				},
				{
					"from": "Cămara Sighet Hm.",
					"to": "Tisa h.",
					"leavesAt": "01:06",
					"arrivesAt": "01:13",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tisa h.",
					"to": "Crăciuneşti h.",
					"leavesAt": "01:14",
					"arrivesAt": "01:17",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Crăciuneşti h.",
					"to": "Bocicoi  Hm.",
					"leavesAt": "01:18",
					"arrivesAt": "01:24",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bocicoi  Hm.",
					"to": "Lunca la Tisa h.",
					"leavesAt": "01:25",
					"arrivesAt": "01:29",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Lunca la Tisa h.",
					"to": "Valea Vişeului",
					"leavesAt": "01:30",
					"arrivesAt": "01:48",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Valea Vişeului",
					"to": "Vişeu Bistra h.",
					"leavesAt": "02:08",
					"arrivesAt": "02:22",
					"waitsAtSource": 1200,
					"distance": 8500
				},
				{
					"from": "Vişeu Bistra h.",
					"to": "Petrova hc.",
					"leavesAt": "02:23",
					"arrivesAt": "02:32",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Petrova hc.",
					"to": "Leordina",
					"leavesAt": "02:33",
					"arrivesAt": "02:44",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Leordina",
					"to": "Leordina h.",
					"leavesAt": "02:45",
					"arrivesAt": "02:50",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Leordina h.",
					"to": "Bocicoel h.",
					"leavesAt": "02:51",
					"arrivesAt": "02:59",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Bocicoel h.",
					"to": "Vişeu de Jos",
					"leavesAt": "03:00",
					"arrivesAt": "03:05",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Vişeu de Jos",
					"to": "Iza P.M.",
					"leavesAt": "03:15",
					"arrivesAt": "03:27",
					"waitsAtSource": 600,
					"distance": 8600
				},
				{
					"from": "Iza P.M.",
					"to": "Săcel Hm.",
					"leavesAt": "03:28",
					"arrivesAt": "03:38",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Săcel Hm.",
					"to": "Dealu Ştefăniţei",
					"leavesAt": "03:39",
					"arrivesAt": "03:50",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dealu Ştefăniţei",
					"to": "Romuli h.",
					"leavesAt": "03:51",
					"arrivesAt": "04:00",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Romuli h.",
					"to": "Fiad Hm.",
					"leavesAt": "04:01",
					"arrivesAt": "04:11",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Fiad Hm.",
					"to": "Fiezel h.",
					"leavesAt": "04:12",
					"arrivesAt": "04:18",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Fiezel h.",
					"to": "Telciu Hm.",
					"leavesAt": "04:19",
					"arrivesAt": "04:27",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Telciu Hm.",
					"to": "Bichigiu h.",
					"leavesAt": "04:28",
					"arrivesAt": "04:32",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Bichigiu h.",
					"to": "Coşbuc Hm.",
					"leavesAt": "04:33",
					"arrivesAt": "04:37",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Coşbuc Hm.",
					"to": "Salva",
					"leavesAt": "04:38",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Salva",
					"to": "Mititei h.",
					"leavesAt": "05:11",
					"arrivesAt": "05:14",
					"waitsAtSource": 1200,
					"distance": 2200
				},
				{
					"from": "Mititei h.",
					"to": "Nimigea Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:21",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Nimigea Hm.",
					"to": "Nimigea h.",
					"leavesAt": "05:22",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Nimigea h.",
					"to": "Mogoşeni Hm.",
					"leavesAt": "05:26",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Mogoşeni Hm.",
					"to": "Cociu h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cociu h.",
					"to": "Beclean pe Someş",
					"leavesAt": "05:35",
					"arrivesAt": "05:44",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Beclean pe Someş",
					"to": "Coldău Hm.",
					"leavesAt": "05:46",
					"arrivesAt": "05:56",
					"waitsAtSource": 120,
					"distance": 5100
				},
				{
					"from": "Coldău Hm.",
					"to": "Ciceu Cristur h.",
					"leavesAt": "05:57",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ciceu Cristur h.",
					"to": "Reteag h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:04",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Reteag h.",
					"to": "Reteag Hm.",
					"leavesAt": "06:05",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Reteag Hm.",
					"to": "Ciceu Mihăeşti h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Ciceu Mihăeşti h.",
					"to": "Dej Triaj",
					"leavesAt": "06:15",
					"arrivesAt": "06:21",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Dej Triaj",
					"to": "Dej Călători",
					"leavesAt": "06:22",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Dej Călători",
					"to": "Nima h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:46",
					"waitsAtSource": 540,
					"distance": 5800
				},
				{
					"from": "Nima h.",
					"to": "Gherla",
					"leavesAt": "06:47",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Gherla",
					"to": "Livada Someş h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Livada Someş h.",
					"to": "Iclod Hm.",
					"leavesAt": "07:06",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Iclod Hm.",
					"to": "Fundătura h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Fundătura h.",
					"to": "Bonţida Hm.",
					"leavesAt": "07:16",
					"arrivesAt": "07:21",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bonţida Hm.",
					"to": "Răscruci h.",
					"leavesAt": "07:22",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Răscruci h.",
					"to": "Jucu Hm.",
					"leavesAt": "07:26",
					"arrivesAt": "07:31",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Jucu Hm.",
					"to": "Apahida",
					"leavesAt": "07:32",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 8900
				},
				{
					"from": "Apahida",
					"to": "Cluj Napoca Est",
					"leavesAt": "07:43",
					"arrivesAt": "07:52",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cluj Napoca Est",
					"to": "Clujana h.",
					"leavesAt": "07:53",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Clujana h.",
					"to": "Cluj Napoca",
					"leavesAt": "07:59",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1851",
			"segments": [
				{
					"from": "Bacău",
					"to": "Roman",
					"leavesAt": "18:20",
					"arrivesAt": "18:51",
					"waitsAtSource": 0,
					"distance": 43800
				},
				{
					"from": "Roman",
					"to": "Târgu Frumos",
					"leavesAt": "18:53",
					"arrivesAt": "19:49",
					"waitsAtSource": 120,
					"distance": 69200
				},
				{
					"from": "Târgu Frumos",
					"to": "Iaşi",
					"leavesAt": "19:50",
					"arrivesAt": "20:25",
					"waitsAtSource": 60,
					"distance": 44900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9594",
			"segments": [
				{
					"from": "Jimbolia",
					"to": "Clarii Vii h.",
					"leavesAt": "17:40",
					"arrivesAt": "17:46",
					"waitsAtSource": 0,
					"distance": 6300
				},
				{
					"from": "Clarii Vii h.",
					"to": "Cărpiniş",
					"leavesAt": "17:47",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Cărpiniş",
					"to": "Beregsău hcv.",
					"leavesAt": "17:56",
					"arrivesAt": "18:03",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Beregsău hcv.",
					"to": "Săcălaz h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Săcălaz h.",
					"to": "Timişoara Nord",
					"leavesAt": "18:12",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2024",
			"segments": [
				{
					"from": "Simeria",
					"to": "Simeria Triaj",
					"leavesAt": "19:53",
					"arrivesAt": "20:00",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Simeria Triaj",
					"to": "Băcia Hm.",
					"leavesAt": "20:01",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Băcia Hm.",
					"to": "Călan Băi",
					"leavesAt": "20:06",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Băi",
					"to": "Călan Hm.",
					"leavesAt": "20:11",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Călan Hm.",
					"to": "Bretea Streiului Hm.",
					"leavesAt": "20:16",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Bretea Streiului Hm.",
					"to": "Subcetate",
					"leavesAt": "20:27",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Subcetate",
					"to": "Băeşti Hm.",
					"leavesAt": "20:35",
					"arrivesAt": "20:43",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Băeşti Hm.",
					"to": "Ruşor h.",
					"leavesAt": "20:44",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ruşor h.",
					"to": "Pui",
					"leavesAt": "20:47",
					"arrivesAt": "20:52",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Pui",
					"to": "Livadia h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Livadia h.",
					"to": "Baru Mare",
					"leavesAt": "20:58",
					"arrivesAt": "21:06",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Baru Mare",
					"to": "Baru Mare h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:11",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Baru Mare h.",
					"to": "Crivadia Hm.",
					"leavesAt": "21:12",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Crivadia Hm.",
					"to": "Merişor Hm.",
					"leavesAt": "21:19",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Merişor Hm.",
					"to": "Băniţa",
					"leavesAt": "21:29",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Băniţa",
					"to": "Peştera Bolii h.",
					"leavesAt": "21:42",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Peştera Bolii h.",
					"to": "Dep Petroşani h.",
					"leavesAt": "21:49",
					"arrivesAt": "21:54",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Dep Petroşani h.",
					"to": "Petroşani",
					"leavesAt": "21:55",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Petroşani",
					"to": "Lunca Jiului hc.",
					"leavesAt": "22:25",
					"arrivesAt": "22:28",
					"waitsAtSource": 1620,
					"distance": 2200
				},
				{
					"from": "Lunca Jiului hc.",
					"to": "Livezeni",
					"leavesAt": "22:29",
					"arrivesAt": "22:34",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Livezeni",
					"to": "Strâmbuţa Hm.",
					"leavesAt": "22:35",
					"arrivesAt": "22:41",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Strâmbuţa Hm.",
					"to": "Lainici Hm.",
					"leavesAt": "22:42",
					"arrivesAt": "23:01",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Lainici Hm.",
					"to": "Meri",
					"leavesAt": "23:06",
					"arrivesAt": "23:16",
					"waitsAtSource": 300,
					"distance": 6400
				},
				{
					"from": "Meri",
					"to": "Valea Sadului Hm.",
					"leavesAt": "23:17",
					"arrivesAt": "23:25",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Valea Sadului Hm.",
					"to": "Bumbeşti Hm.",
					"leavesAt": "23:26",
					"arrivesAt": "23:31",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bumbeşti Hm.",
					"to": "Parângu Hm.",
					"leavesAt": "23:32",
					"arrivesAt": "23:39",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Parângu Hm.",
					"to": "Ecaterina Teodoroiu",
					"leavesAt": "23:40",
					"arrivesAt": "23:46",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Ecaterina Teodoroiu",
					"to": "Ramificaţia C.A.M. h.",
					"leavesAt": "23:47",
					"arrivesAt": "23:50",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ramificaţia C.A.M. h.",
					"to": "Târgu Jiu",
					"leavesAt": "23:51",
					"arrivesAt": "23:55",
					"waitsAtSource": 30,
					"distance": 800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9554",
			"segments": [
				{
					"from": "Caransebeş",
					"to": "Caransebeş haltă h.",
					"leavesAt": "13:28",
					"arrivesAt": "13:30",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Caransebeş haltă h.",
					"to": "Balta Sărată",
					"leavesAt": "13:31",
					"arrivesAt": "13:35",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Balta Sărată",
					"to": "Valea Timişului Hm.",
					"leavesAt": "13:36",
					"arrivesAt": "13:40",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Valea Timişului Hm.",
					"to": "Petroşniţa h.",
					"leavesAt": "13:41",
					"arrivesAt": "13:44",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Petroşniţa h.",
					"to": "Vălişoara Hm.",
					"leavesAt": "13:45",
					"arrivesAt": "13:52",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălişoara Hm.",
					"to": "Slatina Timiş",
					"leavesAt": "13:53",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Slatina Timiş",
					"to": "Armeniş",
					"leavesAt": "14:00",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Armeniş",
					"to": "Teregova Hm.",
					"leavesAt": "14:08",
					"arrivesAt": "14:15",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Teregova Hm.",
					"to": "Poarta Hm.",
					"leavesAt": "14:16",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Poarta Hm.",
					"to": "Luncaviţa h.",
					"leavesAt": "14:26",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Luncaviţa h.",
					"to": "Domaşnea Cornea Hm.",
					"leavesAt": "14:32",
					"arrivesAt": "14:37",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Domaşnea Cornea Hm.",
					"to": "Cornea h.",
					"leavesAt": "14:38",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cornea h.",
					"to": "Cruşovăţ",
					"leavesAt": "14:44",
					"arrivesAt": "14:51",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Cruşovăţ",
					"to": "Iablaniţa",
					"leavesAt": "14:52",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Iablaniţa",
					"to": "Mehadia Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Mehadia Hm.",
					"to": "Mehadia Nouă Hm.",
					"leavesAt": "15:13",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Mehadia Nouă Hm.",
					"to": "Băile Herculane",
					"leavesAt": "15:18",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Băile Herculane",
					"to": "Topleţ Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:31",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Topleţ Hm.",
					"to": "Valea Cernei Hm.",
					"leavesAt": "15:32",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Valea Cernei Hm.",
					"to": "Orşova",
					"leavesAt": "15:38",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 5700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9012",
			"segments": [
				{
					"from": "Craiova",
					"to": "Bordei hc.(901)",
					"leavesAt": "19:25",
					"arrivesAt": "19:29",
					"waitsAtSource": 0,
					"distance": 1700
				},
				{
					"from": "Bordei hc.(901)",
					"to": "Plaiu Vulcăneşti Hm.",
					"leavesAt": "19:30",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Plaiu Vulcăneşti Hm.",
					"to": "Cârcea h.",
					"leavesAt": "19:35",
					"arrivesAt": "19:40",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cârcea h.",
					"to": "Pieleşti Hm.",
					"leavesAt": "19:41",
					"arrivesAt": "19:50",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Pieleşti Hm.",
					"to": "Toporaş h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:01",
					"waitsAtSource": 480,
					"distance": 2300
				},
				{
					"from": "Toporaş h.",
					"to": "Robăneşti Hm.",
					"leavesAt": "20:02",
					"arrivesAt": "20:09",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Robăneşti Hm.",
					"to": "Spineni h.",
					"leavesAt": "20:10",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Spineni h.",
					"to": "Balş",
					"leavesAt": "20:17",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Balş",
					"to": "Canton 217 h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Canton 217 h.",
					"to": "Brăneţ h.",
					"leavesAt": "20:28",
					"arrivesAt": "20:32",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Brăneţ h.",
					"to": "Piatra Olt",
					"leavesAt": "20:33",
					"arrivesAt": "20:42",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Piatra Olt",
					"to": "Criva h.",
					"leavesAt": "20:55",
					"arrivesAt": "21:00",
					"waitsAtSource": 780,
					"distance": 4000
				},
				{
					"from": "Criva h.",
					"to": "Slătioara Hm.",
					"leavesAt": "21:01",
					"arrivesAt": "21:06",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Slătioara Hm.",
					"to": "Milcov Hm.",
					"leavesAt": "21:11",
					"arrivesAt": "21:19",
					"waitsAtSource": 300,
					"distance": 4600
				},
				{
					"from": "Milcov Hm.",
					"to": "Slatina",
					"leavesAt": "21:20",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Slatina",
					"to": "Recea Hm.",
					"leavesAt": "21:28",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Recea Hm.",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "21:38",
					"arrivesAt": "21:47",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Potcoava",
					"leavesAt": "21:48",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Potcoava",
					"to": "Sineşti Hm.",
					"leavesAt": "21:58",
					"arrivesAt": "22:05",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sineşti Hm.",
					"to": "Corbu",
					"leavesAt": "22:06",
					"arrivesAt": "22:13",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Corbu",
					"to": "Hârseşti Hm.",
					"leavesAt": "22:14",
					"arrivesAt": "22:20",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "22:21",
					"arrivesAt": "22:27",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Stolnici Hm.",
					"to": "Fâlfani Hm.",
					"leavesAt": "22:28",
					"arrivesAt": "22:38",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Costeşti",
					"leavesAt": "22:39",
					"arrivesAt": "22:48",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Costeşti",
					"to": "Pârvu h.",
					"leavesAt": "22:49",
					"arrivesAt": "22:58",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Pârvu h.",
					"to": "Bradu de Sus",
					"leavesAt": "22:59",
					"arrivesAt": "23:16",
					"waitsAtSource": 30,
					"distance": 9700
				},
				{
					"from": "Bradu de Sus",
					"to": "Km. 109+000 h.",
					"leavesAt": "23:17",
					"arrivesAt": "23:21",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Km. 109+000 h.",
					"to": "Piteşti",
					"leavesAt": "23:22",
					"arrivesAt": "23:25",
					"waitsAtSource": 30,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 351
				},
				{
					"from": "20180409",
					"to": "20181208",
					"daysOfWeek": 351
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 351
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4049",
			"segments": [
				{
					"from": "Jibou",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "19:53",
					"arrivesAt": "20:03",
					"waitsAtSource": 0,
					"distance": 9300
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Inău h.",
					"leavesAt": "20:04",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Inău h.",
					"to": "Aluniş Sălaj h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aluniş Sălaj h.",
					"to": "Benesat Hm.",
					"leavesAt": "20:13",
					"arrivesAt": "20:17",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Benesat Hm.",
					"to": "Ţicău h.",
					"leavesAt": "20:26",
					"arrivesAt": "20:33",
					"waitsAtSource": 540,
					"distance": 6600
				},
				{
					"from": "Ţicău h.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "20:34",
					"arrivesAt": "20:38",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Mireşu Mare PM.",
					"leavesAt": "20:39",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Fersig h.",
					"leavesAt": "20:46",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Fersig h.",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "20:53",
					"arrivesAt": "20:58",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Baia Mare",
					"leavesAt": "20:59",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 14600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9667",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "16:32",
					"arrivesAt": "16:42",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişeni Hm.",
					"leavesAt": "16:43",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Timişeni Hm.",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "16:52",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Jebel",
					"leavesAt": "17:00",
					"arrivesAt": "17:06",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Jebel",
					"to": "Voiteni",
					"leavesAt": "17:07",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Voiteni",
					"to": "Deta Hm.",
					"leavesAt": "17:20",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Deta Hm.",
					"to": "Denta h.",
					"leavesAt": "17:30",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Denta h.",
					"to": "Stamora Moraviţa",
					"leavesAt": "17:36",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 8400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4402",
			"segments": [
				{
					"from": "Halmeu",
					"to": "Porumbeşti Hm.",
					"leavesAt": "05:40",
					"arrivesAt": "05:46",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Micula Hm.",
					"leavesAt": "05:47",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Micula Hm.",
					"to": "Ram. Botiz h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Satu Mare",
					"leavesAt": "06:04",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180408",
					"daysOfWeek": 319
				},
				{
					"from": "20180410",
					"to": "20180430",
					"daysOfWeek": 319
				},
				{
					"from": "20180502",
					"to": "20180527",
					"daysOfWeek": 319
				},
				{
					"from": "20180529",
					"to": "20180531",
					"daysOfWeek": 319
				},
				{
					"from": "20180602",
					"to": "20181129",
					"daysOfWeek": 319
				},
				{
					"from": "20181202",
					"to": "20181208",
					"daysOfWeek": 319
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 319
				},
				{
					"from": "20171227",
					"to": "20171231",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3531",
			"segments": [
				{
					"from": "Braşov",
					"to": "Stupini Hm.",
					"leavesAt": "07:50",
					"arrivesAt": "07:59",
					"waitsAtSource": 0,
					"distance": 5400
				},
				{
					"from": "Stupini Hm.",
					"to": "Bod Hm.",
					"leavesAt": "08:00",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Bod Hm.",
					"to": "Feldioara Hm.",
					"leavesAt": "08:09",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Feldioara Hm.",
					"to": "Rotbav h.",
					"leavesAt": "08:20",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Rotbav h.",
					"to": "Vadu Roşu h.",
					"leavesAt": "08:24",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Vadu Roşu h.",
					"to": "Măieruş h.",
					"leavesAt": "08:29",
					"arrivesAt": "08:32",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Măieruş h.",
					"to": "Apaţa",
					"leavesAt": "08:33",
					"arrivesAt": "08:45",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Apaţa",
					"to": "Ormeniş h.",
					"leavesAt": "08:46",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Ormeniş h.",
					"to": "Augustin Hm.",
					"leavesAt": "08:53",
					"arrivesAt": "09:06",
					"waitsAtSource": 30,
					"distance": 7100
				},
				{
					"from": "Augustin Hm.",
					"to": "Racoş Hm.",
					"leavesAt": "09:07",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Racoş Hm.",
					"to": "Mateiaş h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mateiaş h.",
					"to": "Rupea",
					"leavesAt": "09:29",
					"arrivesAt": "09:45",
					"waitsAtSource": 30,
					"distance": 10700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "2870",
			"segments": [
				{
					"from": "Târgu Jiu",
					"to": "Amaradia",
					"leavesAt": "06:20",
					"arrivesAt": "06:27",
					"waitsAtSource": 0,
					"distance": 6100
				},
				{
					"from": "Amaradia",
					"to": "Cârbeşti Hm.",
					"leavesAt": "06:28",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Cârbeşti Hm.",
					"to": "Rogojelu",
					"leavesAt": "06:35",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Rogojelu",
					"to": "Km. 49+800 h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Km. 49+800 h.",
					"to": "Rovinari Hm.",
					"leavesAt": "06:48",
					"arrivesAt": "06:51",
					"waitsAtSource": 120,
					"distance": 1000
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180407",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20180526",
					"daysOfWeek": 383
				},
				{
					"from": "20180528",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171224",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1750",
			"segments": [
				{
					"from": "Suceava",
					"to": "Paşcani",
					"leavesAt": "05:20",
					"arrivesAt": "06:03",
					"waitsAtSource": 0,
					"distance": 60600
				},
				{
					"from": "Paşcani",
					"to": "Roman",
					"leavesAt": "06:04",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 40200
				},
				{
					"from": "Roman",
					"to": "Bacău",
					"leavesAt": "06:32",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 43800
				},
				{
					"from": "Bacău",
					"to": "Adjud",
					"leavesAt": "07:02",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 58200
				},
				{
					"from": "Adjud",
					"to": "Focşani",
					"leavesAt": "07:42",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 45400
				},
				{
					"from": "Focşani",
					"to": "Buzău",
					"leavesAt": "08:29",
					"arrivesAt": "09:35",
					"waitsAtSource": 60,
					"distance": 70800
				},
				{
					"from": "Buzău",
					"to": "Ploieşti Sud",
					"leavesAt": "09:36",
					"arrivesAt": "10:40",
					"waitsAtSource": 60,
					"distance": 68600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "10:42",
					"arrivesAt": "11:31",
					"waitsAtSource": 120,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "3111",
			"segments": [
				{
					"from": "Arad",
					"to": "Utviniş h.",
					"leavesAt": "03:20",
					"arrivesAt": "03:33",
					"waitsAtSource": 0,
					"distance": 9600
				},
				{
					"from": "Utviniş h.",
					"to": "Zimandu Nou h.",
					"leavesAt": "03:34",
					"arrivesAt": "03:38",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "03:39",
					"arrivesAt": "03:51",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Comlăuş h.",
					"leavesAt": "03:52",
					"arrivesAt": "03:57",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Comlăuş h.",
					"to": "Şimand Hm.",
					"leavesAt": "03:58",
					"arrivesAt": "04:06",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şimand Hm.",
					"to": "Nădab",
					"leavesAt": "04:07",
					"arrivesAt": "04:15",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Nădab",
					"to": "Chişineu Criş",
					"leavesAt": "04:35",
					"arrivesAt": "04:41",
					"waitsAtSource": 1200,
					"distance": 4900
				},
				{
					"from": "Chişineu Criş",
					"to": "Zerind Hm.",
					"leavesAt": "04:42",
					"arrivesAt": "04:49",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Zerind Hm.",
					"to": "Tămaşda h.",
					"leavesAt": "04:50",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Tămaşda h.",
					"to": "Boiu Bihor h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Boiu Bihor h.",
					"to": "Ciumeghiu Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Ciumeghiu Hm.",
					"to": "Salonta",
					"leavesAt": "05:25",
					"arrivesAt": "05:39",
					"waitsAtSource": 540,
					"distance": 10200
				},
				{
					"from": "Salonta",
					"to": "Mădăraş Bihor h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:52",
					"waitsAtSource": 600,
					"distance": 3200
				},
				{
					"from": "Mădăraş Bihor h.",
					"to": "Cefa Hm.",
					"leavesAt": "05:53",
					"arrivesAt": "06:02",
					"waitsAtSource": 30,
					"distance": 9300
				},
				{
					"from": "Cefa Hm.",
					"to": "Leş Bihor Hm.",
					"leavesAt": "06:03",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Leş Bihor Hm.",
					"to": "Oradea Vest Hm.",
					"leavesAt": "06:14",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Oradea Vest Hm.",
					"to": "Oradea",
					"leavesAt": "06:30",
					"arrivesAt": "06:38",
					"waitsAtSource": 300,
					"distance": 5500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4096",
			"segments": [
				{
					"from": "Baia Mare",
					"to": "Satulung pe Someş Hm.",
					"leavesAt": "08:47",
					"arrivesAt": "09:03",
					"waitsAtSource": 0,
					"distance": 14600
				},
				{
					"from": "Satulung pe Someş Hm.",
					"to": "Fersig h.",
					"leavesAt": "09:14",
					"arrivesAt": "09:19",
					"waitsAtSource": 660,
					"distance": 4300
				},
				{
					"from": "Fersig h.",
					"to": "Mireşu Mare PM.",
					"leavesAt": "09:20",
					"arrivesAt": "09:26",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Mireşu Mare PM.",
					"to": "Ulmeni Sălaj",
					"leavesAt": "09:27",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Ulmeni Sălaj",
					"to": "Benesat Hm.",
					"leavesAt": "09:35",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Benesat Hm.",
					"to": "Someş Odorhei Hm.",
					"leavesAt": "09:45",
					"arrivesAt": "09:54",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Someş Odorhei Hm.",
					"to": "Jibou",
					"leavesAt": "09:55",
					"arrivesAt": "10:05",
					"waitsAtSource": 60,
					"distance": 9300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "7576",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Fileşti Hm.",
					"leavesAt": "19:44",
					"arrivesAt": "19:58",
					"waitsAtSource": 0,
					"distance": 6800
				},
				{
					"from": "Fileşti Hm.",
					"to": "Barboşi",
					"leavesAt": "19:59",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Barboşi",
					"to": "Barboşi Triaj h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Barboşi Triaj h.",
					"to": "Şendreni Hm.",
					"leavesAt": "20:11",
					"arrivesAt": "20:15",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Şendreni Hm.",
					"to": "Şerbeştii Vechi h.",
					"leavesAt": "20:16",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Şerbeştii Vechi h.",
					"to": "Braniştea h.",
					"leavesAt": "20:21",
					"arrivesAt": "20:25",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Braniştea h.",
					"to": "Vasile Alecsandri h.",
					"leavesAt": "20:26",
					"arrivesAt": "20:29",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vasile Alecsandri h.",
					"to": "Independenţa Hm.",
					"leavesAt": "20:30",
					"arrivesAt": "20:35",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Independenţa Hm.",
					"to": "Piscu h.",
					"leavesAt": "20:36",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Piscu h.",
					"to": "Vameş h.",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Vameş h.",
					"to": "Tudor Vladimirescu hc.",
					"leavesAt": "20:48",
					"arrivesAt": "20:54",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Tudor Vladimirescu hc.",
					"to": "Hanu Conachi Hm.",
					"leavesAt": "20:55",
					"arrivesAt": "21:00",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Hanu Conachi Hm.",
					"to": "Şerbăneşti h.",
					"leavesAt": "21:01",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Şerbăneşti h.",
					"to": "Lieşti",
					"leavesAt": "21:07",
					"arrivesAt": "21:10",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lieşti",
					"to": "Buceşti h.",
					"leavesAt": "21:11",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Buceşti h.",
					"to": "Iveşti Hm.",
					"leavesAt": "21:16",
					"arrivesAt": "21:20",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Iveşti Hm.",
					"to": "Umbrăreşti h.",
					"leavesAt": "21:21",
					"arrivesAt": "21:25",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Umbrăreşti h.",
					"to": "Barcea",
					"leavesAt": "21:26",
					"arrivesAt": "21:32",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Barcea",
					"to": "Malul Alb h.",
					"leavesAt": "21:33",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Malul Alb h.",
					"to": "Tecuci",
					"leavesAt": "21:37",
					"arrivesAt": "21:47",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Tecuci",
					"to": "Cosmeşti Hm.",
					"leavesAt": "22:16",
					"arrivesAt": "22:26",
					"waitsAtSource": 1740,
					"distance": 7400
				},
				{
					"from": "Cosmeşti Hm.",
					"to": "G-ral. E. Grigorescu Hm.",
					"leavesAt": "22:27",
					"arrivesAt": "22:33",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "G-ral. E. Grigorescu Hm.",
					"to": "Mărăşeşti",
					"leavesAt": "22:34",
					"arrivesAt": "22:45",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8395",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "20:45",
					"arrivesAt": "20:58",
					"waitsAtSource": 0,
					"distance": 8600
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Eforie Nord",
					"leavesAt": "21:04",
					"arrivesAt": "21:11",
					"waitsAtSource": 360,
					"distance": 5400
				},
				{
					"from": "Eforie Nord",
					"to": "Eforie Sud",
					"leavesAt": "21:12",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Sud",
					"to": "Tuzla h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Tuzla h.",
					"to": "Costineşti",
					"leavesAt": "21:25",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Costineşti",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "21:33",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Neptun hc.",
					"leavesAt": "21:37",
					"arrivesAt": "21:45",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Neptun hc.",
					"to": "Mangalia",
					"leavesAt": "21:46",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 6800
				}
			],
			"restrictions": [
				{
					"from": "20180102",
					"to": "20180105",
					"daysOfWeek": 383
				},
				{
					"from": "20180107",
					"to": "20180112",
					"daysOfWeek": 383
				},
				{
					"from": "20180114",
					"to": "20180119",
					"daysOfWeek": 383
				},
				{
					"from": "20180121",
					"to": "20180126",
					"daysOfWeek": 383
				},
				{
					"from": "20180128",
					"to": "20180202",
					"daysOfWeek": 383
				},
				{
					"from": "20180204",
					"to": "20180209",
					"daysOfWeek": 383
				},
				{
					"from": "20180211",
					"to": "20180216",
					"daysOfWeek": 383
				},
				{
					"from": "20180218",
					"to": "20180223",
					"daysOfWeek": 383
				},
				{
					"from": "20180225",
					"to": "20180302",
					"daysOfWeek": 383
				},
				{
					"from": "20180304",
					"to": "20180309",
					"daysOfWeek": 383
				},
				{
					"from": "20180311",
					"to": "20180316",
					"daysOfWeek": 383
				},
				{
					"from": "20180318",
					"to": "20180323",
					"daysOfWeek": 383
				},
				{
					"from": "20180325",
					"to": "20180330",
					"daysOfWeek": 383
				},
				{
					"from": "20180401",
					"to": "20180406",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20180413",
					"daysOfWeek": 383
				},
				{
					"from": "20180415",
					"to": "20180420",
					"daysOfWeek": 383
				},
				{
					"from": "20180422",
					"to": "20180426",
					"daysOfWeek": 383
				},
				{
					"from": "20180502",
					"to": "20180504",
					"daysOfWeek": 383
				},
				{
					"from": "20180506",
					"to": "20180511",
					"daysOfWeek": 383
				},
				{
					"from": "20180513",
					"to": "20180518",
					"daysOfWeek": 383
				},
				{
					"from": "20180520",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180601",
					"daysOfWeek": 383
				},
				{
					"from": "20180603",
					"to": "20180607",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20180914",
					"daysOfWeek": 383
				},
				{
					"from": "20180916",
					"to": "20180921",
					"daysOfWeek": 383
				},
				{
					"from": "20180923",
					"to": "20180928",
					"daysOfWeek": 383
				},
				{
					"from": "20180930",
					"to": "20181005",
					"daysOfWeek": 383
				},
				{
					"from": "20181007",
					"to": "20181012",
					"daysOfWeek": 383
				},
				{
					"from": "20181014",
					"to": "20181019",
					"daysOfWeek": 383
				},
				{
					"from": "20181021",
					"to": "20181026",
					"daysOfWeek": 383
				},
				{
					"from": "20181028",
					"to": "20181102",
					"daysOfWeek": 383
				},
				{
					"from": "20181104",
					"to": "20181109",
					"daysOfWeek": 383
				},
				{
					"from": "20181111",
					"to": "20181116",
					"daysOfWeek": 383
				},
				{
					"from": "20181118",
					"to": "20181123",
					"daysOfWeek": 383
				},
				{
					"from": "20181125",
					"to": "20181130",
					"daysOfWeek": 383
				},
				{
					"from": "20181202",
					"to": "20181207",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171215",
					"daysOfWeek": 383
				},
				{
					"from": "20171217",
					"to": "20171222",
					"daysOfWeek": 383
				},
				{
					"from": "20171226",
					"to": "20171229",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9479",
			"segments": [
				{
					"from": "Piteşti",
					"to": "Bradu de Sus",
					"leavesAt": "23:40",
					"arrivesAt": "23:46",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bradu de Sus",
					"to": "Pârvu Hm.",
					"leavesAt": "23:47",
					"arrivesAt": "23:54",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Pârvu Hm.",
					"to": "Pârvu h.",
					"leavesAt": "23:55",
					"arrivesAt": "00:01",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Pârvu h.",
					"to": "Costeşti",
					"leavesAt": "00:02",
					"arrivesAt": "00:16",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Costeşti",
					"to": "Fâlfani Hm.",
					"leavesAt": "00:17",
					"arrivesAt": "00:26",
					"waitsAtSource": 60,
					"distance": 7900
				},
				{
					"from": "Fâlfani Hm.",
					"to": "Stolnici Hm.",
					"leavesAt": "00:27",
					"arrivesAt": "00:37",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Stolnici Hm.",
					"to": "Hârseşti Hm.",
					"leavesAt": "00:38",
					"arrivesAt": "00:45",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Hârseşti Hm.",
					"to": "Corbu",
					"leavesAt": "00:46",
					"arrivesAt": "00:53",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Corbu",
					"to": "Sineşti Hm.",
					"leavesAt": "00:54",
					"arrivesAt": "01:02",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Sineşti Hm.",
					"to": "Potcoava",
					"leavesAt": "01:03",
					"arrivesAt": "01:11",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Potcoava",
					"to": "Bâlteni Olt Hm.",
					"leavesAt": "01:12",
					"arrivesAt": "01:21",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Bâlteni Olt Hm.",
					"to": "Recea Hm.",
					"leavesAt": "01:22",
					"arrivesAt": "01:31",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Recea Hm.",
					"to": "Slatina",
					"leavesAt": "01:32",
					"arrivesAt": "01:42",
					"waitsAtSource": 60,
					"distance": 7800
				},
				{
					"from": "Slatina",
					"to": "Milcov Hm.",
					"leavesAt": "01:43",
					"arrivesAt": "01:51",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Milcov Hm.",
					"to": "Slătioara Hm.",
					"leavesAt": "01:52",
					"arrivesAt": "01:59",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Slătioara Hm.",
					"to": "Criva h.",
					"leavesAt": "02:00",
					"arrivesAt": "02:04",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Criva h.",
					"to": "Piatra Olt",
					"leavesAt": "02:05",
					"arrivesAt": "02:11",
					"waitsAtSource": 30,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1991",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "19:48",
					"arrivesAt": "19:55",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "20:03",
					"arrivesAt": "20:08",
					"waitsAtSource": 480,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "20:10",
					"arrivesAt": "20:23",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "20:25",
					"arrivesAt": "20:29",
					"waitsAtSource": 120,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Eforie Sud",
					"leavesAt": "20:30",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "20:47",
					"arrivesAt": "20:54",
					"waitsAtSource": 120,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Constanţa",
					"leavesAt": "20:56",
					"arrivesAt": "21:19",
					"waitsAtSource": 120,
					"distance": 14000
				},
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "21:35",
					"arrivesAt": "22:00",
					"waitsAtSource": 960,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "22:01",
					"arrivesAt": "22:20",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "22:21",
					"arrivesAt": "22:42",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "22:44",
					"arrivesAt": "23:08",
					"waitsAtSource": 120,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Băneasa",
					"leavesAt": "23:09",
					"arrivesAt": "00:03",
					"waitsAtSource": 60,
					"distance": 102300
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Videle",
					"leavesAt": "00:05",
					"arrivesAt": "00:59",
					"waitsAtSource": 120,
					"distance": 51000
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "01:01",
					"arrivesAt": "01:48",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Caracal",
					"leavesAt": "01:50",
					"arrivesAt": "02:38",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "02:40",
					"arrivesAt": "03:20",
					"waitsAtSource": 120,
					"distance": 53600
				},
				{
					"from": "Craiova",
					"to": "Strehaia hc.",
					"leavesAt": "03:30",
					"arrivesAt": "04:25",
					"waitsAtSource": 600,
					"distance": 62100
				},
				{
					"from": "Strehaia hc.",
					"to": "Balota",
					"leavesAt": "04:27",
					"arrivesAt": "05:05",
					"waitsAtSource": 120,
					"distance": 32600
				},
				{
					"from": "Balota",
					"to": "Drobeta Tr. Severin",
					"leavesAt": "05:11",
					"arrivesAt": "05:45",
					"waitsAtSource": 360,
					"distance": 19000
				},
				{
					"from": "Drobeta Tr. Severin",
					"to": "Orşova",
					"leavesAt": "05:48",
					"arrivesAt": "06:22",
					"waitsAtSource": 180,
					"distance": 24000
				},
				{
					"from": "Orşova",
					"to": "Băile Herculane",
					"leavesAt": "06:23",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 17500
				},
				{
					"from": "Băile Herculane",
					"to": "Teregova Hm.",
					"leavesAt": "06:43",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 37900
				},
				{
					"from": "Teregova Hm.",
					"to": "Caransebeş",
					"leavesAt": "07:36",
					"arrivesAt": "08:14",
					"waitsAtSource": 360,
					"distance": 32900
				},
				{
					"from": "Caransebeş",
					"to": "Lugoj",
					"leavesAt": "08:28",
					"arrivesAt": "09:02",
					"waitsAtSource": 840,
					"distance": 39400
				},
				{
					"from": "Lugoj",
					"to": "Timişoara Nord",
					"leavesAt": "09:04",
					"arrivesAt": "09:58",
					"waitsAtSource": 120,
					"distance": 58900
				}
			],
			"restrictions": [
				{
					"from": "20180609",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5606",
			"segments": [
				{
					"from": "Suceava Nord",
					"to": "Suceava",
					"leavesAt": "12:10",
					"arrivesAt": "12:15",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava",
					"to": "Văratec",
					"leavesAt": "12:17",
					"arrivesAt": "12:24",
					"waitsAtSource": 120,
					"distance": 8200
				},
				{
					"from": "Văratec",
					"to": "Vereşti",
					"leavesAt": "12:25",
					"arrivesAt": "12:32",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Vereşti",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "12:33",
					"arrivesAt": "12:39",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Liteni Hm.",
					"leavesAt": "12:40",
					"arrivesAt": "12:46",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Liteni Hm.",
					"to": "Corni h.",
					"leavesAt": "12:47",
					"arrivesAt": "12:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Corni h.",
					"to": "Dolhasca",
					"leavesAt": "12:53",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Dolhasca",
					"to": "Probota h.",
					"leavesAt": "13:03",
					"arrivesAt": "13:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Probota h.",
					"to": "Lespezi Hm.",
					"leavesAt": "13:09",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Lespezi Hm.",
					"to": "Lunca Siretului h.",
					"leavesAt": "13:15",
					"arrivesAt": "13:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Paşcani",
					"leavesAt": "13:21",
					"arrivesAt": "13:27",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Paşcani",
					"to": "Ruginoasa Hm.",
					"leavesAt": "13:31",
					"arrivesAt": "13:45",
					"waitsAtSource": 240,
					"distance": 14700
				},
				{
					"from": "Ruginoasa Hm.",
					"to": "Costeşti Iaşi hc.",
					"leavesAt": "13:46",
					"arrivesAt": "13:53",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Costeşti Iaşi hc.",
					"to": "Pietrişu h.",
					"leavesAt": "13:54",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pietrişu h.",
					"to": "Târgu Frumos",
					"leavesAt": "14:00",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Târgu Frumos",
					"to": "Sârca Hm.",
					"leavesAt": "14:09",
					"arrivesAt": "14:19",
					"waitsAtSource": 60,
					"distance": 11000
				},
				{
					"from": "Sârca Hm.",
					"to": "Budăi hc.",
					"leavesAt": "14:20",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Budăi hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "14:27",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "14:34",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "14:42",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "1570",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Barboşi",
					"leavesAt": "05:00",
					"arrivesAt": "05:19",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Barboşi",
					"to": "Brăila",
					"leavesAt": "05:20",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 19500
				},
				{
					"from": "Brăila",
					"to": "Ianca hc.",
					"leavesAt": "05:39",
					"arrivesAt": "06:09",
					"waitsAtSource": 120,
					"distance": 42400
				},
				{
					"from": "Ianca hc.",
					"to": "Făurei",
					"leavesAt": "06:10",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Făurei",
					"to": "Buzău",
					"leavesAt": "06:27",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "07:07",
					"arrivesAt": "07:39",
					"waitsAtSource": 120,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "07:40",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Bucureşti Nord",
					"leavesAt": "08:17",
					"arrivesAt": "09:10",
					"waitsAtSource": 120,
					"distance": 60200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "8390",
			"segments": [
				{
					"from": "Mangalia",
					"to": "Neptun",
					"leavesAt": "16:07",
					"arrivesAt": "16:13",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Neptun",
					"to": "Neptun hc.",
					"leavesAt": "16:14",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Neptun hc.",
					"to": "Costineşti Tabără hc.",
					"leavesAt": "16:19",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Costineşti Tabără hc.",
					"to": "Costineşti",
					"leavesAt": "16:29",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Costineşti",
					"to": "Tuzla h.",
					"leavesAt": "16:33",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Tuzla h.",
					"to": "Eforie Sud",
					"leavesAt": "16:40",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Eforie Sud",
					"to": "Eforie Nord",
					"leavesAt": "16:47",
					"arrivesAt": "16:52",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Eforie Nord",
					"to": "Agigea Ecluză Hm.",
					"leavesAt": "17:00",
					"arrivesAt": "17:08",
					"waitsAtSource": 480,
					"distance": 5400
				},
				{
					"from": "Agigea Ecluză Hm.",
					"to": "Constanţa",
					"leavesAt": "17:09",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 8600
				}
			],
			"restrictions": [
				{
					"from": "20180502",
					"to": "20180524",
					"daysOfWeek": 383
				},
				{
					"from": "20180530",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180426",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "4404",
			"segments": [
				{
					"from": "Halmeu",
					"to": "Porumbeşti Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:46",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Porumbeşti Hm.",
					"to": "Micula Hm.",
					"leavesAt": "08:47",
					"arrivesAt": "08:54",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Micula Hm.",
					"to": "Ram. Botiz h.",
					"leavesAt": "08:55",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Ram. Botiz h.",
					"to": "Satu Mare",
					"leavesAt": "09:04",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5731",
			"segments": [
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "02:50",
					"arrivesAt": "02:55",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Suceava Nord",
					"to": "Dărmăneşti",
					"leavesAt": "02:56",
					"arrivesAt": "03:05",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Dărmăneşti",
					"to": "Cacica Hm.",
					"leavesAt": "03:06",
					"arrivesAt": "03:42",
					"waitsAtSource": 60,
					"distance": 21300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "9442",
			"segments": [
				{
					"from": "Pietroşiţa Hm.",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Fieni",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Moţăieni h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Moţăieni h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "06:35",
					"arrivesAt": "06:39",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Trainica h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Trainica h.",
					"to": "Scârlenţa h.",
					"leavesAt": "06:44",
					"arrivesAt": "06:46",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Scârlenţa h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "06:47",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Doiceşti h.",
					"leavesAt": "06:51",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Doiceşti h.",
					"to": "Doiceşti",
					"leavesAt": "06:54",
					"arrivesAt": "06:56",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Doiceşti",
					"to": "Săteni h.",
					"leavesAt": "06:57",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Săteni h.",
					"to": "Aninoasa Hm.",
					"leavesAt": "07:01",
					"arrivesAt": "07:03",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Aninoasa Hm.",
					"to": "TEIŞ Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "07:08",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "07:11",
					"arrivesAt": "07:15",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "CFR",
			"number": "5451",
			"segments": [
				{
					"from": "Bacău",
					"to": "Iteşti Hm.",
					"leavesAt": "14:43",
					"arrivesAt": "14:54",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Iteşti Hm.",
					"to": "Şerbeşti Bacău h.",
					"leavesAt": "14:55",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Şerbeşti Bacău h.",
					"to": "Galbeni",
					"leavesAt": "15:00",
					"arrivesAt": "15:05",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Galbeni",
					"to": "Săcueni Roman Hm.",
					"leavesAt": "15:06",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Săcueni Roman Hm.",
					"to": "Ram. Trifeşti",
					"leavesAt": "15:16",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ram. Trifeşti",
					"to": "Roman",
					"leavesAt": "15:21",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Roman",
					"to": "Săbăoani Hm.",
					"leavesAt": "15:30",
					"arrivesAt": "15:37",
					"waitsAtSource": 120,
					"distance": 8100
				},
				{
					"from": "Săbăoani Hm.",
					"to": "Mirceşti",
					"leavesAt": "15:38",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Mirceşti",
					"to": "Hălăuceşti hc.",
					"leavesAt": "15:45",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hălăuceşti hc.",
					"to": "Mogoşeşti hc.",
					"leavesAt": "15:50",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Mogoşeşti hc.",
					"to": "Muncel Hm.",
					"leavesAt": "15:56",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Muncel Hm.",
					"to": "Stolniceni h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stolniceni h.",
					"to": "Paşcani",
					"leavesAt": "16:06",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Paşcani",
					"to": "Lunca Siretului h.",
					"leavesAt": "16:29",
					"arrivesAt": "16:34",
					"waitsAtSource": 780,
					"distance": 5900
				},
				{
					"from": "Lunca Siretului h.",
					"to": "Lespezi Hm.",
					"leavesAt": "16:35",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Lespezi Hm.",
					"to": "Probota h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Probota h.",
					"to": "Dolhasca",
					"leavesAt": "16:52",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Dolhasca",
					"to": "Corni h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Corni h.",
					"to": "Liteni Hm.",
					"leavesAt": "17:05",
					"arrivesAt": "17:11",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Liteni Hm.",
					"to": "Băneşti Suceava hc.",
					"leavesAt": "17:12",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Băneşti Suceava hc.",
					"to": "Vereşti",
					"leavesAt": "17:19",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Vereşti",
					"to": "Văratec",
					"leavesAt": "17:26",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Văratec",
					"to": "Suceava",
					"leavesAt": "17:33",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Suceava",
					"to": "Suceava Nord",
					"leavesAt": "17:42",
					"arrivesAt": "17:48",
					"waitsAtSource": 120,
					"distance": 2500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "CFR",
			"number": "78",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Arad",
					"leavesAt": "07:30",
					"arrivesAt": "08:18",
					"waitsAtSource": 0,
					"distance": 57200
				},
				{
					"from": "Arad",
					"to": "Curtici",
					"leavesAt": "08:21",
					"arrivesAt": "08:34",
					"waitsAtSource": 180,
					"distance": 17000
				},
				{
					"from": "Curtici",
					"to": "Lokoshaza",
					"leavesAt": "08:59",
					"arrivesAt": "09:09",
					"waitsAtSource": 1500,
					"distance": 11200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15107",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "11:00",
					"arrivesAt": "11:05",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "11:06",
					"arrivesAt": "11:15",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "11:16",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "11:21",
					"arrivesAt": "11:25",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Brătăşanca h.",
					"leavesAt": "11:26",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Brătăşanca h.",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "11:31",
					"arrivesAt": "11:35",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "I. L. Caragiale",
					"leavesAt": "11:36",
					"arrivesAt": "11:44",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "I. L. Caragiale",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "11:53",
					"arrivesAt": "11:56",
					"waitsAtSource": 540,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "Mija",
					"leavesAt": "11:57",
					"arrivesAt": "12:02",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mija",
					"to": "Adânca PM.",
					"leavesAt": "12:03",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Adânca PM.",
					"to": "Răzvad hc.",
					"leavesAt": "12:12",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Răzvad hc.",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "12:21",
					"arrivesAt": "12:25",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Târgovişte Nord",
					"leavesAt": "12:26",
					"arrivesAt": "12:33",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgovişte Nord",
					"to": "TEIŞ Hm.",
					"leavesAt": "12:35",
					"arrivesAt": "12:38",
					"waitsAtSource": 120,
					"distance": 1700
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "12:39",
					"arrivesAt": "12:41",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "12:42",
					"arrivesAt": "12:46",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15362",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "16:33",
					"arrivesAt": "16:36",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:45",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "17:06",
					"arrivesAt": "17:12",
					"waitsAtSource": 480,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "17:21",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "17:25",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "17:35",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "17:41",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "17:46",
					"arrivesAt": "17:52",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "17:59",
					"arrivesAt": "18:04",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "18:10",
					"arrivesAt": "18:14",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "18:15",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "18:21",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "18:34",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15189",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "19:46",
					"arrivesAt": "19:54",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:06",
					"waitsAtSource": 480,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "20:13",
					"arrivesAt": "20:16",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "20:17",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:28",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "20:29",
					"arrivesAt": "20:32",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "20:33",
					"arrivesAt": "20:37",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "20:38",
					"arrivesAt": "20:44",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "20:45",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:51",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:55",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "20:56",
					"arrivesAt": "21:00",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "21:01",
					"arrivesAt": "21:06",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "21:07",
					"arrivesAt": "21:19",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15309",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Tuluceşti Hm.",
					"leavesAt": "10:03",
					"arrivesAt": "10:26",
					"waitsAtSource": 0,
					"distance": 13600
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Şiviţa h.",
					"leavesAt": "10:27",
					"arrivesAt": "10:34",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "10:35",
					"arrivesAt": "10:42",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Stoicani h.",
					"leavesAt": "10:43",
					"arrivesAt": "10:49",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stoicani h.",
					"to": "Folteşti Hm.",
					"leavesAt": "10:50",
					"arrivesAt": "10:55",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Folteşti Hm.",
					"to": "Chiraftei h.",
					"leavesAt": "11:03",
					"arrivesAt": "11:09",
					"waitsAtSource": 480,
					"distance": 5700
				},
				{
					"from": "Chiraftei h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "11:10",
					"arrivesAt": "11:14",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Băleni h.",
					"leavesAt": "11:15",
					"arrivesAt": "11:19",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Băleni h.",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "11:20",
					"arrivesAt": "11:25",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Târgu Bujor",
					"leavesAt": "11:26",
					"arrivesAt": "11:29",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgu Bujor",
					"to": "Moscu hc.",
					"leavesAt": "11:30",
					"arrivesAt": "11:34",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moscu hc.",
					"to": "Roşcani h.",
					"leavesAt": "11:35",
					"arrivesAt": "11:42",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Roşcani h.",
					"to": "Balinteşti h.",
					"leavesAt": "11:43",
					"arrivesAt": "11:52",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Balinteşti h.",
					"to": "Bereşti Hm.",
					"leavesAt": "11:53",
					"arrivesAt": "12:02",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Bereşti Hm.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "12:03",
					"arrivesAt": "12:07",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Tălăşmani h.",
					"leavesAt": "12:08",
					"arrivesAt": "12:16",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Tălăşmani h.",
					"to": "Docăneasa hc.",
					"leavesAt": "12:17",
					"arrivesAt": "12:24",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Docăneasa hc.",
					"to": "Lungeşti h.",
					"leavesAt": "12:25",
					"arrivesAt": "12:28",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lungeşti h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "12:29",
					"arrivesAt": "12:35",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Griviţa h.",
					"leavesAt": "12:36",
					"arrivesAt": "12:40",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Griviţa h.",
					"to": "Bârlad",
					"leavesAt": "12:41",
					"arrivesAt": "12:49",
					"waitsAtSource": 30,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15034",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oşorhei Hm.",
					"leavesAt": "11:38",
					"arrivesAt": "11:49",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Aleşd",
					"leavesAt": "11:53",
					"arrivesAt": "12:14",
					"waitsAtSource": 240,
					"distance": 24800
				},
				{
					"from": "Aleşd",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "12:15",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "12:28",
					"arrivesAt": "12:36",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "12:37",
					"arrivesAt": "12:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bratca",
					"to": "Stâna de Vale h.",
					"leavesAt": "12:46",
					"arrivesAt": "12:50",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bulz Hm.",
					"leavesAt": "12:51",
					"arrivesAt": "12:54",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bulz Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "12:55",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Lacu Crişului h.",
					"leavesAt": "13:01",
					"arrivesAt": "13:05",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Negreni h.",
					"leavesAt": "13:06",
					"arrivesAt": "13:10",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Ciucea Hm.",
					"leavesAt": "13:11",
					"arrivesAt": "13:14",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ciucea Hm.",
					"to": "Poieni",
					"leavesAt": "13:15",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Poieni",
					"to": "Huedin",
					"leavesAt": "13:23",
					"arrivesAt": "13:37",
					"waitsAtSource": 60,
					"distance": 15300
				},
				{
					"from": "Huedin",
					"to": "Aghireş h.",
					"leavesAt": "13:38",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 18900
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "14:00",
					"arrivesAt": "14:04",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Gârbău Hm.",
					"leavesAt": "14:05",
					"arrivesAt": "14:12",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Gârbău Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "14:13",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 20200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15261",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Drăcşenei h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:58",
					"waitsAtSource": 0,
					"distance": 13500
				},
				{
					"from": "Drăcşenei h.",
					"to": "Beuca Sat h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:02",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Beuca Sat h.",
					"to": "Beuca h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:06",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca h.",
					"to": "Zâmbreasca h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Balaci Hm.",
					"leavesAt": "17:12",
					"arrivesAt": "17:19",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Balaci Hm.",
					"to": "Surduleşti h.",
					"leavesAt": "17:20",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Surduleşti h.",
					"to": "Miroşi",
					"leavesAt": "17:26",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Miroşi",
					"to": "Colţ h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Colţ h.",
					"to": "Costeşti",
					"leavesAt": "17:43",
					"arrivesAt": "18:15",
					"waitsAtSource": 30,
					"distance": 19300
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181216",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15102",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:44",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "05:45",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Târgovişte Nord",
					"leavesAt": "05:48",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Târgovişte Nord",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "05:52",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Răzvad hc.",
					"leavesAt": "05:58",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Răzvad hc.",
					"to": "Adânca PM.",
					"leavesAt": "06:01",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Adânca PM.",
					"to": "Mija",
					"leavesAt": "06:10",
					"arrivesAt": "06:19",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Mija",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "06:20",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "I. L. Caragiale",
					"leavesAt": "06:25",
					"arrivesAt": "06:30",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "06:38",
					"arrivesAt": "06:44",
					"waitsAtSource": 480,
					"distance": 5000
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "Brătăşanca h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Brătăşanca h.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "06:50",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "06:56",
					"arrivesAt": "06:59",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "07:00",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Ploieşti Vest",
					"leavesAt": "07:06",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "07:18",
					"arrivesAt": "07:24",
					"waitsAtSource": 120,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15051",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Periş",
					"leavesAt": "10:10",
					"arrivesAt": "10:33",
					"waitsAtSource": 0,
					"distance": 30200
				},
				{
					"from": "Periş",
					"to": "Crivina",
					"leavesAt": "10:34",
					"arrivesAt": "10:42",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "10:43",
					"arrivesAt": "10:53",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "10:57",
					"arrivesAt": "11:11",
					"waitsAtSource": 240,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "11:14",
					"arrivesAt": "11:47",
					"waitsAtSource": 180,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "11:48",
					"arrivesAt": "12:24",
					"waitsAtSource": 60,
					"distance": 35000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15352",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "06:51",
					"arrivesAt": "06:55",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "06:56",
					"arrivesAt": "07:00",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:04",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "07:12",
					"arrivesAt": "07:17",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "07:25",
					"arrivesAt": "07:31",
					"waitsAtSource": 480,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:35",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "07:36",
					"arrivesAt": "07:39",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "07:40",
					"arrivesAt": "07:43",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "07:44",
					"arrivesAt": "07:53",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "07:54",
					"arrivesAt": "07:59",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "08:05",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "08:19",
					"arrivesAt": "08:24",
					"waitsAtSource": 480,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "08:25",
					"arrivesAt": "08:30",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "08:31",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "08:36",
					"arrivesAt": "08:40",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "08:41",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "08:47",
					"arrivesAt": "08:53",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "08:54",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "09:01",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15132",
			"segments": [
				{
					"from": "Slănic",
					"to": "Prăjani h.",
					"leavesAt": "13:42",
					"arrivesAt": "13:46",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Prăjani h.",
					"to": "Vărbilău hc.",
					"leavesAt": "13:47",
					"arrivesAt": "13:51",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărbilău hc.",
					"to": "Vlădeşti h.",
					"leavesAt": "13:52",
					"arrivesAt": "13:55",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vlădeşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "13:56",
					"arrivesAt": "14:00",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "14:01",
					"arrivesAt": "14:04",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Mălăeşti h.",
					"leavesAt": "14:05",
					"arrivesAt": "14:10",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mălăeşti h.",
					"to": "Găvănel hc.",
					"leavesAt": "14:11",
					"arrivesAt": "14:14",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Găvănel hc.",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "14:15",
					"arrivesAt": "14:20",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Plopeni",
					"leavesAt": "14:21",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plopeni",
					"to": "Găgeni hc.",
					"leavesAt": "14:27",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Găgeni hc.",
					"to": "Buda",
					"leavesAt": "14:32",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "14:45",
					"arrivesAt": "14:52",
					"waitsAtSource": 240,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "14:53",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15256",
			"segments": [
				{
					"from": "Costeşti",
					"to": "Colţ h.",
					"leavesAt": "11:00",
					"arrivesAt": "11:31",
					"waitsAtSource": 0,
					"distance": 19300
				},
				{
					"from": "Colţ h.",
					"to": "Miroşi",
					"leavesAt": "11:32",
					"arrivesAt": "11:41",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Miroşi",
					"to": "Surduleşti h.",
					"leavesAt": "11:50",
					"arrivesAt": "11:55",
					"waitsAtSource": 540,
					"distance": 4700
				},
				{
					"from": "Surduleşti h.",
					"to": "Balaci Hm.",
					"leavesAt": "11:56",
					"arrivesAt": "12:01",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Balaci Hm.",
					"to": "Zâmbreasca h.",
					"leavesAt": "12:02",
					"arrivesAt": "12:08",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Beuca h.",
					"leavesAt": "12:09",
					"arrivesAt": "12:13",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Beuca h.",
					"to": "Beuca Sat h.",
					"leavesAt": "12:14",
					"arrivesAt": "12:17",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca Sat h.",
					"to": "Drăcşenei h.",
					"leavesAt": "12:18",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Drăcşenei h.",
					"to": "Roşiori Nord",
					"leavesAt": "12:22",
					"arrivesAt": "12:40",
					"waitsAtSource": 30,
					"distance": 13500
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181210",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15149",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Periş",
					"leavesAt": "14:37",
					"arrivesAt": "15:00",
					"waitsAtSource": 0,
					"distance": 30200
				},
				{
					"from": "Periş",
					"to": "Crivina",
					"leavesAt": "15:01",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Crivina",
					"to": "Ploieşti Sud",
					"leavesAt": "15:09",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 20500
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "15:34",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Nord",
					"leavesAt": "15:39",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploieşti Nord",
					"to": "Blejoi",
					"leavesAt": "15:45",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Blejoi",
					"to": "Scăieni h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Scăieni h.",
					"to": "Boldeşti hc.",
					"leavesAt": "15:56",
					"arrivesAt": "15:58",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Boldeşti hc.",
					"to": "Lipăneşti hc.",
					"leavesAt": "15:59",
					"arrivesAt": "16:03",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Măgurele Sud h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:07",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:12",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Nord h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Făget Teleajen",
					"leavesAt": "16:18",
					"arrivesAt": "16:21",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Făget Teleajen",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Vălenii de Munte",
					"leavesAt": "16:27",
					"arrivesAt": "16:31",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vălenii de Munte",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "16:32",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Teişani Hm.",
					"leavesAt": "16:38",
					"arrivesAt": "16:44",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Teişani Hm.",
					"to": "Homorâciu P.M.",
					"leavesAt": "16:45",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Izvoarele hc.",
					"leavesAt": "16:52",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "16:58",
					"arrivesAt": "17:01",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Măneciu",
					"leavesAt": "17:02",
					"arrivesAt": "17:07",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15184",
			"segments": [
				{
					"from": "Olteniţa",
					"to": "Valea Roşie hc.",
					"leavesAt": "14:15",
					"arrivesAt": "14:27",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Curcani h.",
					"leavesAt": "14:28",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Curcani h.",
					"to": "Luica h.",
					"leavesAt": "14:33",
					"arrivesAt": "14:37",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Luica h.",
					"to": "Şoldanu h.",
					"leavesAt": "14:38",
					"arrivesAt": "14:41",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şoldanu h.",
					"to": "Negoieşti h.",
					"leavesAt": "14:42",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Negoieşti h.",
					"to": "Budeşti Hm.",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Budeşti Hm.",
					"to": "Vasilaţi hc.",
					"leavesAt": "14:58",
					"arrivesAt": "15:03",
					"waitsAtSource": 480,
					"distance": 5500
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "15:04",
					"arrivesAt": "15:08",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "15:09",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "15:13",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "15:16",
					"arrivesAt": "15:19",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plătăreşti hc.",
					"to": "Frunzăneşti h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:23",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Tânganu h.",
					"leavesAt": "15:24",
					"arrivesAt": "15:27",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Tânganu h.",
					"to": "Căldăraru h.",
					"leavesAt": "15:28",
					"arrivesAt": "15:33",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Căldăraru h.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "15:34",
					"arrivesAt": "15:39",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Titan Sud Hm.",
					"leavesAt": "15:47",
					"arrivesAt": "15:56",
					"waitsAtSource": 480,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15252",
			"segments": [
				{
					"from": "Costeşti",
					"to": "Colţ h.",
					"leavesAt": "05:50",
					"arrivesAt": "06:21",
					"waitsAtSource": 0,
					"distance": 19300
				},
				{
					"from": "Colţ h.",
					"to": "Miroşi",
					"leavesAt": "06:22",
					"arrivesAt": "06:32",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Miroşi",
					"to": "Surduleşti h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Surduleşti h.",
					"to": "Balaci Hm.",
					"leavesAt": "06:40",
					"arrivesAt": "06:45",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Balaci Hm.",
					"to": "Zâmbreasca h.",
					"leavesAt": "06:55",
					"arrivesAt": "07:03",
					"waitsAtSource": 600,
					"distance": 5900
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Beuca h.",
					"leavesAt": "07:04",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Beuca h.",
					"to": "Beuca Sat h.",
					"leavesAt": "07:10",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Beuca Sat h.",
					"to": "Drăcşenei h.",
					"leavesAt": "07:15",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Drăcşenei h.",
					"to": "Roşiori Nord",
					"leavesAt": "07:20",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 13500
				}
			],
			"restrictions": [
				{
					"from": "20170701",
					"to": "20181209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15109",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "13:54",
					"arrivesAt": "13:59",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "14:00",
					"arrivesAt": "14:09",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "14:10",
					"arrivesAt": "14:14",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "14:15",
					"arrivesAt": "14:19",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Brătăşanca h.",
					"leavesAt": "14:20",
					"arrivesAt": "14:24",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Brătăşanca h.",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "14:25",
					"arrivesAt": "14:29",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "I. L. Caragiale",
					"leavesAt": "14:30",
					"arrivesAt": "14:38",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "I. L. Caragiale",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:51",
					"waitsAtSource": 600,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "Mija",
					"leavesAt": "14:52",
					"arrivesAt": "14:57",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mija",
					"to": "Adânca PM.",
					"leavesAt": "14:58",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Adânca PM.",
					"to": "Răzvad hc.",
					"leavesAt": "15:07",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Răzvad hc.",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "15:16",
					"arrivesAt": "15:20",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Târgovişte Nord",
					"leavesAt": "15:21",
					"arrivesAt": "15:27",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgovişte Nord",
					"to": "TEIŞ Hm.",
					"leavesAt": "15:29",
					"arrivesAt": "15:32",
					"waitsAtSource": 120,
					"distance": 1700
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "15:36",
					"arrivesAt": "15:40",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15112",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "18:20",
					"arrivesAt": "18:23",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "18:24",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Târgovişte Nord",
					"leavesAt": "18:27",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Târgovişte Nord",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "18:31",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Răzvad hc.",
					"leavesAt": "18:37",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Răzvad hc.",
					"to": "Adânca PM.",
					"leavesAt": "18:41",
					"arrivesAt": "18:49",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Adânca PM.",
					"to": "Mija",
					"leavesAt": "18:50",
					"arrivesAt": "19:00",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Mija",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "19:01",
					"arrivesAt": "19:05",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "I. L. Caragiale",
					"leavesAt": "19:06",
					"arrivesAt": "19:11",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "19:21",
					"arrivesAt": "19:27",
					"waitsAtSource": 600,
					"distance": 5000
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "Brătăşanca h.",
					"leavesAt": "19:28",
					"arrivesAt": "19:32",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Brătăşanca h.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "19:33",
					"arrivesAt": "19:39",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "19:40",
					"arrivesAt": "19:43",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "19:44",
					"arrivesAt": "19:49",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Ploieşti Vest",
					"leavesAt": "19:50",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "20:01",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15035",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Gârbău Hm.",
					"leavesAt": "14:02",
					"arrivesAt": "14:21",
					"waitsAtSource": 0,
					"distance": 20200
				},
				{
					"from": "Gârbău Hm.",
					"to": "Aghireş",
					"leavesAt": "14:22",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "14:31",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Huedin",
					"leavesAt": "14:35",
					"arrivesAt": "14:56",
					"waitsAtSource": 30,
					"distance": 18900
				},
				{
					"from": "Huedin",
					"to": "Brăişoru Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Poieni",
					"leavesAt": "15:05",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Poieni",
					"to": "Ciucea Hm.",
					"leavesAt": "15:12",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ciucea Hm.",
					"to": "Negreni h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Lacu Crişului h.",
					"leavesAt": "15:24",
					"arrivesAt": "15:27",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "15:28",
					"arrivesAt": "15:32",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bulz Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:38",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Bulz Hm.",
					"to": "Stâna de Vale h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bratca",
					"leavesAt": "15:42",
					"arrivesAt": "15:47",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bratca",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "15:48",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "15:57",
					"arrivesAt": "16:05",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Aleşd",
					"leavesAt": "16:06",
					"arrivesAt": "16:18",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Aleşd",
					"to": "Telechiu Hm.",
					"leavesAt": "16:19",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Telechiu Hm.",
					"to": "Oşorhei Hm.",
					"leavesAt": "16:28",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Oradea",
					"leavesAt": "16:44",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 336
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15170",
			"segments": [
				{
					"from": "Olteniţa",
					"to": "Valea Roşie hc.",
					"leavesAt": "03:30",
					"arrivesAt": "03:42",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Curcani h.",
					"leavesAt": "03:43",
					"arrivesAt": "03:47",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Curcani h.",
					"to": "Luica h.",
					"leavesAt": "03:48",
					"arrivesAt": "03:52",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Luica h.",
					"to": "Şoldanu h.",
					"leavesAt": "03:53",
					"arrivesAt": "03:56",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şoldanu h.",
					"to": "Negoieşti h.",
					"leavesAt": "03:57",
					"arrivesAt": "03:59",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Negoieşti h.",
					"to": "Budeşti Hm.",
					"leavesAt": "04:00",
					"arrivesAt": "04:05",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Budeşti Hm.",
					"to": "Vasilaţi hc.",
					"leavesAt": "04:06",
					"arrivesAt": "04:11",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "04:12",
					"arrivesAt": "04:15",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "04:16",
					"arrivesAt": "04:19",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "04:20",
					"arrivesAt": "04:23",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "04:24",
					"arrivesAt": "04:26",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plătăreşti hc.",
					"to": "Frunzăneşti h.",
					"leavesAt": "04:27",
					"arrivesAt": "04:31",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Tânganu h.",
					"leavesAt": "04:32",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Tânganu h.",
					"to": "Căldăraru h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:41",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Căldăraru h.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "04:42",
					"arrivesAt": "04:46",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Titan Sud Hm.",
					"leavesAt": "04:47",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15120",
			"segments": [
				{
					"from": "Slănic",
					"to": "Prăjani h.",
					"leavesAt": "04:30",
					"arrivesAt": "04:34",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Prăjani h.",
					"to": "Vărbilău hc.",
					"leavesAt": "04:35",
					"arrivesAt": "04:39",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărbilău hc.",
					"to": "Vlădeşti h.",
					"leavesAt": "04:40",
					"arrivesAt": "04:43",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vlădeşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "04:44",
					"arrivesAt": "04:48",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "04:49",
					"arrivesAt": "04:52",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Mălăeşti h.",
					"leavesAt": "04:53",
					"arrivesAt": "04:58",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mălăeşti h.",
					"to": "Găvănel hc.",
					"leavesAt": "04:59",
					"arrivesAt": "05:02",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Găvănel hc.",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "05:03",
					"arrivesAt": "05:08",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Plopeni",
					"leavesAt": "05:09",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plopeni",
					"to": "Găgeni hc.",
					"leavesAt": "05:14",
					"arrivesAt": "05:18",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Găgeni hc.",
					"to": "Buda",
					"leavesAt": "05:19",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "05:29",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "05:38",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15141",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "05:55",
					"arrivesAt": "05:59",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Nord",
					"leavesAt": "06:00",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploieşti Nord",
					"to": "Blejoi",
					"leavesAt": "06:06",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Blejoi",
					"to": "Scăieni h.",
					"leavesAt": "06:13",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Scăieni h.",
					"to": "Boldeşti hc.",
					"leavesAt": "06:19",
					"arrivesAt": "06:21",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Boldeşti hc.",
					"to": "Lipăneşti hc.",
					"leavesAt": "06:22",
					"arrivesAt": "06:26",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Măgurele Sud h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:36",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Nord h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Făget Teleajen",
					"leavesAt": "06:43",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Făget Teleajen",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Vălenii de Munte",
					"leavesAt": "06:53",
					"arrivesAt": "06:57",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vălenii de Munte",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "06:58",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Teişani Hm.",
					"leavesAt": "07:04",
					"arrivesAt": "07:10",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Teişani Hm.",
					"to": "Homorâciu P.M.",
					"leavesAt": "07:11",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Izvoarele hc.",
					"leavesAt": "07:18",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "07:24",
					"arrivesAt": "07:27",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Măneciu",
					"leavesAt": "07:28",
					"arrivesAt": "07:33",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15148",
			"segments": [
				{
					"from": "Măneciu",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "08:08",
					"arrivesAt": "08:12",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Izvoarele hc.",
					"leavesAt": "08:13",
					"arrivesAt": "08:15",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Homorâciu P.M.",
					"leavesAt": "08:16",
					"arrivesAt": "08:22",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Teişani Hm.",
					"leavesAt": "08:23",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Teişani Hm.",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "08:28",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Vălenii de Munte",
					"leavesAt": "08:33",
					"arrivesAt": "08:37",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălenii de Munte",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Făget Teleajen",
					"leavesAt": "08:42",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Făget Teleajen",
					"to": "Măgurele Nord h.",
					"leavesAt": "08:55",
					"arrivesAt": "08:57",
					"waitsAtSource": 540,
					"distance": 1700
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "08:58",
					"arrivesAt": "09:02",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Sud h.",
					"leavesAt": "09:03",
					"arrivesAt": "09:05",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Lipăneşti hc.",
					"leavesAt": "09:06",
					"arrivesAt": "09:09",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Boldeşti hc.",
					"leavesAt": "09:10",
					"arrivesAt": "09:14",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Boldeşti hc.",
					"to": "Scăieni h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:16",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Scăieni h.",
					"to": "Blejoi",
					"leavesAt": "09:17",
					"arrivesAt": "09:22",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Blejoi",
					"to": "Ploieşti Nord",
					"leavesAt": "09:23",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ploieşti Nord",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "09:29",
					"arrivesAt": "09:33",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Sud",
					"leavesAt": "09:34",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Brazi",
					"leavesAt": "09:45",
					"arrivesAt": "09:59",
					"waitsAtSource": 300,
					"distance": 8800
				},
				{
					"from": "Brazi",
					"to": "Crivina",
					"leavesAt": "10:00",
					"arrivesAt": "10:09",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "10:10",
					"arrivesAt": "10:14",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "10:15",
					"arrivesAt": "10:20",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Bucureşti Nord",
					"leavesAt": "10:21",
					"arrivesAt": "10:49",
					"waitsAtSource": 60,
					"distance": 30200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15263",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Drăcşenei h.",
					"leavesAt": "18:46",
					"arrivesAt": "19:04",
					"waitsAtSource": 0,
					"distance": 13500
				},
				{
					"from": "Drăcşenei h.",
					"to": "Beuca Sat h.",
					"leavesAt": "19:05",
					"arrivesAt": "19:08",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Beuca Sat h.",
					"to": "Beuca h.",
					"leavesAt": "19:09",
					"arrivesAt": "19:12",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca h.",
					"to": "Zâmbreasca h.",
					"leavesAt": "19:13",
					"arrivesAt": "19:17",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Balaci Hm.",
					"leavesAt": "19:18",
					"arrivesAt": "19:25",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Balaci Hm.",
					"to": "Surduleşti h.",
					"leavesAt": "19:34",
					"arrivesAt": "19:39",
					"waitsAtSource": 540,
					"distance": 4100
				},
				{
					"from": "Surduleşti h.",
					"to": "Miroşi",
					"leavesAt": "19:40",
					"arrivesAt": "19:46",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Miroşi",
					"to": "Colţ h.",
					"leavesAt": "19:47",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Colţ h.",
					"to": "Costeşti",
					"leavesAt": "19:57",
					"arrivesAt": "20:29",
					"waitsAtSource": 30,
					"distance": 19300
				}
			],
			"restrictions": [
				{
					"from": "20170701",
					"to": "20181211",
					"daysOfWeek": 383
				},
				{
					"from": "20181214",
					"to": "20181229",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15151",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "17:12",
					"arrivesAt": "17:16",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Nord",
					"leavesAt": "17:17",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploieşti Nord",
					"to": "Blejoi",
					"leavesAt": "17:22",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Blejoi",
					"to": "Scăieni h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:41",
					"waitsAtSource": 540,
					"distance": 3800
				},
				{
					"from": "Scăieni h.",
					"to": "Boldeşti hc.",
					"leavesAt": "17:42",
					"arrivesAt": "17:44",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Boldeşti hc.",
					"to": "Lipăneşti hc.",
					"leavesAt": "17:45",
					"arrivesAt": "17:49",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Măgurele Sud h.",
					"leavesAt": "17:50",
					"arrivesAt": "17:53",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "17:54",
					"arrivesAt": "17:58",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Nord h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:03",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Făget Teleajen",
					"leavesAt": "18:04",
					"arrivesAt": "18:07",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Făget Teleajen",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "18:08",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Vălenii de Munte",
					"leavesAt": "18:13",
					"arrivesAt": "18:17",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vălenii de Munte",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "18:18",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Teişani Hm.",
					"leavesAt": "18:24",
					"arrivesAt": "18:30",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Teişani Hm.",
					"to": "Homorâciu P.M.",
					"leavesAt": "18:31",
					"arrivesAt": "18:37",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Izvoarele hc.",
					"leavesAt": "18:38",
					"arrivesAt": "18:43",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "18:44",
					"arrivesAt": "18:47",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Măneciu",
					"leavesAt": "18:48",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15361",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Nord Hm.",
					"leavesAt": "16:51",
					"arrivesAt": "17:01",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Verneşti",
					"leavesAt": "17:02",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Verneşti",
					"to": "Cândeşti hc.",
					"leavesAt": "17:10",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Cândeşti hc.",
					"to": "Berca Hm.",
					"leavesAt": "17:18",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Berca Hm.",
					"to": "Ojasca h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ojasca h.",
					"to": "Unguriu hc.",
					"leavesAt": "17:30",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Unguriu hc.",
					"to": "Măgura hcv.",
					"leavesAt": "17:35",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Măgura hcv.",
					"to": "Pârscov",
					"leavesAt": "17:41",
					"arrivesAt": "17:47",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pârscov",
					"to": "Bădila h.",
					"leavesAt": "17:55",
					"arrivesAt": "18:01",
					"waitsAtSource": 480,
					"distance": 4300
				},
				{
					"from": "Bădila h.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "18:02",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Vipereşti hc.",
					"leavesAt": "18:07",
					"arrivesAt": "18:12",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vipereşti hc.",
					"to": "Cislău hcv.",
					"leavesAt": "18:13",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cislău hcv.",
					"to": "Gura Bascii h.",
					"leavesAt": "18:23",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Gura Bascii h.",
					"to": "Valea Seacă h.",
					"leavesAt": "18:27",
					"arrivesAt": "18:30",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Valea Seacă h.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "18:31",
					"arrivesAt": "18:34",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "18:35",
					"arrivesAt": "18:41",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "18:42",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Şeţu h.",
					"leavesAt": "18:47",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şeţu h.",
					"to": "Păltineni h.",
					"leavesAt": "18:54",
					"arrivesAt": "18:58",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Păltineni h.",
					"to": "Nehoiu h.",
					"leavesAt": "18:59",
					"arrivesAt": "19:03",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Nehoiu h.",
					"to": "Nehoiaşu",
					"leavesAt": "19:04",
					"arrivesAt": "19:08",
					"waitsAtSource": 30,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15259",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Drăcşenei h.",
					"leavesAt": "14:26",
					"arrivesAt": "14:44",
					"waitsAtSource": 0,
					"distance": 13500
				},
				{
					"from": "Drăcşenei h.",
					"to": "Beuca Sat h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:48",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Beuca Sat h.",
					"to": "Beuca h.",
					"leavesAt": "14:49",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca h.",
					"to": "Zâmbreasca h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:57",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Balaci Hm.",
					"leavesAt": "14:58",
					"arrivesAt": "15:05",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Balaci Hm.",
					"to": "Surduleşti h.",
					"leavesAt": "15:06",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Surduleşti h.",
					"to": "Miroşi",
					"leavesAt": "15:12",
					"arrivesAt": "15:18",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Miroşi",
					"to": "Colţ h.",
					"leavesAt": "15:19",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Colţ h.",
					"to": "Costeşti",
					"leavesAt": "15:29",
					"arrivesAt": "16:01",
					"waitsAtSource": 30,
					"distance": 19300
				}
			],
			"restrictions": [
				{
					"from": "20170701",
					"to": "20181210",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15061",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Periş",
					"leavesAt": "08:32",
					"arrivesAt": "08:55",
					"waitsAtSource": 0,
					"distance": 30200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "08:56",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "09:02",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "09:08",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "09:21",
					"arrivesAt": "09:36",
					"waitsAtSource": 120,
					"distance": 8800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15160",
			"segments": [
				{
					"from": "Pietroşiţa Hm.",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:36",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Fieni",
					"leavesAt": "14:37",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Moţăieni h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Moţăieni h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "14:48",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Trainica h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Trainica h.",
					"to": "Scârlenţa h.",
					"leavesAt": "14:57",
					"arrivesAt": "14:59",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Scârlenţa h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "15:00",
					"arrivesAt": "15:03",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Doiceşti h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Doiceşti h.",
					"to": "Doiceşti",
					"leavesAt": "15:07",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Doiceşti",
					"to": "Aninoasa Hm.",
					"leavesAt": "15:10",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Aninoasa Hm.",
					"to": "TEIŞ Hm.",
					"leavesAt": "15:17",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "15:21",
					"arrivesAt": "15:23",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "15:24",
					"arrivesAt": "15:28",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20180702",
					"to": "20180707",
					"daysOfWeek": 320
				},
				{
					"from": "20180709",
					"to": "20180714",
					"daysOfWeek": 320
				},
				{
					"from": "20180716",
					"to": "20180721",
					"daysOfWeek": 320
				},
				{
					"from": "20180723",
					"to": "20180728",
					"daysOfWeek": 320
				},
				{
					"from": "20180730",
					"to": "20180804",
					"daysOfWeek": 320
				},
				{
					"from": "20180806",
					"to": "20180811",
					"daysOfWeek": 320
				},
				{
					"from": "20180813",
					"to": "20180818",
					"daysOfWeek": 320
				},
				{
					"from": "20180820",
					"to": "20180825",
					"daysOfWeek": 320
				},
				{
					"from": "20180827",
					"to": "20180901",
					"daysOfWeek": 320
				},
				{
					"from": "20180903",
					"to": "20180908",
					"daysOfWeek": 320
				},
				{
					"from": "20180910",
					"to": "20180915",
					"daysOfWeek": 320
				},
				{
					"from": "20180917",
					"to": "20180922",
					"daysOfWeek": 320
				},
				{
					"from": "20180924",
					"to": "20181208",
					"daysOfWeek": 320
				},
				{
					"from": "20171210",
					"to": "20180630",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15145",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "12:22",
					"arrivesAt": "12:26",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Nord",
					"leavesAt": "12:27",
					"arrivesAt": "12:32",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploieşti Nord",
					"to": "Blejoi",
					"leavesAt": "12:33",
					"arrivesAt": "12:38",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Blejoi",
					"to": "Scăieni h.",
					"leavesAt": "12:39",
					"arrivesAt": "12:43",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Scăieni h.",
					"to": "Boldeşti hc.",
					"leavesAt": "12:44",
					"arrivesAt": "12:46",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Boldeşti hc.",
					"to": "Lipăneşti hc.",
					"leavesAt": "12:47",
					"arrivesAt": "12:51",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Măgurele Sud h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:55",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "12:56",
					"arrivesAt": "13:00",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Nord h.",
					"leavesAt": "13:01",
					"arrivesAt": "13:05",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Făget Teleajen",
					"leavesAt": "13:06",
					"arrivesAt": "13:09",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Făget Teleajen",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "13:10",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Vălenii de Munte",
					"leavesAt": "13:15",
					"arrivesAt": "13:19",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vălenii de Munte",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "13:20",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Teişani Hm.",
					"leavesAt": "13:26",
					"arrivesAt": "13:32",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Teişani Hm.",
					"to": "Homorâciu P.M.",
					"leavesAt": "13:33",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Izvoarele hc.",
					"leavesAt": "13:40",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "13:46",
					"arrivesAt": "13:49",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Măneciu",
					"leavesAt": "13:50",
					"arrivesAt": "13:55",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15311",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Tuluceşti Hm.",
					"leavesAt": "13:05",
					"arrivesAt": "13:29",
					"waitsAtSource": 0,
					"distance": 13600
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Şiviţa h.",
					"leavesAt": "13:37",
					"arrivesAt": "13:43",
					"waitsAtSource": 480,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "13:44",
					"arrivesAt": "13:50",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Stoicani h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:57",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stoicani h.",
					"to": "Folteşti Hm.",
					"leavesAt": "13:58",
					"arrivesAt": "14:03",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Folteşti Hm.",
					"to": "Chiraftei h.",
					"leavesAt": "14:04",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Chiraftei h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "14:11",
					"arrivesAt": "14:15",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Băleni h.",
					"leavesAt": "14:16",
					"arrivesAt": "14:20",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Băleni h.",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "14:21",
					"arrivesAt": "14:26",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Târgu Bujor",
					"leavesAt": "14:27",
					"arrivesAt": "14:30",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgu Bujor",
					"to": "Moscu hc.",
					"leavesAt": "14:38",
					"arrivesAt": "14:42",
					"waitsAtSource": 480,
					"distance": 3200
				},
				{
					"from": "Moscu hc.",
					"to": "Roşcani h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:49",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Roşcani h.",
					"to": "Balinteşti h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:58",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Balinteşti h.",
					"to": "Bereşti Hm.",
					"leavesAt": "14:59",
					"arrivesAt": "15:08",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Bereşti Hm.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "15:09",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Tălăşmani h.",
					"leavesAt": "15:14",
					"arrivesAt": "15:22",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Tălăşmani h.",
					"to": "Docăneasa hc.",
					"leavesAt": "15:23",
					"arrivesAt": "15:29",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Docăneasa hc.",
					"to": "Lungeşti h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:33",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lungeşti h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "15:34",
					"arrivesAt": "15:40",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Griviţa h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Griviţa h.",
					"to": "Bârlad",
					"leavesAt": "15:46",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15359",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Nord Hm.",
					"leavesAt": "15:15",
					"arrivesAt": "15:25",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Verneşti",
					"leavesAt": "15:33",
					"arrivesAt": "15:39",
					"waitsAtSource": 480,
					"distance": 5500
				},
				{
					"from": "Verneşti",
					"to": "Cândeşti hc.",
					"leavesAt": "15:40",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Cândeşti hc.",
					"to": "Berca Hm.",
					"leavesAt": "15:47",
					"arrivesAt": "15:53",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Berca Hm.",
					"to": "Ojasca h.",
					"leavesAt": "15:54",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ojasca h.",
					"to": "Unguriu hc.",
					"leavesAt": "15:58",
					"arrivesAt": "16:02",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Unguriu hc.",
					"to": "Măgura hcv.",
					"leavesAt": "16:03",
					"arrivesAt": "16:08",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Măgura hcv.",
					"to": "Pârscov",
					"leavesAt": "16:09",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pârscov",
					"to": "Bădila h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bădila h.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "16:23",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Vipereşti hc.",
					"leavesAt": "16:28",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vipereşti hc.",
					"to": "Cislău hcv.",
					"leavesAt": "16:34",
					"arrivesAt": "16:44",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cislău hcv.",
					"to": "Gura Bascii h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Gura Bascii h.",
					"to": "Valea Seacă h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Valea Seacă h.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "16:53",
					"arrivesAt": "16:56",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "16:57",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Şeţu h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şeţu h.",
					"to": "Păltineni h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Păltineni h.",
					"to": "Nehoiu h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Nehoiu h.",
					"to": "Nehoiaşu",
					"leavesAt": "17:26",
					"arrivesAt": "17:30",
					"waitsAtSource": 30,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20180101",
					"to": "20180105",
					"daysOfWeek": 383
				},
				{
					"from": "20180108",
					"to": "20180112",
					"daysOfWeek": 383
				},
				{
					"from": "20180115",
					"to": "20180119",
					"daysOfWeek": 383
				},
				{
					"from": "20180122",
					"to": "20180126",
					"daysOfWeek": 383
				},
				{
					"from": "20180129",
					"to": "20180202",
					"daysOfWeek": 383
				},
				{
					"from": "20180205",
					"to": "20180209",
					"daysOfWeek": 383
				},
				{
					"from": "20180212",
					"to": "20180216",
					"daysOfWeek": 383
				},
				{
					"from": "20180219",
					"to": "20180223",
					"daysOfWeek": 383
				},
				{
					"from": "20180226",
					"to": "20180302",
					"daysOfWeek": 383
				},
				{
					"from": "20180305",
					"to": "20180309",
					"daysOfWeek": 383
				},
				{
					"from": "20180312",
					"to": "20180316",
					"daysOfWeek": 383
				},
				{
					"from": "20180319",
					"to": "20180323",
					"daysOfWeek": 383
				},
				{
					"from": "20180326",
					"to": "20180330",
					"daysOfWeek": 383
				},
				{
					"from": "20180402",
					"to": "20180406",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20180413",
					"daysOfWeek": 383
				},
				{
					"from": "20180416",
					"to": "20180420",
					"daysOfWeek": 383
				},
				{
					"from": "20180423",
					"to": "20180427",
					"daysOfWeek": 383
				},
				{
					"from": "20180430",
					"to": "20180504",
					"daysOfWeek": 383
				},
				{
					"from": "20180507",
					"to": "20180511",
					"daysOfWeek": 383
				},
				{
					"from": "20180514",
					"to": "20180518",
					"daysOfWeek": 383
				},
				{
					"from": "20180521",
					"to": "20180525",
					"daysOfWeek": 383
				},
				{
					"from": "20180528",
					"to": "20180601",
					"daysOfWeek": 383
				},
				{
					"from": "20180604",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180611",
					"to": "20180615",
					"daysOfWeek": 383
				},
				{
					"from": "20180618",
					"to": "20180622",
					"daysOfWeek": 383
				},
				{
					"from": "20180625",
					"to": "20180629",
					"daysOfWeek": 383
				},
				{
					"from": "20180701",
					"to": "20180706",
					"daysOfWeek": 383
				},
				{
					"from": "20180708",
					"to": "20180713",
					"daysOfWeek": 383
				},
				{
					"from": "20180715",
					"to": "20180720",
					"daysOfWeek": 383
				},
				{
					"from": "20180722",
					"to": "20180727",
					"daysOfWeek": 383
				},
				{
					"from": "20180729",
					"to": "20180803",
					"daysOfWeek": 383
				},
				{
					"from": "20180805",
					"to": "20180810",
					"daysOfWeek": 383
				},
				{
					"from": "20180812",
					"to": "20180817",
					"daysOfWeek": 383
				},
				{
					"from": "20180819",
					"to": "20180824",
					"daysOfWeek": 383
				},
				{
					"from": "20180826",
					"to": "20180831",
					"daysOfWeek": 383
				},
				{
					"from": "20180902",
					"to": "20180907",
					"daysOfWeek": 383
				},
				{
					"from": "20180909",
					"to": "20180914",
					"daysOfWeek": 383
				},
				{
					"from": "20180916",
					"to": "20180921",
					"daysOfWeek": 383
				},
				{
					"from": "20180923",
					"to": "20180928",
					"daysOfWeek": 383
				},
				{
					"from": "20180930",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171211",
					"to": "20171215",
					"daysOfWeek": 383
				},
				{
					"from": "20171218",
					"to": "20171222",
					"daysOfWeek": 383
				},
				{
					"from": "20171225",
					"to": "20171229",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15255",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Drăcşenei h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:18",
					"waitsAtSource": 0,
					"distance": 13500
				},
				{
					"from": "Drăcşenei h.",
					"to": "Beuca Sat h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:22",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Beuca Sat h.",
					"to": "Beuca h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:26",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca h.",
					"to": "Zâmbreasca h.",
					"leavesAt": "08:27",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Balaci Hm.",
					"leavesAt": "08:32",
					"arrivesAt": "08:39",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Balaci Hm.",
					"to": "Surduleşti h.",
					"leavesAt": "08:40",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Surduleşti h.",
					"to": "Miroşi",
					"leavesAt": "08:46",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Miroşi",
					"to": "Colţ h.",
					"leavesAt": "09:01",
					"arrivesAt": "09:10",
					"waitsAtSource": 540,
					"distance": 8100
				},
				{
					"from": "Colţ h.",
					"to": "Costeşti",
					"leavesAt": "09:11",
					"arrivesAt": "09:43",
					"waitsAtSource": 30,
					"distance": 19300
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15161",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "12:38",
					"arrivesAt": "12:40",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "12:41",
					"arrivesAt": "12:43",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Aninoasa Hm.",
					"leavesAt": "12:44",
					"arrivesAt": "12:47",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Aninoasa Hm.",
					"to": "Doiceşti",
					"leavesAt": "12:48",
					"arrivesAt": "12:54",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Doiceşti",
					"to": "Doiceşti h.",
					"leavesAt": "12:55",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Doiceşti h.",
					"to": "Vulcana Pandele P.M.Aj.",
					"leavesAt": "12:58",
					"arrivesAt": "13:01",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vulcana Pandele P.M.Aj.",
					"to": "Scârlenţa h.",
					"leavesAt": "13:02",
					"arrivesAt": "13:05",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Scârlenţa h.",
					"to": "Trainica h.",
					"leavesAt": "13:06",
					"arrivesAt": "13:08",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Trainica h.",
					"to": "Pucioasa Hm.",
					"leavesAt": "13:09",
					"arrivesAt": "13:14",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Pucioasa Hm.",
					"to": "Moţăieni h.",
					"leavesAt": "13:15",
					"arrivesAt": "13:18",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Moţăieni h.",
					"to": "Fieni",
					"leavesAt": "13:19",
					"arrivesAt": "13:24",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Fieni",
					"to": "Ţepeş Vodă h.",
					"leavesAt": "13:25",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ţepeş Vodă h.",
					"to": "Pietroşiţa Hm.",
					"leavesAt": "13:29",
					"arrivesAt": "13:37",
					"waitsAtSource": 30,
					"distance": 4100
				}
			],
			"restrictions": [
				{
					"from": "20180702",
					"to": "20180707",
					"daysOfWeek": 320
				},
				{
					"from": "20180709",
					"to": "20180711",
					"daysOfWeek": 320
				},
				{
					"from": "20180713",
					"to": "20180714",
					"daysOfWeek": 320
				},
				{
					"from": "20180716",
					"to": "20180718",
					"daysOfWeek": 320
				},
				{
					"from": "20180720",
					"to": "20180721",
					"daysOfWeek": 320
				},
				{
					"from": "20180723",
					"to": "20180728",
					"daysOfWeek": 320
				},
				{
					"from": "20180730",
					"to": "20180804",
					"daysOfWeek": 320
				},
				{
					"from": "20180806",
					"to": "20180811",
					"daysOfWeek": 320
				},
				{
					"from": "20180813",
					"to": "20180818",
					"daysOfWeek": 320
				},
				{
					"from": "20180820",
					"to": "20180825",
					"daysOfWeek": 320
				},
				{
					"from": "20180827",
					"to": "20180901",
					"daysOfWeek": 320
				},
				{
					"from": "20180903",
					"to": "20180908",
					"daysOfWeek": 320
				},
				{
					"from": "20180910",
					"to": "20180915",
					"daysOfWeek": 320
				},
				{
					"from": "20180917",
					"to": "20180922",
					"daysOfWeek": 320
				},
				{
					"from": "20180924",
					"to": "20181208",
					"daysOfWeek": 320
				},
				{
					"from": "20171210",
					"to": "20180630",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15150",
			"segments": [
				{
					"from": "Măneciu",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "10:52",
					"arrivesAt": "10:56",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Izvoarele hc.",
					"leavesAt": "10:57",
					"arrivesAt": "10:59",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Homorâciu P.M.",
					"leavesAt": "11:00",
					"arrivesAt": "11:06",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Teişani Hm.",
					"leavesAt": "11:07",
					"arrivesAt": "11:11",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Teişani Hm.",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "11:12",
					"arrivesAt": "11:16",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Vălenii de Munte",
					"leavesAt": "11:17",
					"arrivesAt": "11:21",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălenii de Munte",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "11:22",
					"arrivesAt": "11:25",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Făget Teleajen",
					"leavesAt": "11:26",
					"arrivesAt": "11:30",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Făget Teleajen",
					"to": "Măgurele Nord h.",
					"leavesAt": "11:31",
					"arrivesAt": "11:33",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "11:34",
					"arrivesAt": "11:38",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Sud h.",
					"leavesAt": "11:39",
					"arrivesAt": "11:41",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Lipăneşti hc.",
					"leavesAt": "11:42",
					"arrivesAt": "11:45",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Boldeşti hc.",
					"leavesAt": "11:46",
					"arrivesAt": "11:50",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Boldeşti hc.",
					"to": "Scăieni h.",
					"leavesAt": "11:51",
					"arrivesAt": "11:52",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Scăieni h.",
					"to": "Blejoi",
					"leavesAt": "11:53",
					"arrivesAt": "11:58",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Blejoi",
					"to": "Ploieşti Nord",
					"leavesAt": "11:59",
					"arrivesAt": "12:04",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ploieşti Nord",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "12:05",
					"arrivesAt": "12:09",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Sud",
					"leavesAt": "12:10",
					"arrivesAt": "12:16",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Crivina",
					"leavesAt": "13:00",
					"arrivesAt": "13:22",
					"waitsAtSource": 2640,
					"distance": 20500
				},
				{
					"from": "Crivina",
					"to": "Periş",
					"leavesAt": "13:23",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Periş",
					"to": "Bucureşti Nord",
					"leavesAt": "13:31",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 30200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15264",
			"segments": [
				{
					"from": "Costeşti",
					"to": "Colţ h.",
					"leavesAt": "20:40",
					"arrivesAt": "21:11",
					"waitsAtSource": 0,
					"distance": 19300
				},
				{
					"from": "Colţ h.",
					"to": "Miroşi",
					"leavesAt": "21:12",
					"arrivesAt": "21:21",
					"waitsAtSource": 30,
					"distance": 8100
				}
			],
			"restrictions": [
				{
					"from": "20170701",
					"to": "20181210",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15129",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "13:42",
					"arrivesAt": "13:47",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "13:49",
					"arrivesAt": "13:56",
					"waitsAtSource": 120,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Găgeni hc.",
					"leavesAt": "13:57",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Găgeni hc.",
					"to": "Plopeni",
					"leavesAt": "14:06",
					"arrivesAt": "14:10",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "14:11",
					"arrivesAt": "14:15",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Găvănel hc.",
					"leavesAt": "14:24",
					"arrivesAt": "14:28",
					"waitsAtSource": 540,
					"distance": 2700
				},
				{
					"from": "Găvănel hc.",
					"to": "Mălăeşti h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:32",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mălăeşti h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "14:33",
					"arrivesAt": "14:38",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "14:39",
					"arrivesAt": "14:43",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Vlădeşti h.",
					"leavesAt": "14:44",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Vlădeşti h.",
					"to": "Vărbilău hc.",
					"leavesAt": "14:48",
					"arrivesAt": "14:51",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vărbilău hc.",
					"to": "Prăjani h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:56",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Prăjani h.",
					"to": "Slănic",
					"leavesAt": "14:57",
					"arrivesAt": "15:02",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15056",
			"segments": [
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "16:50",
					"arrivesAt": "17:22",
					"waitsAtSource": 0,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "17:23",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Triaj",
					"leavesAt": "18:04",
					"arrivesAt": "18:11",
					"waitsAtSource": 360,
					"distance": 3600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Crivina",
					"leavesAt": "18:15",
					"arrivesAt": "18:30",
					"waitsAtSource": 240,
					"distance": 16900
				},
				{
					"from": "Crivina",
					"to": "Bucureşti Nord",
					"leavesAt": "18:31",
					"arrivesAt": "19:05",
					"waitsAtSource": 60,
					"distance": 39700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15072",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Barboşi",
					"leavesAt": "07:25",
					"arrivesAt": "07:44",
					"waitsAtSource": 0,
					"distance": 12000
				},
				{
					"from": "Barboşi",
					"to": "Vădeni Hm.",
					"leavesAt": "07:45",
					"arrivesAt": "07:52",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Vădeni Hm.",
					"to": "Baldovineşti Hm.",
					"leavesAt": "07:53",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Brăila",
					"leavesAt": "07:59",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Brăila",
					"to": "Ianca hc.",
					"leavesAt": "08:13",
					"arrivesAt": "08:43",
					"waitsAtSource": 360,
					"distance": 42400
				},
				{
					"from": "Ianca hc.",
					"to": "Făurei",
					"leavesAt": "08:44",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Făurei",
					"to": "Buzău",
					"leavesAt": "09:01",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "09:43",
					"arrivesAt": "10:15",
					"waitsAtSource": 180,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "10:17",
					"arrivesAt": "10:53",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Triaj",
					"leavesAt": "10:55",
					"arrivesAt": "11:02",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Bucureşti Nord",
					"leavesAt": "11:06",
					"arrivesAt": "11:55",
					"waitsAtSource": 240,
					"distance": 56600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15360",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "13:37",
					"arrivesAt": "13:40",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "13:41",
					"arrivesAt": "13:45",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "13:46",
					"arrivesAt": "13:49",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "13:50",
					"arrivesAt": "13:56",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "13:57",
					"arrivesAt": "14:02",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "14:03",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "14:09",
					"arrivesAt": "14:12",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:16",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "14:17",
					"arrivesAt": "14:20",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "14:21",
					"arrivesAt": "14:30",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "14:31",
					"arrivesAt": "14:36",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "14:37",
					"arrivesAt": "14:41",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "14:42",
					"arrivesAt": "14:48",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "14:49",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "14:54",
					"arrivesAt": "14:59",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "15:05",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "15:10",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "15:16",
					"arrivesAt": "15:22",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "15:23",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "15:30",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15351",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Nord Hm.",
					"leavesAt": "07:26",
					"arrivesAt": "07:36",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Verneşti",
					"leavesAt": "07:37",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Verneşti",
					"to": "Cândeşti hc.",
					"leavesAt": "07:44",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Cândeşti hc.",
					"to": "Berca Hm.",
					"leavesAt": "07:51",
					"arrivesAt": "07:57",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Berca Hm.",
					"to": "Ojasca h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ojasca h.",
					"to": "Unguriu hc.",
					"leavesAt": "08:02",
					"arrivesAt": "08:06",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Unguriu hc.",
					"to": "Măgura hcv.",
					"leavesAt": "08:07",
					"arrivesAt": "08:11",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Măgura hcv.",
					"to": "Pârscov",
					"leavesAt": "08:12",
					"arrivesAt": "08:16",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pârscov",
					"to": "Bădila h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bădila h.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "08:24",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Vipereşti hc.",
					"leavesAt": "08:29",
					"arrivesAt": "08:34",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vipereşti hc.",
					"to": "Cislău hcv.",
					"leavesAt": "08:35",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cislău hcv.",
					"to": "Gura Bascii h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:48",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Gura Bascii h.",
					"to": "Valea Seacă h.",
					"leavesAt": "08:49",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Valea Seacă h.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "08:53",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "08:57",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Şeţu h.",
					"leavesAt": "09:09",
					"arrivesAt": "09:15",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şeţu h.",
					"to": "Păltineni h.",
					"leavesAt": "09:16",
					"arrivesAt": "09:19",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Păltineni h.",
					"to": "Nehoiu h.",
					"leavesAt": "09:20",
					"arrivesAt": "09:24",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Nehoiu h.",
					"to": "Nehoiaşu",
					"leavesAt": "09:25",
					"arrivesAt": "09:29",
					"waitsAtSource": 30,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15307",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Tuluceşti Hm.",
					"leavesAt": "08:00",
					"arrivesAt": "08:25",
					"waitsAtSource": 0,
					"distance": 13600
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Şiviţa h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:39",
					"waitsAtSource": 480,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "08:40",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Stoicani h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:53",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stoicani h.",
					"to": "Folteşti Hm.",
					"leavesAt": "08:54",
					"arrivesAt": "08:59",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Folteşti Hm.",
					"to": "Chiraftei h.",
					"leavesAt": "09:00",
					"arrivesAt": "09:06",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Chiraftei h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "09:07",
					"arrivesAt": "09:11",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Băleni h.",
					"leavesAt": "09:12",
					"arrivesAt": "09:16",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Băleni h.",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "09:17",
					"arrivesAt": "09:22",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Târgu Bujor",
					"leavesAt": "09:23",
					"arrivesAt": "09:26",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgu Bujor",
					"to": "Moscu hc.",
					"leavesAt": "09:27",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moscu hc.",
					"to": "Roşcani h.",
					"leavesAt": "09:33",
					"arrivesAt": "09:39",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Roşcani h.",
					"to": "Balinteşti h.",
					"leavesAt": "09:40",
					"arrivesAt": "09:48",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Balinteşti h.",
					"to": "Bereşti Hm.",
					"leavesAt": "09:49",
					"arrivesAt": "09:58",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Bereşti Hm.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "09:59",
					"arrivesAt": "10:03",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Tălăşmani h.",
					"leavesAt": "10:04",
					"arrivesAt": "10:12",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Tălăşmani h.",
					"to": "Docăneasa hc.",
					"leavesAt": "10:13",
					"arrivesAt": "10:19",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Docăneasa hc.",
					"to": "Lungeşti h.",
					"leavesAt": "10:20",
					"arrivesAt": "10:23",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lungeşti h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "10:24",
					"arrivesAt": "10:30",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Griviţa h.",
					"leavesAt": "10:31",
					"arrivesAt": "10:35",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Griviţa h.",
					"to": "Bârlad",
					"leavesAt": "10:36",
					"arrivesAt": "10:44",
					"waitsAtSource": 30,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15146",
			"segments": [
				{
					"from": "Măneciu",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "06:05",
					"arrivesAt": "06:09",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Izvoarele hc.",
					"leavesAt": "06:10",
					"arrivesAt": "06:12",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Homorâciu P.M.",
					"leavesAt": "06:13",
					"arrivesAt": "06:19",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Teişani Hm.",
					"leavesAt": "06:20",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Teişani Hm.",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "06:25",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Vălenii de Munte",
					"leavesAt": "06:30",
					"arrivesAt": "06:34",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălenii de Munte",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Făget Teleajen",
					"leavesAt": "06:39",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Făget Teleajen",
					"to": "Măgurele Nord h.",
					"leavesAt": "06:52",
					"arrivesAt": "06:54",
					"waitsAtSource": 540,
					"distance": 1700
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "06:55",
					"arrivesAt": "06:59",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Sud h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:02",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Lipăneşti hc.",
					"leavesAt": "07:03",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Boldeşti hc.",
					"leavesAt": "07:07",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Boldeşti hc.",
					"to": "Scăieni h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:13",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Scăieni h.",
					"to": "Blejoi",
					"leavesAt": "07:14",
					"arrivesAt": "07:19",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Blejoi",
					"to": "Ploieşti Nord",
					"leavesAt": "07:21",
					"arrivesAt": "07:26",
					"waitsAtSource": 120,
					"distance": 3900
				},
				{
					"from": "Ploieşti Nord",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "07:28",
					"arrivesAt": "07:32",
					"waitsAtSource": 120,
					"distance": 3000
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Sud",
					"leavesAt": "07:33",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15251",
			"segments": [
				{
					"from": "Balaci Hm.",
					"to": "Surduleşti h.",
					"leavesAt": "04:38",
					"arrivesAt": "04:43",
					"waitsAtSource": 0,
					"distance": 4100
				},
				{
					"from": "Surduleşti h.",
					"to": "Miroşi",
					"leavesAt": "04:44",
					"arrivesAt": "04:50",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Miroşi",
					"to": "Colţ h.",
					"leavesAt": "04:51",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Colţ h.",
					"to": "Costeşti",
					"leavesAt": "05:01",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 19300
				}
			],
			"restrictions": [
				{
					"from": "20170701",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15108",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "13:50",
					"arrivesAt": "13:53",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "13:54",
					"arrivesAt": "13:57",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Târgovişte Nord",
					"leavesAt": "13:58",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Târgovişte Nord",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "14:02",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Răzvad hc.",
					"leavesAt": "14:08",
					"arrivesAt": "14:11",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Răzvad hc.",
					"to": "Adânca PM.",
					"leavesAt": "14:12",
					"arrivesAt": "14:20",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Adânca PM.",
					"to": "Mija",
					"leavesAt": "14:21",
					"arrivesAt": "14:31",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Mija",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "14:32",
					"arrivesAt": "14:36",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "I. L. Caragiale",
					"leavesAt": "14:37",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "14:52",
					"arrivesAt": "14:58",
					"waitsAtSource": 600,
					"distance": 5000
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "Brătăşanca h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Brătăşanca h.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "15:05",
					"arrivesAt": "15:11",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "15:12",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "15:16",
					"arrivesAt": "15:21",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Ploieşti Vest",
					"leavesAt": "15:22",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "15:33",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15187",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "18:14",
					"arrivesAt": "18:22",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "18:30",
					"arrivesAt": "18:34",
					"waitsAtSource": 480,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "18:41",
					"arrivesAt": "18:44",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "18:45",
					"arrivesAt": "18:49",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "18:50",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "18:53",
					"arrivesAt": "18:56",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "18:57",
					"arrivesAt": "19:00",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "19:01",
					"arrivesAt": "19:05",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "19:06",
					"arrivesAt": "19:12",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "19:20",
					"arrivesAt": "19:24",
					"waitsAtSource": 480,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "19:25",
					"arrivesAt": "19:26",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:31",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "19:32",
					"arrivesAt": "19:35",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "19:36",
					"arrivesAt": "19:41",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "19:42",
					"arrivesAt": "19:54",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15258",
			"segments": [
				{
					"from": "Costeşti",
					"to": "Colţ h.",
					"leavesAt": "14:30",
					"arrivesAt": "15:01",
					"waitsAtSource": 0,
					"distance": 19300
				},
				{
					"from": "Colţ h.",
					"to": "Miroşi",
					"leavesAt": "15:02",
					"arrivesAt": "15:12",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Miroşi",
					"to": "Surduleşti h.",
					"leavesAt": "15:22",
					"arrivesAt": "15:27",
					"waitsAtSource": 600,
					"distance": 4700
				},
				{
					"from": "Surduleşti h.",
					"to": "Balaci Hm.",
					"leavesAt": "15:28",
					"arrivesAt": "15:33",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Balaci Hm.",
					"to": "Zâmbreasca h.",
					"leavesAt": "15:34",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Beuca h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Beuca h.",
					"to": "Beuca Sat h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:49",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca Sat h.",
					"to": "Drăcşenei h.",
					"leavesAt": "15:50",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Drăcşenei h.",
					"to": "Roşiori Nord",
					"leavesAt": "15:54",
					"arrivesAt": "16:12",
					"waitsAtSource": 30,
					"distance": 13500
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15265",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Drăcşenei h.",
					"leavesAt": "20:20",
					"arrivesAt": "20:38",
					"waitsAtSource": 0,
					"distance": 13500
				},
				{
					"from": "Drăcşenei h.",
					"to": "Beuca Sat h.",
					"leavesAt": "20:39",
					"arrivesAt": "20:42",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Beuca Sat h.",
					"to": "Beuca h.",
					"leavesAt": "20:43",
					"arrivesAt": "20:46",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca h.",
					"to": "Zâmbreasca h.",
					"leavesAt": "20:47",
					"arrivesAt": "20:51",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Balaci Hm.",
					"leavesAt": "20:52",
					"arrivesAt": "20:59",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Balaci Hm.",
					"to": "Surduleşti h.",
					"leavesAt": "21:00",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Surduleşti h.",
					"to": "Miroşi",
					"leavesAt": "21:06",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 4700
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15103",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "05:50",
					"arrivesAt": "05:55",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "05:56",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "06:06",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Brătăşanca h.",
					"leavesAt": "06:16",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Brătăşanca h.",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "06:21",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "I. L. Caragiale",
					"leavesAt": "06:26",
					"arrivesAt": "06:34",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "I. L. Caragiale",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "Mija",
					"leavesAt": "06:39",
					"arrivesAt": "06:44",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mija",
					"to": "Adânca PM.",
					"leavesAt": "06:45",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Adânca PM.",
					"to": "Răzvad hc.",
					"leavesAt": "06:54",
					"arrivesAt": "07:02",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Răzvad hc.",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "07:03",
					"arrivesAt": "07:07",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Târgovişte Nord",
					"leavesAt": "07:08",
					"arrivesAt": "07:15",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgovişte Nord",
					"to": "TEIŞ Hm.",
					"leavesAt": "07:16",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "07:20",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "07:23",
					"arrivesAt": "07:27",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15358",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "12:27",
					"arrivesAt": "12:31",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "12:32",
					"arrivesAt": "12:36",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "12:37",
					"arrivesAt": "12:40",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:47",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "12:48",
					"arrivesAt": "12:53",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "13:02",
					"arrivesAt": "13:08",
					"waitsAtSource": 540,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "13:09",
					"arrivesAt": "13:12",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "13:13",
					"arrivesAt": "13:16",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "13:17",
					"arrivesAt": "13:20",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "13:21",
					"arrivesAt": "13:30",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "13:31",
					"arrivesAt": "13:36",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "13:37",
					"arrivesAt": "13:41",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "13:42",
					"arrivesAt": "13:48",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "13:49",
					"arrivesAt": "13:54",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "13:55",
					"arrivesAt": "14:00",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "14:01",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "14:06",
					"arrivesAt": "14:10",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "14:11",
					"arrivesAt": "14:16",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "14:17",
					"arrivesAt": "14:23",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "14:24",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "14:31",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15181",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "14:03",
					"arrivesAt": "14:11",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "14:12",
					"arrivesAt": "14:15",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "14:16",
					"arrivesAt": "14:21",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "14:22",
					"arrivesAt": "14:25",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "14:26",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "14:31",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:37",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "14:38",
					"arrivesAt": "14:42",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "14:43",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "14:48",
					"arrivesAt": "14:54",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "14:55",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:05",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "15:06",
					"arrivesAt": "15:10",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "15:11",
					"arrivesAt": "15:16",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "15:17",
					"arrivesAt": "15:29",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15155",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "20:44",
					"arrivesAt": "20:48",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Nord",
					"leavesAt": "20:49",
					"arrivesAt": "20:54",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploieşti Nord",
					"to": "Blejoi",
					"leavesAt": "20:55",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Blejoi",
					"to": "Scăieni h.",
					"leavesAt": "21:01",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Scăieni h.",
					"to": "Boldeşti hc.",
					"leavesAt": "21:06",
					"arrivesAt": "21:08",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Boldeşti hc.",
					"to": "Lipăneşti hc.",
					"leavesAt": "21:09",
					"arrivesAt": "21:13",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Măgurele Sud h.",
					"leavesAt": "21:14",
					"arrivesAt": "21:17",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Nord h.",
					"leavesAt": "21:23",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Făget Teleajen",
					"leavesAt": "21:28",
					"arrivesAt": "21:31",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Făget Teleajen",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "21:32",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Vălenii de Munte",
					"leavesAt": "21:37",
					"arrivesAt": "21:41",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vălenii de Munte",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "21:42",
					"arrivesAt": "21:47",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Teişani Hm.",
					"leavesAt": "21:48",
					"arrivesAt": "21:54",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Teişani Hm.",
					"to": "Homorâciu P.M.",
					"leavesAt": "21:55",
					"arrivesAt": "22:01",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Izvoarele hc.",
					"leavesAt": "22:02",
					"arrivesAt": "22:07",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "22:08",
					"arrivesAt": "22:11",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Măneciu",
					"leavesAt": "22:12",
					"arrivesAt": "22:17",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15094",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "15:50",
					"arrivesAt": "15:56",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "16:03",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "16:12",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "16:23",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Titu",
					"to": "Ghergani Hm.",
					"leavesAt": "16:31",
					"arrivesAt": "16:41",
					"waitsAtSource": 180,
					"distance": 12100
				},
				{
					"from": "Ghergani Hm.",
					"to": "Chitila",
					"leavesAt": "16:42",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 26500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Nord",
					"leavesAt": "17:05",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 9400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15124",
			"segments": [
				{
					"from": "Slănic",
					"to": "Prăjani h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:22",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Prăjani h.",
					"to": "Vărbilău hc.",
					"leavesAt": "06:23",
					"arrivesAt": "06:27",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărbilău hc.",
					"to": "Vlădeşti h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vlădeşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:36",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Mălăeşti h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:46",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mălăeşti h.",
					"to": "Găvănel hc.",
					"leavesAt": "06:47",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Găvănel hc.",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "06:51",
					"arrivesAt": "06:56",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Plopeni",
					"leavesAt": "06:57",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plopeni",
					"to": "Găgeni hc.",
					"leavesAt": "07:02",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Găgeni hc.",
					"to": "Buda",
					"leavesAt": "07:07",
					"arrivesAt": "07:16",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "07:17",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "07:26",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15175",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "08:57",
					"arrivesAt": "09:05",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "09:13",
					"arrivesAt": "09:17",
					"waitsAtSource": 480,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "09:18",
					"arrivesAt": "09:23",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:27",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "09:28",
					"arrivesAt": "09:32",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "09:33",
					"arrivesAt": "09:35",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "09:36",
					"arrivesAt": "09:39",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "09:40",
					"arrivesAt": "09:43",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "09:44",
					"arrivesAt": "09:48",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "09:49",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "09:56",
					"arrivesAt": "10:00",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "10:01",
					"arrivesAt": "10:02",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "10:03",
					"arrivesAt": "10:07",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "10:08",
					"arrivesAt": "10:11",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "10:12",
					"arrivesAt": "10:17",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "10:18",
					"arrivesAt": "10:30",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15260",
			"segments": [
				{
					"from": "Costeşti",
					"to": "Colţ h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:51",
					"waitsAtSource": 0,
					"distance": 19300
				},
				{
					"from": "Colţ h.",
					"to": "Miroşi",
					"leavesAt": "16:52",
					"arrivesAt": "17:01",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Miroşi",
					"to": "Surduleşti h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Surduleşti h.",
					"to": "Balaci Hm.",
					"leavesAt": "17:08",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Balaci Hm.",
					"to": "Zâmbreasca h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:29",
					"waitsAtSource": 600,
					"distance": 5900
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Beuca h.",
					"leavesAt": "17:30",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Beuca h.",
					"to": "Beuca Sat h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:38",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca Sat h.",
					"to": "Drăcşenei h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Drăcşenei h.",
					"to": "Roşiori Nord",
					"leavesAt": "17:43",
					"arrivesAt": "18:01",
					"waitsAtSource": 30,
					"distance": 13500
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181210",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15322",
			"segments": [
				{
					"from": "Târgu Bujor",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "03:38",
					"arrivesAt": "03:41",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Băleni h.",
					"leavesAt": "03:42",
					"arrivesAt": "03:47",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Băleni h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "03:48",
					"arrivesAt": "03:52",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Chiraftei h.",
					"leavesAt": "03:53",
					"arrivesAt": "03:57",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Chiraftei h.",
					"to": "Folteşti Hm.",
					"leavesAt": "03:58",
					"arrivesAt": "04:05",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Folteşti Hm.",
					"to": "Stoicani h.",
					"leavesAt": "04:06",
					"arrivesAt": "04:12",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Stoicani h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "04:13",
					"arrivesAt": "04:19",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Şiviţa h.",
					"leavesAt": "04:20",
					"arrivesAt": "04:26",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Tuluceşti Hm.",
					"leavesAt": "04:27",
					"arrivesAt": "04:33",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Galaţi",
					"leavesAt": "04:34",
					"arrivesAt": "04:58",
					"waitsAtSource": 60,
					"distance": 13600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15301",
			"segments": [
				{
					"from": "Târgu Bujor",
					"to": "Bereşti Hm.",
					"leavesAt": "01:46",
					"arrivesAt": "02:11",
					"waitsAtSource": 0,
					"distance": 24900
				},
				{
					"from": "Bereşti Hm.",
					"to": "Bârlad",
					"leavesAt": "02:16",
					"arrivesAt": "02:56",
					"waitsAtSource": 300,
					"distance": 31100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15126",
			"segments": [
				{
					"from": "Slănic",
					"to": "Prăjani h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:04",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Prăjani h.",
					"to": "Vărbilău hc.",
					"leavesAt": "08:05",
					"arrivesAt": "08:09",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărbilău hc.",
					"to": "Vlădeşti h.",
					"leavesAt": "08:10",
					"arrivesAt": "08:13",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vlădeşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:18",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Mălăeşti h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mălăeşti h.",
					"to": "Găvănel hc.",
					"leavesAt": "08:29",
					"arrivesAt": "08:32",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Găvănel hc.",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "08:33",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Plopeni",
					"leavesAt": "08:39",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plopeni",
					"to": "Găgeni hc.",
					"leavesAt": "08:44",
					"arrivesAt": "08:48",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Găgeni hc.",
					"to": "Buda",
					"leavesAt": "08:49",
					"arrivesAt": "08:58",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "08:59",
					"arrivesAt": "09:06",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "09:07",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15182",
			"segments": [
				{
					"from": "Olteniţa",
					"to": "Valea Roşie hc.",
					"leavesAt": "12:24",
					"arrivesAt": "12:36",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Curcani h.",
					"leavesAt": "12:37",
					"arrivesAt": "12:41",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Curcani h.",
					"to": "Luica h.",
					"leavesAt": "12:42",
					"arrivesAt": "12:46",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Luica h.",
					"to": "Şoldanu h.",
					"leavesAt": "12:47",
					"arrivesAt": "12:52",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şoldanu h.",
					"to": "Negoieşti h.",
					"leavesAt": "12:53",
					"arrivesAt": "12:55",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Negoieşti h.",
					"to": "Budeşti Hm.",
					"leavesAt": "12:56",
					"arrivesAt": "13:01",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Budeşti Hm.",
					"to": "Vasilaţi hc.",
					"leavesAt": "13:02",
					"arrivesAt": "13:07",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "13:08",
					"arrivesAt": "13:12",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "13:13",
					"arrivesAt": "13:16",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "13:17",
					"arrivesAt": "13:19",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "13:20",
					"arrivesAt": "13:23",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plătăreşti hc.",
					"to": "Frunzăneşti h.",
					"leavesAt": "13:24",
					"arrivesAt": "13:27",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Tânganu h.",
					"leavesAt": "13:28",
					"arrivesAt": "13:31",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Tânganu h.",
					"to": "Căldăraru h.",
					"leavesAt": "13:32",
					"arrivesAt": "13:37",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Căldăraru h.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "13:38",
					"arrivesAt": "13:43",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Titan Sud Hm.",
					"leavesAt": "13:44",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15127",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "11:32",
					"arrivesAt": "11:37",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "11:38",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Găgeni hc.",
					"leavesAt": "11:47",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Găgeni hc.",
					"to": "Plopeni",
					"leavesAt": "11:56",
					"arrivesAt": "12:00",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "12:01",
					"arrivesAt": "12:05",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Găvănel hc.",
					"leavesAt": "12:06",
					"arrivesAt": "12:10",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Găvănel hc.",
					"to": "Mălăeşti h.",
					"leavesAt": "12:11",
					"arrivesAt": "12:14",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mălăeşti h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "12:15",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:25",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Vlădeşti h.",
					"leavesAt": "12:26",
					"arrivesAt": "12:29",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Vlădeşti h.",
					"to": "Vărbilău hc.",
					"leavesAt": "12:30",
					"arrivesAt": "12:33",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vărbilău hc.",
					"to": "Prăjani h.",
					"leavesAt": "12:34",
					"arrivesAt": "12:38",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Prăjani h.",
					"to": "Slănic",
					"leavesAt": "12:39",
					"arrivesAt": "12:44",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180615",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15143",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "08:04",
					"arrivesAt": "08:08",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Nord",
					"leavesAt": "08:09",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploieşti Nord",
					"to": "Blejoi",
					"leavesAt": "08:15",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Blejoi",
					"to": "Scăieni h.",
					"leavesAt": "08:21",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Scăieni h.",
					"to": "Boldeşti hc.",
					"leavesAt": "08:26",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Boldeşti hc.",
					"to": "Lipăneşti hc.",
					"leavesAt": "08:29",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Măgurele Sud h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:37",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:42",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Nord h.",
					"leavesAt": "08:43",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Făget Teleajen",
					"leavesAt": "08:48",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Făget Teleajen",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "08:52",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Vălenii de Munte",
					"leavesAt": "08:57",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vălenii de Munte",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "09:02",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Teişani Hm.",
					"leavesAt": "09:08",
					"arrivesAt": "09:14",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Teişani Hm.",
					"to": "Homorâciu P.M.",
					"leavesAt": "09:15",
					"arrivesAt": "09:21",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Izvoarele hc.",
					"leavesAt": "09:22",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "09:28",
					"arrivesAt": "09:31",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Măneciu",
					"leavesAt": "09:32",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15144",
			"segments": [
				{
					"from": "Măneciu",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "05:03",
					"arrivesAt": "05:07",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Izvoarele hc.",
					"leavesAt": "05:08",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Homorâciu P.M.",
					"leavesAt": "05:11",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Teişani Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Teişani Hm.",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "05:23",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Vălenii de Munte",
					"leavesAt": "05:28",
					"arrivesAt": "05:32",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălenii de Munte",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Făget Teleajen",
					"leavesAt": "05:37",
					"arrivesAt": "05:41",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Făget Teleajen",
					"to": "Măgurele Nord h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:49",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Sud h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:52",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Lipăneşti hc.",
					"leavesAt": "05:53",
					"arrivesAt": "05:56",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Boldeşti hc.",
					"leavesAt": "05:57",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Boldeşti hc.",
					"to": "Scăieni h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Scăieni h.",
					"to": "Blejoi",
					"leavesAt": "06:04",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Blejoi",
					"to": "Ploieşti Nord",
					"leavesAt": "06:18",
					"arrivesAt": "06:23",
					"waitsAtSource": 540,
					"distance": 3900
				},
				{
					"from": "Ploieşti Nord",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "06:24",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Sud",
					"leavesAt": "06:29",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20180618",
					"to": "20180622",
					"daysOfWeek": 480
				},
				{
					"from": "20180625",
					"to": "20180629",
					"daysOfWeek": 480
				},
				{
					"from": "20180702",
					"to": "20180706",
					"daysOfWeek": 480
				},
				{
					"from": "20180709",
					"to": "20180713",
					"daysOfWeek": 480
				},
				{
					"from": "20180716",
					"to": "20180720",
					"daysOfWeek": 480
				},
				{
					"from": "20180723",
					"to": "20180727",
					"daysOfWeek": 480
				},
				{
					"from": "20180730",
					"to": "20180803",
					"daysOfWeek": 480
				},
				{
					"from": "20180806",
					"to": "20180810",
					"daysOfWeek": 480
				},
				{
					"from": "20180813",
					"to": "20180817",
					"daysOfWeek": 480
				},
				{
					"from": "20180820",
					"to": "20180824",
					"daysOfWeek": 480
				},
				{
					"from": "20180827",
					"to": "20180831",
					"daysOfWeek": 480
				},
				{
					"from": "20180903",
					"to": "20180907",
					"daysOfWeek": 480
				},
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 480
				},
				{
					"from": "20171210",
					"to": "20180615",
					"daysOfWeek": 480
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15142",
			"segments": [
				{
					"from": "Măneciu",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "05:03",
					"arrivesAt": "05:07",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Izvoarele hc.",
					"leavesAt": "05:08",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Homorâciu P.M.",
					"leavesAt": "05:11",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Teişani Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Teişani Hm.",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "05:23",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Vălenii de Munte",
					"leavesAt": "05:28",
					"arrivesAt": "05:32",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălenii de Munte",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Făget Teleajen",
					"leavesAt": "05:37",
					"arrivesAt": "05:41",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Făget Teleajen",
					"to": "Măgurele Nord h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:49",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Sud h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:52",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Lipăneşti hc.",
					"leavesAt": "05:53",
					"arrivesAt": "05:56",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Boldeşti hc.",
					"leavesAt": "05:57",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Boldeşti hc.",
					"to": "Scăieni h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Scăieni h.",
					"to": "Blejoi",
					"leavesAt": "06:04",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Blejoi",
					"to": "Ploieşti Nord",
					"leavesAt": "06:18",
					"arrivesAt": "06:23",
					"waitsAtSource": 540,
					"distance": 3900
				},
				{
					"from": "Ploieşti Nord",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "06:24",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Sud",
					"leavesAt": "06:29",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "06:55",
					"arrivesAt": "07:00",
					"waitsAtSource": 1140,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Brazi",
					"leavesAt": "07:05",
					"arrivesAt": "07:12",
					"waitsAtSource": 300,
					"distance": 7500
				},
				{
					"from": "Brazi",
					"to": "Crivina",
					"leavesAt": "07:13",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "07:23",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "07:28",
					"arrivesAt": "07:33",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Bucureşti Nord",
					"leavesAt": "07:34",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 30200
				}
			],
			"restrictions": [
				{
					"from": "20180101",
					"to": "20180105",
					"daysOfWeek": 383
				},
				{
					"from": "20180108",
					"to": "20180112",
					"daysOfWeek": 383
				},
				{
					"from": "20180115",
					"to": "20180119",
					"daysOfWeek": 383
				},
				{
					"from": "20180122",
					"to": "20180126",
					"daysOfWeek": 383
				},
				{
					"from": "20180129",
					"to": "20180202",
					"daysOfWeek": 383
				},
				{
					"from": "20180205",
					"to": "20180209",
					"daysOfWeek": 383
				},
				{
					"from": "20180212",
					"to": "20180216",
					"daysOfWeek": 383
				},
				{
					"from": "20180219",
					"to": "20180223",
					"daysOfWeek": 383
				},
				{
					"from": "20180226",
					"to": "20180302",
					"daysOfWeek": 383
				},
				{
					"from": "20180305",
					"to": "20180309",
					"daysOfWeek": 383
				},
				{
					"from": "20180312",
					"to": "20180316",
					"daysOfWeek": 383
				},
				{
					"from": "20180319",
					"to": "20180323",
					"daysOfWeek": 383
				},
				{
					"from": "20180326",
					"to": "20180330",
					"daysOfWeek": 383
				},
				{
					"from": "20180402",
					"to": "20180406",
					"daysOfWeek": 383
				},
				{
					"from": "20180409",
					"to": "20180413",
					"daysOfWeek": 383
				},
				{
					"from": "20180416",
					"to": "20180420",
					"daysOfWeek": 383
				},
				{
					"from": "20180423",
					"to": "20180427",
					"daysOfWeek": 383
				},
				{
					"from": "20180430",
					"to": "20180504",
					"daysOfWeek": 383
				},
				{
					"from": "20180507",
					"to": "20180511",
					"daysOfWeek": 383
				},
				{
					"from": "20180514",
					"to": "20180518",
					"daysOfWeek": 383
				},
				{
					"from": "20180521",
					"to": "20180525",
					"daysOfWeek": 383
				},
				{
					"from": "20180528",
					"to": "20180601",
					"daysOfWeek": 383
				},
				{
					"from": "20180604",
					"to": "20180608",
					"daysOfWeek": 383
				},
				{
					"from": "20180611",
					"to": "20180914",
					"daysOfWeek": 383
				},
				{
					"from": "20180917",
					"to": "20180921",
					"daysOfWeek": 383
				},
				{
					"from": "20180924",
					"to": "20180928",
					"daysOfWeek": 383
				},
				{
					"from": "20181001",
					"to": "20181005",
					"daysOfWeek": 383
				},
				{
					"from": "20181008",
					"to": "20181012",
					"daysOfWeek": 383
				},
				{
					"from": "20181015",
					"to": "20181019",
					"daysOfWeek": 383
				},
				{
					"from": "20181022",
					"to": "20181026",
					"daysOfWeek": 383
				},
				{
					"from": "20181029",
					"to": "20181102",
					"daysOfWeek": 383
				},
				{
					"from": "20181105",
					"to": "20181109",
					"daysOfWeek": 383
				},
				{
					"from": "20181112",
					"to": "20181116",
					"daysOfWeek": 383
				},
				{
					"from": "20181119",
					"to": "20181123",
					"daysOfWeek": 383
				},
				{
					"from": "20181126",
					"to": "20181130",
					"daysOfWeek": 383
				},
				{
					"from": "20181203",
					"to": "20181207",
					"daysOfWeek": 383
				},
				{
					"from": "20171211",
					"to": "20171215",
					"daysOfWeek": 383
				},
				{
					"from": "20171218",
					"to": "20171222",
					"daysOfWeek": 383
				},
				{
					"from": "20171225",
					"to": "20171229",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15110",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:23",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Târgovişte Nord",
					"leavesAt": "16:28",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Târgovişte Nord",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "16:32",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Răzvad hc.",
					"leavesAt": "16:38",
					"arrivesAt": "16:41",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Răzvad hc.",
					"to": "Adânca PM.",
					"leavesAt": "16:42",
					"arrivesAt": "16:50",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Adânca PM.",
					"to": "Mija",
					"leavesAt": "16:51",
					"arrivesAt": "17:01",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Mija",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "I. L. Caragiale",
					"leavesAt": "17:07",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "17:13",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "Brătăşanca h.",
					"leavesAt": "17:20",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Brătăşanca h.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "17:25",
					"arrivesAt": "17:31",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "17:32",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "17:36",
					"arrivesAt": "17:41",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Ploieşti Vest",
					"leavesAt": "17:42",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "17:55",
					"arrivesAt": "18:01",
					"waitsAtSource": 180,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15176",
			"segments": [
				{
					"from": "Olteniţa",
					"to": "Valea Roşie hc.",
					"leavesAt": "07:44",
					"arrivesAt": "07:56",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Curcani h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Curcani h.",
					"to": "Luica h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:06",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Luica h.",
					"to": "Şoldanu h.",
					"leavesAt": "08:07",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şoldanu h.",
					"to": "Negoieşti h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:14",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Negoieşti h.",
					"to": "Budeşti Hm.",
					"leavesAt": "08:15",
					"arrivesAt": "08:20",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Budeşti Hm.",
					"to": "Vasilaţi hc.",
					"leavesAt": "08:28",
					"arrivesAt": "08:33",
					"waitsAtSource": 480,
					"distance": 5500
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "08:34",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "08:43",
					"arrivesAt": "08:45",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "08:46",
					"arrivesAt": "08:49",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plătăreşti hc.",
					"to": "Frunzăneşti h.",
					"leavesAt": "08:50",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Tânganu h.",
					"leavesAt": "08:55",
					"arrivesAt": "08:57",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Tânganu h.",
					"to": "Căldăraru h.",
					"leavesAt": "08:58",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Căldăraru h.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "09:04",
					"arrivesAt": "09:09",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Titan Sud Hm.",
					"leavesAt": "09:10",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15122",
			"segments": [
				{
					"from": "Slănic",
					"to": "Prăjani h.",
					"leavesAt": "05:15",
					"arrivesAt": "05:19",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Prăjani h.",
					"to": "Vărbilău hc.",
					"leavesAt": "05:20",
					"arrivesAt": "05:24",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărbilău hc.",
					"to": "Vlădeşti h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vlădeşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "05:29",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Mălăeşti h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:43",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mălăeşti h.",
					"to": "Găvănel hc.",
					"leavesAt": "05:44",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Găvănel hc.",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Plopeni",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plopeni",
					"to": "Găgeni hc.",
					"leavesAt": "05:59",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Găgeni hc.",
					"to": "Buda",
					"leavesAt": "06:04",
					"arrivesAt": "06:14",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "06:15",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15037",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Rădaia h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:31",
					"waitsAtSource": 0,
					"distance": 10600
				},
				{
					"from": "Rădaia h.",
					"to": "Gârbău Hm.",
					"leavesAt": "16:32",
					"arrivesAt": "16:41",
					"waitsAtSource": 30,
					"distance": 9600
				},
				{
					"from": "Gârbău Hm.",
					"to": "Dorolţu h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Dorolţu h.",
					"to": "Aghireş",
					"leavesAt": "16:49",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "16:53",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Huedin",
					"leavesAt": "16:57",
					"arrivesAt": "17:18",
					"waitsAtSource": 30,
					"distance": 18900
				},
				{
					"from": "Huedin",
					"to": "Brăişoru Hm.",
					"leavesAt": "17:19",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Bologa h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bologa h.",
					"to": "Poieni",
					"leavesAt": "17:33",
					"arrivesAt": "17:38",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Poieni",
					"to": "Valea Drăganului h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Drăganului h.",
					"to": "Ciucea Hm.",
					"leavesAt": "17:44",
					"arrivesAt": "17:51",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Ciucea Hm.",
					"to": "Negreni h.",
					"leavesAt": "17:52",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Lacu Crişului h.",
					"leavesAt": "17:57",
					"arrivesAt": "18:01",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "18:02",
					"arrivesAt": "18:07",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bulz Hm.",
					"leavesAt": "18:08",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bulz Hm.",
					"to": "Stâna de Vale h.",
					"leavesAt": "18:18",
					"arrivesAt": "18:20",
					"waitsAtSource": 300,
					"distance": 1800
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bratca",
					"leavesAt": "18:21",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bratca",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "18:36",
					"arrivesAt": "18:43",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Aleşd",
					"leavesAt": "18:44",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Aleşd",
					"to": "Oşorhei Hm.",
					"leavesAt": "18:57",
					"arrivesAt": "19:17",
					"waitsAtSource": 120,
					"distance": 24800
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Oradea",
					"leavesAt": "19:18",
					"arrivesAt": "19:28",
					"waitsAtSource": 60,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15115",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "20:26",
					"arrivesAt": "20:31",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "20:33",
					"arrivesAt": "20:42",
					"waitsAtSource": 120,
					"distance": 6300
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "20:48",
					"arrivesAt": "20:52",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Brătăşanca h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Brătăşanca h.",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "20:58",
					"arrivesAt": "21:02",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "I. L. Caragiale",
					"leavesAt": "21:03",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "I. L. Caragiale",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "21:21",
					"arrivesAt": "21:24",
					"waitsAtSource": 540,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "Mija",
					"leavesAt": "21:25",
					"arrivesAt": "21:30",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mija",
					"to": "Adânca PM.",
					"leavesAt": "21:31",
					"arrivesAt": "21:39",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Adânca PM.",
					"to": "Răzvad hc.",
					"leavesAt": "21:40",
					"arrivesAt": "21:49",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Răzvad hc.",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "21:50",
					"arrivesAt": "21:54",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Târgovişte Nord",
					"leavesAt": "21:55",
					"arrivesAt": "22:01",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Târgovişte Nord",
					"to": "TEIŞ Hm.",
					"leavesAt": "22:03",
					"arrivesAt": "22:06",
					"waitsAtSource": 120,
					"distance": 1700
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "22:07",
					"arrivesAt": "22:09",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "22:10",
					"arrivesAt": "22:14",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15121",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "06:20",
					"arrivesAt": "06:25",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "06:26",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Găgeni hc.",
					"leavesAt": "06:35",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Găgeni hc.",
					"to": "Plopeni",
					"leavesAt": "06:44",
					"arrivesAt": "06:48",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "06:49",
					"arrivesAt": "06:53",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Găvănel hc.",
					"leavesAt": "07:01",
					"arrivesAt": "07:05",
					"waitsAtSource": 480,
					"distance": 2700
				},
				{
					"from": "Găvănel hc.",
					"to": "Mălăeşti h.",
					"leavesAt": "07:06",
					"arrivesAt": "07:09",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mălăeşti h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "07:10",
					"arrivesAt": "07:15",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "07:16",
					"arrivesAt": "07:20",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Vlădeşti h.",
					"leavesAt": "07:21",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Vlădeşti h.",
					"to": "Vărbilău hc.",
					"leavesAt": "07:25",
					"arrivesAt": "07:28",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vărbilău hc.",
					"to": "Prăjani h.",
					"leavesAt": "07:29",
					"arrivesAt": "07:33",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Prăjani h.",
					"to": "Slănic",
					"leavesAt": "07:34",
					"arrivesAt": "07:39",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15318",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Griviţa h.",
					"leavesAt": "22:24",
					"arrivesAt": "22:31",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Griviţa h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "22:32",
					"arrivesAt": "22:36",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Lungeşti h.",
					"leavesAt": "22:37",
					"arrivesAt": "22:43",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lungeşti h.",
					"to": "Docăneasa hc.",
					"leavesAt": "22:44",
					"arrivesAt": "22:47",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Docăneasa hc.",
					"to": "Tălăşmani h.",
					"leavesAt": "22:48",
					"arrivesAt": "22:54",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Tălăşmani h.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "22:55",
					"arrivesAt": "23:02",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Bereşti Hm.",
					"leavesAt": "23:03",
					"arrivesAt": "23:07",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Bereşti Hm.",
					"to": "Târgu Bujor",
					"leavesAt": "23:08",
					"arrivesAt": "23:42",
					"waitsAtSource": 60,
					"distance": 24900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15364",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:01",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:06",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:10",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "20:19",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "20:32",
					"arrivesAt": "20:37",
					"waitsAtSource": 480,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:41",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:45",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "20:46",
					"arrivesAt": "20:49",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "20:50",
					"arrivesAt": "20:59",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "21:00",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "21:06",
					"arrivesAt": "21:10",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "21:11",
					"arrivesAt": "21:17",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "21:18",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "21:24",
					"arrivesAt": "21:29",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "21:30",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "21:35",
					"arrivesAt": "21:39",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "21:40",
					"arrivesAt": "21:45",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "21:46",
					"arrivesAt": "21:52",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "21:53",
					"arrivesAt": "21:59",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "22:00",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15188",
			"segments": [
				{
					"from": "Olteniţa",
					"to": "Valea Roşie hc.",
					"leavesAt": "18:40",
					"arrivesAt": "18:52",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Curcani h.",
					"leavesAt": "18:53",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Curcani h.",
					"to": "Luica h.",
					"leavesAt": "18:58",
					"arrivesAt": "19:02",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Luica h.",
					"to": "Şoldanu h.",
					"leavesAt": "19:03",
					"arrivesAt": "19:07",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şoldanu h.",
					"to": "Negoieşti h.",
					"leavesAt": "19:08",
					"arrivesAt": "19:10",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Negoieşti h.",
					"to": "Budeşti Hm.",
					"leavesAt": "19:11",
					"arrivesAt": "19:16",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Budeşti Hm.",
					"to": "Vasilaţi hc.",
					"leavesAt": "19:17",
					"arrivesAt": "19:22",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "19:23",
					"arrivesAt": "19:26",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:30",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:33",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "19:34",
					"arrivesAt": "19:37",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plătăreşti hc.",
					"to": "Frunzăneşti h.",
					"leavesAt": "19:38",
					"arrivesAt": "19:42",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Tânganu h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Tânganu h.",
					"to": "Căldăraru h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:52",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Căldăraru h.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "19:53",
					"arrivesAt": "19:58",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Titan Sud Hm.",
					"leavesAt": "19:59",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15152",
			"segments": [
				{
					"from": "Măneciu",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "14:05",
					"arrivesAt": "14:09",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Izvoarele hc.",
					"leavesAt": "14:10",
					"arrivesAt": "14:12",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Homorâciu P.M.",
					"leavesAt": "14:13",
					"arrivesAt": "14:19",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Teişani Hm.",
					"leavesAt": "14:20",
					"arrivesAt": "14:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Teişani Hm.",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "14:25",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Vălenii de Munte",
					"leavesAt": "14:30",
					"arrivesAt": "14:34",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălenii de Munte",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "14:35",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Făget Teleajen",
					"leavesAt": "14:39",
					"arrivesAt": "14:43",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Făget Teleajen",
					"to": "Măgurele Nord h.",
					"leavesAt": "14:44",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "14:47",
					"arrivesAt": "14:51",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Sud h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:54",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Lipăneşti hc.",
					"leavesAt": "14:55",
					"arrivesAt": "14:58",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Boldeşti hc.",
					"leavesAt": "14:59",
					"arrivesAt": "15:03",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Boldeşti hc.",
					"to": "Scăieni h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:05",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Scăieni h.",
					"to": "Blejoi",
					"leavesAt": "15:06",
					"arrivesAt": "15:11",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Blejoi",
					"to": "Ploieşti Nord",
					"leavesAt": "15:12",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ploieşti Nord",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "15:18",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Sud",
					"leavesAt": "15:23",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15363",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Nord Hm.",
					"leavesAt": "18:54",
					"arrivesAt": "19:04",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Verneşti",
					"leavesAt": "19:05",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Verneşti",
					"to": "Cândeşti hc.",
					"leavesAt": "19:12",
					"arrivesAt": "19:17",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Cândeşti hc.",
					"to": "Berca Hm.",
					"leavesAt": "19:18",
					"arrivesAt": "19:23",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Berca Hm.",
					"to": "Ojasca h.",
					"leavesAt": "19:24",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ojasca h.",
					"to": "Unguriu hc.",
					"leavesAt": "19:28",
					"arrivesAt": "19:32",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Unguriu hc.",
					"to": "Măgura hcv.",
					"leavesAt": "19:33",
					"arrivesAt": "19:37",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Măgura hcv.",
					"to": "Pârscov",
					"leavesAt": "19:38",
					"arrivesAt": "19:42",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pârscov",
					"to": "Bădila h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:49",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bădila h.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "19:50",
					"arrivesAt": "19:54",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Vipereşti hc.",
					"leavesAt": "19:55",
					"arrivesAt": "20:00",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vipereşti hc.",
					"to": "Cislău hcv.",
					"leavesAt": "20:01",
					"arrivesAt": "20:10",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cislău hcv.",
					"to": "Gura Bascii h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Gura Bascii h.",
					"to": "Valea Seacă h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Valea Seacă h.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "20:19",
					"arrivesAt": "20:22",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "20:23",
					"arrivesAt": "20:29",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "20:30",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Şeţu h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:41",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şeţu h.",
					"to": "Păltineni h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:45",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Păltineni h.",
					"to": "Nehoiu h.",
					"leavesAt": "20:46",
					"arrivesAt": "20:50",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Nehoiu h.",
					"to": "Nehoiaşu",
					"leavesAt": "20:51",
					"arrivesAt": "20:55",
					"waitsAtSource": 30,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15154",
			"segments": [
				{
					"from": "Măneciu",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "16:19",
					"arrivesAt": "16:23",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Izvoarele hc.",
					"leavesAt": "16:24",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Homorâciu P.M.",
					"leavesAt": "16:27",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Teişani Hm.",
					"leavesAt": "16:34",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Teişani Hm.",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "16:47",
					"arrivesAt": "16:51",
					"waitsAtSource": 540,
					"distance": 3300
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Vălenii de Munte",
					"leavesAt": "16:52",
					"arrivesAt": "16:56",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălenii de Munte",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Făget Teleajen",
					"leavesAt": "17:01",
					"arrivesAt": "17:05",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Făget Teleajen",
					"to": "Măgurele Nord h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Sud h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Lipăneşti hc.",
					"leavesAt": "17:17",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Boldeşti hc.",
					"leavesAt": "17:21",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Boldeşti hc.",
					"to": "Scăieni h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:27",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Scăieni h.",
					"to": "Blejoi",
					"leavesAt": "17:28",
					"arrivesAt": "17:33",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Blejoi",
					"to": "Ploieşti Nord",
					"leavesAt": "17:34",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ploieşti Nord",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "17:40",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Sud",
					"leavesAt": "17:45",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15313",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Tuluceşti Hm.",
					"leavesAt": "15:00",
					"arrivesAt": "15:25",
					"waitsAtSource": 0,
					"distance": 13600
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Şiviţa h.",
					"leavesAt": "15:33",
					"arrivesAt": "15:39",
					"waitsAtSource": 480,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:46",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Stoicani h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:53",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stoicani h.",
					"to": "Folteşti Hm.",
					"leavesAt": "15:54",
					"arrivesAt": "15:59",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Folteşti Hm.",
					"to": "Chiraftei h.",
					"leavesAt": "16:00",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Chiraftei h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "16:07",
					"arrivesAt": "16:11",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Băleni h.",
					"leavesAt": "16:12",
					"arrivesAt": "16:16",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Băleni h.",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "16:17",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Târgu Bujor",
					"leavesAt": "16:23",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgu Bujor",
					"to": "Moscu hc.",
					"leavesAt": "16:27",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moscu hc.",
					"to": "Roşcani h.",
					"leavesAt": "16:33",
					"arrivesAt": "16:39",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Roşcani h.",
					"to": "Balinteşti h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Balinteşti h.",
					"to": "Bereşti Hm.",
					"leavesAt": "16:49",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15303",
			"segments": [
				{
					"from": "Târgu Bujor",
					"to": "Moscu hc.",
					"leavesAt": "04:31",
					"arrivesAt": "04:35",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Moscu hc.",
					"to": "Roşcani h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:42",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Roşcani h.",
					"to": "Balinteşti h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:50",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Balinteşti h.",
					"to": "Bereşti Hm.",
					"leavesAt": "04:51",
					"arrivesAt": "05:00",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Bereşti Hm.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:09",
					"waitsAtSource": 300,
					"distance": 2400
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Tălăşmani h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Tălăşmani h.",
					"to": "Docăneasa hc.",
					"leavesAt": "05:18",
					"arrivesAt": "05:23",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Docăneasa hc.",
					"to": "Lungeşti h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:27",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lungeşti h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "05:28",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Griviţa h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:38",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Griviţa h.",
					"to": "Bârlad",
					"leavesAt": "05:39",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15104",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:01",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "08:02",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Târgovişte Nord",
					"leavesAt": "08:06",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Târgovişte Nord",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "08:10",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Răzvad hc.",
					"leavesAt": "08:16",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Răzvad hc.",
					"to": "Adânca PM.",
					"leavesAt": "08:20",
					"arrivesAt": "08:28",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Adânca PM.",
					"to": "Mija",
					"leavesAt": "08:29",
					"arrivesAt": "08:39",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Mija",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "08:40",
					"arrivesAt": "08:44",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "I. L. Caragiale",
					"leavesAt": "08:45",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "08:59",
					"arrivesAt": "09:05",
					"waitsAtSource": 540,
					"distance": 5000
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "Brătăşanca h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:10",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Brătăşanca h.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "09:11",
					"arrivesAt": "09:16",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "09:17",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "09:21",
					"arrivesAt": "09:26",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Ploieşti Vest",
					"leavesAt": "09:27",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "09:38",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180301",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15312",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Griviţa h.",
					"leavesAt": "13:20",
					"arrivesAt": "13:27",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Griviţa h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "13:28",
					"arrivesAt": "13:32",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Lungeşti h.",
					"leavesAt": "13:33",
					"arrivesAt": "13:39",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lungeşti h.",
					"to": "Docăneasa hc.",
					"leavesAt": "13:40",
					"arrivesAt": "13:43",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Docăneasa hc.",
					"to": "Tălăşmani h.",
					"leavesAt": "13:44",
					"arrivesAt": "13:50",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Tălăşmani h.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:59",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Bereşti Hm.",
					"leavesAt": "14:00",
					"arrivesAt": "14:04",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "14:05",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "14:14",
					"arrivesAt": "14:22",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "14:23",
					"arrivesAt": "14:29",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "14:30",
					"arrivesAt": "14:35",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Târgu Bujor",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "14:36",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Băleni h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:45",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Băleni h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "14:46",
					"arrivesAt": "14:50",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Chiraftei h.",
					"leavesAt": "14:51",
					"arrivesAt": "14:55",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Chiraftei h.",
					"to": "Folteşti Hm.",
					"leavesAt": "14:56",
					"arrivesAt": "15:02",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Folteşti Hm.",
					"to": "Stoicani h.",
					"leavesAt": "15:03",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Stoicani h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:16",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Şiviţa h.",
					"leavesAt": "15:17",
					"arrivesAt": "15:23",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Tuluceşti Hm.",
					"leavesAt": "15:24",
					"arrivesAt": "15:30",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Galaţi",
					"leavesAt": "15:31",
					"arrivesAt": "15:55",
					"waitsAtSource": 60,
					"distance": 13600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15355",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Nord Hm.",
					"leavesAt": "11:12",
					"arrivesAt": "11:22",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Verneşti",
					"leavesAt": "11:23",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Verneşti",
					"to": "Cândeşti hc.",
					"leavesAt": "11:31",
					"arrivesAt": "11:37",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Cândeşti hc.",
					"to": "Berca Hm.",
					"leavesAt": "11:38",
					"arrivesAt": "11:44",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Berca Hm.",
					"to": "Ojasca h.",
					"leavesAt": "11:45",
					"arrivesAt": "11:48",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ojasca h.",
					"to": "Unguriu hc.",
					"leavesAt": "11:49",
					"arrivesAt": "11:53",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Unguriu hc.",
					"to": "Măgura hcv.",
					"leavesAt": "11:54",
					"arrivesAt": "11:59",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Măgura hcv.",
					"to": "Pârscov",
					"leavesAt": "12:00",
					"arrivesAt": "12:05",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pârscov",
					"to": "Bădila h.",
					"leavesAt": "12:13",
					"arrivesAt": "12:19",
					"waitsAtSource": 480,
					"distance": 4300
				},
				{
					"from": "Bădila h.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "12:20",
					"arrivesAt": "12:24",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Vipereşti hc.",
					"leavesAt": "12:25",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vipereşti hc.",
					"to": "Cislău hcv.",
					"leavesAt": "12:31",
					"arrivesAt": "12:40",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cislău hcv.",
					"to": "Gura Bascii h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:44",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Gura Bascii h.",
					"to": "Valea Seacă h.",
					"leavesAt": "12:45",
					"arrivesAt": "12:48",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Valea Seacă h.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "12:49",
					"arrivesAt": "12:52",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "12:53",
					"arrivesAt": "12:59",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "13:04",
					"arrivesAt": "13:08",
					"waitsAtSource": 300,
					"distance": 3000
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Şeţu h.",
					"leavesAt": "13:09",
					"arrivesAt": "13:15",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şeţu h.",
					"to": "Păltineni h.",
					"leavesAt": "13:16",
					"arrivesAt": "13:19",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Păltineni h.",
					"to": "Nehoiu h.",
					"leavesAt": "13:20",
					"arrivesAt": "13:24",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Nehoiu h.",
					"to": "Nehoiaşu",
					"leavesAt": "13:25",
					"arrivesAt": "13:29",
					"waitsAtSource": 30,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15036",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oşorhei Hm.",
					"leavesAt": "15:16",
					"arrivesAt": "15:27",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Aleşd",
					"leavesAt": "15:28",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 24800
				},
				{
					"from": "Aleşd",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "15:50",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "16:07",
					"arrivesAt": "16:15",
					"waitsAtSource": 300,
					"distance": 6800
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "16:16",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bratca",
					"to": "Stâna de Vale h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 420,
					"distance": 4100
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bulz Hm.",
					"leavesAt": "16:37",
					"arrivesAt": "16:40",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bulz Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "16:46",
					"arrivesAt": "16:51",
					"waitsAtSource": 360,
					"distance": 4000
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Lacu Crişului h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Negreni h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:00",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Ciucea Hm.",
					"leavesAt": "17:01",
					"arrivesAt": "17:05",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ciucea Hm.",
					"to": "Poieni",
					"leavesAt": "17:12",
					"arrivesAt": "17:20",
					"waitsAtSource": 420,
					"distance": 7100
				},
				{
					"from": "Poieni",
					"to": "Brăişoru Hm.",
					"leavesAt": "17:21",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Huedin",
					"leavesAt": "17:29",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Huedin",
					"to": "Stana Hm.",
					"leavesAt": "17:38",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 10600
				},
				{
					"from": "Stana Hm.",
					"to": "Aghireş h.",
					"leavesAt": "17:51",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "18:00",
					"arrivesAt": "18:04",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Gârbău Hm.",
					"leavesAt": "18:05",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Gârbău Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "18:14",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 20200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15302",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Griviţa h.",
					"leavesAt": "03:10",
					"arrivesAt": "03:17",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Griviţa h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "03:18",
					"arrivesAt": "03:22",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Lungeşti h.",
					"leavesAt": "03:23",
					"arrivesAt": "03:29",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lungeşti h.",
					"to": "Docăneasa hc.",
					"leavesAt": "03:30",
					"arrivesAt": "03:33",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Docăneasa hc.",
					"to": "Tălăşmani h.",
					"leavesAt": "03:34",
					"arrivesAt": "03:40",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Tălăşmani h.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "03:41",
					"arrivesAt": "03:49",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Bereşti Hm.",
					"leavesAt": "03:50",
					"arrivesAt": "03:54",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "03:55",
					"arrivesAt": "04:03",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "04:04",
					"arrivesAt": "04:12",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "04:13",
					"arrivesAt": "04:19",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "04:20",
					"arrivesAt": "04:25",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Târgu Bujor",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "04:26",
					"arrivesAt": "04:29",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Băleni h.",
					"leavesAt": "04:30",
					"arrivesAt": "04:35",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Băleni h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:40",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Chiraftei h.",
					"leavesAt": "04:41",
					"arrivesAt": "04:45",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Chiraftei h.",
					"to": "Folteşti Hm.",
					"leavesAt": "04:46",
					"arrivesAt": "04:53",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Folteşti Hm.",
					"to": "Stoicani h.",
					"leavesAt": "04:54",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Stoicani h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "05:01",
					"arrivesAt": "05:07",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Şiviţa h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Tuluceşti Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:21",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Galaţi",
					"leavesAt": "05:22",
					"arrivesAt": "05:46",
					"waitsAtSource": 60,
					"distance": 13600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15128",
			"segments": [
				{
					"from": "Slănic",
					"to": "Prăjani h.",
					"leavesAt": "09:46",
					"arrivesAt": "09:50",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Prăjani h.",
					"to": "Vărbilău hc.",
					"leavesAt": "09:51",
					"arrivesAt": "09:55",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărbilău hc.",
					"to": "Vlădeşti h.",
					"leavesAt": "09:56",
					"arrivesAt": "09:59",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vlădeşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "10:00",
					"arrivesAt": "10:04",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "10:05",
					"arrivesAt": "10:08",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Mălăeşti h.",
					"leavesAt": "10:09",
					"arrivesAt": "10:14",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mălăeşti h.",
					"to": "Găvănel hc.",
					"leavesAt": "10:15",
					"arrivesAt": "10:18",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Găvănel hc.",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "10:19",
					"arrivesAt": "10:24",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Plopeni",
					"leavesAt": "10:25",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plopeni",
					"to": "Găgeni hc.",
					"leavesAt": "10:30",
					"arrivesAt": "10:34",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Găgeni hc.",
					"to": "Buda",
					"leavesAt": "10:35",
					"arrivesAt": "10:44",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "10:45",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "10:54",
					"arrivesAt": "10:59",
					"waitsAtSource": 120,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180616",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15300",
			"segments": [
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "03:07",
					"arrivesAt": "03:15",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "03:16",
					"arrivesAt": "03:24",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "03:25",
					"arrivesAt": "03:31",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "03:32",
					"arrivesAt": "03:37",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Târgu Bujor",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "03:38",
					"arrivesAt": "03:41",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Băleni h.",
					"leavesAt": "03:42",
					"arrivesAt": "03:47",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Băleni h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "03:48",
					"arrivesAt": "03:52",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Chiraftei h.",
					"leavesAt": "03:53",
					"arrivesAt": "03:57",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Chiraftei h.",
					"to": "Folteşti Hm.",
					"leavesAt": "03:58",
					"arrivesAt": "04:05",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Folteşti Hm.",
					"to": "Stoicani h.",
					"leavesAt": "04:06",
					"arrivesAt": "04:12",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Stoicani h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "04:13",
					"arrivesAt": "04:19",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Şiviţa h.",
					"leavesAt": "04:20",
					"arrivesAt": "04:26",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Tuluceşti Hm.",
					"leavesAt": "04:27",
					"arrivesAt": "04:33",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Galaţi",
					"leavesAt": "04:34",
					"arrivesAt": "04:58",
					"waitsAtSource": 60,
					"distance": 13600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15315",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Tuluceşti Hm.",
					"leavesAt": "16:33",
					"arrivesAt": "16:57",
					"waitsAtSource": 0,
					"distance": 13600
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Şiviţa h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Stoicani h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stoicani h.",
					"to": "Folteşti Hm.",
					"leavesAt": "17:18",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Folteşti Hm.",
					"to": "Chiraftei h.",
					"leavesAt": "17:24",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Chiraftei h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Băleni h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Băleni h.",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "17:41",
					"arrivesAt": "17:46",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Târgu Bujor",
					"leavesAt": "17:47",
					"arrivesAt": "17:50",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgu Bujor",
					"to": "Moscu hc.",
					"leavesAt": "17:51",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moscu hc.",
					"to": "Roşcani h.",
					"leavesAt": "17:57",
					"arrivesAt": "18:03",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Roşcani h.",
					"to": "Balinteşti h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:12",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Balinteşti h.",
					"to": "Bereşti Hm.",
					"leavesAt": "18:13",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Bereşti Hm.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "18:23",
					"arrivesAt": "18:27",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Tălăşmani h.",
					"leavesAt": "18:28",
					"arrivesAt": "18:36",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Tălăşmani h.",
					"to": "Docăneasa hc.",
					"leavesAt": "18:37",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Docăneasa hc.",
					"to": "Lungeşti h.",
					"leavesAt": "18:44",
					"arrivesAt": "18:47",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lungeşti h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "18:48",
					"arrivesAt": "18:54",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Griviţa h.",
					"leavesAt": "18:55",
					"arrivesAt": "18:59",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Griviţa h.",
					"to": "Bârlad",
					"leavesAt": "19:00",
					"arrivesAt": "19:08",
					"waitsAtSource": 30,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15057",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "21:50",
					"arrivesAt": "22:33",
					"waitsAtSource": 0,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "22:38",
					"arrivesAt": "22:43",
					"waitsAtSource": 300,
					"distance": 3000
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "22:45",
					"arrivesAt": "23:18",
					"waitsAtSource": 120,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "23:19",
					"arrivesAt": "23:54",
					"waitsAtSource": 60,
					"distance": 35000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15038",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oradea Est",
					"leavesAt": "17:29",
					"arrivesAt": "17:34",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Oradea Est",
					"to": "Oşorhei Hm.",
					"leavesAt": "17:35",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Aleşd",
					"leavesAt": "17:42",
					"arrivesAt": "18:03",
					"waitsAtSource": 60,
					"distance": 24800
				},
				{
					"from": "Aleşd",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "18:10",
					"arrivesAt": "18:22",
					"waitsAtSource": 420,
					"distance": 12200
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "18:23",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "18:35",
					"arrivesAt": "18:43",
					"waitsAtSource": 240,
					"distance": 6300
				},
				{
					"from": "Bratca",
					"to": "Stâna de Vale h.",
					"leavesAt": "18:44",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bulz Hm.",
					"leavesAt": "18:50",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Bulz Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "18:55",
					"arrivesAt": "19:00",
					"waitsAtSource": 120,
					"distance": 4000
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Lacu Crişului h.",
					"leavesAt": "19:01",
					"arrivesAt": "19:05",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Negreni h.",
					"leavesAt": "19:06",
					"arrivesAt": "19:09",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Ciucea Hm.",
					"leavesAt": "19:10",
					"arrivesAt": "19:14",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ciucea Hm.",
					"to": "Poieni",
					"leavesAt": "19:15",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Poieni",
					"to": "Brăişoru Hm.",
					"leavesAt": "19:24",
					"arrivesAt": "19:31",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Huedin",
					"leavesAt": "19:32",
					"arrivesAt": "19:40",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Huedin",
					"to": "Aghireş h.",
					"leavesAt": "19:41",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 18900
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "20:03",
					"arrivesAt": "20:07",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Gârbău Hm.",
					"leavesAt": "20:08",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Gârbău Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "20:17",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 20200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 336
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15193",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "22:45",
					"arrivesAt": "22:53",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "22:54",
					"arrivesAt": "22:57",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "22:58",
					"arrivesAt": "23:03",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "23:04",
					"arrivesAt": "23:06",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "23:07",
					"arrivesAt": "23:11",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "23:12",
					"arrivesAt": "23:14",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "23:15",
					"arrivesAt": "23:18",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "23:19",
					"arrivesAt": "23:22",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "23:23",
					"arrivesAt": "23:27",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "23:28",
					"arrivesAt": "23:34",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "23:35",
					"arrivesAt": "23:39",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "23:40",
					"arrivesAt": "23:41",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "23:42",
					"arrivesAt": "23:46",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "23:47",
					"arrivesAt": "23:50",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "23:51",
					"arrivesAt": "23:56",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "23:57",
					"arrivesAt": "00:09",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15071",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Triaj",
					"leavesAt": "15:20",
					"arrivesAt": "16:05",
					"waitsAtSource": 0,
					"distance": 56600
				},
				{
					"from": "Ploieşti Triaj",
					"to": "Ploieşti Sud",
					"leavesAt": "16:09",
					"arrivesAt": "16:16",
					"waitsAtSource": 240,
					"distance": 3600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "16:17",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "16:51",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Făurei",
					"leavesAt": "17:27",
					"arrivesAt": "18:03",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Făurei",
					"to": "Ianca hc.",
					"leavesAt": "18:04",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Ianca hc.",
					"to": "Brăila",
					"leavesAt": "18:19",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 42400
				},
				{
					"from": "Brăila",
					"to": "Baldovineşti Hm.",
					"leavesAt": "18:53",
					"arrivesAt": "18:59",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Baldovineşti Hm.",
					"to": "Vădeni Hm.",
					"leavesAt": "19:00",
					"arrivesAt": "19:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Vădeni Hm.",
					"to": "Barboşi",
					"leavesAt": "19:06",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 7300
				},
				{
					"from": "Barboşi",
					"to": "Galaţi",
					"leavesAt": "19:16",
					"arrivesAt": "19:35",
					"waitsAtSource": 60,
					"distance": 12000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15320",
			"segments": [
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "21:36",
					"arrivesAt": "21:43",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "21:44",
					"arrivesAt": "21:52",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "21:53",
					"arrivesAt": "22:00",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "22:01",
					"arrivesAt": "22:05",
					"waitsAtSource": 30,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15306",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Griviţa h.",
					"leavesAt": "06:14",
					"arrivesAt": "06:21",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Griviţa h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:26",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Lungeşti h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lungeşti h.",
					"to": "Docăneasa hc.",
					"leavesAt": "06:34",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Docăneasa hc.",
					"to": "Tălăşmani h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:44",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Tălăşmani h.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:53",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Bereşti Hm.",
					"leavesAt": "06:54",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "07:08",
					"arrivesAt": "07:16",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "07:17",
					"arrivesAt": "07:23",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "07:24",
					"arrivesAt": "07:29",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Târgu Bujor",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:39",
					"waitsAtSource": 480,
					"distance": 2100
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Băleni h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:44",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Băleni h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:49",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Chiraftei h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:54",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Chiraftei h.",
					"to": "Folteşti Hm.",
					"leavesAt": "07:55",
					"arrivesAt": "08:02",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Folteşti Hm.",
					"to": "Stoicani h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Stoicani h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "08:10",
					"arrivesAt": "08:16",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Şiviţa h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:23",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Tuluceşti Hm.",
					"leavesAt": "08:24",
					"arrivesAt": "08:30",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Galaţi",
					"leavesAt": "08:31",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 13600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15262",
			"segments": [
				{
					"from": "Costeşti",
					"to": "Colţ h.",
					"leavesAt": "18:35",
					"arrivesAt": "19:06",
					"waitsAtSource": 0,
					"distance": 19300
				},
				{
					"from": "Colţ h.",
					"to": "Miroşi",
					"leavesAt": "19:07",
					"arrivesAt": "19:17",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Miroşi",
					"to": "Surduleşti h.",
					"leavesAt": "19:18",
					"arrivesAt": "19:24",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Surduleşti h.",
					"to": "Balaci Hm.",
					"leavesAt": "19:25",
					"arrivesAt": "19:30",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Balaci Hm.",
					"to": "Zâmbreasca h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Beuca h.",
					"leavesAt": "19:39",
					"arrivesAt": "19:43",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Beuca h.",
					"to": "Beuca Sat h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:47",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca Sat h.",
					"to": "Drăcşenei h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Drăcşenei h.",
					"to": "Roşiori Nord",
					"leavesAt": "19:52",
					"arrivesAt": "20:10",
					"waitsAtSource": 30,
					"distance": 13500
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181221",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15253",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Drăcşenei h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:28",
					"waitsAtSource": 0,
					"distance": 13500
				},
				{
					"from": "Drăcşenei h.",
					"to": "Beuca Sat h.",
					"leavesAt": "06:29",
					"arrivesAt": "06:33",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Beuca Sat h.",
					"to": "Beuca h.",
					"leavesAt": "06:34",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca h.",
					"to": "Zâmbreasca h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Balaci Hm.",
					"leavesAt": "06:43",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Balaci Hm.",
					"to": "Surduleşti h.",
					"leavesAt": "06:51",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Surduleşti h.",
					"to": "Miroşi",
					"leavesAt": "06:57",
					"arrivesAt": "07:03",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Miroşi",
					"to": "Colţ h.",
					"leavesAt": "07:04",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Colţ h.",
					"to": "Costeşti",
					"leavesAt": "07:14",
					"arrivesAt": "07:46",
					"waitsAtSource": 30,
					"distance": 19300
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181210",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15111",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "16:23",
					"arrivesAt": "16:28",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:38",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "16:39",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "16:44",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Brătăşanca h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Brătăşanca h.",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "16:54",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "I. L. Caragiale",
					"leavesAt": "16:59",
					"arrivesAt": "17:07",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "I. L. Caragiale",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:19",
					"waitsAtSource": 540,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "Mija",
					"leavesAt": "17:20",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mija",
					"to": "Adânca PM.",
					"leavesAt": "17:26",
					"arrivesAt": "17:34",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Adânca PM.",
					"to": "Răzvad hc.",
					"leavesAt": "17:35",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Răzvad hc.",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "17:44",
					"arrivesAt": "17:48",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Târgovişte Nord",
					"leavesAt": "17:49",
					"arrivesAt": "17:55",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgovişte Nord",
					"to": "TEIŞ Hm.",
					"leavesAt": "17:56",
					"arrivesAt": "17:59",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:02",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "18:03",
					"arrivesAt": "18:07",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15106",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "10:55",
					"arrivesAt": "10:58",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "10:59",
					"arrivesAt": "11:02",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Târgovişte Nord",
					"leavesAt": "11:03",
					"arrivesAt": "11:06",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Târgovişte Nord",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "11:07",
					"arrivesAt": "11:12",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Răzvad hc.",
					"leavesAt": "11:13",
					"arrivesAt": "11:16",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Răzvad hc.",
					"to": "Adânca PM.",
					"leavesAt": "11:17",
					"arrivesAt": "11:25",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Adânca PM.",
					"to": "Mija",
					"leavesAt": "11:26",
					"arrivesAt": "11:36",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Mija",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "11:37",
					"arrivesAt": "11:41",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "I. L. Caragiale",
					"leavesAt": "11:42",
					"arrivesAt": "11:47",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "11:48",
					"arrivesAt": "11:54",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "Brătăşanca h.",
					"leavesAt": "11:55",
					"arrivesAt": "11:59",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Brătăşanca h.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "12:00",
					"arrivesAt": "12:06",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "12:07",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "12:12",
					"arrivesAt": "12:17",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Ploieşti Vest",
					"leavesAt": "12:18",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "12:29",
					"arrivesAt": "12:35",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15054",
			"segments": [
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "14:53",
					"arrivesAt": "15:25",
					"waitsAtSource": 0,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "15:26",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Periş",
					"leavesAt": "16:02",
					"arrivesAt": "16:29",
					"waitsAtSource": 120,
					"distance": 30000
				},
				{
					"from": "Periş",
					"to": "Bucureşti Nord",
					"leavesAt": "16:30",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 30200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15033",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Gârbău Hm.",
					"leavesAt": "09:08",
					"arrivesAt": "09:27",
					"waitsAtSource": 0,
					"distance": 20200
				},
				{
					"from": "Gârbău Hm.",
					"to": "Aghireş",
					"leavesAt": "09:28",
					"arrivesAt": "09:36",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "09:37",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Huedin",
					"leavesAt": "09:41",
					"arrivesAt": "10:04",
					"waitsAtSource": 30,
					"distance": 18900
				},
				{
					"from": "Huedin",
					"to": "Poieni",
					"leavesAt": "10:05",
					"arrivesAt": "10:19",
					"waitsAtSource": 60,
					"distance": 15300
				},
				{
					"from": "Poieni",
					"to": "Ciucea Hm.",
					"leavesAt": "10:20",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ciucea Hm.",
					"to": "Negreni h.",
					"leavesAt": "10:28",
					"arrivesAt": "10:31",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Lacu Crişului h.",
					"leavesAt": "10:32",
					"arrivesAt": "10:35",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "10:36",
					"arrivesAt": "10:40",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bulz Hm.",
					"leavesAt": "10:41",
					"arrivesAt": "10:46",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bulz Hm.",
					"to": "Stâna de Vale h.",
					"leavesAt": "10:47",
					"arrivesAt": "10:49",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bratca",
					"leavesAt": "10:50",
					"arrivesAt": "10:55",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bratca",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "11:00",
					"arrivesAt": "11:08",
					"waitsAtSource": 300,
					"distance": 6300
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "11:09",
					"arrivesAt": "11:17",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Aleşd",
					"leavesAt": "11:18",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Aleşd",
					"to": "Oşorhei Hm.",
					"leavesAt": "11:31",
					"arrivesAt": "11:51",
					"waitsAtSource": 60,
					"distance": 24800
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Oradea Est",
					"leavesAt": "11:52",
					"arrivesAt": "11:58",
					"waitsAtSource": 60,
					"distance": 5800
				},
				{
					"from": "Oradea Est",
					"to": "Oradea",
					"leavesAt": "11:59",
					"arrivesAt": "12:05",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15305",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Tuluceşti Hm.",
					"leavesAt": "06:07",
					"arrivesAt": "06:31",
					"waitsAtSource": 0,
					"distance": 13600
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Şiviţa h.",
					"leavesAt": "06:39",
					"arrivesAt": "06:45",
					"waitsAtSource": 480,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:52",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Stoicani h.",
					"leavesAt": "06:53",
					"arrivesAt": "06:59",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stoicani h.",
					"to": "Folteşti Hm.",
					"leavesAt": "07:00",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Folteşti Hm.",
					"to": "Chiraftei h.",
					"leavesAt": "07:06",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Chiraftei h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "07:13",
					"arrivesAt": "07:17",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Băleni h.",
					"leavesAt": "07:18",
					"arrivesAt": "07:22",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Băleni h.",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "07:23",
					"arrivesAt": "07:28",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Târgu Bujor",
					"leavesAt": "07:29",
					"arrivesAt": "07:34",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgu Bujor",
					"to": "Moscu hc.",
					"leavesAt": "07:35",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moscu hc.",
					"to": "Roşcani h.",
					"leavesAt": "07:41",
					"arrivesAt": "07:47",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Roşcani h.",
					"to": "Balinteşti h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:56",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Balinteşti h.",
					"to": "Bereşti Hm.",
					"leavesAt": "07:57",
					"arrivesAt": "08:06",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Bereşti Hm.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "08:07",
					"arrivesAt": "08:11",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Tălăşmani h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:20",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Tălăşmani h.",
					"to": "Docăneasa hc.",
					"leavesAt": "08:21",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Docăneasa hc.",
					"to": "Lungeşti h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lungeşti h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Griviţa h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:43",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Griviţa h.",
					"to": "Bârlad",
					"leavesAt": "08:44",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15357",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Nord Hm.",
					"leavesAt": "13:35",
					"arrivesAt": "13:45",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Verneşti",
					"leavesAt": "13:46",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Verneşti",
					"to": "Cândeşti hc.",
					"leavesAt": "13:53",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Cândeşti hc.",
					"to": "Berca Hm.",
					"leavesAt": "14:00",
					"arrivesAt": "14:06",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Berca Hm.",
					"to": "Ojasca h.",
					"leavesAt": "14:14",
					"arrivesAt": "14:18",
					"waitsAtSource": 480,
					"distance": 2200
				},
				{
					"from": "Ojasca h.",
					"to": "Unguriu hc.",
					"leavesAt": "14:19",
					"arrivesAt": "14:24",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Unguriu hc.",
					"to": "Măgura hcv.",
					"leavesAt": "14:25",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Măgura hcv.",
					"to": "Pârscov",
					"leavesAt": "14:31",
					"arrivesAt": "14:36",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pârscov",
					"to": "Bădila h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:58",
					"waitsAtSource": 960,
					"distance": 4300
				},
				{
					"from": "Bădila h.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "14:59",
					"arrivesAt": "15:03",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Vipereşti hc.",
					"leavesAt": "15:04",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vipereşti hc.",
					"to": "Cislău hcv.",
					"leavesAt": "15:10",
					"arrivesAt": "15:19",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cislău hcv.",
					"to": "Gura Bascii h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:23",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Gura Bascii h.",
					"to": "Valea Seacă h.",
					"leavesAt": "15:24",
					"arrivesAt": "15:27",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Valea Seacă h.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "15:28",
					"arrivesAt": "15:31",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "15:32",
					"arrivesAt": "15:38",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "15:39",
					"arrivesAt": "15:43",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Şeţu h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şeţu h.",
					"to": "Păltineni h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:55",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Păltineni h.",
					"to": "Nehoiu h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:00",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Nehoiu h.",
					"to": "Nehoiaşu",
					"leavesAt": "16:01",
					"arrivesAt": "16:05",
					"waitsAtSource": 30,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15257",
			"segments": [
				{
					"from": "Roşiori Nord",
					"to": "Drăcşenei h.",
					"leavesAt": "10:55",
					"arrivesAt": "11:12",
					"waitsAtSource": 0,
					"distance": 13500
				},
				{
					"from": "Drăcşenei h.",
					"to": "Beuca Sat h.",
					"leavesAt": "11:13",
					"arrivesAt": "11:16",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Beuca Sat h.",
					"to": "Beuca h.",
					"leavesAt": "11:17",
					"arrivesAt": "11:20",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca h.",
					"to": "Zâmbreasca h.",
					"leavesAt": "11:21",
					"arrivesAt": "11:25",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Balaci Hm.",
					"leavesAt": "11:26",
					"arrivesAt": "11:33",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Balaci Hm.",
					"to": "Surduleşti h.",
					"leavesAt": "11:34",
					"arrivesAt": "11:39",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Surduleşti h.",
					"to": "Miroşi",
					"leavesAt": "11:40",
					"arrivesAt": "11:46",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Miroşi",
					"to": "Colţ h.",
					"leavesAt": "11:47",
					"arrivesAt": "11:56",
					"waitsAtSource": 60,
					"distance": 8100
				},
				{
					"from": "Colţ h.",
					"to": "Costeşti",
					"leavesAt": "11:57",
					"arrivesAt": "12:29",
					"waitsAtSource": 30,
					"distance": 19300
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15172",
			"segments": [
				{
					"from": "Olteniţa",
					"to": "Valea Roşie hc.",
					"leavesAt": "04:22",
					"arrivesAt": "04:34",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Curcani h.",
					"leavesAt": "04:35",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Curcani h.",
					"to": "Luica h.",
					"leavesAt": "04:41",
					"arrivesAt": "04:44",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Luica h.",
					"to": "Şoldanu h.",
					"leavesAt": "04:45",
					"arrivesAt": "04:48",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şoldanu h.",
					"to": "Negoieşti h.",
					"leavesAt": "04:49",
					"arrivesAt": "04:51",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Negoieşti h.",
					"to": "Budeşti Hm.",
					"leavesAt": "04:52",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Budeşti Hm.",
					"to": "Vasilaţi hc.",
					"leavesAt": "04:58",
					"arrivesAt": "05:04",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "05:05",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:13",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "05:14",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "05:18",
					"arrivesAt": "05:21",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plătăreşti hc.",
					"to": "Frunzăneşti h.",
					"leavesAt": "05:22",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Tânganu h.",
					"leavesAt": "05:27",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Tânganu h.",
					"to": "Căldăraru h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:36",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Căldăraru h.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "05:37",
					"arrivesAt": "05:42",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Titan Sud Hm.",
					"leavesAt": "05:43",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15130",
			"segments": [
				{
					"from": "Slănic",
					"to": "Prăjani h.",
					"leavesAt": "10:40",
					"arrivesAt": "10:44",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Prăjani h.",
					"to": "Vărbilău hc.",
					"leavesAt": "10:45",
					"arrivesAt": "10:49",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărbilău hc.",
					"to": "Vlădeşti h.",
					"leavesAt": "10:50",
					"arrivesAt": "10:53",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vlădeşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "10:54",
					"arrivesAt": "10:58",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "10:59",
					"arrivesAt": "11:02",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Mălăeşti h.",
					"leavesAt": "11:03",
					"arrivesAt": "11:08",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mălăeşti h.",
					"to": "Găvănel hc.",
					"leavesAt": "11:09",
					"arrivesAt": "11:12",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Găvănel hc.",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "11:13",
					"arrivesAt": "11:18",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Plopeni",
					"leavesAt": "11:19",
					"arrivesAt": "11:23",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plopeni",
					"to": "Găgeni hc.",
					"leavesAt": "11:24",
					"arrivesAt": "11:28",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Găgeni hc.",
					"to": "Buda",
					"leavesAt": "11:29",
					"arrivesAt": "11:38",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "11:39",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "11:47",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180910",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20180615",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15191",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "21:00",
					"arrivesAt": "21:08",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "21:09",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "21:13",
					"arrivesAt": "21:18",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "21:19",
					"arrivesAt": "21:22",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "21:23",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "21:27",
					"arrivesAt": "21:30",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "21:31",
					"arrivesAt": "21:33",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "21:34",
					"arrivesAt": "21:38",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "21:39",
					"arrivesAt": "21:43",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "21:44",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "21:55",
					"arrivesAt": "21:57",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "21:58",
					"arrivesAt": "22:01",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "22:02",
					"arrivesAt": "22:06",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "22:07",
					"arrivesAt": "22:12",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "22:13",
					"arrivesAt": "22:25",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15173",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "07:35",
					"arrivesAt": "07:43",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:53",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "07:54",
					"arrivesAt": "07:56",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "07:57",
					"arrivesAt": "08:01",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "08:05",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "08:09",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "08:13",
					"arrivesAt": "08:17",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "08:18",
					"arrivesAt": "08:24",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "08:25",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "08:30",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:36",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:41",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "08:42",
					"arrivesAt": "08:47",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "08:48",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15135",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Periş",
					"leavesAt": "19:50",
					"arrivesAt": "20:13",
					"waitsAtSource": 0,
					"distance": 30200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "20:14",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "20:19",
					"arrivesAt": "20:23",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "20:24",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "20:36",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "21:07",
					"arrivesAt": "21:12",
					"waitsAtSource": 1080,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "21:14",
					"arrivesAt": "21:21",
					"waitsAtSource": 120,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Găgeni hc.",
					"leavesAt": "21:22",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Găgeni hc.",
					"to": "Plopeni",
					"leavesAt": "21:31",
					"arrivesAt": "21:35",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "21:36",
					"arrivesAt": "21:40",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Găvănel hc.",
					"leavesAt": "21:45",
					"arrivesAt": "21:49",
					"waitsAtSource": 300,
					"distance": 2700
				},
				{
					"from": "Găvănel hc.",
					"to": "Mălăeşti h.",
					"leavesAt": "21:50",
					"arrivesAt": "21:53",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mălăeşti h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "21:54",
					"arrivesAt": "21:59",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "22:00",
					"arrivesAt": "22:04",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Vlădeşti h.",
					"leavesAt": "22:05",
					"arrivesAt": "22:08",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Vlădeşti h.",
					"to": "Vărbilău hc.",
					"leavesAt": "22:09",
					"arrivesAt": "22:12",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vărbilău hc.",
					"to": "Prăjani h.",
					"leavesAt": "22:13",
					"arrivesAt": "22:17",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Prăjani h.",
					"to": "Slănic",
					"leavesAt": "22:18",
					"arrivesAt": "22:23",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15002",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "03:56",
					"arrivesAt": "04:00",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "04:01",
					"arrivesAt": "04:05",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "04:06",
					"arrivesAt": "04:09",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "04:10",
					"arrivesAt": "04:16",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "04:17",
					"arrivesAt": "04:22",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "04:23",
					"arrivesAt": "04:29",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "04:30",
					"arrivesAt": "04:33",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "04:34",
					"arrivesAt": "04:37",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "04:38",
					"arrivesAt": "04:41",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "04:42",
					"arrivesAt": "04:51",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "04:52",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:03",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "05:04",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "05:11",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "05:16",
					"arrivesAt": "05:21",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "05:22",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "05:39",
					"arrivesAt": "05:44",
					"waitsAtSource": 480,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "05:45",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "05:52",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "05:59",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzău",
					"to": "Ulmeni",
					"leavesAt": "06:24",
					"arrivesAt": "06:38",
					"waitsAtSource": 900,
					"distance": 15400
				},
				{
					"from": "Ulmeni",
					"to": "Săhăteni Hm.",
					"leavesAt": "06:39",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "06:53",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Tomşani hc.",
					"leavesAt": "07:01",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "07:13",
					"arrivesAt": "07:18",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "07:19",
					"arrivesAt": "07:22",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Ploieşti Est",
					"leavesAt": "07:23",
					"arrivesAt": "07:36",
					"waitsAtSource": 30,
					"distance": 10100
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "07:37",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "07:53",
					"arrivesAt": "07:58",
					"waitsAtSource": 540,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Brazi",
					"leavesAt": "08:05",
					"arrivesAt": "08:12",
					"waitsAtSource": 420,
					"distance": 7500
				},
				{
					"from": "Brazi",
					"to": "Crivina",
					"leavesAt": "08:13",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "08:24",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "08:29",
					"arrivesAt": "08:34",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Bucureşti Nord",
					"leavesAt": "08:35",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 30200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15185",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "16:45",
					"arrivesAt": "16:53",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:04",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "17:09",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:16",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "17:21",
					"arrivesAt": "17:25",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "17:26",
					"arrivesAt": "17:31",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "17:32",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:51",
					"waitsAtSource": 540,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "17:52",
					"arrivesAt": "17:53",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "17:54",
					"arrivesAt": "17:58",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "18:03",
					"arrivesAt": "18:08",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "18:09",
					"arrivesAt": "18:21",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15004",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "16:33",
					"arrivesAt": "16:36",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:45",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "17:06",
					"arrivesAt": "17:12",
					"waitsAtSource": 480,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "17:21",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "17:25",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "17:35",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "17:41",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "17:46",
					"arrivesAt": "17:52",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "17:59",
					"arrivesAt": "18:04",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "18:05",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "18:10",
					"arrivesAt": "18:14",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "18:15",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "18:21",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "18:34",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buzău",
					"to": "Ulmeni",
					"leavesAt": "19:06",
					"arrivesAt": "19:20",
					"waitsAtSource": 1320,
					"distance": 15400
				},
				{
					"from": "Ulmeni",
					"to": "Săhăteni Hm.",
					"leavesAt": "19:21",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Mizil",
					"leavesAt": "19:34",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Mizil",
					"to": "Tomşani hc.",
					"leavesAt": "19:42",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Tomşani hc.",
					"to": "Cricov Hm.",
					"leavesAt": "19:53",
					"arrivesAt": "19:58",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cricov Hm.",
					"to": "Muru hc.",
					"leavesAt": "19:59",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Muru hc.",
					"to": "Ploieşti Est",
					"leavesAt": "20:02",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 10100
				},
				{
					"from": "Ploieşti Est",
					"to": "Ploieşti Sud",
					"leavesAt": "20:15",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "20:32",
					"arrivesAt": "20:37",
					"waitsAtSource": 660,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crivina",
					"leavesAt": "20:42",
					"arrivesAt": "20:56",
					"waitsAtSource": 300,
					"distance": 19200
				},
				{
					"from": "Crivina",
					"to": "Periş",
					"leavesAt": "20:57",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Periş",
					"to": "Bucureşti Nord",
					"leavesAt": "21:05",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 30200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15101",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "04:17",
					"arrivesAt": "04:22",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "04:23",
					"arrivesAt": "04:32",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "04:33",
					"arrivesAt": "04:37",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "04:38",
					"arrivesAt": "04:42",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Brătăşanca h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Brătăşanca h.",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "04:48",
					"arrivesAt": "04:52",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "I. L. Caragiale",
					"leavesAt": "04:53",
					"arrivesAt": "05:01",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "I. L. Caragiale",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "Mija",
					"leavesAt": "05:06",
					"arrivesAt": "05:11",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mija",
					"to": "Adânca PM.",
					"leavesAt": "05:12",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Adânca PM.",
					"to": "Răzvad hc.",
					"leavesAt": "05:20",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Răzvad hc.",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "05:29",
					"arrivesAt": "05:32",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Târgovişte Nord",
					"leavesAt": "05:33",
					"arrivesAt": "05:39",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgovişte Nord",
					"to": "TEIŞ Hm.",
					"leavesAt": "05:40",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Târgovişte",
					"leavesAt": "05:44",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20180301",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15140",
			"segments": [
				{
					"from": "Măneciu",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "04:24",
					"arrivesAt": "04:28",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Izvoarele hc.",
					"leavesAt": "04:29",
					"arrivesAt": "04:31",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Homorâciu P.M.",
					"leavesAt": "04:32",
					"arrivesAt": "04:38",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Teişani Hm.",
					"leavesAt": "04:39",
					"arrivesAt": "04:43",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Teişani Hm.",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "04:44",
					"arrivesAt": "04:48",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Vălenii de Munte",
					"leavesAt": "04:49",
					"arrivesAt": "04:53",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălenii de Munte",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "04:54",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Făget Teleajen",
					"leavesAt": "04:58",
					"arrivesAt": "05:02",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Făget Teleajen",
					"to": "Măgurele Nord h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "05:06",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Sud h.",
					"leavesAt": "05:11",
					"arrivesAt": "05:13",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Lipăneşti hc.",
					"leavesAt": "05:14",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Boldeşti hc.",
					"leavesAt": "05:18",
					"arrivesAt": "05:22",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Boldeşti hc.",
					"to": "Scăieni h.",
					"leavesAt": "05:23",
					"arrivesAt": "05:24",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Scăieni h.",
					"to": "Blejoi",
					"leavesAt": "05:25",
					"arrivesAt": "05:30",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Blejoi",
					"to": "Ploieşti Nord",
					"leavesAt": "05:31",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ploieşti Nord",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "05:37",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Sud",
					"leavesAt": "05:42",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15304",
			"segments": [
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:18",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "05:19",
					"arrivesAt": "05:27",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "05:28",
					"arrivesAt": "05:34",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "05:35",
					"arrivesAt": "05:40",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Târgu Bujor",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Băleni h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:50",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Băleni h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:55",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Chiraftei h.",
					"leavesAt": "05:56",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Chiraftei h.",
					"to": "Folteşti Hm.",
					"leavesAt": "06:01",
					"arrivesAt": "06:08",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Folteşti Hm.",
					"to": "Stoicani h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Stoicani h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "06:16",
					"arrivesAt": "06:22",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Şiviţa h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Tuluceşti Hm.",
					"leavesAt": "06:30",
					"arrivesAt": "06:36",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Galaţi",
					"leavesAt": "06:37",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 13600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15125",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Periş",
					"leavesAt": "08:32",
					"arrivesAt": "08:55",
					"waitsAtSource": 0,
					"distance": 30200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "08:56",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "09:02",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "09:08",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "09:21",
					"arrivesAt": "09:36",
					"waitsAtSource": 120,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "09:48",
					"arrivesAt": "09:53",
					"waitsAtSource": 720,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "09:54",
					"arrivesAt": "10:00",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Găgeni hc.",
					"leavesAt": "10:01",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Găgeni hc.",
					"to": "Plopeni",
					"leavesAt": "10:11",
					"arrivesAt": "10:15",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "10:16",
					"arrivesAt": "10:20",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Găvănel hc.",
					"leavesAt": "10:28",
					"arrivesAt": "10:32",
					"waitsAtSource": 480,
					"distance": 2700
				},
				{
					"from": "Găvănel hc.",
					"to": "Mălăeşti h.",
					"leavesAt": "10:33",
					"arrivesAt": "10:36",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mălăeşti h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "10:37",
					"arrivesAt": "10:42",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "10:43",
					"arrivesAt": "10:47",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Vlădeşti h.",
					"leavesAt": "10:48",
					"arrivesAt": "10:51",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Vlădeşti h.",
					"to": "Vărbilău hc.",
					"leavesAt": "10:52",
					"arrivesAt": "10:55",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vărbilău hc.",
					"to": "Prăjani h.",
					"leavesAt": "10:56",
					"arrivesAt": "11:00",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Prăjani h.",
					"to": "Slănic",
					"leavesAt": "11:01",
					"arrivesAt": "11:06",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20180616",
					"to": "20180909",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15031",
			"segments": [
				{
					"from": "Cluj Napoca",
					"to": "Gârbău Hm.",
					"leavesAt": "07:15",
					"arrivesAt": "07:35",
					"waitsAtSource": 0,
					"distance": 20200
				},
				{
					"from": "Gârbău Hm.",
					"to": "Aghireş",
					"leavesAt": "07:36",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Aghireş",
					"to": "Aghireş h.",
					"leavesAt": "07:45",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Aghireş h.",
					"to": "Huedin",
					"leavesAt": "07:49",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 18900
				},
				{
					"from": "Huedin",
					"to": "Poieni",
					"leavesAt": "08:13",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 15300
				},
				{
					"from": "Poieni",
					"to": "Ciucea Hm.",
					"leavesAt": "08:28",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Ciucea Hm.",
					"to": "Negreni h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:40",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Lacu Crişului h.",
					"leavesAt": "08:41",
					"arrivesAt": "08:44",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "08:45",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Bulz Hm.",
					"leavesAt": "08:51",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bulz Hm.",
					"to": "Stâna de Vale h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Stâna de Vale h.",
					"to": "Bratca",
					"leavesAt": "09:01",
					"arrivesAt": "09:06",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Bratca",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "09:07",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "09:16",
					"arrivesAt": "09:24",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Aleşd",
					"leavesAt": "09:25",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Aleşd",
					"to": "Oşorhei Hm.",
					"leavesAt": "09:38",
					"arrivesAt": "09:58",
					"waitsAtSource": 60,
					"distance": 24800
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Oradea",
					"leavesAt": "09:59",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 9500
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15180",
			"segments": [
				{
					"from": "Olteniţa",
					"to": "Valea Roşie hc.",
					"leavesAt": "10:54",
					"arrivesAt": "11:06",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Curcani h.",
					"leavesAt": "11:07",
					"arrivesAt": "11:11",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Curcani h.",
					"to": "Luica h.",
					"leavesAt": "11:12",
					"arrivesAt": "11:16",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Luica h.",
					"to": "Şoldanu h.",
					"leavesAt": "11:17",
					"arrivesAt": "11:21",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şoldanu h.",
					"to": "Negoieşti h.",
					"leavesAt": "11:22",
					"arrivesAt": "11:24",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Negoieşti h.",
					"to": "Budeşti Hm.",
					"leavesAt": "11:25",
					"arrivesAt": "11:31",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Budeşti Hm.",
					"to": "Vasilaţi hc.",
					"leavesAt": "11:32",
					"arrivesAt": "11:37",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "11:38",
					"arrivesAt": "11:41",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "11:42",
					"arrivesAt": "11:45",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "11:46",
					"arrivesAt": "11:49",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "11:50",
					"arrivesAt": "11:52",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plătăreşti hc.",
					"to": "Frunzăneşti h.",
					"leavesAt": "11:53",
					"arrivesAt": "11:57",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Tânganu h.",
					"leavesAt": "11:58",
					"arrivesAt": "12:00",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Tânganu h.",
					"to": "Căldăraru h.",
					"leavesAt": "12:01",
					"arrivesAt": "12:07",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Căldăraru h.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "12:08",
					"arrivesAt": "12:12",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Titan Sud Hm.",
					"leavesAt": "12:13",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15032",
			"segments": [
				{
					"from": "Oradea",
					"to": "Oşorhei Hm.",
					"leavesAt": "04:43",
					"arrivesAt": "04:54",
					"waitsAtSource": 0,
					"distance": 9500
				},
				{
					"from": "Oşorhei Hm.",
					"to": "Tileagd",
					"leavesAt": "04:55",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 13600
				},
				{
					"from": "Tileagd",
					"to": "Aleşd",
					"leavesAt": "05:07",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 11200
				},
				{
					"from": "Aleşd",
					"to": "Vadu Crişului Hm.",
					"leavesAt": "05:18",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 12200
				},
				{
					"from": "Vadu Crişului Hm.",
					"to": "Şuncuiuş Hm.",
					"leavesAt": "05:31",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Şuncuiuş Hm.",
					"to": "Bratca",
					"leavesAt": "05:40",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Bratca",
					"to": "Bulz Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Bulz Hm.",
					"to": "Piatra Craiului Hm.",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Piatra Craiului Hm.",
					"to": "Lacu Crişului h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Lacu Crişului h.",
					"to": "Negreni h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Negreni h.",
					"to": "Ciucea Hm.",
					"leavesAt": "06:10",
					"arrivesAt": "06:14",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ciucea Hm.",
					"to": "Poieni",
					"leavesAt": "06:15",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 7100
				},
				{
					"from": "Poieni",
					"to": "Bologa h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Bologa h.",
					"to": "Brăişoru Hm.",
					"leavesAt": "06:27",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Brăişoru Hm.",
					"to": "Huedin",
					"leavesAt": "06:32",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Huedin",
					"to": "Aghireş h.",
					"leavesAt": "06:41",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 18900
				},
				{
					"from": "Aghireş h.",
					"to": "Aghireş",
					"leavesAt": "07:02",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aghireş",
					"to": "Gârbău Hm.",
					"leavesAt": "07:07",
					"arrivesAt": "07:14",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Gârbău Hm.",
					"to": "Cluj Napoca",
					"leavesAt": "07:15",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 20200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15136",
			"segments": [
				{
					"from": "Slănic",
					"to": "Prăjani h.",
					"leavesAt": "19:17",
					"arrivesAt": "19:21",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Prăjani h.",
					"to": "Vărbilău hc.",
					"leavesAt": "19:22",
					"arrivesAt": "19:26",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărbilău hc.",
					"to": "Vlădeşti h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:30",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vlădeşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:35",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "19:36",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Mălăeşti h.",
					"leavesAt": "19:40",
					"arrivesAt": "19:45",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mălăeşti h.",
					"to": "Găvănel hc.",
					"leavesAt": "19:46",
					"arrivesAt": "19:49",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Găvănel hc.",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "19:50",
					"arrivesAt": "19:55",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Plopeni",
					"leavesAt": "19:56",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Plopeni",
					"to": "Găgeni hc.",
					"leavesAt": "20:01",
					"arrivesAt": "20:05",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Găgeni hc.",
					"to": "Buda",
					"leavesAt": "20:06",
					"arrivesAt": "20:15",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "20:17",
					"arrivesAt": "20:25",
					"waitsAtSource": 120,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "20:26",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15314",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Griviţa h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:31",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Griviţa h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "16:32",
					"arrivesAt": "16:36",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Lungeşti h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:43",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lungeşti h.",
					"to": "Docăneasa hc.",
					"leavesAt": "16:44",
					"arrivesAt": "16:47",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Docăneasa hc.",
					"to": "Tălăşmani h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:54",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Tălăşmani h.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "16:55",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Bereşti Hm.",
					"leavesAt": "17:04",
					"arrivesAt": "17:08",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:23",
					"waitsAtSource": 420,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "17:24",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "17:33",
					"arrivesAt": "17:39",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "17:40",
					"arrivesAt": "17:46",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Târgu Bujor",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "17:54",
					"arrivesAt": "17:57",
					"waitsAtSource": 480,
					"distance": 2100
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Băleni h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:03",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Băleni h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:08",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Chiraftei h.",
					"leavesAt": "18:09",
					"arrivesAt": "18:13",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Chiraftei h.",
					"to": "Folteşti Hm.",
					"leavesAt": "18:14",
					"arrivesAt": "18:20",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Folteşti Hm.",
					"to": "Stoicani h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Stoicani h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "18:27",
					"arrivesAt": "18:33",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Şiviţa h.",
					"leavesAt": "18:34",
					"arrivesAt": "18:40",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Tuluceşti Hm.",
					"leavesAt": "18:41",
					"arrivesAt": "18:47",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Galaţi",
					"leavesAt": "18:48",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 13600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15317",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Tuluceşti Hm.",
					"leavesAt": "19:40",
					"arrivesAt": "20:04",
					"waitsAtSource": 0,
					"distance": 13600
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Şiviţa h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Stoicani h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stoicani h.",
					"to": "Folteşti Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Folteşti Hm.",
					"to": "Chiraftei h.",
					"leavesAt": "20:31",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Chiraftei h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:42",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Băleni h.",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Băleni h.",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:53",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Târgu Bujor",
					"leavesAt": "20:54",
					"arrivesAt": "20:57",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgu Bujor",
					"to": "Moscu hc.",
					"leavesAt": "20:58",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moscu hc.",
					"to": "Roşcani h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:10",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Roşcani h.",
					"to": "Balinteşti h.",
					"leavesAt": "21:11",
					"arrivesAt": "21:19",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Balinteşti h.",
					"to": "Bereşti Hm.",
					"leavesAt": "21:20",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Bereşti Hm.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "21:29",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Tălăşmani h.",
					"leavesAt": "21:34",
					"arrivesAt": "21:42",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Tălăşmani h.",
					"to": "Docăneasa hc.",
					"leavesAt": "21:43",
					"arrivesAt": "21:49",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Docăneasa hc.",
					"to": "Lungeşti h.",
					"leavesAt": "21:50",
					"arrivesAt": "21:53",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Lungeşti h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "21:54",
					"arrivesAt": "22:00",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Griviţa h.",
					"leavesAt": "22:01",
					"arrivesAt": "22:05",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Griviţa h.",
					"to": "Bârlad",
					"leavesAt": "22:06",
					"arrivesAt": "22:14",
					"waitsAtSource": 30,
					"distance": 7100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15133",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "19:15",
					"arrivesAt": "19:20",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "19:22",
					"arrivesAt": "19:29",
					"waitsAtSource": 120,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Găgeni hc.",
					"leavesAt": "19:31",
					"arrivesAt": "19:39",
					"waitsAtSource": 120,
					"distance": 6800
				},
				{
					"from": "Găgeni hc.",
					"to": "Plopeni",
					"leavesAt": "19:40",
					"arrivesAt": "19:44",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "19:45",
					"arrivesAt": "19:49",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Găvănel hc.",
					"leavesAt": "19:58",
					"arrivesAt": "20:02",
					"waitsAtSource": 540,
					"distance": 2700
				},
				{
					"from": "Găvănel hc.",
					"to": "Mălăeşti h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:06",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mălăeşti h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "20:13",
					"arrivesAt": "20:17",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Vlădeşti h.",
					"leavesAt": "20:18",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Vlădeşti h.",
					"to": "Vărbilău hc.",
					"leavesAt": "20:22",
					"arrivesAt": "20:25",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vărbilău hc.",
					"to": "Prăjani h.",
					"leavesAt": "20:26",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Prăjani h.",
					"to": "Slănic",
					"leavesAt": "20:31",
					"arrivesAt": "20:36",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15350",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "04:54",
					"arrivesAt": "04:58",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "04:59",
					"arrivesAt": "05:03",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "05:04",
					"arrivesAt": "05:07",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "05:08",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:20",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "05:21",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "05:28",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:35",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "05:36",
					"arrivesAt": "05:39",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "05:40",
					"arrivesAt": "05:49",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "05:50",
					"arrivesAt": "05:55",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "05:56",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "06:01",
					"arrivesAt": "06:07",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "06:08",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "06:14",
					"arrivesAt": "06:19",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "06:20",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "06:30",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "06:36",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "06:43",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "06:50",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15179",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "12:00",
					"arrivesAt": "12:08",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "12:16",
					"arrivesAt": "12:20",
					"waitsAtSource": 480,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "12:21",
					"arrivesAt": "12:26",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "12:27",
					"arrivesAt": "12:29",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "12:30",
					"arrivesAt": "12:34",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "12:35",
					"arrivesAt": "12:37",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "12:38",
					"arrivesAt": "12:41",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "12:42",
					"arrivesAt": "12:45",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "12:46",
					"arrivesAt": "12:50",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "12:51",
					"arrivesAt": "12:57",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "13:05",
					"arrivesAt": "13:09",
					"waitsAtSource": 480,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "13:10",
					"arrivesAt": "13:11",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "13:12",
					"arrivesAt": "13:16",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "13:17",
					"arrivesAt": "13:21",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "13:22",
					"arrivesAt": "13:27",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "13:28",
					"arrivesAt": "13:40",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15147",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "13:50",
					"arrivesAt": "13:54",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Nord",
					"leavesAt": "13:55",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploieşti Nord",
					"to": "Blejoi",
					"leavesAt": "14:01",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Blejoi",
					"to": "Scăieni h.",
					"leavesAt": "14:08",
					"arrivesAt": "14:12",
					"waitsAtSource": 120,
					"distance": 3800
				},
				{
					"from": "Scăieni h.",
					"to": "Boldeşti hc.",
					"leavesAt": "14:13",
					"arrivesAt": "14:15",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Boldeşti hc.",
					"to": "Lipăneşti hc.",
					"leavesAt": "14:16",
					"arrivesAt": "14:20",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Măgurele Sud h.",
					"leavesAt": "14:21",
					"arrivesAt": "14:24",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "14:25",
					"arrivesAt": "14:29",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Nord h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Făget Teleajen",
					"leavesAt": "14:35",
					"arrivesAt": "14:38",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Făget Teleajen",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "14:46",
					"arrivesAt": "14:50",
					"waitsAtSource": 480,
					"distance": 2500
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Vălenii de Munte",
					"leavesAt": "14:51",
					"arrivesAt": "14:55",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vălenii de Munte",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "14:56",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Teişani Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:08",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Teişani Hm.",
					"to": "Homorâciu P.M.",
					"leavesAt": "15:09",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Izvoarele hc.",
					"leavesAt": "15:16",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "15:22",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Măneciu",
					"leavesAt": "15:26",
					"arrivesAt": "15:31",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20180702",
					"to": "20180707",
					"daysOfWeek": 351
				},
				{
					"from": "20180709",
					"to": "20180714",
					"daysOfWeek": 351
				},
				{
					"from": "20180716",
					"to": "20180721",
					"daysOfWeek": 351
				},
				{
					"from": "20180723",
					"to": "20180728",
					"daysOfWeek": 351
				},
				{
					"from": "20180730",
					"to": "20180804",
					"daysOfWeek": 351
				},
				{
					"from": "20180806",
					"to": "20180811",
					"daysOfWeek": 351
				},
				{
					"from": "20180813",
					"to": "20180818",
					"daysOfWeek": 351
				},
				{
					"from": "20180820",
					"to": "20180825",
					"daysOfWeek": 351
				},
				{
					"from": "20180827",
					"to": "20180901",
					"daysOfWeek": 351
				},
				{
					"from": "20180903",
					"to": "20180908",
					"daysOfWeek": 351
				},
				{
					"from": "20180910",
					"to": "20180915",
					"daysOfWeek": 351
				},
				{
					"from": "20180917",
					"to": "20180922",
					"daysOfWeek": 351
				},
				{
					"from": "20180924",
					"to": "20181208",
					"daysOfWeek": 351
				},
				{
					"from": "20171210",
					"to": "20180630",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15113",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "18:30",
					"arrivesAt": "18:35",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "18:36",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "18:46",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "18:51",
					"arrivesAt": "18:55",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Brătăşanca h.",
					"leavesAt": "18:56",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Brătăşanca h.",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "19:01",
					"arrivesAt": "19:06",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "I. L. Caragiale",
					"leavesAt": "19:07",
					"arrivesAt": "19:15",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "I. L. Caragiale",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "19:16",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "Mija",
					"leavesAt": "19:20",
					"arrivesAt": "19:25",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mija",
					"to": "Adânca PM.",
					"leavesAt": "19:26",
					"arrivesAt": "19:34",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Adânca PM.",
					"to": "Răzvad hc.",
					"leavesAt": "19:35",
					"arrivesAt": "19:43",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Răzvad hc.",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "19:44",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Târgovişte Nord",
					"leavesAt": "19:49",
					"arrivesAt": "19:55",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgovişte Nord",
					"to": "TEIŞ Hm.",
					"leavesAt": "19:56",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "20:00",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "20:03",
					"arrivesAt": "20:07",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20180301",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15095",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "18:37",
					"arrivesAt": "18:47",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Ghergani Hm.",
					"leavesAt": "18:48",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 26500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Titu",
					"leavesAt": "19:28",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Băneşti h.",
					"leavesAt": "19:47",
					"arrivesAt": "19:53",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:57",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "19:58",
					"arrivesAt": "20:01",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "20:13",
					"arrivesAt": "20:21",
					"waitsAtSource": 30,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15090",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Văcăreşti h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:36",
					"waitsAtSource": 0,
					"distance": 7200
				},
				{
					"from": "Văcăreşti h.",
					"to": "Cazaci h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Cazaci h.",
					"to": "Nucet",
					"leavesAt": "07:43",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Nucet",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Băneşti h.",
					"leavesAt": "07:52",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Băneşti h.",
					"to": "Dâmbovicioara h.",
					"leavesAt": "07:56",
					"arrivesAt": "08:02",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Titu",
					"leavesAt": "08:03",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Titu",
					"to": "Ghergani Hm.",
					"leavesAt": "08:12",
					"arrivesAt": "08:22",
					"waitsAtSource": 240,
					"distance": 12100
				},
				{
					"from": "Ghergani Hm.",
					"to": "Chitila",
					"leavesAt": "08:23",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 26500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Nord",
					"leavesAt": "08:44",
					"arrivesAt": "08:56",
					"waitsAtSource": 60,
					"distance": 9400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15171",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "05:30",
					"arrivesAt": "05:38",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Tânganu h.",
					"leavesAt": "05:46",
					"arrivesAt": "05:55",
					"waitsAtSource": 480,
					"distance": 8600
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "05:56",
					"arrivesAt": "05:58",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "05:59",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:06",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "06:07",
					"arrivesAt": "06:09",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "06:10",
					"arrivesAt": "06:13",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "06:14",
					"arrivesAt": "06:18",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "06:19",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:38",
					"waitsAtSource": 480,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "06:39",
					"arrivesAt": "06:41",
					"waitsAtSource": 60,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "06:42",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "06:47",
					"arrivesAt": "06:51",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "06:52",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "06:58",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15091",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Chitila",
					"leavesAt": "10:20",
					"arrivesAt": "10:30",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Chitila",
					"to": "Ghergani Hm.",
					"leavesAt": "10:31",
					"arrivesAt": "11:08",
					"waitsAtSource": 60,
					"distance": 26500
				},
				{
					"from": "Ghergani Hm.",
					"to": "Titu",
					"leavesAt": "11:09",
					"arrivesAt": "11:22",
					"waitsAtSource": 60,
					"distance": 12100
				},
				{
					"from": "Titu",
					"to": "Dâmbovicioara h.",
					"leavesAt": "11:24",
					"arrivesAt": "11:27",
					"waitsAtSource": 120,
					"distance": 2500
				},
				{
					"from": "Dâmbovicioara h.",
					"to": "Băneşti h.",
					"leavesAt": "11:28",
					"arrivesAt": "11:34",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Băneşti h.",
					"to": "Movila Dâmboviţa h.",
					"leavesAt": "11:35",
					"arrivesAt": "11:38",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Movila Dâmboviţa h.",
					"to": "Nucet",
					"leavesAt": "11:39",
					"arrivesAt": "11:42",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Nucet",
					"to": "Cazaci h.",
					"leavesAt": "11:43",
					"arrivesAt": "11:47",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Cazaci h.",
					"to": "Văcăreşti h.",
					"leavesAt": "11:48",
					"arrivesAt": "11:53",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Văcăreşti h.",
					"to": "Târgovişte",
					"leavesAt": "11:54",
					"arrivesAt": "12:02",
					"waitsAtSource": 30,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15134",
			"segments": [
				{
					"from": "Slănic",
					"to": "Prăjani h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:24",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Prăjani h.",
					"to": "Vărbilău hc.",
					"leavesAt": "16:25",
					"arrivesAt": "16:29",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Vărbilău hc.",
					"to": "Vlădeşti h.",
					"leavesAt": "16:30",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vlădeşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:38",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "16:39",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Mălăeşti h.",
					"leavesAt": "16:43",
					"arrivesAt": "16:48",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Mălăeşti h.",
					"to": "Găvănel hc.",
					"leavesAt": "16:49",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Găvănel hc.",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "16:53",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Plopeni",
					"leavesAt": "17:08",
					"arrivesAt": "17:11",
					"waitsAtSource": 600,
					"distance": 2200
				},
				{
					"from": "Plopeni",
					"to": "Găgeni hc.",
					"leavesAt": "17:12",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Găgeni hc.",
					"to": "Buda",
					"leavesAt": "17:17",
					"arrivesAt": "17:26",
					"waitsAtSource": 30,
					"distance": 6800
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "17:32",
					"arrivesAt": "17:39",
					"waitsAtSource": 360,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "17:40",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15105",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "08:11",
					"arrivesAt": "08:16",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "08:17",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "08:27",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "08:32",
					"arrivesAt": "08:36",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Brătăşanca h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Brătăşanca h.",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "08:42",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "I. L. Caragiale",
					"leavesAt": "08:47",
					"arrivesAt": "08:55",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "I. L. Caragiale",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "08:56",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "Mija",
					"leavesAt": "09:00",
					"arrivesAt": "09:05",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Mija",
					"to": "Adânca PM.",
					"leavesAt": "09:06",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Adânca PM.",
					"to": "Răzvad hc.",
					"leavesAt": "09:15",
					"arrivesAt": "09:23",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Răzvad hc.",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "09:24",
					"arrivesAt": "09:28",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Târgovişte Nord",
					"leavesAt": "09:29",
					"arrivesAt": "09:36",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Târgovişte Nord",
					"to": "TEIŞ Hm.",
					"leavesAt": "09:37",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Romlux h.",
					"leavesAt": "09:41",
					"arrivesAt": "09:43",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Romlux h.",
					"to": "Târgovişte",
					"leavesAt": "09:44",
					"arrivesAt": "09:48",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15254",
			"segments": [
				{
					"from": "Costeşti",
					"to": "Colţ h.",
					"leavesAt": "08:15",
					"arrivesAt": "08:46",
					"waitsAtSource": 0,
					"distance": 19300
				},
				{
					"from": "Colţ h.",
					"to": "Miroşi",
					"leavesAt": "08:47",
					"arrivesAt": "08:57",
					"waitsAtSource": 30,
					"distance": 8100
				},
				{
					"from": "Miroşi",
					"to": "Surduleşti h.",
					"leavesAt": "08:58",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Surduleşti h.",
					"to": "Balaci Hm.",
					"leavesAt": "09:05",
					"arrivesAt": "09:10",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Balaci Hm.",
					"to": "Zâmbreasca h.",
					"leavesAt": "09:11",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Beuca h.",
					"leavesAt": "09:19",
					"arrivesAt": "09:23",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Beuca h.",
					"to": "Beuca Sat h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:27",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca Sat h.",
					"to": "Drăcşenei h.",
					"leavesAt": "09:28",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Drăcşenei h.",
					"to": "Roşiori Nord",
					"leavesAt": "09:32",
					"arrivesAt": "09:50",
					"waitsAtSource": 30,
					"distance": 13500
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15114",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:28",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "20:29",
					"arrivesAt": "20:32",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Târgovişte Nord",
					"leavesAt": "20:33",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Târgovişte Nord",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "20:37",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Răzvad hc.",
					"leavesAt": "20:43",
					"arrivesAt": "20:46",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Răzvad hc.",
					"to": "Adânca PM.",
					"leavesAt": "20:47",
					"arrivesAt": "20:55",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Adânca PM.",
					"to": "Mija",
					"leavesAt": "20:56",
					"arrivesAt": "21:06",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Mija",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:11",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "I. L. Caragiale",
					"leavesAt": "21:12",
					"arrivesAt": "21:17",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "21:18",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "Brătăşanca h.",
					"leavesAt": "21:25",
					"arrivesAt": "21:30",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Brătăşanca h.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "21:31",
					"arrivesAt": "21:37",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "21:38",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "21:42",
					"arrivesAt": "21:47",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Ploieşti Vest",
					"leavesAt": "21:48",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "21:59",
					"arrivesAt": "22:05",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20180301",
					"to": "20181208",
					"daysOfWeek": 383
				},
				{
					"from": "20171210",
					"to": "20171231",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15354",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "08:31",
					"arrivesAt": "08:35",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "08:36",
					"arrivesAt": "08:40",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "08:41",
					"arrivesAt": "08:45",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "08:46",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "08:53",
					"arrivesAt": "08:58",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "09:06",
					"arrivesAt": "09:11",
					"waitsAtSource": 480,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "09:12",
					"arrivesAt": "09:15",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "09:16",
					"arrivesAt": "09:19",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "09:20",
					"arrivesAt": "09:23",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "09:24",
					"arrivesAt": "09:33",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "09:34",
					"arrivesAt": "09:39",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "09:40",
					"arrivesAt": "09:44",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "09:45",
					"arrivesAt": "09:51",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "09:52",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "09:57",
					"arrivesAt": "10:02",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "10:03",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "10:08",
					"arrivesAt": "10:11",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "10:12",
					"arrivesAt": "10:18",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "10:19",
					"arrivesAt": "10:24",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "10:25",
					"arrivesAt": "10:31",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "10:32",
					"arrivesAt": "10:42",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 287
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15183",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "15:35",
					"arrivesAt": "15:43",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "15:48",
					"arrivesAt": "15:53",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "15:54",
					"arrivesAt": "15:57",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "15:58",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "16:06",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "16:10",
					"arrivesAt": "16:13",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "16:14",
					"arrivesAt": "16:18",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "16:19",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "16:26",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "16:30",
					"arrivesAt": "16:31",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "16:32",
					"arrivesAt": "16:36",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "16:42",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "16:47",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15177",
			"segments": [
				{
					"from": "Titan Sud Hm.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "10:30",
					"arrivesAt": "10:38",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Căldăraru h.",
					"leavesAt": "10:46",
					"arrivesAt": "10:50",
					"waitsAtSource": 480,
					"distance": 3100
				},
				{
					"from": "Căldăraru h.",
					"to": "Tânganu h.",
					"leavesAt": "10:51",
					"arrivesAt": "10:56",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Tânganu h.",
					"to": "Frunzăneşti h.",
					"leavesAt": "10:57",
					"arrivesAt": "11:00",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "11:01",
					"arrivesAt": "11:04",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Plătăreşti hc.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "11:05",
					"arrivesAt": "11:08",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "11:09",
					"arrivesAt": "11:11",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "11:12",
					"arrivesAt": "11:15",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Vasilaţi hc.",
					"leavesAt": "11:16",
					"arrivesAt": "11:20",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Budeşti Hm.",
					"leavesAt": "11:21",
					"arrivesAt": "11:27",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Budeşti Hm.",
					"to": "Negoieşti h.",
					"leavesAt": "11:35",
					"arrivesAt": "11:39",
					"waitsAtSource": 480,
					"distance": 3400
				},
				{
					"from": "Negoieşti h.",
					"to": "Şoldanu h.",
					"leavesAt": "11:40",
					"arrivesAt": "11:41",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Şoldanu h.",
					"to": "Luica h.",
					"leavesAt": "11:42",
					"arrivesAt": "11:46",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Luica h.",
					"to": "Curcani h.",
					"leavesAt": "11:47",
					"arrivesAt": "11:50",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Curcani h.",
					"to": "Valea Roşie hc.",
					"leavesAt": "11:51",
					"arrivesAt": "11:56",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Olteniţa",
					"leavesAt": "11:57",
					"arrivesAt": "12:09",
					"waitsAtSource": 30,
					"distance": 9900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 319
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15153",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "19:34",
					"arrivesAt": "19:38",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Nord",
					"leavesAt": "19:39",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploieşti Nord",
					"to": "Blejoi",
					"leavesAt": "19:45",
					"arrivesAt": "19:50",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Blejoi",
					"to": "Scăieni h.",
					"leavesAt": "19:51",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Scăieni h.",
					"to": "Boldeşti hc.",
					"leavesAt": "19:56",
					"arrivesAt": "19:58",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Boldeşti hc.",
					"to": "Lipăneşti hc.",
					"leavesAt": "19:59",
					"arrivesAt": "20:03",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Măgurele Sud h.",
					"leavesAt": "20:04",
					"arrivesAt": "20:07",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "20:08",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Nord h.",
					"leavesAt": "20:13",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Făget Teleajen",
					"leavesAt": "20:18",
					"arrivesAt": "20:21",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Făget Teleajen",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Vălenii de Munte",
					"leavesAt": "20:27",
					"arrivesAt": "20:31",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vălenii de Munte",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "20:32",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Teişani Hm.",
					"leavesAt": "20:38",
					"arrivesAt": "20:44",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Teişani Hm.",
					"to": "Homorâciu P.M.",
					"leavesAt": "20:45",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Izvoarele hc.",
					"leavesAt": "20:52",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "20:58",
					"arrivesAt": "21:01",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Măneciu",
					"leavesAt": "21:02",
					"arrivesAt": "21:07",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15308",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Griviţa h.",
					"leavesAt": "09:08",
					"arrivesAt": "09:15",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Griviţa h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "09:16",
					"arrivesAt": "09:20",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Lungeşti h.",
					"leavesAt": "09:21",
					"arrivesAt": "09:27",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lungeşti h.",
					"to": "Docăneasa hc.",
					"leavesAt": "09:28",
					"arrivesAt": "09:31",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Docăneasa hc.",
					"to": "Tălăşmani h.",
					"leavesAt": "09:32",
					"arrivesAt": "09:38",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Tălăşmani h.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:47",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Bereşti Hm.",
					"leavesAt": "09:48",
					"arrivesAt": "09:52",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "10:01",
					"arrivesAt": "10:09",
					"waitsAtSource": 540,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "10:10",
					"arrivesAt": "10:18",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "10:19",
					"arrivesAt": "10:25",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "10:26",
					"arrivesAt": "10:31",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Târgu Bujor",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "10:32",
					"arrivesAt": "10:35",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Băleni h.",
					"leavesAt": "10:36",
					"arrivesAt": "10:41",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Băleni h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "10:42",
					"arrivesAt": "10:46",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Chiraftei h.",
					"leavesAt": "10:47",
					"arrivesAt": "10:51",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Chiraftei h.",
					"to": "Folteşti Hm.",
					"leavesAt": "10:52",
					"arrivesAt": "11:00",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Folteşti Hm.",
					"to": "Stoicani h.",
					"leavesAt": "11:01",
					"arrivesAt": "11:07",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Stoicani h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "11:08",
					"arrivesAt": "11:14",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Şiviţa h.",
					"leavesAt": "11:15",
					"arrivesAt": "11:21",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Tuluceşti Hm.",
					"leavesAt": "11:22",
					"arrivesAt": "11:28",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Galaţi",
					"leavesAt": "11:29",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 13600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15321",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Tuluceşti Hm.",
					"leavesAt": "19:40",
					"arrivesAt": "20:04",
					"waitsAtSource": 0,
					"distance": 13600
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Şiviţa h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:18",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Stoicani h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stoicani h.",
					"to": "Folteşti Hm.",
					"leavesAt": "20:25",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Folteşti Hm.",
					"to": "Chiraftei h.",
					"leavesAt": "20:31",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Chiraftei h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:42",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Băleni h.",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Băleni h.",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "20:48",
					"arrivesAt": "20:53",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Târgu Bujor",
					"leavesAt": "20:54",
					"arrivesAt": "20:57",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Târgu Bujor",
					"to": "Moscu hc.",
					"leavesAt": "20:58",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moscu hc.",
					"to": "Roşcani h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:10",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Roşcani h.",
					"to": "Balinteşti h.",
					"leavesAt": "21:11",
					"arrivesAt": "21:19",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Balinteşti h.",
					"to": "Bereşti Hm.",
					"leavesAt": "21:20",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 7200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15100",
			"segments": [
				{
					"from": "Târgovişte",
					"to": "Romlux h.",
					"leavesAt": "04:05",
					"arrivesAt": "04:08",
					"waitsAtSource": 0,
					"distance": 2100
				},
				{
					"from": "Romlux h.",
					"to": "TEIŞ Hm.",
					"leavesAt": "04:09",
					"arrivesAt": "04:12",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "TEIŞ Hm.",
					"to": "Târgovişte Nord",
					"leavesAt": "04:13",
					"arrivesAt": "04:16",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Târgovişte Nord",
					"to": "Valea Voievozilor hc.",
					"leavesAt": "04:17",
					"arrivesAt": "04:22",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Valea Voievozilor hc.",
					"to": "Răzvad hc.",
					"leavesAt": "04:23",
					"arrivesAt": "04:26",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Răzvad hc.",
					"to": "Adânca PM.",
					"leavesAt": "04:27",
					"arrivesAt": "04:35",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Adânca PM.",
					"to": "Mija",
					"leavesAt": "04:36",
					"arrivesAt": "04:46",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Mija",
					"to": "I. L. Caragiale Vest h.",
					"leavesAt": "04:47",
					"arrivesAt": "04:51",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "I. L. Caragiale Vest h.",
					"to": "I. L. Caragiale",
					"leavesAt": "04:52",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "I. L. Caragiale",
					"to": "P. mac. Zalhanaua",
					"leavesAt": "05:05",
					"arrivesAt": "05:11",
					"waitsAtSource": 480,
					"distance": 5000
				},
				{
					"from": "P. mac. Zalhanaua",
					"to": "Brătăşanca h.",
					"leavesAt": "05:12",
					"arrivesAt": "05:16",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Brătăşanca h.",
					"to": "Târgşoru Nou Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:23",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Târgşoru Nou Hm.",
					"to": "Crângu Lui Tei hc.",
					"leavesAt": "05:24",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Crângu Lui Tei hc.",
					"to": "Crângu Lui Bot Hm.",
					"leavesAt": "05:28",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Crângu Lui Bot Hm.",
					"to": "Ploieşti Vest",
					"leavesAt": "05:34",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "05:45",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15250",
			"segments": [
				{
					"from": "Miroşi",
					"to": "Surduleşti h.",
					"leavesAt": "04:18",
					"arrivesAt": "04:24",
					"waitsAtSource": 0,
					"distance": 4700
				},
				{
					"from": "Surduleşti h.",
					"to": "Balaci Hm.",
					"leavesAt": "04:25",
					"arrivesAt": "04:30",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Balaci Hm.",
					"to": "Zâmbreasca h.",
					"leavesAt": "04:50",
					"arrivesAt": "04:57",
					"waitsAtSource": 1200,
					"distance": 5900
				},
				{
					"from": "Zâmbreasca h.",
					"to": "Beuca h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:02",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Beuca h.",
					"to": "Beuca Sat h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:06",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Beuca Sat h.",
					"to": "Drăcşenei h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Drăcşenei h.",
					"to": "Roşiori Nord",
					"leavesAt": "05:12",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 13500
				}
			],
			"restrictions": [
				{
					"from": "20170515",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15349",
			"segments": [
				{
					"from": "Buzău",
					"to": "Verneşti",
					"leavesAt": "05:05",
					"arrivesAt": "05:20",
					"waitsAtSource": 0,
					"distance": 12400
				},
				{
					"from": "Verneşti",
					"to": "Cândeşti hc.",
					"leavesAt": "05:21",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Cândeşti hc.",
					"to": "Berca Hm.",
					"leavesAt": "05:29",
					"arrivesAt": "05:35",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Berca Hm.",
					"to": "Ojasca h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ojasca h.",
					"to": "Unguriu hc.",
					"leavesAt": "05:41",
					"arrivesAt": "05:46",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Unguriu hc.",
					"to": "Măgura hcv.",
					"leavesAt": "05:47",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Măgura hcv.",
					"to": "Pârscov",
					"leavesAt": "05:53",
					"arrivesAt": "05:58",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pârscov",
					"to": "Bădila h.",
					"leavesAt": "06:30",
					"arrivesAt": "06:37",
					"waitsAtSource": 1920,
					"distance": 4300
				},
				{
					"from": "Bădila h.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "06:38",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Vipereşti hc.",
					"leavesAt": "06:44",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vipereşti hc.",
					"to": "Cislău hcv.",
					"leavesAt": "06:50",
					"arrivesAt": "07:00",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cislău hcv.",
					"to": "Gura Bascii h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:04",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Gura Bascii h.",
					"to": "Valea Seacă h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:09",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Valea Seacă h.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "07:10",
					"arrivesAt": "07:13",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "07:14",
					"arrivesAt": "07:21",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "07:22",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Şeţu h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:33",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şeţu h.",
					"to": "Păltineni h.",
					"leavesAt": "07:34",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Păltineni h.",
					"to": "Nehoiu h.",
					"leavesAt": "07:38",
					"arrivesAt": "07:42",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Nehoiu h.",
					"to": "Nehoiaşu",
					"leavesAt": "07:43",
					"arrivesAt": "07:47",
					"waitsAtSource": 30,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15319",
			"segments": [
				{
					"from": "Galaţi",
					"to": "Tuluceşti Hm.",
					"leavesAt": "20:20",
					"arrivesAt": "20:44",
					"waitsAtSource": 0,
					"distance": 13600
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Şiviţa h.",
					"leavesAt": "20:45",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:58",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Stoicani h.",
					"leavesAt": "20:59",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stoicani h.",
					"to": "Folteşti Hm.",
					"leavesAt": "21:06",
					"arrivesAt": "21:11",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Folteşti Hm.",
					"to": "Chiraftei h.",
					"leavesAt": "21:12",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Chiraftei h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "21:19",
					"arrivesAt": "21:23",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Băleni h.",
					"leavesAt": "21:24",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Băleni h.",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "21:29",
					"arrivesAt": "21:34",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Târgu Bujor",
					"leavesAt": "21:35",
					"arrivesAt": "21:38",
					"waitsAtSource": 30,
					"distance": 2100
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15353",
			"segments": [
				{
					"from": "Buzău",
					"to": "Buzău Nord Hm.",
					"leavesAt": "09:36",
					"arrivesAt": "09:46",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Verneşti",
					"leavesAt": "09:47",
					"arrivesAt": "09:53",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Verneşti",
					"to": "Cândeşti hc.",
					"leavesAt": "09:54",
					"arrivesAt": "10:00",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Cândeşti hc.",
					"to": "Berca Hm.",
					"leavesAt": "10:01",
					"arrivesAt": "10:07",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Berca Hm.",
					"to": "Ojasca h.",
					"leavesAt": "10:15",
					"arrivesAt": "10:18",
					"waitsAtSource": 480,
					"distance": 2200
				},
				{
					"from": "Ojasca h.",
					"to": "Unguriu hc.",
					"leavesAt": "10:19",
					"arrivesAt": "10:23",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Unguriu hc.",
					"to": "Măgura hcv.",
					"leavesAt": "10:24",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Măgura hcv.",
					"to": "Pârscov",
					"leavesAt": "10:29",
					"arrivesAt": "10:34",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pârscov",
					"to": "Bădila h.",
					"leavesAt": "10:35",
					"arrivesAt": "10:41",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bădila h.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "10:42",
					"arrivesAt": "10:46",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Vipereşti hc.",
					"leavesAt": "10:47",
					"arrivesAt": "10:52",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vipereşti hc.",
					"to": "Cislău hcv.",
					"leavesAt": "10:53",
					"arrivesAt": "11:02",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cislău hcv.",
					"to": "Gura Bascii h.",
					"leavesAt": "11:03",
					"arrivesAt": "11:06",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Gura Bascii h.",
					"to": "Valea Seacă h.",
					"leavesAt": "11:07",
					"arrivesAt": "11:10",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Valea Seacă h.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "11:11",
					"arrivesAt": "11:14",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "11:15",
					"arrivesAt": "11:21",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "11:22",
					"arrivesAt": "11:26",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Şeţu h.",
					"leavesAt": "11:27",
					"arrivesAt": "11:33",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şeţu h.",
					"to": "Păltineni h.",
					"leavesAt": "11:34",
					"arrivesAt": "11:37",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Păltineni h.",
					"to": "Nehoiu h.",
					"leavesAt": "11:38",
					"arrivesAt": "11:42",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Nehoiu h.",
					"to": "Nehoiaşu",
					"leavesAt": "11:43",
					"arrivesAt": "11:47",
					"waitsAtSource": 30,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15356",
			"segments": [
				{
					"from": "Nehoiaşu",
					"to": "Nehoiu h.",
					"leavesAt": "10:48",
					"arrivesAt": "10:52",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "Nehoiu h.",
					"to": "Păltineni h.",
					"leavesAt": "10:53",
					"arrivesAt": "10:57",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Păltineni h.",
					"to": "Şeţu h.",
					"leavesAt": "10:58",
					"arrivesAt": "11:01",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Şeţu h.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "11:02",
					"arrivesAt": "11:08",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "11:09",
					"arrivesAt": "11:14",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "11:24",
					"arrivesAt": "11:30",
					"waitsAtSource": 600,
					"distance": 4000
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Valea Seacă h.",
					"leavesAt": "11:31",
					"arrivesAt": "11:34",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Valea Seacă h.",
					"to": "Gura Bascii h.",
					"leavesAt": "11:35",
					"arrivesAt": "11:38",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Gura Bascii h.",
					"to": "Cislău hcv.",
					"leavesAt": "11:39",
					"arrivesAt": "11:42",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Cislău hcv.",
					"to": "Vipereşti hc.",
					"leavesAt": "11:43",
					"arrivesAt": "11:52",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Vipereşti hc.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "11:53",
					"arrivesAt": "11:58",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Bădila h.",
					"leavesAt": "11:59",
					"arrivesAt": "12:03",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Bădila h.",
					"to": "Pârscov",
					"leavesAt": "12:04",
					"arrivesAt": "12:10",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pârscov",
					"to": "Măgura hcv.",
					"leavesAt": "12:11",
					"arrivesAt": "12:16",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Măgura hcv.",
					"to": "Unguriu hc.",
					"leavesAt": "12:17",
					"arrivesAt": "12:22",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Unguriu hc.",
					"to": "Ojasca h.",
					"leavesAt": "12:23",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Ojasca h.",
					"to": "Berca Hm.",
					"leavesAt": "12:28",
					"arrivesAt": "12:32",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Berca Hm.",
					"to": "Cândeşti hc.",
					"leavesAt": "12:33",
					"arrivesAt": "12:38",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Cândeşti hc.",
					"to": "Verneşti",
					"leavesAt": "12:39",
					"arrivesAt": "12:46",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Verneşti",
					"to": "Buzău Nord Hm.",
					"leavesAt": "12:47",
					"arrivesAt": "12:53",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Buzău",
					"leavesAt": "12:54",
					"arrivesAt": "13:04",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15156",
			"segments": [
				{
					"from": "Măneciu",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "17:25",
					"arrivesAt": "17:29",
					"waitsAtSource": 0,
					"distance": 2700
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Izvoarele hc.",
					"leavesAt": "17:30",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Homorâciu P.M.",
					"leavesAt": "17:33",
					"arrivesAt": "17:39",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Teişani Hm.",
					"leavesAt": "17:40",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Teişani Hm.",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "17:45",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Vălenii de Munte",
					"leavesAt": "17:50",
					"arrivesAt": "17:54",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Vălenii de Munte",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "17:55",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Făget Teleajen",
					"leavesAt": "17:59",
					"arrivesAt": "18:03",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Făget Teleajen",
					"to": "Măgurele Nord h.",
					"leavesAt": "18:12",
					"arrivesAt": "18:14",
					"waitsAtSource": 540,
					"distance": 1700
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "18:15",
					"arrivesAt": "18:19",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Sud h.",
					"leavesAt": "18:20",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Lipăneşti hc.",
					"leavesAt": "18:23",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Boldeşti hc.",
					"leavesAt": "18:27",
					"arrivesAt": "18:31",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Boldeşti hc.",
					"to": "Scăieni h.",
					"leavesAt": "18:32",
					"arrivesAt": "18:33",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Scăieni h.",
					"to": "Blejoi",
					"leavesAt": "18:34",
					"arrivesAt": "18:39",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Blejoi",
					"to": "Ploieşti Nord",
					"leavesAt": "18:40",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Ploieşti Nord",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "18:46",
					"arrivesAt": "18:50",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Sud",
					"leavesAt": "18:51",
					"arrivesAt": "18:56",
					"waitsAtSource": 60,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 351
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15003",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Periş",
					"leavesAt": "17:22",
					"arrivesAt": "17:46",
					"waitsAtSource": 0,
					"distance": 30200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "17:59",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Vest",
					"leavesAt": "18:11",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "18:24",
					"arrivesAt": "18:29",
					"waitsAtSource": 360,
					"distance": 3000
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Est",
					"leavesAt": "18:33",
					"arrivesAt": "18:39",
					"waitsAtSource": 240,
					"distance": 4300
				},
				{
					"from": "Ploieşti Est",
					"to": "Muru hc.",
					"leavesAt": "18:40",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 10100
				},
				{
					"from": "Muru hc.",
					"to": "Cricov Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "18:55",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Cricov Hm.",
					"to": "Tomşani hc.",
					"leavesAt": "18:56",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Tomşani hc.",
					"to": "Mizil",
					"leavesAt": "19:02",
					"arrivesAt": "19:14",
					"waitsAtSource": 30,
					"distance": 12100
				},
				{
					"from": "Mizil",
					"to": "Săhăteni Hm.",
					"leavesAt": "19:15",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Săhăteni Hm.",
					"to": "Ulmeni",
					"leavesAt": "19:27",
					"arrivesAt": "19:38",
					"waitsAtSource": 60,
					"distance": 12000
				},
				{
					"from": "Ulmeni",
					"to": "Buzău",
					"leavesAt": "19:39",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 15400
				},
				{
					"from": "Buzău",
					"to": "Buzău Nord Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:27",
					"waitsAtSource": 1260,
					"distance": 6900
				},
				{
					"from": "Buzău Nord Hm.",
					"to": "Verneşti",
					"leavesAt": "20:28",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Verneşti",
					"to": "Cândeşti hc.",
					"leavesAt": "20:36",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Cândeşti hc.",
					"to": "Berca Hm.",
					"leavesAt": "20:43",
					"arrivesAt": "20:49",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Berca Hm.",
					"to": "Ojasca h.",
					"leavesAt": "20:50",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ojasca h.",
					"to": "Unguriu hc.",
					"leavesAt": "20:54",
					"arrivesAt": "20:58",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Unguriu hc.",
					"to": "Măgura hcv.",
					"leavesAt": "20:59",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Măgura hcv.",
					"to": "Pârscov",
					"leavesAt": "21:05",
					"arrivesAt": "21:10",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Pârscov",
					"to": "Bădila h.",
					"leavesAt": "21:20",
					"arrivesAt": "21:26",
					"waitsAtSource": 600,
					"distance": 4300
				},
				{
					"from": "Bădila h.",
					"to": "Ruşavăţu hc.",
					"leavesAt": "21:27",
					"arrivesAt": "21:31",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Ruşavăţu hc.",
					"to": "Vipereşti hc.",
					"leavesAt": "21:32",
					"arrivesAt": "21:37",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Vipereşti hc.",
					"to": "Cislău hcv.",
					"leavesAt": "21:38",
					"arrivesAt": "21:47",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Cislău hcv.",
					"to": "Gura Bascii h.",
					"leavesAt": "21:48",
					"arrivesAt": "21:51",
					"waitsAtSource": 30,
					"distance": 1780
				},
				{
					"from": "Gura Bascii h.",
					"to": "Valea Seacă h.",
					"leavesAt": "21:52",
					"arrivesAt": "21:55",
					"waitsAtSource": 30,
					"distance": 2120
				},
				{
					"from": "Valea Seacă h.",
					"to": "Mărunţişu hcv.",
					"leavesAt": "21:56",
					"arrivesAt": "21:59",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Mărunţişu hcv.",
					"to": "Pătârlagele Hm.",
					"leavesAt": "22:00",
					"arrivesAt": "22:06",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Pătârlagele Hm.",
					"to": "Valea Sibiciului h.",
					"leavesAt": "22:07",
					"arrivesAt": "22:11",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Valea Sibiciului h.",
					"to": "Şeţu h.",
					"leavesAt": "22:12",
					"arrivesAt": "22:18",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şeţu h.",
					"to": "Păltineni h.",
					"leavesAt": "22:19",
					"arrivesAt": "22:23",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Păltineni h.",
					"to": "Nehoiu h.",
					"leavesAt": "22:24",
					"arrivesAt": "22:28",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Nehoiu h.",
					"to": "Nehoiaşu",
					"leavesAt": "22:29",
					"arrivesAt": "22:33",
					"waitsAtSource": 30,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15123",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "08:02",
					"arrivesAt": "08:07",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "08:08",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Găgeni hc.",
					"leavesAt": "08:16",
					"arrivesAt": "08:24",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Găgeni hc.",
					"to": "Plopeni",
					"leavesAt": "08:25",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "08:30",
					"arrivesAt": "08:34",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Găvănel hc.",
					"leavesAt": "08:42",
					"arrivesAt": "08:46",
					"waitsAtSource": 480,
					"distance": 2700
				},
				{
					"from": "Găvănel hc.",
					"to": "Mălăeşti h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:50",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mălăeşti h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Vlădeşti h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Vlădeşti h.",
					"to": "Vărbilău hc.",
					"leavesAt": "09:06",
					"arrivesAt": "09:09",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vărbilău hc.",
					"to": "Prăjani h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:14",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Prăjani h.",
					"to": "Slănic",
					"leavesAt": "09:15",
					"arrivesAt": "09:20",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15131",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "16:37",
					"arrivesAt": "16:45",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Găgeni hc.",
					"leavesAt": "16:46",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 6800
				},
				{
					"from": "Găgeni hc.",
					"to": "Plopeni",
					"leavesAt": "16:55",
					"arrivesAt": "16:59",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Plopeni",
					"to": "Plopeni Sat Hm.",
					"leavesAt": "17:00",
					"arrivesAt": "17:04",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Plopeni Sat Hm.",
					"to": "Găvănel hc.",
					"leavesAt": "17:05",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Găvănel hc.",
					"to": "Mălăeşti h.",
					"leavesAt": "17:10",
					"arrivesAt": "17:13",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Mălăeşti h.",
					"to": "Coţofeneşti h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:19",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Coţofeneşti h.",
					"to": "Poiana Slănic h.",
					"leavesAt": "17:20",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Poiana Slănic h.",
					"to": "Vlădeşti h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Vlădeşti h.",
					"to": "Vărbilău hc.",
					"leavesAt": "17:29",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vărbilău hc.",
					"to": "Prăjani h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:37",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Prăjani h.",
					"to": "Slănic",
					"leavesAt": "17:38",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "TFC",
			"number": "15053",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Periş",
					"leavesAt": "12:40",
					"arrivesAt": "13:03",
					"waitsAtSource": 0,
					"distance": 30200
				},
				{
					"from": "Periş",
					"to": "Crivina",
					"leavesAt": "13:04",
					"arrivesAt": "13:12",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "13:13",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Sud",
					"leavesAt": "13:26",
					"arrivesAt": "13:40",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "13:41",
					"arrivesAt": "14:14",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "14:15",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 35000
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15157",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Ploiesti Est Post 1",
					"leavesAt": "21:17",
					"arrivesAt": "21:21",
					"waitsAtSource": 0,
					"distance": 3200
				},
				{
					"from": "Ploiesti Est Post 1",
					"to": "Ploieşti Nord",
					"leavesAt": "21:22",
					"arrivesAt": "21:27",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Ploieşti Nord",
					"to": "Blejoi",
					"leavesAt": "21:28",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Blejoi",
					"to": "Scăieni h.",
					"leavesAt": "21:36",
					"arrivesAt": "21:40",
					"waitsAtSource": 180,
					"distance": 3800
				},
				{
					"from": "Scăieni h.",
					"to": "Boldeşti hc.",
					"leavesAt": "21:41",
					"arrivesAt": "21:43",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Boldeşti hc.",
					"to": "Lipăneşti hc.",
					"leavesAt": "21:44",
					"arrivesAt": "21:48",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lipăneşti hc.",
					"to": "Măgurele Sud h.",
					"leavesAt": "21:49",
					"arrivesAt": "21:52",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Măgurele Sud h.",
					"to": "Măgurele Prahova h.",
					"leavesAt": "21:53",
					"arrivesAt": "21:57",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Măgurele Prahova h.",
					"to": "Măgurele Nord h.",
					"leavesAt": "21:58",
					"arrivesAt": "22:02",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Măgurele Nord h.",
					"to": "Făget Teleajen",
					"leavesAt": "22:03",
					"arrivesAt": "22:06",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Făget Teleajen",
					"to": "PO Gura Vitioarei h.",
					"leavesAt": "22:07",
					"arrivesAt": "22:11",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "PO Gura Vitioarei h.",
					"to": "Vălenii de Munte",
					"leavesAt": "22:12",
					"arrivesAt": "22:16",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Vălenii de Munte",
					"to": "P.mac. Văleni Nord",
					"leavesAt": "22:17",
					"arrivesAt": "22:22",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "P.mac. Văleni Nord",
					"to": "Teişani Hm.",
					"leavesAt": "22:23",
					"arrivesAt": "22:29",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Teişani Hm.",
					"to": "Homorâciu P.M.",
					"leavesAt": "22:30",
					"arrivesAt": "22:36",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Homorâciu P.M.",
					"to": "Izvoarele hc.",
					"leavesAt": "22:37",
					"arrivesAt": "22:42",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Izvoarele hc.",
					"to": "Măneciu Pamânteni hc.",
					"leavesAt": "22:43",
					"arrivesAt": "22:46",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Măneciu Pamânteni hc.",
					"to": "Măneciu",
					"leavesAt": "22:47",
					"arrivesAt": "22:52",
					"waitsAtSource": 30,
					"distance": 2700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15174",
			"segments": [
				{
					"from": "Olteniţa",
					"to": "Valea Roşie hc.",
					"leavesAt": "05:54",
					"arrivesAt": "06:05",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Curcani h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:11",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Curcani h.",
					"to": "Luica h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Luica h.",
					"to": "Şoldanu h.",
					"leavesAt": "06:16",
					"arrivesAt": "06:20",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şoldanu h.",
					"to": "Negoieşti h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Negoieşti h.",
					"to": "Budeşti Hm.",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Budeşti Hm.",
					"to": "Vasilaţi hc.",
					"leavesAt": "06:30",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "06:36",
					"arrivesAt": "06:39",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "06:44",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "06:48",
					"arrivesAt": "06:51",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plătăreşti hc.",
					"to": "Frunzăneşti h.",
					"leavesAt": "06:52",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Tânganu h.",
					"leavesAt": "06:57",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Tânganu h.",
					"to": "Căldăraru h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Căldăraru h.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "07:07",
					"arrivesAt": "07:12",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Titan Sud Hm.",
					"leavesAt": "07:13",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15316",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Griviţa h.",
					"leavesAt": "19:18",
					"arrivesAt": "19:25",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Griviţa h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "19:26",
					"arrivesAt": "19:30",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Lungeşti h.",
					"leavesAt": "19:31",
					"arrivesAt": "19:37",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lungeşti h.",
					"to": "Docăneasa hc.",
					"leavesAt": "19:38",
					"arrivesAt": "19:41",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Docăneasa hc.",
					"to": "Tălăşmani h.",
					"leavesAt": "19:42",
					"arrivesAt": "19:48",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Tălăşmani h.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "19:49",
					"arrivesAt": "19:57",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Bereşti Hm.",
					"leavesAt": "19:58",
					"arrivesAt": "20:02",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "20:03",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:20",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "20:21",
					"arrivesAt": "20:27",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "20:28",
					"arrivesAt": "20:33",
					"waitsAtSource": 30,
					"distance": 3200
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15186",
			"segments": [
				{
					"from": "Olteniţa",
					"to": "Valea Roşie hc.",
					"leavesAt": "17:09",
					"arrivesAt": "17:21",
					"waitsAtSource": 0,
					"distance": 9900
				},
				{
					"from": "Valea Roşie hc.",
					"to": "Curcani h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Curcani h.",
					"to": "Luica h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:31",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Luica h.",
					"to": "Şoldanu h.",
					"leavesAt": "17:32",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Şoldanu h.",
					"to": "Negoieşti h.",
					"leavesAt": "17:36",
					"arrivesAt": "17:38",
					"waitsAtSource": 30,
					"distance": 1100
				},
				{
					"from": "Negoieşti h.",
					"to": "Budeşti Hm.",
					"leavesAt": "17:39",
					"arrivesAt": "17:43",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Budeşti Hm.",
					"to": "Vasilaţi hc.",
					"leavesAt": "17:44",
					"arrivesAt": "17:49",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Vasilaţi hc.",
					"to": "Gălbinaşi hc.",
					"leavesAt": "17:50",
					"arrivesAt": "17:54",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Gălbinaşi hc.",
					"to": "Cucuieţi Sudiţi h.",
					"leavesAt": "17:55",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Cucuieţi Sudiţi h.",
					"to": "PO Podu Pitarului h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:01",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "PO Podu Pitarului h.",
					"to": "Plătăreşti hc.",
					"leavesAt": "18:02",
					"arrivesAt": "18:05",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Plătăreşti hc.",
					"to": "Frunzăneşti h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:10",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Frunzăneşti h.",
					"to": "Tânganu h.",
					"leavesAt": "18:11",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Tânganu h.",
					"to": "Căldăraru h.",
					"leavesAt": "18:14",
					"arrivesAt": "18:20",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Căldăraru h.",
					"to": "Buc. Sud Gr. Călători",
					"leavesAt": "18:21",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Buc. Sud Gr. Călători",
					"to": "Titan Sud Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "TFC",
			"number": "15310",
			"segments": [
				{
					"from": "Bârlad",
					"to": "Griviţa h.",
					"leavesAt": "11:14",
					"arrivesAt": "11:21",
					"waitsAtSource": 0,
					"distance": 7100
				},
				{
					"from": "Griviţa h.",
					"to": "Bălăbăneşti h.",
					"leavesAt": "11:22",
					"arrivesAt": "11:26",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bălăbăneşti h.",
					"to": "Lungeşti h.",
					"leavesAt": "11:27",
					"arrivesAt": "11:33",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Lungeşti h.",
					"to": "Docăneasa hc.",
					"leavesAt": "11:34",
					"arrivesAt": "11:37",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Docăneasa hc.",
					"to": "Tălăşmani h.",
					"leavesAt": "11:38",
					"arrivesAt": "11:44",
					"waitsAtSource": 30,
					"distance": 5000
				},
				{
					"from": "Tălăşmani h.",
					"to": "Bereşti Tunel h.",
					"leavesAt": "11:45",
					"arrivesAt": "11:53",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Bereşti Tunel h.",
					"to": "Bereşti Hm.",
					"leavesAt": "11:54",
					"arrivesAt": "11:58",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Bereşti Hm.",
					"to": "Balinteşti h.",
					"leavesAt": "12:06",
					"arrivesAt": "12:14",
					"waitsAtSource": 480,
					"distance": 7200
				},
				{
					"from": "Balinteşti h.",
					"to": "Roşcani h.",
					"leavesAt": "12:15",
					"arrivesAt": "12:23",
					"waitsAtSource": 30,
					"distance": 7900
				},
				{
					"from": "Roşcani h.",
					"to": "Moscu hc.",
					"leavesAt": "12:24",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Moscu hc.",
					"to": "Târgu Bujor",
					"leavesAt": "12:31",
					"arrivesAt": "12:36",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Târgu Bujor",
					"to": "Umbrăreşti Sat h.",
					"leavesAt": "12:37",
					"arrivesAt": "12:40",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Umbrăreşti Sat h.",
					"to": "Băleni h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:46",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Băleni h.",
					"to": "Fârţăneşti h.",
					"leavesAt": "12:47",
					"arrivesAt": "12:51",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Fârţăneşti h.",
					"to": "Chiraftei h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:56",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Chiraftei h.",
					"to": "Folteşti Hm.",
					"leavesAt": "12:57",
					"arrivesAt": "13:04",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Folteşti Hm.",
					"to": "Stoicani h.",
					"leavesAt": "13:05",
					"arrivesAt": "13:11",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Stoicani h.",
					"to": "Frumuşiţa h.",
					"leavesAt": "13:12",
					"arrivesAt": "13:18",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Frumuşiţa h.",
					"to": "Şiviţa h.",
					"leavesAt": "13:19",
					"arrivesAt": "13:25",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Şiviţa h.",
					"to": "Tuluceşti Hm.",
					"leavesAt": "13:26",
					"arrivesAt": "13:33",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tuluceşti Hm.",
					"to": "Galaţi",
					"leavesAt": "13:34",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 13600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "SFT",
			"number": "15982",
			"segments": [
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "06:50",
					"arrivesAt": "07:30",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Roşiori Nord",
					"leavesAt": "07:32",
					"arrivesAt": "08:16",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "08:18",
					"arrivesAt": "09:02",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "09:03",
					"arrivesAt": "09:54",
					"waitsAtSource": 60,
					"distance": 50900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ciulniţa",
					"leavesAt": "10:20",
					"arrivesAt": "11:13",
					"waitsAtSource": 1560,
					"distance": 108900
				},
				{
					"from": "Ciulniţa",
					"to": "Feteşti",
					"leavesAt": "11:14",
					"arrivesAt": "11:33",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Feteşti",
					"to": "Cernavodă Pod",
					"leavesAt": "11:35",
					"arrivesAt": "11:53",
					"waitsAtSource": 120,
					"distance": 20000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Medgidia",
					"leavesAt": "11:54",
					"arrivesAt": "12:09",
					"waitsAtSource": 60,
					"distance": 24000
				},
				{
					"from": "Medgidia",
					"to": "Constanţa",
					"leavesAt": "12:10",
					"arrivesAt": "12:33",
					"waitsAtSource": 60,
					"distance": 34600
				}
			],
			"restrictions": [
				{
					"from": "20180420",
					"to": "20180915",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "SFT",
			"number": "15939",
			"segments": [
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "16:10",
					"arrivesAt": "16:50",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Roşiori Nord",
					"leavesAt": "16:52",
					"arrivesAt": "17:36",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "17:38",
					"arrivesAt": "18:22",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "18:23",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 50900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "19:38",
					"arrivesAt": "20:17",
					"waitsAtSource": 1440,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "20:19",
					"arrivesAt": "20:43",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "20:44",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "21:08",
					"arrivesAt": "21:16",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "21:17",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "21:23",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "21:34",
					"arrivesAt": "22:12",
					"waitsAtSource": 120,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20180901",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "SFT",
			"number": "15994",
			"segments": [
				{
					"from": "Motru Est Gr. Călători",
					"to": "Motru Est",
					"leavesAt": "19:40",
					"arrivesAt": "19:47",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Motru Est",
					"to": "Samarineşti h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Samarineşti h.",
					"to": "Corcova h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:57",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Corcova h.",
					"to": "Ceramica h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:02",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ceramica h.",
					"to": "Jirov Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:14",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Jirov Hm.",
					"to": "Cernaia h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cernaia h.",
					"to": "Comanda h.",
					"leavesAt": "20:20",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comanda h.",
					"to": "Strehaia Nord h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:29",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Strehaia Nord h.",
					"to": "Strehaia",
					"leavesAt": "20:30",
					"arrivesAt": "20:34",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Strehaia",
					"to": "Lunca Banului h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:39",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Lunca Banului h.",
					"to": "Butoieşti Hm.",
					"leavesAt": "20:40",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Gura Motrului Hm.",
					"leavesAt": "20:48",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Filiaşi",
					"leavesAt": "20:56",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "21:05",
					"arrivesAt": "21:08",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "21:09",
					"arrivesAt": "21:13",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "21:14",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "21:19",
					"arrivesAt": "21:24",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "21:25",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "21:29",
					"arrivesAt": "21:34",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "21:35",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "21:38",
					"arrivesAt": "21:42",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "21:43",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "21:47",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "SFT",
			"number": "15931",
			"segments": [
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "05:55",
					"arrivesAt": "06:34",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Roşiori Nord",
					"leavesAt": "06:35",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 55300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "07:21",
					"arrivesAt": "08:05",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "08:25",
					"arrivesAt": "09:16",
					"waitsAtSource": 1200,
					"distance": 50900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "09:28",
					"arrivesAt": "10:05",
					"waitsAtSource": 720,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "10:06",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "10:29",
					"arrivesAt": "10:51",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "10:52",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "11:00",
					"arrivesAt": "11:05",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "11:06",
					"arrivesAt": "11:15",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "11:17",
					"arrivesAt": "11:55",
					"waitsAtSource": 120,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20180331",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "SFT",
			"number": "15984",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Medgidia",
					"leavesAt": "16:00",
					"arrivesAt": "16:23",
					"waitsAtSource": 0,
					"distance": 34600
				},
				{
					"from": "Medgidia",
					"to": "Cernavodă Pod",
					"leavesAt": "16:25",
					"arrivesAt": "16:42",
					"waitsAtSource": 120,
					"distance": 24000
				},
				{
					"from": "Cernavodă Pod",
					"to": "Feteşti",
					"leavesAt": "16:43",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 20000
				},
				{
					"from": "Feteşti",
					"to": "Ciulniţa",
					"leavesAt": "17:00",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 37500
				},
				{
					"from": "Ciulniţa",
					"to": "Bucureşti Nord",
					"leavesAt": "17:22",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 108900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Chiajna",
					"leavesAt": "18:32",
					"arrivesAt": "18:44",
					"waitsAtSource": 1080,
					"distance": 9000
				},
				{
					"from": "Chiajna",
					"to": "Videle",
					"leavesAt": "18:55",
					"arrivesAt": "19:36",
					"waitsAtSource": 660,
					"distance": 41900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "19:37",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Caracal",
					"leavesAt": "20:24",
					"arrivesAt": "21:12",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "21:13",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 53600
				}
			],
			"restrictions": [
				{
					"from": "20180420",
					"to": "20180915",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "SFT",
			"number": "15935",
			"segments": [
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "06:10",
					"arrivesAt": "06:50",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Roşiori Nord",
					"leavesAt": "06:52",
					"arrivesAt": "07:36",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "07:38",
					"arrivesAt": "08:23",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "08:25",
					"arrivesAt": "09:16",
					"waitsAtSource": 120,
					"distance": 50900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "09:28",
					"arrivesAt": "10:05",
					"waitsAtSource": 720,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "10:06",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "10:29",
					"arrivesAt": "10:51",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "10:52",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "11:00",
					"arrivesAt": "11:05",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "11:06",
					"arrivesAt": "11:15",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "11:17",
					"arrivesAt": "11:55",
					"waitsAtSource": 120,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20180401",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "IR",
			"operator": "SFT",
			"number": "15937",
			"segments": [
				{
					"from": "Craiova",
					"to": "Caracal",
					"leavesAt": "06:50",
					"arrivesAt": "07:30",
					"waitsAtSource": 0,
					"distance": 53600
				},
				{
					"from": "Caracal",
					"to": "Roşiori Nord",
					"leavesAt": "07:32",
					"arrivesAt": "08:16",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Roşiori Nord",
					"to": "Videle",
					"leavesAt": "08:18",
					"arrivesAt": "09:02",
					"waitsAtSource": 120,
					"distance": 49200
				},
				{
					"from": "Videle",
					"to": "Bucureşti Nord",
					"leavesAt": "09:03",
					"arrivesAt": "09:54",
					"waitsAtSource": 60,
					"distance": 50900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Ploieşti Vest",
					"leavesAt": "10:30",
					"arrivesAt": "11:09",
					"waitsAtSource": 2160,
					"distance": 58900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Câmpina",
					"leavesAt": "11:11",
					"arrivesAt": "11:34",
					"waitsAtSource": 120,
					"distance": 32800
				},
				{
					"from": "Câmpina",
					"to": "Sinaia",
					"leavesAt": "11:35",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 29300
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "11:58",
					"arrivesAt": "12:05",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "12:06",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "12:12",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "12:22",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20180401",
					"to": "20180419",
					"daysOfWeek": 383
				},
				{
					"from": "20180916",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "SFT",
			"number": "15993",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "17:00",
					"arrivesAt": "17:04",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "17:05",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "17:09",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "17:14",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "17:22",
					"arrivesAt": "17:26",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "17:32",
					"arrivesAt": "17:37",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "17:42",
					"arrivesAt": "17:47",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Gura Motrului Hm.",
					"leavesAt": "17:48",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Butoieşti Hm.",
					"leavesAt": "17:57",
					"arrivesAt": "18:03",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Lunca Banului h.",
					"leavesAt": "18:04",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lunca Banului h.",
					"to": "Strehaia",
					"leavesAt": "18:10",
					"arrivesAt": "18:15",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Strehaia",
					"to": "Strehaia Nord h.",
					"leavesAt": "18:16",
					"arrivesAt": "18:20",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Strehaia Nord h.",
					"to": "Comanda h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:25",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Comanda h.",
					"to": "Cernaia h.",
					"leavesAt": "18:26",
					"arrivesAt": "18:30",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Cernaia h.",
					"to": "Jirov Hm.",
					"leavesAt": "18:31",
					"arrivesAt": "18:35",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Jirov Hm.",
					"to": "Ceramica h.",
					"leavesAt": "18:36",
					"arrivesAt": "18:40",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ceramica h.",
					"to": "Corcova h.",
					"leavesAt": "18:41",
					"arrivesAt": "18:45",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Corcova h.",
					"to": "Samarineşti h.",
					"leavesAt": "18:46",
					"arrivesAt": "18:49",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Samarineşti h.",
					"to": "Motru Est",
					"leavesAt": "18:50",
					"arrivesAt": "19:03",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Motru Est",
					"to": "Motru Est Gr. Călători",
					"leavesAt": "19:05",
					"arrivesAt": "19:12",
					"waitsAtSource": 120,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "SFT",
			"number": "15932",
			"segments": [
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "14:55",
					"arrivesAt": "15:29",
					"waitsAtSource": 0,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "15:31",
					"arrivesAt": "15:39",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "15:40",
					"arrivesAt": "15:45",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "15:46",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "15:56",
					"arrivesAt": "16:19",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "16:20",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "16:44",
					"arrivesAt": "17:24",
					"waitsAtSource": 120,
					"distance": 58900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "17:42",
					"arrivesAt": "18:33",
					"waitsAtSource": 1080,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "18:34",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Caracal",
					"leavesAt": "19:21",
					"arrivesAt": "20:08",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "20:09",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 53600
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "SFT",
			"number": "15936",
			"segments": [
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "07:10",
					"arrivesAt": "07:45",
					"waitsAtSource": 0,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "07:46",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "07:55",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "08:02",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Câmpina",
					"leavesAt": "08:12",
					"arrivesAt": "08:35",
					"waitsAtSource": 120,
					"distance": 29300
				},
				{
					"from": "Câmpina",
					"to": "Ploieşti Vest",
					"leavesAt": "08:36",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 32800
				},
				{
					"from": "Ploieşti Vest",
					"to": "Bucureşti Nord",
					"leavesAt": "09:01",
					"arrivesAt": "09:43",
					"waitsAtSource": 120,
					"distance": 58900
				},
				{
					"from": "Bucureşti Nord",
					"to": "Videle",
					"leavesAt": "09:55",
					"arrivesAt": "10:45",
					"waitsAtSource": 720,
					"distance": 50900
				},
				{
					"from": "Videle",
					"to": "Roşiori Nord",
					"leavesAt": "10:46",
					"arrivesAt": "11:31",
					"waitsAtSource": 60,
					"distance": 49200
				},
				{
					"from": "Roşiori Nord",
					"to": "Caracal",
					"leavesAt": "11:33",
					"arrivesAt": "12:20",
					"waitsAtSource": 120,
					"distance": 55300
				},
				{
					"from": "Caracal",
					"to": "Craiova",
					"leavesAt": "12:21",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 53600
				}
			],
			"restrictions": [
				{
					"from": "20180901",
					"to": "20181208",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "SFT",
			"number": "15992",
			"segments": [
				{
					"from": "Motru Est Gr. Călători",
					"to": "Motru Est",
					"leavesAt": "07:40",
					"arrivesAt": "07:47",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Motru Est",
					"to": "Samarineşti h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:53",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Samarineşti h.",
					"to": "Corcova h.",
					"leavesAt": "07:54",
					"arrivesAt": "07:57",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Corcova h.",
					"to": "Ceramica h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:02",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Ceramica h.",
					"to": "Jirov Hm.",
					"leavesAt": "08:03",
					"arrivesAt": "08:14",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Jirov Hm.",
					"to": "Cernaia h.",
					"leavesAt": "08:15",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cernaia h.",
					"to": "Comanda h.",
					"leavesAt": "08:20",
					"arrivesAt": "08:24",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comanda h.",
					"to": "Strehaia Nord h.",
					"leavesAt": "08:25",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Strehaia Nord h.",
					"to": "Strehaia",
					"leavesAt": "08:30",
					"arrivesAt": "08:34",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Strehaia",
					"to": "Lunca Banului h.",
					"leavesAt": "08:35",
					"arrivesAt": "08:39",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Lunca Banului h.",
					"to": "Butoieşti Hm.",
					"leavesAt": "08:40",
					"arrivesAt": "08:47",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Gura Motrului Hm.",
					"leavesAt": "08:48",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Filiaşi",
					"leavesAt": "08:56",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Filiaşi",
					"to": "Canton 282 h.",
					"leavesAt": "09:05",
					"arrivesAt": "09:08",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Canton 282 h.",
					"to": "Răcari Hm.",
					"leavesAt": "09:09",
					"arrivesAt": "09:13",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Răcari Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "09:14",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Brădeşti h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "09:19",
					"arrivesAt": "09:24",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Almăj h.",
					"leavesAt": "09:25",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Işalniţa",
					"leavesAt": "09:29",
					"arrivesAt": "09:34",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Işalniţa",
					"to": "Işalniţa hc.",
					"leavesAt": "09:35",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Işalniţa hc.",
					"to": "Cernele",
					"leavesAt": "09:38",
					"arrivesAt": "09:42",
					"waitsAtSource": 30,
					"distance": 4800
				},
				{
					"from": "Cernele",
					"to": "Craiova Triaj hc.",
					"leavesAt": "09:43",
					"arrivesAt": "09:46",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Craiova",
					"leavesAt": "09:47",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 3700
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "SFT",
			"number": "15991",
			"segments": [
				{
					"from": "Craiova",
					"to": "Craiova Triaj hc.",
					"leavesAt": "05:00",
					"arrivesAt": "05:04",
					"waitsAtSource": 0,
					"distance": 3700
				},
				{
					"from": "Craiova Triaj hc.",
					"to": "Cernele",
					"leavesAt": "05:05",
					"arrivesAt": "05:08",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Cernele",
					"to": "Işalniţa hc.",
					"leavesAt": "05:09",
					"arrivesAt": "05:13",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Işalniţa hc.",
					"to": "Işalniţa",
					"leavesAt": "05:14",
					"arrivesAt": "05:17",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Işalniţa",
					"to": "Almăj h.",
					"leavesAt": "05:18",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Almăj h.",
					"to": "Coţofeni Hm.",
					"leavesAt": "05:22",
					"arrivesAt": "05:26",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Coţofeni Hm.",
					"to": "Brădeşti h.",
					"leavesAt": "05:27",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Brădeşti h.",
					"to": "Răcari Hm.",
					"leavesAt": "05:32",
					"arrivesAt": "05:37",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Răcari Hm.",
					"to": "Canton 282 h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Canton 282 h.",
					"to": "Filiaşi",
					"leavesAt": "05:42",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Filiaşi",
					"to": "Gura Motrului Hm.",
					"leavesAt": "05:48",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Gura Motrului Hm.",
					"to": "Butoieşti Hm.",
					"leavesAt": "05:57",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Butoieşti Hm.",
					"to": "Lunca Banului h.",
					"leavesAt": "06:04",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Lunca Banului h.",
					"to": "Strehaia",
					"leavesAt": "06:10",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Strehaia",
					"to": "Strehaia Nord h.",
					"leavesAt": "06:16",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Strehaia Nord h.",
					"to": "Comanda h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Comanda h.",
					"to": "Cernaia h.",
					"leavesAt": "06:26",
					"arrivesAt": "06:30",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Cernaia h.",
					"to": "Jirov Hm.",
					"leavesAt": "06:31",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Jirov Hm.",
					"to": "Ceramica h.",
					"leavesAt": "06:36",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ceramica h.",
					"to": "Corcova h.",
					"leavesAt": "06:41",
					"arrivesAt": "06:45",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Corcova h.",
					"to": "Samarineşti h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:49",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Samarineşti h.",
					"to": "Motru Est",
					"leavesAt": "06:50",
					"arrivesAt": "07:03",
					"waitsAtSource": 30,
					"distance": 5600
				},
				{
					"from": "Motru Est",
					"to": "Motru Est Gr. Călători",
					"leavesAt": "07:05",
					"arrivesAt": "07:12",
					"waitsAtSource": 120,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20171210",
					"to": "20181208",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14712",
			"segments": [
				{
					"from": "Zărneşti",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "17:00",
					"arrivesAt": "17:03",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "17:04",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "Râşnov h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Râşnov h.",
					"to": "Râşnov",
					"leavesAt": "17:13",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Râşnov",
					"to": "Cristian Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cristian Hm.",
					"to": "Lustic h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Lustic h.",
					"to": "Bartolomeu",
					"leavesAt": "17:26",
					"arrivesAt": "17:33",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "17:34",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14713",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "17:50",
					"arrivesAt": "17:56",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "17:57",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "18:10",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "18:15",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "18:18",
					"arrivesAt": "18:23",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "18:24",
					"arrivesAt": "18:27",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "18:28",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14817",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "09:03",
					"arrivesAt": "09:16",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Movileni h",
					"leavesAt": "09:17",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Movileni h",
					"to": "Potângeni hc.",
					"leavesAt": "09:28",
					"arrivesAt": "09:34",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Potângeni hc.",
					"to": "Larga Jijia Hm.",
					"leavesAt": "09:35",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Vlădeni",
					"leavesAt": "09:42",
					"arrivesAt": "09:54",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vlădeni",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "09:55",
					"arrivesAt": "10:01",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Şoldana hc.",
					"leavesAt": "10:02",
					"arrivesAt": "10:07",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Şoldana hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "10:08",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "10:14",
					"arrivesAt": "10:18",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Rediu hc.",
					"to": "Răuşeni hc.",
					"leavesAt": "10:19",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Răuşeni hc.",
					"to": "Todireni Hm.",
					"leavesAt": "10:25",
					"arrivesAt": "10:31",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Todireni Hm.",
					"to": "Jijia h.",
					"leavesAt": "10:32",
					"arrivesAt": "10:40",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Jijia h.",
					"to": "Zlătunoaia h",
					"leavesAt": "10:41",
					"arrivesAt": "10:46",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zlătunoaia h",
					"to": "Truşeşti",
					"leavesAt": "10:47",
					"arrivesAt": "10:55",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Truşeşti",
					"to": "Buhăceni h.",
					"leavesAt": "10:56",
					"arrivesAt": "11:02",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Buhăceni h.",
					"to": "Dângeni",
					"leavesAt": "11:03",
					"arrivesAt": "11:10",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dângeni",
					"to": "Dângeni Nord h.",
					"leavesAt": "11:18",
					"arrivesAt": "11:23",
					"waitsAtSource": 480,
					"distance": 4700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Ungureni Hm.",
					"leavesAt": "11:24",
					"arrivesAt": "11:32",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Ungureni Hm.",
					"to": "Mândreşti h.",
					"leavesAt": "11:33",
					"arrivesAt": "11:38",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mândreşti h.",
					"to": "Vorniceni h.",
					"leavesAt": "11:39",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vorniceni h.",
					"to": "Mateieni h.",
					"leavesAt": "11:47",
					"arrivesAt": "11:51",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Mateieni h.",
					"to": "Corlăteni h",
					"leavesAt": "11:52",
					"arrivesAt": "11:56",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Corlăteni h",
					"to": "Carasa h.",
					"leavesAt": "11:57",
					"arrivesAt": "12:00",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Carasa h.",
					"to": "Broscăuţi h.",
					"leavesAt": "12:01",
					"arrivesAt": "12:07",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Broscăuţi h.",
					"to": "Dorohoi",
					"leavesAt": "12:08",
					"arrivesAt": "12:18",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14604",
			"segments": [
				{
					"from": "Praid",
					"to": "Sovata  hcv.",
					"leavesAt": "07:17",
					"arrivesAt": "07:37",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Sovata  hcv.",
					"to": "Sărăţeni h.",
					"leavesAt": "07:38",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sărăţeni h.",
					"to": "Chibed h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:49",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Chibed h.",
					"to": "Ghindari h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:55",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Ghindari h.",
					"to": "Cioc h.",
					"leavesAt": "07:56",
					"arrivesAt": "08:00",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Cioc h.",
					"to": "Sângeorgiu de Pădure h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Sângeorgiu de Pădure h.",
					"to": "Fântânele h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Fântânele h.",
					"to": "Bălăuşeri hcv.",
					"leavesAt": "08:17",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Bălăuşeri hcv.",
					"to": "Coroiu h.",
					"leavesAt": "08:41",
					"arrivesAt": "08:50",
					"waitsAtSource": 840,
					"distance": 6700
				},
				{
					"from": "Coroiu h.",
					"to": "Şoimuş h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 1300
				},
				{
					"from": "Şoimuş h.",
					"to": "Laslău h.",
					"leavesAt": "08:55",
					"arrivesAt": "09:02",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Laslău h.",
					"to": "Bahnea h.",
					"leavesAt": "09:03",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bahnea h.",
					"to": "Bernadea h.",
					"leavesAt": "09:10",
					"arrivesAt": "09:16",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bernadea h.",
					"to": "Mica h.",
					"leavesAt": "09:17",
					"arrivesAt": "09:21",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mica h.",
					"to": "Deaj h.",
					"leavesAt": "09:22",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Deaj h.",
					"to": "Găneşti h.",
					"leavesAt": "09:27",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Găneşti h.",
					"to": "Şeuca h.",
					"leavesAt": "09:32",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Şeuca h.",
					"to": "Târnaveni",
					"leavesAt": "09:38",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Târnaveni",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "09:46",
					"arrivesAt": "09:51",
					"waitsAtSource": 120,
					"distance": 2400
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Adămuş h.",
					"leavesAt": "09:52",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Adămuş h.",
					"to": "Corneşti Târnava h.",
					"leavesAt": "09:57",
					"arrivesAt": "10:01",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Corneşti Târnava h.",
					"to": "Crăieşti h.",
					"leavesAt": "10:02",
					"arrivesAt": "10:05",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Crăieşti h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "10:06",
					"arrivesAt": "10:13",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Feisa h.",
					"leavesAt": "10:14",
					"arrivesAt": "10:17",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Feisa h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "10:18",
					"arrivesAt": "10:22",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Bălcaci h.",
					"leavesAt": "10:23",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Bălcaci h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "10:28",
					"arrivesAt": "10:32",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Şona h.",
					"leavesAt": "10:33",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Şona h.",
					"to": "Pănade h.",
					"leavesAt": "10:38",
					"arrivesAt": "10:43",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Pănade h.",
					"to": "Sâncel h.",
					"leavesAt": "10:44",
					"arrivesAt": "10:47",
					"waitsAtSource": 30,
					"distance": 1654
				},
				{
					"from": "Sâncel h.",
					"to": "Blaj",
					"leavesAt": "10:48",
					"arrivesAt": "10:55",
					"waitsAtSource": 30,
					"distance": 4246
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14985",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Dâmbu Hm.",
					"leavesAt": "19:08",
					"arrivesAt": "19:13",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "19:14",
					"arrivesAt": "19:19",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Râfov h.",
					"leavesAt": "19:20",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Râfov h.",
					"to": "Trestieni h.",
					"leavesAt": "19:24",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Trestieni h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "19:30",
					"arrivesAt": "19:33",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Cornurile h.",
					"leavesAt": "19:34",
					"arrivesAt": "19:39",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cornurile h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "19:40",
					"arrivesAt": "19:44",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "19:45",
					"arrivesAt": "19:49",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Hătcărău h.",
					"to": "Ciorani Hm.",
					"leavesAt": "19:50",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ciorani Hm.",
					"to": "Fulga hc.",
					"leavesAt": "19:57",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Fulga hc.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "20:02",
					"arrivesAt": "20:09",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "20:10",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "20:17",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "20:22",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18230",
			"segments": [
				{
					"from": "Nerău hcv.",
					"to": "Teremia Banat hc.",
					"leavesAt": "12:17",
					"arrivesAt": "12:25",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Comloşu Mare h.",
					"leavesAt": "12:26",
					"arrivesAt": "12:36",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Gotlob h.",
					"leavesAt": "12:37",
					"arrivesAt": "12:45",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gotlob h.",
					"to": "Lovrin",
					"leavesAt": "12:46",
					"arrivesAt": "12:53",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "13:10",
					"arrivesAt": "13:17",
					"waitsAtSource": 1020,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Pesac h.",
					"leavesAt": "13:18",
					"arrivesAt": "13:26",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pesac h.",
					"to": "Periam",
					"leavesAt": "13:27",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Periam",
					"to": "Variaş hc.",
					"leavesAt": "13:40",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Variaş hc.",
					"to": "Gelu hc.",
					"leavesAt": "13:51",
					"arrivesAt": "13:57",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Gelu hc.",
					"to": "Bărăteaz h.",
					"leavesAt": "13:58",
					"arrivesAt": "14:03",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bărăteaz h.",
					"to": "Chinezu h.",
					"leavesAt": "14:04",
					"arrivesAt": "14:09",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chinezu h.",
					"to": "Hodoni h.",
					"leavesAt": "14:10",
					"arrivesAt": "14:16",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Hodoni h.",
					"to": "Sânandrei Hm.",
					"leavesAt": "14:17",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "14:33",
					"arrivesAt": "14:39",
					"waitsAtSource": 420,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:41",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "14:42",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "14:45",
					"arrivesAt": "14:51",
					"waitsAtSource": 30,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14508",
			"segments": [
				{
					"from": "Reşiţa Nord",
					"to": "Câlnic h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:43",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Câlnic h.",
					"to": "Moniom h.",
					"leavesAt": "14:44",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Moniom h.",
					"to": "Colţan h.",
					"leavesAt": "14:54",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Colţan h.",
					"to": "Bocşa Montană hc.",
					"leavesAt": "15:01",
					"arrivesAt": "15:08",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Vasiova",
					"leavesAt": "15:09",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Română hc.",
					"leavesAt": "15:14",
					"arrivesAt": "15:18",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Berzovia",
					"leavesAt": "15:19",
					"arrivesAt": "15:29",
					"waitsAtSource": 30,
					"distance": 8200
				},
				{
					"from": "Berzovia",
					"to": "Gherteniş hc.",
					"leavesAt": "15:37",
					"arrivesAt": "15:40",
					"waitsAtSource": 480,
					"distance": 3500
				},
				{
					"from": "Gherteniş hc.",
					"to": "Măureni hc.",
					"leavesAt": "15:41",
					"arrivesAt": "15:47",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Măureni hc.",
					"to": "Gătaia",
					"leavesAt": "15:48",
					"arrivesAt": "15:56",
					"waitsAtSource": 30,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14014",
			"segments": [
				{
					"from": "Sărmaşu h.",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:09",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "05:10",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Sărmăşel hcv .",
					"to": "Ţăgşor h.",
					"leavesAt": "05:15",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ţăgşor h.",
					"to": "Ţagu Sat h.",
					"leavesAt": "05:19",
					"arrivesAt": "05:25",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Ţagu Sat h.",
					"to": "Ţagu h.",
					"leavesAt": "05:26",
					"arrivesAt": "05:28",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ţagu h.",
					"to": "Budeşti Cluj h.",
					"leavesAt": "05:29",
					"arrivesAt": "05:37",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Budeşti Cluj h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Brăteni h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Brăteni h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "06:02",
					"arrivesAt": "06:08",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Vermeş h.",
					"leavesAt": "06:09",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vermeş h.",
					"to": "Lechinţa",
					"leavesAt": "06:18",
					"arrivesAt": "06:22",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Lechinţa",
					"to": "Ţigău h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ţigău h.",
					"to": "Chiraleş h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:36",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Chiraleş h.",
					"to": "Chintelnic h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 2276
				},
				{
					"from": "Chintelnic h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "06:41",
					"arrivesAt": "06:45",
					"waitsAtSource": 30,
					"distance": 2314
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "06:46",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel",
					"leavesAt": "06:49",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel",
					"to": "Sărata h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:04",
					"waitsAtSource": 240,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "07:13",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14552",
			"segments": [
				{
					"from": "Luduş",
					"to": "Luduş Sat hc.",
					"leavesAt": "20:45",
					"arrivesAt": "20:48",
					"waitsAtSource": 0,
					"distance": 2400
				},
				{
					"from": "Luduş Sat hc.",
					"to": "Sânger Tăureni h.",
					"leavesAt": "20:49",
					"arrivesAt": "21:00",
					"waitsAtSource": 30,
					"distance": 8080
				},
				{
					"from": "Sânger Tăureni h.",
					"to": "Tăureni h.",
					"leavesAt": "21:01",
					"arrivesAt": "21:08",
					"waitsAtSource": 60,
					"distance": 5620
				},
				{
					"from": "Tăureni h.",
					"to": "Melini Valea Largă h.",
					"leavesAt": "21:09",
					"arrivesAt": "21:13",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Melini Valea Largă h.",
					"to": "Zau de Câmpie h.",
					"leavesAt": "21:14",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Zau de Câmpie h.",
					"to": "Bota Sat h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:23",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Bota Sat h.",
					"to": "Miheşu de Câmpie h.",
					"leavesAt": "21:24",
					"arrivesAt": "21:30",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Miheşu de Câmpie h.",
					"to": "Miheşu de Câmpie Sat h.",
					"leavesAt": "21:31",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Miheşu de Câmpie Sat h.",
					"to": "Balda h.",
					"leavesAt": "21:38",
					"arrivesAt": "21:44",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Balda h.",
					"to": "Sărmaşu h.",
					"leavesAt": "21:45",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Sărmaşu h.",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "21:56",
					"arrivesAt": "22:00",
					"waitsAtSource": 30,
					"distance": 2000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14441",
			"segments": [
				{
					"from": "Arad",
					"to": "Utvinişu Nou",
					"leavesAt": "08:08",
					"arrivesAt": "08:16",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Utvinişu Nou",
					"to": "Utviniş h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Utviniş h.",
					"to": "Zimandu Nou h.",
					"leavesAt": "08:21",
					"arrivesAt": "08:25",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "08:26",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Şiria Hm.",
					"leavesAt": "08:37",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Şiria Hm.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "08:50",
					"arrivesAt": "08:54",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Pâncota h.",
					"leavesAt": "08:55",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Pâncota h.",
					"to": "Seleuş h.",
					"leavesAt": "08:59",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Seleuş h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "09:04",
					"arrivesAt": "09:11",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Mocrea h.",
					"leavesAt": "09:12",
					"arrivesAt": "09:17",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mocrea h.",
					"to": "Ineu",
					"leavesAt": "09:18",
					"arrivesAt": "09:24",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Ineu",
					"to": "Tămand h.",
					"leavesAt": "09:31",
					"arrivesAt": "09:39",
					"waitsAtSource": 420,
					"distance": 8400
				},
				{
					"from": "Tămand h.",
					"to": "Bocsig  h",
					"leavesAt": "09:40",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bocsig  h",
					"to": "Răpsig h.",
					"leavesAt": "09:45",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Răpsig h.",
					"to": "Sebiş",
					"leavesAt": "09:52",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Sebiş",
					"to": "Paulian h.",
					"leavesAt": "10:03",
					"arrivesAt": "10:08",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Paulian h.",
					"to": "Joia Mare hc.",
					"leavesAt": "10:09",
					"arrivesAt": "10:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Joia Mare hc.",
					"to": "Almaş h.",
					"leavesAt": "10:14",
					"arrivesAt": "10:19",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Almaş h.",
					"to": "Bonţeşti h.",
					"leavesAt": "10:20",
					"arrivesAt": "10:25",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bonţeşti h.",
					"to": "Gurahonţ",
					"leavesAt": "10:26",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14709",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "14:20",
					"arrivesAt": "14:26",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "14:27",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "14:35",
					"arrivesAt": "14:38",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "14:39",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "14:44",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "14:47",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "14:53",
					"arrivesAt": "14:56",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "14:57",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14301",
			"segments": [
				{
					"from": "Arad",
					"to": "Arad Vest",
					"leavesAt": "16:16",
					"arrivesAt": "16:25",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Arad Vest",
					"to": "Ferma Ciala h.",
					"leavesAt": "16:26",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Sântoma h.",
					"leavesAt": "16:32",
					"arrivesAt": "16:38",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sântoma h.",
					"to": "Pecica",
					"leavesAt": "16:39",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pecica",
					"to": "Semlac h.",
					"leavesAt": "16:52",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Semlac h.",
					"to": "Şeitin h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Şeitin h.",
					"to": "Nădlac",
					"leavesAt": "17:25",
					"arrivesAt": "17:38",
					"waitsAtSource": 30,
					"distance": 8100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14706",
			"segments": [
				{
					"from": "Zărneşti",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "06:12",
					"arrivesAt": "06:15",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "06:16",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "Râşnov h.",
					"leavesAt": "06:19",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Râşnov h.",
					"to": "Râşnov",
					"leavesAt": "06:25",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Râşnov",
					"to": "Cristian Hm.",
					"leavesAt": "06:30",
					"arrivesAt": "06:34",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cristian Hm.",
					"to": "Lustic h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Lustic h.",
					"to": "Bartolomeu",
					"leavesAt": "06:39",
					"arrivesAt": "06:46",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "06:47",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18263",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "09:44",
					"arrivesAt": "09:50",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "12:07",
					"arrivesAt": "12:15",
					"waitsAtSource": 8220,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "12:16",
					"arrivesAt": "12:19",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "12:20",
					"arrivesAt": "12:24",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "12:25",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "12:28",
					"arrivesAt": "12:33",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "12:34",
					"arrivesAt": "12:37",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "12:38",
					"arrivesAt": "12:41",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 256
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14306",
			"segments": [
				{
					"from": "Nădlac",
					"to": "Şeitin h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:59",
					"waitsAtSource": 0,
					"distance": 8100
				},
				{
					"from": "Şeitin h.",
					"to": "Semlac h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:09",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Semlac h.",
					"to": "Pecica",
					"leavesAt": "18:10",
					"arrivesAt": "18:32",
					"waitsAtSource": 30,
					"distance": 17200
				},
				{
					"from": "Pecica",
					"to": "Sântoma h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Sântoma h.",
					"to": "Ferma Ciala h.",
					"leavesAt": "18:46",
					"arrivesAt": "18:52",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Arad Vest",
					"leavesAt": "18:53",
					"arrivesAt": "18:59",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Arad Vest",
					"to": "Arad",
					"leavesAt": "19:02",
					"arrivesAt": "19:11",
					"waitsAtSource": 180,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14989",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Dâmbu Hm.",
					"leavesAt": "23:44",
					"arrivesAt": "23:49",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "23:50",
					"arrivesAt": "23:55",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Râfov h.",
					"leavesAt": "23:56",
					"arrivesAt": "23:59",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Râfov h.",
					"to": "Trestieni h.",
					"leavesAt": "00:00",
					"arrivesAt": "00:05",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Trestieni h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "00:06",
					"arrivesAt": "00:09",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Cornurile h.",
					"leavesAt": "00:10",
					"arrivesAt": "00:15",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cornurile h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "00:16",
					"arrivesAt": "00:22",
					"waitsAtSource": 60,
					"distance": 4000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14323",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:43",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "16:44",
					"arrivesAt": "16:46",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Hodoni h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:08",
					"waitsAtSource": 300,
					"distance": 8600
				},
				{
					"from": "Hodoni h.",
					"to": "Chinezu h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Chinezu h.",
					"to": "Bărăteaz h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:21",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bărăteaz h.",
					"to": "Gelu hc.",
					"leavesAt": "17:22",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gelu hc.",
					"to": "Variaş hc.",
					"leavesAt": "17:29",
					"arrivesAt": "17:35",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Variaş hc.",
					"to": "Periam",
					"leavesAt": "17:36",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Periam",
					"to": "Pesac h.",
					"leavesAt": "18:03",
					"arrivesAt": "18:14",
					"waitsAtSource": 1020,
					"distance": 6700
				},
				{
					"from": "Pesac h.",
					"to": "Satu Nou Hm.",
					"leavesAt": "18:15",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Lovrin",
					"leavesAt": "18:23",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lovrin",
					"to": "Gotlob h.",
					"leavesAt": "18:38",
					"arrivesAt": "18:44",
					"waitsAtSource": 480,
					"distance": 6400
				},
				{
					"from": "Gotlob h.",
					"to": "Comloşu Mare h.",
					"leavesAt": "18:45",
					"arrivesAt": "18:52",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Teremia Banat hc.",
					"leavesAt": "18:53",
					"arrivesAt": "19:03",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Nerău hcv.",
					"leavesAt": "19:04",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14439",
			"segments": [
				{
					"from": "Arad",
					"to": "Utvinişu Nou",
					"leavesAt": "05:10",
					"arrivesAt": "05:18",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Utvinişu Nou",
					"to": "Zimandu Nou h.",
					"leavesAt": "05:19",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "05:26",
					"arrivesAt": "05:36",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Şiria Hm.",
					"leavesAt": "05:37",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Şiria Hm.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Pâncota h.",
					"leavesAt": "05:55",
					"arrivesAt": "05:58",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Pâncota h.",
					"to": "Seleuş h.",
					"leavesAt": "05:59",
					"arrivesAt": "06:03",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Seleuş h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "06:04",
					"arrivesAt": "06:11",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Mocrea h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mocrea h.",
					"to": "Ineu",
					"leavesAt": "06:18",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Ineu",
					"to": "Tămand h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:39",
					"waitsAtSource": 420,
					"distance": 8400
				},
				{
					"from": "Tămand h.",
					"to": "Bocsig  h",
					"leavesAt": "06:40",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bocsig  h",
					"to": "Răpsig h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Răpsig h.",
					"to": "Sebiş",
					"leavesAt": "06:52",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Sebiş",
					"to": "Paulian h.",
					"leavesAt": "07:03",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Paulian h.",
					"to": "Joia Mare hc.",
					"leavesAt": "07:09",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Joia Mare hc.",
					"to": "Almaş h.",
					"leavesAt": "07:14",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Almaş h.",
					"to": "Bonţeşti h.",
					"leavesAt": "07:20",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bonţeşti h.",
					"to": "Gurahonţ",
					"leavesAt": "07:26",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Gurahonţ",
					"to": "Romaniţa h.",
					"leavesAt": "07:33",
					"arrivesAt": "07:41",
					"waitsAtSource": 180,
					"distance": 6100
				},
				{
					"from": "Romaniţa h.",
					"to": "Aciuţa h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:46",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aciuţa h.",
					"to": "Tălagiu h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:53",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tălagiu h.",
					"to": "Vârfurile Hm.",
					"leavesAt": "07:54",
					"arrivesAt": "08:00",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Vârfurile Hm.",
					"to": "Cariera Leasa h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:20",
					"waitsAtSource": 960,
					"distance": 3600
				},
				{
					"from": "Cariera Leasa h.",
					"to": "Hălmagiu Hm.",
					"leavesAt": "08:21",
					"arrivesAt": "08:26",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Hălmagiu Hm.",
					"to": "Ocişor h.",
					"leavesAt": "08:27",
					"arrivesAt": "08:32",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ocişor h.",
					"to": "Ociu h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ociu h.",
					"to": "Vaţa h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:42",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Vaţa h.",
					"to": "Birtin h.",
					"leavesAt": "08:43",
					"arrivesAt": "08:49",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Birtin h.",
					"to": "Lunca Moţilor h.",
					"leavesAt": "08:50",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lunca Moţilor h.",
					"to": "Baia de Criş h.",
					"leavesAt": "08:56",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Baia de Criş h.",
					"to": "Ţebea h",
					"leavesAt": "09:00",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ţebea h",
					"to": "Ribiţa h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Ribiţa h.",
					"to": "Brad",
					"leavesAt": "09:08",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14298",
			"segments": [
				{
					"from": "Nădlac",
					"to": "Şeitin h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:37",
					"waitsAtSource": 0,
					"distance": 8100
				},
				{
					"from": "Şeitin h.",
					"to": "Semlac h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Semlac h.",
					"to": "Canton Nr. 9 h.",
					"leavesAt": "05:49",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Canton Nr. 9 h.",
					"to": "Pecica",
					"leavesAt": "06:01",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Pecica",
					"to": "Sântoma h.",
					"leavesAt": "06:16",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Sântoma h.",
					"to": "Ferma Ciala h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:34",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Arad Vest",
					"leavesAt": "06:35",
					"arrivesAt": "06:41",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Arad Vest",
					"to": "Arad",
					"leavesAt": "06:44",
					"arrivesAt": "06:53",
					"waitsAtSource": 180,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14391",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "16:17",
					"arrivesAt": "16:23",
					"waitsAtSource": 0,
					"distance": 4400
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:26",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "16:27",
					"arrivesAt": "16:29",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "16:30",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "16:38",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Biled",
					"leavesAt": "16:49",
					"arrivesAt": "17:09",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Biled",
					"to": "Şandra h.",
					"leavesAt": "17:10",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Şandra h.",
					"to": "Satu Nou Hm.",
					"leavesAt": "17:21",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Lovrin",
					"leavesAt": "17:36",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lovrin",
					"to": "Tomnaticu h.",
					"leavesAt": "17:52",
					"arrivesAt": "18:03",
					"waitsAtSource": 540,
					"distance": 7700
				},
				{
					"from": "Tomnaticu h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "18:04",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Sânnicolau Mare",
					"to": "Sânnicolau Nord h.",
					"leavesAt": "18:32",
					"arrivesAt": "18:44",
					"waitsAtSource": 1020,
					"distance": 5400
				},
				{
					"from": "Sânnicolau Nord h.",
					"to": "Cenad h.",
					"leavesAt": "18:45",
					"arrivesAt": "19:08",
					"waitsAtSource": 30,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14735",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:00",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "16:01",
					"arrivesAt": "16:06",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "16:07",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "16:13",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:25",
					"waitsAtSource": 360,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "16:26",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "16:31",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Angheluş h.",
					"leavesAt": "16:39",
					"arrivesAt": "16:48",
					"waitsAtSource": 120,
					"distance": 6500
				},
				{
					"from": "Angheluş h.",
					"to": "Moacşa hcv",
					"leavesAt": "16:49",
					"arrivesAt": "16:55",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Moacşa hcv",
					"to": "Biţa h.",
					"leavesAt": "16:56",
					"arrivesAt": "17:01",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Biţa h.",
					"to": "Boroşneu Mare h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:07",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Boroşneu Mare h.",
					"to": "Ţufalău h.",
					"leavesAt": "17:08",
					"arrivesAt": "17:11",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ţufalău h.",
					"to": "Brateş h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 3020
				},
				{
					"from": "Brateş h.",
					"to": "Covasna Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:26",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Covasna Hm.",
					"to": "Zăbala h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Zăbala h.",
					"to": "Imeci Hm.",
					"leavesAt": "17:33",
					"arrivesAt": "17:39",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Imeci Hm.",
					"to": "Cătălina h.",
					"leavesAt": "17:40",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Cătălina h.",
					"to": "Târgu Secuiesc",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Târgu Secuiesc",
					"to": "Sânzieni h.",
					"leavesAt": "17:49",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Sânzieni h.",
					"to": "Poieniţa h.",
					"leavesAt": "18:02",
					"arrivesAt": "18:07",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Poieniţa h.",
					"to": "Bălani h.",
					"leavesAt": "18:08",
					"arrivesAt": "18:13",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bălani h.",
					"to": "Mereni Lutoasa h.",
					"leavesAt": "18:14",
					"arrivesAt": "18:20",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Mereni Lutoasa h.",
					"to": "Lemnia h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:26",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lemnia h.",
					"to": "Breţcu Hm.",
					"leavesAt": "18:27",
					"arrivesAt": "18:34",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18244",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Saravale h.",
					"leavesAt": "12:11",
					"arrivesAt": "12:21",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Saravale h.",
					"to": "Sânpetru h.",
					"leavesAt": "12:22",
					"arrivesAt": "12:31",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Sânpetru h.",
					"to": "Periam",
					"leavesAt": "12:32",
					"arrivesAt": "12:39",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Periam",
					"to": "Aranca h.",
					"leavesAt": "12:40",
					"arrivesAt": "12:50",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Aranca h.",
					"to": "Secusigiu h",
					"leavesAt": "12:51",
					"arrivesAt": "12:54",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Secusigiu h",
					"to": "Munor h.",
					"leavesAt": "12:55",
					"arrivesAt": "12:59",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Munor h.",
					"to": "Sânpetru German h.",
					"leavesAt": "13:00",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sânpetru German h.",
					"to": "Felnac hc.",
					"leavesAt": "13:04",
					"arrivesAt": "13:11",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Felnac hc.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "13:12",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Zădăreni Hm.",
					"leavesAt": "13:18",
					"arrivesAt": "13:22",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Aradu Nou",
					"leavesAt": "13:23",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "13:36",
					"arrivesAt": "13:43",
					"waitsAtSource": 180,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14675",
			"segments": [
				{
					"from": "Zlatna hcv.",
					"to": "Zlatna h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:07",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Zlatna h.",
					"to": "Zlatna Tehnică",
					"leavesAt": "17:08",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Zlatna Tehnică",
					"to": "Feneş h.",
					"leavesAt": "17:17",
					"arrivesAt": "17:21",
					"waitsAtSource": 180,
					"distance": 2400
				},
				{
					"from": "Feneş h.",
					"to": "Prisaca h.",
					"leavesAt": "17:22",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Prisaca h.",
					"to": "Poiana Ampoiului h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:34",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Poiana Ampoiului h.",
					"to": "Văleni Meteş h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:39",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Văleni Meteş h.",
					"to": "Tăutu Ampoiului h.",
					"leavesAt": "17:40",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tăutu Ampoiului h.",
					"to": "Ampoiţa h.",
					"leavesAt": "17:47",
					"arrivesAt": "17:52",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ampoiţa h.",
					"to": "Şard Ighiu h.",
					"leavesAt": "17:53",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Şard Ighiu h.",
					"to": "Bărăbanţ Nord h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:05",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bărăbanţ Nord h.",
					"to": "Antestaţie Bărăbanţ h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:10",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Antestaţie Bărăbanţ h.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "18:11",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "18:16",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14846",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "13:17",
					"arrivesAt": "13:22",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Ciurea Hm.",
					"leavesAt": "13:23",
					"arrivesAt": "13:29",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Ciurea Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "13:30",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Bârnova Hm.",
					"leavesAt": "13:40",
					"arrivesAt": "13:51",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Grajduri",
					"leavesAt": "13:52",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Grajduri",
					"to": "Scânteia Hm.",
					"leavesAt": "13:59",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Scânteia Hm.",
					"to": "Rebricea Hm.",
					"leavesAt": "14:06",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Rebricea Hm.",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "14:12",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Buhăieşti",
					"leavesAt": "14:18",
					"arrivesAt": "14:26",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Buhăieşti",
					"to": "Negreşti Vaslui Hm.",
					"leavesAt": "14:32",
					"arrivesAt": "14:46",
					"waitsAtSource": 360,
					"distance": 10700
				},
				{
					"from": "Negreşti Vaslui Hm.",
					"to": "Rafaila h.",
					"leavesAt": "14:47",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Rafaila h.",
					"to": "Dumeşti h.",
					"leavesAt": "14:54",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Dumeşti h.",
					"to": "Mareşal C-tin Prezan Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Mareşal C-tin Prezan Hm.",
					"to": "Suhuleţ h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Suhuleţ h.",
					"to": "Băluşeşti h",
					"leavesAt": "15:17",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Băluşeşti h",
					"to": "Dagâţa",
					"leavesAt": "15:21",
					"arrivesAt": "15:25",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Dagâţa",
					"to": "Zece Prăjini h",
					"leavesAt": "15:27",
					"arrivesAt": "15:31",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Zece Prăjini h",
					"to": "Piscu Rusului h.",
					"leavesAt": "15:32",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Stăniţa h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Stăniţa h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "15:53",
					"arrivesAt": "16:00",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Sagna h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Sagna h.",
					"to": "Roman",
					"leavesAt": "16:12",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 8700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14759",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:13",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "16:14",
					"arrivesAt": "16:19",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Budila hcv.",
					"leavesAt": "16:20",
					"arrivesAt": "16:30",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Budila hcv.",
					"to": "Teliu h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Teliu h.",
					"to": "Valea Teliului h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Valea Teliului h.",
					"to": "Poiana Florilor h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:47",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Întorsura Buzăului Hm",
					"leavesAt": "16:48",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14451",
			"segments": [
				{
					"from": "Arad",
					"to": "Utvinişu Nou",
					"leavesAt": "19:48",
					"arrivesAt": "19:56",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Utvinişu Nou",
					"to": "Utviniş h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Utviniş h.",
					"to": "Zimandu Nou h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:06",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "20:07",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Şiria Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Şiria Hm.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "20:31",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Pâncota h.",
					"leavesAt": "20:36",
					"arrivesAt": "20:39",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Pâncota h.",
					"to": "Seleuş h.",
					"leavesAt": "20:40",
					"arrivesAt": "20:44",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Seleuş h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "20:45",
					"arrivesAt": "20:51",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Mocrea h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mocrea h.",
					"to": "Ineu",
					"leavesAt": "20:58",
					"arrivesAt": "21:03",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Ineu",
					"to": "Tămand h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:12",
					"waitsAtSource": 60,
					"distance": 8400
				},
				{
					"from": "Tămand h.",
					"to": "Bocsig  h",
					"leavesAt": "21:13",
					"arrivesAt": "21:17",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bocsig  h",
					"to": "Răpsig h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Răpsig h.",
					"to": "Sebiş",
					"leavesAt": "21:25",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Sebiş",
					"to": "Paulian h.",
					"leavesAt": "21:36",
					"arrivesAt": "21:41",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Paulian h.",
					"to": "Joia Mare hc.",
					"leavesAt": "21:42",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Joia Mare hc.",
					"to": "Almaş h.",
					"leavesAt": "21:47",
					"arrivesAt": "21:52",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Almaş h.",
					"to": "Bonţeşti h.",
					"leavesAt": "21:53",
					"arrivesAt": "21:58",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bonţeşti h.",
					"to": "Gurahonţ",
					"leavesAt": "21:59",
					"arrivesAt": "22:03",
					"waitsAtSource": 60,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14015",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:36",
					"waitsAtSource": 0,
					"distance": 900
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Sărata h.",
					"leavesAt": "14:37",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sărăţel",
					"to": "Arcalia hc.",
					"leavesAt": "14:51",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "14:56",
					"arrivesAt": "14:59",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Chintelnic h.",
					"leavesAt": "15:00",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 2314
				},
				{
					"from": "Chintelnic h.",
					"to": "Chiraleş h.",
					"leavesAt": "15:05",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 2276
				},
				{
					"from": "Chiraleş h.",
					"to": "Ţigău h.",
					"leavesAt": "15:09",
					"arrivesAt": "15:14",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ţigău h.",
					"to": "Lechinţa",
					"leavesAt": "15:15",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lechinţa",
					"to": "Vermeş h.",
					"leavesAt": "15:24",
					"arrivesAt": "15:27",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Vermeş h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "15:28",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Brăteni h.",
					"leavesAt": "15:38",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Brăteni h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:53",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "15:54",
					"arrivesAt": "15:59",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Budeşti Cluj h.",
					"leavesAt": "16:00",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Budeşti Cluj h.",
					"to": "Ţagu h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ţagu h.",
					"to": "Ţagu Sat h.",
					"leavesAt": "16:20",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ţagu Sat h.",
					"to": "Ţăgşor h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:30",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ţăgşor h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "16:31",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 2000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14972",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:04",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "06:05",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:17",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Fulga hc.",
					"leavesAt": "06:18",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Fulga hc.",
					"to": "Ciorani Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ciorani Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "06:32",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hătcărău h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "06:38",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Cornurile h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:48",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Cornurile h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "06:49",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Trestieni h.",
					"leavesAt": "06:55",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Trestieni h.",
					"to": "Râfov h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:02",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Râfov h.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "07:03",
					"arrivesAt": "07:07",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Dâmbu Hm.",
					"leavesAt": "07:08",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Ploieşti Sud",
					"leavesAt": "07:14",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14505",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "07:22",
					"arrivesAt": "07:30",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara C.E.T.",
					"leavesAt": "07:31",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişeni Hm.",
					"leavesAt": "07:35",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişeni Hm.",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "07:41",
					"arrivesAt": "07:46",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Jebel",
					"leavesAt": "07:47",
					"arrivesAt": "07:52",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Jebel",
					"to": "Voiteni",
					"leavesAt": "07:53",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Voiteni",
					"to": "Birda hcv.",
					"leavesAt": "08:04",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Birda hcv.",
					"to": "Gătaia",
					"leavesAt": "08:13",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Gătaia",
					"to": "Măureni hc.",
					"leavesAt": "08:35",
					"arrivesAt": "08:42",
					"waitsAtSource": 840,
					"distance": 6700
				},
				{
					"from": "Măureni hc.",
					"to": "Gherteniş hc.",
					"leavesAt": "08:43",
					"arrivesAt": "08:49",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gherteniş hc.",
					"to": "Berzovia",
					"leavesAt": "08:50",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Berzovia",
					"to": "Bocşa Română hc.",
					"leavesAt": "08:55",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Vasiova",
					"leavesAt": "09:06",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Montană hc.",
					"leavesAt": "09:13",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Colţan h.",
					"leavesAt": "09:17",
					"arrivesAt": "09:24",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Colţan h.",
					"to": "Moniom h.",
					"leavesAt": "09:25",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moniom h.",
					"to": "Câlnic h.",
					"leavesAt": "09:31",
					"arrivesAt": "09:39",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "09:40",
					"arrivesAt": "09:44",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14501",
			"segments": [
				{
					"from": "Gătaia",
					"to": "Măureni hc.",
					"leavesAt": "05:58",
					"arrivesAt": "06:05",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Măureni hc.",
					"to": "Gherteniş hc.",
					"leavesAt": "06:06",
					"arrivesAt": "06:12",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gherteniş hc.",
					"to": "Berzovia",
					"leavesAt": "06:13",
					"arrivesAt": "06:17",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Berzovia",
					"to": "Bocşa Română hc.",
					"leavesAt": "06:18",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Vasiova",
					"leavesAt": "06:29",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Montană hc.",
					"leavesAt": "06:36",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Colţan h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Colţan h.",
					"to": "Moniom h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:54",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Moniom h.",
					"to": "Câlnic h.",
					"leavesAt": "06:55",
					"arrivesAt": "07:03",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "07:04",
					"arrivesAt": "07:08",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14609",
			"segments": [
				{
					"from": "Blaj",
					"to": "Sâncel h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:35",
					"waitsAtSource": 0,
					"distance": 4246
				},
				{
					"from": "Sâncel h.",
					"to": "Pănade h.",
					"leavesAt": "14:36",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 1654
				},
				{
					"from": "Pănade h.",
					"to": "Şona h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Şona h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "14:47",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Bălcaci h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bălcaci h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "14:57",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Feisa h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:06",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Feisa h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "15:07",
					"arrivesAt": "15:11",
					"waitsAtSource": 30,
					"distance": 2540
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Crăieşti h.",
					"leavesAt": "15:12",
					"arrivesAt": "15:18",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Crăieşti h.",
					"to": "Adămuş h.",
					"leavesAt": "15:19",
					"arrivesAt": "15:24",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Adămuş h.",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "15:25",
					"arrivesAt": "15:29",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Târnaveni",
					"leavesAt": "15:30",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Târnaveni",
					"to": "Şeuca h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:47",
					"waitsAtSource": 300,
					"distance": 2600
				},
				{
					"from": "Şeuca h.",
					"to": "Găneşti h.",
					"leavesAt": "15:48",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Găneşti h.",
					"to": "Deaj h.",
					"leavesAt": "15:54",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Deaj h.",
					"to": "Mica h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:03",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Mica h.",
					"to": "Bernadea h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:08",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Bernadea h.",
					"to": "Bahnea h.",
					"leavesAt": "16:09",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bahnea h.",
					"to": "Laslău h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:23",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Laslău h.",
					"to": "Şoimuş h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şoimuş h.",
					"to": "Coroiu h.",
					"leavesAt": "16:32",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Coroiu h.",
					"to": "Bălăuşeri hcv.",
					"leavesAt": "16:36",
					"arrivesAt": "16:47",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bălăuşeri hcv.",
					"to": "Fântânele h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Fântânele h.",
					"to": "Sângeorgiu de Pădure h.",
					"leavesAt": "16:58",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Sângeorgiu de Pădure h.",
					"to": "Cioc h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Cioc h.",
					"to": "Ghindari h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Ghindari h.",
					"to": "Chibed h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:23",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Chibed h.",
					"to": "Sărăţeni h.",
					"leavesAt": "17:24",
					"arrivesAt": "17:29",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sărăţeni h.",
					"to": "Sovata  hcv.",
					"leavesAt": "17:30",
					"arrivesAt": "17:37",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sovata  hcv.",
					"to": "Praid",
					"leavesAt": "17:38",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14671",
			"segments": [
				{
					"from": "Zlatna hcv.",
					"to": "Zlatna h.",
					"leavesAt": "05:00",
					"arrivesAt": "05:03",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Zlatna h.",
					"to": "Zlatna Tehnică",
					"leavesAt": "05:04",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Zlatna Tehnică",
					"to": "Feneş h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:18",
					"waitsAtSource": 180,
					"distance": 2400
				},
				{
					"from": "Feneş h.",
					"to": "Prisaca h.",
					"leavesAt": "05:19",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Prisaca h.",
					"to": "Poiana Ampoiului h.",
					"leavesAt": "05:24",
					"arrivesAt": "05:31",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Poiana Ampoiului h.",
					"to": "Văleni Meteş h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:36",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Văleni Meteş h.",
					"to": "Tăutu Ampoiului h.",
					"leavesAt": "05:37",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tăutu Ampoiului h.",
					"to": "Ampoiţa h.",
					"leavesAt": "05:44",
					"arrivesAt": "05:49",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ampoiţa h.",
					"to": "Şard Ighiu h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Şard Ighiu h.",
					"to": "Bărăbanţ Nord h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:02",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bărăbanţ Nord h.",
					"to": "Antestaţie Bărăbanţ h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:07",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Antestaţie Bărăbanţ h.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "06:08",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "06:13",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14806",
			"segments": [
				{
					"from": "Hârlău",
					"to": "Bădeni hc.",
					"leavesAt": "11:23",
					"arrivesAt": "11:27",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Bădeni hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "11:28",
					"arrivesAt": "11:32",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Cotnari hc.",
					"leavesAt": "11:33",
					"arrivesAt": "11:37",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cotnari hc.",
					"to": "Hodora h.",
					"leavesAt": "11:38",
					"arrivesAt": "11:43",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hodora h.",
					"to": "Podu Ulmi h.",
					"leavesAt": "11:44",
					"arrivesAt": "11:49",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Belceşti Hm.",
					"leavesAt": "11:50",
					"arrivesAt": "11:54",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Belceşti Hm.",
					"to": "Spinoasa h.",
					"leavesAt": "11:55",
					"arrivesAt": "12:06",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spinoasa h.",
					"to": "Erbiceni hc.",
					"leavesAt": "12:07",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Erbiceni hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "12:15",
					"arrivesAt": "12:24",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "12:29",
					"arrivesAt": "12:37",
					"waitsAtSource": 300,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "12:38",
					"arrivesAt": "12:53",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14302",
			"segments": [
				{
					"from": "Nădlac",
					"to": "Şeitin h.",
					"leavesAt": "12:35",
					"arrivesAt": "12:46",
					"waitsAtSource": 0,
					"distance": 8100
				},
				{
					"from": "Şeitin h.",
					"to": "Semlac h.",
					"leavesAt": "12:47",
					"arrivesAt": "12:59",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Semlac h.",
					"to": "Pecica",
					"leavesAt": "13:00",
					"arrivesAt": "13:24",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Pecica",
					"to": "Sântoma h.",
					"leavesAt": "13:25",
					"arrivesAt": "13:36",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Sântoma h.",
					"to": "Ferma Ciala h.",
					"leavesAt": "13:37",
					"arrivesAt": "13:43",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Arad Vest",
					"leavesAt": "13:44",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Arad Vest",
					"to": "Arad",
					"leavesAt": "13:53",
					"arrivesAt": "14:02",
					"waitsAtSource": 180,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14035",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "18:08",
					"arrivesAt": "18:25",
					"waitsAtSource": 0,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "18:31",
					"arrivesAt": "18:34",
					"waitsAtSource": 360,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "18:35",
					"arrivesAt": "18:43",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "18:44",
					"arrivesAt": "18:48",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "18:49",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "18:54",
					"arrivesAt": "19:02",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Vest",
					"leavesAt": "19:03",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "19:21",
					"arrivesAt": "19:27",
					"waitsAtSource": 480,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "19:28",
					"arrivesAt": "19:37",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "19:38",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "19:59",
					"arrivesAt": "20:04",
					"waitsAtSource": 480,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "20:13",
					"arrivesAt": "20:17",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Valea Largă Hm.",
					"leavesAt": "20:18",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Sinaia Sud h.",
					"leavesAt": "20:28",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "20:33",
					"arrivesAt": "20:36",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "20:37",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "20:43",
					"arrivesAt": "20:47",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "20:48",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "20:54",
					"arrivesAt": "21:05",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Dârste",
					"leavesAt": "21:06",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 20100
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "21:34",
					"arrivesAt": "21:43",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14430",
			"segments": [
				{
					"from": "Cermei hcv",
					"to": "Teuz h.",
					"leavesAt": "18:32",
					"arrivesAt": "18:37",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Teuz h.",
					"to": "Ineu",
					"leavesAt": "18:38",
					"arrivesAt": "18:50",
					"waitsAtSource": 30,
					"distance": 10600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18236",
			"segments": [
				{
					"from": "Reşiţa Nord",
					"to": "Câlnic h.",
					"leavesAt": "12:50",
					"arrivesAt": "12:53",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Câlnic h.",
					"to": "Moniom h.",
					"leavesAt": "12:54",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Moniom h.",
					"to": "Colţan h.",
					"leavesAt": "13:03",
					"arrivesAt": "13:09",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Colţan h.",
					"to": "Bocşa Montană hc.",
					"leavesAt": "13:10",
					"arrivesAt": "13:17",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Vasiova",
					"leavesAt": "13:18",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Română hc.",
					"leavesAt": "13:23",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Berzovia",
					"leavesAt": "13:29",
					"arrivesAt": "13:39",
					"waitsAtSource": 30,
					"distance": 8200
				},
				{
					"from": "Berzovia",
					"to": "Gherteniş hc.",
					"leavesAt": "13:50",
					"arrivesAt": "13:54",
					"waitsAtSource": 660,
					"distance": 3500
				},
				{
					"from": "Gherteniş hc.",
					"to": "Măureni hc.",
					"leavesAt": "13:55",
					"arrivesAt": "14:01",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Măureni hc.",
					"to": "Gătaia",
					"leavesAt": "14:02",
					"arrivesAt": "14:09",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Gătaia",
					"to": "Birda hcv.",
					"leavesAt": "14:10",
					"arrivesAt": "14:19",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Birda hcv.",
					"to": "Voiteni",
					"leavesAt": "14:20",
					"arrivesAt": "14:29",
					"waitsAtSource": 30,
					"distance": 9500
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "14:42",
					"arrivesAt": "14:52",
					"waitsAtSource": 780,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "14:53",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "14:58",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara C.E.T.",
					"leavesAt": "15:17",
					"arrivesAt": "15:22",
					"waitsAtSource": 780,
					"distance": 5300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişoara Sud",
					"leavesAt": "15:23",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "15:27",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "RGT",
			"number": "14088",
			"segments": [
				{
					"from": "Braşov",
					"to": "Predeal",
					"leavesAt": "06:20",
					"arrivesAt": "06:55",
					"waitsAtSource": 0,
					"distance": 26300
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "06:56",
					"arrivesAt": "07:04",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "07:05",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Sinaia",
					"leavesAt": "07:11",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sinaia",
					"to": "Comarnic",
					"leavesAt": "07:20",
					"arrivesAt": "07:34",
					"waitsAtSource": 60,
					"distance": 15100
				},
				{
					"from": "Comarnic",
					"to": "Breaza hc.",
					"leavesAt": "07:35",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "07:43",
					"arrivesAt": "07:51",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "07:52",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Ploieşti Vest",
					"leavesAt": "08:04",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 18600
				},
				{
					"from": "Ploieşti Vest",
					"to": "Chitila",
					"leavesAt": "08:23",
					"arrivesAt": "09:00",
					"waitsAtSource": 180,
					"distance": 49500
				},
				{
					"from": "Chitila",
					"to": "Bucureşti Băneasa",
					"leavesAt": "09:01",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Feteşti",
					"leavesAt": "09:19",
					"arrivesAt": "10:49",
					"waitsAtSource": 300,
					"distance": 139800
				},
				{
					"from": "Feteşti",
					"to": "Constanţa",
					"leavesAt": "10:53",
					"arrivesAt": "12:00",
					"waitsAtSource": 240,
					"distance": 78600
				}
			],
			"restrictions": [
				{
					"from": "20170616",
					"to": "20170903",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18232",
			"segments": [
				{
					"from": "Cruceni hcv.",
					"to": "Rudna hc.",
					"leavesAt": "15:20",
					"arrivesAt": "15:37",
					"waitsAtSource": 0,
					"distance": 11000
				},
				{
					"from": "Rudna hc.",
					"to": "Giulvăz h",
					"leavesAt": "15:38",
					"arrivesAt": "15:45",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Giulvăz h",
					"to": "Cebza h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:49",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Cebza h.",
					"to": "Peciu Nou h.",
					"leavesAt": "15:50",
					"arrivesAt": "15:59",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Peciu Nou h.",
					"to": "Parţa h.",
					"leavesAt": "16:00",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Parţa h.",
					"to": "Sânmihai h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:18",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Sânmihai h.",
					"to": "Utvin h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:23",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Utvin h.",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "16:24",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Timişoara Nord",
					"leavesAt": "16:43",
					"arrivesAt": "16:54",
					"waitsAtSource": 780,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14813",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "05:18",
					"arrivesAt": "05:31",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Movileni h",
					"leavesAt": "05:32",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Movileni h",
					"to": "Potângeni hc.",
					"leavesAt": "05:43",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Potângeni hc.",
					"to": "Larga Jijia Hm.",
					"leavesAt": "05:50",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Vlădeni",
					"leavesAt": "05:57",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vlădeni",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 480,
					"distance": 5600
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Şoldana hc.",
					"leavesAt": "06:24",
					"arrivesAt": "06:29",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Şoldana hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "06:30",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "06:36",
					"arrivesAt": "06:40",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Rediu hc.",
					"to": "Răuşeni hc.",
					"leavesAt": "06:41",
					"arrivesAt": "06:46",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Răuşeni hc.",
					"to": "Todireni Hm.",
					"leavesAt": "06:47",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Todireni Hm.",
					"to": "Jijia h.",
					"leavesAt": "07:05",
					"arrivesAt": "07:13",
					"waitsAtSource": 720,
					"distance": 8200
				},
				{
					"from": "Jijia h.",
					"to": "Zlătunoaia h",
					"leavesAt": "07:14",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zlătunoaia h",
					"to": "Truşeşti",
					"leavesAt": "07:20",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 9400
				}
			],
			"restrictions": [
				{
					"from": "20170107",
					"to": "20170205",
					"daysOfWeek": 799
				},
				{
					"from": "20170211",
					"to": "20170418",
					"daysOfWeek": 799
				},
				{
					"from": "20170422",
					"to": "20170423",
					"daysOfWeek": 799
				},
				{
					"from": "20170429",
					"to": "20170618",
					"daysOfWeek": 799
				},
				{
					"from": "20170624",
					"to": "20170625",
					"daysOfWeek": 799
				},
				{
					"from": "20170701",
					"to": "20170702",
					"daysOfWeek": 799
				},
				{
					"from": "20170708",
					"to": "20170709",
					"daysOfWeek": 799
				},
				{
					"from": "20170715",
					"to": "20170716",
					"daysOfWeek": 799
				},
				{
					"from": "20170722",
					"to": "20170723",
					"daysOfWeek": 799
				},
				{
					"from": "20170729",
					"to": "20170730",
					"daysOfWeek": 799
				},
				{
					"from": "20170805",
					"to": "20170806",
					"daysOfWeek": 799
				},
				{
					"from": "20170812",
					"to": "20170813",
					"daysOfWeek": 799
				},
				{
					"from": "20170819",
					"to": "20170820",
					"daysOfWeek": 799
				},
				{
					"from": "20170826",
					"to": "20170827",
					"daysOfWeek": 799
				},
				{
					"from": "20170902",
					"to": "20170903",
					"daysOfWeek": 799
				},
				{
					"from": "20170909",
					"to": "20171209",
					"daysOfWeek": 799
				},
				{
					"from": "20161211",
					"to": "20161225",
					"daysOfWeek": 799
				},
				{
					"from": "20161231",
					"to": "20170101",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14019",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "20:40",
					"arrivesAt": "20:43",
					"waitsAtSource": 0,
					"distance": 900
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Sărata h.",
					"leavesAt": "20:44",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel",
					"leavesAt": "20:52",
					"arrivesAt": "20:57",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sărăţel",
					"to": "Arcalia hc.",
					"leavesAt": "20:58",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "21:03",
					"arrivesAt": "21:06",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Chintelnic h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:11",
					"waitsAtSource": 60,
					"distance": 2314
				},
				{
					"from": "Chintelnic h.",
					"to": "Chiraleş h.",
					"leavesAt": "21:12",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 2276
				},
				{
					"from": "Chiraleş h.",
					"to": "Ţigău h.",
					"leavesAt": "21:16",
					"arrivesAt": "21:21",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ţigău h.",
					"to": "Lechinţa",
					"leavesAt": "21:22",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lechinţa",
					"to": "Vermeş h.",
					"leavesAt": "21:30",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Vermeş h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "21:34",
					"arrivesAt": "21:43",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Brăteni h.",
					"leavesAt": "21:44",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Brăteni h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "21:51",
					"arrivesAt": "21:58",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "21:59",
					"arrivesAt": "22:04",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Budeşti Cluj h.",
					"leavesAt": "22:05",
					"arrivesAt": "22:15",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Budeşti Cluj h.",
					"to": "Ţagu h.",
					"leavesAt": "22:16",
					"arrivesAt": "22:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ţagu h.",
					"to": "Ţagu Sat h.",
					"leavesAt": "22:25",
					"arrivesAt": "22:28",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ţagu Sat h.",
					"to": "Ţăgşor h.",
					"leavesAt": "22:29",
					"arrivesAt": "22:35",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ţăgşor h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "22:36",
					"arrivesAt": "22:40",
					"waitsAtSource": 60,
					"distance": 2000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14327",
			"segments": [
				{
					"from": "Lovrin",
					"to": "Gotlob h.",
					"leavesAt": "21:27",
					"arrivesAt": "21:33",
					"waitsAtSource": 0,
					"distance": 6400
				},
				{
					"from": "Gotlob h.",
					"to": "Comloşu Mare h.",
					"leavesAt": "21:34",
					"arrivesAt": "21:42",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Teremia Banat hc.",
					"leavesAt": "21:43",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Nerău hcv.",
					"leavesAt": "21:54",
					"arrivesAt": "22:02",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14437",
			"segments": [
				{
					"from": "Vârfurile Hm.",
					"to": "Cariera Leasa h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:54",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Cariera Leasa h.",
					"to": "Hălmagiu Hm.",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Hălmagiu Hm.",
					"to": "Ocişor h.",
					"leavesAt": "06:01",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ocişor h.",
					"to": "Ociu h.",
					"leavesAt": "06:07",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ociu h.",
					"to": "Vaţa h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:15",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Vaţa h.",
					"to": "Birtin h.",
					"leavesAt": "06:16",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Birtin h.",
					"to": "Lunca Moţilor h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lunca Moţilor h.",
					"to": "Baia de Criş h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:31",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Baia de Criş h.",
					"to": "Ţebea h",
					"leavesAt": "06:32",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ţebea h",
					"to": "Ribiţa h.",
					"leavesAt": "06:36",
					"arrivesAt": "06:39",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Ribiţa h.",
					"to": "Brad",
					"leavesAt": "06:40",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14513",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "16:14",
					"arrivesAt": "16:24",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara C.E.T.",
					"leavesAt": "16:26",
					"arrivesAt": "16:29",
					"waitsAtSource": 120,
					"distance": 2300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişeni Hm.",
					"leavesAt": "16:30",
					"arrivesAt": "16:36",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişeni Hm.",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "16:37",
					"arrivesAt": "16:43",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Jebel",
					"leavesAt": "16:44",
					"arrivesAt": "16:50",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Jebel",
					"to": "Voiteni",
					"leavesAt": "16:51",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Voiteni",
					"to": "Birda hcv.",
					"leavesAt": "17:03",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Birda hcv.",
					"to": "Gătaia",
					"leavesAt": "17:15",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Gătaia",
					"to": "Măureni hc.",
					"leavesAt": "17:48",
					"arrivesAt": "17:55",
					"waitsAtSource": 1440,
					"distance": 6700
				},
				{
					"from": "Măureni hc.",
					"to": "Gherteniş hc.",
					"leavesAt": "17:56",
					"arrivesAt": "18:02",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gherteniş hc.",
					"to": "Berzovia",
					"leavesAt": "18:03",
					"arrivesAt": "18:07",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Berzovia",
					"to": "Bocşa Română hc.",
					"leavesAt": "18:08",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Vasiova",
					"leavesAt": "18:19",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Montană hc.",
					"leavesAt": "18:26",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Colţan h.",
					"leavesAt": "18:31",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Colţan h.",
					"to": "Moniom h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moniom h.",
					"to": "Câlnic h.",
					"leavesAt": "18:45",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "18:54",
					"arrivesAt": "18:57",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14428",
			"segments": [
				{
					"from": "Cermei hcv",
					"to": "Teuz h.",
					"leavesAt": "16:40",
					"arrivesAt": "16:45",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Teuz h.",
					"to": "Ineu",
					"leavesAt": "16:46",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 10600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14600",
			"segments": [
				{
					"from": "Târnaveni",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "04:53",
					"waitsAtSource": 0,
					"distance": 2400
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Adămuş h.",
					"leavesAt": "04:54",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Adămuş h.",
					"to": "Corneşti Târnava h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:01",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Corneşti Târnava h.",
					"to": "Crăieşti h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:05",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Crăieşti h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "05:06",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 5160
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Feisa h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Feisa h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "05:18",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Bălcaci h.",
					"leavesAt": "05:30",
					"arrivesAt": "05:33",
					"waitsAtSource": 480,
					"distance": 2800
				},
				{
					"from": "Bălcaci h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:37",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Şona h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Şona h.",
					"to": "Pănade h.",
					"leavesAt": "05:43",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pănade h.",
					"to": "Sâncel h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 1654
				},
				{
					"from": "Sâncel h.",
					"to": "Blaj",
					"leavesAt": "05:53",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 4246
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14701",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "06:00",
					"arrivesAt": "06:05",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "06:06",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "06:14",
					"arrivesAt": "06:18",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "06:19",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "06:33",
					"arrivesAt": "06:35",
					"waitsAtSource": 540,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "06:36",
					"arrivesAt": "06:41",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "06:42",
					"arrivesAt": "06:45",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "06:46",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14971",
			"segments": [
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "05:10",
					"arrivesAt": "05:14",
					"waitsAtSource": 0,
					"distance": 2500
				},
				{
					"from": "Hătcărău h.",
					"to": "Ciorani Hm.",
					"leavesAt": "05:15",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ciorani Hm.",
					"to": "Fulga hc.",
					"leavesAt": "05:22",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Fulga hc.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "05:28",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "05:35",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "05:46",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14322",
			"segments": [
				{
					"from": "Nerău hcv.",
					"to": "Teremia Banat hc.",
					"leavesAt": "16:42",
					"arrivesAt": "16:48",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Comloşu Mare h.",
					"leavesAt": "16:49",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Gotlob h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:06",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Gotlob h.",
					"to": "Lovrin",
					"leavesAt": "17:07",
					"arrivesAt": "17:14",
					"waitsAtSource": 30,
					"distance": 6400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14677",
			"segments": [
				{
					"from": "Zlatna hcv.",
					"to": "Zlatna h.",
					"leavesAt": "21:10",
					"arrivesAt": "21:14",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Zlatna h.",
					"to": "Zlatna Tehnică",
					"leavesAt": "21:15",
					"arrivesAt": "21:21",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Zlatna Tehnică",
					"to": "Feneş h.",
					"leavesAt": "21:24",
					"arrivesAt": "21:29",
					"waitsAtSource": 180,
					"distance": 2400
				},
				{
					"from": "Feneş h.",
					"to": "Prisaca h.",
					"leavesAt": "21:30",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Prisaca h.",
					"to": "Poiana Ampoiului h.",
					"leavesAt": "21:35",
					"arrivesAt": "21:42",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Poiana Ampoiului h.",
					"to": "Văleni Meteş h.",
					"leavesAt": "21:43",
					"arrivesAt": "21:47",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Văleni Meteş h.",
					"to": "Tăutu Ampoiului h.",
					"leavesAt": "21:48",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tăutu Ampoiului h.",
					"to": "Ampoiţa h.",
					"leavesAt": "21:55",
					"arrivesAt": "22:00",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ampoiţa h.",
					"to": "Şard Ighiu h.",
					"leavesAt": "22:01",
					"arrivesAt": "22:05",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Şard Ighiu h.",
					"to": "Bărăbanţ Nord h.",
					"leavesAt": "22:06",
					"arrivesAt": "22:13",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bărăbanţ Nord h.",
					"to": "Antestaţie Bărăbanţ h.",
					"leavesAt": "22:14",
					"arrivesAt": "22:18",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Antestaţie Bărăbanţ h.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "22:19",
					"arrivesAt": "22:23",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "22:28",
					"arrivesAt": "22:35",
					"waitsAtSource": 300,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "RGT",
			"number": "14067",
			"segments": [
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "09:28",
					"arrivesAt": "09:33",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "09:34",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "10:07",
					"arrivesAt": "10:41",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "10:42",
					"arrivesAt": "11:12",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "11:13",
					"arrivesAt": "11:51",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "11:52",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Tecuci Nord hc.(605)",
					"leavesAt": "12:20",
					"arrivesAt": "12:43",
					"waitsAtSource": 360,
					"distance": 17800
				},
				{
					"from": "Tecuci Nord hc.(605)",
					"to": "Bârlad",
					"leavesAt": "12:44",
					"arrivesAt": "13:27",
					"waitsAtSource": 60,
					"distance": 48600
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "13:28",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "13:57",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "14:12",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "14:31",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "14:57",
					"arrivesAt": "15:12",
					"waitsAtSource": 120,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "15:14",
					"arrivesAt": "15:22",
					"waitsAtSource": 120,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 353
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14825",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "18:49",
					"arrivesAt": "19:02",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Movileni h",
					"leavesAt": "19:03",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Movileni h",
					"to": "Potângeni hc.",
					"leavesAt": "19:14",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Potângeni hc.",
					"to": "Larga Jijia Hm.",
					"leavesAt": "19:21",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Vlădeni",
					"leavesAt": "19:28",
					"arrivesAt": "19:40",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vlădeni",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "19:41",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Şoldana hc.",
					"leavesAt": "19:47",
					"arrivesAt": "19:52",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Şoldana hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "19:53",
					"arrivesAt": "19:58",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "19:59",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Rediu hc.",
					"to": "Răuşeni hc.",
					"leavesAt": "20:04",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Răuşeni hc.",
					"to": "Todireni Hm.",
					"leavesAt": "20:10",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Todireni Hm.",
					"to": "Jijia h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:33",
					"waitsAtSource": 480,
					"distance": 8200
				},
				{
					"from": "Jijia h.",
					"to": "Zlătunoaia h",
					"leavesAt": "20:34",
					"arrivesAt": "20:39",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zlătunoaia h",
					"to": "Truşeşti",
					"leavesAt": "20:40",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Truşeşti",
					"to": "Buhăceni h.",
					"leavesAt": "20:49",
					"arrivesAt": "20:55",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Buhăceni h.",
					"to": "Dângeni",
					"leavesAt": "20:56",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dângeni",
					"to": "Dângeni Nord h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:09",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Ungureni Hm.",
					"leavesAt": "21:10",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Ungureni Hm.",
					"to": "Mândreşti h.",
					"leavesAt": "21:19",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mândreşti h.",
					"to": "Vorniceni h.",
					"leavesAt": "21:25",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vorniceni h.",
					"to": "Mateieni h.",
					"leavesAt": "21:33",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Mateieni h.",
					"to": "Corlăteni h",
					"leavesAt": "21:38",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Corlăteni h",
					"to": "Carasa h.",
					"leavesAt": "21:43",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Carasa h.",
					"to": "Broscăuţi h.",
					"leavesAt": "21:47",
					"arrivesAt": "21:53",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Broscăuţi h.",
					"to": "Dorohoi",
					"leavesAt": "21:54",
					"arrivesAt": "22:04",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14816",
			"segments": [
				{
					"from": "Dorohoi",
					"to": "Broscăuţi h.",
					"leavesAt": "05:22",
					"arrivesAt": "05:28",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Broscăuţi h.",
					"to": "Carasa h.",
					"leavesAt": "05:29",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Carasa h.",
					"to": "Corlăteni h",
					"leavesAt": "05:37",
					"arrivesAt": "05:40",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Corlăteni h",
					"to": "Mateieni h.",
					"leavesAt": "05:41",
					"arrivesAt": "05:45",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mateieni h.",
					"to": "Vorniceni h.",
					"leavesAt": "05:46",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Vorniceni h.",
					"to": "Mândreşti h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:59",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mândreşti h.",
					"to": "Ungureni Hm.",
					"leavesAt": "06:00",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ungureni Hm.",
					"to": "Dângeni Nord h.",
					"leavesAt": "06:07",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Dângeni",
					"leavesAt": "06:16",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni",
					"to": "Buhăceni h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:28",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Buhăceni h.",
					"to": "Truşeşti",
					"leavesAt": "06:29",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Truşeşti",
					"to": "Zlătunoaia h",
					"leavesAt": "06:36",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Zlătunoaia h",
					"to": "Jijia h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:52",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Jijia h.",
					"to": "Todireni Hm.",
					"leavesAt": "06:53",
					"arrivesAt": "07:01",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Todireni Hm.",
					"to": "Răuşeni hc.",
					"leavesAt": "07:03",
					"arrivesAt": "07:09",
					"waitsAtSource": 120,
					"distance": 6400
				},
				{
					"from": "Răuşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "07:10",
					"arrivesAt": "07:15",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rediu hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "07:16",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Şoldana hc.",
					"leavesAt": "07:22",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Şoldana hc.",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "07:28",
					"arrivesAt": "07:33",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Vlădeni",
					"leavesAt": "07:34",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Vlădeni",
					"to": "Larga Jijia Hm.",
					"leavesAt": "07:48",
					"arrivesAt": "07:59",
					"waitsAtSource": 480,
					"distance": 10800
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Potângeni hc.",
					"leavesAt": "08:00",
					"arrivesAt": "08:06",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Potângeni hc.",
					"to": "Movileni h",
					"leavesAt": "08:07",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Movileni h",
					"to": "Leţcani",
					"leavesAt": "08:16",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "08:27",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14018",
			"segments": [
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "12:50",
					"arrivesAt": "12:55",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Brăteni h.",
					"leavesAt": "12:56",
					"arrivesAt": "13:03",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Brăteni h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "13:04",
					"arrivesAt": "13:10",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Vermeş h.",
					"leavesAt": "13:11",
					"arrivesAt": "13:19",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vermeş h.",
					"to": "Lechinţa",
					"leavesAt": "13:20",
					"arrivesAt": "13:24",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Lechinţa",
					"to": "Ţigău h.",
					"leavesAt": "13:25",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ţigău h.",
					"to": "Chiraleş h.",
					"leavesAt": "13:33",
					"arrivesAt": "13:37",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiraleş h.",
					"to": "Chintelnic h.",
					"leavesAt": "13:38",
					"arrivesAt": "13:42",
					"waitsAtSource": 30,
					"distance": 2276
				},
				{
					"from": "Chintelnic h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "13:43",
					"arrivesAt": "13:47",
					"waitsAtSource": 30,
					"distance": 2314
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "13:48",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel",
					"leavesAt": "13:51",
					"arrivesAt": "13:57",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel",
					"to": "Sărata h.",
					"leavesAt": "13:58",
					"arrivesAt": "14:03",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "14:04",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "14:12",
					"arrivesAt": "14:15",
					"waitsAtSource": 60,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14553",
			"segments": [
				{
					"from": "Sărmăşel hcv .",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "06:10",
					"arrivesAt": "06:13",
					"waitsAtSource": 0,
					"distance": 2000
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmaşu h.",
					"leavesAt": "06:14",
					"arrivesAt": "06:18",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sărmaşu h.",
					"to": "Balda h.",
					"leavesAt": "06:19",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Balda h.",
					"to": "Miheşu de Câmpie Sat h.",
					"leavesAt": "06:24",
					"arrivesAt": "06:30",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Miheşu de Câmpie Sat h.",
					"to": "Miheşu de Câmpie h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:37",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Miheşu de Câmpie h.",
					"to": "Bota Sat h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:44",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bota Sat h.",
					"to": "Zau de Câmpie h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Zau de Câmpie h.",
					"to": "Melini Valea Largă h.",
					"leavesAt": "06:51",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Melini Valea Largă h.",
					"to": "Tăureni h.",
					"leavesAt": "06:55",
					"arrivesAt": "06:59",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Tăureni h.",
					"to": "Sânger Tăureni h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 5620
				},
				{
					"from": "Sânger Tăureni h.",
					"to": "Luduş Sat hc.",
					"leavesAt": "07:09",
					"arrivesAt": "07:20",
					"waitsAtSource": 30,
					"distance": 8080
				},
				{
					"from": "Luduş Sat hc.",
					"to": "Luduş",
					"leavesAt": "07:21",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 2400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14367",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "19:42",
					"arrivesAt": "19:49",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Zădăreni Hm.",
					"leavesAt": "19:50",
					"arrivesAt": "20:00",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "20:01",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Felnac hc.",
					"leavesAt": "20:05",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Felnac hc.",
					"to": "Sânpetru German h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sânpetru German h.",
					"to": "Munor h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Munor h.",
					"to": "Secusigiu h",
					"leavesAt": "20:24",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Secusigiu h",
					"to": "Aranca h.",
					"leavesAt": "20:29",
					"arrivesAt": "20:32",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Aranca h.",
					"to": "Periam",
					"leavesAt": "20:33",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Periam",
					"to": "Sânpetru h.",
					"leavesAt": "20:57",
					"arrivesAt": "21:03",
					"waitsAtSource": 720,
					"distance": 4500
				},
				{
					"from": "Sânpetru h.",
					"to": "Saravale h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Saravale h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "21:13",
					"arrivesAt": "21:23",
					"waitsAtSource": 30,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14364",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Saravale h.",
					"leavesAt": "12:04",
					"arrivesAt": "12:14",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Saravale h.",
					"to": "Sânpetru h.",
					"leavesAt": "12:15",
					"arrivesAt": "12:24",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Sânpetru h.",
					"to": "Periam",
					"leavesAt": "12:25",
					"arrivesAt": "12:32",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Periam",
					"to": "Aranca h.",
					"leavesAt": "12:40",
					"arrivesAt": "12:50",
					"waitsAtSource": 480,
					"distance": 11100
				},
				{
					"from": "Aranca h.",
					"to": "Secusigiu h",
					"leavesAt": "12:51",
					"arrivesAt": "12:54",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Secusigiu h",
					"to": "Munor h.",
					"leavesAt": "12:55",
					"arrivesAt": "12:59",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Munor h.",
					"to": "Sânpetru German h.",
					"leavesAt": "13:00",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sânpetru German h.",
					"to": "Felnac hc.",
					"leavesAt": "13:04",
					"arrivesAt": "13:11",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Felnac hc.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "13:12",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Zădăreni Hm.",
					"leavesAt": "13:18",
					"arrivesAt": "13:22",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Aradu Nou",
					"leavesAt": "13:23",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "13:36",
					"arrivesAt": "13:43",
					"waitsAtSource": 180,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14717",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "22:30",
					"arrivesAt": "22:36",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "22:38",
					"arrivesAt": "22:46",
					"waitsAtSource": 120,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "22:47",
					"arrivesAt": "22:50",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "22:51",
					"arrivesAt": "22:55",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "22:56",
					"arrivesAt": "22:58",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "22:59",
					"arrivesAt": "23:04",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "23:05",
					"arrivesAt": "23:08",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "23:09",
					"arrivesAt": "23:12",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14500",
			"segments": [
				{
					"from": "Reşiţa Nord",
					"to": "Câlnic h.",
					"leavesAt": "04:01",
					"arrivesAt": "04:04",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Câlnic h.",
					"to": "Moniom h.",
					"leavesAt": "04:05",
					"arrivesAt": "04:13",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Moniom h.",
					"to": "Colţan h.",
					"leavesAt": "04:14",
					"arrivesAt": "04:19",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Colţan h.",
					"to": "Bocşa Montană hc.",
					"leavesAt": "04:20",
					"arrivesAt": "04:27",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Vasiova",
					"leavesAt": "04:28",
					"arrivesAt": "04:32",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Română hc.",
					"leavesAt": "04:33",
					"arrivesAt": "04:38",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Berzovia",
					"leavesAt": "04:39",
					"arrivesAt": "04:49",
					"waitsAtSource": 30,
					"distance": 8200
				},
				{
					"from": "Berzovia",
					"to": "Gherteniş hc.",
					"leavesAt": "04:50",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gherteniş hc.",
					"to": "Măureni hc.",
					"leavesAt": "04:55",
					"arrivesAt": "05:01",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Măureni hc.",
					"to": "Gătaia",
					"leavesAt": "05:02",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Gătaia",
					"to": "Birda hcv.",
					"leavesAt": "05:11",
					"arrivesAt": "05:20",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Birda hcv.",
					"to": "Voiteni",
					"leavesAt": "05:21",
					"arrivesAt": "05:30",
					"waitsAtSource": 30,
					"distance": 9500
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "05:33",
					"arrivesAt": "05:43",
					"waitsAtSource": 180,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "05:44",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "05:49",
					"arrivesAt": "05:55",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara C.E.T.",
					"leavesAt": "05:56",
					"arrivesAt": "06:01",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişoara Sud",
					"leavesAt": "06:02",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "06:06",
					"arrivesAt": "06:15",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14420",
			"segments": [
				{
					"from": "Cermei hcv",
					"to": "Teuz h.",
					"leavesAt": "07:10",
					"arrivesAt": "07:15",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Teuz h.",
					"to": "Ineu",
					"leavesAt": "07:16",
					"arrivesAt": "07:28",
					"waitsAtSource": 30,
					"distance": 10600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 895
				}
			]
		},
		{
			"type": "IR",
			"operator": "RGT",
			"number": "14089",
			"segments": [
				{
					"from": "Constanţa",
					"to": "Bucureşti Băneasa",
					"leavesAt": "16:30",
					"arrivesAt": "18:57",
					"waitsAtSource": 0,
					"distance": 218400
				},
				{
					"from": "Bucureşti Băneasa",
					"to": "Ploieşti Vest",
					"leavesAt": "18:59",
					"arrivesAt": "19:50",
					"waitsAtSource": 120,
					"distance": 58100
				},
				{
					"from": "Ploieşti Vest",
					"to": "Floreşti Prahova",
					"leavesAt": "20:08",
					"arrivesAt": "20:22",
					"waitsAtSource": 1080,
					"distance": 18600
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "20:23",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "20:36",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Comarnic",
					"leavesAt": "20:42",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 9000
				},
				{
					"from": "Comarnic",
					"to": "Sinaia",
					"leavesAt": "20:50",
					"arrivesAt": "21:03",
					"waitsAtSource": 60,
					"distance": 15100
				},
				{
					"from": "Sinaia",
					"to": "Buşteni",
					"leavesAt": "21:05",
					"arrivesAt": "21:13",
					"waitsAtSource": 120,
					"distance": 7600
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "21:14",
					"arrivesAt": "21:19",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "21:20",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Braşov",
					"leavesAt": "21:33",
					"arrivesAt": "22:10",
					"waitsAtSource": 120,
					"distance": 26300
				}
			],
			"restrictions": [
				{
					"from": "20170616",
					"to": "20170903",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14736",
			"segments": [
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "15:00",
					"arrivesAt": "15:06",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "15:07",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "15:12",
					"arrivesAt": "15:19",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:29",
					"waitsAtSource": 420,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "15:30",
					"arrivesAt": "15:36",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:41",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "15:42",
					"arrivesAt": "15:46",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14740",
			"segments": [
				{
					"from": "Breţcu Hm.",
					"to": "Lemnia h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:49",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Lemnia h.",
					"to": "Mereni Lutoasa h.",
					"leavesAt": "19:50",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Mereni Lutoasa h.",
					"to": "Bălani h.",
					"leavesAt": "19:56",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bălani h.",
					"to": "Poieniţa h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:07",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Poieniţa h.",
					"to": "Sânzieni h.",
					"leavesAt": "20:08",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Sânzieni h.",
					"to": "Târgu Secuiesc",
					"leavesAt": "20:13",
					"arrivesAt": "20:25",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Târgu Secuiesc",
					"to": "Cătălina h.",
					"leavesAt": "20:51",
					"arrivesAt": "20:56",
					"waitsAtSource": 1560,
					"distance": 4400
				},
				{
					"from": "Cătălina h.",
					"to": "Imeci Hm.",
					"leavesAt": "20:57",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Imeci Hm.",
					"to": "Zăbala h.",
					"leavesAt": "21:01",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Zăbala h.",
					"to": "Covasna Hm.",
					"leavesAt": "21:08",
					"arrivesAt": "21:13",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Covasna Hm.",
					"to": "Brateş h.",
					"leavesAt": "21:14",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Brateş h.",
					"to": "Ţufalău h.",
					"leavesAt": "21:23",
					"arrivesAt": "21:27",
					"waitsAtSource": 30,
					"distance": 3020
				},
				{
					"from": "Ţufalău h.",
					"to": "Boroşneu Mare h.",
					"leavesAt": "21:28",
					"arrivesAt": "21:31",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boroşneu Mare h.",
					"to": "Biţa h.",
					"leavesAt": "21:32",
					"arrivesAt": "21:37",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Biţa h.",
					"to": "Moacşa hcv",
					"leavesAt": "21:38",
					"arrivesAt": "21:43",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Moacşa hcv",
					"to": "Angheluş h.",
					"leavesAt": "21:44",
					"arrivesAt": "21:50",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Angheluş h.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "21:51",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14320",
			"segments": [
				{
					"from": "Nerău hcv.",
					"to": "Teremia Banat hc.",
					"leavesAt": "11:27",
					"arrivesAt": "11:35",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Comloşu Mare h.",
					"leavesAt": "11:36",
					"arrivesAt": "11:45",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Gotlob h.",
					"leavesAt": "11:46",
					"arrivesAt": "11:54",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Gotlob h.",
					"to": "Lovrin",
					"leavesAt": "11:55",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "12:07",
					"arrivesAt": "12:14",
					"waitsAtSource": 300,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Pesac h.",
					"leavesAt": "12:15",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pesac h.",
					"to": "Periam",
					"leavesAt": "12:24",
					"arrivesAt": "12:36",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Periam",
					"to": "Variaş hc.",
					"leavesAt": "12:37",
					"arrivesAt": "12:46",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Variaş hc.",
					"to": "Gelu hc.",
					"leavesAt": "12:47",
					"arrivesAt": "12:53",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Gelu hc.",
					"to": "Bărăteaz h.",
					"leavesAt": "12:54",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bărăteaz h.",
					"to": "Chinezu h.",
					"leavesAt": "12:58",
					"arrivesAt": "13:02",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Chinezu h.",
					"to": "Hodoni h.",
					"leavesAt": "13:03",
					"arrivesAt": "13:08",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Hodoni h.",
					"to": "Sânandrei Hm.",
					"leavesAt": "13:09",
					"arrivesAt": "13:17",
					"waitsAtSource": 30,
					"distance": 8600
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "13:26",
					"arrivesAt": "13:31",
					"waitsAtSource": 540,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "13:32",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "13:34",
					"arrivesAt": "13:36",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "13:37",
					"arrivesAt": "13:44",
					"waitsAtSource": 30,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14425",
			"segments": [
				{
					"from": "Ineu",
					"to": "Teuz h.",
					"leavesAt": "14:20",
					"arrivesAt": "14:31",
					"waitsAtSource": 0,
					"distance": 10600
				},
				{
					"from": "Teuz h.",
					"to": "Cermei hcv",
					"leavesAt": "14:32",
					"arrivesAt": "14:38",
					"waitsAtSource": 30,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14012",
			"segments": [
				{
					"from": "Sărmăşel hcv .",
					"to": "Ţăgşor h.",
					"leavesAt": "04:00",
					"arrivesAt": "04:04",
					"waitsAtSource": 0,
					"distance": 2000
				},
				{
					"from": "Ţăgşor h.",
					"to": "Ţagu Sat h.",
					"leavesAt": "04:05",
					"arrivesAt": "04:11",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ţagu Sat h.",
					"to": "Ţagu h.",
					"leavesAt": "04:12",
					"arrivesAt": "04:15",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ţagu h.",
					"to": "Budeşti Cluj h.",
					"leavesAt": "04:16",
					"arrivesAt": "04:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Budeşti Cluj h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "04:25",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Brăteni h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:50",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Brăteni h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "04:51",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Vermeş h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vermeş h.",
					"to": "Lechinţa",
					"leavesAt": "05:08",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Lechinţa",
					"to": "Ţigău h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:24",
					"waitsAtSource": 300,
					"distance": 5000
				},
				{
					"from": "Ţigău h.",
					"to": "Chiraleş h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:30",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiraleş h.",
					"to": "Chintelnic h.",
					"leavesAt": "05:31",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 2276
				},
				{
					"from": "Chintelnic h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "05:36",
					"arrivesAt": "05:41",
					"waitsAtSource": 60,
					"distance": 2314
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "05:42",
					"arrivesAt": "05:44",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel",
					"leavesAt": "05:45",
					"arrivesAt": "05:51",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel",
					"to": "Sărata h.",
					"leavesAt": "05:53",
					"arrivesAt": "05:58",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "05:59",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "06:07",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14802",
			"segments": [
				{
					"from": "Hârlău",
					"to": "Bădeni hc.",
					"leavesAt": "05:05",
					"arrivesAt": "05:09",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Bădeni hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "05:10",
					"arrivesAt": "05:14",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Cotnari hc.",
					"leavesAt": "05:15",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cotnari hc.",
					"to": "Hodora h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hodora h.",
					"to": "Podu Ulmi h.",
					"leavesAt": "05:26",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Belceşti Hm.",
					"leavesAt": "05:32",
					"arrivesAt": "05:36",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Belceşti Hm.",
					"to": "Spinoasa h.",
					"leavesAt": "05:37",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spinoasa h.",
					"to": "Erbiceni hc.",
					"leavesAt": "05:49",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Erbiceni hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "05:57",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "06:11",
					"arrivesAt": "06:19",
					"waitsAtSource": 300,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "06:20",
					"arrivesAt": "06:35",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14803",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "09:24",
					"arrivesAt": "09:35",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "09:36",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Erbiceni hc.",
					"leavesAt": "09:52",
					"arrivesAt": "10:01",
					"waitsAtSource": 480,
					"distance": 6000
				},
				{
					"from": "Erbiceni hc.",
					"to": "Spinoasa h.",
					"leavesAt": "10:02",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Spinoasa h.",
					"to": "Belceşti Hm.",
					"leavesAt": "10:11",
					"arrivesAt": "10:22",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Belceşti Hm.",
					"to": "Podu Ulmi h.",
					"leavesAt": "10:23",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Hodora h.",
					"leavesAt": "10:29",
					"arrivesAt": "10:34",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Hodora h.",
					"to": "Cotnari hc.",
					"leavesAt": "10:35",
					"arrivesAt": "10:40",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Cotnari hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "10:41",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Bădeni hc.",
					"leavesAt": "10:46",
					"arrivesAt": "10:51",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bădeni hc.",
					"to": "Hârlău",
					"leavesAt": "10:52",
					"arrivesAt": "10:57",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14033",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "11:40",
					"arrivesAt": "11:55",
					"waitsAtSource": 0,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "11:56",
					"arrivesAt": "12:00",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "12:01",
					"arrivesAt": "12:09",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "12:10",
					"arrivesAt": "12:15",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "12:16",
					"arrivesAt": "12:20",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "12:21",
					"arrivesAt": "12:30",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Vest",
					"leavesAt": "12:31",
					"arrivesAt": "12:41",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "12:50",
					"arrivesAt": "12:57",
					"waitsAtSource": 540,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "12:58",
					"arrivesAt": "13:07",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "13:13",
					"arrivesAt": "13:26",
					"waitsAtSource": 360,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "13:27",
					"arrivesAt": "13:32",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "13:33",
					"arrivesAt": "13:36",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "13:37",
					"arrivesAt": "13:40",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "13:41",
					"arrivesAt": "13:45",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Valea Largă Hm.",
					"leavesAt": "13:46",
					"arrivesAt": "13:55",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Sinaia Sud h.",
					"leavesAt": "13:56",
					"arrivesAt": "14:00",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "14:01",
					"arrivesAt": "14:04",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "14:05",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "14:11",
					"arrivesAt": "14:15",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "14:16",
					"arrivesAt": "14:21",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "14:22",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Dârste",
					"leavesAt": "14:35",
					"arrivesAt": "15:04",
					"waitsAtSource": 120,
					"distance": 20100
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "15:05",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14981",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Dâmbu Hm.",
					"leavesAt": "15:47",
					"arrivesAt": "15:52",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "15:53",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Râfov h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Râfov h.",
					"to": "Trestieni h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:07",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Trestieni h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "16:08",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Cornurile h.",
					"leavesAt": "16:12",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cornurile h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "16:18",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Hătcărău h.",
					"to": "Ciorani Hm.",
					"leavesAt": "16:28",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ciorani Hm.",
					"to": "Fulga hc.",
					"leavesAt": "16:35",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Fulga hc.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "16:40",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "16:47",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "16:59",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 799
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14392",
			"segments": [
				{
					"from": "Cenad h.",
					"to": "Sânnicolau Nord h.",
					"leavesAt": "16:47",
					"arrivesAt": "17:09",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Sânnicolau Nord h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "17:10",
					"arrivesAt": "17:22",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Sânnicolau Mare",
					"to": "Tomnaticu h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Tomnaticu h.",
					"to": "Lovrin",
					"leavesAt": "17:34",
					"arrivesAt": "17:47",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "17:48",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Şandra h.",
					"leavesAt": "17:56",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şandra h.",
					"to": "Biled",
					"leavesAt": "18:12",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Biled",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "18:25",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "18:46",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "18:59",
					"arrivesAt": "19:06",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "19:10",
					"arrivesAt": "19:14",
					"waitsAtSource": 240,
					"distance": 2500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "19:15",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14393",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "19:43",
					"arrivesAt": "19:53",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "19:54",
					"arrivesAt": "20:01",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "20:02",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Biled",
					"leavesAt": "20:13",
					"arrivesAt": "20:33",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Biled",
					"to": "Şandra h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:44",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Şandra h.",
					"to": "Satu Nou Hm.",
					"leavesAt": "20:45",
					"arrivesAt": "20:58",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Lovrin",
					"leavesAt": "20:59",
					"arrivesAt": "21:06",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lovrin",
					"to": "Tomnaticu h.",
					"leavesAt": "21:07",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Tomnaticu h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "21:19",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14426",
			"segments": [
				{
					"from": "Cermei hcv",
					"to": "Teuz h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Teuz h.",
					"to": "Ineu",
					"leavesAt": "14:51",
					"arrivesAt": "15:03",
					"waitsAtSource": 30,
					"distance": 10600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14542",
			"segments": [
				{
					"from": "Cruceni hcv.",
					"to": "Rudna hc.",
					"leavesAt": "09:10",
					"arrivesAt": "09:28",
					"waitsAtSource": 0,
					"distance": 11000
				},
				{
					"from": "Rudna hc.",
					"to": "Giulvăz h",
					"leavesAt": "09:29",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Giulvăz h",
					"to": "Cebza h.",
					"leavesAt": "09:38",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Cebza h.",
					"to": "Peciu Nou h.",
					"leavesAt": "09:42",
					"arrivesAt": "09:51",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Peciu Nou h.",
					"to": "Parţa h.",
					"leavesAt": "09:52",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Parţa h.",
					"to": "Sânmihai h.",
					"leavesAt": "10:03",
					"arrivesAt": "10:10",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Sânmihai h.",
					"to": "Utvin h.",
					"leavesAt": "10:11",
					"arrivesAt": "10:15",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Utvin h.",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "10:16",
					"arrivesAt": "10:22",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Timişoara Nord",
					"leavesAt": "10:25",
					"arrivesAt": "10:36",
					"waitsAtSource": 180,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14801",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "05:49",
					"arrivesAt": "06:00",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "06:01",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Erbiceni hc.",
					"leavesAt": "06:14",
					"arrivesAt": "06:23",
					"waitsAtSource": 300,
					"distance": 6000
				},
				{
					"from": "Erbiceni hc.",
					"to": "Spinoasa h.",
					"leavesAt": "06:24",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Spinoasa h.",
					"to": "Belceşti Hm.",
					"leavesAt": "06:33",
					"arrivesAt": "06:44",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Belceşti Hm.",
					"to": "Podu Ulmi h.",
					"leavesAt": "06:45",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Hodora h.",
					"leavesAt": "06:51",
					"arrivesAt": "06:56",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Hodora h.",
					"to": "Cotnari hc.",
					"leavesAt": "06:57",
					"arrivesAt": "07:02",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Cotnari hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "07:03",
					"arrivesAt": "07:07",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Bădeni hc.",
					"leavesAt": "07:08",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bădeni hc.",
					"to": "Hârlău",
					"leavesAt": "07:14",
					"arrivesAt": "07:19",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14507",
			"segments": [
				{
					"from": "Berzovia",
					"to": "Bocşa Română hc.",
					"leavesAt": "12:58",
					"arrivesAt": "13:08",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Vasiova",
					"leavesAt": "13:09",
					"arrivesAt": "13:15",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Montană hc.",
					"leavesAt": "13:16",
					"arrivesAt": "13:19",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Colţan h.",
					"leavesAt": "13:20",
					"arrivesAt": "13:27",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Colţan h.",
					"to": "Moniom h.",
					"leavesAt": "13:28",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moniom h.",
					"to": "Câlnic h.",
					"leavesAt": "13:34",
					"arrivesAt": "13:43",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "13:44",
					"arrivesAt": "13:47",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14326",
			"segments": [
				{
					"from": "Nerău hcv.",
					"to": "Teremia Banat hc.",
					"leavesAt": "19:27",
					"arrivesAt": "19:34",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Comloşu Mare h.",
					"leavesAt": "19:35",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Gotlob h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gotlob h.",
					"to": "Lovrin",
					"leavesAt": "19:55",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "20:03",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Pesac h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pesac h.",
					"to": "Periam",
					"leavesAt": "20:21",
					"arrivesAt": "20:33",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Periam",
					"to": "Variaş hc.",
					"leavesAt": "20:48",
					"arrivesAt": "20:57",
					"waitsAtSource": 900,
					"distance": 7600
				},
				{
					"from": "Variaş hc.",
					"to": "Gelu hc.",
					"leavesAt": "20:58",
					"arrivesAt": "21:04",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Gelu hc.",
					"to": "Bărăteaz h.",
					"leavesAt": "21:05",
					"arrivesAt": "21:10",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bărăteaz h.",
					"to": "Chinezu h.",
					"leavesAt": "21:11",
					"arrivesAt": "21:16",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Chinezu h.",
					"to": "Hodoni h.",
					"leavesAt": "21:17",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Hodoni h.",
					"to": "Sânandrei Hm.",
					"leavesAt": "21:23",
					"arrivesAt": "21:33",
					"waitsAtSource": 30,
					"distance": 8600
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "21:36",
					"arrivesAt": "21:42",
					"waitsAtSource": 180,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Timişoara Nord",
					"leavesAt": "21:43",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14731",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "07:11",
					"arrivesAt": "07:15",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "07:16",
					"arrivesAt": "07:22",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:33",
					"waitsAtSource": 300,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "07:34",
					"arrivesAt": "07:36",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "07:42",
					"arrivesAt": "07:46",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "07:47",
					"arrivesAt": "07:53",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Angheluş h.",
					"leavesAt": "07:56",
					"arrivesAt": "08:05",
					"waitsAtSource": 180,
					"distance": 6500
				},
				{
					"from": "Angheluş h.",
					"to": "Moacşa hcv",
					"leavesAt": "08:06",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Moacşa hcv",
					"to": "Biţa h.",
					"leavesAt": "08:13",
					"arrivesAt": "08:17",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Biţa h.",
					"to": "Boroşneu Mare h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:23",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Boroşneu Mare h.",
					"to": "Ţufalău h.",
					"leavesAt": "08:24",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ţufalău h.",
					"to": "Brateş h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:32",
					"waitsAtSource": 30,
					"distance": 3020
				},
				{
					"from": "Brateş h.",
					"to": "Covasna Hm.",
					"leavesAt": "08:33",
					"arrivesAt": "08:42",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Covasna Hm.",
					"to": "Zăbala h.",
					"leavesAt": "08:43",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Zăbala h.",
					"to": "Imeci Hm.",
					"leavesAt": "08:49",
					"arrivesAt": "08:55",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Imeci Hm.",
					"to": "Cătălina h.",
					"leavesAt": "08:56",
					"arrivesAt": "08:58",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Cătălina h.",
					"to": "Târgu Secuiesc",
					"leavesAt": "08:59",
					"arrivesAt": "09:04",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Târgu Secuiesc",
					"to": "Sânzieni h.",
					"leavesAt": "09:05",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Sânzieni h.",
					"to": "Poieniţa h.",
					"leavesAt": "09:17",
					"arrivesAt": "09:22",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Poieniţa h.",
					"to": "Bălani h.",
					"leavesAt": "09:23",
					"arrivesAt": "09:28",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bălani h.",
					"to": "Mereni Lutoasa h.",
					"leavesAt": "09:29",
					"arrivesAt": "09:35",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Mereni Lutoasa h.",
					"to": "Lemnia h.",
					"leavesAt": "09:36",
					"arrivesAt": "09:41",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lemnia h.",
					"to": "Breţcu Hm.",
					"leavesAt": "09:42",
					"arrivesAt": "09:49",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14730",
			"segments": [
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "05:42",
					"arrivesAt": "05:48",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "05:49",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "05:53",
					"arrivesAt": "05:57",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "06:01",
					"arrivesAt": "06:08",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "06:13",
					"arrivesAt": "06:18",
					"waitsAtSource": 300,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "06:19",
					"arrivesAt": "06:23",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14818",
			"segments": [
				{
					"from": "Dorohoi",
					"to": "Broscăuţi h.",
					"leavesAt": "10:15",
					"arrivesAt": "10:21",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Broscăuţi h.",
					"to": "Carasa h.",
					"leavesAt": "10:22",
					"arrivesAt": "10:29",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Carasa h.",
					"to": "Corlăteni h",
					"leavesAt": "10:30",
					"arrivesAt": "10:33",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Corlăteni h",
					"to": "Mateieni h.",
					"leavesAt": "10:34",
					"arrivesAt": "10:38",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mateieni h.",
					"to": "Vorniceni h.",
					"leavesAt": "10:39",
					"arrivesAt": "10:43",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Vorniceni h.",
					"to": "Mândreşti h.",
					"leavesAt": "10:44",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mândreşti h.",
					"to": "Ungureni Hm.",
					"leavesAt": "10:53",
					"arrivesAt": "10:59",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ungureni Hm.",
					"to": "Dângeni Nord h.",
					"leavesAt": "11:00",
					"arrivesAt": "11:08",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Dângeni",
					"leavesAt": "11:09",
					"arrivesAt": "11:14",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni",
					"to": "Buhăceni h.",
					"leavesAt": "11:16",
					"arrivesAt": "11:22",
					"waitsAtSource": 120,
					"distance": 6000
				},
				{
					"from": "Buhăceni h.",
					"to": "Truşeşti",
					"leavesAt": "11:23",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Truşeşti",
					"to": "Zlătunoaia h",
					"leavesAt": "11:39",
					"arrivesAt": "11:48",
					"waitsAtSource": 600,
					"distance": 9400
				},
				{
					"from": "Zlătunoaia h",
					"to": "Jijia h.",
					"leavesAt": "11:49",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Jijia h.",
					"to": "Todireni Hm.",
					"leavesAt": "11:56",
					"arrivesAt": "12:04",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Todireni Hm.",
					"to": "Răuşeni hc.",
					"leavesAt": "12:05",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Răuşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "12:12",
					"arrivesAt": "12:17",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rediu hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "12:18",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Şoldana hc.",
					"leavesAt": "12:24",
					"arrivesAt": "12:29",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Şoldana hc.",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "12:30",
					"arrivesAt": "12:35",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Vlădeni",
					"leavesAt": "12:36",
					"arrivesAt": "12:42",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Vlădeni",
					"to": "Larga Jijia Hm.",
					"leavesAt": "12:50",
					"arrivesAt": "13:01",
					"waitsAtSource": 480,
					"distance": 10800
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Potângeni hc.",
					"leavesAt": "13:02",
					"arrivesAt": "13:08",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Potângeni hc.",
					"to": "Movileni h",
					"leavesAt": "13:09",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Movileni h",
					"to": "Leţcani",
					"leavesAt": "13:18",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "13:29",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14389",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj h",
					"leavesAt": "14:10",
					"arrivesAt": "14:16",
					"waitsAtSource": 0,
					"distance": 5900
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "14:17",
					"arrivesAt": "14:19",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "14:20",
					"arrivesAt": "14:27",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "14:28",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Biled",
					"leavesAt": "14:40",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Biled",
					"to": "Şandra h.",
					"leavesAt": "15:01",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Şandra h.",
					"to": "Satu Nou Hm.",
					"leavesAt": "15:11",
					"arrivesAt": "15:26",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Lovrin",
					"leavesAt": "15:27",
					"arrivesAt": "15:34",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lovrin",
					"to": "Tomnaticu h.",
					"leavesAt": "15:37",
					"arrivesAt": "15:47",
					"waitsAtSource": 180,
					"distance": 7700
				},
				{
					"from": "Tomnaticu h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "15:48",
					"arrivesAt": "15:59",
					"waitsAtSource": 30,
					"distance": 8200
				},
				{
					"from": "Sânnicolau Mare",
					"to": "Sânnicolau Nord h.",
					"leavesAt": "16:00",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Sânnicolau Nord h.",
					"to": "Cenad h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:35",
					"waitsAtSource": 30,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14980",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:16",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "17:23",
					"arrivesAt": "17:29",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Fulga hc.",
					"leavesAt": "17:30",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Fulga hc.",
					"to": "Ciorani Hm.",
					"leavesAt": "17:37",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Ciorani Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hătcărău h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "17:49",
					"arrivesAt": "17:52",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Cornurile h.",
					"leavesAt": "17:57",
					"arrivesAt": "18:02",
					"waitsAtSource": 300,
					"distance": 4000
				},
				{
					"from": "Cornurile h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "18:03",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Trestieni h.",
					"leavesAt": "18:09",
					"arrivesAt": "18:12",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Trestieni h.",
					"to": "Râfov h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Râfov h.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "18:18",
					"arrivesAt": "18:21",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Dâmbu Hm.",
					"leavesAt": "18:22",
					"arrivesAt": "18:27",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Ploieşti Sud",
					"leavesAt": "18:28",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14390",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Tomnaticu h.",
					"leavesAt": "11:51",
					"arrivesAt": "12:02",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Tomnaticu h.",
					"to": "Lovrin",
					"leavesAt": "12:03",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "12:16",
					"arrivesAt": "12:24",
					"waitsAtSource": 120,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Şandra h.",
					"leavesAt": "12:25",
					"arrivesAt": "12:40",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şandra h.",
					"to": "Biled",
					"leavesAt": "12:41",
					"arrivesAt": "12:53",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Biled",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "12:54",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "13:15",
					"arrivesAt": "13:25",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "13:26",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "13:37",
					"arrivesAt": "13:39",
					"waitsAtSource": 180,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Timişoara Nord",
					"leavesAt": "13:40",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14450",
			"segments": [
				{
					"from": "Brad",
					"to": "Ribiţa h.",
					"leavesAt": "14:16",
					"arrivesAt": "14:21",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Ribiţa h.",
					"to": "Ţebea h",
					"leavesAt": "14:22",
					"arrivesAt": "14:25",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Ţebea h",
					"to": "Baia de Criş h.",
					"leavesAt": "14:26",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Baia de Criş h.",
					"to": "Lunca Moţilor h.",
					"leavesAt": "14:30",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Lunca Moţilor h.",
					"to": "Birtin h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:39",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Birtin h.",
					"to": "Vaţa h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Vaţa h.",
					"to": "Ociu h.",
					"leavesAt": "14:47",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ociu h.",
					"to": "Ocişor h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ocişor h.",
					"to": "Hălmagiu Hm.",
					"leavesAt": "14:58",
					"arrivesAt": "15:03",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Hălmagiu Hm.",
					"to": "Cariera Leasa h.",
					"leavesAt": "15:04",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Cariera Leasa h.",
					"to": "Vârfurile Hm.",
					"leavesAt": "15:09",
					"arrivesAt": "15:13",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Vârfurile Hm.",
					"to": "Tălagiu h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:35",
					"waitsAtSource": 1020,
					"distance": 4500
				},
				{
					"from": "Tălagiu h.",
					"to": "Aciuţa h.",
					"leavesAt": "15:36",
					"arrivesAt": "15:43",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Aciuţa h.",
					"to": "Romaniţa h.",
					"leavesAt": "15:44",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Romaniţa h.",
					"to": "Gurahonţ",
					"leavesAt": "15:48",
					"arrivesAt": "15:58",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gurahonţ",
					"to": "Bonţeşti h.",
					"leavesAt": "15:59",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bonţeşti h.",
					"to": "Almaş h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Almaş h.",
					"to": "Joia Mare hc.",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Joia Mare hc.",
					"to": "Paulian h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Paulian h.",
					"to": "Sebiş",
					"leavesAt": "16:21",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Sebiş",
					"to": "Răpsig h.",
					"leavesAt": "16:37",
					"arrivesAt": "16:47",
					"waitsAtSource": 600,
					"distance": 10000
				},
				{
					"from": "Răpsig h.",
					"to": "Bocsig  h",
					"leavesAt": "16:48",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bocsig  h",
					"to": "Tămand h.",
					"leavesAt": "16:56",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Tămand h.",
					"to": "Ineu",
					"leavesAt": "17:00",
					"arrivesAt": "17:08",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Ineu",
					"to": "Mocrea h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mocrea h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "17:16",
					"arrivesAt": "17:22",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Seleuş h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Seleuş h.",
					"to": "Pâncota h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pâncota h.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Şiria Hm.",
					"leavesAt": "17:41",
					"arrivesAt": "17:45",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Şiria Hm.",
					"to": "Sântana",
					"leavesAt": "17:46",
					"arrivesAt": "17:58",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Sântana",
					"to": "Utvinişu Nou",
					"leavesAt": "18:01",
					"arrivesAt": "18:16",
					"waitsAtSource": 180,
					"distance": 17000
				},
				{
					"from": "Utvinişu Nou",
					"to": "Arad",
					"leavesAt": "18:17",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14844",
			"segments": [
				{
					"from": "Dagâţa",
					"to": "Zece Prăjini h",
					"leavesAt": "10:42",
					"arrivesAt": "10:45",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Zece Prăjini h",
					"to": "Piscu Rusului h.",
					"leavesAt": "10:46",
					"arrivesAt": "10:55",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Stăniţa h.",
					"leavesAt": "10:56",
					"arrivesAt": "11:06",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stăniţa h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "11:07",
					"arrivesAt": "11:14",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Sagna h.",
					"leavesAt": "11:15",
					"arrivesAt": "11:25",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Sagna h.",
					"to": "Roman",
					"leavesAt": "11:26",
					"arrivesAt": "11:39",
					"waitsAtSource": 60,
					"distance": 8700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14734",
			"segments": [
				{
					"from": "Breţcu Hm.",
					"to": "Lemnia h.",
					"leavesAt": "10:18",
					"arrivesAt": "10:24",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Lemnia h.",
					"to": "Mereni Lutoasa h.",
					"leavesAt": "10:25",
					"arrivesAt": "10:30",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Mereni Lutoasa h.",
					"to": "Bălani h.",
					"leavesAt": "10:31",
					"arrivesAt": "10:36",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bălani h.",
					"to": "Poieniţa h.",
					"leavesAt": "10:37",
					"arrivesAt": "10:42",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Poieniţa h.",
					"to": "Sânzieni h.",
					"leavesAt": "10:43",
					"arrivesAt": "10:47",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Sânzieni h.",
					"to": "Târgu Secuiesc",
					"leavesAt": "10:48",
					"arrivesAt": "11:00",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Târgu Secuiesc",
					"to": "Cătălina h.",
					"leavesAt": "11:01",
					"arrivesAt": "11:06",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Cătălina h.",
					"to": "Imeci Hm.",
					"leavesAt": "11:07",
					"arrivesAt": "11:10",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Imeci Hm.",
					"to": "Zăbala h.",
					"leavesAt": "11:11",
					"arrivesAt": "11:17",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Zăbala h.",
					"to": "Covasna Hm.",
					"leavesAt": "11:18",
					"arrivesAt": "11:23",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Covasna Hm.",
					"to": "Brateş h.",
					"leavesAt": "11:24",
					"arrivesAt": "11:32",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Brateş h.",
					"to": "Ţufalău h.",
					"leavesAt": "11:33",
					"arrivesAt": "11:37",
					"waitsAtSource": 30,
					"distance": 3020
				},
				{
					"from": "Ţufalău h.",
					"to": "Boroşneu Mare h.",
					"leavesAt": "11:38",
					"arrivesAt": "11:41",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boroşneu Mare h.",
					"to": "Biţa h.",
					"leavesAt": "11:42",
					"arrivesAt": "11:47",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Biţa h.",
					"to": "Moacşa hcv",
					"leavesAt": "11:48",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moacşa hcv",
					"to": "Angheluş h.",
					"leavesAt": "11:53",
					"arrivesAt": "11:58",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Angheluş h.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "11:59",
					"arrivesAt": "12:22",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Ozun Hm.",
					"leavesAt": "12:26",
					"arrivesAt": "12:33",
					"waitsAtSource": 240,
					"distance": 7600
				},
				{
					"from": "Ozun Hm.",
					"to": "Chichiş h.",
					"leavesAt": "12:34",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Prejmer Hm.",
					"leavesAt": "12:38",
					"arrivesAt": "12:42",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Prejmer Hm.",
					"to": "Ilieni h.",
					"leavesAt": "12:48",
					"arrivesAt": "12:50",
					"waitsAtSource": 360,
					"distance": 1800
				},
				{
					"from": "Ilieni h.",
					"to": "Hărman",
					"leavesAt": "12:51",
					"arrivesAt": "12:57",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "12:58",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "13:03",
					"arrivesAt": "13:08",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14445",
			"segments": [
				{
					"from": "Sebiş",
					"to": "Paulian h.",
					"leavesAt": "14:28",
					"arrivesAt": "14:33",
					"waitsAtSource": 0,
					"distance": 4900
				},
				{
					"from": "Paulian h.",
					"to": "Joia Mare hc.",
					"leavesAt": "14:34",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Joia Mare hc.",
					"to": "Almaş h.",
					"leavesAt": "14:39",
					"arrivesAt": "14:44",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Almaş h.",
					"to": "Bonţeşti h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:50",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bonţeşti h.",
					"to": "Gurahonţ",
					"leavesAt": "14:51",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Gurahonţ",
					"to": "Romaniţa h.",
					"leavesAt": "14:56",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Romaniţa h.",
					"to": "Aciuţa h.",
					"leavesAt": "15:05",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aciuţa h.",
					"to": "Tălagiu h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tălagiu h.",
					"to": "Vârfurile Hm.",
					"leavesAt": "15:17",
					"arrivesAt": "15:23",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Vârfurile Hm.",
					"to": "Cariera Leasa h.",
					"leavesAt": "15:24",
					"arrivesAt": "15:28",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cariera Leasa h.",
					"to": "Hălmagiu Hm.",
					"leavesAt": "15:29",
					"arrivesAt": "15:34",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Hălmagiu Hm.",
					"to": "Ocişor h.",
					"leavesAt": "15:35",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ocişor h.",
					"to": "Ociu h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ociu h.",
					"to": "Vaţa h.",
					"leavesAt": "15:45",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Vaţa h.",
					"to": "Birtin h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Birtin h.",
					"to": "Lunca Moţilor h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lunca Moţilor h.",
					"to": "Baia de Criş h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Baia de Criş h.",
					"to": "Ţebea h",
					"leavesAt": "16:08",
					"arrivesAt": "16:11",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ţebea h",
					"to": "Ribiţa h.",
					"leavesAt": "16:12",
					"arrivesAt": "16:15",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Ribiţa h.",
					"to": "Brad",
					"leavesAt": "16:16",
					"arrivesAt": "16:22",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14840",
			"segments": [
				{
					"from": "Dagâţa",
					"to": "Zece Prăjini h",
					"leavesAt": "04:14",
					"arrivesAt": "04:17",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Zece Prăjini h",
					"to": "Piscu Rusului h.",
					"leavesAt": "04:18",
					"arrivesAt": "04:27",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Stăniţa h.",
					"leavesAt": "04:28",
					"arrivesAt": "04:38",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Stăniţa h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "04:39",
					"arrivesAt": "04:46",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Sagna h.",
					"leavesAt": "04:47",
					"arrivesAt": "04:57",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Sagna h.",
					"to": "Roman",
					"leavesAt": "04:58",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 8700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14438",
			"segments": [
				{
					"from": "Gurahonţ",
					"to": "Bonţeşti h.",
					"leavesAt": "03:34",
					"arrivesAt": "03:38",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Bonţeşti h.",
					"to": "Almaş h.",
					"leavesAt": "03:39",
					"arrivesAt": "03:44",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Almaş h.",
					"to": "Joia Mare hc.",
					"leavesAt": "03:45",
					"arrivesAt": "03:50",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Joia Mare hc.",
					"to": "Paulian h.",
					"leavesAt": "03:51",
					"arrivesAt": "03:55",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Paulian h.",
					"to": "Sebiş",
					"leavesAt": "03:56",
					"arrivesAt": "04:01",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Sebiş",
					"to": "Răpsig h.",
					"leavesAt": "04:02",
					"arrivesAt": "04:12",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Răpsig h.",
					"to": "Bocsig  h",
					"leavesAt": "04:13",
					"arrivesAt": "04:20",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bocsig  h",
					"to": "Tămand h.",
					"leavesAt": "04:21",
					"arrivesAt": "04:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Tămand h.",
					"to": "Ineu",
					"leavesAt": "04:25",
					"arrivesAt": "04:33",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Ineu",
					"to": "Mocrea h.",
					"leavesAt": "04:34",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mocrea h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "04:41",
					"arrivesAt": "04:47",
					"waitsAtSource": 30,
					"distance": 6200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Seleuş h.",
					"leavesAt": "04:48",
					"arrivesAt": "04:55",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Seleuş h.",
					"to": "Pâncota h.",
					"leavesAt": "04:56",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pâncota h.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "05:01",
					"arrivesAt": "05:04",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Şiria Hm.",
					"leavesAt": "05:05",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Şiria Hm.",
					"to": "Sântana",
					"leavesAt": "05:10",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:36",
					"waitsAtSource": 180,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utvinişu Nou",
					"leavesAt": "05:37",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Utvinişu Nou",
					"to": "Arad",
					"leavesAt": "05:44",
					"arrivesAt": "05:53",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14711",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "16:15",
					"arrivesAt": "16:20",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:28",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "16:29",
					"arrivesAt": "16:32",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "16:33",
					"arrivesAt": "16:37",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "16:38",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "16:41",
					"arrivesAt": "16:46",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "16:47",
					"arrivesAt": "16:50",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "16:51",
					"arrivesAt": "16:54",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14452",
			"segments": [
				{
					"from": "Brad",
					"to": "Ribiţa h.",
					"leavesAt": "16:38",
					"arrivesAt": "16:43",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Ribiţa h.",
					"to": "Ţebea h",
					"leavesAt": "16:44",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Ţebea h",
					"to": "Baia de Criş h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:51",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Baia de Criş h.",
					"to": "Lunca Moţilor h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Lunca Moţilor h.",
					"to": "Birtin h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Birtin h.",
					"to": "Vaţa h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:09",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Vaţa h.",
					"to": "Ociu h.",
					"leavesAt": "17:10",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ociu h.",
					"to": "Ocişor h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ocişor h.",
					"to": "Hălmagiu Hm.",
					"leavesAt": "17:21",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Hălmagiu Hm.",
					"to": "Cariera Leasa h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Cariera Leasa h.",
					"to": "Vârfurile Hm.",
					"leavesAt": "17:33",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Vârfurile Hm.",
					"to": "Tălagiu h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:43",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tălagiu h.",
					"to": "Aciuţa h.",
					"leavesAt": "17:44",
					"arrivesAt": "17:51",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Aciuţa h.",
					"to": "Romaniţa h.",
					"leavesAt": "17:52",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Romaniţa h.",
					"to": "Gurahonţ",
					"leavesAt": "17:56",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gurahonţ",
					"to": "Bonţeşti h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bonţeşti h.",
					"to": "Almaş h.",
					"leavesAt": "18:12",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Almaş h.",
					"to": "Joia Mare hc.",
					"leavesAt": "18:18",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Joia Mare hc.",
					"to": "Paulian h.",
					"leavesAt": "18:24",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Paulian h.",
					"to": "Sebiş",
					"leavesAt": "18:29",
					"arrivesAt": "18:35",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Sebiş",
					"to": "Răpsig h.",
					"leavesAt": "18:36",
					"arrivesAt": "18:46",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Răpsig h.",
					"to": "Bocsig  h",
					"leavesAt": "18:47",
					"arrivesAt": "18:54",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bocsig  h",
					"to": "Tămand h.",
					"leavesAt": "18:55",
					"arrivesAt": "18:58",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Tămand h.",
					"to": "Ineu",
					"leavesAt": "18:59",
					"arrivesAt": "19:07",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Ineu",
					"to": "Mocrea h.",
					"leavesAt": "19:14",
					"arrivesAt": "19:21",
					"waitsAtSource": 420,
					"distance": 4600
				},
				{
					"from": "Mocrea h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "19:22",
					"arrivesAt": "19:28",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Seleuş h.",
					"leavesAt": "19:29",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Seleuş h.",
					"to": "Pâncota h.",
					"leavesAt": "19:37",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pâncota h.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Şiria Hm.",
					"leavesAt": "19:47",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Şiria Hm.",
					"to": "Sântana",
					"leavesAt": "19:52",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:18",
					"waitsAtSource": 180,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utviniş h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Utviniş h.",
					"to": "Utvinişu Nou",
					"leavesAt": "20:23",
					"arrivesAt": "20:26",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Utvinişu Nou",
					"to": "Arad",
					"leavesAt": "20:27",
					"arrivesAt": "20:36",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18260",
			"segments": [
				{
					"from": "Întorsura Buzăului Hm",
					"to": "Poiana Florilor h.",
					"leavesAt": "08:56",
					"arrivesAt": "09:07",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Valea Teliului h.",
					"leavesAt": "09:08",
					"arrivesAt": "09:14",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Teliului h.",
					"to": "Teliu h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Teliu h.",
					"to": "Budila hcv.",
					"leavesAt": "09:21",
					"arrivesAt": "09:27",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Budila hcv.",
					"to": "Hărman",
					"leavesAt": "09:28",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Hărman",
					"to": "Braşov Triaj",
					"leavesAt": "09:39",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Braşov Triaj",
					"to": "Braşov",
					"leavesAt": "09:48",
					"arrivesAt": "09:53",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 256
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14758",
			"segments": [
				{
					"from": "Întorsura Buzăului Hm",
					"to": "Poiana Florilor h.",
					"leavesAt": "15:06",
					"arrivesAt": "15:16",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Valea Teliului h.",
					"leavesAt": "15:17",
					"arrivesAt": "15:21",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Teliului h.",
					"to": "Teliu h.",
					"leavesAt": "15:22",
					"arrivesAt": "15:26",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Teliu h.",
					"to": "Budila hcv.",
					"leavesAt": "15:27",
					"arrivesAt": "15:32",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Budila hcv.",
					"to": "Hărman",
					"leavesAt": "15:33",
					"arrivesAt": "15:42",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "15:43",
					"arrivesAt": "15:47",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "15:48",
					"arrivesAt": "15:52",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14422",
			"segments": [
				{
					"from": "Cermei hcv",
					"to": "Teuz h.",
					"leavesAt": "10:10",
					"arrivesAt": "10:15",
					"waitsAtSource": 0,
					"distance": 3800
				},
				{
					"from": "Teuz h.",
					"to": "Ineu",
					"leavesAt": "10:16",
					"arrivesAt": "10:28",
					"waitsAtSource": 30,
					"distance": 10600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14549",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "19:55",
					"arrivesAt": "20:06",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Utvin h.",
					"leavesAt": "20:07",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Utvin h.",
					"to": "Sânmihai h.",
					"leavesAt": "20:14",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sânmihai h.",
					"to": "Parţa h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:27",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Parţa h.",
					"to": "Peciu Nou h.",
					"leavesAt": "20:28",
					"arrivesAt": "20:39",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Peciu Nou h.",
					"to": "Cebza h.",
					"leavesAt": "20:40",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cebza h.",
					"to": "Giulvăz h",
					"leavesAt": "20:49",
					"arrivesAt": "20:53",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Giulvăz h",
					"to": "Rudna hc.",
					"leavesAt": "20:54",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Rudna hc.",
					"to": "Cruceni hcv.",
					"leavesAt": "21:03",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 11000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14312",
			"segments": [
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "04:01",
					"arrivesAt": "04:08",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Pesac h.",
					"leavesAt": "04:09",
					"arrivesAt": "04:17",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pesac h.",
					"to": "Periam",
					"leavesAt": "04:18",
					"arrivesAt": "04:31",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Periam",
					"to": "Variaş hc.",
					"leavesAt": "04:32",
					"arrivesAt": "04:41",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Variaş hc.",
					"to": "Gelu hc.",
					"leavesAt": "04:42",
					"arrivesAt": "04:48",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Gelu hc.",
					"to": "Bărăteaz h.",
					"leavesAt": "04:49",
					"arrivesAt": "04:54",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bărăteaz h.",
					"to": "Chinezu h.",
					"leavesAt": "04:55",
					"arrivesAt": "05:00",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Chinezu h.",
					"to": "Hodoni h.",
					"leavesAt": "05:01",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Hodoni h.",
					"to": "Sânandrei Hm.",
					"leavesAt": "05:07",
					"arrivesAt": "05:16",
					"waitsAtSource": 30,
					"distance": 8600
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "05:19",
					"arrivesAt": "05:25",
					"waitsAtSource": 180,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Timişoara Nord",
					"leavesAt": "05:26",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14607",
			"segments": [
				{
					"from": "Blaj",
					"to": "Sâncel h.",
					"leavesAt": "11:20",
					"arrivesAt": "11:25",
					"waitsAtSource": 0,
					"distance": 4246
				},
				{
					"from": "Sâncel h.",
					"to": "Pănade h.",
					"leavesAt": "11:26",
					"arrivesAt": "11:29",
					"waitsAtSource": 60,
					"distance": 1654
				},
				{
					"from": "Pănade h.",
					"to": "Şona h.",
					"leavesAt": "11:30",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Şona h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "11:36",
					"arrivesAt": "11:40",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "11:41",
					"arrivesAt": "11:47",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Feisa h.",
					"leavesAt": "11:48",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Feisa h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "11:53",
					"arrivesAt": "11:56",
					"waitsAtSource": 30,
					"distance": 2540
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Crăieşti h.",
					"leavesAt": "11:57",
					"arrivesAt": "12:02",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Crăieşti h.",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "12:03",
					"arrivesAt": "12:11",
					"waitsAtSource": 30,
					"distance": 6900
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Târnaveni",
					"leavesAt": "12:12",
					"arrivesAt": "12:17",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Târnaveni",
					"to": "Şeuca h.",
					"leavesAt": "12:22",
					"arrivesAt": "12:26",
					"waitsAtSource": 300,
					"distance": 2600
				},
				{
					"from": "Şeuca h.",
					"to": "Găneşti h.",
					"leavesAt": "12:27",
					"arrivesAt": "12:32",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Găneşti h.",
					"to": "Deaj h.",
					"leavesAt": "12:33",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Deaj h.",
					"to": "Mica h.",
					"leavesAt": "12:38",
					"arrivesAt": "12:42",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Mica h.",
					"to": "Bernadea h.",
					"leavesAt": "12:43",
					"arrivesAt": "12:47",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Bernadea h.",
					"to": "Bahnea h.",
					"leavesAt": "12:48",
					"arrivesAt": "12:54",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bahnea h.",
					"to": "Laslău h.",
					"leavesAt": "12:55",
					"arrivesAt": "13:02",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Laslău h.",
					"to": "Şoimuş h.",
					"leavesAt": "13:03",
					"arrivesAt": "13:10",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şoimuş h.",
					"to": "Coroiu h.",
					"leavesAt": "13:11",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Coroiu h.",
					"to": "Bălăuşeri hcv.",
					"leavesAt": "13:15",
					"arrivesAt": "13:26",
					"waitsAtSource": 30,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14384",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Tomnaticu h.",
					"leavesAt": "04:05",
					"arrivesAt": "04:16",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Tomnaticu h.",
					"to": "Lovrin",
					"leavesAt": "04:17",
					"arrivesAt": "04:28",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "04:29",
					"arrivesAt": "04:36",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Şandra h.",
					"leavesAt": "04:37",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şandra h.",
					"to": "Biled",
					"leavesAt": "04:54",
					"arrivesAt": "05:05",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Biled",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "05:06",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "05:40",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h",
					"leavesAt": "05:50",
					"arrivesAt": "05:52",
					"waitsAtSource": 180,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Timişoara Nord",
					"leavesAt": "05:53",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14821",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "14:22",
					"arrivesAt": "14:35",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Movileni h",
					"leavesAt": "14:36",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Movileni h",
					"to": "Potângeni hc.",
					"leavesAt": "14:47",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Potângeni hc.",
					"to": "Larga Jijia Hm.",
					"leavesAt": "14:54",
					"arrivesAt": "15:00",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Vlădeni",
					"leavesAt": "15:01",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vlădeni",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "15:21",
					"arrivesAt": "15:27",
					"waitsAtSource": 480,
					"distance": 5600
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Şoldana hc.",
					"leavesAt": "15:28",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Şoldana hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "15:34",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "15:40",
					"arrivesAt": "15:44",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Rediu hc.",
					"to": "Răuşeni hc.",
					"leavesAt": "15:45",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Răuşeni hc.",
					"to": "Todireni Hm.",
					"leavesAt": "15:51",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Todireni Hm.",
					"to": "Jijia h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:06",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Jijia h.",
					"to": "Zlătunoaia h",
					"leavesAt": "16:07",
					"arrivesAt": "16:12",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zlătunoaia h",
					"to": "Truşeşti",
					"leavesAt": "16:13",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Truşeşti",
					"to": "Buhăceni h.",
					"leavesAt": "16:35",
					"arrivesAt": "16:41",
					"waitsAtSource": 840,
					"distance": 4700
				},
				{
					"from": "Buhăceni h.",
					"to": "Dângeni",
					"leavesAt": "16:42",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dângeni",
					"to": "Dângeni Nord h.",
					"leavesAt": "16:50",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Ungureni Hm.",
					"leavesAt": "16:56",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Ungureni Hm.",
					"to": "Mândreşti h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mândreşti h.",
					"to": "Vorniceni h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vorniceni h.",
					"to": "Mateieni h.",
					"leavesAt": "17:19",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Mateieni h.",
					"to": "Corlăteni h",
					"leavesAt": "17:24",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Corlăteni h",
					"to": "Carasa h.",
					"leavesAt": "17:29",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Carasa h.",
					"to": "Broscăuţi h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Broscăuţi h.",
					"to": "Dorohoi",
					"leavesAt": "17:40",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18235",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "13:45",
					"arrivesAt": "13:57",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Utvin h.",
					"leavesAt": "13:59",
					"arrivesAt": "14:05",
					"waitsAtSource": 120,
					"distance": 3800
				},
				{
					"from": "Utvin h.",
					"to": "Sânmihai h.",
					"leavesAt": "14:06",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sânmihai h.",
					"to": "Parţa h.",
					"leavesAt": "14:11",
					"arrivesAt": "14:18",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Parţa h.",
					"to": "Peciu Nou h.",
					"leavesAt": "14:19",
					"arrivesAt": "14:30",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Peciu Nou h.",
					"to": "Cebza h.",
					"leavesAt": "14:31",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cebza h.",
					"to": "Giulvăz h",
					"leavesAt": "14:40",
					"arrivesAt": "14:43",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Giulvăz h",
					"to": "Rudna hc.",
					"leavesAt": "14:44",
					"arrivesAt": "14:51",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Rudna hc.",
					"to": "Cruceni hcv.",
					"leavesAt": "14:52",
					"arrivesAt": "15:11",
					"waitsAtSource": 30,
					"distance": 11000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14708",
			"segments": [
				{
					"from": "Zărneşti",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "12:55",
					"arrivesAt": "12:58",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "12:59",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "Râşnov h.",
					"leavesAt": "13:02",
					"arrivesAt": "13:07",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Râşnov h.",
					"to": "Râşnov",
					"leavesAt": "13:08",
					"arrivesAt": "13:11",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Râşnov",
					"to": "Cristian Hm.",
					"leavesAt": "13:12",
					"arrivesAt": "13:16",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cristian Hm.",
					"to": "Bartolomeu",
					"leavesAt": "13:17",
					"arrivesAt": "13:27",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "13:28",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "RGT",
			"number": "14068",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Nicolina",
					"leavesAt": "15:31",
					"arrivesAt": "15:36",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Nicolina",
					"to": "Bârnova Hm.",
					"leavesAt": "15:38",
					"arrivesAt": "16:03",
					"waitsAtSource": 120,
					"distance": 16300
				},
				{
					"from": "Bârnova Hm.",
					"to": "Buhăieşti",
					"leavesAt": "16:04",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 25700
				},
				{
					"from": "Buhăieşti",
					"to": "Vaslui",
					"leavesAt": "16:31",
					"arrivesAt": "16:52",
					"waitsAtSource": 420,
					"distance": 23500
				},
				{
					"from": "Vaslui",
					"to": "Crasna",
					"leavesAt": "16:54",
					"arrivesAt": "17:06",
					"waitsAtSource": 120,
					"distance": 15500
				},
				{
					"from": "Crasna",
					"to": "Bârlad",
					"leavesAt": "17:07",
					"arrivesAt": "17:39",
					"waitsAtSource": 60,
					"distance": 36600
				},
				{
					"from": "Bârlad",
					"to": "Tecuci Nord hc.(605)",
					"leavesAt": "17:40",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 48600
				},
				{
					"from": "Tecuci Nord hc.(605)",
					"to": "Mărăşeşti",
					"leavesAt": "18:25",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 17800
				},
				{
					"from": "Mărăşeşti",
					"to": "Focşani",
					"leavesAt": "18:57",
					"arrivesAt": "19:21",
					"waitsAtSource": 360,
					"distance": 19700
				},
				{
					"from": "Focşani",
					"to": "Râmnicu Sărat",
					"leavesAt": "19:22",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Buzău",
					"leavesAt": "19:59",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 33500
				},
				{
					"from": "Buzău",
					"to": "Mizil",
					"leavesAt": "20:30",
					"arrivesAt": "21:01",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Mizil",
					"to": "Ploieşti Sud",
					"leavesAt": "21:02",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Ploieşti Sud",
					"to": "Ploieşti Vest",
					"leavesAt": "21:39",
					"arrivesAt": "21:44",
					"waitsAtSource": 60,
					"distance": 3000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 368
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14810",
			"segments": [
				{
					"from": "Hârlău",
					"to": "Bădeni hc.",
					"leavesAt": "18:24",
					"arrivesAt": "18:27",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Bădeni hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "18:28",
					"arrivesAt": "18:32",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Cotnari hc.",
					"leavesAt": "18:33",
					"arrivesAt": "18:37",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cotnari hc.",
					"to": "Hodora h.",
					"leavesAt": "18:38",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hodora h.",
					"to": "Podu Ulmi h.",
					"leavesAt": "18:43",
					"arrivesAt": "18:48",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Belceşti Hm.",
					"leavesAt": "18:49",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Belceşti Hm.",
					"to": "Spinoasa h.",
					"leavesAt": "18:54",
					"arrivesAt": "19:05",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spinoasa h.",
					"to": "Erbiceni hc.",
					"leavesAt": "19:06",
					"arrivesAt": "19:13",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Erbiceni hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "19:14",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "19:28",
					"arrivesAt": "19:36",
					"waitsAtSource": 300,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "19:37",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14676",
			"segments": [
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "23:30",
					"arrivesAt": "23:38",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Antestaţie Bărăbanţ h.",
					"leavesAt": "23:39",
					"arrivesAt": "23:41",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Antestaţie Bărăbanţ h.",
					"to": "Bărăbanţ Nord h.",
					"leavesAt": "23:42",
					"arrivesAt": "23:46",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Bărăbanţ Nord h.",
					"to": "Şard Ighiu h.",
					"leavesAt": "23:47",
					"arrivesAt": "23:54",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Şard Ighiu h.",
					"to": "Ampoiţa h.",
					"leavesAt": "23:55",
					"arrivesAt": "23:59",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ampoiţa h.",
					"to": "Tăutu Ampoiului h.",
					"leavesAt": "00:00",
					"arrivesAt": "00:04",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Tăutu Ampoiului h.",
					"to": "Văleni Meteş h.",
					"leavesAt": "00:05",
					"arrivesAt": "00:11",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Văleni Meteş h.",
					"to": "Poiana Ampoiului h.",
					"leavesAt": "00:12",
					"arrivesAt": "00:16",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Poiana Ampoiului h.",
					"to": "Prisaca h.",
					"leavesAt": "00:17",
					"arrivesAt": "00:24",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Prisaca h.",
					"to": "Feneş h.",
					"leavesAt": "00:25",
					"arrivesAt": "00:29",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Feneş h.",
					"to": "Zlatna Tehnică",
					"leavesAt": "00:30",
					"arrivesAt": "00:35",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Zlatna Tehnică",
					"to": "Zlatna h.",
					"leavesAt": "00:38",
					"arrivesAt": "00:44",
					"waitsAtSource": 180,
					"distance": 4000
				},
				{
					"from": "Zlatna h.",
					"to": "Zlatna hcv.",
					"leavesAt": "00:45",
					"arrivesAt": "00:51",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14509",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "13:53",
					"arrivesAt": "14:02",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara C.E.T.",
					"leavesAt": "14:03",
					"arrivesAt": "14:06",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişeni Hm.",
					"leavesAt": "14:07",
					"arrivesAt": "14:12",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişeni Hm.",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "14:13",
					"arrivesAt": "14:18",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Jebel",
					"leavesAt": "14:19",
					"arrivesAt": "14:24",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Jebel",
					"to": "Voiteni",
					"leavesAt": "14:25",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Voiteni",
					"to": "Birda hcv.",
					"leavesAt": "14:36",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Birda hcv.",
					"to": "Gătaia",
					"leavesAt": "14:47",
					"arrivesAt": "14:55",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Gătaia",
					"to": "Măureni hc.",
					"leavesAt": "14:56",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Măureni hc.",
					"to": "Gherteniş hc.",
					"leavesAt": "15:05",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Gherteniş hc.",
					"to": "Berzovia",
					"leavesAt": "15:13",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Berzovia",
					"to": "Bocşa Română hc.",
					"leavesAt": "15:34",
					"arrivesAt": "15:43",
					"waitsAtSource": 1020,
					"distance": 8200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Vasiova",
					"leavesAt": "15:44",
					"arrivesAt": "15:49",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Montană hc.",
					"leavesAt": "15:50",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Colţan h.",
					"leavesAt": "15:54",
					"arrivesAt": "16:01",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Colţan h.",
					"to": "Moniom h.",
					"leavesAt": "16:02",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moniom h.",
					"to": "Câlnic h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:16",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "16:17",
					"arrivesAt": "16:20",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14700",
			"segments": [
				{
					"from": "Zărneşti",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "05:00",
					"arrivesAt": "05:03",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "05:04",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "Râşnov h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:12",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Râşnov h.",
					"to": "Râşnov",
					"leavesAt": "05:13",
					"arrivesAt": "05:16",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Râşnov",
					"to": "Cristian Hm.",
					"leavesAt": "05:17",
					"arrivesAt": "05:21",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cristian Hm.",
					"to": "Lustic h.",
					"leavesAt": "05:22",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Lustic h.",
					"to": "Bartolomeu",
					"leavesAt": "05:26",
					"arrivesAt": "05:33",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "05:34",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14303",
			"segments": [
				{
					"from": "Arad",
					"to": "Arad Vest",
					"leavesAt": "17:50",
					"arrivesAt": "17:59",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Arad Vest",
					"to": "Ferma Ciala h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Sântoma h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:12",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sântoma h.",
					"to": "Pecica",
					"leavesAt": "18:13",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pecica",
					"to": "Semlac h.",
					"leavesAt": "18:38",
					"arrivesAt": "19:02",
					"waitsAtSource": 780,
					"distance": 17200
				},
				{
					"from": "Semlac h.",
					"to": "Şeitin h.",
					"leavesAt": "19:03",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Şeitin h.",
					"to": "Nădlac",
					"leavesAt": "19:13",
					"arrivesAt": "19:26",
					"waitsAtSource": 30,
					"distance": 8100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14606",
			"segments": [
				{
					"from": "Târnaveni",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "13:15",
					"arrivesAt": "13:20",
					"waitsAtSource": 0,
					"distance": 2400
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Crăieşti h.",
					"leavesAt": "13:21",
					"arrivesAt": "13:28",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Crăieşti h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "13:29",
					"arrivesAt": "13:35",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Feisa h.",
					"leavesAt": "13:36",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Feisa h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "13:40",
					"arrivesAt": "13:44",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "13:45",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Şona h.",
					"leavesAt": "13:51",
					"arrivesAt": "13:55",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Şona h.",
					"to": "Pănade h.",
					"leavesAt": "13:56",
					"arrivesAt": "14:01",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Pănade h.",
					"to": "Sâncel h.",
					"leavesAt": "14:02",
					"arrivesAt": "14:05",
					"waitsAtSource": 30,
					"distance": 1654
				},
				{
					"from": "Sâncel h.",
					"to": "Blaj",
					"leavesAt": "14:06",
					"arrivesAt": "14:13",
					"waitsAtSource": 30,
					"distance": 4246
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14449",
			"segments": [
				{
					"from": "Arad",
					"to": "Utvinişu Nou",
					"leavesAt": "16:13",
					"arrivesAt": "16:21",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Utvinişu Nou",
					"to": "Zimandu Nou h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "16:30",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Şiria Hm.",
					"leavesAt": "16:41",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Şiria Hm.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "16:54",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Pâncota h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Pâncota h.",
					"to": "Seleuş h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Seleuş h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "17:08",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Mocrea h.",
					"leavesAt": "17:35",
					"arrivesAt": "17:41",
					"waitsAtSource": 1200,
					"distance": 6200
				},
				{
					"from": "Mocrea h.",
					"to": "Ineu",
					"leavesAt": "17:42",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ineu",
					"to": "Tămand h.",
					"leavesAt": "17:55",
					"arrivesAt": "18:03",
					"waitsAtSource": 420,
					"distance": 8400
				},
				{
					"from": "Tămand h.",
					"to": "Bocsig  h",
					"leavesAt": "18:04",
					"arrivesAt": "18:08",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bocsig  h",
					"to": "Răpsig h.",
					"leavesAt": "18:09",
					"arrivesAt": "18:15",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Răpsig h.",
					"to": "Sebiş",
					"leavesAt": "18:16",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Sebiş",
					"to": "Paulian h.",
					"leavesAt": "18:41",
					"arrivesAt": "18:46",
					"waitsAtSource": 900,
					"distance": 4900
				},
				{
					"from": "Paulian h.",
					"to": "Joia Mare hc.",
					"leavesAt": "18:47",
					"arrivesAt": "18:51",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Joia Mare hc.",
					"to": "Almaş h.",
					"leavesAt": "18:52",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Almaş h.",
					"to": "Bonţeşti h.",
					"leavesAt": "18:58",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bonţeşti h.",
					"to": "Gurahonţ",
					"leavesAt": "19:04",
					"arrivesAt": "19:08",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Gurahonţ",
					"to": "Romaniţa h.",
					"leavesAt": "19:09",
					"arrivesAt": "19:17",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Romaniţa h.",
					"to": "Aciuţa h.",
					"leavesAt": "19:18",
					"arrivesAt": "19:22",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aciuţa h.",
					"to": "Tălagiu h.",
					"leavesAt": "19:23",
					"arrivesAt": "19:29",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tălagiu h.",
					"to": "Vârfurile Hm.",
					"leavesAt": "19:30",
					"arrivesAt": "19:36",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Vârfurile Hm.",
					"to": "Cariera Leasa h.",
					"leavesAt": "19:37",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Cariera Leasa h.",
					"to": "Hălmagiu Hm.",
					"leavesAt": "19:42",
					"arrivesAt": "19:47",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Hălmagiu Hm.",
					"to": "Ocişor h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ocişor h.",
					"to": "Ociu h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ociu h.",
					"to": "Vaţa h.",
					"leavesAt": "19:58",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Vaţa h.",
					"to": "Birtin h.",
					"leavesAt": "20:04",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Birtin h.",
					"to": "Lunca Moţilor h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lunca Moţilor h.",
					"to": "Baia de Criş h.",
					"leavesAt": "20:17",
					"arrivesAt": "20:20",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Baia de Criş h.",
					"to": "Ţebea h",
					"leavesAt": "20:21",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ţebea h",
					"to": "Ribiţa h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Ribiţa h.",
					"to": "Brad",
					"leavesAt": "20:29",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14317",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "07:18",
					"arrivesAt": "07:24",
					"waitsAtSource": 0,
					"distance": 4400
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "07:25",
					"arrivesAt": "07:27",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "07:28",
					"arrivesAt": "07:30",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "07:40",
					"arrivesAt": "07:46",
					"waitsAtSource": 600,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Hodoni h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Hodoni h.",
					"to": "Chinezu h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:02",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Chinezu h.",
					"to": "Bărăteaz h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:07",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Bărăteaz h.",
					"to": "Gelu hc.",
					"leavesAt": "08:08",
					"arrivesAt": "08:12",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Gelu hc.",
					"to": "Variaş hc.",
					"leavesAt": "08:13",
					"arrivesAt": "08:19",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Variaş hc.",
					"to": "Periam",
					"leavesAt": "08:20",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Periam",
					"to": "Pesac h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:53",
					"waitsAtSource": 780,
					"distance": 6700
				},
				{
					"from": "Pesac h.",
					"to": "Satu Nou Hm.",
					"leavesAt": "08:54",
					"arrivesAt": "09:02",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Lovrin",
					"leavesAt": "09:03",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lovrin",
					"to": "Gotlob h.",
					"leavesAt": "09:28",
					"arrivesAt": "09:35",
					"waitsAtSource": 1080,
					"distance": 6400
				},
				{
					"from": "Gotlob h.",
					"to": "Comloşu Mare h.",
					"leavesAt": "09:36",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Teremia Banat hc.",
					"leavesAt": "09:45",
					"arrivesAt": "09:55",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Nerău hcv.",
					"leavesAt": "09:56",
					"arrivesAt": "10:04",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14296",
			"segments": [
				{
					"from": "Nădlac",
					"to": "Şeitin h.",
					"leavesAt": "04:01",
					"arrivesAt": "04:12",
					"waitsAtSource": 0,
					"distance": 8100
				},
				{
					"from": "Şeitin h.",
					"to": "Semlac h.",
					"leavesAt": "04:13",
					"arrivesAt": "04:22",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Semlac h.",
					"to": "Pecica",
					"leavesAt": "04:23",
					"arrivesAt": "04:45",
					"waitsAtSource": 30,
					"distance": 17200
				},
				{
					"from": "Pecica",
					"to": "Sântoma h.",
					"leavesAt": "04:46",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Sântoma h.",
					"to": "Ferma Ciala h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:04",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Arad Vest",
					"leavesAt": "05:05",
					"arrivesAt": "05:11",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Arad Vest",
					"to": "Arad",
					"leavesAt": "05:14",
					"arrivesAt": "05:23",
					"waitsAtSource": 180,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14601",
			"segments": [
				{
					"from": "Jidvei  hcv.",
					"to": "Feisa h.",
					"leavesAt": "05:28",
					"arrivesAt": "05:33",
					"waitsAtSource": 0,
					"distance": 2800
				},
				{
					"from": "Feisa h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "05:34",
					"arrivesAt": "05:37",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Crăieşti h.",
					"leavesAt": "05:38",
					"arrivesAt": "05:45",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Crăieşti h.",
					"to": "Corneşti Târnava h.",
					"leavesAt": "05:46",
					"arrivesAt": "05:49",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Corneşti Târnava h.",
					"to": "Adămuş h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Adămuş h.",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "05:54",
					"arrivesAt": "05:58",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Târnaveni",
					"leavesAt": "05:59",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 2400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14808",
			"segments": [
				{
					"from": "Hârlău",
					"to": "Bădeni hc.",
					"leavesAt": "14:52",
					"arrivesAt": "14:55",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Bădeni hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "14:56",
					"arrivesAt": "15:00",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Cotnari hc.",
					"leavesAt": "15:01",
					"arrivesAt": "15:05",
					"waitsAtSource": 30,
					"distance": 3700
				},
				{
					"from": "Cotnari hc.",
					"to": "Hodora h.",
					"leavesAt": "15:06",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hodora h.",
					"to": "Podu Ulmi h.",
					"leavesAt": "15:12",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Belceşti Hm.",
					"leavesAt": "15:18",
					"arrivesAt": "15:22",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Belceşti Hm.",
					"to": "Spinoasa h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:33",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spinoasa h.",
					"to": "Erbiceni hc.",
					"leavesAt": "15:34",
					"arrivesAt": "15:41",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Erbiceni hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "15:42",
					"arrivesAt": "15:51",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "15:56",
					"arrivesAt": "16:04",
					"waitsAtSource": 300,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "16:05",
					"arrivesAt": "16:20",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14845",
			"segments": [
				{
					"from": "Roman",
					"to": "Sagna h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:27",
					"waitsAtSource": 0,
					"distance": 8700
				},
				{
					"from": "Sagna h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Stăniţa h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Stăniţa h.",
					"to": "Piscu Rusului h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:58",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Zece Prăjini h",
					"leavesAt": "08:59",
					"arrivesAt": "09:08",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Zece Prăjini h",
					"to": "Dagâţa",
					"leavesAt": "09:09",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14544",
			"segments": [
				{
					"from": "Cruceni hcv.",
					"to": "Rudna hc.",
					"leavesAt": "12:43",
					"arrivesAt": "13:01",
					"waitsAtSource": 0,
					"distance": 11000
				},
				{
					"from": "Rudna hc.",
					"to": "Giulvăz h",
					"leavesAt": "13:02",
					"arrivesAt": "13:09",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Giulvăz h",
					"to": "Cebza h.",
					"leavesAt": "13:10",
					"arrivesAt": "13:13",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Cebza h.",
					"to": "Peciu Nou h.",
					"leavesAt": "13:14",
					"arrivesAt": "13:23",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Peciu Nou h.",
					"to": "Parţa h.",
					"leavesAt": "13:24",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Parţa h.",
					"to": "Sânmihai h.",
					"leavesAt": "13:35",
					"arrivesAt": "13:42",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Sânmihai h.",
					"to": "Utvin h.",
					"leavesAt": "13:43",
					"arrivesAt": "13:47",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Utvin h.",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "13:48",
					"arrivesAt": "13:54",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Timişoara Nord",
					"leavesAt": "13:58",
					"arrivesAt": "14:09",
					"waitsAtSource": 240,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14804",
			"segments": [
				{
					"from": "Hârlău",
					"to": "Bădeni hc.",
					"leavesAt": "07:42",
					"arrivesAt": "07:46",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Bădeni hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "07:47",
					"arrivesAt": "07:51",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Cotnari hc.",
					"leavesAt": "07:52",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cotnari hc.",
					"to": "Hodora h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hodora h.",
					"to": "Podu Ulmi h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Belceşti Hm.",
					"leavesAt": "08:09",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Belceşti Hm.",
					"to": "Spinoasa h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spinoasa h.",
					"to": "Erbiceni hc.",
					"leavesAt": "08:26",
					"arrivesAt": "08:33",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Erbiceni hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "08:34",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "08:48",
					"arrivesAt": "08:56",
					"waitsAtSource": 300,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "08:57",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14670",
			"segments": [
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "07:30",
					"arrivesAt": "07:38",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Antestaţie Bărăbanţ h.",
					"leavesAt": "07:39",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Antestaţie Bărăbanţ h.",
					"to": "Bărăbanţ Nord h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:46",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Bărăbanţ Nord h.",
					"to": "Şard Ighiu h.",
					"leavesAt": "07:47",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Şard Ighiu h.",
					"to": "Ampoiţa h.",
					"leavesAt": "07:55",
					"arrivesAt": "07:59",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ampoiţa h.",
					"to": "Tăutu Ampoiului h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:04",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Tăutu Ampoiului h.",
					"to": "Văleni Meteş h.",
					"leavesAt": "08:05",
					"arrivesAt": "08:11",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Văleni Meteş h.",
					"to": "Poiana Ampoiului h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:16",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Poiana Ampoiului h.",
					"to": "Prisaca h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:24",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Prisaca h.",
					"to": "Feneş h.",
					"leavesAt": "08:25",
					"arrivesAt": "08:29",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Feneş h.",
					"to": "Zlatna Tehnică",
					"leavesAt": "08:30",
					"arrivesAt": "08:35",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Zlatna Tehnică",
					"to": "Zlatna h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:44",
					"waitsAtSource": 180,
					"distance": 4000
				},
				{
					"from": "Zlatna h.",
					"to": "Zlatna hcv.",
					"leavesAt": "08:45",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14360",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Saravale h.",
					"leavesAt": "04:50",
					"arrivesAt": "05:00",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Saravale h.",
					"to": "Sânpetru h.",
					"leavesAt": "05:01",
					"arrivesAt": "05:10",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Sânpetru h.",
					"to": "Periam",
					"leavesAt": "05:11",
					"arrivesAt": "05:18",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Periam",
					"to": "Aranca h.",
					"leavesAt": "05:27",
					"arrivesAt": "05:37",
					"waitsAtSource": 540,
					"distance": 11100
				},
				{
					"from": "Aranca h.",
					"to": "Secusigiu h",
					"leavesAt": "05:38",
					"arrivesAt": "05:42",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Secusigiu h",
					"to": "Munor h.",
					"leavesAt": "05:43",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Munor h.",
					"to": "Sânpetru German h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sânpetru German h.",
					"to": "Felnac hc.",
					"leavesAt": "05:52",
					"arrivesAt": "05:59",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Felnac hc.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Zădăreni Hm.",
					"leavesAt": "06:06",
					"arrivesAt": "06:10",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Aradu Nou",
					"leavesAt": "06:11",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "06:24",
					"arrivesAt": "06:31",
					"waitsAtSource": 180,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14318",
			"segments": [
				{
					"from": "Nerău hcv.",
					"to": "Teremia Banat hc.",
					"leavesAt": "07:19",
					"arrivesAt": "07:27",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Comloşu Mare h.",
					"leavesAt": "07:28",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Gotlob h.",
					"leavesAt": "07:39",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Gotlob h.",
					"to": "Lovrin",
					"leavesAt": "07:48",
					"arrivesAt": "07:55",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "07:56",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Pesac h.",
					"leavesAt": "08:04",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pesac h.",
					"to": "Periam",
					"leavesAt": "08:13",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Periam",
					"to": "Variaş hc.",
					"leavesAt": "08:38",
					"arrivesAt": "08:47",
					"waitsAtSource": 780,
					"distance": 7600
				},
				{
					"from": "Variaş hc.",
					"to": "Gelu hc.",
					"leavesAt": "08:48",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Gelu hc.",
					"to": "Bărăteaz h.",
					"leavesAt": "08:55",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bărăteaz h.",
					"to": "Chinezu h.",
					"leavesAt": "09:01",
					"arrivesAt": "09:06",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Chinezu h.",
					"to": "Hodoni h.",
					"leavesAt": "09:07",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Hodoni h.",
					"to": "Sânandrei Hm.",
					"leavesAt": "09:13",
					"arrivesAt": "09:23",
					"waitsAtSource": 30,
					"distance": 8600
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "09:26",
					"arrivesAt": "09:32",
					"waitsAtSource": 180,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Timişoara Nord",
					"leavesAt": "09:33",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14605",
			"segments": [
				{
					"from": "Blaj",
					"to": "Sâncel h.",
					"leavesAt": "08:05",
					"arrivesAt": "08:12",
					"waitsAtSource": 0,
					"distance": 4246
				},
				{
					"from": "Sâncel h.",
					"to": "Pănade h.",
					"leavesAt": "08:13",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 1654
				},
				{
					"from": "Pănade h.",
					"to": "Şona h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Şona h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Bălcaci h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bălcaci h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "08:32",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Feisa h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:43",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Feisa h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "08:44",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Crăieşti h.",
					"leavesAt": "08:48",
					"arrivesAt": "08:55",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Crăieşti h.",
					"to": "Corneşti Târnava h.",
					"leavesAt": "08:56",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Corneşti Târnava h.",
					"to": "Adămuş h.",
					"leavesAt": "09:00",
					"arrivesAt": "09:03",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Adămuş h.",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "09:04",
					"arrivesAt": "09:08",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Târnaveni",
					"leavesAt": "09:09",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 2400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14851",
			"segments": [
				{
					"from": "Roman",
					"to": "Sagna h.",
					"leavesAt": "19:22",
					"arrivesAt": "19:31",
					"waitsAtSource": 0,
					"distance": 8700
				},
				{
					"from": "Sagna h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "19:32",
					"arrivesAt": "19:42",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Stăniţa h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:50",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Stăniţa h.",
					"to": "Piscu Rusului h.",
					"leavesAt": "19:51",
					"arrivesAt": "20:02",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Zece Prăjini h",
					"leavesAt": "20:03",
					"arrivesAt": "20:12",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Zece Prăjini h",
					"to": "Dagâţa",
					"leavesAt": "20:13",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14800",
			"segments": [
				{
					"from": "Hârlău",
					"to": "Bădeni hc.",
					"leavesAt": "03:56",
					"arrivesAt": "04:00",
					"waitsAtSource": 0,
					"distance": 2600
				},
				{
					"from": "Bădeni hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "04:01",
					"arrivesAt": "04:05",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Cotnari hc.",
					"leavesAt": "04:06",
					"arrivesAt": "04:10",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cotnari hc.",
					"to": "Hodora h.",
					"leavesAt": "04:11",
					"arrivesAt": "04:16",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hodora h.",
					"to": "Podu Ulmi h.",
					"leavesAt": "04:17",
					"arrivesAt": "04:22",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Belceşti Hm.",
					"leavesAt": "04:23",
					"arrivesAt": "04:27",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Belceşti Hm.",
					"to": "Spinoasa h.",
					"leavesAt": "04:28",
					"arrivesAt": "04:39",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Spinoasa h.",
					"to": "Erbiceni hc.",
					"leavesAt": "04:40",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Erbiceni hc.",
					"to": "Podu Iloaiei",
					"leavesAt": "04:48",
					"arrivesAt": "04:57",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Podu Iloaiei",
					"to": "Leţcani",
					"leavesAt": "05:02",
					"arrivesAt": "05:10",
					"waitsAtSource": 300,
					"distance": 8800
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "05:11",
					"arrivesAt": "05:27",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14850",
			"segments": [
				{
					"from": "Buhăieşti",
					"to": "Negreşti Vaslui Hm.",
					"leavesAt": "19:30",
					"arrivesAt": "19:44",
					"waitsAtSource": 0,
					"distance": 10700
				},
				{
					"from": "Negreşti Vaslui Hm.",
					"to": "Rafaila h.",
					"leavesAt": "19:45",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Rafaila h.",
					"to": "Dumeşti h.",
					"leavesAt": "19:52",
					"arrivesAt": "19:59",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Dumeşti h.",
					"to": "Mareşal C-tin Prezan Hm.",
					"leavesAt": "20:00",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Mareşal C-tin Prezan Hm.",
					"to": "Suhuleţ h.",
					"leavesAt": "20:08",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Suhuleţ h.",
					"to": "Băluşeşti h",
					"leavesAt": "20:15",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Băluşeşti h",
					"to": "Dagâţa",
					"leavesAt": "20:20",
					"arrivesAt": "20:24",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14421",
			"segments": [
				{
					"from": "Ineu",
					"to": "Teuz h.",
					"leavesAt": "09:40",
					"arrivesAt": "09:51",
					"waitsAtSource": 0,
					"distance": 10600
				},
				{
					"from": "Teuz h.",
					"to": "Cermei hcv",
					"leavesAt": "09:52",
					"arrivesAt": "09:58",
					"waitsAtSource": 30,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14757",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "14:00",
					"arrivesAt": "14:04",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "14:05",
					"arrivesAt": "14:10",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Budila hcv.",
					"leavesAt": "14:11",
					"arrivesAt": "14:21",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Budila hcv.",
					"to": "Teliu h.",
					"leavesAt": "14:22",
					"arrivesAt": "14:28",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Teliu h.",
					"to": "Valea Teliului h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Valea Teliului h.",
					"to": "Poiana Florilor h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:39",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Întorsura Buzăului Hm",
					"leavesAt": "14:40",
					"arrivesAt": "14:53",
					"waitsAtSource": 30,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14386",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Tomnaticu h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:15",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Tomnaticu h.",
					"to": "Lovrin",
					"leavesAt": "05:16",
					"arrivesAt": "05:27",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "05:28",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Şandra h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şandra h.",
					"to": "Biled",
					"leavesAt": "05:51",
					"arrivesAt": "06:02",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Biled",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "06:03",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "06:23",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "06:36",
					"arrivesAt": "06:43",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:47",
					"waitsAtSource": 180,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:50",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "06:51",
					"arrivesAt": "06:57",
					"waitsAtSource": 30,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14545",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "11:00",
					"arrivesAt": "11:11",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Utvin h.",
					"leavesAt": "11:12",
					"arrivesAt": "11:18",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Utvin h.",
					"to": "Sânmihai h.",
					"leavesAt": "11:19",
					"arrivesAt": "11:23",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sânmihai h.",
					"to": "Parţa h.",
					"leavesAt": "11:24",
					"arrivesAt": "11:31",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Parţa h.",
					"to": "Peciu Nou h.",
					"leavesAt": "11:32",
					"arrivesAt": "11:43",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Peciu Nou h.",
					"to": "Cebza h.",
					"leavesAt": "11:44",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cebza h.",
					"to": "Giulvăz h",
					"leavesAt": "11:53",
					"arrivesAt": "11:56",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Giulvăz h",
					"to": "Rudna hc.",
					"leavesAt": "11:57",
					"arrivesAt": "12:04",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Rudna hc.",
					"to": "Cruceni hcv.",
					"leavesAt": "12:05",
					"arrivesAt": "12:24",
					"waitsAtSource": 30,
					"distance": 11000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14307",
			"segments": [
				{
					"from": "Arad",
					"to": "Arad Vest",
					"leavesAt": "22:05",
					"arrivesAt": "22:14",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Arad Vest",
					"to": "Ferma Ciala h.",
					"leavesAt": "22:15",
					"arrivesAt": "22:20",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Sântoma h.",
					"leavesAt": "22:21",
					"arrivesAt": "22:27",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sântoma h.",
					"to": "Pecica",
					"leavesAt": "22:28",
					"arrivesAt": "22:40",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pecica",
					"to": "Semlac h.",
					"leavesAt": "22:41",
					"arrivesAt": "23:04",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Semlac h.",
					"to": "Şeitin h.",
					"leavesAt": "23:05",
					"arrivesAt": "23:14",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Şeitin h.",
					"to": "Nădlac",
					"leavesAt": "23:15",
					"arrivesAt": "23:28",
					"waitsAtSource": 30,
					"distance": 8100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14394",
			"segments": [
				{
					"from": "Cenad h.",
					"to": "Sânnicolau Nord h.",
					"leavesAt": "19:20",
					"arrivesAt": "19:43",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Sânnicolau Nord h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "19:44",
					"arrivesAt": "19:57",
					"waitsAtSource": 60,
					"distance": 5400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14602",
			"segments": [
				{
					"from": "Bălăuşeri hcv.",
					"to": "Coroiu h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:12",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Coroiu h.",
					"to": "Şoimuş h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:16",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Şoimuş h.",
					"to": "Laslău h.",
					"leavesAt": "05:17",
					"arrivesAt": "05:24",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Laslău h.",
					"to": "Bahnea h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:32",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bahnea h.",
					"to": "Bernadea h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:39",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bernadea h.",
					"to": "Mica h.",
					"leavesAt": "05:40",
					"arrivesAt": "05:45",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mica h.",
					"to": "Deaj h.",
					"leavesAt": "05:46",
					"arrivesAt": "05:51",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Deaj h.",
					"to": "Găneşti h.",
					"leavesAt": "05:52",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Găneşti h.",
					"to": "Şeuca h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:03",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Şeuca h.",
					"to": "Târnaveni",
					"leavesAt": "06:04",
					"arrivesAt": "06:09",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Târnaveni",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:16",
					"waitsAtSource": 120,
					"distance": 2400
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Adămuş h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:21",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Adămuş h.",
					"to": "Corneşti Târnava h.",
					"leavesAt": "06:22",
					"arrivesAt": "06:26",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Corneşti Târnava h.",
					"to": "Crăieşti h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:30",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Crăieşti h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 5160
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Feisa h.",
					"leavesAt": "06:39",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Feisa h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "06:43",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Bălcaci h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Bălcaci h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "06:52",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Şona h.",
					"leavesAt": "06:56",
					"arrivesAt": "07:00",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Şona h.",
					"to": "Pănade h.",
					"leavesAt": "07:01",
					"arrivesAt": "07:06",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pănade h.",
					"to": "Sâncel h.",
					"leavesAt": "07:07",
					"arrivesAt": "07:10",
					"waitsAtSource": 30,
					"distance": 1654
				},
				{
					"from": "Sâncel h.",
					"to": "Blaj",
					"leavesAt": "07:11",
					"arrivesAt": "07:17",
					"waitsAtSource": 30,
					"distance": 4246
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14805",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "13:07",
					"arrivesAt": "13:18",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "13:19",
					"arrivesAt": "13:27",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Erbiceni hc.",
					"leavesAt": "13:32",
					"arrivesAt": "13:40",
					"waitsAtSource": 300,
					"distance": 6000
				},
				{
					"from": "Erbiceni hc.",
					"to": "Spinoasa h.",
					"leavesAt": "13:41",
					"arrivesAt": "13:49",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Spinoasa h.",
					"to": "Belceşti Hm.",
					"leavesAt": "13:50",
					"arrivesAt": "14:01",
					"waitsAtSource": 30,
					"distance": 9500
				},
				{
					"from": "Belceşti Hm.",
					"to": "Podu Ulmi h.",
					"leavesAt": "14:02",
					"arrivesAt": "14:07",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Hodora h.",
					"leavesAt": "14:08",
					"arrivesAt": "14:13",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Hodora h.",
					"to": "Cotnari hc.",
					"leavesAt": "14:14",
					"arrivesAt": "14:19",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Cotnari hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "14:20",
					"arrivesAt": "14:24",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Bădeni hc.",
					"leavesAt": "14:25",
					"arrivesAt": "14:29",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bădeni hc.",
					"to": "Hârlău",
					"leavesAt": "14:30",
					"arrivesAt": "14:35",
					"waitsAtSource": 30,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14499",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "03:02",
					"arrivesAt": "03:14",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara C.E.T.",
					"leavesAt": "03:15",
					"arrivesAt": "03:18",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişeni Hm.",
					"leavesAt": "03:19",
					"arrivesAt": "03:26",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişeni Hm.",
					"to": "Jebel",
					"leavesAt": "03:27",
					"arrivesAt": "03:39",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Jebel",
					"to": "Voiteni",
					"leavesAt": "03:40",
					"arrivesAt": "03:50",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Voiteni",
					"to": "Gătaia",
					"leavesAt": "03:51",
					"arrivesAt": "04:09",
					"waitsAtSource": 60,
					"distance": 18200
				},
				{
					"from": "Gătaia",
					"to": "Măureni hc.",
					"leavesAt": "04:24",
					"arrivesAt": "04:32",
					"waitsAtSource": 900,
					"distance": 6700
				},
				{
					"from": "Măureni hc.",
					"to": "Gherteniş hc.",
					"leavesAt": "04:33",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Gherteniş hc.",
					"to": "Berzovia",
					"leavesAt": "04:41",
					"arrivesAt": "04:45",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Berzovia",
					"to": "Bocşa Română hc.",
					"leavesAt": "04:55",
					"arrivesAt": "05:05",
					"waitsAtSource": 600,
					"distance": 8200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Vasiova",
					"leavesAt": "05:06",
					"arrivesAt": "05:12",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Montană hc.",
					"leavesAt": "05:13",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Colţan h.",
					"leavesAt": "05:18",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Colţan h.",
					"to": "Moniom h.",
					"leavesAt": "05:26",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moniom h.",
					"to": "Câlnic h.",
					"leavesAt": "05:32",
					"arrivesAt": "05:40",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "05:41",
					"arrivesAt": "05:45",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14841",
			"segments": [
				{
					"from": "Dagâţa",
					"to": "Băluşeşti h",
					"leavesAt": "04:26",
					"arrivesAt": "04:30",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Băluşeşti h",
					"to": "Suhuleţ h.",
					"leavesAt": "04:31",
					"arrivesAt": "04:35",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Suhuleţ h.",
					"to": "Mareşal C-tin Prezan Hm.",
					"leavesAt": "04:36",
					"arrivesAt": "04:42",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Mareşal C-tin Prezan Hm.",
					"to": "Dumeşti h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:50",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumeşti h.",
					"to": "Rafaila h.",
					"leavesAt": "04:51",
					"arrivesAt": "04:58",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Rafaila h.",
					"to": "Negreşti Vaslui Hm.",
					"leavesAt": "04:59",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Negreşti Vaslui Hm.",
					"to": "Buhăieşti",
					"leavesAt": "05:07",
					"arrivesAt": "05:23",
					"waitsAtSource": 60,
					"distance": 10700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "RGT",
			"number": "14065",
			"segments": [
				{
					"from": "Braşov",
					"to": "Augustin Hm.",
					"leavesAt": "07:44",
					"arrivesAt": "08:39",
					"waitsAtSource": 0,
					"distance": 49100
				},
				{
					"from": "Augustin Hm.",
					"to": "Rupea",
					"leavesAt": "08:40",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 24700
				},
				{
					"from": "Rupea",
					"to": "Sighişoara",
					"leavesAt": "09:16",
					"arrivesAt": "10:28",
					"waitsAtSource": 60,
					"distance": 53600
				},
				{
					"from": "Sighişoara",
					"to": "Mediaş",
					"leavesAt": "10:32",
					"arrivesAt": "11:20",
					"waitsAtSource": 240,
					"distance": 38400
				},
				{
					"from": "Mediaş",
					"to": "Copşa Mică",
					"leavesAt": "11:22",
					"arrivesAt": "11:38",
					"waitsAtSource": 120,
					"distance": 10400
				},
				{
					"from": "Copşa Mică",
					"to": "Valea Lungă",
					"leavesAt": "11:39",
					"arrivesAt": "12:05",
					"waitsAtSource": 60,
					"distance": 17900
				},
				{
					"from": "Valea Lungă",
					"to": "Blaj",
					"leavesAt": "12:13",
					"arrivesAt": "12:27",
					"waitsAtSource": 480,
					"distance": 12100
				},
				{
					"from": "Blaj",
					"to": "Coşlariu Gr. P. Mureş",
					"leavesAt": "12:39",
					"arrivesAt": "13:02",
					"waitsAtSource": 720,
					"distance": 17900
				},
				{
					"from": "Coşlariu Gr. P. Mureş",
					"to": "Coşlariu",
					"leavesAt": "13:10",
					"arrivesAt": "13:16",
					"waitsAtSource": 480,
					"distance": 1500
				},
				{
					"from": "Coşlariu",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "13:21",
					"arrivesAt": "13:42",
					"waitsAtSource": 300,
					"distance": 11100
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "13:50",
					"arrivesAt": "13:58",
					"waitsAtSource": 480,
					"distance": 4500
				},
				{
					"from": "Alba Iulia",
					"to": "Vinţu de Jos",
					"leavesAt": "14:06",
					"arrivesAt": "14:20",
					"waitsAtSource": 480,
					"distance": 9800
				},
				{
					"from": "Vinţu de Jos",
					"to": "Şibot",
					"leavesAt": "14:21",
					"arrivesAt": "14:43",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Şibot",
					"to": "Orăştie",
					"leavesAt": "14:44",
					"arrivesAt": "14:59",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Orăştie",
					"to": "Simeria",
					"leavesAt": "15:05",
					"arrivesAt": "15:28",
					"waitsAtSource": 360,
					"distance": 16500
				},
				{
					"from": "Simeria",
					"to": "Deva",
					"leavesAt": "15:30",
					"arrivesAt": "15:42",
					"waitsAtSource": 120,
					"distance": 9200
				},
				{
					"from": "Deva",
					"to": "Ilia",
					"leavesAt": "15:44",
					"arrivesAt": "16:14",
					"waitsAtSource": 120,
					"distance": 23600
				},
				{
					"from": "Ilia",
					"to": "Săvârşin",
					"leavesAt": "16:15",
					"arrivesAt": "16:56",
					"waitsAtSource": 60,
					"distance": 40400
				},
				{
					"from": "Săvârşin",
					"to": "Radna",
					"leavesAt": "16:57",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 49700
				},
				{
					"from": "Radna",
					"to": "Arad",
					"leavesAt": "17:43",
					"arrivesAt": "18:19",
					"waitsAtSource": 60,
					"distance": 34500
				},
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "18:39",
					"arrivesAt": "18:46",
					"waitsAtSource": 1200,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Timişoara Nord",
					"leavesAt": "18:51",
					"arrivesAt": "19:41",
					"waitsAtSource": 300,
					"distance": 51000
				}
			],
			"restrictions": [
				{
					"from": "20170107",
					"to": "20170107",
					"daysOfWeek": 288
				},
				{
					"from": "20170114",
					"to": "20170114",
					"daysOfWeek": 288
				},
				{
					"from": "20170121",
					"to": "20170121",
					"daysOfWeek": 288
				},
				{
					"from": "20170128",
					"to": "20170128",
					"daysOfWeek": 288
				},
				{
					"from": "20170204",
					"to": "20170204",
					"daysOfWeek": 288
				},
				{
					"from": "20170211",
					"to": "20170211",
					"daysOfWeek": 288
				},
				{
					"from": "20170218",
					"to": "20170218",
					"daysOfWeek": 288
				},
				{
					"from": "20170225",
					"to": "20170225",
					"daysOfWeek": 288
				},
				{
					"from": "20170304",
					"to": "20170304",
					"daysOfWeek": 288
				},
				{
					"from": "20170311",
					"to": "20170311",
					"daysOfWeek": 288
				},
				{
					"from": "20170318",
					"to": "20170318",
					"daysOfWeek": 288
				},
				{
					"from": "20170325",
					"to": "20170325",
					"daysOfWeek": 288
				},
				{
					"from": "20170401",
					"to": "20170401",
					"daysOfWeek": 288
				},
				{
					"from": "20170408",
					"to": "20170408",
					"daysOfWeek": 288
				},
				{
					"from": "20170415",
					"to": "20170415",
					"daysOfWeek": 288
				},
				{
					"from": "20170422",
					"to": "20170422",
					"daysOfWeek": 288
				},
				{
					"from": "20170429",
					"to": "20170429",
					"daysOfWeek": 288
				},
				{
					"from": "20170506",
					"to": "20170506",
					"daysOfWeek": 288
				},
				{
					"from": "20170513",
					"to": "20170513",
					"daysOfWeek": 288
				},
				{
					"from": "20170520",
					"to": "20170520",
					"daysOfWeek": 288
				},
				{
					"from": "20170527",
					"to": "20170527",
					"daysOfWeek": 288
				},
				{
					"from": "20170603",
					"to": "20170603",
					"daysOfWeek": 288
				},
				{
					"from": "20170610",
					"to": "20170610",
					"daysOfWeek": 288
				},
				{
					"from": "20170617",
					"to": "20170617",
					"daysOfWeek": 288
				},
				{
					"from": "20170624",
					"to": "20170624",
					"daysOfWeek": 288
				},
				{
					"from": "20170701",
					"to": "20170701",
					"daysOfWeek": 288
				},
				{
					"from": "20170708",
					"to": "20170708",
					"daysOfWeek": 288
				},
				{
					"from": "20170715",
					"to": "20170715",
					"daysOfWeek": 288
				},
				{
					"from": "20170722",
					"to": "20170722",
					"daysOfWeek": 288
				},
				{
					"from": "20170729",
					"to": "20170729",
					"daysOfWeek": 288
				},
				{
					"from": "20170805",
					"to": "20170805",
					"daysOfWeek": 288
				},
				{
					"from": "20170812",
					"to": "20170812",
					"daysOfWeek": 288
				},
				{
					"from": "20170819",
					"to": "20170819",
					"daysOfWeek": 288
				},
				{
					"from": "20170826",
					"to": "20170826",
					"daysOfWeek": 288
				},
				{
					"from": "20170902",
					"to": "20170902",
					"daysOfWeek": 288
				},
				{
					"from": "20170909",
					"to": "20170909",
					"daysOfWeek": 288
				},
				{
					"from": "20170916",
					"to": "20170916",
					"daysOfWeek": 288
				},
				{
					"from": "20170923",
					"to": "20170923",
					"daysOfWeek": 288
				},
				{
					"from": "20170930",
					"to": "20170930",
					"daysOfWeek": 288
				},
				{
					"from": "20171007",
					"to": "20171007",
					"daysOfWeek": 288
				},
				{
					"from": "20171014",
					"to": "20171014",
					"daysOfWeek": 288
				},
				{
					"from": "20171021",
					"to": "20171021",
					"daysOfWeek": 288
				},
				{
					"from": "20171028",
					"to": "20171028",
					"daysOfWeek": 288
				},
				{
					"from": "20171104",
					"to": "20171104",
					"daysOfWeek": 288
				},
				{
					"from": "20171111",
					"to": "20171111",
					"daysOfWeek": 288
				},
				{
					"from": "20171118",
					"to": "20171118",
					"daysOfWeek": 288
				},
				{
					"from": "20171125",
					"to": "20171125",
					"daysOfWeek": 288
				},
				{
					"from": "20171202",
					"to": "20171202",
					"daysOfWeek": 288
				},
				{
					"from": "20171209",
					"to": "20171209",
					"daysOfWeek": 288
				},
				{
					"from": "20161217",
					"to": "20161217",
					"daysOfWeek": 288
				},
				{
					"from": "20161224",
					"to": "20161224",
					"daysOfWeek": 288
				},
				{
					"from": "20161231",
					"to": "20161231",
					"daysOfWeek": 288
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14300",
			"segments": [
				{
					"from": "Nădlac",
					"to": "Şeitin h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:52",
					"waitsAtSource": 0,
					"distance": 8100
				},
				{
					"from": "Şeitin h.",
					"to": "Semlac h.",
					"leavesAt": "07:53",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Semlac h.",
					"to": "Pecica",
					"leavesAt": "08:04",
					"arrivesAt": "08:28",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Pecica",
					"to": "Sântoma h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:54",
					"waitsAtSource": 840,
					"distance": 8000
				},
				{
					"from": "Sântoma h.",
					"to": "Ferma Ciala h.",
					"leavesAt": "08:55",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Arad Vest",
					"leavesAt": "09:02",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Arad Vest",
					"to": "Arad",
					"leavesAt": "09:11",
					"arrivesAt": "09:20",
					"waitsAtSource": 180,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14295",
			"segments": [
				{
					"from": "Arad",
					"to": "Arad Vest",
					"leavesAt": "05:35",
					"arrivesAt": "05:44",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Arad Vest",
					"to": "Ferma Ciala h.",
					"leavesAt": "05:45",
					"arrivesAt": "05:50",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Sântoma h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:57",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sântoma h.",
					"to": "Pecica",
					"leavesAt": "05:58",
					"arrivesAt": "06:10",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pecica",
					"to": "Canton Nr. 9 h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:36",
					"waitsAtSource": 780,
					"distance": 9600
				},
				{
					"from": "Canton Nr. 9 h.",
					"to": "Semlac h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:47",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Semlac h.",
					"to": "Şeitin h.",
					"leavesAt": "06:48",
					"arrivesAt": "06:58",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Şeitin h.",
					"to": "Nădlac",
					"leavesAt": "06:59",
					"arrivesAt": "07:12",
					"waitsAtSource": 60,
					"distance": 8100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14703",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "07:55",
					"arrivesAt": "08:01",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "08:10",
					"arrivesAt": "08:13",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "08:14",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "08:22",
					"arrivesAt": "08:27",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "08:28",
					"arrivesAt": "08:31",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "08:32",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14440",
			"segments": [
				{
					"from": "Brad",
					"to": "Ribiţa h.",
					"leavesAt": "04:50",
					"arrivesAt": "04:54",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Ribiţa h.",
					"to": "Ţebea h",
					"leavesAt": "04:55",
					"arrivesAt": "04:58",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Ţebea h",
					"to": "Baia de Criş h.",
					"leavesAt": "04:59",
					"arrivesAt": "05:02",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Baia de Criş h.",
					"to": "Lunca Moţilor h.",
					"leavesAt": "05:03",
					"arrivesAt": "05:06",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Lunca Moţilor h.",
					"to": "Birtin h.",
					"leavesAt": "05:07",
					"arrivesAt": "05:12",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Birtin h.",
					"to": "Vaţa h.",
					"leavesAt": "05:13",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Vaţa h.",
					"to": "Ociu h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:24",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ociu h.",
					"to": "Ocişor h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:29",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Ocişor h.",
					"to": "Hălmagiu Hm.",
					"leavesAt": "05:30",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Hălmagiu Hm.",
					"to": "Cariera Leasa h.",
					"leavesAt": "05:36",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Cariera Leasa h.",
					"to": "Vârfurile Hm.",
					"leavesAt": "05:41",
					"arrivesAt": "05:45",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Vârfurile Hm.",
					"to": "Tălagiu h.",
					"leavesAt": "05:57",
					"arrivesAt": "06:02",
					"waitsAtSource": 720,
					"distance": 4500
				},
				{
					"from": "Tălagiu h.",
					"to": "Aciuţa h.",
					"leavesAt": "06:03",
					"arrivesAt": "06:10",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Aciuţa h.",
					"to": "Romaniţa h.",
					"leavesAt": "06:11",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Romaniţa h.",
					"to": "Gurahonţ",
					"leavesAt": "06:15",
					"arrivesAt": "06:25",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gurahonţ",
					"to": "Bonţeşti h.",
					"leavesAt": "06:26",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Bonţeşti h.",
					"to": "Almaş h.",
					"leavesAt": "06:31",
					"arrivesAt": "06:36",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Almaş h.",
					"to": "Joia Mare hc.",
					"leavesAt": "06:37",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Joia Mare hc.",
					"to": "Paulian h.",
					"leavesAt": "06:43",
					"arrivesAt": "06:47",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Paulian h.",
					"to": "Sebiş",
					"leavesAt": "06:48",
					"arrivesAt": "06:54",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Sebiş",
					"to": "Răpsig h.",
					"leavesAt": "07:08",
					"arrivesAt": "07:18",
					"waitsAtSource": 840,
					"distance": 10000
				},
				{
					"from": "Răpsig h.",
					"to": "Bocsig  h",
					"leavesAt": "07:19",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bocsig  h",
					"to": "Tămand h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Tămand h.",
					"to": "Ineu",
					"leavesAt": "07:31",
					"arrivesAt": "07:39",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Ineu",
					"to": "Mocrea h.",
					"leavesAt": "07:40",
					"arrivesAt": "07:47",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mocrea h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "07:48",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Seleuş h.",
					"leavesAt": "07:55",
					"arrivesAt": "08:02",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Seleuş h.",
					"to": "Pâncota h.",
					"leavesAt": "08:03",
					"arrivesAt": "08:08",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pâncota h.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:12",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Şiria Hm.",
					"leavesAt": "08:13",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Şiria Hm.",
					"to": "Sântana",
					"leavesAt": "08:18",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:44",
					"waitsAtSource": 180,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utviniş h.",
					"leavesAt": "08:45",
					"arrivesAt": "08:48",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Utviniş h.",
					"to": "Utvinişu Nou",
					"leavesAt": "08:49",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Utvinişu Nou",
					"to": "Arad",
					"leavesAt": "08:53",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14738",
			"segments": [
				{
					"from": "Breţcu Hm.",
					"to": "Lemnia h.",
					"leavesAt": "16:53",
					"arrivesAt": "16:59",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Lemnia h.",
					"to": "Mereni Lutoasa h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:05",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Mereni Lutoasa h.",
					"to": "Bălani h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:11",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bălani h.",
					"to": "Poieniţa h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:17",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Poieniţa h.",
					"to": "Sânzieni h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Sânzieni h.",
					"to": "Târgu Secuiesc",
					"leavesAt": "17:23",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Târgu Secuiesc",
					"to": "Cătălina h.",
					"leavesAt": "18:00",
					"arrivesAt": "18:05",
					"waitsAtSource": 1500,
					"distance": 4400
				},
				{
					"from": "Cătălina h.",
					"to": "Imeci Hm.",
					"leavesAt": "18:06",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Imeci Hm.",
					"to": "Zăbala h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Zăbala h.",
					"to": "Covasna Hm.",
					"leavesAt": "18:18",
					"arrivesAt": "18:24",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Covasna Hm.",
					"to": "Brateş h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Brateş h.",
					"to": "Ţufalău h.",
					"leavesAt": "18:34",
					"arrivesAt": "18:38",
					"waitsAtSource": 30,
					"distance": 3020
				},
				{
					"from": "Ţufalău h.",
					"to": "Boroşneu Mare h.",
					"leavesAt": "18:39",
					"arrivesAt": "18:42",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boroşneu Mare h.",
					"to": "Biţa h.",
					"leavesAt": "18:43",
					"arrivesAt": "18:48",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Biţa h.",
					"to": "Moacşa hcv",
					"leavesAt": "18:49",
					"arrivesAt": "18:54",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Moacşa hcv",
					"to": "Angheluş h.",
					"leavesAt": "18:55",
					"arrivesAt": "19:01",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Angheluş h.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "19:02",
					"arrivesAt": "19:11",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14442",
			"segments": [
				{
					"from": "Brad",
					"to": "Ribiţa h.",
					"leavesAt": "07:12",
					"arrivesAt": "07:17",
					"waitsAtSource": 0,
					"distance": 3400
				},
				{
					"from": "Ribiţa h.",
					"to": "Ţebea h",
					"leavesAt": "07:18",
					"arrivesAt": "07:21",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Ţebea h",
					"to": "Baia de Criş h.",
					"leavesAt": "07:22",
					"arrivesAt": "07:25",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Baia de Criş h.",
					"to": "Lunca Moţilor h.",
					"leavesAt": "07:26",
					"arrivesAt": "07:29",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Lunca Moţilor h.",
					"to": "Birtin h.",
					"leavesAt": "07:30",
					"arrivesAt": "07:35",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Birtin h.",
					"to": "Vaţa h.",
					"leavesAt": "07:36",
					"arrivesAt": "07:42",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Vaţa h.",
					"to": "Ociu h.",
					"leavesAt": "07:43",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Ociu h.",
					"to": "Ocişor h.",
					"leavesAt": "07:49",
					"arrivesAt": "07:53",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ocişor h.",
					"to": "Hălmagiu Hm.",
					"leavesAt": "07:54",
					"arrivesAt": "07:59",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Hălmagiu Hm.",
					"to": "Cariera Leasa h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:05",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Cariera Leasa h.",
					"to": "Vârfurile Hm.",
					"leavesAt": "08:06",
					"arrivesAt": "08:10",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Vârfurile Hm.",
					"to": "Tălagiu h.",
					"leavesAt": "08:11",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tălagiu h.",
					"to": "Aciuţa h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Aciuţa h.",
					"to": "Romaniţa h.",
					"leavesAt": "08:26",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Romaniţa h.",
					"to": "Gurahonţ",
					"leavesAt": "08:31",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 6100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18231",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "13:23",
					"arrivesAt": "13:30",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Zădăreni Hm.",
					"leavesAt": "13:37",
					"arrivesAt": "13:47",
					"waitsAtSource": 420,
					"distance": 9600
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "13:48",
					"arrivesAt": "13:50",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Felnac hc.",
					"leavesAt": "13:51",
					"arrivesAt": "13:56",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Felnac hc.",
					"to": "Sânpetru German h.",
					"leavesAt": "13:57",
					"arrivesAt": "14:03",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sânpetru German h.",
					"to": "Munor h.",
					"leavesAt": "14:04",
					"arrivesAt": "14:07",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Munor h.",
					"to": "Secusigiu h",
					"leavesAt": "14:08",
					"arrivesAt": "14:12",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Secusigiu h",
					"to": "Aranca h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:16",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Aranca h.",
					"to": "Periam",
					"leavesAt": "14:17",
					"arrivesAt": "14:28",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Periam",
					"to": "Sânpetru h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:35",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Sânpetru h.",
					"to": "Saravale h.",
					"leavesAt": "14:36",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Saravale h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "14:45",
					"arrivesAt": "14:55",
					"waitsAtSource": 30,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14707",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "12:00",
					"arrivesAt": "12:06",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "12:07",
					"arrivesAt": "12:15",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "12:16",
					"arrivesAt": "12:19",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "12:20",
					"arrivesAt": "12:24",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "12:25",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "12:28",
					"arrivesAt": "12:33",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "12:34",
					"arrivesAt": "12:37",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "12:38",
					"arrivesAt": "12:41",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14359",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "07:15",
					"arrivesAt": "07:22",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Zădăreni Hm.",
					"leavesAt": "07:26",
					"arrivesAt": "07:36",
					"waitsAtSource": 240,
					"distance": 9600
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Felnac hc.",
					"leavesAt": "07:42",
					"arrivesAt": "07:48",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Felnac hc.",
					"to": "Sânpetru German h.",
					"leavesAt": "07:49",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sânpetru German h.",
					"to": "Munor h.",
					"leavesAt": "07:57",
					"arrivesAt": "08:00",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Munor h.",
					"to": "Secusigiu h",
					"leavesAt": "08:01",
					"arrivesAt": "08:05",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Secusigiu h",
					"to": "Aranca h.",
					"leavesAt": "08:06",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Aranca h.",
					"to": "Periam",
					"leavesAt": "08:10",
					"arrivesAt": "08:21",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Periam",
					"to": "Sânpetru h.",
					"leavesAt": "08:35",
					"arrivesAt": "08:42",
					"waitsAtSource": 840,
					"distance": 4500
				},
				{
					"from": "Sânpetru h.",
					"to": "Saravale h.",
					"leavesAt": "08:43",
					"arrivesAt": "08:52",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Saravale h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "08:53",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14305",
			"segments": [
				{
					"from": "Arad",
					"to": "Arad Vest",
					"leavesAt": "19:40",
					"arrivesAt": "19:49",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Arad Vest",
					"to": "Ferma Ciala h.",
					"leavesAt": "19:50",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Sântoma h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sântoma h.",
					"to": "Pecica",
					"leavesAt": "20:05",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pecica",
					"to": "Semlac h.",
					"leavesAt": "20:32",
					"arrivesAt": "20:56",
					"waitsAtSource": 780,
					"distance": 17200
				},
				{
					"from": "Semlac h.",
					"to": "Şeitin h.",
					"leavesAt": "20:57",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Şeitin h.",
					"to": "Nădlac",
					"leavesAt": "21:08",
					"arrivesAt": "21:21",
					"waitsAtSource": 60,
					"distance": 8100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14427",
			"segments": [
				{
					"from": "Ineu",
					"to": "Teuz h.",
					"leavesAt": "16:12",
					"arrivesAt": "16:23",
					"waitsAtSource": 0,
					"distance": 10600
				},
				{
					"from": "Teuz h.",
					"to": "Cermei hcv",
					"leavesAt": "16:24",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14970",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "04:24",
					"arrivesAt": "04:28",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "04:29",
					"arrivesAt": "04:34",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "04:35",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Fulga hc.",
					"leavesAt": "04:41",
					"arrivesAt": "04:47",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Fulga hc.",
					"to": "Ciorani Hm.",
					"leavesAt": "04:48",
					"arrivesAt": "04:53",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ciorani Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "04:54",
					"arrivesAt": "04:59",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hătcărău h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "05:00",
					"arrivesAt": "05:03",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Cornurile h.",
					"leavesAt": "05:04",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Cornurile h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "05:10",
					"arrivesAt": "05:15",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Trestieni h.",
					"leavesAt": "05:16",
					"arrivesAt": "05:19",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Trestieni h.",
					"to": "Râfov h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:24",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Râfov h.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "05:25",
					"arrivesAt": "05:28",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Dâmbu Hm.",
					"leavesAt": "05:29",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Ploieşti Sud",
					"leavesAt": "05:35",
					"arrivesAt": "05:40",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14610",
			"segments": [
				{
					"from": "Praid",
					"to": "Sovata  hcv.",
					"leavesAt": "15:30",
					"arrivesAt": "15:50",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Sovata  hcv.",
					"to": "Sărăţeni h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:56",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sărăţeni h.",
					"to": "Chibed h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:02",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Chibed h.",
					"to": "Ghindari h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:08",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Ghindari h.",
					"to": "Cioc h.",
					"leavesAt": "16:09",
					"arrivesAt": "16:13",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Cioc h.",
					"to": "Sângeorgiu de Pădure h.",
					"leavesAt": "16:14",
					"arrivesAt": "16:21",
					"waitsAtSource": 30,
					"distance": 6600
				},
				{
					"from": "Sângeorgiu de Pădure h.",
					"to": "Fântânele h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Fântânele h.",
					"to": "Bălăuşeri hcv.",
					"leavesAt": "16:30",
					"arrivesAt": "16:40",
					"waitsAtSource": 30,
					"distance": 4900
				},
				{
					"from": "Bălăuşeri hcv.",
					"to": "Coroiu h.",
					"leavesAt": "17:00",
					"arrivesAt": "17:10",
					"waitsAtSource": 1200,
					"distance": 6700
				},
				{
					"from": "Coroiu h.",
					"to": "Şoimuş h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:14",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Şoimuş h.",
					"to": "Laslău h.",
					"leavesAt": "17:15",
					"arrivesAt": "17:22",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Laslău h.",
					"to": "Bahnea h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bahnea h.",
					"to": "Bernadea h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bernadea h.",
					"to": "Mica h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:42",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mica h.",
					"to": "Deaj h.",
					"leavesAt": "17:43",
					"arrivesAt": "17:47",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Deaj h.",
					"to": "Găneşti h.",
					"leavesAt": "17:48",
					"arrivesAt": "17:52",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Găneşti h.",
					"to": "Şeuca h.",
					"leavesAt": "17:53",
					"arrivesAt": "17:58",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Şeuca h.",
					"to": "Târnaveni",
					"leavesAt": "17:59",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Târnaveni",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "18:07",
					"arrivesAt": "18:12",
					"waitsAtSource": 180,
					"distance": 2400
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Adămuş h.",
					"leavesAt": "18:13",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Adămuş h.",
					"to": "Crăieşti h.",
					"leavesAt": "18:17",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Crăieşti h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "18:23",
					"arrivesAt": "18:30",
					"waitsAtSource": 60,
					"distance": 5160
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Feisa h.",
					"leavesAt": "18:31",
					"arrivesAt": "18:34",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Feisa h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "18:35",
					"arrivesAt": "18:39",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Bălcaci h.",
					"leavesAt": "18:40",
					"arrivesAt": "18:44",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Bălcaci h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "18:45",
					"arrivesAt": "18:48",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Şona h.",
					"leavesAt": "18:49",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Şona h.",
					"to": "Pănade h.",
					"leavesAt": "18:54",
					"arrivesAt": "18:59",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pănade h.",
					"to": "Sâncel h.",
					"leavesAt": "19:00",
					"arrivesAt": "19:03",
					"waitsAtSource": 60,
					"distance": 1654
				},
				{
					"from": "Sâncel h.",
					"to": "Blaj",
					"leavesAt": "19:04",
					"arrivesAt": "19:10",
					"waitsAtSource": 30,
					"distance": 4246
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14673",
			"segments": [
				{
					"from": "Zlatna hcv.",
					"to": "Zlatna h.",
					"leavesAt": "13:10",
					"arrivesAt": "13:14",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Zlatna h.",
					"to": "Zlatna Tehnică",
					"leavesAt": "13:15",
					"arrivesAt": "13:21",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Zlatna Tehnică",
					"to": "Feneş h.",
					"leavesAt": "13:24",
					"arrivesAt": "13:29",
					"waitsAtSource": 180,
					"distance": 2400
				},
				{
					"from": "Feneş h.",
					"to": "Prisaca h.",
					"leavesAt": "13:30",
					"arrivesAt": "13:34",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Prisaca h.",
					"to": "Poiana Ampoiului h.",
					"leavesAt": "13:35",
					"arrivesAt": "13:42",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Poiana Ampoiului h.",
					"to": "Văleni Meteş h.",
					"leavesAt": "13:43",
					"arrivesAt": "13:47",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Văleni Meteş h.",
					"to": "Tăutu Ampoiului h.",
					"leavesAt": "13:48",
					"arrivesAt": "13:54",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Tăutu Ampoiului h.",
					"to": "Ampoiţa h.",
					"leavesAt": "13:55",
					"arrivesAt": "14:00",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ampoiţa h.",
					"to": "Şard Ighiu h.",
					"leavesAt": "14:01",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Şard Ighiu h.",
					"to": "Bărăbanţ Nord h.",
					"leavesAt": "14:06",
					"arrivesAt": "14:13",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Bărăbanţ Nord h.",
					"to": "Antestaţie Bărăbanţ h.",
					"leavesAt": "14:14",
					"arrivesAt": "14:18",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Antestaţie Bărăbanţ h.",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "14:19",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Alba Iulia",
					"leavesAt": "14:24",
					"arrivesAt": "14:32",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14448",
			"segments": [
				{
					"from": "Gurahonţ",
					"to": "Bonţeşti h.",
					"leavesAt": "13:55",
					"arrivesAt": "13:59",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Bonţeşti h.",
					"to": "Almaş h.",
					"leavesAt": "14:00",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Almaş h.",
					"to": "Joia Mare hc.",
					"leavesAt": "14:06",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Joia Mare hc.",
					"to": "Paulian h.",
					"leavesAt": "14:12",
					"arrivesAt": "14:16",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Paulian h.",
					"to": "Sebiş",
					"leavesAt": "14:17",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Sebiş",
					"to": "Răpsig h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:50",
					"waitsAtSource": 1020,
					"distance": 10000
				},
				{
					"from": "Răpsig h.",
					"to": "Bocsig  h",
					"leavesAt": "14:51",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bocsig  h",
					"to": "Tămand h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Tămand h.",
					"to": "Ineu",
					"leavesAt": "15:03",
					"arrivesAt": "15:11",
					"waitsAtSource": 30,
					"distance": 8400
				},
				{
					"from": "Ineu",
					"to": "Mocrea h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:33",
					"waitsAtSource": 900,
					"distance": 4600
				},
				{
					"from": "Mocrea h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "15:34",
					"arrivesAt": "15:40",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Seleuş h.",
					"leavesAt": "15:41",
					"arrivesAt": "15:48",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Seleuş h.",
					"to": "Pâncota h.",
					"leavesAt": "15:49",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Pâncota h.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "15:55",
					"arrivesAt": "15:58",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Şiria Hm.",
					"leavesAt": "15:59",
					"arrivesAt": "16:03",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Şiria Hm.",
					"to": "Sântana",
					"leavesAt": "16:04",
					"arrivesAt": "16:16",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Sântana",
					"to": "Zimandu Nou h.",
					"leavesAt": "16:21",
					"arrivesAt": "16:32",
					"waitsAtSource": 300,
					"distance": 10700
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Utvinişu Nou",
					"leavesAt": "16:33",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Utvinişu Nou",
					"to": "Arad",
					"leavesAt": "16:40",
					"arrivesAt": "16:49",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14365",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "16:18",
					"arrivesAt": "16:26",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Zădăreni Hm.",
					"leavesAt": "16:30",
					"arrivesAt": "16:41",
					"waitsAtSource": 240,
					"distance": 9600
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "16:43",
					"arrivesAt": "16:47",
					"waitsAtSource": 120,
					"distance": 1900
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Felnac hc.",
					"leavesAt": "16:49",
					"arrivesAt": "16:55",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Felnac hc.",
					"to": "Sânpetru German h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:04",
					"waitsAtSource": 120,
					"distance": 6700
				},
				{
					"from": "Sânpetru German h.",
					"to": "Munor h.",
					"leavesAt": "17:06",
					"arrivesAt": "17:10",
					"waitsAtSource": 120,
					"distance": 2600
				},
				{
					"from": "Munor h.",
					"to": "Secusigiu h",
					"leavesAt": "17:12",
					"arrivesAt": "17:17",
					"waitsAtSource": 120,
					"distance": 2800
				},
				{
					"from": "Secusigiu h",
					"to": "Aranca h.",
					"leavesAt": "17:19",
					"arrivesAt": "17:24",
					"waitsAtSource": 120,
					"distance": 2000
				},
				{
					"from": "Aranca h.",
					"to": "Periam",
					"leavesAt": "17:25",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Periam",
					"to": "Sânpetru h.",
					"leavesAt": "17:59",
					"arrivesAt": "18:06",
					"waitsAtSource": 1320,
					"distance": 4500
				},
				{
					"from": "Sânpetru h.",
					"to": "Saravale h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:16",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Saravale h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "18:17",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14379",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Sânnicolau Nord h.",
					"leavesAt": "06:05",
					"arrivesAt": "06:17",
					"waitsAtSource": 0,
					"distance": 5400
				},
				{
					"from": "Sânnicolau Nord h.",
					"to": "Cenad h.",
					"leavesAt": "06:18",
					"arrivesAt": "06:41",
					"waitsAtSource": 30,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14820",
			"segments": [
				{
					"from": "Dorohoi",
					"to": "Broscăuţi h.",
					"leavesAt": "12:46",
					"arrivesAt": "12:52",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Broscăuţi h.",
					"to": "Carasa h.",
					"leavesAt": "12:53",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Carasa h.",
					"to": "Corlăteni h",
					"leavesAt": "13:01",
					"arrivesAt": "13:04",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Corlăteni h",
					"to": "Mateieni h.",
					"leavesAt": "13:05",
					"arrivesAt": "13:09",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mateieni h.",
					"to": "Vorniceni h.",
					"leavesAt": "13:10",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Vorniceni h.",
					"to": "Mândreşti h.",
					"leavesAt": "13:15",
					"arrivesAt": "13:23",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mândreşti h.",
					"to": "Ungureni Hm.",
					"leavesAt": "13:24",
					"arrivesAt": "13:30",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ungureni Hm.",
					"to": "Dângeni Nord h.",
					"leavesAt": "13:31",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Dângeni",
					"leavesAt": "13:40",
					"arrivesAt": "13:45",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni",
					"to": "Buhăceni h.",
					"leavesAt": "13:46",
					"arrivesAt": "13:52",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Buhăceni h.",
					"to": "Truşeşti",
					"leavesAt": "13:53",
					"arrivesAt": "13:59",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Truşeşti",
					"to": "Zlătunoaia h",
					"leavesAt": "14:14",
					"arrivesAt": "14:23",
					"waitsAtSource": 900,
					"distance": 9400
				},
				{
					"from": "Zlătunoaia h",
					"to": "Jijia h.",
					"leavesAt": "14:24",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Jijia h.",
					"to": "Todireni Hm.",
					"leavesAt": "14:31",
					"arrivesAt": "14:39",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Todireni Hm.",
					"to": "Răuşeni hc.",
					"leavesAt": "14:40",
					"arrivesAt": "14:46",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Răuşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "14:47",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rediu hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "14:53",
					"arrivesAt": "14:58",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Şoldana hc.",
					"leavesAt": "14:59",
					"arrivesAt": "15:04",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Şoldana hc.",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "15:05",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Vlădeni",
					"leavesAt": "15:11",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Vlădeni",
					"to": "Larga Jijia Hm.",
					"leavesAt": "15:19",
					"arrivesAt": "15:30",
					"waitsAtSource": 120,
					"distance": 10800
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Potângeni hc.",
					"leavesAt": "15:31",
					"arrivesAt": "15:37",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Potângeni hc.",
					"to": "Movileni h",
					"leavesAt": "15:38",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Movileni h",
					"to": "Leţcani",
					"leavesAt": "15:47",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "15:59",
					"arrivesAt": "16:15",
					"waitsAtSource": 120,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14297",
			"segments": [
				{
					"from": "Arad",
					"to": "Arad Vest",
					"leavesAt": "08:00",
					"arrivesAt": "08:09",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Arad Vest",
					"to": "Ferma Ciala h.",
					"leavesAt": "08:10",
					"arrivesAt": "08:16",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Sântoma h.",
					"leavesAt": "08:17",
					"arrivesAt": "08:23",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Sântoma h.",
					"to": "Pecica",
					"leavesAt": "08:24",
					"arrivesAt": "08:36",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pecica",
					"to": "Semlac h.",
					"leavesAt": "08:37",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Semlac h.",
					"to": "Şeitin h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Şeitin h.",
					"to": "Nădlac",
					"leavesAt": "09:13",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 8100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14811",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "20:30",
					"arrivesAt": "20:41",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "20:42",
					"arrivesAt": "20:50",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Erbiceni hc.",
					"leavesAt": "20:55",
					"arrivesAt": "21:04",
					"waitsAtSource": 300,
					"distance": 6000
				},
				{
					"from": "Erbiceni hc.",
					"to": "Spinoasa h.",
					"leavesAt": "21:05",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Spinoasa h.",
					"to": "Belceşti Hm.",
					"leavesAt": "21:14",
					"arrivesAt": "21:25",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Belceşti Hm.",
					"to": "Podu Ulmi h.",
					"leavesAt": "21:26",
					"arrivesAt": "21:31",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Hodora h.",
					"leavesAt": "21:32",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Hodora h.",
					"to": "Cotnari hc.",
					"leavesAt": "21:38",
					"arrivesAt": "21:43",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Cotnari hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "21:44",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Bădeni hc.",
					"leavesAt": "21:49",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bădeni hc.",
					"to": "Hârlău",
					"leavesAt": "21:55",
					"arrivesAt": "22:00",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14362",
			"segments": [
				{
					"from": "Vălcani hcv.",
					"to": "Dudeştii Vechi  h",
					"leavesAt": "06:55",
					"arrivesAt": "07:04",
					"waitsAtSource": 0,
					"distance": 7000
				},
				{
					"from": "Dudeştii Vechi  h",
					"to": "Sânnicolau Mare",
					"leavesAt": "07:05",
					"arrivesAt": "07:23",
					"waitsAtSource": 60,
					"distance": 14000
				},
				{
					"from": "Sânnicolau Mare",
					"to": "Saravale h.",
					"leavesAt": "07:37",
					"arrivesAt": "07:47",
					"waitsAtSource": 840,
					"distance": 7600
				},
				{
					"from": "Saravale h.",
					"to": "Sânpetru h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:56",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sânpetru h.",
					"to": "Periam",
					"leavesAt": "07:57",
					"arrivesAt": "08:03",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Periam",
					"to": "Aranca h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:42",
					"waitsAtSource": 1740,
					"distance": 11100
				},
				{
					"from": "Aranca h.",
					"to": "Secusigiu h",
					"leavesAt": "08:43",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Secusigiu h",
					"to": "Munor h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Munor h.",
					"to": "Sânpetru German h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:54",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sânpetru German h.",
					"to": "Felnac hc.",
					"leavesAt": "08:55",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Felnac hc.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:07",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Zădăreni Hm.",
					"leavesAt": "09:08",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Aradu Nou",
					"leavesAt": "09:12",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "09:25",
					"arrivesAt": "09:32",
					"waitsAtSource": 180,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14761",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "19:55",
					"arrivesAt": "20:00",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "20:01",
					"arrivesAt": "20:07",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Budila hcv.",
					"leavesAt": "20:08",
					"arrivesAt": "20:18",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Budila hcv.",
					"to": "Teliu h.",
					"leavesAt": "20:19",
					"arrivesAt": "20:25",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Teliu h.",
					"to": "Valea Teliului h.",
					"leavesAt": "20:26",
					"arrivesAt": "20:31",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Valea Teliului h.",
					"to": "Poiana Florilor h.",
					"leavesAt": "20:32",
					"arrivesAt": "20:38",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Întorsura Buzăului Hm",
					"leavesAt": "20:39",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14611",
			"segments": [
				{
					"from": "Blaj",
					"to": "Sâncel h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:51",
					"waitsAtSource": 0,
					"distance": 4246
				},
				{
					"from": "Sâncel h.",
					"to": "Pănade h.",
					"leavesAt": "16:52",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 1654
				},
				{
					"from": "Pănade h.",
					"to": "Şona h.",
					"leavesAt": "16:56",
					"arrivesAt": "17:01",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Şona h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Bălcaci h.",
					"leavesAt": "17:07",
					"arrivesAt": "17:10",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bălcaci h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "17:11",
					"arrivesAt": "17:15",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Feisa h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Feisa h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:24",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Crăieşti h.",
					"leavesAt": "17:25",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Crăieşti h.",
					"to": "Corneşti Târnava h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Corneşti Târnava h.",
					"to": "Adămuş h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:40",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Adămuş h.",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "17:41",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Târnaveni",
					"leavesAt": "17:46",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 2400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14515",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Sud",
					"leavesAt": "20:02",
					"arrivesAt": "20:12",
					"waitsAtSource": 0,
					"distance": 5600
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara C.E.T.",
					"leavesAt": "20:13",
					"arrivesAt": "20:16",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişeni Hm.",
					"leavesAt": "20:17",
					"arrivesAt": "20:22",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişeni Hm.",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "20:23",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Jebel",
					"leavesAt": "20:29",
					"arrivesAt": "20:34",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Jebel",
					"to": "Voiteni",
					"leavesAt": "20:35",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Voiteni",
					"to": "Birda hcv.",
					"leavesAt": "20:53",
					"arrivesAt": "21:02",
					"waitsAtSource": 480,
					"distance": 9500
				},
				{
					"from": "Birda hcv.",
					"to": "Gătaia",
					"leavesAt": "21:03",
					"arrivesAt": "21:12",
					"waitsAtSource": 30,
					"distance": 8700
				},
				{
					"from": "Gătaia",
					"to": "Măureni hc.",
					"leavesAt": "21:13",
					"arrivesAt": "21:20",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Măureni hc.",
					"to": "Gherteniş hc.",
					"leavesAt": "21:21",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Gherteniş hc.",
					"to": "Berzovia",
					"leavesAt": "21:29",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Berzovia",
					"to": "Bocşa Română hc.",
					"leavesAt": "21:34",
					"arrivesAt": "21:43",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Vasiova",
					"leavesAt": "21:44",
					"arrivesAt": "21:50",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Montană hc.",
					"leavesAt": "21:51",
					"arrivesAt": "21:54",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Colţan h.",
					"leavesAt": "21:55",
					"arrivesAt": "22:02",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Colţan h.",
					"to": "Moniom h.",
					"leavesAt": "22:03",
					"arrivesAt": "22:08",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Moniom h.",
					"to": "Câlnic h.",
					"leavesAt": "22:09",
					"arrivesAt": "22:17",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "22:18",
					"arrivesAt": "22:21",
					"waitsAtSource": 30,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14020",
			"segments": [
				{
					"from": "Luduş",
					"to": "Luduş Sat hc.",
					"leavesAt": "17:14",
					"arrivesAt": "17:18",
					"waitsAtSource": 0,
					"distance": 2400
				},
				{
					"from": "Luduş Sat hc.",
					"to": "Sânger Tăureni h.",
					"leavesAt": "17:19",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 8080
				},
				{
					"from": "Sânger Tăureni h.",
					"to": "Tăureni h.",
					"leavesAt": "17:31",
					"arrivesAt": "17:39",
					"waitsAtSource": 30,
					"distance": 5620
				},
				{
					"from": "Tăureni h.",
					"to": "Melini Valea Largă h.",
					"leavesAt": "17:40",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Melini Valea Largă h.",
					"to": "Zau de Câmpie h.",
					"leavesAt": "17:45",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Zau de Câmpie h.",
					"to": "Bota Sat h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:54",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Bota Sat h.",
					"to": "Miheşu de Câmpie h.",
					"leavesAt": "17:55",
					"arrivesAt": "18:01",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Miheşu de Câmpie h.",
					"to": "Miheşu de Câmpie Sat h.",
					"leavesAt": "18:02",
					"arrivesAt": "18:08",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Miheşu de Câmpie Sat h.",
					"to": "Balda h.",
					"leavesAt": "18:09",
					"arrivesAt": "18:15",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Balda h.",
					"to": "Sărmaşu h.",
					"leavesAt": "18:16",
					"arrivesAt": "18:20",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sărmaşu h.",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "18:21",
					"arrivesAt": "18:25",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "18:26",
					"arrivesAt": "18:30",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Sărmăşel hcv .",
					"to": "Ţăgşor h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:36",
					"waitsAtSource": 180,
					"distance": 2000
				},
				{
					"from": "Ţăgşor h.",
					"to": "Ţagu Sat h.",
					"leavesAt": "18:37",
					"arrivesAt": "18:42",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Ţagu Sat h.",
					"to": "Ţagu h.",
					"leavesAt": "18:43",
					"arrivesAt": "18:45",
					"waitsAtSource": 30,
					"distance": 1400
				},
				{
					"from": "Ţagu h.",
					"to": "Budeşti Cluj h.",
					"leavesAt": "18:46",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Budeşti Cluj h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "18:54",
					"arrivesAt": "19:03",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "19:04",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Brăteni h.",
					"leavesAt": "19:10",
					"arrivesAt": "19:16",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Brăteni h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "19:17",
					"arrivesAt": "19:23",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Vermeş h.",
					"leavesAt": "19:24",
					"arrivesAt": "19:32",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vermeş h.",
					"to": "Lechinţa",
					"leavesAt": "19:33",
					"arrivesAt": "19:37",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Lechinţa",
					"to": "Ţigău h.",
					"leavesAt": "19:38",
					"arrivesAt": "19:45",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ţigău h.",
					"to": "Chiraleş h.",
					"leavesAt": "19:46",
					"arrivesAt": "19:50",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Chiraleş h.",
					"to": "Chintelnic h.",
					"leavesAt": "19:51",
					"arrivesAt": "19:54",
					"waitsAtSource": 30,
					"distance": 2276
				},
				{
					"from": "Chintelnic h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "19:55",
					"arrivesAt": "19:59",
					"waitsAtSource": 30,
					"distance": 2314
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "20:00",
					"arrivesAt": "20:02",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel",
					"leavesAt": "20:03",
					"arrivesAt": "20:09",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel",
					"to": "Sărata h.",
					"leavesAt": "20:10",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "20:16",
					"arrivesAt": "20:23",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "20:24",
					"arrivesAt": "20:27",
					"waitsAtSource": 60,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14984",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "20:40",
					"arrivesAt": "20:44",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "20:45",
					"arrivesAt": "20:50",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "20:51",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Fulga hc.",
					"leavesAt": "20:58",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Fulga hc.",
					"to": "Ciorani Hm.",
					"leavesAt": "21:05",
					"arrivesAt": "21:10",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ciorani Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "21:17",
					"arrivesAt": "21:22",
					"waitsAtSource": 420,
					"distance": 5400
				},
				{
					"from": "Hătcărău h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "21:23",
					"arrivesAt": "21:27",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Cornurile h.",
					"leavesAt": "21:28",
					"arrivesAt": "21:32",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Cornurile h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "21:33",
					"arrivesAt": "21:39",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Trestieni h.",
					"leavesAt": "21:40",
					"arrivesAt": "21:43",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Trestieni h.",
					"to": "Râfov h.",
					"leavesAt": "21:44",
					"arrivesAt": "21:48",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Râfov h.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "21:49",
					"arrivesAt": "21:53",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Dâmbu Hm.",
					"leavesAt": "21:54",
					"arrivesAt": "21:59",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Ploieşti Sud",
					"leavesAt": "22:00",
					"arrivesAt": "22:05",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14368",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Saravale h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:19",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Saravale h.",
					"to": "Sânpetru h.",
					"leavesAt": "20:20",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sânpetru h.",
					"to": "Periam",
					"leavesAt": "20:30",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Periam",
					"to": "Aranca h.",
					"leavesAt": "20:54",
					"arrivesAt": "21:05",
					"waitsAtSource": 1020,
					"distance": 11100
				},
				{
					"from": "Aranca h.",
					"to": "Secusigiu h",
					"leavesAt": "21:06",
					"arrivesAt": "21:10",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Secusigiu h",
					"to": "Munor h.",
					"leavesAt": "21:11",
					"arrivesAt": "21:15",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Munor h.",
					"to": "Sânpetru German h.",
					"leavesAt": "21:16",
					"arrivesAt": "21:20",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Sânpetru German h.",
					"to": "Felnac hc.",
					"leavesAt": "21:21",
					"arrivesAt": "21:28",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Felnac hc.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "21:29",
					"arrivesAt": "21:34",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Zădăreni Hm.",
					"leavesAt": "21:35",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Aradu Nou",
					"leavesAt": "21:39",
					"arrivesAt": "21:49",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "21:52",
					"arrivesAt": "21:59",
					"waitsAtSource": 180,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14366",
			"segments": [
				{
					"from": "Vălcani hcv.",
					"to": "Dudeştii Vechi  h",
					"leavesAt": "16:50",
					"arrivesAt": "16:59",
					"waitsAtSource": 0,
					"distance": 7000
				},
				{
					"from": "Dudeştii Vechi  h",
					"to": "Sânnicolau Mare",
					"leavesAt": "17:00",
					"arrivesAt": "17:18",
					"waitsAtSource": 60,
					"distance": 14000
				},
				{
					"from": "Sânnicolau Mare",
					"to": "Saravale h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:37",
					"waitsAtSource": 540,
					"distance": 7600
				},
				{
					"from": "Saravale h.",
					"to": "Sânpetru h.",
					"leavesAt": "17:38",
					"arrivesAt": "17:46",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sânpetru h.",
					"to": "Periam",
					"leavesAt": "17:47",
					"arrivesAt": "17:54",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Periam",
					"to": "Aranca h.",
					"leavesAt": "18:07",
					"arrivesAt": "18:17",
					"waitsAtSource": 780,
					"distance": 11100
				},
				{
					"from": "Aranca h.",
					"to": "Secusigiu h",
					"leavesAt": "18:18",
					"arrivesAt": "18:22",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Secusigiu h",
					"to": "Munor h.",
					"leavesAt": "18:23",
					"arrivesAt": "18:26",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Munor h.",
					"to": "Sânpetru German h.",
					"leavesAt": "18:27",
					"arrivesAt": "18:31",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Sânpetru German h.",
					"to": "Felnac hc.",
					"leavesAt": "18:32",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Felnac hc.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "18:40",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Zădăreni Hm.",
					"leavesAt": "18:46",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Aradu Nou",
					"leavesAt": "18:50",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "19:03",
					"arrivesAt": "19:10",
					"waitsAtSource": 180,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14674",
			"segments": [
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "19:25",
					"arrivesAt": "19:32",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Antestaţie Bărăbanţ h.",
					"leavesAt": "19:36",
					"arrivesAt": "19:38",
					"waitsAtSource": 240,
					"distance": 1400
				},
				{
					"from": "Antestaţie Bărăbanţ h.",
					"to": "Bărăbanţ Nord h.",
					"leavesAt": "19:39",
					"arrivesAt": "19:43",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Bărăbanţ Nord h.",
					"to": "Şard Ighiu h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:51",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Şard Ighiu h.",
					"to": "Ampoiţa h.",
					"leavesAt": "19:52",
					"arrivesAt": "19:56",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ampoiţa h.",
					"to": "Tăutu Ampoiului h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:01",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Tăutu Ampoiului h.",
					"to": "Văleni Meteş h.",
					"leavesAt": "20:02",
					"arrivesAt": "20:08",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Văleni Meteş h.",
					"to": "Poiana Ampoiului h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:13",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Poiana Ampoiului h.",
					"to": "Prisaca h.",
					"leavesAt": "20:14",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Prisaca h.",
					"to": "Feneş h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:26",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Feneş h.",
					"to": "Zlatna Tehnică",
					"leavesAt": "20:27",
					"arrivesAt": "20:32",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Zlatna Tehnică",
					"to": "Zlatna h.",
					"leavesAt": "20:35",
					"arrivesAt": "20:41",
					"waitsAtSource": 180,
					"distance": 4000
				},
				{
					"from": "Zlatna h.",
					"to": "Zlatna hcv.",
					"leavesAt": "20:42",
					"arrivesAt": "20:48",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14380",
			"segments": [
				{
					"from": "Cenad h.",
					"to": "Sânnicolau Nord h.",
					"leavesAt": "06:51",
					"arrivesAt": "07:14",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Sânnicolau Nord h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "07:15",
					"arrivesAt": "07:28",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Sânnicolau Mare",
					"to": "Tomnaticu h.",
					"leavesAt": "07:29",
					"arrivesAt": "07:39",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Tomnaticu h.",
					"to": "Lovrin",
					"leavesAt": "07:40",
					"arrivesAt": "07:50",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "08:08",
					"arrivesAt": "08:15",
					"waitsAtSource": 1080,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Şandra h.",
					"leavesAt": "08:16",
					"arrivesAt": "08:30",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şandra h.",
					"to": "Biled",
					"leavesAt": "08:31",
					"arrivesAt": "08:42",
					"waitsAtSource": 30,
					"distance": 5900
				},
				{
					"from": "Biled",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "08:54",
					"arrivesAt": "09:14",
					"waitsAtSource": 720,
					"distance": 10500
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "09:15",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "09:28",
					"arrivesAt": "09:35",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "09:38",
					"arrivesAt": "09:39",
					"waitsAtSource": 180,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "09:40",
					"arrivesAt": "09:42",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "09:43",
					"arrivesAt": "09:50",
					"waitsAtSource": 30,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14429",
			"segments": [
				{
					"from": "Ineu",
					"to": "Teuz h.",
					"leavesAt": "18:02",
					"arrivesAt": "18:13",
					"waitsAtSource": 0,
					"distance": 10600
				},
				{
					"from": "Teuz h.",
					"to": "Cermei hcv",
					"leavesAt": "18:14",
					"arrivesAt": "18:20",
					"waitsAtSource": 30,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14732",
			"segments": [
				{
					"from": "Breţcu Hm.",
					"to": "Lemnia h.",
					"leavesAt": "05:35",
					"arrivesAt": "05:41",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Lemnia h.",
					"to": "Mereni Lutoasa h.",
					"leavesAt": "05:42",
					"arrivesAt": "05:47",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Mereni Lutoasa h.",
					"to": "Bălani h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:53",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bălani h.",
					"to": "Poieniţa h.",
					"leavesAt": "05:54",
					"arrivesAt": "05:59",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Poieniţa h.",
					"to": "Sânzieni h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:04",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Sânzieni h.",
					"to": "Târgu Secuiesc",
					"leavesAt": "06:05",
					"arrivesAt": "06:17",
					"waitsAtSource": 30,
					"distance": 7000
				},
				{
					"from": "Târgu Secuiesc",
					"to": "Cătălina h.",
					"leavesAt": "06:19",
					"arrivesAt": "06:24",
					"waitsAtSource": 120,
					"distance": 4400
				},
				{
					"from": "Cătălina h.",
					"to": "Imeci Hm.",
					"leavesAt": "06:25",
					"arrivesAt": "06:27",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Imeci Hm.",
					"to": "Zăbala h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:35",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Zăbala h.",
					"to": "Covasna Hm.",
					"leavesAt": "06:36",
					"arrivesAt": "06:41",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Covasna Hm.",
					"to": "Brateş h.",
					"leavesAt": "06:42",
					"arrivesAt": "06:50",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Brateş h.",
					"to": "Ţufalău h.",
					"leavesAt": "06:51",
					"arrivesAt": "06:55",
					"waitsAtSource": 30,
					"distance": 3020
				},
				{
					"from": "Ţufalău h.",
					"to": "Boroşneu Mare h.",
					"leavesAt": "06:56",
					"arrivesAt": "06:59",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Boroşneu Mare h.",
					"to": "Biţa h.",
					"leavesAt": "07:00",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Biţa h.",
					"to": "Moacşa hcv",
					"leavesAt": "07:06",
					"arrivesAt": "07:10",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Moacşa hcv",
					"to": "Angheluş h.",
					"leavesAt": "07:11",
					"arrivesAt": "07:17",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Angheluş h.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "07:18",
					"arrivesAt": "07:27",
					"waitsAtSource": 60,
					"distance": 6500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14827",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "20:13",
					"arrivesAt": "20:26",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Movileni h",
					"leavesAt": "20:27",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Movileni h",
					"to": "Potângeni hc.",
					"leavesAt": "20:38",
					"arrivesAt": "20:44",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Potângeni hc.",
					"to": "Larga Jijia Hm.",
					"leavesAt": "20:45",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Vlădeni",
					"leavesAt": "20:52",
					"arrivesAt": "21:04",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vlădeni",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "21:06",
					"arrivesAt": "21:12",
					"waitsAtSource": 120,
					"distance": 5600
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Şoldana hc.",
					"leavesAt": "21:13",
					"arrivesAt": "21:18",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Şoldana hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "21:19",
					"arrivesAt": "21:24",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "21:25",
					"arrivesAt": "21:29",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Rediu hc.",
					"to": "Răuşeni hc.",
					"leavesAt": "21:30",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Răuşeni hc.",
					"to": "Todireni Hm.",
					"leavesAt": "21:36",
					"arrivesAt": "21:42",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Todireni Hm.",
					"to": "Jijia h.",
					"leavesAt": "21:43",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Jijia h.",
					"to": "Zlătunoaia h",
					"leavesAt": "21:52",
					"arrivesAt": "21:57",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zlătunoaia h",
					"to": "Truşeşti",
					"leavesAt": "21:58",
					"arrivesAt": "22:06",
					"waitsAtSource": 60,
					"distance": 9400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18251",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "08:35",
					"arrivesAt": "08:38",
					"waitsAtSource": 0,
					"distance": 900
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Sărata h.",
					"leavesAt": "08:39",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel",
					"leavesAt": "08:47",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sărăţel",
					"to": "Arcalia hc.",
					"leavesAt": "08:58",
					"arrivesAt": "09:03",
					"waitsAtSource": 360,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "09:04",
					"arrivesAt": "09:07",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Chintelnic h.",
					"leavesAt": "09:08",
					"arrivesAt": "09:12",
					"waitsAtSource": 60,
					"distance": 2314
				},
				{
					"from": "Chintelnic h.",
					"to": "Chiraleş h.",
					"leavesAt": "09:13",
					"arrivesAt": "09:17",
					"waitsAtSource": 30,
					"distance": 2276
				},
				{
					"from": "Chiraleş h.",
					"to": "Ţigău h.",
					"leavesAt": "09:18",
					"arrivesAt": "09:23",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ţigău h.",
					"to": "Lechinţa",
					"leavesAt": "09:24",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lechinţa",
					"to": "Vermeş h.",
					"leavesAt": "12:01",
					"arrivesAt": "12:04",
					"waitsAtSource": 9000,
					"distance": 2200
				},
				{
					"from": "Vermeş h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "12:05",
					"arrivesAt": "12:14",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Brăteni h.",
					"leavesAt": "12:15",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Brăteni h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "12:22",
					"arrivesAt": "12:29",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "12:30",
					"arrivesAt": "12:36",
					"waitsAtSource": 30,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14387",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "07:53",
					"arrivesAt": "08:00",
					"waitsAtSource": 0,
					"distance": 4400
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "08:04",
					"arrivesAt": "08:06",
					"waitsAtSource": 30,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "08:07",
					"arrivesAt": "08:14",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "08:15",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Biled",
					"leavesAt": "08:27",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Biled",
					"to": "Şandra h.",
					"leavesAt": "08:48",
					"arrivesAt": "08:59",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Şandra h.",
					"to": "Satu Nou Hm.",
					"leavesAt": "09:00",
					"arrivesAt": "09:15",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Lovrin",
					"leavesAt": "09:16",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lovrin",
					"to": "Tomnaticu h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:35",
					"waitsAtSource": 60,
					"distance": 7700
				},
				{
					"from": "Tomnaticu h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "09:36",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 8200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14319",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "14:15",
					"arrivesAt": "14:24",
					"waitsAtSource": 0,
					"distance": 6900
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "14:25",
					"arrivesAt": "14:31",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Hodoni h.",
					"leavesAt": "14:32",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Hodoni h.",
					"to": "Chinezu h.",
					"leavesAt": "14:43",
					"arrivesAt": "14:49",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Chinezu h.",
					"to": "Bărăteaz h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:55",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Bărăteaz h.",
					"to": "Gelu hc.",
					"leavesAt": "14:56",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Gelu hc.",
					"to": "Variaş hc.",
					"leavesAt": "15:02",
					"arrivesAt": "15:08",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Variaş hc.",
					"to": "Periam",
					"leavesAt": "15:09",
					"arrivesAt": "15:18",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Periam",
					"to": "Pesac h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:38",
					"waitsAtSource": 540,
					"distance": 6700
				},
				{
					"from": "Pesac h.",
					"to": "Satu Nou Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:47",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Lovrin",
					"leavesAt": "15:48",
					"arrivesAt": "15:56",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14031",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "08:50",
					"arrivesAt": "09:05",
					"waitsAtSource": 0,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "09:06",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "09:11",
					"arrivesAt": "09:19",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "09:20",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "09:26",
					"arrivesAt": "09:31",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "09:32",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Vest",
					"leavesAt": "09:42",
					"arrivesAt": "09:52",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "10:10",
					"arrivesAt": "10:17",
					"waitsAtSource": 1080,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "10:18",
					"arrivesAt": "10:27",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "10:28",
					"arrivesAt": "10:40",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "10:41",
					"arrivesAt": "10:46",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "10:47",
					"arrivesAt": "10:50",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "10:51",
					"arrivesAt": "10:54",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "10:55",
					"arrivesAt": "10:59",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Valea Largă Hm.",
					"leavesAt": "11:00",
					"arrivesAt": "11:09",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Sinaia Sud h.",
					"leavesAt": "11:10",
					"arrivesAt": "11:14",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "11:15",
					"arrivesAt": "11:18",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "11:19",
					"arrivesAt": "11:24",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "11:25",
					"arrivesAt": "11:29",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "11:30",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "11:36",
					"arrivesAt": "11:47",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Dârste",
					"leavesAt": "11:48",
					"arrivesAt": "12:16",
					"waitsAtSource": 60,
					"distance": 20100
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "12:17",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14715",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "20:15",
					"arrivesAt": "20:21",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "20:22",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "20:31",
					"arrivesAt": "20:34",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "20:35",
					"arrivesAt": "20:39",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "20:40",
					"arrivesAt": "20:42",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "20:43",
					"arrivesAt": "20:48",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "20:49",
					"arrivesAt": "20:52",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "20:53",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14363",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "14:18",
					"arrivesAt": "14:27",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Zădăreni Hm.",
					"leavesAt": "14:28",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "14:39",
					"arrivesAt": "14:42",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Felnac hc.",
					"leavesAt": "14:43",
					"arrivesAt": "14:49",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Felnac hc.",
					"to": "Sânpetru German h.",
					"leavesAt": "14:50",
					"arrivesAt": "14:57",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sânpetru German h.",
					"to": "Munor h.",
					"leavesAt": "14:58",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Munor h.",
					"to": "Secusigiu h",
					"leavesAt": "15:02",
					"arrivesAt": "15:06",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Secusigiu h",
					"to": "Aranca h.",
					"leavesAt": "15:07",
					"arrivesAt": "15:10",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Aranca h.",
					"to": "Periam",
					"leavesAt": "15:11",
					"arrivesAt": "15:22",
					"waitsAtSource": 30,
					"distance": 11100
				},
				{
					"from": "Periam",
					"to": "Sânpetru h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Sânpetru h.",
					"to": "Saravale h.",
					"leavesAt": "15:31",
					"arrivesAt": "15:39",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Saravale h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "15:40",
					"arrivesAt": "15:51",
					"waitsAtSource": 30,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14316",
			"segments": [
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "04:52",
					"arrivesAt": "05:00",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Pesac h.",
					"leavesAt": "05:01",
					"arrivesAt": "05:09",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pesac h.",
					"to": "Periam",
					"leavesAt": "05:10",
					"arrivesAt": "05:22",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Periam",
					"to": "Variaş hc.",
					"leavesAt": "05:23",
					"arrivesAt": "05:34",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Variaş hc.",
					"to": "Gelu hc.",
					"leavesAt": "05:35",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Gelu hc.",
					"to": "Bărăteaz h.",
					"leavesAt": "05:43",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bărăteaz h.",
					"to": "Chinezu h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:54",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Chinezu h.",
					"to": "Hodoni h.",
					"leavesAt": "05:55",
					"arrivesAt": "06:02",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Hodoni h.",
					"to": "Sânandrei Hm.",
					"leavesAt": "06:03",
					"arrivesAt": "06:14",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 180,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "06:24",
					"arrivesAt": "06:26",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "06:27",
					"arrivesAt": "06:30",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "06:31",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14603",
			"segments": [
				{
					"from": "Blaj",
					"to": "Sâncel h.",
					"leavesAt": "06:12",
					"arrivesAt": "06:18",
					"waitsAtSource": 0,
					"distance": 4246
				},
				{
					"from": "Sâncel h.",
					"to": "Pănade h.",
					"leavesAt": "06:19",
					"arrivesAt": "06:22",
					"waitsAtSource": 60,
					"distance": 1654
				},
				{
					"from": "Pănade h.",
					"to": "Şona h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:28",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Şona h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "06:29",
					"arrivesAt": "06:34",
					"waitsAtSource": 30,
					"distance": 3100
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Bălcaci h.",
					"leavesAt": "06:35",
					"arrivesAt": "06:38",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bălcaci h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "06:39",
					"arrivesAt": "06:43",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Feisa h.",
					"leavesAt": "06:50",
					"arrivesAt": "06:54",
					"waitsAtSource": 420,
					"distance": 2800
				},
				{
					"from": "Feisa h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "06:55",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 2540
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Crăieşti h.",
					"leavesAt": "06:59",
					"arrivesAt": "07:05",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Crăieşti h.",
					"to": "Corneşti Târnava h.",
					"leavesAt": "07:06",
					"arrivesAt": "07:09",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Corneşti Târnava h.",
					"to": "Adămuş h.",
					"leavesAt": "07:10",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Adămuş h.",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "07:14",
					"arrivesAt": "07:18",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Târnaveni",
					"leavesAt": "07:19",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Târnaveni",
					"to": "Şeuca h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:32",
					"waitsAtSource": 180,
					"distance": 2600
				},
				{
					"from": "Şeuca h.",
					"to": "Găneşti h.",
					"leavesAt": "07:33",
					"arrivesAt": "07:38",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Găneşti h.",
					"to": "Deaj h.",
					"leavesAt": "07:39",
					"arrivesAt": "07:43",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Deaj h.",
					"to": "Mica h.",
					"leavesAt": "07:44",
					"arrivesAt": "07:49",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Mica h.",
					"to": "Bernadea h.",
					"leavesAt": "07:50",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 2100
				},
				{
					"from": "Bernadea h.",
					"to": "Bahnea h.",
					"leavesAt": "07:55",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bahnea h.",
					"to": "Laslău h.",
					"leavesAt": "08:02",
					"arrivesAt": "08:09",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Laslău h.",
					"to": "Şoimuş h.",
					"leavesAt": "08:10",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Şoimuş h.",
					"to": "Coroiu h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:21",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Coroiu h.",
					"to": "Bălăuşeri hcv.",
					"leavesAt": "08:22",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bălăuşeri hcv.",
					"to": "Fântânele h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:46",
					"waitsAtSource": 240,
					"distance": 4900
				},
				{
					"from": "Fântânele h.",
					"to": "Sângeorgiu de Pădure h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:54",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Sângeorgiu de Pădure h.",
					"to": "Cioc h.",
					"leavesAt": "08:55",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 6600
				},
				{
					"from": "Cioc h.",
					"to": "Ghindari h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:06",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Ghindari h.",
					"to": "Chibed h.",
					"leavesAt": "09:07",
					"arrivesAt": "09:12",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Chibed h.",
					"to": "Sărăţeni h.",
					"leavesAt": "09:13",
					"arrivesAt": "09:18",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sărăţeni h.",
					"to": "Sovata  hcv.",
					"leavesAt": "09:19",
					"arrivesAt": "09:26",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sovata  hcv.",
					"to": "Praid",
					"leavesAt": "09:27",
					"arrivesAt": "09:47",
					"waitsAtSource": 60,
					"distance": 6900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18234",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Tomnaticu h.",
					"leavesAt": "12:36",
					"arrivesAt": "12:46",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Tomnaticu h.",
					"to": "Lovrin",
					"leavesAt": "12:47",
					"arrivesAt": "12:58",
					"waitsAtSource": 30,
					"distance": 7700
				},
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "12:59",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Şandra h.",
					"leavesAt": "13:07",
					"arrivesAt": "13:22",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Şandra h.",
					"to": "Biled",
					"leavesAt": "13:23",
					"arrivesAt": "13:35",
					"waitsAtSource": 60,
					"distance": 5900
				},
				{
					"from": "Biled",
					"to": "Pescăreţu Mic hc.",
					"leavesAt": "13:36",
					"arrivesAt": "13:56",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Pescăreţu Mic hc.",
					"to": "Dudeştii Noi Hm.",
					"leavesAt": "13:57",
					"arrivesAt": "14:08",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dudeştii Noi Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "14:09",
					"arrivesAt": "14:16",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h",
					"leavesAt": "14:21",
					"arrivesAt": "14:22",
					"waitsAtSource": 300,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h",
					"to": "Timişoara Nord",
					"leavesAt": "14:23",
					"arrivesAt": "14:30",
					"waitsAtSource": 30,
					"distance": 5900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14819",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "11:55",
					"arrivesAt": "12:08",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Movileni h",
					"leavesAt": "12:09",
					"arrivesAt": "12:19",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Movileni h",
					"to": "Potângeni hc.",
					"leavesAt": "12:20",
					"arrivesAt": "12:26",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Potângeni hc.",
					"to": "Larga Jijia Hm.",
					"leavesAt": "12:27",
					"arrivesAt": "12:33",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Vlădeni",
					"leavesAt": "12:34",
					"arrivesAt": "12:46",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vlădeni",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "12:48",
					"arrivesAt": "12:54",
					"waitsAtSource": 120,
					"distance": 5600
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Şoldana hc.",
					"leavesAt": "12:55",
					"arrivesAt": "13:00",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Şoldana hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "13:01",
					"arrivesAt": "13:06",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "13:07",
					"arrivesAt": "13:11",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Rediu hc.",
					"to": "Răuşeni hc.",
					"leavesAt": "13:12",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Răuşeni hc.",
					"to": "Todireni Hm.",
					"leavesAt": "13:18",
					"arrivesAt": "13:24",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Todireni Hm.",
					"to": "Jijia h.",
					"leavesAt": "13:25",
					"arrivesAt": "13:33",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Jijia h.",
					"to": "Zlătunoaia h",
					"leavesAt": "13:34",
					"arrivesAt": "13:39",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zlătunoaia h",
					"to": "Truşeşti",
					"leavesAt": "13:40",
					"arrivesAt": "13:48",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Truşeşti",
					"to": "Buhăceni h.",
					"leavesAt": "14:04",
					"arrivesAt": "14:10",
					"waitsAtSource": 960,
					"distance": 4700
				},
				{
					"from": "Buhăceni h.",
					"to": "Dângeni",
					"leavesAt": "14:11",
					"arrivesAt": "14:18",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dângeni",
					"to": "Dângeni Nord h.",
					"leavesAt": "14:19",
					"arrivesAt": "14:24",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Ungureni Hm.",
					"leavesAt": "14:25",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Ungureni Hm.",
					"to": "Mândreşti h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:38",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mândreşti h.",
					"to": "Vorniceni h.",
					"leavesAt": "14:39",
					"arrivesAt": "14:46",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Vorniceni h.",
					"to": "Mateieni h.",
					"leavesAt": "14:47",
					"arrivesAt": "14:50",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Mateieni h.",
					"to": "Corlăteni h",
					"leavesAt": "14:51",
					"arrivesAt": "14:55",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Corlăteni h",
					"to": "Carasa h.",
					"leavesAt": "14:56",
					"arrivesAt": "14:58",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Carasa h.",
					"to": "Broscăuţi h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:05",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Broscăuţi h.",
					"to": "Dorohoi",
					"leavesAt": "15:06",
					"arrivesAt": "15:16",
					"waitsAtSource": 30,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14037",
			"segments": [
				{
					"from": "Bucureşti Nord",
					"to": "Buftea",
					"leavesAt": "20:45",
					"arrivesAt": "20:58",
					"waitsAtSource": 0,
					"distance": 16900
				},
				{
					"from": "Buftea",
					"to": "Dârza h.",
					"leavesAt": "20:59",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Dârza h.",
					"to": "Periş",
					"leavesAt": "21:03",
					"arrivesAt": "21:11",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Periş",
					"to": "Scroviştea h.",
					"leavesAt": "21:17",
					"arrivesAt": "21:22",
					"waitsAtSource": 360,
					"distance": 5200
				},
				{
					"from": "Scroviştea h.",
					"to": "Crivina",
					"leavesAt": "21:23",
					"arrivesAt": "21:27",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Crivina",
					"to": "Brazi",
					"leavesAt": "21:28",
					"arrivesAt": "21:37",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Brazi",
					"to": "Ploieşti Vest",
					"leavesAt": "21:38",
					"arrivesAt": "21:47",
					"waitsAtSource": 60,
					"distance": 7500
				},
				{
					"from": "Ploieşti Vest",
					"to": "Buda",
					"leavesAt": "22:00",
					"arrivesAt": "22:06",
					"waitsAtSource": 780,
					"distance": 6900
				},
				{
					"from": "Buda",
					"to": "Floreşti Prahova",
					"leavesAt": "22:07",
					"arrivesAt": "22:16",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Floreşti Prahova",
					"to": "Câmpina",
					"leavesAt": "22:17",
					"arrivesAt": "22:29",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Câmpina",
					"to": "Breaza hc.",
					"leavesAt": "22:30",
					"arrivesAt": "22:35",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Breaza hc.",
					"to": "Nistoreşti h.",
					"leavesAt": "22:36",
					"arrivesAt": "22:39",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza Nord h.",
					"leavesAt": "22:40",
					"arrivesAt": "22:43",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Breaza Nord h.",
					"to": "Comarnic",
					"leavesAt": "22:44",
					"arrivesAt": "22:48",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Comarnic",
					"to": "Valea Largă Hm.",
					"leavesAt": "22:49",
					"arrivesAt": "22:58",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Sinaia Sud h.",
					"leavesAt": "22:59",
					"arrivesAt": "23:03",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Sinaia",
					"leavesAt": "23:04",
					"arrivesAt": "23:07",
					"waitsAtSource": 30,
					"distance": 1600
				},
				{
					"from": "Sinaia",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "23:08",
					"arrivesAt": "23:12",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Buşteni",
					"leavesAt": "23:13",
					"arrivesAt": "23:17",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Buşteni",
					"to": "Azuga",
					"leavesAt": "23:18",
					"arrivesAt": "23:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Azuga",
					"to": "Predeal",
					"leavesAt": "23:24",
					"arrivesAt": "23:34",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Predeal",
					"to": "Dârste",
					"leavesAt": "23:36",
					"arrivesAt": "00:04",
					"waitsAtSource": 120,
					"distance": 20100
				},
				{
					"from": "Dârste",
					"to": "Braşov",
					"leavesAt": "00:05",
					"arrivesAt": "00:14",
					"waitsAtSource": 60,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14733",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "13:47",
					"arrivesAt": "13:50",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "13:51",
					"arrivesAt": "13:56",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Ilieni h.",
					"leavesAt": "13:57",
					"arrivesAt": "14:02",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ilieni h.",
					"to": "Prejmer Hm.",
					"leavesAt": "14:03",
					"arrivesAt": "14:05",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Prejmer Hm.",
					"to": "Chichiş h.",
					"leavesAt": "14:06",
					"arrivesAt": "14:10",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Chichiş h.",
					"to": "Ozun Hm.",
					"leavesAt": "14:11",
					"arrivesAt": "14:15",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Ozun Hm.",
					"to": "Sfântu Gheorghe",
					"leavesAt": "14:16",
					"arrivesAt": "14:22",
					"waitsAtSource": 60,
					"distance": 7600
				},
				{
					"from": "Sfântu Gheorghe",
					"to": "Angheluş h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:38",
					"waitsAtSource": 420,
					"distance": 6500
				},
				{
					"from": "Angheluş h.",
					"to": "Moacşa hcv",
					"leavesAt": "14:39",
					"arrivesAt": "14:45",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Moacşa hcv",
					"to": "Biţa h.",
					"leavesAt": "14:46",
					"arrivesAt": "14:51",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Biţa h.",
					"to": "Boroşneu Mare h.",
					"leavesAt": "14:52",
					"arrivesAt": "14:57",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Boroşneu Mare h.",
					"to": "Ţufalău h.",
					"leavesAt": "14:58",
					"arrivesAt": "15:01",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Ţufalău h.",
					"to": "Brateş h.",
					"leavesAt": "15:02",
					"arrivesAt": "15:06",
					"waitsAtSource": 30,
					"distance": 3020
				},
				{
					"from": "Brateş h.",
					"to": "Covasna Hm.",
					"leavesAt": "15:07",
					"arrivesAt": "15:15",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Covasna Hm.",
					"to": "Zăbala h.",
					"leavesAt": "15:16",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Zăbala h.",
					"to": "Imeci Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:29",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Imeci Hm.",
					"to": "Cătălina h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:32",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cătălina h.",
					"to": "Târgu Secuiesc",
					"leavesAt": "15:33",
					"arrivesAt": "15:38",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Târgu Secuiesc",
					"to": "Sânzieni h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:52",
					"waitsAtSource": 120,
					"distance": 7000
				},
				{
					"from": "Sânzieni h.",
					"to": "Poieniţa h.",
					"leavesAt": "15:53",
					"arrivesAt": "15:57",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Poieniţa h.",
					"to": "Bălani h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:03",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bălani h.",
					"to": "Mereni Lutoasa h.",
					"leavesAt": "16:04",
					"arrivesAt": "16:09",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Mereni Lutoasa h.",
					"to": "Lemnia h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lemnia h.",
					"to": "Breţcu Hm.",
					"leavesAt": "16:16",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14814",
			"segments": [
				{
					"from": "Truşeşti",
					"to": "Zlătunoaia h",
					"leavesAt": "05:10",
					"arrivesAt": "05:19",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Zlătunoaia h",
					"to": "Jijia h.",
					"leavesAt": "05:20",
					"arrivesAt": "05:26",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Jijia h.",
					"to": "Todireni Hm.",
					"leavesAt": "05:27",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Todireni Hm.",
					"to": "Răuşeni hc.",
					"leavesAt": "05:36",
					"arrivesAt": "05:42",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Răuşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "05:43",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rediu hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "05:49",
					"arrivesAt": "05:54",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Şoldana hc.",
					"leavesAt": "05:55",
					"arrivesAt": "06:00",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Şoldana hc.",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "06:01",
					"arrivesAt": "06:06",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Vlădeni",
					"leavesAt": "06:07",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Vlădeni",
					"to": "Larga Jijia Hm.",
					"leavesAt": "06:15",
					"arrivesAt": "06:26",
					"waitsAtSource": 120,
					"distance": 10800
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Potângeni hc.",
					"leavesAt": "06:27",
					"arrivesAt": "06:33",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Potângeni hc.",
					"to": "Movileni h",
					"leavesAt": "06:34",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Movileni h",
					"to": "Leţcani",
					"leavesAt": "06:43",
					"arrivesAt": "06:53",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "06:54",
					"arrivesAt": "07:10",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14514",
			"segments": [
				{
					"from": "Reşiţa Nord",
					"to": "Câlnic h.",
					"leavesAt": "19:55",
					"arrivesAt": "19:58",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Câlnic h.",
					"to": "Moniom h.",
					"leavesAt": "19:59",
					"arrivesAt": "20:08",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Moniom h.",
					"to": "Colţan h.",
					"leavesAt": "20:09",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Colţan h.",
					"to": "Bocşa Montană hc.",
					"leavesAt": "20:16",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Vasiova",
					"leavesAt": "20:24",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Română hc.",
					"leavesAt": "20:29",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Berzovia",
					"leavesAt": "20:35",
					"arrivesAt": "20:45",
					"waitsAtSource": 30,
					"distance": 8200
				},
				{
					"from": "Berzovia",
					"to": "Gherteniş hc.",
					"leavesAt": "20:46",
					"arrivesAt": "20:49",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gherteniş hc.",
					"to": "Măureni hc.",
					"leavesAt": "20:50",
					"arrivesAt": "20:56",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Măureni hc.",
					"to": "Gătaia",
					"leavesAt": "20:57",
					"arrivesAt": "21:05",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Gătaia",
					"to": "Birda hcv.",
					"leavesAt": "21:17",
					"arrivesAt": "21:27",
					"waitsAtSource": 720,
					"distance": 8700
				},
				{
					"from": "Birda hcv.",
					"to": "Voiteni",
					"leavesAt": "21:28",
					"arrivesAt": "21:37",
					"waitsAtSource": 30,
					"distance": 9500
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "21:40",
					"arrivesAt": "21:50",
					"waitsAtSource": 180,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "21:51",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "21:56",
					"arrivesAt": "22:02",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara C.E.T.",
					"leavesAt": "22:03",
					"arrivesAt": "22:08",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişoara Sud",
					"leavesAt": "22:09",
					"arrivesAt": "22:12",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "22:13",
					"arrivesAt": "22:23",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "RGT",
			"number": "14064",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Sânandrei Hm.",
					"leavesAt": "06:40",
					"arrivesAt": "06:54",
					"waitsAtSource": 0,
					"distance": 13300
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Orţişoara",
					"leavesAt": "06:59",
					"arrivesAt": "07:13",
					"waitsAtSource": 300,
					"distance": 13100
				},
				{
					"from": "Orţişoara",
					"to": "Valea Viilor Hm.",
					"leavesAt": "07:23",
					"arrivesAt": "07:43",
					"waitsAtSource": 600,
					"distance": 19100
				},
				{
					"from": "Valea Viilor Hm.",
					"to": "Aradu Nou",
					"leavesAt": "07:49",
					"arrivesAt": "07:54",
					"waitsAtSource": 360,
					"distance": 5500
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "08:00",
					"arrivesAt": "08:07",
					"waitsAtSource": 360,
					"distance": 6200
				},
				{
					"from": "Arad",
					"to": "Radna",
					"leavesAt": "08:30",
					"arrivesAt": "09:04",
					"waitsAtSource": 1380,
					"distance": 34500
				},
				{
					"from": "Radna",
					"to": "Săvârşin",
					"leavesAt": "09:06",
					"arrivesAt": "09:48",
					"waitsAtSource": 120,
					"distance": 49700
				},
				{
					"from": "Săvârşin",
					"to": "Ilia",
					"leavesAt": "09:50",
					"arrivesAt": "10:28",
					"waitsAtSource": 120,
					"distance": 40400
				},
				{
					"from": "Ilia",
					"to": "Deva",
					"leavesAt": "10:30",
					"arrivesAt": "11:01",
					"waitsAtSource": 120,
					"distance": 23600
				},
				{
					"from": "Deva",
					"to": "Simeria",
					"leavesAt": "11:03",
					"arrivesAt": "11:16",
					"waitsAtSource": 120,
					"distance": 9200
				},
				{
					"from": "Simeria",
					"to": "Orăştie",
					"leavesAt": "11:24",
					"arrivesAt": "11:45",
					"waitsAtSource": 480,
					"distance": 16500
				},
				{
					"from": "Orăştie",
					"to": "Şibot",
					"leavesAt": "11:46",
					"arrivesAt": "12:01",
					"waitsAtSource": 60,
					"distance": 12300
				},
				{
					"from": "Şibot",
					"to": "Vinţu de Jos",
					"leavesAt": "12:02",
					"arrivesAt": "12:23",
					"waitsAtSource": 60,
					"distance": 15000
				},
				{
					"from": "Vinţu de Jos",
					"to": "Alba Iulia",
					"leavesAt": "12:24",
					"arrivesAt": "12:37",
					"waitsAtSource": 60,
					"distance": 9800
				},
				{
					"from": "Alba Iulia",
					"to": "Coşlariu",
					"leavesAt": "12:44",
					"arrivesAt": "13:05",
					"waitsAtSource": 420,
					"distance": 15600
				},
				{
					"from": "Coşlariu",
					"to": "Coşlariu Gr. P. Mureş",
					"leavesAt": "13:26",
					"arrivesAt": "13:32",
					"waitsAtSource": 1260,
					"distance": 1500
				},
				{
					"from": "Coşlariu Gr. P. Mureş",
					"to": "Blaj",
					"leavesAt": "13:44",
					"arrivesAt": "14:10",
					"waitsAtSource": 720,
					"distance": 17900
				},
				{
					"from": "Blaj",
					"to": "Copşa Mică",
					"leavesAt": "14:22",
					"arrivesAt": "14:58",
					"waitsAtSource": 720,
					"distance": 30000
				},
				{
					"from": "Copşa Mică",
					"to": "Mediaş",
					"leavesAt": "14:59",
					"arrivesAt": "15:12",
					"waitsAtSource": 60,
					"distance": 10400
				},
				{
					"from": "Mediaş",
					"to": "Dumbrăveni",
					"leavesAt": "15:13",
					"arrivesAt": "15:35",
					"waitsAtSource": 60,
					"distance": 18000
				},
				{
					"from": "Dumbrăveni",
					"to": "Sighişoara",
					"leavesAt": "15:40",
					"arrivesAt": "16:07",
					"waitsAtSource": 300,
					"distance": 20400
				},
				{
					"from": "Sighişoara",
					"to": "Rupea",
					"leavesAt": "16:11",
					"arrivesAt": "17:18",
					"waitsAtSource": 240,
					"distance": 53600
				},
				{
					"from": "Rupea",
					"to": "Augustin Hm.",
					"leavesAt": "17:20",
					"arrivesAt": "17:53",
					"waitsAtSource": 120,
					"distance": 24700
				},
				{
					"from": "Augustin Hm.",
					"to": "Braşov",
					"leavesAt": "17:54",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 49100
				}
			],
			"restrictions": [
				{
					"from": "20170101",
					"to": "20170101",
					"daysOfWeek": 320
				},
				{
					"from": "20170108",
					"to": "20170108",
					"daysOfWeek": 320
				},
				{
					"from": "20170115",
					"to": "20170115",
					"daysOfWeek": 320
				},
				{
					"from": "20170122",
					"to": "20170122",
					"daysOfWeek": 320
				},
				{
					"from": "20170129",
					"to": "20170129",
					"daysOfWeek": 320
				},
				{
					"from": "20170205",
					"to": "20170205",
					"daysOfWeek": 320
				},
				{
					"from": "20170212",
					"to": "20170212",
					"daysOfWeek": 320
				},
				{
					"from": "20170219",
					"to": "20170219",
					"daysOfWeek": 320
				},
				{
					"from": "20170226",
					"to": "20170226",
					"daysOfWeek": 320
				},
				{
					"from": "20170305",
					"to": "20170305",
					"daysOfWeek": 320
				},
				{
					"from": "20170312",
					"to": "20170312",
					"daysOfWeek": 320
				},
				{
					"from": "20170319",
					"to": "20170319",
					"daysOfWeek": 320
				},
				{
					"from": "20170326",
					"to": "20170326",
					"daysOfWeek": 320
				},
				{
					"from": "20170402",
					"to": "20170402",
					"daysOfWeek": 320
				},
				{
					"from": "20170409",
					"to": "20170409",
					"daysOfWeek": 320
				},
				{
					"from": "20170416",
					"to": "20170416",
					"daysOfWeek": 320
				},
				{
					"from": "20170423",
					"to": "20170423",
					"daysOfWeek": 320
				},
				{
					"from": "20170430",
					"to": "20170430",
					"daysOfWeek": 320
				},
				{
					"from": "20170507",
					"to": "20170507",
					"daysOfWeek": 320
				},
				{
					"from": "20170514",
					"to": "20170514",
					"daysOfWeek": 320
				},
				{
					"from": "20170521",
					"to": "20170521",
					"daysOfWeek": 320
				},
				{
					"from": "20170528",
					"to": "20170528",
					"daysOfWeek": 320
				},
				{
					"from": "20170604",
					"to": "20170604",
					"daysOfWeek": 320
				},
				{
					"from": "20170611",
					"to": "20170611",
					"daysOfWeek": 320
				},
				{
					"from": "20170618",
					"to": "20170618",
					"daysOfWeek": 320
				},
				{
					"from": "20170625",
					"to": "20170625",
					"daysOfWeek": 320
				},
				{
					"from": "20170702",
					"to": "20170702",
					"daysOfWeek": 320
				},
				{
					"from": "20170709",
					"to": "20170709",
					"daysOfWeek": 320
				},
				{
					"from": "20170716",
					"to": "20170716",
					"daysOfWeek": 320
				},
				{
					"from": "20170723",
					"to": "20170723",
					"daysOfWeek": 320
				},
				{
					"from": "20170730",
					"to": "20170730",
					"daysOfWeek": 320
				},
				{
					"from": "20170806",
					"to": "20170806",
					"daysOfWeek": 320
				},
				{
					"from": "20170813",
					"to": "20170813",
					"daysOfWeek": 320
				},
				{
					"from": "20170820",
					"to": "20170820",
					"daysOfWeek": 320
				},
				{
					"from": "20170827",
					"to": "20170827",
					"daysOfWeek": 320
				},
				{
					"from": "20170903",
					"to": "20170903",
					"daysOfWeek": 320
				},
				{
					"from": "20170910",
					"to": "20170910",
					"daysOfWeek": 320
				},
				{
					"from": "20170917",
					"to": "20170917",
					"daysOfWeek": 320
				},
				{
					"from": "20170924",
					"to": "20170924",
					"daysOfWeek": 320
				},
				{
					"from": "20171001",
					"to": "20171001",
					"daysOfWeek": 320
				},
				{
					"from": "20171008",
					"to": "20171008",
					"daysOfWeek": 320
				},
				{
					"from": "20171015",
					"to": "20171015",
					"daysOfWeek": 320
				},
				{
					"from": "20171022",
					"to": "20171022",
					"daysOfWeek": 320
				},
				{
					"from": "20171029",
					"to": "20171029",
					"daysOfWeek": 320
				},
				{
					"from": "20171105",
					"to": "20171105",
					"daysOfWeek": 320
				},
				{
					"from": "20171112",
					"to": "20171112",
					"daysOfWeek": 320
				},
				{
					"from": "20171119",
					"to": "20171119",
					"daysOfWeek": 320
				},
				{
					"from": "20171126",
					"to": "20171126",
					"daysOfWeek": 320
				},
				{
					"from": "20171203",
					"to": "20171203",
					"daysOfWeek": 320
				},
				{
					"from": "20161211",
					"to": "20161211",
					"daysOfWeek": 320
				},
				{
					"from": "20161218",
					"to": "20161218",
					"daysOfWeek": 320
				},
				{
					"from": "20161225",
					"to": "20161225",
					"daysOfWeek": 320
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14017",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "15:53",
					"arrivesAt": "15:56",
					"waitsAtSource": 0,
					"distance": 900
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Sărata h.",
					"leavesAt": "15:57",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel",
					"leavesAt": "16:06",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărăţel",
					"to": "Arcalia hc.",
					"leavesAt": "16:12",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "16:18",
					"arrivesAt": "16:21",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Chintelnic h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 2314
				},
				{
					"from": "Chintelnic h.",
					"to": "Chiraleş h.",
					"leavesAt": "16:27",
					"arrivesAt": "16:30",
					"waitsAtSource": 60,
					"distance": 2276
				},
				{
					"from": "Chiraleş h.",
					"to": "Ţigău h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ţigău h.",
					"to": "Lechinţa",
					"leavesAt": "16:37",
					"arrivesAt": "16:44",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lechinţa",
					"to": "Vermeş h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Vermeş h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "16:51",
					"arrivesAt": "17:00",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Brăteni h.",
					"leavesAt": "17:01",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Brăteni h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:17",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "17:18",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Budeşti Cluj h.",
					"leavesAt": "17:24",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Budeşti Cluj h.",
					"to": "Ţagu h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ţagu h.",
					"to": "Ţagu Sat h.",
					"leavesAt": "17:41",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ţagu Sat h.",
					"to": "Ţăgşor h.",
					"leavesAt": "17:45",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ţăgşor h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "17:52",
					"arrivesAt": "17:56",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Sărmăşel hcv .",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "18:38",
					"arrivesAt": "18:42",
					"waitsAtSource": 2520,
					"distance": 2000
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmaşu h.",
					"leavesAt": "18:43",
					"arrivesAt": "18:48",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sărmaşu h.",
					"to": "Balda h.",
					"leavesAt": "18:49",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Balda h.",
					"to": "Miheşu de Câmpie Sat h.",
					"leavesAt": "18:54",
					"arrivesAt": "19:00",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Miheşu de Câmpie Sat h.",
					"to": "Miheşu de Câmpie h.",
					"leavesAt": "19:01",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Miheşu de Câmpie h.",
					"to": "Bota Sat h.",
					"leavesAt": "19:08",
					"arrivesAt": "19:13",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bota Sat h.",
					"to": "Zau de Câmpie h.",
					"leavesAt": "19:14",
					"arrivesAt": "19:19",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Zau de Câmpie h.",
					"to": "Melini Valea Largă h.",
					"leavesAt": "19:20",
					"arrivesAt": "19:23",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Melini Valea Largă h.",
					"to": "Tăureni h.",
					"leavesAt": "19:24",
					"arrivesAt": "19:28",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Tăureni h.",
					"to": "Sânger Tăureni h.",
					"leavesAt": "19:29",
					"arrivesAt": "19:37",
					"waitsAtSource": 60,
					"distance": 5620
				},
				{
					"from": "Sânger Tăureni h.",
					"to": "Luduş Sat hc.",
					"leavesAt": "19:38",
					"arrivesAt": "19:49",
					"waitsAtSource": 30,
					"distance": 8080
				},
				{
					"from": "Luduş Sat hc.",
					"to": "Luduş",
					"leavesAt": "19:50",
					"arrivesAt": "19:54",
					"waitsAtSource": 60,
					"distance": 2400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14812",
			"segments": [
				{
					"from": "Truşeşti",
					"to": "Zlătunoaia h",
					"leavesAt": "03:18",
					"arrivesAt": "03:27",
					"waitsAtSource": 0,
					"distance": 9400
				},
				{
					"from": "Zlătunoaia h",
					"to": "Jijia h.",
					"leavesAt": "03:28",
					"arrivesAt": "03:34",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Jijia h.",
					"to": "Todireni Hm.",
					"leavesAt": "03:35",
					"arrivesAt": "03:43",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Todireni Hm.",
					"to": "Răuşeni hc.",
					"leavesAt": "03:44",
					"arrivesAt": "03:50",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Răuşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "03:51",
					"arrivesAt": "03:56",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rediu hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "03:57",
					"arrivesAt": "04:02",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Şoldana hc.",
					"leavesAt": "04:03",
					"arrivesAt": "04:08",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Şoldana hc.",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "04:09",
					"arrivesAt": "04:14",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Vlădeni",
					"leavesAt": "04:15",
					"arrivesAt": "04:21",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Vlădeni",
					"to": "Larga Jijia Hm.",
					"leavesAt": "04:22",
					"arrivesAt": "04:33",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Potângeni hc.",
					"leavesAt": "04:34",
					"arrivesAt": "04:40",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Potângeni hc.",
					"to": "Movileni h",
					"leavesAt": "04:41",
					"arrivesAt": "04:49",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Movileni h",
					"to": "Leţcani",
					"leavesAt": "04:50",
					"arrivesAt": "05:00",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "05:01",
					"arrivesAt": "05:17",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": []
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14314",
			"segments": [
				{
					"from": "Nerău hcv.",
					"to": "Teremia Banat hc.",
					"leavesAt": "04:12",
					"arrivesAt": "04:20",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Comloşu Mare h.",
					"leavesAt": "04:21",
					"arrivesAt": "04:30",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Gotlob h.",
					"leavesAt": "04:31",
					"arrivesAt": "04:38",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Gotlob h.",
					"to": "Lovrin",
					"leavesAt": "04:39",
					"arrivesAt": "04:46",
					"waitsAtSource": 30,
					"distance": 6400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14849",
			"segments": [
				{
					"from": "Roman",
					"to": "Sagna h.",
					"leavesAt": "16:41",
					"arrivesAt": "16:51",
					"waitsAtSource": 0,
					"distance": 8700
				},
				{
					"from": "Sagna h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "16:52",
					"arrivesAt": "17:02",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Stăniţa h.",
					"leavesAt": "17:03",
					"arrivesAt": "17:11",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stăniţa h.",
					"to": "Piscu Rusului h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:23",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Zece Prăjini h",
					"leavesAt": "17:24",
					"arrivesAt": "17:33",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zece Prăjini h",
					"to": "Dagâţa",
					"leavesAt": "17:34",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Dagâţa",
					"to": "Băluşeşti h",
					"leavesAt": "17:42",
					"arrivesAt": "17:45",
					"waitsAtSource": 120,
					"distance": 3400
				},
				{
					"from": "Băluşeşti h",
					"to": "Suhuleţ h.",
					"leavesAt": "17:46",
					"arrivesAt": "17:50",
					"waitsAtSource": 30,
					"distance": 3000
				},
				{
					"from": "Suhuleţ h.",
					"to": "Mareşal C-tin Prezan Hm.",
					"leavesAt": "17:51",
					"arrivesAt": "17:57",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Mareşal C-tin Prezan Hm.",
					"to": "Dumeşti h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumeşti h.",
					"to": "Rafaila h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:13",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Rafaila h.",
					"to": "Negreşti Vaslui Hm.",
					"leavesAt": "18:14",
					"arrivesAt": "18:21",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Negreşti Vaslui Hm.",
					"to": "Buhăieşti",
					"leavesAt": "18:22",
					"arrivesAt": "18:38",
					"waitsAtSource": 60,
					"distance": 10700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14299",
			"segments": [
				{
					"from": "Arad",
					"to": "Arad Vest",
					"leavesAt": "14:18",
					"arrivesAt": "14:27",
					"waitsAtSource": 0,
					"distance": 4800
				},
				{
					"from": "Arad Vest",
					"to": "Ferma Ciala h.",
					"leavesAt": "14:28",
					"arrivesAt": "14:33",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Sântoma h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:40",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Sântoma h.",
					"to": "Pecica",
					"leavesAt": "14:41",
					"arrivesAt": "14:53",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Pecica",
					"to": "Semlac h.",
					"leavesAt": "14:54",
					"arrivesAt": "15:17",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Semlac h.",
					"to": "Şeitin h.",
					"leavesAt": "15:18",
					"arrivesAt": "15:27",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Şeitin h.",
					"to": "Nădlac",
					"leavesAt": "15:28",
					"arrivesAt": "15:41",
					"waitsAtSource": 30,
					"distance": 8100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14315",
			"segments": [
				{
					"from": "Lovrin",
					"to": "Gotlob h.",
					"leavesAt": "06:15",
					"arrivesAt": "06:22",
					"waitsAtSource": 0,
					"distance": 6400
				},
				{
					"from": "Gotlob h.",
					"to": "Comloşu Mare h.",
					"leavesAt": "06:23",
					"arrivesAt": "06:31",
					"waitsAtSource": 60,
					"distance": 7200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Teremia Banat hc.",
					"leavesAt": "06:32",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Nerău hcv.",
					"leavesAt": "06:43",
					"arrivesAt": "06:51",
					"waitsAtSource": 60,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14737",
			"segments": [
				{
					"from": "Sfântu Gheorghe",
					"to": "Angheluş h.",
					"leavesAt": "19:25",
					"arrivesAt": "19:34",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Angheluş h.",
					"to": "Moacşa hcv",
					"leavesAt": "19:35",
					"arrivesAt": "19:41",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Moacşa hcv",
					"to": "Biţa h.",
					"leavesAt": "19:42",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Biţa h.",
					"to": "Boroşneu Mare h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Boroşneu Mare h.",
					"to": "Ţufalău h.",
					"leavesAt": "19:54",
					"arrivesAt": "19:58",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Ţufalău h.",
					"to": "Brateş h.",
					"leavesAt": "19:59",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 3020
				},
				{
					"from": "Brateş h.",
					"to": "Covasna Hm.",
					"leavesAt": "20:05",
					"arrivesAt": "20:13",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Covasna Hm.",
					"to": "Zăbala h.",
					"leavesAt": "20:15",
					"arrivesAt": "20:21",
					"waitsAtSource": 120,
					"distance": 4200
				},
				{
					"from": "Zăbala h.",
					"to": "Imeci Hm.",
					"leavesAt": "20:22",
					"arrivesAt": "20:30",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Imeci Hm.",
					"to": "Cătălina h.",
					"leavesAt": "20:31",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Cătălina h.",
					"to": "Târgu Secuiesc",
					"leavesAt": "20:34",
					"arrivesAt": "20:39",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Târgu Secuiesc",
					"to": "Sânzieni h.",
					"leavesAt": "20:40",
					"arrivesAt": "20:52",
					"waitsAtSource": 60,
					"distance": 7000
				},
				{
					"from": "Sânzieni h.",
					"to": "Poieniţa h.",
					"leavesAt": "20:53",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Poieniţa h.",
					"to": "Bălani h.",
					"leavesAt": "20:58",
					"arrivesAt": "21:03",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Bălani h.",
					"to": "Mereni Lutoasa h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:09",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Mereni Lutoasa h.",
					"to": "Lemnia h.",
					"leavesAt": "21:10",
					"arrivesAt": "21:15",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Lemnia h.",
					"to": "Breţcu Hm.",
					"leavesAt": "21:16",
					"arrivesAt": "21:23",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "IR",
			"operator": "RGT",
			"number": "14069",
			"segments": [
				{
					"from": "Ploieşti Vest",
					"to": "Ploieşti Sud",
					"leavesAt": "16:24",
					"arrivesAt": "16:29",
					"waitsAtSource": 0,
					"distance": 3000
				},
				{
					"from": "Ploieşti Sud",
					"to": "Mizil",
					"leavesAt": "16:30",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 33600
				},
				{
					"from": "Mizil",
					"to": "Buzău",
					"leavesAt": "17:05",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 35000
				},
				{
					"from": "Buzău",
					"to": "Râmnicu Sărat",
					"leavesAt": "17:43",
					"arrivesAt": "18:13",
					"waitsAtSource": 120,
					"distance": 33500
				},
				{
					"from": "Râmnicu Sărat",
					"to": "Focşani",
					"leavesAt": "18:14",
					"arrivesAt": "18:52",
					"waitsAtSource": 60,
					"distance": 37300
				},
				{
					"from": "Focşani",
					"to": "Mărăşeşti",
					"leavesAt": "18:54",
					"arrivesAt": "19:17",
					"waitsAtSource": 120,
					"distance": 19700
				},
				{
					"from": "Mărăşeşti",
					"to": "Tecuci Nord hc.(605)",
					"leavesAt": "19:22",
					"arrivesAt": "19:47",
					"waitsAtSource": 300,
					"distance": 17800
				},
				{
					"from": "Tecuci Nord hc.(605)",
					"to": "Bârlad",
					"leavesAt": "19:48",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 48600
				},
				{
					"from": "Bârlad",
					"to": "Crasna",
					"leavesAt": "20:39",
					"arrivesAt": "21:06",
					"waitsAtSource": 360,
					"distance": 36600
				},
				{
					"from": "Crasna",
					"to": "Vaslui",
					"leavesAt": "21:08",
					"arrivesAt": "21:22",
					"waitsAtSource": 120,
					"distance": 15500
				},
				{
					"from": "Vaslui",
					"to": "Buhăieşti",
					"leavesAt": "21:26",
					"arrivesAt": "21:45",
					"waitsAtSource": 240,
					"distance": 23500
				},
				{
					"from": "Buhăieşti",
					"to": "Bârnova Hm.",
					"leavesAt": "21:48",
					"arrivesAt": "22:12",
					"waitsAtSource": 180,
					"distance": 25700
				},
				{
					"from": "Bârnova Hm.",
					"to": "Nicolina",
					"leavesAt": "22:13",
					"arrivesAt": "22:28",
					"waitsAtSource": 60,
					"distance": 16300
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "22:29",
					"arrivesAt": "22:37",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14756",
			"segments": [
				{
					"from": "Întorsura Buzăului Hm",
					"to": "Poiana Florilor h.",
					"leavesAt": "12:41",
					"arrivesAt": "12:51",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Valea Teliului h.",
					"leavesAt": "12:52",
					"arrivesAt": "12:57",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Teliului h.",
					"to": "Teliu h.",
					"leavesAt": "12:58",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Teliu h.",
					"to": "Budila hcv.",
					"leavesAt": "13:03",
					"arrivesAt": "13:08",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Budila hcv.",
					"to": "Hărman",
					"leavesAt": "13:09",
					"arrivesAt": "13:20",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "13:21",
					"arrivesAt": "13:26",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "13:27",
					"arrivesAt": "13:31",
					"waitsAtSource": 60,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14032",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "05:00",
					"arrivesAt": "05:07",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Predeal",
					"leavesAt": "05:08",
					"arrivesAt": "05:35",
					"waitsAtSource": 60,
					"distance": 20100
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "05:36",
					"arrivesAt": "05:43",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "05:44",
					"arrivesAt": "05:48",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "05:49",
					"arrivesAt": "05:52",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "05:53",
					"arrivesAt": "05:58",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "06:00",
					"arrivesAt": "06:02",
					"waitsAtSource": 120,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "06:03",
					"arrivesAt": "06:07",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Comarnic",
					"leavesAt": "06:08",
					"arrivesAt": "06:16",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "06:17",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "06:21",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "06:25",
					"arrivesAt": "06:28",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "06:29",
					"arrivesAt": "06:37",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "06:38",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "06:50",
					"arrivesAt": "06:59",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "07:00",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Brazi",
					"leavesAt": "07:14",
					"arrivesAt": "07:21",
					"waitsAtSource": 360,
					"distance": 7500
				},
				{
					"from": "Brazi",
					"to": "Crivina",
					"leavesAt": "07:22",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:36",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "07:37",
					"arrivesAt": "07:42",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "07:48",
					"arrivesAt": "07:56",
					"waitsAtSource": 360,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "07:57",
					"arrivesAt": "08:01",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "08:02",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14987",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Dâmbu Hm.",
					"leavesAt": "20:26",
					"arrivesAt": "20:31",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "20:32",
					"arrivesAt": "20:37",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Râfov h.",
					"leavesAt": "20:38",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Râfov h.",
					"to": "Trestieni h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Trestieni h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "20:48",
					"arrivesAt": "20:51",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Cornurile h.",
					"leavesAt": "20:52",
					"arrivesAt": "20:57",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cornurile h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "20:58",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "21:03",
					"arrivesAt": "21:07",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Hătcărău h.",
					"to": "Ciorani Hm.",
					"leavesAt": "21:08",
					"arrivesAt": "21:14",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ciorani Hm.",
					"to": "Fulga hc.",
					"leavesAt": "21:15",
					"arrivesAt": "21:19",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Fulga hc.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "21:20",
					"arrivesAt": "21:26",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "21:27",
					"arrivesAt": "21:33",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "21:34",
					"arrivesAt": "21:38",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "21:39",
					"arrivesAt": "21:44",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14823",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "16:49",
					"arrivesAt": "17:02",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Movileni h",
					"leavesAt": "17:03",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Movileni h",
					"to": "Potângeni hc.",
					"leavesAt": "17:14",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Potângeni hc.",
					"to": "Larga Jijia Hm.",
					"leavesAt": "17:21",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Vlădeni",
					"leavesAt": "17:28",
					"arrivesAt": "17:40",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vlădeni",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "17:48",
					"arrivesAt": "17:54",
					"waitsAtSource": 480,
					"distance": 5600
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Şoldana hc.",
					"leavesAt": "17:55",
					"arrivesAt": "18:00",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Şoldana hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "18:01",
					"arrivesAt": "18:06",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "18:07",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Rediu hc.",
					"to": "Răuşeni hc.",
					"leavesAt": "18:12",
					"arrivesAt": "18:17",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Răuşeni hc.",
					"to": "Todireni Hm.",
					"leavesAt": "18:18",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Todireni Hm.",
					"to": "Jijia h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:33",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Jijia h.",
					"to": "Zlătunoaia h",
					"leavesAt": "18:34",
					"arrivesAt": "18:39",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zlătunoaia h",
					"to": "Truşeşti",
					"leavesAt": "18:40",
					"arrivesAt": "18:48",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Truşeşti",
					"to": "Buhăceni h.",
					"leavesAt": "18:53",
					"arrivesAt": "18:58",
					"waitsAtSource": 300,
					"distance": 4700
				},
				{
					"from": "Buhăceni h.",
					"to": "Dângeni",
					"leavesAt": "18:59",
					"arrivesAt": "19:06",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Dângeni",
					"to": "Dângeni Nord h.",
					"leavesAt": "19:07",
					"arrivesAt": "19:12",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Ungureni Hm.",
					"leavesAt": "19:13",
					"arrivesAt": "19:21",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Ungureni Hm.",
					"to": "Mândreşti h.",
					"leavesAt": "19:29",
					"arrivesAt": "19:34",
					"waitsAtSource": 480,
					"distance": 4600
				},
				{
					"from": "Mândreşti h.",
					"to": "Vorniceni h.",
					"leavesAt": "19:35",
					"arrivesAt": "19:42",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vorniceni h.",
					"to": "Mateieni h.",
					"leavesAt": "19:43",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Mateieni h.",
					"to": "Corlăteni h",
					"leavesAt": "19:48",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Corlăteni h",
					"to": "Carasa h.",
					"leavesAt": "19:53",
					"arrivesAt": "19:56",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Carasa h.",
					"to": "Broscăuţi h.",
					"leavesAt": "19:57",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Broscăuţi h.",
					"to": "Dorohoi",
					"leavesAt": "20:04",
					"arrivesAt": "20:14",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14979",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Dâmbu Hm.",
					"leavesAt": "14:00",
					"arrivesAt": "14:05",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "14:06",
					"arrivesAt": "14:11",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Râfov h.",
					"leavesAt": "14:12",
					"arrivesAt": "14:14",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Râfov h.",
					"to": "Trestieni h.",
					"leavesAt": "14:15",
					"arrivesAt": "14:19",
					"waitsAtSource": 30,
					"distance": 3600
				},
				{
					"from": "Trestieni h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "14:20",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Cornurile h.",
					"leavesAt": "14:24",
					"arrivesAt": "14:29",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cornurile h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "14:30",
					"arrivesAt": "14:34",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "14:35",
					"arrivesAt": "14:37",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Hătcărău h.",
					"to": "Ciorani Hm.",
					"leavesAt": "14:38",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Ciorani Hm.",
					"to": "Fulga hc.",
					"leavesAt": "14:45",
					"arrivesAt": "14:48",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Fulga hc.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "14:49",
					"arrivesAt": "14:56",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "14:57",
					"arrivesAt": "15:02",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "15:03",
					"arrivesAt": "15:07",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "15:08",
					"arrivesAt": "15:13",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14510",
			"segments": [
				{
					"from": "Reşiţa Nord",
					"to": "Câlnic h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:37",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Câlnic h.",
					"to": "Moniom h.",
					"leavesAt": "16:38",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Moniom h.",
					"to": "Colţan h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:54",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Colţan h.",
					"to": "Bocşa Montană hc.",
					"leavesAt": "16:55",
					"arrivesAt": "17:02",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Vasiova",
					"leavesAt": "17:03",
					"arrivesAt": "17:07",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Română hc.",
					"leavesAt": "17:08",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Berzovia",
					"leavesAt": "17:14",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 8200
				},
				{
					"from": "Berzovia",
					"to": "Gherteniş hc.",
					"leavesAt": "17:25",
					"arrivesAt": "17:28",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gherteniş hc.",
					"to": "Măureni hc.",
					"leavesAt": "17:29",
					"arrivesAt": "17:35",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Măureni hc.",
					"to": "Gătaia",
					"leavesAt": "17:36",
					"arrivesAt": "17:44",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Gătaia",
					"to": "Birda hcv.",
					"leavesAt": "17:54",
					"arrivesAt": "18:04",
					"waitsAtSource": 600,
					"distance": 8700
				},
				{
					"from": "Birda hcv.",
					"to": "Voiteni",
					"leavesAt": "18:05",
					"arrivesAt": "18:14",
					"waitsAtSource": 30,
					"distance": 9500
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "18:17",
					"arrivesAt": "18:27",
					"waitsAtSource": 180,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "18:28",
					"arrivesAt": "18:32",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "18:33",
					"arrivesAt": "18:39",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara C.E.T.",
					"leavesAt": "18:40",
					"arrivesAt": "18:45",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişoara Sud",
					"leavesAt": "18:46",
					"arrivesAt": "18:49",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "18:50",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14608",
			"segments": [
				{
					"from": "Bălăuşeri hcv.",
					"to": "Coroiu h.",
					"leavesAt": "13:35",
					"arrivesAt": "13:45",
					"waitsAtSource": 0,
					"distance": 6700
				},
				{
					"from": "Coroiu h.",
					"to": "Şoimuş h.",
					"leavesAt": "13:46",
					"arrivesAt": "13:49",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Şoimuş h.",
					"to": "Laslău h.",
					"leavesAt": "13:50",
					"arrivesAt": "13:57",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Laslău h.",
					"to": "Bahnea h.",
					"leavesAt": "13:58",
					"arrivesAt": "14:05",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bahnea h.",
					"to": "Bernadea h.",
					"leavesAt": "14:06",
					"arrivesAt": "14:12",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Bernadea h.",
					"to": "Mica h.",
					"leavesAt": "14:13",
					"arrivesAt": "14:17",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Mica h.",
					"to": "Deaj h.",
					"leavesAt": "14:18",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Deaj h.",
					"to": "Găneşti h.",
					"leavesAt": "14:24",
					"arrivesAt": "14:28",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Găneşti h.",
					"to": "Şeuca h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:34",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Şeuca h.",
					"to": "Târnaveni",
					"leavesAt": "14:35",
					"arrivesAt": "14:40",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Târnaveni",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "15:37",
					"arrivesAt": "15:42",
					"waitsAtSource": 3420,
					"distance": 2400
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Adămuş h.",
					"leavesAt": "15:43",
					"arrivesAt": "15:46",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Adămuş h.",
					"to": "Corneşti Târnava h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Corneşti Târnava h.",
					"to": "Crăieşti h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:54",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Crăieşti h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "15:55",
					"arrivesAt": "16:01",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Feisa h.",
					"leavesAt": "16:02",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Feisa h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "16:06",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Bălcaci h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:14",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Bălcaci h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "16:15",
					"arrivesAt": "16:18",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Şona h.",
					"leavesAt": "16:19",
					"arrivesAt": "16:23",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Şona h.",
					"to": "Pănade h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:29",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pănade h.",
					"to": "Sâncel h.",
					"leavesAt": "16:30",
					"arrivesAt": "16:33",
					"waitsAtSource": 60,
					"distance": 1654
				},
				{
					"from": "Sâncel h.",
					"to": "Blaj",
					"leavesAt": "16:34",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 4246
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14982",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "18:50",
					"arrivesAt": "18:54",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "18:55",
					"arrivesAt": "19:00",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "19:01",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Fulga hc.",
					"leavesAt": "19:08",
					"arrivesAt": "19:14",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Fulga hc.",
					"to": "Ciorani Hm.",
					"leavesAt": "19:15",
					"arrivesAt": "19:20",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ciorani Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "19:21",
					"arrivesAt": "19:26",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hătcărău h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "19:27",
					"arrivesAt": "19:31",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Cornurile h.",
					"leavesAt": "19:32",
					"arrivesAt": "19:36",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Cornurile h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "19:37",
					"arrivesAt": "19:43",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Trestieni h.",
					"leavesAt": "19:44",
					"arrivesAt": "19:47",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Trestieni h.",
					"to": "Râfov h.",
					"leavesAt": "19:48",
					"arrivesAt": "19:52",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Râfov h.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "19:53",
					"arrivesAt": "19:57",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Dâmbu Hm.",
					"leavesAt": "19:58",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Ploieşti Sud",
					"leavesAt": "20:04",
					"arrivesAt": "20:09",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14672",
			"segments": [
				{
					"from": "Alba Iulia",
					"to": "Bărăbanţ Hm.",
					"leavesAt": "15:42",
					"arrivesAt": "15:49",
					"waitsAtSource": 0,
					"distance": 4500
				},
				{
					"from": "Bărăbanţ Hm.",
					"to": "Antestaţie Bărăbanţ h.",
					"leavesAt": "15:50",
					"arrivesAt": "15:52",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Antestaţie Bărăbanţ h.",
					"to": "Bărăbanţ Nord h.",
					"leavesAt": "15:53",
					"arrivesAt": "15:57",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Bărăbanţ Nord h.",
					"to": "Şard Ighiu h.",
					"leavesAt": "15:58",
					"arrivesAt": "16:05",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Şard Ighiu h.",
					"to": "Ampoiţa h.",
					"leavesAt": "16:06",
					"arrivesAt": "16:10",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Ampoiţa h.",
					"to": "Tăutu Ampoiului h.",
					"leavesAt": "16:11",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Tăutu Ampoiului h.",
					"to": "Văleni Meteş h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:22",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Văleni Meteş h.",
					"to": "Poiana Ampoiului h.",
					"leavesAt": "16:23",
					"arrivesAt": "16:27",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Poiana Ampoiului h.",
					"to": "Prisaca h.",
					"leavesAt": "16:28",
					"arrivesAt": "16:35",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Prisaca h.",
					"to": "Feneş h.",
					"leavesAt": "16:36",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Feneş h.",
					"to": "Zlatna Tehnică",
					"leavesAt": "16:41",
					"arrivesAt": "16:45",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Zlatna Tehnică",
					"to": "Zlatna h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:54",
					"waitsAtSource": 180,
					"distance": 4000
				},
				{
					"from": "Zlatna h.",
					"to": "Zlatna hcv.",
					"leavesAt": "16:55",
					"arrivesAt": "16:59",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14815",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "06:53",
					"arrivesAt": "07:06",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Movileni h",
					"leavesAt": "07:07",
					"arrivesAt": "07:17",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Movileni h",
					"to": "Potângeni hc.",
					"leavesAt": "07:18",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Potângeni hc.",
					"to": "Larga Jijia Hm.",
					"leavesAt": "07:25",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Vlădeni",
					"leavesAt": "07:32",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 10800
				},
				{
					"from": "Vlădeni",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "07:46",
					"arrivesAt": "07:52",
					"waitsAtSource": 120,
					"distance": 5600
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Şoldana hc.",
					"leavesAt": "07:53",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Şoldana hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "07:59",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "08:05",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Rediu hc.",
					"to": "Răuşeni hc.",
					"leavesAt": "08:10",
					"arrivesAt": "08:15",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Răuşeni hc.",
					"to": "Todireni Hm.",
					"leavesAt": "08:16",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Todireni Hm.",
					"to": "Jijia h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Jijia h.",
					"to": "Zlătunoaia h",
					"leavesAt": "08:32",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Zlătunoaia h",
					"to": "Truşeşti",
					"leavesAt": "08:38",
					"arrivesAt": "08:46",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Truşeşti",
					"to": "Buhăceni h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Buhăceni h.",
					"to": "Dângeni",
					"leavesAt": "08:54",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Dângeni",
					"to": "Dângeni Nord h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:07",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Ungureni Hm.",
					"leavesAt": "09:08",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Ungureni Hm.",
					"to": "Mândreşti h.",
					"leavesAt": "09:17",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Mândreşti h.",
					"to": "Vorniceni h.",
					"leavesAt": "09:23",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Vorniceni h.",
					"to": "Mateieni h.",
					"leavesAt": "09:31",
					"arrivesAt": "09:35",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Mateieni h.",
					"to": "Corlăteni h",
					"leavesAt": "09:36",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Corlăteni h",
					"to": "Carasa h.",
					"leavesAt": "09:41",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Carasa h.",
					"to": "Broscăuţi h.",
					"leavesAt": "09:45",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Broscăuţi h.",
					"to": "Dorohoi",
					"leavesAt": "09:52",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 5800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14540",
			"segments": [
				{
					"from": "Cruceni hcv.",
					"to": "Rudna hc.",
					"leavesAt": "04:34",
					"arrivesAt": "04:52",
					"waitsAtSource": 0,
					"distance": 11000
				},
				{
					"from": "Rudna hc.",
					"to": "Giulvăz h",
					"leavesAt": "04:53",
					"arrivesAt": "05:00",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Giulvăz h",
					"to": "Cebza h.",
					"leavesAt": "05:01",
					"arrivesAt": "05:04",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Cebza h.",
					"to": "Peciu Nou h.",
					"leavesAt": "05:05",
					"arrivesAt": "05:13",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Peciu Nou h.",
					"to": "Parţa h.",
					"leavesAt": "05:14",
					"arrivesAt": "05:24",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Parţa h.",
					"to": "Sânmihai h.",
					"leavesAt": "05:25",
					"arrivesAt": "05:32",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Sânmihai h.",
					"to": "Utvin h.",
					"leavesAt": "05:33",
					"arrivesAt": "05:37",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Utvin h.",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "05:38",
					"arrivesAt": "05:44",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Timişoara Nord",
					"leavesAt": "05:47",
					"arrivesAt": "05:58",
					"waitsAtSource": 180,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14546",
			"segments": [
				{
					"from": "Cruceni hcv.",
					"to": "Rudna hc.",
					"leavesAt": "17:55",
					"arrivesAt": "18:13",
					"waitsAtSource": 0,
					"distance": 11000
				},
				{
					"from": "Rudna hc.",
					"to": "Giulvăz h",
					"leavesAt": "18:14",
					"arrivesAt": "18:21",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Giulvăz h",
					"to": "Cebza h.",
					"leavesAt": "18:22",
					"arrivesAt": "18:25",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Cebza h.",
					"to": "Peciu Nou h.",
					"leavesAt": "18:26",
					"arrivesAt": "18:34",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Peciu Nou h.",
					"to": "Parţa h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:45",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Parţa h.",
					"to": "Sânmihai h.",
					"leavesAt": "18:46",
					"arrivesAt": "18:53",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Sânmihai h.",
					"to": "Utvin h.",
					"leavesAt": "18:54",
					"arrivesAt": "18:57",
					"waitsAtSource": 30,
					"distance": 2400
				},
				{
					"from": "Utvin h.",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "18:58",
					"arrivesAt": "19:04",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Timişoara Nord",
					"leavesAt": "19:07",
					"arrivesAt": "19:18",
					"waitsAtSource": 180,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14705",
			"segments": [
				{
					"from": "Braşov",
					"to": "Bartolomeu",
					"leavesAt": "09:25",
					"arrivesAt": "09:31",
					"waitsAtSource": 0,
					"distance": 3100
				},
				{
					"from": "Bartolomeu",
					"to": "Lustic h.",
					"leavesAt": "09:32",
					"arrivesAt": "09:40",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Lustic h.",
					"to": "Cristian Hm.",
					"leavesAt": "09:41",
					"arrivesAt": "09:44",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Cristian Hm.",
					"to": "Râşnov",
					"leavesAt": "09:45",
					"arrivesAt": "09:49",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Râşnov",
					"to": "Râşnov h.",
					"leavesAt": "09:50",
					"arrivesAt": "09:52",
					"waitsAtSource": 60,
					"distance": 1800
				},
				{
					"from": "Râşnov h.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "09:53",
					"arrivesAt": "09:58",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "09:59",
					"arrivesAt": "10:02",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Zărneşti",
					"leavesAt": "10:03",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 1800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14324",
			"segments": [
				{
					"from": "Lovrin",
					"to": "Satu Nou Hm.",
					"leavesAt": "17:19",
					"arrivesAt": "17:27",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Pesac h.",
					"leavesAt": "17:28",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pesac h.",
					"to": "Periam",
					"leavesAt": "17:37",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Periam",
					"to": "Variaş hc.",
					"leavesAt": "17:56",
					"arrivesAt": "18:05",
					"waitsAtSource": 360,
					"distance": 7600
				},
				{
					"from": "Variaş hc.",
					"to": "Gelu hc.",
					"leavesAt": "18:06",
					"arrivesAt": "18:13",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Gelu hc.",
					"to": "Bărăteaz h.",
					"leavesAt": "18:14",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Bărăteaz h.",
					"to": "Chinezu h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:24",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Chinezu h.",
					"to": "Hodoni h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:31",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Hodoni h.",
					"to": "Sânandrei Hm.",
					"leavesAt": "18:32",
					"arrivesAt": "18:41",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "18:44",
					"arrivesAt": "18:50",
					"waitsAtSource": 180,
					"distance": 6400
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "18:51",
					"arrivesAt": "18:53",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "18:54",
					"arrivesAt": "18:57",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Timişoara Nord",
					"leavesAt": "18:58",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 4400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14754",
			"segments": [
				{
					"from": "Întorsura Buzăului Hm",
					"to": "Poiana Florilor h.",
					"leavesAt": "08:56",
					"arrivesAt": "09:07",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Valea Teliului h.",
					"leavesAt": "09:08",
					"arrivesAt": "09:14",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Teliului h.",
					"to": "Teliu h.",
					"leavesAt": "09:15",
					"arrivesAt": "09:20",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Teliu h.",
					"to": "Budila hcv.",
					"leavesAt": "09:21",
					"arrivesAt": "09:27",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Budila hcv.",
					"to": "Hărman",
					"leavesAt": "09:28",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:45",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "09:46",
					"arrivesAt": "09:53",
					"waitsAtSource": 60,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14976",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "11:50",
					"arrivesAt": "11:54",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "11:55",
					"arrivesAt": "12:00",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "12:01",
					"arrivesAt": "12:07",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Fulga hc.",
					"leavesAt": "12:08",
					"arrivesAt": "12:14",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Fulga hc.",
					"to": "Ciorani Hm.",
					"leavesAt": "12:15",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ciorani Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "12:22",
					"arrivesAt": "12:27",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hătcărău h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "12:28",
					"arrivesAt": "12:32",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Cornurile h.",
					"leavesAt": "12:42",
					"arrivesAt": "12:46",
					"waitsAtSource": 600,
					"distance": 4000
				},
				{
					"from": "Cornurile h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "12:47",
					"arrivesAt": "12:53",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Trestieni h.",
					"leavesAt": "12:54",
					"arrivesAt": "12:57",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Trestieni h.",
					"to": "Râfov h.",
					"leavesAt": "12:58",
					"arrivesAt": "13:02",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Râfov h.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "13:03",
					"arrivesAt": "13:06",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Dâmbu Hm.",
					"leavesAt": "13:07",
					"arrivesAt": "13:12",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Ploieşti Sud",
					"leavesAt": "13:13",
					"arrivesAt": "13:17",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18261",
			"segments": [
				{
					"from": "Braşov",
					"to": "Braşov Triaj",
					"leavesAt": "11:23",
					"arrivesAt": "11:27",
					"waitsAtSource": 0,
					"distance": 2200
				},
				{
					"from": "Braşov Triaj",
					"to": "Hărman",
					"leavesAt": "11:28",
					"arrivesAt": "11:35",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Hărman",
					"to": "Budila hcv.",
					"leavesAt": "11:36",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Budila hcv.",
					"to": "Teliu h.",
					"leavesAt": "11:47",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Teliu h.",
					"to": "Valea Teliului h.",
					"leavesAt": "11:54",
					"arrivesAt": "11:59",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Valea Teliului h.",
					"to": "Poiana Florilor h.",
					"leavesAt": "12:00",
					"arrivesAt": "12:05",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Întorsura Buzăului Hm",
					"leavesAt": "12:06",
					"arrivesAt": "12:18",
					"waitsAtSource": 30,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 256
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14807",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "16:35",
					"arrivesAt": "16:46",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "16:47",
					"arrivesAt": "16:55",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Erbiceni hc.",
					"leavesAt": "17:02",
					"arrivesAt": "17:11",
					"waitsAtSource": 420,
					"distance": 6000
				},
				{
					"from": "Erbiceni hc.",
					"to": "Spinoasa h.",
					"leavesAt": "17:12",
					"arrivesAt": "17:20",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Spinoasa h.",
					"to": "Belceşti Hm.",
					"leavesAt": "17:21",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Belceşti Hm.",
					"to": "Podu Ulmi h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Hodora h.",
					"leavesAt": "17:39",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Hodora h.",
					"to": "Cotnari hc.",
					"leavesAt": "17:45",
					"arrivesAt": "17:50",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Cotnari hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "17:51",
					"arrivesAt": "17:55",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Bădeni hc.",
					"leavesAt": "17:56",
					"arrivesAt": "18:00",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Bădeni hc.",
					"to": "Hârlău",
					"leavesAt": "18:01",
					"arrivesAt": "18:06",
					"waitsAtSource": 30,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14983",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Dâmbu Hm.",
					"leavesAt": "17:11",
					"arrivesAt": "17:16",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "17:17",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Râfov h.",
					"leavesAt": "17:23",
					"arrivesAt": "17:26",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Râfov h.",
					"to": "Trestieni h.",
					"leavesAt": "17:27",
					"arrivesAt": "17:32",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Trestieni h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "17:33",
					"arrivesAt": "17:36",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Cornurile h.",
					"leavesAt": "17:37",
					"arrivesAt": "17:42",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cornurile h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "17:43",
					"arrivesAt": "17:48",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "17:54",
					"arrivesAt": "17:57",
					"waitsAtSource": 360,
					"distance": 2500
				},
				{
					"from": "Hătcărău h.",
					"to": "Ciorani Hm.",
					"leavesAt": "17:58",
					"arrivesAt": "18:04",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Ciorani Hm.",
					"to": "Fulga hc.",
					"leavesAt": "18:05",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Fulga hc.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "18:10",
					"arrivesAt": "18:17",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "18:18",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:29",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "18:30",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14361",
			"segments": [
				{
					"from": "Arad",
					"to": "Aradu Nou",
					"leavesAt": "11:24",
					"arrivesAt": "11:31",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Aradu Nou",
					"to": "Zădăreni Hm.",
					"leavesAt": "11:32",
					"arrivesAt": "11:42",
					"waitsAtSource": 60,
					"distance": 9600
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "11:43",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Felnac hc.",
					"leavesAt": "11:48",
					"arrivesAt": "11:53",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Felnac hc.",
					"to": "Sânpetru German h.",
					"leavesAt": "11:54",
					"arrivesAt": "12:01",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Sânpetru German h.",
					"to": "Munor h.",
					"leavesAt": "12:02",
					"arrivesAt": "12:06",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Munor h.",
					"to": "Secusigiu h",
					"leavesAt": "12:07",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Secusigiu h",
					"to": "Aranca h.",
					"leavesAt": "12:12",
					"arrivesAt": "12:16",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Aranca h.",
					"to": "Periam",
					"leavesAt": "12:17",
					"arrivesAt": "12:28",
					"waitsAtSource": 60,
					"distance": 11100
				},
				{
					"from": "Periam",
					"to": "Sânpetru h.",
					"leavesAt": "12:44",
					"arrivesAt": "12:51",
					"waitsAtSource": 960,
					"distance": 4500
				},
				{
					"from": "Sânpetru h.",
					"to": "Saravale h.",
					"leavesAt": "12:52",
					"arrivesAt": "13:01",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Saravale h.",
					"to": "Sânnicolau Mare",
					"leavesAt": "13:02",
					"arrivesAt": "13:12",
					"waitsAtSource": 60,
					"distance": 7600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14847",
			"segments": [
				{
					"from": "Roman",
					"to": "Sagna h.",
					"leavesAt": "14:24",
					"arrivesAt": "14:33",
					"waitsAtSource": 0,
					"distance": 8700
				},
				{
					"from": "Sagna h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "14:34",
					"arrivesAt": "14:44",
					"waitsAtSource": 30,
					"distance": 8300
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Stăniţa h.",
					"leavesAt": "14:45",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Stăniţa h.",
					"to": "Piscu Rusului h.",
					"leavesAt": "14:53",
					"arrivesAt": "15:04",
					"waitsAtSource": 30,
					"distance": 5100
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Zece Prăjini h",
					"leavesAt": "15:05",
					"arrivesAt": "15:14",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Zece Prăjini h",
					"to": "Dagâţa",
					"leavesAt": "15:15",
					"arrivesAt": "15:21",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Dagâţa",
					"to": "Băluşeşti h",
					"leavesAt": "15:29",
					"arrivesAt": "15:33",
					"waitsAtSource": 480,
					"distance": 3400
				},
				{
					"from": "Băluşeşti h",
					"to": "Suhuleţ h.",
					"leavesAt": "15:34",
					"arrivesAt": "15:38",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Suhuleţ h.",
					"to": "Mareşal C-tin Prezan Hm.",
					"leavesAt": "15:39",
					"arrivesAt": "15:45",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Mareşal C-tin Prezan Hm.",
					"to": "Dumeşti h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumeşti h.",
					"to": "Rafaila h.",
					"leavesAt": "15:54",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Rafaila h.",
					"to": "Negreşti Vaslui Hm.",
					"leavesAt": "16:02",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Negreşti Vaslui Hm.",
					"to": "Buhăieşti",
					"leavesAt": "16:10",
					"arrivesAt": "16:26",
					"waitsAtSource": 60,
					"distance": 10700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14308",
			"segments": [
				{
					"from": "Nădlac",
					"to": "Şeitin h.",
					"leavesAt": "19:40",
					"arrivesAt": "19:51",
					"waitsAtSource": 0,
					"distance": 8100
				},
				{
					"from": "Şeitin h.",
					"to": "Semlac h.",
					"leavesAt": "19:52",
					"arrivesAt": "20:01",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Semlac h.",
					"to": "Pecica",
					"leavesAt": "20:02",
					"arrivesAt": "20:26",
					"waitsAtSource": 30,
					"distance": 17200
				},
				{
					"from": "Pecica",
					"to": "Sântoma h.",
					"leavesAt": "20:27",
					"arrivesAt": "20:39",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Sântoma h.",
					"to": "Ferma Ciala h.",
					"leavesAt": "20:40",
					"arrivesAt": "20:46",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Arad Vest",
					"leavesAt": "20:47",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Arad Vest",
					"to": "Arad",
					"leavesAt": "20:56",
					"arrivesAt": "21:05",
					"waitsAtSource": 180,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14704",
			"segments": [
				{
					"from": "Zărneşti",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "08:39",
					"arrivesAt": "08:42",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "08:43",
					"arrivesAt": "08:45",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "Râşnov h.",
					"leavesAt": "08:46",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Râşnov h.",
					"to": "Râşnov",
					"leavesAt": "08:52",
					"arrivesAt": "08:55",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Râşnov",
					"to": "Cristian Hm.",
					"leavesAt": "08:56",
					"arrivesAt": "09:00",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cristian Hm.",
					"to": "Lustic h.",
					"leavesAt": "09:01",
					"arrivesAt": "09:04",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Lustic h.",
					"to": "Bartolomeu",
					"leavesAt": "09:05",
					"arrivesAt": "09:12",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "09:13",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14702",
			"segments": [
				{
					"from": "Zărneşti",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "06:59",
					"arrivesAt": "07:02",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "07:03",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "Râşnov h.",
					"leavesAt": "07:06",
					"arrivesAt": "07:11",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Râşnov h.",
					"to": "Râşnov",
					"leavesAt": "07:12",
					"arrivesAt": "07:15",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Râşnov",
					"to": "Cristian Hm.",
					"leavesAt": "07:16",
					"arrivesAt": "07:20",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cristian Hm.",
					"to": "Lustic h.",
					"leavesAt": "07:21",
					"arrivesAt": "07:24",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Lustic h.",
					"to": "Bartolomeu",
					"leavesAt": "07:25",
					"arrivesAt": "07:33",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "07:34",
					"arrivesAt": "07:40",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14543",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "07:27",
					"arrivesAt": "07:38",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Utvin h.",
					"leavesAt": "07:39",
					"arrivesAt": "07:45",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Utvin h.",
					"to": "Sânmihai h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sânmihai h.",
					"to": "Parţa h.",
					"leavesAt": "07:51",
					"arrivesAt": "07:59",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Parţa h.",
					"to": "Peciu Nou h.",
					"leavesAt": "08:00",
					"arrivesAt": "08:11",
					"waitsAtSource": 60,
					"distance": 8000
				},
				{
					"from": "Peciu Nou h.",
					"to": "Cebza h.",
					"leavesAt": "08:12",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 5700
				},
				{
					"from": "Cebza h.",
					"to": "Giulvăz h",
					"leavesAt": "08:21",
					"arrivesAt": "08:24",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Giulvăz h",
					"to": "Rudna hc.",
					"leavesAt": "08:25",
					"arrivesAt": "08:32",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Rudna hc.",
					"to": "Cruceni hcv.",
					"leavesAt": "08:33",
					"arrivesAt": "08:52",
					"waitsAtSource": 30,
					"distance": 11000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14613",
			"segments": [
				{
					"from": "Blaj",
					"to": "Sâncel h.",
					"leavesAt": "19:55",
					"arrivesAt": "20:00",
					"waitsAtSource": 0,
					"distance": 4246
				},
				{
					"from": "Sâncel h.",
					"to": "Pănade h.",
					"leavesAt": "20:01",
					"arrivesAt": "20:04",
					"waitsAtSource": 60,
					"distance": 1654
				},
				{
					"from": "Pănade h.",
					"to": "Şona h.",
					"leavesAt": "20:05",
					"arrivesAt": "20:10",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Şona h.",
					"to": "Sfântu Nicolae h.",
					"leavesAt": "20:11",
					"arrivesAt": "20:15",
					"waitsAtSource": 60,
					"distance": 3100
				},
				{
					"from": "Sfântu Nicolae h.",
					"to": "Bălcaci h.",
					"leavesAt": "20:16",
					"arrivesAt": "20:19",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bălcaci h.",
					"to": "Jidvei  hcv.",
					"leavesAt": "20:20",
					"arrivesAt": "20:24",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Jidvei  hcv.",
					"to": "Feisa h.",
					"leavesAt": "20:25",
					"arrivesAt": "20:29",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Feisa h.",
					"to": "Cetatea de Baltă h.",
					"leavesAt": "20:30",
					"arrivesAt": "20:33",
					"waitsAtSource": 60,
					"distance": 2540
				},
				{
					"from": "Cetatea de Baltă h.",
					"to": "Crăieşti h.",
					"leavesAt": "20:34",
					"arrivesAt": "20:41",
					"waitsAtSource": 30,
					"distance": 5160
				},
				{
					"from": "Crăieşti h.",
					"to": "Corneşti Târnava h.",
					"leavesAt": "20:42",
					"arrivesAt": "20:45",
					"waitsAtSource": 60,
					"distance": 1500
				},
				{
					"from": "Corneşti Târnava h.",
					"to": "Adămuş h.",
					"leavesAt": "20:46",
					"arrivesAt": "20:51",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Adămuş h.",
					"to": "Târnaveni Vest Hm.",
					"leavesAt": "20:52",
					"arrivesAt": "20:56",
					"waitsAtSource": 60,
					"distance": 2800
				},
				{
					"from": "Târnaveni Vest Hm.",
					"to": "Târnaveni",
					"leavesAt": "20:57",
					"arrivesAt": "21:02",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Târnaveni",
					"to": "Şeuca h.",
					"leavesAt": "21:04",
					"arrivesAt": "21:11",
					"waitsAtSource": 120,
					"distance": 2600
				},
				{
					"from": "Şeuca h.",
					"to": "Găneşti h.",
					"leavesAt": "21:12",
					"arrivesAt": "21:17",
					"waitsAtSource": 30,
					"distance": 2800
				},
				{
					"from": "Găneşti h.",
					"to": "Deaj h.",
					"leavesAt": "21:18",
					"arrivesAt": "21:23",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Deaj h.",
					"to": "Mica h.",
					"leavesAt": "21:24",
					"arrivesAt": "21:28",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Mica h.",
					"to": "Bernadea h.",
					"leavesAt": "21:29",
					"arrivesAt": "21:33",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Bernadea h.",
					"to": "Bahnea h.",
					"leavesAt": "21:34",
					"arrivesAt": "21:40",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Bahnea h.",
					"to": "Laslău h.",
					"leavesAt": "21:41",
					"arrivesAt": "21:47",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Laslău h.",
					"to": "Şoimuş h.",
					"leavesAt": "21:48",
					"arrivesAt": "21:55",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Şoimuş h.",
					"to": "Coroiu h.",
					"leavesAt": "21:56",
					"arrivesAt": "21:59",
					"waitsAtSource": 60,
					"distance": 1300
				},
				{
					"from": "Coroiu h.",
					"to": "Bălăuşeri hcv.",
					"leavesAt": "22:00",
					"arrivesAt": "22:10",
					"waitsAtSource": 30,
					"distance": 6700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14822",
			"segments": [
				{
					"from": "Dorohoi",
					"to": "Broscăuţi h.",
					"leavesAt": "15:20",
					"arrivesAt": "15:25",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Broscăuţi h.",
					"to": "Carasa h.",
					"leavesAt": "15:26",
					"arrivesAt": "15:33",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Carasa h.",
					"to": "Corlăteni h",
					"leavesAt": "15:34",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Corlăteni h",
					"to": "Mateieni h.",
					"leavesAt": "15:38",
					"arrivesAt": "15:41",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Mateieni h.",
					"to": "Vorniceni h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:46",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Vorniceni h.",
					"to": "Mândreşti h.",
					"leavesAt": "15:47",
					"arrivesAt": "15:55",
					"waitsAtSource": 30,
					"distance": 7400
				},
				{
					"from": "Mândreşti h.",
					"to": "Ungureni Hm.",
					"leavesAt": "15:56",
					"arrivesAt": "16:02",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ungureni Hm.",
					"to": "Dângeni Nord h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Dângeni",
					"leavesAt": "16:12",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni",
					"to": "Buhăceni h.",
					"leavesAt": "16:18",
					"arrivesAt": "16:24",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Buhăceni h.",
					"to": "Truşeşti",
					"leavesAt": "16:25",
					"arrivesAt": "16:31",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Truşeşti",
					"to": "Zlătunoaia h",
					"leavesAt": "16:41",
					"arrivesAt": "16:50",
					"waitsAtSource": 600,
					"distance": 9400
				},
				{
					"from": "Zlătunoaia h",
					"to": "Jijia h.",
					"leavesAt": "16:51",
					"arrivesAt": "16:57",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Jijia h.",
					"to": "Todireni Hm.",
					"leavesAt": "16:58",
					"arrivesAt": "17:06",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Todireni Hm.",
					"to": "Răuşeni hc.",
					"leavesAt": "17:07",
					"arrivesAt": "17:13",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Răuşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "17:14",
					"arrivesAt": "17:19",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rediu hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "17:20",
					"arrivesAt": "17:25",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Şoldana hc.",
					"leavesAt": "17:26",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Şoldana hc.",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "17:32",
					"arrivesAt": "17:37",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Vlădeni",
					"leavesAt": "17:38",
					"arrivesAt": "17:44",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Vlădeni",
					"to": "Larga Jijia Hm.",
					"leavesAt": "17:46",
					"arrivesAt": "17:57",
					"waitsAtSource": 120,
					"distance": 10800
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Potângeni hc.",
					"leavesAt": "17:58",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Potângeni hc.",
					"to": "Movileni h",
					"leavesAt": "18:05",
					"arrivesAt": "18:14",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Movileni h",
					"to": "Leţcani",
					"leavesAt": "18:15",
					"arrivesAt": "18:25",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "18:26",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14506",
			"segments": [
				{
					"from": "Reşiţa Nord",
					"to": "Câlnic h.",
					"leavesAt": "11:39",
					"arrivesAt": "11:45",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Câlnic h.",
					"to": "Moniom h.",
					"leavesAt": "11:46",
					"arrivesAt": "11:55",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Moniom h.",
					"to": "Colţan h.",
					"leavesAt": "11:56",
					"arrivesAt": "12:02",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Colţan h.",
					"to": "Bocşa Montană hc.",
					"leavesAt": "12:03",
					"arrivesAt": "12:10",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Vasiova",
					"leavesAt": "12:11",
					"arrivesAt": "12:15",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Română hc.",
					"leavesAt": "12:16",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Berzovia",
					"leavesAt": "12:22",
					"arrivesAt": "12:32",
					"waitsAtSource": 30,
					"distance": 8200
				},
				{
					"from": "Berzovia",
					"to": "Gherteniş hc.",
					"leavesAt": "12:42",
					"arrivesAt": "12:46",
					"waitsAtSource": 600,
					"distance": 3500
				},
				{
					"from": "Gherteniş hc.",
					"to": "Măureni hc.",
					"leavesAt": "12:47",
					"arrivesAt": "12:54",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Măureni hc.",
					"to": "Gătaia",
					"leavesAt": "12:55",
					"arrivesAt": "13:03",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Gătaia",
					"to": "Birda hcv.",
					"leavesAt": "13:04",
					"arrivesAt": "13:14",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Birda hcv.",
					"to": "Voiteni",
					"leavesAt": "13:15",
					"arrivesAt": "13:24",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "13:27",
					"arrivesAt": "13:37",
					"waitsAtSource": 180,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "13:38",
					"arrivesAt": "13:44",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "13:45",
					"arrivesAt": "13:51",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara C.E.T.",
					"leavesAt": "13:52",
					"arrivesAt": "13:58",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişoara Sud",
					"leavesAt": "13:59",
					"arrivesAt": "14:02",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "14:07",
					"arrivesAt": "14:17",
					"waitsAtSource": 300,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14504",
			"segments": [
				{
					"from": "Reşiţa Nord",
					"to": "Câlnic h.",
					"leavesAt": "07:18",
					"arrivesAt": "07:21",
					"waitsAtSource": 0,
					"distance": 1600
				},
				{
					"from": "Câlnic h.",
					"to": "Moniom h.",
					"leavesAt": "07:22",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Moniom h.",
					"to": "Colţan h.",
					"leavesAt": "07:32",
					"arrivesAt": "07:38",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Colţan h.",
					"to": "Bocşa Montană hc.",
					"leavesAt": "07:39",
					"arrivesAt": "07:46",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Vasiova",
					"leavesAt": "07:47",
					"arrivesAt": "07:51",
					"waitsAtSource": 30,
					"distance": 1700
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Română hc.",
					"leavesAt": "07:52",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Berzovia",
					"leavesAt": "07:59",
					"arrivesAt": "08:09",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Berzovia",
					"to": "Gherteniş hc.",
					"leavesAt": "08:10",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 3500
				},
				{
					"from": "Gherteniş hc.",
					"to": "Măureni hc.",
					"leavesAt": "08:14",
					"arrivesAt": "08:20",
					"waitsAtSource": 30,
					"distance": 6100
				},
				{
					"from": "Măureni hc.",
					"to": "Gătaia",
					"leavesAt": "08:21",
					"arrivesAt": "08:29",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Gătaia",
					"to": "Birda hcv.",
					"leavesAt": "08:30",
					"arrivesAt": "08:40",
					"waitsAtSource": 60,
					"distance": 8700
				},
				{
					"from": "Birda hcv.",
					"to": "Voiteni",
					"leavesAt": "08:41",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Voiteni",
					"to": "Jebel",
					"leavesAt": "08:53",
					"arrivesAt": "09:03",
					"waitsAtSource": 180,
					"distance": 9200
				},
				{
					"from": "Jebel",
					"to": "Pădureni Timiş  P.M.",
					"leavesAt": "09:04",
					"arrivesAt": "09:09",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Pădureni Timiş  P.M.",
					"to": "Timişeni Hm.",
					"leavesAt": "09:10",
					"arrivesAt": "09:16",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Timişeni Hm.",
					"to": "Timişoara C.E.T.",
					"leavesAt": "09:17",
					"arrivesAt": "09:22",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Timişoara C.E.T.",
					"to": "Timişoara Sud",
					"leavesAt": "09:23",
					"arrivesAt": "09:26",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Timişoara Sud",
					"to": "Timişoara Nord",
					"leavesAt": "09:27",
					"arrivesAt": "09:37",
					"waitsAtSource": 60,
					"distance": 5600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14753",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "07:58",
					"arrivesAt": "08:02",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "08:03",
					"arrivesAt": "08:09",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Budila hcv.",
					"leavesAt": "08:10",
					"arrivesAt": "08:20",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Budila hcv.",
					"to": "Teliu h.",
					"leavesAt": "08:21",
					"arrivesAt": "08:26",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Teliu h.",
					"to": "Valea Teliului h.",
					"leavesAt": "08:27",
					"arrivesAt": "08:32",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Valea Teliului h.",
					"to": "Poiana Florilor h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:38",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Întorsura Buzăului Hm",
					"leavesAt": "08:39",
					"arrivesAt": "08:51",
					"waitsAtSource": 30,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14547",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Timişoara Vest Hm.",
					"leavesAt": "16:21",
					"arrivesAt": "16:33",
					"waitsAtSource": 0,
					"distance": 5000
				},
				{
					"from": "Timişoara Vest Hm.",
					"to": "Utvin h.",
					"leavesAt": "16:34",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Utvin h.",
					"to": "Sânmihai h.",
					"leavesAt": "16:41",
					"arrivesAt": "16:44",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Sânmihai h.",
					"to": "Parţa h.",
					"leavesAt": "16:45",
					"arrivesAt": "16:52",
					"waitsAtSource": 30,
					"distance": 5800
				},
				{
					"from": "Parţa h.",
					"to": "Peciu Nou h.",
					"leavesAt": "16:53",
					"arrivesAt": "17:03",
					"waitsAtSource": 30,
					"distance": 8000
				},
				{
					"from": "Peciu Nou h.",
					"to": "Cebza h.",
					"leavesAt": "17:04",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Cebza h.",
					"to": "Giulvăz h",
					"leavesAt": "17:13",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Giulvăz h",
					"to": "Rudna hc.",
					"leavesAt": "17:17",
					"arrivesAt": "17:24",
					"waitsAtSource": 30,
					"distance": 5300
				},
				{
					"from": "Rudna hc.",
					"to": "Cruceni hcv.",
					"leavesAt": "17:25",
					"arrivesAt": "17:44",
					"waitsAtSource": 30,
					"distance": 11000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18250",
			"segments": [
				{
					"from": "Luduş",
					"to": "Luduş Sat hc.",
					"leavesAt": "08:18",
					"arrivesAt": "08:21",
					"waitsAtSource": 0,
					"distance": 2400
				},
				{
					"from": "Luduş Sat hc.",
					"to": "Sânger Tăureni h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 8080
				},
				{
					"from": "Sânger Tăureni h.",
					"to": "Tăureni h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 5620
				},
				{
					"from": "Tăureni h.",
					"to": "Melini Valea Largă h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Melini Valea Largă h.",
					"to": "Zau de Câmpie h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Zau de Câmpie h.",
					"to": "Bota Sat h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Bota Sat h.",
					"to": "Miheşu de Câmpie h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Miheşu de Câmpie h.",
					"to": "Miheşu de Câmpie Sat h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Miheşu de Câmpie Sat h.",
					"to": "Balda h.",
					"leavesAt": "09:11",
					"arrivesAt": "09:17",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Balda h.",
					"to": "Sărmaşu h.",
					"leavesAt": "09:18",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Sărmaşu h.",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "09:29",
					"arrivesAt": "09:33",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Sărmăşel hcv .",
					"to": "Ţăgşor h.",
					"leavesAt": "09:55",
					"arrivesAt": "09:59",
					"waitsAtSource": 1320,
					"distance": 2000
				},
				{
					"from": "Ţăgşor h.",
					"to": "Ţagu Sat h.",
					"leavesAt": "10:00",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ţagu Sat h.",
					"to": "Ţagu h.",
					"leavesAt": "10:07",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ţagu h.",
					"to": "Budeşti Cluj h.",
					"leavesAt": "10:11",
					"arrivesAt": "10:19",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Budeşti Cluj h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "10:20",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "10:31",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Brăteni h.",
					"leavesAt": "10:38",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Brăteni h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "10:46",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Vermeş h.",
					"leavesAt": "10:53",
					"arrivesAt": "11:01",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vermeş h.",
					"to": "Lechinţa",
					"leavesAt": "11:02",
					"arrivesAt": "11:06",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Lechinţa",
					"to": "Ţigău h.",
					"leavesAt": "11:08",
					"arrivesAt": "11:15",
					"waitsAtSource": 120,
					"distance": 5000
				},
				{
					"from": "Ţigău h.",
					"to": "Chiraleş h.",
					"leavesAt": "11:16",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiraleş h.",
					"to": "Chintelnic h.",
					"leavesAt": "11:21",
					"arrivesAt": "11:25",
					"waitsAtSource": 30,
					"distance": 2276
				},
				{
					"from": "Chintelnic h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "11:26",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 2314
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "12:30",
					"arrivesAt": "12:33",
					"waitsAtSource": 3600,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel",
					"leavesAt": "12:34",
					"arrivesAt": "12:40",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel",
					"to": "Sărata h.",
					"leavesAt": "12:50",
					"arrivesAt": "12:55",
					"waitsAtSource": 600,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "12:56",
					"arrivesAt": "13:03",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "13:04",
					"arrivesAt": "13:07",
					"waitsAtSource": 30,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14752",
			"segments": [
				{
					"from": "Întorsura Buzăului Hm",
					"to": "Poiana Florilor h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:55",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Valea Teliului h.",
					"leavesAt": "06:56",
					"arrivesAt": "07:02",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Teliului h.",
					"to": "Teliu h.",
					"leavesAt": "07:03",
					"arrivesAt": "07:08",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Teliu h.",
					"to": "Budila hcv.",
					"leavesAt": "07:09",
					"arrivesAt": "07:14",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Budila hcv.",
					"to": "Hărman",
					"leavesAt": "07:15",
					"arrivesAt": "07:25",
					"waitsAtSource": 30,
					"distance": 10500
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "07:26",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "07:32",
					"arrivesAt": "07:37",
					"waitsAtSource": 30,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14016",
			"segments": [
				{
					"from": "Luduş",
					"to": "Luduş Sat hc.",
					"leavesAt": "08:18",
					"arrivesAt": "08:21",
					"waitsAtSource": 0,
					"distance": 2400
				},
				{
					"from": "Luduş Sat hc.",
					"to": "Sânger Tăureni h.",
					"leavesAt": "08:22",
					"arrivesAt": "08:33",
					"waitsAtSource": 30,
					"distance": 8080
				},
				{
					"from": "Sânger Tăureni h.",
					"to": "Tăureni h.",
					"leavesAt": "08:34",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 5620
				},
				{
					"from": "Tăureni h.",
					"to": "Melini Valea Largă h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Melini Valea Largă h.",
					"to": "Zau de Câmpie h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:50",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Zau de Câmpie h.",
					"to": "Bota Sat h.",
					"leavesAt": "08:51",
					"arrivesAt": "08:56",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Bota Sat h.",
					"to": "Miheşu de Câmpie h.",
					"leavesAt": "08:57",
					"arrivesAt": "09:03",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Miheşu de Câmpie h.",
					"to": "Miheşu de Câmpie Sat h.",
					"leavesAt": "09:04",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Miheşu de Câmpie Sat h.",
					"to": "Balda h.",
					"leavesAt": "09:11",
					"arrivesAt": "09:17",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Balda h.",
					"to": "Sărmaşu h.",
					"leavesAt": "09:18",
					"arrivesAt": "09:23",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Sărmaşu h.",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "09:24",
					"arrivesAt": "09:28",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "09:29",
					"arrivesAt": "09:33",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Sărmăşel hcv .",
					"to": "Ţăgşor h.",
					"leavesAt": "09:55",
					"arrivesAt": "09:59",
					"waitsAtSource": 1320,
					"distance": 2000
				},
				{
					"from": "Ţăgşor h.",
					"to": "Ţagu Sat h.",
					"leavesAt": "10:00",
					"arrivesAt": "10:06",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ţagu Sat h.",
					"to": "Ţagu h.",
					"leavesAt": "10:07",
					"arrivesAt": "10:10",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ţagu h.",
					"to": "Budeşti Cluj h.",
					"leavesAt": "10:11",
					"arrivesAt": "10:19",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Budeşti Cluj h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "10:20",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "10:31",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Brăteni h.",
					"leavesAt": "10:38",
					"arrivesAt": "10:45",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Brăteni h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "10:46",
					"arrivesAt": "10:52",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Vermeş h.",
					"leavesAt": "10:53",
					"arrivesAt": "11:01",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Vermeş h.",
					"to": "Lechinţa",
					"leavesAt": "11:02",
					"arrivesAt": "11:06",
					"waitsAtSource": 30,
					"distance": 2200
				},
				{
					"from": "Lechinţa",
					"to": "Ţigău h.",
					"leavesAt": "11:08",
					"arrivesAt": "11:15",
					"waitsAtSource": 120,
					"distance": 5000
				},
				{
					"from": "Ţigău h.",
					"to": "Chiraleş h.",
					"leavesAt": "11:16",
					"arrivesAt": "11:20",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Chiraleş h.",
					"to": "Chintelnic h.",
					"leavesAt": "11:21",
					"arrivesAt": "11:25",
					"waitsAtSource": 30,
					"distance": 2276
				},
				{
					"from": "Chintelnic h.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "11:26",
					"arrivesAt": "11:30",
					"waitsAtSource": 60,
					"distance": 2314
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Arcalia hc.",
					"leavesAt": "11:37",
					"arrivesAt": "11:39",
					"waitsAtSource": 420,
					"distance": 2000
				},
				{
					"from": "Arcalia hc.",
					"to": "Sărăţel",
					"leavesAt": "11:40",
					"arrivesAt": "11:46",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Sărăţel",
					"to": "Sărata h.",
					"leavesAt": "11:47",
					"arrivesAt": "11:52",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Sărata h.",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "11:53",
					"arrivesAt": "12:00",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Bistriţa Nord",
					"leavesAt": "12:01",
					"arrivesAt": "12:04",
					"waitsAtSource": 60,
					"distance": 900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14750",
			"segments": [
				{
					"from": "Întorsura Buzăului Hm",
					"to": "Poiana Florilor h.",
					"leavesAt": "04:43",
					"arrivesAt": "04:54",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Valea Teliului h.",
					"leavesAt": "04:55",
					"arrivesAt": "05:01",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Teliului h.",
					"to": "Teliu h.",
					"leavesAt": "05:02",
					"arrivesAt": "05:07",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Teliu h.",
					"to": "Budila hcv.",
					"leavesAt": "05:08",
					"arrivesAt": "05:14",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Budila hcv.",
					"to": "Hărman",
					"leavesAt": "05:15",
					"arrivesAt": "05:25",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "05:26",
					"arrivesAt": "05:31",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "05:32",
					"arrivesAt": "05:38",
					"waitsAtSource": 60,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14977",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Dâmbu Hm.",
					"leavesAt": "11:33",
					"arrivesAt": "11:38",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "11:39",
					"arrivesAt": "11:44",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Râfov h.",
					"leavesAt": "11:45",
					"arrivesAt": "11:48",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Râfov h.",
					"to": "Trestieni h.",
					"leavesAt": "11:49",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Trestieni h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "11:54",
					"arrivesAt": "11:57",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Cornurile h.",
					"leavesAt": "11:58",
					"arrivesAt": "12:03",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cornurile h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "12:04",
					"arrivesAt": "12:08",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "12:09",
					"arrivesAt": "12:11",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Hătcărău h.",
					"to": "Ciorani Hm.",
					"leavesAt": "12:12",
					"arrivesAt": "12:18",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Ciorani Hm.",
					"to": "Fulga hc.",
					"leavesAt": "12:19",
					"arrivesAt": "12:22",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Fulga hc.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "12:23",
					"arrivesAt": "12:30",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "12:31",
					"arrivesAt": "12:36",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "12:37",
					"arrivesAt": "12:40",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "12:41",
					"arrivesAt": "12:46",
					"waitsAtSource": 30,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14751",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "05:50",
					"arrivesAt": "05:54",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "05:55",
					"arrivesAt": "06:01",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Budila hcv.",
					"leavesAt": "06:02",
					"arrivesAt": "06:12",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Budila hcv.",
					"to": "Teliu h.",
					"leavesAt": "06:13",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Teliu h.",
					"to": "Valea Teliului h.",
					"leavesAt": "06:19",
					"arrivesAt": "06:24",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Valea Teliului h.",
					"to": "Poiana Florilor h.",
					"leavesAt": "06:25",
					"arrivesAt": "06:30",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Întorsura Buzăului Hm",
					"leavesAt": "06:31",
					"arrivesAt": "06:42",
					"waitsAtSource": 30,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14755",
			"segments": [
				{
					"from": "Braşov",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "11:23",
					"arrivesAt": "11:28",
					"waitsAtSource": 0,
					"distance": 2900
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Hărman",
					"leavesAt": "11:29",
					"arrivesAt": "11:35",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Hărman",
					"to": "Budila hcv.",
					"leavesAt": "11:36",
					"arrivesAt": "11:46",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Budila hcv.",
					"to": "Teliu h.",
					"leavesAt": "11:47",
					"arrivesAt": "11:53",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Teliu h.",
					"to": "Valea Teliului h.",
					"leavesAt": "11:54",
					"arrivesAt": "11:59",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Valea Teliului h.",
					"to": "Poiana Florilor h.",
					"leavesAt": "12:00",
					"arrivesAt": "12:05",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Întorsura Buzăului Hm",
					"leavesAt": "12:06",
					"arrivesAt": "12:18",
					"waitsAtSource": 30,
					"distance": 7500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14760",
			"segments": [
				{
					"from": "Întorsura Buzăului Hm",
					"to": "Poiana Florilor h.",
					"leavesAt": "17:14",
					"arrivesAt": "17:25",
					"waitsAtSource": 0,
					"distance": 7500
				},
				{
					"from": "Poiana Florilor h.",
					"to": "Valea Teliului h.",
					"leavesAt": "17:26",
					"arrivesAt": "17:32",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Teliului h.",
					"to": "Teliu h.",
					"leavesAt": "17:33",
					"arrivesAt": "17:38",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Teliu h.",
					"to": "Budila hcv.",
					"leavesAt": "17:39",
					"arrivesAt": "17:45",
					"waitsAtSource": 30,
					"distance": 4300
				},
				{
					"from": "Budila hcv.",
					"to": "Hărman",
					"leavesAt": "17:46",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 10500
				},
				{
					"from": "Hărman",
					"to": "Pav. CFR Braşov Triaj h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:04",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Pav. CFR Braşov Triaj h.",
					"to": "Braşov",
					"leavesAt": "18:05",
					"arrivesAt": "18:10",
					"waitsAtSource": 60,
					"distance": 2900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14843",
			"segments": [
				{
					"from": "Roman",
					"to": "Sagna h.",
					"leavesAt": "05:26",
					"arrivesAt": "05:36",
					"waitsAtSource": 0,
					"distance": 8700
				},
				{
					"from": "Sagna h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "05:37",
					"arrivesAt": "05:47",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Stăniţa h.",
					"leavesAt": "05:48",
					"arrivesAt": "05:56",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Stăniţa h.",
					"to": "Piscu Rusului h.",
					"leavesAt": "05:57",
					"arrivesAt": "06:08",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Zece Prăjini h",
					"leavesAt": "06:09",
					"arrivesAt": "06:18",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Zece Prăjini h",
					"to": "Dagâţa",
					"leavesAt": "06:19",
					"arrivesAt": "06:25",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Dagâţa",
					"to": "Băluşeşti h",
					"leavesAt": "06:33",
					"arrivesAt": "06:37",
					"waitsAtSource": 480,
					"distance": 3400
				},
				{
					"from": "Băluşeşti h",
					"to": "Suhuleţ h.",
					"leavesAt": "06:38",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Suhuleţ h.",
					"to": "Mareşal C-tin Prezan Hm.",
					"leavesAt": "06:43",
					"arrivesAt": "06:49",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Mareşal C-tin Prezan Hm.",
					"to": "Dumeşti h.",
					"leavesAt": "06:50",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Dumeşti h.",
					"to": "Rafaila h.",
					"leavesAt": "06:58",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Rafaila h.",
					"to": "Negreşti Vaslui Hm.",
					"leavesAt": "07:06",
					"arrivesAt": "07:13",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Negreşti Vaslui Hm.",
					"to": "Buhăieşti",
					"leavesAt": "07:14",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 10700
				},
				{
					"from": "Buhăieşti",
					"to": "Rateşu Cuzei h.",
					"leavesAt": "07:31",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rateşu Cuzei h.",
					"to": "Rebricea Hm.",
					"leavesAt": "07:36",
					"arrivesAt": "07:41",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Rebricea Hm.",
					"to": "Scânteia Hm.",
					"leavesAt": "07:46",
					"arrivesAt": "07:51",
					"waitsAtSource": 300,
					"distance": 5500
				},
				{
					"from": "Scânteia Hm.",
					"to": "Grajduri",
					"leavesAt": "07:52",
					"arrivesAt": "07:58",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Grajduri",
					"to": "Bârnova Hm.",
					"leavesAt": "07:59",
					"arrivesAt": "08:07",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Bârnova Hm.",
					"to": "Picioru Lupului h.",
					"leavesAt": "08:08",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Picioru Lupului h.",
					"to": "Ciurea Hm.",
					"leavesAt": "08:14",
					"arrivesAt": "08:19",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ciurea Hm.",
					"to": "Nicolina",
					"leavesAt": "08:20",
					"arrivesAt": "08:25",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Nicolina",
					"to": "Iaşi",
					"leavesAt": "08:26",
					"arrivesAt": "08:35",
					"waitsAtSource": 60,
					"distance": 2200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14716",
			"segments": [
				{
					"from": "Zărneşti",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "21:30",
					"arrivesAt": "21:33",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "21:34",
					"arrivesAt": "21:36",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "Râşnov h.",
					"leavesAt": "21:37",
					"arrivesAt": "21:42",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Râşnov h.",
					"to": "Râşnov",
					"leavesAt": "21:43",
					"arrivesAt": "21:46",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Râşnov",
					"to": "Cristian Hm.",
					"leavesAt": "21:47",
					"arrivesAt": "21:51",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cristian Hm.",
					"to": "Lustic h.",
					"leavesAt": "21:52",
					"arrivesAt": "21:55",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Lustic h.",
					"to": "Bartolomeu",
					"leavesAt": "21:56",
					"arrivesAt": "22:03",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "22:04",
					"arrivesAt": "22:10",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14419",
			"segments": [
				{
					"from": "Ineu",
					"to": "Teuz h.",
					"leavesAt": "06:40",
					"arrivesAt": "06:51",
					"waitsAtSource": 0,
					"distance": 10600
				},
				{
					"from": "Teuz h.",
					"to": "Cermei hcv",
					"leavesAt": "06:52",
					"arrivesAt": "06:58",
					"waitsAtSource": 30,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 511
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14304",
			"segments": [
				{
					"from": "Nădlac",
					"to": "Şeitin h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:08",
					"waitsAtSource": 0,
					"distance": 8100
				},
				{
					"from": "Şeitin h.",
					"to": "Semlac h.",
					"leavesAt": "16:09",
					"arrivesAt": "16:19",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Semlac h.",
					"to": "Pecica",
					"leavesAt": "16:20",
					"arrivesAt": "16:44",
					"waitsAtSource": 60,
					"distance": 17200
				},
				{
					"from": "Pecica",
					"to": "Sântoma h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:08",
					"waitsAtSource": 780,
					"distance": 8000
				},
				{
					"from": "Sântoma h.",
					"to": "Ferma Ciala h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 4400
				},
				{
					"from": "Ferma Ciala h.",
					"to": "Arad Vest",
					"leavesAt": "17:16",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Arad Vest",
					"to": "Arad",
					"leavesAt": "17:25",
					"arrivesAt": "17:34",
					"waitsAtSource": 180,
					"distance": 4800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14555",
			"segments": [
				{
					"from": "Sărmăşel hcv .",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "15:42",
					"arrivesAt": "15:45",
					"waitsAtSource": 0,
					"distance": 2000
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmaşu h.",
					"leavesAt": "15:46",
					"arrivesAt": "15:50",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sărmaşu h.",
					"to": "Balda h.",
					"leavesAt": "15:51",
					"arrivesAt": "15:55",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Balda h.",
					"to": "Miheşu de Câmpie Sat h.",
					"leavesAt": "15:56",
					"arrivesAt": "16:02",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Miheşu de Câmpie Sat h.",
					"to": "Miheşu de Câmpie h.",
					"leavesAt": "16:03",
					"arrivesAt": "16:09",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Miheşu de Câmpie h.",
					"to": "Bota Sat h.",
					"leavesAt": "16:10",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bota Sat h.",
					"to": "Zau de Câmpie h.",
					"leavesAt": "16:16",
					"arrivesAt": "16:21",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Zau de Câmpie h.",
					"to": "Melini Valea Largă h.",
					"leavesAt": "16:22",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Melini Valea Largă h.",
					"to": "Tăureni h.",
					"leavesAt": "16:26",
					"arrivesAt": "16:30",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Tăureni h.",
					"to": "Sânger Tăureni h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 5620
				},
				{
					"from": "Sânger Tăureni h.",
					"to": "Luduş Sat hc.",
					"leavesAt": "16:40",
					"arrivesAt": "16:50",
					"waitsAtSource": 30,
					"distance": 8080
				},
				{
					"from": "Luduş Sat hc.",
					"to": "Luduş",
					"leavesAt": "16:51",
					"arrivesAt": "16:55",
					"waitsAtSource": 30,
					"distance": 2400
				}
			],
			"restrictions": [
				{
					"from": "20170101",
					"to": "20171209",
					"daysOfWeek": 383
				},
				{
					"from": "20161211",
					"to": "20161223",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14343",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Dudeştii Vechi  h",
					"leavesAt": "16:10",
					"arrivesAt": "16:27",
					"waitsAtSource": 0,
					"distance": 14000
				},
				{
					"from": "Dudeştii Vechi  h",
					"to": "Vălcani hcv.",
					"leavesAt": "16:28",
					"arrivesAt": "16:37",
					"waitsAtSource": 30,
					"distance": 7000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14038",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "15:50",
					"arrivesAt": "15:57",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Predeal",
					"leavesAt": "15:58",
					"arrivesAt": "16:25",
					"waitsAtSource": 60,
					"distance": 20100
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "16:26",
					"arrivesAt": "16:34",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "16:35",
					"arrivesAt": "16:40",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "16:41",
					"arrivesAt": "16:44",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "16:45",
					"arrivesAt": "16:50",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "16:51",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "16:54",
					"arrivesAt": "16:58",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Comarnic",
					"leavesAt": "16:59",
					"arrivesAt": "17:08",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "17:09",
					"arrivesAt": "17:12",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "17:13",
					"arrivesAt": "17:16",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "17:17",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "17:21",
					"arrivesAt": "17:29",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "17:30",
					"arrivesAt": "17:41",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "17:42",
					"arrivesAt": "17:51",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "17:52",
					"arrivesAt": "18:00",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Brazi",
					"leavesAt": "18:06",
					"arrivesAt": "18:13",
					"waitsAtSource": 360,
					"distance": 7500
				},
				{
					"from": "Brazi",
					"to": "Crivina",
					"leavesAt": "18:14",
					"arrivesAt": "18:23",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "18:24",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "18:29",
					"arrivesAt": "18:34",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "18:35",
					"arrivesAt": "18:43",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "18:44",
					"arrivesAt": "18:48",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "18:49",
					"arrivesAt": "19:07",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14034",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "07:00",
					"arrivesAt": "07:07",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Predeal",
					"leavesAt": "07:08",
					"arrivesAt": "07:35",
					"waitsAtSource": 60,
					"distance": 20100
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "07:36",
					"arrivesAt": "07:44",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "07:45",
					"arrivesAt": "07:50",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "07:51",
					"arrivesAt": "07:54",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "07:55",
					"arrivesAt": "08:00",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "08:01",
					"arrivesAt": "08:03",
					"waitsAtSource": 60,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "08:04",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Comarnic",
					"leavesAt": "08:09",
					"arrivesAt": "08:18",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "08:19",
					"arrivesAt": "08:22",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "08:23",
					"arrivesAt": "08:26",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "08:27",
					"arrivesAt": "08:30",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "08:31",
					"arrivesAt": "08:39",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "08:40",
					"arrivesAt": "08:51",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "08:52",
					"arrivesAt": "09:01",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "09:02",
					"arrivesAt": "09:10",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Brazi",
					"leavesAt": "09:21",
					"arrivesAt": "09:28",
					"waitsAtSource": 660,
					"distance": 7500
				},
				{
					"from": "Brazi",
					"to": "Crivina",
					"leavesAt": "09:29",
					"arrivesAt": "09:38",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "09:39",
					"arrivesAt": "09:44",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "09:45",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "09:58",
					"arrivesAt": "10:05",
					"waitsAtSource": 420,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "10:06",
					"arrivesAt": "10:10",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "10:11",
					"arrivesAt": "10:30",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14975",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Dâmbu Hm.",
					"leavesAt": "08:15",
					"arrivesAt": "08:20",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "08:21",
					"arrivesAt": "08:27",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Râfov h.",
					"leavesAt": "08:28",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Râfov h.",
					"to": "Trestieni h.",
					"leavesAt": "08:32",
					"arrivesAt": "08:37",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Trestieni h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "08:38",
					"arrivesAt": "08:41",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Cornurile h.",
					"leavesAt": "08:42",
					"arrivesAt": "08:47",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cornurile h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "08:48",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "08:54",
					"arrivesAt": "08:58",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Hătcărău h.",
					"to": "Ciorani Hm.",
					"leavesAt": "08:59",
					"arrivesAt": "09:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Ciorani Hm.",
					"to": "Fulga hc.",
					"leavesAt": "09:06",
					"arrivesAt": "09:11",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Fulga hc.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "09:12",
					"arrivesAt": "09:18",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "09:19",
					"arrivesAt": "09:24",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "09:25",
					"arrivesAt": "09:29",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "09:30",
					"arrivesAt": "09:36",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14842",
			"segments": [
				{
					"from": "Buhăieşti",
					"to": "Negreşti Vaslui Hm.",
					"leavesAt": "05:36",
					"arrivesAt": "05:50",
					"waitsAtSource": 0,
					"distance": 10700
				},
				{
					"from": "Negreşti Vaslui Hm.",
					"to": "Rafaila h.",
					"leavesAt": "05:51",
					"arrivesAt": "05:57",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Rafaila h.",
					"to": "Dumeşti h.",
					"leavesAt": "05:58",
					"arrivesAt": "06:05",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Dumeşti h.",
					"to": "Mareşal C-tin Prezan Hm.",
					"leavesAt": "06:06",
					"arrivesAt": "06:13",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Mareşal C-tin Prezan Hm.",
					"to": "Suhuleţ h.",
					"leavesAt": "06:14",
					"arrivesAt": "06:20",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Suhuleţ h.",
					"to": "Băluşeşti h",
					"leavesAt": "06:21",
					"arrivesAt": "06:24",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Băluşeşti h",
					"to": "Dagâţa",
					"leavesAt": "06:25",
					"arrivesAt": "06:29",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Dagâţa",
					"to": "Zece Prăjini h",
					"leavesAt": "06:31",
					"arrivesAt": "06:35",
					"waitsAtSource": 120,
					"distance": 3600
				},
				{
					"from": "Zece Prăjini h",
					"to": "Piscu Rusului h.",
					"leavesAt": "06:36",
					"arrivesAt": "06:45",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Stăniţa h.",
					"leavesAt": "06:46",
					"arrivesAt": "06:57",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Stăniţa h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "06:58",
					"arrivesAt": "07:05",
					"waitsAtSource": 60,
					"distance": 3800
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Sagna h.",
					"leavesAt": "07:06",
					"arrivesAt": "07:16",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Sagna h.",
					"to": "Roman",
					"leavesAt": "07:17",
					"arrivesAt": "07:30",
					"waitsAtSource": 60,
					"distance": 8700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14325",
			"segments": [
				{
					"from": "Timişoara Nord",
					"to": "Ronaţ Triaj Cab.1 h.",
					"leavesAt": "19:33",
					"arrivesAt": "19:39",
					"waitsAtSource": 0,
					"distance": 4400
				},
				{
					"from": "Ronaţ Triaj Cab.1 h.",
					"to": "Ronaţ Triaj h.",
					"leavesAt": "19:40",
					"arrivesAt": "19:43",
					"waitsAtSource": 30,
					"distance": 1500
				},
				{
					"from": "Ronaţ Triaj h.",
					"to": "Ronaţ Triaj Gr. D",
					"leavesAt": "19:44",
					"arrivesAt": "19:46",
					"waitsAtSource": 60,
					"distance": 1000
				},
				{
					"from": "Ronaţ Triaj Gr. D",
					"to": "Sânandrei Hm.",
					"leavesAt": "19:47",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sânandrei Hm.",
					"to": "Hodoni h.",
					"leavesAt": "19:54",
					"arrivesAt": "20:03",
					"waitsAtSource": 60,
					"distance": 8600
				},
				{
					"from": "Hodoni h.",
					"to": "Chinezu h.",
					"leavesAt": "20:04",
					"arrivesAt": "20:11",
					"waitsAtSource": 30,
					"distance": 5700
				},
				{
					"from": "Chinezu h.",
					"to": "Bărăteaz h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Bărăteaz h.",
					"to": "Gelu hc.",
					"leavesAt": "20:18",
					"arrivesAt": "20:23",
					"waitsAtSource": 30,
					"distance": 3500
				},
				{
					"from": "Gelu hc.",
					"to": "Variaş hc.",
					"leavesAt": "20:24",
					"arrivesAt": "20:30",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Variaş hc.",
					"to": "Periam",
					"leavesAt": "20:31",
					"arrivesAt": "20:41",
					"waitsAtSource": 30,
					"distance": 7600
				},
				{
					"from": "Periam",
					"to": "Pesac h.",
					"leavesAt": "20:51",
					"arrivesAt": "21:04",
					"waitsAtSource": 600,
					"distance": 6700
				},
				{
					"from": "Pesac h.",
					"to": "Satu Nou Hm.",
					"leavesAt": "21:05",
					"arrivesAt": "21:13",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Satu Nou Hm.",
					"to": "Lovrin",
					"leavesAt": "21:14",
					"arrivesAt": "21:22",
					"waitsAtSource": 60,
					"distance": 5000
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14848",
			"segments": [
				{
					"from": "Buhăieşti",
					"to": "Negreşti Vaslui Hm.",
					"leavesAt": "16:44",
					"arrivesAt": "16:58",
					"waitsAtSource": 0,
					"distance": 10700
				},
				{
					"from": "Negreşti Vaslui Hm.",
					"to": "Rafaila h.",
					"leavesAt": "16:59",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Rafaila h.",
					"to": "Dumeşti h.",
					"leavesAt": "17:05",
					"arrivesAt": "17:12",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Dumeşti h.",
					"to": "Mareşal C-tin Prezan Hm.",
					"leavesAt": "17:13",
					"arrivesAt": "17:20",
					"waitsAtSource": 30,
					"distance": 5500
				},
				{
					"from": "Mareşal C-tin Prezan Hm.",
					"to": "Suhuleţ h.",
					"leavesAt": "17:21",
					"arrivesAt": "17:27",
					"waitsAtSource": 60,
					"distance": 5500
				},
				{
					"from": "Suhuleţ h.",
					"to": "Băluşeşti h",
					"leavesAt": "17:28",
					"arrivesAt": "17:31",
					"waitsAtSource": 60,
					"distance": 3000
				},
				{
					"from": "Băluşeşti h",
					"to": "Dagâţa",
					"leavesAt": "17:32",
					"arrivesAt": "17:36",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Dagâţa",
					"to": "Zece Prăjini h",
					"leavesAt": "17:44",
					"arrivesAt": "17:48",
					"waitsAtSource": 480,
					"distance": 3600
				},
				{
					"from": "Zece Prăjini h",
					"to": "Piscu Rusului h.",
					"leavesAt": "17:49",
					"arrivesAt": "17:57",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Piscu Rusului h.",
					"to": "Stăniţa h.",
					"leavesAt": "17:58",
					"arrivesAt": "18:09",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Stăniţa h.",
					"to": "Vulpăşeşti h.",
					"leavesAt": "18:10",
					"arrivesAt": "18:17",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Vulpăşeşti h.",
					"to": "Sagna h.",
					"leavesAt": "18:18",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 8300
				},
				{
					"from": "Sagna h.",
					"to": "Roman",
					"leavesAt": "18:29",
					"arrivesAt": "18:42",
					"waitsAtSource": 60,
					"distance": 8700
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14036",
			"segments": [
				{
					"from": "Braşov",
					"to": "Dârste",
					"leavesAt": "13:55",
					"arrivesAt": "14:02",
					"waitsAtSource": 0,
					"distance": 6200
				},
				{
					"from": "Dârste",
					"to": "Predeal",
					"leavesAt": "14:03",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 20100
				},
				{
					"from": "Predeal",
					"to": "Azuga",
					"leavesAt": "14:32",
					"arrivesAt": "14:41",
					"waitsAtSource": 120,
					"distance": 7400
				},
				{
					"from": "Azuga",
					"to": "Buşteni",
					"leavesAt": "14:42",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Buşteni",
					"to": "Poiana Ţapului hc.",
					"leavesAt": "14:48",
					"arrivesAt": "14:51",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Poiana Ţapului hc.",
					"to": "Sinaia",
					"leavesAt": "14:52",
					"arrivesAt": "14:57",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sinaia",
					"to": "Sinaia Sud h.",
					"leavesAt": "14:59",
					"arrivesAt": "15:01",
					"waitsAtSource": 120,
					"distance": 1600
				},
				{
					"from": "Sinaia Sud h.",
					"to": "Valea Largă Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:06",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Valea Largă Hm.",
					"to": "Comarnic",
					"leavesAt": "15:07",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 9700
				},
				{
					"from": "Comarnic",
					"to": "Breaza Nord h.",
					"leavesAt": "15:17",
					"arrivesAt": "15:20",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Breaza Nord h.",
					"to": "Nistoreşti h.",
					"leavesAt": "15:21",
					"arrivesAt": "15:24",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Nistoreşti h.",
					"to": "Breaza hc.",
					"leavesAt": "15:25",
					"arrivesAt": "15:28",
					"waitsAtSource": 30,
					"distance": 2700
				},
				{
					"from": "Breaza hc.",
					"to": "Câmpina",
					"leavesAt": "15:29",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Câmpina",
					"to": "Floreşti Prahova",
					"leavesAt": "15:38",
					"arrivesAt": "15:50",
					"waitsAtSource": 60,
					"distance": 14200
				},
				{
					"from": "Floreşti Prahova",
					"to": "Buda",
					"leavesAt": "15:51",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Buda",
					"to": "Ploieşti Vest",
					"leavesAt": "16:01",
					"arrivesAt": "16:10",
					"waitsAtSource": 60,
					"distance": 6900
				},
				{
					"from": "Ploieşti Vest",
					"to": "Brazi",
					"leavesAt": "16:21",
					"arrivesAt": "16:28",
					"waitsAtSource": 660,
					"distance": 7500
				},
				{
					"from": "Brazi",
					"to": "Crivina",
					"leavesAt": "16:29",
					"arrivesAt": "16:39",
					"waitsAtSource": 60,
					"distance": 11700
				},
				{
					"from": "Crivina",
					"to": "Scroviştea h.",
					"leavesAt": "16:46",
					"arrivesAt": "16:50",
					"waitsAtSource": 420,
					"distance": 4300
				},
				{
					"from": "Scroviştea h.",
					"to": "Periş",
					"leavesAt": "16:51",
					"arrivesAt": "16:56",
					"waitsAtSource": 30,
					"distance": 5200
				},
				{
					"from": "Periş",
					"to": "Dârza h.",
					"leavesAt": "16:57",
					"arrivesAt": "17:04",
					"waitsAtSource": 60,
					"distance": 9200
				},
				{
					"from": "Dârza h.",
					"to": "Buftea",
					"leavesAt": "17:05",
					"arrivesAt": "17:09",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Buftea",
					"to": "Bucureşti Nord",
					"leavesAt": "17:10",
					"arrivesAt": "17:30",
					"waitsAtSource": 60,
					"distance": 16900
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "18237",
			"segments": [
				{
					"from": "Berzovia",
					"to": "Bocşa Română hc.",
					"leavesAt": "13:45",
					"arrivesAt": "13:53",
					"waitsAtSource": 0,
					"distance": 8200
				},
				{
					"from": "Bocşa Română hc.",
					"to": "Vasiova",
					"leavesAt": "13:54",
					"arrivesAt": "13:59",
					"waitsAtSource": 30,
					"distance": 4200
				},
				{
					"from": "Vasiova",
					"to": "Bocşa Montană hc.",
					"leavesAt": "14:00",
					"arrivesAt": "14:03",
					"waitsAtSource": 60,
					"distance": 1700
				},
				{
					"from": "Bocşa Montană hc.",
					"to": "Colţan h.",
					"leavesAt": "14:04",
					"arrivesAt": "14:11",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Colţan h.",
					"to": "Moniom h.",
					"leavesAt": "14:12",
					"arrivesAt": "14:17",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Moniom h.",
					"to": "Câlnic h.",
					"leavesAt": "14:18",
					"arrivesAt": "14:26",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Câlnic h.",
					"to": "Reşiţa Nord",
					"leavesAt": "14:27",
					"arrivesAt": "14:30",
					"waitsAtSource": 60,
					"distance": 1600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14710",
			"segments": [
				{
					"from": "Zărneşti",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "15:05",
					"arrivesAt": "15:08",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "15:09",
					"arrivesAt": "15:11",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "Râşnov h.",
					"leavesAt": "15:12",
					"arrivesAt": "15:17",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Râşnov h.",
					"to": "Râşnov",
					"leavesAt": "15:18",
					"arrivesAt": "15:21",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Râşnov",
					"to": "Cristian Hm.",
					"leavesAt": "15:22",
					"arrivesAt": "15:26",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cristian Hm.",
					"to": "Lustic h.",
					"leavesAt": "15:27",
					"arrivesAt": "15:30",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Lustic h.",
					"to": "Bartolomeu",
					"leavesAt": "15:31",
					"arrivesAt": "15:38",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "15:39",
					"arrivesAt": "15:45",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14974",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "08:38",
					"arrivesAt": "08:42",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "08:43",
					"arrivesAt": "08:48",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "08:49",
					"arrivesAt": "08:55",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Fulga hc.",
					"leavesAt": "08:56",
					"arrivesAt": "09:02",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Fulga hc.",
					"to": "Ciorani Hm.",
					"leavesAt": "09:03",
					"arrivesAt": "09:08",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ciorani Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "09:09",
					"arrivesAt": "09:14",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hătcărău h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "09:15",
					"arrivesAt": "09:19",
					"waitsAtSource": 60,
					"distance": 2500
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Cornurile h.",
					"leavesAt": "09:20",
					"arrivesAt": "09:25",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Cornurile h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "09:26",
					"arrivesAt": "09:31",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Trestieni h.",
					"leavesAt": "09:32",
					"arrivesAt": "09:36",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Trestieni h.",
					"to": "Râfov h.",
					"leavesAt": "09:37",
					"arrivesAt": "09:41",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Râfov h.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "09:42",
					"arrivesAt": "09:45",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Dâmbu Hm.",
					"leavesAt": "09:46",
					"arrivesAt": "09:51",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Ploieşti Sud",
					"leavesAt": "09:52",
					"arrivesAt": "09:56",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14011",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "07:42",
					"arrivesAt": "07:45",
					"waitsAtSource": 0,
					"distance": 900
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Sărata h.",
					"leavesAt": "07:46",
					"arrivesAt": "07:53",
					"waitsAtSource": 60,
					"distance": 6400
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel",
					"leavesAt": "07:54",
					"arrivesAt": "07:59",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sărăţel",
					"to": "Arcalia hc.",
					"leavesAt": "08:00",
					"arrivesAt": "08:04",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "08:05",
					"arrivesAt": "08:08",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Chintelnic h.",
					"leavesAt": "08:09",
					"arrivesAt": "08:13",
					"waitsAtSource": 60,
					"distance": 2314
				},
				{
					"from": "Chintelnic h.",
					"to": "Chiraleş h.",
					"leavesAt": "08:14",
					"arrivesAt": "08:17",
					"waitsAtSource": 60,
					"distance": 2276
				},
				{
					"from": "Chiraleş h.",
					"to": "Ţigău h.",
					"leavesAt": "08:18",
					"arrivesAt": "08:23",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ţigău h.",
					"to": "Lechinţa",
					"leavesAt": "08:24",
					"arrivesAt": "08:31",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lechinţa",
					"to": "Vermeş h.",
					"leavesAt": "08:33",
					"arrivesAt": "08:36",
					"waitsAtSource": 120,
					"distance": 2200
				},
				{
					"from": "Vermeş h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "08:37",
					"arrivesAt": "08:46",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Brăteni h.",
					"leavesAt": "08:47",
					"arrivesAt": "08:53",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Brăteni h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "08:54",
					"arrivesAt": "09:01",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "09:02",
					"arrivesAt": "09:07",
					"waitsAtSource": 30,
					"distance": 3800
				},
				{
					"from": "Miceştii de Câmpie h.",
					"to": "Budeşti Cluj h.",
					"leavesAt": "09:08",
					"arrivesAt": "09:18",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Budeşti Cluj h.",
					"to": "Ţagu h.",
					"leavesAt": "09:19",
					"arrivesAt": "09:27",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Ţagu h.",
					"to": "Ţagu Sat h.",
					"leavesAt": "09:28",
					"arrivesAt": "09:30",
					"waitsAtSource": 60,
					"distance": 1400
				},
				{
					"from": "Ţagu Sat h.",
					"to": "Ţăgşor h.",
					"leavesAt": "09:31",
					"arrivesAt": "09:37",
					"waitsAtSource": 30,
					"distance": 4100
				},
				{
					"from": "Ţăgşor h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "09:38",
					"arrivesAt": "09:42",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Sărmăşel hcv .",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "09:57",
					"arrivesAt": "10:00",
					"waitsAtSource": 900,
					"distance": 2000
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmaşu h.",
					"leavesAt": "10:01",
					"arrivesAt": "10:05",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sărmaşu h.",
					"to": "Balda h.",
					"leavesAt": "10:06",
					"arrivesAt": "10:10",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Balda h.",
					"to": "Miheşu de Câmpie Sat h.",
					"leavesAt": "10:11",
					"arrivesAt": "10:17",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Miheşu de Câmpie Sat h.",
					"to": "Miheşu de Câmpie h.",
					"leavesAt": "10:18",
					"arrivesAt": "10:24",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Miheşu de Câmpie h.",
					"to": "Bota Sat h.",
					"leavesAt": "10:25",
					"arrivesAt": "10:31",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Bota Sat h.",
					"to": "Zau de Câmpie h.",
					"leavesAt": "10:32",
					"arrivesAt": "10:37",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Zau de Câmpie h.",
					"to": "Melini Valea Largă h.",
					"leavesAt": "10:38",
					"arrivesAt": "10:41",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Melini Valea Largă h.",
					"to": "Tăureni h.",
					"leavesAt": "10:42",
					"arrivesAt": "10:46",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Tăureni h.",
					"to": "Sânger Tăureni h.",
					"leavesAt": "10:47",
					"arrivesAt": "10:55",
					"waitsAtSource": 60,
					"distance": 5620
				},
				{
					"from": "Sânger Tăureni h.",
					"to": "Luduş Sat hc.",
					"leavesAt": "10:56",
					"arrivesAt": "11:07",
					"waitsAtSource": 30,
					"distance": 8080
				},
				{
					"from": "Luduş Sat hc.",
					"to": "Luduş",
					"leavesAt": "11:08",
					"arrivesAt": "11:12",
					"waitsAtSource": 60,
					"distance": 2400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14013",
			"segments": [
				{
					"from": "Bistriţa Nord",
					"to": "Bistriţa Fabrici h.",
					"leavesAt": "11:10",
					"arrivesAt": "11:12",
					"waitsAtSource": 0,
					"distance": 900
				},
				{
					"from": "Bistriţa Fabrici h.",
					"to": "Sărata h.",
					"leavesAt": "11:13",
					"arrivesAt": "11:20",
					"waitsAtSource": 30,
					"distance": 6400
				},
				{
					"from": "Sărata h.",
					"to": "Sărăţel",
					"leavesAt": "11:21",
					"arrivesAt": "11:26",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Sărăţel",
					"to": "Arcalia hc.",
					"leavesAt": "11:27",
					"arrivesAt": "11:31",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Arcalia hc.",
					"to": "Măgheruş Şieu Hm.",
					"leavesAt": "11:32",
					"arrivesAt": "11:35",
					"waitsAtSource": 30,
					"distance": 2000
				},
				{
					"from": "Măgheruş Şieu Hm.",
					"to": "Chintelnic h.",
					"leavesAt": "11:36",
					"arrivesAt": "11:40",
					"waitsAtSource": 60,
					"distance": 2314
				},
				{
					"from": "Chintelnic h.",
					"to": "Chiraleş h.",
					"leavesAt": "11:41",
					"arrivesAt": "11:44",
					"waitsAtSource": 30,
					"distance": 2276
				},
				{
					"from": "Chiraleş h.",
					"to": "Ţigău h.",
					"leavesAt": "11:45",
					"arrivesAt": "11:50",
					"waitsAtSource": 30,
					"distance": 3200
				},
				{
					"from": "Ţigău h.",
					"to": "Lechinţa",
					"leavesAt": "11:51",
					"arrivesAt": "11:58",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Lechinţa",
					"to": "Vermeş h.",
					"leavesAt": "12:01",
					"arrivesAt": "12:04",
					"waitsAtSource": 180,
					"distance": 2200
				},
				{
					"from": "Vermeş h.",
					"to": "Sângiorgiu Nou h.",
					"leavesAt": "12:05",
					"arrivesAt": "12:14",
					"waitsAtSource": 30,
					"distance": 6000
				},
				{
					"from": "Sângiorgiu Nou h.",
					"to": "Brăteni h.",
					"leavesAt": "12:15",
					"arrivesAt": "12:21",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Brăteni h.",
					"to": "Sânmihaiu de Câmpie h.",
					"leavesAt": "12:22",
					"arrivesAt": "12:29",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Sânmihaiu de Câmpie h.",
					"to": "Miceştii de Câmpie h.",
					"leavesAt": "12:30",
					"arrivesAt": "12:36",
					"waitsAtSource": 30,
					"distance": 3800
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14550",
			"segments": [
				{
					"from": "Luduş",
					"to": "Luduş Sat hc.",
					"leavesAt": "14:25",
					"arrivesAt": "14:28",
					"waitsAtSource": 0,
					"distance": 2400
				},
				{
					"from": "Luduş Sat hc.",
					"to": "Sânger Tăureni h.",
					"leavesAt": "14:29",
					"arrivesAt": "14:39",
					"waitsAtSource": 30,
					"distance": 8080
				},
				{
					"from": "Sânger Tăureni h.",
					"to": "Tăureni h.",
					"leavesAt": "14:40",
					"arrivesAt": "14:47",
					"waitsAtSource": 30,
					"distance": 5620
				},
				{
					"from": "Tăureni h.",
					"to": "Melini Valea Largă h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:52",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Melini Valea Largă h.",
					"to": "Zau de Câmpie h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Zau de Câmpie h.",
					"to": "Bota Sat h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:02",
					"waitsAtSource": 30,
					"distance": 3300
				},
				{
					"from": "Bota Sat h.",
					"to": "Miheşu de Câmpie h.",
					"leavesAt": "15:03",
					"arrivesAt": "15:09",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Miheşu de Câmpie h.",
					"to": "Miheşu de Câmpie Sat h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:16",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Miheşu de Câmpie Sat h.",
					"to": "Balda h.",
					"leavesAt": "15:17",
					"arrivesAt": "15:22",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Balda h.",
					"to": "Sărmaşu h.",
					"leavesAt": "15:23",
					"arrivesAt": "15:27",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sărmaşu h.",
					"to": "Sărmăşel Gaz Metan h.",
					"leavesAt": "15:28",
					"arrivesAt": "15:32",
					"waitsAtSource": 30,
					"distance": 2900
				},
				{
					"from": "Sărmăşel Gaz Metan h.",
					"to": "Sărmăşel hcv .",
					"leavesAt": "15:33",
					"arrivesAt": "15:37",
					"waitsAtSource": 30,
					"distance": 2000
				}
			],
			"restrictions": [
				{
					"from": "20170101",
					"to": "20171209",
					"daysOfWeek": 383
				},
				{
					"from": "20161211",
					"to": "20161223",
					"daysOfWeek": 383
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14973",
			"segments": [
				{
					"from": "Ploieşti Sud",
					"to": "Dâmbu Hm.",
					"leavesAt": "06:11",
					"arrivesAt": "06:16",
					"waitsAtSource": 0,
					"distance": 3600
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "06:17",
					"arrivesAt": "06:23",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Râfov h.",
					"leavesAt": "06:24",
					"arrivesAt": "06:27",
					"waitsAtSource": 60,
					"distance": 1900
				},
				{
					"from": "Râfov h.",
					"to": "Trestieni h.",
					"leavesAt": "06:28",
					"arrivesAt": "06:32",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Trestieni h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "06:33",
					"arrivesAt": "06:36",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Cornurile h.",
					"leavesAt": "06:37",
					"arrivesAt": "06:42",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Cornurile h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "06:43",
					"arrivesAt": "06:48",
					"waitsAtSource": 30,
					"distance": 4000
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "06:55",
					"arrivesAt": "06:58",
					"waitsAtSource": 420,
					"distance": 2500
				},
				{
					"from": "Hătcărău h.",
					"to": "Ciorani Hm.",
					"leavesAt": "06:59",
					"arrivesAt": "07:06",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Ciorani Hm.",
					"to": "Fulga hc.",
					"leavesAt": "07:07",
					"arrivesAt": "07:11",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Fulga hc.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "07:12",
					"arrivesAt": "07:19",
					"waitsAtSource": 30,
					"distance": 6500
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "07:20",
					"arrivesAt": "07:26",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Bărbuleşti h.",
					"leavesAt": "07:27",
					"arrivesAt": "07:31",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Urziceni",
					"leavesAt": "07:32",
					"arrivesAt": "07:37",
					"waitsAtSource": 60,
					"distance": 3500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14824",
			"segments": [
				{
					"from": "Dorohoi",
					"to": "Broscăuţi h.",
					"leavesAt": "18:41",
					"arrivesAt": "18:47",
					"waitsAtSource": 0,
					"distance": 5800
				},
				{
					"from": "Broscăuţi h.",
					"to": "Carasa h.",
					"leavesAt": "18:48",
					"arrivesAt": "18:55",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Carasa h.",
					"to": "Corlăteni h",
					"leavesAt": "18:56",
					"arrivesAt": "18:59",
					"waitsAtSource": 30,
					"distance": 2300
				},
				{
					"from": "Corlăteni h",
					"to": "Mateieni h.",
					"leavesAt": "19:00",
					"arrivesAt": "19:04",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Mateieni h.",
					"to": "Vorniceni h.",
					"leavesAt": "19:05",
					"arrivesAt": "19:09",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Vorniceni h.",
					"to": "Mândreşti h.",
					"leavesAt": "19:10",
					"arrivesAt": "19:18",
					"waitsAtSource": 60,
					"distance": 7400
				},
				{
					"from": "Mândreşti h.",
					"to": "Ungureni Hm.",
					"leavesAt": "19:19",
					"arrivesAt": "19:25",
					"waitsAtSource": 60,
					"distance": 4600
				},
				{
					"from": "Ungureni Hm.",
					"to": "Dângeni Nord h.",
					"leavesAt": "19:27",
					"arrivesAt": "19:35",
					"waitsAtSource": 120,
					"distance": 8700
				},
				{
					"from": "Dângeni Nord h.",
					"to": "Dângeni",
					"leavesAt": "19:36",
					"arrivesAt": "19:41",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Dângeni",
					"to": "Buhăceni h.",
					"leavesAt": "19:42",
					"arrivesAt": "19:48",
					"waitsAtSource": 60,
					"distance": 6000
				},
				{
					"from": "Buhăceni h.",
					"to": "Truşeşti",
					"leavesAt": "19:49",
					"arrivesAt": "19:55",
					"waitsAtSource": 60,
					"distance": 4700
				},
				{
					"from": "Truşeşti",
					"to": "Zlătunoaia h",
					"leavesAt": "19:56",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 9400
				},
				{
					"from": "Zlătunoaia h",
					"to": "Jijia h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:12",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Jijia h.",
					"to": "Todireni Hm.",
					"leavesAt": "20:13",
					"arrivesAt": "20:21",
					"waitsAtSource": 60,
					"distance": 8200
				},
				{
					"from": "Todireni Hm.",
					"to": "Răuşeni hc.",
					"leavesAt": "20:23",
					"arrivesAt": "20:29",
					"waitsAtSource": 120,
					"distance": 6400
				},
				{
					"from": "Răuşeni hc.",
					"to": "Rediu hc.",
					"leavesAt": "20:30",
					"arrivesAt": "20:35",
					"waitsAtSource": 60,
					"distance": 3900
				},
				{
					"from": "Rediu hc.",
					"to": "Andrieşeni hc.",
					"leavesAt": "20:36",
					"arrivesAt": "20:41",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Andrieşeni hc.",
					"to": "Şoldana hc.",
					"leavesAt": "20:42",
					"arrivesAt": "20:47",
					"waitsAtSource": 60,
					"distance": 4200
				},
				{
					"from": "Şoldana hc.",
					"to": "Iacobenii Vechi hc.",
					"leavesAt": "20:48",
					"arrivesAt": "20:53",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Iacobenii Vechi hc.",
					"to": "Vlădeni",
					"leavesAt": "20:54",
					"arrivesAt": "21:00",
					"waitsAtSource": 60,
					"distance": 5600
				},
				{
					"from": "Vlădeni",
					"to": "Larga Jijia Hm.",
					"leavesAt": "21:08",
					"arrivesAt": "21:19",
					"waitsAtSource": 480,
					"distance": 10800
				},
				{
					"from": "Larga Jijia Hm.",
					"to": "Potângeni hc.",
					"leavesAt": "21:20",
					"arrivesAt": "21:26",
					"waitsAtSource": 60,
					"distance": 4900
				},
				{
					"from": "Potângeni hc.",
					"to": "Movileni h",
					"leavesAt": "21:27",
					"arrivesAt": "21:35",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Movileni h",
					"to": "Leţcani",
					"leavesAt": "21:36",
					"arrivesAt": "21:46",
					"waitsAtSource": 60,
					"distance": 9300
				},
				{
					"from": "Leţcani",
					"to": "Iaşi",
					"leavesAt": "21:47",
					"arrivesAt": "22:03",
					"waitsAtSource": 60,
					"distance": 14100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14809",
			"segments": [
				{
					"from": "Iaşi",
					"to": "Leţcani",
					"leavesAt": "19:07",
					"arrivesAt": "19:18",
					"waitsAtSource": 0,
					"distance": 14100
				},
				{
					"from": "Leţcani",
					"to": "Podu Iloaiei",
					"leavesAt": "19:19",
					"arrivesAt": "19:27",
					"waitsAtSource": 60,
					"distance": 8800
				},
				{
					"from": "Podu Iloaiei",
					"to": "Erbiceni hc.",
					"leavesAt": "19:35",
					"arrivesAt": "19:44",
					"waitsAtSource": 480,
					"distance": 6000
				},
				{
					"from": "Erbiceni hc.",
					"to": "Spinoasa h.",
					"leavesAt": "19:45",
					"arrivesAt": "19:53",
					"waitsAtSource": 60,
					"distance": 5100
				},
				{
					"from": "Spinoasa h.",
					"to": "Belceşti Hm.",
					"leavesAt": "19:54",
					"arrivesAt": "20:05",
					"waitsAtSource": 60,
					"distance": 9500
				},
				{
					"from": "Belceşti Hm.",
					"to": "Podu Ulmi h.",
					"leavesAt": "20:06",
					"arrivesAt": "20:11",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Podu Ulmi h.",
					"to": "Hodora h.",
					"leavesAt": "20:12",
					"arrivesAt": "20:17",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Hodora h.",
					"to": "Cotnari hc.",
					"leavesAt": "20:18",
					"arrivesAt": "20:23",
					"waitsAtSource": 60,
					"distance": 4300
				},
				{
					"from": "Cotnari hc.",
					"to": "Cepleniţa hc.",
					"leavesAt": "20:24",
					"arrivesAt": "20:28",
					"waitsAtSource": 60,
					"distance": 3700
				},
				{
					"from": "Cepleniţa hc.",
					"to": "Bădeni hc.",
					"leavesAt": "20:29",
					"arrivesAt": "20:34",
					"waitsAtSource": 60,
					"distance": 3200
				},
				{
					"from": "Bădeni hc.",
					"to": "Hârlău",
					"leavesAt": "20:35",
					"arrivesAt": "20:40",
					"waitsAtSource": 60,
					"distance": 2600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14358",
			"segments": [
				{
					"from": "Sânnicolau Mare",
					"to": "Saravale h.",
					"leavesAt": "04:01",
					"arrivesAt": "04:11",
					"waitsAtSource": 0,
					"distance": 7600
				},
				{
					"from": "Saravale h.",
					"to": "Sânpetru h.",
					"leavesAt": "04:12",
					"arrivesAt": "04:20",
					"waitsAtSource": 60,
					"distance": 6100
				},
				{
					"from": "Sânpetru h.",
					"to": "Periam",
					"leavesAt": "04:21",
					"arrivesAt": "04:27",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Periam",
					"to": "Aranca h.",
					"leavesAt": "04:36",
					"arrivesAt": "04:46",
					"waitsAtSource": 540,
					"distance": 11100
				},
				{
					"from": "Aranca h.",
					"to": "Secusigiu h",
					"leavesAt": "04:47",
					"arrivesAt": "04:50",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Secusigiu h",
					"to": "Munor h.",
					"leavesAt": "04:52",
					"arrivesAt": "04:56",
					"waitsAtSource": 120,
					"distance": 2800
				},
				{
					"from": "Munor h.",
					"to": "Sânpetru German h.",
					"leavesAt": "04:58",
					"arrivesAt": "05:02",
					"waitsAtSource": 120,
					"distance": 2600
				},
				{
					"from": "Sânpetru German h.",
					"to": "Felnac hc.",
					"leavesAt": "05:03",
					"arrivesAt": "05:10",
					"waitsAtSource": 60,
					"distance": 6700
				},
				{
					"from": "Felnac hc.",
					"to": "Bodrogu Nou h.",
					"leavesAt": "05:12",
					"arrivesAt": "05:18",
					"waitsAtSource": 120,
					"distance": 5200
				},
				{
					"from": "Bodrogu Nou h.",
					"to": "Zădăreni Hm.",
					"leavesAt": "05:20",
					"arrivesAt": "05:24",
					"waitsAtSource": 120,
					"distance": 1900
				},
				{
					"from": "Zădăreni Hm.",
					"to": "Aradu Nou",
					"leavesAt": "05:26",
					"arrivesAt": "05:36",
					"waitsAtSource": 120,
					"distance": 9600
				},
				{
					"from": "Aradu Nou",
					"to": "Arad",
					"leavesAt": "05:40",
					"arrivesAt": "05:47",
					"waitsAtSource": 240,
					"distance": 6200
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14321",
			"segments": [
				{
					"from": "Lovrin",
					"to": "Gotlob h.",
					"leavesAt": "16:01",
					"arrivesAt": "16:07",
					"waitsAtSource": 0,
					"distance": 6400
				},
				{
					"from": "Gotlob h.",
					"to": "Comloşu Mare h.",
					"leavesAt": "16:08",
					"arrivesAt": "16:15",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Comloşu Mare h.",
					"to": "Teremia Banat hc.",
					"leavesAt": "16:16",
					"arrivesAt": "16:25",
					"waitsAtSource": 30,
					"distance": 9200
				},
				{
					"from": "Teremia Banat hc.",
					"to": "Nerău hcv.",
					"leavesAt": "16:26",
					"arrivesAt": "16:33",
					"waitsAtSource": 30,
					"distance": 4500
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14978",
			"segments": [
				{
					"from": "Urziceni",
					"to": "Bărbuleşti h.",
					"leavesAt": "15:30",
					"arrivesAt": "15:34",
					"waitsAtSource": 0,
					"distance": 3500
				},
				{
					"from": "Bărbuleşti h.",
					"to": "Armăşeşti Hm.",
					"leavesAt": "15:35",
					"arrivesAt": "15:40",
					"waitsAtSource": 30,
					"distance": 3400
				},
				{
					"from": "Armăşeşti Hm.",
					"to": "Ialomiţa Hm.",
					"leavesAt": "15:41",
					"arrivesAt": "15:47",
					"waitsAtSource": 60,
					"distance": 5000
				},
				{
					"from": "Ialomiţa Hm.",
					"to": "Fulga hc.",
					"leavesAt": "15:48",
					"arrivesAt": "15:54",
					"waitsAtSource": 60,
					"distance": 6500
				},
				{
					"from": "Fulga hc.",
					"to": "Ciorani Hm.",
					"leavesAt": "15:55",
					"arrivesAt": "16:01",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Ciorani Hm.",
					"to": "Hătcărău h.",
					"leavesAt": "16:02",
					"arrivesAt": "16:07",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Hătcărău h.",
					"to": "Drăgăneşti Prahova Hm.",
					"leavesAt": "16:08",
					"arrivesAt": "16:12",
					"waitsAtSource": 30,
					"distance": 2500
				},
				{
					"from": "Drăgăneşti Prahova Hm.",
					"to": "Cornurile h.",
					"leavesAt": "16:13",
					"arrivesAt": "16:17",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Cornurile h.",
					"to": "Zănoaga Hm.",
					"leavesAt": "16:18",
					"arrivesAt": "16:23",
					"waitsAtSource": 30,
					"distance": 4700
				},
				{
					"from": "Zănoaga Hm.",
					"to": "Trestieni h.",
					"leavesAt": "16:24",
					"arrivesAt": "16:27",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Trestieni h.",
					"to": "Râfov h.",
					"leavesAt": "16:28",
					"arrivesAt": "16:32",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Râfov h.",
					"to": "Corlăteşti Hm.",
					"leavesAt": "16:33",
					"arrivesAt": "16:36",
					"waitsAtSource": 30,
					"distance": 1900
				},
				{
					"from": "Corlăteşti Hm.",
					"to": "Dâmbu Hm.",
					"leavesAt": "16:37",
					"arrivesAt": "16:42",
					"waitsAtSource": 60,
					"distance": 4500
				},
				{
					"from": "Dâmbu Hm.",
					"to": "Ploieşti Sud",
					"leavesAt": "16:43",
					"arrivesAt": "16:48",
					"waitsAtSource": 60,
					"distance": 3600
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14447",
			"segments": [
				{
					"from": "Arad",
					"to": "Utvinişu Nou",
					"leavesAt": "14:08",
					"arrivesAt": "14:16",
					"waitsAtSource": 0,
					"distance": 6500
				},
				{
					"from": "Utvinişu Nou",
					"to": "Zimandu Nou h.",
					"leavesAt": "14:17",
					"arrivesAt": "14:23",
					"waitsAtSource": 60,
					"distance": 6300
				},
				{
					"from": "Zimandu Nou h.",
					"to": "Sântana",
					"leavesAt": "14:24",
					"arrivesAt": "14:34",
					"waitsAtSource": 30,
					"distance": 10700
				},
				{
					"from": "Sântana",
					"to": "Şiria Hm.",
					"leavesAt": "14:35",
					"arrivesAt": "14:47",
					"waitsAtSource": 60,
					"distance": 11900
				},
				{
					"from": "Şiria Hm.",
					"to": "Mâsca Măderat h.",
					"leavesAt": "14:48",
					"arrivesAt": "14:52",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Mâsca Măderat h.",
					"to": "Pâncota h.",
					"leavesAt": "14:53",
					"arrivesAt": "14:56",
					"waitsAtSource": 60,
					"distance": 2700
				},
				{
					"from": "Pâncota h.",
					"to": "Seleuş h.",
					"leavesAt": "14:57",
					"arrivesAt": "15:01",
					"waitsAtSource": 60,
					"distance": 3300
				},
				{
					"from": "Seleuş h.",
					"to": "Târnova Zărand Hm.",
					"leavesAt": "15:02",
					"arrivesAt": "15:09",
					"waitsAtSource": 30,
					"distance": 7200
				},
				{
					"from": "Târnova Zărand Hm.",
					"to": "Mocrea h.",
					"leavesAt": "15:10",
					"arrivesAt": "15:15",
					"waitsAtSource": 60,
					"distance": 6200
				},
				{
					"from": "Mocrea h.",
					"to": "Ineu",
					"leavesAt": "15:16",
					"arrivesAt": "15:21",
					"waitsAtSource": 30,
					"distance": 4600
				},
				{
					"from": "Ineu",
					"to": "Tămand h.",
					"leavesAt": "15:40",
					"arrivesAt": "15:48",
					"waitsAtSource": 1140,
					"distance": 8400
				},
				{
					"from": "Tămand h.",
					"to": "Bocsig  h",
					"leavesAt": "15:49",
					"arrivesAt": "15:53",
					"waitsAtSource": 60,
					"distance": 3600
				},
				{
					"from": "Bocsig  h",
					"to": "Răpsig h.",
					"leavesAt": "15:54",
					"arrivesAt": "16:00",
					"waitsAtSource": 60,
					"distance": 5200
				},
				{
					"from": "Răpsig h.",
					"to": "Sebiş",
					"leavesAt": "16:01",
					"arrivesAt": "16:11",
					"waitsAtSource": 60,
					"distance": 10000
				},
				{
					"from": "Sebiş",
					"to": "Paulian h.",
					"leavesAt": "16:31",
					"arrivesAt": "16:36",
					"waitsAtSource": 1200,
					"distance": 4900
				},
				{
					"from": "Paulian h.",
					"to": "Joia Mare hc.",
					"leavesAt": "16:37",
					"arrivesAt": "16:41",
					"waitsAtSource": 60,
					"distance": 4100
				},
				{
					"from": "Joia Mare hc.",
					"to": "Almaş h.",
					"leavesAt": "16:42",
					"arrivesAt": "16:47",
					"waitsAtSource": 60,
					"distance": 5300
				},
				{
					"from": "Almaş h.",
					"to": "Bonţeşti h.",
					"leavesAt": "16:48",
					"arrivesAt": "16:53",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Bonţeşti h.",
					"to": "Gurahonţ",
					"leavesAt": "16:54",
					"arrivesAt": "16:58",
					"waitsAtSource": 60,
					"distance": 2900
				},
				{
					"from": "Gurahonţ",
					"to": "Romaniţa h.",
					"leavesAt": "17:02",
					"arrivesAt": "17:10",
					"waitsAtSource": 240,
					"distance": 6100
				},
				{
					"from": "Romaniţa h.",
					"to": "Aciuţa h.",
					"leavesAt": "17:11",
					"arrivesAt": "17:15",
					"waitsAtSource": 30,
					"distance": 2600
				},
				{
					"from": "Aciuţa h.",
					"to": "Tălagiu h.",
					"leavesAt": "17:16",
					"arrivesAt": "17:22",
					"waitsAtSource": 60,
					"distance": 5400
				},
				{
					"from": "Tălagiu h.",
					"to": "Vârfurile Hm.",
					"leavesAt": "17:23",
					"arrivesAt": "17:29",
					"waitsAtSource": 30,
					"distance": 4500
				},
				{
					"from": "Vârfurile Hm.",
					"to": "Cariera Leasa h.",
					"leavesAt": "17:45",
					"arrivesAt": "17:49",
					"waitsAtSource": 960,
					"distance": 3600
				},
				{
					"from": "Cariera Leasa h.",
					"to": "Hălmagiu Hm.",
					"leavesAt": "17:50",
					"arrivesAt": "17:55",
					"waitsAtSource": 30,
					"distance": 3900
				},
				{
					"from": "Hălmagiu Hm.",
					"to": "Ocişor h.",
					"leavesAt": "17:56",
					"arrivesAt": "18:01",
					"waitsAtSource": 60,
					"distance": 4400
				},
				{
					"from": "Ocişor h.",
					"to": "Ociu h.",
					"leavesAt": "18:02",
					"arrivesAt": "18:05",
					"waitsAtSource": 60,
					"distance": 2000
				},
				{
					"from": "Ociu h.",
					"to": "Vaţa h.",
					"leavesAt": "18:06",
					"arrivesAt": "18:11",
					"waitsAtSource": 60,
					"distance": 4000
				},
				{
					"from": "Vaţa h.",
					"to": "Birtin h.",
					"leavesAt": "18:12",
					"arrivesAt": "18:18",
					"waitsAtSource": 60,
					"distance": 4800
				},
				{
					"from": "Birtin h.",
					"to": "Lunca Moţilor h.",
					"leavesAt": "18:19",
					"arrivesAt": "18:24",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Lunca Moţilor h.",
					"to": "Baia de Criş h.",
					"leavesAt": "18:25",
					"arrivesAt": "18:28",
					"waitsAtSource": 60,
					"distance": 2400
				},
				{
					"from": "Baia de Criş h.",
					"to": "Ţebea h",
					"leavesAt": "18:29",
					"arrivesAt": "18:32",
					"waitsAtSource": 30,
					"distance": 2100
				},
				{
					"from": "Ţebea h",
					"to": "Ribiţa h.",
					"leavesAt": "18:33",
					"arrivesAt": "18:36",
					"waitsAtSource": 60,
					"distance": 2300
				},
				{
					"from": "Ribiţa h.",
					"to": "Brad",
					"leavesAt": "18:37",
					"arrivesAt": "18:43",
					"waitsAtSource": 60,
					"distance": 3400
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		},
		{
			"type": "R",
			"operator": "RGT",
			"number": "14714",
			"segments": [
				{
					"from": "Zărneşti",
					"to": "G-ral T.Moşoiu hc.",
					"leavesAt": "18:35",
					"arrivesAt": "18:38",
					"waitsAtSource": 0,
					"distance": 1800
				},
				{
					"from": "G-ral T.Moşoiu hc.",
					"to": "Tohanu Vechi hc.",
					"leavesAt": "18:39",
					"arrivesAt": "18:41",
					"waitsAtSource": 60,
					"distance": 2200
				},
				{
					"from": "Tohanu Vechi hc.",
					"to": "Râşnov h.",
					"leavesAt": "18:42",
					"arrivesAt": "18:47",
					"waitsAtSource": 30,
					"distance": 5400
				},
				{
					"from": "Râşnov h.",
					"to": "Râşnov",
					"leavesAt": "18:48",
					"arrivesAt": "18:51",
					"waitsAtSource": 30,
					"distance": 1800
				},
				{
					"from": "Râşnov",
					"to": "Cristian Hm.",
					"leavesAt": "18:52",
					"arrivesAt": "18:56",
					"waitsAtSource": 60,
					"distance": 3400
				},
				{
					"from": "Cristian Hm.",
					"to": "Lustic h.",
					"leavesAt": "18:57",
					"arrivesAt": "19:00",
					"waitsAtSource": 60,
					"distance": 2600
				},
				{
					"from": "Lustic h.",
					"to": "Bartolomeu",
					"leavesAt": "19:01",
					"arrivesAt": "19:08",
					"waitsAtSource": 30,
					"distance": 6700
				},
				{
					"from": "Bartolomeu",
					"to": "Braşov",
					"leavesAt": "19:09",
					"arrivesAt": "19:15",
					"waitsAtSource": 60,
					"distance": 3100
				}
			],
			"restrictions": [
				{
					"from": "20161211",
					"to": "20171209",
					"daysOfWeek": 16767
				}
			]
		}
	];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(31),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(354),
	    hashDelete = __webpack_require__(355),
	    hashGet = __webpack_require__(356),
	    hashHas = __webpack_require__(357),
	    hashSet = __webpack_require__(358);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(31),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(31),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 301 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 302 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 303 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(313);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to search.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 305 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to search.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(310),
	    createBaseEach = __webpack_require__(340);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 307 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(91),
	    isFlattenable = __webpack_require__(364);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(341);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(309),
	    keys = __webpack_require__(21);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(91),
	    isArray = __webpack_require__(10);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 312 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(360);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(149),
	    arrayIncludes = __webpack_require__(304),
	    arrayIncludesWith = __webpack_require__(305),
	    arrayMap = __webpack_require__(52),
	    baseUnary = __webpack_require__(325),
	    cacheHas = __webpack_require__(326);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(89),
	    equalArrays = __webpack_require__(170),
	    equalByTag = __webpack_require__(346),
	    equalObjects = __webpack_require__(347),
	    getTag = __webpack_require__(175),
	    isArray = __webpack_require__(10),
	    isHostObject = __webpack_require__(96),
	    isTypedArray = __webpack_require__(406);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(89),
	    baseIsEqual = __webpack_require__(160);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(62),
	    isHostObject = __webpack_require__(96),
	    isMasked = __webpack_require__(368),
	    isObject = __webpack_require__(18),
	    toSource = __webpack_require__(184);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(316),
	    getMatchData = __webpack_require__(351),
	    matchesStrictComparable = __webpack_require__(179);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(160),
	    get = __webpack_require__(402),
	    hasIn = __webpack_require__(403),
	    isKey = __webpack_require__(60),
	    isStrictComparable = __webpack_require__(177),
	    matchesStrictComparable = __webpack_require__(179),
	    toKey = __webpack_require__(41);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(158);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 321 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(306);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 323 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(90),
	    isSymbol = __webpack_require__(43);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 325 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing wrapper metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 326 */
/***/ function(module, exports) {

	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(102);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(321);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },
/* 329 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 330 */
/***/ function(module, exports) {

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(94);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(301),
	    arrayReduce = __webpack_require__(153),
	    mapToArray = __webpack_require__(178);
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 333 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(302),
	    arrayReduce = __webpack_require__(153),
	    setToArray = __webpack_require__(182);
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(90);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(94);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(167),
	    getSymbols = __webpack_require__(174);
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 339 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(42);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 341 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var createCtorWrapper = __webpack_require__(57),
	    root = __webpack_require__(11);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBaseWrapper(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBaseWrapper;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(51),
	    createCtorWrapper = __webpack_require__(57),
	    createHybridWrapper = __webpack_require__(168),
	    createRecurryWrapper = __webpack_require__(169),
	    getHolder = __webpack_require__(172),
	    replaceHolders = __webpack_require__(97),
	    root = __webpack_require__(11);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurryWrapper(func, bitmask, arity) {
	  var Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurryWrapper(
	        func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurryWrapper;


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(55),
	    isArrayLike = __webpack_require__(42),
	    keys = __webpack_require__(21);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    predicate = baseIteratee(predicate, 3);
	    if (!isArrayLike(collection)) {
	      var props = keys(collection);
	    }
	    var index = findIndexFunc(props || collection, function(value, key) {
	      if (props) {
	        key = value;
	        value = iterable[key];
	      }
	      return predicate(value, key, iterable);
	    }, fromIndex);
	    return index > -1 ? collection[props ? props[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(51),
	    createCtorWrapper = __webpack_require__(57),
	    root = __webpack_require__(11);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartialWrapper(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartialWrapper;


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(90),
	    Uint8Array = __webpack_require__(150),
	    equalArrays = __webpack_require__(170),
	    mapToArray = __webpack_require__(178),
	    setToArray = __webpack_require__(182);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and
	      // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	      // not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object) ? other != +other : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	      stack.set(object, other);
	
	      // Recursively compare objects (susceptible to call stack limits).
	      return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(159),
	    keys = __webpack_require__(21);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : baseHas(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(311),
	    getSymbols = __webpack_require__(174),
	    keys = __webpack_require__(21);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(380);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(93);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(177),
	    keys = __webpack_require__(21);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 352 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(164),
	    isArguments = __webpack_require__(101),
	    isArray = __webpack_require__(10),
	    isIndex = __webpack_require__(59),
	    isKey = __webpack_require__(60),
	    isLength = __webpack_require__(63),
	    isString = __webpack_require__(187),
	    toKey = __webpack_require__(41);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isString(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(61);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	module.exports = hashClear;


/***/ },
/* 355 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(61);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(61);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(61);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(163),
	    isArguments = __webpack_require__(101),
	    isArray = __webpack_require__(10),
	    isLength = __webpack_require__(63),
	    isString = __webpack_require__(187);
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	module.exports = indexKeys;


/***/ },
/* 360 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 361 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(94),
	    cloneDataView = __webpack_require__(331),
	    cloneMap = __webpack_require__(332),
	    cloneRegExp = __webpack_require__(333),
	    cloneSet = __webpack_require__(334),
	    cloneSymbol = __webpack_require__(335),
	    cloneTypedArray = __webpack_require__(336);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(54),
	    getPrototype = __webpack_require__(173),
	    isPrototype = __webpack_require__(176);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(101),
	    isArray = __webpack_require__(10);
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(98),
	    isArrayLike = __webpack_require__(42),
	    isIndex = __webpack_require__(59),
	    isObject = __webpack_require__(18);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 366 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(87),
	    getData = __webpack_require__(171),
	    getFuncName = __webpack_require__(349),
	    lodash = __webpack_require__(424);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(338);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 369 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	module.exports = listCacheClear;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(53);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(53);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(53);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(53);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(298),
	    ListCache = __webpack_require__(50),
	    Map = __webpack_require__(148);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(58);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(58);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(58);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(58);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(165),
	    composeArgsRight = __webpack_require__(166),
	    replaceHolders = __webpack_require__(97);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	    ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 380 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(56),
	    isIndex = __webpack_require__(59);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 382 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 383 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(50);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	module.exports = stackClear;


/***/ },
/* 385 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 387 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(50),
	    MapCache = __webpack_require__(88);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(87),
	    LodashWrapper = __webpack_require__(147),
	    copyArray = __webpack_require__(56);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(95);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var ARY_FLAG = 128;
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments,
	 * ignoring any additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	}
	
	module.exports = ary;


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(157);
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, false, true);
	}
	
	module.exports = clone;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(95);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(344),
	    findIndex = __webpack_require__(394);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to search.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(307),
	    baseIteratee = __webpack_require__(55),
	    toInteger = __webpack_require__(65);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var mapping = __webpack_require__(396),
	    mutateMap = mapping.mutate,
	    fallbackHolder = __webpack_require__(26);
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function immutWrap(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return result;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var setPlaceholder,
	      isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      placeholder = isLib ? func : fallbackHolder,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isFunction': util.isFunction,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'spread': util.spread,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isFunction = helpers.isFunction,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      spread = helpers.spread,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null) {
	        nested[path[index]] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var oldOptions = options;
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[name] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, name, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument passed
	   * thru `transform`.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {...Function} transform The functions to transform the first argument.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func) {
	    name = mapping.aliasToReal[name] || name;
	
	    var result,
	        wrapped = func,
	        wrapper = wrappers[name];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mutateMap.array[name]) {
	        wrapped = immutWrap(func, cloneArray);
	      }
	      else if (mutateMap.object[name]) {
	        wrapped = immutWrap(func, createCloner(func));
	      }
	      else if (mutateMap.set[name]) {
	        wrapped = immutWrap(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (name == otherName) {
	          var aryN = !isLib && mapping.iterateeAry[name],
	              reargIndexes = mapping.iterateeRearg[name],
	              spreadStart = mapping.methodSpread[name];
	
	          result = wrapped;
	          if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	            result = spreadStart === undefined
	              ? ary(result, aryKey)
	              : spread(result, spreadStart);
	          }
	          if (config.rearg && aryKey > 1 && (forceRearg || !mapping.skipRearg[name])) {
	            result = rearg(result, mapping.methodRearg[name] || mapping.aryRearg[aryKey]);
	          }
	          if (config.cap) {
	            if (reargIndexes) {
	              result = iterateeRearg(result, reargIndexes);
	            } else if (aryN) {
	              result = iterateeAry(result, aryN);
	            }
	          }
	          if (forceCurry || (config.curry && aryKey > 1)) {
	            forceCurry  && console.log(forceCurry, name);
	            result = curry(result, aryKey);
	          }
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(name, func);
	    if (mapping.placeholder[name]) {
	      setPlaceholder = true;
	      result.placeholder = func.placeholder = placeholder;
	    }
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  if (setPlaceholder) {
	    _.placeholder = placeholder;
	  }
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ },
/* 396 */
/***/ function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'whereEq': 'filter',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'attempt', 'castArray', 'ceil', 'create', 'curry', 'curryRight', 'floor',
	    'flow', 'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method',
	    'methodOf', 'mixin', 'over', 'overEvery', 'overSome', 'rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignIn', 'at', 'before', 'bind', 'bindAll',
	    'bindKey', 'chunk', 'cloneDeepWith', 'cloneWith', 'concat', 'countBy', 'curryN',
	    'curryRightN', 'debounce', 'defaults', 'defaultsDeep', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith',
	    'eq', 'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast',
	    'findLastIndex', 'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth',
	    'forEach', 'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight',
	    'get', 'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf',
	    'intersection', 'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch',
	    'join', 'keyBy', 'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues',
	    'matchesProperty', 'maxBy', 'meanBy', 'merge', 'minBy', 'multiply', 'nth',
	    'omit', 'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt',
	    'partial', 'partialRight', 'partition', 'pick', 'pickBy', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'reduce', 'reduceRight', 'replace',
	    'set', 'slice', 'sortedIndexBy', 'sortedLastIndexBy', 'transform', 'unionBy',
	    'unionWith', 'update', 'xorBy', 'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInWith': [1, 2, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'invokeArgs': 2,
	  'invokeArgsMap': 2,
	  'partial': 1,
	  'partialRight': 1,
	  'without': 1
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignIn': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsDeep': true,
	    'merge': true,
	    'mergeWith': true
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to track methods with placeholder support */
	exports.placeholder = {
	  'bind': true,
	  'bindKey': true,
	  'curry': true,
	  'curryRight': true,
	  'partial': true,
	  'partialRight': true
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true
	};


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'ary': __webpack_require__(390),
	  'assign': __webpack_require__(156),
	  'clone': __webpack_require__(391),
	  'curry': __webpack_require__(392),
	  'forEach': __webpack_require__(152),
	  'isArray': __webpack_require__(10),
	  'isFunction': __webpack_require__(62),
	  'iteratee': __webpack_require__(407),
	  'keys': __webpack_require__(161),
	  'rearg': __webpack_require__(413),
	  'spread': __webpack_require__(415),
	  'toPath': __webpack_require__(421)
	};


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(32),
	    func = convert('find', __webpack_require__(393));
	
	func.placeholder = __webpack_require__(26);
	module.exports = func;


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(32),
	    func = convert('intersection', __webpack_require__(404));
	
	func.placeholder = __webpack_require__(26);
	module.exports = func;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(32),
	    func = convert('some', __webpack_require__(414));
	
	func.placeholder = __webpack_require__(26);
	module.exports = func;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(32),
	    func = convert('zip', __webpack_require__(425));
	
	func.placeholder = __webpack_require__(26);
	module.exports = func;


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(158);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is used in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(312),
	    hasPath = __webpack_require__(353);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(52),
	    baseIntersection = __webpack_require__(314),
	    castArrayLikeObject = __webpack_require__(327),
	    rest = __webpack_require__(64);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons. The order of result values is determined by the
	 * order they occur in the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = rest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(11),
	    stubFalse = __webpack_require__(417);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = !Buffer ? stubFalse : function(value) {
	  return value instanceof Buffer;
	};
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(229)(module)))

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(63),
	    isObjectLike = __webpack_require__(33);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(157),
	    baseIteratee = __webpack_require__(55);
	
	/**
	 * Creates a function that invokes `func` with the arguments of the created
	 * function. If `func` is a property name, the created function returns the
	 * property value for a given element. If `func` is an array or object, the
	 * created function returns `true` for elements that contain the equivalent
	 * source properties, otherwise it returns `false`.
	 *
	 * @static
	 * @since 4.0.0
	 * @memberOf _
	 * @category Util
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @returns {Function} Returns the callback.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, _.iteratee(['user', 'fred']));
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, _.iteratee('user'));
	 * // => ['barney', 'fred']
	 *
	 * // Create custom iteratee shorthands.
	 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	 *     return func.test(string);
	 *   };
	 * });
	 *
	 * _.filter(['abc', 'def'], /ef/);
	 * // => ['def']
	 */
	function iteratee(func) {
	  return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	}
	
	module.exports = iteratee;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash <https://lodash.com/>
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.13.1';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(\.|\[\])(?:\4|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match non-compound words composed of alphanumeric characters. */
	  var reBasicWord = /[a-zA-Z0-9]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0x/i;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reComplexWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	    rsUpper + '+' + rsOptUpperContr,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasComplexWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'Reflect', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError',
	    'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	  /** Detect free variable `self`. */
	  var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	  /** Detect `this` as the global object. */
	  var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    var length = args.length;
	    switch (length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array ? array.length : 0;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to search.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array ? array.length : 0;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to search.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array ? array.length : 0;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing wrapper metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a cache value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Checks if `value` is a global object.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	   */
	  function checkGlobal(value) {
	    return (value && value.Object === Object) ? value : null;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        result++;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    if (!(string && reHasComplexSymbol.test(string))) {
	      return string.length;
	    }
	    var result = reComplexSymbol.lastIndex = 0;
	    while (reComplexSymbol.test(string)) {
	      result++;
	    }
	    return result;
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return string.match(reComplexSymbol);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Use `context` to stub `Date#getTime` use in `_.now`.
	   * var stubbed = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': stubGetTime };
	   *   }
	   * });
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Date = context.Date,
	        Error = context.Error,
	        Math = context.Math,
	        RegExp = context.RegExp,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = context.Array.prototype,
	        objectProto = context.Object.prototype,
	        stringProto = context.String.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = context.Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Reflect = context.Reflect,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        enumerate = Reflect ? Reflect.enumerate : undefined,
	        getOwnPropertySymbols = Object.getOwnPropertySymbols,
	        iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice;
	
	    /** Built-in method references that are mockable. */
	    var setTimeout = function(func, wait) { return context.setTimeout.call(root, func, wait); };
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetPrototype = Object.getPrototypeOf,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = Object.keys,
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReplace = stringProto.replace,
	        nativeReverse = arrayProto.reverse,
	        nativeSplit = stringProto.split;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	    var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `divide`, `each`,
	     * `eachRight`, `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`,
	     * `findIndex`, `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`,
	     * `floor`, `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`,
	     * `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`,
	     * `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`,
	     * `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`,
	     * `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`,
	     * `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`,
	     * `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      return getMapData(this, key)['delete'](key);
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      getMapData(this, key).set(key, value);
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      this.__data__ = new ListCache(entries);
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      return this.__data__['delete'](key);
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var cache = this.__data__;
	      if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	        cache = this.__data__ = new MapCache(cache.__data__);
	      }
	      cache.set(key, value);
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (typeof key == 'number' && value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to search.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (!isArr) {
	        var props = isFull ? getAllKeys(value) : keys(value);
	      }
	      // Recursively populate clone (susceptible to call stack limits).
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source),
	          length = props.length;
	
	      return function(object) {
	        if (object == null) {
	          return !length;
	        }
	        var index = length;
	        while (index--) {
	          var key = props[index],
	              predicate = source[key],
	              value = object[key];
	
	          if ((value === undefined &&
	              !(key in Object(object))) || !predicate(value)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(proto) {
	      return isObject(proto) ? objectCreate(proto) : {};
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an array
	     * of `func` arguments.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments to provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	      // that are composed entirely of index properties, return `false` for
	      // `hasOwnProperty` checks of them.
	      return object != null &&
	        (hasOwnProperty.call(object, key) ||
	          (typeof object == 'object' && key in object && getPrototype(object) === null));
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = castPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[toKey(path)];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      return nativeKeys(Object(object));
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      object = object == null ? object : Object(object);
	
	      var result = [];
	      for (var key in object) {
	        result.push(key);
	      }
	      return result;
	    }
	
	    // Fallback for IE < 9 with es6-shim.
	    if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	      baseKeysIn = function(object) {
	        return iteratorToArray(enumerate(object));
	      };
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      if (!(isArray(source) || isTypedArray(source))) {
	        var props = keysIn(source);
	      }
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      });
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        newValue = srcValue;
	        if (isArray(srcValue) || isTypedArray(srcValue)) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	          else {
	            newValue = objValue;
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      stack.set(srcValue, newValue);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	      }
	      stack['delete'](srcValue);
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce `n` to an integer.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return arrayReduce(props, function(result, key) {
	        if (key in object) {
	          result[key] = object[key];
	        }
	        return result;
	      }, {});
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, predicate) {
	      var index = -1,
	          props = getAllKeysIn(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          result[key] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = castPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[toKey(last(path))];
	            }
	          }
	          else {
	            delete array[toKey(index)];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]);
	        if (isObject(nested)) {
	          var newValue = value;
	          if (index != lastIndex) {
	            var objValue = nested[key];
	            newValue = customizer ? customizer(objValue, key, nested) : undefined;
	            if (newValue === undefined) {
	              newValue = objValue == null
	                ? (isIndex(path[index + 1]) ? [] : {})
	                : objValue;
	            }
	          }
	          assignValue(nested, key, newValue);
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	      object = parent(object, path);
	
	      var key = toKey(last(path));
	      return !(object != null && baseHas(object, key)) || delete object[key];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var result = new buffer.constructor(buffer.length);
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : source[key];
	
	        assignValue(object, key, newValue);
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return rest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBaseWrapper(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = reHasComplexSymbol.test(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurryWrapper(func, bitmask, arity) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        predicate = getIteratee(predicate, 3);
	        if (!isArrayLike(collection)) {
	          var props = keys(collection);
	        }
	        var index = findIndexFunc(props || collection, function(value, key) {
	          if (props) {
	            key = value;
	            value = iterable[key];
	          }
	          return predicate(value, key, iterable);
	        }, fromIndex);
	        return index > -1 ? collection[props ? props[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return rest(function(funcs) {
	        funcs = baseFlatten(funcs, 1);
	
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return 0;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return rest(function(iteratees) {
	        iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	          ? arrayMap(iteratees[0], baseUnary(getIteratee()))
	          : arrayMap(baseFlatten(iteratees, 1, isFlattenableIteratee), baseUnary(getIteratee()));
	
	        return rest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return reHasComplexSymbol.test(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toNumber(start);
	        start = start === start ? start : 0;
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toNumber(end) || 0;
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     *   512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBaseWrapper(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurryWrapper(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartialWrapper(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!seen.has(othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	                  return seen.add(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and
	          // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	          // not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object) ? other != +other : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	          stack.set(object, other);
	
	          // Recursively compare objects (susceptible to call stack limits).
	          return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : baseHas(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      return result;
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a
	     * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	     * Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the `[[Prototype]]` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {null|Object} Returns the `[[Prototype]]`.
	     */
	    function getPrototype(value) {
	      return nativeGetPrototype(Object(value));
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    function getSymbols(object) {
	      // Coerce `object` to an object to avoid non-object errors in V8.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	      return getOwnPropertySymbols(Object(object));
	    }
	
	    // Fallback for IE < 11.
	    if (!getOwnPropertySymbols) {
	      getSymbols = stubArray;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !getOwnPropertySymbols ? getSymbols : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function getTag(value) {
	      return objectToString.call(value);
	    }
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11,
	    // for data views in Edge, and promises in Node.js.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var result,
	          index = -1,
	          length = path.length;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result) {
	        return result;
	      }
	      var length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isString(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Creates an array of index keys for `object` values of arrays,
	     * `arguments` objects, and strings, otherwise `null` is returned.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array|null} Returns index keys, else `null`.
	     */
	    function indexKeys(object) {
	      var length = object ? object.length : undefined;
	      if (isLength(length) &&
	          (isArray(object) || isString(object) || isArguments(object))) {
	        return baseTimes(length, String);
	      }
	      return null;
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value);
	    }
	
	    /**
	     * Checks if `value` is a flattenable array and not a `_.matchesProperty`
	     * iteratee shorthand.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenableIteratee(value) {
	      return isArray(value) && !(value.length == 2 && !isFunction(value[0]));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack.set(srcValue, objValue));
	      }
	      return objValue;
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoize(function(string) {
	      var result = [];
	      toString(string).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length,
	          args = Array(length ? length - 1 : 0),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return length
	        ? arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other given
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = rest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. Result values
	     * are chosen from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = rest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = rest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = rest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. Result values are chosen
	     * from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = rest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = (
	          index < 0
	            ? nativeMax(length + index, 0)
	            : nativeMin(index, length - 1)
	        ) + 1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index - 1, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = rest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = rest(function(array, indexes) {
	      indexes = baseFlatten(indexes, 1);
	
	      var length = array ? array.length : 0,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = rest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each
	     * element is kept.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = rest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = rest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = rest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = rest(function(paths) {
	      paths = baseFlatten(paths, 1);
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _([1, 2]).forEach(function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function, it's
	     * invoked for and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = rest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getIteratee(predicate, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var array = isArrayLike(collection) ? collection : values(collection),
	          length = array.length;
	
	      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = baseClamp(toInteger(n), 0, length);
	      }
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sampleSize(collection, MAX_ARRAY_LENGTH);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        var result = collection.length;
	        return (result && isString(collection)) ? stringSize(collection) : result;
	      }
	      if (isObjectLike(collection)) {
	        var tag = getTag(collection);
	        if (tag == mapTag || tag == setTag) {
	          return collection.size;
	        }
	      }
	      return keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [iteratees=[_.identity]] The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, function(o) { return o.user; });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     *
	     * _.sortBy(users, 'user', function(o) {
	     *   return Math.floor(o.age / 10);
	     * });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    var sortBy = rest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	        ? iteratees[0]
	        : baseFlatten(iteratees, 1, isFlattenableIteratee);
	
	      return baseOrderBy(collection, iteratees, []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    function now() {
	      return Date.now();
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = rest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = rest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide an options object to indicate whether `func` should be invoked on
	     * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent calls
	     * to the debounced function return the result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one or more milliseconds.
	     */
	    var defer = rest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = rest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrapper(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with arguments transformed by
	     * corresponding `transforms`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [transforms[_.identity]] The functions to transform.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = rest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1, isFlattenableIteratee), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return rest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = rest(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, array);
	          case 1: return func.call(this, args[0], array);
	          case 2: return func.call(this, args[0], args[1], array);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = array;
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/6.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return rest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide an options object to indicate whether
	     * `func` should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @type {Function}
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    function isArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value)) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = !Buffer ? stubFalse : function(value) {
	      return value instanceof Buffer;
	    };
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element,
	     *  else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || isString(value) || isFunction(value.splice) ||
	            isArguments(value) || isBuffer(value))) {
	        return !value.length;
	      }
	      if (isObjectLike(value)) {
	        var tag = getTag(value);
	        if (tag == mapTag || tag == setTag) {
	          return !value.size;
	        }
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return !(nonEnumShadows && keys(value).length);
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object,
	     *  else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number,
	     *  else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8 which returns 'object' for typed array and weak map constructors,
	      // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length,
	     *  else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    function isMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values. This method is
	     * equivalent to a `_.matches` function when `source` is partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the
	     * presence of the `core-js` package because `core-js` circumvents this kind
	     * of detection. Despite multiple requests, the `core-js` maintainer has made
	     * it clear: any attempt to fix the detection will be obstructed. As a result,
	     * we're left with little choice but to throw an error. Unfortunately, this
	     * also affects packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on `core-js`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error('This method is not supported with `core-js`. Try https://github.com/es-shims.');
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object,
	     *  else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) ||
	          objectToString.call(value) != objectTag || isHostObject(value)) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer,
	     *  else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    function isSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = isFunction(value.valueOf) ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.c = 3;
	     * }
	     *
	     * function Bar() {
	     *   this.e = 5;
	     * }
	     *
	     * Foo.prototype.d = 4;
	     * Bar.prototype.f = 6;
	     *
	     * _.assign({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3, 'e': 5 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * function Bar() {
	     *   this.d = 4;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     * Bar.prototype.e = 5;
	     *
	     * _.assignIn({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keysIn(source), object);
	        return;
	      }
	      for (var key in source) {
	        assignValue(object, key, source[key]);
	      }
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = rest(function(object, paths) {
	      return baseAt(object, baseFlatten(paths, 1));
	    });
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = rest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = rest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = rest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      var isProto = isPrototype(object);
	      if (!(isProto || isArrayLike(object))) {
	        return baseKeys(object);
	      }
	      var indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      for (var key in object) {
	        if (baseHas(object, key) &&
	            !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(isProto && key == 'constructor')) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      var index = -1,
	          isProto = isPrototype(object),
	          props = baseKeysIn(object),
	          propsLength = props.length,
	          indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[iteratee(value, key, object)] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[key] = iteratee(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with seven arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = rest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(baseFlatten(props, 1), toKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      predicate = getIteratee(predicate);
	      return basePickBy(object, function(value, key) {
	        return !predicate(value, key);
	      });
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = rest(function(object, props) {
	      return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getIteratee(iteratee, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toNumber(start) || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toNumber(end) || 0;
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toNumber(lower) || 0;
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toNumber(upper) || 0;
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in IE < 9, they can break out of
	     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the
	     * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3109 for more details.
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = toString(string).replace(reTrim, '');
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : nativeReplace.call(string, args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (separator == '' && reHasComplexSymbol.test(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return nativeSplit.call(string, separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      return string.lastIndexOf(baseToString(target), position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (reHasComplexSymbol.test(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = rest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['onClick']);
	     * jQuery(element).on('click', view.onClick);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = rest(function(object, methodNames) {
	      arrayEach(baseFlatten(methodNames, 1), function(key) {
	        key = toKey(key);
	        object[key] = bind(object[key], object);
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.constant(true),                _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return rest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.filter(users, _.conforms({ 'age': function(n) { return n > 38; } }));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument given to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`. The created function is equivalent to
	     * `_.isMatch` with a `source` partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = rest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = rest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * A method that returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return rest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [iteratees=[_.identity]] The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [predicates=[_.identity]] The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [predicates=[_.identity]] The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * A method that returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * A method that returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * A method that returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * A method that returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * A method that returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    });
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    });
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    });
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    });
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.deburr = deburr;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = rest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      predicate = getIteratee(predicate, 3);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Expose Lodash on the free variable `window` or `self` when available so it's
	  // globally accessible, even when bundled with Browserify, Webpack, etc. This
	  // also prevents errors in cases where Lodash is loaded by a script tag in the
	  // presence of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch
	  // for more details. Use `_.noConflict` to remove Lodash from the global object.
	  (freeSelf || {})._ = _;
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(229)(module), (function() { return this; }())))

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(88);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 410 */
/***/ function(module, exports) {

	/**
	 * A method that returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 411 */
/***/ function(module, exports) {

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	function now() {
	  return Date.now();
	}
	
	module.exports = now;


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(93),
	    basePropertyDeep = __webpack_require__(320),
	    isKey = __webpack_require__(60),
	    toKey = __webpack_require__(41);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(308),
	    createWrapper = __webpack_require__(95),
	    rest = __webpack_require__(64);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var REARG_FLAG = 256;
	
	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified `indexes` where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, [2, 0, 1]);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = rest(function(func, indexes) {
	  return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	});
	
	module.exports = rearg;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(154),
	    baseIteratee = __webpack_require__(55),
	    baseSome = __webpack_require__(322),
	    isArray = __webpack_require__(10),
	    isIterateeCall = __webpack_require__(365);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(51),
	    arrayPush = __webpack_require__(91),
	    castSlice = __webpack_require__(328),
	    rest = __webpack_require__(64),
	    toInteger = __webpack_require__(65);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * create function and an array of arguments much like
	 * [`Function#apply`](http://www.ecma-international.org/ecma-262/6.0/#sec-function.prototype.apply).
	 *
	 * **Note:** This method is based on the
	 * [spread operator](https://mdn.io/spread_operator).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.2.0
	 * @category Function
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} [start=0] The start position of the spread.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.spread(function(who, what) {
	 *   return who + ' says ' + what;
	 * });
	 *
	 * say(['fred', 'hello']);
	 * // => 'fred says hello'
	 *
	 * var numbers = Promise.all([
	 *   Promise.resolve(40),
	 *   Promise.resolve(36)
	 * ]);
	 *
	 * numbers.then(_.spread(function(x, y) {
	 *   return x + y;
	 * }));
	 * // => a Promise of 76
	 */
	function spread(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	  return rest(function(args) {
	    var array = args[start],
	        otherArgs = castSlice(args, 0, start);
	
	    if (array) {
	      arrayPush(otherArgs, array);
	    }
	    return apply(func, this, otherArgs);
	  });
	}
	
	module.exports = spread;


/***/ },
/* 416 */
/***/ function(module, exports) {

	/**
	 * A method that returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 417 */
/***/ function(module, exports) {

	/**
	 * A method that returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(323),
	    identity = __webpack_require__(100);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(420);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(62),
	    isObject = __webpack_require__(18),
	    isSymbol = __webpack_require__(43);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(52),
	    copyArray = __webpack_require__(56),
	    isArray = __webpack_require__(10),
	    isSymbol = __webpack_require__(43),
	    stringToPath = __webpack_require__(183),
	    toKey = __webpack_require__(41);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	}
	
	module.exports = toPath;


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(324);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(303),
	    arrayMap = __webpack_require__(52),
	    baseProperty = __webpack_require__(93),
	    baseTimes = __webpack_require__(163),
	    isArrayLikeObject = __webpack_require__(102);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.zip` except that it accepts an array of grouped
	 * elements and creates an array regrouping the elements to their pre-zip
	 * configuration.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.2.0
	 * @category Array
	 * @param {Array} array The array of grouped elements to process.
	 * @returns {Array} Returns the new array of regrouped elements.
	 * @example
	 *
	 * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	 * // => [['fred', 30, true], ['barney', 40, false]]
	 *
	 * _.unzip(zipped);
	 * // => [['fred', 'barney'], [30, 40], [true, false]]
	 */
	function unzip(array) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  var length = 0;
	  array = arrayFilter(array, function(group) {
	    if (isArrayLikeObject(group)) {
	      length = nativeMax(group.length, length);
	      return true;
	    }
	  });
	  return baseTimes(length, function(index) {
	    return arrayMap(array, baseProperty(index));
	  });
	}
	
	module.exports = unzip;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(87),
	    LodashWrapper = __webpack_require__(147),
	    baseLodash = __webpack_require__(92),
	    isArray = __webpack_require__(10),
	    isObjectLike = __webpack_require__(33),
	    wrapperClone = __webpack_require__(389);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array of at least `200` elements
	 * and any iteratees accept only one argument. The heuristic for whether a
	 * section qualifies for shortcut fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `divide`, `each`,
	 * `eachRight`, `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`,
	 * `findIndex`, `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`,
	 * `floor`, `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`,
	 * `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`,
	 * `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`,
	 * `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`,
	 * `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`,
	 * `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`,
	 * `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var rest = __webpack_require__(64),
	    unzip = __webpack_require__(423);
	
	/**
	 * Creates an array of grouped elements, the first of which contains the
	 * first elements of the given arrays, the second of which contains the
	 * second elements of the given arrays, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to process.
	 * @returns {Array} Returns the new array of grouped elements.
	 * @example
	 *
	 * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	 * // => [['fred', 30, true], ['barney', 40, false]]
	 */
	var zip = rest(unzip);
	
	module.exports = zip;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(516);

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,r){ true?module.exports=r(__webpack_require__(1),__webpack_require__(288)):"function"==typeof define&&define.amd?define(["react","highcharts"],r):"object"==typeof exports?exports.ReactHighcharts=r(require("react"),require("highcharts")):t.ReactHighcharts=r(t.React,t.Highcharts)}(this,function(t,r){return function(t){function r(o){if(e[o])return e[o].exports;var n=e[o]={exports:{},id:o,loaded:!1};return t[o].call(n.exports,n,n.exports,r),n.loaded=!0,n.exports}var e={};return r.m=t,r.c=e,r.p="",r(0)}([function(t,r,e){t.exports=e(3)},function(r,e){r.exports=t},function(t,r,e){(function(r){"use strict";var o=Object.assign||function(t){for(var r=1;r<arguments.length;r++){var e=arguments[r];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t},n=e(1),i="undefined"==typeof r?window:r;t.exports=function(r,e){var c="Highcharts"+r,s=n.createClass({displayName:c,propTypes:{config:n.PropTypes.object.isRequired,isPureConfig:n.PropTypes.bool,neverReflow:n.PropTypes.bool,callback:n.PropTypes.func,domProps:n.PropTypes.object},defaultProps:{callback:function(){},domProps:{}},renderChart:function(t){var n=this;if(!t)throw new Error("Config must be specified for the "+c+" component");var s=t.chart;this.chart=new e[r](o({},t,{chart:o({},s,{renderTo:this.refs.chart})}),this.props.callback),this.props.neverReflow||i.requestAnimationFrame&&requestAnimationFrame(function(){n.chart&&n.chart.options&&n.chart.reflow()})},shouldComponentUpdate:function(t){return t.neverReflow||t.isPureConfig&&this.props.config===t.config?!0:(this.renderChart(t.config),!1)},getChart:function(){if(!this.chart)throw new Error("getChart() should not be called before the component is mounted");return this.chart},componentDidMount:function(){this.renderChart(this.props.config)},componentWillUnmount:function(){this.chart.destroy()},render:function(){return n.createElement("div",o({ref:"chart"},this.props.domProps))}});return s.Highcharts=e,s.withHighcharts=function(e){return t.exports(r,e)},s}}).call(r,function(){return this}())},function(t,r,e){"use strict";t.exports=e(2)("Chart",e(4))},function(t,e){t.exports=r}])});

/***/ },
/* 428 */
/***/ function(module, exports) {

	/**
	 * material-design-lite - Material Design Components in CSS, JS and HTML
	 * @version v1.2.0
	 * @license Apache-2.0
	 * @copyright 2015 Google, Inc.
	 * @link https://github.com/google/material-design-lite
	 */
	!function(){"use strict";function e(e,t){if(e){if(t.element_.classList.contains(t.CssClasses_.MDL_JS_RIPPLE_EFFECT)){var s=document.createElement("span");s.classList.add(t.CssClasses_.MDL_RIPPLE_CONTAINER),s.classList.add(t.CssClasses_.MDL_JS_RIPPLE_EFFECT);var i=document.createElement("span");i.classList.add(t.CssClasses_.MDL_RIPPLE),s.appendChild(i),e.appendChild(s)}e.addEventListener("click",function(s){s.preventDefault(),t.resetTabState_(),e.classList.add(t.CssClasses_.ACTIVE_CLASS)})}}function t(e,t,s,i){function n(){i.resetTabState_(t),e.classList.add(i.CssClasses_.IS_ACTIVE)}if(i.tabBar_.classList.contains(i.CssClasses_.JS_RIPPLE_EFFECT)){var a=document.createElement("span");a.classList.add(i.CssClasses_.RIPPLE_CONTAINER),a.classList.add(i.CssClasses_.JS_RIPPLE_EFFECT);var l=document.createElement("span");l.classList.add(i.CssClasses_.RIPPLE),a.appendChild(l),e.appendChild(a)}e.addEventListener("click",function(e){e.preventDefault(),n()}),e.show=n}if("undefined"!=typeof window){var s={upgradeDom:function(e,t){},upgradeElement:function(e,t){},upgradeElements:function(e){},upgradeAllRegistered:function(){},registerUpgradedCallback:function(e,t){},register:function(e){},downgradeElements:function(e){}};s=function(){function e(e,t){for(var s=0;s<h.length;s++)if(h[s].className===e)return"undefined"!=typeof t&&(h[s]=t),h[s];return!1}function t(e){var t=e.getAttribute("data-upgraded");return null===t?[""]:t.split(",")}function s(e,s){var i=t(e);return i.indexOf(s)!==-1}function i(t,s){if("undefined"==typeof t&&"undefined"==typeof s)for(var a=0;a<h.length;a++)i(h[a].className,h[a].cssClass);else{var l=t;if("undefined"==typeof s){var o=e(l);o&&(s=o.cssClass)}for(var r=document.querySelectorAll("."+s),_=0;_<r.length;_++)n(r[_],l)}}function n(i,n){if(!("object"==typeof i&&i instanceof Element))throw new Error("Invalid argument provided to upgrade MDL element.");var a=t(i),l=[];if(n)s(i,n)||l.push(e(n));else{var o=i.classList;h.forEach(function(e){o.contains(e.cssClass)&&l.indexOf(e)===-1&&!s(i,e.className)&&l.push(e)})}for(var r,_=0,d=l.length;_<d;_++){if(r=l[_],!r)throw new Error("Unable to find a registered component for the given class.");a.push(r.className),i.setAttribute("data-upgraded",a.join(","));var C=new r.classConstructor(i);C[p]=r,c.push(C);for(var u=0,E=r.callbacks.length;u<E;u++)r.callbacks[u](i);r.widget&&(i[r.className]=C);var m;"CustomEvent"in window&&"function"==typeof window.CustomEvent?m=new CustomEvent("mdl-componentupgraded",{bubbles:!0,cancelable:!1}):(m=document.createEvent("Events"),m.initEvent("mdl-componentupgraded",!0,!0)),i.dispatchEvent(m)}}function a(e){Array.isArray(e)||(e=e instanceof Element?[e]:Array.prototype.slice.call(e));for(var t,s=0,i=e.length;s<i;s++)t=e[s],t instanceof HTMLElement&&(n(t),t.children.length>0&&a(t.children))}function l(t){var s="undefined"==typeof t.widget&&"undefined"==typeof t.widget,i=!0;s||(i=t.widget||t.widget);var n={classConstructor:t.constructor||t.constructor,className:t.classAsString||t.classAsString,cssClass:t.cssClass||t.cssClass,widget:i,callbacks:[]};if(h.forEach(function(e){if(e.cssClass===n.cssClass)throw new Error("The provided cssClass has already been registered: "+e.cssClass);if(e.className===n.className)throw new Error("The provided className has already been registered")}),t.constructor.prototype.hasOwnProperty(p))throw new Error("MDL component classes must not have "+p+" defined as a property.");var a=e(t.classAsString,n);a||h.push(n)}function o(t,s){var i=e(t);i&&i.callbacks.push(s)}function r(){for(var e=0;e<h.length;e++)i(h[e].className)}function _(e){if(e){var t=c.indexOf(e);c.splice(t,1);var s=e.element_.getAttribute("data-upgraded").split(","),i=s.indexOf(e[p].classAsString);s.splice(i,1),e.element_.setAttribute("data-upgraded",s.join(","));var n;"CustomEvent"in window&&"function"==typeof window.CustomEvent?n=new CustomEvent("mdl-componentdowngraded",{bubbles:!0,cancelable:!1}):(n=document.createEvent("Events"),n.initEvent("mdl-componentdowngraded",!0,!0)),e.element_.dispatchEvent(n)}}function d(e){var t=function(e){c.filter(function(t){return t.element_===e}).forEach(_)};if(e instanceof Array||e instanceof NodeList)for(var s=0;s<e.length;s++)t(e[s]);else{if(!(e instanceof Node))throw new Error("Invalid argument provided to downgrade MDL nodes.");t(e)}}var h=[],c=[],p="mdlComponentConfigInternal_";return{upgradeDom:i,upgradeElement:n,upgradeElements:a,upgradeAllRegistered:r,registerUpgradedCallback:o,register:l,downgradeElements:d}}(),s.ComponentConfigPublic,s.ComponentConfig,s.Component,s.upgradeDom=s.upgradeDom,s.upgradeElement=s.upgradeElement,s.upgradeElements=s.upgradeElements,s.upgradeAllRegistered=s.upgradeAllRegistered,s.registerUpgradedCallback=s.registerUpgradedCallback,s.register=s.register,s.downgradeElements=s.downgradeElements,window.componentHandler=s,window.componentHandler=s,window.addEventListener("load",function(){"classList"in document.createElement("div")&&"querySelector"in document&&"addEventListener"in window&&Array.prototype.forEach?document.documentElement.classList.add("mdl-js"):(s.upgradeElement=function(){},s.register=function(){})}),Date.now||(Date.now=function(){return(new Date).getTime()},Date.now=Date.now);for(var i=["webkit","moz"],n=0;n<i.length&&!window.requestAnimationFrame;++n){var a=i[n];window.requestAnimationFrame=window[a+"RequestAnimationFrame"],window.cancelAnimationFrame=window[a+"CancelAnimationFrame"]||window[a+"CancelRequestAnimationFrame"],window.requestAnimationFrame=window.requestAnimationFrame,window.cancelAnimationFrame=window.cancelAnimationFrame}if(/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent)||!window.requestAnimationFrame||!window.cancelAnimationFrame){var l=0;window.requestAnimationFrame=function(e){var t=Date.now(),s=Math.max(l+16,t);return setTimeout(function(){e(l=s)},s-t)},window.cancelAnimationFrame=clearTimeout,window.requestAnimationFrame=window.requestAnimationFrame,window.cancelAnimationFrame=window.cancelAnimationFrame}var o=function(e){this.element_=e,this.init()};window.MaterialButton=o,o.prototype.Constant_={},o.prototype.CssClasses_={RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_CONTAINER:"mdl-button__ripple-container",RIPPLE:"mdl-ripple"},o.prototype.blurHandler_=function(e){e&&this.element_.blur()},o.prototype.disable=function(){this.element_.disabled=!0},o.prototype.disable=o.prototype.disable,o.prototype.enable=function(){this.element_.disabled=!1},o.prototype.enable=o.prototype.enable,o.prototype.init=function(){if(this.element_){if(this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)){var e=document.createElement("span");e.classList.add(this.CssClasses_.RIPPLE_CONTAINER),this.rippleElement_=document.createElement("span"),this.rippleElement_.classList.add(this.CssClasses_.RIPPLE),e.appendChild(this.rippleElement_),this.boundRippleBlurHandler=this.blurHandler_.bind(this),this.rippleElement_.addEventListener("mouseup",this.boundRippleBlurHandler),this.element_.appendChild(e)}this.boundButtonBlurHandler=this.blurHandler_.bind(this),this.element_.addEventListener("mouseup",this.boundButtonBlurHandler),this.element_.addEventListener("mouseleave",this.boundButtonBlurHandler)}},s.register({constructor:o,classAsString:"MaterialButton",cssClass:"mdl-js-button",widget:!0});var r=function(e){this.element_=e,this.init()};window.MaterialCheckbox=r,r.prototype.Constant_={TINY_TIMEOUT:.001},r.prototype.CssClasses_={INPUT:"mdl-checkbox__input",BOX_OUTLINE:"mdl-checkbox__box-outline",FOCUS_HELPER:"mdl-checkbox__focus-helper",TICK_OUTLINE:"mdl-checkbox__tick-outline",RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_IGNORE_EVENTS:"mdl-js-ripple-effect--ignore-events",RIPPLE_CONTAINER:"mdl-checkbox__ripple-container",RIPPLE_CENTER:"mdl-ripple--center",RIPPLE:"mdl-ripple",IS_FOCUSED:"is-focused",IS_DISABLED:"is-disabled",IS_CHECKED:"is-checked",IS_UPGRADED:"is-upgraded"},r.prototype.onChange_=function(e){this.updateClasses_()},r.prototype.onFocus_=function(e){this.element_.classList.add(this.CssClasses_.IS_FOCUSED)},r.prototype.onBlur_=function(e){this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)},r.prototype.onMouseUp_=function(e){this.blur_()},r.prototype.updateClasses_=function(){this.checkDisabled(),this.checkToggleState()},r.prototype.blur_=function(){window.setTimeout(function(){this.inputElement_.blur()}.bind(this),this.Constant_.TINY_TIMEOUT)},r.prototype.checkToggleState=function(){this.inputElement_.checked?this.element_.classList.add(this.CssClasses_.IS_CHECKED):this.element_.classList.remove(this.CssClasses_.IS_CHECKED)},r.prototype.checkToggleState=r.prototype.checkToggleState,r.prototype.checkDisabled=function(){this.inputElement_.disabled?this.element_.classList.add(this.CssClasses_.IS_DISABLED):this.element_.classList.remove(this.CssClasses_.IS_DISABLED)},r.prototype.checkDisabled=r.prototype.checkDisabled,r.prototype.disable=function(){this.inputElement_.disabled=!0,this.updateClasses_()},r.prototype.disable=r.prototype.disable,r.prototype.enable=function(){this.inputElement_.disabled=!1,this.updateClasses_()},r.prototype.enable=r.prototype.enable,r.prototype.check=function(){this.inputElement_.checked=!0,this.updateClasses_()},r.prototype.check=r.prototype.check,r.prototype.uncheck=function(){this.inputElement_.checked=!1,this.updateClasses_()},r.prototype.uncheck=r.prototype.uncheck,r.prototype.init=function(){if(this.element_){this.inputElement_=this.element_.querySelector("."+this.CssClasses_.INPUT);var e=document.createElement("span");e.classList.add(this.CssClasses_.BOX_OUTLINE);var t=document.createElement("span");t.classList.add(this.CssClasses_.FOCUS_HELPER);var s=document.createElement("span");if(s.classList.add(this.CssClasses_.TICK_OUTLINE),e.appendChild(s),this.element_.appendChild(t),this.element_.appendChild(e),this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)){this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS),this.rippleContainerElement_=document.createElement("span"),this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER),this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT),this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER),this.boundRippleMouseUp=this.onMouseUp_.bind(this),this.rippleContainerElement_.addEventListener("mouseup",this.boundRippleMouseUp);var i=document.createElement("span");i.classList.add(this.CssClasses_.RIPPLE),this.rippleContainerElement_.appendChild(i),this.element_.appendChild(this.rippleContainerElement_)}this.boundInputOnChange=this.onChange_.bind(this),this.boundInputOnFocus=this.onFocus_.bind(this),this.boundInputOnBlur=this.onBlur_.bind(this),this.boundElementMouseUp=this.onMouseUp_.bind(this),this.inputElement_.addEventListener("change",this.boundInputOnChange),this.inputElement_.addEventListener("focus",this.boundInputOnFocus),this.inputElement_.addEventListener("blur",this.boundInputOnBlur),this.element_.addEventListener("mouseup",this.boundElementMouseUp),this.updateClasses_(),this.element_.classList.add(this.CssClasses_.IS_UPGRADED)}},s.register({constructor:r,classAsString:"MaterialCheckbox",cssClass:"mdl-js-checkbox",widget:!0});var _=function(e){this.element_=e,this.init()};window.MaterialIconToggle=_,_.prototype.Constant_={TINY_TIMEOUT:.001},_.prototype.CssClasses_={INPUT:"mdl-icon-toggle__input",JS_RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_IGNORE_EVENTS:"mdl-js-ripple-effect--ignore-events",RIPPLE_CONTAINER:"mdl-icon-toggle__ripple-container",RIPPLE_CENTER:"mdl-ripple--center",RIPPLE:"mdl-ripple",IS_FOCUSED:"is-focused",IS_DISABLED:"is-disabled",IS_CHECKED:"is-checked"},_.prototype.onChange_=function(e){this.updateClasses_()},_.prototype.onFocus_=function(e){this.element_.classList.add(this.CssClasses_.IS_FOCUSED)},_.prototype.onBlur_=function(e){this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)},_.prototype.onMouseUp_=function(e){this.blur_()},_.prototype.updateClasses_=function(){this.checkDisabled(),this.checkToggleState()},_.prototype.blur_=function(){window.setTimeout(function(){this.inputElement_.blur()}.bind(this),this.Constant_.TINY_TIMEOUT)},_.prototype.checkToggleState=function(){this.inputElement_.checked?this.element_.classList.add(this.CssClasses_.IS_CHECKED):this.element_.classList.remove(this.CssClasses_.IS_CHECKED)},_.prototype.checkToggleState=_.prototype.checkToggleState,_.prototype.checkDisabled=function(){this.inputElement_.disabled?this.element_.classList.add(this.CssClasses_.IS_DISABLED):this.element_.classList.remove(this.CssClasses_.IS_DISABLED)},_.prototype.checkDisabled=_.prototype.checkDisabled,_.prototype.disable=function(){this.inputElement_.disabled=!0,this.updateClasses_()},_.prototype.disable=_.prototype.disable,_.prototype.enable=function(){this.inputElement_.disabled=!1,this.updateClasses_()},_.prototype.enable=_.prototype.enable,_.prototype.check=function(){this.inputElement_.checked=!0,this.updateClasses_()},_.prototype.check=_.prototype.check,_.prototype.uncheck=function(){this.inputElement_.checked=!1,this.updateClasses_()},_.prototype.uncheck=_.prototype.uncheck,_.prototype.init=function(){if(this.element_){if(this.inputElement_=this.element_.querySelector("."+this.CssClasses_.INPUT),this.element_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)){this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS),this.rippleContainerElement_=document.createElement("span"),this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER),this.rippleContainerElement_.classList.add(this.CssClasses_.JS_RIPPLE_EFFECT),this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER),this.boundRippleMouseUp=this.onMouseUp_.bind(this),this.rippleContainerElement_.addEventListener("mouseup",this.boundRippleMouseUp);var e=document.createElement("span");e.classList.add(this.CssClasses_.RIPPLE),this.rippleContainerElement_.appendChild(e),this.element_.appendChild(this.rippleContainerElement_)}this.boundInputOnChange=this.onChange_.bind(this),this.boundInputOnFocus=this.onFocus_.bind(this),this.boundInputOnBlur=this.onBlur_.bind(this),this.boundElementOnMouseUp=this.onMouseUp_.bind(this),this.inputElement_.addEventListener("change",this.boundInputOnChange),this.inputElement_.addEventListener("focus",this.boundInputOnFocus),this.inputElement_.addEventListener("blur",this.boundInputOnBlur),this.element_.addEventListener("mouseup",this.boundElementOnMouseUp),this.updateClasses_(),this.element_.classList.add("is-upgraded")}},s.register({constructor:_,classAsString:"MaterialIconToggle",cssClass:"mdl-js-icon-toggle",widget:!0});var d=function(e){this.element_=e,this.init()};window.MaterialMenu=d,d.prototype.Constant_={TRANSITION_DURATION_SECONDS:.3,TRANSITION_DURATION_FRACTION:.8,CLOSE_TIMEOUT:150},d.prototype.Keycodes_={ENTER:13,ESCAPE:27,SPACE:32,UP_ARROW:38,DOWN_ARROW:40},d.prototype.CssClasses_={CONTAINER:"mdl-menu__container",OUTLINE:"mdl-menu__outline",ITEM:"mdl-menu__item",ITEM_RIPPLE_CONTAINER:"mdl-menu__item-ripple-container",RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_IGNORE_EVENTS:"mdl-js-ripple-effect--ignore-events",RIPPLE:"mdl-ripple",IS_UPGRADED:"is-upgraded",IS_VISIBLE:"is-visible",IS_ANIMATING:"is-animating",BOTTOM_LEFT:"mdl-menu--bottom-left",BOTTOM_RIGHT:"mdl-menu--bottom-right",TOP_LEFT:"mdl-menu--top-left",TOP_RIGHT:"mdl-menu--top-right",UNALIGNED:"mdl-menu--unaligned"},d.prototype.init=function(){if(this.element_){var e=document.createElement("div");e.classList.add(this.CssClasses_.CONTAINER),this.element_.parentElement.insertBefore(e,this.element_),this.element_.parentElement.removeChild(this.element_),e.appendChild(this.element_),this.container_=e;var t=document.createElement("div");t.classList.add(this.CssClasses_.OUTLINE),this.outline_=t,e.insertBefore(t,this.element_);var s=this.element_.getAttribute("for")||this.element_.getAttribute("data-mdl-for"),i=null;s&&(i=document.getElementById(s),i&&(this.forElement_=i,i.addEventListener("click",this.handleForClick_.bind(this)),i.addEventListener("keydown",this.handleForKeyboardEvent_.bind(this))));var n=this.element_.querySelectorAll("."+this.CssClasses_.ITEM);this.boundItemKeydown_=this.handleItemKeyboardEvent_.bind(this),this.boundItemClick_=this.handleItemClick_.bind(this);for(var a=0;a<n.length;a++)n[a].addEventListener("click",this.boundItemClick_),n[a].tabIndex="-1",n[a].addEventListener("keydown",this.boundItemKeydown_);if(this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT))for(this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS),a=0;a<n.length;a++){var l=n[a],o=document.createElement("span");o.classList.add(this.CssClasses_.ITEM_RIPPLE_CONTAINER);var r=document.createElement("span");r.classList.add(this.CssClasses_.RIPPLE),o.appendChild(r),l.appendChild(o),l.classList.add(this.CssClasses_.RIPPLE_EFFECT)}this.element_.classList.contains(this.CssClasses_.BOTTOM_LEFT)&&this.outline_.classList.add(this.CssClasses_.BOTTOM_LEFT),this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)&&this.outline_.classList.add(this.CssClasses_.BOTTOM_RIGHT),this.element_.classList.contains(this.CssClasses_.TOP_LEFT)&&this.outline_.classList.add(this.CssClasses_.TOP_LEFT),this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)&&this.outline_.classList.add(this.CssClasses_.TOP_RIGHT),this.element_.classList.contains(this.CssClasses_.UNALIGNED)&&this.outline_.classList.add(this.CssClasses_.UNALIGNED),e.classList.add(this.CssClasses_.IS_UPGRADED)}},d.prototype.handleForClick_=function(e){if(this.element_&&this.forElement_){var t=this.forElement_.getBoundingClientRect(),s=this.forElement_.parentElement.getBoundingClientRect();this.element_.classList.contains(this.CssClasses_.UNALIGNED)||(this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)?(this.container_.style.right=s.right-t.right+"px",this.container_.style.top=this.forElement_.offsetTop+this.forElement_.offsetHeight+"px"):this.element_.classList.contains(this.CssClasses_.TOP_LEFT)?(this.container_.style.left=this.forElement_.offsetLeft+"px",this.container_.style.bottom=s.bottom-t.top+"px"):this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)?(this.container_.style.right=s.right-t.right+"px",this.container_.style.bottom=s.bottom-t.top+"px"):(this.container_.style.left=this.forElement_.offsetLeft+"px",this.container_.style.top=this.forElement_.offsetTop+this.forElement_.offsetHeight+"px"))}this.toggle(e)},d.prototype.handleForKeyboardEvent_=function(e){if(this.element_&&this.container_&&this.forElement_){var t=this.element_.querySelectorAll("."+this.CssClasses_.ITEM+":not([disabled])");t&&t.length>0&&this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)&&(e.keyCode===this.Keycodes_.UP_ARROW?(e.preventDefault(),t[t.length-1].focus()):e.keyCode===this.Keycodes_.DOWN_ARROW&&(e.preventDefault(),t[0].focus()))}},d.prototype.handleItemKeyboardEvent_=function(e){if(this.element_&&this.container_){var t=this.element_.querySelectorAll("."+this.CssClasses_.ITEM+":not([disabled])");if(t&&t.length>0&&this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)){var s=Array.prototype.slice.call(t).indexOf(e.target);if(e.keyCode===this.Keycodes_.UP_ARROW)e.preventDefault(),s>0?t[s-1].focus():t[t.length-1].focus();else if(e.keyCode===this.Keycodes_.DOWN_ARROW)e.preventDefault(),t.length>s+1?t[s+1].focus():t[0].focus();else if(e.keyCode===this.Keycodes_.SPACE||e.keyCode===this.Keycodes_.ENTER){e.preventDefault();var i=new MouseEvent("mousedown");e.target.dispatchEvent(i),i=new MouseEvent("mouseup"),e.target.dispatchEvent(i),e.target.click()}else e.keyCode===this.Keycodes_.ESCAPE&&(e.preventDefault(),this.hide())}}},d.prototype.handleItemClick_=function(e){e.target.hasAttribute("disabled")?e.stopPropagation():(this.closing_=!0,window.setTimeout(function(e){this.hide(),this.closing_=!1}.bind(this),this.Constant_.CLOSE_TIMEOUT))},d.prototype.applyClip_=function(e,t){this.element_.classList.contains(this.CssClasses_.UNALIGNED)?this.element_.style.clip="":this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)?this.element_.style.clip="rect(0 "+t+"px 0 "+t+"px)":this.element_.classList.contains(this.CssClasses_.TOP_LEFT)?this.element_.style.clip="rect("+e+"px 0 "+e+"px 0)":this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)?this.element_.style.clip="rect("+e+"px "+t+"px "+e+"px "+t+"px)":this.element_.style.clip=""},d.prototype.removeAnimationEndListener_=function(e){e.target.classList.remove(d.prototype.CssClasses_.IS_ANIMATING)},d.prototype.addAnimationEndListener_=function(){this.element_.addEventListener("transitionend",this.removeAnimationEndListener_),this.element_.addEventListener("webkitTransitionEnd",this.removeAnimationEndListener_)},d.prototype.show=function(e){if(this.element_&&this.container_&&this.outline_){var t=this.element_.getBoundingClientRect().height,s=this.element_.getBoundingClientRect().width;this.container_.style.width=s+"px",this.container_.style.height=t+"px",this.outline_.style.width=s+"px",this.outline_.style.height=t+"px";for(var i=this.Constant_.TRANSITION_DURATION_SECONDS*this.Constant_.TRANSITION_DURATION_FRACTION,n=this.element_.querySelectorAll("."+this.CssClasses_.ITEM),a=0;a<n.length;a++){var l=null;l=this.element_.classList.contains(this.CssClasses_.TOP_LEFT)||this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)?(t-n[a].offsetTop-n[a].offsetHeight)/t*i+"s":n[a].offsetTop/t*i+"s",n[a].style.transitionDelay=l}this.applyClip_(t,s),window.requestAnimationFrame(function(){this.element_.classList.add(this.CssClasses_.IS_ANIMATING),this.element_.style.clip="rect(0 "+s+"px "+t+"px 0)",this.container_.classList.add(this.CssClasses_.IS_VISIBLE)}.bind(this)),this.addAnimationEndListener_();var o=function(t){t===e||this.closing_||t.target.parentNode===this.element_||(document.removeEventListener("click",o),this.hide())}.bind(this);document.addEventListener("click",o)}},d.prototype.show=d.prototype.show,d.prototype.hide=function(){if(this.element_&&this.container_&&this.outline_){for(var e=this.element_.querySelectorAll("."+this.CssClasses_.ITEM),t=0;t<e.length;t++)e[t].style.removeProperty("transition-delay");var s=this.element_.getBoundingClientRect(),i=s.height,n=s.width;this.element_.classList.add(this.CssClasses_.IS_ANIMATING),this.applyClip_(i,n),this.container_.classList.remove(this.CssClasses_.IS_VISIBLE),this.addAnimationEndListener_()}},d.prototype.hide=d.prototype.hide,d.prototype.toggle=function(e){this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)?this.hide():this.show(e)},d.prototype.toggle=d.prototype.toggle,s.register({constructor:d,classAsString:"MaterialMenu",cssClass:"mdl-js-menu",widget:!0});var h=function(e){this.element_=e,this.init()};window.MaterialProgress=h,h.prototype.Constant_={},h.prototype.CssClasses_={INDETERMINATE_CLASS:"mdl-progress__indeterminate"},h.prototype.setProgress=function(e){this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS)||(this.progressbar_.style.width=e+"%")},h.prototype.setProgress=h.prototype.setProgress,h.prototype.setBuffer=function(e){this.bufferbar_.style.width=e+"%",this.auxbar_.style.width=100-e+"%"},h.prototype.setBuffer=h.prototype.setBuffer,h.prototype.init=function(){if(this.element_){var e=document.createElement("div");e.className="progressbar bar bar1",this.element_.appendChild(e),this.progressbar_=e,e=document.createElement("div"),e.className="bufferbar bar bar2",this.element_.appendChild(e),this.bufferbar_=e,e=document.createElement("div"),e.className="auxbar bar bar3",this.element_.appendChild(e),this.auxbar_=e,this.progressbar_.style.width="0%",this.bufferbar_.style.width="100%",this.auxbar_.style.width="0%",this.element_.classList.add("is-upgraded")}},s.register({constructor:h,classAsString:"MaterialProgress",cssClass:"mdl-js-progress",widget:!0});var c=function(e){this.element_=e,this.init()};window.MaterialRadio=c,c.prototype.Constant_={TINY_TIMEOUT:.001},c.prototype.CssClasses_={IS_FOCUSED:"is-focused",IS_DISABLED:"is-disabled",IS_CHECKED:"is-checked",IS_UPGRADED:"is-upgraded",JS_RADIO:"mdl-js-radio",RADIO_BTN:"mdl-radio__button",RADIO_OUTER_CIRCLE:"mdl-radio__outer-circle",RADIO_INNER_CIRCLE:"mdl-radio__inner-circle",RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_IGNORE_EVENTS:"mdl-js-ripple-effect--ignore-events",RIPPLE_CONTAINER:"mdl-radio__ripple-container",RIPPLE_CENTER:"mdl-ripple--center",RIPPLE:"mdl-ripple"},c.prototype.onChange_=function(e){for(var t=document.getElementsByClassName(this.CssClasses_.JS_RADIO),s=0;s<t.length;s++){var i=t[s].querySelector("."+this.CssClasses_.RADIO_BTN);i.getAttribute("name")===this.btnElement_.getAttribute("name")&&t[s].MaterialRadio.updateClasses_()}},c.prototype.onFocus_=function(e){this.element_.classList.add(this.CssClasses_.IS_FOCUSED)},c.prototype.onBlur_=function(e){this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)},c.prototype.onMouseup_=function(e){this.blur_()},c.prototype.updateClasses_=function(){this.checkDisabled(),this.checkToggleState()},c.prototype.blur_=function(){window.setTimeout(function(){this.btnElement_.blur()}.bind(this),this.Constant_.TINY_TIMEOUT)},c.prototype.checkDisabled=function(){this.btnElement_.disabled?this.element_.classList.add(this.CssClasses_.IS_DISABLED):this.element_.classList.remove(this.CssClasses_.IS_DISABLED)},c.prototype.checkDisabled=c.prototype.checkDisabled,c.prototype.checkToggleState=function(){this.btnElement_.checked?this.element_.classList.add(this.CssClasses_.IS_CHECKED):this.element_.classList.remove(this.CssClasses_.IS_CHECKED)},c.prototype.checkToggleState=c.prototype.checkToggleState,c.prototype.disable=function(){this.btnElement_.disabled=!0,this.updateClasses_()},c.prototype.disable=c.prototype.disable,c.prototype.enable=function(){this.btnElement_.disabled=!1,this.updateClasses_()},c.prototype.enable=c.prototype.enable,c.prototype.check=function(){this.btnElement_.checked=!0,this.onChange_(null)},c.prototype.check=c.prototype.check,c.prototype.uncheck=function(){this.btnElement_.checked=!1,this.onChange_(null)},c.prototype.uncheck=c.prototype.uncheck,c.prototype.init=function(){if(this.element_){this.btnElement_=this.element_.querySelector("."+this.CssClasses_.RADIO_BTN),this.boundChangeHandler_=this.onChange_.bind(this),this.boundFocusHandler_=this.onChange_.bind(this),this.boundBlurHandler_=this.onBlur_.bind(this),this.boundMouseUpHandler_=this.onMouseup_.bind(this);var e=document.createElement("span");e.classList.add(this.CssClasses_.RADIO_OUTER_CIRCLE);var t=document.createElement("span");t.classList.add(this.CssClasses_.RADIO_INNER_CIRCLE),this.element_.appendChild(e),this.element_.appendChild(t);var s;if(this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)){this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS),s=document.createElement("span"),s.classList.add(this.CssClasses_.RIPPLE_CONTAINER),s.classList.add(this.CssClasses_.RIPPLE_EFFECT),s.classList.add(this.CssClasses_.RIPPLE_CENTER),s.addEventListener("mouseup",this.boundMouseUpHandler_);var i=document.createElement("span");i.classList.add(this.CssClasses_.RIPPLE),s.appendChild(i),this.element_.appendChild(s)}this.btnElement_.addEventListener("change",this.boundChangeHandler_),this.btnElement_.addEventListener("focus",this.boundFocusHandler_),this.btnElement_.addEventListener("blur",this.boundBlurHandler_),this.element_.addEventListener("mouseup",this.boundMouseUpHandler_),this.updateClasses_(),this.element_.classList.add(this.CssClasses_.IS_UPGRADED)}},s.register({constructor:c,classAsString:"MaterialRadio",cssClass:"mdl-js-radio",widget:!0});var p=function(e){this.element_=e,this.isIE_=window.navigator.msPointerEnabled,this.init()};window.MaterialSlider=p,p.prototype.Constant_={},p.prototype.CssClasses_={IE_CONTAINER:"mdl-slider__ie-container",SLIDER_CONTAINER:"mdl-slider__container",BACKGROUND_FLEX:"mdl-slider__background-flex",BACKGROUND_LOWER:"mdl-slider__background-lower",BACKGROUND_UPPER:"mdl-slider__background-upper",IS_LOWEST_VALUE:"is-lowest-value",IS_UPGRADED:"is-upgraded"},p.prototype.onInput_=function(e){this.updateValueStyles_()},p.prototype.onChange_=function(e){this.updateValueStyles_()},p.prototype.onMouseUp_=function(e){e.target.blur()},p.prototype.onContainerMouseDown_=function(e){if(e.target===this.element_.parentElement){e.preventDefault();var t=new MouseEvent("mousedown",{target:e.target,buttons:e.buttons,clientX:e.clientX,clientY:this.element_.getBoundingClientRect().y});this.element_.dispatchEvent(t)}},p.prototype.updateValueStyles_=function(){var e=(this.element_.value-this.element_.min)/(this.element_.max-this.element_.min);0===e?this.element_.classList.add(this.CssClasses_.IS_LOWEST_VALUE):this.element_.classList.remove(this.CssClasses_.IS_LOWEST_VALUE),this.isIE_||(this.backgroundLower_.style.flex=e,this.backgroundLower_.style.webkitFlex=e,this.backgroundUpper_.style.flex=1-e,this.backgroundUpper_.style.webkitFlex=1-e)},p.prototype.disable=function(){this.element_.disabled=!0},p.prototype.disable=p.prototype.disable,p.prototype.enable=function(){this.element_.disabled=!1},p.prototype.enable=p.prototype.enable,p.prototype.change=function(e){"undefined"!=typeof e&&(this.element_.value=e),this.updateValueStyles_()},p.prototype.change=p.prototype.change,p.prototype.init=function(){if(this.element_){if(this.isIE_){var e=document.createElement("div");e.classList.add(this.CssClasses_.IE_CONTAINER),this.element_.parentElement.insertBefore(e,this.element_),this.element_.parentElement.removeChild(this.element_),e.appendChild(this.element_)}else{var t=document.createElement("div");t.classList.add(this.CssClasses_.SLIDER_CONTAINER),this.element_.parentElement.insertBefore(t,this.element_),this.element_.parentElement.removeChild(this.element_),t.appendChild(this.element_);var s=document.createElement("div");s.classList.add(this.CssClasses_.BACKGROUND_FLEX),t.appendChild(s),this.backgroundLower_=document.createElement("div"),this.backgroundLower_.classList.add(this.CssClasses_.BACKGROUND_LOWER),s.appendChild(this.backgroundLower_),this.backgroundUpper_=document.createElement("div"),this.backgroundUpper_.classList.add(this.CssClasses_.BACKGROUND_UPPER),s.appendChild(this.backgroundUpper_)}this.boundInputHandler=this.onInput_.bind(this),this.boundChangeHandler=this.onChange_.bind(this),this.boundMouseUpHandler=this.onMouseUp_.bind(this),this.boundContainerMouseDownHandler=this.onContainerMouseDown_.bind(this),this.element_.addEventListener("input",this.boundInputHandler),this.element_.addEventListener("change",this.boundChangeHandler),this.element_.addEventListener("mouseup",this.boundMouseUpHandler),this.element_.parentElement.addEventListener("mousedown",this.boundContainerMouseDownHandler),this.updateValueStyles_(),this.element_.classList.add(this.CssClasses_.IS_UPGRADED)}},s.register({constructor:p,classAsString:"MaterialSlider",cssClass:"mdl-js-slider",widget:!0});var C=function(e){if(this.element_=e,this.textElement_=this.element_.querySelector("."+this.cssClasses_.MESSAGE),this.actionElement_=this.element_.querySelector("."+this.cssClasses_.ACTION),!this.textElement_)throw new Error("There must be a message element for a snackbar.");if(!this.actionElement_)throw new Error("There must be an action element for a snackbar.");this.active=!1,this.actionHandler_=void 0,this.message_=void 0,this.actionText_=void 0,this.queuedNotifications_=[],this.setActionHidden_(!0)};window.MaterialSnackbar=C,C.prototype.Constant_={ANIMATION_LENGTH:250},C.prototype.cssClasses_={SNACKBAR:"mdl-snackbar",MESSAGE:"mdl-snackbar__text",ACTION:"mdl-snackbar__action",ACTIVE:"mdl-snackbar--active"},C.prototype.displaySnackbar_=function(){this.element_.setAttribute("aria-hidden","true"),this.actionHandler_&&(this.actionElement_.textContent=this.actionText_,this.actionElement_.addEventListener("click",this.actionHandler_),this.setActionHidden_(!1)),this.textElement_.textContent=this.message_,this.element_.classList.add(this.cssClasses_.ACTIVE),this.element_.setAttribute("aria-hidden","false"),setTimeout(this.cleanup_.bind(this),this.timeout_);
	},C.prototype.showSnackbar=function(e){if(void 0===e)throw new Error("Please provide a data object with at least a message to display.");if(void 0===e.message)throw new Error("Please provide a message to be displayed.");if(e.actionHandler&&!e.actionText)throw new Error("Please provide action text with the handler.");this.active?this.queuedNotifications_.push(e):(this.active=!0,this.message_=e.message,e.timeout?this.timeout_=e.timeout:this.timeout_=2750,e.actionHandler&&(this.actionHandler_=e.actionHandler),e.actionText&&(this.actionText_=e.actionText),this.displaySnackbar_())},C.prototype.showSnackbar=C.prototype.showSnackbar,C.prototype.checkQueue_=function(){this.queuedNotifications_.length>0&&this.showSnackbar(this.queuedNotifications_.shift())},C.prototype.cleanup_=function(){this.element_.classList.remove(this.cssClasses_.ACTIVE),setTimeout(function(){this.element_.setAttribute("aria-hidden","true"),this.textElement_.textContent="",Boolean(this.actionElement_.getAttribute("aria-hidden"))||(this.setActionHidden_(!0),this.actionElement_.textContent="",this.actionElement_.removeEventListener("click",this.actionHandler_)),this.actionHandler_=void 0,this.message_=void 0,this.actionText_=void 0,this.active=!1,this.checkQueue_()}.bind(this),this.Constant_.ANIMATION_LENGTH)},C.prototype.setActionHidden_=function(e){e?this.actionElement_.setAttribute("aria-hidden","true"):this.actionElement_.removeAttribute("aria-hidden")},s.register({constructor:C,classAsString:"MaterialSnackbar",cssClass:"mdl-js-snackbar",widget:!0});var u=function(e){this.element_=e,this.init()};window.MaterialSpinner=u,u.prototype.Constant_={MDL_SPINNER_LAYER_COUNT:4},u.prototype.CssClasses_={MDL_SPINNER_LAYER:"mdl-spinner__layer",MDL_SPINNER_CIRCLE_CLIPPER:"mdl-spinner__circle-clipper",MDL_SPINNER_CIRCLE:"mdl-spinner__circle",MDL_SPINNER_GAP_PATCH:"mdl-spinner__gap-patch",MDL_SPINNER_LEFT:"mdl-spinner__left",MDL_SPINNER_RIGHT:"mdl-spinner__right"},u.prototype.createLayer=function(e){var t=document.createElement("div");t.classList.add(this.CssClasses_.MDL_SPINNER_LAYER),t.classList.add(this.CssClasses_.MDL_SPINNER_LAYER+"-"+e);var s=document.createElement("div");s.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER),s.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);var i=document.createElement("div");i.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);var n=document.createElement("div");n.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER),n.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);for(var a=[s,i,n],l=0;l<a.length;l++){var o=document.createElement("div");o.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE),a[l].appendChild(o)}t.appendChild(s),t.appendChild(i),t.appendChild(n),this.element_.appendChild(t)},u.prototype.createLayer=u.prototype.createLayer,u.prototype.stop=function(){this.element_.classList.remove("is-active")},u.prototype.stop=u.prototype.stop,u.prototype.start=function(){this.element_.classList.add("is-active")},u.prototype.start=u.prototype.start,u.prototype.init=function(){if(this.element_){for(var e=1;e<=this.Constant_.MDL_SPINNER_LAYER_COUNT;e++)this.createLayer(e);this.element_.classList.add("is-upgraded")}},s.register({constructor:u,classAsString:"MaterialSpinner",cssClass:"mdl-js-spinner",widget:!0});var E=function(e){this.element_=e,this.init()};window.MaterialSwitch=E,E.prototype.Constant_={TINY_TIMEOUT:.001},E.prototype.CssClasses_={INPUT:"mdl-switch__input",TRACK:"mdl-switch__track",THUMB:"mdl-switch__thumb",FOCUS_HELPER:"mdl-switch__focus-helper",RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_IGNORE_EVENTS:"mdl-js-ripple-effect--ignore-events",RIPPLE_CONTAINER:"mdl-switch__ripple-container",RIPPLE_CENTER:"mdl-ripple--center",RIPPLE:"mdl-ripple",IS_FOCUSED:"is-focused",IS_DISABLED:"is-disabled",IS_CHECKED:"is-checked"},E.prototype.onChange_=function(e){this.updateClasses_()},E.prototype.onFocus_=function(e){this.element_.classList.add(this.CssClasses_.IS_FOCUSED)},E.prototype.onBlur_=function(e){this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)},E.prototype.onMouseUp_=function(e){this.blur_()},E.prototype.updateClasses_=function(){this.checkDisabled(),this.checkToggleState()},E.prototype.blur_=function(){window.setTimeout(function(){this.inputElement_.blur()}.bind(this),this.Constant_.TINY_TIMEOUT)},E.prototype.checkDisabled=function(){this.inputElement_.disabled?this.element_.classList.add(this.CssClasses_.IS_DISABLED):this.element_.classList.remove(this.CssClasses_.IS_DISABLED)},E.prototype.checkDisabled=E.prototype.checkDisabled,E.prototype.checkToggleState=function(){this.inputElement_.checked?this.element_.classList.add(this.CssClasses_.IS_CHECKED):this.element_.classList.remove(this.CssClasses_.IS_CHECKED)},E.prototype.checkToggleState=E.prototype.checkToggleState,E.prototype.disable=function(){this.inputElement_.disabled=!0,this.updateClasses_()},E.prototype.disable=E.prototype.disable,E.prototype.enable=function(){this.inputElement_.disabled=!1,this.updateClasses_()},E.prototype.enable=E.prototype.enable,E.prototype.on=function(){this.inputElement_.checked=!0,this.updateClasses_()},E.prototype.on=E.prototype.on,E.prototype.off=function(){this.inputElement_.checked=!1,this.updateClasses_()},E.prototype.off=E.prototype.off,E.prototype.init=function(){if(this.element_){this.inputElement_=this.element_.querySelector("."+this.CssClasses_.INPUT);var e=document.createElement("div");e.classList.add(this.CssClasses_.TRACK);var t=document.createElement("div");t.classList.add(this.CssClasses_.THUMB);var s=document.createElement("span");if(s.classList.add(this.CssClasses_.FOCUS_HELPER),t.appendChild(s),this.element_.appendChild(e),this.element_.appendChild(t),this.boundMouseUpHandler=this.onMouseUp_.bind(this),this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)){this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS),this.rippleContainerElement_=document.createElement("span"),this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER),this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT),this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER),this.rippleContainerElement_.addEventListener("mouseup",this.boundMouseUpHandler);var i=document.createElement("span");i.classList.add(this.CssClasses_.RIPPLE),this.rippleContainerElement_.appendChild(i),this.element_.appendChild(this.rippleContainerElement_)}this.boundChangeHandler=this.onChange_.bind(this),this.boundFocusHandler=this.onFocus_.bind(this),this.boundBlurHandler=this.onBlur_.bind(this),this.inputElement_.addEventListener("change",this.boundChangeHandler),this.inputElement_.addEventListener("focus",this.boundFocusHandler),this.inputElement_.addEventListener("blur",this.boundBlurHandler),this.element_.addEventListener("mouseup",this.boundMouseUpHandler),this.updateClasses_(),this.element_.classList.add("is-upgraded")}},s.register({constructor:E,classAsString:"MaterialSwitch",cssClass:"mdl-js-switch",widget:!0});var m=function(e){this.element_=e,this.init()};window.MaterialTabs=m,m.prototype.Constant_={},m.prototype.CssClasses_={TAB_CLASS:"mdl-tabs__tab",PANEL_CLASS:"mdl-tabs__panel",ACTIVE_CLASS:"is-active",UPGRADED_CLASS:"is-upgraded",MDL_JS_RIPPLE_EFFECT:"mdl-js-ripple-effect",MDL_RIPPLE_CONTAINER:"mdl-tabs__ripple-container",MDL_RIPPLE:"mdl-ripple",MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS:"mdl-js-ripple-effect--ignore-events"},m.prototype.initTabs_=function(){this.element_.classList.contains(this.CssClasses_.MDL_JS_RIPPLE_EFFECT)&&this.element_.classList.add(this.CssClasses_.MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS),this.tabs_=this.element_.querySelectorAll("."+this.CssClasses_.TAB_CLASS),this.panels_=this.element_.querySelectorAll("."+this.CssClasses_.PANEL_CLASS);for(var t=0;t<this.tabs_.length;t++)new e(this.tabs_[t],this);this.element_.classList.add(this.CssClasses_.UPGRADED_CLASS)},m.prototype.resetTabState_=function(){for(var e=0;e<this.tabs_.length;e++)this.tabs_[e].classList.remove(this.CssClasses_.ACTIVE_CLASS)},m.prototype.resetPanelState_=function(){for(var e=0;e<this.panels_.length;e++)this.panels_[e].classList.remove(this.CssClasses_.ACTIVE_CLASS)},m.prototype.init=function(){this.element_&&this.initTabs_()},s.register({constructor:m,classAsString:"MaterialTabs",cssClass:"mdl-js-tabs"});var L=function(e){this.element_=e,this.maxRows=this.Constant_.NO_MAX_ROWS,this.init()};window.MaterialTextfield=L,L.prototype.Constant_={NO_MAX_ROWS:-1,MAX_ROWS_ATTRIBUTE:"maxrows"},L.prototype.CssClasses_={LABEL:"mdl-textfield__label",INPUT:"mdl-textfield__input",IS_DIRTY:"is-dirty",IS_FOCUSED:"is-focused",IS_DISABLED:"is-disabled",IS_INVALID:"is-invalid",IS_UPGRADED:"is-upgraded",HAS_PLACEHOLDER:"has-placeholder"},L.prototype.onKeyDown_=function(e){var t=e.target.value.split("\n").length;13===e.keyCode&&t>=this.maxRows&&e.preventDefault()},L.prototype.onFocus_=function(e){this.element_.classList.add(this.CssClasses_.IS_FOCUSED)},L.prototype.onBlur_=function(e){this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)},L.prototype.onReset_=function(e){this.updateClasses_()},L.prototype.updateClasses_=function(){this.checkDisabled(),this.checkValidity(),this.checkDirty(),this.checkFocus()},L.prototype.checkDisabled=function(){this.input_.disabled?this.element_.classList.add(this.CssClasses_.IS_DISABLED):this.element_.classList.remove(this.CssClasses_.IS_DISABLED)},L.prototype.checkDisabled=L.prototype.checkDisabled,L.prototype.checkFocus=function(){Boolean(this.element_.querySelector(":focus"))?this.element_.classList.add(this.CssClasses_.IS_FOCUSED):this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)},L.prototype.checkFocus=L.prototype.checkFocus,L.prototype.checkValidity=function(){this.input_.validity&&(this.input_.validity.valid?this.element_.classList.remove(this.CssClasses_.IS_INVALID):this.element_.classList.add(this.CssClasses_.IS_INVALID))},L.prototype.checkValidity=L.prototype.checkValidity,L.prototype.checkDirty=function(){this.input_.value&&this.input_.value.length>0?this.element_.classList.add(this.CssClasses_.IS_DIRTY):this.element_.classList.remove(this.CssClasses_.IS_DIRTY)},L.prototype.checkDirty=L.prototype.checkDirty,L.prototype.disable=function(){this.input_.disabled=!0,this.updateClasses_()},L.prototype.disable=L.prototype.disable,L.prototype.enable=function(){this.input_.disabled=!1,this.updateClasses_()},L.prototype.enable=L.prototype.enable,L.prototype.change=function(e){this.input_.value=e||"",this.updateClasses_()},L.prototype.change=L.prototype.change,L.prototype.init=function(){if(this.element_&&(this.label_=this.element_.querySelector("."+this.CssClasses_.LABEL),this.input_=this.element_.querySelector("."+this.CssClasses_.INPUT),this.input_)){this.input_.hasAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE)&&(this.maxRows=parseInt(this.input_.getAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE),10),isNaN(this.maxRows)&&(this.maxRows=this.Constant_.NO_MAX_ROWS)),this.input_.hasAttribute("placeholder")&&this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER),this.boundUpdateClassesHandler=this.updateClasses_.bind(this),this.boundFocusHandler=this.onFocus_.bind(this),this.boundBlurHandler=this.onBlur_.bind(this),this.boundResetHandler=this.onReset_.bind(this),this.input_.addEventListener("input",this.boundUpdateClassesHandler),this.input_.addEventListener("focus",this.boundFocusHandler),this.input_.addEventListener("blur",this.boundBlurHandler),this.input_.addEventListener("reset",this.boundResetHandler),this.maxRows!==this.Constant_.NO_MAX_ROWS&&(this.boundKeyDownHandler=this.onKeyDown_.bind(this),this.input_.addEventListener("keydown",this.boundKeyDownHandler));var e=this.element_.classList.contains(this.CssClasses_.IS_INVALID);this.updateClasses_(),this.element_.classList.add(this.CssClasses_.IS_UPGRADED),e&&this.element_.classList.add(this.CssClasses_.IS_INVALID),this.input_.hasAttribute("autofocus")&&(this.element_.focus(),this.checkFocus())}},s.register({constructor:L,classAsString:"MaterialTextfield",cssClass:"mdl-js-textfield",widget:!0});var I=function(e){this.element_=e,this.init()};window.MaterialTooltip=I,I.prototype.Constant_={},I.prototype.CssClasses_={IS_ACTIVE:"is-active",BOTTOM:"mdl-tooltip--bottom",LEFT:"mdl-tooltip--left",RIGHT:"mdl-tooltip--right",TOP:"mdl-tooltip--top"},I.prototype.handleMouseEnter_=function(e){var t=e.target.getBoundingClientRect(),s=t.left+t.width/2,i=t.top+t.height/2,n=-1*(this.element_.offsetWidth/2),a=-1*(this.element_.offsetHeight/2);this.element_.classList.contains(this.CssClasses_.LEFT)||this.element_.classList.contains(this.CssClasses_.RIGHT)?(s=t.width/2,i+a<0?(this.element_.style.top="0",this.element_.style.marginTop="0"):(this.element_.style.top=i+"px",this.element_.style.marginTop=a+"px")):s+n<0?(this.element_.style.left="0",this.element_.style.marginLeft="0"):(this.element_.style.left=s+"px",this.element_.style.marginLeft=n+"px"),this.element_.classList.contains(this.CssClasses_.TOP)?this.element_.style.top=t.top-this.element_.offsetHeight-10+"px":this.element_.classList.contains(this.CssClasses_.RIGHT)?this.element_.style.left=t.left+t.width+10+"px":this.element_.classList.contains(this.CssClasses_.LEFT)?this.element_.style.left=t.left-this.element_.offsetWidth-10+"px":this.element_.style.top=t.top+t.height+10+"px",this.element_.classList.add(this.CssClasses_.IS_ACTIVE)},I.prototype.hideTooltip_=function(){this.element_.classList.remove(this.CssClasses_.IS_ACTIVE)},I.prototype.init=function(){if(this.element_){var e=this.element_.getAttribute("for")||this.element_.getAttribute("data-mdl-for");e&&(this.forElement_=document.getElementById(e)),this.forElement_&&(this.forElement_.hasAttribute("tabindex")||this.forElement_.setAttribute("tabindex","0"),this.boundMouseEnterHandler=this.handleMouseEnter_.bind(this),this.boundMouseLeaveAndScrollHandler=this.hideTooltip_.bind(this),this.forElement_.addEventListener("mouseenter",this.boundMouseEnterHandler,!1),this.forElement_.addEventListener("touchend",this.boundMouseEnterHandler,!1),this.forElement_.addEventListener("mouseleave",this.boundMouseLeaveAndScrollHandler,!1),window.addEventListener("scroll",this.boundMouseLeaveAndScrollHandler,!0),window.addEventListener("touchstart",this.boundMouseLeaveAndScrollHandler))}},s.register({constructor:I,classAsString:"MaterialTooltip",cssClass:"mdl-tooltip"});var f=function(e){this.element_=e,this.innerContainer_=e.querySelector("."+this.CssClasses_.INNER_CONTAINER),this.init()};window.MaterialLayout=f,f.prototype.Constant_={MAX_WIDTH:"(max-width: 1024px)",TAB_SCROLL_PIXELS:100,RESIZE_TIMEOUT:100,MENU_ICON:"&#xE5D2;",CHEVRON_LEFT:"chevron_left",CHEVRON_RIGHT:"chevron_right"},f.prototype.Keycodes_={ENTER:13,ESCAPE:27,SPACE:32},f.prototype.Mode_={STANDARD:0,SEAMED:1,WATERFALL:2,SCROLL:3},f.prototype.CssClasses_={INNER_CONTAINER:"mdl-layout__inner-container",HEADER:"mdl-layout__header",DRAWER:"mdl-layout__drawer",CONTENT:"mdl-layout__content",DRAWER_BTN:"mdl-layout__drawer-button",ICON:"material-icons",JS_RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_CONTAINER:"mdl-layout__tab-ripple-container",RIPPLE:"mdl-ripple",RIPPLE_IGNORE_EVENTS:"mdl-js-ripple-effect--ignore-events",HEADER_SEAMED:"mdl-layout__header--seamed",HEADER_WATERFALL:"mdl-layout__header--waterfall",HEADER_SCROLL:"mdl-layout__header--scroll",FIXED_HEADER:"mdl-layout--fixed-header",OBFUSCATOR:"mdl-layout__obfuscator",TAB_BAR:"mdl-layout__tab-bar",TAB_CONTAINER:"mdl-layout__tab-bar-container",TAB:"mdl-layout__tab",TAB_BAR_BUTTON:"mdl-layout__tab-bar-button",TAB_BAR_LEFT_BUTTON:"mdl-layout__tab-bar-left-button",TAB_BAR_RIGHT_BUTTON:"mdl-layout__tab-bar-right-button",PANEL:"mdl-layout__tab-panel",HAS_DRAWER:"has-drawer",HAS_TABS:"has-tabs",HAS_SCROLLING_HEADER:"has-scrolling-header",CASTING_SHADOW:"is-casting-shadow",IS_COMPACT:"is-compact",IS_SMALL_SCREEN:"is-small-screen",IS_DRAWER_OPEN:"is-visible",IS_ACTIVE:"is-active",IS_UPGRADED:"is-upgraded",IS_ANIMATING:"is-animating",ON_LARGE_SCREEN:"mdl-layout--large-screen-only",ON_SMALL_SCREEN:"mdl-layout--small-screen-only"},f.prototype.contentScrollHandler_=function(){if(!this.header_.classList.contains(this.CssClasses_.IS_ANIMATING)){var e=!this.element_.classList.contains(this.CssClasses_.IS_SMALL_SCREEN)||this.element_.classList.contains(this.CssClasses_.FIXED_HEADER);this.content_.scrollTop>0&&!this.header_.classList.contains(this.CssClasses_.IS_COMPACT)?(this.header_.classList.add(this.CssClasses_.CASTING_SHADOW),this.header_.classList.add(this.CssClasses_.IS_COMPACT),e&&this.header_.classList.add(this.CssClasses_.IS_ANIMATING)):this.content_.scrollTop<=0&&this.header_.classList.contains(this.CssClasses_.IS_COMPACT)&&(this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW),this.header_.classList.remove(this.CssClasses_.IS_COMPACT),e&&this.header_.classList.add(this.CssClasses_.IS_ANIMATING))}},f.prototype.keyboardEventHandler_=function(e){e.keyCode===this.Keycodes_.ESCAPE&&this.drawer_.classList.contains(this.CssClasses_.IS_DRAWER_OPEN)&&this.toggleDrawer()},f.prototype.screenSizeHandler_=function(){this.screenSizeMediaQuery_.matches?this.element_.classList.add(this.CssClasses_.IS_SMALL_SCREEN):(this.element_.classList.remove(this.CssClasses_.IS_SMALL_SCREEN),this.drawer_&&(this.drawer_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN),this.obfuscator_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN)))},f.prototype.drawerToggleHandler_=function(e){if(e&&"keydown"===e.type){if(e.keyCode!==this.Keycodes_.SPACE&&e.keyCode!==this.Keycodes_.ENTER)return;e.preventDefault()}this.toggleDrawer()},f.prototype.headerTransitionEndHandler_=function(){this.header_.classList.remove(this.CssClasses_.IS_ANIMATING)},f.prototype.headerClickHandler_=function(){this.header_.classList.contains(this.CssClasses_.IS_COMPACT)&&(this.header_.classList.remove(this.CssClasses_.IS_COMPACT),this.header_.classList.add(this.CssClasses_.IS_ANIMATING))},f.prototype.resetTabState_=function(e){for(var t=0;t<e.length;t++)e[t].classList.remove(this.CssClasses_.IS_ACTIVE)},f.prototype.resetPanelState_=function(e){for(var t=0;t<e.length;t++)e[t].classList.remove(this.CssClasses_.IS_ACTIVE)},f.prototype.toggleDrawer=function(){var e=this.innerContainer_.querySelector("."+this.CssClasses_.DRAWER_BTN);this.drawer_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN),this.obfuscator_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN),this.drawer_.classList.contains(this.CssClasses_.IS_DRAWER_OPEN)?(this.drawer_.setAttribute("aria-hidden","false"),e.setAttribute("aria-expanded","true")):(this.drawer_.setAttribute("aria-hidden","true"),e.setAttribute("aria-expanded","false"))},f.prototype.toggleDrawer=f.prototype.toggleDrawer,f.prototype.init=function(){if(this.element_){var e=this.element_.querySelector(":focus");e&&e.focus();for(var s=this.innerContainer_.childNodes,i=s.length,n=0;n<i;n++){var a=s[n];a.classList&&a.classList.contains(this.CssClasses_.HEADER)&&(this.header_=a),a.classList&&a.classList.contains(this.CssClasses_.DRAWER)&&(this.drawer_=a),a.classList&&a.classList.contains(this.CssClasses_.CONTENT)&&(this.content_=a)}window.addEventListener("pageshow",function(e){e.persisted&&(this.innerContainer_.style.overflowY="hidden",requestAnimationFrame(function(){this.innerContainer_.style.overflowY=""}.bind(this)))}.bind(this),!1),this.header_&&(this.tabBar_=this.header_.querySelector("."+this.CssClasses_.TAB_BAR));var l=this.Mode_.STANDARD;if(this.header_&&(this.header_.classList.contains(this.CssClasses_.HEADER_SEAMED)?l=this.Mode_.SEAMED:this.header_.classList.contains(this.CssClasses_.HEADER_WATERFALL)?(l=this.Mode_.WATERFALL,this.header_.addEventListener("transitionend",this.headerTransitionEndHandler_.bind(this)),this.header_.addEventListener("click",this.headerClickHandler_.bind(this))):this.header_.classList.contains(this.CssClasses_.HEADER_SCROLL)&&(l=this.Mode_.SCROLL,this.element_.classList.add(this.CssClasses_.HAS_SCROLLING_HEADER)),l===this.Mode_.STANDARD?(this.header_.classList.add(this.CssClasses_.CASTING_SHADOW),this.tabBar_&&this.tabBar_.classList.add(this.CssClasses_.CASTING_SHADOW)):l===this.Mode_.SEAMED||l===this.Mode_.SCROLL?(this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW),this.tabBar_&&this.tabBar_.classList.remove(this.CssClasses_.CASTING_SHADOW)):l===this.Mode_.WATERFALL&&(this.content_.addEventListener("scroll",this.contentScrollHandler_.bind(this)),this.contentScrollHandler_())),this.drawer_){var o=this.innerContainer_.querySelector("."+this.CssClasses_.DRAWER_BTN);if(!o){o=document.createElement("div"),o.setAttribute("aria-expanded","false"),o.setAttribute("role","button"),o.setAttribute("tabindex","0"),o.classList.add(this.CssClasses_.DRAWER_BTN);var r=document.createElement("i");r.classList.add(this.CssClasses_.ICON),r.innerHTML=this.Constant_.MENU_ICON,o.appendChild(r)}this.drawer_.classList.contains(this.CssClasses_.ON_LARGE_SCREEN)?o.classList.add(this.CssClasses_.ON_LARGE_SCREEN):this.drawer_.classList.contains(this.CssClasses_.ON_SMALL_SCREEN)&&o.classList.add(this.CssClasses_.ON_SMALL_SCREEN),o.addEventListener("click",this.drawerToggleHandler_.bind(this)),o.addEventListener("keydown",this.drawerToggleHandler_.bind(this)),this.element_.classList.add(this.CssClasses_.HAS_DRAWER),this.element_.classList.contains(this.CssClasses_.FIXED_HEADER)?this.header_.insertBefore(o,this.header_.firstChild):this.innerContainer_.insertBefore(o,this.content_);var _=document.createElement("div");_.classList.add(this.CssClasses_.OBFUSCATOR),this.innerContainer_.appendChild(_),_.addEventListener("click",this.drawerToggleHandler_.bind(this)),this.obfuscator_=_,this.drawer_.addEventListener("keydown",this.keyboardEventHandler_.bind(this)),this.drawer_.setAttribute("aria-hidden","true")}if(this.screenSizeMediaQuery_=window.matchMedia(this.Constant_.MAX_WIDTH),this.screenSizeMediaQuery_.addListener(this.screenSizeHandler_.bind(this)),this.screenSizeHandler_(),this.header_&&this.tabBar_){this.element_.classList.add(this.CssClasses_.HAS_TABS);var d=document.createElement("div");d.classList.add(this.CssClasses_.TAB_CONTAINER),this.header_.insertBefore(d,this.tabBar_),this.header_.removeChild(this.tabBar_);var h=document.createElement("div");h.classList.add(this.CssClasses_.TAB_BAR_BUTTON),h.classList.add(this.CssClasses_.TAB_BAR_LEFT_BUTTON);var c=document.createElement("i");c.classList.add(this.CssClasses_.ICON),c.textContent=this.Constant_.CHEVRON_LEFT,h.appendChild(c),h.addEventListener("click",function(){this.tabBar_.scrollLeft-=this.Constant_.TAB_SCROLL_PIXELS}.bind(this));var p=document.createElement("div");p.classList.add(this.CssClasses_.TAB_BAR_BUTTON),p.classList.add(this.CssClasses_.TAB_BAR_RIGHT_BUTTON);var C=document.createElement("i");C.classList.add(this.CssClasses_.ICON),C.textContent=this.Constant_.CHEVRON_RIGHT,p.appendChild(C),p.addEventListener("click",function(){this.tabBar_.scrollLeft+=this.Constant_.TAB_SCROLL_PIXELS}.bind(this)),d.appendChild(h),d.appendChild(this.tabBar_),d.appendChild(p);var u=function(){this.tabBar_.scrollLeft>0?h.classList.add(this.CssClasses_.IS_ACTIVE):h.classList.remove(this.CssClasses_.IS_ACTIVE),this.tabBar_.scrollLeft<this.tabBar_.scrollWidth-this.tabBar_.offsetWidth?p.classList.add(this.CssClasses_.IS_ACTIVE):p.classList.remove(this.CssClasses_.IS_ACTIVE)}.bind(this);this.tabBar_.addEventListener("scroll",u),u();var E=function(){this.resizeTimeoutId_&&clearTimeout(this.resizeTimeoutId_),this.resizeTimeoutId_=setTimeout(function(){u(),this.resizeTimeoutId_=null}.bind(this),this.Constant_.RESIZE_TIMEOUT)}.bind(this);window.addEventListener("resize",E),this.tabBar_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)&&this.tabBar_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);for(var m=this.tabBar_.querySelectorAll("."+this.CssClasses_.TAB),L=this.content_.querySelectorAll("."+this.CssClasses_.PANEL),I=0;I<m.length;I++)new t(m[I],m,L,this)}this.element_.classList.add(this.CssClasses_.IS_UPGRADED)}},window.MaterialLayoutTab=t,s.register({constructor:f,classAsString:"MaterialLayout",cssClass:"mdl-js-layout"});var b=function(e){this.element_=e,this.init()};window.MaterialDataTable=b,b.prototype.Constant_={},b.prototype.CssClasses_={DATA_TABLE:"mdl-data-table",SELECTABLE:"mdl-data-table--selectable",SELECT_ELEMENT:"mdl-data-table__select",IS_SELECTED:"is-selected",IS_UPGRADED:"is-upgraded"},b.prototype.selectRow_=function(e,t,s){return t?function(){e.checked?t.classList.add(this.CssClasses_.IS_SELECTED):t.classList.remove(this.CssClasses_.IS_SELECTED)}.bind(this):s?function(){var t,i;if(e.checked)for(t=0;t<s.length;t++)i=s[t].querySelector("td").querySelector(".mdl-checkbox"),i.MaterialCheckbox.check(),s[t].classList.add(this.CssClasses_.IS_SELECTED);else for(t=0;t<s.length;t++)i=s[t].querySelector("td").querySelector(".mdl-checkbox"),i.MaterialCheckbox.uncheck(),s[t].classList.remove(this.CssClasses_.IS_SELECTED)}.bind(this):void 0},b.prototype.createCheckbox_=function(e,t){var i=document.createElement("label"),n=["mdl-checkbox","mdl-js-checkbox","mdl-js-ripple-effect",this.CssClasses_.SELECT_ELEMENT];i.className=n.join(" ");var a=document.createElement("input");return a.type="checkbox",a.classList.add("mdl-checkbox__input"),e?(a.checked=e.classList.contains(this.CssClasses_.IS_SELECTED),a.addEventListener("change",this.selectRow_(a,e))):t&&a.addEventListener("change",this.selectRow_(a,null,t)),i.appendChild(a),s.upgradeElement(i,"MaterialCheckbox"),i},b.prototype.init=function(){if(this.element_){var e=this.element_.querySelector("th"),t=Array.prototype.slice.call(this.element_.querySelectorAll("tbody tr")),s=Array.prototype.slice.call(this.element_.querySelectorAll("tfoot tr")),i=t.concat(s);if(this.element_.classList.contains(this.CssClasses_.SELECTABLE)){var n=document.createElement("th"),a=this.createCheckbox_(null,i);n.appendChild(a),e.parentElement.insertBefore(n,e);for(var l=0;l<i.length;l++){var o=i[l].querySelector("td");if(o){var r=document.createElement("td");if("TBODY"===i[l].parentNode.nodeName.toUpperCase()){var _=this.createCheckbox_(i[l]);r.appendChild(_)}i[l].insertBefore(r,o)}}this.element_.classList.add(this.CssClasses_.IS_UPGRADED)}}},s.register({constructor:b,classAsString:"MaterialDataTable",cssClass:"mdl-js-data-table"});var y=function(e){this.element_=e,this.init()};window.MaterialRipple=y,y.prototype.Constant_={INITIAL_SCALE:"scale(0.0001, 0.0001)",INITIAL_SIZE:"1px",INITIAL_OPACITY:"0.4",FINAL_OPACITY:"0",FINAL_SCALE:""},y.prototype.CssClasses_={RIPPLE_CENTER:"mdl-ripple--center",RIPPLE_EFFECT_IGNORE_EVENTS:"mdl-js-ripple-effect--ignore-events",RIPPLE:"mdl-ripple",IS_ANIMATING:"is-animating",IS_VISIBLE:"is-visible"},y.prototype.downHandler_=function(e){if(!this.rippleElement_.style.width&&!this.rippleElement_.style.height){var t=this.element_.getBoundingClientRect();this.boundHeight=t.height,this.boundWidth=t.width,this.rippleSize_=2*Math.sqrt(t.width*t.width+t.height*t.height)+2,this.rippleElement_.style.width=this.rippleSize_+"px",this.rippleElement_.style.height=this.rippleSize_+"px"}if(this.rippleElement_.classList.add(this.CssClasses_.IS_VISIBLE),"mousedown"===e.type&&this.ignoringMouseDown_)this.ignoringMouseDown_=!1;else{"touchstart"===e.type&&(this.ignoringMouseDown_=!0);var s=this.getFrameCount();if(s>0)return;this.setFrameCount(1);var i,n,a=e.currentTarget.getBoundingClientRect();if(0===e.clientX&&0===e.clientY)i=Math.round(a.width/2),n=Math.round(a.height/2);else{var l=e.clientX?e.clientX:e.touches[0].clientX,o=e.clientY?e.clientY:e.touches[0].clientY;i=Math.round(l-a.left),n=Math.round(o-a.top)}this.setRippleXY(i,n),this.setRippleStyles(!0),window.requestAnimationFrame(this.animFrameHandler.bind(this))}},y.prototype.upHandler_=function(e){e&&2!==e.detail&&window.setTimeout(function(){this.rippleElement_.classList.remove(this.CssClasses_.IS_VISIBLE)}.bind(this),0)},y.prototype.init=function(){if(this.element_){var e=this.element_.classList.contains(this.CssClasses_.RIPPLE_CENTER);this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT_IGNORE_EVENTS)||(this.rippleElement_=this.element_.querySelector("."+this.CssClasses_.RIPPLE),this.frameCount_=0,this.rippleSize_=0,this.x_=0,this.y_=0,this.ignoringMouseDown_=!1,this.boundDownHandler=this.downHandler_.bind(this),this.element_.addEventListener("mousedown",this.boundDownHandler),this.element_.addEventListener("touchstart",this.boundDownHandler),this.boundUpHandler=this.upHandler_.bind(this),this.element_.addEventListener("mouseup",this.boundUpHandler),this.element_.addEventListener("mouseleave",this.boundUpHandler),this.element_.addEventListener("touchend",this.boundUpHandler),this.element_.addEventListener("blur",this.boundUpHandler),this.getFrameCount=function(){return this.frameCount_},this.setFrameCount=function(e){this.frameCount_=e},this.getRippleElement=function(){return this.rippleElement_},this.setRippleXY=function(e,t){this.x_=e,this.y_=t},this.setRippleStyles=function(t){if(null!==this.rippleElement_){var s,i,n,a="translate("+this.x_+"px, "+this.y_+"px)";t?(i=this.Constant_.INITIAL_SCALE,n=this.Constant_.INITIAL_SIZE):(i=this.Constant_.FINAL_SCALE,n=this.rippleSize_+"px",e&&(a="translate("+this.boundWidth/2+"px, "+this.boundHeight/2+"px)")),s="translate(-50%, -50%) "+a+i,this.rippleElement_.style.webkitTransform=s,this.rippleElement_.style.msTransform=s,this.rippleElement_.style.transform=s,t?this.rippleElement_.classList.remove(this.CssClasses_.IS_ANIMATING):this.rippleElement_.classList.add(this.CssClasses_.IS_ANIMATING)}},this.animFrameHandler=function(){this.frameCount_-- >0?window.requestAnimationFrame(this.animFrameHandler.bind(this)):this.setRippleStyles(!1)})}},s.register({constructor:y,classAsString:"MaterialRipple",cssClass:"mdl-js-ripple-effect",widget:!1})}}();
	//# sourceMappingURL=material.min.js.map


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _clamp = __webpack_require__(241);
	
	var _clamp2 = _interopRequireDefault(_clamp);
	
	var _shadows = __webpack_require__(449);
	
	var _shadows2 = _interopRequireDefault(_shadows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    shadow: _react.PropTypes.number
	};
	
	var Card = function Card(props) {
	    var className = props.className;
	    var shadow = props.shadow;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'shadow', 'children']);
	
	    var hasShadow = typeof shadow !== 'undefined';
	    var shadowLevel = (0, _clamp2.default)(shadow || 0, 0, _shadows2.default.length - 1);
	
	    var classes = (0, _classnames2.default)('mdl-card', _defineProperty({}, _shadows2.default[shadowLevel], hasShadow), className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	Card.propTypes = propTypes;
	
	exports.default = Card;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    border: _react.PropTypes.bool,
	    className: _react.PropTypes.string
	};
	
	var CardActions = function CardActions(props) {
	    var className = props.className;
	    var border = props.border;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'border', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-card__actions', {
	        'mdl-card--border': border
	    }, className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	CardActions.propTypes = propTypes;
	
	exports.default = CardActions;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    expand: _react.PropTypes.bool
	};
	
	var CardTitle = function CardTitle(props) {
	    var className = props.className;
	    var children = props.children;
	    var expand = props.expand;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'children', 'expand']);
	
	    var classes = (0, _classnames2.default)('mdl-card__title', {
	        'mdl-card--expand': expand
	    }, className);
	
	    var title = typeof children === 'string' ? _react2.default.createElement(
	        'h2',
	        { className: 'mdl-card__title-text' },
	        children
	    ) : children;
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        title
	    );
	};
	
	CardTitle.propTypes = propTypes;
	
	exports.default = CardTitle;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(103);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FABButton = function FABButton(props) {
	    var mini = props.mini;
	    var className = props.className;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['mini', 'className', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-button--fab', {
	        'mdl-button--mini-fab': mini
	    }, className);
	
	    return _react2.default.createElement(
	        _Button2.default,
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	FABButton.propTypes = {
	    className: _react.PropTypes.string,
	    mini: _react.PropTypes.bool
	};
	
	exports.default = FABButton;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Content = function Content(props) {
	    var children = props.children;
	    var className = props.className;
	    var component = props.component;
	
	    var otherProps = _objectWithoutProperties(props, ['children', 'className', 'component']);
	
	    var classes = (0, _classnames2.default)('mdl-layout__content', className);
	
	    return _react2.default.createElement(component || 'div', _extends({
	        className: classes
	    }, otherProps), children);
	};
	
	Content.propTypes = {
	    className: _react.PropTypes.string,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func])
	};
	
	exports.default = Content;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Drawer = function Drawer(props) {
	    var className = props.className;
	    var title = props.title;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'title', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-layout__drawer', className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        title ? _react2.default.createElement(
	            'span',
	            { className: 'mdl-layout-title' },
	            title
	        ) : null,
	        children
	    );
	};
	Drawer.propTypes = {
	    className: _react.PropTypes.string,
	    title: _react.PropTypes.node
	};
	
	exports.default = Drawer;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _HeaderRow = __webpack_require__(188);
	
	var _HeaderRow2 = _interopRequireDefault(_HeaderRow);
	
	var _HeaderTabs = __webpack_require__(189);
	
	var _HeaderTabs2 = _interopRequireDefault(_HeaderTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Header = function Header(props) {
	    var className = props.className;
	    var scroll = props.scroll;
	    var seamed = props.seamed;
	    var title = props.title;
	    var transparent = props.transparent;
	    var waterfall = props.waterfall;
	    var hideTop = props.hideTop;
	    var hideSpacer = props.hideSpacer;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'scroll', 'seamed', 'title', 'transparent', 'waterfall', 'hideTop', 'hideSpacer', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-layout__header', {
	        'mdl-layout__header--scroll': scroll,
	        'mdl-layout__header--seamed': seamed,
	        'mdl-layout__header--transparent': transparent,
	        'mdl-layout__header--waterfall': waterfall,
	        'mdl-layout__header--waterfall-hide-top': waterfall && hideTop
	    }, className);
	
	    var isRowOrTab = false;
	    _react2.default.Children.forEach(children, function (child) {
	        if (child && (child.type === _HeaderRow2.default || child.type === _HeaderTabs2.default)) {
	            isRowOrTab = true;
	        }
	    });
	
	    return _react2.default.createElement(
	        'header',
	        _extends({ className: classes }, otherProps),
	        isRowOrTab ? children : _react2.default.createElement(
	            _HeaderRow2.default,
	            { title: title, hideSpacer: hideSpacer },
	            children
	        )
	    );
	};
	Header.propTypes = {
	    className: _react.PropTypes.string,
	    scroll: _react.PropTypes.bool,
	    seamed: _react.PropTypes.bool,
	    title: _react.PropTypes.node,
	    transparent: _react.PropTypes.bool,
	    waterfall: _react.PropTypes.bool,
	    hideTop: _react.PropTypes.bool,
	    hideSpacer: _react.PropTypes.bool
	};
	
	exports.default = Header;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(27);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    fixedDrawer: _react.PropTypes.bool,
	    fixedHeader: _react.PropTypes.bool,
	    fixedTabs: _react.PropTypes.bool
	};
	
	// eslint-disable-next-line react/prefer-stateless-function
	
	var Layout = function (_React$Component) {
	    _inherits(Layout, _React$Component);
	
	    function Layout() {
	        _classCallCheck(this, Layout);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Layout).apply(this, arguments));
	    }
	
	    _createClass(Layout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	            var fixedDrawer = _props.fixedDrawer;
	            var fixedHeader = _props.fixedHeader;
	            var fixedTabs = _props.fixedTabs;
	
	            var otherProps = _objectWithoutProperties(_props, ['className', 'fixedDrawer', 'fixedHeader', 'fixedTabs']);
	
	            var classes = (0, _classnames2.default)('mdl-layout mdl-js-layout', {
	                'mdl-layout--fixed-drawer': fixedDrawer,
	                'mdl-layout--fixed-header': fixedHeader,
	                'mdl-layout--fixed-tabs': fixedTabs
	            }, className);
	
	            return _react2.default.createElement(
	                'div',
	                _extends({ className: classes }, otherProps),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mdl-layout__inner-container' },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Layout);

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cloneChildren = __webpack_require__(448);
	
	var _cloneChildren2 = _interopRequireDefault(_cloneChildren);
	
	var _Spacer = __webpack_require__(104);
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Navigation = function Navigation(props) {
	    var className = props.className;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-navigation', className);
	
	    return _react2.default.createElement(
	        'nav',
	        _extends({ className: classes }, otherProps),
	        (0, _cloneChildren2.default)(children, function (child) {
	            return {
	                className: (0, _classnames2.default)({ 'mdl-navigation__link': child.type !== _Spacer2.default }, child.props.className)
	            };
	        })
	    );
	};
	Navigation.propTypes = {
	    className: _react.PropTypes.string
	};
	
	exports.default = Navigation;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Layout = __webpack_require__(436);
	
	Object.defineProperty(exports, 'Layout', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Layout).default;
	  }
	});
	
	var _Content = __webpack_require__(433);
	
	Object.defineProperty(exports, 'Content', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Content).default;
	  }
	});
	
	var _Drawer = __webpack_require__(434);
	
	Object.defineProperty(exports, 'Drawer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Drawer).default;
	  }
	});
	
	var _Header = __webpack_require__(435);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Header).default;
	  }
	});
	
	var _HeaderRow = __webpack_require__(188);
	
	Object.defineProperty(exports, 'HeaderRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderRow).default;
	  }
	});
	
	var _HeaderTabs = __webpack_require__(189);
	
	Object.defineProperty(exports, 'HeaderTabs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderTabs).default;
	  }
	});
	
	var _Navigation = __webpack_require__(437);
	
	Object.defineProperty(exports, 'Navigation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Navigation).default;
	  }
	});
	
	var _Spacer = __webpack_require__(104);
	
	Object.defineProperty(exports, 'Spacer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spacer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ListItemContent = __webpack_require__(190);
	
	var _ListItemContent2 = _interopRequireDefault(_ListItemContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    children: _react.PropTypes.node,
	    className: _react.PropTypes.string,
	    twoLine: _react.PropTypes.bool,
	    threeLine: _react.PropTypes.bool
	};
	
	var ListItem = function ListItem(props) {
	    var className = props.className;
	    var twoLine = props.twoLine;
	    var threeLine = props.threeLine;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'twoLine', 'threeLine']);
	
	    var classes = (0, _classnames2.default)('mdl-list__item', {
	        'mdl-list__item--two-line': twoLine && !threeLine,
	        'mdl-list__item--three-line': !twoLine && threeLine
	    }, className);
	
	    var children = _react.Children.map(otherProps.children, function (child) {
	        if (typeof child === 'string') {
	            return _react2.default.createElement(
	                _ListItemContent2.default,
	                null,
	                child
	            );
	        }
	        if (child.type === _ListItemContent2.default) {
	            return (0, _react.cloneElement)(child, {
	                useBodyClass: !!threeLine
	            });
	        }
	        return child;
	    });
	
	    return _react2.default.createElement(
	        'li',
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	ListItem.propTypes = propTypes;
	
	exports.default = ListItem;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    children: _react.PropTypes.node,
	    className: _react.PropTypes.string,
	    info: _react.PropTypes.string
	};
	
	var ListItemAction = function ListItemAction(props) {
	    var children = props.children;
	    var className = props.className;
	    var info = props.info;
	
	    var otherProps = _objectWithoutProperties(props, ['children', 'className', 'info']);
	
	    var classes = (0, _classnames2.default)('mdl-list__item-secondary-content', className);
	
	    return _react2.default.createElement(
	        'span',
	        _extends({ className: classes }, otherProps),
	        info && _react2.default.createElement(
	            'span',
	            { className: 'mdl-list__item-secondary-info' },
	            info
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'mdl-list__item-secondary-action' },
	            children
	        )
	    );
	};
	
	ListItemAction.propTypes = propTypes;
	
	exports.default = ListItemAction;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItemContent = exports.ListItemAction = exports.ListItem = exports.List = undefined;
	
	var _ListItem = __webpack_require__(439);
	
	Object.defineProperty(exports, 'ListItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItem).default;
	  }
	});
	
	var _ListItemAction = __webpack_require__(440);
	
	Object.defineProperty(exports, 'ListItemAction', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItemAction).default;
	  }
	});
	
	var _ListItemContent = __webpack_require__(190);
	
	Object.defineProperty(exports, 'ListItemContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItemContent).default;
	  }
	});
	
	var _basicClassCreator = __webpack_require__(106);
	
	var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = exports.List = (0, _basicClassCreator2.default)('List', 'mdl-list', 'ul');

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(27);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    singleColor: _react.PropTypes.bool
	};
	
	// eslint-disable-next-line react/prefer-stateless-function
	
	var Spinner = function (_React$Component) {
	    _inherits(Spinner, _React$Component);
	
	    function Spinner() {
	        _classCallCheck(this, Spinner);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Spinner).apply(this, arguments));
	    }
	
	    _createClass(Spinner, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	            var singleColor = _props.singleColor;
	
	            var otherProps = _objectWithoutProperties(_props, ['className', 'singleColor']);
	
	            var classes = (0, _classnames2.default)('mdl-spinner mdl-js-spinner is-active', {
	                'mdl-spinner--single-color': singleColor
	            }, className);
	
	            return _react2.default.createElement('div', _extends({ className: classes }, otherProps));
	        }
	    }]);
	
	    return Spinner;
	}(_react2.default.Component);
	
	Spinner.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Spinner);

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(66);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(27);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    checked: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    onChange: _react.PropTypes.func,
	    ripple: _react.PropTypes.bool
	};
	
	var Switch = function (_React$Component) {
	    _inherits(Switch, _React$Component);
	
	    function Switch() {
	        _classCallCheck(this, Switch);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Switch).apply(this, arguments));
	    }
	
	    _createClass(Switch, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.disabled !== prevProps.disabled) {
	                var fnName = this.props.disabled ? 'disable' : 'enable';
	                (0, _reactDom.findDOMNode)(this).MaterialSwitch[fnName]();
	            }
	            if (this.props.checked !== prevProps.checked) {
	                var _fnName = this.props.checked ? 'on' : 'off';
	                (0, _reactDom.findDOMNode)(this).MaterialSwitch[_fnName]();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	            var ripple = _props.ripple;
	            var children = _props.children;
	
	            var inputProps = _objectWithoutProperties(_props, ['className', 'ripple', 'children']);
	
	            var classes = (0, _classnames2.default)('mdl-switch mdl-js-switch', {
	                'mdl-js-ripple-effect': ripple
	            }, className);
	
	            return _react2.default.createElement(
	                'label',
	                { className: classes },
	                _react2.default.createElement('input', _extends({
	                    type: 'checkbox',
	                    className: 'mdl-switch__input'
	                }, inputProps)),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mdl-switch__label' },
	                    children
	                )
	            );
	        }
	    }]);
	
	    return Switch;
	}(_react2.default.Component);
	
	Switch.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Switch);

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Tab = __webpack_require__(191);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabBar = __webpack_require__(105);
	
	var _TabBar2 = _interopRequireDefault(_TabBar);
	
	var _mdlUpgrade = __webpack_require__(27);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TabPropType = function TabPropType(props, propName, componentName) {
	    var prop = props[propName];
	    return prop.type !== _Tab2.default && new Error('\'' + componentName + '\' only accepts \'Tab\' as children.');
	};
	
	var propTypes = {
	    activeTab: _react.PropTypes.number,
	    children: _react.PropTypes.oneOfType([TabPropType, _react.PropTypes.arrayOf(TabPropType)]),
	    className: _react.PropTypes.string,
	    onChange: _react.PropTypes.func,
	    tabBarProps: _react.PropTypes.object,
	    ripple: _react.PropTypes.bool
	};
	
	var Tabs = function Tabs(props) {
	    var activeTab = props.activeTab;
	    var className = props.className;
	    var onChange = props.onChange;
	    var children = props.children;
	    var tabBarProps = props.tabBarProps;
	    var ripple = props.ripple;
	
	    var otherProps = _objectWithoutProperties(props, ['activeTab', 'className', 'onChange', 'children', 'tabBarProps', 'ripple']);
	
	    var classes = (0, _classnames2.default)('mdl-tabs mdl-js-tabs', {
	        'mdl-js-ripple-effect': ripple
	    }, className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        _react2.default.createElement(
	            _TabBar2.default,
	            _extends({ cssPrefix: 'mdl-tabs', activeTab: activeTab, onChange: onChange }, tabBarProps),
	            children
	        )
	    );
	};
	
	Tabs.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Tabs);

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tabs = __webpack_require__(444);
	
	Object.defineProperty(exports, 'Tabs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tabs).default;
	  }
	});
	
	var _TabBar = __webpack_require__(105);
	
	Object.defineProperty(exports, 'TabBar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TabBar).default;
	  }
	});
	
	var _Tab = __webpack_require__(191);
	
	Object.defineProperty(exports, 'Tab', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tab).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(66);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(27);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    error: _react.PropTypes.node,
	    expandable: _react.PropTypes.bool,
	    expandableIcon: _react.PropTypes.string,
	    floatingLabel: _react.PropTypes.bool,
	    id: _react.PropTypes.string,
	    inputClassName: _react.PropTypes.string,
	    label: _react.PropTypes.string.isRequired,
	    maxRows: _react.PropTypes.number,
	    onChange: _react.PropTypes.func,
	    pattern: _react.PropTypes.string,
	    required: _react.PropTypes.bool,
	    rows: _react.PropTypes.number,
	    style: _react.PropTypes.object,
	    value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
	};
	
	var Textfield = function (_React$Component) {
	    _inherits(Textfield, _React$Component);
	
	    function Textfield() {
	        _classCallCheck(this, Textfield);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Textfield).apply(this, arguments));
	    }
	
	    _createClass(Textfield, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.error && !this.props.pattern) {
	                this.setAsInvalid();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.required !== prevProps.required || this.props.pattern !== prevProps.pattern || this.props.error !== prevProps.error) {
	                (0, _reactDom.findDOMNode)(this).MaterialTextfield.checkValidity();
	            }
	            if (this.props.disabled !== prevProps.disabled) {
	                (0, _reactDom.findDOMNode)(this).MaterialTextfield.checkDisabled();
	            }
	            if (this.props.value !== prevProps.value && this.inputRef !== document.activeElement) {
	                (0, _reactDom.findDOMNode)(this).MaterialTextfield.change(this.props.value);
	            }
	            if (this.props.error && !this.props.pattern) {
	                // Every time the input gets updated by MDL (checkValidity() or change())
	                // its invalid class gets reset. We have to put it again if the input is specifically set as "invalid"
	                this.setAsInvalid();
	            }
	        }
	    }, {
	        key: 'setAsInvalid',
	        value: function setAsInvalid() {
	            var elt = (0, _reactDom.findDOMNode)(this);
	            if (elt.className.indexOf('is-invalid') < 0) {
	                elt.className = (0, _classnames2.default)(elt.className, 'is-invalid');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var className = _props.className;
	            var inputClassName = _props.inputClassName;
	            var id = _props.id;
	            var error = _props.error;
	            var expandable = _props.expandable;
	            var expandableIcon = _props.expandableIcon;
	            var floatingLabel = _props.floatingLabel;
	            var label = _props.label;
	            var maxRows = _props.maxRows;
	            var rows = _props.rows;
	            var style = _props.style;
	            var children = _props.children;
	
	            var otherProps = _objectWithoutProperties(_props, ['className', 'inputClassName', 'id', 'error', 'expandable', 'expandableIcon', 'floatingLabel', 'label', 'maxRows', 'rows', 'style', 'children']);
	
	            var hasRows = !!rows;
	            var customId = id || 'textfield-' + label.replace(/[^a-z0-9]/gi, '');
	            var inputTag = hasRows || maxRows > 1 ? 'textarea' : 'input';
	
	            var inputProps = _extends({
	                className: (0, _classnames2.default)('mdl-textfield__input', inputClassName),
	                id: customId,
	                rows: rows,
	                ref: function ref(c) {
	                    return _this2.inputRef = c;
	                }
	            }, otherProps);
	
	            var input = _react2.default.createElement(inputTag, inputProps);
	            var labelContainer = _react2.default.createElement(
	                'label',
	                { className: 'mdl-textfield__label', htmlFor: customId },
	                label
	            );
	            var errorContainer = !!error && _react2.default.createElement(
	                'span',
	                { className: 'mdl-textfield__error' },
	                error
	            );
	
	            var containerClasses = (0, _classnames2.default)('mdl-textfield mdl-js-textfield', {
	                'mdl-textfield--floating-label': floatingLabel,
	                'mdl-textfield--expandable': expandable
	            }, className);
	
	            return expandable ? _react2.default.createElement(
	                'div',
	                { className: containerClasses, style: style },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'mdl-button mdl-js-button mdl-button--icon', htmlFor: customId },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'material-icons' },
	                        expandableIcon
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mdl-textfield__expandable-holder' },
	                    input,
	                    labelContainer,
	                    errorContainer
	                ),
	                children
	            ) : _react2.default.createElement(
	                'div',
	                { className: containerClasses, style: style },
	                input,
	                labelContainer,
	                errorContainer,
	                children
	            );
	        }
	    }]);
	
	    return Textfield;
	}(_react2.default.Component);
	
	Textfield.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Textfield);

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(66);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MDLComponent = function (_Component) {
	    _inherits(MDLComponent, _Component);
	
	    function MDLComponent() {
	        _classCallCheck(this, MDLComponent);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(MDLComponent).apply(this, arguments));
	    }
	
	    _createClass(MDLComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.componentHandler.upgradeElement((0, _reactDom.findDOMNode)(this));
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.componentHandler.downgradeElements((0, _reactDom.findDOMNode)(this));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react.Children.only(this.props.children);
	        }
	    }]);
	
	    return MDLComponent;
	}(_react.Component);
	
	exports.default = MDLComponent;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (children, props) {
	    return _react2.default.Children.map(children, function (child) {
	        if (!child) return child;
	        var newProps = typeof props === 'function' ? props(child) : props;
	        return _react2.default.cloneElement(child, newProps);
	    });
	};

/***/ },
/* 449 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var values = [2, 3, 4, 6, 8, 16, 24];
	exports.default = values.map(function (v) {
	  return "mdl-shadow--" + v + "dp";
	});

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(192);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(193);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(22);
	
	var _InternalPropTypes = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(22);
	
	var _InternalPropTypes = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(144);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(49);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(109);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(28);
	
	var _RouterContext = __webpack_require__(69);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(22);
	
	var _RouterUtils = __webpack_require__(194);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(69);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(107);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(69);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(290);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(196);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(34);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(107);
	
	var _makeStateWithLocation = __webpack_require__(197);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(34);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(144);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(196);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(22);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(108);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(34);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(457);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(192);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(451);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(471);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(452);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(453);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(193);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(455);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(450);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(454);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(456);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(470);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(69);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(458);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(468);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(198);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(460);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(461);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(465);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(195);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(34);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(195);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(109);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(22);
	
	var _RouterUtils = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation, nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(107);
	
	var _makeStateWithLocation = __webpack_require__(197);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(34);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(49);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(109);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(472);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 472 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 474 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(16);
	var EventPluginUtils = __webpack_require__(73);
	var EventPropagators = __webpack_require__(37);
	var SyntheticUIEvent = __webpack_require__(39);
	var TouchEventUtils = __webpack_require__(476);
	var ViewportMetrics = __webpack_require__(117);
	
	var keyOf = __webpack_require__(474);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    topLevelTypes.topTouchCancel,
	    topLevelTypes.topTouchEnd,
	    topLevelTypes.topTouchStart,
	    topLevelTypes.topTouchMove
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  topLevelTypes.topTouchStart,
	  topLevelTypes.topTouchCancel,
	  topLevelTypes.topTouchEnd,
	  topLevelTypes.topTouchMove,
	];
	
	var dependencies = [
	  topLevelTypes.topMouseDown,
	  topLevelTypes.topMouseMove,
	  topLevelTypes.topMouseUp,
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ },
/* 476 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ },
/* 477 */
/***/ function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(473);
	var defaultClickRejectionStrategy = __webpack_require__(477);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(36).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(475)(shouldRejectClick)
	  });
	};


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var focusNode = __webpack_require__(138);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPropagators = __webpack_require__(37);
	var ExecutionEnvironment = __webpack_require__(8);
	var FallbackCompositionState = __webpack_require__(486);
	var SyntheticCompositionEvent = __webpack_require__(525);
	var SyntheticInputEvent = __webpack_require__(528);
	
	var keyOf = __webpack_require__(20);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(199);
	var ExecutionEnvironment = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(12);
	
	var camelizeStyleName = __webpack_require__(273);
	var dangerousStyleValue = __webpack_require__(534);
	var hyphenateStyleName = __webpack_require__(279);
	var memoizeStringOnly = __webpack_require__(283);
	var warning = __webpack_require__(3);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onNativeOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPluginHub = __webpack_require__(36);
	var EventPropagators = __webpack_require__(37);
	var ExecutionEnvironment = __webpack_require__(8);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(17);
	var SyntheticEvent = __webpack_require__(19);
	
	var getEventTarget = __webpack_require__(122);
	var isEventSupported = __webpack_require__(124);
	var isTextInputElement = __webpack_require__(226);
	var keyOf = __webpack_require__(20);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(35);
	var ExecutionEnvironment = __webpack_require__(8);
	
	var createNodesFromMarkup = __webpack_require__(276);
	var emptyFunction = __webpack_require__(13);
	var getMarkupWrap = __webpack_require__(140);
	var invariant = __webpack_require__(2);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : void 0;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : void 0;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : void 0;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : void 0;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : void 0;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(20);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPropagators = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(6);
	var SyntheticMouseEvent = __webpack_require__(77);
	
	var keyOf = __webpack_require__(20);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(23);
	
	var getTextContentAccessor = __webpack_require__(224);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(29);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactChildren = __webpack_require__(202);
	var ReactComponent = __webpack_require__(204);
	var ReactClass = __webpack_require__(203);
	var ReactDOMFactories = __webpack_require__(497);
	var ReactElement = __webpack_require__(14);
	var ReactElementValidator = __webpack_require__(209);
	var ReactPropTypes = __webpack_require__(218);
	var ReactVersion = __webpack_require__(220);
	
	var onlyChild = __webpack_require__(540);
	var warning = __webpack_require__(3);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(38);
	
	var instantiateReactComponent = __webpack_require__(225);
	var KeyEscapeUtils = __webpack_require__(112);
	var shouldUpdateReactComponent = __webpack_require__(126);
	var traverseAllChildren = __webpack_require__(127);
	var warning = __webpack_require__(3);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', KeyEscapeUtils.unescape(name)) : void 0;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, removedNodes, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getNativeNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getNativeNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactComponentEnvironment = __webpack_require__(114);
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactElement = __webpack_require__(14);
	var ReactErrorUtils = __webpack_require__(115);
	var ReactInstanceMap = __webpack_require__(116);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactNodeTypes = __webpack_require__(216);
	var ReactPropTypeLocations = __webpack_require__(76);
	var ReactPropTypeLocationNames = __webpack_require__(75);
	var ReactReconciler = __webpack_require__(38);
	var ReactUpdateQueue = __webpack_require__(219);
	
	var emptyObject = __webpack_require__(46);
	var invariant = __webpack_require__(2);
	var shouldUpdateReactComponent = __webpack_require__(126);
	var warning = __webpack_require__(3);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function invokeComponentDidMountWithTimer() {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	  publicInstance.componentDidMount();
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	}
	
	function invokeComponentDidUpdateWithTimer(prevProps, prevState, prevContext) {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	  publicInstance.componentDidUpdate(prevProps, prevState, prevContext);
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	}
	
	function shouldConstruct(Component) {
	  return Component.prototype && Component.prototype.isReactComponent;
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	    this._nativeParent = null;
	    this._nativeContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} nativeParent
	   * @param {?object} nativeContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._nativeParent = nativeParent;
	    this._nativeContainerInfo = nativeContainerInfo;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst = this._constructComponent(publicProps, publicContext);
	    var renderedElement;
	
	    // Support functional components
	    if (!shouldConstruct(Component) && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : invariant(false) : void 0;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidMountWithTimer, this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (publicProps, publicContext) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(publicProps, publicContext);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(publicProps, publicContext);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (publicProps, publicContext) {
	    var Component = this._currentElement.type;
	    var instanceOrElement;
	    if (shouldConstruct(Component)) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	      instanceOrElement = new Component(publicProps, publicContext, ReactUpdateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	    } else {
	      // This can still be an instance in case of factory components
	      // but we'll count this as time spent rendering as the more common case.
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	      instanceOrElement = Component(publicProps, publicContext, ReactUpdateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	    }
	    return instanceOrElement;
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, nativeParent, nativeContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, nativeParent, nativeContainerInfo, transaction, context) {
	    var inst = this._instance;
	    if (inst.componentWillMount) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      inst.componentWillMount();
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedNodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, transaction, nativeParent, nativeContainerInfo, this._processChildContext(context));
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, this._renderedComponent._debugID !== 0 ? [this._renderedComponent._debugID] : []);
	      }
	    }
	
	    return markup;
	  },
	
	  getNativeNode: function () {
	    return ReactReconciler.getNativeNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        inst.componentWillUnmount();
	      }
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	    }
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (false) {
	      ReactInstrumentation.debugTool.onEndProcessingChildContext();
	    }
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : void 0;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : void 0;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : void 0;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : void 0;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    var willReceive = false;
	    var nextContext;
	    var nextProps;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	      inst.componentWillReceiveProps(nextProps, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate && inst.shouldComponentUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	        }
	      }
	      shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidUpdateWithTimer.bind(this, prevProps, prevState, prevContext), this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldNativeNode = ReactReconciler.getNativeNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      this._renderedNodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, transaction, this._nativeParent, this._nativeContainerInfo, this._processChildContext(context));
	
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetChildren(this._debugID, this._renderedComponent._debugID !== 0 ? [this._renderedComponent._debugID] : []);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldNativeNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldNativeNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldNativeNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	    var renderedComponent = inst.render();
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDefaultInjection = __webpack_require__(509);
	var ReactMount = __webpack_require__(213);
	var ReactReconciler = __webpack_require__(38);
	var ReactUpdates = __webpack_require__(17);
	var ReactVersion = __webpack_require__(220);
	
	var findDOMNode = __webpack_require__(535);
	var getNativeComponentFromComposite = __webpack_require__(223);
	var renderSubtreeIntoContainer = __webpack_require__(542);
	var warning = __webpack_require__(3);
	
	ReactDefaultInjection.inject();
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getNativeComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(71);
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: DisabledInputUtils.getNativeProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var AutoFocusUtils = __webpack_require__(479);
	var CSSPropertyOperations = __webpack_require__(481);
	var DOMLazyTree = __webpack_require__(35);
	var DOMNamespaces = __webpack_require__(201);
	var DOMProperty = __webpack_require__(29);
	var DOMPropertyOperations = __webpack_require__(111);
	var EventConstants = __webpack_require__(16);
	var EventPluginHub = __webpack_require__(36);
	var EventPluginRegistry = __webpack_require__(72);
	var ReactBrowserEventEmitter = __webpack_require__(74);
	var ReactComponentBrowserEnvironment = __webpack_require__(205);
	var ReactDOMButton = __webpack_require__(492);
	var ReactDOMComponentFlags = __webpack_require__(206);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMInput = __webpack_require__(500);
	var ReactDOMOption = __webpack_require__(502);
	var ReactDOMSelect = __webpack_require__(207);
	var ReactDOMTextarea = __webpack_require__(505);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactMultiChild = __webpack_require__(514);
	var ReactServerRenderingTransaction = __webpack_require__(519);
	
	var emptyFunction = __webpack_require__(13);
	var escapeTextContentForBrowser = __webpack_require__(79);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(124);
	var keyOf = __webpack_require__(20);
	var shallowEqual = __webpack_require__(141);
	var validateDOMNesting = __webpack_require__(128);
	var warning = __webpack_require__(3);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : invariant(false) : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._nativeContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setContentChildForInstrumentation = emptyFunction;
	if (false) {
	  setContentChildForInstrumentation = function (contentToUse) {
	    var debugID = this._debugID;
	    var contentDebugID = debugID + '#text';
	    this._contentDebugID = contentDebugID;
	    ReactInstrumentation.debugTool.onSetDisplayName(contentDebugID, '#text');
	    ReactInstrumentation.debugTool.onSetText(contentDebugID, '' + contentToUse);
	    ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	    ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._nativeNode = null;
	  this._nativeParent = null;
	  this._rootNodeID = null;
	  this._domID = null;
	  this._nativeContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    this._contentDebugID = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the containing DOM component instance
	   * @param {?object} info about the native container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = nativeContainerInfo._idCounter++;
	    this._nativeParent = nativeParent;
	    this._nativeContainerInfo = nativeContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'object':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, nativeParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, nativeParent);
	        props = ReactDOMInput.getNativeProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, nativeParent);
	        props = ReactDOMOption.getNativeProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, nativeParent);
	        props = ReactDOMSelect.getNativeProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, nativeParent);
	        props = ReactDOMTextarea.getNativeProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (nativeParent != null) {
	      namespaceURI = nativeParent._namespaceURI;
	      parentTag = nativeParent._tag;
	    } else if (nativeContainerInfo._tag) {
	      namespaceURI = nativeContainerInfo._namespaceURI;
	      parentTag = nativeContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (nativeParent != null) {
	        parentInfo = nativeParent._ancestorInfo;
	      } else if (nativeContainerInfo._tag) {
	        parentInfo = nativeContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = nativeContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else {
	          el = ownerDocument.createElement(this._currentElement.type, props.is || null);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._nativeParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'button':
	      case 'input':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._nativeParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          this._contentDebugID = this._debugID + '#text';
	          setContentChildForInstrumentation.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        if (this._contentDebugID) {
	          ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	          this._contentDebugID = null;
	        }
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getNativeNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'iframe':
	      case 'object':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._domID = null;
	    this._wrapperState = null;
	
	    if (false) {
	      if (this._contentDebugID) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	        this._contentDebugID = null;
	      }
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(128);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMDebugTool
	 */
	
	'use strict';
	
	var ReactDOMUnknownPropertyDevtool = __webpack_require__(507);
	
	var warning = __webpack_require__(3);
	
	var eventHandlers = [];
	var handlerDoesThrowForEvent = {};
	
	function emitEvent(handlerFunctionName, arg1, arg2, arg3, arg4, arg5) {
	  if (false) {
	    eventHandlers.forEach(function (handler) {
	      try {
	        if (handler[handlerFunctionName]) {
	          handler[handlerFunctionName](arg1, arg2, arg3, arg4, arg5);
	        }
	      } catch (e) {
	        process.env.NODE_ENV !== 'production' ? warning(!handlerDoesThrowForEvent[handlerFunctionName], 'exception thrown by devtool while handling %s: %s', handlerFunctionName, e.message) : void 0;
	        handlerDoesThrowForEvent[handlerFunctionName] = true;
	      }
	    });
	  }
	}
	
	var ReactDOMDebugTool = {
	  addDevtool: function (devtool) {
	    eventHandlers.push(devtool);
	  },
	  removeDevtool: function (devtool) {
	    for (var i = 0; i < eventHandlers.length; i++) {
	      if (eventHandlers[i] === devtool) {
	        eventHandlers.splice(i, 1);
	        i--;
	      }
	    }
	  },
	  onCreateMarkupForProperty: function (name, value) {
	    emitEvent('onCreateMarkupForProperty', name, value);
	  },
	  onSetValueForProperty: function (node, name, value) {
	    emitEvent('onSetValueForProperty', node, name, value);
	  },
	  onDeleteValueForProperty: function (node, name) {
	    emitEvent('onDeleteValueForProperty', node, name);
	  }
	};
	
	ReactDOMDebugTool.addDevtool(ReactDOMUnknownPropertyDevtool);
	
	module.exports = ReactDOMDebugTool;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._nativeNode = null;
	  this._nativeParent = null;
	  this._nativeContainerInfo = null;
	  this._domID = null;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    var domID = nativeContainerInfo._idCounter++;
	    this._domID = domID;
	    this._nativeParent = nativeParent;
	    this._nativeContainerInfo = nativeContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = nativeContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getNativeNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	var ReactElementValidator = __webpack_require__(209);
	
	var mapObject = __webpack_require__(282);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 498 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(110);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DisabledInputUtils = __webpack_require__(71);
	var DOMPropertyOperations = __webpack_require__(111);
	var LinkedValueUtils = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(17);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueNull = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function warnIfValueIsNull(props) {
	  if (props != null && props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `input` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.') : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined
	    }, DisabledInputUtils.getNativeProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	      warnIfValueIsNull(props);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = props.checked !== undefined || props.value !== undefined;
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      warnIfValueIsNull(props);
	
	      var initialValue = inst._wrapperState.initialChecked || inst._wrapperState.initialValue;
	      var defaultValue = props.defaultChecked || props.defaultValue;
	      var controlled = props.checked !== undefined || props.value !== undefined;
	      var owner = inst._currentElement._owner;
	
	      if ((initialValue || !inst._wrapperState.controlled) && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && (defaultValue || !controlled) && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInstrumentation
	 */
	
	'use strict';
	
	var ReactDOMDebugTool = __webpack_require__(495);
	
	module.exports = { debugTool: ReactDOMDebugTool };

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactChildren = __webpack_require__(202);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMSelect = __webpack_require__(207);
	
	var warning = __webpack_require__(3);
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, nativeParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (nativeParent != null) {
	      var selectParent = nativeParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._nativeParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getNativeProps: function (inst, props) {
	    var nativeProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var getNodeForCharacterOffset = __webpack_require__(538);
	var getTextContentAccessor = __webpack_require__(224);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMChildrenOperations = __webpack_require__(110);
	var DOMLazyTree = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(12);
	
	var escapeTextContentForBrowser = __webpack_require__(79);
	var invariant = __webpack_require__(2);
	var validateDOMNesting = __webpack_require__(128);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._nativeNode = null;
	  this._nativeParent = null;
	
	  // Properties
	  this._domID = null;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetText(this._debugID, this._stringText);
	
	      var parentInfo;
	      if (nativeParent != null) {
	        parentInfo = nativeParent._ancestorInfo;
	      } else if (nativeContainerInfo != null) {
	        parentInfo = nativeContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting('#text', this, parentInfo);
	      }
	    }
	
	    var domID = nativeContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._nativeParent = nativeParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = nativeContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getNativeNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	
	        if (false) {
	          ReactInstrumentation.debugTool.onSetText(this._debugID, nextStringText);
	        }
	      }
	    }
	  },
	
	  getNativeNode: function () {
	    var nativeNode = this._commentNodes;
	    if (nativeNode) {
	      return nativeNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : invariant(false) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    nativeNode = [this._nativeNode, this._closingComment];
	    this._commentNodes = nativeNode;
	    return nativeNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DisabledInputUtils = __webpack_require__(71);
	var DOMPropertyOperations = __webpack_require__(111);
	var LinkedValueUtils = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(17);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValueNull = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	function warnIfValueIsNull(props) {
	  if (props != null && props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `textarea` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.') : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = _assign({}, DisabledInputUtils.getNativeProps(inst, props), {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	      warnIfValueIsNull(props);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : void 0;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : void 0;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      warnIfValueIsNull(props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_nativeNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : invariant(false) : void 0;
	  !('_nativeNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : invariant(false) : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._nativeParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._nativeParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._nativeParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._nativeParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._nativeParent;
	    instB = instB._nativeParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_nativeNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : invariant(false) : void 0;
	  !('_nativeNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : invariant(false) : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._nativeParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_nativeNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : invariant(false) : void 0;
	
	  return inst._nativeParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._nativeParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._nativeParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._nativeParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMUnknownPropertyDevtool
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(29);
	var EventPluginRegistry = __webpack_require__(72);
	
	var warning = __webpack_require__(3);
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
	      return;
	    }
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : void 0;
	
	    var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;
	
	    process.env.NODE_ENV !== 'production' ? warning(registrationName == null, 'Unknown event handler property %s. Did you mean `%s`?', name, registrationName) : void 0;
	  };
	}
	
	var ReactDOMUnknownPropertyDevtool = {
	  onCreateMarkupForProperty: function (name, value) {
	    warnUnknownProperty(name);
	  },
	  onSetValueForProperty: function (node, name, value) {
	    warnUnknownProperty(name);
	  },
	  onDeleteValueForProperty: function (node, name) {
	    warnUnknownProperty(name);
	  }
	};
	
	module.exports = ReactDOMUnknownPropertyDevtool;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactUpdates = __webpack_require__(17);
	var Transaction = __webpack_require__(78);
	
	var emptyFunction = __webpack_require__(13);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(480);
	var ChangeEventPlugin = __webpack_require__(482);
	var DefaultEventPluginOrder = __webpack_require__(484);
	var EnterLeaveEventPlugin = __webpack_require__(485);
	var HTMLDOMPropertyConfig = __webpack_require__(487);
	var ReactComponentBrowserEnvironment = __webpack_require__(205);
	var ReactDOMComponent = __webpack_require__(493);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMEmptyComponent = __webpack_require__(496);
	var ReactDOMTreeTraversal = __webpack_require__(506);
	var ReactDOMTextComponent = __webpack_require__(504);
	var ReactDefaultBatchingStrategy = __webpack_require__(508);
	var ReactEventListener = __webpack_require__(511);
	var ReactInjection = __webpack_require__(512);
	var ReactReconcileTransaction = __webpack_require__(517);
	var SVGDOMPropertyConfig = __webpack_require__(520);
	var SelectEventPlugin = __webpack_require__(521);
	var SimpleEventPlugin = __webpack_require__(522);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(36);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventListener = __webpack_require__(137);
	var ExecutionEnvironment = __webpack_require__(8);
	var PooledClass = __webpack_require__(23);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(17);
	
	var getEventTarget = __webpack_require__(122);
	var getUnboundedScrollPosition = __webpack_require__(277);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._nativeParent) {
	    inst = inst._nativeParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(29);
	var EventPluginHub = __webpack_require__(36);
	var EventPluginUtils = __webpack_require__(73);
	var ReactComponentEnvironment = __webpack_require__(114);
	var ReactClass = __webpack_require__(203);
	var ReactEmptyComponent = __webpack_require__(210);
	var ReactBrowserEventEmitter = __webpack_require__(74);
	var ReactNativeComponent = __webpack_require__(215);
	var ReactUpdates = __webpack_require__(17);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(533);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(114);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactMultiChildUpdateTypes = __webpack_require__(214);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactReconciler = __webpack_require__(38);
	var ReactChildReconciler = __webpack_require__(489);
	
	var emptyFunction = __webpack_require__(13);
	var flattenChildren = __webpack_require__(536);
	var invariant = __webpack_require__(2);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getNativeNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  setChildrenForInstrumentation = function (children) {
	    ReactInstrumentation.debugTool.onSetChildren(this._debugID, children ? Object.keys(children).map(function (key) {
	      return children[key]._debugID;
	    }) : []);
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, removedNodes, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._nativeContainerInfo, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : invariant(false) : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : invariant(false) : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, lastPlacedNode, nextIndex, transaction, context));
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getNativeNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, afterNode, index, transaction, context) {
	      var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._nativeContainerInfo, context);
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ReactDebugTool = __webpack_require__(208);
	var warning = __webpack_require__(3);
	
	function roundFloat(val) {
	  var base = arguments.length <= 1 || arguments[1] === undefined ? 2 : arguments[1];
	
	  var n = Math.pow(10, base);
	  return Math.floor(val * n) / n;
	}
	
	function getFlushHistory() {
	  return ReactDebugTool.getFlushHistory();
	}
	
	function getExclusive() {
	  var flushHistory = arguments.length <= 0 || arguments[0] === undefined ? getFlushHistory() : arguments[0];
	
	  var aggregatedStats = {};
	  var affectedIDs = {};
	
	  function updateAggregatedStats(treeSnapshot, instanceID, timerType, applyUpdate) {
	    var displayName = treeSnapshot[instanceID].displayName;
	
	    var key = displayName;
	    var stats = aggregatedStats[key];
	    if (!stats) {
	      affectedIDs[key] = {};
	      stats = aggregatedStats[key] = {
	        key: key,
	        instanceCount: 0,
	        counts: {},
	        durations: {},
	        totalDuration: 0
	      };
	    }
	    if (!stats.durations[timerType]) {
	      stats.durations[timerType] = 0;
	    }
	    if (!stats.counts[timerType]) {
	      stats.counts[timerType] = 0;
	    }
	    affectedIDs[key][instanceID] = true;
	    applyUpdate(stats);
	  }
	
	  flushHistory.forEach(function (flush) {
	    var measurements = flush.measurements;
	    var treeSnapshot = flush.treeSnapshot;
	
	    measurements.forEach(function (measurement) {
	      var duration = measurement.duration;
	      var instanceID = measurement.instanceID;
	      var timerType = measurement.timerType;
	
	      updateAggregatedStats(treeSnapshot, instanceID, timerType, function (stats) {
	        stats.totalDuration += duration;
	        stats.durations[timerType] += duration;
	        stats.counts[timerType]++;
	      });
	    });
	  });
	
	  return Object.keys(aggregatedStats).map(function (key) {
	    return _extends({}, aggregatedStats[key], {
	      instanceCount: Object.keys(affectedIDs[key]).length
	    });
	  }).sort(function (a, b) {
	    return b.totalDuration - a.totalDuration;
	  });
	}
	
	function getInclusive() {
	  var flushHistory = arguments.length <= 0 || arguments[0] === undefined ? getFlushHistory() : arguments[0];
	
	  var aggregatedStats = {};
	  var affectedIDs = {};
	
	  function updateAggregatedStats(treeSnapshot, instanceID, applyUpdate) {
	    var _treeSnapshot$instanc = treeSnapshot[instanceID];
	    var displayName = _treeSnapshot$instanc.displayName;
	    var ownerID = _treeSnapshot$instanc.ownerID;
	
	    var owner = treeSnapshot[ownerID];
	    var key = (owner ? owner.displayName + ' > ' : '') + displayName;
	    var stats = aggregatedStats[key];
	    if (!stats) {
	      affectedIDs[key] = {};
	      stats = aggregatedStats[key] = {
	        key: key,
	        instanceCount: 0,
	        inclusiveRenderDuration: 0,
	        renderCount: 0
	      };
	    }
	    affectedIDs[key][instanceID] = true;
	    applyUpdate(stats);
	  }
	
	  var isCompositeByID = {};
	  flushHistory.forEach(function (flush) {
	    var measurements = flush.measurements;
	
	    measurements.forEach(function (measurement) {
	      var instanceID = measurement.instanceID;
	      var timerType = measurement.timerType;
	
	      if (timerType !== 'render') {
	        return;
	      }
	      isCompositeByID[instanceID] = true;
	    });
	  });
	
	  flushHistory.forEach(function (flush) {
	    var measurements = flush.measurements;
	    var treeSnapshot = flush.treeSnapshot;
	
	    measurements.forEach(function (measurement) {
	      var duration = measurement.duration;
	      var instanceID = measurement.instanceID;
	      var timerType = measurement.timerType;
	
	      if (timerType !== 'render') {
	        return;
	      }
	      updateAggregatedStats(treeSnapshot, instanceID, function (stats) {
	        stats.renderCount++;
	      });
	      var nextParentID = instanceID;
	      while (nextParentID) {
	        // As we traverse parents, only count inclusive time towards composites.
	        // We know something is a composite if its render() was called.
	        if (isCompositeByID[nextParentID]) {
	          updateAggregatedStats(treeSnapshot, nextParentID, function (stats) {
	            stats.inclusiveRenderDuration += duration;
	          });
	        }
	        nextParentID = treeSnapshot[nextParentID].parentID;
	      }
	    });
	  });
	
	  return Object.keys(aggregatedStats).map(function (key) {
	    return _extends({}, aggregatedStats[key], {
	      instanceCount: Object.keys(affectedIDs[key]).length
	    });
	  }).sort(function (a, b) {
	    return b.inclusiveRenderDuration - a.inclusiveRenderDuration;
	  });
	}
	
	function getWasted() {
	  var flushHistory = arguments.length <= 0 || arguments[0] === undefined ? getFlushHistory() : arguments[0];
	
	  var aggregatedStats = {};
	  var affectedIDs = {};
	
	  function updateAggregatedStats(treeSnapshot, instanceID, applyUpdate) {
	    var _treeSnapshot$instanc2 = treeSnapshot[instanceID];
	    var displayName = _treeSnapshot$instanc2.displayName;
	    var ownerID = _treeSnapshot$instanc2.ownerID;
	
	    var owner = treeSnapshot[ownerID];
	    var key = (owner ? owner.displayName + ' > ' : '') + displayName;
	    var stats = aggregatedStats[key];
	    if (!stats) {
	      affectedIDs[key] = {};
	      stats = aggregatedStats[key] = {
	        key: key,
	        instanceCount: 0,
	        inclusiveRenderDuration: 0,
	        renderCount: 0
	      };
	    }
	    affectedIDs[key][instanceID] = true;
	    applyUpdate(stats);
	  }
	
	  flushHistory.forEach(function (flush) {
	    var measurements = flush.measurements;
	    var treeSnapshot = flush.treeSnapshot;
	    var operations = flush.operations;
	
	    var isDefinitelyNotWastedByID = {};
	
	    // Find native components associated with an operation in this batch.
	    // Mark all components in their parent tree as definitely not wasted.
	    operations.forEach(function (operation) {
	      var instanceID = operation.instanceID;
	
	      var nextParentID = instanceID;
	      while (nextParentID) {
	        isDefinitelyNotWastedByID[nextParentID] = true;
	        nextParentID = treeSnapshot[nextParentID].parentID;
	      }
	    });
	
	    // Find composite components that rendered in this batch.
	    // These are potential candidates for being wasted renders.
	    var renderedCompositeIDs = {};
	    measurements.forEach(function (measurement) {
	      var instanceID = measurement.instanceID;
	      var timerType = measurement.timerType;
	
	      if (timerType !== 'render') {
	        return;
	      }
	      renderedCompositeIDs[instanceID] = true;
	    });
	
	    measurements.forEach(function (measurement) {
	      var duration = measurement.duration;
	      var instanceID = measurement.instanceID;
	      var timerType = measurement.timerType;
	
	      if (timerType !== 'render') {
	        return;
	      }
	
	      // If there was a DOM update below this component, or it has just been
	      // mounted, its render() is not considered wasted.
	      var updateCount = treeSnapshot[instanceID].updateCount;
	
	      if (isDefinitelyNotWastedByID[instanceID] || updateCount === 0) {
	        return;
	      }
	
	      // We consider this render() wasted.
	      updateAggregatedStats(treeSnapshot, instanceID, function (stats) {
	        stats.renderCount++;
	      });
	
	      var nextParentID = instanceID;
	      while (nextParentID) {
	        // Any parents rendered during this batch are considered wasted
	        // unless we previously marked them as dirty.
	        var isWasted = renderedCompositeIDs[nextParentID] && !isDefinitelyNotWastedByID[nextParentID];
	        if (isWasted) {
	          updateAggregatedStats(treeSnapshot, nextParentID, function (stats) {
	            stats.inclusiveRenderDuration += duration;
	          });
	        }
	        nextParentID = treeSnapshot[nextParentID].parentID;
	      }
	    });
	  });
	
	  return Object.keys(aggregatedStats).map(function (key) {
	    return _extends({}, aggregatedStats[key], {
	      instanceCount: Object.keys(affectedIDs[key]).length
	    });
	  }).sort(function (a, b) {
	    return b.inclusiveRenderDuration - a.inclusiveRenderDuration;
	  });
	}
	
	function getOperations() {
	  var flushHistory = arguments.length <= 0 || arguments[0] === undefined ? getFlushHistory() : arguments[0];
	
	  var stats = [];
	  flushHistory.forEach(function (flush, flushIndex) {
	    var operations = flush.operations;
	    var treeSnapshot = flush.treeSnapshot;
	
	    operations.forEach(function (operation) {
	      var instanceID = operation.instanceID;
	      var type = operation.type;
	      var payload = operation.payload;
	      var _treeSnapshot$instanc3 = treeSnapshot[instanceID];
	      var displayName = _treeSnapshot$instanc3.displayName;
	      var ownerID = _treeSnapshot$instanc3.ownerID;
	
	      var owner = treeSnapshot[ownerID];
	      var key = (owner ? owner.displayName + ' > ' : '') + displayName;
	
	      stats.push({
	        flushIndex: flushIndex,
	        instanceID: instanceID,
	        key: key,
	        type: type,
	        ownerID: ownerID,
	        payload: payload
	      });
	    });
	  });
	  return stats;
	}
	
	function printExclusive(flushHistory) {
	  var stats = getExclusive(flushHistory);
	  var table = stats.map(function (item) {
	    var key = item.key;
	    var instanceCount = item.instanceCount;
	    var totalDuration = item.totalDuration;
	
	    var renderCount = item.counts.render || 0;
	    var renderDuration = item.durations.render || 0;
	    return {
	      'Component': key,
	      'Total time (ms)': roundFloat(totalDuration),
	      'Instance count': instanceCount,
	      'Total render time (ms)': roundFloat(renderDuration),
	      'Average render time (ms)': renderCount ? roundFloat(renderDuration / renderCount) : undefined,
	      'Render count': renderCount,
	      'Total lifecycle time (ms)': roundFloat(totalDuration - renderDuration)
	    };
	  });
	  console.table(table);
	}
	
	function printInclusive(flushHistory) {
	  var stats = getInclusive(flushHistory);
	  var table = stats.map(function (item) {
	    var key = item.key;
	    var instanceCount = item.instanceCount;
	    var inclusiveRenderDuration = item.inclusiveRenderDuration;
	    var renderCount = item.renderCount;
	
	    return {
	      'Owner > Component': key,
	      'Inclusive render time (ms)': roundFloat(inclusiveRenderDuration),
	      'Instance count': instanceCount,
	      'Render count': renderCount
	    };
	  });
	  console.table(table);
	}
	
	function printWasted(flushHistory) {
	  var stats = getWasted(flushHistory);
	  var table = stats.map(function (item) {
	    var key = item.key;
	    var instanceCount = item.instanceCount;
	    var inclusiveRenderDuration = item.inclusiveRenderDuration;
	    var renderCount = item.renderCount;
	
	    return {
	      'Owner > Component': key,
	      'Inclusive wasted time (ms)': roundFloat(inclusiveRenderDuration),
	      'Instance count': instanceCount,
	      'Render count': renderCount
	    };
	  });
	  console.table(table);
	}
	
	function printOperations(flushHistory) {
	  var stats = getOperations(flushHistory);
	  var table = stats.map(function (stat) {
	    return {
	      'Owner > Node': stat.key,
	      'Operation': stat.type,
	      'Payload': typeof stat.payload === 'object' ? JSON.stringify(stat.payload) : stat.payload,
	      'Flush index': stat.flushIndex,
	      'Owner Component ID': stat.ownerID,
	      'DOM Component ID': stat.instanceID
	    };
	  });
	  console.table(table);
	}
	
	var warnedAboutPrintDOM = false;
	function printDOM(measurements) {
	   false ? warning(warnedAboutPrintDOM, '`ReactPerf.printDOM(...)` is deprecated. Use ' + '`ReactPerf.printOperations(...)` instead.') : void 0;
	  warnedAboutPrintDOM = true;
	  return printOperations(measurements);
	}
	
	var warnedAboutGetMeasurementsSummaryMap = false;
	function getMeasurementsSummaryMap(measurements) {
	   false ? warning(warnedAboutGetMeasurementsSummaryMap, '`ReactPerf.getMeasurementsSummaryMap(...)` is deprecated. Use ' + '`ReactPerf.getWasted(...)` instead.') : void 0;
	  warnedAboutGetMeasurementsSummaryMap = true;
	  return getWasted(measurements);
	}
	
	function start() {
	  ReactDebugTool.beginProfiling();
	}
	
	function stop() {
	  ReactDebugTool.endProfiling();
	}
	
	var ReactPerfAnalysis = {
	  getLastMeasurements: getFlushHistory,
	  getExclusive: getExclusive,
	  getInclusive: getInclusive,
	  getWasted: getWasted,
	  getOperations: getOperations,
	  printExclusive: printExclusive,
	  printInclusive: printInclusive,
	  printWasted: printWasted,
	  printOperations: printOperations,
	  start: start,
	  stop: stop,
	  // Deprecated:
	  printDOM: printDOM,
	  getMeasurementsSummaryMap: getMeasurementsSummaryMap
	};
	
	module.exports = ReactPerfAnalysis;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(200);
	var PooledClass = __webpack_require__(23);
	var ReactBrowserEventEmitter = __webpack_require__(74);
	var ReactInputSelection = __webpack_require__(212);
	var Transaction = __webpack_require__(78);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(515);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(23);
	var Transaction = __webpack_require__(78);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 520 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPropagators = __webpack_require__(37);
	var ExecutionEnvironment = __webpack_require__(8);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInputSelection = __webpack_require__(212);
	var SyntheticEvent = __webpack_require__(19);
	
	var getActiveElement = __webpack_require__(139);
	var isTextInputElement = __webpack_require__(226);
	var keyOf = __webpack_require__(20);
	var shallowEqual = __webpack_require__(141);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventListener = __webpack_require__(137);
	var EventPropagators = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(6);
	var SyntheticAnimationEvent = __webpack_require__(523);
	var SyntheticClipboardEvent = __webpack_require__(524);
	var SyntheticEvent = __webpack_require__(19);
	var SyntheticFocusEvent = __webpack_require__(527);
	var SyntheticKeyboardEvent = __webpack_require__(529);
	var SyntheticMouseEvent = __webpack_require__(77);
	var SyntheticDragEvent = __webpack_require__(526);
	var SyntheticTouchEvent = __webpack_require__(530);
	var SyntheticTransitionEvent = __webpack_require__(531);
	var SyntheticUIEvent = __webpack_require__(39);
	var SyntheticWheelEvent = __webpack_require__(532);
	
	var emptyFunction = __webpack_require__(13);
	var getEventCharCode = __webpack_require__(120);
	var invariant = __webpack_require__(2);
	var keyOf = __webpack_require__(20);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(77);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(39);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(39);
	
	var getEventCharCode = __webpack_require__(120);
	var getEventKey = __webpack_require__(537);
	var getEventModifierState = __webpack_require__(121);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(39);
	
	var getEventModifierState = __webpack_require__(121);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(77);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 533 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(199);
	var warning = __webpack_require__(3);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      if (component) {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstanceMap = __webpack_require__(116);
	
	var getNativeComponentFromComposite = __webpack_require__(223);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getNativeComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(112);
	var traverseAllChildren = __webpack_require__(127);
	var warning = __webpack_require__(3);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', KeyEscapeUtils.unescape(name)) : void 0;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(120);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 538 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(79);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(213);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 543 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(267);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(228)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./App.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./App.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(268);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(228)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./material.min.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./material.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 546 */
15
/******/ ])));


/** WEBPACK FOOTER **
 ** app.js
 **/